
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9a21"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9a21"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ihoyg", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $d4ecdbf520e63dca$export$a143d493d941bafc; }, function (v) { return $d4ecdbf520e63dca$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a; }, function (v) { return $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $d4ecdbf520e63dca$export$f99ded8fe4b79145; }, function (v) { return $d4ecdbf520e63dca$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $d4ecdbf520e63dca$export$599f31c3813fae4d; }, function (v) { return $d4ecdbf520e63dca$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $d4ecdbf520e63dca$export$a143d493d941bafc;
var $d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a;
var $d4ecdbf520e63dca$export$f99ded8fe4b79145;
var $d4ecdbf520e63dca$export$599f31c3813fae4d;
"use strict";

var $hqZtu = parcelRequire("hqZtu");

var $5WQj6 = parcelRequire("5WQj6");
var $d4ecdbf520e63dca$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$d4ecdbf520e63dca$export$a143d493d941bafc = $d4ecdbf520e63dca$var$Buffer;
$d4ecdbf520e63dca$export$e4cf37d7f6fb9e0a = $d4ecdbf520e63dca$var$SlowBuffer;
$d4ecdbf520e63dca$export$f99ded8fe4b79145 = 50;
var $d4ecdbf520e63dca$var$K_MAX_LENGTH = 0x7fffffff;
$d4ecdbf520e63dca$export$599f31c3813fae4d = $d4ecdbf520e63dca$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT = $d4ecdbf520e63dca$var$typedArraySupport();
if (!$d4ecdbf520e63dca$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $d4ecdbf520e63dca$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($d4ecdbf520e63dca$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $d4ecdbf520e63dca$var$createBuffer(length) {
    if (length > $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $d4ecdbf520e63dca$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $d4ecdbf520e63dca$var$allocUnsafe(arg);
    }
    return $d4ecdbf520e63dca$var$from(arg, encodingOrOffset, length);
}
$d4ecdbf520e63dca$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $d4ecdbf520e63dca$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $d4ecdbf520e63dca$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($d4ecdbf520e63dca$var$isInstance(value, ArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, ArrayBuffer)) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($d4ecdbf520e63dca$var$isInstance(value, SharedArrayBuffer) || value && $d4ecdbf520e63dca$var$isInstance(value.buffer, SharedArrayBuffer))) return $d4ecdbf520e63dca$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $d4ecdbf520e63dca$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $d4ecdbf520e63dca$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $d4ecdbf520e63dca$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $d4ecdbf520e63dca$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $d4ecdbf520e63dca$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($d4ecdbf520e63dca$var$Buffer, Uint8Array);
function $d4ecdbf520e63dca$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $d4ecdbf520e63dca$var$alloc(size, fill, encoding) {
    $d4ecdbf520e63dca$var$assertSize(size);
    if (size <= 0) return $d4ecdbf520e63dca$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $d4ecdbf520e63dca$var$createBuffer(size).fill(fill, encoding) : $d4ecdbf520e63dca$var$createBuffer(size).fill(fill);
    return $d4ecdbf520e63dca$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $d4ecdbf520e63dca$var$Buffer.alloc = function(size, fill, encoding) {
    return $d4ecdbf520e63dca$var$alloc(size, fill, encoding);
};
function $d4ecdbf520e63dca$var$allocUnsafe(size) {
    $d4ecdbf520e63dca$var$assertSize(size);
    return $d4ecdbf520e63dca$var$createBuffer(size < 0 ? 0 : $d4ecdbf520e63dca$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $d4ecdbf520e63dca$var$Buffer.allocUnsafe = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $d4ecdbf520e63dca$var$Buffer.allocUnsafeSlow = function(size) {
    return $d4ecdbf520e63dca$var$allocUnsafe(size);
};
function $d4ecdbf520e63dca$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $d4ecdbf520e63dca$var$byteLength(string, encoding) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $d4ecdbf520e63dca$var$checked(array.length) | 0;
    var buf = $d4ecdbf520e63dca$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $d4ecdbf520e63dca$var$fromArrayView(arrayView) {
    if ($d4ecdbf520e63dca$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $d4ecdbf520e63dca$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $d4ecdbf520e63dca$var$fromArrayLike(arrayView);
}
function $d4ecdbf520e63dca$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return buf;
}
function $d4ecdbf520e63dca$var$fromObject(obj) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(obj)) {
        var len = $d4ecdbf520e63dca$var$checked(obj.length) | 0;
        var buf = $d4ecdbf520e63dca$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $d4ecdbf520e63dca$var$numberIsNaN(obj.length)) return $d4ecdbf520e63dca$var$createBuffer(0);
        return $d4ecdbf520e63dca$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $d4ecdbf520e63dca$var$fromArrayLike(obj.data);
}
function $d4ecdbf520e63dca$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $d4ecdbf520e63dca$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $d4ecdbf520e63dca$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $d4ecdbf520e63dca$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $d4ecdbf520e63dca$var$Buffer.alloc(+length);
}
$d4ecdbf520e63dca$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $d4ecdbf520e63dca$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$d4ecdbf520e63dca$var$Buffer.compare = function compare(a, b) {
    if ($d4ecdbf520e63dca$var$isInstance(a, Uint8Array)) a = $d4ecdbf520e63dca$var$Buffer.from(a, a.offset, a.byteLength);
    if ($d4ecdbf520e63dca$var$isInstance(b, Uint8Array)) b = $d4ecdbf520e63dca$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(a) || !$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$d4ecdbf520e63dca$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$d4ecdbf520e63dca$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $d4ecdbf520e63dca$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $d4ecdbf520e63dca$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($d4ecdbf520e63dca$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $d4ecdbf520e63dca$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $d4ecdbf520e63dca$var$byteLength(string, encoding) {
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $d4ecdbf520e63dca$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $d4ecdbf520e63dca$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $d4ecdbf520e63dca$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$d4ecdbf520e63dca$var$Buffer.byteLength = $d4ecdbf520e63dca$var$byteLength;
function $d4ecdbf520e63dca$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Slice(this, start, end);
        case "ascii":
            return $d4ecdbf520e63dca$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$latin1Slice(this, start, end);
        case "base64":
            return $d4ecdbf520e63dca$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$d4ecdbf520e63dca$var$Buffer.prototype._isBuffer = true;
function $d4ecdbf520e63dca$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$d4ecdbf520e63dca$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$d4ecdbf520e63dca$var$swap(this, i, i + 1);
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $d4ecdbf520e63dca$var$swap(this, i, i + 3);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $d4ecdbf520e63dca$var$swap(this, i, i + 7);
        $d4ecdbf520e63dca$var$swap(this, i + 1, i + 6);
        $d4ecdbf520e63dca$var$swap(this, i + 2, i + 5);
        $d4ecdbf520e63dca$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$d4ecdbf520e63dca$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $d4ecdbf520e63dca$var$utf8Slice(this, 0, length);
    return $d4ecdbf520e63dca$var$slowToString.apply(this, arguments);
};
$d4ecdbf520e63dca$var$Buffer.prototype.toLocaleString = $d4ecdbf520e63dca$var$Buffer.prototype.toString;
$d4ecdbf520e63dca$var$Buffer.prototype.equals = function equals(b) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $d4ecdbf520e63dca$var$Buffer.compare(this, b) === 0;
};
$d4ecdbf520e63dca$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $d4ecdbf520e63dca$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($d4ecdbf520e63dca$var$customInspectSymbol) $d4ecdbf520e63dca$var$Buffer.prototype[$d4ecdbf520e63dca$var$customInspectSymbol] = $d4ecdbf520e63dca$var$Buffer.prototype.inspect;
$d4ecdbf520e63dca$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($d4ecdbf520e63dca$var$isInstance(target, Uint8Array)) target = $d4ecdbf520e63dca$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $d4ecdbf520e63dca$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($d4ecdbf520e63dca$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($d4ecdbf520e63dca$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $d4ecdbf520e63dca$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $d4ecdbf520e63dca$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$d4ecdbf520e63dca$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$d4ecdbf520e63dca$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $d4ecdbf520e63dca$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $d4ecdbf520e63dca$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($d4ecdbf520e63dca$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $d4ecdbf520e63dca$var$utf8Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $d4ecdbf520e63dca$var$asciiWrite(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$asciiToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$base64Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$base64ToBytes(string), buf, offset, length);
}
function $d4ecdbf520e63dca$var$ucs2Write(buf, string, offset, length) {
    return $d4ecdbf520e63dca$var$blitBuffer($d4ecdbf520e63dca$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$d4ecdbf520e63dca$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $d4ecdbf520e63dca$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $d4ecdbf520e63dca$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $d4ecdbf520e63dca$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $d4ecdbf520e63dca$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $d4ecdbf520e63dca$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$d4ecdbf520e63dca$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $d4ecdbf520e63dca$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $hqZtu.fromByteArray(buf);
    else return $hqZtu.fromByteArray(buf.slice(start, end));
}
function $d4ecdbf520e63dca$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $d4ecdbf520e63dca$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $d4ecdbf520e63dca$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $d4ecdbf520e63dca$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $d4ecdbf520e63dca$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $d4ecdbf520e63dca$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $d4ecdbf520e63dca$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $d4ecdbf520e63dca$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $d4ecdbf520e63dca$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$d4ecdbf520e63dca$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $d4ecdbf520e63dca$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $d4ecdbf520e63dca$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$d4ecdbf520e63dca$var$Buffer.prototype.readUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$d4ecdbf520e63dca$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, true, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 4, this.length);
    return $5WQj6.read(this, offset, false, 23, 4);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, true, 52, 8);
};
$d4ecdbf520e63dca$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkOffset(offset, 8, this.length);
    return $5WQj6.read(this, offset, false, 52, 8);
};
function $d4ecdbf520e63dca$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintLE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUintBE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint8 = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint16BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32LE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeUint32BE = $d4ecdbf520e63dca$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $d4ecdbf520e63dca$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $d4ecdbf520e63dca$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeFloat(this, value, offset, false, noAssert);
};
function $d4ecdbf520e63dca$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $d4ecdbf520e63dca$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $5WQj6.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, true, noAssert);
};
$d4ecdbf520e63dca$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $d4ecdbf520e63dca$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$d4ecdbf520e63dca$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$d4ecdbf520e63dca$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$d4ecdbf520e63dca$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$d4ecdbf520e63dca$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $d4ecdbf520e63dca$var$Buffer.isBuffer(val) ? val : $d4ecdbf520e63dca$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $d4ecdbf520e63dca$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $d4ecdbf520e63dca$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($d4ecdbf520e63dca$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $d4ecdbf520e63dca$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $d4ecdbf520e63dca$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $d4ecdbf520e63dca$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $d4ecdbf520e63dca$var$base64ToBytes(str) {
    return $hqZtu.toByteArray($d4ecdbf520e63dca$var$base64clean(str));
}
function $d4ecdbf520e63dca$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $d4ecdbf520e63dca$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $d4ecdbf520e63dca$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $d4ecdbf520e63dca$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRegister("hqZtu", function(module, exports) {

$parcel$export(module.exports, "byteLength", function () { return $034686670a8a195b$export$a48f0734ac7c2329; }, function (v) { return $034686670a8a195b$export$a48f0734ac7c2329 = v; });
$parcel$export(module.exports, "toByteArray", function () { return $034686670a8a195b$export$d622b2ad8d90c771; }, function (v) { return $034686670a8a195b$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $034686670a8a195b$export$6100ba28696e12de; }, function (v) { return $034686670a8a195b$export$6100ba28696e12de = v; });
var $034686670a8a195b$export$a48f0734ac7c2329;
var $034686670a8a195b$export$d622b2ad8d90c771;
var $034686670a8a195b$export$6100ba28696e12de;
"use strict";
$034686670a8a195b$export$a48f0734ac7c2329 = $034686670a8a195b$var$byteLength;
$034686670a8a195b$export$d622b2ad8d90c771 = $034686670a8a195b$var$toByteArray;
$034686670a8a195b$export$6100ba28696e12de = $034686670a8a195b$var$fromByteArray;
var $034686670a8a195b$var$lookup = [];
var $034686670a8a195b$var$revLookup = [];
var $034686670a8a195b$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $034686670a8a195b$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $034686670a8a195b$var$i = 0, $034686670a8a195b$var$len = $034686670a8a195b$var$code.length; $034686670a8a195b$var$i < $034686670a8a195b$var$len; ++$034686670a8a195b$var$i){
    $034686670a8a195b$var$lookup[$034686670a8a195b$var$i] = $034686670a8a195b$var$code[$034686670a8a195b$var$i];
    $034686670a8a195b$var$revLookup[$034686670a8a195b$var$code.charCodeAt($034686670a8a195b$var$i)] = $034686670a8a195b$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$034686670a8a195b$var$revLookup["-".charCodeAt(0)] = 62;
$034686670a8a195b$var$revLookup["_".charCodeAt(0)] = 63;
function $034686670a8a195b$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $034686670a8a195b$var$byteLength(b64) {
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $034686670a8a195b$var$toByteArray(b64) {
    var tmp;
    var lens = $034686670a8a195b$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $034686670a8a195b$var$Arr($034686670a8a195b$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 18 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 2 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $034686670a8a195b$var$revLookup[b64.charCodeAt(i)] << 10 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $034686670a8a195b$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $034686670a8a195b$var$tripletToBase64(num) {
    return $034686670a8a195b$var$lookup[num >> 18 & 0x3F] + $034686670a8a195b$var$lookup[num >> 12 & 0x3F] + $034686670a8a195b$var$lookup[num >> 6 & 0x3F] + $034686670a8a195b$var$lookup[num & 0x3F];
}
function $034686670a8a195b$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($034686670a8a195b$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $034686670a8a195b$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($034686670a8a195b$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 2] + $034686670a8a195b$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($034686670a8a195b$var$lookup[tmp >> 10] + $034686670a8a195b$var$lookup[tmp >> 4 & 0x3F] + $034686670a8a195b$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("5WQj6", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $454af19f7384844b$export$aafa59e2e03f2942; }, function (v) { return $454af19f7384844b$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $454af19f7384844b$export$68d8715fc104d294; }, function (v) { return $454af19f7384844b$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $454af19f7384844b$export$aafa59e2e03f2942;
var $454af19f7384844b$export$68d8715fc104d294;
$454af19f7384844b$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$454af19f7384844b$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("lFpDy", function(module, exports) {

var $jWIPa = parcelRequire("jWIPa");

var $djWs9 = parcelRequire("djWs9");

var $6iw60 = parcelRequire("6iw60");

var $6rkXZ = parcelRequire("6rkXZ");

var $3XNbu = parcelRequire("3XNbu");

var $jSeML = parcelRequire("jSeML");

var $2gFaw = parcelRequire("2gFaw");

var $egG3m = parcelRequire("egG3m");

var $3a5kd = parcelRequire("3a5kd");

var $hNfwf = parcelRequire("hNfwf");

var $1Q7Hg = parcelRequire("1Q7Hg");

var $7YAVQ = parcelRequire("7YAVQ");

var $YfkmL = parcelRequire("YfkmL");

var $6XItq = parcelRequire("6XItq");

var $8xtJG = parcelRequire("8xtJG");

var $33tWh = parcelRequire("33tWh");

var $4h0dO = parcelRequire("4h0dO");

var $7pqG6 = parcelRequire("7pqG6");

var $34AFc = parcelRequire("34AFc");

var $7NkOr = parcelRequire("7NkOr");

var $7qsEP = parcelRequire("7qsEP");
$parcel$exportWildcard(module.exports, $jWIPa);
$parcel$exportWildcard(module.exports, $djWs9);
$parcel$exportWildcard(module.exports, $6iw60);
$parcel$exportWildcard(module.exports, $6rkXZ);
$parcel$exportWildcard(module.exports, $3XNbu);
$parcel$exportWildcard(module.exports, $jSeML);
$parcel$exportWildcard(module.exports, $2gFaw);
$parcel$exportWildcard(module.exports, $egG3m);
$parcel$exportWildcard(module.exports, $3a5kd);
$parcel$exportWildcard(module.exports, $hNfwf);
$parcel$exportWildcard(module.exports, $1Q7Hg);
$parcel$exportWildcard(module.exports, $7YAVQ);
$parcel$exportWildcard(module.exports, $YfkmL);
$parcel$exportWildcard(module.exports, $6XItq);
$parcel$exportWildcard(module.exports, $8xtJG);
$parcel$exportWildcard(module.exports, $33tWh);
$parcel$exportWildcard(module.exports, $4h0dO);
$parcel$exportWildcard(module.exports, $7pqG6);
$parcel$exportWildcard(module.exports, $34AFc);
$parcel$exportWildcard(module.exports, $7NkOr);
$parcel$exportWildcard(module.exports, $7qsEP);

});
parcelRegister("jWIPa", function(module, exports) {

$parcel$export(module.exports, "arkeoDescribePath", function () { return $629059571518631f$export$4ceb48d7eaae7c72; });

var $7NkOr = parcelRequire("7NkOr");
function $629059571518631f$export$4ceb48d7eaae7c72(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Arkeo",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Arkeo")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Arkeo Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Arkeo",
        isKnown: true,
        isPrefork: false
    };
}

});
parcelRegister("7NkOr", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_TIMEOUT", function () { return $d917dcad7ac904f5$export$7bd623b29ec8e1eb; });
$parcel$export(module.exports, "LONG_TIMEOUT", function () { return $d917dcad7ac904f5$export$47bb682e9c9faa1d; });
$parcel$export(module.exports, "isArray", function () { return $d917dcad7ac904f5$export$43bee75e5e14138e; });
$parcel$export(module.exports, "fromHexString", function () { return $d917dcad7ac904f5$export$99a70112ceb8327b; });
$parcel$export(module.exports, "toHexString", function () { return $d917dcad7ac904f5$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "arrayify", function () { return $d917dcad7ac904f5$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "bip32Like", function () { return $d917dcad7ac904f5$export$a2d39b50969bd973; });
$parcel$export(module.exports, "bip32ToAddressNList", function () { return $d917dcad7ac904f5$export$9e5111b347deb80c; });
$parcel$export(module.exports, "addressNListToBIP32", function () { return $d917dcad7ac904f5$export$c8dd9bedf7dfe4ab; });
$parcel$export(module.exports, "takeFirstOfManyEvents", function () { return $d917dcad7ac904f5$export$6ea62e983f777239; });
$parcel$export(module.exports, "stripHexPrefix", function () { return $d917dcad7ac904f5$export$b2f5d0058897e6e6; });
$parcel$export(module.exports, "stripHexPrefixAndLower", function () { return $d917dcad7ac904f5$export$c890361b10217461; });
$parcel$export(module.exports, "base64toHEX", function () { return $d917dcad7ac904f5$export$d06123eb8a0144c4; });
$parcel$export(module.exports, "slip44ByCoin", function () { return $d917dcad7ac904f5$export$75b705fad32d9c31; });
$parcel$export(module.exports, "satsFromStr", function () { return $d917dcad7ac904f5$export$f80a9488cbf324f3; });
$parcel$export(module.exports, "hardenedPath", function () { return $d917dcad7ac904f5$export$10feb6b683b3438a; });
$parcel$export(module.exports, "relativePath", function () { return $d917dcad7ac904f5$export$7413eea5ad243d4; });
$parcel$export(module.exports, "toArrayBuffer", function () { return $d917dcad7ac904f5$export$8b22b05f429b130c; });
$parcel$export(module.exports, "mustBeDefined", function () { return $d917dcad7ac904f5$export$bebbb26cd7c45e2c; });
$parcel$export(module.exports, "untouchable", function () { return $d917dcad7ac904f5$export$37e65ef07b7d1550; });
$parcel$export(module.exports, "checkBufferConcat", function () { return $d917dcad7ac904f5$export$5c2cd69e389d0c6c; });
$parcel$export(module.exports, "compatibleBufferConcat", function () { return $d917dcad7ac904f5$export$9417e0785d7392ce; });
$parcel$export(module.exports, "isIndexable", function () { return $d917dcad7ac904f5$export$ee461155237903cd; });
$parcel$export(module.exports, "sortTxFields", function () { return $d917dcad7ac904f5$export$7785a8007fa9ea58; });

var $b05bP = parcelRequire("b05bP");
var $8EFKA = parcelRequire("8EFKA");

var $7kVra = parcelRequire("7kVra");

var $ihoyg = parcelRequire("ihoyg");
var $d917dcad7ac904f5$require$Buffer = $ihoyg.Buffer;
const $d917dcad7ac904f5$export$7bd623b29ec8e1eb = 5000; // 5 seconds
const $d917dcad7ac904f5$export$47bb682e9c9faa1d = 300000; // 5 minutes
const $d917dcad7ac904f5$export$43bee75e5e14138e = Array.isArray || function(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
};
const $d917dcad7ac904f5$export$99a70112ceb8327b = (hexString)=>{
    const match = hexString.match(/.{1,2}/g) || [];
    return new Uint8Array(match.map((byte)=>parseInt(byte, 16)));
};
function $d917dcad7ac904f5$export$f4915efbb94d4d01(arr) {
    return Array.prototype.map.call(arr, (x)=>("00" + x.toString(16)).slice(-2)).join("");
}
function $d917dcad7ac904f5$export$3131421a7d01b4fb(value) {
    if (value === null) throw new Error("cannot convert null value to array");
    else if (typeof value !== "string") throw new Error("can only convert hex strings");
    const match = value.match(/^(0x)?[0-9a-fA-F]*$/);
    if (!match) throw new Error("invalid hexadecimal string");
    if (match[1] !== "0x") throw new Error("hex string must have 0x prefix");
    value = value.substring(2);
    if (value.length % 2) value = "0" + value;
    const result = [];
    for(let i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
    return new Uint8Array(result);
}
const $d917dcad7ac904f5$var$HARDENED = 0x80000000;
function $d917dcad7ac904f5$export$a2d39b50969bd973(path) {
    if (path == "m/") return true;
    return /^m(((\/[0-9]+h)+|(\/[0-9]+H)+|(\/[0-9]+')*)((\/[0-9]+)*))$/.test(path);
}
function $d917dcad7ac904f5$export$9e5111b347deb80c(path) {
    if (!$d917dcad7ac904f5$export$a2d39b50969bd973(path)) throw new Error(`Not a bip32 path: '${path}'`);
    if (/^m\//i.test(path)) path = path.slice(2);
    const segments = path.split("/");
    if (segments.length === 1 && segments[0] === "") return [];
    const ret = new Array(segments.length);
    for(let i = 0; i < segments.length; i++){
        const tmp = /(\d+)([hH']?)/.exec(segments[i]);
        if (tmp === null) throw new Error("Invalid input");
        ret[i] = parseInt(tmp[1], 10);
        if (ret[i] >= $d917dcad7ac904f5$var$HARDENED) throw new Error("Invalid child index");
        if (tmp[2] === "h" || tmp[2] === "H" || tmp[2] === "'") ret[i] += $d917dcad7ac904f5$var$HARDENED;
        else if (tmp[2].length !== 0) throw new Error("Invalid modifier");
    }
    return ret;
}
function $d917dcad7ac904f5$export$c8dd9bedf7dfe4ab(address) {
    return `m/${address.map((num)=>num >= $d917dcad7ac904f5$var$HARDENED ? `${num - $d917dcad7ac904f5$var$HARDENED}'` : num).join("/")}`;
}
function $d917dcad7ac904f5$export$6ea62e983f777239(eventEmitter, events) {
    return $8EFKA.merge(...events.map((event)=>$b05bP.fromEvent(eventEmitter, event))).pipe($7kVra.first());
}
function $d917dcad7ac904f5$export$b2f5d0058897e6e6(value) {
    return value.replace("0x", "");
}
function $d917dcad7ac904f5$export$c890361b10217461(value) {
    return $d917dcad7ac904f5$export$b2f5d0058897e6e6(value).toLowerCase();
}
function $d917dcad7ac904f5$export$d06123eb8a0144c4(base64) {
    const raw = atob(base64);
    let HEX = "";
    for(let i = 0; i < raw.length; i++){
        const _hex = raw.charCodeAt(i).toString(16);
        HEX += _hex.length == 2 ? _hex : "0" + _hex;
    }
    return "0x" + HEX.toUpperCase();
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $d917dcad7ac904f5$var$slip44Table = Object.freeze({
    Bitcoin: 0,
    Testnet: 1,
    BitcoinCash: 145,
    BitcoinGold: 156,
    Litecoin: 2,
    Dash: 5,
    DigiByte: 20,
    Dogecoin: 3,
    BitcoinSV: 236,
    Atom: 118,
    Osmo: 118,
    Arkeo: 118,
    Binance: 714,
    Ripple: 144,
    Eos: 194,
    Fio: 235,
    Thorchain: 931,
    Rune: 931,
    Cardano: 1815,
    Secret: 529,
    Terra: 330,
    Kava: 459,
    // EVM chains all use the same SLIP44
    Ethereum: 60,
    Avalanche: 60,
    Optimism: 60,
    BnbSmartChain: 60,
    Polygon: 60,
    Gnosis: 60,
    Arbitrum: 60,
    ArbitrumNova: 60,
    Mayachain: 931,
    Cacao: 931
});
function $d917dcad7ac904f5$export$75b705fad32d9c31(coin) {
    return $d917dcad7ac904f5$var$slip44Table[coin];
}
function $d917dcad7ac904f5$export$f80a9488cbf324f3(coins) {
    const index = coins.indexOf(".");
    const exponent = index > 0 ? 8 - (coins.length - index - 1) : 8;
    return Number(coins.replace(/\./g, "")) * 10 ** exponent;
}
function $d917dcad7ac904f5$export$10feb6b683b3438a(path) {
    return path.filter((segment)=>segment >= 0x80000000);
}
function $d917dcad7ac904f5$export$7413eea5ad243d4(path) {
    return path.filter((segment)=>segment < 0x80000000);
}
function $d917dcad7ac904f5$export$8b22b05f429b130c(x) {
    if (x instanceof ArrayBuffer) return x;
    return x.buffer.slice(x.byteOffset, x.byteOffset + x.byteLength);
}
function $d917dcad7ac904f5$export$bebbb26cd7c45e2c(x) {
    if (x === null || x === undefined) throw new Error("expected a value");
    return x;
}
function $d917dcad7ac904f5$export$37e65ef07b7d1550(message) {
    const out = new Proxy({}, new Proxy({}, {
        get (_, p) {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return (_, p2)=>{
                if (p === "get" && p2 === "valueOf") return ()=>out;
                throw new Error(`${String(p)}(${String(p2)}): ${message}`);
            };
        }
    }));
    return out;
}
// Webpack 4's Buffer.concat() polyfill requires Buffer[] instead of Uint8Array[]. This is a
// kludgy compatibility hack until everything gets bumped to Webpack 5.
let $d917dcad7ac904f5$var$needCompatibleBufferConcat = undefined;
function $d917dcad7ac904f5$export$5c2cd69e389d0c6c() {
    if ($d917dcad7ac904f5$var$needCompatibleBufferConcat === undefined) try {
        $d917dcad7ac904f5$require$Buffer.concat([
            new Uint8Array()
        ]);
        $d917dcad7ac904f5$var$needCompatibleBufferConcat = false;
    } catch  {
        $d917dcad7ac904f5$var$needCompatibleBufferConcat = true;
    }
    return $d917dcad7ac904f5$var$needCompatibleBufferConcat;
}
function $d917dcad7ac904f5$export$9417e0785d7392ce(list) {
    if (!$d917dcad7ac904f5$export$5c2cd69e389d0c6c()) return $d917dcad7ac904f5$require$Buffer.concat(list);
    return $d917dcad7ac904f5$require$Buffer.concat(list.map((x)=>$d917dcad7ac904f5$require$Buffer.isBuffer(x) ? x : $d917dcad7ac904f5$require$Buffer.from(x)));
}
function $d917dcad7ac904f5$export$ee461155237903cd(x) {
    return x !== null && [
        "object",
        "function"
    ].includes(typeof x);
}
//codereview.stackexchange.com/questions/265820/using-javascript-given-a-json-value-recursively-find-all-json-objects-then-so
const $d917dcad7ac904f5$var$strSorter = (a, b)=>a > b ? 1 : a < b ? -1 : 0;
const $d917dcad7ac904f5$var$isObj = (obj)=>"object" === typeof obj && null !== obj;
const $d917dcad7ac904f5$var$sortInPlaceObjectKeys = (obj)=>{
    const sorted = Object.entries(obj).sort((a, b)=>$d917dcad7ac904f5$var$strSorter(a[0], b[0]));
    for (const [key] of sorted)delete obj[key];
    return Object.assign(obj, Object.fromEntries(sorted));
};
function $d917dcad7ac904f5$export$7785a8007fa9ea58(obj) {
    const stack = [], checked = new WeakSet();
    if ($d917dcad7ac904f5$var$isObj(obj)) {
        stack.push(obj);
        while(stack.length){
            let o = stack.pop();
            checked.add(o);
            o = !Array.isArray(o) && $d917dcad7ac904f5$var$sortInPlaceObjectKeys(o);
            for (const val of Object.values(o))$d917dcad7ac904f5$var$isObj(val) && !checked.has(val) && stack.push(val);
        }
    }
    return obj;
}

});
parcelRegister("b05bP", function(module, exports) {

$parcel$export(module.exports, "fromEvent", function () { return $8023b86498ea8aad$export$a36e16046ae8f1bb; });
/** PURE_IMPORTS_START _Observable,_util_isArray,_util_isFunction,_operators_map PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $6TsDY = parcelRequire("6TsDY");

var $HkSGF = parcelRequire("HkSGF");

var $47BTs = parcelRequire("47BTs");
var $8023b86498ea8aad$var$toString = /*@__PURE__*/ function() {
    return Object.prototype.toString;
}();
function $8023b86498ea8aad$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $HkSGF.isFunction)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $8023b86498ea8aad$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $47BTs.map)(function(args) {
        return (0, $6TsDY.isArray)(args) ? resultSelector.apply(void 0, args) : resultSelector(args);
    }));
    return new (0, $7BmHO.Observable)(function(subscriber) {
        function handler(e) {
            if (arguments.length > 1) subscriber.next(Array.prototype.slice.call(arguments));
            else subscriber.next(e);
        }
        $8023b86498ea8aad$var$setupSubscription(target, eventName, handler, subscriber, options);
    });
}
function $8023b86498ea8aad$var$setupSubscription(sourceObj, eventName, handler, subscriber, options) {
    var unsubscribe;
    if ($8023b86498ea8aad$var$isEventTarget(sourceObj)) {
        var source_1 = sourceObj;
        sourceObj.addEventListener(eventName, handler, options);
        unsubscribe = function() {
            return source_1.removeEventListener(eventName, handler, options);
        };
    } else if ($8023b86498ea8aad$var$isJQueryStyleEventEmitter(sourceObj)) {
        var source_2 = sourceObj;
        sourceObj.on(eventName, handler);
        unsubscribe = function() {
            return source_2.off(eventName, handler);
        };
    } else if ($8023b86498ea8aad$var$isNodeStyleEventEmitter(sourceObj)) {
        var source_3 = sourceObj;
        sourceObj.addListener(eventName, handler);
        unsubscribe = function() {
            return source_3.removeListener(eventName, handler);
        };
    } else if (sourceObj && sourceObj.length) for(var i = 0, len = sourceObj.length; i < len; i++)$8023b86498ea8aad$var$setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
    else throw new TypeError("Invalid event target");
    subscriber.add(unsubscribe);
}
function $8023b86498ea8aad$var$isNodeStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.addListener === "function" && typeof sourceObj.removeListener === "function";
}
function $8023b86498ea8aad$var$isJQueryStyleEventEmitter(sourceObj) {
    return sourceObj && typeof sourceObj.on === "function" && typeof sourceObj.off === "function";
}
function $8023b86498ea8aad$var$isEventTarget(sourceObj) {
    return sourceObj && typeof sourceObj.addEventListener === "function" && typeof sourceObj.removeEventListener === "function";
}

});
parcelRegister("7BmHO", function(module, exports) {

$parcel$export(module.exports, "Observable", function () { return $588d99fa9202d50f$export$77cea355fa80b5f4; });
/** PURE_IMPORTS_START _util_canReportError,_util_toSubscriber,_symbol_observable,_util_pipe,_config PURE_IMPORTS_END */ 
var $9AmmK = parcelRequire("9AmmK");

var $6eVN5 = parcelRequire("6eVN5");

var $aaHfL = parcelRequire("aaHfL");

var $7l7rJ = parcelRequire("7l7rJ");

var $fChUO = parcelRequire("fChUO");
var $588d99fa9202d50f$export$77cea355fa80b5f4 = /*@__PURE__*/ function() {
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = (0, $6eVN5.toSubscriber)(observerOrNext, error, complete);
        if (operator) sink.add(operator.call(sink, this.source));
        else sink.add(this.source || (0, $fChUO.config).useDeprecatedSynchronousErrorHandling && !sink.syncErrorThrowable ? this._subscribe(sink) : this._trySubscribe(sink));
        if ((0, $fChUO.config).useDeprecatedSynchronousErrorHandling) {
            if (sink.syncErrorThrowable) {
                sink.syncErrorThrowable = false;
                if (sink.syncErrorThrown) throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            if ((0, $fChUO.config).useDeprecatedSynchronousErrorHandling) {
                sink.syncErrorThrown = true;
                sink.syncErrorValue = err;
            }
            if ((0, $9AmmK.canReportError)(sink)) sink.error(err);
            else console.warn(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $588d99fa9202d50f$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function(value) {
                try {
                    next(value);
                } catch (err) {
                    reject(err);
                    if (subscription) subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var source = this.source;
        return source && source.subscribe(subscriber);
    };
    Observable.prototype[0, $aaHfL.observable] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        if (operations.length === 0) return this;
        return (0, $7l7rJ.pipeFromArray)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $588d99fa9202d50f$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $588d99fa9202d50f$var$getPromiseCtor(promiseCtor) {
    if (!promiseCtor) promiseCtor = (0, $fChUO.config).Promise || Promise;
    if (!promiseCtor) throw new Error("no Promise impl found");
    return promiseCtor;
}

});
parcelRegister("9AmmK", function(module, exports) {

$parcel$export(module.exports, "canReportError", function () { return $6fa8d3430b48d05f$export$f7d54ecb625129e3; });
/** PURE_IMPORTS_START _Subscriber PURE_IMPORTS_END */ 
var $6wkmF = parcelRequire("6wkmF");
function $6fa8d3430b48d05f$export$f7d54ecb625129e3(observer) {
    while(observer){
        var _a = observer, closed_1 = _a.closed, destination = _a.destination, isStopped = _a.isStopped;
        if (closed_1 || isStopped) return false;
        else if (destination && destination instanceof (0, $6wkmF.Subscriber)) observer = destination;
        else observer = null;
    }
    return true;
}

});
parcelRegister("6wkmF", function(module, exports) {

$parcel$export(module.exports, "Subscriber", function () { return $4bf58732358a0ba6$export$60959659b2c22881; });
/** PURE_IMPORTS_START tslib,_util_isFunction,_Observer,_Subscription,_internal_symbol_rxSubscriber,_config,_util_hostReportError PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $HkSGF = parcelRequire("HkSGF");

var $ceBSf = parcelRequire("ceBSf");

var $2Pqsh = parcelRequire("2Pqsh");

var $58x1t = parcelRequire("58x1t");

var $fChUO = parcelRequire("fChUO");

var $67ViU = parcelRequire("67ViU");
var $4bf58732358a0ba6$export$60959659b2c22881 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(Subscriber, _super);
    function Subscriber(destinationOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this.syncErrorValue = null;
        _this.syncErrorThrown = false;
        _this.syncErrorThrowable = false;
        _this.isStopped = false;
        switch(arguments.length){
            case 0:
                _this.destination = (0, $ceBSf.empty);
                break;
            case 1:
                if (!destinationOrNext) {
                    _this.destination = (0, $ceBSf.empty);
                    break;
                }
                if (typeof destinationOrNext === "object") {
                    if (destinationOrNext instanceof Subscriber) {
                        _this.syncErrorThrowable = destinationOrNext.syncErrorThrowable;
                        _this.destination = destinationOrNext;
                        destinationOrNext.add(_this);
                    } else {
                        _this.syncErrorThrowable = true;
                        _this.destination = new $4bf58732358a0ba6$export$94eeb6a328cab6c7(_this, destinationOrNext);
                    }
                    break;
                }
            default:
                _this.syncErrorThrowable = true;
                _this.destination = new $4bf58732358a0ba6$export$94eeb6a328cab6c7(_this, destinationOrNext, error, complete);
                break;
        }
        return _this;
    }
    Subscriber.prototype[0, $58x1t.rxSubscriber] = function() {
        return this;
    };
    Subscriber.create = function(next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    Subscriber.prototype.next = function(value) {
        if (!this.isStopped) this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (this.closed) return;
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function() {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function() {
        var _parentOrParents = this._parentOrParents;
        this._parentOrParents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parentOrParents = _parentOrParents;
        return this;
    };
    return Subscriber;
}((0, $2Pqsh.Subscription));
var $4bf58732358a0ba6$export$94eeb6a328cab6c7 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        _this._parentSubscriber = _parentSubscriber;
        var next;
        var context = _this;
        if ((0, $HkSGF.isFunction)(observerOrNext)) next = observerOrNext;
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== (0, $ceBSf.empty)) {
                context = Object.create(observerOrNext);
                if ((0, $HkSGF.isFunction)(context.unsubscribe)) _this.add(context.unsubscribe.bind(context));
                context.unsubscribe = _this.unsubscribe.bind(_this);
            }
        }
        _this._context = context;
        _this._next = next;
        _this._error = error;
        _this._complete = complete;
        return _this;
    }
    SafeSubscriber.prototype.next = function(value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!(0, $fChUO.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) this.__tryOrUnsub(this._next, value);
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.error = function(err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            var useDeprecatedSynchronousErrorHandling = (0, $fChUO.config).useDeprecatedSynchronousErrorHandling;
            if (this._error) {
                if (!useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            } else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                if (useDeprecatedSynchronousErrorHandling) throw err;
                (0, $67ViU.hostReportError)(err);
            } else {
                if (useDeprecatedSynchronousErrorHandling) {
                    _parentSubscriber.syncErrorValue = err;
                    _parentSubscriber.syncErrorThrown = true;
                } else (0, $67ViU.hostReportError)(err);
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function() {
        var _this = this;
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                var wrappedComplete = function() {
                    return _this._complete.call(_this._context);
                };
                if (!(0, $fChUO.config).useDeprecatedSynchronousErrorHandling || !_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(wrappedComplete);
                    this.unsubscribe();
                } else {
                    this.__tryOrSetError(_parentSubscriber, wrappedComplete);
                    this.unsubscribe();
                }
            } else this.unsubscribe();
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function(fn, value) {
        try {
            fn.call(this._context, value);
        } catch (err) {
            this.unsubscribe();
            if ((0, $fChUO.config).useDeprecatedSynchronousErrorHandling) throw err;
            else (0, $67ViU.hostReportError)(err);
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function(parent, fn, value) {
        if (!(0, $fChUO.config).useDeprecatedSynchronousErrorHandling) throw new Error("bad call");
        try {
            fn.call(this._context, value);
        } catch (err) {
            if ((0, $fChUO.config).useDeprecatedSynchronousErrorHandling) {
                parent.syncErrorValue = err;
                parent.syncErrorThrown = true;
                return true;
            } else {
                (0, $67ViU.hostReportError)(err);
                return true;
            }
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function() {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}($4bf58732358a0ba6$export$60959659b2c22881);

});
parcelRegister("ko27v", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $ed77b18549d32986$export$a8ba968b8961cb8a; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $ed77b18549d32986$var$extendStatics = function(d, b) {
    $ed77b18549d32986$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $ed77b18549d32986$var$extendStatics(d, b);
};
function $ed77b18549d32986$export$a8ba968b8961cb8a(d, b) {
    $ed77b18549d32986$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ed77b18549d32986$export$18ce0697a983be9b = function() {
    $ed77b18549d32986$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ed77b18549d32986$export$18ce0697a983be9b.apply(this, arguments);
};
function $ed77b18549d32986$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ed77b18549d32986$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ed77b18549d32986$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ed77b18549d32986$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ed77b18549d32986$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ed77b18549d32986$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $ed77b18549d32986$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $ed77b18549d32986$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $ed77b18549d32986$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ed77b18549d32986$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ed77b18549d32986$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ed77b18549d32986$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ed77b18549d32986$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ed77b18549d32986$export$10c90e4f7922046c(v) {
    return this instanceof $ed77b18549d32986$export$10c90e4f7922046c ? (this.v = v, this) : new $ed77b18549d32986$export$10c90e4f7922046c(v);
}
function $ed77b18549d32986$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ed77b18549d32986$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ed77b18549d32986$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ed77b18549d32986$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $ed77b18549d32986$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ed77b18549d32986$export$19a8beecd37a4c45 === "function" ? $ed77b18549d32986$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ed77b18549d32986$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $ed77b18549d32986$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $ed77b18549d32986$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ed77b18549d32986$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $ed77b18549d32986$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("HkSGF", function(module, exports) {

$parcel$export(module.exports, "isFunction", function () { return $082436cef6fd3af9$export$f6e2535fb5126e54; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $082436cef6fd3af9$export$f6e2535fb5126e54(x) {
    return typeof x === "function";
}

});

parcelRegister("ceBSf", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $8e842bd1f0fb1abb$export$6e22c362a0406a2c; });
/** PURE_IMPORTS_START _config,_util_hostReportError PURE_IMPORTS_END */ 
var $fChUO = parcelRequire("fChUO");

var $67ViU = parcelRequire("67ViU");
var $8e842bd1f0fb1abb$export$6e22c362a0406a2c = {
    closed: true,
    next: function(value) {},
    error: function(err) {
        if ((0, $fChUO.config).useDeprecatedSynchronousErrorHandling) throw err;
        else (0, $67ViU.hostReportError)(err);
    },
    complete: function() {}
};

});
parcelRegister("fChUO", function(module, exports) {

$parcel$export(module.exports, "config", function () { return $b5e84d3c6d2d07bf$export$e506a1d27d1eaa20; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $b5e84d3c6d2d07bf$var$_enable_super_gross_mode_that_will_cause_bad_things = false;
var $b5e84d3c6d2d07bf$export$e506a1d27d1eaa20 = {
    Promise: undefined,
    set useDeprecatedSynchronousErrorHandling (value){
        if (value) {
            var error = /*@__PURE__*/ new Error();
            /*@__PURE__*/ console.warn("DEPRECATED! RxJS was set to use deprecated synchronous error handling behavior by code at: \n" + error.stack);
        } else if ($b5e84d3c6d2d07bf$var$_enable_super_gross_mode_that_will_cause_bad_things) /*@__PURE__*/ console.log("RxJS: Back to a better error behavior. Thank you. <3");
        $b5e84d3c6d2d07bf$var$_enable_super_gross_mode_that_will_cause_bad_things = value;
    },
    get useDeprecatedSynchronousErrorHandling () {
        return $b5e84d3c6d2d07bf$var$_enable_super_gross_mode_that_will_cause_bad_things;
    }
};

});

parcelRegister("67ViU", function(module, exports) {

$parcel$export(module.exports, "hostReportError", function () { return $475fd8e1ba1179ea$export$ebb0f299889f975f; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $475fd8e1ba1179ea$export$ebb0f299889f975f(err) {
    setTimeout(function() {
        throw err;
    }, 0);
}

});


parcelRegister("2Pqsh", function(module, exports) {

$parcel$export(module.exports, "Subscription", function () { return $20f4dd9bc16eae78$export$f55210826850c514; });
/** PURE_IMPORTS_START _util_isArray,_util_isObject,_util_isFunction,_util_UnsubscriptionError PURE_IMPORTS_END */ 
var $6TsDY = parcelRequire("6TsDY");

var $fztEJ = parcelRequire("fztEJ");

var $HkSGF = parcelRequire("HkSGF");

var $9q2RI = parcelRequire("9q2RI");
var $20f4dd9bc16eae78$export$f55210826850c514 = /*@__PURE__*/ function() {
    function Subscription(unsubscribe) {
        this.closed = false;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._ctorUnsubscribe = true;
            this._unsubscribe = unsubscribe;
        }
    }
    Subscription.prototype.unsubscribe = function() {
        var errors;
        if (this.closed) return;
        var _a = this, _parentOrParents = _a._parentOrParents, _ctorUnsubscribe = _a._ctorUnsubscribe, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parentOrParents = null;
        this._subscriptions = null;
        if (_parentOrParents instanceof Subscription) _parentOrParents.remove(this);
        else if (_parentOrParents !== null) for(var index = 0; index < _parentOrParents.length; ++index){
            var parent_1 = _parentOrParents[index];
            parent_1.remove(this);
        }
        if ((0, $HkSGF.isFunction)(_unsubscribe)) {
            if (_ctorUnsubscribe) this._unsubscribe = undefined;
            try {
                _unsubscribe.call(this);
            } catch (e) {
                errors = e instanceof (0, $9q2RI.UnsubscriptionError) ? $20f4dd9bc16eae78$var$flattenUnsubscriptionErrors(e.errors) : [
                    e
                ];
            }
        }
        if ((0, $6TsDY.isArray)(_subscriptions)) {
            var index = -1;
            var len = _subscriptions.length;
            while(++index < len){
                var sub = _subscriptions[index];
                if ((0, $fztEJ.isObject)(sub)) try {
                    sub.unsubscribe();
                } catch (e) {
                    errors = errors || [];
                    if (e instanceof (0, $9q2RI.UnsubscriptionError)) errors = errors.concat($20f4dd9bc16eae78$var$flattenUnsubscriptionErrors(e.errors));
                    else errors.push(e);
                }
            }
        }
        if (errors) throw new (0, $9q2RI.UnsubscriptionError)(errors);
    };
    Subscription.prototype.add = function(teardown) {
        var subscription = teardown;
        if (!teardown) return Subscription.EMPTY;
        switch(typeof teardown){
            case "function":
                subscription = new Subscription(teardown);
            case "object":
                if (subscription === this || subscription.closed || typeof subscription.unsubscribe !== "function") return subscription;
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                } else if (!(subscription instanceof Subscription)) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [
                        tmp
                    ];
                }
                break;
            default:
                throw new Error("unrecognized teardown " + teardown + " added to Subscription.");
        }
        var _parentOrParents = subscription._parentOrParents;
        if (_parentOrParents === null) subscription._parentOrParents = this;
        else if (_parentOrParents instanceof Subscription) {
            if (_parentOrParents === this) return subscription;
            subscription._parentOrParents = [
                _parentOrParents,
                this
            ];
        } else if (_parentOrParents.indexOf(this) === -1) _parentOrParents.push(this);
        else return subscription;
        var subscriptions = this._subscriptions;
        if (subscriptions === null) this._subscriptions = [
            subscription
        ];
        else subscriptions.push(subscription);
        return subscription;
    };
    Subscription.prototype.remove = function(subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) subscriptions.splice(subscriptionIndex, 1);
        }
    };
    Subscription.EMPTY = function(empty) {
        empty.closed = true;
        return empty;
    }(new Subscription());
    return Subscription;
}();
function $20f4dd9bc16eae78$var$flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function(errs, err) {
        return errs.concat(err instanceof (0, $9q2RI.UnsubscriptionError) ? err.errors : err);
    }, []);
}

});
parcelRegister("6TsDY", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $504e1930d7218cc1$export$43bee75e5e14138e; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $504e1930d7218cc1$export$43bee75e5e14138e = /*@__PURE__*/ function() {
    return Array.isArray || function(x) {
        return x && typeof x.length === "number";
    };
}();

});

parcelRegister("fztEJ", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $b56120f54a711add$export$a6cdc56e425d0d0a; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $b56120f54a711add$export$a6cdc56e425d0d0a(x) {
    return x !== null && typeof x === "object";
}

});

parcelRegister("9q2RI", function(module, exports) {

$parcel$export(module.exports, "UnsubscriptionError", function () { return $6db8c3ca76cf05c3$export$c9648b76fd580c34; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $6db8c3ca76cf05c3$var$UnsubscriptionErrorImpl = /*@__PURE__*/ function() {
    function UnsubscriptionErrorImpl(errors) {
        Error.call(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
        return this;
    }
    UnsubscriptionErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return UnsubscriptionErrorImpl;
}();
var $6db8c3ca76cf05c3$export$c9648b76fd580c34 = $6db8c3ca76cf05c3$var$UnsubscriptionErrorImpl;

});


parcelRegister("58x1t", function(module, exports) {

$parcel$export(module.exports, "rxSubscriber", function () { return $3bd750be4aaab86a$export$77f77496d7cade10; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $3bd750be4aaab86a$export$77f77496d7cade10 = /*@__PURE__*/ function() {
    return typeof Symbol === "function" ? /*@__PURE__*/ Symbol("rxSubscriber") : "@@rxSubscriber_" + /*@__PURE__*/ Math.random();
}();
var $3bd750be4aaab86a$export$4a2e07ff24d010f0 = $3bd750be4aaab86a$export$77f77496d7cade10;

});



parcelRegister("6eVN5", function(module, exports) {

$parcel$export(module.exports, "toSubscriber", function () { return $48b0e0ef00ec6d5f$export$2a12c2cebbfd1087; });
/** PURE_IMPORTS_START _Subscriber,_symbol_rxSubscriber,_Observer PURE_IMPORTS_END */ 
var $6wkmF = parcelRequire("6wkmF");

var $58x1t = parcelRequire("58x1t");

var $ceBSf = parcelRequire("ceBSf");
function $48b0e0ef00ec6d5f$export$2a12c2cebbfd1087(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof (0, $6wkmF.Subscriber)) return nextOrObserver;
        if (nextOrObserver[0, $58x1t.rxSubscriber]) return nextOrObserver[0, $58x1t.rxSubscriber]();
    }
    if (!nextOrObserver && !error && !complete) return new (0, $6wkmF.Subscriber)((0, $ceBSf.empty));
    return new (0, $6wkmF.Subscriber)(nextOrObserver, error, complete);
}

});

parcelRegister("aaHfL", function(module, exports) {

$parcel$export(module.exports, "observable", function () { return $767c63be3e2a38cc$export$5ab46cbf6120b33a; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $767c63be3e2a38cc$export$5ab46cbf6120b33a = /*@__PURE__*/ function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();

});

parcelRegister("7l7rJ", function(module, exports) {

$parcel$export(module.exports, "pipeFromArray", function () { return $558045391866d400$export$71f88a61afaa14d7; });
/** PURE_IMPORTS_START _identity PURE_IMPORTS_END */ 
var $iNVFI = parcelRequire("iNVFI");
function $558045391866d400$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $558045391866d400$export$71f88a61afaa14d7(fns);
}
function $558045391866d400$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $iNVFI.identity;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}

});
parcelRegister("iNVFI", function(module, exports) {

$parcel$export(module.exports, "identity", function () { return $db098a0c225e20c6$export$f0954fd7d5368655; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $db098a0c225e20c6$export$f0954fd7d5368655(x) {
    return x;
}

});



parcelRegister("47BTs", function(module, exports) {

$parcel$export(module.exports, "map", function () { return $300535bdf09bd64f$export$871de8747c9eaa88; });
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $6wkmF = parcelRequire("6wkmF");
function $300535bdf09bd64f$export$871de8747c9eaa88(project, thisArg) {
    return function mapOperation(source) {
        if (typeof project !== "function") throw new TypeError("argument is not a function. Are you looking for `mapTo()`?");
        return source.lift(new $300535bdf09bd64f$export$65d6be2d9a2ba8ee(project, thisArg));
    };
}
var $300535bdf09bd64f$export$65d6be2d9a2ba8ee = /*@__PURE__*/ function() {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $300535bdf09bd64f$var$MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}();
var $300535bdf09bd64f$var$MapSubscriber = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.count = 0;
        _this.thisArg = thisArg || _this;
        return _this;
    }
    MapSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}((0, $6wkmF.Subscriber));

});


parcelRegister("8EFKA", function(module, exports) {

$parcel$export(module.exports, "merge", function () { return $64d271eba9528423$export$4950aa0f605343fb; });
/** PURE_IMPORTS_START _Observable,_util_isScheduler,_operators_mergeAll,_fromArray PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $QIcEK = parcelRequire("QIcEK");

var $4mJzy = parcelRequire("4mJzy");

var $6HKqY = parcelRequire("6HKqY");
function $64d271eba9528423$export$4950aa0f605343fb() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i] = arguments[_i];
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if ((0, $QIcEK.isScheduler)(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === "number") concurrent = observables.pop();
    } else if (typeof last === "number") concurrent = observables.pop();
    if (scheduler === null && observables.length === 1 && observables[0] instanceof (0, $7BmHO.Observable)) return observables[0];
    return (0, $4mJzy.mergeAll)(concurrent)((0, $6HKqY.fromArray)(observables, scheduler));
}

});
parcelRegister("QIcEK", function(module, exports) {

$parcel$export(module.exports, "isScheduler", function () { return $09e72543c6fd53c7$export$187e35932e88c15c; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $09e72543c6fd53c7$export$187e35932e88c15c(value) {
    return value && typeof value.schedule === "function";
}

});

parcelRegister("4mJzy", function(module, exports) {

$parcel$export(module.exports, "mergeAll", function () { return $32dc913e414ec4b8$export$18aef43295bbe906; });
/** PURE_IMPORTS_START _mergeMap,_util_identity PURE_IMPORTS_END */ 
var $5ZwVi = parcelRequire("5ZwVi");

var $iNVFI = parcelRequire("iNVFI");
function $32dc913e414ec4b8$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return (0, $5ZwVi.mergeMap)((0, $iNVFI.identity), concurrent);
}

});
parcelRegister("5ZwVi", function(module, exports) {

$parcel$export(module.exports, "mergeMap", function () { return $45cc301e6eb0b572$export$6b9f6c0d32c093f9; });
/** PURE_IMPORTS_START tslib,_map,_observable_from,_innerSubscribe PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $47BTs = parcelRequire("47BTs");

var $409h5 = parcelRequire("409h5");

var $asRHX = parcelRequire("asRHX");
function $45cc301e6eb0b572$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === "function") return function(source) {
        return source.pipe($45cc301e6eb0b572$export$6b9f6c0d32c093f9(function(a, i) {
            return (0, $409h5.from)(project(a, i)).pipe((0, $47BTs.map)(function(b, ii) {
                return resultSelector(a, b, i, ii);
            }));
        }, concurrent));
    };
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return function(source) {
        return source.lift(new $45cc301e6eb0b572$export$397d304a18305ca8(project, concurrent));
    };
}
var $45cc301e6eb0b572$export$397d304a18305ca8 = /*@__PURE__*/ function() {
    function MergeMapOperator(project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.project = project;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $45cc301e6eb0b572$export$c13a9be6692e882(observer, this.project, this.concurrent));
    };
    return MergeMapOperator;
}();
var $45cc301e6eb0b572$export$c13a9be6692e882 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        var _this = _super.call(this, destination) || this;
        _this.project = project;
        _this.concurrent = concurrent;
        _this.hasCompleted = false;
        _this.buffer = [];
        _this.active = 0;
        _this.index = 0;
        return _this;
    }
    MergeMapSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) this._tryNext(value);
        else this.buffer.push(value);
    };
    MergeMapSubscriber.prototype._tryNext = function(value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result);
    };
    MergeMapSubscriber.prototype._innerSub = function(ish) {
        var innerSubscriber = new (0, $asRHX.SimpleInnerSubscriber)(this);
        var destination = this.destination;
        destination.add(innerSubscriber);
        var innerSubscription = (0, $asRHX.innerSubscribe)(ish, innerSubscriber);
        if (innerSubscription !== innerSubscriber) destination.add(innerSubscription);
    };
    MergeMapSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
        this.unsubscribe();
    };
    MergeMapSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    MergeMapSubscriber.prototype.notifyComplete = function() {
        var buffer = this.buffer;
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapSubscriber;
}((0, $asRHX.SimpleOuterSubscriber));
var $45cc301e6eb0b572$export$5b8affa63fc6df16 = $45cc301e6eb0b572$export$6b9f6c0d32c093f9;

});
parcelRegister("409h5", function(module, exports) {

$parcel$export(module.exports, "from", function () { return $2e9e5b44a8821051$export$6788812c4e6611e6; });
/** PURE_IMPORTS_START _Observable,_util_subscribeTo,_scheduled_scheduled PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $aWGrA = parcelRequire("aWGrA");

var $j8MUO = parcelRequire("j8MUO");
function $2e9e5b44a8821051$export$6788812c4e6611e6(input, scheduler) {
    if (!scheduler) {
        if (input instanceof (0, $7BmHO.Observable)) return input;
        return new (0, $7BmHO.Observable)((0, $aWGrA.subscribeTo)(input));
    } else return (0, $j8MUO.scheduled)(input, scheduler);
}

});
parcelRegister("aWGrA", function(module, exports) {

$parcel$export(module.exports, "subscribeTo", function () { return $7f803ea83498e173$export$45e4095b0ba1d337; });
/** PURE_IMPORTS_START _subscribeToArray,_subscribeToPromise,_subscribeToIterable,_subscribeToObservable,_isArrayLike,_isPromise,_isObject,_symbol_iterator,_symbol_observable PURE_IMPORTS_END */ 
var $aAmiU = parcelRequire("aAmiU");

var $hWVAH = parcelRequire("hWVAH");

var $0KEEu = parcelRequire("0KEEu");

var $44C2m = parcelRequire("44C2m");

var $gbBFw = parcelRequire("gbBFw");

var $1LPXe = parcelRequire("1LPXe");

var $fztEJ = parcelRequire("fztEJ");

var $3Dcbb = parcelRequire("3Dcbb");

var $aaHfL = parcelRequire("aaHfL");
var $7f803ea83498e173$export$45e4095b0ba1d337 = function(result) {
    if (!!result && typeof result[0, $aaHfL.observable] === "function") return (0, $44C2m.subscribeToObservable)(result);
    else if ((0, $gbBFw.isArrayLike)(result)) return (0, $aAmiU.subscribeToArray)(result);
    else if ((0, $1LPXe.isPromise)(result)) return (0, $hWVAH.subscribeToPromise)(result);
    else if (!!result && typeof result[0, $3Dcbb.iterator] === "function") return (0, $0KEEu.subscribeToIterable)(result);
    else {
        var value = (0, $fztEJ.isObject)(result) ? "an invalid object" : "'" + result + "'";
        var msg = "You provided " + value + " where a stream was expected." + " You can provide an Observable, Promise, Array, or Iterable.";
        throw new TypeError(msg);
    }
};

});
parcelRegister("aAmiU", function(module, exports) {

$parcel$export(module.exports, "subscribeToArray", function () { return $7b4e914354abcec1$export$ab22aa77f372e159; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $7b4e914354abcec1$export$ab22aa77f372e159 = function(array) {
    return function(subscriber) {
        for(var i = 0, len = array.length; i < len && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    };
};

});

parcelRegister("hWVAH", function(module, exports) {

$parcel$export(module.exports, "subscribeToPromise", function () { return $d11486c9b8af7651$export$3adcd774773826b8; });
/** PURE_IMPORTS_START _hostReportError PURE_IMPORTS_END */ 
var $67ViU = parcelRequire("67ViU");
var $d11486c9b8af7651$export$3adcd774773826b8 = function(promise) {
    return function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $67ViU.hostReportError));
        return subscriber;
    };
};

});

parcelRegister("0KEEu", function(module, exports) {

$parcel$export(module.exports, "subscribeToIterable", function () { return $002430d95c3549de$export$176678a6ee07b575; });
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
var $3Dcbb = parcelRequire("3Dcbb");
var $002430d95c3549de$export$176678a6ee07b575 = function(iterable) {
    return function(subscriber) {
        var iterator = iterable[0, $3Dcbb.iterator]();
        do {
            var item = void 0;
            try {
                item = iterator.next();
            } catch (err) {
                subscriber.error(err);
                return subscriber;
            }
            if (item.done) {
                subscriber.complete();
                break;
            }
            subscriber.next(item.value);
            if (subscriber.closed) break;
        }while (true);
        if (typeof iterator.return === "function") subscriber.add(function() {
            if (iterator.return) iterator.return();
        });
        return subscriber;
    };
};

});
parcelRegister("3Dcbb", function(module, exports) {

$parcel$export(module.exports, "iterator", function () { return $2a4e76338c9ee1fc$export$6f58e2338da23f4d; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $2a4e76338c9ee1fc$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $2a4e76338c9ee1fc$export$6f58e2338da23f4d = /*@__PURE__*/ $2a4e76338c9ee1fc$export$aa9956be4ae4fe8();
var $2a4e76338c9ee1fc$export$9785f547d3164dac = $2a4e76338c9ee1fc$export$6f58e2338da23f4d;

});


parcelRegister("44C2m", function(module, exports) {

$parcel$export(module.exports, "subscribeToObservable", function () { return $2f750a87cdde516f$export$253b2a6a99e75857; });
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $aaHfL = parcelRequire("aaHfL");
var $2f750a87cdde516f$export$253b2a6a99e75857 = function(obj) {
    return function(subscriber) {
        var obs = obj[0, $aaHfL.observable]();
        if (typeof obs.subscribe !== "function") throw new TypeError("Provided object does not correctly implement Symbol.observable");
        else return obs.subscribe(subscriber);
    };
};

});

parcelRegister("gbBFw", function(module, exports) {

$parcel$export(module.exports, "isArrayLike", function () { return $bc8ae4a29a7f4192$export$1e2f57719e155213; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $bc8ae4a29a7f4192$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};

});

parcelRegister("1LPXe", function(module, exports) {

$parcel$export(module.exports, "isPromise", function () { return $14a27b47108f406c$export$4369c812aac99591; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ function $14a27b47108f406c$export$4369c812aac99591(value) {
    return !!value && typeof value.subscribe !== "function" && typeof value.then === "function";
}

});


parcelRegister("j8MUO", function(module, exports) {

$parcel$export(module.exports, "scheduled", function () { return $def4b53a772ef1cd$export$49c44dfc2bb21d70; });
/** PURE_IMPORTS_START _scheduleObservable,_schedulePromise,_scheduleArray,_scheduleIterable,_util_isInteropObservable,_util_isPromise,_util_isArrayLike,_util_isIterable PURE_IMPORTS_END */ 
var $5IroB = parcelRequire("5IroB");

var $ePyJn = parcelRequire("ePyJn");

var $iCFXC = parcelRequire("iCFXC");

var $bsbam = parcelRequire("bsbam");

var $iwu2z = parcelRequire("iwu2z");

var $1LPXe = parcelRequire("1LPXe");

var $gbBFw = parcelRequire("gbBFw");

var $6QbIt = parcelRequire("6QbIt");
function $def4b53a772ef1cd$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $iwu2z.isInteropObservable)(input)) return (0, $5IroB.scheduleObservable)(input, scheduler);
        else if ((0, $1LPXe.isPromise)(input)) return (0, $ePyJn.schedulePromise)(input, scheduler);
        else if ((0, $gbBFw.isArrayLike)(input)) return (0, $iCFXC.scheduleArray)(input, scheduler);
        else if ((0, $6QbIt.isIterable)(input) || typeof input === "string") return (0, $bsbam.scheduleIterable)(input, scheduler);
    }
    throw new TypeError((input !== null && typeof input || input) + " is not observable");
}

});
parcelRegister("5IroB", function(module, exports) {

$parcel$export(module.exports, "scheduleObservable", function () { return $4296500691da098a$export$ed8bd553a12b6a30; });
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_observable PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $2Pqsh = parcelRequire("2Pqsh");

var $aaHfL = parcelRequire("aaHfL");
function $4296500691da098a$export$ed8bd553a12b6a30(input, scheduler) {
    return new (0, $7BmHO.Observable)(function(subscriber) {
        var sub = new (0, $2Pqsh.Subscription)();
        sub.add(scheduler.schedule(function() {
            var observable = input[0, $aaHfL.observable]();
            sub.add(observable.subscribe({
                next: function(value) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.next(value);
                    }));
                },
                error: function(err) {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.error(err);
                    }));
                },
                complete: function() {
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }
            }));
        }));
        return sub;
    });
}

});

parcelRegister("ePyJn", function(module, exports) {

$parcel$export(module.exports, "schedulePromise", function () { return $acc0c4f6a2486803$export$fc9afd948577f0a8; });
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $2Pqsh = parcelRequire("2Pqsh");
function $acc0c4f6a2486803$export$fc9afd948577f0a8(input, scheduler) {
    return new (0, $7BmHO.Observable)(function(subscriber) {
        var sub = new (0, $2Pqsh.Subscription)();
        sub.add(scheduler.schedule(function() {
            return input.then(function(value) {
                sub.add(scheduler.schedule(function() {
                    subscriber.next(value);
                    sub.add(scheduler.schedule(function() {
                        return subscriber.complete();
                    }));
                }));
            }, function(err) {
                sub.add(scheduler.schedule(function() {
                    return subscriber.error(err);
                }));
            });
        }));
        return sub;
    });
}

});

parcelRegister("iCFXC", function(module, exports) {

$parcel$export(module.exports, "scheduleArray", function () { return $d8ec53160e3873fa$export$b34673931371729a; });
/** PURE_IMPORTS_START _Observable,_Subscription PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $2Pqsh = parcelRequire("2Pqsh");
function $d8ec53160e3873fa$export$b34673931371729a(input, scheduler) {
    return new (0, $7BmHO.Observable)(function(subscriber) {
        var sub = new (0, $2Pqsh.Subscription)();
        var i = 0;
        sub.add(scheduler.schedule(function() {
            if (i === input.length) {
                subscriber.complete();
                return;
            }
            subscriber.next(input[i++]);
            if (!subscriber.closed) sub.add(this.schedule());
        }));
        return sub;
    });
}

});

parcelRegister("bsbam", function(module, exports) {

$parcel$export(module.exports, "scheduleIterable", function () { return $856af89c99c7d54b$export$2b75c58ab9b5b766; });
/** PURE_IMPORTS_START _Observable,_Subscription,_symbol_iterator PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $2Pqsh = parcelRequire("2Pqsh");

var $3Dcbb = parcelRequire("3Dcbb");
function $856af89c99c7d54b$export$2b75c58ab9b5b766(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $7BmHO.Observable)(function(subscriber) {
        var sub = new (0, $2Pqsh.Subscription)();
        var iterator;
        sub.add(function() {
            if (iterator && typeof iterator.return === "function") iterator.return();
        });
        sub.add(scheduler.schedule(function() {
            iterator = input[0, $3Dcbb.iterator]();
            sub.add(scheduler.schedule(function() {
                if (subscriber.closed) return;
                var value;
                var done;
                try {
                    var result = iterator.next();
                    value = result.value;
                    done = result.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            }));
        }));
        return sub;
    });
}

});

parcelRegister("iwu2z", function(module, exports) {

$parcel$export(module.exports, "isInteropObservable", function () { return $d7c2848b162a60f1$export$48c0cddbc99c45c2; });
/** PURE_IMPORTS_START _symbol_observable PURE_IMPORTS_END */ 
var $aaHfL = parcelRequire("aaHfL");
function $d7c2848b162a60f1$export$48c0cddbc99c45c2(input) {
    return input && typeof input[0, $aaHfL.observable] === "function";
}

});

parcelRegister("6QbIt", function(module, exports) {

$parcel$export(module.exports, "isIterable", function () { return $4fb0b00429da89f3$export$9652023d9040757; });
/** PURE_IMPORTS_START _symbol_iterator PURE_IMPORTS_END */ 
var $3Dcbb = parcelRequire("3Dcbb");
function $4fb0b00429da89f3$export$9652023d9040757(input) {
    return input && typeof input[0, $3Dcbb.iterator] === "function";
}

});



parcelRegister("asRHX", function(module, exports) {

$parcel$export(module.exports, "SimpleInnerSubscriber", function () { return $79e62e3528fe742f$export$20b3446cf1c359c0; });
$parcel$export(module.exports, "SimpleOuterSubscriber", function () { return $79e62e3528fe742f$export$b73f91a09e7d5376; });
$parcel$export(module.exports, "innerSubscribe", function () { return $79e62e3528fe742f$export$d34bac9c0f124cff; });
/** PURE_IMPORTS_START tslib,_Subscriber,_Observable,_util_subscribeTo PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $6wkmF = parcelRequire("6wkmF");

var $7BmHO = parcelRequire("7BmHO");

var $aWGrA = parcelRequire("aWGrA");
var $79e62e3528fe742f$export$20b3446cf1c359c0 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(SimpleInnerSubscriber, _super);
    function SimpleInnerSubscriber(parent) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        return _this;
    }
    SimpleInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(value);
    };
    SimpleInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    SimpleInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete();
        this.unsubscribe();
    };
    return SimpleInnerSubscriber;
}((0, $6wkmF.Subscriber));
var $79e62e3528fe742f$export$319f8c60b2d80b53 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(ComplexInnerSubscriber, _super);
    function ComplexInnerSubscriber(parent, outerValue, outerIndex) {
        var _this = _super.call(this) || this;
        _this.parent = parent;
        _this.outerValue = outerValue;
        _this.outerIndex = outerIndex;
        return _this;
    }
    ComplexInnerSubscriber.prototype._next = function(value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this);
    };
    ComplexInnerSubscriber.prototype._error = function(error) {
        this.parent.notifyError(error);
        this.unsubscribe();
    };
    ComplexInnerSubscriber.prototype._complete = function() {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return ComplexInnerSubscriber;
}((0, $6wkmF.Subscriber));
var $79e62e3528fe742f$export$b73f91a09e7d5376 = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(SimpleOuterSubscriber, _super);
    function SimpleOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleOuterSubscriber.prototype.notifyNext = function(innerValue) {
        this.destination.next(innerValue);
    };
    SimpleOuterSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    SimpleOuterSubscriber.prototype.notifyComplete = function() {
        this.destination.complete();
    };
    return SimpleOuterSubscriber;
}((0, $6wkmF.Subscriber));
var $79e62e3528fe742f$export$9643bd8e0cc0c90a = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(ComplexOuterSubscriber, _super);
    function ComplexOuterSubscriber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ComplexOuterSubscriber.prototype.notifyNext = function(_outerValue, innerValue, _outerIndex, _innerSub) {
        this.destination.next(innerValue);
    };
    ComplexOuterSubscriber.prototype.notifyError = function(error) {
        this.destination.error(error);
    };
    ComplexOuterSubscriber.prototype.notifyComplete = function(_innerSub) {
        this.destination.complete();
    };
    return ComplexOuterSubscriber;
}((0, $6wkmF.Subscriber));
function $79e62e3528fe742f$export$d34bac9c0f124cff(result, innerSubscriber) {
    if (innerSubscriber.closed) return undefined;
    if (result instanceof (0, $7BmHO.Observable)) return result.subscribe(innerSubscriber);
    var subscription;
    try {
        subscription = (0, $aWGrA.subscribeTo)(result)(innerSubscriber);
    } catch (error) {
        innerSubscriber.error(error);
    }
    return subscription;
}

});



parcelRegister("6HKqY", function(module, exports) {

$parcel$export(module.exports, "fromArray", function () { return $4e1ac70e41827e90$export$571d59b505e6bb4e; });
/** PURE_IMPORTS_START _Observable,_util_subscribeToArray,_scheduled_scheduleArray PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");

var $aAmiU = parcelRequire("aAmiU");

var $iCFXC = parcelRequire("iCFXC");
function $4e1ac70e41827e90$export$571d59b505e6bb4e(input, scheduler) {
    if (!scheduler) return new (0, $7BmHO.Observable)((0, $aAmiU.subscribeToArray)(input));
    else return (0, $iCFXC.scheduleArray)(input, scheduler);
}

});


parcelRegister("7kVra", function(module, exports) {

$parcel$export(module.exports, "first", function () { return $5576f479aa0bad31$export$43128fadae87b74a; });
/** PURE_IMPORTS_START _util_EmptyError,_filter,_take,_defaultIfEmpty,_throwIfEmpty,_util_identity PURE_IMPORTS_END */ 
var $1sGxi = parcelRequire("1sGxi");

var $lDyMY = parcelRequire("lDyMY");

var $1anw2 = parcelRequire("1anw2");

var $dNViv = parcelRequire("dNViv");

var $cBGL4 = parcelRequire("cBGL4");

var $iNVFI = parcelRequire("iNVFI");
function $5576f479aa0bad31$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $lDyMY.filter)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $iNVFI.identity), (0, $1anw2.take)(1), hasDefaultValue ? (0, $dNViv.defaultIfEmpty)(defaultValue) : (0, $cBGL4.throwIfEmpty)(function() {
            return new (0, $1sGxi.EmptyError)();
        }));
    };
}

});
parcelRegister("1sGxi", function(module, exports) {

$parcel$export(module.exports, "EmptyError", function () { return $110966b75e31d4ce$export$78f6d1b1dbcda304; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $110966b75e31d4ce$var$EmptyErrorImpl = /*@__PURE__*/ function() {
    function EmptyErrorImpl() {
        Error.call(this);
        this.message = "no elements in sequence";
        this.name = "EmptyError";
        return this;
    }
    EmptyErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return EmptyErrorImpl;
}();
var $110966b75e31d4ce$export$78f6d1b1dbcda304 = $110966b75e31d4ce$var$EmptyErrorImpl;

});

parcelRegister("lDyMY", function(module, exports) {

$parcel$export(module.exports, "filter", function () { return $fc0839d22166c7c7$export$3dea766d36a8935f; });
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $6wkmF = parcelRequire("6wkmF");
function $fc0839d22166c7c7$export$3dea766d36a8935f(predicate, thisArg) {
    return function filterOperatorFunction(source) {
        return source.lift(new $fc0839d22166c7c7$var$FilterOperator(predicate, thisArg));
    };
}
var $fc0839d22166c7c7$var$FilterOperator = /*@__PURE__*/ function() {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $fc0839d22166c7c7$var$FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}();
var $fc0839d22166c7c7$var$FilterSubscriber = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        var _this = _super.call(this, destination) || this;
        _this.predicate = predicate;
        _this.thisArg = thisArg;
        _this.count = 0;
        return _this;
    }
    FilterSubscriber.prototype._next = function(value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.destination.next(value);
    };
    return FilterSubscriber;
}((0, $6wkmF.Subscriber));

});

parcelRegister("1anw2", function(module, exports) {

$parcel$export(module.exports, "take", function () { return $0d98f75489760f47$export$b7df5d561049483a; });
/** PURE_IMPORTS_START tslib,_Subscriber,_util_ArgumentOutOfRangeError,_observable_empty PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $6wkmF = parcelRequire("6wkmF");

var $lV6y8 = parcelRequire("lV6y8");

var $cRqG5 = parcelRequire("cRqG5");
function $0d98f75489760f47$export$b7df5d561049483a(count) {
    return function(source) {
        if (count === 0) return (0, $cRqG5.empty)();
        else return source.lift(new $0d98f75489760f47$var$TakeOperator(count));
    };
}
var $0d98f75489760f47$var$TakeOperator = /*@__PURE__*/ function() {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) throw new (0, $lV6y8.ArgumentOutOfRangeError);
    }
    TakeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0d98f75489760f47$var$TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}();
var $0d98f75489760f47$var$TakeSubscriber = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        var _this = _super.call(this, destination) || this;
        _this.total = total;
        _this.count = 0;
        return _this;
    }
    TakeSubscriber.prototype._next = function(value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}((0, $6wkmF.Subscriber));

});
parcelRegister("lV6y8", function(module, exports) {

$parcel$export(module.exports, "ArgumentOutOfRangeError", function () { return $ff540077cd86766d$export$630691c4a0cd4093; });
/** PURE_IMPORTS_START  PURE_IMPORTS_END */ var $ff540077cd86766d$var$ArgumentOutOfRangeErrorImpl = /*@__PURE__*/ function() {
    function ArgumentOutOfRangeErrorImpl() {
        Error.call(this);
        this.message = "argument out of range";
        this.name = "ArgumentOutOfRangeError";
        return this;
    }
    ArgumentOutOfRangeErrorImpl.prototype = /*@__PURE__*/ Object.create(Error.prototype);
    return ArgumentOutOfRangeErrorImpl;
}();
var $ff540077cd86766d$export$630691c4a0cd4093 = $ff540077cd86766d$var$ArgumentOutOfRangeErrorImpl;

});

parcelRegister("cRqG5", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $95cf20f3d971f13b$export$6e22c362a0406a2c; });
/** PURE_IMPORTS_START _Observable PURE_IMPORTS_END */ 
var $7BmHO = parcelRequire("7BmHO");
var $95cf20f3d971f13b$export$ccb33e29d92c9a58 = /*@__PURE__*/ new (0, $7BmHO.Observable)(function(subscriber) {
    return subscriber.complete();
});
function $95cf20f3d971f13b$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $95cf20f3d971f13b$var$emptyScheduled(scheduler) : $95cf20f3d971f13b$export$ccb33e29d92c9a58;
}
function $95cf20f3d971f13b$var$emptyScheduled(scheduler) {
    return new (0, $7BmHO.Observable)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}

});


parcelRegister("dNViv", function(module, exports) {

$parcel$export(module.exports, "defaultIfEmpty", function () { return $a0cc4c084980d8e7$export$e4ca6d7b7a6dcf9b; });
/** PURE_IMPORTS_START tslib,_Subscriber PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $6wkmF = parcelRequire("6wkmF");
function $a0cc4c084980d8e7$export$e4ca6d7b7a6dcf9b(defaultValue) {
    if (defaultValue === void 0) defaultValue = null;
    return function(source) {
        return source.lift(new $a0cc4c084980d8e7$var$DefaultIfEmptyOperator(defaultValue));
    };
}
var $a0cc4c084980d8e7$var$DefaultIfEmptyOperator = /*@__PURE__*/ function() {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a0cc4c084980d8e7$var$DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}();
var $a0cc4c084980d8e7$var$DefaultIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        var _this = _super.call(this, destination) || this;
        _this.defaultValue = defaultValue;
        _this.isEmpty = true;
        return _this;
    }
    DefaultIfEmptySubscriber.prototype._next = function(value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function() {
        if (this.isEmpty) this.destination.next(this.defaultValue);
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}((0, $6wkmF.Subscriber));

});

parcelRegister("cBGL4", function(module, exports) {

$parcel$export(module.exports, "throwIfEmpty", function () { return $92da1ba127a0a5f1$export$c8ea5e9f84346833; });
/** PURE_IMPORTS_START tslib,_util_EmptyError,_Subscriber PURE_IMPORTS_END */ 
var $ko27v = parcelRequire("ko27v");

var $1sGxi = parcelRequire("1sGxi");

var $6wkmF = parcelRequire("6wkmF");
function $92da1ba127a0a5f1$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $92da1ba127a0a5f1$var$defaultErrorFactory;
    return function(source) {
        return source.lift(new $92da1ba127a0a5f1$var$ThrowIfEmptyOperator(errorFactory));
    };
}
var $92da1ba127a0a5f1$var$ThrowIfEmptyOperator = /*@__PURE__*/ function() {
    function ThrowIfEmptyOperator(errorFactory) {
        this.errorFactory = errorFactory;
    }
    ThrowIfEmptyOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $92da1ba127a0a5f1$var$ThrowIfEmptySubscriber(subscriber, this.errorFactory));
    };
    return ThrowIfEmptyOperator;
}();
var $92da1ba127a0a5f1$var$ThrowIfEmptySubscriber = /*@__PURE__*/ function(_super) {
    $ko27v.__extends(ThrowIfEmptySubscriber, _super);
    function ThrowIfEmptySubscriber(destination, errorFactory) {
        var _this = _super.call(this, destination) || this;
        _this.errorFactory = errorFactory;
        _this.hasValue = false;
        return _this;
    }
    ThrowIfEmptySubscriber.prototype._next = function(value) {
        this.hasValue = true;
        this.destination.next(value);
    };
    ThrowIfEmptySubscriber.prototype._complete = function() {
        if (!this.hasValue) {
            var err = void 0;
            try {
                err = this.errorFactory();
            } catch (e) {
                err = e;
            }
            this.destination.error(err);
        } else return this.destination.complete();
    };
    return ThrowIfEmptySubscriber;
}((0, $6wkmF.Subscriber));
function $92da1ba127a0a5f1$var$defaultErrorFactory() {
    return new (0, $1sGxi.EmptyError)();
}

});




parcelRegister("djWs9", function(module, exports) {

$parcel$export(module.exports, "binanceDescribePath", function () { return $a8364de70884fbec$export$3ce22f47ad817987; });

var $7NkOr = parcelRequire("7NkOr");
function $a8364de70884fbec$export$3ce22f47ad817987(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Binance",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Binance")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Binance Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Binance",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("6iw60", function(module, exports) {

$parcel$export(module.exports, "BTCInputScriptType", function () { return $3d1bc41e6a7961fa$export$286aa5edc8fa2ef5; });
$parcel$export(module.exports, "BTCOutputScriptType", function () { return $3d1bc41e6a7961fa$export$4fa17e0928652a13; });
$parcel$export(module.exports, "BTCOutputAddressType", function () { return $3d1bc41e6a7961fa$export$e822caaeef0bd24; });
$parcel$export(module.exports, "unknownUTXOPath", function () { return $3d1bc41e6a7961fa$export$d6d57079c196c50d; });
$parcel$export(module.exports, "describeUTXOPath", function () { return $3d1bc41e6a7961fa$export$7fd9c1e1abfa650c; });
$parcel$export(module.exports, "legacyAccount", function () { return $3d1bc41e6a7961fa$export$674ec567e69de536; });
$parcel$export(module.exports, "segwitAccount", function () { return $3d1bc41e6a7961fa$export$1dfb6fab90b513e4; });
$parcel$export(module.exports, "segwitNativeAccount", function () { return $3d1bc41e6a7961fa$export$569b5f9d14f877e0; });

var $liwN5 = parcelRequire("liwN5");

var $7NkOr = parcelRequire("7NkOr");
$liwN5.assert();
var $3d1bc41e6a7961fa$export$286aa5edc8fa2ef5;
(function(BTCInputScriptType) {
    BTCInputScriptType["CashAddr"] = "cashaddr";
    BTCInputScriptType["Bech32"] = "bech32";
    BTCInputScriptType["SpendAddress"] = "p2pkh";
    BTCInputScriptType["SpendMultisig"] = "p2sh";
    BTCInputScriptType["External"] = "external";
    BTCInputScriptType["SpendWitness"] = "p2wpkh";
    BTCInputScriptType["SpendP2SHWitness"] = "p2sh-p2wpkh";
})($3d1bc41e6a7961fa$export$286aa5edc8fa2ef5 || ($3d1bc41e6a7961fa$export$286aa5edc8fa2ef5 = {}));
var $3d1bc41e6a7961fa$export$4fa17e0928652a13;
(function(BTCOutputScriptType) {
    BTCOutputScriptType["PayToAddress"] = "p2pkh";
    BTCOutputScriptType["PayToMultisig"] = "p2sh";
    BTCOutputScriptType["Bech32"] = "bech32";
    BTCOutputScriptType["PayToWitness"] = "p2wpkh";
    BTCOutputScriptType["PayToP2SHWitness"] = "p2sh-p2wpkh";
})($3d1bc41e6a7961fa$export$4fa17e0928652a13 || ($3d1bc41e6a7961fa$export$4fa17e0928652a13 = {}));
var $3d1bc41e6a7961fa$export$e822caaeef0bd24;
(function(BTCOutputAddressType) {
    BTCOutputAddressType["Spend"] = "spend";
    BTCOutputAddressType["Transfer"] = "transfer";
    BTCOutputAddressType["Change"] = "change";
})($3d1bc41e6a7961fa$export$e822caaeef0bd24 || ($3d1bc41e6a7961fa$export$e822caaeef0bd24 = {}));
function $3d1bc41e6a7961fa$export$d6d57079c196c50d(path, coin, scriptType) {
    return {
        verbose: (0, $7NkOr.addressNListToBIP32)(path),
        coin: coin,
        scriptType: scriptType,
        isKnown: false
    };
}
function $3d1bc41e6a7961fa$export$7fd9c1e1abfa650c(path, coin, scriptType) {
    const unknown = $3d1bc41e6a7961fa$export$d6d57079c196c50d(path, coin, scriptType);
    if (path.length !== 3 && path.length !== 5) return unknown;
    if ((path[0] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    const purpose = path[0] & 0x7fffffff;
    if (![
        44,
        49,
        84
    ].includes(purpose)) return unknown;
    if (purpose === 44 && scriptType !== "p2pkh") return unknown;
    if (purpose === 49 && scriptType !== "p2sh-p2wpkh") return unknown;
    const wholeAccount = path.length === 3;
    const script = {
        ["p2pkh"]: [
            "Legacy"
        ],
        ["p2sh-p2wpkh"]: [],
        ["p2wpkh"]: [
            "Segwit"
        ],
        ["bech32"]: [
            "Segwit Native"
        ]
    }[scriptType];
    let isPrefork = false;
    const slip44 = (0, $7NkOr.slip44ByCoin)(coin);
    if (slip44 === undefined) return unknown;
    if (path[1] !== 0x80000000 + slip44) switch(coin){
        case "BitcoinCash":
        case "BitcoinGold":
            if (path[1] === 0x80000000 + (0, $7NkOr.slip44ByCoin)("Bitcoin")) {
                isPrefork = true;
                break;
            }
            return unknown;
        case "BitcoinSV":
            if (path[1] === 0x80000000 + (0, $7NkOr.slip44ByCoin)("Bitcoin") || path[1] === 0x80000000 + (0, $7NkOr.slip44ByCoin)("BitcoinCash")) {
                isPrefork = true;
                break;
            }
            return unknown;
        default:
            return unknown;
    }
    let attributes = isPrefork ? [
        "Prefork"
    ] : [];
    switch(coin){
        case "Bitcoin":
        case "Litecoin":
        case "BitcoinGold":
        case "Testnet":
            if (script) attributes = attributes.concat(script);
            break;
        default:
            break;
    }
    const attr = attributes.length ? ` (${attributes.join(", ")})` : "";
    const accountIdx = path[2] & 0x7fffffff;
    if (wholeAccount) return {
        coin: coin,
        verbose: `${coin} Account #${accountIdx}${attr}`,
        accountIdx: accountIdx,
        wholeAccount: true,
        isKnown: true,
        scriptType: scriptType,
        isPrefork: isPrefork
    };
    else {
        const change = path[3] === 1 ? "Change " : "";
        const addressIdx = path[4];
        return {
            coin: coin,
            verbose: `${coin} Account #${accountIdx}, ${change}Address #${addressIdx}${attr}`,
            accountIdx: accountIdx,
            addressIdx: addressIdx,
            wholeAccount: false,
            isKnown: true,
            isChange: path[3] === 1,
            scriptType: scriptType,
            isPrefork: isPrefork
        };
    }
}
function $3d1bc41e6a7961fa$export$674ec567e69de536(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: "p2pkh",
        addressNList: [
            2147483692,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}
function $3d1bc41e6a7961fa$export$1dfb6fab90b513e4(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: "p2sh-p2wpkh",
        addressNList: [
            2147483697,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}
function $3d1bc41e6a7961fa$export$569b5f9d14f877e0(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: "p2wpkh",
        addressNList: [
            2147483732,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}

});
parcelRegister("liwN5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f814b6f6be05c767$var$assert() {
    return true;
}
module.exports.assert = $f814b6f6be05c767$var$assert;

});


parcelRegister("6rkXZ", function(module, exports) {

$parcel$export(module.exports, "cosmosDescribePath", function () { return $af3a5091586250b5$export$7ab0671b9d24a9c6; });

var $7NkOr = parcelRequire("7NkOr");
function $af3a5091586250b5$export$7ab0671b9d24a9c6(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Atom",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Atom")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Cosmos Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Atom",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("3XNbu", function(module, exports) {

$parcel$export(module.exports, "osmosisDescribePath", function () { return $3c51572a90d9736e$export$9b2e4b46bf21d842; });

var $7NkOr = parcelRequire("7NkOr");
function $3c51572a90d9736e$export$9b2e4b46bf21d842(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Atom",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Osmo")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Osmosis Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Osmo",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("jSeML", function(module, exports) {

});

parcelRegister("2gFaw", function(module, exports) {

});

parcelRegister("egG3m", function(module, exports) {

$parcel$export(module.exports, "ETHTransactionType", function () { return $67ad5b0f941f1ffd$export$cedd8b29335d93b4; });
$parcel$export(module.exports, "describeETHPath", function () { return $67ad5b0f941f1ffd$export$d706019dc3bfb140; });

var $7NkOr = parcelRequire("7NkOr");
var $67ad5b0f941f1ffd$export$cedd8b29335d93b4;
(function(ETHTransactionType) {
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_LEGACY"] = 0] = "ETH_TX_TYPE_LEGACY";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_2930"] = 1] = "ETH_TX_TYPE_EIP_2930";
    ETHTransactionType[ETHTransactionType["ETH_TX_TYPE_EIP_1559"] = 2] = "ETH_TX_TYPE_EIP_1559";
})($67ad5b0f941f1ffd$export$cedd8b29335d93b4 || ($67ad5b0f941f1ffd$export$cedd8b29335d93b4 = {}));
function $67ad5b0f941f1ffd$export$d706019dc3bfb140(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Ethereum",
        isKnown: false
    };
    if (path.length !== 5) return unknown;
    if (path[0] !== 2147483692) return unknown;
    if (path[1] !== 0x80000000 + (0, $7NkOr.slip44ByCoin)("Ethereum")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0) return unknown;
    if (path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Ethereum Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Ethereum",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("3a5kd", function(module, exports) {

$parcel$export(module.exports, "Events", function () { return $7bd470ccb9983bae$export$ada873a34909da65; });
$parcel$export(module.exports, "makeEvent", function () { return $7bd470ccb9983bae$export$2f7b310570bee07a; });
var $7bd470ccb9983bae$export$ada873a34909da65;
(function(Events) {
    Events["BUTTON_REQUEST"] = "BUTTON_REQUEST";
    Events["CANCEL"] = "CANCEL";
    Events["CHARACTER_REQUEST"] = "CHARACTER_REQUEST";
    Events["CONNECT"] = "CONNECT";
    Events["DISCONNECT"] = "DISCONNECT";
    Events["FAILURE"] = "FAILURE";
    Events["PASSPHRASE_REQUEST"] = "PASSPHRASE_REQUEST";
    Events["PIN_REQUEST"] = "PIN_REQUEST";
    Events["SUCCESS"] = "SUCCESS";
    Events["WORD_REQUEST"] = "WORD_REQUEST";
})($7bd470ccb9983bae$export$ada873a34909da65 || ($7bd470ccb9983bae$export$ada873a34909da65 = {}));
function $7bd470ccb9983bae$export$2f7b310570bee07a(e) {
    return {
        date: Date.now(),
        ...e
    };
}

});

parcelRegister("hNfwf", function(module, exports) {

$parcel$export(module.exports, "HDWalletErrorType", function () { return $b15320d05378f860$export$a674024ace81f545; });
$parcel$export(module.exports, "HDWalletError", function () { return $b15320d05378f860$export$c29d9fdec1e90afd; });
$parcel$export(module.exports, "ActionCancelled", function () { return $b15320d05378f860$export$3410eb2a5585b0bf; });
$parcel$export(module.exports, "DeviceDisconnected", function () { return $b15320d05378f860$export$676067f4d261be86; });
$parcel$export(module.exports, "DisconnectedDeviceDuringOperation", function () { return $b15320d05378f860$export$2a60f41a2ed2742; });
$parcel$export(module.exports, "DeviceLocked", function () { return $b15320d05378f860$export$234c146c58e0cc77; });
$parcel$export(module.exports, "PopupClosedError", function () { return $b15320d05378f860$export$dcd1f0ad7e1a6181; });
$parcel$export(module.exports, "ConflictingApp", function () { return $b15320d05378f860$export$94c7df805d093fb7; });
$parcel$export(module.exports, "SelectApp", function () { return $b15320d05378f860$export$9abedc12bdce47eb; });
$parcel$export(module.exports, "WrongApp", function () { return $b15320d05378f860$export$215e8a733c5dd2ec; });
$parcel$export(module.exports, "FirmwareUpdateRequired", function () { return $b15320d05378f860$export$ff7c4a388b895925; });
$parcel$export(module.exports, "WebHIDNotAvailable", function () { return $b15320d05378f860$export$85790c7963c43ba7; });
$parcel$export(module.exports, "WebUSBNotAvailable", function () { return $b15320d05378f860$export$75daa3a54967a386; });
$parcel$export(module.exports, "WebHIDCouldNotInitialize", function () { return $b15320d05378f860$export$ba1f4fcfb71b698a; });
$parcel$export(module.exports, "WebUSBCouldNotInitialize", function () { return $b15320d05378f860$export$5ee8f67c195d3a2c; });
$parcel$export(module.exports, "WebHIDCouldNotPair", function () { return $b15320d05378f860$export$33d7055206e722a8; });
$parcel$export(module.exports, "WebUSBCouldNotPair", function () { return $b15320d05378f860$export$bc06e2a9bcd40ce5; });
$parcel$export(module.exports, "NavigateToDashboard", function () { return $b15320d05378f860$export$d48dc11882b8bcc3; });
var $b15320d05378f860$export$a674024ace81f545;
(function(HDWalletErrorType) {
    HDWalletErrorType["ActionCancelled"] = "ActionCancelled";
    HDWalletErrorType["DeviceDisconnected"] = "DeviceDisconnected";
    HDWalletErrorType["DisconnectedDeviceDuringOperation"] = "DisconnectedDeviceDuringOperation";
    HDWalletErrorType["DeviceLocked"] = "DeviceLocked";
    HDWalletErrorType["PopupClosedError"] = "PopupClosedError";
    HDWalletErrorType["ConflictingApp"] = "ConflictingApp";
    HDWalletErrorType["SelectApp"] = "SelectApp";
    HDWalletErrorType["WrongApp"] = "WrongApp";
    HDWalletErrorType["FirmwareUpdateRequired"] = "FirmwareUpdateRequired";
    HDWalletErrorType["WebHIDNotAvailable"] = "WebHIDNotAvailable";
    HDWalletErrorType["WebHIDCouldNotInitialize"] = "WebHIDCouldNotInitialize";
    HDWalletErrorType["WebHIDCouldNotPair"] = "WebHIDCouldNotPair";
    HDWalletErrorType["WebUSBNotAvailable"] = "WebUSBNotAvailable";
    HDWalletErrorType["WebUSBCouldNotInitialize"] = "WebUSBCouldNotInitialize";
    HDWalletErrorType["WebUSBCouldNotPair"] = "WebUSBCouldNotPair";
    HDWalletErrorType["NavigateToDashboard"] = "NavigateToDashboard";
})($b15320d05378f860$export$a674024ace81f545 || ($b15320d05378f860$export$a674024ace81f545 = {}));
class $b15320d05378f860$export$c29d9fdec1e90afd extends Error {
    constructor(message, type){
        super(message);
        this.name = type;
        this.type = type;
        this.message = message;
        if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(message).stack;
    }
}
class $b15320d05378f860$export$3410eb2a5585b0bf extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super("Action cancelled", "ActionCancelled");
    }
}
class $b15320d05378f860$export$676067f4d261be86 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super("Device disconnected", "DeviceDisconnected");
    }
}
class $b15320d05378f860$export$2a60f41a2ed2742 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super("Ledger device disconnected during operation", "DisconnectedDeviceDuringOperation");
    }
}
class $b15320d05378f860$export$234c146c58e0cc77 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super("Device locked", "DeviceLocked");
    }
}
class $b15320d05378f860$export$dcd1f0ad7e1a6181 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super("TrezorConnect popup closed", "PopupClosedError");
    }
}
class $b15320d05378f860$export$94c7df805d093fb7 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model){
        super(`Conflicting Application: Another wallet is trying to connect with your ${model}.`, "ConflictingApp");
        this.model = model;
    }
}
class $b15320d05378f860$export$9abedc12bdce47eb extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, app){
        super(`Please open the ${app} app on your ${model}.`, "SelectApp");
    }
}
class $b15320d05378f860$export$215e8a733c5dd2ec extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, app){
        super(`Wrong app open. Please open the ${app} app on your ${model} and try again.`, "WrongApp");
    }
}
class $b15320d05378f860$export$ff7c4a388b895925 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, minVer){
        super(`Firmware ${minVer} or later is required to use your ${model} with this client. Please update your device.`, "FirmwareUpdateRequired");
    }
}
class $b15320d05378f860$export$85790c7963c43ba7 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super(`WebHID is not available in this browser. We recommend trying Chrome.`, "WebHIDNotAvailable");
    }
}
class $b15320d05378f860$export$75daa3a54967a386 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(){
        super(`WebUSB is not available in this browser. We recommend trying Chrome.`, "WebUSBNotAvailable");
    }
}
class $b15320d05378f860$export$ba1f4fcfb71b698a extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, message){
        super(`Could not initialize ${model}: ${message}`, "WebHIDCouldNotInitialize");
    }
}
class $b15320d05378f860$export$5ee8f67c195d3a2c extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, message){
        super(`Could not initialize ${model}: ${message}`, "WebUSBCouldNotInitialize");
    }
}
class $b15320d05378f860$export$33d7055206e722a8 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, message){
        super(`Could not pair ${model}: ${message}`, "WebHIDCouldNotPair");
    }
}
class $b15320d05378f860$export$bc06e2a9bcd40ce5 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model, message){
        super(`Could not pair ${model}: ${message}`, "WebUSBCouldNotPair");
    }
}
class $b15320d05378f860$export$d48dc11882b8bcc3 extends $b15320d05378f860$export$c29d9fdec1e90afd {
    constructor(model){
        super(`Please navigate to the dashboard of your ${model}.`, "NavigateToDashboard");
    }
}

});

parcelRegister("1Q7Hg", function(module, exports) {

$parcel$export(module.exports, "Fio", function () { return $3c73aab92cae35f9$export$8def4a45f97e7930; });
$parcel$export(module.exports, "FioEncryptionContentType", function () { return $3c73aab92cae35f9$export$caf55afb5f71879a; });
$parcel$export(module.exports, "fioDescribePath", function () { return $3c73aab92cae35f9$export$856df5ece1ababcd; });

var $7NkOr = parcelRequire("7NkOr");
var $3c73aab92cae35f9$export$8def4a45f97e7930;
(function(Fio) {
    let ContentType;
    (function(ContentType) {
        ContentType["REQUEST"] = "new_funds_content";
        ContentType["OBT"] = "record_obt_data_content";
    })(ContentType = Fio.ContentType || (Fio.ContentType = {}));
})($3c73aab92cae35f9$export$8def4a45f97e7930 || ($3c73aab92cae35f9$export$8def4a45f97e7930 = {}));
const $3c73aab92cae35f9$export$caf55afb5f71879a = $3c73aab92cae35f9$export$8def4a45f97e7930.ContentType;
function $3c73aab92cae35f9$export$856df5ece1ababcd(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Fio",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Fio")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Fio Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Fio",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("7YAVQ", function(module, exports) {

$parcel$export(module.exports, "kavaDescribePath", function () { return $e3c10f71ed4c662f$export$c52ea3025987c397; });

var $7NkOr = parcelRequire("7NkOr");
function $e3c10f71ed4c662f$export$c52ea3025987c397(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Kava",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Kava")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Kava Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Kava",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("YfkmL", function(module, exports) {

$parcel$export(module.exports, "Keyring", function () { return $7efd1854ddc4c26e$export$8f4cadb4ad8fc35; });

var $bYxgp = parcelRequire("bYxgp");
class $7efd1854ddc4c26e$export$8f4cadb4ad8fc35 extends $bYxgp.EventEmitter2 {
    constructor(){
        super({
            wildcard: true
        });
        this.wallets = {};
        this.aliases = {};
    }
    add(wallet, deviceID) {
        const id = deviceID || new Date().toString();
        if (!this.wallets[id]) {
            this.wallets[id] = wallet;
            wallet.transport && this.decorateEvents(id, wallet.transport);
            return true;
        }
        return false;
    }
    addAlias(aliasee, alias) {
        this.aliases[alias] = aliasee;
    }
    getAlias(aliasee) {
        const keys = Object.keys(this.aliases);
        const values = Object.values(this.aliases);
        const index = values.indexOf(aliasee);
        if (index !== -1) return keys[index];
        return aliasee;
    }
    async exec(method, ...args) {
        return Promise.all(Object.values(this.wallets).map((w)=>{
            const fn = w[method];
            if (typeof fn !== "function") throw new Error(`can't exec non-existent method ${method}`);
            return fn.call(w, ...args);
        })).then((values)=>values.reduce((final, response, i)=>{
                final[Object.keys(this.wallets)[i]] = response;
                return final;
            }, {}));
    }
    get(deviceID) {
        if (deviceID && this.aliases[deviceID] && this.wallets[this.aliases[deviceID]]) return this.wallets[this.aliases[deviceID]];
        if (deviceID && this.wallets[deviceID]) return this.wallets[deviceID];
        if (!!Object.keys(this.wallets).length && !deviceID) return Object.values(this.wallets)[0];
        return null;
    }
    async remove(deviceID) {
        const wallet = this.get(deviceID);
        if (!wallet) return;
        try {
            await wallet.disconnect();
        } catch (e) {
            console.error(e);
        } finally{
            const aliasee = this.aliases[deviceID];
            if (aliasee) {
                delete this.aliases[deviceID];
                delete this.wallets[aliasee];
            } else delete this.wallets[deviceID];
        }
    }
    async removeAll() {
        await Promise.all(Object.keys(this.wallets).map(this.remove.bind(this)));
        this.aliases = {};
    }
    async disconnectAll() {
        const wallets = Object.values(this.wallets);
        for(let i = 0; i < wallets.length; i++)await wallets[i].disconnect();
    }
    decorateEvents(deviceID, events) {
        const wallet = this.get(deviceID);
        if (!wallet) return;
        const vendor = wallet.getVendor();
        events.onAny((e, ...values)=>this.emit([
                vendor,
                deviceID,
                typeof e === "string" ? e : e.join(";")
            ], [
                deviceID,
                ...values
            ]));
    }
}

});
parcelRegister("bYxgp", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this._newListener = conf.newListener);
            conf.removeListener && (this._removeListener = conf.removeListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + " listeners added. " + "Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak) errorMsg += " Event name: " + eventName + ".";
        if (typeof $4TNnu !== "undefined" && $4TNnu.emitWarning) {
            var e = new Error(errorMsg);
            e.name = "MaxListenersExceededWarning";
            e.emitter = this;
            e.count = count;
            $4TNnu.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this._newListener = false;
        this._removeListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === "function") {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === "*" || currentType === "**" || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === "*") {
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === "**") {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === "*";
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) {
                    if (branch === "*" || branch === "**") {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree["*"];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree["**"];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== "_listeners" && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            "**": isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree["*"] && xxTree["*"]._listeners) searchListenerTree(handlers, type, xxTree["*"], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === "string" ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === "**" && type[i + 1] === "**") return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === "function") tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = ".";
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = "";
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== "function") throw new Error("many only accepts instances of Function");
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this._newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === "function") {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this._newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === "function") {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== "function") throw new Error("onAny only accepts instances of Function");
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === "function") {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== "function") throw new Error("on only accepts instances of Function");
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        if (this._newListener) this.emit("newListener", type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === "function") // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== "function") throw new Error("removeListener only takes instances of Function");
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                if (this._removeListener) this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                if (this._removeListener) this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                if (this._removeListener) this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            if (this._removeListener) for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (type === undefined) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});
parcelRegister("4TNnu", function(module, exports) {
// shim for using process in browser
var $391299e0893a3dfa$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $391299e0893a3dfa$var$cachedSetTimeout;
var $391299e0893a3dfa$var$cachedClearTimeout;
function $391299e0893a3dfa$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $391299e0893a3dfa$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        else $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedSetTimeout = $391299e0893a3dfa$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        else $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    } catch (e) {
        $391299e0893a3dfa$var$cachedClearTimeout = $391299e0893a3dfa$var$defaultClearTimeout;
    }
})();
function $391299e0893a3dfa$var$runTimeout(fun) {
    if ($391299e0893a3dfa$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedSetTimeout === $391299e0893a3dfa$var$defaultSetTimout || !$391299e0893a3dfa$var$cachedSetTimeout) && setTimeout) {
        $391299e0893a3dfa$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $391299e0893a3dfa$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $391299e0893a3dfa$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $391299e0893a3dfa$var$runClearTimeout(marker) {
    if ($391299e0893a3dfa$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($391299e0893a3dfa$var$cachedClearTimeout === $391299e0893a3dfa$var$defaultClearTimeout || !$391299e0893a3dfa$var$cachedClearTimeout) && clearTimeout) {
        $391299e0893a3dfa$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $391299e0893a3dfa$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $391299e0893a3dfa$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $391299e0893a3dfa$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $391299e0893a3dfa$var$queue = [];
var $391299e0893a3dfa$var$draining = false;
var $391299e0893a3dfa$var$currentQueue;
var $391299e0893a3dfa$var$queueIndex = -1;
function $391299e0893a3dfa$var$cleanUpNextTick() {
    if (!$391299e0893a3dfa$var$draining || !$391299e0893a3dfa$var$currentQueue) return;
    $391299e0893a3dfa$var$draining = false;
    if ($391299e0893a3dfa$var$currentQueue.length) $391299e0893a3dfa$var$queue = $391299e0893a3dfa$var$currentQueue.concat($391299e0893a3dfa$var$queue);
    else $391299e0893a3dfa$var$queueIndex = -1;
    if ($391299e0893a3dfa$var$queue.length) $391299e0893a3dfa$var$drainQueue();
}
function $391299e0893a3dfa$var$drainQueue() {
    if ($391299e0893a3dfa$var$draining) return;
    var timeout = $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$cleanUpNextTick);
    $391299e0893a3dfa$var$draining = true;
    var len = $391299e0893a3dfa$var$queue.length;
    while(len){
        $391299e0893a3dfa$var$currentQueue = $391299e0893a3dfa$var$queue;
        $391299e0893a3dfa$var$queue = [];
        while(++$391299e0893a3dfa$var$queueIndex < len)if ($391299e0893a3dfa$var$currentQueue) $391299e0893a3dfa$var$currentQueue[$391299e0893a3dfa$var$queueIndex].run();
        $391299e0893a3dfa$var$queueIndex = -1;
        len = $391299e0893a3dfa$var$queue.length;
    }
    $391299e0893a3dfa$var$currentQueue = null;
    $391299e0893a3dfa$var$draining = false;
    $391299e0893a3dfa$var$runClearTimeout(timeout);
}
$391299e0893a3dfa$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $391299e0893a3dfa$var$queue.push(new $391299e0893a3dfa$var$Item(fun, args));
    if ($391299e0893a3dfa$var$queue.length === 1 && !$391299e0893a3dfa$var$draining) $391299e0893a3dfa$var$runTimeout($391299e0893a3dfa$var$drainQueue);
};
// v8 likes predictible objects
function $391299e0893a3dfa$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$391299e0893a3dfa$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$391299e0893a3dfa$var$process.title = "browser";
$391299e0893a3dfa$var$process.browser = true;
$391299e0893a3dfa$var$process.env = {};
$391299e0893a3dfa$var$process.argv = [];
$391299e0893a3dfa$var$process.version = ""; // empty string to avoid regexp issues
$391299e0893a3dfa$var$process.versions = {};
function $391299e0893a3dfa$var$noop() {}
$391299e0893a3dfa$var$process.on = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.addListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.once = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.off = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.removeAllListeners = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.emit = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.prependOnceListener = $391299e0893a3dfa$var$noop;
$391299e0893a3dfa$var$process.listeners = function(name) {
    return [];
};
$391299e0893a3dfa$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$391299e0893a3dfa$var$process.cwd = function() {
    return "/";
};
$391299e0893a3dfa$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$391299e0893a3dfa$var$process.umask = function() {
    return 0;
};

});



parcelRegister("6XItq", function(module, exports) {

});

parcelRegister("8xtJG", function(module, exports) {

$parcel$export(module.exports, "secretDescribePath", function () { return $da3f633656928b5d$export$751479596cbf45d5; });

var $7NkOr = parcelRequire("7NkOr");
function $da3f633656928b5d$export$751479596cbf45d5(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Secret",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Secret")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Secret Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Secret",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("33tWh", function(module, exports) {

$parcel$export(module.exports, "terraDescribePath", function () { return $47dfcedbe1043044$export$86cd0a96e0d58683; });

var $7NkOr = parcelRequire("7NkOr");
function $47dfcedbe1043044$export$86cd0a96e0d58683(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Terra",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Terra")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Terra Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Terra",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("4h0dO", function(module, exports) {

$parcel$export(module.exports, "thorchainDescribePath", function () { return $47fa0dba17daae2a$export$6b61ec62ca6d466f; });

var $7NkOr = parcelRequire("7NkOr");
function $47fa0dba17daae2a$export$6b61ec62ca6d466f(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Rune",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Rune")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Thorchain Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Thorchain",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("7pqG6", function(module, exports) {

$parcel$export(module.exports, "mayachainDescribePath", function () { return $38114bf8cc3196fb$export$7cd0da2aaacab635; });

var $7NkOr = parcelRequire("7NkOr");
function $38114bf8cc3196fb$export$7cd0da2aaacab635(path) {
    const pathStr = (0, $7NkOr.addressNListToBIP32)(path);
    const unknown = {
        verbose: pathStr,
        coin: "Cacao",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + (0, $7NkOr.slip44ByCoin)("Cacao")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Mayachain Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Mayachain",
        isKnown: true,
        isPrefork: false
    };
}

});

parcelRegister("34AFc", function(module, exports) {

$parcel$export(module.exports, "Transport", function () { return $228559444622a02f$export$86495b081fef8e52; });

var $bYxgp = parcelRequire("bYxgp");
class $228559444622a02f$export$86495b081fef8e52 extends $bYxgp.EventEmitter2 {
    constructor(keyring){
        super();
        this.keyring = keyring;
    }
    /**
   * Optional method to bootstrap connection to device
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    async connect() {}
    /**
   * Optional function that gets called to clean up connection to device
   */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    async disconnect() {}
}

});

parcelRegister("7qsEP", function(module, exports) {

$parcel$export(module.exports, "supportsBTC", function () { return $71009ffdf5ef41aa$export$5ed34d9aea5260b9; });
$parcel$export(module.exports, "infoBTC", function () { return $71009ffdf5ef41aa$export$4c9c1eef8e1bc6a1; });
$parcel$export(module.exports, "supportsETH", function () { return $71009ffdf5ef41aa$export$7116af2ba424016e; });
$parcel$export(module.exports, "infoETH", function () { return $71009ffdf5ef41aa$export$61dfae9b622e2b5a; });
$parcel$export(module.exports, "supportsCosmos", function () { return $71009ffdf5ef41aa$export$18a8495432c6d0e1; });
$parcel$export(module.exports, "supportsEthSwitchChain", function () { return $71009ffdf5ef41aa$export$24478485338f8c5b; });
$parcel$export(module.exports, "supportsAvalanche", function () { return $71009ffdf5ef41aa$export$e76bc7cacdc1cf3f; });
$parcel$export(module.exports, "supportsOptimism", function () { return $71009ffdf5ef41aa$export$84a61390dd2f3adf; });
$parcel$export(module.exports, "supportsBSC", function () { return $71009ffdf5ef41aa$export$9a712ae57dff209b; });
$parcel$export(module.exports, "supportsPolygon", function () { return $71009ffdf5ef41aa$export$659459ba45abd5eb; });
$parcel$export(module.exports, "supportsGnosis", function () { return $71009ffdf5ef41aa$export$7af8d7c1815d3ab3; });
$parcel$export(module.exports, "supportsArbitrum", function () { return $71009ffdf5ef41aa$export$d57fa5479ac7a04c; });
$parcel$export(module.exports, "supportsArbitrumNova", function () { return $71009ffdf5ef41aa$export$6208fb220ba2c55b; });
$parcel$export(module.exports, "infoCosmos", function () { return $71009ffdf5ef41aa$export$7bdb4294d6fb83c4; });
$parcel$export(module.exports, "supportsOsmosis", function () { return $71009ffdf5ef41aa$export$8671effb53b663fb; });
$parcel$export(module.exports, "infoOsmosis", function () { return $71009ffdf5ef41aa$export$b729419e6ba61e3e; });
$parcel$export(module.exports, "supportsArkeo", function () { return $71009ffdf5ef41aa$export$4d00acbfe83a5b95; });
$parcel$export(module.exports, "infoArkeo", function () { return $71009ffdf5ef41aa$export$aa1dcf90594205d1; });
$parcel$export(module.exports, "supportsThorchain", function () { return $71009ffdf5ef41aa$export$74c6241ef233078d; });
$parcel$export(module.exports, "infoThorchain", function () { return $71009ffdf5ef41aa$export$4df4f29989d5450; });
$parcel$export(module.exports, "supportsMayachain", function () { return $71009ffdf5ef41aa$export$1f4ff22a3bafbb77; });
$parcel$export(module.exports, "infoMayachain", function () { return $71009ffdf5ef41aa$export$333dbf0822cef9f7; });
$parcel$export(module.exports, "supportsEos", function () { return $71009ffdf5ef41aa$export$a5c618a0b8393b9f; });
$parcel$export(module.exports, "infoEos", function () { return $71009ffdf5ef41aa$export$ad0e4f804b708ed8; });
$parcel$export(module.exports, "supportsFio", function () { return $71009ffdf5ef41aa$export$9f72509853c56d8c; });
$parcel$export(module.exports, "infoFio", function () { return $71009ffdf5ef41aa$export$61df0ac89aec74ad; });
$parcel$export(module.exports, "supportsSecret", function () { return $71009ffdf5ef41aa$export$ddec54c6e8f0391a; });
$parcel$export(module.exports, "infoSecret", function () { return $71009ffdf5ef41aa$export$cb58561a0be47b84; });
$parcel$export(module.exports, "supportsTerra", function () { return $71009ffdf5ef41aa$export$2250f71b58ef488a; });
$parcel$export(module.exports, "infoTerra", function () { return $71009ffdf5ef41aa$export$9b3cf958f4920881; });
$parcel$export(module.exports, "supportsKava", function () { return $71009ffdf5ef41aa$export$df72bda9f45cb26; });
$parcel$export(module.exports, "infoKava", function () { return $71009ffdf5ef41aa$export$98ddac74f77b2317; });
$parcel$export(module.exports, "supportsRipple", function () { return $71009ffdf5ef41aa$export$6f9cfdfb2ea31618; });
$parcel$export(module.exports, "infoRipple", function () { return $71009ffdf5ef41aa$export$dff2c8db966a97bf; });
$parcel$export(module.exports, "supportsBinance", function () { return $71009ffdf5ef41aa$export$23cc23d642fcb583; });
$parcel$export(module.exports, "infoBinance", function () { return $71009ffdf5ef41aa$export$2e4bff3700ceb383; });
$parcel$export(module.exports, "supportsDebugLink", function () { return $71009ffdf5ef41aa$export$1933780703f0f58d; });

var $jDBle = parcelRequire("jDBle");
function $71009ffdf5ef41aa$export$5ed34d9aea5260b9(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsBTC;
}
function $71009ffdf5ef41aa$export$4c9c1eef8e1bc6a1(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsBTCInfo;
}
function $71009ffdf5ef41aa$export$7116af2ba424016e(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsETH;
}
function $71009ffdf5ef41aa$export$61dfae9b622e2b5a(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsETHInfo;
}
function $71009ffdf5ef41aa$export$18a8495432c6d0e1(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsCosmos;
}
function $71009ffdf5ef41aa$export$24478485338f8c5b(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsEthSwitchChain;
}
function $71009ffdf5ef41aa$export$e76bc7cacdc1cf3f(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsAvalanche;
}
function $71009ffdf5ef41aa$export$84a61390dd2f3adf(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsOptimism;
}
function $71009ffdf5ef41aa$export$9a712ae57dff209b(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsBSC;
}
function $71009ffdf5ef41aa$export$659459ba45abd5eb(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsPolygon;
}
function $71009ffdf5ef41aa$export$7af8d7c1815d3ab3(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsGnosis;
}
function $71009ffdf5ef41aa$export$d57fa5479ac7a04c(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsArbitrum;
}
function $71009ffdf5ef41aa$export$6208fb220ba2c55b(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsArbitrumNova;
}
function $71009ffdf5ef41aa$export$7bdb4294d6fb83c4(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsCosmosInfo;
}
function $71009ffdf5ef41aa$export$8671effb53b663fb(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsOsmosis;
}
function $71009ffdf5ef41aa$export$b729419e6ba61e3e(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsOsmosisInfo;
}
function $71009ffdf5ef41aa$export$4d00acbfe83a5b95(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsArkeo;
}
function $71009ffdf5ef41aa$export$aa1dcf90594205d1(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsArkeoInfo;
}
function $71009ffdf5ef41aa$export$74c6241ef233078d(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsThorchain;
}
function $71009ffdf5ef41aa$export$4df4f29989d5450(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsThorchainInfo;
}
function $71009ffdf5ef41aa$export$1f4ff22a3bafbb77(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsMayachain;
}
function $71009ffdf5ef41aa$export$333dbf0822cef9f7(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsMayachainInfo;
}
function $71009ffdf5ef41aa$export$a5c618a0b8393b9f(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsEos;
}
function $71009ffdf5ef41aa$export$ad0e4f804b708ed8(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsEosInfo;
}
function $71009ffdf5ef41aa$export$9f72509853c56d8c(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsFio;
}
function $71009ffdf5ef41aa$export$61df0ac89aec74ad(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsFioInfo;
}
function $71009ffdf5ef41aa$export$ddec54c6e8f0391a(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsSecret;
}
function $71009ffdf5ef41aa$export$cb58561a0be47b84(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsSecretInfo;
}
function $71009ffdf5ef41aa$export$2250f71b58ef488a(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsTerra;
}
function $71009ffdf5ef41aa$export$9b3cf958f4920881(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsTerraInfo;
}
function $71009ffdf5ef41aa$export$df72bda9f45cb26(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsKava;
}
function $71009ffdf5ef41aa$export$98ddac74f77b2317(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsKavaInfo;
}
function $71009ffdf5ef41aa$export$6f9cfdfb2ea31618(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsRipple;
}
function $71009ffdf5ef41aa$export$dff2c8db966a97bf(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsRippleInfo;
}
function $71009ffdf5ef41aa$export$23cc23d642fcb583(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsBinance;
}
function $71009ffdf5ef41aa$export$2e4bff3700ceb383(info) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(info) && info._supportsBinanceInfo;
}
function $71009ffdf5ef41aa$export$1933780703f0f58d(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jDBle)))(wallet) && wallet._supportsDebugLink;
}

});
parcelRegister("jDBle", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $e4bea0192758232a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $e4bea0192758232a$var$isObject;

});



parcelRegister("2MzPv", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $206bdb841ab18954$require$Buffer = $ihoyg.Buffer;
var $jscomp = $jscomp || {};
$jscomp.scope = {};
$jscomp.findInternal = function(a, b, c) {
    a instanceof String && (a = String(a));
    for(var d = a.length, e = 0; e < d; e++){
        var f = a[e];
        if (b.call(c, f, e, a)) return {
            i: e,
            v: f
        };
    }
    return {
        i: -1,
        v: void 0
    };
};
$jscomp.ASSUME_ES5 = !1;
$jscomp.ASSUME_NO_NATIVE_MAP = !1;
$jscomp.ASSUME_NO_NATIVE_SET = !1;
$jscomp.SIMPLE_FROUND_POLYFILL = !1;
$jscomp.defineProperty = $jscomp.ASSUME_ES5 || "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};
$jscomp.getGlobal = function(a) {
    return "undefined" != typeof window && window === a ? a : "undefined" != typeof $parcel$global && null != $parcel$global ? $parcel$global : a;
};
$jscomp.global = $jscomp.getGlobal(this);
$jscomp.polyfill = function(a, b, c, d) {
    if (b) {
        c = $jscomp.global;
        a = a.split(".");
        for(d = 0; d < a.length - 1; d++){
            var e = a[d];
            e in c || (c[e] = {});
            c = c[e];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && $jscomp.defineProperty(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    }
};
$jscomp.polyfill("Array.prototype.findIndex", function(a) {
    return a ? a : function(a, c) {
        return $jscomp.findInternal(this, a, c).i;
    };
}, "es6", "es3");
$jscomp.checkStringArgs = function(a, b, c) {
    if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
    if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
    return a + "";
};
$jscomp.polyfill("String.prototype.endsWith", function(a) {
    return a ? a : function(a, c) {
        var b = $jscomp.checkStringArgs(this, a, "endsWith");
        a += "";
        void 0 === c && (c = b.length);
        c = Math.max(0, Math.min(c | 0, b.length));
        for(var e = a.length; 0 < e && 0 < c;)if (b[--c] != a[--e]) return !1;
        return 0 >= e;
    };
}, "es6", "es3");
$jscomp.polyfill("Array.prototype.find", function(a) {
    return a ? a : function(a, c) {
        return $jscomp.findInternal(this, a, c).v;
    };
}, "es6", "es3");
$jscomp.polyfill("String.prototype.startsWith", function(a) {
    return a ? a : function(a, c) {
        var b = $jscomp.checkStringArgs(this, a, "startsWith");
        a += "";
        var e = b.length, f = a.length;
        c = Math.max(0, Math.min(c | 0, b.length));
        for(var g = 0; g < f && c < e;)if (b[c++] != a[g++]) return !1;
        return g >= f;
    };
}, "es6", "es3");
$jscomp.polyfill("String.prototype.repeat", function(a) {
    return a ? a : function(a) {
        var b = $jscomp.checkStringArgs(this, null, "repeat");
        if (0 > a || 1342177279 < a) throw new RangeError("Invalid count value");
        a |= 0;
        for(var d = ""; a;)if (a & 1 && (d += b), a >>>= 1) b += b;
        return d;
    };
}, "es6", "es3");
var COMPILED = !0, goog = goog || {};
goog.global = this || self;
goog.isDef = function(a) {
    return void 0 !== a;
};
goog.isString = function(a) {
    return "string" == typeof a;
};
goog.isBoolean = function(a) {
    return "boolean" == typeof a;
};
goog.isNumber = function(a) {
    return "number" == typeof a;
};
goog.exportPath_ = function(a, b, c) {
    a = a.split(".");
    c = c || goog.global;
    a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
    for(var d; a.length && (d = a.shift());)!a.length && goog.isDef(b) ? c[d] = b : c = c[d] && c[d] !== Object.prototype[d] ? c[d] : c[d] = {};
};
goog.define = function(a, b) {
    if (!COMPILED) {
        var c = goog.global.CLOSURE_UNCOMPILED_DEFINES, d = goog.global.CLOSURE_DEFINES;
        c && void 0 === c.nodeType && Object.prototype.hasOwnProperty.call(c, a) ? b = c[a] : d && void 0 === d.nodeType && Object.prototype.hasOwnProperty.call(d, a) && (b = d[a]);
    }
    return b;
};
goog.FEATURESET_YEAR = 2012;
goog.DEBUG = !0;
goog.LOCALE = "en";
goog.TRUSTED_SITE = !0;
goog.STRICT_MODE_COMPATIBLE = !1;
goog.DISALLOW_TEST_ONLY_CODE = COMPILED && !goog.DEBUG;
goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING = !1;
goog.provide = function(a) {
    if (goog.isInModuleLoader_()) throw Error("goog.provide cannot be used within a module.");
    if (!COMPILED && goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
    goog.constructNamespace_(a);
};
goog.constructNamespace_ = function(a, b) {
    if (!COMPILED) {
        delete goog.implicitNamespaces_[a];
        for(var c = a; (c = c.substring(0, c.lastIndexOf("."))) && !goog.getObjectByName(c);)goog.implicitNamespaces_[c] = !0;
    }
    goog.exportPath_(a, b);
};
goog.getScriptNonce = function(a) {
    if (a && a != goog.global) return goog.getScriptNonce_(a.document);
    null === goog.cspNonce_ && (goog.cspNonce_ = goog.getScriptNonce_(goog.global.document));
    return goog.cspNonce_;
};
goog.NONCE_PATTERN_ = /^[\w+/_-]+[=]{0,2}$/;
goog.cspNonce_ = null;
goog.getScriptNonce_ = function(a) {
    return (a = a.querySelector && a.querySelector("script[nonce]")) && (a = a.nonce || a.getAttribute("nonce")) && goog.NONCE_PATTERN_.test(a) ? a : "";
};
goog.VALID_MODULE_RE_ = /^[a-zA-Z_$][a-zA-Z0-9._$]*$/;
goog.module = function(a) {
    if (!goog.isString(a) || !a || -1 == a.search(goog.VALID_MODULE_RE_)) throw Error("Invalid module identifier");
    if (!goog.isInGoogModuleLoader_()) throw Error("Module " + a + " has been loaded incorrectly. Note, modules cannot be loaded as normal scripts. They require some kind of pre-processing step. You're likely trying to load a module via a script tag or as a part of a concatenated bundle without rewriting the module. For more info see: https://github.com/google/closure-library/wiki/goog.module:-an-ES6-module-like-alternative-to-goog.provide.");
    if (goog.moduleLoaderState_.moduleName) throw Error("goog.module may only be called once per module.");
    goog.moduleLoaderState_.moduleName = a;
    if (!COMPILED) {
        if (goog.isProvided_(a)) throw Error('Namespace "' + a + '" already declared.');
        delete goog.implicitNamespaces_[a];
    }
};
goog.module.get = function(a) {
    return goog.module.getInternal_(a);
};
goog.module.getInternal_ = function(a) {
    if (!COMPILED) {
        if (a in goog.loadedModules_) return goog.loadedModules_[a].exports;
        if (!goog.implicitNamespaces_[a]) return a = goog.getObjectByName(a), null != a ? a : null;
    }
    return null;
};
goog.ModuleType = {
    ES6: "es6",
    GOOG: "goog"
};
goog.moduleLoaderState_ = null;
goog.isInModuleLoader_ = function() {
    return goog.isInGoogModuleLoader_() || goog.isInEs6ModuleLoader_();
};
goog.isInGoogModuleLoader_ = function() {
    return !!goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.GOOG;
};
goog.isInEs6ModuleLoader_ = function() {
    if (goog.moduleLoaderState_ && goog.moduleLoaderState_.type == goog.ModuleType.ES6) return !0;
    var a = goog.global.$jscomp;
    return a ? "function" != typeof a.getCurrentModulePath ? !1 : !!a.getCurrentModulePath() : !1;
};
goog.module.declareLegacyNamespace = function() {
    if (!COMPILED && !goog.isInGoogModuleLoader_()) throw Error("goog.module.declareLegacyNamespace must be called from within a goog.module");
    if (!COMPILED && !goog.moduleLoaderState_.moduleName) throw Error("goog.module must be called prior to goog.module.declareLegacyNamespace.");
    goog.moduleLoaderState_.declareLegacyNamespace = !0;
};
goog.declareModuleId = function(a) {
    if (!COMPILED) {
        if (!goog.isInEs6ModuleLoader_()) throw Error("goog.declareModuleId may only be called from within an ES6 module");
        if (goog.moduleLoaderState_ && goog.moduleLoaderState_.moduleName) throw Error("goog.declareModuleId may only be called once per module.");
        if (a in goog.loadedModules_) throw Error('Module with namespace "' + a + '" already exists.');
    }
    if (goog.moduleLoaderState_) goog.moduleLoaderState_.moduleName = a;
    else {
        var b = goog.global.$jscomp;
        if (!b || "function" != typeof b.getCurrentModulePath) throw Error('Module with namespace "' + a + '" has been loaded incorrectly.');
        b = b.require(b.getCurrentModulePath());
        goog.loadedModules_[a] = {
            exports: b,
            type: goog.ModuleType.ES6,
            moduleId: a
        };
    }
};
goog.setTestOnly = function(a) {
    if (goog.DISALLOW_TEST_ONLY_CODE) throw a = a || "", Error("Importing test-only code into non-debug environment" + (a ? ": " + a : "."));
};
goog.forwardDeclare = function(a) {};
COMPILED || (goog.isProvided_ = function(a) {
    return a in goog.loadedModules_ || !goog.implicitNamespaces_[a] && goog.isDefAndNotNull(goog.getObjectByName(a));
}, goog.implicitNamespaces_ = {
    "goog.module": !0
});
goog.getObjectByName = function(a, b) {
    a = a.split(".");
    b = b || goog.global;
    for(var c = 0; c < a.length; c++)if (b = b[a[c]], !goog.isDefAndNotNull(b)) return null;
    return b;
};
goog.globalize = function(a, b) {
    b = b || goog.global;
    for(var c in a)b[c] = a[c];
};
goog.addDependency = function(a, b, c, d) {
    !COMPILED && goog.DEPENDENCIES_ENABLED && goog.debugLoader_.addDependency(a, b, c, d);
};
goog.ENABLE_DEBUG_LOADER = !0;
goog.logToConsole_ = function(a) {
    goog.global.console && goog.global.console.error(a);
};
goog.require = function(a) {
    if (!COMPILED) {
        goog.ENABLE_DEBUG_LOADER && goog.debugLoader_.requested(a);
        if (goog.isProvided_(a)) {
            if (goog.isInModuleLoader_()) return goog.module.getInternal_(a);
        } else if (goog.ENABLE_DEBUG_LOADER) {
            var b = goog.moduleLoaderState_;
            goog.moduleLoaderState_ = null;
            try {
                goog.debugLoader_.load_(a);
            } finally{
                goog.moduleLoaderState_ = b;
            }
        }
        return null;
    }
};
goog.requireType = function(a) {
    return {};
};
goog.basePath = "";
goog.nullFunction = function() {};
goog.abstractMethod = function() {
    throw Error("unimplemented abstract method");
};
goog.addSingletonGetter = function(a) {
    a.instance_ = void 0;
    a.getInstance = function() {
        if (a.instance_) return a.instance_;
        goog.DEBUG && (goog.instantiatedSingletons_[goog.instantiatedSingletons_.length] = a);
        return a.instance_ = new a;
    };
};
goog.instantiatedSingletons_ = [];
goog.LOAD_MODULE_USING_EVAL = !0;
goog.SEAL_MODULE_EXPORTS = goog.DEBUG;
goog.loadedModules_ = {};
goog.DEPENDENCIES_ENABLED = !COMPILED && goog.ENABLE_DEBUG_LOADER;
goog.TRANSPILE = "detect";
goog.ASSUME_ES_MODULES_TRANSPILED = !1;
goog.TRANSPILE_TO_LANGUAGE = "";
goog.TRANSPILER = "transpile.js";
goog.hasBadLetScoping = null;
goog.useSafari10Workaround = function() {
    if (null == goog.hasBadLetScoping) {
        try {
            var a = !eval('"use strict";let x = 1; function f() { return typeof x; };f() == "number";');
        } catch (b) {
            a = !1;
        }
        goog.hasBadLetScoping = a;
    }
    return goog.hasBadLetScoping;
};
goog.workaroundSafari10EvalBug = function(a) {
    return "(function(){" + a + "\n;})();\n";
};
goog.loadModule = function(a) {
    var b = goog.moduleLoaderState_;
    try {
        goog.moduleLoaderState_ = {
            moduleName: "",
            declareLegacyNamespace: !1,
            type: goog.ModuleType.GOOG
        };
        if (goog.isFunction(a)) var c = a.call(void 0, {});
        else if (goog.isString(a)) goog.useSafari10Workaround() && (a = goog.workaroundSafari10EvalBug(a)), c = goog.loadModuleFromSource_.call(void 0, a);
        else throw Error("Invalid module definition");
        var d = goog.moduleLoaderState_.moduleName;
        if (goog.isString(d) && d) goog.moduleLoaderState_.declareLegacyNamespace ? goog.constructNamespace_(d, c) : goog.SEAL_MODULE_EXPORTS && Object.seal && "object" == typeof c && null != c && Object.seal(c), goog.loadedModules_[d] = {
            exports: c,
            type: goog.ModuleType.GOOG,
            moduleId: goog.moduleLoaderState_.moduleName
        };
        else throw Error('Invalid module name "' + d + '"');
    } finally{
        goog.moduleLoaderState_ = b;
    }
};
goog.loadModuleFromSource_ = function(a) {
    eval(a);
    return {};
};
goog.normalizePath_ = function(a) {
    a = a.split("/");
    for(var b = 0; b < a.length;)"." == a[b] ? a.splice(b, 1) : b && ".." == a[b] && a[b - 1] && ".." != a[b - 1] ? a.splice(--b, 2) : b++;
    return a.join("/");
};
goog.loadFileSync_ = function(a) {
    if (goog.global.CLOSURE_LOAD_FILE_SYNC) return goog.global.CLOSURE_LOAD_FILE_SYNC(a);
    try {
        var b = new goog.global.XMLHttpRequest;
        b.open("get", a, !1);
        b.send();
        return 0 == b.status || 200 == b.status ? b.responseText : null;
    } catch (c) {
        return null;
    }
};
goog.transpile_ = function(a, b, c) {
    var d = goog.global.$jscomp;
    d || (goog.global.$jscomp = d = {});
    var e = d.transpile;
    if (!e) {
        var f = goog.basePath + goog.TRANSPILER, g = goog.loadFileSync_(f);
        if (g) {
            (function() {
                (0, eval)(g + "\n//# sourceURL=" + f);
            }).call(goog.global);
            if (goog.global.$gwtExport && goog.global.$gwtExport.$jscomp && !goog.global.$gwtExport.$jscomp.transpile) throw Error('The transpiler did not properly export the "transpile" method. $gwtExport: ' + JSON.stringify(goog.global.$gwtExport));
            goog.global.$jscomp.transpile = goog.global.$gwtExport.$jscomp.transpile;
            d = goog.global.$jscomp;
            e = d.transpile;
        }
    }
    e || (e = d.transpile = function(a, b) {
        goog.logToConsole_(b + " requires transpilation but no transpiler was found.");
        return a;
    });
    return e(a, b, c);
};
goog.typeOf = function(a) {
    var b = typeof a;
    if ("object" == b) {
        if (a) {
            if (a instanceof Array) return "array";
            if (a instanceof Object) return b;
            var c = Object.prototype.toString.call(a);
            if ("[object Window]" == c) return "object";
            if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
};
goog.isNull = function(a) {
    return null === a;
};
goog.isDefAndNotNull = function(a) {
    return null != a;
};
goog.isArray = function(a) {
    return "array" == goog.typeOf(a);
};
goog.isArrayLike = function(a) {
    var b = goog.typeOf(a);
    return "array" == b || "object" == b && "number" == typeof a.length;
};
goog.isDateLike = function(a) {
    return goog.isObject(a) && "function" == typeof a.getFullYear;
};
goog.isFunction = function(a) {
    return "function" == goog.typeOf(a);
};
goog.isObject = function(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
};
goog.getUid = function(a) {
    return a[goog.UID_PROPERTY_] || (a[goog.UID_PROPERTY_] = ++goog.uidCounter_);
};
goog.hasUid = function(a) {
    return !!a[goog.UID_PROPERTY_];
};
goog.removeUid = function(a) {
    null !== a && "removeAttribute" in a && a.removeAttribute(goog.UID_PROPERTY_);
    try {
        delete a[goog.UID_PROPERTY_];
    } catch (b) {}
};
goog.UID_PROPERTY_ = "closure_uid_" + (1E9 * Math.random() >>> 0);
goog.uidCounter_ = 0;
goog.getHashCode = goog.getUid;
goog.removeHashCode = goog.removeUid;
goog.cloneObject = function(a) {
    var b = goog.typeOf(a);
    if ("object" == b || "array" == b) {
        if ("function" === typeof a.clone) return a.clone();
        b = "array" == b ? [] : {};
        for(var c in a)b[c] = goog.cloneObject(a[c]);
        return b;
    }
    return a;
};
goog.bindNative_ = function(a, b, c) {
    return a.call.apply(a.bind, arguments);
};
goog.bindJs_ = function(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var c = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(c, d);
            return a.apply(b, c);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
};
goog.bind = function(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? goog.bind = goog.bindNative_ : goog.bind = goog.bindJs_;
    return goog.bind.apply(null, arguments);
};
goog.partial = function(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var b = c.slice();
        b.push.apply(b, arguments);
        return a.apply(this, b);
    };
};
goog.mixin = function(a, b) {
    for(var c in b)a[c] = b[c];
};
goog.now = goog.TRUSTED_SITE && Date.now || function() {
    return +new Date;
};
goog.globalEval = function(a) {
    if (goog.global.execScript) goog.global.execScript(a, "JavaScript");
    else if (goog.global.eval) {
        if (null == goog.evalWorksForGlobals_) {
            try {
                goog.global.eval("var _evalTest_ = 1;");
            } catch (d) {}
            if ("undefined" != typeof goog.global._evalTest_) {
                try {
                    delete goog.global._evalTest_;
                } catch (d) {}
                goog.evalWorksForGlobals_ = !0;
            } else goog.evalWorksForGlobals_ = !1;
        }
        if (goog.evalWorksForGlobals_) goog.global.eval(a);
        else {
            var b = goog.global.document, c = b.createElement("SCRIPT");
            c.type = "text/javascript";
            c.defer = !1;
            c.appendChild(b.createTextNode(a));
            b.head.appendChild(c);
            b.head.removeChild(c);
        }
    } else throw Error("goog.globalEval not available");
};
goog.evalWorksForGlobals_ = null;
goog.getCssName = function(a, b) {
    if ("." == String(a).charAt(0)) throw Error('className passed in goog.getCssName must not start with ".". You passed: ' + a);
    var c = function(a) {
        return goog.cssNameMapping_[a] || a;
    }, d = function(a) {
        a = a.split("-");
        for(var b = [], d = 0; d < a.length; d++)b.push(c(a[d]));
        return b.join("-");
    };
    d = goog.cssNameMapping_ ? "BY_WHOLE" == goog.cssNameMappingStyle_ ? c : d : function(a) {
        return a;
    };
    a = b ? a + "-" + d(b) : d(a);
    return goog.global.CLOSURE_CSS_NAME_MAP_FN ? goog.global.CLOSURE_CSS_NAME_MAP_FN(a) : a;
};
goog.setCssNameMapping = function(a, b) {
    goog.cssNameMapping_ = a;
    goog.cssNameMappingStyle_ = b;
};
!COMPILED && goog.global.CLOSURE_CSS_NAME_MAPPING && (goog.cssNameMapping_ = goog.global.CLOSURE_CSS_NAME_MAPPING);
goog.getMsg = function(a, b, c) {
    c && c.html && (a = a.replace(/</g, "&lt;"));
    b && (a = a.replace(/\{\$([^}]+)}/g, function(a, c) {
        return null != b && c in b ? b[c] : a;
    }));
    return a;
};
goog.getMsgWithFallback = function(a, b) {
    return a;
};
goog.exportSymbol = function(a, b, c) {
    goog.exportPath_(a, b, c);
};
goog.exportProperty = function(a, b, c) {
    a[b] = c;
};
goog.inherits = function(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.superClass_ = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.base = function(a, c, f) {
        for(var d = Array(arguments.length - 2), e = 2; e < arguments.length; e++)d[e - 2] = arguments[e];
        return b.prototype[c].apply(a, d);
    };
};
goog.base = function(a, b, c) {
    var d = arguments.callee.caller;
    if (goog.STRICT_MODE_COMPATIBLE || goog.DEBUG && !d) throw Error("arguments.caller not defined.  goog.base() cannot be used with strict mode code. See http://www.ecma-international.org/ecma-262/5.1/#sec-C");
    if ("undefined" !== typeof d.superClass_) {
        for(var e = Array(arguments.length - 1), f = 1; f < arguments.length; f++)e[f - 1] = arguments[f];
        return d.superClass_.constructor.apply(a, e);
    }
    if ("string" != typeof b && "symbol" != typeof b) throw Error("method names provided to goog.base must be a string or a symbol");
    e = Array(arguments.length - 2);
    for(f = 2; f < arguments.length; f++)e[f - 2] = arguments[f];
    f = !1;
    for(var g = a.constructor.prototype; g; g = Object.getPrototypeOf(g))if (g[b] === d) f = !0;
    else if (f) return g[b].apply(a, e);
    if (a[b] === d) return a.constructor.prototype[b].apply(a, e);
    throw Error("goog.base called from a method of one name to a method of a different name");
};
goog.scope = function(a) {
    if (goog.isInModuleLoader_()) throw Error("goog.scope is not supported within a module.");
    a.call(goog.global);
};
COMPILED || (goog.global.COMPILED = COMPILED);
goog.defineClass = function(a, b) {
    var c = b.constructor, d = b.statics;
    c && c != Object.prototype.constructor || (c = function() {
        throw Error("cannot instantiate an interface (no constructor defined).");
    });
    c = goog.defineClass.createSealingConstructor_(c, a);
    a && goog.inherits(c, a);
    delete b.constructor;
    delete b.statics;
    goog.defineClass.applyProperties_(c.prototype, b);
    null != d && (d instanceof Function ? d(c) : goog.defineClass.applyProperties_(c, d));
    return c;
};
goog.defineClass.SEAL_CLASS_INSTANCES = goog.DEBUG;
goog.defineClass.createSealingConstructor_ = function(a, b) {
    if (!goog.defineClass.SEAL_CLASS_INSTANCES) return a;
    var c = !goog.defineClass.isUnsealable_(b), d = function() {
        var b = a.apply(this, arguments) || this;
        b[goog.UID_PROPERTY_] = b[goog.UID_PROPERTY_];
        this.constructor === d && c && Object.seal instanceof Function && Object.seal(b);
        return b;
    };
    return d;
};
goog.defineClass.isUnsealable_ = function(a) {
    return a && a.prototype && a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_];
};
goog.defineClass.OBJECT_PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.defineClass.applyProperties_ = function(a, b) {
    for(var c in b)Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
    for(var d = 0; d < goog.defineClass.OBJECT_PROTOTYPE_FIELDS_.length; d++)c = goog.defineClass.OBJECT_PROTOTYPE_FIELDS_[d], Object.prototype.hasOwnProperty.call(b, c) && (a[c] = b[c]);
};
goog.tagUnsealableClass = function(a) {
    !COMPILED && goog.defineClass.SEAL_CLASS_INSTANCES && (a.prototype[goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_] = !0);
};
goog.UNSEALABLE_CONSTRUCTOR_PROPERTY_ = "goog_defineClass_legacy_unsealable";
!COMPILED && goog.DEPENDENCIES_ENABLED && (goog.inHtmlDocument_ = function() {
    var a = goog.global.document;
    return null != a && "write" in a;
}, goog.isDocumentLoading_ = function() {
    var a = goog.global.document;
    return a.attachEvent ? "complete" != a.readyState : "loading" == a.readyState;
}, goog.findBasePath_ = function() {
    if (goog.isDef(goog.global.CLOSURE_BASE_PATH) && goog.isString(goog.global.CLOSURE_BASE_PATH)) goog.basePath = goog.global.CLOSURE_BASE_PATH;
    else if (goog.inHtmlDocument_()) {
        var a = goog.global.document, b = a.currentScript;
        a = b ? [
            b
        ] : a.getElementsByTagName("SCRIPT");
        for(b = a.length - 1; 0 <= b; --b){
            var c = a[b].src, d = c.lastIndexOf("?");
            d = -1 == d ? c.length : d;
            if ("base.js" == c.substr(d - 7, 7)) {
                goog.basePath = c.substr(0, d - 7);
                break;
            }
        }
    }
}, goog.findBasePath_(), goog.Transpiler = function() {
    this.requiresTranspilation_ = null;
    this.transpilationTarget_ = goog.TRANSPILE_TO_LANGUAGE;
}, goog.Transpiler.prototype.createRequiresTranspilation_ = function() {
    function a(a, b) {
        e ? d[a] = !0 : b() ? (c = a, d[a] = !1) : e = d[a] = !0;
    }
    function b(a) {
        try {
            return !!eval(a);
        } catch (h) {
            return !1;
        }
    }
    var c = "es3", d = {
        es3: !1
    }, e = !1, f = goog.global.navigator && goog.global.navigator.userAgent ? goog.global.navigator.userAgent : "";
    a("es5", function() {
        return b("[1,].length==1");
    });
    a("es6", function() {
        return f.match(/Edge\/(\d+)(\.\d)*/i) ? !1 : b('(()=>{"use strict";class X{constructor(){if(new.target!=String)throw 1;this.x=42}}let q=Reflect.construct(X,[],String);if(q.x!=42||!(q instanceof String))throw 1;for(const a of[2,3]){if(a==2)continue;function f(z={a}){let a=0;return z.a}{function f(){return 0;}}return f()==3}})()');
    });
    a("es7", function() {
        return b("2 ** 2 == 4");
    });
    a("es8", function() {
        return b("async () => 1, true");
    });
    a("es9", function() {
        return b("({...rest} = {}), true");
    });
    a("es_next", function() {
        return !1;
    });
    return {
        target: c,
        map: d
    };
}, goog.Transpiler.prototype.needsTranspile = function(a, b) {
    if ("always" == goog.TRANSPILE) return !0;
    if ("never" == goog.TRANSPILE) return !1;
    if (!this.requiresTranspilation_) {
        var c = this.createRequiresTranspilation_();
        this.requiresTranspilation_ = c.map;
        this.transpilationTarget_ = this.transpilationTarget_ || c.target;
    }
    if (a in this.requiresTranspilation_) return this.requiresTranspilation_[a] ? !0 : !goog.inHtmlDocument_() || "es6" != b || "noModule" in goog.global.document.createElement("script") ? !1 : !0;
    throw Error("Unknown language mode: " + a);
}, goog.Transpiler.prototype.transpile = function(a, b) {
    return goog.transpile_(a, b, this.transpilationTarget_);
}, goog.transpiler_ = new goog.Transpiler, goog.protectScriptTag_ = function(a) {
    return a.replace(/<\/(SCRIPT)/ig, "\\x3c/$1");
}, goog.DebugLoader_ = function() {
    this.dependencies_ = {};
    this.idToPath_ = {};
    this.written_ = {};
    this.loadingDeps_ = [];
    this.depsToLoad_ = [];
    this.paused_ = !1;
    this.factory_ = new goog.DependencyFactory(goog.transpiler_);
    this.deferredCallbacks_ = {};
    this.deferredQueue_ = [];
}, goog.DebugLoader_.prototype.bootstrap = function(a, b) {
    function c() {
        d && (goog.global.setTimeout(d, 0), d = null);
    }
    var d = b;
    if (a.length) {
        b = [];
        for(var e = 0; e < a.length; e++){
            var f = this.getPathFromDeps_(a[e]);
            if (!f) throw Error("Unregonized namespace: " + a[e]);
            b.push(this.dependencies_[f]);
        }
        f = goog.require;
        var g = 0;
        for(e = 0; e < a.length; e++)f(a[e]), b[e].onLoad(function() {
            ++g == a.length && c();
        });
    } else c();
}, goog.DebugLoader_.prototype.loadClosureDeps = function() {
    this.depsToLoad_.push(this.factory_.createDependency(goog.normalizePath_(goog.basePath + "deps.js"), "deps.js", [], [], {}, !1));
    this.loadDeps_();
}, goog.DebugLoader_.prototype.requested = function(a, b) {
    (a = this.getPathFromDeps_(a)) && (b || this.areDepsLoaded_(this.dependencies_[a].requires)) && (b = this.deferredCallbacks_[a]) && (delete this.deferredCallbacks_[a], b());
}, goog.DebugLoader_.prototype.setDependencyFactory = function(a) {
    this.factory_ = a;
}, goog.DebugLoader_.prototype.load_ = function(a) {
    if (this.getPathFromDeps_(a)) {
        var b = this, c = [], d = function(a) {
            var e = b.getPathFromDeps_(a);
            if (!e) throw Error("Bad dependency path or symbol: " + a);
            if (!b.written_[e]) {
                b.written_[e] = !0;
                a = b.dependencies_[e];
                for(e = 0; e < a.requires.length; e++)goog.isProvided_(a.requires[e]) || d(a.requires[e]);
                c.push(a);
            }
        };
        d(a);
        a = !!this.depsToLoad_.length;
        this.depsToLoad_ = this.depsToLoad_.concat(c);
        this.paused_ || a || this.loadDeps_();
    } else throw a = "goog.require could not find: " + a, goog.logToConsole_(a), Error(a);
}, goog.DebugLoader_.prototype.loadDeps_ = function() {
    for(var a = this, b = this.paused_; this.depsToLoad_.length && !b;)(function() {
        var c = !1, d = a.depsToLoad_.shift(), e = !1;
        a.loading_(d);
        var f = {
            pause: function() {
                if (c) throw Error("Cannot call pause after the call to load.");
                b = !0;
            },
            resume: function() {
                c ? a.resume_() : b = !1;
            },
            loaded: function() {
                if (e) throw Error("Double call to loaded.");
                e = !0;
                a.loaded_(d);
            },
            pending: function() {
                for(var b = [], c = 0; c < a.loadingDeps_.length; c++)b.push(a.loadingDeps_[c]);
                return b;
            },
            setModuleState: function(a) {
                goog.moduleLoaderState_ = {
                    type: a,
                    moduleName: "",
                    declareLegacyNamespace: !1
                };
            },
            registerEs6ModuleExports: function(a, b, c) {
                c && (goog.loadedModules_[c] = {
                    exports: b,
                    type: goog.ModuleType.ES6,
                    moduleId: c || ""
                });
            },
            registerGoogModuleExports: function(a, b) {
                goog.loadedModules_[a] = {
                    exports: b,
                    type: goog.ModuleType.GOOG,
                    moduleId: a
                };
            },
            clearModuleState: function() {
                goog.moduleLoaderState_ = null;
            },
            defer: function(b) {
                if (c) throw Error("Cannot register with defer after the call to load.");
                a.defer_(d, b);
            },
            areDepsLoaded: function() {
                return a.areDepsLoaded_(d.requires);
            }
        };
        try {
            d.load(f);
        } finally{
            c = !0;
        }
    })();
    b && this.pause_();
}, goog.DebugLoader_.prototype.pause_ = function() {
    this.paused_ = !0;
}, goog.DebugLoader_.prototype.resume_ = function() {
    this.paused_ && (this.paused_ = !1, this.loadDeps_());
}, goog.DebugLoader_.prototype.loading_ = function(a) {
    this.loadingDeps_.push(a);
}, goog.DebugLoader_.prototype.loaded_ = function(a) {
    for(var b = 0; b < this.loadingDeps_.length; b++)if (this.loadingDeps_[b] == a) {
        this.loadingDeps_.splice(b, 1);
        break;
    }
    for(b = 0; b < this.deferredQueue_.length; b++)if (this.deferredQueue_[b] == a.path) {
        this.deferredQueue_.splice(b, 1);
        break;
    }
    if (this.loadingDeps_.length == this.deferredQueue_.length && !this.depsToLoad_.length) for(; this.deferredQueue_.length;)this.requested(this.deferredQueue_.shift(), !0);
    a.loaded();
}, goog.DebugLoader_.prototype.areDepsLoaded_ = function(a) {
    for(var b = 0; b < a.length; b++){
        var c = this.getPathFromDeps_(a[b]);
        if (!c || !(c in this.deferredCallbacks_ || goog.isProvided_(a[b]))) return !1;
    }
    return !0;
}, goog.DebugLoader_.prototype.getPathFromDeps_ = function(a) {
    return a in this.idToPath_ ? this.idToPath_[a] : a in this.dependencies_ ? a : null;
}, goog.DebugLoader_.prototype.defer_ = function(a, b) {
    this.deferredCallbacks_[a.path] = b;
    this.deferredQueue_.push(a.path);
}, goog.LoadController = function() {}, goog.LoadController.prototype.pause = function() {}, goog.LoadController.prototype.resume = function() {}, goog.LoadController.prototype.loaded = function() {}, goog.LoadController.prototype.pending = function() {}, goog.LoadController.prototype.registerEs6ModuleExports = function(a, b, c) {}, goog.LoadController.prototype.setModuleState = function(a) {}, goog.LoadController.prototype.clearModuleState = function() {}, goog.LoadController.prototype.defer = function(a) {}, goog.LoadController.prototype.areDepsLoaded = function() {}, goog.Dependency = function(a, b, c, d, e) {
    this.path = a;
    this.relativePath = b;
    this.provides = c;
    this.requires = d;
    this.loadFlags = e;
    this.loaded_ = !1;
    this.loadCallbacks_ = [];
}, goog.Dependency.prototype.getPathName = function() {
    var a = this.path, b = a.indexOf("://");
    0 <= b && (a = a.substring(b + 3), b = a.indexOf("/"), 0 <= b && (a = a.substring(b + 1)));
    return a;
}, goog.Dependency.prototype.onLoad = function(a) {
    this.loaded_ ? a() : this.loadCallbacks_.push(a);
}, goog.Dependency.prototype.loaded = function() {
    this.loaded_ = !0;
    var a = this.loadCallbacks_;
    this.loadCallbacks_ = [];
    for(var b = 0; b < a.length; b++)a[b]();
}, goog.Dependency.defer_ = !1, goog.Dependency.callbackMap_ = {}, goog.Dependency.registerCallback_ = function(a) {
    var b = Math.random().toString(32);
    goog.Dependency.callbackMap_[b] = a;
    return b;
}, goog.Dependency.unregisterCallback_ = function(a) {
    delete goog.Dependency.callbackMap_[a];
}, goog.Dependency.callback_ = function(a, b) {
    if (a in goog.Dependency.callbackMap_) {
        for(var c = goog.Dependency.callbackMap_[a], d = [], e = 1; e < arguments.length; e++)d.push(arguments[e]);
        c.apply(void 0, d);
    } else throw Error("Callback key " + a + " does not exist (was base.js loaded more than once?).");
}, goog.Dependency.prototype.load = function(a) {
    if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
    else if (goog.inHtmlDocument_()) {
        var b = goog.global.document;
        if ("complete" == b.readyState && !goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING) {
            if (/\bdeps.js$/.test(this.path)) {
                a.loaded();
                return;
            }
            throw Error('Cannot write "' + this.path + '" after document load');
        }
        if (!goog.ENABLE_CHROME_APP_SAFE_SCRIPT_LOADING && goog.isDocumentLoading_()) {
            var c = goog.Dependency.registerCallback_(function(b) {
                goog.DebugLoader_.IS_OLD_IE_ && "complete" != b.readyState || (goog.Dependency.unregisterCallback_(c), a.loaded());
            }), d = !goog.DebugLoader_.IS_OLD_IE_ && goog.getScriptNonce() ? ' nonce="' + goog.getScriptNonce() + '"' : "";
            d = '<script src="' + this.path + '" ' + (goog.DebugLoader_.IS_OLD_IE_ ? "onreadystatechange" : "onload") + "=\"goog.Dependency.callback_('" + c + '\', this)" type="text/javascript" ' + (goog.Dependency.defer_ ? "defer" : "") + d + "></script>";
            b.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(d) : d);
        } else {
            var e = b.createElement("script");
            e.defer = goog.Dependency.defer_;
            e.async = !1;
            e.type = "text/javascript";
            (d = goog.getScriptNonce()) && e.setAttribute("nonce", d);
            goog.DebugLoader_.IS_OLD_IE_ ? (a.pause(), e.onreadystatechange = function() {
                if ("loaded" == e.readyState || "complete" == e.readyState) a.loaded(), a.resume();
            }) : e.onload = function() {
                e.onload = null;
                a.loaded();
            };
            e.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(this.path) : this.path;
            b.head.appendChild(e);
        }
    } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), "deps.js" == this.relativePath ? (goog.logToConsole_("Consider setting CLOSURE_IMPORT_SCRIPT before loading base.js, or setting CLOSURE_NO_DEPS to true."), a.loaded()) : a.pause();
}, goog.Es6ModuleDependency = function(a, b, c, d, e) {
    goog.Dependency.call(this, a, b, c, d, e);
}, goog.inherits(goog.Es6ModuleDependency, goog.Dependency), goog.Es6ModuleDependency.prototype.load = function(a) {
    function b(a, b) {
        a = b ? '<script type="module" crossorigin>' + b + "</script>" : '<script type="module" crossorigin src="' + a + '"></script>';
        d.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(a) : a);
    }
    function c(a, b) {
        var c = d.createElement("script");
        c.defer = !0;
        c.async = !1;
        c.type = "module";
        c.setAttribute("crossorigin", !0);
        var e = goog.getScriptNonce();
        e && c.setAttribute("nonce", e);
        b ? c.textContent = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScript(b) : b : c.src = goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createScriptURL(a) : a;
        d.head.appendChild(c);
    }
    if (goog.global.CLOSURE_IMPORT_SCRIPT) goog.global.CLOSURE_IMPORT_SCRIPT(this.path) ? a.loaded() : a.pause();
    else if (goog.inHtmlDocument_()) {
        var d = goog.global.document, e = this;
        if (goog.isDocumentLoading_()) {
            var f = b;
            goog.Dependency.defer_ = !0;
        } else f = c;
        var g = goog.Dependency.registerCallback_(function() {
            goog.Dependency.unregisterCallback_(g);
            a.setModuleState(goog.ModuleType.ES6);
        });
        f(void 0, 'goog.Dependency.callback_("' + g + '")');
        f(this.path, void 0);
        var h = goog.Dependency.registerCallback_(function(b) {
            goog.Dependency.unregisterCallback_(h);
            a.registerEs6ModuleExports(e.path, b, goog.moduleLoaderState_.moduleName);
        });
        f(void 0, 'import * as m from "' + this.path + '"; goog.Dependency.callback_("' + h + '", m)');
        var k = goog.Dependency.registerCallback_(function() {
            goog.Dependency.unregisterCallback_(k);
            a.clearModuleState();
            a.loaded();
        });
        f(void 0, 'goog.Dependency.callback_("' + k + '")');
    } else goog.logToConsole_("Cannot use default debug loader outside of HTML documents."), a.pause();
}, goog.TransformedDependency = function(a, b, c, d, e) {
    goog.Dependency.call(this, a, b, c, d, e);
    this.contents_ = null;
    this.lazyFetch_ = !goog.inHtmlDocument_() || !("noModule" in goog.global.document.createElement("script"));
}, goog.inherits(goog.TransformedDependency, goog.Dependency), goog.TransformedDependency.prototype.load = function(a) {
    function b() {
        e.contents_ = goog.loadFileSync_(e.path);
        e.contents_ && (e.contents_ = e.transform(e.contents_), e.contents_ && (e.contents_ += "\n//# sourceURL=" + e.path));
    }
    function c() {
        e.lazyFetch_ && b();
        if (e.contents_) {
            f && a.setModuleState(goog.ModuleType.ES6);
            try {
                var c = e.contents_;
                e.contents_ = null;
                goog.globalEval(c);
                if (f) var d = goog.moduleLoaderState_.moduleName;
            } finally{
                f && a.clearModuleState();
            }
            f && goog.global.$jscomp.require.ensure([
                e.getPathName()
            ], function() {
                a.registerEs6ModuleExports(e.path, goog.global.$jscomp.require(e.getPathName()), d);
            });
            a.loaded();
        }
    }
    function d() {
        var a = goog.global.document, b = goog.Dependency.registerCallback_(function() {
            goog.Dependency.unregisterCallback_(b);
            c();
        }), d = '<script type="text/javascript">' + goog.protectScriptTag_('goog.Dependency.callback_("' + b + '");') + "</script>";
        a.write(goog.TRUSTED_TYPES_POLICY_ ? goog.TRUSTED_TYPES_POLICY_.createHTML(d) : d);
    }
    var e = this;
    if (goog.global.CLOSURE_IMPORT_SCRIPT) b(), this.contents_ && goog.global.CLOSURE_IMPORT_SCRIPT("", this.contents_) ? (this.contents_ = null, a.loaded()) : a.pause();
    else {
        var f = this.loadFlags.module == goog.ModuleType.ES6;
        this.lazyFetch_ || b();
        var g = 1 < a.pending().length, h = g && goog.DebugLoader_.IS_OLD_IE_;
        g = goog.Dependency.defer_ && (g || goog.isDocumentLoading_());
        if (h || g) a.defer(function() {
            c();
        });
        else {
            var k = goog.global.document;
            h = goog.inHtmlDocument_() && "ActiveXObject" in goog.global;
            if (f && goog.inHtmlDocument_() && goog.isDocumentLoading_() && !h) {
                goog.Dependency.defer_ = !0;
                a.pause();
                var l = k.onreadystatechange;
                k.onreadystatechange = function() {
                    "interactive" == k.readyState && (k.onreadystatechange = l, c(), a.resume());
                    goog.isFunction(l) && l.apply(void 0, arguments);
                };
            } else !goog.DebugLoader_.IS_OLD_IE_ && goog.inHtmlDocument_() && goog.isDocumentLoading_() ? d() : c();
        }
    }
}, goog.TransformedDependency.prototype.transform = function(a) {}, goog.TranspiledDependency = function(a, b, c, d, e, f) {
    goog.TransformedDependency.call(this, a, b, c, d, e);
    this.transpiler = f;
}, goog.inherits(goog.TranspiledDependency, goog.TransformedDependency), goog.TranspiledDependency.prototype.transform = function(a) {
    return this.transpiler.transpile(a, this.getPathName());
}, goog.PreTranspiledEs6ModuleDependency = function(a, b, c, d, e) {
    goog.TransformedDependency.call(this, a, b, c, d, e);
}, goog.inherits(goog.PreTranspiledEs6ModuleDependency, goog.TransformedDependency), goog.PreTranspiledEs6ModuleDependency.prototype.transform = function(a) {
    return a;
}, goog.GoogModuleDependency = function(a, b, c, d, e, f, g) {
    goog.TransformedDependency.call(this, a, b, c, d, e);
    this.needsTranspile_ = f;
    this.transpiler_ = g;
}, goog.inherits(goog.GoogModuleDependency, goog.TransformedDependency), goog.GoogModuleDependency.prototype.transform = function(a) {
    this.needsTranspile_ && (a = this.transpiler_.transpile(a, this.getPathName()));
    return goog.LOAD_MODULE_USING_EVAL && goog.isDef(goog.global.JSON) ? "goog.loadModule(" + goog.global.JSON.stringify(a + "\n//# sourceURL=" + this.path + "\n") + ");" : 'goog.loadModule(function(exports) {"use strict";' + a + "\n;return exports});\n//# sourceURL=" + this.path + "\n";
}, goog.DebugLoader_.IS_OLD_IE_ = !(goog.global.atob || !goog.global.document || !goog.global.document.all), goog.DebugLoader_.prototype.addDependency = function(a, b, c, d) {
    b = b || [];
    a = a.replace(/\\/g, "/");
    var e = goog.normalizePath_(goog.basePath + a);
    d && "boolean" !== typeof d || (d = d ? {
        module: goog.ModuleType.GOOG
    } : {});
    c = this.factory_.createDependency(e, a, b, c, d, goog.transpiler_.needsTranspile(d.lang || "es3", d.module));
    this.dependencies_[e] = c;
    for(c = 0; c < b.length; c++)this.idToPath_[b[c]] = e;
    this.idToPath_[a] = e;
}, goog.DependencyFactory = function(a) {
    this.transpiler = a;
}, goog.DependencyFactory.prototype.createDependency = function(a, b, c, d, e, f) {
    return e.module == goog.ModuleType.GOOG ? new goog.GoogModuleDependency(a, b, c, d, e, f, this.transpiler) : f ? new goog.TranspiledDependency(a, b, c, d, e, this.transpiler) : e.module == goog.ModuleType.ES6 ? "never" == goog.TRANSPILE && goog.ASSUME_ES_MODULES_TRANSPILED ? new goog.PreTranspiledEs6ModuleDependency(a, b, c, d, e) : new goog.Es6ModuleDependency(a, b, c, d, e) : new goog.Dependency(a, b, c, d, e);
}, goog.debugLoader_ = new goog.DebugLoader_, goog.loadClosureDeps = function() {
    goog.debugLoader_.loadClosureDeps();
}, goog.setDependencyFactory = function(a) {
    goog.debugLoader_.setDependencyFactory(a);
}, goog.global.CLOSURE_NO_DEPS || goog.debugLoader_.loadClosureDeps(), goog.bootstrap = function(a, b) {
    goog.debugLoader_.bootstrap(a, b);
});
goog.TRUSTED_TYPES_POLICY_NAME = "";
goog.identity_ = function(a) {
    return a;
};
goog.createTrustedTypesPolicy = function(a) {
    var b = null;
    if ("undefined" === typeof TrustedTypes || !TrustedTypes.createPolicy) return b;
    try {
        b = TrustedTypes.createPolicy(a, {
            createHTML: goog.identity_,
            createScript: goog.identity_,
            createScriptURL: goog.identity_,
            createURL: goog.identity_
        });
    } catch (c) {
        goog.logToConsole_(c.message);
    }
    return b;
};
goog.TRUSTED_TYPES_POLICY_ = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#base") : null;
goog.object = {};
goog.object.is = function(a, b) {
    return a === b ? 0 !== a || 1 / a === 1 / b : a !== a && b !== b;
};
goog.object.forEach = function(a, b, c) {
    for(var d in a)b.call(c, a[d], d, a);
};
goog.object.filter = function(a, b, c) {
    var d = {}, e;
    for(e in a)b.call(c, a[e], e, a) && (d[e] = a[e]);
    return d;
};
goog.object.map = function(a, b, c) {
    var d = {}, e;
    for(e in a)d[e] = b.call(c, a[e], e, a);
    return d;
};
goog.object.some = function(a, b, c) {
    for(var d in a)if (b.call(c, a[d], d, a)) return !0;
    return !1;
};
goog.object.every = function(a, b, c) {
    for(var d in a)if (!b.call(c, a[d], d, a)) return !1;
    return !0;
};
goog.object.getCount = function(a) {
    var b = 0, c;
    for(c in a)b++;
    return b;
};
goog.object.getAnyKey = function(a) {
    for(var b in a)return b;
};
goog.object.getAnyValue = function(a) {
    for(var b in a)return a[b];
};
goog.object.contains = function(a, b) {
    return goog.object.containsValue(a, b);
};
goog.object.getValues = function(a) {
    var b = [], c = 0, d;
    for(d in a)b[c++] = a[d];
    return b;
};
goog.object.getKeys = function(a) {
    var b = [], c = 0, d;
    for(d in a)b[c++] = d;
    return b;
};
goog.object.getValueByKeys = function(a, b) {
    var c = goog.isArrayLike(b), d = c ? b : arguments;
    for(c = c ? 0 : 1; c < d.length; c++){
        if (null == a) return;
        a = a[d[c]];
    }
    return a;
};
goog.object.containsKey = function(a, b) {
    return null !== a && b in a;
};
goog.object.containsValue = function(a, b) {
    for(var c in a)if (a[c] == b) return !0;
    return !1;
};
goog.object.findKey = function(a, b, c) {
    for(var d in a)if (b.call(c, a[d], d, a)) return d;
};
goog.object.findValue = function(a, b, c) {
    return (b = goog.object.findKey(a, b, c)) && a[b];
};
goog.object.isEmpty = function(a) {
    for(var b in a)return !1;
    return !0;
};
goog.object.clear = function(a) {
    for(var b in a)delete a[b];
};
goog.object.remove = function(a, b) {
    var c;
    (c = b in a) && delete a[b];
    return c;
};
goog.object.add = function(a, b, c) {
    if (null !== a && b in a) throw Error('The object already contains the key "' + b + '"');
    goog.object.set(a, b, c);
};
goog.object.get = function(a, b, c) {
    return null !== a && b in a ? a[b] : c;
};
goog.object.set = function(a, b, c) {
    a[b] = c;
};
goog.object.setIfUndefined = function(a, b, c) {
    return b in a ? a[b] : a[b] = c;
};
goog.object.setWithReturnValueIfNotSet = function(a, b, c) {
    if (b in a) return a[b];
    c = c();
    return a[b] = c;
};
goog.object.equals = function(a, b) {
    for(var c in a)if (!(c in b) || a[c] !== b[c]) return !1;
    for(var d in b)if (!(d in a)) return !1;
    return !0;
};
goog.object.clone = function(a) {
    var b = {}, c;
    for(c in a)b[c] = a[c];
    return b;
};
goog.object.unsafeClone = function(a) {
    var b = goog.typeOf(a);
    if ("object" == b || "array" == b) {
        if (goog.isFunction(a.clone)) return a.clone();
        b = "array" == b ? [] : {};
        for(var c in a)b[c] = goog.object.unsafeClone(a[c]);
        return b;
    }
    return a;
};
goog.object.transpose = function(a) {
    var b = {}, c;
    for(c in a)b[a[c]] = c;
    return b;
};
goog.object.PROTOTYPE_FIELDS_ = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
goog.object.extend = function(a, b) {
    for(var c, d, e = 1; e < arguments.length; e++){
        d = arguments[e];
        for(c in d)a[c] = d[c];
        for(var f = 0; f < goog.object.PROTOTYPE_FIELDS_.length; f++)c = goog.object.PROTOTYPE_FIELDS_[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
};
goog.object.create = function(a) {
    var b = arguments.length;
    if (1 == b && goog.isArray(arguments[0])) return goog.object.create.apply(null, arguments[0]);
    if (b % 2) throw Error("Uneven number of arguments");
    for(var c = {}, d = 0; d < b; d += 2)c[arguments[d]] = arguments[d + 1];
    return c;
};
goog.object.createSet = function(a) {
    var b = arguments.length;
    if (1 == b && goog.isArray(arguments[0])) return goog.object.createSet.apply(null, arguments[0]);
    for(var c = {}, d = 0; d < b; d++)c[arguments[d]] = !0;
    return c;
};
goog.object.createImmutableView = function(a) {
    var b = a;
    Object.isFrozen && !Object.isFrozen(a) && (b = Object.create(a), Object.freeze(b));
    return b;
};
goog.object.isImmutableView = function(a) {
    return !!Object.isFrozen && Object.isFrozen(a);
};
goog.object.getAllPropertyNames = function(a, b, c) {
    if (!a) return [];
    if (!Object.getOwnPropertyNames || !Object.getPrototypeOf) return goog.object.getKeys(a);
    for(var d = {}; a && (a !== Object.prototype || b) && (a !== Function.prototype || c);){
        for(var e = Object.getOwnPropertyNames(a), f = 0; f < e.length; f++)d[e[f]] = !0;
        a = Object.getPrototypeOf(a);
    }
    return goog.object.getKeys(d);
};
goog.object.getSuperClass = function(a) {
    return (a = Object.getPrototypeOf(a.prototype)) && a.constructor;
};
goog.debug = {};
goog.debug.Error = function(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, goog.debug.Error);
    else {
        var b = Error().stack;
        b && (this.stack = b);
    }
    a && (this.message = String(a));
    this.reportErrorToServer = !0;
};
goog.inherits(goog.debug.Error, Error);
goog.debug.Error.prototype.name = "CustomError";
goog.dom = {};
goog.dom.NodeType = {
    ELEMENT: 1,
    ATTRIBUTE: 2,
    TEXT: 3,
    CDATA_SECTION: 4,
    ENTITY_REFERENCE: 5,
    ENTITY: 6,
    PROCESSING_INSTRUCTION: 7,
    COMMENT: 8,
    DOCUMENT: 9,
    DOCUMENT_TYPE: 10,
    DOCUMENT_FRAGMENT: 11,
    NOTATION: 12
};
goog.asserts = {};
goog.asserts.ENABLE_ASSERTS = goog.DEBUG;
goog.asserts.AssertionError = function(a, b) {
    goog.debug.Error.call(this, goog.asserts.subs_(a, b));
    this.messagePattern = a;
};
goog.inherits(goog.asserts.AssertionError, goog.debug.Error);
goog.asserts.AssertionError.prototype.name = "AssertionError";
goog.asserts.DEFAULT_ERROR_HANDLER = function(a) {
    throw a;
};
goog.asserts.errorHandler_ = goog.asserts.DEFAULT_ERROR_HANDLER;
goog.asserts.subs_ = function(a, b) {
    a = a.split("%s");
    for(var c = "", d = a.length - 1, e = 0; e < d; e++)c += a[e] + (e < b.length ? b[e] : "%s");
    return c + a[d];
};
goog.asserts.doAssertFailure_ = function(a, b, c, d) {
    var e = "Assertion failed";
    if (c) {
        e += ": " + c;
        var f = d;
    } else a && (e += ": " + a, f = b);
    a = new goog.asserts.AssertionError("" + e, f || []);
    goog.asserts.errorHandler_(a);
};
goog.asserts.setErrorHandler = function(a) {
    goog.asserts.ENABLE_ASSERTS && (goog.asserts.errorHandler_ = a);
};
goog.asserts.assert = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !a && goog.asserts.doAssertFailure_("", null, b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertExists = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && null == a && goog.asserts.doAssertFailure_("Expected to exist: %s.", [
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.fail = function(a, b) {
    goog.asserts.ENABLE_ASSERTS && goog.asserts.errorHandler_(new goog.asserts.AssertionError("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1)));
};
goog.asserts.assertNumber = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isNumber(a) && goog.asserts.doAssertFailure_("Expected number but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertString = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isString(a) && goog.asserts.doAssertFailure_("Expected string but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertFunction = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isFunction(a) && goog.asserts.doAssertFailure_("Expected function but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertObject = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isObject(a) && goog.asserts.doAssertFailure_("Expected object but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertArray = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isArray(a) && goog.asserts.doAssertFailure_("Expected array but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertBoolean = function(a, b, c) {
    goog.asserts.ENABLE_ASSERTS && !goog.isBoolean(a) && goog.asserts.doAssertFailure_("Expected boolean but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertElement = function(a, b, c) {
    !goog.asserts.ENABLE_ASSERTS || goog.isObject(a) && a.nodeType == goog.dom.NodeType.ELEMENT || goog.asserts.doAssertFailure_("Expected Element but got %s: %s.", [
        goog.typeOf(a),
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertInstanceof = function(a, b, c, d) {
    !goog.asserts.ENABLE_ASSERTS || a instanceof b || goog.asserts.doAssertFailure_("Expected instanceof %s but got %s.", [
        goog.asserts.getType_(b),
        goog.asserts.getType_(a)
    ], c, Array.prototype.slice.call(arguments, 3));
    return a;
};
goog.asserts.assertFinite = function(a, b, c) {
    !goog.asserts.ENABLE_ASSERTS || "number" == typeof a && isFinite(a) || goog.asserts.doAssertFailure_("Expected %s to be a finite number but it is not.", [
        a
    ], b, Array.prototype.slice.call(arguments, 2));
    return a;
};
goog.asserts.assertObjectPrototypeIsIntact = function() {
    for(var a in Object.prototype)goog.asserts.fail(a + " should not be enumerable in Object.prototype.");
};
goog.asserts.getType_ = function(a) {
    return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
};
var jspb = {
    BinaryConstants: {},
    ConstBinaryMessage: function() {},
    BinaryMessage: function() {}
};
jspb.BinaryConstants.FieldType = {
    INVALID: -1,
    DOUBLE: 1,
    FLOAT: 2,
    INT64: 3,
    UINT64: 4,
    INT32: 5,
    FIXED64: 6,
    FIXED32: 7,
    BOOL: 8,
    STRING: 9,
    GROUP: 10,
    MESSAGE: 11,
    BYTES: 12,
    UINT32: 13,
    ENUM: 14,
    SFIXED32: 15,
    SFIXED64: 16,
    SINT32: 17,
    SINT64: 18,
    FHASH64: 30,
    VHASH64: 31
};
jspb.BinaryConstants.WireType = {
    INVALID: -1,
    VARINT: 0,
    FIXED64: 1,
    DELIMITED: 2,
    START_GROUP: 3,
    END_GROUP: 4,
    FIXED32: 5
};
jspb.BinaryConstants.FieldTypeToWireType = function(a) {
    var b = jspb.BinaryConstants.FieldType, c = jspb.BinaryConstants.WireType;
    switch(a){
        case b.INT32:
        case b.INT64:
        case b.UINT32:
        case b.UINT64:
        case b.SINT32:
        case b.SINT64:
        case b.BOOL:
        case b.ENUM:
        case b.VHASH64:
            return c.VARINT;
        case b.DOUBLE:
        case b.FIXED64:
        case b.SFIXED64:
        case b.FHASH64:
            return c.FIXED64;
        case b.STRING:
        case b.MESSAGE:
        case b.BYTES:
            return c.DELIMITED;
        case b.FLOAT:
        case b.FIXED32:
        case b.SFIXED32:
            return c.FIXED32;
        default:
            return c.INVALID;
    }
};
jspb.BinaryConstants.INVALID_FIELD_NUMBER = -1;
jspb.BinaryConstants.FLOAT32_EPS = 1.401298464324817E-45;
jspb.BinaryConstants.FLOAT32_MIN = 1.1754943508222875E-38;
jspb.BinaryConstants.FLOAT32_MAX = 3.4028234663852886E38;
jspb.BinaryConstants.FLOAT64_EPS = 4.9E-324;
jspb.BinaryConstants.FLOAT64_MIN = 2.2250738585072014E-308;
jspb.BinaryConstants.FLOAT64_MAX = 1.7976931348623157E308;
jspb.BinaryConstants.TWO_TO_20 = 1048576;
jspb.BinaryConstants.TWO_TO_23 = 8388608;
jspb.BinaryConstants.TWO_TO_31 = 2147483648;
jspb.BinaryConstants.TWO_TO_32 = 4294967296;
jspb.BinaryConstants.TWO_TO_52 = 4503599627370496;
jspb.BinaryConstants.TWO_TO_63 = 0x7fffffffffffffff;
jspb.BinaryConstants.TWO_TO_64 = 1.8446744073709552E19;
jspb.BinaryConstants.ZERO_HASH = "\x00\x00\x00\x00\x00\x00\x00\x00";
goog.array = {};
goog.NATIVE_ARRAY_PROTOTYPES = goog.TRUSTED_SITE;
goog.array.ASSUME_NATIVE_FUNCTIONS = 2012 < goog.FEATURESET_YEAR;
goog.array.peek = function(a) {
    return a[a.length - 1];
};
goog.array.last = goog.array.peek;
goog.array.indexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.indexOf) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.indexOf.call(a, b, c);
} : function(a, b, c) {
    c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
    if (goog.isString(a)) return goog.isString(b) && 1 == b.length ? a.indexOf(b, c) : -1;
    for(; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
goog.array.lastIndexOf = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.lastIndexOf) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.lastIndexOf.call(a, b, null == c ? a.length - 1 : c);
} : function(a, b, c) {
    c = null == c ? a.length - 1 : c;
    0 > c && (c = Math.max(0, a.length + c));
    if (goog.isString(a)) return goog.isString(b) && 1 == b.length ? a.lastIndexOf(b, c) : -1;
    for(; 0 <= c; c--)if (c in a && a[c] === b) return c;
    return -1;
};
goog.array.forEach = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.forEach) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    Array.prototype.forEach.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++)f in e && b.call(c, e[f], f, a);
};
goog.array.forEachRight = function(a, b, c) {
    var d = a.length, e = goog.isString(a) ? a.split("") : a;
    for(--d; 0 <= d; --d)d in e && b.call(c, e[d], d, a);
};
goog.array.filter = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.filter) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.filter.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = [], f = 0, g = goog.isString(a) ? a.split("") : a, h = 0; h < d; h++)if (h in g) {
        var k = g[h];
        b.call(c, k, h, a) && (e[f++] = k);
    }
    return e;
};
goog.array.map = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.map) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.map.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = Array(d), f = goog.isString(a) ? a.split("") : a, g = 0; g < d; g++)g in f && (e[g] = b.call(c, f[g], g, a));
    return e;
};
goog.array.reduce = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduce) ? function(a, b, c, d) {
    goog.asserts.assert(null != a.length);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduce.call(a, b, c);
} : function(a, b, c, d) {
    var e = c;
    goog.array.forEach(a, function(c, g) {
        e = b.call(d, e, c, g, a);
    });
    return e;
};
goog.array.reduceRight = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.reduceRight) ? function(a, b, c, d) {
    goog.asserts.assert(null != a.length);
    goog.asserts.assert(null != b);
    d && (b = goog.bind(b, d));
    return Array.prototype.reduceRight.call(a, b, c);
} : function(a, b, c, d) {
    var e = c;
    goog.array.forEachRight(a, function(c, g) {
        e = b.call(d, e, c, g, a);
    });
    return e;
};
goog.array.some = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.some) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.some.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return !0;
    return !1;
};
goog.array.every = goog.NATIVE_ARRAY_PROTOTYPES && (goog.array.ASSUME_NATIVE_FUNCTIONS || Array.prototype.every) ? function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.every.call(a, b, c);
} : function(a, b, c) {
    for(var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++)if (f in e && !b.call(c, e[f], f, a)) return !1;
    return !0;
};
goog.array.count = function(a, b, c) {
    var d = 0;
    goog.array.forEach(a, function(a, f, g) {
        b.call(c, a, f, g) && ++d;
    }, c);
    return d;
};
goog.array.find = function(a, b, c) {
    b = goog.array.findIndex(a, b, c);
    return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndex = function(a, b, c) {
    for(var d = a.length, e = goog.isString(a) ? a.split("") : a, f = 0; f < d; f++)if (f in e && b.call(c, e[f], f, a)) return f;
    return -1;
};
goog.array.findRight = function(a, b, c) {
    b = goog.array.findIndexRight(a, b, c);
    return 0 > b ? null : goog.isString(a) ? a.charAt(b) : a[b];
};
goog.array.findIndexRight = function(a, b, c) {
    var d = a.length, e = goog.isString(a) ? a.split("") : a;
    for(--d; 0 <= d; d--)if (d in e && b.call(c, e[d], d, a)) return d;
    return -1;
};
goog.array.contains = function(a, b) {
    return 0 <= goog.array.indexOf(a, b);
};
goog.array.isEmpty = function(a) {
    return 0 == a.length;
};
goog.array.clear = function(a) {
    if (!goog.isArray(a)) for(var b = a.length - 1; 0 <= b; b--)delete a[b];
    a.length = 0;
};
goog.array.insert = function(a, b) {
    goog.array.contains(a, b) || a.push(b);
};
goog.array.insertAt = function(a, b, c) {
    goog.array.splice(a, c, 0, b);
};
goog.array.insertArrayAt = function(a, b, c) {
    goog.partial(goog.array.splice, a, c, 0).apply(null, b);
};
goog.array.insertBefore = function(a, b, c) {
    var d;
    2 == arguments.length || 0 > (d = goog.array.indexOf(a, c)) ? a.push(b) : goog.array.insertAt(a, b, d);
};
goog.array.remove = function(a, b) {
    b = goog.array.indexOf(a, b);
    var c;
    (c = 0 <= b) && goog.array.removeAt(a, b);
    return c;
};
goog.array.removeLast = function(a, b) {
    b = goog.array.lastIndexOf(a, b);
    return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
};
goog.array.removeAt = function(a, b) {
    goog.asserts.assert(null != a.length);
    return 1 == Array.prototype.splice.call(a, b, 1).length;
};
goog.array.removeIf = function(a, b, c) {
    b = goog.array.findIndex(a, b, c);
    return 0 <= b ? (goog.array.removeAt(a, b), !0) : !1;
};
goog.array.removeAllIf = function(a, b, c) {
    var d = 0;
    goog.array.forEachRight(a, function(e, f) {
        b.call(c, e, f, a) && goog.array.removeAt(a, f) && d++;
    });
    return d;
};
goog.array.concat = function(a) {
    return Array.prototype.concat.apply([], arguments);
};
goog.array.join = function(a) {
    return Array.prototype.concat.apply([], arguments);
};
goog.array.toArray = function(a) {
    var b = a.length;
    if (0 < b) {
        for(var c = Array(b), d = 0; d < b; d++)c[d] = a[d];
        return c;
    }
    return [];
};
goog.array.clone = goog.array.toArray;
goog.array.extend = function(a, b) {
    for(var c = 1; c < arguments.length; c++){
        var d = arguments[c];
        if (goog.isArrayLike(d)) {
            var e = a.length || 0, f = d.length || 0;
            a.length = e + f;
            for(var g = 0; g < f; g++)a[e + g] = d[g];
        } else a.push(d);
    }
};
goog.array.splice = function(a, b, c, d) {
    goog.asserts.assert(null != a.length);
    return Array.prototype.splice.apply(a, goog.array.slice(arguments, 1));
};
goog.array.slice = function(a, b, c) {
    goog.asserts.assert(null != a.length);
    return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
};
goog.array.removeDuplicates = function(a, b, c) {
    b = b || a;
    var d = function(a) {
        return goog.isObject(a) ? "o" + goog.getUid(a) : (typeof a).charAt(0) + a;
    };
    c = c || d;
    d = {};
    for(var e = 0, f = 0; f < a.length;){
        var g = a[f++], h = c(g);
        Object.prototype.hasOwnProperty.call(d, h) || (d[h] = !0, b[e++] = g);
    }
    b.length = e;
};
goog.array.binarySearch = function(a, b, c) {
    return goog.array.binarySearch_(a, c || goog.array.defaultCompare, !1, b);
};
goog.array.binarySelect = function(a, b, c) {
    return goog.array.binarySearch_(a, b, !0, void 0, c);
};
goog.array.binarySearch_ = function(a, b, c, d, e) {
    for(var f = 0, g = a.length, h; f < g;){
        var k = f + g >> 1;
        var l = c ? b.call(e, a[k], k, a) : b(d, a[k]);
        0 < l ? f = k + 1 : (g = k, h = !l);
    }
    return h ? f : ~f;
};
goog.array.sort = function(a, b) {
    a.sort(b || goog.array.defaultCompare);
};
goog.array.stableSort = function(a, b) {
    for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = {
        index: d,
        value: a[d]
    };
    var e = b || goog.array.defaultCompare;
    goog.array.sort(c, function(a, b) {
        return e(a.value, b.value) || a.index - b.index;
    });
    for(d = 0; d < a.length; d++)a[d] = c[d].value;
};
goog.array.sortByKey = function(a, b, c) {
    var d = c || goog.array.defaultCompare;
    goog.array.sort(a, function(a, c) {
        return d(b(a), b(c));
    });
};
goog.array.sortObjectsByKey = function(a, b, c) {
    goog.array.sortByKey(a, function(a) {
        return a[b];
    }, c);
};
goog.array.isSorted = function(a, b, c) {
    b = b || goog.array.defaultCompare;
    for(var d = 1; d < a.length; d++){
        var e = b(a[d - 1], a[d]);
        if (0 < e || 0 == e && c) return !1;
    }
    return !0;
};
goog.array.equals = function(a, b, c) {
    if (!goog.isArrayLike(a) || !goog.isArrayLike(b) || a.length != b.length) return !1;
    var d = a.length;
    c = c || goog.array.defaultCompareEquality;
    for(var e = 0; e < d; e++)if (!c(a[e], b[e])) return !1;
    return !0;
};
goog.array.compare3 = function(a, b, c) {
    c = c || goog.array.defaultCompare;
    for(var d = Math.min(a.length, b.length), e = 0; e < d; e++){
        var f = c(a[e], b[e]);
        if (0 != f) return f;
    }
    return goog.array.defaultCompare(a.length, b.length);
};
goog.array.defaultCompare = function(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
};
goog.array.inverseDefaultCompare = function(a, b) {
    return -goog.array.defaultCompare(a, b);
};
goog.array.defaultCompareEquality = function(a, b) {
    return a === b;
};
goog.array.binaryInsert = function(a, b, c) {
    c = goog.array.binarySearch(a, b, c);
    return 0 > c ? (goog.array.insertAt(a, b, -(c + 1)), !0) : !1;
};
goog.array.binaryRemove = function(a, b, c) {
    b = goog.array.binarySearch(a, b, c);
    return 0 <= b ? goog.array.removeAt(a, b) : !1;
};
goog.array.bucket = function(a, b, c) {
    for(var d = {}, e = 0; e < a.length; e++){
        var f = a[e], g = b.call(c, f, e, a);
        goog.isDef(g) && (d[g] || (d[g] = [])).push(f);
    }
    return d;
};
goog.array.toObject = function(a, b, c) {
    var d = {};
    goog.array.forEach(a, function(e, f) {
        d[b.call(c, e, f, a)] = e;
    });
    return d;
};
goog.array.range = function(a, b, c) {
    var d = [], e = 0, f = a;
    c = c || 1;
    void 0 !== b && (e = a, f = b);
    if (0 > c * (f - e)) return [];
    if (0 < c) for(a = e; a < f; a += c)d.push(a);
    else for(a = e; a > f; a += c)d.push(a);
    return d;
};
goog.array.repeat = function(a, b) {
    for(var c = [], d = 0; d < b; d++)c[d] = a;
    return c;
};
goog.array.flatten = function(a) {
    for(var b = [], c = 0; c < arguments.length; c++){
        var d = arguments[c];
        if (goog.isArray(d)) for(var e = 0; e < d.length; e += 8192){
            var f = goog.array.slice(d, e, e + 8192);
            f = goog.array.flatten.apply(null, f);
            for(var g = 0; g < f.length; g++)b.push(f[g]);
        }
        else b.push(d);
    }
    return b;
};
goog.array.rotate = function(a, b) {
    goog.asserts.assert(null != a.length);
    a.length && (b %= a.length, 0 < b ? Array.prototype.unshift.apply(a, a.splice(-b, b)) : 0 > b && Array.prototype.push.apply(a, a.splice(0, -b)));
    return a;
};
goog.array.moveItem = function(a, b, c) {
    goog.asserts.assert(0 <= b && b < a.length);
    goog.asserts.assert(0 <= c && c < a.length);
    b = Array.prototype.splice.call(a, b, 1);
    Array.prototype.splice.call(a, c, 0, b[0]);
};
goog.array.zip = function(a) {
    if (!arguments.length) return [];
    for(var b = [], c = arguments[0].length, d = 1; d < arguments.length; d++)arguments[d].length < c && (c = arguments[d].length);
    for(d = 0; d < c; d++){
        for(var e = [], f = 0; f < arguments.length; f++)e.push(arguments[f][d]);
        b.push(e);
    }
    return b;
};
goog.array.shuffle = function(a, b) {
    b = b || Math.random;
    for(var c = a.length - 1; 0 < c; c--){
        var d = Math.floor(b() * (c + 1)), e = a[c];
        a[c] = a[d];
        a[d] = e;
    }
};
goog.array.copyByIndex = function(a, b) {
    var c = [];
    goog.array.forEach(b, function(b) {
        c.push(a[b]);
    });
    return c;
};
goog.array.concatMap = function(a, b, c) {
    return goog.array.concat.apply([], goog.array.map(a, b, c));
};
goog.crypt = {};
goog.crypt.stringToByteArray = function(a) {
    for(var b = [], c = 0, d = 0; d < a.length; d++){
        var e = a.charCodeAt(d);
        255 < e && (b[c++] = e & 255, e >>= 8);
        b[c++] = e;
    }
    return b;
};
goog.crypt.byteArrayToString = function(a) {
    if (8192 >= a.length) return String.fromCharCode.apply(null, a);
    for(var b = "", c = 0; c < a.length; c += 8192){
        var d = goog.array.slice(a, c, c + 8192);
        b += String.fromCharCode.apply(null, d);
    }
    return b;
};
goog.crypt.byteArrayToHex = function(a, b) {
    return goog.array.map(a, function(a) {
        a = a.toString(16);
        return 1 < a.length ? a : "0" + a;
    }).join(b || "");
};
goog.crypt.hexToByteArray = function(a) {
    goog.asserts.assert(0 == a.length % 2, "Key string length must be multiple of 2");
    for(var b = [], c = 0; c < a.length; c += 2)b.push(parseInt(a.substring(c, c + 2), 16));
    return b;
};
goog.crypt.stringToUtf8ByteArray = function(a) {
    for(var b = [], c = 0, d = 0; d < a.length; d++){
        var e = a.charCodeAt(d);
        128 > e ? b[c++] = e : (2048 > e ? b[c++] = e >> 6 | 192 : (55296 == (e & 64512) && d + 1 < a.length && 56320 == (a.charCodeAt(d + 1) & 64512) ? (e = 65536 + ((e & 1023) << 10) + (a.charCodeAt(++d) & 1023), b[c++] = e >> 18 | 240, b[c++] = e >> 12 & 63 | 128) : b[c++] = e >> 12 | 224, b[c++] = e >> 6 & 63 | 128), b[c++] = e & 63 | 128);
    }
    return b;
};
goog.crypt.utf8ByteArrayToString = function(a) {
    for(var b = [], c = 0, d = 0; c < a.length;){
        var e = a[c++];
        if (128 > e) b[d++] = String.fromCharCode(e);
        else if (191 < e && 224 > e) {
            var f = a[c++];
            b[d++] = String.fromCharCode((e & 31) << 6 | f & 63);
        } else if (239 < e && 365 > e) {
            f = a[c++];
            var g = a[c++], h = a[c++];
            e = ((e & 7) << 18 | (f & 63) << 12 | (g & 63) << 6 | h & 63) - 65536;
            b[d++] = String.fromCharCode(55296 + (e >> 10));
            b[d++] = String.fromCharCode(56320 + (e & 1023));
        } else f = a[c++], g = a[c++], b[d++] = String.fromCharCode((e & 15) << 12 | (f & 63) << 6 | g & 63);
    }
    return b.join("");
};
goog.crypt.xorByteArray = function(a, b) {
    goog.asserts.assert(a.length == b.length, "XOR array lengths must match");
    for(var c = [], d = 0; d < a.length; d++)c.push(a[d] ^ b[d]);
    return c;
};
goog.dom.asserts = {};
goog.dom.asserts.assertIsLocation = function(a) {
    if (goog.asserts.ENABLE_ASSERTS) {
        var b = goog.dom.asserts.getWindow_(a);
        b && (!a || !(a instanceof b.Location) && a instanceof b.Element) && goog.asserts.fail("Argument is not a Location (or a non-Element mock); got: %s", goog.dom.asserts.debugStringForType_(a));
    }
    return a;
};
goog.dom.asserts.assertIsElementType_ = function(a, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
        var c = goog.dom.asserts.getWindow_(a);
        c && "undefined" != typeof c[b] && (a && (a instanceof c[b] || !(a instanceof c.Location || a instanceof c.Element)) || goog.asserts.fail("Argument is not a %s (or a non-Element, non-Location mock); got: %s", b, goog.dom.asserts.debugStringForType_(a)));
    }
    return a;
};
goog.dom.asserts.assertIsHTMLAnchorElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLAnchorElement");
};
goog.dom.asserts.assertIsHTMLButtonElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLButtonElement");
};
goog.dom.asserts.assertIsHTMLLinkElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLLinkElement");
};
goog.dom.asserts.assertIsHTMLImageElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLImageElement");
};
goog.dom.asserts.assertIsHTMLAudioElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLAudioElement");
};
goog.dom.asserts.assertIsHTMLVideoElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLVideoElement");
};
goog.dom.asserts.assertIsHTMLInputElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLInputElement");
};
goog.dom.asserts.assertIsHTMLTextAreaElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLTextAreaElement");
};
goog.dom.asserts.assertIsHTMLCanvasElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLCanvasElement");
};
goog.dom.asserts.assertIsHTMLEmbedElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLEmbedElement");
};
goog.dom.asserts.assertIsHTMLFormElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLFormElement");
};
goog.dom.asserts.assertIsHTMLFrameElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLFrameElement");
};
goog.dom.asserts.assertIsHTMLIFrameElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLIFrameElement");
};
goog.dom.asserts.assertIsHTMLObjectElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLObjectElement");
};
goog.dom.asserts.assertIsHTMLScriptElement = function(a) {
    return goog.dom.asserts.assertIsElementType_(a, "HTMLScriptElement");
};
goog.dom.asserts.debugStringForType_ = function(a) {
    if (goog.isObject(a)) try {
        return a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
    } catch (b) {
        return "<object could not be stringified>";
    }
    else return void 0 === a ? "undefined" : null === a ? "null" : typeof a;
};
goog.dom.asserts.getWindow_ = function(a) {
    try {
        var b = a && a.ownerDocument, c = b && (b.defaultView || b.parentWindow);
        c = c || goog.global;
        if (c.Element && c.Location) return c;
    } catch (d) {}
    return null;
};
goog.functions = {};
goog.functions.constant = function(a) {
    return function() {
        return a;
    };
};
goog.functions.FALSE = function() {
    return !1;
};
goog.functions.TRUE = function() {
    return !0;
};
goog.functions.NULL = function() {
    return null;
};
goog.functions.identity = function(a, b) {
    return a;
};
goog.functions.error = function(a) {
    return function() {
        throw Error(a);
    };
};
goog.functions.fail = function(a) {
    return function() {
        throw a;
    };
};
goog.functions.lock = function(a, b) {
    b = b || 0;
    return function() {
        return a.apply(this, Array.prototype.slice.call(arguments, 0, b));
    };
};
goog.functions.nth = function(a) {
    return function() {
        return arguments[a];
    };
};
goog.functions.partialRight = function(a, b) {
    var c = Array.prototype.slice.call(arguments, 1);
    return function() {
        var b = Array.prototype.slice.call(arguments);
        b.push.apply(b, c);
        return a.apply(this, b);
    };
};
goog.functions.withReturnValue = function(a, b) {
    return goog.functions.sequence(a, goog.functions.constant(b));
};
goog.functions.equalTo = function(a, b) {
    return function(c) {
        return b ? a == c : a === c;
    };
};
goog.functions.compose = function(a, b) {
    var c = arguments, d = c.length;
    return function() {
        var a;
        d && (a = c[d - 1].apply(this, arguments));
        for(var b = d - 2; 0 <= b; b--)a = c[b].call(this, a);
        return a;
    };
};
goog.functions.sequence = function(a) {
    var b = arguments, c = b.length;
    return function() {
        for(var a, e = 0; e < c; e++)a = b[e].apply(this, arguments);
        return a;
    };
};
goog.functions.and = function(a) {
    var b = arguments, c = b.length;
    return function() {
        for(var a = 0; a < c; a++)if (!b[a].apply(this, arguments)) return !1;
        return !0;
    };
};
goog.functions.or = function(a) {
    var b = arguments, c = b.length;
    return function() {
        for(var a = 0; a < c; a++)if (b[a].apply(this, arguments)) return !0;
        return !1;
    };
};
goog.functions.not = function(a) {
    return function() {
        return !a.apply(this, arguments);
    };
};
goog.functions.create = function(a, b) {
    var c = function() {};
    c.prototype = a.prototype;
    c = new c;
    a.apply(c, Array.prototype.slice.call(arguments, 1));
    return c;
};
goog.functions.CACHE_RETURN_VALUE = !0;
goog.functions.cacheReturnValue = function(a) {
    var b = !1, c;
    return function() {
        if (!goog.functions.CACHE_RETURN_VALUE) return a();
        b || (c = a(), b = !0);
        return c;
    };
};
goog.functions.once = function(a) {
    var b = a;
    return function() {
        if (b) {
            var a = b;
            b = null;
            a();
        }
    };
};
goog.functions.debounce = function(a, b, c) {
    var d = 0;
    return function(e) {
        goog.global.clearTimeout(d);
        var f = arguments;
        d = goog.global.setTimeout(function() {
            a.apply(c, f);
        }, b);
    };
};
goog.functions.throttle = function(a, b, c) {
    var d = 0, e = !1, f = [], g = function() {
        d = 0;
        e && (e = !1, h());
    }, h = function() {
        d = goog.global.setTimeout(g, b);
        a.apply(c, f);
    };
    return function(a) {
        f = arguments;
        d ? e = !0 : h();
    };
};
goog.functions.rateLimit = function(a, b, c) {
    var d = 0, e = function() {
        d = 0;
    };
    return function(f) {
        d || (d = goog.global.setTimeout(e, b), a.apply(c, arguments));
    };
};
goog.dom.HtmlElement = function() {};
goog.dom.TagName = function(a) {
    this.tagName_ = a;
};
goog.dom.TagName.prototype.toString = function() {
    return this.tagName_;
};
goog.dom.TagName.A = new goog.dom.TagName("A");
goog.dom.TagName.ABBR = new goog.dom.TagName("ABBR");
goog.dom.TagName.ACRONYM = new goog.dom.TagName("ACRONYM");
goog.dom.TagName.ADDRESS = new goog.dom.TagName("ADDRESS");
goog.dom.TagName.APPLET = new goog.dom.TagName("APPLET");
goog.dom.TagName.AREA = new goog.dom.TagName("AREA");
goog.dom.TagName.ARTICLE = new goog.dom.TagName("ARTICLE");
goog.dom.TagName.ASIDE = new goog.dom.TagName("ASIDE");
goog.dom.TagName.AUDIO = new goog.dom.TagName("AUDIO");
goog.dom.TagName.B = new goog.dom.TagName("B");
goog.dom.TagName.BASE = new goog.dom.TagName("BASE");
goog.dom.TagName.BASEFONT = new goog.dom.TagName("BASEFONT");
goog.dom.TagName.BDI = new goog.dom.TagName("BDI");
goog.dom.TagName.BDO = new goog.dom.TagName("BDO");
goog.dom.TagName.BIG = new goog.dom.TagName("BIG");
goog.dom.TagName.BLOCKQUOTE = new goog.dom.TagName("BLOCKQUOTE");
goog.dom.TagName.BODY = new goog.dom.TagName("BODY");
goog.dom.TagName.BR = new goog.dom.TagName("BR");
goog.dom.TagName.BUTTON = new goog.dom.TagName("BUTTON");
goog.dom.TagName.CANVAS = new goog.dom.TagName("CANVAS");
goog.dom.TagName.CAPTION = new goog.dom.TagName("CAPTION");
goog.dom.TagName.CENTER = new goog.dom.TagName("CENTER");
goog.dom.TagName.CITE = new goog.dom.TagName("CITE");
goog.dom.TagName.CODE = new goog.dom.TagName("CODE");
goog.dom.TagName.COL = new goog.dom.TagName("COL");
goog.dom.TagName.COLGROUP = new goog.dom.TagName("COLGROUP");
goog.dom.TagName.COMMAND = new goog.dom.TagName("COMMAND");
goog.dom.TagName.DATA = new goog.dom.TagName("DATA");
goog.dom.TagName.DATALIST = new goog.dom.TagName("DATALIST");
goog.dom.TagName.DD = new goog.dom.TagName("DD");
goog.dom.TagName.DEL = new goog.dom.TagName("DEL");
goog.dom.TagName.DETAILS = new goog.dom.TagName("DETAILS");
goog.dom.TagName.DFN = new goog.dom.TagName("DFN");
goog.dom.TagName.DIALOG = new goog.dom.TagName("DIALOG");
goog.dom.TagName.DIR = new goog.dom.TagName("DIR");
goog.dom.TagName.DIV = new goog.dom.TagName("DIV");
goog.dom.TagName.DL = new goog.dom.TagName("DL");
goog.dom.TagName.DT = new goog.dom.TagName("DT");
goog.dom.TagName.EM = new goog.dom.TagName("EM");
goog.dom.TagName.EMBED = new goog.dom.TagName("EMBED");
goog.dom.TagName.FIELDSET = new goog.dom.TagName("FIELDSET");
goog.dom.TagName.FIGCAPTION = new goog.dom.TagName("FIGCAPTION");
goog.dom.TagName.FIGURE = new goog.dom.TagName("FIGURE");
goog.dom.TagName.FONT = new goog.dom.TagName("FONT");
goog.dom.TagName.FOOTER = new goog.dom.TagName("FOOTER");
goog.dom.TagName.FORM = new goog.dom.TagName("FORM");
goog.dom.TagName.FRAME = new goog.dom.TagName("FRAME");
goog.dom.TagName.FRAMESET = new goog.dom.TagName("FRAMESET");
goog.dom.TagName.H1 = new goog.dom.TagName("H1");
goog.dom.TagName.H2 = new goog.dom.TagName("H2");
goog.dom.TagName.H3 = new goog.dom.TagName("H3");
goog.dom.TagName.H4 = new goog.dom.TagName("H4");
goog.dom.TagName.H5 = new goog.dom.TagName("H5");
goog.dom.TagName.H6 = new goog.dom.TagName("H6");
goog.dom.TagName.HEAD = new goog.dom.TagName("HEAD");
goog.dom.TagName.HEADER = new goog.dom.TagName("HEADER");
goog.dom.TagName.HGROUP = new goog.dom.TagName("HGROUP");
goog.dom.TagName.HR = new goog.dom.TagName("HR");
goog.dom.TagName.HTML = new goog.dom.TagName("HTML");
goog.dom.TagName.I = new goog.dom.TagName("I");
goog.dom.TagName.IFRAME = new goog.dom.TagName("IFRAME");
goog.dom.TagName.IMG = new goog.dom.TagName("IMG");
goog.dom.TagName.INPUT = new goog.dom.TagName("INPUT");
goog.dom.TagName.INS = new goog.dom.TagName("INS");
goog.dom.TagName.ISINDEX = new goog.dom.TagName("ISINDEX");
goog.dom.TagName.KBD = new goog.dom.TagName("KBD");
goog.dom.TagName.KEYGEN = new goog.dom.TagName("KEYGEN");
goog.dom.TagName.LABEL = new goog.dom.TagName("LABEL");
goog.dom.TagName.LEGEND = new goog.dom.TagName("LEGEND");
goog.dom.TagName.LI = new goog.dom.TagName("LI");
goog.dom.TagName.LINK = new goog.dom.TagName("LINK");
goog.dom.TagName.MAIN = new goog.dom.TagName("MAIN");
goog.dom.TagName.MAP = new goog.dom.TagName("MAP");
goog.dom.TagName.MARK = new goog.dom.TagName("MARK");
goog.dom.TagName.MATH = new goog.dom.TagName("MATH");
goog.dom.TagName.MENU = new goog.dom.TagName("MENU");
goog.dom.TagName.MENUITEM = new goog.dom.TagName("MENUITEM");
goog.dom.TagName.META = new goog.dom.TagName("META");
goog.dom.TagName.METER = new goog.dom.TagName("METER");
goog.dom.TagName.NAV = new goog.dom.TagName("NAV");
goog.dom.TagName.NOFRAMES = new goog.dom.TagName("NOFRAMES");
goog.dom.TagName.NOSCRIPT = new goog.dom.TagName("NOSCRIPT");
goog.dom.TagName.OBJECT = new goog.dom.TagName("OBJECT");
goog.dom.TagName.OL = new goog.dom.TagName("OL");
goog.dom.TagName.OPTGROUP = new goog.dom.TagName("OPTGROUP");
goog.dom.TagName.OPTION = new goog.dom.TagName("OPTION");
goog.dom.TagName.OUTPUT = new goog.dom.TagName("OUTPUT");
goog.dom.TagName.P = new goog.dom.TagName("P");
goog.dom.TagName.PARAM = new goog.dom.TagName("PARAM");
goog.dom.TagName.PICTURE = new goog.dom.TagName("PICTURE");
goog.dom.TagName.PRE = new goog.dom.TagName("PRE");
goog.dom.TagName.PROGRESS = new goog.dom.TagName("PROGRESS");
goog.dom.TagName.Q = new goog.dom.TagName("Q");
goog.dom.TagName.RP = new goog.dom.TagName("RP");
goog.dom.TagName.RT = new goog.dom.TagName("RT");
goog.dom.TagName.RTC = new goog.dom.TagName("RTC");
goog.dom.TagName.RUBY = new goog.dom.TagName("RUBY");
goog.dom.TagName.S = new goog.dom.TagName("S");
goog.dom.TagName.SAMP = new goog.dom.TagName("SAMP");
goog.dom.TagName.SCRIPT = new goog.dom.TagName("SCRIPT");
goog.dom.TagName.SECTION = new goog.dom.TagName("SECTION");
goog.dom.TagName.SELECT = new goog.dom.TagName("SELECT");
goog.dom.TagName.SMALL = new goog.dom.TagName("SMALL");
goog.dom.TagName.SOURCE = new goog.dom.TagName("SOURCE");
goog.dom.TagName.SPAN = new goog.dom.TagName("SPAN");
goog.dom.TagName.STRIKE = new goog.dom.TagName("STRIKE");
goog.dom.TagName.STRONG = new goog.dom.TagName("STRONG");
goog.dom.TagName.STYLE = new goog.dom.TagName("STYLE");
goog.dom.TagName.SUB = new goog.dom.TagName("SUB");
goog.dom.TagName.SUMMARY = new goog.dom.TagName("SUMMARY");
goog.dom.TagName.SUP = new goog.dom.TagName("SUP");
goog.dom.TagName.SVG = new goog.dom.TagName("SVG");
goog.dom.TagName.TABLE = new goog.dom.TagName("TABLE");
goog.dom.TagName.TBODY = new goog.dom.TagName("TBODY");
goog.dom.TagName.TD = new goog.dom.TagName("TD");
goog.dom.TagName.TEMPLATE = new goog.dom.TagName("TEMPLATE");
goog.dom.TagName.TEXTAREA = new goog.dom.TagName("TEXTAREA");
goog.dom.TagName.TFOOT = new goog.dom.TagName("TFOOT");
goog.dom.TagName.TH = new goog.dom.TagName("TH");
goog.dom.TagName.THEAD = new goog.dom.TagName("THEAD");
goog.dom.TagName.TIME = new goog.dom.TagName("TIME");
goog.dom.TagName.TITLE = new goog.dom.TagName("TITLE");
goog.dom.TagName.TR = new goog.dom.TagName("TR");
goog.dom.TagName.TRACK = new goog.dom.TagName("TRACK");
goog.dom.TagName.TT = new goog.dom.TagName("TT");
goog.dom.TagName.U = new goog.dom.TagName("U");
goog.dom.TagName.UL = new goog.dom.TagName("UL");
goog.dom.TagName.VAR = new goog.dom.TagName("VAR");
goog.dom.TagName.VIDEO = new goog.dom.TagName("VIDEO");
goog.dom.TagName.WBR = new goog.dom.TagName("WBR");
goog.dom.tags = {};
goog.dom.tags.VOID_TAGS_ = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    command: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
};
goog.dom.tags.isVoidTag = function(a) {
    return !0 === goog.dom.tags.VOID_TAGS_[a];
};
goog.html = {};
goog.html.trustedtypes = {};
goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY = goog.TRUSTED_TYPES_POLICY_NAME ? goog.createTrustedTypesPolicy(goog.TRUSTED_TYPES_POLICY_NAME + "#html") : null;
goog.string = {};
goog.string.TypedString = function() {};
goog.string.Const = function(a, b) {
    this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ = a === goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ && b || "";
    this.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ = goog.string.Const.TYPE_MARKER_;
};
goog.string.Const.prototype.implementsGoogStringTypedString = !0;
goog.string.Const.prototype.getTypedStringValue = function() {
    return this.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
};
goog.string.Const.prototype.toString = function() {
    return "Const{" + this.stringConstValueWithSecurityContract__googStringSecurityPrivate_ + "}";
};
goog.string.Const.unwrap = function(a) {
    if (a instanceof goog.string.Const && a.constructor === goog.string.Const && a.STRING_CONST_TYPE_MARKER__GOOG_STRING_SECURITY_PRIVATE_ === goog.string.Const.TYPE_MARKER_) return a.stringConstValueWithSecurityContract__googStringSecurityPrivate_;
    goog.asserts.fail("expected object of type Const, got '" + a + "'");
    return "type_error:Const";
};
goog.string.Const.from = function(a) {
    return new goog.string.Const(goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_, a);
};
goog.string.Const.TYPE_MARKER_ = {};
goog.string.Const.GOOG_STRING_CONSTRUCTOR_TOKEN_PRIVATE_ = {};
goog.string.Const.EMPTY = goog.string.Const.from("");
goog.html.SafeScript = function() {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = "";
    this.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeScript.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeScript.fromConstant = function(a) {
    a = goog.string.Const.unwrap(a);
    return 0 === a.length ? goog.html.SafeScript.EMPTY : goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeScript.fromConstantAndArgs = function(a, b) {
    for(var c = [], d = 1; d < arguments.length; d++)c.push(goog.html.SafeScript.stringify_(arguments[d]));
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("(" + goog.string.Const.unwrap(a) + ")(" + c.join(", ") + ");");
};
goog.html.SafeScript.fromJson = function(a) {
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(goog.html.SafeScript.stringify_(a));
};
goog.html.SafeScript.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeScriptWrappedValue_.toString();
};
goog.DEBUG && (goog.html.SafeScript.prototype.toString = function() {
    return "SafeScript{" + this.privateDoNotAccessOrElseSafeScriptWrappedValue_ + "}";
});
goog.html.SafeScript.unwrap = function(a) {
    return goog.html.SafeScript.unwrapTrustedScript(a).toString();
};
goog.html.SafeScript.unwrapTrustedScript = function(a) {
    if (a instanceof goog.html.SafeScript && a.constructor === goog.html.SafeScript && a.SAFE_SCRIPT_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeScript.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeScriptWrappedValue_;
    goog.asserts.fail("expected object of type SafeScript, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:SafeScript";
};
goog.html.SafeScript.stringify_ = function(a) {
    return JSON.stringify(a).replace(/</g, "\\x3c");
};
goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse = function(a) {
    return (new goog.html.SafeScript).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeScript.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
    this.privateDoNotAccessOrElseSafeScriptWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScript(a) : a;
    return this;
};
goog.html.SafeScript.EMPTY = goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse("");
goog.fs = {};
goog.fs.url = {};
goog.fs.url.createObjectUrl = function(a) {
    return goog.fs.url.getUrlObject_().createObjectURL(a);
};
goog.fs.url.revokeObjectUrl = function(a) {
    goog.fs.url.getUrlObject_().revokeObjectURL(a);
};
goog.fs.url.getUrlObject_ = function() {
    var a = goog.fs.url.findUrlObject_();
    if (null != a) return a;
    throw Error("This browser doesn't seem to support blob URLs");
};
goog.fs.url.findUrlObject_ = function() {
    return goog.isDef(goog.global.URL) && goog.isDef(goog.global.URL.createObjectURL) ? goog.global.URL : goog.isDef(goog.global.webkitURL) && goog.isDef(goog.global.webkitURL.createObjectURL) ? goog.global.webkitURL : goog.isDef(goog.global.createObjectURL) ? goog.global : null;
};
goog.fs.url.browserSupportsObjectUrls = function() {
    return null != goog.fs.url.findUrlObject_();
};
goog.i18n = {};
goog.i18n.bidi = {};
goog.i18n.bidi.FORCE_RTL = !1;
goog.i18n.bidi.IS_RTL = goog.i18n.bidi.FORCE_RTL || ("ar" == goog.LOCALE.substring(0, 2).toLowerCase() || "fa" == goog.LOCALE.substring(0, 2).toLowerCase() || "he" == goog.LOCALE.substring(0, 2).toLowerCase() || "iw" == goog.LOCALE.substring(0, 2).toLowerCase() || "ps" == goog.LOCALE.substring(0, 2).toLowerCase() || "sd" == goog.LOCALE.substring(0, 2).toLowerCase() || "ug" == goog.LOCALE.substring(0, 2).toLowerCase() || "ur" == goog.LOCALE.substring(0, 2).toLowerCase() || "yi" == goog.LOCALE.substring(0, 2).toLowerCase()) && (2 == goog.LOCALE.length || "-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) || 3 <= goog.LOCALE.length && "ckb" == goog.LOCALE.substring(0, 3).toLowerCase() && (3 == goog.LOCALE.length || "-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) || 7 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(2, 3) || "_" == goog.LOCALE.substring(2, 3)) && ("adlm" == goog.LOCALE.substring(3, 7).toLowerCase() || "arab" == goog.LOCALE.substring(3, 7).toLowerCase() || "hebr" == goog.LOCALE.substring(3, 7).toLowerCase() || "nkoo" == goog.LOCALE.substring(3, 7).toLowerCase() || "rohg" == goog.LOCALE.substring(3, 7).toLowerCase() || "thaa" == goog.LOCALE.substring(3, 7).toLowerCase()) || 8 <= goog.LOCALE.length && ("-" == goog.LOCALE.substring(3, 4) || "_" == goog.LOCALE.substring(3, 4)) && ("adlm" == goog.LOCALE.substring(4, 8).toLowerCase() || "arab" == goog.LOCALE.substring(4, 8).toLowerCase() || "hebr" == goog.LOCALE.substring(4, 8).toLowerCase() || "nkoo" == goog.LOCALE.substring(4, 8).toLowerCase() || "rohg" == goog.LOCALE.substring(4, 8).toLowerCase() || "thaa" == goog.LOCALE.substring(4, 8).toLowerCase());
goog.i18n.bidi.Format = {
    LRE: "\u202A",
    RLE: "\u202B",
    PDF: "\u202C",
    LRM: "\u200E",
    RLM: "\u200F"
};
goog.i18n.bidi.Dir = {
    LTR: 1,
    RTL: -1,
    NEUTRAL: 0
};
goog.i18n.bidi.RIGHT = "right";
goog.i18n.bidi.LEFT = "left";
goog.i18n.bidi.I18N_RIGHT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.LEFT : goog.i18n.bidi.RIGHT;
goog.i18n.bidi.I18N_LEFT = goog.i18n.bidi.IS_RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT;
goog.i18n.bidi.toDir = function(a, b) {
    return "number" == typeof a ? 0 < a ? goog.i18n.bidi.Dir.LTR : 0 > a ? goog.i18n.bidi.Dir.RTL : b ? null : goog.i18n.bidi.Dir.NEUTRAL : null == a ? null : a ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
};
goog.i18n.bidi.ltrChars_ = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02B8\u0300-\u0590\u0900-\u1FFF\u200E\u2C00-\ud801\ud804-\ud839\ud83c-\udbff\uF900-\uFB1C\uFE00-\uFE6F\uFEFD-\uFFFF";
goog.i18n.bidi.rtlChars_ = "\u0591-\u06EF\u06FA-\u08FF\u200F\ud802-\ud803\ud83a-\ud83b\uFB1D-\uFDFF\uFE70-\uFEFC";
goog.i18n.bidi.htmlSkipReg_ = /<[^>]*>|&[^;]+;/g;
goog.i18n.bidi.stripHtmlIfNeeded_ = function(a, b) {
    return b ? a.replace(goog.i18n.bidi.htmlSkipReg_, "") : a;
};
goog.i18n.bidi.rtlCharReg_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.ltrCharReg_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.hasAnyRtl = function(a, b) {
    return goog.i18n.bidi.rtlCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.hasRtlChar = goog.i18n.bidi.hasAnyRtl;
goog.i18n.bidi.hasAnyLtr = function(a, b) {
    return goog.i18n.bidi.ltrCharReg_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.ltrRe_ = new RegExp("^[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.rtlRe_ = new RegExp("^[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.isRtlChar = function(a) {
    return goog.i18n.bidi.rtlRe_.test(a);
};
goog.i18n.bidi.isLtrChar = function(a) {
    return goog.i18n.bidi.ltrRe_.test(a);
};
goog.i18n.bidi.isNeutralChar = function(a) {
    return !goog.i18n.bidi.isLtrChar(a) && !goog.i18n.bidi.isRtlChar(a);
};
goog.i18n.bidi.ltrDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.rtlChars_ + "]*[" + goog.i18n.bidi.ltrChars_ + "]");
goog.i18n.bidi.rtlDirCheckRe_ = new RegExp("^[^" + goog.i18n.bidi.ltrChars_ + "]*[" + goog.i18n.bidi.rtlChars_ + "]");
goog.i18n.bidi.startsWithRtl = function(a, b) {
    return goog.i18n.bidi.rtlDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isRtlText = goog.i18n.bidi.startsWithRtl;
goog.i18n.bidi.startsWithLtr = function(a, b) {
    return goog.i18n.bidi.ltrDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isLtrText = goog.i18n.bidi.startsWithLtr;
goog.i18n.bidi.isRequiredLtrRe_ = /^http:\/\/.*/;
goog.i18n.bidi.isNeutralText = function(a, b) {
    a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b);
    return goog.i18n.bidi.isRequiredLtrRe_.test(a) || !goog.i18n.bidi.hasAnyLtr(a) && !goog.i18n.bidi.hasAnyRtl(a);
};
goog.i18n.bidi.ltrExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.ltrChars_ + "][^" + goog.i18n.bidi.rtlChars_ + "]*$");
goog.i18n.bidi.rtlExitDirCheckRe_ = new RegExp("[" + goog.i18n.bidi.rtlChars_ + "][^" + goog.i18n.bidi.ltrChars_ + "]*$");
goog.i18n.bidi.endsWithLtr = function(a, b) {
    return goog.i18n.bidi.ltrExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isLtrExitText = goog.i18n.bidi.endsWithLtr;
goog.i18n.bidi.endsWithRtl = function(a, b) {
    return goog.i18n.bidi.rtlExitDirCheckRe_.test(goog.i18n.bidi.stripHtmlIfNeeded_(a, b));
};
goog.i18n.bidi.isRtlExitText = goog.i18n.bidi.endsWithRtl;
goog.i18n.bidi.rtlLocalesRe_ = /^(ar|ckb|dv|he|iw|fa|nqo|ps|sd|ug|ur|yi|.*[-_](Adlm|Arab|Hebr|Nkoo|Rohg|Thaa))(?!.*[-_](Latn|Cyrl)($|-|_))($|-|_)/i;
goog.i18n.bidi.isRtlLanguage = function(a) {
    return goog.i18n.bidi.rtlLocalesRe_.test(a);
};
goog.i18n.bidi.bracketGuardTextRe_ = /(\(.*?\)+)|(\[.*?\]+)|(\{.*?\}+)|(<.*?>+)/g;
goog.i18n.bidi.guardBracketInText = function(a, b) {
    b = (void 0 === b ? goog.i18n.bidi.hasAnyRtl(a) : b) ? goog.i18n.bidi.Format.RLM : goog.i18n.bidi.Format.LRM;
    return a.replace(goog.i18n.bidi.bracketGuardTextRe_, b + "$&" + b);
};
goog.i18n.bidi.enforceRtlInHtml = function(a) {
    return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=rtl") : "\n<span dir=rtl>" + a + "</span>";
};
goog.i18n.bidi.enforceRtlInText = function(a) {
    return goog.i18n.bidi.Format.RLE + a + goog.i18n.bidi.Format.PDF;
};
goog.i18n.bidi.enforceLtrInHtml = function(a) {
    return "<" == a.charAt(0) ? a.replace(/<\w+/, "$& dir=ltr") : "\n<span dir=ltr>" + a + "</span>";
};
goog.i18n.bidi.enforceLtrInText = function(a) {
    return goog.i18n.bidi.Format.LRE + a + goog.i18n.bidi.Format.PDF;
};
goog.i18n.bidi.dimensionsRe_ = /:\s*([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)\s+([.\d][.\w]*)/g;
goog.i18n.bidi.leftRe_ = /left/gi;
goog.i18n.bidi.rightRe_ = /right/gi;
goog.i18n.bidi.tempRe_ = /%%%%/g;
goog.i18n.bidi.mirrorCSS = function(a) {
    return a.replace(goog.i18n.bidi.dimensionsRe_, ":$1 $4 $3 $2").replace(goog.i18n.bidi.leftRe_, "%%%%").replace(goog.i18n.bidi.rightRe_, goog.i18n.bidi.LEFT).replace(goog.i18n.bidi.tempRe_, goog.i18n.bidi.RIGHT);
};
goog.i18n.bidi.doubleQuoteSubstituteRe_ = /([\u0591-\u05f2])"/g;
goog.i18n.bidi.singleQuoteSubstituteRe_ = /([\u0591-\u05f2])'/g;
goog.i18n.bidi.normalizeHebrewQuote = function(a) {
    return a.replace(goog.i18n.bidi.doubleQuoteSubstituteRe_, "$1\u05F4").replace(goog.i18n.bidi.singleQuoteSubstituteRe_, "$1\u05F3");
};
goog.i18n.bidi.wordSeparatorRe_ = /\s+/;
goog.i18n.bidi.hasNumeralsRe_ = /[\d\u06f0-\u06f9]/;
goog.i18n.bidi.rtlDetectionThreshold_ = .4;
goog.i18n.bidi.estimateDirection = function(a, b) {
    var c = 0, d = 0, e = !1;
    a = goog.i18n.bidi.stripHtmlIfNeeded_(a, b).split(goog.i18n.bidi.wordSeparatorRe_);
    for(b = 0; b < a.length; b++){
        var f = a[b];
        goog.i18n.bidi.startsWithRtl(f) ? (c++, d++) : goog.i18n.bidi.isRequiredLtrRe_.test(f) ? e = !0 : goog.i18n.bidi.hasAnyLtr(f) ? d++ : goog.i18n.bidi.hasNumeralsRe_.test(f) && (e = !0);
    }
    return 0 == d ? e ? goog.i18n.bidi.Dir.LTR : goog.i18n.bidi.Dir.NEUTRAL : c / d > goog.i18n.bidi.rtlDetectionThreshold_ ? goog.i18n.bidi.Dir.RTL : goog.i18n.bidi.Dir.LTR;
};
goog.i18n.bidi.detectRtlDirectionality = function(a, b) {
    return goog.i18n.bidi.estimateDirection(a, b) == goog.i18n.bidi.Dir.RTL;
};
goog.i18n.bidi.setElementDirAndAlign = function(a, b) {
    a && (b = goog.i18n.bidi.toDir(b)) && (a.style.textAlign = b == goog.i18n.bidi.Dir.RTL ? goog.i18n.bidi.RIGHT : goog.i18n.bidi.LEFT, a.dir = b == goog.i18n.bidi.Dir.RTL ? "rtl" : "ltr");
};
goog.i18n.bidi.setElementDirByTextDirectionality = function(a, b) {
    switch(goog.i18n.bidi.estimateDirection(b)){
        case goog.i18n.bidi.Dir.LTR:
            a.dir = "ltr";
            break;
        case goog.i18n.bidi.Dir.RTL:
            a.dir = "rtl";
            break;
        default:
            a.removeAttribute("dir");
    }
};
goog.i18n.bidi.DirectionalString = function() {};
goog.html.TrustedResourceUrl = function() {
    this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = "";
    this.trustedURL_ = null;
    this.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.TrustedResourceUrl.prototype.implementsGoogStringTypedString = !0;
goog.html.TrustedResourceUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_.toString();
};
goog.html.TrustedResourceUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.TrustedResourceUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
};
goog.html.TrustedResourceUrl.prototype.cloneWithParams = function(a, b) {
    var c = goog.html.TrustedResourceUrl.unwrap(this);
    c = goog.html.TrustedResourceUrl.URL_PARAM_PARSER_.exec(c);
    var d = c[3] || "";
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(c[1] + goog.html.TrustedResourceUrl.stringifyParams_("?", c[2] || "", a) + goog.html.TrustedResourceUrl.stringifyParams_("#", d, b));
};
goog.DEBUG && (goog.html.TrustedResourceUrl.prototype.toString = function() {
    return "TrustedResourceUrl{" + this.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ + "}";
});
goog.html.TrustedResourceUrl.unwrap = function(a) {
    return goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(a).toString();
};
goog.html.TrustedResourceUrl.unwrapTrustedScriptURL = function(a) {
    if (a instanceof goog.html.TrustedResourceUrl && a.constructor === goog.html.TrustedResourceUrl && a.TRUSTED_RESOURCE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_;
    goog.asserts.fail("expected object of type TrustedResourceUrl, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:TrustedResourceUrl";
};
goog.html.TrustedResourceUrl.unwrapTrustedURL = function(a) {
    return a.trustedURL_ ? a.trustedURL_ : goog.html.TrustedResourceUrl.unwrap(a);
};
goog.html.TrustedResourceUrl.format = function(a, b) {
    var c = goog.string.Const.unwrap(a);
    if (!goog.html.TrustedResourceUrl.BASE_URL_.test(c)) throw Error("Invalid TrustedResourceUrl format: " + c);
    a = c.replace(goog.html.TrustedResourceUrl.FORMAT_MARKER_, function(a, e) {
        if (!Object.prototype.hasOwnProperty.call(b, e)) throw Error('Found marker, "' + e + '", in format string, "' + c + '", but no valid label mapping found in args: ' + JSON.stringify(b));
        a = b[e];
        return a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : encodeURIComponent(String(a));
    });
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.TrustedResourceUrl.FORMAT_MARKER_ = /%{(\w+)}/g;
goog.html.TrustedResourceUrl.BASE_URL_ = /^((https:)?\/\/[0-9a-z.:[\]-]+\/|\/[^/\\]|[^:/\\%]+\/|[^:/\\%]*[?#]|about:blank#)/i;
goog.html.TrustedResourceUrl.URL_PARAM_PARSER_ = /^([^?#]*)(\?[^#]*)?(#[\s\S]*)?/;
goog.html.TrustedResourceUrl.formatWithParams = function(a, b, c, d) {
    return goog.html.TrustedResourceUrl.format(a, b).cloneWithParams(c, d);
};
goog.html.TrustedResourceUrl.fromConstant = function(a) {
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
};
goog.html.TrustedResourceUrl.fromConstants = function(a) {
    for(var b = "", c = 0; c < a.length; c++)b += goog.string.Const.unwrap(a[c]);
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.TrustedResourceUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse = function(a) {
    var b = new goog.html.TrustedResourceUrl;
    b.privateDoNotAccessOrElseTrustedResourceUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createScriptURL(a) : a;
    goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY && (b.trustedURL_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a));
    return b;
};
goog.html.TrustedResourceUrl.stringifyParams_ = function(a, b, c) {
    if (null == c) return b;
    if (goog.isString(c)) return c ? a + encodeURIComponent(c) : "";
    for(var d in c){
        var e = c[d];
        e = goog.isArray(e) ? e : [
            e
        ];
        for(var f = 0; f < e.length; f++){
            var g = e[f];
            null != g && (b || (b = a), b += (b.length > a.length ? "&" : "") + encodeURIComponent(d) + "=" + encodeURIComponent(String(g)));
        }
    }
    return b;
};
goog.string.internal = {};
goog.string.internal.startsWith = function(a, b) {
    return 0 == a.lastIndexOf(b, 0);
};
goog.string.internal.endsWith = function(a, b) {
    var c = a.length - b.length;
    return 0 <= c && a.indexOf(b, c) == c;
};
goog.string.internal.caseInsensitiveStartsWith = function(a, b) {
    return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(0, b.length));
};
goog.string.internal.caseInsensitiveEndsWith = function(a, b) {
    return 0 == goog.string.internal.caseInsensitiveCompare(b, a.substr(a.length - b.length, b.length));
};
goog.string.internal.caseInsensitiveEquals = function(a, b) {
    return a.toLowerCase() == b.toLowerCase();
};
goog.string.internal.isEmptyOrWhitespace = function(a) {
    return /^[\s\xa0]*$/.test(a);
};
goog.string.internal.trim = goog.TRUSTED_SITE && String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
goog.string.internal.caseInsensitiveCompare = function(a, b) {
    a = String(a).toLowerCase();
    b = String(b).toLowerCase();
    return a < b ? -1 : a == b ? 0 : 1;
};
goog.string.internal.newLineToBr = function(a, b) {
    return a.replace(/(\r\n|\r|\n)/g, b ? "<br />" : "<br>");
};
goog.string.internal.htmlEscape = function(a, b) {
    if (b) a = a.replace(goog.string.internal.AMP_RE_, "&amp;").replace(goog.string.internal.LT_RE_, "&lt;").replace(goog.string.internal.GT_RE_, "&gt;").replace(goog.string.internal.QUOT_RE_, "&quot;").replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;").replace(goog.string.internal.NULL_RE_, "&#0;");
    else {
        if (!goog.string.internal.ALL_RE_.test(a)) return a;
        -1 != a.indexOf("&") && (a = a.replace(goog.string.internal.AMP_RE_, "&amp;"));
        -1 != a.indexOf("<") && (a = a.replace(goog.string.internal.LT_RE_, "&lt;"));
        -1 != a.indexOf(">") && (a = a.replace(goog.string.internal.GT_RE_, "&gt;"));
        -1 != a.indexOf('"') && (a = a.replace(goog.string.internal.QUOT_RE_, "&quot;"));
        -1 != a.indexOf("'") && (a = a.replace(goog.string.internal.SINGLE_QUOTE_RE_, "&#39;"));
        -1 != a.indexOf("\x00") && (a = a.replace(goog.string.internal.NULL_RE_, "&#0;"));
    }
    return a;
};
goog.string.internal.AMP_RE_ = /&/g;
goog.string.internal.LT_RE_ = /</g;
goog.string.internal.GT_RE_ = />/g;
goog.string.internal.QUOT_RE_ = /"/g;
goog.string.internal.SINGLE_QUOTE_RE_ = /'/g;
goog.string.internal.NULL_RE_ = /\x00/g;
goog.string.internal.ALL_RE_ = /[\x00&<>"']/;
goog.string.internal.whitespaceEscape = function(a, b) {
    return goog.string.internal.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.internal.contains = function(a, b) {
    return -1 != a.indexOf(b);
};
goog.string.internal.caseInsensitiveContains = function(a, b) {
    return goog.string.internal.contains(a.toLowerCase(), b.toLowerCase());
};
goog.string.internal.compareVersions = function(a, b) {
    var c = 0;
    a = goog.string.internal.trim(String(a)).split(".");
    b = goog.string.internal.trim(String(b)).split(".");
    for(var d = Math.max(a.length, b.length), e = 0; 0 == c && e < d; e++){
        var f = a[e] || "", g = b[e] || "";
        do {
            f = /(\d*)(\D*)(.*)/.exec(f) || [
                "",
                "",
                "",
                ""
            ];
            g = /(\d*)(\D*)(.*)/.exec(g) || [
                "",
                "",
                "",
                ""
            ];
            if (0 == f[0].length && 0 == g[0].length) break;
            c = 0 == f[1].length ? 0 : parseInt(f[1], 10);
            var h = 0 == g[1].length ? 0 : parseInt(g[1], 10);
            c = goog.string.internal.compareElements_(c, h) || goog.string.internal.compareElements_(0 == f[2].length, 0 == g[2].length) || goog.string.internal.compareElements_(f[2], g[2]);
            f = f[3];
            g = g[3];
        }while (0 == c);
    }
    return c;
};
goog.string.internal.compareElements_ = function(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
};
goog.html.SafeUrl = function() {
    this.privateDoNotAccessOrElseSafeUrlWrappedValue_ = "";
    this.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeUrl.INNOCUOUS_STRING = "about:invalid#zClosurez";
goog.html.SafeUrl.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeUrl.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeUrlWrappedValue_.toString();
};
goog.html.SafeUrl.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.SafeUrl.prototype.getDirection = function() {
    return goog.i18n.bidi.Dir.LTR;
};
goog.DEBUG && (goog.html.SafeUrl.prototype.toString = function() {
    return "SafeUrl{" + this.privateDoNotAccessOrElseSafeUrlWrappedValue_ + "}";
});
goog.html.SafeUrl.unwrap = function(a) {
    return goog.html.SafeUrl.unwrapTrustedURL(a).toString();
};
goog.html.SafeUrl.unwrapTrustedURL = function(a) {
    if (a instanceof goog.html.SafeUrl && a.constructor === goog.html.SafeUrl && a.SAFE_URL_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeUrlWrappedValue_;
    goog.asserts.fail("expected object of type SafeUrl, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:SafeUrl";
};
goog.html.SafeUrl.fromConstant = function(a) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.string.Const.unwrap(a));
};
goog.html.SAFE_MIME_TYPE_PATTERN_ = /^(?:audio\/(?:3gpp2|3gpp|aac|L16|midi|mp3|mp4|mpeg|oga|ogg|opus|x-m4a|x-wav|wav|webm)|image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp|x-icon)|text\/csv|video\/(?:mpeg|mp4|ogg|webm|quicktime))(?:;\w+=(?:\w+|"[\w;=]+"))*$/i;
goog.html.SafeUrl.isSafeMimeType = function(a) {
    return goog.html.SAFE_MIME_TYPE_PATTERN_.test(a);
};
goog.html.SafeUrl.fromBlob = function(a) {
    a = goog.html.SAFE_MIME_TYPE_PATTERN_.test(a.type) ? goog.fs.url.createObjectUrl(a) : goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.DATA_URL_PATTERN_ = /^data:([^,]*);base64,[a-z0-9+\/]+=*$/i;
goog.html.SafeUrl.fromDataUrl = function(a) {
    a = a.replace(/(%0A|%0D)/g, "");
    var b = a.match(goog.html.DATA_URL_PATTERN_);
    b = b && goog.html.SAFE_MIME_TYPE_PATTERN_.test(b[1]);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b ? a : goog.html.SafeUrl.INNOCUOUS_STRING);
};
goog.html.SafeUrl.fromTelUrl = function(a) {
    goog.string.internal.caseInsensitiveStartsWith(a, "tel:") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SIP_URL_PATTERN_ = /^sip[s]?:[+a-z0-9_.!$%&'*\/=^`{|}~-]+@([a-z0-9-]+\.)+[a-z0-9]{2,63}$/i;
goog.html.SafeUrl.fromSipUrl = function(a) {
    goog.html.SIP_URL_PATTERN_.test(decodeURIComponent(a)) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromFacebookMessengerUrl = function(a) {
    goog.string.internal.caseInsensitiveStartsWith(a, "fb-messenger://share") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromWhatsAppUrl = function(a) {
    goog.string.internal.caseInsensitiveStartsWith(a, "whatsapp://send") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.fromSmsUrl = function(a) {
    goog.string.internal.caseInsensitiveStartsWith(a, "sms:") && goog.html.SafeUrl.isSmsUrlBodyValid_(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.isSmsUrlBodyValid_ = function(a) {
    var b = a.indexOf("#");
    0 < b && (a = a.substring(0, b));
    b = a.match(/[?&]body=/gi);
    if (!b) return !0;
    if (1 < b.length) return !1;
    a = a.match(/[?&]body=([^&]*)/)[1];
    if (!a) return !0;
    try {
        decodeURIComponent(a);
    } catch (c) {
        return !1;
    }
    return /^(?:[a-z0-9\-_.~]|%[0-9a-f]{2})+$/i.test(a);
};
goog.html.SafeUrl.fromSshUrl = function(a) {
    goog.string.internal.caseInsensitiveStartsWith(a, "ssh://") || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.sanitizeChromeExtensionUrl = function(a, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^chrome-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeFirefoxExtensionUrl = function(a, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^moz-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeEdgeExtensionUrl = function(a, b) {
    return goog.html.SafeUrl.sanitizeExtensionUrl_(/^ms-browser-extension:\/\/([^\/]+)\//, a, b);
};
goog.html.SafeUrl.sanitizeExtensionUrl_ = function(a, b, c) {
    (a = a.exec(b)) ? (a = a[1], -1 == (c instanceof goog.string.Const ? [
        goog.string.Const.unwrap(c)
    ] : c.map(function(a) {
        return goog.string.Const.unwrap(a);
    })).indexOf(a) && (b = goog.html.SafeUrl.INNOCUOUS_STRING)) : b = goog.html.SafeUrl.INNOCUOUS_STRING;
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.SafeUrl.fromTrustedResourceUrl = function(a) {
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(goog.html.TrustedResourceUrl.unwrap(a));
};
goog.html.SAFE_URL_PATTERN_ = /^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
goog.html.SafeUrl.SAFE_URL_PATTERN = goog.html.SAFE_URL_PATTERN_;
goog.html.SafeUrl.sanitize = function(a) {
    if (a instanceof goog.html.SafeUrl) return a;
    a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
    goog.html.SAFE_URL_PATTERN_.test(a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.sanitizeAssertUnchanged = function(a, b) {
    if (a instanceof goog.html.SafeUrl) return a;
    a = "object" == typeof a && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
    if (b && /^data:/i.test(a) && (b = goog.html.SafeUrl.fromDataUrl(a), b.getTypedStringValue() == a)) return b;
    goog.asserts.assert(goog.html.SAFE_URL_PATTERN_.test(a), "%s does not match the safe URL pattern", a) || (a = goog.html.SafeUrl.INNOCUOUS_STRING);
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeUrl.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse = function(a) {
    var b = new goog.html.SafeUrl;
    b.privateDoNotAccessOrElseSafeUrlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createURL(a) : a;
    return b;
};
goog.html.SafeUrl.ABOUT_BLANK = goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse("about:blank");
goog.html.SafeStyle = function() {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = "";
    this.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeStyle.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeStyle.fromConstant = function(a) {
    a = goog.string.Const.unwrap(a);
    if (0 === a.length) return goog.html.SafeStyle.EMPTY;
    goog.asserts.assert(goog.string.internal.endsWith(a, ";"), "Last character of style string is not ';': " + a);
    goog.asserts.assert(goog.string.internal.contains(a, ":"), "Style string must contain at least one ':', to specify a \"name: value\" pair: " + a);
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeStyle.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleWrappedValue_;
};
goog.DEBUG && (goog.html.SafeStyle.prototype.toString = function() {
    return "SafeStyle{" + this.privateDoNotAccessOrElseSafeStyleWrappedValue_ + "}";
});
goog.html.SafeStyle.unwrap = function(a) {
    if (a instanceof goog.html.SafeStyle && a.constructor === goog.html.SafeStyle && a.SAFE_STYLE_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyle.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeStyleWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyle, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:SafeStyle";
};
goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse = function(a) {
    return (new goog.html.SafeStyle).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeStyle.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
    this.privateDoNotAccessOrElseSafeStyleWrappedValue_ = a;
    return this;
};
goog.html.SafeStyle.EMPTY = goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse("");
goog.html.SafeStyle.INNOCUOUS_STRING = "zClosurez";
goog.html.SafeStyle.create = function(a) {
    var b = "", c;
    for(c in a){
        if (!/^[-_a-zA-Z0-9]+$/.test(c)) throw Error("Name allows only [-_a-zA-Z0-9], got: " + c);
        var d = a[c];
        null != d && (d = goog.isArray(d) ? goog.array.map(d, goog.html.SafeStyle.sanitizePropertyValue_).join(" ") : goog.html.SafeStyle.sanitizePropertyValue_(d), b += c + ":" + d + ";");
    }
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
};
goog.html.SafeStyle.sanitizePropertyValue_ = function(a) {
    if (a instanceof goog.html.SafeUrl) return 'url("' + goog.html.SafeUrl.unwrap(a).replace(/</g, "%3c").replace(/[\\"]/g, "\\$&") + '")';
    a = a instanceof goog.string.Const ? goog.string.Const.unwrap(a) : goog.html.SafeStyle.sanitizePropertyValueString_(String(a));
    if (/[{;}]/.test(a)) throw new goog.asserts.AssertionError("Value does not allow [{;}], got: %s.", [
        a
    ]);
    return a;
};
goog.html.SafeStyle.sanitizePropertyValueString_ = function(a) {
    var b = a.replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.FUNCTIONS_RE_, "$1").replace(goog.html.SafeStyle.URL_RE_, "url");
    if (goog.html.SafeStyle.VALUE_RE_.test(b)) {
        if (goog.html.SafeStyle.COMMENT_RE_.test(a)) return goog.asserts.fail("String value disallows comments, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
        if (!goog.html.SafeStyle.hasBalancedQuotes_(a)) return goog.asserts.fail("String value requires balanced quotes, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
        if (!goog.html.SafeStyle.hasBalancedSquareBrackets_(a)) return goog.asserts.fail("String value requires balanced square brackets and one identifier per pair of brackets, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
    } else return goog.asserts.fail("String value allows only " + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + " and simple functions, got: " + a), goog.html.SafeStyle.INNOCUOUS_STRING;
    return goog.html.SafeStyle.sanitizeUrl_(a);
};
goog.html.SafeStyle.hasBalancedQuotes_ = function(a) {
    for(var b = !0, c = !0, d = 0; d < a.length; d++){
        var e = a.charAt(d);
        "'" == e && c ? b = !b : '"' == e && b && (c = !c);
    }
    return b && c;
};
goog.html.SafeStyle.hasBalancedSquareBrackets_ = function(a) {
    for(var b = !0, c = /^[-_a-zA-Z0-9]$/, d = 0; d < a.length; d++){
        var e = a.charAt(d);
        if ("]" == e) {
            if (b) return !1;
            b = !0;
        } else if ("[" == e) {
            if (!b) return !1;
            b = !1;
        } else if (!b && !c.test(e)) return !1;
    }
    return b;
};
goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ = "[-,.\"'%_!# a-zA-Z0-9\\[\\]]";
goog.html.SafeStyle.VALUE_RE_ = new RegExp("^" + goog.html.SafeStyle.VALUE_ALLOWED_CHARS_ + "+$");
goog.html.SafeStyle.URL_RE_ = /\b(url\([ \t\n]*)('[ -&(-\[\]-~]*'|"[ !#-\[\]-~]*"|[!#-&*-\[\]-~]*)([ \t\n]*\))/g;
goog.html.SafeStyle.FUNCTIONS_RE_ = /\b(hsl|hsla|rgb|rgba|matrix|calc|minmax|fit-content|repeat|(rotate|scale|translate)(X|Y|Z|3d)?)\([-+*/0-9a-z.%\[\], ]+\)/g;
goog.html.SafeStyle.COMMENT_RE_ = /\/\*/;
goog.html.SafeStyle.sanitizeUrl_ = function(a) {
    return a.replace(goog.html.SafeStyle.URL_RE_, function(a, c, d, e) {
        var b = "";
        d = d.replace(/^(['"])(.*)\1$/, function(a, c, d) {
            b = c;
            return d;
        });
        a = goog.html.SafeUrl.sanitize(d).getTypedStringValue();
        return c + b + a + b + e;
    });
};
goog.html.SafeStyle.concat = function(a) {
    var b = "", c = function(a) {
        goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyle.unwrap(a);
    };
    goog.array.forEach(arguments, c);
    return b ? goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b) : goog.html.SafeStyle.EMPTY;
};
goog.html.SafeStyleSheet = function() {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = "";
    this.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
};
goog.html.SafeStyleSheet.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeStyleSheet.createRule = function(a, b) {
    if (goog.string.internal.contains(a, "<")) throw Error("Selector does not allow '<', got: " + a);
    var c = a.replace(/('|")((?!\1)[^\r\n\f\\]|\\[\s\S])*\1/g, "");
    if (!/^[-_a-zA-Z0-9#.:* ,>+~[\]()=^$|]+$/.test(c)) throw Error("Selector allows only [-_a-zA-Z0-9#.:* ,>+~[\\]()=^$|] and strings, got: " + a);
    if (!goog.html.SafeStyleSheet.hasBalancedBrackets_(c)) throw Error("() and [] in selector must be balanced, got: " + a);
    b instanceof goog.html.SafeStyle || (b = goog.html.SafeStyle.create(b));
    a = a + "{" + goog.html.SafeStyle.unwrap(b).replace(/</g, "\\3C ") + "}";
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeStyleSheet.hasBalancedBrackets_ = function(a) {
    for(var b = {
        "(": ")",
        "[": "]"
    }, c = [], d = 0; d < a.length; d++){
        var e = a[d];
        if (b[e]) c.push(b[e]);
        else if (goog.object.contains(b, e) && c.pop() != e) return !1;
    }
    return 0 == c.length;
};
goog.html.SafeStyleSheet.concat = function(a) {
    var b = "", c = function(a) {
        goog.isArray(a) ? goog.array.forEach(a, c) : b += goog.html.SafeStyleSheet.unwrap(a);
    };
    goog.array.forEach(arguments, c);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.SafeStyleSheet.fromConstant = function(a) {
    a = goog.string.Const.unwrap(a);
    if (0 === a.length) return goog.html.SafeStyleSheet.EMPTY;
    goog.asserts.assert(!goog.string.internal.contains(a, "<"), "Forbidden '<' character in style sheet string: " + a);
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(a);
};
goog.html.SafeStyleSheet.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
};
goog.DEBUG && (goog.html.SafeStyleSheet.prototype.toString = function() {
    return "SafeStyleSheet{" + this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ + "}";
});
goog.html.SafeStyleSheet.unwrap = function(a) {
    if (a instanceof goog.html.SafeStyleSheet && a.constructor === goog.html.SafeStyleSheet && a.SAFE_STYLE_SHEET_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeStyleSheet.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_;
    goog.asserts.fail("expected object of type SafeStyleSheet, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:SafeStyleSheet";
};
goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse = function(a) {
    return (new goog.html.SafeStyleSheet).initSecurityPrivateDoNotAccessOrElse_(a);
};
goog.html.SafeStyleSheet.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a) {
    this.privateDoNotAccessOrElseSafeStyleSheetWrappedValue_ = a;
    return this;
};
goog.html.SafeStyleSheet.EMPTY = goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse("");
goog.labs = {};
goog.labs.userAgent = {};
goog.labs.userAgent.util = {};
goog.labs.userAgent.util.getNativeUserAgentString_ = function() {
    var a = goog.labs.userAgent.util.getNavigator_();
    return a && (a = a.userAgent) ? a : "";
};
goog.labs.userAgent.util.getNavigator_ = function() {
    return goog.global.navigator;
};
goog.labs.userAgent.util.userAgent_ = goog.labs.userAgent.util.getNativeUserAgentString_();
goog.labs.userAgent.util.setUserAgent = function(a) {
    goog.labs.userAgent.util.userAgent_ = a || goog.labs.userAgent.util.getNativeUserAgentString_();
};
goog.labs.userAgent.util.getUserAgent = function() {
    return goog.labs.userAgent.util.userAgent_;
};
goog.labs.userAgent.util.matchUserAgent = function(a) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.contains(b, a);
};
goog.labs.userAgent.util.matchUserAgentIgnoreCase = function(a) {
    var b = goog.labs.userAgent.util.getUserAgent();
    return goog.string.internal.caseInsensitiveContains(b, a);
};
goog.labs.userAgent.util.extractVersionTuples = function(a) {
    for(var b = /(\w[\w ]+)\/([^\s]+)\s*(?:\((.*?)\))?/g, c = [], d; d = b.exec(a);)c.push([
        d[1],
        d[2],
        d[3] || void 0
    ]);
    return c;
};
goog.labs.userAgent.browser = {};
goog.labs.userAgent.browser.matchOpera_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Opera");
};
goog.labs.userAgent.browser.matchIE_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
};
goog.labs.userAgent.browser.matchEdgeHtml_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
};
goog.labs.userAgent.browser.matchEdgeChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edg/");
};
goog.labs.userAgent.browser.matchOperaChromium_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("OPR");
};
goog.labs.userAgent.browser.matchFirefox_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Firefox") || goog.labs.userAgent.util.matchUserAgent("FxiOS");
};
goog.labs.userAgent.browser.matchSafari_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Safari") && !(goog.labs.userAgent.browser.matchChrome_() || goog.labs.userAgent.browser.matchCoast_() || goog.labs.userAgent.browser.matchOpera_() || goog.labs.userAgent.browser.matchEdgeHtml_() || goog.labs.userAgent.browser.matchEdgeChromium_() || goog.labs.userAgent.browser.matchOperaChromium_() || goog.labs.userAgent.browser.matchFirefox_() || goog.labs.userAgent.browser.isSilk() || goog.labs.userAgent.util.matchUserAgent("Android"));
};
goog.labs.userAgent.browser.matchCoast_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Coast");
};
goog.labs.userAgent.browser.matchIosWebview_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("iPad") || goog.labs.userAgent.util.matchUserAgent("iPhone")) && !goog.labs.userAgent.browser.matchSafari_() && !goog.labs.userAgent.browser.matchChrome_() && !goog.labs.userAgent.browser.matchCoast_() && !goog.labs.userAgent.browser.matchFirefox_() && goog.labs.userAgent.util.matchUserAgent("AppleWebKit");
};
goog.labs.userAgent.browser.matchChrome_ = function() {
    return (goog.labs.userAgent.util.matchUserAgent("Chrome") || goog.labs.userAgent.util.matchUserAgent("CriOS")) && !goog.labs.userAgent.browser.matchEdgeHtml_();
};
goog.labs.userAgent.browser.matchAndroidBrowser_ = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android") && !(goog.labs.userAgent.browser.isChrome() || goog.labs.userAgent.browser.isFirefox() || goog.labs.userAgent.browser.isOpera() || goog.labs.userAgent.browser.isSilk());
};
goog.labs.userAgent.browser.isOpera = goog.labs.userAgent.browser.matchOpera_;
goog.labs.userAgent.browser.isIE = goog.labs.userAgent.browser.matchIE_;
goog.labs.userAgent.browser.isEdge = goog.labs.userAgent.browser.matchEdgeHtml_;
goog.labs.userAgent.browser.isEdgeChromium = goog.labs.userAgent.browser.matchEdgeChromium_;
goog.labs.userAgent.browser.isOperaChromium = goog.labs.userAgent.browser.matchOperaChromium_;
goog.labs.userAgent.browser.isFirefox = goog.labs.userAgent.browser.matchFirefox_;
goog.labs.userAgent.browser.isSafari = goog.labs.userAgent.browser.matchSafari_;
goog.labs.userAgent.browser.isCoast = goog.labs.userAgent.browser.matchCoast_;
goog.labs.userAgent.browser.isIosWebview = goog.labs.userAgent.browser.matchIosWebview_;
goog.labs.userAgent.browser.isChrome = goog.labs.userAgent.browser.matchChrome_;
goog.labs.userAgent.browser.isAndroidBrowser = goog.labs.userAgent.browser.matchAndroidBrowser_;
goog.labs.userAgent.browser.isSilk = function() {
    return goog.labs.userAgent.util.matchUserAgent("Silk");
};
goog.labs.userAgent.browser.getVersion = function() {
    function a(a) {
        a = goog.array.find(a, d);
        return c[a] || "";
    }
    var b = goog.labs.userAgent.util.getUserAgent();
    if (goog.labs.userAgent.browser.isIE()) return goog.labs.userAgent.browser.getIEVersion_(b);
    b = goog.labs.userAgent.util.extractVersionTuples(b);
    var c = {};
    goog.array.forEach(b, function(a) {
        c[a[0]] = a[1];
    });
    var d = goog.partial(goog.object.containsKey, c);
    return goog.labs.userAgent.browser.isOpera() ? a([
        "Version",
        "Opera"
    ]) : goog.labs.userAgent.browser.isEdge() ? a([
        "Edge"
    ]) : goog.labs.userAgent.browser.isEdgeChromium() ? a([
        "Edg"
    ]) : goog.labs.userAgent.browser.isChrome() ? a([
        "Chrome",
        "CriOS"
    ]) : (b = b[2]) && b[1] || "";
};
goog.labs.userAgent.browser.isVersionOrHigher = function(a) {
    return 0 <= goog.string.internal.compareVersions(goog.labs.userAgent.browser.getVersion(), a);
};
goog.labs.userAgent.browser.getIEVersion_ = function(a) {
    var b = /rv: *([\d\.]*)/.exec(a);
    if (b && b[1]) return b[1];
    b = "";
    var c = /MSIE +([\d\.]+)/.exec(a);
    if (c && c[1]) {
        if (a = /Trident\/(\d.\d)/.exec(a), "7.0" == c[1]) {
            if (a && a[1]) switch(a[1]){
                case "4.0":
                    b = "8.0";
                    break;
                case "5.0":
                    b = "9.0";
                    break;
                case "6.0":
                    b = "10.0";
                    break;
                case "7.0":
                    b = "11.0";
            }
            else b = "7.0";
        } else b = c[1];
    }
    return b;
};
goog.html.SafeHtml = function() {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = "";
    this.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_;
    this.dir_ = null;
};
goog.html.SafeHtml.prototype.implementsGoogI18nBidiDirectionalString = !0;
goog.html.SafeHtml.prototype.getDirection = function() {
    return this.dir_;
};
goog.html.SafeHtml.prototype.implementsGoogStringTypedString = !0;
goog.html.SafeHtml.prototype.getTypedStringValue = function() {
    return this.privateDoNotAccessOrElseSafeHtmlWrappedValue_.toString();
};
goog.DEBUG && (goog.html.SafeHtml.prototype.toString = function() {
    return "SafeHtml{" + this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ + "}";
});
goog.html.SafeHtml.unwrap = function(a) {
    return goog.html.SafeHtml.unwrapTrustedHTML(a).toString();
};
goog.html.SafeHtml.unwrapTrustedHTML = function(a) {
    if (a instanceof goog.html.SafeHtml && a.constructor === goog.html.SafeHtml && a.SAFE_HTML_TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ === goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_) return a.privateDoNotAccessOrElseSafeHtmlWrappedValue_;
    goog.asserts.fail("expected object of type SafeHtml, got '" + a + "' of type " + goog.typeOf(a));
    return "type_error:SafeHtml";
};
goog.html.SafeHtml.htmlEscape = function(a) {
    if (a instanceof goog.html.SafeHtml) return a;
    var b = "object" == typeof a, c = null;
    b && a.implementsGoogI18nBidiDirectionalString && (c = a.getDirection());
    a = b && a.implementsGoogStringTypedString ? a.getTypedStringValue() : String(a);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.htmlEscape(a), c);
};
goog.html.SafeHtml.htmlEscapePreservingNewlines = function(a) {
    if (a instanceof goog.html.SafeHtml) return a;
    a = goog.html.SafeHtml.htmlEscape(a);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.newLineToBr(goog.html.SafeHtml.unwrap(a)), a.getDirection());
};
goog.html.SafeHtml.htmlEscapePreservingNewlinesAndSpaces = function(a) {
    if (a instanceof goog.html.SafeHtml) return a;
    a = goog.html.SafeHtml.htmlEscape(a);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(goog.string.internal.whitespaceEscape(goog.html.SafeHtml.unwrap(a)), a.getDirection());
};
goog.html.SafeHtml.from = goog.html.SafeHtml.htmlEscape;
goog.html.SafeHtml.VALID_NAMES_IN_TAG_ = /^[a-zA-Z0-9-]+$/;
goog.html.SafeHtml.URL_ATTRIBUTES_ = {
    action: !0,
    cite: !0,
    data: !0,
    formaction: !0,
    href: !0,
    manifest: !0,
    poster: !0,
    src: !0
};
goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_ = {
    APPLET: !0,
    BASE: !0,
    EMBED: !0,
    IFRAME: !0,
    LINK: !0,
    MATH: !0,
    META: !0,
    OBJECT: !0,
    SCRIPT: !0,
    STYLE: !0,
    SVG: !0,
    TEMPLATE: !0
};
goog.html.SafeHtml.create = function(a, b, c) {
    goog.html.SafeHtml.verifyTagName(String(a));
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse(String(a), b, c);
};
goog.html.SafeHtml.verifyTagName = function(a) {
    if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(a)) throw Error("Invalid tag name <" + a + ">.");
    if (a.toUpperCase() in goog.html.SafeHtml.NOT_ALLOWED_TAG_NAMES_) throw Error("Tag name <" + a + "> is not allowed for SafeHtml.");
};
goog.html.SafeHtml.createIframe = function(a, b, c, d) {
    a && goog.html.TrustedResourceUrl.unwrap(a);
    var e = {};
    e.src = a || null;
    e.srcdoc = b && goog.html.SafeHtml.unwrap(b);
    a = goog.html.SafeHtml.combineAttributes(e, {
        sandbox: ""
    }, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
};
goog.html.SafeHtml.createSandboxIframe = function(a, b, c, d) {
    if (!goog.html.SafeHtml.canUseSandboxIframe()) throw Error("The browser does not support sandboxed iframes.");
    var e = {};
    e.src = a ? goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a)) : null;
    e.srcdoc = b || null;
    e.sandbox = "";
    a = goog.html.SafeHtml.combineAttributes(e, {}, c);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("iframe", a, d);
};
goog.html.SafeHtml.canUseSandboxIframe = function() {
    return goog.global.HTMLIFrameElement && "sandbox" in goog.global.HTMLIFrameElement.prototype;
};
goog.html.SafeHtml.createScriptSrc = function(a, b) {
    goog.html.TrustedResourceUrl.unwrap(a);
    a = goog.html.SafeHtml.combineAttributes({
        src: a
    }, {}, b);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", a);
};
goog.html.SafeHtml.createScript = function(a, b) {
    for(var c in b){
        var d = c.toLowerCase();
        if ("language" == d || "src" == d || "text" == d || "type" == d) throw Error('Cannot set "' + d + '" attribute');
    }
    c = "";
    a = goog.array.concat(a);
    for(d = 0; d < a.length; d++)c += goog.html.SafeScript.unwrap(a[d]);
    a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("script", b, a);
};
goog.html.SafeHtml.createStyle = function(a, b) {
    b = goog.html.SafeHtml.combineAttributes({
        type: "text/css"
    }, {}, b);
    var c = "";
    a = goog.array.concat(a);
    for(var d = 0; d < a.length; d++)c += goog.html.SafeStyleSheet.unwrap(a[d]);
    a = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(c, goog.i18n.bidi.Dir.NEUTRAL);
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("style", b, a);
};
goog.html.SafeHtml.createMetaRefresh = function(a, b) {
    a = goog.html.SafeUrl.unwrap(goog.html.SafeUrl.sanitize(a));
    (goog.labs.userAgent.browser.isIE() || goog.labs.userAgent.browser.isEdge()) && goog.string.internal.contains(a, ";") && (a = "'" + a.replace(/'/g, "%27") + "'");
    return goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse("meta", {
        "http-equiv": "refresh",
        content: (b || 0) + "; url=" + a
    });
};
goog.html.SafeHtml.getAttrNameAndValue_ = function(a, b, c) {
    if (c instanceof goog.string.Const) c = goog.string.Const.unwrap(c);
    else if ("style" == b.toLowerCase()) c = goog.html.SafeHtml.getStyleValue_(c);
    else {
        if (/^on/i.test(b)) throw Error('Attribute "' + b + '" requires goog.string.Const value, "' + c + '" given.');
        if (b.toLowerCase() in goog.html.SafeHtml.URL_ATTRIBUTES_) {
            if (c instanceof goog.html.TrustedResourceUrl) c = goog.html.TrustedResourceUrl.unwrap(c);
            else if (c instanceof goog.html.SafeUrl) c = goog.html.SafeUrl.unwrap(c);
            else if (goog.isString(c)) c = goog.html.SafeUrl.sanitize(c).getTypedStringValue();
            else throw Error('Attribute "' + b + '" on tag "' + a + '" requires goog.html.SafeUrl, goog.string.Const, or string, value "' + c + '" given.');
        }
    }
    c.implementsGoogStringTypedString && (c = c.getTypedStringValue());
    goog.asserts.assert(goog.isString(c) || goog.isNumber(c), "String or number value expected, got " + typeof c + " with value: " + c);
    return b + '="' + goog.string.internal.htmlEscape(String(c)) + '"';
};
goog.html.SafeHtml.getStyleValue_ = function(a) {
    if (!goog.isObject(a)) throw Error('The "style" attribute requires goog.html.SafeStyle or map of style properties, ' + typeof a + " given: " + a);
    a instanceof goog.html.SafeStyle || (a = goog.html.SafeStyle.create(a));
    return goog.html.SafeStyle.unwrap(a);
};
goog.html.SafeHtml.createWithDir = function(a, b, c, d) {
    b = goog.html.SafeHtml.create(b, c, d);
    b.dir_ = a;
    return b;
};
goog.html.SafeHtml.join = function(a, b) {
    a = goog.html.SafeHtml.htmlEscape(a);
    var c = a.getDirection(), d = [], e = function(a) {
        goog.isArray(a) ? goog.array.forEach(a, e) : (a = goog.html.SafeHtml.htmlEscape(a), d.push(goog.html.SafeHtml.unwrap(a)), a = a.getDirection(), c == goog.i18n.bidi.Dir.NEUTRAL ? c = a : a != goog.i18n.bidi.Dir.NEUTRAL && c != a && (c = null));
    };
    goog.array.forEach(b, e);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(d.join(goog.html.SafeHtml.unwrap(a)), c);
};
goog.html.SafeHtml.concat = function(a) {
    return goog.html.SafeHtml.join(goog.html.SafeHtml.EMPTY, Array.prototype.slice.call(arguments));
};
goog.html.SafeHtml.concatWithDir = function(a, b) {
    var c = goog.html.SafeHtml.concat(goog.array.slice(arguments, 1));
    c.dir_ = a;
    return c;
};
goog.html.SafeHtml.TYPE_MARKER_GOOG_HTML_SECURITY_PRIVATE_ = {};
goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse = function(a, b) {
    return (new goog.html.SafeHtml).initSecurityPrivateDoNotAccessOrElse_(a, b);
};
goog.html.SafeHtml.prototype.initSecurityPrivateDoNotAccessOrElse_ = function(a, b) {
    this.privateDoNotAccessOrElseSafeHtmlWrappedValue_ = goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY ? goog.html.trustedtypes.PRIVATE_DO_NOT_ACCESS_OR_ELSE_POLICY.createHTML(a) : a;
    this.dir_ = b;
    return this;
};
goog.html.SafeHtml.createSafeHtmlTagSecurityPrivateDoNotAccessOrElse = function(a, b, c) {
    var d = null;
    var e = "<" + a + goog.html.SafeHtml.stringifyAttributes(a, b);
    goog.isDefAndNotNull(c) ? goog.isArray(c) || (c = [
        c
    ]) : c = [];
    goog.dom.tags.isVoidTag(a.toLowerCase()) ? (goog.asserts.assert(!c.length, "Void tag <" + a + "> does not allow content."), e += ">") : (d = goog.html.SafeHtml.concat(c), e += ">" + goog.html.SafeHtml.unwrap(d) + "</" + a + ">", d = d.getDirection());
    (a = b && b.dir) && (d = /^(ltr|rtl|auto)$/i.test(a) ? goog.i18n.bidi.Dir.NEUTRAL : null);
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(e, d);
};
goog.html.SafeHtml.stringifyAttributes = function(a, b) {
    var c = "";
    if (b) for(var d in b){
        if (!goog.html.SafeHtml.VALID_NAMES_IN_TAG_.test(d)) throw Error('Invalid attribute name "' + d + '".');
        var e = b[d];
        goog.isDefAndNotNull(e) && (c += " " + goog.html.SafeHtml.getAttrNameAndValue_(a, d, e));
    }
    return c;
};
goog.html.SafeHtml.combineAttributes = function(a, b, c) {
    var d = {}, e;
    for(e in a)goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = a[e];
    for(e in b)goog.asserts.assert(e.toLowerCase() == e, "Must be lower case"), d[e] = b[e];
    for(e in c){
        var f = e.toLowerCase();
        if (f in a) throw Error('Cannot override "' + f + '" attribute, got "' + e + '" with value "' + c[e] + '"');
        f in b && delete d[f];
        d[e] = c[e];
    }
    return d;
};
goog.html.SafeHtml.DOCTYPE_HTML = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<!DOCTYPE html>", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.SafeHtml.EMPTY = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.SafeHtml.BR = goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse("<br>", goog.i18n.bidi.Dir.NEUTRAL);
goog.html.uncheckedconversions = {};
goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract = function(a, b, c) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.SafeHtml.createSafeHtmlSecurityPrivateDoNotAccessOrElse(b, c || null);
};
goog.html.uncheckedconversions.safeScriptFromStringKnownToSatisfyTypeContract = function(a, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.SafeScript.createSafeScriptSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeStyleFromStringKnownToSatisfyTypeContract = function(a, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.SafeStyle.createSafeStyleSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeStyleSheetFromStringKnownToSatisfyTypeContract = function(a, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.SafeStyleSheet.createSafeStyleSheetSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.SafeUrl.createSafeUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.html.uncheckedconversions.trustedResourceUrlFromStringKnownToSatisfyTypeContract = function(a, b) {
    goog.asserts.assertString(goog.string.Const.unwrap(a), "must provide justification");
    goog.asserts.assert(!goog.string.internal.isEmptyOrWhitespace(goog.string.Const.unwrap(a)), "must provide non-empty justification");
    return goog.html.TrustedResourceUrl.createTrustedResourceUrlSecurityPrivateDoNotAccessOrElse(b);
};
goog.dom.safe = {};
goog.dom.safe.InsertAdjacentHtmlPosition = {
    AFTERBEGIN: "afterbegin",
    AFTEREND: "afterend",
    BEFOREBEGIN: "beforebegin",
    BEFOREEND: "beforeend"
};
goog.dom.safe.insertAdjacentHtml = function(a, b, c) {
    a.insertAdjacentHTML(b, goog.html.SafeHtml.unwrapTrustedHTML(c));
};
goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_ = {
    MATH: !0,
    SCRIPT: !0,
    STYLE: !0,
    SVG: !0,
    TEMPLATE: !0
};
goog.dom.safe.isInnerHtmlCleanupRecursive_ = goog.functions.cacheReturnValue(function() {
    if (goog.DEBUG && "undefined" === typeof document) return !1;
    var a = document.createElement("div"), b = document.createElement("div");
    b.appendChild(document.createElement("div"));
    a.appendChild(b);
    if (goog.DEBUG && !a.firstChild) return !1;
    b = a.firstChild.firstChild;
    a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(goog.html.SafeHtml.EMPTY);
    return !b.parentElement;
});
goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse = function(a, b) {
    if (goog.dom.safe.isInnerHtmlCleanupRecursive_()) for(; a.lastChild;)a.removeChild(a.lastChild);
    a.innerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setInnerHtml = function(a, b) {
    if (goog.asserts.ENABLE_ASSERTS) {
        var c = a.tagName.toUpperCase();
        if (goog.dom.safe.SET_INNER_HTML_DISALLOWED_TAGS_[c]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + a.tagName + ".");
    }
    goog.dom.safe.unsafeSetInnerHtmlDoNotUseOrElse(a, b);
};
goog.dom.safe.setOuterHtml = function(a, b) {
    a.outerHTML = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setFormElementAction = function(a, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLFormElement(a).action = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setButtonFormAction = function(a, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLButtonElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setInputFormAction = function(a, b) {
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    goog.dom.asserts.assertIsHTMLInputElement(a).formAction = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setStyle = function(a, b) {
    a.style.cssText = goog.html.SafeStyle.unwrap(b);
};
goog.dom.safe.documentWrite = function(a, b) {
    a.write(goog.html.SafeHtml.unwrapTrustedHTML(b));
};
goog.dom.safe.setAnchorHref = function(a, b) {
    goog.dom.asserts.assertIsHTMLAnchorElement(a);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a.href = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setImageSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLImageElement(a);
    if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:image\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setAudioSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLAudioElement(a);
    if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:audio\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setVideoSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLVideoElement(a);
    if (!(b instanceof goog.html.SafeUrl)) {
        var c = /^data:video\//i.test(b);
        b = goog.html.SafeUrl.sanitizeAssertUnchanged(b, c);
    }
    a.src = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setEmbedSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLEmbedElement(a);
    a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
};
goog.dom.safe.setFrameSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLFrameElement(a);
    a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setIframeSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a);
    a.src = goog.html.TrustedResourceUrl.unwrapTrustedURL(b);
};
goog.dom.safe.setIframeSrcdoc = function(a, b) {
    goog.dom.asserts.assertIsHTMLIFrameElement(a);
    a.srcdoc = goog.html.SafeHtml.unwrapTrustedHTML(b);
};
goog.dom.safe.setLinkHrefAndRel = function(a, b, c) {
    goog.dom.asserts.assertIsHTMLLinkElement(a);
    a.rel = c;
    goog.string.internal.caseInsensitiveContains(c, "stylesheet") ? (goog.asserts.assert(b instanceof goog.html.TrustedResourceUrl, 'URL must be TrustedResourceUrl because "rel" contains "stylesheet"'), a.href = goog.html.TrustedResourceUrl.unwrapTrustedURL(b)) : a.href = b instanceof goog.html.TrustedResourceUrl ? goog.html.TrustedResourceUrl.unwrapTrustedURL(b) : b instanceof goog.html.SafeUrl ? goog.html.SafeUrl.unwrapTrustedURL(b) : goog.html.SafeUrl.unwrapTrustedURL(goog.html.SafeUrl.sanitizeAssertUnchanged(b));
};
goog.dom.safe.setObjectData = function(a, b) {
    goog.dom.asserts.assertIsHTMLObjectElement(a);
    a.data = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
};
goog.dom.safe.setScriptSrc = function(a, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a);
    a.src = goog.html.TrustedResourceUrl.unwrapTrustedScriptURL(b);
    (b = goog.getScriptNonce()) && a.setAttribute("nonce", b);
};
goog.dom.safe.setScriptContent = function(a, b) {
    goog.dom.asserts.assertIsHTMLScriptElement(a);
    a.text = goog.html.SafeScript.unwrapTrustedScript(b);
    (b = goog.getScriptNonce()) && a.setAttribute("nonce", b);
};
goog.dom.safe.setLocationHref = function(a, b) {
    goog.dom.asserts.assertIsLocation(a);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a.href = goog.html.SafeUrl.unwrapTrustedURL(b);
};
goog.dom.safe.assignLocation = function(a, b) {
    goog.dom.asserts.assertIsLocation(a);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a.assign(goog.html.SafeUrl.unwrapTrustedURL(b));
};
goog.dom.safe.replaceLocation = function(a, b) {
    goog.dom.asserts.assertIsLocation(a);
    b = b instanceof goog.html.SafeUrl ? b : goog.html.SafeUrl.sanitizeAssertUnchanged(b);
    a.replace(goog.html.SafeUrl.unwrapTrustedURL(b));
};
goog.dom.safe.openInWindow = function(a, b, c, d, e) {
    a = a instanceof goog.html.SafeUrl ? a : goog.html.SafeUrl.sanitizeAssertUnchanged(a);
    return (b || goog.global).open(goog.html.SafeUrl.unwrapTrustedURL(a), c ? goog.string.Const.unwrap(c) : "", d, e);
};
goog.dom.safe.parseFromStringHtml = function(a, b) {
    return goog.dom.safe.parseFromString(a, b, "text/html");
};
goog.dom.safe.parseFromString = function(a, b, c) {
    return a.parseFromString(goog.html.SafeHtml.unwrapTrustedHTML(b), c);
};
goog.dom.safe.createImageFromBlob = function(a) {
    if (!/^image\/.*/g.test(a.type)) throw Error("goog.dom.safe.createImageFromBlob only accepts MIME type image/.*.");
    var b = goog.global.URL.createObjectURL(a);
    a = new goog.global.Image;
    a.onload = function() {
        goog.global.URL.revokeObjectURL(b);
    };
    goog.dom.safe.setImageSrc(a, goog.html.uncheckedconversions.safeUrlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Image blob URL."), b));
    return a;
};
goog.string.DETECT_DOUBLE_ESCAPING = !1;
goog.string.FORCE_NON_DOM_HTML_UNESCAPING = !1;
goog.string.Unicode = {
    NBSP: "\xa0"
};
goog.string.startsWith = goog.string.internal.startsWith;
goog.string.endsWith = goog.string.internal.endsWith;
goog.string.caseInsensitiveStartsWith = goog.string.internal.caseInsensitiveStartsWith;
goog.string.caseInsensitiveEndsWith = goog.string.internal.caseInsensitiveEndsWith;
goog.string.caseInsensitiveEquals = goog.string.internal.caseInsensitiveEquals;
goog.string.subs = function(a, b) {
    for(var c = a.split("%s"), d = "", e = Array.prototype.slice.call(arguments, 1); e.length && 1 < c.length;)d += c.shift() + e.shift();
    return d + c.join("%s");
};
goog.string.collapseWhitespace = function(a) {
    return a.replace(/[\s\xa0]+/g, " ").replace(/^\s+|\s+$/g, "");
};
goog.string.isEmptyOrWhitespace = goog.string.internal.isEmptyOrWhitespace;
goog.string.isEmptyString = function(a) {
    return 0 == a.length;
};
goog.string.isEmpty = goog.string.isEmptyOrWhitespace;
goog.string.isEmptyOrWhitespaceSafe = function(a) {
    return goog.string.isEmptyOrWhitespace(goog.string.makeSafe(a));
};
goog.string.isEmptySafe = goog.string.isEmptyOrWhitespaceSafe;
goog.string.isBreakingWhitespace = function(a) {
    return !/[^\t\n\r ]/.test(a);
};
goog.string.isAlpha = function(a) {
    return !/[^a-zA-Z]/.test(a);
};
goog.string.isNumeric = function(a) {
    return !/[^0-9]/.test(a);
};
goog.string.isAlphaNumeric = function(a) {
    return !/[^a-zA-Z0-9]/.test(a);
};
goog.string.isSpace = function(a) {
    return " " == a;
};
goog.string.isUnicodeChar = function(a) {
    return 1 == a.length && " " <= a && "~" >= a || "\x80" <= a && "\uFFFD" >= a;
};
goog.string.stripNewlines = function(a) {
    return a.replace(/(\r\n|\r|\n)+/g, " ");
};
goog.string.canonicalizeNewlines = function(a) {
    return a.replace(/(\r\n|\r|\n)/g, "\n");
};
goog.string.normalizeWhitespace = function(a) {
    return a.replace(/\xa0|\s/g, " ");
};
goog.string.normalizeSpaces = function(a) {
    return a.replace(/\xa0|[ \t]+/g, " ");
};
goog.string.collapseBreakingSpaces = function(a) {
    return a.replace(/[\t\r\n ]+/g, " ").replace(/^[\t\r\n ]+|[\t\r\n ]+$/g, "");
};
goog.string.trim = goog.string.internal.trim;
goog.string.trimLeft = function(a) {
    return a.replace(/^[\s\xa0]+/, "");
};
goog.string.trimRight = function(a) {
    return a.replace(/[\s\xa0]+$/, "");
};
goog.string.caseInsensitiveCompare = goog.string.internal.caseInsensitiveCompare;
goog.string.numberAwareCompare_ = function(a, b, c) {
    if (a == b) return 0;
    if (!a) return -1;
    if (!b) return 1;
    for(var d = a.toLowerCase().match(c), e = b.toLowerCase().match(c), f = Math.min(d.length, e.length), g = 0; g < f; g++){
        c = d[g];
        var h = e[g];
        if (c != h) return a = parseInt(c, 10), !isNaN(a) && (b = parseInt(h, 10), !isNaN(b) && a - b) ? a - b : c < h ? -1 : 1;
    }
    return d.length != e.length ? d.length - e.length : a < b ? -1 : 1;
};
goog.string.intAwareCompare = function(a, b) {
    return goog.string.numberAwareCompare_(a, b, /\d+|\D+/g);
};
goog.string.floatAwareCompare = function(a, b) {
    return goog.string.numberAwareCompare_(a, b, /\d+|\.\d+|\D+/g);
};
goog.string.numerateCompare = goog.string.floatAwareCompare;
goog.string.urlEncode = function(a) {
    return encodeURIComponent(String(a));
};
goog.string.urlDecode = function(a) {
    return decodeURIComponent(a.replace(/\+/g, " "));
};
goog.string.newLineToBr = goog.string.internal.newLineToBr;
goog.string.htmlEscape = function(a, b) {
    a = goog.string.internal.htmlEscape(a, b);
    goog.string.DETECT_DOUBLE_ESCAPING && (a = a.replace(goog.string.E_RE_, "&#101;"));
    return a;
};
goog.string.E_RE_ = /e/g;
goog.string.unescapeEntities = function(a) {
    return goog.string.contains(a, "&") ? !goog.string.FORCE_NON_DOM_HTML_UNESCAPING && "document" in goog.global ? goog.string.unescapeEntitiesUsingDom_(a) : goog.string.unescapePureXmlEntities_(a) : a;
};
goog.string.unescapeEntitiesWithDocument = function(a, b) {
    return goog.string.contains(a, "&") ? goog.string.unescapeEntitiesUsingDom_(a, b) : a;
};
goog.string.unescapeEntitiesUsingDom_ = function(a, b) {
    var c = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"'
    };
    var d = b ? b.createElement("div") : goog.global.document.createElement("div");
    return a.replace(goog.string.HTML_ENTITY_PATTERN_, function(a, b) {
        var e = c[a];
        if (e) return e;
        "#" == b.charAt(0) && (b = Number("0" + b.substr(1)), isNaN(b) || (e = String.fromCharCode(b)));
        e || (goog.dom.safe.setInnerHtml(d, goog.html.uncheckedconversions.safeHtmlFromStringKnownToSatisfyTypeContract(goog.string.Const.from("Single HTML entity."), a + " ")), e = d.firstChild.nodeValue.slice(0, -1));
        return c[a] = e;
    });
};
goog.string.unescapePureXmlEntities_ = function(a) {
    return a.replace(/&([^;]+);/g, function(a, c) {
        switch(c){
            case "amp":
                return "&";
            case "lt":
                return "<";
            case "gt":
                return ">";
            case "quot":
                return '"';
            default:
                return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? a : String.fromCharCode(c);
        }
    });
};
goog.string.HTML_ENTITY_PATTERN_ = /&([^;\s<&]+);?/g;
goog.string.whitespaceEscape = function(a, b) {
    return goog.string.newLineToBr(a.replace(/  /g, " &#160;"), b);
};
goog.string.preserveSpaces = function(a) {
    return a.replace(/(^|[\n ]) /g, "$1" + goog.string.Unicode.NBSP);
};
goog.string.stripQuotes = function(a, b) {
    for(var c = b.length, d = 0; d < c; d++){
        var e = 1 == c ? b : b.charAt(d);
        if (a.charAt(0) == e && a.charAt(a.length - 1) == e) return a.substring(1, a.length - 1);
    }
    return a;
};
goog.string.truncate = function(a, b, c) {
    c && (a = goog.string.unescapeEntities(a));
    a.length > b && (a = a.substring(0, b - 3) + "...");
    c && (a = goog.string.htmlEscape(a));
    return a;
};
goog.string.truncateMiddle = function(a, b, c, d) {
    c && (a = goog.string.unescapeEntities(a));
    if (d && a.length > b) {
        d > b && (d = b);
        var e = a.length - d;
        a = a.substring(0, b - d) + "..." + a.substring(e);
    } else a.length > b && (d = Math.floor(b / 2), e = a.length - d, a = a.substring(0, d + b % 2) + "..." + a.substring(e));
    c && (a = goog.string.htmlEscape(a));
    return a;
};
goog.string.specialEscapeChars_ = {
    "\x00": "\\0",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "	": "\\t",
    "\v": "\\x0B",
    '"': '\\"',
    "\\": "\\\\",
    "<": "\\u003C"
};
goog.string.jsEscapeCache_ = {
    "'": "\\'"
};
goog.string.quote = function(a) {
    a = String(a);
    for(var b = [
        '"'
    ], c = 0; c < a.length; c++){
        var d = a.charAt(c), e = d.charCodeAt(0);
        b[c + 1] = goog.string.specialEscapeChars_[d] || (31 < e && 127 > e ? d : goog.string.escapeChar(d));
    }
    b.push('"');
    return b.join("");
};
goog.string.escapeString = function(a) {
    for(var b = [], c = 0; c < a.length; c++)b[c] = goog.string.escapeChar(a.charAt(c));
    return b.join("");
};
goog.string.escapeChar = function(a) {
    if (a in goog.string.jsEscapeCache_) return goog.string.jsEscapeCache_[a];
    if (a in goog.string.specialEscapeChars_) return goog.string.jsEscapeCache_[a] = goog.string.specialEscapeChars_[a];
    var b = a.charCodeAt(0);
    if (31 < b && 127 > b) var c = a;
    else {
        if (256 > b) {
            if (c = "\\x", 16 > b || 256 < b) c += "0";
        } else c = "\\u", 4096 > b && (c += "0");
        c += b.toString(16).toUpperCase();
    }
    return goog.string.jsEscapeCache_[a] = c;
};
goog.string.contains = goog.string.internal.contains;
goog.string.caseInsensitiveContains = goog.string.internal.caseInsensitiveContains;
goog.string.countOf = function(a, b) {
    return a && b ? a.split(b).length - 1 : 0;
};
goog.string.removeAt = function(a, b, c) {
    var d = a;
    0 <= b && b < a.length && 0 < c && (d = a.substr(0, b) + a.substr(b + c, a.length - b - c));
    return d;
};
goog.string.remove = function(a, b) {
    return a.replace(b, "");
};
goog.string.removeAll = function(a, b) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a.replace(b, "");
};
goog.string.replaceAll = function(a, b, c) {
    b = new RegExp(goog.string.regExpEscape(b), "g");
    return a.replace(b, c.replace(/\$/g, "$$$$"));
};
goog.string.regExpEscape = function(a) {
    return String(a).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08");
};
goog.string.repeat = String.prototype.repeat ? function(a, b) {
    return a.repeat(b);
} : function(a, b) {
    return Array(b + 1).join(a);
};
goog.string.padNumber = function(a, b, c) {
    a = goog.isDef(c) ? a.toFixed(c) : String(a);
    c = a.indexOf(".");
    -1 == c && (c = a.length);
    return goog.string.repeat("0", Math.max(0, b - c)) + a;
};
goog.string.makeSafe = function(a) {
    return null == a ? "" : String(a);
};
goog.string.buildString = function(a) {
    return Array.prototype.join.call(arguments, "");
};
goog.string.getRandomString = function() {
    return Math.floor(2147483648 * Math.random()).toString(36) + Math.abs(Math.floor(2147483648 * Math.random()) ^ goog.now()).toString(36);
};
goog.string.compareVersions = goog.string.internal.compareVersions;
goog.string.hashCode = function(a) {
    for(var b = 0, c = 0; c < a.length; ++c)b = 31 * b + a.charCodeAt(c) >>> 0;
    return b;
};
goog.string.uniqueStringCounter_ = 2147483648 * Math.random() | 0;
goog.string.createUniqueString = function() {
    return "goog_" + goog.string.uniqueStringCounter_++;
};
goog.string.toNumber = function(a) {
    var b = Number(a);
    return 0 == b && goog.string.isEmptyOrWhitespace(a) ? NaN : b;
};
goog.string.isLowerCamelCase = function(a) {
    return /^[a-z]+([A-Z][a-z]*)*$/.test(a);
};
goog.string.isUpperCamelCase = function(a) {
    return /^([A-Z][a-z]*)+$/.test(a);
};
goog.string.toCamelCase = function(a) {
    return String(a).replace(/\-([a-z])/g, function(a, c) {
        return c.toUpperCase();
    });
};
goog.string.toSelectorCase = function(a) {
    return String(a).replace(/([A-Z])/g, "-$1").toLowerCase();
};
goog.string.toTitleCase = function(a, b) {
    b = goog.isString(b) ? goog.string.regExpEscape(b) : "\\s";
    return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(a, b, e) {
        return b + e.toUpperCase();
    });
};
goog.string.capitalize = function(a) {
    return String(a.charAt(0)).toUpperCase() + String(a.substr(1)).toLowerCase();
};
goog.string.parseInt = function(a) {
    isFinite(a) && (a = String(a));
    return goog.isString(a) ? /^\s*-?0x/i.test(a) ? parseInt(a, 16) : parseInt(a, 10) : NaN;
};
goog.string.splitLimit = function(a, b, c) {
    a = a.split(b);
    for(var d = []; 0 < c && a.length;)d.push(a.shift()), c--;
    a.length && d.push(a.join(b));
    return d;
};
goog.string.lastComponent = function(a, b) {
    if (b) "string" == typeof b && (b = [
        b
    ]);
    else return a;
    for(var c = -1, d = 0; d < b.length; d++)if ("" != b[d]) {
        var e = a.lastIndexOf(b[d]);
        e > c && (c = e);
    }
    return -1 == c ? a : a.slice(c + 1);
};
goog.string.editDistance = function(a, b) {
    var c = [], d = [];
    if (a == b) return 0;
    if (!a.length || !b.length) return Math.max(a.length, b.length);
    for(var e = 0; e < b.length + 1; e++)c[e] = e;
    for(e = 0; e < a.length; e++){
        d[0] = e + 1;
        for(var f = 0; f < b.length; f++)d[f + 1] = Math.min(d[f] + 1, c[f + 1] + 1, c[f] + Number(a[e] != b[f]));
        for(f = 0; f < c.length; f++)c[f] = d[f];
    }
    return d[b.length];
};
goog.labs.userAgent.engine = {};
goog.labs.userAgent.engine.isPresto = function() {
    return goog.labs.userAgent.util.matchUserAgent("Presto");
};
goog.labs.userAgent.engine.isTrident = function() {
    return goog.labs.userAgent.util.matchUserAgent("Trident") || goog.labs.userAgent.util.matchUserAgent("MSIE");
};
goog.labs.userAgent.engine.isEdge = function() {
    return goog.labs.userAgent.util.matchUserAgent("Edge");
};
goog.labs.userAgent.engine.isWebKit = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("WebKit") && !goog.labs.userAgent.engine.isEdge();
};
goog.labs.userAgent.engine.isGecko = function() {
    return goog.labs.userAgent.util.matchUserAgent("Gecko") && !goog.labs.userAgent.engine.isWebKit() && !goog.labs.userAgent.engine.isTrident() && !goog.labs.userAgent.engine.isEdge();
};
goog.labs.userAgent.engine.getVersion = function() {
    var a = goog.labs.userAgent.util.getUserAgent();
    if (a) {
        a = goog.labs.userAgent.util.extractVersionTuples(a);
        var b = goog.labs.userAgent.engine.getEngineTuple_(a);
        if (b) return "Gecko" == b[0] ? goog.labs.userAgent.engine.getVersionForKey_(a, "Firefox") : b[1];
        a = a[0];
        var c;
        if (a && (c = a[2]) && (c = /Trident\/([^\s;]+)/.exec(c))) return c[1];
    }
    return "";
};
goog.labs.userAgent.engine.getEngineTuple_ = function(a) {
    if (!goog.labs.userAgent.engine.isEdge()) return a[1];
    for(var b = 0; b < a.length; b++){
        var c = a[b];
        if ("Edge" == c[0]) return c;
    }
};
goog.labs.userAgent.engine.isVersionOrHigher = function(a) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.engine.getVersion(), a);
};
goog.labs.userAgent.engine.getVersionForKey_ = function(a, b) {
    return (a = goog.array.find(a, function(a) {
        return b == a[0];
    })) && a[1] || "";
};
goog.labs.userAgent.platform = {};
goog.labs.userAgent.platform.isAndroid = function() {
    return goog.labs.userAgent.util.matchUserAgent("Android");
};
goog.labs.userAgent.platform.isIpod = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPod");
};
goog.labs.userAgent.platform.isIphone = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPhone") && !goog.labs.userAgent.util.matchUserAgent("iPod") && !goog.labs.userAgent.util.matchUserAgent("iPad");
};
goog.labs.userAgent.platform.isIpad = function() {
    return goog.labs.userAgent.util.matchUserAgent("iPad");
};
goog.labs.userAgent.platform.isIos = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpad() || goog.labs.userAgent.platform.isIpod();
};
goog.labs.userAgent.platform.isMacintosh = function() {
    return goog.labs.userAgent.util.matchUserAgent("Macintosh");
};
goog.labs.userAgent.platform.isLinux = function() {
    return goog.labs.userAgent.util.matchUserAgent("Linux");
};
goog.labs.userAgent.platform.isWindows = function() {
    return goog.labs.userAgent.util.matchUserAgent("Windows");
};
goog.labs.userAgent.platform.isChromeOS = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrOS");
};
goog.labs.userAgent.platform.isChromecast = function() {
    return goog.labs.userAgent.util.matchUserAgent("CrKey");
};
goog.labs.userAgent.platform.isKaiOS = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("KaiOS");
};
goog.labs.userAgent.platform.isGo2Phone = function() {
    return goog.labs.userAgent.util.matchUserAgentIgnoreCase("GAFP");
};
goog.labs.userAgent.platform.getVersion = function() {
    var a = goog.labs.userAgent.util.getUserAgent(), b = "";
    goog.labs.userAgent.platform.isWindows() ? (b = /Windows (?:NT|Phone) ([0-9.]+)/, b = (a = b.exec(a)) ? a[1] : "0.0") : goog.labs.userAgent.platform.isIos() ? (b = /(?:iPhone|iPod|iPad|CPU)\s+OS\s+(\S+)/, b = (a = b.exec(a)) && a[1].replace(/_/g, ".")) : goog.labs.userAgent.platform.isMacintosh() ? (b = /Mac OS X ([0-9_.]+)/, b = (a = b.exec(a)) ? a[1].replace(/_/g, ".") : "10") : goog.labs.userAgent.platform.isKaiOS() ? (b = /(?:KaiOS)\/(\S+)/i, b = (a = b.exec(a)) && a[1]) : goog.labs.userAgent.platform.isAndroid() ? (b = /Android\s+([^\);]+)(\)|;)/, b = (a = b.exec(a)) && a[1]) : goog.labs.userAgent.platform.isChromeOS() && (b = /(?:CrOS\s+(?:i686|x86_64)\s+([0-9.]+))/, b = (a = b.exec(a)) && a[1]);
    return b || "";
};
goog.labs.userAgent.platform.isVersionOrHigher = function(a) {
    return 0 <= goog.string.compareVersions(goog.labs.userAgent.platform.getVersion(), a);
};
goog.reflect = {};
goog.reflect.object = function(a, b) {
    return b;
};
goog.reflect.objectProperty = function(a, b) {
    return a;
};
goog.reflect.sinkValue = function(a) {
    goog.reflect.sinkValue[" "](a);
    return a;
};
goog.reflect.sinkValue[" "] = goog.nullFunction;
goog.reflect.canAccessProperty = function(a, b) {
    try {
        return goog.reflect.sinkValue(a[b]), !0;
    } catch (c) {}
    return !1;
};
goog.reflect.cache = function(a, b, c, d) {
    d = d ? d(b) : b;
    return Object.prototype.hasOwnProperty.call(a, d) ? a[d] : a[d] = c(b);
};
goog.userAgent = {};
goog.userAgent.ASSUME_IE = !1;
goog.userAgent.ASSUME_EDGE = !1;
goog.userAgent.ASSUME_GECKO = !1;
goog.userAgent.ASSUME_WEBKIT = !1;
goog.userAgent.ASSUME_MOBILE_WEBKIT = !1;
goog.userAgent.ASSUME_OPERA = !1;
goog.userAgent.ASSUME_ANY_VERSION = !1;
goog.userAgent.BROWSER_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_GECKO || goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_OPERA;
goog.userAgent.getUserAgentString = function() {
    return goog.labs.userAgent.util.getUserAgent();
};
goog.userAgent.getNavigatorTyped = function() {
    return goog.global.navigator || null;
};
goog.userAgent.getNavigator = function() {
    return goog.userAgent.getNavigatorTyped();
};
goog.userAgent.OPERA = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_OPERA : goog.labs.userAgent.browser.isOpera();
goog.userAgent.IE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_IE : goog.labs.userAgent.browser.isIE();
goog.userAgent.EDGE = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_EDGE : goog.labs.userAgent.engine.isEdge();
goog.userAgent.EDGE_OR_IE = goog.userAgent.EDGE || goog.userAgent.IE;
goog.userAgent.GECKO = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_GECKO : goog.labs.userAgent.engine.isGecko();
goog.userAgent.WEBKIT = goog.userAgent.BROWSER_KNOWN_ ? goog.userAgent.ASSUME_WEBKIT || goog.userAgent.ASSUME_MOBILE_WEBKIT : goog.labs.userAgent.engine.isWebKit();
goog.userAgent.isMobile_ = function() {
    return goog.userAgent.WEBKIT && goog.labs.userAgent.util.matchUserAgent("Mobile");
};
goog.userAgent.MOBILE = goog.userAgent.ASSUME_MOBILE_WEBKIT || goog.userAgent.isMobile_();
goog.userAgent.SAFARI = goog.userAgent.WEBKIT;
goog.userAgent.determinePlatform_ = function() {
    var a = goog.userAgent.getNavigatorTyped();
    return a && a.platform || "";
};
goog.userAgent.PLATFORM = goog.userAgent.determinePlatform_();
goog.userAgent.ASSUME_MAC = !1;
goog.userAgent.ASSUME_WINDOWS = !1;
goog.userAgent.ASSUME_LINUX = !1;
goog.userAgent.ASSUME_X11 = !1;
goog.userAgent.ASSUME_ANDROID = !1;
goog.userAgent.ASSUME_IPHONE = !1;
goog.userAgent.ASSUME_IPAD = !1;
goog.userAgent.ASSUME_IPOD = !1;
goog.userAgent.ASSUME_KAIOS = !1;
goog.userAgent.ASSUME_GO2PHONE = !1;
goog.userAgent.PLATFORM_KNOWN_ = goog.userAgent.ASSUME_MAC || goog.userAgent.ASSUME_WINDOWS || goog.userAgent.ASSUME_LINUX || goog.userAgent.ASSUME_X11 || goog.userAgent.ASSUME_ANDROID || goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD;
goog.userAgent.MAC = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_MAC : goog.labs.userAgent.platform.isMacintosh();
goog.userAgent.WINDOWS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_WINDOWS : goog.labs.userAgent.platform.isWindows();
goog.userAgent.isLegacyLinux_ = function() {
    return goog.labs.userAgent.platform.isLinux() || goog.labs.userAgent.platform.isChromeOS();
};
goog.userAgent.LINUX = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_LINUX : goog.userAgent.isLegacyLinux_();
goog.userAgent.isX11_ = function() {
    var a = goog.userAgent.getNavigatorTyped();
    return !!a && goog.string.contains(a.appVersion || "", "X11");
};
goog.userAgent.X11 = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_X11 : goog.userAgent.isX11_();
goog.userAgent.ANDROID = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_ANDROID : goog.labs.userAgent.platform.isAndroid();
goog.userAgent.IPHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE : goog.labs.userAgent.platform.isIphone();
goog.userAgent.IPAD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
goog.userAgent.IPOD = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIpod();
goog.userAgent.IOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_IPHONE || goog.userAgent.ASSUME_IPAD || goog.userAgent.ASSUME_IPOD : goog.labs.userAgent.platform.isIos();
goog.userAgent.KAIOS = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_KAIOS : goog.labs.userAgent.platform.isKaiOS();
goog.userAgent.GO2PHONE = goog.userAgent.PLATFORM_KNOWN_ ? goog.userAgent.ASSUME_GO2PHONE : goog.labs.userAgent.platform.isGo2Phone();
goog.userAgent.determineVersion_ = function() {
    var a = "", b = goog.userAgent.getVersionRegexResult_();
    b && (a = b ? b[1] : "");
    return goog.userAgent.IE && (b = goog.userAgent.getDocumentMode_(), null != b && b > parseFloat(a)) ? String(b) : a;
};
goog.userAgent.getVersionRegexResult_ = function() {
    var a = goog.userAgent.getUserAgentString();
    if (goog.userAgent.GECKO) return /rv:([^\);]+)(\)|;)/.exec(a);
    if (goog.userAgent.EDGE) return /Edge\/([\d\.]+)/.exec(a);
    if (goog.userAgent.IE) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
    if (goog.userAgent.WEBKIT) return /WebKit\/(\S+)/.exec(a);
    if (goog.userAgent.OPERA) return /(?:Version)[ \/]?(\S+)/.exec(a);
};
goog.userAgent.getDocumentMode_ = function() {
    var a = goog.global.document;
    return a ? a.documentMode : void 0;
};
goog.userAgent.VERSION = goog.userAgent.determineVersion_();
goog.userAgent.compare = function(a, b) {
    return goog.string.compareVersions(a, b);
};
goog.userAgent.isVersionOrHigherCache_ = {};
goog.userAgent.isVersionOrHigher = function(a) {
    return goog.userAgent.ASSUME_ANY_VERSION || goog.reflect.cache(goog.userAgent.isVersionOrHigherCache_, a, function() {
        return 0 <= goog.string.compareVersions(goog.userAgent.VERSION, a);
    });
};
goog.userAgent.isVersion = goog.userAgent.isVersionOrHigher;
goog.userAgent.isDocumentModeOrHigher = function(a) {
    return Number(goog.userAgent.DOCUMENT_MODE) >= a;
};
goog.userAgent.isDocumentMode = goog.userAgent.isDocumentModeOrHigher;
goog.userAgent.DOCUMENT_MODE = function() {
    if (goog.global.document && goog.userAgent.IE) return goog.userAgent.getDocumentMode_();
}();
goog.userAgent.product = {};
goog.userAgent.product.ASSUME_FIREFOX = !1;
goog.userAgent.product.ASSUME_IPHONE = !1;
goog.userAgent.product.ASSUME_IPAD = !1;
goog.userAgent.product.ASSUME_ANDROID = !1;
goog.userAgent.product.ASSUME_CHROME = !1;
goog.userAgent.product.ASSUME_SAFARI = !1;
goog.userAgent.product.PRODUCT_KNOWN_ = goog.userAgent.ASSUME_IE || goog.userAgent.ASSUME_EDGE || goog.userAgent.ASSUME_OPERA || goog.userAgent.product.ASSUME_FIREFOX || goog.userAgent.product.ASSUME_IPHONE || goog.userAgent.product.ASSUME_IPAD || goog.userAgent.product.ASSUME_ANDROID || goog.userAgent.product.ASSUME_CHROME || goog.userAgent.product.ASSUME_SAFARI;
goog.userAgent.product.OPERA = goog.userAgent.OPERA;
goog.userAgent.product.IE = goog.userAgent.IE;
goog.userAgent.product.EDGE = goog.userAgent.EDGE;
goog.userAgent.product.FIREFOX = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_FIREFOX : goog.labs.userAgent.browser.isFirefox();
goog.userAgent.product.isIphoneOrIpod_ = function() {
    return goog.labs.userAgent.platform.isIphone() || goog.labs.userAgent.platform.isIpod();
};
goog.userAgent.product.IPHONE = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPHONE : goog.userAgent.product.isIphoneOrIpod_();
goog.userAgent.product.IPAD = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_IPAD : goog.labs.userAgent.platform.isIpad();
goog.userAgent.product.ANDROID = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_ANDROID : goog.labs.userAgent.browser.isAndroidBrowser();
goog.userAgent.product.CHROME = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_CHROME : goog.labs.userAgent.browser.isChrome();
goog.userAgent.product.isSafariDesktop_ = function() {
    return goog.labs.userAgent.browser.isSafari() && !goog.labs.userAgent.platform.isIos();
};
goog.userAgent.product.SAFARI = goog.userAgent.product.PRODUCT_KNOWN_ ? goog.userAgent.product.ASSUME_SAFARI : goog.userAgent.product.isSafariDesktop_();
goog.crypt.base64 = {};
goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
goog.crypt.base64.ENCODED_VALS = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "+/=";
goog.crypt.base64.ENCODED_VALS_WEBSAFE = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_ + "-_.";
goog.crypt.base64.Alphabet = {
    DEFAULT: 0,
    NO_PADDING: 1,
    WEBSAFE: 2,
    WEBSAFE_DOT_PADDING: 3,
    WEBSAFE_NO_PADDING: 4
};
goog.crypt.base64.paddingChars_ = "=.";
goog.crypt.base64.isPadding_ = function(a) {
    return goog.string.contains(goog.crypt.base64.paddingChars_, a);
};
goog.crypt.base64.byteToCharMaps_ = {};
goog.crypt.base64.charToByteMap_ = null;
goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ = goog.userAgent.GECKO || goog.userAgent.WEBKIT && !goog.userAgent.product.SAFARI || goog.userAgent.OPERA;
goog.crypt.base64.HAS_NATIVE_ENCODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || "function" == typeof goog.global.btoa;
goog.crypt.base64.HAS_NATIVE_DECODE_ = goog.crypt.base64.ASSUME_NATIVE_SUPPORT_ || !goog.userAgent.product.SAFARI && !goog.userAgent.IE && "function" == typeof goog.global.atob;
goog.crypt.base64.encodeByteArray = function(a, b) {
    goog.asserts.assert(goog.isArrayLike(a), "encodeByteArray takes an array as a parameter");
    void 0 === b && (b = goog.crypt.base64.Alphabet.DEFAULT);
    goog.crypt.base64.init_();
    b = goog.crypt.base64.byteToCharMaps_[b];
    for(var c = [], d = 0; d < a.length; d += 3){
        var e = a[d], f = d + 1 < a.length, g = f ? a[d + 1] : 0, h = d + 2 < a.length, k = h ? a[d + 2] : 0, l = e >> 2;
        e = (e & 3) << 4 | g >> 4;
        g = (g & 15) << 2 | k >> 6;
        k &= 63;
        h || (k = 64, f || (g = 64));
        c.push(b[l], b[e], b[g] || "", b[k] || "");
    }
    return c.join("");
};
goog.crypt.base64.encodeString = function(a, b) {
    return goog.crypt.base64.HAS_NATIVE_ENCODE_ && !b ? goog.global.btoa(a) : goog.crypt.base64.encodeByteArray(goog.crypt.stringToByteArray(a), b);
};
goog.crypt.base64.decodeString = function(a, b) {
    if (goog.crypt.base64.HAS_NATIVE_DECODE_ && !b) return goog.global.atob(a);
    var c = "";
    goog.crypt.base64.decodeStringInternal_(a, function(a) {
        c += String.fromCharCode(a);
    });
    return c;
};
goog.crypt.base64.decodeStringToByteArray = function(a, b) {
    var c = [];
    goog.crypt.base64.decodeStringInternal_(a, function(a) {
        c.push(a);
    });
    return c;
};
goog.crypt.base64.decodeStringToUint8Array = function(a) {
    goog.asserts.assert(!goog.userAgent.IE || goog.userAgent.isVersionOrHigher("10"), "Browser does not support typed arrays");
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : goog.crypt.base64.isPadding_(a[b - 1]) && (c = goog.crypt.base64.isPadding_(a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), e = 0;
    goog.crypt.base64.decodeStringInternal_(a, function(a) {
        d[e++] = a;
    });
    return d.subarray(0, e);
};
goog.crypt.base64.decodeStringInternal_ = function(a, b) {
    function c(b) {
        for(; d < a.length;){
            var c = a.charAt(d++), e = goog.crypt.base64.charToByteMap_[c];
            if (null != e) return e;
            if (!goog.string.isEmptyOrWhitespace(c)) throw Error("Unknown base64 encoding at char: " + c);
        }
        return b;
    }
    goog.crypt.base64.init_();
    for(var d = 0;;){
        var e = c(-1), f = c(0), g = c(64), h = c(64);
        if (64 === h && -1 === e) break;
        b(e << 2 | f >> 4);
        64 != g && (b(f << 4 & 240 | g >> 2), 64 != h && b(g << 6 & 192 | h));
    }
};
goog.crypt.base64.init_ = function() {
    if (!goog.crypt.base64.charToByteMap_) {
        goog.crypt.base64.charToByteMap_ = {};
        for(var a = goog.crypt.base64.DEFAULT_ALPHABET_COMMON_.split(""), b = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], c = 0; 5 > c; c++){
            var d = a.concat(b[c].split(""));
            goog.crypt.base64.byteToCharMaps_[c] = d;
            for(var e = 0; e < d.length; e++){
                var f = d[e], g = goog.crypt.base64.charToByteMap_[f];
                void 0 === g ? goog.crypt.base64.charToByteMap_[f] = e : goog.asserts.assert(g === e);
            }
        }
    }
};
jspb.utils = {};
jspb.utils.split64Low = 0;
jspb.utils.split64High = 0;
jspb.utils.splitUint64 = function(a) {
    var b = a >>> 0;
    a = Math.floor((a - b) / jspb.BinaryConstants.TWO_TO_32) >>> 0;
    jspb.utils.split64Low = b;
    jspb.utils.split64High = a;
};
jspb.utils.splitInt64 = function(a) {
    var b = 0 > a;
    a = Math.abs(a);
    var c = a >>> 0;
    a = Math.floor((a - c) / jspb.BinaryConstants.TWO_TO_32);
    a >>>= 0;
    b && (a = ~a >>> 0, c = (~c >>> 0) + 1, 4294967295 < c && (c = 0, a++, 4294967295 < a && (a = 0)));
    jspb.utils.split64Low = c;
    jspb.utils.split64High = a;
};
jspb.utils.splitZigzag64 = function(a) {
    var b = 0 > a;
    a = 2 * Math.abs(a);
    jspb.utils.splitUint64(a);
    a = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    b && (0 == a ? 0 == c ? c = a = 4294967295 : (c--, a = 4294967295) : a--);
    jspb.utils.split64Low = a;
    jspb.utils.split64High = c;
};
jspb.utils.splitFloat32 = function(a) {
    var b = 0 > a ? 1 : 0;
    a = b ? -a : a;
    if (0 === a) 0 < 1 / a ? (jspb.utils.split64High = 0, jspb.utils.split64Low = 0) : (jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483648);
    else if (isNaN(a)) jspb.utils.split64High = 0, jspb.utils.split64Low = 2147483647;
    else if (a > jspb.BinaryConstants.FLOAT32_MAX) jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | 2139095040) >>> 0;
    else if (a < jspb.BinaryConstants.FLOAT32_MIN) a = Math.round(a / Math.pow(2, -149)), jspb.utils.split64High = 0, jspb.utils.split64Low = (b << 31 | a) >>> 0;
    else {
        var c = Math.floor(Math.log(a) / Math.LN2);
        a *= Math.pow(2, -c);
        a = Math.round(a * jspb.BinaryConstants.TWO_TO_23) & 8388607;
        jspb.utils.split64High = 0;
        jspb.utils.split64Low = (b << 31 | c + 127 << 23 | a) >>> 0;
    }
};
jspb.utils.splitFloat64 = function(a) {
    var b = 0 > a ? 1 : 0;
    a = b ? -a : a;
    if (0 === a) jspb.utils.split64High = 0 < 1 / a ? 0 : 2147483648, jspb.utils.split64Low = 0;
    else if (isNaN(a)) jspb.utils.split64High = 2147483647, jspb.utils.split64Low = 4294967295;
    else if (a > jspb.BinaryConstants.FLOAT64_MAX) jspb.utils.split64High = (b << 31 | 2146435072) >>> 0, jspb.utils.split64Low = 0;
    else if (a < jspb.BinaryConstants.FLOAT64_MIN) {
        var c = a / Math.pow(2, -1074);
        a = c / jspb.BinaryConstants.TWO_TO_32;
        jspb.utils.split64High = (b << 31 | a) >>> 0;
        jspb.utils.split64Low = c >>> 0;
    } else {
        c = a;
        var d = 0;
        if (2 <= c) for(; 2 <= c && 1023 > d;)d++, c /= 2;
        else for(; 1 > c && -1022 < d;)c *= 2, d--;
        c = a * Math.pow(2, -d);
        a = c * jspb.BinaryConstants.TWO_TO_20 & 1048575;
        c = c * jspb.BinaryConstants.TWO_TO_52 >>> 0;
        jspb.utils.split64High = (b << 31 | d + 1023 << 20 | a) >>> 0;
        jspb.utils.split64Low = c;
    }
};
jspb.utils.splitHash64 = function(a) {
    var b = a.charCodeAt(0), c = a.charCodeAt(1), d = a.charCodeAt(2), e = a.charCodeAt(3), f = a.charCodeAt(4), g = a.charCodeAt(5), h = a.charCodeAt(6);
    a = a.charCodeAt(7);
    jspb.utils.split64Low = b + (c << 8) + (d << 16) + (e << 24) >>> 0;
    jspb.utils.split64High = f + (g << 8) + (h << 16) + (a << 24) >>> 0;
};
jspb.utils.joinUint64 = function(a, b) {
    return b * jspb.BinaryConstants.TWO_TO_32 + (a >>> 0);
};
jspb.utils.joinInt64 = function(a, b) {
    var c = b & 2147483648;
    c && (a = ~a + 1 >>> 0, b = ~b >>> 0, 0 == a && (b = b + 1 >>> 0));
    a = jspb.utils.joinUint64(a, b);
    return c ? -a : a;
};
jspb.utils.toZigzag64 = function(a, b, c) {
    var d = b >> 31;
    return c(a << 1 ^ d, (b << 1 | a >>> 31) ^ d);
};
jspb.utils.joinZigzag64 = function(a, b) {
    return jspb.utils.fromZigzag64(a, b, jspb.utils.joinInt64);
};
jspb.utils.fromZigzag64 = function(a, b, c) {
    var d = -(a & 1);
    return c((a >>> 1 | b << 31) ^ d, b >>> 1 ^ d);
};
jspb.utils.joinFloat32 = function(a, b) {
    b = 2 * (a >> 31) + 1;
    var c = a >>> 23 & 255;
    a &= 8388607;
    return 255 == c ? a ? NaN : Infinity * b : 0 == c ? b * Math.pow(2, -149) * a : b * Math.pow(2, c - 150) * (a + Math.pow(2, 23));
};
jspb.utils.joinFloat64 = function(a, b) {
    var c = 2 * (b >> 31) + 1, d = b >>> 20 & 2047;
    a = jspb.BinaryConstants.TWO_TO_32 * (b & 1048575) + a;
    return 2047 == d ? a ? NaN : Infinity * c : 0 == d ? c * Math.pow(2, -1074) * a : c * Math.pow(2, d - 1075) * (a + jspb.BinaryConstants.TWO_TO_52);
};
jspb.utils.joinHash64 = function(a, b) {
    return String.fromCharCode(a >>> 0 & 255, a >>> 8 & 255, a >>> 16 & 255, a >>> 24 & 255, b >>> 0 & 255, b >>> 8 & 255, b >>> 16 & 255, b >>> 24 & 255);
};
jspb.utils.DIGITS = "0123456789abcdef".split("");
jspb.utils.ZERO_CHAR_CODE_ = 48;
jspb.utils.A_CHAR_CODE_ = 97;
jspb.utils.joinUnsignedDecimalString = function(a, b) {
    function c(a, b) {
        a = a ? String(a) : "";
        return b ? "0000000".slice(a.length) + a : a;
    }
    if (2097151 >= b) return "" + jspb.utils.joinUint64(a, b);
    var d = (a >>> 24 | b << 8) >>> 0 & 16777215;
    b = b >> 16 & 65535;
    a = (a & 16777215) + 6777216 * d + 6710656 * b;
    d += 8147497 * b;
    b *= 2;
    1E7 <= a && (d += Math.floor(a / 1E7), a %= 1E7);
    1E7 <= d && (b += Math.floor(d / 1E7), d %= 1E7);
    return c(b, 0) + c(d, b) + c(a, 1);
};
jspb.utils.joinSignedDecimalString = function(a, b) {
    var c = b & 2147483648;
    c && (a = ~a + 1 >>> 0, b = ~b + (0 == a ? 1 : 0) >>> 0);
    a = jspb.utils.joinUnsignedDecimalString(a, b);
    return c ? "-" + a : a;
};
jspb.utils.hash64ToDecimalString = function(a, b) {
    jspb.utils.splitHash64(a);
    a = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinSignedDecimalString(a, c) : jspb.utils.joinUnsignedDecimalString(a, c);
};
jspb.utils.hash64ArrayToDecimalStrings = function(a, b) {
    for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = jspb.utils.hash64ToDecimalString(a[d], b);
    return c;
};
jspb.utils.decimalStringToHash64 = function(a) {
    function b(a, b) {
        for(var c = 0; 8 > c && (1 !== a || 0 < b); c++)b = a * e[c] + b, e[c] = b & 255, b >>>= 8;
    }
    function c() {
        for(var a = 0; 8 > a; a++)e[a] = ~e[a] & 255;
    }
    goog.asserts.assert(0 < a.length);
    var d = !1;
    "-" === a[0] && (d = !0, a = a.slice(1));
    for(var e = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], f = 0; f < a.length; f++)b(10, a.charCodeAt(f) - jspb.utils.ZERO_CHAR_CODE_);
    d && (c(), b(1, 1));
    return goog.crypt.byteArrayToString(e);
};
jspb.utils.splitDecimalString = function(a) {
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));
};
jspb.utils.toHexDigit_ = function(a) {
    return String.fromCharCode(10 > a ? jspb.utils.ZERO_CHAR_CODE_ + a : jspb.utils.A_CHAR_CODE_ - 10 + a);
};
jspb.utils.fromHexCharCode_ = function(a) {
    return a >= jspb.utils.A_CHAR_CODE_ ? a - jspb.utils.A_CHAR_CODE_ + 10 : a - jspb.utils.ZERO_CHAR_CODE_;
};
jspb.utils.hash64ToHexString = function(a) {
    var b = Array(18);
    b[0] = "0";
    b[1] = "x";
    for(var c = 0; 8 > c; c++){
        var d = a.charCodeAt(7 - c);
        b[2 * c + 2] = jspb.utils.toHexDigit_(d >> 4);
        b[2 * c + 3] = jspb.utils.toHexDigit_(d & 15);
    }
    return b.join("");
};
jspb.utils.hexStringToHash64 = function(a) {
    a = a.toLowerCase();
    goog.asserts.assert(18 == a.length);
    goog.asserts.assert("0" == a[0]);
    goog.asserts.assert("x" == a[1]);
    for(var b = "", c = 0; 8 > c; c++){
        var d = jspb.utils.fromHexCharCode_(a.charCodeAt(2 * c + 2)), e = jspb.utils.fromHexCharCode_(a.charCodeAt(2 * c + 3));
        b = String.fromCharCode(16 * d + e) + b;
    }
    return b;
};
jspb.utils.hash64ToNumber = function(a, b) {
    jspb.utils.splitHash64(a);
    a = jspb.utils.split64Low;
    var c = jspb.utils.split64High;
    return b ? jspb.utils.joinInt64(a, c) : jspb.utils.joinUint64(a, c);
};
jspb.utils.numberToHash64 = function(a) {
    jspb.utils.splitInt64(a);
    return jspb.utils.joinHash64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.utils.countVarints = function(a, b, c) {
    for(var d = 0, e = b; e < c; e++)d += a[e] >> 7;
    return c - b - d;
};
jspb.utils.countVarintFields = function(a, b, c, d) {
    var e = 0;
    d = 8 * d + jspb.BinaryConstants.WireType.VARINT;
    if (128 > d) for(; b < c && a[b++] == d;)for(e++;;){
        var f = a[b++];
        if (0 == (f & 128)) break;
    }
    else for(; b < c;){
        for(f = d; 128 < f;){
            if (a[b] != (f & 127 | 128)) return e;
            b++;
            f >>= 7;
        }
        if (a[b++] != f) break;
        for(e++; f = a[b++], 0 != (f & 128););
    }
    return e;
};
jspb.utils.countFixedFields_ = function(a, b, c, d, e) {
    var f = 0;
    if (128 > d) for(; b < c && a[b++] == d;)f++, b += e;
    else for(; b < c;){
        for(var g = d; 128 < g;){
            if (a[b++] != (g & 127 | 128)) return f;
            g >>= 7;
        }
        if (a[b++] != g) break;
        f++;
        b += e;
    }
    return f;
};
jspb.utils.countFixed32Fields = function(a, b, c, d) {
    return jspb.utils.countFixedFields_(a, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED32, 4);
};
jspb.utils.countFixed64Fields = function(a, b, c, d) {
    return jspb.utils.countFixedFields_(a, b, c, 8 * d + jspb.BinaryConstants.WireType.FIXED64, 8);
};
jspb.utils.countDelimitedFields = function(a, b, c, d) {
    var e = 0;
    for(d = 8 * d + jspb.BinaryConstants.WireType.DELIMITED; b < c;){
        for(var f = d; 128 < f;){
            if (a[b++] != (f & 127 | 128)) return e;
            f >>= 7;
        }
        if (a[b++] != f) break;
        e++;
        for(var g = 0, h = 1; f = a[b++], g += (f & 127) * h, h *= 128, 0 != (f & 128););
        b += g;
    }
    return e;
};
jspb.utils.debugBytesToTextFormat = function(a) {
    var b = '"';
    if (a) {
        a = jspb.utils.byteSourceToUint8Array(a);
        for(var c = 0; c < a.length; c++)b += "\\x", 16 > a[c] && (b += "0"), b += a[c].toString(16);
    }
    return b + '"';
};
jspb.utils.debugScalarToTextFormat = function(a) {
    return "string" === typeof a ? goog.string.quote(a) : a.toString();
};
jspb.utils.stringToByteArray = function(a) {
    for(var b = new Uint8Array(a.length), c = 0; c < a.length; c++){
        var d = a.charCodeAt(c);
        if (255 < d) throw Error("Conversion error: string contains codepoint outside of byte range");
        b[c] = d;
    }
    return b;
};
jspb.utils.byteSourceToUint8Array = function(a) {
    if (a.constructor === Uint8Array) return a;
    if (a.constructor === ArrayBuffer || "undefined" != typeof $206bdb841ab18954$require$Buffer && a.constructor === $206bdb841ab18954$require$Buffer || a.constructor === Array) return new Uint8Array(a);
    if (a.constructor === String) return goog.crypt.base64.decodeStringToUint8Array(a);
    goog.asserts.fail("Type not convertible to Uint8Array.");
    return new Uint8Array(0);
};
jspb.BinaryDecoder = function(a, b, c) {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = !1;
    a && this.setBlock(a, b, c);
};
jspb.BinaryDecoder.instanceCache_ = [];
jspb.BinaryDecoder.alloc = function(a, b, c) {
    if (jspb.BinaryDecoder.instanceCache_.length) {
        var d = jspb.BinaryDecoder.instanceCache_.pop();
        a && d.setBlock(a, b, c);
        return d;
    }
    return new jspb.BinaryDecoder(a, b, c);
};
jspb.BinaryDecoder.prototype.free = function() {
    this.clear();
    100 > jspb.BinaryDecoder.instanceCache_.length && jspb.BinaryDecoder.instanceCache_.push(this);
};
jspb.BinaryDecoder.prototype.clone = function() {
    return jspb.BinaryDecoder.alloc(this.bytes_, this.start_, this.end_ - this.start_);
};
jspb.BinaryDecoder.prototype.clear = function() {
    this.bytes_ = null;
    this.cursor_ = this.end_ = this.start_ = 0;
    this.error_ = !1;
};
jspb.BinaryDecoder.prototype.getBuffer = function() {
    return this.bytes_;
};
jspb.BinaryDecoder.prototype.setBlock = function(a, b, c) {
    this.bytes_ = jspb.utils.byteSourceToUint8Array(a);
    this.start_ = void 0 !== b ? b : 0;
    this.end_ = void 0 !== c ? this.start_ + c : this.bytes_.length;
    this.cursor_ = this.start_;
};
jspb.BinaryDecoder.prototype.getEnd = function() {
    return this.end_;
};
jspb.BinaryDecoder.prototype.setEnd = function(a) {
    this.end_ = a;
};
jspb.BinaryDecoder.prototype.reset = function() {
    this.cursor_ = this.start_;
};
jspb.BinaryDecoder.prototype.getCursor = function() {
    return this.cursor_;
};
jspb.BinaryDecoder.prototype.setCursor = function(a) {
    this.cursor_ = a;
};
jspb.BinaryDecoder.prototype.advance = function(a) {
    this.cursor_ += a;
    goog.asserts.assert(this.cursor_ <= this.end_);
};
jspb.BinaryDecoder.prototype.atEnd = function() {
    return this.cursor_ == this.end_;
};
jspb.BinaryDecoder.prototype.pastEnd = function() {
    return this.cursor_ > this.end_;
};
jspb.BinaryDecoder.prototype.getError = function() {
    return this.error_ || 0 > this.cursor_ || this.cursor_ > this.end_;
};
jspb.BinaryDecoder.prototype.readSplitVarint64 = function(a) {
    for(var b = 128, c = 0, d = 0, e = 0; 4 > e && 128 <= b; e++)b = this.bytes_[this.cursor_++], c |= (b & 127) << 7 * e;
    128 <= b && (b = this.bytes_[this.cursor_++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b) for(e = 0; 5 > e && 128 <= b; e++)b = this.bytes_[this.cursor_++], d |= (b & 127) << 7 * e + 3;
    if (128 > b) return a(c >>> 0, d >>> 0);
    goog.asserts.fail("Failed to read varint, encoding is invalid.");
    this.error_ = !0;
};
jspb.BinaryDecoder.prototype.readSplitZigzagVarint64 = function(a) {
    return this.readSplitVarint64(function(b, c) {
        return jspb.utils.fromZigzag64(b, c, a);
    });
};
jspb.BinaryDecoder.prototype.readSplitFixed64 = function(a) {
    var b = this.bytes_, c = this.cursor_;
    this.cursor_ += 8;
    for(var d = 0, e = 0, f = c + 7; f >= c; f--)d = d << 8 | b[f], e = e << 8 | b[f + 4];
    return a(d, e);
};
jspb.BinaryDecoder.prototype.skipVarint = function() {
    for(; this.bytes_[this.cursor_] & 128;)this.cursor_++;
    this.cursor_++;
};
jspb.BinaryDecoder.prototype.unskipVarint = function(a) {
    for(; 128 < a;)this.cursor_--, a >>>= 7;
    this.cursor_--;
};
jspb.BinaryDecoder.prototype.readUnsignedVarint32 = function() {
    var a = this.bytes_;
    var b = a[this.cursor_ + 0];
    var c = b & 127;
    if (128 > b) return this.cursor_ += 1, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a[this.cursor_ + 1];
    c |= (b & 127) << 7;
    if (128 > b) return this.cursor_ += 2, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a[this.cursor_ + 2];
    c |= (b & 127) << 14;
    if (128 > b) return this.cursor_ += 3, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a[this.cursor_ + 3];
    c |= (b & 127) << 21;
    if (128 > b) return this.cursor_ += 4, goog.asserts.assert(this.cursor_ <= this.end_), c;
    b = a[this.cursor_ + 4];
    c |= (b & 15) << 28;
    if (128 > b) return this.cursor_ += 5, goog.asserts.assert(this.cursor_ <= this.end_), c >>> 0;
    this.cursor_ += 5;
    128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && 128 <= a[this.cursor_++] && goog.asserts.assert(!1);
    goog.asserts.assert(this.cursor_ <= this.end_);
    return c;
};
jspb.BinaryDecoder.prototype.readSignedVarint32 = jspb.BinaryDecoder.prototype.readUnsignedVarint32;
jspb.BinaryDecoder.prototype.readUnsignedVarint32String = function() {
    return this.readUnsignedVarint32().toString();
};
jspb.BinaryDecoder.prototype.readSignedVarint32String = function() {
    return this.readSignedVarint32().toString();
};
jspb.BinaryDecoder.prototype.readZigzagVarint32 = function() {
    var a = this.readUnsignedVarint32();
    return a >>> 1 ^ -(a & 1);
};
jspb.BinaryDecoder.prototype.readUnsignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinUint64);
};
jspb.BinaryDecoder.prototype.readUnsignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinUnsignedDecimalString);
};
jspb.BinaryDecoder.prototype.readSignedVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinInt64);
};
jspb.BinaryDecoder.prototype.readSignedVarint64String = function() {
    return this.readSplitVarint64(jspb.utils.joinSignedDecimalString);
};
jspb.BinaryDecoder.prototype.readZigzagVarint64 = function() {
    return this.readSplitVarint64(jspb.utils.joinZigzag64);
};
jspb.BinaryDecoder.prototype.readZigzagVarintHash64 = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinHash64);
};
jspb.BinaryDecoder.prototype.readZigzagVarint64String = function() {
    return this.readSplitZigzagVarint64(jspb.utils.joinSignedDecimalString);
};
jspb.BinaryDecoder.prototype.readUint8 = function() {
    var a = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a;
};
jspb.BinaryDecoder.prototype.readUint16 = function() {
    var a = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a << 0 | b << 8;
};
jspb.BinaryDecoder.prototype.readUint32 = function() {
    var a = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
};
jspb.BinaryDecoder.prototype.readUint64 = function() {
    var a = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUint64(a, b);
};
jspb.BinaryDecoder.prototype.readUint64String = function() {
    var a = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinUnsignedDecimalString(a, b);
};
jspb.BinaryDecoder.prototype.readInt8 = function() {
    var a = this.bytes_[this.cursor_ + 0];
    this.cursor_ += 1;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a << 24 >> 24;
};
jspb.BinaryDecoder.prototype.readInt16 = function() {
    var a = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1];
    this.cursor_ += 2;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return (a << 0 | b << 8) << 16 >> 16;
};
jspb.BinaryDecoder.prototype.readInt32 = function() {
    var a = this.bytes_[this.cursor_ + 0], b = this.bytes_[this.cursor_ + 1], c = this.bytes_[this.cursor_ + 2], d = this.bytes_[this.cursor_ + 3];
    this.cursor_ += 4;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return a << 0 | b << 8 | c << 16 | d << 24;
};
jspb.BinaryDecoder.prototype.readInt64 = function() {
    var a = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinInt64(a, b);
};
jspb.BinaryDecoder.prototype.readInt64String = function() {
    var a = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinSignedDecimalString(a, b);
};
jspb.BinaryDecoder.prototype.readFloat = function() {
    var a = this.readUint32();
    return jspb.utils.joinFloat32(a, 0);
};
jspb.BinaryDecoder.prototype.readDouble = function() {
    var a = this.readUint32(), b = this.readUint32();
    return jspb.utils.joinFloat64(a, b);
};
jspb.BinaryDecoder.prototype.readBool = function() {
    return !!this.bytes_[this.cursor_++];
};
jspb.BinaryDecoder.prototype.readEnum = function() {
    return this.readSignedVarint32();
};
jspb.BinaryDecoder.prototype.readString = function(a) {
    var b = this.bytes_, c = this.cursor_;
    a = c + a;
    for(var d = [], e = ""; c < a;){
        var f = b[c++];
        if (128 > f) d.push(f);
        else if (192 > f) continue;
        else if (224 > f) {
            var g = b[c++];
            d.push((f & 31) << 6 | g & 63);
        } else if (240 > f) {
            g = b[c++];
            var h = b[c++];
            d.push((f & 15) << 12 | (g & 63) << 6 | h & 63);
        } else if (248 > f) {
            g = b[c++];
            h = b[c++];
            var k = b[c++];
            f = (f & 7) << 18 | (g & 63) << 12 | (h & 63) << 6 | k & 63;
            f -= 65536;
            d.push((f >> 10 & 1023) + 55296, (f & 1023) + 56320);
        }
        8192 <= d.length && (e += String.fromCharCode.apply(null, d), d.length = 0);
    }
    e += goog.crypt.byteArrayToString(d);
    this.cursor_ = c;
    return e;
};
jspb.BinaryDecoder.prototype.readStringWithLength = function() {
    var a = this.readUnsignedVarint32();
    return this.readString(a);
};
jspb.BinaryDecoder.prototype.readBytes = function(a) {
    if (0 > a || this.cursor_ + a > this.bytes_.length) return this.error_ = !0, goog.asserts.fail("Invalid byte length!"), new Uint8Array(0);
    var b = this.bytes_.subarray(this.cursor_, this.cursor_ + a);
    this.cursor_ += a;
    goog.asserts.assert(this.cursor_ <= this.end_);
    return b;
};
jspb.BinaryDecoder.prototype.readVarintHash64 = function() {
    return this.readSplitVarint64(jspb.utils.joinHash64);
};
jspb.BinaryDecoder.prototype.readFixedHash64 = function() {
    var a = this.bytes_, b = this.cursor_, c = a[b + 0], d = a[b + 1], e = a[b + 2], f = a[b + 3], g = a[b + 4], h = a[b + 5], k = a[b + 6];
    a = a[b + 7];
    this.cursor_ += 8;
    return String.fromCharCode(c, d, e, f, g, h, k, a);
};
jspb.BinaryReader = function(a, b, c) {
    this.decoder_ = jspb.BinaryDecoder.alloc(a, b, c);
    this.fieldCursor_ = this.decoder_.getCursor();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = !1;
    this.readCallbacks_ = null;
};
jspb.BinaryReader.instanceCache_ = [];
jspb.BinaryReader.alloc = function(a, b, c) {
    if (jspb.BinaryReader.instanceCache_.length) {
        var d = jspb.BinaryReader.instanceCache_.pop();
        a && d.decoder_.setBlock(a, b, c);
        return d;
    }
    return new jspb.BinaryReader(a, b, c);
};
jspb.BinaryReader.prototype.alloc = jspb.BinaryReader.alloc;
jspb.BinaryReader.prototype.free = function() {
    this.decoder_.clear();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
    this.error_ = !1;
    this.readCallbacks_ = null;
    100 > jspb.BinaryReader.instanceCache_.length && jspb.BinaryReader.instanceCache_.push(this);
};
jspb.BinaryReader.prototype.getFieldCursor = function() {
    return this.fieldCursor_;
};
jspb.BinaryReader.prototype.getCursor = function() {
    return this.decoder_.getCursor();
};
jspb.BinaryReader.prototype.getBuffer = function() {
    return this.decoder_.getBuffer();
};
jspb.BinaryReader.prototype.getFieldNumber = function() {
    return this.nextField_;
};
jspb.BinaryReader.prototype.getWireType = function() {
    return this.nextWireType_;
};
jspb.BinaryReader.prototype.isDelimited = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED;
};
jspb.BinaryReader.prototype.isEndGroup = function() {
    return this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP;
};
jspb.BinaryReader.prototype.getError = function() {
    return this.error_ || this.decoder_.getError();
};
jspb.BinaryReader.prototype.setBlock = function(a, b, c) {
    this.decoder_.setBlock(a, b, c);
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
};
jspb.BinaryReader.prototype.reset = function() {
    this.decoder_.reset();
    this.nextField_ = jspb.BinaryConstants.INVALID_FIELD_NUMBER;
    this.nextWireType_ = jspb.BinaryConstants.WireType.INVALID;
};
jspb.BinaryReader.prototype.advance = function(a) {
    this.decoder_.advance(a);
};
jspb.BinaryReader.prototype.nextField = function() {
    if (this.decoder_.atEnd()) return !1;
    if (this.getError()) return goog.asserts.fail("Decoder hit an error"), !1;
    this.fieldCursor_ = this.decoder_.getCursor();
    var a = this.decoder_.readUnsignedVarint32(), b = a >>> 3;
    a &= 7;
    if (a != jspb.BinaryConstants.WireType.VARINT && a != jspb.BinaryConstants.WireType.FIXED32 && a != jspb.BinaryConstants.WireType.FIXED64 && a != jspb.BinaryConstants.WireType.DELIMITED && a != jspb.BinaryConstants.WireType.START_GROUP && a != jspb.BinaryConstants.WireType.END_GROUP) return goog.asserts.fail("Invalid wire type: %s (at position %s)", a, this.fieldCursor_), this.error_ = !0, !1;
    this.nextField_ = b;
    this.nextWireType_ = a;
    return !0;
};
jspb.BinaryReader.prototype.unskipHeader = function() {
    this.decoder_.unskipVarint(this.nextField_ << 3 | this.nextWireType_);
};
jspb.BinaryReader.prototype.skipMatchingFields = function() {
    var a = this.nextField_;
    for(this.unskipHeader(); this.nextField() && this.getFieldNumber() == a;)this.skipField();
    this.decoder_.atEnd() || this.unskipHeader();
};
jspb.BinaryReader.prototype.skipVarintField = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.VARINT ? (goog.asserts.fail("Invalid wire type for skipVarintField"), this.skipField()) : this.decoder_.skipVarint();
};
jspb.BinaryReader.prototype.skipDelimitedField = function() {
    if (this.nextWireType_ != jspb.BinaryConstants.WireType.DELIMITED) goog.asserts.fail("Invalid wire type for skipDelimitedField"), this.skipField();
    else {
        var a = this.decoder_.readUnsignedVarint32();
        this.decoder_.advance(a);
    }
};
jspb.BinaryReader.prototype.skipFixed32Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED32 ? (goog.asserts.fail("Invalid wire type for skipFixed32Field"), this.skipField()) : this.decoder_.advance(4);
};
jspb.BinaryReader.prototype.skipFixed64Field = function() {
    this.nextWireType_ != jspb.BinaryConstants.WireType.FIXED64 ? (goog.asserts.fail("Invalid wire type for skipFixed64Field"), this.skipField()) : this.decoder_.advance(8);
};
jspb.BinaryReader.prototype.skipGroup = function() {
    var a = this.nextField_;
    do {
        if (!this.nextField()) {
            goog.asserts.fail("Unmatched start-group tag: stream EOF");
            this.error_ = !0;
            break;
        }
        if (this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP) {
            this.nextField_ != a && (goog.asserts.fail("Unmatched end-group tag"), this.error_ = !0);
            break;
        }
        this.skipField();
    }while (1);
};
jspb.BinaryReader.prototype.skipField = function() {
    switch(this.nextWireType_){
        case jspb.BinaryConstants.WireType.VARINT:
            this.skipVarintField();
            break;
        case jspb.BinaryConstants.WireType.FIXED64:
            this.skipFixed64Field();
            break;
        case jspb.BinaryConstants.WireType.DELIMITED:
            this.skipDelimitedField();
            break;
        case jspb.BinaryConstants.WireType.FIXED32:
            this.skipFixed32Field();
            break;
        case jspb.BinaryConstants.WireType.START_GROUP:
            this.skipGroup();
            break;
        default:
            goog.asserts.fail("Invalid wire encoding for field.");
    }
};
jspb.BinaryReader.prototype.registerReadCallback = function(a, b) {
    null === this.readCallbacks_ && (this.readCallbacks_ = {});
    goog.asserts.assert(!this.readCallbacks_[a]);
    this.readCallbacks_[a] = b;
};
jspb.BinaryReader.prototype.runReadCallback = function(a) {
    goog.asserts.assert(null !== this.readCallbacks_);
    a = this.readCallbacks_[a];
    goog.asserts.assert(a);
    return a(this);
};
jspb.BinaryReader.prototype.readAny = function(a) {
    this.nextWireType_ = jspb.BinaryConstants.FieldTypeToWireType(a);
    var b = jspb.BinaryConstants.FieldType;
    switch(a){
        case b.DOUBLE:
            return this.readDouble();
        case b.FLOAT:
            return this.readFloat();
        case b.INT64:
            return this.readInt64();
        case b.UINT64:
            return this.readUint64();
        case b.INT32:
            return this.readInt32();
        case b.FIXED64:
            return this.readFixed64();
        case b.FIXED32:
            return this.readFixed32();
        case b.BOOL:
            return this.readBool();
        case b.STRING:
            return this.readString();
        case b.GROUP:
            goog.asserts.fail("Group field type not supported in readAny()");
        case b.MESSAGE:
            goog.asserts.fail("Message field type not supported in readAny()");
        case b.BYTES:
            return this.readBytes();
        case b.UINT32:
            return this.readUint32();
        case b.ENUM:
            return this.readEnum();
        case b.SFIXED32:
            return this.readSfixed32();
        case b.SFIXED64:
            return this.readSfixed64();
        case b.SINT32:
            return this.readSint32();
        case b.SINT64:
            return this.readSint64();
        case b.FHASH64:
            return this.readFixedHash64();
        case b.VHASH64:
            return this.readVarintHash64();
        default:
            goog.asserts.fail("Invalid field type in readAny()");
    }
    return 0;
};
jspb.BinaryReader.prototype.readMessage = function(a, b) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var c = this.decoder_.getEnd(), d = this.decoder_.readUnsignedVarint32();
    d = this.decoder_.getCursor() + d;
    this.decoder_.setEnd(d);
    b(a, this);
    this.decoder_.setCursor(d);
    this.decoder_.setEnd(c);
};
jspb.BinaryReader.prototype.readGroup = function(a, b, c) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.START_GROUP);
    goog.asserts.assert(this.nextField_ == a);
    c(b, this);
    this.error_ || this.nextWireType_ == jspb.BinaryConstants.WireType.END_GROUP || (goog.asserts.fail("Group submessage did not end with an END_GROUP tag"), this.error_ = !0);
};
jspb.BinaryReader.prototype.getFieldDecoder = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a = this.decoder_.readUnsignedVarint32(), b = this.decoder_.getCursor(), c = b + a;
    a = jspb.BinaryDecoder.alloc(this.decoder_.getBuffer(), b, a);
    this.decoder_.setCursor(c);
    return a;
};
jspb.BinaryReader.prototype.readInt32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32();
};
jspb.BinaryReader.prototype.readInt32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint32String();
};
jspb.BinaryReader.prototype.readInt64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
};
jspb.BinaryReader.prototype.readInt64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64String();
};
jspb.BinaryReader.prototype.readUint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32();
};
jspb.BinaryReader.prototype.readUint32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint32String();
};
jspb.BinaryReader.prototype.readUint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64();
};
jspb.BinaryReader.prototype.readUint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readUnsignedVarint64String();
};
jspb.BinaryReader.prototype.readSint32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint32();
};
jspb.BinaryReader.prototype.readSint64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64();
};
jspb.BinaryReader.prototype.readSint64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarint64String();
};
jspb.BinaryReader.prototype.readFixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readUint32();
};
jspb.BinaryReader.prototype.readFixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64();
};
jspb.BinaryReader.prototype.readFixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readUint64String();
};
jspb.BinaryReader.prototype.readSfixed32 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32();
};
jspb.BinaryReader.prototype.readSfixed32String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readInt32().toString();
};
jspb.BinaryReader.prototype.readSfixed64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64();
};
jspb.BinaryReader.prototype.readSfixed64String = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readInt64String();
};
jspb.BinaryReader.prototype.readFloat = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED32);
    return this.decoder_.readFloat();
};
jspb.BinaryReader.prototype.readDouble = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readDouble();
};
jspb.BinaryReader.prototype.readBool = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return !!this.decoder_.readUnsignedVarint32();
};
jspb.BinaryReader.prototype.readEnum = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSignedVarint64();
};
jspb.BinaryReader.prototype.readString = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readString(a);
};
jspb.BinaryReader.prototype.readBytes = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var a = this.decoder_.readUnsignedVarint32();
    return this.decoder_.readBytes(a);
};
jspb.BinaryReader.prototype.readVarintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readVarintHash64();
};
jspb.BinaryReader.prototype.readSintHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readZigzagVarintHash64();
};
jspb.BinaryReader.prototype.readSplitVarint64 = function(a) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(a);
};
jspb.BinaryReader.prototype.readSplitZigzagVarint64 = function(a) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.VARINT);
    return this.decoder_.readSplitVarint64(function(b, c) {
        return jspb.utils.fromZigzag64(b, c, a);
    });
};
jspb.BinaryReader.prototype.readFixedHash64 = function() {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readFixedHash64();
};
jspb.BinaryReader.prototype.readSplitFixed64 = function(a) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.FIXED64);
    return this.decoder_.readSplitFixed64(a);
};
jspb.BinaryReader.prototype.readPackedField_ = function(a) {
    goog.asserts.assert(this.nextWireType_ == jspb.BinaryConstants.WireType.DELIMITED);
    var b = this.decoder_.readUnsignedVarint32();
    b = this.decoder_.getCursor() + b;
    for(var c = []; this.decoder_.getCursor() < b;)c.push(a.call(this.decoder_));
    return c;
};
jspb.BinaryReader.prototype.readPackedInt32 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32);
};
jspb.BinaryReader.prototype.readPackedInt32String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint32String);
};
jspb.BinaryReader.prototype.readPackedInt64 = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64);
};
jspb.BinaryReader.prototype.readPackedInt64String = function() {
    return this.readPackedField_(this.decoder_.readSignedVarint64String);
};
jspb.BinaryReader.prototype.readPackedUint32 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32);
};
jspb.BinaryReader.prototype.readPackedUint32String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint32String);
};
jspb.BinaryReader.prototype.readPackedUint64 = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64);
};
jspb.BinaryReader.prototype.readPackedUint64String = function() {
    return this.readPackedField_(this.decoder_.readUnsignedVarint64String);
};
jspb.BinaryReader.prototype.readPackedSint32 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint32);
};
jspb.BinaryReader.prototype.readPackedSint64 = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64);
};
jspb.BinaryReader.prototype.readPackedSint64String = function() {
    return this.readPackedField_(this.decoder_.readZigzagVarint64String);
};
jspb.BinaryReader.prototype.readPackedFixed32 = function() {
    return this.readPackedField_(this.decoder_.readUint32);
};
jspb.BinaryReader.prototype.readPackedFixed64 = function() {
    return this.readPackedField_(this.decoder_.readUint64);
};
jspb.BinaryReader.prototype.readPackedFixed64String = function() {
    return this.readPackedField_(this.decoder_.readUint64String);
};
jspb.BinaryReader.prototype.readPackedSfixed32 = function() {
    return this.readPackedField_(this.decoder_.readInt32);
};
jspb.BinaryReader.prototype.readPackedSfixed64 = function() {
    return this.readPackedField_(this.decoder_.readInt64);
};
jspb.BinaryReader.prototype.readPackedSfixed64String = function() {
    return this.readPackedField_(this.decoder_.readInt64String);
};
jspb.BinaryReader.prototype.readPackedFloat = function() {
    return this.readPackedField_(this.decoder_.readFloat);
};
jspb.BinaryReader.prototype.readPackedDouble = function() {
    return this.readPackedField_(this.decoder_.readDouble);
};
jspb.BinaryReader.prototype.readPackedBool = function() {
    return this.readPackedField_(this.decoder_.readBool);
};
jspb.BinaryReader.prototype.readPackedEnum = function() {
    return this.readPackedField_(this.decoder_.readEnum);
};
jspb.BinaryReader.prototype.readPackedVarintHash64 = function() {
    return this.readPackedField_(this.decoder_.readVarintHash64);
};
jspb.BinaryReader.prototype.readPackedFixedHash64 = function() {
    return this.readPackedField_(this.decoder_.readFixedHash64);
};
jspb.BinaryEncoder = function() {
    this.buffer_ = [];
};
jspb.BinaryEncoder.prototype.length = function() {
    return this.buffer_.length;
};
jspb.BinaryEncoder.prototype.end = function() {
    var a = this.buffer_;
    this.buffer_ = [];
    return a;
};
jspb.BinaryEncoder.prototype.writeSplitVarint64 = function(a, b) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);
    for(goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32); 0 < b || 127 < a;)this.buffer_.push(a & 127 | 128), a = (a >>> 7 | b << 25) >>> 0, b >>>= 7;
    this.buffer_.push(a);
};
jspb.BinaryEncoder.prototype.writeSplitFixed64 = function(a, b) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(b == Math.floor(b));
    goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);
    goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32);
    this.writeUint32(a);
    this.writeUint32(b);
};
jspb.BinaryEncoder.prototype.writeUnsignedVarint32 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    for(goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32); 127 < a;)this.buffer_.push(a & 127 | 128), a >>>= 7;
    this.buffer_.push(a);
};
jspb.BinaryEncoder.prototype.writeSignedVarint32 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
    if (0 <= a) this.writeUnsignedVarint32(a);
    else {
        for(var b = 0; 9 > b; b++)this.buffer_.push(a & 127 | 128), a >>= 7;
        this.buffer_.push(1);
    }
};
jspb.BinaryEncoder.prototype.writeUnsignedVarint64 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitInt64(a);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeSignedVarint64 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeZigzagVarint32 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
    this.writeUnsignedVarint32((a << 1 ^ a >> 31) >>> 0);
};
jspb.BinaryEncoder.prototype.writeZigzagVarint64 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitZigzag64(a);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeZigzagVarint64String = function(a) {
    this.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(a));
};
jspb.BinaryEncoder.prototype.writeZigzagVarintHash64 = function(a) {
    var b = this;
    jspb.utils.splitHash64(a);
    jspb.utils.toZigzag64(jspb.utils.split64Low, jspb.utils.split64High, function(a, d) {
        b.writeSplitVarint64(a >>> 0, d >>> 0);
    });
};
jspb.BinaryEncoder.prototype.writeUint8 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(0 <= a && 256 > a);
    this.buffer_.push(a >>> 0 & 255);
};
jspb.BinaryEncoder.prototype.writeUint16 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(0 <= a && 65536 > a);
    this.buffer_.push(a >>> 0 & 255);
    this.buffer_.push(a >>> 8 & 255);
};
jspb.BinaryEncoder.prototype.writeUint32 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_32);
    this.buffer_.push(a >>> 0 & 255);
    this.buffer_.push(a >>> 8 & 255);
    this.buffer_.push(a >>> 16 & 255);
    this.buffer_.push(a >>> 24 & 255);
};
jspb.BinaryEncoder.prototype.writeUint64 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(0 <= a && a < jspb.BinaryConstants.TWO_TO_64);
    jspb.utils.splitUint64(a);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeInt8 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(-128 <= a && 128 > a);
    this.buffer_.push(a >>> 0 & 255);
};
jspb.BinaryEncoder.prototype.writeInt16 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(-32768 <= a && 32768 > a);
    this.buffer_.push(a >>> 0 & 255);
    this.buffer_.push(a >>> 8 & 255);
};
jspb.BinaryEncoder.prototype.writeInt32 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
    this.buffer_.push(a >>> 0 & 255);
    this.buffer_.push(a >>> 8 & 255);
    this.buffer_.push(a >>> 16 & 255);
    this.buffer_.push(a >>> 24 & 255);
};
jspb.BinaryEncoder.prototype.writeInt64 = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_63 && a < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitInt64(a);
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeInt64String = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(+a >= -jspb.BinaryConstants.TWO_TO_63 && +a < jspb.BinaryConstants.TWO_TO_63);
    jspb.utils.splitHash64(jspb.utils.decimalStringToHash64(a));
    this.writeSplitFixed64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeFloat = function(a) {
    goog.asserts.assert(Infinity === a || -Infinity === a || isNaN(a) || a >= -jspb.BinaryConstants.FLOAT32_MAX && a <= jspb.BinaryConstants.FLOAT32_MAX);
    jspb.utils.splitFloat32(a);
    this.writeUint32(jspb.utils.split64Low);
};
jspb.BinaryEncoder.prototype.writeDouble = function(a) {
    goog.asserts.assert(Infinity === a || -Infinity === a || isNaN(a) || a >= -jspb.BinaryConstants.FLOAT64_MAX && a <= jspb.BinaryConstants.FLOAT64_MAX);
    jspb.utils.splitFloat64(a);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeBool = function(a) {
    goog.asserts.assert("boolean" === typeof a || "number" === typeof a);
    this.buffer_.push(a ? 1 : 0);
};
jspb.BinaryEncoder.prototype.writeEnum = function(a) {
    goog.asserts.assert(a == Math.floor(a));
    goog.asserts.assert(a >= -jspb.BinaryConstants.TWO_TO_31 && a < jspb.BinaryConstants.TWO_TO_31);
    this.writeSignedVarint32(a);
};
jspb.BinaryEncoder.prototype.writeBytes = function(a) {
    this.buffer_.push.apply(this.buffer_, a);
};
jspb.BinaryEncoder.prototype.writeVarintHash64 = function(a) {
    jspb.utils.splitHash64(a);
    this.writeSplitVarint64(jspb.utils.split64Low, jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeFixedHash64 = function(a) {
    jspb.utils.splitHash64(a);
    this.writeUint32(jspb.utils.split64Low);
    this.writeUint32(jspb.utils.split64High);
};
jspb.BinaryEncoder.prototype.writeString = function(a) {
    for(var b = this.buffer_.length, c = 0; c < a.length; c++){
        var d = a.charCodeAt(c);
        if (128 > d) this.buffer_.push(d);
        else if (2048 > d) this.buffer_.push(d >> 6 | 192), this.buffer_.push(d & 63 | 128);
        else if (65536 > d) {
            if (55296 <= d && 56319 >= d && c + 1 < a.length) {
                var e = a.charCodeAt(c + 1);
                56320 <= e && 57343 >= e && (d = 1024 * (d - 55296) + e - 56320 + 65536, this.buffer_.push(d >> 18 | 240), this.buffer_.push(d >> 12 & 63 | 128), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128), c++);
            } else this.buffer_.push(d >> 12 | 224), this.buffer_.push(d >> 6 & 63 | 128), this.buffer_.push(d & 63 | 128);
        }
    }
    return this.buffer_.length - b;
};
jspb.arith = {};
jspb.arith.UInt64 = function(a, b) {
    this.lo = a;
    this.hi = b;
};
jspb.arith.UInt64.prototype.cmp = function(a) {
    return this.hi < a.hi || this.hi == a.hi && this.lo < a.lo ? -1 : this.hi == a.hi && this.lo == a.lo ? 0 : 1;
};
jspb.arith.UInt64.prototype.rightShift = function() {
    return new jspb.arith.UInt64((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
};
jspb.arith.UInt64.prototype.leftShift = function() {
    return new jspb.arith.UInt64(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
};
jspb.arith.UInt64.prototype.msb = function() {
    return !!(this.hi & 2147483648);
};
jspb.arith.UInt64.prototype.lsb = function() {
    return !!(this.lo & 1);
};
jspb.arith.UInt64.prototype.zero = function() {
    return 0 == this.lo && 0 == this.hi;
};
jspb.arith.UInt64.prototype.add = function(a) {
    return new jspb.arith.UInt64((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
};
jspb.arith.UInt64.prototype.sub = function(a) {
    return new jspb.arith.UInt64((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
};
jspb.arith.UInt64.mul32x32 = function(a, b) {
    var c = a & 65535;
    a >>>= 16;
    var d = b & 65535, e = b >>> 16;
    b = c * d + 65536 * (c * e & 65535) + 65536 * (a * d & 65535);
    for(c = a * e + (c * e >>> 16) + (a * d >>> 16); 4294967296 <= b;)b -= 4294967296, c += 1;
    return new jspb.arith.UInt64(b >>> 0, c >>> 0);
};
jspb.arith.UInt64.prototype.mul = function(a) {
    var b = jspb.arith.UInt64.mul32x32(this.lo, a);
    a = jspb.arith.UInt64.mul32x32(this.hi, a);
    a.hi = a.lo;
    a.lo = 0;
    return b.add(a);
};
jspb.arith.UInt64.prototype.div = function(a) {
    if (0 == a) return [];
    var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(this.lo, this.hi);
    a = new jspb.arith.UInt64(a, 0);
    for(var d = new jspb.arith.UInt64(1, 0); !a.msb();)a = a.leftShift(), d = d.leftShift();
    for(; !d.zero();)0 >= a.cmp(c) && (b = b.add(d), c = c.sub(a)), a = a.rightShift(), d = d.rightShift();
    return [
        b,
        c
    ];
};
jspb.arith.UInt64.prototype.toString = function() {
    for(var a = "", b = this; !b.zero();){
        b = b.div(10);
        var c = b[0];
        a = b[1].lo + a;
        b = c;
    }
    "" == a && (a = "0");
    return a;
};
jspb.arith.UInt64.fromString = function(a) {
    for(var b = new jspb.arith.UInt64(0, 0), c = new jspb.arith.UInt64(0, 0), d = 0; d < a.length; d++){
        if ("0" > a[d] || "9" < a[d]) return null;
        var e = parseInt(a[d], 10);
        c.lo = e;
        b = b.mul(10).add(c);
    }
    return b;
};
jspb.arith.UInt64.prototype.clone = function() {
    return new jspb.arith.UInt64(this.lo, this.hi);
};
jspb.arith.Int64 = function(a, b) {
    this.lo = a;
    this.hi = b;
};
jspb.arith.Int64.prototype.add = function(a) {
    return new jspb.arith.Int64((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
};
jspb.arith.Int64.prototype.sub = function(a) {
    return new jspb.arith.Int64((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
};
jspb.arith.Int64.prototype.clone = function() {
    return new jspb.arith.Int64(this.lo, this.hi);
};
jspb.arith.Int64.prototype.toString = function() {
    var a = 0 != (this.hi & 2147483648), b = new jspb.arith.UInt64(this.lo, this.hi);
    a && (b = new jspb.arith.UInt64(0, 0).sub(b));
    return (a ? "-" : "") + b.toString();
};
jspb.arith.Int64.fromString = function(a) {
    var b = 0 < a.length && "-" == a[0];
    b && (a = a.substring(1));
    a = jspb.arith.UInt64.fromString(a);
    if (null === a) return null;
    b && (a = new jspb.arith.UInt64(0, 0).sub(a));
    return new jspb.arith.Int64(a.lo, a.hi);
};
jspb.BinaryWriter = function() {
    this.blocks_ = [];
    this.totalLength_ = 0;
    this.encoder_ = new jspb.BinaryEncoder;
    this.bookmarks_ = [];
};
jspb.BinaryWriter.prototype.appendUint8Array_ = function(a) {
    var b = this.encoder_.end();
    this.blocks_.push(b);
    this.blocks_.push(a);
    this.totalLength_ += b.length + a.length;
};
jspb.BinaryWriter.prototype.beginDelimited_ = function(a) {
    this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED);
    a = this.encoder_.end();
    this.blocks_.push(a);
    this.totalLength_ += a.length;
    a.push(this.totalLength_);
    return a;
};
jspb.BinaryWriter.prototype.endDelimited_ = function(a) {
    var b = a.pop();
    b = this.totalLength_ + this.encoder_.length() - b;
    for(goog.asserts.assert(0 <= b); 127 < b;)a.push(b & 127 | 128), b >>>= 7, this.totalLength_++;
    a.push(b);
    this.totalLength_++;
};
jspb.BinaryWriter.prototype.writeSerializedMessage = function(a, b, c) {
    this.appendUint8Array_(a.subarray(b, c));
};
jspb.BinaryWriter.prototype.maybeWriteSerializedMessage = function(a, b, c) {
    null != a && null != b && null != c && this.writeSerializedMessage(a, b, c);
};
jspb.BinaryWriter.prototype.reset = function() {
    this.blocks_ = [];
    this.encoder_.end();
    this.totalLength_ = 0;
    this.bookmarks_ = [];
};
jspb.BinaryWriter.prototype.getResultBuffer = function() {
    goog.asserts.assert(0 == this.bookmarks_.length);
    for(var a = new Uint8Array(this.totalLength_ + this.encoder_.length()), b = this.blocks_, c = b.length, d = 0, e = 0; e < c; e++){
        var f = b[e];
        a.set(f, d);
        d += f.length;
    }
    b = this.encoder_.end();
    a.set(b, d);
    d += b.length;
    goog.asserts.assert(d == a.length);
    this.blocks_ = [
        a
    ];
    return a;
};
jspb.BinaryWriter.prototype.getResultBase64String = function(a) {
    return goog.crypt.base64.encodeByteArray(this.getResultBuffer(), a);
};
jspb.BinaryWriter.prototype.beginSubMessage = function(a) {
    this.bookmarks_.push(this.beginDelimited_(a));
};
jspb.BinaryWriter.prototype.endSubMessage = function() {
    goog.asserts.assert(0 <= this.bookmarks_.length);
    this.endDelimited_(this.bookmarks_.pop());
};
jspb.BinaryWriter.prototype.writeFieldHeader_ = function(a, b) {
    goog.asserts.assert(1 <= a && a == Math.floor(a));
    this.encoder_.writeUnsignedVarint32(8 * a + b);
};
jspb.BinaryWriter.prototype.writeAny = function(a, b, c) {
    var d = jspb.BinaryConstants.FieldType;
    switch(a){
        case d.DOUBLE:
            this.writeDouble(b, c);
            break;
        case d.FLOAT:
            this.writeFloat(b, c);
            break;
        case d.INT64:
            this.writeInt64(b, c);
            break;
        case d.UINT64:
            this.writeUint64(b, c);
            break;
        case d.INT32:
            this.writeInt32(b, c);
            break;
        case d.FIXED64:
            this.writeFixed64(b, c);
            break;
        case d.FIXED32:
            this.writeFixed32(b, c);
            break;
        case d.BOOL:
            this.writeBool(b, c);
            break;
        case d.STRING:
            this.writeString(b, c);
            break;
        case d.GROUP:
            goog.asserts.fail("Group field type not supported in writeAny()");
            break;
        case d.MESSAGE:
            goog.asserts.fail("Message field type not supported in writeAny()");
            break;
        case d.BYTES:
            this.writeBytes(b, c);
            break;
        case d.UINT32:
            this.writeUint32(b, c);
            break;
        case d.ENUM:
            this.writeEnum(b, c);
            break;
        case d.SFIXED32:
            this.writeSfixed32(b, c);
            break;
        case d.SFIXED64:
            this.writeSfixed64(b, c);
            break;
        case d.SINT32:
            this.writeSint32(b, c);
            break;
        case d.SINT64:
            this.writeSint64(b, c);
            break;
        case d.FHASH64:
            this.writeFixedHash64(b, c);
            break;
        case d.VHASH64:
            this.writeVarintHash64(b, c);
            break;
        default:
            goog.asserts.fail("Invalid field type in writeAny()");
    }
};
jspb.BinaryWriter.prototype.writeUnsignedVarint32_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint32(b));
};
jspb.BinaryWriter.prototype.writeSignedVarint32_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
};
jspb.BinaryWriter.prototype.writeUnsignedVarint64_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeUnsignedVarint64(b));
};
jspb.BinaryWriter.prototype.writeSignedVarint64_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint64(b));
};
jspb.BinaryWriter.prototype.writeZigzagVarint32_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint32(b));
};
jspb.BinaryWriter.prototype.writeZigzagVarint64_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64(b));
};
jspb.BinaryWriter.prototype.writeZigzagVarint64String_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarint64String(b));
};
jspb.BinaryWriter.prototype.writeZigzagVarintHash64_ = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeZigzagVarintHash64(b));
};
jspb.BinaryWriter.prototype.writeInt32 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a, b));
};
jspb.BinaryWriter.prototype.writeInt32String = function(a, b) {
    null != b && (b = parseInt(b, 10), goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeSignedVarint32_(a, b));
};
jspb.BinaryWriter.prototype.writeInt64 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeSignedVarint64_(a, b));
};
jspb.BinaryWriter.prototype.writeInt64String = function(a, b) {
    null != b && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
};
jspb.BinaryWriter.prototype.writeUint32 = function(a, b) {
    null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a, b));
};
jspb.BinaryWriter.prototype.writeUint32String = function(a, b) {
    null != b && (b = parseInt(b, 10), goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeUnsignedVarint32_(a, b));
};
jspb.BinaryWriter.prototype.writeUint64 = function(a, b) {
    null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeUnsignedVarint64_(a, b));
};
jspb.BinaryWriter.prototype.writeUint64String = function(a, b) {
    null != b && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSplitVarint64(b.lo, b.hi));
};
jspb.BinaryWriter.prototype.writeSint32 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeZigzagVarint32_(a, b));
};
jspb.BinaryWriter.prototype.writeSint64 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeZigzagVarint64_(a, b));
};
jspb.BinaryWriter.prototype.writeSintHash64 = function(a, b) {
    null != b && this.writeZigzagVarintHash64_(a, b);
};
jspb.BinaryWriter.prototype.writeSint64String = function(a, b) {
    null != b && this.writeZigzagVarint64String_(a, b);
};
jspb.BinaryWriter.prototype.writeFixed32 = function(a, b) {
    null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_32), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeUint32(b));
};
jspb.BinaryWriter.prototype.writeFixed64 = function(a, b) {
    null != b && (goog.asserts.assert(0 <= b && b < jspb.BinaryConstants.TWO_TO_64), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeUint64(b));
};
jspb.BinaryWriter.prototype.writeFixed64String = function(a, b) {
    null != b && (b = jspb.arith.UInt64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
};
jspb.BinaryWriter.prototype.writeSfixed32 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeInt32(b));
};
jspb.BinaryWriter.prototype.writeSfixed64 = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_63 && b < jspb.BinaryConstants.TWO_TO_63), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeInt64(b));
};
jspb.BinaryWriter.prototype.writeSfixed64String = function(a, b) {
    null != b && (b = jspb.arith.Int64.fromString(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeSplitFixed64(b.lo, b.hi));
};
jspb.BinaryWriter.prototype.writeFloat = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED32), this.encoder_.writeFloat(b));
};
jspb.BinaryWriter.prototype.writeDouble = function(a, b) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeDouble(b));
};
jspb.BinaryWriter.prototype.writeBool = function(a, b) {
    null != b && (goog.asserts.assert("boolean" === typeof b || "number" === typeof b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeBool(b));
};
jspb.BinaryWriter.prototype.writeEnum = function(a, b) {
    null != b && (goog.asserts.assert(b >= -jspb.BinaryConstants.TWO_TO_31 && b < jspb.BinaryConstants.TWO_TO_31), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(b));
};
jspb.BinaryWriter.prototype.writeString = function(a, b) {
    null != b && (a = this.beginDelimited_(a), this.encoder_.writeString(b), this.endDelimited_(a));
};
jspb.BinaryWriter.prototype.writeBytes = function(a, b) {
    null != b && (b = jspb.utils.byteSourceToUint8Array(b), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), this.appendUint8Array_(b));
};
jspb.BinaryWriter.prototype.writeMessage = function(a, b, c) {
    null != b && (a = this.beginDelimited_(a), c(b, this), this.endDelimited_(a));
};
jspb.BinaryWriter.prototype.writeMessageSet = function(a, b, c) {
    null != b && (this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.START_GROUP), this.writeFieldHeader_(2, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeSignedVarint32(a), a = this.beginDelimited_(3), c(b, this), this.endDelimited_(a), this.writeFieldHeader_(1, jspb.BinaryConstants.WireType.END_GROUP));
};
jspb.BinaryWriter.prototype.writeGroup = function(a, b, c) {
    null != b && (this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.START_GROUP), c(b, this), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.END_GROUP));
};
jspb.BinaryWriter.prototype.writeFixedHash64 = function(a, b) {
    null != b && (goog.asserts.assert(8 == b.length), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64), this.encoder_.writeFixedHash64(b));
};
jspb.BinaryWriter.prototype.writeVarintHash64 = function(a, b) {
    null != b && (goog.asserts.assert(8 == b.length), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT), this.encoder_.writeVarintHash64(b));
};
jspb.BinaryWriter.prototype.writeSplitFixed64 = function(a, b, c) {
    this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.FIXED64);
    this.encoder_.writeSplitFixed64(b, c);
};
jspb.BinaryWriter.prototype.writeSplitVarint64 = function(a, b, c) {
    this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT);
    this.encoder_.writeSplitVarint64(b, c);
};
jspb.BinaryWriter.prototype.writeSplitZigzagVarint64 = function(a, b, c) {
    this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.VARINT);
    var d = this.encoder_;
    jspb.utils.toZigzag64(b, c, function(a, b) {
        d.writeSplitVarint64(a >>> 0, b >>> 0);
    });
};
jspb.BinaryWriter.prototype.writeRepeatedInt32 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeSignedVarint32_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedInt32String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeInt32String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedInt64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeSignedVarint64_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSplitFixed64 = function(a, b, c, d) {
    if (null != b) for(var e = 0; e < b.length; e++)this.writeSplitFixed64(a, c(b[e]), d(b[e]));
};
jspb.BinaryWriter.prototype.writeRepeatedSplitVarint64 = function(a, b, c, d) {
    if (null != b) for(var e = 0; e < b.length; e++)this.writeSplitVarint64(a, c(b[e]), d(b[e]));
};
jspb.BinaryWriter.prototype.writeRepeatedSplitZigzagVarint64 = function(a, b, c, d) {
    if (null != b) for(var e = 0; e < b.length; e++)this.writeSplitZigzagVarint64(a, c(b[e]), d(b[e]));
};
jspb.BinaryWriter.prototype.writeRepeatedInt64String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeInt64String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedUint32 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeUnsignedVarint32_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedUint32String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeUint32String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedUint64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeUnsignedVarint64_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedUint64String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeUint64String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSint32 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeZigzagVarint32_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSint64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeZigzagVarint64_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSint64String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeZigzagVarint64String_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSintHash64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeZigzagVarintHash64_(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedFixed32 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeFixed32(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedFixed64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeFixed64(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedFixed64String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeFixed64String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSfixed32 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeSfixed32(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSfixed64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeSfixed64(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedSfixed64String = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeSfixed64String(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedFloat = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeFloat(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedDouble = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeDouble(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedBool = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeBool(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedEnum = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeEnum(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedString = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeString(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedBytes = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeBytes(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedMessage = function(a, b, c) {
    if (null != b) for(var d = 0; d < b.length; d++){
        var e = this.beginDelimited_(a);
        c(b[d], this);
        this.endDelimited_(e);
    }
};
jspb.BinaryWriter.prototype.writeRepeatedGroup = function(a, b, c) {
    if (null != b) for(var d = 0; d < b.length; d++)this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.START_GROUP), c(b[d], this), this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.END_GROUP);
};
jspb.BinaryWriter.prototype.writeRepeatedFixedHash64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeFixedHash64(a, b[c]);
};
jspb.BinaryWriter.prototype.writeRepeatedVarintHash64 = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.writeVarintHash64(a, b[c]);
};
jspb.BinaryWriter.prototype.writePackedInt32 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeSignedVarint32(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedInt32String = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeSignedVarint32(parseInt(b[c], 10));
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedInt64 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeSignedVarint64(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSplitFixed64 = function(a, b, c, d) {
    if (null != b) {
        a = this.beginDelimited_(a);
        for(var e = 0; e < b.length; e++)this.encoder_.writeSplitFixed64(c(b[e]), d(b[e]));
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSplitVarint64 = function(a, b, c, d) {
    if (null != b) {
        a = this.beginDelimited_(a);
        for(var e = 0; e < b.length; e++)this.encoder_.writeSplitVarint64(c(b[e]), d(b[e]));
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSplitZigzagVarint64 = function(a, b, c, d) {
    if (null != b) {
        a = this.beginDelimited_(a);
        for(var e = this.encoder_, f = 0; f < b.length; f++)jspb.utils.toZigzag64(c(b[f]), d(b[f]), function(a, b) {
            e.writeSplitVarint64(a >>> 0, b >>> 0);
        });
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedInt64String = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++){
            var d = jspb.arith.Int64.fromString(b[c]);
            this.encoder_.writeSplitVarint64(d.lo, d.hi);
        }
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedUint32 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeUnsignedVarint32(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedUint32String = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeUnsignedVarint32(parseInt(b[c], 10));
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedUint64 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeUnsignedVarint64(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedUint64String = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++){
            var d = jspb.arith.UInt64.fromString(b[c]);
            this.encoder_.writeSplitVarint64(d.lo, d.hi);
        }
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSint32 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeZigzagVarint32(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSint64 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeZigzagVarint64(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSint64String = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeZigzagVarintHash64(jspb.utils.decimalStringToHash64(b[c]));
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedSintHash64 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeZigzagVarintHash64(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedFixed32 = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++)this.encoder_.writeUint32(b[a]);
};
jspb.BinaryWriter.prototype.writePackedFixed64 = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++)this.encoder_.writeUint64(b[a]);
};
jspb.BinaryWriter.prototype.writePackedFixed64String = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++){
        var c = jspb.arith.UInt64.fromString(b[a]);
        this.encoder_.writeSplitFixed64(c.lo, c.hi);
    }
};
jspb.BinaryWriter.prototype.writePackedSfixed32 = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++)this.encoder_.writeInt32(b[a]);
};
jspb.BinaryWriter.prototype.writePackedSfixed64 = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++)this.encoder_.writeInt64(b[a]);
};
jspb.BinaryWriter.prototype.writePackedSfixed64String = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++)this.encoder_.writeInt64String(b[a]);
};
jspb.BinaryWriter.prototype.writePackedFloat = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(4 * b.length), a = 0; a < b.length; a++)this.encoder_.writeFloat(b[a]);
};
jspb.BinaryWriter.prototype.writePackedDouble = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++)this.encoder_.writeDouble(b[a]);
};
jspb.BinaryWriter.prototype.writePackedBool = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(b.length), a = 0; a < b.length; a++)this.encoder_.writeBool(b[a]);
};
jspb.BinaryWriter.prototype.writePackedEnum = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeEnum(b[c]);
        this.endDelimited_(a);
    }
};
jspb.BinaryWriter.prototype.writePackedFixedHash64 = function(a, b) {
    if (null != b && b.length) for(this.writeFieldHeader_(a, jspb.BinaryConstants.WireType.DELIMITED), this.encoder_.writeUnsignedVarint32(8 * b.length), a = 0; a < b.length; a++)this.encoder_.writeFixedHash64(b[a]);
};
jspb.BinaryWriter.prototype.writePackedVarintHash64 = function(a, b) {
    if (null != b && b.length) {
        a = this.beginDelimited_(a);
        for(var c = 0; c < b.length; c++)this.encoder_.writeVarintHash64(b[c]);
        this.endDelimited_(a);
    }
};
jspb.Map = function(a, b) {
    this.arr_ = a;
    this.valueCtor_ = b;
    this.map_ = {};
    this.arrClean = !0;
    0 < this.arr_.length && this.loadFromArray_();
};
jspb.Map.prototype.loadFromArray_ = function() {
    for(var a = 0; a < this.arr_.length; a++){
        var b = this.arr_[a], c = b[0];
        this.map_[c.toString()] = new jspb.Map.Entry_(c, b[1]);
    }
    this.arrClean = !0;
};
jspb.Map.prototype.toArray = function() {
    if (this.arrClean) {
        if (this.valueCtor_) {
            var a = this.map_, b;
            for(b in a)if (Object.prototype.hasOwnProperty.call(a, b)) {
                var c = a[b].valueWrapper;
                c && c.toArray();
            }
        }
    } else {
        this.arr_.length = 0;
        a = this.stringKeys_();
        a.sort();
        for(b = 0; b < a.length; b++){
            var d = this.map_[a[b]];
            (c = d.valueWrapper) && c.toArray();
            this.arr_.push([
                d.key,
                d.value
            ]);
        }
        this.arrClean = !0;
    }
    return this.arr_;
};
jspb.Map.prototype.toObject = function(a, b) {
    for(var c = this.toArray(), d = [], e = 0; e < c.length; e++){
        var f = this.map_[c[e][0].toString()];
        this.wrapEntry_(f);
        var g = f.valueWrapper;
        g ? (goog.asserts.assert(b), d.push([
            f.key,
            b(a, g)
        ])) : d.push([
            f.key,
            f.value
        ]);
    }
    return d;
};
jspb.Map.fromObject = function(a, b, c) {
    b = new jspb.Map([], b);
    for(var d = 0; d < a.length; d++){
        var e = a[d][0], f = c(a[d][1]);
        b.set(e, f);
    }
    return b;
};
jspb.Map.ArrayIteratorIterable_ = function(a) {
    this.idx_ = 0;
    this.arr_ = a;
};
jspb.Map.ArrayIteratorIterable_.prototype.next = function() {
    return this.idx_ < this.arr_.length ? {
        done: !1,
        value: this.arr_[this.idx_++]
    } : {
        done: !0,
        value: void 0
    };
};
"undefined" != typeof Symbol && (jspb.Map.ArrayIteratorIterable_.prototype[Symbol.iterator] = function() {
    return this;
});
jspb.Map.prototype.getLength = function() {
    return this.stringKeys_().length;
};
jspb.Map.prototype.clear = function() {
    this.map_ = {};
    this.arrClean = !1;
};
jspb.Map.prototype.del = function(a) {
    a = a.toString();
    var b = this.map_.hasOwnProperty(a);
    delete this.map_[a];
    this.arrClean = !1;
    return b;
};
jspb.Map.prototype.getEntryList = function() {
    var a = [], b = this.stringKeys_();
    b.sort();
    for(var c = 0; c < b.length; c++){
        var d = this.map_[b[c]];
        a.push([
            d.key,
            d.value
        ]);
    }
    return a;
};
jspb.Map.prototype.entries = function() {
    var a = [], b = this.stringKeys_();
    b.sort();
    for(var c = 0; c < b.length; c++){
        var d = this.map_[b[c]];
        a.push([
            d.key,
            this.wrapEntry_(d)
        ]);
    }
    return new jspb.Map.ArrayIteratorIterable_(a);
};
jspb.Map.prototype.keys = function() {
    var a = [], b = this.stringKeys_();
    b.sort();
    for(var c = 0; c < b.length; c++)a.push(this.map_[b[c]].key);
    return new jspb.Map.ArrayIteratorIterable_(a);
};
jspb.Map.prototype.values = function() {
    var a = [], b = this.stringKeys_();
    b.sort();
    for(var c = 0; c < b.length; c++)a.push(this.wrapEntry_(this.map_[b[c]]));
    return new jspb.Map.ArrayIteratorIterable_(a);
};
jspb.Map.prototype.forEach = function(a, b) {
    var c = this.stringKeys_();
    c.sort();
    for(var d = 0; d < c.length; d++){
        var e = this.map_[c[d]];
        a.call(b, this.wrapEntry_(e), e.key, this);
    }
};
jspb.Map.prototype.set = function(a, b) {
    var c = new jspb.Map.Entry_(a);
    this.valueCtor_ ? (c.valueWrapper = b, c.value = b.toArray()) : c.value = b;
    this.map_[a.toString()] = c;
    this.arrClean = !1;
    return this;
};
jspb.Map.prototype.wrapEntry_ = function(a) {
    return this.valueCtor_ ? (a.valueWrapper || (a.valueWrapper = new this.valueCtor_(a.value)), a.valueWrapper) : a.value;
};
jspb.Map.prototype.get = function(a) {
    if (a = this.map_[a.toString()]) return this.wrapEntry_(a);
};
jspb.Map.prototype.has = function(a) {
    return a.toString() in this.map_;
};
jspb.Map.prototype.serializeBinary = function(a, b, c, d, e) {
    var f = this.stringKeys_();
    f.sort();
    for(var g = 0; g < f.length; g++){
        var h = this.map_[f[g]];
        b.beginSubMessage(a);
        c.call(b, 1, h.key);
        this.valueCtor_ ? d.call(b, 2, this.wrapEntry_(h), e) : d.call(b, 2, h.value);
        b.endSubMessage();
    }
};
jspb.Map.deserializeBinary = function(a, b, c, d, e, f, g) {
    for(; b.nextField() && !b.isEndGroup();){
        var h = b.getFieldNumber();
        1 == h ? f = c.call(b) : 2 == h && (a.valueCtor_ ? (goog.asserts.assert(e), g || (g = new a.valueCtor_), d.call(b, g, e)) : g = d.call(b));
    }
    goog.asserts.assert(void 0 != f);
    goog.asserts.assert(void 0 != g);
    a.set(f, g);
};
jspb.Map.prototype.stringKeys_ = function() {
    var a = this.map_, b = [], c;
    for(c in a)Object.prototype.hasOwnProperty.call(a, c) && b.push(c);
    return b;
};
jspb.Map.Entry_ = function(a, b) {
    this.key = a;
    this.value = b;
    this.valueWrapper = void 0;
};
jspb.ExtensionFieldInfo = function(a, b, c, d, e) {
    this.fieldIndex = a;
    this.fieldName = b;
    this.ctor = c;
    this.toObjectFn = d;
    this.isRepeated = e;
};
jspb.ExtensionFieldBinaryInfo = function(a, b, c, d, e, f) {
    this.fieldInfo = a;
    this.binaryReaderFn = b;
    this.binaryWriterFn = c;
    this.binaryMessageSerializeFn = d;
    this.binaryMessageDeserializeFn = e;
    this.isPacked = f;
};
jspb.ExtensionFieldInfo.prototype.isMessageType = function() {
    return !!this.ctor;
};
jspb.Message = function() {};
jspb.Message.GENERATE_TO_OBJECT = !0;
jspb.Message.GENERATE_FROM_OBJECT = !goog.DISALLOW_TEST_ONLY_CODE;
jspb.Message.GENERATE_TO_STRING = !0;
jspb.Message.ASSUME_LOCAL_ARRAYS = !1;
jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS = !0;
jspb.Message.SUPPORTS_UINT8ARRAY_ = "function" == typeof Uint8Array;
jspb.Message.prototype.getJsPbMessageId = function() {
    return this.messageId_;
};
jspb.Message.getIndex_ = function(a, b) {
    return b + a.arrayIndexOffset_;
};
jspb.Message.hiddenES6Property_ = function() {};
jspb.Message.getFieldNumber_ = function(a, b) {
    return b - a.arrayIndexOffset_;
};
jspb.Message.initialize = function(a, b, c, d, e, f) {
    a.wrappers_ = null;
    b || (b = c ? [
        c
    ] : []);
    a.messageId_ = c ? String(c) : void 0;
    a.arrayIndexOffset_ = 0 === c ? -1 : 0;
    a.array = b;
    jspb.Message.initPivotAndExtensionObject_(a, d);
    a.convertedPrimitiveFields_ = {};
    jspb.Message.SERIALIZE_EMPTY_TRAILING_FIELDS || (a.repeatedFields = e);
    if (e) for(b = 0; b < e.length; b++)c = e[b], c < a.pivot_ ? (c = jspb.Message.getIndex_(a, c), a.array[c] = a.array[c] || jspb.Message.EMPTY_LIST_SENTINEL_) : (jspb.Message.maybeInitEmptyExtensionObject_(a), a.extensionObject_[c] = a.extensionObject_[c] || jspb.Message.EMPTY_LIST_SENTINEL_);
    if (f && f.length) for(b = 0; b < f.length; b++)jspb.Message.computeOneofCase(a, f[b]);
};
jspb.Message.EMPTY_LIST_SENTINEL_ = goog.DEBUG && Object.freeze ? Object.freeze([]) : [];
jspb.Message.isArray_ = function(a) {
    return jspb.Message.ASSUME_LOCAL_ARRAYS ? a instanceof Array : Array.isArray(a);
};
jspb.Message.isExtensionObject_ = function(a) {
    return null !== a && "object" == typeof a && !jspb.Message.isArray_(a) && !(jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array);
};
jspb.Message.initPivotAndExtensionObject_ = function(a, b) {
    var c = a.array.length, d = -1;
    if (c && (d = c - 1, c = a.array[d], jspb.Message.isExtensionObject_(c))) {
        a.pivot_ = jspb.Message.getFieldNumber_(a, d);
        a.extensionObject_ = c;
        return;
    }
    -1 < b ? (a.pivot_ = Math.max(b, jspb.Message.getFieldNumber_(a, d + 1)), a.extensionObject_ = null) : a.pivot_ = Number.MAX_VALUE;
};
jspb.Message.maybeInitEmptyExtensionObject_ = function(a) {
    var b = jspb.Message.getIndex_(a, a.pivot_);
    a.array[b] || (a.extensionObject_ = a.array[b] = {});
};
jspb.Message.toObjectList = function(a, b, c) {
    for(var d = [], e = 0; e < a.length; e++)d[e] = b.call(a[e], c, a[e]);
    return d;
};
jspb.Message.toObjectExtension = function(a, b, c, d, e) {
    for(var f in c){
        var g = c[f], h = d.call(a, g);
        if (null != h) {
            for(var k in g.fieldName)if (g.fieldName.hasOwnProperty(k)) break;
            b[k] = g.toObjectFn ? g.isRepeated ? jspb.Message.toObjectList(h, g.toObjectFn, e) : g.toObjectFn(e, h) : h;
        }
    }
};
jspb.Message.serializeBinaryExtensions = function(a, b, c, d) {
    for(var e in c){
        var f = c[e], g = f.fieldInfo;
        if (!f.binaryWriterFn) throw Error("Message extension present that was generated without binary serialization support");
        var h = d.call(a, g);
        if (null != h) {
            if (g.isMessageType()) {
                if (f.binaryMessageSerializeFn) f.binaryWriterFn.call(b, g.fieldIndex, h, f.binaryMessageSerializeFn);
                else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
            } else f.binaryWriterFn.call(b, g.fieldIndex, h);
        }
    }
};
jspb.Message.readBinaryExtension = function(a, b, c, d, e) {
    var f = c[b.getFieldNumber()];
    if (f) {
        c = f.fieldInfo;
        if (!f.binaryReaderFn) throw Error("Deserializing extension whose generated code does not support binary format");
        if (c.isMessageType()) {
            var g = new c.ctor;
            f.binaryReaderFn.call(b, g, f.binaryMessageDeserializeFn);
        } else g = f.binaryReaderFn.call(b);
        c.isRepeated && !f.isPacked ? (b = d.call(a, c)) ? b.push(g) : e.call(a, c, [
            g
        ]) : e.call(a, c, g);
    } else b.skipField();
};
jspb.Message.getField = function(a, b) {
    if (b < a.pivot_) {
        b = jspb.Message.getIndex_(a, b);
        var c = a.array[b];
        return c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a.array[b] = [] : c;
    }
    if (a.extensionObject_) return c = a.extensionObject_[b], c === jspb.Message.EMPTY_LIST_SENTINEL_ ? a.extensionObject_[b] = [] : c;
};
jspb.Message.getRepeatedField = function(a, b) {
    return jspb.Message.getField(a, b);
};
jspb.Message.getOptionalFloatingPointField = function(a, b) {
    a = jspb.Message.getField(a, b);
    return null == a ? a : +a;
};
jspb.Message.getBooleanField = function(a, b) {
    a = jspb.Message.getField(a, b);
    return null == a ? a : !!a;
};
jspb.Message.getRepeatedFloatingPointField = function(a, b) {
    var c = jspb.Message.getRepeatedField(a, b);
    a.convertedPrimitiveFields_ || (a.convertedPrimitiveFields_ = {});
    if (!a.convertedPrimitiveFields_[b]) {
        for(var d = 0; d < c.length; d++)c[d] = +c[d];
        a.convertedPrimitiveFields_[b] = !0;
    }
    return c;
};
jspb.Message.getRepeatedBooleanField = function(a, b) {
    var c = jspb.Message.getRepeatedField(a, b);
    a.convertedPrimitiveFields_ || (a.convertedPrimitiveFields_ = {});
    if (!a.convertedPrimitiveFields_[b]) {
        for(var d = 0; d < c.length; d++)c[d] = !!c[d];
        a.convertedPrimitiveFields_[b] = !0;
    }
    return c;
};
jspb.Message.bytesAsB64 = function(a) {
    if (null == a || "string" === typeof a) return a;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array) return goog.crypt.base64.encodeByteArray(a);
    goog.asserts.fail("Cannot coerce to b64 string: " + goog.typeOf(a));
    return null;
};
jspb.Message.bytesAsU8 = function(a) {
    if (null == a || a instanceof Uint8Array) return a;
    if ("string" === typeof a) return goog.crypt.base64.decodeStringToUint8Array(a);
    goog.asserts.fail("Cannot coerce to Uint8Array: " + goog.typeOf(a));
    return null;
};
jspb.Message.bytesListAsB64 = function(a) {
    jspb.Message.assertConsistentTypes_(a);
    return a.length && "string" !== typeof a[0] ? goog.array.map(a, jspb.Message.bytesAsB64) : a;
};
jspb.Message.bytesListAsU8 = function(a) {
    jspb.Message.assertConsistentTypes_(a);
    return !a.length || a[0] instanceof Uint8Array ? a : goog.array.map(a, jspb.Message.bytesAsU8);
};
jspb.Message.assertConsistentTypes_ = function(a) {
    if (goog.DEBUG && a && 1 < a.length) {
        var b = goog.typeOf(a[0]);
        goog.array.forEach(a, function(a) {
            goog.typeOf(a) != b && goog.asserts.fail("Inconsistent type in JSPB repeated field array. Got " + goog.typeOf(a) + " expected " + b);
        });
    }
};
jspb.Message.getFieldWithDefault = function(a, b, c) {
    a = jspb.Message.getField(a, b);
    return null == a ? c : a;
};
jspb.Message.getBooleanFieldWithDefault = function(a, b, c) {
    a = jspb.Message.getBooleanField(a, b);
    return null == a ? c : a;
};
jspb.Message.getFloatingPointFieldWithDefault = function(a, b, c) {
    a = jspb.Message.getOptionalFloatingPointField(a, b);
    return null == a ? c : a;
};
jspb.Message.getFieldProto3 = jspb.Message.getFieldWithDefault;
jspb.Message.getMapField = function(a, b, c, d) {
    a.wrappers_ || (a.wrappers_ = {});
    if (b in a.wrappers_) return a.wrappers_[b];
    var e = jspb.Message.getField(a, b);
    if (!e) {
        if (c) return;
        e = [];
        jspb.Message.setField(a, b, e);
    }
    return a.wrappers_[b] = new jspb.Map(e, d);
};
jspb.Message.setField = function(a, b, c) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    b < a.pivot_ ? a.array[jspb.Message.getIndex_(a, b)] = c : (jspb.Message.maybeInitEmptyExtensionObject_(a), a.extensionObject_[b] = c);
    return a;
};
jspb.Message.setProto3IntField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
};
jspb.Message.setProto3FloatField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
};
jspb.Message.setProto3BooleanField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, !1);
};
jspb.Message.setProto3StringField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, "");
};
jspb.Message.setProto3BytesField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, "");
};
jspb.Message.setProto3EnumField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, 0);
};
jspb.Message.setProto3StringIntField = function(a, b, c) {
    return jspb.Message.setFieldIgnoringDefault_(a, b, c, "0");
};
jspb.Message.setFieldIgnoringDefault_ = function(a, b, c, d) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    c !== d ? jspb.Message.setField(a, b, c) : b < a.pivot_ ? a.array[jspb.Message.getIndex_(a, b)] = null : (jspb.Message.maybeInitEmptyExtensionObject_(a), delete a.extensionObject_[b]);
    return a;
};
jspb.Message.addToRepeatedField = function(a, b, c, d) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    b = jspb.Message.getRepeatedField(a, b);
    void 0 != d ? b.splice(d, 0, c) : b.push(c);
    return a;
};
jspb.Message.setOneofField = function(a, b, c, d) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    (c = jspb.Message.computeOneofCase(a, c)) && c !== b && void 0 !== d && (a.wrappers_ && c in a.wrappers_ && (a.wrappers_[c] = void 0), jspb.Message.setField(a, c, void 0));
    return jspb.Message.setField(a, b, d);
};
jspb.Message.computeOneofCase = function(a, b) {
    for(var c, d, e = 0; e < b.length; e++){
        var f = b[e], g = jspb.Message.getField(a, f);
        null != g && (c = f, d = g, jspb.Message.setField(a, f, void 0));
    }
    return c ? (jspb.Message.setField(a, c, d), c) : 0;
};
jspb.Message.getWrapperField = function(a, b, c, d) {
    a.wrappers_ || (a.wrappers_ = {});
    if (!a.wrappers_[c]) {
        var e = jspb.Message.getField(a, c);
        if (d || e) a.wrappers_[c] = new b(e);
    }
    return a.wrappers_[c];
};
jspb.Message.getRepeatedWrapperField = function(a, b, c) {
    jspb.Message.wrapRepeatedField_(a, b, c);
    b = a.wrappers_[c];
    b == jspb.Message.EMPTY_LIST_SENTINEL_ && (b = a.wrappers_[c] = []);
    return b;
};
jspb.Message.wrapRepeatedField_ = function(a, b, c) {
    a.wrappers_ || (a.wrappers_ = {});
    if (!a.wrappers_[c]) {
        for(var d = jspb.Message.getRepeatedField(a, c), e = [], f = 0; f < d.length; f++)e[f] = new b(d[f]);
        a.wrappers_[c] = e;
    }
};
jspb.Message.setWrapperField = function(a, b, c) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    a.wrappers_ || (a.wrappers_ = {});
    var d = c ? c.toArray() : c;
    a.wrappers_[b] = c;
    return jspb.Message.setField(a, b, d);
};
jspb.Message.setOneofWrapperField = function(a, b, c, d) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    a.wrappers_ || (a.wrappers_ = {});
    var e = d ? d.toArray() : d;
    a.wrappers_[b] = d;
    return jspb.Message.setOneofField(a, b, c, e);
};
jspb.Message.setRepeatedWrapperField = function(a, b, c) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    a.wrappers_ || (a.wrappers_ = {});
    c = c || [];
    for(var d = [], e = 0; e < c.length; e++)d[e] = c[e].toArray();
    a.wrappers_[b] = c;
    return jspb.Message.setField(a, b, d);
};
jspb.Message.addToRepeatedWrapperField = function(a, b, c, d, e) {
    jspb.Message.wrapRepeatedField_(a, d, b);
    var f = a.wrappers_[b];
    f || (f = a.wrappers_[b] = []);
    c = c ? c : new d;
    a = jspb.Message.getRepeatedField(a, b);
    void 0 != e ? (f.splice(e, 0, c), a.splice(e, 0, c.toArray())) : (f.push(c), a.push(c.toArray()));
    return c;
};
jspb.Message.toMap = function(a, b, c, d) {
    for(var e = {}, f = 0; f < a.length; f++)e[b.call(a[f])] = c ? c.call(a[f], d, a[f]) : a[f];
    return e;
};
jspb.Message.prototype.syncMapFields_ = function() {
    if (this.wrappers_) for(var a in this.wrappers_){
        var b = this.wrappers_[a];
        if (Array.isArray(b)) for(var c = 0; c < b.length; c++)b[c] && b[c].toArray();
        else b && b.toArray();
    }
};
jspb.Message.prototype.toArray = function() {
    this.syncMapFields_();
    return this.array;
};
jspb.Message.GENERATE_TO_STRING && (jspb.Message.prototype.toString = function() {
    this.syncMapFields_();
    return this.array.toString();
});
jspb.Message.prototype.getExtension = function(a) {
    if (this.extensionObject_) {
        this.wrappers_ || (this.wrappers_ = {});
        var b = a.fieldIndex;
        if (a.isRepeated) {
            if (a.isMessageType()) return this.wrappers_[b] || (this.wrappers_[b] = goog.array.map(this.extensionObject_[b] || [], function(b) {
                return new a.ctor(b);
            })), this.wrappers_[b];
        } else if (a.isMessageType()) return !this.wrappers_[b] && this.extensionObject_[b] && (this.wrappers_[b] = new a.ctor(this.extensionObject_[b])), this.wrappers_[b];
        return this.extensionObject_[b];
    }
};
jspb.Message.prototype.setExtension = function(a, b) {
    this.wrappers_ || (this.wrappers_ = {});
    jspb.Message.maybeInitEmptyExtensionObject_(this);
    var c = a.fieldIndex;
    a.isRepeated ? (b = b || [], a.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = goog.array.map(b, function(a) {
        return a.toArray();
    })) : this.extensionObject_[c] = b) : a.isMessageType() ? (this.wrappers_[c] = b, this.extensionObject_[c] = b ? b.toArray() : b) : this.extensionObject_[c] = b;
    return this;
};
jspb.Message.difference = function(a, b) {
    if (!(a instanceof b.constructor)) throw Error("Messages have different types.");
    var c = a.toArray();
    b = b.toArray();
    var d = [], e = 0, f = c.length > b.length ? c.length : b.length;
    a.getJsPbMessageId() && (d[0] = a.getJsPbMessageId(), e = 1);
    for(; e < f; e++)jspb.Message.compareFields(c[e], b[e]) || (d[e] = b[e]);
    return new a.constructor(d);
};
jspb.Message.equals = function(a, b) {
    return a == b || !(!a || !b) && a instanceof b.constructor && jspb.Message.compareFields(a.toArray(), b.toArray());
};
jspb.Message.compareExtensions = function(a, b) {
    a = a || {};
    b = b || {};
    var c = {}, d;
    for(d in a)c[d] = 0;
    for(d in b)c[d] = 0;
    for(d in c)if (!jspb.Message.compareFields(a[d], b[d])) return !1;
    return !0;
};
jspb.Message.compareFields = function(a, b) {
    if (a == b) return !0;
    if (!goog.isObject(a) || !goog.isObject(b)) return "number" === typeof a && isNaN(a) || "number" === typeof b && isNaN(b) ? String(a) == String(b) : !1;
    if (a.constructor != b.constructor) return !1;
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a.constructor === Uint8Array) {
        if (a.length != b.length) return !1;
        for(var c = 0; c < a.length; c++)if (a[c] != b[c]) return !1;
        return !0;
    }
    if (a.constructor === Array) {
        var d = void 0, e = void 0, f = Math.max(a.length, b.length);
        for(c = 0; c < f; c++){
            var g = a[c], h = b[c];
            g && g.constructor == Object && (goog.asserts.assert(void 0 === d), goog.asserts.assert(c === a.length - 1), d = g, g = void 0);
            h && h.constructor == Object && (goog.asserts.assert(void 0 === e), goog.asserts.assert(c === b.length - 1), e = h, h = void 0);
            if (!jspb.Message.compareFields(g, h)) return !1;
        }
        return d || e ? (d = d || {}, e = e || {}, jspb.Message.compareExtensions(d, e)) : !0;
    }
    if (a.constructor === Object) return jspb.Message.compareExtensions(a, b);
    throw Error("Invalid type in JSPB array");
};
jspb.Message.prototype.cloneMessage = function() {
    return jspb.Message.cloneMessage(this);
};
jspb.Message.prototype.clone = function() {
    return jspb.Message.cloneMessage(this);
};
jspb.Message.clone = function(a) {
    return jspb.Message.cloneMessage(a);
};
jspb.Message.cloneMessage = function(a) {
    return new a.constructor(jspb.Message.clone_(a.toArray()));
};
jspb.Message.copyInto = function(a, b) {
    goog.asserts.assertInstanceof(a, jspb.Message);
    goog.asserts.assertInstanceof(b, jspb.Message);
    goog.asserts.assert(a.constructor == b.constructor, "Copy source and target message should have the same type.");
    a = jspb.Message.clone(a);
    for(var c = b.toArray(), d = a.toArray(), e = c.length = 0; e < d.length; e++)c[e] = d[e];
    b.wrappers_ = a.wrappers_;
    b.extensionObject_ = a.extensionObject_;
};
jspb.Message.clone_ = function(a) {
    if (Array.isArray(a)) {
        for(var b = Array(a.length), c = 0; c < a.length; c++){
            var d = a[c];
            null != d && (b[c] = "object" == typeof d ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
        }
        return b;
    }
    if (jspb.Message.SUPPORTS_UINT8ARRAY_ && a instanceof Uint8Array) return new Uint8Array(a);
    b = {};
    for(c in a)d = a[c], null != d && (b[c] = "object" == typeof d ? jspb.Message.clone_(goog.asserts.assert(d)) : d);
    return b;
};
jspb.Message.registerMessageType = function(a, b) {
    b.messageId = a;
};
jspb.Message.messageSetExtensions = {};
jspb.Message.messageSetExtensionsBinary = {};
jspb.Export = {};
exports.Map = jspb.Map;
exports.Message = jspb.Message;
exports.BinaryReader = jspb.BinaryReader;
exports.BinaryWriter = jspb.BinaryWriter;
exports.ExtensionFieldInfo = jspb.ExtensionFieldInfo;
exports.ExtensionFieldBinaryInfo = jspb.ExtensionFieldBinaryInfo;
exports.exportSymbol = goog.exportSymbol;
exports.inherits = goog.inherits;
exports.object = {
    extend: goog.object.extend
};
exports.typeOf = goog.typeOf;

});

parcelRegister("kEUo3", function(module, exports) {
(function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = "4.17.21";
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = "__lodash_placeholder__";
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            "ary",
            WRAP_ARY_FLAG
        ],
        [
            "bind",
            WRAP_BIND_FLAG
        ],
        [
            "bindKey",
            WRAP_BIND_KEY_FLAG
        ],
        [
            "curry",
            WRAP_CURRY_FLAG
        ],
        [
            "curryRight",
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            "flip",
            WRAP_FLIP_FLAG
        ],
        [
            "partial",
            WRAP_PARTIAL_FLAG
        ],
        [
            "partialRight",
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            "rearg",
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
    var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = "\ud800-\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\ud83c[\udffb-\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
    /** Used to compose unicode regexes. */ var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [
        rsNonAstral + rsCombo + "?",
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join("|") + ")";
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, "g");
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, "g");
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [
            rsBreak,
            rsUpper,
            "$"
        ].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [
            rsBreak,
            rsUpper + rsMiscLower,
            "$"
        ].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join("|"), "g");
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        "\xc0": "A",
        "\xc1": "A",
        "\xc2": "A",
        "\xc3": "A",
        "\xc4": "A",
        "\xc5": "A",
        "\xe0": "a",
        "\xe1": "a",
        "\xe2": "a",
        "\xe3": "a",
        "\xe4": "a",
        "\xe5": "a",
        "\xc7": "C",
        "\xe7": "c",
        "\xd0": "D",
        "\xf0": "d",
        "\xc8": "E",
        "\xc9": "E",
        "\xca": "E",
        "\xcb": "E",
        "\xe8": "e",
        "\xe9": "e",
        "\xea": "e",
        "\xeb": "e",
        "\xcc": "I",
        "\xcd": "I",
        "\xce": "I",
        "\xcf": "I",
        "\xec": "i",
        "\xed": "i",
        "\xee": "i",
        "\xef": "i",
        "\xd1": "N",
        "\xf1": "n",
        "\xd2": "O",
        "\xd3": "O",
        "\xd4": "O",
        "\xd5": "O",
        "\xd6": "O",
        "\xd8": "O",
        "\xf2": "o",
        "\xf3": "o",
        "\xf4": "o",
        "\xf5": "o",
        "\xf6": "o",
        "\xf8": "o",
        "\xd9": "U",
        "\xda": "U",
        "\xdb": "U",
        "\xdc": "U",
        "\xf9": "u",
        "\xfa": "u",
        "\xfb": "u",
        "\xfc": "u",
        "\xdd": "Y",
        "\xfd": "y",
        "\xff": "y",
        "\xc6": "Ae",
        "\xe6": "ae",
        "\xde": "Th",
        "\xfe": "th",
        "\xdf": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require("util").types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty("length");
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split("");
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context["__core-js_shared__"];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
            return uid ? "Symbol(src)_1." + uid : "";
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, "defineProperty");
                func({}, "", {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object1, "create");
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, "__wrapped__")) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "escape": reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "evaluate": reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ "interpolate": reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ "variable": "",
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ "imports": {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ "_": lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                "hash": new Hash,
                "map": new (Map || ListCache),
                "string": new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)["delete"](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data["delete"](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == "__proto__" && defineProperty) defineProperty(object, key, {
                "configurable": true,
                "enumerable": true,
                "value": value,
                "writable": true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == "function") return value;
            if (value == null) return identity;
            if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack["delete"](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    "criteria": criteria,
                    "index": ++index,
                    "value": value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = "";
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + "");
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, "toString", {
                "configurable": true,
                "enumerable": false,
                "value": constant(string),
                "writable": true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == "string") return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + "";
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            object = parent(object, path);
            return object == null || delete object[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == "function" ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == "desc" ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == "wrapper") var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == "string" || typeof other == "string") {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? " " : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join("") : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != "number" && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == "string" && typeof other == "string")) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
                    pair = (toString(value) + "e").split("e");
                    return +(pair[0] + "e" + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack["delete"](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack["delete"](array);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + "";
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack["delete"](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == "constructor");
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
            }
            stack["delete"](object);
            stack["delete"](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + "");
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + "", array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case "drop":
                        start += size;
                        break;
                    case "dropRight":
                        end -= size;
                        break;
                    case "take":
                        end = nativeMin(end, start + size);
                        break;
                    case "takeRight":
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                "start": start,
                "end": end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
            details = details.join(length > 2 ? ", " : " ");
            return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === "constructor" && typeof object[key] === "function") return;
            if (key == "__proto__") return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + "";
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == "string" || isSymbol(value)) return value;
            var result = value + "";
            return result == "0" && 1 / value == -INFINITY ? "-0" : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + "";
                } catch (e) {}
            }
            return "";
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = "_." + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == "function" ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? "" : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == "function" ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == "function" ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == "function" ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                "func": thru,
                "args": [
                    interceptor
                ],
                "thisArg": undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                "done": done,
                "value": value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    "func": thru,
                    "args": [
                        reverse
                    ],
                    "thisArg": undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == "function", result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = "maxWait" in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != "function") throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != "function") throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = "leading" in options ? !!options.leading : leading;
                trailing = "trailing" in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                "leading": leading,
                "maxWait": wait,
                "trailing": trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == "number" && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == "number" && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == "object" || type == "function");
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == "object";
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
            return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == "number") return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == "function" ? value.valueOf() : value;
                value = isObject(other) ? other + "" : other;
            }
            if (typeof value != "string") return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? "" : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != "function") value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == "function" ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == "boolean") {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == "boolean") {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? "-" : "") + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst("toLowerCase");
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? "_" : "") + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$", "g");
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, "variable") && options.variable;
            if (!variable) source = "with (obj) {\n" + source + "\n}\n";
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
            // Frame code as the function body.
            source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + "return " + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join("");
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join("");
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, "");
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join("");
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = "separator" in options ? options.separator : separator;
                length = "length" in options ? toInteger(options.length) : length;
                omission = "omission" in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + "g");
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? " " : "") + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst("toUpperCase");
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != "function") throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            "func": func,
                            "args": arguments,
                            "thisArg": object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return "";
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound("ceil");
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound("floor");
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound("round");
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            "chain": false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            "bind",
            "bindKey",
            "curry",
            "curryRight",
            "partial",
            "partialRight"
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            "drop",
            "take"
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    "size": nativeMin(n, MAX_ARRAY_LENGTH),
                    "type": methodName + (result.__dir__ < 0 ? "Right" : "")
                });
                return result;
            };
            LazyWrapper.prototype[methodName + "Right"] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            "filter",
            "map",
            "takeWhile"
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    "iteratee": getIteratee(iteratee, 3),
                    "type": type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            "head",
            "last"
        ], function(methodName, index) {
            var takeName = "take" + (index ? "Right" : "");
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            "initial",
            "tail"
        ], function(methodName, index) {
            var dropName = "drop" + (index ? "" : "Right");
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == "function") return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == "function" && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        "func": thru,
                        "args": [
                            interceptor
                        ],
                        "thisArg": undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            "pop",
            "push",
            "shift",
            "sort",
            "splice",
            "unshift"
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + "";
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    "name": methodName,
                    "func": lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                "name": "wrapper",
                "func": undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("iMRgf", function(module, exports) {

var $dNfWb = parcelRequire("dNfWb");
var $dad60640805af566$require$MAX_SAFE_COMPONENT_LENGTH = $dNfWb.MAX_SAFE_COMPONENT_LENGTH;

var $aZLZv = parcelRequire("aZLZv");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const createToken = (name, value, isGlobal)=>{
    const index = R++;
    $aZLZv(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "[0-9]+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", "\\d*[a-zA-Z-][a-zA-Z0-9-]*");
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", "[0-9A-Za-z-]+");
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCE", `${"(^|[^\\d])(\\d{1,"}${$dad60640805af566$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$dad60640805af566$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$dad60640805af566$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("dNfWb", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $a0ac36d127e0d54f$var$SEMVER_SPEC_VERSION = "2.0.0";
const $a0ac36d127e0d54f$var$MAX_LENGTH = 256;
const $a0ac36d127e0d54f$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $a0ac36d127e0d54f$var$MAX_SAFE_COMPONENT_LENGTH = 16;
module.exports = {
    SEMVER_SPEC_VERSION: $a0ac36d127e0d54f$var$SEMVER_SPEC_VERSION,
    MAX_LENGTH: $a0ac36d127e0d54f$var$MAX_LENGTH,
    MAX_SAFE_INTEGER: $a0ac36d127e0d54f$var$MAX_SAFE_INTEGER,
    MAX_SAFE_COMPONENT_LENGTH: $a0ac36d127e0d54f$var$MAX_SAFE_COMPONENT_LENGTH
};

});

parcelRegister("aZLZv", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
const $8014d3eb5db09d18$var$debug = (typeof $4TNnu === "object" && $4TNnu.env && undefined, ()=>{});
module.exports = $8014d3eb5db09d18$var$debug;

});


parcelRegister("aTLS7", function(module, exports) {
"use strict";
module.exports = function(Yallist) {
    Yallist.prototype[Symbol.iterator] = function*() {
        for(let walker = this.head; walker; walker = walker.next)yield walker.value;
    };
};

});

parcelRegister("hqAsy", function(module, exports) {
(function(globalObject) {
    "use strict";
    /*
 *      bignumber.js v9.0.1
 *      A JavaScript library for arbitrary-precision arithmetic.
 *      https://github.com/MikeMcl/bignumber.js
 *      Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
 *      MIT Licensed.
 *
 *      BigNumber.prototype methods     |  BigNumber methods
 *                                      |
 *      absoluteValue            abs    |  clone
 *      comparedTo                      |  config               set
 *      decimalPlaces            dp     |      DECIMAL_PLACES
 *      dividedBy                div    |      ROUNDING_MODE
 *      dividedToIntegerBy       idiv   |      EXPONENTIAL_AT
 *      exponentiatedBy          pow    |      RANGE
 *      integerValue                    |      CRYPTO
 *      isEqualTo                eq     |      MODULO_MODE
 *      isFinite                        |      POW_PRECISION
 *      isGreaterThan            gt     |      FORMAT
 *      isGreaterThanOrEqualTo   gte    |      ALPHABET
 *      isInteger                       |  isBigNumber
 *      isLessThan               lt     |  maximum              max
 *      isLessThanOrEqualTo      lte    |  minimum              min
 *      isNaN                           |  random
 *      isNegative                      |  sum
 *      isPositive                      |
 *      isZero                          |
 *      minus                           |
 *      modulo                   mod    |
 *      multipliedBy             times  |
 *      negated                         |
 *      plus                            |
 *      precision                sd     |
 *      shiftedBy                       |
 *      squareRoot               sqrt   |
 *      toExponential                   |
 *      toFixed                         |
 *      toFormat                        |
 *      toFraction                      |
 *      toJSON                          |
 *      toNumber                        |
 *      toPrecision                     |
 *      toString                        |
 *      valueOf                         |
 *
 */ var BigNumber, isNumeric = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, mathceil = Math.ceil, mathfloor = Math.floor, bignumberError = "[BigNumber Error] ", tooManyDigits = bignumberError + "Number primitive has more than 15 significant digits: ", BASE = 1e14, LOG_BASE = 14, MAX_SAFE_INTEGER = 0x1fffffffffffff, // MAX_INT32 = 0x7fffffff,                   // 2^31 - 1
    POWS_TEN = [
        1,
        10,
        100,
        1e3,
        1e4,
        1e5,
        1e6,
        1e7,
        1e8,
        1e9,
        1e10,
        1e11,
        1e12,
        1e13
    ], SQRT_BASE = 1e7, // EDITABLE
    // The limit on the value of DECIMAL_PLACES, TO_EXP_NEG, TO_EXP_POS, MIN_EXP, MAX_EXP, and
    // the arguments to toExponential, toFixed, toFormat, and toPrecision.
    MAX = 1E9; // 0 to MAX_INT32
    /*
   * Create and return a BigNumber constructor.
   */ function clone(configObject) {
        var div, convertBase, parseNumeric, P = BigNumber.prototype = {
            constructor: BigNumber,
            toString: null,
            valueOf: null
        }, ONE = new BigNumber(1), //----------------------------- EDITABLE CONFIG DEFAULTS -------------------------------
        // The default values below must be integers within the inclusive ranges stated.
        // The values can also be changed at run-time using BigNumber.set.
        // The maximum number of decimal places for operations involving division.
        DECIMAL_PLACES = 20, // The rounding mode used when rounding to the above decimal places, and when using
        // toExponential, toFixed, toFormat and toPrecision, and round (default value).
        // UP         0 Away from zero.
        // DOWN       1 Towards zero.
        // CEIL       2 Towards +Infinity.
        // FLOOR      3 Towards -Infinity.
        // HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        ROUNDING_MODE = 4, // EXPONENTIAL_AT : [TO_EXP_NEG , TO_EXP_POS]
        // The exponent value at and beneath which toString returns exponential notation.
        // Number type: -7
        TO_EXP_NEG = -7, // The exponent value at and above which toString returns exponential notation.
        // Number type: 21
        TO_EXP_POS = 21, // RANGE : [MIN_EXP, MAX_EXP]
        // The minimum exponent value, beneath which underflow to zero occurs.
        // Number type: -324  (5e-324)
        MIN_EXP = -10000000, // The maximum exponent value, above which overflow to Infinity occurs.
        // Number type:  308  (1.7976931348623157e+308)
        // For MAX_EXP > 1e7, e.g. new BigNumber('1e100000000').plus(1) may be slow.
        MAX_EXP = 1e7, // Whether to use cryptographically-secure random number generation, if available.
        CRYPTO = false, // The modulo mode used when calculating the modulus: a mod n.
        // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
        // The remainder (r) is calculated as: r = a - n * q.
        //
        // UP        0 The remainder is positive if the dividend is negative, else is negative.
        // DOWN      1 The remainder has the same sign as the dividend.
        //             This modulo mode is commonly known as 'truncated division' and is
        //             equivalent to (a % n) in JavaScript.
        // FLOOR     3 The remainder has the same sign as the divisor (Python %).
        // HALF_EVEN 6 This modulo mode implements the IEEE 754 remainder function.
        // EUCLID    9 Euclidian division. q = sign(n) * floor(a / abs(n)).
        //             The remainder is always positive.
        //
        // The truncated division, floored division, Euclidian division and IEEE 754 remainder
        // modes are commonly used for the modulus operation.
        // Although the other rounding modes can also be used, they may not give useful results.
        MODULO_MODE = 1, // The maximum number of significant digits of the result of the exponentiatedBy operation.
        // If POW_PRECISION is 0, there will be unlimited significant digits.
        POW_PRECISION = 0, // The format specification used by the BigNumber.prototype.toFormat method.
        FORMAT = {
            prefix: "",
            groupSize: 3,
            secondaryGroupSize: 0,
            groupSeparator: ",",
            decimalSeparator: ".",
            fractionGroupSize: 0,
            fractionGroupSeparator: "\xa0",
            suffix: ""
        }, // The alphabet used for base conversion. It must be at least 2 characters long, with no '+',
        // '-', '.', whitespace, or repeated character.
        // '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ$_'
        ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
        //------------------------------------------------------------------------------------------
        // CONSTRUCTOR
        /*
     * The BigNumber constructor and exported function.
     * Create and return a new instance of a BigNumber object.
     *
     * v {number|string|BigNumber} A numeric value.
     * [b] {number} The base of v. Integer, 2 to ALPHABET.length inclusive.
     */ function BigNumber(v, b) {
            var alphabet, c, caseChanged, e, i, isNum, len, str, x = this;
            // Enable constructor call without `new`.
            if (!(x instanceof BigNumber)) return new BigNumber(v, b);
            if (b == null) {
                if (v && v._isBigNumber === true) {
                    x.s = v.s;
                    if (!v.c || v.e > MAX_EXP) x.c = x.e = null;
                    else if (v.e < MIN_EXP) x.c = [
                        x.e = 0
                    ];
                    else {
                        x.e = v.e;
                        x.c = v.c.slice();
                    }
                    return;
                }
                if ((isNum = typeof v == "number") && v * 0 == 0) {
                    // Use `1 / n` to handle minus zero also.
                    x.s = 1 / v < 0 ? (v = -v, -1) : 1;
                    // Fast path for integers, where n < 2147483648 (2**31).
                    if (v === ~~v) {
                        for(e = 0, i = v; i >= 10; i /= 10, e++);
                        if (e > MAX_EXP) x.c = x.e = null;
                        else {
                            x.e = e;
                            x.c = [
                                v
                            ];
                        }
                        return;
                    }
                    str = String(v);
                } else {
                    if (!isNumeric.test(str = String(v))) return parseNumeric(x, str, isNum);
                    x.s = str.charCodeAt(0) == 45 ? (str = str.slice(1), -1) : 1;
                }
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                // Exponential form?
                if ((i = str.search(/e/i)) > 0) {
                    // Determine exponent.
                    if (e < 0) e = i;
                    e += +str.slice(i + 1);
                    str = str.substring(0, i);
                } else if (e < 0) // Integer.
                e = str.length;
            } else {
                // '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
                intCheck(b, 2, ALPHABET.length, "Base");
                // Allow exponential notation to be used with base 10 argument, while
                // also rounding to DECIMAL_PLACES as with other bases.
                if (b == 10) {
                    x = new BigNumber(v);
                    return round(x, DECIMAL_PLACES + x.e + 1, ROUNDING_MODE);
                }
                str = String(v);
                if (isNum = typeof v == "number") {
                    // Avoid potential interpretation of Infinity and NaN as base 44+ values.
                    if (v * 0 != 0) return parseNumeric(x, str, isNum, b);
                    x.s = 1 / v < 0 ? (str = str.slice(1), -1) : 1;
                    // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                    if (BigNumber.DEBUG && str.replace(/^0\.0*|\./, "").length > 15) throw Error(tooManyDigits + v);
                } else x.s = str.charCodeAt(0) === 45 ? (str = str.slice(1), -1) : 1;
                alphabet = ALPHABET.slice(0, b);
                e = i = 0;
                // Check that str is a valid base b number.
                // Don't use RegExp, so alphabet can contain special characters.
                for(len = str.length; i < len; i++)if (alphabet.indexOf(c = str.charAt(i)) < 0) {
                    if (c == ".") // If '.' is not the first character and it has not be found before.
                    {
                        if (i > e) {
                            e = len;
                            continue;
                        }
                    } else if (!caseChanged) // Allow e.g. hexadecimal 'FF' as well as 'ff'.
                    {
                        if (str == str.toUpperCase() && (str = str.toLowerCase()) || str == str.toLowerCase() && (str = str.toUpperCase())) {
                            caseChanged = true;
                            i = -1;
                            e = 0;
                            continue;
                        }
                    }
                    return parseNumeric(x, String(v), isNum, b);
                }
                // Prevent later check for length on converted number.
                isNum = false;
                str = convertBase(str, b, 10, x.s);
                // Decimal point?
                if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
                else e = str.length;
            }
            // Determine leading zeros.
            for(i = 0; str.charCodeAt(i) === 48; i++);
            // Determine trailing zeros.
            for(len = str.length; str.charCodeAt(--len) === 48;);
            if (str = str.slice(i, ++len)) {
                len -= i;
                // '[BigNumber Error] Number primitive has more than 15 significant digits: {n}'
                if (isNum && BigNumber.DEBUG && len > 15 && (v > MAX_SAFE_INTEGER || v !== mathfloor(v))) throw Error(tooManyDigits + x.s * v);
                // Overflow?
                if ((e = e - i - 1) > MAX_EXP) // Infinity.
                x.c = x.e = null;
                else if (e < MIN_EXP) // Zero.
                x.c = [
                    x.e = 0
                ];
                else {
                    x.e = e;
                    x.c = [];
                    // Transform base
                    // e is the base 10 exponent.
                    // i is where to slice str to get the first element of the coefficient array.
                    i = (e + 1) % LOG_BASE;
                    if (e < 0) i += LOG_BASE; // i < 1
                    if (i < len) {
                        if (i) x.c.push(+str.slice(0, i));
                        for(len -= LOG_BASE; i < len;)x.c.push(+str.slice(i, i += LOG_BASE));
                        i = LOG_BASE - (str = str.slice(i)).length;
                    } else i -= len;
                    for(; i--; str += "0");
                    x.c.push(+str);
                }
            } else // Zero.
            x.c = [
                x.e = 0
            ];
        }
        // CONSTRUCTOR PROPERTIES
        BigNumber.clone = clone;
        BigNumber.ROUND_UP = 0;
        BigNumber.ROUND_DOWN = 1;
        BigNumber.ROUND_CEIL = 2;
        BigNumber.ROUND_FLOOR = 3;
        BigNumber.ROUND_HALF_UP = 4;
        BigNumber.ROUND_HALF_DOWN = 5;
        BigNumber.ROUND_HALF_EVEN = 6;
        BigNumber.ROUND_HALF_CEIL = 7;
        BigNumber.ROUND_HALF_FLOOR = 8;
        BigNumber.EUCLID = 9;
        /*
     * Configure infrequently-changing library-wide settings.
     *
     * Accept an object with the following optional properties (if the value of a property is
     * a number, it must be an integer within the inclusive range stated):
     *
     *   DECIMAL_PLACES   {number}           0 to MAX
     *   ROUNDING_MODE    {number}           0 to 8
     *   EXPONENTIAL_AT   {number|number[]}  -MAX to MAX  or  [-MAX to 0, 0 to MAX]
     *   RANGE            {number|number[]}  -MAX to MAX (not zero)  or  [-MAX to -1, 1 to MAX]
     *   CRYPTO           {boolean}          true or false
     *   MODULO_MODE      {number}           0 to 9
     *   POW_PRECISION       {number}           0 to MAX
     *   ALPHABET         {string}           A string of two or more unique characters which does
     *                                       not contain '.'.
     *   FORMAT           {object}           An object with some of the following properties:
     *     prefix                 {string}
     *     groupSize              {number}
     *     secondaryGroupSize     {number}
     *     groupSeparator         {string}
     *     decimalSeparator       {string}
     *     fractionGroupSize      {number}
     *     fractionGroupSeparator {string}
     *     suffix                 {string}
     *
     * (The values assigned to the above FORMAT object properties are not checked for validity.)
     *
     * E.g.
     * BigNumber.config({ DECIMAL_PLACES : 20, ROUNDING_MODE : 4 })
     *
     * Ignore properties/parameters set to null or undefined, except for ALPHABET.
     *
     * Return an object with the properties current values.
     */ BigNumber.config = BigNumber.set = function(obj) {
            var p, v;
            if (obj != null) {
                if (typeof obj == "object") {
                    // DECIMAL_PLACES {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] DECIMAL_PLACES {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "DECIMAL_PLACES")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        DECIMAL_PLACES = v;
                    }
                    // ROUNDING_MODE {number} Integer, 0 to 8 inclusive.
                    // '[BigNumber Error] ROUNDING_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "ROUNDING_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 8, p);
                        ROUNDING_MODE = v;
                    }
                    // EXPONENTIAL_AT {number|number[]}
                    // Integer, -MAX to MAX inclusive or
                    // [integer -MAX to 0 inclusive, 0 to MAX inclusive].
                    // '[BigNumber Error] EXPONENTIAL_AT {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "EXPONENTIAL_AT")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, 0, p);
                            intCheck(v[1], 0, MAX, p);
                            TO_EXP_NEG = v[0];
                            TO_EXP_POS = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            TO_EXP_NEG = -(TO_EXP_POS = v < 0 ? -v : v);
                        }
                    }
                    // RANGE {number|number[]} Non-zero integer, -MAX to MAX inclusive or
                    // [integer -MAX to -1 inclusive, integer 1 to MAX inclusive].
                    // '[BigNumber Error] RANGE {not a primitive number|not an integer|out of range|cannot be zero}: {v}'
                    if (obj.hasOwnProperty(p = "RANGE")) {
                        v = obj[p];
                        if (v && v.pop) {
                            intCheck(v[0], -MAX, -1, p);
                            intCheck(v[1], 1, MAX, p);
                            MIN_EXP = v[0];
                            MAX_EXP = v[1];
                        } else {
                            intCheck(v, -MAX, MAX, p);
                            if (v) MIN_EXP = -(MAX_EXP = v < 0 ? -v : v);
                            else throw Error(bignumberError + p + " cannot be zero: " + v);
                        }
                    }
                    // CRYPTO {boolean} true or false.
                    // '[BigNumber Error] CRYPTO not true or false: {v}'
                    // '[BigNumber Error] crypto unavailable'
                    if (obj.hasOwnProperty(p = "CRYPTO")) {
                        v = obj[p];
                        if (v === !!v) {
                            if (v) {
                                if (typeof crypto != "undefined" && crypto && (crypto.getRandomValues || crypto.randomBytes)) CRYPTO = v;
                                else {
                                    CRYPTO = !v;
                                    throw Error(bignumberError + "crypto unavailable");
                                }
                            } else CRYPTO = v;
                        } else throw Error(bignumberError + p + " not true or false: " + v);
                    }
                    // MODULO_MODE {number} Integer, 0 to 9 inclusive.
                    // '[BigNumber Error] MODULO_MODE {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "MODULO_MODE")) {
                        v = obj[p];
                        intCheck(v, 0, 9, p);
                        MODULO_MODE = v;
                    }
                    // POW_PRECISION {number} Integer, 0 to MAX inclusive.
                    // '[BigNumber Error] POW_PRECISION {not a primitive number|not an integer|out of range}: {v}'
                    if (obj.hasOwnProperty(p = "POW_PRECISION")) {
                        v = obj[p];
                        intCheck(v, 0, MAX, p);
                        POW_PRECISION = v;
                    }
                    // FORMAT {object}
                    // '[BigNumber Error] FORMAT not an object: {v}'
                    if (obj.hasOwnProperty(p = "FORMAT")) {
                        v = obj[p];
                        if (typeof v == "object") FORMAT = v;
                        else throw Error(bignumberError + p + " not an object: " + v);
                    }
                    // ALPHABET {string}
                    // '[BigNumber Error] ALPHABET invalid: {v}'
                    if (obj.hasOwnProperty(p = "ALPHABET")) {
                        v = obj[p];
                        // Disallow if less than two characters,
                        // or if it contains '+', '-', '.', whitespace, or a repeated character.
                        if (typeof v == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(v)) ALPHABET = v;
                        else throw Error(bignumberError + p + " invalid: " + v);
                    }
                } else // '[BigNumber Error] Object expected: {v}'
                throw Error(bignumberError + "Object expected: " + obj);
            }
            return {
                DECIMAL_PLACES: DECIMAL_PLACES,
                ROUNDING_MODE: ROUNDING_MODE,
                EXPONENTIAL_AT: [
                    TO_EXP_NEG,
                    TO_EXP_POS
                ],
                RANGE: [
                    MIN_EXP,
                    MAX_EXP
                ],
                CRYPTO: CRYPTO,
                MODULO_MODE: MODULO_MODE,
                POW_PRECISION: POW_PRECISION,
                FORMAT: FORMAT,
                ALPHABET: ALPHABET
            };
        };
        /*
     * Return true if v is a BigNumber instance, otherwise return false.
     *
     * If BigNumber.DEBUG is true, throw if a BigNumber instance is not well-formed.
     *
     * v {any}
     *
     * '[BigNumber Error] Invalid BigNumber: {v}'
     */ BigNumber.isBigNumber = function(v) {
            if (!v || v._isBigNumber !== true) return false;
            if (!BigNumber.DEBUG) return true;
            var i, n, c = v.c, e = v.e, s = v.s;
            out: if (({}).toString.call(c) == "[object Array]") {
                if ((s === 1 || s === -1) && e >= -MAX && e <= MAX && e === mathfloor(e)) {
                    // If the first element is zero, the BigNumber value must be zero.
                    if (c[0] === 0) {
                        if (e === 0 && c.length === 1) return true;
                        break out;
                    }
                    // Calculate number of digits that c[0] should have, based on the exponent.
                    i = (e + 1) % LOG_BASE;
                    if (i < 1) i += LOG_BASE;
                    // Calculate number of digits of c[0].
                    //if (Math.ceil(Math.log(c[0] + 1) / Math.LN10) == i) {
                    if (String(c[0]).length == i) {
                        for(i = 0; i < c.length; i++){
                            n = c[i];
                            if (n < 0 || n >= BASE || n !== mathfloor(n)) break out;
                        }
                        // Last element cannot be zero, unless it is the only element.
                        if (n !== 0) return true;
                    }
                }
            } else if (c === null && e === null && (s === null || s === 1 || s === -1)) return true;
            throw Error(bignumberError + "Invalid BigNumber: " + v);
        };
        /*
     * Return a new BigNumber whose value is the maximum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.maximum = BigNumber.max = function() {
            return maxOrMin(arguments, P.lt);
        };
        /*
     * Return a new BigNumber whose value is the minimum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.minimum = BigNumber.min = function() {
            return maxOrMin(arguments, P.gt);
        };
        /*
     * Return a new BigNumber with a random value equal to or greater than 0 and less than 1,
     * and with dp, or DECIMAL_PLACES if dp is omitted, decimal places (or less if trailing
     * zeros are produced).
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp}'
     * '[BigNumber Error] crypto unavailable'
     */ BigNumber.random = function() {
            var pow2_53 = 0x20000000000000;
            // Return a 53 bit integer n, where 0 <= n < 9007199254740992.
            // Check if Math.random() produces more than 32 bits of randomness.
            // If it does, assume at least 53 bits are produced, otherwise assume at least 30 bits.
            // 0x40000000 is 2^30, 0x800000 is 2^23, 0x1fffff is 2^21 - 1.
            var random53bitInt = Math.random() * pow2_53 & 0x1fffff ? function() {
                return mathfloor(Math.random() * pow2_53);
            } : function() {
                return (Math.random() * 0x40000000 | 0) * 0x800000 + (Math.random() * 0x800000 | 0);
            };
            return function(dp) {
                var a, b, e, k, v, i = 0, c = [], rand = new BigNumber(ONE);
                if (dp == null) dp = DECIMAL_PLACES;
                else intCheck(dp, 0, MAX);
                k = mathceil(dp / LOG_BASE);
                if (CRYPTO) {
                    // Browsers supporting crypto.getRandomValues.
                    if (crypto.getRandomValues) {
                        a = crypto.getRandomValues(new Uint32Array(k *= 2));
                        for(; i < k;){
                            // 53 bits:
                            // ((Math.pow(2, 32) - 1) * Math.pow(2, 21)).toString(2)
                            // 11111 11111111 11111111 11111111 11100000 00000000 00000000
                            // ((Math.pow(2, 32) - 1) >>> 11).toString(2)
                            //                                     11111 11111111 11111111
                            // 0x20000 is 2^21.
                            v = a[i] * 0x20000 + (a[i + 1] >>> 11);
                            // Rejection sampling:
                            // 0 <= v < 9007199254740992
                            // Probability that v >= 9e15, is
                            // 7199254740992 / 9007199254740992 ~= 0.0008, i.e. 1 in 1251
                            if (v >= 9e15) {
                                b = crypto.getRandomValues(new Uint32Array(2));
                                a[i] = b[0];
                                a[i + 1] = b[1];
                            } else {
                                // 0 <= v <= 8999999999999999
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 2;
                            }
                        }
                        i = k / 2;
                    // Node.js supporting crypto.randomBytes.
                    } else if (crypto.randomBytes) {
                        // buffer
                        a = crypto.randomBytes(k *= 7);
                        for(; i < k;){
                            // 0x1000000000000 is 2^48, 0x10000000000 is 2^40
                            // 0x100000000 is 2^32, 0x1000000 is 2^24
                            // 11111 11111111 11111111 11111111 11111111 11111111 11111111
                            // 0 <= v < 9007199254740992
                            v = (a[i] & 31) * 0x1000000000000 + a[i + 1] * 0x10000000000 + a[i + 2] * 0x100000000 + a[i + 3] * 0x1000000 + (a[i + 4] << 16) + (a[i + 5] << 8) + a[i + 6];
                            if (v >= 9e15) crypto.randomBytes(7).copy(a, i);
                            else {
                                // 0 <= (v % 1e14) <= 99999999999999
                                c.push(v % 1e14);
                                i += 7;
                            }
                        }
                        i = k / 7;
                    } else {
                        CRYPTO = false;
                        throw Error(bignumberError + "crypto unavailable");
                    }
                }
                // Use Math.random.
                if (!CRYPTO) for(; i < k;){
                    v = random53bitInt();
                    if (v < 9e15) c[i++] = v % 1e14;
                }
                k = c[--i];
                dp %= LOG_BASE;
                // Convert trailing digits to zeros according to dp.
                if (k && dp) {
                    v = POWS_TEN[LOG_BASE - dp];
                    c[i] = mathfloor(k / v) * v;
                }
                // Remove trailing elements which are zero.
                for(; c[i] === 0; c.pop(), i--);
                // Zero?
                if (i < 0) c = [
                    e = 0
                ];
                else {
                    // Remove leading elements which are zero and adjust exponent accordingly.
                    for(e = -1; c[0] === 0; c.splice(0, 1), e -= LOG_BASE);
                    // Count the digits of the first element of c to determine leading zeros, and...
                    for(i = 1, v = c[0]; v >= 10; v /= 10, i++);
                    // adjust the exponent accordingly.
                    if (i < LOG_BASE) e -= LOG_BASE - i;
                }
                rand.e = e;
                rand.c = c;
                return rand;
            };
        }();
        /*
     * Return a BigNumber whose value is the sum of the arguments.
     *
     * arguments {number|string|BigNumber}
     */ BigNumber.sum = function() {
            var i = 1, args = arguments, sum = new BigNumber(args[0]);
            for(; i < args.length;)sum = sum.plus(args[i++]);
            return sum;
        };
        // PRIVATE FUNCTIONS
        // Called by BigNumber and BigNumber.prototype.toString.
        convertBase = function() {
            var decimal = "0123456789";
            /*
       * Convert string of baseIn to an array of numbers of baseOut.
       * Eg. toBaseOut('255', 10, 16) returns [15, 15].
       * Eg. toBaseOut('ff', 16, 10) returns [2, 5, 5].
       */ function toBaseOut(str, baseIn, baseOut, alphabet) {
                var j, arr = [
                    0
                ], arrL, i = 0, len = str.length;
                for(; i < len;){
                    for(arrL = arr.length; arrL--; arr[arrL] *= baseIn);
                    arr[0] += alphabet.indexOf(str.charAt(i++));
                    for(j = 0; j < arr.length; j++)if (arr[j] > baseOut - 1) {
                        if (arr[j + 1] == null) arr[j + 1] = 0;
                        arr[j + 1] += arr[j] / baseOut | 0;
                        arr[j] %= baseOut;
                    }
                }
                return arr.reverse();
            }
            // Convert a numeric string of baseIn to a numeric string of baseOut.
            // If the caller is toString, we are converting from base 10 to baseOut.
            // If the caller is BigNumber, we are converting from baseIn to base 10.
            return function(str, baseIn, baseOut, sign, callerIsToString) {
                var alphabet, d, e, k, r, x, xc, y, i = str.indexOf("."), dp = DECIMAL_PLACES, rm = ROUNDING_MODE;
                // Non-integer.
                if (i >= 0) {
                    k = POW_PRECISION;
                    // Unlimited precision.
                    POW_PRECISION = 0;
                    str = str.replace(".", "");
                    y = new BigNumber(baseIn);
                    x = y.pow(str.length - i);
                    POW_PRECISION = k;
                    // Convert str as if an integer, then restore the fraction part by dividing the
                    // result by its base raised to a power.
                    y.c = toBaseOut(toFixedPoint(coeffToString(x.c), x.e, "0"), 10, baseOut, decimal);
                    y.e = y.c.length;
                }
                // Convert the number as integer.
                xc = toBaseOut(str, baseIn, baseOut, callerIsToString ? (alphabet = ALPHABET, decimal) : (alphabet = decimal, ALPHABET));
                // xc now represents str as an integer and converted to baseOut. e is the exponent.
                e = k = xc.length;
                // Remove trailing zeros.
                for(; xc[--k] == 0; xc.pop());
                // Zero?
                if (!xc[0]) return alphabet.charAt(0);
                // Does str represent an integer? If so, no need for the division.
                if (i < 0) --e;
                else {
                    x.c = xc;
                    x.e = e;
                    // The sign is needed for correct rounding.
                    x.s = sign;
                    x = div(x, y, dp, rm, baseOut);
                    xc = x.c;
                    r = x.r;
                    e = x.e;
                }
                // xc now represents str converted to baseOut.
                // THe index of the rounding digit.
                d = e + dp + 1;
                // The rounding digit: the digit to the right of the digit that may be rounded up.
                i = xc[d];
                // Look at the rounding digits and mode to determine whether to round up.
                k = baseOut / 2;
                r = r || d < 0 || xc[d + 1] != null;
                r = rm < 4 ? (i != null || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : i > k || i == k && (rm == 4 || r || rm == 6 && xc[d - 1] & 1 || rm == (x.s < 0 ? 8 : 7));
                // If the index of the rounding digit is not greater than zero, or xc represents
                // zero, then the result of the base conversion is zero or, if rounding up, a value
                // such as 0.00001.
                if (d < 1 || !xc[0]) // 1^-dp or 0
                str = r ? toFixedPoint(alphabet.charAt(1), -dp, alphabet.charAt(0)) : alphabet.charAt(0);
                else {
                    // Truncate xc to the required number of decimal places.
                    xc.length = d;
                    // Round up?
                    if (r) // Rounding up may mean the previous digit has to be rounded up and so on.
                    for(--baseOut; ++xc[--d] > baseOut;){
                        xc[d] = 0;
                        if (!d) {
                            ++e;
                            xc = [
                                1
                            ].concat(xc);
                        }
                    }
                    // Determine trailing zeros.
                    for(k = xc.length; !xc[--k];);
                    // E.g. [4, 11, 15] becomes 4bf.
                    for(i = 0, str = ""; i <= k; str += alphabet.charAt(xc[i++]));
                    // Add leading zeros, decimal point and trailing zeros as required.
                    str = toFixedPoint(str, e, alphabet.charAt(0));
                }
                // The caller will add the sign.
                return str;
            };
        }();
        // Perform division in the specified base. Called by div and convertBase.
        div = function() {
            // Assume non-zero x and k.
            function multiply(x, k, base) {
                var m, temp, xlo, xhi, carry = 0, i = x.length, klo = k % SQRT_BASE, khi = k / SQRT_BASE | 0;
                for(x = x.slice(); i--;){
                    xlo = x[i] % SQRT_BASE;
                    xhi = x[i] / SQRT_BASE | 0;
                    m = khi * xlo + xhi * klo;
                    temp = klo * xlo + m % SQRT_BASE * SQRT_BASE + carry;
                    carry = (temp / base | 0) + (m / SQRT_BASE | 0) + khi * xhi;
                    x[i] = temp % base;
                }
                if (carry) x = [
                    carry
                ].concat(x);
                return x;
            }
            function compare(a, b, aL, bL) {
                var i, cmp;
                if (aL != bL) cmp = aL > bL ? 1 : -1;
                else {
                    for(i = cmp = 0; i < aL; i++)if (a[i] != b[i]) {
                        cmp = a[i] > b[i] ? 1 : -1;
                        break;
                    }
                }
                return cmp;
            }
            function subtract(a, b, aL, base) {
                var i = 0;
                // Subtract b from a.
                for(; aL--;){
                    a[aL] -= i;
                    i = a[aL] < b[aL] ? 1 : 0;
                    a[aL] = i * base + a[aL] - b[aL];
                }
                // Remove leading zeros.
                for(; !a[0] && a.length > 1; a.splice(0, 1));
            }
            // x: dividend, y: divisor.
            return function(x, y, dp, rm, base) {
                var cmp, e, i, more, n, prod, prodL, q, qc, rem, remL, rem0, xi, xL, yc0, yL, yz, s = x.s == y.s ? 1 : -1, xc = x.c, yc = y.c;
                // Either NaN, Infinity or 0?
                if (!xc || !xc[0] || !yc || !yc[0]) return new BigNumber(// Return NaN if either NaN, or both Infinity or 0.
                !x.s || !y.s || (xc ? yc && xc[0] == yc[0] : !yc) ? NaN : // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
                xc && xc[0] == 0 || !yc ? s * 0 : s / 0);
                q = new BigNumber(s);
                qc = q.c = [];
                e = x.e - y.e;
                s = dp + e + 1;
                if (!base) {
                    base = BASE;
                    e = bitFloor(x.e / LOG_BASE) - bitFloor(y.e / LOG_BASE);
                    s = s / LOG_BASE | 0;
                }
                // Result exponent may be one less then the current value of e.
                // The coefficients of the BigNumbers from convertBase may have trailing zeros.
                for(i = 0; yc[i] == (xc[i] || 0); i++);
                if (yc[i] > (xc[i] || 0)) e--;
                if (s < 0) {
                    qc.push(1);
                    more = true;
                } else {
                    xL = xc.length;
                    yL = yc.length;
                    i = 0;
                    s += 2;
                    // Normalise xc and yc so highest order digit of yc is >= base / 2.
                    n = mathfloor(base / (yc[0] + 1));
                    // Not necessary, but to handle odd bases where yc[0] == (base / 2) - 1.
                    // if (n > 1 || n++ == 1 && yc[0] < base / 2) {
                    if (n > 1) {
                        yc = multiply(yc, n, base);
                        xc = multiply(xc, n, base);
                        yL = yc.length;
                        xL = xc.length;
                    }
                    xi = yL;
                    rem = xc.slice(0, yL);
                    remL = rem.length;
                    // Add zeros to make remainder as long as divisor.
                    for(; remL < yL; rem[remL++] = 0);
                    yz = yc.slice();
                    yz = [
                        0
                    ].concat(yz);
                    yc0 = yc[0];
                    if (yc[1] >= base / 2) yc0++;
                    // Not necessary, but to prevent trial digit n > base, when using base 3.
                    // else if (base == 3 && yc0 == 1) yc0 = 1 + 1e-15;
                    do {
                        n = 0;
                        // Compare divisor and remainder.
                        cmp = compare(yc, rem, yL, remL);
                        // If divisor < remainder.
                        if (cmp < 0) {
                            // Calculate trial digit, n.
                            rem0 = rem[0];
                            if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);
                            // n is how many times the divisor goes into the current remainder.
                            n = mathfloor(rem0 / yc0);
                            //  Algorithm:
                            //  product = divisor multiplied by trial digit (n).
                            //  Compare product and remainder.
                            //  If product is greater than remainder:
                            //    Subtract divisor from product, decrement trial digit.
                            //  Subtract product from remainder.
                            //  If product was less than remainder at the last compare:
                            //    Compare new remainder and divisor.
                            //    If remainder is greater than divisor:
                            //      Subtract divisor from remainder, increment trial digit.
                            if (n > 1) {
                                // n may be > base only when base is 3.
                                if (n >= base) n = base - 1;
                                // product = divisor * trial digit.
                                prod = multiply(yc, n, base);
                                prodL = prod.length;
                                remL = rem.length;
                                // Compare product and remainder.
                                // If product > remainder then trial digit n too high.
                                // n is 1 too high about 5% of the time, and is not known to have
                                // ever been more than 1 too high.
                                while(compare(prod, rem, prodL, remL) == 1){
                                    n--;
                                    // Subtract divisor from product.
                                    subtract(prod, yL < prodL ? yz : yc, prodL, base);
                                    prodL = prod.length;
                                    cmp = 1;
                                }
                            } else {
                                // n is 0 or 1, cmp is -1.
                                // If n is 0, there is no need to compare yc and rem again below,
                                // so change cmp to 1 to avoid it.
                                // If n is 1, leave cmp as -1, so yc and rem are compared again.
                                if (n == 0) // divisor < remainder, so n must be at least 1.
                                cmp = n = 1;
                                // product = divisor
                                prod = yc.slice();
                                prodL = prod.length;
                            }
                            if (prodL < remL) prod = [
                                0
                            ].concat(prod);
                            // Subtract product from remainder.
                            subtract(rem, prod, remL, base);
                            remL = rem.length;
                            // If product was < remainder.
                            if (cmp == -1) // Compare divisor and new remainder.
                            // If divisor < new remainder, subtract divisor from remainder.
                            // Trial digit n too low.
                            // n is 1 too low about 5% of the time, and very rarely 2 too low.
                            while(compare(yc, rem, yL, remL) < 1){
                                n++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yc, remL, base);
                                remL = rem.length;
                            }
                        } else if (cmp === 0) {
                            n++;
                            rem = [
                                0
                            ];
                        } // else cmp === 1 and n will be 0
                        // Add the next digit, n, to the result array.
                        qc[i++] = n;
                        // Update the remainder.
                        if (rem[0]) rem[remL++] = xc[xi] || 0;
                        else {
                            rem = [
                                xc[xi]
                            ];
                            remL = 1;
                        }
                    }while ((xi++ < xL || rem[0] != null) && s--);
                    more = rem[0] != null;
                    // Leading zero?
                    if (!qc[0]) qc.splice(0, 1);
                }
                if (base == BASE) {
                    // To calculate q.e, first get the number of digits of qc[0].
                    for(i = 1, s = qc[0]; s >= 10; s /= 10, i++);
                    round(q, dp + (q.e = i + e * LOG_BASE - 1) + 1, rm, more);
                // Caller is convertBase.
                } else {
                    q.e = e;
                    q.r = +more;
                }
                return q;
            };
        }();
        /*
     * Return a string representing the value of BigNumber n in fixed-point or exponential
     * notation rounded to the specified decimal places or significant digits.
     *
     * n: a BigNumber.
     * i: the index of the last digit required (i.e. the digit that may be rounded up).
     * rm: the rounding mode.
     * id: 1 (toExponential) or 2 (toPrecision).
     */ function format(n, i, rm, id) {
            var c0, e, ne, len, str;
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            if (!n.c) return n.toString();
            c0 = n.c[0];
            ne = n.e;
            if (i == null) {
                str = coeffToString(n.c);
                str = id == 1 || id == 2 && (ne <= TO_EXP_NEG || ne >= TO_EXP_POS) ? toExponential(str, ne) : toFixedPoint(str, ne, "0");
            } else {
                n = round(new BigNumber(n), i, rm);
                // n.e may have changed if the value was rounded up.
                e = n.e;
                str = coeffToString(n.c);
                len = str.length;
                // toPrecision returns exponential notation if the number of significant digits
                // specified is less than the number of digits necessary to represent the integer
                // part of the value in fixed-point notation.
                // Exponential notation.
                if (id == 1 || id == 2 && (i <= e || e <= TO_EXP_NEG)) {
                    // Append zeros?
                    for(; len < i; str += "0", len++);
                    str = toExponential(str, e);
                // Fixed-point notation.
                } else {
                    i -= ne;
                    str = toFixedPoint(str, e, "0");
                    // Append zeros?
                    if (e + 1 > len) {
                        if (--i > 0) for(str += "."; i--; str += "0");
                    } else {
                        i += e - len;
                        if (i > 0) {
                            if (e + 1 == len) str += ".";
                            for(; i--; str += "0");
                        }
                    }
                }
            }
            return n.s < 0 && c0 ? "-" + str : str;
        }
        // Handle BigNumber.max and BigNumber.min.
        function maxOrMin(args, method) {
            var n, i = 1, m = new BigNumber(args[0]);
            for(; i < args.length; i++){
                n = new BigNumber(args[i]);
                // If any number is NaN, return NaN.
                if (!n.s) {
                    m = n;
                    break;
                } else if (method.call(m, n)) m = n;
            }
            return m;
        }
        /*
     * Strip trailing zeros, calculate base 10 exponent and check against MIN_EXP and MAX_EXP.
     * Called by minus, plus and times.
     */ function normalise(n, c, e) {
            var i = 1, j = c.length;
            // Remove trailing zeros.
            for(; !c[--j]; c.pop());
            // Calculate the base 10 exponent. First get the number of digits of c[0].
            for(j = c[0]; j >= 10; j /= 10, i++);
            // Overflow?
            if ((e = i + e * LOG_BASE - 1) > MAX_EXP) // Infinity.
            n.c = n.e = null;
            else if (e < MIN_EXP) // Zero.
            n.c = [
                n.e = 0
            ];
            else {
                n.e = e;
                n.c = c;
            }
            return n;
        }
        // Handle values that fail the validity test in BigNumber.
        parseNumeric = function() {
            var basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i, dotAfter = /^([^.]+)\.$/, dotBefore = /^\.([^.]+)$/, isInfinityOrNaN = /^-?(Infinity|NaN)$/, whitespaceOrPlus = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
            return function(x, str, isNum, b) {
                var base, s = isNum ? str : str.replace(whitespaceOrPlus, "");
                // No exception on ±Infinity or NaN.
                if (isInfinityOrNaN.test(s)) x.s = isNaN(s) ? null : s < 0 ? -1 : 1;
                else {
                    if (!isNum) {
                        // basePrefix = /^(-?)0([xbo])(?=\w[\w.]*$)/i
                        s = s.replace(basePrefix, function(m, p1, p2) {
                            base = (p2 = p2.toLowerCase()) == "x" ? 16 : p2 == "b" ? 2 : 8;
                            return !b || b == base ? p1 : m;
                        });
                        if (b) {
                            base = b;
                            // E.g. '1.' to '1', '.1' to '0.1'
                            s = s.replace(dotAfter, "$1").replace(dotBefore, "0.$1");
                        }
                        if (str != s) return new BigNumber(s, base);
                    }
                    // '[BigNumber Error] Not a number: {n}'
                    // '[BigNumber Error] Not a base {b} number: {n}'
                    if (BigNumber.DEBUG) throw Error(bignumberError + "Not a" + (b ? " base " + b : "") + " number: " + str);
                    // NaN
                    x.s = null;
                }
                x.c = x.e = null;
            };
        }();
        /*
     * Round x to sd significant digits using rounding mode rm. Check for over/under-flow.
     * If r is truthy, it is known that there are more digits after the rounding digit.
     */ function round(x, sd, rm, r) {
            var d, i, j, k, n, ni, rd, xc = x.c, pows10 = POWS_TEN;
            // if x is not Infinity or NaN...
            if (xc) {
                // rd is the rounding digit, i.e. the digit after the digit that may be rounded up.
                // n is a base 1e14 number, the value of the element of array x.c containing rd.
                // ni is the index of n within x.c.
                // d is the number of digits of n.
                // i is the index of rd within n including leading zeros.
                // j is the actual index of rd within n (if < 0, rd is a leading zero).
                out: {
                    // Get the number of digits of the first element of xc.
                    for(d = 1, k = xc[0]; k >= 10; k /= 10, d++);
                    i = sd - d;
                    // If the rounding digit is in the first element of xc...
                    if (i < 0) {
                        i += LOG_BASE;
                        j = sd;
                        n = xc[ni = 0];
                        // Get the rounding digit at index j of n.
                        rd = n / pows10[d - j - 1] % 10 | 0;
                    } else {
                        ni = mathceil((i + 1) / LOG_BASE);
                        if (ni >= xc.length) {
                            if (r) {
                                // Needed by sqrt.
                                for(; xc.length <= ni; xc.push(0));
                                n = rd = 0;
                                d = 1;
                                i %= LOG_BASE;
                                j = i - LOG_BASE + 1;
                            } else break out;
                        } else {
                            n = k = xc[ni];
                            // Get the number of digits of n.
                            for(d = 1; k >= 10; k /= 10, d++);
                            // Get the index of rd within n.
                            i %= LOG_BASE;
                            // Get the index of rd within n, adjusted for leading zeros.
                            // The number of leading zeros of n is given by LOG_BASE - d.
                            j = i - LOG_BASE + d;
                            // Get the rounding digit at index j of n.
                            rd = j < 0 ? 0 : n / pows10[d - j - 1] % 10 | 0;
                        }
                    }
                    r = r || sd < 0 || // Are there any non-zero digits after the rounding digit?
                    // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
                    // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
                    xc[ni + 1] != null || (j < 0 ? n : n % pows10[d - j - 1]);
                    r = rm < 4 ? (rd || r) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || r || rm == 6 && (i > 0 ? j > 0 ? n / pows10[d - j] : 0 : xc[ni - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
                    if (sd < 1 || !xc[0]) {
                        xc.length = 0;
                        if (r) {
                            // Convert sd to decimal places.
                            sd -= x.e + 1;
                            // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                            xc[0] = pows10[(LOG_BASE - sd % LOG_BASE) % LOG_BASE];
                            x.e = -sd || 0;
                        } else // Zero.
                        xc[0] = x.e = 0;
                        return x;
                    }
                    // Remove excess digits.
                    if (i == 0) {
                        xc.length = ni;
                        k = 1;
                        ni--;
                    } else {
                        xc.length = ni + 1;
                        k = pows10[LOG_BASE - i];
                        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
                        // j > 0 means i > number of leading zeros of n.
                        xc[ni] = j > 0 ? mathfloor(n / pows10[d - j] % pows10[j]) * k : 0;
                    }
                    // Round up?
                    if (r) {
                        for(;;)// If the digit to be rounded up is in the first element of xc...
                        if (ni == 0) {
                            // i will be the length of xc[0] before k is added.
                            for(i = 1, j = xc[0]; j >= 10; j /= 10, i++);
                            j = xc[0] += k;
                            for(k = 1; j >= 10; j /= 10, k++);
                            // if i != k the length has increased.
                            if (i != k) {
                                x.e++;
                                if (xc[0] == BASE) xc[0] = 1;
                            }
                            break;
                        } else {
                            xc[ni] += k;
                            if (xc[ni] != BASE) break;
                            xc[ni--] = 0;
                            k = 1;
                        }
                    }
                    // Remove trailing zeros.
                    for(i = xc.length; xc[--i] === 0; xc.pop());
                }
                // Overflow? Infinity.
                if (x.e > MAX_EXP) x.c = x.e = null;
                else if (x.e < MIN_EXP) x.c = [
                    x.e = 0
                ];
            }
            return x;
        }
        function valueOf(n) {
            var str, e = n.e;
            if (e === null) return n.toString();
            str = coeffToString(n.c);
            str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(str, e) : toFixedPoint(str, e, "0");
            return n.s < 0 ? "-" + str : str;
        }
        // PROTOTYPE/INSTANCE METHODS
        /*
     * Return a new BigNumber whose value is the absolute value of this BigNumber.
     */ P.absoluteValue = P.abs = function() {
            var x = new BigNumber(this);
            if (x.s < 0) x.s = 1;
            return x;
        };
        /*
     * Return
     *   1 if the value of this BigNumber is greater than the value of BigNumber(y, b),
     *   -1 if the value of this BigNumber is less than the value of BigNumber(y, b),
     *   0 if they have the same value,
     *   or null if the value of either is NaN.
     */ P.comparedTo = function(y, b) {
            return compare(this, new BigNumber(y, b));
        };
        /*
     * If dp is undefined or null or true or false, return the number of decimal places of the
     * value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     *
     * Otherwise, if dp is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of dp decimal places using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * [dp] {number} Decimal places: integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.decimalPlaces = P.dp = function(dp, rm) {
            var c, n, v, x = this;
            if (dp != null) {
                intCheck(dp, 0, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), dp + x.e + 1, rm);
            }
            if (!(c = x.c)) return null;
            n = ((v = c.length - 1) - bitFloor(this.e / LOG_BASE)) * LOG_BASE;
            // Subtract the number of trailing zeros of the last number.
            if (v = c[v]) for(; v % 10 == 0; v /= 10, n--);
            if (n < 0) n = 0;
            return n;
        };
        /*
     *  n / 0 = I
     *  n / N = N
     *  n / I = 0
     *  0 / n = 0
     *  0 / 0 = N
     *  0 / N = N
     *  0 / I = 0
     *  N / n = N
     *  N / 0 = N
     *  N / N = N
     *  N / I = N
     *  I / n = I
     *  I / 0 = I
     *  I / N = N
     *  I / I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber divided by the value of
     * BigNumber(y, b), rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.dividedBy = P.div = function(y, b) {
            return div(this, new BigNumber(y, b), DECIMAL_PLACES, ROUNDING_MODE);
        };
        /*
     * Return a new BigNumber whose value is the integer part of dividing the value of this
     * BigNumber by the value of BigNumber(y, b).
     */ P.dividedToIntegerBy = P.idiv = function(y, b) {
            return div(this, new BigNumber(y, b), 0, 1);
        };
        /*
     * Return a BigNumber whose value is the value of this BigNumber exponentiated by n.
     *
     * If m is present, return the result modulo m.
     * If n is negative round according to DECIMAL_PLACES and ROUNDING_MODE.
     * If POW_PRECISION is non-zero and m is not present, round to POW_PRECISION using ROUNDING_MODE.
     *
     * The modular power operation works efficiently when x, n, and m are integers, otherwise it
     * is equivalent to calculating x.exponentiatedBy(n).modulo(m) with a POW_PRECISION of 0.
     *
     * n {number|string|BigNumber} The exponent. An integer.
     * [m] {number|string|BigNumber} The modulus.
     *
     * '[BigNumber Error] Exponent not an integer: {n}'
     */ P.exponentiatedBy = P.pow = function(n, m) {
            var half, isModExp, i, k, more, nIsBig, nIsNeg, nIsOdd, y, x = this;
            n = new BigNumber(n);
            // Allow NaN and ±Infinity, but not other non-integers.
            if (n.c && !n.isInteger()) throw Error(bignumberError + "Exponent not an integer: " + valueOf(n));
            if (m != null) m = new BigNumber(m);
            // Exponent of MAX_SAFE_INTEGER is 15.
            nIsBig = n.e > 14;
            // If x is NaN, ±Infinity, ±0 or ±1, or n is ±Infinity, NaN or ±0.
            if (!x.c || !x.c[0] || x.c[0] == 1 && !x.e && x.c.length == 1 || !n.c || !n.c[0]) {
                // The sign of the result of pow when x is negative depends on the evenness of n.
                // If +n overflows to ±Infinity, the evenness of n would be not be known.
                y = new BigNumber(Math.pow(+valueOf(x), nIsBig ? 2 - isOdd(n) : +valueOf(n)));
                return m ? y.mod(m) : y;
            }
            nIsNeg = n.s < 0;
            if (m) {
                // x % m returns NaN if abs(m) is zero, or m is NaN.
                if (m.c ? !m.c[0] : !m.s) return new BigNumber(NaN);
                isModExp = !nIsNeg && x.isInteger() && m.isInteger();
                if (isModExp) x = x.mod(m);
            // Overflow to ±Infinity: >=2**1e10 or >=1.0000024**1e15.
            // Underflow to ±0: <=0.79**1e10 or <=0.9999975**1e15.
            } else if (n.e > 9 && (x.e > 0 || x.e < -1 || (x.e == 0 ? x.c[0] > 1 || nIsBig && x.c[1] >= 24e7 : x.c[0] < 8e13 || nIsBig && x.c[0] <= 9999975e7))) {
                // If x is negative and n is odd, k = -0, else k = 0.
                k = x.s < 0 && isOdd(n) ? -0 : 0;
                // If x >= 1, k = ±Infinity.
                if (x.e > -1) k = 1 / k;
                // If n is negative return ±0, else return ±Infinity.
                return new BigNumber(nIsNeg ? 1 / k : k);
            } else if (POW_PRECISION) // Truncating each coefficient array to a length of k after each multiplication
            // equates to truncating significant digits to POW_PRECISION + [28, 41],
            // i.e. there will be a minimum of 28 guard digits retained.
            k = mathceil(POW_PRECISION / LOG_BASE + 2);
            if (nIsBig) {
                half = new BigNumber(0.5);
                if (nIsNeg) n.s = 1;
                nIsOdd = isOdd(n);
            } else {
                i = Math.abs(+valueOf(n));
                nIsOdd = i % 2;
            }
            y = new BigNumber(ONE);
            // Performs 54 loop iterations for n of 9007199254740991.
            for(;;){
                if (nIsOdd) {
                    y = y.times(x);
                    if (!y.c) break;
                    if (k) {
                        if (y.c.length > k) y.c.length = k;
                    } else if (isModExp) y = y.mod(m); //y = y.minus(div(y, m, 0, MODULO_MODE).times(m));
                }
                if (i) {
                    i = mathfloor(i / 2);
                    if (i === 0) break;
                    nIsOdd = i % 2;
                } else {
                    n = n.times(half);
                    round(n, n.e + 1, 1);
                    if (n.e > 14) nIsOdd = isOdd(n);
                    else {
                        i = +valueOf(n);
                        if (i === 0) break;
                        nIsOdd = i % 2;
                    }
                }
                x = x.times(x);
                if (k) {
                    if (x.c && x.c.length > k) x.c.length = k;
                } else if (isModExp) x = x.mod(m); //x = x.minus(div(x, m, 0, MODULO_MODE).times(m));
            }
            if (isModExp) return y;
            if (nIsNeg) y = ONE.div(y);
            return m ? y.mod(m) : k ? round(y, POW_PRECISION, ROUNDING_MODE, more) : y;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber rounded to an integer
     * using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {rm}'
     */ P.integerValue = function(rm) {
            var n = new BigNumber(this);
            if (rm == null) rm = ROUNDING_MODE;
            else intCheck(rm, 0, 8);
            return round(n, n.e + 1, rm);
        };
        /*
     * Return true if the value of this BigNumber is equal to the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isEqualTo = P.eq = function(y, b) {
            return compare(this, new BigNumber(y, b)) === 0;
        };
        /*
     * Return true if the value of this BigNumber is a finite number, otherwise return false.
     */ P.isFinite = function() {
            return !!this.c;
        };
        /*
     * Return true if the value of this BigNumber is greater than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isGreaterThan = P.gt = function(y, b) {
            return compare(this, new BigNumber(y, b)) > 0;
        };
        /*
     * Return true if the value of this BigNumber is greater than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isGreaterThanOrEqualTo = P.gte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === 1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is an integer, otherwise return false.
     */ P.isInteger = function() {
            return !!this.c && bitFloor(this.e / LOG_BASE) > this.c.length - 2;
        };
        /*
     * Return true if the value of this BigNumber is less than the value of BigNumber(y, b),
     * otherwise return false.
     */ P.isLessThan = P.lt = function(y, b) {
            return compare(this, new BigNumber(y, b)) < 0;
        };
        /*
     * Return true if the value of this BigNumber is less than or equal to the value of
     * BigNumber(y, b), otherwise return false.
     */ P.isLessThanOrEqualTo = P.lte = function(y, b) {
            return (b = compare(this, new BigNumber(y, b))) === -1 || b === 0;
        };
        /*
     * Return true if the value of this BigNumber is NaN, otherwise return false.
     */ P.isNaN = function() {
            return !this.s;
        };
        /*
     * Return true if the value of this BigNumber is negative, otherwise return false.
     */ P.isNegative = function() {
            return this.s < 0;
        };
        /*
     * Return true if the value of this BigNumber is positive, otherwise return false.
     */ P.isPositive = function() {
            return this.s > 0;
        };
        /*
     * Return true if the value of this BigNumber is 0 or -0, otherwise return false.
     */ P.isZero = function() {
            return !!this.c && this.c[0] == 0;
        };
        /*
     *  n - 0 = n
     *  n - N = N
     *  n - I = -I
     *  0 - n = -n
     *  0 - 0 = 0
     *  0 - N = N
     *  0 - I = -I
     *  N - n = N
     *  N - 0 = N
     *  N - N = N
     *  N - I = N
     *  I - n = I
     *  I - 0 = I
     *  I - N = N
     *  I - I = N
     *
     * Return a new BigNumber whose value is the value of this BigNumber minus the value of
     * BigNumber(y, b).
     */ P.minus = function(y, b) {
            var i, j, t, xLTy, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.plus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Either Infinity?
                if (!xc || !yc) return xc ? (y.s = -b, y) : new BigNumber(yc ? x : NaN);
                // Either zero?
                if (!xc[0] || !yc[0]) // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                return yc[0] ? (y.s = -b, y) : new BigNumber(xc[0] ? x : // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
                ROUNDING_MODE == 3 ? -0 : 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Determine which is the bigger number.
            if (a = xe - ye) {
                if (xLTy = a < 0) {
                    a = -a;
                    t = xc;
                } else {
                    ye = xe;
                    t = yc;
                }
                t.reverse();
                // Prepend zeros to equalise exponents.
                for(b = a; b--; t.push(0));
                t.reverse();
            } else {
                // Exponents equal. Check digit by digit.
                j = (xLTy = (a = xc.length) < (b = yc.length)) ? a : b;
                for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                    xLTy = xc[b] < yc[b];
                    break;
                }
            }
            // x < y? Point xc to the array of the bigger number.
            if (xLTy) t = xc, xc = yc, yc = t, y.s = -y.s;
            b = (j = yc.length) - (i = xc.length);
            // Append zeros to xc if shorter.
            // No need to add zeros to yc if shorter as subtract only needs to start at yc.length.
            if (b > 0) for(; b--; xc[i++] = 0);
            b = BASE - 1;
            // Subtract yc from xc.
            for(; j > a;){
                if (xc[--j] < yc[j]) {
                    for(i = j; i && !xc[--i]; xc[i] = b);
                    --xc[i];
                    xc[j] += BASE;
                }
                xc[j] -= yc[j];
            }
            // Remove leading zeros and adjust exponent accordingly.
            for(; xc[0] == 0; xc.splice(0, 1), --ye);
            // Zero?
            if (!xc[0]) {
                // Following IEEE 754 (2008) 6.3,
                // n - n = +0  but  n - n = -0  when rounding towards -Infinity.
                y.s = ROUNDING_MODE == 3 ? -1 : 1;
                y.c = [
                    y.e = 0
                ];
                return y;
            }
            // No need to check for Infinity as +x - +y != Infinity && -x - -y != Infinity
            // for finite x and y.
            return normalise(y, xc, ye);
        };
        /*
     *   n % 0 =  N
     *   n % N =  N
     *   n % I =  n
     *   0 % n =  0
     *  -0 % n = -0
     *   0 % 0 =  N
     *   0 % N =  N
     *   0 % I =  0
     *   N % n =  N
     *   N % 0 =  N
     *   N % N =  N
     *   N % I =  N
     *   I % n =  N
     *   I % 0 =  N
     *   I % N =  N
     *   I % I =  N
     *
     * Return a new BigNumber whose value is the value of this BigNumber modulo the value of
     * BigNumber(y, b). The result depends on the value of MODULO_MODE.
     */ P.modulo = P.mod = function(y, b) {
            var q, s, x = this;
            y = new BigNumber(y, b);
            // Return NaN if x is Infinity or NaN, or y is NaN or zero.
            if (!x.c || !y.s || y.c && !y.c[0]) return new BigNumber(NaN);
            else if (!y.c || x.c && !x.c[0]) return new BigNumber(x);
            if (MODULO_MODE == 9) {
                // Euclidian division: q = sign(y) * floor(x / abs(y))
                // r = x - qy    where  0 <= r < abs(y)
                s = y.s;
                y.s = 1;
                q = div(x, y, 0, 3);
                y.s = s;
                q.s *= s;
            } else q = div(x, y, 0, MODULO_MODE);
            y = x.minus(q.times(y));
            // To match JavaScript %, ensure sign of zero is sign of dividend.
            if (!y.c[0] && MODULO_MODE == 1) y.s = x.s;
            return y;
        };
        /*
     *  n * 0 = 0
     *  n * N = N
     *  n * I = I
     *  0 * n = 0
     *  0 * 0 = 0
     *  0 * N = N
     *  0 * I = N
     *  N * n = N
     *  N * 0 = N
     *  N * N = N
     *  N * I = N
     *  I * n = I
     *  I * 0 = N
     *  I * N = N
     *  I * I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber multiplied by the value
     * of BigNumber(y, b).
     */ P.multipliedBy = P.times = function(y, b) {
            var c, e, i, j, k, m, xcL, xlo, xhi, ycL, ylo, yhi, zc, base, sqrtBase, x = this, xc = x.c, yc = (y = new BigNumber(y, b)).c;
            // Either NaN, ±Infinity or ±0?
            if (!xc || !yc || !xc[0] || !yc[0]) {
                // Return NaN if either is NaN, or one is 0 and the other is Infinity.
                if (!x.s || !y.s || xc && !xc[0] && !yc || yc && !yc[0] && !xc) y.c = y.e = y.s = null;
                else {
                    y.s *= x.s;
                    // Return ±Infinity if either is ±Infinity.
                    if (!xc || !yc) y.c = y.e = null;
                    else {
                        y.c = [
                            0
                        ];
                        y.e = 0;
                    }
                }
                return y;
            }
            e = bitFloor(x.e / LOG_BASE) + bitFloor(y.e / LOG_BASE);
            y.s *= x.s;
            xcL = xc.length;
            ycL = yc.length;
            // Ensure xc points to longer array and xcL to its length.
            if (xcL < ycL) zc = xc, xc = yc, yc = zc, i = xcL, xcL = ycL, ycL = i;
            // Initialise the result array with zeros.
            for(i = xcL + ycL, zc = []; i--; zc.push(0));
            base = BASE;
            sqrtBase = SQRT_BASE;
            for(i = ycL; --i >= 0;){
                c = 0;
                ylo = yc[i] % sqrtBase;
                yhi = yc[i] / sqrtBase | 0;
                for(k = xcL, j = i + k; j > i;){
                    xlo = xc[--k] % sqrtBase;
                    xhi = xc[k] / sqrtBase | 0;
                    m = yhi * xlo + xhi * ylo;
                    xlo = ylo * xlo + m % sqrtBase * sqrtBase + zc[j] + c;
                    c = (xlo / base | 0) + (m / sqrtBase | 0) + yhi * xhi;
                    zc[j--] = xlo % base;
                }
                zc[j] = c;
            }
            if (c) ++e;
            else zc.splice(0, 1);
            return normalise(y, zc, e);
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber negated,
     * i.e. multiplied by -1.
     */ P.negated = function() {
            var x = new BigNumber(this);
            x.s = -x.s || null;
            return x;
        };
        /*
     *  n + 0 = n
     *  n + N = N
     *  n + I = I
     *  0 + n = n
     *  0 + 0 = 0
     *  0 + N = N
     *  0 + I = I
     *  N + n = N
     *  N + 0 = N
     *  N + N = N
     *  N + I = N
     *  I + n = I
     *  I + 0 = I
     *  I + N = N
     *  I + I = I
     *
     * Return a new BigNumber whose value is the value of this BigNumber plus the value of
     * BigNumber(y, b).
     */ P.plus = function(y, b) {
            var t, x = this, a = x.s;
            y = new BigNumber(y, b);
            b = y.s;
            // Either NaN?
            if (!a || !b) return new BigNumber(NaN);
            // Signs differ?
            if (a != b) {
                y.s = -b;
                return x.minus(y);
            }
            var xe = x.e / LOG_BASE, ye = y.e / LOG_BASE, xc = x.c, yc = y.c;
            if (!xe || !ye) {
                // Return ±Infinity if either ±Infinity.
                if (!xc || !yc) return new BigNumber(a / 0);
                // Either zero?
                // Return y if y is non-zero, x if x is non-zero, or zero if both are zero.
                if (!xc[0] || !yc[0]) return yc[0] ? y : new BigNumber(xc[0] ? x : a * 0);
            }
            xe = bitFloor(xe);
            ye = bitFloor(ye);
            xc = xc.slice();
            // Prepend zeros to equalise exponents. Faster to use reverse then do unshifts.
            if (a = xe - ye) {
                if (a > 0) {
                    ye = xe;
                    t = yc;
                } else {
                    a = -a;
                    t = xc;
                }
                t.reverse();
                for(; a--; t.push(0));
                t.reverse();
            }
            a = xc.length;
            b = yc.length;
            // Point xc to the longer array, and b to the shorter length.
            if (a - b < 0) t = yc, yc = xc, xc = t, b = a;
            // Only start adding at yc.length - 1 as the further digits of xc can be ignored.
            for(a = 0; b;){
                a = (xc[--b] = xc[b] + yc[b] + a) / BASE | 0;
                xc[b] = BASE === xc[b] ? 0 : xc[b] % BASE;
            }
            if (a) {
                xc = [
                    a
                ].concat(xc);
                ++ye;
            }
            // No need to check for zero, as +x + +y != 0 && -x + -y != 0
            // ye = MAX_EXP + 1 possible
            return normalise(y, xc, ye);
        };
        /*
     * If sd is undefined or null or true or false, return the number of significant digits of
     * the value of this BigNumber, or null if the value of this BigNumber is ±Infinity or NaN.
     * If sd is true include integer-part trailing zeros in the count.
     *
     * Otherwise, if sd is a number, return a new BigNumber whose value is the value of this
     * BigNumber rounded to a maximum of sd significant digits using rounding mode rm, or
     * ROUNDING_MODE if rm is omitted.
     *
     * sd {number|boolean} number: significant digits: integer, 1 to MAX inclusive.
     *                     boolean: whether to count integer-part trailing zeros: true or false.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.precision = P.sd = function(sd, rm) {
            var c, n, v, x = this;
            if (sd != null && sd !== !!sd) {
                intCheck(sd, 1, MAX);
                if (rm == null) rm = ROUNDING_MODE;
                else intCheck(rm, 0, 8);
                return round(new BigNumber(x), sd, rm);
            }
            if (!(c = x.c)) return null;
            v = c.length - 1;
            n = v * LOG_BASE + 1;
            if (v = c[v]) {
                // Subtract the number of trailing zeros of the last element.
                for(; v % 10 == 0; v /= 10, n--);
                // Add the number of digits of the first element.
                for(v = c[0]; v >= 10; v /= 10, n++);
            }
            if (sd && x.e + 1 > n) n = x.e + 1;
            return n;
        };
        /*
     * Return a new BigNumber whose value is the value of this BigNumber shifted by k places
     * (powers of 10). Shift to the right if n > 0, and to the left if n < 0.
     *
     * k {number} Integer, -MAX_SAFE_INTEGER to MAX_SAFE_INTEGER inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {k}'
     */ P.shiftedBy = function(k) {
            intCheck(k, -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER);
            return this.times("1e" + k);
        };
        /*
     *  sqrt(-n) =  N
     *  sqrt(N) =  N
     *  sqrt(-I) =  N
     *  sqrt(I) =  I
     *  sqrt(0) =  0
     *  sqrt(-0) = -0
     *
     * Return a new BigNumber whose value is the square root of the value of this BigNumber,
     * rounded according to DECIMAL_PLACES and ROUNDING_MODE.
     */ P.squareRoot = P.sqrt = function() {
            var m, n, r, rep, t, x = this, c = x.c, s = x.s, e = x.e, dp = DECIMAL_PLACES + 4, half = new BigNumber("0.5");
            // Negative/NaN/Infinity/zero?
            if (s !== 1 || !c || !c[0]) return new BigNumber(!s || s < 0 && (!c || c[0]) ? NaN : c ? x : 1 / 0);
            // Initial estimate.
            s = Math.sqrt(+valueOf(x));
            // Math.sqrt underflow/overflow?
            // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
            if (s == 0 || s == 1 / 0) {
                n = coeffToString(c);
                if ((n.length + e) % 2 == 0) n += "0";
                s = Math.sqrt(+n);
                e = bitFloor((e + 1) / 2) - (e < 0 || e % 2);
                if (s == 1 / 0) n = "5e" + e;
                else {
                    n = s.toExponential();
                    n = n.slice(0, n.indexOf("e") + 1) + e;
                }
                r = new BigNumber(n);
            } else r = new BigNumber(s + "");
            // Check for zero.
            // r could be zero if MIN_EXP is changed after the this value was created.
            // This would cause a division by zero (x/t) and hence Infinity below, which would cause
            // coeffToString to throw.
            if (r.c[0]) {
                e = r.e;
                s = e + dp;
                if (s < 3) s = 0;
                // Newton-Raphson iteration.
                for(;;){
                    t = r;
                    r = half.times(t.plus(div(x, t, dp, 1)));
                    if (coeffToString(t.c).slice(0, s) === (n = coeffToString(r.c)).slice(0, s)) {
                        // The exponent of r may here be one less than the final result exponent,
                        // e.g 0.0009999 (e-4) --> 0.001 (e-3), so adjust s so the rounding digits
                        // are indexed correctly.
                        if (r.e < e) --s;
                        n = n.slice(s - 3, s + 1);
                        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits
                        // are 9999 or 4999 (i.e. approaching a rounding boundary) continue the
                        // iteration.
                        if (n == "9999" || !rep && n == "4999") {
                            // On the first iteration only, check to see if rounding up gives the
                            // exact result as the nines may infinitely repeat.
                            if (!rep) {
                                round(t, t.e + DECIMAL_PLACES + 2, 0);
                                if (t.times(t).eq(x)) {
                                    r = t;
                                    break;
                                }
                            }
                            dp += 4;
                            s += 4;
                            rep = 1;
                        } else {
                            // If rounding digits are null, 0{0,4} or 50{0,3}, check for exact
                            // result. If not, then there are further digits and m will be truthy.
                            if (!+n || !+n.slice(1) && n.charAt(0) == "5") {
                                // Truncate to the first rounding digit.
                                round(r, r.e + DECIMAL_PLACES + 2, 1);
                                m = !r.times(r).eq(x);
                            }
                            break;
                        }
                    }
                }
            }
            return round(r, r.e + DECIMAL_PLACES + 1, ROUNDING_MODE, m);
        };
        /*
     * Return a string representing the value of this BigNumber in exponential notation and
     * rounded using ROUNDING_MODE to dp fixed decimal places.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toExponential = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp++;
            }
            return format(this, dp, rm, 1);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounding
     * to dp fixed decimal places using rounding mode rm, or ROUNDING_MODE if rm is omitted.
     *
     * Note: as with JavaScript's number type, (-0).toFixed(0) is '0',
     * but e.g. (-0.00001).toFixed(0) is '-0'.
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     */ P.toFixed = function(dp, rm) {
            if (dp != null) {
                intCheck(dp, 0, MAX);
                dp = dp + this.e + 1;
            }
            return format(this, dp, rm);
        };
        /*
     * Return a string representing the value of this BigNumber in fixed-point notation rounded
     * using rm or ROUNDING_MODE to dp decimal places, and formatted according to the properties
     * of the format or FORMAT object (see BigNumber.set).
     *
     * The formatting object may contain some or all of the properties shown below.
     *
     * FORMAT = {
     *   prefix: '',
     *   groupSize: 3,
     *   secondaryGroupSize: 0,
     *   groupSeparator: ',',
     *   decimalSeparator: '.',
     *   fractionGroupSize: 0,
     *   fractionGroupSeparator: '\xA0',      // non-breaking space
     *   suffix: ''
     * };
     *
     * [dp] {number} Decimal places. Integer, 0 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     * [format] {object} Formatting options. See FORMAT pbject above.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {dp|rm}'
     * '[BigNumber Error] Argument not an object: {format}'
     */ P.toFormat = function(dp, rm, format) {
            var str, x = this;
            if (format == null) {
                if (dp != null && rm && typeof rm == "object") {
                    format = rm;
                    rm = null;
                } else if (dp && typeof dp == "object") {
                    format = dp;
                    dp = rm = null;
                } else format = FORMAT;
            } else if (typeof format != "object") throw Error(bignumberError + "Argument not an object: " + format);
            str = x.toFixed(dp, rm);
            if (x.c) {
                var i, arr = str.split("."), g1 = +format.groupSize, g2 = +format.secondaryGroupSize, groupSeparator = format.groupSeparator || "", intPart = arr[0], fractionPart = arr[1], isNeg = x.s < 0, intDigits = isNeg ? intPart.slice(1) : intPart, len = intDigits.length;
                if (g2) i = g1, g1 = g2, g2 = i, len -= i;
                if (g1 > 0 && len > 0) {
                    i = len % g1 || g1;
                    intPart = intDigits.substr(0, i);
                    for(; i < len; i += g1)intPart += groupSeparator + intDigits.substr(i, g1);
                    if (g2 > 0) intPart += groupSeparator + intDigits.slice(i);
                    if (isNeg) intPart = "-" + intPart;
                }
                str = fractionPart ? intPart + (format.decimalSeparator || "") + ((g2 = +format.fractionGroupSize) ? fractionPart.replace(new RegExp("\\d{" + g2 + "}\\B", "g"), "$&" + (format.fractionGroupSeparator || "")) : fractionPart) : intPart;
            }
            return (format.prefix || "") + str + (format.suffix || "");
        };
        /*
     * Return an array of two BigNumbers representing the value of this BigNumber as a simple
     * fraction with an integer numerator and an integer denominator.
     * The denominator will be a positive non-zero value less than or equal to the specified
     * maximum denominator. If a maximum denominator is not specified, the denominator will be
     * the lowest value necessary to represent the number exactly.
     *
     * [md] {number|string|BigNumber} Integer >= 1, or Infinity. The maximum denominator.
     *
     * '[BigNumber Error] Argument {not an integer|out of range} : {md}'
     */ P.toFraction = function(md) {
            var d, d0, d1, d2, e, exp, n, n0, n1, q, r, s, x = this, xc = x.c;
            if (md != null) {
                n = new BigNumber(md);
                // Throw if md is less than one or is not an integer, unless it is Infinity.
                if (!n.isInteger() && (n.c || n.s !== 1) || n.lt(ONE)) throw Error(bignumberError + "Argument " + (n.isInteger() ? "out of range: " : "not an integer: ") + valueOf(n));
            }
            if (!xc) return new BigNumber(x);
            d = new BigNumber(ONE);
            n1 = d0 = new BigNumber(ONE);
            d1 = n0 = new BigNumber(ONE);
            s = coeffToString(xc);
            // Determine initial denominator.
            // d is a power of 10 and the minimum max denominator that specifies the value exactly.
            e = d.e = s.length - x.e - 1;
            d.c[0] = POWS_TEN[(exp = e % LOG_BASE) < 0 ? LOG_BASE + exp : exp];
            md = !md || n.comparedTo(d) > 0 ? e > 0 ? d : n1 : n;
            exp = MAX_EXP;
            MAX_EXP = 1 / 0;
            n = new BigNumber(s);
            // n0 = d1 = 0
            n0.c[0] = 0;
            for(;;){
                q = div(n, d, 0, 1);
                d2 = d0.plus(q.times(d1));
                if (d2.comparedTo(md) == 1) break;
                d0 = d1;
                d1 = d2;
                n1 = n0.plus(q.times(d2 = n1));
                n0 = d2;
                d = n.minus(q.times(d2 = d));
                n = d2;
            }
            d2 = div(md.minus(d0), d1, 0, 1);
            n0 = n0.plus(d2.times(n1));
            d0 = d0.plus(d2.times(d1));
            n0.s = n1.s = x.s;
            e = e * 2;
            // Determine which fraction is closer to x, n0/d0 or n1/d1
            r = div(n1, d1, e, ROUNDING_MODE).minus(x).abs().comparedTo(div(n0, d0, e, ROUNDING_MODE).minus(x).abs()) < 1 ? [
                n1,
                d1
            ] : [
                n0,
                d0
            ];
            MAX_EXP = exp;
            return r;
        };
        /*
     * Return the value of this BigNumber converted to a number primitive.
     */ P.toNumber = function() {
            return +valueOf(this);
        };
        /*
     * Return a string representing the value of this BigNumber rounded to sd significant digits
     * using rounding mode rm or ROUNDING_MODE. If sd is less than the number of digits
     * necessary to represent the integer part of the value in fixed-point notation, then use
     * exponential notation.
     *
     * [sd] {number} Significant digits. Integer, 1 to MAX inclusive.
     * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
     *
     * '[BigNumber Error] Argument {not a primitive number|not an integer|out of range}: {sd|rm}'
     */ P.toPrecision = function(sd, rm) {
            if (sd != null) intCheck(sd, 1, MAX);
            return format(this, sd, rm, 2);
        };
        /*
     * Return a string representing the value of this BigNumber in base b, or base 10 if b is
     * omitted. If a base is specified, including base 10, round according to DECIMAL_PLACES and
     * ROUNDING_MODE. If a base is not specified, and this BigNumber has a positive exponent
     * that is equal to or greater than TO_EXP_POS, or a negative exponent equal to or less than
     * TO_EXP_NEG, return exponential notation.
     *
     * [b] {number} Integer, 2 to ALPHABET.length inclusive.
     *
     * '[BigNumber Error] Base {not a primitive number|not an integer|out of range}: {b}'
     */ P.toString = function(b) {
            var str, n = this, s = n.s, e = n.e;
            // Infinity or NaN?
            if (e === null) {
                if (s) {
                    str = "Infinity";
                    if (s < 0) str = "-" + str;
                } else str = "NaN";
            } else {
                if (b == null) str = e <= TO_EXP_NEG || e >= TO_EXP_POS ? toExponential(coeffToString(n.c), e) : toFixedPoint(coeffToString(n.c), e, "0");
                else if (b === 10) {
                    n = round(new BigNumber(n), DECIMAL_PLACES + e + 1, ROUNDING_MODE);
                    str = toFixedPoint(coeffToString(n.c), n.e, "0");
                } else {
                    intCheck(b, 2, ALPHABET.length, "Base");
                    str = convertBase(toFixedPoint(coeffToString(n.c), e, "0"), 10, b, s, true);
                }
                if (s < 0 && n.c[0]) str = "-" + str;
            }
            return str;
        };
        /*
     * Return as toString, but do not accept a base argument, and include the minus sign for
     * negative zero.
     */ P.valueOf = P.toJSON = function() {
            return valueOf(this);
        };
        P._isBigNumber = true;
        if (configObject != null) BigNumber.set(configObject);
        return BigNumber;
    }
    // PRIVATE HELPER FUNCTIONS
    // These functions don't need access to variables,
    // e.g. DECIMAL_PLACES, in the scope of the `clone` function above.
    function bitFloor(n) {
        var i = n | 0;
        return n > 0 || n === i ? i : i - 1;
    }
    // Return a coefficient array as a string of base 10 digits.
    function coeffToString(a) {
        var s, z, i = 1, j = a.length, r = a[0] + "";
        for(; i < j;){
            s = a[i++] + "";
            z = LOG_BASE - s.length;
            for(; z--; s = "0" + s);
            r += s;
        }
        // Determine trailing zeros.
        for(j = r.length; r.charCodeAt(--j) === 48;);
        return r.slice(0, j + 1 || 1);
    }
    // Compare the value of BigNumbers x and y.
    function compare(x, y) {
        var a, b, xc = x.c, yc = y.c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either NaN?
        if (!i || !j) return null;
        a = xc && !xc[0];
        b = yc && !yc[0];
        // Either zero?
        if (a || b) return a ? b ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        a = i < 0;
        b = k == l;
        // Either Infinity?
        if (!xc || !yc) return b ? 0 : !xc ^ a ? 1 : -1;
        // Compare exponents.
        if (!b) return k > l ^ a ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = 0; i < j; i++)if (xc[i] != yc[i]) return xc[i] > yc[i] ^ a ? 1 : -1;
        // Compare lengths.
        return k == l ? 0 : k > l ^ a ? 1 : -1;
    }
    /*
   * Check that n is a primitive number, an integer, and in range, otherwise throw.
   */ function intCheck(n, min, max, name) {
        if (n < min || n > max || n !== mathfloor(n)) throw Error(bignumberError + (name || "Argument") + (typeof n == "number" ? n < min || n > max ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(n));
    }
    // Assumes finite n.
    function isOdd(n) {
        var k = n.c.length - 1;
        return bitFloor(n.e / LOG_BASE) == k && n.c[k] % 2 != 0;
    }
    function toExponential(str, e) {
        return (str.length > 1 ? str.charAt(0) + "." + str.slice(1) : str) + (e < 0 ? "e" : "e+") + e;
    }
    function toFixedPoint(str, e, z) {
        var len, zs;
        // Negative exponent?
        if (e < 0) {
            // Prepend zeros.
            for(zs = z + "."; ++e; zs += z);
            str = zs + str;
        // Positive exponent
        } else {
            len = str.length;
            // Append zeros.
            if (++e > len) {
                for(zs = z, e -= len; --e; zs += z);
                str += zs;
            } else if (e < len) str = str.slice(0, e) + "." + str.slice(e);
        }
        return str;
    }
    // EXPORT
    BigNumber = clone();
    BigNumber["default"] = BigNumber.BigNumber = BigNumber;
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return BigNumber;
    });
    else if (0, module.exports) module.exports = BigNumber;
    else {
        if (!globalObject) globalObject = typeof self != "undefined" && self ? self : window;
        globalObject.BigNumber = BigNumber;
    }
})(module.exports);

});

parcelRegister("kWcCv", function(module, exports) {

































(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("9PUgX")), (parcelRequire("gu0dW")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("lqaMD")), (parcelRequire("hNROW")), (parcelRequire("kgfdC")), (parcelRequire("6PaKQ")), (parcelRequire("bZEkw")), (parcelRequire("AFosI")), (parcelRequire("bIitx")), (parcelRequire("7ft6W")), (parcelRequire("as0jN")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")), (parcelRequire("kvEE5")), (parcelRequire("4phbY")), (parcelRequire("5AuZH")), (parcelRequire("9xxh3")), (parcelRequire("hsvIJ")), (parcelRequire("cIj8k")), (parcelRequire("3XsJo")), (parcelRequire("4cP0m")), (parcelRequire("1bHm1")), (parcelRequire("5oWlT")), (parcelRequire("eSHMm")), (parcelRequire("3H9rt")), (parcelRequire("2QWZ2")), (parcelRequire("1sYM8")), (parcelRequire("hUv46")), (parcelRequire("3ybbi")));
})(this, function(CryptoJS) {
    return CryptoJS;
});

});
parcelRegister("cfaDk", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /*globals window, global, require*/ /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        var crypto;
        // Native crypto from window (Browser)
        if (typeof window !== "undefined" && window.crypto) crypto = window.crypto;
        // Native (experimental IE 11) crypto from window (Browser)
        if (!crypto && typeof window !== "undefined" && window.msCrypto) crypto = window.msCrypto;
        // Native crypto from global (NodeJS)
        if (!crypto && typeof $parcel$global !== "undefined" && $parcel$global.crypto) crypto = $parcel$global.crypto;
        // Native crypto import via require (NodeJS)
        if (!crypto && true) try {
            crypto = (parcelRequire("aO8Ot"));
        } catch (err) {}
        /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */ var cryptoSecureRandomInt = function() {
            if (crypto) {
                // Use getRandomValues method (Browser)
                if (typeof crypto.getRandomValues === "function") try {
                    return crypto.getRandomValues(new Uint32Array(1))[0];
                } catch (err) {}
                // Use randomBytes method (NodeJS)
                if (typeof crypto.randomBytes === "function") try {
                    return crypto.randomBytes(4).readInt32LE();
                } catch (err) {}
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
        };
        /*
	     * Local polyfill of Object.create

	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                for(var i = 0; i < nBytes; i += 4)words.push(cryptoSecureRandomInt());
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                var processedWords;
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});
parcelRegister("aO8Ot", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $7de568f77242e9e6$export$5f828d93ff035aa8; }, function (v) { return $7de568f77242e9e6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $7de568f77242e9e6$export$cd94982b18c6332c; }, function (v) { return $7de568f77242e9e6$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $7de568f77242e9e6$export$1d518568e4f529b0; }, function (v) { return $7de568f77242e9e6$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $7de568f77242e9e6$export$5285b6d41c912b41; }, function (v) { return $7de568f77242e9e6$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e; }, function (v) { return $7de568f77242e9e6$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd; }, function (v) { return $7de568f77242e9e6$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $7de568f77242e9e6$export$da39cf97e1eb7c91; }, function (v) { return $7de568f77242e9e6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $7de568f77242e9e6$export$52a9039d7177394f; }, function (v) { return $7de568f77242e9e6$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $7de568f77242e9e6$export$f7201db400317331; }, function (v) { return $7de568f77242e9e6$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $7de568f77242e9e6$export$448fa22aedc9dbca; }, function (v) { return $7de568f77242e9e6$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $7de568f77242e9e6$export$b80c7ba289c8fa56; }, function (v) { return $7de568f77242e9e6$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $7de568f77242e9e6$export$26e5786e8ac8e530; }, function (v) { return $7de568f77242e9e6$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $7de568f77242e9e6$export$bdd223f16383713e; }, function (v) { return $7de568f77242e9e6$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $7de568f77242e9e6$export$20533d26f07f1ee0; }, function (v) { return $7de568f77242e9e6$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $7de568f77242e9e6$export$2f64596b8cbf08b4; }, function (v) { return $7de568f77242e9e6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a; }, function (v) { return $7de568f77242e9e6$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $7de568f77242e9e6$export$12ada9414fbc594c; }, function (v) { return $7de568f77242e9e6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $7de568f77242e9e6$export$f5e7e39d57cd9700; }, function (v) { return $7de568f77242e9e6$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7de568f77242e9e6$export$36b6d6ef312eab39; }, function (v) { return $7de568f77242e9e6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $7de568f77242e9e6$export$58a258485f1e49f6; }, function (v) { return $7de568f77242e9e6$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $7de568f77242e9e6$export$dedd8dc3dc62b370; }, function (v) { return $7de568f77242e9e6$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $7de568f77242e9e6$export$971862a2fcb1bb40; }, function (v) { return $7de568f77242e9e6$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $7de568f77242e9e6$export$c6ff6a88acbeaf40; }, function (v) { return $7de568f77242e9e6$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $7de568f77242e9e6$export$fdc27893e98845cc; }, function (v) { return $7de568f77242e9e6$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $7de568f77242e9e6$export$6671fb9a1323bed; }, function (v) { return $7de568f77242e9e6$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $7de568f77242e9e6$export$d74daf141a551db; }, function (v) { return $7de568f77242e9e6$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $7de568f77242e9e6$export$45df7cae684751af; }, function (v) { return $7de568f77242e9e6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $7de568f77242e9e6$export$1db683ad541682f6; }, function (v) { return $7de568f77242e9e6$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $7de568f77242e9e6$export$6f65485f87568e37; }, function (v) { return $7de568f77242e9e6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $7de568f77242e9e6$export$91a8e56769aeb334; }, function (v) { return $7de568f77242e9e6$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $7de568f77242e9e6$export$2d4117e99c2179e4; }, function (v) { return $7de568f77242e9e6$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $7de568f77242e9e6$export$512823e338ddb1b7; }, function (v) { return $7de568f77242e9e6$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3; }, function (v) { return $7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $7de568f77242e9e6$export$b9d55ff329113abd; }, function (v) { return $7de568f77242e9e6$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $7de568f77242e9e6$export$7efb24e2fddf99b9; }, function (v) { return $7de568f77242e9e6$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8; }, function (v) { return $7de568f77242e9e6$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $7de568f77242e9e6$export$2f7171e78e524d5e; }, function (v) { return $7de568f77242e9e6$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $7de568f77242e9e6$export$e1d879b482f37d98; }, function (v) { return $7de568f77242e9e6$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $7de568f77242e9e6$export$1a988e7317c65621; }, function (v) { return $7de568f77242e9e6$export$1a988e7317c65621 = v; });
var $7de568f77242e9e6$export$5f828d93ff035aa8;
var $7de568f77242e9e6$export$cd94982b18c6332c;
var $7de568f77242e9e6$export$1d518568e4f529b0;
var $7de568f77242e9e6$export$5285b6d41c912b41;
var $7de568f77242e9e6$export$2fb37efbf6ae0c0e;
var $7de568f77242e9e6$export$ab85ecd77ce6a5cd;
var $7de568f77242e9e6$export$da39cf97e1eb7c91;
var $7de568f77242e9e6$export$52a9039d7177394f;
var $7de568f77242e9e6$export$f7201db400317331;
var $7de568f77242e9e6$export$448fa22aedc9dbca;
var $7de568f77242e9e6$export$b80c7ba289c8fa56;
var $7de568f77242e9e6$export$26e5786e8ac8e530;
var $7de568f77242e9e6$export$bdd223f16383713e;
var $7de568f77242e9e6$export$20533d26f07f1ee0;
var $7de568f77242e9e6$export$2f64596b8cbf08b4;
var $7de568f77242e9e6$export$2ce6d8d0e8b04e1a;
var $7de568f77242e9e6$export$12ada9414fbc594c;
var $7de568f77242e9e6$export$f5e7e39d57cd9700;
var $7de568f77242e9e6$export$36b6d6ef312eab39;
var $7de568f77242e9e6$export$58a258485f1e49f6;
var $7de568f77242e9e6$export$dedd8dc3dc62b370;
var $7de568f77242e9e6$export$971862a2fcb1bb40;
var $7de568f77242e9e6$export$c6ff6a88acbeaf40;
var $7de568f77242e9e6$export$fdc27893e98845cc;
var $7de568f77242e9e6$export$6671fb9a1323bed;
var $7de568f77242e9e6$export$d74daf141a551db;
var $7de568f77242e9e6$export$45df7cae684751af;
var $7de568f77242e9e6$export$1db683ad541682f6;
var $7de568f77242e9e6$export$6f65485f87568e37;
var $7de568f77242e9e6$export$91a8e56769aeb334;
var $7de568f77242e9e6$export$2d4117e99c2179e4;
var $7de568f77242e9e6$export$512823e338ddb1b7;
var $7de568f77242e9e6$export$9d0e0c0c4a8d30f3;
var $7de568f77242e9e6$export$b9d55ff329113abd;
var $7de568f77242e9e6$export$7efb24e2fddf99b9;
var $7de568f77242e9e6$export$bb1abf2ce84fc7e8;
var $7de568f77242e9e6$export$2f7171e78e524d5e;
var $7de568f77242e9e6$export$e1d879b482f37d98;
var $7de568f77242e9e6$export$1a988e7317c65621;
"use strict";

$7de568f77242e9e6$export$5f828d93ff035aa8 = $7de568f77242e9e6$export$cd94982b18c6332c = $7de568f77242e9e6$export$1d518568e4f529b0 = $7de568f77242e9e6$export$5285b6d41c912b41 = (parcelRequire("5rfiH"));

$7de568f77242e9e6$export$2fb37efbf6ae0c0e = $7de568f77242e9e6$export$ab85ecd77ce6a5cd = (parcelRequire("3FiLE"));

$7de568f77242e9e6$export$da39cf97e1eb7c91 = $7de568f77242e9e6$export$52a9039d7177394f = (parcelRequire("cUvgf"));

var $fAh7A = parcelRequire("fAh7A");
var $7de568f77242e9e6$var$algoKeys = Object.keys($fAh7A);
var $7de568f77242e9e6$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($7de568f77242e9e6$var$algoKeys);
$7de568f77242e9e6$export$f7201db400317331 = function() {
    return $7de568f77242e9e6$var$hashes;
};

var $1UZ5c = parcelRequire("1UZ5c");
$7de568f77242e9e6$export$448fa22aedc9dbca = $1UZ5c.pbkdf2;
$7de568f77242e9e6$export$b80c7ba289c8fa56 = $1UZ5c.pbkdf2Sync;

var $3lJ0u = parcelRequire("3lJ0u");
$7de568f77242e9e6$export$26e5786e8ac8e530 = $3lJ0u.Cipher;
$7de568f77242e9e6$export$bdd223f16383713e = $3lJ0u.createCipher;
$7de568f77242e9e6$export$20533d26f07f1ee0 = $3lJ0u.Cipheriv;
$7de568f77242e9e6$export$2f64596b8cbf08b4 = $3lJ0u.createCipheriv;
$7de568f77242e9e6$export$2ce6d8d0e8b04e1a = $3lJ0u.Decipher;
$7de568f77242e9e6$export$12ada9414fbc594c = $3lJ0u.createDecipher;
$7de568f77242e9e6$export$f5e7e39d57cd9700 = $3lJ0u.Decipheriv;
$7de568f77242e9e6$export$36b6d6ef312eab39 = $3lJ0u.createDecipheriv;
$7de568f77242e9e6$export$58a258485f1e49f6 = $3lJ0u.getCiphers;
$7de568f77242e9e6$export$dedd8dc3dc62b370 = $3lJ0u.listCiphers;

var $4evoR = parcelRequire("4evoR");
$7de568f77242e9e6$export$971862a2fcb1bb40 = $4evoR.DiffieHellmanGroup;
$7de568f77242e9e6$export$c6ff6a88acbeaf40 = $4evoR.createDiffieHellmanGroup;
$7de568f77242e9e6$export$fdc27893e98845cc = $4evoR.getDiffieHellman;
$7de568f77242e9e6$export$6671fb9a1323bed = $4evoR.createDiffieHellman;
$7de568f77242e9e6$export$d74daf141a551db = $4evoR.DiffieHellman;

var $bOCXe = parcelRequire("bOCXe");
$7de568f77242e9e6$export$45df7cae684751af = $bOCXe.createSign;
$7de568f77242e9e6$export$1db683ad541682f6 = $bOCXe.Sign;
$7de568f77242e9e6$export$6f65485f87568e37 = $bOCXe.createVerify;
$7de568f77242e9e6$export$91a8e56769aeb334 = $bOCXe.Verify;

$7de568f77242e9e6$export$2d4117e99c2179e4 = (parcelRequire("bpRNH"));

var $e8Hvp = parcelRequire("e8Hvp");
$7de568f77242e9e6$export$512823e338ddb1b7 = $e8Hvp.publicEncrypt;
$7de568f77242e9e6$export$9d0e0c0c4a8d30f3 = $e8Hvp.privateEncrypt;
$7de568f77242e9e6$export$b9d55ff329113abd = $e8Hvp.publicDecrypt;
$7de568f77242e9e6$export$7efb24e2fddf99b9 = $e8Hvp.privateDecrypt;

var $6zHAr = parcelRequire("6zHAr");
$7de568f77242e9e6$export$bb1abf2ce84fc7e8 = $6zHAr.randomFill;
$7de568f77242e9e6$export$2f7171e78e524d5e = $6zHAr.randomFillSync;
$7de568f77242e9e6$export$e1d879b482f37d98 = function() {
    throw new Error([
        "sorry, createCredentials is not implemented yet",
        "we accept pull requests",
        "https://github.com/crypto-browserify/crypto-browserify"
    ].join("\n"));
};
$7de568f77242e9e6$export$1a988e7317c65621 = {
    "DH_CHECK_P_NOT_SAFE_PRIME": 2,
    "DH_CHECK_P_NOT_PRIME": 1,
    "DH_UNABLE_TO_CHECK_GENERATOR": 4,
    "DH_NOT_SUITABLE_GENERATOR": 8,
    "NPN_ENABLED": 1,
    "ALPN_ENABLED": 1,
    "RSA_PKCS1_PADDING": 1,
    "RSA_SSLV23_PADDING": 2,
    "RSA_NO_PADDING": 3,
    "RSA_PKCS1_OAEP_PADDING": 4,
    "RSA_X931_PADDING": 5,
    "RSA_PKCS1_PSS_PADDING": 6,
    "POINT_CONVERSION_COMPRESSED": 2,
    "POINT_CONVERSION_UNCOMPRESSED": 4,
    "POINT_CONVERSION_HYBRID": 6
};

});
parcelRegister("5rfiH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $3f5b57c5e5054ef5$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $3f5b57c5e5054ef5$var$MAX_UINT32 = 4294967295;
function $3f5b57c5e5054ef5$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");
var $3f5b57c5e5054ef5$require$Buffer = $6U9mG.Buffer;
var $3f5b57c5e5054ef5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($3f5b57c5e5054ef5$var$crypto && $3f5b57c5e5054ef5$var$crypto.getRandomValues) module.exports = $3f5b57c5e5054ef5$var$randomBytes;
else module.exports = $3f5b57c5e5054ef5$var$oldBrowser;
function $3f5b57c5e5054ef5$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $3f5b57c5e5054ef5$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $3f5b57c5e5054ef5$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $3f5b57c5e5054ef5$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $3f5b57c5e5054ef5$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes.slice(generated, generated + $3f5b57c5e5054ef5$var$MAX_BYTES));
        else $3f5b57c5e5054ef5$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $4TNnu.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});
parcelRegister("6U9mG", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $506f3cb9e9ae23e7$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $506f3cb9e9ae23e7$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($506f3cb9e9ae23e7$var$Buffer.from && $506f3cb9e9ae23e7$var$Buffer.alloc && $506f3cb9e9ae23e7$var$Buffer.allocUnsafe && $506f3cb9e9ae23e7$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $506f3cb9e9ae23e7$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $506f3cb9e9ae23e7$var$SafeBuffer;
}
function $506f3cb9e9ae23e7$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
}
$506f3cb9e9ae23e7$var$SafeBuffer.prototype = Object.create($506f3cb9e9ae23e7$var$Buffer.prototype);
// Copy static methods from Buffer
$506f3cb9e9ae23e7$var$copyProps($506f3cb9e9ae23e7$var$Buffer, $506f3cb9e9ae23e7$var$SafeBuffer);
$506f3cb9e9ae23e7$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $506f3cb9e9ae23e7$var$Buffer(arg, encodingOrOffset, length);
};
$506f3cb9e9ae23e7$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $506f3cb9e9ae23e7$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $506f3cb9e9ae23e7$var$Buffer(size);
};
$506f3cb9e9ae23e7$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});


parcelRegister("3FiLE", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $cvCaQ = parcelRequire("cvCaQ");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $fpHcA = parcelRequire("fpHcA");
function $2ab3c24d6f7239f3$var$Hash(hash) {
    $fpHcA.call(this, "digest");
    this._hash = hash;
}
$eSHUL($2ab3c24d6f7239f3$var$Hash, $fpHcA);
$2ab3c24d6f7239f3$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$2ab3c24d6f7239f3$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $cvCaQ();
    if (alg === "rmd160" || alg === "ripemd160") return new $cjuEr();
    return new $2ab3c24d6f7239f3$var$Hash($fkJVr(alg));
};

});
parcelRegister("eSHUL", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("cvCaQ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");

var $6U9mG = parcelRequire("6U9mG");
var $91b5fdd475e07956$require$Buffer = $6U9mG.Buffer;
var $91b5fdd475e07956$var$ARRAY16 = new Array(16);
function $91b5fdd475e07956$var$MD5() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$eSHUL($91b5fdd475e07956$var$MD5, $9aUYR);
$91b5fdd475e07956$var$MD5.prototype._update = function() {
    var M = $91b5fdd475e07956$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $91b5fdd475e07956$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $91b5fdd475e07956$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $91b5fdd475e07956$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $91b5fdd475e07956$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $91b5fdd475e07956$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $91b5fdd475e07956$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $91b5fdd475e07956$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $91b5fdd475e07956$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $91b5fdd475e07956$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $91b5fdd475e07956$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $91b5fdd475e07956$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $91b5fdd475e07956$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $91b5fdd475e07956$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $91b5fdd475e07956$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $91b5fdd475e07956$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $91b5fdd475e07956$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$91b5fdd475e07956$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $91b5fdd475e07956$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $91b5fdd475e07956$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $91b5fdd475e07956$var$fnF(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnG(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnH(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $91b5fdd475e07956$var$fnI(a, b, c, d, m, k, s) {
    return $91b5fdd475e07956$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $91b5fdd475e07956$var$MD5;

});
parcelRegister("9aUYR", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $6ae13f602076a4da$require$Buffer = $6U9mG.Buffer;

var $9AddZ = parcelRequire("9AddZ");
var $6ae13f602076a4da$require$Transform = $9AddZ.Transform;

var $eSHUL = parcelRequire("eSHUL");
function $6ae13f602076a4da$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $6ae13f602076a4da$var$HashBase(blockSize) {
    $6ae13f602076a4da$require$Transform.call(this);
    this._block = $6ae13f602076a4da$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$eSHUL($6ae13f602076a4da$var$HashBase, $6ae13f602076a4da$require$Transform);
$6ae13f602076a4da$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$6ae13f602076a4da$var$HashBase.prototype.update = function(data, encoding) {
    $6ae13f602076a4da$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$6ae13f602076a4da$require$Buffer.isBuffer(data)) data = $6ae13f602076a4da$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$6ae13f602076a4da$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$6ae13f602076a4da$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$6ae13f602076a4da$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $6ae13f602076a4da$var$HashBase;

});
parcelRegister("9AddZ", function(module, exports) {

exports = module.exports = (parcelRequire("cEnbP"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("cuAoD"));

exports.Duplex = (parcelRequire("2Hlr9"));

exports.Transform = (parcelRequire("l7DDn"));

exports.PassThrough = (parcelRequire("6VFzs"));

exports.finished = (parcelRequire("gr8mb"));

exports.pipeline = (parcelRequire("e8JAK"));

});
parcelRegister("cEnbP", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $935b35782dc2f587$var$Readable;
/*<replacement>*/ var $935b35782dc2f587$var$Duplex;
/*</replacement>*/ $935b35782dc2f587$var$Readable.ReadableState = $935b35782dc2f587$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $935b35782dc2f587$require$EE = $jMc9N.EventEmitter;
var $935b35782dc2f587$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $935b35782dc2f587$require$Buffer = $ihoyg.Buffer;
var $935b35782dc2f587$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk) {
    return $935b35782dc2f587$require$Buffer.from(chunk);
}
function $935b35782dc2f587$var$_isUint8Array(obj) {
    return $935b35782dc2f587$require$Buffer.isBuffer(obj) || obj instanceof $935b35782dc2f587$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $935b35782dc2f587$var$debug;
if ($5Io6y && $5Io6y.debuglog) $935b35782dc2f587$var$debug = $5Io6y.debuglog("stream");
else $935b35782dc2f587$var$debug = function debug() {};

var $5KjdV = parcelRequire("5KjdV");

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $935b35782dc2f587$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $935b35782dc2f587$require$_require$codes = $dzxhd.codes;
var $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE = $935b35782dc2f587$require$_require$codes.ERR_INVALID_ARG_TYPE, $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF = $935b35782dc2f587$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED = $935b35782dc2f587$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $935b35782dc2f587$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT; // Lazy loaded to improve the startup performance.
var $935b35782dc2f587$var$StringDecoder;
var $935b35782dc2f587$var$createReadableStreamAsyncIterator;
var $935b35782dc2f587$var$from;

(parcelRequire("eSHUL"))($935b35782dc2f587$var$Readable, $j5tZS);
var $935b35782dc2f587$var$errorOrDestroy = $kZIsm.errorOrDestroy;
var $935b35782dc2f587$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $935b35782dc2f587$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn); // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $935b35782dc2f587$var$ReadableState(options, stream, isDuplex) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $935b35782dc2f587$var$Duplex; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $935b35782dc2f587$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex); // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $5KjdV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy; // has it been destroyed
    this.destroyed = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $935b35782dc2f587$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $935b35782dc2f587$var$Readable(options) {
    $935b35782dc2f587$var$Duplex = $935b35782dc2f587$var$Duplex || (parcelRequire("2Hlr9"));
    if (!(this instanceof $935b35782dc2f587$var$Readable)) return new $935b35782dc2f587$var$Readable(options); // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $935b35782dc2f587$var$Duplex;
    this._readableState = new $935b35782dc2f587$var$ReadableState(options, this, isDuplex); // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $j5tZS.call(this);
}
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$935b35782dc2f587$var$Readable.prototype.destroy = $kZIsm.destroy;
$935b35782dc2f587$var$Readable.prototype._undestroy = $kZIsm.undestroy;
$935b35782dc2f587$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
}; // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$935b35782dc2f587$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $935b35782dc2f587$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
}; // Unshift should *always* be something directly out of read()
$935b35782dc2f587$var$Readable.prototype.unshift = function(chunk) {
    return $935b35782dc2f587$var$readableAddChunk(this, chunk, null, true, false);
};
function $935b35782dc2f587$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $935b35782dc2f587$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $935b35782dc2f587$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $935b35782dc2f587$var$chunkInvalid(state, chunk);
        if (er) $935b35782dc2f587$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $935b35782dc2f587$require$Buffer.prototype) chunk = $935b35782dc2f587$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $935b35782dc2f587$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $935b35782dc2f587$var$errorOrDestroy(stream, new $935b35782dc2f587$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
                    else $935b35782dc2f587$var$maybeReadMore(stream, state);
                } else $935b35782dc2f587$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $935b35782dc2f587$var$maybeReadMore(stream, state);
        }
    } // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $935b35782dc2f587$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $935b35782dc2f587$var$emitReadable(stream);
    }
    $935b35782dc2f587$var$maybeReadMore(stream, state);
}
function $935b35782dc2f587$var$chunkInvalid(state, chunk) {
    var er;
    if (!$935b35782dc2f587$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $935b35782dc2f587$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$935b35782dc2f587$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
}; // backwards compatibility.

$935b35782dc2f587$var$Readable.prototype.setEncoding = function(enc) {
    if (!$935b35782dc2f587$var$StringDecoder) $935b35782dc2f587$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $935b35782dc2f587$var$StringDecoder(enc);
    this._readableState.decoder = decoder; // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding; // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
}; // Don't raise the hwm > 1GB
var $935b35782dc2f587$var$MAX_HWM = 0x40000000;
function $935b35782dc2f587$var$computeNewHighWaterMark(n) {
    if (n >= $935b35782dc2f587$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $935b35782dc2f587$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $935b35782dc2f587$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$935b35782dc2f587$var$Readable.prototype.read = function(n) {
    $935b35782dc2f587$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $935b35782dc2f587$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $935b35782dc2f587$var$endReadable(this);
        else $935b35782dc2f587$var$emitReadable(this);
        return null;
    }
    n = $935b35782dc2f587$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $935b35782dc2f587$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $935b35782dc2f587$var$debug("need readable", doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $935b35782dc2f587$var$debug("length less than watermark", doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $935b35782dc2f587$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $935b35782dc2f587$var$debug("do read");
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $935b35782dc2f587$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $935b35782dc2f587$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $935b35782dc2f587$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $935b35782dc2f587$var$onEofChunk(stream, state) {
    $935b35782dc2f587$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $935b35782dc2f587$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $935b35782dc2f587$var$emitReadable_(stream);
        }
    }
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $935b35782dc2f587$var$emitReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $935b35782dc2f587$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($935b35782dc2f587$var$emitReadable_, stream);
    }
}
function $935b35782dc2f587$var$emitReadable_(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    } // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $935b35782dc2f587$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $935b35782dc2f587$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($935b35782dc2f587$var$maybeReadMore_, stream, state);
    }
}
function $935b35782dc2f587$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $935b35782dc2f587$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$935b35782dc2f587$var$Readable.prototype._read = function(n) {
    $935b35782dc2f587$var$errorOrDestroy(this, new $935b35782dc2f587$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$935b35782dc2f587$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $935b35782dc2f587$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $935b35782dc2f587$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $935b35782dc2f587$var$debug("onend");
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $935b35782dc2f587$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $935b35782dc2f587$var$debug("cleanup"); // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $935b35782dc2f587$var$debug("ondata");
        var ret = dest.write(chunk);
        $935b35782dc2f587$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $935b35782dc2f587$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $935b35782dc2f587$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $935b35782dc2f587$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($935b35782dc2f587$var$EElistenerCount(dest, "error") === 0) $935b35782dc2f587$var$errorOrDestroy(dest, er);
    } // Make sure our error handler is attached before userland ones.
    $935b35782dc2f587$var$prependListener(dest, "error", onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $935b35782dc2f587$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $935b35782dc2f587$var$debug("unpipe");
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit("pipe", src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $935b35782dc2f587$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $935b35782dc2f587$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $935b35782dc2f587$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $935b35782dc2f587$var$flow(src);
        }
    };
}
$935b35782dc2f587$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    }; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    } // try to find the right one.
    var index = $935b35782dc2f587$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$935b35782dc2f587$var$Readable.prototype.on = function(ev, fn) {
    var res = $j5tZS.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0; // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $935b35782dc2f587$var$debug("on readable", state.length, state.reading);
            if (state.length) $935b35782dc2f587$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($935b35782dc2f587$var$nReadingNextTick, this);
        }
    }
    return res;
};
$935b35782dc2f587$var$Readable.prototype.addListener = $935b35782dc2f587$var$Readable.prototype.on;
$935b35782dc2f587$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $j5tZS.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
$935b35782dc2f587$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $j5tZS.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($935b35782dc2f587$var$updateReadableListening, this);
    return res;
};
function $935b35782dc2f587$var$updateReadableListening(self) {
    var state = self._readableState;
    state.readableListening = self.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true; // crude way to check if we should resume
    else if (self.listenerCount("data") > 0) self.resume();
}
function $935b35782dc2f587$var$nReadingNextTick(self) {
    $935b35782dc2f587$var$debug("readable nexttick read 0");
    self.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$935b35782dc2f587$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $935b35782dc2f587$var$debug("resume"); // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $935b35782dc2f587$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $935b35782dc2f587$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($935b35782dc2f587$var$resume_, stream, state);
    }
}
function $935b35782dc2f587$var$resume_(stream, state) {
    $935b35782dc2f587$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $935b35782dc2f587$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$935b35782dc2f587$var$Readable.prototype.pause = function() {
    $935b35782dc2f587$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $935b35782dc2f587$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $935b35782dc2f587$var$flow(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$935b35782dc2f587$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $935b35782dc2f587$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $935b35782dc2f587$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    for(var n = 0; n < $935b35782dc2f587$var$kProxyEvents.length; n++)stream.on($935b35782dc2f587$var$kProxyEvents[n], this.emit.bind(this, $935b35782dc2f587$var$kProxyEvents[n]));
     // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $935b35782dc2f587$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($935b35782dc2f587$var$createReadableStreamAsyncIterator === undefined) $935b35782dc2f587$var$createReadableStreamAsyncIterator = (parcelRequire("8BamM"));
    return $935b35782dc2f587$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
}); // exposed for testing purposes only.
$935b35782dc2f587$var$Readable._fromList = $935b35782dc2f587$var$fromList;
Object.defineProperty($935b35782dc2f587$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
}); // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $935b35782dc2f587$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $935b35782dc2f587$var$endReadable(stream) {
    var state = stream._readableState;
    $935b35782dc2f587$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($935b35782dc2f587$var$endReadableNT, state, stream);
    }
}
function $935b35782dc2f587$var$endReadableNT(state, stream) {
    $935b35782dc2f587$var$debug("endReadableNT", state.endEmitted, state.length); // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $935b35782dc2f587$var$Readable.from = function(iterable, opts) {
    if ($935b35782dc2f587$var$from === undefined) $935b35782dc2f587$var$from = (parcelRequire("eGESN"));
    return $935b35782dc2f587$var$from($935b35782dc2f587$var$Readable, iterable, opts);
};
function $935b35782dc2f587$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jMc9N", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $e65bee21a7cdc3da$var$R = typeof Reflect === "object" ? Reflect : null;
var $e65bee21a7cdc3da$var$ReflectApply = $e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.apply === "function" ? $e65bee21a7cdc3da$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $e65bee21a7cdc3da$var$ReflectOwnKeys;
if ($e65bee21a7cdc3da$var$R && typeof $e65bee21a7cdc3da$var$R.ownKeys === "function") $e65bee21a7cdc3da$var$ReflectOwnKeys = $e65bee21a7cdc3da$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $e65bee21a7cdc3da$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $e65bee21a7cdc3da$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $e65bee21a7cdc3da$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $e65bee21a7cdc3da$var$EventEmitter() {
    $e65bee21a7cdc3da$var$EventEmitter.init.call(this);
}
module.exports = $e65bee21a7cdc3da$var$EventEmitter;
module.exports.once = $e65bee21a7cdc3da$var$once;
// Backwards-compat with node 0.10.x
$e65bee21a7cdc3da$var$EventEmitter.EventEmitter = $e65bee21a7cdc3da$var$EventEmitter;
$e65bee21a7cdc3da$var$EventEmitter.prototype._events = undefined;
$e65bee21a7cdc3da$var$EventEmitter.prototype._eventsCount = 0;
$e65bee21a7cdc3da$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $e65bee21a7cdc3da$var$defaultMaxListeners = 10;
function $e65bee21a7cdc3da$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($e65bee21a7cdc3da$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $e65bee21a7cdc3da$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $e65bee21a7cdc3da$var$defaultMaxListeners = arg;
    }
});
$e65bee21a7cdc3da$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$e65bee21a7cdc3da$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $e65bee21a7cdc3da$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $e65bee21a7cdc3da$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $e65bee21a7cdc3da$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $e65bee21a7cdc3da$var$_getMaxListeners(this);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $e65bee21a7cdc3da$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $e65bee21a7cdc3da$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$e65bee21a7cdc3da$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $e65bee21a7cdc3da$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $e65bee21a7cdc3da$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $e65bee21a7cdc3da$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, false);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.on = $e65bee21a7cdc3da$var$EventEmitter.prototype.addListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $e65bee21a7cdc3da$var$_addListener(this, type, listener, true);
};
function $e65bee21a7cdc3da$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $e65bee21a7cdc3da$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $e65bee21a7cdc3da$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.once = function once(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.on(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $e65bee21a7cdc3da$var$checkListener(listener);
    this.prependListener(type, $e65bee21a7cdc3da$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $e65bee21a7cdc3da$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $e65bee21a7cdc3da$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.off = $e65bee21a7cdc3da$var$EventEmitter.prototype.removeListener;
$e65bee21a7cdc3da$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $e65bee21a7cdc3da$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $e65bee21a7cdc3da$var$unwrapListeners(evlistener) : $e65bee21a7cdc3da$var$arrayClone(evlistener, evlistener.length);
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, true);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $e65bee21a7cdc3da$var$_listeners(this, type, false);
};
$e65bee21a7cdc3da$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $e65bee21a7cdc3da$var$listenerCount.call(emitter, type);
};
$e65bee21a7cdc3da$var$EventEmitter.prototype.listenerCount = $e65bee21a7cdc3da$var$listenerCount;
function $e65bee21a7cdc3da$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$e65bee21a7cdc3da$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $e65bee21a7cdc3da$var$ReflectOwnKeys(this._events) : [];
};
function $e65bee21a7cdc3da$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $e65bee21a7cdc3da$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $e65bee21a7cdc3da$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $e65bee21a7cdc3da$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $e65bee21a7cdc3da$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $e65bee21a7cdc3da$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("j5tZS", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("5Io6y", function(module, exports) {
"use strict";

});

parcelRegister("5KjdV", function(module, exports) {
"use strict";
function $42f0290b37cf0d25$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $42f0290b37cf0d25$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $42f0290b37cf0d25$var$ownKeys(Object(source), true).forEach(function(key) {
            $42f0290b37cf0d25$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $42f0290b37cf0d25$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $42f0290b37cf0d25$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $42f0290b37cf0d25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $42f0290b37cf0d25$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $42f0290b37cf0d25$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $42f0290b37cf0d25$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $42f0290b37cf0d25$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

var $ihoyg = parcelRequire("ihoyg");
var $42f0290b37cf0d25$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $42f0290b37cf0d25$var$inspect = $5Io6y.inspect;
var $42f0290b37cf0d25$var$custom = $42f0290b37cf0d25$var$inspect && $42f0290b37cf0d25$var$inspect.custom || "inspect";
function $42f0290b37cf0d25$var$copyBuffer(src, target, offset) {
    $42f0290b37cf0d25$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $42f0290b37cf0d25$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $42f0290b37cf0d25$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $42f0290b37cf0d25$var$Buffer.alloc(0);
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $42f0290b37cf0d25$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            } // Consumes a specified amount of bytes or characters from the buffered data.
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            } // Consumes a specified amount of characters from the buffered data.
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Consumes a specified amount of bytes from the buffered data.
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $42f0290b37cf0d25$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            } // Make sure the linked list only shows the minimal necessary information.
        },
        {
            key: $42f0290b37cf0d25$var$custom,
            value: function value(_, options) {
                return $42f0290b37cf0d25$var$inspect(this, $42f0290b37cf0d25$var$_objectSpread({}, options, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("kZIsm", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict"; // undocumented cb() API, needed for core, not for public API
function $f48bfd4745615c07$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorNT, this, err);
            }
        }
        return this;
    } // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
     // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($f48bfd4745615c07$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($f48bfd4745615c07$var$emitCloseNT, _this);
    });
    return this;
}
function $f48bfd4745615c07$var$emitErrorAndCloseNT(self, err) {
    $f48bfd4745615c07$var$emitErrorNT(self, err);
    $f48bfd4745615c07$var$emitCloseNT(self);
}
function $f48bfd4745615c07$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $f48bfd4745615c07$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $f48bfd4745615c07$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $f48bfd4745615c07$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $f48bfd4745615c07$var$destroy,
    undestroy: $f48bfd4745615c07$var$undestroy,
    errorOrDestroy: $f48bfd4745615c07$var$errorOrDestroy
};

});

parcelRegister("ipGaF", function(module, exports) {
"use strict";

var $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dzxhd")).codes.ERR_INVALID_OPT_VALUE;
function $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $d67b4619993ae46f$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $d67b4619993ae46f$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $d67b4619993ae46f$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    } // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $d67b4619993ae46f$var$getHighWaterMark
};

});
parcelRegister("dzxhd", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $9e185b4d377b7281$export$e45cb6485273080e; }, function (v) { return $9e185b4d377b7281$export$e45cb6485273080e = v; });
var $9e185b4d377b7281$export$e45cb6485273080e;
"use strict";
function $9e185b4d377b7281$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $9e185b4d377b7281$var$codes = {};
function $9e185b4d377b7281$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $9e185b4d377b7281$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $9e185b4d377b7281$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $9e185b4d377b7281$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $9e185b4d377b7281$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $9e185b4d377b7281$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $9e185b4d377b7281$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $9e185b4d377b7281$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($9e185b4d377b7281$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    else {
        var type = $9e185b4d377b7281$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($9e185b4d377b7281$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$9e185b4d377b7281$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$9e185b4d377b7281$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$9e185b4d377b7281$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$9e185b4d377b7281$export$e45cb6485273080e = $9e185b4d377b7281$var$codes;

});


parcelRegister("2Hlr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
/*<replacement>*/ var $1f7039dea5b1b29a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1f7039dea5b1b29a$var$Duplex;

var $cEnbP = parcelRequire("cEnbP");

var $cuAoD = parcelRequire("cuAoD");

(parcelRequire("eSHUL"))($1f7039dea5b1b29a$var$Duplex, $cEnbP);
// Allow the keys array to be GC'ed.
var $1f7039dea5b1b29a$var$keys = $1f7039dea5b1b29a$var$objectKeys($cuAoD.prototype);
for(var $1f7039dea5b1b29a$var$v = 0; $1f7039dea5b1b29a$var$v < $1f7039dea5b1b29a$var$keys.length; $1f7039dea5b1b29a$var$v++){
    var $1f7039dea5b1b29a$var$method = $1f7039dea5b1b29a$var$keys[$1f7039dea5b1b29a$var$v];
    if (!$1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method]) $1f7039dea5b1b29a$var$Duplex.prototype[$1f7039dea5b1b29a$var$method] = $cuAoD.prototype[$1f7039dea5b1b29a$var$method];
}
function $1f7039dea5b1b29a$var$Duplex(options) {
    if (!(this instanceof $1f7039dea5b1b29a$var$Duplex)) return new $1f7039dea5b1b29a$var$Duplex(options);
    $cEnbP.call(this, options);
    $cuAoD.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $1f7039dea5b1b29a$var$onend);
        }
    }
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
}); // the no-half-open enforcer
function $1f7039dea5b1b29a$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($1f7039dea5b1b29a$var$onEndNT, this);
}
function $1f7039dea5b1b29a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1f7039dea5b1b29a$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("cuAoD", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $918484e8c698b555$var$Writable;
/* <replacement> */ function $918484e8c698b555$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $918484e8c698b555$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $918484e8c698b555$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $918484e8c698b555$var$Duplex;
/*</replacement>*/ $918484e8c698b555$var$Writable.WritableState = $918484e8c698b555$var$WritableState;

/*<replacement>*/ var $918484e8c698b555$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $j5tZS = parcelRequire("j5tZS");

var $ihoyg = parcelRequire("ihoyg");
var $918484e8c698b555$require$Buffer = $ihoyg.Buffer;
var $918484e8c698b555$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $918484e8c698b555$var$_uint8ArrayToBuffer(chunk) {
    return $918484e8c698b555$require$Buffer.from(chunk);
}
function $918484e8c698b555$var$_isUint8Array(obj) {
    return $918484e8c698b555$require$Buffer.isBuffer(obj) || obj instanceof $918484e8c698b555$var$OurUint8Array;
}

var $kZIsm = parcelRequire("kZIsm");

var $ipGaF = parcelRequire("ipGaF");
var $918484e8c698b555$var$getHighWaterMark = $ipGaF.getHighWaterMark;

var $dzxhd = parcelRequire("dzxhd");
var $918484e8c698b555$require$_require$codes = $dzxhd.codes;
var $918484e8c698b555$var$ERR_INVALID_ARG_TYPE = $918484e8c698b555$require$_require$codes.ERR_INVALID_ARG_TYPE, $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED = $918484e8c698b555$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK = $918484e8c698b555$require$_require$codes.ERR_MULTIPLE_CALLBACK, $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE = $918484e8c698b555$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $918484e8c698b555$var$ERR_STREAM_DESTROYED = $918484e8c698b555$require$_require$codes.ERR_STREAM_DESTROYED, $918484e8c698b555$var$ERR_STREAM_NULL_VALUES = $918484e8c698b555$require$_require$codes.ERR_STREAM_NULL_VALUES, $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END = $918484e8c698b555$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $918484e8c698b555$var$ERR_UNKNOWN_ENCODING = $918484e8c698b555$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $918484e8c698b555$var$errorOrDestroy = $kZIsm.errorOrDestroy;

(parcelRequire("eSHUL"))($918484e8c698b555$var$Writable, $j5tZS);
function $918484e8c698b555$var$nop() {}

function $918484e8c698b555$var$WritableState(options, stream, isDuplex) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9"));
    options = options || {}; // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $918484e8c698b555$var$Duplex; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $918484e8c698b555$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex); // if _final has been called
    this.finalCalled = false; // drain event flag.
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // has it been destroyed
    this.destroyed = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8"; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $918484e8c698b555$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false; // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(this);
}
$918484e8c698b555$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($918484e8c698b555$var$WritableState.prototype, "buffer", {
            get: $918484e8c698b555$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})(); // Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $918484e8c698b555$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $918484e8c698b555$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($918484e8c698b555$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($918484e8c698b555$var$realHasInstance.call(this, object)) return true;
            if (this !== $918484e8c698b555$var$Writable) return false;
            return object && object._writableState instanceof $918484e8c698b555$var$WritableState;
        }
    });
} else $918484e8c698b555$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $918484e8c698b555$var$Writable(options) {
    $918484e8c698b555$var$Duplex = $918484e8c698b555$var$Duplex || (parcelRequire("2Hlr9")); // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $918484e8c698b555$var$Duplex;
    if (!isDuplex && !$918484e8c698b555$var$realHasInstance.call($918484e8c698b555$var$Writable, this)) return new $918484e8c698b555$var$Writable(options);
    this._writableState = new $918484e8c698b555$var$WritableState(options, this, isDuplex); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $j5tZS.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$918484e8c698b555$var$Writable.prototype.pipe = function() {
    $918484e8c698b555$var$errorOrDestroy(this, new $918484e8c698b555$var$ERR_STREAM_CANNOT_PIPE());
};
function $918484e8c698b555$var$writeAfterEnd(stream, cb) {
    var er = new $918484e8c698b555$var$ERR_STREAM_WRITE_AFTER_END(); // TODO: defer error events consistently everywhere, not just the cb
    $918484e8c698b555$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
} // Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $918484e8c698b555$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $918484e8c698b555$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $918484e8c698b555$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $918484e8c698b555$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$918484e8c698b555$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $918484e8c698b555$var$_isUint8Array(chunk);
    if (isBuf && !$918484e8c698b555$require$Buffer.isBuffer(chunk)) chunk = $918484e8c698b555$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $918484e8c698b555$var$nop;
    if (state.ending) $918484e8c698b555$var$writeAfterEnd(this, cb);
    else if (isBuf || $918484e8c698b555$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $918484e8c698b555$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$918484e8c698b555$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$918484e8c698b555$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(this, state);
    }
};
$918484e8c698b555$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $918484e8c698b555$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $918484e8c698b555$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $918484e8c698b555$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
}); // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $918484e8c698b555$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $918484e8c698b555$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $918484e8c698b555$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $918484e8c698b555$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er); // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($918484e8c698b555$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $918484e8c698b555$var$errorOrDestroy(stream, er); // this can emit finish, but finish must
        // always follow error
        $918484e8c698b555$var$finishMaybe(stream, state);
    }
}
function $918484e8c698b555$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $918484e8c698b555$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $918484e8c698b555$var$ERR_MULTIPLE_CALLBACK();
    $918484e8c698b555$var$onwriteStateUpdate(state);
    if (er) $918484e8c698b555$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $918484e8c698b555$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $918484e8c698b555$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($918484e8c698b555$var$afterWrite, stream, state, finished, cb);
        else $918484e8c698b555$var$afterWrite(stream, state, finished, cb);
    }
}
function $918484e8c698b555$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $918484e8c698b555$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $918484e8c698b555$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $918484e8c698b555$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
} // if there's something in the buffer waiting, then process it
function $918484e8c698b555$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $918484e8c698b555$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $918484e8c698b555$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $918484e8c698b555$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$918484e8c698b555$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $918484e8c698b555$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$918484e8c698b555$var$Writable.prototype._writev = null;
$918484e8c698b555$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending) $918484e8c698b555$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $918484e8c698b555$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $918484e8c698b555$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $918484e8c698b555$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $918484e8c698b555$var$finishMaybe(stream, state);
    });
}
function $918484e8c698b555$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($918484e8c698b555$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $918484e8c698b555$var$finishMaybe(stream, state) {
    var need = $918484e8c698b555$var$needFinish(state);
    if (need) {
        $918484e8c698b555$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $918484e8c698b555$var$endWritable(stream, state, cb) {
    state.ending = true;
    $918484e8c698b555$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $918484e8c698b555$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    } // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($918484e8c698b555$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
         // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$918484e8c698b555$var$Writable.prototype.destroy = $kZIsm.destroy;
$918484e8c698b555$var$Writable.prototype._undestroy = $kZIsm.undestroy;
$918484e8c698b555$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("l4FQK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $f57a6f356a44cf08$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f57a6f356a44cf08$var$deprecate(fn, msg) {
    if ($f57a6f356a44cf08$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f57a6f356a44cf08$var$config("throwDeprecation")) throw new Error(msg);
            else if ($f57a6f356a44cf08$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f57a6f356a44cf08$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("lEpDX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $fc3139ad3bf9c399$export$63a7aa211a91ed69; }, function (v) { return $fc3139ad3bf9c399$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $fc3139ad3bf9c399$export$63a7aa211a91ed69;
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $fc3139ad3bf9c399$require$Buffer = $6U9mG.Buffer;
/*</replacement>*/ var $fc3139ad3bf9c399$var$isEncoding = $fc3139ad3bf9c399$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $fc3139ad3bf9c399$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $fc3139ad3bf9c399$var$normalizeEncoding(enc) {
    var nenc = $fc3139ad3bf9c399$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($fc3139ad3bf9c399$require$Buffer.isEncoding === $fc3139ad3bf9c399$var$isEncoding || !$fc3139ad3bf9c399$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$fc3139ad3bf9c399$export$63a7aa211a91ed69 = $fc3139ad3bf9c399$var$StringDecoder;
function $fc3139ad3bf9c399$var$StringDecoder(encoding) {
    this.encoding = $fc3139ad3bf9c399$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $fc3139ad3bf9c399$var$utf16Text;
            this.end = $fc3139ad3bf9c399$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $fc3139ad3bf9c399$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $fc3139ad3bf9c399$var$base64Text;
            this.end = $fc3139ad3bf9c399$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $fc3139ad3bf9c399$var$simpleWrite;
            this.end = $fc3139ad3bf9c399$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $fc3139ad3bf9c399$require$Buffer.allocUnsafe(nb);
}
$fc3139ad3bf9c399$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$fc3139ad3bf9c399$var$StringDecoder.prototype.end = $fc3139ad3bf9c399$var$utf8End;
// Returns only complete characters in a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.text = $fc3139ad3bf9c399$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$fc3139ad3bf9c399$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $fc3139ad3bf9c399$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $fc3139ad3bf9c399$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $fc3139ad3bf9c399$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $fc3139ad3bf9c399$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $fc3139ad3bf9c399$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $fc3139ad3bf9c399$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $fc3139ad3bf9c399$var$utf8Text(buf, i) {
    var total = $fc3139ad3bf9c399$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $fc3139ad3bf9c399$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $fc3139ad3bf9c399$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $fc3139ad3bf9c399$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $fc3139ad3bf9c399$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $fc3139ad3bf9c399$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $fc3139ad3bf9c399$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $fc3139ad3bf9c399$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("8BamM", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $6429d1f92cebcf33$var$_Object$setPrototypeO;
function $6429d1f92cebcf33$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

var $gr8mb = parcelRequire("gr8mb");
var $6429d1f92cebcf33$var$kLastResolve = Symbol("lastResolve");
var $6429d1f92cebcf33$var$kLastReject = Symbol("lastReject");
var $6429d1f92cebcf33$var$kError = Symbol("error");
var $6429d1f92cebcf33$var$kEnded = Symbol("ended");
var $6429d1f92cebcf33$var$kLastPromise = Symbol("lastPromise");
var $6429d1f92cebcf33$var$kHandlePromise = Symbol("handlePromise");
var $6429d1f92cebcf33$var$kStream = Symbol("stream");
function $6429d1f92cebcf33$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $6429d1f92cebcf33$var$readAndResolve(iter) {
    var resolve = iter[$6429d1f92cebcf33$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$6429d1f92cebcf33$var$kStream].read(); // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$6429d1f92cebcf33$var$kLastPromise] = null;
            iter[$6429d1f92cebcf33$var$kLastResolve] = null;
            iter[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(data, false));
        }
    }
}
function $6429d1f92cebcf33$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($6429d1f92cebcf33$var$readAndResolve, iter);
}
function $6429d1f92cebcf33$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$6429d1f92cebcf33$var$kEnded]) {
                resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
                return;
            }
            iter[$6429d1f92cebcf33$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $6429d1f92cebcf33$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($6429d1f92cebcf33$var$_Object$setPrototypeO = {
    get stream () {
        return this[$6429d1f92cebcf33$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$6429d1f92cebcf33$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$6429d1f92cebcf33$var$kEnded]) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        if (this[$6429d1f92cebcf33$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$6429d1f92cebcf33$var$kError]) reject(_this[$6429d1f92cebcf33$var$kError]);
                else resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
            });
        });
         // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$6429d1f92cebcf33$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($6429d1f92cebcf33$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$6429d1f92cebcf33$var$kStream].read();
            if (data !== null) return Promise.resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            promise = new Promise(this[$6429d1f92cebcf33$var$kHandlePromise]);
        }
        this[$6429d1f92cebcf33$var$kLastPromise] = promise;
        return promise;
    }
}, $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $6429d1f92cebcf33$var$_defineProperty($6429d1f92cebcf33$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$6429d1f92cebcf33$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        });
    });
}), $6429d1f92cebcf33$var$_Object$setPrototypeO), $6429d1f92cebcf33$var$AsyncIteratorPrototype);
var $6429d1f92cebcf33$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($6429d1f92cebcf33$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kStream, {
        value: stream,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastResolve, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kLastReject, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kError, {
        value: null,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $6429d1f92cebcf33$var$_defineProperty(_Object$create, $6429d1f92cebcf33$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$6429d1f92cebcf33$var$kStream].read();
            if (data) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                resolve($6429d1f92cebcf33$var$createIterResult(data, false));
            } else {
                iterator[$6429d1f92cebcf33$var$kLastResolve] = resolve;
                iterator[$6429d1f92cebcf33$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
    $gr8mb(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$6429d1f92cebcf33$var$kLastReject]; // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
                iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
                iterator[$6429d1f92cebcf33$var$kLastReject] = null;
                reject(err);
            }
            iterator[$6429d1f92cebcf33$var$kError] = err;
            return;
        }
        var resolve = iterator[$6429d1f92cebcf33$var$kLastResolve];
        if (resolve !== null) {
            iterator[$6429d1f92cebcf33$var$kLastPromise] = null;
            iterator[$6429d1f92cebcf33$var$kLastResolve] = null;
            iterator[$6429d1f92cebcf33$var$kLastReject] = null;
            resolve($6429d1f92cebcf33$var$createIterResult(undefined, true));
        }
        iterator[$6429d1f92cebcf33$var$kEnded] = true;
    });
    stream.on("readable", $6429d1f92cebcf33$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $6429d1f92cebcf33$var$createReadableStreamAsyncIterator;

});
parcelRegister("gr8mb", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dzxhd")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $bf75a6707710fb34$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $bf75a6707710fb34$var$noop() {}
function $bf75a6707710fb34$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $bf75a6707710fb34$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $bf75a6707710fb34$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $bf75a6707710fb34$var$once(callback || $bf75a6707710fb34$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $bf75a6707710fb34$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($bf75a6707710fb34$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $bf75a6707710fb34$var$eos;

});


parcelRegister("eGESN", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("l7DDn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $f608fef10a5347dd$var$Transform;

var $dzxhd = parcelRequire("dzxhd");
var $f608fef10a5347dd$require$_require$codes = $dzxhd.codes;
var $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED = $f608fef10a5347dd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK = $f608fef10a5347dd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0 = $f608fef10a5347dd$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $2Hlr9 = parcelRequire("2Hlr9");

(parcelRequire("eSHUL"))($f608fef10a5347dd$var$Transform, $2Hlr9);
function $f608fef10a5347dd$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $f608fef10a5347dd$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $f608fef10a5347dd$var$Transform(options) {
    if (!(this instanceof $f608fef10a5347dd$var$Transform)) return new $f608fef10a5347dd$var$Transform(options);
    $2Hlr9.call(this, options);
    this._transformState = {
        afterTransform: $f608fef10a5347dd$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    }; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    } // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $f608fef10a5347dd$var$prefinish);
}
function $f608fef10a5347dd$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $f608fef10a5347dd$var$done(_this, er, data);
    });
    else $f608fef10a5347dd$var$done(this, null, null);
}
$f608fef10a5347dd$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Hlr9.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$f608fef10a5347dd$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $f608fef10a5347dd$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$f608fef10a5347dd$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$f608fef10a5347dd$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$f608fef10a5347dd$var$Transform.prototype._destroy = function(err, cb) {
    $2Hlr9.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $f608fef10a5347dd$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data); // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $f608fef10a5347dd$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6VFzs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $50b8500ab5b3088d$var$PassThrough;

var $l7DDn = parcelRequire("l7DDn");

(parcelRequire("eSHUL"))($50b8500ab5b3088d$var$PassThrough, $l7DDn);
function $50b8500ab5b3088d$var$PassThrough(options) {
    if (!(this instanceof $50b8500ab5b3088d$var$PassThrough)) return new $50b8500ab5b3088d$var$PassThrough(options);
    $l7DDn.call(this, options);
}
$50b8500ab5b3088d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("e8JAK", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $a4b52da101f8f158$var$eos;
function $a4b52da101f8f158$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dzxhd = parcelRequire("dzxhd");
var $a4b52da101f8f158$require$_require$codes = $dzxhd.codes;
var $a4b52da101f8f158$var$ERR_MISSING_ARGS = $a4b52da101f8f158$require$_require$codes.ERR_MISSING_ARGS, $a4b52da101f8f158$var$ERR_STREAM_DESTROYED = $a4b52da101f8f158$require$_require$codes.ERR_STREAM_DESTROYED;
function $a4b52da101f8f158$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $a4b52da101f8f158$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $a4b52da101f8f158$var$destroyer(stream, reading, writing, callback) {
    callback = $a4b52da101f8f158$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($a4b52da101f8f158$var$eos === undefined) $a4b52da101f8f158$var$eos = (parcelRequire("gr8mb"));
    $a4b52da101f8f158$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true; // request.destroy just do .end - .abort is what we want
        if ($a4b52da101f8f158$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $a4b52da101f8f158$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $a4b52da101f8f158$var$call(fn) {
    fn();
}
function $a4b52da101f8f158$var$pipe(from, to) {
    return from.pipe(to);
}
function $a4b52da101f8f158$var$popCallback(streams) {
    if (!streams.length) return $a4b52da101f8f158$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $a4b52da101f8f158$var$noop;
    return streams.pop();
}
function $a4b52da101f8f158$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $a4b52da101f8f158$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $a4b52da101f8f158$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $a4b52da101f8f158$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($a4b52da101f8f158$var$call);
            if (reading) return;
            destroys.forEach($a4b52da101f8f158$var$call);
            callback(error);
        });
    });
    return streams.reduce($a4b52da101f8f158$var$pipe);
}
module.exports = $a4b52da101f8f158$var$pipeline;

});




parcelRegister("cjuEr", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $8f6f09199cc1903f$require$Buffer = $ihoyg.Buffer;

var $eSHUL = parcelRequire("eSHUL");

var $9aUYR = parcelRequire("9aUYR");
var $8f6f09199cc1903f$var$ARRAY16 = new Array(16);
var $8f6f09199cc1903f$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $8f6f09199cc1903f$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $8f6f09199cc1903f$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $8f6f09199cc1903f$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $8f6f09199cc1903f$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $8f6f09199cc1903f$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $8f6f09199cc1903f$var$RIPEMD160() {
    $9aUYR.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$eSHUL($8f6f09199cc1903f$var$RIPEMD160, $9aUYR);
$8f6f09199cc1903f$var$RIPEMD160.prototype._update = function() {
    var words = $8f6f09199cc1903f$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $8f6f09199cc1903f$var$fn1(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[0], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn5(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[0], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 32) {
            tl = $8f6f09199cc1903f$var$fn2(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[1], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn4(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[1], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 48) {
            tl = $8f6f09199cc1903f$var$fn3(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[2], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn3(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[2], $8f6f09199cc1903f$var$sr[i]);
        } else if (i < 64) {
            tl = $8f6f09199cc1903f$var$fn4(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[3], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn2(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[3], $8f6f09199cc1903f$var$sr[i]);
        } else {
            tl = $8f6f09199cc1903f$var$fn5(al, bl, cl, dl, el, words[$8f6f09199cc1903f$var$zl[i]], $8f6f09199cc1903f$var$hl[4], $8f6f09199cc1903f$var$sl[i]);
            tr = $8f6f09199cc1903f$var$fn1(ar, br, cr, dr, er, words[$8f6f09199cc1903f$var$zr[i]], $8f6f09199cc1903f$var$hr[4], $8f6f09199cc1903f$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $8f6f09199cc1903f$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $8f6f09199cc1903f$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$8f6f09199cc1903f$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $8f6f09199cc1903f$require$Buffer.alloc ? $8f6f09199cc1903f$require$Buffer.alloc(20) : new $8f6f09199cc1903f$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $8f6f09199cc1903f$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $8f6f09199cc1903f$var$fn1(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn2(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn3(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn4(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $8f6f09199cc1903f$var$fn5(a, b, c, d, e, m, k, s) {
    return $8f6f09199cc1903f$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $8f6f09199cc1903f$var$RIPEMD160;

});

parcelRegister("fkJVr", function(module, exports) {
var $b29c591d3a8bb26b$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $b29c591d3a8bb26b$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$b29c591d3a8bb26b$var$exports.sha = (parcelRequire("g2uoB"));

$b29c591d3a8bb26b$var$exports.sha1 = (parcelRequire("lyJtz"));

$b29c591d3a8bb26b$var$exports.sha224 = (parcelRequire("cwjAo"));

$b29c591d3a8bb26b$var$exports.sha256 = (parcelRequire("1o1iT"));

$b29c591d3a8bb26b$var$exports.sha384 = (parcelRequire("kWtXA"));

$b29c591d3a8bb26b$var$exports.sha512 = (parcelRequire("1HQNC"));

});
parcelRegister("g2uoB", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $bad46934fbfe816d$require$Buffer = $6U9mG.Buffer;
var $bad46934fbfe816d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $bad46934fbfe816d$var$W = new Array(80);
function $bad46934fbfe816d$var$Sha() {
    this.init();
    this._w = $bad46934fbfe816d$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($bad46934fbfe816d$var$Sha, $6fUHB);
$bad46934fbfe816d$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $bad46934fbfe816d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $bad46934fbfe816d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $bad46934fbfe816d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$bad46934fbfe816d$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $bad46934fbfe816d$var$rotl5(a) + $bad46934fbfe816d$var$ft(s, b, c, d) + e + W[j] + $bad46934fbfe816d$var$K[s] | 0;
        e = d;
        d = c;
        c = $bad46934fbfe816d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$bad46934fbfe816d$var$Sha.prototype._hash = function() {
    var H = $bad46934fbfe816d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $bad46934fbfe816d$var$Sha;

});
parcelRegister("6fUHB", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $48e020b2c4716d14$require$Buffer = $6U9mG.Buffer;
// prototype class for hash functions
function $48e020b2c4716d14$var$Hash(blockSize, finalSize) {
    this._block = $48e020b2c4716d14$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$48e020b2c4716d14$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $48e020b2c4716d14$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$48e020b2c4716d14$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$48e020b2c4716d14$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $48e020b2c4716d14$var$Hash;

});


parcelRegister("lyJtz", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $fb200c8a1442e09f$require$Buffer = $6U9mG.Buffer;
var $fb200c8a1442e09f$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $fb200c8a1442e09f$var$W = new Array(80);
function $fb200c8a1442e09f$var$Sha1() {
    this.init();
    this._w = $fb200c8a1442e09f$var$W;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($fb200c8a1442e09f$var$Sha1, $6fUHB);
$fb200c8a1442e09f$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $fb200c8a1442e09f$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $fb200c8a1442e09f$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $fb200c8a1442e09f$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $fb200c8a1442e09f$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$fb200c8a1442e09f$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $fb200c8a1442e09f$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $fb200c8a1442e09f$var$rotl5(a) + $fb200c8a1442e09f$var$ft(s, b, c, d) + e + W[j] + $fb200c8a1442e09f$var$K[s] | 0;
        e = d;
        d = c;
        c = $fb200c8a1442e09f$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$fb200c8a1442e09f$var$Sha1.prototype._hash = function() {
    var H = $fb200c8a1442e09f$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $fb200c8a1442e09f$var$Sha1;

});

parcelRegister("cwjAo", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $1o1iT = parcelRequire("1o1iT");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $91d7aa8b17a16320$require$Buffer = $6U9mG.Buffer;
var $91d7aa8b17a16320$var$W = new Array(64);
function $91d7aa8b17a16320$var$Sha224() {
    this.init();
    this._w = $91d7aa8b17a16320$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($91d7aa8b17a16320$var$Sha224, $1o1iT);
$91d7aa8b17a16320$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$91d7aa8b17a16320$var$Sha224.prototype._hash = function() {
    var H = $91d7aa8b17a16320$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $91d7aa8b17a16320$var$Sha224;

});
parcelRegister("1o1iT", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $10290b3c9978cdf8$require$Buffer = $6U9mG.Buffer;
var $10290b3c9978cdf8$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $10290b3c9978cdf8$var$W = new Array(64);
function $10290b3c9978cdf8$var$Sha256() {
    this.init();
    this._w = $10290b3c9978cdf8$var$W // new Array(64)
    ;
    $6fUHB.call(this, 64, 56);
}
$eSHUL($10290b3c9978cdf8$var$Sha256, $6fUHB);
$10290b3c9978cdf8$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $10290b3c9978cdf8$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $10290b3c9978cdf8$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $10290b3c9978cdf8$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $10290b3c9978cdf8$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $10290b3c9978cdf8$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $10290b3c9978cdf8$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$10290b3c9978cdf8$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $10290b3c9978cdf8$var$gamma1(W[i - 2]) + W[i - 7] + $10290b3c9978cdf8$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $10290b3c9978cdf8$var$sigma1(e) + $10290b3c9978cdf8$var$ch(e, f, g) + $10290b3c9978cdf8$var$K[j] + W[j] | 0;
        var T2 = $10290b3c9978cdf8$var$sigma0(a) + $10290b3c9978cdf8$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$10290b3c9978cdf8$var$Sha256.prototype._hash = function() {
    var H = $10290b3c9978cdf8$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $10290b3c9978cdf8$var$Sha256;

});


parcelRegister("kWtXA", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $1HQNC = parcelRequire("1HQNC");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $f3f076e48793fba5$require$Buffer = $6U9mG.Buffer;
var $f3f076e48793fba5$var$W = new Array(160);
function $f3f076e48793fba5$var$Sha384() {
    this.init();
    this._w = $f3f076e48793fba5$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($f3f076e48793fba5$var$Sha384, $1HQNC);
$f3f076e48793fba5$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$f3f076e48793fba5$var$Sha384.prototype._hash = function() {
    var H = $f3f076e48793fba5$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $f3f076e48793fba5$var$Sha384;

});
parcelRegister("1HQNC", function(module, exports) {

var $eSHUL = parcelRequire("eSHUL");

var $6fUHB = parcelRequire("6fUHB");

var $6U9mG = parcelRequire("6U9mG");
var $13e2c371a41c8789$require$Buffer = $6U9mG.Buffer;
var $13e2c371a41c8789$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $13e2c371a41c8789$var$W = new Array(160);
function $13e2c371a41c8789$var$Sha512() {
    this.init();
    this._w = $13e2c371a41c8789$var$W;
    $6fUHB.call(this, 128, 112);
}
$eSHUL($13e2c371a41c8789$var$Sha512, $6fUHB);
$13e2c371a41c8789$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $13e2c371a41c8789$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $13e2c371a41c8789$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $13e2c371a41c8789$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $13e2c371a41c8789$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $13e2c371a41c8789$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $13e2c371a41c8789$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $13e2c371a41c8789$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $13e2c371a41c8789$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $13e2c371a41c8789$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$13e2c371a41c8789$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $13e2c371a41c8789$var$Gamma0(xh, xl);
        var gamma0l = $13e2c371a41c8789$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $13e2c371a41c8789$var$Gamma1(xh, xl);
        var gamma1l = $13e2c371a41c8789$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $13e2c371a41c8789$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $13e2c371a41c8789$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $13e2c371a41c8789$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $13e2c371a41c8789$var$maj(ah, bh, ch);
        var majl = $13e2c371a41c8789$var$maj(al, bl, cl);
        var sigma0h = $13e2c371a41c8789$var$sigma0(ah, al);
        var sigma0l = $13e2c371a41c8789$var$sigma0(al, ah);
        var sigma1h = $13e2c371a41c8789$var$sigma1(eh, el);
        var sigma1l = $13e2c371a41c8789$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $13e2c371a41c8789$var$K[j];
        var Kil = $13e2c371a41c8789$var$K[j + 1];
        var chh = $13e2c371a41c8789$var$Ch(eh, fh, gh);
        var chl = $13e2c371a41c8789$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $13e2c371a41c8789$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $13e2c371a41c8789$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $13e2c371a41c8789$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $13e2c371a41c8789$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $13e2c371a41c8789$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $13e2c371a41c8789$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $13e2c371a41c8789$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $13e2c371a41c8789$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $13e2c371a41c8789$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $13e2c371a41c8789$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $13e2c371a41c8789$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $13e2c371a41c8789$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $13e2c371a41c8789$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $13e2c371a41c8789$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $13e2c371a41c8789$var$getCarry(this._hl, hl) | 0;
};
$13e2c371a41c8789$var$Sha512.prototype._hash = function() {
    var H = $13e2c371a41c8789$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $13e2c371a41c8789$var$Sha512;

});



parcelRegister("fpHcA", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $b38ab3d1a7f86ec9$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $b38ab3d1a7f86ec9$require$Transform = $bks2w.Transform;

var $lEpDX = parcelRequire("lEpDX");
var $b38ab3d1a7f86ec9$require$StringDecoder = $lEpDX.StringDecoder;

var $eSHUL = parcelRequire("eSHUL");
function $b38ab3d1a7f86ec9$var$CipherBase(hashMode) {
    $b38ab3d1a7f86ec9$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$eSHUL($b38ab3d1a7f86ec9$var$CipherBase, $b38ab3d1a7f86ec9$require$Transform);
$b38ab3d1a7f86ec9$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $b38ab3d1a7f86ec9$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAutoPadding = function() {};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $b38ab3d1a7f86ec9$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$b38ab3d1a7f86ec9$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $b38ab3d1a7f86ec9$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $b38ab3d1a7f86ec9$var$CipherBase;

});
parcelRegister("bks2w", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $83f7500f17fcc367$var$Stream;

var $jMc9N = parcelRequire("jMc9N");
var $83f7500f17fcc367$require$EE = $jMc9N.EventEmitter;

var $eSHUL = parcelRequire("eSHUL");
$eSHUL($83f7500f17fcc367$var$Stream, $83f7500f17fcc367$require$EE);

$83f7500f17fcc367$var$Stream.Readable = (parcelRequire("gbyK3"));

$83f7500f17fcc367$var$Stream.Writable = (parcelRequire("7OiFs"));

$83f7500f17fcc367$var$Stream.Duplex = (parcelRequire("gb1AQ"));

$83f7500f17fcc367$var$Stream.Transform = (parcelRequire("7ozOp"));

$83f7500f17fcc367$var$Stream.PassThrough = (parcelRequire("6qwr0"));

$83f7500f17fcc367$var$Stream.finished = (parcelRequire("bMXnq"));

$83f7500f17fcc367$var$Stream.pipeline = (parcelRequire("46RH2"));
// Backwards-compat with node 0.4.x
$83f7500f17fcc367$var$Stream.Stream = $83f7500f17fcc367$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $83f7500f17fcc367$var$Stream() {
    $83f7500f17fcc367$require$EE.call(this);
}
$83f7500f17fcc367$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($83f7500f17fcc367$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("gbyK3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $bc889f6f92aedec0$var$Readable;
/*<replacement>*/ var $bc889f6f92aedec0$var$Duplex;
/*</replacement>*/ $bc889f6f92aedec0$var$Readable.ReadableState = $bc889f6f92aedec0$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $bc889f6f92aedec0$require$EE = $jMc9N.EventEmitter;
var $bc889f6f92aedec0$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jzO5Y = parcelRequire("jzO5Y");

var $ihoyg = parcelRequire("ihoyg");
var $bc889f6f92aedec0$require$Buffer = $ihoyg.Buffer;
var $bc889f6f92aedec0$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $bc889f6f92aedec0$var$_uint8ArrayToBuffer(chunk) {
    return $bc889f6f92aedec0$require$Buffer.from(chunk);
}
function $bc889f6f92aedec0$var$_isUint8Array(obj) {
    return $bc889f6f92aedec0$require$Buffer.isBuffer(obj) || obj instanceof $bc889f6f92aedec0$var$OurUint8Array;
}

var $5Io6y = parcelRequire("5Io6y");
var $bc889f6f92aedec0$var$debug;
if ($5Io6y && $5Io6y.debuglog) $bc889f6f92aedec0$var$debug = $5Io6y.debuglog("stream");
else $bc889f6f92aedec0$var$debug = function debug() {};

var $6OboF = parcelRequire("6OboF");

var $hgvHE = parcelRequire("hgvHE");

var $1qNnQ = parcelRequire("1qNnQ");
var $bc889f6f92aedec0$var$getHighWaterMark = $1qNnQ.getHighWaterMark;

var $dRF2w = parcelRequire("dRF2w");
var $bc889f6f92aedec0$require$_require$codes = $dRF2w.codes;
var $bc889f6f92aedec0$var$ERR_INVALID_ARG_TYPE = $bc889f6f92aedec0$require$_require$codes.ERR_INVALID_ARG_TYPE, $bc889f6f92aedec0$var$ERR_STREAM_PUSH_AFTER_EOF = $bc889f6f92aedec0$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $bc889f6f92aedec0$var$ERR_METHOD_NOT_IMPLEMENTED = $bc889f6f92aedec0$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $bc889f6f92aedec0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $bc889f6f92aedec0$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $bc889f6f92aedec0$var$StringDecoder;
var $bc889f6f92aedec0$var$createReadableStreamAsyncIterator;
var $bc889f6f92aedec0$var$from;

(parcelRequire("eSHUL"))($bc889f6f92aedec0$var$Readable, $jzO5Y);
var $bc889f6f92aedec0$var$errorOrDestroy = $hgvHE.errorOrDestroy;
var $bc889f6f92aedec0$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $bc889f6f92aedec0$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $bc889f6f92aedec0$var$ReadableState(options, stream, isDuplex) {
    $bc889f6f92aedec0$var$Duplex = $bc889f6f92aedec0$var$Duplex || (parcelRequire("gb1AQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $bc889f6f92aedec0$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $bc889f6f92aedec0$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6OboF();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$bc889f6f92aedec0$var$StringDecoder) $bc889f6f92aedec0$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
        this.decoder = new $bc889f6f92aedec0$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bc889f6f92aedec0$var$Readable(options) {
    $bc889f6f92aedec0$var$Duplex = $bc889f6f92aedec0$var$Duplex || (parcelRequire("gb1AQ"));
    if (!(this instanceof $bc889f6f92aedec0$var$Readable)) return new $bc889f6f92aedec0$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $bc889f6f92aedec0$var$Duplex;
    this._readableState = new $bc889f6f92aedec0$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jzO5Y.call(this);
}
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$bc889f6f92aedec0$var$Readable.prototype.destroy = $hgvHE.destroy;
$bc889f6f92aedec0$var$Readable.prototype._undestroy = $hgvHE.undestroy;
$bc889f6f92aedec0$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bc889f6f92aedec0$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $bc889f6f92aedec0$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $bc889f6f92aedec0$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$bc889f6f92aedec0$var$Readable.prototype.unshift = function(chunk) {
    return $bc889f6f92aedec0$var$readableAddChunk(this, chunk, null, true, false);
};
function $bc889f6f92aedec0$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $bc889f6f92aedec0$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $bc889f6f92aedec0$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $bc889f6f92aedec0$var$chunkInvalid(state, chunk);
        if (er) $bc889f6f92aedec0$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $bc889f6f92aedec0$require$Buffer.prototype) chunk = $bc889f6f92aedec0$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $bc889f6f92aedec0$var$errorOrDestroy(stream, new $bc889f6f92aedec0$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $bc889f6f92aedec0$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $bc889f6f92aedec0$var$errorOrDestroy(stream, new $bc889f6f92aedec0$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $bc889f6f92aedec0$var$addChunk(stream, state, chunk, false);
                    else $bc889f6f92aedec0$var$maybeReadMore(stream, state);
                } else $bc889f6f92aedec0$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $bc889f6f92aedec0$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $bc889f6f92aedec0$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $bc889f6f92aedec0$var$emitReadable(stream);
    }
    $bc889f6f92aedec0$var$maybeReadMore(stream, state);
}
function $bc889f6f92aedec0$var$chunkInvalid(state, chunk) {
    var er;
    if (!$bc889f6f92aedec0$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $bc889f6f92aedec0$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$bc889f6f92aedec0$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$bc889f6f92aedec0$var$Readable.prototype.setEncoding = function(enc) {
    if (!$bc889f6f92aedec0$var$StringDecoder) $bc889f6f92aedec0$var$StringDecoder = (parcelRequire("lEpDX")).StringDecoder;
    var decoder = new $bc889f6f92aedec0$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $bc889f6f92aedec0$var$MAX_HWM = 0x40000000;
function $bc889f6f92aedec0$var$computeNewHighWaterMark(n) {
    if (n >= $bc889f6f92aedec0$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $bc889f6f92aedec0$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc889f6f92aedec0$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bc889f6f92aedec0$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$bc889f6f92aedec0$var$Readable.prototype.read = function(n) {
    $bc889f6f92aedec0$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $bc889f6f92aedec0$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $bc889f6f92aedec0$var$endReadable(this);
        else $bc889f6f92aedec0$var$emitReadable(this);
        return null;
    }
    n = $bc889f6f92aedec0$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bc889f6f92aedec0$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $bc889f6f92aedec0$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bc889f6f92aedec0$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $bc889f6f92aedec0$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $bc889f6f92aedec0$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bc889f6f92aedec0$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bc889f6f92aedec0$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bc889f6f92aedec0$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $bc889f6f92aedec0$var$onEofChunk(stream, state) {
    $bc889f6f92aedec0$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $bc889f6f92aedec0$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $bc889f6f92aedec0$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bc889f6f92aedec0$var$emitReadable(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bc889f6f92aedec0$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$emitReadable_, stream);
    }
}
function $bc889f6f92aedec0$var$emitReadable_(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $bc889f6f92aedec0$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bc889f6f92aedec0$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$maybeReadMore_, stream, state);
    }
}
function $bc889f6f92aedec0$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $bc889f6f92aedec0$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bc889f6f92aedec0$var$Readable.prototype._read = function(n) {
    $bc889f6f92aedec0$var$errorOrDestroy(this, new $bc889f6f92aedec0$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$bc889f6f92aedec0$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $bc889f6f92aedec0$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4TNnu.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bc889f6f92aedec0$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bc889f6f92aedec0$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $bc889f6f92aedec0$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $bc889f6f92aedec0$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $bc889f6f92aedec0$var$debug("ondata");
        var ret = dest.write(chunk);
        $bc889f6f92aedec0$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $bc889f6f92aedec0$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $bc889f6f92aedec0$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bc889f6f92aedec0$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($bc889f6f92aedec0$var$EElistenerCount(dest, "error") === 0) $bc889f6f92aedec0$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $bc889f6f92aedec0$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $bc889f6f92aedec0$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $bc889f6f92aedec0$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $bc889f6f92aedec0$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $bc889f6f92aedec0$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $bc889f6f92aedec0$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $bc889f6f92aedec0$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $bc889f6f92aedec0$var$flow(src);
        }
    };
}
$bc889f6f92aedec0$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $bc889f6f92aedec0$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$bc889f6f92aedec0$var$Readable.prototype.on = function(ev, fn) {
    var res = $jzO5Y.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $bc889f6f92aedec0$var$debug("on readable", state.length, state.reading);
            if (state.length) $bc889f6f92aedec0$var$emitReadable(this);
            else if (!state.reading) $4TNnu.nextTick($bc889f6f92aedec0$var$nReadingNextTick, this);
        }
    }
    return res;
};
$bc889f6f92aedec0$var$Readable.prototype.addListener = $bc889f6f92aedec0$var$Readable.prototype.on;
$bc889f6f92aedec0$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jzO5Y.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($bc889f6f92aedec0$var$updateReadableListening, this);
    return res;
};
$bc889f6f92aedec0$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jzO5Y.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4TNnu.nextTick($bc889f6f92aedec0$var$updateReadableListening, this);
    return res;
};
function $bc889f6f92aedec0$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $bc889f6f92aedec0$var$nReadingNextTick(self1) {
    $bc889f6f92aedec0$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bc889f6f92aedec0$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bc889f6f92aedec0$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $bc889f6f92aedec0$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $bc889f6f92aedec0$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$resume_, stream, state);
    }
}
function $bc889f6f92aedec0$var$resume_(stream, state) {
    $bc889f6f92aedec0$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $bc889f6f92aedec0$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bc889f6f92aedec0$var$Readable.prototype.pause = function() {
    $bc889f6f92aedec0$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $bc889f6f92aedec0$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $bc889f6f92aedec0$var$flow(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bc889f6f92aedec0$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $bc889f6f92aedec0$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $bc889f6f92aedec0$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $bc889f6f92aedec0$var$kProxyEvents.length; n++)stream.on($bc889f6f92aedec0$var$kProxyEvents[n], this.emit.bind(this, $bc889f6f92aedec0$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $bc889f6f92aedec0$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $bc889f6f92aedec0$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($bc889f6f92aedec0$var$createReadableStreamAsyncIterator === undefined) $bc889f6f92aedec0$var$createReadableStreamAsyncIterator = (parcelRequire("j2AXH"));
    return $bc889f6f92aedec0$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$bc889f6f92aedec0$var$Readable._fromList = $bc889f6f92aedec0$var$fromList;
Object.defineProperty($bc889f6f92aedec0$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bc889f6f92aedec0$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $bc889f6f92aedec0$var$endReadable(stream) {
    var state = stream._readableState;
    $bc889f6f92aedec0$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4TNnu.nextTick($bc889f6f92aedec0$var$endReadableNT, state, stream);
    }
}
function $bc889f6f92aedec0$var$endReadableNT(state, stream) {
    $bc889f6f92aedec0$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $bc889f6f92aedec0$var$Readable.from = function(iterable, opts) {
    if ($bc889f6f92aedec0$var$from === undefined) $bc889f6f92aedec0$var$from = (parcelRequire("9fR9D"));
    return $bc889f6f92aedec0$var$from($bc889f6f92aedec0$var$Readable, iterable, opts);
};
function $bc889f6f92aedec0$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jzO5Y", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("6OboF", function(module, exports) {
"use strict";
function $4f5040c8913da7e7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f5040c8913da7e7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4f5040c8913da7e7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4f5040c8913da7e7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4f5040c8913da7e7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f5040c8913da7e7$var$_defineProperty(obj, key, value) {
    key = $4f5040c8913da7e7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4f5040c8913da7e7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4f5040c8913da7e7$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4f5040c8913da7e7$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4f5040c8913da7e7$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4f5040c8913da7e7$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4f5040c8913da7e7$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4f5040c8913da7e7$var$_toPropertyKey(arg) {
    var key = $4f5040c8913da7e7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $4f5040c8913da7e7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $ihoyg = parcelRequire("ihoyg");
var $4f5040c8913da7e7$var$Buffer = $ihoyg.Buffer;

var $5Io6y = parcelRequire("5Io6y");
var $4f5040c8913da7e7$var$inspect = $5Io6y.inspect;
var $4f5040c8913da7e7$var$custom = $4f5040c8913da7e7$var$inspect && $4f5040c8913da7e7$var$inspect.custom || "inspect";
function $4f5040c8913da7e7$var$copyBuffer(src, target, offset) {
    $4f5040c8913da7e7$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $4f5040c8913da7e7$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $4f5040c8913da7e7$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $4f5040c8913da7e7$var$Buffer.alloc(0);
                var ret = $4f5040c8913da7e7$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $4f5040c8913da7e7$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $4f5040c8913da7e7$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $4f5040c8913da7e7$var$custom,
            value: function value(_, options) {
                return $4f5040c8913da7e7$var$inspect(this, $4f5040c8913da7e7$var$_objectSpread($4f5040c8913da7e7$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("hgvHE", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $c91c85d93ea50665$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4TNnu.nextTick($c91c85d93ea50665$var$emitErrorAndCloseNT, _this, err);
            } else $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
        } else if (cb) {
            $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
            cb(err);
        } else $4TNnu.nextTick($c91c85d93ea50665$var$emitCloseNT, _this);
    });
    return this;
}
function $c91c85d93ea50665$var$emitErrorAndCloseNT(self, err) {
    $c91c85d93ea50665$var$emitErrorNT(self, err);
    $c91c85d93ea50665$var$emitCloseNT(self);
}
function $c91c85d93ea50665$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $c91c85d93ea50665$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $c91c85d93ea50665$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $c91c85d93ea50665$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $c91c85d93ea50665$var$destroy,
    undestroy: $c91c85d93ea50665$var$undestroy,
    errorOrDestroy: $c91c85d93ea50665$var$errorOrDestroy
};

});

parcelRegister("1qNnQ", function(module, exports) {
"use strict";

var $10ae86b99ba11b35$var$ERR_INVALID_OPT_VALUE = (parcelRequire("dRF2w")).codes.ERR_INVALID_OPT_VALUE;
function $10ae86b99ba11b35$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $10ae86b99ba11b35$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $10ae86b99ba11b35$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $10ae86b99ba11b35$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $10ae86b99ba11b35$var$getHighWaterMark
};

});
parcelRegister("dRF2w", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $a1800f36e40daaed$export$e45cb6485273080e; }, function (v) { return $a1800f36e40daaed$export$e45cb6485273080e = v; });
var $a1800f36e40daaed$export$e45cb6485273080e;
"use strict";
function $a1800f36e40daaed$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $a1800f36e40daaed$var$codes = {};
function $a1800f36e40daaed$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $a1800f36e40daaed$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $a1800f36e40daaed$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $a1800f36e40daaed$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $a1800f36e40daaed$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $a1800f36e40daaed$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $a1800f36e40daaed$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$a1800f36e40daaed$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$a1800f36e40daaed$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $a1800f36e40daaed$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($a1800f36e40daaed$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($a1800f36e40daaed$var$oneOf(expected, "type"));
    else {
        var type = $a1800f36e40daaed$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($a1800f36e40daaed$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$a1800f36e40daaed$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$a1800f36e40daaed$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$a1800f36e40daaed$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$a1800f36e40daaed$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$a1800f36e40daaed$export$e45cb6485273080e = $a1800f36e40daaed$var$codes;

});


parcelRegister("gb1AQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
/*<replacement>*/ var $bc6ee8cc9ce4fb49$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $bc6ee8cc9ce4fb49$var$Duplex;

var $gbyK3 = parcelRequire("gbyK3");

var $7OiFs = parcelRequire("7OiFs");

(parcelRequire("eSHUL"))($bc6ee8cc9ce4fb49$var$Duplex, $gbyK3);
// Allow the keys array to be GC'ed.
var $bc6ee8cc9ce4fb49$var$keys = $bc6ee8cc9ce4fb49$var$objectKeys($7OiFs.prototype);
for(var $bc6ee8cc9ce4fb49$var$v = 0; $bc6ee8cc9ce4fb49$var$v < $bc6ee8cc9ce4fb49$var$keys.length; $bc6ee8cc9ce4fb49$var$v++){
    var $bc6ee8cc9ce4fb49$var$method = $bc6ee8cc9ce4fb49$var$keys[$bc6ee8cc9ce4fb49$var$v];
    if (!$bc6ee8cc9ce4fb49$var$Duplex.prototype[$bc6ee8cc9ce4fb49$var$method]) $bc6ee8cc9ce4fb49$var$Duplex.prototype[$bc6ee8cc9ce4fb49$var$method] = $7OiFs.prototype[$bc6ee8cc9ce4fb49$var$method];
}
function $bc6ee8cc9ce4fb49$var$Duplex(options) {
    if (!(this instanceof $bc6ee8cc9ce4fb49$var$Duplex)) return new $bc6ee8cc9ce4fb49$var$Duplex(options);
    $gbyK3.call(this, options);
    $7OiFs.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $bc6ee8cc9ce4fb49$var$onend);
        }
    }
}
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $bc6ee8cc9ce4fb49$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4TNnu.nextTick($bc6ee8cc9ce4fb49$var$onEndNT, this);
}
function $bc6ee8cc9ce4fb49$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($bc6ee8cc9ce4fb49$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("7OiFs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
module.exports = $5afbaee75d9861fc$var$Writable;
/* <replacement> */ function $5afbaee75d9861fc$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5afbaee75d9861fc$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5afbaee75d9861fc$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5afbaee75d9861fc$var$Duplex;
/*</replacement>*/ $5afbaee75d9861fc$var$Writable.WritableState = $5afbaee75d9861fc$var$WritableState;

/*<replacement>*/ var $5afbaee75d9861fc$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $jzO5Y = parcelRequire("jzO5Y");

var $ihoyg = parcelRequire("ihoyg");
var $5afbaee75d9861fc$require$Buffer = $ihoyg.Buffer;
var $5afbaee75d9861fc$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5afbaee75d9861fc$var$_uint8ArrayToBuffer(chunk) {
    return $5afbaee75d9861fc$require$Buffer.from(chunk);
}
function $5afbaee75d9861fc$var$_isUint8Array(obj) {
    return $5afbaee75d9861fc$require$Buffer.isBuffer(obj) || obj instanceof $5afbaee75d9861fc$var$OurUint8Array;
}

var $hgvHE = parcelRequire("hgvHE");

var $1qNnQ = parcelRequire("1qNnQ");
var $5afbaee75d9861fc$var$getHighWaterMark = $1qNnQ.getHighWaterMark;

var $dRF2w = parcelRequire("dRF2w");
var $5afbaee75d9861fc$require$_require$codes = $dRF2w.codes;
var $5afbaee75d9861fc$var$ERR_INVALID_ARG_TYPE = $5afbaee75d9861fc$require$_require$codes.ERR_INVALID_ARG_TYPE, $5afbaee75d9861fc$var$ERR_METHOD_NOT_IMPLEMENTED = $5afbaee75d9861fc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5afbaee75d9861fc$var$ERR_MULTIPLE_CALLBACK = $5afbaee75d9861fc$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5afbaee75d9861fc$var$ERR_STREAM_CANNOT_PIPE = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5afbaee75d9861fc$var$ERR_STREAM_DESTROYED = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_DESTROYED, $5afbaee75d9861fc$var$ERR_STREAM_NULL_VALUES = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_NULL_VALUES, $5afbaee75d9861fc$var$ERR_STREAM_WRITE_AFTER_END = $5afbaee75d9861fc$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5afbaee75d9861fc$var$ERR_UNKNOWN_ENCODING = $5afbaee75d9861fc$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5afbaee75d9861fc$var$errorOrDestroy = $hgvHE.errorOrDestroy;

(parcelRequire("eSHUL"))($5afbaee75d9861fc$var$Writable, $jzO5Y);
function $5afbaee75d9861fc$var$nop() {}

function $5afbaee75d9861fc$var$WritableState(options, stream, isDuplex) {
    $5afbaee75d9861fc$var$Duplex = $5afbaee75d9861fc$var$Duplex || (parcelRequire("gb1AQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5afbaee75d9861fc$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5afbaee75d9861fc$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5afbaee75d9861fc$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5afbaee75d9861fc$var$CorkedRequest(this);
}
$5afbaee75d9861fc$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5afbaee75d9861fc$var$WritableState.prototype, "buffer", {
            get: $5afbaee75d9861fc$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5afbaee75d9861fc$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5afbaee75d9861fc$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5afbaee75d9861fc$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5afbaee75d9861fc$var$realHasInstance.call(this, object)) return true;
            if (this !== $5afbaee75d9861fc$var$Writable) return false;
            return object && object._writableState instanceof $5afbaee75d9861fc$var$WritableState;
        }
    });
} else $5afbaee75d9861fc$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5afbaee75d9861fc$var$Writable(options) {
    $5afbaee75d9861fc$var$Duplex = $5afbaee75d9861fc$var$Duplex || (parcelRequire("gb1AQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5afbaee75d9861fc$var$Duplex;
    if (!isDuplex && !$5afbaee75d9861fc$var$realHasInstance.call($5afbaee75d9861fc$var$Writable, this)) return new $5afbaee75d9861fc$var$Writable(options);
    this._writableState = new $5afbaee75d9861fc$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jzO5Y.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5afbaee75d9861fc$var$Writable.prototype.pipe = function() {
    $5afbaee75d9861fc$var$errorOrDestroy(this, new $5afbaee75d9861fc$var$ERR_STREAM_CANNOT_PIPE());
};
function $5afbaee75d9861fc$var$writeAfterEnd(stream, cb) {
    var er = new $5afbaee75d9861fc$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
    $4TNnu.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5afbaee75d9861fc$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5afbaee75d9861fc$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5afbaee75d9861fc$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
        $4TNnu.nextTick(cb, er);
        return false;
    }
    return true;
}
$5afbaee75d9861fc$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5afbaee75d9861fc$var$_isUint8Array(chunk);
    if (isBuf && !$5afbaee75d9861fc$require$Buffer.isBuffer(chunk)) chunk = $5afbaee75d9861fc$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5afbaee75d9861fc$var$nop;
    if (state.ending) $5afbaee75d9861fc$var$writeAfterEnd(this, cb);
    else if (isBuf || $5afbaee75d9861fc$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5afbaee75d9861fc$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5afbaee75d9861fc$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5afbaee75d9861fc$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5afbaee75d9861fc$var$clearBuffer(this, state);
    }
};
$5afbaee75d9861fc$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5afbaee75d9861fc$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5afbaee75d9861fc$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5afbaee75d9861fc$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5afbaee75d9861fc$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5afbaee75d9861fc$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5afbaee75d9861fc$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5afbaee75d9861fc$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5afbaee75d9861fc$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5afbaee75d9861fc$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4TNnu.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4TNnu.nextTick($5afbaee75d9861fc$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5afbaee75d9861fc$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5afbaee75d9861fc$var$finishMaybe(stream, state);
    }
}
function $5afbaee75d9861fc$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5afbaee75d9861fc$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5afbaee75d9861fc$var$ERR_MULTIPLE_CALLBACK();
    $5afbaee75d9861fc$var$onwriteStateUpdate(state);
    if (er) $5afbaee75d9861fc$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5afbaee75d9861fc$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5afbaee75d9861fc$var$clearBuffer(stream, state);
        if (sync) $4TNnu.nextTick($5afbaee75d9861fc$var$afterWrite, stream, state, finished, cb);
        else $5afbaee75d9861fc$var$afterWrite(stream, state, finished, cb);
    }
}
function $5afbaee75d9861fc$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5afbaee75d9861fc$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5afbaee75d9861fc$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5afbaee75d9861fc$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5afbaee75d9861fc$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5afbaee75d9861fc$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5afbaee75d9861fc$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5afbaee75d9861fc$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5afbaee75d9861fc$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5afbaee75d9861fc$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5afbaee75d9861fc$var$Writable.prototype._writev = null;
$5afbaee75d9861fc$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5afbaee75d9861fc$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5afbaee75d9861fc$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5afbaee75d9861fc$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5afbaee75d9861fc$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5afbaee75d9861fc$var$finishMaybe(stream, state);
    });
}
function $5afbaee75d9861fc$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4TNnu.nextTick($5afbaee75d9861fc$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5afbaee75d9861fc$var$finishMaybe(stream, state) {
    var need = $5afbaee75d9861fc$var$needFinish(state);
    if (need) {
        $5afbaee75d9861fc$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5afbaee75d9861fc$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5afbaee75d9861fc$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4TNnu.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5afbaee75d9861fc$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5afbaee75d9861fc$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5afbaee75d9861fc$var$Writable.prototype.destroy = $hgvHE.destroy;
$5afbaee75d9861fc$var$Writable.prototype._undestroy = $hgvHE.undestroy;
$5afbaee75d9861fc$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});


parcelRegister("j2AXH", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
var $ddcae0115fad8035$var$_Object$setPrototypeO;
function $ddcae0115fad8035$var$_defineProperty(obj, key, value) {
    key = $ddcae0115fad8035$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ddcae0115fad8035$var$_toPropertyKey(arg) {
    var key = $ddcae0115fad8035$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $ddcae0115fad8035$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bMXnq = parcelRequire("bMXnq");
var $ddcae0115fad8035$var$kLastResolve = Symbol("lastResolve");
var $ddcae0115fad8035$var$kLastReject = Symbol("lastReject");
var $ddcae0115fad8035$var$kError = Symbol("error");
var $ddcae0115fad8035$var$kEnded = Symbol("ended");
var $ddcae0115fad8035$var$kLastPromise = Symbol("lastPromise");
var $ddcae0115fad8035$var$kHandlePromise = Symbol("handlePromise");
var $ddcae0115fad8035$var$kStream = Symbol("stream");
function $ddcae0115fad8035$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $ddcae0115fad8035$var$readAndResolve(iter) {
    var resolve = iter[$ddcae0115fad8035$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$ddcae0115fad8035$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$ddcae0115fad8035$var$kLastPromise] = null;
            iter[$ddcae0115fad8035$var$kLastResolve] = null;
            iter[$ddcae0115fad8035$var$kLastReject] = null;
            resolve($ddcae0115fad8035$var$createIterResult(data, false));
        }
    }
}
function $ddcae0115fad8035$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4TNnu.nextTick($ddcae0115fad8035$var$readAndResolve, iter);
}
function $ddcae0115fad8035$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$ddcae0115fad8035$var$kEnded]) {
                resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
                return;
            }
            iter[$ddcae0115fad8035$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $ddcae0115fad8035$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $ddcae0115fad8035$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($ddcae0115fad8035$var$_Object$setPrototypeO = {
    get stream () {
        return this[$ddcae0115fad8035$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$ddcae0115fad8035$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$ddcae0115fad8035$var$kEnded]) return Promise.resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        if (this[$ddcae0115fad8035$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4TNnu.nextTick(function() {
                if (_this[$ddcae0115fad8035$var$kError]) reject(_this[$ddcae0115fad8035$var$kError]);
                else resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$ddcae0115fad8035$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($ddcae0115fad8035$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$ddcae0115fad8035$var$kStream].read();
            if (data !== null) return Promise.resolve($ddcae0115fad8035$var$createIterResult(data, false));
            promise = new Promise(this[$ddcae0115fad8035$var$kHandlePromise]);
        }
        this[$ddcae0115fad8035$var$kLastPromise] = promise;
        return promise;
    }
}, $ddcae0115fad8035$var$_defineProperty($ddcae0115fad8035$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $ddcae0115fad8035$var$_defineProperty($ddcae0115fad8035$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$ddcae0115fad8035$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        });
    });
}), $ddcae0115fad8035$var$_Object$setPrototypeO), $ddcae0115fad8035$var$AsyncIteratorPrototype);
var $ddcae0115fad8035$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($ddcae0115fad8035$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kStream, {
        value: stream,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kLastResolve, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kLastReject, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kError, {
        value: null,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $ddcae0115fad8035$var$_defineProperty(_Object$create, $ddcae0115fad8035$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$ddcae0115fad8035$var$kStream].read();
            if (data) {
                iterator[$ddcae0115fad8035$var$kLastPromise] = null;
                iterator[$ddcae0115fad8035$var$kLastResolve] = null;
                iterator[$ddcae0115fad8035$var$kLastReject] = null;
                resolve($ddcae0115fad8035$var$createIterResult(data, false));
            } else {
                iterator[$ddcae0115fad8035$var$kLastResolve] = resolve;
                iterator[$ddcae0115fad8035$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$ddcae0115fad8035$var$kLastPromise] = null;
    $bMXnq(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$ddcae0115fad8035$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$ddcae0115fad8035$var$kLastPromise] = null;
                iterator[$ddcae0115fad8035$var$kLastResolve] = null;
                iterator[$ddcae0115fad8035$var$kLastReject] = null;
                reject(err);
            }
            iterator[$ddcae0115fad8035$var$kError] = err;
            return;
        }
        var resolve = iterator[$ddcae0115fad8035$var$kLastResolve];
        if (resolve !== null) {
            iterator[$ddcae0115fad8035$var$kLastPromise] = null;
            iterator[$ddcae0115fad8035$var$kLastResolve] = null;
            iterator[$ddcae0115fad8035$var$kLastReject] = null;
            resolve($ddcae0115fad8035$var$createIterResult(undefined, true));
        }
        iterator[$ddcae0115fad8035$var$kEnded] = true;
    });
    stream.on("readable", $ddcae0115fad8035$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $ddcae0115fad8035$var$createReadableStreamAsyncIterator;

});
parcelRegister("bMXnq", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("dRF2w")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $89523c68c4325aec$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $89523c68c4325aec$var$noop() {}
function $89523c68c4325aec$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $89523c68c4325aec$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $89523c68c4325aec$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $89523c68c4325aec$var$once(callback || $89523c68c4325aec$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $89523c68c4325aec$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($89523c68c4325aec$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $89523c68c4325aec$var$eos;

});


parcelRegister("9fR9D", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("7ozOp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $56268dd0da6eb5b6$var$Transform;

var $dRF2w = parcelRequire("dRF2w");
var $56268dd0da6eb5b6$require$_require$codes = $dRF2w.codes;
var $56268dd0da6eb5b6$var$ERR_METHOD_NOT_IMPLEMENTED = $56268dd0da6eb5b6$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $56268dd0da6eb5b6$var$ERR_MULTIPLE_CALLBACK = $56268dd0da6eb5b6$require$_require$codes.ERR_MULTIPLE_CALLBACK, $56268dd0da6eb5b6$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $56268dd0da6eb5b6$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $56268dd0da6eb5b6$var$ERR_TRANSFORM_WITH_LENGTH_0 = $56268dd0da6eb5b6$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $gb1AQ = parcelRequire("gb1AQ");

(parcelRequire("eSHUL"))($56268dd0da6eb5b6$var$Transform, $gb1AQ);
function $56268dd0da6eb5b6$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $56268dd0da6eb5b6$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $56268dd0da6eb5b6$var$Transform(options) {
    if (!(this instanceof $56268dd0da6eb5b6$var$Transform)) return new $56268dd0da6eb5b6$var$Transform(options);
    $gb1AQ.call(this, options);
    this._transformState = {
        afterTransform: $56268dd0da6eb5b6$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $56268dd0da6eb5b6$var$prefinish);
}
function $56268dd0da6eb5b6$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $56268dd0da6eb5b6$var$done(_this, er, data);
    });
    else $56268dd0da6eb5b6$var$done(this, null, null);
}
$56268dd0da6eb5b6$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $gb1AQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$56268dd0da6eb5b6$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $56268dd0da6eb5b6$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$56268dd0da6eb5b6$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$56268dd0da6eb5b6$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$56268dd0da6eb5b6$var$Transform.prototype._destroy = function(err, cb) {
    $gb1AQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $56268dd0da6eb5b6$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $56268dd0da6eb5b6$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $56268dd0da6eb5b6$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6qwr0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4ade549c8d3aaa92$var$PassThrough;

var $7ozOp = parcelRequire("7ozOp");

(parcelRequire("eSHUL"))($4ade549c8d3aaa92$var$PassThrough, $7ozOp);
function $4ade549c8d3aaa92$var$PassThrough(options) {
    if (!(this instanceof $4ade549c8d3aaa92$var$PassThrough)) return new $4ade549c8d3aaa92$var$PassThrough(options);
    $7ozOp.call(this, options);
}
$4ade549c8d3aaa92$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("46RH2", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $2fe15f5371d1165f$var$eos;
function $2fe15f5371d1165f$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $dRF2w = parcelRequire("dRF2w");
var $2fe15f5371d1165f$require$_require$codes = $dRF2w.codes;
var $2fe15f5371d1165f$var$ERR_MISSING_ARGS = $2fe15f5371d1165f$require$_require$codes.ERR_MISSING_ARGS, $2fe15f5371d1165f$var$ERR_STREAM_DESTROYED = $2fe15f5371d1165f$require$_require$codes.ERR_STREAM_DESTROYED;
function $2fe15f5371d1165f$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $2fe15f5371d1165f$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $2fe15f5371d1165f$var$destroyer(stream, reading, writing, callback) {
    callback = $2fe15f5371d1165f$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($2fe15f5371d1165f$var$eos === undefined) $2fe15f5371d1165f$var$eos = (parcelRequire("bMXnq"));
    $2fe15f5371d1165f$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($2fe15f5371d1165f$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $2fe15f5371d1165f$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $2fe15f5371d1165f$var$call(fn) {
    fn();
}
function $2fe15f5371d1165f$var$pipe(from, to) {
    return from.pipe(to);
}
function $2fe15f5371d1165f$var$popCallback(streams) {
    if (!streams.length) return $2fe15f5371d1165f$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $2fe15f5371d1165f$var$noop;
    return streams.pop();
}
function $2fe15f5371d1165f$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $2fe15f5371d1165f$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $2fe15f5371d1165f$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $2fe15f5371d1165f$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($2fe15f5371d1165f$var$call);
            if (reading) return;
            destroys.forEach($2fe15f5371d1165f$var$call);
            callback(error);
        });
    });
    return streams.reduce($2fe15f5371d1165f$var$pipe);
}
module.exports = $2fe15f5371d1165f$var$pipeline;

});




parcelRegister("cUvgf", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $bRBTe = parcelRequire("bRBTe");

var $fpHcA = parcelRequire("fpHcA");

var $6U9mG = parcelRequire("6U9mG");
var $9662f6cbdeac7c49$require$Buffer = $6U9mG.Buffer;

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");
var $9662f6cbdeac7c49$var$ZEROS = $9662f6cbdeac7c49$require$Buffer.alloc(128);
function $9662f6cbdeac7c49$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $9662f6cbdeac7c49$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $9662f6cbdeac7c49$require$Buffer.concat([
        key,
        $9662f6cbdeac7c49$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $9662f6cbdeac7c49$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $cjuEr() : $fkJVr(alg);
    this._hash.update(ipad);
}
$eSHUL($9662f6cbdeac7c49$var$Hmac, $fpHcA);
$9662f6cbdeac7c49$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$9662f6cbdeac7c49$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $cjuEr() : $fkJVr(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $9662f6cbdeac7c49$var$Hmac("rmd160", key);
    if (alg === "md5") return new $bRBTe($5GY4Y, key);
    return new $9662f6cbdeac7c49$var$Hmac(alg, key);
};

});
parcelRegister("bRBTe", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $8a32091105b403f5$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");
var $8a32091105b403f5$var$ZEROS = $8a32091105b403f5$require$Buffer.alloc(128);
var $8a32091105b403f5$var$blocksize = 64;
function $8a32091105b403f5$var$Hmac(alg, key) {
    $fpHcA.call(this, "digest");
    if (typeof key === "string") key = $8a32091105b403f5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $8a32091105b403f5$var$blocksize) key = alg(key);
    else if (key.length < $8a32091105b403f5$var$blocksize) key = $8a32091105b403f5$require$Buffer.concat([
        key,
        $8a32091105b403f5$var$ZEROS
    ], $8a32091105b403f5$var$blocksize);
    var ipad = this._ipad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    var opad = this._opad = $8a32091105b403f5$require$Buffer.allocUnsafe($8a32091105b403f5$var$blocksize);
    for(var i = 0; i < $8a32091105b403f5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$eSHUL($8a32091105b403f5$var$Hmac, $fpHcA);
$8a32091105b403f5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$8a32091105b403f5$var$Hmac.prototype._final = function() {
    var h = this._alg($8a32091105b403f5$require$Buffer.concat(this._hash));
    return this._alg($8a32091105b403f5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $8a32091105b403f5$var$Hmac;

});

parcelRegister("5GY4Y", function(module, exports) {

var $cvCaQ = parcelRequire("cvCaQ");
module.exports = function(buffer) {
    return new $cvCaQ().update(buffer).digest();
};

});


parcelRegister("fAh7A", function(module, exports) {

module.exports = (parcelRequire("jdVex"));

});
parcelRegister("jdVex", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});


parcelRegister("1UZ5c", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $165a6736bece551e$export$448fa22aedc9dbca; }, function (v) { return $165a6736bece551e$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $165a6736bece551e$export$b80c7ba289c8fa56; }, function (v) { return $165a6736bece551e$export$b80c7ba289c8fa56 = v; });
var $165a6736bece551e$export$448fa22aedc9dbca;
var $165a6736bece551e$export$b80c7ba289c8fa56;

$165a6736bece551e$export$448fa22aedc9dbca = (parcelRequire("dIhCC"));

$165a6736bece551e$export$b80c7ba289c8fa56 = (parcelRequire("6LmVU"));

});
parcelRegister("dIhCC", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9fbd0dc1d3c42e2b$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $6LmVU = parcelRequire("6LmVU");

var $dq9GI = parcelRequire("dq9GI");
var $9fbd0dc1d3c42e2b$var$ZERO_BUF;
var $9fbd0dc1d3c42e2b$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $9fbd0dc1d3c42e2b$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $9fbd0dc1d3c42e2b$var$checks = [];
function $9fbd0dc1d3c42e2b$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$9fbd0dc1d3c42e2b$var$subtle || !$9fbd0dc1d3c42e2b$var$subtle.importKey || !$9fbd0dc1d3c42e2b$var$subtle.deriveBits) return Promise.resolve(false);
    if ($9fbd0dc1d3c42e2b$var$checks[algo] !== undefined) return $9fbd0dc1d3c42e2b$var$checks[algo];
    $9fbd0dc1d3c42e2b$var$ZERO_BUF = $9fbd0dc1d3c42e2b$var$ZERO_BUF || $9fbd0dc1d3c42e2b$require$Buffer.alloc(8);
    var prom = $9fbd0dc1d3c42e2b$var$browserPbkdf2($9fbd0dc1d3c42e2b$var$ZERO_BUF, $9fbd0dc1d3c42e2b$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $9fbd0dc1d3c42e2b$var$checks[algo] = prom;
    return prom;
}
var $9fbd0dc1d3c42e2b$var$nextTick;
function $9fbd0dc1d3c42e2b$var$getNextTick() {
    if ($9fbd0dc1d3c42e2b$var$nextTick) return $9fbd0dc1d3c42e2b$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setImmediate;
    else $9fbd0dc1d3c42e2b$var$nextTick = $parcel$global.setTimeout;
    return $9fbd0dc1d3c42e2b$var$nextTick;
}
function $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $9fbd0dc1d3c42e2b$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $9fbd0dc1d3c42e2b$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $9fbd0dc1d3c42e2b$require$Buffer.from(res);
    });
}
function $9fbd0dc1d3c42e2b$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $9fbd0dc1d3c42e2b$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $9fbd0dc1d3c42e2b$var$getNextTick()(function() {
            var out;
            try {
                out = $6LmVU(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $9fbd0dc1d3c42e2b$var$resolvePromise($9fbd0dc1d3c42e2b$var$checkNative(algo).then(function(resp) {
        if (resp) return $9fbd0dc1d3c42e2b$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $6LmVU(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("1iCjP", function(module, exports) {
var $0f253230941a725c$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $0f253230941a725c$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("d5AyT", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
var $98781a6615686185$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $98781a6615686185$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $98781a6615686185$var$pVersionMajor = parseInt($4TNnu.version.split(".")[0].slice(1), 10);
    $98781a6615686185$var$defaultEncoding = $98781a6615686185$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $98781a6615686185$var$defaultEncoding = "utf-8";
module.exports = $98781a6615686185$var$defaultEncoding;

});

parcelRegister("6LmVU", function(module, exports) {

var $5GY4Y = parcelRequire("5GY4Y");

var $cjuEr = parcelRequire("cjuEr");

var $fkJVr = parcelRequire("fkJVr");

var $6U9mG = parcelRequire("6U9mG");
var $4ec8ebe845b2b457$require$Buffer = $6U9mG.Buffer;

var $1iCjP = parcelRequire("1iCjP");

var $d5AyT = parcelRequire("d5AyT");

var $dq9GI = parcelRequire("dq9GI");
var $4ec8ebe845b2b457$var$ZEROS = $4ec8ebe845b2b457$require$Buffer.alloc(128);
var $4ec8ebe845b2b457$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $4ec8ebe845b2b457$var$Hmac(alg, key, saltLen) {
    var hash = $4ec8ebe845b2b457$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $4ec8ebe845b2b457$require$Buffer.concat([
        key,
        $4ec8ebe845b2b457$var$ZEROS
    ], blocksize);
    var ipad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    var opad = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + $4ec8ebe845b2b457$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $4ec8ebe845b2b457$var$sizes[alg];
}
$4ec8ebe845b2b457$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $4ec8ebe845b2b457$var$getDigest(alg) {
    function shaFunc(data) {
        return $fkJVr(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $cjuEr().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $5GY4Y;
    return shaFunc;
}
function $4ec8ebe845b2b457$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $1iCjP(iterations, keylen);
    password = $dq9GI(password, $d5AyT, "Password");
    salt = $dq9GI(salt, $d5AyT, "Salt");
    digest = digest || "sha1";
    var hmac = new $4ec8ebe845b2b457$var$Hmac(digest, password, salt.length);
    var DK = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(keylen);
    var block1 = $4ec8ebe845b2b457$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $4ec8ebe845b2b457$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $4ec8ebe845b2b457$var$pbkdf2;

});
parcelRegister("dq9GI", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $9c5537e46f7ed310$require$Buffer = $6U9mG.Buffer;
module.exports = function(thing, encoding, name) {
    if ($9c5537e46f7ed310$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $9c5537e46f7ed310$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $9c5537e46f7ed310$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});




parcelRegister("3lJ0u", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $27063eb805988425$export$bdd223f16383713e; }, function (v) { return $27063eb805988425$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $27063eb805988425$export$26e5786e8ac8e530; }, function (v) { return $27063eb805988425$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $27063eb805988425$export$2f64596b8cbf08b4; }, function (v) { return $27063eb805988425$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $27063eb805988425$export$20533d26f07f1ee0; }, function (v) { return $27063eb805988425$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $27063eb805988425$export$12ada9414fbc594c; }, function (v) { return $27063eb805988425$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $27063eb805988425$export$2ce6d8d0e8b04e1a; }, function (v) { return $27063eb805988425$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $27063eb805988425$export$36b6d6ef312eab39; }, function (v) { return $27063eb805988425$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $27063eb805988425$export$f5e7e39d57cd9700; }, function (v) { return $27063eb805988425$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $27063eb805988425$export$dedd8dc3dc62b370; }, function (v) { return $27063eb805988425$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $27063eb805988425$export$58a258485f1e49f6; }, function (v) { return $27063eb805988425$export$58a258485f1e49f6 = v; });
var $27063eb805988425$export$bdd223f16383713e;
var $27063eb805988425$export$26e5786e8ac8e530;
var $27063eb805988425$export$2f64596b8cbf08b4;
var $27063eb805988425$export$20533d26f07f1ee0;
var $27063eb805988425$export$12ada9414fbc594c;
var $27063eb805988425$export$2ce6d8d0e8b04e1a;
var $27063eb805988425$export$36b6d6ef312eab39;
var $27063eb805988425$export$f5e7e39d57cd9700;
var $27063eb805988425$export$dedd8dc3dc62b370;
var $27063eb805988425$export$58a258485f1e49f6;

var $5e4Jl = parcelRequire("5e4Jl");

var $k1gB1 = parcelRequire("k1gB1");

var $saHx5 = parcelRequire("saHx5");

var $hqhSB = parcelRequire("hqhSB");

var $5uIwM = parcelRequire("5uIwM");
function $27063eb805988425$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createCipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($saHx5[suite]) {
        keyLen = $saHx5[suite].key;
        ivLen = $saHx5[suite].iv;
    } else if ($hqhSB[suite]) {
        keyLen = $hqhSB[suite].key * 8;
        ivLen = $hqhSB[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, keyLen, ivLen);
    return $27063eb805988425$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $27063eb805988425$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createCipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($saHx5[suite]) return $k1gB1.createDecipheriv(suite, key, iv);
    if ($hqhSB[suite]) return new $5e4Jl({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $27063eb805988425$var$getCiphers() {
    return Object.keys($hqhSB).concat($k1gB1.getCiphers());
}
$27063eb805988425$export$bdd223f16383713e = $27063eb805988425$export$26e5786e8ac8e530 = $27063eb805988425$var$createCipher;
$27063eb805988425$export$2f64596b8cbf08b4 = $27063eb805988425$export$20533d26f07f1ee0 = $27063eb805988425$var$createCipheriv;
$27063eb805988425$export$12ada9414fbc594c = $27063eb805988425$export$2ce6d8d0e8b04e1a = $27063eb805988425$var$createDecipher;
$27063eb805988425$export$36b6d6ef312eab39 = $27063eb805988425$export$f5e7e39d57cd9700 = $27063eb805988425$var$createDecipheriv;
$27063eb805988425$export$dedd8dc3dc62b370 = $27063eb805988425$export$58a258485f1e49f6 = $27063eb805988425$var$getCiphers;

});
parcelRegister("5e4Jl", function(module, exports) {

var $fpHcA = parcelRequire("fpHcA");

var $lCSZA = parcelRequire("lCSZA");

var $eSHUL = parcelRequire("eSHUL");

var $6U9mG = parcelRequire("6U9mG");
var $3ce1edebcff63bba$require$Buffer = $6U9mG.Buffer;
var $3ce1edebcff63bba$var$modes = {
    "des-ede3-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede3": $lCSZA.EDE,
    "des-ede-cbc": $lCSZA.CBC.instantiate($lCSZA.EDE),
    "des-ede": $lCSZA.EDE,
    "des-cbc": $lCSZA.CBC.instantiate($lCSZA.DES),
    "des-ecb": $lCSZA.DES
};
$3ce1edebcff63bba$var$modes.des = $3ce1edebcff63bba$var$modes["des-cbc"];
$3ce1edebcff63bba$var$modes.des3 = $3ce1edebcff63bba$var$modes["des-ede3-cbc"];
module.exports = $3ce1edebcff63bba$var$DES;
$eSHUL($3ce1edebcff63bba$var$DES, $fpHcA);
function $3ce1edebcff63bba$var$DES(opts) {
    $fpHcA.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $3ce1edebcff63bba$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(key)) key = $3ce1edebcff63bba$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $3ce1edebcff63bba$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$3ce1edebcff63bba$require$Buffer.isBuffer(iv)) iv = $3ce1edebcff63bba$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$3ce1edebcff63bba$var$DES.prototype._update = function(data) {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.update(data));
};
$3ce1edebcff63bba$var$DES.prototype._final = function() {
    return $3ce1edebcff63bba$require$Buffer.from(this._des.final());
};

});
parcelRegister("lCSZA", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $fbe7cdeec3c8acd6$export$cc8859615686b300; }, function (v) { return $fbe7cdeec3c8acd6$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5; }, function (v) { return $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $fbe7cdeec3c8acd6$export$947646e34766044f; }, function (v) { return $fbe7cdeec3c8acd6$export$947646e34766044f = v; });
var $fbe7cdeec3c8acd6$export$eab97d15b1788b8d;
var $fbe7cdeec3c8acd6$export$26e5786e8ac8e530;
var $fbe7cdeec3c8acd6$export$cc8859615686b300;
var $fbe7cdeec3c8acd6$export$8ad3f227af08fcc5;
var $fbe7cdeec3c8acd6$export$947646e34766044f;
"use strict";

$fbe7cdeec3c8acd6$export$eab97d15b1788b8d = (parcelRequire("amxhE"));

$fbe7cdeec3c8acd6$export$26e5786e8ac8e530 = (parcelRequire("aAaZT"));

$fbe7cdeec3c8acd6$export$cc8859615686b300 = (parcelRequire("lbpyh"));

$fbe7cdeec3c8acd6$export$8ad3f227af08fcc5 = (parcelRequire("4KVAb"));

$fbe7cdeec3c8acd6$export$947646e34766044f = (parcelRequire("ipB6Y"));

});
parcelRegister("amxhE", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $78b5c6e404207be9$export$cfaef8ed399428b0; }, function (v) { return $78b5c6e404207be9$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $78b5c6e404207be9$export$a80c7deaea7cbd80; }, function (v) { return $78b5c6e404207be9$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef; }, function (v) { return $78b5c6e404207be9$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $78b5c6e404207be9$export$5dcbef3aa594f567; }, function (v) { return $78b5c6e404207be9$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $78b5c6e404207be9$export$5bc8001ca71ed9c5; }, function (v) { return $78b5c6e404207be9$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2; }, function (v) { return $78b5c6e404207be9$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $78b5c6e404207be9$export$94c3e544fd062b7f; }, function (v) { return $78b5c6e404207be9$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $78b5c6e404207be9$export$9f77e0932fb78f72; }, function (v) { return $78b5c6e404207be9$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $78b5c6e404207be9$export$d865ce2836f5927f; }, function (v) { return $78b5c6e404207be9$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $78b5c6e404207be9$export$95e62ad65da8b7d2; }, function (v) { return $78b5c6e404207be9$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $78b5c6e404207be9$export$209139ff098c441a; }, function (v) { return $78b5c6e404207be9$export$209139ff098c441a = v; });
var $78b5c6e404207be9$export$cfaef8ed399428b0;
var $78b5c6e404207be9$export$a80c7deaea7cbd80;
var $78b5c6e404207be9$export$ed7577ae6e1cd0ef;
var $78b5c6e404207be9$export$5dcbef3aa594f567;
var $78b5c6e404207be9$export$5bc8001ca71ed9c5;
var $78b5c6e404207be9$export$3e714e2c5d5d8cb2;
var $78b5c6e404207be9$export$94c3e544fd062b7f;
var $78b5c6e404207be9$export$9f77e0932fb78f72;
var $78b5c6e404207be9$export$d865ce2836f5927f;
var $78b5c6e404207be9$export$95e62ad65da8b7d2;
var $78b5c6e404207be9$export$209139ff098c441a;
"use strict";
$78b5c6e404207be9$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$78b5c6e404207be9$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$78b5c6e404207be9$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $78b5c6e404207be9$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$78b5c6e404207be9$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $78b5c6e404207be9$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $78b5c6e404207be9$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $78b5c6e404207be9$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$78b5c6e404207be9$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $78b5c6e404207be9$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$78b5c6e404207be9$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $78b5c6e404207be9$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $78b5c6e404207be9$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$78b5c6e404207be9$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $78b5c6e404207be9$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $78b5c6e404207be9$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$78b5c6e404207be9$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("aAaZT", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");
function $7b45cbfb22d7466a$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
}
module.exports = $7b45cbfb22d7466a$var$Cipher;
$7b45cbfb22d7466a$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$7b45cbfb22d7466a$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$7b45cbfb22d7466a$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$7b45cbfb22d7466a$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$7b45cbfb22d7466a$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$7b45cbfb22d7466a$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$7b45cbfb22d7466a$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $aJt1P.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("aJt1P", function(module, exports) {
module.exports = $7d049fca35679f9f$var$assert;
function $7d049fca35679f9f$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$7d049fca35679f9f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});


parcelRegister("lbpyh", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $amxhE = parcelRequire("amxhE");

var $aAaZT = parcelRequire("aAaZT");
function $f6be72270bafa6fd$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $f6be72270bafa6fd$var$DES(options) {
    $aAaZT.call(this, options);
    var state = new $f6be72270bafa6fd$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$eSHUL($f6be72270bafa6fd$var$DES, $aAaZT);
module.exports = $f6be72270bafa6fd$var$DES;
$f6be72270bafa6fd$var$DES.create = function create(options) {
    return new $f6be72270bafa6fd$var$DES(options);
};
var $f6be72270bafa6fd$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$f6be72270bafa6fd$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $aJt1P.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $amxhE.readUInt32BE(key, 0);
    var kR = $amxhE.readUInt32BE(key, 4);
    $amxhE.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $f6be72270bafa6fd$var$shiftTable[i >>> 1];
        kL = $amxhE.r28shl(kL, shift);
        kR = $amxhE.r28shl(kR, shift);
        $amxhE.pc2(kL, kR, state.keys, i);
    }
};
$f6be72270bafa6fd$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $amxhE.readUInt32BE(inp, inOff);
    var r = $amxhE.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $amxhE.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $amxhE.writeUInt32BE(out, l, outOff);
    $amxhE.writeUInt32BE(out, r, outOff + 4);
};
$f6be72270bafa6fd$var$DES.prototype._pad = function _pad(buffer, off) {
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$f6be72270bafa6fd$var$DES.prototype._unpad = function _unpad(buffer) {
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$aJt1P.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$f6be72270bafa6fd$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(r, l, out, off);
};
$f6be72270bafa6fd$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $amxhE.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $amxhE.substitute(keyL, keyR);
        var f = $amxhE.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $amxhE.rip(l, r, out, off);
};

});

parcelRegister("4KVAb", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $37681ffc4c67db45$export$f9bb8d20ccc7477a; }, function (v) { return $37681ffc4c67db45$export$f9bb8d20ccc7477a = v; });
var $37681ffc4c67db45$export$f9bb8d20ccc7477a;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
var $37681ffc4c67db45$var$proto = {};
function $37681ffc4c67db45$var$CBCState(iv) {
    $aJt1P.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $37681ffc4c67db45$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $eSHUL(CBC, Base);
    var keys = Object.keys($37681ffc4c67db45$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $37681ffc4c67db45$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$37681ffc4c67db45$export$f9bb8d20ccc7477a = $37681ffc4c67db45$var$instantiate;
$37681ffc4c67db45$var$proto._cbcInit = function _cbcInit() {
    var state = new $37681ffc4c67db45$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$37681ffc4c67db45$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("ipB6Y", function(module, exports) {
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");

var $aAaZT = parcelRequire("aAaZT");

var $lbpyh = parcelRequire("lbpyh");
function $d677595fc0ef2155$var$EDEState(type, key) {
    $aJt1P.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $lbpyh.create({
            type: "encrypt",
            key: k1
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $lbpyh.create({
            type: "decrypt",
            key: k3
        }),
        $lbpyh.create({
            type: "encrypt",
            key: k2
        }),
        $lbpyh.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $d677595fc0ef2155$var$EDE(options) {
    $aAaZT.call(this, options);
    var state = new $d677595fc0ef2155$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$eSHUL($d677595fc0ef2155$var$EDE, $aAaZT);
module.exports = $d677595fc0ef2155$var$EDE;
$d677595fc0ef2155$var$EDE.create = function create(options) {
    return new $d677595fc0ef2155$var$EDE(options);
};
$d677595fc0ef2155$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$d677595fc0ef2155$var$EDE.prototype._pad = $lbpyh.prototype._pad;
$d677595fc0ef2155$var$EDE.prototype._unpad = $lbpyh.prototype._unpad;

});



parcelRegister("k1gB1", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e930c647c2b036f8$export$2f64596b8cbf08b4; }, function (v) { return $e930c647c2b036f8$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e930c647c2b036f8$export$36b6d6ef312eab39; }, function (v) { return $e930c647c2b036f8$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e930c647c2b036f8$export$58a258485f1e49f6; }, function (v) { return $e930c647c2b036f8$export$58a258485f1e49f6 = v; });
var $e930c647c2b036f8$export$bdd223f16383713e;
var $e930c647c2b036f8$export$26e5786e8ac8e530;
var $e930c647c2b036f8$export$2f64596b8cbf08b4;
var $e930c647c2b036f8$export$20533d26f07f1ee0;
var $e930c647c2b036f8$export$12ada9414fbc594c;
var $e930c647c2b036f8$export$2ce6d8d0e8b04e1a;
var $e930c647c2b036f8$export$36b6d6ef312eab39;
var $e930c647c2b036f8$export$f5e7e39d57cd9700;
var $e930c647c2b036f8$export$dedd8dc3dc62b370;
var $e930c647c2b036f8$export$58a258485f1e49f6;

var $5lUqw = parcelRequire("5lUqw");

var $gQor2 = parcelRequire("gQor2");

var $hPX1p = parcelRequire("hPX1p");
function $e930c647c2b036f8$var$getCiphers() {
    return Object.keys($hPX1p);
}
$e930c647c2b036f8$export$bdd223f16383713e = $e930c647c2b036f8$export$26e5786e8ac8e530 = $5lUqw.createCipher;
$e930c647c2b036f8$export$2f64596b8cbf08b4 = $e930c647c2b036f8$export$20533d26f07f1ee0 = $5lUqw.createCipheriv;
$e930c647c2b036f8$export$12ada9414fbc594c = $e930c647c2b036f8$export$2ce6d8d0e8b04e1a = $gQor2.createDecipher;
$e930c647c2b036f8$export$36b6d6ef312eab39 = $e930c647c2b036f8$export$f5e7e39d57cd9700 = $gQor2.createDecipheriv;
$e930c647c2b036f8$export$dedd8dc3dc62b370 = $e930c647c2b036f8$export$58a258485f1e49f6 = $e930c647c2b036f8$var$getCiphers;

});
parcelRegister("5lUqw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $3e5aaf1af369121b$export$2f64596b8cbf08b4; }, function (v) { return $3e5aaf1af369121b$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $3e5aaf1af369121b$export$bdd223f16383713e; }, function (v) { return $3e5aaf1af369121b$export$bdd223f16383713e = v; });
var $3e5aaf1af369121b$export$2f64596b8cbf08b4;
var $3e5aaf1af369121b$export$bdd223f16383713e;

var $saHx5 = parcelRequire("saHx5");

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $3e5aaf1af369121b$require$Buffer = $6U9mG.Buffer;

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $3e5aaf1af369121b$var$Cipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $3e5aaf1af369121b$var$Splitter();
    this._cipher = new $4Nfih.AES(key);
    this._prev = $3e5aaf1af369121b$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($3e5aaf1af369121b$var$Cipher, $fpHcA);
$3e5aaf1af369121b$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $3e5aaf1af369121b$require$Buffer.concat(out);
};
var $3e5aaf1af369121b$var$PADDING = $3e5aaf1af369121b$require$Buffer.alloc(16, 0x10);
$3e5aaf1af369121b$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($3e5aaf1af369121b$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$3e5aaf1af369121b$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $3e5aaf1af369121b$var$Splitter() {
    this.cache = $3e5aaf1af369121b$require$Buffer.allocUnsafe(0);
}
$3e5aaf1af369121b$var$Splitter.prototype.add = function(data) {
    this.cache = $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$3e5aaf1af369121b$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$3e5aaf1af369121b$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $3e5aaf1af369121b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $3e5aaf1af369121b$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $3e5aaf1af369121b$var$createCipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $3e5aaf1af369121b$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $3e5aaf1af369121b$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv);
    return new $3e5aaf1af369121b$var$Cipher(config.module, password, iv);
}
function $3e5aaf1af369121b$var$createCipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $3e5aaf1af369121b$var$createCipheriv(suite, keys.key, keys.iv);
}
$3e5aaf1af369121b$export$2f64596b8cbf08b4 = $3e5aaf1af369121b$var$createCipheriv;
$3e5aaf1af369121b$export$bdd223f16383713e = $3e5aaf1af369121b$var$createCipher;

});
parcelRegister("saHx5", function(module, exports) {








var $054aeaa9bab312d6$var$modeModules = {
    ECB: (parcelRequire("l764o")),
    CBC: (parcelRequire("gXYn1")),
    CFB: (parcelRequire("UMnWk")),
    CFB8: (parcelRequire("00tcX")),
    CFB1: (parcelRequire("6r7x9")),
    OFB: (parcelRequire("anS7G")),
    CTR: (parcelRequire("1z9Wt")),
    GCM: (parcelRequire("1z9Wt"))
};

var $hPX1p = parcelRequire("hPX1p");
for(var $054aeaa9bab312d6$var$key in $hPX1p)$hPX1p[$054aeaa9bab312d6$var$key].module = $054aeaa9bab312d6$var$modeModules[$hPX1p[$054aeaa9bab312d6$var$key].mode];
module.exports = $hPX1p;

});
parcelRegister("l764o", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18; }, function (v) { return $f5eef5c6e22a602a$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3; }, function (v) { return $f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = v; });
var $f5eef5c6e22a602a$export$5b0f6292f11d1d18;
var $f5eef5c6e22a602a$export$e85a0c9a1067c5d3;
$f5eef5c6e22a602a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$f5eef5c6e22a602a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("gXYn1", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18; }, function (v) { return $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3; }, function (v) { return $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = v; });
var $c5a0fc56dc7b26c3$export$5b0f6292f11d1d18;
var $c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3;

var $fDcjW = parcelRequire("fDcjW");
$c5a0fc56dc7b26c3$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $fDcjW(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$c5a0fc56dc7b26c3$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $fDcjW(out, pad);
};

});
parcelRegister("fDcjW", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $b6140e2d47be3780$require$Buffer = $ihoyg.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $b6140e2d47be3780$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("UMnWk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18; }, function (v) { return $0aaac35ae317ce1a$export$5b0f6292f11d1d18 = v; });
var $0aaac35ae317ce1a$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $0aaac35ae317ce1a$require$Buffer = $6U9mG.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $fDcjW(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $0aaac35ae317ce1a$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$0aaac35ae317ce1a$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $0aaac35ae317ce1a$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $0aaac35ae317ce1a$require$Buffer.concat([
                out,
                $0aaac35ae317ce1a$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("00tcX", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $00005d8db091e94d$export$5b0f6292f11d1d18; }, function (v) { return $00005d8db091e94d$export$5b0f6292f11d1d18 = v; });
var $00005d8db091e94d$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $00005d8db091e94d$require$Buffer = $6U9mG.Buffer;
function $00005d8db091e94d$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00005d8db091e94d$require$Buffer.concat([
        self._prev.slice(1),
        $00005d8db091e94d$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00005d8db091e94d$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00005d8db091e94d$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00005d8db091e94d$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("6r7x9", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4afb1bbda820b619$export$5b0f6292f11d1d18; }, function (v) { return $4afb1bbda820b619$export$5b0f6292f11d1d18 = v; });
var $4afb1bbda820b619$export$5b0f6292f11d1d18;

var $6U9mG = parcelRequire("6U9mG");
var $4afb1bbda820b619$require$Buffer = $6U9mG.Buffer;
function $4afb1bbda820b619$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $4afb1bbda820b619$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $4afb1bbda820b619$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(buffer.length);
    buffer = $4afb1bbda820b619$require$Buffer.concat([
        buffer,
        $4afb1bbda820b619$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$4afb1bbda820b619$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $4afb1bbda820b619$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $4afb1bbda820b619$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("anS7G", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $78f6090cb273111f$export$5b0f6292f11d1d18; }, function (v) { return $78f6090cb273111f$export$5b0f6292f11d1d18 = v; });
var $78f6090cb273111f$export$5b0f6292f11d1d18;

var $ihoyg = parcelRequire("ihoyg");
var $78f6090cb273111f$require$Buffer = $ihoyg.Buffer;

var $fDcjW = parcelRequire("fDcjW");
function $78f6090cb273111f$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$78f6090cb273111f$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $78f6090cb273111f$require$Buffer.concat([
        self._cache,
        $78f6090cb273111f$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});

parcelRegister("1z9Wt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18; }, function (v) { return $1240c5a5b7a9d372$export$5b0f6292f11d1d18 = v; });
var $1240c5a5b7a9d372$export$5b0f6292f11d1d18;

var $fDcjW = parcelRequire("fDcjW");

var $6U9mG = parcelRequire("6U9mG");
var $1240c5a5b7a9d372$require$Buffer = $6U9mG.Buffer;

var $b0v5s = parcelRequire("b0v5s");
function $1240c5a5b7a9d372$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $b0v5s(self._prev);
    return out;
}
var $1240c5a5b7a9d372$var$blockSize = 16;
$1240c5a5b7a9d372$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $1240c5a5b7a9d372$var$blockSize);
    var start = self._cache.length;
    self._cache = $1240c5a5b7a9d372$require$Buffer.concat([
        self._cache,
        $1240c5a5b7a9d372$require$Buffer.allocUnsafe(chunkNum * $1240c5a5b7a9d372$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $1240c5a5b7a9d372$var$getBlock(self);
        var offset = start + i * $1240c5a5b7a9d372$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $fDcjW(chunk, pad);
};

});
parcelRegister("b0v5s", function(module, exports) {
function $8037cf0dcb3400de$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $8037cf0dcb3400de$var$incr32;

});


parcelRegister("hPX1p", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("iEPe6", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $d953b2ef02a1977a$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");

var $eqhe5 = parcelRequire("eqhe5");

var $fDcjW = parcelRequire("fDcjW");

var $b0v5s = parcelRequire("b0v5s");
function $d953b2ef02a1977a$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $d953b2ef02a1977a$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $d953b2ef02a1977a$require$Buffer.concat([
            iv,
            $d953b2ef02a1977a$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $eqhe5(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($d953b2ef02a1977a$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($d953b2ef02a1977a$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $d953b2ef02a1977a$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $d953b2ef02a1977a$require$Buffer.from(self._finID);
    $b0v5s(out);
    return out;
}
function $d953b2ef02a1977a$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    var h = $d953b2ef02a1977a$require$Buffer.alloc(4, 0);
    this._cipher = new $4Nfih.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $eqhe5(ck);
    iv = $d953b2ef02a1977a$var$calcIv(this, iv, ck);
    this._prev = $d953b2ef02a1977a$require$Buffer.from(iv);
    this._cache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._secCache = $d953b2ef02a1977a$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$eSHUL($d953b2ef02a1977a$var$StreamCipher, $fpHcA);
$d953b2ef02a1977a$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $d953b2ef02a1977a$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$d953b2ef02a1977a$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $fDcjW(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $d953b2ef02a1977a$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$d953b2ef02a1977a$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$d953b2ef02a1977a$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$d953b2ef02a1977a$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $d953b2ef02a1977a$var$StreamCipher;

});
parcelRegister("4Nfih", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5; }, function (v) { return $37d79a127135d0aa$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $37d79a127135d0aa$export$b80fbe1c3a2b92b5;

var $6U9mG = parcelRequire("6U9mG");
var $37d79a127135d0aa$require$Buffer = $6U9mG.Buffer;
function $37d79a127135d0aa$var$asUInt32Array(buf) {
    if (!$37d79a127135d0aa$require$Buffer.isBuffer(buf)) buf = $37d79a127135d0aa$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $37d79a127135d0aa$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $37d79a127135d0aa$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $37d79a127135d0aa$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $37d79a127135d0aa$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $37d79a127135d0aa$var$AES(key) {
    this._key = $37d79a127135d0aa$var$asUInt32Array(key);
    this._reset();
}
$37d79a127135d0aa$var$AES.blockSize = 16;
$37d79a127135d0aa$var$AES.keySize = 32;
$37d79a127135d0aa$var$AES.prototype.blockSize = $37d79a127135d0aa$var$AES.blockSize;
$37d79a127135d0aa$var$AES.prototype.keySize = $37d79a127135d0aa$var$AES.keySize;
$37d79a127135d0aa$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
            t ^= $37d79a127135d0aa$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $37d79a127135d0aa$var$G.SBOX[t >>> 24] << 24 | $37d79a127135d0aa$var$G.SBOX[t >>> 16 & 0xff] << 16 | $37d79a127135d0aa$var$G.SBOX[t >>> 8 & 0xff] << 8 | $37d79a127135d0aa$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $37d79a127135d0aa$var$G.INV_SUB_MIX[0][$37d79a127135d0aa$var$G.SBOX[tt >>> 24]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[1][$37d79a127135d0aa$var$G.SBOX[tt >>> 16 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[2][$37d79a127135d0aa$var$G.SBOX[tt >>> 8 & 0xff]] ^ $37d79a127135d0aa$var$G.INV_SUB_MIX[3][$37d79a127135d0aa$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$37d79a127135d0aa$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    return $37d79a127135d0aa$var$cryptBlock(M, this._keySchedule, $37d79a127135d0aa$var$G.SUB_MIX, $37d79a127135d0aa$var$G.SBOX, this._nRounds);
};
$37d79a127135d0aa$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.decryptBlock = function(M) {
    M = $37d79a127135d0aa$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $37d79a127135d0aa$var$cryptBlock(M, this._invKeySchedule, $37d79a127135d0aa$var$G.INV_SUB_MIX, $37d79a127135d0aa$var$G.INV_SBOX, this._nRounds);
    var buf = $37d79a127135d0aa$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$37d79a127135d0aa$var$AES.prototype.scrub = function() {
    $37d79a127135d0aa$var$scrubVec(this._keySchedule);
    $37d79a127135d0aa$var$scrubVec(this._invKeySchedule);
    $37d79a127135d0aa$var$scrubVec(this._key);
};
$37d79a127135d0aa$export$b80fbe1c3a2b92b5 = $37d79a127135d0aa$var$AES;

});

parcelRegister("eqhe5", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $a800db270fade44b$require$Buffer = $6U9mG.Buffer;
var $a800db270fade44b$var$ZEROES = $a800db270fade44b$require$Buffer.alloc(16, 0);
function $a800db270fade44b$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $a800db270fade44b$var$fromArray(out) {
    var buf = $a800db270fade44b$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $a800db270fade44b$var$GHASH(key) {
    this.h = key;
    this.state = $a800db270fade44b$require$Buffer.alloc(16, 0);
    this.cache = $a800db270fade44b$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$a800db270fade44b$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$a800db270fade44b$var$GHASH.prototype._multiply = function() {
    var Vi = $a800db270fade44b$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $a800db270fade44b$var$fromArray(Zi);
};
$a800db270fade44b$var$GHASH.prototype.update = function(buf) {
    this.cache = $a800db270fade44b$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$a800db270fade44b$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($a800db270fade44b$require$Buffer.concat([
        this.cache,
        $a800db270fade44b$var$ZEROES
    ], 16));
    this.ghash($a800db270fade44b$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $a800db270fade44b$var$GHASH;

});


parcelRegister("aKCeN", function(module, exports) {

var $4Nfih = parcelRequire("4Nfih");

var $6U9mG = parcelRequire("6U9mG");
var $7d3bdc7569c86a8c$require$Buffer = $6U9mG.Buffer;

var $fpHcA = parcelRequire("fpHcA");

var $eSHUL = parcelRequire("eSHUL");
function $7d3bdc7569c86a8c$var$StreamCipher(mode, key, iv, decrypt) {
    $fpHcA.call(this);
    this._cipher = new $4Nfih.AES(key);
    this._prev = $7d3bdc7569c86a8c$require$Buffer.from(iv);
    this._cache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._secCache = $7d3bdc7569c86a8c$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$eSHUL($7d3bdc7569c86a8c$var$StreamCipher, $fpHcA);
$7d3bdc7569c86a8c$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$7d3bdc7569c86a8c$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $7d3bdc7569c86a8c$var$StreamCipher;

});

parcelRegister("5uIwM", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $40024b5f4411b288$require$Buffer = $6U9mG.Buffer;

var $cvCaQ = parcelRequire("cvCaQ");
/* eslint-disable camelcase */ function $40024b5f4411b288$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$40024b5f4411b288$require$Buffer.isBuffer(password)) password = $40024b5f4411b288$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$40024b5f4411b288$require$Buffer.isBuffer(salt)) salt = $40024b5f4411b288$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $40024b5f4411b288$require$Buffer.alloc(keyLen);
    var iv = $40024b5f4411b288$require$Buffer.alloc(ivLen || 0);
    var tmp = $40024b5f4411b288$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $cvCaQ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $40024b5f4411b288$var$EVP_BytesToKey;

});


parcelRegister("gQor2", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $c43474f95c9fc530$export$12ada9414fbc594c; }, function (v) { return $c43474f95c9fc530$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $c43474f95c9fc530$export$36b6d6ef312eab39; }, function (v) { return $c43474f95c9fc530$export$36b6d6ef312eab39 = v; });
var $c43474f95c9fc530$export$12ada9414fbc594c;
var $c43474f95c9fc530$export$36b6d6ef312eab39;

var $iEPe6 = parcelRequire("iEPe6");

var $6U9mG = parcelRequire("6U9mG");
var $c43474f95c9fc530$require$Buffer = $6U9mG.Buffer;

var $saHx5 = parcelRequire("saHx5");

var $aKCeN = parcelRequire("aKCeN");

var $fpHcA = parcelRequire("fpHcA");

var $4Nfih = parcelRequire("4Nfih");

var $5uIwM = parcelRequire("5uIwM");

var $eSHUL = parcelRequire("eSHUL");
function $c43474f95c9fc530$var$Decipher(mode, key, iv) {
    $fpHcA.call(this);
    this._cache = new $c43474f95c9fc530$var$Splitter();
    this._last = void 0;
    this._cipher = new $4Nfih.AES(key);
    this._prev = $c43474f95c9fc530$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$eSHUL($c43474f95c9fc530$var$Decipher, $fpHcA);
$c43474f95c9fc530$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $c43474f95c9fc530$require$Buffer.concat(out);
};
$c43474f95c9fc530$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $c43474f95c9fc530$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$c43474f95c9fc530$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $c43474f95c9fc530$var$Splitter() {
    this.cache = $c43474f95c9fc530$require$Buffer.allocUnsafe(0);
}
$c43474f95c9fc530$var$Splitter.prototype.add = function(data) {
    this.cache = $c43474f95c9fc530$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$c43474f95c9fc530$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$c43474f95c9fc530$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $c43474f95c9fc530$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $c43474f95c9fc530$var$createDecipheriv(suite, password, iv) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $c43474f95c9fc530$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $c43474f95c9fc530$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $aKCeN(config.module, password, iv, true);
    else if (config.type === "auth") return new $iEPe6(config.module, password, iv, true);
    return new $c43474f95c9fc530$var$Decipher(config.module, password, iv);
}
function $c43474f95c9fc530$var$createDecipher(suite, password) {
    var config = $saHx5[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $5uIwM(password, false, config.key, config.iv);
    return $c43474f95c9fc530$var$createDecipheriv(suite, keys.key, keys.iv);
}
$c43474f95c9fc530$export$12ada9414fbc594c = $c43474f95c9fc530$var$createDecipher;
$c43474f95c9fc530$export$36b6d6ef312eab39 = $c43474f95c9fc530$var$createDecipheriv;

});


parcelRegister("hqhSB", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $caf2bbe4b8db6f3b$export$116f8a5cee447347; }, function (v) { return $caf2bbe4b8db6f3b$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9; }, function (v) { return $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06; }, function (v) { return $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8; }, function (v) { return $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $caf2bbe4b8db6f3b$export$eba20568dde4ada; }, function (v) { return $caf2bbe4b8db6f3b$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae; }, function (v) { return $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $caf2bbe4b8db6f3b$export$57c08356130bc99b; }, function (v) { return $caf2bbe4b8db6f3b$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d; }, function (v) { return $caf2bbe4b8db6f3b$export$c7169791d5c1e65d = v; });
var $caf2bbe4b8db6f3b$export$116f8a5cee447347;
var $caf2bbe4b8db6f3b$export$7483c4066bfb7ae9;
var $caf2bbe4b8db6f3b$export$e7a565d2e588bb06;
var $caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8;
var $caf2bbe4b8db6f3b$export$eba20568dde4ada;
var $caf2bbe4b8db6f3b$export$d3b5e5996938f5ae;
var $caf2bbe4b8db6f3b$export$57c08356130bc99b;
var $caf2bbe4b8db6f3b$export$c7169791d5c1e65d;
$caf2bbe4b8db6f3b$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$caf2bbe4b8db6f3b$export$7483c4066bfb7ae9 = $caf2bbe4b8db6f3b$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$caf2bbe4b8db6f3b$export$aaa2f54a426f3eb8 = $caf2bbe4b8db6f3b$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$caf2bbe4b8db6f3b$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$caf2bbe4b8db6f3b$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$caf2bbe4b8db6f3b$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("4evoR", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$971862a2fcb1bb40; }, function (v) { return $3150d39cd6c438f1$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40; }, function (v) { return $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $3150d39cd6c438f1$export$fdc27893e98845cc; }, function (v) { return $3150d39cd6c438f1$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $3150d39cd6c438f1$export$6671fb9a1323bed; }, function (v) { return $3150d39cd6c438f1$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $3150d39cd6c438f1$export$d74daf141a551db; }, function (v) { return $3150d39cd6c438f1$export$d74daf141a551db = v; });
var $3150d39cd6c438f1$export$971862a2fcb1bb40;
var $3150d39cd6c438f1$export$c6ff6a88acbeaf40;
var $3150d39cd6c438f1$export$fdc27893e98845cc;
var $3150d39cd6c438f1$export$6671fb9a1323bed;
var $3150d39cd6c438f1$export$d74daf141a551db;

var $ihoyg = parcelRequire("ihoyg");
var $3150d39cd6c438f1$require$Buffer = $ihoyg.Buffer;

var $lNmPw = parcelRequire("lNmPw");

var $fsr3h = parcelRequire("fsr3h");

var $2kgCI = parcelRequire("2kgCI");
function $3150d39cd6c438f1$var$getDiffieHellman(mod) {
    var prime = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].prime, "hex");
    var gen = new $3150d39cd6c438f1$require$Buffer($fsr3h[mod].gen, "hex");
    return new $2kgCI(prime, gen);
}
var $3150d39cd6c438f1$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $3150d39cd6c438f1$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($3150d39cd6c438f1$require$Buffer.isBuffer(enc) || $3150d39cd6c438f1$var$ENCODINGS[enc] === undefined) return $3150d39cd6c438f1$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $3150d39cd6c438f1$require$Buffer([
        2
    ]);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(generator)) generator = new $3150d39cd6c438f1$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $2kgCI($lNmPw(prime, generator), generator, true);
    if (!$3150d39cd6c438f1$require$Buffer.isBuffer(prime)) prime = new $3150d39cd6c438f1$require$Buffer(prime, enc);
    return new $2kgCI(prime, generator, true);
}
$3150d39cd6c438f1$export$971862a2fcb1bb40 = $3150d39cd6c438f1$export$c6ff6a88acbeaf40 = $3150d39cd6c438f1$export$fdc27893e98845cc = $3150d39cd6c438f1$var$getDiffieHellman;
$3150d39cd6c438f1$export$6671fb9a1323bed = $3150d39cd6c438f1$export$d74daf141a551db = $3150d39cd6c438f1$var$createDiffieHellman;

});
parcelRegister("lNmPw", function(module, exports) {

var $5rfiH = parcelRequire("5rfiH");
module.exports = $fddfe224e234e046$var$findPrime;
$fddfe224e234e046$var$findPrime.simpleSieve = $fddfe224e234e046$var$simpleSieve;
$fddfe224e234e046$var$findPrime.fermatTest = $fddfe224e234e046$var$fermatTest;

var $7vYz3 = parcelRequire("7vYz3");
var $fddfe224e234e046$var$TWENTYFOUR = new $7vYz3(24);

var $4hcaz = parcelRequire("4hcaz");
var $fddfe224e234e046$var$millerRabin = new $4hcaz();
var $fddfe224e234e046$var$ONE = new $7vYz3(1);
var $fddfe224e234e046$var$TWO = new $7vYz3(2);
var $fddfe224e234e046$var$FIVE = new $7vYz3(5);
var $fddfe224e234e046$var$SIXTEEN = new $7vYz3(16);
var $fddfe224e234e046$var$EIGHT = new $7vYz3(8);
var $fddfe224e234e046$var$TEN = new $7vYz3(10);
var $fddfe224e234e046$var$THREE = new $7vYz3(3);
var $fddfe224e234e046$var$SEVEN = new $7vYz3(7);
var $fddfe224e234e046$var$ELEVEN = new $7vYz3(11);
var $fddfe224e234e046$var$FOUR = new $7vYz3(4);
var $fddfe224e234e046$var$TWELVE = new $7vYz3(12);
var $fddfe224e234e046$var$primes = null;
function $fddfe224e234e046$var$_getPrimes() {
    if ($fddfe224e234e046$var$primes !== null) return $fddfe224e234e046$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $fddfe224e234e046$var$primes = res;
    return res;
}
function $fddfe224e234e046$var$simpleSieve(p) {
    var primes = $fddfe224e234e046$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $fddfe224e234e046$var$fermatTest(p) {
    var red = $7vYz3.mont(p);
    return $fddfe224e234e046$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $fddfe224e234e046$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $7vYz3([
            0x8c,
            0x7b
        ]);
        else return new $7vYz3([
            0x8c,
            0x27
        ]);
    }
    gen = new $7vYz3(gen);
    var num, n2;
    while(true){
        num = new $7vYz3($5rfiH(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($fddfe224e234e046$var$ONE);
        if (!num.testn(1)) num.iadd($fddfe224e234e046$var$TWO);
        if (!gen.cmp($fddfe224e234e046$var$TWO)) while(num.mod($fddfe224e234e046$var$TWENTYFOUR).cmp($fddfe224e234e046$var$ELEVEN))num.iadd($fddfe224e234e046$var$FOUR);
        else if (!gen.cmp($fddfe224e234e046$var$FIVE)) while(num.mod($fddfe224e234e046$var$TEN).cmp($fddfe224e234e046$var$THREE))num.iadd($fddfe224e234e046$var$FOUR);
        n2 = num.shrn(1);
        if ($fddfe224e234e046$var$simpleSieve(n2) && $fddfe224e234e046$var$simpleSieve(num) && $fddfe224e234e046$var$fermatTest(n2) && $fddfe224e234e046$var$fermatTest(num) && $fddfe224e234e046$var$millerRabin.test(n2) && $fddfe224e234e046$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("7vYz3", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4hcaz", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $9JRha = parcelRequire("9JRha");
function $31d2308cd740d826$var$MillerRabin(rand) {
    this.rand = rand || new $9JRha.Rand();
}
module.exports = $31d2308cd740d826$var$MillerRabin;
$31d2308cd740d826$var$MillerRabin.create = function create(rand) {
    return new $31d2308cd740d826$var$MillerRabin(rand);
};
$31d2308cd740d826$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7vYz3(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$31d2308cd740d826$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$31d2308cd740d826$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$31d2308cd740d826$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7vYz3.mont(n);
    var rone = new $7vYz3(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7vYz3(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("9JRha", function(module, exports) {
var $7171a486633c2eed$var$r;
module.exports = function rand(len) {
    if (!$7171a486633c2eed$var$r) $7171a486633c2eed$var$r = new $7171a486633c2eed$var$Rand(null);
    return $7171a486633c2eed$var$r.generate(len);
};
function $7171a486633c2eed$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $7171a486633c2eed$var$Rand;
$7171a486633c2eed$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $7171a486633c2eed$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $7171a486633c2eed$var$crypto = (parcelRequire("5Io6y"));
    if (typeof $7171a486633c2eed$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $7171a486633c2eed$var$Rand.prototype._rand = function _rand(n) {
        return $7171a486633c2eed$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("fsr3h", function(module, exports) {
module.exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');

});

parcelRegister("2kgCI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1b1a581faa6d58f2$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $4hcaz = parcelRequire("4hcaz");
var $1b1a581faa6d58f2$var$millerRabin = new $4hcaz();
var $1b1a581faa6d58f2$var$TWENTYFOUR = new $7vYz3(24);
var $1b1a581faa6d58f2$var$ELEVEN = new $7vYz3(11);
var $1b1a581faa6d58f2$var$TEN = new $7vYz3(10);
var $1b1a581faa6d58f2$var$THREE = new $7vYz3(3);
var $1b1a581faa6d58f2$var$SEVEN = new $7vYz3(7);

var $lNmPw = parcelRequire("lNmPw");

var $5rfiH = parcelRequire("5rfiH");
module.exports = $1b1a581faa6d58f2$var$DH;
function $1b1a581faa6d58f2$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(pub)) pub = new $1b1a581faa6d58f2$require$Buffer(pub, enc);
    this._pub = new $7vYz3(pub);
    return this;
}
function $1b1a581faa6d58f2$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(priv)) priv = new $1b1a581faa6d58f2$require$Buffer(priv, enc);
    this._priv = new $7vYz3(priv);
    return this;
}
var $1b1a581faa6d58f2$var$primeCache = {};
function $1b1a581faa6d58f2$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $1b1a581faa6d58f2$var$primeCache) return $1b1a581faa6d58f2$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$lNmPw.simpleSieve || !$lNmPw.fermatTest(prime) || !$1b1a581faa6d58f2$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $1b1a581faa6d58f2$var$primeCache[hex] = error;
        return error;
    }
    if (!$1b1a581faa6d58f2$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($1b1a581faa6d58f2$var$TWENTYFOUR).cmp($1b1a581faa6d58f2$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($1b1a581faa6d58f2$var$TEN);
            if (rem.cmp($1b1a581faa6d58f2$var$THREE) && rem.cmp($1b1a581faa6d58f2$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $1b1a581faa6d58f2$var$primeCache[hex] = error;
    return error;
}
function $1b1a581faa6d58f2$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $7vYz3(prime);
    this._prime = $7vYz3.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $1b1a581faa6d58f2$var$setPublicKey;
        this.setPrivateKey = $1b1a581faa6d58f2$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($1b1a581faa6d58f2$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $1b1a581faa6d58f2$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$1b1a581faa6d58f2$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $7vYz3($5rfiH(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$1b1a581faa6d58f2$var$DH.prototype.computeSecret = function(other) {
    other = new $7vYz3(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $1b1a581faa6d58f2$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $1b1a581faa6d58f2$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $1b1a581faa6d58f2$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$1b1a581faa6d58f2$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._pub, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._priv, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getPrime = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this.__prime, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.getGenerator = function(enc) {
    return $1b1a581faa6d58f2$var$formatReturnValue(this._gen, enc);
};
$1b1a581faa6d58f2$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$1b1a581faa6d58f2$require$Buffer.isBuffer(gen)) gen = new $1b1a581faa6d58f2$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $7vYz3(gen);
    return this;
};
function $1b1a581faa6d58f2$var$formatReturnValue(bn, enc) {
    var buf = new $1b1a581faa6d58f2$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("bOCXe", function(module, exports) {

var $6U9mG = parcelRequire("6U9mG");
var $89a294bd7a4a7e9a$require$Buffer = $6U9mG.Buffer;

var $3FiLE = parcelRequire("3FiLE");

var $9AddZ = parcelRequire("9AddZ");

var $eSHUL = parcelRequire("eSHUL");

var $ar1Lb = parcelRequire("ar1Lb");

var $eri43 = parcelRequire("eri43");

var $jdVex = parcelRequire("jdVex");
Object.keys($jdVex).forEach(function(key) {
    $jdVex[key].id = $89a294bd7a4a7e9a$require$Buffer.from($jdVex[key].id, "hex");
    $jdVex[key.toLowerCase()] = $jdVex[key];
});
function $89a294bd7a4a7e9a$var$Sign(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Sign, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Sign.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $89a294bd7a4a7e9a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$89a294bd7a4a7e9a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $ar1Lb(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $89a294bd7a4a7e9a$var$Verify(algorithm) {
    $9AddZ.Writable.call(this);
    var data = $jdVex[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $3FiLE(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$eSHUL($89a294bd7a4a7e9a$var$Verify, $9AddZ.Writable);
$89a294bd7a4a7e9a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$89a294bd7a4a7e9a$var$Verify.prototype.update = function update(data, enc) {
    if (typeof data === "string") data = $89a294bd7a4a7e9a$require$Buffer.from(data, enc);
    this._hash.update(data);
    return this;
};
$89a294bd7a4a7e9a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    if (typeof sig === "string") sig = $89a294bd7a4a7e9a$require$Buffer.from(sig, enc);
    this.end();
    var hash = this._hash.digest();
    return $eri43(sig, hash, key, this._signType, this._tag);
};
function $89a294bd7a4a7e9a$var$createSign(algorithm) {
    return new $89a294bd7a4a7e9a$var$Sign(algorithm);
}
function $89a294bd7a4a7e9a$var$createVerify(algorithm) {
    return new $89a294bd7a4a7e9a$var$Verify(algorithm);
}
module.exports = {
    Sign: $89a294bd7a4a7e9a$var$createSign,
    Verify: $89a294bd7a4a7e9a$var$createVerify,
    createSign: $89a294bd7a4a7e9a$var$createSign,
    createVerify: $89a294bd7a4a7e9a$var$createVerify
};

});
parcelRegister("ar1Lb", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $6U9mG = parcelRequire("6U9mG");
var $798dca7f522a1f11$require$Buffer = $6U9mG.Buffer;

var $cUvgf = parcelRequire("cUvgf");

var $hG1cM = parcelRequire("hG1cM");

var $8J1ou = parcelRequire("8J1ou");
var $798dca7f522a1f11$require$EC = $8J1ou.ec;

var $4B7L6 = parcelRequire("4B7L6");

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $798dca7f522a1f11$var$sign(hash, key, hashType, signType, tag) {
    var priv = $579Op(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $798dca7f522a1f11$var$dsaSign(hash, priv, hashType);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    }
    hash = $798dca7f522a1f11$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $hG1cM(pad, priv);
    return out;
}
function $798dca7f522a1f11$var$ecSign(hash, priv) {
    var curveId = $i66tY[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $798dca7f522a1f11$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $798dca7f522a1f11$require$Buffer.from(out.toDER());
}
function $798dca7f522a1f11$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $4B7L6(0);
    var k;
    var H = $798dca7f522a1f11$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $798dca7f522a1f11$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $798dca7f522a1f11$var$makeKey(q, kv, algo);
        r = $798dca7f522a1f11$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $4B7L6(0);
        }
    }
    return $798dca7f522a1f11$var$toDER(r, s);
}
function $798dca7f522a1f11$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $798dca7f522a1f11$require$Buffer.from(res);
}
function $798dca7f522a1f11$var$getKey(x, q, hash, algo) {
    x = $798dca7f522a1f11$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - x.length);
        x = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $798dca7f522a1f11$var$bits2octets(hash, q);
    var v = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $798dca7f522a1f11$require$Buffer.alloc(hlen);
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    k = $cUvgf(algo, k).update(v).update($798dca7f522a1f11$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cUvgf(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $798dca7f522a1f11$var$bits2int(obits, q) {
    var bits = new $4B7L6(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $798dca7f522a1f11$var$bits2octets(bits, q) {
    bits = $798dca7f522a1f11$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $798dca7f522a1f11$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $798dca7f522a1f11$require$Buffer.alloc(q.byteLength() - out.length);
        out = $798dca7f522a1f11$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $798dca7f522a1f11$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $798dca7f522a1f11$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
            t = $798dca7f522a1f11$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $798dca7f522a1f11$var$bits2int(t, q);
        kv.k = $cUvgf(algo, kv.k).update(kv.v).update($798dca7f522a1f11$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cUvgf(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $798dca7f522a1f11$var$makeR(g, k, p, q) {
    return g.toRed($4B7L6.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $798dca7f522a1f11$var$sign;
module.exports.getKey = $798dca7f522a1f11$var$getKey;
module.exports.makeKey = $798dca7f522a1f11$var$makeKey;

});
parcelRegister("hG1cM", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03522ea20c8c4eb1$require$Buffer = $ihoyg.Buffer;

var $DJXAs = parcelRequire("DJXAs");

var $5rfiH = parcelRequire("5rfiH");
function $03522ea20c8c4eb1$var$blind(priv) {
    var r = $03522ea20c8c4eb1$var$getr(priv);
    var blinder = r.toRed($DJXAs.mont(priv.modulus)).redPow(new $DJXAs(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $03522ea20c8c4eb1$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $DJXAs($5rfiH(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $03522ea20c8c4eb1$var$crt(msg, priv) {
    var blinds = $03522ea20c8c4eb1$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $DJXAs(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($DJXAs.mont(priv.prime1));
    var c2 = blinded.toRed($DJXAs.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($03522ea20c8c4eb1$require$Buffer, "be", len);
}
$03522ea20c8c4eb1$var$crt.getr = $03522ea20c8c4eb1$var$getr;
module.exports = $03522ea20c8c4eb1$var$crt;

});
parcelRegister("DJXAs", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("8J1ou", function(module, exports) {
"use strict";
var $65a39b84537b61c7$var$elliptic = module.exports;

$65a39b84537b61c7$var$elliptic.version = (parcelRequire("jfwBV")).version;

$65a39b84537b61c7$var$elliptic.utils = (parcelRequire("ZdcNb"));

$65a39b84537b61c7$var$elliptic.rand = (parcelRequire("9JRha"));

$65a39b84537b61c7$var$elliptic.curve = (parcelRequire("fYJT3"));

$65a39b84537b61c7$var$elliptic.curves = (parcelRequire("hwVHR"));

// Protocols
$65a39b84537b61c7$var$elliptic.ec = (parcelRequire("9lW0h"));

$65a39b84537b61c7$var$elliptic.eddsa = (parcelRequire("96jZE"));

});
parcelRegister("jfwBV", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("ZdcNb", function(module, exports) {
"use strict";
var $0b7ff0ec21b47efd$var$utils = module.exports;

var $7vYz3 = parcelRequire("7vYz3");

var $aJt1P = parcelRequire("aJt1P");

var $6J8qY = parcelRequire("6J8qY");
$0b7ff0ec21b47efd$var$utils.assert = $aJt1P;
$0b7ff0ec21b47efd$var$utils.toArray = $6J8qY.toArray;
$0b7ff0ec21b47efd$var$utils.zero2 = $6J8qY.zero2;
$0b7ff0ec21b47efd$var$utils.toHex = $6J8qY.toHex;
$0b7ff0ec21b47efd$var$utils.encode = $6J8qY.encode;
// Represent num in a w-NAF form
function $0b7ff0ec21b47efd$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    naf.fill(0);
    var ws = 1 << w + 1;
    var k = num.clone();
    for(var i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$0b7ff0ec21b47efd$var$utils.getNAF = $0b7ff0ec21b47efd$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $0b7ff0ec21b47efd$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$0b7ff0ec21b47efd$var$utils.getJSF = $0b7ff0ec21b47efd$var$getJSF;
function $0b7ff0ec21b47efd$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$0b7ff0ec21b47efd$var$utils.cachedProperty = $0b7ff0ec21b47efd$var$cachedProperty;
function $0b7ff0ec21b47efd$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $0b7ff0ec21b47efd$var$utils.toArray(bytes, "hex") : bytes;
}
$0b7ff0ec21b47efd$var$utils.parseBytes = $0b7ff0ec21b47efd$var$parseBytes;
function $0b7ff0ec21b47efd$var$intFromLE(bytes) {
    return new $7vYz3(bytes, "hex", "le");
}
$0b7ff0ec21b47efd$var$utils.intFromLE = $0b7ff0ec21b47efd$var$intFromLE;

});
parcelRegister("6J8qY", function(module, exports) {
"use strict";
var $4e5d7ce234b4cbb5$var$utils = module.exports;
function $4e5d7ce234b4cbb5$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toArray = $4e5d7ce234b4cbb5$var$toArray;
function $4e5d7ce234b4cbb5$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$4e5d7ce234b4cbb5$var$utils.zero2 = $4e5d7ce234b4cbb5$var$zero2;
function $4e5d7ce234b4cbb5$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $4e5d7ce234b4cbb5$var$zero2(msg[i].toString(16));
    return res;
}
$4e5d7ce234b4cbb5$var$utils.toHex = $4e5d7ce234b4cbb5$var$toHex;
$4e5d7ce234b4cbb5$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $4e5d7ce234b4cbb5$var$toHex(arr);
    else return arr;
};

});


parcelRegister("fYJT3", function(module, exports) {
"use strict";
var $ba200dd58ee56ab1$var$curve = module.exports;

$ba200dd58ee56ab1$var$curve.base = (parcelRequire("1dHTG"));

$ba200dd58ee56ab1$var$curve.short = (parcelRequire("laKc8"));

$ba200dd58ee56ab1$var$curve.mont = (parcelRequire("3uGhx"));

$ba200dd58ee56ab1$var$curve.edwards = (parcelRequire("a0HUE"));

});
parcelRegister("1dHTG", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $0e390e60fe847ab5$var$getNAF = $ZdcNb.getNAF;
var $0e390e60fe847ab5$var$getJSF = $ZdcNb.getJSF;
var $0e390e60fe847ab5$var$assert = $ZdcNb.assert;
function $0e390e60fe847ab5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7vYz3(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7vYz3.red(conf.prime) : $7vYz3.mont(this.p);
    // Useful for many curves
    this.zero = new $7vYz3(0).toRed(this.red);
    this.one = new $7vYz3(1).toRed(this.red);
    this.two = new $7vYz3(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7vYz3(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $0e390e60fe847ab5$var$BaseCurve;
$0e390e60fe847ab5$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $0e390e60fe847ab5$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $0e390e60fe847ab5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $0e390e60fe847ab5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $0e390e60fe847ab5$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$0e390e60fe847ab5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $0e390e60fe847ab5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $0e390e60fe847ab5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $0e390e60fe847ab5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $0e390e60fe847ab5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$0e390e60fe847ab5$var$BaseCurve.BasePoint = $0e390e60fe847ab5$var$BasePoint;
$0e390e60fe847ab5$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$0e390e60fe847ab5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$0e390e60fe847ab5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $ZdcNb.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $0e390e60fe847ab5$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$0e390e60fe847ab5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$0e390e60fe847ab5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$0e390e60fe847ab5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $ZdcNb.encode(this._encode(compact), enc);
};
$0e390e60fe847ab5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$0e390e60fe847ab5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$0e390e60fe847ab5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$0e390e60fe847ab5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$0e390e60fe847ab5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("laKc8", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $f69e5d783a5b036a$var$assert = $ZdcNb.assert;
function $f69e5d783a5b036a$var$ShortCurve(conf) {
    $1dHTG.call(this, "short", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$eSHUL($f69e5d783a5b036a$var$ShortCurve, $1dHTG);
module.exports = $f69e5d783a5b036a$var$ShortCurve;
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7vYz3(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7vYz3(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $f69e5d783a5b036a$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7vYz3(vec.a, 16),
            b: new $7vYz3(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7vYz3.mont(num);
    var tinv = new $7vYz3(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7vYz3(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7vYz3(1);
    var y1 = new $7vYz3(0);
    var x2 = new $7vYz3(0);
    var y2 = new $7vYz3(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $f69e5d783a5b036a$var$Point(curve, x, y, isRed) {
    $1dHTG.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$eSHUL($f69e5d783a5b036a$var$Point, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $f69e5d783a5b036a$var$Point(this, x, y, isRed);
};
$f69e5d783a5b036a$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $f69e5d783a5b036a$var$Point.fromJSON(this, obj, red);
};
$f69e5d783a5b036a$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$f69e5d783a5b036a$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$f69e5d783a5b036a$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$f69e5d783a5b036a$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$f69e5d783a5b036a$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$f69e5d783a5b036a$var$Point.prototype.mul = function mul(k) {
    k = new $7vYz3(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$f69e5d783a5b036a$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$f69e5d783a5b036a$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$f69e5d783a5b036a$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$f69e5d783a5b036a$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $f69e5d783a5b036a$var$JPoint(curve, x, y, z) {
    $1dHTG.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7vYz3(0);
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = new $7vYz3(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$eSHUL($f69e5d783a5b036a$var$JPoint, $1dHTG.BasePoint);
$f69e5d783a5b036a$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $f69e5d783a5b036a$var$JPoint(this, x, y, z);
};
$f69e5d783a5b036a$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$f69e5d783a5b036a$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$f69e5d783a5b036a$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$f69e5d783a5b036a$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$f69e5d783a5b036a$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$f69e5d783a5b036a$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7vYz3(k, kbase);
    return this.curve._wnafMul(this, k);
};
$f69e5d783a5b036a$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$f69e5d783a5b036a$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$f69e5d783a5b036a$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$f69e5d783a5b036a$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("3uGhx", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");

var $ZdcNb = parcelRequire("ZdcNb");
function $28b4f8bfddf22eb4$var$MontCurve(conf) {
    $1dHTG.call(this, "mont", conf);
    this.a = new $7vYz3(conf.a, 16).toRed(this.red);
    this.b = new $7vYz3(conf.b, 16).toRed(this.red);
    this.i4 = new $7vYz3(4).toRed(this.red).redInvm();
    this.two = new $7vYz3(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$eSHUL($28b4f8bfddf22eb4$var$MontCurve, $1dHTG);
module.exports = $28b4f8bfddf22eb4$var$MontCurve;
$28b4f8bfddf22eb4$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $28b4f8bfddf22eb4$var$Point(curve, x, z) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7vYz3(x, 16);
        this.z = new $7vYz3(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$eSHUL($28b4f8bfddf22eb4$var$Point, $1dHTG.BasePoint);
$28b4f8bfddf22eb4$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($ZdcNb.toArray(bytes, enc), 1);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.point = function point(x, z) {
    return new $28b4f8bfddf22eb4$var$Point(this, x, z);
};
$28b4f8bfddf22eb4$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $28b4f8bfddf22eb4$var$Point.fromJSON(this, obj);
};
$28b4f8bfddf22eb4$var$Point.prototype.precompute = function precompute() {
// No-op
};
$28b4f8bfddf22eb4$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$28b4f8bfddf22eb4$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $28b4f8bfddf22eb4$var$Point(curve, obj[0], obj[1] || curve.one);
};
$28b4f8bfddf22eb4$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$28b4f8bfddf22eb4$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$28b4f8bfddf22eb4$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$28b4f8bfddf22eb4$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$28b4f8bfddf22eb4$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$28b4f8bfddf22eb4$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$28b4f8bfddf22eb4$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("a0HUE", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");

var $7vYz3 = parcelRequire("7vYz3");

var $eSHUL = parcelRequire("eSHUL");

var $1dHTG = parcelRequire("1dHTG");
var $749bf799fac4284f$var$assert = $ZdcNb.assert;
function $749bf799fac4284f$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $1dHTG.call(this, "edwards", conf);
    this.a = new $7vYz3(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7vYz3(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7vYz3(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $749bf799fac4284f$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$eSHUL($749bf799fac4284f$var$EdwardsCurve, $1dHTG);
module.exports = $749bf799fac4284f$var$EdwardsCurve;
$749bf799fac4284f$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$749bf799fac4284f$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$749bf799fac4284f$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7vYz3(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7vYz3(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $749bf799fac4284f$var$Point(curve, x, y, z, t) {
    $1dHTG.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7vYz3(x, 16);
        this.y = new $7vYz3(y, 16);
        this.z = z ? new $7vYz3(z, 16) : this.curve.one;
        this.t = t && new $7vYz3(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$eSHUL($749bf799fac4284f$var$Point, $1dHTG.BasePoint);
$749bf799fac4284f$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $749bf799fac4284f$var$Point.fromJSON(this, obj);
};
$749bf799fac4284f$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $749bf799fac4284f$var$Point(this, x, y, z, t);
};
$749bf799fac4284f$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $749bf799fac4284f$var$Point(curve, obj[0], obj[1], obj[2]);
};
$749bf799fac4284f$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$749bf799fac4284f$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$749bf799fac4284f$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$749bf799fac4284f$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$749bf799fac4284f$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$749bf799fac4284f$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$749bf799fac4284f$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$749bf799fac4284f$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$749bf799fac4284f$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$749bf799fac4284f$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$749bf799fac4284f$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$749bf799fac4284f$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$749bf799fac4284f$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$749bf799fac4284f$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$749bf799fac4284f$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$749bf799fac4284f$var$Point.prototype.toP = $749bf799fac4284f$var$Point.prototype.normalize;
$749bf799fac4284f$var$Point.prototype.mixedAdd = $749bf799fac4284f$var$Point.prototype.add;

});


parcelRegister("hwVHR", function(module, exports) {
"use strict";
var $cc32301b3f482b8e$var$curves = module.exports;

var $leqJp = parcelRequire("leqJp");

var $fYJT3 = parcelRequire("fYJT3");

var $ZdcNb = parcelRequire("ZdcNb");
var $cc32301b3f482b8e$var$assert = $ZdcNb.assert;
function $cc32301b3f482b8e$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $fYJT3.short(options);
    else if (options.type === "edwards") this.curve = new $fYJT3.edwards(options);
    else this.curve = new $fYJT3.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $cc32301b3f482b8e$var$assert(this.g.validate(), "Invalid curve");
    $cc32301b3f482b8e$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$cc32301b3f482b8e$var$curves.PresetCurve = $cc32301b3f482b8e$var$PresetCurve;
function $cc32301b3f482b8e$var$defineCurve(name, options) {
    Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $cc32301b3f482b8e$var$PresetCurve(options);
            Object.defineProperty($cc32301b3f482b8e$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$cc32301b3f482b8e$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $leqJp.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$cc32301b3f482b8e$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $leqJp.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$cc32301b3f482b8e$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$cc32301b3f482b8e$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $leqJp.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $cc32301b3f482b8e$var$pre;

try {
    $cc32301b3f482b8e$var$pre = (parcelRequire("63oZi"));
} catch (e) {
    $cc32301b3f482b8e$var$pre = undefined;
}
$cc32301b3f482b8e$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $leqJp.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $cc32301b3f482b8e$var$pre
    ]
});

});
parcelRegister("leqJp", function(module, exports) {
var $f74fa412f2053ea0$var$hash = module.exports;

$f74fa412f2053ea0$var$hash.utils = (parcelRequire("3vltz"));

$f74fa412f2053ea0$var$hash.common = (parcelRequire("hoO3s"));

$f74fa412f2053ea0$var$hash.sha = (parcelRequire("esJCG"));

$f74fa412f2053ea0$var$hash.ripemd = (parcelRequire("ak1PH"));

$f74fa412f2053ea0$var$hash.hmac = (parcelRequire("X5z30"));
// Proxy hash functions to the main object
$f74fa412f2053ea0$var$hash.sha1 = $f74fa412f2053ea0$var$hash.sha.sha1;
$f74fa412f2053ea0$var$hash.sha256 = $f74fa412f2053ea0$var$hash.sha.sha256;
$f74fa412f2053ea0$var$hash.sha224 = $f74fa412f2053ea0$var$hash.sha.sha224;
$f74fa412f2053ea0$var$hash.sha384 = $f74fa412f2053ea0$var$hash.sha.sha384;
$f74fa412f2053ea0$var$hash.sha512 = $f74fa412f2053ea0$var$hash.sha.sha512;
$f74fa412f2053ea0$var$hash.ripemd160 = $f74fa412f2053ea0$var$hash.ripemd.ripemd160;

});
parcelRegister("3vltz", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $28d4ed0635aac004$export$69f1b2dcda23c5f8; }, function (v) { return $28d4ed0635aac004$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $28d4ed0635aac004$export$45b10814cc054894; }, function (v) { return $28d4ed0635aac004$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $28d4ed0635aac004$export$7ea66e3774a60b67; }, function (v) { return $28d4ed0635aac004$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $28d4ed0635aac004$export$34a52f00f601f6f1; }, function (v) { return $28d4ed0635aac004$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $28d4ed0635aac004$export$812b0cbd5e8a72ab; }, function (v) { return $28d4ed0635aac004$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $28d4ed0635aac004$export$f24f9e11d63bb314; }, function (v) { return $28d4ed0635aac004$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $28d4ed0635aac004$export$b71357c7e07ca1f1; }, function (v) { return $28d4ed0635aac004$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $28d4ed0635aac004$export$2e58a4b541fdcbe8; }, function (v) { return $28d4ed0635aac004$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $28d4ed0635aac004$export$183b950bde9faab8; }, function (v) { return $28d4ed0635aac004$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $28d4ed0635aac004$export$4785c77169fea59e; }, function (v) { return $28d4ed0635aac004$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $28d4ed0635aac004$export$242a185dfcffac5b; }, function (v) { return $28d4ed0635aac004$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $28d4ed0635aac004$export$58c04ae0ae31877d; }, function (v) { return $28d4ed0635aac004$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $28d4ed0635aac004$export$d058ca695f8c6f11; }, function (v) { return $28d4ed0635aac004$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $28d4ed0635aac004$export$a1efd7fc3e986367; }, function (v) { return $28d4ed0635aac004$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $28d4ed0635aac004$export$bbfea4a2b5abaab4; }, function (v) { return $28d4ed0635aac004$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $28d4ed0635aac004$export$97ad4afc7de86152; }, function (v) { return $28d4ed0635aac004$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $28d4ed0635aac004$export$ce4673d9a79f6a4b; }, function (v) { return $28d4ed0635aac004$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $28d4ed0635aac004$export$786cc99fc6eedc0b; }, function (v) { return $28d4ed0635aac004$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $28d4ed0635aac004$export$45c59b9a1848dd0; }, function (v) { return $28d4ed0635aac004$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $28d4ed0635aac004$export$50d8f613e76d3034; }, function (v) { return $28d4ed0635aac004$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $28d4ed0635aac004$export$b8e83683c60ee162; }, function (v) { return $28d4ed0635aac004$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $28d4ed0635aac004$export$aeeb51790d1bcc4a; }, function (v) { return $28d4ed0635aac004$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $28d4ed0635aac004$export$bb7c616f719ad9c; }, function (v) { return $28d4ed0635aac004$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $28d4ed0635aac004$export$4d63290824f9d7df; }, function (v) { return $28d4ed0635aac004$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $28d4ed0635aac004$export$2f64ceb90ef28ea1; }, function (v) { return $28d4ed0635aac004$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $28d4ed0635aac004$export$8d2089d465f6d10d; }, function (v) { return $28d4ed0635aac004$export$8d2089d465f6d10d = v; });
var $28d4ed0635aac004$export$69f1b2dcda23c5f8;
var $28d4ed0635aac004$export$45b10814cc054894;
var $28d4ed0635aac004$export$7ea66e3774a60b67;
var $28d4ed0635aac004$export$34a52f00f601f6f1;
var $28d4ed0635aac004$export$812b0cbd5e8a72ab;
var $28d4ed0635aac004$export$f24f9e11d63bb314;
var $28d4ed0635aac004$export$b71357c7e07ca1f1;
var $28d4ed0635aac004$export$2e58a4b541fdcbe8;
var $28d4ed0635aac004$export$183b950bde9faab8;
var $28d4ed0635aac004$export$4785c77169fea59e;
var $28d4ed0635aac004$export$242a185dfcffac5b;
var $28d4ed0635aac004$export$58c04ae0ae31877d;
var $28d4ed0635aac004$export$d058ca695f8c6f11;
var $28d4ed0635aac004$export$a1efd7fc3e986367;
var $28d4ed0635aac004$export$bbfea4a2b5abaab4;
var $28d4ed0635aac004$export$97ad4afc7de86152;
var $28d4ed0635aac004$export$ce4673d9a79f6a4b;
var $28d4ed0635aac004$export$786cc99fc6eedc0b;
var $28d4ed0635aac004$export$45c59b9a1848dd0;
var $28d4ed0635aac004$export$50d8f613e76d3034;
var $28d4ed0635aac004$export$b8e83683c60ee162;
var $28d4ed0635aac004$export$aeeb51790d1bcc4a;
var $28d4ed0635aac004$export$bb7c616f719ad9c;
var $28d4ed0635aac004$export$4d63290824f9d7df;
var $28d4ed0635aac004$export$2f64ceb90ef28ea1;
var $28d4ed0635aac004$export$8d2089d465f6d10d;
"use strict";

var $aJt1P = parcelRequire("aJt1P");

var $eSHUL = parcelRequire("eSHUL");
$28d4ed0635aac004$export$69f1b2dcda23c5f8 = $eSHUL;
function $28d4ed0635aac004$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $28d4ed0635aac004$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($28d4ed0635aac004$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$28d4ed0635aac004$export$45b10814cc054894 = $28d4ed0635aac004$var$toArray;
function $28d4ed0635aac004$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $28d4ed0635aac004$var$zero2(msg[i].toString(16));
    return res;
}
$28d4ed0635aac004$export$7ea66e3774a60b67 = $28d4ed0635aac004$var$toHex;
function $28d4ed0635aac004$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$28d4ed0635aac004$export$34a52f00f601f6f1 = $28d4ed0635aac004$var$htonl;
function $28d4ed0635aac004$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $28d4ed0635aac004$var$htonl(w);
        res += $28d4ed0635aac004$var$zero8(w.toString(16));
    }
    return res;
}
$28d4ed0635aac004$export$812b0cbd5e8a72ab = $28d4ed0635aac004$var$toHex32;
function $28d4ed0635aac004$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$28d4ed0635aac004$export$f24f9e11d63bb314 = $28d4ed0635aac004$var$zero2;
function $28d4ed0635aac004$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$28d4ed0635aac004$export$b71357c7e07ca1f1 = $28d4ed0635aac004$var$zero8;
function $28d4ed0635aac004$var$join32(msg, start, end, endian) {
    var len = end - start;
    $aJt1P(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$28d4ed0635aac004$export$2e58a4b541fdcbe8 = $28d4ed0635aac004$var$join32;
function $28d4ed0635aac004$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$28d4ed0635aac004$export$183b950bde9faab8 = $28d4ed0635aac004$var$split32;
function $28d4ed0635aac004$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$28d4ed0635aac004$export$4785c77169fea59e = $28d4ed0635aac004$var$rotr32;
function $28d4ed0635aac004$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$28d4ed0635aac004$export$242a185dfcffac5b = $28d4ed0635aac004$var$rotl32;
function $28d4ed0635aac004$var$sum32(a, b) {
    return a + b >>> 0;
}
$28d4ed0635aac004$export$58c04ae0ae31877d = $28d4ed0635aac004$var$sum32;
function $28d4ed0635aac004$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$28d4ed0635aac004$export$d058ca695f8c6f11 = $28d4ed0635aac004$var$sum32_3;
function $28d4ed0635aac004$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$28d4ed0635aac004$export$a1efd7fc3e986367 = $28d4ed0635aac004$var$sum32_4;
function $28d4ed0635aac004$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$28d4ed0635aac004$export$bbfea4a2b5abaab4 = $28d4ed0635aac004$var$sum32_5;
function $28d4ed0635aac004$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$28d4ed0635aac004$export$97ad4afc7de86152 = $28d4ed0635aac004$var$sum64;
function $28d4ed0635aac004$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$28d4ed0635aac004$export$ce4673d9a79f6a4b = $28d4ed0635aac004$var$sum64_hi;
function $28d4ed0635aac004$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$786cc99fc6eedc0b = $28d4ed0635aac004$var$sum64_lo;
function $28d4ed0635aac004$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$45c59b9a1848dd0 = $28d4ed0635aac004$var$sum64_4_hi;
function $28d4ed0635aac004$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$28d4ed0635aac004$export$50d8f613e76d3034 = $28d4ed0635aac004$var$sum64_4_lo;
function $28d4ed0635aac004$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$28d4ed0635aac004$export$b8e83683c60ee162 = $28d4ed0635aac004$var$sum64_5_hi;
function $28d4ed0635aac004$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$28d4ed0635aac004$export$aeeb51790d1bcc4a = $28d4ed0635aac004$var$sum64_5_lo;
function $28d4ed0635aac004$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$bb7c616f719ad9c = $28d4ed0635aac004$var$rotr64_hi;
function $28d4ed0635aac004$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$4d63290824f9d7df = $28d4ed0635aac004$var$rotr64_lo;
function $28d4ed0635aac004$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$28d4ed0635aac004$export$2f64ceb90ef28ea1 = $28d4ed0635aac004$var$shr64_hi;
function $28d4ed0635aac004$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$28d4ed0635aac004$export$8d2089d465f6d10d = $28d4ed0635aac004$var$shr64_lo;

});

parcelRegister("hoO3s", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $caab81610dd48e7b$export$8687658379b577e6; }, function (v) { return $caab81610dd48e7b$export$8687658379b577e6 = v; });
var $caab81610dd48e7b$export$8687658379b577e6;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $caab81610dd48e7b$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$caab81610dd48e7b$export$8687658379b577e6 = $caab81610dd48e7b$var$BlockHash;
$caab81610dd48e7b$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $3vltz.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $3vltz.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$caab81610dd48e7b$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $aJt1P(this.pending === null);
    return this._digest(enc);
};
$caab81610dd48e7b$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("esJCG", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $a87711fd35b0090f$export$5091bdda49ba90f5; }, function (v) { return $a87711fd35b0090f$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $a87711fd35b0090f$export$97b70509d4e397ea; }, function (v) { return $a87711fd35b0090f$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $a87711fd35b0090f$export$bced8d2aada2d1c9; }, function (v) { return $a87711fd35b0090f$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $a87711fd35b0090f$export$612d47d55dedde45; }, function (v) { return $a87711fd35b0090f$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $a87711fd35b0090f$export$a888d2532e6dc7bb; }, function (v) { return $a87711fd35b0090f$export$a888d2532e6dc7bb = v; });
var $a87711fd35b0090f$export$5091bdda49ba90f5;
var $a87711fd35b0090f$export$97b70509d4e397ea;
var $a87711fd35b0090f$export$bced8d2aada2d1c9;
var $a87711fd35b0090f$export$612d47d55dedde45;
var $a87711fd35b0090f$export$a888d2532e6dc7bb;
"use strict";

$a87711fd35b0090f$export$5091bdda49ba90f5 = (parcelRequire("4n9Qi"));

$a87711fd35b0090f$export$97b70509d4e397ea = (parcelRequire("2w2RS"));

$a87711fd35b0090f$export$bced8d2aada2d1c9 = (parcelRequire("6tl9X"));

$a87711fd35b0090f$export$612d47d55dedde45 = (parcelRequire("1zFKP"));

$a87711fd35b0090f$export$a888d2532e6dc7bb = (parcelRequire("b8Cnj"));

});
parcelRegister("4n9Qi", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");
var $32f0f1f12aa851fd$var$rotl32 = $3vltz.rotl32;
var $32f0f1f12aa851fd$var$sum32 = $3vltz.sum32;
var $32f0f1f12aa851fd$var$sum32_5 = $3vltz.sum32_5;
var $32f0f1f12aa851fd$var$ft_1 = $7pXSD.ft_1;
var $32f0f1f12aa851fd$var$BlockHash = $hoO3s.BlockHash;
var $32f0f1f12aa851fd$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $32f0f1f12aa851fd$var$SHA1() {
    if (!(this instanceof $32f0f1f12aa851fd$var$SHA1)) return new $32f0f1f12aa851fd$var$SHA1();
    $32f0f1f12aa851fd$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$3vltz.inherits($32f0f1f12aa851fd$var$SHA1, $32f0f1f12aa851fd$var$BlockHash);
module.exports = $32f0f1f12aa851fd$var$SHA1;
$32f0f1f12aa851fd$var$SHA1.blockSize = 512;
$32f0f1f12aa851fd$var$SHA1.outSize = 160;
$32f0f1f12aa851fd$var$SHA1.hmacStrength = 80;
$32f0f1f12aa851fd$var$SHA1.padLength = 64;
$32f0f1f12aa851fd$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $32f0f1f12aa851fd$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $32f0f1f12aa851fd$var$sum32_5($32f0f1f12aa851fd$var$rotl32(a, 5), $32f0f1f12aa851fd$var$ft_1(s, b, c, d), e, W[i], $32f0f1f12aa851fd$var$sha1_K[s]);
        e = d;
        d = c;
        c = $32f0f1f12aa851fd$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $32f0f1f12aa851fd$var$sum32(this.h[0], a);
    this.h[1] = $32f0f1f12aa851fd$var$sum32(this.h[1], b);
    this.h[2] = $32f0f1f12aa851fd$var$sum32(this.h[2], c);
    this.h[3] = $32f0f1f12aa851fd$var$sum32(this.h[3], d);
    this.h[4] = $32f0f1f12aa851fd$var$sum32(this.h[4], e);
};
$32f0f1f12aa851fd$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});
parcelRegister("7pXSD", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $5669512b21aa6962$export$5a92649d7ddb9f63; }, function (v) { return $5669512b21aa6962$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $5669512b21aa6962$export$c6d0d020c3a6269; }, function (v) { return $5669512b21aa6962$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $5669512b21aa6962$export$eb90c27fca05f956; }, function (v) { return $5669512b21aa6962$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $5669512b21aa6962$export$14a4a98e063b1999; }, function (v) { return $5669512b21aa6962$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $5669512b21aa6962$export$d20cecfa1564c686; }, function (v) { return $5669512b21aa6962$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $5669512b21aa6962$export$44fd472a12fc6db; }, function (v) { return $5669512b21aa6962$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $5669512b21aa6962$export$1ed238bb6ea1dd47; }, function (v) { return $5669512b21aa6962$export$1ed238bb6ea1dd47 = v; });
var $5669512b21aa6962$export$5a92649d7ddb9f63;
var $5669512b21aa6962$export$c6d0d020c3a6269;
var $5669512b21aa6962$export$eb90c27fca05f956;
var $5669512b21aa6962$export$cc992891a14496a1;
var $5669512b21aa6962$export$14a4a98e063b1999;
var $5669512b21aa6962$export$d20cecfa1564c686;
var $5669512b21aa6962$export$44fd472a12fc6db;
var $5669512b21aa6962$export$1ed238bb6ea1dd47;
"use strict";

var $3vltz = parcelRequire("3vltz");
var $5669512b21aa6962$var$rotr32 = $3vltz.rotr32;
function $5669512b21aa6962$var$ft_1(s, x, y, z) {
    if (s === 0) return $5669512b21aa6962$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $5669512b21aa6962$var$p32(x, y, z);
    if (s === 2) return $5669512b21aa6962$var$maj32(x, y, z);
}
$5669512b21aa6962$export$5a92649d7ddb9f63 = $5669512b21aa6962$var$ft_1;
function $5669512b21aa6962$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$5669512b21aa6962$export$c6d0d020c3a6269 = $5669512b21aa6962$var$ch32;
function $5669512b21aa6962$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$5669512b21aa6962$export$eb90c27fca05f956 = $5669512b21aa6962$var$maj32;
function $5669512b21aa6962$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$5669512b21aa6962$export$cc992891a14496a1 = $5669512b21aa6962$var$p32;
function $5669512b21aa6962$var$s0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 2) ^ $5669512b21aa6962$var$rotr32(x, 13) ^ $5669512b21aa6962$var$rotr32(x, 22);
}
$5669512b21aa6962$export$14a4a98e063b1999 = $5669512b21aa6962$var$s0_256;
function $5669512b21aa6962$var$s1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 6) ^ $5669512b21aa6962$var$rotr32(x, 11) ^ $5669512b21aa6962$var$rotr32(x, 25);
}
$5669512b21aa6962$export$d20cecfa1564c686 = $5669512b21aa6962$var$s1_256;
function $5669512b21aa6962$var$g0_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 7) ^ $5669512b21aa6962$var$rotr32(x, 18) ^ x >>> 3;
}
$5669512b21aa6962$export$44fd472a12fc6db = $5669512b21aa6962$var$g0_256;
function $5669512b21aa6962$var$g1_256(x) {
    return $5669512b21aa6962$var$rotr32(x, 17) ^ $5669512b21aa6962$var$rotr32(x, 19) ^ x >>> 10;
}
$5669512b21aa6962$export$1ed238bb6ea1dd47 = $5669512b21aa6962$var$g1_256;

});


parcelRegister("2w2RS", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $6tl9X = parcelRequire("6tl9X");
function $1d50cb6dff0ac7e1$var$SHA224() {
    if (!(this instanceof $1d50cb6dff0ac7e1$var$SHA224)) return new $1d50cb6dff0ac7e1$var$SHA224();
    $6tl9X.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$3vltz.inherits($1d50cb6dff0ac7e1$var$SHA224, $6tl9X);
module.exports = $1d50cb6dff0ac7e1$var$SHA224;
$1d50cb6dff0ac7e1$var$SHA224.blockSize = 512;
$1d50cb6dff0ac7e1$var$SHA224.outSize = 224;
$1d50cb6dff0ac7e1$var$SHA224.hmacStrength = 192;
$1d50cb6dff0ac7e1$var$SHA224.padLength = 64;
$1d50cb6dff0ac7e1$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 7), "big");
    else return $3vltz.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("6tl9X", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $7pXSD = parcelRequire("7pXSD");

var $aJt1P = parcelRequire("aJt1P");
var $4b65dd591dedf929$var$sum32 = $3vltz.sum32;
var $4b65dd591dedf929$var$sum32_4 = $3vltz.sum32_4;
var $4b65dd591dedf929$var$sum32_5 = $3vltz.sum32_5;
var $4b65dd591dedf929$var$ch32 = $7pXSD.ch32;
var $4b65dd591dedf929$var$maj32 = $7pXSD.maj32;
var $4b65dd591dedf929$var$s0_256 = $7pXSD.s0_256;
var $4b65dd591dedf929$var$s1_256 = $7pXSD.s1_256;
var $4b65dd591dedf929$var$g0_256 = $7pXSD.g0_256;
var $4b65dd591dedf929$var$g1_256 = $7pXSD.g1_256;
var $4b65dd591dedf929$var$BlockHash = $hoO3s.BlockHash;
var $4b65dd591dedf929$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $4b65dd591dedf929$var$SHA256() {
    if (!(this instanceof $4b65dd591dedf929$var$SHA256)) return new $4b65dd591dedf929$var$SHA256();
    $4b65dd591dedf929$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $4b65dd591dedf929$var$sha256_K;
    this.W = new Array(64);
}
$3vltz.inherits($4b65dd591dedf929$var$SHA256, $4b65dd591dedf929$var$BlockHash);
module.exports = $4b65dd591dedf929$var$SHA256;
$4b65dd591dedf929$var$SHA256.blockSize = 512;
$4b65dd591dedf929$var$SHA256.outSize = 256;
$4b65dd591dedf929$var$SHA256.hmacStrength = 192;
$4b65dd591dedf929$var$SHA256.padLength = 64;
$4b65dd591dedf929$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $4b65dd591dedf929$var$sum32_4($4b65dd591dedf929$var$g1_256(W[i - 2]), W[i - 7], $4b65dd591dedf929$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $aJt1P(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $4b65dd591dedf929$var$sum32_5(h, $4b65dd591dedf929$var$s1_256(e), $4b65dd591dedf929$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $4b65dd591dedf929$var$sum32($4b65dd591dedf929$var$s0_256(a), $4b65dd591dedf929$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $4b65dd591dedf929$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $4b65dd591dedf929$var$sum32(T1, T2);
    }
    this.h[0] = $4b65dd591dedf929$var$sum32(this.h[0], a);
    this.h[1] = $4b65dd591dedf929$var$sum32(this.h[1], b);
    this.h[2] = $4b65dd591dedf929$var$sum32(this.h[2], c);
    this.h[3] = $4b65dd591dedf929$var$sum32(this.h[3], d);
    this.h[4] = $4b65dd591dedf929$var$sum32(this.h[4], e);
    this.h[5] = $4b65dd591dedf929$var$sum32(this.h[5], f);
    this.h[6] = $4b65dd591dedf929$var$sum32(this.h[6], g);
    this.h[7] = $4b65dd591dedf929$var$sum32(this.h[7], h);
};
$4b65dd591dedf929$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};

});


parcelRegister("1zFKP", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $b8Cnj = parcelRequire("b8Cnj");
function $125972e0f41acdab$var$SHA384() {
    if (!(this instanceof $125972e0f41acdab$var$SHA384)) return new $125972e0f41acdab$var$SHA384();
    $b8Cnj.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$3vltz.inherits($125972e0f41acdab$var$SHA384, $b8Cnj);
module.exports = $125972e0f41acdab$var$SHA384;
$125972e0f41acdab$var$SHA384.blockSize = 1024;
$125972e0f41acdab$var$SHA384.outSize = 384;
$125972e0f41acdab$var$SHA384.hmacStrength = 192;
$125972e0f41acdab$var$SHA384.padLength = 128;
$125972e0f41acdab$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h.slice(0, 12), "big");
    else return $3vltz.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("b8Cnj", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");

var $aJt1P = parcelRequire("aJt1P");
var $81be358d8f6abcff$var$rotr64_hi = $3vltz.rotr64_hi;
var $81be358d8f6abcff$var$rotr64_lo = $3vltz.rotr64_lo;
var $81be358d8f6abcff$var$shr64_hi = $3vltz.shr64_hi;
var $81be358d8f6abcff$var$shr64_lo = $3vltz.shr64_lo;
var $81be358d8f6abcff$var$sum64 = $3vltz.sum64;
var $81be358d8f6abcff$var$sum64_hi = $3vltz.sum64_hi;
var $81be358d8f6abcff$var$sum64_lo = $3vltz.sum64_lo;
var $81be358d8f6abcff$var$sum64_4_hi = $3vltz.sum64_4_hi;
var $81be358d8f6abcff$var$sum64_4_lo = $3vltz.sum64_4_lo;
var $81be358d8f6abcff$var$sum64_5_hi = $3vltz.sum64_5_hi;
var $81be358d8f6abcff$var$sum64_5_lo = $3vltz.sum64_5_lo;
var $81be358d8f6abcff$var$BlockHash = $hoO3s.BlockHash;
var $81be358d8f6abcff$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $81be358d8f6abcff$var$SHA512() {
    if (!(this instanceof $81be358d8f6abcff$var$SHA512)) return new $81be358d8f6abcff$var$SHA512();
    $81be358d8f6abcff$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $81be358d8f6abcff$var$sha512_K;
    this.W = new Array(160);
}
$3vltz.inherits($81be358d8f6abcff$var$SHA512, $81be358d8f6abcff$var$BlockHash);
module.exports = $81be358d8f6abcff$var$SHA512;
$81be358d8f6abcff$var$SHA512.blockSize = 1024;
$81be358d8f6abcff$var$SHA512.outSize = 512;
$81be358d8f6abcff$var$SHA512.hmacStrength = 192;
$81be358d8f6abcff$var$SHA512.padLength = 128;
$81be358d8f6abcff$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $81be358d8f6abcff$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $81be358d8f6abcff$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $81be358d8f6abcff$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $81be358d8f6abcff$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $81be358d8f6abcff$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $81be358d8f6abcff$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$81be358d8f6abcff$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $aJt1P(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $81be358d8f6abcff$var$s1_512_hi(eh, el);
        var c1_lo = $81be358d8f6abcff$var$s1_512_lo(eh, el);
        var c2_hi = $81be358d8f6abcff$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $81be358d8f6abcff$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $81be358d8f6abcff$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $81be358d8f6abcff$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $81be358d8f6abcff$var$s0_512_hi(ah, al);
        c0_lo = $81be358d8f6abcff$var$s0_512_lo(ah, al);
        c1_hi = $81be358d8f6abcff$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $81be358d8f6abcff$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $81be358d8f6abcff$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $81be358d8f6abcff$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $81be358d8f6abcff$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $81be358d8f6abcff$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $81be358d8f6abcff$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $81be358d8f6abcff$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $81be358d8f6abcff$var$sum64(this.h, 0, ah, al);
    $81be358d8f6abcff$var$sum64(this.h, 2, bh, bl);
    $81be358d8f6abcff$var$sum64(this.h, 4, ch, cl);
    $81be358d8f6abcff$var$sum64(this.h, 6, dh, dl);
    $81be358d8f6abcff$var$sum64(this.h, 8, eh, el);
    $81be358d8f6abcff$var$sum64(this.h, 10, fh, fl);
    $81be358d8f6abcff$var$sum64(this.h, 12, gh, gl);
    $81be358d8f6abcff$var$sum64(this.h, 14, hh, hl);
};
$81be358d8f6abcff$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "big");
    else return $3vltz.split32(this.h, "big");
};
function $81be358d8f6abcff$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$s1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g0_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_hi(xh, xl) {
    var c0_hi = $81be358d8f6abcff$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $81be358d8f6abcff$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $81be358d8f6abcff$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $81be358d8f6abcff$var$g1_512_lo(xh, xl) {
    var c0_lo = $81be358d8f6abcff$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $81be358d8f6abcff$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $81be358d8f6abcff$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("ak1PH", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e; }, function (v) { return $783d3195a6b3253e$export$d1cea0ee4e3f0d3e = v; });
var $783d3195a6b3253e$export$d1cea0ee4e3f0d3e;
"use strict";

var $3vltz = parcelRequire("3vltz");

var $hoO3s = parcelRequire("hoO3s");
var $783d3195a6b3253e$var$rotl32 = $3vltz.rotl32;
var $783d3195a6b3253e$var$sum32 = $3vltz.sum32;
var $783d3195a6b3253e$var$sum32_3 = $3vltz.sum32_3;
var $783d3195a6b3253e$var$sum32_4 = $3vltz.sum32_4;
var $783d3195a6b3253e$var$BlockHash = $hoO3s.BlockHash;
function $783d3195a6b3253e$var$RIPEMD160() {
    if (!(this instanceof $783d3195a6b3253e$var$RIPEMD160)) return new $783d3195a6b3253e$var$RIPEMD160();
    $783d3195a6b3253e$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$3vltz.inherits($783d3195a6b3253e$var$RIPEMD160, $783d3195a6b3253e$var$BlockHash);
$783d3195a6b3253e$export$d1cea0ee4e3f0d3e = $783d3195a6b3253e$var$RIPEMD160;
$783d3195a6b3253e$var$RIPEMD160.blockSize = 512;
$783d3195a6b3253e$var$RIPEMD160.outSize = 160;
$783d3195a6b3253e$var$RIPEMD160.hmacStrength = 192;
$783d3195a6b3253e$var$RIPEMD160.padLength = 64;
$783d3195a6b3253e$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(A, $783d3195a6b3253e$var$f(j, B, C, D), msg[$783d3195a6b3253e$var$r[j] + start], $783d3195a6b3253e$var$K(j)), $783d3195a6b3253e$var$s[j]), E);
        A = E;
        E = D;
        D = $783d3195a6b3253e$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $783d3195a6b3253e$var$sum32($783d3195a6b3253e$var$rotl32($783d3195a6b3253e$var$sum32_4(Ah, $783d3195a6b3253e$var$f(79 - j, Bh, Ch, Dh), msg[$783d3195a6b3253e$var$rh[j] + start], $783d3195a6b3253e$var$Kh(j)), $783d3195a6b3253e$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $783d3195a6b3253e$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $783d3195a6b3253e$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $783d3195a6b3253e$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $783d3195a6b3253e$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $783d3195a6b3253e$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $783d3195a6b3253e$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$783d3195a6b3253e$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $3vltz.toHex32(this.h, "little");
    else return $3vltz.split32(this.h, "little");
};
function $783d3195a6b3253e$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $783d3195a6b3253e$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $783d3195a6b3253e$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $783d3195a6b3253e$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $783d3195a6b3253e$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $783d3195a6b3253e$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $783d3195a6b3253e$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("X5z30", function(module, exports) {
"use strict";

var $3vltz = parcelRequire("3vltz");

var $aJt1P = parcelRequire("aJt1P");
function $0b19d3c0f7d555a6$var$Hmac(hash, key, enc) {
    if (!(this instanceof $0b19d3c0f7d555a6$var$Hmac)) return new $0b19d3c0f7d555a6$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($3vltz.toArray(key, enc));
}
module.exports = $0b19d3c0f7d555a6$var$Hmac;
$0b19d3c0f7d555a6$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $aJt1P(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$0b19d3c0f7d555a6$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$0b19d3c0f7d555a6$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("63oZi", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("9lW0h", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $5WFpm = parcelRequire("5WFpm");

var $ZdcNb = parcelRequire("ZdcNb");

var $hwVHR = parcelRequire("hwVHR");

var $9JRha = parcelRequire("9JRha");
var $6cf31182d56f3d95$var$assert = $ZdcNb.assert;

var $lE5ol = parcelRequire("lE5ol");

var $kQeFn = parcelRequire("kQeFn");
function $6cf31182d56f3d95$var$EC(options) {
    if (!(this instanceof $6cf31182d56f3d95$var$EC)) return new $6cf31182d56f3d95$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $6cf31182d56f3d95$var$assert(Object.prototype.hasOwnProperty.call($hwVHR, options), "Unknown curve " + options);
        options = $hwVHR[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hwVHR.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $6cf31182d56f3d95$var$EC;
$6cf31182d56f3d95$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lE5ol(this, options);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lE5ol.fromPrivate(this, priv, enc);
};
$6cf31182d56f3d95$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lE5ol.fromPublic(this, pub, enc);
};
$6cf31182d56f3d95$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $9JRha(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7vYz3(2));
    for(;;){
        var priv = new $7vYz3(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$6cf31182d56f3d95$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$6cf31182d56f3d95$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new $7vYz3(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $5WFpm({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7vYz3(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7vYz3(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $kQeFn({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$6cf31182d56f3d95$var$EC.prototype.verify = function verify(msg, signature, key, enc) {
    msg = this._truncateToN(new $7vYz3(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature = new $kQeFn(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$6cf31182d56f3d95$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $6cf31182d56f3d95$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $kQeFn(signature, enc);
    var n = this.n;
    var e = new $7vYz3(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$6cf31182d56f3d95$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $kQeFn(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("5WFpm", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $6J8qY = parcelRequire("6J8qY");

var $aJt1P = parcelRequire("aJt1P");
function $45427d4f96da3b8c$var$HmacDRBG(options) {
    if (!(this instanceof $45427d4f96da3b8c$var$HmacDRBG)) return new $45427d4f96da3b8c$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $6J8qY.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $6J8qY.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $6J8qY.toArray(options.pers, options.persEnc || "hex");
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $45427d4f96da3b8c$var$HmacDRBG;
$45427d4f96da3b8c$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $leqJp.hmac(this.hash, this.K);
};
$45427d4f96da3b8c$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $6J8qY.toArray(entropy, entropyEnc);
    add = $6J8qY.toArray(add, addEnc);
    $aJt1P(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$45427d4f96da3b8c$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $6J8qY.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $6J8qY.encode(res, enc);
};

});

parcelRegister("lE5ol", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $fc21840fd53be280$var$assert = $ZdcNb.assert;
function $fc21840fd53be280$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fc21840fd53be280$var$KeyPair;
$fc21840fd53be280$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fc21840fd53be280$var$KeyPair) return pub;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fc21840fd53be280$var$KeyPair) return priv;
    return new $fc21840fd53be280$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fc21840fd53be280$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fc21840fd53be280$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fc21840fd53be280$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fc21840fd53be280$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7vYz3(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fc21840fd53be280$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fc21840fd53be280$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fc21840fd53be280$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fc21840fd53be280$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fc21840fd53be280$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fc21840fd53be280$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fc21840fd53be280$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$fc21840fd53be280$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("kQeFn", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $f2c40a6448de4ea4$var$assert = $ZdcNb.assert;
function $f2c40a6448de4ea4$var$Signature(options, enc) {
    if (options instanceof $f2c40a6448de4ea4$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $f2c40a6448de4ea4$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $7vYz3(options.r, 16);
    this.s = new $7vYz3(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $f2c40a6448de4ea4$var$Signature;
function $f2c40a6448de4ea4$var$Position() {
    this.place = 0;
}
function $f2c40a6448de4ea4$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $f2c40a6448de4ea4$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$f2c40a6448de4ea4$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $ZdcNb.toArray(data, enc);
    var p = new $f2c40a6448de4ea4$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $f2c40a6448de4ea4$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $f2c40a6448de4ea4$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7vYz3(r);
    this.s = new $7vYz3(s);
    this.recoveryParam = null;
    return true;
};
function $f2c40a6448de4ea4$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$f2c40a6448de4ea4$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $f2c40a6448de4ea4$var$rmPadding(r);
    s = $f2c40a6448de4ea4$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $f2c40a6448de4ea4$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $f2c40a6448de4ea4$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $f2c40a6448de4ea4$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $ZdcNb.encode(res, enc);
};

});


parcelRegister("96jZE", function(module, exports) {
"use strict";

var $leqJp = parcelRequire("leqJp");

var $hwVHR = parcelRequire("hwVHR");

var $ZdcNb = parcelRequire("ZdcNb");
var $6a042ee1f208896f$var$assert = $ZdcNb.assert;
var $6a042ee1f208896f$var$parseBytes = $ZdcNb.parseBytes;

var $cR8ar = parcelRequire("cR8ar");

var $8zcvU = parcelRequire("8zcvU");
function $6a042ee1f208896f$var$EDDSA(curve) {
    $6a042ee1f208896f$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $6a042ee1f208896f$var$EDDSA)) return new $6a042ee1f208896f$var$EDDSA(curve);
    curve = $hwVHR[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $leqJp.sha512;
}
module.exports = $6a042ee1f208896f$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6a042ee1f208896f$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6a042ee1f208896f$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6a042ee1f208896f$var$parseBytes(message);
    sig = this.makeSignature(sig);
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6a042ee1f208896f$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $ZdcNb.intFromLE(hash.digest()).umod(this.curve.n);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $cR8ar.fromPublic(this, pub);
};
$6a042ee1f208896f$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $cR8ar.fromSecret(this, secret);
};
$6a042ee1f208896f$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $8zcvU) return sig;
    return new $8zcvU(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6a042ee1f208896f$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6a042ee1f208896f$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $ZdcNb.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $ZdcNb.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6a042ee1f208896f$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$6a042ee1f208896f$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $ZdcNb.intFromLE(bytes);
};
$6a042ee1f208896f$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("cR8ar", function(module, exports) {
"use strict";

var $ZdcNb = parcelRequire("ZdcNb");
var $95c0c52842c57a81$var$assert = $ZdcNb.assert;
var $95c0c52842c57a81$var$parseBytes = $ZdcNb.parseBytes;
var $95c0c52842c57a81$var$cachedProperty = $ZdcNb.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $95c0c52842c57a81$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $95c0c52842c57a81$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $95c0c52842c57a81$var$parseBytes(params.pub);
}
$95c0c52842c57a81$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $95c0c52842c57a81$var$KeyPair) return pub;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        pub: pub
    });
};
$95c0c52842c57a81$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $95c0c52842c57a81$var$KeyPair) return secret;
    return new $95c0c52842c57a81$var$KeyPair(eddsa, {
        secret: secret
    });
};
$95c0c52842c57a81$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$95c0c52842c57a81$var$cachedProperty($95c0c52842c57a81$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$95c0c52842c57a81$var$KeyPair.prototype.sign = function sign(message) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$95c0c52842c57a81$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $95c0c52842c57a81$var$assert(this._secret, "KeyPair is public only");
    return $ZdcNb.encode(this.secret(), enc);
};
$95c0c52842c57a81$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $ZdcNb.encode(this.pubBytes(), enc);
};
module.exports = $95c0c52842c57a81$var$KeyPair;

});

parcelRegister("8zcvU", function(module, exports) {
"use strict";

var $7vYz3 = parcelRequire("7vYz3");

var $ZdcNb = parcelRequire("ZdcNb");
var $63cb4c939de36593$var$assert = $ZdcNb.assert;
var $63cb4c939de36593$var$cachedProperty = $ZdcNb.cachedProperty;
var $63cb4c939de36593$var$parseBytes = $ZdcNb.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $63cb4c939de36593$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $63cb4c939de36593$var$parseBytes(sig);
    if (Array.isArray(sig)) sig = {
        R: sig.slice(0, eddsa.encodingLength),
        S: sig.slice(eddsa.encodingLength)
    };
    $63cb4c939de36593$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7vYz3) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$63cb4c939de36593$var$cachedProperty($63cb4c939de36593$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$63cb4c939de36593$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$63cb4c939de36593$var$Signature.prototype.toHex = function toHex() {
    return $ZdcNb.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $63cb4c939de36593$var$Signature;

});



parcelRegister("4B7L6", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("579Op", function(module, exports) {

var $2FHZp = parcelRequire("2FHZp");

var $buRsR = parcelRequire("buRsR");

var $hpCup = parcelRequire("hpCup");

var $k1gB1 = parcelRequire("k1gB1");

var $1UZ5c = parcelRequire("1UZ5c");

var $6U9mG = parcelRequire("6U9mG");
var $3b9537b0914cb295$require$Buffer = $6U9mG.Buffer;
module.exports = $3b9537b0914cb295$var$parseKeys;
function $3b9537b0914cb295$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$3b9537b0914cb295$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $3b9537b0914cb295$require$Buffer.from(buffer);
    var stripped = $hpCup(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $2FHZp.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $2FHZp.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $2FHZp.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $2FHZp.EncryptedPrivateKey.decode(data, "der");
            data = $3b9537b0914cb295$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $2FHZp.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $2FHZp.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $2FHZp.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $2FHZp.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $2FHZp.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $2FHZp.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $2FHZp.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $2FHZp.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$3b9537b0914cb295$var$parseKeys.signature = $2FHZp.signature;
function $3b9537b0914cb295$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $buRsR[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $1UZ5c.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $k1gB1.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher.final());
    return $3b9537b0914cb295$require$Buffer.concat(out);
}

});
parcelRegister("2FHZp", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $1f21887c987abd19$export$c98397a6eb8d0678; }, function (v) { return $1f21887c987abd19$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $1f21887c987abd19$export$f4aab6816f64fa6b; }, function (v) { return $1f21887c987abd19$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $1f21887c987abd19$export$4471f5c65d097c11; }, function (v) { return $1f21887c987abd19$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $1f21887c987abd19$export$ca8b6604d6ce14de; }, function (v) { return $1f21887c987abd19$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $1f21887c987abd19$export$8f54525b330fd87b; }, function (v) { return $1f21887c987abd19$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $1f21887c987abd19$export$23cd2842b44ca3e7; }, function (v) { return $1f21887c987abd19$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $1f21887c987abd19$export$245c9aaa9f5ce4ce; }, function (v) { return $1f21887c987abd19$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $1f21887c987abd19$export$8ad762e3e6399afe; }, function (v) { return $1f21887c987abd19$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $1f21887c987abd19$export$32ef6f92e22c6ab0; }, function (v) { return $1f21887c987abd19$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $1f21887c987abd19$export$c9cd164b539ebb63; }, function (v) { return $1f21887c987abd19$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $1f21887c987abd19$export$c98397a6eb8d0678;
var $1f21887c987abd19$export$f4aab6816f64fa6b;
var $1f21887c987abd19$export$4471f5c65d097c11;
var $1f21887c987abd19$export$ca8b6604d6ce14de;
var $1f21887c987abd19$export$8f54525b330fd87b;
var $1f21887c987abd19$export$23cd2842b44ca3e7;
var $1f21887c987abd19$export$245c9aaa9f5ce4ce;
var $1f21887c987abd19$export$8ad762e3e6399afe;
var $1f21887c987abd19$export$32ef6f92e22c6ab0;
var $1f21887c987abd19$export$c9cd164b539ebb63;
"use strict";

var $aMCkA = parcelRequire("aMCkA");

$1f21887c987abd19$export$c98397a6eb8d0678 = (parcelRequire("aa7wN"));
var $1f21887c987abd19$var$RSAPrivateKey = $aMCkA.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("modulus").int(), this.key("publicExponent").int(), this.key("privateExponent").int(), this.key("prime1").int(), this.key("prime2").int(), this.key("exponent1").int(), this.key("exponent2").int(), this.key("coefficient").int());
});
$1f21887c987abd19$export$f4aab6816f64fa6b = $1f21887c987abd19$var$RSAPrivateKey;
var $1f21887c987abd19$var$RSAPublicKey = $aMCkA.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus").int(), this.key("publicExponent").int());
});
$1f21887c987abd19$export$4471f5c65d097c11 = $1f21887c987abd19$var$RSAPublicKey;
var $1f21887c987abd19$var$PublicKey = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$1f21887c987abd19$export$ca8b6604d6ce14de = $1f21887c987abd19$var$PublicKey;
var $1f21887c987abd19$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p").int(), this.key("q").int(), this.key("g").int()).optional());
});
var $1f21887c987abd19$var$PrivateKeyInfo = $aMCkA.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version").int(), this.key("algorithm").use($1f21887c987abd19$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$8f54525b330fd87b = $1f21887c987abd19$var$PrivateKeyInfo;
var $1f21887c987abd19$var$EncryptedPrivateKeyInfo = $aMCkA.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters").int())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$1f21887c987abd19$export$23cd2842b44ca3e7 = $1f21887c987abd19$var$EncryptedPrivateKeyInfo;
var $1f21887c987abd19$var$DSAPrivateKey = $aMCkA.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("p").int(), this.key("q").int(), this.key("g").int(), this.key("pub_key").int(), this.key("priv_key").int());
});
$1f21887c987abd19$export$245c9aaa9f5ce4ce = $1f21887c987abd19$var$DSAPrivateKey;
$1f21887c987abd19$export$8ad762e3e6399afe = $aMCkA.define("DSAparam", function() {
    this.int();
});
var $1f21887c987abd19$var$ECPrivateKey = $aMCkA.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version").int(), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($1f21887c987abd19$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$1f21887c987abd19$export$32ef6f92e22c6ab0 = $1f21887c987abd19$var$ECPrivateKey;
var $1f21887c987abd19$var$ECParameters = $aMCkA.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
$1f21887c987abd19$export$c9cd164b539ebb63 = $aMCkA.define("signature", function() {
    this.seq().obj(this.key("r").int(), this.key("s").int());
});

});
parcelRegister("aMCkA", function(module, exports) {
"use strict";
const $7d9c1ed330ef59e6$var$asn1 = module.exports;

$7d9c1ed330ef59e6$var$asn1.bignum = (parcelRequire("7vYz3"));

$7d9c1ed330ef59e6$var$asn1.define = (parcelRequire("jcRMx")).define;

$7d9c1ed330ef59e6$var$asn1.base = (parcelRequire("eMucS"));

$7d9c1ed330ef59e6$var$asn1.constants = (parcelRequire("2Qobq"));

$7d9c1ed330ef59e6$var$asn1.decoders = (parcelRequire("jTBMn"));

$7d9c1ed330ef59e6$var$asn1.encoders = (parcelRequire("8MqVr"));

});
parcelRegister("jcRMx", function(module, exports) {
"use strict";

var $8MqVr = parcelRequire("8MqVr");

var $jTBMn = parcelRequire("jTBMn");

var $eSHUL = parcelRequire("eSHUL");
const $dfb8db4a4a86a3f4$var$api = module.exports;
$dfb8db4a4a86a3f4$var$api.define = function define(name, body) {
    return new $dfb8db4a4a86a3f4$var$Entity(name, body);
};
function $dfb8db4a4a86a3f4$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}
$dfb8db4a4a86a3f4$var$Entity.prototype._createNamed = function createNamed(Base) {
    const name = this.name;
    function Generated(entity) {
        this._initNamed(entity, name);
    }
    $eSHUL(Generated, Base);
    Generated.prototype._initNamed = function _initNamed(entity, name) {
        Base.call(this, entity, name);
    };
    return new Generated(this);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($jTBMn[enc]);
    return this.decoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$dfb8db4a4a86a3f4$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($8MqVr[enc]);
    return this.encoders[enc];
};
$dfb8db4a4a86a3f4$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("8MqVr", function(module, exports) {
"use strict";
const $6647b13f24468e50$var$encoders = module.exports;

$6647b13f24468e50$var$encoders.der = (parcelRequire("44g7l"));

$6647b13f24468e50$var$encoders.pem = (parcelRequire("8MKvJ"));

});
parcelRegister("44g7l", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2f6409b794513848$require$Buffer = $dLNO7.Buffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $2f6409b794513848$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $2f6409b794513848$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $2f6409b794513848$var$DEREncoder;
$2f6409b794513848$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $2f6409b794513848$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($2f6409b794513848$var$DERNode, $aAKRg);
$2f6409b794513848$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    const encodedTag = $2f6409b794513848$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        const header = $2f6409b794513848$require$Buffer.alloc(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    let lenOctets = 1;
    for(let i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    const header = $2f6409b794513848$require$Buffer.alloc(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$2f6409b794513848$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        const buf = $2f6409b794513848$require$Buffer.alloc(str.length * 2);
        for(let i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$2f6409b794513848$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s.]+/g);
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(let i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    let size = 0;
    for(let i = 0; i < id.length; i++){
        let ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    const objid = $2f6409b794513848$require$Buffer.alloc(size);
    let offset = objid.length - 1;
    for(let i = id.length - 1; i >= 0; i--){
        let ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $2f6409b794513848$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$2f6409b794513848$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    let str;
    const date = new Date(time);
    if (tag === "gentime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear()),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $2f6409b794513848$var$two(date.getUTCFullYear() % 100),
        $2f6409b794513848$var$two(date.getUTCMonth() + 1),
        $2f6409b794513848$var$two(date.getUTCDate()),
        $2f6409b794513848$var$two(date.getUTCHours()),
        $2f6409b794513848$var$two(date.getUTCMinutes()),
        $2f6409b794513848$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$2f6409b794513848$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$2f6409b794513848$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$2f6409b794513848$require$Buffer.isBuffer(num)) {
        const numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = $2f6409b794513848$require$Buffer.from(numArray);
    }
    if ($2f6409b794513848$require$Buffer.isBuffer(num)) {
        let size = num.length;
        if (num.length === 0) size++;
        const out = $2f6409b794513848$require$Buffer.alloc(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    let size = 1;
    for(let i = num; i >= 0x100; i >>= 8)size++;
    const out = new Array(size);
    for(let i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer($2f6409b794513848$require$Buffer.from(out));
};
$2f6409b794513848$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$2f6409b794513848$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$2f6409b794513848$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    const state = this._baseState;
    let i;
    if (state["default"] === null) return false;
    const data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $2f6409b794513848$var$encodeTag(tag, primitive, cls, reporter) {
    let res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($6SLsO.tagByName.hasOwnProperty(tag)) res = $6SLsO.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $6SLsO.tagClassByName[cls || "universal"] << 6;
    return res;
}

});
parcelRegister("dLNO7", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $a0664cdc1e6bc00b$var$Buffer = $ihoyg.Buffer;
var $a0664cdc1e6bc00b$var$safer = {};
var $a0664cdc1e6bc00b$var$key;
for($a0664cdc1e6bc00b$var$key in $ihoyg){
    if (!$ihoyg.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "SlowBuffer" || $a0664cdc1e6bc00b$var$key === "Buffer") continue;
    $a0664cdc1e6bc00b$var$safer[$a0664cdc1e6bc00b$var$key] = $ihoyg[$a0664cdc1e6bc00b$var$key];
}
var $a0664cdc1e6bc00b$var$Safer = $a0664cdc1e6bc00b$var$safer.Buffer = {};
for($a0664cdc1e6bc00b$var$key in $a0664cdc1e6bc00b$var$Buffer){
    if (!$a0664cdc1e6bc00b$var$Buffer.hasOwnProperty($a0664cdc1e6bc00b$var$key)) continue;
    if ($a0664cdc1e6bc00b$var$key === "allocUnsafe" || $a0664cdc1e6bc00b$var$key === "allocUnsafeSlow") continue;
    $a0664cdc1e6bc00b$var$Safer[$a0664cdc1e6bc00b$var$key] = $a0664cdc1e6bc00b$var$Buffer[$a0664cdc1e6bc00b$var$key];
}
$a0664cdc1e6bc00b$var$safer.Buffer.prototype = $a0664cdc1e6bc00b$var$Buffer.prototype;
if (!$a0664cdc1e6bc00b$var$Safer.from || $a0664cdc1e6bc00b$var$Safer.from === Uint8Array.from) $a0664cdc1e6bc00b$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === "undefined") throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    return $a0664cdc1e6bc00b$var$Buffer(value, encodingOrOffset, length);
};
if (!$a0664cdc1e6bc00b$var$Safer.alloc) $a0664cdc1e6bc00b$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $a0664cdc1e6bc00b$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === "string") buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$a0664cdc1e6bc00b$var$safer.kStringMaxLength) try {
    $a0664cdc1e6bc00b$var$safer.kStringMaxLength = $4TNnu.binding("buffer").kStringMaxLength;
} catch (e) {
// we can't determine kStringMaxLength in environments where process.binding
// is unsupported, so let's not set it
}
if (!$a0664cdc1e6bc00b$var$safer.constants) {
    $a0664cdc1e6bc00b$var$safer.constants = {
        MAX_LENGTH: $a0664cdc1e6bc00b$var$safer.kMaxLength
    };
    if ($a0664cdc1e6bc00b$var$safer.kStringMaxLength) $a0664cdc1e6bc00b$var$safer.constants.MAX_STRING_LENGTH = $a0664cdc1e6bc00b$var$safer.kStringMaxLength;
}
module.exports = $a0664cdc1e6bc00b$var$safer;

});

parcelRegister("aAKRg", function(module, exports) {
"use strict";

var $1NWy8 = parcelRequire("1NWy8");
var $7b619d3ab2aa52ef$require$Reporter = $1NWy8.Reporter;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$EncoderBuffer = $hJsPi.EncoderBuffer;

var $hJsPi = parcelRequire("hJsPi");
var $7b619d3ab2aa52ef$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aJt1P = parcelRequire("aJt1P");
// Supported tags
const $7b619d3ab2aa52ef$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
const $7b619d3ab2aa52ef$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($7b619d3ab2aa52ef$var$tags);
// Overrided methods list
const $7b619d3ab2aa52ef$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $7b619d3ab2aa52ef$var$Node(enc, parent, name) {
    const state = {};
    this._baseState = state;
    state.name = name;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $7b619d3ab2aa52ef$var$Node;
const $7b619d3ab2aa52ef$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$7b619d3ab2aa52ef$var$Node.prototype.clone = function clone() {
    const state = this._baseState;
    const cstate = {};
    $7b619d3ab2aa52ef$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    const res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$7b619d3ab2aa52ef$var$Node.prototype._wrap = function wrap() {
    const state = this._baseState;
    $7b619d3ab2aa52ef$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            const clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$7b619d3ab2aa52ef$var$Node.prototype._init = function init(body) {
    const state = this._baseState;
    $aJt1P(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $aJt1P.equal(state.children.length, 1, "Root node can have only one child");
};
$7b619d3ab2aa52ef$var$Node.prototype._useArgs = function useArgs(args) {
    const state = this._baseState;
    // Filter children and args
    const children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $aJt1P(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $aJt1P(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            const res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                const value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$7b619d3ab2aa52ef$var$overrided.forEach(function(method) {
    $7b619d3ab2aa52ef$var$Node.prototype[method] = function _overrided() {
        const state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$7b619d3ab2aa52ef$var$tags.forEach(function(tag) {
    $7b619d3ab2aa52ef$var$Node.prototype[tag] = function _tagMethod() {
        const state = this._baseState;
        const args = Array.prototype.slice.call(arguments);
        $aJt1P(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$7b619d3ab2aa52ef$var$Node.prototype.use = function use(item) {
    $aJt1P(item);
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.use = item;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.optional = function optional() {
    const state = this._baseState;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.def = function def(val) {
    const state = this._baseState;
    $aJt1P(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.explicit = function explicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.implicit = function implicit(num) {
    const state = this._baseState;
    $aJt1P(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.obj = function obj() {
    const state = this._baseState;
    const args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.key = function key(newKey) {
    const state = this._baseState;
    $aJt1P(state.key === null);
    state.key = newKey;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.any = function any() {
    const state = this._baseState;
    state.any = true;
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.choice = function choice(obj) {
    const state = this._baseState;
    $aJt1P(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$7b619d3ab2aa52ef$var$Node.prototype.contains = function contains(item) {
    const state = this._baseState;
    $aJt1P(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$7b619d3ab2aa52ef$var$Node.prototype._decode = function decode(input, options) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    let result = state["default"];
    let present = true;
    let prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        let tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            const save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    let prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            const explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        const start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            let save;
            if (state.any) save = input.save();
            const body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) ;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            const data = new $7b619d3ab2aa52ef$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    const state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._getUse = function _getUse(entity, obj) {
    const state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $aJt1P(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$7b619d3ab2aa52ef$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    const state = this._baseState;
    let result = null;
    let match = false;
    Object.keys(state.choice).some(function(key) {
        const save = input.save();
        const node = state.choice[key];
        try {
            const value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$7b619d3ab2aa52ef$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $7b619d3ab2aa52ef$require$EncoderBuffer(data, this.reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encode = function encode(data, reporter, parent) {
    const state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    const result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    const state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $7b619d3ab2aa52ef$require$Reporter());
    let result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    let content = null;
    let primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            const prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            const res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            const child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                const state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    if (!state.any && state.choice === null) {
        const tag = state.implicit !== null ? state.implicit : state.tag;
        const cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$7b619d3ab2aa52ef$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    const state = this._baseState;
    const node = state.choice[data.type];
    if (!node) $aJt1P(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$7b619d3ab2aa52ef$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    const state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$7b619d3ab2aa52ef$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$7b619d3ab2aa52ef$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str);
};

});
parcelRegister("1NWy8", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $1507c8ca35a04511$export$957313a2f485e5ed; }, function (v) { return $1507c8ca35a04511$export$957313a2f485e5ed = v; });
var $1507c8ca35a04511$export$957313a2f485e5ed;
"use strict";

var $eSHUL = parcelRequire("eSHUL");
function $1507c8ca35a04511$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$1507c8ca35a04511$export$957313a2f485e5ed = $1507c8ca35a04511$var$Reporter;
$1507c8ca35a04511$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $1507c8ca35a04511$var$ReporterError;
};
$1507c8ca35a04511$var$Reporter.prototype.save = function save() {
    const state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$1507c8ca35a04511$var$Reporter.prototype.restore = function restore(data) {
    const state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$1507c8ca35a04511$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$1507c8ca35a04511$var$Reporter.prototype.exitKey = function exitKey(index) {
    const state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$1507c8ca35a04511$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    const state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$1507c8ca35a04511$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$1507c8ca35a04511$var$Reporter.prototype.enterObject = function enterObject() {
    const state = this._reporterState;
    const prev = state.obj;
    state.obj = {};
    return prev;
};
$1507c8ca35a04511$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    const state = this._reporterState;
    const now = state.obj;
    state.obj = prev;
    return now;
};
$1507c8ca35a04511$var$Reporter.prototype.error = function error(msg) {
    let err;
    const state = this._reporterState;
    const inherited = msg instanceof $1507c8ca35a04511$var$ReporterError;
    if (inherited) err = msg;
    else err = new $1507c8ca35a04511$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$1507c8ca35a04511$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    const state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $1507c8ca35a04511$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$eSHUL($1507c8ca35a04511$var$ReporterError, Error);
$1507c8ca35a04511$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $1507c8ca35a04511$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("hJsPi", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163; }, function (v) { return $ce8cfff3092e20f1$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e; }, function (v) { return $ce8cfff3092e20f1$export$8ff24f7760c7a78e = v; });
var $ce8cfff3092e20f1$export$bf9f79cdc4a49163;
var $ce8cfff3092e20f1$export$8ff24f7760c7a78e;
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $1NWy8 = parcelRequire("1NWy8");
var $ce8cfff3092e20f1$require$Reporter = $1NWy8.Reporter;

var $dLNO7 = parcelRequire("dLNO7");
var $ce8cfff3092e20f1$require$Buffer = $dLNO7.Buffer;
function $ce8cfff3092e20f1$var$DecoderBuffer(base, options) {
    $ce8cfff3092e20f1$require$Reporter.call(this, options);
    if (!$ce8cfff3092e20f1$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$eSHUL($ce8cfff3092e20f1$var$DecoderBuffer, $ce8cfff3092e20f1$require$Reporter);
$ce8cfff3092e20f1$export$bf9f79cdc4a49163 = $ce8cfff3092e20f1$var$DecoderBuffer;
$ce8cfff3092e20f1$var$DecoderBuffer.isDecoderBuffer = function isDecoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$DecoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && $ce8cfff3092e20f1$require$Buffer.isBuffer(data.base) && data.constructor.name === "DecoderBuffer" && typeof data.offset === "number" && typeof data.length === "number" && typeof data.save === "function" && typeof data.restore === "function" && typeof data.isEmpty === "function" && typeof data.readUInt8 === "function" && typeof data.skip === "function" && typeof data.raw === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $ce8cfff3092e20f1$require$Reporter.prototype.save.call(this)
    };
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $ce8cfff3092e20f1$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    const res = new $ce8cfff3092e20f1$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$ce8cfff3092e20f1$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $ce8cfff3092e20f1$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer(item)) item = new $ce8cfff3092e20f1$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $ce8cfff3092e20f1$require$Buffer.byteLength(value);
    } else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$ce8cfff3092e20f1$export$8ff24f7760c7a78e = $ce8cfff3092e20f1$var$EncoderBuffer;
$ce8cfff3092e20f1$var$EncoderBuffer.isEncoderBuffer = function isEncoderBuffer(data) {
    if (data instanceof $ce8cfff3092e20f1$var$EncoderBuffer) return true;
    // Or accept compatible API
    const isCompatible = typeof data === "object" && data.constructor.name === "EncoderBuffer" && typeof data.length === "number" && typeof data.join === "function";
    return isCompatible;
};
$ce8cfff3092e20f1$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = $ce8cfff3092e20f1$require$Buffer.alloc(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($ce8cfff3092e20f1$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});


parcelRegister("6SLsO", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $502c9a8b0256715a$export$3584c46ed60baee8; }, function (v) { return $502c9a8b0256715a$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $502c9a8b0256715a$export$f18596ef8d632e49; }, function (v) { return $502c9a8b0256715a$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $502c9a8b0256715a$export$2b067c6666111485; }, function (v) { return $502c9a8b0256715a$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $502c9a8b0256715a$export$f17df38a421ab9e3; }, function (v) { return $502c9a8b0256715a$export$f17df38a421ab9e3 = v; });
var $502c9a8b0256715a$export$3584c46ed60baee8;
var $502c9a8b0256715a$export$f18596ef8d632e49;
var $502c9a8b0256715a$export$2b067c6666111485;
var $502c9a8b0256715a$export$f17df38a421ab9e3;
"use strict";
// Helper
function $502c9a8b0256715a$var$reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
}
$502c9a8b0256715a$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$502c9a8b0256715a$export$f18596ef8d632e49 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$3584c46ed60baee8);
$502c9a8b0256715a$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$502c9a8b0256715a$export$f17df38a421ab9e3 = $502c9a8b0256715a$var$reverse($502c9a8b0256715a$export$2b067c6666111485);

});


parcelRegister("8MKvJ", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $44g7l = parcelRequire("44g7l");
function $6656e2818f922400$var$PEMEncoder(entity) {
    $44g7l.call(this, entity);
    this.enc = "pem";
}
$eSHUL($6656e2818f922400$var$PEMEncoder, $44g7l);
module.exports = $6656e2818f922400$var$PEMEncoder;
$6656e2818f922400$var$PEMEncoder.prototype.encode = function encode(data, options) {
    const buf = $44g7l.prototype.encode.call(this, data);
    const p = buf.toString("base64");
    const out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(let i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});


parcelRegister("jTBMn", function(module, exports) {
"use strict";
const $e7c0758d361c90ed$var$decoders = module.exports;

$e7c0758d361c90ed$var$decoders.der = (parcelRequire("9Mx3V"));

$e7c0758d361c90ed$var$decoders.pem = (parcelRequire("3KeDh"));

});
parcelRegister("9Mx3V", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $7vYz3 = parcelRequire("7vYz3");

var $hJsPi = parcelRequire("hJsPi");
var $71f23e3d24920fc8$require$DecoderBuffer = $hJsPi.DecoderBuffer;

var $aAKRg = parcelRequire("aAKRg");

var $6SLsO = parcelRequire("6SLsO");
function $71f23e3d24920fc8$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $71f23e3d24920fc8$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $71f23e3d24920fc8$var$DERDecoder;
$71f23e3d24920fc8$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!$71f23e3d24920fc8$require$DecoderBuffer.isDecoderBuffer(data)) data = new $71f23e3d24920fc8$require$DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $71f23e3d24920fc8$var$DERNode(parent) {
    $aAKRg.call(this, "der", parent);
}
$eSHUL($71f23e3d24920fc8$var$DERNode, $aAKRg);
$71f23e3d24920fc8$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    const state = buffer.save();
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    const decodedTag = $71f23e3d24920fc8$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    let len = $71f23e3d24920fc8$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    const state = buffer.save();
    const res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$71f23e3d24920fc8$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    for(;;){
        const tag = $71f23e3d24920fc8$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        const len = $71f23e3d24920fc8$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        let res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    const result = [];
    while(!buffer.isEmpty()){
        const possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        const res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        const unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        const raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        let str = "";
        for(let i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        const numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        const printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    let result;
    const identifiers = [];
    let ident = 0;
    let subident = 0;
    while(!buffer.isEmpty()){
        subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    const first = identifiers[0] / 40 | 0;
    const second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        let tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    const str = buffer.raw().toString();
    let year;
    let mon;
    let day;
    let hour;
    let min;
    let sec;
    if (tag === "gentime") {
        year = str.slice(0, 4) | 0;
        mon = str.slice(4, 6) | 0;
        day = str.slice(6, 8) | 0;
        hour = str.slice(8, 10) | 0;
        min = str.slice(10, 12) | 0;
        sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        year = str.slice(0, 2) | 0;
        mon = str.slice(2, 4) | 0;
        day = str.slice(4, 6) | 0;
        hour = str.slice(6, 8) | 0;
        min = str.slice(8, 10) | 0;
        sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeNull = function decodeNull() {
    return null;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    const res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$71f23e3d24920fc8$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    const raw = buffer.raw();
    let res = new $7vYz3(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$71f23e3d24920fc8$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $71f23e3d24920fc8$var$derDecodeTag(buf, fail) {
    let tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    const cls = $6SLsO.tagClass[tag >> 6];
    const primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        let oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    const tagStr = $6SLsO.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $71f23e3d24920fc8$var$derDecodeLen(buf, primitive, fail) {
    let len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    const num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(let i = 0; i < num; i++){
        len <<= 8;
        const j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("3KeDh", function(module, exports) {
"use strict";

var $eSHUL = parcelRequire("eSHUL");

var $dLNO7 = parcelRequire("dLNO7");
var $2ba104b685a3b739$require$Buffer = $dLNO7.Buffer;

var $9Mx3V = parcelRequire("9Mx3V");
function $2ba104b685a3b739$var$PEMDecoder(entity) {
    $9Mx3V.call(this, entity);
    this.enc = "pem";
}
$eSHUL($2ba104b685a3b739$var$PEMDecoder, $9Mx3V);
module.exports = $2ba104b685a3b739$var$PEMDecoder;
$2ba104b685a3b739$var$PEMDecoder.prototype.decode = function decode(data, options) {
    const lines = data.toString().split(/[\r\n]+/g);
    const label = options.label.toUpperCase();
    const re = /^-----(BEGIN|END) ([^-]+)-----$/;
    let start = -1;
    let end = -1;
    for(let i = 0; i < lines.length; i++){
        const match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    const base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9+/=]+/gi, "");
    const input = $2ba104b685a3b739$require$Buffer.from(base64, "base64");
    return $9Mx3V.prototype.decode.call(this, input, options);
};

});



parcelRegister("eMucS", function(module, exports) {
"use strict";
const $ac2cfaccb178df17$var$base = module.exports;

$ac2cfaccb178df17$var$base.Reporter = (parcelRequire("1NWy8")).Reporter;

$ac2cfaccb178df17$var$base.DecoderBuffer = (parcelRequire("hJsPi")).DecoderBuffer;

$ac2cfaccb178df17$var$base.EncoderBuffer = (parcelRequire("hJsPi")).EncoderBuffer;

$ac2cfaccb178df17$var$base.Node = (parcelRequire("aAKRg"));

});

parcelRegister("2Qobq", function(module, exports) {
"use strict";
const $2123325f185a31d1$var$constants = module.exports;
// Helper
$2123325f185a31d1$var$constants._reverse = function reverse(map) {
    const res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        const value = map[key];
        res[value] = key;
    });
    return res;
};

$2123325f185a31d1$var$constants.der = (parcelRequire("6SLsO"));

});


parcelRegister("aa7wN", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $aMCkA = parcelRequire("aMCkA");
var $7660ad76acc34f2e$var$Time = $aMCkA.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $7660ad76acc34f2e$var$AttributeTypeValue = $aMCkA.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $7660ad76acc34f2e$var$AlgorithmIdentifier = $aMCkA.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $7660ad76acc34f2e$var$SubjectPublicKeyInfo = $aMCkA.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $7660ad76acc34f2e$var$RelativeDistinguishedName = $aMCkA.define("RelativeDistinguishedName", function() {
    this.setof($7660ad76acc34f2e$var$AttributeTypeValue);
});
var $7660ad76acc34f2e$var$RDNSequence = $aMCkA.define("RDNSequence", function() {
    this.seqof($7660ad76acc34f2e$var$RelativeDistinguishedName);
});
var $7660ad76acc34f2e$var$Name = $aMCkA.define("Name", function() {
    this.choice({
        rdnSequence: this.use($7660ad76acc34f2e$var$RDNSequence)
    });
});
var $7660ad76acc34f2e$var$Validity = $aMCkA.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($7660ad76acc34f2e$var$Time), this.key("notAfter").use($7660ad76acc34f2e$var$Time));
});
var $7660ad76acc34f2e$var$Extension = $aMCkA.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $7660ad76acc34f2e$var$TBSCertificate = $aMCkA.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0).int().optional(), this.key("serialNumber").int(), this.key("signature").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("issuer").use($7660ad76acc34f2e$var$Name), this.key("validity").use($7660ad76acc34f2e$var$Validity), this.key("subject").use($7660ad76acc34f2e$var$Name), this.key("subjectPublicKeyInfo").use($7660ad76acc34f2e$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($7660ad76acc34f2e$var$Extension).optional());
});
var $7660ad76acc34f2e$var$X509Certificate = $aMCkA.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($7660ad76acc34f2e$var$TBSCertificate), this.key("signatureAlgorithm").use($7660ad76acc34f2e$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $7660ad76acc34f2e$var$X509Certificate;

});


parcelRegister("buRsR", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("hpCup", function(module, exports) {
// adapted from https://github.com/apatil/pemstrip
var $cad2a0aed7a43a6b$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $cad2a0aed7a43a6b$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $cad2a0aed7a43a6b$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $5uIwM = parcelRequire("5uIwM");

var $k1gB1 = parcelRequire("k1gB1");

var $6U9mG = parcelRequire("6U9mG");
var $cad2a0aed7a43a6b$require$Buffer = $6U9mG.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($cad2a0aed7a43a6b$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($cad2a0aed7a43a6b$var$fullRegex);
        decrypted = $cad2a0aed7a43a6b$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $cad2a0aed7a43a6b$require$Buffer.from(match[2], "hex");
        var cipherText = $cad2a0aed7a43a6b$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $5uIwM(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $k1gB1.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher.final());
        decrypted = $cad2a0aed7a43a6b$require$Buffer.concat(out);
    }
    var tag = key.match($cad2a0aed7a43a6b$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("i66tY", function(module, exports) {
module.exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');

});


parcelRegister("eri43", function(module, exports) {
// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js

var $6U9mG = parcelRequire("6U9mG");
var $a831998143a5cb0b$require$Buffer = $6U9mG.Buffer;

var $4B7L6 = parcelRequire("4B7L6");

var $8J1ou = parcelRequire("8J1ou");
var $a831998143a5cb0b$require$EC = $8J1ou.ec;

var $579Op = parcelRequire("579Op");

var $i66tY = parcelRequire("i66tY");
function $a831998143a5cb0b$var$verify(sig, hash, key, signType, tag) {
    var pub = $579Op(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $a831998143a5cb0b$var$dsaVerify(sig, hash, pub);
    } else {
        if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    }
    hash = $a831998143a5cb0b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum++;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $a831998143a5cb0b$require$Buffer.from(pad);
    var red = $4B7L6.mont(pub.modulus);
    sig = new $4B7L6(sig).toRed(red);
    sig = sig.redPow(new $4B7L6(pub.publicExponent));
    sig = $a831998143a5cb0b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $a831998143a5cb0b$var$ecVerify(sig, hash, pub) {
    var curveId = $i66tY[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $a831998143a5cb0b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $a831998143a5cb0b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $579Op.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $a831998143a5cb0b$var$checkValue(s, q);
    $a831998143a5cb0b$var$checkValue(r, q);
    var montp = $4B7L6.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $4B7L6(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $a831998143a5cb0b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= q) throw new Error("invalid sig");
}
module.exports = $a831998143a5cb0b$var$verify;

});


parcelRegister("bpRNH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $84fbc32b9717e45c$require$Buffer = $ihoyg.Buffer;

var $8J1ou = parcelRequire("8J1ou");

var $7vYz3 = parcelRequire("7vYz3");
module.exports = function createECDH(curve) {
    return new $84fbc32b9717e45c$var$ECDH(curve);
};
var $84fbc32b9717e45c$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$84fbc32b9717e45c$var$aliases.p224 = $84fbc32b9717e45c$var$aliases.secp224r1;
$84fbc32b9717e45c$var$aliases.p256 = $84fbc32b9717e45c$var$aliases.secp256r1 = $84fbc32b9717e45c$var$aliases.prime256v1;
$84fbc32b9717e45c$var$aliases.p192 = $84fbc32b9717e45c$var$aliases.secp192r1 = $84fbc32b9717e45c$var$aliases.prime192v1;
$84fbc32b9717e45c$var$aliases.p384 = $84fbc32b9717e45c$var$aliases.secp384r1;
$84fbc32b9717e45c$var$aliases.p521 = $84fbc32b9717e45c$var$aliases.secp521r1;
function $84fbc32b9717e45c$var$ECDH(curve) {
    this.curveType = $84fbc32b9717e45c$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $8J1ou.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$84fbc32b9717e45c$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$84fbc32b9717e45c$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(other)) other = new $84fbc32b9717e45c$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $84fbc32b9717e45c$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $84fbc32b9717e45c$var$formatReturnValue(key, enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $84fbc32b9717e45c$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$84fbc32b9717e45c$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(pub)) pub = new $84fbc32b9717e45c$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$84fbc32b9717e45c$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$84fbc32b9717e45c$require$Buffer.isBuffer(priv)) priv = new $84fbc32b9717e45c$require$Buffer(priv, enc);
    var _priv = new $7vYz3(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $84fbc32b9717e45c$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $84fbc32b9717e45c$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $84fbc32b9717e45c$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $84fbc32b9717e45c$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});

parcelRegister("e8Hvp", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a4b38f5366ff7954$export$512823e338ddb1b7; }, function (v) { return $a4b38f5366ff7954$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a4b38f5366ff7954$export$7efb24e2fddf99b9; }, function (v) { return $a4b38f5366ff7954$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3; }, function (v) { return $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a4b38f5366ff7954$export$b9d55ff329113abd; }, function (v) { return $a4b38f5366ff7954$export$b9d55ff329113abd = v; });
var $a4b38f5366ff7954$export$512823e338ddb1b7;
var $a4b38f5366ff7954$export$7efb24e2fddf99b9;
var $a4b38f5366ff7954$export$9d0e0c0c4a8d30f3;
var $a4b38f5366ff7954$export$b9d55ff329113abd;

$a4b38f5366ff7954$export$512823e338ddb1b7 = (parcelRequire("4XSWL"));

$a4b38f5366ff7954$export$7efb24e2fddf99b9 = (parcelRequire("JGlZv"));
$a4b38f5366ff7954$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a4b38f5366ff7954$export$512823e338ddb1b7(key, buf, true);
};
$a4b38f5366ff7954$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a4b38f5366ff7954$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("4XSWL", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $5rfiH = parcelRequire("5rfiH");

var $3FiLE = parcelRequire("3FiLE");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $d9Eed = parcelRequire("d9Eed");

var $hG1cM = parcelRequire("hG1cM");

var $6U9mG = parcelRequire("6U9mG");
var $39d74b68ba721c1e$require$Buffer = $6U9mG.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $39d74b68ba721c1e$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $39d74b68ba721c1e$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $7vYz3(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $hG1cM(paddedMsg, key);
    else return $d9Eed(paddedMsg, key);
};
function $39d74b68ba721c1e$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $3FiLE("sha1").update($39d74b68ba721c1e$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $5rfiH(hLen);
    var maskedDb = $65ECs($39d74b68ba721c1e$require$Buffer.concat([
        iHash,
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $lRbMS(seed, dblen));
    var maskedSeed = $65ECs(seed, $lRbMS(maskedDb, hLen));
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $39d74b68ba721c1e$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $39d74b68ba721c1e$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $39d74b68ba721c1e$var$nonZero(k - mLen - 3);
    return new $7vYz3($39d74b68ba721c1e$require$Buffer.concat([
        $39d74b68ba721c1e$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $39d74b68ba721c1e$require$Buffer.alloc(1),
        msg
    ], k));
}
function $39d74b68ba721c1e$var$nonZero(len) {
    var out = $39d74b68ba721c1e$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $5rfiH(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $5rfiH(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("lRbMS", function(module, exports) {

var $3FiLE = parcelRequire("3FiLE");

var $6U9mG = parcelRequire("6U9mG");
var $fe97b0ee2bc1dbf7$require$Buffer = $6U9mG.Buffer;
module.exports = function(seed, len) {
    var t = $fe97b0ee2bc1dbf7$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $fe97b0ee2bc1dbf7$var$i2ops(i++);
        t = $fe97b0ee2bc1dbf7$require$Buffer.concat([
            t,
            $3FiLE("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $fe97b0ee2bc1dbf7$var$i2ops(c) {
    var out = $fe97b0ee2bc1dbf7$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("65ECs", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("d9Eed", function(module, exports) {

var $7vYz3 = parcelRequire("7vYz3");

var $6U9mG = parcelRequire("6U9mG");
var $993b521f149aacc0$require$Buffer = $6U9mG.Buffer;
function $993b521f149aacc0$var$withPublic(paddedMsg, key) {
    return $993b521f149aacc0$require$Buffer.from(paddedMsg.toRed($7vYz3.mont(key.modulus)).redPow(new $7vYz3(key.publicExponent)).fromRed().toArray());
}
module.exports = $993b521f149aacc0$var$withPublic;

});


parcelRegister("JGlZv", function(module, exports) {

var $579Op = parcelRequire("579Op");

var $lRbMS = parcelRequire("lRbMS");

var $65ECs = parcelRequire("65ECs");

var $7vYz3 = parcelRequire("7vYz3");

var $hG1cM = parcelRequire("hG1cM");

var $3FiLE = parcelRequire("3FiLE");

var $d9Eed = parcelRequire("d9Eed");

var $6U9mG = parcelRequire("6U9mG");
var $08950ea5301bc0f1$require$Buffer = $6U9mG.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $579Op(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $7vYz3(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $d9Eed(new $7vYz3(enc), key);
    else msg = $hG1cM(enc, key);
    var zBuffer = $08950ea5301bc0f1$require$Buffer.alloc(k - msg.length);
    msg = $08950ea5301bc0f1$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $08950ea5301bc0f1$var$oaep(key, msg);
    else if (padding === 1) return $08950ea5301bc0f1$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $08950ea5301bc0f1$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $3FiLE("sha1").update($08950ea5301bc0f1$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $65ECs(maskedSeed, $lRbMS(maskedDb, hLen));
    var db = $65ECs(maskedDb, $lRbMS(seed, k - hLen - 1));
    if ($08950ea5301bc0f1$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $08950ea5301bc0f1$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $08950ea5301bc0f1$var$compare(a, b) {
    a = $08950ea5301bc0f1$require$Buffer.from(a);
    b = $08950ea5301bc0f1$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("6zHAr", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8; }, function (v) { return $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4c97d268940b2c08$export$2f7171e78e524d5e; }, function (v) { return $4c97d268940b2c08$export$2f7171e78e524d5e = v; });
var $4c97d268940b2c08$export$bb1abf2ce84fc7e8;
var $4c97d268940b2c08$export$2f7171e78e524d5e;

var $4TNnu = parcelRequire("4TNnu");
"use strict";
function $4c97d268940b2c08$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $6U9mG = parcelRequire("6U9mG");

var $5rfiH = parcelRequire("5rfiH");
var $4c97d268940b2c08$var$Buffer = $6U9mG.Buffer;
var $4c97d268940b2c08$var$kBufferMaxLength = $6U9mG.kMaxLength;
var $4c97d268940b2c08$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $4c97d268940b2c08$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $4c97d268940b2c08$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $4c97d268940b2c08$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $4c97d268940b2c08$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $4c97d268940b2c08$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $4c97d268940b2c08$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $4c97d268940b2c08$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($4c97d268940b2c08$var$crypto && $4c97d268940b2c08$var$crypto.getRandomValues || false) {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$randomFill;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$randomFillSync;
} else {
    $4c97d268940b2c08$export$bb1abf2ce84fc7e8 = $4c97d268940b2c08$var$oldBrowser;
    $4c97d268940b2c08$export$2f7171e78e524d5e = $4c97d268940b2c08$var$oldBrowser;
}
function $4c97d268940b2c08$var$randomFill(buf, offset, size, cb) {
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size, cb);
}
function $4c97d268940b2c08$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $4c97d268940b2c08$var$crypto.getRandomValues(uint);
    if (cb) {
        $4TNnu.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $5rfiH(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $5rfiH(size);
    bytes.copy(buf, offset);
    return buf;
}
function $4c97d268940b2c08$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$4c97d268940b2c08$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $4c97d268940b2c08$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $4c97d268940b2c08$var$assertSize(size, offset, buf.length);
    return $4c97d268940b2c08$var$actualFill(buf, offset, size);
}

});



parcelRegister("gn80J", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});

parcelRegister("9PUgX", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Check if typed arrays are supported
        if (typeof ArrayBuffer != "function") return;
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        // Reference original init
        var superInit = WordArray.init;
        // Augment WordArray.init to handle typed arrays
        var subInit = WordArray.init = function(typedArray) {
            // Convert buffers to uint8
            if (typedArray instanceof ArrayBuffer) typedArray = new Uint8Array(typedArray);
            // Convert other array views to uint8
            if (typedArray instanceof Int8Array || typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray || typedArray instanceof Int16Array || typedArray instanceof Uint16Array || typedArray instanceof Int32Array || typedArray instanceof Uint32Array || typedArray instanceof Float32Array || typedArray instanceof Float64Array) typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
            // Handle Uint8Array
            if (typedArray instanceof Uint8Array) {
                // Shortcut
                var typedArrayByteLength = typedArray.byteLength;
                // Extract bytes
                var words = [];
                for(var i = 0; i < typedArrayByteLength; i++)words[i >>> 2] |= typedArray[i] << 24 - i % 4 * 8;
                // Initialize this word array
                superInit.call(this, words, typedArrayByteLength);
            } else // Else call normal init
            superInit.apply(this, arguments);
        };
        subInit.prototype = WordArray;
    })();
    return CryptoJS.lib.WordArray;
});

});

parcelRegister("gu0dW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * UTF-16 BE encoding strategy.
	     */ var Utf16BE = C_enc.Utf16 = C_enc.Utf16BE = {
            /**
	         * Converts a word array to a UTF-16 BE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 BE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff;
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 BE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 BE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= utf16Str.charCodeAt(i) << 16 - i % 2 * 16;
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        /**
	     * UTF-16 LE encoding strategy.
	     */ C_enc.Utf16LE = {
            /**
	         * Converts a word array to a UTF-16 LE string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-16 LE string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var utf16Chars = [];
                for(var i = 0; i < sigBytes; i += 2){
                    var codePoint = swapEndian(words[i >>> 2] >>> 16 - i % 4 * 8 & 0xffff);
                    utf16Chars.push(String.fromCharCode(codePoint));
                }
                return utf16Chars.join("");
            },
            /**
	         * Converts a UTF-16 LE string to a word array.
	         *
	         * @param {string} utf16Str The UTF-16 LE string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
	         */ parse: function(utf16Str) {
                // Shortcut
                var utf16StrLength = utf16Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < utf16StrLength; i++)words[i >>> 1] |= swapEndian(utf16Str.charCodeAt(i) << 16 - i % 2 * 16);
                return WordArray.create(words, utf16StrLength * 2);
            }
        };
        function swapEndian(word) {
            return word << 8 & 0xff00ff00 | word >>> 8 & 0x00ff00ff;
        }
    })();
    return CryptoJS.enc.Utf16;
});

});

parcelRegister("500SS", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_enc = C.enc;
        /**
	     * Base64 encoding strategy.
	     */ var Base64 = C_enc.Base64 = {
            /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                var map = this._map;
                // Clamp excess bits
                wordArray.clamp();
                // Convert
                var base64Chars = [];
                for(var i = 0; i < sigBytes; i += 3){
                    var byte1 = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    var byte2 = words[i + 1 >>> 2] >>> 24 - (i + 1) % 4 * 8 & 0xff;
                    var byte3 = words[i + 2 >>> 2] >>> 24 - (i + 2) % 4 * 8 & 0xff;
                    var triplet = byte1 << 16 | byte2 << 8 | byte3;
                    for(var j = 0; j < 4 && i + j * 0.75 < sigBytes; j++)base64Chars.push(map.charAt(triplet >>> 6 * (3 - j) & 0x3f));
                }
                // Add padding
                var paddingChar = map.charAt(64);
                if (paddingChar) while(base64Chars.length % 4)base64Chars.push(paddingChar);
                return base64Chars.join("");
            },
            /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */ parse: function(base64Str) {
                // Shortcuts
                var base64StrLength = base64Str.length;
                var map = this._map;
                var reverseMap = this._reverseMap;
                if (!reverseMap) {
                    reverseMap = this._reverseMap = [];
                    for(var j = 0; j < map.length; j++)reverseMap[map.charCodeAt(j)] = j;
                }
                // Ignore padding
                var paddingChar = map.charAt(64);
                if (paddingChar) {
                    var paddingIndex = base64Str.indexOf(paddingChar);
                    if (paddingIndex !== -1) base64StrLength = paddingIndex;
                }
                // Convert
                return parseLoop(base64Str, base64StrLength, reverseMap);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
        };
        function parseLoop(base64Str, base64StrLength, reverseMap) {
            var words = [];
            var nBytes = 0;
            for(var i = 0; i < base64StrLength; i++)if (i % 4) {
                var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << i % 4 * 2;
                var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> 6 - i % 4 * 2;
                var bitsCombined = bits1 | bits2;
                words[nBytes >>> 2] |= bitsCombined << 24 - nBytes % 4 * 8;
                nBytes++;
            }
            return WordArray.create(words, nBytes);
        }
    })();
    return CryptoJS.enc.Base64;
});

});

parcelRegister("6oXxt", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var T = [];
        // Compute constants
        (function() {
            for(var i = 0; i < 64; i++)T[i] = Math1.abs(Math1.sin(i + 1)) * 0x100000000 | 0;
        })();
        /**
	     * MD5 hash algorithm.
	     */ var MD5 = C_algo.MD5 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcuts
                var H = this._hash.words;
                var M_offset_0 = M[offset + 0];
                var M_offset_1 = M[offset + 1];
                var M_offset_2 = M[offset + 2];
                var M_offset_3 = M[offset + 3];
                var M_offset_4 = M[offset + 4];
                var M_offset_5 = M[offset + 5];
                var M_offset_6 = M[offset + 6];
                var M_offset_7 = M[offset + 7];
                var M_offset_8 = M[offset + 8];
                var M_offset_9 = M[offset + 9];
                var M_offset_10 = M[offset + 10];
                var M_offset_11 = M[offset + 11];
                var M_offset_12 = M[offset + 12];
                var M_offset_13 = M[offset + 13];
                var M_offset_14 = M[offset + 14];
                var M_offset_15 = M[offset + 15];
                // Working varialbes
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                // Computation
                a = FF(a, b, c, d, M_offset_0, 7, T[0]);
                d = FF(d, a, b, c, M_offset_1, 12, T[1]);
                c = FF(c, d, a, b, M_offset_2, 17, T[2]);
                b = FF(b, c, d, a, M_offset_3, 22, T[3]);
                a = FF(a, b, c, d, M_offset_4, 7, T[4]);
                d = FF(d, a, b, c, M_offset_5, 12, T[5]);
                c = FF(c, d, a, b, M_offset_6, 17, T[6]);
                b = FF(b, c, d, a, M_offset_7, 22, T[7]);
                a = FF(a, b, c, d, M_offset_8, 7, T[8]);
                d = FF(d, a, b, c, M_offset_9, 12, T[9]);
                c = FF(c, d, a, b, M_offset_10, 17, T[10]);
                b = FF(b, c, d, a, M_offset_11, 22, T[11]);
                a = FF(a, b, c, d, M_offset_12, 7, T[12]);
                d = FF(d, a, b, c, M_offset_13, 12, T[13]);
                c = FF(c, d, a, b, M_offset_14, 17, T[14]);
                b = FF(b, c, d, a, M_offset_15, 22, T[15]);
                a = GG(a, b, c, d, M_offset_1, 5, T[16]);
                d = GG(d, a, b, c, M_offset_6, 9, T[17]);
                c = GG(c, d, a, b, M_offset_11, 14, T[18]);
                b = GG(b, c, d, a, M_offset_0, 20, T[19]);
                a = GG(a, b, c, d, M_offset_5, 5, T[20]);
                d = GG(d, a, b, c, M_offset_10, 9, T[21]);
                c = GG(c, d, a, b, M_offset_15, 14, T[22]);
                b = GG(b, c, d, a, M_offset_4, 20, T[23]);
                a = GG(a, b, c, d, M_offset_9, 5, T[24]);
                d = GG(d, a, b, c, M_offset_14, 9, T[25]);
                c = GG(c, d, a, b, M_offset_3, 14, T[26]);
                b = GG(b, c, d, a, M_offset_8, 20, T[27]);
                a = GG(a, b, c, d, M_offset_13, 5, T[28]);
                d = GG(d, a, b, c, M_offset_2, 9, T[29]);
                c = GG(c, d, a, b, M_offset_7, 14, T[30]);
                b = GG(b, c, d, a, M_offset_12, 20, T[31]);
                a = HH(a, b, c, d, M_offset_5, 4, T[32]);
                d = HH(d, a, b, c, M_offset_8, 11, T[33]);
                c = HH(c, d, a, b, M_offset_11, 16, T[34]);
                b = HH(b, c, d, a, M_offset_14, 23, T[35]);
                a = HH(a, b, c, d, M_offset_1, 4, T[36]);
                d = HH(d, a, b, c, M_offset_4, 11, T[37]);
                c = HH(c, d, a, b, M_offset_7, 16, T[38]);
                b = HH(b, c, d, a, M_offset_10, 23, T[39]);
                a = HH(a, b, c, d, M_offset_13, 4, T[40]);
                d = HH(d, a, b, c, M_offset_0, 11, T[41]);
                c = HH(c, d, a, b, M_offset_3, 16, T[42]);
                b = HH(b, c, d, a, M_offset_6, 23, T[43]);
                a = HH(a, b, c, d, M_offset_9, 4, T[44]);
                d = HH(d, a, b, c, M_offset_12, 11, T[45]);
                c = HH(c, d, a, b, M_offset_15, 16, T[46]);
                b = HH(b, c, d, a, M_offset_2, 23, T[47]);
                a = II(a, b, c, d, M_offset_0, 6, T[48]);
                d = II(d, a, b, c, M_offset_7, 10, T[49]);
                c = II(c, d, a, b, M_offset_14, 15, T[50]);
                b = II(b, c, d, a, M_offset_5, 21, T[51]);
                a = II(a, b, c, d, M_offset_12, 6, T[52]);
                d = II(d, a, b, c, M_offset_3, 10, T[53]);
                c = II(c, d, a, b, M_offset_10, 15, T[54]);
                b = II(b, c, d, a, M_offset_1, 21, T[55]);
                a = II(a, b, c, d, M_offset_8, 6, T[56]);
                d = II(d, a, b, c, M_offset_15, 10, T[57]);
                c = II(c, d, a, b, M_offset_6, 15, T[58]);
                b = II(b, c, d, a, M_offset_13, 21, T[59]);
                a = II(a, b, c, d, M_offset_4, 6, T[60]);
                d = II(d, a, b, c, M_offset_11, 10, T[61]);
                c = II(c, d, a, b, M_offset_2, 15, T[62]);
                b = II(b, c, d, a, M_offset_9, 21, T[63]);
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                var nBitsTotalH = Math1.floor(nBitsTotal / 0x100000000);
                var nBitsTotalL = nBitsTotal;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = (nBitsTotalH << 8 | nBitsTotalH >>> 24) & 0x00ff00ff | (nBitsTotalH << 24 | nBitsTotalH >>> 8) & 0xff00ff00;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotalL << 8 | nBitsTotalL >>> 24) & 0x00ff00ff | (nBitsTotalL << 24 | nBitsTotalL >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 4; i++){
                    // Shortcut
                    var H_i = H[i];
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function FF(a, b, c, d, x, s, t) {
            var n = a + (b & c | ~b & d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function GG(a, b, c, d, x, s, t) {
            var n = a + (b & d | c & ~d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function HH(a, b, c, d, x, s, t) {
            var n = a + (b ^ c ^ d) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        function II(a, b, c, d, x, s, t) {
            var n = a + (c ^ (b | ~d)) + x + t;
            return (n << s | n >>> 32 - s) + b;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.MD5('message');
	     *     var hash = CryptoJS.MD5(wordArray);
	     */ C.MD5 = Hasher._createHelper(MD5);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacMD5(message, key);
	     */ C.HmacMD5 = Hasher._createHmacHelper(MD5);
    })(Math);
    return CryptoJS.MD5;
});

});

parcelRegister("lqaMD", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Reusable object
        var W = [];
        /**
	     * SHA-1 hash algorithm.
	     */ var SHA1 = C_algo.SHA1 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0x67452301,
                    0xefcdab89,
                    0x98badcfe,
                    0x10325476,
                    0xc3d2e1f0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                // Computation
                for(var i = 0; i < 80; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var n = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
                        W[i] = n << 1 | n >>> 31;
                    }
                    var t = (a << 5 | a >>> 27) + e + W[i];
                    if (i < 20) t += (b & c | ~b & d) + 0x5a827999;
                    else if (i < 40) t += (b ^ c ^ d) + 0x6ed9eba1;
                    else if (i < 60) t += (b & c | b & d | c & d) - 0x70e44324;
                    else t += (b ^ c ^ d) - 0x359d3e2a;
                    e = d;
                    d = c;
                    c = b << 30 | b >>> 2;
                    b = a;
                    a = t;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA1('message');
	     *     var hash = CryptoJS.SHA1(wordArray);
	     */ C.SHA1 = Hasher._createHelper(SHA1);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA1(message, key);
	     */ C.HmacSHA1 = Hasher._createHmacHelper(SHA1);
    })();
    return CryptoJS.SHA1;
});

});

parcelRegister("hNROW", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("kgfdC", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("hNROW")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA256 = C_algo.SHA256;
        /**
	     * SHA-224 hash algorithm.
	     */ var SHA224 = C_algo.SHA224 = SHA256.extend({
            _doReset: function() {
                this._hash = new WordArray.init([
                    0xc1059ed8,
                    0x367cd507,
                    0x3070dd17,
                    0xf70e5939,
                    0xffc00b31,
                    0x68581511,
                    0x64f98fa7,
                    0xbefa4fa4
                ]);
            },
            _doFinalize: function() {
                var hash = SHA256._doFinalize.call(this);
                hash.sigBytes -= 4;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA224('message');
	     *     var hash = CryptoJS.SHA224(wordArray);
	     */ C.SHA224 = SHA256._createHelper(SHA224);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA224(message, key);
	     */ C.HmacSHA224 = SHA256._createHmacHelper(SHA224);
    })();
    return CryptoJS.SHA224;
});

});

parcelRegister("6PaKQ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        function X64Word_create() {
            return X64Word.create.apply(X64Word, arguments);
        }
        // Constants
        var K = [
            X64Word_create(0x428a2f98, 0xd728ae22),
            X64Word_create(0x71374491, 0x23ef65cd),
            X64Word_create(0xb5c0fbcf, 0xec4d3b2f),
            X64Word_create(0xe9b5dba5, 0x8189dbbc),
            X64Word_create(0x3956c25b, 0xf348b538),
            X64Word_create(0x59f111f1, 0xb605d019),
            X64Word_create(0x923f82a4, 0xaf194f9b),
            X64Word_create(0xab1c5ed5, 0xda6d8118),
            X64Word_create(0xd807aa98, 0xa3030242),
            X64Word_create(0x12835b01, 0x45706fbe),
            X64Word_create(0x243185be, 0x4ee4b28c),
            X64Word_create(0x550c7dc3, 0xd5ffb4e2),
            X64Word_create(0x72be5d74, 0xf27b896f),
            X64Word_create(0x80deb1fe, 0x3b1696b1),
            X64Word_create(0x9bdc06a7, 0x25c71235),
            X64Word_create(0xc19bf174, 0xcf692694),
            X64Word_create(0xe49b69c1, 0x9ef14ad2),
            X64Word_create(0xefbe4786, 0x384f25e3),
            X64Word_create(0x0fc19dc6, 0x8b8cd5b5),
            X64Word_create(0x240ca1cc, 0x77ac9c65),
            X64Word_create(0x2de92c6f, 0x592b0275),
            X64Word_create(0x4a7484aa, 0x6ea6e483),
            X64Word_create(0x5cb0a9dc, 0xbd41fbd4),
            X64Word_create(0x76f988da, 0x831153b5),
            X64Word_create(0x983e5152, 0xee66dfab),
            X64Word_create(0xa831c66d, 0x2db43210),
            X64Word_create(0xb00327c8, 0x98fb213f),
            X64Word_create(0xbf597fc7, 0xbeef0ee4),
            X64Word_create(0xc6e00bf3, 0x3da88fc2),
            X64Word_create(0xd5a79147, 0x930aa725),
            X64Word_create(0x06ca6351, 0xe003826f),
            X64Word_create(0x14292967, 0x0a0e6e70),
            X64Word_create(0x27b70a85, 0x46d22ffc),
            X64Word_create(0x2e1b2138, 0x5c26c926),
            X64Word_create(0x4d2c6dfc, 0x5ac42aed),
            X64Word_create(0x53380d13, 0x9d95b3df),
            X64Word_create(0x650a7354, 0x8baf63de),
            X64Word_create(0x766a0abb, 0x3c77b2a8),
            X64Word_create(0x81c2c92e, 0x47edaee6),
            X64Word_create(0x92722c85, 0x1482353b),
            X64Word_create(0xa2bfe8a1, 0x4cf10364),
            X64Word_create(0xa81a664b, 0xbc423001),
            X64Word_create(0xc24b8b70, 0xd0f89791),
            X64Word_create(0xc76c51a3, 0x0654be30),
            X64Word_create(0xd192e819, 0xd6ef5218),
            X64Word_create(0xd6990624, 0x5565a910),
            X64Word_create(0xf40e3585, 0x5771202a),
            X64Word_create(0x106aa070, 0x32bbd1b8),
            X64Word_create(0x19a4c116, 0xb8d2d0c8),
            X64Word_create(0x1e376c08, 0x5141ab53),
            X64Word_create(0x2748774c, 0xdf8eeb99),
            X64Word_create(0x34b0bcb5, 0xe19b48a8),
            X64Word_create(0x391c0cb3, 0xc5c95a63),
            X64Word_create(0x4ed8aa4a, 0xe3418acb),
            X64Word_create(0x5b9cca4f, 0x7763e373),
            X64Word_create(0x682e6ff3, 0xd6b2b8a3),
            X64Word_create(0x748f82ee, 0x5defb2fc),
            X64Word_create(0x78a5636f, 0x43172f60),
            X64Word_create(0x84c87814, 0xa1f0ab72),
            X64Word_create(0x8cc70208, 0x1a6439ec),
            X64Word_create(0x90befffa, 0x23631e28),
            X64Word_create(0xa4506ceb, 0xde82bde9),
            X64Word_create(0xbef9a3f7, 0xb2c67915),
            X64Word_create(0xc67178f2, 0xe372532b),
            X64Word_create(0xca273ece, 0xea26619c),
            X64Word_create(0xd186b8c7, 0x21c0c207),
            X64Word_create(0xeada7dd6, 0xcde0eb1e),
            X64Word_create(0xf57d4f7f, 0xee6ed178),
            X64Word_create(0x06f067aa, 0x72176fba),
            X64Word_create(0x0a637dc5, 0xa2c898a6),
            X64Word_create(0x113f9804, 0xbef90dae),
            X64Word_create(0x1b710b35, 0x131c471b),
            X64Word_create(0x28db77f5, 0x23047d84),
            X64Word_create(0x32caab7b, 0x40c72493),
            X64Word_create(0x3c9ebe0a, 0x15c9bebc),
            X64Word_create(0x431d67c4, 0x9c100d4c),
            X64Word_create(0x4cc5d4be, 0xcb3e42b6),
            X64Word_create(0x597f299c, 0xfc657e2a),
            X64Word_create(0x5fcb6fab, 0x3ad6faec),
            X64Word_create(0x6c44198c, 0x4a475817)
        ];
        // Reusable objects
        var W = [];
        (function() {
            for(var i = 0; i < 80; i++)W[i] = X64Word_create();
        })();
        /**
	     * SHA-512 hash algorithm.
	     */ var SHA512 = C_algo.SHA512 = Hasher.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0x6a09e667, 0xf3bcc908),
                    new X64Word.init(0xbb67ae85, 0x84caa73b),
                    new X64Word.init(0x3c6ef372, 0xfe94f82b),
                    new X64Word.init(0xa54ff53a, 0x5f1d36f1),
                    new X64Word.init(0x510e527f, 0xade682d1),
                    new X64Word.init(0x9b05688c, 0x2b3e6c1f),
                    new X64Word.init(0x1f83d9ab, 0xfb41bd6b),
                    new X64Word.init(0x5be0cd19, 0x137e2179)
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var H = this._hash.words;
                var H0 = H[0];
                var H1 = H[1];
                var H2 = H[2];
                var H3 = H[3];
                var H4 = H[4];
                var H5 = H[5];
                var H6 = H[6];
                var H7 = H[7];
                var H0h = H0.high;
                var H0l = H0.low;
                var H1h = H1.high;
                var H1l = H1.low;
                var H2h = H2.high;
                var H2l = H2.low;
                var H3h = H3.high;
                var H3l = H3.low;
                var H4h = H4.high;
                var H4l = H4.low;
                var H5h = H5.high;
                var H5l = H5.low;
                var H6h = H6.high;
                var H6l = H6.low;
                var H7h = H7.high;
                var H7l = H7.low;
                // Working variables
                var ah = H0h;
                var al = H0l;
                var bh = H1h;
                var bl = H1l;
                var ch = H2h;
                var cl = H2l;
                var dh = H3h;
                var dl = H3l;
                var eh = H4h;
                var el = H4l;
                var fh = H5h;
                var fl = H5l;
                var gh = H6h;
                var gl = H6l;
                var hh = H7h;
                var hl = H7l;
                // Rounds
                for(var i = 0; i < 80; i++){
                    var Wil;
                    var Wih;
                    // Shortcut
                    var Wi = W[i];
                    // Extend message
                    if (i < 16) {
                        Wih = Wi.high = M[offset + i * 2] | 0;
                        Wil = Wi.low = M[offset + i * 2 + 1] | 0;
                    } else {
                        // Gamma0
                        var gamma0x = W[i - 15];
                        var gamma0xh = gamma0x.high;
                        var gamma0xl = gamma0x.low;
                        var gamma0h = (gamma0xh >>> 1 | gamma0xl << 31) ^ (gamma0xh >>> 8 | gamma0xl << 24) ^ gamma0xh >>> 7;
                        var gamma0l = (gamma0xl >>> 1 | gamma0xh << 31) ^ (gamma0xl >>> 8 | gamma0xh << 24) ^ (gamma0xl >>> 7 | gamma0xh << 25);
                        // Gamma1
                        var gamma1x = W[i - 2];
                        var gamma1xh = gamma1x.high;
                        var gamma1xl = gamma1x.low;
                        var gamma1h = (gamma1xh >>> 19 | gamma1xl << 13) ^ (gamma1xh << 3 | gamma1xl >>> 29) ^ gamma1xh >>> 6;
                        var gamma1l = (gamma1xl >>> 19 | gamma1xh << 13) ^ (gamma1xl << 3 | gamma1xh >>> 29) ^ (gamma1xl >>> 6 | gamma1xh << 26);
                        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
                        var Wi7 = W[i - 7];
                        var Wi7h = Wi7.high;
                        var Wi7l = Wi7.low;
                        var Wi16 = W[i - 16];
                        var Wi16h = Wi16.high;
                        var Wi16l = Wi16.low;
                        Wil = gamma0l + Wi7l;
                        Wih = gamma0h + Wi7h + (Wil >>> 0 < gamma0l >>> 0 ? 1 : 0);
                        Wil = Wil + gamma1l;
                        Wih = Wih + gamma1h + (Wil >>> 0 < gamma1l >>> 0 ? 1 : 0);
                        Wil = Wil + Wi16l;
                        Wih = Wih + Wi16h + (Wil >>> 0 < Wi16l >>> 0 ? 1 : 0);
                        Wi.high = Wih;
                        Wi.low = Wil;
                    }
                    var chh = eh & fh ^ ~eh & gh;
                    var chl = el & fl ^ ~el & gl;
                    var majh = ah & bh ^ ah & ch ^ bh & ch;
                    var majl = al & bl ^ al & cl ^ bl & cl;
                    var sigma0h = (ah >>> 28 | al << 4) ^ (ah << 30 | al >>> 2) ^ (ah << 25 | al >>> 7);
                    var sigma0l = (al >>> 28 | ah << 4) ^ (al << 30 | ah >>> 2) ^ (al << 25 | ah >>> 7);
                    var sigma1h = (eh >>> 14 | el << 18) ^ (eh >>> 18 | el << 14) ^ (eh << 23 | el >>> 9);
                    var sigma1l = (el >>> 14 | eh << 18) ^ (el >>> 18 | eh << 14) ^ (el << 23 | eh >>> 9);
                    // t1 = h + sigma1 + ch + K[i] + W[i]
                    var Ki = K[i];
                    var Kih = Ki.high;
                    var Kil = Ki.low;
                    var t1l = hl + sigma1l;
                    var t1h = hh + sigma1h + (t1l >>> 0 < hl >>> 0 ? 1 : 0);
                    var t1l = t1l + chl;
                    var t1h = t1h + chh + (t1l >>> 0 < chl >>> 0 ? 1 : 0);
                    var t1l = t1l + Kil;
                    var t1h = t1h + Kih + (t1l >>> 0 < Kil >>> 0 ? 1 : 0);
                    var t1l = t1l + Wil;
                    var t1h = t1h + Wih + (t1l >>> 0 < Wil >>> 0 ? 1 : 0);
                    // t2 = sigma0 + maj
                    var t2l = sigma0l + majl;
                    var t2h = sigma0h + majh + (t2l >>> 0 < sigma0l >>> 0 ? 1 : 0);
                    // Update working variables
                    hh = gh;
                    hl = gl;
                    gh = fh;
                    gl = fl;
                    fh = eh;
                    fl = el;
                    el = dl + t1l | 0;
                    eh = dh + t1h + (el >>> 0 < dl >>> 0 ? 1 : 0) | 0;
                    dh = ch;
                    dl = cl;
                    ch = bh;
                    cl = bl;
                    bh = ah;
                    bl = al;
                    al = t1l + t2l | 0;
                    ah = t1h + t2h + (al >>> 0 < t1l >>> 0 ? 1 : 0) | 0;
                }
                // Intermediate hash value
                H0l = H0.low = H0l + al;
                H0.high = H0h + ah + (H0l >>> 0 < al >>> 0 ? 1 : 0);
                H1l = H1.low = H1l + bl;
                H1.high = H1h + bh + (H1l >>> 0 < bl >>> 0 ? 1 : 0);
                H2l = H2.low = H2l + cl;
                H2.high = H2h + ch + (H2l >>> 0 < cl >>> 0 ? 1 : 0);
                H3l = H3.low = H3l + dl;
                H3.high = H3h + dh + (H3l >>> 0 < dl >>> 0 ? 1 : 0);
                H4l = H4.low = H4l + el;
                H4.high = H4h + eh + (H4l >>> 0 < el >>> 0 ? 1 : 0);
                H5l = H5.low = H5l + fl;
                H5.high = H5h + fh + (H5l >>> 0 < fl >>> 0 ? 1 : 0);
                H6l = H6.low = H6l + gl;
                H6.high = H6h + gh + (H6l >>> 0 < gl >>> 0 ? 1 : 0);
                H7l = H7.low = H7l + hl;
                H7.high = H7h + hh + (H7l >>> 0 < hl >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 30] = Math.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 128 >>> 10 << 5) + 31] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Convert hash to 32-bit word array before returning
                var hash = this._hash.toX32();
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            },
            blockSize: 32
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA512('message');
	     *     var hash = CryptoJS.SHA512(wordArray);
	     */ C.SHA512 = Hasher._createHelper(SHA512);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA512(message, key);
	     */ C.HmacSHA512 = Hasher._createHmacHelper(SHA512);
    })();
    return CryptoJS.SHA512;
});

});

parcelRegister("bZEkw", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")), (parcelRequire("6PaKQ")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var X64WordArray = C_x64.WordArray;
        var C_algo = C.algo;
        var SHA512 = C_algo.SHA512;
        /**
	     * SHA-384 hash algorithm.
	     */ var SHA384 = C_algo.SHA384 = SHA512.extend({
            _doReset: function() {
                this._hash = new X64WordArray.init([
                    new X64Word.init(0xcbbb9d5d, 0xc1059ed8),
                    new X64Word.init(0x629a292a, 0x367cd507),
                    new X64Word.init(0x9159015a, 0x3070dd17),
                    new X64Word.init(0x152fecd8, 0xf70e5939),
                    new X64Word.init(0x67332667, 0xffc00b31),
                    new X64Word.init(0x8eb44a87, 0x68581511),
                    new X64Word.init(0xdb0c2e0d, 0x64f98fa7),
                    new X64Word.init(0x47b5481d, 0xbefa4fa4)
                ]);
            },
            _doFinalize: function() {
                var hash = SHA512._doFinalize.call(this);
                hash.sigBytes -= 16;
                return hash;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA384('message');
	     *     var hash = CryptoJS.SHA384(wordArray);
	     */ C.SHA384 = SHA512._createHelper(SHA384);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA384(message, key);
	     */ C.HmacSHA384 = SHA512._createHmacHelper(SHA384);
    })();
    return CryptoJS.SHA384;
});

});

parcelRegister("AFosI", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("gn80J")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        var tMsw;
                        var tLsw;
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});

parcelRegister("bIitx", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("7ft6W", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var C_algo = C.algo;
        /**
	     * HMAC algorithm.
	     */ var HMAC = C_algo.HMAC = Base.extend({
            /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */ init: function(hasher, key) {
                // Init hasher
                hasher = this._hasher = new hasher.init();
                // Convert string to WordArray, else assume WordArray already
                if (typeof key == "string") key = Utf8.parse(key);
                // Shortcuts
                var hasherBlockSize = hasher.blockSize;
                var hasherBlockSizeBytes = hasherBlockSize * 4;
                // Allow arbitrary length keys
                if (key.sigBytes > hasherBlockSizeBytes) key = hasher.finalize(key);
                // Clamp excess bits
                key.clamp();
                // Clone key for inner and outer pads
                var oKey = this._oKey = key.clone();
                var iKey = this._iKey = key.clone();
                // Shortcuts
                var oKeyWords = oKey.words;
                var iKeyWords = iKey.words;
                // XOR keys with pad constants
                for(var i = 0; i < hasherBlockSize; i++){
                    oKeyWords[i] ^= 0x5c5c5c5c;
                    iKeyWords[i] ^= 0x36363636;
                }
                oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */ reset: function() {
                // Shortcut
                var hasher = this._hasher;
                // Reset
                hasher.reset();
                hasher.update(this._iKey);
            },
            /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */ update: function(messageUpdate) {
                this._hasher.update(messageUpdate);
                // Chainable
                return this;
            },
            /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Shortcut
                var hasher = this._hasher;
                // Compute HMAC
                var innerHash = hasher.finalize(messageUpdate);
                hasher.reset();
                var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));
                return hmac;
            }
        });
    })();
});

});

parcelRegister("as0jN", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var SHA1 = C_algo.SHA1;
        var HMAC = C_algo.HMAC;
        /**
	     * Password-Based Key Derivation Function 2 algorithm.
	     */ var PBKDF2 = C_algo.PBKDF2 = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hasher to use. Default: SHA1
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: SHA1,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.PBKDF2.create();
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Computes the Password-Based Key Derivation Function 2.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                // Shortcut
                var cfg = this.cfg;
                // Init HMAC
                var hmac = HMAC.create(cfg.hasher, password);
                // Initial values
                var derivedKey = WordArray.create();
                var blockIndex = WordArray.create([
                    0x00000001
                ]);
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var blockIndexWords = blockIndex.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    var block = hmac.update(salt).finalize(blockIndex);
                    hmac.reset();
                    // Shortcuts
                    var blockWords = block.words;
                    var blockWordsLength = blockWords.length;
                    // Iterations
                    var intermediate = block;
                    for(var i = 1; i < iterations; i++){
                        intermediate = hmac.finalize(intermediate);
                        hmac.reset();
                        // Shortcut
                        var intermediateWords = intermediate.words;
                        // XOR intermediate with block
                        for(var j = 0; j < blockWordsLength; j++)blockWords[j] ^= intermediateWords[j];
                    }
                    derivedKey.concat(block);
                    blockIndexWords[0]++;
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Computes the Password-Based Key Derivation Function 2.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.PBKDF2(password, salt);
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.PBKDF2(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.PBKDF2 = function(password, salt, cfg) {
            return PBKDF2.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.PBKDF2;
});

});

parcelRegister("ioEPr", function(module, exports) {



(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("lqaMD")), (parcelRequire("7ft6W")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var C_algo = C.algo;
        var MD5 = C_algo.MD5;
        /**
	     * This key derivation function is meant to conform with EVP_BytesToKey.
	     * www.openssl.org/docs/crypto/EVP_BytesToKey.html
	     */ var EvpKDF = C_algo.EvpKDF = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
	         * @property {Hasher} hasher The hash algorithm to use. Default: MD5
	         * @property {number} iterations The number of iterations to perform. Default: 1
	         */ cfg: Base.extend({
                keySize: 4,
                hasher: MD5,
                iterations: 1
            }),
            /**
	         * Initializes a newly created key derivation function.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for the derivation.
	         *
	         * @example
	         *
	         *     var kdf = CryptoJS.algo.EvpKDF.create();
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
	         *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
	         */ init: function(cfg) {
                this.cfg = this.cfg.extend(cfg);
            },
            /**
	         * Derives a key from a password.
	         *
	         * @param {WordArray|string} password The password.
	         * @param {WordArray|string} salt A salt.
	         *
	         * @return {WordArray} The derived key.
	         *
	         * @example
	         *
	         *     var key = kdf.compute(password, salt);
	         */ compute: function(password, salt) {
                var block;
                // Shortcut
                var cfg = this.cfg;
                // Init hasher
                var hasher = cfg.hasher.create();
                // Initial values
                var derivedKey = WordArray.create();
                // Shortcuts
                var derivedKeyWords = derivedKey.words;
                var keySize = cfg.keySize;
                var iterations = cfg.iterations;
                // Generate key
                while(derivedKeyWords.length < keySize){
                    if (block) hasher.update(block);
                    block = hasher.update(password).finalize(salt);
                    hasher.reset();
                    // Iterations
                    for(var i = 1; i < iterations; i++){
                        block = hasher.finalize(block);
                        hasher.reset();
                    }
                    derivedKey.concat(block);
                }
                derivedKey.sigBytes = keySize * 4;
                return derivedKey;
            }
        });
        /**
	     * Derives a key from a password.
	     *
	     * @param {WordArray|string} password The password.
	     * @param {WordArray|string} salt A salt.
	     * @param {Object} cfg (Optional) The configuration options to use for this computation.
	     *
	     * @return {WordArray} The derived key.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var key = CryptoJS.EvpKDF(password, salt);
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8 });
	     *     var key = CryptoJS.EvpKDF(password, salt, { keySize: 8, iterations: 1000 });
	     */ C.EvpKDF = function(password, salt, cfg) {
            return EvpKDF.create(cfg).compute(password, salt);
        };
    })();
    return CryptoJS.EvpKDF;
});

});

parcelRegister("fctwD", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("ioEPr")));
})(this, function(CryptoJS) {
    /**
	 * Cipher core components.
	 */ CryptoJS.lib.Cipher || function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var WordArray = C_lib.WordArray;
        var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm;
        var C_enc = C.enc;
        var Utf8 = C_enc.Utf8;
        var Base64 = C_enc.Base64;
        var C_algo = C.algo;
        var EvpKDF = C_algo.EvpKDF;
        /**
	     * Abstract base cipher template.
	     *
	     * @property {number} keySize This cipher's key size. Default: 4 (128 bits)
	     * @property {number} ivSize This cipher's IV size. Default: 4 (128 bits)
	     * @property {number} _ENC_XFORM_MODE A constant representing encryption mode.
	     * @property {number} _DEC_XFORM_MODE A constant representing decryption mode.
	     */ var Cipher = C_lib.Cipher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         *
	         * @property {WordArray} iv The IV to use for this operation.
	         */ cfg: Base.extend(),
            /**
	         * Creates this cipher in encryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
	         */ createEncryptor: function(key, cfg) {
                return this.create(this._ENC_XFORM_MODE, key, cfg);
            },
            /**
	         * Creates this cipher in decryption mode.
	         *
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {Cipher} A cipher instance.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
	         */ createDecryptor: function(key, cfg) {
                return this.create(this._DEC_XFORM_MODE, key, cfg);
            },
            /**
	         * Initializes a newly created cipher.
	         *
	         * @param {number} xformMode Either the encryption or decryption transormation mode constant.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @example
	         *
	         *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
	         */ init: function(xformMode, key, cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Store transform mode and key
                this._xformMode = xformMode;
                this._key = key;
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this cipher to its initial state.
	         *
	         * @example
	         *
	         *     cipher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-cipher logic
                this._doReset();
            },
            /**
	         * Adds data to be encrypted or decrypted.
	         *
	         * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.process('data');
	         *     var encrypted = cipher.process(wordArray);
	         */ process: function(dataUpdate) {
                // Append
                this._append(dataUpdate);
                // Process available blocks
                return this._process();
            },
            /**
	         * Finalizes the encryption or decryption process.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
	         *
	         * @return {WordArray} The data after final processing.
	         *
	         * @example
	         *
	         *     var encrypted = cipher.finalize();
	         *     var encrypted = cipher.finalize('data');
	         *     var encrypted = cipher.finalize(wordArray);
	         */ finalize: function(dataUpdate) {
                // Final data update
                if (dataUpdate) this._append(dataUpdate);
                // Perform concrete-cipher logic
                var finalProcessedData = this._doFinalize();
                return finalProcessedData;
            },
            keySize: 4,
            ivSize: 4,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
	         * Creates shortcut functions to a cipher's object interface.
	         *
	         * @param {Cipher} cipher The cipher to create a helper for.
	         *
	         * @return {Object} An object with encrypt and decrypt shortcut functions.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
	         */ _createHelper: function() {
                function selectCipherStrategy(key) {
                    if (typeof key == "string") return PasswordBasedCipher;
                    else return SerializableCipher;
                }
                return function(cipher) {
                    return {
                        encrypt: function(message, key, cfg) {
                            return selectCipherStrategy(key).encrypt(cipher, message, key, cfg);
                        },
                        decrypt: function(ciphertext, key, cfg) {
                            return selectCipherStrategy(key).decrypt(cipher, ciphertext, key, cfg);
                        }
                    };
                };
            }()
        });
        /**
	     * Abstract base stream cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 1 (32 bits)
	     */ var StreamCipher = C_lib.StreamCipher = Cipher.extend({
            _doFinalize: function() {
                // Process partial blocks
                var finalProcessedBlocks = this._process(true);
                return finalProcessedBlocks;
            },
            blockSize: 1
        });
        /**
	     * Mode namespace.
	     */ var C_mode = C.mode = {};
        /**
	     * Abstract base block cipher mode template.
	     */ var BlockCipherMode = C_lib.BlockCipherMode = Base.extend({
            /**
	         * Creates this mode for encryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
	         */ createEncryptor: function(cipher, iv) {
                return this.Encryptor.create(cipher, iv);
            },
            /**
	         * Creates this mode for decryption.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
	         */ createDecryptor: function(cipher, iv) {
                return this.Decryptor.create(cipher, iv);
            },
            /**
	         * Initializes a newly created mode.
	         *
	         * @param {Cipher} cipher A block cipher instance.
	         * @param {Array} iv The IV words.
	         *
	         * @example
	         *
	         *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
	         */ init: function(cipher, iv) {
                this._cipher = cipher;
                this._iv = iv;
            }
        });
        /**
	     * Cipher Block Chaining mode.
	     */ var CBC = C_mode.CBC = function() {
            /**
	         * Abstract base CBC mode.
	         */ var CBC = BlockCipherMode.extend();
            /**
	         * CBC encryptor.
	         */ CBC.Encryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // XOR and encrypt
                    xorBlock.call(this, words, offset, blockSize);
                    cipher.encryptBlock(words, offset);
                    // Remember this block to use with next block
                    this._prevBlock = words.slice(offset, offset + blockSize);
                }
            });
            /**
	         * CBC decryptor.
	         */ CBC.Decryptor = CBC.extend({
                /**
	             * Processes the data block at offset.
	             *
	             * @param {Array} words The data words to operate on.
	             * @param {number} offset The offset where the block starts.
	             *
	             * @example
	             *
	             *     mode.processBlock(data.words, offset);
	             */ processBlock: function(words, offset) {
                    // Shortcuts
                    var cipher = this._cipher;
                    var blockSize = cipher.blockSize;
                    // Remember this block to use with next block
                    var thisBlock = words.slice(offset, offset + blockSize);
                    // Decrypt and XOR
                    cipher.decryptBlock(words, offset);
                    xorBlock.call(this, words, offset, blockSize);
                    // This block becomes the previous block
                    this._prevBlock = thisBlock;
                }
            });
            function xorBlock(words, offset, blockSize) {
                var block;
                // Shortcut
                var iv = this._iv;
                // Choose mixing block
                if (iv) {
                    block = iv;
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                } else block = this._prevBlock;
                // XOR blocks
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= block[i];
            }
            return CBC;
        }();
        /**
	     * Padding namespace.
	     */ var C_pad = C.pad = {};
        /**
	     * PKCS #5/7 padding strategy.
	     */ var Pkcs7 = C_pad.Pkcs7 = {
            /**
	         * Pads data using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to pad.
	         * @param {number} blockSize The multiple that the data should be padded to.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
	         */ pad: function(data, blockSize) {
                // Shortcut
                var blockSizeBytes = blockSize * 4;
                // Count padding bytes
                var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
                // Create padding word
                var paddingWord = nPaddingBytes << 24 | nPaddingBytes << 16 | nPaddingBytes << 8 | nPaddingBytes;
                // Create padding
                var paddingWords = [];
                for(var i = 0; i < nPaddingBytes; i += 4)paddingWords.push(paddingWord);
                var padding = WordArray.create(paddingWords, nPaddingBytes);
                // Add padding
                data.concat(padding);
            },
            /**
	         * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
	         *
	         * @param {WordArray} data The data to unpad.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     CryptoJS.pad.Pkcs7.unpad(wordArray);
	         */ unpad: function(data) {
                // Get number of padding bytes from last byte
                var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
                // Remove padding
                data.sigBytes -= nPaddingBytes;
            }
        };
        /**
	     * Abstract base block cipher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this cipher operates on. Default: 4 (128 bits)
	     */ var BlockCipher = C_lib.BlockCipher = Cipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Mode} mode The block mode to use. Default: CBC
	         * @property {Padding} padding The padding strategy to use. Default: Pkcs7
	         */ cfg: Cipher.cfg.extend({
                mode: CBC,
                padding: Pkcs7
            }),
            reset: function() {
                var modeCreator;
                // Reset cipher
                Cipher.reset.call(this);
                // Shortcuts
                var cfg = this.cfg;
                var iv = cfg.iv;
                var mode = cfg.mode;
                // Reset block mode
                if (this._xformMode == this._ENC_XFORM_MODE) modeCreator = mode.createEncryptor;
                else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    modeCreator = mode.createDecryptor;
                    // Keep at least one block in the buffer for unpadding
                    this._minBufferSize = 1;
                }
                if (this._mode && this._mode.__creator == modeCreator) this._mode.init(this, iv && iv.words);
                else {
                    this._mode = modeCreator.call(mode, this, iv && iv.words);
                    this._mode.__creator = modeCreator;
                }
            },
            _doProcessBlock: function(words, offset) {
                this._mode.processBlock(words, offset);
            },
            _doFinalize: function() {
                var finalProcessedBlocks;
                // Shortcut
                var padding = this.cfg.padding;
                // Finalize
                if (this._xformMode == this._ENC_XFORM_MODE) {
                    // Pad data
                    padding.pad(this._data, this.blockSize);
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                } else /* if (this._xformMode == this._DEC_XFORM_MODE) */ {
                    // Process final blocks
                    finalProcessedBlocks = this._process(true);
                    // Unpad data
                    padding.unpad(finalProcessedBlocks);
                }
                return finalProcessedBlocks;
            },
            blockSize: 4
        });
        /**
	     * A collection of cipher parameters.
	     *
	     * @property {WordArray} ciphertext The raw ciphertext.
	     * @property {WordArray} key The key to this ciphertext.
	     * @property {WordArray} iv The IV used in the ciphering operation.
	     * @property {WordArray} salt The salt used with a key derivation function.
	     * @property {Cipher} algorithm The cipher algorithm.
	     * @property {Mode} mode The block mode used in the ciphering operation.
	     * @property {Padding} padding The padding scheme used in the ciphering operation.
	     * @property {number} blockSize The block size of the cipher.
	     * @property {Format} formatter The default formatting strategy to convert this cipher params object to a string.
	     */ var CipherParams = C_lib.CipherParams = Base.extend({
            /**
	         * Initializes a newly created cipher params object.
	         *
	         * @param {Object} cipherParams An object with any of the possible cipher parameters.
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.lib.CipherParams.create({
	         *         ciphertext: ciphertextWordArray,
	         *         key: keyWordArray,
	         *         iv: ivWordArray,
	         *         salt: saltWordArray,
	         *         algorithm: CryptoJS.algo.AES,
	         *         mode: CryptoJS.mode.CBC,
	         *         padding: CryptoJS.pad.PKCS7,
	         *         blockSize: 4,
	         *         formatter: CryptoJS.format.OpenSSL
	         *     });
	         */ init: function(cipherParams) {
                this.mixIn(cipherParams);
            },
            /**
	         * Converts this cipher params object to a string.
	         *
	         * @param {Format} formatter (Optional) The formatting strategy to use.
	         *
	         * @return {string} The stringified cipher params.
	         *
	         * @throws Error If neither the formatter nor the default formatter is set.
	         *
	         * @example
	         *
	         *     var string = cipherParams + '';
	         *     var string = cipherParams.toString();
	         *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
	         */ toString: function(formatter) {
                return (formatter || this.formatter).stringify(this);
            }
        });
        /**
	     * Format namespace.
	     */ var C_format = C.format = {};
        /**
	     * OpenSSL formatting strategy.
	     */ var OpenSSLFormatter = C_format.OpenSSL = {
            /**
	         * Converts a cipher params object to an OpenSSL-compatible string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The OpenSSL-compatible string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                var wordArray;
                // Shortcuts
                var ciphertext = cipherParams.ciphertext;
                var salt = cipherParams.salt;
                // Format
                if (salt) wordArray = WordArray.create([
                    0x53616c74,
                    0x65645f5f
                ]).concat(salt).concat(ciphertext);
                else wordArray = ciphertext;
                return wordArray.toString(Base64);
            },
            /**
	         * Converts an OpenSSL-compatible string to a cipher params object.
	         *
	         * @param {string} openSSLStr The OpenSSL-compatible string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
	         */ parse: function(openSSLStr) {
                var salt;
                // Parse base64
                var ciphertext = Base64.parse(openSSLStr);
                // Shortcut
                var ciphertextWords = ciphertext.words;
                // Test for salt
                if (ciphertextWords[0] == 0x53616c74 && ciphertextWords[1] == 0x65645f5f) {
                    // Extract salt
                    salt = WordArray.create(ciphertextWords.slice(2, 4));
                    // Remove salt from ciphertext
                    ciphertextWords.splice(0, 4);
                    ciphertext.sigBytes -= 16;
                }
                return CipherParams.create({
                    ciphertext: ciphertext,
                    salt: salt
                });
            }
        };
        /**
	     * A cipher wrapper that returns ciphertext as a serializable cipher params object.
	     */ var SerializableCipher = C_lib.SerializableCipher = Base.extend({
            /**
	         * Configuration options.
	         *
	         * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
	         */ cfg: Base.extend({
                format: OpenSSLFormatter
            }),
            /**
	         * Encrypts a message.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Encrypt
                var encryptor = cipher.createEncryptor(key, cfg);
                var ciphertext = encryptor.finalize(message);
                // Shortcut
                var cipherCfg = encryptor.cfg;
                // Create and return serializable cipher params
                return CipherParams.create({
                    ciphertext: ciphertext,
                    key: key,
                    iv: cipherCfg.iv,
                    algorithm: cipher,
                    mode: cipherCfg.mode,
                    padding: cipherCfg.padding,
                    blockSize: cipher.blockSize,
                    formatter: cfg.format
                });
            },
            /**
	         * Decrypts serialized ciphertext.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {WordArray} key The key.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, key, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Decrypt
                var plaintext = cipher.createDecryptor(key, cfg).finalize(ciphertext.ciphertext);
                return plaintext;
            },
            /**
	         * Converts serialized ciphertext to CipherParams,
	         * else assumed CipherParams already and returns ciphertext unchanged.
	         *
	         * @param {CipherParams|string} ciphertext The ciphertext.
	         * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
	         *
	         * @return {CipherParams} The unserialized ciphertext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
	         */ _parse: function(ciphertext, format) {
                if (typeof ciphertext == "string") return format.parse(ciphertext, this);
                else return ciphertext;
            }
        });
        /**
	     * Key derivation function namespace.
	     */ var C_kdf = C.kdf = {};
        /**
	     * OpenSSL key derivation function.
	     */ var OpenSSLKdf = C_kdf.OpenSSL = {
            /**
	         * Derives a key and IV from a password.
	         *
	         * @param {string} password The password to derive from.
	         * @param {number} keySize The size in words of the key to generate.
	         * @param {number} ivSize The size in words of the IV to generate.
	         * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
	         *
	         * @return {CipherParams} A cipher params object with the key, IV, and salt.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
	         *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
	         */ execute: function(password, keySize, ivSize, salt) {
                // Generate random salt
                if (!salt) salt = WordArray.random(8);
                // Derive key and IV
                var key = EvpKDF.create({
                    keySize: keySize + ivSize
                }).compute(password, salt);
                // Separate key and IV
                var iv = WordArray.create(key.words.slice(keySize), ivSize * 4);
                key.sigBytes = keySize * 4;
                // Return params
                return CipherParams.create({
                    key: key,
                    iv: iv,
                    salt: salt
                });
            }
        };
        /**
	     * A serializable cipher wrapper that derives the key from a password,
	     * and returns ciphertext as a serializable cipher params object.
	     */ var PasswordBasedCipher = C_lib.PasswordBasedCipher = SerializableCipher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
	         */ cfg: SerializableCipher.cfg.extend({
                kdf: OpenSSLKdf
            }),
            /**
	         * Encrypts a message using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {WordArray|string} message The message to encrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {CipherParams} A cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
	         *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
	         */ encrypt: function(cipher, message, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Encrypt
                var ciphertext = SerializableCipher.encrypt.call(this, cipher, message, derivedParams.key, cfg);
                // Mix in derived params
                ciphertext.mixIn(derivedParams);
                return ciphertext;
            },
            /**
	         * Decrypts serialized ciphertext using a password.
	         *
	         * @param {Cipher} cipher The cipher algorithm to use.
	         * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
	         * @param {string} password The password.
	         * @param {Object} cfg (Optional) The configuration options to use for this operation.
	         *
	         * @return {WordArray} The plaintext.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
	         *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
	         */ decrypt: function(cipher, ciphertext, password, cfg) {
                // Apply config defaults
                cfg = this.cfg.extend(cfg);
                // Convert string to CipherParams
                ciphertext = this._parse(ciphertext, cfg.format);
                // Derive key and other params
                var derivedParams = cfg.kdf.execute(password, cipher.keySize, cipher.ivSize, ciphertext.salt);
                // Add IV to config
                cfg.iv = derivedParams.iv;
                // Decrypt
                var plaintext = SerializableCipher.decrypt.call(this, cipher, ciphertext, derivedParams.key, cfg);
                return plaintext;
            }
        });
    }();
});

});

parcelRegister("kvEE5", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Cipher Feedback block mode.
	 */ CryptoJS.mode.CFB = function() {
        var CFB = CryptoJS.lib.BlockCipherMode.extend();
        CFB.Encryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // Remember this block to use with next block
                this._prevBlock = words.slice(offset, offset + blockSize);
            }
        });
        CFB.Decryptor = CFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                // Remember this block to use with next block
                var thisBlock = words.slice(offset, offset + blockSize);
                generateKeystreamAndEncrypt.call(this, words, offset, blockSize, cipher);
                // This block becomes the previous block
                this._prevBlock = thisBlock;
            }
        });
        function generateKeystreamAndEncrypt(words, offset, blockSize, cipher) {
            var keystream;
            // Shortcut
            var iv = this._iv;
            // Generate keystream
            if (iv) {
                keystream = iv.slice(0);
                // Remove IV for subsequent blocks
                this._iv = undefined;
            } else keystream = this._prevBlock;
            cipher.encryptBlock(keystream, 0);
            // Encrypt
            for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
        }
        return CFB;
    }();
    return CryptoJS.mode.CFB;
});

});

parcelRegister("4phbY", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Counter block mode.
	 */ CryptoJS.mode.CTR = function() {
        var CTR = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = CTR.Encryptor = CTR.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Increment counter
                counter[blockSize - 1] = counter[blockSize - 1] + 1 | 0;
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTR.Decryptor = Encryptor;
        return CTR;
    }();
    return CryptoJS.mode.CTR;
});

});

parcelRegister("5AuZH", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /** @preserve
	 * Counter block mode compatible with  Dr Brian Gladman fileenc.c
	 * derived from CryptoJS.mode.CTR
	 * Jan Hruby jhruby.web@gmail.com
	 */ CryptoJS.mode.CTRGladman = function() {
        var CTRGladman = CryptoJS.lib.BlockCipherMode.extend();
        function incWord(word) {
            if ((word >> 24 & 0xff) === 0xff) {
                var b1 = word >> 16 & 0xff;
                var b2 = word >> 8 & 0xff;
                var b3 = word & 0xff;
                if (b1 === 0xff) {
                    b1 = 0;
                    if (b2 === 0xff) {
                        b2 = 0;
                        if (b3 === 0xff) b3 = 0;
                        else ++b3;
                    } else ++b2;
                } else ++b1;
                word = 0;
                word += b1 << 16;
                word += b2 << 8;
                word += b3;
            } else word += 16777216;
            return word;
        }
        function incCounter(counter) {
            if ((counter[0] = incWord(counter[0])) === 0) // encr_data in fileenc.c from  Dr Brian Gladman's counts only with DWORD j < 8
            counter[1] = incWord(counter[1]);
            return counter;
        }
        var Encryptor = CTRGladman.Encryptor = CTRGladman.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var counter = this._counter;
                // Generate keystream
                if (iv) {
                    counter = this._counter = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                incCounter(counter);
                var keystream = counter.slice(0);
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        CTRGladman.Decryptor = Encryptor;
        return CTRGladman;
    }();
    return CryptoJS.mode.CTRGladman;
});

});

parcelRegister("9xxh3", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Output Feedback block mode.
	 */ CryptoJS.mode.OFB = function() {
        var OFB = CryptoJS.lib.BlockCipherMode.extend();
        var Encryptor = OFB.Encryptor = OFB.extend({
            processBlock: function(words, offset) {
                // Shortcuts
                var cipher = this._cipher;
                var blockSize = cipher.blockSize;
                var iv = this._iv;
                var keystream = this._keystream;
                // Generate keystream
                if (iv) {
                    keystream = this._keystream = iv.slice(0);
                    // Remove IV for subsequent blocks
                    this._iv = undefined;
                }
                cipher.encryptBlock(keystream, 0);
                // Encrypt
                for(var i = 0; i < blockSize; i++)words[offset + i] ^= keystream[i];
            }
        });
        OFB.Decryptor = Encryptor;
        return OFB;
    }();
    return CryptoJS.mode.OFB;
});

});

parcelRegister("hsvIJ", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Electronic Codebook block mode.
	 */ CryptoJS.mode.ECB = function() {
        var ECB = CryptoJS.lib.BlockCipherMode.extend();
        ECB.Encryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.encryptBlock(words, offset);
            }
        });
        ECB.Decryptor = ECB.extend({
            processBlock: function(words, offset) {
                this._cipher.decryptBlock(words, offset);
            }
        });
        return ECB;
    }();
    return CryptoJS.mode.ECB;
});

});

parcelRegister("cIj8k", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ANSI X.923 padding strategy.
	 */ CryptoJS.pad.AnsiX923 = {
        pad: function(data, blockSize) {
            // Shortcuts
            var dataSigBytes = data.sigBytes;
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - dataSigBytes % blockSizeBytes;
            // Compute last byte position
            var lastBytePos = dataSigBytes + nPaddingBytes - 1;
            // Pad
            data.clamp();
            data.words[lastBytePos >>> 2] |= nPaddingBytes << 24 - lastBytePos % 4 * 8;
            data.sigBytes += nPaddingBytes;
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Ansix923;
});

});

parcelRegister("3XsJo", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO 10126 padding strategy.
	 */ CryptoJS.pad.Iso10126 = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Count padding bytes
            var nPaddingBytes = blockSizeBytes - data.sigBytes % blockSizeBytes;
            // Pad
            data.concat(CryptoJS.lib.WordArray.random(nPaddingBytes - 1)).concat(CryptoJS.lib.WordArray.create([
                nPaddingBytes << 24
            ], 1));
        },
        unpad: function(data) {
            // Get number of padding bytes from last byte
            var nPaddingBytes = data.words[data.sigBytes - 1 >>> 2] & 0xff;
            // Remove padding
            data.sigBytes -= nPaddingBytes;
        }
    };
    return CryptoJS.pad.Iso10126;
});

});

parcelRegister("4cP0m", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * ISO/IEC 9797-1 Padding Method 2.
	 */ CryptoJS.pad.Iso97971 = {
        pad: function(data, blockSize) {
            // Add 0x80 byte
            data.concat(CryptoJS.lib.WordArray.create([
                0x80000000
            ], 1));
            // Zero pad the rest
            CryptoJS.pad.ZeroPadding.pad(data, blockSize);
        },
        unpad: function(data) {
            // Remove zero padding
            CryptoJS.pad.ZeroPadding.unpad(data);
            // Remove one more byte -- the 0x80 byte
            data.sigBytes--;
        }
    };
    return CryptoJS.pad.Iso97971;
});

});

parcelRegister("1bHm1", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * Zero padding strategy.
	 */ CryptoJS.pad.ZeroPadding = {
        pad: function(data, blockSize) {
            // Shortcut
            var blockSizeBytes = blockSize * 4;
            // Pad
            data.clamp();
            data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
        },
        unpad: function(data) {
            // Shortcut
            var dataWords = data.words;
            // Unpad
            var i = data.sigBytes - 1;
            for(var i = data.sigBytes - 1; i >= 0; i--)if (dataWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff) {
                data.sigBytes = i + 1;
                break;
            }
        }
    };
    return CryptoJS.pad.ZeroPadding;
});

});

parcelRegister("5oWlT", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    /**
	 * A noop padding strategy.
	 */ CryptoJS.pad.NoPadding = {
        pad: function() {},
        unpad: function() {}
    };
    return CryptoJS.pad.NoPadding;
});

});

parcelRegister("eSHMm", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var CipherParams = C_lib.CipherParams;
        var C_enc = C.enc;
        var Hex = C_enc.Hex;
        var C_format = C.format;
        var HexFormatter = C_format.Hex = {
            /**
	         * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
	         *
	         * @param {CipherParams} cipherParams The cipher params object.
	         *
	         * @return {string} The hexadecimally encoded string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
	         */ stringify: function(cipherParams) {
                return cipherParams.ciphertext.toString(Hex);
            },
            /**
	         * Converts a hexadecimally encoded ciphertext string to a cipher params object.
	         *
	         * @param {string} input The hexadecimally encoded string.
	         *
	         * @return {CipherParams} The cipher params object.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
	         */ parse: function(input) {
                var ciphertext = Hex.parse(input);
                return CipherParams.create({
                    ciphertext: ciphertext
                });
            }
        };
    })();
    return CryptoJS.format.Hex;
});

});

parcelRegister("3H9rt", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Lookup tables
        var SBOX = [];
        var INV_SBOX = [];
        var SUB_MIX_0 = [];
        var SUB_MIX_1 = [];
        var SUB_MIX_2 = [];
        var SUB_MIX_3 = [];
        var INV_SUB_MIX_0 = [];
        var INV_SUB_MIX_1 = [];
        var INV_SUB_MIX_2 = [];
        var INV_SUB_MIX_3 = [];
        // Compute lookup tables
        (function() {
            // Compute double table
            var d = [];
            for(var i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
            else d[i] = i << 1 ^ 0x11b;
            // Walk GF(2^8)
            var x = 0;
            var xi = 0;
            for(var i = 0; i < 256; i++){
                // Compute sbox
                var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
                sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
                SBOX[x] = sx;
                INV_SBOX[sx] = x;
                // Compute multiplication
                var x2 = d[x];
                var x4 = d[x2];
                var x8 = d[x4];
                // Compute sub bytes, mix columns tables
                var t = d[sx] * 0x101 ^ sx * 0x1010100;
                SUB_MIX_0[x] = t << 24 | t >>> 8;
                SUB_MIX_1[x] = t << 16 | t >>> 16;
                SUB_MIX_2[x] = t << 8 | t >>> 24;
                SUB_MIX_3[x] = t;
                // Compute inv sub bytes, inv mix columns tables
                var t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
                INV_SUB_MIX_0[sx] = t << 24 | t >>> 8;
                INV_SUB_MIX_1[sx] = t << 16 | t >>> 16;
                INV_SUB_MIX_2[sx] = t << 8 | t >>> 24;
                INV_SUB_MIX_3[sx] = t;
                // Compute next counter
                if (!x) x = xi = 1;
                else {
                    x = x2 ^ d[d[d[x8 ^ x2]]];
                    xi ^= d[d[xi]];
                }
            }
        })();
        // Precomputed Rcon lookup
        var RCON = [
            0x00,
            0x01,
            0x02,
            0x04,
            0x08,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        /**
	     * AES block cipher algorithm.
	     */ var AES = C_algo.AES = BlockCipher.extend({
            _doReset: function() {
                var t;
                // Skip reset of nRounds has been set before and key did not change
                if (this._nRounds && this._keyPriorReset === this._key) return;
                // Shortcuts
                var key = this._keyPriorReset = this._key;
                var keyWords = key.words;
                var keySize = key.sigBytes / 4;
                // Compute number of rounds
                var nRounds = this._nRounds = keySize + 6;
                // Compute number of key schedule rows
                var ksRows = (nRounds + 1) * 4;
                // Compute key schedule
                var keySchedule = this._keySchedule = [];
                for(var ksRow = 0; ksRow < ksRows; ksRow++)if (ksRow < keySize) keySchedule[ksRow] = keyWords[ksRow];
                else {
                    t = keySchedule[ksRow - 1];
                    if (!(ksRow % keySize)) {
                        // Rot word
                        t = t << 8 | t >>> 24;
                        // Sub word
                        t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                        // Mix Rcon
                        t ^= RCON[ksRow / keySize | 0] << 24;
                    } else if (keySize > 6 && ksRow % keySize == 4) // Sub word
                    t = SBOX[t >>> 24] << 24 | SBOX[t >>> 16 & 0xff] << 16 | SBOX[t >>> 8 & 0xff] << 8 | SBOX[t & 0xff];
                    keySchedule[ksRow] = keySchedule[ksRow - keySize] ^ t;
                }
                // Compute inv key schedule
                var invKeySchedule = this._invKeySchedule = [];
                for(var invKsRow = 0; invKsRow < ksRows; invKsRow++){
                    var ksRow = ksRows - invKsRow;
                    if (invKsRow % 4) var t = keySchedule[ksRow];
                    else var t = keySchedule[ksRow - 4];
                    if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
                    else invKeySchedule[invKsRow] = INV_SUB_MIX_0[SBOX[t >>> 24]] ^ INV_SUB_MIX_1[SBOX[t >>> 16 & 0xff]] ^ INV_SUB_MIX_2[SBOX[t >>> 8 & 0xff]] ^ INV_SUB_MIX_3[SBOX[t & 0xff]];
                }
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX);
            },
            decryptBlock: function(M, offset) {
                // Swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
                this._doCryptBlock(M, offset, this._invKeySchedule, INV_SUB_MIX_0, INV_SUB_MIX_1, INV_SUB_MIX_2, INV_SUB_MIX_3, INV_SBOX);
                // Inv swap 2nd and 4th rows
                var t = M[offset + 1];
                M[offset + 1] = M[offset + 3];
                M[offset + 3] = t;
            },
            _doCryptBlock: function(M, offset, keySchedule, SUB_MIX_0, SUB_MIX_1, SUB_MIX_2, SUB_MIX_3, SBOX) {
                // Shortcut
                var nRounds = this._nRounds;
                // Get input, add round key
                var s0 = M[offset] ^ keySchedule[0];
                var s1 = M[offset + 1] ^ keySchedule[1];
                var s2 = M[offset + 2] ^ keySchedule[2];
                var s3 = M[offset + 3] ^ keySchedule[3];
                // Key schedule row counter
                var ksRow = 4;
                // Rounds
                for(var round = 1; round < nRounds; round++){
                    // Shift rows, sub bytes, mix columns, add round key
                    var t0 = SUB_MIX_0[s0 >>> 24] ^ SUB_MIX_1[s1 >>> 16 & 0xff] ^ SUB_MIX_2[s2 >>> 8 & 0xff] ^ SUB_MIX_3[s3 & 0xff] ^ keySchedule[ksRow++];
                    var t1 = SUB_MIX_0[s1 >>> 24] ^ SUB_MIX_1[s2 >>> 16 & 0xff] ^ SUB_MIX_2[s3 >>> 8 & 0xff] ^ SUB_MIX_3[s0 & 0xff] ^ keySchedule[ksRow++];
                    var t2 = SUB_MIX_0[s2 >>> 24] ^ SUB_MIX_1[s3 >>> 16 & 0xff] ^ SUB_MIX_2[s0 >>> 8 & 0xff] ^ SUB_MIX_3[s1 & 0xff] ^ keySchedule[ksRow++];
                    var t3 = SUB_MIX_0[s3 >>> 24] ^ SUB_MIX_1[s0 >>> 16 & 0xff] ^ SUB_MIX_2[s1 >>> 8 & 0xff] ^ SUB_MIX_3[s2 & 0xff] ^ keySchedule[ksRow++];
                    // Update state
                    s0 = t0;
                    s1 = t1;
                    s2 = t2;
                    s3 = t3;
                }
                // Shift rows, sub bytes, add round key
                var t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
                var t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
                var t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
                var t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
                // Set output
                M[offset] = t0;
                M[offset + 1] = t1;
                M[offset + 2] = t2;
                M[offset + 3] = t3;
            },
            keySize: 8
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.AES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.AES.decrypt(ciphertext, key, cfg);
	     */ C.AES = BlockCipher._createHelper(AES);
    })();
    return CryptoJS.AES;
});

});

parcelRegister("2QWZ2", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var BlockCipher = C_lib.BlockCipher;
        var C_algo = C.algo;
        // Permuted Choice 1 constants
        var PC1 = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
        ];
        // Permuted Choice 2 constants
        var PC2 = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
        ];
        // Cumulative bit shift constants
        var BIT_SHIFTS = [
            1,
            2,
            4,
            6,
            8,
            10,
            12,
            14,
            15,
            17,
            19,
            21,
            23,
            25,
            27,
            28
        ];
        // SBOXes and round permutation constants
        var SBOX_P = [
            {
                0x0: 0x808200,
                0x10000000: 0x8000,
                0x20000000: 0x808002,
                0x30000000: 0x2,
                0x40000000: 0x200,
                0x50000000: 0x808202,
                0x60000000: 0x800202,
                0x70000000: 0x800000,
                0x80000000: 0x202,
                0x90000000: 0x800200,
                0xa0000000: 0x8200,
                0xb0000000: 0x808000,
                0xc0000000: 0x8002,
                0xd0000000: 0x800002,
                0xe0000000: 0x0,
                0xf0000000: 0x8202,
                0x8000000: 0x0,
                0x18000000: 0x808202,
                0x28000000: 0x8202,
                0x38000000: 0x8000,
                0x48000000: 0x808200,
                0x58000000: 0x200,
                0x68000000: 0x808002,
                0x78000000: 0x2,
                0x88000000: 0x800200,
                0x98000000: 0x8200,
                0xa8000000: 0x808000,
                0xb8000000: 0x800202,
                0xc8000000: 0x800002,
                0xd8000000: 0x8002,
                0xe8000000: 0x202,
                0xf8000000: 0x800000,
                0x1: 0x8000,
                0x10000001: 0x2,
                0x20000001: 0x808200,
                0x30000001: 0x800000,
                0x40000001: 0x808002,
                0x50000001: 0x8200,
                0x60000001: 0x200,
                0x70000001: 0x800202,
                0x80000001: 0x808202,
                0x90000001: 0x808000,
                0xa0000001: 0x800002,
                0xb0000001: 0x8202,
                0xc0000001: 0x202,
                0xd0000001: 0x800200,
                0xe0000001: 0x8002,
                0xf0000001: 0x0,
                0x8000001: 0x808202,
                0x18000001: 0x808000,
                0x28000001: 0x800000,
                0x38000001: 0x200,
                0x48000001: 0x8000,
                0x58000001: 0x800002,
                0x68000001: 0x2,
                0x78000001: 0x8202,
                0x88000001: 0x8002,
                0x98000001: 0x800202,
                0xa8000001: 0x202,
                0xb8000001: 0x808200,
                0xc8000001: 0x800200,
                0xd8000001: 0x0,
                0xe8000001: 0x8200,
                0xf8000001: 0x808002
            },
            {
                0x0: 0x40084010,
                0x1000000: 0x4000,
                0x2000000: 0x80000,
                0x3000000: 0x40080010,
                0x4000000: 0x40000010,
                0x5000000: 0x40084000,
                0x6000000: 0x40004000,
                0x7000000: 0x10,
                0x8000000: 0x84000,
                0x9000000: 0x40004010,
                0xa000000: 0x40000000,
                0xb000000: 0x84010,
                0xc000000: 0x80010,
                0xd000000: 0x0,
                0xe000000: 0x4010,
                0xf000000: 0x40080000,
                0x800000: 0x40004000,
                0x1800000: 0x84010,
                0x2800000: 0x10,
                0x3800000: 0x40004010,
                0x4800000: 0x40084010,
                0x5800000: 0x40000000,
                0x6800000: 0x80000,
                0x7800000: 0x40080010,
                0x8800000: 0x80010,
                0x9800000: 0x0,
                0xa800000: 0x4000,
                0xb800000: 0x40080000,
                0xc800000: 0x40000010,
                0xd800000: 0x84000,
                0xe800000: 0x40084000,
                0xf800000: 0x4010,
                0x10000000: 0x0,
                0x11000000: 0x40080010,
                0x12000000: 0x40004010,
                0x13000000: 0x40084000,
                0x14000000: 0x40080000,
                0x15000000: 0x10,
                0x16000000: 0x84010,
                0x17000000: 0x4000,
                0x18000000: 0x4010,
                0x19000000: 0x80000,
                0x1a000000: 0x80010,
                0x1b000000: 0x40000010,
                0x1c000000: 0x84000,
                0x1d000000: 0x40004000,
                0x1e000000: 0x40000000,
                0x1f000000: 0x40084010,
                0x10800000: 0x84010,
                0x11800000: 0x80000,
                0x12800000: 0x40080000,
                0x13800000: 0x4000,
                0x14800000: 0x40004000,
                0x15800000: 0x40084010,
                0x16800000: 0x10,
                0x17800000: 0x40000000,
                0x18800000: 0x40084000,
                0x19800000: 0x40000010,
                0x1a800000: 0x40004010,
                0x1b800000: 0x80010,
                0x1c800000: 0x0,
                0x1d800000: 0x4010,
                0x1e800000: 0x40080010,
                0x1f800000: 0x84000
            },
            {
                0x0: 0x104,
                0x100000: 0x0,
                0x200000: 0x4000100,
                0x300000: 0x10104,
                0x400000: 0x10004,
                0x500000: 0x4000004,
                0x600000: 0x4010104,
                0x700000: 0x4010000,
                0x800000: 0x4000000,
                0x900000: 0x4010100,
                0xa00000: 0x10100,
                0xb00000: 0x4010004,
                0xc00000: 0x4000104,
                0xd00000: 0x10000,
                0xe00000: 0x4,
                0xf00000: 0x100,
                0x80000: 0x4010100,
                0x180000: 0x4010004,
                0x280000: 0x0,
                0x380000: 0x4000100,
                0x480000: 0x4000004,
                0x580000: 0x10000,
                0x680000: 0x10004,
                0x780000: 0x104,
                0x880000: 0x4,
                0x980000: 0x100,
                0xa80000: 0x4010000,
                0xb80000: 0x10104,
                0xc80000: 0x10100,
                0xd80000: 0x4000104,
                0xe80000: 0x4010104,
                0xf80000: 0x4000000,
                0x1000000: 0x4010100,
                0x1100000: 0x10004,
                0x1200000: 0x10000,
                0x1300000: 0x4000100,
                0x1400000: 0x100,
                0x1500000: 0x4010104,
                0x1600000: 0x4000004,
                0x1700000: 0x0,
                0x1800000: 0x4000104,
                0x1900000: 0x4000000,
                0x1a00000: 0x4,
                0x1b00000: 0x10100,
                0x1c00000: 0x4010000,
                0x1d00000: 0x104,
                0x1e00000: 0x10104,
                0x1f00000: 0x4010004,
                0x1080000: 0x4000000,
                0x1180000: 0x104,
                0x1280000: 0x4010100,
                0x1380000: 0x0,
                0x1480000: 0x10004,
                0x1580000: 0x4000100,
                0x1680000: 0x100,
                0x1780000: 0x4010004,
                0x1880000: 0x10000,
                0x1980000: 0x4010104,
                0x1a80000: 0x10104,
                0x1b80000: 0x4000004,
                0x1c80000: 0x4000104,
                0x1d80000: 0x4010000,
                0x1e80000: 0x4,
                0x1f80000: 0x10100
            },
            {
                0x0: 0x80401000,
                0x10000: 0x80001040,
                0x20000: 0x401040,
                0x30000: 0x80400000,
                0x40000: 0x0,
                0x50000: 0x401000,
                0x60000: 0x80000040,
                0x70000: 0x400040,
                0x80000: 0x80000000,
                0x90000: 0x400000,
                0xa0000: 0x40,
                0xb0000: 0x80001000,
                0xc0000: 0x80400040,
                0xd0000: 0x1040,
                0xe0000: 0x1000,
                0xf0000: 0x80401040,
                0x8000: 0x80001040,
                0x18000: 0x40,
                0x28000: 0x80400040,
                0x38000: 0x80001000,
                0x48000: 0x401000,
                0x58000: 0x80401040,
                0x68000: 0x0,
                0x78000: 0x80400000,
                0x88000: 0x1000,
                0x98000: 0x80401000,
                0xa8000: 0x400000,
                0xb8000: 0x1040,
                0xc8000: 0x80000000,
                0xd8000: 0x400040,
                0xe8000: 0x401040,
                0xf8000: 0x80000040,
                0x100000: 0x400040,
                0x110000: 0x401000,
                0x120000: 0x80000040,
                0x130000: 0x0,
                0x140000: 0x1040,
                0x150000: 0x80400040,
                0x160000: 0x80401000,
                0x170000: 0x80001040,
                0x180000: 0x80401040,
                0x190000: 0x80000000,
                0x1a0000: 0x80400000,
                0x1b0000: 0x401040,
                0x1c0000: 0x80001000,
                0x1d0000: 0x400000,
                0x1e0000: 0x40,
                0x1f0000: 0x1000,
                0x108000: 0x80400000,
                0x118000: 0x80401040,
                0x128000: 0x0,
                0x138000: 0x401000,
                0x148000: 0x400040,
                0x158000: 0x80000000,
                0x168000: 0x80001040,
                0x178000: 0x40,
                0x188000: 0x80000040,
                0x198000: 0x1000,
                0x1a8000: 0x80001000,
                0x1b8000: 0x80400040,
                0x1c8000: 0x1040,
                0x1d8000: 0x80401000,
                0x1e8000: 0x400000,
                0x1f8000: 0x401040
            },
            {
                0x0: 0x80,
                0x1000: 0x1040000,
                0x2000: 0x40000,
                0x3000: 0x20000000,
                0x4000: 0x20040080,
                0x5000: 0x1000080,
                0x6000: 0x21000080,
                0x7000: 0x40080,
                0x8000: 0x1000000,
                0x9000: 0x20040000,
                0xa000: 0x20000080,
                0xb000: 0x21040080,
                0xc000: 0x21040000,
                0xd000: 0x0,
                0xe000: 0x1040080,
                0xf000: 0x21000000,
                0x800: 0x1040080,
                0x1800: 0x21000080,
                0x2800: 0x80,
                0x3800: 0x1040000,
                0x4800: 0x40000,
                0x5800: 0x20040080,
                0x6800: 0x21040000,
                0x7800: 0x20000000,
                0x8800: 0x20040000,
                0x9800: 0x0,
                0xa800: 0x21040080,
                0xb800: 0x1000080,
                0xc800: 0x20000080,
                0xd800: 0x21000000,
                0xe800: 0x1000000,
                0xf800: 0x40080,
                0x10000: 0x40000,
                0x11000: 0x80,
                0x12000: 0x20000000,
                0x13000: 0x21000080,
                0x14000: 0x1000080,
                0x15000: 0x21040000,
                0x16000: 0x20040080,
                0x17000: 0x1000000,
                0x18000: 0x21040080,
                0x19000: 0x21000000,
                0x1a000: 0x1040000,
                0x1b000: 0x20040000,
                0x1c000: 0x40080,
                0x1d000: 0x20000080,
                0x1e000: 0x0,
                0x1f000: 0x1040080,
                0x10800: 0x21000080,
                0x11800: 0x1000000,
                0x12800: 0x1040000,
                0x13800: 0x20040080,
                0x14800: 0x20000000,
                0x15800: 0x1040080,
                0x16800: 0x80,
                0x17800: 0x21040000,
                0x18800: 0x40080,
                0x19800: 0x21040080,
                0x1a800: 0x0,
                0x1b800: 0x21000000,
                0x1c800: 0x1000080,
                0x1d800: 0x40000,
                0x1e800: 0x20040000,
                0x1f800: 0x20000080
            },
            {
                0x0: 0x10000008,
                0x100: 0x2000,
                0x200: 0x10200000,
                0x300: 0x10202008,
                0x400: 0x10002000,
                0x500: 0x200000,
                0x600: 0x200008,
                0x700: 0x10000000,
                0x800: 0x0,
                0x900: 0x10002008,
                0xa00: 0x202000,
                0xb00: 0x8,
                0xc00: 0x10200008,
                0xd00: 0x202008,
                0xe00: 0x2008,
                0xf00: 0x10202000,
                0x80: 0x10200000,
                0x180: 0x10202008,
                0x280: 0x8,
                0x380: 0x200000,
                0x480: 0x202008,
                0x580: 0x10000008,
                0x680: 0x10002000,
                0x780: 0x2008,
                0x880: 0x200008,
                0x980: 0x2000,
                0xa80: 0x10002008,
                0xb80: 0x10200008,
                0xc80: 0x0,
                0xd80: 0x10202000,
                0xe80: 0x202000,
                0xf80: 0x10000000,
                0x1000: 0x10002000,
                0x1100: 0x10200008,
                0x1200: 0x10202008,
                0x1300: 0x2008,
                0x1400: 0x200000,
                0x1500: 0x10000000,
                0x1600: 0x10000008,
                0x1700: 0x202000,
                0x1800: 0x202008,
                0x1900: 0x0,
                0x1a00: 0x8,
                0x1b00: 0x10200000,
                0x1c00: 0x2000,
                0x1d00: 0x10002008,
                0x1e00: 0x10202000,
                0x1f00: 0x200008,
                0x1080: 0x8,
                0x1180: 0x202000,
                0x1280: 0x200000,
                0x1380: 0x10000008,
                0x1480: 0x10002000,
                0x1580: 0x2008,
                0x1680: 0x10202008,
                0x1780: 0x10200000,
                0x1880: 0x10202000,
                0x1980: 0x10200008,
                0x1a80: 0x2000,
                0x1b80: 0x202008,
                0x1c80: 0x200008,
                0x1d80: 0x0,
                0x1e80: 0x10000000,
                0x1f80: 0x10002008
            },
            {
                0x0: 0x100000,
                0x10: 0x2000401,
                0x20: 0x400,
                0x30: 0x100401,
                0x40: 0x2100401,
                0x50: 0x0,
                0x60: 0x1,
                0x70: 0x2100001,
                0x80: 0x2000400,
                0x90: 0x100001,
                0xa0: 0x2000001,
                0xb0: 0x2100400,
                0xc0: 0x2100000,
                0xd0: 0x401,
                0xe0: 0x100400,
                0xf0: 0x2000000,
                0x8: 0x2100001,
                0x18: 0x0,
                0x28: 0x2000401,
                0x38: 0x2100400,
                0x48: 0x100000,
                0x58: 0x2000001,
                0x68: 0x2000000,
                0x78: 0x401,
                0x88: 0x100401,
                0x98: 0x2000400,
                0xa8: 0x2100000,
                0xb8: 0x100001,
                0xc8: 0x400,
                0xd8: 0x2100401,
                0xe8: 0x1,
                0xf8: 0x100400,
                0x100: 0x2000000,
                0x110: 0x100000,
                0x120: 0x2000401,
                0x130: 0x2100001,
                0x140: 0x100001,
                0x150: 0x2000400,
                0x160: 0x2100400,
                0x170: 0x100401,
                0x180: 0x401,
                0x190: 0x2100401,
                0x1a0: 0x100400,
                0x1b0: 0x1,
                0x1c0: 0x0,
                0x1d0: 0x2100000,
                0x1e0: 0x2000001,
                0x1f0: 0x400,
                0x108: 0x100400,
                0x118: 0x2000401,
                0x128: 0x2100001,
                0x138: 0x1,
                0x148: 0x2000000,
                0x158: 0x100000,
                0x168: 0x401,
                0x178: 0x2100400,
                0x188: 0x2000001,
                0x198: 0x2100000,
                0x1a8: 0x0,
                0x1b8: 0x2100401,
                0x1c8: 0x100401,
                0x1d8: 0x400,
                0x1e8: 0x2000400,
                0x1f8: 0x100001
            },
            {
                0x0: 0x8000820,
                0x1: 0x20000,
                0x2: 0x8000000,
                0x3: 0x20,
                0x4: 0x20020,
                0x5: 0x8020820,
                0x6: 0x8020800,
                0x7: 0x800,
                0x8: 0x8020000,
                0x9: 0x8000800,
                0xa: 0x20800,
                0xb: 0x8020020,
                0xc: 0x820,
                0xd: 0x0,
                0xe: 0x8000020,
                0xf: 0x20820,
                0x80000000: 0x800,
                0x80000001: 0x8020820,
                0x80000002: 0x8000820,
                0x80000003: 0x8000000,
                0x80000004: 0x8020000,
                0x80000005: 0x20800,
                0x80000006: 0x20820,
                0x80000007: 0x20,
                0x80000008: 0x8000020,
                0x80000009: 0x820,
                0x8000000a: 0x20020,
                0x8000000b: 0x8020800,
                0x8000000c: 0x0,
                0x8000000d: 0x8020020,
                0x8000000e: 0x8000800,
                0x8000000f: 0x20000,
                0x10: 0x20820,
                0x11: 0x8020800,
                0x12: 0x20,
                0x13: 0x800,
                0x14: 0x8000800,
                0x15: 0x8000020,
                0x16: 0x8020020,
                0x17: 0x20000,
                0x18: 0x0,
                0x19: 0x20020,
                0x1a: 0x8020000,
                0x1b: 0x8000820,
                0x1c: 0x8020820,
                0x1d: 0x20800,
                0x1e: 0x820,
                0x1f: 0x8000000,
                0x80000010: 0x20000,
                0x80000011: 0x800,
                0x80000012: 0x8020020,
                0x80000013: 0x20820,
                0x80000014: 0x20,
                0x80000015: 0x8020000,
                0x80000016: 0x8000000,
                0x80000017: 0x8000820,
                0x80000018: 0x8020820,
                0x80000019: 0x8000020,
                0x8000001a: 0x8000800,
                0x8000001b: 0x0,
                0x8000001c: 0x20800,
                0x8000001d: 0x820,
                0x8000001e: 0x20020,
                0x8000001f: 0x8020800
            }
        ];
        // Masks that select the SBOX input
        var SBOX_MASK = [
            0xf8000001,
            0x1f800000,
            0x01f80000,
            0x001f8000,
            0x0001f800,
            0x00001f80,
            0x000001f8,
            0x8000001f
        ];
        /**
	     * DES block cipher algorithm.
	     */ var DES = C_algo.DES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Select 56 bits according to PC1
                var keyBits = [];
                for(var i = 0; i < 56; i++){
                    var keyBitPos = PC1[i] - 1;
                    keyBits[i] = keyWords[keyBitPos >>> 5] >>> 31 - keyBitPos % 32 & 1;
                }
                // Assemble 16 subkeys
                var subKeys = this._subKeys = [];
                for(var nSubKey = 0; nSubKey < 16; nSubKey++){
                    // Create subkey
                    var subKey = subKeys[nSubKey] = [];
                    // Shortcut
                    var bitShift = BIT_SHIFTS[nSubKey];
                    // Select 48 bits according to PC2
                    for(var i = 0; i < 24; i++){
                        // Select from the left 28 key bits
                        subKey[i / 6 | 0] |= keyBits[(PC2[i] - 1 + bitShift) % 28] << 31 - i % 6;
                        // Select from the right 28 key bits
                        subKey[4 + (i / 6 | 0)] |= keyBits[28 + (PC2[i + 24] - 1 + bitShift) % 28] << 31 - i % 6;
                    }
                    // Since each subkey is applied to an expanded 32-bit input,
                    // the subkey can be broken into 8 values scaled to 32-bits,
                    // which allows the key to be used without expansion
                    subKey[0] = subKey[0] << 1 | subKey[0] >>> 31;
                    for(var i = 1; i < 7; i++)subKey[i] = subKey[i] >>> (i - 1) * 4 + 3;
                    subKey[7] = subKey[7] << 5 | subKey[7] >>> 27;
                }
                // Compute inverse subkeys
                var invSubKeys = this._invSubKeys = [];
                for(var i = 0; i < 16; i++)invSubKeys[i] = subKeys[15 - i];
            },
            encryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._subKeys);
            },
            decryptBlock: function(M, offset) {
                this._doCryptBlock(M, offset, this._invSubKeys);
            },
            _doCryptBlock: function(M, offset, subKeys) {
                // Get input
                this._lBlock = M[offset];
                this._rBlock = M[offset + 1];
                // Initial permutation
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeLR.call(this, 1, 0x55555555);
                // Rounds
                for(var round = 0; round < 16; round++){
                    // Shortcuts
                    var subKey = subKeys[round];
                    var lBlock = this._lBlock;
                    var rBlock = this._rBlock;
                    // Feistel function
                    var f = 0;
                    for(var i = 0; i < 8; i++)f |= SBOX_P[i][((rBlock ^ subKey[i]) & SBOX_MASK[i]) >>> 0];
                    this._lBlock = rBlock;
                    this._rBlock = lBlock ^ f;
                }
                // Undo swap from last round
                var t = this._lBlock;
                this._lBlock = this._rBlock;
                this._rBlock = t;
                // Final permutation
                exchangeLR.call(this, 1, 0x55555555);
                exchangeRL.call(this, 8, 0x00ff00ff);
                exchangeRL.call(this, 2, 0x33333333);
                exchangeLR.call(this, 16, 0x0000ffff);
                exchangeLR.call(this, 4, 0x0f0f0f0f);
                // Set output
                M[offset] = this._lBlock;
                M[offset + 1] = this._rBlock;
            },
            keySize: 2,
            ivSize: 2,
            blockSize: 2
        });
        // Swap bits across the left and right words
        function exchangeLR(offset, mask) {
            var t = (this._lBlock >>> offset ^ this._rBlock) & mask;
            this._rBlock ^= t;
            this._lBlock ^= t << offset;
        }
        function exchangeRL(offset, mask) {
            var t = (this._rBlock >>> offset ^ this._lBlock) & mask;
            this._lBlock ^= t;
            this._rBlock ^= t << offset;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.DES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.DES.decrypt(ciphertext, key, cfg);
	     */ C.DES = BlockCipher._createHelper(DES);
        /**
	     * Triple-DES block cipher algorithm.
	     */ var TripleDES = C_algo.TripleDES = BlockCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                // Make sure the key length is valid (64, 128 or >= 192 bit)
                if (keyWords.length !== 2 && keyWords.length !== 4 && keyWords.length < 6) throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
                // Extend the key according to the keying options defined in 3DES standard
                var key1 = keyWords.slice(0, 2);
                var key2 = keyWords.length < 4 ? keyWords.slice(0, 2) : keyWords.slice(2, 4);
                var key3 = keyWords.length < 6 ? keyWords.slice(0, 2) : keyWords.slice(4, 6);
                // Create DES instances
                this._des1 = DES.createEncryptor(WordArray.create(key1));
                this._des2 = DES.createEncryptor(WordArray.create(key2));
                this._des3 = DES.createEncryptor(WordArray.create(key3));
            },
            encryptBlock: function(M, offset) {
                this._des1.encryptBlock(M, offset);
                this._des2.decryptBlock(M, offset);
                this._des3.encryptBlock(M, offset);
            },
            decryptBlock: function(M, offset) {
                this._des3.decryptBlock(M, offset);
                this._des2.encryptBlock(M, offset);
                this._des1.decryptBlock(M, offset);
            },
            keySize: 6,
            ivSize: 2,
            blockSize: 2
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.TripleDES.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.TripleDES.decrypt(ciphertext, key, cfg);
	     */ C.TripleDES = BlockCipher._createHelper(TripleDES);
    })();
    return CryptoJS.TripleDES;
});

});

parcelRegister("1sYM8", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        /**
	     * RC4 stream cipher algorithm.
	     */ var RC4 = C_algo.RC4 = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var key = this._key;
                var keyWords = key.words;
                var keySigBytes = key.sigBytes;
                // Init sbox
                var S = this._S = [];
                for(var i = 0; i < 256; i++)S[i] = i;
                // Key setup
                for(var i = 0, j = 0; i < 256; i++){
                    var keyByteIndex = i % keySigBytes;
                    var keyByte = keyWords[keyByteIndex >>> 2] >>> 24 - keyByteIndex % 4 * 8 & 0xff;
                    j = (j + S[i] + keyByte) % 256;
                    // Swap
                    var t = S[i];
                    S[i] = S[j];
                    S[j] = t;
                }
                // Counters
                this._i = this._j = 0;
            },
            _doProcessBlock: function(M, offset) {
                M[offset] ^= generateKeystreamWord.call(this);
            },
            keySize: 8,
            ivSize: 0
        });
        function generateKeystreamWord() {
            // Shortcuts
            var S = this._S;
            var i = this._i;
            var j = this._j;
            // Generate keystream word
            var keystreamWord = 0;
            for(var n = 0; n < 4; n++){
                i = (i + 1) % 256;
                j = (j + S[i]) % 256;
                // Swap
                var t = S[i];
                S[i] = S[j];
                S[j] = t;
                keystreamWord |= S[(S[i] + S[j]) % 256] << 24 - n * 8;
            }
            // Update counters
            this._i = i;
            this._j = j;
            return keystreamWord;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4.decrypt(ciphertext, key, cfg);
	     */ C.RC4 = StreamCipher._createHelper(RC4);
        /**
	     * Modified RC4 stream cipher algorithm.
	     */ var RC4Drop = C_algo.RC4Drop = RC4.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} drop The number of keystream words to drop. Default 192
	         */ cfg: RC4.cfg.extend({
                drop: 192
            }),
            _doReset: function() {
                RC4._doReset.call(this);
                // Drop
                for(var i = this.cfg.drop; i > 0; i--)generateKeystreamWord.call(this);
            }
        });
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RC4Drop.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RC4Drop.decrypt(ciphertext, key, cfg);
	     */ C.RC4Drop = StreamCipher._createHelper(RC4Drop);
    })();
    return CryptoJS.RC4;
});

});

parcelRegister("hUv46", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm
	     */ var Rabbit = C_algo.Rabbit = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Swap endian
                for(var i = 0; i < 4; i++)K[i] = (K[i] << 8 | K[i] >>> 24) & 0x00ff00ff | (K[i] << 24 | K[i] >>> 8) & 0xff00ff00;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.Rabbit.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.Rabbit.decrypt(ciphertext, key, cfg);
	     */ C.Rabbit = StreamCipher._createHelper(Rabbit);
    })();
    return CryptoJS.Rabbit;
});

});

parcelRegister("3ybbi", function(module, exports) {





(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("cfaDk")), (parcelRequire("500SS")), (parcelRequire("6oXxt")), (parcelRequire("ioEPr")), (parcelRequire("fctwD")));
})(this, function(CryptoJS) {
    (function() {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var StreamCipher = C_lib.StreamCipher;
        var C_algo = C.algo;
        // Reusable objects
        var S = [];
        var C_ = [];
        var G = [];
        /**
	     * Rabbit stream cipher algorithm.
	     *
	     * This is a legacy version that neglected to convert the key to little-endian.
	     * This error doesn't affect the cipher's security,
	     * but it does affect its compatibility with other implementations.
	     */ var RabbitLegacy = C_algo.RabbitLegacy = StreamCipher.extend({
            _doReset: function() {
                // Shortcuts
                var K = this._key.words;
                var iv = this.cfg.iv;
                // Generate initial state values
                var X = this._X = [
                    K[0],
                    K[3] << 16 | K[2] >>> 16,
                    K[1],
                    K[0] << 16 | K[3] >>> 16,
                    K[2],
                    K[1] << 16 | K[0] >>> 16,
                    K[3],
                    K[2] << 16 | K[1] >>> 16
                ];
                // Generate initial counter values
                var C = this._C = [
                    K[2] << 16 | K[2] >>> 16,
                    K[0] & 0xffff0000 | K[1] & 0x0000ffff,
                    K[3] << 16 | K[3] >>> 16,
                    K[1] & 0xffff0000 | K[2] & 0x0000ffff,
                    K[0] << 16 | K[0] >>> 16,
                    K[2] & 0xffff0000 | K[3] & 0x0000ffff,
                    K[1] << 16 | K[1] >>> 16,
                    K[3] & 0xffff0000 | K[0] & 0x0000ffff
                ];
                // Carry bit
                this._b = 0;
                // Iterate the system four times
                for(var i = 0; i < 4; i++)nextState.call(this);
                // Modify the counters
                for(var i = 0; i < 8; i++)C[i] ^= X[i + 4 & 7];
                // IV setup
                if (iv) {
                    // Shortcuts
                    var IV = iv.words;
                    var IV_0 = IV[0];
                    var IV_1 = IV[1];
                    // Generate four subvectors
                    var i0 = (IV_0 << 8 | IV_0 >>> 24) & 0x00ff00ff | (IV_0 << 24 | IV_0 >>> 8) & 0xff00ff00;
                    var i2 = (IV_1 << 8 | IV_1 >>> 24) & 0x00ff00ff | (IV_1 << 24 | IV_1 >>> 8) & 0xff00ff00;
                    var i1 = i0 >>> 16 | i2 & 0xffff0000;
                    var i3 = i2 << 16 | i0 & 0x0000ffff;
                    // Modify counter values
                    C[0] ^= i0;
                    C[1] ^= i1;
                    C[2] ^= i2;
                    C[3] ^= i3;
                    C[4] ^= i0;
                    C[5] ^= i1;
                    C[6] ^= i2;
                    C[7] ^= i3;
                    // Iterate the system four times
                    for(var i = 0; i < 4; i++)nextState.call(this);
                }
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var X = this._X;
                // Iterate the system
                nextState.call(this);
                // Generate four keystream words
                S[0] = X[0] ^ X[5] >>> 16 ^ X[3] << 16;
                S[1] = X[2] ^ X[7] >>> 16 ^ X[5] << 16;
                S[2] = X[4] ^ X[1] >>> 16 ^ X[7] << 16;
                S[3] = X[6] ^ X[3] >>> 16 ^ X[1] << 16;
                for(var i = 0; i < 4; i++){
                    // Swap endian
                    S[i] = (S[i] << 8 | S[i] >>> 24) & 0x00ff00ff | (S[i] << 24 | S[i] >>> 8) & 0xff00ff00;
                    // Encrypt
                    M[offset + i] ^= S[i];
                }
            },
            blockSize: 4,
            ivSize: 2
        });
        function nextState() {
            // Shortcuts
            var X = this._X;
            var C = this._C;
            // Save old counter values
            for(var i = 0; i < 8; i++)C_[i] = C[i];
            // Calculate new counter values
            C[0] = C[0] + 0x4d34d34d + this._b | 0;
            C[1] = C[1] + 0xd34d34d3 + (C[0] >>> 0 < C_[0] >>> 0 ? 1 : 0) | 0;
            C[2] = C[2] + 0x34d34d34 + (C[1] >>> 0 < C_[1] >>> 0 ? 1 : 0) | 0;
            C[3] = C[3] + 0x4d34d34d + (C[2] >>> 0 < C_[2] >>> 0 ? 1 : 0) | 0;
            C[4] = C[4] + 0xd34d34d3 + (C[3] >>> 0 < C_[3] >>> 0 ? 1 : 0) | 0;
            C[5] = C[5] + 0x34d34d34 + (C[4] >>> 0 < C_[4] >>> 0 ? 1 : 0) | 0;
            C[6] = C[6] + 0x4d34d34d + (C[5] >>> 0 < C_[5] >>> 0 ? 1 : 0) | 0;
            C[7] = C[7] + 0xd34d34d3 + (C[6] >>> 0 < C_[6] >>> 0 ? 1 : 0) | 0;
            this._b = C[7] >>> 0 < C_[7] >>> 0 ? 1 : 0;
            // Calculate the g-values
            for(var i = 0; i < 8; i++){
                var gx = X[i] + C[i];
                // Construct high and low argument for squaring
                var ga = gx & 0xffff;
                var gb = gx >>> 16;
                // Calculate high and low result of squaring
                var gh = ((ga * ga >>> 17) + ga * gb >>> 15) + gb * gb;
                var gl = ((gx & 0xffff0000) * gx | 0) + ((gx & 0x0000ffff) * gx | 0);
                // High XOR low
                G[i] = gh ^ gl;
            }
            // Calculate new state values
            X[0] = G[0] + (G[7] << 16 | G[7] >>> 16) + (G[6] << 16 | G[6] >>> 16) | 0;
            X[1] = G[1] + (G[0] << 8 | G[0] >>> 24) + G[7] | 0;
            X[2] = G[2] + (G[1] << 16 | G[1] >>> 16) + (G[0] << 16 | G[0] >>> 16) | 0;
            X[3] = G[3] + (G[2] << 8 | G[2] >>> 24) + G[1] | 0;
            X[4] = G[4] + (G[3] << 16 | G[3] >>> 16) + (G[2] << 16 | G[2] >>> 16) | 0;
            X[5] = G[5] + (G[4] << 8 | G[4] >>> 24) + G[3] | 0;
            X[6] = G[6] + (G[5] << 16 | G[5] >>> 16) + (G[4] << 16 | G[4] >>> 16) | 0;
            X[7] = G[7] + (G[6] << 8 | G[6] >>> 24) + G[5] | 0;
        }
        /**
	     * Shortcut functions to the cipher's object interface.
	     *
	     * @example
	     *
	     *     var ciphertext = CryptoJS.RabbitLegacy.encrypt(message, key, cfg);
	     *     var plaintext  = CryptoJS.RabbitLegacy.decrypt(ciphertext, key, cfg);
	     */ C.RabbitLegacy = StreamCipher._createHelper(RabbitLegacy);
    })();
    return CryptoJS.RabbitLegacy;
});

});


parcelRegister("hQ2c4", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");

var $3sU9H = parcelRequire("3sU9H");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "BncClient", {
    enumerable: true,
    get: function get() {
        return $ia7G2.BncClient;
    }
});
Object.defineProperty(module.exports, "rpc", {
    enumerable: true,
    get: function get() {
        return $cfc8fe9c7cb4ac0b$var$_rpc["default"];
    }
});
Object.defineProperty(module.exports, "Transaction", {
    enumerable: true,
    get: function get() {
        return $cfc8fe9c7cb4ac0b$var$_tx["default"];
    }
});
module.exports.utils = module.exports.types = module.exports.crypto = module.exports.amino = void 0;
parcelRequire("drGCL");

var $cfc8fe9c7cb4ac0b$var$amino = $3sU9H((parcelRequire("22ocj")));
module.exports.amino = $cfc8fe9c7cb4ac0b$var$amino;

var $ia7G2 = parcelRequire("ia7G2");

var $cfc8fe9c7cb4ac0b$var$crypto = $3sU9H((parcelRequire("kYX0e")));
module.exports.crypto = $cfc8fe9c7cb4ac0b$var$crypto;

var $cfc8fe9c7cb4ac0b$var$types = $3sU9H((parcelRequire("eULcN")));
module.exports.types = $cfc8fe9c7cb4ac0b$var$types;

var $cfc8fe9c7cb4ac0b$var$utils = $3sU9H((parcelRequire("1ZFs6")));
module.exports.utils = $cfc8fe9c7cb4ac0b$var$utils;

var $cfc8fe9c7cb4ac0b$var$_rpc = $2ZnTs((parcelRequire("6MTKw")));

var $cfc8fe9c7cb4ac0b$var$_tx = $2ZnTs((parcelRequire("cM7UC")));

});
parcelRegister("2ZnTs", function(module, exports) {
function $22d3d00379a62cb8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $22d3d00379a62cb8$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3sU9H", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $285f8beb5d670554$var$_typeof = $crtHL.default;
function $285f8beb5d670554$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($285f8beb5d670554$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $285f8beb5d670554$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $285f8beb5d670554$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        "default": obj
    };
    var cache = $285f8beb5d670554$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj["default"] = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
module.exports = $285f8beb5d670554$var$_interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("crtHL", function(module, exports) {
function $90ef0c6889924fa4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return module.exports = $90ef0c6889924fa4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $90ef0c6889924fa4$var$_typeof(obj);
}
module.exports = $90ef0c6889924fa4$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("drGCL", function(module, exports) {
"use strict";

});

parcelRegister("22ocj", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $17be89d34683db38$var$_exportNames = {
    decoder: true,
    encoder: true
};
module.exports.encoder = module.exports.decoder = void 0;

var $17be89d34683db38$var$decoder = $3sU9H((parcelRequire("9GTuw")));
module.exports.decoder = $17be89d34683db38$var$decoder;
Object.keys($17be89d34683db38$var$decoder).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($17be89d34683db38$var$_exportNames, key)) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $17be89d34683db38$var$decoder[key];
        }
    });
});

var $17be89d34683db38$var$encoder = $3sU9H((parcelRequire("bg2Aj")));
module.exports.encoder = $17be89d34683db38$var$encoder;
Object.keys($17be89d34683db38$var$encoder).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($17be89d34683db38$var$_exportNames, key)) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $17be89d34683db38$var$encoder[key];
        }
    });
});

});
parcelRegister("9GTuw", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $70e314b48c40e926$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeFieldNumberAndTyp3 = module.exports.unMarshalBinaryBare = module.exports.unMarshalBinaryLengthPrefixed = void 0;

var $70e314b48c40e926$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $70e314b48c40e926$var$_is_js = $2ZnTs((parcelRequire("2zdJh")));

var $2R6e4 = parcelRequire("2R6e4");

var $70e314b48c40e926$var$_encoderHelper = $2ZnTs((parcelRequire("aERsS")));
function $70e314b48c40e926$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $70e314b48c40e926$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $70e314b48c40e926$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $70e314b48c40e926$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $70e314b48c40e926$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $70e314b48c40e926$var$decoder = function decoder(bytes, varType) {
    var val = varType.decode(bytes, 0);
    var offset = varType.encodingLength(val);
    return {
        val: val,
        offset: offset
    };
};
/**
 * @category amino
 * js amino UnmarshalBinaryLengthPrefixed
 * @param {Buffer} bytes
 * @param {Object} type
 * @returns {Object}
 *  */ var $70e314b48c40e926$var$unMarshalBinaryLengthPrefixed = function unMarshalBinaryLengthPrefixed(bytes, type) {
    if (bytes.length === 0) throw new TypeError("Cannot decode empty bytes"); // read byte-length prefix
    var _decoder = $70e314b48c40e926$var$decoder(bytes, $2R6e4.varint), len = _decoder.offset;
    if (len < 0) throw new Error("Error reading msg byte-length prefix: got code ".concat(len));
    bytes = bytes.slice(len);
    return $70e314b48c40e926$var$unMarshalBinaryBare(bytes, type);
};
/**
 * @category amino
 * js amino UnmarshalBinaryBare
 * @param {Buffer} bytes
 * @param {Object} type
 * @returns {Object}
 *  */ module.exports.unMarshalBinaryLengthPrefixed = $70e314b48c40e926$var$unMarshalBinaryLengthPrefixed;
var $70e314b48c40e926$var$unMarshalBinaryBare = function unMarshalBinaryBare(bytes, type) {
    if (!$70e314b48c40e926$var$_is_js["default"].object(type)) throw new TypeError("type should be object");
    if (!$70e314b48c40e926$require$Buffer.isBuffer(bytes)) throw new TypeError("bytes must be buffer");
    if ($70e314b48c40e926$var$_is_js["default"].array(type)) {
        if (!$70e314b48c40e926$var$_is_js["default"].object(type[0])) throw new TypeError("type should be object");
        return $70e314b48c40e926$var$decodeArrayBinary(bytes, type[0]);
    }
    return $70e314b48c40e926$var$decodeBinary(bytes, type);
};
module.exports.unMarshalBinaryBare = $70e314b48c40e926$var$unMarshalBinaryBare;
var $70e314b48c40e926$var$decodeBinary = function decodeBinary(bytes, type, isLengthPrefixed) {
    if ($70e314b48c40e926$require$Buffer.isBuffer(type)) return $70e314b48c40e926$var$decoder(bytes, $2R6e4.bytes);
    if ($70e314b48c40e926$var$_is_js["default"].array(type)) return $70e314b48c40e926$var$decodeArrayBinary(bytes, type);
    if ($70e314b48c40e926$var$_is_js["default"].number(type)) return $70e314b48c40e926$var$decoder(bytes, $2R6e4.varint);
    if ($70e314b48c40e926$var$_is_js["default"]["boolean"](type)) return $70e314b48c40e926$var$decoder(bytes, $2R6e4.bool);
    if ($70e314b48c40e926$var$_is_js["default"].string(type)) return $70e314b48c40e926$var$decoder(bytes, $2R6e4.string);
    if ($70e314b48c40e926$var$_is_js["default"].object(type)) return $70e314b48c40e926$var$decodeObjectBinary(bytes, type, isLengthPrefixed);
    return;
};
var $70e314b48c40e926$var$setDefaultValue = function setDefaultValue(type, key) {
    if ($70e314b48c40e926$var$_is_js["default"].object(type[key])) type[key] = null;
    if ($70e314b48c40e926$var$_is_js["default"].number(type[key])) type[key] = 0;
    if ($70e314b48c40e926$var$_is_js["default"]["boolean"](type[key])) type[key] = false;
    if ($70e314b48c40e926$var$_is_js["default"].string(type[key])) type[key] = "";
};
var $70e314b48c40e926$var$decodeObjectBinary = function decodeObjectBinary(bytes, type, isLengthPrefixed) {
    var objectOffset = 0; // read byte-length prefix
    if (isLengthPrefixed) {
        var _decoder2 = $70e314b48c40e926$var$decoder(bytes, $2R6e4.varint), len = _decoder2.offset;
        bytes = bytes.slice(len);
        objectOffset += len;
    } // If registered concrete, consume and verify prefix bytes.
    if (type.aminoPrefix) {
        bytes = bytes.slice(4);
        objectOffset += 4;
    }
    var lastFieldNum = 0;
    var keys = Object.keys(type).filter(function(key) {
        return key !== "aminoPrefix";
    });
    keys.forEach(function(key, index) {
        if ($70e314b48c40e926$var$_is_js["default"].array(type[key])) {
            var _decodeArrayBinary = $70e314b48c40e926$var$decodeArrayBinary(bytes, type[key][0]), offset = _decodeArrayBinary.offset, val = _decodeArrayBinary.val;
            objectOffset += offset;
            type[key] = val;
            bytes = bytes.slice(offset);
        } else {
            var _decodeFieldNumberAnd = $70e314b48c40e926$var$decodeFieldNumberAndTyp3(bytes), fieldNum = _decodeFieldNumberAnd.fieldNum, typ = _decodeFieldNumberAnd.typ; //if this field is default value, continue
            if (index + 1 !== fieldNum || fieldNum < 0) {
                $70e314b48c40e926$var$setDefaultValue(type, key);
                return;
            }
            if (fieldNum <= lastFieldNum) throw new Error("encountered fieldNum: ".concat(fieldNum, ", but we have already seen fnum: ").concat(lastFieldNum));
            lastFieldNum = fieldNum;
            if (index + 1 !== fieldNum) throw new Error("field number is not expected");
            var typeWanted = (0, $70e314b48c40e926$var$_encoderHelper["default"])(type[key]);
            if (typ !== typeWanted) throw new Error("field type is not expected");
             //remove 1 byte of type
            bytes = bytes.slice(1);
            var _decodeBinary = $70e314b48c40e926$var$decodeBinary(bytes, type[key], true), _val = _decodeBinary.val, _offset = _decodeBinary.offset;
            type[key] = _val; //remove decoded bytes
            bytes = bytes.slice(_offset);
            objectOffset += _offset + 1;
        }
    });
    return {
        val: type,
        offset: objectOffset
    };
};
var $70e314b48c40e926$var$decodeArrayBinary = function decodeArrayBinary(bytes, type) {
    var arr = [];
    var arrayOffset = 0;
    var _decodeFieldNumberAnd2 = $70e314b48c40e926$var$decodeFieldNumberAndTyp3(bytes), fieldNumber = _decodeFieldNumberAnd2.fieldNum;
    while(true){
        var _decodeFieldNumberAnd3 = $70e314b48c40e926$var$decodeFieldNumberAndTyp3(bytes), fieldNum = _decodeFieldNumberAnd3.fieldNum;
        if (fieldNum !== fieldNumber || fieldNum < 0) break; //remove 1 byte of encoded field number and type
        bytes = bytes.slice(1); //is default value, skip and continue read bytes
        // if (bytes.length > 0 && bytes[0] === 0x00) continue
        if (bytes.length > 0 && bytes.readUInt8(0) === 0x00) continue;
        var _decodeBinary2 = $70e314b48c40e926$var$decodeBinary(bytes, type, true), offset = _decodeBinary2.offset, val = _decodeBinary2.val;
        arr.push($70e314b48c40e926$var$_objectSpread({}, val));
        bytes = bytes.slice(offset + 1); //add 1 byte of type
        arrayOffset += offset + 1;
        fieldNumber = fieldNum;
    } // console.log(arr)
    return {
        val: arr,
        offset: arrayOffset
    };
};
var $70e314b48c40e926$var$decodeFieldNumberAndTyp3 = function decodeFieldNumberAndTyp3(bytes) {
    if (bytes.length < 2) //default value
    return {
        fieldNum: -1
    };
    var _decoder3 = $70e314b48c40e926$var$decoder(bytes, $2R6e4.varint), val = _decoder3.val;
    var typ = val & 7;
    var fieldNum = val >> 3;
    if (fieldNum > 268435456) throw new Error("invalid field num ".concat(fieldNum));
    return {
        fieldNum: fieldNum,
        typ: typ
    };
};
module.exports.decodeFieldNumberAndTyp3 = $70e314b48c40e926$var$decodeFieldNumberAndTyp3;

});
parcelRegister("jqdsN", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $e23ae39501459ba4$var$_defineProperty(obj, key, value) {
    key = $7keJs(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
module.exports = $e23ae39501459ba4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("7keJs", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $5555d428bd3bf37b$var$_typeof = $crtHL.default;

var $2PEUm = parcelRequire("2PEUm");
function $5555d428bd3bf37b$var$_toPropertyKey(arg) {
    var key = $2PEUm(arg, "string");
    return $5555d428bd3bf37b$var$_typeof(key) === "symbol" ? key : String(key);
}
module.exports = $5555d428bd3bf37b$var$_toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2PEUm", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $210013a7b1d5e66c$var$_typeof = $crtHL.default;
function $210013a7b1d5e66c$var$_toPrimitive(input, hint) {
    if ($210013a7b1d5e66c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($210013a7b1d5e66c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
module.exports = $210013a7b1d5e66c$var$_toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("2zdJh", function(module, exports) {
/*!
 * is.js 0.8.0
 * Author: Aras Atasaygin
 */ // AMD with global, Node, or global
(function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        // Also create a global in case some scripts
        // that are loaded still are looking for
        // a global even when an AMD loader is in use.
        return root.is = factory();
    });
    else // Node. Does not work with strict CommonJS, but
    // only CommonJS-like enviroments that support module.exports,
    // like Node.
    module.exports = factory();
})(module.exports, function() {
    // Baseline
    /* -------------------------------------------------------------------------- */ // define 'is' object and current version
    var is = {};
    is.VERSION = "0.8.0";
    // define interfaces
    is.not = {};
    is.all = {};
    is.any = {};
    // cache some methods to call later on
    var toString = Object.prototype.toString;
    var slice = Array.prototype.slice;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    // helper function which reverses the sense of predicate result
    function not(func) {
        return function() {
            return !func.apply(null, slice.call(arguments));
        };
    }
    // helper function which call predicate function per parameter and return true if all pass
    function all(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for(var i = 0; i < length; i++){
                if (!func.call(null, params[i])) return false;
            }
            return true;
        };
    }
    // helper function which call predicate function per parameter and return true if any pass
    function any(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for(var i = 0; i < length; i++){
                if (func.call(null, params[i])) return true;
            }
            return false;
        };
    }
    // build a 'comparator' object for various comparison checks
    var comparator = {
        "<": function(a, b) {
            return a < b;
        },
        "<=": function(a, b) {
            return a <= b;
        },
        ">": function(a, b) {
            return a > b;
        },
        ">=": function(a, b) {
            return a >= b;
        }
    };
    // helper function which compares a version to a range
    function compareVersion(version, range) {
        var string = range + "";
        var n = +(string.match(/\d+/) || NaN);
        var op = string.match(/^[<>]=?|/)[0];
        return comparator[op] ? comparator[op](version, n) : version == n || n !== n;
    }
    // helper function which extracts params from arguments
    function getParams(args) {
        var params = slice.call(args);
        var length = params.length;
        if (length === 1 && is.array(params[0])) params = params[0];
        return params;
    }
    // Type checks
    /* -------------------------------------------------------------------------- */ // is a given value Arguments?
    is.arguments = function(value) {
        return toString.call(value) === "[object Arguments]" || value != null && typeof value === "object" && "callee" in value;
    };
    // is a given value Array?
    is.array = Array.isArray || function(value) {
        return toString.call(value) === "[object Array]";
    };
    // is a given value Boolean?
    is.boolean = function(value) {
        return value === true || value === false || toString.call(value) === "[object Boolean]";
    };
    // is a given value Char?
    is.char = function(value) {
        return is.string(value) && value.length === 1;
    };
    // is a given value Date Object?
    is.date = function(value) {
        return toString.call(value) === "[object Date]";
    };
    // is a given object a DOM node?
    is.domNode = function(object) {
        return is.object(object) && object.nodeType > 0;
    };
    // is a given value Error object?
    is.error = function(value) {
        return toString.call(value) === "[object Error]";
    };
    // is a given value function?
    is["function"] = function(value) {
        return toString.call(value) === "[object Function]" || typeof value === "function";
    };
    // is given value a pure JSON object?
    is.json = function(value) {
        return toString.call(value) === "[object Object]";
    };
    // is a given value NaN?
    is.nan = function(value) {
        return value !== value;
    };
    // is a given value null?
    is["null"] = function(value) {
        return value === null;
    };
    // is a given value number?
    is.number = function(value) {
        return is.not.nan(value) && toString.call(value) === "[object Number]";
    };
    // is a given value object?
    is.object = function(value) {
        return Object(value) === value;
    };
    // is a given value RegExp?
    is.regexp = function(value) {
        return toString.call(value) === "[object RegExp]";
    };
    // are given values same type?
    // prevent NaN, Number same type check
    is.sameType = function(value, other) {
        var tag = toString.call(value);
        if (tag !== toString.call(other)) return false;
        if (tag === "[object Number]") return !is.any.nan(value, other) || is.all.nan(value, other);
        return true;
    };
    // sameType method does not support 'all' and 'any' interfaces
    is.sameType.api = [
        "not"
    ];
    // is a given value String?
    is.string = function(value) {
        return toString.call(value) === "[object String]";
    };
    // is a given value undefined?
    is.undefined = function(value) {
        return value === void 0;
    };
    // is a given value window?
    // setInterval method is only available for window object
    is.windowObject = function(value) {
        return value != null && typeof value === "object" && "setInterval" in value;
    };
    // Presence checks
    /* -------------------------------------------------------------------------- */ //is a given value empty? Objects, arrays, strings
    is.empty = function(value) {
        if (is.object(value)) {
            var length = Object.getOwnPropertyNames(value).length;
            if (length === 0 || length === 1 && is.array(value) || length === 2 && is.arguments(value)) return true;
            return false;
        }
        return value === "";
    };
    // is a given value existy?
    is.existy = function(value) {
        return value != null;
    };
    // is a given value falsy?
    is.falsy = function(value) {
        return !value;
    };
    // is a given value truthy?
    is.truthy = not(is.falsy);
    // Arithmetic checks
    /* -------------------------------------------------------------------------- */ // is a given number above minimum parameter?
    is.above = function(n, min) {
        return is.all.number(n, min) && n > min;
    };
    // above method does not support 'all' and 'any' interfaces
    is.above.api = [
        "not"
    ];
    // is a given number decimal?
    is.decimal = function(n) {
        return is.number(n) && n % 1 !== 0;
    };
    // are given values equal? supports numbers, strings, regexes, booleans
    // TODO: Add object and array support
    is.equal = function(value, other) {
        // check 0 and -0 equity with Infinity and -Infinity
        if (is.all.number(value, other)) return value === other && 1 / value === 1 / other;
        // check regexes as strings too
        if (is.all.string(value, other) || is.all.regexp(value, other)) return "" + value === "" + other;
        if (is.all.boolean(value, other)) return value === other;
        return false;
    };
    // equal method does not support 'all' and 'any' interfaces
    is.equal.api = [
        "not"
    ];
    // is a given number even?
    is.even = function(n) {
        return is.number(n) && n % 2 === 0;
    };
    // is a given number finite?
    is.finite = isFinite || function(n) {
        return is.not.infinite(n) && is.not.nan(n);
    };
    // is a given number infinite?
    is.infinite = function(n) {
        return n === Infinity || n === -Infinity;
    };
    // is a given number integer?
    is.integer = function(n) {
        return is.number(n) && n % 1 === 0;
    };
    // is a given number negative?
    is.negative = function(n) {
        return is.number(n) && n < 0;
    };
    // is a given number odd?
    is.odd = function(n) {
        return is.number(n) && n % 2 === 1;
    };
    // is a given number positive?
    is.positive = function(n) {
        return is.number(n) && n > 0;
    };
    // is a given number above maximum parameter?
    is.under = function(n, max) {
        return is.all.number(n, max) && n < max;
    };
    // least method does not support 'all' and 'any' interfaces
    is.under.api = [
        "not"
    ];
    // is a given number within minimum and maximum parameters?
    is.within = function(n, min, max) {
        return is.all.number(n, min, max) && n > min && n < max;
    };
    // within method does not support 'all' and 'any' interfaces
    is.within.api = [
        "not"
    ];
    // Regexp checks
    /* -------------------------------------------------------------------------- */ // Steven Levithan, Jan Goyvaerts: Regular Expressions Cookbook
    // Scott Gonzalez: Email address validation
    // dateString match m/d/yy and mm/dd/yyyy, allowing any combination of one or two digits for the day and month, and two or four digits for the year
    // eppPhone match extensible provisioning protocol format
    // nanpPhone match north american number plan format
    // time match hours, minutes, and seconds, 24-hour clock
    var regexes = {
        affirmative: /^(?:1|t(?:rue)?|y(?:es)?|ok(?:ay)?)$/,
        alphaNumeric: /^[A-Za-z0-9]+$/,
        caPostalCode: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\s?[0-9][A-Z][0-9]$/,
        creditCard: /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/,
        dateString: /^(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])(?:\2)(?:[0-9]{2})?[0-9]{2}$/,
        email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i,
        eppPhone: /^\+[0-9]{1,3}\.[0-9]{4,14}(?:x.+)?$/,
        hexadecimal: /^(?:0x)?[0-9a-fA-F]+$/,
        hexColor: /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
        ipv4: /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/,
        ipv6: /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i,
        nanpPhone: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        socialSecurityNumber: /^(?!000|666)[0-8][0-9]{2}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4}$/,
        timeString: /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/,
        ukPostCode: /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/,
        url: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i,
        usZipCode: /^[0-9]{5}(?:-[0-9]{4})?$/
    };
    function regexpCheck(regexp, regexes) {
        is[regexp] = function(value) {
            return regexes[regexp].test(value);
        };
    }
    // create regexp checks methods from 'regexes' object
    for(var regexp in regexes)if (regexes.hasOwnProperty(regexp)) regexpCheck(regexp, regexes);
    // simplify IP checks by calling the regex helpers for IPv4 and IPv6
    is.ip = function(value) {
        return is.ipv4(value) || is.ipv6(value);
    };
    // String checks
    /* -------------------------------------------------------------------------- */ // is a given string or sentence capitalized?
    is.capitalized = function(string) {
        if (is.not.string(string)) return false;
        var words = string.split(" ");
        for(var i = 0; i < words.length; i++){
            var word = words[i];
            if (word.length) {
                var chr = word.charAt(0);
                if (chr !== chr.toUpperCase()) return false;
            }
        }
        return true;
    };
    // is string end with a given target parameter?
    is.endWith = function(string, target) {
        if (is.not.string(string)) return false;
        target += "";
        var position = string.length - target.length;
        return position >= 0 && string.indexOf(target, position) === position;
    };
    // endWith method does not support 'all' and 'any' interfaces
    is.endWith.api = [
        "not"
    ];
    // is a given string include parameter target?
    is.include = function(string, target) {
        return string.indexOf(target) > -1;
    };
    // include method does not support 'all' and 'any' interfaces
    is.include.api = [
        "not"
    ];
    // is a given string all lowercase?
    is.lowerCase = function(string) {
        return is.string(string) && string === string.toLowerCase();
    };
    // is a given string palindrome?
    is.palindrome = function(string) {
        if (is.not.string(string)) return false;
        string = string.replace(/[^a-zA-Z0-9]+/g, "").toLowerCase();
        var length = string.length - 1;
        for(var i = 0, half = Math.floor(length / 2); i <= half; i++){
            if (string.charAt(i) !== string.charAt(length - i)) return false;
        }
        return true;
    };
    // is a given value space?
    // horizantal tab: 9, line feed: 10, vertical tab: 11, form feed: 12, carriage return: 13, space: 32
    is.space = function(value) {
        if (is.not.char(value)) return false;
        var charCode = value.charCodeAt(0);
        return charCode > 8 && charCode < 14 || charCode === 32;
    };
    // is string start with a given target parameter?
    is.startWith = function(string, target) {
        return is.string(string) && string.indexOf(target) === 0;
    };
    // startWith method does not support 'all' and 'any' interfaces
    is.startWith.api = [
        "not"
    ];
    // is a given string all uppercase?
    is.upperCase = function(string) {
        return is.string(string) && string === string.toUpperCase();
    };
    // Time checks
    /* -------------------------------------------------------------------------- */ var days = [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
    ];
    var months = [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december"
    ];
    // is a given dates day equal given day parameter?
    is.day = function(date, day) {
        return is.date(date) && day.toLowerCase() === days[date.getDay()];
    };
    // day method does not support 'all' and 'any' interfaces
    is.day.api = [
        "not"
    ];
    // is a given date in daylight saving time?
    is.dayLightSavingTime = function(date) {
        var january = new Date(date.getFullYear(), 0, 1);
        var july = new Date(date.getFullYear(), 6, 1);
        var stdTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
        return date.getTimezoneOffset() < stdTimezoneOffset;
    };
    // is a given date future?
    is.future = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() > now.getTime();
    };
    // is date within given range?
    is.inDateRange = function(date, start, end) {
        if (is.not.date(date) || is.not.date(start) || is.not.date(end)) return false;
        var stamp = date.getTime();
        return stamp > start.getTime() && stamp < end.getTime();
    };
    // inDateRange method does not support 'all' and 'any' interfaces
    is.inDateRange.api = [
        "not"
    ];
    // is a given date in last month range?
    is.inLastMonth = function(date) {
        return is.inDateRange(date, new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date());
    };
    // is a given date in last week range?
    is.inLastWeek = function(date) {
        return is.inDateRange(date, new Date(new Date().setDate(new Date().getDate() - 7)), new Date());
    };
    // is a given date in last year range?
    is.inLastYear = function(date) {
        return is.inDateRange(date, new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date());
    };
    // is a given date in next month range?
    is.inNextMonth = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setMonth(new Date().getMonth() + 1)));
    };
    // is a given date in next week range?
    is.inNextWeek = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setDate(new Date().getDate() + 7)));
    };
    // is a given date in next year range?
    is.inNextYear = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
    };
    // is the given year a leap year?
    is.leapYear = function(year) {
        return is.number(year) && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    };
    // is a given dates month equal given month parameter?
    is.month = function(date, month) {
        return is.date(date) && month.toLowerCase() === months[date.getMonth()];
    };
    // month method does not support 'all' and 'any' interfaces
    is.month.api = [
        "not"
    ];
    // is a given date past?
    is.past = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() < now.getTime();
    };
    // is a given date in the parameter quarter?
    is.quarterOfYear = function(date, quarter) {
        return is.date(date) && is.number(quarter) && quarter === Math.floor((date.getMonth() + 3) / 3);
    };
    // quarterOfYear method does not support 'all' and 'any' interfaces
    is.quarterOfYear.api = [
        "not"
    ];
    // is a given date indicate today?
    is.today = function(date) {
        var now = new Date();
        var todayString = now.toDateString();
        return is.date(date) && date.toDateString() === todayString;
    };
    // is a given date indicate tomorrow?
    is.tomorrow = function(date) {
        var now = new Date();
        var tomorrowString = new Date(now.setDate(now.getDate() + 1)).toDateString();
        return is.date(date) && date.toDateString() === tomorrowString;
    };
    // is a given date weekend?
    // 6: Saturday, 0: Sunday
    is.weekend = function(date) {
        return is.date(date) && (date.getDay() === 6 || date.getDay() === 0);
    };
    // is a given date weekday?
    is.weekday = not(is.weekend);
    // is a given dates year equal given year parameter?
    is.year = function(date, year) {
        return is.date(date) && is.number(year) && year === date.getFullYear();
    };
    // year method does not support 'all' and 'any' interfaces
    is.year.api = [
        "not"
    ];
    // is a given date indicate yesterday?
    is.yesterday = function(date) {
        var now = new Date();
        var yesterdayString = new Date(now.setDate(now.getDate() - 1)).toDateString();
        return is.date(date) && date.toDateString() === yesterdayString;
    };
    // Environment checks
    /* -------------------------------------------------------------------------- */ var freeGlobal = is.windowObject(typeof $parcel$global == "object" && $parcel$global) && $parcel$global;
    var freeSelf = is.windowObject(typeof self == "object" && self) && self;
    var thisGlobal = is.windowObject(typeof this == "object" && this) && this;
    var root = freeGlobal || freeSelf || thisGlobal || Function("return this")();
    var document = freeSelf && freeSelf.document;
    var previousIs = root.is;
    // store navigator properties to use later
    var navigator = freeSelf && freeSelf.navigator;
    var appVersion = (navigator && navigator.appVersion || "").toLowerCase();
    var userAgent = (navigator && navigator.userAgent || "").toLowerCase();
    var vendor = (navigator && navigator.vendor || "").toLowerCase();
    // is current device android?
    is.android = function() {
        return /android/.test(userAgent);
    };
    // android method does not support 'all' and 'any' interfaces
    is.android.api = [
        "not"
    ];
    // is current device android phone?
    is.androidPhone = function() {
        return /android/.test(userAgent) && /mobile/.test(userAgent);
    };
    // androidPhone method does not support 'all' and 'any' interfaces
    is.androidPhone.api = [
        "not"
    ];
    // is current device android tablet?
    is.androidTablet = function() {
        return /android/.test(userAgent) && !/mobile/.test(userAgent);
    };
    // androidTablet method does not support 'all' and 'any' interfaces
    is.androidTablet.api = [
        "not"
    ];
    // is current device blackberry?
    is.blackberry = function() {
        return /blackberry/.test(userAgent) || /bb10/.test(userAgent);
    };
    // blackberry method does not support 'all' and 'any' interfaces
    is.blackberry.api = [
        "not"
    ];
    // is current browser chrome?
    // parameter is optional
    is.chrome = function(range) {
        var match = /google inc/.test(vendor) ? userAgent.match(/(?:chrome|crios)\/(\d+)/) : null;
        return match !== null && compareVersion(match[1], range);
    };
    // chrome method does not support 'all' and 'any' interfaces
    is.chrome.api = [
        "not"
    ];
    // is current device desktop?
    is.desktop = function() {
        return is.not.mobile() && is.not.tablet();
    };
    // desktop method does not support 'all' and 'any' interfaces
    is.desktop.api = [
        "not"
    ];
    // is current browser edge?
    // parameter is optional
    is.edge = function(range) {
        var match = userAgent.match(/edge\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // edge method does not support 'all' and 'any' interfaces
    is.edge.api = [
        "not"
    ];
    // is current browser firefox?
    // parameter is optional
    is.firefox = function(range) {
        var match = userAgent.match(/(?:firefox|fxios)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // firefox method does not support 'all' and 'any' interfaces
    is.firefox.api = [
        "not"
    ];
    // is current browser internet explorer?
    // parameter is optional
    is.ie = function(range) {
        var match = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ie method does not support 'all' and 'any' interfaces
    is.ie.api = [
        "not"
    ];
    // is current device ios?
    is.ios = function() {
        return is.iphone() || is.ipad() || is.ipod();
    };
    // ios method does not support 'all' and 'any' interfaces
    is.ios.api = [
        "not"
    ];
    // is current device ipad?
    // parameter is optional
    is.ipad = function(range) {
        var match = userAgent.match(/ipad.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipad method does not support 'all' and 'any' interfaces
    is.ipad.api = [
        "not"
    ];
    // is current device iphone?
    // parameter is optional
    is.iphone = function(range) {
        // original iPhone doesn't have the os portion of the UA
        var match = userAgent.match(/iphone(?:.+?os (\d+))?/);
        return match !== null && compareVersion(match[1] || 1, range);
    };
    // iphone method does not support 'all' and 'any' interfaces
    is.iphone.api = [
        "not"
    ];
    // is current device ipod?
    // parameter is optional
    is.ipod = function(range) {
        var match = userAgent.match(/ipod.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipod method does not support 'all' and 'any' interfaces
    is.ipod.api = [
        "not"
    ];
    // is current operating system linux?
    is.linux = function() {
        return /linux/.test(appVersion);
    };
    // linux method does not support 'all' and 'any' interfaces
    is.linux.api = [
        "not"
    ];
    // is current operating system mac?
    is.mac = function() {
        return /mac/.test(appVersion);
    };
    // mac method does not support 'all' and 'any' interfaces
    is.mac.api = [
        "not"
    ];
    // is current device mobile?
    is.mobile = function() {
        return is.iphone() || is.ipod() || is.androidPhone() || is.blackberry() || is.windowsPhone();
    };
    // mobile method does not support 'all' and 'any' interfaces
    is.mobile.api = [
        "not"
    ];
    // is current state offline?
    is.offline = not(is.online);
    // offline method does not support 'all' and 'any' interfaces
    is.offline.api = [
        "not"
    ];
    // is current state online?
    is.online = function() {
        return !navigator || navigator.onLine === true;
    };
    // online method does not support 'all' and 'any' interfaces
    is.online.api = [
        "not"
    ];
    // is current browser opera?
    // parameter is optional
    is.opera = function(range) {
        var match = userAgent.match(/(?:^opera.+?version|opr)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // opera method does not support 'all' and 'any' interfaces
    is.opera.api = [
        "not"
    ];
    // is current browser phantomjs?
    // parameter is optional
    is.phantom = function(range) {
        var match = userAgent.match(/phantomjs\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // phantom method does not support 'all' and 'any' interfaces
    is.phantom.api = [
        "not"
    ];
    // is current browser safari?
    // parameter is optional
    is.safari = function(range) {
        var match = userAgent.match(/version\/(\d+).+?safari/);
        return match !== null && compareVersion(match[1], range);
    };
    // safari method does not support 'all' and 'any' interfaces
    is.safari.api = [
        "not"
    ];
    // is current device tablet?
    is.tablet = function() {
        return is.ipad() || is.androidTablet() || is.windowsTablet();
    };
    // tablet method does not support 'all' and 'any' interfaces
    is.tablet.api = [
        "not"
    ];
    // is current device supports touch?
    is.touchDevice = function() {
        return !!document && ("ontouchstart" in freeSelf || "DocumentTouch" in freeSelf && document instanceof DocumentTouch);
    };
    // touchDevice method does not support 'all' and 'any' interfaces
    is.touchDevice.api = [
        "not"
    ];
    // is current operating system windows?
    is.windows = function() {
        return /win/.test(appVersion);
    };
    // windows method does not support 'all' and 'any' interfaces
    is.windows.api = [
        "not"
    ];
    // is current device windows phone?
    is.windowsPhone = function() {
        return is.windows() && /phone/.test(userAgent);
    };
    // windowsPhone method does not support 'all' and 'any' interfaces
    is.windowsPhone.api = [
        "not"
    ];
    // is current device windows tablet?
    is.windowsTablet = function() {
        return is.windows() && is.not.windowsPhone() && /touch/.test(userAgent);
    };
    // windowsTablet method does not support 'all' and 'any' interfaces
    is.windowsTablet.api = [
        "not"
    ];
    // Object checks
    /* -------------------------------------------------------------------------- */ // has a given object got parameterized count property?
    is.propertyCount = function(object, count) {
        if (is.not.object(object) || is.not.number(count)) return false;
        var n = 0;
        for(var property in object){
            if (hasOwnProperty.call(object, property) && ++n > count) return false;
        }
        return n === count;
    };
    // propertyCount method does not support 'all' and 'any' interfaces
    is.propertyCount.api = [
        "not"
    ];
    // is given object has parameterized property?
    is.propertyDefined = function(object, property) {
        return is.object(object) && is.string(property) && property in object;
    };
    // propertyDefined method does not support 'all' and 'any' interfaces
    is.propertyDefined.api = [
        "not"
    ];
    // Array checks
    /* -------------------------------------------------------------------------- */ // is a given item in an array?
    is.inArray = function(value, array) {
        if (is.not.array(array)) return false;
        for(var i = 0; i < array.length; i++){
            if (array[i] === value) return true;
        }
        return false;
    };
    // inArray method does not support 'all' and 'any' interfaces
    is.inArray.api = [
        "not"
    ];
    // is a given array sorted?
    is.sorted = function(array, sign) {
        if (is.not.array(array)) return false;
        var predicate = comparator[sign] || comparator[">="];
        for(var i = 1; i < array.length; i++){
            if (!predicate(array[i], array[i - 1])) return false;
        }
        return true;
    };
    // API
    // Set 'not', 'all' and 'any' interfaces to methods based on their api property
    /* -------------------------------------------------------------------------- */ function setInterfaces() {
        var options = is;
        for(var option in options)if (hasOwnProperty.call(options, option) && is["function"](options[option])) {
            var interfaces = options[option].api || [
                "not",
                "all",
                "any"
            ];
            for(var i = 0; i < interfaces.length; i++){
                if (interfaces[i] === "not") is.not[option] = not(is[option]);
                if (interfaces[i] === "all") is.all[option] = all(is[option]);
                if (interfaces[i] === "any") is.any[option] = any(is[option]);
            }
        }
    }
    setInterfaces();
    // Configuration methods
    // Intentionally added after setInterfaces function
    /* -------------------------------------------------------------------------- */ // change namespace of library to prevent name collisions
    // var preferredName = is.setNamespace();
    // preferredName.odd(3);
    // => true
    is.setNamespace = function() {
        root.is = previousIs;
        return this;
    };
    // set optional regexes to methods
    is.setRegexp = function(regexp, name) {
        for(var r in regexes)if (hasOwnProperty.call(regexes, r) && name === r) regexes[r] = regexp;
    };
    return is;
});

});

parcelRegister("2R6e4", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $21455c555af0c6a9$require$Buffer = $ihoyg.Buffer;

var $jFGxN = parcelRequire("jFGxN");

var $sBuD1 = parcelRequire("sBuD1");
module.exports.make = $21455c555af0c6a9$var$encoder;
module.exports.name = function(enc) {
    var keys = Object.keys(module.exports);
    for(var i = 0; i < keys.length; i++){
        if (module.exports[keys[i]] === enc) return keys[i];
    }
    return null;
};
module.exports.skip = function(type, buffer, offset) {
    switch(type){
        case 0:
            $jFGxN.decode(buffer, offset);
            return offset + $jFGxN.decode.bytes;
        case 1:
            return offset + 8;
        case 2:
            var len = $jFGxN.decode(buffer, offset);
            return offset + $jFGxN.decode.bytes + len;
        case 3:
        case 4:
            throw new Error("Groups are not supported");
        case 5:
            return offset + 4;
    }
    throw new Error("Unknown wire type: " + type);
};
module.exports.bytes = $21455c555af0c6a9$var$encoder(2, function encode(val, buffer, offset) {
    var oldOffset = offset;
    var len = $21455c555af0c6a9$var$bufferLength(val);
    $jFGxN.encode(len, buffer, offset);
    offset += $jFGxN.encode.bytes;
    if ($21455c555af0c6a9$require$Buffer.isBuffer(val)) val.copy(buffer, offset);
    else buffer.write(val, offset, len);
    offset += len;
    encode.bytes = offset - oldOffset;
    return buffer;
}, function decode(buffer, offset) {
    var oldOffset = offset;
    var len = $jFGxN.decode(buffer, offset);
    offset += $jFGxN.decode.bytes;
    var val = buffer.slice(offset, offset + len);
    offset += val.length;
    decode.bytes = offset - oldOffset;
    return val;
}, function encodingLength(val) {
    var len = $21455c555af0c6a9$var$bufferLength(val);
    return $jFGxN.encodingLength(len) + len;
});
module.exports.string = $21455c555af0c6a9$var$encoder(2, function encode(val, buffer, offset) {
    var oldOffset = offset;
    var len = $21455c555af0c6a9$require$Buffer.byteLength(val);
    $jFGxN.encode(len, buffer, offset, "utf-8");
    offset += $jFGxN.encode.bytes;
    buffer.write(val, offset, len);
    offset += len;
    encode.bytes = offset - oldOffset;
    return buffer;
}, function decode(buffer, offset) {
    var oldOffset = offset;
    var len = $jFGxN.decode(buffer, offset);
    offset += $jFGxN.decode.bytes;
    var val = buffer.toString("utf-8", offset, offset + len);
    offset += len;
    decode.bytes = offset - oldOffset;
    return val;
}, function encodingLength(val) {
    var len = $21455c555af0c6a9$require$Buffer.byteLength(val);
    return $jFGxN.encodingLength(len) + len;
});
module.exports.bool = $21455c555af0c6a9$var$encoder(0, function encode(val, buffer, offset) {
    buffer[offset] = val ? 1 : 0;
    encode.bytes = 1;
    return buffer;
}, function decode(buffer, offset) {
    var bool = buffer[offset] > 0;
    decode.bytes = 1;
    return bool;
}, function encodingLength() {
    return 1;
});
module.exports.int32 = $21455c555af0c6a9$var$encoder(0, function encode(val, buffer, offset) {
    $jFGxN.encode(val < 0 ? val + 4294967296 : val, buffer, offset);
    encode.bytes = $jFGxN.encode.bytes;
    return buffer;
}, function decode(buffer, offset) {
    var val = $jFGxN.decode(buffer, offset);
    decode.bytes = $jFGxN.decode.bytes;
    return val > 2147483647 ? val - 4294967296 : val;
}, function encodingLength(val) {
    return $jFGxN.encodingLength(val < 0 ? val + 4294967296 : val);
});
module.exports.int64 = $21455c555af0c6a9$var$encoder(0, function encode(val, buffer, offset) {
    if (val < 0) {
        var last = offset + 9;
        $jFGxN.encode(val * -1, buffer, offset);
        offset += $jFGxN.encode.bytes - 1;
        buffer[offset] = buffer[offset] | 0x80;
        while(offset < last - 1){
            offset++;
            buffer[offset] = 0xff;
        }
        buffer[last] = 0x01;
        encode.bytes = 10;
    } else {
        $jFGxN.encode(val, buffer, offset);
        encode.bytes = $jFGxN.encode.bytes;
    }
    return buffer;
}, function decode(buffer, offset) {
    var val = $jFGxN.decode(buffer, offset);
    if (val >= Math.pow(2, 63)) {
        var limit = 9;
        while(buffer[offset + limit - 1] === 0xff)limit--;
        limit = limit || 9;
        var subset = $21455c555af0c6a9$require$Buffer.allocUnsafe(limit);
        buffer.copy(subset, 0, offset, offset + limit);
        subset[limit - 1] = subset[limit - 1] & 0x7f;
        val = -1 * $jFGxN.decode(subset, 0);
        decode.bytes = 10;
    } else decode.bytes = $jFGxN.decode.bytes;
    return val;
}, function encodingLength(val) {
    return val < 0 ? 10 : $jFGxN.encodingLength(val);
});
module.exports.sint32 = module.exports.sint64 = $21455c555af0c6a9$var$encoder(0, $sBuD1.encode, $sBuD1.decode, $sBuD1.encodingLength);
module.exports.uint32 = module.exports.uint64 = module.exports.enum = module.exports.varint = $21455c555af0c6a9$var$encoder(0, $jFGxN.encode, $jFGxN.decode, $jFGxN.encodingLength);
// we cannot represent these in javascript so we just use buffers
module.exports.fixed64 = module.exports.sfixed64 = $21455c555af0c6a9$var$encoder(1, function encode(val, buffer, offset) {
    val.copy(buffer, offset);
    encode.bytes = 8;
    return buffer;
}, function decode(buffer, offset) {
    var val = buffer.slice(offset, offset + 8);
    decode.bytes = 8;
    return val;
}, function encodingLength() {
    return 8;
});
module.exports.double = $21455c555af0c6a9$var$encoder(1, function encode(val, buffer, offset) {
    buffer.writeDoubleLE(val, offset);
    encode.bytes = 8;
    return buffer;
}, function decode(buffer, offset) {
    var val = buffer.readDoubleLE(offset);
    decode.bytes = 8;
    return val;
}, function encodingLength() {
    return 8;
});
module.exports.fixed32 = $21455c555af0c6a9$var$encoder(5, function encode(val, buffer, offset) {
    buffer.writeUInt32LE(val, offset);
    encode.bytes = 4;
    return buffer;
}, function decode(buffer, offset) {
    var val = buffer.readUInt32LE(offset);
    decode.bytes = 4;
    return val;
}, function encodingLength() {
    return 4;
});
module.exports.sfixed32 = $21455c555af0c6a9$var$encoder(5, function encode(val, buffer, offset) {
    buffer.writeInt32LE(val, offset);
    encode.bytes = 4;
    return buffer;
}, function decode(buffer, offset) {
    var val = buffer.readInt32LE(offset);
    decode.bytes = 4;
    return val;
}, function encodingLength() {
    return 4;
});
module.exports.float = $21455c555af0c6a9$var$encoder(5, function encode(val, buffer, offset) {
    buffer.writeFloatLE(val, offset);
    encode.bytes = 4;
    return buffer;
}, function decode(buffer, offset) {
    var val = buffer.readFloatLE(offset);
    decode.bytes = 4;
    return val;
}, function encodingLength() {
    return 4;
});
function $21455c555af0c6a9$var$encoder(type, encode, decode, encodingLength) {
    encode.bytes = decode.bytes = 0;
    return {
        type: type,
        encode: encode,
        decode: decode,
        encodingLength: encodingLength
    };
}
function $21455c555af0c6a9$var$bufferLength(val) {
    return $21455c555af0c6a9$require$Buffer.isBuffer(val) ? val.length : $21455c555af0c6a9$require$Buffer.byteLength(val);
}

});
parcelRegister("jFGxN", function(module, exports) {



module.exports = {
    encode: (parcelRequire("7K6mb")),
    decode: (parcelRequire("c5mHt")),
    encodingLength: (parcelRequire("gYrnS"))
};

});
parcelRegister("7K6mb", function(module, exports) {
module.exports = $5a31c295e25e0d6e$var$encode;
var $5a31c295e25e0d6e$var$MSB = 0x80, $5a31c295e25e0d6e$var$REST = 0x7F, $5a31c295e25e0d6e$var$MSBALL = ~$5a31c295e25e0d6e$var$REST, $5a31c295e25e0d6e$var$INT = Math.pow(2, 31);
function $5a31c295e25e0d6e$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $5a31c295e25e0d6e$var$INT){
        out[offset++] = num & 0xFF | $5a31c295e25e0d6e$var$MSB;
        num /= 128;
    }
    while(num & $5a31c295e25e0d6e$var$MSBALL){
        out[offset++] = num & 0xFF | $5a31c295e25e0d6e$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $5a31c295e25e0d6e$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRegister("c5mHt", function(module, exports) {
module.exports = $8cc78f6ef3d68b00$var$read;
var $8cc78f6ef3d68b00$var$MSB = 0x80, $8cc78f6ef3d68b00$var$REST = 0x7F;
function $8cc78f6ef3d68b00$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $8cc78f6ef3d68b00$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $8cc78f6ef3d68b00$var$REST) << shift : (b & $8cc78f6ef3d68b00$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $8cc78f6ef3d68b00$var$MSB);
    $8cc78f6ef3d68b00$var$read.bytes = counter - offset;
    return res;
}

});

parcelRegister("gYrnS", function(module, exports) {
var $c5b77ddc6b77feb7$var$N1 = Math.pow(2, 7);
var $c5b77ddc6b77feb7$var$N2 = Math.pow(2, 14);
var $c5b77ddc6b77feb7$var$N3 = Math.pow(2, 21);
var $c5b77ddc6b77feb7$var$N4 = Math.pow(2, 28);
var $c5b77ddc6b77feb7$var$N5 = Math.pow(2, 35);
var $c5b77ddc6b77feb7$var$N6 = Math.pow(2, 42);
var $c5b77ddc6b77feb7$var$N7 = Math.pow(2, 49);
var $c5b77ddc6b77feb7$var$N8 = Math.pow(2, 56);
var $c5b77ddc6b77feb7$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $c5b77ddc6b77feb7$var$N1 ? 1 : value < $c5b77ddc6b77feb7$var$N2 ? 2 : value < $c5b77ddc6b77feb7$var$N3 ? 3 : value < $c5b77ddc6b77feb7$var$N4 ? 4 : value < $c5b77ddc6b77feb7$var$N5 ? 5 : value < $c5b77ddc6b77feb7$var$N6 ? 6 : value < $c5b77ddc6b77feb7$var$N7 ? 7 : value < $c5b77ddc6b77feb7$var$N8 ? 8 : value < $c5b77ddc6b77feb7$var$N9 ? 9 : 10;
};

});


parcelRegister("sBuD1", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $055fb2f845d9c0fe$export$c564cdbbe6da493; }, function (v) { return $055fb2f845d9c0fe$export$c564cdbbe6da493 = v; });
$parcel$export(module.exports, "decode", function () { return $055fb2f845d9c0fe$export$2f872c0f2117be69; }, function (v) { return $055fb2f845d9c0fe$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "encodingLength", function () { return $055fb2f845d9c0fe$export$cbee51f25f0626d7; }, function (v) { return $055fb2f845d9c0fe$export$cbee51f25f0626d7 = v; });
var $055fb2f845d9c0fe$export$c564cdbbe6da493;
var $055fb2f845d9c0fe$export$2f872c0f2117be69;
var $055fb2f845d9c0fe$export$cbee51f25f0626d7;

var $9q7Fh = parcelRequire("9q7Fh");
$055fb2f845d9c0fe$export$c564cdbbe6da493 = function encode(v, b, o) {
    v = v >= 0 ? v * 2 : v * -2 - 1;
    var r = $9q7Fh.encode(v, b, o);
    encode.bytes = $9q7Fh.encode.bytes;
    return r;
};
$055fb2f845d9c0fe$export$2f872c0f2117be69 = function decode(b, o) {
    var v = $9q7Fh.decode(b, o);
    decode.bytes = $9q7Fh.decode.bytes;
    return v & 1 ? (v + 1) / -2 : v / 2;
};
$055fb2f845d9c0fe$export$cbee51f25f0626d7 = function(v) {
    return $9q7Fh.encodingLength(v >= 0 ? v * 2 : v * -2 - 1);
};

});
parcelRegister("9q7Fh", function(module, exports) {



module.exports = {
    encode: (parcelRequire("cZzev")),
    decode: (parcelRequire("rgfqI")),
    encodingLength: (parcelRequire("iZeK9"))
};

});
parcelRegister("cZzev", function(module, exports) {
module.exports = $975683152764e1d6$var$encode;
var $975683152764e1d6$var$MSB = 0x80, $975683152764e1d6$var$REST = 0x7F, $975683152764e1d6$var$MSBALL = ~$975683152764e1d6$var$REST, $975683152764e1d6$var$INT = Math.pow(2, 31);
function $975683152764e1d6$var$encode(num, out, offset) {
    out = out || [];
    offset = offset || 0;
    var oldOffset = offset;
    while(num >= $975683152764e1d6$var$INT){
        out[offset++] = num & 0xFF | $975683152764e1d6$var$MSB;
        num /= 128;
    }
    while(num & $975683152764e1d6$var$MSBALL){
        out[offset++] = num & 0xFF | $975683152764e1d6$var$MSB;
        num >>>= 7;
    }
    out[offset] = num | 0;
    $975683152764e1d6$var$encode.bytes = offset - oldOffset + 1;
    return out;
}

});

parcelRegister("rgfqI", function(module, exports) {
module.exports = $051f20383393b63d$var$read;
var $051f20383393b63d$var$MSB = 0x80, $051f20383393b63d$var$REST = 0x7F;
function $051f20383393b63d$var$read(buf, offset) {
    var res = 0, offset = offset || 0, shift = 0, counter = offset, b, l = buf.length;
    do {
        if (counter >= l) {
            $051f20383393b63d$var$read.bytes = 0;
            throw new RangeError("Could not decode varint");
        }
        b = buf[counter++];
        res += shift < 28 ? (b & $051f20383393b63d$var$REST) << shift : (b & $051f20383393b63d$var$REST) * Math.pow(2, shift);
        shift += 7;
    }while (b >= $051f20383393b63d$var$MSB);
    $051f20383393b63d$var$read.bytes = counter - offset;
    return res;
}

});

parcelRegister("iZeK9", function(module, exports) {
var $dd295c37707a103e$var$N1 = Math.pow(2, 7);
var $dd295c37707a103e$var$N2 = Math.pow(2, 14);
var $dd295c37707a103e$var$N3 = Math.pow(2, 21);
var $dd295c37707a103e$var$N4 = Math.pow(2, 28);
var $dd295c37707a103e$var$N5 = Math.pow(2, 35);
var $dd295c37707a103e$var$N6 = Math.pow(2, 42);
var $dd295c37707a103e$var$N7 = Math.pow(2, 49);
var $dd295c37707a103e$var$N8 = Math.pow(2, 56);
var $dd295c37707a103e$var$N9 = Math.pow(2, 63);
module.exports = function(value) {
    return value < $dd295c37707a103e$var$N1 ? 1 : value < $dd295c37707a103e$var$N2 ? 2 : value < $dd295c37707a103e$var$N3 ? 3 : value < $dd295c37707a103e$var$N4 ? 4 : value < $dd295c37707a103e$var$N5 ? 5 : value < $dd295c37707a103e$var$N6 ? 6 : value < $dd295c37707a103e$var$N7 ? 7 : value < $dd295c37707a103e$var$N8 ? 8 : value < $dd295c37707a103e$var$N9 ? 9 : 10;
};

});




parcelRegister("aERsS", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.size = module.exports["default"] = void 0;

var $7c271ccd20df44dc$var$_is_js = $2ZnTs((parcelRequire("2zdJh")));
// typeToTyp3
//amino type convert
var $7c271ccd20df44dc$var$_default = function _default(type) {
    if ($7c271ccd20df44dc$var$_is_js["default"]["boolean"](type)) return 0;
    if ($7c271ccd20df44dc$var$_is_js["default"].number(type)) {
        if ($7c271ccd20df44dc$var$_is_js["default"].integer(type)) return 0;
        else return 1;
    }
    if ($7c271ccd20df44dc$var$_is_js["default"].string(type) || $7c271ccd20df44dc$var$_is_js["default"].array(type) || $7c271ccd20df44dc$var$_is_js["default"].object(type)) return 2;
    throw new Error('Invalid type "'.concat(type, '"')); // Is this what's expected?
};
module.exports["default"] = $7c271ccd20df44dc$var$_default;
var $7c271ccd20df44dc$var$size = function size(items, iter, acc) {
    if (acc === undefined) acc = 0;
    for(var i = 0; i < items.length; ++i)acc += iter(items[i], i, acc);
    return acc;
};
module.exports.size = $7c271ccd20df44dc$var$size;

});


parcelRegister("bg2Aj", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $83233199cd358343$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $83233199cd358343$var$_exportNames = {
    encodeNumber: true,
    encodeBool: true,
    encodeString: true,
    encodeTime: true,
    convertObjectToSignBytes: true,
    marshalBinary: true,
    marshalBinaryBare: true,
    encodeBinary: true,
    encodeBinaryByteArray: true,
    encodeObjectBinary: true,
    encodeArrayBinary: true
};
module.exports.encodeArrayBinary = module.exports.encodeObjectBinary = module.exports.encodeBinaryByteArray = module.exports.encodeBinary = module.exports.marshalBinaryBare = module.exports.marshalBinary = module.exports.convertObjectToSignBytes = module.exports.encodeTime = module.exports.encodeString = module.exports.encodeBool = module.exports.encodeNumber = void 0;

var $83233199cd358343$var$_typeof2 = $2ZnTs((parcelRequire("crtHL")));

var $83233199cd358343$var$_is_js = $2ZnTs((parcelRequire("2zdJh")));

var $2R6e4 = parcelRequire("2R6e4");

var $83233199cd358343$var$_encoderHelper = $2ZnTs((parcelRequire("aERsS")));

var $20FwV = parcelRequire("20FwV");
Object.keys($20FwV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call($83233199cd358343$var$_exportNames, key)) return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $20FwV[key];
        }
    });
});
var $83233199cd358343$var$sortObject = function sortObject(obj) {
    if (obj === null) return null;
    if ((0, $83233199cd358343$var$_typeof2["default"])(obj) !== "object") return obj; // arrays have typeof "object" in js!
    if (Array.isArray(obj)) return obj.map(sortObject);
    var sortedKeys = Object.keys(obj).sort();
    var result = {};
    sortedKeys.forEach(function(key) {
        result[key] = sortObject(obj[key]);
    });
    return result;
};
/**
 * encode number
 * @category amino
 * @param num
 */ var $83233199cd358343$var$encodeNumber = function encodeNumber(num) {
    return $20FwV.UVarInt.encode(num);
};
/**
 * encode bool
 * @category amino
 * @param b
 */ module.exports.encodeNumber = $83233199cd358343$var$encodeNumber;
var $83233199cd358343$var$encodeBool = function encodeBool(b) {
    return b ? $20FwV.UVarInt.encode(1) : $20FwV.UVarInt.encode(0);
};
/**
 * encode string
 * @category amino
 * @param str
 */ module.exports.encodeBool = $83233199cd358343$var$encodeBool;
var $83233199cd358343$var$encodeString = function encodeString(str) {
    var buf = $83233199cd358343$require$Buffer.alloc($2R6e4.string.encodingLength(str));
    return $2R6e4.string.encode(str, buf, 0);
};
/**
 * encode time
 * @category amino
 * @param value
 */ module.exports.encodeString = $83233199cd358343$var$encodeString;
var $83233199cd358343$var$encodeTime = function encodeTime(value) {
    var millis = new Date(value).getTime();
    var seconds = Math.floor(millis / 1000);
    var nanos = Number(seconds.toString().padEnd(9, "0"));
    var buffer = $83233199cd358343$require$Buffer.alloc(14); // buffer[0] = (1 << 3) | 1 // field 1, typ3 1
    buffer.writeInt32LE(9, 0);
    buffer.writeUInt32LE(seconds, 1); // buffer[9] = (2 << 3) | 5 // field 2, typ3 5
    buffer.writeInt32LE(21, 9);
    buffer.writeUInt32LE(nanos, 10);
    return buffer;
};
/**
 * @category amino
 * @param obj -- {object}
 * @return bytes {Buffer}
 */ module.exports.encodeTime = $83233199cd358343$var$encodeTime;
var $83233199cd358343$var$convertObjectToSignBytes = function convertObjectToSignBytes(obj) {
    return $83233199cd358343$require$Buffer.from(JSON.stringify($83233199cd358343$var$sortObject(obj)));
};
/**
 * js amino MarshalBinary
 * @category amino
 * @param {Object} obj
 *  */ module.exports.convertObjectToSignBytes = $83233199cd358343$var$convertObjectToSignBytes;
var $83233199cd358343$var$marshalBinary = function marshalBinary(obj) {
    if (!$83233199cd358343$var$_is_js["default"].object(obj)) throw new TypeError("data must be an object");
    return $83233199cd358343$var$encodeBinary(obj, -1, true).toString("hex");
};
/**
 * js amino MarshalBinaryBare
 * @category amino
 * @param {Object} obj
 *  */ module.exports.marshalBinary = $83233199cd358343$var$marshalBinary;
var $83233199cd358343$var$marshalBinaryBare = function marshalBinaryBare(obj) {
    if (!$83233199cd358343$var$_is_js["default"].object(obj)) throw new TypeError("data must be an object");
    return $83233199cd358343$var$encodeBinary(obj).toString("hex");
};
/**
 * This is the main entrypoint for encoding all types in binary form.
 * @category amino
 * @param {*} js data type (not null, not undefined)
 * @param {Number} field index of object
 * @param {Boolean} isByteLenPrefix
 * @return {Buffer} binary of object.
 */ module.exports.marshalBinaryBare = $83233199cd358343$var$marshalBinaryBare;
var $83233199cd358343$var$encodeBinary = function encodeBinary(val, fieldNum, isByteLenPrefix) {
    if (val === null || val === undefined) throw new TypeError("unsupported type");
    if ($83233199cd358343$require$Buffer.isBuffer(val)) {
        if (isByteLenPrefix) return $83233199cd358343$require$Buffer.concat([
            $20FwV.UVarInt.encode(val.length),
            val
        ]);
        return val;
    }
    if ($83233199cd358343$var$_is_js["default"].array(val)) return $83233199cd358343$var$encodeArrayBinary(fieldNum, val, isByteLenPrefix);
    if ($83233199cd358343$var$_is_js["default"].number(val)) return $83233199cd358343$var$encodeNumber(val);
    if ($83233199cd358343$var$_is_js["default"]["boolean"](val)) return $83233199cd358343$var$encodeBool(val);
    if ($83233199cd358343$var$_is_js["default"].string(val)) return $83233199cd358343$var$encodeString(val);
    if ($83233199cd358343$var$_is_js["default"].object(val)) return $83233199cd358343$var$encodeObjectBinary(val, isByteLenPrefix);
    return;
};
/**
 * prefixed with bytes length
 * @category amino
 * @param {Buffer} bytes
 * @return {Buffer} with bytes length prefixed
 */ module.exports.encodeBinary = $83233199cd358343$var$encodeBinary;
var $83233199cd358343$var$encodeBinaryByteArray = function encodeBinaryByteArray(bytes) {
    var lenPrefix = bytes.length;
    return $83233199cd358343$require$Buffer.concat([
        $20FwV.UVarInt.encode(lenPrefix),
        bytes
    ]);
};
/**
 * @category amino
 * @param {Object} obj
 * @return {Buffer} with bytes length prefixed
 */ module.exports.encodeBinaryByteArray = $83233199cd358343$var$encodeBinaryByteArray;
var $83233199cd358343$var$encodeObjectBinary = function encodeObjectBinary(obj, isByteLenPrefix) {
    var bufferArr = [];
    Object.keys(obj).forEach(function(key, index) {
        if (key === "aminoPrefix" || key === "version") return;
        if ($83233199cd358343$var$isDefaultValue(obj[key])) return;
        if ($83233199cd358343$var$_is_js["default"].array(obj[key]) && obj[key].length > 0) bufferArr.push($83233199cd358343$var$encodeArrayBinary(index, obj[key]));
        else {
            bufferArr.push($83233199cd358343$var$encodeTypeAndField(index, obj[key]));
            bufferArr.push($83233199cd358343$var$encodeBinary(obj[key], index, true));
        }
    });
    var bytes = $83233199cd358343$require$Buffer.concat(bufferArr); // add prefix
    if (obj.aminoPrefix) {
        var prefix = $83233199cd358343$require$Buffer.from(obj.aminoPrefix, "hex");
        bytes = $83233199cd358343$require$Buffer.concat([
            prefix,
            bytes
        ]);
    } // Write byte-length prefixed.
    if (isByteLenPrefix) {
        var lenBytes = $20FwV.UVarInt.encode(bytes.length);
        bytes = $83233199cd358343$require$Buffer.concat([
            lenBytes,
            bytes
        ]);
    }
    return bytes;
};
/**
 * @category amino
 * @param {Number} fieldNum object field index
 * @param {Array} arr
 * @param {Boolean} isByteLenPrefix
 * @return {Buffer} bytes of array
 */ module.exports.encodeObjectBinary = $83233199cd358343$var$encodeObjectBinary;
var $83233199cd358343$var$encodeArrayBinary = function encodeArrayBinary(fieldNum, arr, isByteLenPrefix) {
    var result = [];
    arr.forEach(function(item) {
        result.push($83233199cd358343$var$encodeTypeAndField(fieldNum, item));
        if ($83233199cd358343$var$isDefaultValue(item)) {
            result.push($83233199cd358343$require$Buffer.from("00", "hex"));
            return;
        }
        result.push($83233199cd358343$var$encodeBinary(item, fieldNum, true));
    }); //encode length
    if (isByteLenPrefix) {
        var length = result.reduce(function(prev, item) {
            return prev + item.length;
        }, 0);
        result.unshift($20FwV.UVarInt.encode(length));
    }
    return $83233199cd358343$require$Buffer.concat(result);
}; // Write field key.
module.exports.encodeArrayBinary = $83233199cd358343$var$encodeArrayBinary;
var $83233199cd358343$var$encodeTypeAndField = function encodeTypeAndField(index, field) {
    index = Number(index);
    var value = index + 1 << 3 | (0, $83233199cd358343$var$_encoderHelper["default"])(field);
    return $20FwV.UVarInt.encode(value);
};
var $83233199cd358343$var$isDefaultValue = function isDefaultValue(obj) {
    if (obj === null) return false;
    return $83233199cd358343$var$_is_js["default"].number(obj) && obj === 0 || $83233199cd358343$var$_is_js["default"].string(obj) && obj === "" || $83233199cd358343$var$_is_js["default"].array(obj) && obj.length === 0 || $83233199cd358343$var$_is_js["default"]["boolean"](obj) && !obj;
};

});
parcelRegister("20FwV", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $176bcbdc53d686c7$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.VarInt = module.exports.UVarInt = void 0;

var $176bcbdc53d686c7$var$_bn = $2ZnTs((parcelRequire("7vYz3")));
function $176bcbdc53d686c7$var$VarIntFunc(signed) {
    var encodingLength = function encodingLength(n) {
        if (signed) n *= 2;
        if (n < 0) throw Error("varint value is out of bounds");
        var bits = Math.log2(n + 1);
        return Math.ceil(bits / 7) || 1;
    };
    var encode = function encode(n, buffer, offset) {
        if (n < 0) throw Error("varint value is out of bounds");
        buffer = buffer || $176bcbdc53d686c7$require$Buffer.alloc(encodingLength(n));
        offset = offset || 0;
        var nStr = n.toString();
        var bn = new $176bcbdc53d686c7$var$_bn["default"](nStr, 10);
        var num255 = new $176bcbdc53d686c7$var$_bn["default"](0xff);
        var num128 = new $176bcbdc53d686c7$var$_bn["default"](0x80); // amino signed varint is multiplied by 2
        if (signed) bn = bn.muln(2);
        var i = 0;
        while(bn.gten(0x80)){
            buffer[offset + i] = bn.and(num255).or(num128).toNumber();
            bn = bn.shrn(7);
            i++;
        }
        buffer[offset + i] = bn.andln(0xff); // TODO
        // encode.bytes = i + 1
        return buffer;
    };
    /**
   * https://github.com/golang/go/blob/master/src/encoding/binary/varint.go#L60
   */ var decode = function decode(bytes) {
        var x = 0;
        var s = 0;
        for(var i = 0, len = bytes.length; i < len; i++){
            var b = bytes[i];
            if (b < 0x80) {
                if (i > 9 || i === 9 && b > 1) return 0;
                return x | b << s;
            }
            x |= (b & 0x7f) << s;
            s += 7;
        }
        return 0;
    };
    return {
        encode: encode,
        decode: decode,
        encodingLength: encodingLength
    };
}
var $176bcbdc53d686c7$var$UVarInt = $176bcbdc53d686c7$var$VarIntFunc(false);
module.exports.UVarInt = $176bcbdc53d686c7$var$UVarInt;
var $176bcbdc53d686c7$var$VarInt = $176bcbdc53d686c7$var$VarIntFunc(true);
module.exports.VarInt = $176bcbdc53d686c7$var$VarInt;

});



parcelRegister("ia7G2", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BncClient = module.exports.DefaultBroadcastDelegate = module.exports.DefaultSigningDelegate = module.exports.NETWORK_PREFIX_MAPPING = module.exports.api = void 0;

var $d38f1da47d560f72$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $d38f1da47d560f72$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $d38f1da47d560f72$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $d38f1da47d560f72$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $d38f1da47d560f72$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $d38f1da47d560f72$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $d38f1da47d560f72$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $d38f1da47d560f72$var$_tx = $2ZnTs((parcelRequire("cM7UC")));

var $eULcN = parcelRequire("eULcN");

var $d38f1da47d560f72$var$_request = $2ZnTs((parcelRequire("hWh1h")));

var $ddfDI = parcelRequire("ddfDI");

var $d38f1da47d560f72$var$_gov = $2ZnTs((parcelRequire("4qD4R")));

var $d38f1da47d560f72$var$_swap = $2ZnTs((parcelRequire("fwcxq")));

var $d38f1da47d560f72$var$_token = $3sU9H((parcelRequire("2lKhK")));

var $1VioX = parcelRequire("1VioX");

var $6Pl5j = parcelRequire("6Pl5j");
function $d38f1da47d560f72$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d38f1da47d560f72$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d38f1da47d560f72$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d38f1da47d560f72$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d38f1da47d560f72$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d38f1da47d560f72$var$BASENUMBER = Math.pow(10, 8);
var $d38f1da47d560f72$var$api = {
    broadcast: "/api/v1/broadcast",
    nodeInfo: "/api/v1/node-info",
    getAccount: "/api/v1/account",
    getMarkets: "/api/v1/markets",
    getSwaps: "/api/v1/atomic-swaps",
    getOpenOrders: "/api/v1/orders/open",
    getDepth: "/api/v1/depth",
    getTransactions: "/api/v1/transactions",
    getTx: "/api/v1/tx"
};
module.exports.api = $d38f1da47d560f72$var$api;
var $d38f1da47d560f72$var$NETWORK_PREFIX_MAPPING = {
    testnet: "tbnb",
    mainnet: "bnb"
};
module.exports.NETWORK_PREFIX_MAPPING = $d38f1da47d560f72$var$NETWORK_PREFIX_MAPPING;
/**
 * The default signing delegate which uses the local private key.
 * @param  {Transaction} tx      the transaction
 * @param  {Object}      signMsg the canonical sign bytes for the msg
 * @return {Transaction}
 */ var $d38f1da47d560f72$var$DefaultSigningDelegate = /*#__PURE__*/ function() {
    var _ref = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee(tx, signMsg) {
        var privateKey;
        return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    privateKey = this.getPrivateKey();
                    if (privateKey) {
                        _context.next = 3;
                        break;
                    }
                    return _context.abrupt("return", Promise.reject("Private key has to be set before signing a transaction"));
                case 3:
                    return _context.abrupt("return", tx.sign(privateKey, signMsg));
                case 4:
                case "end":
                    return _context.stop();
            }
        }, _callee, this);
    }));
    return function DefaultSigningDelegate(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * The default broadcast delegate which immediately broadcasts a transaction.
 * @param {Transaction} signedTx the signed transaction
 */ module.exports.DefaultSigningDelegate = $d38f1da47d560f72$var$DefaultSigningDelegate;
var $d38f1da47d560f72$var$DefaultBroadcastDelegate = /*#__PURE__*/ function() {
    var _ref2 = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee2(signedTx) {
        return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    return _context2.abrupt("return", this.sendTransaction(signedTx, true));
                case 1:
                case "end":
                    return _context2.stop();
            }
        }, _callee2, this);
    }));
    return function DefaultBroadcastDelegate(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}(); // /**
//  * The Ledger signing delegate.
//  * @param  {LedgerApp}  ledgerApp
//  * @param  {preSignCb}  function
//  * @param  {postSignCb} function
//  * @param  {errCb} function
//  * @return {function}
//  */
// export const LedgerSigningDelegate = (
//   ledgerApp: LedgerApp,
//   preSignCb: (preSignCb: Buffer) => void,
//   postSignCb: (pubKeyResp: PublicKey, sigResp: SignedSignature) => void,
//   errCb: (error: any) => void,
//   hdPath: number[]
// ): typeof DefaultSigningDelegate =>
//   async function (tx, signMsg) {
//     const signBytes = tx.getSignBytes(signMsg)
//     preSignCb && preSignCb(signBytes)
//     let pubKeyResp: PublicKey, sigResp: SignedSignature
//     try {
//       pubKeyResp = await ledgerApp.getPublicKey(hdPath)
//       sigResp = await ledgerApp.sign(signBytes, hdPath)
//       postSignCb && postSignCb(pubKeyResp, sigResp)
//     } catch (err) {
//       console.warn("LedgerSigningDelegate error", err)
//       errCb && errCb(err)
//     }
//     if (sigResp! && sigResp!.signature) {
//       const pubKey = crypto.getPublicKey(pubKeyResp!.pk!.toString("hex"))
//       return tx.addSignature(pubKey, sigResp!.signature)
//     }
//     return tx
//   }
/**
 * validate the input number.
 * @param {Array} outputs
 */ module.exports.DefaultBroadcastDelegate = $d38f1da47d560f72$var$DefaultBroadcastDelegate;
var $d38f1da47d560f72$var$checkOutputs = function checkOutputs(outputs) {
    outputs.forEach(function(transfer) {
        var coins = transfer.coins || [];
        coins.forEach(function(coin) {
            (0, $ddfDI.checkNumber)(coin.amount);
            if (!coin.denom) throw new Error("invalid denmon");
        });
    });
};
/**
 * sum corresponding input coin
 * @param {Array} inputs
 * @param {Array} coins
 */ var $d38f1da47d560f72$var$calInputCoins = function calInputCoins(inputs, coins) {
    coins.forEach(function(coin) {
        var existCoin = inputs[0].coins.find(function(c) {
            return c.denom === coin.denom;
        });
        if (existCoin) {
            var existAmount = new $d38f1da47d560f72$var$_big["default"](existCoin.amount);
            existCoin.amount = Number(existAmount.plus(coin.amount).toString());
        } else inputs[0].coins.push($d38f1da47d560f72$var$_objectSpread({}, coin));
    });
};
/**
 * The Binance Chain client.
 */ var $d38f1da47d560f72$var$BncClient = /*#__PURE__*/ function() {
    /**
   * @param {String} server Binance Chain public url
   * @param {Boolean} useAsyncBroadcast use async broadcast mode, faster but less guarantees (default off)
   * @param {Number} source where does this transaction come from (default 0)
   */ function BncClient(server) {
        var useAsyncBroadcast = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        (0, $d38f1da47d560f72$var$_classCallCheck2["default"])(this, BncClient);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_httpClient", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_signingDelegate", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_broadcastDelegate", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_useAsyncBroadcast", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_source", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "tokens", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "swap", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "gov", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "bridge", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "stake", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "chainId", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "addressPrefix", "tbnb");
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "network", "testnet");
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "address", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_setPkPromise", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "account_number", void 0);
        (0, $d38f1da47d560f72$var$_defineProperty2["default"])(this, "_privateKey", null);
        if (!server) throw new Error("Binance chain server should not be null");
        this._httpClient = new $d38f1da47d560f72$var$_request["default"](server);
        this._signingDelegate = $d38f1da47d560f72$var$DefaultSigningDelegate;
        this._broadcastDelegate = $d38f1da47d560f72$var$DefaultBroadcastDelegate;
        this._useAsyncBroadcast = useAsyncBroadcast;
        this._source = source;
        this.tokens = new $d38f1da47d560f72$var$_token["default"](this);
        this.swap = new $d38f1da47d560f72$var$_swap["default"](this);
        this.gov = new $d38f1da47d560f72$var$_gov["default"](this);
        this.bridge = new $1VioX.Bridge(this);
        this.stake = new $6Pl5j.Stake(this);
    }
    /**
   * Initialize the client with the chain's ID. Asynchronous.
   * @return {Promise}
   */ (0, $d38f1da47d560f72$var$_createClass2["default"])(BncClient, [
        {
            key: "initChain",
            value: function() {
                var _initChain = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee3() {
                    var data;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (this.chainId) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return this._httpClient.request("get", $d38f1da47d560f72$var$api.nodeInfo);
                            case 3:
                                data = _context3.sent;
                                this.chainId = data.result.node_info && data.result.node_info.network;
                            case 5:
                                return _context3.abrupt("return", this);
                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initChain() {
                    return _initChain.apply(this, arguments);
                }
                return initChain;
            }()
        },
        {
            key: "chooseNetwork",
            value: function chooseNetwork(network) {
                this.addressPrefix = $d38f1da47d560f72$var$NETWORK_PREFIX_MAPPING[network] || "tbnb";
                this.network = $d38f1da47d560f72$var$NETWORK_PREFIX_MAPPING[network] ? network : "testnet";
            }
        },
        {
            key: "setPrivateKey",
            value: function() {
                var _setPrivateKey = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee4(privateKey) {
                    var localOnly, address, promise, data, _args4 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                localOnly = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
                                if (!(privateKey !== this._privateKey)) {
                                    _context4.next = 19;
                                    break;
                                }
                                address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                                if (address) {
                                    _context4.next = 5;
                                    break;
                                }
                                throw new Error("address is falsy: ".concat(address, ". invalid private key?"));
                            case 5:
                                this._privateKey = privateKey;
                                this.address = address;
                                if (localOnly) {
                                    _context4.next = 19;
                                    break;
                                }
                                _context4.prev = 8;
                                promise = this._setPkPromise = this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getAccount, "/").concat(address));
                                _context4.next = 12;
                                return promise;
                            case 12:
                                data = _context4.sent;
                                this.account_number = data.result.account_number;
                                _context4.next = 19;
                                break;
                            case 16:
                                _context4.prev = 16;
                                _context4.t0 = _context4["catch"](8);
                                throw new Error("unable to query the address on the blockchain. try sending it some funds first: ".concat(address));
                            case 19:
                                return _context4.abrupt("return", this);
                            case 20:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this, [
                        [
                            8,
                            16
                        ]
                    ]);
                }));
                function setPrivateKey(_x6) {
                    return _setPrivateKey.apply(this, arguments);
                }
                return setPrivateKey;
            }()
        },
        {
            key: "removePrivateKey",
            value: function removePrivateKey() {
                this._privateKey = null;
                return this;
            }
        },
        {
            key: "getPrivateKey",
            value: function getPrivateKey() {
                return this._privateKey;
            }
        },
        {
            key: "setAccountNumber",
            value: function setAccountNumber(accountNumber) {
                this.account_number = accountNumber;
            }
        },
        {
            key: "useAsyncBroadcast",
            value: function useAsyncBroadcast() {
                var _useAsyncBroadcast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this._useAsyncBroadcast = _useAsyncBroadcast;
                return this;
            }
        },
        {
            key: "setSigningDelegate",
            value: function setSigningDelegate(delegate) {
                if (typeof delegate !== "function") throw new Error("signing delegate must be a function");
                this._signingDelegate = delegate;
                return this;
            }
        },
        {
            key: "setBroadcastDelegate",
            value: function setBroadcastDelegate(delegate) {
                if (typeof delegate !== "function") throw new Error("broadcast delegate must be a function");
                this._broadcastDelegate = delegate;
                return this;
            }
        },
        {
            key: "useDefaultSigningDelegate",
            value: function useDefaultSigningDelegate() {
                this._signingDelegate = $d38f1da47d560f72$var$DefaultSigningDelegate;
                return this;
            }
        },
        {
            key: "useDefaultBroadcastDelegate",
            value: function useDefaultBroadcastDelegate() {
                this._broadcastDelegate = $d38f1da47d560f72$var$DefaultBroadcastDelegate;
                return this;
            }
        },
        {
            key: "transfer",
            value: function() {
                var _transfer = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee5(fromAddress, toAddress, amount, asset) {
                    var memo, sequence, accCode, toAccCode, coin, msg, signMsg, signedTx, signedBz, _args5 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                memo = _args5.length > 4 && _args5[4] !== undefined ? _args5[4] : "";
                                sequence = _args5.length > 5 && _args5[5] !== undefined ? _args5[5] : null;
                                accCode = $d38f1da47d560f72$var$crypto.decodeAddress(fromAddress);
                                toAccCode = $d38f1da47d560f72$var$crypto.decodeAddress(toAddress);
                                amount = new $d38f1da47d560f72$var$_big["default"](amount);
                                amount = Number(amount.mul($d38f1da47d560f72$var$BASENUMBER).toString());
                                (0, $ddfDI.checkNumber)(amount, "amount");
                                coin = {
                                    denom: asset,
                                    amount: amount
                                };
                                msg = {
                                    inputs: [
                                        {
                                            address: accCode,
                                            coins: [
                                                coin
                                            ]
                                        }
                                    ],
                                    outputs: [
                                        {
                                            address: toAccCode,
                                            coins: [
                                                coin
                                            ]
                                        }
                                    ],
                                    aminoPrefix: $eULcN.AminoPrefix.MsgSend
                                };
                                signMsg = {
                                    inputs: [
                                        {
                                            address: fromAddress,
                                            coins: [
                                                {
                                                    amount: amount,
                                                    denom: asset
                                                }
                                            ]
                                        }
                                    ],
                                    outputs: [
                                        {
                                            address: toAddress,
                                            coins: [
                                                {
                                                    amount: amount,
                                                    denom: asset
                                                }
                                            ]
                                        }
                                    ]
                                };
                                _context5.next = 12;
                                return this._prepareTransaction(msg, signMsg, fromAddress, sequence, memo);
                            case 12:
                                signedTx = _context5.sent;
                                signedBz = signedTx.serialize(); // @ts-ignore
                                signedTx.serialized = signedBz;
                                return _context5.abrupt("return", signedTx);
                            case 16:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function transfer(_x7, _x8, _x9, _x10) {
                    return _transfer.apply(this, arguments);
                }
                return transfer;
            }()
        },
        {
            key: "multiSend",
            value: function() {
                var _multiSend = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee6(fromAddress, outputs) {
                    var memo, sequence, fromAddrCode, inputs, transfers, msg, signInputs, signOutputs, signMsg, signedTx, _args6 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                memo = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : "";
                                sequence = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : null;
                                if (fromAddress) {
                                    _context6.next = 4;
                                    break;
                                }
                                throw new Error("fromAddress should not be falsy");
                            case 4:
                                if (Array.isArray(outputs)) {
                                    _context6.next = 6;
                                    break;
                                }
                                throw new Error("outputs should be array");
                            case 6:
                                $d38f1da47d560f72$var$checkOutputs(outputs); //sort denom by alphbet and init amount
                                outputs.forEach(function(item) {
                                    item.coins = item.coins.sort(function(a, b) {
                                        return a.denom.localeCompare(b.denom);
                                    });
                                    item.coins.forEach(function(coin) {
                                        var amount = new $d38f1da47d560f72$var$_big["default"](coin.amount);
                                        coin.amount = Number(amount.mul($d38f1da47d560f72$var$BASENUMBER).toString());
                                    });
                                });
                                fromAddrCode = $d38f1da47d560f72$var$crypto.decodeAddress(fromAddress);
                                inputs = [
                                    {
                                        address: fromAddrCode,
                                        coins: []
                                    }
                                ];
                                transfers = [];
                                outputs.forEach(function(item) {
                                    var toAddcCode = $d38f1da47d560f72$var$crypto.decodeAddress(item.to);
                                    $d38f1da47d560f72$var$calInputCoins(inputs, item.coins);
                                    transfers.push({
                                        address: toAddcCode,
                                        coins: item.coins
                                    });
                                });
                                msg = {
                                    inputs: inputs,
                                    outputs: transfers,
                                    aminoPrefix: $eULcN.AminoPrefix.MsgSend
                                };
                                signInputs = [
                                    {
                                        address: fromAddress,
                                        coins: []
                                    }
                                ];
                                signOutputs = [];
                                outputs.forEach(function(item, index) {
                                    signOutputs.push({
                                        address: item.to,
                                        coins: []
                                    });
                                    item.coins.forEach(function(c) {
                                        signOutputs[index].coins.push(c);
                                    });
                                    $d38f1da47d560f72$var$calInputCoins(signInputs, item.coins);
                                });
                                signMsg = {
                                    inputs: signInputs,
                                    outputs: signOutputs
                                };
                                _context6.next = 19;
                                return this._prepareTransaction(msg, signMsg, fromAddress, sequence, memo);
                            case 19:
                                signedTx = _context6.sent;
                                return _context6.abrupt("return", this._broadcastDelegate(signedTx));
                            case 21:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function multiSend(_x11, _x12) {
                    return _multiSend.apply(this, arguments);
                }
                return multiSend;
            }()
        },
        {
            key: "cancelOrder",
            value: function() {
                var _cancelOrder = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee7(fromAddress, symbol, refid) {
                    var sequence, accCode, msg, signMsg, signedTx, _args7 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                sequence = _args7.length > 3 && _args7[3] !== undefined ? _args7[3] : null;
                                accCode = $d38f1da47d560f72$var$crypto.decodeAddress(fromAddress);
                                msg = {
                                    sender: accCode,
                                    symbol: symbol,
                                    refid: refid,
                                    aminoPrefix: $eULcN.AminoPrefix.CancelOrderMsg
                                };
                                signMsg = {
                                    refid: refid,
                                    sender: fromAddress,
                                    symbol: symbol
                                };
                                _context7.next = 6;
                                return this._prepareTransaction(msg, signMsg, fromAddress, sequence, "");
                            case 6:
                                signedTx = _context7.sent;
                                return _context7.abrupt("return", this._broadcastDelegate(signedTx));
                            case 8:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function cancelOrder(_x13, _x14, _x15) {
                    return _cancelOrder.apply(this, arguments);
                }
                return cancelOrder;
            }()
        },
        {
            key: "placeOrder",
            value: function() {
                var _placeOrder = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee8() {
                    var address, symbol, side, price, quantity, sequence, timeinforce, accCode, data, bigPrice, bigQuantity, placeOrderMsg, signMsg, signedTx, _args8 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                address = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : this.address;
                                symbol = _args8.length > 1 ? _args8[1] : undefined;
                                side = _args8.length > 2 ? _args8[2] : undefined;
                                price = _args8.length > 3 ? _args8[3] : undefined;
                                quantity = _args8.length > 4 ? _args8[4] : undefined;
                                sequence = _args8.length > 5 && _args8[5] !== undefined ? _args8[5] : null;
                                timeinforce = _args8.length > 6 && _args8[6] !== undefined ? _args8[6] : 1;
                                if (address) {
                                    _context8.next = 9;
                                    break;
                                }
                                throw new Error("address should not be falsy");
                            case 9:
                                if (symbol) {
                                    _context8.next = 11;
                                    break;
                                }
                                throw new Error("symbol should not be falsy");
                            case 11:
                                if (!(side !== 1 && side !== 2)) {
                                    _context8.next = 13;
                                    break;
                                }
                                throw new Error("side can only be 1 or 2");
                            case 13:
                                if (!(timeinforce !== 1 && timeinforce !== 3)) {
                                    _context8.next = 15;
                                    break;
                                }
                                throw new Error("timeinforce can only be 1 or 3");
                            case 15:
                                accCode = $d38f1da47d560f72$var$crypto.decodeAddress(address);
                                if (!(sequence !== 0 && !sequence)) {
                                    _context8.next = 21;
                                    break;
                                }
                                _context8.next = 19;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getAccount, "/").concat(address));
                            case 19:
                                data = _context8.sent;
                                sequence = data.result && data.result.sequence;
                            case 21:
                                bigPrice = new $d38f1da47d560f72$var$_big["default"](price);
                                bigQuantity = new $d38f1da47d560f72$var$_big["default"](quantity);
                                placeOrderMsg = {
                                    sender: accCode,
                                    id: "".concat(accCode.toString("hex"), "-").concat(sequence + 1).toUpperCase(),
                                    symbol: symbol,
                                    ordertype: 2,
                                    side: side,
                                    price: parseFloat(bigPrice.mul($d38f1da47d560f72$var$BASENUMBER).toString()),
                                    quantity: parseFloat(bigQuantity.mul($d38f1da47d560f72$var$BASENUMBER).toString()),
                                    timeinforce: timeinforce,
                                    aminoPrefix: $eULcN.AminoPrefix.NewOrderMsg
                                };
                                signMsg = {
                                    id: placeOrderMsg.id,
                                    ordertype: placeOrderMsg.ordertype,
                                    price: placeOrderMsg.price,
                                    quantity: placeOrderMsg.quantity,
                                    sender: address,
                                    side: placeOrderMsg.side,
                                    symbol: placeOrderMsg.symbol,
                                    timeinforce: timeinforce
                                };
                                (0, $ddfDI.checkNumber)(placeOrderMsg.price, "price");
                                (0, $ddfDI.checkNumber)(placeOrderMsg.quantity, "quantity");
                                _context8.next = 29;
                                return this._prepareTransaction(placeOrderMsg, signMsg, address, sequence, "");
                            case 29:
                                signedTx = _context8.sent;
                                return _context8.abrupt("return", this._broadcastDelegate(signedTx));
                            case 31:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function placeOrder() {
                    return _placeOrder.apply(this, arguments);
                }
                return placeOrder;
            }()
        },
        {
            key: "list",
            value: function() {
                var _list = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee9(address, proposalId, baseAsset, quoteAsset, initPrice) {
                    var sequence, accCode, init_price, listMsg, signMsg, signedTx, _args9 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                sequence = _args9.length > 5 && _args9[5] !== undefined ? _args9[5] : null;
                                accCode = $d38f1da47d560f72$var$crypto.decodeAddress(address);
                                if (address) {
                                    _context9.next = 4;
                                    break;
                                }
                                throw new Error("address should not be falsy");
                            case 4:
                                if (!(proposalId <= 0)) {
                                    _context9.next = 6;
                                    break;
                                }
                                throw new Error("proposal id should larger than 0");
                            case 6:
                                if (!(initPrice <= 0)) {
                                    _context9.next = 8;
                                    break;
                                }
                                throw new Error("price should larger than 0");
                            case 8:
                                if (baseAsset) {
                                    _context9.next = 10;
                                    break;
                                }
                                throw new Error("baseAsset should not be falsy");
                            case 10:
                                if (quoteAsset) {
                                    _context9.next = 12;
                                    break;
                                }
                                throw new Error("quoteAsset should not be falsy");
                            case 12:
                                init_price = Number(new $d38f1da47d560f72$var$_big["default"](initPrice).mul($d38f1da47d560f72$var$BASENUMBER).toString());
                                listMsg = {
                                    from: accCode,
                                    proposal_id: proposalId,
                                    base_asset_symbol: baseAsset,
                                    quote_asset_symbol: quoteAsset,
                                    init_price: init_price,
                                    aminoPrefix: $eULcN.AminoPrefix.ListMsg
                                };
                                signMsg = {
                                    base_asset_symbol: baseAsset,
                                    from: address,
                                    init_price: init_price,
                                    proposal_id: proposalId,
                                    quote_asset_symbol: quoteAsset
                                };
                                _context9.next = 17;
                                return this._prepareTransaction(listMsg, signMsg, address, sequence, "");
                            case 17:
                                signedTx = _context9.sent;
                                return _context9.abrupt("return", this._broadcastDelegate(signedTx));
                            case 19:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function list(_x16, _x17, _x18, _x19, _x20) {
                    return _list.apply(this, arguments);
                }
                return list;
            }()
        },
        {
            key: "listMiniToken",
            value: function() {
                var _listMiniToken = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee10(_ref3) {
                    var from, baseAsset, quoteAsset, initPrice, _ref3$sequence, sequence, init_price, listMiniMsg, signedTx;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                from = _ref3.from, baseAsset = _ref3.baseAsset, quoteAsset = _ref3.quoteAsset, initPrice = _ref3.initPrice, _ref3$sequence = _ref3.sequence, sequence = _ref3$sequence === void 0 ? null : _ref3$sequence;
                                (0, $d38f1da47d560f72$var$_token.validateMiniTokenSymbol)(baseAsset);
                                if (!(initPrice <= 0)) {
                                    _context10.next = 4;
                                    break;
                                }
                                throw new Error("price should larger than 0");
                            case 4:
                                if (from) {
                                    _context10.next = 6;
                                    break;
                                }
                                throw new Error("address should not be falsy");
                            case 6:
                                if (quoteAsset) {
                                    _context10.next = 8;
                                    break;
                                }
                                throw new Error("quoteAsset should not be falsy");
                            case 8:
                                init_price = Number(new $d38f1da47d560f72$var$_big["default"](initPrice).mul($d38f1da47d560f72$var$BASENUMBER).toString());
                                listMiniMsg = new $eULcN.ListMiniMsg({
                                    from: from,
                                    base_asset_symbol: baseAsset,
                                    quote_asset_symbol: quoteAsset,
                                    init_price: init_price
                                });
                                _context10.next = 12;
                                return this._prepareTransaction(listMiniMsg.getMsg(), listMiniMsg.getSignMsg(), from, sequence);
                            case 12:
                                signedTx = _context10.sent;
                                return _context10.abrupt("return", this._broadcastDelegate(signedTx));
                            case 14:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function listMiniToken(_x21) {
                    return _listMiniToken.apply(this, arguments);
                }
                return listMiniToken;
            }()
        },
        {
            key: "setAccountFlags",
            value: function() {
                var _setAccountFlags = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee11(address, flags) {
                    var sequence, accCode, msg, signMsg, signedTx, _args11 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                sequence = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : null;
                                accCode = $d38f1da47d560f72$var$crypto.decodeAddress(address);
                                msg = {
                                    from: accCode,
                                    flags: flags,
                                    aminoPrefix: $eULcN.AminoPrefix.SetAccountFlagsMsg
                                };
                                signMsg = {
                                    flags: flags,
                                    from: address
                                };
                                _context11.next = 6;
                                return this._prepareTransaction(msg, signMsg, address, sequence, "");
                            case 6:
                                signedTx = _context11.sent;
                                return _context11.abrupt("return", this._broadcastDelegate(signedTx));
                            case 8:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function setAccountFlags(_x22, _x23) {
                    return _setAccountFlags.apply(this, arguments);
                }
                return setAccountFlags;
            }()
        },
        {
            key: "_prepareTransaction",
            value: function() {
                var _prepareTransaction2 = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee12(msg, stdSignMsg, address) {
                    var sequence, memo, data, tx, _args12 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                sequence = _args12.length > 3 && _args12[3] !== undefined ? _args12[3] : null;
                                memo = _args12.length > 4 && _args12[4] !== undefined ? _args12[4] : "";
                                if (!((!this.account_number || sequence !== 0 && !sequence) && address)) {
                                    _context12.next = 10;
                                    break;
                                }
                                _context12.next = 5;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getAccount, "/").concat(address));
                            case 5:
                                data = _context12.sent;
                                sequence = data.result.sequence;
                                this.account_number = data.result.account_number; // if user has not used `await` in its call to setPrivateKey (old API), we should wait for the promise here
                                _context12.next = 13;
                                break;
                            case 10:
                                if (!this._setPkPromise) {
                                    _context12.next = 13;
                                    break;
                                }
                                _context12.next = 13;
                                return this._setPkPromise;
                            case 13:
                                tx = new $d38f1da47d560f72$var$_tx["default"]({
                                    accountNumber: typeof this.account_number !== "number" ? parseInt(this.account_number) : this.account_number,
                                    chainId: this.chainId,
                                    memo: memo,
                                    msg: msg,
                                    sequence: typeof sequence !== "number" ? parseInt(sequence) : sequence,
                                    source: this._source
                                });
                                return _context12.abrupt("return", this._signingDelegate.call(this, tx, stdSignMsg));
                            case 15:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function _prepareTransaction(_x24, _x25, _x26) {
                    return _prepareTransaction2.apply(this, arguments);
                }
                return _prepareTransaction;
            }()
        },
        {
            key: "sendTransaction",
            value: function() {
                var _sendTransaction2 = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee13(signedTx, sync) {
                    var signedBz;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee13$(_context13) {
                        while(true)switch(_context13.prev = _context13.next){
                            case 0:
                                signedBz = signedTx.serialize();
                                return _context13.abrupt("return", this.sendRawTransaction(signedBz, sync));
                            case 2:
                            case "end":
                                return _context13.stop();
                        }
                    }, _callee13, this);
                }));
                function sendTransaction(_x27, _x28) {
                    return _sendTransaction2.apply(this, arguments);
                }
                return sendTransaction;
            }()
        },
        {
            key: "sendRawTransaction",
            value: function() {
                var _sendRawTransaction = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee14(signedBz) {
                    var sync, opts, _args14 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee14$(_context14) {
                        while(true)switch(_context14.prev = _context14.next){
                            case 0:
                                sync = _args14.length > 1 && _args14[1] !== undefined ? _args14[1] : !this._useAsyncBroadcast;
                                opts = {
                                    data: signedBz,
                                    headers: {
                                        "content-type": "text/plain"
                                    }
                                };
                                return _context14.abrupt("return", this._httpClient.request("post", "".concat($d38f1da47d560f72$var$api.broadcast, "?sync=").concat(sync), null, opts));
                            case 3:
                            case "end":
                                return _context14.stop();
                        }
                    }, _callee14, this);
                }));
                function sendRawTransaction(_x29) {
                    return _sendRawTransaction.apply(this, arguments);
                }
                return sendRawTransaction;
            }()
        },
        {
            key: "_sendTransaction",
            value: function() {
                var _sendTransaction3 = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee15(msg, stdSignMsg, address) {
                    var sequence, memo, sync, signedTx, _args15 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee15$(_context15) {
                        while(true)switch(_context15.prev = _context15.next){
                            case 0:
                                sequence = _args15.length > 3 && _args15[3] !== undefined ? _args15[3] : null;
                                memo = _args15.length > 4 && _args15[4] !== undefined ? _args15[4] : "";
                                sync = _args15.length > 5 && _args15[5] !== undefined ? _args15[5] : !this._useAsyncBroadcast;
                                _context15.next = 5;
                                return this._prepareTransaction(msg, stdSignMsg, address, sequence, memo);
                            case 5:
                                signedTx = _context15.sent;
                                return _context15.abrupt("return", this.sendTransaction(signedTx, sync));
                            case 7:
                            case "end":
                                return _context15.stop();
                        }
                    }, _callee15, this);
                }));
                function _sendTransaction(_x30, _x31, _x32) {
                    return _sendTransaction3.apply(this, arguments);
                }
                return _sendTransaction;
            }()
        },
        {
            key: "getAccount",
            value: function() {
                var _getAccount = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee16() {
                    var address, data, _args16 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee16$(_context16) {
                        while(true)switch(_context16.prev = _context16.next){
                            case 0:
                                address = _args16.length > 0 && _args16[0] !== undefined ? _args16[0] : this.address;
                                if (address) {
                                    _context16.next = 3;
                                    break;
                                }
                                throw new Error("address should not be falsy");
                            case 3:
                                _context16.prev = 3;
                                _context16.next = 6;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getAccount, "/").concat(address));
                            case 6:
                                data = _context16.sent;
                                return _context16.abrupt("return", data);
                            case 10:
                                _context16.prev = 10;
                                _context16.t0 = _context16["catch"](3);
                                return _context16.abrupt("return", null);
                            case 13:
                            case "end":
                                return _context16.stop();
                        }
                    }, _callee16, this, [
                        [
                            3,
                            10
                        ]
                    ]);
                }));
                function getAccount() {
                    return _getAccount.apply(this, arguments);
                }
                return getAccount;
            }()
        },
        {
            key: "getBalance",
            value: function() {
                var _getBalance = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee17() {
                    var address, data, _args17 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee17$(_context17) {
                        while(true)switch(_context17.prev = _context17.next){
                            case 0:
                                address = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : this.address;
                                _context17.prev = 1;
                                _context17.next = 4;
                                return this.getAccount(address);
                            case 4:
                                data = _context17.sent;
                                return _context17.abrupt("return", data.result.balances);
                            case 8:
                                _context17.prev = 8;
                                _context17.t0 = _context17["catch"](1);
                                return _context17.abrupt("return", []);
                            case 11:
                            case "end":
                                return _context17.stop();
                        }
                    }, _callee17, this, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                function getBalance() {
                    return _getBalance.apply(this, arguments);
                }
                return getBalance;
            }()
        },
        {
            key: "getMarkets",
            value: function() {
                var _getMarkets = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee18() {
                    var limit, offset, data, _args18 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee18$(_context18) {
                        while(true)switch(_context18.prev = _context18.next){
                            case 0:
                                limit = _args18.length > 0 && _args18[0] !== undefined ? _args18[0] : 1000;
                                offset = _args18.length > 1 && _args18[1] !== undefined ? _args18[1] : 0;
                                _context18.prev = 2;
                                _context18.next = 5;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getMarkets, "?limit=").concat(limit, "&offset=").concat(offset));
                            case 5:
                                data = _context18.sent;
                                return _context18.abrupt("return", data);
                            case 9:
                                _context18.prev = 9;
                                _context18.t0 = _context18["catch"](2);
                                console.warn("getMarkets error", _context18.t0);
                                return _context18.abrupt("return", []);
                            case 13:
                            case "end":
                                return _context18.stop();
                        }
                    }, _callee18, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function getMarkets() {
                    return _getMarkets.apply(this, arguments);
                }
                return getMarkets;
            }()
        },
        {
            key: "getTransactions",
            value: function() {
                var _getTransactions = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee19() {
                    var address, offset, data, _args19 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee19$(_context19) {
                        while(true)switch(_context19.prev = _context19.next){
                            case 0:
                                address = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : this.address;
                                offset = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : 0;
                                _context19.prev = 2;
                                _context19.next = 5;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getTransactions, "?address=").concat(address, "&offset=").concat(offset));
                            case 5:
                                data = _context19.sent;
                                return _context19.abrupt("return", data);
                            case 9:
                                _context19.prev = 9;
                                _context19.t0 = _context19["catch"](2);
                                console.warn("getTransactions error", _context19.t0);
                                return _context19.abrupt("return", []);
                            case 13:
                            case "end":
                                return _context19.stop();
                        }
                    }, _callee19, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function getTransactions() {
                    return _getTransactions.apply(this, arguments);
                }
                return getTransactions;
            }()
        },
        {
            key: "getTx",
            value: function() {
                var _getTx = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee20(hash) {
                    var data;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee20$(_context20) {
                        while(true)switch(_context20.prev = _context20.next){
                            case 0:
                                _context20.prev = 0;
                                _context20.next = 3;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getTx, "/").concat(hash));
                            case 3:
                                data = _context20.sent;
                                return _context20.abrupt("return", data);
                            case 7:
                                _context20.prev = 7;
                                _context20.t0 = _context20["catch"](0);
                                console.warn("getTx error", _context20.t0);
                                return _context20.abrupt("return", []);
                            case 11:
                            case "end":
                                return _context20.stop();
                        }
                    }, _callee20, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function getTx(_x33) {
                    return _getTx.apply(this, arguments);
                }
                return getTx;
            }()
        },
        {
            key: "getDepth",
            value: function() {
                var _getDepth = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee21() {
                    var symbol, data, _args21 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee21$(_context21) {
                        while(true)switch(_context21.prev = _context21.next){
                            case 0:
                                symbol = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : "BNB_BUSD-BD1";
                                _context21.prev = 1;
                                _context21.next = 4;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getDepth, "?symbol=").concat(symbol));
                            case 4:
                                data = _context21.sent;
                                return _context21.abrupt("return", data);
                            case 8:
                                _context21.prev = 8;
                                _context21.t0 = _context21["catch"](1);
                                console.warn("getDepth error", _context21.t0);
                                return _context21.abrupt("return", []);
                            case 12:
                            case "end":
                                return _context21.stop();
                        }
                    }, _callee21, this, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                function getDepth() {
                    return _getDepth.apply(this, arguments);
                }
                return getDepth;
            }()
        },
        {
            key: "getOpenOrders",
            value: function() {
                var _getOpenOrders = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee22() {
                    var address, data, _args22 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee22$(_context22) {
                        while(true)switch(_context22.prev = _context22.next){
                            case 0:
                                address = _args22.length > 0 && _args22[0] !== undefined ? _args22[0] : this.address;
                                _context22.prev = 1;
                                _context22.next = 4;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getOpenOrders, "?address=").concat(address));
                            case 4:
                                data = _context22.sent;
                                return _context22.abrupt("return", data);
                            case 8:
                                _context22.prev = 8;
                                _context22.t0 = _context22["catch"](1);
                                console.warn("getOpenOrders error", _context22.t0);
                                return _context22.abrupt("return", []);
                            case 12:
                            case "end":
                                return _context22.stop();
                        }
                    }, _callee22, this, [
                        [
                            1,
                            8
                        ]
                    ]);
                }));
                function getOpenOrders() {
                    return _getOpenOrders.apply(this, arguments);
                }
                return getOpenOrders;
            }()
        },
        {
            key: "getSwapByID",
            value: function() {
                var _getSwapByID = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee23(swapID) {
                    var data;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee23$(_context23) {
                        while(true)switch(_context23.prev = _context23.next){
                            case 0:
                                _context23.prev = 0;
                                _context23.next = 3;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getSwaps, "/").concat(swapID));
                            case 3:
                                data = _context23.sent;
                                return _context23.abrupt("return", data);
                            case 7:
                                _context23.prev = 7;
                                _context23.t0 = _context23["catch"](0);
                                console.warn("query swap by swapID error", _context23.t0);
                                return _context23.abrupt("return", []);
                            case 11:
                            case "end":
                                return _context23.stop();
                        }
                    }, _callee23, this, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function getSwapByID(_x34) {
                    return _getSwapByID.apply(this, arguments);
                }
                return getSwapByID;
            }()
        },
        {
            key: "getSwapByCreator",
            value: function() {
                var _getSwapByCreator = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee24(creator) {
                    var limit, offset, data, _args24 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee24$(_context24) {
                        while(true)switch(_context24.prev = _context24.next){
                            case 0:
                                limit = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : 100;
                                offset = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : 0;
                                _context24.prev = 2;
                                _context24.next = 5;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getSwaps, "?fromAddress=").concat(creator, "&limit=").concat(limit, "&offset=").concat(offset));
                            case 5:
                                data = _context24.sent;
                                return _context24.abrupt("return", data);
                            case 9:
                                _context24.prev = 9;
                                _context24.t0 = _context24["catch"](2);
                                console.warn("query swap list by swap creator error", _context24.t0);
                                return _context24.abrupt("return", []);
                            case 13:
                            case "end":
                                return _context24.stop();
                        }
                    }, _callee24, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function getSwapByCreator(_x35) {
                    return _getSwapByCreator.apply(this, arguments);
                }
                return getSwapByCreator;
            }()
        },
        {
            key: "getSwapByRecipient",
            value: function() {
                var _getSwapByRecipient = (0, $d38f1da47d560f72$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $d38f1da47d560f72$var$_regenerator["default"].mark(function _callee25(recipient) {
                    var limit, offset, data, _args25 = arguments;
                    return $d38f1da47d560f72$var$_regenerator["default"].wrap(function _callee25$(_context25) {
                        while(true)switch(_context25.prev = _context25.next){
                            case 0:
                                limit = _args25.length > 1 && _args25[1] !== undefined ? _args25[1] : 100;
                                offset = _args25.length > 2 && _args25[2] !== undefined ? _args25[2] : 0;
                                _context25.prev = 2;
                                _context25.next = 5;
                                return this._httpClient.request("get", "".concat($d38f1da47d560f72$var$api.getSwaps, "?toAddress=").concat(recipient, "&limit=").concat(limit, "&offset=").concat(offset));
                            case 5:
                                data = _context25.sent;
                                return _context25.abrupt("return", data);
                            case 9:
                                _context25.prev = 9;
                                _context25.t0 = _context25["catch"](2);
                                console.warn("query swap list by swap recipient error", _context25.t0);
                                return _context25.abrupt("return", []);
                            case 13:
                            case "end":
                                return _context25.stop();
                        }
                    }, _callee25, this, [
                        [
                            2,
                            9
                        ]
                    ]);
                }));
                function getSwapByRecipient(_x36) {
                    return _getSwapByRecipient.apply(this, arguments);
                }
                return getSwapByRecipient;
            }()
        },
        {
            key: "createAccount",
            value: function createAccount() {
                var privateKey = $d38f1da47d560f72$var$crypto.generatePrivateKey();
                return {
                    privateKey: privateKey,
                    address: $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix)
                };
            }
        },
        {
            key: "createAccountWithKeystore",
            value: function createAccountWithKeystore(password) {
                if (!password) throw new Error("password should not be falsy");
                var privateKey = $d38f1da47d560f72$var$crypto.generatePrivateKey();
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                var keystore = $d38f1da47d560f72$var$crypto.generateKeyStore(privateKey, password);
                return {
                    privateKey: privateKey,
                    address: address,
                    keystore: keystore
                };
            }
        },
        {
            key: "createAccountWithMneomnic",
            value: function createAccountWithMneomnic() {
                var mnemonic = $d38f1da47d560f72$var$crypto.generateMnemonic();
                var privateKey = $d38f1da47d560f72$var$crypto.getPrivateKeyFromMnemonic(mnemonic);
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                return {
                    privateKey: privateKey,
                    address: address,
                    mnemonic: mnemonic
                };
            }
        },
        {
            key: "recoverAccountFromKeystore",
            value: function recoverAccountFromKeystore(keystore, password) {
                var privateKey = $d38f1da47d560f72$var$crypto.getPrivateKeyFromKeyStore(keystore, password);
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                return {
                    privateKey: privateKey,
                    address: address
                };
            }
        },
        {
            key: "recoverAccountFromMnemonic",
            value: function recoverAccountFromMnemonic(mnemonic) {
                var privateKey = $d38f1da47d560f72$var$crypto.getPrivateKeyFromMnemonic(mnemonic);
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                return {
                    privateKey: privateKey,
                    address: address
                };
            } // support an old method name containing a typo
        },
        {
            key: "recoverAccountFromMneomnic",
            value: function recoverAccountFromMneomnic(mnemonic) {
                return this.recoverAccountFromMnemonic(mnemonic);
            }
        },
        {
            key: "recoverAccountFromPrivateKey",
            value: function recoverAccountFromPrivateKey(privateKey) {
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(privateKey, this.addressPrefix);
                return {
                    privateKey: privateKey,
                    address: address
                };
            }
        },
        {
            key: "checkAddress",
            value: function checkAddress(address) {
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.addressPrefix;
                return $d38f1da47d560f72$var$crypto.checkAddress(address, prefix);
            }
        },
        {
            key: "getClientKeyAddress",
            value: function getClientKeyAddress() {
                if (!this._privateKey) throw new Error("no private key is set on this client");
                var address = $d38f1da47d560f72$var$crypto.getAddressFromPrivateKey(this._privateKey, this.addressPrefix);
                this.address = address;
                return address;
            }
        }
    ]);
    return BncClient;
}();
module.exports.BncClient = $d38f1da47d560f72$var$BncClient;

});
parcelRegister("bfbtb", function(module, exports) {
function $82f9fe10102e948b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $82f9fe10102e948b$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kNrk6", function(module, exports) {

var $7keJs = parcelRequire("7keJs");
function $f23d94100a43e193$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7keJs(descriptor.key), descriptor);
    }
}
function $f23d94100a43e193$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f23d94100a43e193$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f23d94100a43e193$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
module.exports = $f23d94100a43e193$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kM9CL", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $f1ffc181de632b16$var$runtime = (parcelRequire("3pCEE"))();
module.exports = $f1ffc181de632b16$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $f1ffc181de632b16$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $f1ffc181de632b16$var$runtime;
    else Function("r", "regeneratorRuntime = r")($f1ffc181de632b16$var$runtime);
}

});
parcelRegister("3pCEE", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $27c1b0e942ce910b$var$_typeof = $crtHL.default;
function $27c1b0e942ce910b$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return exports;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        return Object.defineProperty(obj, key, {
            value: value,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), obj[key];
    }
    try {
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []);
        return defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        }), generator;
    }
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if ("throw" !== record.type) {
                var result = record.arg, value = result.value;
                return value && "object" == $27c1b0e942ce910b$var$_typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                }) : PromiseImpl.resolve(value).then(function(unwrapped) {
                    result.value = unwrapped, resolve(result);
                }, function(error) {
                    return invoke("throw", error, resolve, reject);
                });
            }
            reject(record.arg);
        }
        var previousPromise;
        defineProperty(this, "_invoke", {
            value: function value(method, arg) {
                function callInvokeWithMethodAndArg() {
                    return new PromiseImpl(function(resolve, reject) {
                        invoke(method, arg, resolve, reject);
                    });
                }
                return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(innerFn, self, context) {
        var state = "suspendedStart";
        return function(method, arg) {
            if ("executing" === state) throw new Error("Generator is already running");
            if ("completed" === state) {
                if ("throw" === method) throw arg;
                return doneResult();
            }
            for(context.method = method, context.arg = arg;;){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if ("next" === context.method) context.sent = context._sent = context.arg;
                else if ("throw" === context.method) {
                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                    context.dispatchException(context.arg);
                } else "return" === context.method && context.abrupt("return", context.arg);
                state = "executing";
                var record = tryCatch(innerFn, self, context);
                if ("normal" === record.type) {
                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                }
                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
            }
        };
    }
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method, method = delegate.iterator[methodName];
        if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
        var record = tryCatch(method, delegate.iterator, context.arg);
        if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
        var info = record.arg;
        return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if ("function" == typeof iterable.next) return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    for(; ++i < iterable.length;){
                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                    }
                    return next.value = undefined, next.done = !0, next;
                };
                return next.next = next;
            }
        }
        return {
            next: doneResult
        };
    }
    function doneResult() {
        return {
            value: undefined,
            done: !0
        };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function(genFun) {
        var ctor = "function" == typeof genFun && genFun.constructor;
        return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function(genFun) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function(arg) {
        return {
            __await: arg
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        void 0 === PromiseImpl && (PromiseImpl = Promise);
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function() {
        return this;
    }), define(Gp, "toString", function() {
        return "[object Generator]";
    }), exports.keys = function(val) {
        var object = Object(val), keys = [];
        for(var key in object)keys.push(key);
        return keys.reverse(), function next() {
            for(; keys.length;){
                var key = keys.pop();
                if (key in object) return next.value = key, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, exports.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for(var name in this)"t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
        },
        stop: function stop() {
            this.done = !0;
            var rootRecord = this.tryEntries[0].completion;
            if ("throw" === rootRecord.type) throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i], record = entry.completion;
                if ("root" === entry.tryLoc) return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                    } else {
                        if (!hasFinally) throw new Error("try statement without catch or finally");
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
            var record = finallyEntry ? finallyEntry.completion : {};
            return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if ("throw" === record.type) throw record.arg;
            return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
            }
        },
        "catch": function _catch(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if ("throw" === record.type) {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            return this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
        }
    }, exports;
}
module.exports = $27c1b0e942ce910b$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dxUGa", function(module, exports) {
function $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $9dca52b7b9a5d7e7$var$_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $9dca52b7b9a5d7e7$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
module.exports = $9dca52b7b9a5d7e7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3qN14", function(module, exports) {
(function(GLOBAL) {
    "use strict";
    var Big, /************************************** EDITABLE DEFAULTS *****************************************/ // The default values below must be integers within the stated ranges.
    /*
     * The maximum number of decimal places (DP) of the results of operations involving division:
     * div and sqrt, and pow with negative exponents.
     */ DP = 20, /*
     * The rounding mode (RM) used when rounding to the above decimal places.
     *
     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
     *  3  Away from zero.                                  (ROUND_UP)
     */ RM = 1, // The maximum value of DP and Big.DP.
    MAX_DP = 1E6, // The maximum magnitude of the exponent argument to the pow method.
    MAX_POWER = 1E6, /*
     * The negative exponent (NE) at and beneath which toString returns exponential notation.
     * (JavaScript numbers: -7)
     * -1000000 is the minimum recommended exponent value of a Big.
     */ NE = -7, /*
     * The positive exponent (PE) at and above which toString returns exponential notation.
     * (JavaScript numbers: 21)
     * 1000000 is the maximum recommended exponent value of a Big.
     * (This limit is not enforced or checked.)
     */ PE = 21, /**************************************************************************************************/ // Error messages.
    NAME = "[big.js] ", INVALID = NAME + "Invalid ", INVALID_DP = INVALID + "decimal places", INVALID_RM = INVALID + "rounding mode", DIV_BY_ZERO = NAME + "Division by zero", // The shared prototype object.
    P = {}, UNDEFINED = void 0, NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
    /*
   * Create and return a Big constructor.
   *
   */ function _Big_() {
        /*
     * The Big constructor and exported function.
     * Create and return a new instance of a Big number object.
     *
     * n {number|string|Big} A numeric value.
     */ function Big(n) {
            var x = this;
            // Enable constructor usage without new.
            if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
            // Duplicate.
            if (n instanceof Big) {
                x.s = n.s;
                x.e = n.e;
                x.c = n.c.slice();
            } else parse(x, n);
            /*
       * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
       * points to Object.
       */ x.constructor = Big;
        }
        Big.prototype = P;
        Big.DP = DP;
        Big.RM = RM;
        Big.NE = NE;
        Big.PE = PE;
        Big.version = "5.2.2";
        return Big;
    }
    /*
   * Parse the number or string value passed to a Big constructor.
   *
   * x {Big} A Big number instance.
   * n {number|string} A numeric value.
   */ function parse(x, n) {
        var e, i, nl;
        // Minus zero?
        if (n === 0 && 1 / n < 0) n = "-0";
        else if (!NUMERIC.test(n += "")) throw Error(INVALID + "number");
        // Determine sign.
        x.s = n.charAt(0) == "-" ? (n = n.slice(1), -1) : 1;
        // Decimal point?
        if ((e = n.indexOf(".")) > -1) n = n.replace(".", "");
        // Exponential form?
        if ((i = n.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +n.slice(i + 1);
            n = n.substring(0, i);
        } else if (e < 0) // Integer.
        e = n.length;
        nl = n.length;
        // Determine leading zeros.
        for(i = 0; i < nl && n.charAt(i) == "0";)++i;
        if (i == nl) // Zero.
        x.c = [
            x.e = 0
        ];
        else {
            // Determine trailing zeros.
            for(; nl > 0 && n.charAt(--nl) == "0";);
            x.e = e - i - 1;
            x.c = [];
            // Convert string to array of digits without leading/trailing zeros.
            for(e = 0; i <= nl;)x.c[e++] = +n.charAt(i++);
        }
        return x;
    }
    /*
   * Round Big x to a maximum of dp decimal places using rounding mode rm.
   * Called by stringify, P.div, P.round and P.sqrt.
   *
   * x {Big} The Big to round.
   * dp {number} Integer, 0 to MAX_DP inclusive.
   * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
   * [more] {boolean} Whether the result of division was truncated.
   */ function round(x, dp, rm, more) {
        var xc = x.c, i = x.e + dp + 1;
        if (i < xc.length) {
            if (rm === 1) // xc[i] is the digit after the digit that may be rounded up.
            more = xc[i] >= 5;
            else if (rm === 2) more = xc[i] > 5 || xc[i] == 5 && (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
            else if (rm === 3) more = more || !!xc[0];
            else {
                more = false;
                if (rm !== 0) throw Error(INVALID_RM);
            }
            if (i < 1) {
                xc.length = 1;
                if (more) {
                    // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                    x.e = -dp;
                    xc[0] = 1;
                } else // Zero.
                xc[0] = x.e = 0;
            } else {
                // Remove any digits after the required decimal places.
                xc.length = i--;
                // Round up?
                if (more) // Rounding up may mean the previous digit has to be rounded up.
                for(; ++xc[i] > 9;){
                    xc[i] = 0;
                    if (!i--) {
                        ++x.e;
                        xc.unshift(1);
                    }
                }
                // Remove trailing zeros.
                for(i = xc.length; !xc[--i];)xc.pop();
            }
        } else if (rm < 0 || rm > 3 || rm !== ~~rm) throw Error(INVALID_RM);
        return x;
    }
    /*
   * Return a string representing the value of Big x in normal or exponential notation.
   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
   *
   * x {Big}
   * id? {number} Caller id.
   *         1 toExponential
   *         2 toFixed
   *         3 toPrecision
   *         4 valueOf
   * n? {number|undefined} Caller's argument.
   * k? {number|undefined}
   */ function stringify(x, id, n, k) {
        var e, s, Big = x.constructor, z = !x.c[0];
        if (n !== UNDEFINED) {
            if (n !== ~~n || n < (id == 3) || n > MAX_DP) throw Error(id == 3 ? INVALID + "precision" : INVALID_DP);
            x = new Big(x);
            // The index of the digit that may be rounded up.
            n = k - x.e;
            // Round?
            if (x.c.length > ++k) round(x, n, Big.RM);
            // toFixed: recalculate k as x.e may have changed if value rounded up.
            if (id == 2) k = x.e + n + 1;
            // Append zeros?
            for(; x.c.length < k;)x.c.push(0);
        }
        e = x.e;
        s = x.c.join("");
        n = s.length;
        // Exponential notation?
        if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) s = s.charAt(0) + (n > 1 ? "." + s.slice(1) : "") + (e < 0 ? "e" : "e+") + e;
        else if (e < 0) {
            for(; ++e;)s = "0" + s;
            s = "0." + s;
        } else if (e > 0) {
            if (++e > n) for(e -= n; e--;)s += "0";
            else if (e < n) s = s.slice(0, e) + "." + s.slice(e);
        } else if (n > 1) s = s.charAt(0) + "." + s.slice(1);
        return x.s < 0 && (!z || id == 4) ? "-" + s : s;
    }
    // Prototype/instance methods
    /*
   * Return a new Big whose value is the absolute value of this Big.
   */ P.abs = function() {
        var x = new this.constructor(this);
        x.s = 1;
        return x;
    };
    /*
   * Return 1 if the value of this Big is greater than the value of Big y,
   *       -1 if the value of this Big is less than the value of Big y, or
   *        0 if they have the same value.
  */ P.cmp = function(y) {
        var isneg, x = this, xc = x.c, yc = (y = new x.constructor(y)).c, i = x.s, j = y.s, k = x.e, l = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
        // Signs differ?
        if (i != j) return i;
        isneg = i < 0;
        // Compare exponents.
        if (k != l) return k > l ^ isneg ? 1 : -1;
        j = (k = xc.length) < (l = yc.length) ? k : l;
        // Compare digit by digit.
        for(i = -1; ++i < j;){
            if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
        }
        // Compare lengths.
        return k == l ? 0 : k > l ^ isneg ? 1 : -1;
    };
    /*
   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.div = function(y) {
        var x = this, Big = x.constructor, a = x.c, b = (y = new Big(y)).c, k = x.s == y.s ? 1 : -1, dp = Big.DP;
        if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
        // Divisor is zero?
        if (!b[0]) throw Error(DIV_BY_ZERO);
        // Dividend is 0? Return +-0.
        if (!a[0]) return new Big(k * 0);
        var bl, bt, n, cmp, ri, bz = b.slice(), ai = bl = b.length, al = a.length, r = a.slice(0, bl), rl = r.length, q = y, qc = q.c = [], qi = 0, d = dp + (q.e = x.e - y.e) + 1; // number of digits of the result
        q.s = k;
        k = d < 0 ? 0 : d;
        // Create version of divisor with leading zero.
        bz.unshift(0);
        // Add zeros to make remainder as long as divisor.
        for(; rl++ < bl;)r.push(0);
        do {
            // n is how many times the divisor goes into current remainder.
            for(n = 0; n < 10; n++){
                // Compare divisor and remainder.
                if (bl != (rl = r.length)) cmp = bl > rl ? 1 : -1;
                else {
                    for(ri = -1, cmp = 0; ++ri < bl;)if (b[ri] != r[ri]) {
                        cmp = b[ri] > r[ri] ? 1 : -1;
                        break;
                    }
                }
                // If divisor < remainder, subtract divisor from remainder.
                if (cmp < 0) {
                    // Remainder can't be more than 1 digit longer than divisor.
                    // Equalise lengths using divisor with extra leading zero?
                    for(bt = rl == bl ? b : bz; rl;){
                        if (r[--rl] < bt[rl]) {
                            ri = rl;
                            for(; ri && !r[--ri];)r[ri] = 9;
                            --r[ri];
                            r[rl] += 10;
                        }
                        r[rl] -= bt[rl];
                    }
                    for(; !r[0];)r.shift();
                } else break;
            }
            // Add the digit n to the result array.
            qc[qi++] = cmp ? n : ++n;
            // Update the remainder.
            if (r[0] && cmp) r[rl] = a[ai] || 0;
            else r = [
                a[ai]
            ];
        }while ((ai++ < al || r[0] !== UNDEFINED) && k--);
        // Leading zero? Do not remove if result is simply zero (qi == 1).
        if (!qc[0] && qi != 1) {
            // There can't be more than one zero.
            qc.shift();
            q.e--;
        }
        // Round?
        if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);
        return q;
    };
    /*
   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
   */ P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return true if the value of this Big is greater than the value of Big y, otherwise return
   * false.
   */ P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
   * return false.
   */ P.gte = function(y) {
        return this.cmp(y) > -1;
    };
    /*
   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
   */ P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
   * return false.
   */ P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return a new Big whose value is the value of this Big minus the value of Big y.
   */ P.minus = P.sub = function(y) {
        var i, j, t, xlty, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.plus(y);
        }
        var xc = x.c.slice(), xe = x.e, yc = y.c, ye = y.e;
        // Either zero?
        if (!xc[0] || !yc[0]) // y is non-zero? x is non-zero? Or both are zero.
        return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
        // Determine which is the bigger number. Prepend zeros to equalise exponents.
        if (a = xe - ye) {
            if (xlty = a < 0) {
                a = -a;
                t = xc;
            } else {
                ye = xe;
                t = yc;
            }
            t.reverse();
            for(b = a; b--;)t.push(0);
            t.reverse();
        } else {
            // Exponents equal. Check digit by digit.
            j = ((xlty = xc.length < yc.length) ? xc : yc).length;
            for(a = b = 0; b < j; b++)if (xc[b] != yc[b]) {
                xlty = xc[b] < yc[b];
                break;
            }
        }
        // x < y? Point xc to the array of the bigger number.
        if (xlty) {
            t = xc;
            xc = yc;
            yc = t;
            y.s = -y.s;
        }
        /*
     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
     * needs to start at yc.length.
     */ if ((b = (j = yc.length) - (i = xc.length)) > 0) for(; b--;)xc[i++] = 0;
        // Subtract yc from xc.
        for(b = i; j > a;){
            if (xc[--j] < yc[j]) {
                for(i = j; i && !xc[--i];)xc[i] = 9;
                --xc[i];
                xc[j] += 10;
            }
            xc[j] -= yc[j];
        }
        // Remove trailing zeros.
        for(; xc[--b] === 0;)xc.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xc[0] === 0;){
            xc.shift();
            --ye;
        }
        if (!xc[0]) {
            // n - n = +0
            y.s = 1;
            // Result must be zero.
            xc = [
                ye = 0
            ];
        }
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a new Big whose value is the value of this Big modulo the value of Big y.
   */ P.mod = function(y) {
        var ygtx, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        if (!y.c[0]) throw Error(DIV_BY_ZERO);
        x.s = y.s = 1;
        ygtx = y.cmp(x) == 1;
        x.s = a;
        y.s = b;
        if (ygtx) return new Big(x);
        a = Big.DP;
        b = Big.RM;
        Big.DP = Big.RM = 0;
        x = x.div(y);
        Big.DP = a;
        Big.RM = b;
        return this.minus(x.times(y));
    };
    /*
   * Return a new Big whose value is the value of this Big plus the value of Big y.
   */ P.plus = P.add = function(y) {
        var t, x = this, Big = x.constructor, a = x.s, b = (y = new Big(y)).s;
        // Signs differ?
        if (a != b) {
            y.s = -b;
            return x.minus(y);
        }
        var xe = x.e, xc = x.c, ye = y.e, yc = y.c;
        // Either zero? y is non-zero? x is non-zero? Or both are zero.
        if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);
        xc = xc.slice();
        // Prepend zeros to equalise exponents.
        // Note: reverse faster than unshifts.
        if (a = xe - ye) {
            if (a > 0) {
                ye = xe;
                t = yc;
            } else {
                a = -a;
                t = xc;
            }
            t.reverse();
            for(; a--;)t.push(0);
            t.reverse();
        }
        // Point xc to the longer array.
        if (xc.length - yc.length < 0) {
            t = yc;
            yc = xc;
            xc = t;
        }
        a = yc.length;
        // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
        for(b = 0; a; xc[a] %= 10)b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        if (b) {
            xc.unshift(b);
            ++ye;
        }
        // Remove trailing zeros.
        for(a = xc.length; xc[--a] === 0;)xc.pop();
        y.c = xc;
        y.e = ye;
        return y;
    };
    /*
   * Return a Big whose value is the value of this Big raised to the power n.
   * If n is negative, round to a maximum of Big.DP decimal places using rounding
   * mode Big.RM.
   *
   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
   */ P.pow = function(n) {
        var x = this, one = new x.constructor(1), y = one, isneg = n < 0;
        if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + "exponent");
        if (isneg) n = -n;
        for(;;){
            if (n & 1) y = y.times(x);
            n >>= 1;
            if (!n) break;
            x = x.times(x);
        }
        return isneg ? one.div(y) : y;
    };
    /*
   * Return a new Big whose value is the value of this Big rounded using rounding mode rm
   * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
   * multiple of 10**-dp.
   * If dp is not specified, round to 0 decimal places.
   * If rm is not specified, use Big.RM.
   *
   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
   * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
   */ P.round = function(dp, rm) {
        var Big = this.constructor;
        if (dp === UNDEFINED) dp = 0;
        else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
        return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
    };
    /*
   * Return a new Big whose value is the square root of the value of this Big, rounded, if
   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
   */ P.sqrt = function() {
        var r, c, t, x = this, Big = x.constructor, s = x.s, e = x.e, half = new Big(0.5);
        // Zero?
        if (!x.c[0]) return new Big(x);
        // Negative?
        if (s < 0) throw Error(NAME + "No square root");
        // Estimate.
        s = Math.sqrt(x + "");
        // Math.sqrt underflow/overflow?
        // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
        if (s === 0 || s === 1 / 0) {
            c = x.c.join("");
            if (!(c.length + e & 1)) c += "0";
            s = Math.sqrt(c);
            e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
            r = new Big((s == 1 / 0 ? "1e" : (s = s.toExponential()).slice(0, s.indexOf("e") + 1)) + e);
        } else r = new Big(s);
        e = r.e + (Big.DP += 4);
        // Newton-Raphson iteration.
        do {
            t = r;
            r = half.times(t.plus(x.div(t)));
        }while (t.c.slice(0, e).join("") !== r.c.slice(0, e).join(""));
        return round(r, Big.DP -= 4, Big.RM);
    };
    /*
   * Return a new Big whose value is the value of this Big times the value of Big y.
   */ P.times = P.mul = function(y) {
        var c, x = this, Big = x.constructor, xc = x.c, yc = (y = new Big(y)).c, a = xc.length, b = yc.length, i = x.e, j = y.e;
        // Determine sign of result.
        y.s = x.s == y.s ? 1 : -1;
        // Return signed 0 if either 0.
        if (!xc[0] || !yc[0]) return new Big(y.s * 0);
        // Initialise exponent of result as x.e + y.e.
        y.e = i + j;
        // If array xc has fewer digits than yc, swap xc and yc, and lengths.
        if (a < b) {
            c = xc;
            xc = yc;
            yc = c;
            j = a;
            a = b;
            b = j;
        }
        // Initialise coefficient array of result with zeros.
        for(c = new Array(j = a + b); j--;)c[j] = 0;
        // Multiply.
        // i is initially xc.length.
        for(i = b; i--;){
            b = 0;
            // a is yc.length.
            for(j = a + i; j > i;){
                // Current sum of products at this digit position, plus carry.
                b = c[j] + yc[i] * xc[j - i - 1] + b;
                c[j--] = b % 10;
                // carry
                b = b / 10 | 0;
            }
            c[j] = (c[j] + b) % 10;
        }
        // Increment result exponent if there is a final carry, otherwise remove leading zero.
        if (b) ++y.e;
        else c.shift();
        // Remove trailing zeros.
        for(i = c.length; !c[--i];)c.pop();
        y.c = c;
        return y;
    };
    /*
   * Return a string representing the value of this Big in exponential notation to dp fixed decimal
   * places and rounded using Big.RM.
   *
   * dp? {number} Integer, 0 to MAX_DP inclusive.
   */ P.toExponential = function(dp) {
        return stringify(this, 1, dp, dp);
    };
    /*
   * Return a string representing the value of this Big in normal notation to dp fixed decimal
   * places and rounded using Big.RM.
   *
   * dp? {number} Integer, 0 to MAX_DP inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   */ P.toFixed = function(dp) {
        return stringify(this, 2, dp, this.e + dp);
    };
    /*
   * Return a string representing the value of this Big rounded to sd significant digits using
   * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * sd {number} Integer, 1 to MAX_DP inclusive.
   */ P.toPrecision = function(sd) {
        return stringify(this, 3, sd, sd - 1);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Omit the sign for negative zero.
   */ P.toString = function() {
        return stringify(this);
    };
    /*
   * Return a string representing the value of this Big.
   * Return exponential notation if this Big has a positive exponent equal to or greater than
   * Big.PE, or a negative exponent equal to or less than Big.NE.
   * Include the sign for negative zero.
   */ P.valueOf = P.toJSON = function() {
        return stringify(this, 4);
    };
    // Export
    Big = _Big_();
    Big["default"] = Big.Big = Big;
    //AMD.
    if (typeof define === "function" && define.amd) define(function() {
        return Big;
    });
    else if (0, module.exports) module.exports = Big;
    else GLOBAL.Big = Big;
})(module.exports);

});

parcelRegister("kYX0e", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f4672df49b90cc5a$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getPrivateKeyFromMnemonic = module.exports.validateMnemonic = module.exports.generateMnemonic = module.exports.getPrivateKeyFromKeyStore = module.exports.generateKeyStore = module.exports.verifySignature = module.exports.generateSignature = module.exports.getAddressFromPrivateKey = module.exports.getAddressFromPublicKey = module.exports.generatePubKey = module.exports.getPublicKeyFromPrivateKey = module.exports.getPublicKey = module.exports.generateRandomArray = module.exports.generatePrivateKey = module.exports.encodeAddress = module.exports.checkAddress = module.exports.decodeAddress = void 0;

var $f4672df49b90cc5a$var$_bech = $2ZnTs((parcelRequire("5wgCY")));

var $f4672df49b90cc5a$var$bip32 = $3sU9H((parcelRequire("8AB7q")));

var $f4672df49b90cc5a$var$bip39 = $3sU9H((parcelRequire("5qnT8")));

var $f4672df49b90cc5a$var$_cryptoBrowserify = $2ZnTs((parcelRequire("aO8Ot")));

var $8J1ou = parcelRequire("8J1ou");

var $f4672df49b90cc5a$var$_is_js = $2ZnTs((parcelRequire("2zdJh")));

var $f4672df49b90cc5a$var$_secureRandom = $2ZnTs((parcelRequire("5E8Co")));

var $f4672df49b90cc5a$var$_tinySecp256k = $2ZnTs((parcelRequire("bAAqK")));

var $f4672df49b90cc5a$var$_uuid = $2ZnTs((parcelRequire("luOI8")));

var $1ZFs6 = parcelRequire("1ZFs6");
// secp256k1 privkey is 32 bytes
var $f4672df49b90cc5a$var$PRIVKEY_LEN = 32;
var $f4672df49b90cc5a$var$MNEMONIC_LEN = 256;
var $f4672df49b90cc5a$var$DECODED_ADDRESS_LEN = 20;
var $f4672df49b90cc5a$var$CURVE = "secp256k1"; //hdpath
var $f4672df49b90cc5a$var$HDPATH = "44'/714'/0'/0/";
var $f4672df49b90cc5a$var$ec = new $8J1ou.ec($f4672df49b90cc5a$var$CURVE);
/**
 * Decodes an address in bech32 format.
 * @category crypto
 * @param {string} value the bech32 address to decode
 */ var $f4672df49b90cc5a$var$decodeAddress = function decodeAddress(value) {
    var decodeAddress = $f4672df49b90cc5a$var$_bech["default"].decode(value);
    return $f4672df49b90cc5a$require$Buffer.from($f4672df49b90cc5a$var$_bech["default"].fromWords(decodeAddress.words));
};
/**
 * Checks whether an address is valid.
 * @category crypto
 * @param {string} address the bech32 address to decode
 * @param {string} hrp the prefix to check for the bech32 address
 * @return {boolean}
 */ module.exports.decodeAddress = $f4672df49b90cc5a$var$decodeAddress;
var $f4672df49b90cc5a$var$checkAddress = function checkAddress(address, hrp) {
    try {
        if (!address.startsWith(hrp)) return false;
        var decodedAddress = $f4672df49b90cc5a$var$_bech["default"].decode(address);
        var decodedAddressLength = $f4672df49b90cc5a$var$decodeAddress(address).length;
        if (decodedAddressLength === $f4672df49b90cc5a$var$DECODED_ADDRESS_LEN && decodedAddress.prefix === hrp) return true;
        return false;
    } catch (err) {
        return false;
    }
};
/**
 * Encodes an address from input data bytes.
 * @category crypto
 * @param {string} value the public key to encode
 * @param {*} prefix the address prefix
 * @param {*} type the output type (default: hex)
 */ module.exports.checkAddress = $f4672df49b90cc5a$var$checkAddress;
var $f4672df49b90cc5a$var$encodeAddress = function encodeAddress(value) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "tbnb";
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "hex";
    var words;
    if ($f4672df49b90cc5a$require$Buffer.isBuffer(value)) words = $f4672df49b90cc5a$var$_bech["default"].toWords($f4672df49b90cc5a$require$Buffer.from(value));
    else words = $f4672df49b90cc5a$var$_bech["default"].toWords($f4672df49b90cc5a$require$Buffer.from(value, type));
    return $f4672df49b90cc5a$var$_bech["default"].encode(prefix, words);
};
/**
 * Generates 32 bytes of random entropy
 * @category crypto
 * @param {number} len output length (default: 32 bytes)
 * @returns {string} entropy bytes hexstring
 */ module.exports.encodeAddress = $f4672df49b90cc5a$var$encodeAddress;
var $f4672df49b90cc5a$var$generatePrivateKey = function generatePrivateKey() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f4672df49b90cc5a$var$PRIVKEY_LEN;
    return (0, $1ZFs6.ab2hexstring)((0, $f4672df49b90cc5a$var$_secureRandom["default"])(len));
};
/**
 * Generates an arrayBuffer filled with random bits.
 * @category crypto
 * @param {number} length - Length of buffer.
 * @returns {ArrayBuffer}
 */ module.exports.generatePrivateKey = $f4672df49b90cc5a$var$generatePrivateKey;
var $f4672df49b90cc5a$var$generateRandomArray = function generateRandomArray(length) {
    return (0, $f4672df49b90cc5a$var$_secureRandom["default"])(length);
};
/**
 * @category crypto
 * @param {string} publicKey - Encoded public key
 * @return {Elliptic.PublicKey} public key hexstring
 */ module.exports.generateRandomArray = $f4672df49b90cc5a$var$generateRandomArray;
var $f4672df49b90cc5a$var$getPublicKey = function getPublicKey(publicKey) {
    var keyPair = $f4672df49b90cc5a$var$ec.keyFromPublic(publicKey, "hex");
    return keyPair.getPublic();
};
/**
 * Calculates the public key from a given private key.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring
 * @return {string} public key hexstring
 */ module.exports.getPublicKey = $f4672df49b90cc5a$var$getPublicKey;
var $f4672df49b90cc5a$var$getPublicKeyFromPrivateKey = function getPublicKeyFromPrivateKey(privateKeyHex) {
    if (!privateKeyHex || privateKeyHex.length !== $f4672df49b90cc5a$var$PRIVKEY_LEN * 2) throw new Error("invalid privateKey");
    var curve = new $8J1ou.ec($f4672df49b90cc5a$var$CURVE);
    var keypair = curve.keyFromPrivate(privateKeyHex, "hex");
    var unencodedPubKey = keypair.getPublic().encode("hex", false);
    return unencodedPubKey;
};
/**
 * PubKey performs the point-scalar multiplication from the privKey on the
 * generator point to get the pubkey.
 * @category crypto
 * @param {Buffer} privateKey
 * @return {Elliptic.PublicKey} PubKey
 * */ module.exports.getPublicKeyFromPrivateKey = $f4672df49b90cc5a$var$getPublicKeyFromPrivateKey;
var $f4672df49b90cc5a$var$generatePubKey = function generatePubKey(privateKey) {
    var curve = new $8J1ou.ec($f4672df49b90cc5a$var$CURVE);
    var keypair = curve.keyFromPrivate(privateKey);
    return keypair.getPublic();
};
/**
 * Gets an address from a public key hex.
 * @category crypto
 * @param {string} publicKeyHex the public key hexstring
 * @param {string} prefix the address prefix
 */ module.exports.generatePubKey = $f4672df49b90cc5a$var$generatePubKey;
var $f4672df49b90cc5a$var$getAddressFromPublicKey = function getAddressFromPublicKey(publicKeyHex, prefix) {
    var pubKey = $f4672df49b90cc5a$var$ec.keyFromPublic(publicKeyHex, "hex");
    var pubPoint = pubKey.getPublic();
    var compressed = pubPoint.encodeCompressed();
    var hexed = (0, $1ZFs6.ab2hexstring)(compressed);
    var hash = (0, $1ZFs6.sha256ripemd160)(hexed); // https://git.io/fAn8N
    var address = $f4672df49b90cc5a$var$encodeAddress(hash, prefix);
    return address;
};
/**
 * Gets an address from a private key.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring
 * @param {string} prefix the address prefix
 */ module.exports.getAddressFromPublicKey = $f4672df49b90cc5a$var$getAddressFromPublicKey;
var $f4672df49b90cc5a$var$getAddressFromPrivateKey = function getAddressFromPrivateKey(privateKeyHex, prefix) {
    return $f4672df49b90cc5a$var$getAddressFromPublicKey($f4672df49b90cc5a$var$getPublicKeyFromPrivateKey(privateKeyHex), prefix);
};
/**
 * Generates a signature (64 byte <r,s>) for a transaction based on given private key.
 * @category crypto
 * @param {string} signBytesHex - Unsigned transaction sign bytes hexstring.
 * @param {string | Buffer} privateKey - The private key.
 * @return {Buffer} Signature. Does not include tx.
 */ module.exports.getAddressFromPrivateKey = $f4672df49b90cc5a$var$getAddressFromPrivateKey;
var $f4672df49b90cc5a$var$generateSignature = function generateSignature(signBytesHex, privateKey) {
    var msgHash = (0, $1ZFs6.sha256)(signBytesHex);
    var msgHashHex = $f4672df49b90cc5a$require$Buffer.from(msgHash, "hex");
    var signature = $f4672df49b90cc5a$var$_tinySecp256k["default"].sign(msgHashHex, typeof privateKey === "string" ? $f4672df49b90cc5a$require$Buffer.from(privateKey, "hex") : privateKey);
    return signature;
};
/**
 * Verifies a signature (64 byte <r,s>) given the sign bytes and public key.
 * @category crypto
 * @param {string} sigHex - The signature hexstring.
 * @param {string} signBytesHex - Unsigned transaction sign bytes hexstring.
 * @param {string} publicKeyHex - The public key.
 * @return {boolean}
 */ module.exports.generateSignature = $f4672df49b90cc5a$var$generateSignature;
var $f4672df49b90cc5a$var$verifySignature = function verifySignature(sigHex, signBytesHex, publicKeyHex) {
    var publicKey = $f4672df49b90cc5a$require$Buffer.from(publicKeyHex, "hex");
    if (!$f4672df49b90cc5a$var$_tinySecp256k["default"].isPoint(publicKey)) throw new Error("Invalid public key provided");
    var msgHash = (0, $1ZFs6.sha256)(signBytesHex);
    var msgHashHex = $f4672df49b90cc5a$require$Buffer.from(msgHash, "hex");
    return $f4672df49b90cc5a$var$_tinySecp256k["default"].verify(msgHashHex, publicKey, $f4672df49b90cc5a$require$Buffer.from(sigHex, "hex"));
};
/**
 * Generates a keystore object (web3 secret storage format) given a private key to store and a password.
 * @category crypto
 * @param {string} privateKeyHex the private key hexstring.
 * @param {string} password the password.
 * @return {object} the keystore object.
 */ module.exports.verifySignature = $f4672df49b90cc5a$var$verifySignature;
var $f4672df49b90cc5a$var$generateKeyStore = function generateKeyStore(privateKeyHex, password) {
    var salt = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].randomBytes(32);
    var iv = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].randomBytes(16);
    var cipherAlg = "aes-256-ctr";
    var kdf = "pbkdf2";
    var kdfparams = {
        dklen: 32,
        salt: salt.toString("hex"),
        c: 262144,
        prf: "hmac-sha256"
    };
    var derivedKey = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].pbkdf2Sync($f4672df49b90cc5a$require$Buffer.from(password), salt, kdfparams.c, kdfparams.dklen, "sha256");
    var cipher = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].createCipheriv(cipherAlg, derivedKey.slice(0, 32), iv);
    if (!cipher) throw new Error("Unsupported cipher");
    var ciphertext = $f4672df49b90cc5a$require$Buffer.concat([
        cipher.update($f4672df49b90cc5a$require$Buffer.from(privateKeyHex, "hex")),
        cipher["final"]()
    ]);
    var bufferValue = $f4672df49b90cc5a$require$Buffer.concat([
        derivedKey.slice(16, 32),
        ciphertext
    ]);
    return {
        version: 1,
        id: $f4672df49b90cc5a$var$_uuid["default"].v4({
            random: $f4672df49b90cc5a$var$_cryptoBrowserify["default"].randomBytes(16)
        }),
        crypto: {
            ciphertext: ciphertext.toString("hex"),
            cipherparams: {
                iv: iv.toString("hex")
            },
            cipher: cipherAlg,
            kdf: kdf,
            kdfparams: kdfparams,
            // mac must use sha3 according to web3 secret storage spec
            mac: (0, $1ZFs6.sha3)(bufferValue.toString("hex"))
        }
    };
};
/**
 * Gets a private key from a keystore given its password.
 * @category crypto
 * @param {string} keystore the keystore in json format
 * @param {string} password the password.
 */ module.exports.generateKeyStore = $f4672df49b90cc5a$var$generateKeyStore;
var $f4672df49b90cc5a$var$getPrivateKeyFromKeyStore = function getPrivateKeyFromKeyStore(keystore, password) {
    if (!$f4672df49b90cc5a$var$_is_js["default"].string(password)) throw new Error("No password given.");
    var json = $f4672df49b90cc5a$var$_is_js["default"].object(keystore) ? keystore : JSON.parse(keystore);
    var kdfparams = json.crypto.kdfparams;
    if (kdfparams.prf !== "hmac-sha256") throw new Error("Unsupported parameters to PBKDF2");
    var derivedKey = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].pbkdf2Sync($f4672df49b90cc5a$require$Buffer.from(password), $f4672df49b90cc5a$require$Buffer.from(kdfparams.salt, "hex"), kdfparams.c, kdfparams.dklen, "sha256");
    var ciphertext = $f4672df49b90cc5a$require$Buffer.from(json.crypto.ciphertext, "hex");
    var bufferValue = $f4672df49b90cc5a$require$Buffer.concat([
        derivedKey.slice(16, 32),
        ciphertext
    ]); // try sha3 (new / ethereum keystore) mac first
    var mac = (0, $1ZFs6.sha3)(bufferValue.toString("hex"));
    if (mac !== json.crypto.mac) {
        // the legacy (sha256) mac is next to be checked. pre-testnet keystores used a sha256 digest for the mac.
        // the sha256 mac was not compatible with ethereum keystores, so it was changed to sha3 for mainnet.
        var macLegacy = (0, $1ZFs6.sha256)(bufferValue.toString("hex"));
        if (macLegacy !== json.crypto.mac) throw new Error("Keystore mac check failed (sha3 & sha256) - wrong password?");
    }
    var decipher = $f4672df49b90cc5a$var$_cryptoBrowserify["default"].createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 32), $f4672df49b90cc5a$require$Buffer.from(json.crypto.cipherparams.iv, "hex"));
    var privateKey = $f4672df49b90cc5a$require$Buffer.concat([
        decipher.update(ciphertext),
        decipher["final"]()
    ]).toString("hex");
    return privateKey;
};
/**
 * Generates mnemonic phrase words using random entropy.
 * @category crypto
 */ module.exports.getPrivateKeyFromKeyStore = $f4672df49b90cc5a$var$getPrivateKeyFromKeyStore;
var $f4672df49b90cc5a$var$generateMnemonic = function generateMnemonic() {
    return $f4672df49b90cc5a$var$bip39.generateMnemonic($f4672df49b90cc5a$var$MNEMONIC_LEN);
};
/**
 * Validates mnemonic phrase words.
 * @ignore
 * @param {string} mnemonic the mnemonic phrase words
 * @return {bool} validation result
 */ module.exports.generateMnemonic = $f4672df49b90cc5a$var$generateMnemonic;
var $f4672df49b90cc5a$var$validateMnemonic = $f4672df49b90cc5a$var$bip39.validateMnemonic;
/**
 * Get a private key from mnemonic words.
 * @category crypto
 * @param {string} mnemonic the mnemonic phrase words
 * @param {Boolean} derive derive a private key using the default HD path (default: true)
 * @param {number} index the bip44 address index (default: 0)
 * @param {string} password according to bip39
 * @return {string} hexstring
 */ module.exports.validateMnemonic = $f4672df49b90cc5a$var$validateMnemonic;
var $f4672df49b90cc5a$var$getPrivateKeyFromMnemonic = function getPrivateKeyFromMnemonic(mnemonic) {
    var derive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var password = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    if (!$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.english) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.chinese_simplified) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.chinese_traditional) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.korean) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.french) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.italian) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.spanish) && !$f4672df49b90cc5a$var$bip39.validateMnemonic(mnemonic, $f4672df49b90cc5a$var$bip39.wordlists.japanese)) throw new Error("wrong mnemonic format");
    var seed = $f4672df49b90cc5a$var$bip39.mnemonicToSeedSync(mnemonic, password);
    if (derive) {
        var master = $f4672df49b90cc5a$var$bip32.fromSeed(seed);
        var child = master.derivePath($f4672df49b90cc5a$var$HDPATH + index);
        if (!child.privateKey) throw new Error("child does not have a privateKey");
        return child.privateKey.toString("hex");
    }
    return seed.toString("hex");
};
module.exports.getPrivateKeyFromMnemonic = $f4672df49b90cc5a$var$getPrivateKeyFromMnemonic;

});
parcelRegister("5wgCY", function(module, exports) {
"use strict";
var $404cd6cca7e8755b$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $404cd6cca7e8755b$var$ALPHABET_MAP = {};
for(var $404cd6cca7e8755b$var$z = 0; $404cd6cca7e8755b$var$z < $404cd6cca7e8755b$var$ALPHABET.length; $404cd6cca7e8755b$var$z++){
    var $404cd6cca7e8755b$var$x = $404cd6cca7e8755b$var$ALPHABET.charAt($404cd6cca7e8755b$var$z);
    if ($404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] !== undefined) throw new TypeError($404cd6cca7e8755b$var$x + " is ambiguous");
    $404cd6cca7e8755b$var$ALPHABET_MAP[$404cd6cca7e8755b$var$x] = $404cd6cca7e8755b$var$z;
}
function $404cd6cca7e8755b$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $404cd6cca7e8755b$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $404cd6cca7e8755b$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $404cd6cca7e8755b$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ x;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $404cd6cca7e8755b$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $404cd6cca7e8755b$var$ALPHABET.charAt(v);
    }
    return result;
}
function $404cd6cca7e8755b$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $404cd6cca7e8755b$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $404cd6cca7e8755b$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $404cd6cca7e8755b$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $404cd6cca7e8755b$var$decodeUnsafe() {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $404cd6cca7e8755b$var$decode(str) {
    var res = $404cd6cca7e8755b$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $404cd6cca7e8755b$var$toWordsUnsafe(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$toWords(bytes) {
    var res = $404cd6cca7e8755b$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $404cd6cca7e8755b$var$fromWordsUnsafe(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $404cd6cca7e8755b$var$fromWords(words) {
    var res = $404cd6cca7e8755b$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
module.exports = {
    decodeUnsafe: $404cd6cca7e8755b$var$decodeUnsafe,
    decode: $404cd6cca7e8755b$var$decode,
    encode: $404cd6cca7e8755b$var$encode,
    toWordsUnsafe: $404cd6cca7e8755b$var$toWordsUnsafe,
    toWords: $404cd6cca7e8755b$var$toWords,
    fromWordsUnsafe: $404cd6cca7e8755b$var$fromWordsUnsafe,
    fromWords: $404cd6cca7e8755b$var$fromWords
};

});

parcelRegister("8AB7q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jzgQH = parcelRequire("jzgQH");
module.exports.fromSeed = $jzgQH.fromSeed;
module.exports.fromBase58 = $jzgQH.fromBase58;
module.exports.fromPublicKey = $jzgQH.fromPublicKey;
module.exports.fromPrivateKey = $jzgQH.fromPrivateKey;

});
parcelRegister("jzgQH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e3ee5b147894d49f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fuOE5 = parcelRequire("fuOE5");

var $1Vf4C = parcelRequire("1Vf4C");

var $bAAqK = parcelRequire("bAAqK");

var $bDP98 = parcelRequire("bDP98");

var $bTFmB = parcelRequire("bTFmB");
const $e3ee5b147894d49f$var$UINT256_TYPE = $bDP98.BufferN(32);
const $e3ee5b147894d49f$var$NETWORK_TYPE = $bDP98.compile({
    wif: $bDP98.UInt8,
    bip32: {
        public: $bDP98.UInt32,
        private: $bDP98.UInt32
    }
});
const $e3ee5b147894d49f$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $e3ee5b147894d49f$var$HIGHEST_BIT = 0x80000000;
const $e3ee5b147894d49f$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e3ee5b147894d49f$var$BIP32Path(value) {
    return $bDP98.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $e3ee5b147894d49f$var$UInt31(value) {
    return $bDP98.UInt32(value) && value <= $e3ee5b147894d49f$var$UINT31_MAX;
}
class $e3ee5b147894d49f$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $bDP98($e3ee5b147894d49f$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $bAAqK.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $fuOE5.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $e3ee5b147894d49f$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $e3ee5b147894d49f$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $1Vf4C.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $bTFmB.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $bDP98($bDP98.UInt32, index);
        const isHardened = index >= $e3ee5b147894d49f$var$HIGHEST_BIT;
        const data = $e3ee5b147894d49f$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $fuOE5.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$bAAqK.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $bAAqK.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $bAAqK.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $bDP98($e3ee5b147894d49f$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $e3ee5b147894d49f$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $bDP98($e3ee5b147894d49f$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $bAAqK.sign(hash, this.privateKey);
        else {
            let sig = $bAAqK.sign(hash, this.privateKey);
            const extraData = $e3ee5b147894d49f$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $bAAqK.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $bAAqK.verify(hash, this.publicKey, signature);
    }
}
function $e3ee5b147894d49f$var$fromBase58(inString, network) {
    const buffer = $1Vf4C.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $e3ee5b147894d49f$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $e3ee5b147894d49f$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
module.exports.fromBase58 = $e3ee5b147894d49f$var$fromBase58;
function $e3ee5b147894d49f$var$fromPrivateKey(privateKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
module.exports.fromPrivateKey = $e3ee5b147894d49f$var$fromPrivateKey;
function $e3ee5b147894d49f$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        privateKey: $e3ee5b147894d49f$var$UINT256_TYPE,
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    if (!$bAAqK.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $e3ee5b147894d49f$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromPublicKey(publicKey, chainCode, network) {
    return $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
module.exports.fromPublicKey = $e3ee5b147894d49f$var$fromPublicKey;
function $e3ee5b147894d49f$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $bDP98({
        publicKey: $bDP98.BufferN(33),
        chainCode: $e3ee5b147894d49f$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$bAAqK.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $e3ee5b147894d49f$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $e3ee5b147894d49f$var$fromSeed(seed, network) {
    $bDP98($bDP98.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $e3ee5b147894d49f$var$BITCOIN;
    const I = $fuOE5.hmacSHA512($e3ee5b147894d49f$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $e3ee5b147894d49f$var$fromPrivateKey(IL, IR, network);
}
module.exports.fromSeed = $e3ee5b147894d49f$var$fromSeed;

});
parcelRegister("fuOE5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");

var $cUvgf = parcelRequire("cUvgf");
function $b480f183ee1f31a5$var$hash160(buffer) {
    const sha256Hash = $3FiLE("sha256").update(buffer).digest();
    try {
        return $3FiLE("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $3FiLE("ripemd160").update(sha256Hash).digest();
    }
}
module.exports.hash160 = $b480f183ee1f31a5$var$hash160;
function $b480f183ee1f31a5$var$hmacSHA512(key, data) {
    return $cUvgf("sha512", key).update(data).digest();
}
module.exports.hmacSHA512 = $b480f183ee1f31a5$var$hmacSHA512;

});

parcelRegister("1Vf4C", function(module, exports) {
"use strict";

var $3FiLE = parcelRequire("3FiLE");

var $g1FRD = parcelRequire("g1FRD");
// SHA256(SHA256(buffer))
function $1666ce9de42769b3$var$sha256x2(buffer) {
    var tmp = $3FiLE("sha256").update(buffer).digest();
    return $3FiLE("sha256").update(tmp).digest();
}
module.exports = $g1FRD($1666ce9de42769b3$var$sha256x2);

});
parcelRegister("g1FRD", function(module, exports) {
"use strict";

var $hZS7n = parcelRequire("hZS7n");

var $6U9mG = parcelRequire("6U9mG");
var $baad36aa31fd3816$require$Buffer = $6U9mG.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $hZS7n.encode($baad36aa31fd3816$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $hZS7n.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $hZS7n.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("hZS7n", function(module, exports) {

var $kG2My = parcelRequire("kG2My");
var $d1a21cdb0a134c34$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $kG2My($d1a21cdb0a134c34$var$ALPHABET);

});
parcelRegister("kG2My", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $f0d9e357f46e8580$require$_Buffer = $6U9mG.Buffer;
function $f0d9e357f46e8580$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $f0d9e357f46e8580$require$_Buffer.from(source);
        if (!$f0d9e357f46e8580$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $f0d9e357f46e8580$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip leading spaces.
        if (source[psz] === " ") return;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip trailing spaces.
        if (source[psz] === " ") return;
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $f0d9e357f46e8580$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $f0d9e357f46e8580$var$base;

});




parcelRegister("bAAqK", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $86ff50d9446c20a0$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $8J1ou = parcelRequire("8J1ou");
var $86ff50d9446c20a0$require$EC = $8J1ou.ec;
const $86ff50d9446c20a0$var$secp256k1 = new $86ff50d9446c20a0$require$EC("secp256k1");

var $6JcDT = parcelRequire("6JcDT");
const $86ff50d9446c20a0$var$ZERO32 = $86ff50d9446c20a0$require$Buffer.alloc(32, 0);
const $86ff50d9446c20a0$var$EC_GROUP_ORDER = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $86ff50d9446c20a0$var$EC_P = $86ff50d9446c20a0$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $86ff50d9446c20a0$var$n = $86ff50d9446c20a0$var$secp256k1.curve.n;
const $86ff50d9446c20a0$var$nDiv2 = $86ff50d9446c20a0$var$n.shrn(1);
const $86ff50d9446c20a0$var$G = $86ff50d9446c20a0$var$secp256k1.curve.g;
const $86ff50d9446c20a0$var$THROW_BAD_PRIVATE = "Expected Private";
const $86ff50d9446c20a0$var$THROW_BAD_POINT = "Expected Point";
const $86ff50d9446c20a0$var$THROW_BAD_TWEAK = "Expected Tweak";
const $86ff50d9446c20a0$var$THROW_BAD_HASH = "Expected Hash";
const $86ff50d9446c20a0$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $86ff50d9446c20a0$var$isScalar(x) {
    return $86ff50d9446c20a0$require$Buffer.isBuffer(x) && x.length === 32;
}
function $86ff50d9446c20a0$var$isOrderScalar(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isPoint(p) {
    if (!$86ff50d9446c20a0$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (x.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $86ff50d9446c20a0$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($86ff50d9446c20a0$var$ZERO32) === 0) return false;
    if (y.compare($86ff50d9446c20a0$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $86ff50d9446c20a0$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $86ff50d9446c20a0$var$isPointCompressed(p) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) return false;
    return $86ff50d9446c20a0$var$__isPointCompressed(p);
}
function $86ff50d9446c20a0$var$isPrivate(x) {
    if (!$86ff50d9446c20a0$var$isScalar(x)) return false;
    return x.compare($86ff50d9446c20a0$var$ZERO32) > 0 && // > 0
    x.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $86ff50d9446c20a0$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $86ff50d9446c20a0$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0 && s.compare($86ff50d9446c20a0$var$EC_GROUP_ORDER) < 0;
}
function $86ff50d9446c20a0$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $86ff50d9446c20a0$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $86ff50d9446c20a0$var$fromBuffer(d) {
    return new $7vYz3(d);
}
function $86ff50d9446c20a0$var$toBuffer(d) {
    return d.toArrayLike($86ff50d9446c20a0$require$Buffer, "be", 32);
}
function $86ff50d9446c20a0$var$decodeFrom(P) {
    return $86ff50d9446c20a0$var$secp256k1.curve.decodePoint(P);
}
function $86ff50d9446c20a0$var$getEncoded(P, compressed) {
    return $86ff50d9446c20a0$require$Buffer.from(P._encode(compressed));
}
function $86ff50d9446c20a0$var$pointAdd(pA, pB, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(pA)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isPoint(pB)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const a = $86ff50d9446c20a0$var$decodeFrom(pA);
    const b = $86ff50d9446c20a0$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, pA);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointAddScalar(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (tweak.compare($86ff50d9446c20a0$var$ZERO32) === 0) return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = $86ff50d9446c20a0$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(uu, compressed);
}
function $86ff50d9446c20a0$var$pointCompress(p, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointFromScalar(d, __compressed) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const pp = $86ff50d9446c20a0$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed);
    return $86ff50d9446c20a0$var$getEncoded(pp, compressed);
}
function $86ff50d9446c20a0$var$pointMultiply(p, tweak, __compressed) {
    if (!$86ff50d9446c20a0$var$isPoint(p)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const compressed = $86ff50d9446c20a0$var$assumeCompression(__compressed, p);
    const pp = $86ff50d9446c20a0$var$decodeFrom(p);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $86ff50d9446c20a0$var$getEncoded(qq, compressed);
}
function $86ff50d9446c20a0$var$privateAdd(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.add(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$privateSub(d, tweak) {
    if (!$86ff50d9446c20a0$var$isPrivate(d)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (!$86ff50d9446c20a0$var$isOrderScalar(tweak)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_TWEAK);
    const dd = $86ff50d9446c20a0$var$fromBuffer(d);
    const tt = $86ff50d9446c20a0$var$fromBuffer(tweak);
    const dt = $86ff50d9446c20a0$var$toBuffer(dd.sub(tt).umod($86ff50d9446c20a0$var$n));
    if (!$86ff50d9446c20a0$var$isPrivate(dt)) return null;
    return dt;
}
function $86ff50d9446c20a0$var$sign(hash, x) {
    return $86ff50d9446c20a0$var$__sign(hash, x);
}
function $86ff50d9446c20a0$var$signWithEntropy(hash, x, addData) {
    return $86ff50d9446c20a0$var$__sign(hash, x, addData);
}
function $86ff50d9446c20a0$var$__sign(hash, x, addData) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPrivate(x)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$86ff50d9446c20a0$var$isScalar(addData)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_EXTRA_DATA);
    const d = $86ff50d9446c20a0$var$fromBuffer(x);
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $86ff50d9446c20a0$var$fromBuffer(k);
        const Q = $86ff50d9446c20a0$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($86ff50d9446c20a0$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($86ff50d9446c20a0$var$n).mul(e.add(d.mul(r))).umod($86ff50d9446c20a0$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $6JcDT(hash, x, checkSig, $86ff50d9446c20a0$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) s = $86ff50d9446c20a0$var$n.sub(s);
    const buffer = $86ff50d9446c20a0$require$Buffer.allocUnsafe(64);
    $86ff50d9446c20a0$var$toBuffer(r).copy(buffer, 0);
    $86ff50d9446c20a0$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $86ff50d9446c20a0$var$verify(hash, q, signature, strict) {
    if (!$86ff50d9446c20a0$var$isScalar(hash)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_HASH);
    if (!$86ff50d9446c20a0$var$isPoint(q)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$86ff50d9446c20a0$var$isSignature(signature)) throw new TypeError($86ff50d9446c20a0$var$THROW_BAD_SIGNATURE);
    const Q = $86ff50d9446c20a0$var$decodeFrom(q);
    const r = $86ff50d9446c20a0$var$fromBuffer(signature.slice(0, 32));
    const s = $86ff50d9446c20a0$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($86ff50d9446c20a0$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $86ff50d9446c20a0$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($86ff50d9446c20a0$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($86ff50d9446c20a0$var$n);
    const u2 = r.mul(sInv).umod($86ff50d9446c20a0$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $86ff50d9446c20a0$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($86ff50d9446c20a0$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
module.exports = {
    isPoint: $86ff50d9446c20a0$var$isPoint,
    isPointCompressed: $86ff50d9446c20a0$var$isPointCompressed,
    isPrivate: $86ff50d9446c20a0$var$isPrivate,
    pointAdd: $86ff50d9446c20a0$var$pointAdd,
    pointAddScalar: $86ff50d9446c20a0$var$pointAddScalar,
    pointCompress: $86ff50d9446c20a0$var$pointCompress,
    pointFromScalar: $86ff50d9446c20a0$var$pointFromScalar,
    pointMultiply: $86ff50d9446c20a0$var$pointMultiply,
    privateAdd: $86ff50d9446c20a0$var$privateAdd,
    privateSub: $86ff50d9446c20a0$var$privateSub,
    sign: $86ff50d9446c20a0$var$sign,
    signWithEntropy: $86ff50d9446c20a0$var$signWithEntropy,
    verify: $86ff50d9446c20a0$var$verify
};

});
parcelRegister("6JcDT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0143a0025c0142a7$require$Buffer = $ihoyg.Buffer;

var $cUvgf = parcelRequire("cUvgf");
const $0143a0025c0142a7$var$ONE1 = $0143a0025c0142a7$require$Buffer.alloc(1, 1);
const $0143a0025c0142a7$var$ZERO1 = $0143a0025c0142a7$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $0143a0025c0142a7$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $0143a0025c0142a7$require$Buffer.alloc(32, 0);
    let v = $0143a0025c0142a7$require$Buffer.alloc(32, 1);
    // Step D
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $cUvgf("sha256", k).update(v).digest();
    // Step F
    k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $cUvgf("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $cUvgf("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $cUvgf("sha256", k).update(v).update($0143a0025c0142a7$var$ZERO1).digest();
        v = $cUvgf("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $cUvgf("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
module.exports = $0143a0025c0142a7$var$deterministicGenerateK;

});


parcelRegister("bDP98", function(module, exports) {

var $5PqjV = parcelRequire("5PqjV");

var $WjcEN = parcelRequire("WjcEN");
// short-hand
var $879b02cdd754e3b5$var$tfJSON = $5PqjV.tfJSON;
var $879b02cdd754e3b5$var$TfTypeError = $5PqjV.TfTypeError;
var $879b02cdd754e3b5$var$TfPropertyTypeError = $5PqjV.TfPropertyTypeError;
var $879b02cdd754e3b5$var$tfSubError = $5PqjV.tfSubError;
var $879b02cdd754e3b5$var$getValueTypeName = $5PqjV.getValueTypeName;
var $879b02cdd754e3b5$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $879b02cdd754e3b5$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$WjcEN.Array(array)) return false;
            if ($WjcEN.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $879b02cdd754e3b5$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $879b02cdd754e3b5$var$compile(type);
        function _maybe(value, strict) {
            return $WjcEN.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $879b02cdd754e3b5$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $879b02cdd754e3b5$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $879b02cdd754e3b5$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyKeyType) + ": " + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $879b02cdd754e3b5$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $879b02cdd754e3b5$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$WjcEN.Object(value)) return false;
            if ($WjcEN.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $879b02cdd754e3b5$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $879b02cdd754e3b5$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $879b02cdd754e3b5$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $879b02cdd754e3b5$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($879b02cdd754e3b5$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $879b02cdd754e3b5$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($879b02cdd754e3b5$var$compile);
        function _tuple(values, strict) {
            if ($WjcEN.Nil(values)) return false;
            if ($WjcEN.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $879b02cdd754e3b5$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $879b02cdd754e3b5$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($879b02cdd754e3b5$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$879b02cdd754e3b5$var$TYPES.oneOf = $879b02cdd754e3b5$var$TYPES.anyOf;
function $879b02cdd754e3b5$var$compile(type) {
    if ($WjcEN.String(type)) {
        if (type[0] === "?") return $879b02cdd754e3b5$var$TYPES.maybe(type.slice(1));
        return $WjcEN[type] || $879b02cdd754e3b5$var$TYPES.quacksLike(type);
    } else if (type && $WjcEN.Object(type)) {
        if ($WjcEN.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $879b02cdd754e3b5$var$TYPES.arrayOf(type[0]);
        }
        return $879b02cdd754e3b5$var$TYPES.object(type);
    } else if ($WjcEN.Function(type)) return type;
    return $879b02cdd754e3b5$var$TYPES.value(type);
}
function $879b02cdd754e3b5$var$typeforce(type, value, strict, surrogate) {
    if ($WjcEN.Function(type)) {
        if (type(value, strict)) return true;
        throw new $879b02cdd754e3b5$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $879b02cdd754e3b5$var$typeforce($879b02cdd754e3b5$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $879b02cdd754e3b5$var$typeName in $WjcEN)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $WjcEN[$879b02cdd754e3b5$var$typeName];
for($879b02cdd754e3b5$var$typeName in $879b02cdd754e3b5$var$TYPES)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $879b02cdd754e3b5$var$TYPES[$879b02cdd754e3b5$var$typeName];

var $i4G8Y = parcelRequire("i4G8Y");
for($879b02cdd754e3b5$var$typeName in $i4G8Y)$879b02cdd754e3b5$var$typeforce[$879b02cdd754e3b5$var$typeName] = $i4G8Y[$879b02cdd754e3b5$var$typeName];
$879b02cdd754e3b5$var$typeforce.compile = $879b02cdd754e3b5$var$compile;
$879b02cdd754e3b5$var$typeforce.TfTypeError = $879b02cdd754e3b5$var$TfTypeError;
$879b02cdd754e3b5$var$typeforce.TfPropertyTypeError = $879b02cdd754e3b5$var$TfPropertyTypeError;
module.exports = $879b02cdd754e3b5$var$typeforce;

});
parcelRegister("5PqjV", function(module, exports) {

var $WjcEN = parcelRequire("WjcEN");
function $43e621d6b47985c7$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $43e621d6b47985c7$var$getValueTypeName(value) {
    return $WjcEN.Nil(value) ? "" : $43e621d6b47985c7$var$getTypeName(value.constructor);
}
function $43e621d6b47985c7$var$getValue(value) {
    if ($WjcEN.Function(value)) return "";
    if ($WjcEN.String(value)) return JSON.stringify(value);
    if (value && $WjcEN.Object(value)) return "";
    return value;
}
function $43e621d6b47985c7$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $43e621d6b47985c7$var$tfJSON(type) {
    if ($WjcEN.Function(type)) return type.toJSON ? type.toJSON() : $43e621d6b47985c7$var$getTypeName(type);
    if ($WjcEN.Array(type)) return "Array";
    if (type && $WjcEN.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $43e621d6b47985c7$var$getValue(value);
    return "Expected " + $43e621d6b47985c7$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $43e621d6b47985c7$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
    this.message = $43e621d6b47985c7$var$tfErrorString(type, value, valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $43e621d6b47985c7$var$tfErrorString('property "' + $43e621d6b47985c7$var$tfJSON(name) + description + $43e621d6b47985c7$var$tfJSON(type), value, valueTypeName);
}
function $43e621d6b47985c7$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $43e621d6b47985c7$var$getValueTypeName(value);
        this.message = $43e621d6b47985c7$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $43e621d6b47985c7$var$captureStackTrace(this, $43e621d6b47985c7$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$43e621d6b47985c7$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$43e621d6b47985c7$var$TfPropertyTypeError.prototype.constructor = $43e621d6b47985c7$var$TfTypeError;
function $43e621d6b47985c7$var$tfCustomError(expected, actual) {
    return new $43e621d6b47985c7$var$TfTypeError(expected, {}, actual);
}
function $43e621d6b47985c7$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $43e621d6b47985c7$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $43e621d6b47985c7$var$TfTypeError) e = new $43e621d6b47985c7$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $43e621d6b47985c7$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $43e621d6b47985c7$var$TfTypeError,
    TfPropertyTypeError: $43e621d6b47985c7$var$TfPropertyTypeError,
    tfCustomError: $43e621d6b47985c7$var$tfCustomError,
    tfSubError: $43e621d6b47985c7$var$tfSubError,
    tfJSON: $43e621d6b47985c7$var$tfJSON,
    getValueTypeName: $43e621d6b47985c7$var$getValueTypeName
};

});
parcelRegister("WjcEN", function(module, exports) {
var $0af4503d1812f988$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$0af4503d1812f988$var$types.Null = $0af4503d1812f988$var$types.Nil;
for(var $0af4503d1812f988$var$typeName in $0af4503d1812f988$var$types)$0af4503d1812f988$var$types[$0af4503d1812f988$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $0af4503d1812f988$var$typeName);
module.exports = $0af4503d1812f988$var$types;

});


parcelRegister("i4G8Y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $03654fa7a69bc7e8$require$Buffer = $ihoyg.Buffer;

var $WjcEN = parcelRequire("WjcEN");

var $5PqjV = parcelRequire("5PqjV");
function $03654fa7a69bc7e8$var$_Buffer(value) {
    return $03654fa7a69bc7e8$require$Buffer.isBuffer(value);
}
function $03654fa7a69bc7e8$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $03654fa7a69bc7e8$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $5PqjV.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $03654fa7a69bc7e8$var$_ArrayN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.Array);
var $03654fa7a69bc7e8$var$_BufferN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$_Buffer);
var $03654fa7a69bc7e8$var$_HexN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $03654fa7a69bc7e8$var$Hex);
var $03654fa7a69bc7e8$var$_StringN = $03654fa7a69bc7e8$var$_LengthN.bind(null, $WjcEN.String);
function $03654fa7a69bc7e8$var$Range(a, b, f) {
    f = f || $WjcEN.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $03654fa7a69bc7e8$var$INT53_MAX = Math.pow(2, 53) - 1;
function $03654fa7a69bc7e8$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $03654fa7a69bc7e8$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $03654fa7a69bc7e8$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $03654fa7a69bc7e8$var$Int32(value) {
    return (value | 0) === value;
}
function $03654fa7a69bc7e8$var$Int53(value) {
    return typeof value === "number" && value >= -$03654fa7a69bc7e8$var$INT53_MAX && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
function $03654fa7a69bc7e8$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $03654fa7a69bc7e8$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $03654fa7a69bc7e8$var$UInt32(value) {
    return value >>> 0 === value;
}
function $03654fa7a69bc7e8$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $03654fa7a69bc7e8$var$INT53_MAX && Math.floor(value) === value;
}
var $03654fa7a69bc7e8$var$types = {
    ArrayN: $03654fa7a69bc7e8$var$_ArrayN,
    Buffer: $03654fa7a69bc7e8$var$_Buffer,
    BufferN: $03654fa7a69bc7e8$var$_BufferN,
    Finite: $03654fa7a69bc7e8$var$Finite,
    Hex: $03654fa7a69bc7e8$var$Hex,
    HexN: $03654fa7a69bc7e8$var$_HexN,
    Int8: $03654fa7a69bc7e8$var$Int8,
    Int16: $03654fa7a69bc7e8$var$Int16,
    Int32: $03654fa7a69bc7e8$var$Int32,
    Int53: $03654fa7a69bc7e8$var$Int53,
    Range: $03654fa7a69bc7e8$var$Range,
    StringN: $03654fa7a69bc7e8$var$_StringN,
    UInt8: $03654fa7a69bc7e8$var$UInt8,
    UInt16: $03654fa7a69bc7e8$var$UInt16,
    UInt32: $03654fa7a69bc7e8$var$UInt32,
    UInt53: $03654fa7a69bc7e8$var$UInt53
};
for(var $03654fa7a69bc7e8$var$typeName in $03654fa7a69bc7e8$var$types)$03654fa7a69bc7e8$var$types[$03654fa7a69bc7e8$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $03654fa7a69bc7e8$var$typeName);
module.exports = $03654fa7a69bc7e8$var$types;

});


parcelRegister("bTFmB", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a94eab3b5d39034$require$Buffer = $ihoyg.Buffer;

var $1Vf4C = parcelRequire("1Vf4C");
function $8a94eab3b5d39034$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed) {
    var result = new $8a94eab3b5d39034$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $8a94eab3b5d39034$var$decode(string, version) {
    return $8a94eab3b5d39034$var$decodeRaw($1Vf4C.decode(string), version);
}
function $8a94eab3b5d39034$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version, privateKey, compressed));
    return $1Vf4C.encode($8a94eab3b5d39034$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
module.exports = {
    decode: $8a94eab3b5d39034$var$decode,
    decodeRaw: $8a94eab3b5d39034$var$decodeRaw,
    encode: $8a94eab3b5d39034$var$encode,
    encodeRaw: $8a94eab3b5d39034$var$encodeRaw
};

});



parcelRegister("5qnT8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $3f31e9298802700a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");

var $1UZ5c = parcelRequire("1UZ5c");

var $5rfiH = parcelRequire("5rfiH");

var $guT51 = parcelRequire("guT51");
let $3f31e9298802700a$var$DEFAULT_WORDLIST = $guT51._default;
const $3f31e9298802700a$var$INVALID_MNEMONIC = "Invalid mnemonic";
const $3f31e9298802700a$var$INVALID_ENTROPY = "Invalid entropy";
const $3f31e9298802700a$var$INVALID_CHECKSUM = "Invalid mnemonic checksum";
const $3f31e9298802700a$var$WORDLIST_REQUIRED = "A wordlist is required but a default could not be found.\nPlease pass a 2048 word array explicitly.";
function $3f31e9298802700a$var$pbkdf2Promise(password, saltMixin, iterations, keylen, digest) {
    return Promise.resolve().then(()=>new Promise((resolve, reject)=>{
            const callback = (err, derivedKey)=>{
                if (err) return reject(err);
                else return resolve(derivedKey);
            };
            $1UZ5c.pbkdf2(password, saltMixin, iterations, keylen, digest, callback);
        }));
}
function $3f31e9298802700a$var$normalize(str) {
    return (str || "").normalize("NFKD");
}
function $3f31e9298802700a$var$lpad(str, padString, length) {
    while(str.length < length)str = padString + str;
    return str;
}
function $3f31e9298802700a$var$binaryToByte(bin) {
    return parseInt(bin, 2);
}
function $3f31e9298802700a$var$bytesToBinary(bytes) {
    return bytes.map((x)=>$3f31e9298802700a$var$lpad(x.toString(2), "0", 8)).join("");
}
function $3f31e9298802700a$var$deriveChecksumBits(entropyBuffer) {
    const ENT = entropyBuffer.length * 8;
    const CS = ENT / 32;
    const hash = $3FiLE("sha256").update(entropyBuffer).digest();
    return $3f31e9298802700a$var$bytesToBinary(Array.from(hash)).slice(0, CS);
}
function $3f31e9298802700a$var$salt(password) {
    return "mnemonic" + (password || "");
}
function $3f31e9298802700a$var$mnemonicToSeedSync(mnemonic, password) {
    const mnemonicBuffer = $3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8");
    const saltBuffer = $3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8");
    return $1UZ5c.pbkdf2Sync(mnemonicBuffer, saltBuffer, 2048, 64, "sha512");
}
module.exports.mnemonicToSeedSync = $3f31e9298802700a$var$mnemonicToSeedSync;
function $3f31e9298802700a$var$mnemonicToSeed(mnemonic, password) {
    return Promise.resolve().then(()=>{
        const mnemonicBuffer = $3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$normalize(mnemonic), "utf8");
        const saltBuffer = $3f31e9298802700a$require$Buffer.from($3f31e9298802700a$var$salt($3f31e9298802700a$var$normalize(password)), "utf8");
        return $3f31e9298802700a$var$pbkdf2Promise(mnemonicBuffer, saltBuffer, 2048, 64, "sha512");
    });
}
module.exports.mnemonicToSeed = $3f31e9298802700a$var$mnemonicToSeed;
function $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist) {
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    const words = $3f31e9298802700a$var$normalize(mnemonic).split(" ");
    if (words.length % 3 !== 0) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
    // convert word indices to 11 bit binary strings
    const bits = words.map((word)=>{
        const index = wordlist.indexOf(word);
        if (index === -1) throw new Error($3f31e9298802700a$var$INVALID_MNEMONIC);
        return $3f31e9298802700a$var$lpad(index.toString(2), "0", 11);
    }).join("");
    // split the binary string into ENT/CS
    const dividerIndex = Math.floor(bits.length / 33) * 32;
    const entropyBits = bits.slice(0, dividerIndex);
    const checksumBits = bits.slice(dividerIndex);
    // calculate the checksum and compare
    const entropyBytes = entropyBits.match(/(.{1,8})/g).map($3f31e9298802700a$var$binaryToByte);
    if (entropyBytes.length < 16) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length > 32) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropyBytes.length % 4 !== 0) throw new Error($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropy = $3f31e9298802700a$require$Buffer.from(entropyBytes);
    const newChecksum = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    if (newChecksum !== checksumBits) throw new Error($3f31e9298802700a$var$INVALID_CHECKSUM);
    return entropy.toString("hex");
}
module.exports.mnemonicToEntropy = $3f31e9298802700a$var$mnemonicToEntropy;
function $3f31e9298802700a$var$entropyToMnemonic(entropy, wordlist) {
    if (!$3f31e9298802700a$require$Buffer.isBuffer(entropy)) entropy = $3f31e9298802700a$require$Buffer.from(entropy, "hex");
    wordlist = wordlist || $3f31e9298802700a$var$DEFAULT_WORDLIST;
    if (!wordlist) throw new Error($3f31e9298802700a$var$WORDLIST_REQUIRED);
    // 128 <= ENT <= 256
    if (entropy.length < 16) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length > 32) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    if (entropy.length % 4 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    const entropyBits = $3f31e9298802700a$var$bytesToBinary(Array.from(entropy));
    const checksumBits = $3f31e9298802700a$var$deriveChecksumBits(entropy);
    const bits = entropyBits + checksumBits;
    const chunks = bits.match(/(.{1,11})/g);
    const words = chunks.map((binary)=>{
        const index = $3f31e9298802700a$var$binaryToByte(binary);
        return wordlist[index];
    });
    return wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093" // Japanese wordlist
     ? words.join("\u3000") : words.join(" ");
}
module.exports.entropyToMnemonic = $3f31e9298802700a$var$entropyToMnemonic;
function $3f31e9298802700a$var$generateMnemonic(strength, rng, wordlist) {
    strength = strength || 128;
    if (strength % 32 !== 0) throw new TypeError($3f31e9298802700a$var$INVALID_ENTROPY);
    rng = rng || $5rfiH;
    return $3f31e9298802700a$var$entropyToMnemonic(rng(strength / 8), wordlist);
}
module.exports.generateMnemonic = $3f31e9298802700a$var$generateMnemonic;
function $3f31e9298802700a$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $3f31e9298802700a$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
module.exports.validateMnemonic = $3f31e9298802700a$var$validateMnemonic;
function $3f31e9298802700a$var$setDefaultWordlist(language) {
    const result = $guT51.wordlists[language];
    if (result) $3f31e9298802700a$var$DEFAULT_WORDLIST = result;
    else throw new Error('Could not find wordlist for language "' + language + '"');
}
module.exports.setDefaultWordlist = $3f31e9298802700a$var$setDefaultWordlist;
function $3f31e9298802700a$var$getDefaultWordlist() {
    if (!$3f31e9298802700a$var$DEFAULT_WORDLIST) throw new Error("No Default Wordlist set");
    return Object.keys($guT51.wordlists).filter((lang)=>{
        if (lang === "JA" || lang === "EN") return false;
        return $guT51.wordlists[lang].every((word, index)=>word === $3f31e9298802700a$var$DEFAULT_WORDLIST[index]);
    })[0];
}
module.exports.getDefaultWordlist = $3f31e9298802700a$var$getDefaultWordlist;

var $guT51 = parcelRequire("guT51");
module.exports.wordlists = $guT51.wordlists;

});
parcelRegister("guT51", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// browserify by default only pulls in files that are hard coded in requires
// In order of last to first in this file, the default wordlist will be chosen
// based on what is present. (Bundles may remove wordlists they don't need)
const $c02a2c711f53a649$var$wordlists = {};
module.exports.wordlists = $c02a2c711f53a649$var$wordlists;
let $c02a2c711f53a649$var$_default;
module.exports._default = $c02a2c711f53a649$var$_default;

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4YRZc"));
    $c02a2c711f53a649$var$wordlists.czech = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("gmhgI"));
    $c02a2c711f53a649$var$wordlists.chinese_simplified = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("9FVoO"));
    $c02a2c711f53a649$var$wordlists.chinese_traditional = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("4M2Fv"));
    $c02a2c711f53a649$var$wordlists.korean = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("eFCbz"));
    $c02a2c711f53a649$var$wordlists.french = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("hrLhZ"));
    $c02a2c711f53a649$var$wordlists.italian = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("911oV"));
    $c02a2c711f53a649$var$wordlists.spanish = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("lW32h"));
    $c02a2c711f53a649$var$wordlists.japanese = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.JA = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("g6Pks"));
    $c02a2c711f53a649$var$wordlists.portuguese = $c02a2c711f53a649$var$_default;
} catch (err) {}

try {
    module.exports._default = $c02a2c711f53a649$var$_default = (parcelRequire("ml96a"));
    $c02a2c711f53a649$var$wordlists.english = $c02a2c711f53a649$var$_default;
    $c02a2c711f53a649$var$wordlists.EN = $c02a2c711f53a649$var$_default;
} catch (err) {}

});
parcelRegister("4YRZc", function(module, exports) {
module.exports = JSON.parse('["abdikace","abeceda","adresa","agrese","akce","aktovka","alej","alkohol","amputace","ananas","andulka","anekdota","anketa","antika","anulovat","archa","arogance","asfalt","asistent","aspirace","astma","astronom","atlas","atletika","atol","autobus","azyl","babka","bachor","bacil","baculka","badatel","bageta","bagr","bahno","bakterie","balada","baletka","balkon","balonek","balvan","balza","bambus","bankomat","barbar","baret","barman","baroko","barva","baterka","batoh","bavlna","bazalka","bazilika","bazuka","bedna","beran","beseda","bestie","beton","bezinka","bezmoc","beztak","bicykl","bidlo","biftek","bikiny","bilance","biograf","biolog","bitva","bizon","blahobyt","blatouch","blecha","bledule","blesk","blikat","blizna","blokovat","bloudit","blud","bobek","bobr","bodlina","bodnout","bohatost","bojkot","bojovat","bokorys","bolest","borec","borovice","bota","boubel","bouchat","bouda","boule","bourat","boxer","bradavka","brambora","branka","bratr","brepta","briketa","brko","brloh","bronz","broskev","brunetka","brusinka","brzda","brzy","bublina","bubnovat","buchta","buditel","budka","budova","bufet","bujarost","bukvice","buldok","bulva","bunda","bunkr","burza","butik","buvol","buzola","bydlet","bylina","bytovka","bzukot","capart","carevna","cedr","cedule","cejch","cejn","cela","celer","celkem","celnice","cenina","cennost","cenovka","centrum","cenzor","cestopis","cetka","chalupa","chapadlo","charita","chata","chechtat","chemie","chichot","chirurg","chlad","chleba","chlubit","chmel","chmura","chobot","chochol","chodba","cholera","chomout","chopit","choroba","chov","chrapot","chrlit","chrt","chrup","chtivost","chudina","chutnat","chvat","chvilka","chvost","chyba","chystat","chytit","cibule","cigareta","cihelna","cihla","cinkot","cirkus","cisterna","citace","citrus","cizinec","cizost","clona","cokoliv","couvat","ctitel","ctnost","cudnost","cuketa","cukr","cupot","cvaknout","cval","cvik","cvrkot","cyklista","daleko","dareba","datel","datum","dcera","debata","dechovka","decibel","deficit","deflace","dekl","dekret","demokrat","deprese","derby","deska","detektiv","dikobraz","diktovat","dioda","diplom","disk","displej","divadlo","divoch","dlaha","dlouho","dluhopis","dnes","dobro","dobytek","docent","dochutit","dodnes","dohled","dohoda","dohra","dojem","dojnice","doklad","dokola","doktor","dokument","dolar","doleva","dolina","doma","dominant","domluvit","domov","donutit","dopad","dopis","doplnit","doposud","doprovod","dopustit","dorazit","dorost","dort","dosah","doslov","dostatek","dosud","dosyta","dotaz","dotek","dotknout","doufat","doutnat","dovozce","dozadu","doznat","dozorce","drahota","drak","dramatik","dravec","draze","drdol","drobnost","drogerie","drozd","drsnost","drtit","drzost","duben","duchovno","dudek","duha","duhovka","dusit","dusno","dutost","dvojice","dvorec","dynamit","ekolog","ekonomie","elektron","elipsa","email","emise","emoce","empatie","epizoda","epocha","epopej","epos","esej","esence","eskorta","eskymo","etiketa","euforie","evoluce","exekuce","exkurze","expedice","exploze","export","extrakt","facka","fajfka","fakulta","fanatik","fantazie","farmacie","favorit","fazole","federace","fejeton","fenka","fialka","figurant","filozof","filtr","finance","finta","fixace","fjord","flanel","flirt","flotila","fond","fosfor","fotbal","fotka","foton","frakce","freska","fronta","fukar","funkce","fyzika","galeje","garant","genetika","geolog","gilotina","glazura","glejt","golem","golfista","gotika","graf","gramofon","granule","grep","gril","grog","groteska","guma","hadice","hadr","hala","halenka","hanba","hanopis","harfa","harpuna","havran","hebkost","hejkal","hejno","hejtman","hektar","helma","hematom","herec","herna","heslo","hezky","historik","hladovka","hlasivky","hlava","hledat","hlen","hlodavec","hloh","hloupost","hltat","hlubina","hluchota","hmat","hmota","hmyz","hnis","hnojivo","hnout","hoblina","hoboj","hoch","hodiny","hodlat","hodnota","hodovat","hojnost","hokej","holinka","holka","holub","homole","honitba","honorace","horal","horda","horizont","horko","horlivec","hormon","hornina","horoskop","horstvo","hospoda","hostina","hotovost","houba","houf","houpat","houska","hovor","hradba","hranice","hravost","hrazda","hrbolek","hrdina","hrdlo","hrdost","hrnek","hrobka","hromada","hrot","hrouda","hrozen","hrstka","hrubost","hryzat","hubenost","hubnout","hudba","hukot","humr","husita","hustota","hvozd","hybnost","hydrant","hygiena","hymna","hysterik","idylka","ihned","ikona","iluze","imunita","infekce","inflace","inkaso","inovace","inspekce","internet","invalida","investor","inzerce","ironie","jablko","jachta","jahoda","jakmile","jakost","jalovec","jantar","jarmark","jaro","jasan","jasno","jatka","javor","jazyk","jedinec","jedle","jednatel","jehlan","jekot","jelen","jelito","jemnost","jenom","jepice","jeseter","jevit","jezdec","jezero","jinak","jindy","jinoch","jiskra","jistota","jitrnice","jizva","jmenovat","jogurt","jurta","kabaret","kabel","kabinet","kachna","kadet","kadidlo","kahan","kajak","kajuta","kakao","kaktus","kalamita","kalhoty","kalibr","kalnost","kamera","kamkoliv","kamna","kanibal","kanoe","kantor","kapalina","kapela","kapitola","kapka","kaple","kapota","kapr","kapusta","kapybara","karamel","karotka","karton","kasa","katalog","katedra","kauce","kauza","kavalec","kazajka","kazeta","kazivost","kdekoliv","kdesi","kedluben","kemp","keramika","kino","klacek","kladivo","klam","klapot","klasika","klaun","klec","klenba","klepat","klesnout","klid","klima","klisna","klobouk","klokan","klopa","kloub","klubovna","klusat","kluzkost","kmen","kmitat","kmotr","kniha","knot","koalice","koberec","kobka","kobliha","kobyla","kocour","kohout","kojenec","kokos","koktejl","kolaps","koleda","kolize","kolo","komando","kometa","komik","komnata","komora","kompas","komunita","konat","koncept","kondice","konec","konfese","kongres","konina","konkurs","kontakt","konzerva","kopanec","kopie","kopnout","koprovka","korbel","korektor","kormidlo","koroptev","korpus","koruna","koryto","korzet","kosatec","kostka","kotel","kotleta","kotoul","koukat","koupelna","kousek","kouzlo","kovboj","koza","kozoroh","krabice","krach","krajina","kralovat","krasopis","kravata","kredit","krejcar","kresba","kreveta","kriket","kritik","krize","krkavec","krmelec","krmivo","krocan","krok","kronika","kropit","kroupa","krovka","krtek","kruhadlo","krupice","krutost","krvinka","krychle","krypta","krystal","kryt","kudlanka","kufr","kujnost","kukla","kulajda","kulich","kulka","kulomet","kultura","kuna","kupodivu","kurt","kurzor","kutil","kvalita","kvasinka","kvestor","kynolog","kyselina","kytara","kytice","kytka","kytovec","kyvadlo","labrador","lachtan","ladnost","laik","lakomec","lamela","lampa","lanovka","lasice","laso","lastura","latinka","lavina","lebka","leckdy","leden","lednice","ledovka","ledvina","legenda","legie","legrace","lehce","lehkost","lehnout","lektvar","lenochod","lentilka","lepenka","lepidlo","letadlo","letec","letmo","letokruh","levhart","levitace","levobok","libra","lichotka","lidojed","lidskost","lihovina","lijavec","lilek","limetka","linie","linka","linoleum","listopad","litina","litovat","lobista","lodivod","logika","logoped","lokalita","loket","lomcovat","lopata","lopuch","lord","losos","lotr","loudal","louh","louka","louskat","lovec","lstivost","lucerna","lucifer","lump","lusk","lustrace","lvice","lyra","lyrika","lysina","madam","madlo","magistr","mahagon","majetek","majitel","majorita","makak","makovice","makrela","malba","malina","malovat","malvice","maminka","mandle","manko","marnost","masakr","maskot","masopust","matice","matrika","maturita","mazanec","mazivo","mazlit","mazurka","mdloba","mechanik","meditace","medovina","melasa","meloun","mentolka","metla","metoda","metr","mezera","migrace","mihnout","mihule","mikina","mikrofon","milenec","milimetr","milost","mimika","mincovna","minibar","minomet","minulost","miska","mistr","mixovat","mladost","mlha","mlhovina","mlok","mlsat","mluvit","mnich","mnohem","mobil","mocnost","modelka","modlitba","mohyla","mokro","molekula","momentka","monarcha","monokl","monstrum","montovat","monzun","mosaz","moskyt","most","motivace","motorka","motyka","moucha","moudrost","mozaika","mozek","mozol","mramor","mravenec","mrkev","mrtvola","mrzet","mrzutost","mstitel","mudrc","muflon","mulat","mumie","munice","muset","mutace","muzeum","muzikant","myslivec","mzda","nabourat","nachytat","nadace","nadbytek","nadhoz","nadobro","nadpis","nahlas","nahnat","nahodile","nahradit","naivita","najednou","najisto","najmout","naklonit","nakonec","nakrmit","nalevo","namazat","namluvit","nanometr","naoko","naopak","naostro","napadat","napevno","naplnit","napnout","naposled","naprosto","narodit","naruby","narychlo","nasadit","nasekat","naslepo","nastat","natolik","navenek","navrch","navzdory","nazvat","nebe","nechat","necky","nedaleko","nedbat","neduh","negace","nehet","nehoda","nejen","nejprve","neklid","nelibost","nemilost","nemoc","neochota","neonka","nepokoj","nerost","nerv","nesmysl","nesoulad","netvor","neuron","nevina","nezvykle","nicota","nijak","nikam","nikdy","nikl","nikterak","nitro","nocleh","nohavice","nominace","nora","norek","nositel","nosnost","nouze","noviny","novota","nozdra","nuda","nudle","nuget","nutit","nutnost","nutrie","nymfa","obal","obarvit","obava","obdiv","obec","obehnat","obejmout","obezita","obhajoba","obilnice","objasnit","objekt","obklopit","oblast","oblek","obliba","obloha","obluda","obnos","obohatit","obojek","obout","obrazec","obrna","obruba","obrys","obsah","obsluha","obstarat","obuv","obvaz","obvinit","obvod","obvykle","obyvatel","obzor","ocas","ocel","ocenit","ochladit","ochota","ochrana","ocitnout","odboj","odbyt","odchod","odcizit","odebrat","odeslat","odevzdat","odezva","odhadce","odhodit","odjet","odjinud","odkaz","odkoupit","odliv","odluka","odmlka","odolnost","odpad","odpis","odplout","odpor","odpustit","odpykat","odrazka","odsoudit","odstup","odsun","odtok","odtud","odvaha","odveta","odvolat","odvracet","odznak","ofina","ofsajd","ohlas","ohnisko","ohrada","ohrozit","ohryzek","okap","okenice","oklika","okno","okouzlit","okovy","okrasa","okres","okrsek","okruh","okupant","okurka","okusit","olejnina","olizovat","omak","omeleta","omezit","omladina","omlouvat","omluva","omyl","onehdy","opakovat","opasek","operace","opice","opilost","opisovat","opora","opozice","opravdu","oproti","orbital","orchestr","orgie","orlice","orloj","ortel","osada","oschnout","osika","osivo","oslava","oslepit","oslnit","oslovit","osnova","osoba","osolit","ospalec","osten","ostraha","ostuda","ostych","osvojit","oteplit","otisk","otop","otrhat","otrlost","otrok","otruby","otvor","ovanout","ovar","oves","ovlivnit","ovoce","oxid","ozdoba","pachatel","pacient","padouch","pahorek","pakt","palanda","palec","palivo","paluba","pamflet","pamlsek","panenka","panika","panna","panovat","panstvo","pantofle","paprika","parketa","parodie","parta","paruka","paryba","paseka","pasivita","pastelka","patent","patrona","pavouk","pazneht","pazourek","pecka","pedagog","pejsek","peklo","peloton","penalta","pendrek","penze","periskop","pero","pestrost","petarda","petice","petrolej","pevnina","pexeso","pianista","piha","pijavice","pikle","piknik","pilina","pilnost","pilulka","pinzeta","pipeta","pisatel","pistole","pitevna","pivnice","pivovar","placenta","plakat","plamen","planeta","plastika","platit","plavidlo","plaz","plech","plemeno","plenta","ples","pletivo","plevel","plivat","plnit","plno","plocha","plodina","plomba","plout","pluk","plyn","pobavit","pobyt","pochod","pocit","poctivec","podat","podcenit","podepsat","podhled","podivit","podklad","podmanit","podnik","podoba","podpora","podraz","podstata","podvod","podzim","poezie","pohanka","pohnutka","pohovor","pohroma","pohyb","pointa","pojistka","pojmout","pokazit","pokles","pokoj","pokrok","pokuta","pokyn","poledne","polibek","polknout","poloha","polynom","pomalu","pominout","pomlka","pomoc","pomsta","pomyslet","ponechat","ponorka","ponurost","popadat","popel","popisek","poplach","poprosit","popsat","popud","poradce","porce","porod","porucha","poryv","posadit","posed","posila","poskok","poslanec","posoudit","pospolu","postava","posudek","posyp","potah","potkan","potlesk","potomek","potrava","potupa","potvora","poukaz","pouto","pouzdro","povaha","povidla","povlak","povoz","povrch","povstat","povyk","povzdech","pozdrav","pozemek","poznatek","pozor","pozvat","pracovat","prahory","praktika","prales","praotec","praporek","prase","pravda","princip","prkno","probudit","procento","prodej","profese","prohra","projekt","prolomit","promile","pronikat","propad","prorok","prosba","proton","proutek","provaz","prskavka","prsten","prudkost","prut","prvek","prvohory","psanec","psovod","pstruh","ptactvo","puberta","puch","pudl","pukavec","puklina","pukrle","pult","pumpa","punc","pupen","pusa","pusinka","pustina","putovat","putyka","pyramida","pysk","pytel","racek","rachot","radiace","radnice","radon","raft","ragby","raketa","rakovina","rameno","rampouch","rande","rarach","rarita","rasovna","rastr","ratolest","razance","razidlo","reagovat","reakce","recept","redaktor","referent","reflex","rejnok","reklama","rekord","rekrut","rektor","reputace","revize","revma","revolver","rezerva","riskovat","riziko","robotika","rodokmen","rohovka","rokle","rokoko","romaneto","ropovod","ropucha","rorejs","rosol","rostlina","rotmistr","rotoped","rotunda","roubenka","roucho","roup","roura","rovina","rovnice","rozbor","rozchod","rozdat","rozeznat","rozhodce","rozinka","rozjezd","rozkaz","rozloha","rozmar","rozpad","rozruch","rozsah","roztok","rozum","rozvod","rubrika","ruchadlo","rukavice","rukopis","ryba","rybolov","rychlost","rydlo","rypadlo","rytina","ryzost","sadista","sahat","sako","samec","samizdat","samota","sanitka","sardinka","sasanka","satelit","sazba","sazenice","sbor","schovat","sebranka","secese","sedadlo","sediment","sedlo","sehnat","sejmout","sekera","sekta","sekunda","sekvoje","semeno","seno","servis","sesadit","seshora","seskok","seslat","sestra","sesuv","sesypat","setba","setina","setkat","setnout","setrvat","sever","seznam","shoda","shrnout","sifon","silnice","sirka","sirotek","sirup","situace","skafandr","skalisko","skanzen","skaut","skeptik","skica","skladba","sklenice","sklo","skluz","skoba","skokan","skoro","skripta","skrz","skupina","skvost","skvrna","slabika","sladidlo","slanina","slast","slavnost","sledovat","slepec","sleva","slezina","slib","slina","sliznice","slon","sloupek","slovo","sluch","sluha","slunce","slupka","slza","smaragd","smetana","smilstvo","smlouva","smog","smrad","smrk","smrtka","smutek","smysl","snad","snaha","snob","sobota","socha","sodovka","sokol","sopka","sotva","souboj","soucit","soudce","souhlas","soulad","soumrak","souprava","soused","soutok","souviset","spalovna","spasitel","spis","splav","spodek","spojenec","spolu","sponzor","spornost","spousta","sprcha","spustit","sranda","sraz","srdce","srna","srnec","srovnat","srpen","srst","srub","stanice","starosta","statika","stavba","stehno","stezka","stodola","stolek","stopa","storno","stoupat","strach","stres","strhnout","strom","struna","studna","stupnice","stvol","styk","subjekt","subtropy","suchar","sudost","sukno","sundat","sunout","surikata","surovina","svah","svalstvo","svetr","svatba","svazek","svisle","svitek","svoboda","svodidlo","svorka","svrab","sykavka","sykot","synek","synovec","sypat","sypkost","syrovost","sysel","sytost","tabletka","tabule","tahoun","tajemno","tajfun","tajga","tajit","tajnost","taktika","tamhle","tampon","tancovat","tanec","tanker","tapeta","tavenina","tazatel","technika","tehdy","tekutina","telefon","temnota","tendence","tenista","tenor","teplota","tepna","teprve","terapie","termoska","textil","ticho","tiskopis","titulek","tkadlec","tkanina","tlapka","tleskat","tlukot","tlupa","tmel","toaleta","topinka","topol","torzo","touha","toulec","tradice","traktor","tramp","trasa","traverza","trefit","trest","trezor","trhavina","trhlina","trochu","trojice","troska","trouba","trpce","trpitel","trpkost","trubec","truchlit","truhlice","trus","trvat","tudy","tuhnout","tuhost","tundra","turista","turnaj","tuzemsko","tvaroh","tvorba","tvrdost","tvrz","tygr","tykev","ubohost","uboze","ubrat","ubrousek","ubrus","ubytovna","ucho","uctivost","udivit","uhradit","ujednat","ujistit","ujmout","ukazatel","uklidnit","uklonit","ukotvit","ukrojit","ulice","ulita","ulovit","umyvadlo","unavit","uniforma","uniknout","upadnout","uplatnit","uplynout","upoutat","upravit","uran","urazit","usednout","usilovat","usmrtit","usnadnit","usnout","usoudit","ustlat","ustrnout","utahovat","utkat","utlumit","utonout","utopenec","utrousit","uvalit","uvolnit","uvozovka","uzdravit","uzel","uzenina","uzlina","uznat","vagon","valcha","valoun","vana","vandal","vanilka","varan","varhany","varovat","vcelku","vchod","vdova","vedro","vegetace","vejce","velbloud","veletrh","velitel","velmoc","velryba","venkov","veranda","verze","veselka","veskrze","vesnice","vespodu","vesta","veterina","veverka","vibrace","vichr","videohra","vidina","vidle","vila","vinice","viset","vitalita","vize","vizitka","vjezd","vklad","vkus","vlajka","vlak","vlasec","vlevo","vlhkost","vliv","vlnovka","vloupat","vnucovat","vnuk","voda","vodivost","vodoznak","vodstvo","vojensky","vojna","vojsko","volant","volba","volit","volno","voskovka","vozidlo","vozovna","vpravo","vrabec","vracet","vrah","vrata","vrba","vrcholek","vrhat","vrstva","vrtule","vsadit","vstoupit","vstup","vtip","vybavit","vybrat","vychovat","vydat","vydra","vyfotit","vyhledat","vyhnout","vyhodit","vyhradit","vyhubit","vyjasnit","vyjet","vyjmout","vyklopit","vykonat","vylekat","vymazat","vymezit","vymizet","vymyslet","vynechat","vynikat","vynutit","vypadat","vyplatit","vypravit","vypustit","vyrazit","vyrovnat","vyrvat","vyslovit","vysoko","vystavit","vysunout","vysypat","vytasit","vytesat","vytratit","vyvinout","vyvolat","vyvrhel","vyzdobit","vyznat","vzadu","vzbudit","vzchopit","vzdor","vzduch","vzdychat","vzestup","vzhledem","vzkaz","vzlykat","vznik","vzorek","vzpoura","vztah","vztek","xylofon","zabrat","zabydlet","zachovat","zadarmo","zadusit","zafoukat","zahltit","zahodit","zahrada","zahynout","zajatec","zajet","zajistit","zaklepat","zakoupit","zalepit","zamezit","zamotat","zamyslet","zanechat","zanikat","zaplatit","zapojit","zapsat","zarazit","zastavit","zasunout","zatajit","zatemnit","zatknout","zaujmout","zavalit","zavelet","zavinit","zavolat","zavrtat","zazvonit","zbavit","zbrusu","zbudovat","zbytek","zdaleka","zdarma","zdatnost","zdivo","zdobit","zdroj","zdvih","zdymadlo","zelenina","zeman","zemina","zeptat","zezadu","zezdola","zhatit","zhltnout","zhluboka","zhotovit","zhruba","zima","zimnice","zjemnit","zklamat","zkoumat","zkratka","zkumavka","zlato","zlehka","zloba","zlom","zlost","zlozvyk","zmapovat","zmar","zmatek","zmije","zmizet","zmocnit","zmodrat","zmrzlina","zmutovat","znak","znalost","znamenat","znovu","zobrazit","zotavit","zoubek","zoufale","zplodit","zpomalit","zprava","zprostit","zprudka","zprvu","zrada","zranit","zrcadlo","zrnitost","zrno","zrovna","zrychlit","zrzavost","zticha","ztratit","zubovina","zubr","zvednout","zvenku","zvesela","zvon","zvrat","zvukovod","zvyk"]');

});

parcelRegister("gmhgI", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u8FD9","\u4E2D","\u5927","\u4E3A","\u4E0A","\u4E2A","\u56FD","\u6211","\u4EE5","\u8981","\u4ED6","\u65F6","\u6765","\u7528","\u4EEC","\u751F","\u5230","\u4F5C","\u5730","\u4E8E","\u51FA","\u5C31","\u5206","\u5BF9","\u6210","\u4F1A","\u53EF","\u4E3B","\u53D1","\u5E74","\u52A8","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u8FC7","\u5B50","\u8BF4","\u4EA7","\u79CD","\u9762","\u800C","\u65B9","\u540E","\u591A","\u5B9A","\u884C","\u5B66","\u6CD5","\u6240","\u6C11","\u5F97","\u7ECF","\u5341","\u4E09","\u4E4B","\u8FDB","\u7740","\u7B49","\u90E8","\u5EA6","\u5BB6","\u7535","\u529B","\u91CC","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73B0","\u5B9E","\u52A0","\u91CF","\u90FD","\u4E24","\u4F53","\u5236","\u673A","\u5F53","\u4F7F","\u70B9","\u4ECE","\u4E1A","\u672C","\u53BB","\u628A","\u6027","\u597D","\u5E94","\u5F00","\u5B83","\u5408","\u8FD8","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u4E49","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u95F4","\u6837","\u4E0E","\u5173","\u5404","\u91CD","\u65B0","\u7EBF","\u5185","\u6570","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u4E48","\u5229","\u6BD4","\u6216","\u4F46","\u8D28","\u6C14","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u53D8","\u6761","\u53EA","\u6CA1","\u7ED3","\u89E3","\u95EE","\u610F","\u5EFA","\u6708","\u516C","\u65E0","\u7CFB","\u519B","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u5E76","\u63D0","\u76F4","\u9898","\u515A","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u5458","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u603B","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8BBE","\u53CA","\u7BA1","\u7279","\u4EF6","\u957F","\u6C42","\u8001","\u5934","\u57FA","\u8D44","\u8FB9","\u6D41","\u8DEF","\u7EA7","\u5C11","\u56FE","\u5C71","\u7EDF","\u63A5","\u77E5","\u8F83","\u5C06","\u7EC4","\u89C1","\u8BA1","\u522B","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8BBA","\u8FD0","\u519C","\u6307","\u51E0","\u4E5D","\u533A","\u5F3A","\u653E","\u51B3","\u897F","\u88AB","\u5E72","\u505A","\u5FC5","\u6218","\u5148","\u56DE","\u5219","\u4EFB","\u53D6","\u636E","\u5904","\u961F","\u5357","\u7ED9","\u8272","\u5149","\u95E8","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u89C4","\u70ED","\u9886","\u4E03","\u6D77","\u53E3","\u4E1C","\u5BFC","\u5668","\u538B","\u5FD7","\u4E16","\u91D1","\u589E","\u4E89","\u6D4E","\u9636","\u6CB9","\u601D","\u672F","\u6781","\u4EA4","\u53D7","\u8054","\u4EC0","\u8BA4","\u516D","\u5171","\u6743","\u6536","\u8BC1","\u6539","\u6E05","\u7F8E","\u518D","\u91C7","\u8F6C","\u66F4","\u5355","\u98CE","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E26","\u5B89","\u573A","\u8EAB","\u8F66","\u4F8B","\u771F","\u52A1","\u5177","\u4E07","\u6BCF","\u76EE","\u81F3","\u8FBE","\u8D70","\u79EF","\u793A","\u8BAE","\u58F0","\u62A5","\u6597","\u5B8C","\u7C7B","\u516B","\u79BB","\u534E","\u540D","\u786E","\u624D","\u79D1","\u5F20","\u4FE1","\u9A6C","\u8282","\u8BDD","\u7C73","\u6574","\u7A7A","\u5143","\u51B5","\u4ECA","\u96C6","\u6E29","\u4F20","\u571F","\u8BB8","\u6B65","\u7FA4","\u5E7F","\u77F3","\u8BB0","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C2","\u8D8A","\u7EC7","\u88C5","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u4F17","\u4E66","\u5E03","\u590D","\u5BB9","\u513F","\u987B","\u9645","\u5546","\u975E","\u9A8C","\u8FDE","\u65AD","\u6DF1","\u96BE","\u8FD1","\u77FF","\u5343","\u5468","\u59D4","\u7D20","\u6280","\u5907","\u534A","\u529E","\u9752","\u7701","\u5217","\u4E60","\u54CD","\u7EA6","\u652F","\u822C","\u53F2","\u611F","\u52B3","\u4FBF","\u56E2","\u5F80","\u9178","\u5386","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u6784","\u5E9C","\u79F0","\u592A","\u51C6","\u7CBE","\u503C","\u53F7","\u7387","\u65CF","\u7EF4","\u5212","\u9009","\u6807","\u5199","\u5B58","\u5019","\u6BDB","\u4EB2","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u517B","\u6613","\u7F6E","\u6D3E","\u5C42","\u7247","\u59CB","\u5374","\u4E13","\u72B6","\u80B2","\u5382","\u4EAC","\u8BC6","\u9002","\u5C5E","\u5706","\u5305","\u706B","\u4F4F","\u8C03","\u6EE1","\u53BF","\u5C40","\u7167","\u53C2","\u7EA2","\u7EC6","\u5F15","\u542C","\u8BE5","\u94C1","\u4EF7","\u4E25","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u968F","\u75C5","\u82CF","\u5931","\u5C14","\u6B7B","\u8BB2","\u914D","\u5973","\u9EC4","\u63A8","\u663E","\u8C08","\u7F6A","\u795E","\u827A","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u8425","\u9879","\u9632","\u4E3E","\u7403","\u82F1","\u6C27","\u52BF","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E2E","\u8F6E","\u7834","\u4E9A","\u5E08","\u56F4","\u6CE8","\u8FDC","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u6001","\u5C01","\u53E6","\u65BD","\u51CF","\u6811","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u53F6","\u9C7C","\u6CE2","\u89C6","\u4EC5","\u8D39","\u7D27","\u7231","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7EED","\u8F7B","\u670D","\u8BD5","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u62A4","\u53F8","\u8DB3","\u67D0","\u7EC3","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8D1F","\u51FB","\u8303","\u7EE7","\u5174","\u4F3C","\u4F59","\u575A","\u66F2","\u8F93","\u4FEE","\u6545","\u57CE","\u592B","\u591F","\u9001","\u7B14","\u8239","\u5360","\u53F3","\u8D22","\u5403","\u5BCC","\u6625","\u804C","\u89C9","\u6C49","\u753B","\u529F","\u5DF4","\u8DDF","\u867D","\u6742","\u98DE","\u68C0","\u5438","\u52A9","\u5347","\u9633","\u4E92","\u521D","\u521B","\u6297","\u8003","\u6295","\u574F","\u7B56","\u53E4","\u5F84","\u6362","\u672A","\u8DD1","\u7559","\u94A2","\u66FE","\u7AEF","\u8D23","\u7AD9","\u7B80","\u8FF0","\u94B1","\u526F","\u5C3D","\u5E1D","\u5C04","\u8349","\u51B2","\u627F","\u72EC","\u4EE4","\u9650","\u963F","\u5BA3","\u73AF","\u53CC","\u8BF7","\u8D85","\u5FAE","\u8BA9","\u63A7","\u5DDE","\u826F","\u8F74","\u627E","\u5426","\u7EAA","\u76CA","\u4F9D","\u4F18","\u9876","\u7840","\u8F7D","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u654C","\u7565","\u5BA2","\u8881","\u51B7","\u80DC","\u7EDD","\u6790","\u5757","\u5242","\u6D4B","\u4E1D","\u534F","\u8BC9","\u5FF5","\u9648","\u4ECD","\u7F57","\u76D0","\u53CB","\u6D0B","\u9519","\u82E6","\u591C","\u5211","\u79FB","\u9891","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7EC8","\u805A","\u6C7D","\u6751","\u4E91","\u54EA","\u65E2","\u8DDD","\u536B","\u505C","\u70C8","\u592E","\u5BDF","\u70E7","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u6E38","\u4E45","\u83DC","\u5473","\u65E7","\u6A21","\u6E56","\u8D27","\u635F","\u9884","\u963B","\u6BEB","\u666E","\u7A33","\u4E59","\u5988","\u690D","\u606F","\u6269","\u94F6","\u8BED","\u6325","\u9152","\u5B88","\u62FF","\u5E8F","\u7EB8","\u533B","\u7F3A","\u96E8","\u5417","\u9488","\u5218","\u554A","\u6025","\u5531","\u8BEF","\u8BAD","\u613F","\u5BA1","\u9644","\u83B7","\u8336","\u9C9C","\u7CAE","\u65A4","\u5B69","\u8131","\u786B","\u80A5","\u5584","\u9F99","\u6F14","\u7236","\u6E10","\u8840","\u6B22","\u68B0","\u638C","\u6B4C","\u6C99","\u521A","\u653B","\u8C13","\u76FE","\u8BA8","\u665A","\u7C92","\u4E71","\u71C3","\u77DB","\u4E4E","\u6740","\u836F","\u5B81","\u9C81","\u8D35","\u949F","\u7164","\u8BFB","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u4E30","\u57F9","\u63E1","\u5170","\u62C5","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u6267","\u7B54","\u4E50","\u8C01","\u987A","\u70DF","\u7F29","\u5F81","\u8138","\u559C","\u677E","\u811A","\u56F0","\u5F02","\u514D","\u80CC","\u661F","\u798F","\u4E70","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u9759","\u8865","\u8BC4","\u7FFB","\u8089","\u8DF5","\u5C3C","\u8863","\u5BBD","\u626C","\u68C9","\u5E0C","\u4F24","\u64CD","\u5782","\u79CB","\u5B9C","\u6C22","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u5BAA","\u5E86","\u7F16","\u725B","\u89E6","\u6620","\u96F7","\u9500","\u8BD7","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7EFF","\u6676","\u539A","\u76DF","\u8861","\u9E21","\u5B59","\u5EF6","\u5371","\u80F6","\u5C4B","\u4E61","\u4E34","\u9646","\u987E","\u6389","\u5440","\u706F","\u5C81","\u63AA","\u675F","\u8010","\u5267","\u7389","\u8D75","\u8DF3","\u54E5","\u5B63","\u8BFE","\u51EF","\u80E1","\u989D","\u6B3E","\u7ECD","\u5377","\u9F50","\u4F1F","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7089","\u5CA9","\u5F31","\u96F6","\u6768","\u594F","\u6CBF","\u9732","\u6746","\u63A2","\u6ED1","\u9547","\u996D","\u6D53","\u822A","\u6000","\u8D76","\u5E93","\u593A","\u4F0A","\u7075","\u7A0E","\u9014","\u706D","\u8D5B","\u5F52","\u53EC","\u9F13","\u64AD","\u76D8","\u88C1","\u9669","\u5EB7","\u552F","\u5F55","\u83CC","\u7EAF","\u501F","\u7CD6","\u76D6","\u6A2A","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u67AA","\u6DA6","\u5E45","\u54C8","\u7ADF","\u719F","\u866B","\u6CFD","\u8111","\u58E4","\u78B3","\u6B27","\u904D","\u4FA7","\u5BE8","\u6562","\u5F7B","\u8651","\u659C","\u8584","\u5EAD","\u7EB3","\u5F39","\u9972","\u4F38","\u6298","\u9EA6","\u6E7F","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7B51","\u6076","\u6237","\u8BBF","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8FF9","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u6446","\u7070","\u5F69","\u5356","\u8017","\u590F","\u62E9","\u5FD9","\u94DC","\u732E","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9635","\u9634","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u697C","\u907F","\u8C0B","\u5428","\u91CE","\u732A","\u65D7","\u7D2F","\u504F","\u5178","\u9986","\u7D22","\u79E6","\u8102","\u6F6E","\u7237","\u8C46","\u5FFD","\u6258","\u60CA","\u5851","\u9057","\u6108","\u6731","\u66FF","\u7EA4","\u7C97","\u503E","\u5C1A","\u75DB","\u695A","\u8C22","\u594B","\u8D2D","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76D1","\u6355","\u5F1F","\u66B4","\u5272","\u8D2F","\u6B8A","\u91CA","\u8BCD","\u4EA1","\u58C1","\u987F","\u5B9D","\u5348","\u5C18","\u95FB","\u63ED","\u70AE","\u6B8B","\u51AC","\u6865","\u5987","\u8B66","\u7EFC","\u62DB","\u5434","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6447","\u8C37","\u8D5E","\u7BB1","\u9694","\u8BA2","\u7537","\u5439","\u56ED","\u7EB7","\u5510","\u8D25","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u8363","\u95ED","\u6E7E","\u952E","\u51E1","\u9A7B","\u9505","\u6551","\u6069","\u5265","\u51DD","\u78B1","\u9F7F","\u622A","\u70BC","\u9EBB","\u7EBA","\u7981","\u5E9F","\u76DB","\u7248","\u7F13","\u51C0","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u5E84","\u8857","\u85CF","\u59D1","\u8D38","\u8150","\u5974","\u5566","\u60EF","\u4E58","\u4F19","\u6062","\u5300","\u7EB1","\u624E","\u8FA9","\u8033","\u5F6A","\u81E3","\u4EBF","\u7483","\u62B5","\u8109","\u79C0","\u8428","\u4FC4","\u7F51","\u821E","\u5E97","\u55B7","\u7EB5","\u5BF8","\u6C57","\u6302","\u6D2A","\u8D3A","\u95EA","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u5899","\u8F6F","\u52C7","\u50CF","\u6EDA","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u8361","\u817F","\u4EEA","\u65C5","\u5C3E","\u8F67","\u51B0","\u8D21","\u767B","\u9ECE","\u524A","\u94BB","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E01","\u6E2F","\u4F0F","\u8F68","\u4EA9","\u6BD5","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5C9B","\u7518","\u6CE1","\u7761","\u7AE5","\u94F8","\u6C64","\u9600","\u4F11","\u6C47","\u820D","\u7267","\u7ED5","\u70B8","\u54F2","\u78F7","\u7EE9","\u670B","\u6DE1","\u5C16","\u542F","\u9677","\u67F4","\u5448","\u5F92","\u989C","\u6CEA","\u7A0D","\u5FD8","\u6CF5","\u84DD","\u62D6","\u6D1E","\u6388","\u955C","\u8F9B","\u58EE","\u950B","\u8D2B","\u865A","\u5F2F","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7EB2","\u5F04","\u96B6","\u7591","\u6C0F","\u5BAB","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u8FDD","\u5939","\u8170","\u7F18","\u73E0","\u7A77","\u68EE","\u679D","\u7AF9","\u6C9F","\u50AC","\u7EF3","\u5FC6","\u90A6","\u5269","\u5E78","\u6D46","\u680F","\u62E5","\u7259","\u8D2E","\u793C","\u6EE4","\u94A0","\u7EB9","\u7F62","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F5A","\u7126","\u6F5C","\u4F0D","\u58A8","\u6B32","\u7F1D","\u59D3","\u520A","\u9971","\u4EFF","\u5956","\u94DD","\u9B3C","\u4E3D","\u8DE8","\u9ED8","\u6316","\u94FE","\u626B","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8BF8","\u5F27","\u52B1","\u6885","\u5976","\u6D01","\u707E","\u821F","\u9274","\u82EF","\u8BBC","\u62B1","\u6BC1","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C4A","\u8DC3","\u6E21","\u6311","\u4E39","\u8270","\u8D1D","\u78B0","\u62D4","\u7239","\u6234","\u7801","\u68A6","\u82BD","\u7194","\u8D64","\u6E14","\u54ED","\u656C","\u9897","\u5954","\u94C5","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u4ED3","\u9B4F","\u9510","\u6653","\u6C2E","\u517C","\u9690","\u788D","\u8D6B","\u62E8","\u5FE0","\u8083","\u7F38","\u7275","\u62A2","\u535A","\u5DE7","\u58F3","\u5144","\u675C","\u8BAF","\u8BDA","\u78A7","\u7965","\u67EF","\u9875","\u5DE1","\u77E9","\u60B2","\u704C","\u9F84","\u4F26","\u7968","\u5BFB","\u6842","\u94FA","\u5723","\u6050","\u6070","\u90D1","\u8DA3","\u62AC","\u8352","\u817E","\u8D34","\u67D4","\u6EF4","\u731B","\u9614","\u8F86","\u59BB","\u586B","\u64A4","\u50A8","\u7B7E","\u95F9","\u6270","\u7D2B","\u7802","\u9012","\u620F","\u540A","\u9676","\u4F10","\u5582","\u7597","\u74F6","\u5A46","\u629A","\u81C2","\u6478","\u5FCD","\u867E","\u8721","\u90BB","\u80F8","\u5DE9","\u6324","\u5076","\u5F03","\u69FD","\u52B2","\u4E73","\u9093","\u5409","\u4EC1","\u70C2","\u7816","\u79DF","\u4E4C","\u8230","\u4F34","\u74DC","\u6D45","\u4E19","\u6682","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u80C6","\u8BE6","\u7C27","\u8E0F","\u74F7","\u8C31","\u5446","\u5BBE","\u7CCA","\u6D1B","\u8F89","\u6124","\u7ADE","\u9699","\u6012","\u7C98","\u4E43","\u7EEA","\u80A9","\u7C4D","\u654F","\u6D82","\u7199","\u7686","\u4FA6","\u60AC","\u6398","\u4EAB","\u7EA0","\u9192","\u72C2","\u9501","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8D4F","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9E2D","\u8D8B","\u51E4","\u6668","\u755C","\u8F88","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u6EE9","\u68CB","\u9A71","\u7B5B","\u5CE1","\u5192","\u5565","\u5BFF","\u8BD1","\u6D78","\u6CC9","\u5E3D","\u8FDF","\u7845","\u7586","\u8D37","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u80C1","\u82AF","\u7262","\u53DB","\u8680","\u5965","\u9E23","\u5CAD","\u7F8A","\u51ED","\u4E32","\u5858","\u7ED8","\u9175","\u878D","\u76C6","\u9521","\u5E99","\u7B79","\u51BB","\u8F85","\u6444","\u88AD","\u7B4B","\u62D2","\u50DA","\u65F1","\u94BE","\u9E1F","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97E9","\u903C","\u626D","\u4FA8","\u51C9","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u998F","\u529D","\u8C6A","\u8FBD","\u52C3","\u9E3F","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F8A","\u63A9","\u996E","\u642C","\u9A82","\u8F9E","\u52FE","\u6263","\u4F30","\u848B","\u7ED2","\u96FE","\u4E08","\u6735","\u59C6","\u62DF","\u5B87","\u8F91","\u9655","\u96D5","\u507F","\u84C4","\u5D07","\u526A","\u5021","\u5385","\u54AC","\u9A76","\u85AF","\u5237","\u65A5","\u756A","\u8D4B","\u5949","\u4F5B","\u6D47","\u6F2B","\u66FC","\u6247","\u9499","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u4E8F","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A97","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u80C0","\u8C10","\u629B","\u9709","\u6851","\u5C97","\u561B","\u8870","\u76D7","\u6E17","\u810F","\u8D56","\u6D8C","\u751C","\u66F9","\u9605","\u808C","\u54E9","\u5389","\u70C3","\u7EAC","\u6BC5","\u6628","\u4F2A","\u75C7","\u716E","\u53F9","\u9489","\u642D","\u830E","\u7B3C","\u9177","\u5077","\u5F13","\u9525","\u6052","\u6770","\u5751","\u9F3B","\u7FFC","\u7EB6","\u53D9","\u72F1","\u902E","\u7F50","\u7EDC","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9AA4","\u7A46","\u51B6","\u67AF","\u518C","\u5C38","\u51F8","\u7EC5","\u576F","\u727A","\u7130","\u8F70","\u6B23","\u664B","\u7626","\u5FA1","\u952D","\u9526","\u4E27","\u65EC","\u953B","\u5784","\u641C","\u6251","\u9080","\u4EAD","\u916F","\u8FC8","\u8212","\u8106","\u9176","\u95F2","\u5FE7","\u915A","\u987D","\u7FBD","\u6DA8","\u5378","\u4ED7","\u966A","\u8F9F","\u60E9","\u676D","\u59DA","\u809A","\u6349","\u98D8","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u9970","\u8427","\u96C5","\u90AE","\u8FC1","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u70E6","\u503A","\u5E10","\u6591","\u94C3","\u65E8","\u9187","\u8463","\u997C","\u96CF","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8D24","\u62C6","\u6B6A","\u8461","\u80FA","\u4E22","\u6D69","\u5FBD","\u6602","\u57AB","\u6321","\u89C8","\u8D2A","\u6170","\u7F34","\u6C6A","\u614C","\u51AF","\u8BFA","\u59DC","\u8C0A","\u51F6","\u52A3","\u8BEC","\u8000","\u660F","\u8EBA","\u76C8","\u9A91","\u4E54","\u6EAA","\u4E1B","\u5362","\u62B9","\u95F7","\u54A8","\u522E","\u9A7E","\u7F06","\u609F","\u6458","\u94D2","\u63B7","\u9887","\u5E7B","\u67C4","\u60E0","\u60E8","\u4F73","\u4EC7","\u814A","\u7A9D","\u6DA4","\u5251","\u77A7","\u5821","\u6CFC","\u8471","\u7F69","\u970D","\u635E","\u80CE","\u82CD","\u6EE8","\u4FE9","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u75AF","\u6DEE","\u9042","\u718A","\u7CAA","\u70D8","\u5BBF","\u6863","\u6208","\u9A73","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u80A0","\u6491","\u6652","\u8FA8","\u6BBF","\u83B2","\u644A","\u6405","\u9171","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76B1","\u7545","\u53E0","\u9601","\u83B1","\u6572","\u8F96","\u94A9","\u75D5","\u575D","\u5DF7","\u997F","\u7978","\u4E18","\u7384","\u6E9C","\u66F0","\u903B","\u5F6D","\u5C1D","\u537F","\u59A8","\u8247","\u541E","\u97E6","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("9FVoO", function(module, exports) {
module.exports = JSON.parse('["\u7684","\u4E00","\u662F","\u5728","\u4E0D","\u4E86","\u6709","\u548C","\u4EBA","\u9019","\u4E2D","\u5927","\u70BA","\u4E0A","\u500B","\u570B","\u6211","\u4EE5","\u8981","\u4ED6","\u6642","\u4F86","\u7528","\u5011","\u751F","\u5230","\u4F5C","\u5730","\u65BC","\u51FA","\u5C31","\u5206","\u5C0D","\u6210","\u6703","\u53EF","\u4E3B","\u767C","\u5E74","\u52D5","\u540C","\u5DE5","\u4E5F","\u80FD","\u4E0B","\u904E","\u5B50","\u8AAA","\u7522","\u7A2E","\u9762","\u800C","\u65B9","\u5F8C","\u591A","\u5B9A","\u884C","\u5B78","\u6CD5","\u6240","\u6C11","\u5F97","\u7D93","\u5341","\u4E09","\u4E4B","\u9032","\u8457","\u7B49","\u90E8","\u5EA6","\u5BB6","\u96FB","\u529B","\u88E1","\u5982","\u6C34","\u5316","\u9AD8","\u81EA","\u4E8C","\u7406","\u8D77","\u5C0F","\u7269","\u73FE","\u5BE6","\u52A0","\u91CF","\u90FD","\u5169","\u9AD4","\u5236","\u6A5F","\u7576","\u4F7F","\u9EDE","\u5F9E","\u696D","\u672C","\u53BB","\u628A","\u6027","\u597D","\u61C9","\u958B","\u5B83","\u5408","\u9084","\u56E0","\u7531","\u5176","\u4E9B","\u7136","\u524D","\u5916","\u5929","\u653F","\u56DB","\u65E5","\u90A3","\u793E","\u7FA9","\u4E8B","\u5E73","\u5F62","\u76F8","\u5168","\u8868","\u9593","\u6A23","\u8207","\u95DC","\u5404","\u91CD","\u65B0","\u7DDA","\u5167","\u6578","\u6B63","\u5FC3","\u53CD","\u4F60","\u660E","\u770B","\u539F","\u53C8","\u9EBC","\u5229","\u6BD4","\u6216","\u4F46","\u8CEA","\u6C23","\u7B2C","\u5411","\u9053","\u547D","\u6B64","\u8B8A","\u689D","\u53EA","\u6C92","\u7D50","\u89E3","\u554F","\u610F","\u5EFA","\u6708","\u516C","\u7121","\u7CFB","\u8ECD","\u5F88","\u60C5","\u8005","\u6700","\u7ACB","\u4EE3","\u60F3","\u5DF2","\u901A","\u4E26","\u63D0","\u76F4","\u984C","\u9EE8","\u7A0B","\u5C55","\u4E94","\u679C","\u6599","\u8C61","\u54E1","\u9769","\u4F4D","\u5165","\u5E38","\u6587","\u7E3D","\u6B21","\u54C1","\u5F0F","\u6D3B","\u8A2D","\u53CA","\u7BA1","\u7279","\u4EF6","\u9577","\u6C42","\u8001","\u982D","\u57FA","\u8CC7","\u908A","\u6D41","\u8DEF","\u7D1A","\u5C11","\u5716","\u5C71","\u7D71","\u63A5","\u77E5","\u8F03","\u5C07","\u7D44","\u898B","\u8A08","\u5225","\u5979","\u624B","\u89D2","\u671F","\u6839","\u8AD6","\u904B","\u8FB2","\u6307","\u5E7E","\u4E5D","\u5340","\u5F37","\u653E","\u6C7A","\u897F","\u88AB","\u5E79","\u505A","\u5FC5","\u6230","\u5148","\u56DE","\u5247","\u4EFB","\u53D6","\u64DA","\u8655","\u968A","\u5357","\u7D66","\u8272","\u5149","\u9580","\u5373","\u4FDD","\u6CBB","\u5317","\u9020","\u767E","\u898F","\u71B1","\u9818","\u4E03","\u6D77","\u53E3","\u6771","\u5C0E","\u5668","\u58D3","\u5FD7","\u4E16","\u91D1","\u589E","\u722D","\u6FDF","\u968E","\u6CB9","\u601D","\u8853","\u6975","\u4EA4","\u53D7","\u806F","\u4EC0","\u8A8D","\u516D","\u5171","\u6B0A","\u6536","\u8B49","\u6539","\u6E05","\u7F8E","\u518D","\u63A1","\u8F49","\u66F4","\u55AE","\u98A8","\u5207","\u6253","\u767D","\u6559","\u901F","\u82B1","\u5E36","\u5B89","\u5834","\u8EAB","\u8ECA","\u4F8B","\u771F","\u52D9","\u5177","\u842C","\u6BCF","\u76EE","\u81F3","\u9054","\u8D70","\u7A4D","\u793A","\u8B70","\u8072","\u5831","\u9B25","\u5B8C","\u985E","\u516B","\u96E2","\u83EF","\u540D","\u78BA","\u624D","\u79D1","\u5F35","\u4FE1","\u99AC","\u7BC0","\u8A71","\u7C73","\u6574","\u7A7A","\u5143","\u6CC1","\u4ECA","\u96C6","\u6EAB","\u50B3","\u571F","\u8A31","\u6B65","\u7FA4","\u5EE3","\u77F3","\u8A18","\u9700","\u6BB5","\u7814","\u754C","\u62C9","\u6797","\u5F8B","\u53EB","\u4E14","\u7A76","\u89C0","\u8D8A","\u7E54","\u88DD","\u5F71","\u7B97","\u4F4E","\u6301","\u97F3","\u773E","\u66F8","\u5E03","\u590D","\u5BB9","\u5152","\u9808","\u969B","\u5546","\u975E","\u9A57","\u9023","\u65B7","\u6DF1","\u96E3","\u8FD1","\u7926","\u5343","\u9031","\u59D4","\u7D20","\u6280","\u5099","\u534A","\u8FA6","\u9752","\u7701","\u5217","\u7FD2","\u97FF","\u7D04","\u652F","\u822C","\u53F2","\u611F","\u52DE","\u4FBF","\u5718","\u5F80","\u9178","\u6B77","\u5E02","\u514B","\u4F55","\u9664","\u6D88","\u69CB","\u5E9C","\u7A31","\u592A","\u6E96","\u7CBE","\u503C","\u865F","\u7387","\u65CF","\u7DAD","\u5283","\u9078","\u6A19","\u5BEB","\u5B58","\u5019","\u6BDB","\u89AA","\u5FEB","\u6548","\u65AF","\u9662","\u67E5","\u6C5F","\u578B","\u773C","\u738B","\u6309","\u683C","\u990A","\u6613","\u7F6E","\u6D3E","\u5C64","\u7247","\u59CB","\u537B","\u5C08","\u72C0","\u80B2","\u5EE0","\u4EAC","\u8B58","\u9069","\u5C6C","\u5713","\u5305","\u706B","\u4F4F","\u8ABF","\u6EFF","\u7E23","\u5C40","\u7167","\u53C3","\u7D05","\u7D30","\u5F15","\u807D","\u8A72","\u9435","\u50F9","\u56B4","\u9996","\u5E95","\u6DB2","\u5B98","\u5FB7","\u96A8","\u75C5","\u8607","\u5931","\u723E","\u6B7B","\u8B1B","\u914D","\u5973","\u9EC3","\u63A8","\u986F","\u8AC7","\u7F6A","\u795E","\u85DD","\u5462","\u5E2D","\u542B","\u4F01","\u671B","\u5BC6","\u6279","\u71DF","\u9805","\u9632","\u8209","\u7403","\u82F1","\u6C27","\u52E2","\u544A","\u674E","\u53F0","\u843D","\u6728","\u5E6B","\u8F2A","\u7834","\u4E9E","\u5E2B","\u570D","\u6CE8","\u9060","\u5B57","\u6750","\u6392","\u4F9B","\u6CB3","\u614B","\u5C01","\u53E6","\u65BD","\u6E1B","\u6A39","\u6EB6","\u600E","\u6B62","\u6848","\u8A00","\u58EB","\u5747","\u6B66","\u56FA","\u8449","\u9B5A","\u6CE2","\u8996","\u50C5","\u8CBB","\u7DCA","\u611B","\u5DE6","\u7AE0","\u65E9","\u671D","\u5BB3","\u7E8C","\u8F15","\u670D","\u8A66","\u98DF","\u5145","\u5175","\u6E90","\u5224","\u8B77","\u53F8","\u8DB3","\u67D0","\u7DF4","\u5DEE","\u81F4","\u677F","\u7530","\u964D","\u9ED1","\u72AF","\u8CA0","\u64CA","\u8303","\u7E7C","\u8208","\u4F3C","\u9918","\u5805","\u66F2","\u8F38","\u4FEE","\u6545","\u57CE","\u592B","\u5920","\u9001","\u7B46","\u8239","\u4F54","\u53F3","\u8CA1","\u5403","\u5BCC","\u6625","\u8077","\u89BA","\u6F22","\u756B","\u529F","\u5DF4","\u8DDF","\u96D6","\u96DC","\u98DB","\u6AA2","\u5438","\u52A9","\u6607","\u967D","\u4E92","\u521D","\u5275","\u6297","\u8003","\u6295","\u58DE","\u7B56","\u53E4","\u5F91","\u63DB","\u672A","\u8DD1","\u7559","\u92FC","\u66FE","\u7AEF","\u8CAC","\u7AD9","\u7C21","\u8FF0","\u9322","\u526F","\u76E1","\u5E1D","\u5C04","\u8349","\u885D","\u627F","\u7368","\u4EE4","\u9650","\u963F","\u5BA3","\u74B0","\u96D9","\u8ACB","\u8D85","\u5FAE","\u8B93","\u63A7","\u5DDE","\u826F","\u8EF8","\u627E","\u5426","\u7D00","\u76CA","\u4F9D","\u512A","\u9802","\u790E","\u8F09","\u5012","\u623F","\u7A81","\u5750","\u7C89","\u6575","\u7565","\u5BA2","\u8881","\u51B7","\u52DD","\u7D55","\u6790","\u584A","\u5291","\u6E2C","\u7D72","\u5354","\u8A34","\u5FF5","\u9673","\u4ECD","\u7F85","\u9E7D","\u53CB","\u6D0B","\u932F","\u82E6","\u591C","\u5211","\u79FB","\u983B","\u9010","\u9760","\u6DF7","\u6BCD","\u77ED","\u76AE","\u7D42","\u805A","\u6C7D","\u6751","\u96F2","\u54EA","\u65E2","\u8DDD","\u885B","\u505C","\u70C8","\u592E","\u5BDF","\u71D2","\u8FC5","\u5883","\u82E5","\u5370","\u6D32","\u523B","\u62EC","\u6FC0","\u5B54","\u641E","\u751A","\u5BA4","\u5F85","\u6838","\u6821","\u6563","\u4FB5","\u5427","\u7532","\u904A","\u4E45","\u83DC","\u5473","\u820A","\u6A21","\u6E56","\u8CA8","\u640D","\u9810","\u963B","\u6BEB","\u666E","\u7A69","\u4E59","\u5ABD","\u690D","\u606F","\u64F4","\u9280","\u8A9E","\u63EE","\u9152","\u5B88","\u62FF","\u5E8F","\u7D19","\u91AB","\u7F3A","\u96E8","\u55CE","\u91DD","\u5289","\u554A","\u6025","\u5531","\u8AA4","\u8A13","\u9858","\u5BE9","\u9644","\u7372","\u8336","\u9BAE","\u7CE7","\u65A4","\u5B69","\u812B","\u786B","\u80A5","\u5584","\u9F8D","\u6F14","\u7236","\u6F38","\u8840","\u6B61","\u68B0","\u638C","\u6B4C","\u6C99","\u525B","\u653B","\u8B02","\u76FE","\u8A0E","\u665A","\u7C92","\u4E82","\u71C3","\u77DB","\u4E4E","\u6BBA","\u85E5","\u5BE7","\u9B6F","\u8CB4","\u9418","\u7164","\u8B80","\u73ED","\u4F2F","\u9999","\u4ECB","\u8FEB","\u53E5","\u8C50","\u57F9","\u63E1","\u862D","\u64D4","\u5F26","\u86CB","\u6C89","\u5047","\u7A7F","\u57F7","\u7B54","\u6A02","\u8AB0","\u9806","\u7159","\u7E2E","\u5FB5","\u81C9","\u559C","\u677E","\u8173","\u56F0","\u7570","\u514D","\u80CC","\u661F","\u798F","\u8CB7","\u67D3","\u4E95","\u6982","\u6162","\u6015","\u78C1","\u500D","\u7956","\u7687","\u4FC3","\u975C","\u88DC","\u8A55","\u7FFB","\u8089","\u8E10","\u5C3C","\u8863","\u5BEC","\u63DA","\u68C9","\u5E0C","\u50B7","\u64CD","\u5782","\u79CB","\u5B9C","\u6C2B","\u5957","\u7763","\u632F","\u67B6","\u4EAE","\u672B","\u61B2","\u6176","\u7DE8","\u725B","\u89F8","\u6620","\u96F7","\u92B7","\u8A69","\u5EA7","\u5C45","\u6293","\u88C2","\u80DE","\u547C","\u5A18","\u666F","\u5A01","\u7DA0","\u6676","\u539A","\u76DF","\u8861","\u96DE","\u5B6B","\u5EF6","\u5371","\u81A0","\u5C4B","\u9109","\u81E8","\u9678","\u9867","\u6389","\u5440","\u71C8","\u6B72","\u63AA","\u675F","\u8010","\u5287","\u7389","\u8D99","\u8DF3","\u54E5","\u5B63","\u8AB2","\u51F1","\u80E1","\u984D","\u6B3E","\u7D39","\u5377","\u9F4A","\u5049","\u84B8","\u6B96","\u6C38","\u5B97","\u82D7","\u5DDD","\u7210","\u5CA9","\u5F31","\u96F6","\u694A","\u594F","\u6CBF","\u9732","\u687F","\u63A2","\u6ED1","\u93AE","\u98EF","\u6FC3","\u822A","\u61F7","\u8D95","\u5EAB","\u596A","\u4F0A","\u9748","\u7A05","\u9014","\u6EC5","\u8CFD","\u6B78","\u53EC","\u9F13","\u64AD","\u76E4","\u88C1","\u96AA","\u5EB7","\u552F","\u9304","\u83CC","\u7D14","\u501F","\u7CD6","\u84CB","\u6A6B","\u7B26","\u79C1","\u52AA","\u5802","\u57DF","\u69CD","\u6F64","\u5E45","\u54C8","\u7ADF","\u719F","\u87F2","\u6FA4","\u8166","\u58E4","\u78B3","\u6B50","\u904D","\u5074","\u5BE8","\u6562","\u5FB9","\u616E","\u659C","\u8584","\u5EAD","\u7D0D","\u5F48","\u98FC","\u4F38","\u6298","\u9EA5","\u6FD5","\u6697","\u8377","\u74E6","\u585E","\u5E8A","\u7BC9","\u60E1","\u6236","\u8A2A","\u5854","\u5947","\u900F","\u6881","\u5200","\u65CB","\u8DE1","\u5361","\u6C2F","\u9047","\u4EFD","\u6BD2","\u6CE5","\u9000","\u6D17","\u64FA","\u7070","\u5F69","\u8CE3","\u8017","\u590F","\u64C7","\u5FD9","\u9285","\u737B","\u786C","\u4E88","\u7E41","\u5708","\u96EA","\u51FD","\u4EA6","\u62BD","\u7BC7","\u9663","\u9670","\u4E01","\u5C3A","\u8FFD","\u5806","\u96C4","\u8FCE","\u6CDB","\u7238","\u6A13","\u907F","\u8B00","\u5678","\u91CE","\u8C6C","\u65D7","\u7D2F","\u504F","\u5178","\u9928","\u7D22","\u79E6","\u8102","\u6F6E","\u723A","\u8C46","\u5FFD","\u6258","\u9A5A","\u5851","\u907A","\u6108","\u6731","\u66FF","\u7E96","\u7C97","\u50BE","\u5C1A","\u75DB","\u695A","\u8B1D","\u596E","\u8CFC","\u78E8","\u541B","\u6C60","\u65C1","\u788E","\u9AA8","\u76E3","\u6355","\u5F1F","\u66B4","\u5272","\u8CAB","\u6B8A","\u91CB","\u8A5E","\u4EA1","\u58C1","\u9813","\u5BF6","\u5348","\u5875","\u805E","\u63ED","\u70AE","\u6B98","\u51AC","\u6A4B","\u5A66","\u8B66","\u7D9C","\u62DB","\u5433","\u4ED8","\u6D6E","\u906D","\u5F90","\u60A8","\u6416","\u8C37","\u8D0A","\u7BB1","\u9694","\u8A02","\u7537","\u5439","\u5712","\u7D1B","\u5510","\u6557","\u5B8B","\u73BB","\u5DE8","\u8015","\u5766","\u69AE","\u9589","\u7063","\u9375","\u51E1","\u99D0","\u934B","\u6551","\u6069","\u525D","\u51DD","\u9E7C","\u9F52","\u622A","\u7149","\u9EBB","\u7D21","\u7981","\u5EE2","\u76DB","\u7248","\u7DE9","\u6DE8","\u775B","\u660C","\u5A5A","\u6D89","\u7B52","\u5634","\u63D2","\u5CB8","\u6717","\u838A","\u8857","\u85CF","\u59D1","\u8CBF","\u8150","\u5974","\u5566","\u6163","\u4E58","\u5925","\u6062","\u52FB","\u7D17","\u624E","\u8FAF","\u8033","\u5F6A","\u81E3","\u5104","\u7483","\u62B5","\u8108","\u79C0","\u85A9","\u4FC4","\u7DB2","\u821E","\u5E97","\u5674","\u7E31","\u5BF8","\u6C57","\u639B","\u6D2A","\u8CC0","\u9583","\u67EC","\u7206","\u70EF","\u6D25","\u7A3B","\u7246","\u8EDF","\u52C7","\u50CF","\u6EFE","\u5398","\u8499","\u82B3","\u80AF","\u5761","\u67F1","\u76EA","\u817F","\u5100","\u65C5","\u5C3E","\u8ECB","\u51B0","\u8CA2","\u767B","\u9ECE","\u524A","\u947D","\u52D2","\u9003","\u969C","\u6C28","\u90ED","\u5CF0","\u5E63","\u6E2F","\u4F0F","\u8ECC","\u755D","\u7562","\u64E6","\u83AB","\u523A","\u6D6A","\u79D8","\u63F4","\u682A","\u5065","\u552E","\u80A1","\u5CF6","\u7518","\u6CE1","\u7761","\u7AE5","\u9444","\u6E6F","\u95A5","\u4F11","\u532F","\u820D","\u7267","\u7E5E","\u70B8","\u54F2","\u78F7","\u7E3E","\u670B","\u6DE1","\u5C16","\u555F","\u9677","\u67F4","\u5448","\u5F92","\u984F","\u6DDA","\u7A0D","\u5FD8","\u6CF5","\u85CD","\u62D6","\u6D1E","\u6388","\u93E1","\u8F9B","\u58EF","\u92D2","\u8CA7","\u865B","\u5F4E","\u6469","\u6CF0","\u5E7C","\u5EF7","\u5C0A","\u7A97","\u7DB1","\u5F04","\u96B8","\u7591","\u6C0F","\u5BAE","\u59D0","\u9707","\u745E","\u602A","\u5C24","\u7434","\u5FAA","\u63CF","\u819C","\u9055","\u593E","\u8170","\u7DE3","\u73E0","\u7AAE","\u68EE","\u679D","\u7AF9","\u6E9D","\u50AC","\u7E69","\u61B6","\u90A6","\u5269","\u5E78","\u6F3F","\u6B04","\u64C1","\u7259","\u8CAF","\u79AE","\u6FFE","\u9209","\u7D0B","\u7F77","\u62CD","\u54B1","\u558A","\u8896","\u57C3","\u52E4","\u7F70","\u7126","\u6F5B","\u4F0D","\u58A8","\u6B32","\u7E2B","\u59D3","\u520A","\u98FD","\u4EFF","\u734E","\u92C1","\u9B3C","\u9E97","\u8DE8","\u9ED8","\u6316","\u93C8","\u6383","\u559D","\u888B","\u70AD","\u6C61","\u5E55","\u8AF8","\u5F27","\u52F5","\u6885","\u5976","\u6F54","\u707D","\u821F","\u9451","\u82EF","\u8A1F","\u62B1","\u6BC0","\u61C2","\u5BD2","\u667A","\u57D4","\u5BC4","\u5C46","\u8E8D","\u6E21","\u6311","\u4E39","\u8271","\u8C9D","\u78B0","\u62D4","\u7239","\u6234","\u78BC","\u5922","\u82BD","\u7194","\u8D64","\u6F01","\u54ED","\u656C","\u9846","\u5954","\u925B","\u4EF2","\u864E","\u7A00","\u59B9","\u4E4F","\u73CD","\u7533","\u684C","\u9075","\u5141","\u9686","\u87BA","\u5009","\u9B4F","\u92B3","\u66C9","\u6C2E","\u517C","\u96B1","\u7919","\u8D6B","\u64A5","\u5FE0","\u8085","\u7F38","\u727D","\u6436","\u535A","\u5DE7","\u6BBC","\u5144","\u675C","\u8A0A","\u8AA0","\u78A7","\u7965","\u67EF","\u9801","\u5DE1","\u77E9","\u60B2","\u704C","\u9F61","\u502B","\u7968","\u5C0B","\u6842","\u92EA","\u8056","\u6050","\u6070","\u912D","\u8DA3","\u62AC","\u8352","\u9A30","\u8CBC","\u67D4","\u6EF4","\u731B","\u95CA","\u8F1B","\u59BB","\u586B","\u64A4","\u5132","\u7C3D","\u9B27","\u64FE","\u7D2B","\u7802","\u905E","\u6232","\u540A","\u9676","\u4F10","\u9935","\u7642","\u74F6","\u5A46","\u64AB","\u81C2","\u6478","\u5FCD","\u8766","\u881F","\u9130","\u80F8","\u978F","\u64E0","\u5076","\u68C4","\u69FD","\u52C1","\u4E73","\u9127","\u5409","\u4EC1","\u721B","\u78DA","\u79DF","\u70CF","\u8266","\u4F34","\u74DC","\u6DFA","\u4E19","\u66AB","\u71E5","\u6A61","\u67F3","\u8FF7","\u6696","\u724C","\u79E7","\u81BD","\u8A73","\u7C27","\u8E0F","\u74F7","\u8B5C","\u5446","\u8CD3","\u7CCA","\u6D1B","\u8F1D","\u61A4","\u7AF6","\u9699","\u6012","\u7C98","\u4E43","\u7DD2","\u80A9","\u7C4D","\u654F","\u5857","\u7199","\u7686","\u5075","\u61F8","\u6398","\u4EAB","\u7CFE","\u9192","\u72C2","\u9396","\u6DC0","\u6068","\u7272","\u9738","\u722C","\u8CDE","\u9006","\u73A9","\u9675","\u795D","\u79D2","\u6D59","\u8C8C","\u5F79","\u5F7C","\u6089","\u9D28","\u8DA8","\u9CF3","\u6668","\u755C","\u8F29","\u79E9","\u5375","\u7F72","\u68AF","\u708E","\u7058","\u68CB","\u9A45","\u7BE9","\u5CFD","\u5192","\u5565","\u58FD","\u8B6F","\u6D78","\u6CC9","\u5E3D","\u9072","\u77FD","\u7586","\u8CB8","\u6F0F","\u7A3F","\u51A0","\u5AE9","\u8105","\u82AF","\u7262","\u53DB","\u8755","\u5967","\u9CF4","\u5DBA","\u7F8A","\u6191","\u4E32","\u5858","\u7E6A","\u9175","\u878D","\u76C6","\u932B","\u5EDF","\u7C4C","\u51CD","\u8F14","\u651D","\u8972","\u7B4B","\u62D2","\u50DA","\u65F1","\u9240","\u9CE5","\u6F06","\u6C88","\u7709","\u758F","\u6DFB","\u68D2","\u7A57","\u785D","\u97D3","\u903C","\u626D","\u50D1","\u6DBC","\u633A","\u7897","\u683D","\u7092","\u676F","\u60A3","\u993E","\u52F8","\u8C6A","\u907C","\u52C3","\u9D3B","\u65E6","\u540F","\u62DC","\u72D7","\u57CB","\u8F25","\u63A9","\u98F2","\u642C","\u7F75","\u8FAD","\u52FE","\u6263","\u4F30","\u8523","\u7D68","\u9727","\u4E08","\u6735","\u59C6","\u64EC","\u5B87","\u8F2F","\u965D","\u96D5","\u511F","\u84C4","\u5D07","\u526A","\u5021","\u5EF3","\u54AC","\u99DB","\u85AF","\u5237","\u65A5","\u756A","\u8CE6","\u5949","\u4F5B","\u6F86","\u6F2B","\u66FC","\u6247","\u9223","\u6843","\u6276","\u4ED4","\u8FD4","\u4FD7","\u8667","\u8154","\u978B","\u68F1","\u8986","\u6846","\u6084","\u53D4","\u649E","\u9A19","\u52D8","\u65FA","\u6CB8","\u5B64","\u5410","\u5B5F","\u6E20","\u5C48","\u75BE","\u5999","\u60DC","\u4EF0","\u72E0","\u8139","\u8AE7","\u62CB","\u9EF4","\u6851","\u5D17","\u561B","\u8870","\u76DC","\u6EF2","\u81DF","\u8CF4","\u6E67","\u751C","\u66F9","\u95B1","\u808C","\u54E9","\u53B2","\u70F4","\u7DEF","\u6BC5","\u6628","\u507D","\u75C7","\u716E","\u5606","\u91D8","\u642D","\u8396","\u7C60","\u9177","\u5077","\u5F13","\u9310","\u6046","\u5091","\u5751","\u9F3B","\u7FFC","\u7DB8","\u6558","\u7344","\u902E","\u7F50","\u7D61","\u68DA","\u6291","\u81A8","\u852C","\u5BFA","\u9A5F","\u7A46","\u51B6","\u67AF","\u518A","\u5C4D","\u51F8","\u7D33","\u576F","\u72A7","\u7130","\u8F5F","\u6B23","\u6649","\u7626","\u79A6","\u9320","\u9326","\u55AA","\u65EC","\u935B","\u58DF","\u641C","\u64B2","\u9080","\u4EAD","\u916F","\u9081","\u8212","\u8106","\u9176","\u9592","\u6182","\u915A","\u9811","\u7FBD","\u6F32","\u5378","\u4ED7","\u966A","\u95E2","\u61F2","\u676D","\u59DA","\u809A","\u6349","\u98C4","\u6F02","\u6606","\u6B3A","\u543E","\u90CE","\u70F7","\u6C41","\u5475","\u98FE","\u856D","\u96C5","\u90F5","\u9077","\u71D5","\u6492","\u59FB","\u8D74","\u5BB4","\u7169","\u50B5","\u5E33","\u6591","\u9234","\u65E8","\u9187","\u8463","\u9905","\u96DB","\u59FF","\u62CC","\u5085","\u8179","\u59A5","\u63C9","\u8CE2","\u62C6","\u6B6A","\u8461","\u80FA","\u4E1F","\u6D69","\u5FBD","\u6602","\u588A","\u64CB","\u89BD","\u8CAA","\u6170","\u7E73","\u6C6A","\u614C","\u99AE","\u8AFE","\u59DC","\u8ABC","\u5147","\u52A3","\u8AA3","\u8000","\u660F","\u8EBA","\u76C8","\u9A0E","\u55AC","\u6EAA","\u53E2","\u76E7","\u62B9","\u60B6","\u8AEE","\u522E","\u99D5","\u7E9C","\u609F","\u6458","\u927A","\u64F2","\u9817","\u5E7B","\u67C4","\u60E0","\u6158","\u4F73","\u4EC7","\u81D8","\u7AA9","\u6ECC","\u528D","\u77A7","\u5821","\u6F51","\u8525","\u7F69","\u970D","\u6488","\u80CE","\u84BC","\u6FF1","\u5006","\u6345","\u6E58","\u780D","\u971E","\u90B5","\u8404","\u760B","\u6DEE","\u9042","\u718A","\u7CDE","\u70D8","\u5BBF","\u6A94","\u6208","\u99C1","\u5AC2","\u88D5","\u5F99","\u7BAD","\u6350","\u8178","\u6490","\u66EC","\u8FA8","\u6BBF","\u84EE","\u6524","\u652A","\u91AC","\u5C4F","\u75AB","\u54C0","\u8521","\u5835","\u6CAB","\u76BA","\u66A2","\u758A","\u95A3","\u840A","\u6572","\u8F44","\u9264","\u75D5","\u58E9","\u5DF7","\u9913","\u798D","\u4E18","\u7384","\u6E9C","\u66F0","\u908F","\u5F6D","\u5617","\u537F","\u59A8","\u8247","\u541E","\u97CB","\u6028","\u77EE","\u6B47"]');

});

parcelRegister("4M2Fv", function(module, exports) {
module.exports = JSON.parse('["\u1100\u1161\u1100\u1167\u11A8","\u1100\u1161\u1101\u1173\u11B7","\u1100\u1161\u1102\u1161\u11AB","\u1100\u1161\u1102\u1173\u11BC","\u1100\u1161\u1103\u1173\u11A8","\u1100\u1161\u1105\u1173\u110E\u1175\u11B7","\u1100\u1161\u1106\u116E\u11B7","\u1100\u1161\u1107\u1161\u11BC","\u1100\u1161\u1109\u1161\u11BC","\u1100\u1161\u1109\u1173\u11B7","\u1100\u1161\u110B\u116E\u11AB\u1103\u1166","\u1100\u1161\u110B\u1173\u11AF","\u1100\u1161\u110B\u1175\u1103\u1173","\u1100\u1161\u110B\u1175\u11B8","\u1100\u1161\u110C\u1161\u11BC","\u1100\u1161\u110C\u1165\u11BC","\u1100\u1161\u110C\u1169\u11A8","\u1100\u1161\u110C\u116E\u11A8","\u1100\u1161\u11A8\u110B\u1169","\u1100\u1161\u11A8\u110C\u1161","\u1100\u1161\u11AB\u1100\u1167\u11A8","\u1100\u1161\u11AB\u1107\u116E","\u1100\u1161\u11AB\u1109\u1165\u11B8","\u1100\u1161\u11AB\u110C\u1161\u11BC","\u1100\u1161\u11AB\u110C\u1165\u11B8","\u1100\u1161\u11AB\u1111\u1161\u11AB","\u1100\u1161\u11AF\u1103\u1173\u11BC","\u1100\u1161\u11AF\u1107\u1175","\u1100\u1161\u11AF\u1109\u1162\u11A8","\u1100\u1161\u11AF\u110C\u1173\u11BC","\u1100\u1161\u11B7\u1100\u1161\u11A8","\u1100\u1161\u11B7\u1100\u1175","\u1100\u1161\u11B7\u1109\u1169","\u1100\u1161\u11B7\u1109\u116E\u1109\u1165\u11BC","\u1100\u1161\u11B7\u110C\u1161","\u1100\u1161\u11B7\u110C\u1165\u11BC","\u1100\u1161\u11B8\u110C\u1161\u1100\u1175","\u1100\u1161\u11BC\u1102\u1161\u11B7","\u1100\u1161\u11BC\u1103\u1161\u11BC","\u1100\u1161\u11BC\u1103\u1169","\u1100\u1161\u11BC\u1105\u1167\u11A8\u1112\u1175","\u1100\u1161\u11BC\u1107\u1167\u11AB","\u1100\u1161\u11BC\u1107\u116E\u11A8","\u1100\u1161\u11BC\u1109\u1161","\u1100\u1161\u11BC\u1109\u116E\u1105\u1163\u11BC","\u1100\u1161\u11BC\u110B\u1161\u110C\u1175","\u1100\u1161\u11BC\u110B\u116F\u11AB\u1103\u1169","\u1100\u1161\u11BC\u110B\u1174","\u1100\u1161\u11BC\u110C\u1166","\u1100\u1161\u11BC\u110C\u1169","\u1100\u1161\u11C0\u110B\u1175","\u1100\u1162\u1100\u116E\u1105\u1175","\u1100\u1162\u1102\u1161\u1105\u1175","\u1100\u1162\u1107\u1161\u11BC","\u1100\u1162\u1107\u1167\u11AF","\u1100\u1162\u1109\u1165\u11AB","\u1100\u1162\u1109\u1165\u11BC","\u1100\u1162\u110B\u1175\u11AB","\u1100\u1162\u11A8\u1100\u116A\u11AB\u110C\u1165\u11A8","\u1100\u1165\u1109\u1175\u11AF","\u1100\u1165\u110B\u1162\u11A8","\u1100\u1165\u110B\u116E\u11AF","\u1100\u1165\u110C\u1175\u11BA","\u1100\u1165\u1111\u116E\u11B7","\u1100\u1165\u11A8\u110C\u1165\u11BC","\u1100\u1165\u11AB\u1100\u1161\u11BC","\u1100\u1165\u11AB\u1106\u116E\u11AF","\u1100\u1165\u11AB\u1109\u1165\u11AF","\u1100\u1165\u11AB\u110C\u1169","\u1100\u1165\u11AB\u110E\u116E\u11A8","\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1100\u1165\u11B7\u1109\u1161","\u1100\u1165\u11B7\u1110\u1169","\u1100\u1166\u1109\u1175\u1111\u1161\u11AB","\u1100\u1166\u110B\u1175\u11B7","\u1100\u1167\u110B\u116E\u11AF","\u1100\u1167\u11AB\u1112\u1162","\u1100\u1167\u11AF\u1100\u116A","\u1100\u1167\u11AF\u1100\u116E\u11A8","\u1100\u1167\u11AF\u1105\u1169\u11AB","\u1100\u1167\u11AF\u1109\u1165\u11A8","\u1100\u1167\u11AF\u1109\u1173\u11BC","\u1100\u1167\u11AF\u1109\u1175\u11B7","\u1100\u1167\u11AF\u110C\u1165\u11BC","\u1100\u1167\u11AF\u1112\u1169\u11AB","\u1100\u1167\u11BC\u1100\u1168","\u1100\u1167\u11BC\u1100\u1169","\u1100\u1167\u11BC\u1100\u1175","\u1100\u1167\u11BC\u1105\u1167\u11A8","\u1100\u1167\u11BC\u1107\u1169\u11A8\u1100\u116E\u11BC","\u1100\u1167\u11BC\u1107\u1175","\u1100\u1167\u11BC\u1109\u1161\u11BC\u1103\u1169","\u1100\u1167\u11BC\u110B\u1167\u11BC","\u1100\u1167\u11BC\u110B\u116E","\u1100\u1167\u11BC\u110C\u1162\u11BC","\u1100\u1167\u11BC\u110C\u1166","\u1100\u1167\u11BC\u110C\u116E","\u1100\u1167\u11BC\u110E\u1161\u11AF","\u1100\u1167\u11BC\u110E\u1175","\u1100\u1167\u11BC\u1112\u1163\u11BC","\u1100\u1167\u11BC\u1112\u1165\u11B7","\u1100\u1168\u1100\u1169\u11A8","\u1100\u1168\u1103\u1161\u11AB","\u1100\u1168\u1105\u1161\u11AB","\u1100\u1168\u1109\u1161\u11AB","\u1100\u1168\u1109\u1169\u11A8","\u1100\u1168\u110B\u1163\u11A8","\u1100\u1168\u110C\u1165\u11AF","\u1100\u1168\u110E\u1173\u11BC","\u1100\u1168\u1112\u116C\u11A8","\u1100\u1169\u1100\u1162\u11A8","\u1100\u1169\u1100\u116E\u1105\u1167","\u1100\u1169\u1100\u116E\u11BC","\u1100\u1169\u1100\u1173\u11B8","\u1100\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1100\u1169\u1106\u116E\u1109\u1175\u11AB","\u1100\u1169\u1106\u1175\u11AB","\u1100\u1169\u110B\u1163\u11BC\u110B\u1175","\u1100\u1169\u110C\u1161\u11BC","\u1100\u1169\u110C\u1165\u11AB","\u1100\u1169\u110C\u1175\u11B8","\u1100\u1169\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1100\u1169\u1110\u1169\u11BC","\u1100\u1169\u1112\u1163\u11BC","\u1100\u1169\u11A8\u1109\u1175\u11A8","\u1100\u1169\u11AF\u1106\u1169\u11A8","\u1100\u1169\u11AF\u110D\u1161\u1100\u1175","\u1100\u1169\u11AF\u1111\u1173","\u1100\u1169\u11BC\u1100\u1161\u11AB","\u1100\u1169\u11BC\u1100\u1162","\u1100\u1169\u11BC\u1100\u1167\u11A8","\u1100\u1169\u11BC\u1100\u116E\u11AB","\u1100\u1169\u11BC\u1100\u1173\u11B8","\u1100\u1169\u11BC\u1100\u1175","\u1100\u1169\u11BC\u1103\u1169\u11BC","\u1100\u1169\u11BC\u1106\u116E\u110B\u116F\u11AB","\u1100\u1169\u11BC\u1107\u116E","\u1100\u1169\u11BC\u1109\u1161","\u1100\u1169\u11BC\u1109\u1175\u11A8","\u1100\u1169\u11BC\u110B\u1165\u11B8","\u1100\u1169\u11BC\u110B\u1167\u11AB","\u1100\u1169\u11BC\u110B\u116F\u11AB","\u1100\u1169\u11BC\u110C\u1161\u11BC","\u1100\u1169\u11BC\u110D\u1161","\u1100\u1169\u11BC\u110E\u1162\u11A8","\u1100\u1169\u11BC\u1110\u1169\u11BC","\u1100\u1169\u11BC\u1111\u1169","\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1100\u1169\u11BC\u1112\u1172\u110B\u1175\u11AF","\u1100\u116A\u1106\u1169\u11A8","\u1100\u116A\u110B\u1175\u11AF","\u1100\u116A\u110C\u1161\u11BC","\u1100\u116A\u110C\u1165\u11BC","\u1100\u116A\u1112\u1161\u11A8","\u1100\u116A\u11AB\u1100\u1162\u11A8","\u1100\u116A\u11AB\u1100\u1168","\u1100\u116A\u11AB\u1100\u116A\u11BC","\u1100\u116A\u11AB\u1102\u1167\u11B7","\u1100\u116A\u11AB\u1105\u1161\u11B7","\u1100\u116A\u11AB\u1105\u1167\u11AB","\u1100\u116A\u11AB\u1105\u1175","\u1100\u116A\u11AB\u1109\u1173\u11B8","\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1100\u116A\u11AB\u110C\u1165\u11B7","\u1100\u116A\u11AB\u110E\u1161\u11AF","\u1100\u116A\u11BC\u1100\u1167\u11BC","\u1100\u116A\u11BC\u1100\u1169","\u1100\u116A\u11BC\u110C\u1161\u11BC","\u1100\u116A\u11BC\u110C\u116E","\u1100\u116C\u1105\u1169\u110B\u116E\u11B7","\u1100\u116C\u11BC\u110C\u1161\u11BC\u1112\u1175","\u1100\u116D\u1100\u116A\u1109\u1165","\u1100\u116D\u1106\u116E\u11AB","\u1100\u116D\u1107\u1169\u11A8","\u1100\u116D\u1109\u1175\u11AF","\u1100\u116D\u110B\u1163\u11BC","\u1100\u116D\u110B\u1172\u11A8","\u1100\u116D\u110C\u1161\u11BC","\u1100\u116D\u110C\u1175\u11A8","\u1100\u116D\u1110\u1169\u11BC","\u1100\u116D\u1112\u116A\u11AB","\u1100\u116D\u1112\u116E\u11AB","\u1100\u116E\u1100\u1167\u11BC","\u1100\u116E\u1105\u1173\u11B7","\u1100\u116E\u1106\u1165\u11BC","\u1100\u116E\u1107\u1167\u11AF","\u1100\u116E\u1107\u116E\u11AB","\u1100\u116E\u1109\u1165\u11A8","\u1100\u116E\u1109\u1165\u11BC","\u1100\u116E\u1109\u1169\u11A8","\u1100\u116E\u110B\u1167\u11A8","\u1100\u116E\u110B\u1175\u11B8","\u1100\u116E\u110E\u1165\u11BC","\u1100\u116E\u110E\u1166\u110C\u1165\u11A8","\u1100\u116E\u11A8\u1100\u1161","\u1100\u116E\u11A8\u1100\u1175","\u1100\u116E\u11A8\u1102\u1162","\u1100\u116E\u11A8\u1105\u1175\u11B8","\u1100\u116E\u11A8\u1106\u116E\u11AF","\u1100\u116E\u11A8\u1106\u1175\u11AB","\u1100\u116E\u11A8\u1109\u116E","\u1100\u116E\u11A8\u110B\u1165","\u1100\u116E\u11A8\u110B\u116A\u11BC","\u1100\u116E\u11A8\u110C\u1165\u11A8","\u1100\u116E\u11A8\u110C\u1166","\u1100\u116E\u11A8\u1112\u116C","\u1100\u116E\u11AB\u1103\u1162","\u1100\u116E\u11AB\u1109\u1161","\u1100\u116E\u11AB\u110B\u1175\u11AB","\u1100\u116E\u11BC\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1100\u116F\u11AB\u1105\u1175","\u1100\u116F\u11AB\u110B\u1171","\u1100\u116F\u11AB\u1110\u116E","\u1100\u1171\u1100\u116E\u11A8","\u1100\u1171\u1109\u1175\u11AB","\u1100\u1172\u110C\u1165\u11BC","\u1100\u1172\u110E\u1175\u11A8","\u1100\u1172\u11AB\u1112\u1167\u11BC","\u1100\u1173\u1102\u1161\u11AF","\u1100\u1173\u1102\u1163\u11BC","\u1100\u1173\u1102\u1173\u11AF","\u1100\u1173\u1105\u1165\u1102\u1161","\u1100\u1173\u1105\u116E\u11B8","\u1100\u1173\u1105\u1173\u11BA","\u1100\u1173\u1105\u1175\u11B7","\u1100\u1173\u110C\u1166\u1109\u1165\u110B\u1163","\u1100\u1173\u1110\u1169\u1105\u1169\u11A8","\u1100\u1173\u11A8\u1107\u1169\u11A8","\u1100\u1173\u11A8\u1112\u1175","\u1100\u1173\u11AB\u1100\u1165","\u1100\u1173\u11AB\u1100\u116D","\u1100\u1173\u11AB\u1105\u1162","\u1100\u1173\u11AB\u1105\u1169","\u1100\u1173\u11AB\u1106\u116E","\u1100\u1173\u11AB\u1107\u1169\u11AB","\u1100\u1173\u11AB\u110B\u116F\u11AB","\u1100\u1173\u11AB\u110B\u1172\u11A8","\u1100\u1173\u11AB\u110E\u1165","\u1100\u1173\u11AF\u110A\u1175","\u1100\u1173\u11AF\u110C\u1161","\u1100\u1173\u11B7\u1100\u1161\u11BC\u1109\u1161\u11AB","\u1100\u1173\u11B7\u1100\u1169","\u1100\u1173\u11B7\u1102\u1167\u11AB","\u1100\u1173\u11B7\u1106\u1166\u1103\u1161\u11AF","\u1100\u1173\u11B7\u110B\u1162\u11A8","\u1100\u1173\u11B7\u110B\u1167\u11AB","\u1100\u1173\u11B7\u110B\u116D\u110B\u1175\u11AF","\u1100\u1173\u11B7\u110C\u1175","\u1100\u1173\u11BC\u110C\u1165\u11BC\u110C\u1165\u11A8","\u1100\u1175\u1100\u1161\u11AB","\u1100\u1175\u1100\u116A\u11AB","\u1100\u1175\u1102\u1167\u11B7","\u1100\u1175\u1102\u1173\u11BC","\u1100\u1175\u1103\u1169\u11A8\u1100\u116D","\u1100\u1175\u1103\u116E\u11BC","\u1100\u1175\u1105\u1169\u11A8","\u1100\u1175\u1105\u1173\u11B7","\u1100\u1175\u1107\u1165\u11B8","\u1100\u1175\u1107\u1169\u11AB","\u1100\u1175\u1107\u116E\u11AB","\u1100\u1175\u1108\u1173\u11B7","\u1100\u1175\u1109\u116E\u11A8\u1109\u1161","\u1100\u1175\u1109\u116E\u11AF","\u1100\u1175\u110B\u1165\u11A8","\u1100\u1175\u110B\u1165\u11B8","\u1100\u1175\u110B\u1169\u11AB","\u1100\u1175\u110B\u116E\u11AB","\u1100\u1175\u110B\u116F\u11AB","\u1100\u1175\u110C\u1165\u11A8","\u1100\u1175\u110C\u116E\u11AB","\u1100\u1175\u110E\u1175\u11B7","\u1100\u1175\u1112\u1169\u11AB","\u1100\u1175\u1112\u116C\u11A8","\u1100\u1175\u11AB\u1100\u1173\u11B8","\u1100\u1175\u11AB\u110C\u1161\u11BC","\u1100\u1175\u11AF\u110B\u1175","\u1100\u1175\u11B7\u1107\u1161\u11B8","\u1100\u1175\u11B7\u110E\u1175","\u1100\u1175\u11B7\u1111\u1169\u1100\u1169\u11BC\u1112\u1161\u11BC","\u1101\u1161\u11A8\u1103\u116E\u1100\u1175","\u1101\u1161\u11B7\u1108\u1161\u11A8","\u1101\u1162\u1103\u1161\u11AF\u110B\u1173\u11B7","\u1101\u1162\u1109\u1169\u1100\u1173\u11B7","\u1101\u1165\u11B8\u110C\u1175\u11AF","\u1101\u1169\u11A8\u1103\u1162\u1100\u1175","\u1101\u1169\u11BE\u110B\u1175\u11C1","\u1102\u1161\u1103\u1173\u11AF\u110B\u1175","\u1102\u1161\u1105\u1161\u11AB\u1112\u1175","\u1102\u1161\u1106\u1165\u110C\u1175","\u1102\u1161\u1106\u116E\u11AF","\u1102\u1161\u110E\u1175\u11B7\u1107\u1161\u11AB","\u1102\u1161\u1112\u1173\u11AF","\u1102\u1161\u11A8\u110B\u1167\u11B8","\u1102\u1161\u11AB\u1107\u1161\u11BC","\u1102\u1161\u11AF\u1100\u1162","\u1102\u1161\u11AF\u110A\u1175","\u1102\u1161\u11AF\u110D\u1161","\u1102\u1161\u11B7\u1102\u1167","\u1102\u1161\u11B7\u1103\u1162\u1106\u116E\u11AB","\u1102\u1161\u11B7\u1106\u1162","\u1102\u1161\u11B7\u1109\u1161\u11AB","\u1102\u1161\u11B7\u110C\u1161","\u1102\u1161\u11B7\u1111\u1167\u11AB","\u1102\u1161\u11B7\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1102\u1161\u11BC\u1107\u1175","\u1102\u1161\u11C0\u1106\u1161\u11AF","\u1102\u1162\u1102\u1167\u11AB","\u1102\u1162\u110B\u116D\u11BC","\u1102\u1162\u110B\u1175\u11AF","\u1102\u1162\u11B7\u1107\u1175","\u1102\u1162\u11B7\u1109\u1162","\u1102\u1162\u11BA\u1106\u116E\u11AF","\u1102\u1162\u11BC\u1103\u1169\u11BC","\u1102\u1162\u11BC\u1106\u1167\u11AB","\u1102\u1162\u11BC\u1107\u1161\u11BC","\u1102\u1162\u11BC\u110C\u1161\u11BC\u1100\u1169","\u1102\u1166\u11A8\u1110\u1161\u110B\u1175","\u1102\u1166\u11BA\u110D\u1162","\u1102\u1169\u1103\u1169\u11BC","\u1102\u1169\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1102\u1169\u1105\u1167\u11A8","\u1102\u1169\u110B\u1175\u11AB","\u1102\u1169\u11A8\u110B\u1173\u11B7","\u1102\u1169\u11A8\u110E\u1161","\u1102\u1169\u11A8\u1112\u116A","\u1102\u1169\u11AB\u1105\u1175","\u1102\u1169\u11AB\u1106\u116E\u11AB","\u1102\u1169\u11AB\u110C\u1162\u11BC","\u1102\u1169\u11AF\u110B\u1175","\u1102\u1169\u11BC\u1100\u116E","\u1102\u1169\u11BC\u1103\u1161\u11B7","\u1102\u1169\u11BC\u1106\u1175\u11AB","\u1102\u1169\u11BC\u1107\u116E","\u1102\u1169\u11BC\u110B\u1165\u11B8","\u1102\u1169\u11BC\u110C\u1161\u11BC","\u1102\u1169\u11BC\u110E\u1169\u11AB","\u1102\u1169\u11C1\u110B\u1175","\u1102\u116E\u11AB\u1103\u1169\u11BC\u110C\u1161","\u1102\u116E\u11AB\u1106\u116E\u11AF","\u1102\u116E\u11AB\u110A\u1165\u11B8","\u1102\u1172\u110B\u116D\u11A8","\u1102\u1173\u1101\u1175\u11B7","\u1102\u1173\u11A8\u1103\u1162","\u1102\u1173\u11BC\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1102\u1173\u11BC\u1105\u1167\u11A8","\u1103\u1161\u1107\u1161\u11BC","\u1103\u1161\u110B\u1163\u11BC\u1109\u1165\u11BC","\u1103\u1161\u110B\u1173\u11B7","\u1103\u1161\u110B\u1175\u110B\u1165\u1110\u1173","\u1103\u1161\u1112\u1162\u11BC","\u1103\u1161\u11AB\u1100\u1168","\u1103\u1161\u11AB\u1100\u1169\u11AF","\u1103\u1161\u11AB\u1103\u1169\u11A8","\u1103\u1161\u11AB\u1106\u1161\u11BA","\u1103\u1161\u11AB\u1109\u116E\u11AB","\u1103\u1161\u11AB\u110B\u1165","\u1103\u1161\u11AB\u110B\u1171","\u1103\u1161\u11AB\u110C\u1165\u11B7","\u1103\u1161\u11AB\u110E\u1166","\u1103\u1161\u11AB\u110E\u116E","\u1103\u1161\u11AB\u1111\u1167\u11AB","\u1103\u1161\u11AB\u1111\u116E\u11BC","\u1103\u1161\u11AF\u1100\u1163\u11AF","\u1103\u1161\u11AF\u1105\u1165","\u1103\u1161\u11AF\u1105\u1167\u11A8","\u1103\u1161\u11AF\u1105\u1175","\u1103\u1161\u11B0\u1100\u1169\u1100\u1175","\u1103\u1161\u11B7\u1103\u1161\u11BC","\u1103\u1161\u11B7\u1107\u1162","\u1103\u1161\u11B7\u110B\u116D","\u1103\u1161\u11B7\u110B\u1175\u11B7","\u1103\u1161\u11B8\u1107\u1167\u11AB","\u1103\u1161\u11B8\u110C\u1161\u11BC","\u1103\u1161\u11BC\u1100\u1173\u11AB","\u1103\u1161\u11BC\u1107\u116E\u11AB\u1100\u1161\u11AB","\u1103\u1161\u11BC\u110B\u1167\u11AB\u1112\u1175","\u1103\u1161\u11BC\u110C\u1161\u11BC","\u1103\u1162\u1100\u1172\u1106\u1169","\u1103\u1162\u1102\u1161\u11BD","\u1103\u1162\u1103\u1161\u11AB\u1112\u1175","\u1103\u1162\u1103\u1161\u11B8","\u1103\u1162\u1103\u1169\u1109\u1175","\u1103\u1162\u1105\u1163\u11A8","\u1103\u1162\u1105\u1163\u11BC","\u1103\u1162\u1105\u1172\u11A8","\u1103\u1162\u1106\u116E\u11AB","\u1103\u1162\u1107\u116E\u1107\u116E\u11AB","\u1103\u1162\u1109\u1175\u11AB","\u1103\u1162\u110B\u1173\u11BC","\u1103\u1162\u110C\u1161\u11BC","\u1103\u1162\u110C\u1165\u11AB","\u1103\u1162\u110C\u1165\u11B8","\u1103\u1162\u110C\u116E\u11BC","\u1103\u1162\u110E\u1162\u11A8","\u1103\u1162\u110E\u116E\u11AF","\u1103\u1162\u110E\u116E\u11BC","\u1103\u1162\u1110\u1169\u11BC\u1105\u1167\u11BC","\u1103\u1162\u1112\u1161\u11A8","\u1103\u1162\u1112\u1161\u11AB\u1106\u1175\u11AB\u1100\u116E\u11A8","\u1103\u1162\u1112\u1161\u11B8\u1109\u1175\u11AF","\u1103\u1162\u1112\u1167\u11BC","\u1103\u1165\u11BC\u110B\u1165\u1105\u1175","\u1103\u1166\u110B\u1175\u1110\u1173","\u1103\u1169\u1103\u1162\u110E\u1166","\u1103\u1169\u1103\u1165\u11A8","\u1103\u1169\u1103\u116E\u11A8","\u1103\u1169\u1106\u1161\u11BC","\u1103\u1169\u1109\u1165\u1100\u116A\u11AB","\u1103\u1169\u1109\u1175\u11B7","\u1103\u1169\u110B\u116E\u11B7","\u1103\u1169\u110B\u1175\u11B8","\u1103\u1169\u110C\u1161\u1100\u1175","\u1103\u1169\u110C\u1165\u1112\u1175","\u1103\u1169\u110C\u1165\u11AB","\u1103\u1169\u110C\u116E\u11BC","\u1103\u1169\u110E\u1161\u11A8","\u1103\u1169\u11A8\u1100\u1161\u11B7","\u1103\u1169\u11A8\u1105\u1175\u11B8","\u1103\u1169\u11A8\u1109\u1165","\u1103\u1169\u11A8\u110B\u1175\u11AF","\u1103\u1169\u11A8\u110E\u1161\u11BC\u110C\u1165\u11A8","\u1103\u1169\u11BC\u1112\u116A\u110E\u1162\u11A8","\u1103\u1171\u11BA\u1106\u1169\u1109\u1173\u11B8","\u1103\u1171\u11BA\u1109\u1161\u11AB","\u1104\u1161\u11AF\u110B\u1161\u110B\u1175","\u1106\u1161\u1102\u116E\u1105\u1161","\u1106\u1161\u1102\u1173\u11AF","\u1106\u1161\u1103\u1161\u11BC","\u1106\u1161\u1105\u1161\u1110\u1169\u11AB","\u1106\u1161\u1105\u1167\u11AB","\u1106\u1161\u1106\u116E\u1105\u1175","\u1106\u1161\u1109\u1161\u110C\u1175","\u1106\u1161\u110B\u1163\u11A8","\u1106\u1161\u110B\u116D\u1102\u1166\u110C\u1173","\u1106\u1161\u110B\u1173\u11AF","\u1106\u1161\u110B\u1173\u11B7","\u1106\u1161\u110B\u1175\u110F\u1173","\u1106\u1161\u110C\u116E\u11BC","\u1106\u1161\u110C\u1175\u1106\u1161\u11A8","\u1106\u1161\u110E\u1161\u11AB\u1100\u1161\u110C\u1175","\u1106\u1161\u110E\u1161\u11AF","\u1106\u1161\u1112\u1173\u11AB","\u1106\u1161\u11A8\u1100\u1165\u11AF\u1105\u1175","\u1106\u1161\u11A8\u1102\u1162","\u1106\u1161\u11A8\u1109\u1161\u11BC","\u1106\u1161\u11AB\u1102\u1161\u11B7","\u1106\u1161\u11AB\u1103\u116E","\u1106\u1161\u11AB\u1109\u1166","\u1106\u1161\u11AB\u110B\u1163\u11A8","\u1106\u1161\u11AB\u110B\u1175\u11AF","\u1106\u1161\u11AB\u110C\u1165\u11B7","\u1106\u1161\u11AB\u110C\u1169\u11A8","\u1106\u1161\u11AB\u1112\u116A","\u1106\u1161\u11AD\u110B\u1175","\u1106\u1161\u11AF\u1100\u1175","\u1106\u1161\u11AF\u110A\u1173\u11B7","\u1106\u1161\u11AF\u1110\u116E","\u1106\u1161\u11B7\u1103\u1162\u1105\u1169","\u1106\u1161\u11BC\u110B\u116F\u11AB\u1100\u1167\u11BC","\u1106\u1162\u1102\u1167\u11AB","\u1106\u1162\u1103\u1161\u11AF","\u1106\u1162\u1105\u1167\u11A8","\u1106\u1162\u1107\u1165\u11AB","\u1106\u1162\u1109\u1173\u110F\u1165\u11B7","\u1106\u1162\u110B\u1175\u11AF","\u1106\u1162\u110C\u1161\u11BC","\u1106\u1162\u11A8\u110C\u116E","\u1106\u1165\u11A8\u110B\u1175","\u1106\u1165\u11AB\u110C\u1165","\u1106\u1165\u11AB\u110C\u1175","\u1106\u1165\u11AF\u1105\u1175","\u1106\u1166\u110B\u1175\u11AF","\u1106\u1167\u1102\u1173\u1105\u1175","\u1106\u1167\u110E\u1175\u11AF","\u1106\u1167\u11AB\u1103\u1161\u11B7","\u1106\u1167\u11AF\u110E\u1175","\u1106\u1167\u11BC\u1103\u1161\u11AB","\u1106\u1167\u11BC\u1105\u1167\u11BC","\u1106\u1167\u11BC\u110B\u1168","\u1106\u1167\u11BC\u110B\u1174","\u1106\u1167\u11BC\u110C\u1165\u11AF","\u1106\u1167\u11BC\u110E\u1175\u11BC","\u1106\u1167\u11BC\u1112\u1161\u11B7","\u1106\u1169\u1100\u1173\u11B7","\u1106\u1169\u1102\u1175\u1110\u1165","\u1106\u1169\u1103\u1166\u11AF","\u1106\u1169\u1103\u1173\u11AB","\u1106\u1169\u1107\u1165\u11B7","\u1106\u1169\u1109\u1173\u11B8","\u1106\u1169\u110B\u1163\u11BC","\u1106\u1169\u110B\u1175\u11B7","\u1106\u1169\u110C\u1169\u1105\u1175","\u1106\u1169\u110C\u1175\u11B8","\u1106\u1169\u1110\u116E\u11BC\u110B\u1175","\u1106\u1169\u11A8\u1100\u1165\u11AF\u110B\u1175","\u1106\u1169\u11A8\u1105\u1169\u11A8","\u1106\u1169\u11A8\u1109\u1161","\u1106\u1169\u11A8\u1109\u1169\u1105\u1175","\u1106\u1169\u11A8\u1109\u116E\u11B7","\u1106\u1169\u11A8\u110C\u1165\u11A8","\u1106\u1169\u11A8\u1111\u116D","\u1106\u1169\u11AF\u1105\u1162","\u1106\u1169\u11B7\u1106\u1162","\u1106\u1169\u11B7\u1106\u116E\u1100\u1166","\u1106\u1169\u11B7\u1109\u1161\u11AF","\u1106\u1169\u11B7\u1109\u1169\u11A8","\u1106\u1169\u11B7\u110C\u1175\u11BA","\u1106\u1169\u11B7\u1110\u1169\u11BC","\u1106\u1169\u11B8\u1109\u1175","\u1106\u116E\u1100\u116A\u11AB\u1109\u1175\u11B7","\u1106\u116E\u1100\u116E\u11BC\u1112\u116A","\u1106\u116E\u1103\u1165\u110B\u1171","\u1106\u116E\u1103\u1165\u11B7","\u1106\u116E\u1105\u1173\u11C1","\u1106\u116E\u1109\u1173\u11AB","\u1106\u116E\u110B\u1165\u11BA","\u1106\u116E\u110B\u1167\u11A8","\u1106\u116E\u110B\u116D\u11BC","\u1106\u116E\u110C\u1169\u1100\u1165\u11AB","\u1106\u116E\u110C\u1175\u1100\u1162","\u1106\u116E\u110E\u1165\u11A8","\u1106\u116E\u11AB\u1100\u116E","\u1106\u116E\u11AB\u1103\u1173\u11A8","\u1106\u116E\u11AB\u1107\u1165\u11B8","\u1106\u116E\u11AB\u1109\u1165","\u1106\u116E\u11AB\u110C\u1166","\u1106\u116E\u11AB\u1112\u1161\u11A8","\u1106\u116E\u11AB\u1112\u116A","\u1106\u116E\u11AF\u1100\u1161","\u1106\u116E\u11AF\u1100\u1165\u11AB","\u1106\u116E\u11AF\u1100\u1167\u11AF","\u1106\u116E\u11AF\u1100\u1169\u1100\u1175","\u1106\u116E\u11AF\u1105\u1169\u11AB","\u1106\u116E\u11AF\u1105\u1175\u1112\u1161\u11A8","\u1106\u116E\u11AF\u110B\u1173\u11B7","\u1106\u116E\u11AF\u110C\u1175\u11AF","\u1106\u116E\u11AF\u110E\u1166","\u1106\u1175\u1100\u116E\u11A8","\u1106\u1175\u1103\u1175\u110B\u1165","\u1106\u1175\u1109\u1161\u110B\u1175\u11AF","\u1106\u1175\u1109\u116E\u11AF","\u1106\u1175\u110B\u1167\u11A8","\u1106\u1175\u110B\u116D\u11BC\u1109\u1175\u11AF","\u1106\u1175\u110B\u116E\u11B7","\u1106\u1175\u110B\u1175\u11AB","\u1106\u1175\u1110\u1175\u11BC","\u1106\u1175\u1112\u1169\u11AB","\u1106\u1175\u11AB\u1100\u1161\u11AB","\u1106\u1175\u11AB\u110C\u1169\u11A8","\u1106\u1175\u11AB\u110C\u116E","\u1106\u1175\u11AE\u110B\u1173\u11B7","\u1106\u1175\u11AF\u1100\u1161\u1105\u116E","\u1106\u1175\u11AF\u1105\u1175\u1106\u1175\u1110\u1165","\u1106\u1175\u11C0\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1100\u1161\u110C\u1175","\u1107\u1161\u1100\u116E\u1102\u1175","\u1107\u1161\u1102\u1161\u1102\u1161","\u1107\u1161\u1102\u1173\u11AF","\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u1103\u1161\u11BA\u1100\u1161","\u1107\u1161\u1105\u1161\u11B7","\u1107\u1161\u110B\u1175\u1105\u1165\u1109\u1173","\u1107\u1161\u1110\u1161\u11BC","\u1107\u1161\u11A8\u1106\u116E\u11AF\u1100\u116A\u11AB","\u1107\u1161\u11A8\u1109\u1161","\u1107\u1161\u11A8\u1109\u116E","\u1107\u1161\u11AB\u1103\u1162","\u1107\u1161\u11AB\u1103\u1173\u1109\u1175","\u1107\u1161\u11AB\u1106\u1161\u11AF","\u1107\u1161\u11AB\u1107\u1161\u11AF","\u1107\u1161\u11AB\u1109\u1165\u11BC","\u1107\u1161\u11AB\u110B\u1173\u11BC","\u1107\u1161\u11AB\u110C\u1161\u11BC","\u1107\u1161\u11AB\u110C\u116E\u11A8","\u1107\u1161\u11AB\u110C\u1175","\u1107\u1161\u11AB\u110E\u1161\u11AB","\u1107\u1161\u11AE\u110E\u1175\u11B7","\u1107\u1161\u11AF\u1100\u1161\u1105\u1161\u11A8","\u1107\u1161\u11AF\u1100\u1165\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u1100\u1167\u11AB","\u1107\u1161\u11AF\u1103\u1161\u11AF","\u1107\u1161\u11AF\u1105\u1166","\u1107\u1161\u11AF\u1106\u1169\u11A8","\u1107\u1161\u11AF\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11AF\u1109\u1162\u11BC","\u1107\u1161\u11AF\u110B\u1173\u11B7","\u1107\u1161\u11AF\u110C\u1161\u1100\u116E\u11A8","\u1107\u1161\u11AF\u110C\u1165\u11AB","\u1107\u1161\u11AF\u1110\u1169\u11B8","\u1107\u1161\u11AF\u1111\u116D","\u1107\u1161\u11B7\u1112\u1161\u1102\u1173\u11AF","\u1107\u1161\u11B8\u1100\u1173\u1105\u1173\u11BA","\u1107\u1161\u11B8\u1106\u1161\u11BA","\u1107\u1161\u11B8\u1109\u1161\u11BC","\u1107\u1161\u11B8\u1109\u1169\u11C0","\u1107\u1161\u11BC\u1100\u1173\u11B7","\u1107\u1161\u11BC\u1106\u1167\u11AB","\u1107\u1161\u11BC\u1106\u116E\u11AB","\u1107\u1161\u11BC\u1107\u1161\u1103\u1161\u11A8","\u1107\u1161\u11BC\u1107\u1165\u11B8","\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1107\u1161\u11BC\u1109\u1175\u11A8","\u1107\u1161\u11BC\u110B\u1161\u11AB","\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1161\u11BC\u110C\u1175","\u1107\u1161\u11BC\u1112\u1161\u11A8","\u1107\u1161\u11BC\u1112\u1162","\u1107\u1161\u11BC\u1112\u1163\u11BC","\u1107\u1162\u1100\u1167\u11BC","\u1107\u1162\u1101\u1169\u11B8","\u1107\u1162\u1103\u1161\u11AF","\u1107\u1162\u1103\u1173\u1106\u1175\u11AB\u1110\u1165\u11AB","\u1107\u1162\u11A8\u1103\u116E\u1109\u1161\u11AB","\u1107\u1162\u11A8\u1109\u1162\u11A8","\u1107\u1162\u11A8\u1109\u1165\u11BC","\u1107\u1162\u11A8\u110B\u1175\u11AB","\u1107\u1162\u11A8\u110C\u1166","\u1107\u1162\u11A8\u1112\u116A\u110C\u1165\u11B7","\u1107\u1165\u1105\u1173\u11BA","\u1107\u1165\u1109\u1165\u11BA","\u1107\u1165\u1110\u1173\u11AB","\u1107\u1165\u11AB\u1100\u1162","\u1107\u1165\u11AB\u110B\u1167\u11A8","\u1107\u1165\u11AB\u110C\u1175","\u1107\u1165\u11AB\u1112\u1169","\u1107\u1165\u11AF\u1100\u1173\u11B7","\u1107\u1165\u11AF\u1105\u1166","\u1107\u1165\u11AF\u110A\u1165","\u1107\u1165\u11B7\u110B\u1171","\u1107\u1165\u11B7\u110B\u1175\u11AB","\u1107\u1165\u11B7\u110C\u116C","\u1107\u1165\u11B8\u1105\u1172\u11AF","\u1107\u1165\u11B8\u110B\u116F\u11AB","\u1107\u1165\u11B8\u110C\u1165\u11A8","\u1107\u1165\u11B8\u110E\u1175\u11A8","\u1107\u1166\u110B\u1175\u110C\u1175\u11BC","\u1107\u1166\u11AF\u1110\u1173","\u1107\u1167\u11AB\u1100\u1167\u11BC","\u1107\u1167\u11AB\u1103\u1169\u11BC","\u1107\u1167\u11AB\u1106\u1167\u11BC","\u1107\u1167\u11AB\u1109\u1175\u11AB","\u1107\u1167\u11AB\u1112\u1169\u1109\u1161","\u1107\u1167\u11AB\u1112\u116A","\u1107\u1167\u11AF\u1103\u1169","\u1107\u1167\u11AF\u1106\u1167\u11BC","\u1107\u1167\u11AF\u110B\u1175\u11AF","\u1107\u1167\u11BC\u1109\u1175\u11AF","\u1107\u1167\u11BC\u110B\u1161\u1105\u1175","\u1107\u1167\u11BC\u110B\u116F\u11AB","\u1107\u1169\u1100\u116A\u11AB","\u1107\u1169\u1102\u1165\u1109\u1173","\u1107\u1169\u1105\u1161\u1109\u1162\u11A8","\u1107\u1169\u1105\u1161\u11B7","\u1107\u1169\u1105\u1173\u11B7","\u1107\u1169\u1109\u1161\u11BC","\u1107\u1169\u110B\u1161\u11AB","\u1107\u1169\u110C\u1161\u1100\u1175","\u1107\u1169\u110C\u1161\u11BC","\u1107\u1169\u110C\u1165\u11AB","\u1107\u1169\u110C\u1169\u11AB","\u1107\u1169\u1110\u1169\u11BC","\u1107\u1169\u1111\u1167\u11AB\u110C\u1165\u11A8","\u1107\u1169\u1112\u1165\u11B7","\u1107\u1169\u11A8\u1103\u1169","\u1107\u1169\u11A8\u1109\u1161","\u1107\u1169\u11A8\u1109\u116E\u11BC\u110B\u1161","\u1107\u1169\u11A8\u1109\u1173\u11B8","\u1107\u1169\u11A9\u110B\u1173\u11B7","\u1107\u1169\u11AB\u1100\u1167\u11A8\u110C\u1165\u11A8","\u1107\u1169\u11AB\u1105\u1162","\u1107\u1169\u11AB\u1107\u116E","\u1107\u1169\u11AB\u1109\u1161","\u1107\u1169\u11AB\u1109\u1165\u11BC","\u1107\u1169\u11AB\u110B\u1175\u11AB","\u1107\u1169\u11AB\u110C\u1175\u11AF","\u1107\u1169\u11AF\u1111\u1166\u11AB","\u1107\u1169\u11BC\u1109\u1161","\u1107\u1169\u11BC\u110C\u1175","\u1107\u1169\u11BC\u1110\u116E","\u1107\u116E\u1100\u1173\u11AB","\u1107\u116E\u1101\u1173\u1105\u1165\u110B\u116E\u11B7","\u1107\u116E\u1103\u1161\u11B7","\u1107\u116E\u1103\u1169\u11BC\u1109\u1161\u11AB","\u1107\u116E\u1106\u116E\u11AB","\u1107\u116E\u1107\u116E\u11AB","\u1107\u116E\u1109\u1161\u11AB","\u1107\u116E\u1109\u1161\u11BC","\u1107\u116E\u110B\u1165\u11BF","\u1107\u116E\u110B\u1175\u11AB","\u1107\u116E\u110C\u1161\u11A8\u110B\u116D\u11BC","\u1107\u116E\u110C\u1161\u11BC","\u1107\u116E\u110C\u1165\u11BC","\u1107\u116E\u110C\u1169\u11A8","\u1107\u116E\u110C\u1175\u1105\u1165\u11AB\u1112\u1175","\u1107\u116E\u110E\u1175\u11AB","\u1107\u116E\u1110\u1161\u11A8","\u1107\u116E\u1111\u116E\u11B7","\u1107\u116E\u1112\u116C\u110C\u1161\u11BC","\u1107\u116E\u11A8\u1107\u116E","\u1107\u116E\u11A8\u1112\u1161\u11AB","\u1107\u116E\u11AB\u1102\u1169","\u1107\u116E\u11AB\u1105\u1163\u11BC","\u1107\u116E\u11AB\u1105\u1175","\u1107\u116E\u11AB\u1106\u1167\u11BC","\u1107\u116E\u11AB\u1109\u1165\u11A8","\u1107\u116E\u11AB\u110B\u1163","\u1107\u116E\u11AB\u110B\u1171\u1100\u1175","\u1107\u116E\u11AB\u1111\u1175\u11AF","\u1107\u116E\u11AB\u1112\u1169\u11BC\u1109\u1162\u11A8","\u1107\u116E\u11AF\u1100\u1169\u1100\u1175","\u1107\u116E\u11AF\u1100\u116A","\u1107\u116E\u11AF\u1100\u116D","\u1107\u116E\u11AF\u1101\u1169\u11BE","\u1107\u116E\u11AF\u1106\u1161\u11AB","\u1107\u116E\u11AF\u1107\u1165\u11B8","\u1107\u116E\u11AF\u1107\u1175\u11BE","\u1107\u116E\u11AF\u110B\u1161\u11AB","\u1107\u116E\u11AF\u110B\u1175\u110B\u1175\u11A8","\u1107\u116E\u11AF\u1112\u1162\u11BC","\u1107\u1173\u1105\u1162\u11AB\u1103\u1173","\u1107\u1175\u1100\u1173\u11A8","\u1107\u1175\u1102\u1161\u11AB","\u1107\u1175\u1102\u1175\u11AF","\u1107\u1175\u1103\u116E\u11AF\u1100\u1175","\u1107\u1175\u1103\u1175\u110B\u1169","\u1107\u1175\u1105\u1169\u1109\u1169","\u1107\u1175\u1106\u1161\u11AB","\u1107\u1175\u1106\u1167\u11BC","\u1107\u1175\u1106\u1175\u11AF","\u1107\u1175\u1107\u1161\u1105\u1161\u11B7","\u1107\u1175\u1107\u1175\u11B7\u1107\u1161\u11B8","\u1107\u1175\u1109\u1161\u11BC","\u1107\u1175\u110B\u116D\u11BC","\u1107\u1175\u110B\u1172\u11AF","\u1107\u1175\u110C\u116E\u11BC","\u1107\u1175\u1110\u1161\u1106\u1175\u11AB","\u1107\u1175\u1111\u1161\u11AB","\u1107\u1175\u11AF\u1103\u1175\u11BC","\u1107\u1175\u11BA\u1106\u116E\u11AF","\u1107\u1175\u11BA\u1107\u1161\u11BC\u110B\u116E\u11AF","\u1107\u1175\u11BA\u110C\u116E\u11AF\u1100\u1175","\u1107\u1175\u11BE\u1101\u1161\u11AF","\u1108\u1161\u11AF\u1100\u1161\u11AB\u1109\u1162\u11A8","\u1108\u1161\u11AF\u1105\u1162","\u1108\u1161\u11AF\u1105\u1175","\u1109\u1161\u1100\u1165\u11AB","\u1109\u1161\u1100\u1168\u110C\u1165\u11AF","\u1109\u1161\u1102\u1161\u110B\u1175","\u1109\u1161\u1102\u1163\u11BC","\u1109\u1161\u1105\u1161\u11B7","\u1109\u1161\u1105\u1161\u11BC","\u1109\u1161\u1105\u1175\u11B8","\u1109\u1161\u1106\u1169\u1102\u1175\u11B7","\u1109\u1161\u1106\u116E\u11AF","\u1109\u1161\u1107\u1161\u11BC","\u1109\u1161\u1109\u1161\u11BC","\u1109\u1161\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1161\u1109\u1165\u11AF","\u1109\u1161\u1109\u1173\u11B7","\u1109\u1161\u1109\u1175\u11AF","\u1109\u1161\u110B\u1165\u11B8","\u1109\u1161\u110B\u116D\u11BC","\u1109\u1161\u110B\u116F\u11AF","\u1109\u1161\u110C\u1161\u11BC","\u1109\u1161\u110C\u1165\u11AB","\u1109\u1161\u110C\u1175\u11AB","\u1109\u1161\u110E\u1169\u11AB","\u1109\u1161\u110E\u116E\u11AB\u1100\u1175","\u1109\u1161\u1110\u1161\u11BC","\u1109\u1161\u1110\u116E\u1105\u1175","\u1109\u1161\u1112\u1173\u11AF","\u1109\u1161\u11AB\u1100\u1175\u11AF","\u1109\u1161\u11AB\u1107\u116E\u110B\u1175\u11AB\u1100\u116A","\u1109\u1161\u11AB\u110B\u1165\u11B8","\u1109\u1161\u11AB\u110E\u1162\u11A8","\u1109\u1161\u11AF\u1105\u1175\u11B7","\u1109\u1161\u11AF\u110B\u1175\u11AB","\u1109\u1161\u11AF\u110D\u1161\u11A8","\u1109\u1161\u11B7\u1100\u1168\u1110\u1161\u11BC","\u1109\u1161\u11B7\u1100\u116E\u11A8","\u1109\u1161\u11B7\u1109\u1175\u11B8","\u1109\u1161\u11B7\u110B\u116F\u11AF","\u1109\u1161\u11B7\u110E\u1169\u11AB","\u1109\u1161\u11BC\u1100\u116A\u11AB","\u1109\u1161\u11BC\u1100\u1173\u11B7","\u1109\u1161\u11BC\u1103\u1162","\u1109\u1161\u11BC\u1105\u1172","\u1109\u1161\u11BC\u1107\u1161\u11AB\u1100\u1175","\u1109\u1161\u11BC\u1109\u1161\u11BC","\u1109\u1161\u11BC\u1109\u1175\u11A8","\u1109\u1161\u11BC\u110B\u1165\u11B8","\u1109\u1161\u11BC\u110B\u1175\u11AB","\u1109\u1161\u11BC\u110C\u1161","\u1109\u1161\u11BC\u110C\u1165\u11B7","\u1109\u1161\u11BC\u110E\u1165","\u1109\u1161\u11BC\u110E\u116E","\u1109\u1161\u11BC\u1110\u1162","\u1109\u1161\u11BC\u1111\u116D","\u1109\u1161\u11BC\u1111\u116E\u11B7","\u1109\u1161\u11BC\u1112\u116A\u11BC","\u1109\u1162\u1107\u1167\u11A8","\u1109\u1162\u11A8\u1101\u1161\u11AF","\u1109\u1162\u11A8\u110B\u1167\u11AB\u1111\u1175\u11AF","\u1109\u1162\u11BC\u1100\u1161\u11A8","\u1109\u1162\u11BC\u1106\u1167\u11BC","\u1109\u1162\u11BC\u1106\u116E\u11AF","\u1109\u1162\u11BC\u1107\u1161\u11BC\u1109\u1169\u11BC","\u1109\u1162\u11BC\u1109\u1161\u11AB","\u1109\u1162\u11BC\u1109\u1165\u11AB","\u1109\u1162\u11BC\u1109\u1175\u11AB","\u1109\u1162\u11BC\u110B\u1175\u11AF","\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1165\u1105\u1161\u11B8","\u1109\u1165\u1105\u1173\u11AB","\u1109\u1165\u1106\u1167\u11BC","\u1109\u1165\u1106\u1175\u11AB","\u1109\u1165\u1107\u1175\u1109\u1173","\u1109\u1165\u110B\u1163\u11BC","\u1109\u1165\u110B\u116E\u11AF","\u1109\u1165\u110C\u1165\u11A8","\u1109\u1165\u110C\u1165\u11B7","\u1109\u1165\u110D\u1169\u11A8","\u1109\u1165\u110F\u1173\u11AF","\u1109\u1165\u11A8\u1109\u1161","\u1109\u1165\u11A8\u110B\u1172","\u1109\u1165\u11AB\u1100\u1165","\u1109\u1165\u11AB\u1106\u116E\u11AF","\u1109\u1165\u11AB\u1107\u1162","\u1109\u1165\u11AB\u1109\u1162\u11BC","\u1109\u1165\u11AB\u1109\u116E","\u1109\u1165\u11AB\u110B\u116F\u11AB","\u1109\u1165\u11AB\u110C\u1161\u11BC","\u1109\u1165\u11AB\u110C\u1165\u11AB","\u1109\u1165\u11AB\u1110\u1162\u11A8","\u1109\u1165\u11AB\u1111\u116E\u11BC\u1100\u1175","\u1109\u1165\u11AF\u1100\u1165\u110C\u1175","\u1109\u1165\u11AF\u1102\u1161\u11AF","\u1109\u1165\u11AF\u1105\u1165\u11BC\u1110\u1161\u11BC","\u1109\u1165\u11AF\u1106\u1167\u11BC","\u1109\u1165\u11AF\u1106\u116E\u11AB","\u1109\u1165\u11AF\u1109\u1161","\u1109\u1165\u11AF\u110B\u1161\u11A8\u1109\u1161\u11AB","\u1109\u1165\u11AF\u110E\u1175","\u1109\u1165\u11AF\u1110\u1161\u11BC","\u1109\u1165\u11B8\u110A\u1175","\u1109\u1165\u11BC\u1100\u1169\u11BC","\u1109\u1165\u11BC\u1103\u1161\u11BC","\u1109\u1165\u11BC\u1106\u1167\u11BC","\u1109\u1165\u11BC\u1107\u1167\u11AF","\u1109\u1165\u11BC\u110B\u1175\u11AB","\u1109\u1165\u11BC\u110C\u1161\u11BC","\u1109\u1165\u11BC\u110C\u1165\u11A8","\u1109\u1165\u11BC\u110C\u1175\u11AF","\u1109\u1165\u11BC\u1112\u1161\u11B7","\u1109\u1166\u1100\u1173\u11B7","\u1109\u1166\u1106\u1175\u1102\u1161","\u1109\u1166\u1109\u1161\u11BC","\u1109\u1166\u110B\u116F\u11AF","\u1109\u1166\u110C\u1169\u11BC\u1103\u1162\u110B\u116A\u11BC","\u1109\u1166\u1110\u1161\u11A8","\u1109\u1166\u11AB\u1110\u1165","\u1109\u1166\u11AB\u1110\u1175\u1106\u1175\u1110\u1165","\u1109\u1166\u11BA\u110D\u1162","\u1109\u1169\u1100\u1172\u1106\u1169","\u1109\u1169\u1100\u1173\u11A8\u110C\u1165\u11A8","\u1109\u1169\u1100\u1173\u11B7","\u1109\u1169\u1102\u1161\u1100\u1175","\u1109\u1169\u1102\u1167\u11AB","\u1109\u1169\u1103\u1173\u11A8","\u1109\u1169\u1106\u1161\u11BC","\u1109\u1169\u1106\u116E\u11AB","\u1109\u1169\u1109\u1165\u11AF","\u1109\u1169\u1109\u1169\u11A8","\u1109\u1169\u110B\u1161\u1100\u116A","\u1109\u1169\u110B\u116D\u11BC","\u1109\u1169\u110B\u116F\u11AB","\u1109\u1169\u110B\u1173\u11B7","\u1109\u1169\u110C\u116E\u11BC\u1112\u1175","\u1109\u1169\u110C\u1175\u1111\u116E\u11B7","\u1109\u1169\u110C\u1175\u11AF","\u1109\u1169\u1111\u116E\u11BC","\u1109\u1169\u1112\u1167\u11BC","\u1109\u1169\u11A8\u1103\u1161\u11B7","\u1109\u1169\u11A8\u1103\u1169","\u1109\u1169\u11A8\u110B\u1169\u11BA","\u1109\u1169\u11AB\u1100\u1161\u1105\u1161\u11A8","\u1109\u1169\u11AB\u1100\u1175\u11AF","\u1109\u1169\u11AB\u1102\u1167","\u1109\u1169\u11AB\u1102\u1175\u11B7","\u1109\u1169\u11AB\u1103\u1173\u11BC","\u1109\u1169\u11AB\u1106\u1169\u11A8","\u1109\u1169\u11AB\u1108\u1167\u11A8","\u1109\u1169\u11AB\u1109\u1175\u11AF","\u1109\u1169\u11AB\u110C\u1175\u11AF","\u1109\u1169\u11AB\u1110\u1169\u11B8","\u1109\u1169\u11AB\u1112\u1162","\u1109\u1169\u11AF\u110C\u1175\u11A8\u1112\u1175","\u1109\u1169\u11B7\u110A\u1175","\u1109\u1169\u11BC\u110B\u1161\u110C\u1175","\u1109\u1169\u11BC\u110B\u1175","\u1109\u1169\u11BC\u1111\u1167\u11AB","\u1109\u116C\u1100\u1169\u1100\u1175","\u1109\u116D\u1111\u1175\u11BC","\u1109\u116E\u1100\u1165\u11AB","\u1109\u116E\u1102\u1167\u11AB","\u1109\u116E\u1103\u1161\u11AB","\u1109\u116E\u1103\u1169\u11BA\u1106\u116E\u11AF","\u1109\u116E\u1103\u1169\u11BC\u110C\u1165\u11A8","\u1109\u116E\u1106\u1167\u11AB","\u1109\u116E\u1106\u1167\u11BC","\u1109\u116E\u1107\u1161\u11A8","\u1109\u116E\u1109\u1161\u11BC","\u1109\u116E\u1109\u1165\u11A8","\u1109\u116E\u1109\u116E\u11AF","\u1109\u116E\u1109\u1175\u1105\u1169","\u1109\u116E\u110B\u1165\u11B8","\u1109\u116E\u110B\u1167\u11B7","\u1109\u116E\u110B\u1167\u11BC","\u1109\u116E\u110B\u1175\u11B8","\u1109\u116E\u110C\u116E\u11AB","\u1109\u116E\u110C\u1175\u11B8","\u1109\u116E\u110E\u116E\u11AF","\u1109\u116E\u110F\u1165\u11BA","\u1109\u116E\u1111\u1175\u11AF","\u1109\u116E\u1112\u1161\u11A8","\u1109\u116E\u1112\u1165\u11B7\u1109\u1162\u11BC","\u1109\u116E\u1112\u116A\u1100\u1175","\u1109\u116E\u11A8\u1102\u1167","\u1109\u116E\u11A8\u1109\u1169","\u1109\u116E\u11A8\u110C\u1166","\u1109\u116E\u11AB\u1100\u1161\u11AB","\u1109\u116E\u11AB\u1109\u1165","\u1109\u116E\u11AB\u1109\u116E","\u1109\u116E\u11AB\u1109\u1175\u11A8\u1100\u1161\u11AB","\u1109\u116E\u11AB\u110B\u1171","\u1109\u116E\u11AE\u1100\u1161\u1105\u1161\u11A8","\u1109\u116E\u11AF\u1107\u1167\u11BC","\u1109\u116E\u11AF\u110C\u1175\u11B8","\u1109\u116E\u11BA\u110C\u1161","\u1109\u1173\u1102\u1175\u11B7","\u1109\u1173\u1106\u116E\u11AF","\u1109\u1173\u1109\u1173\u1105\u1169","\u1109\u1173\u1109\u1173\u11BC","\u1109\u1173\u110B\u1170\u1110\u1165","\u1109\u1173\u110B\u1171\u110E\u1175","\u1109\u1173\u110F\u1166\u110B\u1175\u1110\u1173","\u1109\u1173\u1110\u1172\u1103\u1175\u110B\u1169","\u1109\u1173\u1110\u1173\u1105\u1166\u1109\u1173","\u1109\u1173\u1111\u1169\u110E\u1173","\u1109\u1173\u11AF\u110D\u1165\u11A8","\u1109\u1173\u11AF\u1111\u1173\u11B7","\u1109\u1173\u11B8\u1100\u116A\u11AB","\u1109\u1173\u11B8\u1100\u1175","\u1109\u1173\u11BC\u1100\u1162\u11A8","\u1109\u1173\u11BC\u1105\u1175","\u1109\u1173\u11BC\u1107\u116E","\u1109\u1173\u11BC\u110B\u116D\u11BC\u110E\u1161","\u1109\u1173\u11BC\u110C\u1175\u11AB","\u1109\u1175\u1100\u1161\u11A8","\u1109\u1175\u1100\u1161\u11AB","\u1109\u1175\u1100\u1169\u11AF","\u1109\u1175\u1100\u1173\u11B7\u110E\u1175","\u1109\u1175\u1102\u1161\u1105\u1175\u110B\u1169","\u1109\u1175\u1103\u1162\u11A8","\u1109\u1175\u1105\u1175\u110C\u1173","\u1109\u1175\u1106\u1166\u11AB\u1110\u1173","\u1109\u1175\u1106\u1175\u11AB","\u1109\u1175\u1107\u116E\u1106\u1169","\u1109\u1175\u1109\u1165\u11AB","\u1109\u1175\u1109\u1165\u11AF","\u1109\u1175\u1109\u1173\u1110\u1166\u11B7","\u1109\u1175\u110B\u1161\u1107\u1165\u110C\u1175","\u1109\u1175\u110B\u1165\u1106\u1165\u1102\u1175","\u1109\u1175\u110B\u116F\u11AF","\u1109\u1175\u110B\u1175\u11AB","\u1109\u1175\u110B\u1175\u11AF","\u1109\u1175\u110C\u1161\u11A8","\u1109\u1175\u110C\u1161\u11BC","\u1109\u1175\u110C\u1165\u11AF","\u1109\u1175\u110C\u1165\u11B7","\u1109\u1175\u110C\u116E\u11BC","\u1109\u1175\u110C\u1173\u11AB","\u1109\u1175\u110C\u1175\u11B8","\u1109\u1175\u110E\u1165\u11BC","\u1109\u1175\u1112\u1161\u11B8","\u1109\u1175\u1112\u1165\u11B7","\u1109\u1175\u11A8\u1100\u116E","\u1109\u1175\u11A8\u1100\u1175","\u1109\u1175\u11A8\u1103\u1161\u11BC","\u1109\u1175\u11A8\u1105\u1163\u11BC","\u1109\u1175\u11A8\u1105\u116D\u1111\u116E\u11B7","\u1109\u1175\u11A8\u1106\u116E\u11AF","\u1109\u1175\u11A8\u1108\u1161\u11BC","\u1109\u1175\u11A8\u1109\u1161","\u1109\u1175\u11A8\u1109\u1162\u11BC\u1112\u116A\u11AF","\u1109\u1175\u11A8\u110E\u1169","\u1109\u1175\u11A8\u1110\u1161\u11A8","\u1109\u1175\u11A8\u1111\u116E\u11B7","\u1109\u1175\u11AB\u1100\u1169","\u1109\u1175\u11AB\u1100\u1172","\u1109\u1175\u11AB\u1102\u1167\u11B7","\u1109\u1175\u11AB\u1106\u116E\u11AB","\u1109\u1175\u11AB\u1107\u1161\u11AF","\u1109\u1175\u11AB\u1107\u1175","\u1109\u1175\u11AB\u1109\u1161","\u1109\u1175\u11AB\u1109\u1166","\u1109\u1175\u11AB\u110B\u116D\u11BC","\u1109\u1175\u11AB\u110C\u1166\u1111\u116E\u11B7","\u1109\u1175\u11AB\u110E\u1165\u11BC","\u1109\u1175\u11AB\u110E\u1166","\u1109\u1175\u11AB\u1112\u116A","\u1109\u1175\u11AF\u1100\u1161\u11B7","\u1109\u1175\u11AF\u1102\u1162","\u1109\u1175\u11AF\u1105\u1167\u11A8","\u1109\u1175\u11AF\u1105\u1168","\u1109\u1175\u11AF\u1106\u1161\u11BC","\u1109\u1175\u11AF\u1109\u116E","\u1109\u1175\u11AF\u1109\u1173\u11B8","\u1109\u1175\u11AF\u1109\u1175","\u1109\u1175\u11AF\u110C\u1161\u11BC","\u1109\u1175\u11AF\u110C\u1165\u11BC","\u1109\u1175\u11AF\u110C\u1175\u11AF\u110C\u1165\u11A8","\u1109\u1175\u11AF\u110E\u1165\u11AB","\u1109\u1175\u11AF\u110E\u1166","\u1109\u1175\u11AF\u110F\u1165\u11BA","\u1109\u1175\u11AF\u1110\u1162","\u1109\u1175\u11AF\u1111\u1162","\u1109\u1175\u11AF\u1112\u1165\u11B7","\u1109\u1175\u11AF\u1112\u1167\u11AB","\u1109\u1175\u11B7\u1105\u1175","\u1109\u1175\u11B7\u1107\u116E\u1105\u1173\u11B7","\u1109\u1175\u11B7\u1109\u1161","\u1109\u1175\u11B7\u110C\u1161\u11BC","\u1109\u1175\u11B7\u110C\u1165\u11BC","\u1109\u1175\u11B7\u1111\u1161\u11AB","\u110A\u1161\u11BC\u1103\u116E\u11BC\u110B\u1175","\u110A\u1175\u1105\u1173\u11B7","\u110A\u1175\u110B\u1161\u11BA","\u110B\u1161\u1100\u1161\u110A\u1175","\u110B\u1161\u1102\u1161\u110B\u116E\u11AB\u1109\u1165","\u110B\u1161\u1103\u1173\u1102\u1175\u11B7","\u110B\u1161\u1103\u1173\u11AF","\u110B\u1161\u1109\u1171\u110B\u116E\u11B7","\u110B\u1161\u1109\u1173\u1111\u1161\u11AF\u1110\u1173","\u110B\u1161\u1109\u1175\u110B\u1161","\u110B\u1161\u110B\u116E\u11AF\u1105\u1165","\u110B\u1161\u110C\u1165\u110A\u1175","\u110B\u1161\u110C\u116E\u11B7\u1106\u1161","\u110B\u1161\u110C\u1175\u11A8","\u110B\u1161\u110E\u1175\u11B7","\u110B\u1161\u1111\u1161\u1110\u1173","\u110B\u1161\u1111\u1173\u1105\u1175\u110F\u1161","\u110B\u1161\u1111\u1173\u11B7","\u110B\u1161\u1112\u1169\u11B8","\u110B\u1161\u1112\u1173\u11AB","\u110B\u1161\u11A8\u1100\u1175","\u110B\u1161\u11A8\u1106\u1169\u11BC","\u110B\u1161\u11A8\u1109\u116E","\u110B\u1161\u11AB\u1100\u1162","\u110B\u1161\u11AB\u1100\u1167\u11BC","\u110B\u1161\u11AB\u1100\u116A","\u110B\u1161\u11AB\u1102\u1162","\u110B\u1161\u11AB\u1102\u1167\u11BC","\u110B\u1161\u11AB\u1103\u1169\u11BC","\u110B\u1161\u11AB\u1107\u1161\u11BC","\u110B\u1161\u11AB\u1107\u116E","\u110B\u1161\u11AB\u110C\u116E","\u110B\u1161\u11AF\u1105\u116E\u1106\u1175\u1102\u1172\u11B7","\u110B\u1161\u11AF\u110F\u1169\u110B\u1169\u11AF","\u110B\u1161\u11B7\u1109\u1175","\u110B\u1161\u11B7\u110F\u1165\u11BA","\u110B\u1161\u11B8\u1105\u1167\u11A8","\u110B\u1161\u11C1\u1102\u1161\u11AF","\u110B\u1161\u11C1\u1106\u116E\u11AB","\u110B\u1162\u110B\u1175\u11AB","\u110B\u1162\u110C\u1165\u11BC","\u110B\u1162\u11A8\u1109\u116E","\u110B\u1162\u11AF\u1107\u1165\u11B7","\u110B\u1163\u1100\u1161\u11AB","\u110B\u1163\u1103\u1161\u11AB","\u110B\u1163\u110B\u1169\u11BC","\u110B\u1163\u11A8\u1100\u1161\u11AB","\u110B\u1163\u11A8\u1100\u116E\u11A8","\u110B\u1163\u11A8\u1109\u1169\u11A8","\u110B\u1163\u11A8\u1109\u116E","\u110B\u1163\u11A8\u110C\u1165\u11B7","\u110B\u1163\u11A8\u1111\u116E\u11B7","\u110B\u1163\u11A8\u1112\u1169\u11AB\u1102\u1167","\u110B\u1163\u11BC\u1102\u1167\u11B7","\u110B\u1163\u11BC\u1105\u1167\u11A8","\u110B\u1163\u11BC\u1106\u1161\u11AF","\u110B\u1163\u11BC\u1107\u1162\u110E\u116E","\u110B\u1163\u11BC\u110C\u116E","\u110B\u1163\u11BC\u1111\u1161","\u110B\u1165\u1103\u116E\u11B7","\u110B\u1165\u1105\u1167\u110B\u116E\u11B7","\u110B\u1165\u1105\u1173\u11AB","\u110B\u1165\u110C\u1166\u11BA\u1107\u1161\u11B7","\u110B\u1165\u110D\u1162\u11BB\u1103\u1173\u11AB","\u110B\u1165\u110D\u1165\u1103\u1161\u1100\u1161","\u110B\u1165\u110D\u1165\u11AB\u110C\u1175","\u110B\u1165\u11AB\u1102\u1175","\u110B\u1165\u11AB\u1103\u1165\u11A8","\u110B\u1165\u11AB\u1105\u1169\u11AB","\u110B\u1165\u11AB\u110B\u1165","\u110B\u1165\u11AF\u1100\u116E\u11AF","\u110B\u1165\u11AF\u1105\u1173\u11AB","\u110B\u1165\u11AF\u110B\u1173\u11B7","\u110B\u1165\u11AF\u1111\u1175\u11BA","\u110B\u1165\u11B7\u1106\u1161","\u110B\u1165\u11B8\u1106\u116E","\u110B\u1165\u11B8\u110C\u1169\u11BC","\u110B\u1165\u11B8\u110E\u1166","\u110B\u1165\u11BC\u1103\u1165\u11BC\u110B\u1175","\u110B\u1165\u11BC\u1106\u1161\u11BC","\u110B\u1165\u11BC\u1110\u1165\u1105\u1175","\u110B\u1165\u11BD\u1100\u1173\u110C\u1166","\u110B\u1166\u1102\u1165\u110C\u1175","\u110B\u1166\u110B\u1165\u110F\u1165\u11AB","\u110B\u1166\u11AB\u110C\u1175\u11AB","\u110B\u1167\u1100\u1165\u11AB","\u110B\u1167\u1100\u1169\u1109\u1162\u11BC","\u110B\u1167\u1100\u116A\u11AB","\u110B\u1167\u1100\u116E\u11AB","\u110B\u1167\u1100\u116F\u11AB","\u110B\u1167\u1103\u1162\u1109\u1162\u11BC","\u110B\u1167\u1103\u1165\u11B2","\u110B\u1167\u1103\u1169\u11BC\u1109\u1162\u11BC","\u110B\u1167\u1103\u1173\u11AB","\u110B\u1167\u1105\u1169\u11AB","\u110B\u1167\u1105\u1173\u11B7","\u110B\u1167\u1109\u1165\u11BA","\u110B\u1167\u1109\u1165\u11BC","\u110B\u1167\u110B\u116A\u11BC","\u110B\u1167\u110B\u1175\u11AB","\u110B\u1167\u110C\u1165\u11AB\u1112\u1175","\u110B\u1167\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110B\u1167\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110B\u1167\u1112\u1162\u11BC","\u110B\u1167\u11A8\u1109\u1161","\u110B\u1167\u11A8\u1109\u1175","\u110B\u1167\u11A8\u1112\u1161\u11AF","\u110B\u1167\u11AB\u1100\u1167\u11AF","\u110B\u1167\u11AB\u1100\u116E","\u110B\u1167\u11AB\u1100\u1173\u11A8","\u110B\u1167\u11AB\u1100\u1175","\u110B\u1167\u11AB\u1105\u1161\u11A8","\u110B\u1167\u11AB\u1109\u1165\u11AF","\u110B\u1167\u11AB\u1109\u1166","\u110B\u1167\u11AB\u1109\u1169\u11A8","\u110B\u1167\u11AB\u1109\u1173\u11B8","\u110B\u1167\u11AB\u110B\u1162","\u110B\u1167\u11AB\u110B\u1168\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110B\u1175\u11AB","\u110B\u1167\u11AB\u110C\u1161\u11BC","\u110B\u1167\u11AB\u110C\u116E","\u110B\u1167\u11AB\u110E\u116E\u11AF","\u110B\u1167\u11AB\u1111\u1175\u11AF","\u110B\u1167\u11AB\u1112\u1161\u11B8","\u110B\u1167\u11AB\u1112\u1172","\u110B\u1167\u11AF\u1100\u1175","\u110B\u1167\u11AF\u1106\u1162","\u110B\u1167\u11AF\u1109\u116C","\u110B\u1167\u11AF\u1109\u1175\u11B7\u1112\u1175","\u110B\u1167\u11AF\u110C\u1165\u11BC","\u110B\u1167\u11AF\u110E\u1161","\u110B\u1167\u11AF\u1112\u1173\u11AF","\u110B\u1167\u11B7\u1105\u1167","\u110B\u1167\u11B8\u1109\u1165","\u110B\u1167\u11BC\u1100\u116E\u11A8","\u110B\u1167\u11BC\u1102\u1161\u11B7","\u110B\u1167\u11BC\u1109\u1161\u11BC","\u110B\u1167\u11BC\u110B\u1163\u11BC","\u110B\u1167\u11BC\u110B\u1167\u11A8","\u110B\u1167\u11BC\u110B\u116E\u11BC","\u110B\u1167\u11BC\u110B\u116F\u11AB\u1112\u1175","\u110B\u1167\u11BC\u1112\u1161","\u110B\u1167\u11BC\u1112\u1163\u11BC","\u110B\u1167\u11BC\u1112\u1169\u11AB","\u110B\u1167\u11BC\u1112\u116A","\u110B\u1167\u11C1\u1100\u116E\u1105\u1175","\u110B\u1167\u11C1\u1107\u1161\u11BC","\u110B\u1167\u11C1\u110C\u1175\u11B8","\u110B\u1168\u1100\u1161\u11B7","\u110B\u1168\u1100\u1173\u11B7","\u110B\u1168\u1107\u1161\u11BC","\u110B\u1168\u1109\u1161\u11AB","\u110B\u1168\u1109\u1161\u11BC","\u110B\u1168\u1109\u1165\u11AB","\u110B\u1168\u1109\u116E\u11AF","\u110B\u1168\u1109\u1173\u11B8","\u110B\u1168\u1109\u1175\u11A8\u110C\u1161\u11BC","\u110B\u1168\u110B\u1163\u11A8","\u110B\u1168\u110C\u1165\u11AB","\u110B\u1168\u110C\u1165\u11AF","\u110B\u1168\u110C\u1165\u11BC","\u110B\u1168\u110F\u1165\u11AB\u1103\u1162","\u110B\u1168\u11BA\u1102\u1161\u11AF","\u110B\u1169\u1102\u1173\u11AF","\u110B\u1169\u1105\u1161\u11A8","\u110B\u1169\u1105\u1162\u11BA\u1103\u1169\u11BC\u110B\u1161\u11AB","\u110B\u1169\u1105\u1166\u11AB\u110C\u1175","\u110B\u1169\u1105\u1169\u110C\u1175","\u110B\u1169\u1105\u1173\u11AB\u1107\u1161\u11AF","\u110B\u1169\u1107\u1173\u11AB","\u110B\u1169\u1109\u1175\u11B8","\u110B\u1169\u110B\u1167\u11B7","\u110B\u1169\u110B\u116F\u11AF","\u110B\u1169\u110C\u1165\u11AB","\u110B\u1169\u110C\u1175\u11A8","\u110B\u1169\u110C\u1175\u11BC\u110B\u1165","\u110B\u1169\u1111\u1166\u1105\u1161","\u110B\u1169\u1111\u1175\u1109\u1173\u1110\u1166\u11AF","\u110B\u1169\u1112\u1175\u1105\u1167","\u110B\u1169\u11A8\u1109\u1161\u11BC","\u110B\u1169\u11A8\u1109\u116E\u1109\u116E","\u110B\u1169\u11AB\u1100\u1161\u11BD","\u110B\u1169\u11AB\u1105\u1161\u110B\u1175\u11AB","\u110B\u1169\u11AB\u1106\u1169\u11B7","\u110B\u1169\u11AB\u110C\u1169\u11BC\u110B\u1175\u11AF","\u110B\u1169\u11AB\u1110\u1169\u11BC","\u110B\u1169\u11AF\u1100\u1161\u110B\u1173\u11AF","\u110B\u1169\u11AF\u1105\u1175\u11B7\u1111\u1175\u11A8","\u110B\u1169\u11AF\u1112\u1162","\u110B\u1169\u11BA\u110E\u1161\u1105\u1175\u11B7","\u110B\u116A\u110B\u1175\u1109\u1167\u110E\u1173","\u110B\u116A\u110B\u1175\u11AB","\u110B\u116A\u11AB\u1109\u1165\u11BC","\u110B\u116A\u11AB\u110C\u1165\u11AB","\u110B\u116A\u11BC\u1107\u1175","\u110B\u116A\u11BC\u110C\u1161","\u110B\u116B\u1102\u1163\u1112\u1161\u1106\u1167\u11AB","\u110B\u116B\u11AB\u110C\u1175","\u110B\u116C\u1100\u1161\u11BA\u110C\u1175\u11B8","\u110B\u116C\u1100\u116E\u11A8","\u110B\u116C\u1105\u1169\u110B\u116E\u11B7","\u110B\u116C\u1109\u1161\u11B7\u110E\u1169\u11AB","\u110B\u116C\u110E\u116E\u11AF","\u110B\u116C\u110E\u1175\u11B7","\u110B\u116C\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u110B\u116C\u11AB\u1107\u1161\u11AF","\u110B\u116C\u11AB\u1109\u1169\u11AB","\u110B\u116C\u11AB\u110D\u1169\u11A8","\u110B\u116D\u1100\u1173\u11B7","\u110B\u116D\u110B\u1175\u11AF","\u110B\u116D\u110C\u1173\u11B7","\u110B\u116D\u110E\u1165\u11BC","\u110B\u116D\u11BC\u1100\u1175","\u110B\u116D\u11BC\u1109\u1165","\u110B\u116D\u11BC\u110B\u1165","\u110B\u116E\u1109\u1161\u11AB","\u110B\u116E\u1109\u1165\u11AB","\u110B\u116E\u1109\u1173\u11BC","\u110B\u116E\u110B\u1167\u11AB\u1112\u1175","\u110B\u116E\u110C\u1165\u11BC","\u110B\u116E\u110E\u1166\u1100\u116E\u11A8","\u110B\u116E\u1111\u1167\u11AB","\u110B\u116E\u11AB\u1103\u1169\u11BC","\u110B\u116E\u11AB\u1106\u1167\u11BC","\u110B\u116E\u11AB\u1107\u1161\u11AB","\u110B\u116E\u11AB\u110C\u1165\u11AB","\u110B\u116E\u11AB\u1112\u1162\u11BC","\u110B\u116E\u11AF\u1109\u1161\u11AB","\u110B\u116E\u11AF\u110B\u1173\u11B7","\u110B\u116E\u11B7\u110C\u1175\u11A8\u110B\u1175\u11B7","\u110B\u116E\u11BA\u110B\u1165\u1105\u1173\u11AB","\u110B\u116E\u11BA\u110B\u1173\u11B7","\u110B\u116F\u1102\u1161\u11A8","\u110B\u116F\u11AB\u1100\u1169","\u110B\u116F\u11AB\u1105\u1162","\u110B\u116F\u11AB\u1109\u1165","\u110B\u116F\u11AB\u1109\u116E\u11BC\u110B\u1175","\u110B\u116F\u11AB\u110B\u1175\u11AB","\u110B\u116F\u11AB\u110C\u1161\u11BC","\u110B\u116F\u11AB\u1111\u1175\u1109\u1173","\u110B\u116F\u11AF\u1100\u1173\u11B8","\u110B\u116F\u11AF\u1103\u1173\u110F\u1165\u11B8","\u110B\u116F\u11AF\u1109\u1166","\u110B\u116F\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1170\u110B\u1175\u1110\u1165","\u110B\u1171\u1107\u1161\u11AB","\u110B\u1171\u1107\u1165\u11B8","\u110B\u1171\u1109\u1165\u11BC","\u110B\u1171\u110B\u116F\u11AB","\u110B\u1171\u1112\u1165\u11B7","\u110B\u1171\u1112\u1167\u11B8","\u110B\u1171\u11BA\u1109\u1161\u1105\u1161\u11B7","\u110B\u1172\u1102\u1161\u11AB\u1112\u1175","\u110B\u1172\u1105\u1165\u11B8","\u110B\u1172\u1106\u1167\u11BC","\u110B\u1172\u1106\u116E\u11AF","\u110B\u1172\u1109\u1161\u11AB","\u110B\u1172\u110C\u1165\u11A8","\u110B\u1172\u110E\u1175\u110B\u116F\u11AB","\u110B\u1172\u1112\u1161\u11A8","\u110B\u1172\u1112\u1162\u11BC","\u110B\u1172\u1112\u1167\u11BC","\u110B\u1172\u11A8\u1100\u116E\u11AB","\u110B\u1172\u11A8\u1109\u1161\u11BC","\u110B\u1172\u11A8\u1109\u1175\u11B8","\u110B\u1172\u11A8\u110E\u1166","\u110B\u1173\u11AB\u1112\u1162\u11BC","\u110B\u1173\u11B7\u1105\u1167\u11A8","\u110B\u1173\u11B7\u1105\u116D","\u110B\u1173\u11B7\u1107\u1161\u11AB","\u110B\u1173\u11B7\u1109\u1165\u11BC","\u110B\u1173\u11B7\u1109\u1175\u11A8","\u110B\u1173\u11B7\u110B\u1161\u11A8","\u110B\u1173\u11B7\u110C\u116E","\u110B\u1174\u1100\u1167\u11AB","\u110B\u1174\u1102\u1169\u11AB","\u110B\u1174\u1106\u116E\u11AB","\u110B\u1174\u1107\u1169\u11A8","\u110B\u1174\u1109\u1175\u11A8","\u110B\u1174\u1109\u1175\u11B7","\u110B\u1174\u110B\u116C\u1105\u1169","\u110B\u1174\u110B\u116D\u11A8","\u110B\u1174\u110B\u116F\u11AB","\u110B\u1174\u1112\u1161\u11A8","\u110B\u1175\u1100\u1165\u11BA","\u110B\u1175\u1100\u1169\u11BA","\u110B\u1175\u1102\u1167\u11B7","\u110B\u1175\u1102\u1169\u11B7","\u110B\u1175\u1103\u1161\u11AF","\u110B\u1175\u1103\u1162\u1105\u1169","\u110B\u1175\u1103\u1169\u11BC","\u110B\u1175\u1105\u1165\u11C2\u1100\u1166","\u110B\u1175\u1105\u1167\u11A8\u1109\u1165","\u110B\u1175\u1105\u1169\u11AB\u110C\u1165\u11A8","\u110B\u1175\u1105\u1173\u11B7","\u110B\u1175\u1106\u1175\u11AB","\u110B\u1175\u1107\u1161\u11AF\u1109\u1169","\u110B\u1175\u1107\u1167\u11AF","\u110B\u1175\u1107\u116E\u11AF","\u110B\u1175\u1108\u1161\u11AF","\u110B\u1175\u1109\u1161\u11BC","\u110B\u1175\u1109\u1165\u11BC","\u110B\u1175\u1109\u1173\u11AF","\u110B\u1175\u110B\u1163\u1100\u1175","\u110B\u1175\u110B\u116D\u11BC","\u110B\u1175\u110B\u116E\u11BA","\u110B\u1175\u110B\u116F\u11AF","\u110B\u1175\u110B\u1173\u11A8\u1100\u1169","\u110B\u1175\u110B\u1175\u11A8","\u110B\u1175\u110C\u1165\u11AB","\u110B\u1175\u110C\u116E\u11BC","\u110B\u1175\u1110\u1173\u11AE\u1102\u1161\u11AF","\u110B\u1175\u1110\u1173\u11AF","\u110B\u1175\u1112\u1169\u11AB","\u110B\u1175\u11AB\u1100\u1161\u11AB","\u110B\u1175\u11AB\u1100\u1167\u11A8","\u110B\u1175\u11AB\u1100\u1169\u11BC","\u110B\u1175\u11AB\u1100\u116E","\u110B\u1175\u11AB\u1100\u1173\u11AB","\u110B\u1175\u11AB\u1100\u1175","\u110B\u1175\u11AB\u1103\u1169","\u110B\u1175\u11AB\u1105\u1172","\u110B\u1175\u11AB\u1106\u116E\u11AF","\u110B\u1175\u11AB\u1109\u1162\u11BC","\u110B\u1175\u11AB\u1109\u116B","\u110B\u1175\u11AB\u110B\u1167\u11AB","\u110B\u1175\u11AB\u110B\u116F\u11AB","\u110B\u1175\u11AB\u110C\u1162","\u110B\u1175\u11AB\u110C\u1169\u11BC","\u110B\u1175\u11AB\u110E\u1165\u11AB","\u110B\u1175\u11AB\u110E\u1166","\u110B\u1175\u11AB\u1110\u1165\u1102\u1166\u11BA","\u110B\u1175\u11AB\u1112\u1161","\u110B\u1175\u11AB\u1112\u1167\u11BC","\u110B\u1175\u11AF\u1100\u1169\u11B8","\u110B\u1175\u11AF\u1100\u1175","\u110B\u1175\u11AF\u1103\u1161\u11AB","\u110B\u1175\u11AF\u1103\u1162","\u110B\u1175\u11AF\u1103\u1173\u11BC","\u110B\u1175\u11AF\u1107\u1161\u11AB","\u110B\u1175\u11AF\u1107\u1169\u11AB","\u110B\u1175\u11AF\u1107\u116E","\u110B\u1175\u11AF\u1109\u1161\u11BC","\u110B\u1175\u11AF\u1109\u1162\u11BC","\u110B\u1175\u11AF\u1109\u1169\u11AB","\u110B\u1175\u11AF\u110B\u116D\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110B\u116F\u11AF","\u110B\u1175\u11AF\u110C\u1165\u11BC","\u110B\u1175\u11AF\u110C\u1169\u11BC","\u110B\u1175\u11AF\u110C\u116E\u110B\u1175\u11AF","\u110B\u1175\u11AF\u110D\u1175\u11A8","\u110B\u1175\u11AF\u110E\u1166","\u110B\u1175\u11AF\u110E\u1175","\u110B\u1175\u11AF\u1112\u1162\u11BC","\u110B\u1175\u11AF\u1112\u116C\u110B\u116D\u11BC","\u110B\u1175\u11B7\u1100\u1173\u11B7","\u110B\u1175\u11B7\u1106\u116E","\u110B\u1175\u11B8\u1103\u1162","\u110B\u1175\u11B8\u1105\u1167\u11A8","\u110B\u1175\u11B8\u1106\u1161\u11BA","\u110B\u1175\u11B8\u1109\u1161","\u110B\u1175\u11B8\u1109\u116E\u11AF","\u110B\u1175\u11B8\u1109\u1175","\u110B\u1175\u11B8\u110B\u116F\u11AB","\u110B\u1175\u11B8\u110C\u1161\u11BC","\u110B\u1175\u11B8\u1112\u1161\u11A8","\u110C\u1161\u1100\u1161\u110B\u116D\u11BC","\u110C\u1161\u1100\u1167\u11A8","\u110C\u1161\u1100\u1173\u11A8","\u110C\u1161\u1103\u1169\u11BC","\u110C\u1161\u1105\u1161\u11BC","\u110C\u1161\u1107\u116E\u1109\u1175\u11B7","\u110C\u1161\u1109\u1175\u11A8","\u110C\u1161\u1109\u1175\u11AB","\u110C\u1161\u110B\u1167\u11AB","\u110C\u1161\u110B\u116F\u11AB","\u110C\u1161\u110B\u1172\u11AF","\u110C\u1161\u110C\u1165\u11AB\u1100\u1165","\u110C\u1161\u110C\u1165\u11BC","\u110C\u1161\u110C\u1169\u11AB\u1109\u1175\u11B7","\u110C\u1161\u1111\u1161\u11AB","\u110C\u1161\u11A8\u1100\u1161","\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1161\u11A8\u1109\u1165\u11BC","\u110C\u1161\u11A8\u110B\u1165\u11B8","\u110C\u1161\u11A8\u110B\u116D\u11BC","\u110C\u1161\u11A8\u110B\u1173\u11AB\u1104\u1161\u11AF","\u110C\u1161\u11A8\u1111\u116E\u11B7","\u110C\u1161\u11AB\u1103\u1175","\u110C\u1161\u11AB\u1104\u1173\u11A8","\u110C\u1161\u11AB\u110E\u1175","\u110C\u1161\u11AF\u1106\u1169\u11BA","\u110C\u1161\u11B7\u1101\u1161\u11AB","\u110C\u1161\u11B7\u1109\u116E\u1112\u1161\u11B7","\u110C\u1161\u11B7\u1109\u1175","\u110C\u1161\u11B7\u110B\u1169\u11BA","\u110C\u1161\u11B7\u110C\u1161\u1105\u1175","\u110C\u1161\u11B8\u110C\u1175","\u110C\u1161\u11BC\u1100\u116A\u11AB","\u110C\u1161\u11BC\u1100\u116E\u11AB","\u110C\u1161\u11BC\u1100\u1175\u1100\u1161\u11AB","\u110C\u1161\u11BC\u1105\u1162","\u110C\u1161\u11BC\u1105\u1168","\u110C\u1161\u11BC\u1105\u1173","\u110C\u1161\u11BC\u1106\u1161","\u110C\u1161\u11BC\u1106\u1167\u11AB","\u110C\u1161\u11BC\u1106\u1169","\u110C\u1161\u11BC\u1106\u1175","\u110C\u1161\u11BC\u1107\u1175","\u110C\u1161\u11BC\u1109\u1161","\u110C\u1161\u11BC\u1109\u1169","\u110C\u1161\u11BC\u1109\u1175\u11A8","\u110C\u1161\u11BC\u110B\u1162\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110B\u1175\u11AB","\u110C\u1161\u11BC\u110C\u1165\u11B7","\u110C\u1161\u11BC\u110E\u1161","\u110C\u1161\u11BC\u1112\u1161\u11A8\u1100\u1173\u11B7","\u110C\u1162\u1102\u1173\u11BC","\u110C\u1162\u1108\u1161\u11AF\u1105\u1175","\u110C\u1162\u1109\u1161\u11AB","\u110C\u1162\u1109\u1162\u11BC","\u110C\u1162\u110C\u1161\u11A8\u1102\u1167\u11AB","\u110C\u1162\u110C\u1165\u11BC","\u110C\u1162\u110E\u1162\u1100\u1175","\u110C\u1162\u1111\u1161\u11AB","\u110C\u1162\u1112\u1161\u11A8","\u110C\u1162\u1112\u116A\u11AF\u110B\u116D\u11BC","\u110C\u1165\u1100\u1165\u11BA","\u110C\u1165\u1100\u1169\u1105\u1175","\u110C\u1165\u1100\u1169\u11BA","\u110C\u1165\u1102\u1167\u11A8","\u110C\u1165\u1105\u1165\u11AB","\u110C\u1165\u1105\u1165\u11C2\u1100\u1166","\u110C\u1165\u1107\u1165\u11AB","\u110C\u1165\u110B\u116E\u11AF","\u110C\u1165\u110C\u1165\u11AF\u1105\u1169","\u110C\u1165\u110E\u116E\u11A8","\u110C\u1165\u11A8\u1100\u1173\u11A8","\u110C\u1165\u11A8\u1103\u1161\u11BC\u1112\u1175","\u110C\u1165\u11A8\u1109\u1165\u11BC","\u110C\u1165\u11A8\u110B\u116D\u11BC","\u110C\u1165\u11A8\u110B\u1173\u11BC","\u110C\u1165\u11AB\u1100\u1162","\u110C\u1165\u11AB\u1100\u1169\u11BC","\u110C\u1165\u11AB\u1100\u1175","\u110C\u1165\u11AB\u1103\u1161\u11AF","\u110C\u1165\u11AB\u1105\u1161\u1103\u1169","\u110C\u1165\u11AB\u1106\u1161\u11BC","\u110C\u1165\u11AB\u1106\u116E\u11AB","\u110C\u1165\u11AB\u1107\u1161\u11AB","\u110C\u1165\u11AB\u1107\u116E","\u110C\u1165\u11AB\u1109\u1166","\u110C\u1165\u11AB\u1109\u1175","\u110C\u1165\u11AB\u110B\u116D\u11BC","\u110C\u1165\u11AB\u110C\u1161","\u110C\u1165\u11AB\u110C\u1162\u11BC","\u110C\u1165\u11AB\u110C\u116E","\u110C\u1165\u11AB\u110E\u1165\u11AF","\u110C\u1165\u11AB\u110E\u1166","\u110C\u1165\u11AB\u1110\u1169\u11BC","\u110C\u1165\u11AB\u1112\u1167","\u110C\u1165\u11AB\u1112\u116E","\u110C\u1165\u11AF\u1103\u1162","\u110C\u1165\u11AF\u1106\u1161\u11BC","\u110C\u1165\u11AF\u1107\u1161\u11AB","\u110C\u1165\u11AF\u110B\u1163\u11A8","\u110C\u1165\u11AF\u110E\u1161","\u110C\u1165\u11B7\u1100\u1165\u11B7","\u110C\u1165\u11B7\u1109\u116E","\u110C\u1165\u11B7\u1109\u1175\u11B7","\u110C\u1165\u11B7\u110B\u116F\u11AB","\u110C\u1165\u11B7\u110C\u1165\u11B7","\u110C\u1165\u11B7\u110E\u1161","\u110C\u1165\u11B8\u1100\u1173\u11AB","\u110C\u1165\u11B8\u1109\u1175","\u110C\u1165\u11B8\u110E\u1169\u11A8","\u110C\u1165\u11BA\u1100\u1161\u1105\u1161\u11A8","\u110C\u1165\u11BC\u1100\u1165\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1103\u1169","\u110C\u1165\u11BC\u1105\u1172\u110C\u1161\u11BC","\u110C\u1165\u11BC\u1105\u1175","\u110C\u1165\u11BC\u1106\u1161\u11AF","\u110C\u1165\u11BC\u1106\u1167\u11AB","\u110C\u1165\u11BC\u1106\u116E\u11AB","\u110C\u1165\u11BC\u1107\u1161\u11AB\u1103\u1162","\u110C\u1165\u11BC\u1107\u1169","\u110C\u1165\u11BC\u1107\u116E","\u110C\u1165\u11BC\u1107\u1175","\u110C\u1165\u11BC\u1109\u1161\u11BC","\u110C\u1165\u11BC\u1109\u1165\u11BC","\u110C\u1165\u11BC\u110B\u1169","\u110C\u1165\u11BC\u110B\u116F\u11AB","\u110C\u1165\u11BC\u110C\u1161\u11BC","\u110C\u1165\u11BC\u110C\u1175","\u110C\u1165\u11BC\u110E\u1175","\u110C\u1165\u11BC\u1112\u116A\u11A8\u1112\u1175","\u110C\u1166\u1100\u1169\u11BC","\u110C\u1166\u1100\u116A\u110C\u1165\u11B7","\u110C\u1166\u1103\u1162\u1105\u1169","\u110C\u1166\u1106\u1169\u11A8","\u110C\u1166\u1107\u1161\u11AF","\u110C\u1166\u1107\u1165\u11B8","\u110C\u1166\u1109\u1161\u11BA\u1102\u1161\u11AF","\u110C\u1166\u110B\u1161\u11AB","\u110C\u1166\u110B\u1175\u11AF","\u110C\u1166\u110C\u1161\u11A8","\u110C\u1166\u110C\u116E\u1103\u1169","\u110C\u1166\u110E\u116E\u11AF","\u110C\u1166\u1111\u116E\u11B7","\u110C\u1166\u1112\u1161\u11AB","\u110C\u1169\u1100\u1161\u11A8","\u110C\u1169\u1100\u1165\u11AB","\u110C\u1169\u1100\u1173\u11B7","\u110C\u1169\u1100\u1175\u11BC","\u110C\u1169\u1106\u1167\u11BC","\u110C\u1169\u1106\u1175\u1105\u116D","\u110C\u1169\u1109\u1161\u11BC","\u110C\u1169\u1109\u1165\u11AB","\u110C\u1169\u110B\u116D\u11BC\u1112\u1175","\u110C\u1169\u110C\u1165\u11AF","\u110C\u1169\u110C\u1165\u11BC","\u110C\u1169\u110C\u1175\u11A8","\u110C\u1169\u11AB\u1103\u1162\u11BA\u1106\u1161\u11AF","\u110C\u1169\u11AB\u110C\u1162","\u110C\u1169\u11AF\u110B\u1165\u11B8","\u110C\u1169\u11AF\u110B\u1173\u11B7","\u110C\u1169\u11BC\u1100\u116D","\u110C\u1169\u11BC\u1105\u1169","\u110C\u1169\u11BC\u1105\u1172","\u110C\u1169\u11BC\u1109\u1169\u1105\u1175","\u110C\u1169\u11BC\u110B\u1165\u11B8\u110B\u116F\u11AB","\u110C\u1169\u11BC\u110C\u1169\u11BC","\u110C\u1169\u11BC\u1112\u1161\u11B8","\u110C\u116A\u1109\u1165\u11A8","\u110C\u116C\u110B\u1175\u11AB","\u110C\u116E\u1100\u116A\u11AB\u110C\u1165\u11A8","\u110C\u116E\u1105\u1173\u11B7","\u110C\u116E\u1106\u1161\u11AF","\u110C\u116E\u1106\u1165\u1102\u1175","\u110C\u116E\u1106\u1165\u11A8","\u110C\u116E\u1106\u116E\u11AB","\u110C\u116E\u1106\u1175\u11AB","\u110C\u116E\u1107\u1161\u11BC","\u110C\u116E\u1107\u1167\u11AB","\u110C\u116E\u1109\u1175\u11A8","\u110C\u116E\u110B\u1175\u11AB","\u110C\u116E\u110B\u1175\u11AF","\u110C\u116E\u110C\u1161\u11BC","\u110C\u116E\u110C\u1165\u11AB\u110C\u1161","\u110C\u116E\u1110\u1162\u11A8","\u110C\u116E\u11AB\u1107\u1175","\u110C\u116E\u11AF\u1100\u1165\u1105\u1175","\u110C\u116E\u11AF\u1100\u1175","\u110C\u116E\u11AF\u1106\u116E\u1102\u1174","\u110C\u116E\u11BC\u1100\u1161\u11AB","\u110C\u116E\u11BC\u1100\u1168\u1107\u1161\u11BC\u1109\u1169\u11BC","\u110C\u116E\u11BC\u1100\u116E\u11A8","\u110C\u116E\u11BC\u1102\u1167\u11AB","\u110C\u116E\u11BC\u1103\u1161\u11AB","\u110C\u116E\u11BC\u1103\u1169\u11A8","\u110C\u116E\u11BC\u1107\u1161\u11AB","\u110C\u116E\u11BC\u1107\u116E","\u110C\u116E\u11BC\u1109\u1166","\u110C\u116E\u11BC\u1109\u1169\u1100\u1175\u110B\u1165\u11B8","\u110C\u116E\u11BC\u1109\u116E\u11AB","\u110C\u116E\u11BC\u110B\u1161\u11BC","\u110C\u116E\u11BC\u110B\u116D","\u110C\u116E\u11BC\u1112\u1161\u11A8\u1100\u116D","\u110C\u1173\u11A8\u1109\u1165\u11A8","\u110C\u1173\u11A8\u1109\u1175","\u110C\u1173\u11AF\u1100\u1165\u110B\u116E\u11B7","\u110C\u1173\u11BC\u1100\u1161","\u110C\u1173\u11BC\u1100\u1165","\u110C\u1173\u11BC\u1100\u116F\u11AB","\u110C\u1173\u11BC\u1109\u1161\u11BC","\u110C\u1173\u11BC\u1109\u1166","\u110C\u1175\u1100\u1161\u11A8","\u110C\u1175\u1100\u1161\u11B8","\u110C\u1175\u1100\u1167\u11BC","\u110C\u1175\u1100\u1173\u11A8\u1112\u1175","\u110C\u1175\u1100\u1173\u11B7","\u110C\u1175\u1100\u1173\u11B8","\u110C\u1175\u1102\u1173\u11BC","\u110C\u1175\u1105\u1173\u11B7\u1100\u1175\u11AF","\u110C\u1175\u1105\u1175\u1109\u1161\u11AB","\u110C\u1175\u1107\u1161\u11BC","\u110C\u1175\u1107\u116E\u11BC","\u110C\u1175\u1109\u1175\u11A8","\u110C\u1175\u110B\u1167\u11A8","\u110C\u1175\u110B\u116E\u1100\u1162","\u110C\u1175\u110B\u116F\u11AB","\u110C\u1175\u110C\u1165\u11A8","\u110C\u1175\u110C\u1165\u11B7","\u110C\u1175\u110C\u1175\u11AB","\u110C\u1175\u110E\u116E\u11AF","\u110C\u1175\u11A8\u1109\u1165\u11AB","\u110C\u1175\u11A8\u110B\u1165\u11B8","\u110C\u1175\u11A8\u110B\u116F\u11AB","\u110C\u1175\u11A8\u110C\u1161\u11BC","\u110C\u1175\u11AB\u1100\u1173\u11B8","\u110C\u1175\u11AB\u1103\u1169\u11BC","\u110C\u1175\u11AB\u1105\u1169","\u110C\u1175\u11AB\u1105\u116D","\u110C\u1175\u11AB\u1105\u1175","\u110C\u1175\u11AB\u110D\u1161","\u110C\u1175\u11AB\u110E\u1161\u11AF","\u110C\u1175\u11AB\u110E\u116E\u11AF","\u110C\u1175\u11AB\u1110\u1169\u11BC","\u110C\u1175\u11AB\u1112\u1162\u11BC","\u110C\u1175\u11AF\u1106\u116E\u11AB","\u110C\u1175\u11AF\u1107\u1167\u11BC","\u110C\u1175\u11AF\u1109\u1165","\u110C\u1175\u11B7\u110C\u1161\u11A8","\u110C\u1175\u11B8\u1103\u1161\u11AB","\u110C\u1175\u11B8\u110B\u1161\u11AB","\u110C\u1175\u11B8\u110C\u116E\u11BC","\u110D\u1161\u110C\u1173\u11BC","\u110D\u1175\u1101\u1165\u1100\u1175","\u110E\u1161\u1102\u1161\u11B7","\u110E\u1161\u1105\u1161\u1105\u1175","\u110E\u1161\u1105\u1163\u11BC","\u110E\u1161\u1105\u1175\u11B7","\u110E\u1161\u1107\u1167\u11AF","\u110E\u1161\u1109\u1165\u11AB","\u110E\u1161\u110E\u1173\u11B7","\u110E\u1161\u11A8\u1100\u1161\u11A8","\u110E\u1161\u11AB\u1106\u116E\u11AF","\u110E\u1161\u11AB\u1109\u1165\u11BC","\u110E\u1161\u11B7\u1100\u1161","\u110E\u1161\u11B7\u1100\u1175\u1105\u1173\u11B7","\u110E\u1161\u11B7\u1109\u1162","\u110E\u1161\u11B7\u1109\u1165\u11A8","\u110E\u1161\u11B7\u110B\u1167","\u110E\u1161\u11B7\u110B\u116C","\u110E\u1161\u11B7\u110C\u1169","\u110E\u1161\u11BA\u110C\u1161\u11AB","\u110E\u1161\u11BC\u1100\u1161","\u110E\u1161\u11BC\u1100\u1169","\u110E\u1161\u11BC\u1100\u116E","\u110E\u1161\u11BC\u1106\u116E\u11AB","\u110E\u1161\u11BC\u1107\u1161\u11A9","\u110E\u1161\u11BC\u110C\u1161\u11A8","\u110E\u1161\u11BC\u110C\u1169","\u110E\u1162\u1102\u1165\u11AF","\u110E\u1162\u110C\u1165\u11B7","\u110E\u1162\u11A8\u1100\u1161\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1107\u1161\u11BC","\u110E\u1162\u11A8\u1109\u1161\u11BC","\u110E\u1162\u11A8\u110B\u1175\u11B7","\u110E\u1162\u11B7\u1111\u1175\u110B\u1165\u11AB","\u110E\u1165\u1107\u1165\u11AF","\u110E\u1165\u110B\u1173\u11B7","\u110E\u1165\u11AB\u1100\u116E\u11A8","\u110E\u1165\u11AB\u1103\u116E\u11BC","\u110E\u1165\u11AB\u110C\u1161\u11BC","\u110E\u1165\u11AB\u110C\u1162","\u110E\u1165\u11AB\u110E\u1165\u11AB\u1112\u1175","\u110E\u1165\u11AF\u1103\u1169","\u110E\u1165\u11AF\u110C\u1165\u1112\u1175","\u110E\u1165\u11AF\u1112\u1161\u11A8","\u110E\u1165\u11BA\u1102\u1161\u11AF","\u110E\u1165\u11BA\u110D\u1162","\u110E\u1165\u11BC\u1102\u1167\u11AB","\u110E\u1165\u11BC\u1107\u1161\u110C\u1175","\u110E\u1165\u11BC\u1109\u1169","\u110E\u1165\u11BC\u110E\u116E\u11AB","\u110E\u1166\u1100\u1168","\u110E\u1166\u1105\u1167\u11A8","\u110E\u1166\u110B\u1169\u11AB","\u110E\u1166\u110B\u1172\u11A8","\u110E\u1166\u110C\u116E\u11BC","\u110E\u1166\u1112\u1165\u11B7","\u110E\u1169\u1103\u1173\u11BC\u1112\u1161\u11A8\u1109\u1162\u11BC","\u110E\u1169\u1107\u1161\u11AB","\u110E\u1169\u1107\u1161\u11B8","\u110E\u1169\u1109\u1161\u11BC\u1112\u116A","\u110E\u1169\u1109\u116E\u11AB","\u110E\u1169\u110B\u1167\u1105\u1173\u11B7","\u110E\u1169\u110B\u116F\u11AB","\u110E\u1169\u110C\u1165\u1102\u1167\u11A8","\u110E\u1169\u110C\u1165\u11B7","\u110E\u1169\u110E\u1165\u11BC","\u110E\u1169\u110F\u1169\u11AF\u1105\u1175\u11BA","\u110E\u1169\u11BA\u1107\u116E\u11AF","\u110E\u1169\u11BC\u1100\u1161\u11A8","\u110E\u1169\u11BC\u1105\u1175","\u110E\u1169\u11BC\u110C\u1161\u11BC","\u110E\u116A\u11AF\u110B\u1167\u11BC","\u110E\u116C\u1100\u1173\u11AB","\u110E\u116C\u1109\u1161\u11BC","\u110E\u116C\u1109\u1165\u11AB","\u110E\u116C\u1109\u1175\u11AB","\u110E\u116C\u110B\u1161\u11A8","\u110E\u116C\u110C\u1169\u11BC","\u110E\u116E\u1109\u1165\u11A8","\u110E\u116E\u110B\u1165\u11A8","\u110E\u116E\u110C\u1175\u11AB","\u110E\u116E\u110E\u1165\u11AB","\u110E\u116E\u110E\u1173\u11A8","\u110E\u116E\u11A8\u1100\u116E","\u110E\u116E\u11A8\u1109\u1169","\u110E\u116E\u11A8\u110C\u1166","\u110E\u116E\u11A8\u1112\u1161","\u110E\u116E\u11AF\u1100\u1173\u11AB","\u110E\u116E\u11AF\u1107\u1161\u11AF","\u110E\u116E\u11AF\u1109\u1161\u11AB","\u110E\u116E\u11AF\u1109\u1175\u11AB","\u110E\u116E\u11AF\u110B\u1167\u11AB","\u110E\u116E\u11AF\u110B\u1175\u11B8","\u110E\u116E\u11AF\u110C\u1161\u11BC","\u110E\u116E\u11AF\u1111\u1161\u11AB","\u110E\u116E\u11BC\u1100\u1167\u11A8","\u110E\u116E\u11BC\u1100\u1169","\u110E\u116E\u11BC\u1103\u1169\u11AF","\u110E\u116E\u11BC\u1107\u116E\u11AB\u1112\u1175","\u110E\u116E\u11BC\u110E\u1165\u11BC\u1103\u1169","\u110E\u1171\u110B\u1165\u11B8","\u110E\u1171\u110C\u1175\u11A8","\u110E\u1171\u1112\u1163\u11BC","\u110E\u1175\u110B\u1163\u11A8","\u110E\u1175\u11AB\u1100\u116E","\u110E\u1175\u11AB\u110E\u1165\u11A8","\u110E\u1175\u11AF\u1109\u1175\u11B8","\u110E\u1175\u11AF\u110B\u116F\u11AF","\u110E\u1175\u11AF\u1111\u1161\u11AB","\u110E\u1175\u11B7\u1103\u1162","\u110E\u1175\u11B7\u1106\u116E\u11A8","\u110E\u1175\u11B7\u1109\u1175\u11AF","\u110E\u1175\u11BA\u1109\u1169\u11AF","\u110E\u1175\u11BC\u110E\u1161\u11AB","\u110F\u1161\u1106\u1166\u1105\u1161","\u110F\u1161\u110B\u116E\u11AB\u1110\u1165","\u110F\u1161\u11AF\u1100\u116E\u11A8\u1109\u116E","\u110F\u1162\u1105\u1175\u11A8\u1110\u1165","\u110F\u1162\u11B7\u1111\u1165\u1109\u1173","\u110F\u1162\u11B7\u1111\u1166\u110B\u1175\u11AB","\u110F\u1165\u1110\u1173\u11AB","\u110F\u1165\u11AB\u1103\u1175\u1109\u1167\u11AB","\u110F\u1165\u11AF\u1105\u1165","\u110F\u1165\u11B7\u1111\u1172\u1110\u1165","\u110F\u1169\u1101\u1175\u1105\u1175","\u110F\u1169\u1106\u1175\u1103\u1175","\u110F\u1169\u11AB\u1109\u1165\u1110\u1173","\u110F\u1169\u11AF\u1105\u1161","\u110F\u1169\u11B7\u1111\u1173\u11AF\u1105\u1166\u11A8\u1109\u1173","\u110F\u1169\u11BC\u1102\u1161\u1106\u116E\u11AF","\u110F\u116B\u1100\u1161\u11B7","\u110F\u116E\u1103\u1166\u1110\u1161","\u110F\u1173\u1105\u1175\u11B7","\u110F\u1173\u11AB\u1100\u1175\u11AF","\u110F\u1173\u11AB\u1104\u1161\u11AF","\u110F\u1173\u11AB\u1109\u1169\u1105\u1175","\u110F\u1173\u11AB\u110B\u1161\u1103\u1173\u11AF","\u110F\u1173\u11AB\u110B\u1165\u1106\u1165\u1102\u1175","\u110F\u1173\u11AB\u110B\u1175\u11AF","\u110F\u1173\u11AB\u110C\u1165\u11AF","\u110F\u1173\u11AF\u1105\u1162\u1109\u1175\u11A8","\u110F\u1173\u11AF\u1105\u1165\u11B8","\u110F\u1175\u11AF\u1105\u1169","\u1110\u1161\u110B\u1175\u11B8","\u1110\u1161\u110C\u1161\u1100\u1175","\u1110\u1161\u11A8\u1100\u116E","\u1110\u1161\u11A8\u110C\u1161","\u1110\u1161\u11AB\u1109\u1162\u11BC","\u1110\u1162\u1100\u116F\u11AB\u1103\u1169","\u1110\u1162\u110B\u1163\u11BC","\u1110\u1162\u1111\u116E\u11BC","\u1110\u1162\u11A8\u1109\u1175","\u1110\u1162\u11AF\u1105\u1165\u11AB\u1110\u1173","\u1110\u1165\u1102\u1165\u11AF","\u1110\u1165\u1106\u1175\u1102\u1165\u11AF","\u1110\u1166\u1102\u1175\u1109\u1173","\u1110\u1166\u1109\u1173\u1110\u1173","\u1110\u1166\u110B\u1175\u1107\u1173\u11AF","\u1110\u1166\u11AF\u1105\u1166\u1107\u1175\u110C\u1165\u11AB","\u1110\u1169\u1105\u1169\u11AB","\u1110\u1169\u1106\u1161\u1110\u1169","\u1110\u1169\u110B\u116D\u110B\u1175\u11AF","\u1110\u1169\u11BC\u1100\u1168","\u1110\u1169\u11BC\u1100\u116A","\u1110\u1169\u11BC\u1105\u1169","\u1110\u1169\u11BC\u1109\u1175\u11AB","\u1110\u1169\u11BC\u110B\u1167\u11A8","\u1110\u1169\u11BC\u110B\u1175\u11AF","\u1110\u1169\u11BC\u110C\u1161\u11BC","\u1110\u1169\u11BC\u110C\u1166","\u1110\u1169\u11BC\u110C\u1173\u11BC","\u1110\u1169\u11BC\u1112\u1161\u11B8","\u1110\u1169\u11BC\u1112\u116A","\u1110\u116C\u1100\u1173\u11AB","\u1110\u116C\u110B\u116F\u11AB","\u1110\u116C\u110C\u1175\u11A8\u1100\u1173\u11B7","\u1110\u1171\u1100\u1175\u11B7","\u1110\u1173\u1105\u1165\u11A8","\u1110\u1173\u11A8\u1100\u1173\u11B8","\u1110\u1173\u11A8\u1107\u1167\u11AF","\u1110\u1173\u11A8\u1109\u1165\u11BC","\u1110\u1173\u11A8\u1109\u116E","\u1110\u1173\u11A8\u110C\u1175\u11BC","\u1110\u1173\u11A8\u1112\u1175","\u1110\u1173\u11AB\u1110\u1173\u11AB\u1112\u1175","\u1110\u1175\u1109\u1167\u110E\u1173","\u1111\u1161\u1105\u1161\u11AB\u1109\u1162\u11A8","\u1111\u1161\u110B\u1175\u11AF","\u1111\u1161\u110E\u116E\u11AF\u1109\u1169","\u1111\u1161\u11AB\u1100\u1167\u11AF","\u1111\u1161\u11AB\u1103\u1161\u11AB","\u1111\u1161\u11AB\u1106\u1162","\u1111\u1161\u11AB\u1109\u1161","\u1111\u1161\u11AF\u1109\u1175\u11B8","\u1111\u1161\u11AF\u110B\u116F\u11AF","\u1111\u1161\u11B8\u1109\u1169\u11BC","\u1111\u1162\u1109\u1167\u11AB","\u1111\u1162\u11A8\u1109\u1173","\u1111\u1162\u11A8\u1109\u1175\u1106\u1175\u11AF\u1105\u1175","\u1111\u1162\u11AB\u1110\u1175","\u1111\u1165\u1109\u1166\u11AB\u1110\u1173","\u1111\u1166\u110B\u1175\u11AB\u1110\u1173","\u1111\u1167\u11AB\u1100\u1167\u11AB","\u1111\u1167\u11AB\u110B\u1174","\u1111\u1167\u11AB\u110C\u1175","\u1111\u1167\u11AB\u1112\u1175","\u1111\u1167\u11BC\u1100\u1161","\u1111\u1167\u11BC\u1100\u1172\u11AB","\u1111\u1167\u11BC\u1109\u1162\u11BC","\u1111\u1167\u11BC\u1109\u1169","\u1111\u1167\u11BC\u110B\u1163\u11BC","\u1111\u1167\u11BC\u110B\u1175\u11AF","\u1111\u1167\u11BC\u1112\u116A","\u1111\u1169\u1109\u1173\u1110\u1165","\u1111\u1169\u110B\u1175\u11AB\u1110\u1173","\u1111\u1169\u110C\u1161\u11BC","\u1111\u1169\u1112\u1161\u11B7","\u1111\u116D\u1106\u1167\u11AB","\u1111\u116D\u110C\u1165\u11BC","\u1111\u116D\u110C\u116E\u11AB","\u1111\u116D\u1112\u1167\u11AB","\u1111\u116E\u11B7\u1106\u1169\u11A8","\u1111\u116E\u11B7\u110C\u1175\u11AF","\u1111\u116E\u11BC\u1100\u1167\u11BC","\u1111\u116E\u11BC\u1109\u1169\u11A8","\u1111\u116E\u11BC\u1109\u1173\u11B8","\u1111\u1173\u1105\u1161\u11BC\u1109\u1173","\u1111\u1173\u1105\u1175\u11AB\u1110\u1165","\u1111\u1173\u11AF\u1105\u1161\u1109\u1173\u1110\u1175\u11A8","\u1111\u1175\u1100\u1169\u11AB","\u1111\u1175\u1106\u1161\u11BC","\u1111\u1175\u110B\u1161\u1102\u1169","\u1111\u1175\u11AF\u1105\u1173\u11B7","\u1111\u1175\u11AF\u1109\u116E","\u1111\u1175\u11AF\u110B\u116D","\u1111\u1175\u11AF\u110C\u1161","\u1111\u1175\u11AF\u1110\u1169\u11BC","\u1111\u1175\u11BC\u1100\u1168","\u1112\u1161\u1102\u1173\u1102\u1175\u11B7","\u1112\u1161\u1102\u1173\u11AF","\u1112\u1161\u1103\u1173\u110B\u1170\u110B\u1165","\u1112\u1161\u1105\u116E\u11BA\u1107\u1161\u11B7","\u1112\u1161\u1107\u1161\u11AB\u1100\u1175","\u1112\u1161\u1109\u116E\u11A8\u110C\u1175\u11B8","\u1112\u1161\u1109\u116E\u11AB","\u1112\u1161\u110B\u1167\u1110\u1173\u11AB","\u1112\u1161\u110C\u1175\u1106\u1161\u11AB","\u1112\u1161\u110E\u1165\u11AB","\u1112\u1161\u1111\u116E\u11B7","\u1112\u1161\u1111\u1175\u11AF","\u1112\u1161\u11A8\u1100\u116A","\u1112\u1161\u11A8\u1100\u116D","\u1112\u1161\u11A8\u1100\u1173\u11B8","\u1112\u1161\u11A8\u1100\u1175","\u1112\u1161\u11A8\u1102\u1167\u11AB","\u1112\u1161\u11A8\u1105\u1167\u11A8","\u1112\u1161\u11A8\u1107\u1165\u11AB","\u1112\u1161\u11A8\u1107\u116E\u1106\u1169","\u1112\u1161\u11A8\u1107\u1175","\u1112\u1161\u11A8\u1109\u1162\u11BC","\u1112\u1161\u11A8\u1109\u116E\u11AF","\u1112\u1161\u11A8\u1109\u1173\u11B8","\u1112\u1161\u11A8\u110B\u116D\u11BC\u1111\u116E\u11B7","\u1112\u1161\u11A8\u110B\u116F\u11AB","\u1112\u1161\u11A8\u110B\u1171","\u1112\u1161\u11A8\u110C\u1161","\u1112\u1161\u11A8\u110C\u1165\u11B7","\u1112\u1161\u11AB\u1100\u1168","\u1112\u1161\u11AB\u1100\u1173\u11AF","\u1112\u1161\u11AB\u1101\u1165\u1107\u1165\u11AB\u110B\u1166","\u1112\u1161\u11AB\u1102\u1161\u11BD","\u1112\u1161\u11AB\u1102\u116E\u11AB","\u1112\u1161\u11AB\u1103\u1169\u11BC\u110B\u1161\u11AB","\u1112\u1161\u11AB\u1104\u1162","\u1112\u1161\u11AB\u1105\u1161\u1109\u1161\u11AB","\u1112\u1161\u11AB\u1106\u1161\u1103\u1175","\u1112\u1161\u11AB\u1106\u116E\u11AB","\u1112\u1161\u11AB\u1107\u1165\u11AB","\u1112\u1161\u11AB\u1107\u1169\u11A8","\u1112\u1161\u11AB\u1109\u1175\u11A8","\u1112\u1161\u11AB\u110B\u1167\u1105\u1173\u11B7","\u1112\u1161\u11AB\u110D\u1169\u11A8","\u1112\u1161\u11AF\u1106\u1165\u1102\u1175","\u1112\u1161\u11AF\u110B\u1161\u1107\u1165\u110C\u1175","\u1112\u1161\u11AF\u110B\u1175\u11AB","\u1112\u1161\u11B7\u1101\u1166","\u1112\u1161\u11B7\u1107\u116E\u1105\u1169","\u1112\u1161\u11B8\u1100\u1167\u11A8","\u1112\u1161\u11B8\u1105\u1175\u110C\u1165\u11A8","\u1112\u1161\u11BC\u1100\u1169\u11BC","\u1112\u1161\u11BC\u1100\u116E","\u1112\u1161\u11BC\u1109\u1161\u11BC","\u1112\u1161\u11BC\u110B\u1174","\u1112\u1162\u1100\u1167\u11AF","\u1112\u1162\u1100\u116E\u11AB","\u1112\u1162\u1103\u1161\u11B8","\u1112\u1162\u1103\u1161\u11BC","\u1112\u1162\u1106\u116E\u11AF","\u1112\u1162\u1109\u1165\u11A8","\u1112\u1162\u1109\u1165\u11AF","\u1112\u1162\u1109\u116E\u110B\u116D\u11A8\u110C\u1161\u11BC","\u1112\u1162\u110B\u1161\u11AB","\u1112\u1162\u11A8\u1109\u1175\u11B7","\u1112\u1162\u11AB\u1103\u1173\u1107\u1162\u11A8","\u1112\u1162\u11B7\u1107\u1165\u1100\u1165","\u1112\u1162\u11BA\u1107\u1167\u11C0","\u1112\u1162\u11BA\u1109\u1161\u11AF","\u1112\u1162\u11BC\u1103\u1169\u11BC","\u1112\u1162\u11BC\u1107\u1169\u11A8","\u1112\u1162\u11BC\u1109\u1161","\u1112\u1162\u11BC\u110B\u116E\u11AB","\u1112\u1162\u11BC\u110B\u1171","\u1112\u1163\u11BC\u1100\u1175","\u1112\u1163\u11BC\u1109\u1161\u11BC","\u1112\u1163\u11BC\u1109\u116E","\u1112\u1165\u1105\u1161\u11A8","\u1112\u1165\u110B\u116D\u11BC","\u1112\u1166\u11AF\u1100\u1175","\u1112\u1167\u11AB\u1100\u116A\u11AB","\u1112\u1167\u11AB\u1100\u1173\u11B7","\u1112\u1167\u11AB\u1103\u1162","\u1112\u1167\u11AB\u1109\u1161\u11BC","\u1112\u1167\u11AB\u1109\u1175\u11AF","\u1112\u1167\u11AB\u110C\u1161\u11BC","\u1112\u1167\u11AB\u110C\u1162","\u1112\u1167\u11AB\u110C\u1175","\u1112\u1167\u11AF\u110B\u1162\u11A8","\u1112\u1167\u11B8\u1105\u1167\u11A8","\u1112\u1167\u11BC\u1107\u116E","\u1112\u1167\u11BC\u1109\u1161","\u1112\u1167\u11BC\u1109\u116E","\u1112\u1167\u11BC\u1109\u1175\u11A8","\u1112\u1167\u11BC\u110C\u1166","\u1112\u1167\u11BC\u1110\u1162","\u1112\u1167\u11BC\u1111\u1167\u11AB","\u1112\u1168\u1110\u1162\u11A8","\u1112\u1169\u1100\u1175\u1109\u1175\u11B7","\u1112\u1169\u1102\u1161\u11B7","\u1112\u1169\u1105\u1161\u11BC\u110B\u1175","\u1112\u1169\u1107\u1161\u11A8","\u1112\u1169\u1110\u1166\u11AF","\u1112\u1169\u1112\u1173\u11B8","\u1112\u1169\u11A8\u1109\u1175","\u1112\u1169\u11AF\u1105\u1169","\u1112\u1169\u11B7\u1111\u1166\u110B\u1175\u110C\u1175","\u1112\u1169\u11BC\u1107\u1169","\u1112\u1169\u11BC\u1109\u116E","\u1112\u1169\u11BC\u110E\u1161","\u1112\u116A\u1106\u1167\u11AB","\u1112\u116A\u1107\u116E\u11AB","\u1112\u116A\u1109\u1161\u11AF","\u1112\u116A\u110B\u116D\u110B\u1175\u11AF","\u1112\u116A\u110C\u1161\u11BC","\u1112\u116A\u1112\u1161\u11A8","\u1112\u116A\u11A8\u1107\u1169","\u1112\u116A\u11A8\u110B\u1175\u11AB","\u1112\u116A\u11A8\u110C\u1161\u11BC","\u1112\u116A\u11A8\u110C\u1165\u11BC","\u1112\u116A\u11AB\u1100\u1161\u11B8","\u1112\u116A\u11AB\u1100\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1167\u11BC","\u1112\u116A\u11AB\u110B\u1172\u11AF","\u1112\u116A\u11AB\u110C\u1161","\u1112\u116A\u11AF\u1100\u1175","\u1112\u116A\u11AF\u1103\u1169\u11BC","\u1112\u116A\u11AF\u1107\u1161\u11AF\u1112\u1175","\u1112\u116A\u11AF\u110B\u116D\u11BC","\u1112\u116A\u11AF\u110D\u1161\u11A8","\u1112\u116C\u1100\u1167\u11AB","\u1112\u116C\u1100\u116A\u11AB","\u1112\u116C\u1107\u1169\u11A8","\u1112\u116C\u1109\u1162\u11A8","\u1112\u116C\u110B\u116F\u11AB","\u1112\u116C\u110C\u1161\u11BC","\u1112\u116C\u110C\u1165\u11AB","\u1112\u116C\u11BA\u1109\u116E","\u1112\u116C\u11BC\u1103\u1161\u11AB\u1107\u1169\u1103\u1169","\u1112\u116D\u110B\u1172\u11AF\u110C\u1165\u11A8","\u1112\u116E\u1107\u1161\u11AB","\u1112\u116E\u110E\u116E\u11BA\u1100\u1161\u1105\u116E","\u1112\u116E\u11AB\u1105\u1167\u11AB","\u1112\u116F\u11AF\u110A\u1175\u11AB","\u1112\u1172\u1109\u1175\u11A8","\u1112\u1172\u110B\u1175\u11AF","\u1112\u1172\u11BC\u1102\u1162","\u1112\u1173\u1105\u1173\u11B7","\u1112\u1173\u11A8\u1107\u1162\u11A8","\u1112\u1173\u11A8\u110B\u1175\u11AB","\u1112\u1173\u11AB\u110C\u1165\u11A8","\u1112\u1173\u11AB\u1112\u1175","\u1112\u1173\u11BC\u1106\u1175","\u1112\u1173\u11BC\u1107\u116E\u11AB","\u1112\u1174\u1100\u1169\u11A8","\u1112\u1174\u1106\u1161\u11BC","\u1112\u1174\u1109\u1162\u11BC","\u1112\u1174\u11AB\u1109\u1162\u11A8","\u1112\u1175\u11B7\u1101\u1165\u11BA"]');

});

parcelRegister("eFCbz", function(module, exports) {
module.exports = JSON.parse('["abaisser","abandon","abdiquer","abeille","abolir","aborder","aboutir","aboyer","abrasif","abreuver","abriter","abroger","abrupt","absence","absolu","absurde","abusif","abyssal","acade\u0301mie","acajou","acarien","accabler","accepter","acclamer","accolade","accroche","accuser","acerbe","achat","acheter","aciduler","acier","acompte","acque\u0301rir","acronyme","acteur","actif","actuel","adepte","ade\u0301quat","adhe\u0301sif","adjectif","adjuger","admettre","admirer","adopter","adorer","adoucir","adresse","adroit","adulte","adverbe","ae\u0301rer","ae\u0301ronef","affaire","affecter","affiche","affreux","affubler","agacer","agencer","agile","agiter","agrafer","agre\u0301able","agrume","aider","aiguille","ailier","aimable","aisance","ajouter","ajuster","alarmer","alchimie","alerte","alge\u0300bre","algue","alie\u0301ner","aliment","alle\u0301ger","alliage","allouer","allumer","alourdir","alpaga","altesse","alve\u0301ole","amateur","ambigu","ambre","ame\u0301nager","amertume","amidon","amiral","amorcer","amour","amovible","amphibie","ampleur","amusant","analyse","anaphore","anarchie","anatomie","ancien","ane\u0301antir","angle","angoisse","anguleux","animal","annexer","annonce","annuel","anodin","anomalie","anonyme","anormal","antenne","antidote","anxieux","apaiser","ape\u0301ritif","aplanir","apologie","appareil","appeler","apporter","appuyer","aquarium","aqueduc","arbitre","arbuste","ardeur","ardoise","argent","arlequin","armature","armement","armoire","armure","arpenter","arracher","arriver","arroser","arsenic","arte\u0301riel","article","aspect","asphalte","aspirer","assaut","asservir","assiette","associer","assurer","asticot","astre","astuce","atelier","atome","atrium","atroce","attaque","attentif","attirer","attraper","aubaine","auberge","audace","audible","augurer","aurore","automne","autruche","avaler","avancer","avarice","avenir","averse","aveugle","aviateur","avide","avion","aviser","avoine","avouer","avril","axial","axiome","badge","bafouer","bagage","baguette","baignade","balancer","balcon","baleine","balisage","bambin","bancaire","bandage","banlieue","bannie\u0300re","banquier","barbier","baril","baron","barque","barrage","bassin","bastion","bataille","bateau","batterie","baudrier","bavarder","belette","be\u0301lier","belote","be\u0301ne\u0301fice","berceau","berger","berline","bermuda","besace","besogne","be\u0301tail","beurre","biberon","bicycle","bidule","bijou","bilan","bilingue","billard","binaire","biologie","biopsie","biotype","biscuit","bison","bistouri","bitume","bizarre","blafard","blague","blanchir","blessant","blinder","blond","bloquer","blouson","bobard","bobine","boire","boiser","bolide","bonbon","bondir","bonheur","bonifier","bonus","bordure","borne","botte","boucle","boueux","bougie","boulon","bouquin","bourse","boussole","boutique","boxeur","branche","brasier","brave","brebis","bre\u0300che","breuvage","bricoler","brigade","brillant","brioche","brique","brochure","broder","bronzer","brousse","broyeur","brume","brusque","brutal","bruyant","buffle","buisson","bulletin","bureau","burin","bustier","butiner","butoir","buvable","buvette","cabanon","cabine","cachette","cadeau","cadre","cafe\u0301ine","caillou","caisson","calculer","calepin","calibre","calmer","calomnie","calvaire","camarade","came\u0301ra","camion","campagne","canal","caneton","canon","cantine","canular","capable","caporal","caprice","capsule","capter","capuche","carabine","carbone","caresser","caribou","carnage","carotte","carreau","carton","cascade","casier","casque","cassure","causer","caution","cavalier","caverne","caviar","ce\u0301dille","ceinture","ce\u0301leste","cellule","cendrier","censurer","central","cercle","ce\u0301re\u0301bral","cerise","cerner","cerveau","cesser","chagrin","chaise","chaleur","chambre","chance","chapitre","charbon","chasseur","chaton","chausson","chavirer","chemise","chenille","che\u0301quier","chercher","cheval","chien","chiffre","chignon","chime\u0300re","chiot","chlorure","chocolat","choisir","chose","chouette","chrome","chute","cigare","cigogne","cimenter","cine\u0301ma","cintrer","circuler","cirer","cirque","citerne","citoyen","citron","civil","clairon","clameur","claquer","classe","clavier","client","cligner","climat","clivage","cloche","clonage","cloporte","cobalt","cobra","cocasse","cocotier","coder","codifier","coffre","cogner","cohe\u0301sion","coiffer","coincer","cole\u0300re","colibri","colline","colmater","colonel","combat","come\u0301die","commande","compact","concert","conduire","confier","congeler","connoter","consonne","contact","convexe","copain","copie","corail","corbeau","cordage","corniche","corpus","correct","corte\u0300ge","cosmique","costume","coton","coude","coupure","courage","couteau","couvrir","coyote","crabe","crainte","cravate","crayon","cre\u0301ature","cre\u0301diter","cre\u0301meux","creuser","crevette","cribler","crier","cristal","crite\u0300re","croire","croquer","crotale","crucial","cruel","crypter","cubique","cueillir","cuille\u0300re","cuisine","cuivre","culminer","cultiver","cumuler","cupide","curatif","curseur","cyanure","cycle","cylindre","cynique","daigner","damier","danger","danseur","dauphin","de\u0301battre","de\u0301biter","de\u0301border","de\u0301brider","de\u0301butant","de\u0301caler","de\u0301cembre","de\u0301chirer","de\u0301cider","de\u0301clarer","de\u0301corer","de\u0301crire","de\u0301cupler","de\u0301dale","de\u0301ductif","de\u0301esse","de\u0301fensif","de\u0301filer","de\u0301frayer","de\u0301gager","de\u0301givrer","de\u0301glutir","de\u0301grafer","de\u0301jeuner","de\u0301lice","de\u0301loger","demander","demeurer","de\u0301molir","de\u0301nicher","de\u0301nouer","dentelle","de\u0301nuder","de\u0301part","de\u0301penser","de\u0301phaser","de\u0301placer","de\u0301poser","de\u0301ranger","de\u0301rober","de\u0301sastre","descente","de\u0301sert","de\u0301signer","de\u0301sobe\u0301ir","dessiner","destrier","de\u0301tacher","de\u0301tester","de\u0301tourer","de\u0301tresse","devancer","devenir","deviner","devoir","diable","dialogue","diamant","dicter","diffe\u0301rer","dige\u0301rer","digital","digne","diluer","dimanche","diminuer","dioxyde","directif","diriger","discuter","disposer","dissiper","distance","divertir","diviser","docile","docteur","dogme","doigt","domaine","domicile","dompter","donateur","donjon","donner","dopamine","dortoir","dorure","dosage","doseur","dossier","dotation","douanier","double","douceur","douter","doyen","dragon","draper","dresser","dribbler","droiture","duperie","duplexe","durable","durcir","dynastie","e\u0301blouir","e\u0301carter","e\u0301charpe","e\u0301chelle","e\u0301clairer","e\u0301clipse","e\u0301clore","e\u0301cluse","e\u0301cole","e\u0301conomie","e\u0301corce","e\u0301couter","e\u0301craser","e\u0301cre\u0301mer","e\u0301crivain","e\u0301crou","e\u0301cume","e\u0301cureuil","e\u0301difier","e\u0301duquer","effacer","effectif","effigie","effort","effrayer","effusion","e\u0301galiser","e\u0301garer","e\u0301jecter","e\u0301laborer","e\u0301largir","e\u0301lectron","e\u0301le\u0301gant","e\u0301le\u0301phant","e\u0301le\u0300ve","e\u0301ligible","e\u0301litisme","e\u0301loge","e\u0301lucider","e\u0301luder","emballer","embellir","embryon","e\u0301meraude","e\u0301mission","emmener","e\u0301motion","e\u0301mouvoir","empereur","employer","emporter","emprise","e\u0301mulsion","encadrer","enche\u0300re","enclave","encoche","endiguer","endosser","endroit","enduire","e\u0301nergie","enfance","enfermer","enfouir","engager","engin","englober","e\u0301nigme","enjamber","enjeu","enlever","ennemi","ennuyeux","enrichir","enrobage","enseigne","entasser","entendre","entier","entourer","entraver","e\u0301nume\u0301rer","envahir","enviable","envoyer","enzyme","e\u0301olien","e\u0301paissir","e\u0301pargne","e\u0301patant","e\u0301paule","e\u0301picerie","e\u0301pide\u0301mie","e\u0301pier","e\u0301pilogue","e\u0301pine","e\u0301pisode","e\u0301pitaphe","e\u0301poque","e\u0301preuve","e\u0301prouver","e\u0301puisant","e\u0301querre","e\u0301quipe","e\u0301riger","e\u0301rosion","erreur","e\u0301ruption","escalier","espadon","espe\u0300ce","espie\u0300gle","espoir","esprit","esquiver","essayer","essence","essieu","essorer","estime","estomac","estrade","e\u0301tage\u0300re","e\u0301taler","e\u0301tanche","e\u0301tatique","e\u0301teindre","e\u0301tendoir","e\u0301ternel","e\u0301thanol","e\u0301thique","ethnie","e\u0301tirer","e\u0301toffer","e\u0301toile","e\u0301tonnant","e\u0301tourdir","e\u0301trange","e\u0301troit","e\u0301tude","euphorie","e\u0301valuer","e\u0301vasion","e\u0301ventail","e\u0301vidence","e\u0301viter","e\u0301volutif","e\u0301voquer","exact","exage\u0301rer","exaucer","exceller","excitant","exclusif","excuse","exe\u0301cuter","exemple","exercer","exhaler","exhorter","exigence","exiler","exister","exotique","expe\u0301dier","explorer","exposer","exprimer","exquis","extensif","extraire","exulter","fable","fabuleux","facette","facile","facture","faiblir","falaise","fameux","famille","farceur","farfelu","farine","farouche","fasciner","fatal","fatigue","faucon","fautif","faveur","favori","fe\u0301brile","fe\u0301conder","fe\u0301de\u0301rer","fe\u0301lin","femme","fe\u0301mur","fendoir","fe\u0301odal","fermer","fe\u0301roce","ferveur","festival","feuille","feutre","fe\u0301vrier","fiasco","ficeler","fictif","fide\u0300le","figure","filature","filetage","filie\u0300re","filleul","filmer","filou","filtrer","financer","finir","fiole","firme","fissure","fixer","flairer","flamme","flasque","flatteur","fle\u0301au","fle\u0300che","fleur","flexion","flocon","flore","fluctuer","fluide","fluvial","folie","fonderie","fongible","fontaine","forcer","forgeron","formuler","fortune","fossile","foudre","fouge\u0300re","fouiller","foulure","fourmi","fragile","fraise","franchir","frapper","frayeur","fre\u0301gate","freiner","frelon","fre\u0301mir","fre\u0301ne\u0301sie","fre\u0300re","friable","friction","frisson","frivole","froid","fromage","frontal","frotter","fruit","fugitif","fuite","fureur","furieux","furtif","fusion","futur","gagner","galaxie","galerie","gambader","garantir","gardien","garnir","garrigue","gazelle","gazon","ge\u0301ant","ge\u0301latine","ge\u0301lule","gendarme","ge\u0301ne\u0301ral","ge\u0301nie","genou","gentil","ge\u0301ologie","ge\u0301ome\u0300tre","ge\u0301ranium","germe","gestuel","geyser","gibier","gicler","girafe","givre","glace","glaive","glisser","globe","gloire","glorieux","golfeur","gomme","gonfler","gorge","gorille","goudron","gouffre","goulot","goupille","gourmand","goutte","graduel","graffiti","graine","grand","grappin","gratuit","gravir","grenat","griffure","griller","grimper","grogner","gronder","grotte","groupe","gruger","grutier","gruye\u0300re","gue\u0301pard","guerrier","guide","guimauve","guitare","gustatif","gymnaste","gyrostat","habitude","hachoir","halte","hameau","hangar","hanneton","haricot","harmonie","harpon","hasard","he\u0301lium","he\u0301matome","herbe","he\u0301risson","hermine","he\u0301ron","he\u0301siter","heureux","hiberner","hibou","hilarant","histoire","hiver","homard","hommage","homoge\u0300ne","honneur","honorer","honteux","horde","horizon","horloge","hormone","horrible","houleux","housse","hublot","huileux","humain","humble","humide","humour","hurler","hydromel","hygie\u0300ne","hymne","hypnose","idylle","ignorer","iguane","illicite","illusion","image","imbiber","imiter","immense","immobile","immuable","impact","impe\u0301rial","implorer","imposer","imprimer","imputer","incarner","incendie","incident","incliner","incolore","indexer","indice","inductif","ine\u0301dit","ineptie","inexact","infini","infliger","informer","infusion","inge\u0301rer","inhaler","inhiber","injecter","injure","innocent","inoculer","inonder","inscrire","insecte","insigne","insolite","inspirer","instinct","insulter","intact","intense","intime","intrigue","intuitif","inutile","invasion","inventer","inviter","invoquer","ironique","irradier","irre\u0301el","irriter","isoler","ivoire","ivresse","jaguar","jaillir","jambe","janvier","jardin","jauger","jaune","javelot","jetable","jeton","jeudi","jeunesse","joindre","joncher","jongler","joueur","jouissif","journal","jovial","joyau","joyeux","jubiler","jugement","junior","jupon","juriste","justice","juteux","juve\u0301nile","kayak","kimono","kiosque","label","labial","labourer","lace\u0301rer","lactose","lagune","laine","laisser","laitier","lambeau","lamelle","lampe","lanceur","langage","lanterne","lapin","largeur","larme","laurier","lavabo","lavoir","lecture","le\u0301gal","le\u0301ger","le\u0301gume","lessive","lettre","levier","lexique","le\u0301zard","liasse","libe\u0301rer","libre","licence","licorne","lie\u0300ge","lie\u0300vre","ligature","ligoter","ligue","limer","limite","limonade","limpide","line\u0301aire","lingot","lionceau","liquide","lisie\u0300re","lister","lithium","litige","littoral","livreur","logique","lointain","loisir","lombric","loterie","louer","lourd","loutre","louve","loyal","lubie","lucide","lucratif","lueur","lugubre","luisant","lumie\u0300re","lunaire","lundi","luron","lutter","luxueux","machine","magasin","magenta","magique","maigre","maillon","maintien","mairie","maison","majorer","malaxer","male\u0301fice","malheur","malice","mallette","mammouth","mandater","maniable","manquant","manteau","manuel","marathon","marbre","marchand","mardi","maritime","marqueur","marron","marteler","mascotte","massif","mate\u0301riel","matie\u0300re","matraque","maudire","maussade","mauve","maximal","me\u0301chant","me\u0301connu","me\u0301daille","me\u0301decin","me\u0301diter","me\u0301duse","meilleur","me\u0301lange","me\u0301lodie","membre","me\u0301moire","menacer","mener","menhir","mensonge","mentor","mercredi","me\u0301rite","merle","messager","mesure","me\u0301tal","me\u0301te\u0301ore","me\u0301thode","me\u0301tier","meuble","miauler","microbe","miette","mignon","migrer","milieu","million","mimique","mince","mine\u0301ral","minimal","minorer","minute","miracle","miroiter","missile","mixte","mobile","moderne","moelleux","mondial","moniteur","monnaie","monotone","monstre","montagne","monument","moqueur","morceau","morsure","mortier","moteur","motif","mouche","moufle","moulin","mousson","mouton","mouvant","multiple","munition","muraille","mure\u0300ne","murmure","muscle","muse\u0301um","musicien","mutation","muter","mutuel","myriade","myrtille","myste\u0300re","mythique","nageur","nappe","narquois","narrer","natation","nation","nature","naufrage","nautique","navire","ne\u0301buleux","nectar","ne\u0301faste","ne\u0301gation","ne\u0301gliger","ne\u0301gocier","neige","nerveux","nettoyer","neurone","neutron","neveu","niche","nickel","nitrate","niveau","noble","nocif","nocturne","noirceur","noisette","nomade","nombreux","nommer","normatif","notable","notifier","notoire","nourrir","nouveau","novateur","novembre","novice","nuage","nuancer","nuire","nuisible","nume\u0301ro","nuptial","nuque","nutritif","obe\u0301ir","objectif","obliger","obscur","observer","obstacle","obtenir","obturer","occasion","occuper","oce\u0301an","octobre","octroyer","octupler","oculaire","odeur","odorant","offenser","officier","offrir","ogive","oiseau","oisillon","olfactif","olivier","ombrage","omettre","onctueux","onduler","one\u0301reux","onirique","opale","opaque","ope\u0301rer","opinion","opportun","opprimer","opter","optique","orageux","orange","orbite","ordonner","oreille","organe","orgueil","orifice","ornement","orque","ortie","osciller","osmose","ossature","otarie","ouragan","ourson","outil","outrager","ouvrage","ovation","oxyde","oxyge\u0300ne","ozone","paisible","palace","palmare\u0300s","palourde","palper","panache","panda","pangolin","paniquer","panneau","panorama","pantalon","papaye","papier","papoter","papyrus","paradoxe","parcelle","paresse","parfumer","parler","parole","parrain","parsemer","partager","parure","parvenir","passion","paste\u0300que","paternel","patience","patron","pavillon","pavoiser","payer","paysage","peigne","peintre","pelage","pe\u0301lican","pelle","pelouse","peluche","pendule","pe\u0301ne\u0301trer","pe\u0301nible","pensif","pe\u0301nurie","pe\u0301pite","pe\u0301plum","perdrix","perforer","pe\u0301riode","permuter","perplexe","persil","perte","peser","pe\u0301tale","petit","pe\u0301trir","peuple","pharaon","phobie","phoque","photon","phrase","physique","piano","pictural","pie\u0300ce","pierre","pieuvre","pilote","pinceau","pipette","piquer","pirogue","piscine","piston","pivoter","pixel","pizza","placard","plafond","plaisir","planer","plaque","plastron","plateau","pleurer","plexus","pliage","plomb","plonger","pluie","plumage","pochette","poe\u0301sie","poe\u0300te","pointe","poirier","poisson","poivre","polaire","policier","pollen","polygone","pommade","pompier","ponctuel","ponde\u0301rer","poney","portique","position","posse\u0301der","posture","potager","poteau","potion","pouce","poulain","poumon","pourpre","poussin","pouvoir","prairie","pratique","pre\u0301cieux","pre\u0301dire","pre\u0301fixe","pre\u0301lude","pre\u0301nom","pre\u0301sence","pre\u0301texte","pre\u0301voir","primitif","prince","prison","priver","proble\u0300me","proce\u0301der","prodige","profond","progre\u0300s","proie","projeter","prologue","promener","propre","prospe\u0300re","prote\u0301ger","prouesse","proverbe","prudence","pruneau","psychose","public","puceron","puiser","pulpe","pulsar","punaise","punitif","pupitre","purifier","puzzle","pyramide","quasar","querelle","question","quie\u0301tude","quitter","quotient","racine","raconter","radieux","ragondin","raideur","raisin","ralentir","rallonge","ramasser","rapide","rasage","ratisser","ravager","ravin","rayonner","re\u0301actif","re\u0301agir","re\u0301aliser","re\u0301animer","recevoir","re\u0301citer","re\u0301clamer","re\u0301colter","recruter","reculer","recycler","re\u0301diger","redouter","refaire","re\u0301flexe","re\u0301former","refrain","refuge","re\u0301galien","re\u0301gion","re\u0301glage","re\u0301gulier","re\u0301ite\u0301rer","rejeter","rejouer","relatif","relever","relief","remarque","reme\u0300de","remise","remonter","remplir","remuer","renard","renfort","renifler","renoncer","rentrer","renvoi","replier","reporter","reprise","reptile","requin","re\u0301serve","re\u0301sineux","re\u0301soudre","respect","rester","re\u0301sultat","re\u0301tablir","retenir","re\u0301ticule","retomber","retracer","re\u0301union","re\u0301ussir","revanche","revivre","re\u0301volte","re\u0301vulsif","richesse","rideau","rieur","rigide","rigoler","rincer","riposter","risible","risque","rituel","rival","rivie\u0300re","rocheux","romance","rompre","ronce","rondin","roseau","rosier","rotatif","rotor","rotule","rouge","rouille","rouleau","routine","royaume","ruban","rubis","ruche","ruelle","rugueux","ruiner","ruisseau","ruser","rustique","rythme","sabler","saboter","sabre","sacoche","safari","sagesse","saisir","salade","salive","salon","saluer","samedi","sanction","sanglier","sarcasme","sardine","saturer","saugrenu","saumon","sauter","sauvage","savant","savonner","scalpel","scandale","sce\u0301le\u0301rat","sce\u0301nario","sceptre","sche\u0301ma","science","scinder","score","scrutin","sculpter","se\u0301ance","se\u0301cable","se\u0301cher","secouer","se\u0301cre\u0301ter","se\u0301datif","se\u0301duire","seigneur","se\u0301jour","se\u0301lectif","semaine","sembler","semence","se\u0301minal","se\u0301nateur","sensible","sentence","se\u0301parer","se\u0301quence","serein","sergent","se\u0301rieux","serrure","se\u0301rum","service","se\u0301same","se\u0301vir","sevrage","sextuple","side\u0301ral","sie\u0300cle","sie\u0301ger","siffler","sigle","signal","silence","silicium","simple","since\u0300re","sinistre","siphon","sirop","sismique","situer","skier","social","socle","sodium","soigneux","soldat","soleil","solitude","soluble","sombre","sommeil","somnoler","sonde","songeur","sonnette","sonore","sorcier","sortir","sosie","sottise","soucieux","soudure","souffle","soulever","soupape","source","soutirer","souvenir","spacieux","spatial","spe\u0301cial","sphe\u0300re","spiral","stable","station","sternum","stimulus","stipuler","strict","studieux","stupeur","styliste","sublime","substrat","subtil","subvenir","succe\u0300s","sucre","suffixe","sugge\u0301rer","suiveur","sulfate","superbe","supplier","surface","suricate","surmener","surprise","sursaut","survie","suspect","syllabe","symbole","syme\u0301trie","synapse","syntaxe","syste\u0300me","tabac","tablier","tactile","tailler","talent","talisman","talonner","tambour","tamiser","tangible","tapis","taquiner","tarder","tarif","tartine","tasse","tatami","tatouage","taupe","taureau","taxer","te\u0301moin","temporel","tenaille","tendre","teneur","tenir","tension","terminer","terne","terrible","te\u0301tine","texte","the\u0300me","the\u0301orie","the\u0301rapie","thorax","tibia","tie\u0300de","timide","tirelire","tiroir","tissu","titane","titre","tituber","toboggan","tole\u0301rant","tomate","tonique","tonneau","toponyme","torche","tordre","tornade","torpille","torrent","torse","tortue","totem","toucher","tournage","tousser","toxine","traction","trafic","tragique","trahir","train","trancher","travail","tre\u0300fle","tremper","tre\u0301sor","treuil","triage","tribunal","tricoter","trilogie","triomphe","tripler","triturer","trivial","trombone","tronc","tropical","troupeau","tuile","tulipe","tumulte","tunnel","turbine","tuteur","tutoyer","tuyau","tympan","typhon","typique","tyran","ubuesque","ultime","ultrason","unanime","unifier","union","unique","unitaire","univers","uranium","urbain","urticant","usage","usine","usuel","usure","utile","utopie","vacarme","vaccin","vagabond","vague","vaillant","vaincre","vaisseau","valable","valise","vallon","valve","vampire","vanille","vapeur","varier","vaseux","vassal","vaste","vecteur","vedette","ve\u0301ge\u0301tal","ve\u0301hicule","veinard","ve\u0301loce","vendredi","ve\u0301ne\u0301rer","venger","venimeux","ventouse","verdure","ve\u0301rin","vernir","verrou","verser","vertu","veston","ve\u0301te\u0301ran","ve\u0301tuste","vexant","vexer","viaduc","viande","victoire","vidange","vide\u0301o","vignette","vigueur","vilain","village","vinaigre","violon","vipe\u0300re","virement","virtuose","virus","visage","viseur","vision","visqueux","visuel","vital","vitesse","viticole","vitrine","vivace","vivipare","vocation","voguer","voile","voisin","voiture","volaille","volcan","voltiger","volume","vorace","vortex","voter","vouloir","voyage","voyelle","wagon","xe\u0301non","yacht","ze\u0300bre","ze\u0301nith","zeste","zoologie"]');

});

parcelRegister("hrLhZ", function(module, exports) {
module.exports = JSON.parse('["abaco","abbaglio","abbinato","abete","abisso","abolire","abrasivo","abrogato","accadere","accenno","accusato","acetone","achille","acido","acqua","acre","acrilico","acrobata","acuto","adagio","addebito","addome","adeguato","aderire","adipe","adottare","adulare","affabile","affetto","affisso","affranto","aforisma","afoso","africano","agave","agente","agevole","aggancio","agire","agitare","agonismo","agricolo","agrumeto","aguzzo","alabarda","alato","albatro","alberato","albo","albume","alce","alcolico","alettone","alfa","algebra","aliante","alibi","alimento","allagato","allegro","allievo","allodola","allusivo","almeno","alogeno","alpaca","alpestre","altalena","alterno","alticcio","altrove","alunno","alveolo","alzare","amalgama","amanita","amarena","ambito","ambrato","ameba","america","ametista","amico","ammasso","ammenda","ammirare","ammonito","amore","ampio","ampliare","amuleto","anacardo","anagrafe","analista","anarchia","anatra","anca","ancella","ancora","andare","andrea","anello","angelo","angolare","angusto","anima","annegare","annidato","anno","annuncio","anonimo","anticipo","anzi","apatico","apertura","apode","apparire","appetito","appoggio","approdo","appunto","aprile","arabica","arachide","aragosta","araldica","arancio","aratura","arazzo","arbitro","archivio","ardito","arenile","argento","argine","arguto","aria","armonia","arnese","arredato","arringa","arrosto","arsenico","arso","artefice","arzillo","asciutto","ascolto","asepsi","asettico","asfalto","asino","asola","aspirato","aspro","assaggio","asse","assoluto","assurdo","asta","astenuto","astice","astratto","atavico","ateismo","atomico","atono","attesa","attivare","attorno","attrito","attuale","ausilio","austria","autista","autonomo","autunno","avanzato","avere","avvenire","avviso","avvolgere","azione","azoto","azzimo","azzurro","babele","baccano","bacino","baco","badessa","badilata","bagnato","baita","balcone","baldo","balena","ballata","balzano","bambino","bandire","baraonda","barbaro","barca","baritono","barlume","barocco","basilico","basso","batosta","battuto","baule","bava","bavosa","becco","beffa","belgio","belva","benda","benevole","benigno","benzina","bere","berlina","beta","bibita","bici","bidone","bifido","biga","bilancia","bimbo","binocolo","biologo","bipede","bipolare","birbante","birra","biscotto","bisesto","bisnonno","bisonte","bisturi","bizzarro","blando","blatta","bollito","bonifico","bordo","bosco","botanico","bottino","bozzolo","braccio","bradipo","brama","branca","bravura","bretella","brevetto","brezza","briglia","brillante","brindare","broccolo","brodo","bronzina","brullo","bruno","bubbone","buca","budino","buffone","buio","bulbo","buono","burlone","burrasca","bussola","busta","cadetto","caduco","calamaro","calcolo","calesse","calibro","calmo","caloria","cambusa","camerata","camicia","cammino","camola","campale","canapa","candela","cane","canino","canotto","cantina","capace","capello","capitolo","capogiro","cappero","capra","capsula","carapace","carcassa","cardo","carisma","carovana","carretto","cartolina","casaccio","cascata","caserma","caso","cassone","castello","casuale","catasta","catena","catrame","cauto","cavillo","cedibile","cedrata","cefalo","celebre","cellulare","cena","cenone","centesimo","ceramica","cercare","certo","cerume","cervello","cesoia","cespo","ceto","chela","chiaro","chicca","chiedere","chimera","china","chirurgo","chitarra","ciao","ciclismo","cifrare","cigno","cilindro","ciottolo","circa","cirrosi","citrico","cittadino","ciuffo","civetta","civile","classico","clinica","cloro","cocco","codardo","codice","coerente","cognome","collare","colmato","colore","colposo","coltivato","colza","coma","cometa","commando","comodo","computer","comune","conciso","condurre","conferma","congelare","coniuge","connesso","conoscere","consumo","continuo","convegno","coperto","copione","coppia","copricapo","corazza","cordata","coricato","cornice","corolla","corpo","corredo","corsia","cortese","cosmico","costante","cottura","covato","cratere","cravatta","creato","credere","cremoso","crescita","creta","criceto","crinale","crisi","critico","croce","cronaca","crostata","cruciale","crusca","cucire","cuculo","cugino","cullato","cupola","curatore","cursore","curvo","cuscino","custode","dado","daino","dalmata","damerino","daniela","dannoso","danzare","datato","davanti","davvero","debutto","decennio","deciso","declino","decollo","decreto","dedicato","definito","deforme","degno","delegare","delfino","delirio","delta","demenza","denotato","dentro","deposito","derapata","derivare","deroga","descritto","deserto","desiderio","desumere","detersivo","devoto","diametro","dicembre","diedro","difeso","diffuso","digerire","digitale","diluvio","dinamico","dinnanzi","dipinto","diploma","dipolo","diradare","dire","dirotto","dirupo","disagio","discreto","disfare","disgelo","disposto","distanza","disumano","dito","divano","divelto","dividere","divorato","doblone","docente","doganale","dogma","dolce","domato","domenica","dominare","dondolo","dono","dormire","dote","dottore","dovuto","dozzina","drago","druido","dubbio","dubitare","ducale","duna","duomo","duplice","duraturo","ebano","eccesso","ecco","eclissi","economia","edera","edicola","edile","editoria","educare","egemonia","egli","egoismo","egregio","elaborato","elargire","elegante","elencato","eletto","elevare","elfico","elica","elmo","elsa","eluso","emanato","emblema","emesso","emiro","emotivo","emozione","empirico","emulo","endemico","enduro","energia","enfasi","enoteca","entrare","enzima","epatite","epilogo","episodio","epocale","eppure","equatore","erario","erba","erboso","erede","eremita","erigere","ermetico","eroe","erosivo","errante","esagono","esame","esanime","esaudire","esca","esempio","esercito","esibito","esigente","esistere","esito","esofago","esortato","esoso","espanso","espresso","essenza","esso","esteso","estimare","estonia","estroso","esultare","etilico","etnico","etrusco","etto","euclideo","europa","evaso","evidenza","evitato","evoluto","evviva","fabbrica","faccenda","fachiro","falco","famiglia","fanale","fanfara","fango","fantasma","fare","farfalla","farinoso","farmaco","fascia","fastoso","fasullo","faticare","fato","favoloso","febbre","fecola","fede","fegato","felpa","feltro","femmina","fendere","fenomeno","fermento","ferro","fertile","fessura","festivo","fetta","feudo","fiaba","fiducia","fifa","figurato","filo","finanza","finestra","finire","fiore","fiscale","fisico","fiume","flacone","flamenco","flebo","flemma","florido","fluente","fluoro","fobico","focaccia","focoso","foderato","foglio","folata","folclore","folgore","fondente","fonetico","fonia","fontana","forbito","forchetta","foresta","formica","fornaio","foro","fortezza","forzare","fosfato","fosso","fracasso","frana","frassino","fratello","freccetta","frenata","fresco","frigo","frollino","fronde","frugale","frutta","fucilata","fucsia","fuggente","fulmine","fulvo","fumante","fumetto","fumoso","fune","funzione","fuoco","furbo","furgone","furore","fuso","futile","gabbiano","gaffe","galateo","gallina","galoppo","gambero","gamma","garanzia","garbo","garofano","garzone","gasdotto","gasolio","gastrico","gatto","gaudio","gazebo","gazzella","geco","gelatina","gelso","gemello","gemmato","gene","genitore","gennaio","genotipo","gergo","ghepardo","ghiaccio","ghisa","giallo","gilda","ginepro","giocare","gioiello","giorno","giove","girato","girone","gittata","giudizio","giurato","giusto","globulo","glutine","gnomo","gobba","golf","gomito","gommone","gonfio","gonna","governo","gracile","grado","grafico","grammo","grande","grattare","gravoso","grazia","greca","gregge","grifone","grigio","grinza","grotta","gruppo","guadagno","guaio","guanto","guardare","gufo","guidare","ibernato","icona","identico","idillio","idolo","idra","idrico","idrogeno","igiene","ignaro","ignorato","ilare","illeso","illogico","illudere","imballo","imbevuto","imbocco","imbuto","immane","immerso","immolato","impacco","impeto","impiego","importo","impronta","inalare","inarcare","inattivo","incanto","incendio","inchino","incisivo","incluso","incontro","incrocio","incubo","indagine","india","indole","inedito","infatti","infilare","inflitto","ingaggio","ingegno","inglese","ingordo","ingrosso","innesco","inodore","inoltrare","inondato","insano","insetto","insieme","insonnia","insulina","intasato","intero","intonaco","intuito","inumidire","invalido","invece","invito","iperbole","ipnotico","ipotesi","ippica","iride","irlanda","ironico","irrigato","irrorare","isolato","isotopo","isterico","istituto","istrice","italia","iterare","labbro","labirinto","lacca","lacerato","lacrima","lacuna","laddove","lago","lampo","lancetta","lanterna","lardoso","larga","laringe","lastra","latenza","latino","lattuga","lavagna","lavoro","legale","leggero","lembo","lentezza","lenza","leone","lepre","lesivo","lessato","lesto","letterale","leva","levigato","libero","lido","lievito","lilla","limatura","limitare","limpido","lineare","lingua","liquido","lira","lirica","lisca","lite","litigio","livrea","locanda","lode","logica","lombare","londra","longevo","loquace","lorenzo","loto","lotteria","luce","lucidato","lumaca","luminoso","lungo","lupo","luppolo","lusinga","lusso","lutto","macabro","macchina","macero","macinato","madama","magico","maglia","magnete","magro","maiolica","malafede","malgrado","malinteso","malsano","malto","malumore","mana","mancia","mandorla","mangiare","manifesto","mannaro","manovra","mansarda","mantide","manubrio","mappa","maratona","marcire","maretta","marmo","marsupio","maschera","massaia","mastino","materasso","matricola","mattone","maturo","mazurca","meandro","meccanico","mecenate","medesimo","meditare","mega","melassa","melis","melodia","meninge","meno","mensola","mercurio","merenda","merlo","meschino","mese","messere","mestolo","metallo","metodo","mettere","miagolare","mica","micelio","michele","microbo","midollo","miele","migliore","milano","milite","mimosa","minerale","mini","minore","mirino","mirtillo","miscela","missiva","misto","misurare","mitezza","mitigare","mitra","mittente","mnemonico","modello","modifica","modulo","mogano","mogio","mole","molosso","monastero","monco","mondina","monetario","monile","monotono","monsone","montato","monviso","mora","mordere","morsicato","mostro","motivato","motosega","motto","movenza","movimento","mozzo","mucca","mucosa","muffa","mughetto","mugnaio","mulatto","mulinello","multiplo","mummia","munto","muovere","murale","musa","muscolo","musica","mutevole","muto","nababbo","nafta","nanometro","narciso","narice","narrato","nascere","nastrare","naturale","nautica","naviglio","nebulosa","necrosi","negativo","negozio","nemmeno","neofita","neretto","nervo","nessuno","nettuno","neutrale","neve","nevrotico","nicchia","ninfa","nitido","nobile","nocivo","nodo","nome","nomina","nordico","normale","norvegese","nostrano","notare","notizia","notturno","novella","nucleo","nulla","numero","nuovo","nutrire","nuvola","nuziale","oasi","obbedire","obbligo","obelisco","oblio","obolo","obsoleto","occasione","occhio","occidente","occorrere","occultare","ocra","oculato","odierno","odorare","offerta","offrire","offuscato","oggetto","oggi","ognuno","olandese","olfatto","oliato","oliva","ologramma","oltre","omaggio","ombelico","ombra","omega","omissione","ondoso","onere","onice","onnivoro","onorevole","onta","operato","opinione","opposto","oracolo","orafo","ordine","orecchino","orefice","orfano","organico","origine","orizzonte","orma","ormeggio","ornativo","orologio","orrendo","orribile","ortensia","ortica","orzata","orzo","osare","oscurare","osmosi","ospedale","ospite","ossa","ossidare","ostacolo","oste","otite","otre","ottagono","ottimo","ottobre","ovale","ovest","ovino","oviparo","ovocito","ovunque","ovviare","ozio","pacchetto","pace","pacifico","padella","padrone","paese","paga","pagina","palazzina","palesare","pallido","palo","palude","pandoro","pannello","paolo","paonazzo","paprica","parabola","parcella","parere","pargolo","pari","parlato","parola","partire","parvenza","parziale","passivo","pasticca","patacca","patologia","pattume","pavone","peccato","pedalare","pedonale","peggio","peloso","penare","pendice","penisola","pennuto","penombra","pensare","pentola","pepe","pepita","perbene","percorso","perdonato","perforare","pergamena","periodo","permesso","perno","perplesso","persuaso","pertugio","pervaso","pesatore","pesista","peso","pestifero","petalo","pettine","petulante","pezzo","piacere","pianta","piattino","piccino","picozza","piega","pietra","piffero","pigiama","pigolio","pigro","pila","pilifero","pillola","pilota","pimpante","pineta","pinna","pinolo","pioggia","piombo","piramide","piretico","pirite","pirolisi","pitone","pizzico","placebo","planare","plasma","platano","plenario","pochezza","poderoso","podismo","poesia","poggiare","polenta","poligono","pollice","polmonite","polpetta","polso","poltrona","polvere","pomice","pomodoro","ponte","popoloso","porfido","poroso","porpora","porre","portata","posa","positivo","possesso","postulato","potassio","potere","pranzo","prassi","pratica","precluso","predica","prefisso","pregiato","prelievo","premere","prenotare","preparato","presenza","pretesto","prevalso","prima","principe","privato","problema","procura","produrre","profumo","progetto","prolunga","promessa","pronome","proposta","proroga","proteso","prova","prudente","prugna","prurito","psiche","pubblico","pudica","pugilato","pugno","pulce","pulito","pulsante","puntare","pupazzo","pupilla","puro","quadro","qualcosa","quasi","querela","quota","raccolto","raddoppio","radicale","radunato","raffica","ragazzo","ragione","ragno","ramarro","ramingo","ramo","randagio","rantolare","rapato","rapina","rappreso","rasatura","raschiato","rasente","rassegna","rastrello","rata","ravveduto","reale","recepire","recinto","recluta","recondito","recupero","reddito","redimere","regalato","registro","regola","regresso","relazione","remare","remoto","renna","replica","reprimere","reputare","resa","residente","responso","restauro","rete","retina","retorica","rettifica","revocato","riassunto","ribadire","ribelle","ribrezzo","ricarica","ricco","ricevere","riciclato","ricordo","ricreduto","ridicolo","ridurre","rifasare","riflesso","riforma","rifugio","rigare","rigettato","righello","rilassato","rilevato","rimanere","rimbalzo","rimedio","rimorchio","rinascita","rincaro","rinforzo","rinnovo","rinomato","rinsavito","rintocco","rinuncia","rinvenire","riparato","ripetuto","ripieno","riportare","ripresa","ripulire","risata","rischio","riserva","risibile","riso","rispetto","ristoro","risultato","risvolto","ritardo","ritegno","ritmico","ritrovo","riunione","riva","riverso","rivincita","rivolto","rizoma","roba","robotico","robusto","roccia","roco","rodaggio","rodere","roditore","rogito","rollio","romantico","rompere","ronzio","rosolare","rospo","rotante","rotondo","rotula","rovescio","rubizzo","rubrica","ruga","rullino","rumine","rumoroso","ruolo","rupe","russare","rustico","sabato","sabbiare","sabotato","sagoma","salasso","saldatura","salgemma","salivare","salmone","salone","saltare","saluto","salvo","sapere","sapido","saporito","saraceno","sarcasmo","sarto","sassoso","satellite","satira","satollo","saturno","savana","savio","saziato","sbadiglio","sbalzo","sbancato","sbarra","sbattere","sbavare","sbendare","sbirciare","sbloccato","sbocciato","sbrinare","sbruffone","sbuffare","scabroso","scadenza","scala","scambiare","scandalo","scapola","scarso","scatenare","scavato","scelto","scenico","scettro","scheda","schiena","sciarpa","scienza","scindere","scippo","sciroppo","scivolo","sclerare","scodella","scolpito","scomparto","sconforto","scoprire","scorta","scossone","scozzese","scriba","scrollare","scrutinio","scuderia","scultore","scuola","scuro","scusare","sdebitare","sdoganare","seccatura","secondo","sedano","seggiola","segnalato","segregato","seguito","selciato","selettivo","sella","selvaggio","semaforo","sembrare","seme","seminato","sempre","senso","sentire","sepolto","sequenza","serata","serbato","sereno","serio","serpente","serraglio","servire","sestina","setola","settimana","sfacelo","sfaldare","sfamato","sfarzoso","sfaticato","sfera","sfida","sfilato","sfinge","sfocato","sfoderare","sfogo","sfoltire","sforzato","sfratto","sfruttato","sfuggito","sfumare","sfuso","sgabello","sgarbato","sgonfiare","sgorbio","sgrassato","sguardo","sibilo","siccome","sierra","sigla","signore","silenzio","sillaba","simbolo","simpatico","simulato","sinfonia","singolo","sinistro","sino","sintesi","sinusoide","sipario","sisma","sistole","situato","slitta","slogatura","sloveno","smarrito","smemorato","smentito","smeraldo","smilzo","smontare","smottato","smussato","snellire","snervato","snodo","sobbalzo","sobrio","soccorso","sociale","sodale","soffitto","sogno","soldato","solenne","solido","sollazzo","solo","solubile","solvente","somatico","somma","sonda","sonetto","sonnifero","sopire","soppeso","sopra","sorgere","sorpasso","sorriso","sorso","sorteggio","sorvolato","sospiro","sosta","sottile","spada","spalla","spargere","spatola","spavento","spazzola","specie","spedire","spegnere","spelatura","speranza","spessore","spettrale","spezzato","spia","spigoloso","spillato","spinoso","spirale","splendido","sportivo","sposo","spranga","sprecare","spronato","spruzzo","spuntino","squillo","sradicare","srotolato","stabile","stacco","staffa","stagnare","stampato","stantio","starnuto","stasera","statuto","stelo","steppa","sterzo","stiletto","stima","stirpe","stivale","stizzoso","stonato","storico","strappo","stregato","stridulo","strozzare","strutto","stuccare","stufo","stupendo","subentro","succoso","sudore","suggerito","sugo","sultano","suonare","superbo","supporto","surgelato","surrogato","sussurro","sutura","svagare","svedese","sveglio","svelare","svenuto","svezia","sviluppo","svista","svizzera","svolta","svuotare","tabacco","tabulato","tacciare","taciturno","tale","talismano","tampone","tannino","tara","tardivo","targato","tariffa","tarpare","tartaruga","tasto","tattico","taverna","tavolata","tazza","teca","tecnico","telefono","temerario","tempo","temuto","tendone","tenero","tensione","tentacolo","teorema","terme","terrazzo","terzetto","tesi","tesserato","testato","tetro","tettoia","tifare","tigella","timbro","tinto","tipico","tipografo","tiraggio","tiro","titanio","titolo","titubante","tizio","tizzone","toccare","tollerare","tolto","tombola","tomo","tonfo","tonsilla","topazio","topologia","toppa","torba","tornare","torrone","tortora","toscano","tossire","tostatura","totano","trabocco","trachea","trafila","tragedia","tralcio","tramonto","transito","trapano","trarre","trasloco","trattato","trave","treccia","tremolio","trespolo","tributo","tricheco","trifoglio","trillo","trincea","trio","tristezza","triturato","trivella","tromba","trono","troppo","trottola","trovare","truccato","tubatura","tuffato","tulipano","tumulto","tunisia","turbare","turchino","tuta","tutela","ubicato","uccello","uccisore","udire","uditivo","uffa","ufficio","uguale","ulisse","ultimato","umano","umile","umorismo","uncinetto","ungere","ungherese","unicorno","unificato","unisono","unitario","unte","uovo","upupa","uragano","urgenza","urlo","usanza","usato","uscito","usignolo","usuraio","utensile","utilizzo","utopia","vacante","vaccinato","vagabondo","vagliato","valanga","valgo","valico","valletta","valoroso","valutare","valvola","vampata","vangare","vanitoso","vano","vantaggio","vanvera","vapore","varano","varcato","variante","vasca","vedetta","vedova","veduto","vegetale","veicolo","velcro","velina","velluto","veloce","venato","vendemmia","vento","verace","verbale","vergogna","verifica","vero","verruca","verticale","vescica","vessillo","vestale","veterano","vetrina","vetusto","viandante","vibrante","vicenda","vichingo","vicinanza","vidimare","vigilia","vigneto","vigore","vile","villano","vimini","vincitore","viola","vipera","virgola","virologo","virulento","viscoso","visione","vispo","vissuto","visura","vita","vitello","vittima","vivanda","vivido","viziare","voce","voga","volatile","volere","volpe","voragine","vulcano","zampogna","zanna","zappato","zattera","zavorra","zefiro","zelante","zelo","zenzero","zerbino","zibetto","zinco","zircone","zitto","zolla","zotico","zucchero","zufolo","zulu","zuppa"]');

});

parcelRegister("911oV", function(module, exports) {
module.exports = JSON.parse('["a\u0301baco","abdomen","abeja","abierto","abogado","abono","aborto","abrazo","abrir","abuelo","abuso","acabar","academia","acceso","accio\u0301n","aceite","acelga","acento","aceptar","a\u0301cido","aclarar","acne\u0301","acoger","acoso","activo","acto","actriz","actuar","acudir","acuerdo","acusar","adicto","admitir","adoptar","adorno","aduana","adulto","ae\u0301reo","afectar","aficio\u0301n","afinar","afirmar","a\u0301gil","agitar","agoni\u0301a","agosto","agotar","agregar","agrio","agua","agudo","a\u0301guila","aguja","ahogo","ahorro","aire","aislar","ajedrez","ajeno","ajuste","alacra\u0301n","alambre","alarma","alba","a\u0301lbum","alcalde","aldea","alegre","alejar","alerta","aleta","alfiler","alga","algodo\u0301n","aliado","aliento","alivio","alma","almeja","almi\u0301bar","altar","alteza","altivo","alto","altura","alumno","alzar","amable","amante","amapola","amargo","amasar","a\u0301mbar","a\u0301mbito","ameno","amigo","amistad","amor","amparo","amplio","ancho","anciano","ancla","andar","ande\u0301n","anemia","a\u0301ngulo","anillo","a\u0301nimo","ani\u0301s","anotar","antena","antiguo","antojo","anual","anular","anuncio","an\u0303adir","an\u0303ejo","an\u0303o","apagar","aparato","apetito","apio","aplicar","apodo","aporte","apoyo","aprender","aprobar","apuesta","apuro","arado","aran\u0303a","arar","a\u0301rbitro","a\u0301rbol","arbusto","archivo","arco","arder","ardilla","arduo","a\u0301rea","a\u0301rido","aries","armoni\u0301a","arne\u0301s","aroma","arpa","arpo\u0301n","arreglo","arroz","arruga","arte","artista","asa","asado","asalto","ascenso","asegurar","aseo","asesor","asiento","asilo","asistir","asno","asombro","a\u0301spero","astilla","astro","astuto","asumir","asunto","atajo","ataque","atar","atento","ateo","a\u0301tico","atleta","a\u0301tomo","atraer","atroz","atu\u0301n","audaz","audio","auge","aula","aumento","ausente","autor","aval","avance","avaro","ave","avellana","avena","avestruz","avio\u0301n","aviso","ayer","ayuda","ayuno","azafra\u0301n","azar","azote","azu\u0301car","azufre","azul","baba","babor","bache","bahi\u0301a","baile","bajar","balanza","balco\u0301n","balde","bambu\u0301","banco","banda","ban\u0303o","barba","barco","barniz","barro","ba\u0301scula","basto\u0301n","basura","batalla","bateri\u0301a","batir","batuta","bau\u0301l","bazar","bebe\u0301","bebida","bello","besar","beso","bestia","bicho","bien","bingo","blanco","bloque","blusa","boa","bobina","bobo","boca","bocina","boda","bodega","boina","bola","bolero","bolsa","bomba","bondad","bonito","bono","bonsa\u0301i","borde","borrar","bosque","bote","boti\u0301n","bo\u0301veda","bozal","bravo","brazo","brecha","breve","brillo","brinco","brisa","broca","broma","bronce","brote","bruja","brusco","bruto","buceo","bucle","bueno","buey","bufanda","bufo\u0301n","bu\u0301ho","buitre","bulto","burbuja","burla","burro","buscar","butaca","buzo\u0301n","caballo","cabeza","cabina","cabra","cacao","cada\u0301ver","cadena","caer","cafe\u0301","cai\u0301da","caima\u0301n","caja","cajo\u0301n","cal","calamar","calcio","caldo","calidad","calle","calma","calor","calvo","cama","cambio","camello","camino","campo","ca\u0301ncer","candil","canela","canguro","canica","canto","can\u0303a","can\u0303o\u0301n","caoba","caos","capaz","capita\u0301n","capote","captar","capucha","cara","carbo\u0301n","ca\u0301rcel","careta","carga","carin\u0303o","carne","carpeta","carro","carta","casa","casco","casero","caspa","castor","catorce","catre","caudal","causa","cazo","cebolla","ceder","cedro","celda","ce\u0301lebre","celoso","ce\u0301lula","cemento","ceniza","centro","cerca","cerdo","cereza","cero","cerrar","certeza","ce\u0301sped","cetro","chacal","chaleco","champu\u0301","chancla","chapa","charla","chico","chiste","chivo","choque","choza","chuleta","chupar","ciclo\u0301n","ciego","cielo","cien","cierto","cifra","cigarro","cima","cinco","cine","cinta","cipre\u0301s","circo","ciruela","cisne","cita","ciudad","clamor","clan","claro","clase","clave","cliente","clima","cli\u0301nica","cobre","coccio\u0301n","cochino","cocina","coco","co\u0301digo","codo","cofre","coger","cohete","coji\u0301n","cojo","cola","colcha","colegio","colgar","colina","collar","colmo","columna","combate","comer","comida","co\u0301modo","compra","conde","conejo","conga","conocer","consejo","contar","copa","copia","corazo\u0301n","corbata","corcho","cordo\u0301n","corona","correr","coser","cosmos","costa","cra\u0301neo","cra\u0301ter","crear","crecer","crei\u0301do","crema","cri\u0301a","crimen","cripta","crisis","cromo","cro\u0301nica","croqueta","crudo","cruz","cuadro","cuarto","cuatro","cubo","cubrir","cuchara","cuello","cuento","cuerda","cuesta","cueva","cuidar","culebra","culpa","culto","cumbre","cumplir","cuna","cuneta","cuota","cupo\u0301n","cu\u0301pula","curar","curioso","curso","curva","cutis","dama","danza","dar","dardo","da\u0301til","deber","de\u0301bil","de\u0301cada","decir","dedo","defensa","definir","dejar","delfi\u0301n","delgado","delito","demora","denso","dental","deporte","derecho","derrota","desayuno","deseo","desfile","desnudo","destino","desvi\u0301o","detalle","detener","deuda","di\u0301a","diablo","diadema","diamante","diana","diario","dibujo","dictar","diente","dieta","diez","difi\u0301cil","digno","dilema","diluir","dinero","directo","dirigir","disco","disen\u0303o","disfraz","diva","divino","doble","doce","dolor","domingo","don","donar","dorado","dormir","dorso","dos","dosis","drago\u0301n","droga","ducha","duda","duelo","duen\u0303o","dulce","du\u0301o","duque","durar","dureza","duro","e\u0301bano","ebrio","echar","eco","ecuador","edad","edicio\u0301n","edificio","editor","educar","efecto","eficaz","eje","ejemplo","elefante","elegir","elemento","elevar","elipse","e\u0301lite","elixir","elogio","eludir","embudo","emitir","emocio\u0301n","empate","empen\u0303o","empleo","empresa","enano","encargo","enchufe","enci\u0301a","enemigo","enero","enfado","enfermo","engan\u0303o","enigma","enlace","enorme","enredo","ensayo","ensen\u0303ar","entero","entrar","envase","envi\u0301o","e\u0301poca","equipo","erizo","escala","escena","escolar","escribir","escudo","esencia","esfera","esfuerzo","espada","espejo","espi\u0301a","esposa","espuma","esqui\u0301","estar","este","estilo","estufa","etapa","eterno","e\u0301tica","etnia","evadir","evaluar","evento","evitar","exacto","examen","exceso","excusa","exento","exigir","exilio","existir","e\u0301xito","experto","explicar","exponer","extremo","fa\u0301brica","fa\u0301bula","fachada","fa\u0301cil","factor","faena","faja","falda","fallo","falso","faltar","fama","familia","famoso","farao\u0301n","farmacia","farol","farsa","fase","fatiga","fauna","favor","fax","febrero","fecha","feliz","feo","feria","feroz","fe\u0301rtil","fervor","festi\u0301n","fiable","fianza","fiar","fibra","ficcio\u0301n","ficha","fideo","fiebre","fiel","fiera","fiesta","figura","fijar","fijo","fila","filete","filial","filtro","fin","finca","fingir","finito","firma","flaco","flauta","flecha","flor","flota","fluir","flujo","flu\u0301or","fobia","foca","fogata","fogo\u0301n","folio","folleto","fondo","forma","forro","fortuna","forzar","fosa","foto","fracaso","fra\u0301gil","franja","frase","fraude","frei\u0301r","freno","fresa","fri\u0301o","frito","fruta","fuego","fuente","fuerza","fuga","fumar","funcio\u0301n","funda","furgo\u0301n","furia","fusil","fu\u0301tbol","futuro","gacela","gafas","gaita","gajo","gala","galeri\u0301a","gallo","gamba","ganar","gancho","ganga","ganso","garaje","garza","gasolina","gastar","gato","gavila\u0301n","gemelo","gemir","gen","ge\u0301nero","genio","gente","geranio","gerente","germen","gesto","gigante","gimnasio","girar","giro","glaciar","globo","gloria","gol","golfo","goloso","golpe","goma","gordo","gorila","gorra","gota","goteo","gozar","grada","gra\u0301fico","grano","grasa","gratis","grave","grieta","grillo","gripe","gris","grito","grosor","gru\u0301a","grueso","grumo","grupo","guante","guapo","guardia","guerra","gui\u0301a","guin\u0303o","guion","guiso","guitarra","gusano","gustar","haber","ha\u0301bil","hablar","hacer","hacha","hada","hallar","hamaca","harina","haz","hazan\u0303a","hebilla","hebra","hecho","helado","helio","hembra","herir","hermano","he\u0301roe","hervir","hielo","hierro","hi\u0301gado","higiene","hijo","himno","historia","hocico","hogar","hoguera","hoja","hombre","hongo","honor","honra","hora","hormiga","horno","hostil","hoyo","hueco","huelga","huerta","hueso","huevo","huida","huir","humano","hu\u0301medo","humilde","humo","hundir","huraca\u0301n","hurto","icono","ideal","idioma","i\u0301dolo","iglesia","iglu\u0301","igual","ilegal","ilusio\u0301n","imagen","ima\u0301n","imitar","impar","imperio","imponer","impulso","incapaz","i\u0301ndice","inerte","infiel","informe","ingenio","inicio","inmenso","inmune","innato","insecto","instante","intere\u0301s","i\u0301ntimo","intuir","inu\u0301til","invierno","ira","iris","ironi\u0301a","isla","islote","jabali\u0301","jabo\u0301n","jamo\u0301n","jarabe","jardi\u0301n","jarra","jaula","jazmi\u0301n","jefe","jeringa","jinete","jornada","joroba","joven","joya","juerga","jueves","juez","jugador","jugo","juguete","juicio","junco","jungla","junio","juntar","ju\u0301piter","jurar","justo","juvenil","juzgar","kilo","koala","labio","lacio","lacra","lado","ladro\u0301n","lagarto","la\u0301grima","laguna","laico","lamer","la\u0301mina","la\u0301mpara","lana","lancha","langosta","lanza","la\u0301piz","largo","larva","la\u0301stima","lata","la\u0301tex","latir","laurel","lavar","lazo","leal","leccio\u0301n","leche","lector","leer","legio\u0301n","legumbre","lejano","lengua","lento","len\u0303a","leo\u0301n","leopardo","lesio\u0301n","letal","letra","leve","leyenda","libertad","libro","licor","li\u0301der","lidiar","lienzo","liga","ligero","lima","li\u0301mite","limo\u0301n","limpio","lince","lindo","li\u0301nea","lingote","lino","linterna","li\u0301quido","liso","lista","litera","litio","litro","llaga","llama","llanto","llave","llegar","llenar","llevar","llorar","llover","lluvia","lobo","locio\u0301n","loco","locura","lo\u0301gica","logro","lombriz","lomo","lonja","lote","lucha","lucir","lugar","lujo","luna","lunes","lupa","lustro","luto","luz","maceta","macho","madera","madre","maduro","maestro","mafia","magia","mago","mai\u0301z","maldad","maleta","malla","malo","mama\u0301","mambo","mamut","manco","mando","manejar","manga","maniqui\u0301","manjar","mano","manso","manta","man\u0303ana","mapa","ma\u0301quina","mar","marco","marea","marfil","margen","marido","ma\u0301rmol","marro\u0301n","martes","marzo","masa","ma\u0301scara","masivo","matar","materia","matiz","matriz","ma\u0301ximo","mayor","mazorca","mecha","medalla","medio","me\u0301dula","mejilla","mejor","melena","melo\u0301n","memoria","menor","mensaje","mente","menu\u0301","mercado","merengue","me\u0301rito","mes","meso\u0301n","meta","meter","me\u0301todo","metro","mezcla","miedo","miel","miembro","miga","mil","milagro","militar","millo\u0301n","mimo","mina","minero","mi\u0301nimo","minuto","miope","mirar","misa","miseria","misil","mismo","mitad","mito","mochila","mocio\u0301n","moda","modelo","moho","mojar","molde","moler","molino","momento","momia","monarca","moneda","monja","monto","mon\u0303o","morada","morder","moreno","morir","morro","morsa","mortal","mosca","mostrar","motivo","mover","mo\u0301vil","mozo","mucho","mudar","mueble","muela","muerte","muestra","mugre","mujer","mula","muleta","multa","mundo","mun\u0303eca","mural","muro","mu\u0301sculo","museo","musgo","mu\u0301sica","muslo","na\u0301car","nacio\u0301n","nadar","naipe","naranja","nariz","narrar","nasal","natal","nativo","natural","na\u0301usea","naval","nave","navidad","necio","ne\u0301ctar","negar","negocio","negro","neo\u0301n","nervio","neto","neutro","nevar","nevera","nicho","nido","niebla","nieto","nin\u0303ez","nin\u0303o","ni\u0301tido","nivel","nobleza","noche","no\u0301mina","noria","norma","norte","nota","noticia","novato","novela","novio","nube","nuca","nu\u0301cleo","nudillo","nudo","nuera","nueve","nuez","nulo","nu\u0301mero","nutria","oasis","obeso","obispo","objeto","obra","obrero","observar","obtener","obvio","oca","ocaso","oce\u0301ano","ochenta","ocho","ocio","ocre","octavo","octubre","oculto","ocupar","ocurrir","odiar","odio","odisea","oeste","ofensa","oferta","oficio","ofrecer","ogro","oi\u0301do","oi\u0301r","ojo","ola","oleada","olfato","olivo","olla","olmo","olor","olvido","ombligo","onda","onza","opaco","opcio\u0301n","o\u0301pera","opinar","oponer","optar","o\u0301ptica","opuesto","oracio\u0301n","orador","oral","o\u0301rbita","orca","orden","oreja","o\u0301rgano","orgi\u0301a","orgullo","oriente","origen","orilla","oro","orquesta","oruga","osadi\u0301a","oscuro","osezno","oso","ostra","oton\u0303o","otro","oveja","o\u0301vulo","o\u0301xido","oxi\u0301geno","oyente","ozono","pacto","padre","paella","pa\u0301gina","pago","pai\u0301s","pa\u0301jaro","palabra","palco","paleta","pa\u0301lido","palma","paloma","palpar","pan","panal","pa\u0301nico","pantera","pan\u0303uelo","papa\u0301","papel","papilla","paquete","parar","parcela","pared","parir","paro","pa\u0301rpado","parque","pa\u0301rrafo","parte","pasar","paseo","pasio\u0301n","paso","pasta","pata","patio","patria","pausa","pauta","pavo","payaso","peato\u0301n","pecado","pecera","pecho","pedal","pedir","pegar","peine","pelar","peldan\u0303o","pelea","peligro","pellejo","pelo","peluca","pena","pensar","pen\u0303o\u0301n","peo\u0301n","peor","pepino","pequen\u0303o","pera","percha","perder","pereza","perfil","perico","perla","permiso","perro","persona","pesa","pesca","pe\u0301simo","pestan\u0303a","pe\u0301talo","petro\u0301leo","pez","pezun\u0303a","picar","picho\u0301n","pie","piedra","pierna","pieza","pijama","pilar","piloto","pimienta","pino","pintor","pinza","pin\u0303a","piojo","pipa","pirata","pisar","piscina","piso","pista","pito\u0301n","pizca","placa","plan","plata","playa","plaza","pleito","pleno","plomo","pluma","plural","pobre","poco","poder","podio","poema","poesi\u0301a","poeta","polen","polici\u0301a","pollo","polvo","pomada","pomelo","pomo","pompa","poner","porcio\u0301n","portal","posada","poseer","posible","poste","potencia","potro","pozo","prado","precoz","pregunta","premio","prensa","preso","previo","primo","pri\u0301ncipe","prisio\u0301n","privar","proa","probar","proceso","producto","proeza","profesor","programa","prole","promesa","pronto","propio","pro\u0301ximo","prueba","pu\u0301blico","puchero","pudor","pueblo","puerta","puesto","pulga","pulir","pulmo\u0301n","pulpo","pulso","puma","punto","pun\u0303al","pun\u0303o","pupa","pupila","pure\u0301","quedar","queja","quemar","querer","queso","quieto","qui\u0301mica","quince","quitar","ra\u0301bano","rabia","rabo","racio\u0301n","radical","rai\u0301z","rama","rampa","rancho","rango","rapaz","ra\u0301pido","rapto","rasgo","raspa","rato","rayo","raza","razo\u0301n","reaccio\u0301n","realidad","reban\u0303o","rebote","recaer","receta","rechazo","recoger","recreo","recto","recurso","red","redondo","reducir","reflejo","reforma","refra\u0301n","refugio","regalo","regir","regla","regreso","rehe\u0301n","reino","rei\u0301r","reja","relato","relevo","relieve","relleno","reloj","remar","remedio","remo","rencor","rendir","renta","reparto","repetir","reposo","reptil","res","rescate","resina","respeto","resto","resumen","retiro","retorno","retrato","reunir","reve\u0301s","revista","rey","rezar","rico","riego","rienda","riesgo","rifa","ri\u0301gido","rigor","rinco\u0301n","rin\u0303o\u0301n","ri\u0301o","riqueza","risa","ritmo","rito","rizo","roble","roce","rociar","rodar","rodeo","rodilla","roer","rojizo","rojo","romero","romper","ron","ronco","ronda","ropa","ropero","rosa","rosca","rostro","rotar","rubi\u0301","rubor","rudo","rueda","rugir","ruido","ruina","ruleta","rulo","rumbo","rumor","ruptura","ruta","rutina","sa\u0301bado","saber","sabio","sable","sacar","sagaz","sagrado","sala","saldo","salero","salir","salmo\u0301n","salo\u0301n","salsa","salto","salud","salvar","samba","sancio\u0301n","sandi\u0301a","sanear","sangre","sanidad","sano","santo","sapo","saque","sardina","sarte\u0301n","sastre","sata\u0301n","sauna","saxofo\u0301n","seccio\u0301n","seco","secreto","secta","sed","seguir","seis","sello","selva","semana","semilla","senda","sensor","sen\u0303al","sen\u0303or","separar","sepia","sequi\u0301a","ser","serie","sermo\u0301n","servir","sesenta","sesio\u0301n","seta","setenta","severo","sexo","sexto","sidra","siesta","siete","siglo","signo","si\u0301laba","silbar","silencio","silla","si\u0301mbolo","simio","sirena","sistema","sitio","situar","sobre","socio","sodio","sol","solapa","soldado","soledad","so\u0301lido","soltar","solucio\u0301n","sombra","sondeo","sonido","sonoro","sonrisa","sopa","soplar","soporte","sordo","sorpresa","sorteo","soste\u0301n","so\u0301tano","suave","subir","suceso","sudor","suegra","suelo","suen\u0303o","suerte","sufrir","sujeto","sulta\u0301n","sumar","superar","suplir","suponer","supremo","sur","surco","suren\u0303o","surgir","susto","sutil","tabaco","tabique","tabla","tabu\u0301","taco","tacto","tajo","talar","talco","talento","talla","talo\u0301n","taman\u0303o","tambor","tango","tanque","tapa","tapete","tapia","tapo\u0301n","taquilla","tarde","tarea","tarifa","tarjeta","tarot","tarro","tarta","tatuaje","tauro","taza","tazo\u0301n","teatro","techo","tecla","te\u0301cnica","tejado","tejer","tejido","tela","tele\u0301fono","tema","temor","templo","tenaz","tender","tener","tenis","tenso","teori\u0301a","terapia","terco","te\u0301rmino","ternura","terror","tesis","tesoro","testigo","tetera","texto","tez","tibio","tiburo\u0301n","tiempo","tienda","tierra","tieso","tigre","tijera","tilde","timbre","ti\u0301mido","timo","tinta","ti\u0301o","ti\u0301pico","tipo","tira","tiro\u0301n","tita\u0301n","ti\u0301tere","ti\u0301tulo","tiza","toalla","tobillo","tocar","tocino","todo","toga","toldo","tomar","tono","tonto","topar","tope","toque","to\u0301rax","torero","tormenta","torneo","toro","torpedo","torre","torso","tortuga","tos","tosco","toser","to\u0301xico","trabajo","tractor","traer","tra\u0301fico","trago","traje","tramo","trance","trato","trauma","trazar","tre\u0301bol","tregua","treinta","tren","trepar","tres","tribu","trigo","tripa","triste","triunfo","trofeo","trompa","tronco","tropa","trote","trozo","truco","trueno","trufa","tuberi\u0301a","tubo","tuerto","tumba","tumor","tu\u0301nel","tu\u0301nica","turbina","turismo","turno","tutor","ubicar","u\u0301lcera","umbral","unidad","unir","universo","uno","untar","un\u0303a","urbano","urbe","urgente","urna","usar","usuario","u\u0301til","utopi\u0301a","uva","vaca","vaci\u0301o","vacuna","vagar","vago","vaina","vajilla","vale","va\u0301lido","valle","valor","va\u0301lvula","vampiro","vara","variar","varo\u0301n","vaso","vecino","vector","vehi\u0301culo","veinte","vejez","vela","velero","veloz","vena","vencer","venda","veneno","vengar","venir","venta","venus","ver","verano","verbo","verde","vereda","verja","verso","verter","vi\u0301a","viaje","vibrar","vicio","vi\u0301ctima","vida","vi\u0301deo","vidrio","viejo","viernes","vigor","vil","villa","vinagre","vino","vin\u0303edo","violi\u0301n","viral","virgo","virtud","visor","vi\u0301spera","vista","vitamina","viudo","vivaz","vivero","vivir","vivo","volca\u0301n","volumen","volver","voraz","votar","voto","voz","vuelo","vulgar","yacer","yate","yegua","yema","yerno","yeso","yodo","yoga","yogur","zafiro","zanja","zapato","zarza","zona","zorro","zumo","zurdo"]');

});

parcelRegister("lW32h", function(module, exports) {
module.exports = JSON.parse('["\u3042\u3044\u3053\u304F\u3057\u3093","\u3042\u3044\u3055\u3064","\u3042\u3044\u305F\u3099","\u3042\u304A\u305D\u3099\u3089","\u3042\u304B\u3061\u3083\u3093","\u3042\u304D\u308B","\u3042\u3051\u304B\u3099\u305F","\u3042\u3051\u308B","\u3042\u3053\u304B\u3099\u308C\u308B","\u3042\u3055\u3044","\u3042\u3055\u3072","\u3042\u3057\u3042\u3068","\u3042\u3057\u3099\u308F\u3046","\u3042\u3059\u3099\u304B\u308B","\u3042\u3059\u3099\u304D","\u3042\u305D\u3075\u3099","\u3042\u305F\u3048\u308B","\u3042\u305F\u305F\u3081\u308B","\u3042\u305F\u308A\u307E\u3048","\u3042\u305F\u308B","\u3042\u3064\u3044","\u3042\u3064\u304B\u3046","\u3042\u3063\u3057\u3085\u304F","\u3042\u3064\u307E\u308A","\u3042\u3064\u3081\u308B","\u3042\u3066\u306A","\u3042\u3066\u306F\u307E\u308B","\u3042\u3072\u308B","\u3042\u3075\u3099\u3089","\u3042\u3075\u3099\u308B","\u3042\u3075\u308C\u308B","\u3042\u307E\u3044","\u3042\u307E\u3068\u3099","\u3042\u307E\u3084\u304B\u3059","\u3042\u307E\u308A","\u3042\u307F\u3082\u306E","\u3042\u3081\u308A\u304B","\u3042\u3084\u307E\u308B","\u3042\u3086\u3080","\u3042\u3089\u3044\u304F\u3099\u307E","\u3042\u3089\u3057","\u3042\u3089\u3059\u3057\u3099","\u3042\u3089\u305F\u3081\u308B","\u3042\u3089\u3086\u308B","\u3042\u3089\u308F\u3059","\u3042\u308A\u304B\u3099\u3068\u3046","\u3042\u308F\u305B\u308B","\u3042\u308F\u3066\u308B","\u3042\u3093\u3044","\u3042\u3093\u304B\u3099\u3044","\u3042\u3093\u3053","\u3042\u3093\u305B\u3099\u3093","\u3042\u3093\u3066\u3044","\u3042\u3093\u306A\u3044","\u3042\u3093\u307E\u308A","\u3044\u3044\u305F\u3099\u3059","\u3044\u304A\u3093","\u3044\u304B\u3099\u3044","\u3044\u304B\u3099\u304F","\u3044\u304D\u304A\u3044","\u3044\u304D\u306A\u308A","\u3044\u304D\u3082\u306E","\u3044\u304D\u308B","\u3044\u304F\u3057\u3099","\u3044\u304F\u3075\u3099\u3093","\u3044\u3051\u306F\u3099\u306A","\u3044\u3051\u3093","\u3044\u3053\u3046","\u3044\u3053\u304F","\u3044\u3053\u3064","\u3044\u3055\u307E\u3057\u3044","\u3044\u3055\u3093","\u3044\u3057\u304D","\u3044\u3057\u3099\u3085\u3046","\u3044\u3057\u3099\u3087\u3046","\u3044\u3057\u3099\u308F\u308B","\u3044\u3059\u3099\u307F","\u3044\u3059\u3099\u308C","\u3044\u305B\u3044","\u3044\u305B\u3048\u3072\u3099","\u3044\u305B\u304B\u3044","\u3044\u305B\u304D","\u3044\u305B\u3099\u3093","\u3044\u305D\u3046\u308D\u3046","\u3044\u305D\u304B\u3099\u3057\u3044","\u3044\u305F\u3099\u3044","\u3044\u305F\u3099\u304F","\u3044\u305F\u3059\u3099\u3089","\u3044\u305F\u307F","\u3044\u305F\u308A\u3042","\u3044\u3061\u304A\u3046","\u3044\u3061\u3057\u3099","\u3044\u3061\u3068\u3099","\u3044\u3061\u306F\u3099","\u3044\u3061\u3075\u3099","\u3044\u3061\u308A\u3085\u3046","\u3044\u3064\u304B","\u3044\u3063\u3057\u3085\u3093","\u3044\u3063\u305B\u3044","\u3044\u3063\u305D\u3046","\u3044\u3063\u305F\u3093","\u3044\u3063\u3061","\u3044\u3063\u3066\u3044","\u3044\u3063\u307B\u309A\u3046","\u3044\u3066\u3055\u3099","\u3044\u3066\u3093","\u3044\u3068\u3099\u3046","\u3044\u3068\u3053","\u3044\u306A\u3044","\u3044\u306A\u304B","\u3044\u306D\u3080\u308A","\u3044\u306E\u3061","\u3044\u306E\u308B","\u3044\u306F\u3064","\u3044\u306F\u3099\u308B","\u3044\u306F\u3093","\u3044\u3072\u3099\u304D","\u3044\u3072\u3093","\u3044\u3075\u304F","\u3044\u3078\u3093","\u3044\u307B\u3046","\u3044\u307F\u3093","\u3044\u3082\u3046\u3068","\u3044\u3082\u305F\u308C","\u3044\u3082\u308A","\u3044\u3084\u304B\u3099\u308B","\u3044\u3084\u3059","\u3044\u3088\u304B\u3093","\u3044\u3088\u304F","\u3044\u3089\u3044","\u3044\u3089\u3059\u3068","\u3044\u308A\u304F\u3099\u3061","\u3044\u308A\u3087\u3046","\u3044\u308C\u3044","\u3044\u308C\u3082\u306E","\u3044\u308C\u308B","\u3044\u308D\u3048\u3093\u3072\u309A\u3064","\u3044\u308F\u3044","\u3044\u308F\u3046","\u3044\u308F\u304B\u3093","\u3044\u308F\u306F\u3099","\u3044\u308F\u3086\u308B","\u3044\u3093\u3051\u3099\u3093\u307E\u3081","\u3044\u3093\u3055\u3064","\u3044\u3093\u3057\u3087\u3046","\u3044\u3093\u3088\u3046","\u3046\u3048\u304D","\u3046\u3048\u308B","\u3046\u304A\u3055\u3099","\u3046\u304B\u3099\u3044","\u3046\u304B\u3075\u3099","\u3046\u304B\u3078\u3099\u308B","\u3046\u304D\u308F","\u3046\u304F\u3089\u3044\u306A","\u3046\u304F\u308C\u308C","\u3046\u3051\u305F\u307E\u308F\u308B","\u3046\u3051\u3064\u3051","\u3046\u3051\u3068\u308B","\u3046\u3051\u3082\u3064","\u3046\u3051\u308B","\u3046\u3053\u3099\u304B\u3059","\u3046\u3053\u3099\u304F","\u3046\u3053\u3093","\u3046\u3055\u304D\u3099","\u3046\u3057\u306A\u3046","\u3046\u3057\u308D\u304B\u3099\u307F","\u3046\u3059\u3044","\u3046\u3059\u304D\u3099","\u3046\u3059\u304F\u3099\u3089\u3044","\u3046\u3059\u3081\u308B","\u3046\u305B\u3064","\u3046\u3061\u3042\u308F\u305B","\u3046\u3061\u304B\u3099\u308F","\u3046\u3061\u304D","\u3046\u3061\u3085\u3046","\u3046\u3063\u304B\u308A","\u3046\u3064\u304F\u3057\u3044","\u3046\u3063\u305F\u3048\u308B","\u3046\u3064\u308B","\u3046\u3068\u3099\u3093","\u3046\u306A\u304D\u3099","\u3046\u306A\u3057\u3099","\u3046\u306A\u3059\u3099\u304F","\u3046\u306A\u308B","\u3046\u306D\u308B","\u3046\u306E\u3046","\u3046\u3075\u3099\u3051\u3099","\u3046\u3075\u3099\u3053\u3099\u3048","\u3046\u307E\u308C\u308B","\u3046\u3081\u308B","\u3046\u3082\u3046","\u3046\u3084\u307E\u3046","\u3046\u3088\u304F","\u3046\u3089\u304B\u3099\u3048\u3059","\u3046\u3089\u304F\u3099\u3061","\u3046\u3089\u306A\u3044","\u3046\u308A\u3042\u3051\u3099","\u3046\u308A\u304D\u308C","\u3046\u308B\u3055\u3044","\u3046\u308C\u3057\u3044","\u3046\u308C\u3086\u304D","\u3046\u308C\u308B","\u3046\u308D\u3053","\u3046\u308F\u304D","\u3046\u308F\u3055","\u3046\u3093\u3053\u3046","\u3046\u3093\u3061\u3093","\u3046\u3093\u3066\u3093","\u3046\u3093\u3068\u3099\u3046","\u3048\u3044\u3048\u3093","\u3048\u3044\u304B\u3099","\u3048\u3044\u304D\u3087\u3046","\u3048\u3044\u3053\u3099","\u3048\u3044\u305B\u3044","\u3048\u3044\u3075\u3099\u3093","\u3048\u3044\u3088\u3046","\u3048\u3044\u308F","\u3048\u304A\u308A","\u3048\u304B\u3099\u304A","\u3048\u304B\u3099\u304F","\u3048\u304D\u305F\u3044","\u3048\u304F\u305B\u308B","\u3048\u3057\u3083\u304F","\u3048\u3059\u3066","\u3048\u3064\u3089\u3093","\u3048\u306E\u304F\u3099","\u3048\u307B\u3046\u307E\u304D","\u3048\u307B\u3093","\u3048\u307E\u304D","\u3048\u3082\u3057\u3099","\u3048\u3082\u306E","\u3048\u3089\u3044","\u3048\u3089\u3075\u3099","\u3048\u308A\u3042","\u3048\u3093\u3048\u3093","\u3048\u3093\u304B\u3044","\u3048\u3093\u304D\u3099","\u3048\u3093\u3051\u3099\u304D","\u3048\u3093\u3057\u3085\u3046","\u3048\u3093\u305B\u3099\u3064","\u3048\u3093\u305D\u304F","\u3048\u3093\u3061\u3087\u3046","\u3048\u3093\u3068\u3064","\u304A\u3044\u304B\u3051\u308B","\u304A\u3044\u3053\u3059","\u304A\u3044\u3057\u3044","\u304A\u3044\u3064\u304F","\u304A\u3046\u3048\u3093","\u304A\u3046\u3055\u307E","\u304A\u3046\u3057\u3099","\u304A\u3046\u305B\u3064","\u304A\u3046\u305F\u3044","\u304A\u3046\u3075\u304F","\u304A\u3046\u3078\u3099\u3044","\u304A\u3046\u3088\u3046","\u304A\u3048\u308B","\u304A\u304A\u3044","\u304A\u304A\u3046","\u304A\u304A\u3068\u3099\u304A\u308A","\u304A\u304A\u3084","\u304A\u304A\u3088\u305D","\u304A\u304B\u3048\u308A","\u304A\u304B\u3059\u3099","\u304A\u304B\u3099\u3080","\u304A\u304B\u308F\u308A","\u304A\u304D\u3099\u306A\u3046","\u304A\u304D\u308B","\u304A\u304F\u3055\u307E","\u304A\u304F\u3057\u3099\u3087\u3046","\u304A\u304F\u308A\u304B\u3099\u306A","\u304A\u304F\u308B","\u304A\u304F\u308C\u308B","\u304A\u3053\u3059","\u304A\u3053\u306A\u3046","\u304A\u3053\u308B","\u304A\u3055\u3048\u308B","\u304A\u3055\u306A\u3044","\u304A\u3055\u3081\u308B","\u304A\u3057\u3044\u308C","\u304A\u3057\u3048\u308B","\u304A\u3057\u3099\u304D\u3099","\u304A\u3057\u3099\u3055\u3093","\u304A\u3057\u3083\u308C","\u304A\u305D\u3089\u304F","\u304A\u305D\u308F\u308B","\u304A\u305F\u304B\u3099\u3044","\u304A\u305F\u304F","\u304A\u305F\u3099\u3084\u304B","\u304A\u3061\u3064\u304F","\u304A\u3063\u3068","\u304A\u3064\u308A","\u304A\u3066\u3099\u304B\u3051","\u304A\u3068\u3057\u3082\u306E","\u304A\u3068\u306A\u3057\u3044","\u304A\u3068\u3099\u308A","\u304A\u3068\u3099\u308D\u304B\u3059","\u304A\u306F\u3099\u3055\u3093","\u304A\u307E\u3044\u308A","\u304A\u3081\u3066\u3099\u3068\u3046","\u304A\u3082\u3044\u3066\u3099","\u304A\u3082\u3046","\u304A\u3082\u305F\u3044","\u304A\u3082\u3061\u3083","\u304A\u3084\u3064","\u304A\u3084\u3086\u3072\u3099","\u304A\u3088\u307B\u3099\u3059","\u304A\u3089\u3093\u305F\u3099","\u304A\u308D\u3059","\u304A\u3093\u304B\u3099\u304F","\u304A\u3093\u3051\u3044","\u304A\u3093\u3057\u3083","\u304A\u3093\u305B\u3093","\u304A\u3093\u305F\u3099\u3093","\u304A\u3093\u3061\u3085\u3046","\u304A\u3093\u3068\u3099\u3051\u3044","\u304B\u3042\u3064","\u304B\u3044\u304B\u3099","\u304B\u3099\u3044\u304D","\u304B\u3099\u3044\u3051\u3093","\u304B\u3099\u3044\u3053\u3046","\u304B\u3044\u3055\u3064","\u304B\u3044\u3057\u3083","\u304B\u3044\u3059\u3044\u3088\u304F","\u304B\u3044\u305B\u3099\u3093","\u304B\u3044\u305D\u3099\u3046\u3068\u3099","\u304B\u3044\u3064\u3046","\u304B\u3044\u3066\u3093","\u304B\u3044\u3068\u3046","\u304B\u3044\u3075\u304F","\u304B\u3099\u3044\u3078\u304D","\u304B\u3044\u307B\u3046","\u304B\u3044\u3088\u3046","\u304B\u3099\u3044\u3089\u3044","\u304B\u3044\u308F","\u304B\u3048\u308B","\u304B\u304A\u308A","\u304B\u304B\u3048\u308B","\u304B\u304B\u3099\u304F","\u304B\u304B\u3099\u3057","\u304B\u304B\u3099\u307F","\u304B\u304F\u3053\u3099","\u304B\u304F\u3068\u304F","\u304B\u3055\u3099\u308B","\u304B\u3099\u305D\u3099\u3046","\u304B\u305F\u3044","\u304B\u305F\u3061","\u304B\u3099\u3061\u3087\u3046","\u304B\u3099\u3063\u304D\u3085\u3046","\u304B\u3099\u3063\u3053\u3046","\u304B\u3099\u3063\u3055\u3093","\u304B\u3099\u3063\u3057\u3087\u3046","\u304B\u306A\u3055\u3099\u308F\u3057","\u304B\u306E\u3046","\u304B\u3099\u306F\u304F","\u304B\u3075\u3099\u304B","\u304B\u307B\u3046","\u304B\u307B\u3053\u3099","\u304B\u307E\u3046","\u304B\u307E\u307B\u3099\u3053","\u304B\u3081\u308C\u304A\u3093","\u304B\u3086\u3044","\u304B\u3088\u3046\u3072\u3099","\u304B\u3089\u3044","\u304B\u308B\u3044","\u304B\u308D\u3046","\u304B\u308F\u304F","\u304B\u308F\u3089","\u304B\u3099\u3093\u304B","\u304B\u3093\u3051\u3044","\u304B\u3093\u3053\u3046","\u304B\u3093\u3057\u3083","\u304B\u3093\u305D\u3046","\u304B\u3093\u305F\u3093","\u304B\u3093\u3061","\u304B\u3099\u3093\u306F\u3099\u308B","\u304D\u3042\u3044","\u304D\u3042\u3064","\u304D\u3044\u308D","\u304D\u3099\u3044\u3093","\u304D\u3046\u3044","\u304D\u3046\u3093","\u304D\u3048\u308B","\u304D\u304A\u3046","\u304D\u304A\u304F","\u304D\u304A\u3061","\u304D\u304A\u3093","\u304D\u304B\u3044","\u304D\u304B\u304F","\u304D\u304B\u3093\u3057\u3083","\u304D\u304D\u3066","\u304D\u304F\u306F\u3099\u308A","\u304D\u304F\u3089\u3051\u3099","\u304D\u3051\u3093\u305B\u3044","\u304D\u3053\u3046","\u304D\u3053\u3048\u308B","\u304D\u3053\u304F","\u304D\u3055\u3044","\u304D\u3055\u304F","\u304D\u3055\u307E","\u304D\u3055\u3089\u304D\u3099","\u304D\u3099\u3057\u3099\u304B\u304B\u3099\u304F","\u304D\u3099\u3057\u304D","\u304D\u3099\u3057\u3099\u305F\u3044\u3051\u3093","\u304D\u3099\u3057\u3099\u306B\u3063\u3066\u3044","\u304D\u3099\u3057\u3099\u3085\u3064\u3057\u3083","\u304D\u3059\u3046","\u304D\u305B\u3044","\u304D\u305B\u304D","\u304D\u305B\u3064","\u304D\u305D\u3046","\u304D\u305D\u3099\u304F","\u304D\u305D\u3099\u3093","\u304D\u305F\u3048\u308B","\u304D\u3061\u3087\u3046","\u304D\u3064\u3048\u3093","\u304D\u3099\u3063\u3061\u308A","\u304D\u3064\u3064\u304D","\u304D\u3064\u306D","\u304D\u3066\u3044","\u304D\u3068\u3099\u3046","\u304D\u3068\u3099\u304F","\u304D\u306A\u3044","\u304D\u306A\u304B\u3099","\u304D\u306A\u3053","\u304D\u306C\u3053\u3099\u3057","\u304D\u306D\u3093","\u304D\u306E\u3046","\u304D\u306E\u3057\u305F","\u304D\u306F\u304F","\u304D\u3072\u3099\u3057\u3044","\u304D\u3072\u3093","\u304D\u3075\u304F","\u304D\u3075\u3099\u3093","\u304D\u307B\u3099\u3046","\u304D\u307B\u3093","\u304D\u307E\u308B","\u304D\u307F\u3064","\u304D\u3080\u3059\u3099\u304B\u3057\u3044","\u304D\u3081\u308B","\u304D\u3082\u305F\u3099\u3081\u3057","\u304D\u3082\u3061","\u304D\u3082\u306E","\u304D\u3083\u304F","\u304D\u3084\u304F","\u304D\u3099\u3085\u3046\u306B\u304F","\u304D\u3088\u3046","\u304D\u3087\u3046\u308A\u3085\u3046","\u304D\u3089\u3044","\u304D\u3089\u304F","\u304D\u308A\u3093","\u304D\u308C\u3044","\u304D\u308C\u3064","\u304D\u308D\u304F","\u304D\u3099\u308D\u3093","\u304D\u308F\u3081\u308B","\u304D\u3099\u3093\u3044\u308D","\u304D\u3093\u304B\u304F\u3057\u3099","\u304D\u3093\u3057\u3099\u3087","\u304D\u3093\u3088\u3046\u3072\u3099","\u304F\u3099\u3042\u3044","\u304F\u3044\u3059\u3099","\u304F\u3046\u304B\u3093","\u304F\u3046\u304D","\u304F\u3046\u304F\u3099\u3093","\u304F\u3046\u3053\u3046","\u304F\u3099\u3046\u305B\u3044","\u304F\u3046\u305D\u3046","\u304F\u3099\u3046\u305F\u3089","\u304F\u3046\u3075\u304F","\u304F\u3046\u307B\u3099","\u304F\u304B\u3093","\u304F\u304D\u3087\u3046","\u304F\u3051\u3099\u3093","\u304F\u3099\u3053\u3046","\u304F\u3055\u3044","\u304F\u3055\u304D","\u304F\u3055\u306F\u3099\u306A","\u304F\u3055\u308B","\u304F\u3057\u3083\u307F","\u304F\u3057\u3087\u3046","\u304F\u3059\u306E\u304D","\u304F\u3059\u308A\u3086\u3072\u3099","\u304F\u305B\u3051\u3099","\u304F\u305B\u3093","\u304F\u3099\u305F\u3044\u3066\u304D","\u304F\u305F\u3099\u3055\u308B","\u304F\u305F\u3072\u3099\u308C\u308B","\u304F\u3061\u3053\u307F","\u304F\u3061\u3055\u304D","\u304F\u3064\u3057\u305F","\u304F\u3099\u3063\u3059\u308A","\u304F\u3064\u308D\u304F\u3099","\u304F\u3068\u3046\u3066\u3093","\u304F\u3068\u3099\u304F","\u304F\u306A\u3093","\u304F\u306D\u304F\u306D","\u304F\u306E\u3046","\u304F\u3075\u3046","\u304F\u307F\u3042\u308F\u305B","\u304F\u307F\u305F\u3066\u308B","\u304F\u3081\u308B","\u304F\u3084\u304F\u3057\u3087","\u304F\u3089\u3059","\u304F\u3089\u3078\u3099\u308B","\u304F\u308B\u307E","\u304F\u308C\u308B","\u304F\u308D\u3046","\u304F\u308F\u3057\u3044","\u304F\u3099\u3093\u304B\u3093","\u304F\u3099\u3093\u3057\u3087\u304F","\u304F\u3099\u3093\u305F\u3044","\u304F\u3099\u3093\u3066","\u3051\u3042\u306A","\u3051\u3044\u304B\u304F","\u3051\u3044\u3051\u3093","\u3051\u3044\u3053","\u3051\u3044\u3055\u3064","\u3051\u3099\u3044\u3057\u3099\u3085\u3064","\u3051\u3044\u305F\u3044","\u3051\u3099\u3044\u306E\u3046\u3057\u3099\u3093","\u3051\u3044\u308C\u304D","\u3051\u3044\u308D","\u3051\u304A\u3068\u3059","\u3051\u304A\u308A\u3082\u306E","\u3051\u3099\u304D\u304B","\u3051\u3099\u304D\u3051\u3099\u3093","\u3051\u3099\u304D\u305F\u3099\u3093","\u3051\u3099\u304D\u3061\u3093","\u3051\u3099\u304D\u3068\u3064","\u3051\u3099\u304D\u306F","\u3051\u3099\u304D\u3084\u304F","\u3051\u3099\u3053\u3046","\u3051\u3099\u3053\u304F\u3057\u3099\u3087\u3046","\u3051\u3099\u3055\u3099\u3044","\u3051\u3055\u304D","\u3051\u3099\u3055\u3099\u3093","\u3051\u3057\u304D","\u3051\u3057\u3053\u3099\u3080","\u3051\u3057\u3087\u3046","\u3051\u3099\u3059\u3068","\u3051\u305F\u306F\u3099","\u3051\u3061\u3083\u3063\u3075\u309A","\u3051\u3061\u3089\u3059","\u3051\u3064\u3042\u3064","\u3051\u3064\u3044","\u3051\u3064\u3048\u304D","\u3051\u3063\u3053\u3093","\u3051\u3064\u3057\u3099\u3087","\u3051\u3063\u305B\u304D","\u3051\u3063\u3066\u3044","\u3051\u3064\u307E\u3064","\u3051\u3099\u3064\u3088\u3046\u3072\u3099","\u3051\u3099\u3064\u308C\u3044","\u3051\u3064\u308D\u3093","\u3051\u3099\u3068\u3099\u304F","\u3051\u3068\u306F\u3099\u3059","\u3051\u3068\u308B","\u3051\u306A\u3051\u3099","\u3051\u306A\u3059","\u3051\u306A\u307F","\u3051\u306C\u304D","\u3051\u3099\u306D\u3064","\u3051\u306D\u3093","\u3051\u306F\u3044","\u3051\u3099\u3072\u3093","\u3051\u3075\u3099\u304B\u3044","\u3051\u3099\u307B\u3099\u304F","\u3051\u307E\u308A","\u3051\u307F\u304B\u308B","\u3051\u3080\u3057","\u3051\u3080\u308A","\u3051\u3082\u306E","\u3051\u3089\u3044","\u3051\u308D\u3051\u308D","\u3051\u308F\u3057\u3044","\u3051\u3093\u3044","\u3051\u3093\u3048\u3064","\u3051\u3093\u304A","\u3051\u3093\u304B","\u3051\u3099\u3093\u304D","\u3051\u3093\u3051\u3099\u3093","\u3051\u3093\u3053\u3046","\u3051\u3093\u3055\u304F","\u3051\u3093\u3057\u3085\u3046","\u3051\u3093\u3059\u3046","\u3051\u3099\u3093\u305D\u3046","\u3051\u3093\u3061\u304F","\u3051\u3093\u3066\u3044","\u3051\u3093\u3068\u3046","\u3051\u3093\u306A\u3044","\u3051\u3093\u306B\u3093","\u3051\u3099\u3093\u3075\u3099\u3064","\u3051\u3093\u307E","\u3051\u3093\u307F\u3093","\u3051\u3093\u3081\u3044","\u3051\u3093\u3089\u3093","\u3051\u3093\u308A","\u3053\u3042\u304F\u307E","\u3053\u3044\u306C","\u3053\u3044\u3072\u3099\u3068","\u3053\u3099\u3046\u3044","\u3053\u3046\u3048\u3093","\u3053\u3046\u304A\u3093","\u3053\u3046\u304B\u3093","\u3053\u3099\u3046\u304D\u3085\u3046","\u3053\u3099\u3046\u3051\u3044","\u3053\u3046\u3053\u3046","\u3053\u3046\u3055\u3044","\u3053\u3046\u3057\u3099","\u3053\u3046\u3059\u3044","\u3053\u3099\u3046\u305B\u3044","\u3053\u3046\u305D\u304F","\u3053\u3046\u305F\u3044","\u3053\u3046\u3061\u3083","\u3053\u3046\u3064\u3046","\u3053\u3046\u3066\u3044","\u3053\u3046\u3068\u3099\u3046","\u3053\u3046\u306A\u3044","\u3053\u3046\u306F\u3044","\u3053\u3099\u3046\u307B\u3046","\u3053\u3099\u3046\u307E\u3093","\u3053\u3046\u3082\u304F","\u3053\u3046\u308A\u3064","\u3053\u3048\u308B","\u3053\u304A\u308A","\u3053\u3099\u304B\u3044","\u3053\u3099\u304B\u3099\u3064","\u3053\u3099\u304B\u3093","\u3053\u304F\u3053\u3099","\u3053\u304F\u3055\u3044","\u3053\u304F\u3068\u3046","\u3053\u304F\u306A\u3044","\u3053\u304F\u306F\u304F","\u3053\u304F\u3099\u307E","\u3053\u3051\u3044","\u3053\u3051\u308B","\u3053\u3053\u306E\u304B","\u3053\u3053\u308D","\u3053\u3055\u3081","\u3053\u3057\u3064","\u3053\u3059\u3046","\u3053\u305B\u3044","\u3053\u305B\u304D","\u3053\u305B\u3099\u3093","\u3053\u305D\u305F\u3099\u3066","\u3053\u305F\u3044","\u3053\u305F\u3048\u308B","\u3053\u305F\u3064","\u3053\u3061\u3087\u3046","\u3053\u3063\u304B","\u3053\u3064\u3053\u3064","\u3053\u3064\u306F\u3099\u3093","\u3053\u3064\u3075\u3099","\u3053\u3066\u3044","\u3053\u3066\u3093","\u3053\u3068\u304B\u3099\u3089","\u3053\u3068\u3057","\u3053\u3068\u306F\u3099","\u3053\u3068\u308A","\u3053\u306A\u3053\u3099\u306A","\u3053\u306D\u3053\u306D","\u3053\u306E\u307E\u307E","\u3053\u306E\u307F","\u3053\u306E\u3088","\u3053\u3099\u306F\u3093","\u3053\u3072\u3064\u3057\u3099","\u3053\u3075\u3046","\u3053\u3075\u3093","\u3053\u307B\u3099\u308C\u308B","\u3053\u3099\u307E\u3042\u3075\u3099\u3089","\u3053\u307E\u304B\u3044","\u3053\u3099\u307E\u3059\u308A","\u3053\u307E\u3064\u306A","\u3053\u307E\u308B","\u3053\u3080\u304D\u3099\u3053","\u3053\u3082\u3057\u3099","\u3053\u3082\u3061","\u3053\u3082\u306E","\u3053\u3082\u3093","\u3053\u3084\u304F","\u3053\u3084\u307E","\u3053\u3086\u3046","\u3053\u3086\u3072\u3099","\u3053\u3088\u3044","\u3053\u3088\u3046","\u3053\u308A\u308B","\u3053\u308C\u304F\u3057\u3087\u3093","\u3053\u308D\u3063\u3051","\u3053\u308F\u3082\u3066","\u3053\u308F\u308C\u308B","\u3053\u3093\u3044\u3093","\u3053\u3093\u304B\u3044","\u3053\u3093\u304D","\u3053\u3093\u3057\u3085\u3046","\u3053\u3093\u3059\u3044","\u3053\u3093\u305F\u3099\u3066","\u3053\u3093\u3068\u3093","\u3053\u3093\u306A\u3093","\u3053\u3093\u3072\u3099\u306B","\u3053\u3093\u307B\u309A\u3093","\u3053\u3093\u307E\u3051","\u3053\u3093\u3084","\u3053\u3093\u308C\u3044","\u3053\u3093\u308F\u304F","\u3055\u3099\u3044\u3048\u304D","\u3055\u3044\u304B\u3044","\u3055\u3044\u304D\u3093","\u3055\u3099\u3044\u3051\u3099\u3093","\u3055\u3099\u3044\u3053","\u3055\u3044\u3057\u3087","\u3055\u3044\u305B\u3044","\u3055\u3099\u3044\u305F\u304F","\u3055\u3099\u3044\u3061\u3085\u3046","\u3055\u3044\u3066\u304D","\u3055\u3099\u3044\u308A\u3087\u3046","\u3055\u3046\u306A","\u3055\u304B\u3044\u3057","\u3055\u304B\u3099\u3059","\u3055\u304B\u306A","\u3055\u304B\u307F\u3061","\u3055\u304B\u3099\u308B","\u3055\u304D\u3099\u3087\u3046","\u3055\u304F\u3057","\u3055\u304F\u3072\u3093","\u3055\u304F\u3089","\u3055\u3053\u304F","\u3055\u3053\u3064","\u3055\u3059\u3099\u304B\u308B","\u3055\u3099\u305B\u304D","\u3055\u305F\u3093","\u3055\u3064\u3048\u3044","\u3055\u3099\u3064\u304A\u3093","\u3055\u3099\u3063\u304B","\u3055\u3099\u3064\u304B\u3099\u304F","\u3055\u3063\u304D\u3087\u304F","\u3055\u3099\u3063\u3057","\u3055\u3064\u3057\u3099\u3093","\u3055\u3099\u3063\u305D\u3046","\u3055\u3064\u305F\u306F\u3099","\u3055\u3064\u307E\u3044\u3082","\u3055\u3066\u3044","\u3055\u3068\u3044\u3082","\u3055\u3068\u3046","\u3055\u3068\u304A\u3084","\u3055\u3068\u3057","\u3055\u3068\u308B","\u3055\u306E\u3046","\u3055\u306F\u3099\u304F","\u3055\u3072\u3099\u3057\u3044","\u3055\u3078\u3099\u3064","\u3055\u307B\u3046","\u3055\u307B\u3068\u3099","\u3055\u307E\u3059","\u3055\u307F\u3057\u3044","\u3055\u307F\u305F\u3099\u308C","\u3055\u3080\u3051","\u3055\u3081\u308B","\u3055\u3084\u3048\u3093\u3068\u3099\u3046","\u3055\u3086\u3046","\u3055\u3088\u3046","\u3055\u3088\u304F","\u3055\u3089\u305F\u3099","\u3055\u3099\u308B\u305D\u306F\u3099","\u3055\u308F\u3084\u304B","\u3055\u308F\u308B","\u3055\u3093\u3044\u3093","\u3055\u3093\u304B","\u3055\u3093\u304D\u3083\u304F","\u3055\u3093\u3053\u3046","\u3055\u3093\u3055\u3044","\u3055\u3099\u3093\u3057\u3087","\u3055\u3093\u3059\u3046","\u3055\u3093\u305B\u3044","\u3055\u3093\u305D","\u3055\u3093\u3061","\u3055\u3093\u307E","\u3055\u3093\u307F","\u3055\u3093\u3089\u3093","\u3057\u3042\u3044","\u3057\u3042\u3051\u3099","\u3057\u3042\u3055\u3063\u3066","\u3057\u3042\u308F\u305B","\u3057\u3044\u304F","\u3057\u3044\u3093","\u3057\u3046\u3061","\u3057\u3048\u3044","\u3057\u304A\u3051","\u3057\u304B\u3044","\u3057\u304B\u304F","\u3057\u3099\u304B\u3093","\u3057\u3053\u3099\u3068","\u3057\u3059\u3046","\u3057\u3099\u305F\u3099\u3044","\u3057\u305F\u3046\u3051","\u3057\u305F\u304D\u3099","\u3057\u305F\u3066","\u3057\u305F\u307F","\u3057\u3061\u3087\u3046","\u3057\u3061\u308A\u3093","\u3057\u3063\u304B\u308A","\u3057\u3064\u3057\u3099","\u3057\u3064\u3082\u3093","\u3057\u3066\u3044","\u3057\u3066\u304D","\u3057\u3066\u3064","\u3057\u3099\u3066\u3093","\u3057\u3099\u3068\u3099\u3046","\u3057\u306A\u304D\u3099\u308C","\u3057\u306A\u3082\u306E","\u3057\u306A\u3093","\u3057\u306D\u307E","\u3057\u306D\u3093","\u3057\u306E\u304F\u3099","\u3057\u306E\u3075\u3099","\u3057\u306F\u3044","\u3057\u306F\u3099\u304B\u308A","\u3057\u306F\u3064","\u3057\u306F\u3089\u3044","\u3057\u306F\u3093","\u3057\u3072\u3087\u3046","\u3057\u3075\u304F","\u3057\u3099\u3075\u3099\u3093","\u3057\u3078\u3044","\u3057\u307B\u3046","\u3057\u307B\u3093","\u3057\u307E\u3046","\u3057\u307E\u308B","\u3057\u307F\u3093","\u3057\u3080\u3051\u308B","\u3057\u3099\u3080\u3057\u3087","\u3057\u3081\u3044","\u3057\u3081\u308B","\u3057\u3082\u3093","\u3057\u3083\u3044\u3093","\u3057\u3083\u3046\u3093","\u3057\u3083\u304A\u3093","\u3057\u3099\u3083\u304B\u3099\u3044\u3082","\u3057\u3084\u304F\u3057\u3087","\u3057\u3083\u304F\u307B\u3046","\u3057\u3083\u3051\u3093","\u3057\u3083\u3053","\u3057\u3083\u3055\u3099\u3044","\u3057\u3083\u3057\u3093","\u3057\u3083\u305B\u3093","\u3057\u3083\u305D\u3046","\u3057\u3083\u305F\u3044","\u3057\u3083\u3061\u3087\u3046","\u3057\u3083\u3063\u304D\u3093","\u3057\u3099\u3083\u307E","\u3057\u3083\u308A\u3093","\u3057\u3083\u308C\u3044","\u3057\u3099\u3086\u3046","\u3057\u3099\u3085\u3046\u3057\u3087","\u3057\u3085\u304F\u306F\u304F","\u3057\u3099\u3085\u3057\u3093","\u3057\u3085\u3063\u305B\u304D","\u3057\u3085\u307F","\u3057\u3085\u3089\u306F\u3099","\u3057\u3099\u3085\u3093\u306F\u3099\u3093","\u3057\u3087\u3046\u304B\u3044","\u3057\u3087\u304F\u305F\u304F","\u3057\u3087\u3063\u3051\u3093","\u3057\u3087\u3068\u3099\u3046","\u3057\u3087\u3082\u3064","\u3057\u3089\u305B\u308B","\u3057\u3089\u3078\u3099\u308B","\u3057\u3093\u304B","\u3057\u3093\u3053\u3046","\u3057\u3099\u3093\u3057\u3099\u3083","\u3057\u3093\u305B\u3044\u3057\u3099","\u3057\u3093\u3061\u304F","\u3057\u3093\u308A\u3093","\u3059\u3042\u3051\u3099","\u3059\u3042\u3057","\u3059\u3042\u306A","\u3059\u3099\u3042\u3093","\u3059\u3044\u3048\u3044","\u3059\u3044\u304B","\u3059\u3044\u3068\u3046","\u3059\u3099\u3044\u3075\u3099\u3093","\u3059\u3044\u3088\u3046\u3072\u3099","\u3059\u3046\u304B\u3099\u304F","\u3059\u3046\u3057\u3099\u3064","\u3059\u3046\u305B\u3093","\u3059\u304A\u3068\u3099\u308A","\u3059\u304D\u307E","\u3059\u304F\u3046","\u3059\u304F\u306A\u3044","\u3059\u3051\u308B","\u3059\u3053\u3099\u3044","\u3059\u3053\u3057","\u3059\u3099\u3055\u3093","\u3059\u3059\u3099\u3057\u3044","\u3059\u3059\u3080","\u3059\u3059\u3081\u308B","\u3059\u3063\u304B\u308A","\u3059\u3099\u3063\u3057\u308A","\u3059\u3099\u3063\u3068","\u3059\u3066\u304D","\u3059\u3066\u308B","\u3059\u306D\u308B","\u3059\u306E\u3053","\u3059\u306F\u305F\u3099","\u3059\u306F\u3099\u3089\u3057\u3044","\u3059\u3099\u3072\u3087\u3046","\u3059\u3099\u3075\u3099\u306C\u308C","\u3059\u3075\u3099\u308A","\u3059\u3075\u308C","\u3059\u3078\u3099\u3066","\u3059\u3078\u3099\u308B","\u3059\u3099\u307B\u3046","\u3059\u307B\u3099\u3093","\u3059\u307E\u3044","\u3059\u3081\u3057","\u3059\u3082\u3046","\u3059\u3084\u304D","\u3059\u3089\u3059\u3089","\u3059\u308B\u3081","\u3059\u308C\u3061\u304B\u3099\u3046","\u3059\u308D\u3063\u3068","\u3059\u308F\u308B","\u3059\u3093\u305B\u3099\u3093","\u3059\u3093\u307B\u309A\u3046","\u305B\u3042\u3075\u3099\u3089","\u305B\u3044\u304B\u3064","\u305B\u3044\u3051\u3099\u3093","\u305B\u3044\u3057\u3099","\u305B\u3044\u3088\u3046","\u305B\u304A\u3046","\u305B\u304B\u3044\u304B\u3093","\u305B\u304D\u306B\u3093","\u305B\u304D\u3080","\u305B\u304D\u3086","\u305B\u304D\u3089\u3093\u3046\u3093","\u305B\u3051\u3093","\u305B\u3053\u3046","\u305B\u3059\u3057\u3099","\u305B\u305F\u3044","\u305B\u305F\u3051","\u305B\u3063\u304B\u304F","\u305B\u3063\u304D\u3083\u304F","\u305B\u3099\u3063\u304F","\u305B\u3063\u3051\u3093","\u305B\u3063\u3053\u3064","\u305B\u3063\u3055\u305F\u304F\u307E","\u305B\u3064\u305D\u3099\u304F","\u305B\u3064\u305F\u3099\u3093","\u305B\u3064\u3066\u3099\u3093","\u305B\u3063\u306F\u309A\u3093","\u305B\u3064\u3072\u3099","\u305B\u3064\u3075\u3099\u3093","\u305B\u3064\u3081\u3044","\u305B\u3064\u308A\u3064","\u305B\u306A\u304B","\u305B\u306E\u3072\u3099","\u305B\u306F\u306F\u3099","\u305B\u3072\u3099\u308D","\u305B\u307B\u3099\u306D","\u305B\u307E\u3044","\u305B\u307E\u308B","\u305B\u3081\u308B","\u305B\u3082\u305F\u308C","\u305B\u308A\u3075","\u305B\u3099\u3093\u3042\u304F","\u305B\u3093\u3044","\u305B\u3093\u3048\u3044","\u305B\u3093\u304B","\u305B\u3093\u304D\u3087","\u305B\u3093\u304F","\u305B\u3093\u3051\u3099\u3093","\u305B\u3099\u3093\u3053\u3099","\u305B\u3093\u3055\u3044","\u305B\u3093\u3057\u3085","\u305B\u3093\u3059\u3044","\u305B\u3093\u305B\u3044","\u305B\u3093\u305D\u3099","\u305B\u3093\u305F\u304F","\u305B\u3093\u3061\u3087\u3046","\u305B\u3093\u3066\u3044","\u305B\u3093\u3068\u3046","\u305B\u3093\u306C\u304D","\u305B\u3093\u306D\u3093","\u305B\u3093\u306F\u309A\u3044","\u305B\u3099\u3093\u3075\u3099","\u305B\u3099\u3093\u307B\u309A\u3046","\u305B\u3093\u3080","\u305B\u3093\u3081\u3093\u3057\u3099\u3087","\u305B\u3093\u3082\u3093","\u305B\u3093\u3084\u304F","\u305B\u3093\u3086\u3046","\u305B\u3093\u3088\u3046","\u305B\u3099\u3093\u3089","\u305B\u3099\u3093\u308A\u3083\u304F","\u305B\u3093\u308C\u3044","\u305B\u3093\u308D","\u305D\u3042\u304F","\u305D\u3044\u3068\u3051\u3099\u308B","\u305D\u3044\u306D","\u305D\u3046\u304B\u3099\u3093\u304D\u3087\u3046","\u305D\u3046\u304D","\u305D\u3046\u3053\u3099","\u305D\u3046\u3057\u3093","\u305D\u3046\u305F\u3099\u3093","\u305D\u3046\u306A\u3093","\u305D\u3046\u3072\u3099","\u305D\u3046\u3081\u3093","\u305D\u3046\u308A","\u305D\u3048\u3082\u306E","\u305D\u3048\u3093","\u305D\u304B\u3099\u3044","\u305D\u3051\u3099\u304D","\u305D\u3053\u3046","\u305D\u3053\u305D\u3053","\u305D\u3055\u3099\u3044","\u305D\u3057\u306A","\u305D\u305B\u3044","\u305D\u305B\u3093","\u305D\u305D\u304F\u3099","\u305D\u305F\u3099\u3066\u308B","\u305D\u3064\u3046","\u305D\u3064\u3048\u3093","\u305D\u3063\u304B\u3093","\u305D\u3064\u304D\u3099\u3087\u3046","\u305D\u3063\u3051\u3064","\u305D\u3063\u3053\u3046","\u305D\u3063\u305B\u3093","\u305D\u3063\u3068","\u305D\u3068\u304B\u3099\u308F","\u305D\u3068\u3064\u3099\u3089","\u305D\u306A\u3048\u308B","\u305D\u306A\u305F","\u305D\u3075\u307B\u3099","\u305D\u307B\u3099\u304F","\u305D\u307B\u3099\u308D","\u305D\u307E\u3064","\u305D\u307E\u308B","\u305D\u3080\u304F","\u305D\u3080\u308A\u3048","\u305D\u3081\u308B","\u305D\u3082\u305D\u3082","\u305D\u3088\u304B\u305B\u3099","\u305D\u3089\u307E\u3081","\u305D\u308D\u3046","\u305D\u3093\u304B\u3044","\u305D\u3093\u3051\u3044","\u305D\u3093\u3055\u3099\u3044","\u305D\u3093\u3057\u3064","\u305D\u3093\u305D\u3099\u304F","\u305D\u3093\u3061\u3087\u3046","\u305D\u3099\u3093\u3072\u3099","\u305D\u3099\u3093\u3075\u3099\u3093","\u305D\u3093\u307F\u3093","\u305F\u3042\u3044","\u305F\u3044\u3044\u3093","\u305F\u3044\u3046\u3093","\u305F\u3044\u3048\u304D","\u305F\u3044\u304A\u3046","\u305F\u3099\u3044\u304B\u3099\u304F","\u305F\u3044\u304D","\u305F\u3044\u304F\u3099\u3046","\u305F\u3044\u3051\u3093","\u305F\u3044\u3053","\u305F\u3044\u3055\u3099\u3044","\u305F\u3099\u3044\u3057\u3099\u3087\u3046\u3075\u3099","\u305F\u3099\u3044\u3059\u304D","\u305F\u3044\u305B\u3064","\u305F\u3044\u305D\u3046","\u305F\u3099\u3044\u305F\u3044","\u305F\u3044\u3061\u3087\u3046","\u305F\u3044\u3066\u3044","\u305F\u3099\u3044\u3068\u3099\u3053\u308D","\u305F\u3044\u306A\u3044","\u305F\u3044\u306D\u3064","\u305F\u3044\u306E\u3046","\u305F\u3044\u306F\u3093","\u305F\u3099\u3044\u3072\u3087\u3046","\u305F\u3044\u3075\u3046","\u305F\u3044\u3078\u3093","\u305F\u3044\u307B","\u305F\u3044\u307E\u3064\u306F\u3099\u306A","\u305F\u3044\u307F\u3093\u304F\u3099","\u305F\u3044\u3080","\u305F\u3044\u3081\u3093","\u305F\u3044\u3084\u304D","\u305F\u3044\u3088\u3046","\u305F\u3044\u3089","\u305F\u3044\u308A\u3087\u304F","\u305F\u3044\u308B","\u305F\u3044\u308F\u3093","\u305F\u3046\u3048","\u305F\u3048\u308B","\u305F\u304A\u3059","\u305F\u304A\u308B","\u305F\u304A\u308C\u308B","\u305F\u304B\u3044","\u305F\u304B\u306D","\u305F\u304D\u3072\u3099","\u305F\u304F\u3055\u3093","\u305F\u3053\u304F","\u305F\u3053\u3084\u304D","\u305F\u3055\u3044","\u305F\u3057\u3055\u3099\u3093","\u305F\u3099\u3057\u3099\u3083\u308C","\u305F\u3059\u3051\u308B","\u305F\u3059\u3099\u3055\u308F\u308B","\u305F\u305D\u304B\u3099\u308C","\u305F\u305F\u304B\u3046","\u305F\u305F\u304F","\u305F\u305F\u3099\u3057\u3044","\u305F\u305F\u307F","\u305F\u3061\u306F\u3099\u306A","\u305F\u3099\u3063\u304B\u3044","\u305F\u3099\u3063\u304D\u3083\u304F","\u305F\u3099\u3063\u3053","\u305F\u3099\u3063\u3057\u3085\u3064","\u305F\u3099\u3063\u305F\u3044","\u305F\u3066\u308B","\u305F\u3068\u3048\u308B","\u305F\u306A\u306F\u3099\u305F","\u305F\u306B\u3093","\u305F\u306C\u304D","\u305F\u306E\u3057\u307F","\u305F\u306F\u3064","\u305F\u3075\u3099\u3093","\u305F\u3078\u3099\u308B","\u305F\u307B\u3099\u3046","\u305F\u307E\u3053\u3099","\u305F\u307E\u308B","\u305F\u3099\u3080\u308B","\u305F\u3081\u3044\u304D","\u305F\u3081\u3059","\u305F\u3081\u308B","\u305F\u3082\u3064","\u305F\u3084\u3059\u3044","\u305F\u3088\u308B","\u305F\u3089\u3059","\u305F\u308A\u304D\u307B\u3093\u304B\u3099\u3093","\u305F\u308A\u3087\u3046","\u305F\u308A\u308B","\u305F\u308B\u3068","\u305F\u308C\u308B","\u305F\u308C\u3093\u3068","\u305F\u308D\u3063\u3068","\u305F\u308F\u3080\u308C\u308B","\u305F\u3099\u3093\u3042\u3064","\u305F\u3093\u3044","\u305F\u3093\u304A\u3093","\u305F\u3093\u304B","\u305F\u3093\u304D","\u305F\u3093\u3051\u3093","\u305F\u3093\u3053\u3099","\u305F\u3093\u3055\u3093","\u305F\u3093\u3057\u3099\u3087\u3046\u3072\u3099","\u305F\u3099\u3093\u305B\u3044","\u305F\u3093\u305D\u304F","\u305F\u3093\u305F\u3044","\u305F\u3099\u3093\u3061","\u305F\u3093\u3066\u3044","\u305F\u3093\u3068\u3046","\u305F\u3099\u3093\u306A","\u305F\u3093\u306B\u3093","\u305F\u3099\u3093\u306D\u3064","\u305F\u3093\u306E\u3046","\u305F\u3093\u3072\u309A\u3093","\u305F\u3099\u3093\u307B\u3099\u3046","\u305F\u3093\u307E\u3064","\u305F\u3093\u3081\u3044","\u305F\u3099\u3093\u308C\u3064","\u305F\u3099\u3093\u308D","\u305F\u3099\u3093\u308F","\u3061\u3042\u3044","\u3061\u3042\u3093","\u3061\u3044\u304D","\u3061\u3044\u3055\u3044","\u3061\u3048\u3093","\u3061\u304B\u3044","\u3061\u304B\u3089","\u3061\u304D\u3085\u3046","\u3061\u304D\u3093","\u3061\u3051\u3044\u3059\u3099","\u3061\u3051\u3093","\u3061\u3053\u304F","\u3061\u3055\u3044","\u3061\u3057\u304D","\u3061\u3057\u308A\u3087\u3046","\u3061\u305B\u3044","\u3061\u305D\u3046","\u3061\u305F\u3044","\u3061\u305F\u3093","\u3061\u3061\u304A\u3084","\u3061\u3064\u3057\u3099\u3087","\u3061\u3066\u304D","\u3061\u3066\u3093","\u3061\u306C\u304D","\u3061\u306C\u308A","\u3061\u306E\u3046","\u3061\u3072\u3087\u3046","\u3061\u3078\u3044\u305B\u3093","\u3061\u307B\u3046","\u3061\u307E\u305F","\u3061\u307F\u3064","\u3061\u307F\u3068\u3099\u308D","\u3061\u3081\u3044\u3068\u3099","\u3061\u3083\u3093\u3053\u306A\u3078\u3099","\u3061\u3085\u3046\u3044","\u3061\u3086\u308A\u3087\u304F","\u3061\u3087\u3046\u3057","\u3061\u3087\u3055\u304F\u3051\u3093","\u3061\u3089\u3057","\u3061\u3089\u307F","\u3061\u308A\u304B\u3099\u307F","\u3061\u308A\u3087\u3046","\u3061\u308B\u3068\u3099","\u3061\u308F\u308F","\u3061\u3093\u305F\u3044","\u3061\u3093\u3082\u304F","\u3064\u3044\u304B","\u3064\u3044\u305F\u3061","\u3064\u3046\u304B","\u3064\u3046\u3057\u3099\u3087\u3046","\u3064\u3046\u306F\u3093","\u3064\u3046\u308F","\u3064\u304B\u3046","\u3064\u304B\u308C\u308B","\u3064\u304F\u306D","\u3064\u304F\u308B","\u3064\u3051\u306D","\u3064\u3051\u308B","\u3064\u3053\u3099\u3046","\u3064\u305F\u3048\u308B","\u3064\u3064\u3099\u304F","\u3064\u3064\u3057\u3099","\u3064\u3064\u3080","\u3064\u3068\u3081\u308B","\u3064\u306A\u304B\u3099\u308B","\u3064\u306A\u307F","\u3064\u306D\u3064\u3099\u306D","\u3064\u306E\u308B","\u3064\u3075\u3099\u3059","\u3064\u307E\u3089\u306A\u3044","\u3064\u307E\u308B","\u3064\u307F\u304D","\u3064\u3081\u305F\u3044","\u3064\u3082\u308A","\u3064\u3082\u308B","\u3064\u3088\u3044","\u3064\u308B\u307B\u3099","\u3064\u308B\u307F\u304F","\u3064\u308F\u3082\u306E","\u3064\u308F\u308A","\u3066\u3042\u3057","\u3066\u3042\u3066","\u3066\u3042\u307F","\u3066\u3044\u304A\u3093","\u3066\u3044\u304B","\u3066\u3044\u304D","\u3066\u3044\u3051\u3044","\u3066\u3044\u3053\u304F","\u3066\u3044\u3055\u3064","\u3066\u3044\u3057","\u3066\u3044\u305B\u3044","\u3066\u3044\u305F\u3044","\u3066\u3044\u3068\u3099","\u3066\u3044\u306D\u3044","\u3066\u3044\u3072\u3087\u3046","\u3066\u3044\u3078\u3093","\u3066\u3044\u307B\u3099\u3046","\u3066\u3046\u3061","\u3066\u304A\u304F\u308C","\u3066\u304D\u3068\u3046","\u3066\u304F\u3072\u3099","\u3066\u3099\u3053\u307B\u3099\u3053","\u3066\u3055\u304D\u3099\u3087\u3046","\u3066\u3055\u3051\u3099","\u3066\u3059\u308A","\u3066\u305D\u3046","\u3066\u3061\u304B\u3099\u3044","\u3066\u3061\u3087\u3046","\u3066\u3064\u304B\u3099\u304F","\u3066\u3064\u3064\u3099\u304D","\u3066\u3099\u3063\u306F\u309A","\u3066\u3064\u307B\u3099\u3046","\u3066\u3064\u3084","\u3066\u3099\u306C\u304B\u3048","\u3066\u306C\u304D","\u3066\u306C\u304F\u3099\u3044","\u3066\u306E\u3072\u3089","\u3066\u306F\u3044","\u3066\u3075\u3099\u304F\u308D","\u3066\u3075\u305F\u3099","\u3066\u307B\u3068\u3099\u304D","\u3066\u307B\u3093","\u3066\u307E\u3048","\u3066\u307E\u304D\u3059\u3099\u3057","\u3066\u307F\u3057\u3099\u304B","\u3066\u307F\u3084\u3051\u3099","\u3066\u3089\u3059","\u3066\u308C\u3072\u3099","\u3066\u308F\u3051","\u3066\u308F\u305F\u3057","\u3066\u3099\u3093\u3042\u3064","\u3066\u3093\u3044\u3093","\u3066\u3093\u304B\u3044","\u3066\u3093\u304D","\u3066\u3093\u304F\u3099","\u3066\u3093\u3051\u3093","\u3066\u3093\u3053\u3099\u304F","\u3066\u3093\u3055\u3044","\u3066\u3093\u3057","\u3066\u3093\u3059\u3046","\u3066\u3099\u3093\u3061","\u3066\u3093\u3066\u304D","\u3066\u3093\u3068\u3046","\u3066\u3093\u306A\u3044","\u3066\u3093\u3075\u309A\u3089","\u3066\u3093\u307B\u3099\u3046\u305F\u3099\u3044","\u3066\u3093\u3081\u3064","\u3066\u3093\u3089\u3093\u304B\u3044","\u3066\u3099\u3093\u308A\u3087\u304F","\u3066\u3099\u3093\u308F","\u3068\u3099\u3042\u3044","\u3068\u3044\u308C","\u3068\u3099\u3046\u304B\u3093","\u3068\u3046\u304D\u3085\u3046","\u3068\u3099\u3046\u304F\u3099","\u3068\u3046\u3057","\u3068\u3046\u3080\u304D\u3099","\u3068\u304A\u3044","\u3068\u304A\u304B","\u3068\u304A\u304F","\u3068\u304A\u3059","\u3068\u304A\u308B","\u3068\u304B\u3044","\u3068\u304B\u3059","\u3068\u304D\u304A\u308A","\u3068\u304D\u3068\u3099\u304D","\u3068\u304F\u3044","\u3068\u304F\u3057\u3085\u3046","\u3068\u304F\u3066\u3093","\u3068\u304F\u306B","\u3068\u304F\u3078\u3099\u3064","\u3068\u3051\u3044","\u3068\u3051\u308B","\u3068\u3053\u3084","\u3068\u3055\u304B","\u3068\u3057\u3087\u304B\u3093","\u3068\u305D\u3046","\u3068\u305F\u3093","\u3068\u3061\u3085\u3046","\u3068\u3063\u304D\u3085\u3046","\u3068\u3063\u304F\u3093","\u3068\u3064\u305B\u3099\u3093","\u3068\u3064\u306B\u3085\u3046","\u3068\u3068\u3099\u3051\u308B","\u3068\u3068\u306E\u3048\u308B","\u3068\u306A\u3044","\u3068\u306A\u3048\u308B","\u3068\u306A\u308A","\u3068\u306E\u3055\u307E","\u3068\u306F\u3099\u3059","\u3068\u3099\u3075\u3099\u304B\u3099\u308F","\u3068\u307B\u3046","\u3068\u307E\u308B","\u3068\u3081\u308B","\u3068\u3082\u305F\u3099\u3061","\u3068\u3082\u308B","\u3068\u3099\u3088\u3046\u3072\u3099","\u3068\u3089\u3048\u308B","\u3068\u3093\u304B\u3064","\u3068\u3099\u3093\u3075\u3099\u308A","\u306A\u3044\u304B\u304F","\u306A\u3044\u3053\u3046","\u306A\u3044\u3057\u3087","\u306A\u3044\u3059","\u306A\u3044\u305B\u3093","\u306A\u3044\u305D\u3046","\u306A\u304A\u3059","\u306A\u304B\u3099\u3044","\u306A\u304F\u3059","\u306A\u3051\u3099\u308B","\u306A\u3053\u3046\u3068\u3099","\u306A\u3055\u3051","\u306A\u305F\u3066\u3099\u3053\u3053","\u306A\u3063\u3068\u3046","\u306A\u3064\u3084\u3059\u307F","\u306A\u306A\u304A\u3057","\u306A\u306B\u3053\u3099\u3068","\u306A\u306B\u3082\u306E","\u306A\u306B\u308F","\u306A\u306E\u304B","\u306A\u3075\u305F\u3099","\u306A\u307E\u3044\u304D","\u306A\u307E\u3048","\u306A\u307E\u307F","\u306A\u307F\u305F\u3099","\u306A\u3081\u3089\u304B","\u306A\u3081\u308B","\u306A\u3084\u3080","\u306A\u3089\u3046","\u306A\u3089\u3072\u3099","\u306A\u3089\u3075\u3099","\u306A\u308C\u308B","\u306A\u308F\u3068\u3072\u3099","\u306A\u308F\u306F\u3099\u308A","\u306B\u3042\u3046","\u306B\u3044\u304B\u3099\u305F","\u306B\u3046\u3051","\u306B\u304A\u3044","\u306B\u304B\u3044","\u306B\u304B\u3099\u3066","\u306B\u304D\u3072\u3099","\u306B\u304F\u3057\u307F","\u306B\u304F\u307E\u3093","\u306B\u3051\u3099\u308B","\u306B\u3055\u3093\u304B\u305F\u3093\u305D","\u306B\u3057\u304D","\u306B\u305B\u3082\u306E","\u306B\u3061\u3057\u3099\u3087\u3046","\u306B\u3061\u3088\u3046\u3072\u3099","\u306B\u3063\u304B","\u306B\u3063\u304D","\u306B\u3063\u3051\u3044","\u306B\u3063\u3053\u3046","\u306B\u3063\u3055\u3093","\u306B\u3063\u3057\u3087\u304F","\u306B\u3063\u3059\u3046","\u306B\u3063\u305B\u304D","\u306B\u3063\u3066\u3044","\u306B\u306A\u3046","\u306B\u307B\u3093","\u306B\u307E\u3081","\u306B\u3082\u3064","\u306B\u3084\u308A","\u306B\u3085\u3046\u3044\u3093","\u306B\u308A\u3093\u3057\u3083","\u306B\u308F\u3068\u308A","\u306B\u3093\u3044","\u306B\u3093\u304B","\u306B\u3093\u304D","\u306B\u3093\u3051\u3099\u3093","\u306B\u3093\u3057\u304D","\u306B\u3093\u3059\u3099\u3046","\u306B\u3093\u305D\u3046","\u306B\u3093\u305F\u3044","\u306B\u3093\u3061","\u306B\u3093\u3066\u3044","\u306B\u3093\u306B\u304F","\u306B\u3093\u3075\u309A","\u306B\u3093\u307E\u308A","\u306B\u3093\u3080","\u306B\u3093\u3081\u3044","\u306B\u3093\u3088\u3046","\u306C\u3044\u304F\u304D\u3099","\u306C\u304B\u3059","\u306C\u304F\u3099\u3044\u3068\u308B","\u306C\u304F\u3099\u3046","\u306C\u304F\u3082\u308A","\u306C\u3059\u3080","\u306C\u307E\u3048\u3072\u3099","\u306C\u3081\u308A","\u306C\u3089\u3059","\u306C\u3093\u3061\u3083\u304F","\u306D\u3042\u3051\u3099","\u306D\u3044\u304D","\u306D\u3044\u308B","\u306D\u3044\u308D","\u306D\u304F\u3099\u305B","\u306D\u304F\u305F\u3044","\u306D\u304F\u3089","\u306D\u3053\u305B\u3099","\u306D\u3053\u3080","\u306D\u3055\u3051\u3099","\u306D\u3059\u3053\u3099\u3059","\u306D\u305D\u3078\u3099\u308B","\u306D\u305F\u3099\u3093","\u306D\u3064\u3044","\u306D\u3063\u3057\u3093","\u306D\u3064\u305D\u3099\u3046","\u306D\u3063\u305F\u3044\u304D\u3099\u3087","\u306D\u3075\u3099\u305D\u304F","\u306D\u3075\u305F\u3099","\u306D\u307B\u3099\u3046","\u306D\u307B\u308A\u306F\u307B\u308A","\u306D\u307E\u304D","\u306D\u307E\u308F\u3057","\u306D\u307F\u307F","\u306D\u3080\u3044","\u306D\u3080\u305F\u3044","\u306D\u3082\u3068","\u306D\u3089\u3046","\u306D\u308F\u3055\u3099","\u306D\u3093\u3044\u308A","\u306D\u3093\u304A\u3057","\u306D\u3093\u304B\u3093","\u306D\u3093\u304D\u3093","\u306D\u3093\u304F\u3099","\u306D\u3093\u3055\u3099","\u306D\u3093\u3057","\u306D\u3093\u3061\u3083\u304F","\u306D\u3093\u3068\u3099","\u306D\u3093\u3072\u309A","\u306D\u3093\u3075\u3099\u3064","\u306D\u3093\u307E\u3064","\u306D\u3093\u308A\u3087\u3046","\u306D\u3093\u308C\u3044","\u306E\u3044\u3059\u3099","\u306E\u304A\u3064\u3099\u307E","\u306E\u304B\u3099\u3059","\u306E\u304D\u306A\u307F","\u306E\u3053\u304D\u3099\u308A","\u306E\u3053\u3059","\u306E\u3053\u308B","\u306E\u305B\u308B","\u306E\u305D\u3099\u304F","\u306E\u305D\u3099\u3080","\u306E\u305F\u307E\u3046","\u306E\u3061\u307B\u3068\u3099","\u306E\u3063\u304F","\u306E\u306F\u3099\u3059","\u306E\u306F\u3089","\u306E\u3078\u3099\u308B","\u306E\u307B\u3099\u308B","\u306E\u307F\u3082\u306E","\u306E\u3084\u307E","\u306E\u3089\u3044\u306C","\u306E\u3089\u306D\u3053","\u306E\u308A\u3082\u306E","\u306E\u308A\u3086\u304D","\u306E\u308C\u3093","\u306E\u3093\u304D","\u306F\u3099\u3042\u3044","\u306F\u3042\u304F","\u306F\u3099\u3042\u3055\u3093","\u306F\u3099\u3044\u304B","\u306F\u3099\u3044\u304F","\u306F\u3044\u3051\u3093","\u306F\u3044\u3053\u3099","\u306F\u3044\u3057\u3093","\u306F\u3044\u3059\u3044","\u306F\u3044\u305B\u3093","\u306F\u3044\u305D\u3046","\u306F\u3044\u3061","\u306F\u3099\u3044\u306F\u3099\u3044","\u306F\u3044\u308C\u3064","\u306F\u3048\u308B","\u306F\u304A\u308B","\u306F\u304B\u3044","\u306F\u3099\u304B\u308A","\u306F\u304B\u308B","\u306F\u304F\u3057\u3085","\u306F\u3051\u3093","\u306F\u3053\u3075\u3099","\u306F\u3055\u307F","\u306F\u3055\u3093","\u306F\u3057\u3053\u3099","\u306F\u3099\u3057\u3087","\u306F\u3057\u308B","\u306F\u305B\u308B","\u306F\u309A\u305D\u3053\u3093","\u306F\u305D\u3093","\u306F\u305F\u3093","\u306F\u3061\u307F\u3064","\u306F\u3064\u304A\u3093","\u306F\u3063\u304B\u304F","\u306F\u3064\u3099\u304D","\u306F\u3063\u304D\u308A","\u306F\u3063\u304F\u3064","\u306F\u3063\u3051\u3093","\u306F\u3063\u3053\u3046","\u306F\u3063\u3055\u3093","\u306F\u3063\u3057\u3093","\u306F\u3063\u305F\u3064","\u306F\u3063\u3061\u3085\u3046","\u306F\u3063\u3066\u3093","\u306F\u3063\u3072\u309A\u3087\u3046","\u306F\u3063\u307B\u309A\u3046","\u306F\u306A\u3059","\u306F\u306A\u3072\u3099","\u306F\u306B\u304B\u3080","\u306F\u3075\u3099\u3089\u3057","\u306F\u307F\u304B\u3099\u304D","\u306F\u3080\u304B\u3046","\u306F\u3081\u3064","\u306F\u3084\u3044","\u306F\u3084\u3057","\u306F\u3089\u3046","\u306F\u308D\u3046\u3043\u3093","\u306F\u308F\u3044","\u306F\u3093\u3044","\u306F\u3093\u3048\u3044","\u306F\u3093\u304A\u3093","\u306F\u3093\u304B\u304F","\u306F\u3093\u304D\u3087\u3046","\u306F\u3099\u3093\u304F\u3099\u307F","\u306F\u3093\u3053","\u306F\u3093\u3057\u3083","\u306F\u3093\u3059\u3046","\u306F\u3093\u305F\u3099\u3093","\u306F\u309A\u3093\u3061","\u306F\u309A\u3093\u3064","\u306F\u3093\u3066\u3044","\u306F\u3093\u3068\u3057","\u306F\u3093\u306E\u3046","\u306F\u3093\u306F\u309A","\u306F\u3093\u3075\u3099\u3093","\u306F\u3093\u3078\u309A\u3093","\u306F\u3093\u307B\u3099\u3046\u304D","\u306F\u3093\u3081\u3044","\u306F\u3093\u3089\u3093","\u306F\u3093\u308D\u3093","\u3072\u3044\u304D","\u3072\u3046\u3093","\u3072\u3048\u308B","\u3072\u304B\u304F","\u3072\u304B\u308A","\u3072\u304B\u308B","\u3072\u304B\u3093","\u3072\u304F\u3044","\u3072\u3051\u3064","\u3072\u3053\u3046\u304D","\u3072\u3053\u304F","\u3072\u3055\u3044","\u3072\u3055\u3057\u3075\u3099\u308A","\u3072\u3055\u3093","\u3072\u3099\u3057\u3099\u3085\u3064\u304B\u3093","\u3072\u3057\u3087","\u3072\u305D\u304B","\u3072\u305D\u3080","\u3072\u305F\u3080\u304D","\u3072\u305F\u3099\u308A","\u3072\u305F\u308B","\u3072\u3064\u304D\u3099","\u3072\u3063\u3053\u3057","\u3072\u3063\u3057","\u3072\u3064\u3057\u3099\u3085\u3072\u3093","\u3072\u3063\u3059","\u3072\u3064\u305B\u3099\u3093","\u3072\u309A\u3063\u305F\u308A","\u3072\u309A\u3063\u3061\u308A","\u3072\u3064\u3088\u3046","\u3072\u3066\u3044","\u3072\u3068\u3053\u3099\u307F","\u3072\u306A\u307E\u3064\u308A","\u3072\u306A\u3093","\u3072\u306D\u308B","\u3072\u306F\u3093","\u3072\u3072\u3099\u304F","\u3072\u3072\u3087\u3046","\u3072\u307B\u3046","\u3072\u307E\u308F\u308A","\u3072\u307E\u3093","\u3072\u307F\u3064","\u3072\u3081\u3044","\u3072\u3081\u3057\u3099\u3057","\u3072\u3084\u3051","\u3072\u3084\u3059","\u3072\u3088\u3046","\u3072\u3099\u3087\u3046\u304D","\u3072\u3089\u304B\u3099\u306A","\u3072\u3089\u304F","\u3072\u308A\u3064","\u3072\u308A\u3087\u3046","\u3072\u308B\u307E","\u3072\u308B\u3084\u3059\u307F","\u3072\u308C\u3044","\u3072\u308D\u3044","\u3072\u308D\u3046","\u3072\u308D\u304D","\u3072\u308D\u3086\u304D","\u3072\u3093\u304B\u304F","\u3072\u3093\u3051\u3064","\u3072\u3093\u3053\u3093","\u3072\u3093\u3057\u3085","\u3072\u3093\u305D\u3046","\u3072\u309A\u3093\u3061","\u3072\u3093\u306F\u309A\u3093","\u3072\u3099\u3093\u307B\u3099\u3046","\u3075\u3042\u3093","\u3075\u3044\u3046\u3061","\u3075\u3046\u3051\u3044","\u3075\u3046\u305B\u3093","\u3075\u309A\u3046\u305F\u308D\u3046","\u3075\u3046\u3068\u3046","\u3075\u3046\u3075","\u3075\u3048\u308B","\u3075\u304A\u3093","\u3075\u304B\u3044","\u3075\u304D\u3093","\u3075\u304F\u3055\u3099\u3064","\u3075\u304F\u3075\u3099\u304F\u308D","\u3075\u3053\u3046","\u3075\u3055\u3044","\u3075\u3057\u304D\u3099","\u3075\u3057\u3099\u307F","\u3075\u3059\u307E","\u3075\u305B\u3044","\u3075\u305B\u304F\u3099","\u3075\u305D\u304F","\u3075\u3099\u305F\u306B\u304F","\u3075\u305F\u3093","\u3075\u3061\u3087\u3046","\u3075\u3064\u3046","\u3075\u3064\u304B","\u3075\u3063\u304B\u3064","\u3075\u3063\u304D","\u3075\u3063\u3053\u304F","\u3075\u3099\u3068\u3099\u3046","\u3075\u3068\u308B","\u3075\u3068\u3093","\u3075\u306E\u3046","\u3075\u306F\u3044","\u3075\u3072\u3087\u3046","\u3075\u3078\u3093","\u3075\u307E\u3093","\u3075\u307F\u3093","\u3075\u3081\u3064","\u3075\u3081\u3093","\u3075\u3088\u3046","\u3075\u308A\u3053","\u3075\u308A\u308B","\u3075\u308B\u3044","\u3075\u3093\u3044\u304D","\u3075\u3099\u3093\u304B\u3099\u304F","\u3075\u3099\u3093\u304F\u3099","\u3075\u3093\u3057\u3064","\u3075\u3099\u3093\u305B\u304D","\u3075\u3093\u305D\u3046","\u3075\u3099\u3093\u307B\u309A\u3046","\u3078\u3044\u3042\u3093","\u3078\u3044\u304A\u3093","\u3078\u3044\u304B\u3099\u3044","\u3078\u3044\u304D","\u3078\u3044\u3051\u3099\u3093","\u3078\u3044\u3053\u3046","\u3078\u3044\u3055","\u3078\u3044\u3057\u3083","\u3078\u3044\u305B\u3064","\u3078\u3044\u305D","\u3078\u3044\u305F\u304F","\u3078\u3044\u3066\u3093","\u3078\u3044\u306D\u3064","\u3078\u3044\u308F","\u3078\u304D\u304B\u3099","\u3078\u3053\u3080","\u3078\u3099\u306B\u3044\u308D","\u3078\u3099\u306B\u3057\u3087\u3046\u304B\u3099","\u3078\u3089\u3059","\u3078\u3093\u304B\u3093","\u3078\u3099\u3093\u304D\u3087\u3046","\u3078\u3099\u3093\u3053\u3099\u3057","\u3078\u3093\u3055\u3044","\u3078\u3093\u305F\u3044","\u3078\u3099\u3093\u308A","\u307B\u3042\u3093","\u307B\u3044\u304F","\u307B\u3099\u3046\u304D\u3099\u3087","\u307B\u3046\u3053\u304F","\u307B\u3046\u305D\u3046","\u307B\u3046\u307B\u3046","\u307B\u3046\u3082\u3093","\u307B\u3046\u308A\u3064","\u307B\u3048\u308B","\u307B\u304A\u3093","\u307B\u304B\u3093","\u307B\u304D\u3087\u3046","\u307B\u3099\u304D\u3093","\u307B\u304F\u308D","\u307B\u3051\u3064","\u307B\u3051\u3093","\u307B\u3053\u3046","\u307B\u3053\u308B","\u307B\u3057\u3044","\u307B\u3057\u3064","\u307B\u3057\u3085","\u307B\u3057\u3087\u3046","\u307B\u305B\u3044","\u307B\u305D\u3044","\u307B\u305D\u304F","\u307B\u305F\u3066","\u307B\u305F\u308B","\u307B\u309A\u3061\u3075\u3099\u304F\u308D","\u307B\u3063\u304D\u3087\u304F","\u307B\u3063\u3055","\u307B\u3063\u305F\u3093","\u307B\u3068\u3093\u3068\u3099","\u307B\u3081\u308B","\u307B\u3093\u3044","\u307B\u3093\u304D","\u307B\u3093\u3051","\u307B\u3093\u3057\u3064","\u307B\u3093\u3084\u304F","\u307E\u3044\u306B\u3061","\u307E\u304B\u3044","\u307E\u304B\u305B\u308B","\u307E\u304B\u3099\u308B","\u307E\u3051\u308B","\u307E\u3053\u3068","\u307E\u3055\u3064","\u307E\u3057\u3099\u3081","\u307E\u3059\u304F","\u307E\u305B\u3099\u308B","\u307E\u3064\u308A","\u307E\u3068\u3081","\u307E\u306A\u3075\u3099","\u307E\u306C\u3051","\u307E\u306D\u304F","\u307E\u307B\u3046","\u307E\u3082\u308B","\u307E\u3086\u3051\u3099","\u307E\u3088\u3046","\u307E\u308D\u3084\u304B","\u307E\u308F\u3059","\u307E\u308F\u308A","\u307E\u308F\u308B","\u307E\u3093\u304B\u3099","\u307E\u3093\u304D\u3064","\u307E\u3093\u305D\u3099\u304F","\u307E\u3093\u306A\u304B","\u307F\u3044\u3089","\u307F\u3046\u3061","\u307F\u3048\u308B","\u307F\u304B\u3099\u304F","\u307F\u304B\u305F","\u307F\u304B\u3093","\u307F\u3051\u3093","\u307F\u3053\u3093","\u307F\u3057\u3099\u304B\u3044","\u307F\u3059\u3044","\u307F\u3059\u3048\u308B","\u307F\u305B\u308B","\u307F\u3063\u304B","\u307F\u3064\u304B\u308B","\u307F\u3064\u3051\u308B","\u307F\u3066\u3044","\u307F\u3068\u3081\u308B","\u307F\u306A\u3068","\u307F\u306A\u307F\u304B\u3055\u3044","\u307F\u306D\u3089\u308B","\u307F\u306E\u3046","\u307F\u306E\u304B\u3099\u3059","\u307F\u307B\u3093","\u307F\u3082\u3068","\u307F\u3084\u3051\u3099","\u307F\u3089\u3044","\u307F\u308A\u3087\u304F","\u307F\u308F\u304F","\u307F\u3093\u304B","\u307F\u3093\u305D\u3099\u304F","\u3080\u3044\u304B","\u3080\u3048\u304D","\u3080\u3048\u3093","\u3080\u304B\u3044","\u3080\u304B\u3046","\u3080\u304B\u3048","\u3080\u304B\u3057","\u3080\u304D\u3099\u3061\u3083","\u3080\u3051\u308B","\u3080\u3051\u3099\u3093","\u3080\u3055\u307B\u3099\u308B","\u3080\u3057\u3042\u3064\u3044","\u3080\u3057\u306F\u3099","\u3080\u3057\u3099\u3085\u3093","\u3080\u3057\u308D","\u3080\u3059\u3046","\u3080\u3059\u3053","\u3080\u3059\u3075\u3099","\u3080\u3059\u3081","\u3080\u305B\u308B","\u3080\u305B\u3093","\u3080\u3061\u3085\u3046","\u3080\u306A\u3057\u3044","\u3080\u306E\u3046","\u3080\u3084\u307F","\u3080\u3088\u3046","\u3080\u3089\u3055\u304D","\u3080\u308A\u3087\u3046","\u3080\u308D\u3093","\u3081\u3044\u3042\u3093","\u3081\u3044\u3046\u3093","\u3081\u3044\u3048\u3093","\u3081\u3044\u304B\u304F","\u3081\u3044\u304D\u3087\u304F","\u3081\u3044\u3055\u3044","\u3081\u3044\u3057","\u3081\u3044\u305D\u3046","\u3081\u3044\u3075\u3099\u3064","\u3081\u3044\u308C\u3044","\u3081\u3044\u308F\u304F","\u3081\u304F\u3099\u307E\u308C\u308B","\u3081\u3055\u3099\u3059","\u3081\u3057\u305F","\u3081\u3059\u3099\u3089\u3057\u3044","\u3081\u305F\u3099\u3064","\u3081\u307E\u3044","\u3081\u3084\u3059","\u3081\u3093\u304D\u3087","\u3081\u3093\u305B\u304D","\u3081\u3093\u3068\u3099\u3046","\u3082\u3046\u3057\u3042\u3051\u3099\u308B","\u3082\u3046\u3068\u3099\u3046\u3051\u3093","\u3082\u3048\u308B","\u3082\u304F\u3057","\u3082\u304F\u3066\u304D","\u3082\u304F\u3088\u3046\u3072\u3099","\u3082\u3061\u308D\u3093","\u3082\u3068\u3099\u308B","\u3082\u3089\u3046","\u3082\u3093\u304F","\u3082\u3093\u305F\u3099\u3044","\u3084\u304A\u3084","\u3084\u3051\u308B","\u3084\u3055\u3044","\u3084\u3055\u3057\u3044","\u3084\u3059\u3044","\u3084\u3059\u305F\u308D\u3046","\u3084\u3059\u307F","\u3084\u305B\u308B","\u3084\u305D\u3046","\u3084\u305F\u3044","\u3084\u3061\u3093","\u3084\u3063\u3068","\u3084\u3063\u306F\u309A\u308A","\u3084\u3075\u3099\u308B","\u3084\u3081\u308B","\u3084\u3084\u3053\u3057\u3044","\u3084\u3088\u3044","\u3084\u308F\u3089\u304B\u3044","\u3086\u3046\u304D","\u3086\u3046\u3072\u3099\u3093\u304D\u3087\u304F","\u3086\u3046\u3078\u3099","\u3086\u3046\u3081\u3044","\u3086\u3051\u3064","\u3086\u3057\u3085\u3064","\u3086\u305B\u3093","\u3086\u305D\u3046","\u3086\u305F\u304B","\u3086\u3061\u3083\u304F","\u3086\u3066\u3099\u308B","\u3086\u306B\u3085\u3046","\u3086\u3072\u3099\u308F","\u3086\u3089\u3044","\u3086\u308C\u308B","\u3088\u3046\u3044","\u3088\u3046\u304B","\u3088\u3046\u304D\u3085\u3046","\u3088\u3046\u3057\u3099","\u3088\u3046\u3059","\u3088\u3046\u3061\u3048\u3093","\u3088\u304B\u305B\u3099","\u3088\u304B\u3093","\u3088\u304D\u3093","\u3088\u304F\u305B\u3044","\u3088\u304F\u307B\u3099\u3046","\u3088\u3051\u3044","\u3088\u3053\u3099\u308C\u308B","\u3088\u3055\u3093","\u3088\u3057\u3085\u3046","\u3088\u305D\u3046","\u3088\u305D\u304F","\u3088\u3063\u304B","\u3088\u3066\u3044","\u3088\u3068\u3099\u304B\u3099\u308F\u304F","\u3088\u306D\u3064","\u3088\u3084\u304F","\u3088\u3086\u3046","\u3088\u308D\u3053\u3075\u3099","\u3088\u308D\u3057\u3044","\u3089\u3044\u3046","\u3089\u304F\u304B\u3099\u304D","\u3089\u304F\u3053\u3099","\u3089\u304F\u3055\u3064","\u3089\u304F\u305F\u3099","\u3089\u3057\u3093\u306F\u3099\u3093","\u3089\u305B\u3093","\u3089\u305D\u3099\u304F","\u3089\u305F\u3044","\u3089\u3063\u304B","\u3089\u308C\u3064","\u308A\u3048\u304D","\u308A\u304B\u3044","\u308A\u304D\u3055\u304F","\u308A\u304D\u305B\u3064","\u308A\u304F\u304F\u3099\u3093","\u308A\u304F\u3064","\u308A\u3051\u3093","\u308A\u3053\u3046","\u308A\u305B\u3044","\u308A\u305D\u3046","\u308A\u305D\u304F","\u308A\u3066\u3093","\u308A\u306D\u3093","\u308A\u3086\u3046","\u308A\u3085\u3046\u304B\u3099\u304F","\u308A\u3088\u3046","\u308A\u3087\u3046\u308A","\u308A\u3087\u304B\u3093","\u308A\u3087\u304F\u3061\u3083","\u308A\u3087\u3053\u3046","\u308A\u308A\u304F","\u308A\u308C\u304D","\u308A\u308D\u3093","\u308A\u3093\u3053\u3099","\u308B\u3044\u3051\u3044","\u308B\u3044\u3055\u3044","\u308B\u3044\u3057\u3099","\u308B\u3044\u305B\u304D","\u308B\u3059\u306F\u3099\u3093","\u308B\u308A\u304B\u3099\u308F\u3089","\u308C\u3044\u304B\u3093","\u308C\u3044\u304D\u3099","\u308C\u3044\u305B\u3044","\u308C\u3044\u305D\u3099\u3046\u3053","\u308C\u3044\u3068\u3046","\u308C\u3044\u307B\u3099\u3046","\u308C\u304D\u3057","\u308C\u304D\u305F\u3099\u3044","\u308C\u3093\u3042\u3044","\u308C\u3093\u3051\u3044","\u308C\u3093\u3053\u3093","\u308C\u3093\u3055\u3044","\u308C\u3093\u3057\u3085\u3046","\u308C\u3093\u305D\u3099\u304F","\u308C\u3093\u3089\u304F","\u308D\u3046\u304B","\u308D\u3046\u3053\u3099","\u308D\u3046\u3057\u3099\u3093","\u308D\u3046\u305D\u304F","\u308D\u304F\u304B\u3099","\u308D\u3053\u3064","\u308D\u3057\u3099\u3046\u3089","\u308D\u3057\u3085\u3064","\u308D\u305B\u3093","\u308D\u3066\u3093","\u308D\u3081\u3093","\u308D\u308C\u3064","\u308D\u3093\u304D\u3099","\u308D\u3093\u306F\u309A","\u308D\u3093\u3075\u3099\u3093","\u308D\u3093\u308A","\u308F\u304B\u3059","\u308F\u304B\u3081","\u308F\u304B\u3084\u307E","\u308F\u304B\u308C\u308B","\u308F\u3057\u3064","\u308F\u3057\u3099\u307E\u3057","\u308F\u3059\u308C\u3082\u306E","\u308F\u3089\u3046","\u308F\u308C\u308B"]');

});

parcelRegister("g6Pks", function(module, exports) {
module.exports = JSON.parse('["abacate","abaixo","abalar","abater","abduzir","abelha","aberto","abismo","abotoar","abranger","abreviar","abrigar","abrupto","absinto","absoluto","absurdo","abutre","acabado","acalmar","acampar","acanhar","acaso","aceitar","acelerar","acenar","acervo","acessar","acetona","achatar","acidez","acima","acionado","acirrar","aclamar","aclive","acolhida","acomodar","acoplar","acordar","acumular","acusador","adaptar","adega","adentro","adepto","adequar","aderente","adesivo","adeus","adiante","aditivo","adjetivo","adjunto","admirar","adorar","adquirir","adubo","adverso","advogado","aeronave","afastar","aferir","afetivo","afinador","afivelar","aflito","afluente","afrontar","agachar","agarrar","agasalho","agenciar","agilizar","agiota","agitado","agora","agradar","agreste","agrupar","aguardar","agulha","ajoelhar","ajudar","ajustar","alameda","alarme","alastrar","alavanca","albergue","albino","alcatra","aldeia","alecrim","alegria","alertar","alface","alfinete","algum","alheio","aliar","alicate","alienar","alinhar","aliviar","almofada","alocar","alpiste","alterar","altitude","alucinar","alugar","aluno","alusivo","alvo","amaciar","amador","amarelo","amassar","ambas","ambiente","ameixa","amenizar","amido","amistoso","amizade","amolador","amontoar","amoroso","amostra","amparar","ampliar","ampola","anagrama","analisar","anarquia","anatomia","andaime","anel","anexo","angular","animar","anjo","anomalia","anotado","ansioso","anterior","anuidade","anunciar","anzol","apagador","apalpar","apanhado","apego","apelido","apertada","apesar","apetite","apito","aplauso","aplicada","apoio","apontar","aposta","aprendiz","aprovar","aquecer","arame","aranha","arara","arcada","ardente","areia","arejar","arenito","aresta","argiloso","argola","arma","arquivo","arraial","arrebate","arriscar","arroba","arrumar","arsenal","arterial","artigo","arvoredo","asfaltar","asilado","aspirar","assador","assinar","assoalho","assunto","astral","atacado","atadura","atalho","atarefar","atear","atender","aterro","ateu","atingir","atirador","ativo","atoleiro","atracar","atrevido","atriz","atual","atum","auditor","aumentar","aura","aurora","autismo","autoria","autuar","avaliar","avante","avaria","avental","avesso","aviador","avisar","avulso","axila","azarar","azedo","azeite","azulejo","babar","babosa","bacalhau","bacharel","bacia","bagagem","baiano","bailar","baioneta","bairro","baixista","bajular","baleia","baliza","balsa","banal","bandeira","banho","banir","banquete","barato","barbado","baronesa","barraca","barulho","baseado","bastante","batata","batedor","batida","batom","batucar","baunilha","beber","beijo","beirada","beisebol","beldade","beleza","belga","beliscar","bendito","bengala","benzer","berimbau","berlinda","berro","besouro","bexiga","bezerro","bico","bicudo","bienal","bifocal","bifurcar","bigorna","bilhete","bimestre","bimotor","biologia","biombo","biosfera","bipolar","birrento","biscoito","bisneto","bispo","bissexto","bitola","bizarro","blindado","bloco","bloquear","boato","bobagem","bocado","bocejo","bochecha","boicotar","bolada","boletim","bolha","bolo","bombeiro","bonde","boneco","bonita","borbulha","borda","boreal","borracha","bovino","boxeador","branco","brasa","braveza","breu","briga","brilho","brincar","broa","brochura","bronzear","broto","bruxo","bucha","budismo","bufar","bule","buraco","busca","busto","buzina","cabana","cabelo","cabide","cabo","cabrito","cacau","cacetada","cachorro","cacique","cadastro","cadeado","cafezal","caiaque","caipira","caixote","cajado","caju","calafrio","calcular","caldeira","calibrar","calmante","calota","camada","cambista","camisa","camomila","campanha","camuflar","canavial","cancelar","caneta","canguru","canhoto","canivete","canoa","cansado","cantar","canudo","capacho","capela","capinar","capotar","capricho","captador","capuz","caracol","carbono","cardeal","careca","carimbar","carneiro","carpete","carreira","cartaz","carvalho","casaco","casca","casebre","castelo","casulo","catarata","cativar","caule","causador","cautelar","cavalo","caverna","cebola","cedilha","cegonha","celebrar","celular","cenoura","censo","centeio","cercar","cerrado","certeiro","cerveja","cetim","cevada","chacota","chaleira","chamado","chapada","charme","chatice","chave","chefe","chegada","cheiro","cheque","chicote","chifre","chinelo","chocalho","chover","chumbo","chutar","chuva","cicatriz","ciclone","cidade","cidreira","ciente","cigana","cimento","cinto","cinza","ciranda","circuito","cirurgia","citar","clareza","clero","clicar","clone","clube","coado","coagir","cobaia","cobertor","cobrar","cocada","coelho","coentro","coeso","cogumelo","coibir","coifa","coiote","colar","coleira","colher","colidir","colmeia","colono","coluna","comando","combinar","comentar","comitiva","comover","complexo","comum","concha","condor","conectar","confuso","congelar","conhecer","conjugar","consumir","contrato","convite","cooperar","copeiro","copiador","copo","coquetel","coragem","cordial","corneta","coronha","corporal","correio","cortejo","coruja","corvo","cosseno","costela","cotonete","couro","couve","covil","cozinha","cratera","cravo","creche","credor","creme","crer","crespo","criada","criminal","crioulo","crise","criticar","crosta","crua","cruzeiro","cubano","cueca","cuidado","cujo","culatra","culminar","culpar","cultura","cumprir","cunhado","cupido","curativo","curral","cursar","curto","cuspir","custear","cutelo","damasco","datar","debater","debitar","deboche","debulhar","decalque","decimal","declive","decote","decretar","dedal","dedicado","deduzir","defesa","defumar","degelo","degrau","degustar","deitado","deixar","delator","delegado","delinear","delonga","demanda","demitir","demolido","dentista","depenado","depilar","depois","depressa","depurar","deriva","derramar","desafio","desbotar","descanso","desenho","desfiado","desgaste","desigual","deslize","desmamar","desova","despesa","destaque","desviar","detalhar","detentor","detonar","detrito","deusa","dever","devido","devotado","dezena","diagrama","dialeto","didata","difuso","digitar","dilatado","diluente","diminuir","dinastia","dinheiro","diocese","direto","discreta","disfarce","disparo","disquete","dissipar","distante","ditador","diurno","diverso","divisor","divulgar","dizer","dobrador","dolorido","domador","dominado","donativo","donzela","dormente","dorsal","dosagem","dourado","doutor","drenagem","drible","drogaria","duelar","duende","dueto","duplo","duquesa","durante","duvidoso","eclodir","ecoar","ecologia","edificar","edital","educado","efeito","efetivar","ejetar","elaborar","eleger","eleitor","elenco","elevador","eliminar","elogiar","embargo","embolado","embrulho","embutido","emenda","emergir","emissor","empatia","empenho","empinado","empolgar","emprego","empurrar","emulador","encaixe","encenado","enchente","encontro","endeusar","endossar","enfaixar","enfeite","enfim","engajado","engenho","englobar","engomado","engraxar","enguia","enjoar","enlatar","enquanto","enraizar","enrolado","enrugar","ensaio","enseada","ensino","ensopado","entanto","enteado","entidade","entortar","entrada","entulho","envergar","enviado","envolver","enxame","enxerto","enxofre","enxuto","epiderme","equipar","ereto","erguido","errata","erva","ervilha","esbanjar","esbelto","escama","escola","escrita","escuta","esfinge","esfolar","esfregar","esfumado","esgrima","esmalte","espanto","espelho","espiga","esponja","espreita","espumar","esquerda","estaca","esteira","esticar","estofado","estrela","estudo","esvaziar","etanol","etiqueta","euforia","europeu","evacuar","evaporar","evasivo","eventual","evidente","evoluir","exagero","exalar","examinar","exato","exausto","excesso","excitar","exclamar","executar","exemplo","exibir","exigente","exonerar","expandir","expelir","expirar","explanar","exposto","expresso","expulsar","externo","extinto","extrato","fabricar","fabuloso","faceta","facial","fada","fadiga","faixa","falar","falta","familiar","fandango","fanfarra","fantoche","fardado","farelo","farinha","farofa","farpa","fartura","fatia","fator","favorita","faxina","fazenda","fechado","feijoada","feirante","felino","feminino","fenda","feno","fera","feriado","ferrugem","ferver","festejar","fetal","feudal","fiapo","fibrose","ficar","ficheiro","figurado","fileira","filho","filme","filtrar","firmeza","fisgada","fissura","fita","fivela","fixador","fixo","flacidez","flamingo","flanela","flechada","flora","flutuar","fluxo","focal","focinho","fofocar","fogo","foguete","foice","folgado","folheto","forjar","formiga","forno","forte","fosco","fossa","fragata","fralda","frango","frasco","fraterno","freira","frente","fretar","frieza","friso","fritura","fronha","frustrar","fruteira","fugir","fulano","fuligem","fundar","fungo","funil","furador","furioso","futebol","gabarito","gabinete","gado","gaiato","gaiola","gaivota","galega","galho","galinha","galocha","ganhar","garagem","garfo","gargalo","garimpo","garoupa","garrafa","gasoduto","gasto","gata","gatilho","gaveta","gazela","gelado","geleia","gelo","gemada","gemer","gemido","generoso","gengiva","genial","genoma","genro","geologia","gerador","germinar","gesso","gestor","ginasta","gincana","gingado","girafa","girino","glacial","glicose","global","glorioso","goela","goiaba","golfe","golpear","gordura","gorjeta","gorro","gostoso","goteira","governar","gracejo","gradual","grafite","gralha","grampo","granada","gratuito","graveto","graxa","grego","grelhar","greve","grilo","grisalho","gritaria","grosso","grotesco","grudado","grunhido","gruta","guache","guarani","guaxinim","guerrear","guiar","guincho","guisado","gula","guloso","guru","habitar","harmonia","haste","haver","hectare","herdar","heresia","hesitar","hiato","hibernar","hidratar","hiena","hino","hipismo","hipnose","hipoteca","hoje","holofote","homem","honesto","honrado","hormonal","hospedar","humorado","iate","ideia","idoso","ignorado","igreja","iguana","ileso","ilha","iludido","iluminar","ilustrar","imagem","imediato","imenso","imersivo","iminente","imitador","imortal","impacto","impedir","implante","impor","imprensa","impune","imunizar","inalador","inapto","inativo","incenso","inchar","incidir","incluir","incolor","indeciso","indireto","indutor","ineficaz","inerente","infantil","infestar","infinito","inflamar","informal","infrator","ingerir","inibido","inicial","inimigo","injetar","inocente","inodoro","inovador","inox","inquieto","inscrito","inseto","insistir","inspetor","instalar","insulto","intacto","integral","intimar","intocado","intriga","invasor","inverno","invicto","invocar","iogurte","iraniano","ironizar","irreal","irritado","isca","isento","isolado","isqueiro","italiano","janeiro","jangada","janta","jararaca","jardim","jarro","jasmim","jato","javali","jazida","jejum","joaninha","joelhada","jogador","joia","jornal","jorrar","jovem","juba","judeu","judoca","juiz","julgador","julho","jurado","jurista","juro","justa","labareda","laboral","lacre","lactante","ladrilho","lagarta","lagoa","laje","lamber","lamentar","laminar","lampejo","lanche","lapidar","lapso","laranja","lareira","largura","lasanha","lastro","lateral","latido","lavanda","lavoura","lavrador","laxante","lazer","lealdade","lebre","legado","legendar","legista","leigo","leiloar","leitura","lembrete","leme","lenhador","lentilha","leoa","lesma","leste","letivo","letreiro","levar","leveza","levitar","liberal","libido","liderar","ligar","ligeiro","limitar","limoeiro","limpador","linda","linear","linhagem","liquidez","listagem","lisura","litoral","livro","lixa","lixeira","locador","locutor","lojista","lombo","lona","longe","lontra","lorde","lotado","loteria","loucura","lousa","louvar","luar","lucidez","lucro","luneta","lustre","lutador","luva","macaco","macete","machado","macio","madeira","madrinha","magnata","magreza","maior","mais","malandro","malha","malote","maluco","mamilo","mamoeiro","mamute","manada","mancha","mandato","manequim","manhoso","manivela","manobrar","mansa","manter","manusear","mapeado","maquinar","marcador","maresia","marfim","margem","marinho","marmita","maroto","marquise","marreco","martelo","marujo","mascote","masmorra","massagem","mastigar","matagal","materno","matinal","matutar","maxilar","medalha","medida","medusa","megafone","meiga","melancia","melhor","membro","memorial","menino","menos","mensagem","mental","merecer","mergulho","mesada","mesclar","mesmo","mesquita","mestre","metade","meteoro","metragem","mexer","mexicano","micro","migalha","migrar","milagre","milenar","milhar","mimado","minerar","minhoca","ministro","minoria","miolo","mirante","mirtilo","misturar","mocidade","moderno","modular","moeda","moer","moinho","moita","moldura","moleza","molho","molinete","molusco","montanha","moqueca","morango","morcego","mordomo","morena","mosaico","mosquete","mostarda","motel","motim","moto","motriz","muda","muito","mulata","mulher","multar","mundial","munido","muralha","murcho","muscular","museu","musical","nacional","nadador","naja","namoro","narina","narrado","nascer","nativa","natureza","navalha","navegar","navio","neblina","nebuloso","negativa","negociar","negrito","nervoso","neta","neural","nevasca","nevoeiro","ninar","ninho","nitidez","nivelar","nobreza","noite","noiva","nomear","nominal","nordeste","nortear","notar","noticiar","noturno","novelo","novilho","novo","nublado","nudez","numeral","nupcial","nutrir","nuvem","obcecado","obedecer","objetivo","obrigado","obscuro","obstetra","obter","obturar","ocidente","ocioso","ocorrer","oculista","ocupado","ofegante","ofensiva","oferenda","oficina","ofuscado","ogiva","olaria","oleoso","olhar","oliveira","ombro","omelete","omisso","omitir","ondulado","oneroso","ontem","opcional","operador","oponente","oportuno","oposto","orar","orbitar","ordem","ordinal","orfanato","orgasmo","orgulho","oriental","origem","oriundo","orla","ortodoxo","orvalho","oscilar","ossada","osso","ostentar","otimismo","ousadia","outono","outubro","ouvido","ovelha","ovular","oxidar","oxigenar","pacato","paciente","pacote","pactuar","padaria","padrinho","pagar","pagode","painel","pairar","paisagem","palavra","palestra","palheta","palito","palmada","palpitar","pancada","panela","panfleto","panqueca","pantanal","papagaio","papelada","papiro","parafina","parcial","pardal","parede","partida","pasmo","passado","pastel","patamar","patente","patinar","patrono","paulada","pausar","peculiar","pedalar","pedestre","pediatra","pedra","pegada","peitoral","peixe","pele","pelicano","penca","pendurar","peneira","penhasco","pensador","pente","perceber","perfeito","pergunta","perito","permitir","perna","perplexo","persiana","pertence","peruca","pescado","pesquisa","pessoa","petiscar","piada","picado","piedade","pigmento","pilastra","pilhado","pilotar","pimenta","pincel","pinguim","pinha","pinote","pintar","pioneiro","pipoca","piquete","piranha","pires","pirueta","piscar","pistola","pitanga","pivete","planta","plaqueta","platina","plebeu","plumagem","pluvial","pneu","poda","poeira","poetisa","polegada","policiar","poluente","polvilho","pomar","pomba","ponderar","pontaria","populoso","porta","possuir","postal","pote","poupar","pouso","povoar","praia","prancha","prato","praxe","prece","predador","prefeito","premiar","prensar","preparar","presilha","pretexto","prevenir","prezar","primata","princesa","prisma","privado","processo","produto","profeta","proibido","projeto","prometer","propagar","prosa","protetor","provador","publicar","pudim","pular","pulmonar","pulseira","punhal","punir","pupilo","pureza","puxador","quadra","quantia","quarto","quase","quebrar","queda","queijo","quente","querido","quimono","quina","quiosque","rabanada","rabisco","rachar","racionar","radial","raiar","rainha","raio","raiva","rajada","ralado","ramal","ranger","ranhura","rapadura","rapel","rapidez","raposa","raquete","raridade","rasante","rascunho","rasgar","raspador","rasteira","rasurar","ratazana","ratoeira","realeza","reanimar","reaver","rebaixar","rebelde","rebolar","recado","recente","recheio","recibo","recordar","recrutar","recuar","rede","redimir","redonda","reduzida","reenvio","refinar","refletir","refogar","refresco","refugiar","regalia","regime","regra","reinado","reitor","rejeitar","relativo","remador","remendo","remorso","renovado","reparo","repelir","repleto","repolho","represa","repudiar","requerer","resenha","resfriar","resgatar","residir","resolver","respeito","ressaca","restante","resumir","retalho","reter","retirar","retomada","retratar","revelar","revisor","revolta","riacho","rica","rigidez","rigoroso","rimar","ringue","risada","risco","risonho","robalo","rochedo","rodada","rodeio","rodovia","roedor","roleta","romano","roncar","rosado","roseira","rosto","rota","roteiro","rotina","rotular","rouco","roupa","roxo","rubro","rugido","rugoso","ruivo","rumo","rupestre","russo","sabor","saciar","sacola","sacudir","sadio","safira","saga","sagrada","saibro","salada","saleiro","salgado","saliva","salpicar","salsicha","saltar","salvador","sambar","samurai","sanar","sanfona","sangue","sanidade","sapato","sarda","sargento","sarjeta","saturar","saudade","saxofone","sazonal","secar","secular","seda","sedento","sediado","sedoso","sedutor","segmento","segredo","segundo","seiva","seleto","selvagem","semanal","semente","senador","senhor","sensual","sentado","separado","sereia","seringa","serra","servo","setembro","setor","sigilo","silhueta","silicone","simetria","simpatia","simular","sinal","sincero","singular","sinopse","sintonia","sirene","siri","situado","soberano","sobra","socorro","sogro","soja","solda","soletrar","solteiro","sombrio","sonata","sondar","sonegar","sonhador","sono","soprano","soquete","sorrir","sorteio","sossego","sotaque","soterrar","sovado","sozinho","suavizar","subida","submerso","subsolo","subtrair","sucata","sucesso","suco","sudeste","sufixo","sugador","sugerir","sujeito","sulfato","sumir","suor","superior","suplicar","suposto","suprimir","surdina","surfista","surpresa","surreal","surtir","suspiro","sustento","tabela","tablete","tabuada","tacho","tagarela","talher","talo","talvez","tamanho","tamborim","tampa","tangente","tanto","tapar","tapioca","tardio","tarefa","tarja","tarraxa","tatuagem","taurino","taxativo","taxista","teatral","tecer","tecido","teclado","tedioso","teia","teimar","telefone","telhado","tempero","tenente","tensor","tentar","termal","terno","terreno","tese","tesoura","testado","teto","textura","texugo","tiara","tigela","tijolo","timbrar","timidez","tingido","tinteiro","tiragem","titular","toalha","tocha","tolerar","tolice","tomada","tomilho","tonel","tontura","topete","tora","torcido","torneio","torque","torrada","torto","tostar","touca","toupeira","toxina","trabalho","tracejar","tradutor","trafegar","trajeto","trama","trancar","trapo","traseiro","tratador","travar","treino","tremer","trepidar","trevo","triagem","tribo","triciclo","tridente","trilogia","trindade","triplo","triturar","triunfal","trocar","trombeta","trova","trunfo","truque","tubular","tucano","tudo","tulipa","tupi","turbo","turma","turquesa","tutelar","tutorial","uivar","umbigo","unha","unidade","uniforme","urologia","urso","urtiga","urubu","usado","usina","usufruir","vacina","vadiar","vagaroso","vaidoso","vala","valente","validade","valores","vantagem","vaqueiro","varanda","vareta","varrer","vascular","vasilha","vassoura","vazar","vazio","veado","vedar","vegetar","veicular","veleiro","velhice","veludo","vencedor","vendaval","venerar","ventre","verbal","verdade","vereador","vergonha","vermelho","verniz","versar","vertente","vespa","vestido","vetorial","viaduto","viagem","viajar","viatura","vibrador","videira","vidraria","viela","viga","vigente","vigiar","vigorar","vilarejo","vinco","vinheta","vinil","violeta","virada","virtude","visitar","visto","vitral","viveiro","vizinho","voador","voar","vogal","volante","voleibol","voltagem","volumoso","vontade","vulto","vuvuzela","xadrez","xarope","xeque","xeretar","xerife","xingar","zangado","zarpar","zebu","zelador","zombar","zoologia","zumbido"]');

});

parcelRegister("ml96a", function(module, exports) {
module.exports = JSON.parse('["abandon","ability","able","about","above","absent","absorb","abstract","absurd","abuse","access","accident","account","accuse","achieve","acid","acoustic","acquire","across","act","action","actor","actress","actual","adapt","add","addict","address","adjust","admit","adult","advance","advice","aerobic","affair","afford","afraid","again","age","agent","agree","ahead","aim","air","airport","aisle","alarm","album","alcohol","alert","alien","all","alley","allow","almost","alone","alpha","already","also","alter","always","amateur","amazing","among","amount","amused","analyst","anchor","ancient","anger","angle","angry","animal","ankle","announce","annual","another","answer","antenna","antique","anxiety","any","apart","apology","appear","apple","approve","april","arch","arctic","area","arena","argue","arm","armed","armor","army","around","arrange","arrest","arrive","arrow","art","artefact","artist","artwork","ask","aspect","assault","asset","assist","assume","asthma","athlete","atom","attack","attend","attitude","attract","auction","audit","august","aunt","author","auto","autumn","average","avocado","avoid","awake","aware","away","awesome","awful","awkward","axis","baby","bachelor","bacon","badge","bag","balance","balcony","ball","bamboo","banana","banner","bar","barely","bargain","barrel","base","basic","basket","battle","beach","bean","beauty","because","become","beef","before","begin","behave","behind","believe","below","belt","bench","benefit","best","betray","better","between","beyond","bicycle","bid","bike","bind","biology","bird","birth","bitter","black","blade","blame","blanket","blast","bleak","bless","blind","blood","blossom","blouse","blue","blur","blush","board","boat","body","boil","bomb","bone","bonus","book","boost","border","boring","borrow","boss","bottom","bounce","box","boy","bracket","brain","brand","brass","brave","bread","breeze","brick","bridge","brief","bright","bring","brisk","broccoli","broken","bronze","broom","brother","brown","brush","bubble","buddy","budget","buffalo","build","bulb","bulk","bullet","bundle","bunker","burden","burger","burst","bus","business","busy","butter","buyer","buzz","cabbage","cabin","cable","cactus","cage","cake","call","calm","camera","camp","can","canal","cancel","candy","cannon","canoe","canvas","canyon","capable","capital","captain","car","carbon","card","cargo","carpet","carry","cart","case","cash","casino","castle","casual","cat","catalog","catch","category","cattle","caught","cause","caution","cave","ceiling","celery","cement","census","century","cereal","certain","chair","chalk","champion","change","chaos","chapter","charge","chase","chat","cheap","check","cheese","chef","cherry","chest","chicken","chief","child","chimney","choice","choose","chronic","chuckle","chunk","churn","cigar","cinnamon","circle","citizen","city","civil","claim","clap","clarify","claw","clay","clean","clerk","clever","click","client","cliff","climb","clinic","clip","clock","clog","close","cloth","cloud","clown","club","clump","cluster","clutch","coach","coast","coconut","code","coffee","coil","coin","collect","color","column","combine","come","comfort","comic","common","company","concert","conduct","confirm","congress","connect","consider","control","convince","cook","cool","copper","copy","coral","core","corn","correct","cost","cotton","couch","country","couple","course","cousin","cover","coyote","crack","cradle","craft","cram","crane","crash","crater","crawl","crazy","cream","credit","creek","crew","cricket","crime","crisp","critic","crop","cross","crouch","crowd","crucial","cruel","cruise","crumble","crunch","crush","cry","crystal","cube","culture","cup","cupboard","curious","current","curtain","curve","cushion","custom","cute","cycle","dad","damage","damp","dance","danger","daring","dash","daughter","dawn","day","deal","debate","debris","decade","december","decide","decline","decorate","decrease","deer","defense","define","defy","degree","delay","deliver","demand","demise","denial","dentist","deny","depart","depend","deposit","depth","deputy","derive","describe","desert","design","desk","despair","destroy","detail","detect","develop","device","devote","diagram","dial","diamond","diary","dice","diesel","diet","differ","digital","dignity","dilemma","dinner","dinosaur","direct","dirt","disagree","discover","disease","dish","dismiss","disorder","display","distance","divert","divide","divorce","dizzy","doctor","document","dog","doll","dolphin","domain","donate","donkey","donor","door","dose","double","dove","draft","dragon","drama","drastic","draw","dream","dress","drift","drill","drink","drip","drive","drop","drum","dry","duck","dumb","dune","during","dust","dutch","duty","dwarf","dynamic","eager","eagle","early","earn","earth","easily","east","easy","echo","ecology","economy","edge","edit","educate","effort","egg","eight","either","elbow","elder","electric","elegant","element","elephant","elevator","elite","else","embark","embody","embrace","emerge","emotion","employ","empower","empty","enable","enact","end","endless","endorse","enemy","energy","enforce","engage","engine","enhance","enjoy","enlist","enough","enrich","enroll","ensure","enter","entire","entry","envelope","episode","equal","equip","era","erase","erode","erosion","error","erupt","escape","essay","essence","estate","eternal","ethics","evidence","evil","evoke","evolve","exact","example","excess","exchange","excite","exclude","excuse","execute","exercise","exhaust","exhibit","exile","exist","exit","exotic","expand","expect","expire","explain","expose","express","extend","extra","eye","eyebrow","fabric","face","faculty","fade","faint","faith","fall","false","fame","family","famous","fan","fancy","fantasy","farm","fashion","fat","fatal","father","fatigue","fault","favorite","feature","february","federal","fee","feed","feel","female","fence","festival","fetch","fever","few","fiber","fiction","field","figure","file","film","filter","final","find","fine","finger","finish","fire","firm","first","fiscal","fish","fit","fitness","fix","flag","flame","flash","flat","flavor","flee","flight","flip","float","flock","floor","flower","fluid","flush","fly","foam","focus","fog","foil","fold","follow","food","foot","force","forest","forget","fork","fortune","forum","forward","fossil","foster","found","fox","fragile","frame","frequent","fresh","friend","fringe","frog","front","frost","frown","frozen","fruit","fuel","fun","funny","furnace","fury","future","gadget","gain","galaxy","gallery","game","gap","garage","garbage","garden","garlic","garment","gas","gasp","gate","gather","gauge","gaze","general","genius","genre","gentle","genuine","gesture","ghost","giant","gift","giggle","ginger","giraffe","girl","give","glad","glance","glare","glass","glide","glimpse","globe","gloom","glory","glove","glow","glue","goat","goddess","gold","good","goose","gorilla","gospel","gossip","govern","gown","grab","grace","grain","grant","grape","grass","gravity","great","green","grid","grief","grit","grocery","group","grow","grunt","guard","guess","guide","guilt","guitar","gun","gym","habit","hair","half","hammer","hamster","hand","happy","harbor","hard","harsh","harvest","hat","have","hawk","hazard","head","health","heart","heavy","hedgehog","height","hello","helmet","help","hen","hero","hidden","high","hill","hint","hip","hire","history","hobby","hockey","hold","hole","holiday","hollow","home","honey","hood","hope","horn","horror","horse","hospital","host","hotel","hour","hover","hub","huge","human","humble","humor","hundred","hungry","hunt","hurdle","hurry","hurt","husband","hybrid","ice","icon","idea","identify","idle","ignore","ill","illegal","illness","image","imitate","immense","immune","impact","impose","improve","impulse","inch","include","income","increase","index","indicate","indoor","industry","infant","inflict","inform","inhale","inherit","initial","inject","injury","inmate","inner","innocent","input","inquiry","insane","insect","inside","inspire","install","intact","interest","into","invest","invite","involve","iron","island","isolate","issue","item","ivory","jacket","jaguar","jar","jazz","jealous","jeans","jelly","jewel","job","join","joke","journey","joy","judge","juice","jump","jungle","junior","junk","just","kangaroo","keen","keep","ketchup","key","kick","kid","kidney","kind","kingdom","kiss","kit","kitchen","kite","kitten","kiwi","knee","knife","knock","know","lab","label","labor","ladder","lady","lake","lamp","language","laptop","large","later","latin","laugh","laundry","lava","law","lawn","lawsuit","layer","lazy","leader","leaf","learn","leave","lecture","left","leg","legal","legend","leisure","lemon","lend","length","lens","leopard","lesson","letter","level","liar","liberty","library","license","life","lift","light","like","limb","limit","link","lion","liquid","list","little","live","lizard","load","loan","lobster","local","lock","logic","lonely","long","loop","lottery","loud","lounge","love","loyal","lucky","luggage","lumber","lunar","lunch","luxury","lyrics","machine","mad","magic","magnet","maid","mail","main","major","make","mammal","man","manage","mandate","mango","mansion","manual","maple","marble","march","margin","marine","market","marriage","mask","mass","master","match","material","math","matrix","matter","maximum","maze","meadow","mean","measure","meat","mechanic","medal","media","melody","melt","member","memory","mention","menu","mercy","merge","merit","merry","mesh","message","metal","method","middle","midnight","milk","million","mimic","mind","minimum","minor","minute","miracle","mirror","misery","miss","mistake","mix","mixed","mixture","mobile","model","modify","mom","moment","monitor","monkey","monster","month","moon","moral","more","morning","mosquito","mother","motion","motor","mountain","mouse","move","movie","much","muffin","mule","multiply","muscle","museum","mushroom","music","must","mutual","myself","mystery","myth","naive","name","napkin","narrow","nasty","nation","nature","near","neck","need","negative","neglect","neither","nephew","nerve","nest","net","network","neutral","never","news","next","nice","night","noble","noise","nominee","noodle","normal","north","nose","notable","note","nothing","notice","novel","now","nuclear","number","nurse","nut","oak","obey","object","oblige","obscure","observe","obtain","obvious","occur","ocean","october","odor","off","offer","office","often","oil","okay","old","olive","olympic","omit","once","one","onion","online","only","open","opera","opinion","oppose","option","orange","orbit","orchard","order","ordinary","organ","orient","original","orphan","ostrich","other","outdoor","outer","output","outside","oval","oven","over","own","owner","oxygen","oyster","ozone","pact","paddle","page","pair","palace","palm","panda","panel","panic","panther","paper","parade","parent","park","parrot","party","pass","patch","path","patient","patrol","pattern","pause","pave","payment","peace","peanut","pear","peasant","pelican","pen","penalty","pencil","people","pepper","perfect","permit","person","pet","phone","photo","phrase","physical","piano","picnic","picture","piece","pig","pigeon","pill","pilot","pink","pioneer","pipe","pistol","pitch","pizza","place","planet","plastic","plate","play","please","pledge","pluck","plug","plunge","poem","poet","point","polar","pole","police","pond","pony","pool","popular","portion","position","possible","post","potato","pottery","poverty","powder","power","practice","praise","predict","prefer","prepare","present","pretty","prevent","price","pride","primary","print","priority","prison","private","prize","problem","process","produce","profit","program","project","promote","proof","property","prosper","protect","proud","provide","public","pudding","pull","pulp","pulse","pumpkin","punch","pupil","puppy","purchase","purity","purpose","purse","push","put","puzzle","pyramid","quality","quantum","quarter","question","quick","quit","quiz","quote","rabbit","raccoon","race","rack","radar","radio","rail","rain","raise","rally","ramp","ranch","random","range","rapid","rare","rate","rather","raven","raw","razor","ready","real","reason","rebel","rebuild","recall","receive","recipe","record","recycle","reduce","reflect","reform","refuse","region","regret","regular","reject","relax","release","relief","rely","remain","remember","remind","remove","render","renew","rent","reopen","repair","repeat","replace","report","require","rescue","resemble","resist","resource","response","result","retire","retreat","return","reunion","reveal","review","reward","rhythm","rib","ribbon","rice","rich","ride","ridge","rifle","right","rigid","ring","riot","ripple","risk","ritual","rival","river","road","roast","robot","robust","rocket","romance","roof","rookie","room","rose","rotate","rough","round","route","royal","rubber","rude","rug","rule","run","runway","rural","sad","saddle","sadness","safe","sail","salad","salmon","salon","salt","salute","same","sample","sand","satisfy","satoshi","sauce","sausage","save","say","scale","scan","scare","scatter","scene","scheme","school","science","scissors","scorpion","scout","scrap","screen","script","scrub","sea","search","season","seat","second","secret","section","security","seed","seek","segment","select","sell","seminar","senior","sense","sentence","series","service","session","settle","setup","seven","shadow","shaft","shallow","share","shed","shell","sheriff","shield","shift","shine","ship","shiver","shock","shoe","shoot","shop","short","shoulder","shove","shrimp","shrug","shuffle","shy","sibling","sick","side","siege","sight","sign","silent","silk","silly","silver","similar","simple","since","sing","siren","sister","situate","six","size","skate","sketch","ski","skill","skin","skirt","skull","slab","slam","sleep","slender","slice","slide","slight","slim","slogan","slot","slow","slush","small","smart","smile","smoke","smooth","snack","snake","snap","sniff","snow","soap","soccer","social","sock","soda","soft","solar","soldier","solid","solution","solve","someone","song","soon","sorry","sort","soul","sound","soup","source","south","space","spare","spatial","spawn","speak","special","speed","spell","spend","sphere","spice","spider","spike","spin","spirit","split","spoil","sponsor","spoon","sport","spot","spray","spread","spring","spy","square","squeeze","squirrel","stable","stadium","staff","stage","stairs","stamp","stand","start","state","stay","steak","steel","stem","step","stereo","stick","still","sting","stock","stomach","stone","stool","story","stove","strategy","street","strike","strong","struggle","student","stuff","stumble","style","subject","submit","subway","success","such","sudden","suffer","sugar","suggest","suit","summer","sun","sunny","sunset","super","supply","supreme","sure","surface","surge","surprise","surround","survey","suspect","sustain","swallow","swamp","swap","swarm","swear","sweet","swift","swim","swing","switch","sword","symbol","symptom","syrup","system","table","tackle","tag","tail","talent","talk","tank","tape","target","task","taste","tattoo","taxi","teach","team","tell","ten","tenant","tennis","tent","term","test","text","thank","that","theme","then","theory","there","they","thing","this","thought","three","thrive","throw","thumb","thunder","ticket","tide","tiger","tilt","timber","time","tiny","tip","tired","tissue","title","toast","tobacco","today","toddler","toe","together","toilet","token","tomato","tomorrow","tone","tongue","tonight","tool","tooth","top","topic","topple","torch","tornado","tortoise","toss","total","tourist","toward","tower","town","toy","track","trade","traffic","tragic","train","transfer","trap","trash","travel","tray","treat","tree","trend","trial","tribe","trick","trigger","trim","trip","trophy","trouble","truck","true","truly","trumpet","trust","truth","try","tube","tuition","tumble","tuna","tunnel","turkey","turn","turtle","twelve","twenty","twice","twin","twist","two","type","typical","ugly","umbrella","unable","unaware","uncle","uncover","under","undo","unfair","unfold","unhappy","uniform","unique","unit","universe","unknown","unlock","until","unusual","unveil","update","upgrade","uphold","upon","upper","upset","urban","urge","usage","use","used","useful","useless","usual","utility","vacant","vacuum","vague","valid","valley","valve","van","vanish","vapor","various","vast","vault","vehicle","velvet","vendor","venture","venue","verb","verify","version","very","vessel","veteran","viable","vibrant","vicious","victory","video","view","village","vintage","violin","virtual","virus","visa","visit","visual","vital","vivid","vocal","voice","void","volcano","volume","vote","voyage","wage","wagon","wait","walk","wall","walnut","want","warfare","warm","warrior","wash","wasp","waste","water","wave","way","wealth","weapon","wear","weasel","weather","web","wedding","weekend","weird","welcome","west","wet","whale","what","wheat","wheel","when","where","whip","whisper","wide","width","wife","wild","will","win","window","wine","wing","wink","winner","winter","wire","wisdom","wise","wish","witness","wolf","woman","wonder","wood","wool","word","work","world","worry","worth","wrap","wreck","wrestle","wrist","write","wrong","yard","year","yellow","you","young","youth","zebra","zero","zone","zoo"]');

});



parcelRegister("5E8Co", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $ihoyg = parcelRequire("ihoyg");
var $41c75f91d53b5439$require$Buffer = $ihoyg.Buffer;

!function(globals) {
    "use strict";
    //*** UMD BEGIN
    if (typeof define !== "undefined" && define.amd) define([], function() {
        return secureRandom;
    });
    else if (0, module.exports) module.exports = secureRandom;
    else globals.secureRandom = secureRandom;
    //*** UMD END
    //options.type is the only valid option
    function secureRandom(count, options) {
        options = options || {
            type: "Array"
        };
        //we check for process.pid to prevent browserify from tricking us
        if (typeof $4TNnu != "undefined" && typeof $4TNnu.pid == "number" && $4TNnu.versions && $4TNnu.versions.node) return nodeRandom(count, options);
        else {
            var crypto = window.crypto || window.msCrypto;
            if (!crypto) throw new Error("Your browser does not support window.crypto.");
            return browserRandom(count, options);
        }
    }
    function nodeRandom(count, options) {
        var crypto = (parcelRequire("5Io6y"));
        var buf = crypto.randomBytes(count);
        switch(options.type){
            case "Array":
                return [].slice.call(buf);
            case "Buffer":
                return buf;
            case "Uint8Array":
                var arr = new Uint8Array(count);
                for(var i = 0; i < count; ++i)arr[i] = buf.readUInt8(i);
                return arr;
            default:
                throw new Error(options.type + " is unsupported.");
        }
    }
    function browserRandom(count, options) {
        var nativeArr = new Uint8Array(count);
        var crypto = window.crypto || window.msCrypto;
        crypto.getRandomValues(nativeArr);
        switch(options.type){
            case "Array":
                return [].slice.call(nativeArr);
            case "Buffer":
                try {
                    var b = new $41c75f91d53b5439$require$Buffer(1);
                } catch (e) {
                    throw new Error("Buffer not supported in this environment. Use Node.js or Browserify for browser support.");
                }
                return new $41c75f91d53b5439$require$Buffer(nativeArr);
            case "Uint8Array":
                return nativeArr;
            default:
                throw new Error(options.type + " is unsupported.");
        }
    }
    secureRandom.randomArray = function(byteCount) {
        return secureRandom(byteCount, {
            type: "Array"
        });
    };
    secureRandom.randomUint8Array = function(byteCount) {
        return secureRandom(byteCount, {
            type: "Uint8Array"
        });
    };
    secureRandom.randomBuffer = function(byteCount) {
        return secureRandom(byteCount, {
            type: "Buffer"
        });
    };
}(module.exports);

});

parcelRegister("luOI8", function(module, exports) {

var $7Ebry = parcelRequire("7Ebry");

var $4QNK6 = parcelRequire("4QNK6");
var $fa63bc7178f44c6c$var$uuid = $4QNK6;
$fa63bc7178f44c6c$var$uuid.v1 = $7Ebry;
$fa63bc7178f44c6c$var$uuid.v4 = $4QNK6;
module.exports = $fa63bc7178f44c6c$var$uuid;

});
parcelRegister("7Ebry", function(module, exports) {

var $kzPP1 = parcelRequire("kzPP1");

var $hQS9Z = parcelRequire("hQS9Z");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $59152544e52bcfe4$var$_nodeId;
var $59152544e52bcfe4$var$_clockseq;
// Previous uuid creation time
var $59152544e52bcfe4$var$_lastMSecs = 0;
var $59152544e52bcfe4$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $59152544e52bcfe4$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $59152544e52bcfe4$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $59152544e52bcfe4$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $kzPP1();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $59152544e52bcfe4$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $59152544e52bcfe4$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $59152544e52bcfe4$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $59152544e52bcfe4$var$_lastMSecs + (nsecs - $59152544e52bcfe4$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $59152544e52bcfe4$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $59152544e52bcfe4$var$_lastMSecs = msecs;
    $59152544e52bcfe4$var$_lastNSecs = nsecs;
    $59152544e52bcfe4$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $hQS9Z(b);
}
module.exports = $59152544e52bcfe4$var$v1;

});
parcelRegister("kzPP1", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $efaf4645e75faaa5$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($efaf4645e75faaa5$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $efaf4645e75faaa5$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $efaf4645e75faaa5$var$getRandomValues($efaf4645e75faaa5$var$rnds8);
        return $efaf4645e75faaa5$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $efaf4645e75faaa5$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $efaf4645e75faaa5$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $efaf4645e75faaa5$var$rnds;
    };
}

});

parcelRegister("hQS9Z", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $cff14e1635e35fc6$var$byteToHex = [];
for(var $cff14e1635e35fc6$var$i = 0; $cff14e1635e35fc6$var$i < 256; ++$cff14e1635e35fc6$var$i)$cff14e1635e35fc6$var$byteToHex[$cff14e1635e35fc6$var$i] = ($cff14e1635e35fc6$var$i + 0x100).toString(16).substr(1);
function $cff14e1635e35fc6$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $cff14e1635e35fc6$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $cff14e1635e35fc6$var$bytesToUuid;

});


parcelRegister("4QNK6", function(module, exports) {

var $kzPP1 = parcelRequire("kzPP1");

var $hQS9Z = parcelRequire("hQS9Z");
function $38829a98cf252fbf$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $kzPP1)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $hQS9Z(rnds);
}
module.exports = $38829a98cf252fbf$var$v4;

});


parcelRegister("1ZFs6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j0qjh = parcelRequire("j0qjh");
Object.keys($j0qjh).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $j0qjh[key];
        }
    });
});

var $aERsS = parcelRequire("aERsS");
Object.keys($aERsS).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $aERsS[key];
        }
    });
});

var $ddfDI = parcelRequire("ddfDI");
Object.keys($ddfDI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $ddfDI[key];
        }
    });
});

var $f8MQV = parcelRequire("f8MQV");
Object.keys($f8MQV).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $f8MQV[key];
        }
    });
});

var $hWh1h = parcelRequire("hWh1h");
Object.keys($hWh1h).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $hWh1h[key];
        }
    });
});

});
parcelRegister("j0qjh", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $dd626d026b9181be$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculateSwapID = module.exports.calculateRandomNumberHash = module.exports.sha3 = module.exports.sha256 = module.exports.sha256ripemd160 = module.exports.ensureHex = module.exports.isHex = module.exports.reverseHex = module.exports.reverseArray = module.exports.hexXor = module.exports.num2VarInt = module.exports.num2hexstring = module.exports.int2hex = module.exports.hexstring2str = module.exports.str2hexstring = module.exports.ab2hexstring = module.exports.hexstring2ab = module.exports.str2ab = module.exports.ab2str = void 0;

var $dd626d026b9181be$var$_typeof2 = $2ZnTs((parcelRequire("crtHL")));

var $dd626d026b9181be$var$_encHex = $2ZnTs((parcelRequire("jFVGA")));

var $dd626d026b9181be$var$_ripemd = $2ZnTs((parcelRequire("clFak")));

var $dd626d026b9181be$var$_sha = $2ZnTs((parcelRequire("biekZ")));

var $dd626d026b9181be$var$_sha2 = $2ZnTs((parcelRequire("6aHME")));

var $dd626d026b9181be$var$crypto = $3sU9H((parcelRequire("kYX0e")));
/**
 * @param {arrayBuffer} buf
 * @returns {string} ASCII string
 */ var $dd626d026b9181be$var$ab2str = function ab2str(buf) {
    var numArr = [];
    for(var i = 0, len = buf.length; i < len; i++)numArr.push(buf[i]);
    String.fromCharCode.apply(null, numArr);
};
/**
 * @param {string} str - ASCII string
 * @returns {arrayBuffer}
 */ module.exports.ab2str = $dd626d026b9181be$var$ab2str;
var $dd626d026b9181be$var$str2ab = function str2ab(str) {
    if (typeof str !== "string") throw new Error("str2ab expects a string");
    var result = new Uint8Array(str.length);
    for(var i = 0, strLen = str.length; i < strLen; i++)result[i] = str.charCodeAt(i);
    return result;
};
/**
 * @param {string} str - HEX string
 * @returns {number[]}
 */ module.exports.str2ab = $dd626d026b9181be$var$str2ab;
var $dd626d026b9181be$var$hexstring2ab = function hexstring2ab(str) {
    $dd626d026b9181be$var$ensureHex(str);
    if (!str.length) return new Uint8Array();
    var iters = str.length / 2;
    var result = new Uint8Array(iters);
    for(var i = 0; i < iters; i++){
        result[i] = parseInt(str.substring(0, 2), 16);
        str = str.substring(2);
    }
    return result;
};
/**
 * @param {arrayBuffer} arr
 * @returns {string} HEX string
 */ module.exports.hexstring2ab = $dd626d026b9181be$var$hexstring2ab;
var $dd626d026b9181be$var$ab2hexstring = function ab2hexstring(arr) {
    if ((0, $dd626d026b9181be$var$_typeof2["default"])(arr) !== "object") throw new Error("ab2hexstring expects an array");
    var result = "";
    for(var i = 0; i < arr.length; i++){
        var str = arr[i].toString(16);
        str = str.length === 0 ? "00" : str.length === 1 ? "0" + str : str;
        result += str;
    }
    return result;
};
/**
 * @param {string} str - ASCII string
 * @returns {string} HEX string
 */ module.exports.ab2hexstring = $dd626d026b9181be$var$ab2hexstring;
var $dd626d026b9181be$var$str2hexstring = function str2hexstring(str) {
    return $dd626d026b9181be$var$ab2hexstring($dd626d026b9181be$var$str2ab(str));
};
/**
 * @param {string} hexstring - HEX string
 * @returns {string} ASCII string
 */ module.exports.str2hexstring = $dd626d026b9181be$var$str2hexstring;
var $dd626d026b9181be$var$hexstring2str = function hexstring2str(hexstring) {
    return $dd626d026b9181be$var$ab2str($dd626d026b9181be$var$hexstring2ab(hexstring));
};
/**
 * convert an integer to big endian hex and add leading zeros
 * @param {Number} num
 * @returns {string}
 */ module.exports.hexstring2str = $dd626d026b9181be$var$hexstring2str;
var $dd626d026b9181be$var$int2hex = function int2hex(num) {
    if (typeof num !== "number") throw new Error("int2hex expects a number");
    var h = num.toString(16);
    return h.length % 2 ? "0" + h : h;
};
/**
 * Converts a number to a big endian hexstring of a suitable size, optionally little endian
 * @param {Number} num
 * @param {Number} size - The required size in bytes, eg 1 for Uint8, 2 for Uint16. Defaults to 1.
 * @param {Boolean} littleEndian - Encode the hex in little endian form
 * @return {string}
 */ module.exports.int2hex = $dd626d026b9181be$var$int2hex;
var $dd626d026b9181be$var$num2hexstring = function num2hexstring(num) {
    var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var littleEndian = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (typeof num !== "number") throw new Error("num must be numeric");
    if (num < 0) throw new RangeError("num is unsigned (>= 0)");
    if (size % 1 !== 0) throw new Error("size must be a whole integer");
    if (!Number.isSafeInteger(num)) throw new RangeError("num (".concat(num, ") must be a safe integer"));
    size = size * 2;
    var hexstring = num.toString(16);
    hexstring = hexstring.length % size === 0 ? hexstring : ("0".repeat(size) + hexstring).substring(hexstring.length);
    if (littleEndian) hexstring = $dd626d026b9181be$var$reverseHex(hexstring);
    return hexstring;
};
/**
 * Converts a number to a variable length Int. Used for array length header
 * @param {Number} num - The number
 * @returns {string} hexstring of the variable Int.
 */ module.exports.num2hexstring = $dd626d026b9181be$var$num2hexstring;
var $dd626d026b9181be$var$num2VarInt = function num2VarInt(num) {
    if (num < 0xfd) return $dd626d026b9181be$var$num2hexstring(num);
    else if (num <= 0xffff) // uint16
    return "fd" + $dd626d026b9181be$var$num2hexstring(num, 2, true);
    else if (num <= 0xffffffff) // uint32
    return "fe" + $dd626d026b9181be$var$num2hexstring(num, 4, true);
    else // uint64
    return "ff" + $dd626d026b9181be$var$num2hexstring(num, 8, true);
};
/**
 * XORs two hexstrings
 * @param {string} str1 - HEX string
 * @param {string} str2 - HEX string
 * @returns {string} XOR output as a HEX string
 */ module.exports.num2VarInt = $dd626d026b9181be$var$num2VarInt;
var $dd626d026b9181be$var$hexXor = function hexXor(str1, str2) {
    $dd626d026b9181be$var$ensureHex(str1);
    $dd626d026b9181be$var$ensureHex(str2);
    if (str1.length !== str2.length) throw new Error("strings are disparate lengths");
    var result = [];
    for(var i = 0; i < str1.length; i += 2)result.push(parseInt(str1.substr(i, 2), 16) ^ parseInt(str2.substr(i, 2), 16));
    return $dd626d026b9181be$var$ab2hexstring(result);
};
/**
 * Reverses an array. Accepts arrayBuffer.
 * @param {Array} arr
 * @returns {Uint8Array}
 */ module.exports.hexXor = $dd626d026b9181be$var$hexXor;
var $dd626d026b9181be$var$reverseArray = function reverseArray(arr) {
    if ((0, $dd626d026b9181be$var$_typeof2["default"])(arr) !== "object" || !arr.length) throw new Error("reverseArray expects an array");
    var result = new Uint8Array(arr.length);
    for(var i = 0; i < arr.length; i++)result[i] = arr[arr.length - 1 - i];
    return result;
};
/**
 * Reverses a HEX string, treating 2 chars as a byte.
 * @example
 * reverseHex('abcdef') = 'efcdab'
 * @param {string} hex - HEX string
 * @return {string} HEX string reversed in 2s.
 */ module.exports.reverseArray = $dd626d026b9181be$var$reverseArray;
var $dd626d026b9181be$var$reverseHex = function reverseHex(hex) {
    $dd626d026b9181be$var$ensureHex(hex);
    var out = "";
    for(var i = hex.length - 2; i >= 0; i -= 2)out += hex.substr(i, 2);
    return out;
};
module.exports.reverseHex = $dd626d026b9181be$var$reverseHex;
var $dd626d026b9181be$var$hexRegex = /^([0-9A-Fa-f]{2})*$/;
/**
 * Checks if input is a hexstring. Empty string is considered a hexstring.
 * @example
 * isHex('0101') = true
 * isHex('') = true
 * isHex('0x01') = false
 * @param {string} str
 * @return {boolean}
 */ var $dd626d026b9181be$var$isHex = function isHex(str) {
    try {
        return $dd626d026b9181be$var$hexRegex.test(str);
    } catch (err) {
        return false;
    }
};
/**
 * Throws an error if input is not hexstring.
 * @param {string} str
 */ module.exports.isHex = $dd626d026b9181be$var$isHex;
var $dd626d026b9181be$var$ensureHex = function ensureHex(str) {
    if (!$dd626d026b9181be$var$isHex(str)) throw new Error("Expected a hexstring but got ".concat(str));
};
/**
 * Computes a SHA256 followed by a RIPEMD160.
 * @param {string} hex message to hash
 * @returns {string} hash output
 */ module.exports.ensureHex = $dd626d026b9181be$var$ensureHex;
var $dd626d026b9181be$var$sha256ripemd160 = function sha256ripemd160(hex) {
    if (typeof hex !== "string") throw new Error("sha256ripemd160 expects a string");
    if (hex.length % 2 !== 0) throw new Error("invalid hex string length: ".concat(hex));
    var hexEncoded = $dd626d026b9181be$var$_encHex["default"].parse(hex);
    var ProgramSha256 = (0, $dd626d026b9181be$var$_sha["default"])(hexEncoded);
    return (0, $dd626d026b9181be$var$_ripemd["default"])(ProgramSha256).toString();
};
/**
 * Computes a single SHA256 digest.
 * @param {string} hex message to hash
 * @returns {string} hash output
 */ module.exports.sha256ripemd160 = $dd626d026b9181be$var$sha256ripemd160;
var $dd626d026b9181be$var$sha256 = function sha256(hex) {
    if (typeof hex !== "string") throw new Error("sha256 expects a hex string");
    if (hex.length % 2 !== 0) throw new Error("invalid hex string length: ".concat(hex));
    var hexEncoded = $dd626d026b9181be$var$_encHex["default"].parse(hex);
    return (0, $dd626d026b9181be$var$_sha["default"])(hexEncoded).toString();
};
/**
 * Computes a single SHA3 (Keccak) digest.
 * @param {string} hex message to hash
 * @returns {string} hash output
 */ module.exports.sha256 = $dd626d026b9181be$var$sha256;
var $dd626d026b9181be$var$sha3 = function sha3(hex) {
    if (typeof hex !== "string") throw new Error("sha3 expects a hex string");
    if (hex.length % 2 !== 0) throw new Error("invalid hex string length: ".concat(hex));
    var hexEncoded = $dd626d026b9181be$var$_encHex["default"].parse(hex);
    return (0, $dd626d026b9181be$var$_sha2["default"])(hexEncoded).toString();
};
/**
 * Computes sha256 of random number and timestamp
 * @param {String} randomNumber
 * @param {Number} timestamp
 * @returns {string} sha256 result
 */ module.exports.sha3 = $dd626d026b9181be$var$sha3;
var $dd626d026b9181be$var$calculateRandomNumberHash = function calculateRandomNumberHash(randomNumber, timestamp) {
    var timestampHexStr = timestamp.toString(16);
    var timestampHexStrFormat = timestampHexStr;
    for(var i = 0; i < 16 - timestampHexStr.length; i++)timestampHexStrFormat = "0" + timestampHexStrFormat;
    var timestampBytes = $dd626d026b9181be$require$Buffer.from(timestampHexStrFormat, "hex");
    var newBuffer = $dd626d026b9181be$require$Buffer.concat([
        $dd626d026b9181be$require$Buffer.from(randomNumber, "hex"),
        timestampBytes
    ]);
    return $dd626d026b9181be$var$sha256(newBuffer.toString("hex"));
};
/**
 * Computes swapID
 * @param {String} randomNumberHash
 * @param {String} sender
 * @param {String} senderOtherChain
 * @returns {string} sha256 result
 */ module.exports.calculateRandomNumberHash = $dd626d026b9181be$var$calculateRandomNumberHash;
var $dd626d026b9181be$var$calculateSwapID = function calculateSwapID(randomNumberHash, sender, senderOtherChain) {
    var randomNumberHashBytes = $dd626d026b9181be$require$Buffer.from(randomNumberHash, "hex");
    var senderBytes = $dd626d026b9181be$var$crypto.decodeAddress(sender);
    var sendOtherChainBytes = $dd626d026b9181be$require$Buffer.from(senderOtherChain.toLowerCase(), "utf8");
    var newBuffer = $dd626d026b9181be$require$Buffer.concat([
        randomNumberHashBytes,
        senderBytes,
        sendOtherChainBytes
    ]);
    return $dd626d026b9181be$var$sha256(newBuffer.toString("hex"));
};
module.exports.calculateSwapID = $dd626d026b9181be$var$calculateSwapID;

});
parcelRegister("jFVGA", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("evaoA")));
})(this, function(CryptoJS) {
    return CryptoJS.enc.Hex;
});

});
parcelRegister("evaoA", function(module, exports) {
(function(root, factory) {
    // CommonJS
    module.exports = exports = factory();
})(this, function() {
    /**
	 * CryptoJS core components.
	 */ var CryptoJS = CryptoJS || function(Math1, undefined) {
        /*
	     * Local polyfil of Object.create
	     */ var create = Object.create || function() {
            function F() {}
            return function(obj) {
                var subtype;
                F.prototype = obj;
                subtype = new F();
                F.prototype = null;
                return subtype;
            };
        }();
        /**
	     * CryptoJS namespace.
	     */ var C = {};
        /**
	     * Library namespace.
	     */ var C_lib = C.lib = {};
        /**
	     * Base object for prototypal inheritance.
	     */ var Base = C_lib.Base = function() {
            return {
                /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */ extend: function(overrides) {
                    // Spawn
                    var subtype = create(this);
                    // Augment
                    if (overrides) subtype.mixIn(overrides);
                    // Create default initializer
                    if (!subtype.hasOwnProperty("init") || this.init === subtype.init) subtype.init = function() {
                        subtype.$super.init.apply(this, arguments);
                    };
                    // Initializer's prototype is the subtype object
                    subtype.init.prototype = subtype;
                    // Reference supertype
                    subtype.$super = this;
                    return subtype;
                },
                /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */ create: function() {
                    var instance = this.extend();
                    instance.init.apply(instance, arguments);
                    return instance;
                },
                /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */ init: function() {},
                /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */ mixIn: function(properties) {
                    for(var propertyName in properties)if (properties.hasOwnProperty(propertyName)) this[propertyName] = properties[propertyName];
                    // IE won't copy toString using the loop above
                    if (properties.hasOwnProperty("toString")) this.toString = properties.toString;
                },
                /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */ clone: function() {
                    return this.init.prototype.extend(this);
                }
            };
        }();
        /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var WordArray = C_lib.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 4;
            },
            /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */ toString: function(encoder) {
                return (encoder || Hex).stringify(this);
            },
            /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */ concat: function(wordArray) {
                // Shortcuts
                var thisWords = this.words;
                var thatWords = wordArray.words;
                var thisSigBytes = this.sigBytes;
                var thatSigBytes = wordArray.sigBytes;
                // Clamp excess bits
                this.clamp();
                // Concat
                if (thisSigBytes % 4) // Copy one byte at a time
                for(var i = 0; i < thatSigBytes; i++){
                    var thatByte = thatWords[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    thisWords[thisSigBytes + i >>> 2] |= thatByte << 24 - (thisSigBytes + i) % 4 * 8;
                }
                else // Copy one word at a time
                for(var i = 0; i < thatSigBytes; i += 4)thisWords[thisSigBytes + i >>> 2] = thatWords[i >>> 2];
                this.sigBytes += thatSigBytes;
                // Chainable
                return this;
            },
            /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */ clamp: function() {
                // Shortcuts
                var words = this.words;
                var sigBytes = this.sigBytes;
                // Clamp
                words[sigBytes >>> 2] &= 0xffffffff << 32 - sigBytes % 4 * 8;
                words.length = Math1.ceil(sigBytes / 4);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone.words = this.words.slice(0);
                return clone;
            },
            /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */ random: function(nBytes) {
                var words = [];
                var r = function(m_w) {
                    var m_w = m_w;
                    var m_z = 0x3ade68b1;
                    var mask = 0xffffffff;
                    return function() {
                        m_z = 0x9069 * (m_z & 0xFFFF) + (m_z >> 0x10) & mask;
                        m_w = 0x4650 * (m_w & 0xFFFF) + (m_w >> 0x10) & mask;
                        var result = (m_z << 0x10) + m_w & mask;
                        result /= 0x100000000;
                        result += 0.5;
                        return result * (Math1.random() > .5 ? 1 : -1);
                    };
                };
                for(var i = 0, rcache; i < nBytes; i += 4){
                    var _r = r((rcache || Math1.random()) * 0x100000000);
                    rcache = _r() * 0x3ade67b7;
                    words.push(_r() * 0x100000000 | 0);
                }
                return new WordArray.init(words, nBytes);
            }
        });
        /**
	     * Encoder namespace.
	     */ var C_enc = C.enc = {};
        /**
	     * Hex encoding strategy.
	     */ var Hex = C_enc.Hex = {
            /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var hexChars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    hexChars.push((bite >>> 4).toString(16));
                    hexChars.push((bite & 0x0f).toString(16));
                }
                return hexChars.join("");
            },
            /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */ parse: function(hexStr) {
                // Shortcut
                var hexStrLength = hexStr.length;
                // Convert
                var words = [];
                for(var i = 0; i < hexStrLength; i += 2)words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << 24 - i % 8 * 4;
                return new WordArray.init(words, hexStrLength / 2);
            }
        };
        /**
	     * Latin1 encoding strategy.
	     */ var Latin1 = C_enc.Latin1 = {
            /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */ stringify: function(wordArray) {
                // Shortcuts
                var words = wordArray.words;
                var sigBytes = wordArray.sigBytes;
                // Convert
                var latin1Chars = [];
                for(var i = 0; i < sigBytes; i++){
                    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
                    latin1Chars.push(String.fromCharCode(bite));
                }
                return latin1Chars.join("");
            },
            /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */ parse: function(latin1Str) {
                // Shortcut
                var latin1StrLength = latin1Str.length;
                // Convert
                var words = [];
                for(var i = 0; i < latin1StrLength; i++)words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << 24 - i % 4 * 8;
                return new WordArray.init(words, latin1StrLength);
            }
        };
        /**
	     * UTF-8 encoding strategy.
	     */ var Utf8 = C_enc.Utf8 = {
            /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */ stringify: function(wordArray) {
                try {
                    return decodeURIComponent(escape(Latin1.stringify(wordArray)));
                } catch (e) {
                    throw new Error("Malformed UTF-8 data");
                }
            },
            /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */ parse: function(utf8Str) {
                return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
            }
        };
        /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */ var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
            /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */ reset: function() {
                // Initial values
                this._data = new WordArray.init();
                this._nDataBytes = 0;
            },
            /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */ _append: function(data) {
                // Convert string to WordArray, else assume WordArray already
                if (typeof data == "string") data = Utf8.parse(data);
                // Append
                this._data.concat(data);
                this._nDataBytes += data.sigBytes;
            },
            /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */ _process: function(doFlush) {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var dataSigBytes = data.sigBytes;
                var blockSize = this.blockSize;
                var blockSizeBytes = blockSize * 4;
                // Count blocks ready
                var nBlocksReady = dataSigBytes / blockSizeBytes;
                if (doFlush) // Round up to include partial blocks
                nBlocksReady = Math1.ceil(nBlocksReady);
                else // Round down to include only full blocks,
                // less the number of blocks that must remain in the buffer
                nBlocksReady = Math1.max((nBlocksReady | 0) - this._minBufferSize, 0);
                // Count words ready
                var nWordsReady = nBlocksReady * blockSize;
                // Count bytes ready
                var nBytesReady = Math1.min(nWordsReady * 4, dataSigBytes);
                // Process blocks
                if (nWordsReady) {
                    for(var offset = 0; offset < nWordsReady; offset += blockSize)// Perform concrete-algorithm logic
                    this._doProcessBlock(dataWords, offset);
                    // Remove processed words
                    var processedWords = dataWords.splice(0, nWordsReady);
                    data.sigBytes -= nBytesReady;
                }
                // Return processed words
                return new WordArray.init(processedWords, nBytesReady);
            },
            /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                clone._data = this._data.clone();
                return clone;
            },
            _minBufferSize: 0
        });
        /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */ var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
            /**
	         * Configuration options.
	         */ cfg: Base.extend(),
            /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */ init: function(cfg) {
                // Apply config defaults
                this.cfg = this.cfg.extend(cfg);
                // Set initial values
                this.reset();
            },
            /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */ reset: function() {
                // Reset data buffer
                BufferedBlockAlgorithm.reset.call(this);
                // Perform concrete-hasher logic
                this._doReset();
            },
            /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */ update: function(messageUpdate) {
                // Append
                this._append(messageUpdate);
                // Update the hash
                this._process();
                // Chainable
                return this;
            },
            /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */ finalize: function(messageUpdate) {
                // Final message update
                if (messageUpdate) this._append(messageUpdate);
                // Perform concrete-hasher logic
                var hash = this._doFinalize();
                return hash;
            },
            blockSize: 16,
            /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */ _createHelper: function(hasher) {
                return function(message, cfg) {
                    return new hasher.init(cfg).finalize(message);
                };
            },
            /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */ _createHmacHelper: function(hasher) {
                return function(message, key) {
                    return new C_algo.HMAC.init(hasher, key).finalize(message);
                };
            }
        });
        /**
	     * Algorithm namespace.
	     */ var C_algo = C.algo = {};
        return C;
    }(Math);
    return CryptoJS;
});

});


parcelRegister("clFak", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("evaoA")));
})(this, function(CryptoJS) {
    /** @preserve
	(c) 2012 by Cédric Mesnil. All rights reserved.

	Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

	    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
	    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

	THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
	*/ (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Constants table
        var _zl = WordArray.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
        ]);
        var _zr = WordArray.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
        ]);
        var _sl = WordArray.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
        ]);
        var _sr = WordArray.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
        ]);
        var _hl = WordArray.create([
            0x00000000,
            0x5A827999,
            0x6ED9EBA1,
            0x8F1BBCDC,
            0xA953FD4E
        ]);
        var _hr = WordArray.create([
            0x50A28BE6,
            0x5C4DD124,
            0x6D703EF3,
            0x7A6D76E9,
            0x00000000
        ]);
        /**
	     * RIPEMD160 hash algorithm.
	     */ var RIPEMD160 = C_algo.RIPEMD160 = Hasher.extend({
            _doReset: function() {
                this._hash = WordArray.create([
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0
                ]);
            },
            _doProcessBlock: function(M, offset) {
                // Swap endian
                for(var i = 0; i < 16; i++){
                    // Shortcuts
                    var offset_i = offset + i;
                    var M_offset_i = M[offset_i];
                    // Swap
                    M[offset_i] = (M_offset_i << 8 | M_offset_i >>> 24) & 0x00ff00ff | (M_offset_i << 24 | M_offset_i >>> 8) & 0xff00ff00;
                }
                // Shortcut
                var H = this._hash.words;
                var hl = _hl.words;
                var hr = _hr.words;
                var zl = _zl.words;
                var zr = _zr.words;
                var sl = _sl.words;
                var sr = _sr.words;
                // Working variables
                var al, bl, cl, dl, el;
                var ar, br, cr, dr, er;
                ar = al = H[0];
                br = bl = H[1];
                cr = cl = H[2];
                dr = dl = H[3];
                er = el = H[4];
                // Computation
                var t;
                for(var i = 0; i < 80; i += 1){
                    t = al + M[offset + zl[i]] | 0;
                    if (i < 16) t += f1(bl, cl, dl) + hl[0];
                    else if (i < 32) t += f2(bl, cl, dl) + hl[1];
                    else if (i < 48) t += f3(bl, cl, dl) + hl[2];
                    else if (i < 64) t += f4(bl, cl, dl) + hl[3];
                    else t += f5(bl, cl, dl) + hl[4];
                    t = t | 0;
                    t = rotl(t, sl[i]);
                    t = t + el | 0;
                    al = el;
                    el = dl;
                    dl = rotl(cl, 10);
                    cl = bl;
                    bl = t;
                    t = ar + M[offset + zr[i]] | 0;
                    if (i < 16) t += f5(br, cr, dr) + hr[0];
                    else if (i < 32) t += f4(br, cr, dr) + hr[1];
                    else if (i < 48) t += f3(br, cr, dr) + hr[2];
                    else if (i < 64) t += f2(br, cr, dr) + hr[3];
                    else t += f1(br, cr, dr) + hr[4];
                    t = t | 0;
                    t = rotl(t, sr[i]);
                    t = t + er | 0;
                    ar = er;
                    er = dr;
                    dr = rotl(cr, 10);
                    cr = br;
                    br = t;
                }
                // Intermediate hash value
                t = H[1] + cl + dr | 0;
                H[1] = H[2] + dl + er | 0;
                H[2] = H[3] + el + ar | 0;
                H[3] = H[4] + al + br | 0;
                H[4] = H[0] + bl + cr | 0;
                H[0] = t;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = (nBitsTotal << 8 | nBitsTotal >>> 24) & 0x00ff00ff | (nBitsTotal << 24 | nBitsTotal >>> 8) & 0xff00ff00;
                data.sigBytes = (dataWords.length + 1) * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var hash = this._hash;
                var H = hash.words;
                // Swap endian
                for(var i = 0; i < 5; i++){
                    // Shortcut
                    var H_i = H[i];
                    // Swap
                    H[i] = (H_i << 8 | H_i >>> 24) & 0x00ff00ff | (H_i << 24 | H_i >>> 8) & 0xff00ff00;
                }
                // Return final computed hash
                return hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        function f1(x, y, z) {
            return x ^ y ^ z;
        }
        function f2(x, y, z) {
            return x & y | ~x & z;
        }
        function f3(x, y, z) {
            return (x | ~y) ^ z;
        }
        function f4(x, y, z) {
            return x & z | y & ~z;
        }
        function f5(x, y, z) {
            return x ^ (y | ~z);
        }
        function rotl(x, n) {
            return x << n | x >>> 32 - n;
        }
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.RIPEMD160('message');
	     *     var hash = CryptoJS.RIPEMD160(wordArray);
	     */ C.RIPEMD160 = Hasher._createHelper(RIPEMD160);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacRIPEMD160(message, key);
	     */ C.HmacRIPEMD160 = Hasher._createHmacHelper(RIPEMD160);
    })(Math);
    return CryptoJS.RIPEMD160;
});

});

parcelRegister("biekZ", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("evaoA")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_algo = C.algo;
        // Initialization and round constants tables
        var H = [];
        var K = [];
        // Compute constants
        (function() {
            function isPrime(n) {
                var sqrtN = Math1.sqrt(n);
                for(var factor = 2; factor <= sqrtN; factor++){
                    if (!(n % factor)) return false;
                }
                return true;
            }
            function getFractionalBits(n) {
                return (n - (n | 0)) * 0x100000000 | 0;
            }
            var n = 2;
            var nPrime = 0;
            while(nPrime < 64){
                if (isPrime(n)) {
                    if (nPrime < 8) H[nPrime] = getFractionalBits(Math1.pow(n, 0.5));
                    K[nPrime] = getFractionalBits(Math1.pow(n, 1 / 3));
                    nPrime++;
                }
                n++;
            }
        })();
        // Reusable object
        var W = [];
        /**
	     * SHA-256 hash algorithm.
	     */ var SHA256 = C_algo.SHA256 = Hasher.extend({
            _doReset: function() {
                this._hash = new WordArray.init(H.slice(0));
            },
            _doProcessBlock: function(M, offset) {
                // Shortcut
                var H = this._hash.words;
                // Working variables
                var a = H[0];
                var b = H[1];
                var c = H[2];
                var d = H[3];
                var e = H[4];
                var f = H[5];
                var g = H[6];
                var h = H[7];
                // Computation
                for(var i = 0; i < 64; i++){
                    if (i < 16) W[i] = M[offset + i] | 0;
                    else {
                        var gamma0x = W[i - 15];
                        var gamma0 = (gamma0x << 25 | gamma0x >>> 7) ^ (gamma0x << 14 | gamma0x >>> 18) ^ gamma0x >>> 3;
                        var gamma1x = W[i - 2];
                        var gamma1 = (gamma1x << 15 | gamma1x >>> 17) ^ (gamma1x << 13 | gamma1x >>> 19) ^ gamma1x >>> 10;
                        W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
                    }
                    var ch = e & f ^ ~e & g;
                    var maj = a & b ^ a & c ^ b & c;
                    var sigma0 = (a << 30 | a >>> 2) ^ (a << 19 | a >>> 13) ^ (a << 10 | a >>> 22);
                    var sigma1 = (e << 26 | e >>> 6) ^ (e << 21 | e >>> 11) ^ (e << 7 | e >>> 25);
                    var t1 = h + sigma1 + ch + K[i] + W[i];
                    var t2 = sigma0 + maj;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                // Intermediate hash value
                H[0] = H[0] + a | 0;
                H[1] = H[1] + b | 0;
                H[2] = H[2] + c | 0;
                H[3] = H[3] + d | 0;
                H[4] = H[4] + e | 0;
                H[5] = H[5] + f | 0;
                H[6] = H[6] + g | 0;
                H[7] = H[7] + h | 0;
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x80 << 24 - nBitsLeft % 32;
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 14] = Math1.floor(nBitsTotal / 0x100000000);
                dataWords[(nBitsLeft + 64 >>> 9 << 4) + 15] = nBitsTotal;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Return final computed hash
                return this._hash;
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                clone._hash = this._hash.clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */ C.SHA256 = Hasher._createHelper(SHA256);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */ C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
    })(Math);
    return CryptoJS.SHA256;
});

});

parcelRegister("6aHME", function(module, exports) {


(function(root, factory, undef) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("evaoA")), (parcelRequire("jMpz1")));
})(this, function(CryptoJS) {
    (function(Math1) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var WordArray = C_lib.WordArray;
        var Hasher = C_lib.Hasher;
        var C_x64 = C.x64;
        var X64Word = C_x64.Word;
        var C_algo = C.algo;
        // Constants tables
        var RHO_OFFSETS = [];
        var PI_INDEXES = [];
        var ROUND_CONSTANTS = [];
        // Compute Constants
        (function() {
            // Compute rho offset constants
            var x = 1, y = 0;
            for(var t = 0; t < 24; t++){
                RHO_OFFSETS[x + 5 * y] = (t + 1) * (t + 2) / 2 % 64;
                var newX = y % 5;
                var newY = (2 * x + 3 * y) % 5;
                x = newX;
                y = newY;
            }
            // Compute pi index constants
            for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++)PI_INDEXES[x + 5 * y] = y + (2 * x + 3 * y) % 5 * 5;
            // Compute round constants
            var LFSR = 0x01;
            for(var i = 0; i < 24; i++){
                var roundConstantMsw = 0;
                var roundConstantLsw = 0;
                for(var j = 0; j < 7; j++){
                    if (LFSR & 0x01) {
                        var bitPosition = (1 << j) - 1;
                        if (bitPosition < 32) roundConstantLsw ^= 1 << bitPosition;
                        else roundConstantMsw ^= 1 << bitPosition - 32;
                    }
                    // Compute next LFSR
                    if (LFSR & 0x80) // Primitive polynomial over GF(2): x^8 + x^6 + x^5 + x^4 + 1
                    LFSR = LFSR << 1 ^ 0x71;
                    else LFSR <<= 1;
                }
                ROUND_CONSTANTS[i] = X64Word.create(roundConstantMsw, roundConstantLsw);
            }
        })();
        // Reusable objects for temporary values
        var T = [];
        (function() {
            for(var i = 0; i < 25; i++)T[i] = X64Word.create();
        })();
        /**
	     * SHA-3 hash algorithm.
	     */ var SHA3 = C_algo.SHA3 = Hasher.extend({
            /**
	         * Configuration options.
	         *
	         * @property {number} outputLength
	         *   The desired number of bits in the output hash.
	         *   Only values permitted are: 224, 256, 384, 512.
	         *   Default: 512
	         */ cfg: Hasher.cfg.extend({
                outputLength: 512
            }),
            _doReset: function() {
                var state = this._state = [];
                for(var i = 0; i < 25; i++)state[i] = new X64Word.init();
                this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(M, offset) {
                // Shortcuts
                var state = this._state;
                var nBlockSizeLanes = this.blockSize / 2;
                // Absorb
                for(var i = 0; i < nBlockSizeLanes; i++){
                    // Shortcuts
                    var M2i = M[offset + 2 * i];
                    var M2i1 = M[offset + 2 * i + 1];
                    // Swap endian
                    M2i = (M2i << 8 | M2i >>> 24) & 0x00ff00ff | (M2i << 24 | M2i >>> 8) & 0xff00ff00;
                    M2i1 = (M2i1 << 8 | M2i1 >>> 24) & 0x00ff00ff | (M2i1 << 24 | M2i1 >>> 8) & 0xff00ff00;
                    // Absorb message into state
                    var lane = state[i];
                    lane.high ^= M2i1;
                    lane.low ^= M2i;
                }
                // Rounds
                for(var round = 0; round < 24; round++){
                    // Theta
                    for(var x = 0; x < 5; x++){
                        // Mix column lanes
                        var tMsw = 0, tLsw = 0;
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            tMsw ^= lane.high;
                            tLsw ^= lane.low;
                        }
                        // Temporary values
                        var Tx = T[x];
                        Tx.high = tMsw;
                        Tx.low = tLsw;
                    }
                    for(var x = 0; x < 5; x++){
                        // Shortcuts
                        var Tx4 = T[(x + 4) % 5];
                        var Tx1 = T[(x + 1) % 5];
                        var Tx1Msw = Tx1.high;
                        var Tx1Lsw = Tx1.low;
                        // Mix surrounding columns
                        var tMsw = Tx4.high ^ (Tx1Msw << 1 | Tx1Lsw >>> 31);
                        var tLsw = Tx4.low ^ (Tx1Lsw << 1 | Tx1Msw >>> 31);
                        for(var y = 0; y < 5; y++){
                            var lane = state[x + 5 * y];
                            lane.high ^= tMsw;
                            lane.low ^= tLsw;
                        }
                    }
                    // Rho Pi
                    for(var laneIndex = 1; laneIndex < 25; laneIndex++){
                        // Shortcuts
                        var lane = state[laneIndex];
                        var laneMsw = lane.high;
                        var laneLsw = lane.low;
                        var rhoOffset = RHO_OFFSETS[laneIndex];
                        // Rotate lanes
                        if (rhoOffset < 32) {
                            var tMsw = laneMsw << rhoOffset | laneLsw >>> 32 - rhoOffset;
                            var tLsw = laneLsw << rhoOffset | laneMsw >>> 32 - rhoOffset;
                        } else /* if (rhoOffset >= 32) */ {
                            var tMsw = laneLsw << rhoOffset - 32 | laneMsw >>> 64 - rhoOffset;
                            var tLsw = laneMsw << rhoOffset - 32 | laneLsw >>> 64 - rhoOffset;
                        }
                        // Transpose lanes
                        var TPiLane = T[PI_INDEXES[laneIndex]];
                        TPiLane.high = tMsw;
                        TPiLane.low = tLsw;
                    }
                    // Rho pi at x = y = 0
                    var T0 = T[0];
                    var state0 = state[0];
                    T0.high = state0.high;
                    T0.low = state0.low;
                    // Chi
                    for(var x = 0; x < 5; x++)for(var y = 0; y < 5; y++){
                        // Shortcuts
                        var laneIndex = x + 5 * y;
                        var lane = state[laneIndex];
                        var TLane = T[laneIndex];
                        var Tx1Lane = T[(x + 1) % 5 + 5 * y];
                        var Tx2Lane = T[(x + 2) % 5 + 5 * y];
                        // Mix rows
                        lane.high = TLane.high ^ ~Tx1Lane.high & Tx2Lane.high;
                        lane.low = TLane.low ^ ~Tx1Lane.low & Tx2Lane.low;
                    }
                    // Iota
                    var lane = state[0];
                    var roundConstant = ROUND_CONSTANTS[round];
                    lane.high ^= roundConstant.high;
                    lane.low ^= roundConstant.low;
                }
            },
            _doFinalize: function() {
                // Shortcuts
                var data = this._data;
                var dataWords = data.words;
                var nBitsTotal = this._nDataBytes * 8;
                var nBitsLeft = data.sigBytes * 8;
                var blockSizeBits = this.blockSize * 32;
                // Add padding
                dataWords[nBitsLeft >>> 5] |= 0x1 << 24 - nBitsLeft % 32;
                dataWords[(Math1.ceil((nBitsLeft + 1) / blockSizeBits) * blockSizeBits >>> 5) - 1] |= 0x80;
                data.sigBytes = dataWords.length * 4;
                // Hash final blocks
                this._process();
                // Shortcuts
                var state = this._state;
                var outputLengthBytes = this.cfg.outputLength / 8;
                var outputLengthLanes = outputLengthBytes / 8;
                // Squeeze
                var hashWords = [];
                for(var i = 0; i < outputLengthLanes; i++){
                    // Shortcuts
                    var lane = state[i];
                    var laneMsw = lane.high;
                    var laneLsw = lane.low;
                    // Swap endian
                    laneMsw = (laneMsw << 8 | laneMsw >>> 24) & 0x00ff00ff | (laneMsw << 24 | laneMsw >>> 8) & 0xff00ff00;
                    laneLsw = (laneLsw << 8 | laneLsw >>> 24) & 0x00ff00ff | (laneLsw << 24 | laneLsw >>> 8) & 0xff00ff00;
                    // Squeeze state to retrieve hash
                    hashWords.push(laneLsw);
                    hashWords.push(laneMsw);
                }
                // Return final computed hash
                return new WordArray.init(hashWords, outputLengthBytes);
            },
            clone: function() {
                var clone = Hasher.clone.call(this);
                var state = clone._state = this._state.slice(0);
                for(var i = 0; i < 25; i++)state[i] = state[i].clone();
                return clone;
            }
        });
        /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA3('message');
	     *     var hash = CryptoJS.SHA3(wordArray);
	     */ C.SHA3 = Hasher._createHelper(SHA3);
        /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA3(message, key);
	     */ C.HmacSHA3 = Hasher._createHmacHelper(SHA3);
    })(Math);
    return CryptoJS.SHA3;
});

});
parcelRegister("jMpz1", function(module, exports) {

(function(root, factory) {
    // CommonJS
    module.exports = exports = factory((parcelRequire("evaoA")));
})(this, function(CryptoJS) {
    (function(undefined) {
        // Shortcuts
        var C = CryptoJS;
        var C_lib = C.lib;
        var Base = C_lib.Base;
        var X32WordArray = C_lib.WordArray;
        /**
	     * x64 namespace.
	     */ var C_x64 = C.x64 = {};
        /**
	     * A 64-bit word.
	     */ var X64Word = C_x64.Word = Base.extend({
            /**
	         * Initializes a newly created 64-bit word.
	         *
	         * @param {number} high The high 32 bits.
	         * @param {number} low The low 32 bits.
	         *
	         * @example
	         *
	         *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
	         */ init: function(high, low) {
                this.high = high;
                this.low = low;
            }
        });
        /**
	     * An array of 64-bit words.
	     *
	     * @property {Array} words The array of CryptoJS.x64.Word objects.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */ var X64WordArray = C_x64.WordArray = Base.extend({
            /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create();
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ]);
	         *
	         *     var wordArray = CryptoJS.x64.WordArray.create([
	         *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
	         *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
	         *     ], 10);
	         */ init: function(words, sigBytes) {
                words = this.words = words || [];
                if (sigBytes != undefined) this.sigBytes = sigBytes;
                else this.sigBytes = words.length * 8;
            },
            /**
	         * Converts this 64-bit word array to a 32-bit word array.
	         *
	         * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
	         *
	         * @example
	         *
	         *     var x32WordArray = x64WordArray.toX32();
	         */ toX32: function() {
                // Shortcuts
                var x64Words = this.words;
                var x64WordsLength = x64Words.length;
                // Convert
                var x32Words = [];
                for(var i = 0; i < x64WordsLength; i++){
                    var x64Word = x64Words[i];
                    x32Words.push(x64Word.high);
                    x32Words.push(x64Word.low);
                }
                return X32WordArray.create(x32Words, this.sigBytes);
            },
            /**
	         * Creates a copy of this word array.
	         *
	         * @return {X64WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = x64WordArray.clone();
	         */ clone: function() {
                var clone = Base.clone.call(this);
                // Clone "words" array
                var words = clone.words = this.words.slice(0);
                // Clone each X64Word object
                var wordsLength = words.length;
                for(var i = 0; i < wordsLength; i++)words[i] = words[i].clone();
                return clone;
            }
        });
    })();
    return CryptoJS;
});

});



parcelRegister("ddfDI", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateOffsetLimit = module.exports.validateTradingPair = module.exports.validateSymbol = module.exports.checkCoins = module.exports.checkNumber = void 0;

var $99e89efa5248b686$var$_big = $2ZnTs((parcelRequire("3qN14")));
var $99e89efa5248b686$var$MAX_INT64 = Math.pow(2, 63);
/**
 * validate the input number.
 * @param {Number} value
 */ var $99e89efa5248b686$var$checkNumber = function checkNumber(value) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "input number";
    if (new $99e89efa5248b686$var$_big["default"](value).lte(0)) throw new Error("".concat(name, " should be a positive number"));
    if (new $99e89efa5248b686$var$_big["default"](value).gte($99e89efa5248b686$var$MAX_INT64)) throw new Error("".concat(name, " should be less than 2^63"));
};
/**
 * basic validation of coins
 * @param {Array} coins
 */ module.exports.checkNumber = $99e89efa5248b686$var$checkNumber;
var $99e89efa5248b686$var$checkCoins = function checkCoins(coins) {
    coins = coins || [];
    coins.forEach(function(coin) {
        $99e89efa5248b686$var$checkNumber(coin.amount);
        if (!coin.denom) throw new Error("invalid denmon");
    });
};
module.exports.checkCoins = $99e89efa5248b686$var$checkCoins;
var $99e89efa5248b686$var$validateSymbol = function validateSymbol(symbol) {
    if (!symbol) throw new Error("suffixed token symbol cannot be empty");
    var splitSymbols = symbol.split("-"); //check length with .B suffix
    if (!/^[a-zA-z\d/.]{3,10}$/.test(splitSymbols[0])) throw new Error("symbol length is limited to 3~10");
};
module.exports.validateSymbol = $99e89efa5248b686$var$validateSymbol;
var $99e89efa5248b686$var$validateTradingPair = function validateTradingPair(pair) {
    var symbols = pair.split("_");
    if (symbols.length !== 2) throw new Error('the pair should in format "symbol1_symbol2"');
    $99e89efa5248b686$var$validateSymbol(symbols[0]);
    $99e89efa5248b686$var$validateSymbol(symbols[1]);
};
module.exports.validateTradingPair = $99e89efa5248b686$var$validateTradingPair;
var $99e89efa5248b686$var$validateOffsetLimit = function validateOffsetLimit(offset, limit) {
    if (offset < 0) throw new Error("offset can't be less than 0");
    if (limit < 0) throw new Error("limit can't be less than 0");
};
module.exports.validateOffsetLimit = $99e89efa5248b686$var$validateOffsetLimit;

});

parcelRegister("f8MQV", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMsgByAminoPrefix = module.exports.convertObjectArrayNum = module.exports.divide = module.exports.BASENUMBER = void 0;

var $b05d7f79f5409b67$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $eULcN = parcelRequire("eULcN");
var $b05d7f79f5409b67$var$BASENUMBER = Math.pow(10, 8);
module.exports.BASENUMBER = $b05d7f79f5409b67$var$BASENUMBER;
var $b05d7f79f5409b67$var$divide = function divide(num) {
    return +new $b05d7f79f5409b67$var$_big["default"](num).div($b05d7f79f5409b67$var$BASENUMBER).toString();
};
module.exports.divide = $b05d7f79f5409b67$var$divide;
var $b05d7f79f5409b67$var$convertObjectArrayNum = function convertObjectArrayNum(objArr, keys) {
    objArr.forEach(function(item) {
        keys.forEach(function(key) {
            item[key] = $b05d7f79f5409b67$var$divide(item[key]);
        });
    });
}; //TODO add gov and swap
module.exports.convertObjectArrayNum = $b05d7f79f5409b67$var$convertObjectArrayNum;
var $b05d7f79f5409b67$var$getMsgByAminoPrefix = function getMsgByAminoPrefix(aminoPrefix) {
    switch(aminoPrefix.toUpperCase()){
        case $eULcN.AminoPrefix.NewOrderMsg:
            return $eULcN.NewOrderMsg;
        case $eULcN.AminoPrefix.CancelOrderMsg:
            return $eULcN.CancelOrderMsg;
        case $eULcN.AminoPrefix.MsgSend:
            return $eULcN.SendMsg;
        case $eULcN.AminoPrefix.IssueMsg:
            return $eULcN.IssueTokenMsg;
        case $eULcN.AminoPrefix.FreezeMsg:
            return $eULcN.FreezeTokenMsg;
        case $eULcN.AminoPrefix.UnfreezeMsg:
            return $eULcN.UnFreezeTokenMsg;
        case $eULcN.AminoPrefix.BurnMsg:
            return $eULcN.BurnTokenMsg;
        case $eULcN.AminoPrefix.MintMsg:
            return $eULcN.MintTokenMsg;
        case $eULcN.AminoPrefix.TimeLockMsg:
            return $eULcN.TimeLockMsg;
        case $eULcN.AminoPrefix.TimeRelockMsg:
            return $eULcN.TimeReLockMsg;
        case $eULcN.AminoPrefix.TimeUnlockMsg:
            return $eULcN.TimeUnlockMsg;
        default:
            return $eULcN.BaseMsg;
    }
};
module.exports.getMsgByAminoPrefix = $b05d7f79f5409b67$var$getMsgByAminoPrefix;

});
parcelRegister("eULcN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2PdRI = parcelRequire("2PdRI");
Object.keys($2PdRI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $2PdRI[key];
        }
    });
});

var $5JQUv = parcelRequire("5JQUv");
Object.keys($5JQUv).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $5JQUv[key];
        }
    });
});

var $kyzm3 = parcelRequire("kyzm3");
Object.keys($kyzm3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $kyzm3[key];
        }
    });
});

});
parcelRegister("2PdRI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kg2QH = parcelRequire("kg2QH");
Object.keys($kg2QH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $kg2QH[key];
        }
    });
});

var $fKsU2 = parcelRequire("fKsU2");
Object.keys($fKsU2).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $fKsU2[key];
        }
    });
});

var $2WaAr = parcelRequire("2WaAr");
Object.keys($2WaAr).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $2WaAr[key];
        }
    });
});

var $6gb15 = parcelRequire("6gb15");
Object.keys($6gb15).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $6gb15[key];
        }
    });
});

var $hw10X = parcelRequire("hw10X");
Object.keys($hw10X).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $hw10X[key];
        }
    });
});

var $1Gpeb = parcelRequire("1Gpeb");
Object.keys($1Gpeb).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $1Gpeb[key];
        }
    });
});

});
parcelRegister("kg2QH", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BaseMsg = void 0;

var $ebf7830625d7e240$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $ebf7830625d7e240$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));
/* eslint-disable */ var $ebf7830625d7e240$var$BaseMsg = /*#__PURE__*/ function() {
    function BaseMsg() {
        (0, $ebf7830625d7e240$var$_classCallCheck2["default"])(this, BaseMsg);
    }
    (0, $ebf7830625d7e240$var$_createClass2["default"])(BaseMsg, null, [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {};
            }
        }
    ]);
    return BaseMsg;
}();
module.exports.BaseMsg = $ebf7830625d7e240$var$BaseMsg;

});

parcelRegister("fKsU2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cEbnH = parcelRequire("cEbnH");
Object.keys($cEbnH).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $cEbnH[key];
        }
    });
});

var $l5axD = parcelRequire("l5axD");
Object.keys($l5axD).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $l5axD[key];
        }
    });
});

var $jsewl = parcelRequire("jsewl");
Object.keys($jsewl).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $jsewl[key];
        }
    });
});

});
parcelRegister("cEbnH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $93520c857b0c3c2e$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelOrderMsg = void 0;

var $93520c857b0c3c2e$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $93520c857b0c3c2e$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $93520c857b0c3c2e$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $93520c857b0c3c2e$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $93520c857b0c3c2e$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $93520c857b0c3c2e$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $93520c857b0c3c2e$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $93520c857b0c3c2e$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");

var $kg2QH = parcelRequire("kg2QH");
function $93520c857b0c3c2e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $93520c857b0c3c2e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $93520c857b0c3c2e$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $93520c857b0c3c2e$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $93520c857b0c3c2e$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $93520c857b0c3c2e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $93520c857b0c3c2e$var$CancelOrderMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $93520c857b0c3c2e$var$_inherits2["default"])(CancelOrderMsg, _BaseMsg);
    var _super = $93520c857b0c3c2e$var$_createSuper(CancelOrderMsg);
    function CancelOrderMsg(address, sybmol, orderId) {
        var _this;
        (0, $93520c857b0c3c2e$var$_classCallCheck2["default"])(this, CancelOrderMsg);
        _this = _super.call(this);
        (0, $93520c857b0c3c2e$var$_defineProperty2["default"])((0, $93520c857b0c3c2e$var$_assertThisInitialized2["default"])(_this), "address", void 0);
        (0, $93520c857b0c3c2e$var$_defineProperty2["default"])((0, $93520c857b0c3c2e$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $93520c857b0c3c2e$var$_defineProperty2["default"])((0, $93520c857b0c3c2e$var$_assertThisInitialized2["default"])(_this), "orderId", void 0);
        (0, $93520c857b0c3c2e$var$_defineProperty2["default"])((0, $93520c857b0c3c2e$var$_assertThisInitialized2["default"])(_this), "aminoPrefix", $5JQUv.AminoPrefix.CancelOrderMsg);
        _this.address = address;
        _this.symbol = sybmol;
        _this.orderId = orderId;
        return _this;
    }
    (0, $93520c857b0c3c2e$var$_createClass2["default"])(CancelOrderMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    sender: this.address,
                    symbol: this.symbol,
                    refid: this.orderId
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    sender: $93520c857b0c3c2e$var$crypto.decodeAddress(this.address),
                    symbol: this.symbol,
                    refid: this.orderId,
                    aminoPrefix: $5JQUv.AminoPrefix.CancelOrderMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    sender: $93520c857b0c3c2e$require$Buffer.from(""),
                    symbol: "",
                    refid: "",
                    aminoPrefix: $5JQUv.AminoPrefix.CancelOrderMsg
                };
            }
        }
    ]);
    return CancelOrderMsg;
}($kg2QH.BaseMsg);
module.exports.CancelOrderMsg = $93520c857b0c3c2e$var$CancelOrderMsg;

});
parcelRegister("eiXAs", function(module, exports) {
function $a6a0f7da525baef5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
module.exports = $a6a0f7da525baef5$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("ljhd4", function(module, exports) {

var $96bT5 = parcelRequire("96bT5");
function $f838b8d3ab72d3a5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $96bT5(subClass, superClass);
}
module.exports = $f838b8d3ab72d3a5$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("96bT5", function(module, exports) {
function $69fde538af35e679$var$_setPrototypeOf(o, p) {
    module.exports = $69fde538af35e679$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $69fde538af35e679$var$_setPrototypeOf(o, p);
}
module.exports = $69fde538af35e679$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("cybvJ", function(module, exports) {

var $crtHL = parcelRequire("crtHL");
var $923196d71df5e353$var$_typeof = $crtHL.default;

var $eiXAs = parcelRequire("eiXAs");
function $923196d71df5e353$var$_possibleConstructorReturn(self, call) {
    if (call && ($923196d71df5e353$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $eiXAs(self);
}
module.exports = $923196d71df5e353$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("j4o1m", function(module, exports) {
function $de21061e32125644$var$_getPrototypeOf(o) {
    module.exports = $de21061e32125644$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    return $de21061e32125644$var$_getPrototypeOf(o);
}
module.exports = $de21061e32125644$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5JQUv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4aPEj = parcelRequire("4aPEj");
Object.keys($4aPEj).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $4aPEj[key];
        }
    });
});

var $5ikoc = parcelRequire("5ikoc");
Object.keys($5ikoc).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $5ikoc[key];
        }
    });
});

var $dSnWQ = parcelRequire("dSnWQ");
Object.keys($dSnWQ).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $dSnWQ[key];
        }
    });
});

});
parcelRegister("4aPEj", function(module, exports) {
"use strict";

});

parcelRegister("5ikoc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AminoPrefix = void 0;
var $3dae7313d277eb27$var$AminoPrefix;
module.exports.AminoPrefix = $3dae7313d277eb27$var$AminoPrefix;
(function(AminoPrefix) {
    AminoPrefix["MsgSend"] = "2A2C87FA";
    AminoPrefix["NewOrderMsg"] = "CE6DC043";
    AminoPrefix["CancelOrderMsg"] = "166E681B";
    AminoPrefix["IssueMsg"] = "17EFAB80";
    AminoPrefix["BurnMsg"] = "7ED2D2A0";
    AminoPrefix["FreezeMsg"] = "E774B32D";
    AminoPrefix["UnfreezeMsg"] = "6515FF0D";
    AminoPrefix["MintMsg"] = "467E0829";
    AminoPrefix["ListMsg"] = "B41DE13F";
    AminoPrefix["StdTx"] = "F0625DEE";
    AminoPrefix["PubKeySecp256k1"] = "EB5AE987";
    AminoPrefix["SignatureSecp256k1"] = "7FC4A495";
    AminoPrefix["MsgSubmitProposal"] = "B42D614E";
    AminoPrefix["MsgDeposit"] = "A18A56E5";
    AminoPrefix["MsgVote"] = "A1CADD36";
    AminoPrefix["TimeLockMsg"] = "07921531";
    AminoPrefix["TimeUnlockMsg"] = "C4050C6C";
    AminoPrefix["TimeRelockMsg"] = "504711DA";
    AminoPrefix["HTLTMsg"] = "B33F9A24";
    AminoPrefix["DepositHTLTMsg"] = "63986496";
    AminoPrefix["ClaimHTLTMsg"] = "C1665300";
    AminoPrefix["RefundHTLTMsg"] = "3454A27C";
    AminoPrefix["SetAccountFlagsMsg"] = "BEA6E301";
    AminoPrefix["BnbchainAccount"] = "4BDC4C27";
    AminoPrefix["BnbchainToken"] = "140364E6";
    AminoPrefix["MsgCreateValidator"] = "EB361D01";
    AminoPrefix["MsgRemoveValidator"] = "C1AFE85F";
    AminoPrefix["MsgCreateValidatorProposal"] = "DB6A19FD";
    AminoPrefix["MsgEditValidator"] = "C2E8BCCD";
    AminoPrefix["MsgDelegate"] = "921D2E4E";
    AminoPrefix["MsgBeginUnbonding"] = "A3823C9A";
    AminoPrefix["MsgBeginRedelegate"] = "267996D2";
    AminoPrefix["MsgCreateSideChainValidator"] = "D17201E5";
    AminoPrefix["MsgEditSideChainValidator"] = "264CC57B";
    AminoPrefix["MsgSideChainDelegate"] = "E3A07FD2";
    AminoPrefix["MsgSideChainRedelegate"] = "E3CED364";
    AminoPrefix["MsgSideChainUndelegate"] = "514F7E0E";
    AminoPrefix["Claim"] = "4E781C11";
    AminoPrefix["ClaimMsg"] = "175A0521";
    AminoPrefix["BindMsg"] = "B9AE640C";
    AminoPrefix["TransferOutMsg"] = "800819C0";
    AminoPrefix["IssueMiniMsg"] = "A3F16C41";
    AminoPrefix["IssueTinyMsg"] = "ED2832D4";
    AminoPrefix["SetURIMsg"] = "7B1D34E7";
    AminoPrefix["ListMiniMsg"] = "4C264019";
    AminoPrefix["MiniToken"] = "E0051C20";
})($3dae7313d277eb27$var$AminoPrefix || (module.exports.AminoPrefix = $3dae7313d277eb27$var$AminoPrefix = {}));

});

parcelRegister("dSnWQ", function(module, exports) {
"use strict";

});



parcelRegister("l5axD", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f5923de80f8aba49$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NewOrderMsg = void 0;

var $f5923de80f8aba49$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $f5923de80f8aba49$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $f5923de80f8aba49$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $f5923de80f8aba49$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $f5923de80f8aba49$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $f5923de80f8aba49$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $f5923de80f8aba49$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $f5923de80f8aba49$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $kg2QH = parcelRequire("kg2QH");

var $f5923de80f8aba49$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $f5923de80f8aba49$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f5923de80f8aba49$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $f5923de80f8aba49$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $f5923de80f8aba49$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $f5923de80f8aba49$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f5923de80f8aba49$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f5923de80f8aba49$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $f5923de80f8aba49$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $f5923de80f8aba49$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $f5923de80f8aba49$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $f5923de80f8aba49$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $f5923de80f8aba49$var$BASENUMBER = Math.pow(10, 8);
var $f5923de80f8aba49$var$NewOrderMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $f5923de80f8aba49$var$_inherits2["default"])(NewOrderMsg, _BaseMsg);
    var _super = $f5923de80f8aba49$var$_createSuper(NewOrderMsg);
    function NewOrderMsg(data, address) {
        var _this;
        (0, $f5923de80f8aba49$var$_classCallCheck2["default"])(this, NewOrderMsg);
        _this = _super.call(this);
        (0, $f5923de80f8aba49$var$_defineProperty2["default"])((0, $f5923de80f8aba49$var$_assertThisInitialized2["default"])(_this), "newOrder", void 0);
        (0, $f5923de80f8aba49$var$_defineProperty2["default"])((0, $f5923de80f8aba49$var$_assertThisInitialized2["default"])(_this), "address", void 0);
        (0, $f5923de80f8aba49$var$_defineProperty2["default"])((0, $f5923de80f8aba49$var$_assertThisInitialized2["default"])(_this), "aminoPrefix", $5JQUv.AminoPrefix.NewOrderMsg);
        var bigPrice = new $f5923de80f8aba49$var$_big["default"](data.price);
        var bigQuantity = new $f5923de80f8aba49$var$_big["default"](data.quantity);
        _this.newOrder = data;
        _this.newOrder.price = Number(bigPrice.mul($f5923de80f8aba49$var$BASENUMBER).toString());
        _this.newOrder.quantity = Number(bigQuantity.mul($f5923de80f8aba49$var$BASENUMBER).toString());
        _this.address = address;
        return _this;
    }
    (0, $f5923de80f8aba49$var$_createClass2["default"])(NewOrderMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = $f5923de80f8aba49$var$_objectSpread({
                    sender: this.address
                }, this.newOrder);
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    sender: $f5923de80f8aba49$var$crypto.decodeAddress(this.address),
                    id: this.newOrder.id,
                    symbol: this.newOrder.symbol,
                    ordertype: this.newOrder.ordertype,
                    side: this.newOrder.side,
                    price: this.newOrder.price,
                    quantity: this.newOrder.quantity,
                    timeinforce: this.newOrder.timeinforce,
                    aminoPrefix: this.aminoPrefix
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    sender: $f5923de80f8aba49$require$Buffer.from(""),
                    id: "",
                    symbol: "",
                    orderType: 0,
                    side: 0,
                    price: 0,
                    quantity: 0,
                    timeinforce: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.NewOrderMsg
                };
            }
        }
    ]);
    return NewOrderMsg;
}($kg2QH.BaseMsg);
module.exports.NewOrderMsg = $f5923de80f8aba49$var$NewOrderMsg;

});

parcelRegister("jsewl", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e29be55addd78346$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ListMiniMsg = void 0;

var $e29be55addd78346$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $e29be55addd78346$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $e29be55addd78346$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $e29be55addd78346$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $e29be55addd78346$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $e29be55addd78346$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $e29be55addd78346$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $e29be55addd78346$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");

var $kg2QH = parcelRequire("kg2QH");
function $e29be55addd78346$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e29be55addd78346$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e29be55addd78346$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e29be55addd78346$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $e29be55addd78346$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $e29be55addd78346$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e29be55addd78346$var$ListMiniMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $e29be55addd78346$var$_inherits2["default"])(ListMiniMsg, _BaseMsg);
    var _super = $e29be55addd78346$var$_createSuper(ListMiniMsg);
    function ListMiniMsg(_ref) {
        var _this;
        var from = _ref.from, base_asset_symbol = _ref.base_asset_symbol, quote_asset_symbol = _ref.quote_asset_symbol, init_price = _ref.init_price;
        (0, $e29be55addd78346$var$_classCallCheck2["default"])(this, ListMiniMsg);
        _this = _super.call(this);
        (0, $e29be55addd78346$var$_defineProperty2["default"])((0, $e29be55addd78346$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $e29be55addd78346$var$_defineProperty2["default"])((0, $e29be55addd78346$var$_assertThisInitialized2["default"])(_this), "base_asset_symbol", void 0);
        (0, $e29be55addd78346$var$_defineProperty2["default"])((0, $e29be55addd78346$var$_assertThisInitialized2["default"])(_this), "quote_asset_symbol", void 0);
        (0, $e29be55addd78346$var$_defineProperty2["default"])((0, $e29be55addd78346$var$_assertThisInitialized2["default"])(_this), "init_price", void 0);
        _this.from = from;
        _this.base_asset_symbol = base_asset_symbol;
        _this.quote_asset_symbol = quote_asset_symbol;
        _this.init_price = init_price;
        return _this;
    }
    (0, $e29be55addd78346$var$_createClass2["default"])(ListMiniMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    base_asset_symbol: this.base_asset_symbol,
                    quote_asset_symbol: this.quote_asset_symbol,
                    init_price: this.init_price
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $e29be55addd78346$var$crypto.decodeAddress(this.from),
                    base_asset_symbol: this.base_asset_symbol,
                    quote_asset_symbol: this.quote_asset_symbol,
                    init_price: this.init_price,
                    aminoPrefix: $5JQUv.AminoPrefix.ListMiniMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $e29be55addd78346$require$Buffer.from(""),
                    base_asset_symbol: "",
                    quote_asset_symbol: "",
                    init_price: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.ListMiniMsg
                };
            }
        }
    ]);
    return ListMiniMsg;
}($kg2QH.BaseMsg);
module.exports.ListMiniMsg = $e29be55addd78346$var$ListMiniMsg;

});


parcelRegister("2WaAr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8voDa = parcelRequire("8voDa");
Object.keys($8voDa).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $8voDa[key];
        }
    });
});

var $dNOM3 = parcelRequire("dNOM3");
Object.keys($dNOM3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $dNOM3[key];
        }
    });
});

var $9HUOL = parcelRequire("9HUOL");
Object.keys($9HUOL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $9HUOL[key];
        }
    });
});

var $bKkdk = parcelRequire("bKkdk");
Object.keys($bKkdk).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $bKkdk[key];
        }
    });
});

var $6RBU3 = parcelRequire("6RBU3");
Object.keys($6RBU3).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $6RBU3[key];
        }
    });
});

var $eYaI0 = parcelRequire("eYaI0");
Object.keys($eYaI0).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $eYaI0[key];
        }
    });
});

var $jthvI = parcelRequire("jthvI");
Object.keys($jthvI).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $jthvI[key];
        }
    });
});

var $7hYSy = parcelRequire("7hYSy");
Object.keys($7hYSy).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $7hYSy[key];
        }
    });
});

var $9nTwp = parcelRequire("9nTwp");
Object.keys($9nTwp).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $9nTwp[key];
        }
    });
});

var $6zsql = parcelRequire("6zsql");
Object.keys($6zsql).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $6zsql[key];
        }
    });
});

var $1ecZt = parcelRequire("1ecZt");
Object.keys($1ecZt).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $1ecZt[key];
        }
    });
});

});
parcelRegister("8voDa", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $631453224b71ca4e$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BurnTokenMsg = void 0;

var $631453224b71ca4e$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $631453224b71ca4e$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $631453224b71ca4e$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $631453224b71ca4e$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $631453224b71ca4e$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $631453224b71ca4e$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $631453224b71ca4e$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $631453224b71ca4e$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $631453224b71ca4e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $631453224b71ca4e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $631453224b71ca4e$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $631453224b71ca4e$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $631453224b71ca4e$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $631453224b71ca4e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $631453224b71ca4e$var$BurnTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $631453224b71ca4e$var$_inherits2["default"])(BurnTokenMsg, _BaseMsg);
    var _super = $631453224b71ca4e$var$_createSuper(BurnTokenMsg);
    function BurnTokenMsg(_ref) {
        var _this;
        var address = _ref.address, sybmol = _ref.sybmol, amount = _ref.amount;
        (0, $631453224b71ca4e$var$_classCallCheck2["default"])(this, BurnTokenMsg);
        _this = _super.call(this);
        (0, $631453224b71ca4e$var$_defineProperty2["default"])((0, $631453224b71ca4e$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $631453224b71ca4e$var$_defineProperty2["default"])((0, $631453224b71ca4e$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $631453224b71ca4e$var$_defineProperty2["default"])((0, $631453224b71ca4e$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.symbol = sybmol;
        _this.amount = amount;
        return _this;
    }
    (0, $631453224b71ca4e$var$_createClass2["default"])(BurnTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    symbol: this.symbol,
                    amount: this.amount
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $631453224b71ca4e$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    amount: this.amount,
                    aminoPrefix: $5JQUv.AminoPrefix.BurnMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $631453224b71ca4e$require$Buffer.from(""),
                    symbol: "",
                    amount: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.BurnMsg
                };
            }
        }
    ]);
    return BurnTokenMsg;
}($kg2QH.BaseMsg);
module.exports.BurnTokenMsg = $631453224b71ca4e$var$BurnTokenMsg;

});

parcelRegister("dNOM3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $a0c73ca2ffae2de7$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FreezeTokenMsg = void 0;

var $a0c73ca2ffae2de7$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $a0c73ca2ffae2de7$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $a0c73ca2ffae2de7$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $a0c73ca2ffae2de7$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $a0c73ca2ffae2de7$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $a0c73ca2ffae2de7$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $a0c73ca2ffae2de7$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $a0c73ca2ffae2de7$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $a0c73ca2ffae2de7$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a0c73ca2ffae2de7$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $a0c73ca2ffae2de7$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $a0c73ca2ffae2de7$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $a0c73ca2ffae2de7$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $a0c73ca2ffae2de7$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a0c73ca2ffae2de7$var$FreezeTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $a0c73ca2ffae2de7$var$_inherits2["default"])(FreezeTokenMsg, _BaseMsg);
    var _super = $a0c73ca2ffae2de7$var$_createSuper(FreezeTokenMsg);
    function FreezeTokenMsg(_ref) {
        var _this;
        var address = _ref.address, sybmol = _ref.sybmol, amount = _ref.amount;
        (0, $a0c73ca2ffae2de7$var$_classCallCheck2["default"])(this, FreezeTokenMsg);
        _this = _super.call(this);
        (0, $a0c73ca2ffae2de7$var$_defineProperty2["default"])((0, $a0c73ca2ffae2de7$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $a0c73ca2ffae2de7$var$_defineProperty2["default"])((0, $a0c73ca2ffae2de7$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $a0c73ca2ffae2de7$var$_defineProperty2["default"])((0, $a0c73ca2ffae2de7$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.symbol = sybmol;
        _this.amount = amount;
        return _this;
    }
    (0, $a0c73ca2ffae2de7$var$_createClass2["default"])(FreezeTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    symbol: this.symbol,
                    amount: this.amount
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $a0c73ca2ffae2de7$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    amount: this.amount,
                    aminoPrefix: $5JQUv.AminoPrefix.FreezeMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $a0c73ca2ffae2de7$require$Buffer.from(""),
                    symbol: "",
                    amount: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.FreezeMsg
                };
            }
        }
    ]);
    return FreezeTokenMsg;
}($kg2QH.BaseMsg);
module.exports.FreezeTokenMsg = $a0c73ca2ffae2de7$var$FreezeTokenMsg;

});

parcelRegister("9HUOL", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $711434080d9a7fab$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnFreezeTokenMsg = void 0;

var $711434080d9a7fab$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $711434080d9a7fab$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $711434080d9a7fab$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $711434080d9a7fab$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $711434080d9a7fab$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $711434080d9a7fab$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $711434080d9a7fab$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $711434080d9a7fab$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $711434080d9a7fab$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $711434080d9a7fab$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $711434080d9a7fab$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $711434080d9a7fab$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $711434080d9a7fab$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $711434080d9a7fab$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $711434080d9a7fab$var$UnFreezeTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $711434080d9a7fab$var$_inherits2["default"])(UnFreezeTokenMsg, _BaseMsg);
    var _super = $711434080d9a7fab$var$_createSuper(UnFreezeTokenMsg);
    function UnFreezeTokenMsg(_ref) {
        var _this;
        var address = _ref.address, sybmol = _ref.sybmol, amount = _ref.amount;
        (0, $711434080d9a7fab$var$_classCallCheck2["default"])(this, UnFreezeTokenMsg);
        _this = _super.call(this);
        (0, $711434080d9a7fab$var$_defineProperty2["default"])((0, $711434080d9a7fab$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $711434080d9a7fab$var$_defineProperty2["default"])((0, $711434080d9a7fab$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $711434080d9a7fab$var$_defineProperty2["default"])((0, $711434080d9a7fab$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.symbol = sybmol;
        _this.amount = amount;
        return _this;
    }
    (0, $711434080d9a7fab$var$_createClass2["default"])(UnFreezeTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    symbol: this.symbol,
                    amount: this.amount
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $711434080d9a7fab$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    amount: this.amount,
                    aminoPrefix: $5JQUv.AminoPrefix.UnfreezeMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $711434080d9a7fab$require$Buffer.from(""),
                    symbol: "",
                    amount: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.UnfreezeMsg
                };
            }
        }
    ]);
    return UnFreezeTokenMsg;
}($kg2QH.BaseMsg);
module.exports.UnFreezeTokenMsg = $711434080d9a7fab$var$UnFreezeTokenMsg;

});

parcelRegister("bKkdk", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $88d3abaa0aee5b95$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IssueTokenMsg = void 0;

var $88d3abaa0aee5b95$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $88d3abaa0aee5b95$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $88d3abaa0aee5b95$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $88d3abaa0aee5b95$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $88d3abaa0aee5b95$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $88d3abaa0aee5b95$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $88d3abaa0aee5b95$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $88d3abaa0aee5b95$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $88d3abaa0aee5b95$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $88d3abaa0aee5b95$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $88d3abaa0aee5b95$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $88d3abaa0aee5b95$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $88d3abaa0aee5b95$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $88d3abaa0aee5b95$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $88d3abaa0aee5b95$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $88d3abaa0aee5b95$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $88d3abaa0aee5b95$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $88d3abaa0aee5b95$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $88d3abaa0aee5b95$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $88d3abaa0aee5b95$var$IssueTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $88d3abaa0aee5b95$var$_inherits2["default"])(IssueTokenMsg, _BaseMsg);
    var _super = $88d3abaa0aee5b95$var$_createSuper(IssueTokenMsg);
    function IssueTokenMsg(params, address) {
        var _this;
        (0, $88d3abaa0aee5b95$var$_classCallCheck2["default"])(this, IssueTokenMsg);
        _this = _super.call(this);
        (0, $88d3abaa0aee5b95$var$_defineProperty2["default"])((0, $88d3abaa0aee5b95$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $88d3abaa0aee5b95$var$_defineProperty2["default"])((0, $88d3abaa0aee5b95$var$_assertThisInitialized2["default"])(_this), "params", void 0);
        _this.from = address;
        _this.params = params;
        return _this;
    }
    (0, $88d3abaa0aee5b95$var$_createClass2["default"])(IssueTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = $88d3abaa0aee5b95$var$_objectSpread({
                    from: this.from
                }, this.params);
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $88d3abaa0aee5b95$var$crypto.decodeAddress(this.from),
                    name: this.params.name,
                    symbol: this.params.symbol,
                    total_supply: this.params.total_supply,
                    mintable: this.params.mintable,
                    aminoPrefix: $5JQUv.AminoPrefix.IssueMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $88d3abaa0aee5b95$require$Buffer.from,
                    name: "",
                    symbol: "",
                    total_supply: 0,
                    mintable: false,
                    aminoPrefix: $5JQUv.AminoPrefix.IssueMsg
                };
            }
        }
    ]);
    return IssueTokenMsg;
}($kg2QH.BaseMsg);
module.exports.IssueTokenMsg = $88d3abaa0aee5b95$var$IssueTokenMsg;

});

parcelRegister("6RBU3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4ff51814c69a30bf$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MintTokenMsg = void 0;

var $4ff51814c69a30bf$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $4ff51814c69a30bf$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $4ff51814c69a30bf$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $4ff51814c69a30bf$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $4ff51814c69a30bf$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $4ff51814c69a30bf$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $4ff51814c69a30bf$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $4ff51814c69a30bf$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $kg2QH = parcelRequire("kg2QH");

var $4ff51814c69a30bf$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $4ff51814c69a30bf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4ff51814c69a30bf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $4ff51814c69a30bf$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4ff51814c69a30bf$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4ff51814c69a30bf$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $4ff51814c69a30bf$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $4ff51814c69a30bf$var$MintTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $4ff51814c69a30bf$var$_inherits2["default"])(MintTokenMsg, _BaseMsg);
    var _super = $4ff51814c69a30bf$var$_createSuper(MintTokenMsg);
    function MintTokenMsg(_ref) {
        var _this;
        var address = _ref.address, sybmol = _ref.sybmol, amount = _ref.amount;
        (0, $4ff51814c69a30bf$var$_classCallCheck2["default"])(this, MintTokenMsg);
        _this = _super.call(this);
        (0, $4ff51814c69a30bf$var$_defineProperty2["default"])((0, $4ff51814c69a30bf$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $4ff51814c69a30bf$var$_defineProperty2["default"])((0, $4ff51814c69a30bf$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $4ff51814c69a30bf$var$_defineProperty2["default"])((0, $4ff51814c69a30bf$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.symbol = sybmol;
        _this.amount = amount;
        return _this;
    }
    (0, $4ff51814c69a30bf$var$_createClass2["default"])(MintTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    amount: Number(new $4ff51814c69a30bf$var$_big["default"](this.amount).mul(Math.pow(10, 8)).toString()),
                    symbol: this.symbol
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $4ff51814c69a30bf$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    amount: Number(new $4ff51814c69a30bf$var$_big["default"](this.amount).mul(Math.pow(10, 8)).toString()),
                    aminoPrefix: $5JQUv.AminoPrefix.MintMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $4ff51814c69a30bf$require$Buffer.from(""),
                    symbol: "",
                    amount: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.MintMsg
                };
            }
        }
    ]);
    return MintTokenMsg;
}($kg2QH.BaseMsg);
module.exports.MintTokenMsg = $4ff51814c69a30bf$var$MintTokenMsg;

});

parcelRegister("eYaI0", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $ae5ef9d975531cf1$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeLockMsg = void 0;

var $ae5ef9d975531cf1$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $ae5ef9d975531cf1$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $ae5ef9d975531cf1$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $ae5ef9d975531cf1$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $ae5ef9d975531cf1$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $ae5ef9d975531cf1$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $ae5ef9d975531cf1$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $ae5ef9d975531cf1$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $ae5ef9d975531cf1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ae5ef9d975531cf1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ae5ef9d975531cf1$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ae5ef9d975531cf1$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ae5ef9d975531cf1$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $ae5ef9d975531cf1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ae5ef9d975531cf1$var$TimeLockMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $ae5ef9d975531cf1$var$_inherits2["default"])(TimeLockMsg, _BaseMsg);
    var _super = $ae5ef9d975531cf1$var$_createSuper(TimeLockMsg);
    function TimeLockMsg(_ref) {
        var _this;
        var address = _ref.address, description = _ref.description, amount = _ref.amount, lock_time = _ref.lock_time;
        (0, $ae5ef9d975531cf1$var$_classCallCheck2["default"])(this, TimeLockMsg);
        _this = _super.call(this);
        (0, $ae5ef9d975531cf1$var$_defineProperty2["default"])((0, $ae5ef9d975531cf1$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $ae5ef9d975531cf1$var$_defineProperty2["default"])((0, $ae5ef9d975531cf1$var$_assertThisInitialized2["default"])(_this), "description", void 0);
        (0, $ae5ef9d975531cf1$var$_defineProperty2["default"])((0, $ae5ef9d975531cf1$var$_assertThisInitialized2["default"])(_this), "lock_time", void 0);
        (0, $ae5ef9d975531cf1$var$_defineProperty2["default"])((0, $ae5ef9d975531cf1$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.description = description;
        _this.amount = amount;
        _this.lock_time = lock_time;
        return _this;
    }
    (0, $ae5ef9d975531cf1$var$_createClass2["default"])(TimeLockMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    amount: this.amount,
                    description: this.description,
                    lock_time: this.lock_time
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $ae5ef9d975531cf1$var$crypto.decodeAddress(this.from),
                    description: this.description,
                    amount: this.amount,
                    lock_time: this.lock_time,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeLockMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $ae5ef9d975531cf1$require$Buffer.from(""),
                    description: "",
                    amount: [
                        {
                            denom: "",
                            amount: 0
                        }
                    ],
                    lock_time: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeLockMsg
                };
            }
        }
    ]);
    return TimeLockMsg;
}($kg2QH.BaseMsg);
module.exports.TimeLockMsg = $ae5ef9d975531cf1$var$TimeLockMsg;

});

parcelRegister("jthvI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e2ce4efe48e9f859$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeReLockMsg = void 0;

var $e2ce4efe48e9f859$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $e2ce4efe48e9f859$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $e2ce4efe48e9f859$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $e2ce4efe48e9f859$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $e2ce4efe48e9f859$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $e2ce4efe48e9f859$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $e2ce4efe48e9f859$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $e2ce4efe48e9f859$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $e2ce4efe48e9f859$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e2ce4efe48e9f859$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $e2ce4efe48e9f859$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $e2ce4efe48e9f859$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $e2ce4efe48e9f859$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $e2ce4efe48e9f859$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $e2ce4efe48e9f859$var$TimeReLockMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $e2ce4efe48e9f859$var$_inherits2["default"])(TimeReLockMsg, _BaseMsg);
    var _super = $e2ce4efe48e9f859$var$_createSuper(TimeReLockMsg);
    function TimeReLockMsg(_ref) {
        var _this;
        var address = _ref.address, time_lock_id = _ref.time_lock_id, description = _ref.description, amount = _ref.amount, lock_time = _ref.lock_time;
        (0, $e2ce4efe48e9f859$var$_classCallCheck2["default"])(this, TimeReLockMsg);
        _this = _super.call(this);
        (0, $e2ce4efe48e9f859$var$_defineProperty2["default"])((0, $e2ce4efe48e9f859$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $e2ce4efe48e9f859$var$_defineProperty2["default"])((0, $e2ce4efe48e9f859$var$_assertThisInitialized2["default"])(_this), "time_lock_id", void 0);
        (0, $e2ce4efe48e9f859$var$_defineProperty2["default"])((0, $e2ce4efe48e9f859$var$_assertThisInitialized2["default"])(_this), "description", void 0);
        (0, $e2ce4efe48e9f859$var$_defineProperty2["default"])((0, $e2ce4efe48e9f859$var$_assertThisInitialized2["default"])(_this), "lock_time", void 0);
        (0, $e2ce4efe48e9f859$var$_defineProperty2["default"])((0, $e2ce4efe48e9f859$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        _this.from = address;
        _this.description = description;
        _this.amount = amount;
        _this.lock_time = lock_time;
        _this.time_lock_id = time_lock_id;
        return _this;
    }
    (0, $e2ce4efe48e9f859$var$_createClass2["default"])(TimeReLockMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    time_lock_id: this.time_lock_id,
                    amount: this.amount,
                    description: this.description,
                    lock_time: this.lock_time
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $e2ce4efe48e9f859$var$crypto.decodeAddress(this.from),
                    time_lock_id: this.time_lock_id,
                    description: this.description,
                    amount: this.amount,
                    lock_time: this.lock_time,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeRelockMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $e2ce4efe48e9f859$require$Buffer.from(""),
                    description: "",
                    amount: 0,
                    lock_time: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeRelockMsg
                };
            }
        }
    ]);
    return TimeReLockMsg;
}($kg2QH.BaseMsg);
module.exports.TimeReLockMsg = $e2ce4efe48e9f859$var$TimeReLockMsg;

});

parcelRegister("7hYSy", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $54e9583771316429$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TimeUnlockMsg = void 0;

var $54e9583771316429$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $54e9583771316429$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $54e9583771316429$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $54e9583771316429$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $54e9583771316429$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $54e9583771316429$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $54e9583771316429$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $54e9583771316429$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $54e9583771316429$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $54e9583771316429$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $54e9583771316429$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $54e9583771316429$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $54e9583771316429$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $54e9583771316429$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $54e9583771316429$var$TimeUnlockMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $54e9583771316429$var$_inherits2["default"])(TimeUnlockMsg, _BaseMsg);
    var _super = $54e9583771316429$var$_createSuper(TimeUnlockMsg);
    function TimeUnlockMsg(_ref) {
        var _this;
        var address = _ref.address, time_lock_id = _ref.time_lock_id;
        (0, $54e9583771316429$var$_classCallCheck2["default"])(this, TimeUnlockMsg);
        _this = _super.call(this);
        (0, $54e9583771316429$var$_defineProperty2["default"])((0, $54e9583771316429$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $54e9583771316429$var$_defineProperty2["default"])((0, $54e9583771316429$var$_assertThisInitialized2["default"])(_this), "time_lock_id", void 0);
        _this.from = address;
        _this.time_lock_id = time_lock_id;
        return _this;
    }
    (0, $54e9583771316429$var$_createClass2["default"])(TimeUnlockMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    time_lock_id: this.time_lock_id
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $54e9583771316429$var$crypto.decodeAddress(this.from),
                    time_lock_id: this.time_lock_id,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeUnlockMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $54e9583771316429$require$Buffer.from(""),
                    time_lock_id: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.TimeUnlockMsg
                };
            }
        }
    ]);
    return TimeUnlockMsg;
}($kg2QH.BaseMsg);
module.exports.TimeUnlockMsg = $54e9583771316429$var$TimeUnlockMsg;

});

parcelRegister("9nTwp", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $6d5154852152cf27$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IssueMiniTokenMsg = void 0;

var $6d5154852152cf27$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $6d5154852152cf27$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $6d5154852152cf27$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $6d5154852152cf27$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $6d5154852152cf27$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $6d5154852152cf27$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $6d5154852152cf27$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $6d5154852152cf27$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $6d5154852152cf27$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6d5154852152cf27$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6d5154852152cf27$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $6d5154852152cf27$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6d5154852152cf27$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6d5154852152cf27$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6d5154852152cf27$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $6d5154852152cf27$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $6d5154852152cf27$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $6d5154852152cf27$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $6d5154852152cf27$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $6d5154852152cf27$var$IssueMiniTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $6d5154852152cf27$var$_inherits2["default"])(IssueMiniTokenMsg, _BaseMsg);
    var _super = $6d5154852152cf27$var$_createSuper(IssueMiniTokenMsg);
    function IssueMiniTokenMsg(params) {
        var _this;
        (0, $6d5154852152cf27$var$_classCallCheck2["default"])(this, IssueMiniTokenMsg);
        _this = _super.call(this);
        (0, $6d5154852152cf27$var$_defineProperty2["default"])((0, $6d5154852152cf27$var$_assertThisInitialized2["default"])(_this), "params", void 0);
        _this.params = params;
        return _this;
    }
    (0, $6d5154852152cf27$var$_createClass2["default"])(IssueMiniTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = $6d5154852152cf27$var$_objectSpread({}, this.params);
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $6d5154852152cf27$var$crypto.decodeAddress(this.params.from),
                    name: this.params.name,
                    symbol: this.params.symbol,
                    total_supply: this.params.total_supply,
                    mintable: this.params.mintable,
                    token_uri: this.params.token_uri,
                    aminoPrefix: $5JQUv.AminoPrefix.IssueMiniMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $6d5154852152cf27$require$Buffer.from,
                    name: "",
                    symbol: "",
                    total_supply: 0,
                    mintable: false,
                    token_uri: "",
                    aminoPrefix: $5JQUv.AminoPrefix.IssueMiniMsg
                };
            }
        }
    ]);
    return IssueMiniTokenMsg;
}($kg2QH.BaseMsg);
module.exports.IssueMiniTokenMsg = $6d5154852152cf27$var$IssueMiniTokenMsg;

});

parcelRegister("6zsql", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4c8c0f5e5c3610ce$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IssueTinyTokenMsg = void 0;

var $4c8c0f5e5c3610ce$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $4c8c0f5e5c3610ce$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $4c8c0f5e5c3610ce$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $4c8c0f5e5c3610ce$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $4c8c0f5e5c3610ce$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $4c8c0f5e5c3610ce$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $4c8c0f5e5c3610ce$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $4c8c0f5e5c3610ce$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $4c8c0f5e5c3610ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4c8c0f5e5c3610ce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4c8c0f5e5c3610ce$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $4c8c0f5e5c3610ce$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4c8c0f5e5c3610ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4c8c0f5e5c3610ce$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4c8c0f5e5c3610ce$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $4c8c0f5e5c3610ce$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4c8c0f5e5c3610ce$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4c8c0f5e5c3610ce$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $4c8c0f5e5c3610ce$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $4c8c0f5e5c3610ce$var$IssueTinyTokenMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $4c8c0f5e5c3610ce$var$_inherits2["default"])(IssueTinyTokenMsg, _BaseMsg);
    var _super = $4c8c0f5e5c3610ce$var$_createSuper(IssueTinyTokenMsg);
    function IssueTinyTokenMsg(params) {
        var _this;
        (0, $4c8c0f5e5c3610ce$var$_classCallCheck2["default"])(this, IssueTinyTokenMsg);
        _this = _super.call(this);
        (0, $4c8c0f5e5c3610ce$var$_defineProperty2["default"])((0, $4c8c0f5e5c3610ce$var$_assertThisInitialized2["default"])(_this), "params", void 0);
        _this.params = params;
        return _this;
    }
    (0, $4c8c0f5e5c3610ce$var$_createClass2["default"])(IssueTinyTokenMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = $4c8c0f5e5c3610ce$var$_objectSpread({}, this.params);
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $4c8c0f5e5c3610ce$var$crypto.decodeAddress(this.params.from),
                    name: this.params.name,
                    symbol: this.params.symbol,
                    total_supply: this.params.total_supply,
                    mintable: this.params.mintable,
                    token_uri: this.params.token_uri,
                    aminoPrefix: $5JQUv.AminoPrefix.IssueTinyMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $4c8c0f5e5c3610ce$require$Buffer.from,
                    name: "",
                    symbol: "",
                    total_supply: 0,
                    mintable: false,
                    token_uri: "",
                    aminoPrefix: $5JQUv.AminoPrefix.IssueTinyMsg
                };
            }
        }
    ]);
    return IssueTinyTokenMsg;
}($kg2QH.BaseMsg);
module.exports.IssueTinyTokenMsg = $4c8c0f5e5c3610ce$var$IssueTinyTokenMsg;

});

parcelRegister("1ecZt", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $0e512cdf195f9e0e$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetTokenUriMsg = void 0;

var $0e512cdf195f9e0e$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $0e512cdf195f9e0e$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $0e512cdf195f9e0e$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $0e512cdf195f9e0e$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $0e512cdf195f9e0e$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $0e512cdf195f9e0e$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $0e512cdf195f9e0e$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $0e512cdf195f9e0e$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $0e512cdf195f9e0e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0e512cdf195f9e0e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $0e512cdf195f9e0e$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $0e512cdf195f9e0e$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $0e512cdf195f9e0e$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $0e512cdf195f9e0e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $0e512cdf195f9e0e$var$SetTokenUriMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $0e512cdf195f9e0e$var$_inherits2["default"])(SetTokenUriMsg, _BaseMsg);
    var _super = $0e512cdf195f9e0e$var$_createSuper(SetTokenUriMsg);
    function SetTokenUriMsg(_ref) {
        var _this;
        var from = _ref.from, symbol = _ref.symbol, token_uri = _ref.token_uri;
        (0, $0e512cdf195f9e0e$var$_classCallCheck2["default"])(this, SetTokenUriMsg);
        _this = _super.call(this);
        (0, $0e512cdf195f9e0e$var$_defineProperty2["default"])((0, $0e512cdf195f9e0e$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $0e512cdf195f9e0e$var$_defineProperty2["default"])((0, $0e512cdf195f9e0e$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $0e512cdf195f9e0e$var$_defineProperty2["default"])((0, $0e512cdf195f9e0e$var$_assertThisInitialized2["default"])(_this), "token_uri", void 0);
        _this.from = from;
        _this.symbol = symbol;
        _this.token_uri = token_uri;
        return _this;
    }
    (0, $0e512cdf195f9e0e$var$_createClass2["default"])(SetTokenUriMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var signMsg = {
                    from: this.from,
                    symbol: this.symbol,
                    token_uri: this.token_uri
                };
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    from: $0e512cdf195f9e0e$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    token_uri: this.token_uri,
                    aminoPrefix: $5JQUv.AminoPrefix.SetURIMsg
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $0e512cdf195f9e0e$require$Buffer.from(""),
                    symbol: "",
                    token_uri: "",
                    aminoPrefix: $5JQUv.AminoPrefix.SetURIMsg
                };
            }
        }
    ]);
    return SetTokenUriMsg;
}($kg2QH.BaseMsg);
module.exports.SetTokenUriMsg = $0e512cdf195f9e0e$var$SetTokenUriMsg;

});


parcelRegister("6gb15", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $48ecc856ddf0dd5f$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SendMsg = void 0;

var $48ecc856ddf0dd5f$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $48ecc856ddf0dd5f$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $48ecc856ddf0dd5f$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $48ecc856ddf0dd5f$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $48ecc856ddf0dd5f$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $48ecc856ddf0dd5f$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $48ecc856ddf0dd5f$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $48ecc856ddf0dd5f$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $48ecc856ddf0dd5f$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");

var $kg2QH = parcelRequire("kg2QH");
function $48ecc856ddf0dd5f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $48ecc856ddf0dd5f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $48ecc856ddf0dd5f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $48ecc856ddf0dd5f$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $48ecc856ddf0dd5f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $48ecc856ddf0dd5f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $48ecc856ddf0dd5f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $48ecc856ddf0dd5f$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $48ecc856ddf0dd5f$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $48ecc856ddf0dd5f$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $48ecc856ddf0dd5f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * @ignore
 * Only support transfers of one-to-one, one-to-many
 */ var $48ecc856ddf0dd5f$var$SendMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $48ecc856ddf0dd5f$var$_inherits2["default"])(SendMsg, _BaseMsg);
    var _super = $48ecc856ddf0dd5f$var$_createSuper(SendMsg);
    function SendMsg(sender, outputs) {
        var _this;
        (0, $48ecc856ddf0dd5f$var$_classCallCheck2["default"])(this, SendMsg);
        _this = _super.call(this);
        (0, $48ecc856ddf0dd5f$var$_defineProperty2["default"])((0, $48ecc856ddf0dd5f$var$_assertThisInitialized2["default"])(_this), "sender", void 0);
        (0, $48ecc856ddf0dd5f$var$_defineProperty2["default"])((0, $48ecc856ddf0dd5f$var$_assertThisInitialized2["default"])(_this), "outputs", void 0);
        (0, $48ecc856ddf0dd5f$var$_defineProperty2["default"])((0, $48ecc856ddf0dd5f$var$_assertThisInitialized2["default"])(_this), "aminoPrefix", $5JQUv.AminoPrefix.MsgSend);
        _this.sender = sender;
        _this.outputs = outputs;
        return _this;
    }
    (0, $48ecc856ddf0dd5f$var$_createClass2["default"])(SendMsg, [
        {
            key: "calInputCoins",
            value: function calInputCoins(inputsCoins, coins) {
                coins.forEach(function(coin) {
                    var existCoin = inputsCoins.find(function(c) {
                        return c.denom === coin.denom;
                    });
                    if (existCoin) {
                        var existAmount = new $48ecc856ddf0dd5f$var$_big["default"](existCoin.amount);
                        existCoin.amount = Number(existAmount.plus(coin.amount).toString());
                    } else inputsCoins.push($48ecc856ddf0dd5f$var$_objectSpread({}, coin));
                });
            }
        },
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var _this2 = this;
                var signMsg = {
                    inputs: [
                        {
                            address: this.sender,
                            coins: []
                        }
                    ],
                    outputs: this.outputs
                };
                this.outputs.forEach(function(item) {
                    _this2.calInputCoins(signMsg.inputs[0].coins, item.coins);
                });
                return signMsg;
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var _this3 = this;
                var msg = {
                    inputs: [
                        {
                            address: $48ecc856ddf0dd5f$var$crypto.decodeAddress(this.sender),
                            coins: []
                        }
                    ],
                    outputs: [],
                    aminoPrefix: this.aminoPrefix
                };
                this.outputs.forEach(function(item) {
                    _this3.calInputCoins(msg.inputs[0].coins, item.coins);
                    var output = {
                        address: $48ecc856ddf0dd5f$var$crypto.decodeAddress(item.address),
                        coins: item.coins
                    };
                    msg.outputs.push(output);
                });
                return msg;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    inputs: [
                        {
                            address: $48ecc856ddf0dd5f$require$Buffer.from(""),
                            coins: [
                                {
                                    denom: "",
                                    amount: 0
                                }
                            ]
                        }
                    ],
                    outputs: [
                        {
                            address: $48ecc856ddf0dd5f$require$Buffer.from(""),
                            coins: [
                                {
                                    denom: "",
                                    amount: 0
                                }
                            ]
                        }
                    ],
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSend
                };
            }
        }
    ]);
    return SendMsg;
}($kg2QH.BaseMsg);
module.exports.SendMsg = $48ecc856ddf0dd5f$var$SendMsg;

});

parcelRegister("hw10X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $j2TEd = parcelRequire("j2TEd");
Object.keys($j2TEd).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $j2TEd[key];
        }
    });
});

var $7ffzL = parcelRequire("7ffzL");
Object.keys($7ffzL).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $7ffzL[key];
        }
    });
});

var $gPgLF = parcelRequire("gPgLF");
Object.keys($gPgLF).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $gPgLF[key];
        }
    });
});

var $iYthi = parcelRequire("iYthi");
Object.keys($iYthi).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $iYthi[key];
        }
    });
});

});
parcelRegister("j2TEd", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $ddd95eadcd2d8362$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindMsg = void 0;

var $ddd95eadcd2d8362$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $ddd95eadcd2d8362$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $ddd95eadcd2d8362$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $ddd95eadcd2d8362$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $ddd95eadcd2d8362$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $ddd95eadcd2d8362$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $ddd95eadcd2d8362$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $ddd95eadcd2d8362$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $ddd95eadcd2d8362$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ddd95eadcd2d8362$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $ddd95eadcd2d8362$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $ddd95eadcd2d8362$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $ddd95eadcd2d8362$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $ddd95eadcd2d8362$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ddd95eadcd2d8362$var$BindMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $ddd95eadcd2d8362$var$_inherits2["default"])(BindMsg, _BaseMsg);
    var _super = $ddd95eadcd2d8362$var$_createSuper(BindMsg);
    function BindMsg(_ref) {
        var _this;
        var from = _ref.from, symbol = _ref.symbol, amount = _ref.amount, contract_address = _ref.contract_address, contract_decimals = _ref.contract_decimals, expire_time = _ref.expire_time;
        (0, $ddd95eadcd2d8362$var$_classCallCheck2["default"])(this, BindMsg);
        _this = _super.call(this);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "symbol", void 0);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "contract_address", void 0);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "contract_decimals", void 0);
        (0, $ddd95eadcd2d8362$var$_defineProperty2["default"])((0, $ddd95eadcd2d8362$var$_assertThisInitialized2["default"])(_this), "expire_time", void 0);
        _this.from = from;
        _this.symbol = symbol;
        _this.amount = amount;
        _this.contract_address = contract_address;
        _this.contract_decimals = contract_decimals;
        _this.expire_time = expire_time;
        return _this;
    }
    (0, $ddd95eadcd2d8362$var$_createClass2["default"])(BindMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                return {
                    from: this.from,
                    symbol: this.symbol,
                    amount: this.amount,
                    contract_address: this.contract_address,
                    contract_decimals: this.contract_decimals,
                    expire_time: this.expire_time
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                return {
                    from: $ddd95eadcd2d8362$var$crypto.decodeAddress(this.from),
                    symbol: this.symbol,
                    amount: this.amount,
                    contract_address: $ddd95eadcd2d8362$require$Buffer.from(this.contract_address.slice(2), "hex"),
                    contract_decimals: this.contract_decimals,
                    expire_time: this.expire_time,
                    aminoPrefix: $5JQUv.AminoPrefix.BindMsg
                };
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $ddd95eadcd2d8362$require$Buffer.from(""),
                    symbol: "",
                    amount: 0,
                    contract_address: $ddd95eadcd2d8362$require$Buffer.from(""),
                    contract_decimals: 0,
                    expire_time: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.BindMsg
                };
            }
        }
    ]);
    return BindMsg;
}($kg2QH.BaseMsg);
module.exports.BindMsg = $ddd95eadcd2d8362$var$BindMsg;

});

parcelRegister("7ffzL", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5466042158ea39d3$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimMsg = void 0;

var $5466042158ea39d3$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $5466042158ea39d3$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $5466042158ea39d3$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $5466042158ea39d3$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $5466042158ea39d3$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $5466042158ea39d3$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $5466042158ea39d3$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $5466042158ea39d3$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");

var $gPgLF = parcelRequire("gPgLF");
function $5466042158ea39d3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $5466042158ea39d3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $5466042158ea39d3$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $5466042158ea39d3$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $5466042158ea39d3$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $5466042158ea39d3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $5466042158ea39d3$var$ClaimMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $5466042158ea39d3$var$_inherits2["default"])(ClaimMsg, _BaseMsg);
    var _super = $5466042158ea39d3$var$_createSuper(ClaimMsg);
    function ClaimMsg(_ref) {
        var _this;
        var claim_type = _ref.claim_type, sequence = _ref.sequence, claim = _ref.claim, validator_address = _ref.validator_address;
        (0, $5466042158ea39d3$var$_classCallCheck2["default"])(this, ClaimMsg);
        _this = _super.call(this);
        (0, $5466042158ea39d3$var$_defineProperty2["default"])((0, $5466042158ea39d3$var$_assertThisInitialized2["default"])(_this), "claim_type", void 0);
        (0, $5466042158ea39d3$var$_defineProperty2["default"])((0, $5466042158ea39d3$var$_assertThisInitialized2["default"])(_this), "sequence", void 0);
        (0, $5466042158ea39d3$var$_defineProperty2["default"])((0, $5466042158ea39d3$var$_assertThisInitialized2["default"])(_this), "claim", void 0);
        (0, $5466042158ea39d3$var$_defineProperty2["default"])((0, $5466042158ea39d3$var$_assertThisInitialized2["default"])(_this), "validator_address", void 0);
        _this.claim_type = claim_type;
        _this.sequence = sequence;
        _this.claim = claim;
        _this.validator_address = validator_address;
        return _this;
    }
    (0, $5466042158ea39d3$var$_createClass2["default"])(ClaimMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                return {
                    claim_type: this.claim_type,
                    sequence: this.sequence,
                    claim: this.claim,
                    validator_address: this.validator_address
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                return {
                    claim_type: this.claim_type,
                    sequence: this.sequence,
                    claim: this.claim,
                    validator_address: $5466042158ea39d3$var$crypto.decodeAddress(this.validator_address),
                    aminoPrefix: $5JQUv.AminoPrefix.ClaimMsg
                };
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    claim_type: $gPgLF.ClaimTypes.ClaimTypeSkipSequence,
                    sequence: 0,
                    claim: "",
                    validator_address: $5466042158ea39d3$require$Buffer.from(""),
                    aminoPrefix: $5JQUv.AminoPrefix.ClaimMsg
                };
            }
        }
    ]);
    return ClaimMsg;
}($kg2QH.BaseMsg);
module.exports.ClaimMsg = $5466042158ea39d3$var$ClaimMsg;

});
parcelRegister("gPgLF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BindStatus = module.exports.RefundReason = module.exports.ClaimTypes = void 0;
var $c3fe6a7e06b7f19c$var$ClaimTypes;
module.exports.ClaimTypes = $c3fe6a7e06b7f19c$var$ClaimTypes;
(function(ClaimTypes) {
    ClaimTypes[ClaimTypes["ClaimTypeSkipSequence"] = 1] = "ClaimTypeSkipSequence";
    ClaimTypes[ClaimTypes["ClaimTypeUpdateBind"] = 2] = "ClaimTypeUpdateBind";
    ClaimTypes[ClaimTypes["ClaimTypeTransferOutRefund"] = 3] = "ClaimTypeTransferOutRefund";
    ClaimTypes[ClaimTypes["ClaimTypeTransferIn"] = 4] = "ClaimTypeTransferIn";
})($c3fe6a7e06b7f19c$var$ClaimTypes || (module.exports.ClaimTypes = $c3fe6a7e06b7f19c$var$ClaimTypes = {}));
var $c3fe6a7e06b7f19c$var$RefundReason;
module.exports.RefundReason = $c3fe6a7e06b7f19c$var$RefundReason;
(function(RefundReason) {
    RefundReason[RefundReason["UnboundToken"] = 1] = "UnboundToken";
    RefundReason[RefundReason["Timeout"] = 2] = "Timeout";
    RefundReason[RefundReason["InsufficientBalance"] = 3] = "InsufficientBalance";
    RefundReason[RefundReason["Unkown"] = 4] = "Unkown";
})($c3fe6a7e06b7f19c$var$RefundReason || (module.exports.RefundReason = $c3fe6a7e06b7f19c$var$RefundReason = {}));
var $c3fe6a7e06b7f19c$var$BindStatus;
module.exports.BindStatus = $c3fe6a7e06b7f19c$var$BindStatus;
(function(BindStatus) {
    BindStatus[BindStatus["BindStatusSuccess"] = 0] = "BindStatusSuccess";
    BindStatus[BindStatus["BindStatusRejected"] = 1] = "BindStatusRejected";
    BindStatus[BindStatus["BindStatusTimeout"] = 2] = "BindStatusTimeout";
    BindStatus[BindStatus["BindStatusInvalidParameter"] = 3] = "BindStatusInvalidParameter";
})($c3fe6a7e06b7f19c$var$BindStatus || (module.exports.BindStatus = $c3fe6a7e06b7f19c$var$BindStatus = {}));

});


parcelRegister("iYthi", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $dd048a92cd7154f8$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferOutMsg = void 0;

var $dd048a92cd7154f8$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $dd048a92cd7154f8$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $dd048a92cd7154f8$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $dd048a92cd7154f8$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $dd048a92cd7154f8$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $dd048a92cd7154f8$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $dd048a92cd7154f8$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $dd048a92cd7154f8$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $kg2QH = parcelRequire("kg2QH");

var $dd048a92cd7154f8$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $dd048a92cd7154f8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dd048a92cd7154f8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dd048a92cd7154f8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dd048a92cd7154f8$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dd048a92cd7154f8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dd048a92cd7154f8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $dd048a92cd7154f8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $dd048a92cd7154f8$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $dd048a92cd7154f8$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $dd048a92cd7154f8$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $dd048a92cd7154f8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $dd048a92cd7154f8$var$TransferOutMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $dd048a92cd7154f8$var$_inherits2["default"])(TransferOutMsg, _BaseMsg);
    var _super = $dd048a92cd7154f8$var$_createSuper(TransferOutMsg);
    function TransferOutMsg(_ref) {
        var _this;
        var from = _ref.from, to = _ref.to, amount = _ref.amount, expire_time = _ref.expire_time;
        (0, $dd048a92cd7154f8$var$_classCallCheck2["default"])(this, TransferOutMsg);
        _this = _super.call(this);
        (0, $dd048a92cd7154f8$var$_defineProperty2["default"])((0, $dd048a92cd7154f8$var$_assertThisInitialized2["default"])(_this), "from", void 0);
        (0, $dd048a92cd7154f8$var$_defineProperty2["default"])((0, $dd048a92cd7154f8$var$_assertThisInitialized2["default"])(_this), "to", void 0);
        (0, $dd048a92cd7154f8$var$_defineProperty2["default"])((0, $dd048a92cd7154f8$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        (0, $dd048a92cd7154f8$var$_defineProperty2["default"])((0, $dd048a92cd7154f8$var$_assertThisInitialized2["default"])(_this), "expire_time", void 0);
        _this.from = from;
        _this.to = to;
        _this.amount = $dd048a92cd7154f8$var$_objectSpread($dd048a92cd7154f8$var$_objectSpread({}, amount), {}, {
            amount: Number(new $dd048a92cd7154f8$var$_big["default"](amount.amount).mul(Math.pow(10, 8)).toString())
        });
        _this.expire_time = expire_time;
        return _this;
    }
    (0, $dd048a92cd7154f8$var$_createClass2["default"])(TransferOutMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                return {
                    from: this.from,
                    to: this.to,
                    amount: this.amount,
                    expire_time: this.expire_time
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                return {
                    from: $dd048a92cd7154f8$var$crypto.decodeAddress(this.from),
                    to: $dd048a92cd7154f8$require$Buffer.from(this.to.slice(2), "hex"),
                    amount: this.amount,
                    expire_time: this.expire_time,
                    aminoPrefix: $5JQUv.AminoPrefix.TransferOutMsg
                };
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    from: $dd048a92cd7154f8$require$Buffer.from(""),
                    to: $dd048a92cd7154f8$require$Buffer.from(""),
                    amount: {
                        denom: "",
                        amount: 0
                    },
                    expire_time: 0,
                    aminoPrefix: $5JQUv.AminoPrefix.TransferOutMsg
                };
            }
        }
    ]);
    return TransferOutMsg;
}($kg2QH.BaseMsg);
module.exports.TransferOutMsg = $dd048a92cd7154f8$var$TransferOutMsg;

});


parcelRegister("1Gpeb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gAhX4 = parcelRequire("gAhX4");
Object.keys($gAhX4).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $gAhX4[key];
        }
    });
});

var $36Xvo = parcelRequire("36Xvo");
Object.keys($36Xvo).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $36Xvo[key];
        }
    });
});

var $1MTC6 = parcelRequire("1MTC6");
Object.keys($1MTC6).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(module.exports, key, {
        enumerable: true,
        get: function get() {
            return $1MTC6[key];
        }
    });
});

});
parcelRegister("gAhX4", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c12deeff3f4d5826$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BscDelegateMsg = void 0;

var $c12deeff3f4d5826$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $c12deeff3f4d5826$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $c12deeff3f4d5826$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $c12deeff3f4d5826$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $c12deeff3f4d5826$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $c12deeff3f4d5826$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $c12deeff3f4d5826$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $c12deeff3f4d5826$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $c12deeff3f4d5826$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c12deeff3f4d5826$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $c12deeff3f4d5826$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $c12deeff3f4d5826$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $c12deeff3f4d5826$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $c12deeff3f4d5826$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $c12deeff3f4d5826$var$BscDelegateMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $c12deeff3f4d5826$var$_inherits2["default"])(BscDelegateMsg, _BaseMsg);
    var _super = $c12deeff3f4d5826$var$_createSuper(BscDelegateMsg);
    function BscDelegateMsg(_ref) {
        var _this;
        var delegator_addr = _ref.delegator_addr, validator_addr = _ref.validator_addr, delegation = _ref.delegation, side_chain_id = _ref.side_chain_id;
        (0, $c12deeff3f4d5826$var$_classCallCheck2["default"])(this, BscDelegateMsg);
        _this = _super.call(this);
        (0, $c12deeff3f4d5826$var$_defineProperty2["default"])((0, $c12deeff3f4d5826$var$_assertThisInitialized2["default"])(_this), "delegator_addr", void 0);
        (0, $c12deeff3f4d5826$var$_defineProperty2["default"])((0, $c12deeff3f4d5826$var$_assertThisInitialized2["default"])(_this), "validator_addr", void 0);
        (0, $c12deeff3f4d5826$var$_defineProperty2["default"])((0, $c12deeff3f4d5826$var$_assertThisInitialized2["default"])(_this), "delegation", void 0);
        (0, $c12deeff3f4d5826$var$_defineProperty2["default"])((0, $c12deeff3f4d5826$var$_assertThisInitialized2["default"])(_this), "side_chain_id", void 0);
        _this.delegator_addr = delegator_addr;
        _this.validator_addr = validator_addr;
        _this.delegation = delegation;
        _this.side_chain_id = side_chain_id;
        return _this;
    }
    (0, $c12deeff3f4d5826$var$_createClass2["default"])(BscDelegateMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var _this$delegation = this.delegation, denom = _this$delegation.denom, amount = _this$delegation.amount;
                var signMsg = {
                    delegator_addr: this.delegator_addr,
                    validator_addr: this.validator_addr,
                    delegation: {
                        denom: denom,
                        amount: String(amount)
                    },
                    side_chain_id: this.side_chain_id
                };
                return {
                    type: "cosmos-sdk/MsgSideChainDelegate",
                    value: signMsg
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    delegator_addr: $c12deeff3f4d5826$var$crypto.decodeAddress(this.delegator_addr),
                    validator_addr: $c12deeff3f4d5826$var$crypto.decodeAddress(this.validator_addr),
                    delegation: this.delegation,
                    side_chain_id: this.side_chain_id,
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainDelegate
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    delegator_addr: $c12deeff3f4d5826$require$Buffer.from(""),
                    validator_addr: $c12deeff3f4d5826$require$Buffer.from(""),
                    delegation: [
                        {
                            denom: "",
                            amount: 0
                        }
                    ],
                    side_chain_id: "",
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainDelegate
                };
            }
        }
    ]);
    return BscDelegateMsg;
}($kg2QH.BaseMsg);
module.exports.BscDelegateMsg = $c12deeff3f4d5826$var$BscDelegateMsg;

});

parcelRegister("36Xvo", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $2440172835ccee8e$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BscUndelegateMsg = void 0;

var $2440172835ccee8e$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $2440172835ccee8e$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $2440172835ccee8e$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $2440172835ccee8e$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $2440172835ccee8e$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $2440172835ccee8e$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $2440172835ccee8e$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $2440172835ccee8e$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $2440172835ccee8e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2440172835ccee8e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $2440172835ccee8e$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $2440172835ccee8e$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $2440172835ccee8e$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $2440172835ccee8e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $2440172835ccee8e$var$BscUndelegateMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $2440172835ccee8e$var$_inherits2["default"])(BscUndelegateMsg, _BaseMsg);
    var _super = $2440172835ccee8e$var$_createSuper(BscUndelegateMsg);
    function BscUndelegateMsg(_ref) {
        var _this;
        var delegator_addr = _ref.delegator_addr, validator_addr = _ref.validator_addr, amount = _ref.amount, side_chain_id = _ref.side_chain_id;
        (0, $2440172835ccee8e$var$_classCallCheck2["default"])(this, BscUndelegateMsg);
        _this = _super.call(this);
        (0, $2440172835ccee8e$var$_defineProperty2["default"])((0, $2440172835ccee8e$var$_assertThisInitialized2["default"])(_this), "delegator_addr", void 0);
        (0, $2440172835ccee8e$var$_defineProperty2["default"])((0, $2440172835ccee8e$var$_assertThisInitialized2["default"])(_this), "validator_addr", void 0);
        (0, $2440172835ccee8e$var$_defineProperty2["default"])((0, $2440172835ccee8e$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        (0, $2440172835ccee8e$var$_defineProperty2["default"])((0, $2440172835ccee8e$var$_assertThisInitialized2["default"])(_this), "side_chain_id", void 0);
        _this.delegator_addr = delegator_addr;
        _this.validator_addr = validator_addr;
        _this.amount = amount;
        _this.side_chain_id = side_chain_id;
        return _this;
    }
    (0, $2440172835ccee8e$var$_createClass2["default"])(BscUndelegateMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var _this$amount = this.amount, denom = _this$amount.denom, amount = _this$amount.amount;
                var signMsg = {
                    delegator_addr: this.delegator_addr,
                    validator_addr: this.validator_addr,
                    amount: {
                        denom: denom,
                        amount: String(amount)
                    },
                    side_chain_id: this.side_chain_id
                };
                return {
                    type: "cosmos-sdk/MsgSideChainUndelegate",
                    value: signMsg
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    delegator_addr: $2440172835ccee8e$var$crypto.decodeAddress(this.delegator_addr),
                    validator_addr: $2440172835ccee8e$var$crypto.decodeAddress(this.validator_addr),
                    amount: this.amount,
                    side_chain_id: this.side_chain_id,
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainUndelegate
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    delegator_addr: $2440172835ccee8e$require$Buffer.from(""),
                    validator_addr: $2440172835ccee8e$require$Buffer.from(""),
                    amount: [
                        {
                            denom: "",
                            amount: 0
                        }
                    ],
                    side_chain_id: "",
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainUndelegate
                };
            }
        }
    ]);
    return BscUndelegateMsg;
}($kg2QH.BaseMsg);
module.exports.BscUndelegateMsg = $2440172835ccee8e$var$BscUndelegateMsg;

});

parcelRegister("1MTC6", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $14d569da66ede6f4$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BscReDelegateMsg = void 0;

var $14d569da66ede6f4$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $14d569da66ede6f4$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $14d569da66ede6f4$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $14d569da66ede6f4$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $14d569da66ede6f4$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $14d569da66ede6f4$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $14d569da66ede6f4$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kg2QH = parcelRequire("kg2QH");

var $14d569da66ede6f4$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $5JQUv = parcelRequire("5JQUv");
function $14d569da66ede6f4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $14d569da66ede6f4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $14d569da66ede6f4$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $14d569da66ede6f4$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $14d569da66ede6f4$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $14d569da66ede6f4$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $14d569da66ede6f4$var$BscReDelegateMsg = /*#__PURE__*/ function(_BaseMsg) {
    (0, $14d569da66ede6f4$var$_inherits2["default"])(BscReDelegateMsg, _BaseMsg);
    var _super = $14d569da66ede6f4$var$_createSuper(BscReDelegateMsg);
    function BscReDelegateMsg(_ref) {
        var _this;
        var delegator_addr = _ref.delegator_addr, validator_src_addr = _ref.validator_src_addr, validator_dst_addr = _ref.validator_dst_addr, amount = _ref.amount, side_chain_id = _ref.side_chain_id;
        (0, $14d569da66ede6f4$var$_classCallCheck2["default"])(this, BscReDelegateMsg);
        _this = _super.call(this);
        (0, $14d569da66ede6f4$var$_defineProperty2["default"])((0, $14d569da66ede6f4$var$_assertThisInitialized2["default"])(_this), "delegator_addr", void 0);
        (0, $14d569da66ede6f4$var$_defineProperty2["default"])((0, $14d569da66ede6f4$var$_assertThisInitialized2["default"])(_this), "validator_src_addr", void 0);
        (0, $14d569da66ede6f4$var$_defineProperty2["default"])((0, $14d569da66ede6f4$var$_assertThisInitialized2["default"])(_this), "validator_dst_addr", void 0);
        (0, $14d569da66ede6f4$var$_defineProperty2["default"])((0, $14d569da66ede6f4$var$_assertThisInitialized2["default"])(_this), "amount", void 0);
        (0, $14d569da66ede6f4$var$_defineProperty2["default"])((0, $14d569da66ede6f4$var$_assertThisInitialized2["default"])(_this), "side_chain_id", void 0);
        _this.delegator_addr = delegator_addr;
        _this.validator_src_addr = validator_src_addr;
        _this.validator_dst_addr = validator_dst_addr;
        _this.amount = amount;
        _this.side_chain_id = side_chain_id;
        return _this;
    }
    (0, $14d569da66ede6f4$var$_createClass2["default"])(BscReDelegateMsg, [
        {
            key: "getSignMsg",
            value: function getSignMsg() {
                var _this$amount = this.amount, denom = _this$amount.denom, amount = _this$amount.amount;
                var signMsg = {
                    delegator_addr: this.delegator_addr,
                    validator_src_addr: this.validator_src_addr,
                    validator_dst_addr: this.validator_dst_addr,
                    amount: {
                        denom: denom,
                        amount: String(amount)
                    },
                    side_chain_id: this.side_chain_id
                };
                return {
                    type: "cosmos-sdk/MsgSideChainRedelegate",
                    value: signMsg
                };
            }
        },
        {
            key: "getMsg",
            value: function getMsg() {
                var data = {
                    delegator_addr: $14d569da66ede6f4$var$crypto.decodeAddress(this.delegator_addr),
                    validator_src_addr: $14d569da66ede6f4$var$crypto.decodeAddress(this.validator_src_addr),
                    validator_dst_addr: $14d569da66ede6f4$var$crypto.decodeAddress(this.validator_dst_addr),
                    amount: this.amount,
                    side_chain_id: this.side_chain_id,
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainRedelegate
                };
                return data;
            }
        }
    ], [
        {
            key: "defaultMsg",
            value: function defaultMsg() {
                return {
                    delegator_addr: $14d569da66ede6f4$require$Buffer.from(""),
                    validator_src_addr: $14d569da66ede6f4$require$Buffer.from(""),
                    validator_dst_addr: $14d569da66ede6f4$require$Buffer.from(""),
                    amount: [
                        {
                            denom: "",
                            amount: 0
                        }
                    ],
                    side_chain_id: "",
                    aminoPrefix: $5JQUv.AminoPrefix.MsgSideChainRedelegate
                };
            }
        }
    ]);
    return BscReDelegateMsg;
}($kg2QH.BaseMsg);
module.exports.BscReDelegateMsg = $14d569da66ede6f4$var$BscReDelegateMsg;

});



parcelRegister("kyzm3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $ef7268519b0e13aa$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SubmitProposalMsg = module.exports.OrderBook = module.exports.OrderBookLevel = module.exports.TradingPair = module.exports.OpenOrder = module.exports.TokenBalance = module.exports.AppAccount = module.exports.BaseAccount = module.exports.TokenOfList = module.exports.Token = void 0;

var $ef7268519b0e13aa$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $ef7268519b0e13aa$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $5JQUv = parcelRequire("5JQUv");
var $ef7268519b0e13aa$var$Token = function Token() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, Token);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "aminoPrefix", $5JQUv.AminoPrefix.BnbchainToken);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "name", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "original_symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "total_supply", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "owner", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "mintable", void 0);
    this.name = opts.name || "";
    this.symbol = opts.symbol || "";
    this.original_symbol = opts.original_symbol || "";
    this.total_supply = opts.total_supply || 0;
    this.owner = opts.owner || $ef7268519b0e13aa$require$Buffer.alloc(0);
    this.mintable = opts.mintable || false;
};
module.exports.Token = $ef7268519b0e13aa$var$Token;
var $ef7268519b0e13aa$var$TokenOfList = function TokenOfList() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, TokenOfList);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "name", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "original_symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "total_supply", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "owner", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "mintable", void 0);
    this.name = opts.name || "";
    this.symbol = opts.symbol || "";
    this.original_symbol = opts.original_symbol || "";
    this.total_supply = opts.total_supply || 0;
    this.owner = opts.owner || $ef7268519b0e13aa$require$Buffer.alloc(0);
    this.mintable = opts.mintable || false;
};
module.exports.TokenOfList = $ef7268519b0e13aa$var$TokenOfList;
var $ef7268519b0e13aa$var$BaseAccount = function BaseAccount() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, BaseAccount);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "address", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "coins", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "public_key", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "account_number", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "sequence", void 0);
    this.address = opts.address || $ef7268519b0e13aa$require$Buffer.alloc(0);
    this.coins = opts.coins || [
        {
            denom: "",
            amount: 0
        }
    ];
    this.public_key = opts.public_key || $ef7268519b0e13aa$require$Buffer.alloc(0);
    this.account_number = opts.account_number || 0;
    this.sequence = opts.sequence || 0;
};
module.exports.BaseAccount = $ef7268519b0e13aa$var$BaseAccount;
var $ef7268519b0e13aa$var$AppAccount = function AppAccount() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, AppAccount);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "aminoPrefix", $5JQUv.AminoPrefix.BnbchainAccount);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "base", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "name", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "locked", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "frozen", void 0);
    this.base = opts.base || new $ef7268519b0e13aa$var$BaseAccount();
    this.name = opts.name || "";
    this.locked = opts.locked || [
        {
            denom: "",
            amount: 0
        }
    ];
    this.frozen = opts.frozen || [
        {
            denom: "",
            amount: 0
        }
    ];
};
module.exports.AppAccount = $ef7268519b0e13aa$var$AppAccount;
var $ef7268519b0e13aa$var$TokenBalance = function TokenBalance() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, TokenBalance);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "free", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "locked", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "frozen", void 0);
    this.symbol = opts.symbol || "";
    this.free = opts.free || 0;
    this.locked = opts.locked || 0;
    this.frozen = opts.frozen || 0;
};
module.exports.TokenBalance = $ef7268519b0e13aa$var$TokenBalance;
var $ef7268519b0e13aa$var$OpenOrder = function OpenOrder() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, OpenOrder);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "id", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "price", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "quantity", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "cumQty", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "createdHeight", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "createdTimestamp", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "lastUpdatedHeight", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "lastUpdatedTimestamp", void 0);
    this.id = opts.id || "";
    this.symbol = opts.symbol || "";
    this.price = opts.price || 0;
    this.quantity = opts.quantity || 0;
    this.cumQty = opts.cumQty || 0;
    this.createdHeight = opts.createdHeight || 0;
    this.createdTimestamp = opts.createdTimestamp || 0;
    this.lastUpdatedHeight = opts.lastUpdatedHeight || 0;
    this.lastUpdatedTimestamp = opts.lastUpdatedTimestamp || 0;
};
module.exports.OpenOrder = $ef7268519b0e13aa$var$OpenOrder;
var $ef7268519b0e13aa$var$TradingPair = function TradingPair() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, TradingPair);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "base_asset_symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "quote_asset_symbol", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "list_price", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "tick_size", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "lot_size", void 0);
    this.base_asset_symbol = opts.base_asset_symbol || "";
    this.quote_asset_symbol = opts.quote_asset_symbol || "";
    this.list_price = opts.list_price || 0;
    this.tick_size = opts.tick_size || 0;
    this.lot_size = opts.lot_size || 0;
};
module.exports.TradingPair = $ef7268519b0e13aa$var$TradingPair;
var $ef7268519b0e13aa$var$OrderBookLevel = function OrderBookLevel() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, OrderBookLevel);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "buyQty", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "buyPrice", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "sellQty", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "sellPrice", void 0);
    this.buyQty = opts.buyQty || 0;
    this.buyPrice = opts.buyPrice || 0;
    this.sellQty = opts.sellQty || 0;
    this.sellPrice = opts.sellPrice || 0;
};
module.exports.OrderBookLevel = $ef7268519b0e13aa$var$OrderBookLevel;
var $ef7268519b0e13aa$var$OrderBook = function OrderBook() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, OrderBook);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "height", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "levels", void 0);
    this.height = opts.height || 0;
    this.levels = opts.levels || [
        new $ef7268519b0e13aa$var$OrderBookLevel()
    ];
};
module.exports.OrderBook = $ef7268519b0e13aa$var$OrderBook;
var $ef7268519b0e13aa$var$SubmitProposalMsg = function SubmitProposalMsg() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    (0, $ef7268519b0e13aa$var$_classCallCheck2["default"])(this, SubmitProposalMsg);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "aminoPrefix", $5JQUv.AminoPrefix.MsgSubmitProposal);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "title", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "description", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "proposal_type", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "proposer", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "initial_deposit", void 0);
    (0, $ef7268519b0e13aa$var$_defineProperty2["default"])(this, "voting_period", void 0);
    opts = opts || {};
    this.title = opts.title || "";
    this.description = opts.description || "";
    this.proposal_type = opts.proposal_type || 0;
    this.proposer = opts.proposer || $ef7268519b0e13aa$require$Buffer.alloc(0);
    this.initial_deposit = opts.initial_deposit || [];
    this.voting_period = opts.voting_period || 0;
};
module.exports.SubmitProposalMsg = $ef7268519b0e13aa$var$SubmitProposalMsg;

});



parcelRegister("hWh1h", function(module, exports) {
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.HttpRequest = void 0;

var $d0f50e32f8d3f7ec$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $d0f50e32f8d3f7ec$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $d0f50e32f8d3f7ec$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $d0f50e32f8d3f7ec$var$_axios = $2ZnTs((parcelRequire("gEDAL")));
function $d0f50e32f8d3f7ec$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d0f50e32f8d3f7ec$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d0f50e32f8d3f7ec$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $d0f50e32f8d3f7ec$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d0f50e32f8d3f7ec$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d0f50e32f8d3f7ec$var$HttpRequest = /*#__PURE__*/ function() {
    function HttpRequest(baseURL) {
        (0, $d0f50e32f8d3f7ec$var$_classCallCheck2["default"])(this, HttpRequest);
        (0, $d0f50e32f8d3f7ec$var$_defineProperty2["default"])(this, "httpClient", void 0);
        this.httpClient = $d0f50e32f8d3f7ec$var$_axios["default"].create({
            baseURL: baseURL
        });
    }
    (0, $d0f50e32f8d3f7ec$var$_createClass2["default"])(HttpRequest, [
        {
            key: "get",
            value: function get(path, params, opts) {
                return this.request("get", path, params, opts);
            }
        },
        {
            key: "post",
            value: function post(path, body, opts) {
                return this.request("post", path, body, opts);
            }
        },
        {
            key: "request",
            value: function request(method, path, params) {
                var opts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var options = $d0f50e32f8d3f7ec$var$_objectSpread({
                    method: method,
                    url: path
                }, opts);
                if (params) {
                    if (method === "get") options.params = params;
                    else options.data = params;
                }
                return this.httpClient.request(options).then(function(response) {
                    return {
                        result: response.data,
                        status: response.status
                    };
                })["catch"](function(err) {
                    var error = err;
                    try {
                        var msgObj = err.response && err.response.data;
                        error = new Error(msgObj.message);
                        error.code = msgObj.code;
                    } catch (err) {
                        throw error;
                    }
                    throw error;
                });
            }
        }
    ]);
    return HttpRequest;
}();
module.exports.HttpRequest = $d0f50e32f8d3f7ec$var$HttpRequest;
var $d0f50e32f8d3f7ec$var$_default = $d0f50e32f8d3f7ec$var$HttpRequest;
module.exports["default"] = $d0f50e32f8d3f7ec$var$_default;

});
parcelRegister("gEDAL", function(module, exports) {

module.exports = (parcelRequire("jZFZP"));

});
parcelRegister("jZFZP", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");

var $ebhd0 = parcelRequire("ebhd0");

var $aXnHO = parcelRequire("aXnHO");

var $g9ZA6 = parcelRequire("g9ZA6");

var $47zwB = parcelRequire("47zwB");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $e8e44a662da0a071$var$createInstance(defaultConfig) {
    var context = new $aXnHO(defaultConfig);
    var instance = $ebhd0($aXnHO.prototype.request, context);
    // Copy axios.prototype to instance
    $freuI.extend(instance, $aXnHO.prototype, context);
    // Copy context to instance
    $freuI.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $e8e44a662da0a071$var$axios = $e8e44a662da0a071$var$createInstance($47zwB);
// Expose Axios class to allow class inheritance
$e8e44a662da0a071$var$axios.Axios = $aXnHO;
// Factory for creating new instances
$e8e44a662da0a071$var$axios.create = function create(instanceConfig) {
    return $e8e44a662da0a071$var$createInstance($g9ZA6($e8e44a662da0a071$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$e8e44a662da0a071$var$axios.Cancel = (parcelRequire("1dRzx"));

$e8e44a662da0a071$var$axios.CancelToken = (parcelRequire("gu3b9"));

$e8e44a662da0a071$var$axios.isCancel = (parcelRequire("fCxQ9"));
// Expose all/spread
$e8e44a662da0a071$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$e8e44a662da0a071$var$axios.spread = (parcelRequire("fNjuo"));
module.exports = $e8e44a662da0a071$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $e8e44a662da0a071$var$axios;

});
parcelRegister("freuI", function(module, exports) {
"use strict";

var $ebhd0 = parcelRequire("ebhd0");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $b3d49eeec354dc86$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $b3d49eeec354dc86$var$isArray(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $b3d49eeec354dc86$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $b3d49eeec354dc86$var$isBuffer(val) {
    return val !== null && !$b3d49eeec354dc86$var$isUndefined(val) && val.constructor !== null && !$b3d49eeec354dc86$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $b3d49eeec354dc86$var$isArrayBuffer(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $b3d49eeec354dc86$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $b3d49eeec354dc86$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $b3d49eeec354dc86$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $b3d49eeec354dc86$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $b3d49eeec354dc86$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $b3d49eeec354dc86$var$isDate(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $b3d49eeec354dc86$var$isFile(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $b3d49eeec354dc86$var$isBlob(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $b3d49eeec354dc86$var$isFunction(val) {
    return $b3d49eeec354dc86$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $b3d49eeec354dc86$var$isStream(val) {
    return $b3d49eeec354dc86$var$isObject(val) && $b3d49eeec354dc86$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $b3d49eeec354dc86$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $b3d49eeec354dc86$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $b3d49eeec354dc86$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $b3d49eeec354dc86$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($b3d49eeec354dc86$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $b3d49eeec354dc86$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $b3d49eeec354dc86$var$merge(result[key], val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$b3d49eeec354dc86$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $b3d49eeec354dc86$var$deepMerge() {
    var result = {};
    function assignValue(val, key) {
        if (typeof result[key] === "object" && typeof val === "object") result[key] = $b3d49eeec354dc86$var$deepMerge(result[key], val);
        else if (typeof val === "object") result[key] = $b3d49eeec354dc86$var$deepMerge({}, val);
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$b3d49eeec354dc86$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $b3d49eeec354dc86$var$extend(a, b, thisArg) {
    $b3d49eeec354dc86$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $ebhd0(val, thisArg);
        else a[key] = val;
    });
    return a;
}
module.exports = {
    isArray: $b3d49eeec354dc86$var$isArray,
    isArrayBuffer: $b3d49eeec354dc86$var$isArrayBuffer,
    isBuffer: $b3d49eeec354dc86$var$isBuffer,
    isFormData: $b3d49eeec354dc86$var$isFormData,
    isArrayBufferView: $b3d49eeec354dc86$var$isArrayBufferView,
    isString: $b3d49eeec354dc86$var$isString,
    isNumber: $b3d49eeec354dc86$var$isNumber,
    isObject: $b3d49eeec354dc86$var$isObject,
    isUndefined: $b3d49eeec354dc86$var$isUndefined,
    isDate: $b3d49eeec354dc86$var$isDate,
    isFile: $b3d49eeec354dc86$var$isFile,
    isBlob: $b3d49eeec354dc86$var$isBlob,
    isFunction: $b3d49eeec354dc86$var$isFunction,
    isStream: $b3d49eeec354dc86$var$isStream,
    isURLSearchParams: $b3d49eeec354dc86$var$isURLSearchParams,
    isStandardBrowserEnv: $b3d49eeec354dc86$var$isStandardBrowserEnv,
    forEach: $b3d49eeec354dc86$var$forEach,
    merge: $b3d49eeec354dc86$var$merge,
    deepMerge: $b3d49eeec354dc86$var$deepMerge,
    extend: $b3d49eeec354dc86$var$extend,
    trim: $b3d49eeec354dc86$var$trim
};

});
parcelRegister("ebhd0", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("aXnHO", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");

var $57o2v = parcelRequire("57o2v");

var $gnIFk = parcelRequire("gnIFk");

var $hfUWP = parcelRequire("hfUWP");

var $g9ZA6 = parcelRequire("g9ZA6");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $7fa1cd7f1ab10edb$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $gnIFk(),
        response: new $gnIFk()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $7fa1cd7f1ab10edb$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $g9ZA6(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $hfUWP,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$7fa1cd7f1ab10edb$var$Axios.prototype.getUri = function getUri(config) {
    config = $g9ZA6(this.defaults, config);
    return $57o2v(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$freuI.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $7fa1cd7f1ab10edb$var$Axios.prototype[method] = function(url, config) {
        return this.request($freuI.merge(config || {}, {
            method: method,
            url: url
        }));
    };
});
$freuI.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $7fa1cd7f1ab10edb$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($freuI.merge(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $7fa1cd7f1ab10edb$var$Axios;

});
parcelRegister("57o2v", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
function $3ba040eb29d6dea1$var$encode(val) {
    return encodeURIComponent(val).replace(/%40/gi, "@").replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($freuI.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $freuI.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($freuI.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $freuI.forEach(val, function parseValue(v) {
                if ($freuI.isDate(v)) v = v.toISOString();
                else if ($freuI.isObject(v)) v = JSON.stringify(v);
                parts.push($3ba040eb29d6dea1$var$encode(key) + "=" + $3ba040eb29d6dea1$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("gnIFk", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
function $bed170f741b744ef$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $bed170f741b744ef$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $bed170f741b744ef$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $bed170f741b744ef$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $freuI.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $bed170f741b744ef$var$InterceptorManager;

});

parcelRegister("hfUWP", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");

var $9iUIz = parcelRequire("9iUIz");

var $fCxQ9 = parcelRequire("fCxQ9");

var $47zwB = parcelRequire("47zwB");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $c900030ef634acdb$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $c900030ef634acdb$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $9iUIz(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $freuI.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $freuI.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $47zwB.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $c900030ef634acdb$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $9iUIz(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$fCxQ9(reason)) {
            $c900030ef634acdb$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $9iUIz(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("9iUIz", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $freuI.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("fCxQ9", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("47zwB", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $freuI = parcelRequire("freuI");

var $Fk4sE = parcelRequire("Fk4sE");
var $30035f5eb8c9c7f8$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $30035f5eb8c9c7f8$var$setContentTypeIfUnset(headers, value) {
    if (!$freuI.isUndefined(headers) && $freuI.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $30035f5eb8c9c7f8$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("8wGO0"));
    else if (typeof $4TNnu !== "undefined" && Object.prototype.toString.call($4TNnu) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("8wGO0"));
    return adapter;
}
var $30035f5eb8c9c7f8$var$defaults = {
    adapter: $30035f5eb8c9c7f8$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $Fk4sE(headers, "Accept");
            $Fk4sE(headers, "Content-Type");
            if ($freuI.isFormData(data) || $freuI.isArrayBuffer(data) || $freuI.isBuffer(data) || $freuI.isStream(data) || $freuI.isFile(data) || $freuI.isBlob(data)) return data;
            if ($freuI.isArrayBufferView(data)) return data.buffer;
            if ($freuI.isURLSearchParams(data)) {
                $30035f5eb8c9c7f8$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($freuI.isObject(data)) {
                $30035f5eb8c9c7f8$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$30035f5eb8c9c7f8$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$freuI.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $30035f5eb8c9c7f8$var$defaults.headers[method] = {};
});
$freuI.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $30035f5eb8c9c7f8$var$defaults.headers[method] = $freuI.merge($30035f5eb8c9c7f8$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $30035f5eb8c9c7f8$var$defaults;

});
parcelRegister("Fk4sE", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $freuI.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8wGO0", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");

var $gkaVH = parcelRequire("gkaVH");

var $57o2v = parcelRequire("57o2v");

var $2mCEq = parcelRequire("2mCEq");

var $9pR3A = parcelRequire("9pR3A");

var $4jWpj = parcelRequire("4jWpj");

var $iRLzk = parcelRequire("iRLzk");

module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($freuI.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password || "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $2mCEq(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $57o2v(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $9pR3A(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $gkaVH(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($iRLzk("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($iRLzk("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($iRLzk(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($freuI.isStandardBrowserEnv()) {
            var cookies = (parcelRequire("8Ada6"));
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $4jWpj(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $freuI.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$freuI.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (requestData === undefined) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("gkaVH", function(module, exports) {
"use strict";

var $iRLzk = parcelRequire("iRLzk");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!validateStatus || validateStatus(response.status)) resolve(response);
    else reject($iRLzk("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("iRLzk", function(module, exports) {
"use strict";

var $awSEd = parcelRequire("awSEd");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $awSEd(error, config, code, request, response);
};

});
parcelRegister("awSEd", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("2mCEq", function(module, exports) {
"use strict";

var $8FNeY = parcelRequire("8FNeY");

var $8U8nl = parcelRequire("8U8nl");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$8FNeY(requestedURL)) return $8U8nl(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("8FNeY", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("8U8nl", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("9pR3A", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $6daf9ad9d2b634ce$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $freuI.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $freuI.trim(line.substr(0, i)).toLowerCase();
        val = $freuI.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $6daf9ad9d2b634ce$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("4jWpj", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
module.exports = $freuI.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $freuI.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("8Ada6", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
module.exports = $freuI.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($freuI.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($freuI.isString(path)) cookie.push("path=" + path);
            if ($freuI.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});




parcelRegister("g9ZA6", function(module, exports) {
"use strict";

var $freuI = parcelRequire("freuI");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "params",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "url",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "maxContentLength",
        "validateStatus",
        "maxRedirects",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath"
    ];
    $freuI.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
    });
    $freuI.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
        if ($freuI.isObject(config2[prop])) config[prop] = $freuI.deepMerge(config1[prop], config2[prop]);
        else if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if ($freuI.isObject(config1[prop])) config[prop] = $freuI.deepMerge(config1[prop]);
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    $freuI.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys);
    var otherKeys = Object.keys(config2).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $freuI.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
        if (typeof config2[prop] !== "undefined") config[prop] = config2[prop];
        else if (typeof config1[prop] !== "undefined") config[prop] = config1[prop];
    });
    return config;
};

});


parcelRegister("1dRzx", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $0e408fabe8515077$var$Cancel(message) {
    this.message = message;
}
$0e408fabe8515077$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$0e408fabe8515077$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $0e408fabe8515077$var$Cancel;

});

parcelRegister("gu3b9", function(module, exports) {
"use strict";

var $1dRzx = parcelRequire("1dRzx");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $c001e9ef3cc1fbf2$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $1dRzx(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $c001e9ef3cc1fbf2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $c001e9ef3cc1fbf2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $c001e9ef3cc1fbf2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $c001e9ef3cc1fbf2$var$CancelToken;

});

parcelRegister("fNjuo", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});






parcelRegister("cM7UC", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $94d01af2e53dc8fc$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $94d01af2e53dc8fc$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $94d01af2e53dc8fc$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $94d01af2e53dc8fc$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $22ocj = parcelRequire("22ocj");

var $94d01af2e53dc8fc$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");
/**
 * Creates a new transaction object.
 * @example
 * var rawTx = {
 *   accountNumber: 1,
 *   chainId: 'bnbchain-1000',
 *   memo: '',
 *   msg: {},
 *   type: 'NewOrderMsg',
 *   sequence: 29,
 *   source: 0
 * };
 * var tx = new Transaction(rawTx);
 * @property {Buffer} raw The raw vstruct encoded transaction
 * @param {Number} data.account_number account number
 * @param {String} data.chain_id bnbChain Id
 * @param {String} data.memo transaction memo
 * @param {String} type transaction type
 * @param {Msg} data.msg object data of tx type
 * @param {Number} data.sequence transaction counts
 * @param {Number} data.source where does this transaction come from
 */ var $94d01af2e53dc8fc$var$Transaction = /*#__PURE__*/ function() {
    // DEPRECATED: Retained for backward compatibility,
    function Transaction(data) {
        (0, $94d01af2e53dc8fc$var$_classCallCheck2["default"])(this, Transaction);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "sequence", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "accountNumber", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "chainId", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "msg", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "baseMsg", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "memo", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "source", void 0);
        (0, $94d01af2e53dc8fc$var$_defineProperty2["default"])(this, "signatures", void 0);
        data = data || {};
        if (!data.chainId) throw new Error("chain id should not be null");
        this.sequence = data.sequence || 0;
        this.accountNumber = data.accountNumber || 0;
        this.chainId = data.chainId;
        this.msg = data.msg;
        this.baseMsg = data.baseMsg;
        this.memo = data.memo;
        this.source = data.source || 0; // default value is 0
        this.signatures = [];
    }
    /**
   * generate the sign bytes for a transaction, given a msg
   * @param {SignMsg} concrete msg object
   * @return {Buffer}
   **/ (0, $94d01af2e53dc8fc$var$_createClass2["default"])(Transaction, [
        {
            key: "getSignBytes",
            value: function getSignBytes(msg) {
                msg = msg || this.baseMsg && this.baseMsg.getSignMsg();
                var signMsg = {
                    account_number: this.accountNumber.toString(),
                    chain_id: this.chainId,
                    data: null,
                    memo: this.memo,
                    msgs: [
                        msg
                    ],
                    sequence: this.sequence.toString(),
                    source: this.source.toString()
                };
                return (0, $22ocj.convertObjectToSignBytes)(signMsg);
            }
        },
        {
            key: "addSignature",
            value: function addSignature(pubKey, signature) {
                var pubKeyBuf = this._serializePubKey(pubKey); // => Buffer
                this.signatures = [
                    {
                        pub_key: pubKeyBuf,
                        signature: signature,
                        account_number: this.accountNumber,
                        sequence: this.sequence
                    }
                ];
                return this;
            }
        },
        {
            key: "sign",
            value: function sign(privateKey, msg) {
                if (!privateKey) throw new Error("private key should not be null");
                var signBytes = this.getSignBytes(msg);
                var privKeyBuf = $94d01af2e53dc8fc$require$Buffer.from(privateKey, "hex");
                var signature = $94d01af2e53dc8fc$var$crypto.generateSignature(signBytes.toString("hex"), privKeyBuf);
                this.addSignature($94d01af2e53dc8fc$var$crypto.generatePubKey(privKeyBuf), signature);
                return this;
            }
        },
        {
            key: "serialize",
            value: function serialize() {
                if (!this.signatures) throw new Error("need signature");
                var msg = this.msg || this.baseMsg && this.baseMsg.getMsg();
                var stdTx = {
                    msg: [
                        msg
                    ],
                    signatures: this.signatures,
                    memo: this.memo,
                    source: this.source,
                    // sdk value is 0, web wallet value is 1
                    data: "",
                    aminoPrefix: $eULcN.AminoPrefix.StdTx
                };
                var bytes = (0, $22ocj.marshalBinary)(stdTx);
                return bytes.toString("hex");
            }
        },
        {
            key: "_serializePubKey",
            value: function _serializePubKey(unencodedPubKey) {
                var format = 0x2;
                var y = unencodedPubKey.getY();
                var x = unencodedPubKey.getX();
                if (y && y.isOdd()) format |= 0x1;
                var pubBz = $94d01af2e53dc8fc$require$Buffer.concat([
                    $22ocj.UVarInt.encode(format),
                    x.toArrayLike($94d01af2e53dc8fc$require$Buffer, "be", 32)
                ]); // prefixed with length
                pubBz = (0, $22ocj.encodeBinaryByteArray)(pubBz); // add the amino prefix
                pubBz = $94d01af2e53dc8fc$require$Buffer.concat([
                    $94d01af2e53dc8fc$require$Buffer.from("EB5AE987", "hex"),
                    pubBz
                ]);
                return pubBz;
            }
        }
    ]);
    return Transaction;
}();
module.exports["default"] = $94d01af2e53dc8fc$var$Transaction;

});

parcelRegister("4qD4R", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.voteOption = void 0;

var $3397e711ad776b40$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $3397e711ad776b40$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $3397e711ad776b40$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $3397e711ad776b40$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $3397e711ad776b40$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $3397e711ad776b40$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $3397e711ad776b40$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");

var $ddfDI = parcelRequire("ddfDI");

var $3397e711ad776b40$var$_proposalType = $2ZnTs((parcelRequire("i8rhP")));
// This is a circular dependecy; should be changed to `import type` asap
var $3397e711ad776b40$var$BASENUMBER = Math.pow(10, 8);
var $3397e711ad776b40$var$proposalTypeMapping = {
    0x04: "ListTradingPair",
    0x00: "Nil",
    0x01: "Text",
    0x02: "ParameterChange",
    0x03: "SoftwareUpgrade",
    0x05: "FeeChange",
    0x06: "CreateValidator",
    0x07: "RemoveValidator"
};
/**
 * VoteOption
 * @ignore
 * @example
 * OptionEmpty - 0x00
 * OptionYes - 0x01
 * OptionAbstain - 0x02
 * OptionNo - 0x03
 * OptionNoWithVeto - 0x04
 */ var $3397e711ad776b40$var$voteOption = {
    OptionEmpty: 0x00,
    OptionYes: 0x01,
    OptionAbstain: 0x02,
    OptionNo: 0x03,
    OptionNoWithVeto: 0x04
};
module.exports.voteOption = $3397e711ad776b40$var$voteOption;
var $3397e711ad776b40$var$voteOptionMapping = {
    0x00: "Empty",
    0x01: "Yes",
    0x02: "Abstain",
    0x03: "No",
    0x04: "NoWithVeto"
};
var $3397e711ad776b40$var$Gov = /*#__PURE__*/ function() {
    /**
   * @param {Object} bncClient
   */ function Gov(bncClient) {
        (0, $3397e711ad776b40$var$_classCallCheck2["default"])(this, Gov);
        (0, $3397e711ad776b40$var$_defineProperty2["default"])(this, "_bncClient", void 0);
        if (!Gov.instance) {
            this._bncClient = bncClient;
            Gov.instance = this;
        }
        return Gov.instance;
    }
    /**
   * Submit a list proposal along with an initial deposit
   * @param {Object} listParams
   * @example
   * var listParams = {
   *  title: 'New trading pair',
   *  description: '',
   *  baseAsset: 'BTC',
   *  quoteAsset: 'BNB',
   *  initPrice: 1,
   *  address: '',
   *  initialDeposit: 2000,
   *  expireTime: 1570665600,
   *  votingPeriod: 604800
   * }
   */ (0, $3397e711ad776b40$var$_createClass2["default"])(Gov, [
        {
            key: "submitListProposal",
            value: function() {
                var _submitListProposal = (0, $3397e711ad776b40$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $3397e711ad776b40$var$_regenerator["default"].mark(function _callee(listParams) {
                    var listTradingPairObj, description, address, title, initialDeposit, votingPeriod;
                    return $3397e711ad776b40$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                listTradingPairObj = {
                                    base_asset_symbol: listParams.baseAsset,
                                    quote_asset_symbol: listParams.quoteAsset,
                                    init_price: +new $3397e711ad776b40$var$_big["default"](listParams.initPrice).mul($3397e711ad776b40$var$BASENUMBER).toString(),
                                    description: listParams.description,
                                    expire_time: new Date(listParams.expireTime).toISOString()
                                };
                                description = JSON.stringify(listTradingPairObj);
                                address = listParams.address, title = listParams.title, initialDeposit = listParams.initialDeposit, votingPeriod = listParams.votingPeriod;
                                _context.next = 5;
                                return this.submitProposal(address, title, description, $3397e711ad776b40$var$_proposalType["default"].ProposalTypeListTradingPair, initialDeposit, votingPeriod);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function submitListProposal(_x) {
                    return _submitListProposal.apply(this, arguments);
                }
                return submitListProposal;
            }()
        },
        {
            key: "submitProposal",
            value: function() {
                var _submitProposal = (0, $3397e711ad776b40$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $3397e711ad776b40$var$_regenerator["default"].mark(function _callee2(address, title, description, proposalType, initialDeposit, votingPeriod) {
                    var accAddress, coins, proposalMsg, signMsg, signedTx;
                    return $3397e711ad776b40$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                accAddress = $3397e711ad776b40$var$crypto.decodeAddress(address);
                                coins = [
                                    {
                                        denom: "BNB",
                                        amount: new $3397e711ad776b40$var$_big["default"](initialDeposit).mul($3397e711ad776b40$var$BASENUMBER).toString()
                                    }
                                ];
                                votingPeriod = +new $3397e711ad776b40$var$_big["default"](votingPeriod).mul(Math.pow(10, 9)).toString();
                                proposalMsg = {
                                    title: title,
                                    description: description,
                                    proposal_type: proposalType,
                                    proposer: accAddress,
                                    initial_deposit: [
                                        {
                                            denom: "BNB",
                                            amount: +new $3397e711ad776b40$var$_big["default"](initialDeposit).mul($3397e711ad776b40$var$BASENUMBER).toString()
                                        }
                                    ],
                                    voting_period: votingPeriod,
                                    aminoPrefix: $eULcN.AminoPrefix.MsgSubmitProposal
                                };
                                signMsg = {
                                    description: description,
                                    initial_deposit: coins,
                                    proposal_type: $3397e711ad776b40$var$proposalTypeMapping[proposalType],
                                    proposer: address,
                                    title: title,
                                    voting_period: votingPeriod.toString()
                                };
                                _context2.next = 7;
                                return this._bncClient._prepareTransaction(proposalMsg, signMsg, address);
                            case 7:
                                signedTx = _context2.sent;
                                return _context2.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function submitProposal(_x2, _x3, _x4, _x5, _x6, _x7) {
                    return _submitProposal.apply(this, arguments);
                }
                return submitProposal;
            }()
        },
        {
            key: "deposit",
            value: function() {
                var _deposit = (0, $3397e711ad776b40$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $3397e711ad776b40$var$_regenerator["default"].mark(function _callee3(proposalId, address, coins) {
                    var accAddress, amount, depositMsg, signMsg, signedTx;
                    return $3397e711ad776b40$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                accAddress = $3397e711ad776b40$var$crypto.decodeAddress(address);
                                (0, $ddfDI.checkCoins)(coins);
                                amount = [];
                                coins.forEach(function(coin) {
                                    amount.push({
                                        denom: coin.denom,
                                        amount: +new $3397e711ad776b40$var$_big["default"](coin.amount).mul($3397e711ad776b40$var$BASENUMBER).toString()
                                    });
                                });
                                depositMsg = {
                                    proposal_id: proposalId,
                                    depositer: accAddress,
                                    amount: amount,
                                    aminoPrefix: $eULcN.AminoPrefix.MsgDeposit
                                };
                                signMsg = {
                                    amount: amount.map(function(coin) {
                                        return {
                                            denom: coin.denom,
                                            amount: String(coin.amount)
                                        };
                                    }),
                                    depositer: address,
                                    proposal_id: String(proposalId)
                                };
                                _context3.next = 8;
                                return this._bncClient._prepareTransaction(depositMsg, signMsg, address);
                            case 8:
                                signedTx = _context3.sent;
                                return _context3.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function deposit(_x8, _x9, _x10) {
                    return _deposit.apply(this, arguments);
                }
                return deposit;
            }()
        },
        {
            key: "vote",
            value: function() {
                var _vote = (0, $3397e711ad776b40$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $3397e711ad776b40$var$_regenerator["default"].mark(function _callee4(proposalId, voter, option) {
                    var accAddress, voteMsg, signMsg, signedTx;
                    return $3397e711ad776b40$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                accAddress = $3397e711ad776b40$var$crypto.decodeAddress(voter);
                                voteMsg = {
                                    proposal_id: proposalId,
                                    voter: accAddress,
                                    option: option,
                                    aminoPrefix: $eULcN.AminoPrefix.MsgVote
                                };
                                signMsg = {
                                    option: $3397e711ad776b40$var$voteOptionMapping[option],
                                    proposal_id: String(proposalId),
                                    voter: voter
                                };
                                _context4.next = 5;
                                return this._bncClient._prepareTransaction(voteMsg, signMsg, voter);
                            case 5:
                                signedTx = _context4.sent;
                                return _context4.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function vote(_x11, _x12, _x13) {
                    return _vote.apply(this, arguments);
                }
                return vote;
            }()
        }
    ]);
    return Gov;
}();
(0, $3397e711ad776b40$var$_defineProperty2["default"])($3397e711ad776b40$var$Gov, "instance", void 0);
var $3397e711ad776b40$var$_default = $3397e711ad776b40$var$Gov;
module.exports["default"] = $3397e711ad776b40$var$_default;

});
parcelRegister("i8rhP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
var $d33e23e110dfdf0c$var$ProposalTypeNil = 0x00;
var $d33e23e110dfdf0c$var$ProposalTypeText = 0x01;
var $d33e23e110dfdf0c$var$ProposalTypeParameterChange = 0x02;
var $d33e23e110dfdf0c$var$ProposalTypeSoftwareUpgrade = 0x03;
var $d33e23e110dfdf0c$var$ProposalTypeListTradingPair = 0x04;
var $d33e23e110dfdf0c$var$ProposalTypeFeeChange = 0x05;
var $d33e23e110dfdf0c$var$ProposalTypeCreateValidator = 0x06;
var $d33e23e110dfdf0c$var$ProposalTypeRemoveValidator = 0x07;
var $d33e23e110dfdf0c$var$_default = {
    ProposalTypeNil: $d33e23e110dfdf0c$var$ProposalTypeNil,
    ProposalTypeText: $d33e23e110dfdf0c$var$ProposalTypeText,
    ProposalTypeParameterChange: $d33e23e110dfdf0c$var$ProposalTypeParameterChange,
    ProposalTypeSoftwareUpgrade: $d33e23e110dfdf0c$var$ProposalTypeSoftwareUpgrade,
    ProposalTypeListTradingPair: $d33e23e110dfdf0c$var$ProposalTypeListTradingPair,
    ProposalTypeFeeChange: $d33e23e110dfdf0c$var$ProposalTypeFeeChange,
    ProposalTypeCreateValidator: $d33e23e110dfdf0c$var$ProposalTypeCreateValidator,
    ProposalTypeRemoveValidator: $d33e23e110dfdf0c$var$ProposalTypeRemoveValidator
};
module.exports["default"] = $d33e23e110dfdf0c$var$_default;

});


parcelRegister("fwcxq", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $b4c391f52bb9c558$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $b4c391f52bb9c558$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $b4c391f52bb9c558$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $b4c391f52bb9c558$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $b4c391f52bb9c558$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $ihoyg = parcelRequire("ihoyg");

var $b4c391f52bb9c558$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");

var $ddfDI = parcelRequire("ddfDI");
/**
 * @module Swap
 */ var $b4c391f52bb9c558$var$Swap = /*#__PURE__*/ function() {
    /**
   * @param {Object} bncClient
   */ function Swap(bncClient) {
        (0, $b4c391f52bb9c558$var$_classCallCheck2["default"])(this, Swap);
        (0, $b4c391f52bb9c558$var$_defineProperty2["default"])(this, "_bncClient", void 0);
        if (!Swap.instance) {
            this._bncClient = bncClient;
            Swap.instance = this;
        }
        return Swap.instance;
    }
    /**
   * HTLT(Hash timer locked transfer, create an atomic swap)
   * @param {String} from
   * @param {String} recipient
   * @param {String} recipientOtherChain
   * @param {String} senderOtherChain
   * @param {String} randomNumberHash
   * @param {Number} timestamp
   * @param {Array} amount
   * @param {String} expectedIncome
   * @param {Number} heightSpan
   * @param {boolean} crossChain
   * @returns {Promise}  resolves with response (success or fail)
   */ (0, $b4c391f52bb9c558$var$_createClass2["default"])(Swap, [
        {
            key: "HTLT",
            value: function() {
                var _HTLT = (0, $b4c391f52bb9c558$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b4c391f52bb9c558$var$_regenerator["default"].mark(function _callee(from, recipient, recipientOtherChain, senderOtherChain, randomNumberHash, timestamp, amount, expectedIncome, heightSpan, crossChain) {
                    var htltMsg, signHTLTMsg, signedTx;
                    return $b4c391f52bb9c558$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                (0, $ddfDI.checkCoins)(amount);
                                htltMsg = {
                                    from: $b4c391f52bb9c558$var$crypto.decodeAddress(from),
                                    to: $b4c391f52bb9c558$var$crypto.decodeAddress(recipient),
                                    recipient_other_chain: recipientOtherChain,
                                    sender_other_chain: senderOtherChain,
                                    random_number_hash: $ihoyg.Buffer.from(randomNumberHash, "hex"),
                                    timestamp: timestamp,
                                    amount: amount,
                                    expected_income: expectedIncome,
                                    height_span: heightSpan,
                                    cross_chain: crossChain,
                                    aminoPrefix: $eULcN.AminoPrefix.HTLTMsg
                                };
                                signHTLTMsg = {
                                    from: from,
                                    to: recipient,
                                    recipient_other_chain: recipientOtherChain,
                                    sender_other_chain: senderOtherChain,
                                    random_number_hash: randomNumberHash,
                                    timestamp: timestamp,
                                    amount: amount,
                                    expected_income: expectedIncome,
                                    height_span: heightSpan,
                                    cross_chain: crossChain
                                };
                                _context.next = 5;
                                return this._bncClient._prepareTransaction(htltMsg, signHTLTMsg, from);
                            case 5:
                                signedTx = _context.sent;
                                return _context.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 7:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function HTLT(_x, _x2, _x3, _x4, _x5, _x6, _x7, _x8, _x9, _x10) {
                    return _HTLT.apply(this, arguments);
                }
                return HTLT;
            }()
        },
        {
            key: "depositHTLT",
            value: function() {
                var _depositHTLT = (0, $b4c391f52bb9c558$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b4c391f52bb9c558$var$_regenerator["default"].mark(function _callee2(from, swapID, amount) {
                    var depositHTLTMsg, signDepositHTLTMsg, signedTx;
                    return $b4c391f52bb9c558$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                (0, $ddfDI.checkCoins)(amount);
                                depositHTLTMsg = {
                                    from: $b4c391f52bb9c558$var$crypto.decodeAddress(from),
                                    amount: amount,
                                    swap_id: $ihoyg.Buffer.from(swapID, "hex"),
                                    aminoPrefix: $eULcN.AminoPrefix.DepositHTLTMsg
                                };
                                signDepositHTLTMsg = {
                                    from: from,
                                    amount: amount,
                                    swap_id: swapID
                                };
                                _context2.next = 5;
                                return this._bncClient._prepareTransaction(depositHTLTMsg, signDepositHTLTMsg, from);
                            case 5:
                                signedTx = _context2.sent;
                                return _context2.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 7:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function depositHTLT(_x11, _x12, _x13) {
                    return _depositHTLT.apply(this, arguments);
                }
                return depositHTLT;
            }()
        },
        {
            key: "claimHTLT",
            value: function() {
                var _claimHTLT = (0, $b4c391f52bb9c558$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b4c391f52bb9c558$var$_regenerator["default"].mark(function _callee3(from, swapID, randomNumber) {
                    var claimHTLTMsg, signClaimHTLTMsg, signedTx;
                    return $b4c391f52bb9c558$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                claimHTLTMsg = {
                                    from: $b4c391f52bb9c558$var$crypto.decodeAddress(from),
                                    swap_id: $ihoyg.Buffer.from(swapID, "hex"),
                                    random_number: $ihoyg.Buffer.from(randomNumber, "hex"),
                                    aminoPrefix: $eULcN.AminoPrefix.ClaimHTLTMsg
                                };
                                signClaimHTLTMsg = {
                                    from: from,
                                    swap_id: swapID,
                                    random_number: randomNumber
                                };
                                _context3.next = 4;
                                return this._bncClient._prepareTransaction(claimHTLTMsg, signClaimHTLTMsg, from);
                            case 4:
                                signedTx = _context3.sent;
                                return _context3.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function claimHTLT(_x14, _x15, _x16) {
                    return _claimHTLT.apply(this, arguments);
                }
                return claimHTLT;
            }()
        },
        {
            key: "refundHTLT",
            value: function() {
                var _refundHTLT = (0, $b4c391f52bb9c558$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $b4c391f52bb9c558$var$_regenerator["default"].mark(function _callee4(from, swapID) {
                    var refundHTLTMsg, signRefundHTLTMsg, signedTx;
                    return $b4c391f52bb9c558$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                refundHTLTMsg = {
                                    from: $b4c391f52bb9c558$var$crypto.decodeAddress(from),
                                    swap_id: $ihoyg.Buffer.from(swapID, "hex"),
                                    aminoPrefix: $eULcN.AminoPrefix.RefundHTLTMsg
                                };
                                signRefundHTLTMsg = {
                                    from: from,
                                    swap_id: swapID
                                };
                                _context4.next = 4;
                                return this._bncClient._prepareTransaction(refundHTLTMsg, signRefundHTLTMsg, from);
                            case 4:
                                signedTx = _context4.sent;
                                return _context4.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 6:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function refundHTLT(_x17, _x18) {
                    return _refundHTLT.apply(this, arguments);
                }
                return refundHTLT;
            }()
        }
    ]);
    return Swap;
}();
(0, $b4c391f52bb9c558$var$_defineProperty2["default"])($b4c391f52bb9c558$var$Swap, "instance", void 0);
var $b4c391f52bb9c558$var$_default = $b4c391f52bb9c558$var$Swap;
module.exports["default"] = $b4c391f52bb9c558$var$_default;

});

parcelRegister("2lKhK", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.validateMiniTokenSymbol = void 0;

var $1b61723d5536714b$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $1b61723d5536714b$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $1b61723d5536714b$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $1b61723d5536714b$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $1b61723d5536714b$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $1b61723d5536714b$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $ia7G2 = parcelRequire("ia7G2");

var $1b61723d5536714b$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");

var $ddfDI = parcelRequire("ddfDI");
var $1b61723d5536714b$var$MAXTOTALSUPPLY = 9000000000000000000;
var $1b61723d5536714b$var$MINI_TOKEN_MAX_TOTAL_SUPPAY = 1000000;
var $1b61723d5536714b$var$TINY_TOKEN_MAX_TOTAL_SUPPAY = 10000;
var $1b61723d5536714b$var$validateNonZeroAmount = /*#__PURE__*/ function() {
    var _ref = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee(amountParam, symbol, fromAddress, httpClient) {
        var type, amount, _yield$httpClient$req, result, balance, _args = arguments;
        return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    type = _args.length > 4 && _args[4] !== undefined ? _args[4] : "free";
                    amount = new $1b61723d5536714b$var$_big["default"](amountParam);
                    if (!(amount.lte(0) || amount.gt($1b61723d5536714b$var$MAXTOTALSUPPLY))) {
                        _context.next = 4;
                        break;
                    }
                    throw new Error("invalid amount");
                case 4:
                    _context.prev = 4;
                    _context.next = 7;
                    return httpClient.request("get", "".concat($ia7G2.api.getAccount, "/").concat(fromAddress));
                case 7:
                    _yield$httpClient$req = _context.sent;
                    result = _yield$httpClient$req.result;
                    balance = result.balances.find(function(b) {
                        return b.symbol.toUpperCase() === symbol.toUpperCase();
                    });
                    if (balance) {
                        _context.next = 12;
                        break;
                    }
                    throw new Error("the account doesn't have ".concat(symbol));
                case 12:
                    if (!amount.gte(balance[type])) {
                        _context.next = 14;
                        break;
                    }
                    throw new Error("the account doesn't have enougth balance");
                case 14:
                    _context.next = 18;
                    break;
                case 16:
                    _context.prev = 16;
                    _context.t0 = _context["catch"](4);
                case 18:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                4,
                16
            ]
        ]);
    }));
    return function validateNonZeroAmount(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
    };
}();
var $1b61723d5536714b$var$validateMiniTokenSymbol = function validateMiniTokenSymbol(symbol) {
    if (!symbol) throw new Error("suffixed token symbol cannot be empty");
    var splitedSymbol = symbol.split("-");
    if (splitedSymbol.length != 2) throw new Error("suffixed mini-token symbol must contain a hyphen ('-')");
    if (!splitedSymbol[1]) throw new Error('suffixed mini-token symbol must contain just one hyphen (" - ")');
    if (!/^[a-zA-z\d]{3,8}$/.test(splitedSymbol[0])) throw new Error("symbol should be alphanumeric and length is limited to 3~8");
    if (!splitedSymbol[1].endsWith("M")) throw new Error("mini-token symbol suffix must end with M");
};
/**
 * issue or view tokens
 */ module.exports.validateMiniTokenSymbol = $1b61723d5536714b$var$validateMiniTokenSymbol;
var $1b61723d5536714b$var$TokenManagement = /*#__PURE__*/ function() {
    /**
   * @param {Object} bncClient
   */ function TokenManagement(bncClient) {
        (0, $1b61723d5536714b$var$_classCallCheck2["default"])(this, TokenManagement);
        (0, $1b61723d5536714b$var$_defineProperty2["default"])(this, "_bncClient", void 0);
        this._bncClient = bncClient;
    }
    /**
   * create a new asset on Binance Chain
   * @param {String} - senderAddress
   * @param {String} - tokenName
   * @param {String} - symbol
   * @param {Number} - totalSupply
   * @param {Boolean} - mintable
   * @returns {Promise} resolves with response (success or fail)
   */ (0, $1b61723d5536714b$var$_createClass2["default"])(TokenManagement, [
        {
            key: "issue",
            value: function() {
                var _issue = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee2(senderAddress, tokenName, symbol) {
                    var totalSupply, mintable, issueMsg, signIssueMsg, signedTx, _args2 = arguments;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                totalSupply = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : 0;
                                mintable = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
                                if (senderAddress) {
                                    _context2.next = 4;
                                    break;
                                }
                                throw new Error("sender address cannot be empty");
                            case 4:
                                if (!(tokenName.length > 32)) {
                                    _context2.next = 6;
                                    break;
                                }
                                throw new Error("token name is limited to 32 characters");
                            case 6:
                                if (/^[a-zA-z\d]{3,8}$/.test(symbol)) {
                                    _context2.next = 8;
                                    break;
                                }
                                throw new Error("symbol should be alphanumeric and length is limited to 3~8");
                            case 8:
                                if (!(totalSupply <= 0 || totalSupply > $1b61723d5536714b$var$MAXTOTALSUPPLY)) {
                                    _context2.next = 10;
                                    break;
                                }
                                throw new Error("invalid supply amount");
                            case 10:
                                totalSupply = Number(new $1b61723d5536714b$var$_big["default"](totalSupply).mul(Math.pow(10, 8)).toString());
                                issueMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(senderAddress),
                                    name: tokenName,
                                    symbol: symbol,
                                    total_supply: totalSupply,
                                    mintable: mintable,
                                    aminoPrefix: $eULcN.AminoPrefix.IssueMsg
                                };
                                signIssueMsg = {
                                    from: senderAddress,
                                    name: tokenName,
                                    symbol: symbol,
                                    total_supply: totalSupply,
                                    mintable: mintable
                                };
                                _context2.next = 15;
                                return this._bncClient._prepareTransaction(issueMsg, signIssueMsg, senderAddress);
                            case 15:
                                signedTx = _context2.sent;
                                return _context2.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 17:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function issue(_x5, _x6, _x7) {
                    return _issue.apply(this, arguments);
                }
                return issue;
            }()
        },
        {
            key: "issueMiniToken",
            value: function() {
                var _issueMiniToken = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee3(senderAddress, tokenName, symbol) {
                    var totalSupply, mintable, tokenUri, issueMiniMsg, signedTx, _args3 = arguments;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                totalSupply = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : 0;
                                mintable = _args3.length > 4 && _args3[4] !== undefined ? _args3[4] : false;
                                tokenUri = _args3.length > 5 ? _args3[5] : undefined;
                                if (senderAddress) {
                                    _context3.next = 5;
                                    break;
                                }
                                throw new Error("sender address cannot be empty");
                            case 5:
                                if (!(tokenName.length > 32)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new Error("token name is limited to 32 characters");
                            case 7:
                                if (/^[a-zA-z\d]{3,8}$/.test(symbol)) {
                                    _context3.next = 9;
                                    break;
                                }
                                throw new Error("symbol should be alphanumeric and length is limited to 3~8");
                            case 9:
                                if (!(totalSupply <= 0 || totalSupply > $1b61723d5536714b$var$MINI_TOKEN_MAX_TOTAL_SUPPAY)) {
                                    _context3.next = 11;
                                    break;
                                }
                                throw new Error("invalid supply amount");
                            case 11:
                                totalSupply = Number(new $1b61723d5536714b$var$_big["default"](totalSupply).mul(Math.pow(10, 8)).toString());
                                issueMiniMsg = new $eULcN.IssueMiniTokenMsg({
                                    name: tokenName,
                                    symbol: symbol,
                                    total_supply: totalSupply,
                                    mintable: mintable,
                                    token_uri: tokenUri,
                                    from: senderAddress
                                });
                                _context3.next = 15;
                                return this._bncClient._prepareTransaction(issueMiniMsg.getMsg(), issueMiniMsg.getSignMsg(), senderAddress);
                            case 15:
                                signedTx = _context3.sent;
                                return _context3.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 17:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function issueMiniToken(_x8, _x9, _x10) {
                    return _issueMiniToken.apply(this, arguments);
                }
                return issueMiniToken;
            }()
        },
        {
            key: "issueTinyToken",
            value: function() {
                var _issueTinyToken = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee4(senderAddress, tokenName, symbol) {
                    var totalSupply, mintable, tokenUri, issueMiniMsg, signedTx, _args4 = arguments;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                totalSupply = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 0;
                                mintable = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : false;
                                tokenUri = _args4.length > 5 ? _args4[5] : undefined;
                                if (senderAddress) {
                                    _context4.next = 5;
                                    break;
                                }
                                throw new Error("sender address cannot be empty");
                            case 5:
                                if (!(tokenName.length > 32)) {
                                    _context4.next = 7;
                                    break;
                                }
                                throw new Error("token name is limited to 32 characters");
                            case 7:
                                if (/^[a-zA-z\d]{3,8}$/.test(symbol)) {
                                    _context4.next = 9;
                                    break;
                                }
                                throw new Error("symbol should be alphanumeric and length is limited to 3~8");
                            case 9:
                                if (!(totalSupply <= 0 || totalSupply > $1b61723d5536714b$var$TINY_TOKEN_MAX_TOTAL_SUPPAY)) {
                                    _context4.next = 11;
                                    break;
                                }
                                throw new Error("invalid supply amount");
                            case 11:
                                totalSupply = Number(new $1b61723d5536714b$var$_big["default"](totalSupply).mul(Math.pow(10, 8)).toString());
                                issueMiniMsg = new $eULcN.IssueTinyTokenMsg({
                                    name: tokenName,
                                    symbol: symbol,
                                    total_supply: totalSupply,
                                    mintable: mintable,
                                    token_uri: tokenUri,
                                    from: senderAddress
                                });
                                _context4.next = 15;
                                return this._bncClient._prepareTransaction(issueMiniMsg.getMsg(), issueMiniMsg.getSignMsg(), senderAddress);
                            case 15:
                                signedTx = _context4.sent;
                                return _context4.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 17:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function issueTinyToken(_x11, _x12, _x13) {
                    return _issueTinyToken.apply(this, arguments);
                }
                return issueTinyToken;
            }()
        },
        {
            key: "setTokenUri",
            value: function() {
                var _setTokenUri = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee5(_ref2) {
                    var fromAddress, tokenUri, symbol, setUriMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                fromAddress = _ref2.fromAddress, tokenUri = _ref2.tokenUri, symbol = _ref2.symbol;
                                $1b61723d5536714b$var$validateMiniTokenSymbol(symbol);
                                if (!(tokenUri.length > 2048)) {
                                    _context5.next = 4;
                                    break;
                                }
                                throw new Error("uri cannot be longer than 2048 characters");
                            case 4:
                                if (fromAddress) {
                                    _context5.next = 6;
                                    break;
                                }
                                throw new Error("address cannot be empty");
                            case 6:
                                setUriMsg = new $eULcN.SetTokenUriMsg({
                                    from: fromAddress,
                                    token_uri: tokenUri,
                                    symbol: symbol
                                });
                                _context5.next = 9;
                                return this._bncClient._prepareTransaction(setUriMsg.getMsg(), setUriMsg.getSignMsg(), fromAddress);
                            case 9:
                                signedTx = _context5.sent;
                                return _context5.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function setTokenUri(_x14) {
                    return _setTokenUri.apply(this, arguments);
                }
                return setTokenUri;
            }()
        },
        {
            key: "freeze",
            value: function() {
                var _freeze = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee6(fromAddress, symbol, amount) {
                    var freezeMsg, freezeSignMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                (0, $ddfDI.validateSymbol)(symbol);
                                $1b61723d5536714b$var$validateNonZeroAmount(amount, symbol, fromAddress, this._bncClient._httpClient, "free");
                                amount = +Number(new $1b61723d5536714b$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                freezeMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    symbol: symbol,
                                    amount: amount,
                                    aminoPrefix: $eULcN.AminoPrefix.FreezeMsg
                                };
                                freezeSignMsg = {
                                    amount: amount,
                                    from: fromAddress,
                                    symbol: symbol
                                };
                                _context6.next = 7;
                                return this._bncClient._prepareTransaction(freezeMsg, freezeSignMsg, fromAddress);
                            case 7:
                                signedTx = _context6.sent;
                                return _context6.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 9:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function freeze(_x15, _x16, _x17) {
                    return _freeze.apply(this, arguments);
                }
                return freeze;
            }()
        },
        {
            key: "unfreeze",
            value: function() {
                var _unfreeze = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee7(fromAddress, symbol, amount) {
                    var unfreezeMsg, unfreezeSignMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                (0, $ddfDI.validateSymbol)(symbol);
                                $1b61723d5536714b$var$validateNonZeroAmount(amount, symbol, fromAddress, this._bncClient._httpClient, "frozen");
                                amount = +Number(new $1b61723d5536714b$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                unfreezeMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    symbol: symbol,
                                    amount: amount,
                                    aminoPrefix: $eULcN.AminoPrefix.UnfreezeMsg
                                };
                                unfreezeSignMsg = {
                                    amount: amount,
                                    from: fromAddress,
                                    symbol: symbol
                                };
                                _context7.next = 7;
                                return this._bncClient._prepareTransaction(unfreezeMsg, unfreezeSignMsg, fromAddress);
                            case 7:
                                signedTx = _context7.sent;
                                return _context7.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 9:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function unfreeze(_x18, _x19, _x20) {
                    return _unfreeze.apply(this, arguments);
                }
                return unfreeze;
            }()
        },
        {
            key: "burn",
            value: function() {
                var _burn = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee8(fromAddress, symbol, amount) {
                    var burnMsg, burnSignMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                (0, $ddfDI.validateSymbol)(symbol);
                                $1b61723d5536714b$var$validateNonZeroAmount(amount, symbol, fromAddress, this._bncClient._httpClient);
                                amount = +Number(new $1b61723d5536714b$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                burnMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    symbol: symbol,
                                    amount: amount,
                                    aminoPrefix: $eULcN.AminoPrefix.BurnMsg
                                };
                                burnSignMsg = {
                                    amount: amount,
                                    from: fromAddress,
                                    symbol: symbol
                                };
                                _context8.next = 7;
                                return this._bncClient._prepareTransaction(burnMsg, burnSignMsg, fromAddress);
                            case 7:
                                signedTx = _context8.sent;
                                return _context8.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 9:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function burn(_x21, _x22, _x23) {
                    return _burn.apply(this, arguments);
                }
                return burn;
            }()
        },
        {
            key: "mint",
            value: function() {
                var _mint = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee9(fromAddress, symbol, amount) {
                    var mintMsg, mintSignMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                (0, $ddfDI.validateSymbol)(symbol);
                                if (!(amount <= 0 || amount > $1b61723d5536714b$var$MAXTOTALSUPPLY)) {
                                    _context9.next = 3;
                                    break;
                                }
                                throw new Error("invalid amount");
                            case 3:
                                amount = Number(new $1b61723d5536714b$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                mintMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    symbol: symbol,
                                    amount: amount,
                                    aminoPrefix: $eULcN.AminoPrefix.MintMsg
                                };
                                mintSignMsg = {
                                    amount: amount,
                                    from: fromAddress,
                                    symbol: symbol
                                };
                                _context9.next = 8;
                                return this._bncClient._prepareTransaction(mintMsg, mintSignMsg, fromAddress);
                            case 8:
                                signedTx = _context9.sent;
                                return _context9.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 10:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function mint(_x24, _x25, _x26) {
                    return _mint.apply(this, arguments);
                }
                return mint;
            }()
        },
        {
            key: "timeLock",
            value: function() {
                var _timeLock = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee10(fromAddress, description, amount, lockTime) {
                    var timeLockMsg, signTimeLockMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                (0, $ddfDI.checkCoins)(amount);
                                if (!(description.length > 128)) {
                                    _context10.next = 3;
                                    break;
                                }
                                throw new Error("description is too long");
                            case 3:
                                if (!(lockTime < 60 || lockTime > 253402300800)) {
                                    _context10.next = 5;
                                    break;
                                }
                                throw new Error("timeTime must be in [60, 253402300800]");
                            case 5:
                                timeLockMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    description: description,
                                    amount: amount,
                                    lock_time: lockTime,
                                    aminoPrefix: $eULcN.AminoPrefix.TimeLockMsg
                                };
                                signTimeLockMsg = {
                                    from: fromAddress,
                                    description: description,
                                    amount: amount,
                                    lock_time: lockTime
                                };
                                _context10.next = 9;
                                return this._bncClient._prepareTransaction(timeLockMsg, signTimeLockMsg, fromAddress);
                            case 9:
                                signedTx = _context10.sent;
                                return _context10.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 11:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function timeLock(_x27, _x28, _x29, _x30) {
                    return _timeLock.apply(this, arguments);
                }
                return timeLock;
            }()
        },
        {
            key: "timeRelock",
            value: function() {
                var _timeRelock = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee11(fromAddress, id, description, amount, lockTime) {
                    var timeRelockMsg, signTimeRelockMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                (0, $ddfDI.checkCoins)(amount);
                                if (!(description.length > 128)) {
                                    _context11.next = 3;
                                    break;
                                }
                                throw new Error("description is too long");
                            case 3:
                                if (!(lockTime < 60 || lockTime > 253402300800)) {
                                    _context11.next = 5;
                                    break;
                                }
                                throw new Error("timeTime must be in [60, 253402300800]");
                            case 5:
                                timeRelockMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    time_lock_id: id,
                                    description: description,
                                    amount: amount,
                                    lock_time: lockTime,
                                    aminoPrefix: $eULcN.AminoPrefix.TimeRelockMsg
                                };
                                signTimeRelockMsg = {
                                    from: fromAddress,
                                    time_lock_id: id,
                                    description: description,
                                    amount: amount,
                                    lock_time: lockTime
                                };
                                _context11.next = 9;
                                return this._bncClient._prepareTransaction(timeRelockMsg, signTimeRelockMsg, fromAddress);
                            case 9:
                                signedTx = _context11.sent;
                                return _context11.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 11:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, this);
                }));
                function timeRelock(_x31, _x32, _x33, _x34, _x35) {
                    return _timeRelock.apply(this, arguments);
                }
                return timeRelock;
            }()
        },
        {
            key: "timeUnlock",
            value: function() {
                var _timeUnlock = (0, $1b61723d5536714b$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $1b61723d5536714b$var$_regenerator["default"].mark(function _callee12(fromAddress, id) {
                    var timeUnlockMsg, signTimeUnlockMsg, signedTx;
                    return $1b61723d5536714b$var$_regenerator["default"].wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                timeUnlockMsg = {
                                    from: $1b61723d5536714b$var$crypto.decodeAddress(fromAddress),
                                    time_lock_id: id,
                                    aminoPrefix: $eULcN.AminoPrefix.TimeUnlockMsg
                                };
                                signTimeUnlockMsg = {
                                    from: fromAddress,
                                    time_lock_id: id
                                };
                                _context12.next = 4;
                                return this._bncClient._prepareTransaction(timeUnlockMsg, signTimeUnlockMsg, fromAddress);
                            case 4:
                                signedTx = _context12.sent;
                                return _context12.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 6:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, this);
                }));
                function timeUnlock(_x36, _x37) {
                    return _timeUnlock.apply(this, arguments);
                }
                return timeUnlock;
            }()
        }
    ]);
    return TokenManagement;
}();
var $1b61723d5536714b$var$_default = $1b61723d5536714b$var$TokenManagement;
module.exports["default"] = $1b61723d5536714b$var$_default;

});

parcelRegister("1VioX", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $166963780de521b5$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Bridge = void 0;

var $166963780de521b5$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $166963780de521b5$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $166963780de521b5$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $166963780de521b5$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $166963780de521b5$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $kYX0e = parcelRequire("kYX0e");

var $eULcN = parcelRequire("eULcN");
/**
 * Bridge
 */ var $166963780de521b5$var$Bridge = /*#__PURE__*/ function() {
    /**
   * @param {BncClient} bncClient
   */ function Bridge(bncClient) {
        (0, $166963780de521b5$var$_classCallCheck2["default"])(this, Bridge);
        (0, $166963780de521b5$var$_defineProperty2["default"])(this, "_bncClient", void 0);
        this._bncClient = bncClient;
    }
    /**
   * transfer smart chain token to binance chain receiver
   */ (0, $166963780de521b5$var$_createClass2["default"])(Bridge, [
        {
            key: "transferIn",
            value: function() {
                var _transferIn = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee(_ref) {
                    var sequence, contract_address, refund_addresses, receiver_addresses, amounts, relay_fee, expire_time, symbol, fromAddress, receiverAddresses, refundAddresses, claimHex;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                sequence = _ref.sequence, contract_address = _ref.contract_address, refund_addresses = _ref.refund_addresses, receiver_addresses = _ref.receiver_addresses, amounts = _ref.amounts, relay_fee = _ref.relay_fee, expire_time = _ref.expire_time, symbol = _ref.symbol, fromAddress = _ref.fromAddress;
                                if (!(sequence < 0)) {
                                    _context.next = 3;
                                    break;
                                }
                                throw new Error("sequence should not be less than 0");
                            case 3:
                                if (contract_address) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("contract address should not be empty");
                            case 5:
                                if (relay_fee) {
                                    _context.next = 7;
                                    break;
                                }
                                throw new Error("relay fee should not be empty");
                            case 7:
                                if (symbol) {
                                    _context.next = 9;
                                    break;
                                }
                                throw new Error("symbol should not be null");
                            case 9:
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context.next = 11;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 11:
                                if (!(refund_addresses.length != receiver_addresses.length || refund_addresses.length != amounts.length)) {
                                    _context.next = 13;
                                    break;
                                }
                                throw new Error("the length of refund address array, recipient address array and transfer amount array must be the same");
                            case 13:
                                receiverAddresses = receiver_addresses.map(function(address) {
                                    var addressHrp = address.startsWith("tbnb") ? "tbnb" : "bnb";
                                    if (!(0, $kYX0e.checkAddress)(address, addressHrp)) throw new Error("".concat(address, " in receiver_addresses is not a valid Binance Chain address"));
                                    return (0, $kYX0e.decodeAddress)(address);
                                });
                                refundAddresses = refund_addresses.map(function(address) {
                                    if (!address.startsWith("0x")) throw new Error("".concat(address, " is invalid"));
                                    return $166963780de521b5$require$Buffer.from(address.slice(2), "hex");
                                });
                                claimHex = $166963780de521b5$require$Buffer.from(JSON.stringify({
                                    contract_address: contract_address,
                                    refund_addresses: refundAddresses,
                                    receiver_addresses: receiverAddresses,
                                    amounts: amounts,
                                    symbol: symbol,
                                    relay_fee: relay_fee,
                                    expire_time: expire_time
                                })).toString("hex");
                                return _context.abrupt("return", this.buildClaimAndBroadcast({
                                    claimHex: claimHex,
                                    claim_type: $eULcN.ClaimTypes.ClaimTypeTransferIn,
                                    fromAddress: fromAddress,
                                    sequence: sequence
                                }));
                            case 17:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function transferIn(_x) {
                    return _transferIn.apply(this, arguments);
                }
                return transferIn;
            }()
        },
        {
            key: "transferOutRefund",
            value: function() {
                var _transferOutRefund = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee2(_ref2) {
                    var transfer_out_sequence, refund_address, refund_reason, amount, fromAddress, claimHex;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                transfer_out_sequence = _ref2.transfer_out_sequence, refund_address = _ref2.refund_address, refund_reason = _ref2.refund_reason, amount = _ref2.amount, fromAddress = _ref2.fromAddress;
                                if (!(transfer_out_sequence < 0)) {
                                    _context2.next = 3;
                                    break;
                                }
                                throw new Error("sequence should not be less than 0");
                            case 3:
                                if (amount) {
                                    _context2.next = 5;
                                    break;
                                }
                                throw new Error("amount should not be empty");
                            case 5:
                                if (refund_reason) {
                                    _context2.next = 7;
                                    break;
                                }
                                throw new Error("empty refund reason");
                            case 7:
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context2.next = 9;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 9:
                                claimHex = $166963780de521b5$require$Buffer.from(JSON.stringify({
                                    transfer_out_sequence: transfer_out_sequence,
                                    refund_address: refund_address,
                                    amount: amount,
                                    refund_reason: refund_reason
                                })).toString("hex");
                                return _context2.abrupt("return", this.buildClaimAndBroadcast({
                                    claimHex: claimHex,
                                    claim_type: $eULcN.ClaimTypes.ClaimTypeTransferOutRefund,
                                    sequence: transfer_out_sequence,
                                    fromAddress: fromAddress
                                }));
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function transferOutRefund(_x2) {
                    return _transferOutRefund.apply(this, arguments);
                }
                return transferOutRefund;
            }()
        },
        {
            key: "bind",
            value: function() {
                var _bind = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee3(_ref3) {
                    var contractAddress, contractDecimal, amount, symbol, expireTime, fromAddress, bindMsg;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                contractAddress = _ref3.contractAddress, contractDecimal = _ref3.contractDecimal, amount = _ref3.amount, symbol = _ref3.symbol, expireTime = _ref3.expireTime, fromAddress = _ref3.fromAddress;
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 3:
                                if (contractAddress.startsWith("0x")) {
                                    _context3.next = 5;
                                    break;
                                }
                                throw new Error('contractAddress "'.concat(contractAddress, '" is invalid'));
                            case 5:
                                bindMsg = new $eULcN.BindMsg({
                                    from: fromAddress,
                                    amount: amount,
                                    contract_address: contractAddress,
                                    contract_decimals: contractDecimal,
                                    expire_time: expireTime,
                                    symbol: symbol
                                });
                                _context3.next = 8;
                                return this.broadcast(bindMsg, fromAddress);
                            case 8:
                                return _context3.abrupt("return", _context3.sent);
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function bind(_x3) {
                    return _bind.apply(this, arguments);
                }
                return bind;
            }()
        },
        {
            key: "transferFromBcToBsc",
            value: function() {
                var _transferFromBcToBsc = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee4(_ref4) {
                    var toAddress, amount, symbol, expireTime, fromAddress, transferOut;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                toAddress = _ref4.toAddress, amount = _ref4.amount, symbol = _ref4.symbol, expireTime = _ref4.expireTime, fromAddress = _ref4.fromAddress;
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context4.next = 3;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 3:
                                if (toAddress.startsWith("0x")) {
                                    _context4.next = 5;
                                    break;
                                }
                                throw new Error('toAddress "'.concat(toAddress, '" is invalid'));
                            case 5:
                                transferOut = new $eULcN.TransferOutMsg({
                                    from: fromAddress,
                                    to: toAddress,
                                    amount: {
                                        denom: symbol,
                                        amount: amount
                                    },
                                    expire_time: expireTime
                                });
                                return _context4.abrupt("return", this.broadcast(transferOut, fromAddress));
                            case 7:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function transferFromBcToBsc(_x4) {
                    return _transferFromBcToBsc.apply(this, arguments);
                }
                return transferFromBcToBsc;
            }()
        },
        {
            key: "upateBind",
            value: function() {
                var _upateBind = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee5(_ref5) {
                    var sequence, contract_address, symbol, status, fromAddress, claimHex;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                sequence = _ref5.sequence, contract_address = _ref5.contract_address, symbol = _ref5.symbol, status = _ref5.status, fromAddress = _ref5.fromAddress;
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context5.next = 3;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 3:
                                if (contract_address.startsWith("0x")) {
                                    _context5.next = 5;
                                    break;
                                }
                                throw new Error('toAddress "'.concat(contract_address, '" is invalid'));
                            case 5:
                                claimHex = $166963780de521b5$require$Buffer.from(JSON.stringify({
                                    status: status,
                                    symbol: symbol,
                                    contract_address: contract_address
                                })).toString("hex");
                                return _context5.abrupt("return", this.buildClaimAndBroadcast({
                                    claimHex: claimHex,
                                    sequence: sequence,
                                    fromAddress: fromAddress,
                                    claim_type: $eULcN.ClaimTypes.ClaimTypeUpdateBind
                                }));
                            case 7:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function upateBind(_x5) {
                    return _upateBind.apply(this, arguments);
                }
                return upateBind;
            }()
        },
        {
            key: "skipSequence",
            value: function() {
                var _skipSequence = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee6(_ref6) {
                    var sequence, sequenceToSkip, fromAddress, claimHex;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                sequence = _ref6.sequence, sequenceToSkip = _ref6.sequenceToSkip, fromAddress = _ref6.fromAddress;
                                if (!(sequence < 0)) {
                                    _context6.next = 3;
                                    break;
                                }
                                throw new Error("sequence should not be less than 0");
                            case 3:
                                if ((0, $kYX0e.checkAddress)(fromAddress, this._bncClient.addressPrefix)) {
                                    _context6.next = 5;
                                    break;
                                }
                                throw new Error("fromAddress is not a valid Binance Chain address");
                            case 5:
                                claimHex = $166963780de521b5$require$Buffer.from(JSON.stringify({
                                    claim_type: $eULcN.ClaimTypes.ClaimTypeUpdateBind,
                                    sequence: sequenceToSkip
                                })).toString("hex");
                                return _context6.abrupt("return", this.buildClaimAndBroadcast({
                                    claimHex: claimHex,
                                    sequence: sequence,
                                    fromAddress: fromAddress,
                                    claim_type: $eULcN.ClaimTypes.ClaimTypeSkipSequence
                                }));
                            case 7:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function skipSequence(_x6) {
                    return _skipSequence.apply(this, arguments);
                }
                return skipSequence;
            }()
        },
        {
            key: "buildClaimAndBroadcast",
            value: function() {
                var _buildClaimAndBroadcast = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee7(_ref7) {
                    var claimHex, claim_type, sequence, fromAddress, claimMsg;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                claimHex = _ref7.claimHex, claim_type = _ref7.claim_type, sequence = _ref7.sequence, fromAddress = _ref7.fromAddress;
                                claimMsg = new $eULcN.ClaimMsg({
                                    claim_type: claim_type,
                                    sequence: sequence,
                                    claim: claimHex,
                                    validator_address: fromAddress
                                });
                                _context7.next = 4;
                                return this.broadcast(claimMsg, fromAddress, sequence);
                            case 4:
                                return _context7.abrupt("return", _context7.sent);
                            case 5:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function buildClaimAndBroadcast(_x7) {
                    return _buildClaimAndBroadcast.apply(this, arguments);
                }
                return buildClaimAndBroadcast;
            }()
        },
        {
            key: "broadcast",
            value: function() {
                var _broadcast = (0, $166963780de521b5$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $166963780de521b5$var$_regenerator["default"].mark(function _callee8(msg, fromAddress, sequence) {
                    var signedTx;
                    return $166963780de521b5$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                _context8.next = 2;
                                return this._bncClient._prepareTransaction(msg.getMsg(), msg.getSignMsg(), fromAddress, sequence);
                            case 2:
                                signedTx = _context8.sent;
                                return _context8.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 4:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function broadcast(_x8, _x9, _x10) {
                    return _broadcast.apply(this, arguments);
                }
                return broadcast;
            }()
        }
    ]);
    return Bridge;
}();
module.exports.Bridge = $166963780de521b5$var$Bridge;

});

parcelRegister("6Pl5j", function(module, exports) {
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Stake = void 0;

var $4f87dc7842e84168$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $4f87dc7842e84168$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $4f87dc7842e84168$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $4f87dc7842e84168$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $4f87dc7842e84168$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $4f87dc7842e84168$var$_big = $2ZnTs((parcelRequire("3qN14")));

var $4f87dc7842e84168$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");
/**
 * Stake
 */ var $4f87dc7842e84168$var$Stake = /*#__PURE__*/ function() {
    /**
   * @param {BncClient} bncClient
   */ function Stake(bncClient) {
        (0, $4f87dc7842e84168$var$_classCallCheck2["default"])(this, Stake);
        (0, $4f87dc7842e84168$var$_defineProperty2["default"])(this, "_bncClient", void 0);
        this._bncClient = bncClient;
    }
    (0, $4f87dc7842e84168$var$_createClass2["default"])(Stake, [
        {
            key: "bscDelegate",
            value: function() {
                var _bscDelegate = (0, $4f87dc7842e84168$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f87dc7842e84168$var$_regenerator["default"].mark(function _callee(_ref) {
                    var delegateAddress, validatorAddress, amount, _ref$symbol, symbol, _ref$sideChainId, sideChainId, bscDelegateMsg;
                    return $4f87dc7842e84168$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                delegateAddress = _ref.delegateAddress, validatorAddress = _ref.validatorAddress, amount = _ref.amount, _ref$symbol = _ref.symbol, symbol = _ref$symbol === void 0 ? "BNB" : _ref$symbol, _ref$sideChainId = _ref.sideChainId, sideChainId = _ref$sideChainId === void 0 ? "chapel" : _ref$sideChainId;
                                if (amount) {
                                    _context.next = 3;
                                    break;
                                }
                                throw new Error("amount should not be empty");
                            case 3:
                                if (delegateAddress) {
                                    _context.next = 5;
                                    break;
                                }
                                throw new Error("delegate address should not be null");
                            case 5:
                                if ($4f87dc7842e84168$var$crypto.checkAddress(validatorAddress, "bva")) {
                                    _context.next = 7;
                                    break;
                                }
                                throw new Error("validator address is not valid");
                            case 7:
                                amount = Number(new $4f87dc7842e84168$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                bscDelegateMsg = new $eULcN.BscDelegateMsg({
                                    delegator_addr: delegateAddress,
                                    validator_addr: validatorAddress,
                                    delegation: {
                                        denom: symbol,
                                        amount: amount
                                    },
                                    side_chain_id: sideChainId
                                });
                                _context.next = 11;
                                return this.broadcast(bscDelegateMsg, delegateAddress);
                            case 11:
                                return _context.abrupt("return", _context.sent);
                            case 12:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function bscDelegate(_x) {
                    return _bscDelegate.apply(this, arguments);
                }
                return bscDelegate;
            }()
        },
        {
            key: "bscUndelegate",
            value: function() {
                var _bscUndelegate = (0, $4f87dc7842e84168$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f87dc7842e84168$var$_regenerator["default"].mark(function _callee2(_ref2) {
                    var delegateAddress, validatorAddress, amount, _ref2$symbol, symbol, _ref2$sideChainId, sideChainId, unDelegateMsg;
                    return $4f87dc7842e84168$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                delegateAddress = _ref2.delegateAddress, validatorAddress = _ref2.validatorAddress, amount = _ref2.amount, _ref2$symbol = _ref2.symbol, symbol = _ref2$symbol === void 0 ? "BNB" : _ref2$symbol, _ref2$sideChainId = _ref2.sideChainId, sideChainId = _ref2$sideChainId === void 0 ? "chapel" : _ref2$sideChainId;
                                if (amount) {
                                    _context2.next = 3;
                                    break;
                                }
                                throw new Error("amount should not be empty");
                            case 3:
                                if (delegateAddress) {
                                    _context2.next = 5;
                                    break;
                                }
                                throw new Error("delegate address should not be null");
                            case 5:
                                if ($4f87dc7842e84168$var$crypto.checkAddress(validatorAddress, "bva")) {
                                    _context2.next = 7;
                                    break;
                                }
                                throw new Error("validator address is not valid");
                            case 7:
                                amount = Number(new $4f87dc7842e84168$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                unDelegateMsg = new $eULcN.BscUndelegateMsg({
                                    delegator_addr: delegateAddress,
                                    validator_addr: validatorAddress,
                                    amount: {
                                        denom: symbol,
                                        amount: amount
                                    },
                                    side_chain_id: sideChainId
                                });
                                _context2.next = 11;
                                return this.broadcast(unDelegateMsg, delegateAddress);
                            case 11:
                                return _context2.abrupt("return", _context2.sent);
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function bscUndelegate(_x2) {
                    return _bscUndelegate.apply(this, arguments);
                }
                return bscUndelegate;
            }()
        },
        {
            key: "bscReDelegate",
            value: function() {
                var _bscReDelegate = (0, $4f87dc7842e84168$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f87dc7842e84168$var$_regenerator["default"].mark(function _callee3(_ref3) {
                    var delegateAddress, validatorSrcAddress, validatorDstAddress, amount, _ref3$symbol, symbol, _ref3$sideChainId, sideChainId, bscReDelegateMsg;
                    return $4f87dc7842e84168$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                delegateAddress = _ref3.delegateAddress, validatorSrcAddress = _ref3.validatorSrcAddress, validatorDstAddress = _ref3.validatorDstAddress, amount = _ref3.amount, _ref3$symbol = _ref3.symbol, symbol = _ref3$symbol === void 0 ? "BNB" : _ref3$symbol, _ref3$sideChainId = _ref3.sideChainId, sideChainId = _ref3$sideChainId === void 0 ? "chapel" : _ref3$sideChainId;
                                if (amount) {
                                    _context3.next = 3;
                                    break;
                                }
                                throw new Error("amount should not be empty");
                            case 3:
                                if (delegateAddress) {
                                    _context3.next = 5;
                                    break;
                                }
                                throw new Error("delegate address should not be null");
                            case 5:
                                if ($4f87dc7842e84168$var$crypto.checkAddress(validatorSrcAddress, "bva")) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new Error("validator source address is not valid");
                            case 7:
                                if ($4f87dc7842e84168$var$crypto.checkAddress(validatorDstAddress, "bva")) {
                                    _context3.next = 9;
                                    break;
                                }
                                throw new Error("validator dest address is not valid");
                            case 9:
                                amount = Number(new $4f87dc7842e84168$var$_big["default"](amount).mul(Math.pow(10, 8)).toString());
                                bscReDelegateMsg = new $eULcN.BscReDelegateMsg({
                                    delegator_addr: delegateAddress,
                                    validator_src_addr: validatorSrcAddress,
                                    validator_dst_addr: validatorDstAddress,
                                    amount: {
                                        denom: symbol,
                                        amount: amount
                                    },
                                    side_chain_id: sideChainId
                                });
                                _context3.next = 13;
                                return this.broadcast(bscReDelegateMsg, delegateAddress);
                            case 13:
                                return _context3.abrupt("return", _context3.sent);
                            case 14:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function bscReDelegate(_x3) {
                    return _bscReDelegate.apply(this, arguments);
                }
                return bscReDelegate;
            }()
        },
        {
            key: "broadcast",
            value: function() {
                var _broadcast = (0, $4f87dc7842e84168$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f87dc7842e84168$var$_regenerator["default"].mark(function _callee4(msg, fromAddress, sequence) {
                    var signedTx;
                    return $4f87dc7842e84168$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return this._bncClient._prepareTransaction(msg.getMsg(), msg.getSignMsg(), fromAddress, sequence);
                            case 2:
                                signedTx = _context4.sent;
                                return _context4.abrupt("return", this._bncClient._broadcastDelegate(signedTx));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function broadcast(_x4, _x5, _x6) {
                    return _broadcast.apply(this, arguments);
                }
                return broadcast;
            }()
        }
    ]);
    return Stake;
}();
module.exports.Stake = $4f87dc7842e84168$var$Stake;

});


parcelRegister("6MTKw", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4f12786c80d593c9$require$Buffer = $ihoyg.Buffer;
"use strict";

var $3sU9H = parcelRequire("3sU9H");

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4f12786c80d593c9$var$_regenerator = $2ZnTs((parcelRequire("kM9CL")));

var $4f12786c80d593c9$var$_asyncToGenerator2 = $2ZnTs((parcelRequire("dxUGa")));

var $4f12786c80d593c9$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $4f12786c80d593c9$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $4f12786c80d593c9$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $4f12786c80d593c9$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $4f12786c80d593c9$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $4f12786c80d593c9$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $4f12786c80d593c9$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $3qN14 = parcelRequire("3qN14");

var $22ocj = parcelRequire("22ocj");

var $4f12786c80d593c9$var$crypto = $3sU9H((parcelRequire("kYX0e")));

var $eULcN = parcelRequire("eULcN");

var $1ZFs6 = parcelRequire("1ZFs6");

var $4f12786c80d593c9$var$_baseRpc = $2ZnTs((parcelRequire("islZS")));
function $4f12786c80d593c9$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4f12786c80d593c9$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4f12786c80d593c9$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $4f12786c80d593c9$var$_defineProperty2["default"])(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4f12786c80d593c9$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4f12786c80d593c9$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $4f12786c80d593c9$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $4f12786c80d593c9$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $4f12786c80d593c9$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $4f12786c80d593c9$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $4f12786c80d593c9$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * The Binance Chain Node rpc client
 */ var $4f12786c80d593c9$var$RpcClient = /*#__PURE__*/ function(_BaseRpc) {
    (0, $4f12786c80d593c9$var$_inherits2["default"])(RpcClient, _BaseRpc);
    var _super = $4f12786c80d593c9$var$_createSuper(RpcClient);
    /**
   * @param {String} uriString dataseed address
   * @param {String} netWork Binance Chain network
   */ function RpcClient() {
        var _this;
        var uriString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localhost:27146";
        var netWork = arguments.length > 1 ? arguments[1] : undefined;
        (0, $4f12786c80d593c9$var$_classCallCheck2["default"])(this, RpcClient);
        _this = _super.call(this, uriString);
        (0, $4f12786c80d593c9$var$_defineProperty2["default"])((0, $4f12786c80d593c9$var$_assertThisInitialized2["default"])(_this), "netWork", void 0);
        _this.netWork = netWork || "mainnet";
        return _this;
    }
    /**
   * The RPC broadcast delegate broadcasts a transaction via RPC. This is intended for optional use as BncClient's broadcast delegate.
   * @param {Transaction} signedTx the signed transaction
   * @return {Promise}
   */ (0, $4f12786c80d593c9$var$_createClass2["default"])(RpcClient, [
        {
            key: "broadcastDelegate",
            value: function() {
                var _broadcastDelegate = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee(signedTx) {
                    var encoded, res;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                // amino encode the signed TX
                                encoded = signedTx.serialize(); // broadcast it via RPC; we have to use a promise here because that's
                                // what the BncClient expects as the return value of this function.
                                _context.next = 3;
                                return this.broadcastTxSync({
                                    tx: $4f12786c80d593c9$require$Buffer.from(encoded, "hex")
                                });
                            case 3:
                                res = _context.sent;
                                if (!("".concat(res.code) === "0")) {
                                    _context.next = 8;
                                    break;
                                }
                                return _context.abrupt("return", res);
                            case 8:
                                throw new Error("broadcastDelegate: non-zero status code ".concat(res.code));
                            case 9:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function broadcastDelegate(_x) {
                    return _broadcastDelegate.apply(this, arguments);
                }
                return broadcastDelegate;
            }()
        },
        {
            key: "getBech32Prefix",
            value: function getBech32Prefix() {
                if (this.netWork === "mainnet") return "bnb";
                if (this.netWork === "testnet") return "tbnb";
                return "";
            }
        },
        {
            key: "getTokenInfo",
            value: function() {
                var _getTokenInfo = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee2(symbol) {
                    var path, res, bytes, tokenInfo, bech32Prefix, ownerAddress;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                (0, $1ZFs6.validateSymbol)(symbol);
                                path = "/tokens/info/" + symbol;
                                _context2.next = 4;
                                return this.abciQuery({
                                    path: path
                                });
                            case 4:
                                res = _context2.sent;
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                tokenInfo = new $eULcN.Token();
                                (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, tokenInfo);
                                bech32Prefix = this.getBech32Prefix();
                                ownerAddress = $4f12786c80d593c9$var$crypto.encodeAddress(tokenInfo.owner, bech32Prefix);
                                delete tokenInfo.aminoPrefix; //TODO all the result contains aminoPrefix, need to improve
                                return _context2.abrupt("return", $4f12786c80d593c9$var$_objectSpread($4f12786c80d593c9$var$_objectSpread({}, tokenInfo), {}, {
                                    owner: ownerAddress
                                }));
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function getTokenInfo(_x2) {
                    return _getTokenInfo.apply(this, arguments);
                }
                return getTokenInfo;
            }()
        },
        {
            key: "listAllTokens",
            value: function() {
                var _listAllTokens = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee3(offset, limit) {
                    var _this2 = this;
                    var path, res, bytes, tokenArr, _unMarshalBinaryLengt, tokenList;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                (0, $1ZFs6.validateOffsetLimit)(offset, limit);
                                path = "tokens/list/".concat(offset, "/").concat(limit);
                                _context3.next = 4;
                                return this.abciQuery({
                                    path: path
                                });
                            case 4:
                                res = _context3.sent;
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                tokenArr = [
                                    new $eULcN.TokenOfList()
                                ];
                                _unMarshalBinaryLengt = (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, tokenArr), tokenList = _unMarshalBinaryLengt.val;
                                (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, tokenList);
                                return _context3.abrupt("return", tokenList.map(function(item) {
                                    return $4f12786c80d593c9$var$_objectSpread($4f12786c80d593c9$var$_objectSpread({}, item), {}, {
                                        owner: $4f12786c80d593c9$var$crypto.encodeAddress(item.owner, _this2.getBech32Prefix())
                                    });
                                }));
                            case 10:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function listAllTokens(_x3, _x4) {
                    return _listAllTokens.apply(this, arguments);
                }
                return listAllTokens;
            }()
        },
        {
            key: "getAccount",
            value: function() {
                var _getAccount = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee4(address) {
                    var res, accountInfo, bytes, bech32Prefix;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return this.abciQuery({
                                    path: "/account/".concat(address)
                                });
                            case 2:
                                res = _context4.sent;
                                accountInfo = new $eULcN.AppAccount();
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                (0, $22ocj.unMarshalBinaryBare)(bytes, accountInfo);
                                bech32Prefix = this.getBech32Prefix();
                                return _context4.abrupt("return", {
                                    name: accountInfo.name,
                                    locked: accountInfo.locked,
                                    frozen: accountInfo.frozen,
                                    base: $4f12786c80d593c9$var$_objectSpread($4f12786c80d593c9$var$_objectSpread({}, accountInfo.base), {}, {
                                        address: $4f12786c80d593c9$var$crypto.encodeAddress(accountInfo.base.address, bech32Prefix)
                                    })
                                });
                            case 8:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function getAccount(_x5) {
                    return _getAccount.apply(this, arguments);
                }
                return getAccount;
            }()
        },
        {
            key: "getBalances",
            value: function() {
                var _getBalances = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee5(address) {
                    var account, coins, balances;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                _context5.next = 2;
                                return this.getAccount(address);
                            case 2:
                                account = _context5.sent;
                                coins = [];
                                balances = [];
                                if (account) {
                                    coins = account.base && account.base.coins || [];
                                    (0, $1ZFs6.convertObjectArrayNum)(coins, [
                                        "amount"
                                    ]);
                                    (0, $1ZFs6.convertObjectArrayNum)(account.locked, [
                                        "amount"
                                    ]);
                                    (0, $1ZFs6.convertObjectArrayNum)(account.frozen, [
                                        "amount"
                                    ]);
                                }
                                coins.forEach(function(item) {
                                    var locked = account.locked.find(function(lockedItem) {
                                        return item.denom === lockedItem.denom;
                                    }) || {};
                                    var frozen = account.frozen.find(function(frozenItem) {
                                        return item.denom === frozenItem.denom;
                                    }) || {};
                                    var bal = new $eULcN.TokenBalance();
                                    bal.symbol = item.denom;
                                    bal.free = +new $3qN14.Big(item.amount).toString();
                                    bal.locked = locked.amount || 0;
                                    bal.frozen = frozen.amount || 0;
                                    balances.push(bal);
                                });
                                return _context5.abrupt("return", balances);
                            case 8:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function getBalances(_x6) {
                    return _getBalances.apply(this, arguments);
                }
                return getBalances;
            }()
        },
        {
            key: "getBalance",
            value: function() {
                var _getBalance = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee6(address, symbol) {
                    var balances, bal;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                (0, $1ZFs6.validateSymbol)(symbol);
                                _context6.next = 3;
                                return this.getBalances(address);
                            case 3:
                                balances = _context6.sent;
                                bal = balances.find(function(item) {
                                    return item.symbol.toUpperCase() === symbol.toUpperCase();
                                });
                                return _context6.abrupt("return", bal);
                            case 6:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6, this);
                }));
                function getBalance(_x7, _x8) {
                    return _getBalance.apply(this, arguments);
                }
                return getBalance;
            }()
        },
        {
            key: "getOpenOrders",
            value: function() {
                var _getOpenOrders = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee7(address, symbol) {
                    var path, res, bytes, result, _unMarshalBinaryLengt2, openOrders;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                path = "/dex/openorders/".concat(symbol, "/").concat(address);
                                _context7.next = 3;
                                return this.abciQuery({
                                    path: path
                                });
                            case 3:
                                res = _context7.sent;
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                result = [
                                    new $eULcN.OpenOrder()
                                ];
                                _unMarshalBinaryLengt2 = (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, result), openOrders = _unMarshalBinaryLengt2.val;
                                (0, $1ZFs6.convertObjectArrayNum)(openOrders, [
                                    "price",
                                    "quantity",
                                    "cumQty"
                                ]);
                                return _context7.abrupt("return", openOrders);
                            case 9:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this);
                }));
                function getOpenOrders(_x9, _x10) {
                    return _getOpenOrders.apply(this, arguments);
                }
                return getOpenOrders;
            }()
        },
        {
            key: "getTradingPairs",
            value: function() {
                var _getTradingPairs = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee8(offset, limit) {
                    var path, res, bytes, result, _unMarshalBinaryLengt3, tradingPairs;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                (0, $1ZFs6.validateOffsetLimit)(offset, limit);
                                path = "/dex/pairs/".concat(offset, "/").concat(limit);
                                _context8.next = 4;
                                return this.abciQuery({
                                    path: path
                                });
                            case 4:
                                res = _context8.sent;
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                result = [
                                    new $eULcN.TradingPair()
                                ];
                                _unMarshalBinaryLengt3 = (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, result), tradingPairs = _unMarshalBinaryLengt3.val;
                                (0, $1ZFs6.convertObjectArrayNum)(tradingPairs, [
                                    "list_price",
                                    "tick_size",
                                    "lot_size"
                                ]);
                                return _context8.abrupt("return", tradingPairs);
                            case 10:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this);
                }));
                function getTradingPairs(_x11, _x12) {
                    return _getTradingPairs.apply(this, arguments);
                }
                return getTradingPairs;
            }()
        },
        {
            key: "getDepth",
            value: function() {
                var _getDepth = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee9(tradePair) {
                    var path, res, bytes, result, _unMarshalBinaryLengt4, depth;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                (0, $1ZFs6.validateTradingPair)(tradePair);
                                path = "dex/orderbook/".concat(tradePair);
                                _context9.next = 4;
                                return this.abciQuery({
                                    path: path
                                });
                            case 4:
                                res = _context9.sent;
                                bytes = $4f12786c80d593c9$require$Buffer.from(res.response.value, "base64");
                                result = new $eULcN.OrderBook();
                                _unMarshalBinaryLengt4 = (0, $22ocj.unMarshalBinaryLengthPrefixed)(bytes, result), depth = _unMarshalBinaryLengt4.val;
                                (0, $1ZFs6.convertObjectArrayNum)(depth.levels, [
                                    "buyQty",
                                    "buyPrice",
                                    "sellQty",
                                    "sellPrice"
                                ]);
                                return _context9.abrupt("return", depth);
                            case 10:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this);
                }));
                function getDepth(_x13) {
                    return _getDepth.apply(this, arguments);
                }
                return getDepth;
            }()
        },
        {
            key: "getTxByHash",
            value: function() {
                var _getTxByHash = (0, $4f12786c80d593c9$var$_asyncToGenerator2["default"])(/*#__PURE__*/ $4f12786c80d593c9$var$_regenerator["default"].mark(function _callee10(hash) {
                    var prove, res, txBytes, msgAminoPrefix, msgType, type, _unMarshalBinaryLengt5, result, txResult, _args10 = arguments;
                    return $4f12786c80d593c9$var$_regenerator["default"].wrap(function _callee10$(_context10) {
                        while(true)switch(_context10.prev = _context10.next){
                            case 0:
                                prove = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : true;
                                if (!$4f12786c80d593c9$require$Buffer.isBuffer(hash)) hash = $4f12786c80d593c9$require$Buffer.from(hash, "hex");
                                _context10.next = 4;
                                return this.tx({
                                    hash: hash,
                                    prove: prove
                                });
                            case 4:
                                res = _context10.sent;
                                txBytes = $4f12786c80d593c9$require$Buffer.from(res.tx, "base64");
                                msgAminoPrefix = txBytes.slice(8, 12).toString("hex");
                                msgType = (0, $1ZFs6.getMsgByAminoPrefix)(msgAminoPrefix);
                                type = {
                                    msg: [
                                        msgType.defaultMsg()
                                    ],
                                    signatures: [
                                        {
                                            pub_key: $4f12786c80d593c9$require$Buffer.from(""),
                                            signature: $4f12786c80d593c9$require$Buffer.from(""),
                                            account_number: 0,
                                            sequence: 0
                                        }
                                    ],
                                    memo: "",
                                    source: 0,
                                    data: "",
                                    aminoPrefix: $eULcN.AminoPrefix.StdTx
                                };
                                _unMarshalBinaryLengt5 = (0, $22ocj.unMarshalBinaryLengthPrefixed)(txBytes, type), result = _unMarshalBinaryLengt5.val;
                                txResult = this.parseTxResult(res.tx_result); //TODO remove aminoPrefix
                                return _context10.abrupt("return", $4f12786c80d593c9$var$_objectSpread($4f12786c80d593c9$var$_objectSpread({}, res), {}, {
                                    tx: result,
                                    tx_result: txResult
                                }));
                            case 12:
                            case "end":
                                return _context10.stop();
                        }
                    }, _callee10, this);
                }));
                function getTxByHash(_x14) {
                    return _getTxByHash.apply(this, arguments);
                }
                return getTxByHash;
            }()
        },
        {
            key: "parseTxResult",
            value: function parseTxResult(txResult) {
                if (txResult.data) txResult.data = $4f12786c80d593c9$require$Buffer.from(txResult.data, "base64").toString();
                if (txResult.events && txResult.events.length > 0) for(var i = 0; i < txResult.events.length; i++){
                    var event = txResult.events[i];
                    if (event.attributes && event.attributes.length > 0) event.attributes = event.attributes.map(function(item) {
                        return {
                            key: $4f12786c80d593c9$require$Buffer.from(item.key, "base64").toString(),
                            value: $4f12786c80d593c9$require$Buffer.from(item.value, "base64").toString()
                        };
                    });
                }
                if (txResult.tags && txResult.tags.length > 0) txResult.tags = txResult.tags.map(function(item) {
                    return {
                        key: $4f12786c80d593c9$require$Buffer.from(item.key, "base64").toString(),
                        value: $4f12786c80d593c9$require$Buffer.from(item.value, "base64").toString()
                    };
                });
                return $4f12786c80d593c9$var$_objectSpread({}, txResult);
            }
        }
    ]);
    return RpcClient;
}($4f12786c80d593c9$var$_baseRpc["default"]);
var $4f12786c80d593c9$var$_default = $4f12786c80d593c9$var$RpcClient;
module.exports["default"] = $4f12786c80d593c9$var$_default;

});
parcelRegister("islZS", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d6fbe7ac05ca377a$require$Buffer = $ihoyg.Buffer;
"use strict";

var $2ZnTs = parcelRequire("2ZnTs");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $d6fbe7ac05ca377a$var$_classCallCheck2 = $2ZnTs((parcelRequire("bfbtb")));

var $d6fbe7ac05ca377a$var$_createClass2 = $2ZnTs((parcelRequire("kNrk6")));

var $d6fbe7ac05ca377a$var$_assertThisInitialized2 = $2ZnTs((parcelRequire("eiXAs")));

var $d6fbe7ac05ca377a$var$_inherits2 = $2ZnTs((parcelRequire("ljhd4")));

var $d6fbe7ac05ca377a$var$_possibleConstructorReturn2 = $2ZnTs((parcelRequire("cybvJ")));

var $d6fbe7ac05ca377a$var$_getPrototypeOf2 = $2ZnTs((parcelRequire("j4o1m")));

var $d6fbe7ac05ca377a$var$_defineProperty2 = $2ZnTs((parcelRequire("jqdsN")));

var $d6fbe7ac05ca377a$var$_axios = $2ZnTs((parcelRequire("gEDAL")));

var $jMc9N = parcelRequire("jMc9N");

var $d6fbe7ac05ca377a$var$_is_js = $2ZnTs((parcelRequire("2zdJh")));

var $d6fbe7ac05ca377a$var$_ndjson = $2ZnTs((parcelRequire("e1HjZ")));

var $d6fbe7ac05ca377a$var$_pumpify = $2ZnTs((parcelRequire("acOFb")));

var $d6fbe7ac05ca377a$var$_url = $2ZnTs((parcelRequire("hH01d")));

var $d6fbe7ac05ca377a$var$_websocketStream = $2ZnTs((parcelRequire("38MJ4")));
function $d6fbe7ac05ca377a$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d6fbe7ac05ca377a$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $d6fbe7ac05ca377a$var$_getPrototypeOf2["default"])(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $d6fbe7ac05ca377a$var$_getPrototypeOf2["default"])(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $d6fbe7ac05ca377a$var$_possibleConstructorReturn2["default"])(this, result);
    };
}
function $d6fbe7ac05ca377a$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d6fbe7ac05ca377a$var$convertHttpArgs(url) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var search = [];
    for(var _k in args){
        if ($d6fbe7ac05ca377a$var$_is_js["default"].string(args[_k])) search.push("".concat(_k, '="').concat(args[_k], '"'));
        else if ($d6fbe7ac05ca377a$require$Buffer.isBuffer(args[_k])) search.push("".concat(_k, "=0x").concat(args[_k].toString("hex")));
        else search.push("".concat(_k, "=").concat(args[_k]));
    }
    return "".concat(url, "?").concat(search.join("&"));
}
function $d6fbe7ac05ca377a$var$convertWsArgs() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    for(var _k2 in args){
        var v = args[_k2];
        if (typeof v === "number") args[_k2] = String(v);
        else if ($d6fbe7ac05ca377a$require$Buffer.isBuffer(v)) args[_k2] = "0x" + v.toString("hex");
        else if (v instanceof Uint8Array) args[_k2] = "0x" + $d6fbe7ac05ca377a$require$Buffer.from(v).toString("hex");
    }
    return args;
}
var $d6fbe7ac05ca377a$var$wsProtocols = [
    "ws:",
    "wss:"
];
var $d6fbe7ac05ca377a$var$httpProtocols = [
    "http:",
    "https:"
];
var $d6fbe7ac05ca377a$var$allProtocols = $d6fbe7ac05ca377a$var$wsProtocols.concat($d6fbe7ac05ca377a$var$httpProtocols);
var $d6fbe7ac05ca377a$var$BaseRpc = /*#__PURE__*/ function(_EventEmitter) {
    (0, $d6fbe7ac05ca377a$var$_inherits2["default"])(BaseRpc, _EventEmitter);
    var _super = $d6fbe7ac05ca377a$var$_createSuper(BaseRpc);
    function BaseRpc() {
        var _this;
        var uriString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "localhost:27146";
        (0, $d6fbe7ac05ca377a$var$_classCallCheck2["default"])(this, BaseRpc);
        _this = _super.call(this); // parse full-node URI
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "uri", void 0);
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "call", void 0);
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "closed", false);
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "ws", void 0);
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "createCallBasedMethod", function(name) {
            return function(args, listener) {
                return _this.call(name, args, listener).then(function(res) {
                    return res;
                });
            };
        });
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "subscribe", _this.createCallBasedMethod("subscribe"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "unsubscribe", _this.createCallBasedMethod("unsubscribe"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "unsubscribeAll", _this.createCallBasedMethod("unsubscribe_all"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "status", _this.createCallBasedMethod("status"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "netInfo", _this.createCallBasedMethod("net_info"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "blockchain", _this.createCallBasedMethod("blockchain"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "genesis", _this.createCallBasedMethod("genesis"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "health", _this.createCallBasedMethod("health"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "block", _this.createCallBasedMethod("block"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "blockResults", _this.createCallBasedMethod("block_results"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "validators", _this.createCallBasedMethod("validators"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "consensusState", _this.createCallBasedMethod("consensus_state"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "dumpConsensusState", _this.createCallBasedMethod("dump_consensus_state"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "broadcastTxCommit", _this.createCallBasedMethod("broadcast_tx_commit"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "broadcastTxSync", _this.createCallBasedMethod("broadcast_tx_sync"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "broadcastTxAsync", _this.createCallBasedMethod("broadcast_tx_async"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "unconfirmedTxs", _this.createCallBasedMethod("unconfirmed_txs"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "numUnconfirmedTxs", _this.createCallBasedMethod("num_unconfirmed_txs"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "commit", _this.createCallBasedMethod("commit"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "tx", _this.createCallBasedMethod("tx"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "txSearch", _this.createCallBasedMethod("tx_search"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "abciQuery", _this.createCallBasedMethod("abci_query"));
        (0, $d6fbe7ac05ca377a$var$_defineProperty2["default"])((0, $d6fbe7ac05ca377a$var$_assertThisInitialized2["default"])(_this), "abciInfo", _this.createCallBasedMethod("abci_info"));
        var _url$parse = $d6fbe7ac05ca377a$var$_url["default"].parse(uriString), protocol = _url$parse.protocol, hostname = _url$parse.hostname, port = _url$parse.port; // default to http
        if (!protocol || !$d6fbe7ac05ca377a$var$allProtocols.includes(protocol)) {
            var uri = $d6fbe7ac05ca377a$var$_url["default"].parse("http://".concat(uriString));
            protocol = uri.protocol;
            hostname = uri.hostname;
            port = uri.port;
        }
        _this.uri = !port ? "".concat(protocol, "//").concat(hostname, "/") : "".concat(protocol, "//").concat(hostname, ":").concat(port, "/");
        if (protocol && $d6fbe7ac05ca377a$var$wsProtocols.includes(protocol)) {
            _this.uri = "".concat(_this.uri, "websocket");
            _this.call = _this.callWs;
            _this.connectWs();
        } else if (protocol && $d6fbe7ac05ca377a$var$httpProtocols.includes(protocol)) _this.call = _this.callHttp;
        return _this;
    }
    (0, $d6fbe7ac05ca377a$var$_createClass2["default"])(BaseRpc, [
        {
            key: "connectWs",
            value: function connectWs() {
                var _this2 = this;
                this.ws = new $d6fbe7ac05ca377a$var$_pumpify["default"].obj($d6fbe7ac05ca377a$var$_ndjson["default"].stringify(), (0, $d6fbe7ac05ca377a$var$_websocketStream["default"])(this.uri));
                this.ws.on("error", function(err) {
                    return _this2.emit("error", err);
                });
                this.ws.on("close", function() {
                    if (_this2.closed) return;
                    _this2.emit("error", Error("websocket disconnected"));
                });
                this.ws.on("data", function(data) {
                    data = JSON.parse(data);
                    if (!data.id) return;
                    _this2.emit(data.id, data.error, data.result);
                });
            }
        },
        {
            key: "callHttp",
            value: function callHttp(method, args) {
                var url = this.uri + method;
                url = $d6fbe7ac05ca377a$var$convertHttpArgs(url, args);
                return (0, $d6fbe7ac05ca377a$var$_axios["default"])({
                    url: url
                }).then(function(_ref) {
                    var data = _ref.data;
                    if (data.error) {
                        var err = Error(data.error.message);
                        Object.assign(err, data.error);
                        throw err;
                    }
                    return data.result;
                }, function(err) {
                    throw Error(err);
                });
            }
        },
        {
            key: "callWs",
            value: function callWs(method, args, listener) {
                var _this3 = this;
                var self = this;
                return new Promise(function(resolve, reject) {
                    var _this3$ws;
                    var id = Math.random().toString(36);
                    var params = $d6fbe7ac05ca377a$var$convertWsArgs(args);
                    if (method === "subscribe") {
                        if (typeof listener !== "function") throw Error("Must provide listener function");
                         // events get passed to listener
                        _this3.on(id + "#event", function(err, res) {
                            if (err) return self.emit("error", err);
                            return listener(res.data.value);
                        }); // promise resolves on successful subscription or error
                        _this3.on(id, function(err) {
                            if (err) return reject(err);
                            resolve();
                        });
                    } else // response goes to promise
                    _this3.once(id, function(err, res) {
                        if (err) return reject(err);
                        resolve(res);
                    });
                    (_this3$ws = _this3.ws) === null || _this3$ws === void 0 || _this3$ws.write({
                        jsonrpc: "2.0",
                        id: id,
                        method: method,
                        params: params
                    });
                });
            }
        },
        {
            key: "close",
            value: function close() {
                this.closed = true;
                if (!this.ws) return;
                this.ws.destroy();
            }
        }
    ]);
    return BaseRpc;
}($jMc9N.EventEmitter);
module.exports["default"] = $d6fbe7ac05ca377a$var$BaseRpc;

});
parcelRegister("e1HjZ", function(module, exports) {

var $hgxrz = parcelRequire("hgxrz");

var $l0GeG = parcelRequire("l0GeG");

var $9GD6K = parcelRequire("9GD6K");
var $a362c369833b4d8e$require$EOL = $9GD6K.EOL;

var $c2s0i = parcelRequire("c2s0i");
module.exports = $a362c369833b4d8e$var$parse;
module.exports.serialize = module.exports.stringify = $a362c369833b4d8e$var$serialize;
module.exports.parse = $a362c369833b4d8e$var$parse;
function $a362c369833b4d8e$var$parse(opts) {
    opts = opts || {};
    opts.strict = opts.strict !== false;
    function parseRow(row) {
        try {
            if (row) return JSON.parse(row);
        } catch (e) {
            if (opts.strict) this.emit("error", new Error("Could not parse row " + row.slice(0, 50) + "..."));
        }
    }
    return $l0GeG(parseRow, opts);
}
function $a362c369833b4d8e$var$serialize(opts) {
    return $hgxrz.obj(opts, function(obj, enc, cb) {
        cb(null, $c2s0i(obj) + $a362c369833b4d8e$require$EOL);
    });
}

});
parcelRegister("hgxrz", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $43A2Q = parcelRequire("43A2Q");
var $c91ddf831a9c89fd$require$Transform = $43A2Q.Transform;

var $4zyeF = parcelRequire("4zyeF");
var $c91ddf831a9c89fd$require$inherits = $4zyeF.inherits;

var $57907 = parcelRequire("57907");
function $c91ddf831a9c89fd$var$DestroyableTransform(opts) {
    $c91ddf831a9c89fd$require$Transform.call(this, opts);
    this._destroyed = false;
}
$c91ddf831a9c89fd$require$inherits($c91ddf831a9c89fd$var$DestroyableTransform, $c91ddf831a9c89fd$require$Transform);
$c91ddf831a9c89fd$var$DestroyableTransform.prototype.destroy = function(err) {
    if (this._destroyed) return;
    this._destroyed = true;
    var self = this;
    $4TNnu.nextTick(function() {
        if (err) self.emit("error", err);
        self.emit("close");
    });
};
// a noop _transform function
function $c91ddf831a9c89fd$var$noop(chunk, enc, callback) {
    callback(null, chunk);
}
// create a new export function, used by both the main export and
// the .ctor export, contains common logic for dealing with arguments
function $c91ddf831a9c89fd$var$through2(construct) {
    return function(options, transform, flush) {
        if (typeof options == "function") {
            flush = transform;
            transform = options;
            options = {};
        }
        if (typeof transform != "function") transform = $c91ddf831a9c89fd$var$noop;
        if (typeof flush != "function") flush = null;
        return construct(options, transform, flush);
    };
}
// main export, just make me a transform stream!
module.exports = $c91ddf831a9c89fd$var$through2(function(options, transform, flush) {
    var t2 = new $c91ddf831a9c89fd$var$DestroyableTransform(options);
    t2._transform = transform;
    if (flush) t2._flush = flush;
    return t2;
});
// make me a reusable prototype that I can `new`, or implicitly `new`
// with a constructor call
module.exports.ctor = $c91ddf831a9c89fd$var$through2(function(options, transform, flush) {
    function Through2(override) {
        if (!(this instanceof Through2)) return new Through2(override);
        this.options = $57907(options, override);
        $c91ddf831a9c89fd$var$DestroyableTransform.call(this, this.options);
    }
    $c91ddf831a9c89fd$require$inherits(Through2, $c91ddf831a9c89fd$var$DestroyableTransform);
    Through2.prototype._transform = transform;
    if (flush) Through2.prototype._flush = flush;
    return Through2;
});
module.exports.obj = $c91ddf831a9c89fd$var$through2(function(options, transform, flush) {
    var t2 = new $c91ddf831a9c89fd$var$DestroyableTransform($57907({
        objectMode: true,
        highWaterMark: 16
    }, options));
    t2._transform = transform;
    if (flush) t2._flush = flush;
    return t2;
});

});
parcelRegister("43A2Q", function(module, exports) {

exports = module.exports = (parcelRequire("2jtx7"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("7Qh3f"));

exports.Duplex = (parcelRequire("2Al3B"));

exports.Transform = (parcelRequire("fU4hb"));

exports.PassThrough = (parcelRequire("1xTWy"));

});
parcelRegister("2jtx7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $1af443cbfdf2bd44$var$Readable;

var $9ILyq = parcelRequire("9ILyq");
/*</replacement>*/ /*<replacement>*/ var $1af443cbfdf2bd44$var$Duplex;
/*</replacement>*/ $1af443cbfdf2bd44$var$Readable.ReadableState = $1af443cbfdf2bd44$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $1af443cbfdf2bd44$require$EE = $jMc9N.EventEmitter;
var $1af443cbfdf2bd44$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $4x1AF = parcelRequire("4x1AF");

var $6mw0j = parcelRequire("6mw0j");
var $1af443cbfdf2bd44$require$Buffer = $6mw0j.Buffer;
var $1af443cbfdf2bd44$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $1af443cbfdf2bd44$var$_uint8ArrayToBuffer(chunk) {
    return $1af443cbfdf2bd44$require$Buffer.from(chunk);
}
function $1af443cbfdf2bd44$var$_isUint8Array(obj) {
    return $1af443cbfdf2bd44$require$Buffer.isBuffer(obj) || obj instanceof $1af443cbfdf2bd44$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $1af443cbfdf2bd44$var$util = Object.create((parcelRequire("iItjM")));

$1af443cbfdf2bd44$var$util.inherits = (parcelRequire("eSHUL"));

var $5Io6y = parcelRequire("5Io6y");
var $1af443cbfdf2bd44$var$debug = void 0;
if ($5Io6y && $5Io6y.debuglog) $1af443cbfdf2bd44$var$debug = $5Io6y.debuglog("stream");
else $1af443cbfdf2bd44$var$debug = function() {};

var $60B9X = parcelRequire("60B9X");

var $jFyt4 = parcelRequire("jFyt4");
var $1af443cbfdf2bd44$var$StringDecoder;
$1af443cbfdf2bd44$var$util.inherits($1af443cbfdf2bd44$var$Readable, $4x1AF);
var $1af443cbfdf2bd44$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $1af443cbfdf2bd44$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($9ILyq(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $1af443cbfdf2bd44$var$ReadableState(options, stream) {
    $1af443cbfdf2bd44$var$Duplex = $1af443cbfdf2bd44$var$Duplex || (parcelRequire("2Al3B"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $1af443cbfdf2bd44$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $60B9X();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$1af443cbfdf2bd44$var$StringDecoder) $1af443cbfdf2bd44$var$StringDecoder = (parcelRequire("5ZLII")).StringDecoder;
        this.decoder = new $1af443cbfdf2bd44$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $1af443cbfdf2bd44$var$Readable(options) {
    $1af443cbfdf2bd44$var$Duplex = $1af443cbfdf2bd44$var$Duplex || (parcelRequire("2Al3B"));
    if (!(this instanceof $1af443cbfdf2bd44$var$Readable)) return new $1af443cbfdf2bd44$var$Readable(options);
    this._readableState = new $1af443cbfdf2bd44$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $4x1AF.call(this);
}
Object.defineProperty($1af443cbfdf2bd44$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$1af443cbfdf2bd44$var$Readable.prototype.destroy = $jFyt4.destroy;
$1af443cbfdf2bd44$var$Readable.prototype._undestroy = $jFyt4.undestroy;
$1af443cbfdf2bd44$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$1af443cbfdf2bd44$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $1af443cbfdf2bd44$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $1af443cbfdf2bd44$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$1af443cbfdf2bd44$var$Readable.prototype.unshift = function(chunk) {
    return $1af443cbfdf2bd44$var$readableAddChunk(this, chunk, null, true, false);
};
function $1af443cbfdf2bd44$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $1af443cbfdf2bd44$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $1af443cbfdf2bd44$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $1af443cbfdf2bd44$require$Buffer.prototype) chunk = $1af443cbfdf2bd44$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $1af443cbfdf2bd44$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $1af443cbfdf2bd44$var$addChunk(stream, state, chunk, false);
                    else $1af443cbfdf2bd44$var$maybeReadMore(stream, state);
                } else $1af443cbfdf2bd44$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $1af443cbfdf2bd44$var$needMoreData(state);
}
function $1af443cbfdf2bd44$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $1af443cbfdf2bd44$var$emitReadable(stream);
    }
    $1af443cbfdf2bd44$var$maybeReadMore(stream, state);
}
function $1af443cbfdf2bd44$var$chunkInvalid(state, chunk) {
    var er;
    if (!$1af443cbfdf2bd44$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $1af443cbfdf2bd44$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$1af443cbfdf2bd44$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$1af443cbfdf2bd44$var$Readable.prototype.setEncoding = function(enc) {
    if (!$1af443cbfdf2bd44$var$StringDecoder) $1af443cbfdf2bd44$var$StringDecoder = (parcelRequire("5ZLII")).StringDecoder;
    this._readableState.decoder = new $1af443cbfdf2bd44$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $1af443cbfdf2bd44$var$MAX_HWM = 0x800000;
function $1af443cbfdf2bd44$var$computeNewHighWaterMark(n) {
    if (n >= $1af443cbfdf2bd44$var$MAX_HWM) n = $1af443cbfdf2bd44$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1af443cbfdf2bd44$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $1af443cbfdf2bd44$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$1af443cbfdf2bd44$var$Readable.prototype.read = function(n) {
    $1af443cbfdf2bd44$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $1af443cbfdf2bd44$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $1af443cbfdf2bd44$var$endReadable(this);
        else $1af443cbfdf2bd44$var$emitReadable(this);
        return null;
    }
    n = $1af443cbfdf2bd44$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $1af443cbfdf2bd44$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $1af443cbfdf2bd44$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $1af443cbfdf2bd44$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $1af443cbfdf2bd44$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $1af443cbfdf2bd44$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $1af443cbfdf2bd44$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $1af443cbfdf2bd44$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $1af443cbfdf2bd44$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $1af443cbfdf2bd44$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $1af443cbfdf2bd44$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $1af443cbfdf2bd44$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $1af443cbfdf2bd44$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kEUYA.nextTick($1af443cbfdf2bd44$var$emitReadable_, stream);
        else $1af443cbfdf2bd44$var$emitReadable_(stream);
    }
}
function $1af443cbfdf2bd44$var$emitReadable_(stream) {
    $1af443cbfdf2bd44$var$debug("emit readable");
    stream.emit("readable");
    $1af443cbfdf2bd44$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $1af443cbfdf2bd44$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kEUYA.nextTick($1af443cbfdf2bd44$var$maybeReadMore_, stream, state);
    }
}
function $1af443cbfdf2bd44$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $1af443cbfdf2bd44$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$1af443cbfdf2bd44$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$1af443cbfdf2bd44$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $1af443cbfdf2bd44$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kEUYA.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $1af443cbfdf2bd44$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $1af443cbfdf2bd44$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $1af443cbfdf2bd44$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $1af443cbfdf2bd44$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $1af443cbfdf2bd44$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $1af443cbfdf2bd44$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $1af443cbfdf2bd44$var$debug("false write response, pause", src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $1af443cbfdf2bd44$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($1af443cbfdf2bd44$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $1af443cbfdf2bd44$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $1af443cbfdf2bd44$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $1af443cbfdf2bd44$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $1af443cbfdf2bd44$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $1af443cbfdf2bd44$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $1af443cbfdf2bd44$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $1af443cbfdf2bd44$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $1af443cbfdf2bd44$var$flow(src);
        }
    };
}
$1af443cbfdf2bd44$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, unpipeInfo);
        return this;
    }
    // try to find the right one.
    var index = $1af443cbfdf2bd44$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$1af443cbfdf2bd44$var$Readable.prototype.on = function(ev, fn) {
    var res = $4x1AF.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kEUYA.nextTick($1af443cbfdf2bd44$var$nReadingNextTick, this);
            else if (state.length) $1af443cbfdf2bd44$var$emitReadable(this);
        }
    }
    return res;
};
$1af443cbfdf2bd44$var$Readable.prototype.addListener = $1af443cbfdf2bd44$var$Readable.prototype.on;
function $1af443cbfdf2bd44$var$nReadingNextTick(self) {
    $1af443cbfdf2bd44$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$1af443cbfdf2bd44$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $1af443cbfdf2bd44$var$debug("resume");
        state.flowing = true;
        $1af443cbfdf2bd44$var$resume(this, state);
    }
    return this;
};
function $1af443cbfdf2bd44$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kEUYA.nextTick($1af443cbfdf2bd44$var$resume_, stream, state);
    }
}
function $1af443cbfdf2bd44$var$resume_(stream, state) {
    if (!state.reading) {
        $1af443cbfdf2bd44$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $1af443cbfdf2bd44$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$1af443cbfdf2bd44$var$Readable.prototype.pause = function() {
    $1af443cbfdf2bd44$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $1af443cbfdf2bd44$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $1af443cbfdf2bd44$var$flow(stream) {
    var state = stream._readableState;
    $1af443cbfdf2bd44$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$1af443cbfdf2bd44$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $1af443cbfdf2bd44$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $1af443cbfdf2bd44$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $1af443cbfdf2bd44$var$kProxyEvents.length; n++)stream.on($1af443cbfdf2bd44$var$kProxyEvents[n], this.emit.bind(this, $1af443cbfdf2bd44$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $1af443cbfdf2bd44$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($1af443cbfdf2bd44$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$1af443cbfdf2bd44$var$Readable._fromList = $1af443cbfdf2bd44$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1af443cbfdf2bd44$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $1af443cbfdf2bd44$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1af443cbfdf2bd44$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $1af443cbfdf2bd44$var$copyFromBufferString(n, list) : $1af443cbfdf2bd44$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1af443cbfdf2bd44$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $1af443cbfdf2bd44$var$copyFromBuffer(n, list) {
    var ret = $1af443cbfdf2bd44$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $1af443cbfdf2bd44$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kEUYA.nextTick($1af443cbfdf2bd44$var$endReadableNT, state, stream);
    }
}
function $1af443cbfdf2bd44$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $1af443cbfdf2bd44$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kEUYA", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";
if (typeof $4TNnu === "undefined" || !$4TNnu.version || $4TNnu.version.indexOf("v0.") === 0 || $4TNnu.version.indexOf("v1.") === 0 && $4TNnu.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: $f0a3bd5c7cdf9bcd$var$nextTick
};
else module.exports = $4TNnu;
function $f0a3bd5c7cdf9bcd$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4TNnu.nextTick(fn);
        case 2:
            return $4TNnu.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4TNnu.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4TNnu.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4TNnu.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("9ILyq", function(module, exports) {
var $713d1c6c66d58098$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $713d1c6c66d58098$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("4x1AF", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("6mw0j", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $4a1d9f7e6a99afe2$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $4a1d9f7e6a99afe2$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($4a1d9f7e6a99afe2$var$Buffer.from && $4a1d9f7e6a99afe2$var$Buffer.alloc && $4a1d9f7e6a99afe2$var$Buffer.allocUnsafe && $4a1d9f7e6a99afe2$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $4a1d9f7e6a99afe2$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $4a1d9f7e6a99afe2$var$SafeBuffer;
}
function $4a1d9f7e6a99afe2$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $4a1d9f7e6a99afe2$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$4a1d9f7e6a99afe2$var$copyProps($4a1d9f7e6a99afe2$var$Buffer, $4a1d9f7e6a99afe2$var$SafeBuffer);
$4a1d9f7e6a99afe2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $4a1d9f7e6a99afe2$var$Buffer(arg, encodingOrOffset, length);
};
$4a1d9f7e6a99afe2$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $4a1d9f7e6a99afe2$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$4a1d9f7e6a99afe2$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $4a1d9f7e6a99afe2$var$Buffer(size);
};
$4a1d9f7e6a99afe2$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});

parcelRegister("iItjM", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $da031406cd389190$export$43bee75e5e14138e; }, function (v) { return $da031406cd389190$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $da031406cd389190$export$f9ce7b637dfbe238; }, function (v) { return $da031406cd389190$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $da031406cd389190$export$630801d484da15df; }, function (v) { return $da031406cd389190$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $da031406cd389190$export$bedb7023a7733221; }, function (v) { return $da031406cd389190$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $da031406cd389190$export$7e4aa119212bc614; }, function (v) { return $da031406cd389190$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $da031406cd389190$export$844ec244b1367d54; }, function (v) { return $da031406cd389190$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $da031406cd389190$export$a244864fd9645c7f; }, function (v) { return $da031406cd389190$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $da031406cd389190$export$fce6876652108ab; }, function (v) { return $da031406cd389190$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $da031406cd389190$export$49841c62b9eff15; }, function (v) { return $da031406cd389190$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $da031406cd389190$export$a6cdc56e425d0d0a; }, function (v) { return $da031406cd389190$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $da031406cd389190$export$871608497c498473; }, function (v) { return $da031406cd389190$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $da031406cd389190$export$e6127cc7fe7395c3; }, function (v) { return $da031406cd389190$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $da031406cd389190$export$f6e2535fb5126e54; }, function (v) { return $da031406cd389190$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $da031406cd389190$export$c3825b437cbdea5c; }, function (v) { return $da031406cd389190$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $da031406cd389190$export$a7884ebc965f8f54; }, function (v) { return $da031406cd389190$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $da031406cd389190$export$43bee75e5e14138e;
var $da031406cd389190$export$f9ce7b637dfbe238;
var $da031406cd389190$export$630801d484da15df;
var $da031406cd389190$export$bedb7023a7733221;
var $da031406cd389190$export$7e4aa119212bc614;
var $da031406cd389190$export$844ec244b1367d54;
var $da031406cd389190$export$a244864fd9645c7f;
var $da031406cd389190$export$fce6876652108ab;
var $da031406cd389190$export$49841c62b9eff15;
var $da031406cd389190$export$a6cdc56e425d0d0a;
var $da031406cd389190$export$871608497c498473;
var $da031406cd389190$export$e6127cc7fe7395c3;
var $da031406cd389190$export$f6e2535fb5126e54;
var $da031406cd389190$export$c3825b437cbdea5c;
var $da031406cd389190$export$a7884ebc965f8f54;

var $ihoyg = parcelRequire("ihoyg");
var $da031406cd389190$require$Buffer = $ihoyg.Buffer;
function $da031406cd389190$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $da031406cd389190$var$objectToString(arg) === "[object Array]";
}
$da031406cd389190$export$43bee75e5e14138e = $da031406cd389190$var$isArray;
function $da031406cd389190$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$da031406cd389190$export$f9ce7b637dfbe238 = $da031406cd389190$var$isBoolean;
function $da031406cd389190$var$isNull(arg) {
    return arg === null;
}
$da031406cd389190$export$630801d484da15df = $da031406cd389190$var$isNull;
function $da031406cd389190$var$isNullOrUndefined(arg) {
    return arg == null;
}
$da031406cd389190$export$bedb7023a7733221 = $da031406cd389190$var$isNullOrUndefined;
function $da031406cd389190$var$isNumber(arg) {
    return typeof arg === "number";
}
$da031406cd389190$export$7e4aa119212bc614 = $da031406cd389190$var$isNumber;
function $da031406cd389190$var$isString(arg) {
    return typeof arg === "string";
}
$da031406cd389190$export$844ec244b1367d54 = $da031406cd389190$var$isString;
function $da031406cd389190$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$da031406cd389190$export$a244864fd9645c7f = $da031406cd389190$var$isSymbol;
function $da031406cd389190$var$isUndefined(arg) {
    return arg === void 0;
}
$da031406cd389190$export$fce6876652108ab = $da031406cd389190$var$isUndefined;
function $da031406cd389190$var$isRegExp(re) {
    return $da031406cd389190$var$objectToString(re) === "[object RegExp]";
}
$da031406cd389190$export$49841c62b9eff15 = $da031406cd389190$var$isRegExp;
function $da031406cd389190$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$da031406cd389190$export$a6cdc56e425d0d0a = $da031406cd389190$var$isObject;
function $da031406cd389190$var$isDate(d) {
    return $da031406cd389190$var$objectToString(d) === "[object Date]";
}
$da031406cd389190$export$871608497c498473 = $da031406cd389190$var$isDate;
function $da031406cd389190$var$isError(e) {
    return $da031406cd389190$var$objectToString(e) === "[object Error]" || e instanceof Error;
}
$da031406cd389190$export$e6127cc7fe7395c3 = $da031406cd389190$var$isError;
function $da031406cd389190$var$isFunction(arg) {
    return typeof arg === "function";
}
$da031406cd389190$export$f6e2535fb5126e54 = $da031406cd389190$var$isFunction;
function $da031406cd389190$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$da031406cd389190$export$c3825b437cbdea5c = $da031406cd389190$var$isPrimitive;
$da031406cd389190$export$a7884ebc965f8f54 = $da031406cd389190$require$Buffer.isBuffer;
function $da031406cd389190$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("60B9X", function(module, exports) {
"use strict";
function $45ff9145ce699b3a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $6mw0j = parcelRequire("6mw0j");
var $45ff9145ce699b3a$require$Buffer = $6mw0j.Buffer;

var $5Io6y = parcelRequire("5Io6y");
function $45ff9145ce699b3a$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $45ff9145ce699b3a$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $45ff9145ce699b3a$require$Buffer.alloc(0);
        if (this.length === 1) return this.head.data;
        var ret = $45ff9145ce699b3a$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $45ff9145ce699b3a$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($5Io6y && $5Io6y.inspect && $5Io6y.inspect.custom) module.exports.prototype[$5Io6y.inspect.custom] = function() {
    var obj = $5Io6y.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("jFyt4", function(module, exports) {
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $e51c9543e75d3cf3$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err && (!this._writableState || !this._writableState.errorEmitted)) $kEUYA.nextTick($e51c9543e75d3cf3$var$emitErrorNT, this, err);
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            $kEUYA.nextTick($e51c9543e75d3cf3$var$emitErrorNT, _this, err);
            if (_this._writableState) _this._writableState.errorEmitted = true;
        } else if (cb) cb(err);
    });
    return this;
}
function $e51c9543e75d3cf3$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $e51c9543e75d3cf3$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $e51c9543e75d3cf3$var$destroy,
    undestroy: $e51c9543e75d3cf3$var$undestroy
};

});

parcelRegister("2Al3B", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ /*<replacement>*/ var $1e1f4711325e7f68$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $1e1f4711325e7f68$var$Duplex;

/*<replacement>*/ var $1e1f4711325e7f68$var$util = Object.create((parcelRequire("iItjM")));

$1e1f4711325e7f68$var$util.inherits = (parcelRequire("eSHUL"));

var $2jtx7 = parcelRequire("2jtx7");

var $7Qh3f = parcelRequire("7Qh3f");
$1e1f4711325e7f68$var$util.inherits($1e1f4711325e7f68$var$Duplex, $2jtx7);
// avoid scope creep, the keys array can then be collected
var $1e1f4711325e7f68$var$keys = $1e1f4711325e7f68$var$objectKeys($7Qh3f.prototype);
for(var $1e1f4711325e7f68$var$v = 0; $1e1f4711325e7f68$var$v < $1e1f4711325e7f68$var$keys.length; $1e1f4711325e7f68$var$v++){
    var $1e1f4711325e7f68$var$method = $1e1f4711325e7f68$var$keys[$1e1f4711325e7f68$var$v];
    if (!$1e1f4711325e7f68$var$Duplex.prototype[$1e1f4711325e7f68$var$method]) $1e1f4711325e7f68$var$Duplex.prototype[$1e1f4711325e7f68$var$method] = $7Qh3f.prototype[$1e1f4711325e7f68$var$method];
}
function $1e1f4711325e7f68$var$Duplex(options) {
    if (!(this instanceof $1e1f4711325e7f68$var$Duplex)) return new $1e1f4711325e7f68$var$Duplex(options);
    $2jtx7.call(this, options);
    $7Qh3f.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $1e1f4711325e7f68$var$onend);
}
Object.defineProperty($1e1f4711325e7f68$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $1e1f4711325e7f68$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kEUYA.nextTick($1e1f4711325e7f68$var$onEndNT, this);
}
function $1e1f4711325e7f68$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($1e1f4711325e7f68$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$1e1f4711325e7f68$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kEUYA.nextTick(cb, err);
};

});
parcelRegister("7Qh3f", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $5b5a9dcdeeb95096$var$Writable;
/* <replacement> */ function $5b5a9dcdeeb95096$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5b5a9dcdeeb95096$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5b5a9dcdeeb95096$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5b5a9dcdeeb95096$var$asyncWrite = (0, $kEUYA.nextTick);
/*</replacement>*/ /*<replacement>*/ var $5b5a9dcdeeb95096$var$Duplex;
/*</replacement>*/ $5b5a9dcdeeb95096$var$Writable.WritableState = $5b5a9dcdeeb95096$var$WritableState;

/*<replacement>*/ var $5b5a9dcdeeb95096$var$util = Object.create((parcelRequire("iItjM")));

$5b5a9dcdeeb95096$var$util.inherits = (parcelRequire("eSHUL"));

/*</replacement>*/ /*<replacement>*/ var $5b5a9dcdeeb95096$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $4x1AF = parcelRequire("4x1AF");

var $6mw0j = parcelRequire("6mw0j");
var $5b5a9dcdeeb95096$require$Buffer = $6mw0j.Buffer;
var $5b5a9dcdeeb95096$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $5b5a9dcdeeb95096$var$_uint8ArrayToBuffer(chunk) {
    return $5b5a9dcdeeb95096$require$Buffer.from(chunk);
}
function $5b5a9dcdeeb95096$var$_isUint8Array(obj) {
    return $5b5a9dcdeeb95096$require$Buffer.isBuffer(obj) || obj instanceof $5b5a9dcdeeb95096$var$OurUint8Array;
}

var $jFyt4 = parcelRequire("jFyt4");
$5b5a9dcdeeb95096$var$util.inherits($5b5a9dcdeeb95096$var$Writable, $4x1AF);
function $5b5a9dcdeeb95096$var$nop() {}

function $5b5a9dcdeeb95096$var$WritableState(options, stream) {
    $5b5a9dcdeeb95096$var$Duplex = $5b5a9dcdeeb95096$var$Duplex || (parcelRequire("2Al3B"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $5b5a9dcdeeb95096$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5b5a9dcdeeb95096$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5b5a9dcdeeb95096$var$CorkedRequest(this);
}
$5b5a9dcdeeb95096$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5b5a9dcdeeb95096$var$WritableState.prototype, "buffer", {
            get: $5b5a9dcdeeb95096$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5b5a9dcdeeb95096$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5b5a9dcdeeb95096$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5b5a9dcdeeb95096$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($5b5a9dcdeeb95096$var$realHasInstance.call(this, object)) return true;
            if (this !== $5b5a9dcdeeb95096$var$Writable) return false;
            return object && object._writableState instanceof $5b5a9dcdeeb95096$var$WritableState;
        }
    });
} else $5b5a9dcdeeb95096$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $5b5a9dcdeeb95096$var$Writable(options) {
    $5b5a9dcdeeb95096$var$Duplex = $5b5a9dcdeeb95096$var$Duplex || (parcelRequire("2Al3B"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$5b5a9dcdeeb95096$var$realHasInstance.call($5b5a9dcdeeb95096$var$Writable, this) && !(this instanceof $5b5a9dcdeeb95096$var$Duplex)) return new $5b5a9dcdeeb95096$var$Writable(options);
    this._writableState = new $5b5a9dcdeeb95096$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $4x1AF.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5b5a9dcdeeb95096$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $5b5a9dcdeeb95096$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $kEUYA.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5b5a9dcdeeb95096$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $kEUYA.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$5b5a9dcdeeb95096$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5b5a9dcdeeb95096$var$_isUint8Array(chunk);
    if (isBuf && !$5b5a9dcdeeb95096$require$Buffer.isBuffer(chunk)) chunk = $5b5a9dcdeeb95096$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5b5a9dcdeeb95096$var$nop;
    if (state.ended) $5b5a9dcdeeb95096$var$writeAfterEnd(this, cb);
    else if (isBuf || $5b5a9dcdeeb95096$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5b5a9dcdeeb95096$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5b5a9dcdeeb95096$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$5b5a9dcdeeb95096$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $5b5a9dcdeeb95096$var$clearBuffer(this, state);
    }
};
$5b5a9dcdeeb95096$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $5b5a9dcdeeb95096$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5b5a9dcdeeb95096$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5b5a9dcdeeb95096$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5b5a9dcdeeb95096$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5b5a9dcdeeb95096$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5b5a9dcdeeb95096$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5b5a9dcdeeb95096$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5b5a9dcdeeb95096$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kEUYA.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kEUYA.nextTick($5b5a9dcdeeb95096$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $5b5a9dcdeeb95096$var$finishMaybe(stream, state);
    }
}
function $5b5a9dcdeeb95096$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5b5a9dcdeeb95096$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $5b5a9dcdeeb95096$var$onwriteStateUpdate(state);
    if (er) $5b5a9dcdeeb95096$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5b5a9dcdeeb95096$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5b5a9dcdeeb95096$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $5b5a9dcdeeb95096$var$asyncWrite($5b5a9dcdeeb95096$var$afterWrite, stream, state, finished, cb);
        else $5b5a9dcdeeb95096$var$afterWrite(stream, state, finished, cb);
    }
}
function $5b5a9dcdeeb95096$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5b5a9dcdeeb95096$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5b5a9dcdeeb95096$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5b5a9dcdeeb95096$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5b5a9dcdeeb95096$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5b5a9dcdeeb95096$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5b5a9dcdeeb95096$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5b5a9dcdeeb95096$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5b5a9dcdeeb95096$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$5b5a9dcdeeb95096$var$Writable.prototype._writev = null;
$5b5a9dcdeeb95096$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $5b5a9dcdeeb95096$var$endWritable(this, state, cb);
};
function $5b5a9dcdeeb95096$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5b5a9dcdeeb95096$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5b5a9dcdeeb95096$var$finishMaybe(stream, state);
    });
}
function $5b5a9dcdeeb95096$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $kEUYA.nextTick($5b5a9dcdeeb95096$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5b5a9dcdeeb95096$var$finishMaybe(stream, state) {
    var need = $5b5a9dcdeeb95096$var$needFinish(state);
    if (need) {
        $5b5a9dcdeeb95096$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $5b5a9dcdeeb95096$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5b5a9dcdeeb95096$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kEUYA.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5b5a9dcdeeb95096$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    if (state.corkedRequestsFree) state.corkedRequestsFree.next = corkReq;
    else state.corkedRequestsFree = corkReq;
}
Object.defineProperty($5b5a9dcdeeb95096$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5b5a9dcdeeb95096$var$Writable.prototype.destroy = $jFyt4.destroy;
$5b5a9dcdeeb95096$var$Writable.prototype._undestroy = $jFyt4.undestroy;
$5b5a9dcdeeb95096$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("5ZLII", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $45d7aa7f94faf082$export$63a7aa211a91ed69; }, function (v) { return $45d7aa7f94faf082$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $45d7aa7f94faf082$export$63a7aa211a91ed69;
"use strict";

var $6mw0j = parcelRequire("6mw0j");
var $45d7aa7f94faf082$require$Buffer = $6mw0j.Buffer;
/*</replacement>*/ var $45d7aa7f94faf082$var$isEncoding = $45d7aa7f94faf082$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $45d7aa7f94faf082$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $45d7aa7f94faf082$var$normalizeEncoding(enc) {
    var nenc = $45d7aa7f94faf082$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($45d7aa7f94faf082$require$Buffer.isEncoding === $45d7aa7f94faf082$var$isEncoding || !$45d7aa7f94faf082$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$45d7aa7f94faf082$export$63a7aa211a91ed69 = $45d7aa7f94faf082$var$StringDecoder;
function $45d7aa7f94faf082$var$StringDecoder(encoding) {
    this.encoding = $45d7aa7f94faf082$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $45d7aa7f94faf082$var$utf16Text;
            this.end = $45d7aa7f94faf082$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $45d7aa7f94faf082$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $45d7aa7f94faf082$var$base64Text;
            this.end = $45d7aa7f94faf082$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $45d7aa7f94faf082$var$simpleWrite;
            this.end = $45d7aa7f94faf082$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $45d7aa7f94faf082$require$Buffer.allocUnsafe(nb);
}
$45d7aa7f94faf082$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$45d7aa7f94faf082$var$StringDecoder.prototype.end = $45d7aa7f94faf082$var$utf8End;
// Returns only complete characters in a Buffer
$45d7aa7f94faf082$var$StringDecoder.prototype.text = $45d7aa7f94faf082$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$45d7aa7f94faf082$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $45d7aa7f94faf082$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $45d7aa7f94faf082$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $45d7aa7f94faf082$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $45d7aa7f94faf082$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $45d7aa7f94faf082$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $45d7aa7f94faf082$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $45d7aa7f94faf082$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $45d7aa7f94faf082$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $45d7aa7f94faf082$var$utf8Text(buf, i) {
    var total = $45d7aa7f94faf082$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $45d7aa7f94faf082$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $45d7aa7f94faf082$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $45d7aa7f94faf082$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $45d7aa7f94faf082$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $45d7aa7f94faf082$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $45d7aa7f94faf082$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $45d7aa7f94faf082$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});


parcelRegister("fU4hb", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $b93f672770af38b3$var$Transform;

var $2Al3B = parcelRequire("2Al3B");

/*<replacement>*/ var $b93f672770af38b3$var$util = Object.create((parcelRequire("iItjM")));

$b93f672770af38b3$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $b93f672770af38b3$var$util.inherits($b93f672770af38b3$var$Transform, $2Al3B);
function $b93f672770af38b3$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $b93f672770af38b3$var$Transform(options) {
    if (!(this instanceof $b93f672770af38b3$var$Transform)) return new $b93f672770af38b3$var$Transform(options);
    $2Al3B.call(this, options);
    this._transformState = {
        afterTransform: $b93f672770af38b3$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $b93f672770af38b3$var$prefinish);
}
function $b93f672770af38b3$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $b93f672770af38b3$var$done(_this, er, data);
    });
    else $b93f672770af38b3$var$done(this, null, null);
}
$b93f672770af38b3$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $2Al3B.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$b93f672770af38b3$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$b93f672770af38b3$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$b93f672770af38b3$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$b93f672770af38b3$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $2Al3B.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $b93f672770af38b3$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("1xTWy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $120444b241c45553$var$PassThrough;

var $fU4hb = parcelRequire("fU4hb");

/*<replacement>*/ var $120444b241c45553$var$util = Object.create((parcelRequire("iItjM")));

$120444b241c45553$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $120444b241c45553$var$util.inherits($120444b241c45553$var$PassThrough, $fU4hb);
function $120444b241c45553$var$PassThrough(options) {
    if (!(this instanceof $120444b241c45553$var$PassThrough)) return new $120444b241c45553$var$PassThrough(options);
    $fU4hb.call(this, options);
}
$120444b241c45553$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("4zyeF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
var $3544fccbcc6ce858$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $3544fccbcc6ce858$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$3544fccbcc6ce858$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($3544fccbcc6ce858$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($3544fccbcc6ce858$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($3544fccbcc6ce858$var$isNull(x) || !$3544fccbcc6ce858$var$isObject(x)) str += " " + x;
    else str += " " + $3544fccbcc6ce858$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $4TNnu !== "undefined" && $4TNnu.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $4TNnu === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($4TNnu.throwDeprecation) throw new Error(msg);
            else if ($4TNnu.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $3544fccbcc6ce858$var$debugs = {};
var $3544fccbcc6ce858$var$debugEnvRegex = /^$/;
var $3544fccbcc6ce858$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$3544fccbcc6ce858$var$debugs[set]) {
        if ($3544fccbcc6ce858$var$debugEnvRegex.test(set)) {
            var pid = $4TNnu.pid;
            $3544fccbcc6ce858$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $3544fccbcc6ce858$var$debugs[set] = function() {};
    }
    return $3544fccbcc6ce858$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $3544fccbcc6ce858$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $3544fccbcc6ce858$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($3544fccbcc6ce858$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($3544fccbcc6ce858$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($3544fccbcc6ce858$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $3544fccbcc6ce858$var$stylizeWithColor;
    return $3544fccbcc6ce858$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $3544fccbcc6ce858$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$3544fccbcc6ce858$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$3544fccbcc6ce858$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $3544fccbcc6ce858$var$stylizeWithColor(str, styleType) {
    var style = $3544fccbcc6ce858$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $3544fccbcc6ce858$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $3544fccbcc6ce858$var$inspect.colors[style][1] + "m";
    else return str;
}
function $3544fccbcc6ce858$var$stylizeNoColor(str, styleType) {
    return str;
}
function $3544fccbcc6ce858$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $3544fccbcc6ce858$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $3544fccbcc6ce858$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$3544fccbcc6ce858$var$isString(ret)) ret = $3544fccbcc6ce858$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $3544fccbcc6ce858$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $3544fccbcc6ce858$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($3544fccbcc6ce858$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $3544fccbcc6ce858$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($3544fccbcc6ce858$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($3544fccbcc6ce858$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($3544fccbcc6ce858$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($3544fccbcc6ce858$var$isError(value)) return $3544fccbcc6ce858$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($3544fccbcc6ce858$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($3544fccbcc6ce858$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($3544fccbcc6ce858$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($3544fccbcc6ce858$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($3544fccbcc6ce858$var$isError(value)) base = " " + $3544fccbcc6ce858$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($3544fccbcc6ce858$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $3544fccbcc6ce858$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $3544fccbcc6ce858$var$reduceToSingleString(output, base, braces);
}
function $3544fccbcc6ce858$var$formatPrimitive(ctx, value) {
    if ($3544fccbcc6ce858$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($3544fccbcc6ce858$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($3544fccbcc6ce858$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($3544fccbcc6ce858$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($3544fccbcc6ce858$var$isNull(value)) return ctx.stylize("null", "null");
}
function $3544fccbcc6ce858$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $3544fccbcc6ce858$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($3544fccbcc6ce858$var$hasOwnProperty(value, String(i))) output.push($3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $3544fccbcc6ce858$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$3544fccbcc6ce858$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($3544fccbcc6ce858$var$isNull(recurseTimes)) str = $3544fccbcc6ce858$var$formatValue(ctx, desc.value, null);
            else str = $3544fccbcc6ce858$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").substr(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($3544fccbcc6ce858$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $3544fccbcc6ce858$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("kPQSU"));
function $3544fccbcc6ce858$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $3544fccbcc6ce858$var$isArray;
function $3544fccbcc6ce858$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $3544fccbcc6ce858$var$isBoolean;
function $3544fccbcc6ce858$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $3544fccbcc6ce858$var$isNull;
function $3544fccbcc6ce858$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $3544fccbcc6ce858$var$isNullOrUndefined;
function $3544fccbcc6ce858$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $3544fccbcc6ce858$var$isNumber;
function $3544fccbcc6ce858$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $3544fccbcc6ce858$var$isString;
function $3544fccbcc6ce858$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $3544fccbcc6ce858$var$isSymbol;
function $3544fccbcc6ce858$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $3544fccbcc6ce858$var$isUndefined;
function $3544fccbcc6ce858$var$isRegExp(re) {
    return $3544fccbcc6ce858$var$isObject(re) && $3544fccbcc6ce858$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $3544fccbcc6ce858$var$isRegExp;
module.exports.types.isRegExp = $3544fccbcc6ce858$var$isRegExp;
function $3544fccbcc6ce858$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $3544fccbcc6ce858$var$isObject;
function $3544fccbcc6ce858$var$isDate(d) {
    return $3544fccbcc6ce858$var$isObject(d) && $3544fccbcc6ce858$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $3544fccbcc6ce858$var$isDate;
module.exports.types.isDate = $3544fccbcc6ce858$var$isDate;
function $3544fccbcc6ce858$var$isError(e) {
    return $3544fccbcc6ce858$var$isObject(e) && ($3544fccbcc6ce858$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $3544fccbcc6ce858$var$isError;
module.exports.types.isNativeError = $3544fccbcc6ce858$var$isError;
function $3544fccbcc6ce858$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $3544fccbcc6ce858$var$isFunction;
function $3544fccbcc6ce858$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $3544fccbcc6ce858$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("kieVX"));
function $3544fccbcc6ce858$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $3544fccbcc6ce858$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $3544fccbcc6ce858$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $3544fccbcc6ce858$var$timestamp() {
    var d = new Date();
    var time = [
        $3544fccbcc6ce858$var$pad(d.getHours()),
        $3544fccbcc6ce858$var$pad(d.getMinutes()),
        $3544fccbcc6ce858$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $3544fccbcc6ce858$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $3544fccbcc6ce858$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("eSHUL"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$3544fccbcc6ce858$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $3544fccbcc6ce858$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $3544fccbcc6ce858$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($3544fccbcc6ce858$var$kCustomPromisifiedSymbol && original[$3544fccbcc6ce858$var$kCustomPromisifiedSymbol]) {
        var fn = original[$3544fccbcc6ce858$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $3544fccbcc6ce858$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($3544fccbcc6ce858$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $3544fccbcc6ce858$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $3544fccbcc6ce858$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $3544fccbcc6ce858$var$kCustomPromisifiedSymbol;
function $3544fccbcc6ce858$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $3544fccbcc6ce858$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4TNnu.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4TNnu.nextTick($3544fccbcc6ce858$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $3544fccbcc6ce858$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $3544fccbcc6ce858$var$callbackify;

});
parcelRegister("kPQSU", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $6LFJs = parcelRequire("6LFJs");

var $lhqXC = parcelRequire("lhqXC");

var $nBFK4 = parcelRequire("nBFK4");

var $htkB6 = parcelRequire("htkB6");
function $f2b197d61b88f951$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $f2b197d61b88f951$var$BigIntSupported = typeof BigInt !== "undefined";
var $f2b197d61b88f951$var$SymbolSupported = typeof Symbol !== "undefined";
var $f2b197d61b88f951$var$ObjectToString = $f2b197d61b88f951$var$uncurryThis(Object.prototype.toString);
var $f2b197d61b88f951$var$numberValue = $f2b197d61b88f951$var$uncurryThis(Number.prototype.valueOf);
var $f2b197d61b88f951$var$stringValue = $f2b197d61b88f951$var$uncurryThis(String.prototype.valueOf);
var $f2b197d61b88f951$var$booleanValue = $f2b197d61b88f951$var$uncurryThis(Boolean.prototype.valueOf);
if ($f2b197d61b88f951$var$BigIntSupported) var $f2b197d61b88f951$var$bigIntValue = $f2b197d61b88f951$var$uncurryThis(BigInt.prototype.valueOf);
if ($f2b197d61b88f951$var$SymbolSupported) var $f2b197d61b88f951$var$symbolValue = $f2b197d61b88f951$var$uncurryThis(Symbol.prototype.valueOf);
function $f2b197d61b88f951$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $6LFJs;
module.exports.isGeneratorFunction = $lhqXC;
module.exports.isTypedArray = $htkB6;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $f2b197d61b88f951$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $f2b197d61b88f951$var$isPromise;
function $f2b197d61b88f951$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $htkB6(value) || $f2b197d61b88f951$var$isDataView(value);
}
module.exports.isArrayBufferView = $f2b197d61b88f951$var$isArrayBufferView;
function $f2b197d61b88f951$var$isUint8Array(value) {
    return $nBFK4(value) === "Uint8Array";
}
module.exports.isUint8Array = $f2b197d61b88f951$var$isUint8Array;
function $f2b197d61b88f951$var$isUint8ClampedArray(value) {
    return $nBFK4(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $f2b197d61b88f951$var$isUint8ClampedArray;
function $f2b197d61b88f951$var$isUint16Array(value) {
    return $nBFK4(value) === "Uint16Array";
}
module.exports.isUint16Array = $f2b197d61b88f951$var$isUint16Array;
function $f2b197d61b88f951$var$isUint32Array(value) {
    return $nBFK4(value) === "Uint32Array";
}
module.exports.isUint32Array = $f2b197d61b88f951$var$isUint32Array;
function $f2b197d61b88f951$var$isInt8Array(value) {
    return $nBFK4(value) === "Int8Array";
}
module.exports.isInt8Array = $f2b197d61b88f951$var$isInt8Array;
function $f2b197d61b88f951$var$isInt16Array(value) {
    return $nBFK4(value) === "Int16Array";
}
module.exports.isInt16Array = $f2b197d61b88f951$var$isInt16Array;
function $f2b197d61b88f951$var$isInt32Array(value) {
    return $nBFK4(value) === "Int32Array";
}
module.exports.isInt32Array = $f2b197d61b88f951$var$isInt32Array;
function $f2b197d61b88f951$var$isFloat32Array(value) {
    return $nBFK4(value) === "Float32Array";
}
module.exports.isFloat32Array = $f2b197d61b88f951$var$isFloat32Array;
function $f2b197d61b88f951$var$isFloat64Array(value) {
    return $nBFK4(value) === "Float64Array";
}
module.exports.isFloat64Array = $f2b197d61b88f951$var$isFloat64Array;
function $f2b197d61b88f951$var$isBigInt64Array(value) {
    return $nBFK4(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $f2b197d61b88f951$var$isBigInt64Array;
function $f2b197d61b88f951$var$isBigUint64Array(value) {
    return $nBFK4(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $f2b197d61b88f951$var$isBigUint64Array;
function $f2b197d61b88f951$var$isMapToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object Map]";
}
$f2b197d61b88f951$var$isMapToString.working = typeof Map !== "undefined" && $f2b197d61b88f951$var$isMapToString(new Map());
function $f2b197d61b88f951$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $f2b197d61b88f951$var$isMapToString.working ? $f2b197d61b88f951$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $f2b197d61b88f951$var$isMap;
function $f2b197d61b88f951$var$isSetToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object Set]";
}
$f2b197d61b88f951$var$isSetToString.working = typeof Set !== "undefined" && $f2b197d61b88f951$var$isSetToString(new Set());
function $f2b197d61b88f951$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $f2b197d61b88f951$var$isSetToString.working ? $f2b197d61b88f951$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $f2b197d61b88f951$var$isSet;
function $f2b197d61b88f951$var$isWeakMapToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object WeakMap]";
}
$f2b197d61b88f951$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $f2b197d61b88f951$var$isWeakMapToString(new WeakMap());
function $f2b197d61b88f951$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $f2b197d61b88f951$var$isWeakMapToString.working ? $f2b197d61b88f951$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $f2b197d61b88f951$var$isWeakMap;
function $f2b197d61b88f951$var$isWeakSetToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object WeakSet]";
}
$f2b197d61b88f951$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $f2b197d61b88f951$var$isWeakSetToString(new WeakSet());
function $f2b197d61b88f951$var$isWeakSet(value) {
    return $f2b197d61b88f951$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $f2b197d61b88f951$var$isWeakSet;
function $f2b197d61b88f951$var$isArrayBufferToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$f2b197d61b88f951$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $f2b197d61b88f951$var$isArrayBufferToString(new ArrayBuffer());
function $f2b197d61b88f951$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $f2b197d61b88f951$var$isArrayBufferToString.working ? $f2b197d61b88f951$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $f2b197d61b88f951$var$isArrayBuffer;
function $f2b197d61b88f951$var$isDataViewToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object DataView]";
}
$f2b197d61b88f951$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $f2b197d61b88f951$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $f2b197d61b88f951$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $f2b197d61b88f951$var$isDataViewToString.working ? $f2b197d61b88f951$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $f2b197d61b88f951$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $f2b197d61b88f951$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $f2b197d61b88f951$var$isSharedArrayBufferToString(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $f2b197d61b88f951$var$isSharedArrayBuffer(value) {
    if (typeof $f2b197d61b88f951$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $f2b197d61b88f951$var$isSharedArrayBufferToString.working === "undefined") $f2b197d61b88f951$var$isSharedArrayBufferToString.working = $f2b197d61b88f951$var$isSharedArrayBufferToString(new $f2b197d61b88f951$var$SharedArrayBufferCopy());
    return $f2b197d61b88f951$var$isSharedArrayBufferToString.working ? $f2b197d61b88f951$var$isSharedArrayBufferToString(value) : value instanceof $f2b197d61b88f951$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $f2b197d61b88f951$var$isSharedArrayBuffer;
function $f2b197d61b88f951$var$isAsyncFunction(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $f2b197d61b88f951$var$isAsyncFunction;
function $f2b197d61b88f951$var$isMapIterator(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $f2b197d61b88f951$var$isMapIterator;
function $f2b197d61b88f951$var$isSetIterator(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $f2b197d61b88f951$var$isSetIterator;
function $f2b197d61b88f951$var$isGeneratorObject(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $f2b197d61b88f951$var$isGeneratorObject;
function $f2b197d61b88f951$var$isWebAssemblyCompiledModule(value) {
    return $f2b197d61b88f951$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $f2b197d61b88f951$var$isWebAssemblyCompiledModule;
function $f2b197d61b88f951$var$isNumberObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$numberValue);
}
module.exports.isNumberObject = $f2b197d61b88f951$var$isNumberObject;
function $f2b197d61b88f951$var$isStringObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$stringValue);
}
module.exports.isStringObject = $f2b197d61b88f951$var$isStringObject;
function $f2b197d61b88f951$var$isBooleanObject(value) {
    return $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$booleanValue);
}
module.exports.isBooleanObject = $f2b197d61b88f951$var$isBooleanObject;
function $f2b197d61b88f951$var$isBigIntObject(value) {
    return $f2b197d61b88f951$var$BigIntSupported && $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$bigIntValue);
}
module.exports.isBigIntObject = $f2b197d61b88f951$var$isBigIntObject;
function $f2b197d61b88f951$var$isSymbolObject(value) {
    return $f2b197d61b88f951$var$SymbolSupported && $f2b197d61b88f951$var$checkBoxedPrimitive(value, $f2b197d61b88f951$var$symbolValue);
}
module.exports.isSymbolObject = $f2b197d61b88f951$var$isSymbolObject;
function $f2b197d61b88f951$var$isBoxedPrimitive(value) {
    return $f2b197d61b88f951$var$isNumberObject(value) || $f2b197d61b88f951$var$isStringObject(value) || $f2b197d61b88f951$var$isBooleanObject(value) || $f2b197d61b88f951$var$isBigIntObject(value) || $f2b197d61b88f951$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $f2b197d61b88f951$var$isBoxedPrimitive;
function $f2b197d61b88f951$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($f2b197d61b88f951$var$isArrayBuffer(value) || $f2b197d61b88f951$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $f2b197d61b88f951$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("6LFJs", function(module, exports) {
"use strict";
var $4ed781073515e0c4$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";

var $jLsQW = parcelRequire("jLsQW");
var $4ed781073515e0c4$var$$toString = $jLsQW("Object.prototype.toString");
var $4ed781073515e0c4$var$isStandardArguments = function isArguments(value) {
    if ($4ed781073515e0c4$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $4ed781073515e0c4$var$$toString(value) === "[object Arguments]";
};
var $4ed781073515e0c4$var$isLegacyArguments = function isArguments(value) {
    if ($4ed781073515e0c4$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $4ed781073515e0c4$var$$toString(value) !== "[object Array]" && $4ed781073515e0c4$var$$toString(value.callee) === "[object Function]";
};
var $4ed781073515e0c4$var$supportsStandardArguments = function() {
    return $4ed781073515e0c4$var$isStandardArguments(arguments);
}();
$4ed781073515e0c4$var$isStandardArguments.isLegacyArguments = $4ed781073515e0c4$var$isLegacyArguments; // for tests
module.exports = $4ed781073515e0c4$var$supportsStandardArguments ? $4ed781073515e0c4$var$isStandardArguments : $4ed781073515e0c4$var$isLegacyArguments;

});
parcelRegister("jLsQW", function(module, exports) {
"use strict";

var $aVPs1 = parcelRequire("aVPs1");

var $e9CQ6 = parcelRequire("e9CQ6");
var $e638c9b041e57a82$var$$indexOf = $e9CQ6($aVPs1("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $aVPs1(name, !!allowMissing);
    if (typeof intrinsic === "function" && $e638c9b041e57a82$var$$indexOf(name, ".prototype.") > -1) return $e9CQ6(intrinsic);
    return intrinsic;
};

});
parcelRegister("aVPs1", function(module, exports) {
"use strict";
var $7f57235e2fac8f7f$var$undefined1;
var $7f57235e2fac8f7f$var$$SyntaxError = SyntaxError;
var $7f57235e2fac8f7f$var$$Function = Function;
var $7f57235e2fac8f7f$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7f57235e2fac8f7f$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7f57235e2fac8f7f$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7f57235e2fac8f7f$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7f57235e2fac8f7f$var$$gOPD) try {
    $7f57235e2fac8f7f$var$$gOPD({}, "");
} catch (e) {
    $7f57235e2fac8f7f$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7f57235e2fac8f7f$var$throwTypeError = function() {
    throw new $7f57235e2fac8f7f$var$$TypeError();
};
var $7f57235e2fac8f7f$var$ThrowTypeError = $7f57235e2fac8f7f$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7f57235e2fac8f7f$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7f57235e2fac8f7f$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7f57235e2fac8f7f$var$throwTypeError;
        }
    }
}() : $7f57235e2fac8f7f$var$throwTypeError;

var $7f57235e2fac8f7f$var$hasSymbols = (parcelRequire("5CmBX"))();
var $7f57235e2fac8f7f$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $7f57235e2fac8f7f$var$needsEval = {};
var $7f57235e2fac8f7f$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $7f57235e2fac8f7f$var$getProto(Uint8Array);
var $7f57235e2fac8f7f$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7f57235e2fac8f7f$var$hasSymbols ? $7f57235e2fac8f7f$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $7f57235e2fac8f7f$var$needsEval,
    "%AsyncGenerator%": $7f57235e2fac8f7f$var$needsEval,
    "%AsyncGeneratorFunction%": $7f57235e2fac8f7f$var$needsEval,
    "%AsyncIteratorPrototype%": $7f57235e2fac8f7f$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $7f57235e2fac8f7f$var$$Function,
    "%GeneratorFunction%": $7f57235e2fac8f7f$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7f57235e2fac8f7f$var$hasSymbols ? $7f57235e2fac8f7f$var$getProto($7f57235e2fac8f7f$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7f57235e2fac8f7f$var$hasSymbols ? undefined : $7f57235e2fac8f7f$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7f57235e2fac8f7f$var$hasSymbols ? undefined : $7f57235e2fac8f7f$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7f57235e2fac8f7f$var$hasSymbols ? $7f57235e2fac8f7f$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $7f57235e2fac8f7f$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $7f57235e2fac8f7f$var$$SyntaxError,
    "%ThrowTypeError%": $7f57235e2fac8f7f$var$ThrowTypeError,
    "%TypedArray%": $7f57235e2fac8f7f$var$TypedArray,
    "%TypeError%": $7f57235e2fac8f7f$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var $7f57235e2fac8f7f$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7f57235e2fac8f7f$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7f57235e2fac8f7f$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7f57235e2fac8f7f$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = $7f57235e2fac8f7f$var$getProto(gen.prototype);
    }
    $7f57235e2fac8f7f$var$INTRINSICS[name] = value;
    return value;
};
var $7f57235e2fac8f7f$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $56d6a = parcelRequire("56d6a");
var $7f57235e2fac8f7f$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $7f57235e2fac8f7f$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $7f57235e2fac8f7f$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $7f57235e2fac8f7f$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7f57235e2fac8f7f$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7f57235e2fac8f7f$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7f57235e2fac8f7f$var$stringToPath = function stringToPath(string) {
    var first = $7f57235e2fac8f7f$var$$strSlice(string, 0, 1);
    var last = $7f57235e2fac8f7f$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $7f57235e2fac8f7f$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $7f57235e2fac8f7f$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7f57235e2fac8f7f$var$$replace(string, $7f57235e2fac8f7f$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7f57235e2fac8f7f$var$$replace(subString, $7f57235e2fac8f7f$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7f57235e2fac8f7f$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($56d6a($7f57235e2fac8f7f$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7f57235e2fac8f7f$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($56d6a($7f57235e2fac8f7f$var$INTRINSICS, intrinsicName)) {
        var value = $7f57235e2fac8f7f$var$INTRINSICS[intrinsicName];
        if (value === $7f57235e2fac8f7f$var$needsEval) value = $7f57235e2fac8f7f$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $7f57235e2fac8f7f$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7f57235e2fac8f7f$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $7f57235e2fac8f7f$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $7f57235e2fac8f7f$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $7f57235e2fac8f7f$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7f57235e2fac8f7f$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7f57235e2fac8f7f$var$$spliceApply(parts, $7f57235e2fac8f7f$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7f57235e2fac8f7f$var$$strSlice(part, 0, 1);
        var last = $7f57235e2fac8f7f$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $7f57235e2fac8f7f$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($56d6a($7f57235e2fac8f7f$var$INTRINSICS, intrinsicRealName)) value = $7f57235e2fac8f7f$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7f57235e2fac8f7f$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7f57235e2fac8f7f$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7f57235e2fac8f7f$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $56d6a(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7f57235e2fac8f7f$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5CmBX", function(module, exports) {
"use strict";
var $41720a79fda68d9e$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $fNdnD = parcelRequire("fNdnD");
module.exports = function hasNativeSymbols() {
    if (typeof $41720a79fda68d9e$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $41720a79fda68d9e$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $fNdnD();
};

});
parcelRegister("fNdnD", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("a7ABz", function(module, exports) {
"use strict";

var $cytJY = parcelRequire("cytJY");
module.exports = Function.prototype.bind || $cytJY;

});
parcelRegister("cytJY", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $923fbadf1e720976$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $923fbadf1e720976$var$slice = Array.prototype.slice;
var $923fbadf1e720976$var$toStr = Object.prototype.toString;
var $923fbadf1e720976$var$funcType = "[object Function]";
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $923fbadf1e720976$var$toStr.call(target) !== $923fbadf1e720976$var$funcType) throw new TypeError($923fbadf1e720976$var$ERROR_MESSAGE + target);
    var args = $923fbadf1e720976$var$slice.call(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($923fbadf1e720976$var$slice.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($923fbadf1e720976$var$slice.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push("$" + i);
    bound = Function("binder", "return function (" + boundArgs.join(",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("56d6a", function(module, exports) {
"use strict";

var $a7ABz = parcelRequire("a7ABz");
module.exports = $a7ABz.call(Function.call, Object.prototype.hasOwnProperty);

});


parcelRegister("e9CQ6", function(module, exports) {
"use strict";

var $a7ABz = parcelRequire("a7ABz");

var $aVPs1 = parcelRequire("aVPs1");
var $a4e008a795944d5c$var$$apply = $aVPs1("%Function.prototype.apply%");
var $a4e008a795944d5c$var$$call = $aVPs1("%Function.prototype.call%");
var $a4e008a795944d5c$var$$reflectApply = $aVPs1("%Reflect.apply%", true) || $a7ABz.call($a4e008a795944d5c$var$$call, $a4e008a795944d5c$var$$apply);
var $a4e008a795944d5c$var$$gOPD = $aVPs1("%Object.getOwnPropertyDescriptor%", true);
var $a4e008a795944d5c$var$$defineProperty = $aVPs1("%Object.defineProperty%", true);
var $a4e008a795944d5c$var$$max = $aVPs1("%Math.max%");
if ($a4e008a795944d5c$var$$defineProperty) try {
    $a4e008a795944d5c$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $a4e008a795944d5c$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    var func = $a4e008a795944d5c$var$$reflectApply($a7ABz, $a4e008a795944d5c$var$$call, arguments);
    if ($a4e008a795944d5c$var$$gOPD && $a4e008a795944d5c$var$$defineProperty) {
        var desc = $a4e008a795944d5c$var$$gOPD(func, "length");
        if (desc.configurable) // original length, plus the receiver, minus any additional arguments (after the receiver)
        $a4e008a795944d5c$var$$defineProperty(func, "length", {
            value: 1 + $a4e008a795944d5c$var$$max(0, originalFunction.length - (arguments.length - 1))
        });
    }
    return func;
};
var $a4e008a795944d5c$var$applyBind = function applyBind() {
    return $a4e008a795944d5c$var$$reflectApply($a7ABz, $a4e008a795944d5c$var$$apply, arguments);
};
if ($a4e008a795944d5c$var$$defineProperty) $a4e008a795944d5c$var$$defineProperty(module.exports, "apply", {
    value: $a4e008a795944d5c$var$applyBind
});
else module.exports.apply = $a4e008a795944d5c$var$applyBind;

});



parcelRegister("lhqXC", function(module, exports) {
"use strict";
var $f7e0195071cf767f$var$toStr = Object.prototype.toString;
var $f7e0195071cf767f$var$fnToStr = Function.prototype.toString;
var $f7e0195071cf767f$var$isFnRegex = /^\s*(?:function)?\*/;
var $f7e0195071cf767f$var$hasToStringTag = typeof Symbol === "function" && typeof Symbol.toStringTag === "symbol";
var $f7e0195071cf767f$var$getProto = Object.getPrototypeOf;
var $f7e0195071cf767f$var$getGeneratorFunc = function() {
    if (!$f7e0195071cf767f$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $f7e0195071cf767f$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($f7e0195071cf767f$var$isFnRegex.test($f7e0195071cf767f$var$fnToStr.call(fn))) return true;
    if (!$f7e0195071cf767f$var$hasToStringTag) {
        var str = $f7e0195071cf767f$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$f7e0195071cf767f$var$getProto) return false;
    if (typeof $f7e0195071cf767f$var$GeneratorFunction === "undefined") {
        var generatorFunc = $f7e0195071cf767f$var$getGeneratorFunc();
        $f7e0195071cf767f$var$GeneratorFunction = generatorFunc ? $f7e0195071cf767f$var$getProto(generatorFunc) : false;
    }
    return $f7e0195071cf767f$var$getProto(fn) === $f7e0195071cf767f$var$GeneratorFunction;
};

});

parcelRegister("nBFK4", function(module, exports) {
"use strict";

var $1InzA = parcelRequire("1InzA");

var $lUXdk = parcelRequire("lUXdk");

var $jLsQW = parcelRequire("jLsQW");
var $046f5f05efc793ca$var$$toString = $jLsQW("Object.prototype.toString");

var $046f5f05efc793ca$var$hasSymbols = (parcelRequire("5CmBX"))();
var $046f5f05efc793ca$var$hasToStringTag = $046f5f05efc793ca$var$hasSymbols && typeof Symbol.toStringTag === "symbol";
var $046f5f05efc793ca$var$typedArrays = $lUXdk();
var $046f5f05efc793ca$var$$slice = $jLsQW("String.prototype.slice");
var $046f5f05efc793ca$var$toStrTags = {};

var $kSFJ4 = parcelRequire("kSFJ4");
var $046f5f05efc793ca$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($046f5f05efc793ca$var$hasToStringTag && $kSFJ4 && $046f5f05efc793ca$var$getPrototypeOf) $1InzA($046f5f05efc793ca$var$typedArrays, function(typedArray) {
    if (typeof $parcel$global[typedArray] === "function") {
        var arr = new $parcel$global[typedArray]();
        if (!(Symbol.toStringTag in arr)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + typedArray + " does not have the property! Please report this.");
        var proto = $046f5f05efc793ca$var$getPrototypeOf(arr);
        var descriptor = $kSFJ4(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $046f5f05efc793ca$var$getPrototypeOf(proto);
            descriptor = $kSFJ4(superProto, Symbol.toStringTag);
        }
        $046f5f05efc793ca$var$toStrTags[typedArray] = descriptor.get;
    }
});
var $046f5f05efc793ca$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var foundName = false;
    $1InzA($046f5f05efc793ca$var$toStrTags, function(getter, typedArray) {
        if (!foundName) try {
            var name = getter.call(value);
            if (name === typedArray) foundName = name;
        } catch (e) {}
    });
    return foundName;
};

var $htkB6 = parcelRequire("htkB6");
module.exports = function whichTypedArray(value) {
    if (!$htkB6(value)) return false;
    if (!$046f5f05efc793ca$var$hasToStringTag) return $046f5f05efc793ca$var$$slice($046f5f05efc793ca$var$$toString(value), 8, -1);
    return $046f5f05efc793ca$var$tryTypedArrays(value);
};

});
parcelRegister("1InzA", function(module, exports) {
var $13fc2f98aa8cc231$var$hasOwn = Object.prototype.hasOwnProperty;
var $13fc2f98aa8cc231$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($13fc2f98aa8cc231$var$toString.call(fn) !== "[object Function]") throw new TypeError("iterator must be a function");
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($13fc2f98aa8cc231$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});

parcelRegister("lUXdk", function(module, exports) {
"use strict";
var $ff4cc296ed9551f0$var$possibleNames = [
    "BigInt64Array",
    "BigUint64Array",
    "Float32Array",
    "Float64Array",
    "Int16Array",
    "Int32Array",
    "Int8Array",
    "Uint16Array",
    "Uint32Array",
    "Uint8Array",
    "Uint8ClampedArray"
];
module.exports = function availableTypedArrays() {
    var out = [];
    for(var i = 0; i < $ff4cc296ed9551f0$var$possibleNames.length; i++)if (typeof $parcel$global[$ff4cc296ed9551f0$var$possibleNames[i]] === "function") out[out.length] = $ff4cc296ed9551f0$var$possibleNames[i];
    return out;
};

});

parcelRegister("kSFJ4", function(module, exports) {
"use strict";

var $1Dxjv = parcelRequire("1Dxjv");
var $f33937b6b223d489$var$$gOPD = $1Dxjv("%Object.getOwnPropertyDescriptor%");
if ($f33937b6b223d489$var$$gOPD) try {
    $f33937b6b223d489$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f33937b6b223d489$var$$gOPD = null;
}
module.exports = $f33937b6b223d489$var$$gOPD;

});
parcelRegister("1Dxjv", function(module, exports) {
"use strict";
var $13134656ccc79c29$var$undefined1;
var $13134656ccc79c29$var$$SyntaxError = SyntaxError;
var $13134656ccc79c29$var$$Function = Function;
var $13134656ccc79c29$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $13134656ccc79c29$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $13134656ccc79c29$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $13134656ccc79c29$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($13134656ccc79c29$var$$gOPD) try {
    $13134656ccc79c29$var$$gOPD({}, "");
} catch (e) {
    $13134656ccc79c29$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $13134656ccc79c29$var$throwTypeError = function() {
    throw new $13134656ccc79c29$var$$TypeError();
};
var $13134656ccc79c29$var$ThrowTypeError = $13134656ccc79c29$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $13134656ccc79c29$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $13134656ccc79c29$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $13134656ccc79c29$var$throwTypeError;
        }
    }
}() : $13134656ccc79c29$var$throwTypeError;

var $13134656ccc79c29$var$hasSymbols = (parcelRequire("5CmBX"))();
var $13134656ccc79c29$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $13134656ccc79c29$var$needsEval = {};
var $13134656ccc79c29$var$TypedArray = typeof Uint8Array === "undefined" ? undefined : $13134656ccc79c29$var$getProto(Uint8Array);
var $13134656ccc79c29$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $13134656ccc79c29$var$hasSymbols ? $13134656ccc79c29$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $13134656ccc79c29$var$needsEval,
    "%AsyncGenerator%": $13134656ccc79c29$var$needsEval,
    "%AsyncGeneratorFunction%": $13134656ccc79c29$var$needsEval,
    "%AsyncIteratorPrototype%": $13134656ccc79c29$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $13134656ccc79c29$var$$Function,
    "%GeneratorFunction%": $13134656ccc79c29$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $13134656ccc79c29$var$hasSymbols ? $13134656ccc79c29$var$getProto($13134656ccc79c29$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$13134656ccc79c29$var$hasSymbols ? undefined : $13134656ccc79c29$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$13134656ccc79c29$var$hasSymbols ? undefined : $13134656ccc79c29$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $13134656ccc79c29$var$hasSymbols ? $13134656ccc79c29$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $13134656ccc79c29$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $13134656ccc79c29$var$$SyntaxError,
    "%ThrowTypeError%": $13134656ccc79c29$var$ThrowTypeError,
    "%TypedArray%": $13134656ccc79c29$var$TypedArray,
    "%TypeError%": $13134656ccc79c29$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
var $13134656ccc79c29$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $13134656ccc79c29$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $13134656ccc79c29$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $13134656ccc79c29$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen) value = $13134656ccc79c29$var$getProto(gen.prototype);
    }
    $13134656ccc79c29$var$INTRINSICS[name] = value;
    return value;
};
var $13134656ccc79c29$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $a7ABz = parcelRequire("a7ABz");

var $56d6a = parcelRequire("56d6a");
var $13134656ccc79c29$var$$concat = $a7ABz.call(Function.call, Array.prototype.concat);
var $13134656ccc79c29$var$$spliceApply = $a7ABz.call(Function.apply, Array.prototype.splice);
var $13134656ccc79c29$var$$replace = $a7ABz.call(Function.call, String.prototype.replace);
var $13134656ccc79c29$var$$strSlice = $a7ABz.call(Function.call, String.prototype.slice);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $13134656ccc79c29$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $13134656ccc79c29$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $13134656ccc79c29$var$stringToPath = function stringToPath(string) {
    var first = $13134656ccc79c29$var$$strSlice(string, 0, 1);
    var last = $13134656ccc79c29$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $13134656ccc79c29$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $13134656ccc79c29$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $13134656ccc79c29$var$$replace(string, $13134656ccc79c29$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $13134656ccc79c29$var$$replace(subString, $13134656ccc79c29$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $13134656ccc79c29$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($56d6a($13134656ccc79c29$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $13134656ccc79c29$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($56d6a($13134656ccc79c29$var$INTRINSICS, intrinsicName)) {
        var value = $13134656ccc79c29$var$INTRINSICS[intrinsicName];
        if (value === $13134656ccc79c29$var$needsEval) value = $13134656ccc79c29$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $13134656ccc79c29$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $13134656ccc79c29$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $13134656ccc79c29$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $13134656ccc79c29$var$$TypeError('"allowMissing" argument must be a boolean');
    var parts = $13134656ccc79c29$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $13134656ccc79c29$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $13134656ccc79c29$var$$spliceApply(parts, $13134656ccc79c29$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $13134656ccc79c29$var$$strSlice(part, 0, 1);
        var last = $13134656ccc79c29$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $13134656ccc79c29$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($56d6a($13134656ccc79c29$var$INTRINSICS, intrinsicRealName)) value = $13134656ccc79c29$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $13134656ccc79c29$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($13134656ccc79c29$var$$gOPD && i + 1 >= parts.length) {
                var desc = $13134656ccc79c29$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $56d6a(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $13134656ccc79c29$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});


parcelRegister("htkB6", function(module, exports) {
"use strict";

var $1InzA = parcelRequire("1InzA");

var $lUXdk = parcelRequire("lUXdk");

var $jLsQW = parcelRequire("jLsQW");
var $cb851f547f806f23$var$$toString = $jLsQW("Object.prototype.toString");

var $cb851f547f806f23$var$hasSymbols = (parcelRequire("5CmBX"))();
var $cb851f547f806f23$var$hasToStringTag = $cb851f547f806f23$var$hasSymbols && typeof Symbol.toStringTag === "symbol";
var $cb851f547f806f23$var$typedArrays = $lUXdk();
var $cb851f547f806f23$var$$indexOf = $jLsQW("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
var $cb851f547f806f23$var$$slice = $jLsQW("String.prototype.slice");
var $cb851f547f806f23$var$toStrTags = {};

var $kSFJ4 = parcelRequire("kSFJ4");
var $cb851f547f806f23$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
if ($cb851f547f806f23$var$hasToStringTag && $kSFJ4 && $cb851f547f806f23$var$getPrototypeOf) $1InzA($cb851f547f806f23$var$typedArrays, function(typedArray) {
    var arr = new $parcel$global[typedArray]();
    if (!(Symbol.toStringTag in arr)) throw new EvalError("this engine has support for Symbol.toStringTag, but " + typedArray + " does not have the property! Please report this.");
    var proto = $cb851f547f806f23$var$getPrototypeOf(arr);
    var descriptor = $kSFJ4(proto, Symbol.toStringTag);
    if (!descriptor) {
        var superProto = $cb851f547f806f23$var$getPrototypeOf(proto);
        descriptor = $kSFJ4(superProto, Symbol.toStringTag);
    }
    $cb851f547f806f23$var$toStrTags[typedArray] = descriptor.get;
});
var $cb851f547f806f23$var$tryTypedArrays = function tryAllTypedArrays(value) {
    var anyTrue = false;
    $1InzA($cb851f547f806f23$var$toStrTags, function(getter, typedArray) {
        if (!anyTrue) try {
            anyTrue = getter.call(value) === typedArray;
        } catch (e) {}
    });
    return anyTrue;
};
module.exports = function isTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$cb851f547f806f23$var$hasToStringTag) {
        var tag = $cb851f547f806f23$var$$slice($cb851f547f806f23$var$$toString(value), 8, -1);
        return $cb851f547f806f23$var$$indexOf($cb851f547f806f23$var$typedArrays, tag) > -1;
    }
    if (!$kSFJ4) return false;
    return $cb851f547f806f23$var$tryTypedArrays(value);
};

});



parcelRegister("kieVX", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});


parcelRegister("57907", function(module, exports) {
module.exports = $3b949694bc56fbac$var$extend;
var $3b949694bc56fbac$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $3b949694bc56fbac$var$extend() {
    var target = {};
    for(var i = 0; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if ($3b949694bc56fbac$var$hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}

});


parcelRegister("l0GeG", function(module, exports) {
/*
Copyright (c) 2014-2016, Matteo Collina <hello@matteocollina.com>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR
IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ "use strict";

var $hgxrz = parcelRequire("hgxrz");

var $5ZLII = parcelRequire("5ZLII");
var $f4ba5c35114e20d6$require$StringDecoder = $5ZLII.StringDecoder;
function $f4ba5c35114e20d6$var$transform(chunk, enc, cb) {
    this._last += this._decoder.write(chunk);
    if (this._last.length > this.maxLength) return cb(new Error("maximum buffer reached"));
    var list = this._last.split(this.matcher);
    this._last = list.pop();
    for(var i = 0; i < list.length; i++)$f4ba5c35114e20d6$var$push(this, this.mapper(list[i]));
    cb();
}
function $f4ba5c35114e20d6$var$flush(cb) {
    // forward any gibberish left in there
    this._last += this._decoder.end();
    if (this._last) $f4ba5c35114e20d6$var$push(this, this.mapper(this._last));
    cb();
}
function $f4ba5c35114e20d6$var$push(self, val) {
    if (val !== undefined) self.push(val);
}
function $f4ba5c35114e20d6$var$noop(incoming) {
    return incoming;
}
function $f4ba5c35114e20d6$var$split(matcher, mapper, options) {
    // Set defaults for any arguments not supplied.
    matcher = matcher || /\r?\n/;
    mapper = mapper || $f4ba5c35114e20d6$var$noop;
    options = options || {};
    // Test arguments explicitly.
    switch(arguments.length){
        case 1:
            // If mapper is only argument.
            if (typeof matcher === "function") {
                mapper = matcher;
                matcher = /\r?\n/;
            // If options is only argument.
            } else if (typeof matcher === "object" && !(matcher instanceof RegExp)) {
                options = matcher;
                matcher = /\r?\n/;
            }
            break;
        case 2:
            // If mapper and options are arguments.
            if (typeof matcher === "function") {
                options = mapper;
                mapper = matcher;
                matcher = /\r?\n/;
            // If matcher and options are arguments.
            } else if (typeof mapper === "object") {
                options = mapper;
                mapper = $f4ba5c35114e20d6$var$noop;
            }
    }
    var stream = $hgxrz(options, $f4ba5c35114e20d6$var$transform, $f4ba5c35114e20d6$var$flush);
    // this stream is in objectMode only in the readable part
    stream._readableState.objectMode = true;
    // objectMode default hwm is 16 and not 16384
    if (stream._readableState.highWaterMark && !options.highWaterMark) stream._readableState.highWaterMark = 16;
    stream._last = "";
    stream._decoder = new $f4ba5c35114e20d6$require$StringDecoder("utf8");
    stream.matcher = matcher;
    stream.mapper = mapper;
    stream.maxLength = options.maxLength;
    return stream;
}
module.exports = $f4ba5c35114e20d6$var$split;

});

parcelRegister("9GD6K", function(module, exports) {

$parcel$export(module.exports, "type", function () { return $70d65f50a9b9216e$export$bf9fb029d174d554; }, function (v) { return $70d65f50a9b9216e$export$bf9fb029d174d554 = v; });
$parcel$export(module.exports, "arch", function () { return $70d65f50a9b9216e$export$7925d89f138dad5b; }, function (v) { return $70d65f50a9b9216e$export$7925d89f138dad5b = v; });
$parcel$export(module.exports, "EOL", function () { return $70d65f50a9b9216e$export$266d3b9babd1fc45; }, function (v) { return $70d65f50a9b9216e$export$266d3b9babd1fc45 = v; });
var $70d65f50a9b9216e$export$edf525f30916fbb8;
var $70d65f50a9b9216e$export$640106f6dc7d2706;
var $70d65f50a9b9216e$export$3ea386628068cf62;
var $70d65f50a9b9216e$export$749d472264fad440;
var $70d65f50a9b9216e$export$8b931a48d9488767;
var $70d65f50a9b9216e$export$9123f37609399513;
var $70d65f50a9b9216e$export$9b60beb643db4d69;
var $70d65f50a9b9216e$export$bf9fb029d174d554;
var $70d65f50a9b9216e$export$23d3fad09dc44362;
var $70d65f50a9b9216e$export$d2f3c2f7e0c7dcf5;
var $70d65f50a9b9216e$export$3bf7c33313eba0fe;
var $70d65f50a9b9216e$export$7925d89f138dad5b;
var $70d65f50a9b9216e$export$722a64dea1b767dc;
var $70d65f50a9b9216e$export$9e6c06a7d47f9af7;
var $70d65f50a9b9216e$export$6b76988456c0292f;
var $70d65f50a9b9216e$export$266d3b9babd1fc45;
var $70d65f50a9b9216e$export$c1d46b5ea6262c0b;
$70d65f50a9b9216e$export$edf525f30916fbb8 = function() {
    return "LE";
};
$70d65f50a9b9216e$export$640106f6dc7d2706 = function() {
    if (typeof location !== "undefined") return location.hostname;
    else return "";
};
$70d65f50a9b9216e$export$3ea386628068cf62 = function() {
    return [];
};
$70d65f50a9b9216e$export$749d472264fad440 = function() {
    return 0;
};
$70d65f50a9b9216e$export$8b931a48d9488767 = function() {
    return Number.MAX_VALUE;
};
$70d65f50a9b9216e$export$9123f37609399513 = function() {
    return Number.MAX_VALUE;
};
$70d65f50a9b9216e$export$9b60beb643db4d69 = function() {
    return [];
};
$70d65f50a9b9216e$export$bf9fb029d174d554 = function() {
    return "Browser";
};
$70d65f50a9b9216e$export$23d3fad09dc44362 = function() {
    if (typeof navigator !== "undefined") return navigator.appVersion;
    return "";
};
$70d65f50a9b9216e$export$d2f3c2f7e0c7dcf5 = $70d65f50a9b9216e$export$3bf7c33313eba0fe = function() {
    return {};
};
$70d65f50a9b9216e$export$7925d89f138dad5b = function() {
    return "javascript";
};
$70d65f50a9b9216e$export$722a64dea1b767dc = function() {
    return "browser";
};
$70d65f50a9b9216e$export$9e6c06a7d47f9af7 = $70d65f50a9b9216e$export$6b76988456c0292f = function() {
    return "/tmp";
};
$70d65f50a9b9216e$export$266d3b9babd1fc45 = "\n";
$70d65f50a9b9216e$export$c1d46b5ea6262c0b = function() {
    return "/";
};

});

parcelRegister("c2s0i", function(module, exports) {
exports = module.exports = stringify;
exports.getSerialize = serializer;
function stringify(obj, replacer, spaces, cycleReplacer) {
    return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces);
}
function serializer(replacer, cycleReplacer) {
    var stack = [], keys = [];
    if (cycleReplacer == null) cycleReplacer = function(key, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value);
        } else stack.push(value);
        return replacer == null ? value : replacer.call(this, key, value);
    };
}

});


parcelRegister("acOFb", function(module, exports) {

var $1vbr5 = parcelRequire("1vbr5");

var $eSHUL = parcelRequire("eSHUL");

var $dh5rM = parcelRequire("dh5rM");
var $76e253035be6d1dc$var$toArray = function(args) {
    if (!args.length) return [];
    return Array.isArray(args[0]) ? args[0] : Array.prototype.slice.call(args);
};
var $76e253035be6d1dc$var$define = function(opts) {
    var Pumpify = function() {
        var streams = $76e253035be6d1dc$var$toArray(arguments);
        if (!(this instanceof Pumpify)) return new Pumpify(streams);
        $dh5rM.call(this, null, null, opts);
        if (streams.length) this.setPipeline(streams);
    };
    $eSHUL(Pumpify, $dh5rM);
    Pumpify.prototype.setPipeline = function() {
        var streams = $76e253035be6d1dc$var$toArray(arguments);
        var self = this;
        var ended = false;
        var w = streams[0];
        var r = streams[streams.length - 1];
        r = r.readable ? r : null;
        w = w.writable ? w : null;
        var onclose = function() {
            streams[0].emit("error", new Error("stream was destroyed"));
        };
        this.on("close", onclose);
        this.on("prefinish", function() {
            if (!ended) self.cork();
        });
        $1vbr5(streams, function(err) {
            self.removeListener("close", onclose);
            if (err) return self.destroy(err.message === "premature close" ? null : err);
            ended = true;
            // pump ends after the last stream is not writable *but*
            // pumpify still forwards the readable part so we need to catch errors
            // still, so reenable autoDestroy in this case
            if (self._autoDestroy === false) self._autoDestroy = true;
            self.uncork();
        });
        if (this.destroyed) return onclose();
        this.setWritable(w);
        this.setReadable(r);
    };
    return Pumpify;
};
module.exports = $76e253035be6d1dc$var$define({
    autoDestroy: false,
    destroy: false
});
module.exports.obj = $76e253035be6d1dc$var$define({
    autoDestroy: false,
    destroy: false,
    objectMode: true,
    highWaterMark: 16
});
module.exports.ctor = $76e253035be6d1dc$var$define;

});
parcelRegister("1vbr5", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $kHhtt = parcelRequire("kHhtt");

var $k3pns = parcelRequire("k3pns");

var $5Io6y = parcelRequire("5Io6y");
var $11818e9bb42028c1$var$noop = function() {};
var $11818e9bb42028c1$var$ancient = /^v?\.0/.test($4TNnu.version);
var $11818e9bb42028c1$var$isFn = function(fn) {
    return typeof fn === "function";
};
var $11818e9bb42028c1$var$isFS = function(stream) {
    if (!$11818e9bb42028c1$var$ancient) return false // newer node version do not need to care about fs is a special way
    ;
    if (!$5Io6y) return false // browser
    ;
    return (stream instanceof ($5Io6y.ReadStream || $11818e9bb42028c1$var$noop) || stream instanceof ($5Io6y.WriteStream || $11818e9bb42028c1$var$noop)) && $11818e9bb42028c1$var$isFn(stream.close);
};
var $11818e9bb42028c1$var$isRequest = function(stream) {
    return stream.setHeader && $11818e9bb42028c1$var$isFn(stream.abort);
};
var $11818e9bb42028c1$var$destroyer = function(stream, reading, writing, callback) {
    callback = $kHhtt(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    $k3pns(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        if ($11818e9bb42028c1$var$isFS(stream)) return stream.close($11818e9bb42028c1$var$noop) // use close for fs streams to avoid fd leaks
        ;
        if ($11818e9bb42028c1$var$isRequest(stream)) return stream.abort() // request.destroy just do .end - .abort is what we want
        ;
        if ($11818e9bb42028c1$var$isFn(stream.destroy)) return stream.destroy();
        callback(err || new Error("stream was destroyed"));
    };
};
var $11818e9bb42028c1$var$call = function(fn) {
    fn();
};
var $11818e9bb42028c1$var$pipe = function(from, to) {
    return from.pipe(to);
};
var $11818e9bb42028c1$var$pump = function() {
    var streams = Array.prototype.slice.call(arguments);
    var callback = $11818e9bb42028c1$var$isFn(streams[streams.length - 1] || $11818e9bb42028c1$var$noop) && streams.pop() || $11818e9bb42028c1$var$noop;
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new Error("pump requires two streams per minimum");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $11818e9bb42028c1$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($11818e9bb42028c1$var$call);
            if (reading) return;
            destroys.forEach($11818e9bb42028c1$var$call);
            callback(error);
        });
    });
    return streams.reduce($11818e9bb42028c1$var$pipe);
};
module.exports = $11818e9bb42028c1$var$pump;

});
parcelRegister("kHhtt", function(module, exports) {

var $82mpb = parcelRequire("82mpb");
module.exports = $82mpb($f11560dd8186a095$var$once);
module.exports.strict = $82mpb($f11560dd8186a095$var$onceStrict);
$f11560dd8186a095$var$once.proto = $f11560dd8186a095$var$once(function() {
    Object.defineProperty(Function.prototype, "once", {
        value: function() {
            return $f11560dd8186a095$var$once(this);
        },
        configurable: true
    });
    Object.defineProperty(Function.prototype, "onceStrict", {
        value: function() {
            return $f11560dd8186a095$var$onceStrict(this);
        },
        configurable: true
    });
});
function $f11560dd8186a095$var$once(fn) {
    var f = function() {
        if (f.called) return f.value;
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    f.called = false;
    return f;
}
function $f11560dd8186a095$var$onceStrict(fn) {
    var f = function() {
        if (f.called) throw new Error(f.onceError);
        f.called = true;
        return f.value = fn.apply(this, arguments);
    };
    var name = fn.name || "Function wrapped with `once`";
    f.onceError = name + " shouldn't be called more than once";
    f.called = false;
    return f;
}

});
parcelRegister("82mpb", function(module, exports) {
// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = $5d9fe3dae9c02db7$var$wrappy;
function $5d9fe3dae9c02db7$var$wrappy(fn, cb) {
    if (fn && cb) return $5d9fe3dae9c02db7$var$wrappy(fn)(cb);
    if (typeof fn !== "function") throw new TypeError("need wrapper function");
    Object.keys(fn).forEach(function(k) {
        wrapper[k] = fn[k];
    });
    return wrapper;
    function wrapper() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        var ret = fn.apply(this, args);
        var cb = args[args.length - 1];
        if (typeof ret === "function" && ret !== cb) Object.keys(cb).forEach(function(k) {
            ret[k] = cb[k];
        });
        return ret;
    }
}

});


parcelRegister("k3pns", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $kHhtt = parcelRequire("kHhtt");
var $e997c5e34664990d$var$noop = function() {};
var $e997c5e34664990d$var$isRequest = function(stream) {
    return stream.setHeader && typeof stream.abort === "function";
};
var $e997c5e34664990d$var$isChildProcess = function(stream) {
    return stream.stdio && Array.isArray(stream.stdio) && stream.stdio.length === 3;
};
var $e997c5e34664990d$var$eos = function(stream, opts, callback) {
    if (typeof opts === "function") return $e997c5e34664990d$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $kHhtt(callback || $e997c5e34664990d$var$noop);
    var ws = stream._writableState;
    var rs = stream._readableState;
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var cancelled = false;
    var onlegacyfinish = function() {
        if (!stream.writable) onfinish();
    };
    var onfinish = function() {
        writable = false;
        if (!readable) callback.call(stream);
    };
    var onend = function() {
        readable = false;
        if (!writable) callback.call(stream);
    };
    var onexit = function(exitCode) {
        callback.call(stream, exitCode ? new Error("exited with error code: " + exitCode) : null);
    };
    var onerror = function(err) {
        callback.call(stream, err);
    };
    var onclose = function() {
        $4TNnu.nextTick(onclosenexttick);
    };
    var onclosenexttick = function() {
        if (cancelled) return;
        if (readable && !(rs && rs.ended && !rs.destroyed)) return callback.call(stream, new Error("premature close"));
        if (writable && !(ws && ws.ended && !ws.destroyed)) return callback.call(stream, new Error("premature close"));
    };
    var onrequest = function() {
        stream.req.on("finish", onfinish);
    };
    if ($e997c5e34664990d$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !ws) {
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    if ($e997c5e34664990d$var$isChildProcess(stream)) stream.on("exit", onexit);
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        cancelled = true;
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("exit", onexit);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
};
module.exports = $e997c5e34664990d$var$eos;

});


parcelRegister("dh5rM", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $9aa11693e28e51f3$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");

var $9AddZ = parcelRequire("9AddZ");

var $k3pns = parcelRequire("k3pns");

var $eSHUL = parcelRequire("eSHUL");

var $jE46M = parcelRequire("jE46M");
var $9aa11693e28e51f3$var$SIGNAL_FLUSH = $9aa11693e28e51f3$require$Buffer.from && $9aa11693e28e51f3$require$Buffer.from !== Uint8Array.from ? $9aa11693e28e51f3$require$Buffer.from([
    0
]) : new $9aa11693e28e51f3$require$Buffer([
    0
]);
var $9aa11693e28e51f3$var$onuncork = function(self, fn) {
    if (self._corked) self.once("uncork", fn);
    else fn();
};
var $9aa11693e28e51f3$var$autoDestroy = function(self, err) {
    if (self._autoDestroy) self.destroy(err);
};
var $9aa11693e28e51f3$var$destroyer = function(self, end) {
    return function(err) {
        if (err) $9aa11693e28e51f3$var$autoDestroy(self, err.message === "premature close" ? null : err);
        else if (end && !self._ended) self.end();
    };
};
var $9aa11693e28e51f3$var$end = function(ws, fn) {
    if (!ws) return fn();
    if (ws._writableState && ws._writableState.finished) return fn();
    if (ws._writableState) return ws.end(fn);
    ws.end();
    fn();
};
var $9aa11693e28e51f3$var$noop = function() {};
var $9aa11693e28e51f3$var$toStreams2 = function(rs) {
    return new $9AddZ.Readable({
        objectMode: true,
        highWaterMark: 16
    }).wrap(rs);
};
var $9aa11693e28e51f3$var$Duplexify = function(writable, readable, opts) {
    if (!(this instanceof $9aa11693e28e51f3$var$Duplexify)) return new $9aa11693e28e51f3$var$Duplexify(writable, readable, opts);
    $9AddZ.Duplex.call(this, opts);
    this._writable = null;
    this._readable = null;
    this._readable2 = null;
    this._autoDestroy = !opts || opts.autoDestroy !== false;
    this._forwardDestroy = !opts || opts.destroy !== false;
    this._forwardEnd = !opts || opts.end !== false;
    this._corked = 1 // start corked
    ;
    this._ondrain = null;
    this._drained = false;
    this._forwarding = false;
    this._unwrite = null;
    this._unread = null;
    this._ended = false;
    this.destroyed = false;
    if (writable) this.setWritable(writable);
    if (readable) this.setReadable(readable);
};
$eSHUL($9aa11693e28e51f3$var$Duplexify, $9AddZ.Duplex);
$9aa11693e28e51f3$var$Duplexify.obj = function(writable, readable, opts) {
    if (!opts) opts = {};
    opts.objectMode = true;
    opts.highWaterMark = 16;
    return new $9aa11693e28e51f3$var$Duplexify(writable, readable, opts);
};
$9aa11693e28e51f3$var$Duplexify.prototype.cork = function() {
    if (++this._corked === 1) this.emit("cork");
};
$9aa11693e28e51f3$var$Duplexify.prototype.uncork = function() {
    if (this._corked && --this._corked === 0) this.emit("uncork");
};
$9aa11693e28e51f3$var$Duplexify.prototype.setWritable = function(writable) {
    if (this._unwrite) this._unwrite();
    if (this.destroyed) {
        if (writable && writable.destroy) writable.destroy();
        return;
    }
    if (writable === null || writable === false) {
        this.end();
        return;
    }
    var self = this;
    var unend = $k3pns(writable, {
        writable: true,
        readable: false
    }, $9aa11693e28e51f3$var$destroyer(this, this._forwardEnd));
    var ondrain = function() {
        var ondrain = self._ondrain;
        self._ondrain = null;
        if (ondrain) ondrain();
    };
    var clear = function() {
        self._writable.removeListener("drain", ondrain);
        unend();
    };
    if (this._unwrite) $4TNnu.nextTick(ondrain) // force a drain on stream reset to avoid livelocks
    ;
    this._writable = writable;
    this._writable.on("drain", ondrain);
    this._unwrite = clear;
    this.uncork() // always uncork setWritable
    ;
};
$9aa11693e28e51f3$var$Duplexify.prototype.setReadable = function(readable) {
    if (this._unread) this._unread();
    if (this.destroyed) {
        if (readable && readable.destroy) readable.destroy();
        return;
    }
    if (readable === null || readable === false) {
        this.push(null);
        this.resume();
        return;
    }
    var self = this;
    var unend = $k3pns(readable, {
        writable: false,
        readable: true
    }, $9aa11693e28e51f3$var$destroyer(this));
    var onreadable = function() {
        self._forward();
    };
    var onend = function() {
        self.push(null);
    };
    var clear = function() {
        self._readable2.removeListener("readable", onreadable);
        self._readable2.removeListener("end", onend);
        unend();
    };
    this._drained = true;
    this._readable = readable;
    this._readable2 = readable._readableState ? readable : $9aa11693e28e51f3$var$toStreams2(readable);
    this._readable2.on("readable", onreadable);
    this._readable2.on("end", onend);
    this._unread = clear;
    this._forward();
};
$9aa11693e28e51f3$var$Duplexify.prototype._read = function() {
    this._drained = true;
    this._forward();
};
$9aa11693e28e51f3$var$Duplexify.prototype._forward = function() {
    if (this._forwarding || !this._readable2 || !this._drained) return;
    this._forwarding = true;
    var data;
    while(this._drained && (data = $jE46M(this._readable2)) !== null){
        if (this.destroyed) continue;
        this._drained = this.push(data);
    }
    this._forwarding = false;
};
$9aa11693e28e51f3$var$Duplexify.prototype.destroy = function(err, cb) {
    if (!cb) cb = $9aa11693e28e51f3$var$noop;
    if (this.destroyed) return cb(null);
    this.destroyed = true;
    var self = this;
    $4TNnu.nextTick(function() {
        self._destroy(err);
        cb(null);
    });
};
$9aa11693e28e51f3$var$Duplexify.prototype._destroy = function(err) {
    if (err) {
        var ondrain = this._ondrain;
        this._ondrain = null;
        if (ondrain) ondrain(err);
        else this.emit("error", err);
    }
    if (this._forwardDestroy) {
        if (this._readable && this._readable.destroy) this._readable.destroy();
        if (this._writable && this._writable.destroy) this._writable.destroy();
    }
    this.emit("close");
};
$9aa11693e28e51f3$var$Duplexify.prototype._write = function(data, enc, cb) {
    if (this.destroyed) return;
    if (this._corked) return $9aa11693e28e51f3$var$onuncork(this, this._write.bind(this, data, enc, cb));
    if (data === $9aa11693e28e51f3$var$SIGNAL_FLUSH) return this._finish(cb);
    if (!this._writable) return cb();
    if (this._writable.write(data) === false) this._ondrain = cb;
    else if (!this.destroyed) cb();
};
$9aa11693e28e51f3$var$Duplexify.prototype._finish = function(cb) {
    var self = this;
    this.emit("preend");
    $9aa11693e28e51f3$var$onuncork(this, function() {
        $9aa11693e28e51f3$var$end(self._forwardEnd && self._writable, function() {
            // haxx to not emit prefinish twice
            if (self._writableState.prefinished === false) self._writableState.prefinished = true;
            self.emit("prefinish");
            $9aa11693e28e51f3$var$onuncork(self, cb);
        });
    });
};
$9aa11693e28e51f3$var$Duplexify.prototype.end = function(data, enc, cb) {
    if (typeof data === "function") return this.end(null, null, data);
    if (typeof enc === "function") return this.end(data, null, enc);
    this._ended = true;
    if (data) this.write(data);
    if (!this._writableState.ending) this.write($9aa11693e28e51f3$var$SIGNAL_FLUSH);
    return $9AddZ.Writable.prototype.end.call(this, cb);
};
module.exports = $9aa11693e28e51f3$var$Duplexify;

});
parcelRegister("jE46M", function(module, exports) {
module.exports = $e4d4f097d967820e$var$shift;
function $e4d4f097d967820e$var$shift(stream) {
    var rs = stream._readableState;
    if (!rs) return null;
    return rs.objectMode || typeof stream._duplexState === "number" ? stream.read() : stream.read($e4d4f097d967820e$var$getStateLength(rs));
}
function $e4d4f097d967820e$var$getStateLength(state) {
    if (state.buffer.length) {
        // Since node 6.3.0 state.buffer is a BufferList not an array
        if (state.buffer.head) return state.buffer.head.data.length;
        return state.buffer[0].length;
    }
    return state.length;
}

});



parcelRegister("hH01d", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";

var $9Wff9 = parcelRequire("9Wff9");

var $4kBTp = parcelRequire("4kBTp");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $hKeqt = parcelRequire("hKeqt");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $4kBTp.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$4kBTp.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $hKeqt.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $9Wff9.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $hKeqt.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($4kBTp.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $4kBTp.isObject(this.query) && Object.keys(this.query).length) query = $hKeqt.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($4kBTp.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$4kBTp.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$4kBTp.isNull(result.pathname) || !$4kBTp.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$4kBTp.isNull(result.pathname) || !$4kBTp.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("9Wff9", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("4kBTp", function(module, exports) {
"use strict";
module.exports = {
    isString: function(arg) {
        return typeof arg === "string";
    },
    isObject: function(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function(arg) {
        return arg === null;
    },
    isNullOrUndefined: function(arg) {
        return arg == null;
    }
};

});

parcelRegister("hKeqt", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $ceb1ec40fec4febd$export$98e6a39c04603d36; }, function (v) { return $ceb1ec40fec4febd$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $ceb1ec40fec4febd$export$fac44ee5b035f737; }, function (v) { return $ceb1ec40fec4febd$export$fac44ee5b035f737 = v; });
var $ceb1ec40fec4febd$export$2f872c0f2117be69;
var $ceb1ec40fec4febd$export$98e6a39c04603d36;
var $ceb1ec40fec4febd$export$c564cdbbe6da493;
var $ceb1ec40fec4febd$export$fac44ee5b035f737;
"use strict";

$ceb1ec40fec4febd$export$2f872c0f2117be69 = $ceb1ec40fec4febd$export$98e6a39c04603d36 = (parcelRequire("7fdz3"));

$ceb1ec40fec4febd$export$c564cdbbe6da493 = $ceb1ec40fec4febd$export$fac44ee5b035f737 = (parcelRequire("21Uuv"));

});
parcelRegister("7fdz3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $546474b3babc0f01$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$546474b3babc0f01$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($546474b3babc0f01$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $546474b3babc0f01$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRegister("21Uuv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $17a77eb6fdc3ab55$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $17a77eb6fdc3ab55$var$map($17a77eb6fdc3ab55$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($17a77eb6fdc3ab55$var$stringifyPrimitive(k)) + eq;
        if ($17a77eb6fdc3ab55$var$isArray(obj[k])) return $17a77eb6fdc3ab55$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($17a77eb6fdc3ab55$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($17a77eb6fdc3ab55$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($17a77eb6fdc3ab55$var$stringifyPrimitive(name)) + eq + encodeURIComponent($17a77eb6fdc3ab55$var$stringifyPrimitive(obj));
};
var $17a77eb6fdc3ab55$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $17a77eb6fdc3ab55$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $17a77eb6fdc3ab55$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});



parcelRegister("38MJ4", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $edQZK = parcelRequire("edQZK");
var $2497ea6be5790dd1$require$Transform = $edQZK.Transform;

var $7tMAS = parcelRequire("7tMAS");

var $7QcYH = parcelRequire("7QcYH");

var $6U9mG = parcelRequire("6U9mG");
var $2497ea6be5790dd1$require$Buffer = $6U9mG.Buffer;
module.exports = $2497ea6be5790dd1$var$WebSocketStream;
function $2497ea6be5790dd1$var$buildProxy(options, socketWrite, socketEnd) {
    var proxy = new $2497ea6be5790dd1$require$Transform({
        objectMode: options.objectMode
    });
    proxy._write = socketWrite;
    proxy._flush = socketEnd;
    return proxy;
}
function $2497ea6be5790dd1$var$WebSocketStream(target, protocols, options) {
    var stream, socket;
    var isBrowser = $4TNnu.title === "browser";
    var isNative = !!$parcel$global.WebSocket;
    var socketWrite = isBrowser ? socketWriteBrowser : socketWriteNode;
    if (protocols && !Array.isArray(protocols) && "object" === typeof protocols) {
        // accept the "options" Object as the 2nd argument
        options = protocols;
        protocols = null;
        if (typeof options.protocol === "string" || Array.isArray(options.protocol)) protocols = options.protocol;
    }
    if (!options) options = {};
    if (options.objectMode === undefined) options.objectMode = !(options.binary === true || options.binary === undefined);
    var proxy = $2497ea6be5790dd1$var$buildProxy(options, socketWrite, socketEnd);
    if (!options.objectMode) proxy._writev = writev;
    // browser only: sets the maximum socket buffer size before throttling
    var bufferSize = options.browserBufferSize || 524288;
    // browser only: how long to wait when throttling
    var bufferTimeout = options.browserBufferTimeout || 1000;
    // use existing WebSocket object that was passed in
    if (typeof target === "object") socket = target;
    else {
        // special constructor treatment for native websockets in browsers, see
        // https://github.com/maxogden/websocket-stream/issues/82
        if (isNative && isBrowser) socket = new $7QcYH(target, protocols);
        else socket = new $7QcYH(target, protocols, options);
        socket.binaryType = "arraybuffer";
    }
    // according to https://github.com/baygeldin/ws-streamify/issues/1
    // Nodejs WebSocketServer cause memory leak
    // Handlers like onerror, onclose, onmessage and onopen are accessible via setter/getter
    // And setter first of all fires removeAllListeners, that doesnt make inner array of clients on WebSocketServer cleared ever
    var eventListenerSupport = "undefined" === typeof socket.addEventListener;
    // was already open when passed in
    if (socket.readyState === socket.OPEN) stream = proxy;
    else {
        stream = stream = $7tMAS(undefined, undefined, options);
        if (!options.objectMode) stream._writev = writev;
        if (eventListenerSupport) socket.addEventListener("open", onopen);
        else socket.onopen = onopen;
    }
    stream.socket = socket;
    if (eventListenerSupport) {
        socket.addEventListener("close", onclose);
        socket.addEventListener("error", onerror);
        socket.addEventListener("message", onmessage);
    } else {
        socket.onclose = onclose;
        socket.onerror = onerror;
        socket.onmessage = onmessage;
    }
    proxy.on("close", destroy);
    var coerceToBuffer = !options.objectMode;
    function socketWriteNode(chunk, enc, next) {
        // avoid errors, this never happens unless
        // destroy() is called
        if (socket.readyState !== socket.OPEN) {
            next();
            return;
        }
        if (coerceToBuffer && typeof chunk === "string") chunk = $2497ea6be5790dd1$require$Buffer.from(chunk, "utf8");
        socket.send(chunk, next);
    }
    function socketWriteBrowser(chunk, enc, next) {
        if (socket.bufferedAmount > bufferSize) {
            setTimeout(socketWriteBrowser, bufferTimeout, chunk, enc, next);
            return;
        }
        if (coerceToBuffer && typeof chunk === "string") chunk = $2497ea6be5790dd1$require$Buffer.from(chunk, "utf8");
        try {
            socket.send(chunk);
        } catch (err) {
            return next(err);
        }
        next();
    }
    function socketEnd(done) {
        socket.close();
        done();
    }
    function onopen() {
        stream.setReadable(proxy);
        stream.setWritable(proxy);
        stream.emit("connect");
    }
    function onclose() {
        stream.end();
        stream.destroy();
    }
    function onerror(err) {
        stream.destroy(err);
    }
    function onmessage(event) {
        var data = event.data;
        if (data instanceof ArrayBuffer) data = $2497ea6be5790dd1$require$Buffer.from(data);
        else data = $2497ea6be5790dd1$require$Buffer.from(data, "utf8");
        proxy.push(data);
    }
    function destroy() {
        socket.close();
    }
    // this is to be enabled only if objectMode is false
    function writev(chunks, cb) {
        var buffers = new Array(chunks.length);
        for(var i = 0; i < chunks.length; i++)if (typeof chunks[i].chunk === "string") buffers[i] = $2497ea6be5790dd1$require$Buffer.from(chunks[i], "utf8");
        else buffers[i] = chunks[i].chunk;
        this._write($2497ea6be5790dd1$require$Buffer.concat(buffers), "binary", cb);
    }
    return stream;
}

});
parcelRegister("edQZK", function(module, exports) {

exports = module.exports = (parcelRequire("gGiEd"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3d5nc"));

exports.Duplex = (parcelRequire("jgYJO"));

exports.Transform = (parcelRequire("jjUMi"));

exports.PassThrough = (parcelRequire("3bZCo"));

});
parcelRegister("gGiEd", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $c24f08a25e7fd58c$var$Readable;

var $9ILyq = parcelRequire("9ILyq");
/*</replacement>*/ /*<replacement>*/ var $c24f08a25e7fd58c$var$Duplex;
/*</replacement>*/ $c24f08a25e7fd58c$var$Readable.ReadableState = $c24f08a25e7fd58c$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $c24f08a25e7fd58c$require$EE = $jMc9N.EventEmitter;
var $c24f08a25e7fd58c$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jTOAe = parcelRequire("jTOAe");

var $5JPqm = parcelRequire("5JPqm");
var $c24f08a25e7fd58c$require$Buffer = $5JPqm.Buffer;
var $c24f08a25e7fd58c$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $c24f08a25e7fd58c$var$_uint8ArrayToBuffer(chunk) {
    return $c24f08a25e7fd58c$require$Buffer.from(chunk);
}
function $c24f08a25e7fd58c$var$_isUint8Array(obj) {
    return $c24f08a25e7fd58c$require$Buffer.isBuffer(obj) || obj instanceof $c24f08a25e7fd58c$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $c24f08a25e7fd58c$var$util = Object.create((parcelRequire("iItjM")));

$c24f08a25e7fd58c$var$util.inherits = (parcelRequire("eSHUL"));

var $5Io6y = parcelRequire("5Io6y");
var $c24f08a25e7fd58c$var$debug = void 0;
if ($5Io6y && $5Io6y.debuglog) $c24f08a25e7fd58c$var$debug = $5Io6y.debuglog("stream");
else $c24f08a25e7fd58c$var$debug = function() {};

var $9PviE = parcelRequire("9PviE");

var $5hsQj = parcelRequire("5hsQj");
var $c24f08a25e7fd58c$var$StringDecoder;
$c24f08a25e7fd58c$var$util.inherits($c24f08a25e7fd58c$var$Readable, $jTOAe);
var $c24f08a25e7fd58c$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $c24f08a25e7fd58c$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($9ILyq(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $c24f08a25e7fd58c$var$ReadableState(options, stream) {
    $c24f08a25e7fd58c$var$Duplex = $c24f08a25e7fd58c$var$Duplex || (parcelRequire("jgYJO"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $c24f08a25e7fd58c$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $9PviE();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$c24f08a25e7fd58c$var$StringDecoder) $c24f08a25e7fd58c$var$StringDecoder = (parcelRequire("7Pejd")).StringDecoder;
        this.decoder = new $c24f08a25e7fd58c$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $c24f08a25e7fd58c$var$Readable(options) {
    $c24f08a25e7fd58c$var$Duplex = $c24f08a25e7fd58c$var$Duplex || (parcelRequire("jgYJO"));
    if (!(this instanceof $c24f08a25e7fd58c$var$Readable)) return new $c24f08a25e7fd58c$var$Readable(options);
    this._readableState = new $c24f08a25e7fd58c$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jTOAe.call(this);
}
Object.defineProperty($c24f08a25e7fd58c$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$c24f08a25e7fd58c$var$Readable.prototype.destroy = $5hsQj.destroy;
$c24f08a25e7fd58c$var$Readable.prototype._undestroy = $5hsQj.undestroy;
$c24f08a25e7fd58c$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$c24f08a25e7fd58c$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $c24f08a25e7fd58c$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $c24f08a25e7fd58c$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$c24f08a25e7fd58c$var$Readable.prototype.unshift = function(chunk) {
    return $c24f08a25e7fd58c$var$readableAddChunk(this, chunk, null, true, false);
};
function $c24f08a25e7fd58c$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $c24f08a25e7fd58c$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $c24f08a25e7fd58c$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $c24f08a25e7fd58c$require$Buffer.prototype) chunk = $c24f08a25e7fd58c$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $c24f08a25e7fd58c$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $c24f08a25e7fd58c$var$addChunk(stream, state, chunk, false);
                    else $c24f08a25e7fd58c$var$maybeReadMore(stream, state);
                } else $c24f08a25e7fd58c$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $c24f08a25e7fd58c$var$needMoreData(state);
}
function $c24f08a25e7fd58c$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $c24f08a25e7fd58c$var$emitReadable(stream);
    }
    $c24f08a25e7fd58c$var$maybeReadMore(stream, state);
}
function $c24f08a25e7fd58c$var$chunkInvalid(state, chunk) {
    var er;
    if (!$c24f08a25e7fd58c$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $c24f08a25e7fd58c$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$c24f08a25e7fd58c$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$c24f08a25e7fd58c$var$Readable.prototype.setEncoding = function(enc) {
    if (!$c24f08a25e7fd58c$var$StringDecoder) $c24f08a25e7fd58c$var$StringDecoder = (parcelRequire("7Pejd")).StringDecoder;
    this._readableState.decoder = new $c24f08a25e7fd58c$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $c24f08a25e7fd58c$var$MAX_HWM = 0x800000;
function $c24f08a25e7fd58c$var$computeNewHighWaterMark(n) {
    if (n >= $c24f08a25e7fd58c$var$MAX_HWM) n = $c24f08a25e7fd58c$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c24f08a25e7fd58c$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $c24f08a25e7fd58c$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$c24f08a25e7fd58c$var$Readable.prototype.read = function(n) {
    $c24f08a25e7fd58c$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $c24f08a25e7fd58c$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $c24f08a25e7fd58c$var$endReadable(this);
        else $c24f08a25e7fd58c$var$emitReadable(this);
        return null;
    }
    n = $c24f08a25e7fd58c$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $c24f08a25e7fd58c$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $c24f08a25e7fd58c$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $c24f08a25e7fd58c$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $c24f08a25e7fd58c$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $c24f08a25e7fd58c$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $c24f08a25e7fd58c$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $c24f08a25e7fd58c$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $c24f08a25e7fd58c$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $c24f08a25e7fd58c$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $c24f08a25e7fd58c$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $c24f08a25e7fd58c$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $c24f08a25e7fd58c$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kEUYA.nextTick($c24f08a25e7fd58c$var$emitReadable_, stream);
        else $c24f08a25e7fd58c$var$emitReadable_(stream);
    }
}
function $c24f08a25e7fd58c$var$emitReadable_(stream) {
    $c24f08a25e7fd58c$var$debug("emit readable");
    stream.emit("readable");
    $c24f08a25e7fd58c$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $c24f08a25e7fd58c$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kEUYA.nextTick($c24f08a25e7fd58c$var$maybeReadMore_, stream, state);
    }
}
function $c24f08a25e7fd58c$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $c24f08a25e7fd58c$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$c24f08a25e7fd58c$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$c24f08a25e7fd58c$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $c24f08a25e7fd58c$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kEUYA.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $c24f08a25e7fd58c$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $c24f08a25e7fd58c$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $c24f08a25e7fd58c$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $c24f08a25e7fd58c$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $c24f08a25e7fd58c$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $c24f08a25e7fd58c$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $c24f08a25e7fd58c$var$debug("false write response, pause", src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $c24f08a25e7fd58c$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($c24f08a25e7fd58c$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $c24f08a25e7fd58c$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $c24f08a25e7fd58c$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $c24f08a25e7fd58c$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $c24f08a25e7fd58c$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $c24f08a25e7fd58c$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $c24f08a25e7fd58c$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $c24f08a25e7fd58c$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $c24f08a25e7fd58c$var$flow(src);
        }
    };
}
$c24f08a25e7fd58c$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, unpipeInfo);
        return this;
    }
    // try to find the right one.
    var index = $c24f08a25e7fd58c$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$c24f08a25e7fd58c$var$Readable.prototype.on = function(ev, fn) {
    var res = $jTOAe.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kEUYA.nextTick($c24f08a25e7fd58c$var$nReadingNextTick, this);
            else if (state.length) $c24f08a25e7fd58c$var$emitReadable(this);
        }
    }
    return res;
};
$c24f08a25e7fd58c$var$Readable.prototype.addListener = $c24f08a25e7fd58c$var$Readable.prototype.on;
function $c24f08a25e7fd58c$var$nReadingNextTick(self) {
    $c24f08a25e7fd58c$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$c24f08a25e7fd58c$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $c24f08a25e7fd58c$var$debug("resume");
        state.flowing = true;
        $c24f08a25e7fd58c$var$resume(this, state);
    }
    return this;
};
function $c24f08a25e7fd58c$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kEUYA.nextTick($c24f08a25e7fd58c$var$resume_, stream, state);
    }
}
function $c24f08a25e7fd58c$var$resume_(stream, state) {
    if (!state.reading) {
        $c24f08a25e7fd58c$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $c24f08a25e7fd58c$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$c24f08a25e7fd58c$var$Readable.prototype.pause = function() {
    $c24f08a25e7fd58c$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $c24f08a25e7fd58c$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $c24f08a25e7fd58c$var$flow(stream) {
    var state = stream._readableState;
    $c24f08a25e7fd58c$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$c24f08a25e7fd58c$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $c24f08a25e7fd58c$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $c24f08a25e7fd58c$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $c24f08a25e7fd58c$var$kProxyEvents.length; n++)stream.on($c24f08a25e7fd58c$var$kProxyEvents[n], this.emit.bind(this, $c24f08a25e7fd58c$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $c24f08a25e7fd58c$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($c24f08a25e7fd58c$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$c24f08a25e7fd58c$var$Readable._fromList = $c24f08a25e7fd58c$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c24f08a25e7fd58c$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $c24f08a25e7fd58c$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c24f08a25e7fd58c$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $c24f08a25e7fd58c$var$copyFromBufferString(n, list) : $c24f08a25e7fd58c$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c24f08a25e7fd58c$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $c24f08a25e7fd58c$var$copyFromBuffer(n, list) {
    var ret = $c24f08a25e7fd58c$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $c24f08a25e7fd58c$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kEUYA.nextTick($c24f08a25e7fd58c$var$endReadableNT, state, stream);
    }
}
function $c24f08a25e7fd58c$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $c24f08a25e7fd58c$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jTOAe", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("5JPqm", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $42d90b7ca0a8221b$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $42d90b7ca0a8221b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($42d90b7ca0a8221b$var$Buffer.from && $42d90b7ca0a8221b$var$Buffer.alloc && $42d90b7ca0a8221b$var$Buffer.allocUnsafe && $42d90b7ca0a8221b$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $42d90b7ca0a8221b$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $42d90b7ca0a8221b$var$SafeBuffer;
}
function $42d90b7ca0a8221b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $42d90b7ca0a8221b$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$42d90b7ca0a8221b$var$copyProps($42d90b7ca0a8221b$var$Buffer, $42d90b7ca0a8221b$var$SafeBuffer);
$42d90b7ca0a8221b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $42d90b7ca0a8221b$var$Buffer(arg, encodingOrOffset, length);
};
$42d90b7ca0a8221b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $42d90b7ca0a8221b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$42d90b7ca0a8221b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $42d90b7ca0a8221b$var$Buffer(size);
};
$42d90b7ca0a8221b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});

parcelRegister("9PviE", function(module, exports) {
"use strict";
function $728127f96a928c2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $5JPqm = parcelRequire("5JPqm");
var $728127f96a928c2e$require$Buffer = $5JPqm.Buffer;

var $5Io6y = parcelRequire("5Io6y");
function $728127f96a928c2e$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $728127f96a928c2e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $728127f96a928c2e$require$Buffer.alloc(0);
        if (this.length === 1) return this.head.data;
        var ret = $728127f96a928c2e$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $728127f96a928c2e$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($5Io6y && $5Io6y.inspect && $5Io6y.inspect.custom) module.exports.prototype[$5Io6y.inspect.custom] = function() {
    var obj = $5Io6y.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("5hsQj", function(module, exports) {
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $3d84e9dcdc083e2c$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err && (!this._writableState || !this._writableState.errorEmitted)) $kEUYA.nextTick($3d84e9dcdc083e2c$var$emitErrorNT, this, err);
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            $kEUYA.nextTick($3d84e9dcdc083e2c$var$emitErrorNT, _this, err);
            if (_this._writableState) _this._writableState.errorEmitted = true;
        } else if (cb) cb(err);
    });
    return this;
}
function $3d84e9dcdc083e2c$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $3d84e9dcdc083e2c$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $3d84e9dcdc083e2c$var$destroy,
    undestroy: $3d84e9dcdc083e2c$var$undestroy
};

});

parcelRegister("jgYJO", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ /*<replacement>*/ var $e07ea037432ee48d$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $e07ea037432ee48d$var$Duplex;

/*<replacement>*/ var $e07ea037432ee48d$var$util = Object.create((parcelRequire("iItjM")));

$e07ea037432ee48d$var$util.inherits = (parcelRequire("eSHUL"));

var $gGiEd = parcelRequire("gGiEd");

var $3d5nc = parcelRequire("3d5nc");
$e07ea037432ee48d$var$util.inherits($e07ea037432ee48d$var$Duplex, $gGiEd);
// avoid scope creep, the keys array can then be collected
var $e07ea037432ee48d$var$keys = $e07ea037432ee48d$var$objectKeys($3d5nc.prototype);
for(var $e07ea037432ee48d$var$v = 0; $e07ea037432ee48d$var$v < $e07ea037432ee48d$var$keys.length; $e07ea037432ee48d$var$v++){
    var $e07ea037432ee48d$var$method = $e07ea037432ee48d$var$keys[$e07ea037432ee48d$var$v];
    if (!$e07ea037432ee48d$var$Duplex.prototype[$e07ea037432ee48d$var$method]) $e07ea037432ee48d$var$Duplex.prototype[$e07ea037432ee48d$var$method] = $3d5nc.prototype[$e07ea037432ee48d$var$method];
}
function $e07ea037432ee48d$var$Duplex(options) {
    if (!(this instanceof $e07ea037432ee48d$var$Duplex)) return new $e07ea037432ee48d$var$Duplex(options);
    $gGiEd.call(this, options);
    $3d5nc.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $e07ea037432ee48d$var$onend);
}
Object.defineProperty($e07ea037432ee48d$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $e07ea037432ee48d$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kEUYA.nextTick($e07ea037432ee48d$var$onEndNT, this);
}
function $e07ea037432ee48d$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($e07ea037432ee48d$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$e07ea037432ee48d$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kEUYA.nextTick(cb, err);
};

});
parcelRegister("3d5nc", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $2566c0ff872cf3ad$var$Writable;
/* <replacement> */ function $2566c0ff872cf3ad$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2566c0ff872cf3ad$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2566c0ff872cf3ad$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2566c0ff872cf3ad$var$asyncWrite = (0, $kEUYA.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2566c0ff872cf3ad$var$Duplex;
/*</replacement>*/ $2566c0ff872cf3ad$var$Writable.WritableState = $2566c0ff872cf3ad$var$WritableState;

/*<replacement>*/ var $2566c0ff872cf3ad$var$util = Object.create((parcelRequire("iItjM")));

$2566c0ff872cf3ad$var$util.inherits = (parcelRequire("eSHUL"));

/*</replacement>*/ /*<replacement>*/ var $2566c0ff872cf3ad$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $jTOAe = parcelRequire("jTOAe");

var $5JPqm = parcelRequire("5JPqm");
var $2566c0ff872cf3ad$require$Buffer = $5JPqm.Buffer;
var $2566c0ff872cf3ad$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $2566c0ff872cf3ad$var$_uint8ArrayToBuffer(chunk) {
    return $2566c0ff872cf3ad$require$Buffer.from(chunk);
}
function $2566c0ff872cf3ad$var$_isUint8Array(obj) {
    return $2566c0ff872cf3ad$require$Buffer.isBuffer(obj) || obj instanceof $2566c0ff872cf3ad$var$OurUint8Array;
}

var $5hsQj = parcelRequire("5hsQj");
$2566c0ff872cf3ad$var$util.inherits($2566c0ff872cf3ad$var$Writable, $jTOAe);
function $2566c0ff872cf3ad$var$nop() {}

function $2566c0ff872cf3ad$var$WritableState(options, stream) {
    $2566c0ff872cf3ad$var$Duplex = $2566c0ff872cf3ad$var$Duplex || (parcelRequire("jgYJO"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2566c0ff872cf3ad$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2566c0ff872cf3ad$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2566c0ff872cf3ad$var$CorkedRequest(this);
}
$2566c0ff872cf3ad$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2566c0ff872cf3ad$var$WritableState.prototype, "buffer", {
            get: $2566c0ff872cf3ad$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2566c0ff872cf3ad$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2566c0ff872cf3ad$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2566c0ff872cf3ad$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2566c0ff872cf3ad$var$realHasInstance.call(this, object)) return true;
            if (this !== $2566c0ff872cf3ad$var$Writable) return false;
            return object && object._writableState instanceof $2566c0ff872cf3ad$var$WritableState;
        }
    });
} else $2566c0ff872cf3ad$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2566c0ff872cf3ad$var$Writable(options) {
    $2566c0ff872cf3ad$var$Duplex = $2566c0ff872cf3ad$var$Duplex || (parcelRequire("jgYJO"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2566c0ff872cf3ad$var$realHasInstance.call($2566c0ff872cf3ad$var$Writable, this) && !(this instanceof $2566c0ff872cf3ad$var$Duplex)) return new $2566c0ff872cf3ad$var$Writable(options);
    this._writableState = new $2566c0ff872cf3ad$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jTOAe.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2566c0ff872cf3ad$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $2566c0ff872cf3ad$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $kEUYA.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2566c0ff872cf3ad$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $kEUYA.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2566c0ff872cf3ad$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2566c0ff872cf3ad$var$_isUint8Array(chunk);
    if (isBuf && !$2566c0ff872cf3ad$require$Buffer.isBuffer(chunk)) chunk = $2566c0ff872cf3ad$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2566c0ff872cf3ad$var$nop;
    if (state.ended) $2566c0ff872cf3ad$var$writeAfterEnd(this, cb);
    else if (isBuf || $2566c0ff872cf3ad$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2566c0ff872cf3ad$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2566c0ff872cf3ad$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2566c0ff872cf3ad$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $2566c0ff872cf3ad$var$clearBuffer(this, state);
    }
};
$2566c0ff872cf3ad$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2566c0ff872cf3ad$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2566c0ff872cf3ad$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2566c0ff872cf3ad$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2566c0ff872cf3ad$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2566c0ff872cf3ad$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2566c0ff872cf3ad$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2566c0ff872cf3ad$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2566c0ff872cf3ad$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kEUYA.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kEUYA.nextTick($2566c0ff872cf3ad$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $2566c0ff872cf3ad$var$finishMaybe(stream, state);
    }
}
function $2566c0ff872cf3ad$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2566c0ff872cf3ad$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2566c0ff872cf3ad$var$onwriteStateUpdate(state);
    if (er) $2566c0ff872cf3ad$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2566c0ff872cf3ad$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2566c0ff872cf3ad$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2566c0ff872cf3ad$var$asyncWrite($2566c0ff872cf3ad$var$afterWrite, stream, state, finished, cb);
        else $2566c0ff872cf3ad$var$afterWrite(stream, state, finished, cb);
    }
}
function $2566c0ff872cf3ad$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2566c0ff872cf3ad$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2566c0ff872cf3ad$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2566c0ff872cf3ad$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2566c0ff872cf3ad$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2566c0ff872cf3ad$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2566c0ff872cf3ad$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2566c0ff872cf3ad$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2566c0ff872cf3ad$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$2566c0ff872cf3ad$var$Writable.prototype._writev = null;
$2566c0ff872cf3ad$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $2566c0ff872cf3ad$var$endWritable(this, state, cb);
};
function $2566c0ff872cf3ad$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2566c0ff872cf3ad$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2566c0ff872cf3ad$var$finishMaybe(stream, state);
    });
}
function $2566c0ff872cf3ad$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $kEUYA.nextTick($2566c0ff872cf3ad$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2566c0ff872cf3ad$var$finishMaybe(stream, state) {
    var need = $2566c0ff872cf3ad$var$needFinish(state);
    if (need) {
        $2566c0ff872cf3ad$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $2566c0ff872cf3ad$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2566c0ff872cf3ad$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kEUYA.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2566c0ff872cf3ad$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    if (state.corkedRequestsFree) state.corkedRequestsFree.next = corkReq;
    else state.corkedRequestsFree = corkReq;
}
Object.defineProperty($2566c0ff872cf3ad$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2566c0ff872cf3ad$var$Writable.prototype.destroy = $5hsQj.destroy;
$2566c0ff872cf3ad$var$Writable.prototype._undestroy = $5hsQj.undestroy;
$2566c0ff872cf3ad$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("7Pejd", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $5b286542548635e4$export$63a7aa211a91ed69; }, function (v) { return $5b286542548635e4$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $5b286542548635e4$export$63a7aa211a91ed69;
"use strict";

var $2wFCi = parcelRequire("2wFCi");
var $5b286542548635e4$require$Buffer = $2wFCi.Buffer;
/*</replacement>*/ var $5b286542548635e4$var$isEncoding = $5b286542548635e4$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $5b286542548635e4$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $5b286542548635e4$var$normalizeEncoding(enc) {
    var nenc = $5b286542548635e4$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($5b286542548635e4$require$Buffer.isEncoding === $5b286542548635e4$var$isEncoding || !$5b286542548635e4$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$5b286542548635e4$export$63a7aa211a91ed69 = $5b286542548635e4$var$StringDecoder;
function $5b286542548635e4$var$StringDecoder(encoding) {
    this.encoding = $5b286542548635e4$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $5b286542548635e4$var$utf16Text;
            this.end = $5b286542548635e4$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $5b286542548635e4$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $5b286542548635e4$var$base64Text;
            this.end = $5b286542548635e4$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $5b286542548635e4$var$simpleWrite;
            this.end = $5b286542548635e4$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $5b286542548635e4$require$Buffer.allocUnsafe(nb);
}
$5b286542548635e4$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$5b286542548635e4$var$StringDecoder.prototype.end = $5b286542548635e4$var$utf8End;
// Returns only complete characters in a Buffer
$5b286542548635e4$var$StringDecoder.prototype.text = $5b286542548635e4$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$5b286542548635e4$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $5b286542548635e4$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $5b286542548635e4$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $5b286542548635e4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $5b286542548635e4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $5b286542548635e4$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $5b286542548635e4$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $5b286542548635e4$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $5b286542548635e4$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $5b286542548635e4$var$utf8Text(buf, i) {
    var total = $5b286542548635e4$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $5b286542548635e4$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $5b286542548635e4$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $5b286542548635e4$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $5b286542548635e4$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $5b286542548635e4$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $5b286542548635e4$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $5b286542548635e4$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});
parcelRegister("2wFCi", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $1d6eda22cbabf65b$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $1d6eda22cbabf65b$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1d6eda22cbabf65b$var$Buffer.from && $1d6eda22cbabf65b$var$Buffer.alloc && $1d6eda22cbabf65b$var$Buffer.allocUnsafe && $1d6eda22cbabf65b$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $1d6eda22cbabf65b$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $1d6eda22cbabf65b$var$SafeBuffer;
}
function $1d6eda22cbabf65b$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1d6eda22cbabf65b$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$1d6eda22cbabf65b$var$copyProps($1d6eda22cbabf65b$var$Buffer, $1d6eda22cbabf65b$var$SafeBuffer);
$1d6eda22cbabf65b$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1d6eda22cbabf65b$var$Buffer(arg, encodingOrOffset, length);
};
$1d6eda22cbabf65b$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1d6eda22cbabf65b$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1d6eda22cbabf65b$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1d6eda22cbabf65b$var$Buffer(size);
};
$1d6eda22cbabf65b$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});



parcelRegister("jjUMi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e10bd5996b6e31a0$var$Transform;

var $jgYJO = parcelRequire("jgYJO");

/*<replacement>*/ var $e10bd5996b6e31a0$var$util = Object.create((parcelRequire("iItjM")));

$e10bd5996b6e31a0$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $e10bd5996b6e31a0$var$util.inherits($e10bd5996b6e31a0$var$Transform, $jgYJO);
function $e10bd5996b6e31a0$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e10bd5996b6e31a0$var$Transform(options) {
    if (!(this instanceof $e10bd5996b6e31a0$var$Transform)) return new $e10bd5996b6e31a0$var$Transform(options);
    $jgYJO.call(this, options);
    this._transformState = {
        afterTransform: $e10bd5996b6e31a0$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e10bd5996b6e31a0$var$prefinish);
}
function $e10bd5996b6e31a0$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $e10bd5996b6e31a0$var$done(_this, er, data);
    });
    else $e10bd5996b6e31a0$var$done(this, null, null);
}
$e10bd5996b6e31a0$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $jgYJO.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e10bd5996b6e31a0$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$e10bd5996b6e31a0$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e10bd5996b6e31a0$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e10bd5996b6e31a0$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $jgYJO.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $e10bd5996b6e31a0$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("3bZCo", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $25323240cd3af4ed$var$PassThrough;

var $jjUMi = parcelRequire("jjUMi");

/*<replacement>*/ var $25323240cd3af4ed$var$util = Object.create((parcelRequire("iItjM")));

$25323240cd3af4ed$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $25323240cd3af4ed$var$util.inherits($25323240cd3af4ed$var$PassThrough, $jjUMi);
function $25323240cd3af4ed$var$PassThrough(options) {
    if (!(this instanceof $25323240cd3af4ed$var$PassThrough)) return new $25323240cd3af4ed$var$PassThrough(options);
    $jjUMi.call(this, options);
}
$25323240cd3af4ed$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("7tMAS", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5720ef869096bc14$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");

var $jq3IT = parcelRequire("jq3IT");

var $k3pns = parcelRequire("k3pns");

var $eSHUL = parcelRequire("eSHUL");

var $jE46M = parcelRequire("jE46M");
var $5720ef869096bc14$var$SIGNAL_FLUSH = $5720ef869096bc14$require$Buffer.from && $5720ef869096bc14$require$Buffer.from !== Uint8Array.from ? $5720ef869096bc14$require$Buffer.from([
    0
]) : new $5720ef869096bc14$require$Buffer([
    0
]);
var $5720ef869096bc14$var$onuncork = function(self, fn) {
    if (self._corked) self.once("uncork", fn);
    else fn();
};
var $5720ef869096bc14$var$autoDestroy = function(self, err) {
    if (self._autoDestroy) self.destroy(err);
};
var $5720ef869096bc14$var$destroyer = function(self, end) {
    return function(err) {
        if (err) $5720ef869096bc14$var$autoDestroy(self, err.message === "premature close" ? null : err);
        else if (end && !self._ended) self.end();
    };
};
var $5720ef869096bc14$var$end = function(ws, fn) {
    if (!ws) return fn();
    if (ws._writableState && ws._writableState.finished) return fn();
    if (ws._writableState) return ws.end(fn);
    ws.end();
    fn();
};
var $5720ef869096bc14$var$toStreams2 = function(rs) {
    return new $jq3IT.Readable({
        objectMode: true,
        highWaterMark: 16
    }).wrap(rs);
};
var $5720ef869096bc14$var$Duplexify = function(writable, readable, opts) {
    if (!(this instanceof $5720ef869096bc14$var$Duplexify)) return new $5720ef869096bc14$var$Duplexify(writable, readable, opts);
    $jq3IT.Duplex.call(this, opts);
    this._writable = null;
    this._readable = null;
    this._readable2 = null;
    this._autoDestroy = !opts || opts.autoDestroy !== false;
    this._forwardDestroy = !opts || opts.destroy !== false;
    this._forwardEnd = !opts || opts.end !== false;
    this._corked = 1 // start corked
    ;
    this._ondrain = null;
    this._drained = false;
    this._forwarding = false;
    this._unwrite = null;
    this._unread = null;
    this._ended = false;
    this.destroyed = false;
    if (writable) this.setWritable(writable);
    if (readable) this.setReadable(readable);
};
$eSHUL($5720ef869096bc14$var$Duplexify, $jq3IT.Duplex);
$5720ef869096bc14$var$Duplexify.obj = function(writable, readable, opts) {
    if (!opts) opts = {};
    opts.objectMode = true;
    opts.highWaterMark = 16;
    return new $5720ef869096bc14$var$Duplexify(writable, readable, opts);
};
$5720ef869096bc14$var$Duplexify.prototype.cork = function() {
    if (++this._corked === 1) this.emit("cork");
};
$5720ef869096bc14$var$Duplexify.prototype.uncork = function() {
    if (this._corked && --this._corked === 0) this.emit("uncork");
};
$5720ef869096bc14$var$Duplexify.prototype.setWritable = function(writable) {
    if (this._unwrite) this._unwrite();
    if (this.destroyed) {
        if (writable && writable.destroy) writable.destroy();
        return;
    }
    if (writable === null || writable === false) {
        this.end();
        return;
    }
    var self = this;
    var unend = $k3pns(writable, {
        writable: true,
        readable: false
    }, $5720ef869096bc14$var$destroyer(this, this._forwardEnd));
    var ondrain = function() {
        var ondrain = self._ondrain;
        self._ondrain = null;
        if (ondrain) ondrain();
    };
    var clear = function() {
        self._writable.removeListener("drain", ondrain);
        unend();
    };
    if (this._unwrite) $4TNnu.nextTick(ondrain) // force a drain on stream reset to avoid livelocks
    ;
    this._writable = writable;
    this._writable.on("drain", ondrain);
    this._unwrite = clear;
    this.uncork() // always uncork setWritable
    ;
};
$5720ef869096bc14$var$Duplexify.prototype.setReadable = function(readable) {
    if (this._unread) this._unread();
    if (this.destroyed) {
        if (readable && readable.destroy) readable.destroy();
        return;
    }
    if (readable === null || readable === false) {
        this.push(null);
        this.resume();
        return;
    }
    var self = this;
    var unend = $k3pns(readable, {
        writable: false,
        readable: true
    }, $5720ef869096bc14$var$destroyer(this));
    var onreadable = function() {
        self._forward();
    };
    var onend = function() {
        self.push(null);
    };
    var clear = function() {
        self._readable2.removeListener("readable", onreadable);
        self._readable2.removeListener("end", onend);
        unend();
    };
    this._drained = true;
    this._readable = readable;
    this._readable2 = readable._readableState ? readable : $5720ef869096bc14$var$toStreams2(readable);
    this._readable2.on("readable", onreadable);
    this._readable2.on("end", onend);
    this._unread = clear;
    this._forward();
};
$5720ef869096bc14$var$Duplexify.prototype._read = function() {
    this._drained = true;
    this._forward();
};
$5720ef869096bc14$var$Duplexify.prototype._forward = function() {
    if (this._forwarding || !this._readable2 || !this._drained) return;
    this._forwarding = true;
    var data;
    while(this._drained && (data = $jE46M(this._readable2)) !== null){
        if (this.destroyed) continue;
        this._drained = this.push(data);
    }
    this._forwarding = false;
};
$5720ef869096bc14$var$Duplexify.prototype.destroy = function(err) {
    if (this.destroyed) return;
    this.destroyed = true;
    var self = this;
    $4TNnu.nextTick(function() {
        self._destroy(err);
    });
};
$5720ef869096bc14$var$Duplexify.prototype._destroy = function(err) {
    if (err) {
        var ondrain = this._ondrain;
        this._ondrain = null;
        if (ondrain) ondrain(err);
        else this.emit("error", err);
    }
    if (this._forwardDestroy) {
        if (this._readable && this._readable.destroy) this._readable.destroy();
        if (this._writable && this._writable.destroy) this._writable.destroy();
    }
    this.emit("close");
};
$5720ef869096bc14$var$Duplexify.prototype._write = function(data, enc, cb) {
    if (this.destroyed) return cb();
    if (this._corked) return $5720ef869096bc14$var$onuncork(this, this._write.bind(this, data, enc, cb));
    if (data === $5720ef869096bc14$var$SIGNAL_FLUSH) return this._finish(cb);
    if (!this._writable) return cb();
    if (this._writable.write(data) === false) this._ondrain = cb;
    else cb();
};
$5720ef869096bc14$var$Duplexify.prototype._finish = function(cb) {
    var self = this;
    this.emit("preend");
    $5720ef869096bc14$var$onuncork(this, function() {
        $5720ef869096bc14$var$end(self._forwardEnd && self._writable, function() {
            // haxx to not emit prefinish twice
            if (self._writableState.prefinished === false) self._writableState.prefinished = true;
            self.emit("prefinish");
            $5720ef869096bc14$var$onuncork(self, cb);
        });
    });
};
$5720ef869096bc14$var$Duplexify.prototype.end = function(data, enc, cb) {
    if (typeof data === "function") return this.end(null, null, data);
    if (typeof enc === "function") return this.end(data, null, enc);
    this._ended = true;
    if (data) this.write(data);
    if (!this._writableState.ending) this.write($5720ef869096bc14$var$SIGNAL_FLUSH);
    return $jq3IT.Writable.prototype.end.call(this, cb);
};
module.exports = $5720ef869096bc14$var$Duplexify;

});
parcelRegister("jq3IT", function(module, exports) {

exports = module.exports = (parcelRequire("1qnZ9"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("c7ZKt"));

exports.Duplex = (parcelRequire("bgcMJ"));

exports.Transform = (parcelRequire("7n1zQ"));

exports.PassThrough = (parcelRequire("kRqxh"));

});
parcelRegister("1qnZ9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $109ad326d9d01aaf$var$Readable;

var $9ILyq = parcelRequire("9ILyq");
/*</replacement>*/ /*<replacement>*/ var $109ad326d9d01aaf$var$Duplex;
/*</replacement>*/ $109ad326d9d01aaf$var$Readable.ReadableState = $109ad326d9d01aaf$var$ReadableState;

var $jMc9N = parcelRequire("jMc9N");
var $109ad326d9d01aaf$require$EE = $jMc9N.EventEmitter;
var $109ad326d9d01aaf$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $bNlFI = parcelRequire("bNlFI");

var $jT9LW = parcelRequire("jT9LW");
var $109ad326d9d01aaf$require$Buffer = $jT9LW.Buffer;
var $109ad326d9d01aaf$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $109ad326d9d01aaf$var$_uint8ArrayToBuffer(chunk) {
    return $109ad326d9d01aaf$require$Buffer.from(chunk);
}
function $109ad326d9d01aaf$var$_isUint8Array(obj) {
    return $109ad326d9d01aaf$require$Buffer.isBuffer(obj) || obj instanceof $109ad326d9d01aaf$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $109ad326d9d01aaf$var$util = Object.create((parcelRequire("iItjM")));

$109ad326d9d01aaf$var$util.inherits = (parcelRequire("eSHUL"));

var $5Io6y = parcelRequire("5Io6y");
var $109ad326d9d01aaf$var$debug = void 0;
if ($5Io6y && $5Io6y.debuglog) $109ad326d9d01aaf$var$debug = $5Io6y.debuglog("stream");
else $109ad326d9d01aaf$var$debug = function() {};

var $lMsOI = parcelRequire("lMsOI");

var $37rEc = parcelRequire("37rEc");
var $109ad326d9d01aaf$var$StringDecoder;
$109ad326d9d01aaf$var$util.inherits($109ad326d9d01aaf$var$Readable, $bNlFI);
var $109ad326d9d01aaf$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $109ad326d9d01aaf$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($9ILyq(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $109ad326d9d01aaf$var$ReadableState(options, stream) {
    $109ad326d9d01aaf$var$Duplex = $109ad326d9d01aaf$var$Duplex || (parcelRequire("bgcMJ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $109ad326d9d01aaf$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $lMsOI();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$109ad326d9d01aaf$var$StringDecoder) $109ad326d9d01aaf$var$StringDecoder = (parcelRequire("9FjVZ")).StringDecoder;
        this.decoder = new $109ad326d9d01aaf$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $109ad326d9d01aaf$var$Readable(options) {
    $109ad326d9d01aaf$var$Duplex = $109ad326d9d01aaf$var$Duplex || (parcelRequire("bgcMJ"));
    if (!(this instanceof $109ad326d9d01aaf$var$Readable)) return new $109ad326d9d01aaf$var$Readable(options);
    this._readableState = new $109ad326d9d01aaf$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $bNlFI.call(this);
}
Object.defineProperty($109ad326d9d01aaf$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$109ad326d9d01aaf$var$Readable.prototype.destroy = $37rEc.destroy;
$109ad326d9d01aaf$var$Readable.prototype._undestroy = $37rEc.undestroy;
$109ad326d9d01aaf$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$109ad326d9d01aaf$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $109ad326d9d01aaf$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $109ad326d9d01aaf$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$109ad326d9d01aaf$var$Readable.prototype.unshift = function(chunk) {
    return $109ad326d9d01aaf$var$readableAddChunk(this, chunk, null, true, false);
};
function $109ad326d9d01aaf$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $109ad326d9d01aaf$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $109ad326d9d01aaf$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $109ad326d9d01aaf$require$Buffer.prototype) chunk = $109ad326d9d01aaf$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $109ad326d9d01aaf$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $109ad326d9d01aaf$var$addChunk(stream, state, chunk, false);
                    else $109ad326d9d01aaf$var$maybeReadMore(stream, state);
                } else $109ad326d9d01aaf$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $109ad326d9d01aaf$var$needMoreData(state);
}
function $109ad326d9d01aaf$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $109ad326d9d01aaf$var$emitReadable(stream);
    }
    $109ad326d9d01aaf$var$maybeReadMore(stream, state);
}
function $109ad326d9d01aaf$var$chunkInvalid(state, chunk) {
    var er;
    if (!$109ad326d9d01aaf$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $109ad326d9d01aaf$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$109ad326d9d01aaf$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$109ad326d9d01aaf$var$Readable.prototype.setEncoding = function(enc) {
    if (!$109ad326d9d01aaf$var$StringDecoder) $109ad326d9d01aaf$var$StringDecoder = (parcelRequire("9FjVZ")).StringDecoder;
    this._readableState.decoder = new $109ad326d9d01aaf$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $109ad326d9d01aaf$var$MAX_HWM = 0x800000;
function $109ad326d9d01aaf$var$computeNewHighWaterMark(n) {
    if (n >= $109ad326d9d01aaf$var$MAX_HWM) n = $109ad326d9d01aaf$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $109ad326d9d01aaf$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $109ad326d9d01aaf$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$109ad326d9d01aaf$var$Readable.prototype.read = function(n) {
    $109ad326d9d01aaf$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $109ad326d9d01aaf$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $109ad326d9d01aaf$var$endReadable(this);
        else $109ad326d9d01aaf$var$emitReadable(this);
        return null;
    }
    n = $109ad326d9d01aaf$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $109ad326d9d01aaf$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $109ad326d9d01aaf$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $109ad326d9d01aaf$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $109ad326d9d01aaf$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $109ad326d9d01aaf$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $109ad326d9d01aaf$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $109ad326d9d01aaf$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $109ad326d9d01aaf$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $109ad326d9d01aaf$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $109ad326d9d01aaf$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $109ad326d9d01aaf$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $109ad326d9d01aaf$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kEUYA.nextTick($109ad326d9d01aaf$var$emitReadable_, stream);
        else $109ad326d9d01aaf$var$emitReadable_(stream);
    }
}
function $109ad326d9d01aaf$var$emitReadable_(stream) {
    $109ad326d9d01aaf$var$debug("emit readable");
    stream.emit("readable");
    $109ad326d9d01aaf$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $109ad326d9d01aaf$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kEUYA.nextTick($109ad326d9d01aaf$var$maybeReadMore_, stream, state);
    }
}
function $109ad326d9d01aaf$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $109ad326d9d01aaf$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$109ad326d9d01aaf$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$109ad326d9d01aaf$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $109ad326d9d01aaf$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4TNnu.stdout && dest !== $4TNnu.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kEUYA.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $109ad326d9d01aaf$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $109ad326d9d01aaf$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $109ad326d9d01aaf$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $109ad326d9d01aaf$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $109ad326d9d01aaf$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $109ad326d9d01aaf$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $109ad326d9d01aaf$var$debug("false write response, pause", src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $109ad326d9d01aaf$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($109ad326d9d01aaf$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $109ad326d9d01aaf$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $109ad326d9d01aaf$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $109ad326d9d01aaf$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $109ad326d9d01aaf$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $109ad326d9d01aaf$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $109ad326d9d01aaf$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $109ad326d9d01aaf$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $109ad326d9d01aaf$var$flow(src);
        }
    };
}
$109ad326d9d01aaf$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, unpipeInfo);
        return this;
    }
    // try to find the right one.
    var index = $109ad326d9d01aaf$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$109ad326d9d01aaf$var$Readable.prototype.on = function(ev, fn) {
    var res = $bNlFI.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kEUYA.nextTick($109ad326d9d01aaf$var$nReadingNextTick, this);
            else if (state.length) $109ad326d9d01aaf$var$emitReadable(this);
        }
    }
    return res;
};
$109ad326d9d01aaf$var$Readable.prototype.addListener = $109ad326d9d01aaf$var$Readable.prototype.on;
function $109ad326d9d01aaf$var$nReadingNextTick(self) {
    $109ad326d9d01aaf$var$debug("readable nexttick read 0");
    self.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$109ad326d9d01aaf$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $109ad326d9d01aaf$var$debug("resume");
        state.flowing = true;
        $109ad326d9d01aaf$var$resume(this, state);
    }
    return this;
};
function $109ad326d9d01aaf$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kEUYA.nextTick($109ad326d9d01aaf$var$resume_, stream, state);
    }
}
function $109ad326d9d01aaf$var$resume_(stream, state) {
    if (!state.reading) {
        $109ad326d9d01aaf$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $109ad326d9d01aaf$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$109ad326d9d01aaf$var$Readable.prototype.pause = function() {
    $109ad326d9d01aaf$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $109ad326d9d01aaf$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $109ad326d9d01aaf$var$flow(stream) {
    var state = stream._readableState;
    $109ad326d9d01aaf$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$109ad326d9d01aaf$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $109ad326d9d01aaf$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $109ad326d9d01aaf$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $109ad326d9d01aaf$var$kProxyEvents.length; n++)stream.on($109ad326d9d01aaf$var$kProxyEvents[n], this.emit.bind(this, $109ad326d9d01aaf$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $109ad326d9d01aaf$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($109ad326d9d01aaf$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$109ad326d9d01aaf$var$Readable._fromList = $109ad326d9d01aaf$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $109ad326d9d01aaf$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $109ad326d9d01aaf$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $109ad326d9d01aaf$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $109ad326d9d01aaf$var$copyFromBufferString(n, list) : $109ad326d9d01aaf$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $109ad326d9d01aaf$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $109ad326d9d01aaf$var$copyFromBuffer(n, list) {
    var ret = $109ad326d9d01aaf$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $109ad326d9d01aaf$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kEUYA.nextTick($109ad326d9d01aaf$var$endReadableNT, state, stream);
    }
}
function $109ad326d9d01aaf$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $109ad326d9d01aaf$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bNlFI", function(module, exports) {

module.exports = (parcelRequire("jMc9N")).EventEmitter;

});

parcelRegister("jT9LW", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $ihoyg = parcelRequire("ihoyg");
var $e7aabbf58ca0c4a2$var$Buffer = $ihoyg.Buffer;
// alternative to using Object.keys for old browsers
function $e7aabbf58ca0c4a2$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($e7aabbf58ca0c4a2$var$Buffer.from && $e7aabbf58ca0c4a2$var$Buffer.alloc && $e7aabbf58ca0c4a2$var$Buffer.allocUnsafe && $e7aabbf58ca0c4a2$var$Buffer.allocUnsafeSlow) module.exports = $ihoyg;
else {
    // Copy properties from require('buffer')
    $e7aabbf58ca0c4a2$var$copyProps($ihoyg, module.exports);
    module.exports.Buffer = $e7aabbf58ca0c4a2$var$SafeBuffer;
}
function $e7aabbf58ca0c4a2$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $e7aabbf58ca0c4a2$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$e7aabbf58ca0c4a2$var$copyProps($e7aabbf58ca0c4a2$var$Buffer, $e7aabbf58ca0c4a2$var$SafeBuffer);
$e7aabbf58ca0c4a2$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $e7aabbf58ca0c4a2$var$Buffer(arg, encodingOrOffset, length);
};
$e7aabbf58ca0c4a2$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $e7aabbf58ca0c4a2$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$e7aabbf58ca0c4a2$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $e7aabbf58ca0c4a2$var$Buffer(size);
};
$e7aabbf58ca0c4a2$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $ihoyg.SlowBuffer(size);
};

});

parcelRegister("lMsOI", function(module, exports) {
"use strict";
function $fdb46f21dc000463$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $jT9LW = parcelRequire("jT9LW");
var $fdb46f21dc000463$require$Buffer = $jT9LW.Buffer;

var $5Io6y = parcelRequire("5Io6y");
function $fdb46f21dc000463$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $fdb46f21dc000463$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $fdb46f21dc000463$require$Buffer.alloc(0);
        if (this.length === 1) return this.head.data;
        var ret = $fdb46f21dc000463$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $fdb46f21dc000463$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($5Io6y && $5Io6y.inspect && $5Io6y.inspect.custom) module.exports.prototype[$5Io6y.inspect.custom] = function() {
    var obj = $5Io6y.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("37rEc", function(module, exports) {
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $245778be78488bef$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err && (!this._writableState || !this._writableState.errorEmitted)) $kEUYA.nextTick($245778be78488bef$var$emitErrorNT, this, err);
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            $kEUYA.nextTick($245778be78488bef$var$emitErrorNT, _this, err);
            if (_this._writableState) _this._writableState.errorEmitted = true;
        } else if (cb) cb(err);
    });
    return this;
}
function $245778be78488bef$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $245778be78488bef$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $245778be78488bef$var$destroy,
    undestroy: $245778be78488bef$var$undestroy
};

});

parcelRegister("bgcMJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ /*<replacement>*/ var $832b1b2ce11190cb$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $832b1b2ce11190cb$var$Duplex;

/*<replacement>*/ var $832b1b2ce11190cb$var$util = Object.create((parcelRequire("iItjM")));

$832b1b2ce11190cb$var$util.inherits = (parcelRequire("eSHUL"));

var $1qnZ9 = parcelRequire("1qnZ9");

var $c7ZKt = parcelRequire("c7ZKt");
$832b1b2ce11190cb$var$util.inherits($832b1b2ce11190cb$var$Duplex, $1qnZ9);
// avoid scope creep, the keys array can then be collected
var $832b1b2ce11190cb$var$keys = $832b1b2ce11190cb$var$objectKeys($c7ZKt.prototype);
for(var $832b1b2ce11190cb$var$v = 0; $832b1b2ce11190cb$var$v < $832b1b2ce11190cb$var$keys.length; $832b1b2ce11190cb$var$v++){
    var $832b1b2ce11190cb$var$method = $832b1b2ce11190cb$var$keys[$832b1b2ce11190cb$var$v];
    if (!$832b1b2ce11190cb$var$Duplex.prototype[$832b1b2ce11190cb$var$method]) $832b1b2ce11190cb$var$Duplex.prototype[$832b1b2ce11190cb$var$method] = $c7ZKt.prototype[$832b1b2ce11190cb$var$method];
}
function $832b1b2ce11190cb$var$Duplex(options) {
    if (!(this instanceof $832b1b2ce11190cb$var$Duplex)) return new $832b1b2ce11190cb$var$Duplex(options);
    $1qnZ9.call(this, options);
    $c7ZKt.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $832b1b2ce11190cb$var$onend);
}
Object.defineProperty($832b1b2ce11190cb$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $832b1b2ce11190cb$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kEUYA.nextTick($832b1b2ce11190cb$var$onEndNT, this);
}
function $832b1b2ce11190cb$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($832b1b2ce11190cb$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$832b1b2ce11190cb$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kEUYA.nextTick(cb, err);
};

});
parcelRegister("c7ZKt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $kEUYA = parcelRequire("kEUYA");
/*</replacement>*/ module.exports = $8d46097aa91ae1e7$var$Writable;
/* <replacement> */ function $8d46097aa91ae1e7$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $8d46097aa91ae1e7$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $8d46097aa91ae1e7$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $8d46097aa91ae1e7$var$asyncWrite = (0, $kEUYA.nextTick);
/*</replacement>*/ /*<replacement>*/ var $8d46097aa91ae1e7$var$Duplex;
/*</replacement>*/ $8d46097aa91ae1e7$var$Writable.WritableState = $8d46097aa91ae1e7$var$WritableState;

/*<replacement>*/ var $8d46097aa91ae1e7$var$util = Object.create((parcelRequire("iItjM")));

$8d46097aa91ae1e7$var$util.inherits = (parcelRequire("eSHUL"));

/*</replacement>*/ /*<replacement>*/ var $8d46097aa91ae1e7$var$internalUtil = {
    deprecate: (parcelRequire("l4FQK"))
};

var $bNlFI = parcelRequire("bNlFI");

var $jT9LW = parcelRequire("jT9LW");
var $8d46097aa91ae1e7$require$Buffer = $jT9LW.Buffer;
var $8d46097aa91ae1e7$var$OurUint8Array = $parcel$global.Uint8Array || function() {};
function $8d46097aa91ae1e7$var$_uint8ArrayToBuffer(chunk) {
    return $8d46097aa91ae1e7$require$Buffer.from(chunk);
}
function $8d46097aa91ae1e7$var$_isUint8Array(obj) {
    return $8d46097aa91ae1e7$require$Buffer.isBuffer(obj) || obj instanceof $8d46097aa91ae1e7$var$OurUint8Array;
}

var $37rEc = parcelRequire("37rEc");
$8d46097aa91ae1e7$var$util.inherits($8d46097aa91ae1e7$var$Writable, $bNlFI);
function $8d46097aa91ae1e7$var$nop() {}

function $8d46097aa91ae1e7$var$WritableState(options, stream) {
    $8d46097aa91ae1e7$var$Duplex = $8d46097aa91ae1e7$var$Duplex || (parcelRequire("bgcMJ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $8d46097aa91ae1e7$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $8d46097aa91ae1e7$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $8d46097aa91ae1e7$var$CorkedRequest(this);
}
$8d46097aa91ae1e7$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($8d46097aa91ae1e7$var$WritableState.prototype, "buffer", {
            get: $8d46097aa91ae1e7$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $8d46097aa91ae1e7$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $8d46097aa91ae1e7$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($8d46097aa91ae1e7$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($8d46097aa91ae1e7$var$realHasInstance.call(this, object)) return true;
            if (this !== $8d46097aa91ae1e7$var$Writable) return false;
            return object && object._writableState instanceof $8d46097aa91ae1e7$var$WritableState;
        }
    });
} else $8d46097aa91ae1e7$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $8d46097aa91ae1e7$var$Writable(options) {
    $8d46097aa91ae1e7$var$Duplex = $8d46097aa91ae1e7$var$Duplex || (parcelRequire("bgcMJ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$8d46097aa91ae1e7$var$realHasInstance.call($8d46097aa91ae1e7$var$Writable, this) && !(this instanceof $8d46097aa91ae1e7$var$Duplex)) return new $8d46097aa91ae1e7$var$Writable(options);
    this._writableState = new $8d46097aa91ae1e7$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $bNlFI.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$8d46097aa91ae1e7$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $8d46097aa91ae1e7$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $kEUYA.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $8d46097aa91ae1e7$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $kEUYA.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$8d46097aa91ae1e7$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $8d46097aa91ae1e7$var$_isUint8Array(chunk);
    if (isBuf && !$8d46097aa91ae1e7$require$Buffer.isBuffer(chunk)) chunk = $8d46097aa91ae1e7$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $8d46097aa91ae1e7$var$nop;
    if (state.ended) $8d46097aa91ae1e7$var$writeAfterEnd(this, cb);
    else if (isBuf || $8d46097aa91ae1e7$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $8d46097aa91ae1e7$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$8d46097aa91ae1e7$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$8d46097aa91ae1e7$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $8d46097aa91ae1e7$var$clearBuffer(this, state);
    }
};
$8d46097aa91ae1e7$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $8d46097aa91ae1e7$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $8d46097aa91ae1e7$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($8d46097aa91ae1e7$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $8d46097aa91ae1e7$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $8d46097aa91ae1e7$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $8d46097aa91ae1e7$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $8d46097aa91ae1e7$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $8d46097aa91ae1e7$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kEUYA.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kEUYA.nextTick($8d46097aa91ae1e7$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $8d46097aa91ae1e7$var$finishMaybe(stream, state);
    }
}
function $8d46097aa91ae1e7$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $8d46097aa91ae1e7$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $8d46097aa91ae1e7$var$onwriteStateUpdate(state);
    if (er) $8d46097aa91ae1e7$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $8d46097aa91ae1e7$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $8d46097aa91ae1e7$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $8d46097aa91ae1e7$var$asyncWrite($8d46097aa91ae1e7$var$afterWrite, stream, state, finished, cb);
        else $8d46097aa91ae1e7$var$afterWrite(stream, state, finished, cb);
    }
}
function $8d46097aa91ae1e7$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $8d46097aa91ae1e7$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $8d46097aa91ae1e7$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $8d46097aa91ae1e7$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $8d46097aa91ae1e7$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $8d46097aa91ae1e7$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $8d46097aa91ae1e7$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $8d46097aa91ae1e7$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$8d46097aa91ae1e7$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$8d46097aa91ae1e7$var$Writable.prototype._writev = null;
$8d46097aa91ae1e7$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $8d46097aa91ae1e7$var$endWritable(this, state, cb);
};
function $8d46097aa91ae1e7$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $8d46097aa91ae1e7$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $8d46097aa91ae1e7$var$finishMaybe(stream, state);
    });
}
function $8d46097aa91ae1e7$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $kEUYA.nextTick($8d46097aa91ae1e7$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $8d46097aa91ae1e7$var$finishMaybe(stream, state) {
    var need = $8d46097aa91ae1e7$var$needFinish(state);
    if (need) {
        $8d46097aa91ae1e7$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $8d46097aa91ae1e7$var$endWritable(stream, state, cb) {
    state.ending = true;
    $8d46097aa91ae1e7$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kEUYA.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $8d46097aa91ae1e7$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    if (state.corkedRequestsFree) state.corkedRequestsFree.next = corkReq;
    else state.corkedRequestsFree = corkReq;
}
Object.defineProperty($8d46097aa91ae1e7$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$8d46097aa91ae1e7$var$Writable.prototype.destroy = $37rEc.destroy;
$8d46097aa91ae1e7$var$Writable.prototype._undestroy = $37rEc.undestroy;
$8d46097aa91ae1e7$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("9FjVZ", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $709767f0e294e7de$export$63a7aa211a91ed69; }, function (v) { return $709767f0e294e7de$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $709767f0e294e7de$export$63a7aa211a91ed69;
"use strict";

var $jT9LW = parcelRequire("jT9LW");
var $709767f0e294e7de$require$Buffer = $jT9LW.Buffer;
/*</replacement>*/ var $709767f0e294e7de$var$isEncoding = $709767f0e294e7de$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $709767f0e294e7de$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $709767f0e294e7de$var$normalizeEncoding(enc) {
    var nenc = $709767f0e294e7de$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($709767f0e294e7de$require$Buffer.isEncoding === $709767f0e294e7de$var$isEncoding || !$709767f0e294e7de$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$709767f0e294e7de$export$63a7aa211a91ed69 = $709767f0e294e7de$var$StringDecoder;
function $709767f0e294e7de$var$StringDecoder(encoding) {
    this.encoding = $709767f0e294e7de$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $709767f0e294e7de$var$utf16Text;
            this.end = $709767f0e294e7de$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $709767f0e294e7de$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $709767f0e294e7de$var$base64Text;
            this.end = $709767f0e294e7de$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $709767f0e294e7de$var$simpleWrite;
            this.end = $709767f0e294e7de$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $709767f0e294e7de$require$Buffer.allocUnsafe(nb);
}
$709767f0e294e7de$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$709767f0e294e7de$var$StringDecoder.prototype.end = $709767f0e294e7de$var$utf8End;
// Returns only complete characters in a Buffer
$709767f0e294e7de$var$StringDecoder.prototype.text = $709767f0e294e7de$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$709767f0e294e7de$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $709767f0e294e7de$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $709767f0e294e7de$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $709767f0e294e7de$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $709767f0e294e7de$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $709767f0e294e7de$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $709767f0e294e7de$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $709767f0e294e7de$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $709767f0e294e7de$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $709767f0e294e7de$var$utf8Text(buf, i) {
    var total = $709767f0e294e7de$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $709767f0e294e7de$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $709767f0e294e7de$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $709767f0e294e7de$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $709767f0e294e7de$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $709767f0e294e7de$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $709767f0e294e7de$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $709767f0e294e7de$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});


parcelRegister("7n1zQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $55dbe797acd0450f$var$Transform;

var $bgcMJ = parcelRequire("bgcMJ");

/*<replacement>*/ var $55dbe797acd0450f$var$util = Object.create((parcelRequire("iItjM")));

$55dbe797acd0450f$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $55dbe797acd0450f$var$util.inherits($55dbe797acd0450f$var$Transform, $bgcMJ);
function $55dbe797acd0450f$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $55dbe797acd0450f$var$Transform(options) {
    if (!(this instanceof $55dbe797acd0450f$var$Transform)) return new $55dbe797acd0450f$var$Transform(options);
    $bgcMJ.call(this, options);
    this._transformState = {
        afterTransform: $55dbe797acd0450f$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $55dbe797acd0450f$var$prefinish);
}
function $55dbe797acd0450f$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $55dbe797acd0450f$var$done(_this, er, data);
    });
    else $55dbe797acd0450f$var$done(this, null, null);
}
$55dbe797acd0450f$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $bgcMJ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$55dbe797acd0450f$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$55dbe797acd0450f$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$55dbe797acd0450f$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$55dbe797acd0450f$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $bgcMJ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $55dbe797acd0450f$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("kRqxh", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $03eb4fdc362d42f8$var$PassThrough;

var $7n1zQ = parcelRequire("7n1zQ");

/*<replacement>*/ var $03eb4fdc362d42f8$var$util = Object.create((parcelRequire("iItjM")));

$03eb4fdc362d42f8$var$util.inherits = (parcelRequire("eSHUL"));
/*</replacement>*/ $03eb4fdc362d42f8$var$util.inherits($03eb4fdc362d42f8$var$PassThrough, $7n1zQ);
function $03eb4fdc362d42f8$var$PassThrough(options) {
    if (!(this instanceof $03eb4fdc362d42f8$var$PassThrough)) return new $03eb4fdc362d42f8$var$PassThrough(options);
    $7n1zQ.call(this, options);
}
$03eb4fdc362d42f8$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});



parcelRegister("7QcYH", function(module, exports) {
var $5b5774dfd8df979c$var$ws = null;
if (typeof WebSocket !== "undefined") $5b5774dfd8df979c$var$ws = WebSocket;
else if (typeof MozWebSocket !== "undefined") $5b5774dfd8df979c$var$ws = MozWebSocket;
else if (typeof window !== "undefined") $5b5774dfd8df979c$var$ws = window.WebSocket || window.MozWebSocket;
module.exports = $5b5774dfd8df979c$var$ws;

});





parcelRegister("1JUZg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8AB7q = parcelRequire("8AB7q");
module.exports.bip32 = $8AB7q;

var $h6Byf = parcelRequire("h6Byf");
module.exports.address = $h6Byf;

var $3yeGF = parcelRequire("3yeGF");
module.exports.crypto = $3yeGF;

var $kNAnL = parcelRequire("kNAnL");
module.exports.ECPair = $kNAnL;

var $csNcS = parcelRequire("csNcS");
module.exports.networks = $csNcS;

var $ltfXM = parcelRequire("ltfXM");
module.exports.payments = $ltfXM;

var $jodFS = parcelRequire("jodFS");
module.exports.script = $jodFS;

var $25LHc = parcelRequire("25LHc");
module.exports.Block = $25LHc.Block;

var $1Mn1d = parcelRequire("1Mn1d");
module.exports.Psbt = $1Mn1d.Psbt;

var $jodFS = parcelRequire("jodFS");
module.exports.opcodes = $jodFS.OPS;

var $5BO4o = parcelRequire("5BO4o");
module.exports.Transaction = $5BO4o.Transaction;

var $6NUsZ = parcelRequire("6NUsZ");
module.exports.TransactionBuilder = $6NUsZ.TransactionBuilder;

});
parcelRegister("h6Byf", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c74020224d79110a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fUMe0 = parcelRequire("fUMe0");

var $csNcS = parcelRequire("csNcS");

var $ltfXM = parcelRequire("ltfXM");

var $jodFS = parcelRequire("jodFS");

var $7TFFW = parcelRequire("7TFFW");

var $5wgCY = parcelRequire("5wgCY");

var $1Vf4C = parcelRequire("1Vf4C");

var $bDP98 = parcelRequire("bDP98");
function $c74020224d79110a$var$fromBase58Check(address) {
    const isBCH = $fUMe0.VALID_PREFIXES.indexOf(address.split(":")[0]) > -1;
    if (isBCH) {
        const result = $fUMe0.decode(address);
        let network;
        switch(result.prefix){
            case "bitcoincash":
                network = $csNcS.bitcoin;
                break;
            case "bchtest":
                network = $csNcS.testnet;
                break;
            case "bchreg":
                network = $csNcS.regtest;
                break;
        }
        let version;
        switch(result.type){
            case "P2PKH":
                version = network.pubKeyHash;
                break;
            case "P2SH":
                version = network.scriptHash;
                break;
        }
        if (result.hash.length < 20) throw new TypeError(address + " is too short");
        if (result.hash.length > 20) throw new TypeError(address + " is too long");
        return {
            version: version,
            hash: $c74020224d79110a$require$Buffer.from(result.hash)
        };
    } else {
        const payload = $1Vf4C.decode(address);
        // TODO: 4.0.0, move to "toOutputScript"
        if (payload.length < 21) throw new TypeError(address + " is too short");
        if (payload.length > 21) throw new TypeError(address + " is too long");
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    }
}
module.exports.fromBase58Check = $c74020224d79110a$var$fromBase58Check;
function $c74020224d79110a$var$fromBech32(address) {
    const result = $5wgCY.decode(address);
    const data = $5wgCY.fromWords(result.words.slice(1));
    return {
        version: result.words[0],
        prefix: result.prefix,
        data: $c74020224d79110a$require$Buffer.from(data)
    };
}
module.exports.fromBech32 = $c74020224d79110a$var$fromBech32;
function $c74020224d79110a$var$toBase58Check(hash, version) {
    $bDP98($7TFFW.tuple($7TFFW.Hash160bit, $7TFFW.UInt8), arguments);
    const payload = $c74020224d79110a$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $1Vf4C.encode(payload);
}
module.exports.toBase58Check = $c74020224d79110a$var$toBase58Check;
function $c74020224d79110a$var$toBech32(data, version, prefix) {
    const words = $5wgCY.toWords(data);
    words.unshift(version);
    return $5wgCY.encode(prefix, words);
}
module.exports.toBech32 = $c74020224d79110a$var$toBech32;
function $c74020224d79110a$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $csNcS.bitcoin;
    try {
        return $ltfXM.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $ltfXM.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $ltfXM.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $ltfXM.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    throw new Error($jodFS.toASM(output) + " has no matching Address");
}
module.exports.fromOutputScript = $c74020224d79110a$var$fromOutputScript;
function $c74020224d79110a$var$toOutputScript(address, network) {
    network = network || $csNcS.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $c74020224d79110a$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $ltfXM.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $ltfXM.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $c74020224d79110a$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $ltfXM.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $ltfXM.p2wsh({
                    hash: decodeBech32.data
                }).output;
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
module.exports.toOutputScript = $c74020224d79110a$var$toOutputScript;

});
parcelRegister("fUMe0", function(module, exports) {
"use strict";
/**
 * @license
 * https://github.com/bitcoincashjs/cashaddr
 * Copyright (c) 2017-2018 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8w8wf = parcelRequire("8w8wf");

var $9w79v = parcelRequire("9w79v");

var $2hdH5 = parcelRequire("2hdH5");

var $85ODl = parcelRequire("85ODl");
const $b9617e6f494b80f4$var$validate = $85ODl.validate;
/**
 * Encoding and decoding of the new Cash Address format for Bitcoin Cash. <br />
 * Compliant with the original cashaddr specification:
 * {@link https://github.com/Bitcoin-UAHF/spec/blob/master/cashaddr.md}
 * @module cashaddr
 */ /**
 * Encodes a hash from a given type into a Bitcoin Cash address with the given prefix.
 *
 * @static
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'.
 * @param {string} type Type of address to generate. Either 'P2PKH' or 'P2SH'.
 * @param {Uint8Array} hash Hash to encode represented as an array of 8-bit integers.
 * @returns {string}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$encode(prefix, type, hash) {
    $b9617e6f494b80f4$var$validate(typeof prefix === "string" && $b9617e6f494b80f4$var$isValidPrefix(prefix), "Invalid prefix: " + prefix + ".");
    $b9617e6f494b80f4$var$validate(typeof type === "string", "Invalid type: " + type + ".");
    $b9617e6f494b80f4$var$validate(hash instanceof Uint8Array, "Invalid hash: " + hash + ".");
    const prefixData = $b9617e6f494b80f4$var$concat($b9617e6f494b80f4$var$prefixToUint5Array(prefix), new Uint8Array(1));
    const versionByte = $b9617e6f494b80f4$var$getTypeBits(type) + $b9617e6f494b80f4$var$getHashSizeBits(hash);
    const payloadData = $b9617e6f494b80f4$var$toUint5Array($b9617e6f494b80f4$var$concat(new Uint8Array([
        versionByte
    ]), hash));
    const checksumData = $b9617e6f494b80f4$var$concat($b9617e6f494b80f4$var$concat(prefixData, payloadData), new Uint8Array(8));
    const payload = $b9617e6f494b80f4$var$concat(payloadData, $b9617e6f494b80f4$var$checksumToUint5Array($b9617e6f494b80f4$var$polymod(checksumData)));
    return prefix + ":" + $9w79v.encode(payload);
}
module.exports.encode = $b9617e6f494b80f4$var$encode;
/**
 * Decodes the given address into its constituting prefix, type and hash. See [#encode()]{@link encode}.
 *
 * @static
 * @param {string} address Address to decode. E.g.: 'bitcoincash:qpm2qsznhks23z7629mms6s4cwef74vcwvy22gdx6a'.
 * @returns {object}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$decode(address) {
    $b9617e6f494b80f4$var$validate(typeof address === "string" && $b9617e6f494b80f4$var$hasSingleCase(address), "Invalid address: " + address + ".");
    const pieces = address.toLowerCase().split(":");
    $b9617e6f494b80f4$var$validate(pieces.length === 2, "Missing prefix: " + address + ".");
    const prefix = pieces[0];
    const payload = $9w79v.decode(pieces[1]);
    $b9617e6f494b80f4$var$validate($b9617e6f494b80f4$var$validChecksum(prefix, payload), "Invalid checksum: " + address + ".");
    const payloadData = $b9617e6f494b80f4$var$fromUint5Array(payload.subarray(0, -8));
    const versionByte = payloadData[0];
    const hash = payloadData.subarray(1);
    $b9617e6f494b80f4$var$validate($b9617e6f494b80f4$var$getHashSize(versionByte) === hash.length * 8, "Invalid hash size: " + address + ".");
    const type = $b9617e6f494b80f4$var$getType(versionByte);
    return {
        prefix: prefix,
        type: type,
        hash: hash
    };
}
module.exports.decode = $b9617e6f494b80f4$var$decode;
/**
 * Error thrown when encoding or decoding fail due to invalid input.
 *
 * @constructor ValidationError
 * @param {string} message Error description.
 */ module.exports.ValidationError = $85ODl.ValidationError;
/**
 * Valid address prefixes.
 *
 * @private
 */ module.exports.VALID_PREFIXES = [
    "bitcoincash",
    "bchtest",
    "bchreg"
];
/**
 * Checks whether a string is a valid prefix; ie., it has a single letter case
 * and is one of 'bitcoincash', 'bchtest', or 'bchreg'.
 *
 * @private
 * @param {string} prefix
 * @returns {boolean}
 */ function $b9617e6f494b80f4$var$isValidPrefix(prefix) {
    return $b9617e6f494b80f4$var$hasSingleCase(prefix) && module.exports.VALID_PREFIXES.indexOf(prefix.toLowerCase()) !== -1;
}
/**
 * Derives an array from the given prefix to be used in the computation
 * of the address' checksum.
 *
 * @private
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'.
 * @returns {Uint8Array}
 */ function $b9617e6f494b80f4$var$prefixToUint5Array(prefix) {
    const result = new Uint8Array(prefix.length);
    for(let i = 0; i < prefix.length; ++i)result[i] = prefix[i].charCodeAt(0) & 31;
    return result;
}
/**
 * Returns an array representation of the given checksum to be encoded
 * within the address' payload.
 *
 * @private
 * @param {BigInteger} checksum Computed checksum.
 * @returns {Uint8Array}
 */ function $b9617e6f494b80f4$var$checksumToUint5Array(checksum) {
    const result = new Uint8Array(8);
    for(let i = 0; i < 8; ++i){
        result[7 - i] = checksum.and(31).toJSNumber();
        checksum = checksum.shiftRight(5);
    }
    return result;
}
/**
 * Returns the bit representation of the given type within the version
 * byte.
 *
 * @private
 * @param {string} type Address type. Either 'P2PKH' or 'P2SH'.
 * @returns {number}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$getTypeBits(type) {
    switch(type){
        case "P2PKH":
            return 0;
        case "P2SH":
            return 8;
        default:
            throw new module.exports.ValidationError("Invalid type: " + type + ".");
    }
}
/**
 * Retrieves the address type from its bit representation within the
 * version byte.
 *
 * @private
 * @param {number} versionByte
 * @returns {string}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$getType(versionByte) {
    switch(versionByte & 0x78){
        case 0:
            return "P2PKH";
        case 8:
            return "P2SH";
        default:
            throw new module.exports.ValidationError("Invalid address type in version byte: " + versionByte + ".");
    }
}
/**
 * Returns the bit representation of the length in bits of the given
 * hash within the version byte.
 *
 * @private
 * @param {Uint8Array} hash Hash to encode represented as an array of 8-bit integers.
 * @returns {number}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$getHashSizeBits(hash) {
    switch(hash.length * 8){
        case 160:
            return 0;
        case 192:
            return 1;
        case 224:
            return 2;
        case 256:
            return 3;
        case 320:
            return 4;
        case 384:
            return 5;
        case 448:
            return 6;
        case 512:
            return 7;
        default:
            throw new module.exports.ValidationError("Invalid hash size: " + hash.length + ".");
    }
}
/**
 * Retrieves the the length in bits of the encoded hash from its bit
 * representation within the version byte.
 *
 * @private
 * @param {number} versionByte
 * @returns {number}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$getHashSize(versionByte) {
    switch(versionByte & 7){
        case 0:
            return 160;
        case 1:
            return 192;
        case 2:
            return 224;
        case 3:
            return 256;
        case 4:
            return 320;
        case 5:
            return 384;
        case 6:
            return 448;
        case 7:
            return 512;
        default:
            throw new module.exports.ValidationError("Invalid versionByte: " + (versionByte & 7) + ".");
    }
}
/**
 * Converts an array of 8-bit integers into an array of 5-bit integers,
 * right-padding with zeroes if necessary.
 *
 * @private
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */ function $b9617e6f494b80f4$var$toUint5Array(data) {
    return $2hdH5.convertBits(data, 8, 5);
}
/**
 * Converts an array of 5-bit integers back into an array of 8-bit integers,
 * removing extra zeroes left from padding if necessary.
 * Throws a {@link ValidationError} if input is not a zero-padded array of 8-bit integers.
 *
 * @private
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$fromUint5Array(data) {
    return $2hdH5.convertBits(data, 5, 8, true);
}
/**
 * Returns the concatenation a and b.
 *
 * @private
 * @param {Uint8Array} a
 * @param {Uint8Array} b
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $b9617e6f494b80f4$var$concat(a, b) {
    const ab = new Uint8Array(a.length + b.length);
    ab.set(a);
    ab.set(b, a.length);
    return ab;
}
/**
 * Computes a checksum from the given input data as specified for the CashAddr
 * format: https://github.com/Bitcoin-UAHF/spec/blob/master/cashaddr.md.
 *
 * @private
 * @param {Uint8Array} data Array of 5-bit integers over which the checksum is to be computed.
 * @returns {BigInteger}
 */ function $b9617e6f494b80f4$var$polymod(data) {
    const GENERATOR = [
        0x98f2bc8e61,
        0x79b76d99e2,
        0xf33e5fb3c4,
        0xae2eabe2a8,
        0x1e4f43e470
    ];
    let checksum = $8w8wf(1);
    for (const value of data){
        const topBits = checksum.shiftRight(35);
        checksum = checksum.and(0x07ffffffff).shiftLeft(5).xor(value);
        for(let j = 0; j < GENERATOR.length; ++j)if (topBits.shiftRight(j).and(1).equals(1)) checksum = checksum.xor(GENERATOR[j]);
    }
    return checksum.xor(1);
}
/**
 * Verify that the payload has not been corrupted by checking that the
 * checksum is valid.
 *
 * @private
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'.
 * @param {Uint8Array} payload Array of 5-bit integers containing the address' payload.
 * @returns {boolean}
 */ function $b9617e6f494b80f4$var$validChecksum(prefix, payload) {
    const prefixData = $b9617e6f494b80f4$var$concat($b9617e6f494b80f4$var$prefixToUint5Array(prefix), new Uint8Array(1));
    const checksumData = $b9617e6f494b80f4$var$concat(prefixData, payload);
    return $b9617e6f494b80f4$var$polymod(checksumData).equals(0);
}
/**
 * Returns true if, and only if, the given string contains either uppercase
 * or lowercase letters, but not both.
 *
 * @private
 * @param {string} string Input string.
 * @returns {boolean}
 */ function $b9617e6f494b80f4$var$hasSingleCase(strng) {
    return strng === strng.toLowerCase() || strng === strng.toUpperCase();
}

});
parcelRegister("8w8wf", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), DEFAULT_ALPHABET = "0123456789abcdefghijklmnopqrstuvwxyz";
    var supportsNativeBigInt = typeof BigInt === "function";
    function Integer(v, radix, alphabet, caseSensitive) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 && !alphabet ? parseValue(v) : parseBase(v, radix, alphabet, caseSensitive);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function NativeBigInt(value) {
        this.value = value;
    }
    NativeBigInt.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    NativeBigInt.prototype.add = function(v) {
        return new NativeBigInt(this.value + parseValue(v).value);
    };
    NativeBigInt.prototype.plus = NativeBigInt.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    NativeBigInt.prototype.subtract = function(v) {
        return new NativeBigInt(this.value - parseValue(v).value);
    };
    NativeBigInt.prototype.minus = NativeBigInt.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    NativeBigInt.prototype.negate = function() {
        return new NativeBigInt(-this.value);
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    NativeBigInt.prototype.abs = function() {
        return new NativeBigInt(this.value >= 0 ? this.value : -this.value);
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    NativeBigInt.prototype.multiply = function(v) {
        return new NativeBigInt(this.value * parseValue(v).value);
    };
    NativeBigInt.prototype.times = NativeBigInt.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    NativeBigInt.prototype.square = function(v) {
        return new NativeBigInt(this.value * this.value);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        if (supportsNativeBigInt) return [
            new NativeBigInt(self.value / n.value),
            new NativeBigInt(self.value % n.value)
        ];
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    NativeBigInt.prototype.divmod = SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    NativeBigInt.prototype.over = NativeBigInt.prototype.divide = function(v) {
        return new NativeBigInt(this.value / parseValue(v).value);
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    NativeBigInt.prototype.mod = NativeBigInt.prototype.remainder = function(v) {
        return new NativeBigInt(this.value % parseValue(v).value);
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    NativeBigInt.prototype.pow = function(v) {
        var n = parseValue(v);
        var a = this.value, b = n.value;
        var _0 = BigInt(0), _1 = BigInt(1), _2 = BigInt(2);
        if (b === _0) return Integer[1];
        if (a === _0) return Integer[0];
        if (a === _1) return Integer[1];
        if (a === BigInt(-1)) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.isNegative()) return new NativeBigInt(_0);
        var x = this;
        var y = Integer[1];
        while(true){
            if ((b & _1) === _1) {
                y = y.times(x);
                --b;
            }
            if (b === _0) break;
            b /= _2;
            x = x.square();
        }
        return y;
    };
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        if (exp.isNegative()) {
            exp = exp.multiply(Integer[-1]);
            base = base.modInv(mod);
        }
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    NativeBigInt.prototype.modPow = SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    NativeBigInt.prototype.compareAbs = function(v) {
        var a = this.value;
        var b = parseValue(v).value;
        a = a >= 0 ? a : -a;
        b = b >= 0 ? b : -b;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    NativeBigInt.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var a = this.value;
        var b = parseValue(v).value;
        return a === b ? 0 : a > b ? 1 : -1;
    };
    NativeBigInt.prototype.compareTo = NativeBigInt.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    NativeBigInt.prototype.eq = NativeBigInt.prototype.equals = SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    NativeBigInt.prototype.neq = NativeBigInt.prototype.notEquals = SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    NativeBigInt.prototype.gt = NativeBigInt.prototype.greater = SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    NativeBigInt.prototype.lt = NativeBigInt.prototype.lesser = SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    NativeBigInt.prototype.geq = NativeBigInt.prototype.greaterOrEquals = SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    NativeBigInt.prototype.leq = NativeBigInt.prototype.lesserOrEquals = SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    NativeBigInt.prototype.isEven = function() {
        return (this.value & BigInt(1)) === BigInt(0);
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    NativeBigInt.prototype.isOdd = function() {
        return (this.value & BigInt(1)) === BigInt(1);
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    NativeBigInt.prototype.isPositive = SmallInteger.prototype.isPositive;
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    NativeBigInt.prototype.isNegative = SmallInteger.prototype.isNegative;
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    NativeBigInt.prototype.isUnit = function() {
        return this.abs().value === BigInt(1);
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    NativeBigInt.prototype.isZero = function() {
        return this.value === BigInt(0);
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        if (n.isZero()) return false;
        if (n.isUnit()) return true;
        if (n.compareAbs(2) === 0) return this.isEven();
        return this.mod(n).isZero();
    };
    NativeBigInt.prototype.isDivisibleBy = SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.isUnit() || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            3,
            5,
            7,
            11,
            13,
            17,
            19,
            23,
            29,
            31,
            37
        ]);
        var logN = Math.log(2) * bits.toJSNumber();
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isPrime = SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations, rng) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2), rng));
        return millerRabinTest(n, a);
    };
    NativeBigInt.prototype.isProbablePrime = SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.isZero()){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.isUnit()) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    NativeBigInt.prototype.modInv = SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    NativeBigInt.prototype.next = function() {
        return new NativeBigInt(this.value + BigInt(1));
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    NativeBigInt.prototype.prev = function() {
        return new NativeBigInt(this.value - BigInt(1));
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return Math.abs(n) <= BASE;
    }
    BigInteger.prototype.shiftLeft = function(v) {
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    NativeBigInt.prototype.shiftLeft = SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(v) {
        var remQuo;
        var n = parseValue(v).toJSNumber();
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    NativeBigInt.prototype.shiftRight = SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    NativeBigInt.prototype.not = SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    NativeBigInt.prototype.and = SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    NativeBigInt.prototype.or = SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    NativeBigInt.prototype.xor = SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : typeof v === "bigint" ? v | BigInt(LOBMASK_I) : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    NativeBigInt.prototype.bitLength = SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b, rng) {
        a = parseValue(a);
        b = parseValue(b);
        var usedRNG = rng || Math.random;
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(usedRNG() * range));
        var digits = toBase(range, BASE).value;
        var result = [], restricted = true;
        for(var i = 0; i < digits.length; i++){
            var top = restricted ? digits[i] : BASE;
            var digit = truncate(usedRNG() * top);
            result.push(digit);
            if (digit < top) restricted = false;
        }
        return low.add(Integer.fromArray(result, BASE, false));
    }
    var parseBase = function(text, base, alphabet, caseSensitive) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        text = String(text);
        if (!caseSensitive) {
            text = text.toLowerCase();
            alphabet = alphabet.toLowerCase();
        }
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        var alphabetValues = {};
        for(i = 0; i < alphabet.length; i++)alphabetValues[alphabet[i]] = i;
        for(i = 0; i < length; i++){
            var c = text[i];
            if (c === "-") continue;
            if (c in alphabetValues) {
                if (alphabetValues[c] >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                }
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i];
            if (c in alphabetValues) digits.push(parseValue(alphabetValues[c]));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">" && i < text.length);
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit, alphabet) {
        alphabet = alphabet || DEFAULT_ALPHABET;
        if (digit < alphabet.length) return alphabet[digit];
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n.toJSNumber())).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(n.toJSNumber() - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.isUnit()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(n.toJSNumber())).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base, alphabet) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(function(x) {
            return stringify(x, alphabet);
        }).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    NativeBigInt.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix !== 10) return toBaseString(this, radix, alphabet);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix, alphabet) {
        if (radix === undefined) radix = 10;
        if (radix != 10) return toBaseString(this, radix, alphabet);
        return String(this.value);
    };
    NativeBigInt.prototype.toString = SmallInteger.prototype.toString;
    NativeBigInt.prototype.toJSON = BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    NativeBigInt.prototype.valueOf = NativeBigInt.prototype.toJSNumber = function() {
        return parseInt(this.toString(), 10);
    };
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return supportsNativeBigInt ? new NativeBigInt(BigInt(x)) : new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(sign ? "-" + v : v));
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (supportsNativeBigInt) return new NativeBigInt(BigInt(v));
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        if (typeof v === "bigint") return new NativeBigInt(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = parseValue(i);
        if (i > 0) Integer[-i] = parseValue(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger || x instanceof NativeBigInt;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define(function() {
    return bigInt;
});

});

parcelRegister("9w79v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $85ODl = parcelRequire("85ODl");
/**
 * Base32 encoding and decoding.
 *
 * @module base32
 */ /**
 * Charset containing the 32 symbols used in the base32 encoding.
 * @private
 */ const $6edca67f51d33e79$var$CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
/**
 * Inverted index mapping each symbol into its index within the charset.
 * @private
 */ const $6edca67f51d33e79$var$CHARSET_INVERSE_INDEX = {
    q: 0,
    p: 1,
    z: 2,
    r: 3,
    y: 4,
    9: 5,
    x: 6,
    8: 7,
    g: 8,
    f: 9,
    2: 10,
    t: 11,
    v: 12,
    d: 13,
    w: 14,
    0: 15,
    s: 16,
    3: 17,
    j: 18,
    n: 19,
    5: 20,
    4: 21,
    k: 22,
    h: 23,
    c: 24,
    e: 25,
    6: 26,
    m: 27,
    u: 28,
    a: 29,
    7: 30,
    l: 31
};
/**
 * Encodes the given array of 5-bit integers as a base32-encoded string.
 *
 * @static
 * @param {Uint8Array} data Array of integers between 0 and 31 inclusive.
 * @returns {string}
 * @throws {ValidationError}
 */ function $6edca67f51d33e79$var$encode(data) {
    $85ODl.validate(data instanceof Uint8Array, "Invalid data: " + data + ".");
    let base32 = "";
    for (const value of data){
        $85ODl.validate(0 <= value && value < 32, "Invalid value: " + value + ".");
        base32 += $6edca67f51d33e79$var$CHARSET[value];
    }
    return base32;
}
module.exports.encode = $6edca67f51d33e79$var$encode;
/**
 * Decodes the given base32-encoded string into an array of 5-bit integers.
 *
 * @static
 * @param {string} string
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $6edca67f51d33e79$var$decode(strng) {
    $85ODl.validate(typeof strng === "string", "Invalid base32-encoded string: " + strng + ".");
    const data = new Uint8Array(strng.length);
    for(let i = 0; i < strng.length; ++i){
        const value = strng[i];
        $85ODl.validate(value in $6edca67f51d33e79$var$CHARSET_INVERSE_INDEX, "Invalid value: " + value + ".");
        data[i] = $6edca67f51d33e79$var$CHARSET_INVERSE_INDEX[value];
    }
    return data;
}
module.exports.decode = $6edca67f51d33e79$var$decode;

});
parcelRegister("85ODl", function(module, exports) {
"use strict";
/**
 * @license
 * https://github.com/bitcoincashjs/cashaddr
 * Copyright (c) 2017-2018 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Validation utility.
 *
 * @module validation
 */ /**
 * Error thrown when encoding or decoding fail due to invalid input.
 *
 * @constructor ValidationError
 * @param {string} message Error description.
 */ class $5e46111f358f9d61$var$ValidationError extends Error {
    constructor(message){
        super(message);
        this.name = "ValidationError";
        Object.setPrototypeOf(this, $5e46111f358f9d61$var$ValidationError.prototype);
    }
}
module.exports.ValidationError = $5e46111f358f9d61$var$ValidationError;
/**
 * Validates a given condition, throwing a {@link ValidationError} if
 * the given condition does not hold.
 *
 * @static
 * @param {boolean} condition Condition to validate.
 * @param {string} message Error message in case the condition does not hold.
 */ function $5e46111f358f9d61$var$validate(condition, message) {
    if (!condition) throw new $5e46111f358f9d61$var$ValidationError(message);
}
module.exports.validate = $5e46111f358f9d61$var$validate;

});


parcelRegister("2hdH5", function(module, exports) {
"use strict";
// Copyright (c) 2017-2018 Emilio Almansi
// Copyright (c) 2017 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $85ODl = parcelRequire("85ODl");
/**
 * Converts an array of integers made up of 'from' bits into an
 * array of integers made up of 'to' bits. The output array is
 * zero-padded if necessary, unless strict mode is true.
 * Throws a {@link ValidationError} if input is invalid.
 * Original by Pieter Wuille: https://github.com/sipa/bech32.
 *
 * @param {Uint8Array} data Array of integers made up of 'from' bits.
 * @param {number} from Length in bits of elements in the input array.
 * @param {number} to Length in bits of elements in the output array.
 * @param {bool} strictMode Require the conversion to be completed without padding.
 * @returns {Uint8Array}
 */ function $1a87caa41abc8b63$var$convertBits(data, from, to, strictMode) {
    const length = strictMode ? Math.floor(data.length * from / to) : Math.ceil(data.length * from / to);
    const mask = (1 << to) - 1;
    const result = new Uint8Array(length);
    let index = 0;
    let accumulator = 0;
    let bits = 0;
    for (const value of data){
        $85ODl.validate(0 <= value && value >> from === 0, "Invalid value: " + value + ".");
        accumulator = accumulator << from | value;
        bits += from;
        while(bits >= to){
            bits -= to;
            result[index] = accumulator >> bits & mask;
            ++index;
        }
    }
    if (!strictMode) {
        if (bits > 0) {
            result[index] = accumulator << to - bits & mask;
            ++index;
        }
    } else $85ODl.validate(bits < from && (accumulator << to - bits & mask) === 0, "Input cannot be converted to " + to + " bits without padding, but strict mode was used.");
    return result;
}
module.exports.convertBits = $1a87caa41abc8b63$var$convertBits;

});


parcelRegister("csNcS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bitcoingold = {
    messagePrefix: "\x18Bitcoin Gold Signed Message:\n",
    bech32: "btg",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x26,
    scriptHash: 0x17,
    wif: 0x80
};
module.exports.bitcoin = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
module.exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
module.exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};

});

parcelRegister("ltfXM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9iADq = parcelRequire("9iADq");
module.exports.embed = $9iADq.p2data;

var $8buuY = parcelRequire("8buuY");
module.exports.p2ms = $8buuY.p2ms;

var $8lnQV = parcelRequire("8lnQV");
module.exports.p2pk = $8lnQV.p2pk;

var $2aVOu = parcelRequire("2aVOu");
module.exports.p2pkh = $2aVOu.p2pkh;

var $6GYG8 = parcelRequire("6GYG8");
module.exports.p2sh = $6GYG8.p2sh;

var $nirJJ = parcelRequire("nirJJ");
module.exports.p2wpkh = $nirJJ.p2wpkh;

var $2mgzh = parcelRequire("2mgzh");
module.exports.p2wsh = $2mgzh.p2wsh; // TODO
 // witness commitment

});
parcelRegister("9iADq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $01bf42f128f36066$var$OPS = $jodFS.OPS;
function $01bf42f128f36066$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $01bf42f128f36066$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        output: $bDP98.maybe($bDP98.Buffer),
        data: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
    }, a);
    const network = a.network || $csNcS.bitcoin;
    const o = {
        name: "embed",
        network: network
    };
    $gVMye.prop(o, "output", ()=>{
        if (!a.data) return;
        return $jodFS.compile([
            $01bf42f128f36066$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $gVMye.prop(o, "data", ()=>{
        if (!a.output) return;
        return $jodFS.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $jodFS.decompile(a.output);
            if (chunks[0] !== $01bf42f128f36066$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($bDP98.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !$01bf42f128f36066$var$stacksEqual(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2data = $01bf42f128f36066$var$p2data;

});
parcelRegister("jodFS", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e1daddaac8f3b6cd$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6i43A = parcelRequire("6i43A");

var $kzOVL = parcelRequire("kzOVL");

var $7TFFW = parcelRequire("7TFFW");

var $1iXiz = parcelRequire("1iXiz");

var $bAAqK = parcelRequire("bAAqK");

var $kAD4O = parcelRequire("kAD4O");

var $bDP98 = parcelRequire("bDP98");

module.exports.OPS = (parcelRequire("4a7WJ"));

var $fWq5o = parcelRequire("fWq5o");
const $e1daddaac8f3b6cd$var$OP_INT_BASE = module.exports.OPS.OP_RESERVED; // OP_1 - 1
function $e1daddaac8f3b6cd$var$isOPInt(value) {
    return $7TFFW.Number(value) && (value === module.exports.OPS.OP_0 || value >= module.exports.OPS.OP_1 && value <= module.exports.OPS.OP_16 || value === module.exports.OPS.OP_1NEGATE);
}
function $e1daddaac8f3b6cd$var$isPushOnlyChunk(value) {
    return $7TFFW.Buffer(value) || $e1daddaac8f3b6cd$var$isOPInt(value);
}
function $e1daddaac8f3b6cd$var$isPushOnly(value) {
    return $7TFFW.Array(value) && value.every($e1daddaac8f3b6cd$var$isPushOnlyChunk);
}
module.exports.isPushOnly = $e1daddaac8f3b6cd$var$isPushOnly;
function $e1daddaac8f3b6cd$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return module.exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $e1daddaac8f3b6cd$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return module.exports.OPS.OP_1NEGATE;
}
function $e1daddaac8f3b6cd$var$chunksIsBuffer(buf) {
    return $e1daddaac8f3b6cd$require$Buffer.isBuffer(buf);
}
function $e1daddaac8f3b6cd$var$chunksIsArray(buf) {
    return $7TFFW.Array(buf);
}
function $e1daddaac8f3b6cd$var$singleChunkIsBuffer(buf) {
    return $e1daddaac8f3b6cd$require$Buffer.isBuffer(buf);
}
function $e1daddaac8f3b6cd$var$compile(chunks) {
    // TODO: remove me
    if ($e1daddaac8f3b6cd$var$chunksIsBuffer(chunks)) return chunks;
    $bDP98($7TFFW.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($e1daddaac8f3b6cd$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $e1daddaac8f3b6cd$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $kAD4O.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $e1daddaac8f3b6cd$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($e1daddaac8f3b6cd$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $e1daddaac8f3b6cd$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $kAD4O.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
module.exports.compile = $e1daddaac8f3b6cd$var$compile;
function $e1daddaac8f3b6cd$var$decompile(buffer) {
    // TODO: remove me
    if ($e1daddaac8f3b6cd$var$chunksIsArray(buffer)) return buffer;
    $bDP98($7TFFW.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > module.exports.OPS.OP_0 && opcode <= module.exports.OPS.OP_PUSHDATA4) {
            const d = $kAD4O.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $e1daddaac8f3b6cd$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
module.exports.decompile = $e1daddaac8f3b6cd$var$decompile;
function $e1daddaac8f3b6cd$var$toASM(chunks) {
    if ($e1daddaac8f3b6cd$var$chunksIsBuffer(chunks)) chunks = $e1daddaac8f3b6cd$var$decompile(chunks);
    return chunks.map((chunk)=>{
        // data?
        if ($e1daddaac8f3b6cd$var$singleChunkIsBuffer(chunk)) {
            const op = $e1daddaac8f3b6cd$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $fWq5o[chunk];
    }).join(" ");
}
module.exports.toASM = $e1daddaac8f3b6cd$var$toASM;
function $e1daddaac8f3b6cd$var$fromASM(asm) {
    $bDP98($7TFFW.String, asm);
    return $e1daddaac8f3b6cd$var$compile(asm.split(" ").map((chunkStr)=>{
        // opcode?
        if (module.exports.OPS[chunkStr] !== undefined) return module.exports.OPS[chunkStr];
        $bDP98($7TFFW.Hex, chunkStr);
        // data!
        return $e1daddaac8f3b6cd$require$Buffer.from(chunkStr, "hex");
    }));
}
module.exports.fromASM = $e1daddaac8f3b6cd$var$fromASM;
function $e1daddaac8f3b6cd$var$toStack(chunks) {
    chunks = $e1daddaac8f3b6cd$var$decompile(chunks);
    $bDP98($e1daddaac8f3b6cd$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($e1daddaac8f3b6cd$var$singleChunkIsBuffer(op)) return op;
        if (op === module.exports.OPS.OP_0) return $e1daddaac8f3b6cd$require$Buffer.allocUnsafe(0);
        return $6i43A.encode(op - $e1daddaac8f3b6cd$var$OP_INT_BASE);
    });
}
module.exports.toStack = $e1daddaac8f3b6cd$var$toStack;
function $e1daddaac8f3b6cd$var$isCanonicalPubKey(buffer) {
    return $bAAqK.isPoint(buffer);
}
module.exports.isCanonicalPubKey = $e1daddaac8f3b6cd$var$isCanonicalPubKey;
function $e1daddaac8f3b6cd$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -193;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
module.exports.isDefinedHashType = $e1daddaac8f3b6cd$var$isDefinedHashType;
function $e1daddaac8f3b6cd$var$isCanonicalScriptSignature(buffer) {
    if (!$e1daddaac8f3b6cd$require$Buffer.isBuffer(buffer)) return false;
    if (!$e1daddaac8f3b6cd$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $1iXiz.check(buffer.slice(0, -1));
}
module.exports.isCanonicalScriptSignature = $e1daddaac8f3b6cd$var$isCanonicalScriptSignature;
// tslint:disable-next-line variable-name
module.exports.number = $6i43A;
module.exports.signature = $kzOVL;

});
parcelRegister("6i43A", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4947921cb76afcba$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $4947921cb76afcba$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
module.exports.decode = $4947921cb76afcba$var$decode;
function $4947921cb76afcba$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $4947921cb76afcba$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $4947921cb76afcba$var$scriptNumSize(value);
    const buffer = $4947921cb76afcba$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
module.exports.encode = $4947921cb76afcba$var$encode;

});

parcelRegister("kzOVL", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $efae954f25f7605c$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7TFFW = parcelRequire("7TFFW");

var $1iXiz = parcelRequire("1iXiz");

var $bDP98 = parcelRequire("bDP98");
const $efae954f25f7605c$var$ZERO = $efae954f25f7605c$require$Buffer.alloc(1, 0);
function $efae954f25f7605c$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $efae954f25f7605c$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $efae954f25f7605c$require$Buffer.concat([
        $efae954f25f7605c$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $efae954f25f7605c$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $efae954f25f7605c$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $efae954f25f7605c$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    const hashTypeMod = hashType & -193;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const decoded = $1iXiz.decode(buffer.slice(0, -1));
    const r = $efae954f25f7605c$var$fromDER(decoded.r);
    const s = $efae954f25f7605c$var$fromDER(decoded.s);
    const signature = $efae954f25f7605c$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
module.exports.decode = $efae954f25f7605c$var$decode;
function $efae954f25f7605c$var$encode(signature, hashType) {
    $bDP98({
        signature: $7TFFW.BufferN(64),
        hashType: $7TFFW.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    const hashTypeMod = hashType & -193;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const hashTypeBuffer = $efae954f25f7605c$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $efae954f25f7605c$var$toDER(signature.slice(0, 32));
    const s = $efae954f25f7605c$var$toDER(signature.slice(32, 64));
    return $efae954f25f7605c$require$Buffer.concat([
        $1iXiz.encode(r, s),
        hashTypeBuffer
    ]);
}
module.exports.encode = $efae954f25f7605c$var$encode;

});
parcelRegister("7TFFW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bDP98 = parcelRequire("bDP98");
const $5bfdff50e5d05fe4$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $5bfdff50e5d05fe4$var$UInt31(value) {
    return $bDP98.UInt32(value) && value <= $5bfdff50e5d05fe4$var$UINT31_MAX;
}
module.exports.UInt31 = $5bfdff50e5d05fe4$var$UInt31;
function $5bfdff50e5d05fe4$var$BIP32Path(value) {
    return $bDP98.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
module.exports.BIP32Path = $5bfdff50e5d05fe4$var$BIP32Path;
$5bfdff50e5d05fe4$var$BIP32Path.toJSON = ()=>{
    return "BIP32 derivation path";
};
function $5bfdff50e5d05fe4$var$Signer(obj) {
    return ($bDP98.Buffer(obj.publicKey) || typeof obj.getPublicKey === "function") && typeof obj.sign === "function";
}
module.exports.Signer = $5bfdff50e5d05fe4$var$Signer;
const $5bfdff50e5d05fe4$var$SATOSHI_MAX = 21 * 1e14;
function $5bfdff50e5d05fe4$var$Satoshi(value) {
    return $bDP98.UInt53(value) && value <= $5bfdff50e5d05fe4$var$SATOSHI_MAX;
}
module.exports.Satoshi = $5bfdff50e5d05fe4$var$Satoshi;
// external dependent types
module.exports.ECPoint = $bDP98.quacksLike("Point");
// exposed, external API
module.exports.Network = $bDP98.compile({
    messagePrefix: $bDP98.oneOf($bDP98.Buffer, $bDP98.String),
    bip32: {
        public: $bDP98.UInt32,
        private: $bDP98.UInt32
    },
    pubKeyHash: $bDP98.UInt8,
    scriptHash: $bDP98.UInt8,
    wif: $bDP98.UInt8
});
module.exports.Buffer256bit = $bDP98.BufferN(32);
module.exports.Hash160bit = $bDP98.BufferN(20);
module.exports.Hash256bit = $bDP98.BufferN(32);
module.exports.Number = $bDP98.Number; // tslint:disable-line variable-name
module.exports.Array = $bDP98.Array;
module.exports.Boolean = $bDP98.Boolean; // tslint:disable-line variable-name
module.exports.String = $bDP98.String; // tslint:disable-line variable-name
module.exports.Buffer = $bDP98.Buffer;
module.exports.Hex = $bDP98.Hex;
module.exports.maybe = $bDP98.maybe;
module.exports.tuple = $bDP98.tuple;
module.exports.UInt8 = $bDP98.UInt8;
module.exports.UInt32 = $bDP98.UInt32;
module.exports.UInt53 = $bDP98.UInt53;
module.exports.Function = $bDP98.Function;
module.exports.BufferN = $bDP98.BufferN;
module.exports.Null = $bDP98.Null;
module.exports.oneOf = $bDP98.oneOf;

});

parcelRegister("1iXiz", function(module, exports) {
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use

var $6U9mG = parcelRequire("6U9mG");
var $0f3578563656ba65$require$Buffer = $6U9mG.Buffer;
function $0f3578563656ba65$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    var lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    var lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
function $0f3578563656ba65$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    var lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    var lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
*/ function $0f3578563656ba65$var$encode(r, s) {
    var lenR = r.length;
    var lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    var signature = $0f3578563656ba65$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
module.exports = {
    check: $0f3578563656ba65$var$check,
    decode: $0f3578563656ba65$var$decode,
    encode: $0f3578563656ba65$var$encode
};

});


parcelRegister("kAD4O", function(module, exports) {

var $4a7WJ = parcelRequire("4a7WJ");
function $efd57b3b2f6766f9$var$encodingLength(i) {
    return i < $4a7WJ.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
function $efd57b3b2f6766f9$var$encode(buffer, number, offset) {
    var size = $efd57b3b2f6766f9$var$encodingLength(number);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(number, offset);
    else if (size === 2) {
        buffer.writeUInt8($4a7WJ.OP_PUSHDATA1, offset);
        buffer.writeUInt8(number, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($4a7WJ.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(number, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($4a7WJ.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(number, offset + 1);
    }
    return size;
}
function $efd57b3b2f6766f9$var$decode(buffer, offset) {
    var opcode = buffer.readUInt8(offset);
    var number, size;
    // ~6 bit
    if (opcode < $4a7WJ.OP_PUSHDATA1) {
        number = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $4a7WJ.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        number = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $4a7WJ.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        number = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $4a7WJ.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        number = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: number,
        size: size
    };
}
module.exports = {
    encodingLength: $efd57b3b2f6766f9$var$encodingLength,
    encode: $efd57b3b2f6766f9$var$encode,
    decode: $efd57b3b2f6766f9$var$decode
};

});
parcelRegister("4a7WJ", function(module, exports) {
module.exports = JSON.parse('{"OP_FALSE":0,"OP_0":0,"OP_PUSHDATA1":76,"OP_PUSHDATA2":77,"OP_PUSHDATA4":78,"OP_1NEGATE":79,"OP_RESERVED":80,"OP_TRUE":81,"OP_1":81,"OP_2":82,"OP_3":83,"OP_4":84,"OP_5":85,"OP_6":86,"OP_7":87,"OP_8":88,"OP_9":89,"OP_10":90,"OP_11":91,"OP_12":92,"OP_13":93,"OP_14":94,"OP_15":95,"OP_16":96,"OP_NOP":97,"OP_VER":98,"OP_IF":99,"OP_NOTIF":100,"OP_VERIF":101,"OP_VERNOTIF":102,"OP_ELSE":103,"OP_ENDIF":104,"OP_VERIFY":105,"OP_RETURN":106,"OP_TOALTSTACK":107,"OP_FROMALTSTACK":108,"OP_2DROP":109,"OP_2DUP":110,"OP_3DUP":111,"OP_2OVER":112,"OP_2ROT":113,"OP_2SWAP":114,"OP_IFDUP":115,"OP_DEPTH":116,"OP_DROP":117,"OP_DUP":118,"OP_NIP":119,"OP_OVER":120,"OP_PICK":121,"OP_ROLL":122,"OP_ROT":123,"OP_SWAP":124,"OP_TUCK":125,"OP_CAT":126,"OP_SUBSTR":127,"OP_LEFT":128,"OP_RIGHT":129,"OP_SIZE":130,"OP_INVERT":131,"OP_AND":132,"OP_OR":133,"OP_XOR":134,"OP_EQUAL":135,"OP_EQUALVERIFY":136,"OP_RESERVED1":137,"OP_RESERVED2":138,"OP_1ADD":139,"OP_1SUB":140,"OP_2MUL":141,"OP_2DIV":142,"OP_NEGATE":143,"OP_ABS":144,"OP_NOT":145,"OP_0NOTEQUAL":146,"OP_ADD":147,"OP_SUB":148,"OP_MUL":149,"OP_DIV":150,"OP_MOD":151,"OP_LSHIFT":152,"OP_RSHIFT":153,"OP_BOOLAND":154,"OP_BOOLOR":155,"OP_NUMEQUAL":156,"OP_NUMEQUALVERIFY":157,"OP_NUMNOTEQUAL":158,"OP_LESSTHAN":159,"OP_GREATERTHAN":160,"OP_LESSTHANOREQUAL":161,"OP_GREATERTHANOREQUAL":162,"OP_MIN":163,"OP_MAX":164,"OP_WITHIN":165,"OP_RIPEMD160":166,"OP_SHA1":167,"OP_SHA256":168,"OP_HASH160":169,"OP_HASH256":170,"OP_CODESEPARATOR":171,"OP_CHECKSIG":172,"OP_CHECKSIGVERIFY":173,"OP_CHECKMULTISIG":174,"OP_CHECKMULTISIGVERIFY":175,"OP_NOP1":176,"OP_NOP2":177,"OP_CHECKLOCKTIMEVERIFY":177,"OP_NOP3":178,"OP_CHECKSEQUENCEVERIFY":178,"OP_NOP4":179,"OP_NOP5":180,"OP_NOP6":181,"OP_NOP7":182,"OP_NOP8":183,"OP_NOP9":184,"OP_NOP10":185,"OP_PUBKEYHASH":253,"OP_PUBKEY":254,"OP_INVALIDOPCODE":255}');

});


parcelRegister("fWq5o", function(module, exports) {

var $4a7WJ = parcelRequire("4a7WJ");
var $b9b081f39ed33938$var$map = {};
for(var $b9b081f39ed33938$var$op in $4a7WJ){
    var $b9b081f39ed33938$var$code = $4a7WJ[$b9b081f39ed33938$var$op];
    $b9b081f39ed33938$var$map[$b9b081f39ed33938$var$code] = $b9b081f39ed33938$var$op;
}
module.exports = $b9b081f39ed33938$var$map;

});


parcelRegister("gVMye", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $c537a17692574721$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
module.exports.prop = $c537a17692574721$var$prop;
function $c537a17692574721$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
module.exports.value = $c537a17692574721$var$value;

});


parcelRegister("8buuY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");
const $0189a953586aa5e5$var$OPS = $jodFS.OPS;

var $bDP98 = parcelRequire("bDP98");

var $bAAqK = parcelRequire("bAAqK");
const $0189a953586aa5e5$var$OP_INT_BASE = $0189a953586aa5e5$var$OPS.OP_RESERVED; // OP_1 - 1
function $0189a953586aa5e5$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $0189a953586aa5e5$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $jodFS.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $0189a953586aa5e5$var$OPS.OP_0) !== undefined;
    }
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        m: $bDP98.maybe($bDP98.Number),
        n: $bDP98.maybe($bDP98.Number),
        output: $bDP98.maybe($bDP98.Buffer),
        pubkeys: $bDP98.maybe($bDP98.arrayOf($bAAqK.isPoint)),
        signatures: $bDP98.maybe($bDP98.arrayOf(isAcceptableSignature)),
        input: $bDP98.maybe($bDP98.Buffer)
    }, a);
    const network = a.network || $csNcS.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $jodFS.decompile(output);
        o.m = chunks[0] - $0189a953586aa5e5$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $0189a953586aa5e5$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $gVMye.prop(o, "output", ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $jodFS.compile([].concat($0189a953586aa5e5$var$OP_INT_BASE + a.m, a.pubkeys, $0189a953586aa5e5$var$OP_INT_BASE + o.n, $0189a953586aa5e5$var$OPS.OP_CHECKMULTISIG));
    });
    $gVMye.prop(o, "m", ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $gVMye.prop(o, "n", ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $gVMye.prop(o, "pubkeys", ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $gVMye.prop(o, "signatures", ()=>{
        if (!a.input) return;
        return $jodFS.decompile(a.input).slice(1);
    });
    $gVMye.prop(o, "input", ()=>{
        if (!a.signatures) return;
        return $jodFS.compile([
            $0189a953586aa5e5$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $gVMye.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    $gVMye.prop(o, "name", ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$bDP98.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$bDP98.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $0189a953586aa5e5$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every((x)=>$bAAqK.isPoint(x))) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !$0189a953586aa5e5$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $0189a953586aa5e5$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !$0189a953586aa5e5$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2ms = $0189a953586aa5e5$var$p2ms;

});

parcelRegister("8lnQV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $6132c9824c0df76a$var$OPS = $jodFS.OPS;

var $bAAqK = parcelRequire("bAAqK");
// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $6132c9824c0df76a$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        output: $bDP98.maybe($bDP98.Buffer),
        pubkey: $bDP98.maybe($bAAqK.isPoint),
        signature: $bDP98.maybe($jodFS.isCanonicalScriptSignature),
        input: $bDP98.maybe($bDP98.Buffer)
    }, a);
    const _chunks = $gVMye.value(()=>{
        return $jodFS.decompile(a.input);
    });
    const network = a.network || $csNcS.bitcoin;
    const o = {
        name: "p2pk",
        network: network
    };
    $gVMye.prop(o, "output", ()=>{
        if (!a.pubkey) return;
        return $jodFS.compile([
            a.pubkey,
            $6132c9824c0df76a$var$OPS.OP_CHECKSIG
        ]);
    });
    $gVMye.prop(o, "pubkey", ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $gVMye.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $gVMye.prop(o, "input", ()=>{
        if (!a.signature) return;
        return $jodFS.compile([
            a.signature
        ]);
    });
    $gVMye.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $6132c9824c0df76a$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!$bAAqK.isPoint(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$jodFS.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pk = $6132c9824c0df76a$var$p2pk;

});

parcelRegister("2aVOu", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $19595c7c918d910b$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3yeGF = parcelRequire("3yeGF");

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $19595c7c918d910b$var$OPS = $jodFS.OPS;

var $bAAqK = parcelRequire("bAAqK");

var $1Vf4C = parcelRequire("1Vf4C");
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $19595c7c918d910b$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        address: $bDP98.maybe($bDP98.String),
        hash: $bDP98.maybe($bDP98.BufferN(20)),
        output: $bDP98.maybe($bDP98.BufferN(25)),
        pubkey: $bDP98.maybe($bAAqK.isPoint),
        signature: $bDP98.maybe($jodFS.isCanonicalScriptSignature),
        input: $bDP98.maybe($bDP98.Buffer)
    }, a);
    const _address = $gVMye.value(()=>{
        const payload = $1Vf4C.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $gVMye.value(()=>{
        return $jodFS.decompile(a.input);
    });
    const network = a.network || $csNcS.bitcoin;
    const o = {
        name: "p2pkh",
        network: network
    };
    $gVMye.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $19595c7c918d910b$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $1Vf4C.encode(payload);
    });
    $gVMye.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $3yeGF.hash160(a.pubkey || o.pubkey);
    });
    $gVMye.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $jodFS.compile([
            $19595c7c918d910b$var$OPS.OP_DUP,
            $19595c7c918d910b$var$OPS.OP_HASH160,
            o.hash,
            $19595c7c918d910b$var$OPS.OP_EQUALVERIFY,
            $19595c7c918d910b$var$OPS.OP_CHECKSIG
        ]);
    });
    $gVMye.prop(o, "pubkey", ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $gVMye.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $gVMye.prop(o, "input", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $jodFS.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $gVMye.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $19595c7c918d910b$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $19595c7c918d910b$var$OPS.OP_DUP || a.output[1] !== $19595c7c918d910b$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $19595c7c918d910b$var$OPS.OP_EQUALVERIFY || a.output[24] !== $19595c7c918d910b$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $3yeGF.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$jodFS.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!$bAAqK.isPoint(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $3yeGF.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pkh = $19595c7c918d910b$var$p2pkh;

});
parcelRegister("3yeGF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3FiLE = parcelRequire("3FiLE");
const $295ff0a322ee66e4$var$AlgorithmLength = {
    ripemd160: 20,
    sha1: 20,
    sha256: 32,
    hash160: 20,
    hash256: 32
};
function $295ff0a322ee66e4$var$asDigest(buffer, preimage, algorithm) {
    const out = Object.assign(buffer, {
        preimage: preimage,
        algorithm: algorithm
    });
    const expectedLength = $295ff0a322ee66e4$var$AlgorithmLength[algorithm];
    if (out.length !== expectedLength) throw new Error("bad digest length");
    return out;
}
function $295ff0a322ee66e4$var$ripemd160(buffer) {
    let out;
    try {
        out = $3FiLE("rmd160").update(buffer).digest();
    } catch (err) {
        out = $3FiLE("ripemd160").update(buffer).digest();
    }
    return $295ff0a322ee66e4$var$asDigest(out, buffer, "ripemd160");
}
module.exports.ripemd160 = $295ff0a322ee66e4$var$ripemd160;
function $295ff0a322ee66e4$var$sha1(buffer) {
    const out = $3FiLE("sha1").update(buffer).digest();
    return $295ff0a322ee66e4$var$asDigest(out, buffer, "sha1");
}
module.exports.sha1 = $295ff0a322ee66e4$var$sha1;
function $295ff0a322ee66e4$var$sha256(buffer) {
    const out = $3FiLE("sha256").update(buffer).digest();
    return $295ff0a322ee66e4$var$asDigest(out, buffer, "sha256");
}
module.exports.sha256 = $295ff0a322ee66e4$var$sha256;
function $295ff0a322ee66e4$var$hash160(buffer) {
    const out = $295ff0a322ee66e4$var$ripemd160($295ff0a322ee66e4$var$sha256(buffer));
    return $295ff0a322ee66e4$var$asDigest(out, buffer, "hash160");
}
module.exports.hash160 = $295ff0a322ee66e4$var$hash160;
function $295ff0a322ee66e4$var$hash256(buffer) {
    const out = $295ff0a322ee66e4$var$sha256($295ff0a322ee66e4$var$sha256(buffer));
    return $295ff0a322ee66e4$var$asDigest(out, buffer, "hash256");
}
module.exports.hash256 = $295ff0a322ee66e4$var$hash256;

});


parcelRegister("6GYG8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4df5bbd3c8a66eb3$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3yeGF = parcelRequire("3yeGF");

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $4df5bbd3c8a66eb3$var$OPS = $jodFS.OPS;

var $1Vf4C = parcelRequire("1Vf4C");
function $4df5bbd3c8a66eb3$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $4df5bbd3c8a66eb3$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        address: $bDP98.maybe($bDP98.String),
        hash: $bDP98.maybe($bDP98.BufferN(20)),
        output: $bDP98.maybe($bDP98.BufferN(23)),
        redeem: $bDP98.maybe({
            network: $bDP98.maybe($bDP98.Object),
            output: $bDP98.maybe($bDP98.Buffer),
            input: $bDP98.maybe($bDP98.Buffer),
            witness: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
        }),
        input: $bDP98.maybe($bDP98.Buffer),
        witness: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $csNcS.bitcoin;
    const o = {
        network: network
    };
    const _address = $gVMye.value(()=>{
        const payload = $1Vf4C.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $gVMye.value(()=>{
        return $jodFS.decompile(a.input);
    });
    const _redeem = $gVMye.value(()=>{
        const chunks = _chunks();
        return {
            network: network,
            output: chunks[chunks.length - 1],
            input: $jodFS.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $gVMye.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $4df5bbd3c8a66eb3$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $1Vf4C.encode(payload);
    });
    $gVMye.prop(o, "hash", ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $3yeGF.hash160(o.redeem.output);
    });
    $gVMye.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $jodFS.compile([
            $4df5bbd3c8a66eb3$var$OPS.OP_HASH160,
            o.hash,
            $4df5bbd3c8a66eb3$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $gVMye.prop(o, "redeem", ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $gVMye.prop(o, "input", ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $jodFS.compile([].concat($jodFS.decompile(a.redeem.input), a.redeem.output));
    });
    $gVMye.prop(o, "witness", ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $gVMye.prop(o, "name", ()=>{
        const nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        let hash = $4df5bbd3c8a66eb3$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $4df5bbd3c8a66eb3$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $4df5bbd3c8a66eb3$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $jodFS.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                // match hash against other sources
                const hash2 = $3yeGF.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    const richunks = $jodFS.decompile(redeem.input);
                    if (!$jodFS.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$4df5bbd3c8a66eb3$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$4df5bbd3c8a66eb3$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2sh = $4df5bbd3c8a66eb3$var$p2sh;

});

parcelRegister("nirJJ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $046075293f62ed7e$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3yeGF = parcelRequire("3yeGF");

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $046075293f62ed7e$var$OPS = $jodFS.OPS;

var $bAAqK = parcelRequire("bAAqK");

var $5wgCY = parcelRequire("5wgCY");
const $046075293f62ed7e$var$EMPTY_BUFFER = $046075293f62ed7e$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $046075293f62ed7e$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        address: $bDP98.maybe($bDP98.String),
        hash: $bDP98.maybe($bDP98.BufferN(20)),
        input: $bDP98.maybe($bDP98.BufferN(0)),
        network: $bDP98.maybe($bDP98.Object),
        output: $bDP98.maybe($bDP98.BufferN(22)),
        pubkey: $bDP98.maybe($bAAqK.isPoint),
        signature: $bDP98.maybe($jodFS.isCanonicalScriptSignature),
        witness: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
    }, a);
    const _address = $gVMye.value(()=>{
        const result = $5wgCY.decode(a.address);
        const version = result.words.shift();
        const data = $5wgCY.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $046075293f62ed7e$require$Buffer.from(data)
        };
    });
    const network = a.network || $csNcS.bitcoin;
    const o = {
        name: "p2wpkh",
        network: network
    };
    $gVMye.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $5wgCY.toWords(o.hash);
        words.unshift(0x00);
        return $5wgCY.encode(network.bech32, words);
    });
    $gVMye.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $3yeGF.hash160(a.pubkey || o.pubkey);
    });
    $gVMye.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $jodFS.compile([
            $046075293f62ed7e$var$OPS.OP_0,
            o.hash
        ]);
    });
    $gVMye.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $gVMye.prop(o, "signature", ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $gVMye.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $046075293f62ed7e$var$EMPTY_BUFFER;
    });
    $gVMye.prop(o, "witness", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $046075293f62ed7e$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $046075293f62ed7e$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $3yeGF.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!$bAAqK.isPoint(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$jodFS.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!$bAAqK.isPoint(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $3yeGF.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wpkh = $046075293f62ed7e$var$p2wpkh;

});

parcelRegister("2mgzh", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1b7a7ce9d3531bc8$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3yeGF = parcelRequire("3yeGF");

var $csNcS = parcelRequire("csNcS");

var $jodFS = parcelRequire("jodFS");

var $gVMye = parcelRequire("gVMye");

var $bDP98 = parcelRequire("bDP98");
const $1b7a7ce9d3531bc8$var$OPS = $jodFS.OPS;

var $bAAqK = parcelRequire("bAAqK");

var $5wgCY = parcelRequire("5wgCY");
const $1b7a7ce9d3531bc8$var$EMPTY_BUFFER = $1b7a7ce9d3531bc8$require$Buffer.alloc(0);
function $1b7a7ce9d3531bc8$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
function $1b7a7ce9d3531bc8$var$chunkHasUncompressedPubkey(chunk) {
    if ($1b7a7ce9d3531bc8$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && $bAAqK.isPoint(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $1b7a7ce9d3531bc8$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $bDP98({
        network: $bDP98.maybe($bDP98.Object),
        address: $bDP98.maybe($bDP98.String),
        hash: $bDP98.maybe($bDP98.BufferN(32)),
        output: $bDP98.maybe($bDP98.BufferN(34)),
        redeem: $bDP98.maybe({
            input: $bDP98.maybe($bDP98.Buffer),
            network: $bDP98.maybe($bDP98.Object),
            output: $bDP98.maybe($bDP98.Buffer),
            witness: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
        }),
        input: $bDP98.maybe($bDP98.BufferN(0)),
        witness: $bDP98.maybe($bDP98.arrayOf($bDP98.Buffer))
    }, a);
    const _address = $gVMye.value(()=>{
        const result = $5wgCY.decode(a.address);
        const version = result.words.shift();
        const data = $5wgCY.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $1b7a7ce9d3531bc8$require$Buffer.from(data)
        };
    });
    const _rchunks = $gVMye.value(()=>{
        return $jodFS.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $csNcS.bitcoin;
    const o = {
        network: network
    };
    $gVMye.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $5wgCY.toWords(o.hash);
        words.unshift(0x00);
        return $5wgCY.encode(network.bech32, words);
    });
    $gVMye.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $3yeGF.sha256(o.redeem.output);
    });
    $gVMye.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $jodFS.compile([
            $1b7a7ce9d3531bc8$var$OPS.OP_0,
            o.hash
        ]);
    });
    $gVMye.prop(o, "redeem", ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $1b7a7ce9d3531bc8$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $gVMye.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $1b7a7ce9d3531bc8$var$EMPTY_BUFFER;
    });
    $gVMye.prop(o, "witness", ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $jodFS.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $1b7a7ce9d3531bc8$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $gVMye.prop(o, "name", ()=>{
        const nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        let hash = $1b7a7ce9d3531bc8$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $1b7a7ce9d3531bc8$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty?
            if (a.redeem.output) {
                if ($jodFS.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // match hash against other sources
                const hash2 = $3yeGF.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (a.redeem.input && !$jodFS.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !$1b7a7ce9d3531bc8$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($1b7a7ce9d3531bc8$var$chunkHasUncompressedPubkey) || a.redeem.output && ($jodFS.decompile(a.redeem.output) || []).some($1b7a7ce9d3531bc8$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($1b7a7ce9d3531bc8$var$chunkHasUncompressedPubkey) || ($jodFS.decompile(wScript) || []).some($1b7a7ce9d3531bc8$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wsh = $1b7a7ce9d3531bc8$var$p2wsh;

});



parcelRegister("kNAnL", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f2449afe11014762$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $csNcS = parcelRequire("csNcS");

var $7TFFW = parcelRequire("7TFFW");

var $bAAqK = parcelRequire("bAAqK");

var $5rfiH = parcelRequire("5rfiH");

var $bDP98 = parcelRequire("bDP98");

var $bTFmB = parcelRequire("bTFmB");
const $f2449afe11014762$var$isOptions = $bDP98.maybe($bDP98.compile({
    compressed: $7TFFW.maybe($7TFFW.Boolean),
    network: $7TFFW.maybe($7TFFW.Network)
}));
class $f2449afe11014762$var$ECPair {
    constructor(__D, __Q, options){
        this.__D = __D;
        this.__Q = __Q;
        this.lowR = false;
        if (options === undefined) options = {};
        this.compressed = options.compressed === undefined ? true : options.compressed;
        this.network = options.network || $csNcS.bitcoin;
        if (__Q !== undefined) this.__Q = $bAAqK.pointCompress(__Q, this.compressed);
    }
    get privateKey() {
        return this.__D;
    }
    get publicKey() {
        if (!this.__Q) this.__Q = $bAAqK.pointFromScalar(this.__D, this.compressed);
        return this.__Q;
    }
    toWIF() {
        if (!this.__D) throw new Error("Missing private key");
        return $bTFmB.encode(this.network.wif, this.__D, this.compressed);
    }
    sign(hash, lowR) {
        if (!this.__D) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $bAAqK.sign(hash, this.__D);
        else {
            let sig = $bAAqK.sign(hash, this.__D);
            const extraData = $f2449afe11014762$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $bAAqK.signWithEntropy(hash, this.__D, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $bAAqK.verify(hash, this.publicKey, signature);
    }
}
function $f2449afe11014762$var$fromPrivateKey(buffer, options) {
    $bDP98($7TFFW.Buffer256bit, buffer);
    if (!$bAAqK.isPrivate(buffer)) throw new TypeError("Private key not in range [1, n)");
    $bDP98($f2449afe11014762$var$isOptions, options);
    return new $f2449afe11014762$var$ECPair(buffer, undefined, options);
}
module.exports.fromPrivateKey = $f2449afe11014762$var$fromPrivateKey;
function $f2449afe11014762$var$fromPublicKey(buffer, options) {
    $bDP98($bAAqK.isPoint, buffer);
    $bDP98($f2449afe11014762$var$isOptions, options);
    return new $f2449afe11014762$var$ECPair(undefined, buffer, options);
}
module.exports.fromPublicKey = $f2449afe11014762$var$fromPublicKey;
function $f2449afe11014762$var$fromWIF(wifString, network) {
    const decoded = $bTFmB.decode(wifString);
    const version = decoded.version;
    // list of networks?
    if ($7TFFW.Array(network)) {
        network = network.filter((x)=>{
            return version === x.wif;
        }).pop();
        if (!network) throw new Error("Unknown network version");
    // otherwise, assume a network object (or default to bitcoin)
    } else {
        network = network || $csNcS.bitcoin;
        if (version !== network.wif) throw new Error("Invalid network version");
    }
    return $f2449afe11014762$var$fromPrivateKey(decoded.privateKey, {
        compressed: decoded.compressed,
        network: network
    });
}
module.exports.fromWIF = $f2449afe11014762$var$fromWIF;
function $f2449afe11014762$var$makeRandom(options) {
    $bDP98($f2449afe11014762$var$isOptions, options);
    if (options === undefined) options = {};
    const rng = options.rng || $5rfiH;
    let d;
    do {
        d = rng(32);
        $bDP98($7TFFW.Buffer256bit, d);
    }while (!$bAAqK.isPrivate(d));
    return $f2449afe11014762$var$fromPrivateKey(d, options);
}
module.exports.makeRandom = $f2449afe11014762$var$makeRandom;

});

parcelRegister("25LHc", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $18610bc8de268b4a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ioOhP = parcelRequire("ioOhP");

var $3yeGF = parcelRequire("3yeGF");

var $5BO4o = parcelRequire("5BO4o");

var $7TFFW = parcelRequire("7TFFW");

var $2hPmQ = parcelRequire("2hPmQ");

var $bDP98 = parcelRequire("bDP98");

var $fzlx7 = parcelRequire("fzlx7");
const $18610bc8de268b4a$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
const $18610bc8de268b4a$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
class $18610bc8de268b4a$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
        const bufferReader = new $ioOhP.BufferReader(buffer);
        const block = new $18610bc8de268b4a$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $5BO4o.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $18610bc8de268b4a$var$Block.fromBuffer($18610bc8de268b4a$require$Buffer.from(hex, "hex"));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $18610bc8de268b4a$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $bDP98([
            {
                getHash: $7TFFW.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $18610bc8de268b4a$var$errorMerkleNoTxes;
        if (forWitness && !$18610bc8de268b4a$var$txesHaveWitnessCommit(transactions)) throw $18610bc8de268b4a$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = $2hPmQ(hashes, $3yeGF.hash256);
        return forWitness ? $3yeGF.hash256($18610bc8de268b4a$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$18610bc8de268b4a$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($18610bc8de268b4a$require$Buffer.from("6a24aa21a9ed", "hex"))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $18610bc8de268b4a$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $18610bc8de268b4a$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $18610bc8de268b4a$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $fzlx7.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $3yeGF.hash256(this.toBuffer(true));
    }
    getId() {
        return $ioOhP.reverseBuffer(this.getHash()).toString("hex");
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $18610bc8de268b4a$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $ioOhP.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $fzlx7.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $fzlx7.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString("hex");
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = $ioOhP.reverseBuffer(this.getHash());
        const target = $18610bc8de268b4a$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $18610bc8de268b4a$var$errorMerkleNoTxes;
        const actualMerkleRoot = $18610bc8de268b4a$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $18610bc8de268b4a$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $18610bc8de268b4a$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $18610bc8de268b4a$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
module.exports.Block = $18610bc8de268b4a$var$Block;
function $18610bc8de268b4a$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $18610bc8de268b4a$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === "object" && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === "object" && input.witness instanceof Array && input.witness.length > 0));
}

});
parcelRegister("ioOhP", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d65179bfff1c5685$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7TFFW = parcelRequire("7TFFW");

var $bDP98 = parcelRequire("bDP98");

var $fzlx7 = parcelRequire("fzlx7");
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $d65179bfff1c5685$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $d65179bfff1c5685$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $d65179bfff1c5685$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $d65179bfff1c5685$var$readUInt64LE;
function $d65179bfff1c5685$var$writeUInt64LE(buffer, value, offset) {
    $d65179bfff1c5685$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $d65179bfff1c5685$var$writeUInt64LE;
function $d65179bfff1c5685$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $d65179bfff1c5685$var$reverseBuffer;
function $d65179bfff1c5685$var$cloneBuffer(buffer) {
    const clone = $d65179bfff1c5685$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
module.exports.cloneBuffer = $d65179bfff1c5685$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $d65179bfff1c5685$var$BufferWriter {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $bDP98($7TFFW.tuple($7TFFW.Buffer, $7TFFW.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $d65179bfff1c5685$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $fzlx7.encode(i, this.buffer, this.offset);
        this.offset += $fzlx7.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
}
module.exports.BufferWriter = $d65179bfff1c5685$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $d65179bfff1c5685$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $bDP98($7TFFW.tuple($7TFFW.Buffer, $7TFFW.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $d65179bfff1c5685$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $fzlx7.decode(this.buffer, this.offset);
        this.offset += $fzlx7.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $d65179bfff1c5685$var$BufferReader;

});
parcelRegister("fzlx7", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $b55ad3f0f448722b$require$Buffer = $6U9mG.Buffer;
// Number.MAX_SAFE_INTEGER
var $b55ad3f0f448722b$var$MAX_SAFE_INTEGER = 9007199254740991;
function $b55ad3f0f448722b$var$checkUInt53(n) {
    if (n < 0 || n > $b55ad3f0f448722b$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $b55ad3f0f448722b$var$encode(number, buffer, offset) {
    $b55ad3f0f448722b$var$checkUInt53(number);
    if (!buffer) buffer = $b55ad3f0f448722b$require$Buffer.allocUnsafe($b55ad3f0f448722b$var$encodingLength(number));
    if (!$b55ad3f0f448722b$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        $b55ad3f0f448722b$var$encode.bytes = 1;
    // 16 bit
    } else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        $b55ad3f0f448722b$var$encode.bytes = 3;
    // 32 bit
    } else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        $b55ad3f0f448722b$var$encode.bytes = 5;
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE(number / 0x100000000 | 0, offset + 5);
        $b55ad3f0f448722b$var$encode.bytes = 9;
    }
    return buffer;
}
function $b55ad3f0f448722b$var$decode(buffer, offset) {
    if (!$b55ad3f0f448722b$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        $b55ad3f0f448722b$var$decode.bytes = 1;
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        $b55ad3f0f448722b$var$decode.bytes = 3;
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        $b55ad3f0f448722b$var$decode.bytes = 5;
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        $b55ad3f0f448722b$var$decode.bytes = 9;
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var number = hi * 0x0100000000 + lo;
        $b55ad3f0f448722b$var$checkUInt53(number);
        return number;
    }
}
function $b55ad3f0f448722b$var$encodingLength(number) {
    $b55ad3f0f448722b$var$checkUInt53(number);
    return number < 0xfd ? 1 : number <= 0xffff ? 3 : number <= 0xffffffff ? 5 : 9;
}
module.exports = {
    encode: $b55ad3f0f448722b$var$encode,
    decode: $b55ad3f0f448722b$var$decode,
    encodingLength: $b55ad3f0f448722b$var$encodingLength
};

});


parcelRegister("5BO4o", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $41573f4cfb5bcca5$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ioOhP = parcelRequire("ioOhP");

var $3yeGF = parcelRequire("3yeGF");

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");

var $7TFFW = parcelRequire("7TFFW");

var $bDP98 = parcelRequire("bDP98");

var $fzlx7 = parcelRequire("fzlx7");
function $41573f4cfb5bcca5$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $fzlx7.encodingLength(length) + length;
}
function $41573f4cfb5bcca5$var$vectorSize(someVector) {
    const length = someVector.length;
    return $fzlx7.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $41573f4cfb5bcca5$var$varSliceSize(witness);
    }, 0);
}
const $41573f4cfb5bcca5$var$EMPTY_SCRIPT = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(0);
const $41573f4cfb5bcca5$var$EMPTY_WITNESS = [];
const $41573f4cfb5bcca5$var$ZERO = $41573f4cfb5bcca5$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
const $41573f4cfb5bcca5$var$ONE = $41573f4cfb5bcca5$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
const $41573f4cfb5bcca5$var$VALUE_UINT64_MAX = $41573f4cfb5bcca5$require$Buffer.from("ffffffffffffffff", "hex");
const $41573f4cfb5bcca5$var$BLANK_OUTPUT = {
    script: $41573f4cfb5bcca5$var$EMPTY_SCRIPT,
    valueBuffer: $41573f4cfb5bcca5$var$VALUE_UINT64_MAX
};
function $41573f4cfb5bcca5$var$isOutput(out) {
    return out.value !== undefined;
}
class $41573f4cfb5bcca5$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $ioOhP.BufferReader(buffer);
        const tx = new $41573f4cfb5bcca5$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $41573f4cfb5bcca5$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
        return tx;
    }
    static fromHex(hex) {
        return $41573f4cfb5bcca5$var$Transaction.fromBuffer($41573f4cfb5bcca5$require$Buffer.from(hex, "hex"), false);
    }
    static isCoinbaseHash(buffer) {
        $bDP98($7TFFW.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $41573f4cfb5bcca5$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $bDP98($7TFFW.tuple($7TFFW.Hash256bit, $7TFFW.UInt32, $7TFFW.maybe($7TFFW.UInt32), $7TFFW.maybe($7TFFW.Buffer)), arguments);
        if ($7TFFW.Null(sequence)) sequence = $41573f4cfb5bcca5$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $41573f4cfb5bcca5$var$EMPTY_SCRIPT,
            sequence: sequence,
            witness: $41573f4cfb5bcca5$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $bDP98($7TFFW.tuple($7TFFW.Buffer, $7TFFW.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $fzlx7.encodingLength(this.ins.length) + $fzlx7.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $41573f4cfb5bcca5$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $41573f4cfb5bcca5$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $41573f4cfb5bcca5$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $41573f4cfb5bcca5$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $bDP98($7TFFW.tuple($7TFFW.UInt32, $7TFFW.Buffer, /* types.UInt8 */ $7TFFW.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $41573f4cfb5bcca5$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $jodFS.compile($jodFS.decompile(prevOutScript).filter((x)=>{
            return x !== $jodFS.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $41573f4cfb5bcca5$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $41573f4cfb5bcca5$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $41573f4cfb5bcca5$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $41573f4cfb5bcca5$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $41573f4cfb5bcca5$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $41573f4cfb5bcca5$var$EMPTY_SCRIPT;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $3yeGF.hash256(buffer);
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $bDP98($7TFFW.tuple($7TFFW.UInt32, $7TFFW.Buffer, $7TFFW.Satoshi, $7TFFW.UInt32), arguments);
        let tbuffer = $41573f4cfb5bcca5$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $41573f4cfb5bcca5$var$ZERO;
        let hashPrevouts = $41573f4cfb5bcca5$var$ZERO;
        let hashSequence = $41573f4cfb5bcca5$var$ZERO;
        if (!(hashType & $41573f4cfb5bcca5$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $ioOhP.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $3yeGF.hash256(tbuffer);
        }
        if (!(hashType & $41573f4cfb5bcca5$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $41573f4cfb5bcca5$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $41573f4cfb5bcca5$var$Transaction.SIGHASH_NONE) {
            tbuffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $ioOhP.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $3yeGF.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $41573f4cfb5bcca5$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $41573f4cfb5bcca5$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $41573f4cfb5bcca5$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $ioOhP.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $3yeGF.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $41573f4cfb5bcca5$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(8 + $41573f4cfb5bcca5$var$varSliceSize(output.script));
            bufferWriter = new $ioOhP.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $3yeGF.hash256(tbuffer);
        }
        tbuffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(156 + $41573f4cfb5bcca5$var$varSliceSize(prevOutScript));
        bufferWriter = new $ioOhP.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeUInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $3yeGF.hash256(tbuffer);
    }
    /**
   * Hash transaction for signing a specific input for Bitcoin Cash.
   */ hashForCashSignature(inIndex, prevOutScript, inAmount, hashType) {
        $bDP98($7TFFW.tuple($7TFFW.UInt32, $7TFFW.Buffer, /* types.UInt8 */ $7TFFW.Number, $7TFFW.maybe($7TFFW.UInt53)), arguments);
        // This function works the way it does because Bitcoin Cash
        // uses BIP143 as their replay protection, AND their algo
        // includes `forkId | hashType`, AND since their forkId=0,
        // this is a NOP, and has no difference to segwit. To support
        // other forks, another parameter is required, and a new parameter
        // would be required in the hashForWitnessV0 function, or
        // it could be broken into two..
        // BIP143 sighash activated in BitcoinCash via 0x40 bit
        if (hashType & $41573f4cfb5bcca5$var$Transaction.SIGHASH_BITCOINCASHBIP143) {
            if ($7TFFW.Null(inAmount)) throw new Error("Bitcoin Cash sighash requires value of input to be signed.");
            return this.hashForWitnessV0(inIndex, prevOutScript, inAmount, hashType);
        } else return this.hashForSignature(inIndex, prevOutScript, hashType);
    }
    /**
   * Hash transaction for signing a specific input for Bitcoin Gold.
   */ hashForGoldSignature(inIndex, prevOutScript, inAmount, hashType, sigVersion) {
        $bDP98($7TFFW.tuple($7TFFW.UInt32, $7TFFW.Buffer, /* types.UInt8 */ $7TFFW.Number, $7TFFW.maybe($7TFFW.UInt53)), arguments);
        // Bitcoin Gold also implements segregated witness
        // therefore we can pull out the setting of nForkHashType
        // and pass it into the functions.
        let nForkHashType = hashType;
        const fUseForkId = (hashType & $41573f4cfb5bcca5$var$Transaction.SIGHASH_BITCOINCASHBIP143) > 0;
        if (fUseForkId) nForkHashType |= $41573f4cfb5bcca5$var$Transaction.FORKID_BTG << 8;
        // BIP143 sighash activated in BitcoinCash via 0x40 bit
        if (sigVersion || fUseForkId) {
            if ($7TFFW.Null(inAmount)) throw new Error("Bitcoin Cash sighash requires value of input to be signed.");
            return this.hashForWitnessV0(inIndex, prevOutScript, inAmount, nForkHashType);
        } else return this.hashForSignature(inIndex, prevOutScript, nForkHashType);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $41573f4cfb5bcca5$require$Buffer.alloc(32, 0);
        return $3yeGF.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return $ioOhP.reverseBuffer(this.getHash(false)).toString("hex");
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString("hex");
    }
    setInputScript(index, scriptSig) {
        $bDP98($7TFFW.tuple($7TFFW.Number, $7TFFW.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $bDP98($7TFFW.tuple($7TFFW.Number, [
            $7TFFW.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $41573f4cfb5bcca5$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $ioOhP.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($41573f4cfb5bcca5$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
$41573f4cfb5bcca5$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$41573f4cfb5bcca5$var$Transaction.SIGHASH_ALL = 0x01;
$41573f4cfb5bcca5$var$Transaction.SIGHASH_NONE = 0x02;
$41573f4cfb5bcca5$var$Transaction.SIGHASH_SINGLE = 0x03;
$41573f4cfb5bcca5$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$41573f4cfb5bcca5$var$Transaction.SIGHASH_BITCOINCASHBIP143 = 0x40;
$41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$41573f4cfb5bcca5$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;
$41573f4cfb5bcca5$var$Transaction.FORKID_BTG = 0x4f; // 79
$41573f4cfb5bcca5$var$Transaction.FORKID_BCH = 0x00;
module.exports.Transaction = $41573f4cfb5bcca5$var$Transaction;

});

parcelRegister("2hPmQ", function(module, exports) {
// constant-space merkle root calculation algorithm

var $ihoyg = parcelRequire("ihoyg");
var $1aa503d23d5ee581$require$Buffer = $ihoyg.Buffer;
module.exports = function fastRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    var length = values.length;
    var results = values.concat();
    while(length > 1){
        var j = 0;
        for(var i = 0; i < length; i += 2, ++j){
            var left = results[i];
            var right = i + 1 === length ? left : results[i + 1];
            var data = $1aa503d23d5ee581$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
};

});


parcelRegister("1Mn1d", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $14bc2124010cfa0c$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gGBHT = parcelRequire("gGBHT");

var $kU6Cf = parcelRequire("kU6Cf");

var $93bki = parcelRequire("93bki");

var $h6Byf = parcelRequire("h6Byf");

var $ioOhP = parcelRequire("ioOhP");

var $3yeGF = parcelRequire("3yeGF");

var $kNAnL = parcelRequire("kNAnL");

var $csNcS = parcelRequire("csNcS");

var $ltfXM = parcelRequire("ltfXM");

var $jodFS = parcelRequire("jodFS");

var $5BO4o = parcelRequire("5BO4o");
const $14bc2124010cfa0c$var$BCH_SIGHASH_ALL = $5BO4o.Transaction.SIGHASH_ALL | $5BO4o.Transaction.SIGHASH_BITCOINCASHBIP143;
const $14bc2124010cfa0c$var$BTG_SIGHASH_ALL = $5BO4o.Transaction.SIGHASH_ALL | $5BO4o.Transaction.SIGHASH_BITCOINCASHBIP143 | $5BO4o.Transaction.FORKID_BTG << 8;
const $14bc2124010cfa0c$var$DEFAULT_SIGHASHES = [
    // BTC SIGHASH_ALL
    $5BO4o.Transaction.SIGHASH_ALL,
    // BCH SIGHASH_ALL
    $14bc2124010cfa0c$var$BCH_SIGHASH_ALL,
    // BTG SIGHASH_ALL
    $14bc2124010cfa0c$var$BTG_SIGHASH_ALL
];
/**
 * These are the default arguments for a Psbt instance.
 */ const $14bc2124010cfa0c$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $csNcS.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000,
    forkCoin: "none"
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $14bc2124010cfa0c$var$Psbt {
    constructor(opts = {}, data = new $gGBHT.Psbt(new $14bc2124010cfa0c$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $14bc2124010cfa0c$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Old TransactionBuilder behavior was to not confirm input values
            // before signing. Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    static fromBase64(data, opts = {}) {
        const buffer = $14bc2124010cfa0c$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $14bc2124010cfa0c$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $gGBHT.Psbt.fromBuffer(buffer, $14bc2124010cfa0c$var$transactionFromBuffer);
        const psbt = new $14bc2124010cfa0c$var$Psbt(opts, psbtBase);
        $14bc2124010cfa0c$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: $ioOhP.cloneBuffer(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = $h6Byf.fromOutputScript(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: $ioOhP.cloneBuffer(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $14bc2124010cfa0c$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $14bc2124010cfa0c$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $14bc2124010cfa0c$var$check32Bit(version);
        $14bc2124010cfa0c$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $14bc2124010cfa0c$var$check32Bit(locktime);
        $14bc2124010cfa0c$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $14bc2124010cfa0c$var$check32Bit(sequence);
        $14bc2124010cfa0c$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        $14bc2124010cfa0c$var$checkInputsForPartialSig(this.data.inputs, "addInput");
        if (inputData.witnessScript) $14bc2124010cfa0c$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $14bc2124010cfa0c$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $14bc2124010cfa0c$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $14bc2124010cfa0c$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
        const { address: address } = outputData;
        if (typeof address === "string") {
            const { network: network } = this.opts;
            const script = $h6Byf.toOutputScript(address, network);
            outputData = Object.assign(outputData, {
                script: script
            });
        }
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($14bc2124010cfa0c$var$isFinalized)) throw new Error("Not finalized");
        const c = this.__CACHE;
        if (!disableFeeCheck) $14bc2124010cfa0c$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $14bc2124010cfa0c$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $14bc2124010cfa0c$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $14bc2124010cfa0c$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        $93bki.checkForInput(this.data.inputs, 0); // making sure we have at least one
        $14bc2124010cfa0c$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc = $14bc2124010cfa0c$var$getFinalScripts) {
        const input = $93bki.checkForInput(this.data.inputs, inputIndex);
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $14bc2124010cfa0c$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $14bc2124010cfa0c$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = $93bki.checkForInput(this.data.inputs, inputIndex);
        const script = $14bc2124010cfa0c$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $14bc2124010cfa0c$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $14bc2124010cfa0c$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $14bc2124010cfa0c$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === "raw" ? "" : result.type + "-";
        const mainType = $14bc2124010cfa0c$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = $93bki.checkForInput(this.data.inputs, inputIndex);
        return $14bc2124010cfa0c$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = $93bki.checkForInput(this.data.inputs, inputIndex);
        const derivationIsMine = $14bc2124010cfa0c$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = $93bki.checkForOutput(this.data.outputs, outputIndex);
        return $14bc2124010cfa0c$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = $93bki.checkForOutput(this.data.outputs, outputIndex);
        const derivationIsMine = $14bc2124010cfa0c$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs() {
        $93bki.checkForInput(this.data.inputs, 0); // making sure we have at least one
        const results = $14bc2124010cfa0c$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $jodFS.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $14bc2124010cfa0c$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true, this.opts.forkCoin) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $14bc2124010cfa0c$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
            const keypair = $kNAnL.fromPublicKey(pSig.pubkey);
            results.push(keypair.verify(hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    signAllInputsHD(hdKeyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const results = [];
        for (const i of $14bc2124010cfa0c$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const results = [];
            const promises = [];
            for (const i of $14bc2124010cfa0c$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const signers = $14bc2124010cfa0c$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const signers = $14bc2124010cfa0c$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $14bc2124010cfa0c$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const { hash: hash, sighashType: sighashType } = $14bc2124010cfa0c$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes, this.opts.forkCoin);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $jodFS.signature.encode(keyPair.sign(hash), sighashType & 0xff)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes = $14bc2124010cfa0c$var$DEFAULT_SIGHASHES) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const { hash: hash, sighashType: sighashType } = $14bc2124010cfa0c$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes, this.opts.forkCoin);
            return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
                const partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $jodFS.signature.encode(signature, sighashType & 0xff)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
            });
        });
    }
    toBuffer() {
        $14bc2124010cfa0c$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $14bc2124010cfa0c$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $14bc2124010cfa0c$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $14bc2124010cfa0c$var$checkInvalidP2WSH(updateData.witnessScript);
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $14bc2124010cfa0c$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
module.exports.Psbt = $14bc2124010cfa0c$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $14bc2124010cfa0c$var$transactionFromBuffer = (buffer)=>new $14bc2124010cfa0c$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $14bc2124010cfa0c$var$PsbtTransaction {
    constructor(buffer = $14bc2124010cfa0c$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $5BO4o.Transaction.fromBuffer(buffer);
        $14bc2124010cfa0c$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$14bc2124010cfa0c$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
        const hash = typeof input.hash === "string" ? $ioOhP.reverseBuffer($14bc2124010cfa0c$require$Buffer.from(input.hash, "hex")) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$14bc2124010cfa0c$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $14bc2124010cfa0c$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $14bc2124010cfa0c$var$hasSigs(1, input.partialSig);
        case "multisig":
            const p2ms = $ltfXM.p2ms({
                output: script
            });
            return $14bc2124010cfa0c$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $14bc2124010cfa0c$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $14bc2124010cfa0c$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $kNAnL.fromPublicKey(pkey, {
            compressed: true
        }).publicKey;
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $14bc2124010cfa0c$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $14bc2124010cfa0c$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
const $14bc2124010cfa0c$var$isP2MS = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2ms);
const $14bc2124010cfa0c$var$isP2PK = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2pk);
const $14bc2124010cfa0c$var$isP2PKH = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2pkh);
const $14bc2124010cfa0c$var$isP2WPKH = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2wpkh);
const $14bc2124010cfa0c$var$isP2WSHScript = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2wsh);
const $14bc2124010cfa0c$var$isP2SHScript = $14bc2124010cfa0c$var$isPaymentFactory($ltfXM.p2sh);
function $14bc2124010cfa0c$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $14bc2124010cfa0c$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $14bc2124010cfa0c$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $14bc2124010cfa0c$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        let throws = false;
        let pSigs = [];
        if ((input.partialSig || []).length === 0) {
            if (!input.finalScriptSig && !input.finalScriptWitness) return;
            pSigs = $14bc2124010cfa0c$var$getPsigsFromInputFinalScripts(input);
        } else pSigs = input.partialSig;
        pSigs.forEach((pSig)=>{
            const { hashType: hashType } = $jodFS.signature.decode(pSig.signature);
            const whitelist = [];
            const isAnyoneCanPay = hashType & $5BO4o.Transaction.SIGHASH_ANYONECANPAY;
            if (isAnyoneCanPay) whitelist.push("addInput");
            const hashMod = hashType & 0x1f;
            switch(hashMod){
                case $5BO4o.Transaction.SIGHASH_ALL:
                    break;
                case $5BO4o.Transaction.SIGHASH_SINGLE:
                case $5BO4o.Transaction.SIGHASH_NONE:
                    whitelist.push("addOutput");
                    whitelist.push("setInputSequence");
                    break;
            }
            if (whitelist.indexOf(action) === -1) throws = true;
        });
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $14bc2124010cfa0c$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $jodFS.signature.decode(pSig.signature);
        if ((sighashType & 0xff) !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $14bc2124010cfa0c$var$checkScriptForPubkey(pubkey, script, action) {
    if (!$14bc2124010cfa0c$var$pubkeyInScript(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString("hex")}`);
}
function $14bc2124010cfa0c$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $14bc2124010cfa0c$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $14bc2124010cfa0c$var$checkTxInputCache(cache, input);
    });
}
function $14bc2124010cfa0c$var$checkTxInputCache(cache, input) {
    const key = $ioOhP.reverseBuffer($14bc2124010cfa0c$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $14bc2124010cfa0c$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $14bc2124010cfa0c$var$checkRedeemScript = $14bc2124010cfa0c$var$scriptCheckerFactory($ltfXM.p2sh, "Redeem script");
const $14bc2124010cfa0c$var$checkWitnessScript = $14bc2124010cfa0c$var$scriptCheckerFactory($ltfXM.p2wsh, "Witness script");
function $14bc2124010cfa0c$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($14bc2124010cfa0c$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $14bc2124010cfa0c$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $14bc2124010cfa0c$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $14bc2124010cfa0c$var$classifyScript(script);
    if (!$14bc2124010cfa0c$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $14bc2124010cfa0c$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $14bc2124010cfa0c$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $14bc2124010cfa0c$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $ltfXM.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $ltfXM.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = $14bc2124010cfa0c$var$witnessStackToScriptWitness(p2wsh.witness);
        else finalScriptWitness = $14bc2124010cfa0c$var$witnessStackToScriptWitness(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $14bc2124010cfa0c$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes, forkCoin) {
    const input = $93bki.checkForInput(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $14bc2124010cfa0c$var$getHashForSig(inputIndex, input, cache, false, forkCoin, sighashTypes);
    $14bc2124010cfa0c$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $14bc2124010cfa0c$var$getDefaultSighash(forkCoin) {
    switch(forkCoin){
        case "bch":
            return $14bc2124010cfa0c$var$BCH_SIGHASH_ALL;
        case "btg":
            return $14bc2124010cfa0c$var$BTG_SIGHASH_ALL;
        case "none":
            return $5BO4o.Transaction.SIGHASH_ALL;
    }
}
function $14bc2124010cfa0c$var$getHashForSig(inputIndex, input, cache, forValidate, forkCoin, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $14bc2124010cfa0c$var$getDefaultSighash(forkCoin);
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $14bc2124010cfa0c$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
    let hash;
    let prevout;
    const isForkId = (sighashType & $5BO4o.Transaction.SIGHASH_BITCOINCASHBIP143) > 0;
    const isBTG = (sighashType & $5BO4o.Transaction.FORKID_BTG << 8) > 0;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $14bc2124010cfa0c$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    const { meaningfulScript: meaningfulScript, type: type } = $14bc2124010cfa0c$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript);
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) {
        if (isForkId && isBTG) hash = unsignedTx.hashForGoldSignature(inputIndex, meaningfulScript, prevout.value, sighashType, true);
        else hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    } else if ($14bc2124010cfa0c$var$isP2WPKH(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $ltfXM.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        if (isForkId && isBTG) hash = unsignedTx.hashForGoldSignature(inputIndex, signingScript, prevout.value, sighashType, true);
        else hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (!isForkId && input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString("hex")}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as the old TransactionBuilder class when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        if (isForkId && isBTG) hash = unsignedTx.hashForGoldSignature(inputIndex, meaningfulScript, prevout.value, sighashType, true);
        else if (isForkId) hash = unsignedTx.hashForCashSignature(inputIndex, meaningfulScript, prevout.value, sighashType);
        else hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $14bc2124010cfa0c$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case "multisig":
            const sigs = $14bc2124010cfa0c$var$getSortedSigs(script, partialSig);
            payment = $ltfXM.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $ltfXM.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $ltfXM.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $ltfXM.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $14bc2124010cfa0c$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $jodFS.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $jodFS.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $14bc2124010cfa0c$require$Buffer.isBuffer(item) && $jodFS.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}
function $14bc2124010cfa0c$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $14bc2124010cfa0c$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || $14bc2124010cfa0c$var$isP2WPKH(res.script)) res.isSegwit = true;
    return res;
}
function $14bc2124010cfa0c$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = $93bki.checkForInput(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $14bc2124010cfa0c$var$getSortedSigs(script, partialSig) {
    const p2ms = $ltfXM.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $14bc2124010cfa0c$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $kU6Cf.decode(buffer, offset);
        offset += $kU6Cf.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $14bc2124010cfa0c$var$sighashTypeToString(sighashType) {
    let text = sighashType & $5BO4o.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    if (sighashType & $5BO4o.Transaction.SIGHASH_BITCOINCASHBIP143) text += "SIGHASH_BITCOINCASHBIP143 | ";
    if (sighashType & $5BO4o.Transaction.FORKID_BTG << 8) text += "FORKID_BTG | ";
    else text += "FORKID_BCH | ";
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $5BO4o.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $5BO4o.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $5BO4o.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $14bc2124010cfa0c$var$witnessStackToScriptWitness(witness) {
    let buffer = $14bc2124010cfa0c$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $14bc2124010cfa0c$require$Buffer.concat([
            buffer,
            $14bc2124010cfa0c$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $kU6Cf.encodingLength(i);
        buffer = $14bc2124010cfa0c$require$Buffer.concat([
            buffer,
            $14bc2124010cfa0c$require$Buffer.allocUnsafe(varintLen)
        ]);
        $kU6Cf.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $14bc2124010cfa0c$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $5BO4o.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $14bc2124010cfa0c$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $14bc2124010cfa0c$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $14bc2124010cfa0c$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $14bc2124010cfa0c$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $14bc2124010cfa0c$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $14bc2124010cfa0c$var$getScriptFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return input.witnessUtxo.script;
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $14bc2124010cfa0c$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        return nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index].script;
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $14bc2124010cfa0c$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $14bc2124010cfa0c$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $14bc2124010cfa0c$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript);
    return $14bc2124010cfa0c$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $14bc2124010cfa0c$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $14bc2124010cfa0c$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript);
    return $14bc2124010cfa0c$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $14bc2124010cfa0c$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $jodFS.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$14bc2124010cfa0c$require$Buffer.isBuffer(lastItem) || $14bc2124010cfa0c$var$isPubkeyLike(lastItem) || $14bc2124010cfa0c$var$isSigLike(lastItem)) return;
    const sDecomp = $jodFS.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $14bc2124010cfa0c$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $14bc2124010cfa0c$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($14bc2124010cfa0c$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $jodFS.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $14bc2124010cfa0c$var$isPubkeyLike(buf) {
    return buf.length === 33 && $jodFS.isCanonicalPubKey(buf);
}
function $14bc2124010cfa0c$var$isSigLike(buf) {
    return $jodFS.isCanonicalScriptSignature(buf);
}
function $14bc2124010cfa0c$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = $14bc2124010cfa0c$var$isP2SHScript(script);
    const isP2SHP2WSH = isP2SH && redeemScript && $14bc2124010cfa0c$var$isP2WSHScript(redeemScript);
    const isP2WSH = $14bc2124010cfa0c$var$isP2WSHScript(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $14bc2124010cfa0c$var$checkRedeemScript(index, script, redeemScript, ioType);
        $14bc2124010cfa0c$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $14bc2124010cfa0c$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $14bc2124010cfa0c$var$checkWitnessScript(index, script, witnessScript, ioType);
        $14bc2124010cfa0c$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $14bc2124010cfa0c$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $14bc2124010cfa0c$var$checkInvalidP2WSH(script) {
    if ($14bc2124010cfa0c$var$isP2WPKH(script) || $14bc2124010cfa0c$var$isP2SHScript(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $14bc2124010cfa0c$var$pubkeyInScript(pubkey, script) {
    const pubkeyHash = $3yeGF.hash160(pubkey);
    const decompiled = $jodFS.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.some((element)=>{
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash);
    });
}
function $14bc2124010cfa0c$var$classifyScript(script) {
    if ($14bc2124010cfa0c$var$isP2WPKH(script)) return "witnesspubkeyhash";
    if ($14bc2124010cfa0c$var$isP2PKH(script)) return "pubkeyhash";
    if ($14bc2124010cfa0c$var$isP2MS(script)) return "multisig";
    if ($14bc2124010cfa0c$var$isP2PK(script)) return "pubkey";
    return "nonstandard";
}
function $14bc2124010cfa0c$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}

});
parcelRegister("gGBHT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c25dd16627186265$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8yaiT = parcelRequire("8yaiT");

var $eTnUG = parcelRequire("eTnUG");

var $9d715 = parcelRequire("9d715");

var $93bki = parcelRequire("93bki");
class $c25dd16627186265$var$Psbt {
    constructor(tx){
        this.inputs = [];
        this.outputs = [];
        this.globalMap = {
            unsignedTx: tx
        };
    }
    static fromBase64(data, txFromBuffer) {
        const buffer = $c25dd16627186265$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromHex(data, txFromBuffer) {
        const buffer = $c25dd16627186265$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromBuffer(buffer, txFromBuffer) {
        const results = $eTnUG.psbtFromBuffer(buffer, txFromBuffer);
        const psbt = new this(results.globalMap.unsignedTx);
        Object.assign(psbt, results);
        return psbt;
    }
    toBase64() {
        const buffer = this.toBuffer();
        return buffer.toString("base64");
    }
    toHex() {
        const buffer = this.toBuffer();
        return buffer.toString("hex");
    }
    toBuffer() {
        return $eTnUG.psbtToBuffer(this);
    }
    updateGlobal(updateData) {
        $93bki.updateGlobal(updateData, this.globalMap);
        return this;
    }
    updateInput(inputIndex, updateData) {
        const input = $93bki.checkForInput(this.inputs, inputIndex);
        $93bki.updateInput(updateData, input);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const output = $93bki.checkForOutput(this.outputs, outputIndex);
        $93bki.updateOutput(updateData, output);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        $93bki.checkHasKey(keyVal, this.globalMap.unknownKeyVals, $93bki.getEnumLength($9d715.GlobalTypes));
        if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
        this.globalMap.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        const input = $93bki.checkForInput(this.inputs, inputIndex);
        $93bki.checkHasKey(keyVal, input.unknownKeyVals, $93bki.getEnumLength($9d715.InputTypes));
        if (!input.unknownKeyVals) input.unknownKeyVals = [];
        input.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        const output = $93bki.checkForOutput(this.outputs, outputIndex);
        $93bki.checkHasKey(keyVal, output.unknownKeyVals, $93bki.getEnumLength($9d715.OutputTypes));
        if (!output.unknownKeyVals) output.unknownKeyVals = [];
        output.unknownKeyVals.push(keyVal);
        return this;
    }
    addInput(inputData) {
        this.globalMap.unsignedTx.addInput(inputData);
        this.inputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = inputData.unknownKeyVals || [];
        const inputIndex = this.inputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToInput(inputIndex, keyVal));
        $93bki.addInputAttributes(this.inputs, inputData);
        return this;
    }
    addOutput(outputData) {
        this.globalMap.unsignedTx.addOutput(outputData);
        this.outputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = outputData.unknownKeyVals || [];
        const outputIndex = this.outputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToInput(outputIndex, keyVal));
        $93bki.addOutputAttributes(this.outputs, outputData);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        const input = $93bki.checkForInput(this.inputs, inputIndex);
        $93bki.inputCheckUncleanFinalized(inputIndex, input);
        for (const key of Object.keys(input))if (![
            "witnessUtxo",
            "nonWitnessUtxo",
            "finalScriptSig",
            "finalScriptWitness",
            "unknownKeyVals"
        ].includes(key)) // @ts-ignore
        delete input[key];
        return this;
    }
    combine(...those) {
        // Combine this with those.
        // Return self for chaining.
        const result = $8yaiT.combine([
            this
        ].concat(those));
        Object.assign(this, result);
        return this;
    }
    getTransaction() {
        return this.globalMap.unsignedTx.toBuffer();
    }
}
module.exports.Psbt = $c25dd16627186265$var$Psbt;

});
parcelRegister("8yaiT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eTnUG = parcelRequire("eTnUG");
function $63997dcd1936dc7c$var$combine(psbts) {
    const self = psbts[0];
    const selfKeyVals = $eTnUG.psbtToKeyVals(self);
    const others = psbts.slice(1);
    if (others.length === 0) throw new Error("Combine: Nothing to combine");
    const selfTx = $63997dcd1936dc7c$var$getTx(self);
    if (selfTx === undefined) throw new Error("Combine: Self missing transaction");
    const selfGlobalSet = $63997dcd1936dc7c$var$getKeySet(selfKeyVals.globalKeyVals);
    const selfInputSets = selfKeyVals.inputKeyVals.map($63997dcd1936dc7c$var$getKeySet);
    const selfOutputSets = selfKeyVals.outputKeyVals.map($63997dcd1936dc7c$var$getKeySet);
    for (const other of others){
        const otherTx = $63997dcd1936dc7c$var$getTx(other);
        if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) throw new Error("Combine: One of the Psbts does not have the same transaction.");
        const otherKeyVals = $eTnUG.psbtToKeyVals(other);
        const otherGlobalSet = $63997dcd1936dc7c$var$getKeySet(otherKeyVals.globalKeyVals);
        otherGlobalSet.forEach($63997dcd1936dc7c$var$keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
        const otherInputSets = otherKeyVals.inputKeyVals.map($63997dcd1936dc7c$var$getKeySet);
        otherInputSets.forEach((inputSet, idx)=>inputSet.forEach($63997dcd1936dc7c$var$keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx])));
        const otherOutputSets = otherKeyVals.outputKeyVals.map($63997dcd1936dc7c$var$getKeySet);
        otherOutputSets.forEach((outputSet, idx)=>outputSet.forEach($63997dcd1936dc7c$var$keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx])));
    }
    return $eTnUG.psbtFromKeyVals(selfTx, {
        globalMapKeyVals: selfKeyVals.globalKeyVals,
        inputKeyVals: selfKeyVals.inputKeyVals,
        outputKeyVals: selfKeyVals.outputKeyVals
    });
}
module.exports.combine = $63997dcd1936dc7c$var$combine;
function $63997dcd1936dc7c$var$keyPusher(selfSet, selfKeyVals, otherKeyVals) {
    return (key)=>{
        if (selfSet.has(key)) return;
        const newKv = otherKeyVals.filter((kv)=>kv.key.toString("hex") === key)[0];
        selfKeyVals.push(newKv);
        selfSet.add(key);
    };
}
function $63997dcd1936dc7c$var$getTx(psbt) {
    return psbt.globalMap.unsignedTx;
}
function $63997dcd1936dc7c$var$getKeySet(keyVals) {
    const set = new Set();
    keyVals.forEach((keyVal)=>{
        const hex = keyVal.key.toString("hex");
        if (set.has(hex)) throw new Error("Combine: KeyValue Map keys should be unique");
        set.add(hex);
    });
    return set;
}

});
parcelRegister("eTnUG", function(module, exports) {
"use strict";
function $ad78c0653c67d16b$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ad78c0653c67d16b$var$__export((parcelRequire("hZfx3")));

$ad78c0653c67d16b$var$__export((parcelRequire("ePtWO")));

});
parcelRegister("hZfx3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d1842e8232afe607$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hbHfA = parcelRequire("hbHfA");

var $gjIyn = parcelRequire("gjIyn");

var $kU6Cf = parcelRequire("kU6Cf");

var $9d715 = parcelRequire("9d715");
function $d1842e8232afe607$var$psbtFromBuffer(buffer, txGetter) {
    let offset = 0;
    function varSlice() {
        const keyLen = $kU6Cf.decode(buffer, offset);
        offset += $kU6Cf.encodingLength(keyLen);
        const key = buffer.slice(offset, offset + keyLen);
        offset += keyLen;
        return key;
    }
    function readUInt32BE() {
        const num = buffer.readUInt32BE(offset);
        offset += 4;
        return num;
    }
    function readUInt8() {
        const num = buffer.readUInt8(offset);
        offset += 1;
        return num;
    }
    function getKeyValue() {
        const key = varSlice();
        const value = varSlice();
        return {
            key: key,
            value: value
        };
    }
    function checkEndOfKeyValPairs() {
        if (offset >= buffer.length) throw new Error("Format Error: Unexpected End of PSBT");
        const isEnd = buffer.readUInt8(offset) === 0;
        if (isEnd) offset++;
        return isEnd;
    }
    if (readUInt32BE() !== 0x70736274) throw new Error("Format Error: Invalid Magic Number");
    if (readUInt8() !== 0xff) throw new Error("Format Error: Magic Number must be followed by 0xff separator");
    const globalMapKeyVals = [];
    const globalKeyIndex = {};
    while(!checkEndOfKeyValPairs()){
        const keyVal = getKeyValue();
        const hexKey = keyVal.key.toString("hex");
        if (globalKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for global keymap: key " + hexKey);
        globalKeyIndex[hexKey] = 1;
        globalMapKeyVals.push(keyVal);
    }
    const unsignedTxMaps = globalMapKeyVals.filter((keyVal)=>keyVal.key[0] === $9d715.GlobalTypes.UNSIGNED_TX);
    if (unsignedTxMaps.length !== 1) throw new Error("Format Error: Only one UNSIGNED_TX allowed");
    const unsignedTx = txGetter(unsignedTxMaps[0].value);
    // Get input and output counts to loop the respective fields
    const { inputCount: inputCount, outputCount: outputCount } = unsignedTx.getInputOutputCounts();
    const inputKeyVals = [];
    const outputKeyVals = [];
    // Get input fields
    for (const index of $gjIyn.range(inputCount)){
        const inputKeyIndex = {};
        const input = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (inputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each input: input index " + index + " key " + hexKey);
            inputKeyIndex[hexKey] = 1;
            input.push(keyVal);
        }
        inputKeyVals.push(input);
    }
    for (const index of $gjIyn.range(outputCount)){
        const outputKeyIndex = {};
        const output = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (outputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each output: output index " + index + " key " + hexKey);
            outputKeyIndex[hexKey] = 1;
            output.push(keyVal);
        }
        outputKeyVals.push(output);
    }
    return $d1842e8232afe607$var$psbtFromKeyVals(unsignedTx, {
        globalMapKeyVals: globalMapKeyVals,
        inputKeyVals: inputKeyVals,
        outputKeyVals: outputKeyVals
    });
}
module.exports.psbtFromBuffer = $d1842e8232afe607$var$psbtFromBuffer;
function $d1842e8232afe607$var$checkKeyBuffer(type, keyBuf, keyNum) {
    if (!keyBuf.equals($d1842e8232afe607$require$Buffer.from([
        keyNum
    ]))) throw new Error(`Format Error: Invalid ${type} key: ${keyBuf.toString("hex")}`);
}
module.exports.checkKeyBuffer = $d1842e8232afe607$var$checkKeyBuffer;
function $d1842e8232afe607$var$psbtFromKeyVals(unsignedTx, { globalMapKeyVals: globalMapKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals }) {
    // That was easy :-)
    const globalMap = {
        unsignedTx: unsignedTx
    };
    let txCount = 0;
    for (const keyVal of globalMapKeyVals)// If a globalMap item needs pubkey, uncomment
    // const pubkey = convert.globals.checkPubkey(keyVal);
    switch(keyVal.key[0]){
        case $9d715.GlobalTypes.UNSIGNED_TX:
            $d1842e8232afe607$var$checkKeyBuffer("global", keyVal.key, $9d715.GlobalTypes.UNSIGNED_TX);
            if (txCount > 0) throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
            txCount++;
            break;
        case $9d715.GlobalTypes.GLOBAL_XPUB:
            if (globalMap.globalXpub === undefined) globalMap.globalXpub = [];
            globalMap.globalXpub.push($hbHfA.globals.globalXpub.decode(keyVal));
            break;
        default:
            // This will allow inclusion during serialization.
            if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
            globalMap.unknownKeyVals.push(keyVal);
    }
    // Get input and output counts to loop the respective fields
    const inputCount = inputKeyVals.length;
    const outputCount = outputKeyVals.length;
    const inputs = [];
    const outputs = [];
    // Get input fields
    for (const index of $gjIyn.range(inputCount)){
        const input = {};
        for (const keyVal of inputKeyVals[index]){
            $hbHfA.inputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $9d715.InputTypes.NON_WITNESS_UTXO:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.NON_WITNESS_UTXO);
                    if (input.nonWitnessUtxo !== undefined) throw new Error("Format Error: Input has multiple NON_WITNESS_UTXO");
                    input.nonWitnessUtxo = $hbHfA.inputs.nonWitnessUtxo.decode(keyVal);
                    break;
                case $9d715.InputTypes.WITNESS_UTXO:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.WITNESS_UTXO);
                    if (input.witnessUtxo !== undefined) throw new Error("Format Error: Input has multiple WITNESS_UTXO");
                    input.witnessUtxo = $hbHfA.inputs.witnessUtxo.decode(keyVal);
                    break;
                case $9d715.InputTypes.PARTIAL_SIG:
                    if (input.partialSig === undefined) input.partialSig = [];
                    input.partialSig.push($hbHfA.inputs.partialSig.decode(keyVal));
                    break;
                case $9d715.InputTypes.SIGHASH_TYPE:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.SIGHASH_TYPE);
                    if (input.sighashType !== undefined) throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
                    input.sighashType = $hbHfA.inputs.sighashType.decode(keyVal);
                    break;
                case $9d715.InputTypes.REDEEM_SCRIPT:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.REDEEM_SCRIPT);
                    if (input.redeemScript !== undefined) throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
                    input.redeemScript = $hbHfA.inputs.redeemScript.decode(keyVal);
                    break;
                case $9d715.InputTypes.WITNESS_SCRIPT:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.WITNESS_SCRIPT);
                    if (input.witnessScript !== undefined) throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
                    input.witnessScript = $hbHfA.inputs.witnessScript.decode(keyVal);
                    break;
                case $9d715.InputTypes.BIP32_DERIVATION:
                    if (input.bip32Derivation === undefined) input.bip32Derivation = [];
                    input.bip32Derivation.push($hbHfA.inputs.bip32Derivation.decode(keyVal));
                    break;
                case $9d715.InputTypes.FINAL_SCRIPTSIG:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.FINAL_SCRIPTSIG);
                    input.finalScriptSig = $hbHfA.inputs.finalScriptSig.decode(keyVal);
                    break;
                case $9d715.InputTypes.FINAL_SCRIPTWITNESS:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.FINAL_SCRIPTWITNESS);
                    input.finalScriptWitness = $hbHfA.inputs.finalScriptWitness.decode(keyVal);
                    break;
                case $9d715.InputTypes.POR_COMMITMENT:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.POR_COMMITMENT);
                    input.porCommitment = $hbHfA.inputs.porCommitment.decode(keyVal);
                    break;
                case $9d715.InputTypes.TAP_KEY_SIG:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.TAP_KEY_SIG);
                    input.tapKeySig = $hbHfA.inputs.tapKeySig.decode(keyVal);
                    break;
                case $9d715.InputTypes.TAP_SCRIPT_SIG:
                    if (input.tapScriptSig === undefined) input.tapScriptSig = [];
                    input.tapScriptSig.push($hbHfA.inputs.tapScriptSig.decode(keyVal));
                    break;
                case $9d715.InputTypes.TAP_LEAF_SCRIPT:
                    if (input.tapLeafScript === undefined) input.tapLeafScript = [];
                    input.tapLeafScript.push($hbHfA.inputs.tapLeafScript.decode(keyVal));
                    break;
                case $9d715.InputTypes.TAP_BIP32_DERIVATION:
                    if (input.tapBip32Derivation === undefined) input.tapBip32Derivation = [];
                    input.tapBip32Derivation.push($hbHfA.inputs.tapBip32Derivation.decode(keyVal));
                    break;
                case $9d715.InputTypes.TAP_INTERNAL_KEY:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.TAP_INTERNAL_KEY);
                    input.tapInternalKey = $hbHfA.inputs.tapInternalKey.decode(keyVal);
                    break;
                case $9d715.InputTypes.TAP_MERKLE_ROOT:
                    $d1842e8232afe607$var$checkKeyBuffer("input", keyVal.key, $9d715.InputTypes.TAP_MERKLE_ROOT);
                    input.tapMerkleRoot = $hbHfA.inputs.tapMerkleRoot.decode(keyVal);
                    break;
                default:
                    // This will allow inclusion during serialization.
                    if (!input.unknownKeyVals) input.unknownKeyVals = [];
                    input.unknownKeyVals.push(keyVal);
            }
        }
        inputs.push(input);
    }
    for (const index of $gjIyn.range(outputCount)){
        const output = {};
        for (const keyVal of outputKeyVals[index]){
            $hbHfA.outputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $9d715.OutputTypes.REDEEM_SCRIPT:
                    $d1842e8232afe607$var$checkKeyBuffer("output", keyVal.key, $9d715.OutputTypes.REDEEM_SCRIPT);
                    if (output.redeemScript !== undefined) throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
                    output.redeemScript = $hbHfA.outputs.redeemScript.decode(keyVal);
                    break;
                case $9d715.OutputTypes.WITNESS_SCRIPT:
                    $d1842e8232afe607$var$checkKeyBuffer("output", keyVal.key, $9d715.OutputTypes.WITNESS_SCRIPT);
                    if (output.witnessScript !== undefined) throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
                    output.witnessScript = $hbHfA.outputs.witnessScript.decode(keyVal);
                    break;
                case $9d715.OutputTypes.BIP32_DERIVATION:
                    if (output.bip32Derivation === undefined) output.bip32Derivation = [];
                    output.bip32Derivation.push($hbHfA.outputs.bip32Derivation.decode(keyVal));
                    break;
                case $9d715.OutputTypes.TAP_INTERNAL_KEY:
                    $d1842e8232afe607$var$checkKeyBuffer("output", keyVal.key, $9d715.OutputTypes.TAP_INTERNAL_KEY);
                    output.tapInternalKey = $hbHfA.outputs.tapInternalKey.decode(keyVal);
                    break;
                case $9d715.OutputTypes.TAP_TREE:
                    $d1842e8232afe607$var$checkKeyBuffer("output", keyVal.key, $9d715.OutputTypes.TAP_TREE);
                    output.tapTree = $hbHfA.outputs.tapTree.decode(keyVal);
                    break;
                case $9d715.OutputTypes.TAP_BIP32_DERIVATION:
                    if (output.tapBip32Derivation === undefined) output.tapBip32Derivation = [];
                    output.tapBip32Derivation.push($hbHfA.outputs.tapBip32Derivation.decode(keyVal));
                    break;
                default:
                    if (!output.unknownKeyVals) output.unknownKeyVals = [];
                    output.unknownKeyVals.push(keyVal);
            }
        }
        outputs.push(output);
    }
    return {
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    };
}
module.exports.psbtFromKeyVals = $d1842e8232afe607$var$psbtFromKeyVals;

});
parcelRegister("hbHfA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");

var $6z1vA = parcelRequire("6z1vA");

var $ibNMP = parcelRequire("ibNMP");

var $8Qjtw = parcelRequire("8Qjtw");

var $buQ3j = parcelRequire("buQ3j");

var $gW0OG = parcelRequire("gW0OG");

var $hDV0C = parcelRequire("hDV0C");

var $9ZvoT = parcelRequire("9ZvoT");

var $hOvAt = parcelRequire("hOvAt");

var $c9GeX = parcelRequire("c9GeX");

var $3ma56 = parcelRequire("3ma56");

var $gHwDc = parcelRequire("gHwDc");

var $gIpva = parcelRequire("gIpva");

var $iTBiM = parcelRequire("iTBiM");

var $6XoTa = parcelRequire("6XoTa");

var $iaP7I = parcelRequire("iaP7I");

var $e52a6 = parcelRequire("e52a6");

var $aoVda = parcelRequire("aoVda");

var $jroxy = parcelRequire("jroxy");

var $9WEJS = parcelRequire("9WEJS");

var $eWanr = parcelRequire("eWanr");
const $c8350363aec65b07$var$globals = {
    unsignedTx: $ibNMP,
    globalXpub: $6z1vA,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: $e52a6.makeChecker([])
};
module.exports.globals = $c8350363aec65b07$var$globals;
const $c8350363aec65b07$var$inputs = {
    nonWitnessUtxo: $gW0OG,
    partialSig: $hDV0C,
    sighashType: $hOvAt,
    finalScriptSig: $8Qjtw,
    finalScriptWitness: $buQ3j,
    porCommitment: $9ZvoT,
    witnessUtxo: $iTBiM,
    bip32Derivation: $iaP7I.makeConverter($9d715.InputTypes.BIP32_DERIVATION),
    redeemScript: $aoVda.makeConverter($9d715.InputTypes.REDEEM_SCRIPT),
    witnessScript: $eWanr.makeConverter($9d715.InputTypes.WITNESS_SCRIPT),
    checkPubkey: $e52a6.makeChecker([
        $9d715.InputTypes.PARTIAL_SIG,
        $9d715.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: $c9GeX,
    tapScriptSig: $gIpva,
    tapLeafScript: $3ma56,
    tapBip32Derivation: $jroxy.makeConverter($9d715.InputTypes.TAP_BIP32_DERIVATION),
    tapInternalKey: $9WEJS.makeConverter($9d715.InputTypes.TAP_INTERNAL_KEY),
    tapMerkleRoot: $gHwDc
};
module.exports.inputs = $c8350363aec65b07$var$inputs;
const $c8350363aec65b07$var$outputs = {
    bip32Derivation: $iaP7I.makeConverter($9d715.OutputTypes.BIP32_DERIVATION),
    redeemScript: $aoVda.makeConverter($9d715.OutputTypes.REDEEM_SCRIPT),
    witnessScript: $eWanr.makeConverter($9d715.OutputTypes.WITNESS_SCRIPT),
    checkPubkey: $e52a6.makeChecker([
        $9d715.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: $jroxy.makeConverter($9d715.OutputTypes.TAP_BIP32_DERIVATION),
    tapTree: $6XoTa,
    tapInternalKey: $9WEJS.makeConverter($9d715.OutputTypes.TAP_INTERNAL_KEY)
};
module.exports.outputs = $c8350363aec65b07$var$outputs;

});
parcelRegister("9d715", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6b4ac54e66d903bf$var$GlobalTypes;
(function(GlobalTypes) {
    GlobalTypes[GlobalTypes["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    GlobalTypes[GlobalTypes["GLOBAL_XPUB"] = 1] = "GLOBAL_XPUB";
})($6b4ac54e66d903bf$var$GlobalTypes = module.exports.GlobalTypes || (module.exports.GlobalTypes = {}));
module.exports.GLOBAL_TYPE_NAMES = [
    "unsignedTx",
    "globalXpub"
];
var $6b4ac54e66d903bf$var$InputTypes;
(function(InputTypes) {
    InputTypes[InputTypes["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    InputTypes[InputTypes["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    InputTypes[InputTypes["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    InputTypes[InputTypes["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    InputTypes[InputTypes["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    InputTypes[InputTypes["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    InputTypes[InputTypes["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    InputTypes[InputTypes["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    InputTypes[InputTypes["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    InputTypes[InputTypes["POR_COMMITMENT"] = 9] = "POR_COMMITMENT";
    InputTypes[InputTypes["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    InputTypes[InputTypes["TAP_SCRIPT_SIG"] = 20] = "TAP_SCRIPT_SIG";
    InputTypes[InputTypes["TAP_LEAF_SCRIPT"] = 21] = "TAP_LEAF_SCRIPT";
    InputTypes[InputTypes["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
    InputTypes[InputTypes["TAP_INTERNAL_KEY"] = 23] = "TAP_INTERNAL_KEY";
    InputTypes[InputTypes["TAP_MERKLE_ROOT"] = 24] = "TAP_MERKLE_ROOT";
})($6b4ac54e66d903bf$var$InputTypes = module.exports.InputTypes || (module.exports.InputTypes = {}));
module.exports.INPUT_TYPE_NAMES = [
    "nonWitnessUtxo",
    "witnessUtxo",
    "partialSig",
    "sighashType",
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "finalScriptSig",
    "finalScriptWitness",
    "porCommitment",
    "tapKeySig",
    "tapScriptSig",
    "tapLeafScript",
    "tapBip32Derivation",
    "tapInternalKey",
    "tapMerkleRoot"
];
var $6b4ac54e66d903bf$var$OutputTypes;
(function(OutputTypes) {
    OutputTypes[OutputTypes["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    OutputTypes[OutputTypes["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    OutputTypes[OutputTypes["BIP32_DERIVATION"] = 2] = "BIP32_DERIVATION";
    OutputTypes[OutputTypes["TAP_INTERNAL_KEY"] = 5] = "TAP_INTERNAL_KEY";
    OutputTypes[OutputTypes["TAP_TREE"] = 6] = "TAP_TREE";
    OutputTypes[OutputTypes["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($6b4ac54e66d903bf$var$OutputTypes = module.exports.OutputTypes || (module.exports.OutputTypes = {}));
module.exports.OUTPUT_TYPE_NAMES = [
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "tapInternalKey",
    "tapTree",
    "tapBip32Derivation"
];

});

parcelRegister("6z1vA", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4c772e83935bdf25$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
const $4c772e83935bdf25$var$range = (n)=>[
        ...Array(n).keys()
    ];
function $4c772e83935bdf25$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.GlobalTypes.GLOBAL_XPUB) throw new Error("Decode Error: could not decode globalXpub with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 79 || ![
        2,
        3
    ].includes(keyVal.key[46])) throw new Error("Decode Error: globalXpub has invalid extended pubkey in key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Global GLOBAL_XPUB value length should be multiple of 4");
    const extendedPubkey = keyVal.key.slice(1);
    const data = {
        masterFingerprint: keyVal.value.slice(0, 4),
        extendedPubkey: extendedPubkey,
        path: "m"
    };
    for (const i of $4c772e83935bdf25$var$range(keyVal.value.length / 4 - 1)){
        const val = keyVal.value.readUInt32LE(i * 4 + 4);
        const isHard = !!(val & 0x80000000);
        const idx = val & 0x7fffffff;
        data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
    }
    return data;
}
module.exports.decode = $4c772e83935bdf25$var$decode;
function $4c772e83935bdf25$var$encode(data) {
    const head = $4c772e83935bdf25$require$Buffer.from([
        $9d715.GlobalTypes.GLOBAL_XPUB
    ]);
    const key = $4c772e83935bdf25$require$Buffer.concat([
        head,
        data.extendedPubkey
    ]);
    const splitPath = data.path.split("/");
    const value = $4c772e83935bdf25$require$Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    let offset = 4;
    splitPath.slice(1).forEach((level)=>{
        const isHard = level.slice(-1) === "'";
        let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
        if (isHard) num += 0x80000000;
        value.writeUInt32LE(num, offset);
        offset += 4;
    });
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $4c772e83935bdf25$var$encode;
module.exports.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
function $4c772e83935bdf25$var$check(data) {
    const epk = data.extendedPubkey;
    const mfp = data.masterFingerprint;
    const p = data.path;
    return $4c772e83935bdf25$require$Buffer.isBuffer(epk) && epk.length === 78 && [
        2,
        3
    ].indexOf(epk[45]) > -1 && $4c772e83935bdf25$require$Buffer.isBuffer(mfp) && mfp.length === 4 && typeof p === "string" && !!p.match(/^m(\/\d+'?)*$/);
}
module.exports.check = $4c772e83935bdf25$var$check;
function $4c772e83935bdf25$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.extendedPubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.extendedPubkey.equals(item.extendedPubkey)).length === 0;
}
module.exports.canAddToArray = $4c772e83935bdf25$var$canAddToArray;

});

parcelRegister("ibNMP", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d3dfdfa4e0c70de2$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $d3dfdfa4e0c70de2$var$encode(data) {
    return {
        key: $d3dfdfa4e0c70de2$require$Buffer.from([
            $9d715.GlobalTypes.UNSIGNED_TX
        ]),
        value: data.toBuffer()
    };
}
module.exports.encode = $d3dfdfa4e0c70de2$var$encode;

});

parcelRegister("8Qjtw", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $670249712e60587c$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $670249712e60587c$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.FINAL_SCRIPTSIG) throw new Error("Decode Error: could not decode finalScriptSig with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $670249712e60587c$var$decode;
function $670249712e60587c$var$encode(data) {
    const key = $670249712e60587c$require$Buffer.from([
        $9d715.InputTypes.FINAL_SCRIPTSIG
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $670249712e60587c$var$encode;
module.exports.expected = "Buffer";
function $670249712e60587c$var$check(data) {
    return $670249712e60587c$require$Buffer.isBuffer(data);
}
module.exports.check = $670249712e60587c$var$check;
function $670249712e60587c$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptSig === undefined;
}
module.exports.canAdd = $670249712e60587c$var$canAdd;

});

parcelRegister("buQ3j", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $85eadf9aa92ebd5b$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $85eadf9aa92ebd5b$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.FINAL_SCRIPTWITNESS) throw new Error("Decode Error: could not decode finalScriptWitness with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $85eadf9aa92ebd5b$var$decode;
function $85eadf9aa92ebd5b$var$encode(data) {
    const key = $85eadf9aa92ebd5b$require$Buffer.from([
        $9d715.InputTypes.FINAL_SCRIPTWITNESS
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $85eadf9aa92ebd5b$var$encode;
module.exports.expected = "Buffer";
function $85eadf9aa92ebd5b$var$check(data) {
    return $85eadf9aa92ebd5b$require$Buffer.isBuffer(data);
}
module.exports.check = $85eadf9aa92ebd5b$var$check;
function $85eadf9aa92ebd5b$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptWitness === undefined;
}
module.exports.canAdd = $85eadf9aa92ebd5b$var$canAdd;

});

parcelRegister("gW0OG", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c542b243ea330736$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $c542b243ea330736$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.NON_WITNESS_UTXO) throw new Error("Decode Error: could not decode nonWitnessUtxo with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $c542b243ea330736$var$decode;
function $c542b243ea330736$var$encode(data) {
    return {
        key: $c542b243ea330736$require$Buffer.from([
            $9d715.InputTypes.NON_WITNESS_UTXO
        ]),
        value: data
    };
}
module.exports.encode = $c542b243ea330736$var$encode;
module.exports.expected = "Buffer";
function $c542b243ea330736$var$check(data) {
    return $c542b243ea330736$require$Buffer.isBuffer(data);
}
module.exports.check = $c542b243ea330736$var$check;
function $c542b243ea330736$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.nonWitnessUtxo === undefined;
}
module.exports.canAdd = $c542b243ea330736$var$canAdd;

});

parcelRegister("hDV0C", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $cd824cff119077b4$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $cd824cff119077b4$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.PARTIAL_SIG) throw new Error("Decode Error: could not decode partialSig with key 0x" + keyVal.key.toString("hex"));
    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![
        2,
        3,
        4
    ].includes(keyVal.key[1])) throw new Error("Decode Error: partialSig has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1);
    return {
        pubkey: pubkey,
        signature: keyVal.value
    };
}
module.exports.decode = $cd824cff119077b4$var$decode;
function $cd824cff119077b4$var$encode(pSig) {
    const head = $cd824cff119077b4$require$Buffer.from([
        $9d715.InputTypes.PARTIAL_SIG
    ]);
    return {
        key: $cd824cff119077b4$require$Buffer.concat([
            head,
            pSig.pubkey
        ]),
        value: pSig.signature
    };
}
module.exports.encode = $cd824cff119077b4$var$encode;
module.exports.expected = "{ pubkey: Buffer; signature: Buffer; }";
function $cd824cff119077b4$var$check(data) {
    return $cd824cff119077b4$require$Buffer.isBuffer(data.pubkey) && $cd824cff119077b4$require$Buffer.isBuffer(data.signature) && [
        33,
        65
    ].includes(data.pubkey.length) && [
        2,
        3,
        4
    ].includes(data.pubkey[0]) && $cd824cff119077b4$var$isDerSigWithSighash(data.signature);
}
module.exports.check = $cd824cff119077b4$var$check;
function $cd824cff119077b4$var$isDerSigWithSighash(buf) {
    if (!$cd824cff119077b4$require$Buffer.isBuffer(buf) || buf.length < 9) return false;
    if (buf[0] !== 0x30) return false;
    if (buf.length !== buf[1] + 3) return false;
    if (buf[2] !== 0x02) return false;
    const rLen = buf[3];
    if (rLen > 33 || rLen < 1) return false;
    if (buf[3 + rLen + 1] !== 0x02) return false;
    const sLen = buf[3 + rLen + 2];
    if (sLen > 33 || sLen < 1) return false;
    if (buf.length !== 3 + rLen + 2 + sLen + 2) return false;
    return true;
}
function $cd824cff119077b4$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
}
module.exports.canAddToArray = $cd824cff119077b4$var$canAddToArray;

});

parcelRegister("9ZvoT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $74622b0d5fe0db2f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $74622b0d5fe0db2f$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.POR_COMMITMENT) throw new Error("Decode Error: could not decode porCommitment with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.toString("utf8");
}
module.exports.decode = $74622b0d5fe0db2f$var$decode;
function $74622b0d5fe0db2f$var$encode(data) {
    const key = $74622b0d5fe0db2f$require$Buffer.from([
        $9d715.InputTypes.POR_COMMITMENT
    ]);
    return {
        key: key,
        value: $74622b0d5fe0db2f$require$Buffer.from(data, "utf8")
    };
}
module.exports.encode = $74622b0d5fe0db2f$var$encode;
module.exports.expected = "string";
function $74622b0d5fe0db2f$var$check(data) {
    return typeof data === "string";
}
module.exports.check = $74622b0d5fe0db2f$var$check;
function $74622b0d5fe0db2f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.porCommitment === undefined;
}
module.exports.canAdd = $74622b0d5fe0db2f$var$canAdd;

});

parcelRegister("hOvAt", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $cf7f9bbd78b62e4e$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $cf7f9bbd78b62e4e$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.SIGHASH_TYPE) throw new Error("Decode Error: could not decode sighashType with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.readUInt32LE(0);
}
module.exports.decode = $cf7f9bbd78b62e4e$var$decode;
function $cf7f9bbd78b62e4e$var$encode(data) {
    const key = $cf7f9bbd78b62e4e$require$Buffer.from([
        $9d715.InputTypes.SIGHASH_TYPE
    ]);
    const value = $cf7f9bbd78b62e4e$require$Buffer.allocUnsafe(4);
    value.writeUInt32LE(data, 0);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $cf7f9bbd78b62e4e$var$encode;
module.exports.expected = "number";
function $cf7f9bbd78b62e4e$var$check(data) {
    return typeof data === "number";
}
module.exports.check = $cf7f9bbd78b62e4e$var$check;
function $cf7f9bbd78b62e4e$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.sighashType === undefined;
}
module.exports.canAdd = $cf7f9bbd78b62e4e$var$canAdd;

});

parcelRegister("c9GeX", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8d971751bad3733f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $8d971751bad3733f$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.TAP_KEY_SIG || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapKeySig with key 0x" + keyVal.key.toString("hex"));
    if (!$8d971751bad3733f$var$check(keyVal.value)) throw new Error("Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature");
    return keyVal.value;
}
module.exports.decode = $8d971751bad3733f$var$decode;
function $8d971751bad3733f$var$encode(value) {
    const key = $8d971751bad3733f$require$Buffer.from([
        $9d715.InputTypes.TAP_KEY_SIG
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $8d971751bad3733f$var$encode;
module.exports.expected = "Buffer";
function $8d971751bad3733f$var$check(data) {
    return $8d971751bad3733f$require$Buffer.isBuffer(data) && (data.length === 64 || data.length === 65);
}
module.exports.check = $8d971751bad3733f$var$check;
function $8d971751bad3733f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapKeySig === undefined;
}
module.exports.canAdd = $8d971751bad3733f$var$canAdd;

});

parcelRegister("3ma56", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $271b3f1e25eb0814$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $271b3f1e25eb0814$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.TAP_LEAF_SCRIPT) throw new Error("Decode Error: could not decode tapLeafScript with key 0x" + keyVal.key.toString("hex"));
    if ((keyVal.key.length - 2) % 32 !== 0) throw new Error("Decode Error: tapLeafScript has invalid control block in key 0x" + keyVal.key.toString("hex"));
    const leafVersion = keyVal.value[keyVal.value.length - 1];
    if ((keyVal.key[1] & 0xfe) !== leafVersion) throw new Error("Decode Error: tapLeafScript bad leaf version in key 0x" + keyVal.key.toString("hex"));
    const script = keyVal.value.slice(0, -1);
    const controlBlock = keyVal.key.slice(1);
    return {
        controlBlock: controlBlock,
        script: script,
        leafVersion: leafVersion
    };
}
module.exports.decode = $271b3f1e25eb0814$var$decode;
function $271b3f1e25eb0814$var$encode(tScript) {
    const head = $271b3f1e25eb0814$require$Buffer.from([
        $9d715.InputTypes.TAP_LEAF_SCRIPT
    ]);
    const verBuf = $271b3f1e25eb0814$require$Buffer.from([
        tScript.leafVersion
    ]);
    return {
        key: $271b3f1e25eb0814$require$Buffer.concat([
            head,
            tScript.controlBlock
        ]),
        value: $271b3f1e25eb0814$require$Buffer.concat([
            tScript.script,
            verBuf
        ])
    };
}
module.exports.encode = $271b3f1e25eb0814$var$encode;
module.exports.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
function $271b3f1e25eb0814$var$check(data) {
    return $271b3f1e25eb0814$require$Buffer.isBuffer(data.controlBlock) && (data.controlBlock.length - 1) % 32 === 0 && (data.controlBlock[0] & 0xfe) === data.leafVersion && $271b3f1e25eb0814$require$Buffer.isBuffer(data.script);
}
module.exports.check = $271b3f1e25eb0814$var$check;
function $271b3f1e25eb0814$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.controlBlock.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.controlBlock.equals(item.controlBlock)).length === 0;
}
module.exports.canAddToArray = $271b3f1e25eb0814$var$canAddToArray;

});

parcelRegister("gHwDc", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c289f95dedc3070f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $c289f95dedc3070f$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.TAP_MERKLE_ROOT || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapMerkleRoot with key 0x" + keyVal.key.toString("hex"));
    if (!$c289f95dedc3070f$var$check(keyVal.value)) throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
    return keyVal.value;
}
module.exports.decode = $c289f95dedc3070f$var$decode;
function $c289f95dedc3070f$var$encode(value) {
    const key = $c289f95dedc3070f$require$Buffer.from([
        $9d715.InputTypes.TAP_MERKLE_ROOT
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $c289f95dedc3070f$var$encode;
module.exports.expected = "Buffer";
function $c289f95dedc3070f$var$check(data) {
    return $c289f95dedc3070f$require$Buffer.isBuffer(data) && data.length === 32;
}
module.exports.check = $c289f95dedc3070f$var$check;
function $c289f95dedc3070f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapMerkleRoot === undefined;
}
module.exports.canAdd = $c289f95dedc3070f$var$canAdd;

});

parcelRegister("gIpva", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c2b48987b2237780$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");
function $c2b48987b2237780$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.TAP_SCRIPT_SIG) throw new Error("Decode Error: could not decode tapScriptSig with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length !== 64 && keyVal.value.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid signature in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1, 33);
    const leafHash = keyVal.key.slice(33);
    return {
        pubkey: pubkey,
        leafHash: leafHash,
        signature: keyVal.value
    };
}
module.exports.decode = $c2b48987b2237780$var$decode;
function $c2b48987b2237780$var$encode(tSig) {
    const head = $c2b48987b2237780$require$Buffer.from([
        $9d715.InputTypes.TAP_SCRIPT_SIG
    ]);
    return {
        key: $c2b48987b2237780$require$Buffer.concat([
            head,
            tSig.pubkey,
            tSig.leafHash
        ]),
        value: tSig.signature
    };
}
module.exports.encode = $c2b48987b2237780$var$encode;
module.exports.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
function $c2b48987b2237780$var$check(data) {
    return $c2b48987b2237780$require$Buffer.isBuffer(data.pubkey) && $c2b48987b2237780$require$Buffer.isBuffer(data.leafHash) && $c2b48987b2237780$require$Buffer.isBuffer(data.signature) && data.pubkey.length === 32 && data.leafHash.length === 32 && (data.signature.length === 64 || data.signature.length === 65);
}
module.exports.check = $c2b48987b2237780$var$check;
function $c2b48987b2237780$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex") + item.leafHash.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey) && v.leafHash.equals(item.leafHash)).length === 0;
}
module.exports.canAddToArray = $c2b48987b2237780$var$canAddToArray;

});

parcelRegister("iTBiM", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $dc1a4c73b4a5e1ed$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");

var $gjIyn = parcelRequire("gjIyn");

var $kU6Cf = parcelRequire("kU6Cf");
function $dc1a4c73b4a5e1ed$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.InputTypes.WITNESS_UTXO) throw new Error("Decode Error: could not decode witnessUtxo with key 0x" + keyVal.key.toString("hex"));
    const value = $gjIyn.readUInt64LE(keyVal.value, 0);
    let _offset = 8;
    const scriptLen = $kU6Cf.decode(keyVal.value, _offset);
    _offset += $kU6Cf.encodingLength(scriptLen);
    const script = keyVal.value.slice(_offset);
    if (script.length !== scriptLen) throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
    return {
        script: script,
        value: value
    };
}
module.exports.decode = $dc1a4c73b4a5e1ed$var$decode;
function $dc1a4c73b4a5e1ed$var$encode(data) {
    const { script: script, value: value } = data;
    const varintLen = $kU6Cf.encodingLength(script.length);
    const result = $dc1a4c73b4a5e1ed$require$Buffer.allocUnsafe(8 + varintLen + script.length);
    $gjIyn.writeUInt64LE(result, value, 0);
    $kU6Cf.encode(script.length, result, 8);
    script.copy(result, 8 + varintLen);
    return {
        key: $dc1a4c73b4a5e1ed$require$Buffer.from([
            $9d715.InputTypes.WITNESS_UTXO
        ]),
        value: result
    };
}
module.exports.encode = $dc1a4c73b4a5e1ed$var$encode;
module.exports.expected = "{ script: Buffer; value: number; }";
function $dc1a4c73b4a5e1ed$var$check(data) {
    return $dc1a4c73b4a5e1ed$require$Buffer.isBuffer(data.script) && typeof data.value === "number";
}
module.exports.check = $dc1a4c73b4a5e1ed$var$check;
function $dc1a4c73b4a5e1ed$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.witnessUtxo === undefined;
}
module.exports.canAdd = $dc1a4c73b4a5e1ed$var$canAdd;

});
parcelRegister("gjIyn", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $be10fb1431437c93$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kU6Cf = parcelRequire("kU6Cf");
module.exports.range = (n)=>[
        ...Array(n).keys()
    ];
function $be10fb1431437c93$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $be10fb1431437c93$var$reverseBuffer;
function $be10fb1431437c93$var$keyValsToBuffer(keyVals) {
    const buffers = keyVals.map($be10fb1431437c93$var$keyValToBuffer);
    buffers.push($be10fb1431437c93$require$Buffer.from([
        0
    ]));
    return $be10fb1431437c93$require$Buffer.concat(buffers);
}
module.exports.keyValsToBuffer = $be10fb1431437c93$var$keyValsToBuffer;
function $be10fb1431437c93$var$keyValToBuffer(keyVal) {
    const keyLen = keyVal.key.length;
    const valLen = keyVal.value.length;
    const keyVarIntLen = $kU6Cf.encodingLength(keyLen);
    const valVarIntLen = $kU6Cf.encodingLength(valLen);
    const buffer = $be10fb1431437c93$require$Buffer.allocUnsafe(keyVarIntLen + keyLen + valVarIntLen + valLen);
    $kU6Cf.encode(keyLen, buffer, 0);
    keyVal.key.copy(buffer, keyVarIntLen);
    $kU6Cf.encode(valLen, buffer, keyVarIntLen + keyLen);
    keyVal.value.copy(buffer, keyVarIntLen + keyLen + valVarIntLen);
    return buffer;
}
module.exports.keyValToBuffer = $be10fb1431437c93$var$keyValToBuffer;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $be10fb1431437c93$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $be10fb1431437c93$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $be10fb1431437c93$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $be10fb1431437c93$var$readUInt64LE;
function $be10fb1431437c93$var$writeUInt64LE(buffer, value, offset) {
    $be10fb1431437c93$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $be10fb1431437c93$var$writeUInt64LE;

});
parcelRegister("kU6Cf", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f37e2b6084a8f5aa$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Number.MAX_SAFE_INTEGER
const $f37e2b6084a8f5aa$var$MAX_SAFE_INTEGER = 9007199254740991;
function $f37e2b6084a8f5aa$var$checkUInt53(n) {
    if (n < 0 || n > $f37e2b6084a8f5aa$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $f37e2b6084a8f5aa$var$encode(_number, buffer, offset) {
    $f37e2b6084a8f5aa$var$checkUInt53(_number);
    if (!buffer) buffer = $f37e2b6084a8f5aa$require$Buffer.allocUnsafe($f37e2b6084a8f5aa$var$encodingLength(_number));
    if (!$f37e2b6084a8f5aa$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (_number < 0xfd) {
        buffer.writeUInt8(_number, offset);
        Object.assign($f37e2b6084a8f5aa$var$encode, {
            bytes: 1
        });
    // 16 bit
    } else if (_number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(_number, offset + 1);
        Object.assign($f37e2b6084a8f5aa$var$encode, {
            bytes: 3
        });
    // 32 bit
    } else if (_number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(_number, offset + 1);
        Object.assign($f37e2b6084a8f5aa$var$encode, {
            bytes: 5
        });
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(_number >>> 0, offset + 1);
        buffer.writeUInt32LE(_number / 0x100000000 | 0, offset + 5);
        Object.assign($f37e2b6084a8f5aa$var$encode, {
            bytes: 9
        });
    }
    return buffer;
}
module.exports.encode = $f37e2b6084a8f5aa$var$encode;
function $f37e2b6084a8f5aa$var$decode(buffer, offset) {
    if (!$f37e2b6084a8f5aa$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    const first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        Object.assign($f37e2b6084a8f5aa$var$decode, {
            bytes: 1
        });
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        Object.assign($f37e2b6084a8f5aa$var$decode, {
            bytes: 3
        });
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        Object.assign($f37e2b6084a8f5aa$var$decode, {
            bytes: 5
        });
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        Object.assign($f37e2b6084a8f5aa$var$decode, {
            bytes: 9
        });
        const lo = buffer.readUInt32LE(offset + 1);
        const hi = buffer.readUInt32LE(offset + 5);
        const _number = hi * 0x0100000000 + lo;
        $f37e2b6084a8f5aa$var$checkUInt53(_number);
        return _number;
    }
}
module.exports.decode = $f37e2b6084a8f5aa$var$decode;
function $f37e2b6084a8f5aa$var$encodingLength(_number) {
    $f37e2b6084a8f5aa$var$checkUInt53(_number);
    return _number < 0xfd ? 1 : _number <= 0xffff ? 3 : _number <= 0xffffffff ? 5 : 9;
}
module.exports.encodingLength = $f37e2b6084a8f5aa$var$encodingLength;

});



parcelRegister("6XoTa", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $510b8f2d76f682b0$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9d715 = parcelRequire("9d715");

var $kU6Cf = parcelRequire("kU6Cf");
function $510b8f2d76f682b0$var$decode(keyVal) {
    if (keyVal.key[0] !== $9d715.OutputTypes.TAP_TREE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapTree with key 0x" + keyVal.key.toString("hex"));
    let _offset = 0;
    const data = [];
    while(_offset < keyVal.value.length){
        const depth = keyVal.value[_offset++];
        const leafVersion = keyVal.value[_offset++];
        const scriptLen = $kU6Cf.decode(keyVal.value, _offset);
        _offset += $kU6Cf.encodingLength(scriptLen);
        data.push({
            depth: depth,
            leafVersion: leafVersion,
            script: keyVal.value.slice(_offset, _offset + scriptLen)
        });
        _offset += scriptLen;
    }
    return {
        leaves: data
    };
}
module.exports.decode = $510b8f2d76f682b0$var$decode;
function $510b8f2d76f682b0$var$encode(tree) {
    const key = $510b8f2d76f682b0$require$Buffer.from([
        $9d715.OutputTypes.TAP_TREE
    ]);
    const bufs = [].concat(...tree.leaves.map((tapLeaf)=>[
            $510b8f2d76f682b0$require$Buffer.of(tapLeaf.depth, tapLeaf.leafVersion),
            $kU6Cf.encode(tapLeaf.script.length),
            tapLeaf.script
        ]));
    return {
        key: key,
        value: $510b8f2d76f682b0$require$Buffer.concat(bufs)
    };
}
module.exports.encode = $510b8f2d76f682b0$var$encode;
module.exports.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
function $510b8f2d76f682b0$var$check(data) {
    return Array.isArray(data.leaves) && data.leaves.every((tapLeaf)=>tapLeaf.depth >= 0 && tapLeaf.depth <= 128 && (tapLeaf.leafVersion & 0xfe) === tapLeaf.leafVersion && $510b8f2d76f682b0$require$Buffer.isBuffer(tapLeaf.script));
}
module.exports.check = $510b8f2d76f682b0$var$check;
function $510b8f2d76f682b0$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapTree === undefined;
}
module.exports.canAdd = $510b8f2d76f682b0$var$canAdd;

});

parcelRegister("iaP7I", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d3b0d137b0fe57be$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $d3b0d137b0fe57be$var$range = (n)=>[
        ...Array(n).keys()
    ];
const $d3b0d137b0fe57be$var$isValidDERKey = (pubkey)=>pubkey.length === 33 && [
        2,
        3
    ].includes(pubkey[0]) || pubkey.length === 65 && 4 === pubkey[0];
function $d3b0d137b0fe57be$var$makeConverter(TYPE_BYTE, isValidPubkey = $d3b0d137b0fe57be$var$isValidDERKey) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode bip32Derivation with key 0x" + keyVal.key.toString("hex"));
        const pubkey = keyVal.key.slice(1);
        if (!isValidPubkey(pubkey)) throw new Error("Decode Error: bip32Derivation has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Input BIP32_DERIVATION value length should be multiple of 4");
        const data = {
            masterFingerprint: keyVal.value.slice(0, 4),
            pubkey: pubkey,
            path: "m"
        };
        for (const i of $d3b0d137b0fe57be$var$range(keyVal.value.length / 4 - 1)){
            const val = keyVal.value.readUInt32LE(i * 4 + 4);
            const isHard = !!(val & 0x80000000);
            const idx = val & 0x7fffffff;
            data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
        }
        return data;
    }
    function encode(data) {
        const head = $d3b0d137b0fe57be$require$Buffer.from([
            TYPE_BYTE
        ]);
        const key = $d3b0d137b0fe57be$require$Buffer.concat([
            head,
            data.pubkey
        ]);
        const splitPath = data.path.split("/");
        const value = $d3b0d137b0fe57be$require$Buffer.allocUnsafe(splitPath.length * 4);
        data.masterFingerprint.copy(value, 0);
        let offset = 4;
        splitPath.slice(1).forEach((level)=>{
            const isHard = level.slice(-1) === "'";
            let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
            if (isHard) num += 0x80000000;
            value.writeUInt32LE(num, offset);
            offset += 4;
        });
        return {
            key: key,
            value: value
        };
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
    function check(data) {
        return $d3b0d137b0fe57be$require$Buffer.isBuffer(data.pubkey) && $d3b0d137b0fe57be$require$Buffer.isBuffer(data.masterFingerprint) && typeof data.path === "string" && isValidPubkey(data.pubkey) && data.masterFingerprint.length === 4;
    }
    function canAddToArray(array, item, dupeSet) {
        const dupeString = item.pubkey.toString("hex");
        if (dupeSet.has(dupeString)) return false;
        dupeSet.add(dupeString);
        return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: canAddToArray
    };
}
module.exports.makeConverter = $d3b0d137b0fe57be$var$makeConverter;

});

parcelRegister("e52a6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $a403359fb27a74c6$var$makeChecker(pubkeyTypes) {
    return checkPubkey;
    function checkPubkey(keyVal) {
        let pubkey;
        if (pubkeyTypes.includes(keyVal.key[0])) {
            pubkey = keyVal.key.slice(1);
            if (!(pubkey.length === 33 || pubkey.length === 65) || ![
                2,
                3,
                4
            ].includes(pubkey[0])) throw new Error("Format Error: invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        }
        return pubkey;
    }
}
module.exports.makeChecker = $a403359fb27a74c6$var$makeChecker;

});

parcelRegister("aoVda", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $01f4443aecf16adb$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $01f4443aecf16adb$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode redeemScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $01f4443aecf16adb$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $01f4443aecf16adb$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.redeemScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $01f4443aecf16adb$var$makeConverter;

});

parcelRegister("jroxy", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e2739318bc824ad0$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kU6Cf = parcelRequire("kU6Cf");

var $iaP7I = parcelRequire("iaP7I");
const $e2739318bc824ad0$var$isValidBIP340Key = (pubkey)=>pubkey.length === 32;
function $e2739318bc824ad0$var$makeConverter(TYPE_BYTE) {
    const parent = $iaP7I.makeConverter(TYPE_BYTE, $e2739318bc824ad0$var$isValidBIP340Key);
    function decode(keyVal) {
        const nHashes = $kU6Cf.decode(keyVal.value);
        const nHashesLen = $kU6Cf.encodingLength(nHashes);
        const base = parent.decode({
            key: keyVal.key,
            value: keyVal.value.slice(nHashesLen + nHashes * 32)
        });
        const leafHashes = new Array(nHashes);
        for(let i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32)leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
        return Object.assign({}, base, {
            leafHashes: leafHashes
        });
    }
    function encode(data) {
        const base = parent.encode(data);
        const nHashesLen = $kU6Cf.encodingLength(data.leafHashes.length);
        const nHashesBuf = $e2739318bc824ad0$require$Buffer.allocUnsafe(nHashesLen);
        $kU6Cf.encode(data.leafHashes.length, nHashesBuf);
        const value = $e2739318bc824ad0$require$Buffer.concat([
            nHashesBuf,
            ...data.leafHashes,
            base.value
        ]);
        return Object.assign({}, base, {
            value: value
        });
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function check(data) {
        return Array.isArray(data.leafHashes) && data.leafHashes.every((leafHash)=>$e2739318bc824ad0$require$Buffer.isBuffer(leafHash) && leafHash.length === 32) && parent.check(data);
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: parent.canAddToArray
    };
}
module.exports.makeConverter = $e2739318bc824ad0$var$makeConverter;

});

parcelRegister("9WEJS", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $73d921c1e0e0ba27$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $73d921c1e0e0ba27$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapInternalKey with key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length !== 32) throw new Error("Decode Error: tapInternalKey not a 32-byte x-only pubkey");
        return keyVal.value;
    }
    function encode(value) {
        const key = $73d921c1e0e0ba27$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: value
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $73d921c1e0e0ba27$require$Buffer.isBuffer(data) && data.length === 32;
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.tapInternalKey === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $73d921c1e0e0ba27$var$makeConverter;

});

parcelRegister("eWanr", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $adfe88295f8eb65a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $adfe88295f8eb65a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode witnessScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $adfe88295f8eb65a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $adfe88295f8eb65a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.witnessScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $adfe88295f8eb65a$var$makeConverter;

});



parcelRegister("ePtWO", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $acbd0f0f6cb13a7f$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hbHfA = parcelRequire("hbHfA");

var $gjIyn = parcelRequire("gjIyn");
function $acbd0f0f6cb13a7f$var$psbtToBuffer({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    const { globalKeyVals: globalKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals } = $acbd0f0f6cb13a7f$var$psbtToKeyVals({
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    });
    const globalBuffer = $gjIyn.keyValsToBuffer(globalKeyVals);
    const keyValsOrEmptyToBuffer = (keyVals)=>keyVals.length === 0 ? [
            $acbd0f0f6cb13a7f$require$Buffer.from([
                0
            ])
        ] : keyVals.map($gjIyn.keyValsToBuffer);
    const inputBuffers = keyValsOrEmptyToBuffer(inputKeyVals);
    const outputBuffers = keyValsOrEmptyToBuffer(outputKeyVals);
    const header = $acbd0f0f6cb13a7f$require$Buffer.allocUnsafe(5);
    header.writeUIntBE(0x70736274ff, 0, 5);
    return $acbd0f0f6cb13a7f$require$Buffer.concat([
        header,
        globalBuffer
    ].concat(inputBuffers, outputBuffers));
}
module.exports.psbtToBuffer = $acbd0f0f6cb13a7f$var$psbtToBuffer;
const $acbd0f0f6cb13a7f$var$sortKeyVals = (a, b)=>{
    return a.key.compare(b.key);
};
function $acbd0f0f6cb13a7f$var$keyValsFromMap(keyValMap, converterFactory) {
    const keyHexSet = new Set();
    const keyVals = Object.entries(keyValMap).reduce((result, [key, value])=>{
        if (key === "unknownKeyVals") return result;
        // We are checking for undefined anyways. So ignore TS error
        // @ts-ignore
        const converter = converterFactory[key];
        if (converter === undefined) return result;
        const encodedKeyVals = (Array.isArray(value) ? value : [
            value
        ]).map(converter.encode);
        const keyHexes = encodedKeyVals.map((kv)=>kv.key.toString("hex"));
        keyHexes.forEach((hex)=>{
            if (keyHexSet.has(hex)) throw new Error("Serialize Error: Duplicate key: " + hex);
            keyHexSet.add(hex);
        });
        return result.concat(encodedKeyVals);
    }, []);
    // Get other keyVals that have not yet been gotten
    const otherKeyVals = keyValMap.unknownKeyVals ? keyValMap.unknownKeyVals.filter((keyVal)=>{
        return !keyHexSet.has(keyVal.key.toString("hex"));
    }) : [];
    return keyVals.concat(otherKeyVals).sort($acbd0f0f6cb13a7f$var$sortKeyVals);
}
function $acbd0f0f6cb13a7f$var$psbtToKeyVals({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    // First parse the global keyVals
    // Get any extra keyvals to pass along
    return {
        globalKeyVals: $acbd0f0f6cb13a7f$var$keyValsFromMap(globalMap, $hbHfA.globals),
        inputKeyVals: inputs.map((i)=>$acbd0f0f6cb13a7f$var$keyValsFromMap(i, $hbHfA.inputs)),
        outputKeyVals: outputs.map((o)=>$acbd0f0f6cb13a7f$var$keyValsFromMap(o, $hbHfA.outputs))
    };
}
module.exports.psbtToKeyVals = $acbd0f0f6cb13a7f$var$psbtToKeyVals;

});



parcelRegister("93bki", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $696d2e0ac7f32306$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hbHfA = parcelRequire("hbHfA");
function $696d2e0ac7f32306$var$checkForInput(inputs, inputIndex) {
    const input = inputs[inputIndex];
    if (input === undefined) throw new Error(`No input #${inputIndex}`);
    return input;
}
module.exports.checkForInput = $696d2e0ac7f32306$var$checkForInput;
function $696d2e0ac7f32306$var$checkForOutput(outputs, outputIndex) {
    const output = outputs[outputIndex];
    if (output === undefined) throw new Error(`No output #${outputIndex}`);
    return output;
}
module.exports.checkForOutput = $696d2e0ac7f32306$var$checkForOutput;
function $696d2e0ac7f32306$var$checkHasKey(checkKeyVal, keyVals, enumLength) {
    if (checkKeyVal.key[0] < enumLength) throw new Error(`Use the method for your specific key instead of addUnknownKeyVal*`);
    if (keyVals && keyVals.filter((kv)=>kv.key.equals(checkKeyVal.key)).length !== 0) throw new Error(`Duplicate Key: ${checkKeyVal.key.toString("hex")}`);
}
module.exports.checkHasKey = $696d2e0ac7f32306$var$checkHasKey;
function $696d2e0ac7f32306$var$getEnumLength(myenum) {
    let count = 0;
    Object.keys(myenum).forEach((val)=>{
        if (Number(isNaN(Number(val)))) count++;
    });
    return count;
}
module.exports.getEnumLength = $696d2e0ac7f32306$var$getEnumLength;
function $696d2e0ac7f32306$var$inputCheckUncleanFinalized(inputIndex, input) {
    let result = false;
    if (input.nonWitnessUtxo || input.witnessUtxo) {
        const needScriptSig = !!input.redeemScript;
        const needWitnessScript = !!input.witnessScript;
        const scriptSigOK = !needScriptSig || !!input.finalScriptSig;
        const witnessScriptOK = !needWitnessScript || !!input.finalScriptWitness;
        const hasOneFinal = !!input.finalScriptSig || !!input.finalScriptWitness;
        result = scriptSigOK && witnessScriptOK && hasOneFinal;
    }
    if (result === false) throw new Error(`Input #${inputIndex} has too much or too little data to clean`);
}
module.exports.inputCheckUncleanFinalized = $696d2e0ac7f32306$var$inputCheckUncleanFinalized;
function $696d2e0ac7f32306$var$throwForUpdateMaker(typeName, name, expected, data) {
    throw new Error(`Data for ${typeName} key ${name} is incorrect: Expected ` + `${expected} and got ${JSON.stringify(data)}`);
}
function $696d2e0ac7f32306$var$updateMaker(typeName) {
    return (updateData, mainData)=>{
        for (const name of Object.keys(updateData)){
            // @ts-ignore
            const data = updateData[name];
            // @ts-ignore
            const { canAdd: canAdd, canAddToArray: canAddToArray, check: check, expected: expected } = // @ts-ignore
            $hbHfA[typeName + "s"][name] || {};
            const isArray = !!canAddToArray;
            // If unknown data. ignore and do not add
            if (check) {
                if (isArray) {
                    if (!Array.isArray(data) || // @ts-ignore
                    mainData[name] && !Array.isArray(mainData[name])) throw new Error(`Key type ${name} must be an array`);
                    if (!data.every(check)) $696d2e0ac7f32306$var$throwForUpdateMaker(typeName, name, expected, data);
                    // @ts-ignore
                    const arr = mainData[name] || [];
                    const dupeCheckSet = new Set();
                    if (!data.every((v)=>canAddToArray(arr, v, dupeCheckSet))) throw new Error("Can not add duplicate data to array");
                    // @ts-ignore
                    mainData[name] = arr.concat(data);
                } else {
                    if (!check(data)) $696d2e0ac7f32306$var$throwForUpdateMaker(typeName, name, expected, data);
                    if (!canAdd(mainData, data)) throw new Error(`Can not add duplicate data to ${typeName}`);
                    // @ts-ignore
                    mainData[name] = data;
                }
            }
        }
    };
}
module.exports.updateGlobal = $696d2e0ac7f32306$var$updateMaker("global");
module.exports.updateInput = $696d2e0ac7f32306$var$updateMaker("input");
module.exports.updateOutput = $696d2e0ac7f32306$var$updateMaker("output");
function $696d2e0ac7f32306$var$addInputAttributes(inputs, data) {
    const index = inputs.length - 1;
    const input = $696d2e0ac7f32306$var$checkForInput(inputs, index);
    module.exports.updateInput(data, input);
}
module.exports.addInputAttributes = $696d2e0ac7f32306$var$addInputAttributes;
function $696d2e0ac7f32306$var$addOutputAttributes(outputs, data) {
    const index = outputs.length - 1;
    const output = $696d2e0ac7f32306$var$checkForOutput(outputs, index);
    module.exports.updateOutput(data, output);
}
module.exports.addOutputAttributes = $696d2e0ac7f32306$var$addOutputAttributes;
function $696d2e0ac7f32306$var$defaultVersionSetter(version, txBuf) {
    if (!$696d2e0ac7f32306$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Version: Invalid Transaction");
    txBuf.writeUInt32LE(version, 0);
    return txBuf;
}
module.exports.defaultVersionSetter = $696d2e0ac7f32306$var$defaultVersionSetter;
function $696d2e0ac7f32306$var$defaultLocktimeSetter(locktime, txBuf) {
    if (!$696d2e0ac7f32306$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Locktime: Invalid Transaction");
    txBuf.writeUInt32LE(locktime, txBuf.length - 4);
    return txBuf;
}
module.exports.defaultLocktimeSetter = $696d2e0ac7f32306$var$defaultLocktimeSetter;

});



parcelRegister("6NUsZ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4f431ec2f9e50aca$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $h6Byf = parcelRequire("h6Byf");

var $ioOhP = parcelRequire("ioOhP");

var $kKMp6 = parcelRequire("kKMp6");

var $3yeGF = parcelRequire("3yeGF");

var $kNAnL = parcelRequire("kNAnL");

var $csNcS = parcelRequire("csNcS");

var $ltfXM = parcelRequire("ltfXM");

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");

var $5BO4o = parcelRequire("5BO4o");

var $7TFFW = parcelRequire("7TFFW");

var $bDP98 = parcelRequire("bDP98");
const $4f431ec2f9e50aca$var$SCRIPT_TYPES = $kKMp6.types;
const $4f431ec2f9e50aca$var$PREVOUT_TYPES = new Set([
    // Raw
    "p2pkh",
    "p2pk",
    "p2wpkh",
    "p2ms",
    // P2SH wrapped
    "p2sh-p2pkh",
    "p2sh-p2pk",
    "p2sh-p2wpkh",
    "p2sh-p2ms",
    // P2WSH wrapped
    "p2wsh-p2pkh",
    "p2wsh-p2pk",
    "p2wsh-p2ms",
    // P2SH-P2WSH wrapper
    "p2sh-p2wsh-p2pkh",
    "p2sh-p2wsh-p2pk",
    "p2sh-p2wsh-p2ms"
]);
function $4f431ec2f9e50aca$var$tfMessage(type, value, message) {
    try {
        $bDP98(type, value);
    } catch (err) {
        throw new Error(message);
    }
}
function $4f431ec2f9e50aca$var$txIsString(tx) {
    return typeof tx === "string" || tx instanceof String;
}
function $4f431ec2f9e50aca$var$txIsTransaction(tx) {
    return tx instanceof $5BO4o.Transaction;
}
class $4f431ec2f9e50aca$var$TransactionBuilder {
    // WARNING: maximumFeeRate is __NOT__ to be relied on,
    //          it's just another potential safety mechanism (safety in-depth)
    constructor(network = $csNcS.bitcoin, maximumFeeRate = 2500){
        this.network = network;
        this.maximumFeeRate = maximumFeeRate;
        this.__PREV_TX_SET = {};
        this.__INPUTS = [];
        this.__BITCOINCASH = false;
        this.__BITCOINGOLD = false;
        this.__TX = new $5BO4o.Transaction();
        this.__TX.version = 2;
        this.__USE_LOW_R = false;
        console.warn("Deprecation Warning: TransactionBuilder will be removed in the future. (v6.x.x or later) Please use the Psbt class instead. Examples of usage are available in the transactions-psbt.js integration test file on our Github. A high level explanation is available in the psbt.ts and psbt.js files as well.");
    }
    static fromTransaction(transaction, network, forkId) {
        const txb = new $4f431ec2f9e50aca$var$TransactionBuilder(network);
        if (typeof forkId === "number") {
            if (forkId === $5BO4o.Transaction.FORKID_BTG) txb.enableBitcoinGold(true);
            else if (forkId === $5BO4o.Transaction.FORKID_BCH) txb.enableBitcoinCash(true);
        }
        // Copy transaction fields
        txb.setVersion(transaction.version);
        txb.setLockTime(transaction.locktime);
        // Copy outputs (done first to avoid signature invalidation)
        transaction.outs.forEach((txOut)=>{
            txb.addOutput(txOut.script, txOut.value);
        });
        // Copy inputs
        transaction.ins.forEach((txIn)=>{
            txb.__addInputUnsafe(txIn.hash, txIn.index, {
                sequence: txIn.sequence,
                script: txIn.script,
                witness: txIn.witness,
                value: txIn.value
            });
        });
        // fix some things not possible through the public API
        txb.__INPUTS.forEach((input, i)=>{
            $4f431ec2f9e50aca$var$fixMultisigOrder(input, transaction, i, input.value, forkId);
        });
        return txb;
    }
    enableBitcoinCash(enable) {
        if (typeof enable === "undefined") enable = true;
        this.__BITCOINCASH = enable;
    }
    enableBitcoinGold(enable) {
        if (typeof enable === "undefined") enable = true;
        this.__BITCOINGOLD = enable;
    }
    setLowR(setting) {
        $bDP98($bDP98.maybe($bDP98.Boolean), setting);
        if (setting === undefined) setting = true;
        this.__USE_LOW_R = setting;
        return setting;
    }
    setLockTime(locktime) {
        $bDP98($7TFFW.UInt32, locktime);
        // if any signatures exist, throw
        if (this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((s)=>s !== undefined);
        })) throw new Error("No, this would invalidate signatures");
        this.__TX.locktime = locktime;
    }
    setVersion(version) {
        $bDP98($7TFFW.UInt32, version);
        // XXX: this might eventually become more complex depending on what the versions represent
        this.__TX.version = version;
    }
    addInput(txHash, vout, sequence, prevOutScript) {
        if (!this.__canModifyInputs()) throw new Error("No, this would invalidate signatures");
        let value;
        // is it a hex string?
        if ($4f431ec2f9e50aca$var$txIsString(txHash)) // transaction hashs's are displayed in reverse order, un-reverse it
        txHash = $ioOhP.reverseBuffer($4f431ec2f9e50aca$require$Buffer.from(txHash, "hex"));
        else if ($4f431ec2f9e50aca$var$txIsTransaction(txHash)) {
            const txOut = txHash.outs[vout];
            prevOutScript = txOut.script;
            value = txOut.value;
            txHash = txHash.getHash(false);
        }
        return this.__addInputUnsafe(txHash, vout, {
            sequence: sequence,
            prevOutScript: prevOutScript,
            value: value
        });
    }
    addOutput(scriptPubKey, value) {
        if (!this.__canModifyOutputs()) throw new Error("No, this would invalidate signatures");
        // Attempt to get a script if it's a base58 or bech32 address string
        if (typeof scriptPubKey === "string") scriptPubKey = $h6Byf.toOutputScript(scriptPubKey, this.network);
        return this.__TX.addOutput(scriptPubKey, value);
    }
    build() {
        return this.__build(false);
    }
    buildIncomplete() {
        return this.__build(true);
    }
    sign(signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
        $4f431ec2f9e50aca$var$trySign($4f431ec2f9e50aca$var$getSigningData(this.network, this.__INPUTS, this.__needsOutputs.bind(this), this.__TX, signParams, {
            btg: this.__BITCOINGOLD,
            bch: this.__BITCOINCASH
        }, keyPair, redeemScript, hashType, witnessValue, witnessScript, this.__USE_LOW_R));
    }
    __addInputUnsafe(txHash, vout, options) {
        if ($5BO4o.Transaction.isCoinbaseHash(txHash)) throw new Error("coinbase inputs not supported");
        const prevTxOut = txHash.toString("hex") + ":" + vout;
        if (this.__PREV_TX_SET[prevTxOut] !== undefined) throw new Error("Duplicate TxOut: " + prevTxOut);
        let input = {};
        // derive what we can from the scriptSig
        if (options.script !== undefined) input = $4f431ec2f9e50aca$var$expandInput(options.script, options.witness || []);
        // if an input value was given, retain it
        if (options.value !== undefined) input.value = options.value;
        // derive what we can from the previous transactions output script
        if (!input.prevOutScript && options.prevOutScript) {
            let prevOutType;
            if (!input.pubkeys && !input.signatures) {
                const expanded = $4f431ec2f9e50aca$var$expandOutput(options.prevOutScript);
                if (expanded.pubkeys) {
                    input.pubkeys = expanded.pubkeys;
                    input.signatures = expanded.signatures;
                }
                prevOutType = expanded.type;
            }
            input.prevOutScript = options.prevOutScript;
            input.prevOutType = prevOutType || $kKMp6.output(options.prevOutScript);
        }
        const vin = this.__TX.addInput(txHash, vout, options.sequence, options.scriptSig);
        this.__INPUTS[vin] = input;
        this.__PREV_TX_SET[prevTxOut] = true;
        return vin;
    }
    __build(allowIncomplete) {
        if (!allowIncomplete) {
            if (!this.__TX.ins.length) throw new Error("Transaction has no inputs");
            if (!this.__TX.outs.length) throw new Error("Transaction has no outputs");
        }
        const tx = this.__TX.clone();
        // create script signatures from inputs
        this.__INPUTS.forEach((input, i)=>{
            if (!input.prevOutType && !allowIncomplete) throw new Error("Transaction is not complete");
            const result = $4f431ec2f9e50aca$var$build(input.prevOutType, input, allowIncomplete);
            if (!result) {
                if (!allowIncomplete && input.prevOutType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.NONSTANDARD) throw new Error("Unknown input type");
                if (!allowIncomplete) throw new Error("Not enough information");
                return;
            }
            tx.setInputScript(i, result.input);
            tx.setWitness(i, result.witness);
        });
        if (!allowIncomplete) {
            // do not rely on this, its merely a last resort
            if (this.__overMaximumFees(tx.virtualSize())) throw new Error("Transaction has absurd fees");
        }
        return tx;
    }
    __canModifyInputs() {
        return this.__INPUTS.every((input)=>{
            if (!input.signatures) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $4f431ec2f9e50aca$var$signatureHashType(signature);
                // if SIGHASH_ANYONECANPAY is set, signatures would not
                // be invalidated by more inputs
                return (hashType & $5BO4o.Transaction.SIGHASH_ANYONECANPAY) !== 0;
            });
        });
    }
    __needsOutputs(signingHashType) {
        if (signingHashType === $5BO4o.Transaction.SIGHASH_ALL) return this.__TX.outs.length === 0;
        // if inputs are being signed with SIGHASH_NONE, we don't strictly need outputs
        // .build() will fail, but .buildIncomplete() is OK
        return this.__TX.outs.length === 0 && this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((signature)=>{
                if (!signature) return false; // no signature, no issue
                const hashType = $4f431ec2f9e50aca$var$signatureHashType(signature);
                if (hashType & $5BO4o.Transaction.SIGHASH_NONE) return false; // SIGHASH_NONE doesn't care about outputs
                return true; // SIGHASH_* does care
            });
        });
    }
    __canModifyOutputs() {
        const nInputs = this.__TX.ins.length;
        const nOutputs = this.__TX.outs.length;
        return this.__INPUTS.every((input)=>{
            if (input.signatures === undefined) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $4f431ec2f9e50aca$var$signatureHashType(signature);
                const hashTypeMod = hashType & 0x1f;
                if (hashTypeMod === $5BO4o.Transaction.SIGHASH_NONE) return true;
                if (hashTypeMod === $5BO4o.Transaction.SIGHASH_SINGLE) // if SIGHASH_SINGLE is set, and nInputs > nOutputs
                // some signatures would be invalidated by the addition
                // of more outputs
                return nInputs <= nOutputs;
                return false;
            });
        });
    }
    __overMaximumFees(bytes) {
        // not all inputs will have .value defined
        const incoming = this.__INPUTS.reduce((a, x)=>a + (x.value >>> 0), 0);
        // but all outputs do, and if we have any input value
        // we can immediately determine if the outputs are too small
        const outgoing = this.__TX.outs.reduce((a, x)=>a + x.value, 0);
        const fee = incoming - outgoing;
        const feeRate = fee / bytes;
        return feeRate > this.maximumFeeRate;
    }
}
module.exports.TransactionBuilder = $4f431ec2f9e50aca$var$TransactionBuilder;
function $4f431ec2f9e50aca$var$expandInput(scriptSig, witnessStack, type, scriptPubKey) {
    if (scriptSig.length === 0 && witnessStack.length === 0) return {};
    if (!type) {
        let ssType = $kKMp6.input(scriptSig, true);
        let wsType = $kKMp6.witness(witnessStack, true);
        if (ssType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.NONSTANDARD) ssType = undefined;
        if (wsType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.NONSTANDARD) wsType = undefined;
        type = ssType || wsType;
    }
    switch(type){
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $ltfXM.p2wpkh({
                    witness: witnessStack
                });
                return {
                    prevOutScript: output,
                    prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $ltfXM.p2pkh({
                    input: scriptSig
                });
                return {
                    prevOutScript: output,
                    prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PK:
            {
                const { signature: signature } = $ltfXM.p2pk({
                    input: scriptSig
                });
                return {
                    prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PK,
                    pubkeys: [
                        undefined
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2MS:
            {
                const { m: m, pubkeys: pubkeys, signatures: signatures } = $ltfXM.p2ms({
                    input: scriptSig,
                    output: scriptPubKey
                }, {
                    allowIncomplete: true
                });
                return {
                    prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2MS,
                    pubkeys: pubkeys,
                    signatures: signatures,
                    maxSignatures: m
                };
            }
    }
    if (type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH) {
        const { output: output, redeem: redeem } = $ltfXM.p2sh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $kKMp6.output(redeem.output);
        const expanded = $4f431ec2f9e50aca$var$expandInput(redeem.input, redeem.witness, outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH,
            redeemScript: redeem.output,
            redeemScriptType: expanded.prevOutType,
            witnessScript: expanded.witnessScript,
            witnessScriptType: expanded.witnessScriptType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    if (type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH) {
        const { output: output, redeem: redeem } = $ltfXM.p2wsh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $kKMp6.output(redeem.output);
        let expanded;
        if (outputType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH) expanded = $4f431ec2f9e50aca$var$expandInput(redeem.input, redeem.witness, outputType);
        else expanded = $4f431ec2f9e50aca$var$expandInput($jodFS.compile(redeem.witness), [], outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH,
            witnessScript: redeem.output,
            witnessScriptType: expanded.prevOutType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    return {
        prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.NONSTANDARD,
        prevOutScript: scriptSig
    };
}
// could be done in expandInput, but requires the original Transaction for hashForSignature
function $4f431ec2f9e50aca$var$fixMultisigOrder(input, transaction, vin, value, forkId) {
    if (input.redeemScriptType !== $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2MS || !input.redeemScript) return;
    if (input.pubkeys.length === input.signatures.length) return;
    const unmatched = input.signatures.concat();
    input.signatures = input.pubkeys.map((pubKey)=>{
        const keyPair = $kNAnL.fromPublicKey(pubKey);
        let match;
        // check for a signature
        unmatched.some((signature, i)=>{
            // skip if undefined || OP_0
            if (!signature) return false;
            // TODO: avoid O(n) hashForSignature
            const parsed = $jodFS.signature.decode(signature);
            let hash;
            switch(forkId){
                case $5BO4o.Transaction.FORKID_BCH:
                    hash = transaction.hashForCashSignature(vin, input.redeemScript, value, parsed.hashType);
                    break;
                case $5BO4o.Transaction.FORKID_BTG:
                    hash = transaction.hashForGoldSignature(vin, input.redeemScript, value, parsed.hashType);
                    break;
                default:
                    if (input.witness) hash = transaction.hashForWitnessV0(vin, input.redeemScript, value, parsed.hashType);
                    else hash = transaction.hashForSignature(vin, input.redeemScript, parsed.hashType);
                    break;
            }
            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false;
            // remove matched signature from unmatched
            unmatched[i] = undefined;
            match = signature;
            return true;
        });
        return match;
    });
}
function $4f431ec2f9e50aca$var$expandOutput(script, ourPubKey) {
    $bDP98($7TFFW.Buffer, script);
    const type = $kKMp6.output(script);
    switch(type){
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const pkh1 = $ltfXM.p2pkh({
                    output: script
                }).hash;
                const pkh2 = $3yeGF.hash160(ourPubKey);
                if (!pkh1.equals(pkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const wpkh1 = $ltfXM.p2wpkh({
                    output: script
                }).hash;
                const wpkh2 = $3yeGF.hash160(ourPubKey);
                if (!wpkh1.equals(wpkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PK:
            {
                const p2pk = $ltfXM.p2pk({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: [
                        p2pk.pubkey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2MS:
            {
                const p2ms = $ltfXM.p2ms({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: p2ms.pubkeys,
                    signatures: p2ms.pubkeys.map(()=>undefined),
                    maxSignatures: p2ms.m
                };
            }
    }
    return {
        type: type
    };
}
function $4f431ec2f9e50aca$var$prepareInput(input, ourPubKey, redeemScript, witnessScript) {
    if (redeemScript && witnessScript) {
        const p2wsh = $ltfXM.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        const p2wshAlt = $ltfXM.p2wsh({
            output: redeemScript
        });
        const p2sh = $ltfXM.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        const p2shAlt = $ltfXM.p2sh({
            redeem: p2wsh
        });
        // enforces P2SH(P2WSH(...))
        if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        const expanded = $4f431ec2f9e50aca$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as witnessScript (" + $jodFS.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2SH(P2WSH(P2WPKH)) is a consensus failure");
        return {
            redeemScript: redeemScript,
            redeemScriptType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH,
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (redeemScript) {
        const p2sh = $ltfXM.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        if (input.prevOutScript) {
            let p2shAlt;
            try {
                p2shAlt = $ltfXM.p2sh({
                    output: input.prevOutScript
                });
            } catch (e) {
                throw new Error("PrevOutScript must be P2SH");
            }
            if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        }
        const expanded = $4f431ec2f9e50aca$var$expandOutput(p2sh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as redeemScript (" + $jodFS.toASM(redeemScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = redeemScript;
        if (expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH) signScript = $ltfXM.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            redeemScript: redeemScript,
            redeemScriptType: expanded.type,
            prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (witnessScript) {
        const p2wsh = $ltfXM.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        if (input.prevOutScript) {
            const p2wshAlt = $ltfXM.p2wsh({
                output: input.prevOutScript
            });
            if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        }
        const expanded = $4f431ec2f9e50aca$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as witnessScript (" + $jodFS.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2WSH(P2WPKH) is a consensus failure");
        return {
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH,
            prevOutScript: p2wsh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (input.prevOutType && input.prevOutScript) {
        // embedded scripts are not possible without extra information
        if (input.prevOutType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires redeemScript");
        if (input.prevOutType === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires witnessScript");
        if (!input.prevOutScript) throw new Error("PrevOutScript is missing");
        const expanded = $4f431ec2f9e50aca$var$expandOutput(input.prevOutScript, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported (" + $jodFS.toASM(input.prevOutScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = input.prevOutScript;
        if (expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH) signScript = $ltfXM.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            prevOutType: expanded.type,
            prevOutScript: input.prevOutScript,
            hasWitness: expanded.type === $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    const prevOutScript = $ltfXM.p2pkh({
        pubkey: ourPubKey
    }).output;
    return {
        prevOutType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH,
        prevOutScript: prevOutScript,
        hasWitness: false,
        signScript: prevOutScript,
        signType: $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH,
        pubkeys: [
            ourPubKey
        ],
        signatures: [
            undefined
        ]
    };
}
function $4f431ec2f9e50aca$var$build(type, input, allowIncomplete) {
    const pubkeys = input.pubkeys || [];
    let signatures = input.signatures || [];
    switch(type){
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $ltfXM.p2pkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WPKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $ltfXM.p2wpkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2PK:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $ltfXM.p2pk({
                signature: signatures[0]
            });
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2MS:
            {
                const m = input.maxSignatures;
                if (allowIncomplete) signatures = signatures.map((x)=>x || $jodFS.OPS.OP_0);
                else signatures = signatures.filter((x)=>x);
                // if the transaction is not not complete (complete), or if signatures.length === m, validate
                // otherwise, the number of OP_0's may be >= m, so don't validate (boo)
                const validate = !allowIncomplete || m === signatures.length;
                return $ltfXM.p2ms({
                    m: m,
                    pubkeys: pubkeys,
                    signatures: signatures
                }, {
                    allowIncomplete: allowIncomplete,
                    validate: validate
                });
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2SH:
            {
                const redeem = $4f431ec2f9e50aca$var$build(input.redeemScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $ltfXM.p2sh({
                    redeem: {
                        output: redeem.output || input.redeemScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
        case $4f431ec2f9e50aca$var$SCRIPT_TYPES.P2WSH:
            {
                const redeem = $4f431ec2f9e50aca$var$build(input.witnessScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $ltfXM.p2wsh({
                    redeem: {
                        output: input.witnessScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
    }
}
function $4f431ec2f9e50aca$var$canSign(input) {
    return input.signScript !== undefined && input.signType !== undefined && input.pubkeys !== undefined && input.signatures !== undefined && input.signatures.length === input.pubkeys.length && input.pubkeys.length > 0 && (input.hasWitness === false || input.value !== undefined);
}
function $4f431ec2f9e50aca$var$signatureHashType(buffer) {
    return buffer.readUInt8(buffer.length - 1);
}
function $4f431ec2f9e50aca$var$checkSignArgs(inputs, signParams) {
    if (!$4f431ec2f9e50aca$var$PREVOUT_TYPES.has(signParams.prevOutScriptType)) throw new TypeError(`Unknown prevOutScriptType "${signParams.prevOutScriptType}"`);
    $4f431ec2f9e50aca$var$tfMessage($bDP98.Number, signParams.vin, `sign must include vin parameter as Number (input index)`);
    $4f431ec2f9e50aca$var$tfMessage($7TFFW.Signer, signParams.keyPair, `sign must include keyPair parameter as Signer interface`);
    $4f431ec2f9e50aca$var$tfMessage($bDP98.maybe($bDP98.Number), signParams.hashType, `sign hashType parameter must be a number`);
    const prevOutType = (inputs[signParams.vin] || []).prevOutType;
    const posType = signParams.prevOutScriptType;
    switch(posType){
        case "p2pkh":
            if (prevOutType && prevOutType !== "pubkeyhash") throw new TypeError(`input #${signParams.vin} is not of type p2pkh: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2pk":
            if (prevOutType && prevOutType !== "pubkey") throw new TypeError(`input #${signParams.vin} is not of type p2pk: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2wpkh":
            if (prevOutType && prevOutType !== "witnesspubkeyhash") throw new TypeError(`input #${signParams.vin} is not of type p2wpkh: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($7TFFW.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2ms":
            if (prevOutType && prevOutType !== "multisig") throw new TypeError(`input #${signParams.vin} is not of type p2ms: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2sh-p2wpkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type p2sh-p2wpkh: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($7TFFW.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2sh-p2ms":
        case "p2sh-p2pk":
        case "p2sh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2wsh-p2ms":
        case "p2wsh-p2pk":
        case "p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "witnessscripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $4f431ec2f9e50aca$var$tfMessage($7TFFW.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2sh-p2wsh-p2ms":
        case "p2sh-p2wsh-p2pk":
        case "p2sh-p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($bDP98.Buffer, signParams.redeemScript, `${posType} requires witnessScript`);
            $4f431ec2f9e50aca$var$tfMessage($7TFFW.Satoshi, signParams.witnessValue, `${posType} requires witnessScript`);
            break;
    }
}
function $4f431ec2f9e50aca$var$trySign({ input: input, ourPubKey: ourPubKey, keyPair: keyPair, signatureHash: signatureHash, hashType: hashType, useLowR: useLowR }) {
    // enforce in order signing of public keys
    let signed = false;
    for (const [i, pubKey] of input.pubkeys.entries()){
        if (!ourPubKey.equals(pubKey)) continue;
        if (input.signatures[i]) throw new Error("Signature already exists");
        // TODO: add tests
        if (ourPubKey.length !== 33 && input.hasWitness) throw new Error("BIP143 rejects uncompressed public keys in P2WPKH or P2WSH");
        const signature = keyPair.sign(signatureHash, useLowR);
        input.signatures[i] = $jodFS.signature.encode(signature, hashType);
        signed = true;
    }
    if (!signed) throw new Error("Key pair cannot sign for this input");
}
function $4f431ec2f9e50aca$var$getSigningData(network, inputs, needsOutputs, tx, signParams, forkBools, keyPair, redeemScript, hashType, witnessValue, witnessScript, useLowR) {
    let vin;
    if (typeof signParams === "number") {
        console.warn("DEPRECATED: TransactionBuilder sign method arguments will change in v6, please use the TxbSignArg interface");
        vin = signParams;
    } else if (typeof signParams === "object") {
        $4f431ec2f9e50aca$var$checkSignArgs(inputs, signParams);
        ({ vin: vin, keyPair: keyPair, redeemScript: redeemScript, hashType: hashType, witnessValue: witnessValue, witnessScript: witnessScript } = signParams);
    } else throw new TypeError("TransactionBuilder sign first arg must be TxbSignArg or number");
    if (keyPair === undefined) throw new Error("sign requires keypair");
    // TODO: remove keyPair.network matching in 4.0.0
    if (keyPair.network && keyPair.network !== network) throw new TypeError("Inconsistent network");
    if (!inputs[vin]) throw new Error("No input at index: " + vin);
    hashType = hashType || $5BO4o.Transaction.SIGHASH_ALL;
    if (needsOutputs(hashType)) throw new Error("Transaction needs outputs");
    const input = inputs[vin];
    // if redeemScript was previously provided, enforce consistency
    if (input.redeemScript !== undefined && redeemScript && !input.redeemScript.equals(redeemScript)) throw new Error("Inconsistent redeemScript");
    const ourPubKey = keyPair.publicKey || keyPair.getPublicKey && keyPair.getPublicKey();
    if (!$4f431ec2f9e50aca$var$canSign(input)) {
        if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error("Input did not match witnessValue");
            $bDP98($7TFFW.Satoshi, witnessValue);
            input.value = witnessValue;
        }
        if (!$4f431ec2f9e50aca$var$canSign(input)) {
            const prepared = $4f431ec2f9e50aca$var$prepareInput(input, ourPubKey, redeemScript, witnessScript);
            // updates inline
            Object.assign(input, prepared);
        }
        if (!$4f431ec2f9e50aca$var$canSign(input)) throw Error(input.prevOutType + " not supported");
    }
    // ready to sign
    let signatureHash;
    if (forkBools.btg) signatureHash = tx.hashForGoldSignature(vin, input.signScript, input.value, hashType, !!input.witness);
    else if (forkBools.bch) signatureHash = tx.hashForCashSignature(vin, input.signScript, input.value, hashType);
    else if (input.hasWitness) signatureHash = tx.hashForWitnessV0(vin, input.signScript, input.value, hashType);
    else signatureHash = tx.hashForSignature(vin, input.signScript, hashType);
    return {
        input: input,
        ourPubKey: ourPubKey,
        keyPair: keyPair,
        signatureHash: signatureHash,
        hashType: hashType,
        useLowR: !!useLowR
    };
}

});
parcelRegister("kKMp6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $1XtnJ = parcelRequire("1XtnJ");

var $a00IW = parcelRequire("a00IW");

var $bLBlz = parcelRequire("bLBlz");

var $k2Xmh = parcelRequire("k2Xmh");

var $fyrz8 = parcelRequire("fyrz8");

var $a7SYK = parcelRequire("a7SYK");

var $lpAGM = parcelRequire("lpAGM");

var $9Sh8x = parcelRequire("9Sh8x");
const $f1bda68473729e06$var$types = {
    P2MS: "multisig",
    NONSTANDARD: "nonstandard",
    NULLDATA: "nulldata",
    P2PK: "pubkey",
    P2PKH: "pubkeyhash",
    P2SH: "scripthash",
    P2WPKH: "witnesspubkeyhash",
    P2WSH: "witnessscripthash",
    WITNESS_COMMITMENT: "witnesscommitment"
};
module.exports.types = $f1bda68473729e06$var$types;
function $f1bda68473729e06$var$classifyOutput(script) {
    if ($lpAGM.output.check(script)) return $f1bda68473729e06$var$types.P2WPKH;
    if ($9Sh8x.output.check(script)) return $f1bda68473729e06$var$types.P2WSH;
    if ($k2Xmh.output.check(script)) return $f1bda68473729e06$var$types.P2PKH;
    if ($fyrz8.output.check(script)) return $f1bda68473729e06$var$types.P2SH;
    // XXX: optimization, below functions .decompile before use
    const chunks = $jodFS.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($1XtnJ.output.check(chunks)) return $f1bda68473729e06$var$types.P2MS;
    if ($bLBlz.output.check(chunks)) return $f1bda68473729e06$var$types.P2PK;
    if ($a7SYK.output.check(chunks)) return $f1bda68473729e06$var$types.WITNESS_COMMITMENT;
    if ($a00IW.output.check(chunks)) return $f1bda68473729e06$var$types.NULLDATA;
    return $f1bda68473729e06$var$types.NONSTANDARD;
}
module.exports.output = $f1bda68473729e06$var$classifyOutput;
function $f1bda68473729e06$var$classifyInput(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $jodFS.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($k2Xmh.input.check(chunks)) return $f1bda68473729e06$var$types.P2PKH;
    if ($fyrz8.input.check(chunks, allowIncomplete)) return $f1bda68473729e06$var$types.P2SH;
    if ($1XtnJ.input.check(chunks, allowIncomplete)) return $f1bda68473729e06$var$types.P2MS;
    if ($bLBlz.input.check(chunks)) return $f1bda68473729e06$var$types.P2PK;
    return $f1bda68473729e06$var$types.NONSTANDARD;
}
module.exports.input = $f1bda68473729e06$var$classifyInput;
function $f1bda68473729e06$var$classifyWitness(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $jodFS.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($lpAGM.input.check(chunks)) return $f1bda68473729e06$var$types.P2WPKH;
    if ($9Sh8x.input.check(chunks, allowIncomplete)) return $f1bda68473729e06$var$types.P2WSH;
    return $f1bda68473729e06$var$types.NONSTANDARD;
}
module.exports.witness = $f1bda68473729e06$var$classifyWitness;

});
parcelRegister("1XtnJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kmxDk = parcelRequire("kmxDk");
module.exports.input = $kmxDk;

var $cAMaK = parcelRequire("cAMaK");
module.exports.output = $cAMaK;

});
parcelRegister("kmxDk", function(module, exports) {
"use strict";
// OP_0 [signatures ...]
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $ed2ff39b39fddc1e$var$partialSignature(value) {
    return value === $jodFS.OPS.OP_0 || $jodFS.isCanonicalScriptSignature(value);
}
function $ed2ff39b39fddc1e$var$check(script, allowIncomplete) {
    const chunks = $jodFS.decompile(script);
    if (chunks.length < 2) return false;
    if (chunks[0] !== $jodFS.OPS.OP_0) return false;
    if (allowIncomplete) return chunks.slice(1).every($ed2ff39b39fddc1e$var$partialSignature);
    return chunks.slice(1).every($jodFS.isCanonicalScriptSignature);
}
module.exports.check = $ed2ff39b39fddc1e$var$check;
$ed2ff39b39fddc1e$var$check.toJSON = ()=>{
    return "multisig input";
};

});

parcelRegister("cAMaK", function(module, exports) {
"use strict";
// m [pubKeys ...] n OP_CHECKMULTISIG
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");

var $7TFFW = parcelRequire("7TFFW");
const $92ae36dedb64be8d$var$OP_INT_BASE = $jodFS.OPS.OP_RESERVED; // OP_1 - 1
function $92ae36dedb64be8d$var$check(script, allowIncomplete) {
    const chunks = $jodFS.decompile(script);
    if (chunks.length < 4) return false;
    if (chunks[chunks.length - 1] !== $jodFS.OPS.OP_CHECKMULTISIG) return false;
    if (!$7TFFW.Number(chunks[0])) return false;
    if (!$7TFFW.Number(chunks[chunks.length - 2])) return false;
    const m = chunks[0] - $92ae36dedb64be8d$var$OP_INT_BASE;
    const n = chunks[chunks.length - 2] - $92ae36dedb64be8d$var$OP_INT_BASE;
    if (m <= 0) return false;
    if (n > 16) return false;
    if (m > n) return false;
    if (n !== chunks.length - 3) return false;
    if (allowIncomplete) return true;
    const keys = chunks.slice(1, -2);
    return keys.every($jodFS.isCanonicalPubKey);
}
module.exports.check = $92ae36dedb64be8d$var$check;
$92ae36dedb64be8d$var$check.toJSON = ()=>{
    return "multi-sig output";
};

});


parcelRegister("a00IW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");
const $747a7735a8272589$var$OPS = $jodFS.OPS;
function $747a7735a8272589$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length > 1 && buffer[0] === $747a7735a8272589$var$OPS.OP_RETURN;
}
module.exports.check = $747a7735a8272589$var$check;
$747a7735a8272589$var$check.toJSON = ()=>{
    return "null data output";
};
const $747a7735a8272589$var$output = {
    check: $747a7735a8272589$var$check
};
module.exports.output = $747a7735a8272589$var$output;

});

parcelRegister("bLBlz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aWis5 = parcelRequire("aWis5");
module.exports.input = $aWis5;

var $lH1Ql = parcelRequire("lH1Ql");
module.exports.output = $lH1Ql;

});
parcelRegister("aWis5", function(module, exports) {
"use strict";
// {signature}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");
function $7f6da25491d267ae$var$check(script) {
    const chunks = $jodFS.decompile(script);
    return chunks.length === 1 && $jodFS.isCanonicalScriptSignature(chunks[0]);
}
module.exports.check = $7f6da25491d267ae$var$check;
$7f6da25491d267ae$var$check.toJSON = ()=>{
    return "pubKey input";
};

});

parcelRegister("lH1Ql", function(module, exports) {
"use strict";
// {pubKey} OP_CHECKSIG
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $fcaf0b2a13818387$var$check(script) {
    const chunks = $jodFS.decompile(script);
    return chunks.length === 2 && $jodFS.isCanonicalPubKey(chunks[0]) && chunks[1] === $jodFS.OPS.OP_CHECKSIG;
}
module.exports.check = $fcaf0b2a13818387$var$check;
$fcaf0b2a13818387$var$check.toJSON = ()=>{
    return "pubKey output";
};

});


parcelRegister("k2Xmh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bdKJJ = parcelRequire("bdKJJ");
module.exports.input = $bdKJJ;

var $iTdp9 = parcelRequire("iTdp9");
module.exports.output = $iTdp9;

});
parcelRegister("bdKJJ", function(module, exports) {
"use strict";
// {signature} {pubKey}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");
function $82b52986563584ab$var$check(script) {
    const chunks = $jodFS.decompile(script);
    return chunks.length === 2 && $jodFS.isCanonicalScriptSignature(chunks[0]) && $jodFS.isCanonicalPubKey(chunks[1]);
}
module.exports.check = $82b52986563584ab$var$check;
$82b52986563584ab$var$check.toJSON = ()=>{
    return "pubKeyHash input";
};

});

parcelRegister("iTdp9", function(module, exports) {
"use strict";
// OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $dc07c2ee52c10b4e$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length === 25 && buffer[0] === $jodFS.OPS.OP_DUP && buffer[1] === $jodFS.OPS.OP_HASH160 && buffer[2] === 0x14 && buffer[23] === $jodFS.OPS.OP_EQUALVERIFY && buffer[24] === $jodFS.OPS.OP_CHECKSIG;
}
module.exports.check = $dc07c2ee52c10b4e$var$check;
$dc07c2ee52c10b4e$var$check.toJSON = ()=>{
    return "pubKeyHash output";
};

});


parcelRegister("fyrz8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3uuD1 = parcelRequire("3uuD1");
module.exports.input = $3uuD1;

var $iOxPp = parcelRequire("iOxPp");
module.exports.output = $iOxPp;

});
parcelRegister("3uuD1", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $28abee98e37e8562$require$Buffer = $ihoyg.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $1XtnJ = parcelRequire("1XtnJ");

var $bLBlz = parcelRequire("bLBlz");

var $k2Xmh = parcelRequire("k2Xmh");

var $9KLDH = parcelRequire("9KLDH");

var $ccbbY = parcelRequire("ccbbY");
function $28abee98e37e8562$var$check(script, allowIncomplete) {
    const chunks = $jodFS.decompile(script);
    if (chunks.length < 1) return false;
    const lastChunk = chunks[chunks.length - 1];
    if (!$28abee98e37e8562$require$Buffer.isBuffer(lastChunk)) return false;
    const scriptSigChunks = $jodFS.decompile($jodFS.compile(chunks.slice(0, -1)));
    const redeemScriptChunks = $jodFS.decompile(lastChunk);
    // is redeemScript a valid script?
    if (!redeemScriptChunks) return false;
    // is redeemScriptSig push only?
    if (!$jodFS.isPushOnly(scriptSigChunks)) return false;
    // is witness?
    if (chunks.length === 1) return $ccbbY.check(redeemScriptChunks) || $9KLDH.check(redeemScriptChunks);
    // match types
    if ($k2Xmh.input.check(scriptSigChunks) && $k2Xmh.output.check(redeemScriptChunks)) return true;
    if ($1XtnJ.input.check(scriptSigChunks, allowIncomplete) && $1XtnJ.output.check(redeemScriptChunks)) return true;
    if ($bLBlz.input.check(scriptSigChunks) && $bLBlz.output.check(redeemScriptChunks)) return true;
    return false;
}
module.exports.check = $28abee98e37e8562$var$check;
$28abee98e37e8562$var$check.toJSON = ()=>{
    return "scriptHash input";
};

});
parcelRegister("9KLDH", function(module, exports) {
"use strict";
// OP_0 {pubKeyHash}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $719d5d2155c818e7$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length === 22 && buffer[0] === $jodFS.OPS.OP_0 && buffer[1] === 0x14;
}
module.exports.check = $719d5d2155c818e7$var$check;
$719d5d2155c818e7$var$check.toJSON = ()=>{
    return "Witness pubKeyHash output";
};

});

parcelRegister("ccbbY", function(module, exports) {
"use strict";
// OP_0 {scriptHash}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $8e0f498f8ea3003a$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length === 34 && buffer[0] === $jodFS.OPS.OP_0 && buffer[1] === 0x20;
}
module.exports.check = $8e0f498f8ea3003a$var$check;
$8e0f498f8ea3003a$var$check.toJSON = ()=>{
    return "Witness scriptHash output";
};

});


parcelRegister("iOxPp", function(module, exports) {
"use strict";
// OP_HASH160 {scriptHash} OP_EQUAL
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");
function $0388e3a9a82d7776$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length === 23 && buffer[0] === $jodFS.OPS.OP_HASH160 && buffer[1] === 0x14 && buffer[22] === $jodFS.OPS.OP_EQUAL;
}
module.exports.check = $0388e3a9a82d7776$var$check;
$0388e3a9a82d7776$var$check.toJSON = ()=>{
    return "scriptHash output";
};

});


parcelRegister("a7SYK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4rglo = parcelRequire("4rglo");
module.exports.output = $4rglo;

});
parcelRegister("4rglo", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $33b65ca2c0027be4$require$Buffer = $ihoyg.Buffer;
"use strict";
// OP_RETURN {aa21a9ed} {commitment}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $jodFS = parcelRequire("jodFS");

var $7TFFW = parcelRequire("7TFFW");

var $bDP98 = parcelRequire("bDP98");
const $33b65ca2c0027be4$var$HEADER = $33b65ca2c0027be4$require$Buffer.from("aa21a9ed", "hex");
function $33b65ca2c0027be4$var$check(script) {
    const buffer = $jodFS.compile(script);
    return buffer.length > 37 && buffer[0] === $jodFS.OPS.OP_RETURN && buffer[1] === 0x24 && buffer.slice(2, 6).equals($33b65ca2c0027be4$var$HEADER);
}
module.exports.check = $33b65ca2c0027be4$var$check;
$33b65ca2c0027be4$var$check.toJSON = ()=>{
    return "Witness commitment output";
};
function $33b65ca2c0027be4$var$encode(commitment) {
    $bDP98($7TFFW.Hash256bit, commitment);
    const buffer = $33b65ca2c0027be4$require$Buffer.allocUnsafe(36);
    $33b65ca2c0027be4$var$HEADER.copy(buffer, 0);
    commitment.copy(buffer, 4);
    return $jodFS.compile([
        $jodFS.OPS.OP_RETURN,
        buffer
    ]);
}
module.exports.encode = $33b65ca2c0027be4$var$encode;
function $33b65ca2c0027be4$var$decode(buffer) {
    $bDP98($33b65ca2c0027be4$var$check, buffer);
    return $jodFS.decompile(buffer)[1].slice(4, 36);
}
module.exports.decode = $33b65ca2c0027be4$var$decode;

});


parcelRegister("lpAGM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8QsqP = parcelRequire("8QsqP");
module.exports.input = $8QsqP;

var $9KLDH = parcelRequire("9KLDH");
module.exports.output = $9KLDH;

});
parcelRegister("8QsqP", function(module, exports) {
"use strict";
// {signature} {pubKey}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");
function $67093bfbf0ba776f$var$isCompressedCanonicalPubKey(pubKey) {
    return $jodFS.isCanonicalPubKey(pubKey) && pubKey.length === 33;
}
function $67093bfbf0ba776f$var$check(script) {
    const chunks = $jodFS.decompile(script);
    return chunks.length === 2 && $jodFS.isCanonicalScriptSignature(chunks[0]) && $67093bfbf0ba776f$var$isCompressedCanonicalPubKey(chunks[1]);
}
module.exports.check = $67093bfbf0ba776f$var$check;
$67093bfbf0ba776f$var$check.toJSON = ()=>{
    return "witnessPubKeyHash input";
};

});


parcelRegister("9Sh8x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4EcZh = parcelRequire("4EcZh");
module.exports.input = $4EcZh;

var $ccbbY = parcelRequire("ccbbY");
module.exports.output = $ccbbY;

});
parcelRegister("4EcZh", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $3624f8e409ed556f$require$Buffer = $ihoyg.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jodFS = parcelRequire("jodFS");

var $bDP98 = parcelRequire("bDP98");

var $1XtnJ = parcelRequire("1XtnJ");

var $bLBlz = parcelRequire("bLBlz");

var $k2Xmh = parcelRequire("k2Xmh");
function $3624f8e409ed556f$var$check(chunks, allowIncomplete) {
    $bDP98($bDP98.Array, chunks);
    if (chunks.length < 1) return false;
    const witnessScript = chunks[chunks.length - 1];
    if (!$3624f8e409ed556f$require$Buffer.isBuffer(witnessScript)) return false;
    const witnessScriptChunks = $jodFS.decompile(witnessScript);
    // is witnessScript a valid script?
    if (!witnessScriptChunks || witnessScriptChunks.length === 0) return false;
    const witnessRawScriptSig = $jodFS.compile(chunks.slice(0, -1));
    // match types
    if ($k2Xmh.input.check(witnessRawScriptSig) && $k2Xmh.output.check(witnessScriptChunks)) return true;
    if ($1XtnJ.input.check(witnessRawScriptSig, allowIncomplete) && $1XtnJ.output.check(witnessScriptChunks)) return true;
    if ($bLBlz.input.check(witnessRawScriptSig) && $bLBlz.output.check(witnessScriptChunks)) return true;
    return false;
}
module.exports.check = $3624f8e409ed556f$var$check;
$3624f8e409ed556f$var$check.toJSON = ()=>{
    return "witnessScriptHash input";
};

});





parcelRegister("bhJ7Q", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
"use strict";
function $83744938df793cc1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $83744938df793cc1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $83744938df793cc1$var$_typeof(o);
}
function $83744938df793cc1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $83744938df793cc1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $83744938df793cc1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $83744938df793cc1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $83744938df793cc1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $83744938df793cc1$var$_toPropertyKey(arg) {
    var key = $83744938df793cc1$var$_toPrimitive(arg, "string");
    return $83744938df793cc1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $83744938df793cc1$var$_toPrimitive(input, hint) {
    if ($83744938df793cc1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($83744938df793cc1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $83744938df793cc1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $9XRIq = parcelRequire("9XRIq");
var $83744938df793cc1$var$_require$codes = $9XRIq.codes, $83744938df793cc1$var$ERR_AMBIGUOUS_ARGUMENT = $83744938df793cc1$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $83744938df793cc1$var$ERR_INVALID_ARG_TYPE = $83744938df793cc1$var$_require$codes.ERR_INVALID_ARG_TYPE, $83744938df793cc1$var$ERR_INVALID_ARG_VALUE = $83744938df793cc1$var$_require$codes.ERR_INVALID_ARG_VALUE, $83744938df793cc1$var$ERR_INVALID_RETURN_VALUE = $83744938df793cc1$var$_require$codes.ERR_INVALID_RETURN_VALUE, $83744938df793cc1$var$ERR_MISSING_ARGS = $83744938df793cc1$var$_require$codes.ERR_MISSING_ARGS;

var $1Nj8z = parcelRequire("1Nj8z");

var $JAxlr = parcelRequire("JAxlr");
var $83744938df793cc1$var$inspect = $JAxlr.inspect;

var $JAxlr = parcelRequire("JAxlr");
var $83744938df793cc1$require$_require$types = $JAxlr.types;
var $83744938df793cc1$var$isPromise = $83744938df793cc1$require$_require$types.isPromise, $83744938df793cc1$var$isRegExp = $83744938df793cc1$require$_require$types.isRegExp;

var $83744938df793cc1$var$objectAssign = (parcelRequire("5XaH2"))();

var $83744938df793cc1$var$objectIs = (parcelRequire("7f1SY"))();

var $83744938df793cc1$var$RegExpPrototypeTest = (parcelRequire("jLsQW"))("RegExp.prototype.test");
var $83744938df793cc1$var$errorCache = new Map();
var $83744938df793cc1$var$isDeepEqual;
var $83744938df793cc1$var$isDeepStrictEqual;
var $83744938df793cc1$var$parseExpressionAt;
var $83744938df793cc1$var$findNodeAround;
var $83744938df793cc1$var$decoder;

function $83744938df793cc1$var$lazyLoadComparison() {
    var comparison = (parcelRequire("dFslL"));
    $83744938df793cc1$var$isDeepEqual = comparison.isDeepEqual;
    $83744938df793cc1$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $83744938df793cc1$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $83744938df793cc1$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $83744938df793cc1$var$escapeFn = function escapeFn(str) {
    return $83744938df793cc1$var$meta[str.charCodeAt(0)];
};
var $83744938df793cc1$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $83744938df793cc1$var$assert = module.exports = $83744938df793cc1$var$ok;
var $83744938df793cc1$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $83744938df793cc1$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $1Nj8z(obj);
}
function $83744938df793cc1$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($83744938df793cc1$var$warned === false) {
            $83744938df793cc1$var$warned = true;
            var warn = $4TNnu.emitWarning ? $4TNnu.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $83744938df793cc1$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $1Nj8z(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$83744938df793cc1$var$assert.fail = $83744938df793cc1$var$fail;
// The AssertionError is defined in internal/error.
$83744938df793cc1$var$assert.AssertionError = $1Nj8z;
function $83744938df793cc1$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $1Nj8z({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $83744938df793cc1$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $83744938df793cc1$var$innerOk.apply(void 0, [
        $83744938df793cc1$var$ok,
        args.length
    ].concat(args));
}
$83744938df793cc1$var$assert.ok = $83744938df793cc1$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $83744938df793cc1$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$83744938df793cc1$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$83744938df793cc1$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($83744938df793cc1$var$isDeepEqual === undefined) $83744938df793cc1$var$lazyLoadComparison();
    if (!$83744938df793cc1$var$isDeepEqual(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$83744938df793cc1$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($83744938df793cc1$var$isDeepEqual === undefined) $83744938df793cc1$var$lazyLoadComparison();
    if ($83744938df793cc1$var$isDeepEqual(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $83744938df793cc1$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($83744938df793cc1$var$isDeepEqual === undefined) $83744938df793cc1$var$lazyLoadComparison();
    if (!$83744938df793cc1$var$isDeepStrictEqual(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$83744938df793cc1$var$assert.notDeepStrictEqual = $83744938df793cc1$var$notDeepStrictEqual;
function $83744938df793cc1$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($83744938df793cc1$var$isDeepEqual === undefined) $83744938df793cc1$var$lazyLoadComparison();
    if ($83744938df793cc1$var$isDeepStrictEqual(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $83744938df793cc1$var$notDeepStrictEqual
    });
}
$83744938df793cc1$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$83744938df793cc1$var$objectIs(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$83744938df793cc1$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $83744938df793cc1$var$ERR_MISSING_ARGS("actual", "expected");
    if ($83744938df793cc1$var$objectIs(actual, expected)) $83744938df793cc1$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $83744938df793cc1$var$Comparison = /*#__PURE__*/ $83744938df793cc1$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $83744938df793cc1$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $83744938df793cc1$var$isRegExp(obj[key]) && $83744938df793cc1$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $83744938df793cc1$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$83744938df793cc1$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $83744938df793cc1$var$Comparison(actual, keys);
            var b = new $83744938df793cc1$var$Comparison(expected, keys, actual);
            var err = new $1Nj8z({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $83744938df793cc1$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $83744938df793cc1$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($83744938df793cc1$var$isRegExp(expected)) return $83744938df793cc1$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($83744938df793cc1$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $1Nj8z({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $83744938df793cc1$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($83744938df793cc1$var$isDeepEqual === undefined) $83744938df793cc1$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $83744938df793cc1$var$isRegExp(expected[key]) && $83744938df793cc1$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $83744938df793cc1$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $83744938df793cc1$var$getActual(fn) {
    if (typeof fn !== "function") throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $83744938df793cc1$var$NO_EXCEPTION_SENTINEL;
}
function $83744938df793cc1$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $83744938df793cc1$var$isPromise(obj) || obj !== null && $83744938df793cc1$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $83744938df793cc1$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$83744938df793cc1$var$checkIsPromise(resultPromise)) throw new $83744938df793cc1$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($83744938df793cc1$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $83744938df793cc1$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $83744938df793cc1$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($83744938df793cc1$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $83744938df793cc1$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $83744938df793cc1$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $83744938df793cc1$var$_typeof(error) !== "object" && typeof error !== "function") throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $83744938df793cc1$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $83744938df793cc1$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$83744938df793cc1$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $83744938df793cc1$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $83744938df793cc1$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $83744938df793cc1$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $83744938df793cc1$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$83744938df793cc1$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $83744938df793cc1$var$expectsError.apply(void 0, [
        throws,
        $83744938df793cc1$var$getActual(promiseFn)
    ].concat(args));
};
$83744938df793cc1$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $83744938df793cc1$var$waitForActual(promiseFn).then(function(result) {
        return $83744938df793cc1$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$83744938df793cc1$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $83744938df793cc1$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $83744938df793cc1$var$getActual(fn)
    ].concat(args));
};
$83744938df793cc1$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $83744938df793cc1$var$waitForActual(fn).then(function(result) {
        return $83744938df793cc1$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$83744938df793cc1$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($83744938df793cc1$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $83744938df793cc1$var$inspect(err);
        var newErr = new $1Nj8z({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $83744938df793cc1$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$83744938df793cc1$var$isRegExp(regexp)) throw new $83744938df793cc1$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $83744938df793cc1$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($83744938df793cc1$var$_typeof(string), " (").concat($83744938df793cc1$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($83744938df793cc1$var$inspect(regexp), ". Input:\n\n").concat($83744938df793cc1$var$inspect(string), "\n"));
        var err = new $1Nj8z({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$83744938df793cc1$var$assert.match = function match(string, regexp, message) {
    $83744938df793cc1$var$internalMatch(string, regexp, message, match, "match");
};
$83744938df793cc1$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $83744938df793cc1$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $83744938df793cc1$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $83744938df793cc1$var$innerOk.apply(void 0, [
        $83744938df793cc1$var$strict,
        args.length
    ].concat(args));
}
$83744938df793cc1$var$assert.strict = $83744938df793cc1$var$objectAssign($83744938df793cc1$var$strict, $83744938df793cc1$var$assert, {
    equal: $83744938df793cc1$var$assert.strictEqual,
    deepEqual: $83744938df793cc1$var$assert.deepStrictEqual,
    notEqual: $83744938df793cc1$var$assert.notStrictEqual,
    notDeepEqual: $83744938df793cc1$var$assert.notDeepStrictEqual
});
$83744938df793cc1$var$assert.strict.strict = $83744938df793cc1$var$assert.strict;

});
parcelRegister("9XRIq", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $74134a85fc47d0ea$export$e45cb6485273080e; }, function (v) { return $74134a85fc47d0ea$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $74134a85fc47d0ea$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $74134a85fc47d0ea$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $74134a85fc47d0ea$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $74134a85fc47d0ea$var$_typeof(o);
}
function $74134a85fc47d0ea$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $74134a85fc47d0ea$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $74134a85fc47d0ea$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $74134a85fc47d0ea$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $74134a85fc47d0ea$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $74134a85fc47d0ea$var$_toPropertyKey(arg) {
    var key = $74134a85fc47d0ea$var$_toPrimitive(arg, "string");
    return $74134a85fc47d0ea$var$_typeof(key) === "symbol" ? key : String(key);
}
function $74134a85fc47d0ea$var$_toPrimitive(input, hint) {
    if ($74134a85fc47d0ea$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($74134a85fc47d0ea$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $74134a85fc47d0ea$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $74134a85fc47d0ea$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $74134a85fc47d0ea$var$_setPrototypeOf(subClass, superClass);
}
function $74134a85fc47d0ea$var$_setPrototypeOf(o, p) {
    $74134a85fc47d0ea$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $74134a85fc47d0ea$var$_setPrototypeOf(o, p);
}
function $74134a85fc47d0ea$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $74134a85fc47d0ea$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $74134a85fc47d0ea$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $74134a85fc47d0ea$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $74134a85fc47d0ea$var$_possibleConstructorReturn(this, result);
    };
}
function $74134a85fc47d0ea$var$_possibleConstructorReturn(self, call) {
    if (call && ($74134a85fc47d0ea$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $74134a85fc47d0ea$var$_assertThisInitialized(self);
}
function $74134a85fc47d0ea$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $74134a85fc47d0ea$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $74134a85fc47d0ea$var$_getPrototypeOf(o) {
    $74134a85fc47d0ea$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $74134a85fc47d0ea$var$_getPrototypeOf(o);
}
var $74134a85fc47d0ea$var$codes = {};
// Lazy loaded
var $74134a85fc47d0ea$var$assert;
var $74134a85fc47d0ea$var$util;
function $74134a85fc47d0ea$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $74134a85fc47d0ea$var$_inherits(NodeError, _Base);
        var _super = $74134a85fc47d0ea$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $74134a85fc47d0ea$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $74134a85fc47d0ea$var$_createClass(NodeError);
    }(Base);
    $74134a85fc47d0ea$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $74134a85fc47d0ea$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $74134a85fc47d0ea$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $74134a85fc47d0ea$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $74134a85fc47d0ea$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$74134a85fc47d0ea$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$74134a85fc47d0ea$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($74134a85fc47d0ea$var$assert === undefined) $74134a85fc47d0ea$var$assert = (parcelRequire("bhJ7Q"));
    $74134a85fc47d0ea$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $74134a85fc47d0ea$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($74134a85fc47d0ea$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($74134a85fc47d0ea$var$oneOf(expected, "type"));
    else {
        var type = $74134a85fc47d0ea$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($74134a85fc47d0ea$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($74134a85fc47d0ea$var$_typeof(actual));
    return msg;
}, TypeError);

$74134a85fc47d0ea$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($74134a85fc47d0ea$var$util === undefined) $74134a85fc47d0ea$var$util = (parcelRequire("JAxlr"));
    var inspected = $74134a85fc47d0ea$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$74134a85fc47d0ea$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($74134a85fc47d0ea$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$74134a85fc47d0ea$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($74134a85fc47d0ea$var$assert === undefined) $74134a85fc47d0ea$var$assert = (parcelRequire("bhJ7Q"));
    $74134a85fc47d0ea$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$74134a85fc47d0ea$export$e45cb6485273080e = $74134a85fc47d0ea$var$codes;

});
parcelRegister("JAxlr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4TNnu = parcelRequire("4TNnu");
var $08908b89201ce09a$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $08908b89201ce09a$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$08908b89201ce09a$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($08908b89201ce09a$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($08908b89201ce09a$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($08908b89201ce09a$var$isNull(x) || !$08908b89201ce09a$var$isObject(x)) str += " " + x;
    else str += " " + $08908b89201ce09a$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $4TNnu !== "undefined" && $4TNnu.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $4TNnu === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($4TNnu.throwDeprecation) throw new Error(msg);
            else if ($4TNnu.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $08908b89201ce09a$var$debugs = {};
var $08908b89201ce09a$var$debugEnvRegex = /^$/;
var $08908b89201ce09a$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$08908b89201ce09a$var$debugs[set]) {
        if ($08908b89201ce09a$var$debugEnvRegex.test(set)) {
            var pid = $4TNnu.pid;
            $08908b89201ce09a$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $08908b89201ce09a$var$debugs[set] = function() {};
    }
    return $08908b89201ce09a$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $08908b89201ce09a$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $08908b89201ce09a$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($08908b89201ce09a$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($08908b89201ce09a$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($08908b89201ce09a$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($08908b89201ce09a$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($08908b89201ce09a$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $08908b89201ce09a$var$stylizeWithColor;
    return $08908b89201ce09a$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $08908b89201ce09a$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$08908b89201ce09a$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$08908b89201ce09a$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $08908b89201ce09a$var$stylizeWithColor(str, styleType) {
    var style = $08908b89201ce09a$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $08908b89201ce09a$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $08908b89201ce09a$var$inspect.colors[style][1] + "m";
    else return str;
}
function $08908b89201ce09a$var$stylizeNoColor(str, styleType) {
    return str;
}
function $08908b89201ce09a$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $08908b89201ce09a$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $08908b89201ce09a$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$08908b89201ce09a$var$isString(ret)) ret = $08908b89201ce09a$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $08908b89201ce09a$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $08908b89201ce09a$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($08908b89201ce09a$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $08908b89201ce09a$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($08908b89201ce09a$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($08908b89201ce09a$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($08908b89201ce09a$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($08908b89201ce09a$var$isError(value)) return $08908b89201ce09a$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($08908b89201ce09a$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($08908b89201ce09a$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($08908b89201ce09a$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($08908b89201ce09a$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($08908b89201ce09a$var$isError(value)) base = " " + $08908b89201ce09a$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($08908b89201ce09a$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $08908b89201ce09a$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $08908b89201ce09a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $08908b89201ce09a$var$reduceToSingleString(output, base, braces);
}
function $08908b89201ce09a$var$formatPrimitive(ctx, value) {
    if ($08908b89201ce09a$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($08908b89201ce09a$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($08908b89201ce09a$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($08908b89201ce09a$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($08908b89201ce09a$var$isNull(value)) return ctx.stylize("null", "null");
}
function $08908b89201ce09a$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $08908b89201ce09a$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($08908b89201ce09a$var$hasOwnProperty(value, String(i))) output.push($08908b89201ce09a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($08908b89201ce09a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $08908b89201ce09a$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$08908b89201ce09a$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($08908b89201ce09a$var$isNull(recurseTimes)) str = $08908b89201ce09a$var$formatValue(ctx, desc.value, null);
            else str = $08908b89201ce09a$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($08908b89201ce09a$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $08908b89201ce09a$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("jX7EM"));
function $08908b89201ce09a$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $08908b89201ce09a$var$isArray;
function $08908b89201ce09a$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $08908b89201ce09a$var$isBoolean;
function $08908b89201ce09a$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $08908b89201ce09a$var$isNull;
function $08908b89201ce09a$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $08908b89201ce09a$var$isNullOrUndefined;
function $08908b89201ce09a$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $08908b89201ce09a$var$isNumber;
function $08908b89201ce09a$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $08908b89201ce09a$var$isString;
function $08908b89201ce09a$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $08908b89201ce09a$var$isSymbol;
function $08908b89201ce09a$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $08908b89201ce09a$var$isUndefined;
function $08908b89201ce09a$var$isRegExp(re) {
    return $08908b89201ce09a$var$isObject(re) && $08908b89201ce09a$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $08908b89201ce09a$var$isRegExp;
module.exports.types.isRegExp = $08908b89201ce09a$var$isRegExp;
function $08908b89201ce09a$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $08908b89201ce09a$var$isObject;
function $08908b89201ce09a$var$isDate(d) {
    return $08908b89201ce09a$var$isObject(d) && $08908b89201ce09a$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $08908b89201ce09a$var$isDate;
module.exports.types.isDate = $08908b89201ce09a$var$isDate;
function $08908b89201ce09a$var$isError(e) {
    return $08908b89201ce09a$var$isObject(e) && ($08908b89201ce09a$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $08908b89201ce09a$var$isError;
module.exports.types.isNativeError = $08908b89201ce09a$var$isError;
function $08908b89201ce09a$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $08908b89201ce09a$var$isFunction;
function $08908b89201ce09a$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $08908b89201ce09a$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("c2DqF"));
function $08908b89201ce09a$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $08908b89201ce09a$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $08908b89201ce09a$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $08908b89201ce09a$var$timestamp() {
    var d = new Date();
    var time = [
        $08908b89201ce09a$var$pad(d.getHours()),
        $08908b89201ce09a$var$pad(d.getMinutes()),
        $08908b89201ce09a$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $08908b89201ce09a$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $08908b89201ce09a$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("eSHUL"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$08908b89201ce09a$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $08908b89201ce09a$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $08908b89201ce09a$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($08908b89201ce09a$var$kCustomPromisifiedSymbol && original[$08908b89201ce09a$var$kCustomPromisifiedSymbol]) {
        var fn = original[$08908b89201ce09a$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $08908b89201ce09a$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($08908b89201ce09a$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $08908b89201ce09a$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $08908b89201ce09a$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $08908b89201ce09a$var$kCustomPromisifiedSymbol;
function $08908b89201ce09a$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $08908b89201ce09a$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4TNnu.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4TNnu.nextTick($08908b89201ce09a$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $08908b89201ce09a$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $08908b89201ce09a$var$callbackify;

});
parcelRegister("jX7EM", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $6LFJs = parcelRequire("6LFJs");

var $lhqXC = parcelRequire("lhqXC");

var $nBFK4 = parcelRequire("nBFK4");

var $htkB6 = parcelRequire("htkB6");
function $e869777d2a51d993$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $e869777d2a51d993$var$BigIntSupported = typeof BigInt !== "undefined";
var $e869777d2a51d993$var$SymbolSupported = typeof Symbol !== "undefined";
var $e869777d2a51d993$var$ObjectToString = $e869777d2a51d993$var$uncurryThis(Object.prototype.toString);
var $e869777d2a51d993$var$numberValue = $e869777d2a51d993$var$uncurryThis(Number.prototype.valueOf);
var $e869777d2a51d993$var$stringValue = $e869777d2a51d993$var$uncurryThis(String.prototype.valueOf);
var $e869777d2a51d993$var$booleanValue = $e869777d2a51d993$var$uncurryThis(Boolean.prototype.valueOf);
if ($e869777d2a51d993$var$BigIntSupported) var $e869777d2a51d993$var$bigIntValue = $e869777d2a51d993$var$uncurryThis(BigInt.prototype.valueOf);
if ($e869777d2a51d993$var$SymbolSupported) var $e869777d2a51d993$var$symbolValue = $e869777d2a51d993$var$uncurryThis(Symbol.prototype.valueOf);
function $e869777d2a51d993$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $6LFJs;
module.exports.isGeneratorFunction = $lhqXC;
module.exports.isTypedArray = $htkB6;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $e869777d2a51d993$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $e869777d2a51d993$var$isPromise;
function $e869777d2a51d993$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $htkB6(value) || $e869777d2a51d993$var$isDataView(value);
}
module.exports.isArrayBufferView = $e869777d2a51d993$var$isArrayBufferView;
function $e869777d2a51d993$var$isUint8Array(value) {
    return $nBFK4(value) === "Uint8Array";
}
module.exports.isUint8Array = $e869777d2a51d993$var$isUint8Array;
function $e869777d2a51d993$var$isUint8ClampedArray(value) {
    return $nBFK4(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $e869777d2a51d993$var$isUint8ClampedArray;
function $e869777d2a51d993$var$isUint16Array(value) {
    return $nBFK4(value) === "Uint16Array";
}
module.exports.isUint16Array = $e869777d2a51d993$var$isUint16Array;
function $e869777d2a51d993$var$isUint32Array(value) {
    return $nBFK4(value) === "Uint32Array";
}
module.exports.isUint32Array = $e869777d2a51d993$var$isUint32Array;
function $e869777d2a51d993$var$isInt8Array(value) {
    return $nBFK4(value) === "Int8Array";
}
module.exports.isInt8Array = $e869777d2a51d993$var$isInt8Array;
function $e869777d2a51d993$var$isInt16Array(value) {
    return $nBFK4(value) === "Int16Array";
}
module.exports.isInt16Array = $e869777d2a51d993$var$isInt16Array;
function $e869777d2a51d993$var$isInt32Array(value) {
    return $nBFK4(value) === "Int32Array";
}
module.exports.isInt32Array = $e869777d2a51d993$var$isInt32Array;
function $e869777d2a51d993$var$isFloat32Array(value) {
    return $nBFK4(value) === "Float32Array";
}
module.exports.isFloat32Array = $e869777d2a51d993$var$isFloat32Array;
function $e869777d2a51d993$var$isFloat64Array(value) {
    return $nBFK4(value) === "Float64Array";
}
module.exports.isFloat64Array = $e869777d2a51d993$var$isFloat64Array;
function $e869777d2a51d993$var$isBigInt64Array(value) {
    return $nBFK4(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $e869777d2a51d993$var$isBigInt64Array;
function $e869777d2a51d993$var$isBigUint64Array(value) {
    return $nBFK4(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $e869777d2a51d993$var$isBigUint64Array;
function $e869777d2a51d993$var$isMapToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object Map]";
}
$e869777d2a51d993$var$isMapToString.working = typeof Map !== "undefined" && $e869777d2a51d993$var$isMapToString(new Map());
function $e869777d2a51d993$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $e869777d2a51d993$var$isMapToString.working ? $e869777d2a51d993$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $e869777d2a51d993$var$isMap;
function $e869777d2a51d993$var$isSetToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object Set]";
}
$e869777d2a51d993$var$isSetToString.working = typeof Set !== "undefined" && $e869777d2a51d993$var$isSetToString(new Set());
function $e869777d2a51d993$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $e869777d2a51d993$var$isSetToString.working ? $e869777d2a51d993$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $e869777d2a51d993$var$isSet;
function $e869777d2a51d993$var$isWeakMapToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object WeakMap]";
}
$e869777d2a51d993$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $e869777d2a51d993$var$isWeakMapToString(new WeakMap());
function $e869777d2a51d993$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $e869777d2a51d993$var$isWeakMapToString.working ? $e869777d2a51d993$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $e869777d2a51d993$var$isWeakMap;
function $e869777d2a51d993$var$isWeakSetToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object WeakSet]";
}
$e869777d2a51d993$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $e869777d2a51d993$var$isWeakSetToString(new WeakSet());
function $e869777d2a51d993$var$isWeakSet(value) {
    return $e869777d2a51d993$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $e869777d2a51d993$var$isWeakSet;
function $e869777d2a51d993$var$isArrayBufferToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$e869777d2a51d993$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $e869777d2a51d993$var$isArrayBufferToString(new ArrayBuffer());
function $e869777d2a51d993$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $e869777d2a51d993$var$isArrayBufferToString.working ? $e869777d2a51d993$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $e869777d2a51d993$var$isArrayBuffer;
function $e869777d2a51d993$var$isDataViewToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object DataView]";
}
$e869777d2a51d993$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $e869777d2a51d993$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $e869777d2a51d993$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $e869777d2a51d993$var$isDataViewToString.working ? $e869777d2a51d993$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $e869777d2a51d993$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $e869777d2a51d993$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $e869777d2a51d993$var$isSharedArrayBufferToString(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $e869777d2a51d993$var$isSharedArrayBuffer(value) {
    if (typeof $e869777d2a51d993$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $e869777d2a51d993$var$isSharedArrayBufferToString.working === "undefined") $e869777d2a51d993$var$isSharedArrayBufferToString.working = $e869777d2a51d993$var$isSharedArrayBufferToString(new $e869777d2a51d993$var$SharedArrayBufferCopy());
    return $e869777d2a51d993$var$isSharedArrayBufferToString.working ? $e869777d2a51d993$var$isSharedArrayBufferToString(value) : value instanceof $e869777d2a51d993$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $e869777d2a51d993$var$isSharedArrayBuffer;
function $e869777d2a51d993$var$isAsyncFunction(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $e869777d2a51d993$var$isAsyncFunction;
function $e869777d2a51d993$var$isMapIterator(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $e869777d2a51d993$var$isMapIterator;
function $e869777d2a51d993$var$isSetIterator(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $e869777d2a51d993$var$isSetIterator;
function $e869777d2a51d993$var$isGeneratorObject(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $e869777d2a51d993$var$isGeneratorObject;
function $e869777d2a51d993$var$isWebAssemblyCompiledModule(value) {
    return $e869777d2a51d993$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $e869777d2a51d993$var$isWebAssemblyCompiledModule;
function $e869777d2a51d993$var$isNumberObject(value) {
    return $e869777d2a51d993$var$checkBoxedPrimitive(value, $e869777d2a51d993$var$numberValue);
}
module.exports.isNumberObject = $e869777d2a51d993$var$isNumberObject;
function $e869777d2a51d993$var$isStringObject(value) {
    return $e869777d2a51d993$var$checkBoxedPrimitive(value, $e869777d2a51d993$var$stringValue);
}
module.exports.isStringObject = $e869777d2a51d993$var$isStringObject;
function $e869777d2a51d993$var$isBooleanObject(value) {
    return $e869777d2a51d993$var$checkBoxedPrimitive(value, $e869777d2a51d993$var$booleanValue);
}
module.exports.isBooleanObject = $e869777d2a51d993$var$isBooleanObject;
function $e869777d2a51d993$var$isBigIntObject(value) {
    return $e869777d2a51d993$var$BigIntSupported && $e869777d2a51d993$var$checkBoxedPrimitive(value, $e869777d2a51d993$var$bigIntValue);
}
module.exports.isBigIntObject = $e869777d2a51d993$var$isBigIntObject;
function $e869777d2a51d993$var$isSymbolObject(value) {
    return $e869777d2a51d993$var$SymbolSupported && $e869777d2a51d993$var$checkBoxedPrimitive(value, $e869777d2a51d993$var$symbolValue);
}
module.exports.isSymbolObject = $e869777d2a51d993$var$isSymbolObject;
function $e869777d2a51d993$var$isBoxedPrimitive(value) {
    return $e869777d2a51d993$var$isNumberObject(value) || $e869777d2a51d993$var$isStringObject(value) || $e869777d2a51d993$var$isBooleanObject(value) || $e869777d2a51d993$var$isBigIntObject(value) || $e869777d2a51d993$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $e869777d2a51d993$var$isBoxedPrimitive;
function $e869777d2a51d993$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($e869777d2a51d993$var$isArrayBuffer(value) || $e869777d2a51d993$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $e869777d2a51d993$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});

parcelRegister("c2DqF", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});



parcelRegister("1Nj8z", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $4TNnu = parcelRequire("4TNnu");
"use strict";
function $14e9364b4a5cf51d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14e9364b4a5cf51d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14e9364b4a5cf51d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $14e9364b4a5cf51d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14e9364b4a5cf51d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14e9364b4a5cf51d$var$_defineProperty(obj, key, value) {
    key = $14e9364b4a5cf51d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14e9364b4a5cf51d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $14e9364b4a5cf51d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $14e9364b4a5cf51d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $14e9364b4a5cf51d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $14e9364b4a5cf51d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $14e9364b4a5cf51d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $14e9364b4a5cf51d$var$_toPropertyKey(arg) {
    var key = $14e9364b4a5cf51d$var$_toPrimitive(arg, "string");
    return $14e9364b4a5cf51d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $14e9364b4a5cf51d$var$_toPrimitive(input, hint) {
    if ($14e9364b4a5cf51d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($14e9364b4a5cf51d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $14e9364b4a5cf51d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $14e9364b4a5cf51d$var$_setPrototypeOf(subClass, superClass);
}
function $14e9364b4a5cf51d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $14e9364b4a5cf51d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $14e9364b4a5cf51d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $14e9364b4a5cf51d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $14e9364b4a5cf51d$var$_possibleConstructorReturn(this, result);
    };
}
function $14e9364b4a5cf51d$var$_possibleConstructorReturn(self, call) {
    if (call && ($14e9364b4a5cf51d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $14e9364b4a5cf51d$var$_assertThisInitialized(self);
}
function $14e9364b4a5cf51d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $14e9364b4a5cf51d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $14e9364b4a5cf51d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$14e9364b4a5cf51d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $14e9364b4a5cf51d$var$_construct(Class, arguments, $14e9364b4a5cf51d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $14e9364b4a5cf51d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $14e9364b4a5cf51d$var$_wrapNativeSuper(Class);
}
function $14e9364b4a5cf51d$var$_construct(Parent, args, Class) {
    if ($14e9364b4a5cf51d$var$_isNativeReflectConstruct()) $14e9364b4a5cf51d$var$_construct = Reflect.construct.bind();
    else $14e9364b4a5cf51d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $14e9364b4a5cf51d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $14e9364b4a5cf51d$var$_construct.apply(null, arguments);
}
function $14e9364b4a5cf51d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $14e9364b4a5cf51d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $14e9364b4a5cf51d$var$_setPrototypeOf(o, p) {
    $14e9364b4a5cf51d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $14e9364b4a5cf51d$var$_setPrototypeOf(o, p);
}
function $14e9364b4a5cf51d$var$_getPrototypeOf(o) {
    $14e9364b4a5cf51d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $14e9364b4a5cf51d$var$_getPrototypeOf(o);
}
function $14e9364b4a5cf51d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $14e9364b4a5cf51d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $14e9364b4a5cf51d$var$_typeof(o);
}

var $JAxlr = parcelRequire("JAxlr");
var $14e9364b4a5cf51d$var$inspect = $JAxlr.inspect;

var $9XRIq = parcelRequire("9XRIq");
var $14e9364b4a5cf51d$var$ERR_INVALID_ARG_TYPE = $9XRIq.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $14e9364b4a5cf51d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $14e9364b4a5cf51d$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $14e9364b4a5cf51d$var$blue = "";
var $14e9364b4a5cf51d$var$green = "";
var $14e9364b4a5cf51d$var$red = "";
var $14e9364b4a5cf51d$var$white = "";
var $14e9364b4a5cf51d$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $14e9364b4a5cf51d$var$kMaxShortLength = 10;
function $14e9364b4a5cf51d$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $14e9364b4a5cf51d$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $14e9364b4a5cf51d$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $14e9364b4a5cf51d$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $14e9364b4a5cf51d$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $14e9364b4a5cf51d$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $14e9364b4a5cf51d$var$_typeof(actual) === "object" && $14e9364b4a5cf51d$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $14e9364b4a5cf51d$var$kMaxShortLength) {
            if (($14e9364b4a5cf51d$var$_typeof(actual) !== "object" || actual === null) && ($14e9364b4a5cf51d$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($14e9364b4a5cf51d$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $4TNnu.stderr && $4TNnu.stderr.isTTY ? $4TNnu.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($14e9364b4a5cf51d$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($14e9364b4a5cf51d$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $14e9364b4a5cf51d$var$kReadableOperator[operator] + "\n".concat($14e9364b4a5cf51d$var$green, "+ actual").concat($14e9364b4a5cf51d$var$white, " ").concat($14e9364b4a5cf51d$var$red, "- expected").concat($14e9364b4a5cf51d$var$white);
    var skippedMsg = " ".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($14e9364b4a5cf51d$var$red, "-").concat($14e9364b4a5cf51d$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($14e9364b4a5cf51d$var$green, "+").concat($14e9364b4a5cf51d$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$14e9364b4a5cf51d$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $14e9364b4a5cf51d$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($14e9364b4a5cf51d$var$green, "+").concat($14e9364b4a5cf51d$var$white, " ").concat(actualLine);
                other += "\n".concat($14e9364b4a5cf51d$var$red, "-").concat($14e9364b4a5cf51d$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white).concat(other, "\n") + "".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $14e9364b4a5cf51d$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $14e9364b4a5cf51d$var$_inherits(AssertionError, _Error);
    var _super = $14e9364b4a5cf51d$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $14e9364b4a5cf51d$var$_classCallCheck(this, AssertionError);
        if ($14e9364b4a5cf51d$var$_typeof(options) !== "object" || options === null) throw new $14e9364b4a5cf51d$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($4TNnu.stderr && $4TNnu.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($4TNnu.stderr && $4TNnu.stderr.getColorDepth && $4TNnu.stderr.getColorDepth() !== 1) {
                    $14e9364b4a5cf51d$var$blue = "\x1b[34m";
                    $14e9364b4a5cf51d$var$green = "\x1b[32m";
                    $14e9364b4a5cf51d$var$white = "\x1b[39m";
                    $14e9364b4a5cf51d$var$red = "\x1b[31m";
                } else {
                    $14e9364b4a5cf51d$var$blue = "";
                    $14e9364b4a5cf51d$var$green = "";
                    $14e9364b4a5cf51d$var$white = "";
                    $14e9364b4a5cf51d$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($14e9364b4a5cf51d$var$_typeof(actual) === "object" && actual !== null && $14e9364b4a5cf51d$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $14e9364b4a5cf51d$var$copyError(actual);
                expected = $14e9364b4a5cf51d$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $14e9364b4a5cf51d$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $14e9364b4a5cf51d$var$kReadableOperator[operator];
                var res = $14e9364b4a5cf51d$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $14e9364b4a5cf51d$var$_typeof(actual) === "object" && actual !== null) base = $14e9364b4a5cf51d$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($14e9364b4a5cf51d$var$blue, "...").concat($14e9364b4a5cf51d$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $14e9364b4a5cf51d$var$inspectValue(actual);
                var other = "";
                var knownOperators = $14e9364b4a5cf51d$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($14e9364b4a5cf51d$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($14e9364b4a5cf51d$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($14e9364b4a5cf51d$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($14e9364b4a5cf51d$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $14e9364b4a5cf51d$var$_possibleConstructorReturn(_this);
    }
    $14e9364b4a5cf51d$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $14e9364b4a5cf51d$var$inspect(this, $14e9364b4a5cf51d$var$_objectSpread($14e9364b4a5cf51d$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $14e9364b4a5cf51d$var$_wrapNativeSuper(Error), $14e9364b4a5cf51d$var$inspect.custom);
module.exports = $14e9364b4a5cf51d$var$AssertionError;

});

parcelRegister("5XaH2", function(module, exports) {
"use strict";

var $gJTvG = parcelRequire("gJTvG");
var $455ac1e1527f875e$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $455ac1e1527f875e$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $gJTvG;
    if ($455ac1e1527f875e$var$lacksProperEnumerationOrder()) return $gJTvG;
    if ($455ac1e1527f875e$var$assignHasPendingExceptions()) return $gJTvG;
    return Object.assign;
};

});
parcelRegister("gJTvG", function(module, exports) {
"use strict";

var $lTDqP = parcelRequire("lTDqP");

var $c2fbe873323b95d2$var$hasSymbols = (parcelRequire("4onDj"))();

var $bWSVx = parcelRequire("bWSVx");
var $c2fbe873323b95d2$var$toObject = Object;
var $c2fbe873323b95d2$var$$push = $bWSVx("Array.prototype.push");
var $c2fbe873323b95d2$var$$propIsEnumerable = $bWSVx("Object.prototype.propertyIsEnumerable");
var $c2fbe873323b95d2$var$originalGetSymbols = $c2fbe873323b95d2$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $c2fbe873323b95d2$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $c2fbe873323b95d2$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $lTDqP(from);
        var getSymbols = $c2fbe873323b95d2$var$hasSymbols && (Object.getOwnPropertySymbols || $c2fbe873323b95d2$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($c2fbe873323b95d2$var$$propIsEnumerable(from, key)) $c2fbe873323b95d2$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($c2fbe873323b95d2$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("lTDqP", function(module, exports) {
"use strict";
var $ff0d52530ad179f5$var$slice = Array.prototype.slice;

var $cqifw = parcelRequire("cqifw");
var $ff0d52530ad179f5$var$origKeys = Object.keys;

var $ff0d52530ad179f5$var$keysShim = $ff0d52530ad179f5$var$origKeys ? function keys(o) {
    return $ff0d52530ad179f5$var$origKeys(o);
} : (parcelRequire("2HCYb"));
var $ff0d52530ad179f5$var$originalKeys = Object.keys;
$ff0d52530ad179f5$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($cqifw(object)) return $ff0d52530ad179f5$var$originalKeys($ff0d52530ad179f5$var$slice.call(object));
            return $ff0d52530ad179f5$var$originalKeys(object);
        };
    } else Object.keys = $ff0d52530ad179f5$var$keysShim;
    return Object.keys || $ff0d52530ad179f5$var$keysShim;
};
module.exports = $ff0d52530ad179f5$var$keysShim;

});
parcelRegister("cqifw", function(module, exports) {
"use strict";
var $90b611aa4982c4db$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $90b611aa4982c4db$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $90b611aa4982c4db$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("2HCYb", function(module, exports) {
"use strict";
var $1f7dd37c88a3e4eb$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $1f7dd37c88a3e4eb$var$has = Object.prototype.hasOwnProperty;
    var $1f7dd37c88a3e4eb$var$toStr = Object.prototype.toString;
    var $1f7dd37c88a3e4eb$var$isArgs = (parcelRequire("cqifw")); // eslint-disable-line global-require
    var $1f7dd37c88a3e4eb$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $1f7dd37c88a3e4eb$var$hasDontEnumBug = !$1f7dd37c88a3e4eb$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $1f7dd37c88a3e4eb$var$hasProtoEnumBug = $1f7dd37c88a3e4eb$var$isEnumerable.call(function() {}, "prototype");
    var $1f7dd37c88a3e4eb$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $1f7dd37c88a3e4eb$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $1f7dd37c88a3e4eb$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$1f7dd37c88a3e4eb$var$excludedKeys["$" + k] && $1f7dd37c88a3e4eb$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$1f7dd37c88a3e4eb$var$hasAutomationEqualityBug) return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        try {
            return $1f7dd37c88a3e4eb$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $1f7dd37c88a3e4eb$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object Function]";
        var isArguments = $1f7dd37c88a3e4eb$var$isArgs(object);
        var isString = isObject && $1f7dd37c88a3e4eb$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $1f7dd37c88a3e4eb$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$1f7dd37c88a3e4eb$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $1f7dd37c88a3e4eb$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($1f7dd37c88a3e4eb$var$hasDontEnumBug) {
            var skipConstructor = $1f7dd37c88a3e4eb$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $1f7dd37c88a3e4eb$var$dontEnums.length; ++k)if (!(skipConstructor && $1f7dd37c88a3e4eb$var$dontEnums[k] === "constructor") && $1f7dd37c88a3e4eb$var$has.call(object, $1f7dd37c88a3e4eb$var$dontEnums[k])) theKeys.push($1f7dd37c88a3e4eb$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $1f7dd37c88a3e4eb$var$keysShim;

});


parcelRegister("4onDj", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});

parcelRegister("bWSVx", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");

var $cOyNq = parcelRequire("cOyNq");
var $8b2fb7de28a518d3$var$$indexOf = $cOyNq($avqmt("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $avqmt(name, !!allowMissing);
    if (typeof intrinsic === "function" && $8b2fb7de28a518d3$var$$indexOf(name, ".prototype.") > -1) return $cOyNq(intrinsic);
    return intrinsic;
};

});
parcelRegister("avqmt", function(module, exports) {
"use strict";
var $7a613f7503e09dde$var$undefined1;
var $7a613f7503e09dde$var$$SyntaxError = SyntaxError;
var $7a613f7503e09dde$var$$Function = Function;
var $7a613f7503e09dde$var$$TypeError = TypeError;
// eslint-disable-next-line consistent-return
var $7a613f7503e09dde$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $7a613f7503e09dde$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $7a613f7503e09dde$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($7a613f7503e09dde$var$$gOPD) try {
    $7a613f7503e09dde$var$$gOPD({}, "");
} catch (e) {
    $7a613f7503e09dde$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $7a613f7503e09dde$var$throwTypeError = function() {
    throw new $7a613f7503e09dde$var$$TypeError();
};
var $7a613f7503e09dde$var$ThrowTypeError = $7a613f7503e09dde$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $7a613f7503e09dde$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $7a613f7503e09dde$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $7a613f7503e09dde$var$throwTypeError;
        }
    }
}() : $7a613f7503e09dde$var$throwTypeError;

var $7a613f7503e09dde$var$hasSymbols = (parcelRequire("hExmX"))();

var $7a613f7503e09dde$var$hasProto = (parcelRequire("1q0DH"))();
var $7a613f7503e09dde$var$getProto = Object.getPrototypeOf || ($7a613f7503e09dde$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $7a613f7503e09dde$var$needsEval = {};
var $7a613f7503e09dde$var$TypedArray = typeof Uint8Array === "undefined" || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(Uint8Array);
var $7a613f7503e09dde$var$INTRINSICS = {
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGenerator%": $7a613f7503e09dde$var$needsEval,
    "%AsyncGeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%AsyncIteratorPrototype%": $7a613f7503e09dde$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": Error,
    "%eval%": eval,
    "%EvalError%": EvalError,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $7a613f7503e09dde$var$$Function,
    "%GeneratorFunction%": $7a613f7503e09dde$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": RangeError,
    "%ReferenceError%": ReferenceError,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$7a613f7503e09dde$var$hasSymbols || !$7a613f7503e09dde$var$getProto ? undefined : $7a613f7503e09dde$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $7a613f7503e09dde$var$hasSymbols && $7a613f7503e09dde$var$getProto ? $7a613f7503e09dde$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $7a613f7503e09dde$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $7a613f7503e09dde$var$$SyntaxError,
    "%ThrowTypeError%": $7a613f7503e09dde$var$ThrowTypeError,
    "%TypedArray%": $7a613f7503e09dde$var$TypedArray,
    "%TypeError%": $7a613f7503e09dde$var$$TypeError,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": URIError,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($7a613f7503e09dde$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $7a613f7503e09dde$var$errorProto = $7a613f7503e09dde$var$getProto($7a613f7503e09dde$var$getProto(e));
    $7a613f7503e09dde$var$INTRINSICS["%Error.prototype%"] = $7a613f7503e09dde$var$errorProto;
}
var $7a613f7503e09dde$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $7a613f7503e09dde$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $7a613f7503e09dde$var$getProto) value = $7a613f7503e09dde$var$getProto(gen.prototype);
    }
    $7a613f7503e09dde$var$INTRINSICS[name] = value;
    return value;
};
var $7a613f7503e09dde$var$LEGACY_ALIASES = {
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $bMCYV = parcelRequire("bMCYV");

var $7Dte4 = parcelRequire("7Dte4");
var $7a613f7503e09dde$var$$concat = $bMCYV.call(Function.call, Array.prototype.concat);
var $7a613f7503e09dde$var$$spliceApply = $bMCYV.call(Function.apply, Array.prototype.splice);
var $7a613f7503e09dde$var$$replace = $bMCYV.call(Function.call, String.prototype.replace);
var $7a613f7503e09dde$var$$strSlice = $bMCYV.call(Function.call, String.prototype.slice);
var $7a613f7503e09dde$var$$exec = $bMCYV.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $7a613f7503e09dde$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $7a613f7503e09dde$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $7a613f7503e09dde$var$stringToPath = function stringToPath(string) {
    var first = $7a613f7503e09dde$var$$strSlice(string, 0, 1);
    var last = $7a613f7503e09dde$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $7a613f7503e09dde$var$$SyntaxError("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $7a613f7503e09dde$var$$replace(string, $7a613f7503e09dde$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $7a613f7503e09dde$var$$replace(subString, $7a613f7503e09dde$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $7a613f7503e09dde$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($7Dte4($7a613f7503e09dde$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $7a613f7503e09dde$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicName)) {
        var value = $7a613f7503e09dde$var$INTRINSICS[intrinsicName];
        if (value === $7a613f7503e09dde$var$needsEval) value = $7a613f7503e09dde$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $7a613f7503e09dde$var$$TypeError("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $7a613f7503e09dde$var$$SyntaxError("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $7a613f7503e09dde$var$$TypeError("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $7a613f7503e09dde$var$$TypeError('"allowMissing" argument must be a boolean');
    if ($7a613f7503e09dde$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $7a613f7503e09dde$var$$SyntaxError("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $7a613f7503e09dde$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $7a613f7503e09dde$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $7a613f7503e09dde$var$$spliceApply(parts, $7a613f7503e09dde$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $7a613f7503e09dde$var$$strSlice(part, 0, 1);
        var last = $7a613f7503e09dde$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $7a613f7503e09dde$var$$SyntaxError("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($7Dte4($7a613f7503e09dde$var$INTRINSICS, intrinsicRealName)) value = $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $7a613f7503e09dde$var$$TypeError("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($7a613f7503e09dde$var$$gOPD && i + 1 >= parts.length) {
                var desc = $7a613f7503e09dde$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $7Dte4(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $7a613f7503e09dde$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("hExmX", function(module, exports) {
"use strict";
var $cda00e83f51ced00$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $5meeV = parcelRequire("5meeV");
module.exports = function hasNativeSymbols() {
    if (typeof $cda00e83f51ced00$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $cda00e83f51ced00$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $5meeV();
};

});
parcelRegister("5meeV", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("1q0DH", function(module, exports) {
"use strict";
var $1088b720f9e31113$var$test = {
    foo: {}
};
var $1088b720f9e31113$var$$Object = Object;
module.exports = function hasProto() {
    return ({
        __proto__: $1088b720f9e31113$var$test
    }).foo === $1088b720f9e31113$var$test.foo && !(({
        __proto__: null
    }) instanceof $1088b720f9e31113$var$$Object);
};

});

parcelRegister("bMCYV", function(module, exports) {
"use strict";

var $5RMz0 = parcelRequire("5RMz0");
module.exports = Function.prototype.bind || $5RMz0;

});
parcelRegister("5RMz0", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $445792b3d22035e9$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $445792b3d22035e9$var$toStr = Object.prototype.toString;
var $445792b3d22035e9$var$max = Math.max;
var $445792b3d22035e9$var$funcType = "[object Function]";
var $445792b3d22035e9$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $445792b3d22035e9$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $445792b3d22035e9$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $445792b3d22035e9$var$toStr.apply(target) !== $445792b3d22035e9$var$funcType) throw new TypeError($445792b3d22035e9$var$ERROR_MESSAGE + target);
    var args = $445792b3d22035e9$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $445792b3d22035e9$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $445792b3d22035e9$var$concatty(args, arguments));
    };
    var boundLength = $445792b3d22035e9$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $445792b3d22035e9$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("7Dte4", function(module, exports) {
"use strict";
var $58f2d89a35f5270b$var$call = Function.prototype.call;
var $58f2d89a35f5270b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $7PMsQ = parcelRequire("7PMsQ");
/** @type {(o: {}, p: PropertyKey) => p is keyof o} */ module.exports = $7PMsQ.call($58f2d89a35f5270b$var$call, $58f2d89a35f5270b$var$$hasOwn);

});
parcelRegister("7PMsQ", function(module, exports) {
"use strict";

var $kIaTV = parcelRequire("kIaTV");
module.exports = Function.prototype.bind || $kIaTV;

});
parcelRegister("kIaTV", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $f1405f69c53ed081$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $f1405f69c53ed081$var$toStr = Object.prototype.toString;
var $f1405f69c53ed081$var$max = Math.max;
var $f1405f69c53ed081$var$funcType = "[object Function]";
var $f1405f69c53ed081$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $f1405f69c53ed081$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $f1405f69c53ed081$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $f1405f69c53ed081$var$toStr.apply(target) !== $f1405f69c53ed081$var$funcType) throw new TypeError($f1405f69c53ed081$var$ERROR_MESSAGE + target);
    var args = $f1405f69c53ed081$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $f1405f69c53ed081$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $f1405f69c53ed081$var$concatty(args, arguments));
    };
    var boundLength = $f1405f69c53ed081$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $f1405f69c53ed081$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});




parcelRegister("cOyNq", function(module, exports) {
"use strict";

var $3qk4K = parcelRequire("3qk4K");

var $avqmt = parcelRequire("avqmt");

var $64wPI = parcelRequire("64wPI");
var $954525547e6d848e$var$$TypeError = $avqmt("%TypeError%");
var $954525547e6d848e$var$$apply = $avqmt("%Function.prototype.apply%");
var $954525547e6d848e$var$$call = $avqmt("%Function.prototype.call%");
var $954525547e6d848e$var$$reflectApply = $avqmt("%Reflect.apply%", true) || $3qk4K.call($954525547e6d848e$var$$call, $954525547e6d848e$var$$apply);
var $954525547e6d848e$var$$defineProperty = $avqmt("%Object.defineProperty%", true);
var $954525547e6d848e$var$$max = $avqmt("%Math.max%");
if ($954525547e6d848e$var$$defineProperty) try {
    $954525547e6d848e$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $954525547e6d848e$var$$defineProperty = null;
}
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $954525547e6d848e$var$$TypeError("a function is required");
    var func = $954525547e6d848e$var$$reflectApply($3qk4K, $954525547e6d848e$var$$call, arguments);
    return $64wPI(func, 1 + $954525547e6d848e$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $954525547e6d848e$var$applyBind = function applyBind() {
    return $954525547e6d848e$var$$reflectApply($3qk4K, $954525547e6d848e$var$$apply, arguments);
};
if ($954525547e6d848e$var$$defineProperty) $954525547e6d848e$var$$defineProperty(module.exports, "apply", {
    value: $954525547e6d848e$var$applyBind
});
else module.exports.apply = $954525547e6d848e$var$applyBind;

});
parcelRegister("3qk4K", function(module, exports) {
"use strict";

var $aIMHO = parcelRequire("aIMHO");
module.exports = Function.prototype.bind || $aIMHO;

});
parcelRegister("aIMHO", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $7ce3cb5ef638d980$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $7ce3cb5ef638d980$var$toStr = Object.prototype.toString;
var $7ce3cb5ef638d980$var$max = Math.max;
var $7ce3cb5ef638d980$var$funcType = "[object Function]";
var $7ce3cb5ef638d980$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $7ce3cb5ef638d980$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $7ce3cb5ef638d980$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $7ce3cb5ef638d980$var$toStr.apply(target) !== $7ce3cb5ef638d980$var$funcType) throw new TypeError($7ce3cb5ef638d980$var$ERROR_MESSAGE + target);
    var args = $7ce3cb5ef638d980$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $7ce3cb5ef638d980$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $7ce3cb5ef638d980$var$concatty(args, arguments));
    };
    var boundLength = $7ce3cb5ef638d980$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $7ce3cb5ef638d980$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("64wPI", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");

var $26m4v = parcelRequire("26m4v");

var $46bc95c30a58fa4c$var$hasDescriptors = (parcelRequire("73hDB"))();

var $crSdH = parcelRequire("crSdH");
var $46bc95c30a58fa4c$var$$TypeError = $avqmt("%TypeError%");
var $46bc95c30a58fa4c$var$$floor = $avqmt("%Math.floor%");
/** @typedef {(...args: unknown[]) => unknown} Func */ /** @type {<T extends Func = Func>(fn: T, length: number, loose?: boolean) => T} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $46bc95c30a58fa4c$var$$TypeError("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $46bc95c30a58fa4c$var$$floor(length) !== length) throw new $46bc95c30a58fa4c$var$$TypeError("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $crSdH) {
        var desc = $crSdH(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($46bc95c30a58fa4c$var$hasDescriptors) $26m4v(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $26m4v(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("26m4v", function(module, exports) {
"use strict";

var $187d4346b4af3633$var$hasPropertyDescriptors = (parcelRequire("73hDB"))();

var $avqmt = parcelRequire("avqmt");
var $187d4346b4af3633$var$$defineProperty = $187d4346b4af3633$var$hasPropertyDescriptors && $avqmt("%Object.defineProperty%", true);
if ($187d4346b4af3633$var$$defineProperty) try {
    $187d4346b4af3633$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $187d4346b4af3633$var$$defineProperty = false;
}
var $187d4346b4af3633$var$$SyntaxError = $avqmt("%SyntaxError%");
var $187d4346b4af3633$var$$TypeError = $avqmt("%TypeError%");

var $crSdH = parcelRequire("crSdH");
/** @type {(obj: Record<PropertyKey, unknown>, property: PropertyKey, value: unknown, nonEnumerable?: boolean | null, nonWritable?: boolean | null, nonConfigurable?: boolean | null, loose?: boolean) => void} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $187d4346b4af3633$var$$TypeError("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $187d4346b4af3633$var$$TypeError("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $187d4346b4af3633$var$$TypeError("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $187d4346b4af3633$var$$TypeError("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$crSdH && $crSdH(obj, property);
    if ($187d4346b4af3633$var$$defineProperty) $187d4346b4af3633$var$$defineProperty(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $187d4346b4af3633$var$$SyntaxError("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("73hDB", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $52267eb4294466ed$var$$defineProperty = $avqmt("%Object.defineProperty%", true);
var $52267eb4294466ed$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    if ($52267eb4294466ed$var$$defineProperty) try {
        $52267eb4294466ed$var$$defineProperty({}, "a", {
            value: 1
        });
        return true;
    } catch (e) {
        // IE 8 has a broken defineProperty
        return false;
    }
    return false;
};
$52267eb4294466ed$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$52267eb4294466ed$var$hasPropertyDescriptors()) return null;
    try {
        return $52267eb4294466ed$var$$defineProperty([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $52267eb4294466ed$var$hasPropertyDescriptors;

});

parcelRegister("crSdH", function(module, exports) {
"use strict";

var $avqmt = parcelRequire("avqmt");
var $9102109fbf1ea315$var$$gOPD = $avqmt("%Object.getOwnPropertyDescriptor%", true);
if ($9102109fbf1ea315$var$$gOPD) try {
    $9102109fbf1ea315$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $9102109fbf1ea315$var$$gOPD = null;
}
module.exports = $9102109fbf1ea315$var$$gOPD;

});







parcelRegister("7f1SY", function(module, exports) {
"use strict";

var $5kJ8M = parcelRequire("5kJ8M");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $5kJ8M;
};

});
parcelRegister("5kJ8M", function(module, exports) {
"use strict";
var $3e21d5fcadc285da$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($3e21d5fcadc285da$var$numberIsNaN(a) && $3e21d5fcadc285da$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("dFslL", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $9f3518710c51c339$var$_slicedToArray(arr, i) {
    return $9f3518710c51c339$var$_arrayWithHoles(arr) || $9f3518710c51c339$var$_iterableToArrayLimit(arr, i) || $9f3518710c51c339$var$_unsupportedIterableToArray(arr, i) || $9f3518710c51c339$var$_nonIterableRest();
}
function $9f3518710c51c339$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9f3518710c51c339$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9f3518710c51c339$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9f3518710c51c339$var$_arrayLikeToArray(o, minLen);
}
function $9f3518710c51c339$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9f3518710c51c339$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $9f3518710c51c339$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $9f3518710c51c339$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9f3518710c51c339$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9f3518710c51c339$var$_typeof(o);
}
var $9f3518710c51c339$var$regexFlagsSupported = /a/g.flags !== undefined;
var $9f3518710c51c339$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $9f3518710c51c339$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $9f3518710c51c339$var$objectIs = Object.is ? Object.is : (parcelRequire("fmpVL"));
var $9f3518710c51c339$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $9f3518710c51c339$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("4GuR1"));
function $9f3518710c51c339$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $9f3518710c51c339$var$hasOwnProperty = $9f3518710c51c339$var$uncurryThis(Object.prototype.hasOwnProperty);
var $9f3518710c51c339$var$propertyIsEnumerable = $9f3518710c51c339$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $9f3518710c51c339$var$objectToString = $9f3518710c51c339$var$uncurryThis(Object.prototype.toString);

var $JAxlr = parcelRequire("JAxlr");
var $9f3518710c51c339$require$_require$types = $JAxlr.types;
var $9f3518710c51c339$var$isAnyArrayBuffer = $9f3518710c51c339$require$_require$types.isAnyArrayBuffer, $9f3518710c51c339$var$isArrayBufferView = $9f3518710c51c339$require$_require$types.isArrayBufferView, $9f3518710c51c339$var$isDate = $9f3518710c51c339$require$_require$types.isDate, $9f3518710c51c339$var$isMap = $9f3518710c51c339$require$_require$types.isMap, $9f3518710c51c339$var$isRegExp = $9f3518710c51c339$require$_require$types.isRegExp, $9f3518710c51c339$var$isSet = $9f3518710c51c339$require$_require$types.isSet, $9f3518710c51c339$var$isNativeError = $9f3518710c51c339$require$_require$types.isNativeError, $9f3518710c51c339$var$isBoxedPrimitive = $9f3518710c51c339$require$_require$types.isBoxedPrimitive, $9f3518710c51c339$var$isNumberObject = $9f3518710c51c339$require$_require$types.isNumberObject, $9f3518710c51c339$var$isStringObject = $9f3518710c51c339$require$_require$types.isStringObject, $9f3518710c51c339$var$isBooleanObject = $9f3518710c51c339$require$_require$types.isBooleanObject, $9f3518710c51c339$var$isBigIntObject = $9f3518710c51c339$require$_require$types.isBigIntObject, $9f3518710c51c339$var$isSymbolObject = $9f3518710c51c339$require$_require$types.isSymbolObject, $9f3518710c51c339$var$isFloat32Array = $9f3518710c51c339$require$_require$types.isFloat32Array, $9f3518710c51c339$var$isFloat64Array = $9f3518710c51c339$require$_require$types.isFloat64Array;
function $9f3518710c51c339$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $9f3518710c51c339$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($9f3518710c51c339$var$isNonIndex).concat($9f3518710c51c339$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $9f3518710c51c339$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $9f3518710c51c339$var$ONLY_ENUMERABLE = undefined;
var $9f3518710c51c339$var$kStrict = true;
var $9f3518710c51c339$var$kLoose = false;
var $9f3518710c51c339$var$kNoIterator = 0;
var $9f3518710c51c339$var$kIsArray = 1;
var $9f3518710c51c339$var$kIsSet = 2;
var $9f3518710c51c339$var$kIsMap = 3;
// Check if they have the same source and flags
function $9f3518710c51c339$var$areSimilarRegExps(a, b) {
    return $9f3518710c51c339$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $9f3518710c51c339$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $9f3518710c51c339$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $9f3518710c51c339$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $9f3518710c51c339$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $9f3518710c51c339$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $9f3518710c51c339$var$isEqualBoxedPrimitive(val1, val2) {
    if ($9f3518710c51c339$var$isNumberObject(val1)) return $9f3518710c51c339$var$isNumberObject(val2) && $9f3518710c51c339$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($9f3518710c51c339$var$isStringObject(val1)) return $9f3518710c51c339$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($9f3518710c51c339$var$isBooleanObject(val1)) return $9f3518710c51c339$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($9f3518710c51c339$var$isBigIntObject(val1)) return $9f3518710c51c339$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $9f3518710c51c339$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $9f3518710c51c339$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $9f3518710c51c339$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($9f3518710c51c339$var$_typeof(val1) !== "object") return typeof val1 === "number" && $9f3518710c51c339$var$numberIsNaN(val1) && $9f3518710c51c339$var$numberIsNaN(val2);
        if ($9f3518710c51c339$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $9f3518710c51c339$var$_typeof(val1) !== "object") {
            if (val2 === null || $9f3518710c51c339$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $9f3518710c51c339$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $9f3518710c51c339$var$objectToString(val1);
    var val2Tag = $9f3518710c51c339$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $9f3518710c51c339$var$getOwnNonIndexProperties(val1, $9f3518710c51c339$var$ONLY_ENUMERABLE);
        var keys2 = $9f3518710c51c339$var$getOwnNonIndexProperties(val2, $9f3518710c51c339$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, $9f3518710c51c339$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$9f3518710c51c339$var$isMap(val1) && $9f3518710c51c339$var$isMap(val2) || !$9f3518710c51c339$var$isSet(val1) && $9f3518710c51c339$var$isSet(val2)) return false;
    }
    if ($9f3518710c51c339$var$isDate(val1)) {
        if (!$9f3518710c51c339$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($9f3518710c51c339$var$isRegExp(val1)) {
        if (!$9f3518710c51c339$var$isRegExp(val2) || !$9f3518710c51c339$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($9f3518710c51c339$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($9f3518710c51c339$var$isArrayBufferView(val1)) {
        if (!strict && ($9f3518710c51c339$var$isFloat32Array(val1) || $9f3518710c51c339$var$isFloat64Array(val1))) {
            if (!$9f3518710c51c339$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$9f3518710c51c339$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $9f3518710c51c339$var$getOwnNonIndexProperties(val1, $9f3518710c51c339$var$ONLY_ENUMERABLE);
        var _keys2 = $9f3518710c51c339$var$getOwnNonIndexProperties(val2, $9f3518710c51c339$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, $9f3518710c51c339$var$kNoIterator, _keys);
    } else if ($9f3518710c51c339$var$isSet(val1)) {
        if (!$9f3518710c51c339$var$isSet(val2) || val1.size !== val2.size) return false;
        return $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, $9f3518710c51c339$var$kIsSet);
    } else if ($9f3518710c51c339$var$isMap(val1)) {
        if (!$9f3518710c51c339$var$isMap(val2) || val1.size !== val2.size) return false;
        return $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, $9f3518710c51c339$var$kIsMap);
    } else if ($9f3518710c51c339$var$isAnyArrayBuffer(val1)) {
        if (!$9f3518710c51c339$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($9f3518710c51c339$var$isBoxedPrimitive(val1) && !$9f3518710c51c339$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, $9f3518710c51c339$var$kNoIterator);
}
function $9f3518710c51c339$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $9f3518710c51c339$var$propertyIsEnumerable(val, k);
    });
}
function $9f3518710c51c339$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$9f3518710c51c339$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $9f3518710c51c339$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($9f3518710c51c339$var$propertyIsEnumerable(val1, key)) {
                    if (!$9f3518710c51c339$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($9f3518710c51c339$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $9f3518710c51c339$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $9f3518710c51c339$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $9f3518710c51c339$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $9f3518710c51c339$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $9f3518710c51c339$var$kNoIterator || iterationType === $9f3518710c51c339$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $9f3518710c51c339$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $9f3518710c51c339$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $9f3518710c51c339$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($9f3518710c51c339$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $9f3518710c51c339$var$findLooseMatchingPrimitives(prim) {
    switch($9f3518710c51c339$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($9f3518710c51c339$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $9f3518710c51c339$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $9f3518710c51c339$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $9f3518710c51c339$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $9f3518710c51c339$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$9f3518710c51c339$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $9f3518710c51c339$var$innerDeepEqual(item, curB, false, memo);
}
function $9f3518710c51c339$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $9f3518710c51c339$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($9f3518710c51c339$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$9f3518710c51c339$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $9f3518710c51c339$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($9f3518710c51c339$var$_typeof(_val) === "object" && _val !== null) {
                if (!$9f3518710c51c339$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$9f3518710c51c339$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9f3518710c51c339$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $9f3518710c51c339$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($9f3518710c51c339$var$innerDeepEqual(key1, key2, strict, memo) && $9f3518710c51c339$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $9f3518710c51c339$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $9f3518710c51c339$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $9f3518710c51c339$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($9f3518710c51c339$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$9f3518710c51c339$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$9f3518710c51c339$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $9f3518710c51c339$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $9f3518710c51c339$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($9f3518710c51c339$var$_typeof(_key) === "object" && _key !== null) {
                if (!$9f3518710c51c339$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$9f3518710c51c339$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9f3518710c51c339$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $9f3518710c51c339$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $9f3518710c51c339$var$kIsSet) {
        if (!$9f3518710c51c339$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9f3518710c51c339$var$kIsMap) {
        if (!$9f3518710c51c339$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $9f3518710c51c339$var$kIsArray) for(; i < a.length; i++){
        if ($9f3518710c51c339$var$hasOwnProperty(a, i)) {
            if (!$9f3518710c51c339$var$hasOwnProperty(b, i) || !$9f3518710c51c339$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($9f3518710c51c339$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$9f3518710c51c339$var$hasOwnProperty(b, key) || !$9f3518710c51c339$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$9f3518710c51c339$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $9f3518710c51c339$var$isDeepEqual(val1, val2) {
    return $9f3518710c51c339$var$innerDeepEqual(val1, val2, $9f3518710c51c339$var$kLoose);
}
function $9f3518710c51c339$var$isDeepStrictEqual(val1, val2) {
    return $9f3518710c51c339$var$innerDeepEqual(val1, val2, $9f3518710c51c339$var$kStrict);
}
module.exports = {
    isDeepEqual: $9f3518710c51c339$var$isDeepEqual,
    isDeepStrictEqual: $9f3518710c51c339$var$isDeepStrictEqual
};

});
parcelRegister("fmpVL", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $e9CQ6 = parcelRequire("e9CQ6");

var $5kJ8M = parcelRequire("5kJ8M");

var $7f1SY = parcelRequire("7f1SY");

var $h1yzf = parcelRequire("h1yzf");
var $b2ed0666e6b8b190$var$polyfill = $e9CQ6($7f1SY(), Object);
$5AcsX($b2ed0666e6b8b190$var$polyfill, {
    getPolyfill: $7f1SY,
    implementation: $5kJ8M,
    shim: $h1yzf
});
module.exports = $b2ed0666e6b8b190$var$polyfill;

});
parcelRegister("5AcsX", function(module, exports) {
"use strict";

var $lTDqP = parcelRequire("lTDqP");
var $4109fc0dc4761cef$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $4109fc0dc4761cef$var$toStr = Object.prototype.toString;
var $4109fc0dc4761cef$var$concat = Array.prototype.concat;
var $4109fc0dc4761cef$var$origDefineProperty = Object.defineProperty;
var $4109fc0dc4761cef$var$isFunction = function(fn) {
    return typeof fn === "function" && $4109fc0dc4761cef$var$toStr.call(fn) === "[object Function]";
};
var $4109fc0dc4761cef$var$arePropertyDescriptorsSupported = function() {
    var obj = {};
    try {
        $4109fc0dc4761cef$var$origDefineProperty(obj, "x", {
            enumerable: false,
            value: obj
        });
        // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)return false;
        return obj.x === obj;
    } catch (e) {
        return false;
    }
};
var $4109fc0dc4761cef$var$supportsDescriptors = $4109fc0dc4761cef$var$origDefineProperty && $4109fc0dc4761cef$var$arePropertyDescriptorsSupported();
var $4109fc0dc4761cef$var$defineProperty = function(object, name, value, predicate) {
    if (name in object && (!$4109fc0dc4761cef$var$isFunction(predicate) || !predicate())) return;
    if ($4109fc0dc4761cef$var$supportsDescriptors) $4109fc0dc4761cef$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $4109fc0dc4761cef$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $lTDqP(map);
    if ($4109fc0dc4761cef$var$hasSymbols) props = $4109fc0dc4761cef$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$4109fc0dc4761cef$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$4109fc0dc4761cef$var$defineProperties.supportsDescriptors = !!$4109fc0dc4761cef$var$supportsDescriptors;
module.exports = $4109fc0dc4761cef$var$defineProperties;

});

parcelRegister("h1yzf", function(module, exports) {
"use strict";

var $7f1SY = parcelRequire("7f1SY");

var $5AcsX = parcelRequire("5AcsX");
module.exports = function shimObjectIs() {
    var polyfill = $7f1SY();
    $5AcsX(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("4GuR1", function(module, exports) {
"use strict";

var $e9CQ6 = parcelRequire("e9CQ6");

var $5AcsX = parcelRequire("5AcsX");

var $3o2B8 = parcelRequire("3o2B8");

var $eJ6Gj = parcelRequire("eJ6Gj");

var $9j2pv = parcelRequire("9j2pv");
var $369304a8312d9914$var$polyfill = $e9CQ6($eJ6Gj(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $5AcsX($369304a8312d9914$var$polyfill, {
    getPolyfill: $eJ6Gj,
    implementation: $3o2B8,
    shim: $9j2pv
});
module.exports = $369304a8312d9914$var$polyfill;

});
parcelRegister("3o2B8", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("eJ6Gj", function(module, exports) {
"use strict";

var $3o2B8 = parcelRequire("3o2B8");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $3o2B8;
};

});

parcelRegister("9j2pv", function(module, exports) {
"use strict";

var $5AcsX = parcelRequire("5AcsX");

var $eJ6Gj = parcelRequire("eJ6Gj");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $eJ6Gj();
    $5AcsX(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("gGdnO", function(module, exports) {
"use strict";
class $c24af32ffff969ab$var$PLazy extends Promise {
    constructor(executor){
        super((resolve)=>{
            resolve();
        });
        this._executor = executor;
    }
    static from(fn) {
        return new $c24af32ffff969ab$var$PLazy((resolve)=>{
            resolve(fn());
        });
    }
    static resolve(value) {
        return new $c24af32ffff969ab$var$PLazy((resolve)=>{
            resolve(value);
        });
    }
    static reject(error) {
        return new $c24af32ffff969ab$var$PLazy((resolve, reject)=>{
            reject(error);
        });
    }
    then(onFulfilled, onRejected) {
        this._promise = this._promise || new Promise(this._executor);
        // eslint-disable-next-line promise/prefer-await-to-then
        return this._promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        this._promise = this._promise || new Promise(this._executor);
        return this._promise.catch(onRejected);
    }
}
module.exports = $c24af32ffff969ab$var$PLazy;

});

parcelRegister("eknzC", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("7f0Rw"),
    $hffE7("kDFgN")
]).then(()=>parcelRequire("i8VLH"));

});
parcelRegister("hffE7", function(module, exports) {
"use strict";

function $c8dff9588896671a$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("kyEFX")).resolve(id));
}
module.exports = $c8dff9588896671a$var$load;

});


parcelRegister("jRkuS", function(module, exports) {
module.exports = $e752ddd240bc56a4$var$Long;
/**
 * wasm optimizations, to do native i64 multiplication and divide
 */ var $e752ddd240bc56a4$var$wasm = null;
try {
    $e752ddd240bc56a4$var$wasm = new WebAssembly.Instance(new WebAssembly.Module(new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        13,
        2,
        96,
        0,
        1,
        127,
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        3,
        7,
        6,
        0,
        1,
        1,
        1,
        1,
        1,
        6,
        6,
        1,
        127,
        1,
        65,
        0,
        11,
        7,
        50,
        6,
        3,
        109,
        117,
        108,
        0,
        1,
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        10,
        191,
        1,
        6,
        4,
        0,
        35,
        0,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
    ])), {}).exports;
} catch (e) {
// no wasm support :(
}
/**
 * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
 *  See the from* functions below for more convenient ways of constructing Longs.
 * @exports Long
 * @class A Long class for representing a 64 bit two's-complement integer value.
 * @param {number} low The low (signed) 32 bits of the long
 * @param {number} high The high (signed) 32 bits of the long
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @constructor
 */ function $e752ddd240bc56a4$var$Long(low, high, unsigned) {
    /**
     * The low 32 bits as a signed value.
     * @type {number}
     */ this.low = low | 0;
    /**
     * The high 32 bits as a signed value.
     * @type {number}
     */ this.high = high | 0;
    /**
     * Whether unsigned or not.
     * @type {boolean}
     */ this.unsigned = !!unsigned;
}
// The internal representation of a long is the two given signed, 32-bit values.
// We use 32-bit pieces because these are the size of integers on which
// Javascript performs bit-operations.  For operations like addition and
// multiplication, we split each number into 16 bit pieces, which can easily be
// multiplied within Javascript's floating-point representation without overflow
// or change in sign.
//
// In the algorithms below, we frequently reduce the negative case to the
// positive case by negating the input(s) and then post-processing the result.
// Note that we must ALWAYS check specially whether those values are MIN_VALUE
// (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
// a positive number, it overflows back into a negative).  Not handling this
// case would often result in infinite recursion.
//
// Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
// methods on which they depend.
/**
 * An indicator used to reliably determine if an object is a Long or not.
 * @type {boolean}
 * @const
 * @private
 */ $e752ddd240bc56a4$var$Long.prototype.__isLong__;
Object.defineProperty($e752ddd240bc56a4$var$Long.prototype, "__isLong__", {
    value: true
});
/**
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 * @inner
 */ function $e752ddd240bc56a4$var$isLong(obj) {
    return (obj && obj["__isLong__"]) === true;
}
/**
 * Tests if the specified object is a Long.
 * @function
 * @param {*} obj Object
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$Long.isLong = $e752ddd240bc56a4$var$isLong;
/**
 * A cache of the Long representations of small integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$INT_CACHE = {};
/**
 * A cache of the Long representations of small unsigned integer values.
 * @type {!Object}
 * @inner
 */ var $e752ddd240bc56a4$var$UINT_CACHE = {};
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromInt(value, unsigned) {
    var obj, cachedObj, cache;
    if (unsigned) {
        value >>>= 0;
        if (cache = 0 <= value && value < 256) {
            cachedObj = $e752ddd240bc56a4$var$UINT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, (value | 0) < 0 ? -1 : 0, true);
        if (cache) $e752ddd240bc56a4$var$UINT_CACHE[value] = obj;
        return obj;
    } else {
        value |= 0;
        if (cache = -128 <= value && value < 128) {
            cachedObj = $e752ddd240bc56a4$var$INT_CACHE[value];
            if (cachedObj) return cachedObj;
        }
        obj = $e752ddd240bc56a4$var$fromBits(value, value < 0 ? -1 : 0, false);
        if (cache) $e752ddd240bc56a4$var$INT_CACHE[value] = obj;
        return obj;
    }
}
/**
 * Returns a Long representing the given 32 bit integer value.
 * @function
 * @param {number} value The 32 bit integer in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromInt = $e752ddd240bc56a4$var$fromInt;
/**
 * @param {number} value
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromNumber(value, unsigned) {
    if (isNaN(value)) return unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    if (unsigned) {
        if (value < 0) return $e752ddd240bc56a4$var$UZERO;
        if (value >= $e752ddd240bc56a4$var$TWO_PWR_64_DBL) return $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
    } else {
        if (value <= -$e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MIN_VALUE;
        if (value + 1 >= $e752ddd240bc56a4$var$TWO_PWR_63_DBL) return $e752ddd240bc56a4$var$MAX_VALUE;
    }
    if (value < 0) return $e752ddd240bc56a4$var$fromNumber(-value, unsigned).neg();
    return $e752ddd240bc56a4$var$fromBits(value % $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, value / $e752ddd240bc56a4$var$TWO_PWR_32_DBL | 0, unsigned);
}
/**
 * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
 * @function
 * @param {number} value The number in question
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromNumber = $e752ddd240bc56a4$var$fromNumber;
/**
 * @param {number} lowBits
 * @param {number} highBits
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromBits(lowBits, highBits, unsigned) {
    return new $e752ddd240bc56a4$var$Long(lowBits, highBits, unsigned);
}
/**
 * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
 *  assumed to use 32 bits.
 * @function
 * @param {number} lowBits The low 32 bits
 * @param {number} highBits The high 32 bits
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBits = $e752ddd240bc56a4$var$fromBits;
/**
 * @function
 * @param {number} base
 * @param {number} exponent
 * @returns {number}
 * @inner
 */ var $e752ddd240bc56a4$var$pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
/**
 * @param {string} str
 * @param {(boolean|number)=} unsigned
 * @param {number=} radix
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromString(str, unsigned, radix) {
    if (str.length === 0) throw Error("empty string");
    if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity") return $e752ddd240bc56a4$var$ZERO;
    if (typeof unsigned === "number") // For goog.math.long compatibility
    radix = unsigned, unsigned = false;
    else unsigned = !!unsigned;
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    var p;
    if ((p = str.indexOf("-")) > 0) throw Error("interior hyphen");
    else if (p === 0) return $e752ddd240bc56a4$var$fromString(str.substring(1), unsigned, radix).neg();
    // Do several (8) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 8));
    var result = $e752ddd240bc56a4$var$ZERO;
    for(var i = 0; i < str.length; i += 8){
        var size = Math.min(8, str.length - i), value = parseInt(str.substring(i, i + size), radix);
        if (size < 8) {
            var power = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, size));
            result = result.mul(power).add($e752ddd240bc56a4$var$fromNumber(value));
        } else {
            result = result.mul(radixToPower);
            result = result.add($e752ddd240bc56a4$var$fromNumber(value));
        }
    }
    result.unsigned = unsigned;
    return result;
}
/**
 * Returns a Long representation of the given string, written using the specified radix.
 * @function
 * @param {string} str The textual representation of the Long
 * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to signed
 * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
 * @returns {!Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromString = $e752ddd240bc56a4$var$fromString;
/**
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
 * @param {boolean=} unsigned
 * @returns {!Long}
 * @inner
 */ function $e752ddd240bc56a4$var$fromValue(val, unsigned) {
    if (typeof val === "number") return $e752ddd240bc56a4$var$fromNumber(val, unsigned);
    if (typeof val === "string") return $e752ddd240bc56a4$var$fromString(val, unsigned);
    // Throws for non-objects, converts non-instanceof Long:
    return $e752ddd240bc56a4$var$fromBits(val.low, val.high, typeof unsigned === "boolean" ? unsigned : val.unsigned);
}
/**
 * Converts the specified value to a Long using the appropriate from* function for its type.
 * @function
 * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$Long.fromValue = $e752ddd240bc56a4$var$fromValue;
// NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
// no runtime penalty for these.
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_16_DBL = 65536;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24_DBL = 16777216;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_32_DBL = $e752ddd240bc56a4$var$TWO_PWR_16_DBL * $e752ddd240bc56a4$var$TWO_PWR_16_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_64_DBL = $e752ddd240bc56a4$var$TWO_PWR_32_DBL * $e752ddd240bc56a4$var$TWO_PWR_32_DBL;
/**
 * @type {number}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_63_DBL = $e752ddd240bc56a4$var$TWO_PWR_64_DBL / 2;
/**
 * @type {!Long}
 * @const
 * @inner
 */ var $e752ddd240bc56a4$var$TWO_PWR_24 = $e752ddd240bc56a4$var$fromInt($e752ddd240bc56a4$var$TWO_PWR_24_DBL);
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ZERO = $e752ddd240bc56a4$var$fromInt(0);
/**
 * Signed zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ZERO = $e752ddd240bc56a4$var$ZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UZERO = $e752ddd240bc56a4$var$fromInt(0, true);
/**
 * Unsigned zero.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UZERO = $e752ddd240bc56a4$var$UZERO;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$ONE = $e752ddd240bc56a4$var$fromInt(1);
/**
 * Signed one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.ONE = $e752ddd240bc56a4$var$ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$UONE = $e752ddd240bc56a4$var$fromInt(1, true);
/**
 * Unsigned one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.UONE = $e752ddd240bc56a4$var$UONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$NEG_ONE = $e752ddd240bc56a4$var$fromInt(-1);
/**
 * Signed negative one.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.NEG_ONE = $e752ddd240bc56a4$var$NEG_ONE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_VALUE = $e752ddd240bc56a4$var$fromBits(-1, 2147483647, false);
/**
 * Maximum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_VALUE = $e752ddd240bc56a4$var$MAX_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$fromBits(-1, -1, true);
/**
 * Maximum unsigned value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MAX_UNSIGNED_VALUE = $e752ddd240bc56a4$var$MAX_UNSIGNED_VALUE;
/**
 * @type {!Long}
 * @inner
 */ var $e752ddd240bc56a4$var$MIN_VALUE = $e752ddd240bc56a4$var$fromBits(0, -2147483648, false);
/**
 * Minimum signed value.
 * @type {!Long}
 */ $e752ddd240bc56a4$var$Long.MIN_VALUE = $e752ddd240bc56a4$var$MIN_VALUE;
/**
 * @alias Long.prototype
 * @inner
 */ var $e752ddd240bc56a4$var$LongPrototype = $e752ddd240bc56a4$var$Long.prototype;
/**
 * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toInt = function toInt() {
    return this.unsigned ? this.low >>> 0 : this.low;
};
/**
 * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.toNumber = function toNumber() {
    if (this.unsigned) return (this.high >>> 0) * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
    return this.high * $e752ddd240bc56a4$var$TWO_PWR_32_DBL + (this.low >>> 0);
};
/**
 * Converts the Long to a string written in the specified radix.
 * @param {number=} radix Radix (2-36), defaults to 10
 * @returns {string}
 * @override
 * @throws {RangeError} If `radix` is out of range
 */ $e752ddd240bc56a4$var$LongPrototype.toString = function toString(radix) {
    radix = radix || 10;
    if (radix < 2 || 36 < radix) throw RangeError("radix");
    if (this.isZero()) return "0";
    if (this.isNegative()) {
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            // We need to change the Long value before it can be negated, so we remove
            // the bottom-most digit in this base and then recurse to do the rest.
            var radixLong = $e752ddd240bc56a4$var$fromNumber(radix), div = this.div(radixLong), rem1 = div.mul(radixLong).sub(this);
            return div.toString(radix) + rem1.toInt().toString(radix);
        } else return "-" + this.neg().toString(radix);
    }
    // Do several (6) digits each time through the loop, so as to
    // minimize the calls to the very expensive emulated div.
    var radixToPower = $e752ddd240bc56a4$var$fromNumber($e752ddd240bc56a4$var$pow_dbl(radix, 6), this.unsigned), rem = this;
    var result = "";
    while(true){
        var remDiv = rem.div(radixToPower), intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0, digits = intval.toString(radix);
        rem = remDiv;
        if (rem.isZero()) return digits + result;
        else {
            while(digits.length < 6)digits = "0" + digits;
            result = "" + digits + result;
        }
    }
};
/**
 * Gets the high 32 bits as a signed integer.
 * @returns {number} Signed high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBits = function getHighBits() {
    return this.high;
};
/**
 * Gets the high 32 bits as an unsigned integer.
 * @returns {number} Unsigned high bits
 */ $e752ddd240bc56a4$var$LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
    return this.high >>> 0;
};
/**
 * Gets the low 32 bits as a signed integer.
 * @returns {number} Signed low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBits = function getLowBits() {
    return this.low;
};
/**
 * Gets the low 32 bits as an unsigned integer.
 * @returns {number} Unsigned low bits
 */ $e752ddd240bc56a4$var$LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
    return this.low >>> 0;
};
/**
 * Gets the number of bits needed to represent the absolute value of this Long.
 * @returns {number}
 */ $e752ddd240bc56a4$var$LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
    if (this.isNegative()) return this.eq($e752ddd240bc56a4$var$MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
    var val = this.high != 0 ? this.high : this.low;
    for(var bit = 31; bit > 0; bit--)if ((val & 1 << bit) != 0) break;
    return this.high != 0 ? bit + 33 : bit + 1;
};
/**
 * Tests if this Long's value equals zero.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isZero = function isZero() {
    return this.high === 0 && this.low === 0;
};
/**
 * Tests if this Long's value equals zero. This is an alias of {@link Long#isZero}.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eqz = $e752ddd240bc56a4$var$LongPrototype.isZero;
/**
 * Tests if this Long's value is negative.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isNegative = function isNegative() {
    return !this.unsigned && this.high < 0;
};
/**
 * Tests if this Long's value is positive.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isPositive = function isPositive() {
    return this.unsigned || this.high >= 0;
};
/**
 * Tests if this Long's value is odd.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isOdd = function isOdd() {
    return (this.low & 1) === 1;
};
/**
 * Tests if this Long's value is even.
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.isEven = function isEven() {
    return (this.low & 1) === 0;
};
/**
 * Tests if this Long's value equals the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.equals = function equals(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.unsigned !== other.unsigned && this.high >>> 31 === 1 && other.high >>> 31 === 1) return false;
    return this.high === other.high && this.low === other.low;
};
/**
 * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.eq = $e752ddd240bc56a4$var$LongPrototype.equals;
/**
 * Tests if this Long's value differs from the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.notEquals = function notEquals(other) {
    return !this.eq(/* validates */ other);
};
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.neq = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ne = $e752ddd240bc56a4$var$LongPrototype.notEquals;
/**
 * Tests if this Long's value is less than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThan = function lessThan(other) {
    return this.comp(/* validates */ other) < 0;
};
/**
 * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lt = $e752ddd240bc56a4$var$LongPrototype.lessThan;
/**
 * Tests if this Long's value is less than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
    return this.comp(/* validates */ other) <= 0;
};
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.lte = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.le = $e752ddd240bc56a4$var$LongPrototype.lessThanOrEqual;
/**
 * Tests if this Long's value is greater than the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThan = function greaterThan(other) {
    return this.comp(/* validates */ other) > 0;
};
/**
 * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gt = $e752ddd240bc56a4$var$LongPrototype.greaterThan;
/**
 * Tests if this Long's value is greater than or equal the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
    return this.comp(/* validates */ other) >= 0;
};
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.gte = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {boolean}
 */ $e752ddd240bc56a4$var$LongPrototype.ge = $e752ddd240bc56a4$var$LongPrototype.greaterThanOrEqual;
/**
 * Compares this Long's value with the specified's.
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.compare = function compare(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    if (this.eq(other)) return 0;
    var thisNeg = this.isNegative(), otherNeg = other.isNegative();
    if (thisNeg && !otherNeg) return -1;
    if (!thisNeg && otherNeg) return 1;
    // At this point the sign bits are the same
    if (!this.unsigned) return this.sub(other).isNegative() ? -1 : 1;
    // Both are positive if at least one is unsigned
    return other.high >>> 0 > this.high >>> 0 || other.high === this.high && other.low >>> 0 > this.low >>> 0 ? -1 : 1;
};
/**
 * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
 * @function
 * @param {!Long|number|string} other Other value
 * @returns {number} 0 if they are the same, 1 if the this is greater and -1
 *  if the given one is greater
 */ $e752ddd240bc56a4$var$LongPrototype.comp = $e752ddd240bc56a4$var$LongPrototype.compare;
/**
 * Negates this Long's value.
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.negate = function negate() {
    if (!this.unsigned && this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$MIN_VALUE;
    return this.not().add($e752ddd240bc56a4$var$ONE);
};
/**
 * Negates this Long's value. This is an alias of {@link Long#negate}.
 * @function
 * @returns {!Long} Negated Long
 */ $e752ddd240bc56a4$var$LongPrototype.neg = $e752ddd240bc56a4$var$LongPrototype.negate;
/**
 * Returns the sum of this and the specified Long.
 * @param {!Long|number|string} addend Addend
 * @returns {!Long} Sum
 */ $e752ddd240bc56a4$var$LongPrototype.add = function add(addend) {
    if (!$e752ddd240bc56a4$var$isLong(addend)) addend = $e752ddd240bc56a4$var$fromValue(addend);
    // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = addend.high >>> 16;
    var b32 = addend.high & 0xFFFF;
    var b16 = addend.low >>> 16;
    var b00 = addend.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 + b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 + b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 + b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 + b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the difference of this and the specified Long.
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.subtract = function subtract(subtrahend) {
    if (!$e752ddd240bc56a4$var$isLong(subtrahend)) subtrahend = $e752ddd240bc56a4$var$fromValue(subtrahend);
    return this.add(subtrahend.neg());
};
/**
 * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
 * @function
 * @param {!Long|number|string} subtrahend Subtrahend
 * @returns {!Long} Difference
 */ $e752ddd240bc56a4$var$LongPrototype.sub = $e752ddd240bc56a4$var$LongPrototype.subtract;
/**
 * Returns the product of this and the specified Long.
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.multiply = function multiply(multiplier) {
    if (this.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (!$e752ddd240bc56a4$var$isLong(multiplier)) multiplier = $e752ddd240bc56a4$var$fromValue(multiplier);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = $e752ddd240bc56a4$var$wasm.mul(this.low, this.high, multiplier.low, multiplier.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (multiplier.isZero()) return $e752ddd240bc56a4$var$ZERO;
    if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) return multiplier.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (multiplier.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.isOdd() ? $e752ddd240bc56a4$var$MIN_VALUE : $e752ddd240bc56a4$var$ZERO;
    if (this.isNegative()) {
        if (multiplier.isNegative()) return this.neg().mul(multiplier.neg());
        else return this.neg().mul(multiplier).neg();
    } else if (multiplier.isNegative()) return this.mul(multiplier.neg()).neg();
    // If both longs are small, use float multiplication
    if (this.lt($e752ddd240bc56a4$var$TWO_PWR_24) && multiplier.lt($e752ddd240bc56a4$var$TWO_PWR_24)) return $e752ddd240bc56a4$var$fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
    // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
    // We can skip products that would overflow.
    var a48 = this.high >>> 16;
    var a32 = this.high & 0xFFFF;
    var a16 = this.low >>> 16;
    var a00 = this.low & 0xFFFF;
    var b48 = multiplier.high >>> 16;
    var b32 = multiplier.high & 0xFFFF;
    var b16 = multiplier.low >>> 16;
    var b00 = multiplier.low & 0xFFFF;
    var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
    c00 += a00 * b00;
    c16 += c00 >>> 16;
    c00 &= 0xFFFF;
    c16 += a16 * b00;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c16 += a00 * b16;
    c32 += c16 >>> 16;
    c16 &= 0xFFFF;
    c32 += a32 * b00;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a16 * b16;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c32 += a00 * b32;
    c48 += c32 >>> 16;
    c32 &= 0xFFFF;
    c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
    c48 &= 0xFFFF;
    return $e752ddd240bc56a4$var$fromBits(c16 << 16 | c00, c48 << 16 | c32, this.unsigned);
};
/**
 * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
 * @function
 * @param {!Long|number|string} multiplier Multiplier
 * @returns {!Long} Product
 */ $e752ddd240bc56a4$var$LongPrototype.mul = $e752ddd240bc56a4$var$LongPrototype.multiply;
/**
 * Returns this Long divided by the specified. The result is signed if this Long is signed or
 *  unsigned if this Long is unsigned.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.divide = function divide(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    if (divisor.isZero()) throw Error("division by zero");
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        // guard against signed division overflow: the largest
        // negative number / -1 would be 1 larger than the largest
        // positive number, due to two's complement.
        if (!this.unsigned && this.high === -2147483648 && divisor.low === -1 && divisor.high === -1) // be consistent with non-wasm code path
        return this;
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.div_u : $e752ddd240bc56a4$var$wasm.div_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    if (this.isZero()) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
    var approx, rem, res;
    if (!this.unsigned) {
        // This section is only relevant for signed longs and is derived from the
        // closure library as a whole.
        if (this.eq($e752ddd240bc56a4$var$MIN_VALUE)) {
            if (divisor.eq($e752ddd240bc56a4$var$ONE) || divisor.eq($e752ddd240bc56a4$var$NEG_ONE)) return $e752ddd240bc56a4$var$MIN_VALUE; // recall that -MIN_VALUE == MIN_VALUE
            else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return $e752ddd240bc56a4$var$ONE;
            else {
                // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
                var halfThis = this.shr(1);
                approx = halfThis.div(divisor).shl(1);
                if (approx.eq($e752ddd240bc56a4$var$ZERO)) return divisor.isNegative() ? $e752ddd240bc56a4$var$ONE : $e752ddd240bc56a4$var$NEG_ONE;
                else {
                    rem = this.sub(divisor.mul(approx));
                    res = approx.add(rem.div(divisor));
                    return res;
                }
            }
        } else if (divisor.eq($e752ddd240bc56a4$var$MIN_VALUE)) return this.unsigned ? $e752ddd240bc56a4$var$UZERO : $e752ddd240bc56a4$var$ZERO;
        if (this.isNegative()) {
            if (divisor.isNegative()) return this.neg().div(divisor.neg());
            return this.neg().div(divisor).neg();
        } else if (divisor.isNegative()) return this.div(divisor.neg()).neg();
        res = $e752ddd240bc56a4$var$ZERO;
    } else {
        // The algorithm below has not been made for unsigned longs. It's therefore
        // required to take special care of the MSB prior to running it.
        if (!divisor.unsigned) divisor = divisor.toUnsigned();
        if (divisor.gt(this)) return $e752ddd240bc56a4$var$UZERO;
        if (divisor.gt(this.shru(1))) return $e752ddd240bc56a4$var$UONE;
        res = $e752ddd240bc56a4$var$UZERO;
    }
    // Repeat the following until the remainder is less than other:  find a
    // floating-point that approximates remainder / other *from below*, add this
    // into the result, and subtract it from the remainder.  It is critical that
    // the approximate value is less than or equal to the real value so that the
    // remainder never becomes negative.
    rem = this;
    while(rem.gte(divisor)){
        // Approximate the result of division. This may be a little greater or
        // smaller than the actual value.
        approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
        // We will tweak the approximate result by changing it in the 48-th digit or
        // the smallest non-fractional digit, whichever is larger.
        var log2 = Math.ceil(Math.log(approx) / Math.LN2), delta = log2 <= 48 ? 1 : $e752ddd240bc56a4$var$pow_dbl(2, log2 - 48), // Decrease the approximation until it is smaller than the remainder.  Note
        // that if it is too large, the product overflows and is negative.
        approxRes = $e752ddd240bc56a4$var$fromNumber(approx), approxRem = approxRes.mul(divisor);
        while(approxRem.isNegative() || approxRem.gt(rem)){
            approx -= delta;
            approxRes = $e752ddd240bc56a4$var$fromNumber(approx, this.unsigned);
            approxRem = approxRes.mul(divisor);
        }
        // We know the answer can't be zero... and actually, zero would cause
        // infinite recursion since we would make no progress.
        if (approxRes.isZero()) approxRes = $e752ddd240bc56a4$var$ONE;
        res = res.add(approxRes);
        rem = rem.sub(approxRem);
    }
    return res;
};
/**
 * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Quotient
 */ $e752ddd240bc56a4$var$LongPrototype.div = $e752ddd240bc56a4$var$LongPrototype.divide;
/**
 * Returns this Long modulo the specified.
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.modulo = function modulo(divisor) {
    if (!$e752ddd240bc56a4$var$isLong(divisor)) divisor = $e752ddd240bc56a4$var$fromValue(divisor);
    // use wasm support if present
    if ($e752ddd240bc56a4$var$wasm) {
        var low = (this.unsigned ? $e752ddd240bc56a4$var$wasm.rem_u : $e752ddd240bc56a4$var$wasm.rem_s)(this.low, this.high, divisor.low, divisor.high);
        return $e752ddd240bc56a4$var$fromBits(low, $e752ddd240bc56a4$var$wasm.get_high(), this.unsigned);
    }
    return this.sub(this.div(divisor).mul(divisor));
};
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.mod = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
 * @function
 * @param {!Long|number|string} divisor Divisor
 * @returns {!Long} Remainder
 */ $e752ddd240bc56a4$var$LongPrototype.rem = $e752ddd240bc56a4$var$LongPrototype.modulo;
/**
 * Returns the bitwise NOT of this Long.
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.not = function not() {
    return $e752ddd240bc56a4$var$fromBits(~this.low, ~this.high, this.unsigned);
};
/**
 * Returns the bitwise AND of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.and = function and(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low & other.low, this.high & other.high, this.unsigned);
};
/**
 * Returns the bitwise OR of this Long and the specified.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.or = function or(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low | other.low, this.high | other.high, this.unsigned);
};
/**
 * Returns the bitwise XOR of this Long and the given one.
 * @param {!Long|number|string} other Other Long
 * @returns {!Long}
 */ $e752ddd240bc56a4$var$LongPrototype.xor = function xor(other) {
    if (!$e752ddd240bc56a4$var$isLong(other)) other = $e752ddd240bc56a4$var$fromValue(other);
    return $e752ddd240bc56a4$var$fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftLeft = function shiftLeft(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low << numBits, this.high << numBits | this.low >>> 32 - numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(0, this.low << numBits - 32, this.unsigned);
};
/**
 * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shl = $e752ddd240bc56a4$var$LongPrototype.shiftLeft;
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRight = function shiftRight(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    if ((numBits &= 63) === 0) return this;
    else if (numBits < 32) return $e752ddd240bc56a4$var$fromBits(this.low >>> numBits | this.high << 32 - numBits, this.high >> numBits, this.unsigned);
    else return $e752ddd240bc56a4$var$fromBits(this.high >> numBits - 32, this.high >= 0 ? 0 : -1, this.unsigned);
};
/**
 * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr = $e752ddd240bc56a4$var$LongPrototype.shiftRight;
/**
 * Returns this Long with bits logically shifted to the right by the given amount.
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
    if ($e752ddd240bc56a4$var$isLong(numBits)) numBits = numBits.toInt();
    numBits &= 63;
    if (numBits === 0) return this;
    else {
        var high = this.high;
        if (numBits < 32) {
            var low = this.low;
            return $e752ddd240bc56a4$var$fromBits(low >>> numBits | high << 32 - numBits, high >>> numBits, this.unsigned);
        } else if (numBits === 32) return $e752ddd240bc56a4$var$fromBits(high, 0, this.unsigned);
        else return $e752ddd240bc56a4$var$fromBits(high >>> numBits - 32, 0, this.unsigned);
    }
};
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shru = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
 * @function
 * @param {number|!Long} numBits Number of bits
 * @returns {!Long} Shifted Long
 */ $e752ddd240bc56a4$var$LongPrototype.shr_u = $e752ddd240bc56a4$var$LongPrototype.shiftRightUnsigned;
/**
 * Converts this Long to signed.
 * @returns {!Long} Signed long
 */ $e752ddd240bc56a4$var$LongPrototype.toSigned = function toSigned() {
    if (!this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, false);
};
/**
 * Converts this Long to unsigned.
 * @returns {!Long} Unsigned long
 */ $e752ddd240bc56a4$var$LongPrototype.toUnsigned = function toUnsigned() {
    if (this.unsigned) return this;
    return $e752ddd240bc56a4$var$fromBits(this.low, this.high, true);
};
/**
 * Converts this Long to its byte representation.
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {!Array.<number>} Byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytes = function toBytes(le) {
    return le ? this.toBytesLE() : this.toBytesBE();
};
/**
 * Converts this Long to its little endian byte representation.
 * @returns {!Array.<number>} Little endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesLE = function toBytesLE() {
    var hi = this.high, lo = this.low;
    return [
        lo & 0xff,
        lo >>> 8 & 0xff,
        lo >>> 16 & 0xff,
        lo >>> 24,
        hi & 0xff,
        hi >>> 8 & 0xff,
        hi >>> 16 & 0xff,
        hi >>> 24
    ];
};
/**
 * Converts this Long to its big endian byte representation.
 * @returns {!Array.<number>} Big endian byte representation
 */ $e752ddd240bc56a4$var$LongPrototype.toBytesBE = function toBytesBE() {
    var hi = this.high, lo = this.low;
    return [
        hi >>> 24,
        hi >>> 16 & 0xff,
        hi >>> 8 & 0xff,
        hi & 0xff,
        lo >>> 24,
        lo >>> 16 & 0xff,
        lo >>> 8 & 0xff,
        lo & 0xff
    ];
};
/**
 * Creates a Long from its byte representation.
 * @param {!Array.<number>} bytes Byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @param {boolean=} le Whether little or big endian, defaults to big endian
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytes = function fromBytes(bytes, unsigned, le) {
    return le ? $e752ddd240bc56a4$var$Long.fromBytesLE(bytes, unsigned) : $e752ddd240bc56a4$var$Long.fromBytesBE(bytes, unsigned);
};
/**
 * Creates a Long from its little endian byte representation.
 * @param {!Array.<number>} bytes Little endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesLE = function fromBytesLE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[0] | bytes[1] << 8 | bytes[2] << 16 | bytes[3] << 24, bytes[4] | bytes[5] << 8 | bytes[6] << 16 | bytes[7] << 24, unsigned);
};
/**
 * Creates a Long from its big endian byte representation.
 * @param {!Array.<number>} bytes Big endian byte representation
 * @param {boolean=} unsigned Whether unsigned or not, defaults to signed
 * @returns {Long} The corresponding Long value
 */ $e752ddd240bc56a4$var$Long.fromBytesBE = function fromBytesBE(bytes, unsigned) {
    return new $e752ddd240bc56a4$var$Long(bytes[4] << 24 | bytes[5] << 16 | bytes[6] << 8 | bytes[7], bytes[0] << 24 | bytes[1] << 16 | bytes[2] << 8 | bytes[3], unsigned);
};

});

parcelRegister("bE5P3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $87a7f25813897ac8$require$Buffer = $ihoyg.Buffer;
"use strict";
var $87a7f25813897ac8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $87a7f25813897ac8$var$__assign = module.exports && module.exports.__assign || function() {
    $87a7f25813897ac8$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87a7f25813897ac8$var$__assign.apply(this, arguments);
};
var $87a7f25813897ac8$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hardfork = module.exports.Chain = module.exports.CustomChain = void 0;

var $jMc9N = parcelRequire("jMc9N");

var $70UGJ = parcelRequire("70UGJ");

var $eqs3F = parcelRequire("eqs3F");

var $bNSDz = parcelRequire("bNSDz");

var $ifHyT = parcelRequire("ifHyT");

var $dyf0U = parcelRequire("dyf0U");
var $87a7f25813897ac8$var$CustomChain;
(function(CustomChain) {
    /**
     * Polygon (Matic) Mainnet
     *
     * - [Documentation](https://docs.matic.network/docs/develop/network-details/network)
     */ CustomChain["PolygonMainnet"] = "polygon-mainnet";
    /**
     * Polygon (Matic) Mumbai Testnet
     *
     * - [Documentation](https://docs.matic.network/docs/develop/network-details/network)
     */ CustomChain["PolygonMumbai"] = "polygon-mumbai";
    /**
     * Arbitrum Rinkeby Testnet
     *
     * - [Documentation](https://developer.offchainlabs.com/docs/public_testnet)
     */ CustomChain["ArbitrumRinkebyTestnet"] = "arbitrum-rinkeby-testnet";
    /**
     * xDai EVM sidechain with a native stable token
     *
     * - [Documentation](https://www.xdaichain.com/)
     */ CustomChain["xDaiChain"] = "x-dai-chain";
})($87a7f25813897ac8$var$CustomChain = module.exports.CustomChain || (module.exports.CustomChain = {}));
var $87a7f25813897ac8$var$Chain;
(function(Chain) {
    Chain[Chain["Mainnet"] = 1] = "Mainnet";
    Chain[Chain["Ropsten"] = 3] = "Ropsten";
    Chain[Chain["Rinkeby"] = 4] = "Rinkeby";
    Chain[Chain["Kovan"] = 42] = "Kovan";
    Chain[Chain["Goerli"] = 5] = "Goerli";
    Chain[Chain["Calaveras"] = 123] = "Calaveras";
})($87a7f25813897ac8$var$Chain = module.exports.Chain || (module.exports.Chain = {}));
var $87a7f25813897ac8$var$Hardfork;
(function(Hardfork) {
    Hardfork["Chainstart"] = "chainstart";
    Hardfork["Homestead"] = "homestead";
    Hardfork["Dao"] = "dao";
    Hardfork["TangerineWhistle"] = "tangerineWhistle";
    Hardfork["SpuriousDragon"] = "spuriousDragon";
    Hardfork["Byzantium"] = "byzantium";
    Hardfork["Constantinople"] = "constantinople";
    Hardfork["Petersburg"] = "petersburg";
    Hardfork["Istanbul"] = "istanbul";
    Hardfork["MuirGlacier"] = "muirGlacier";
    Hardfork["Berlin"] = "berlin";
    Hardfork["London"] = "london";
})($87a7f25813897ac8$var$Hardfork = module.exports.Hardfork || (module.exports.Hardfork = {}));
/**
 * Common class to access chain and hardfork parameters and to provide
 * a unified and shared view on the network and hardfork state.
 *
 * Use the {@link Common.custom} static constructor for creating simple
 * custom chain {@link Common} objects (more complete custom chain setups
 * can be created via the main constructor and the {@link CommonOpts.customChains} parameter).
 */ var $87a7f25813897ac8$var$Common = /** @class */ function(_super) {
    $87a7f25813897ac8$var$__extends(Common, _super);
    /**
     * @constructor
     */ function Common(opts) {
        var _a, _b;
        var _this = _super.call(this) || this;
        _this._supportedHardforks = [];
        _this._eips = [];
        _this._customChains = (_a = opts.customChains) !== null && _a !== void 0 ? _a : [];
        _this._chainParams = _this.setChain(opts.chain);
        _this.DEFAULT_HARDFORK = (_b = _this._chainParams.defaultHardfork) !== null && _b !== void 0 ? _b : $87a7f25813897ac8$var$Hardfork.Istanbul;
        _this._hardfork = _this.DEFAULT_HARDFORK;
        if (opts.supportedHardforks) _this._supportedHardforks = opts.supportedHardforks;
        if (opts.hardfork) _this.setHardfork(opts.hardfork);
        if (opts.eips) _this.setEIPs(opts.eips);
        return _this;
    }
    /**
     * Creates a {@link Common} object for a custom chain, based on a standard one.
     *
     * It uses all the {@link Chain} parameters from the {@link baseChain} option except the ones overridden
     * in a provided {@link chainParamsOrName} dictionary. Some usage example:
     *
     * ```javascript
     * Common.custom({chainId: 123})
     * ```
     *
     * There are also selected supported custom chains which can be initialized by using one of the
     * {@link CustomChains} for {@link chainParamsOrName}, e.g.:
     *
     * ```javascript
     * Common.custom(CustomChains.MaticMumbai)
     * ```
     *
     * Note that these supported custom chains only provide some base parameters (usually the chain and
     * network ID and a name) and can only be used for selected use cases (e.g. sending a tx with
     * the `@ethereumjs/tx` library to a Layer-2 chain).
     *
     * @param chainParamsOrName Custom parameter dict (`name` will default to `custom-chain`) or string with name of a supported custom chain
     * @param opts Custom chain options to set the {@link CustomCommonOpts.baseChain}, selected {@link CustomCommonOpts.hardfork} and others
     */ Common.custom = function(chainParamsOrName, opts) {
        var _a;
        if (opts === void 0) opts = {};
        var baseChain = (_a = opts.baseChain) !== null && _a !== void 0 ? _a : "mainnet";
        var standardChainParams = $87a7f25813897ac8$var$__assign({}, Common._getChainParams(baseChain));
        standardChainParams["name"] = "custom-chain";
        if (typeof chainParamsOrName !== "string") return new Common($87a7f25813897ac8$var$__assign({
            chain: $87a7f25813897ac8$var$__assign($87a7f25813897ac8$var$__assign({}, standardChainParams), chainParamsOrName)
        }, opts));
        else {
            if (chainParamsOrName === $87a7f25813897ac8$var$CustomChain.PolygonMainnet) return Common.custom({
                name: $87a7f25813897ac8$var$CustomChain.PolygonMainnet,
                chainId: 137,
                networkId: 137
            });
            if (chainParamsOrName === $87a7f25813897ac8$var$CustomChain.PolygonMumbai) return Common.custom({
                name: $87a7f25813897ac8$var$CustomChain.PolygonMumbai,
                chainId: 80001,
                networkId: 80001
            });
            if (chainParamsOrName === $87a7f25813897ac8$var$CustomChain.ArbitrumRinkebyTestnet) return Common.custom({
                name: $87a7f25813897ac8$var$CustomChain.ArbitrumRinkebyTestnet,
                chainId: 421611,
                networkId: 421611
            });
            if (chainParamsOrName === $87a7f25813897ac8$var$CustomChain.xDaiChain) return Common.custom({
                name: $87a7f25813897ac8$var$CustomChain.xDaiChain,
                chainId: 100,
                networkId: 100
            });
            throw new Error("Custom chain " + chainParamsOrName + " not supported");
        }
    };
    /**
     * Creates a {@link Common} object for a custom chain, based on a standard one. It uses all the `Chain`
     * params from {@link baseChain} except the ones overridden in {@link customChainParams}.
     *
     * @deprecated Use {@link Common.custom} instead
     *
     * @param baseChain The name (`mainnet`) or id (`1`) of a standard chain used to base the custom
     * chain params on.
     * @param customChainParams The custom parameters of the chain.
     * @param hardfork String identifier ('byzantium') for hardfork (optional)
     * @param supportedHardforks Limit parameter returns to the given hardforks (optional)
     */ Common.forCustomChain = function(baseChain, customChainParams, hardfork, supportedHardforks) {
        var standardChainParams = Common._getChainParams(baseChain);
        return new Common({
            chain: $87a7f25813897ac8$var$__assign($87a7f25813897ac8$var$__assign({}, standardChainParams), customChainParams),
            hardfork: hardfork,
            supportedHardforks: supportedHardforks
        });
    };
    /**
     * Static method to determine if a {@link chainId} is supported as a standard chain
     * @param chainId BN id (`1`) of a standard chain
     * @returns boolean
     */ Common.isSupportedChainId = function(chainId) {
        var initializedChains = $bNSDz._getInitializedChains();
        return Boolean(initializedChains["names"][chainId.toString()]);
    };
    Common._getChainParams = function(chain, customChains) {
        var initializedChains = $bNSDz._getInitializedChains(customChains);
        if (typeof chain === "number" || $eqs3F.BN.isBN(chain)) {
            chain = chain.toString();
            if (initializedChains["names"][chain]) {
                var name_1 = initializedChains["names"][chain];
                return initializedChains[name_1];
            }
            throw new Error("Chain with ID " + chain + " not supported");
        }
        if (initializedChains[chain]) return initializedChains[chain];
        throw new Error("Chain with name " + chain + " not supported");
    };
    /**
     * Sets the chain
     * @param chain String ('mainnet') or Number (1) chain
     *     representation. Or, a Dictionary of chain parameters for a private network.
     * @returns The dictionary with parameters set as chain
     */ Common.prototype.setChain = function(chain) {
        var e_1, _a;
        if (typeof chain === "number" || typeof chain === "string" || $eqs3F.BN.isBN(chain)) this._chainParams = Common._getChainParams(chain, this._customChains);
        else if (typeof chain === "object") {
            if (this._customChains.length > 0) throw new Error("Chain must be a string, number, or BN when initialized with customChains passed in");
            var required = [
                "networkId",
                "genesis",
                "hardforks",
                "bootstrapNodes"
            ];
            try {
                for(var required_1 = $87a7f25813897ac8$var$__values(required), required_1_1 = required_1.next(); !required_1_1.done; required_1_1 = required_1.next()){
                    var param = required_1_1.value;
                    if (chain[param] === undefined) throw new Error("Missing required chain parameter: " + param);
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (required_1_1 && !required_1_1.done && (_a = required_1.return)) _a.call(required_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            this._chainParams = chain;
        } else throw new Error("Wrong input format");
        return this._chainParams;
    };
    /**
     * Sets the hardfork to get params for
     * @param hardfork String identifier (e.g. 'byzantium')
     */ Common.prototype.setHardfork = function(hardfork) {
        var e_2, _a;
        if (!this._isSupportedHardfork(hardfork)) throw new Error("Hardfork " + hardfork + " not set as supported in supportedHardforks");
        var existing = false;
        try {
            for(var HARDFORK_CHANGES_1 = $87a7f25813897ac8$var$__values($ifHyT.hardforks), HARDFORK_CHANGES_1_1 = HARDFORK_CHANGES_1.next(); !HARDFORK_CHANGES_1_1.done; HARDFORK_CHANGES_1_1 = HARDFORK_CHANGES_1.next()){
                var hfChanges = HARDFORK_CHANGES_1_1.value;
                if (hfChanges[0] === hardfork) {
                    if (this._hardfork !== hardfork) {
                        this._hardfork = hardfork;
                        this.emit("hardforkChanged", hardfork);
                    }
                    existing = true;
                }
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_1_1 && !HARDFORK_CHANGES_1_1.done && (_a = HARDFORK_CHANGES_1.return)) _a.call(HARDFORK_CHANGES_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        if (!existing) throw new Error("Hardfork with name " + hardfork + " not supported");
    };
    /**
     * Returns the hardfork based on the block number provided
     * @param blockNumber
     * @returns The name of the HF
     */ Common.prototype.getHardforkByBlockNumber = function(blockNumber) {
        var e_3, _a;
        blockNumber = $eqs3F.toType(blockNumber, $eqs3F.TypeOutput.BN);
        var hardfork = $87a7f25813897ac8$var$Hardfork.Chainstart;
        try {
            for(var _b = $87a7f25813897ac8$var$__values(this.hardforks()), _c = _b.next(); !_c.done; _c = _b.next()){
                var hf = _c.value;
                // Skip comparison for not applied HFs
                if (hf.block === null) continue;
                if (blockNumber.gte(new $eqs3F.BN(hf.block))) hardfork = hf.name;
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return hardfork;
    };
    /**
     * Sets a new hardfork based on the block number provided
     * @param blockNumber
     * @returns The name of the HF set
     */ Common.prototype.setHardforkByBlockNumber = function(blockNumber) {
        blockNumber = $eqs3F.toType(blockNumber, $eqs3F.TypeOutput.BN);
        var hardfork = this.getHardforkByBlockNumber(blockNumber);
        this.setHardfork(hardfork);
        return hardfork;
    };
    /**
     * Internal helper function to choose between hardfork set and hardfork provided as param
     * @param hardfork Hardfork given to function as a parameter
     * @returns Hardfork chosen to be used
     */ Common.prototype._chooseHardfork = function(hardfork, onlySupported) {
        if (onlySupported === void 0) onlySupported = true;
        if (!hardfork) hardfork = this._hardfork;
        else if (onlySupported && !this._isSupportedHardfork(hardfork)) throw new Error("Hardfork " + hardfork + " not set as supported in supportedHardforks");
        return hardfork;
    };
    /**
     * Internal helper function, returns the params for the given hardfork for the chain set
     * @param hardfork Hardfork name
     * @returns Dictionary with hardfork params
     */ Common.prototype._getHardfork = function(hardfork) {
        var e_4, _a;
        var hfs = this.hardforks();
        try {
            for(var hfs_1 = $87a7f25813897ac8$var$__values(hfs), hfs_1_1 = hfs_1.next(); !hfs_1_1.done; hfs_1_1 = hfs_1.next()){
                var hf = hfs_1_1.value;
                if (hf["name"] === hardfork) return hf;
            }
        } catch (e_4_1) {
            e_4 = {
                error: e_4_1
            };
        } finally{
            try {
                if (hfs_1_1 && !hfs_1_1.done && (_a = hfs_1.return)) _a.call(hfs_1);
            } finally{
                if (e_4) throw e_4.error;
            }
        }
        throw new Error("Hardfork " + hardfork + " not defined for chain " + this.chainName());
    };
    /**
     * Internal helper function to check if a hardfork is set to be supported by the library
     * @param hardfork Hardfork name
     * @returns True if hardfork is supported
     */ Common.prototype._isSupportedHardfork = function(hardfork) {
        var e_5, _a;
        if (this._supportedHardforks.length > 0) try {
            for(var _b = $87a7f25813897ac8$var$__values(this._supportedHardforks), _c = _b.next(); !_c.done; _c = _b.next()){
                var supportedHf = _c.value;
                if (hardfork === supportedHf) return true;
            }
        } catch (e_5_1) {
            e_5 = {
                error: e_5_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_5) throw e_5.error;
            }
        }
        else return true;
        return false;
    };
    /**
     * Sets the active EIPs
     * @param eips
     */ Common.prototype.setEIPs = function(eips) {
        var e_6, _a;
        var _this = this;
        if (eips === void 0) eips = [];
        var _loop_1 = function(eip) {
            if (!(eip in $dyf0U.EIPs)) throw new Error(eip + " not supported");
            var minHF = this_1.gteHardfork($dyf0U.EIPs[eip]["minimumHardfork"]);
            if (!minHF) throw new Error(eip + " cannot be activated on hardfork " + this_1.hardfork() + ", minimumHardfork: " + minHF);
            if ($dyf0U.EIPs[eip].requiredEIPs) // eslint-disable-next-line prettier/prettier
            $dyf0U.EIPs[eip].requiredEIPs.forEach(function(elem) {
                if (!(eips.includes(elem) || _this.isActivatedEIP(elem))) throw new Error(eip + " requires EIP " + elem + ", but is not included in the EIP list");
            });
        };
        var this_1 = this;
        try {
            for(var eips_2 = $87a7f25813897ac8$var$__values(eips), eips_2_1 = eips_2.next(); !eips_2_1.done; eips_2_1 = eips_2.next()){
                var eip = eips_2_1.value;
                _loop_1(eip);
            }
        } catch (e_6_1) {
            e_6 = {
                error: e_6_1
            };
        } finally{
            try {
                if (eips_2_1 && !eips_2_1.done && (_a = eips_2.return)) _a.call(eips_2);
            } finally{
                if (e_6) throw e_6.error;
            }
        }
        this._eips = eips;
    };
    /**
     * Returns a parameter for the current chain setup
     *
     * If the parameter is present in an EIP, the EIP always takes precendence.
     * Otherwise the parameter if taken from the latest applied HF with
     * a change on the respective parameter.
     *
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @returns The value requested or `null` if not found
     */ Common.prototype.param = function(topic, name) {
        var e_7, _a;
        // TODO: consider the case that different active EIPs
        // can change the same parameter
        var value = null;
        try {
            for(var _b = $87a7f25813897ac8$var$__values(this._eips), _c = _b.next(); !_c.done; _c = _b.next()){
                var eip = _c.value;
                value = this.paramByEIP(topic, name, eip);
                if (value !== null) return value;
            }
        } catch (e_7_1) {
            e_7 = {
                error: e_7_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_7) throw e_7.error;
            }
        }
        return this.paramByHardfork(topic, name, this._hardfork);
    };
    /**
     * Returns the parameter corresponding to a hardfork
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param hardfork Hardfork name
     * @returns The value requested or `null` if not found
     */ Common.prototype.paramByHardfork = function(topic, name, hardfork) {
        var e_8, _a, e_9, _b;
        hardfork = this._chooseHardfork(hardfork);
        var value = null;
        try {
            for(var HARDFORK_CHANGES_2 = $87a7f25813897ac8$var$__values($ifHyT.hardforks), HARDFORK_CHANGES_2_1 = HARDFORK_CHANGES_2.next(); !HARDFORK_CHANGES_2_1.done; HARDFORK_CHANGES_2_1 = HARDFORK_CHANGES_2.next()){
                var hfChanges = HARDFORK_CHANGES_2_1.value;
                // EIP-referencing HF file (e.g. berlin.json)
                if (hfChanges[1].hasOwnProperty("eips")) {
                    var hfEIPs = hfChanges[1]["eips"];
                    try {
                        for(var hfEIPs_1 = (e_9 = void 0, $87a7f25813897ac8$var$__values(hfEIPs)), hfEIPs_1_1 = hfEIPs_1.next(); !hfEIPs_1_1.done; hfEIPs_1_1 = hfEIPs_1.next()){
                            var eip = hfEIPs_1_1.value;
                            var valueEIP = this.paramByEIP(topic, name, eip);
                            value = valueEIP !== null ? valueEIP : value;
                        }
                    } catch (e_9_1) {
                        e_9 = {
                            error: e_9_1
                        };
                    } finally{
                        try {
                            if (hfEIPs_1_1 && !hfEIPs_1_1.done && (_b = hfEIPs_1.return)) _b.call(hfEIPs_1);
                        } finally{
                            if (e_9) throw e_9.error;
                        }
                    }
                // Paramater-inlining HF file (e.g. istanbul.json)
                } else {
                    if (!hfChanges[1][topic]) throw new Error("Topic " + topic + " not defined");
                    if (hfChanges[1][topic][name] !== undefined) value = hfChanges[1][topic][name].v;
                }
                if (hfChanges[0] === hardfork) break;
            }
        } catch (e_8_1) {
            e_8 = {
                error: e_8_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_2_1 && !HARDFORK_CHANGES_2_1.done && (_a = HARDFORK_CHANGES_2.return)) _a.call(HARDFORK_CHANGES_2);
            } finally{
                if (e_8) throw e_8.error;
            }
        }
        return value;
    };
    /**
     * Returns a parameter corresponding to an EIP
     * @param topic Parameter topic ('gasConfig', 'gasPrices', 'vm', 'pow')
     * @param name Parameter name (e.g. 'minGasLimit' for 'gasConfig' topic)
     * @param eip Number of the EIP
     * @returns The value requested or `null` if not found
     */ Common.prototype.paramByEIP = function(topic, name, eip) {
        if (!(eip in $dyf0U.EIPs)) throw new Error(eip + " not supported");
        var eipParams = $dyf0U.EIPs[eip];
        if (!(topic in eipParams)) throw new Error("Topic " + topic + " not defined");
        if (eipParams[topic][name] === undefined) return null;
        var value = eipParams[topic][name].v;
        return value;
    };
    /**
     * Returns a parameter for the hardfork active on block number
     * @param topic Parameter topic
     * @param name Parameter name
     * @param blockNumber Block number
     */ Common.prototype.paramByBlock = function(topic, name, blockNumber) {
        var activeHfs = this.activeHardforks(blockNumber);
        var hardfork = activeHfs[activeHfs.length - 1]["name"];
        return this.paramByHardfork(topic, name, hardfork);
    };
    /**
     * Checks if an EIP is activated by either being included in the EIPs
     * manually passed in with the {@link CommonOpts.eips} or in a
     * hardfork currently being active
     *
     * Note: this method only works for EIPs being supported
     * by the {@link CommonOpts.eips} constructor option
     * @param eip
     */ Common.prototype.isActivatedEIP = function(eip) {
        var e_10, _a;
        if (this.eips().includes(eip)) return true;
        try {
            for(var HARDFORK_CHANGES_3 = $87a7f25813897ac8$var$__values($ifHyT.hardforks), HARDFORK_CHANGES_3_1 = HARDFORK_CHANGES_3.next(); !HARDFORK_CHANGES_3_1.done; HARDFORK_CHANGES_3_1 = HARDFORK_CHANGES_3.next()){
                var hfChanges = HARDFORK_CHANGES_3_1.value;
                var hf = hfChanges[1];
                if (this.gteHardfork(hf["name"]) && "eips" in hf) {
                    if (hf["eips"].includes(eip)) return true;
                }
            }
        } catch (e_10_1) {
            e_10 = {
                error: e_10_1
            };
        } finally{
            try {
                if (HARDFORK_CHANGES_3_1 && !HARDFORK_CHANGES_3_1.done && (_a = HARDFORK_CHANGES_3.return)) _a.call(HARDFORK_CHANGES_3);
            } finally{
                if (e_10) throw e_10.error;
            }
        }
        return false;
    };
    /**
     * Checks if set or provided hardfork is active on block number
     * @param hardfork Hardfork name or null (for HF set)
     * @param blockNumber
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if HF is active on block number
     */ Common.prototype.hardforkIsActiveOnBlock = function(hardfork, blockNumber, opts) {
        var _a;
        if (opts === void 0) opts = {};
        blockNumber = $eqs3F.toType(blockNumber, $eqs3F.TypeOutput.BN);
        var onlySupported = (_a = opts.onlySupported) !== null && _a !== void 0 ? _a : false;
        hardfork = this._chooseHardfork(hardfork, onlySupported);
        var hfBlock = this.hardforkBlockBN(hardfork);
        if (hfBlock && blockNumber.gte(hfBlock)) return true;
        return false;
    };
    /**
     * Alias to hardforkIsActiveOnBlock when hardfork is set
     * @param blockNumber
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if HF is active on block number
     */ Common.prototype.activeOnBlock = function(blockNumber, opts) {
        return this.hardforkIsActiveOnBlock(null, blockNumber, opts);
    };
    /**
     * Sequence based check if given or set HF1 is greater than or equal HF2
     * @param hardfork1 Hardfork name or null (if set)
     * @param hardfork2 Hardfork name
     * @param opts Hardfork options
     * @returns True if HF1 gte HF2
     */ Common.prototype.hardforkGteHardfork = function(hardfork1, hardfork2, opts) {
        var e_11, _a;
        if (opts === void 0) opts = {};
        var onlyActive = opts.onlyActive === undefined ? false : opts.onlyActive;
        hardfork1 = this._chooseHardfork(hardfork1, opts.onlySupported);
        var hardforks;
        if (onlyActive) hardforks = this.activeHardforks(null, opts);
        else hardforks = this.hardforks();
        var posHf1 = -1, posHf2 = -1;
        var index = 0;
        try {
            for(var hardforks_2 = $87a7f25813897ac8$var$__values(hardforks), hardforks_2_1 = hardforks_2.next(); !hardforks_2_1.done; hardforks_2_1 = hardforks_2.next()){
                var hf = hardforks_2_1.value;
                if (hf["name"] === hardfork1) posHf1 = index;
                if (hf["name"] === hardfork2) posHf2 = index;
                index += 1;
            }
        } catch (e_11_1) {
            e_11 = {
                error: e_11_1
            };
        } finally{
            try {
                if (hardforks_2_1 && !hardforks_2_1.done && (_a = hardforks_2.return)) _a.call(hardforks_2);
            } finally{
                if (e_11) throw e_11.error;
            }
        }
        return posHf1 >= posHf2 && posHf2 !== -1;
    };
    /**
     * Alias to hardforkGteHardfork when hardfork is set
     * @param hardfork Hardfork name
     * @param opts Hardfork options
     * @returns True if hardfork set is greater than hardfork provided
     */ Common.prototype.gteHardfork = function(hardfork, opts) {
        return this.hardforkGteHardfork(null, hardfork, opts);
    };
    /**
     * Checks if given or set hardfork is active on the chain
     * @param hardfork Hardfork name, optional if HF set
     * @param opts Hardfork options (onlyActive unused)
     * @returns True if hardfork is active on the chain
     */ Common.prototype.hardforkIsActiveOnChain = function(hardfork, opts) {
        var e_12, _a;
        var _b;
        if (opts === void 0) opts = {};
        var onlySupported = (_b = opts.onlySupported) !== null && _b !== void 0 ? _b : false;
        hardfork = this._chooseHardfork(hardfork, onlySupported);
        try {
            for(var _c = $87a7f25813897ac8$var$__values(this.hardforks()), _d = _c.next(); !_d.done; _d = _c.next()){
                var hf = _d.value;
                if (hf["name"] === hardfork && hf["block"] !== null) return true;
            }
        } catch (e_12_1) {
            e_12 = {
                error: e_12_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_12) throw e_12.error;
            }
        }
        return false;
    };
    /**
     * Returns the active hardfork switches for the current chain
     * @param blockNumber up to block if provided, otherwise for the whole chain
     * @param opts Hardfork options (onlyActive unused)
     * @return Array with hardfork arrays
     */ Common.prototype.activeHardforks = function(blockNumber, opts) {
        var e_13, _a;
        if (opts === void 0) opts = {};
        var activeHardforks = [];
        var hfs = this.hardforks();
        try {
            for(var hfs_2 = $87a7f25813897ac8$var$__values(hfs), hfs_2_1 = hfs_2.next(); !hfs_2_1.done; hfs_2_1 = hfs_2.next()){
                var hf = hfs_2_1.value;
                if (hf["block"] === null) continue;
                if (blockNumber !== undefined && blockNumber !== null && blockNumber < hf["block"]) break;
                if (opts.onlySupported && !this._isSupportedHardfork(hf["name"])) continue;
                activeHardforks.push(hf);
            }
        } catch (e_13_1) {
            e_13 = {
                error: e_13_1
            };
        } finally{
            try {
                if (hfs_2_1 && !hfs_2_1.done && (_a = hfs_2.return)) _a.call(hfs_2);
            } finally{
                if (e_13) throw e_13.error;
            }
        }
        return activeHardforks;
    };
    /**
     * Returns the latest active hardfork name for chain or block or throws if unavailable
     * @param blockNumber up to block if provided, otherwise for the whole chain
     * @param opts Hardfork options (onlyActive unused)
     * @return Hardfork name
     */ Common.prototype.activeHardfork = function(blockNumber, opts) {
        if (opts === void 0) opts = {};
        var activeHardforks = this.activeHardforks(blockNumber, opts);
        if (activeHardforks.length > 0) return activeHardforks[activeHardforks.length - 1]["name"];
        else throw new Error("No (supported) active hardfork found");
    };
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number
     * @deprecated Please use hardforkBlockBN() for large number support
     */ Common.prototype.hardforkBlock = function(hardfork) {
        return $eqs3F.toType(this.hardforkBlockBN(hardfork), $eqs3F.TypeOutput.Number);
    };
    /**
     * Returns the hardfork change block for hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number
     */ Common.prototype.hardforkBlockBN = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        return new $eqs3F.BN(this._getHardfork(hardfork)["block"]);
    };
    /**
     * True if block number provided is the hardfork (given or set) change block
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     */ Common.prototype.isHardforkBlock = function(blockNumber, hardfork) {
        blockNumber = $eqs3F.toType(blockNumber, $eqs3F.TypeOutput.BN);
        hardfork = this._chooseHardfork(hardfork, false);
        return this.hardforkBlockBN(hardfork).eq(blockNumber);
    };
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if not available
     * @deprecated Please use nextHardforkBlockBN() for large number support
     */ Common.prototype.nextHardforkBlock = function(hardfork) {
        var block = this.nextHardforkBlockBN(hardfork);
        return block === null ? null : $eqs3F.toType(block, $eqs3F.TypeOutput.Number);
    };
    /**
     * Returns the change block for the next hardfork after the hardfork provided or set
     * @param hardfork Hardfork name, optional if HF set
     * @returns Block number or null if not available
     */ Common.prototype.nextHardforkBlockBN = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var hfBlock = this.hardforkBlockBN(hardfork);
        // Next fork block number or null if none available
        // Logic: if accumulator is still null and on the first occurence of
        // a block greater than the current hfBlock set the accumulator,
        // pass on the accumulator as the final result from this time on
        var nextHfBlock = this.hardforks().reduce(function(acc, hf) {
            var block = new $eqs3F.BN(hf.block);
            return block.gt(hfBlock) && acc === null ? block : acc;
        }, null);
        return nextHfBlock;
    };
    /**
     * True if block number provided is the hardfork change block following the hardfork given or set
     * @param blockNumber Number of the block to check
     * @param hardfork Hardfork name, optional if HF set
     * @returns True if blockNumber is HF block
     */ Common.prototype.isNextHardforkBlock = function(blockNumber, hardfork) {
        blockNumber = $eqs3F.toType(blockNumber, $eqs3F.TypeOutput.BN);
        hardfork = this._chooseHardfork(hardfork, false);
        var nextHardforkBlock = this.nextHardforkBlockBN(hardfork);
        return nextHardforkBlock === null ? false : nextHardforkBlock.eq(blockNumber);
    };
    /**
     * Internal helper function to calculate a fork hash
     * @param hardfork Hardfork name
     * @returns Fork hash as hex string
     */ Common.prototype._calcForkHash = function(hardfork) {
        var e_14, _a;
        var genesis = $87a7f25813897ac8$require$Buffer.from(this.genesis().hash.substr(2), "hex");
        var hfBuffer = $87a7f25813897ac8$require$Buffer.alloc(0);
        var prevBlock = 0;
        try {
            for(var _b = $87a7f25813897ac8$var$__values(this.hardforks()), _c = _b.next(); !_c.done; _c = _b.next()){
                var hf = _c.value;
                var block = hf.block;
                // Skip for chainstart (0), not applied HFs (null) and
                // when already applied on same block number HFs
                if (block !== 0 && block !== null && block !== prevBlock) {
                    var hfBlockBuffer = $87a7f25813897ac8$require$Buffer.from(block.toString(16).padStart(16, "0"), "hex");
                    hfBuffer = $87a7f25813897ac8$require$Buffer.concat([
                        hfBuffer,
                        hfBlockBuffer
                    ]);
                }
                if (hf.name === hardfork) break;
                prevBlock = block;
            }
        } catch (e_14_1) {
            e_14 = {
                error: e_14_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_14) throw e_14.error;
            }
        }
        var inputBuffer = $87a7f25813897ac8$require$Buffer.concat([
            genesis,
            hfBuffer
        ]);
        // CRC32 delivers result as signed (negative) 32-bit integer,
        // convert to hex string
        var forkhash = $eqs3F.intToBuffer($70UGJ.buf(inputBuffer) >>> 0).toString("hex");
        return "0x" + forkhash;
    };
    /**
     * Returns an eth/64 compliant fork hash (EIP-2124)
     * @param hardfork Hardfork name, optional if HF set
     */ Common.prototype.forkHash = function(hardfork) {
        hardfork = this._chooseHardfork(hardfork, false);
        var data = this._getHardfork(hardfork);
        if (data["block"] === null) {
            var msg = "No fork hash calculation possible for non-applied or future hardfork";
            throw new Error(msg);
        }
        if (data["forkHash"] !== undefined) return data["forkHash"];
        return this._calcForkHash(hardfork);
    };
    /**
     *
     * @param forkHash Fork hash as a hex string
     * @returns Array with hardfork data (name, block, forkHash)
     */ Common.prototype.hardforkForForkHash = function(forkHash) {
        var resArray = this.hardforks().filter(function(hf) {
            return hf.forkHash === forkHash;
        });
        return resArray.length >= 1 ? resArray[resArray.length - 1] : null;
    };
    /**
     * Returns the Genesis parameters of current chain
     * @returns Genesis dictionary
     */ Common.prototype.genesis = function() {
        return this._chainParams["genesis"];
    };
    /**
     * Returns the hardforks for current chain
     * @returns {Array} Array with arrays of hardforks
     */ Common.prototype.hardforks = function() {
        return this._chainParams["hardforks"];
    };
    /**
     * Returns bootstrap nodes for the current chain
     * @returns {Dictionary} Dict with bootstrap nodes
     */ Common.prototype.bootstrapNodes = function() {
        return this._chainParams["bootstrapNodes"];
    };
    /**
     * Returns DNS networks for the current chain
     * @returns {String[]} Array of DNS ENR urls
     */ Common.prototype.dnsNetworks = function() {
        return this._chainParams["dnsNetworks"];
    };
    /**
     * Returns the hardfork set
     * @returns Hardfork name
     */ Common.prototype.hardfork = function() {
        return this._hardfork;
    };
    /**
     * Returns the Id of current chain
     * @returns chain Id
     * @deprecated Please use chainIdBN() for large number support
     */ Common.prototype.chainId = function() {
        return $eqs3F.toType(this.chainIdBN(), $eqs3F.TypeOutput.Number);
    };
    /**
     * Returns the Id of current chain
     * @returns chain Id
     */ Common.prototype.chainIdBN = function() {
        return new $eqs3F.BN(this._chainParams["chainId"]);
    };
    /**
     * Returns the name of current chain
     * @returns chain name (lower case)
     */ Common.prototype.chainName = function() {
        return this._chainParams["name"];
    };
    /**
     * Returns the Id of current network
     * @returns network Id
     * @deprecated Please use networkIdBN() for large number support
     */ Common.prototype.networkId = function() {
        return $eqs3F.toType(this.networkIdBN(), $eqs3F.TypeOutput.Number);
    };
    /**
     * Returns the Id of current network
     * @returns network Id
     */ Common.prototype.networkIdBN = function() {
        return new $eqs3F.BN(this._chainParams["networkId"]);
    };
    /**
     * Returns the active EIPs
     * @returns List of EIPs
     */ Common.prototype.eips = function() {
        return this._eips;
    };
    /**
     * Returns the consensus type of the network
     * Possible values: "pow"|"poa"
     */ Common.prototype.consensusType = function() {
        return this._chainParams["consensus"]["type"];
    };
    /**
     * Returns the concrete consensus implementation
     * algorithm or protocol for the network
     * e.g. "ethash" for "pow" consensus type or
     * "clique" for "poa" consensus type
     */ Common.prototype.consensusAlgorithm = function() {
        return this._chainParams["consensus"]["algorithm"];
    };
    /**
     * Returns a dictionary with consensus configuration
     * parameters based on the consensus algorithm
     *
     * Expected returns (parameters must be present in
     * the respective chain json files):
     *
     * ethash: -
     * clique: period, epoch
     * aura: -
     */ Common.prototype.consensusConfig = function() {
        return this._chainParams["consensus"][this.consensusAlgorithm()];
    };
    /**
     * Returns a deep copy of this {@link Common} instance.
     */ Common.prototype.copy = function() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this);
    };
    return Common;
}($jMc9N.EventEmitter);
module.exports.default = $87a7f25813897ac8$var$Common;

});
parcelRegister("70UGJ", function(module, exports) {
/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $51b4819b61af78fe$var$CRC32;
(function(factory) {
    /*jshint ignore:start */ /*eslint-disable */ if (typeof DO_NOT_EXPORT_CRC === "undefined") factory(module.exports);
    else factory($51b4819b61af78fe$var$CRC32 = {});
/*eslint-enable */ /*jshint ignore:end */ })(function(CRC32) {
    CRC32.version = "1.2.0";
    /* see perf/crc32table.js */ /*global Int32Array */ function signed_crc_table() {
        var c = 0, table = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== "undefined" ? new Int32Array(table) : table;
    }
    var T = signed_crc_table();
    function crc32_bstr(bstr, seed) {
        var C = seed ^ -1, L = bstr.length - 1;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
            C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        }
        if (i === L) C = C >>> 8 ^ T[(C ^ bstr.charCodeAt(i)) & 0xFF];
        return C ^ -1;
    }
    function crc32_buf(buf, seed) {
        if (buf.length > 10000) return crc32_buf_8(buf, seed);
        var C = seed ^ -1, L = buf.length - 3;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        }
        while(i < L + 3)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        return C ^ -1;
    }
    function crc32_buf_8(buf, seed) {
        var C = seed ^ -1, L = buf.length - 7;
        for(var i = 0; i < L;){
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
            C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        }
        while(i < L + 7)C = C >>> 8 ^ T[(C ^ buf[i++]) & 0xFF];
        return C ^ -1;
    }
    function crc32_str(str, seed) {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c, d; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return C ^ -1;
    }
    CRC32.table = T;
    // $FlowIgnore
    CRC32.bstr = crc32_bstr;
    // $FlowIgnore
    CRC32.buf = crc32_buf;
    // $FlowIgnore
    CRC32.str = crc32_str;
});

});

parcelRegister("eqs3F", function(module, exports) {
"use strict";
var $a8094223c0f1b5e3$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a8094223c0f1b5e3$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $a8094223c0f1b5e3$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/// <reference path="./@types/ethjs-util/index.ts"/>
/**
 * Constants
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("cjwEX")), module.exports);

/**
 * Account class and helper functions
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("25kzW")), module.exports);

/**
 * Address type
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("dUBqU")), module.exports);

/**
 * Hash functions
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("gnQU8")), module.exports);

/**
 * ECDSA signature
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("tdm0D")), module.exports);

/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("7Usx4")), module.exports);

/**
 * Function for definining properties on an object
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("jhaqU")), module.exports);

/**
 * External exports (BN, rlp, secp256k1)
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("7HC2t")), module.exports);

/**
 * Helpful TypeScript types
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("gO7zN")), module.exports);

/**
 * Export ethjs-util methods
 */ $a8094223c0f1b5e3$var$__exportStar((parcelRequire("aFbW5")), module.exports);

});
parcelRegister("cjwEX", function(module, exports) {
"use strict";
var $8f7097e301e8c6da$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KECCAK256_RLP = module.exports.KECCAK256_RLP_S = module.exports.KECCAK256_RLP_ARRAY = module.exports.KECCAK256_RLP_ARRAY_S = module.exports.KECCAK256_NULL = module.exports.KECCAK256_NULL_S = module.exports.TWO_POW256 = module.exports.MAX_INTEGER = void 0;

var $ihoyg = parcelRequire("ihoyg");
var $8f7097e301e8c6da$require$Buffer = $ihoyg.Buffer;

var $8f7097e301e8c6da$var$bn_js_1 = $8f7097e301e8c6da$var$__importDefault((parcelRequire("bzyAZ")));
/**
 * The max integer that this VM can handle
 */ module.exports.MAX_INTEGER = new $8f7097e301e8c6da$var$bn_js_1.default("ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff", 16);
/**
 * 2^256
 */ module.exports.TWO_POW256 = new $8f7097e301e8c6da$var$bn_js_1.default("10000000000000000000000000000000000000000000000000000000000000000", 16);
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL = $8f7097e301e8c6da$require$Buffer.from(module.exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY = $8f7097e301e8c6da$require$Buffer.from(module.exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP = $8f7097e301e8c6da$require$Buffer.from(module.exports.KECCAK256_RLP_S, "hex");

});
parcelRegister("bzyAZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("25kzW", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $184c02e319f70b4f$require$Buffer = $ihoyg.Buffer;
"use strict";
var $184c02e319f70b4f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $184c02e319f70b4f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $184c02e319f70b4f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $184c02e319f70b4f$var$__createBinding(result, mod, k);
    }
    $184c02e319f70b4f$var$__setModuleDefault(result, mod);
    return result;
};
var $184c02e319f70b4f$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $184c02e319f70b4f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isZeroAddress = module.exports.zeroAddress = module.exports.importPublic = module.exports.privateToAddress = module.exports.privateToPublic = module.exports.publicToAddress = module.exports.pubToAddress = module.exports.isValidPublic = module.exports.isValidPrivate = module.exports.generateAddress2 = module.exports.generateAddress = module.exports.isValidChecksumAddress = module.exports.toChecksumAddress = module.exports.isValidAddress = module.exports.Account = void 0;

var $184c02e319f70b4f$var$assert_1 = $184c02e319f70b4f$var$__importDefault((parcelRequire("bhJ7Q")));

var $184c02e319f70b4f$var$bn_js_1 = $184c02e319f70b4f$var$__importDefault((parcelRequire("bzyAZ")));

var $184c02e319f70b4f$var$rlp = $184c02e319f70b4f$var$__importStar((parcelRequire("thfOi")));

var $l3pVp = parcelRequire("l3pVp");

var $aFbW5 = parcelRequire("aFbW5");

var $cjwEX = parcelRequire("cjwEX");

var $7Usx4 = parcelRequire("7Usx4");

var $gnQU8 = parcelRequire("gnQU8");

var $bRaTu = parcelRequire("bRaTu");

var $gO7zN = parcelRequire("gO7zN");
var $184c02e319f70b4f$var$Account = /** @class */ function() {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ function Account(nonce, balance, stateRoot, codeHash) {
        if (nonce === void 0) nonce = new $184c02e319f70b4f$var$bn_js_1.default(0);
        if (balance === void 0) balance = new $184c02e319f70b4f$var$bn_js_1.default(0);
        if (stateRoot === void 0) stateRoot = $cjwEX.KECCAK256_RLP;
        if (codeHash === void 0) codeHash = $cjwEX.KECCAK256_NULL;
        this.nonce = nonce;
        this.balance = balance;
        this.stateRoot = stateRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    Account.fromAccountData = function(accountData) {
        var nonce = accountData.nonce, balance = accountData.balance, stateRoot = accountData.stateRoot, codeHash = accountData.codeHash;
        return new Account(nonce ? new $184c02e319f70b4f$var$bn_js_1.default($7Usx4.toBuffer(nonce)) : undefined, balance ? new $184c02e319f70b4f$var$bn_js_1.default($7Usx4.toBuffer(balance)) : undefined, stateRoot ? $7Usx4.toBuffer(stateRoot) : undefined, codeHash ? $7Usx4.toBuffer(codeHash) : undefined);
    };
    Account.fromRlpSerializedAccount = function(serialized) {
        var values = $184c02e319f70b4f$var$rlp.decode(serialized);
        if (!Array.isArray(values)) throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(values);
    };
    Account.fromValuesArray = function(values) {
        var _a = $184c02e319f70b4f$var$__read(values, 4), nonce = _a[0], balance = _a[1], stateRoot = _a[2], codeHash = _a[3];
        return new Account(new $184c02e319f70b4f$var$bn_js_1.default(nonce), new $184c02e319f70b4f$var$bn_js_1.default(balance), stateRoot, codeHash);
    };
    Account.prototype._validate = function() {
        if (this.nonce.lt(new $184c02e319f70b4f$var$bn_js_1.default(0))) throw new Error("nonce must be greater than zero");
        if (this.balance.lt(new $184c02e319f70b4f$var$bn_js_1.default(0))) throw new Error("balance must be greater than zero");
        if (this.stateRoot.length !== 32) throw new Error("stateRoot must have a length of 32");
        if (this.codeHash.length !== 32) throw new Error("codeHash must have a length of 32");
    };
    /**
     * Returns a Buffer Array of the raw Buffers for the account, in order.
     */ Account.prototype.raw = function() {
        return [
            $gO7zN.bnToUnpaddedBuffer(this.nonce),
            $gO7zN.bnToUnpaddedBuffer(this.balance),
            this.stateRoot,
            this.codeHash
        ];
    };
    /**
     * Returns the RLP serialization of the account as a `Buffer`.
     */ Account.prototype.serialize = function() {
        return $184c02e319f70b4f$var$rlp.encode(this.raw());
    };
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ Account.prototype.isContract = function() {
        return !this.codeHash.equals($cjwEX.KECCAK256_NULL);
    };
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ Account.prototype.isEmpty = function() {
        return this.balance.isZero() && this.nonce.isZero() && this.codeHash.equals($cjwEX.KECCAK256_NULL);
    };
    return Account;
}();
module.exports.Account = $184c02e319f70b4f$var$Account;
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ module.exports.isValidAddress = function(hexAddress) {
    try {
        $bRaTu.assertIsString(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
/**
 * Returns a checksummed address.
 *
 * If a eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details see [EIP-1191](https://eips.ethereum.org/EIPS/eip-1191).
 *
 * WARNING: Checksums with and without the chainId will differ. As of 2019-06-26, the most commonly
 * used variation in Ethereum was without the chainId. This may change in the future.
 */ module.exports.toChecksumAddress = function(hexAddress, eip1191ChainId) {
    $bRaTu.assertIsHexString(hexAddress);
    var address = $aFbW5.stripHexPrefix(hexAddress).toLowerCase();
    var prefix = "";
    if (eip1191ChainId) {
        var chainId = $gO7zN.toType(eip1191ChainId, $gO7zN.TypeOutput.BN);
        prefix = chainId.toString() + "0x";
    }
    var hash = $gnQU8.keccakFromString(prefix + address).toString("hex");
    var ret = "0x";
    for(var i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ module.exports.isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return module.exports.isValidAddress(hexAddress) && module.exports.toChecksumAddress(hexAddress, eip1191ChainId) === hexAddress;
};
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ module.exports.generateAddress = function(from, nonce) {
    $bRaTu.assertIsBuffer(from);
    $bRaTu.assertIsBuffer(nonce);
    var nonceBN = new $184c02e319f70b4f$var$bn_js_1.default(nonce);
    if (nonceBN.isZero()) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return $gnQU8.rlphash([
        from,
        null
    ]).slice(-20);
    // Only take the lower 160bits of the hash
    return $gnQU8.rlphash([
        from,
        $184c02e319f70b4f$require$Buffer.from(nonceBN.toArray())
    ]).slice(-20);
};
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ module.exports.generateAddress2 = function(from, salt, initCode) {
    $bRaTu.assertIsBuffer(from);
    $bRaTu.assertIsBuffer(salt);
    $bRaTu.assertIsBuffer(initCode);
    $184c02e319f70b4f$var$assert_1.default(from.length === 20);
    $184c02e319f70b4f$var$assert_1.default(salt.length === 32);
    var address = $gnQU8.keccak256($184c02e319f70b4f$require$Buffer.concat([
        $184c02e319f70b4f$require$Buffer.from("ff", "hex"),
        from,
        salt,
        $gnQU8.keccak256(initCode)
    ]));
    return address.slice(-20);
};
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ module.exports.isValidPrivate = function(privateKey) {
    return $l3pVp.privateKeyVerify(privateKey);
};
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ module.exports.isValidPublic = function(publicKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    $bRaTu.assertIsBuffer(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    return $l3pVp.publicKeyVerify($184c02e319f70b4f$require$Buffer.concat([
        $184c02e319f70b4f$require$Buffer.from([
            4
        ]),
        publicKey
    ]));
    if (!sanitize) return false;
    return $l3pVp.publicKeyVerify(publicKey);
};
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ module.exports.pubToAddress = function(pubKey, sanitize) {
    if (sanitize === void 0) sanitize = false;
    $bRaTu.assertIsBuffer(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = $184c02e319f70b4f$require$Buffer.from($l3pVp.publicKeyConvert(pubKey, false).slice(1));
    $184c02e319f70b4f$var$assert_1.default(pubKey.length === 64);
    // Only take the lower 160bits of the hash
    return $gnQU8.keccak(pubKey).slice(-20);
};
module.exports.publicToAddress = module.exports.pubToAddress;
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ module.exports.privateToPublic = function(privateKey) {
    $bRaTu.assertIsBuffer(privateKey);
    // skip the type flag and use the X, Y points
    return $184c02e319f70b4f$require$Buffer.from($l3pVp.publicKeyCreate(privateKey, false)).slice(1);
};
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ module.exports.privateToAddress = function(privateKey) {
    return module.exports.publicToAddress(module.exports.privateToPublic(privateKey));
};
/**
 * Converts a public key to the Ethereum format.
 */ module.exports.importPublic = function(publicKey) {
    $bRaTu.assertIsBuffer(publicKey);
    if (publicKey.length !== 64) publicKey = $184c02e319f70b4f$require$Buffer.from($l3pVp.publicKeyConvert(publicKey, false).slice(1));
    return publicKey;
};
/**
 * Returns the zero address.
 */ module.exports.zeroAddress = function() {
    var addressLength = 20;
    var addr = $7Usx4.zeros(addressLength);
    return $7Usx4.bufferToHex(addr);
};
/**
 * Checks if a given address is the zero address.
 */ module.exports.isZeroAddress = function(hexAddress) {
    try {
        $bRaTu.assertIsString(hexAddress);
    } catch (e) {
        return false;
    }
    var zeroAddr = module.exports.zeroAddress();
    return zeroAddr === hexAddress;
};

});
parcelRegister("thfOi", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $058017d57f9e35bc$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getLength = module.exports.decode = module.exports.encode = void 0;

var $7vYz3 = parcelRequire("7vYz3");
/**
 * RLP Encoding based on: https://github.com/ethereum/wiki/wiki/%5BEnglish%5D-RLP
 * This function takes in a data, convert it to buffer if not, and a length for recursion
 * @param input - will be converted to buffer
 * @returns returns buffer of encoded data
 **/ function $058017d57f9e35bc$var$encode(input) {
    if (Array.isArray(input)) {
        var output = [];
        for(var i = 0; i < input.length; i++)output.push($058017d57f9e35bc$var$encode(input[i]));
        var buf = $058017d57f9e35bc$require$Buffer.concat(output);
        return $058017d57f9e35bc$require$Buffer.concat([
            $058017d57f9e35bc$var$encodeLength(buf.length, 192),
            buf
        ]);
    } else {
        var inputBuf = $058017d57f9e35bc$var$toBuffer(input);
        return inputBuf.length === 1 && inputBuf[0] < 128 ? inputBuf : $058017d57f9e35bc$require$Buffer.concat([
            $058017d57f9e35bc$var$encodeLength(inputBuf.length, 128),
            inputBuf
        ]);
    }
}
module.exports.encode = $058017d57f9e35bc$var$encode;
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 * @param base The base to parse the integer into
 */ function $058017d57f9e35bc$var$safeParseInt(v, base) {
    if (v.slice(0, 2) === "00") throw new Error("invalid RLP: extra zeros");
    return parseInt(v, base);
}
function $058017d57f9e35bc$var$encodeLength(len, offset) {
    if (len < 56) return $058017d57f9e35bc$require$Buffer.from([
        len + offset
    ]);
    else {
        var hexLength = $058017d57f9e35bc$var$intToHex(len);
        var lLength = hexLength.length / 2;
        var firstByte = $058017d57f9e35bc$var$intToHex(offset + 55 + lLength);
        return $058017d57f9e35bc$require$Buffer.from(firstByte + hexLength, "hex");
    }
}
function $058017d57f9e35bc$var$decode(input, stream) {
    if (stream === void 0) stream = false;
    if (!input || input.length === 0) return $058017d57f9e35bc$require$Buffer.from([]);
    var inputBuffer = $058017d57f9e35bc$var$toBuffer(input);
    var decoded = $058017d57f9e35bc$var$_decode(inputBuffer);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid remainder");
    return decoded.data;
}
module.exports.decode = $058017d57f9e35bc$var$decode;
/**
 * Get the length of the RLP input
 * @param input
 * @returns The length of the input or an empty Buffer if no input
 */ function $058017d57f9e35bc$var$getLength(input) {
    if (!input || input.length === 0) return $058017d57f9e35bc$require$Buffer.from([]);
    var inputBuffer = $058017d57f9e35bc$var$toBuffer(input);
    var firstByte = inputBuffer[0];
    if (firstByte <= 0x7f) return inputBuffer.length;
    else if (firstByte <= 0xb7) return firstByte - 0x7f;
    else if (firstByte <= 0xbf) return firstByte - 0xb6;
    else if (firstByte <= 0xf7) // a list between  0-55 bytes long
    return firstByte - 0xbf;
    else {
        // a list  over 55 bytes long
        var llength = firstByte - 0xf6;
        var length = $058017d57f9e35bc$var$safeParseInt(inputBuffer.slice(1, llength).toString("hex"), 16);
        return llength + length;
    }
}
module.exports.getLength = $058017d57f9e35bc$var$getLength;
/** Decode an input with RLP */ function $058017d57f9e35bc$var$_decode(input) {
    var length, llength, data, innerRemainder, d;
    var decoded = [];
    var firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = $058017d57f9e35bc$require$Buffer.from([]);
        else data = input.slice(1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid rlp encoding: byte must be less 0x80");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $058017d57f9e35bc$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = input.slice(llength, length + llength);
        if (data.length < length) throw new Error("invalid RLP: not enough bytes for string");
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between  0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = input.slice(1, length);
        while(innerRemainder.length){
            d = $058017d57f9e35bc$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list  over 55 bytes long
        llength = firstByte - 0xf6;
        length = $058017d57f9e35bc$var$safeParseInt(input.slice(1, llength).toString("hex"), 16);
        var totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid rlp: total length is larger than the data");
        innerRemainder = input.slice(llength, totalLength);
        if (innerRemainder.length === 0) throw new Error("invalid rlp, List has a invalid length");
        while(innerRemainder.length){
            d = $058017d57f9e35bc$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
/** Check if a string is prefixed by 0x */ function $058017d57f9e35bc$var$isHexPrefixed(str) {
    return str.slice(0, 2) === "0x";
}
/** Removes 0x from a given String */ function $058017d57f9e35bc$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $058017d57f9e35bc$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform an integer into its hexadecimal value */ function $058017d57f9e35bc$var$intToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    var hex = integer.toString(16);
    return hex.length % 2 ? "0" + hex : hex;
}
/** Pad a string to be even */ function $058017d57f9e35bc$var$padToEven(a) {
    return a.length % 2 ? "0" + a : a;
}
/** Transform an integer into a Buffer */ function $058017d57f9e35bc$var$intToBuffer(integer) {
    var hex = $058017d57f9e35bc$var$intToHex(integer);
    return $058017d57f9e35bc$require$Buffer.from(hex, "hex");
}
/** Transform anything into a Buffer */ function $058017d57f9e35bc$var$toBuffer(v) {
    if (!$058017d57f9e35bc$require$Buffer.isBuffer(v)) {
        if (typeof v === "string") {
            if ($058017d57f9e35bc$var$isHexPrefixed(v)) return $058017d57f9e35bc$require$Buffer.from($058017d57f9e35bc$var$padToEven($058017d57f9e35bc$var$stripHexPrefix(v)), "hex");
            else return $058017d57f9e35bc$require$Buffer.from(v);
        } else if (typeof v === "number" || typeof v === "bigint") {
            if (!v) return $058017d57f9e35bc$require$Buffer.from([]);
            else return $058017d57f9e35bc$var$intToBuffer(v);
        } else if (v === null || v === undefined) return $058017d57f9e35bc$require$Buffer.from([]);
        else if (v instanceof Uint8Array) return $058017d57f9e35bc$require$Buffer.from(v);
        else if ($7vYz3.isBN(v)) // converts a BN to a Buffer
        return $058017d57f9e35bc$require$Buffer.from(v.toArray());
        else throw new Error("invalid type");
    }
    return v;
}

});

parcelRegister("l3pVp", function(module, exports) {
"use strict";
var $f53dfcf19c0773d5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f53dfcf19c0773d5$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $f53dfcf19c0773d5$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});


var $jbii1 = parcelRequire("jbii1");
var $f53dfcf19c0773d5$var$SECP256K1_PRIVATE_KEY_SIZE = 32;
function $f53dfcf19c0773d5$var$createPrivateKey() {
    return $f53dfcf19c0773d5$var$__awaiter(this, void 0, void 0, function() {
        var pk;
        return $f53dfcf19c0773d5$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        $jbii1.getRandomBytes($f53dfcf19c0773d5$var$SECP256K1_PRIVATE_KEY_SIZE)
                    ];
                case 1:
                    pk = _a.sent();
                    if ((parcelRequire("6nAvv")).privateKeyVerify(pk)) return [
                        2 /*return*/ ,
                        pk
                    ];
                    return [
                        3 /*break*/ ,
                        0
                    ];
                case 2:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.createPrivateKey = $f53dfcf19c0773d5$var$createPrivateKey;
function $f53dfcf19c0773d5$var$createPrivateKeySync() {
    while(true){
        var pk = $jbii1.getRandomBytesSync($f53dfcf19c0773d5$var$SECP256K1_PRIVATE_KEY_SIZE);
        if ((parcelRequire("6nAvv")).privateKeyVerify(pk)) return pk;
    }
}
module.exports.createPrivateKeySync = $f53dfcf19c0773d5$var$createPrivateKeySync;

$f53dfcf19c0773d5$var$__export((parcelRequire("6nAvv")));

});
parcelRegister("6nAvv", function(module, exports) {


module.exports = (parcelRequire("1txlI"))((parcelRequire("bfW9V")));

});
parcelRegister("1txlI", function(module, exports) {
const $11325e57f028843e$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $11325e57f028843e$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $11325e57f028843e$var$isUint8Array(name, value, length) {
    $11325e57f028843e$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $11325e57f028843e$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $11325e57f028843e$var$assert(value.length === length, msg);
        }
    }
}
function $11325e57f028843e$var$isCompressed(value) {
    $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $11325e57f028843e$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $11325e57f028843e$var$isUint8Array("output", output, length);
    return output;
}
function $11325e57f028843e$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $11325e57f028843e$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $11325e57f028843e$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($11325e57f028843e$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            $11325e57f028843e$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            $11325e57f028843e$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $11325e57f028843e$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $11325e57f028843e$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isUint8Array("tweak", tweak, 32);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isUint8Array("tweak", tweak, 32);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $11325e57f028843e$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $11325e57f028843e$var$isUint8Array("signature", sig, 64);
            output = $11325e57f028843e$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $11325e57f028843e$var$isUint8Array("signature", sig);
            output = $11325e57f028843e$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $11325e57f028843e$var$isUint8Array("message", msg32, 32);
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $11325e57f028843e$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $11325e57f028843e$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIGN);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $11325e57f028843e$var$isUint8Array("signature", sig, 64);
            $11325e57f028843e$var$isUint8Array("message", msg32, 32);
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $11325e57f028843e$var$isUint8Array("signature", sig, 64);
            $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $11325e57f028843e$var$isUint8Array("message", msg32, 32);
            $11325e57f028843e$var$isCompressed(compressed);
            output = $11325e57f028843e$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.RECOVER);
                case 3:
                    throw new Error($11325e57f028843e$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $11325e57f028843e$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $11325e57f028843e$var$isUint8Array("private key", seckey, 32);
            $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $11325e57f028843e$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $11325e57f028843e$var$assert($11325e57f028843e$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $11325e57f028843e$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $11325e57f028843e$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $11325e57f028843e$var$isUint8Array("output", output);
            } else output = $11325e57f028843e$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($11325e57f028843e$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($11325e57f028843e$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("bfW9V", function(module, exports) {

var $8J1ou = parcelRequire("8J1ou");
var $831e3595a081723e$require$EC = $8J1ou.ec;
const $831e3595a081723e$var$ec = new $831e3595a081723e$require$EC("secp256k1");
const $831e3595a081723e$var$ecparams = $831e3595a081723e$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $831e3595a081723e$var$BN = $831e3595a081723e$var$ecparams.n.constructor;
function $831e3595a081723e$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $831e3595a081723e$var$BN(xbuf);
    // overflow
    if (x.cmp($831e3595a081723e$var$ecparams.p) >= 0) return null;
    x = x.toRed($831e3595a081723e$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($831e3595a081723e$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $831e3595a081723e$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $831e3595a081723e$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $831e3595a081723e$var$BN(xbuf);
    let y = new $831e3595a081723e$var$BN(ybuf);
    // overflow
    if (x.cmp($831e3595a081723e$var$ecparams.p) >= 0 || y.cmp($831e3595a081723e$var$ecparams.p) >= 0) return null;
    x = x.toRed($831e3595a081723e$var$ecparams.red);
    y = y.toRed($831e3595a081723e$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($831e3595a081723e$var$ecparams.b)).isZero()) return null;
    return $831e3595a081723e$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $831e3595a081723e$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $831e3595a081723e$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $831e3595a081723e$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $831e3595a081723e$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $831e3595a081723e$var$BN(seckey);
        return bn.cmp($831e3595a081723e$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $831e3595a081723e$var$BN(seckey);
        const negate = $831e3595a081723e$var$ecparams.n.sub(bn).umod($831e3595a081723e$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $831e3595a081723e$var$BN(tweak);
        if (bn.cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $831e3595a081723e$var$BN(seckey));
        if (bn.cmp($831e3595a081723e$var$ecparams.n) >= 0) bn.isub($831e3595a081723e$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $831e3595a081723e$var$BN(tweak);
        if (bn.cmp($831e3595a081723e$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $831e3595a081723e$var$BN(seckey));
        if (bn.cmp($831e3595a081723e$var$ecparams.n) >= 0) bn = bn.umod($831e3595a081723e$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $831e3595a081723e$var$BN(seckey);
        if (bn.cmp($831e3595a081723e$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $831e3595a081723e$var$ec.keyFromPrivate(seckey).getPublic();
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $831e3595a081723e$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $831e3595a081723e$var$BN(tweak);
        if (tweak.cmp($831e3595a081723e$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($831e3595a081723e$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $831e3595a081723e$var$BN(tweak);
        if (tweak.cmp($831e3595a081723e$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $831e3595a081723e$var$BN(sig.subarray(0, 32));
        const s = new $831e3595a081723e$var$BN(sig.subarray(32, 64));
        if (r.cmp($831e3595a081723e$var$ecparams.n) >= 0 || s.cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        if (s.cmp($831e3595a081723e$var$ec.nh) === 1) sig.set($831e3595a081723e$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $831e3595a081723e$var$BN(sigR).cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        if (new $831e3595a081723e$var$BN(sigS).cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $831e3595a081723e$var$BN(sigR);
        if (r.cmp($831e3595a081723e$var$ecparams.n) >= 0) r = new $831e3595a081723e$var$BN(0);
        let s = new $831e3595a081723e$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($831e3595a081723e$var$ecparams.n) >= 0) s = new $831e3595a081723e$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $831e3595a081723e$var$BN(nonce);
            };
        }
        const d = new $831e3595a081723e$var$BN(seckey);
        if (d.cmp($831e3595a081723e$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $831e3595a081723e$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $831e3595a081723e$var$BN(sigObj.r);
        const sigs = new $831e3595a081723e$var$BN(sigObj.s);
        if (sigr.cmp($831e3595a081723e$var$ecparams.n) >= 0 || sigs.cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($831e3595a081723e$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $831e3595a081723e$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $831e3595a081723e$var$BN(sigObj.r);
        const sigs = new $831e3595a081723e$var$BN(sigObj.s);
        if (sigr.cmp($831e3595a081723e$var$ecparams.n) >= 0 || sigs.cmp($831e3595a081723e$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $831e3595a081723e$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $831e3595a081723e$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $831e3595a081723e$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $831e3595a081723e$var$BN(seckey);
        if (scalar.cmp($831e3595a081723e$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $831e3595a081723e$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});


parcelRegister("jbii1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $5rfiH = parcelRequire("5rfiH");
function $df6d3b5413d9798f$var$getRandomBytes(bytes) {
    return new Promise(function(resolve, reject) {
        $5rfiH(bytes, function(err, resp) {
            if (err) {
                reject(err);
                return;
            }
            resolve(resp);
        });
    });
}
module.exports.getRandomBytes = $df6d3b5413d9798f$var$getRandomBytes;
function $df6d3b5413d9798f$var$getRandomBytesSync(bytes) {
    return $5rfiH(bytes);
}
module.exports.getRandomBytesSync = $df6d3b5413d9798f$var$getRandomBytesSync;

});


parcelRegister("aFbW5", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $7c36fdf31c4ea18f$require$Buffer = $ihoyg.Buffer;
"use strict";

var $d5RtO = parcelRequire("d5RtO");

var $gZv7G = parcelRequire("gZv7G");
/**
 * Pads a `String` to have an even length
 * @param {String} value
 * @return {String} output
 */ function $7c36fdf31c4ea18f$var$padToEven(value) {
    var a = value; // eslint-disable-line
    if (typeof a !== "string") throw new Error("[ethjs-util] while padding to even, value must be string, is currently " + typeof a + ", while padToEven.");
    if (a.length % 2) a = "0" + a;
    return a;
}
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ function $7c36fdf31c4ea18f$var$intToHex(i) {
    var hex = i.toString(16); // eslint-disable-line
    return "0x" + hex;
}
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ function $7c36fdf31c4ea18f$var$intToBuffer(i) {
    var hex = $7c36fdf31c4ea18f$var$intToHex(i);
    return new $7c36fdf31c4ea18f$require$Buffer($7c36fdf31c4ea18f$var$padToEven(hex.slice(2)), "hex");
}
/**
 * Get the binary size of a string
 * @param {String} str
 * @return {Number}
 */ function $7c36fdf31c4ea18f$var$getBinarySize(str) {
    if (typeof str !== "string") throw new Error("[ethjs-util] while getting binary size, method getBinarySize requires input 'str' to be type String, got '" + typeof str + "'.");
    return $7c36fdf31c4ea18f$require$Buffer.byteLength(str, "utf8");
}
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param {array} superset
 * @param {array} subset
 *
 * @returns {boolean}
 */ function $7c36fdf31c4ea18f$var$arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'superset' to be an array got type '" + typeof superset + "'");
    if (Array.isArray(subset) !== true) throw new Error("[ethjs-util] method arrayContainsArray requires input 'subset' to be an array got type '" + typeof subset + "'");
    return subset[Boolean(some) && "some" || "every"](function(value) {
        return superset.indexOf(value) >= 0;
    });
}
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method toUtf8
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function $7c36fdf31c4ea18f$var$toUtf8(hex) {
    var bufferValue = new $7c36fdf31c4ea18f$require$Buffer($7c36fdf31c4ea18f$var$padToEven($gZv7G(hex).replace(/^0+|0+$/g, "")), "hex");
    return bufferValue.toString("utf8");
}
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method toAscii
 * @param {String} string in hex
 * @returns {String} ascii string representation of hex value
 */ function $7c36fdf31c4ea18f$var$toAscii(hex) {
    var str = ""; // eslint-disable-line
    var i = 0, l = hex.length; // eslint-disable-line
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method fromUtf8
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function $7c36fdf31c4ea18f$var$fromUtf8(stringValue) {
    var str = new $7c36fdf31c4ea18f$require$Buffer(stringValue, "utf8");
    return "0x" + $7c36fdf31c4ea18f$var$padToEven(str.toString("hex")).replace(/^0+|0+$/g, "");
}
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method fromAscii
 * @param {String} string
 * @param {Number} optional padding
 * @returns {String} hex representation of input string
 */ function $7c36fdf31c4ea18f$var$fromAscii(stringValue) {
    var hex = ""; // eslint-disable-line
    for(var i = 0; i < stringValue.length; i++){
        // eslint-disable-line
        var code = stringValue.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
}
/**
 * getKeys([{a: 1, b: 2}, {a: 3, b: 4}], 'a') => [1, 3]
 *
 * @method getKeys get specific key from inner object array of objects
 * @param {String} params
 * @param {String} key
 * @param {Boolean} allowEmpty
 * @returns {Array} output just a simple array of output keys
 */ function $7c36fdf31c4ea18f$var$getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error("[ethjs-util] method getKeys expecting type Array as 'params' input, got '" + typeof params + "'");
    if (typeof key !== "string") throw new Error("[ethjs-util] method getKeys expecting type String for input 'key' got '" + typeof key + "'.");
    var result = []; // eslint-disable-line
    for(var i = 0; i < params.length; i++){
        // eslint-disable-line
        var value = params[i][key]; // eslint-disable-line
        if (allowEmpty && !value) value = "";
        else if (typeof value !== "string") throw new Error("invalid abi");
        result.push(value);
    }
    return result;
}
/**
 * Is the string a hex string.
 *
 * @method check if string is hex string of specific length
 * @param {String} value
 * @param {Number} length
 * @returns {Boolean} output the string is a hex string
 */ function $7c36fdf31c4ea18f$var$isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports = {
    arrayContainsArray: $7c36fdf31c4ea18f$var$arrayContainsArray,
    intToBuffer: $7c36fdf31c4ea18f$var$intToBuffer,
    getBinarySize: $7c36fdf31c4ea18f$var$getBinarySize,
    isHexPrefixed: $d5RtO,
    stripHexPrefix: $gZv7G,
    padToEven: $7c36fdf31c4ea18f$var$padToEven,
    intToHex: $7c36fdf31c4ea18f$var$intToHex,
    fromAscii: $7c36fdf31c4ea18f$var$fromAscii,
    fromUtf8: $7c36fdf31c4ea18f$var$fromUtf8,
    toAscii: $7c36fdf31c4ea18f$var$toAscii,
    toUtf8: $7c36fdf31c4ea18f$var$toUtf8,
    getKeys: $7c36fdf31c4ea18f$var$getKeys,
    isHexString: $7c36fdf31c4ea18f$var$isHexString
};

});
parcelRegister("d5RtO", function(module, exports) {
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param {String} str the string input value
 * @return {Boolean} a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ module.exports = function isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error("[is-hex-prefixed] value must be type 'string', is currently type " + typeof str + ", while checking isHexPrefixed.");
    return str.slice(0, 2) === "0x";
};

});

parcelRegister("gZv7G", function(module, exports) {

var $d5RtO = parcelRequire("d5RtO");
/**
 * Removes '0x' from a given `String` is present
 * @param {String} str the string value
 * @return {String|Optional} a string by pass if necessary
 */ module.exports = function stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $d5RtO(str) ? str.slice(2) : str;
};

});


parcelRegister("7Usx4", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5c23e54c8a1fec14$require$Buffer = $ihoyg.Buffer;
"use strict";
var $5c23e54c8a1fec14$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.baToJSON = module.exports.addHexPrefix = module.exports.toUnsigned = module.exports.fromSigned = module.exports.bufferToHex = module.exports.bufferToInt = module.exports.toBuffer = module.exports.unpadHexString = module.exports.unpadArray = module.exports.unpadBuffer = module.exports.setLengthRight = module.exports.setLengthLeft = module.exports.zeros = void 0;

var $5c23e54c8a1fec14$var$bn_js_1 = $5c23e54c8a1fec14$var$__importDefault((parcelRequire("bzyAZ")));

var $aFbW5 = parcelRequire("aFbW5");

var $bRaTu = parcelRequire("bRaTu");
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ module.exports.zeros = function(bytes) {
    return $5c23e54c8a1fec14$require$Buffer.allocUnsafe(bytes).fill(0);
};
/**
 * Pads a `Buffer` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer)
 */ var $5c23e54c8a1fec14$var$setLength = function(msg, length, right) {
    var buf = module.exports.zeros(length);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Left Pads a `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ module.exports.setLengthLeft = function(msg, length) {
    $bRaTu.assertIsBuffer(msg);
    return $5c23e54c8a1fec14$var$setLength(msg, length, false);
};
/**
 * Right Pads a `Buffer` with trailing zeros till it has `length` bytes.
 * it truncates the end if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ module.exports.setLengthRight = function(msg, length) {
    $bRaTu.assertIsBuffer(msg);
    return $5c23e54c8a1fec14$var$setLength(msg, length, true);
};
/**
 * Trims leading zeros from a `Buffer`, `String` or `Number[]`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ var $5c23e54c8a1fec14$var$stripZeros = function(a) {
    var first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Trims leading zeros from a `Buffer`.
 * @param a (Buffer)
 * @return (Buffer)
 */ module.exports.unpadBuffer = function(a) {
    $bRaTu.assertIsBuffer(a);
    return $5c23e54c8a1fec14$var$stripZeros(a);
};
/**
 * Trims leading zeros from an `Array` (of numbers).
 * @param a (number[])
 * @return (number[])
 */ module.exports.unpadArray = function(a) {
    $bRaTu.assertIsArray(a);
    return $5c23e54c8a1fec14$var$stripZeros(a);
};
/**
 * Trims leading zeros from a hex-prefixed `String`.
 * @param a (String)
 * @return (String)
 */ module.exports.unpadHexString = function(a) {
    $bRaTu.assertIsHexString(a);
    a = $aFbW5.stripHexPrefix(a);
    return $5c23e54c8a1fec14$var$stripZeros(a);
};
/**
 * Attempts to turn a value into a `Buffer`.
 * Inputs supported: `Buffer`, `String` (hex-prefixed), `Number`, null/undefined, `BN` and other objects
 * with a `toArray()` or `toBuffer()` method.
 * @param v the value
 */ module.exports.toBuffer = function(v) {
    if (v === null || v === undefined) return $5c23e54c8a1fec14$require$Buffer.allocUnsafe(0);
    if ($5c23e54c8a1fec14$require$Buffer.isBuffer(v)) return $5c23e54c8a1fec14$require$Buffer.from(v);
    if (Array.isArray(v) || v instanceof Uint8Array) return $5c23e54c8a1fec14$require$Buffer.from(v);
    if (typeof v === "string") {
        if (!$aFbW5.isHexString(v)) throw new Error("Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: " + v);
        return $5c23e54c8a1fec14$require$Buffer.from($aFbW5.padToEven($aFbW5.stripHexPrefix(v)), "hex");
    }
    if (typeof v === "number") return $aFbW5.intToBuffer(v);
    if ($5c23e54c8a1fec14$var$bn_js_1.default.isBN(v)) return v.toArrayLike($5c23e54c8a1fec14$require$Buffer);
    if (v.toArray) // converts a BN to a Buffer
    return $5c23e54c8a1fec14$require$Buffer.from(v.toArray());
    if (v.toBuffer) return $5c23e54c8a1fec14$require$Buffer.from(v.toBuffer());
    throw new Error("invalid type");
};
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ module.exports.bufferToInt = function(buf) {
    return new $5c23e54c8a1fec14$var$bn_js_1.default(module.exports.toBuffer(buf)).toNumber();
};
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ module.exports.bufferToHex = function(buf) {
    buf = module.exports.toBuffer(buf);
    return "0x" + buf.toString("hex");
};
/**
 * Interprets a `Buffer` as a signed integer and returns a `BN`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ module.exports.fromSigned = function(num) {
    return new $5c23e54c8a1fec14$var$bn_js_1.default(num).fromTwos(256);
};
/**
 * Converts a `BN` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ module.exports.toUnsigned = function(num) {
    return $5c23e54c8a1fec14$require$Buffer.from(num.toTwos(256).toArray());
};
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ module.exports.addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return $aFbW5.isHexPrefixed(str) ? str : "0x" + str;
};
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ module.exports.baToJSON = function(ba) {
    if ($5c23e54c8a1fec14$require$Buffer.isBuffer(ba)) return "0x" + ba.toString("hex");
    else if (ba instanceof Array) {
        var array = [];
        for(var i = 0; i < ba.length; i++)array.push(module.exports.baToJSON(ba[i]));
        return array;
    }
};

});
parcelRegister("bRaTu", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a1d18443c5daaf2$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertIsString = module.exports.assertIsArray = module.exports.assertIsBuffer = module.exports.assertIsHexString = void 0;

var $aFbW5 = parcelRequire("aFbW5");
/**
 * Throws if a string is not hex prefixed
 * @param {string} input string to check hex prefix of
 */ module.exports.assertIsHexString = function(input) {
    if (!$aFbW5.isHexString(input)) {
        var msg = "This method only supports 0x-prefixed hex strings but input was: " + input;
        throw new Error(msg);
    }
};
/**
 * Throws if input is not a buffer
 * @param {Buffer} input value to check
 */ module.exports.assertIsBuffer = function(input) {
    if (!$8a1d18443c5daaf2$require$Buffer.isBuffer(input)) {
        var msg = "This method only supports Buffer but input was: " + input;
        throw new Error(msg);
    }
};
/**
 * Throws if input is not an array
 * @param {number[]} input value to check
 */ module.exports.assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        var msg = "This method only supports number arrays but input was: " + input;
        throw new Error(msg);
    }
};
/**
 * Throws if input is not a string
 * @param {string} input value to check
 */ module.exports.assertIsString = function(input) {
    if (typeof input !== "string") {
        var msg = "This method only supports strings but input was: " + input;
        throw new Error(msg);
    }
};

});


parcelRegister("gnQU8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bed7d50827abc79f$require$Buffer = $ihoyg.Buffer;
"use strict";
var $bed7d50827abc79f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $bed7d50827abc79f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $bed7d50827abc79f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $bed7d50827abc79f$var$__createBinding(result, mod, k);
    }
    $bed7d50827abc79f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlphash = module.exports.ripemd160FromArray = module.exports.ripemd160FromString = module.exports.ripemd160 = module.exports.sha256FromArray = module.exports.sha256FromString = module.exports.sha256 = module.exports.keccakFromArray = module.exports.keccakFromHexString = module.exports.keccakFromString = module.exports.keccak256 = module.exports.keccak = void 0;

var $8wvhD = parcelRequire("8wvhD");

var $3FiLE = parcelRequire("3FiLE");

var $bed7d50827abc79f$var$rlp = $bed7d50827abc79f$var$__importStar((parcelRequire("thfOi")));

var $7Usx4 = parcelRequire("7Usx4");

var $bRaTu = parcelRequire("bRaTu");
/**
 * Creates Keccak hash of a Buffer input
 * @param a The input data (Buffer)
 * @param bits (number = 256) The Keccak width
 */ module.exports.keccak = function(a, bits) {
    if (bits === void 0) bits = 256;
    $bRaTu.assertIsBuffer(a);
    switch(bits){
        case 224:
            return $8wvhD.keccak224(a);
        case 256:
            return $8wvhD.keccak256(a);
        case 384:
            return $8wvhD.keccak384(a);
        case 512:
            return $8wvhD.keccak512(a);
        default:
            throw new Error("Invald algorithm: keccak" + bits);
    }
};
/**
 * Creates Keccak-256 hash of the input, alias for keccak(a, 256).
 * @param a The input data (Buffer)
 */ module.exports.keccak256 = function(a) {
    return module.exports.keccak(a);
};
/**
 * Creates Keccak hash of a utf-8 string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ module.exports.keccakFromString = function(a, bits) {
    if (bits === void 0) bits = 256;
    $bRaTu.assertIsString(a);
    var buf = $bed7d50827abc79f$require$Buffer.from(a, "utf8");
    return module.exports.keccak(buf, bits);
};
/**
 * Creates Keccak hash of an 0x-prefixed string input
 * @param a The input data (String)
 * @param bits (number = 256) The Keccak width
 */ module.exports.keccakFromHexString = function(a, bits) {
    if (bits === void 0) bits = 256;
    $bRaTu.assertIsHexString(a);
    return module.exports.keccak($7Usx4.toBuffer(a), bits);
};
/**
 * Creates Keccak hash of a number array input
 * @param a The input data (number[])
 * @param bits (number = 256) The Keccak width
 */ module.exports.keccakFromArray = function(a, bits) {
    if (bits === void 0) bits = 256;
    $bRaTu.assertIsArray(a);
    return module.exports.keccak($7Usx4.toBuffer(a), bits);
};
/**
 * Creates SHA256 hash of an input.
 * @param  a The input data (Buffer|Array|String)
 */ var $bed7d50827abc79f$var$_sha256 = function(a) {
    a = $7Usx4.toBuffer(a);
    return $3FiLE("sha256").update(a).digest();
};
/**
 * Creates SHA256 hash of a Buffer input.
 * @param a The input data (Buffer)
 */ module.exports.sha256 = function(a) {
    $bRaTu.assertIsBuffer(a);
    return $bed7d50827abc79f$var$_sha256(a);
};
/**
 * Creates SHA256 hash of a string input.
 * @param a The input data (string)
 */ module.exports.sha256FromString = function(a) {
    $bRaTu.assertIsString(a);
    return $bed7d50827abc79f$var$_sha256(a);
};
/**
 * Creates SHA256 hash of a number[] input.
 * @param a The input data (number[])
 */ module.exports.sha256FromArray = function(a) {
    $bRaTu.assertIsArray(a);
    return $bed7d50827abc79f$var$_sha256(a);
};
/**
 * Creates RIPEMD160 hash of the input.
 * @param a The input data (Buffer|Array|String|Number)
 * @param padded Whether it should be padded to 256 bits or not
 */ var $bed7d50827abc79f$var$_ripemd160 = function(a, padded) {
    a = $7Usx4.toBuffer(a);
    var hash = $3FiLE("rmd160").update(a).digest();
    if (padded === true) return $7Usx4.setLengthLeft(hash, 32);
    else return hash;
};
/**
 * Creates RIPEMD160 hash of a Buffer input.
 * @param a The input data (Buffer)
 * @param padded Whether it should be padded to 256 bits or not
 */ module.exports.ripemd160 = function(a, padded) {
    $bRaTu.assertIsBuffer(a);
    return $bed7d50827abc79f$var$_ripemd160(a, padded);
};
/**
 * Creates RIPEMD160 hash of a string input.
 * @param a The input data (String)
 * @param padded Whether it should be padded to 256 bits or not
 */ module.exports.ripemd160FromString = function(a, padded) {
    $bRaTu.assertIsString(a);
    return $bed7d50827abc79f$var$_ripemd160(a, padded);
};
/**
 * Creates RIPEMD160 hash of a number[] input.
 * @param a The input data (number[])
 * @param padded Whether it should be padded to 256 bits or not
 */ module.exports.ripemd160FromArray = function(a, padded) {
    $bRaTu.assertIsArray(a);
    return $bed7d50827abc79f$var$_ripemd160(a, padded);
};
/**
 * Creates SHA-3 hash of the RLP encoded version of the input.
 * @param a The input data
 */ module.exports.rlphash = function(a) {
    return module.exports.keccak($bed7d50827abc79f$var$rlp.encode(a));
};

});
parcelRegister("8wvhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3EWa8 = parcelRequire("3EWa8");

var $bwBbC = parcelRequire("bwBbC");
module.exports.keccak224 = $3EWa8.createHashFunction(function() {
    return $bwBbC("keccak224");
});
module.exports.keccak256 = $3EWa8.createHashFunction(function() {
    return $bwBbC("keccak256");
});
module.exports.keccak384 = $3EWa8.createHashFunction(function() {
    return $bwBbC("keccak384");
});
module.exports.keccak512 = $3EWa8.createHashFunction(function() {
    return $bwBbC("keccak512");
});

});
parcelRegister("3EWa8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $2aa239654483e6dc$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $2aa239654483e6dc$var$createHashFunction(hashConstructor) {
    return function(msg) {
        var hash = hashConstructor();
        hash.update(msg);
        return $2aa239654483e6dc$require$Buffer.from(hash.digest());
    };
}
module.exports.createHashFunction = $2aa239654483e6dc$var$createHashFunction;

});

parcelRegister("bwBbC", function(module, exports) {


module.exports = (parcelRequire("lFie1"))((parcelRequire("OMLiT")));

});
parcelRegister("lFie1", function(module, exports) {

var $h5UTs = parcelRequire("h5UTs");

var $bncCR = parcelRequire("bncCR");
module.exports = function(KeccakState) {
    const Keccak = $h5UTs(KeccakState);
    const Shake = $bncCR(KeccakState);
    return function(algorithm, options) {
        const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

});
parcelRegister("h5UTs", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c71f0927cae117bb$require$Buffer = $ihoyg.Buffer;

var $bks2w = parcelRequire("bks2w");
var $c71f0927cae117bb$require$Transform = $bks2w.Transform;
module.exports = (KeccakState)=>class Keccak extends $c71f0927cae117bb$require$Transform {
        constructor(rate, capacity, delimitedSuffix, hashBitLength, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._hashBitLength = hashBitLength;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush(callback) {
            let error = null;
            try {
                this.push(this.digest());
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        update(data, encoding) {
            if (!$c71f0927cae117bb$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Digest already called");
            if (!$c71f0927cae117bb$require$Buffer.isBuffer(data)) data = $c71f0927cae117bb$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        digest(encoding) {
            if (this._finalized) throw new Error("Digest already called");
            this._finalized = true;
            if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
            let digest = this._state.squeeze(this._hashBitLength / 8);
            if (encoding !== undefined) digest = digest.toString(encoding);
            this._resetState();
            return digest;
        }
        // remove result from memory
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        // because sometimes we need hash right now and little later
        _clone() {
            const clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});

parcelRegister("bncCR", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $847ba2e50bfac482$require$Buffer = $ihoyg.Buffer;

var $bks2w = parcelRequire("bks2w");
var $847ba2e50bfac482$require$Transform = $bks2w.Transform;
module.exports = (KeccakState)=>class Shake extends $847ba2e50bfac482$require$Transform {
        constructor(rate, capacity, delimitedSuffix, options){
            super(options);
            this._rate = rate;
            this._capacity = capacity;
            this._delimitedSuffix = delimitedSuffix;
            this._options = options;
            this._state = new KeccakState();
            this._state.initialize(rate, capacity);
            this._finalized = false;
        }
        _transform(chunk, encoding, callback) {
            let error = null;
            try {
                this.update(chunk, encoding);
            } catch (err) {
                error = err;
            }
            callback(error);
        }
        _flush() {}
        _read(size) {
            this.push(this.squeeze(size));
        }
        update(data, encoding) {
            if (!$847ba2e50bfac482$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
            if (this._finalized) throw new Error("Squeeze already called");
            if (!$847ba2e50bfac482$require$Buffer.isBuffer(data)) data = $847ba2e50bfac482$require$Buffer.from(data, encoding);
            this._state.absorb(data);
            return this;
        }
        squeeze(dataByteLength, encoding) {
            if (!this._finalized) {
                this._finalized = true;
                this._state.absorbLastFewBits(this._delimitedSuffix);
            }
            let data = this._state.squeeze(dataByteLength);
            if (encoding !== undefined) data = data.toString(encoding);
            return data;
        }
        _resetState() {
            this._state.initialize(this._rate, this._capacity);
            return this;
        }
        _clone() {
            const clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
            this._state.copy(clone._state);
            clone._finalized = this._finalized;
            return clone;
        }
    };

});


parcelRegister("OMLiT", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $098a7ebca24f0f7d$require$Buffer = $ihoyg.Buffer;

var $110qB = parcelRequire("110qB");
function $098a7ebca24f0f7d$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$098a7ebca24f0f7d$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(let i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$098a7ebca24f0f7d$var$Keccak.prototype.absorb = function(data) {
    for(let i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $110qB.p1600(this.state);
            this.count = 0;
        }
    }
};
$098a7ebca24f0f7d$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $110qB.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $110qB.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$098a7ebca24f0f7d$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    const output = $098a7ebca24f0f7d$require$Buffer.alloc(length);
    for(let i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $110qB.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$098a7ebca24f0f7d$var$Keccak.prototype.copy = function(dest) {
    for(let i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $098a7ebca24f0f7d$var$Keccak;

});
parcelRegister("110qB", function(module, exports) {

$parcel$export(module.exports, "p1600", function () { return $0bd6376c3c540080$export$471358fe9e8379c0; }, function (v) { return $0bd6376c3c540080$export$471358fe9e8379c0 = v; });
var $0bd6376c3c540080$export$471358fe9e8379c0;
const $0bd6376c3c540080$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$0bd6376c3c540080$export$471358fe9e8379c0 = function(s) {
    for(let round = 0; round < 24; ++round){
        // theta
        const lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        const hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        const lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        const hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        const lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        const hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        const lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        const hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        const lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        const hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        let lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        let hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        const t1slo0 = s[0] ^ lo;
        const t1shi0 = s[1] ^ hi;
        const t1slo5 = s[10] ^ lo;
        const t1shi5 = s[11] ^ hi;
        const t1slo10 = s[20] ^ lo;
        const t1shi10 = s[21] ^ hi;
        const t1slo15 = s[30] ^ lo;
        const t1shi15 = s[31] ^ hi;
        const t1slo20 = s[40] ^ lo;
        const t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        const t1slo1 = s[2] ^ lo;
        const t1shi1 = s[3] ^ hi;
        const t1slo6 = s[12] ^ lo;
        const t1shi6 = s[13] ^ hi;
        const t1slo11 = s[22] ^ lo;
        const t1shi11 = s[23] ^ hi;
        const t1slo16 = s[32] ^ lo;
        const t1shi16 = s[33] ^ hi;
        const t1slo21 = s[42] ^ lo;
        const t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        const t1slo2 = s[4] ^ lo;
        const t1shi2 = s[5] ^ hi;
        const t1slo7 = s[14] ^ lo;
        const t1shi7 = s[15] ^ hi;
        const t1slo12 = s[24] ^ lo;
        const t1shi12 = s[25] ^ hi;
        const t1slo17 = s[34] ^ lo;
        const t1shi17 = s[35] ^ hi;
        const t1slo22 = s[44] ^ lo;
        const t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        const t1slo3 = s[6] ^ lo;
        const t1shi3 = s[7] ^ hi;
        const t1slo8 = s[16] ^ lo;
        const t1shi8 = s[17] ^ hi;
        const t1slo13 = s[26] ^ lo;
        const t1shi13 = s[27] ^ hi;
        const t1slo18 = s[36] ^ lo;
        const t1shi18 = s[37] ^ hi;
        const t1slo23 = s[46] ^ lo;
        const t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        const t1slo4 = s[8] ^ lo;
        const t1shi4 = s[9] ^ hi;
        const t1slo9 = s[18] ^ lo;
        const t1shi9 = s[19] ^ hi;
        const t1slo14 = s[28] ^ lo;
        const t1shi14 = s[29] ^ hi;
        const t1slo19 = s[38] ^ lo;
        const t1shi19 = s[39] ^ hi;
        const t1slo24 = s[48] ^ lo;
        const t1shi24 = s[49] ^ hi;
        // rho & pi
        const t2slo0 = t1slo0;
        const t2shi0 = t1shi0;
        const t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        const t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        const t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        const t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        const t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        const t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        const t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        const t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        const t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        const t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        const t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        const t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        const t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        const t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        const t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        const t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        const t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        const t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        const t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        const t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        const t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        const t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        const t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        const t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        const t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        const t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        const t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        const t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        const t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        const t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        const t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        const t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        const t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        const t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        const t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        const t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        const t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        const t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        const t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        const t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        const t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        const t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        const t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        const t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        const t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        const t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        const t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        const t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $0bd6376c3c540080$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $0bd6376c3c540080$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});





parcelRegister("gO7zN", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c3c7315f2c1db9c3$require$Buffer = $ihoyg.Buffer;
"use strict";
var $c3c7315f2c1db9c3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toType = module.exports.TypeOutput = module.exports.bnToRlp = module.exports.bnToUnpaddedBuffer = module.exports.bnToHex = void 0;

var $c3c7315f2c1db9c3$var$bn_js_1 = $c3c7315f2c1db9c3$var$__importDefault((parcelRequire("bzyAZ")));

var $aFbW5 = parcelRequire("aFbW5");

var $7Usx4 = parcelRequire("7Usx4");
/**
 * Convert BN to 0x-prefixed hex string.
 */ function $c3c7315f2c1db9c3$var$bnToHex(value) {
    return "0x" + value.toString(16);
}
module.exports.bnToHex = $c3c7315f2c1db9c3$var$bnToHex;
/**
 * Convert value from BN to an unpadded Buffer
 * (useful for RLP transport)
 * @param value value to convert
 */ function $c3c7315f2c1db9c3$var$bnToUnpaddedBuffer(value) {
    // Using `bn.toArrayLike(Buffer)` instead of `bn.toBuffer()`
    // for compatibility with browserify and similar tools
    return $7Usx4.unpadBuffer(value.toArrayLike($c3c7315f2c1db9c3$require$Buffer));
}
module.exports.bnToUnpaddedBuffer = $c3c7315f2c1db9c3$var$bnToUnpaddedBuffer;
/**
 * Deprecated alias for {@link bnToUnpaddedBuffer}
 * @deprecated
 */ function $c3c7315f2c1db9c3$var$bnToRlp(value) {
    return $c3c7315f2c1db9c3$var$bnToUnpaddedBuffer(value);
}
module.exports.bnToRlp = $c3c7315f2c1db9c3$var$bnToRlp;
/**
 * Type output options
 */ var $c3c7315f2c1db9c3$var$TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BN"] = 1] = "BN";
    TypeOutput[TypeOutput["Buffer"] = 2] = "Buffer";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})($c3c7315f2c1db9c3$var$TypeOutput = module.exports.TypeOutput || (module.exports.TypeOutput = {}));
/**
 * Convert an input to a specified type
 * @param input value to convert
 * @param outputType type to output
 */ function $c3c7315f2c1db9c3$var$toType(input, outputType) {
    if (typeof input === "string" && !$aFbW5.isHexString(input)) throw new Error("A string must be provided with a 0x-prefix, given: " + input);
    else if (typeof input === "number" && !Number.isSafeInteger(input)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    input = $7Usx4.toBuffer(input);
    if (outputType === $c3c7315f2c1db9c3$var$TypeOutput.Buffer) return input;
    else if (outputType === $c3c7315f2c1db9c3$var$TypeOutput.BN) return new $c3c7315f2c1db9c3$var$bn_js_1.default(input);
    else if (outputType === $c3c7315f2c1db9c3$var$TypeOutput.Number) {
        var bn = new $c3c7315f2c1db9c3$var$bn_js_1.default(input);
        var max = new $c3c7315f2c1db9c3$var$bn_js_1.default(Number.MAX_SAFE_INTEGER.toString());
        if (bn.gt(max)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
        return bn.toNumber();
    } else // outputType === TypeOutput.PrefixedHexString
    return "0x" + input.toString("hex");
}
module.exports.toType = $c3c7315f2c1db9c3$var$toType;

});


parcelRegister("dUBqU", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $a20d8ac0a06df425$require$Buffer = $ihoyg.Buffer;
"use strict";
var $a20d8ac0a06df425$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address = void 0;

var $a20d8ac0a06df425$var$assert_1 = $a20d8ac0a06df425$var$__importDefault((parcelRequire("bhJ7Q")));

var $a20d8ac0a06df425$var$bn_js_1 = $a20d8ac0a06df425$var$__importDefault((parcelRequire("bzyAZ")));

var $7Usx4 = parcelRequire("7Usx4");

var $25kzW = parcelRequire("25kzW");
var $a20d8ac0a06df425$var$Address = /** @class */ function() {
    function Address(buf) {
        $a20d8ac0a06df425$var$assert_1.default(buf.length === 20, "Invalid address length");
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */ Address.zero = function() {
        return new Address($7Usx4.zeros(20));
    };
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ Address.fromString = function(str) {
        $a20d8ac0a06df425$var$assert_1.default($25kzW.isValidAddress(str), "Invalid address");
        return new Address($7Usx4.toBuffer(str));
    };
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ Address.fromPublicKey = function(pubKey) {
        $a20d8ac0a06df425$var$assert_1.default($a20d8ac0a06df425$require$Buffer.isBuffer(pubKey), "Public key should be Buffer");
        var buf = $25kzW.pubToAddress(pubKey);
        return new Address(buf);
    };
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ Address.fromPrivateKey = function(privateKey) {
        $a20d8ac0a06df425$var$assert_1.default($a20d8ac0a06df425$require$Buffer.isBuffer(privateKey), "Private key should be Buffer");
        var buf = $25kzW.privateToAddress(privateKey);
        return new Address(buf);
    };
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ Address.generate = function(from, nonce) {
        $a20d8ac0a06df425$var$assert_1.default($a20d8ac0a06df425$var$bn_js_1.default.isBN(nonce));
        return new Address($25kzW.generateAddress(from.buf, nonce.toArrayLike($a20d8ac0a06df425$require$Buffer)));
    };
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ Address.generate2 = function(from, salt, initCode) {
        $a20d8ac0a06df425$var$assert_1.default($a20d8ac0a06df425$require$Buffer.isBuffer(salt));
        $a20d8ac0a06df425$var$assert_1.default($a20d8ac0a06df425$require$Buffer.isBuffer(initCode));
        return new Address($25kzW.generateAddress2(from.buf, salt, initCode));
    };
    /**
     * Is address equal to another.
     */ Address.prototype.equals = function(address) {
        return this.buf.equals(address.buf);
    };
    /**
     * Is address zero.
     */ Address.prototype.isZero = function() {
        return this.equals(Address.zero());
    };
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ Address.prototype.isPrecompileOrSystemAddress = function() {
        var addressBN = new $a20d8ac0a06df425$var$bn_js_1.default(this.buf);
        var rangeMin = new $a20d8ac0a06df425$var$bn_js_1.default(0);
        var rangeMax = new $a20d8ac0a06df425$var$bn_js_1.default("ffff", "hex");
        return addressBN.gte(rangeMin) && addressBN.lte(rangeMax);
    };
    /**
     * Returns hex encoding of address.
     */ Address.prototype.toString = function() {
        return "0x" + this.buf.toString("hex");
    };
    /**
     * Returns Buffer representation of address.
     */ Address.prototype.toBuffer = function() {
        return $a20d8ac0a06df425$require$Buffer.from(this.buf);
    };
    return Address;
}();
module.exports.Address = $a20d8ac0a06df425$var$Address;

});

parcelRegister("tdm0D", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $057d115f3edbcf08$require$Buffer = $ihoyg.Buffer;
"use strict";
var $057d115f3edbcf08$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashPersonalMessage = module.exports.isValidSignature = module.exports.fromRpcSig = module.exports.toCompactSig = module.exports.toRpcSig = module.exports.ecrecover = module.exports.ecsign = void 0;

var $l3pVp = parcelRequire("l3pVp");

var $057d115f3edbcf08$var$bn_js_1 = $057d115f3edbcf08$var$__importDefault((parcelRequire("bzyAZ")));

var $7Usx4 = parcelRequire("7Usx4");

var $gnQU8 = parcelRequire("gnQU8");

var $bRaTu = parcelRequire("bRaTu");

var $gO7zN = parcelRequire("gO7zN");
function $057d115f3edbcf08$var$ecsign(msgHash, privateKey, chainId) {
    var _a = $l3pVp.ecdsaSign(msgHash, privateKey), signature = _a.signature, recovery = _a.recid;
    var r = $057d115f3edbcf08$require$Buffer.from(signature.slice(0, 32));
    var s = $057d115f3edbcf08$require$Buffer.from(signature.slice(32, 64));
    if (!chainId || typeof chainId === "number") {
        // return legacy type ECDSASignature (deprecated in favor of ECDSASignatureBuffer to handle large chainIds)
        if (chainId && !Number.isSafeInteger(chainId)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
        var v_1 = chainId ? recovery + (chainId * 2 + 35) : recovery + 27;
        return {
            r: r,
            s: s,
            v: v_1
        };
    }
    var chainIdBN = $gO7zN.toType(chainId, $gO7zN.TypeOutput.BN);
    var v = chainIdBN.muln(2).addn(35).addn(recovery).toArrayLike($057d115f3edbcf08$require$Buffer);
    return {
        r: r,
        s: s,
        v: v
    };
}
module.exports.ecsign = $057d115f3edbcf08$var$ecsign;
function $057d115f3edbcf08$var$calculateSigRecovery(v, chainId) {
    var vBN = $gO7zN.toType(v, $gO7zN.TypeOutput.BN);
    if (!chainId) return vBN.subn(27);
    var chainIdBN = $gO7zN.toType(chainId, $gO7zN.TypeOutput.BN);
    return vBN.sub(chainIdBN.muln(2).addn(35));
}
function $057d115f3edbcf08$var$isValidSigRecovery(recovery) {
    var rec = new $057d115f3edbcf08$var$bn_js_1.default(recovery);
    return rec.eqn(0) || rec.eqn(1);
}
/**
 * ECDSA public key recovery from signature.
 * @returns Recovered public key
 */ module.exports.ecrecover = function(msgHash, v, r, s, chainId) {
    var signature = $057d115f3edbcf08$require$Buffer.concat([
        $7Usx4.setLengthLeft(r, 32),
        $7Usx4.setLengthLeft(s, 32)
    ], 64);
    var recovery = $057d115f3edbcf08$var$calculateSigRecovery(v, chainId);
    if (!$057d115f3edbcf08$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var senderPubKey = $l3pVp.ecdsaRecover(signature, recovery.toNumber(), msgHash);
    return $057d115f3edbcf08$require$Buffer.from($l3pVp.publicKeyConvert(senderPubKey, false).slice(1));
};
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * @returns Signature
 */ module.exports.toRpcSig = function(v, r, s, chainId) {
    var recovery = $057d115f3edbcf08$var$calculateSigRecovery(v, chainId);
    if (!$057d115f3edbcf08$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return $7Usx4.bufferToHex($057d115f3edbcf08$require$Buffer.concat([
        $7Usx4.setLengthLeft(r, 32),
        $7Usx4.setLengthLeft(s, 32),
        $7Usx4.toBuffer(v)
    ]));
};
/**
 * Convert signature parameters into the format of Compact Signature Representation (EIP-2098).
 * @returns Signature
 */ module.exports.toCompactSig = function(v, r, s, chainId) {
    var recovery = $057d115f3edbcf08$var$calculateSigRecovery(v, chainId);
    if (!$057d115f3edbcf08$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    var vn = $gO7zN.toType(v, $gO7zN.TypeOutput.Number);
    var ss = s;
    if (vn > 28 && vn % 2 === 1 || vn === 1 || vn === 28) {
        ss = $057d115f3edbcf08$require$Buffer.from(s);
        ss[0] |= 0x80;
    }
    return $7Usx4.bufferToHex($057d115f3edbcf08$require$Buffer.concat([
        $7Usx4.setLengthLeft(r, 32),
        $7Usx4.setLengthLeft(ss, 32)
    ]));
};
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 * NOTE: all because of a bug in geth: https://github.com/ethereum/go-ethereum/issues/2053
 */ module.exports.fromRpcSig = function(sig) {
    var buf = $7Usx4.toBuffer(sig);
    var r;
    var s;
    var v;
    if (buf.length >= 65) {
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = $7Usx4.bufferToInt(buf.slice(64));
    } else if (buf.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = $7Usx4.bufferToInt(buf.slice(32, 33)) >> 7;
        s[0] &= 0x7f;
    } else throw new Error("Invalid signature length");
    // support both versions of `eth_sign` responses
    if (v < 27) v += 27;
    return {
        v: v,
        r: r,
        s: s
    };
};
/**
 * Validate a ECDSA signature.
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ module.exports.isValidSignature = function(v, r, s, homesteadOrLater, chainId) {
    if (homesteadOrLater === void 0) homesteadOrLater = true;
    var SECP256K1_N_DIV_2 = new $057d115f3edbcf08$var$bn_js_1.default("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);
    var SECP256K1_N = new $057d115f3edbcf08$var$bn_js_1.default("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", 16);
    if (r.length !== 32 || s.length !== 32) return false;
    if (!$057d115f3edbcf08$var$isValidSigRecovery($057d115f3edbcf08$var$calculateSigRecovery(v, chainId))) return false;
    var rBN = new $057d115f3edbcf08$var$bn_js_1.default(r);
    var sBN = new $057d115f3edbcf08$var$bn_js_1.default(s);
    if (rBN.isZero() || rBN.gt(SECP256K1_N) || sBN.isZero() || sBN.gt(SECP256K1_N)) return false;
    if (homesteadOrLater && sBN.cmp(SECP256K1_N_DIV_2) === 1) return false;
    return true;
};
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ module.exports.hashPersonalMessage = function(message) {
    $bRaTu.assertIsBuffer(message);
    var prefix = $057d115f3edbcf08$require$Buffer.from("\x19Ethereum Signed Message:\n" + message.length.toString(), "utf-8");
    return $gnQU8.keccak($057d115f3edbcf08$require$Buffer.concat([
        prefix,
        message
    ]));
};

});

parcelRegister("jhaqU", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e087b2a009bdf3eb$require$Buffer = $ihoyg.Buffer;
"use strict";
var $e087b2a009bdf3eb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e087b2a009bdf3eb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e087b2a009bdf3eb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $e087b2a009bdf3eb$var$__createBinding(result, mod, k);
    }
    $e087b2a009bdf3eb$var$__setModuleDefault(result, mod);
    return result;
};
var $e087b2a009bdf3eb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defineProperties = void 0;

var $e087b2a009bdf3eb$var$assert_1 = $e087b2a009bdf3eb$var$__importDefault((parcelRequire("bhJ7Q")));

var $e087b2a009bdf3eb$var$ethjsUtil = $e087b2a009bdf3eb$var$__importStar((parcelRequire("aFbW5")));

var $e087b2a009bdf3eb$var$rlp = $e087b2a009bdf3eb$var$__importStar((parcelRequire("thfOi")));

var $7Usx4 = parcelRequire("7Usx4");
/**
 * Defines properties on a `Object`. It make the assumption that underlying data is binary.
 * @param self the `Object` to define properties on
 * @param fields an array fields to define. Fields can contain:
 * * `name` - the name of the properties
 * * `length` - the number of bytes the field can have
 * * `allowLess` - if the field can be less than the length
 * * `allowEmpty`
 * @param data data to be validated against the definitions
 * @deprecated
 */ module.exports.defineProperties = function(self, fields, data) {
    self.raw = [];
    self._fields = [];
    // attach the `toJSON`
    self.toJSON = function(label) {
        if (label === void 0) label = false;
        if (label) {
            var obj_1 = {};
            self._fields.forEach(function(field) {
                obj_1[field] = "0x" + self[field].toString("hex");
            });
            return obj_1;
        }
        return $7Usx4.baToJSON(self.raw);
    };
    self.serialize = function serialize() {
        return $e087b2a009bdf3eb$var$rlp.encode(self.raw);
    };
    fields.forEach(function(field, i) {
        self._fields.push(field.name);
        function getter() {
            return self.raw[i];
        }
        function setter(v) {
            v = $7Usx4.toBuffer(v);
            if (v.toString("hex") === "00" && !field.allowZero) v = $e087b2a009bdf3eb$require$Buffer.allocUnsafe(0);
            if (field.allowLess && field.length) {
                v = $7Usx4.unpadBuffer(v);
                $e087b2a009bdf3eb$var$assert_1.default(field.length >= v.length, "The field " + field.name + " must not have more " + field.length + " bytes");
            } else if (!(field.allowZero && v.length === 0) && field.length) $e087b2a009bdf3eb$var$assert_1.default(field.length === v.length, "The field " + field.name + " must have byte length of " + field.length);
            self.raw[i] = v;
        }
        Object.defineProperty(self, field.name, {
            enumerable: true,
            configurable: true,
            get: getter,
            set: setter
        });
        if (field.default) self[field.name] = field.default;
        // attach alias
        if (field.alias) Object.defineProperty(self, field.alias, {
            enumerable: false,
            configurable: true,
            set: setter,
            get: getter
        });
    });
    // if the constuctor is passed data
    if (data) {
        if (typeof data === "string") data = $e087b2a009bdf3eb$require$Buffer.from($e087b2a009bdf3eb$var$ethjsUtil.stripHexPrefix(data), "hex");
        if ($e087b2a009bdf3eb$require$Buffer.isBuffer(data)) data = $e087b2a009bdf3eb$var$rlp.decode(data);
        if (Array.isArray(data)) {
            if (data.length > self._fields.length) throw new Error("wrong number of fields in data");
            // make sure all the items are buffers
            data.forEach(function(d, i) {
                self[self._fields[i]] = $7Usx4.toBuffer(d);
            });
        } else if (typeof data === "object") {
            var keys_1 = Object.keys(data);
            fields.forEach(function(field) {
                if (keys_1.indexOf(field.name) !== -1) self[field.name] = data[field.name];
                if (keys_1.indexOf(field.alias) !== -1) self[field.alias] = data[field.alias];
            });
        } else throw new Error("invalid data");
    }
};

});

parcelRegister("7HC2t", function(module, exports) {
"use strict";
/**
 * Re-exports commonly used modules:
 * * Exports [`BN`](https://github.com/indutny/bn.js), [`rlp`](https://github.com/ethereumjs/rlp).
 * @packageDocumentation
 */ var $59ba0e4c684d19dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $59ba0e4c684d19dd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $59ba0e4c684d19dd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.hasOwnProperty.call(mod, k)) $59ba0e4c684d19dd$var$__createBinding(result, mod, k);
    }
    $59ba0e4c684d19dd$var$__setModuleDefault(result, mod);
    return result;
};
var $59ba0e4c684d19dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rlp = module.exports.BN = void 0;

var $59ba0e4c684d19dd$var$bn_js_1 = $59ba0e4c684d19dd$var$__importDefault((parcelRequire("bzyAZ")));
module.exports.BN = $59ba0e4c684d19dd$var$bn_js_1.default;

var $59ba0e4c684d19dd$var$rlp = $59ba0e4c684d19dd$var$__importStar((parcelRequire("thfOi")));
module.exports.rlp = $59ba0e4c684d19dd$var$rlp;

});


parcelRegister("bNSDz", function(module, exports) {
"use strict";
var $897ea7243c075184$var$__values = module.exports && module.exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $897ea7243c075184$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chains = module.exports._getInitializedChains = void 0;

var $897ea7243c075184$var$mainnet_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("1YiTZ")));

var $897ea7243c075184$var$ropsten_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("hxycM")));

var $897ea7243c075184$var$rinkeby_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("i5I7r")));

var $897ea7243c075184$var$kovan_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("1BIIN")));

var $897ea7243c075184$var$goerli_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("13W37")));

var $897ea7243c075184$var$calaveras_json_1 = $897ea7243c075184$var$__importDefault((parcelRequire("1M0hm")));
/**
 * @hidden
 */ function $897ea7243c075184$var$_getInitializedChains(customChains) {
    var e_1, _a;
    var names = {
        "1": "mainnet",
        "3": "ropsten",
        "4": "rinkeby",
        "42": "kovan",
        "5": "goerli",
        "123": "calaveras"
    };
    var chains = {
        mainnet: $897ea7243c075184$var$mainnet_json_1.default,
        ropsten: $897ea7243c075184$var$ropsten_json_1.default,
        rinkeby: $897ea7243c075184$var$rinkeby_json_1.default,
        kovan: $897ea7243c075184$var$kovan_json_1.default,
        goerli: $897ea7243c075184$var$goerli_json_1.default,
        calaveras: $897ea7243c075184$var$calaveras_json_1.default
    };
    if (customChains) try {
        for(var customChains_1 = $897ea7243c075184$var$__values(customChains), customChains_1_1 = customChains_1.next(); !customChains_1_1.done; customChains_1_1 = customChains_1.next()){
            var chain = customChains_1_1.value;
            var name_1 = chain.name;
            names[chain.chainId.toString()] = name_1;
            chains[name_1] = chain;
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (customChains_1_1 && !customChains_1_1.done && (_a = customChains_1.return)) _a.call(customChains_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    chains["names"] = names;
    return chains;
}
module.exports._getInitializedChains = $897ea7243c075184$var$_getInitializedChains;
/**
 * @deprecated this constant will be internalized (removed)
 * on next major version update
 */ module.exports.chains = $897ea7243c075184$var$_getInitializedChains();

});
parcelRegister("1YiTZ", function(module, exports) {
module.exports = JSON.parse('{"name":"mainnet","chainId":1,"networkId":1,"defaultHardfork":"istanbul","consensus":{"type":"pow","algorithm":"ethash","ethash":{}},"comment":"The Ethereum main chain","url":"https://ethstats.net/","genesis":{"hash":"0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3","timestamp":null,"gasLimit":5000,"difficulty":17179869184,"nonce":"0x0000000000000042","extraData":"0x11bbe8db4e347b4e8c937c1c8370e4b5ed33adb3db69cbdb7a38e1e50b1b82fa","stateRoot":"0xd7f8974fb5ac78d9ac099b9ad5018bedc2ce0a72dad1827a1709da30580f0544"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xfc64ec04"},{"name":"homestead","block":1150000,"forkHash":"0x97c2c34c"},{"name":"dao","block":1920000,"forkHash":"0x91d1f948"},{"name":"tangerineWhistle","block":2463000,"forkHash":"0x7a64da13"},{"name":"spuriousDragon","block":2675000,"forkHash":"0x3edd5b10"},{"name":"byzantium","block":4370000,"forkHash":"0xa00bc324"},{"name":"constantinople","block":7280000,"forkHash":"0x668db0af"},{"name":"petersburg","block":7280000,"forkHash":"0x668db0af"},{"name":"istanbul","block":9069000,"forkHash":"0x879d6e30"},{"name":"muirGlacier","block":9200000,"forkHash":"0xe029e991"},{"name":"berlin","block":12244000,"forkHash":"0x0eb440f6"},{"name":"london","block":12965000,"forkHash":"0xb715077d"}],"bootstrapNodes":[{"ip":"18.138.108.67","port":30303,"id":"d860a01f9722d78051619d1e2351aba3f43f943f6f00718d1b9baa4101932a1f5011f16bb2b1bb35db20d6fe28fa0bf09636d26a87d31de9ec6203eeedb1f666","location":"ap-southeast-1-001","comment":"bootnode-aws-ap-southeast-1-001"},{"ip":"3.209.45.79","port":30303,"id":"22a8232c3abc76a16ae9d6c3b164f98775fe226f0917b0ca871128a74a8e9630b458460865bab457221f1d448dd9791d24c4e5d88786180ac185df813a68d4de","location":"us-east-1-001","comment":"bootnode-aws-us-east-1-001"},{"ip":"34.255.23.113","port":30303,"id":"ca6de62fce278f96aea6ec5a2daadb877e51651247cb96ee310a318def462913b653963c155a0ef6c7d50048bba6e6cea881130857413d9f50a621546b590758","location":"eu-west-1-001","comment":"bootnode-aws-eu-west-1-001"},{"ip":"35.158.244.151","port":30303,"id":"279944d8dcd428dffaa7436f25ca0ca43ae19e7bcf94a8fb7d1641651f92d121e972ac2e8f381414b80cc8e5555811c2ec6e1a99bb009b3f53c4c69923e11bd8","location":"eu-central-1-001","comment":"bootnode-aws-eu-central-1-001"},{"ip":"52.187.207.27","port":30303,"id":"8499da03c47d637b20eee24eec3c356c9a2e6148d6fe25ca195c7949ab8ec2c03e3556126b0d7ed644675e78c4318b08691b7b57de10e5f0d40d05b09238fa0a","location":"australiaeast-001","comment":"bootnode-azure-australiaeast-001"},{"ip":"191.234.162.198","port":30303,"id":"103858bdb88756c71f15e9b5e09b56dc1be52f0a5021d46301dbbfb7e130029cc9d0d6f73f693bc29b665770fff7da4d34f3c6379fe12721b5d7a0bcb5ca1fc1","location":"brazilsouth-001","comment":"bootnode-azure-brazilsouth-001"},{"ip":"52.231.165.108","port":30303,"id":"715171f50508aba88aecd1250af392a45a330af91d7b90701c436b618c86aaa1589c9184561907bebbb56439b8f8787bc01f49a7c77276c58c1b09822d75e8e8","location":"koreasouth-001","comment":"bootnode-azure-koreasouth-001"},{"ip":"104.42.217.25","port":30303,"id":"5d6d7cd20d6da4bb83a1d28cadb5d409b64edf314c0335df658c1a54e32c7c4a7ab7823d57c39b6a757556e68ff1df17c748b698544a55cb488b52479a92b60f","location":"westus-001","comment":"bootnode-azure-westus-001"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.mainnet.ethdisco.net"]}');

});

parcelRegister("hxycM", function(module, exports) {
module.exports = JSON.parse('{"name":"ropsten","chainId":3,"networkId":3,"defaultHardfork":"istanbul","consensus":{"type":"pow","algorithm":"ethash","ethash":{}},"comment":"PoW test network","url":"https://github.com/ethereum/ropsten","genesis":{"hash":"0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d","timestamp":null,"gasLimit":16777216,"difficulty":1048576,"nonce":"0x0000000000000042","extraData":"0x3535353535353535353535353535353535353535353535353535353535353535","stateRoot":"0x217b0bbcfb72e2d57e28f33cb361b9983513177755dc3f33ce3e7022ed62b77b"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x30c7ddbc"},{"name":"homestead","block":0,"forkHash":"0x30c7ddbc"},{"name":"dao","block":null,"forkHash":null},{"name":"tangerineWhistle","block":0,"forkHash":"0x30c7ddbc"},{"name":"spuriousDragon","block":10,"forkHash":"0x63760190"},{"name":"byzantium","block":1700000,"forkHash":"0x3ea159c7"},{"name":"constantinople","block":4230000,"forkHash":"0x97b544f3"},{"name":"petersburg","block":4939394,"forkHash":"0xd6e2149b"},{"name":"istanbul","block":6485846,"forkHash":"0x4bc66396"},{"name":"muirGlacier","block":7117117,"forkHash":"0x6727ef90"},{"name":"berlin","block":9812189,"forkHash":"0xa157d377"},{"name":"london","block":10499401,"forkHash":"0x7119b6b3"}],"bootstrapNodes":[{"ip":"52.176.7.10","port":30303,"id":"30b7ab30a01c124a6cceca36863ece12c4f5fa68e3ba9b0b51407ccc002eeed3b3102d20a88f1c1d3c3154e2449317b8ef95090e77b312d5cc39354f86d5d606","location":"","comment":"US-Azure geth"},{"ip":"52.176.100.77","port":30303,"id":"865a63255b3bb68023b6bffd5095118fcc13e79dcf014fe4e47e065c350c7cc72af2e53eff895f11ba1bbb6a2b33271c1116ee870f266618eadfc2e78aa7349c","location":"","comment":"US-Azure parity"},{"ip":"52.232.243.152","port":30303,"id":"6332792c4a00e3e4ee0926ed89e0d27ef985424d97b6a45bf0f23e51f0dcb5e66b875777506458aea7af6f9e4ffb69f43f3778ee73c81ed9d34c51c4b16b0b0f","location":"","comment":"Parity"},{"ip":"192.81.208.223","port":30303,"id":"94c15d1b9e2fe7ce56e458b9a3b672ef11894ddedd0c6f247e0f1d3487f52b66208fb4aeb8179fce6e3a749ea93ed147c37976d67af557508d199d9594c35f09","location":"","comment":"@gpip"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.ropsten.ethdisco.net"]}');

});

parcelRegister("i5I7r", function(module, exports) {
module.exports = JSON.parse('{"name":"rinkeby","chainId":4,"networkId":4,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"clique","clique":{"period":15,"epoch":30000}},"comment":"PoA test network","url":"https://www.rinkeby.io","genesis":{"hash":"0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177","timestamp":"0x58ee40ba","gasLimit":4700000,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x52657370656374206d7920617574686f7269746168207e452e436172746d616e42eb768f2244c8811c63729a21a3569731535f067ffc57839b00206d1ad20c69a1981b489f772031b279182d99e65703f0076e4812653aab85fca0f00000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x53580584816f617295ea26c0e17641e0120cab2f0a8ffb53a866fd53aa8e8c2d"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x3b8e0691"},{"name":"homestead","block":1,"forkHash":"0x60949295"},{"name":"dao","block":null,"forkHash":null},{"name":"tangerineWhistle","block":2,"forkHash":"0x8bde40dd"},{"name":"spuriousDragon","block":3,"forkHash":"0xcb3a64bb"},{"name":"byzantium","block":1035301,"forkHash":"0x8d748b57"},{"name":"constantinople","block":3660663,"forkHash":"0xe49cab14"},{"name":"petersburg","block":4321234,"forkHash":"0xafec6b27"},{"name":"istanbul","block":5435345,"forkHash":"0xcbdb8838"},{"name":"berlin","block":8290928,"forkHash":"0x6910c8bd"},{"name":"london","block":8897988,"forkHash":"0x8e29f2f3"}],"bootstrapNodes":[{"ip":"52.169.42.101","port":30303,"id":"a24ac7c5484ef4ed0c5eb2d36620ba4e4aa13b8c84684e1b4aab0cebea2ae45cb4d375b77eab56516d34bfbd3c1a833fc51296ff084b770b94fb9028c4d25ccf","location":"","comment":"IE"},{"ip":"52.3.158.184","port":30303,"id":"343149e4feefa15d882d9fe4ac7d88f885bd05ebb735e547f12e12080a9fa07c8014ca6fd7f373123488102fe5e34111f8509cf0b7de3f5b44339c9f25e87cb8","location":"","comment":"INFURA"},{"ip":"159.89.28.211","port":30303,"id":"b6b28890b006743680c52e64e0d16db57f28124885595fa03a562be1d2bf0f3a1da297d56b13da25fb992888fd556d4c1a27b1f39d531bde7de1921c90061cc6","location":"","comment":"AKASHA"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.rinkeby.ethdisco.net"]}');

});

parcelRegister("1BIIN", function(module, exports) {
module.exports = JSON.parse('{"name":"kovan","chainId":42,"networkId":42,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"aura","aura":{}},"comment":"Parity PoA test network","url":"https://kovan-testnet.github.io/website/","genesis":{"hash":"0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9","timestamp":null,"gasLimit":6000000,"difficulty":131072,"nonce":"0x0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","extraData":"0x","stateRoot":"0x2480155b48a1cea17d67dbfdfaafe821c1d19cdd478c5358e8ec56dec24502b2"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0x010ffe56"},{"name":"homestead","block":0,"forkHash":"0x010ffe56"},{"name":"dao","block":null,"forkHash":"0x010ffe56"},{"name":"tangerineWhistle","block":0,"forkHash":"0x010ffe56"},{"name":"spuriousDragon","block":0,"forkHash":"0x010ffe56"},{"name":"byzantium","block":5067000,"forkHash":"0x7f83c620"},{"name":"constantinople","block":9200000,"forkHash":"0xa94e3dc4"},{"name":"petersburg","block":10255201,"forkHash":"0x186874aa"},{"name":"istanbul","block":14111141,"forkHash":"0x7f6599a6"},{"name":"berlin","block":null,"forkHash":null},{"name":"london","block":null,"forkHash":null}],"bootstrapNodes":[{"ip":"116.203.116.241","port":30303,"id":"16898006ba2cd4fa8bf9a3dfe32684c178fa861df144bfc21fe800dc4838a03e342056951fa9fd533dcb0be1219e306106442ff2cf1f7e9f8faa5f2fc1a3aa45","location":"","comment":"1"},{"ip":"3.217.96.11","port":30303,"id":"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0","location":"","comment":"2"},{"ip":"108.61.170.124","port":30303,"id":"740e1c8ea64e71762c71a463a04e2046070a0c9394fcab5891d41301dc473c0cff00ebab5a9bc87fbcb610ab98ac18225ff897bc8b7b38def5975d5ceb0a7d7c","location":"","comment":"3"},{"ip":"157.230.31.163","port":30303,"id":"2909846f78c37510cc0e306f185323b83bb2209e5ff4fdd279d93c60e3f365e3c6e62ad1d2133ff11f9fd6d23ad9c3dad73bb974d53a22f7d1ac5b7dea79d0b0","location":"","comment":"4"}]}');

});

parcelRegister("13W37", function(module, exports) {
module.exports = JSON.parse('{"name":"goerli","chainId":5,"networkId":5,"defaultHardfork":"istanbul","consensus":{"type":"poa","algorithm":"clique","clique":{"period":15,"epoch":30000}},"comment":"Cross-client PoA test network","url":"https://github.com/goerli/testnet","genesis":{"hash":"0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a","timestamp":"0x5c51a607","gasLimit":10485760,"difficulty":1,"nonce":"0x0000000000000000","extraData":"0x22466c6578692069732061207468696e6722202d204166726900000000000000e0a2bd4258d2768837baa26a28fe71dc079f84c70000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x5d6cded585e73c4e322c30c2f782a336316f17dd85a4863b9d838d2d4b8b3008"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xa3f5ab08"},{"name":"homestead","block":0,"forkHash":"0xa3f5ab08"},{"name":"dao","block":null,"forkHash":"0xa3f5ab08"},{"name":"tangerineWhistle","block":0,"forkHash":"0xa3f5ab08"},{"name":"spuriousDragon","block":0,"forkHash":"0xa3f5ab08"},{"name":"byzantium","block":0,"forkHash":"0xa3f5ab08"},{"name":"constantinople","block":0,"forkHash":"0xa3f5ab08"},{"name":"petersburg","block":0,"forkHash":"0xa3f5ab08"},{"name":"istanbul","block":1561651,"forkHash":"0xc25efa5c"},{"name":"berlin","block":4460644,"forkHash":"0x757a1c47"},{"name":"london","block":5062605,"forkHash":"0xb8c6299d"}],"bootstrapNodes":[{"ip":"51.141.78.53","port":30303,"id":"011f758e6552d105183b1761c5e2dea0111bc20fd5f6422bc7f91e0fabbec9a6595caf6239b37feb773dddd3f87240d99d859431891e4a642cf2a0a9e6cbb98a","location":"","comment":"Upstream bootnode 1"},{"ip":"13.93.54.137","port":30303,"id":"176b9417f511d05b6b2cf3e34b756cf0a7096b3094572a8f6ef4cdcb9d1f9d00683bf0f83347eebdf3b81c3521c2332086d9592802230bf528eaf606a1d9677b","location":"","comment":"Upstream bootnode 2"},{"ip":"94.237.54.114","port":30313,"id":"46add44b9f13965f7b9875ac6b85f016f341012d84f975377573800a863526f4da19ae2c620ec73d11591fa9510e992ecc03ad0751f53cc02f7c7ed6d55c7291","location":"","comment":"Upstream bootnode 3"},{"ip":"18.218.250.66","port":30313,"id":"b5948a2d3e9d486c4d75bf32713221c2bd6cf86463302339299bd227dc2e276cd5a1c7ca4f43a0e9122fe9af884efed563bd2a1fd28661f3b5f5ad7bf1de5949","location":"","comment":"Upstream bootnode 4"},{"ip":"3.11.147.67","port":30303,"id":"a61215641fb8714a373c80edbfa0ea8878243193f57c96eeb44d0bc019ef295abd4e044fd619bfc4c59731a73fb79afe84e9ab6da0c743ceb479cbb6d263fa91","location":"","comment":"Ethereum Foundation bootnode"},{"ip":"51.15.116.226","port":30303,"id":"a869b02cec167211fb4815a82941db2e7ed2936fd90e78619c53eb17753fcf0207463e3419c264e2a1dd8786de0df7e68cf99571ab8aeb7c4e51367ef186b1dd","location":"","comment":"Goerli Initiative bootnode"},{"ip":"51.15.119.157","port":30303,"id":"807b37ee4816ecf407e9112224494b74dd5933625f655962d892f2f0f02d7fbbb3e2a94cf87a96609526f30c998fd71e93e2f53015c558ffc8b03eceaf30ee33","location":"","comment":"Goerli Initiative bootnode"},{"ip":"51.15.119.157","port":40303,"id":"a59e33ccd2b3e52d578f1fbd70c6f9babda2650f0760d6ff3b37742fdcdfdb3defba5d56d315b40c46b70198c7621e63ffa3f987389c7118634b0fefbbdfa7fd","location":"","comment":"Goerli Initiative bootnode"}],"dnsNetworks":["enrtree://AKA3AM6LPBYEUDMVNU3BSVQJ5AD45Y7YPOHJLEF6W26QOE4VTUDPE@all.goerli.ethdisco.net"]}');

});

parcelRegister("1M0hm", function(module, exports) {
module.exports = JSON.parse('{"name":"calaveras","chainId":123,"networkId":123,"defaultHardfork":"berlin","consensus":{"type":"poa","algorithm":"clique","clique":{"period":30,"epoch":30000}},"comment":"The Calaveras testnet chain","url":"https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/client-integration-testnets/calaveras.md","genesis":{"hash":"0xeb9233d066c275efcdfed8037f4fc082770176aefdbcb7691c71da412a5670f2","gasLimit":"0x47b760","difficulty":"0x1","nonce":"0x0000000000000000","extraData":"0x00000000000000000000000000000000000000000000000000000000000000005211cea3870c7ba7c6c44b185e62eecdb864cd8c560228ce57d31efbf64c200b2c200aacec78cf17a7148e784fe95a7a750335f8b9572ee28d72e7650000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000","stateRoot":"0x664c93de37eb4a72953ea42b8c046cdb64c9f0b0bca5505ade8d970d49ebdb8c","timestamp":"0x60b3877f"},"hardforks":[{"name":"chainstart","block":0,"forkHash":"0xe34c4aff"},{"name":"homestead","block":0,"forkHash":"0xe34c4aff"},{"name":"dao","block":null,"forkHash":"0xe34c4aff"},{"name":"tangerineWhistle","block":0,"forkHash":"0xe34c4aff"},{"name":"spuriousDragon","block":0,"forkHash":"0xe34c4aff"},{"name":"byzantium","block":0,"forkHash":"0xe34c4aff"},{"name":"constantinople","block":0,"forkHash":"0xe34c4aff"},{"name":"petersburg","block":0,"forkHash":"0xe34c4aff"},{"name":"istanbul","block":0,"forkHash":"0xe34c4aff"},{"name":"berlin","block":0,"forkHash":"0xe34c4aff"},{"name":"london","block":500,"forkHash":"0x173783e4"}],"bootstrapNodes":[{"ip":"3.21.156.138","port":30303,"id":"39eb08bbfad87481553c471a63ff2a4b4885fffa4ff50f1cf46744d9ad6e2f764ede146fe4df563fa9ccda1a46b9b1a88fb08135e1bf1d71b320912499da773d","location":"","comment":"Calaveras bootnode 1"},{"ip":"3.9.20.133","port":30303,"id":"9e1096aa59862a6f164994cb5cb16f5124d6c992cdbf4535ff7dea43ea1512afe5448dca9df1b7ab0726129603f1a3336b631e4d7a1a44c94daddd03241587f9","location":"","comment":"Calaveras bootnode 2"}]}');

});


parcelRegister("ifHyT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hardforks = void 0;












module.exports.hardforks = [
    [
        "chainstart",
        (parcelRequire("4ib3d"))
    ],
    [
        "homestead",
        (parcelRequire("cZGLO"))
    ],
    [
        "dao",
        (parcelRequire("4iOmW"))
    ],
    [
        "tangerineWhistle",
        (parcelRequire("1DQBx"))
    ],
    [
        "spuriousDragon",
        (parcelRequire("di5bY"))
    ],
    [
        "byzantium",
        (parcelRequire("nq0A6"))
    ],
    [
        "constantinople",
        (parcelRequire("jarbW"))
    ],
    [
        "petersburg",
        (parcelRequire("i26uj"))
    ],
    [
        "istanbul",
        (parcelRequire("hd1bU"))
    ],
    [
        "muirGlacier",
        (parcelRequire("iQmvx"))
    ],
    [
        "berlin",
        (parcelRequire("gNXju"))
    ],
    [
        "london",
        (parcelRequire("8Rd0Z"))
    ]
];

});
parcelRegister("4ib3d", function(module, exports) {
module.exports = JSON.parse('{"name":"chainstart","comment":"Start of the Ethereum main chain","url":"","status":"","gasConfig":{"minGasLimit":{"v":5000,"d":"Minimum the gas limit may ever be"},"gasLimitBoundDivisor":{"v":1024,"d":"The bound divisor of the gas limit, used in update calculations"},"maxRefundQuotient":{"v":2,"d":"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"}},"gasPrices":{"base":{"v":2,"d":"Gas base cost, used e.g. for ChainID opcode (Istanbul)"},"tierStep":{"v":[0,2,3,5,8,10,20],"d":"Once per operation, for a selection of them"},"exp":{"v":10,"d":"Base fee of the EXP opcode"},"expByte":{"v":10,"d":"Times ceil(log256(exponent)) for the EXP instruction"},"sha3":{"v":30,"d":"Base fee of the SHA3 opcode"},"sha3Word":{"v":6,"d":"Once per word of the SHA3 operation\'s data"},"sload":{"v":50,"d":"Base fee of the SLOAD opcode"},"sstoreSet":{"v":20000,"d":"Once per SSTORE operation if the zeroness changes from zero"},"sstoreReset":{"v":5000,"d":"Once per SSTORE operation if the zeroness does not change from zero"},"sstoreRefund":{"v":15000,"d":"Once per SSTORE operation if the zeroness changes to zero"},"jumpdest":{"v":1,"d":"Base fee of the JUMPDEST opcode"},"log":{"v":375,"d":"Base fee of the LOG opcode"},"logData":{"v":8,"d":"Per byte in a LOG* operation\'s data"},"logTopic":{"v":375,"d":"Multiplied by the * of the LOG*, per LOG transaction. e.g. LOG0 incurs 0 * c_txLogTopicGas, LOG4 incurs 4 * c_txLogTopicGas"},"create":{"v":32000,"d":"Base fee of the CREATE opcode"},"call":{"v":40,"d":"Base fee of the CALL opcode"},"callStipend":{"v":2300,"d":"Free gas given at beginning of call"},"callValueTransfer":{"v":9000,"d":"Paid for CALL when the value transfor is non-zero"},"callNewAccount":{"v":25000,"d":"Paid for CALL when the destination address didn\'t exist prior"},"selfdestructRefund":{"v":24000,"d":"Refunded following a selfdestruct operation"},"memory":{"v":3,"d":"Times the address of the (highest referenced byte in memory + 1). NOTE: referencing happens on read, write and in instructions such as RETURN and CALL"},"quadCoeffDiv":{"v":512,"d":"Divisor for the quadratic particle of the memory cost equation"},"createData":{"v":200,"d":""},"tx":{"v":21000,"d":"Per transaction. NOTE: Not payable on data of calls between transactions"},"txCreation":{"v":32000,"d":"The cost of creating a contract via tx"},"txDataZero":{"v":4,"d":"Per byte of data attached to a transaction that equals zero. NOTE: Not payable on data of calls between transactions"},"txDataNonZero":{"v":68,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"copy":{"v":3,"d":"Multiplied by the number of 32-byte words that are copied (round up) for any *COPY operation and added"},"ecRecover":{"v":3000,"d":""},"sha256":{"v":60,"d":""},"sha256Word":{"v":12,"d":""},"ripemd160":{"v":600,"d":""},"ripemd160Word":{"v":120,"d":""},"identity":{"v":15,"d":""},"identityWord":{"v":3,"d":""},"stop":{"v":0,"d":"Base fee of the STOP opcode"},"add":{"v":3,"d":"Base fee of the ADD opcode"},"mul":{"v":5,"d":"Base fee of the MUL opcode"},"sub":{"v":3,"d":"Base fee of the SUB opcode"},"div":{"v":5,"d":"Base fee of the DIV opcode"},"sdiv":{"v":5,"d":"Base fee of the SDIV opcode"},"mod":{"v":5,"d":"Base fee of the MOD opcode"},"smod":{"v":5,"d":"Base fee of the SMOD opcode"},"addmod":{"v":8,"d":"Base fee of the ADDMOD opcode"},"mulmod":{"v":8,"d":"Base fee of the MULMOD opcode"},"signextend":{"v":5,"d":"Base fee of the SIGNEXTEND opcode"},"lt":{"v":3,"d":"Base fee of the LT opcode"},"gt":{"v":3,"d":"Base fee of the GT opcode"},"slt":{"v":3,"d":"Base fee of the SLT opcode"},"sgt":{"v":3,"d":"Base fee of the SGT opcode"},"eq":{"v":3,"d":"Base fee of the EQ opcode"},"iszero":{"v":3,"d":"Base fee of the ISZERO opcode"},"and":{"v":3,"d":"Base fee of the AND opcode"},"or":{"v":3,"d":"Base fee of the OR opcode"},"xor":{"v":3,"d":"Base fee of the XOR opcode"},"not":{"v":3,"d":"Base fee of the NOT opcode"},"byte":{"v":3,"d":"Base fee of the BYTE opcode"},"address":{"v":2,"d":"Base fee of the ADDRESS opcode"},"balance":{"v":20,"d":"Base fee of the BALANCE opcode"},"origin":{"v":2,"d":"Base fee of the ORIGIN opcode"},"caller":{"v":2,"d":"Base fee of the CALLER opcode"},"callvalue":{"v":2,"d":"Base fee of the CALLVALUE opcode"},"calldataload":{"v":3,"d":"Base fee of the CALLDATALOAD opcode"},"calldatasize":{"v":2,"d":"Base fee of the CALLDATASIZE opcode"},"calldatacopy":{"v":3,"d":"Base fee of the CALLDATACOPY opcode"},"codesize":{"v":2,"d":"Base fee of the CODESIZE opcode"},"codecopy":{"v":3,"d":"Base fee of the CODECOPY opcode"},"gasprice":{"v":2,"d":"Base fee of the GASPRICE opcode"},"extcodesize":{"v":20,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":20,"d":"Base fee of the EXTCODECOPY opcode"},"blockhash":{"v":20,"d":"Base fee of the BLOCKHASH opcode"},"coinbase":{"v":2,"d":"Base fee of the COINBASE opcode"},"timestamp":{"v":2,"d":"Base fee of the TIMESTAMP opcode"},"number":{"v":2,"d":"Base fee of the NUMBER opcode"},"difficulty":{"v":2,"d":"Base fee of the DIFFICULTY opcode"},"gaslimit":{"v":2,"d":"Base fee of the GASLIMIT opcode"},"pop":{"v":2,"d":"Base fee of the POP opcode"},"mload":{"v":3,"d":"Base fee of the MLOAD opcode"},"mstore":{"v":3,"d":"Base fee of the MSTORE opcode"},"mstore8":{"v":3,"d":"Base fee of the MSTORE8 opcode"},"sstore":{"v":0,"d":"Base fee of the SSTORE opcode"},"jump":{"v":8,"d":"Base fee of the JUMP opcode"},"jumpi":{"v":10,"d":"Base fee of the JUMPI opcode"},"pc":{"v":2,"d":"Base fee of the PC opcode"},"msize":{"v":2,"d":"Base fee of the MSIZE opcode"},"gas":{"v":2,"d":"Base fee of the GAS opcode"},"push":{"v":3,"d":"Base fee of the PUSH opcode"},"dup":{"v":3,"d":"Base fee of the DUP opcode"},"swap":{"v":3,"d":"Base fee of the SWAP opcode"},"callcode":{"v":40,"d":"Base fee of the CALLCODE opcode"},"return":{"v":0,"d":"Base fee of the RETURN opcode"},"invalid":{"v":0,"d":"Base fee of the INVALID opcode"},"selfdestruct":{"v":0,"d":"Base fee of the SELFDESTRUCT opcode"}},"vm":{"stackLimit":{"v":1024,"d":"Maximum size of VM stack allowed"},"callCreateDepth":{"v":1024,"d":"Maximum depth of call/create stack"},"maxExtraDataSize":{"v":32,"d":"Maximum size extra data may be after Genesis"}},"pow":{"minimumDifficulty":{"v":131072,"d":"The minimum that the difficulty may ever be"},"difficultyBoundDivisor":{"v":2048,"d":"The bound divisor of the difficulty, used in the update calculations"},"durationLimit":{"v":13,"d":"The decision boundary on the blocktime duration used to determine whether difficulty should go up or not"},"epochDuration":{"v":30000,"d":"Duration between proof-of-work epochs"},"timebombPeriod":{"v":100000,"d":"Exponential difficulty timebomb period"},"minerReward":{"v":"5000000000000000000","d":"the amount a miner get rewarded for mining a block"},"difficultyBombDelay":{"v":0,"d":"the amount of blocks to delay the difficulty bomb with"}}}');

});

parcelRegister("cZGLO", function(module, exports) {
module.exports = JSON.parse('{"name":"homestead","comment":"Homestead hardfork with protocol and network changes","url":"https://eips.ethereum.org/EIPS/eip-606","status":"Final","gasConfig":{},"gasPrices":{"delegatecall":{"v":40,"d":"Base fee of the DELEGATECALL opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("4iOmW", function(module, exports) {
module.exports = JSON.parse('{"name":"dao","comment":"DAO rescue hardfork","url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final","gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');

});

parcelRegister("1DQBx", function(module, exports) {
module.exports = JSON.parse('{"name":"tangerineWhistle","comment":"Hardfork with gas cost changes for IO-heavy operations","url":"https://eips.ethereum.org/EIPS/eip-608","status":"Final","gasConfig":{},"gasPrices":{"sload":{"v":200,"d":"Once per SLOAD operation"},"call":{"v":700,"d":"Once per CALL operation & message call transaction"},"extcodesize":{"v":700,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":700,"d":"Base fee of the EXTCODECOPY opcode"},"balance":{"v":400,"d":"Base fee of the BALANCE opcode"},"delegatecall":{"v":700,"d":"Base fee of the DELEGATECALL opcode"},"callcode":{"v":700,"d":"Base fee of the CALLCODE opcode"},"selfdestruct":{"v":5000,"d":"Base fee of the SELFDESTRUCT opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("di5bY", function(module, exports) {
module.exports = JSON.parse('{"name":"spuriousDragon","comment":"HF with EIPs for simple replay attack protection, EXP cost increase, state trie clearing, contract code size limit","url":"https://eips.ethereum.org/EIPS/eip-607","status":"Final","gasConfig":{},"gasPrices":{"expByte":{"v":50,"d":"Times ceil(log256(exponent)) for the EXP instruction"}},"vm":{"maxCodeSize":{"v":24576,"d":"Maximum length of contract code"}},"pow":{}}');

});

parcelRegister("nq0A6", function(module, exports) {
module.exports = JSON.parse('{"name":"byzantium","comment":"Hardfork with new precompiles, instructions and other protocol changes","url":"https://eips.ethereum.org/EIPS/eip-609","status":"Final","gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":20,"d":"Gquaddivisor from modexp precompile for gas calculation"},"ecAdd":{"v":500,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":40000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":100000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":80000,"d":"Gas costs regarding curve pairing precompile input length"},"revert":{"v":0,"d":"Base fee of the REVERT opcode"},"staticcall":{"v":700,"d":"Base fee of the STATICCALL opcode"},"returndatasize":{"v":2,"d":"Base fee of the RETURNDATASIZE opcode"},"returndatacopy":{"v":3,"d":"Base fee of the RETURNDATACOPY opcode"}},"vm":{},"pow":{"minerReward":{"v":"3000000000000000000","d":"the amount a miner get rewarded for mining a block"},"difficultyBombDelay":{"v":3000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');

});

parcelRegister("jarbW", function(module, exports) {
module.exports = JSON.parse('{"name":"constantinople","comment":"Postponed hardfork including EIP-1283 (SSTORE gas metering changes)","url":"https://eips.ethereum.org/EIPS/eip-1013","status":"Final","gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":200,"d":"Once per SSTORE operation if the value doesn\'t change"},"netSstoreInitGas":{"v":20000,"d":"Once per SSTORE operation from clean zero"},"netSstoreCleanGas":{"v":5000,"d":"Once per SSTORE operation from clean non-zero"},"netSstoreDirtyGas":{"v":200,"d":"Once per SSTORE operation from dirty"},"netSstoreClearRefund":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"netSstoreResetRefund":{"v":4800,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"netSstoreResetClearRefund":{"v":19800,"d":"Once per SSTORE operation for resetting to the original zero value"},"shl":{"v":3,"d":"Base fee of the SHL opcode"},"shr":{"v":3,"d":"Base fee of the SHR opcode"},"sar":{"v":3,"d":"Base fee of the SAR opcode"},"extcodehash":{"v":400,"d":"Base fee of the EXTCODEHASH opcode"},"create2":{"v":32000,"d":"Base fee of the CREATE2 opcode"}},"vm":{},"pow":{"minerReward":{"v":"2000000000000000000","d":"The amount a miner gets rewarded for mining a block"},"difficultyBombDelay":{"v":5000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');

});

parcelRegister("i26uj", function(module, exports) {
module.exports = JSON.parse('{"name":"petersburg","comment":"Aka constantinopleFix, removes EIP-1283, activate together with or after constantinople","url":"https://eips.ethereum.org/EIPS/eip-1716","status":"Draft","gasConfig":{},"gasPrices":{"netSstoreNoopGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreInitGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreCleanGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreDirtyGas":{"v":null,"d":"Removed along EIP-1283"},"netSstoreClearRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetRefund":{"v":null,"d":"Removed along EIP-1283"},"netSstoreResetClearRefund":{"v":null,"d":"Removed along EIP-1283"}},"vm":{},"pow":{}}');

});

parcelRegister("hd1bU", function(module, exports) {
module.exports = JSON.parse('{"name":"istanbul","comment":"HF targeted for December 2019 following the Constantinople/Petersburg HF","url":"https://eips.ethereum.org/EIPS/eip-1679","status":"Draft","gasConfig":{},"gasPrices":{"blake2Round":{"v":1,"d":"Gas cost per round for the Blake2 F precompile"},"ecAdd":{"v":150,"d":"Gas costs for curve addition precompile"},"ecMul":{"v":6000,"d":"Gas costs for curve multiplication precompile"},"ecPairing":{"v":45000,"d":"Base gas costs for curve pairing precompile"},"ecPairingWord":{"v":34000,"d":"Gas costs regarding curve pairing precompile input length"},"txDataNonZero":{"v":16,"d":"Per byte of data attached to a transaction that is not equal to zero. NOTE: Not payable on data of calls between transactions"},"sstoreSentryGasEIP2200":{"v":2300,"d":"Minimum gas required to be present for an SSTORE call, not consumed"},"sstoreNoopGasEIP2200":{"v":800,"d":"Once per SSTORE operation if the value doesn\'t change"},"sstoreDirtyGasEIP2200":{"v":800,"d":"Once per SSTORE operation if a dirty value is changed"},"sstoreInitGasEIP2200":{"v":20000,"d":"Once per SSTORE operation from clean zero to non-zero"},"sstoreInitRefundEIP2200":{"v":19200,"d":"Once per SSTORE operation for resetting to the original zero value"},"sstoreCleanGasEIP2200":{"v":5000,"d":"Once per SSTORE operation from clean non-zero to something else"},"sstoreCleanRefundEIP2200":{"v":4200,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"sstoreClearRefundEIP2200":{"v":15000,"d":"Once per SSTORE operation for clearing an originally existing storage slot"},"balance":{"v":700,"d":"Base fee of the BALANCE opcode"},"extcodehash":{"v":700,"d":"Base fee of the EXTCODEHASH opcode"},"chainid":{"v":2,"d":"Base fee of the CHAINID opcode"},"selfbalance":{"v":5,"d":"Base fee of the SELFBALANCE opcode"},"sload":{"v":800,"d":"Base fee of the SLOAD opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("iQmvx", function(module, exports) {
module.exports = JSON.parse('{"name":"muirGlacier","comment":"HF to delay the difficulty bomb","url":"https://eips.ethereum.org/EIPS/eip-2384","status":"Final","gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":9000000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');

});

parcelRegister("gNXju", function(module, exports) {
module.exports = JSON.parse('{"name":"berlin","comment":"HF targeted for July 2020 following the Muir Glacier HF","url":"https://eips.ethereum.org/EIPS/eip-2070","status":"Draft","eips":[2565,2929,2718,2930]}');

});

parcelRegister("8Rd0Z", function(module, exports) {
module.exports = JSON.parse('{"name":"london","comment":"HF targeted for July 2021 following the Berlin fork","url":"https://github.com/ethereum/eth1.0-specs/blob/master/network-upgrades/mainnet-upgrades/london.md","status":"Draft","eips":[1559,3198,3529,3541]}');

});


parcelRegister("dyf0U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EIPs = void 0;











module.exports.EIPs = {
    1559: (parcelRequire("fn0HW")),
    2315: (parcelRequire("fcmgJ")),
    2537: (parcelRequire("6cafU")),
    2565: (parcelRequire("d2tmT")),
    2718: (parcelRequire("4d3FE")),
    2929: (parcelRequire("6PWDu")),
    2930: (parcelRequire("9hrqI")),
    3198: (parcelRequire("1gHgS")),
    3529: (parcelRequire("dTif7")),
    3541: (parcelRequire("vCoev")),
    3554: (parcelRequire("Oy1RQ"))
};

});
parcelRegister("fn0HW", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-1559","number":1559,"comment":"Fee market change for ETH 1.0 chain","url":"https://eips.ethereum.org/EIPS/eip-1559","status":"Review","minimumHardfork":"berlin","requiredEIPs":[2930],"gasConfig":{"baseFeeMaxChangeDenominator":{"v":8,"d":"Maximum base fee change denominator"},"elasticityMultiplier":{"v":2,"d":"Maximum block gas target elasticity"},"initialBaseFee":{"v":1000000000,"d":"Initial base fee on first EIP1559 block"}},"gasPrices":{},"vm":{},"pow":{}}');

});

parcelRegister("fcmgJ", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2315","number":2315,"comment":"Simple subroutines for the EVM","url":"https://eips.ethereum.org/EIPS/eip-2315","status":"Draft","minimumHardfork":"istanbul","gasConfig":{},"gasPrices":{"beginsub":{"v":2,"d":"Base fee of the BEGINSUB opcode"},"returnsub":{"v":5,"d":"Base fee of the RETURNSUB opcode"},"jumpsub":{"v":10,"d":"Base fee of the JUMPSUB opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("6cafU", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2537","number":2537,"comment":"BLS12-381 precompiles","url":"https://eips.ethereum.org/EIPS/eip-2537","status":"Draft","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{"Bls12381G1AddGas":{"v":600,"d":"Gas cost of a single BLS12-381 G1 addition precompile-call"},"Bls12381G1MulGas":{"v":12000,"d":"Gas cost of a single BLS12-381 G1 multiplication precompile-call"},"Bls12381G2AddGas":{"v":4500,"d":"Gas cost of a single BLS12-381 G2 addition precompile-call"},"Bls12381G2MulGas":{"v":55000,"d":"Gas cost of a single BLS12-381 G2 multiplication precompile-call"},"Bls12381PairingBaseGas":{"v":115000,"d":"Base gas cost of BLS12-381 pairing check"},"Bls12381PairingPerPairGas":{"v":23000,"d":"Per-pair gas cost of BLS12-381 pairing check"},"Bls12381MapG1Gas":{"v":5500,"d":"Gas cost of BLS12-381 map field element to G1"},"Bls12381MapG2Gas":{"v":110000,"d":"Gas cost of BLS12-381 map field element to G2"},"Bls12381MultiExpGasDiscount":{"v":[[1,1200],[2,888],[3,764],[4,641],[5,594],[6,547],[7,500],[8,453],[9,438],[10,423],[11,408],[12,394],[13,379],[14,364],[15,349],[16,334],[17,330],[18,326],[19,322],[20,318],[21,314],[22,310],[23,306],[24,302],[25,298],[26,294],[27,289],[28,285],[29,281],[30,277],[31,273],[32,269],[33,268],[34,266],[35,265],[36,263],[37,262],[38,260],[39,259],[40,257],[41,256],[42,254],[43,253],[44,251],[45,250],[46,248],[47,247],[48,245],[49,244],[50,242],[51,241],[52,239],[53,238],[54,236],[55,235],[56,233],[57,232],[58,231],[59,229],[60,228],[61,226],[62,225],[63,223],[64,222],[65,221],[66,220],[67,219],[68,219],[69,218],[70,217],[71,216],[72,216],[73,215],[74,214],[75,213],[76,213],[77,212],[78,211],[79,211],[80,210],[81,209],[82,208],[83,208],[84,207],[85,206],[86,205],[87,205],[88,204],[89,203],[90,202],[91,202],[92,201],[93,200],[94,199],[95,199],[96,198],[97,197],[98,196],[99,196],[100,195],[101,194],[102,193],[103,193],[104,192],[105,191],[106,191],[107,190],[108,189],[109,188],[110,188],[111,187],[112,186],[113,185],[114,185],[115,184],[116,183],[117,182],[118,182],[119,181],[120,180],[121,179],[122,179],[123,178],[124,177],[125,176],[126,176],[127,175],[128,174]],"d":"Discount gas costs of calls to the MultiExp precompiles with `k` (point, scalar) pair"}},"vm":{},"pow":{}}');

});

parcelRegister("d2tmT", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2565","number":2565,"comment":"ModExp gas cost","url":"https://eips.ethereum.org/EIPS/eip-2565","status":"Last call","minimumHardfork":"byzantium","gasConfig":{},"gasPrices":{"modexpGquaddivisor":{"v":3,"d":"Gquaddivisor from modexp precompile for gas calculation"}},"vm":{},"pow":{}}');

});

parcelRegister("4d3FE", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2718","comment":"Typed Transaction Envelope","url":"https://eips.ethereum.org/EIPS/eip-2718","status":"Draft","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');

});

parcelRegister("6PWDu", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2929","comment":"Gas cost increases for state access opcodes","url":"https://eips.ethereum.org/EIPS/eip-2929","status":"Draft","minimumHardfork":"chainstart","gasConfig":{},"gasPrices":{"coldsload":{"v":2100,"d":"Gas cost of the first read of storage from a given location (per transaction)"},"coldaccountaccess":{"v":2600,"d":"Gas cost of the first read of a given address (per transaction)"},"warmstorageread":{"v":100,"d":"Gas cost of reading storage locations which have already loaded \'cold\'"},"sstoreCleanGasEIP2200":{"v":2900,"d":"Once per SSTORE operation from clean non-zero to something else"},"sstoreNoopGasEIP2200":{"v":100,"d":"Once per SSTORE operation if the value doesn\'t change"},"sstoreDirtyGasEIP2200":{"v":100,"d":"Once per SSTORE operation if a dirty value is changed"},"sstoreInitRefundEIP2200":{"v":19900,"d":"Once per SSTORE operation for resetting to the original zero value"},"sstoreCleanRefundEIP2200":{"v":4900,"d":"Once per SSTORE operation for resetting to the original non-zero value"},"call":{"v":0,"d":"Base fee of the CALL opcode"},"callcode":{"v":0,"d":"Base fee of the CALLCODE opcode"},"delegatecall":{"v":0,"d":"Base fee of the DELEGATECALL opcode"},"staticcall":{"v":0,"d":"Base fee of the STATICCALL opcode"},"balance":{"v":0,"d":"Base fee of the BALANCE opcode"},"extcodesize":{"v":0,"d":"Base fee of the EXTCODESIZE opcode"},"extcodecopy":{"v":0,"d":"Base fee of the EXTCODECOPY opcode"},"extcodehash":{"v":0,"d":"Base fee of the EXTCODEHASH opcode"},"sload":{"v":0,"d":"Base fee of the SLOAD opcode"},"sstore":{"v":0,"d":"Base fee of the SSTORE opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("9hrqI", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-2930","comment":"Optional access lists","url":"https://eips.ethereum.org/EIPS/eip-2930","status":"Draft","minimumHardfork":"istanbul","requiredEIPs":[2718,2929],"gasConfig":{},"gasPrices":{"accessListStorageKeyCost":{"v":1900,"d":"Gas cost per storage key in an Access List transaction"},"accessListAddressCost":{"v":2400,"d":"Gas cost per storage key in an Access List transaction"}},"vm":{},"pow":{}}');

});

parcelRegister("1gHgS", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-3198","number":3198,"comment":"BASEFEE opcode","url":"https://eips.ethereum.org/EIPS/eip-3198","status":"Review","minimumHardfork":"london","gasConfig":{},"gasPrices":{"basefee":{"v":2,"d":"Gas cost of the BASEFEE opcode"}},"vm":{},"pow":{}}');

});

parcelRegister("dTif7", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-3529","comment":"Reduction in refunds","url":"https://eips.ethereum.org/EIPS/eip-3529","status":"Draft","minimumHardfork":"berlin","requiredEIPs":[2929],"gasConfig":{"maxRefundQuotient":{"v":5,"d":"Maximum refund quotient; max tx refund is min(tx.gasUsed/maxRefundQuotient, tx.gasRefund)"}},"gasPrices":{"selfdestructRefund":{"v":0,"d":"Refunded following a selfdestruct operation"},"sstoreClearRefundEIP2200":{"v":4800,"d":"Once per SSTORE operation for clearing an originally existing storage slot"}},"vm":{},"pow":{}}');

});

parcelRegister("vCoev", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-3541","comment":"Reject new contracts starting with the 0xEF byte","url":"https://eips.ethereum.org/EIPS/eip-3541","status":"Draft","minimumHardfork":"berlin","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{}}');

});

parcelRegister("Oy1RQ", function(module, exports) {
module.exports = JSON.parse('{"name":"EIP-3554","comment":"Reduction in refunds","url":"Difficulty Bomb Delay to December 1st 2021","status":"Draft","minimumHardfork":"muirGlacier","requiredEIPs":[],"gasConfig":{},"gasPrices":{},"vm":{},"pow":{"difficultyBombDelay":{"v":9500000,"d":"the amount of blocks to delay the difficulty bomb with"}}}');

});



parcelRegister("6bHyf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.N_DIV_2 = module.exports.isAccessList = module.exports.isAccessListBuffer = module.exports.Capability = void 0;

var $eqs3F = parcelRequire("eqs3F");
/**
 * Can be used in conjunction with {@link Transaction.supports}
 * to query on tx capabilities
 */ var $48158d8b4bf5aee7$var$Capability;
(function(Capability) {
    /**
     * Tx supports EIP-155 replay protection
     * See: [155](https://eips.ethereum.org/EIPS/eip-155) Replay Attack Protection EIP
     */ Capability[Capability["EIP155ReplayProtection"] = 155] = "EIP155ReplayProtection";
    /**
     * Tx supports EIP-1559 gas fee market mechansim
     * See: [1559](https://eips.ethereum.org/EIPS/eip-1559) Fee Market EIP
     */ Capability[Capability["EIP1559FeeMarket"] = 1559] = "EIP1559FeeMarket";
    /**
     * Tx is a typed transaction as defined in EIP-2718
     * See: [2718](https://eips.ethereum.org/EIPS/eip-2718) Transaction Type EIP
     */ Capability[Capability["EIP2718TypedTransaction"] = 2718] = "EIP2718TypedTransaction";
    /**
     * Tx supports access list generation as defined in EIP-2930
     * See: [2930](https://eips.ethereum.org/EIPS/eip-2930) Access Lists EIP
     */ Capability[Capability["EIP2930AccessLists"] = 2930] = "EIP2930AccessLists";
})($48158d8b4bf5aee7$var$Capability = module.exports.Capability || (module.exports.Capability = {}));
function $48158d8b4bf5aee7$var$isAccessListBuffer(input) {
    if (input.length === 0) return true;
    var firstItem = input[0];
    if (Array.isArray(firstItem)) return true;
    return false;
}
module.exports.isAccessListBuffer = $48158d8b4bf5aee7$var$isAccessListBuffer;
function $48158d8b4bf5aee7$var$isAccessList(input) {
    return !$48158d8b4bf5aee7$var$isAccessListBuffer(input); // This is exactly the same method, except the output is negated.
}
module.exports.isAccessList = $48158d8b4bf5aee7$var$isAccessList;
/**
 * A const defining secp256k1n/2
 */ module.exports.N_DIV_2 = new $eqs3F.BN("7fffffffffffffffffffffffffffffff5d576e7357a4501ddfe92f46681b20a0", 16);

});

parcelRegister("dQo6s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extractPublicKey = module.exports.recoverPersonalSignature = module.exports.personalSign = void 0;

var $fz3Xx = parcelRequire("fz3Xx");

var $grbfr = parcelRequire("grbfr");
/**
 * Create an Ethereum-specific signature for a message.
 *
 * This function is equivalent to the `eth_sign` Ethereum JSON-RPC method as specified in EIP-1417,
 * as well as the MetaMask's `personal_sign` method.
 *
 * @param options - The personal sign options.
 * @param options.privateKey - The key to sign with.
 * @param options.data - The hex data to sign.
 * @returns The '0x'-prefixed hex encoded signature.
 */ function $a142d416309307e3$var$personalSign({ privateKey: privateKey, data: data }) {
    if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(privateKey)) throw new Error("Missing privateKey parameter");
    const message = (0, $grbfr.legacyToBuffer)(data);
    const msgHash = (0, $fz3Xx.hashPersonalMessage)(message);
    const sig = (0, $fz3Xx.ecsign)(msgHash, privateKey);
    const serialized = (0, $grbfr.concatSig)((0, $fz3Xx.toBuffer)(sig.v), sig.r, sig.s);
    return serialized;
}
module.exports.personalSign = $a142d416309307e3$var$personalSign;
/**
 * Recover the address of the account used to create the given Ethereum signature. The message
 * must have been signed using the `personalSign` function, or an equivalent function.
 *
 * @param options - The signature recovery options.
 * @param options.data - The hex data that was signed.
 * @param options.signature - The '0x'-prefixed hex encoded message signature.
 * @returns The '0x'-prefixed hex encoded address of the message signer.
 */ function $a142d416309307e3$var$recoverPersonalSignature({ data: data, signature: signature }) {
    if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(signature)) throw new Error("Missing signature parameter");
    const publicKey = $a142d416309307e3$var$getPublicKeyFor(data, signature);
    const sender = (0, $fz3Xx.publicToAddress)(publicKey);
    const senderHex = (0, $fz3Xx.bufferToHex)(sender);
    return senderHex;
}
module.exports.recoverPersonalSignature = $a142d416309307e3$var$recoverPersonalSignature;
/**
 * Recover the public key of the account used to create the given Ethereum signature. The message
 * must have been signed using the `personalSign` function, or an equivalent function.
 *
 * @param options - The public key recovery options.
 * @param options.data - The hex data that was signed.
 * @param options.signature - The '0x'-prefixed hex encoded message signature.
 * @returns The '0x'-prefixed hex encoded public key of the message signer.
 */ function $a142d416309307e3$var$extractPublicKey({ data: data, signature: signature }) {
    if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(signature)) throw new Error("Missing signature parameter");
    const publicKey = $a142d416309307e3$var$getPublicKeyFor(data, signature);
    return `0x${publicKey.toString("hex")}`;
}
module.exports.extractPublicKey = $a142d416309307e3$var$extractPublicKey;
/**
 * Get the public key for the given signature and message.
 *
 * @param message - The message that was signed.
 * @param signature - The '0x'-prefixed hex encoded message signature.
 * @returns The public key of the signer.
 */ function $a142d416309307e3$var$getPublicKeyFor(message, signature) {
    const messageHash = (0, $fz3Xx.hashPersonalMessage)((0, $grbfr.legacyToBuffer)(message));
    return (0, $grbfr.recoverPublicKey)(messageHash, signature);
}

});
parcelRegister("fz3Xx", function(module, exports) {
"use strict";
var $b54d321fe75a82a2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b54d321fe75a82a2$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b54d321fe75a82a2$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toAscii = module.exports.stripHexPrefix = module.exports.padToEven = module.exports.isHexString = module.exports.isHexPrefixed = module.exports.getKeys = module.exports.getBinarySize = module.exports.fromUtf8 = module.exports.fromAscii = module.exports.arrayContainsArray = void 0;

/**
 * Constants
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("3amHV")), module.exports);

/**
 * Units helpers
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("1yx80")), module.exports);

/**
 * Account class and helper functions
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("cjATJ")), module.exports);

/**
 * Address type
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("kMKXc")), module.exports);

/**
 * Withdrawal type
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("i8Xv8")), module.exports);

/**
 * ECDSA signature
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("kPUtI")), module.exports);

/**
 * Utilities for manipulating Buffers, byte arrays, etc.
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("4nduh")), module.exports);

/**
 * Helpful TypeScript types
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("h6mqJ")), module.exports);

/**
 * Helper function for working with compact encoding
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("eKZ3r")), module.exports);

/**
 * Export ethjs-util methods
 */ $b54d321fe75a82a2$var$__exportStar((parcelRequire("kW3fK")), module.exports);

var $6oTn3 = parcelRequire("6oTn3");
Object.defineProperty(module.exports, "arrayContainsArray", {
    enumerable: true,
    get: function() {
        return $6oTn3.arrayContainsArray;
    }
});
Object.defineProperty(module.exports, "fromAscii", {
    enumerable: true,
    get: function() {
        return $6oTn3.fromAscii;
    }
});
Object.defineProperty(module.exports, "fromUtf8", {
    enumerable: true,
    get: function() {
        return $6oTn3.fromUtf8;
    }
});
Object.defineProperty(module.exports, "getBinarySize", {
    enumerable: true,
    get: function() {
        return $6oTn3.getBinarySize;
    }
});
Object.defineProperty(module.exports, "getKeys", {
    enumerable: true,
    get: function() {
        return $6oTn3.getKeys;
    }
});
Object.defineProperty(module.exports, "isHexPrefixed", {
    enumerable: true,
    get: function() {
        return $6oTn3.isHexPrefixed;
    }
});
Object.defineProperty(module.exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $6oTn3.isHexString;
    }
});
Object.defineProperty(module.exports, "padToEven", {
    enumerable: true,
    get: function() {
        return $6oTn3.padToEven;
    }
});
Object.defineProperty(module.exports, "stripHexPrefix", {
    enumerable: true,
    get: function() {
        return $6oTn3.stripHexPrefix;
    }
});
Object.defineProperty(module.exports, "toAscii", {
    enumerable: true,
    get: function() {
        return $6oTn3.toAscii;
    }
});

$b54d321fe75a82a2$var$__exportStar((parcelRequire("1lNHU")), module.exports);

$b54d321fe75a82a2$var$__exportStar((parcelRequire("5qpD3")), module.exports);

});
parcelRegister("3amHV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MAX_WITHDRAWALS_PER_PAYLOAD = module.exports.RLP_EMPTY_STRING = module.exports.KECCAK256_RLP = module.exports.KECCAK256_RLP_S = module.exports.KECCAK256_RLP_ARRAY = module.exports.KECCAK256_RLP_ARRAY_S = module.exports.KECCAK256_NULL = module.exports.KECCAK256_NULL_S = module.exports.TWO_POW256 = module.exports.SECP256K1_ORDER_DIV_2 = module.exports.SECP256K1_ORDER = module.exports.MAX_INTEGER_BIGINT = module.exports.MAX_INTEGER = module.exports.MAX_UINT64 = void 0;

var $ihoyg = parcelRequire("ihoyg");

var $hOBcC = parcelRequire("hOBcC");
/**
 * 2^64-1
 */ module.exports.MAX_UINT64 = BigInt("0xffffffffffffffff");
/**
 * The max integer that the evm can handle (2^256-1)
 */ module.exports.MAX_INTEGER = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
/**
 * The max integer that the evm can handle (2^256-1) as a bigint
 * 2^256-1 equals to 340282366920938463463374607431768211455
 * We use literal value instead of calculated value for compatibility issue.
 */ module.exports.MAX_INTEGER_BIGINT = BigInt("115792089237316195423570985008687907853269984665640564039457584007913129639935");
module.exports.SECP256K1_ORDER = $hOBcC.secp256k1.CURVE.n;
module.exports.SECP256K1_ORDER_DIV_2 = $hOBcC.secp256k1.CURVE.n / BigInt(2);
/**
 * 2^256
 */ module.exports.TWO_POW256 = BigInt("0x10000000000000000000000000000000000000000000000000000000000000000");
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL_S = "c5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
/**
 * Keccak-256 hash of null
 */ module.exports.KECCAK256_NULL = $ihoyg.Buffer.from(module.exports.KECCAK256_NULL_S, "hex");
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY_S = "1dcc4de8dec75d7aab85b567b6ccd41ad312451b948a7413f0a142fd40d49347";
/**
 * Keccak-256 of an RLP of an empty array
 */ module.exports.KECCAK256_RLP_ARRAY = $ihoyg.Buffer.from(module.exports.KECCAK256_RLP_ARRAY_S, "hex");
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP_S = "56e81f171bcc55a6ff8345e692c0f86e5b48e01b996cadc001622fb5e363b421";
/**
 * Keccak-256 hash of the RLP of null
 */ module.exports.KECCAK256_RLP = $ihoyg.Buffer.from(module.exports.KECCAK256_RLP_S, "hex");
/**
 *  RLP encoded empty string
 */ module.exports.RLP_EMPTY_STRING = $ihoyg.Buffer.from([
    0x80
]);
module.exports.MAX_WITHDRAWALS_PER_PAYLOAD = 16;

});
parcelRegister("hOBcC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.secp256k1 = void 0;

var $fM65e = parcelRequire("fM65e");
Object.defineProperty(module.exports, "secp256k1", {
    enumerable: true,
    get: function() {
        return $fM65e.secp256k1;
    }
});

});
parcelRegister("fM65e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encodeToCurve = module.exports.hashToCurve = module.exports.schnorr = module.exports.secp256k1 = void 0;

var $en59a = parcelRequire("en59a");

var $fMlZ8 = parcelRequire("fMlZ8");

var $kXwf6 = parcelRequire("kXwf6");

var $fuwhd = parcelRequire("fuwhd");

var $ebkGf = parcelRequire("ebkGf");

var $6pfYR = parcelRequire("6pfYR");

var $jop2u = parcelRequire("jop2u");
const $b7c00ec1cc5daba7$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $b7c00ec1cc5daba7$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $b7c00ec1cc5daba7$var$_1n = BigInt(1);
const $b7c00ec1cc5daba7$var$_2n = BigInt(2);
const $b7c00ec1cc5daba7$var$divNearest = (a, b)=>(a + b / $b7c00ec1cc5daba7$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $b7c00ec1cc5daba7$var$sqrtMod(y) {
    const P = $b7c00ec1cc5daba7$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $kXwf6.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $kXwf6.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $kXwf6.pow2)(b9, $b7c00ec1cc5daba7$var$_2n, P) * b2 % P;
    const b22 = (0, $kXwf6.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $kXwf6.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $kXwf6.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $kXwf6.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $kXwf6.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $kXwf6.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $kXwf6.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $kXwf6.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $kXwf6.pow2)(t2, $b7c00ec1cc5daba7$var$_2n, P);
    if (!$b7c00ec1cc5daba7$var$Fp.eql($b7c00ec1cc5daba7$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $b7c00ec1cc5daba7$var$Fp = (0, $kXwf6.Field)($b7c00ec1cc5daba7$var$secp256k1P, undefined, undefined, {
    sqrt: $b7c00ec1cc5daba7$var$sqrtMod
});
module.exports.secp256k1 = (0, $jop2u.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $b7c00ec1cc5daba7$var$Fp,
    n: $b7c00ec1cc5daba7$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $b7c00ec1cc5daba7$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$b7c00ec1cc5daba7$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $b7c00ec1cc5daba7$var$divNearest(b2 * k, n);
            const c2 = $b7c00ec1cc5daba7$var$divNearest(-b1 * k, n);
            let k1 = (0, $kXwf6.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $kXwf6.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $en59a.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $b7c00ec1cc5daba7$var$_0n = BigInt(0);
const $b7c00ec1cc5daba7$var$fe = (x)=>typeof x === "bigint" && $b7c00ec1cc5daba7$var$_0n < x && x < $b7c00ec1cc5daba7$var$secp256k1P;
const $b7c00ec1cc5daba7$var$ge = (x)=>typeof x === "bigint" && $b7c00ec1cc5daba7$var$_0n < x && x < $b7c00ec1cc5daba7$var$secp256k1N;
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES = {};
function $b7c00ec1cc5daba7$var$taggedHash(tag, ...messages) {
    let tagP = $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $en59a.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $ebkGf.concatBytes)(tagH, tagH);
        $b7c00ec1cc5daba7$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $en59a.sha256)((0, $ebkGf.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $b7c00ec1cc5daba7$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $b7c00ec1cc5daba7$var$numTo32b = (n)=>(0, $ebkGf.numberToBytesBE)(n, 32);
const $b7c00ec1cc5daba7$var$modP = (x)=>(0, $kXwf6.mod)(x, $b7c00ec1cc5daba7$var$secp256k1P);
const $b7c00ec1cc5daba7$var$modN = (x)=>(0, $kXwf6.mod)(x, $b7c00ec1cc5daba7$var$secp256k1N);
const $b7c00ec1cc5daba7$var$Point = module.exports.secp256k1.ProjectivePoint;
const $b7c00ec1cc5daba7$var$GmulAdd = (Q, a, b)=>$b7c00ec1cc5daba7$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(priv) {
    let d_ = module.exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $b7c00ec1cc5daba7$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $b7c00ec1cc5daba7$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $b7c00ec1cc5daba7$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $b7c00ec1cc5daba7$var$lift_x(x) {
    if (!$b7c00ec1cc5daba7$var$fe(x)) throw new Error("bad x: need 0 < x < p"); // Fail if x ≥ p.
    const xx = $b7c00ec1cc5daba7$var$modP(x * x);
    const c = $b7c00ec1cc5daba7$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $b7c00ec1cc5daba7$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $b7c00ec1cc5daba7$var$_2n !== $b7c00ec1cc5daba7$var$_0n) y = $b7c00ec1cc5daba7$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $b7c00ec1cc5daba7$var$Point(x, y, $b7c00ec1cc5daba7$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $b7c00ec1cc5daba7$var$challenge(...args) {
    return $b7c00ec1cc5daba7$var$modN((0, $ebkGf.bytesToNumberBE)($b7c00ec1cc5daba7$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $b7c00ec1cc5daba7$var$schnorrGetPublicKey(privateKey) {
    return $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $b7c00ec1cc5daba7$var$schnorrSign(message, privateKey, auxRand = (0, $fMlZ8.randomBytes)(32)) {
    const m = (0, $ebkGf.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $ebkGf.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $b7c00ec1cc5daba7$var$numTo32b(d ^ (0, $ebkGf.bytesToNumberBE)($b7c00ec1cc5daba7$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $b7c00ec1cc5daba7$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $b7c00ec1cc5daba7$var$modN((0, $ebkGf.bytesToNumberBE)(rand)); // Let k' = int(rand) mod n
    if (k_ === $b7c00ec1cc5daba7$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $b7c00ec1cc5daba7$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $b7c00ec1cc5daba7$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($b7c00ec1cc5daba7$var$numTo32b($b7c00ec1cc5daba7$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$b7c00ec1cc5daba7$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $b7c00ec1cc5daba7$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $ebkGf.ensureBytes)("signature", signature, 64);
    const m = (0, $ebkGf.ensureBytes)("message", message);
    const pub = (0, $ebkGf.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $b7c00ec1cc5daba7$var$lift_x((0, $ebkGf.bytesToNumberBE)(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = (0, $ebkGf.bytesToNumberBE)(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!$b7c00ec1cc5daba7$var$fe(r)) return false;
        const s = (0, $ebkGf.bytesToNumberBE)(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!$b7c00ec1cc5daba7$var$ge(s)) return false;
        const e = $b7c00ec1cc5daba7$var$challenge($b7c00ec1cc5daba7$var$numTo32b(r), $b7c00ec1cc5daba7$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $b7c00ec1cc5daba7$var$GmulAdd(P, s, $b7c00ec1cc5daba7$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
module.exports.schnorr = (()=>({
        getPublicKey: $b7c00ec1cc5daba7$var$schnorrGetPublicKey,
        sign: $b7c00ec1cc5daba7$var$schnorrSign,
        verify: $b7c00ec1cc5daba7$var$schnorrVerify,
        utils: {
            randomPrivateKey: module.exports.secp256k1.utils.randomPrivateKey,
            lift_x: $b7c00ec1cc5daba7$var$lift_x,
            pointToBytes: $b7c00ec1cc5daba7$var$pointToBytes,
            numberToBytesBE: $ebkGf.numberToBytesBE,
            bytesToNumberBE: $ebkGf.bytesToNumberBE,
            taggedHash: $b7c00ec1cc5daba7$var$taggedHash,
            mod: $kXwf6.mod
        }
    }))();
const $b7c00ec1cc5daba7$var$isoMap = /* @__PURE__ */ (()=>(0, $6pfYR.isogenyMap)($b7c00ec1cc5daba7$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $b7c00ec1cc5daba7$var$mapSWU = /* @__PURE__ */ (()=>(0, $fuwhd.mapToCurveSimpleSWU)($b7c00ec1cc5daba7$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $b7c00ec1cc5daba7$var$Fp.create(BigInt("-11"))
    }))();
const $b7c00ec1cc5daba7$var$htf = /* @__PURE__ */ (()=>(0, $6pfYR.createHasher)(module.exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $b7c00ec1cc5daba7$var$mapSWU($b7c00ec1cc5daba7$var$Fp.create(scalars[0]));
        return $b7c00ec1cc5daba7$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $b7c00ec1cc5daba7$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $en59a.sha256
    }))();
module.exports.hashToCurve = (()=>$b7c00ec1cc5daba7$var$htf.hashToCurve)();
module.exports.encodeToCurve = (()=>$b7c00ec1cc5daba7$var$htf.encodeToCurve)();

});
parcelRegister("en59a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = void 0;

var $hrYsh = parcelRequire("hrYsh");

var $fMlZ8 = parcelRequire("fMlZ8");
// Choice: a ? b : c
const $a76734b607d726cc$var$Chi = (a, b, c)=>a & b ^ ~a & c;
// Majority function, true if any two inpust is true
const $a76734b607d726cc$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $a76734b607d726cc$var$SHA256_K = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
// prettier-ignore
const $a76734b607d726cc$var$IV = new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $a76734b607d726cc$var$SHA256_W = new Uint32Array(64);
class $a76734b607d726cc$var$SHA256 extends $hrYsh.SHA2 {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $a76734b607d726cc$var$IV[0] | 0;
        this.B = $a76734b607d726cc$var$IV[1] | 0;
        this.C = $a76734b607d726cc$var$IV[2] | 0;
        this.D = $a76734b607d726cc$var$IV[3] | 0;
        this.E = $a76734b607d726cc$var$IV[4] | 0;
        this.F = $a76734b607d726cc$var$IV[5] | 0;
        this.G = $a76734b607d726cc$var$IV[6] | 0;
        this.H = $a76734b607d726cc$var$IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$a76734b607d726cc$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $a76734b607d726cc$var$SHA256_W[i - 15];
            const W2 = $a76734b607d726cc$var$SHA256_W[i - 2];
            const s0 = (0, $fMlZ8.rotr)(W15, 7) ^ (0, $fMlZ8.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $fMlZ8.rotr)(W2, 17) ^ (0, $fMlZ8.rotr)(W2, 19) ^ W2 >>> 10;
            $a76734b607d726cc$var$SHA256_W[i] = s1 + $a76734b607d726cc$var$SHA256_W[i - 7] + s0 + $a76734b607d726cc$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $fMlZ8.rotr)(E, 6) ^ (0, $fMlZ8.rotr)(E, 11) ^ (0, $fMlZ8.rotr)(E, 25);
            const T1 = H + sigma1 + $a76734b607d726cc$var$Chi(E, F, G) + $a76734b607d726cc$var$SHA256_K[i] + $a76734b607d726cc$var$SHA256_W[i] | 0;
            const sigma0 = (0, $fMlZ8.rotr)(A, 2) ^ (0, $fMlZ8.rotr)(A, 13) ^ (0, $fMlZ8.rotr)(A, 22);
            const T2 = sigma0 + $a76734b607d726cc$var$Maj(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $a76734b607d726cc$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $a76734b607d726cc$var$SHA224 extends $a76734b607d726cc$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $fMlZ8.wrapConstructor)(()=>new $a76734b607d726cc$var$SHA256());
module.exports.sha224 = (0, $fMlZ8.wrapConstructor)(()=>new $a76734b607d726cc$var$SHA224());

});
parcelRegister("hrYsh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SHA2 = void 0;

var $eAZ7S = parcelRequire("eAZ7S");

var $fMlZ8 = parcelRequire("fMlZ8");
// Polyfill for Safari 14
function $cb43da6e59c7d919$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
// Base SHA2 class (RFC 6234)
class $cb43da6e59c7d919$var$SHA2 extends $fMlZ8.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $fMlZ8.createView)(this.buffer);
    }
    update(data) {
        $eAZ7S.default.exists(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $fMlZ8.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $fMlZ8.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        $eAZ7S.default.exists(this);
        $eAZ7S.default.output(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $cb43da6e59c7d919$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $fMlZ8.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.SHA2 = $cb43da6e59c7d919$var$SHA2;

});
parcelRegister("eAZ7S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $aa03d7ddccda6350$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $aa03d7ddccda6350$var$number;
function $aa03d7ddccda6350$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $aa03d7ddccda6350$var$bool;
function $aa03d7ddccda6350$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $aa03d7ddccda6350$var$bytes;
function $aa03d7ddccda6350$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $aa03d7ddccda6350$var$number(hash.outputLen);
    $aa03d7ddccda6350$var$number(hash.blockLen);
}
module.exports.hash = $aa03d7ddccda6350$var$hash;
function $aa03d7ddccda6350$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $aa03d7ddccda6350$var$exists;
function $aa03d7ddccda6350$var$output(out, instance) {
    $aa03d7ddccda6350$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $aa03d7ddccda6350$var$output;
const $aa03d7ddccda6350$var$assert = {
    number: $aa03d7ddccda6350$var$number,
    bool: $aa03d7ddccda6350$var$bool,
    bytes: $aa03d7ddccda6350$var$bytes,
    hash: $aa03d7ddccda6350$var$hash,
    exists: $aa03d7ddccda6350$var$exists,
    output: $aa03d7ddccda6350$var$output
};
module.exports.default = $aa03d7ddccda6350$var$assert;

});

parcelRegister("fMlZ8", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $1PUkX = parcelRequire("1PUkX");
const $b7cc647cc1232eb5$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $b7cc647cc1232eb5$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $b7cc647cc1232eb5$var$u8;
const $b7cc647cc1232eb5$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $b7cc647cc1232eb5$var$u32;
// Cast array to view
const $b7cc647cc1232eb5$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $b7cc647cc1232eb5$var$createView;
// The rotate right (circular right shift) operation for uint32
const $b7cc647cc1232eb5$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $b7cc647cc1232eb5$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $b7cc647cc1232eb5$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $b7cc647cc1232eb5$var$bytesToHex(bytes) {
    if (!$b7cc647cc1232eb5$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $b7cc647cc1232eb5$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $b7cc647cc1232eb5$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $b7cc647cc1232eb5$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $b7cc647cc1232eb5$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $b7cc647cc1232eb5$var$nextTick = async ()=>{};
module.exports.nextTick = $b7cc647cc1232eb5$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $b7cc647cc1232eb5$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $b7cc647cc1232eb5$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $b7cc647cc1232eb5$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $b7cc647cc1232eb5$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $b7cc647cc1232eb5$var$toBytes(data) {
    if (typeof data === "string") data = $b7cc647cc1232eb5$var$utf8ToBytes(data);
    if (!$b7cc647cc1232eb5$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $b7cc647cc1232eb5$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $b7cc647cc1232eb5$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$b7cc647cc1232eb5$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $b7cc647cc1232eb5$var$concatBytes;
// For runtime check if class implements interface
class $b7cc647cc1232eb5$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $b7cc647cc1232eb5$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $b7cc647cc1232eb5$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $b7cc647cc1232eb5$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$b7cc647cc1232eb5$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $b7cc647cc1232eb5$var$checkOpts;
function $b7cc647cc1232eb5$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($b7cc647cc1232eb5$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $b7cc647cc1232eb5$var$wrapConstructor;
function $b7cc647cc1232eb5$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b7cc647cc1232eb5$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $b7cc647cc1232eb5$var$wrapConstructorWithOpts;
function $b7cc647cc1232eb5$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($b7cc647cc1232eb5$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $b7cc647cc1232eb5$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $b7cc647cc1232eb5$var$randomBytes(bytesLength = 32) {
    if ($1PUkX.crypto && typeof $1PUkX.crypto.getRandomValues === "function") return $1PUkX.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $b7cc647cc1232eb5$var$randomBytes;

});
parcelRegister("1PUkX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("kXwf6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashToPrivateScalar = module.exports.FpSqrtEven = module.exports.FpSqrtOdd = module.exports.Field = module.exports.nLength = module.exports.FpIsSquare = module.exports.FpDiv = module.exports.FpInvertBatch = module.exports.FpPow = module.exports.validateField = module.exports.isNegativeLE = module.exports.FpSqrt = module.exports.tonelliShanks = module.exports.invert = module.exports.pow2 = module.exports.pow = module.exports.mod = void 0;

var $ebkGf = parcelRequire("ebkGf");
// prettier-ignore
const $f4225407683e7e63$var$_0n = BigInt(0), $f4225407683e7e63$var$_1n = BigInt(1), $f4225407683e7e63$var$_2n = BigInt(2), $f4225407683e7e63$var$_3n = BigInt(3);
// prettier-ignore
const $f4225407683e7e63$var$_4n = BigInt(4), $f4225407683e7e63$var$_5n = BigInt(5), $f4225407683e7e63$var$_8n = BigInt(8);
// prettier-ignore
const $f4225407683e7e63$var$_9n = BigInt(9), $f4225407683e7e63$var$_16n = BigInt(16);
// Calculates a modulo b
function $f4225407683e7e63$var$mod(a, b) {
    const result = a % b;
    return result >= $f4225407683e7e63$var$_0n ? result : b + result;
}
module.exports.mod = $f4225407683e7e63$var$mod;
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $f4225407683e7e63$var$pow(num, power, modulo) {
    if (modulo <= $f4225407683e7e63$var$_0n || power < $f4225407683e7e63$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $f4225407683e7e63$var$_1n) return $f4225407683e7e63$var$_0n;
    let res = $f4225407683e7e63$var$_1n;
    while(power > $f4225407683e7e63$var$_0n){
        if (power & $f4225407683e7e63$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $f4225407683e7e63$var$_1n;
    }
    return res;
}
module.exports.pow = $f4225407683e7e63$var$pow;
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $f4225407683e7e63$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $f4225407683e7e63$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
module.exports.pow2 = $f4225407683e7e63$var$pow2;
// Inverses number over modulo
function $f4225407683e7e63$var$invert(number, modulo) {
    if (number === $f4225407683e7e63$var$_0n || modulo <= $f4225407683e7e63$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $f4225407683e7e63$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $f4225407683e7e63$var$_0n, y = $f4225407683e7e63$var$_1n, u = $f4225407683e7e63$var$_1n, v = $f4225407683e7e63$var$_0n;
    while(a !== $f4225407683e7e63$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $f4225407683e7e63$var$_1n) throw new Error("invert: does not exist");
    return $f4225407683e7e63$var$mod(x, modulo);
}
module.exports.invert = $f4225407683e7e63$var$invert;
// Tonelli-Shanks algorithm
// Paper 1: https://eprint.iacr.org/2012/685.pdf (page 12)
// Paper 2: Square Roots from 1; 24, 51, 10 to Dan Shanks
function $f4225407683e7e63$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $f4225407683e7e63$var$_1n, S = 0; Q % $f4225407683e7e63$var$_2n === $f4225407683e7e63$var$_0n; Q /= $f4225407683e7e63$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $f4225407683e7e63$var$_2n; Z < P && $f4225407683e7e63$var$pow(Z, legendreC, P) !== P - $f4225407683e7e63$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $f4225407683e7e63$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
module.exports.tonelliShanks = $f4225407683e7e63$var$tonelliShanks;
function $f4225407683e7e63$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $f4225407683e7e63$var$_4n === $f4225407683e7e63$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $f4225407683e7e63$var$_8n === $f4225407683e7e63$var$_5n) {
        const c1 = (P - $f4225407683e7e63$var$_5n) / $f4225407683e7e63$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $f4225407683e7e63$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $f4225407683e7e63$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $f4225407683e7e63$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $f4225407683e7e63$var$tonelliShanks(P);
}
module.exports.FpSqrt = $f4225407683e7e63$var$FpSqrt;
// Little-endian check for first LE bit (last BE bit);
const $f4225407683e7e63$var$isNegativeLE = (num, modulo)=>($f4225407683e7e63$var$mod(num, modulo) & $f4225407683e7e63$var$_1n) === $f4225407683e7e63$var$_1n;
module.exports.isNegativeLE = $f4225407683e7e63$var$isNegativeLE;
// prettier-ignore
const $f4225407683e7e63$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $f4225407683e7e63$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $f4225407683e7e63$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $ebkGf.validateObject)(field, opts);
}
module.exports.validateField = $f4225407683e7e63$var$validateField;
// Generic field functions
function $f4225407683e7e63$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $f4225407683e7e63$var$_0n) throw new Error("Expected power > 0");
    if (power === $f4225407683e7e63$var$_0n) return f.ONE;
    if (power === $f4225407683e7e63$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $f4225407683e7e63$var$_0n){
        if (power & $f4225407683e7e63$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $f4225407683e7e63$var$_1n;
    }
    return p;
}
module.exports.FpPow = $f4225407683e7e63$var$FpPow;
// 0 is non-invertible: non-batched version will throw on 0
function $f4225407683e7e63$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
module.exports.FpInvertBatch = $f4225407683e7e63$var$FpInvertBatch;
function $f4225407683e7e63$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $f4225407683e7e63$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
module.exports.FpDiv = $f4225407683e7e63$var$FpDiv;
// This function returns True whenever the value x is a square in the field F.
function $f4225407683e7e63$var$FpIsSquare(f) {
    const legendreConst = (f.ORDER - $f4225407683e7e63$var$_1n) / $f4225407683e7e63$var$_2n; // Integer arithmetic
    return (x)=>{
        const p = f.pow(x, legendreConst);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
module.exports.FpIsSquare = $f4225407683e7e63$var$FpIsSquare;
// CURVE.n lengths
function $f4225407683e7e63$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
module.exports.nLength = $f4225407683e7e63$var$nLength;
/**
 * Initializes a galois field over prime. Non-primes are not supported for now.
 * Do not init in loop: slow. Very fragile: always run a benchmark on change.
 * Major performance gains:
 * a) non-normalized operations like mulN instead of mul
 * b) `Object.freeze`
 * c) Same object shape: never add or remove keys
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $f4225407683e7e63$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $f4225407683e7e63$var$_0n) throw new Error(`Expected Fp ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $f4225407683e7e63$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $f4225407683e7e63$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $ebkGf.bitMask)(BITS),
        ZERO: $f4225407683e7e63$var$_0n,
        ONE: $f4225407683e7e63$var$_1n,
        create: (num)=>$f4225407683e7e63$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $f4225407683e7e63$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $f4225407683e7e63$var$_0n,
        isOdd: (num)=>(num & $f4225407683e7e63$var$_1n) === $f4225407683e7e63$var$_1n,
        neg: (num)=>$f4225407683e7e63$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$f4225407683e7e63$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$f4225407683e7e63$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$f4225407683e7e63$var$mod(lhs * $f4225407683e7e63$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$f4225407683e7e63$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$f4225407683e7e63$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $ebkGf.numberToBytesLE)(num, BYTES) : (0, $ebkGf.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $ebkGf.bytesToNumberLE)(bytes) : (0, $ebkGf.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
module.exports.Field = $f4225407683e7e63$var$Field;
function $f4225407683e7e63$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
module.exports.FpSqrtOdd = $f4225407683e7e63$var$FpSqrtOdd;
function $f4225407683e7e63$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
module.exports.FpSqrtEven = $f4225407683e7e63$var$FpSqrtEven;
/**
 * FIPS 186 B.4.1-compliant "constant-time" private key generation utility.
 * Can take (n+8) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 40 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. curveFn.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $f4225407683e7e63$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $ebkGf.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $f4225407683e7e63$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $ebkGf.bytesToNumberLE)(hash) : (0, $ebkGf.bytesToNumberBE)(hash);
    return $f4225407683e7e63$var$mod(num, groupOrder - $f4225407683e7e63$var$_1n) + $f4225407683e7e63$var$_1n;
}
module.exports.hashToPrivateScalar = $f4225407683e7e63$var$hashToPrivateScalar;

});
parcelRegister("ebkGf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateObject = module.exports.createHmacDrbg = module.exports.bitMask = module.exports.bitSet = module.exports.bitGet = module.exports.bitLen = module.exports.utf8ToBytes = module.exports.equalBytes = module.exports.concatBytes = module.exports.ensureBytes = module.exports.numberToVarBytesBE = module.exports.numberToBytesLE = module.exports.numberToBytesBE = module.exports.bytesToNumberLE = module.exports.bytesToNumberBE = module.exports.hexToBytes = module.exports.hexToNumber = module.exports.numberToHexUnpadded = module.exports.bytesToHex = void 0;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a53222754f250272$var$_0n = BigInt(0);
const $a53222754f250272$var$_1n = BigInt(1);
const $a53222754f250272$var$_2n = BigInt(2);
const $a53222754f250272$var$u8a = (a)=>a instanceof Uint8Array;
const $a53222754f250272$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a53222754f250272$var$bytesToHex(bytes) {
    if (!$a53222754f250272$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a53222754f250272$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $a53222754f250272$var$bytesToHex;
function $a53222754f250272$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
module.exports.numberToHexUnpadded = $a53222754f250272$var$numberToHexUnpadded;
function $a53222754f250272$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
module.exports.hexToNumber = $a53222754f250272$var$hexToNumber;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a53222754f250272$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $a53222754f250272$var$hexToBytes;
// BE: Big Endian, LE: Little Endian
function $a53222754f250272$var$bytesToNumberBE(bytes) {
    return $a53222754f250272$var$hexToNumber($a53222754f250272$var$bytesToHex(bytes));
}
module.exports.bytesToNumberBE = $a53222754f250272$var$bytesToNumberBE;
function $a53222754f250272$var$bytesToNumberLE(bytes) {
    if (!$a53222754f250272$var$u8a(bytes)) throw new Error("Uint8Array expected");
    return $a53222754f250272$var$hexToNumber($a53222754f250272$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
module.exports.bytesToNumberLE = $a53222754f250272$var$bytesToNumberLE;
function $a53222754f250272$var$numberToBytesBE(n, len) {
    return $a53222754f250272$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
module.exports.numberToBytesBE = $a53222754f250272$var$numberToBytesBE;
function $a53222754f250272$var$numberToBytesLE(n, len) {
    return $a53222754f250272$var$numberToBytesBE(n, len).reverse();
}
module.exports.numberToBytesLE = $a53222754f250272$var$numberToBytesLE;
// Unpadded, rarely used
function $a53222754f250272$var$numberToVarBytesBE(n) {
    return $a53222754f250272$var$hexToBytes($a53222754f250272$var$numberToHexUnpadded(n));
}
module.exports.numberToVarBytesBE = $a53222754f250272$var$numberToVarBytesBE;
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a53222754f250272$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a53222754f250272$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a53222754f250272$var$u8a(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
module.exports.ensureBytes = $a53222754f250272$var$ensureBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $a53222754f250272$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$a53222754f250272$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $a53222754f250272$var$concatBytes;
function $a53222754f250272$var$equalBytes(b1, b2) {
    // We don't care about timing attacks here
    if (b1.length !== b2.length) return false;
    for(let i = 0; i < b1.length; i++)if (b1[i] !== b2[i]) return false;
    return true;
}
module.exports.equalBytes = $a53222754f250272$var$equalBytes;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a53222754f250272$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $a53222754f250272$var$utf8ToBytes;
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a53222754f250272$var$bitLen(n) {
    let len;
    for(len = 0; n > $a53222754f250272$var$_0n; n >>= $a53222754f250272$var$_1n, len += 1);
    return len;
}
module.exports.bitLen = $a53222754f250272$var$bitLen;
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a53222754f250272$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a53222754f250272$var$_1n;
}
module.exports.bitGet = $a53222754f250272$var$bitGet;
/**
 * Sets single bit at position.
 */ const $a53222754f250272$var$bitSet = (n, pos, value)=>{
    return n | (value ? $a53222754f250272$var$_1n : $a53222754f250272$var$_0n) << BigInt(pos);
};
module.exports.bitSet = $a53222754f250272$var$bitSet;
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a53222754f250272$var$bitMask = (n)=>($a53222754f250272$var$_2n << BigInt(n - 1)) - $a53222754f250272$var$_1n;
module.exports.bitMask = $a53222754f250272$var$bitMask;
// DRBG
const $a53222754f250272$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a53222754f250272$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a53222754f250272$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a53222754f250272$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a53222754f250272$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a53222754f250272$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a53222754f250272$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a53222754f250272$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a53222754f250272$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
module.exports.createHmacDrbg = $a53222754f250272$var$createHmacDrbg;
// Validating curves and fields
const $a53222754f250272$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a53222754f250272$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a53222754f250272$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
module.exports.validateObject = $a53222754f250272$var$validateObject; // validate type tests
 // const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
 // const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
 // // Should fail type-check
 // const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
 // const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
 // const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
 // const z4 = validateObject(o, { a: 'boolean', z: 'bug' });

});


parcelRegister("fuwhd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.mapToCurveSimpleSWU = module.exports.SWUFpSqrtRatio = module.exports.weierstrass = module.exports.weierstrassPoints = module.exports.DER = void 0;

var $kXwf6 = parcelRequire("kXwf6");

var $ebkGf = parcelRequire("ebkGf");

var $ebkGf = parcelRequire("ebkGf");

var $4Kwii = parcelRequire("4Kwii");
function $b472b1d3a53ce762$var$validatePointOpts(curve) {
    const opts = (0, $4Kwii.validateBasic)(curve);
    $ebkGf.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
// ASN.1 DER encoding utilities
const { bytesToNumberBE: $b472b1d3a53ce762$var$b2n, hexToBytes: $b472b1d3a53ce762$var$h2b } = $ebkGf;
module.exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    _parseInt (data) {
        const { Err: E } = module.exports.DER;
        if (data.length < 2 || data[0] !== 0x02) throw new E("Invalid signature integer tag");
        const len = data[1];
        const res = data.subarray(2, len + 2);
        if (!len || res.length !== len) throw new E("Invalid signature integer: wrong length");
        // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
        // since we always use positive integers here. It must always be empty:
        // - add zero byte if exists
        // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
        if (res[0] & 128) throw new E("Invalid signature integer: negative");
        if (res[0] === 0x00 && !(res[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
        return {
            d: $b472b1d3a53ce762$var$b2n(res),
            l: data.subarray(len + 2)
        }; // d is data, l is left
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E } = module.exports.DER;
        const data = typeof hex === "string" ? $b472b1d3a53ce762$var$h2b(hex) : hex;
        if (!(data instanceof Uint8Array)) throw new Error("ui8a expected");
        let l = data.length;
        if (l < 2 || data[0] != 0x30) throw new E("Invalid signature tag");
        if (data[1] !== l - 2) throw new E("Invalid signature: incorrect length");
        const { d: r, l: sBytes } = module.exports.DER._parseInt(data.subarray(2));
        const { d: s, l: rBytesLeft } = module.exports.DER._parseInt(sBytes);
        if (rBytesLeft.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: r,
            s: s
        };
    },
    hexFromSig (sig) {
        // Add leading zero if first byte has negative bit enabled. More details in '_parseInt'
        const slice = (s)=>Number.parseInt(s[0], 16) & 8 ? "00" + s : s;
        const h = (num)=>{
            const hex = num.toString(16);
            return hex.length & 1 ? `0${hex}` : hex;
        };
        const s = slice(h(sig.s));
        const r = slice(h(sig.r));
        const shl = s.length / 2;
        const rhl = r.length / 2;
        const sl = h(shl);
        const rl = h(rhl);
        return `30${h(rhl + shl + 4)}02${rl}${r}02${sl}${s}`;
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $b472b1d3a53ce762$var$_0n = BigInt(0), $b472b1d3a53ce762$var$_1n = BigInt(1), $b472b1d3a53ce762$var$_2n = BigInt(2), $b472b1d3a53ce762$var$_3n = BigInt(3), $b472b1d3a53ce762$var$_4n = BigInt(4);
function $b472b1d3a53ce762$var$weierstrassPoints(opts) {
    const CURVE = $b472b1d3a53ce762$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const toBytes = CURVE.toBytes || ((c, point, isCompressed)=>{
        const a = point.toAffine();
        return $ebkGf.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return typeof num === "bigint" && $b472b1d3a53ce762$var$_0n < num && num < CURVE.n;
    }
    function assertGE(num) {
        if (!isWithinCurveOrder(num)) throw new Error("Expected valid bigint: 0 < bigint < curve.n");
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: n } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if (key instanceof Uint8Array) key = $ebkGf.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $ebkGf.bytesToNumberBE((0, $ebkGf.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $kXwf6.mod(num, n); // disabled by default, enabled for BLS
        assertGE(num); // num in range [1..N-1]
        return num;
    }
    const pointPrecomputes = new Map();
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $ebkGf.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            this._WINDOW_SIZE = windowSize;
            pointPrecomputes.delete(this);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            // Zero is valid point too!
            if (this.is0()) {
                if (CURVE.allowInfinityPoint) return;
                throw new Error("bad point: ZERO");
            }
            // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
            const { x: x, y: y } = this.toAffine();
            // Check if x, y are valid field elements
            if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
            const left = Fp.sqr(y); // y²
            const right = weierstrassEquation(x); // x³ + ax + b
            if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
            if (!this.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $b472b1d3a53ce762$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $b472b1d3a53ce762$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, pointPrecomputes, n, (comp)=>{
                const toInv = Fp.invertBatch(comp.map((p)=>p.pz));
                return comp.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
            });
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(n) {
            const I = Point.ZERO;
            if (n === $b472b1d3a53ce762$var$_0n) return I;
            assertGE(n); // Will throw on 0
            if (n === $b472b1d3a53ce762$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, n);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $b472b1d3a53ce762$var$_0n || k2 > $b472b1d3a53ce762$var$_0n){
                if (k1 & $b472b1d3a53ce762$var$_1n) k1p = k1p.add(d);
                if (k2 & $b472b1d3a53ce762$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $b472b1d3a53ce762$var$_1n;
                k2 >>= $b472b1d3a53ce762$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            assertGE(scalar);
            let n = scalar;
            let point, fake; // Fake point is used to const-time mult
            const { endo: endo } = CURVE;
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(n);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(n);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $b472b1d3a53ce762$var$_0n || a === $b472b1d3a53ce762$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            const { px: x, py: y, pz: z } = this;
            const is0 = this.is0();
            // If invZ was 0, we return zero point. However we still want to execute
            // all operations, so we replace invZ with a random number, 1.
            if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
            const ax = Fp.mul(x, iz);
            const ay = Fp.mul(y, iz);
            const zz = Fp.mul(z, iz);
            if (is0) return {
                x: Fp.ZERO,
                y: Fp.ZERO
            };
            if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
            return {
                x: ax,
                y: ay
            };
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $b472b1d3a53ce762$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $b472b1d3a53ce762$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            return $ebkGf.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $4Kwii.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
module.exports.weierstrassPoints = $b472b1d3a53ce762$var$weierstrassPoints;
function $b472b1d3a53ce762$var$validateOpts(curve) {
    const opts = (0, $4Kwii.validateBasic)(curve);
    $ebkGf.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
function $b472b1d3a53ce762$var$weierstrass(curveDef) {
    const CURVE = $b472b1d3a53ce762$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function isValidFieldElement(num) {
        return $b472b1d3a53ce762$var$_0n < num && num < Fp.ORDER; // 0 is banned since it's not invertible FE
    }
    function modN(a) {
        return $kXwf6.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $kXwf6.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $b472b1d3a53ce762$var$weierstrassPoints({
        ...CURVE,
        toBytes (c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $ebkGf.concatBytes;
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $ebkGf.bytesToNumberBE(tail);
                if (!isValidFieldElement(x)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                const isYOdd = (y & $b472b1d3a53ce762$var$_1n) === $b472b1d3a53ce762$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$ebkGf.bytesToHex($ebkGf.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $b472b1d3a53ce762$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$ebkGf.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $ebkGf.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = module.exports.DER.toSig((0, $ebkGf.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            // can use assertGE here
            if (!isWithinCurveOrder(this.r)) throw new Error("r must be 0 < r < CURVE.n");
            if (!isWithinCurveOrder(this.s)) throw new Error("s must be 0 < s < CURVE.n");
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $ebkGf.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $ebkGf.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return module.exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $ebkGf.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size (nBitLength+64)
         * as per FIPS 186 B.4.1 with modulo bias being neglible.
         */ randomPrivateKey: ()=>{
            const rand = CURVE.randomBytes(Fp.BYTES + 8);
            const num = $kXwf6.hashToPrivateScalar(rand, CURVE_ORDER);
            return $ebkGf.numberToBytesBE(num, CURVE.nByteLength);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = item instanceof Uint8Array;
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $ebkGf.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $ebkGf.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        if (typeof num !== "bigint") throw new Error("bigint expected");
        if (!($b472b1d3a53ce762$var$_0n <= num && num < ORDER_MASK)) throw new Error(`bigint expected < 2^${CURVE.nBitLength}`);
        // works with order, can have different size than numToField!
        return $ebkGf.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $ebkGf.ensureBytes)("msgHash", msgHash);
        if (prehash) msgHash = (0, $ebkGf.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $ebkGf.ensureBytes)("extraEntropy", e, Fp.BYTES)); // check for being of size BYTES
        }
        const seed = $ebkGf.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $b472b1d3a53ce762$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $b472b1d3a53ce762$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $b472b1d3a53ce762$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $ebkGf.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $ebkGf.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $ebkGf.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || sg instanceof Uint8Array) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof module.exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
module.exports.weierstrass = $b472b1d3a53ce762$var$weierstrass;
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $b472b1d3a53ce762$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $b472b1d3a53ce762$var$_0n;
    for(let o = q - $b472b1d3a53ce762$var$_1n; o % $b472b1d3a53ce762$var$_2n === $b472b1d3a53ce762$var$_0n; o /= $b472b1d3a53ce762$var$_2n)l += $b472b1d3a53ce762$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $b472b1d3a53ce762$var$_2n << c1 - $b472b1d3a53ce762$var$_1n - $b472b1d3a53ce762$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $b472b1d3a53ce762$var$_2n;
    const c2 = (q - $b472b1d3a53ce762$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $b472b1d3a53ce762$var$_1n) / $b472b1d3a53ce762$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $b472b1d3a53ce762$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $b472b1d3a53ce762$var$_1n) / $b472b1d3a53ce762$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $b472b1d3a53ce762$var$_1n; i--){
            let tv5 = i - $b472b1d3a53ce762$var$_2n; // 18.    tv5 = i - 2
            tv5 = $b472b1d3a53ce762$var$_2n << tv5 - $b472b1d3a53ce762$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $b472b1d3a53ce762$var$_4n === $b472b1d3a53ce762$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $b472b1d3a53ce762$var$_3n) / $b472b1d3a53ce762$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
module.exports.SWUFpSqrtRatio = $b472b1d3a53ce762$var$SWUFpSqrtRatio;
/**
 * From draft-irtf-cfrg-hash-to-curve-16
 */ function $b472b1d3a53ce762$var$mapToCurveSimpleSWU(Fp, opts) {
    $kXwf6.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $b472b1d3a53ce762$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}
module.exports.mapToCurveSimpleSWU = $b472b1d3a53ce762$var$mapToCurveSimpleSWU;

});
parcelRegister("4Kwii", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validateBasic = exports.wNAF = void 0;

var $kXwf6 = parcelRequire("kXwf6");

var $ebkGf = parcelRequire("ebkGf");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const opts = (W)=>{
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, precomputesMap, n, transform) {
            // @ts-ignore
            const W = P._WINDOW_SIZE || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = precomputesMap.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) precomputesMap.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        }
    };
}
exports.wNAF = wNAF;
function validateBasic(curve) {
    (0, $kXwf6.validateField)(curve.Fp);
    (0, $ebkGf.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $kXwf6.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}
exports.validateBasic = validateBasic;

});


parcelRegister("6pfYR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createHasher = module.exports.isogenyMap = module.exports.hash_to_field = module.exports.expand_message_xof = module.exports.expand_message_xmd = void 0;

var $kXwf6 = parcelRequire("kXwf6");

var $ebkGf = parcelRequire("ebkGf");
function $4aa17946f6094e60$var$validateDST(dst) {
    if (dst instanceof Uint8Array) return dst;
    if (typeof dst === "string") return (0, $ebkGf.utf8ToBytes)(dst);
    throw new Error("DST must be Uint8Array or string");
}
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $4aa17946f6094e60$var$os2ip = $ebkGf.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $4aa17946f6094e60$var$i2osp(value, length) {
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $4aa17946f6094e60$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $4aa17946f6094e60$var$isBytes(item) {
    if (!(item instanceof Uint8Array)) throw new Error("Uint8Array expected");
}
function $4aa17946f6094e60$var$isNum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-11#section-5.4.1
function $4aa17946f6094e60$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    $4aa17946f6094e60$var$isBytes(msg);
    $4aa17946f6094e60$var$isBytes(DST);
    $4aa17946f6094e60$var$isNum(lenInBytes);
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-5.3.3
    if (DST.length > 255) DST = H((0, $ebkGf.concatBytes)((0, $ebkGf.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (ell > 255) throw new Error("Invalid xmd length");
    const DST_prime = (0, $ebkGf.concatBytes)(DST, $4aa17946f6094e60$var$i2osp(DST.length, 1));
    const Z_pad = $4aa17946f6094e60$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $4aa17946f6094e60$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $ebkGf.concatBytes)(Z_pad, msg, l_i_b_str, $4aa17946f6094e60$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $ebkGf.concatBytes)(b_0, $4aa17946f6094e60$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $4aa17946f6094e60$var$strxor(b_0, b[i - 1]),
            $4aa17946f6094e60$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $ebkGf.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $ebkGf.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
module.exports.expand_message_xmd = $4aa17946f6094e60$var$expand_message_xmd;
function $4aa17946f6094e60$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    $4aa17946f6094e60$var$isBytes(msg);
    $4aa17946f6094e60$var$isBytes(DST);
    $4aa17946f6094e60$var$isNum(lenInBytes);
    // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $ebkGf.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($4aa17946f6094e60$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($4aa17946f6094e60$var$i2osp(DST.length, 1)).digest();
}
module.exports.expand_message_xof = $4aa17946f6094e60$var$expand_message_xof;
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-11#section-5.3
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $4aa17946f6094e60$var$hash_to_field(msg, count, options) {
    (0, $ebkGf.validateObject)(options, {
        DST: "string",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    $4aa17946f6094e60$var$isBytes(msg);
    $4aa17946f6094e60$var$isNum(count);
    const DST = $4aa17946f6094e60$var$validateDST(_DST);
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $4aa17946f6094e60$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $4aa17946f6094e60$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $kXwf6.mod)($4aa17946f6094e60$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
module.exports.hash_to_field = $4aa17946f6094e60$var$hash_to_field;
function $4aa17946f6094e60$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
module.exports.isogenyMap = $4aa17946f6094e60$var$isogenyMap;
function $4aa17946f6094e60$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve
        // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
        hashToCurve (msg, options) {
            const u = $4aa17946f6094e60$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // https://datatracker.ietf.org/doc/html/draft-irtf-cfrg-hash-to-curve-16#section-3
        encodeToCurve (msg, options) {
            const u = $4aa17946f6094e60$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}
module.exports.createHasher = $4aa17946f6094e60$var$createHasher;

});

parcelRegister("jop2u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createCurve = module.exports.getHash = void 0;

var $5dDxt = parcelRequire("5dDxt");

var $fMlZ8 = parcelRequire("fMlZ8");

var $fuwhd = parcelRequire("fuwhd");
// connects noble-curves to noble-hashes
function $e1e3ae774b62fefe$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $5dDxt.hmac)(hash, key, (0, $fMlZ8.concatBytes)(...msgs)),
        randomBytes: $fMlZ8.randomBytes
    };
}
module.exports.getHash = $e1e3ae774b62fefe$var$getHash;
function $e1e3ae774b62fefe$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $fuwhd.weierstrass)({
            ...curveDef,
            ...$e1e3ae774b62fefe$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}
module.exports.createCurve = $e1e3ae774b62fefe$var$createCurve;

});
parcelRegister("5dDxt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hmac = module.exports.HMAC = void 0;

var $eAZ7S = parcelRequire("eAZ7S");

var $fMlZ8 = parcelRequire("fMlZ8");
// HMAC (RFC 2104)
class $3cccd641544f614b$var$HMAC extends $fMlZ8.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        $eAZ7S.default.hash(hash);
        const key = (0, $fMlZ8.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        $eAZ7S.default.exists(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        $eAZ7S.default.exists(this);
        $eAZ7S.default.bytes(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
module.exports.HMAC = $3cccd641544f614b$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 */ const $3cccd641544f614b$var$hmac = (hash, key, message)=>new $3cccd641544f614b$var$HMAC(hash, key).update(message).digest();
module.exports.hmac = $3cccd641544f614b$var$hmac;
module.exports.hmac.create = (hash, key)=>new $3cccd641544f614b$var$HMAC(hash, key);

});





parcelRegister("1yx80", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GWEI_TO_WEI = void 0;
/** Easy conversion from Gwei to wei */ module.exports.GWEI_TO_WEI = BigInt(1000000000);

});

parcelRegister("cjATJ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8f73e18c3a81bc91$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.accountBodyToRLP = module.exports.accountBodyToSlim = module.exports.accountBodyFromSlim = module.exports.isZeroAddress = module.exports.zeroAddress = module.exports.importPublic = module.exports.privateToAddress = module.exports.privateToPublic = module.exports.publicToAddress = module.exports.pubToAddress = module.exports.isValidPublic = module.exports.isValidPrivate = module.exports.generateAddress2 = module.exports.generateAddress = module.exports.isValidChecksumAddress = module.exports.toChecksumAddress = module.exports.isValidAddress = module.exports.Account = void 0;

var $dHW8i = parcelRequire("dHW8i");

var $8ytum = parcelRequire("8ytum");

var $hOBcC = parcelRequire("hOBcC");

var $cNxzl = parcelRequire("cNxzl");

var $4nduh = parcelRequire("4nduh");

var $3amHV = parcelRequire("3amHV");

var $8c6iI = parcelRequire("8c6iI");

var $6oTn3 = parcelRequire("6oTn3");
const $8f73e18c3a81bc91$var$_0n = BigInt(0);
class $8f73e18c3a81bc91$var$Account {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating an Account from varying data types.
     */ constructor(nonce = $8f73e18c3a81bc91$var$_0n, balance = $8f73e18c3a81bc91$var$_0n, storageRoot = $3amHV.KECCAK256_RLP, codeHash = $3amHV.KECCAK256_NULL){
        this.nonce = nonce;
        this.balance = balance;
        this.storageRoot = storageRoot;
        this.codeHash = codeHash;
        this._validate();
    }
    static fromAccountData(accountData) {
        const { nonce: nonce, balance: balance, storageRoot: storageRoot, codeHash: codeHash } = accountData;
        return new $8f73e18c3a81bc91$var$Account(nonce !== undefined ? (0, $4nduh.bufferToBigInt)((0, $4nduh.toBuffer)(nonce)) : undefined, balance !== undefined ? (0, $4nduh.bufferToBigInt)((0, $4nduh.toBuffer)(balance)) : undefined, storageRoot !== undefined ? (0, $4nduh.toBuffer)(storageRoot) : undefined, codeHash !== undefined ? (0, $4nduh.toBuffer)(codeHash) : undefined);
    }
    static fromRlpSerializedAccount(serialized) {
        const values = (0, $4nduh.arrToBufArr)($dHW8i.RLP.decode(Uint8Array.from(serialized)));
        if (!Array.isArray(values)) throw new Error("Invalid serialized account input. Must be array");
        return this.fromValuesArray(values);
    }
    static fromValuesArray(values) {
        const [nonce, balance, storageRoot, codeHash] = values;
        return new $8f73e18c3a81bc91$var$Account((0, $4nduh.bufferToBigInt)(nonce), (0, $4nduh.bufferToBigInt)(balance), storageRoot, codeHash);
    }
    _validate() {
        if (this.nonce < $8f73e18c3a81bc91$var$_0n) throw new Error("nonce must be greater than zero");
        if (this.balance < $8f73e18c3a81bc91$var$_0n) throw new Error("balance must be greater than zero");
        if (this.storageRoot.length !== 32) throw new Error("storageRoot must have a length of 32");
        if (this.codeHash.length !== 32) throw new Error("codeHash must have a length of 32");
    }
    /**
     * Returns a Buffer Array of the raw Buffers for the account, in order.
     */ raw() {
        return [
            (0, $4nduh.bigIntToUnpaddedBuffer)(this.nonce),
            (0, $4nduh.bigIntToUnpaddedBuffer)(this.balance),
            this.storageRoot,
            this.codeHash
        ];
    }
    /**
     * Returns the RLP serialization of the account as a `Buffer`.
     */ serialize() {
        return $8f73e18c3a81bc91$require$Buffer.from($dHW8i.RLP.encode((0, $4nduh.bufArrToArr)(this.raw())));
    }
    /**
     * Returns a `Boolean` determining if the account is a contract.
     */ isContract() {
        return !this.codeHash.equals($3amHV.KECCAK256_NULL);
    }
    /**
     * Returns a `Boolean` determining if the account is empty complying to the definition of
     * account emptiness in [EIP-161](https://eips.ethereum.org/EIPS/eip-161):
     * "An account is considered empty when it has no code and zero nonce and zero balance."
     */ isEmpty() {
        return this.balance === $8f73e18c3a81bc91$var$_0n && this.nonce === $8f73e18c3a81bc91$var$_0n && this.codeHash.equals($3amHV.KECCAK256_NULL);
    }
}
module.exports.Account = $8f73e18c3a81bc91$var$Account;
/**
 * Checks if the address is a valid. Accepts checksummed addresses too.
 */ const $8f73e18c3a81bc91$var$isValidAddress = function(hexAddress) {
    try {
        (0, $8c6iI.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    return /^0x[0-9a-fA-F]{40}$/.test(hexAddress);
};
module.exports.isValidAddress = $8f73e18c3a81bc91$var$isValidAddress;
/**
 * Returns a checksummed address.
 *
 * If an eip1191ChainId is provided, the chainId will be included in the checksum calculation. This
 * has the effect of checksummed addresses for one chain having invalid checksums for others.
 * For more details see [EIP-1191](https://eips.ethereum.org/EIPS/eip-1191).
 *
 * WARNING: Checksums with and without the chainId will differ and the EIP-1191 checksum is not
 * backwards compatible to the original widely adopted checksum format standard introduced in
 * [EIP-55](https://eips.ethereum.org/EIPS/eip-55), so this will break in existing applications.
 * Usage of this EIP is therefore discouraged unless you have a very targeted use case.
 */ const $8f73e18c3a81bc91$var$toChecksumAddress = function(hexAddress, eip1191ChainId) {
    (0, $8c6iI.assertIsHexString)(hexAddress);
    const address = (0, $6oTn3.stripHexPrefix)(hexAddress).toLowerCase();
    let prefix = "";
    if (eip1191ChainId !== undefined) {
        const chainId = (0, $4nduh.bufferToBigInt)((0, $4nduh.toBuffer)(eip1191ChainId));
        prefix = chainId.toString() + "0x";
    }
    const buf = $8f73e18c3a81bc91$require$Buffer.from(prefix + address, "utf8");
    const hash = (0, $cNxzl.bytesToHex)((0, $8ytum.keccak256)(buf));
    let ret = "0x";
    for(let i = 0; i < address.length; i++)if (parseInt(hash[i], 16) >= 8) ret += address[i].toUpperCase();
    else ret += address[i];
    return ret;
};
module.exports.toChecksumAddress = $8f73e18c3a81bc91$var$toChecksumAddress;
/**
 * Checks if the address is a valid checksummed address.
 *
 * See toChecksumAddress' documentation for details about the eip1191ChainId parameter.
 */ const $8f73e18c3a81bc91$var$isValidChecksumAddress = function(hexAddress, eip1191ChainId) {
    return (0, module.exports.isValidAddress)(hexAddress) && (0, module.exports.toChecksumAddress)(hexAddress, eip1191ChainId) === hexAddress;
};
module.exports.isValidChecksumAddress = $8f73e18c3a81bc91$var$isValidChecksumAddress;
/**
 * Generates an address of a newly created contract.
 * @param from The address which is creating this new address
 * @param nonce The nonce of the from account
 */ const $8f73e18c3a81bc91$var$generateAddress = function(from, nonce) {
    (0, $8c6iI.assertIsBuffer)(from);
    (0, $8c6iI.assertIsBuffer)(nonce);
    if ((0, $4nduh.bufferToBigInt)(nonce) === BigInt(0)) // in RLP we want to encode null in the case of zero nonce
    // read the RLP documentation for an answer if you dare
    return $8f73e18c3a81bc91$require$Buffer.from((0, $8ytum.keccak256)($dHW8i.RLP.encode((0, $4nduh.bufArrToArr)([
        from,
        null
    ])))).slice(-20);
    // Only take the lower 160bits of the hash
    return $8f73e18c3a81bc91$require$Buffer.from((0, $8ytum.keccak256)($dHW8i.RLP.encode((0, $4nduh.bufArrToArr)([
        from,
        nonce
    ])))).slice(-20);
};
module.exports.generateAddress = $8f73e18c3a81bc91$var$generateAddress;
/**
 * Generates an address for a contract created using CREATE2.
 * @param from The address which is creating this new address
 * @param salt A salt
 * @param initCode The init code of the contract being created
 */ const $8f73e18c3a81bc91$var$generateAddress2 = function(from, salt, initCode) {
    (0, $8c6iI.assertIsBuffer)(from);
    (0, $8c6iI.assertIsBuffer)(salt);
    (0, $8c6iI.assertIsBuffer)(initCode);
    if (from.length !== 20) throw new Error("Expected from to be of length 20");
    if (salt.length !== 32) throw new Error("Expected salt to be of length 32");
    const address = (0, $8ytum.keccak256)($8f73e18c3a81bc91$require$Buffer.concat([
        $8f73e18c3a81bc91$require$Buffer.from("ff", "hex"),
        from,
        salt,
        (0, $8ytum.keccak256)(initCode)
    ]));
    return (0, $4nduh.toBuffer)(address).slice(-20);
};
module.exports.generateAddress2 = $8f73e18c3a81bc91$var$generateAddress2;
/**
 * Checks if the private key satisfies the rules of the curve secp256k1.
 */ const $8f73e18c3a81bc91$var$isValidPrivate = function(privateKey) {
    return $hOBcC.secp256k1.utils.isValidPrivateKey(privateKey);
};
module.exports.isValidPrivate = $8f73e18c3a81bc91$var$isValidPrivate;
/**
 * Checks if the public key satisfies the rules of the curve secp256k1
 * and the requirements of Ethereum.
 * @param publicKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ const $8f73e18c3a81bc91$var$isValidPublic = function(publicKey, sanitize = false) {
    (0, $8c6iI.assertIsBuffer)(publicKey);
    if (publicKey.length === 64) // Convert to SEC1 for secp256k1
    // Automatically checks whether point is on curve
    try {
        $hOBcC.secp256k1.ProjectivePoint.fromHex($8f73e18c3a81bc91$require$Buffer.concat([
            $8f73e18c3a81bc91$require$Buffer.from([
                4
            ]),
            publicKey
        ]));
        return true;
    } catch (e) {
        return false;
    }
    if (!sanitize) return false;
    try {
        $hOBcC.secp256k1.ProjectivePoint.fromHex(publicKey);
        return true;
    } catch (e) {
        return false;
    }
};
module.exports.isValidPublic = $8f73e18c3a81bc91$var$isValidPublic;
/**
 * Returns the ethereum address of a given public key.
 * Accepts "Ethereum public keys" and SEC1 encoded keys.
 * @param pubKey The two points of an uncompressed key, unless sanitize is enabled
 * @param sanitize Accept public keys in other formats
 */ const $8f73e18c3a81bc91$var$pubToAddress = function(pubKey, sanitize = false) {
    (0, $8c6iI.assertIsBuffer)(pubKey);
    if (sanitize && pubKey.length !== 64) pubKey = $8f73e18c3a81bc91$require$Buffer.from($hOBcC.secp256k1.ProjectivePoint.fromHex(pubKey).toRawBytes(false).slice(1));
    if (pubKey.length !== 64) throw new Error("Expected pubKey to be of length 64");
    // Only take the lower 160bits of the hash
    return $8f73e18c3a81bc91$require$Buffer.from((0, $8ytum.keccak256)(pubKey)).slice(-20);
};
module.exports.pubToAddress = $8f73e18c3a81bc91$var$pubToAddress;
module.exports.publicToAddress = module.exports.pubToAddress;
/**
 * Returns the ethereum public key of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ const $8f73e18c3a81bc91$var$privateToPublic = function(privateKey) {
    (0, $8c6iI.assertIsBuffer)(privateKey);
    // skip the type flag and use the X, Y points
    return $8f73e18c3a81bc91$require$Buffer.from($hOBcC.secp256k1.ProjectivePoint.fromPrivateKey(privateKey).toRawBytes(false).slice(1));
};
module.exports.privateToPublic = $8f73e18c3a81bc91$var$privateToPublic;
/**
 * Returns the ethereum address of a given private key.
 * @param privateKey A private key must be 256 bits wide
 */ const $8f73e18c3a81bc91$var$privateToAddress = function(privateKey) {
    return (0, module.exports.publicToAddress)((0, module.exports.privateToPublic)(privateKey));
};
module.exports.privateToAddress = $8f73e18c3a81bc91$var$privateToAddress;
/**
 * Converts a public key to the Ethereum format.
 */ const $8f73e18c3a81bc91$var$importPublic = function(publicKey) {
    (0, $8c6iI.assertIsBuffer)(publicKey);
    if (publicKey.length !== 64) publicKey = $8f73e18c3a81bc91$require$Buffer.from($hOBcC.secp256k1.ProjectivePoint.fromHex(publicKey).toRawBytes(false).slice(1));
    return publicKey;
};
module.exports.importPublic = $8f73e18c3a81bc91$var$importPublic;
/**
 * Returns the zero address.
 */ const $8f73e18c3a81bc91$var$zeroAddress = function() {
    const addressLength = 20;
    const addr = (0, $4nduh.zeros)(addressLength);
    return (0, $4nduh.bufferToHex)(addr);
};
module.exports.zeroAddress = $8f73e18c3a81bc91$var$zeroAddress;
/**
 * Checks if a given address is the zero address.
 */ const $8f73e18c3a81bc91$var$isZeroAddress = function(hexAddress) {
    try {
        (0, $8c6iI.assertIsString)(hexAddress);
    } catch (e) {
        return false;
    }
    const zeroAddr = (0, module.exports.zeroAddress)();
    return zeroAddr === hexAddress;
};
module.exports.isZeroAddress = $8f73e18c3a81bc91$var$isZeroAddress;
function $8f73e18c3a81bc91$var$accountBodyFromSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, $4nduh.arrToBufArr)(storageRoot).length === 0 ? $3amHV.KECCAK256_RLP : storageRoot,
        (0, $4nduh.arrToBufArr)(codeHash).length === 0 ? $3amHV.KECCAK256_NULL : codeHash
    ];
}
module.exports.accountBodyFromSlim = $8f73e18c3a81bc91$var$accountBodyFromSlim;
const $8f73e18c3a81bc91$var$emptyUint8Arr = new Uint8Array(0);
function $8f73e18c3a81bc91$var$accountBodyToSlim(body) {
    const [nonce, balance, storageRoot, codeHash] = body;
    return [
        nonce,
        balance,
        (0, $4nduh.arrToBufArr)(storageRoot).equals($3amHV.KECCAK256_RLP) ? $8f73e18c3a81bc91$var$emptyUint8Arr : storageRoot,
        (0, $4nduh.arrToBufArr)(codeHash).equals($3amHV.KECCAK256_NULL) ? $8f73e18c3a81bc91$var$emptyUint8Arr : codeHash
    ];
}
module.exports.accountBodyToSlim = $8f73e18c3a81bc91$var$accountBodyToSlim;
/**
 * Converts a slim account (per snap protocol spec) to the RLP encoded version of the account
 * @param body Array of 4 Buffer-like items to represent the account
 * @returns RLP encoded version of the account
 */ function $8f73e18c3a81bc91$var$accountBodyToRLP(body, couldBeSlim = true) {
    const accountBody = couldBeSlim ? $8f73e18c3a81bc91$var$accountBodyFromSlim(body) : body;
    return (0, $4nduh.arrToBufArr)($dHW8i.RLP.encode(accountBody));
}
module.exports.accountBodyToRLP = $8f73e18c3a81bc91$var$accountBodyToRLP;

});
parcelRegister("dHW8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RLP = module.exports.utils = module.exports.decode = module.exports.encode = void 0;
/**
 * RLP Encoding based on https://ethereum.org/en/developers/docs/data-structures-and-encoding/rlp/
 * This function takes in data, converts it to Uint8Array if not,
 * and adds a length for recursion.
 * @param input Will be converted to Uint8Array
 * @returns Uint8Array of encoded data
 **/ function $9fac627fa34a7307$var$encode(input) {
    if (Array.isArray(input)) {
        const output = [];
        let outputLength = 0;
        for(let i = 0; i < input.length; i++){
            const encoded = $9fac627fa34a7307$var$encode(input[i]);
            output.push(encoded);
            outputLength += encoded.length;
        }
        return $9fac627fa34a7307$var$concatBytes($9fac627fa34a7307$var$encodeLength(outputLength, 192), ...output);
    }
    const inputBuf = $9fac627fa34a7307$var$toBytes(input);
    if (inputBuf.length === 1 && inputBuf[0] < 128) return inputBuf;
    return $9fac627fa34a7307$var$concatBytes($9fac627fa34a7307$var$encodeLength(inputBuf.length, 128), inputBuf);
}
module.exports.encode = $9fac627fa34a7307$var$encode;
/**
 * Slices a Uint8Array, throws if the slice goes out-of-bounds of the Uint8Array.
 * E.g. `safeSlice(hexToBytes('aa'), 1, 2)` will throw.
 * @param input
 * @param start
 * @param end
 */ function $9fac627fa34a7307$var$safeSlice(input, start, end) {
    if (end > input.length) throw new Error("invalid RLP (safeSlice): end slice of Uint8Array out-of-bounds");
    return input.slice(start, end);
}
/**
 * Parse integers. Check if there is no leading zeros
 * @param v The value to parse
 */ function $9fac627fa34a7307$var$decodeLength(v) {
    if (v[0] === 0) throw new Error("invalid RLP: extra zeros");
    return $9fac627fa34a7307$var$parseHexByte($9fac627fa34a7307$var$bytesToHex(v));
}
function $9fac627fa34a7307$var$encodeLength(len, offset) {
    if (len < 56) return Uint8Array.from([
        len + offset
    ]);
    const hexLength = $9fac627fa34a7307$var$numberToHex(len);
    const lLength = hexLength.length / 2;
    const firstByte = $9fac627fa34a7307$var$numberToHex(offset + 55 + lLength);
    return Uint8Array.from($9fac627fa34a7307$var$hexToBytes(firstByte + hexLength));
}
function $9fac627fa34a7307$var$decode(input, stream = false) {
    if (typeof input === "undefined" || input === null || input.length === 0) return Uint8Array.from([]);
    const inputBytes = $9fac627fa34a7307$var$toBytes(input);
    const decoded = $9fac627fa34a7307$var$_decode(inputBytes);
    if (stream) return decoded;
    if (decoded.remainder.length !== 0) throw new Error("invalid RLP: remainder must be zero");
    return decoded.data;
}
module.exports.decode = $9fac627fa34a7307$var$decode;
/** Decode an input with RLP */ function $9fac627fa34a7307$var$_decode(input) {
    let length, llength, data, innerRemainder, d;
    const decoded = [];
    const firstByte = input[0];
    if (firstByte <= 0x7f) // a single byte whose value is in the [0x00, 0x7f] range, that byte is its own RLP encoding.
    return {
        data: input.slice(0, 1),
        remainder: input.slice(1)
    };
    else if (firstByte <= 0xb7) {
        // string is 0-55 bytes long. A single byte with value 0x80 plus the length of the string followed by the string
        // The range of the first byte is [0x80, 0xb7]
        length = firstByte - 0x7f;
        // set 0x80 null to 0
        if (firstByte === 0x80) data = Uint8Array.from([]);
        else data = $9fac627fa34a7307$var$safeSlice(input, 1, length);
        if (length === 2 && data[0] < 0x80) throw new Error("invalid RLP encoding: invalid prefix, single byte < 0x80 are not prefixed");
        return {
            data: data,
            remainder: input.slice(length)
        };
    } else if (firstByte <= 0xbf) {
        // string is greater than 55 bytes long. A single byte with the value (0xb7 plus the length of the length),
        // followed by the length, followed by the string
        llength = firstByte - 0xb6;
        if (input.length - 1 < llength) throw new Error("invalid RLP: not enough bytes for string length");
        length = $9fac627fa34a7307$var$decodeLength($9fac627fa34a7307$var$safeSlice(input, 1, llength));
        if (length <= 55) throw new Error("invalid RLP: expected string length to be greater than 55");
        data = $9fac627fa34a7307$var$safeSlice(input, llength, length + llength);
        return {
            data: data,
            remainder: input.slice(length + llength)
        };
    } else if (firstByte <= 0xf7) {
        // a list between 0-55 bytes long
        length = firstByte - 0xbf;
        innerRemainder = $9fac627fa34a7307$var$safeSlice(input, 1, length);
        while(innerRemainder.length){
            d = $9fac627fa34a7307$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(length)
        };
    } else {
        // a list over 55 bytes long
        llength = firstByte - 0xf6;
        length = $9fac627fa34a7307$var$decodeLength($9fac627fa34a7307$var$safeSlice(input, 1, llength));
        if (length < 56) throw new Error("invalid RLP: encoded list too short");
        const totalLength = llength + length;
        if (totalLength > input.length) throw new Error("invalid RLP: total length is larger than the data");
        innerRemainder = $9fac627fa34a7307$var$safeSlice(input, llength, totalLength);
        while(innerRemainder.length){
            d = $9fac627fa34a7307$var$_decode(innerRemainder);
            decoded.push(d.data);
            innerRemainder = d.remainder;
        }
        return {
            data: decoded,
            remainder: input.slice(totalLength)
        };
    }
}
const $9fac627fa34a7307$var$cachedHexes = Array.from({
    length: 256
}, (_v, i)=>i.toString(16).padStart(2, "0"));
function $9fac627fa34a7307$var$bytesToHex(uint8a) {
    // Pre-caching chars with `cachedHexes` speeds this up 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += $9fac627fa34a7307$var$cachedHexes[uint8a[i]];
    return hex;
}
function $9fac627fa34a7307$var$parseHexByte(hexByte) {
    const byte = Number.parseInt(hexByte, 16);
    if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
    return byte;
}
// Caching slows it down 2-3x
function $9fac627fa34a7307$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        array[i] = $9fac627fa34a7307$var$parseHexByte(hex.slice(j, j + 2));
    }
    return array;
}
/** Concatenates two Uint8Arrays into one. */ function $9fac627fa34a7307$var$concatBytes(...arrays) {
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
function $9fac627fa34a7307$var$utf8ToBytes(utf) {
    return new TextEncoder().encode(utf);
}
/** Transform an integer into its hexadecimal value */ function $9fac627fa34a7307$var$numberToHex(integer) {
    if (integer < 0) throw new Error("Invalid integer as argument, must be unsigned!");
    const hex = integer.toString(16);
    return hex.length % 2 ? `0${hex}` : hex;
}
/** Pad a string to be even */ function $9fac627fa34a7307$var$padToEven(a) {
    return a.length % 2 ? `0${a}` : a;
}
/** Check if a string is prefixed by 0x */ function $9fac627fa34a7307$var$isHexPrefixed(str) {
    return str.length >= 2 && str[0] === "0" && str[1] === "x";
}
/** Removes 0x from a given String */ function $9fac627fa34a7307$var$stripHexPrefix(str) {
    if (typeof str !== "string") return str;
    return $9fac627fa34a7307$var$isHexPrefixed(str) ? str.slice(2) : str;
}
/** Transform anything into a Uint8Array */ function $9fac627fa34a7307$var$toBytes(v) {
    if (v instanceof Uint8Array) return v;
    if (typeof v === "string") {
        if ($9fac627fa34a7307$var$isHexPrefixed(v)) return $9fac627fa34a7307$var$hexToBytes($9fac627fa34a7307$var$padToEven($9fac627fa34a7307$var$stripHexPrefix(v)));
        return $9fac627fa34a7307$var$utf8ToBytes(v);
    }
    if (typeof v === "number" || typeof v === "bigint") {
        if (!v) return Uint8Array.from([]);
        return $9fac627fa34a7307$var$hexToBytes($9fac627fa34a7307$var$numberToHex(v));
    }
    if (v === null || v === undefined) return Uint8Array.from([]);
    throw new Error("toBytes: received unsupported type " + typeof v);
}
module.exports.utils = {
    bytesToHex: $9fac627fa34a7307$var$bytesToHex,
    concatBytes: $9fac627fa34a7307$var$concatBytes,
    hexToBytes: $9fac627fa34a7307$var$hexToBytes,
    utf8ToBytes: $9fac627fa34a7307$var$utf8ToBytes
};
module.exports.RLP = {
    encode: $9fac627fa34a7307$var$encode,
    decode: $9fac627fa34a7307$var$decode
};

});

parcelRegister("8ytum", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.keccak512 = module.exports.keccak384 = module.exports.keccak256 = module.exports.keccak224 = void 0;

var $hxX7P = parcelRequire("hxX7P");

var $cNxzl = parcelRequire("cNxzl");
module.exports.keccak224 = (0, $cNxzl.wrapHash)($hxX7P.keccak_224);
module.exports.keccak256 = (()=>{
    const k = (0, $cNxzl.wrapHash)($hxX7P.keccak_256);
    k.create = $hxX7P.keccak_256.create;
    return k;
})();
module.exports.keccak384 = (0, $cNxzl.wrapHash)($hxX7P.keccak_384);
module.exports.keccak512 = (0, $cNxzl.wrapHash)($hxX7P.keccak_512);

});
parcelRegister("hxX7P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $5EDGQ = parcelRequire("5EDGQ");

var $2lF1K = parcelRequire("2lF1K");

var $1jBZ8 = parcelRequire("1jBZ8");
// Various per round constants calculations
const [$cc6361caecf98ed1$var$SHA3_PI, $cc6361caecf98ed1$var$SHA3_ROTL, $cc6361caecf98ed1$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $cc6361caecf98ed1$var$_0n = BigInt(0);
const $cc6361caecf98ed1$var$_1n = BigInt(1);
const $cc6361caecf98ed1$var$_2n = BigInt(2);
const $cc6361caecf98ed1$var$_7n = BigInt(7);
const $cc6361caecf98ed1$var$_256n = BigInt(256);
const $cc6361caecf98ed1$var$_0x71n = BigInt(0x71);
for(let round = 0, R = $cc6361caecf98ed1$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $cc6361caecf98ed1$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $cc6361caecf98ed1$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $cc6361caecf98ed1$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $cc6361caecf98ed1$var$_1n ^ (R >> $cc6361caecf98ed1$var$_7n) * $cc6361caecf98ed1$var$_0x71n) % $cc6361caecf98ed1$var$_256n;
        if (R & $cc6361caecf98ed1$var$_2n) t ^= $cc6361caecf98ed1$var$_1n << ($cc6361caecf98ed1$var$_1n << BigInt(j)) - $cc6361caecf98ed1$var$_1n;
    }
    $cc6361caecf98ed1$var$_SHA3_IOTA.push(t);
}
const [$cc6361caecf98ed1$var$SHA3_IOTA_H, $cc6361caecf98ed1$var$SHA3_IOTA_L] = $2lF1K.default.split($cc6361caecf98ed1$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $cc6361caecf98ed1$var$rotlH = (h, l, s)=>s > 32 ? $2lF1K.default.rotlBH(h, l, s) : $2lF1K.default.rotlSH(h, l, s);
const $cc6361caecf98ed1$var$rotlL = (h, l, s)=>s > 32 ? $2lF1K.default.rotlBL(h, l, s) : $2lF1K.default.rotlSL(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $cc6361caecf98ed1$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $cc6361caecf98ed1$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $cc6361caecf98ed1$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $cc6361caecf98ed1$var$SHA3_ROTL[t];
            const Th = $cc6361caecf98ed1$var$rotlH(curH, curL, shift);
            const Tl = $cc6361caecf98ed1$var$rotlL(curH, curL, shift);
            const PI = $cc6361caecf98ed1$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $cc6361caecf98ed1$var$SHA3_IOTA_H[round];
        s[1] ^= $cc6361caecf98ed1$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $cc6361caecf98ed1$var$keccakP;
class $cc6361caecf98ed1$var$Keccak extends $1jBZ8.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        $5EDGQ.default.number(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $1jBZ8.u32)(this.state);
    }
    keccak() {
        $cc6361caecf98ed1$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        $5EDGQ.default.exists(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $1jBZ8.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        $5EDGQ.default.exists(this, false);
        $5EDGQ.default.bytes(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        $5EDGQ.default.number(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        $5EDGQ.default.output(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $cc6361caecf98ed1$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $cc6361caecf98ed1$var$Keccak;
const $cc6361caecf98ed1$var$gen = (suffix, blockLen, outputLen)=>(0, $1jBZ8.wrapConstructor)(()=>new $cc6361caecf98ed1$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $cc6361caecf98ed1$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $cc6361caecf98ed1$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $cc6361caecf98ed1$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $cc6361caecf98ed1$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $cc6361caecf98ed1$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $cc6361caecf98ed1$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $cc6361caecf98ed1$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $cc6361caecf98ed1$var$gen(0x01, 72, 64);
const $cc6361caecf98ed1$var$genShake = (suffix, blockLen, outputLen)=>(0, $1jBZ8.wrapXOFConstructorWithOpts)((opts = {})=>new $cc6361caecf98ed1$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $cc6361caecf98ed1$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $cc6361caecf98ed1$var$genShake(0x1f, 136, 32);

});
parcelRegister("5EDGQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $41df79d103671901$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $41df79d103671901$var$number;
function $41df79d103671901$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $41df79d103671901$var$bool;
function $41df79d103671901$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $41df79d103671901$var$bytes;
function $41df79d103671901$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $41df79d103671901$var$number(hash.outputLen);
    $41df79d103671901$var$number(hash.blockLen);
}
module.exports.hash = $41df79d103671901$var$hash;
function $41df79d103671901$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $41df79d103671901$var$exists;
function $41df79d103671901$var$output(out, instance) {
    $41df79d103671901$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $41df79d103671901$var$output;
const $41df79d103671901$var$assert = {
    number: $41df79d103671901$var$number,
    bool: $41df79d103671901$var$bool,
    bytes: $41df79d103671901$var$bytes,
    hash: $41df79d103671901$var$hash,
    exists: $41df79d103671901$var$exists,
    output: $41df79d103671901$var$output
};
module.exports.default = $41df79d103671901$var$assert;

});

parcelRegister("2lF1K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $1b5d5e124c3ddc30$var$U32_MASK64 = BigInt(2 ** 32 - 1);
const $1b5d5e124c3ddc30$var$_32n = BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $1b5d5e124c3ddc30$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $1b5d5e124c3ddc30$var$U32_MASK64),
        l: Number(n >> $1b5d5e124c3ddc30$var$_32n & $1b5d5e124c3ddc30$var$U32_MASK64)
    };
    return {
        h: Number(n >> $1b5d5e124c3ddc30$var$_32n & $1b5d5e124c3ddc30$var$U32_MASK64) | 0,
        l: Number(n & $1b5d5e124c3ddc30$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $1b5d5e124c3ddc30$var$fromBig;
function $1b5d5e124c3ddc30$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $1b5d5e124c3ddc30$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $1b5d5e124c3ddc30$var$split;
const $1b5d5e124c3ddc30$var$toBig = (h, l)=>BigInt(h >>> 0) << $1b5d5e124c3ddc30$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $1b5d5e124c3ddc30$var$toBig;
// for Shift in [0, 32)
const $1b5d5e124c3ddc30$var$shrSH = (h, l, s)=>h >>> s;
const $1b5d5e124c3ddc30$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in [1, 32)
const $1b5d5e124c3ddc30$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
const $1b5d5e124c3ddc30$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $1b5d5e124c3ddc30$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
const $1b5d5e124c3ddc30$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
// Right rotate for shift===32 (just swaps l&h)
const $1b5d5e124c3ddc30$var$rotr32H = (h, l)=>l;
const $1b5d5e124c3ddc30$var$rotr32L = (h, l)=>h;
// Left rotate for Shift in [1, 32)
const $1b5d5e124c3ddc30$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
const $1b5d5e124c3ddc30$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $1b5d5e124c3ddc30$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
const $1b5d5e124c3ddc30$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
// Removing "export" has 5% perf penalty -_-
function $1b5d5e124c3ddc30$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $1b5d5e124c3ddc30$var$add;
// Addition with more than 2 elements
const $1b5d5e124c3ddc30$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
const $1b5d5e124c3ddc30$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
const $1b5d5e124c3ddc30$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
const $1b5d5e124c3ddc30$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
const $1b5d5e124c3ddc30$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
const $1b5d5e124c3ddc30$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
// prettier-ignore
const $1b5d5e124c3ddc30$var$u64 = {
    fromBig: $1b5d5e124c3ddc30$var$fromBig,
    split: $1b5d5e124c3ddc30$var$split,
    toBig: module.exports.toBig,
    shrSH: $1b5d5e124c3ddc30$var$shrSH,
    shrSL: $1b5d5e124c3ddc30$var$shrSL,
    rotrSH: $1b5d5e124c3ddc30$var$rotrSH,
    rotrSL: $1b5d5e124c3ddc30$var$rotrSL,
    rotrBH: $1b5d5e124c3ddc30$var$rotrBH,
    rotrBL: $1b5d5e124c3ddc30$var$rotrBL,
    rotr32H: $1b5d5e124c3ddc30$var$rotr32H,
    rotr32L: $1b5d5e124c3ddc30$var$rotr32L,
    rotlSH: $1b5d5e124c3ddc30$var$rotlSH,
    rotlSL: $1b5d5e124c3ddc30$var$rotlSL,
    rotlBH: $1b5d5e124c3ddc30$var$rotlBH,
    rotlBL: $1b5d5e124c3ddc30$var$rotlBL,
    add: $1b5d5e124c3ddc30$var$add,
    add3L: $1b5d5e124c3ddc30$var$add3L,
    add3H: $1b5d5e124c3ddc30$var$add3H,
    add4L: $1b5d5e124c3ddc30$var$add4L,
    add4H: $1b5d5e124c3ddc30$var$add4H,
    add5H: $1b5d5e124c3ddc30$var$add5H,
    add5L: $1b5d5e124c3ddc30$var$add5L
};
module.exports.default = $1b5d5e124c3ddc30$var$u64;

});

parcelRegister("1jBZ8", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $ewlVs = parcelRequire("ewlVs");
const $0f5507d7fd00da48$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $0f5507d7fd00da48$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $0f5507d7fd00da48$var$u8;
const $0f5507d7fd00da48$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $0f5507d7fd00da48$var$u32;
// Cast array to view
const $0f5507d7fd00da48$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $0f5507d7fd00da48$var$createView;
// The rotate right (circular right shift) operation for uint32
const $0f5507d7fd00da48$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $0f5507d7fd00da48$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $0f5507d7fd00da48$var$hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $0f5507d7fd00da48$var$bytesToHex(bytes) {
    if (!$0f5507d7fd00da48$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $0f5507d7fd00da48$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $0f5507d7fd00da48$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $0f5507d7fd00da48$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $0f5507d7fd00da48$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $0f5507d7fd00da48$var$nextTick = async ()=>{};
module.exports.nextTick = $0f5507d7fd00da48$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $0f5507d7fd00da48$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $0f5507d7fd00da48$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $0f5507d7fd00da48$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $0f5507d7fd00da48$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $0f5507d7fd00da48$var$toBytes(data) {
    if (typeof data === "string") data = $0f5507d7fd00da48$var$utf8ToBytes(data);
    if (!$0f5507d7fd00da48$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $0f5507d7fd00da48$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $0f5507d7fd00da48$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$0f5507d7fd00da48$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $0f5507d7fd00da48$var$concatBytes;
// For runtime check if class implements interface
class $0f5507d7fd00da48$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $0f5507d7fd00da48$var$Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
const $0f5507d7fd00da48$var$isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function $0f5507d7fd00da48$var$checkOpts(defaults, opts) {
    if (opts !== undefined && (typeof opts !== "object" || !$0f5507d7fd00da48$var$isPlainObject(opts))) throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $0f5507d7fd00da48$var$checkOpts;
function $0f5507d7fd00da48$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($0f5507d7fd00da48$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $0f5507d7fd00da48$var$wrapConstructor;
function $0f5507d7fd00da48$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($0f5507d7fd00da48$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $0f5507d7fd00da48$var$wrapConstructorWithOpts;
function $0f5507d7fd00da48$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($0f5507d7fd00da48$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $0f5507d7fd00da48$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $0f5507d7fd00da48$var$randomBytes(bytesLength = 32) {
    if ($ewlVs.crypto && typeof $ewlVs.crypto.getRandomValues === "function") return $ewlVs.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $0f5507d7fd00da48$var$randomBytes;

});
parcelRegister("ewlVs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("cNxzl", function(module, exports) {
"use strict";
var __importDefault = this && this.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.crypto = exports.wrapHash = exports.equalsBytes = exports.hexToBytes = exports.bytesToUtf8 = exports.utf8ToBytes = exports.createView = exports.concatBytes = exports.toHex = exports.bytesToHex = exports.assertBytes = exports.assertBool = void 0;

const _assert_1 = __importDefault((parcelRequire("5EDGQ")));

var $1jBZ8 = parcelRequire("1jBZ8");
const assertBool = _assert_1.default.bool;
exports.assertBool = assertBool;
const assertBytes = _assert_1.default.bytes;
exports.assertBytes = assertBytes;

var $1jBZ8 = parcelRequire("1jBZ8");
Object.defineProperty(exports, "bytesToHex", {
    enumerable: true,
    get: function() {
        return $1jBZ8.bytesToHex;
    }
});
Object.defineProperty(exports, "toHex", {
    enumerable: true,
    get: function() {
        return $1jBZ8.bytesToHex;
    }
});
Object.defineProperty(exports, "concatBytes", {
    enumerable: true,
    get: function() {
        return $1jBZ8.concatBytes;
    }
});
Object.defineProperty(exports, "createView", {
    enumerable: true,
    get: function() {
        return $1jBZ8.createView;
    }
});
Object.defineProperty(exports, "utf8ToBytes", {
    enumerable: true,
    get: function() {
        return $1jBZ8.utf8ToBytes;
    }
});
// buf.toString('utf8') -> bytesToUtf8(buf)
function bytesToUtf8(data) {
    if (!(data instanceof Uint8Array)) throw new TypeError(`bytesToUtf8 expected Uint8Array, got ${typeof data}`);
    return new TextDecoder().decode(data);
}
exports.bytesToUtf8 = bytesToUtf8;
function hexToBytes(data) {
    const sliced = data.startsWith("0x") ? data.substring(2) : data;
    return (0, $1jBZ8.hexToBytes)(sliced);
}
exports.hexToBytes = hexToBytes;
// buf.equals(buf2) -> equalsBytes(buf, buf2)
function equalsBytes(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
exports.equalsBytes = equalsBytes;
// Internal utils
function wrapHash(hash) {
    return (msg)=>{
        _assert_1.default.bytes(msg);
        return hash(msg);
    };
}
exports.wrapHash = wrapHash;
// TODO(v3): switch away from node crypto, remove this unnecessary variable.
exports.crypto = (()=>{
    const webCrypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    return {
        node: nodeRequire && !webCrypto ? nodeRequire("crypto") : undefined,
        web: webCrypto
    };
})();

});


parcelRegister("4nduh", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $32f3c5bc996dde79$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.intToUnpaddedBuffer = module.exports.bigIntToUnpaddedBuffer = module.exports.bigIntToHex = module.exports.bufArrToArr = module.exports.arrToBufArr = module.exports.validateNoLeadingZeroes = module.exports.baToJSON = module.exports.toUtf8 = module.exports.short = module.exports.addHexPrefix = module.exports.toUnsigned = module.exports.fromSigned = module.exports.bufferToInt = module.exports.bigIntToBuffer = module.exports.bufferToBigInt = module.exports.bufferToHex = module.exports.toBuffer = module.exports.unpadHexString = module.exports.unpadArray = module.exports.unpadBuffer = module.exports.setLengthRight = module.exports.setLengthLeft = module.exports.zeros = module.exports.intToBuffer = module.exports.intToHex = void 0;

var $8c6iI = parcelRequire("8c6iI");

var $6oTn3 = parcelRequire("6oTn3");
/**
 * Converts a `Number` into a hex `String`
 * @param {Number} i
 * @return {String}
 */ const $32f3c5bc996dde79$var$intToHex = function(i) {
    if (!Number.isSafeInteger(i) || i < 0) throw new Error(`Received an invalid integer type: ${i}`);
    return `0x${i.toString(16)}`;
};
module.exports.intToHex = $32f3c5bc996dde79$var$intToHex;
/**
 * Converts an `Number` to a `Buffer`
 * @param {Number} i
 * @return {Buffer}
 */ const $32f3c5bc996dde79$var$intToBuffer = function(i) {
    const hex = (0, module.exports.intToHex)(i);
    return $32f3c5bc996dde79$require$Buffer.from((0, $6oTn3.padToEven)(hex.slice(2)), "hex");
};
module.exports.intToBuffer = $32f3c5bc996dde79$var$intToBuffer;
/**
 * Returns a buffer filled with 0s.
 * @param bytes the number of bytes the buffer should be
 */ const $32f3c5bc996dde79$var$zeros = function(bytes) {
    return $32f3c5bc996dde79$require$Buffer.allocUnsafe(bytes).fill(0);
};
module.exports.zeros = $32f3c5bc996dde79$var$zeros;
/**
 * Pads a `Buffer` with zeros till it has `length` bytes.
 * Truncates the beginning or end of input if its length exceeds `length`.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @param right whether to start padding form the left or right
 * @return (Buffer)
 */ const $32f3c5bc996dde79$var$setLength = function(msg, length, right) {
    const buf = (0, module.exports.zeros)(length);
    if (right) {
        if (msg.length < length) {
            msg.copy(buf);
            return buf;
        }
        return msg.slice(0, length);
    } else {
        if (msg.length < length) {
            msg.copy(buf, length - msg.length);
            return buf;
        }
        return msg.slice(-length);
    }
};
/**
 * Left Pads a `Buffer` with leading zeros till it has `length` bytes.
 * Or it truncates the beginning if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ const $32f3c5bc996dde79$var$setLengthLeft = function(msg, length) {
    (0, $8c6iI.assertIsBuffer)(msg);
    return $32f3c5bc996dde79$var$setLength(msg, length, false);
};
module.exports.setLengthLeft = $32f3c5bc996dde79$var$setLengthLeft;
/**
 * Right Pads a `Buffer` with trailing zeros till it has `length` bytes.
 * it truncates the end if it exceeds.
 * @param msg the value to pad (Buffer)
 * @param length the number of bytes the output should be
 * @return (Buffer)
 */ const $32f3c5bc996dde79$var$setLengthRight = function(msg, length) {
    (0, $8c6iI.assertIsBuffer)(msg);
    return $32f3c5bc996dde79$var$setLength(msg, length, true);
};
module.exports.setLengthRight = $32f3c5bc996dde79$var$setLengthRight;
/**
 * Trims leading zeros from a `Buffer`, `String` or `Number[]`.
 * @param a (Buffer|Array|String)
 * @return (Buffer|Array|String)
 */ const $32f3c5bc996dde79$var$stripZeros = function(a) {
    let first = a[0];
    while(a.length > 0 && first.toString() === "0"){
        a = a.slice(1);
        first = a[0];
    }
    return a;
};
/**
 * Trims leading zeros from a `Buffer`.
 * @param a (Buffer)
 * @return (Buffer)
 */ const $32f3c5bc996dde79$var$unpadBuffer = function(a) {
    (0, $8c6iI.assertIsBuffer)(a);
    return $32f3c5bc996dde79$var$stripZeros(a);
};
module.exports.unpadBuffer = $32f3c5bc996dde79$var$unpadBuffer;
/**
 * Trims leading zeros from an `Array` (of numbers).
 * @param a (number[])
 * @return (number[])
 */ const $32f3c5bc996dde79$var$unpadArray = function(a) {
    (0, $8c6iI.assertIsArray)(a);
    return $32f3c5bc996dde79$var$stripZeros(a);
};
module.exports.unpadArray = $32f3c5bc996dde79$var$unpadArray;
/**
 * Trims leading zeros from a hex-prefixed `String`.
 * @param a (String)
 * @return (String)
 */ const $32f3c5bc996dde79$var$unpadHexString = function(a) {
    (0, $8c6iI.assertIsHexString)(a);
    a = (0, $6oTn3.stripHexPrefix)(a);
    return "0x" + $32f3c5bc996dde79$var$stripZeros(a);
};
module.exports.unpadHexString = $32f3c5bc996dde79$var$unpadHexString;
/**
 * Attempts to turn a value into a `Buffer`.
 * Inputs supported: `Buffer`, `String` (hex-prefixed), `Number`, null/undefined, `BigInt` and other objects
 * with a `toArray()` or `toBuffer()` method.
 * @param v the value
 */ const $32f3c5bc996dde79$var$toBuffer = function(v) {
    if (v === null || v === undefined) return $32f3c5bc996dde79$require$Buffer.allocUnsafe(0);
    if ($32f3c5bc996dde79$require$Buffer.isBuffer(v)) return $32f3c5bc996dde79$require$Buffer.from(v);
    if (Array.isArray(v) || v instanceof Uint8Array) return $32f3c5bc996dde79$require$Buffer.from(v);
    if (typeof v === "string") {
        if (!(0, $6oTn3.isHexString)(v)) throw new Error(`Cannot convert string to buffer. toBuffer only supports 0x-prefixed hex strings and this string was given: ${v}`);
        return $32f3c5bc996dde79$require$Buffer.from((0, $6oTn3.padToEven)((0, $6oTn3.stripHexPrefix)(v)), "hex");
    }
    if (typeof v === "number") return (0, module.exports.intToBuffer)(v);
    if (typeof v === "bigint") {
        if (v < BigInt(0)) throw new Error(`Cannot convert negative bigint to buffer. Given: ${v}`);
        let n = v.toString(16);
        if (n.length % 2) n = "0" + n;
        return $32f3c5bc996dde79$require$Buffer.from(n, "hex");
    }
    if (v.toArray) // converts a BN to a Buffer
    return $32f3c5bc996dde79$require$Buffer.from(v.toArray());
    if (v.toBuffer) return $32f3c5bc996dde79$require$Buffer.from(v.toBuffer());
    throw new Error("invalid type");
};
module.exports.toBuffer = $32f3c5bc996dde79$var$toBuffer;
/**
 * Converts a `Buffer` into a `0x`-prefixed hex `String`.
 * @param buf `Buffer` object to convert
 */ const $32f3c5bc996dde79$var$bufferToHex = function(buf) {
    buf = (0, module.exports.toBuffer)(buf);
    return "0x" + buf.toString("hex");
};
module.exports.bufferToHex = $32f3c5bc996dde79$var$bufferToHex;
/**
 * Converts a {@link Buffer} to a {@link bigint}
 */ function $32f3c5bc996dde79$var$bufferToBigInt(buf) {
    const hex = (0, module.exports.bufferToHex)(buf);
    if (hex === "0x") return BigInt(0);
    return BigInt(hex);
}
module.exports.bufferToBigInt = $32f3c5bc996dde79$var$bufferToBigInt;
/**
 * Converts a {@link bigint} to a {@link Buffer}
 */ function $32f3c5bc996dde79$var$bigIntToBuffer(num) {
    return (0, module.exports.toBuffer)("0x" + num.toString(16));
}
module.exports.bigIntToBuffer = $32f3c5bc996dde79$var$bigIntToBuffer;
/**
 * Converts a `Buffer` to a `Number`.
 * @param buf `Buffer` object to convert
 * @throws If the input number exceeds 53 bits.
 */ const $32f3c5bc996dde79$var$bufferToInt = function(buf) {
    const res = Number($32f3c5bc996dde79$var$bufferToBigInt(buf));
    if (!Number.isSafeInteger(res)) throw new Error("Number exceeds 53 bits");
    return res;
};
module.exports.bufferToInt = $32f3c5bc996dde79$var$bufferToInt;
/**
 * Interprets a `Buffer` as a signed integer and returns a `BigInt`. Assumes 256-bit numbers.
 * @param num Signed integer value
 */ const $32f3c5bc996dde79$var$fromSigned = function(num) {
    return BigInt.asIntN(256, $32f3c5bc996dde79$var$bufferToBigInt(num));
};
module.exports.fromSigned = $32f3c5bc996dde79$var$fromSigned;
/**
 * Converts a `BigInt` to an unsigned integer and returns it as a `Buffer`. Assumes 256-bit numbers.
 * @param num
 */ const $32f3c5bc996dde79$var$toUnsigned = function(num) {
    return $32f3c5bc996dde79$var$bigIntToBuffer(BigInt.asUintN(256, num));
};
module.exports.toUnsigned = $32f3c5bc996dde79$var$toUnsigned;
/**
 * Adds "0x" to a given `String` if it does not already start with "0x".
 */ const $32f3c5bc996dde79$var$addHexPrefix = function(str) {
    if (typeof str !== "string") return str;
    return (0, $6oTn3.isHexPrefixed)(str) ? str : "0x" + str;
};
module.exports.addHexPrefix = $32f3c5bc996dde79$var$addHexPrefix;
/**
 * Shortens a string  or buffer's hex string representation to maxLength (default 50).
 *
 * Examples:
 *
 * Input:  '657468657265756d000000000000000000000000000000000000000000000000'
 * Output: '657468657265756d0000000000000000000000000000000000…'
 */ function $32f3c5bc996dde79$var$short(buffer, maxLength = 50) {
    const bufferStr = $32f3c5bc996dde79$require$Buffer.isBuffer(buffer) ? buffer.toString("hex") : buffer;
    if (bufferStr.length <= maxLength) return bufferStr;
    return bufferStr.slice(0, maxLength) + "\u2026";
}
module.exports.short = $32f3c5bc996dde79$var$short;
/**
 * Returns the utf8 string representation from a hex string.
 *
 * Examples:
 *
 * Input 1: '657468657265756d000000000000000000000000000000000000000000000000'
 * Input 2: '657468657265756d'
 * Input 3: '000000000000000000000000000000000000000000000000657468657265756d'
 *
 * Output (all 3 input variants): 'ethereum'
 *
 * Note that this method is not intended to be used with hex strings
 * representing quantities in both big endian or little endian notation.
 *
 * @param string Hex string, should be `0x` prefixed
 * @return Utf8 string
 */ const $32f3c5bc996dde79$var$toUtf8 = function(hex) {
    const zerosRegexp = /^(00)+|(00)+$/g;
    hex = (0, $6oTn3.stripHexPrefix)(hex);
    if (hex.length % 2 !== 0) throw new Error("Invalid non-even hex string input for toUtf8() provided");
    const bufferVal = $32f3c5bc996dde79$require$Buffer.from(hex.replace(zerosRegexp, ""), "hex");
    return bufferVal.toString("utf8");
};
module.exports.toUtf8 = $32f3c5bc996dde79$var$toUtf8;
/**
 * Converts a `Buffer` or `Array` to JSON.
 * @param ba (Buffer|Array)
 * @return (Array|String|null)
 */ const $32f3c5bc996dde79$var$baToJSON = function(ba) {
    if ($32f3c5bc996dde79$require$Buffer.isBuffer(ba)) return `0x${ba.toString("hex")}`;
    else if (ba instanceof Array) {
        const array = [];
        for(let i = 0; i < ba.length; i++)array.push((0, module.exports.baToJSON)(ba[i]));
        return array;
    }
};
module.exports.baToJSON = $32f3c5bc996dde79$var$baToJSON;
/**
 * Checks provided Buffers for leading zeroes and throws if found.
 *
 * Examples:
 *
 * Valid values: 0x1, 0x, 0x01, 0x1234
 * Invalid values: 0x0, 0x00, 0x001, 0x0001
 *
 * Note: This method is useful for validating that RLP encoded integers comply with the rule that all
 * integer values encoded to RLP must be in the most compact form and contain no leading zero bytes
 * @param values An object containing string keys and Buffer values
 * @throws if any provided value is found to have leading zero bytes
 */ const $32f3c5bc996dde79$var$validateNoLeadingZeroes = function(values) {
    for (const [k, v] of Object.entries(values)){
        if (v !== undefined && v.length > 0 && v[0] === 0) throw new Error(`${k} cannot have leading zeroes, received: ${v.toString("hex")}`);
    }
};
module.exports.validateNoLeadingZeroes = $32f3c5bc996dde79$var$validateNoLeadingZeroes;
function $32f3c5bc996dde79$var$arrToBufArr(arr) {
    if (!Array.isArray(arr)) return $32f3c5bc996dde79$require$Buffer.from(arr);
    return arr.map((a)=>$32f3c5bc996dde79$var$arrToBufArr(a));
}
module.exports.arrToBufArr = $32f3c5bc996dde79$var$arrToBufArr;
function $32f3c5bc996dde79$var$bufArrToArr(arr) {
    if (!Array.isArray(arr)) return Uint8Array.from(arr ?? []);
    return arr.map((a)=>$32f3c5bc996dde79$var$bufArrToArr(a));
}
module.exports.bufArrToArr = $32f3c5bc996dde79$var$bufArrToArr;
/**
 * Converts a {@link bigint} to a `0x` prefixed hex string
 */ const $32f3c5bc996dde79$var$bigIntToHex = (num)=>{
    return "0x" + num.toString(16);
};
module.exports.bigIntToHex = $32f3c5bc996dde79$var$bigIntToHex;
/**
 * Convert value from bigint to an unpadded Buffer
 * (useful for RLP transport)
 * @param value value to convert
 */ function $32f3c5bc996dde79$var$bigIntToUnpaddedBuffer(value) {
    return (0, module.exports.unpadBuffer)($32f3c5bc996dde79$var$bigIntToBuffer(value));
}
module.exports.bigIntToUnpaddedBuffer = $32f3c5bc996dde79$var$bigIntToUnpaddedBuffer;
function $32f3c5bc996dde79$var$intToUnpaddedBuffer(value) {
    return (0, module.exports.unpadBuffer)((0, module.exports.intToBuffer)(value));
}
module.exports.intToUnpaddedBuffer = $32f3c5bc996dde79$var$intToUnpaddedBuffer;

});
parcelRegister("8c6iI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $5f7454f51cc63c8d$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assertIsString = module.exports.assertIsArray = module.exports.assertIsBuffer = module.exports.assertIsHexString = void 0;

var $6oTn3 = parcelRequire("6oTn3");
/**
 * Throws if a string is not hex prefixed
 * @param {string} input string to check hex prefix of
 */ const $5f7454f51cc63c8d$var$assertIsHexString = function(input) {
    if (!(0, $6oTn3.isHexString)(input)) {
        const msg = `This method only supports 0x-prefixed hex strings but input was: ${input}`;
        throw new Error(msg);
    }
};
module.exports.assertIsHexString = $5f7454f51cc63c8d$var$assertIsHexString;
/**
 * Throws if input is not a buffer
 * @param {Buffer} input value to check
 */ const $5f7454f51cc63c8d$var$assertIsBuffer = function(input) {
    if (!$5f7454f51cc63c8d$require$Buffer.isBuffer(input)) {
        const msg = `This method only supports Buffer but input was: ${input}`;
        throw new Error(msg);
    }
};
module.exports.assertIsBuffer = $5f7454f51cc63c8d$var$assertIsBuffer;
/**
 * Throws if input is not an array
 * @param {number[]} input value to check
 */ const $5f7454f51cc63c8d$var$assertIsArray = function(input) {
    if (!Array.isArray(input)) {
        const msg = `This method only supports number arrays but input was: ${input}`;
        throw new Error(msg);
    }
};
module.exports.assertIsArray = $5f7454f51cc63c8d$var$assertIsArray;
/**
 * Throws if input is not a string
 * @param {string} input value to check
 */ const $5f7454f51cc63c8d$var$assertIsString = function(input) {
    if (typeof input !== "string") {
        const msg = `This method only supports strings but input was: ${input}`;
        throw new Error(msg);
    }
};
module.exports.assertIsString = $5f7454f51cc63c8d$var$assertIsString;

});
parcelRegister("6oTn3", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4a8fef7a50c1fe63$require$Buffer = $ihoyg.Buffer;
"use strict";
/*
The MIT License

Copyright (c) 2016 Nick Dodson. nickdodson.com

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isHexString = module.exports.getKeys = module.exports.fromAscii = module.exports.fromUtf8 = module.exports.toAscii = module.exports.arrayContainsArray = module.exports.getBinarySize = module.exports.padToEven = module.exports.stripHexPrefix = module.exports.isHexPrefixed = void 0;
/**
 * Returns a `Boolean` on whether or not the a `String` starts with '0x'
 * @param str the string input value
 * @return a boolean if it is or is not hex prefixed
 * @throws if the str input is not a string
 */ function $4a8fef7a50c1fe63$var$isHexPrefixed(str) {
    if (typeof str !== "string") throw new Error(`[isHexPrefixed] input must be type 'string', received type ${typeof str}`);
    return str[0] === "0" && str[1] === "x";
}
module.exports.isHexPrefixed = $4a8fef7a50c1fe63$var$isHexPrefixed;
/**
 * Removes '0x' from a given `String` if present
 * @param str the string value
 * @returns the string without 0x prefix
 */ const $4a8fef7a50c1fe63$var$stripHexPrefix = (str)=>{
    if (typeof str !== "string") throw new Error(`[stripHexPrefix] input must be type 'string', received ${typeof str}`);
    return $4a8fef7a50c1fe63$var$isHexPrefixed(str) ? str.slice(2) : str;
};
module.exports.stripHexPrefix = $4a8fef7a50c1fe63$var$stripHexPrefix;
/**
 * Pads a `String` to have an even length
 * @param value
 * @return output
 */ function $4a8fef7a50c1fe63$var$padToEven(value) {
    let a = value;
    if (typeof a !== "string") throw new Error(`[padToEven] value must be type 'string', received ${typeof a}`);
    if (a.length % 2) a = `0${a}`;
    return a;
}
module.exports.padToEven = $4a8fef7a50c1fe63$var$padToEven;
/**
 * Get the binary size of a string
 * @param str
 * @returns the number of bytes contained within the string
 */ function $4a8fef7a50c1fe63$var$getBinarySize(str) {
    if (typeof str !== "string") throw new Error(`[getBinarySize] method requires input type 'string', received ${typeof str}`);
    return $4a8fef7a50c1fe63$require$Buffer.byteLength(str, "utf8");
}
module.exports.getBinarySize = $4a8fef7a50c1fe63$var$getBinarySize;
/**
 * Returns TRUE if the first specified array contains all elements
 * from the second one. FALSE otherwise.
 *
 * @param superset
 * @param subset
 *
 */ function $4a8fef7a50c1fe63$var$arrayContainsArray(superset, subset, some) {
    if (Array.isArray(superset) !== true) throw new Error(`[arrayContainsArray] method requires input 'superset' to be an array, got type '${typeof superset}'`);
    if (Array.isArray(subset) !== true) throw new Error(`[arrayContainsArray] method requires input 'subset' to be an array, got type '${typeof subset}'`);
    return subset[some === true ? "some" : "every"]((value)=>superset.indexOf(value) >= 0);
}
module.exports.arrayContainsArray = $4a8fef7a50c1fe63$var$arrayContainsArray;
/**
 * Should be called to get ascii from its hex representation
 *
 * @param string in hex
 * @returns ascii string representation of hex value
 */ function $4a8fef7a50c1fe63$var$toAscii(hex) {
    let str = "";
    let i = 0;
    const l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        const code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
}
module.exports.toAscii = $4a8fef7a50c1fe63$var$toAscii;
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @param string
 * @param optional padding
 * @returns hex representation of input string
 */ function $4a8fef7a50c1fe63$var$fromUtf8(stringValue) {
    const str = $4a8fef7a50c1fe63$require$Buffer.from(stringValue, "utf8");
    return `0x${$4a8fef7a50c1fe63$var$padToEven(str.toString("hex")).replace(/^0+|0+$/g, "")}`;
}
module.exports.fromUtf8 = $4a8fef7a50c1fe63$var$fromUtf8;
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @param  string
 * @param  optional padding
 * @returns  hex representation of input string
 */ function $4a8fef7a50c1fe63$var$fromAscii(stringValue) {
    let hex = "";
    for(let i = 0; i < stringValue.length; i++){
        const code = stringValue.charCodeAt(i);
        const n = code.toString(16);
        hex += n.length < 2 ? `0${n}` : n;
    }
    return `0x${hex}`;
}
module.exports.fromAscii = $4a8fef7a50c1fe63$var$fromAscii;
/**
 * Returns the keys from an array of objects.
 * @example
 * ```js
 * getKeys([{a: '1', b: '2'}, {a: '3', b: '4'}], 'a') => ['1', '3']
 *````
 * @param  params
 * @param  key
 * @param  allowEmpty
 * @returns output just a simple array of output keys
 */ function $4a8fef7a50c1fe63$var$getKeys(params, key, allowEmpty) {
    if (!Array.isArray(params)) throw new Error(`[getKeys] method expects input 'params' to be an array, got ${typeof params}`);
    if (typeof key !== "string") throw new Error(`[getKeys] method expects input 'key' to be type 'string', got ${typeof params}`);
    const result = [];
    for(let i = 0; i < params.length; i++){
        let value = params[i][key];
        if (allowEmpty === true && !value) value = "";
        else if (typeof value !== "string") throw new Error(`invalid abi - expected type 'string', received ${typeof value}`);
        result.push(value);
    }
    return result;
}
module.exports.getKeys = $4a8fef7a50c1fe63$var$getKeys;
/**
 * Is the string a hex string.
 *
 * @param  value
 * @param  length
 * @returns  output the string is a hex string
 */ function $4a8fef7a50c1fe63$var$isHexString(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (typeof length !== "undefined" && length > 0 && value.length !== 2 + 2 * length) return false;
    return true;
}
module.exports.isHexString = $4a8fef7a50c1fe63$var$isHexString;

});




parcelRegister("kMKXc", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f21cb666262712b4$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address = void 0;

var $cjATJ = parcelRequire("cjATJ");

var $4nduh = parcelRequire("4nduh");
/**
 * Handling and generating Ethereum addresses
 */ class $f21cb666262712b4$var$Address {
    constructor(buf){
        if (buf.length !== 20) throw new Error("Invalid address length");
        this.buf = buf;
    }
    /**
     * Returns the zero address.
     */ static zero() {
        return new $f21cb666262712b4$var$Address((0, $4nduh.zeros)(20));
    }
    /**
     * Returns an Address object from a hex-encoded string.
     * @param str - Hex-encoded address
     */ static fromString(str) {
        if (!(0, $cjATJ.isValidAddress)(str)) throw new Error("Invalid address");
        return new $f21cb666262712b4$var$Address((0, $4nduh.toBuffer)(str));
    }
    /**
     * Returns an address for a given public key.
     * @param pubKey The two points of an uncompressed key
     */ static fromPublicKey(pubKey) {
        if (!$f21cb666262712b4$require$Buffer.isBuffer(pubKey)) throw new Error("Public key should be Buffer");
        const buf = (0, $cjATJ.pubToAddress)(pubKey);
        return new $f21cb666262712b4$var$Address(buf);
    }
    /**
     * Returns an address for a given private key.
     * @param privateKey A private key must be 256 bits wide
     */ static fromPrivateKey(privateKey) {
        if (!$f21cb666262712b4$require$Buffer.isBuffer(privateKey)) throw new Error("Private key should be Buffer");
        const buf = (0, $cjATJ.privateToAddress)(privateKey);
        return new $f21cb666262712b4$var$Address(buf);
    }
    /**
     * Generates an address for a newly created contract.
     * @param from The address which is creating this new address
     * @param nonce The nonce of the from account
     */ static generate(from, nonce) {
        if (typeof nonce !== "bigint") throw new Error("Expected nonce to be a bigint");
        return new $f21cb666262712b4$var$Address((0, $cjATJ.generateAddress)(from.buf, (0, $4nduh.bigIntToBuffer)(nonce)));
    }
    /**
     * Generates an address for a contract created using CREATE2.
     * @param from The address which is creating this new address
     * @param salt A salt
     * @param initCode The init code of the contract being created
     */ static generate2(from, salt, initCode) {
        if (!$f21cb666262712b4$require$Buffer.isBuffer(salt)) throw new Error("Expected salt to be a Buffer");
        if (!$f21cb666262712b4$require$Buffer.isBuffer(initCode)) throw new Error("Expected initCode to be a Buffer");
        return new $f21cb666262712b4$var$Address((0, $cjATJ.generateAddress2)(from.buf, salt, initCode));
    }
    /**
     * Is address equal to another.
     */ equals(address) {
        return this.buf.equals(address.buf);
    }
    /**
     * Is address zero.
     */ isZero() {
        return this.equals($f21cb666262712b4$var$Address.zero());
    }
    /**
     * True if address is in the address range defined
     * by EIP-1352
     */ isPrecompileOrSystemAddress() {
        const address = (0, $4nduh.bufferToBigInt)(this.buf);
        const rangeMin = BigInt(0);
        const rangeMax = BigInt("0xffff");
        return address >= rangeMin && address <= rangeMax;
    }
    /**
     * Returns hex encoding of address.
     */ toString() {
        return "0x" + this.buf.toString("hex");
    }
    /**
     * Returns Buffer representation of address.
     */ toBuffer() {
        return $f21cb666262712b4$require$Buffer.from(this.buf);
    }
}
module.exports.Address = $f21cb666262712b4$var$Address;

});

parcelRegister("i8Xv8", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $d35721093a2dd44a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Withdrawal = void 0;

var $kMKXc = parcelRequire("kMKXc");

var $4nduh = parcelRequire("4nduh");

var $h6mqJ = parcelRequire("h6mqJ");
/**
 * Representation of EIP-4895 withdrawal data
 */ class $d35721093a2dd44a$var$Withdrawal {
    /**
     * This constructor assigns and validates the values.
     * Use the static factory methods to assist in creating a Withdrawal object from varying data types.
     * Its amount is in Gwei to match CL representation and for eventual ssz withdrawalsRoot
     */ constructor(index, validatorIndex, address, /**
     * withdrawal amount in Gwei to match the CL repesentation and eventually ssz withdrawalsRoot
     */ amount){
        this.index = index;
        this.validatorIndex = validatorIndex;
        this.address = address;
        this.amount = amount;
    }
    static fromWithdrawalData(withdrawalData) {
        const { index: indexData, validatorIndex: validatorIndexData, address: addressData, amount: amountData } = withdrawalData;
        const index = (0, $h6mqJ.toType)(indexData, $h6mqJ.TypeOutput.BigInt);
        const validatorIndex = (0, $h6mqJ.toType)(validatorIndexData, $h6mqJ.TypeOutput.BigInt);
        const address = new $kMKXc.Address((0, $h6mqJ.toType)(addressData, $h6mqJ.TypeOutput.Buffer));
        const amount = (0, $h6mqJ.toType)(amountData, $h6mqJ.TypeOutput.BigInt);
        return new $d35721093a2dd44a$var$Withdrawal(index, validatorIndex, address, amount);
    }
    static fromValuesArray(withdrawalArray) {
        if (withdrawalArray.length !== 4) throw Error(`Invalid withdrawalArray length expected=4 actual=${withdrawalArray.length}`);
        const [index, validatorIndex, address, amount] = withdrawalArray;
        return $d35721093a2dd44a$var$Withdrawal.fromWithdrawalData({
            index: index,
            validatorIndex: validatorIndex,
            address: address,
            amount: amount
        });
    }
    /**
     * Convert a withdrawal to a buffer array
     * @param withdrawal the withdrawal to convert
     * @returns buffer array of the withdrawal
     */ static toBufferArray(withdrawal) {
        const { index: index, validatorIndex: validatorIndex, address: address, amount: amount } = withdrawal;
        const indexBuffer = (0, $h6mqJ.toType)(index, $h6mqJ.TypeOutput.BigInt) === BigInt(0) ? $d35721093a2dd44a$require$Buffer.alloc(0) : (0, $h6mqJ.toType)(index, $h6mqJ.TypeOutput.Buffer);
        const validatorIndexBuffer = (0, $h6mqJ.toType)(validatorIndex, $h6mqJ.TypeOutput.BigInt) === BigInt(0) ? $d35721093a2dd44a$require$Buffer.alloc(0) : (0, $h6mqJ.toType)(validatorIndex, $h6mqJ.TypeOutput.Buffer);
        let addressBuffer;
        if (address instanceof $kMKXc.Address) addressBuffer = address.buf;
        else addressBuffer = (0, $h6mqJ.toType)(address, $h6mqJ.TypeOutput.Buffer);
        const amountBuffer = (0, $h6mqJ.toType)(amount, $h6mqJ.TypeOutput.BigInt) === BigInt(0) ? $d35721093a2dd44a$require$Buffer.alloc(0) : (0, $h6mqJ.toType)(amount, $h6mqJ.TypeOutput.Buffer);
        return [
            indexBuffer,
            validatorIndexBuffer,
            addressBuffer,
            amountBuffer
        ];
    }
    raw() {
        return $d35721093a2dd44a$var$Withdrawal.toBufferArray(this);
    }
    toValue() {
        return {
            index: this.index,
            validatorIndex: this.validatorIndex,
            address: this.address.buf,
            amount: this.amount
        };
    }
    toJSON() {
        return {
            index: (0, $4nduh.bigIntToHex)(this.index),
            validatorIndex: (0, $4nduh.bigIntToHex)(this.validatorIndex),
            address: "0x" + this.address.buf.toString("hex"),
            amount: (0, $4nduh.bigIntToHex)(this.amount)
        };
    }
}
module.exports.Withdrawal = $d35721093a2dd44a$var$Withdrawal;

});
parcelRegister("h6mqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toType = module.exports.TypeOutput = void 0;

var $4nduh = parcelRequire("4nduh");

var $6oTn3 = parcelRequire("6oTn3");
/**
 * Type output options
 */ var $c73465646a90c04a$var$TypeOutput;
(function(TypeOutput) {
    TypeOutput[TypeOutput["Number"] = 0] = "Number";
    TypeOutput[TypeOutput["BigInt"] = 1] = "BigInt";
    TypeOutput[TypeOutput["Buffer"] = 2] = "Buffer";
    TypeOutput[TypeOutput["PrefixedHexString"] = 3] = "PrefixedHexString";
})($c73465646a90c04a$var$TypeOutput = module.exports.TypeOutput || (module.exports.TypeOutput = {}));
function $c73465646a90c04a$var$toType(input, outputType) {
    if (input === null) return null;
    if (input === undefined) return undefined;
    if (typeof input === "string" && !(0, $6oTn3.isHexString)(input)) throw new Error(`A string must be provided with a 0x-prefix, given: ${input}`);
    else if (typeof input === "number" && !Number.isSafeInteger(input)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative input type)");
    const output = (0, $4nduh.toBuffer)(input);
    switch(outputType){
        case $c73465646a90c04a$var$TypeOutput.Buffer:
            return output;
        case $c73465646a90c04a$var$TypeOutput.BigInt:
            return (0, $4nduh.bufferToBigInt)(output);
        case $c73465646a90c04a$var$TypeOutput.Number:
            {
                const bigInt = (0, $4nduh.bufferToBigInt)(output);
                if (bigInt > BigInt(Number.MAX_SAFE_INTEGER)) throw new Error("The provided number is greater than MAX_SAFE_INTEGER (please use an alternative output type)");
                return Number(bigInt);
            }
        case $c73465646a90c04a$var$TypeOutput.PrefixedHexString:
            return (0, $4nduh.bufferToHex)(output);
        default:
            throw new Error("unknown outputType");
    }
}
module.exports.toType = $c73465646a90c04a$var$toType;

});


parcelRegister("kPUtI", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f2b461789dedb887$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashPersonalMessage = module.exports.isValidSignature = module.exports.fromRpcSig = module.exports.toCompactSig = module.exports.toRpcSig = module.exports.ecrecover = module.exports.ecsign = void 0;

var $8ytum = parcelRequire("8ytum");

var $hOBcC = parcelRequire("hOBcC");

var $4nduh = parcelRequire("4nduh");

var $3amHV = parcelRequire("3amHV");

var $8c6iI = parcelRequire("8c6iI");
/**
 * Returns the ECDSA signature of a message hash.
 *
 * If `chainId` is provided assume an EIP-155-style signature and calculate the `v` value
 * accordingly, otherwise return a "static" `v` just derived from the `recovery` bit
 */ function $f2b461789dedb887$var$ecsign(msgHash, privateKey, chainId) {
    const sig = $hOBcC.secp256k1.sign(msgHash, privateKey);
    const buf = sig.toCompactRawBytes();
    const r = $f2b461789dedb887$require$Buffer.from(buf.slice(0, 32));
    const s = $f2b461789dedb887$require$Buffer.from(buf.slice(32, 64));
    const v = chainId === undefined ? BigInt(sig.recovery + 27) : BigInt(sig.recovery + 35) + BigInt(chainId) * BigInt(2);
    return {
        r: r,
        s: s,
        v: v
    };
}
module.exports.ecsign = $f2b461789dedb887$var$ecsign;
function $f2b461789dedb887$var$calculateSigRecovery(v, chainId) {
    if (v === BigInt(0) || v === BigInt(1)) return v;
    if (chainId === undefined) return v - BigInt(27);
    return v - (chainId * BigInt(2) + BigInt(35));
}
function $f2b461789dedb887$var$isValidSigRecovery(recovery) {
    return recovery === BigInt(0) || recovery === BigInt(1);
}
/**
 * ECDSA public key recovery from signature.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Recovered public key
 */ const $f2b461789dedb887$var$ecrecover = function(msgHash, v, r, s, chainId) {
    const signature = $f2b461789dedb887$require$Buffer.concat([
        (0, $4nduh.setLengthLeft)(r, 32),
        (0, $4nduh.setLengthLeft)(s, 32)
    ], 64);
    const recovery = $f2b461789dedb887$var$calculateSigRecovery(v, chainId);
    if (!$f2b461789dedb887$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    const sig = $hOBcC.secp256k1.Signature.fromCompact(signature).addRecoveryBit(Number(recovery));
    const senderPubKey = sig.recoverPublicKey(msgHash);
    return $f2b461789dedb887$require$Buffer.from(senderPubKey.toRawBytes(false).slice(1));
};
module.exports.ecrecover = $f2b461789dedb887$var$ecrecover;
/**
 * Convert signature parameters into the format of `eth_sign` RPC method.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Signature
 */ const $f2b461789dedb887$var$toRpcSig = function(v, r, s, chainId) {
    const recovery = $f2b461789dedb887$var$calculateSigRecovery(v, chainId);
    if (!$f2b461789dedb887$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    // geth (and the RPC eth_sign method) uses the 65 byte format used by Bitcoin
    return (0, $4nduh.bufferToHex)($f2b461789dedb887$require$Buffer.concat([
        (0, $4nduh.setLengthLeft)(r, 32),
        (0, $4nduh.setLengthLeft)(s, 32),
        (0, $4nduh.toBuffer)(v)
    ]));
};
module.exports.toRpcSig = $f2b461789dedb887$var$toRpcSig;
/**
 * Convert signature parameters into the format of Compact Signature Representation (EIP-2098).
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @returns Signature
 */ const $f2b461789dedb887$var$toCompactSig = function(v, r, s, chainId) {
    const recovery = $f2b461789dedb887$var$calculateSigRecovery(v, chainId);
    if (!$f2b461789dedb887$var$isValidSigRecovery(recovery)) throw new Error("Invalid signature v value");
    let ss = s;
    if (v > BigInt(28) && v % BigInt(2) === BigInt(1) || v === BigInt(1) || v === BigInt(28)) {
        ss = $f2b461789dedb887$require$Buffer.from(s);
        ss[0] |= 0x80;
    }
    return (0, $4nduh.bufferToHex)($f2b461789dedb887$require$Buffer.concat([
        (0, $4nduh.setLengthLeft)(r, 32),
        (0, $4nduh.setLengthLeft)(ss, 32)
    ]));
};
module.exports.toCompactSig = $f2b461789dedb887$var$toCompactSig;
/**
 * Convert signature format of the `eth_sign` RPC method to signature parameters
 *
 * NOTE: For an extracted `v` value < 27 (see Geth bug https://github.com/ethereum/go-ethereum/issues/2053)
 * `v + 27` is returned for the `v` value
 * NOTE: After EIP1559, `v` could be `0` or `1` but this function assumes
 * it's a signed message (EIP-191 or EIP-712) adding `27` at the end. Remove if needed.
 */ const $f2b461789dedb887$var$fromRpcSig = function(sig) {
    const buf = (0, $4nduh.toBuffer)(sig);
    let r;
    let s;
    let v;
    if (buf.length >= 65) {
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = (0, $4nduh.bufferToBigInt)(buf.slice(64));
    } else if (buf.length === 64) {
        // Compact Signature Representation (https://eips.ethereum.org/EIPS/eip-2098)
        r = buf.slice(0, 32);
        s = buf.slice(32, 64);
        v = BigInt((0, $4nduh.bufferToInt)(buf.slice(32, 33)) >> 7);
        s[0] &= 0x7f;
    } else throw new Error("Invalid signature length");
    // support both versions of `eth_sign` responses
    if (v < 27) v = v + BigInt(27);
    return {
        v: v,
        r: r,
        s: s
    };
};
module.exports.fromRpcSig = $f2b461789dedb887$var$fromRpcSig;
/**
 * Validate a ECDSA signature.
 * NOTE: Accepts `v === 0 | v === 1` for EIP1559 transactions
 * @param homesteadOrLater Indicates whether this is being used on either the homestead hardfork or a later one
 */ const $f2b461789dedb887$var$isValidSignature = function(v, r, s, homesteadOrLater = true, chainId) {
    if (r.length !== 32 || s.length !== 32) return false;
    if (!$f2b461789dedb887$var$isValidSigRecovery($f2b461789dedb887$var$calculateSigRecovery(v, chainId))) return false;
    const rBigInt = (0, $4nduh.bufferToBigInt)(r);
    const sBigInt = (0, $4nduh.bufferToBigInt)(s);
    if (rBigInt === BigInt(0) || rBigInt >= $3amHV.SECP256K1_ORDER || sBigInt === BigInt(0) || sBigInt >= $3amHV.SECP256K1_ORDER) return false;
    if (homesteadOrLater && sBigInt >= $3amHV.SECP256K1_ORDER_DIV_2) return false;
    return true;
};
module.exports.isValidSignature = $f2b461789dedb887$var$isValidSignature;
/**
 * Returns the keccak-256 hash of `message`, prefixed with the header used by the `eth_sign` RPC call.
 * The output of this function can be fed into `ecsign` to produce the same signature as the `eth_sign`
 * call for a given `message`, or fed to `ecrecover` along with a signature to recover the public key
 * used to produce the signature.
 */ const $f2b461789dedb887$var$hashPersonalMessage = function(message) {
    (0, $8c6iI.assertIsBuffer)(message);
    const prefix = $f2b461789dedb887$require$Buffer.from(`\u0019Ethereum Signed Message:\n${message.length}`, "utf-8");
    return $f2b461789dedb887$require$Buffer.from((0, $8ytum.keccak256)($f2b461789dedb887$require$Buffer.concat([
        prefix,
        message
    ])));
};
module.exports.hashPersonalMessage = $f2b461789dedb887$var$hashPersonalMessage;

});

parcelRegister("eKZ3r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.compactBytesToNibbles = module.exports.bytesToNibbles = module.exports.nibblesToCompactBytes = module.exports.nibblesToBytes = module.exports.hasTerminator = void 0;
// Reference: https://ethereum.org/en/developers/docs/data-structures-and-encoding/patricia-merkle-trie/
/**
 *
 * @param s byte sequence
 * @returns boolean indicating if input hex nibble sequence has terminator indicating leaf-node
 *          terminator is represented with 16 because a nibble ranges from 0 - 15(f)
 */ const $abe4b8b493b51c12$var$hasTerminator = (nibbles)=>{
    return nibbles.length > 0 && nibbles[nibbles.length - 1] === 16;
};
module.exports.hasTerminator = $abe4b8b493b51c12$var$hasTerminator;
const $abe4b8b493b51c12$var$nibblesToBytes = (nibbles, bytes)=>{
    for(let bi = 0, ni = 0; ni < nibbles.length; bi += 1, ni += 2)bytes[bi] = nibbles[ni] << 4 | nibbles[ni + 1];
};
module.exports.nibblesToBytes = $abe4b8b493b51c12$var$nibblesToBytes;
const $abe4b8b493b51c12$var$nibblesToCompactBytes = (nibbles)=>{
    let terminator = 0;
    if ((0, module.exports.hasTerminator)(nibbles)) {
        terminator = 1;
        // Remove the terminator from the sequence
        nibbles = nibbles.subarray(0, nibbles.length - 1);
    }
    const buf = new Uint8Array(nibbles.length / 2 + 1);
    // Shift the terminator info into the first nibble of buf[0]
    buf[0] = terminator << 5;
    // If odd length, then add that flag into the first nibble and put the odd nibble to
    // second part of buf[0] which otherwise will be left padded with a 0
    if ((nibbles.length & 1) === 1) {
        buf[0] |= 16;
        buf[0] |= nibbles[0];
        nibbles = nibbles.subarray(1);
    }
    // create bytes out of the rest even nibbles
    (0, module.exports.nibblesToBytes)(nibbles, buf.subarray(1));
    return buf;
};
module.exports.nibblesToCompactBytes = $abe4b8b493b51c12$var$nibblesToCompactBytes;
const $abe4b8b493b51c12$var$bytesToNibbles = (str)=>{
    const l = str.length * 2 + 1;
    const nibbles = new Uint8Array(l);
    for(let i = 0; i < str.length; i++){
        const b = str[i];
        nibbles[i * 2] = b / 16;
        nibbles[i * 2 + 1] = b % 16;
    }
    // This will get removed from calling function if the first nibble
    // indicates that terminator is not present
    nibbles[l - 1] = 16;
    return nibbles;
};
module.exports.bytesToNibbles = $abe4b8b493b51c12$var$bytesToNibbles;
const $abe4b8b493b51c12$var$compactBytesToNibbles = (compact)=>{
    if (compact.length === 0) return compact;
    let base = (0, module.exports.bytesToNibbles)(compact);
    // delete terminator flag if terminator flag was not in first nibble
    if (base[0] < 2) base = base.subarray(0, base.length - 1);
    // chop the terminator nibble and the even padding (if there is one)
    // i.e.  chop 2 left nibbles when even else 1 when odd
    const chop = 2 - (base[0] & 1);
    return base.subarray(chop);
};
module.exports.compactBytesToNibbles = $abe4b8b493b51c12$var$compactBytesToNibbles; /**
 * A test helper to generates compact path for a subset of key bytes
 *
 * TODO: Commenting the code for now as this seems to be helper function
 * (from geth codebase )
 *
 */  //
 //
 // export const getPathTo = (tillBytes: number, key: Buffer) => {
 //   const hexNibbles = bytesToNibbles(key).subarray(0, tillBytes)
 //   // Remove the terminator if its there, although it would be there only if tillBytes >= key.length
 //   // This seems to be a test helper to generate paths so correctness of this isn't necessary
 //   hexNibbles[hexNibbles.length - 1] = 0
 //   const compactBytes = nibblesToCompactBytes(hexNibbles)
 //   return [Buffer.from(compactBytes)]
 // }

});

parcelRegister("kW3fK", function(module, exports) {
"use strict";
/**
 * Ported to Typescript from original implementation below:
 * https://github.com/ahultgren/async-eventemitter -- MIT licensed
 *
 * Type Definitions based on work by: patarapolw <https://github.com/patarapolw> -- MIT licensed
 * that was contributed to Definitely Typed below:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/tree/master/types/async-eventemitter
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AsyncEventEmitter = void 0;

var $jMc9N = parcelRequire("jMc9N");
async function $f3dbbf676285c105$var$runInSeries(context, tasks, data) {
    let error;
    for await (const task of tasks)try {
        if (task.length < 2) //sync
        task.call(context, data);
        else await new Promise((resolve, reject)=>{
            task.call(context, data, (error)=>{
                if (error) reject(error);
                else resolve();
            });
        });
    } catch (e) {
        error = e;
    }
    if (error) throw error;
}
class $f3dbbf676285c105$var$AsyncEventEmitter extends $jMc9N.EventEmitter {
    emit(event, ...args) {
        let [data, callback] = args;
        const self = this;
        let listeners = self._events[event] ?? [];
        // Optional data argument
        if (callback === undefined && typeof data === "function") {
            callback = data;
            data = undefined;
        }
        // Special treatment of internal newListener and removeListener events
        if (event === "newListener" || event === "removeListener") {
            data = {
                event: data,
                fn: callback
            };
            callback = undefined;
        }
        // A single listener is just a function not an array...
        listeners = Array.isArray(listeners) ? listeners : [
            listeners
        ];
        $f3dbbf676285c105$var$runInSeries(self, listeners.slice(), data).then(callback).catch(callback);
        return self.listenerCount(event) > 0;
    }
    once(event, listener) {
        const self = this;
        let g;
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Hack to support set arity
        if (listener.length >= 2) g = function(e, next) {
            self.removeListener(event, g);
            listener(e, next);
        };
        else g = function(e) {
            self.removeListener(event, g);
            listener(e, g);
        };
        self.on(event, g);
        return self;
    }
    first(event, listener) {
        let listeners = this._events[event] ?? [];
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        listeners.unshift(listener);
        return this;
    }
    before(event, target, listener) {
        return this.beforeOrAfter(event, target, listener);
    }
    after(event, target, listener) {
        return this.beforeOrAfter(event, target, listener, "after");
    }
    beforeOrAfter(event, target, listener, beforeOrAfter) {
        let listeners = this._events[event] ?? [];
        let i;
        let index;
        const add = beforeOrAfter === "after" ? 1 : 0;
        // Contract
        if (typeof listener !== "function") throw new TypeError("listener must be a function");
        if (typeof target !== "function") throw new TypeError("target must be a function");
        // Listeners are not always an array
        if (!Array.isArray(listeners)) this._events[event] = listeners = [
            listeners
        ];
        index = listeners.length;
        for(i = listeners.length; i--;)if (listeners[i] === target) {
            index = i + add;
            break;
        }
        listeners.splice(index, 0, listener);
        return this;
    }
    on(event, listener) {
        return super.on(event, listener);
    }
    addListener(event, listener) {
        return super.addListener(event, listener);
    }
    prependListener(event, listener) {
        return super.prependListener(event, listener);
    }
    prependOnceListener(event, listener) {
        return super.prependOnceListener(event, listener);
    }
    removeAllListeners(event) {
        return super.removeAllListeners(event);
    }
    removeListener(event, listener) {
        return super.removeListener(event, listener);
    }
    eventNames() {
        return super.eventNames();
    }
    listeners(event) {
        return super.listeners(event);
    }
    listenerCount(event) {
        return super.listenerCount(event);
    }
    getMaxListeners() {
        return super.getMaxListeners();
    }
    setMaxListeners(maxListeners) {
        return super.setMaxListeners(maxListeners);
    }
}
module.exports.AsyncEventEmitter = $f3dbbf676285c105$var$AsyncEventEmitter;

});

parcelRegister("1lNHU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Lock = void 0;
// Based on https://github.com/jsoendermann/semaphore-async-await/blob/master/src/Semaphore.ts
class $0fbe4f6a6edf07fd$var$Lock {
    constructor(){
        this.permits = 1;
        this.promiseResolverQueue = [];
    }
    /**
     * Returns a promise used to wait for a permit to become available. This method should be awaited on.
     * @returns  A promise that gets resolved when execution is allowed to proceed.
     */ async acquire() {
        if (this.permits > 0) {
            this.permits -= 1;
            return Promise.resolve(true);
        }
        // If there is no permit available, we return a promise that resolves once the semaphore gets
        // signaled enough times that permits is equal to one.
        return new Promise((resolver)=>this.promiseResolverQueue.push(resolver));
    }
    /**
     * Increases the number of permits by one. If there are other functions waiting, one of them will
     * continue to execute in a future iteration of the event loop.
     */ release() {
        this.permits += 1;
        if (this.permits > 1 && this.promiseResolverQueue.length > 0) // eslint-disable-next-line no-console
        console.warn("Lock.permits should never be > 0 when there is someone waiting.");
        else if (this.permits === 1 && this.promiseResolverQueue.length > 0) {
            // If there is someone else waiting, immediately consume the permit that was released
            // at the beginning of this function and let the waiting function resume.
            this.permits -= 1;
            const nextResolver = this.promiseResolverQueue.shift();
            if (nextResolver) nextResolver(true);
        }
    }
}
module.exports.Lock = $0fbe4f6a6edf07fd$var$Lock;

});

parcelRegister("5qpD3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getProvider = module.exports.fetchFromProvider = void 0;

var $7fn5x = parcelRequire("7fn5x");
const $3f3342cd4ec036e2$var$fetchFromProvider = async (url, params)=>{
    const res = await (0, $7fn5x.default)(url, {
        headers: {
            "content-type": "application/json"
        },
        type: "json",
        data: {
            method: params.method,
            params: params.params,
            jsonrpc: "2.0",
            id: 1
        }
    });
    return res.result;
};
module.exports.fetchFromProvider = $3f3342cd4ec036e2$var$fetchFromProvider;
const $3f3342cd4ec036e2$var$getProvider = (provider)=>{
    if (typeof provider === "string") return provider;
    else if (provider?.connection?.url !== undefined) return provider.connection.url;
    else throw new Error("Must provide valid provider URL or Web3Provider");
};
module.exports.getProvider = $3f3342cd4ec036e2$var$getProvider;

});
parcelRegister("7fn5x", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $546bd7fd5e8e45b5$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InvalidStatusCodeError = module.exports.InvalidCertError = void 0;
const $546bd7fd5e8e45b5$var$DEFAULT_OPT = Object.freeze({
    redirect: true,
    expectStatusCode: 200,
    headers: {},
    full: false,
    keepAlive: true,
    cors: false,
    referrer: false,
    sslAllowSelfSigned: false,
    _redirectCount: 0
});
class $546bd7fd5e8e45b5$var$InvalidCertError extends Error {
    constructor(msg, fingerprint256){
        super(msg);
        this.fingerprint256 = fingerprint256;
    }
}
module.exports.InvalidCertError = $546bd7fd5e8e45b5$var$InvalidCertError;
class $546bd7fd5e8e45b5$var$InvalidStatusCodeError extends Error {
    constructor(statusCode){
        super(`Request Failed. Status Code: ${statusCode}`);
        this.statusCode = statusCode;
    }
}
module.exports.InvalidStatusCodeError = $546bd7fd5e8e45b5$var$InvalidStatusCodeError;
function $546bd7fd5e8e45b5$var$detectType(b, type) {
    if (!type || type === "text" || type === "json") try {
        let text = new TextDecoder("utf8", {
            fatal: true
        }).decode(b);
        if (type === "text") return text;
        try {
            return JSON.parse(text);
        } catch (err) {
            if (type === "json") throw err;
            return text;
        }
    } catch (err) {
        if (type === "text" || type === "json") throw err;
    }
    return b;
}
let $546bd7fd5e8e45b5$var$agents = {};





function $546bd7fd5e8e45b5$var$fetchNode(url, _options) {
    let options = {
        ...$546bd7fd5e8e45b5$var$DEFAULT_OPT,
        ..._options
    };
    const http = (parcelRequire("3JpYu"));
    const https = (parcelRequire("hrxEy"));
    const zlib = (parcelRequire("cAzsp"));
    const { promisify: promisify } = (parcelRequire("4zyeF"));
    const { resolve: urlResolve } = (parcelRequire("hH01d"));
    const isSecure = !!/^https/.test(url);
    let opts = {
        method: options.method || "GET",
        headers: {
            "Accept-Encoding": "gzip, deflate, br"
        }
    };
    const compactFP = (s)=>s.replace(/:| /g, "").toLowerCase();
    if (options.keepAlive) {
        const agentOpt = {
            keepAlive: true,
            keepAliveMsecs: 30000,
            maxFreeSockets: 1024,
            maxCachedSessions: 1024
        };
        const agentKey = [
            isSecure,
            isSecure && options.sslPinnedCertificates?.map((i)=>compactFP(i)).sort()
        ].join();
        opts.agent = $546bd7fd5e8e45b5$var$agents[agentKey] || ($546bd7fd5e8e45b5$var$agents[agentKey] = new (isSecure ? https : http).Agent(agentOpt));
    }
    if (options.type === "json") opts.headers["Content-Type"] = "application/json";
    if (options.data) {
        if (!options.method) opts.method = "POST";
        opts.body = options.type === "json" ? JSON.stringify(options.data) : options.data;
    }
    opts.headers = {
        ...opts.headers,
        ...options.headers
    };
    if (options.sslAllowSelfSigned) opts.rejectUnauthorized = false;
    const handleRes = async (res)=>{
        const status = res.statusCode;
        if (options.redirect && 300 <= status && status < 400 && res.headers["location"]) {
            if (options._redirectCount == 10) throw new Error("Request failed. Too much redirects.");
            options._redirectCount += 1;
            return await $546bd7fd5e8e45b5$var$fetchNode(urlResolve(url, res.headers["location"]), options);
        }
        if (options.expectStatusCode && status !== options.expectStatusCode) {
            res.resume();
            throw new $546bd7fd5e8e45b5$var$InvalidStatusCodeError(status);
        }
        let buf = [];
        for await (const chunk of res)buf.push(chunk);
        let bytes = $546bd7fd5e8e45b5$require$Buffer.concat(buf);
        const encoding = res.headers["content-encoding"];
        if (encoding === "br") bytes = await promisify(zlib.brotliDecompress)(bytes);
        if (encoding === "gzip" || encoding === "deflate") bytes = await promisify(zlib.unzip)(bytes);
        const body = $546bd7fd5e8e45b5$var$detectType(bytes, options.type);
        if (options.full) return {
            headers: res.headers,
            status: status,
            body: body
        };
        return body;
    };
    return new Promise((resolve, reject)=>{
        const handleError = async (err)=>{
            if (err && err.code === "DEPTH_ZERO_SELF_SIGNED_CERT") try {
                await $546bd7fd5e8e45b5$var$fetchNode(url, {
                    ...options,
                    sslAllowSelfSigned: true,
                    sslPinnedCertificates: []
                });
            } catch (e) {
                if (e && e.fingerprint256) err = new $546bd7fd5e8e45b5$var$InvalidCertError(`Self-signed SSL certificate: ${e.fingerprint256}`, e.fingerprint256);
            }
            reject(err);
        };
        const req = (isSecure ? https : http).request(url, opts, (res)=>{
            res.on("error", handleError);
            (async ()=>{
                try {
                    resolve(await handleRes(res));
                } catch (error) {
                    reject(error);
                }
            })();
        });
        req.on("error", handleError);
        const pinned = options.sslPinnedCertificates?.map((i)=>compactFP(i));
        const mfetchSecureConnect = (socket)=>{
            const fp256 = compactFP(socket.getPeerCertificate()?.fingerprint256 || "");
            if (!fp256 && socket.isSessionReused()) return;
            if (pinned.includes(fp256)) return;
            req.emit("error", new $546bd7fd5e8e45b5$var$InvalidCertError(`Invalid SSL certificate: ${fp256} Expected: ${pinned}`, fp256));
            return req.abort();
        };
        if (options.sslPinnedCertificates) req.on("socket", (socket)=>{
            const hasListeners = socket.listeners("secureConnect").map((i)=>(i.name || "").replace("bound ", "")).includes("mfetchSecureConnect");
            if (hasListeners) return;
            socket.on("secureConnect", mfetchSecureConnect.bind(null, socket));
        });
        if (options.keepAlive) req.setNoDelay(true);
        if (opts.body) req.write(opts.body);
        req.end();
    });
}
const $546bd7fd5e8e45b5$var$SAFE_HEADERS = new Set([
    "Accept",
    "Accept-Language",
    "Content-Language",
    "Content-Type"
].map((i)=>i.toLowerCase()));
const $546bd7fd5e8e45b5$var$FORBIDDEN_HEADERS = new Set([
    "Accept-Charset",
    "Accept-Encoding",
    "Access-Control-Request-Headers",
    "Access-Control-Request-Method",
    "Connection",
    "Content-Length",
    "Cookie",
    "Cookie2",
    "Date",
    "DNT",
    "Expect",
    "Host",
    "Keep-Alive",
    "Origin",
    "Referer",
    "TE",
    "Trailer",
    "Transfer-Encoding",
    "Upgrade",
    "Via"
].map((i)=>i.toLowerCase()));
async function $546bd7fd5e8e45b5$var$fetchBrowser(url, _options) {
    let options = {
        ...$546bd7fd5e8e45b5$var$DEFAULT_OPT,
        ..._options
    };
    const headers = new Headers();
    if (options.type === "json") headers.set("Content-Type", "application/json");
    let parsed = new URL(url);
    if (parsed.username) {
        const auth = btoa(`${parsed.username}:${parsed.password}`);
        headers.set("Authorization", `Basic ${auth}`);
        parsed.username = "";
        parsed.password = "";
    }
    url = "" + parsed;
    for(let k in options.headers){
        const name = k.toLowerCase();
        if ($546bd7fd5e8e45b5$var$SAFE_HEADERS.has(name) || options.cors && !$546bd7fd5e8e45b5$var$FORBIDDEN_HEADERS.has(name)) headers.set(k, options.headers[k]);
    }
    let opts = {
        headers: headers,
        redirect: options.redirect ? "follow" : "manual"
    };
    if (!options.referrer) opts.referrerPolicy = "no-referrer";
    if (options.cors) opts.mode = "cors";
    if (options.data) {
        if (!options.method) opts.method = "POST";
        opts.body = options.type === "json" ? JSON.stringify(options.data) : options.data;
    }
    const res = await fetch(url, opts);
    if (options.expectStatusCode && res.status !== options.expectStatusCode) throw new $546bd7fd5e8e45b5$var$InvalidStatusCodeError(res.status);
    const body = $546bd7fd5e8e45b5$var$detectType(new Uint8Array(await res.arrayBuffer()), options.type);
    if (options.full) return {
        headers: Object.fromEntries(res.headers.entries()),
        status: res.status,
        body: body
    };
    return body;
}
const $546bd7fd5e8e45b5$var$IS_NODE = !!(typeof $4TNnu == "object" && $4TNnu.versions && $4TNnu.versions.node && $4TNnu.versions.v8);
function $546bd7fd5e8e45b5$var$fetchUrl(url, options) {
    const fn = $546bd7fd5e8e45b5$var$IS_NODE ? $546bd7fd5e8e45b5$var$fetchNode : $546bd7fd5e8e45b5$var$fetchBrowser;
    return fn(url, options);
}
module.exports.default = $546bd7fd5e8e45b5$var$fetchUrl;

});
parcelRegister("3JpYu", function(module, exports) {

var $hxw2T = parcelRequire("hxw2T");

var $4KSWs = parcelRequire("4KSWs");

var $57907 = parcelRequire("57907");

var $jrXzS = parcelRequire("jrXzS");

var $hH01d = parcelRequire("hH01d");
var $2b79b913beb52453$var$http = module.exports;
$2b79b913beb52453$var$http.request = function(opts, cb) {
    if (typeof opts === "string") opts = $hH01d.parse(opts);
    else opts = $57907(opts);
    // Normally, the page is loaded from http or https, so not specifying a protocol
    // will result in a (valid) protocol-relative url. However, this won't work if
    // the protocol is something else, like 'file:'
    var defaultProtocol = $parcel$global.location.protocol.search(/^https?:$/) === -1 ? "http:" : "";
    var protocol = opts.protocol || defaultProtocol;
    var host = opts.hostname || opts.host;
    var port = opts.port;
    var path = opts.path || "/";
    // Necessary for IPv6 addresses
    if (host && host.indexOf(":") !== -1) host = "[" + host + "]";
    // This may be a relative url. The browser should always be able to interpret it correctly.
    opts.url = (host ? protocol + "//" + host : "") + (port ? ":" + port : "") + path;
    opts.method = (opts.method || "GET").toUpperCase();
    opts.headers = opts.headers || {};
    // Also valid opts.auth, opts.mode
    var req = new $hxw2T(opts);
    if (cb) req.on("response", cb);
    return req;
};
$2b79b913beb52453$var$http.get = function get(opts, cb) {
    var req = $2b79b913beb52453$var$http.request(opts, cb);
    req.end();
    return req;
};
$2b79b913beb52453$var$http.ClientRequest = $hxw2T;
$2b79b913beb52453$var$http.IncomingMessage = $4KSWs.IncomingMessage;
$2b79b913beb52453$var$http.Agent = function() {};
$2b79b913beb52453$var$http.Agent.defaultMaxSockets = 4;
$2b79b913beb52453$var$http.globalAgent = new $2b79b913beb52453$var$http.Agent();
$2b79b913beb52453$var$http.STATUS_CODES = $jrXzS;
$2b79b913beb52453$var$http.METHODS = [
    "CHECKOUT",
    "CONNECT",
    "COPY",
    "DELETE",
    "GET",
    "HEAD",
    "LOCK",
    "M-SEARCH",
    "MERGE",
    "MKACTIVITY",
    "MKCOL",
    "MOVE",
    "NOTIFY",
    "OPTIONS",
    "PATCH",
    "POST",
    "PROPFIND",
    "PROPPATCH",
    "PURGE",
    "PUT",
    "REPORT",
    "SEARCH",
    "SUBSCRIBE",
    "TRACE",
    "UNLOCK",
    "UNSUBSCRIBE"
];

});
parcelRegister("hxw2T", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $cc4e605311c120c9$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");

var $7mvjX = parcelRequire("7mvjX");

var $eSHUL = parcelRequire("eSHUL");

var $4KSWs = parcelRequire("4KSWs");

var $9AddZ = parcelRequire("9AddZ");
var $cc4e605311c120c9$var$IncomingMessage = $4KSWs.IncomingMessage;
var $cc4e605311c120c9$var$rStates = $4KSWs.readyStates;
function $cc4e605311c120c9$var$decideMode(preferBinary, useFetch) {
    if ($7mvjX.fetch && useFetch) return "fetch";
    else if ($7mvjX.mozchunkedarraybuffer) return "moz-chunked-arraybuffer";
    else if ($7mvjX.msstream) return "ms-stream";
    else if ($7mvjX.arraybuffer && preferBinary) return "arraybuffer";
    else return "text";
}
var $cc4e605311c120c9$var$ClientRequest = module.exports = function(opts) {
    var self = this;
    $9AddZ.Writable.call(self);
    self._opts = opts;
    self._body = [];
    self._headers = {};
    if (opts.auth) self.setHeader("Authorization", "Basic " + $cc4e605311c120c9$require$Buffer.from(opts.auth).toString("base64"));
    Object.keys(opts.headers).forEach(function(name) {
        self.setHeader(name, opts.headers[name]);
    });
    var preferBinary;
    var useFetch = true;
    if (opts.mode === "disable-fetch" || "requestTimeout" in opts && !$7mvjX.abortController) {
        // If the use of XHR should be preferred. Not typically needed.
        useFetch = false;
        preferBinary = true;
    } else if (opts.mode === "prefer-streaming") // If streaming is a high priority but binary compatibility and
    // the accuracy of the 'content-type' header aren't
    preferBinary = false;
    else if (opts.mode === "allow-wrong-content-type") // If streaming is more important than preserving the 'content-type' header
    preferBinary = !$7mvjX.overrideMimeType;
    else if (!opts.mode || opts.mode === "default" || opts.mode === "prefer-fast") // Use binary if text streaming may corrupt data or the content-type header, or for speed
    preferBinary = true;
    else throw new Error("Invalid value for opts.mode");
    self._mode = $cc4e605311c120c9$var$decideMode(preferBinary, useFetch);
    self._fetchTimer = null;
    self._socketTimeout = null;
    self._socketTimer = null;
    self.on("finish", function() {
        self._onFinish();
    });
};
$eSHUL($cc4e605311c120c9$var$ClientRequest, $9AddZ.Writable);
$cc4e605311c120c9$var$ClientRequest.prototype.setHeader = function(name, value) {
    var self = this;
    var lowerName = name.toLowerCase();
    // This check is not necessary, but it prevents warnings from browsers about setting unsafe
    // headers. To be honest I'm not entirely sure hiding these warnings is a good thing, but
    // http-browserify did it, so I will too.
    if ($cc4e605311c120c9$var$unsafeHeaders.indexOf(lowerName) !== -1) return;
    self._headers[lowerName] = {
        name: name,
        value: value
    };
};
$cc4e605311c120c9$var$ClientRequest.prototype.getHeader = function(name) {
    var header = this._headers[name.toLowerCase()];
    if (header) return header.value;
    return null;
};
$cc4e605311c120c9$var$ClientRequest.prototype.removeHeader = function(name) {
    var self = this;
    delete self._headers[name.toLowerCase()];
};
$cc4e605311c120c9$var$ClientRequest.prototype._onFinish = function() {
    var self = this;
    if (self._destroyed) return;
    var opts = self._opts;
    if ("timeout" in opts && opts.timeout !== 0) self.setTimeout(opts.timeout);
    var headersObj = self._headers;
    var body = null;
    if (opts.method !== "GET" && opts.method !== "HEAD") body = new Blob(self._body, {
        type: (headersObj["content-type"] || {}).value || ""
    });
    // create flattened list of headers
    var headersList = [];
    Object.keys(headersObj).forEach(function(keyName) {
        var name = headersObj[keyName].name;
        var value = headersObj[keyName].value;
        if (Array.isArray(value)) value.forEach(function(v) {
            headersList.push([
                name,
                v
            ]);
        });
        else headersList.push([
            name,
            value
        ]);
    });
    if (self._mode === "fetch") {
        var signal = null;
        if ($7mvjX.abortController) {
            var controller = new AbortController();
            signal = controller.signal;
            self._fetchAbortController = controller;
            if ("requestTimeout" in opts && opts.requestTimeout !== 0) self._fetchTimer = $parcel$global.setTimeout(function() {
                self.emit("requestTimeout");
                if (self._fetchAbortController) self._fetchAbortController.abort();
            }, opts.requestTimeout);
        }
        $parcel$global.fetch(self._opts.url, {
            method: self._opts.method,
            headers: headersList,
            body: body || undefined,
            mode: "cors",
            credentials: opts.withCredentials ? "include" : "same-origin",
            signal: signal
        }).then(function(response) {
            self._fetchResponse = response;
            self._resetTimers(false);
            self._connect();
        }, function(reason) {
            self._resetTimers(true);
            if (!self._destroyed) self.emit("error", reason);
        });
    } else {
        var xhr = self._xhr = new $parcel$global.XMLHttpRequest();
        try {
            xhr.open(self._opts.method, self._opts.url, true);
        } catch (err) {
            $4TNnu.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
        // Can't set responseType on really old browsers
        if ("responseType" in xhr) xhr.responseType = self._mode;
        if ("withCredentials" in xhr) xhr.withCredentials = !!opts.withCredentials;
        if (self._mode === "text" && "overrideMimeType" in xhr) xhr.overrideMimeType("text/plain; charset=x-user-defined");
        if ("requestTimeout" in opts) {
            xhr.timeout = opts.requestTimeout;
            xhr.ontimeout = function() {
                self.emit("requestTimeout");
            };
        }
        headersList.forEach(function(header) {
            xhr.setRequestHeader(header[0], header[1]);
        });
        self._response = null;
        xhr.onreadystatechange = function() {
            switch(xhr.readyState){
                case $cc4e605311c120c9$var$rStates.LOADING:
                case $cc4e605311c120c9$var$rStates.DONE:
                    self._onXHRProgress();
                    break;
            }
        };
        // Necessary for streaming in Firefox, since xhr.response is ONLY defined
        // in onprogress, not in onreadystatechange with xhr.readyState = 3
        if (self._mode === "moz-chunked-arraybuffer") xhr.onprogress = function() {
            self._onXHRProgress();
        };
        xhr.onerror = function() {
            if (self._destroyed) return;
            self._resetTimers(true);
            self.emit("error", new Error("XHR error"));
        };
        try {
            xhr.send(body);
        } catch (err) {
            $4TNnu.nextTick(function() {
                self.emit("error", err);
            });
            return;
        }
    }
};
/**
 * Checks if xhr.status is readable and non-zero, indicating no error.
 * Even though the spec says it should be available in readyState 3,
 * accessing it throws an exception in IE8
 */ function $cc4e605311c120c9$var$statusValid(xhr) {
    try {
        var status = xhr.status;
        return status !== null && status !== 0;
    } catch (e) {
        return false;
    }
}
$cc4e605311c120c9$var$ClientRequest.prototype._onXHRProgress = function() {
    var self = this;
    self._resetTimers(false);
    if (!$cc4e605311c120c9$var$statusValid(self._xhr) || self._destroyed) return;
    if (!self._response) self._connect();
    self._response._onXHRProgress(self._resetTimers.bind(self));
};
$cc4e605311c120c9$var$ClientRequest.prototype._connect = function() {
    var self = this;
    if (self._destroyed) return;
    self._response = new $cc4e605311c120c9$var$IncomingMessage(self._xhr, self._fetchResponse, self._mode, self._resetTimers.bind(self));
    self._response.on("error", function(err) {
        self.emit("error", err);
    });
    self.emit("response", self._response);
};
$cc4e605311c120c9$var$ClientRequest.prototype._write = function(chunk, encoding, cb) {
    var self = this;
    self._body.push(chunk);
    cb();
};
$cc4e605311c120c9$var$ClientRequest.prototype._resetTimers = function(done) {
    var self = this;
    $parcel$global.clearTimeout(self._socketTimer);
    self._socketTimer = null;
    if (done) {
        $parcel$global.clearTimeout(self._fetchTimer);
        self._fetchTimer = null;
    } else if (self._socketTimeout) self._socketTimer = $parcel$global.setTimeout(function() {
        self.emit("timeout");
    }, self._socketTimeout);
};
$cc4e605311c120c9$var$ClientRequest.prototype.abort = $cc4e605311c120c9$var$ClientRequest.prototype.destroy = function(err) {
    var self = this;
    self._destroyed = true;
    self._resetTimers(true);
    if (self._response) self._response._destroyed = true;
    if (self._xhr) self._xhr.abort();
    else if (self._fetchAbortController) self._fetchAbortController.abort();
    if (err) self.emit("error", err);
};
$cc4e605311c120c9$var$ClientRequest.prototype.end = function(data, encoding, cb) {
    var self = this;
    if (typeof data === "function") {
        cb = data;
        data = undefined;
    }
    $9AddZ.Writable.prototype.end.call(self, data, encoding, cb);
};
$cc4e605311c120c9$var$ClientRequest.prototype.setTimeout = function(timeout, cb) {
    var self = this;
    if (cb) self.once("timeout", cb);
    self._socketTimeout = timeout;
    self._resetTimers(false);
};
$cc4e605311c120c9$var$ClientRequest.prototype.flushHeaders = function() {};
$cc4e605311c120c9$var$ClientRequest.prototype.setNoDelay = function() {};
$cc4e605311c120c9$var$ClientRequest.prototype.setSocketKeepAlive = function() {};
// Taken from http://www.w3.org/TR/XMLHttpRequest/#the-setrequestheader%28%29-method
var $cc4e605311c120c9$var$unsafeHeaders = [
    "accept-charset",
    "accept-encoding",
    "access-control-request-headers",
    "access-control-request-method",
    "connection",
    "content-length",
    "cookie",
    "cookie2",
    "date",
    "dnt",
    "expect",
    "host",
    "keep-alive",
    "origin",
    "referer",
    "te",
    "trailer",
    "transfer-encoding",
    "upgrade",
    "via"
];

});
parcelRegister("7mvjX", function(module, exports) {

$parcel$export(module.exports, "fetch", function () { return $55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3; }, function (v) { return $55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 = v; });
$parcel$export(module.exports, "writableStream", function () { return $55c2e225bb15ad00$export$37489d82087dc5d1; }, function (v) { return $55c2e225bb15ad00$export$37489d82087dc5d1 = v; });
$parcel$export(module.exports, "abortController", function () { return $55c2e225bb15ad00$export$f137bf8a46425a6f; }, function (v) { return $55c2e225bb15ad00$export$f137bf8a46425a6f = v; });
$parcel$export(module.exports, "arraybuffer", function () { return $55c2e225bb15ad00$export$724c4efdc2b90612; }, function (v) { return $55c2e225bb15ad00$export$724c4efdc2b90612 = v; });
$parcel$export(module.exports, "msstream", function () { return $55c2e225bb15ad00$export$a9aa1e45c4448986; }, function (v) { return $55c2e225bb15ad00$export$a9aa1e45c4448986 = v; });
$parcel$export(module.exports, "mozchunkedarraybuffer", function () { return $55c2e225bb15ad00$export$4c3c163e941f6ba3; }, function (v) { return $55c2e225bb15ad00$export$4c3c163e941f6ba3 = v; });
$parcel$export(module.exports, "overrideMimeType", function () { return $55c2e225bb15ad00$export$8f1269d6d73f87ef; }, function (v) { return $55c2e225bb15ad00$export$8f1269d6d73f87ef = v; });
var $55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3;
var $55c2e225bb15ad00$export$37489d82087dc5d1;
var $55c2e225bb15ad00$export$f137bf8a46425a6f;
// If fetch is supported, then arraybuffer will be supported too. Skip calling
// checkTypeSupport(), since that calls getXHR().
var $55c2e225bb15ad00$export$724c4efdc2b90612;
// These next two tests unavoidably show warnings in Chrome. Since fetch will always
// be used if it's available, just return false for these to avoid the warnings.
var $55c2e225bb15ad00$export$a9aa1e45c4448986;
var $55c2e225bb15ad00$export$4c3c163e941f6ba3;
// If fetch is supported, then overrideMimeType will be supported too. Skip calling
// getXHR().
var $55c2e225bb15ad00$export$8f1269d6d73f87ef;
$55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 = $55c2e225bb15ad00$var$isFunction($parcel$global.fetch) && $55c2e225bb15ad00$var$isFunction($parcel$global.ReadableStream);
$55c2e225bb15ad00$export$37489d82087dc5d1 = $55c2e225bb15ad00$var$isFunction($parcel$global.WritableStream);
$55c2e225bb15ad00$export$f137bf8a46425a6f = $55c2e225bb15ad00$var$isFunction($parcel$global.AbortController);
// The xhr request to example.com may violate some restrictive CSP configurations,
// so if we're running in a browser that supports `fetch`, avoid calling getXHR()
// and assume support for certain features below.
var $55c2e225bb15ad00$var$xhr;
function $55c2e225bb15ad00$var$getXHR() {
    // Cache the xhr value
    if ($55c2e225bb15ad00$var$xhr !== undefined) return $55c2e225bb15ad00$var$xhr;
    if ($parcel$global.XMLHttpRequest) {
        $55c2e225bb15ad00$var$xhr = new $parcel$global.XMLHttpRequest();
        // If XDomainRequest is available (ie only, where xhr might not work
        // cross domain), use the page location. Otherwise use example.com
        // Note: this doesn't actually make an http request.
        try {
            $55c2e225bb15ad00$var$xhr.open("GET", $parcel$global.XDomainRequest ? "/" : "https://example.com");
        } catch (e) {
            $55c2e225bb15ad00$var$xhr = null;
        }
    } else // Service workers don't have XHR
    $55c2e225bb15ad00$var$xhr = null;
    return $55c2e225bb15ad00$var$xhr;
}
function $55c2e225bb15ad00$var$checkTypeSupport(type) {
    var xhr = $55c2e225bb15ad00$var$getXHR();
    if (!xhr) return false;
    try {
        xhr.responseType = type;
        return xhr.responseType === type;
    } catch (e) {}
    return false;
}
$55c2e225bb15ad00$export$724c4efdc2b90612 = $55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 || $55c2e225bb15ad00$var$checkTypeSupport("arraybuffer");
$55c2e225bb15ad00$export$a9aa1e45c4448986 = !$55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 && $55c2e225bb15ad00$var$checkTypeSupport("ms-stream");
$55c2e225bb15ad00$export$4c3c163e941f6ba3 = !$55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 && $55c2e225bb15ad00$var$checkTypeSupport("moz-chunked-arraybuffer");
$55c2e225bb15ad00$export$8f1269d6d73f87ef = $55c2e225bb15ad00$export$e7aa7bc5c1b3cfb3 || ($55c2e225bb15ad00$var$getXHR() ? $55c2e225bb15ad00$var$isFunction($55c2e225bb15ad00$var$getXHR().overrideMimeType) : false);
function $55c2e225bb15ad00$var$isFunction(value) {
    return typeof value === "function";
}
$55c2e225bb15ad00$var$xhr = null // Help gc
;

});

parcelRegister("4KSWs", function(module, exports) {

$parcel$export(module.exports, "readyStates", function () { return $376613a1041dbb0b$export$8e4da25483e314e6; }, function (v) { return $376613a1041dbb0b$export$8e4da25483e314e6 = v; });
$parcel$export(module.exports, "IncomingMessage", function () { return $376613a1041dbb0b$export$9d4333345ffa4fd6; }, function (v) { return $376613a1041dbb0b$export$9d4333345ffa4fd6 = v; });
var $376613a1041dbb0b$export$8e4da25483e314e6;
var $376613a1041dbb0b$export$9d4333345ffa4fd6;

var $4TNnu = parcelRequire("4TNnu");

var $ihoyg = parcelRequire("ihoyg");
var $376613a1041dbb0b$require$Buffer = $ihoyg.Buffer;

var $7mvjX = parcelRequire("7mvjX");

var $eSHUL = parcelRequire("eSHUL");

var $9AddZ = parcelRequire("9AddZ");
var $376613a1041dbb0b$var$rStates = $376613a1041dbb0b$export$8e4da25483e314e6 = {
    UNSENT: 0,
    OPENED: 1,
    HEADERS_RECEIVED: 2,
    LOADING: 3,
    DONE: 4
};
var $376613a1041dbb0b$var$IncomingMessage = $376613a1041dbb0b$export$9d4333345ffa4fd6 = function(xhr, response, mode, resetTimers) {
    var self = this;
    $9AddZ.Readable.call(self);
    self._mode = mode;
    self.headers = {};
    self.rawHeaders = [];
    self.trailers = {};
    self.rawTrailers = [];
    // Fake the 'close' event, but only once 'end' fires
    self.on("end", function() {
        // The nextTick is necessary to prevent the 'request' module from causing an infinite loop
        $4TNnu.nextTick(function() {
            self.emit("close");
        });
    });
    if (mode === "fetch") {
        self._fetchResponse = response;
        self.url = response.url;
        self.statusCode = response.status;
        self.statusMessage = response.statusText;
        response.headers.forEach(function(header, key) {
            self.headers[key.toLowerCase()] = header;
            self.rawHeaders.push(key, header);
        });
        if ($7mvjX.writableStream) {
            var writable = new WritableStream({
                write: function(chunk) {
                    resetTimers(false);
                    return new Promise(function(resolve, reject) {
                        if (self._destroyed) reject();
                        else if (self.push($376613a1041dbb0b$require$Buffer.from(chunk))) resolve();
                        else self._resumeFetch = resolve;
                    });
                },
                close: function() {
                    resetTimers(true);
                    if (!self._destroyed) self.push(null);
                },
                abort: function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                }
            });
            try {
                response.body.pipeTo(writable).catch(function(err) {
                    resetTimers(true);
                    if (!self._destroyed) self.emit("error", err);
                });
                return;
            } catch (e) {} // pipeTo method isn't defined. Can't find a better way to feature test this
        }
        // fallback for when writableStream or pipeTo aren't available
        var reader = response.body.getReader();
        function read() {
            reader.read().then(function(result) {
                if (self._destroyed) return;
                resetTimers(result.done);
                if (result.done) {
                    self.push(null);
                    return;
                }
                self.push($376613a1041dbb0b$require$Buffer.from(result.value));
                read();
            }).catch(function(err) {
                resetTimers(true);
                if (!self._destroyed) self.emit("error", err);
            });
        }
        read();
    } else {
        self._xhr = xhr;
        self._pos = 0;
        self.url = xhr.responseURL;
        self.statusCode = xhr.status;
        self.statusMessage = xhr.statusText;
        var headers = xhr.getAllResponseHeaders().split(/\r?\n/);
        headers.forEach(function(header) {
            var matches = header.match(/^([^:]+):\s*(.*)/);
            if (matches) {
                var key = matches[1].toLowerCase();
                if (key === "set-cookie") {
                    if (self.headers[key] === undefined) self.headers[key] = [];
                    self.headers[key].push(matches[2]);
                } else if (self.headers[key] !== undefined) self.headers[key] += ", " + matches[2];
                else self.headers[key] = matches[2];
                self.rawHeaders.push(matches[1], matches[2]);
            }
        });
        self._charset = "x-user-defined";
        if (!$7mvjX.overrideMimeType) {
            var mimeType = self.rawHeaders["mime-type"];
            if (mimeType) {
                var charsetMatch = mimeType.match(/;\s*charset=([^;])(;|$)/);
                if (charsetMatch) self._charset = charsetMatch[1].toLowerCase();
            }
            if (!self._charset) self._charset = "utf-8" // best guess
            ;
        }
    }
};
$eSHUL($376613a1041dbb0b$var$IncomingMessage, $9AddZ.Readable);
$376613a1041dbb0b$var$IncomingMessage.prototype._read = function() {
    var self = this;
    var resolve = self._resumeFetch;
    if (resolve) {
        self._resumeFetch = null;
        resolve();
    }
};
$376613a1041dbb0b$var$IncomingMessage.prototype._onXHRProgress = function(resetTimers) {
    var self = this;
    var xhr = self._xhr;
    var response = null;
    switch(self._mode){
        case "text":
            response = xhr.responseText;
            if (response.length > self._pos) {
                var newData = response.substr(self._pos);
                if (self._charset === "x-user-defined") {
                    var buffer = $376613a1041dbb0b$require$Buffer.alloc(newData.length);
                    for(var i = 0; i < newData.length; i++)buffer[i] = newData.charCodeAt(i) & 0xff;
                    self.push(buffer);
                } else self.push(newData, self._charset);
                self._pos = response.length;
            }
            break;
        case "arraybuffer":
            if (xhr.readyState !== $376613a1041dbb0b$var$rStates.DONE || !xhr.response) break;
            response = xhr.response;
            self.push($376613a1041dbb0b$require$Buffer.from(new Uint8Array(response)));
            break;
        case "moz-chunked-arraybuffer":
            response = xhr.response;
            if (xhr.readyState !== $376613a1041dbb0b$var$rStates.LOADING || !response) break;
            self.push($376613a1041dbb0b$require$Buffer.from(new Uint8Array(response)));
            break;
        case "ms-stream":
            response = xhr.response;
            if (xhr.readyState !== $376613a1041dbb0b$var$rStates.LOADING) break;
            var reader = new $parcel$global.MSStreamReader();
            reader.onprogress = function() {
                if (reader.result.byteLength > self._pos) {
                    self.push($376613a1041dbb0b$require$Buffer.from(new Uint8Array(reader.result.slice(self._pos))));
                    self._pos = reader.result.byteLength;
                }
            };
            reader.onload = function() {
                resetTimers(true);
                self.push(null);
            };
            // reader.onerror = ??? // TODO: this
            reader.readAsArrayBuffer(response);
            break;
    }
    // The ms-stream case handles end separately in reader.onload()
    if (self._xhr.readyState === $376613a1041dbb0b$var$rStates.DONE && self._mode !== "ms-stream") {
        resetTimers(true);
        self.push(null);
    }
};

});


parcelRegister("jrXzS", function(module, exports) {
module.exports = {
    "100": "Continue",
    "101": "Switching Protocols",
    "102": "Processing",
    "200": "OK",
    "201": "Created",
    "202": "Accepted",
    "203": "Non-Authoritative Information",
    "204": "No Content",
    "205": "Reset Content",
    "206": "Partial Content",
    "207": "Multi-Status",
    "208": "Already Reported",
    "226": "IM Used",
    "300": "Multiple Choices",
    "301": "Moved Permanently",
    "302": "Found",
    "303": "See Other",
    "304": "Not Modified",
    "305": "Use Proxy",
    "307": "Temporary Redirect",
    "308": "Permanent Redirect",
    "400": "Bad Request",
    "401": "Unauthorized",
    "402": "Payment Required",
    "403": "Forbidden",
    "404": "Not Found",
    "405": "Method Not Allowed",
    "406": "Not Acceptable",
    "407": "Proxy Authentication Required",
    "408": "Request Timeout",
    "409": "Conflict",
    "410": "Gone",
    "411": "Length Required",
    "412": "Precondition Failed",
    "413": "Payload Too Large",
    "414": "URI Too Long",
    "415": "Unsupported Media Type",
    "416": "Range Not Satisfiable",
    "417": "Expectation Failed",
    "418": "I'm a teapot",
    "421": "Misdirected Request",
    "422": "Unprocessable Entity",
    "423": "Locked",
    "424": "Failed Dependency",
    "425": "Unordered Collection",
    "426": "Upgrade Required",
    "428": "Precondition Required",
    "429": "Too Many Requests",
    "431": "Request Header Fields Too Large",
    "451": "Unavailable For Legal Reasons",
    "500": "Internal Server Error",
    "501": "Not Implemented",
    "502": "Bad Gateway",
    "503": "Service Unavailable",
    "504": "Gateway Timeout",
    "505": "HTTP Version Not Supported",
    "506": "Variant Also Negotiates",
    "507": "Insufficient Storage",
    "508": "Loop Detected",
    "509": "Bandwidth Limit Exceeded",
    "510": "Not Extended",
    "511": "Network Authentication Required"
};

});


parcelRegister("hrxEy", function(module, exports) {

var $3JpYu = parcelRequire("3JpYu");

var $hH01d = parcelRequire("hH01d");
var $cb2f10199216ff2c$var$https = module.exports;
for(var $cb2f10199216ff2c$var$key in $3JpYu)if ($3JpYu.hasOwnProperty($cb2f10199216ff2c$var$key)) $cb2f10199216ff2c$var$https[$cb2f10199216ff2c$var$key] = $3JpYu[$cb2f10199216ff2c$var$key];
$cb2f10199216ff2c$var$https.request = function(params, cb) {
    params = $cb2f10199216ff2c$var$validateParams(params);
    return $3JpYu.request.call(this, params, cb);
};
$cb2f10199216ff2c$var$https.get = function(params, cb) {
    params = $cb2f10199216ff2c$var$validateParams(params);
    return $3JpYu.get.call(this, params, cb);
};
function $cb2f10199216ff2c$var$validateParams(params) {
    if (typeof params === "string") params = $hH01d.parse(params);
    if (!params.protocol) params.protocol = "https:";
    if (params.protocol !== "https:") throw new Error('Protocol "' + params.protocol + '" not supported. Expected "https:"');
    return params;
}

});

parcelRegister("cAzsp", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $92a459e6c28741a7$require$Buffer = $ihoyg.Buffer;

var $bks2w = parcelRequire("bks2w");
var $92a459e6c28741a7$require$Transform = $bks2w.Transform;

var $4giXK = parcelRequire("4giXK");

var $4zyeF = parcelRequire("4zyeF");

var $bhJ7Q = parcelRequire("bhJ7Q");
var $92a459e6c28741a7$require$assert = $bhJ7Q.ok;

var $ihoyg = parcelRequire("ihoyg");
var $92a459e6c28741a7$require$kMaxLength = $ihoyg.kMaxLength;
var $92a459e6c28741a7$var$kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + $92a459e6c28741a7$require$kMaxLength.toString(16) + " bytes";
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$4giXK.Z_MIN_WINDOWBITS = 8;
$4giXK.Z_MAX_WINDOWBITS = 15;
$4giXK.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$4giXK.Z_MIN_CHUNK = 64;
$4giXK.Z_MAX_CHUNK = Infinity;
$4giXK.Z_DEFAULT_CHUNK = 16384;
$4giXK.Z_MIN_MEMLEVEL = 1;
$4giXK.Z_MAX_MEMLEVEL = 9;
$4giXK.Z_DEFAULT_MEMLEVEL = 8;
$4giXK.Z_MIN_LEVEL = -1;
$4giXK.Z_MAX_LEVEL = 9;
$4giXK.Z_DEFAULT_LEVEL = $4giXK.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var $92a459e6c28741a7$var$bkeys = Object.keys($4giXK);
for(var $92a459e6c28741a7$var$bk = 0; $92a459e6c28741a7$var$bk < $92a459e6c28741a7$var$bkeys.length; $92a459e6c28741a7$var$bk++){
    var $92a459e6c28741a7$var$bkey = $92a459e6c28741a7$var$bkeys[$92a459e6c28741a7$var$bk];
    if ($92a459e6c28741a7$var$bkey.match(/^Z/)) Object.defineProperty(module.exports, $92a459e6c28741a7$var$bkey, {
        enumerable: true,
        value: $4giXK[$92a459e6c28741a7$var$bkey],
        writable: false
    });
}
// translation table for return codes.
var $92a459e6c28741a7$var$codes = {
    Z_OK: $4giXK.Z_OK,
    Z_STREAM_END: $4giXK.Z_STREAM_END,
    Z_NEED_DICT: $4giXK.Z_NEED_DICT,
    Z_ERRNO: $4giXK.Z_ERRNO,
    Z_STREAM_ERROR: $4giXK.Z_STREAM_ERROR,
    Z_DATA_ERROR: $4giXK.Z_DATA_ERROR,
    Z_MEM_ERROR: $4giXK.Z_MEM_ERROR,
    Z_BUF_ERROR: $4giXK.Z_BUF_ERROR,
    Z_VERSION_ERROR: $4giXK.Z_VERSION_ERROR
};
var $92a459e6c28741a7$var$ckeys = Object.keys($92a459e6c28741a7$var$codes);
for(var $92a459e6c28741a7$var$ck = 0; $92a459e6c28741a7$var$ck < $92a459e6c28741a7$var$ckeys.length; $92a459e6c28741a7$var$ck++){
    var $92a459e6c28741a7$var$ckey = $92a459e6c28741a7$var$ckeys[$92a459e6c28741a7$var$ck];
    $92a459e6c28741a7$var$codes[$92a459e6c28741a7$var$codes[$92a459e6c28741a7$var$ckey]] = $92a459e6c28741a7$var$ckey;
}
Object.defineProperty(module.exports, "codes", {
    enumerable: true,
    value: Object.freeze($92a459e6c28741a7$var$codes),
    writable: false
});
module.exports.Deflate = $92a459e6c28741a7$var$Deflate;
module.exports.Inflate = $92a459e6c28741a7$var$Inflate;
module.exports.Gzip = $92a459e6c28741a7$var$Gzip;
module.exports.Gunzip = $92a459e6c28741a7$var$Gunzip;
module.exports.DeflateRaw = $92a459e6c28741a7$var$DeflateRaw;
module.exports.InflateRaw = $92a459e6c28741a7$var$InflateRaw;
module.exports.Unzip = $92a459e6c28741a7$var$Unzip;
module.exports.createDeflate = function(o) {
    return new $92a459e6c28741a7$var$Deflate(o);
};
module.exports.createInflate = function(o) {
    return new $92a459e6c28741a7$var$Inflate(o);
};
module.exports.createDeflateRaw = function(o) {
    return new $92a459e6c28741a7$var$DeflateRaw(o);
};
module.exports.createInflateRaw = function(o) {
    return new $92a459e6c28741a7$var$InflateRaw(o);
};
module.exports.createGzip = function(o) {
    return new $92a459e6c28741a7$var$Gzip(o);
};
module.exports.createGunzip = function(o) {
    return new $92a459e6c28741a7$var$Gunzip(o);
};
module.exports.createUnzip = function(o) {
    return new $92a459e6c28741a7$var$Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
module.exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$Deflate(opts), buffer, callback);
};
module.exports.deflateSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$Deflate(opts), buffer);
};
module.exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$Gzip(opts), buffer, callback);
};
module.exports.gzipSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$Gzip(opts), buffer);
};
module.exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$DeflateRaw(opts), buffer, callback);
};
module.exports.deflateRawSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$DeflateRaw(opts), buffer);
};
module.exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$Unzip(opts), buffer, callback);
};
module.exports.unzipSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$Unzip(opts), buffer);
};
module.exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$Inflate(opts), buffer, callback);
};
module.exports.inflateSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$Inflate(opts), buffer);
};
module.exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$Gunzip(opts), buffer, callback);
};
module.exports.gunzipSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$Gunzip(opts), buffer);
};
module.exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === "function") {
        callback = opts;
        opts = {};
    }
    return $92a459e6c28741a7$var$zlibBuffer(new $92a459e6c28741a7$var$InflateRaw(opts), buffer, callback);
};
module.exports.inflateRawSync = function(buffer, opts) {
    return $92a459e6c28741a7$var$zlibBufferSync(new $92a459e6c28741a7$var$InflateRaw(opts), buffer);
};
function $92a459e6c28741a7$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on("error", onError);
    engine.on("end", onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once("readable", flow);
    }
    function onError(err) {
        engine.removeListener("end", onEnd);
        engine.removeListener("readable", flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= $92a459e6c28741a7$require$kMaxLength) err = new RangeError($92a459e6c28741a7$var$kRangeErrorMessage);
        else buf = $92a459e6c28741a7$require$Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function $92a459e6c28741a7$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === "string") buffer = $92a459e6c28741a7$require$Buffer.from(buffer);
    if (!$92a459e6c28741a7$require$Buffer.isBuffer(buffer)) throw new TypeError("Not a string or buffer");
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $92a459e6c28741a7$var$Deflate(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$Deflate)) return new $92a459e6c28741a7$var$Deflate(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.DEFLATE);
}
function $92a459e6c28741a7$var$Inflate(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$Inflate)) return new $92a459e6c28741a7$var$Inflate(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.INFLATE);
}
// gzip - bigger header, same deflate compression
function $92a459e6c28741a7$var$Gzip(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$Gzip)) return new $92a459e6c28741a7$var$Gzip(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.GZIP);
}
function $92a459e6c28741a7$var$Gunzip(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$Gunzip)) return new $92a459e6c28741a7$var$Gunzip(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.GUNZIP);
}
// raw - no header
function $92a459e6c28741a7$var$DeflateRaw(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$DeflateRaw)) return new $92a459e6c28741a7$var$DeflateRaw(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.DEFLATERAW);
}
function $92a459e6c28741a7$var$InflateRaw(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$InflateRaw)) return new $92a459e6c28741a7$var$InflateRaw(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.INFLATERAW);
}
// auto-detect header.
function $92a459e6c28741a7$var$Unzip(opts) {
    if (!(this instanceof $92a459e6c28741a7$var$Unzip)) return new $92a459e6c28741a7$var$Unzip(opts);
    $92a459e6c28741a7$var$Zlib.call(this, opts, $4giXK.UNZIP);
}
function $92a459e6c28741a7$var$isValidFlushFlag(flag) {
    return flag === $4giXK.Z_NO_FLUSH || flag === $4giXK.Z_PARTIAL_FLUSH || flag === $4giXK.Z_SYNC_FLUSH || flag === $4giXK.Z_FULL_FLUSH || flag === $4giXK.Z_FINISH || flag === $4giXK.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $92a459e6c28741a7$var$Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || module.exports.Z_DEFAULT_CHUNK;
    $92a459e6c28741a7$require$Transform.call(this, opts);
    if (opts.flush && !$92a459e6c28741a7$var$isValidFlushFlag(opts.flush)) throw new Error("Invalid flush flag: " + opts.flush);
    if (opts.finishFlush && !$92a459e6c28741a7$var$isValidFlushFlag(opts.finishFlush)) throw new Error("Invalid flush flag: " + opts.finishFlush);
    this._flushFlag = opts.flush || $4giXK.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== "undefined" ? opts.finishFlush : $4giXK.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < module.exports.Z_MIN_CHUNK || opts.chunkSize > module.exports.Z_MAX_CHUNK) throw new Error("Invalid chunk size: " + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < module.exports.Z_MIN_WINDOWBITS || opts.windowBits > module.exports.Z_MAX_WINDOWBITS) throw new Error("Invalid windowBits: " + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < module.exports.Z_MIN_LEVEL || opts.level > module.exports.Z_MAX_LEVEL) throw new Error("Invalid compression level: " + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < module.exports.Z_MIN_MEMLEVEL || opts.memLevel > module.exports.Z_MAX_MEMLEVEL) throw new Error("Invalid memLevel: " + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != module.exports.Z_FILTERED && opts.strategy != module.exports.Z_HUFFMAN_ONLY && opts.strategy != module.exports.Z_RLE && opts.strategy != module.exports.Z_FIXED && opts.strategy != module.exports.Z_DEFAULT_STRATEGY) throw new Error("Invalid strategy: " + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$92a459e6c28741a7$require$Buffer.isBuffer(opts.dictionary)) throw new Error("Invalid dictionary: it should be a Buffer instance");
    }
    this._handle = new $4giXK.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        $92a459e6c28741a7$var$_close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = module.exports.codes[errno];
        self.emit("error", error);
    };
    var level = module.exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === "number") level = opts.level;
    var strategy = module.exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === "number") strategy = opts.strategy;
    this._handle.init(opts.windowBits || module.exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || module.exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = $92a459e6c28741a7$require$Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once("end", this.close);
    Object.defineProperty(this, "_closed", {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
$4zyeF.inherits($92a459e6c28741a7$var$Zlib, $92a459e6c28741a7$require$Transform);
$92a459e6c28741a7$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < module.exports.Z_MIN_LEVEL || level > module.exports.Z_MAX_LEVEL) throw new RangeError("Invalid compression level: " + level);
    if (strategy != module.exports.Z_FILTERED && strategy != module.exports.Z_HUFFMAN_ONLY && strategy != module.exports.Z_RLE && strategy != module.exports.Z_FIXED && strategy != module.exports.Z_DEFAULT_STRATEGY) throw new TypeError("Invalid strategy: " + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush($4giXK.Z_SYNC_FLUSH, function() {
            $92a459e6c28741a7$require$assert(self._handle, "zlib binding closed");
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $4TNnu.nextTick(callback);
};
$92a459e6c28741a7$var$Zlib.prototype.reset = function() {
    $92a459e6c28741a7$require$assert(this._handle, "zlib binding closed");
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$92a459e6c28741a7$var$Zlib.prototype._flush = function(callback) {
    this._transform($92a459e6c28741a7$require$Buffer.alloc(0), "", callback);
};
$92a459e6c28741a7$var$Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === "function" || kind === undefined && !callback) {
        callback = kind;
        kind = $4giXK.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $4TNnu.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once("end", callback);
    } else if (ws.needDrain) {
        if (callback) this.once("drain", function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write($92a459e6c28741a7$require$Buffer.alloc(0), "", callback);
    }
};
$92a459e6c28741a7$var$Zlib.prototype.close = function(callback) {
    $92a459e6c28741a7$var$_close(this, callback);
    $4TNnu.nextTick($92a459e6c28741a7$var$emitCloseNT, this);
};
function $92a459e6c28741a7$var$_close(engine, callback) {
    if (callback) $4TNnu.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function $92a459e6c28741a7$var$emitCloseNT(self) {
    self.emit("close");
}
$92a459e6c28741a7$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !$92a459e6c28741a7$require$Buffer.isBuffer(chunk)) return cb(new Error("invalid input"));
    if (!this._handle) return cb(new Error("zlib binding closed"));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $4giXK.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$92a459e6c28741a7$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === "function";
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on("error", function(er) {
            error = er;
        });
        $92a459e6c28741a7$require$assert(this._handle, "zlib binding closed");
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= $92a459e6c28741a7$require$kMaxLength) {
            $92a459e6c28741a7$var$_close(this);
            throw new RangeError($92a459e6c28741a7$var$kRangeErrorMessage);
        }
        var buf = $92a459e6c28741a7$require$Buffer.concat(buffers, nread);
        $92a459e6c28741a7$var$_close(this);
        return buf;
    }
    $92a459e6c28741a7$require$assert(this._handle, "zlib binding closed");
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $92a459e6c28741a7$require$assert(have >= 0, "have should not go down");
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $92a459e6c28741a7$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$4zyeF.inherits($92a459e6c28741a7$var$Deflate, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$Inflate, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$Gzip, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$Gunzip, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$DeflateRaw, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$InflateRaw, $92a459e6c28741a7$var$Zlib);
$4zyeF.inherits($92a459e6c28741a7$var$Unzip, $92a459e6c28741a7$var$Zlib);

});
parcelRegister("4giXK", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $31a75da9a1147361$require$Buffer = $ihoyg.Buffer;

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $bhJ7Q = parcelRequire("bhJ7Q");

var $fUApU = parcelRequire("fUApU");

var $fRJEp = parcelRequire("fRJEp");

var $ccqNh = parcelRequire("ccqNh");

var $bManr = parcelRequire("bManr");
for(var $31a75da9a1147361$var$key in $bManr)module.exports[$31a75da9a1147361$var$key] = $bManr[$31a75da9a1147361$var$key];
// zlib modes
module.exports.NONE = 0;
module.exports.DEFLATE = 1;
module.exports.INFLATE = 2;
module.exports.GZIP = 3;
module.exports.GUNZIP = 4;
module.exports.DEFLATERAW = 5;
module.exports.INFLATERAW = 6;
module.exports.UNZIP = 7;
var $31a75da9a1147361$var$GZIP_HEADER_ID1 = 0x1f;
var $31a75da9a1147361$var$GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function $31a75da9a1147361$var$Zlib(mode) {
    if (typeof mode !== "number" || mode < module.exports.DEFLATE || mode > module.exports.UNZIP) throw new TypeError("Bad argument");
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
$31a75da9a1147361$var$Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    $bhJ7Q(this.init_done, "close before init");
    $bhJ7Q(this.mode <= module.exports.UNZIP);
    if (this.mode === module.exports.DEFLATE || this.mode === module.exports.GZIP || this.mode === module.exports.DEFLATERAW) $fRJEp.deflateEnd(this.strm);
    else if (this.mode === module.exports.INFLATE || this.mode === module.exports.GUNZIP || this.mode === module.exports.INFLATERAW || this.mode === module.exports.UNZIP) $ccqNh.inflateEnd(this.strm);
    this.mode = module.exports.NONE;
    this.dictionary = null;
};
$31a75da9a1147361$var$Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
$31a75da9a1147361$var$Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
$31a75da9a1147361$var$Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    $bhJ7Q.equal(arguments.length, 8);
    $bhJ7Q(this.init_done, "write before init");
    $bhJ7Q(this.mode !== module.exports.NONE, "already finalized");
    $bhJ7Q.equal(false, this.write_in_progress, "write already in progress");
    $bhJ7Q.equal(false, this.pending_close, "close is pending");
    this.write_in_progress = true;
    $bhJ7Q.equal(false, flush === undefined, "must provide flush value");
    this.write_in_progress = true;
    if (flush !== module.exports.Z_NO_FLUSH && flush !== module.exports.Z_PARTIAL_FLUSH && flush !== module.exports.Z_SYNC_FLUSH && flush !== module.exports.Z_FULL_FLUSH && flush !== module.exports.Z_FINISH && flush !== module.exports.Z_BLOCK) throw new Error("Invalid flush value");
    if (input == null) {
        input = $31a75da9a1147361$require$Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    $4TNnu.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
$31a75da9a1147361$var$Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
$31a75da9a1147361$var$Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $fRJEp.deflate(this.strm, this.flush);
            break;
        case module.exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $31a75da9a1147361$var$GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = module.exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $31a75da9a1147361$var$GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = module.exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = module.exports.INFLATE;
                    break;
                default:
                    throw new Error("invalid number of gzip magic number bytes read");
            }
        // fallthrough
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
            this.err = $ccqNh.inflate(this.strm, this.flush);
            if (this.err === module.exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = $ccqNh.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === module.exports.Z_OK) // And try to decode again
                this.err = $ccqNh.inflate(this.strm, this.flush);
                else if (this.err === module.exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = module.exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === module.exports.GUNZIP && this.err === module.exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = $ccqNh.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
};
$31a75da9a1147361$var$Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case module.exports.Z_OK:
        case module.exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === module.exports.Z_FINISH) {
                this._error("unexpected end of file");
                return false;
            }
            break;
        case module.exports.Z_STREAM_END:
            break;
        case module.exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error("Missing dictionary");
            else this._error("Bad dictionary");
            return false;
        default:
            // something else.
            this._error("Zlib error");
            return false;
    }
    return true;
};
$31a75da9a1147361$var$Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
$31a75da9a1147361$var$Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
$31a75da9a1147361$var$Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    $bhJ7Q(arguments.length === 4 || arguments.length === 5, "init(windowBits, level, memLevel, strategy, [dictionary])");
    $bhJ7Q(windowBits >= 8 && windowBits <= 15, "invalid windowBits");
    $bhJ7Q(level >= -1 && level <= 9, "invalid compression level");
    $bhJ7Q(memLevel >= 1 && memLevel <= 9, "invalid memlevel");
    $bhJ7Q(strategy === module.exports.Z_FILTERED || strategy === module.exports.Z_HUFFMAN_ONLY || strategy === module.exports.Z_RLE || strategy === module.exports.Z_FIXED || strategy === module.exports.Z_DEFAULT_STRATEGY, "invalid strategy");
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
$31a75da9a1147361$var$Zlib.prototype.params = function() {
    throw new Error("deflateParams Not supported");
};
$31a75da9a1147361$var$Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
$31a75da9a1147361$var$Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = module.exports.Z_NO_FLUSH;
    this.err = module.exports.Z_OK;
    if (this.mode === module.exports.GZIP || this.mode === module.exports.GUNZIP) this.windowBits += 16;
    if (this.mode === module.exports.UNZIP) this.windowBits += 32;
    if (this.mode === module.exports.DEFLATERAW || this.mode === module.exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new $fUApU();
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $fRJEp.deflateInit2(this.strm, this.level, module.exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
        case module.exports.UNZIP:
            this.err = $ccqNh.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error("Unknown mode " + this.mode);
    }
    if (this.err !== module.exports.Z_OK) this._error("Init error");
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
$31a75da9a1147361$var$Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
            this.err = $fRJEp.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error("Failed to set dictionary");
};
$31a75da9a1147361$var$Zlib.prototype._reset = function() {
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
        case module.exports.GZIP:
            this.err = $fRJEp.deflateReset(this.strm);
            break;
        case module.exports.INFLATE:
        case module.exports.INFLATERAW:
        case module.exports.GUNZIP:
            this.err = $ccqNh.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error("Failed to reset stream");
};
module.exports.Zlib = $31a75da9a1147361$var$Zlib;

});
parcelRegister("fUApU", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $b95855a11842e5ab$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = "" /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $b95855a11842e5ab$var$ZStream;

});

parcelRegister("fRJEp", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $b8cf378babf7a1a0$export$a65c7b2bde87cb70; }, function (v) { return $b8cf378babf7a1a0$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateReset", function () { return $b8cf378babf7a1a0$export$8f99f0e30bc7dd53; }, function (v) { return $b8cf378babf7a1a0$export$8f99f0e30bc7dd53 = v; });
$parcel$export(module.exports, "deflate", function () { return $b8cf378babf7a1a0$export$2316623ecd1285ab; }, function (v) { return $b8cf378babf7a1a0$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $b8cf378babf7a1a0$export$599854fa319a815f; }, function (v) { return $b8cf378babf7a1a0$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $b8cf378babf7a1a0$export$f55e0b3ab66b5d46; }, function (v) { return $b8cf378babf7a1a0$export$f55e0b3ab66b5d46 = v; });
var $b8cf378babf7a1a0$export$72b35d618fb8ad9b;
var $b8cf378babf7a1a0$export$a65c7b2bde87cb70;
var $b8cf378babf7a1a0$export$8f99f0e30bc7dd53;
var $b8cf378babf7a1a0$export$e78fab288549509;
var $b8cf378babf7a1a0$export$1cd50f7b2515ba19;
var $b8cf378babf7a1a0$export$2316623ecd1285ab;
var $b8cf378babf7a1a0$export$599854fa319a815f;
var $b8cf378babf7a1a0$export$f55e0b3ab66b5d46;
var $b8cf378babf7a1a0$export$12b6e1fcadea22f9;
"use strict";

var $1GjYS = parcelRequire("1GjYS");

var $fkxto = parcelRequire("fkxto");

var $jgTtM = parcelRequire("jgTtM");

var $laWcq = parcelRequire("laWcq");

var $2wNWS = parcelRequire("2wNWS");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $b8cf378babf7a1a0$var$Z_NO_FLUSH = 0;
var $b8cf378babf7a1a0$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $b8cf378babf7a1a0$var$Z_FULL_FLUSH = 3;
var $b8cf378babf7a1a0$var$Z_FINISH = 4;
var $b8cf378babf7a1a0$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $b8cf378babf7a1a0$var$Z_OK = 0;
var $b8cf378babf7a1a0$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $b8cf378babf7a1a0$var$Z_STREAM_ERROR = -2;
var $b8cf378babf7a1a0$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $b8cf378babf7a1a0$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $b8cf378babf7a1a0$var$Z_DEFAULT_COMPRESSION = -1;
var $b8cf378babf7a1a0$var$Z_FILTERED = 1;
var $b8cf378babf7a1a0$var$Z_HUFFMAN_ONLY = 2;
var $b8cf378babf7a1a0$var$Z_RLE = 3;
var $b8cf378babf7a1a0$var$Z_FIXED = 4;
var $b8cf378babf7a1a0$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $b8cf378babf7a1a0$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $b8cf378babf7a1a0$var$Z_DEFLATED = 8;
/*============================================================================*/ var $b8cf378babf7a1a0$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $b8cf378babf7a1a0$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $b8cf378babf7a1a0$var$DEF_MEM_LEVEL = 8;
var $b8cf378babf7a1a0$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $b8cf378babf7a1a0$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $b8cf378babf7a1a0$var$L_CODES = $b8cf378babf7a1a0$var$LITERALS + 1 + $b8cf378babf7a1a0$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $b8cf378babf7a1a0$var$D_CODES = 30;
/* number of distance codes */ var $b8cf378babf7a1a0$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $b8cf378babf7a1a0$var$HEAP_SIZE = 2 * $b8cf378babf7a1a0$var$L_CODES + 1;
/* maximum heap size */ var $b8cf378babf7a1a0$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $b8cf378babf7a1a0$var$MIN_MATCH = 3;
var $b8cf378babf7a1a0$var$MAX_MATCH = 258;
var $b8cf378babf7a1a0$var$MIN_LOOKAHEAD = $b8cf378babf7a1a0$var$MAX_MATCH + $b8cf378babf7a1a0$var$MIN_MATCH + 1;
var $b8cf378babf7a1a0$var$PRESET_DICT = 0x20;
var $b8cf378babf7a1a0$var$INIT_STATE = 42;
var $b8cf378babf7a1a0$var$EXTRA_STATE = 69;
var $b8cf378babf7a1a0$var$NAME_STATE = 73;
var $b8cf378babf7a1a0$var$COMMENT_STATE = 91;
var $b8cf378babf7a1a0$var$HCRC_STATE = 103;
var $b8cf378babf7a1a0$var$BUSY_STATE = 113;
var $b8cf378babf7a1a0$var$FINISH_STATE = 666;
var $b8cf378babf7a1a0$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $b8cf378babf7a1a0$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $b8cf378babf7a1a0$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $b8cf378babf7a1a0$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $b8cf378babf7a1a0$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $b8cf378babf7a1a0$var$err(strm, errorCode) {
    strm.msg = $2wNWS[errorCode];
    return errorCode;
}
function $b8cf378babf7a1a0$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $b8cf378babf7a1a0$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $b8cf378babf7a1a0$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $1GjYS.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $b8cf378babf7a1a0$var$flush_block_only(s, last) {
    $fkxto._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $b8cf378babf7a1a0$var$flush_pending(s.strm);
}
function $b8cf378babf7a1a0$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $b8cf378babf7a1a0$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $b8cf378babf7a1a0$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $1GjYS.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $jgTtM(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $laWcq(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $b8cf378babf7a1a0$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $b8cf378babf7a1a0$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $b8cf378babf7a1a0$var$MAX_MATCH - (strend - scan);
        scan = strend - $b8cf378babf7a1a0$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $b8cf378babf7a1a0$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD)) {
            $1GjYS.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $b8cf378babf7a1a0$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $b8cf378babf7a1a0$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $b8cf378babf7a1a0$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $b8cf378babf7a1a0$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $b8cf378babf7a1a0$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $b8cf378babf7a1a0$var$fill_window(s);
            if (s.lookahead === 0 && flush === $b8cf378babf7a1a0$var$Z_NO_FLUSH) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $b8cf378babf7a1a0$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_FINISH_STARTED;
        /***/ return $b8cf378babf7a1a0$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
    /***/ }
    return $b8cf378babf7a1a0$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $b8cf378babf7a1a0$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) {
            $b8cf378babf7a1a0$var$fill_window(s);
            if (s.lookahead < $b8cf378babf7a1a0$var$MIN_LOOKAHEAD && flush === $b8cf378babf7a1a0$var$Z_NO_FLUSH) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $b8cf378babf7a1a0$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $b8cf378babf7a1a0$var$longest_match(s, hash_head);
        if (s.match_length >= $b8cf378babf7a1a0$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $fkxto._tr_tally(s, s.strstart - s.match_start, s.match_length - $b8cf378babf7a1a0$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $b8cf378babf7a1a0$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fkxto._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $b8cf378babf7a1a0$var$MIN_MATCH - 1 ? s.strstart : $b8cf378babf7a1a0$var$MIN_MATCH - 1;
    if (flush === $b8cf378babf7a1a0$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_FINISH_STARTED;
        /***/ return $b8cf378babf7a1a0$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
    /***/ }
    return $b8cf378babf7a1a0$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $b8cf378babf7a1a0$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) {
            $b8cf378babf7a1a0$var$fill_window(s);
            if (s.lookahead < $b8cf378babf7a1a0$var$MIN_LOOKAHEAD && flush === $b8cf378babf7a1a0$var$Z_NO_FLUSH) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $b8cf378babf7a1a0$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $b8cf378babf7a1a0$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $b8cf378babf7a1a0$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $b8cf378babf7a1a0$var$Z_FILTERED || s.match_length === $b8cf378babf7a1a0$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $b8cf378babf7a1a0$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $b8cf378babf7a1a0$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $fkxto._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $b8cf378babf7a1a0$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $fkxto._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $fkxto._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $b8cf378babf7a1a0$var$MIN_MATCH - 1 ? s.strstart : $b8cf378babf7a1a0$var$MIN_MATCH - 1;
    if (flush === $b8cf378babf7a1a0$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_FINISH_STARTED;
        /***/ return $b8cf378babf7a1a0$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
    /***/ }
    return $b8cf378babf7a1a0$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $b8cf378babf7a1a0$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $b8cf378babf7a1a0$var$MAX_MATCH) {
            $b8cf378babf7a1a0$var$fill_window(s);
            if (s.lookahead <= $b8cf378babf7a1a0$var$MAX_MATCH && flush === $b8cf378babf7a1a0$var$Z_NO_FLUSH) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $b8cf378babf7a1a0$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $b8cf378babf7a1a0$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $b8cf378babf7a1a0$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $b8cf378babf7a1a0$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $fkxto._tr_tally(s, 1, s.match_length - $b8cf378babf7a1a0$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fkxto._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $b8cf378babf7a1a0$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_FINISH_STARTED;
        /***/ return $b8cf378babf7a1a0$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
    /***/ }
    return $b8cf378babf7a1a0$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $b8cf378babf7a1a0$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $b8cf378babf7a1a0$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $b8cf378babf7a1a0$var$Z_NO_FLUSH) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $fkxto._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $b8cf378babf7a1a0$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_FINISH_STARTED;
        /***/ return $b8cf378babf7a1a0$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $b8cf378babf7a1a0$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $b8cf378babf7a1a0$var$BS_NEED_MORE;
    /***/ }
    return $b8cf378babf7a1a0$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $b8cf378babf7a1a0$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $b8cf378babf7a1a0$var$configuration_table;
$b8cf378babf7a1a0$var$configuration_table = [
    /*      good lazy nice chain */ new $b8cf378babf7a1a0$var$Config(0, 0, 0, 0, $b8cf378babf7a1a0$var$deflate_stored),
    /* 0 store only */ new $b8cf378babf7a1a0$var$Config(4, 4, 8, 4, $b8cf378babf7a1a0$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $b8cf378babf7a1a0$var$Config(4, 5, 16, 8, $b8cf378babf7a1a0$var$deflate_fast),
    /* 2 */ new $b8cf378babf7a1a0$var$Config(4, 6, 32, 32, $b8cf378babf7a1a0$var$deflate_fast),
    /* 3 */ new $b8cf378babf7a1a0$var$Config(4, 4, 16, 16, $b8cf378babf7a1a0$var$deflate_slow),
    /* 4 lazy matches */ new $b8cf378babf7a1a0$var$Config(8, 16, 32, 32, $b8cf378babf7a1a0$var$deflate_slow),
    /* 5 */ new $b8cf378babf7a1a0$var$Config(8, 16, 128, 128, $b8cf378babf7a1a0$var$deflate_slow),
    /* 6 */ new $b8cf378babf7a1a0$var$Config(8, 32, 128, 256, $b8cf378babf7a1a0$var$deflate_slow),
    /* 7 */ new $b8cf378babf7a1a0$var$Config(32, 128, 258, 1024, $b8cf378babf7a1a0$var$deflate_slow),
    /* 8 */ new $b8cf378babf7a1a0$var$Config(32, 258, 258, 4096, $b8cf378babf7a1a0$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $b8cf378babf7a1a0$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $b8cf378babf7a1a0$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $b8cf378babf7a1a0$var$configuration_table[s.level].max_lazy;
    s.good_match = $b8cf378babf7a1a0$var$configuration_table[s.level].good_length;
    s.nice_match = $b8cf378babf7a1a0$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $b8cf378babf7a1a0$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $b8cf378babf7a1a0$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $b8cf378babf7a1a0$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $1GjYS.Buf16($b8cf378babf7a1a0$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $1GjYS.Buf16((2 * $b8cf378babf7a1a0$var$D_CODES + 1) * 2);
    this.bl_tree = new $1GjYS.Buf16((2 * $b8cf378babf7a1a0$var$BL_CODES + 1) * 2);
    $b8cf378babf7a1a0$var$zero(this.dyn_ltree);
    $b8cf378babf7a1a0$var$zero(this.dyn_dtree);
    $b8cf378babf7a1a0$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $1GjYS.Buf16($b8cf378babf7a1a0$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $1GjYS.Buf16(2 * $b8cf378babf7a1a0$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $b8cf378babf7a1a0$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $1GjYS.Buf16(2 * $b8cf378babf7a1a0$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $b8cf378babf7a1a0$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $b8cf378babf7a1a0$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $b8cf378babf7a1a0$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $b8cf378babf7a1a0$var$INIT_STATE : $b8cf378babf7a1a0$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $b8cf378babf7a1a0$var$Z_NO_FLUSH;
    $fkxto._tr_init(s);
    return $b8cf378babf7a1a0$var$Z_OK;
}
function $b8cf378babf7a1a0$var$deflateReset(strm) {
    var ret = $b8cf378babf7a1a0$var$deflateResetKeep(strm);
    if (ret === $b8cf378babf7a1a0$var$Z_OK) $b8cf378babf7a1a0$var$lm_init(strm.state);
    return ret;
}
function $b8cf378babf7a1a0$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $b8cf378babf7a1a0$var$Z_OK;
}
function $b8cf378babf7a1a0$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $b8cf378babf7a1a0$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $b8cf378babf7a1a0$var$MAX_MEM_LEVEL || method !== $b8cf378babf7a1a0$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $b8cf378babf7a1a0$var$Z_FIXED) return $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $b8cf378babf7a1a0$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $b8cf378babf7a1a0$var$MIN_MATCH - 1) / $b8cf378babf7a1a0$var$MIN_MATCH);
    s.window = new $1GjYS.Buf8(s.w_size * 2);
    s.head = new $1GjYS.Buf16(s.hash_size);
    s.prev = new $1GjYS.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $1GjYS.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $b8cf378babf7a1a0$var$deflateReset(strm);
}
function $b8cf378babf7a1a0$var$deflateInit(strm, level) {
    return $b8cf378babf7a1a0$var$deflateInit2(strm, level, $b8cf378babf7a1a0$var$Z_DEFLATED, $b8cf378babf7a1a0$var$MAX_WBITS, $b8cf378babf7a1a0$var$DEF_MEM_LEVEL, $b8cf378babf7a1a0$var$Z_DEFAULT_STRATEGY);
}
function $b8cf378babf7a1a0$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $b8cf378babf7a1a0$var$Z_BLOCK || flush < 0) return strm ? $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_STREAM_ERROR) : $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $b8cf378babf7a1a0$var$FINISH_STATE && flush !== $b8cf378babf7a1a0$var$Z_FINISH) return $b8cf378babf7a1a0$var$err(strm, strm.avail_out === 0 ? $b8cf378babf7a1a0$var$Z_BUF_ERROR : $b8cf378babf7a1a0$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $b8cf378babf7a1a0$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $b8cf378babf7a1a0$var$put_byte(s, 31);
            $b8cf378babf7a1a0$var$put_byte(s, 139);
            $b8cf378babf7a1a0$var$put_byte(s, 8);
            if (!s.gzhead) {
                $b8cf378babf7a1a0$var$put_byte(s, 0);
                $b8cf378babf7a1a0$var$put_byte(s, 0);
                $b8cf378babf7a1a0$var$put_byte(s, 0);
                $b8cf378babf7a1a0$var$put_byte(s, 0);
                $b8cf378babf7a1a0$var$put_byte(s, 0);
                $b8cf378babf7a1a0$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $b8cf378babf7a1a0$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $b8cf378babf7a1a0$var$put_byte(s, $b8cf378babf7a1a0$var$OS_CODE);
                s.status = $b8cf378babf7a1a0$var$BUSY_STATE;
            } else {
                $b8cf378babf7a1a0$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.time & 0xff);
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $b8cf378babf7a1a0$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $b8cf378babf7a1a0$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $b8cf378babf7a1a0$var$EXTRA_STATE;
            }
        } else {
            var header = $b8cf378babf7a1a0$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $b8cf378babf7a1a0$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $b8cf378babf7a1a0$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $b8cf378babf7a1a0$var$BUSY_STATE;
            $b8cf378babf7a1a0$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $b8cf378babf7a1a0$var$putShortMSB(s, strm.adler >>> 16);
                $b8cf378babf7a1a0$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $b8cf378babf7a1a0$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $b8cf378babf7a1a0$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $b8cf378babf7a1a0$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $b8cf378babf7a1a0$var$NAME_STATE;
            }
        } else s.status = $b8cf378babf7a1a0$var$NAME_STATE;
    }
    if (s.status === $b8cf378babf7a1a0$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $b8cf378babf7a1a0$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $b8cf378babf7a1a0$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $b8cf378babf7a1a0$var$COMMENT_STATE;
            }
        } else s.status = $b8cf378babf7a1a0$var$COMMENT_STATE;
    }
    if (s.status === $b8cf378babf7a1a0$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $b8cf378babf7a1a0$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $b8cf378babf7a1a0$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $laWcq(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $b8cf378babf7a1a0$var$HCRC_STATE;
        } else s.status = $b8cf378babf7a1a0$var$HCRC_STATE;
    }
    if (s.status === $b8cf378babf7a1a0$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $b8cf378babf7a1a0$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $b8cf378babf7a1a0$var$put_byte(s, strm.adler & 0xff);
                $b8cf378babf7a1a0$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $b8cf378babf7a1a0$var$BUSY_STATE;
            }
        } else s.status = $b8cf378babf7a1a0$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $b8cf378babf7a1a0$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $b8cf378babf7a1a0$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $b8cf378babf7a1a0$var$rank(flush) <= $b8cf378babf7a1a0$var$rank(old_flush) && flush !== $b8cf378babf7a1a0$var$Z_FINISH) return $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $b8cf378babf7a1a0$var$FINISH_STATE && strm.avail_in !== 0) return $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $b8cf378babf7a1a0$var$Z_NO_FLUSH && s.status !== $b8cf378babf7a1a0$var$FINISH_STATE) {
        var bstate = s.strategy === $b8cf378babf7a1a0$var$Z_HUFFMAN_ONLY ? $b8cf378babf7a1a0$var$deflate_huff(s, flush) : s.strategy === $b8cf378babf7a1a0$var$Z_RLE ? $b8cf378babf7a1a0$var$deflate_rle(s, flush) : $b8cf378babf7a1a0$var$configuration_table[s.level].func(s, flush);
        if (bstate === $b8cf378babf7a1a0$var$BS_FINISH_STARTED || bstate === $b8cf378babf7a1a0$var$BS_FINISH_DONE) s.status = $b8cf378babf7a1a0$var$FINISH_STATE;
        if (bstate === $b8cf378babf7a1a0$var$BS_NEED_MORE || bstate === $b8cf378babf7a1a0$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $b8cf378babf7a1a0$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $b8cf378babf7a1a0$var$BS_BLOCK_DONE) {
            if (flush === $b8cf378babf7a1a0$var$Z_PARTIAL_FLUSH) $fkxto._tr_align(s);
            else if (flush !== $b8cf378babf7a1a0$var$Z_BLOCK) {
                $fkxto._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $b8cf378babf7a1a0$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $b8cf378babf7a1a0$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $b8cf378babf7a1a0$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $b8cf378babf7a1a0$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $b8cf378babf7a1a0$var$Z_FINISH) return $b8cf378babf7a1a0$var$Z_OK;
    if (s.wrap <= 0) return $b8cf378babf7a1a0$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $b8cf378babf7a1a0$var$put_byte(s, strm.adler & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.adler >> 8 & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.adler >> 16 & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.adler >> 24 & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.total_in & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $b8cf378babf7a1a0$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $b8cf378babf7a1a0$var$putShortMSB(s, strm.adler >>> 16);
        $b8cf378babf7a1a0$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $b8cf378babf7a1a0$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $b8cf378babf7a1a0$var$Z_OK : $b8cf378babf7a1a0$var$Z_STREAM_END;
}
function $b8cf378babf7a1a0$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $b8cf378babf7a1a0$var$INIT_STATE && status !== $b8cf378babf7a1a0$var$EXTRA_STATE && status !== $b8cf378babf7a1a0$var$NAME_STATE && status !== $b8cf378babf7a1a0$var$COMMENT_STATE && status !== $b8cf378babf7a1a0$var$HCRC_STATE && status !== $b8cf378babf7a1a0$var$BUSY_STATE && status !== $b8cf378babf7a1a0$var$FINISH_STATE) return $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $b8cf378babf7a1a0$var$BUSY_STATE ? $b8cf378babf7a1a0$var$err(strm, $b8cf378babf7a1a0$var$Z_DATA_ERROR) : $b8cf378babf7a1a0$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $b8cf378babf7a1a0$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $b8cf378babf7a1a0$var$INIT_STATE || s.lookahead) return $b8cf378babf7a1a0$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $jgTtM(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $b8cf378babf7a1a0$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $1GjYS.Buf8(s.w_size);
        $1GjYS.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $b8cf378babf7a1a0$var$fill_window(s);
    while(s.lookahead >= $b8cf378babf7a1a0$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($b8cf378babf7a1a0$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $b8cf378babf7a1a0$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
        $b8cf378babf7a1a0$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $b8cf378babf7a1a0$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $b8cf378babf7a1a0$var$Z_OK;
}
$b8cf378babf7a1a0$export$72b35d618fb8ad9b = $b8cf378babf7a1a0$var$deflateInit;
$b8cf378babf7a1a0$export$a65c7b2bde87cb70 = $b8cf378babf7a1a0$var$deflateInit2;
$b8cf378babf7a1a0$export$8f99f0e30bc7dd53 = $b8cf378babf7a1a0$var$deflateReset;
$b8cf378babf7a1a0$export$e78fab288549509 = $b8cf378babf7a1a0$var$deflateResetKeep;
$b8cf378babf7a1a0$export$1cd50f7b2515ba19 = $b8cf378babf7a1a0$var$deflateSetHeader;
$b8cf378babf7a1a0$export$2316623ecd1285ab = $b8cf378babf7a1a0$var$deflate;
$b8cf378babf7a1a0$export$599854fa319a815f = $b8cf378babf7a1a0$var$deflateEnd;
$b8cf378babf7a1a0$export$f55e0b3ab66b5d46 = $b8cf378babf7a1a0$var$deflateSetDictionary;
$b8cf378babf7a1a0$export$12b6e1fcadea22f9 = "pako deflate (from Nodeca project)"; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("1GjYS", function(module, exports) {
"use strict";
var $1399367af11cec6a$var$TYPED_OK = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Int32Array !== "undefined";
function $1399367af11cec6a$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== "object") throw new TypeError(source + "must be non-object");
        for(var p in source)if ($1399367af11cec6a$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $1399367af11cec6a$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $1399367af11cec6a$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $1399367af11cec6a$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $1399367af11cec6a$var$fnUntyped);
    }
};
module.exports.setTyped($1399367af11cec6a$var$TYPED_OK);

});

parcelRegister("fkxto", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $b292b058cfdfb330$export$4e4fc0157c3cd14d; }, function (v) { return $b292b058cfdfb330$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $b292b058cfdfb330$export$8959e34c5e020172; }, function (v) { return $b292b058cfdfb330$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $b292b058cfdfb330$export$44f15b52eef0cf41; }, function (v) { return $b292b058cfdfb330$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $b292b058cfdfb330$export$b3cbce147289408f; }, function (v) { return $b292b058cfdfb330$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $b292b058cfdfb330$export$bfb360e02ee9b403; }, function (v) { return $b292b058cfdfb330$export$bfb360e02ee9b403 = v; });
var $b292b058cfdfb330$export$4e4fc0157c3cd14d;
var $b292b058cfdfb330$export$8959e34c5e020172;
var $b292b058cfdfb330$export$44f15b52eef0cf41;
var $b292b058cfdfb330$export$b3cbce147289408f;
var $b292b058cfdfb330$export$bfb360e02ee9b403;
"use strict";

var $1GjYS = parcelRequire("1GjYS");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $b292b058cfdfb330$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $b292b058cfdfb330$var$Z_BINARY = 0;
var $b292b058cfdfb330$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $b292b058cfdfb330$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $b292b058cfdfb330$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $b292b058cfdfb330$var$STORED_BLOCK = 0;
var $b292b058cfdfb330$var$STATIC_TREES = 1;
var $b292b058cfdfb330$var$DYN_TREES = 2;
/* The three kinds of block type */ var $b292b058cfdfb330$var$MIN_MATCH = 3;
var $b292b058cfdfb330$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $b292b058cfdfb330$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $b292b058cfdfb330$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $b292b058cfdfb330$var$L_CODES = $b292b058cfdfb330$var$LITERALS + 1 + $b292b058cfdfb330$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $b292b058cfdfb330$var$D_CODES = 30;
/* number of distance codes */ var $b292b058cfdfb330$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $b292b058cfdfb330$var$HEAP_SIZE = 2 * $b292b058cfdfb330$var$L_CODES + 1;
/* maximum heap size */ var $b292b058cfdfb330$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $b292b058cfdfb330$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $b292b058cfdfb330$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $b292b058cfdfb330$var$END_BLOCK = 256;
/* end of block literal code */ var $b292b058cfdfb330$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $b292b058cfdfb330$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $b292b058cfdfb330$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $b292b058cfdfb330$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $b292b058cfdfb330$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $b292b058cfdfb330$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $b292b058cfdfb330$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $b292b058cfdfb330$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $b292b058cfdfb330$var$static_ltree = new Array(($b292b058cfdfb330$var$L_CODES + 2) * 2);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $b292b058cfdfb330$var$static_dtree = new Array($b292b058cfdfb330$var$D_CODES * 2);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $b292b058cfdfb330$var$_dist_code = new Array($b292b058cfdfb330$var$DIST_CODE_LEN);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $b292b058cfdfb330$var$_length_code = new Array($b292b058cfdfb330$var$MAX_MATCH - $b292b058cfdfb330$var$MIN_MATCH + 1);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $b292b058cfdfb330$var$base_length = new Array($b292b058cfdfb330$var$LENGTH_CODES);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $b292b058cfdfb330$var$base_dist = new Array($b292b058cfdfb330$var$D_CODES);
$b292b058cfdfb330$var$zero($b292b058cfdfb330$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $b292b058cfdfb330$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $b292b058cfdfb330$var$static_l_desc;
var $b292b058cfdfb330$var$static_d_desc;
var $b292b058cfdfb330$var$static_bl_desc;
function $b292b058cfdfb330$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $b292b058cfdfb330$var$d_code(dist) {
    return dist < 256 ? $b292b058cfdfb330$var$_dist_code[dist] : $b292b058cfdfb330$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $b292b058cfdfb330$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $b292b058cfdfb330$var$send_bits(s, value, length) {
    if (s.bi_valid > $b292b058cfdfb330$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $b292b058cfdfb330$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $b292b058cfdfb330$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $b292b058cfdfb330$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $b292b058cfdfb330$var$send_code(s, c, tree) {
    $b292b058cfdfb330$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $b292b058cfdfb330$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $b292b058cfdfb330$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $b292b058cfdfb330$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $b292b058cfdfb330$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $b292b058cfdfb330$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $b292b058cfdfb330$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $b292b058cfdfb330$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($b292b058cfdfb330$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $b292b058cfdfb330$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $b292b058cfdfb330$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $b292b058cfdfb330$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($b292b058cfdfb330$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $b292b058cfdfb330$var$LENGTH_CODES - 1; code++){
        $b292b058cfdfb330$var$base_length[code] = length;
        for(n = 0; n < 1 << $b292b058cfdfb330$var$extra_lbits[code]; n++)$b292b058cfdfb330$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $b292b058cfdfb330$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $b292b058cfdfb330$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $b292b058cfdfb330$var$extra_dbits[code]; n++)$b292b058cfdfb330$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $b292b058cfdfb330$var$D_CODES; code++){
        $b292b058cfdfb330$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $b292b058cfdfb330$var$extra_dbits[code] - 7; n++)$b292b058cfdfb330$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $b292b058cfdfb330$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $b292b058cfdfb330$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $b292b058cfdfb330$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $b292b058cfdfb330$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $b292b058cfdfb330$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $b292b058cfdfb330$var$gen_codes($b292b058cfdfb330$var$static_ltree, $b292b058cfdfb330$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $b292b058cfdfb330$var$D_CODES; n++){
        $b292b058cfdfb330$var$static_dtree[n * 2 + 1] = 5;
        $b292b058cfdfb330$var$static_dtree[n * 2] = $b292b058cfdfb330$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $b292b058cfdfb330$var$static_l_desc = new $b292b058cfdfb330$var$StaticTreeDesc($b292b058cfdfb330$var$static_ltree, $b292b058cfdfb330$var$extra_lbits, $b292b058cfdfb330$var$LITERALS + 1, $b292b058cfdfb330$var$L_CODES, $b292b058cfdfb330$var$MAX_BITS);
    $b292b058cfdfb330$var$static_d_desc = new $b292b058cfdfb330$var$StaticTreeDesc($b292b058cfdfb330$var$static_dtree, $b292b058cfdfb330$var$extra_dbits, 0, $b292b058cfdfb330$var$D_CODES, $b292b058cfdfb330$var$MAX_BITS);
    $b292b058cfdfb330$var$static_bl_desc = new $b292b058cfdfb330$var$StaticTreeDesc(new Array(0), $b292b058cfdfb330$var$extra_blbits, 0, $b292b058cfdfb330$var$BL_CODES, $b292b058cfdfb330$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $b292b058cfdfb330$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $b292b058cfdfb330$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $b292b058cfdfb330$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $b292b058cfdfb330$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$b292b058cfdfb330$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $b292b058cfdfb330$var$bi_windup(s) {
    if (s.bi_valid > 8) $b292b058cfdfb330$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $b292b058cfdfb330$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $b292b058cfdfb330$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $b292b058cfdfb330$var$put_short(s, len);
        $b292b058cfdfb330$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $1GjYS.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $b292b058cfdfb330$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $b292b058cfdfb330$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $b292b058cfdfb330$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($b292b058cfdfb330$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $b292b058cfdfb330$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $b292b058cfdfb330$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $b292b058cfdfb330$var$_length_code[lc];
            $b292b058cfdfb330$var$send_code(s, code + $b292b058cfdfb330$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $b292b058cfdfb330$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $b292b058cfdfb330$var$base_length[code];
                $b292b058cfdfb330$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $b292b058cfdfb330$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $b292b058cfdfb330$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $b292b058cfdfb330$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $b292b058cfdfb330$var$base_dist[code];
                $b292b058cfdfb330$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $b292b058cfdfb330$var$send_code(s, $b292b058cfdfb330$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $b292b058cfdfb330$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $b292b058cfdfb330$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$b292b058cfdfb330$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $b292b058cfdfb330$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $b292b058cfdfb330$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $b292b058cfdfb330$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $b292b058cfdfb330$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $b292b058cfdfb330$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$b292b058cfdfb330$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$b292b058cfdfb330$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$b292b058cfdfb330$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $b292b058cfdfb330$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $b292b058cfdfb330$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $b292b058cfdfb330$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $b292b058cfdfb330$var$send_code(s, $b292b058cfdfb330$var$REP_3_6, s.bl_tree);
            $b292b058cfdfb330$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $b292b058cfdfb330$var$send_code(s, $b292b058cfdfb330$var$REPZ_3_10, s.bl_tree);
            $b292b058cfdfb330$var$send_bits(s, count - 3, 3);
        } else {
            $b292b058cfdfb330$var$send_code(s, $b292b058cfdfb330$var$REPZ_11_138, s.bl_tree);
            $b292b058cfdfb330$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $b292b058cfdfb330$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $b292b058cfdfb330$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $b292b058cfdfb330$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $b292b058cfdfb330$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $b292b058cfdfb330$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$b292b058cfdfb330$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $b292b058cfdfb330$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $b292b058cfdfb330$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $b292b058cfdfb330$var$send_bits(s, dcodes - 1, 5);
    $b292b058cfdfb330$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $b292b058cfdfb330$var$send_bits(s, s.bl_tree[$b292b058cfdfb330$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $b292b058cfdfb330$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $b292b058cfdfb330$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $b292b058cfdfb330$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $b292b058cfdfb330$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $b292b058cfdfb330$var$Z_TEXT;
    for(n = 32; n < $b292b058cfdfb330$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $b292b058cfdfb330$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $b292b058cfdfb330$var$Z_BINARY;
}
var $b292b058cfdfb330$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $b292b058cfdfb330$var$_tr_init(s) {
    if (!$b292b058cfdfb330$var$static_init_done) {
        $b292b058cfdfb330$var$tr_static_init();
        $b292b058cfdfb330$var$static_init_done = true;
    }
    s.l_desc = new $b292b058cfdfb330$var$TreeDesc(s.dyn_ltree, $b292b058cfdfb330$var$static_l_desc);
    s.d_desc = new $b292b058cfdfb330$var$TreeDesc(s.dyn_dtree, $b292b058cfdfb330$var$static_d_desc);
    s.bl_desc = new $b292b058cfdfb330$var$TreeDesc(s.bl_tree, $b292b058cfdfb330$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $b292b058cfdfb330$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $b292b058cfdfb330$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $b292b058cfdfb330$var$send_bits(s, ($b292b058cfdfb330$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $b292b058cfdfb330$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $b292b058cfdfb330$var$_tr_align(s) {
    $b292b058cfdfb330$var$send_bits(s, $b292b058cfdfb330$var$STATIC_TREES << 1, 3);
    $b292b058cfdfb330$var$send_code(s, $b292b058cfdfb330$var$END_BLOCK, $b292b058cfdfb330$var$static_ltree);
    $b292b058cfdfb330$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $b292b058cfdfb330$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $b292b058cfdfb330$var$Z_UNKNOWN) s.strm.data_type = $b292b058cfdfb330$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $b292b058cfdfb330$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $b292b058cfdfb330$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $b292b058cfdfb330$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $b292b058cfdfb330$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $b292b058cfdfb330$var$Z_FIXED || static_lenb === opt_lenb) {
        $b292b058cfdfb330$var$send_bits(s, ($b292b058cfdfb330$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $b292b058cfdfb330$var$compress_block(s, $b292b058cfdfb330$var$static_ltree, $b292b058cfdfb330$var$static_dtree);
    } else {
        $b292b058cfdfb330$var$send_bits(s, ($b292b058cfdfb330$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $b292b058cfdfb330$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $b292b058cfdfb330$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $b292b058cfdfb330$var$init_block(s);
    if (last) $b292b058cfdfb330$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $b292b058cfdfb330$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($b292b058cfdfb330$var$_length_code[lc] + $b292b058cfdfb330$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$b292b058cfdfb330$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$b292b058cfdfb330$export$4e4fc0157c3cd14d = $b292b058cfdfb330$var$_tr_init;
$b292b058cfdfb330$export$8959e34c5e020172 = $b292b058cfdfb330$var$_tr_stored_block;
$b292b058cfdfb330$export$44f15b52eef0cf41 = $b292b058cfdfb330$var$_tr_flush_block;
$b292b058cfdfb330$export$b3cbce147289408f = $b292b058cfdfb330$var$_tr_tally;
$b292b058cfdfb330$export$bfb360e02ee9b403 = $b292b058cfdfb330$var$_tr_align;

});

parcelRegister("jgTtM", function(module, exports) {
"use strict";
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $e07a8bfc76ac1c7f$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $e07a8bfc76ac1c7f$var$adler32;

});

parcelRegister("laWcq", function(module, exports) {
"use strict";
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $f6a7ad510a40b31e$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $f6a7ad510a40b31e$var$crcTable = $f6a7ad510a40b31e$var$makeTable();
function $f6a7ad510a40b31e$var$crc32(crc, buf, len, pos) {
    var t = $f6a7ad510a40b31e$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $f6a7ad510a40b31e$var$crc32;

});

parcelRegister("2wNWS", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */ 1: "stream end",
    /* Z_STREAM_END      1  */ 0: "",
    /* Z_OK              0  */ "-1": "file error",
    /* Z_ERRNO         (-1) */ "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */ "-3": "data error",
    /* Z_DATA_ERROR    (-3) */ "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */ "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */ "-6": "incompatible version" /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("ccqNh", function(module, exports) {

$parcel$export(module.exports, "inflateReset", function () { return $8e1b63b35e874e30$export$42de45683a92ba94; }, function (v) { return $8e1b63b35e874e30$export$42de45683a92ba94 = v; });
$parcel$export(module.exports, "inflateInit2", function () { return $8e1b63b35e874e30$export$6792d92addc5c8a0; }, function (v) { return $8e1b63b35e874e30$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $8e1b63b35e874e30$export$cae1ce83fe4a1782; }, function (v) { return $8e1b63b35e874e30$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $8e1b63b35e874e30$export$224e1a443c3fba76; }, function (v) { return $8e1b63b35e874e30$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $8e1b63b35e874e30$export$60da749bed98ccf8; }, function (v) { return $8e1b63b35e874e30$export$60da749bed98ccf8 = v; });
var $8e1b63b35e874e30$export$42de45683a92ba94;
var $8e1b63b35e874e30$export$7633ac2cd30f9650;
var $8e1b63b35e874e30$export$6710ea52c4ec9d6a;
var $8e1b63b35e874e30$export$9c140b25e26874f9;
var $8e1b63b35e874e30$export$6792d92addc5c8a0;
var $8e1b63b35e874e30$export$cae1ce83fe4a1782;
var $8e1b63b35e874e30$export$224e1a443c3fba76;
var $8e1b63b35e874e30$export$6d4647cb9e1c75fc;
var $8e1b63b35e874e30$export$60da749bed98ccf8;
var $8e1b63b35e874e30$export$220f6291ca35fd71;
"use strict";

var $1GjYS = parcelRequire("1GjYS");

var $jgTtM = parcelRequire("jgTtM");

var $laWcq = parcelRequire("laWcq");

var $gmDWF = parcelRequire("gmDWF");

var $5hFuc = parcelRequire("5hFuc");
var $8e1b63b35e874e30$var$CODES = 0;
var $8e1b63b35e874e30$var$LENS = 1;
var $8e1b63b35e874e30$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $8e1b63b35e874e30$var$Z_FINISH = 4;
var $8e1b63b35e874e30$var$Z_BLOCK = 5;
var $8e1b63b35e874e30$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $8e1b63b35e874e30$var$Z_OK = 0;
var $8e1b63b35e874e30$var$Z_STREAM_END = 1;
var $8e1b63b35e874e30$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $8e1b63b35e874e30$var$Z_STREAM_ERROR = -2;
var $8e1b63b35e874e30$var$Z_DATA_ERROR = -3;
var $8e1b63b35e874e30$var$Z_MEM_ERROR = -4;
var $8e1b63b35e874e30$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $8e1b63b35e874e30$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $8e1b63b35e874e30$var$HEAD = 1; /* i: waiting for magic header */ 
var $8e1b63b35e874e30$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $8e1b63b35e874e30$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $8e1b63b35e874e30$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $8e1b63b35e874e30$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $8e1b63b35e874e30$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $8e1b63b35e874e30$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $8e1b63b35e874e30$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $8e1b63b35e874e30$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $8e1b63b35e874e30$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $8e1b63b35e874e30$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $8e1b63b35e874e30$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $8e1b63b35e874e30$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $8e1b63b35e874e30$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $8e1b63b35e874e30$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $8e1b63b35e874e30$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $8e1b63b35e874e30$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $8e1b63b35e874e30$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $8e1b63b35e874e30$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $8e1b63b35e874e30$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $8e1b63b35e874e30$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $8e1b63b35e874e30$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $8e1b63b35e874e30$var$DIST = 23; /* i: waiting for distance code */ 
var $8e1b63b35e874e30$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $8e1b63b35e874e30$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $8e1b63b35e874e30$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $8e1b63b35e874e30$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $8e1b63b35e874e30$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $8e1b63b35e874e30$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $8e1b63b35e874e30$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $8e1b63b35e874e30$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $8e1b63b35e874e30$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $8e1b63b35e874e30$var$ENOUGH_LENS = 852;
var $8e1b63b35e874e30$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $8e1b63b35e874e30$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $8e1b63b35e874e30$var$DEF_WBITS = $8e1b63b35e874e30$var$MAX_WBITS;
function $8e1b63b35e874e30$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $8e1b63b35e874e30$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $1GjYS.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $1GjYS.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $8e1b63b35e874e30$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ""; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $8e1b63b35e874e30$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $1GjYS.Buf32($8e1b63b35e874e30$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $1GjYS.Buf32($8e1b63b35e874e30$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $8e1b63b35e874e30$var$Z_OK;
}
function $8e1b63b35e874e30$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $8e1b63b35e874e30$var$inflateResetKeep(strm);
}
function $8e1b63b35e874e30$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $8e1b63b35e874e30$var$inflateReset(strm);
}
function $8e1b63b35e874e30$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $8e1b63b35e874e30$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $8e1b63b35e874e30$var$inflateReset2(strm, windowBits);
    if (ret !== $8e1b63b35e874e30$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $8e1b63b35e874e30$var$inflateInit(strm) {
    return $8e1b63b35e874e30$var$inflateInit2(strm, $8e1b63b35e874e30$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $8e1b63b35e874e30$var$virgin = true;
var $8e1b63b35e874e30$var$lenfix, $8e1b63b35e874e30$var$distfix; // We have no pointers in JS, so keep tables separate
function $8e1b63b35e874e30$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($8e1b63b35e874e30$var$virgin) {
        var sym;
        $8e1b63b35e874e30$var$lenfix = new $1GjYS.Buf32(512);
        $8e1b63b35e874e30$var$distfix = new $1GjYS.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $5hFuc($8e1b63b35e874e30$var$LENS, state.lens, 0, 288, $8e1b63b35e874e30$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $5hFuc($8e1b63b35e874e30$var$DISTS, state.lens, 0, 32, $8e1b63b35e874e30$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $8e1b63b35e874e30$var$virgin = false;
    }
    state.lencode = $8e1b63b35e874e30$var$lenfix;
    state.lenbits = 9;
    state.distcode = $8e1b63b35e874e30$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $8e1b63b35e874e30$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $1GjYS.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $1GjYS.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $1GjYS.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $1GjYS.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $8e1b63b35e874e30$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $1GjYS.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $8e1b63b35e874e30$var$TYPE) state.mode = $8e1b63b35e874e30$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $8e1b63b35e874e30$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $8e1b63b35e874e30$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $8e1b63b35e874e30$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $laWcq(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $8e1b63b35e874e30$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = "incorrect header check";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $8e1b63b35e874e30$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = "invalid window size";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $8e1b63b35e874e30$var$DICTID : $8e1b63b35e874e30$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $8e1b63b35e874e30$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $8e1b63b35e874e30$var$Z_DEFLATED) {
                strm.msg = "unknown compression method";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = "unknown header flags set";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $laWcq(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $8e1b63b35e874e30$var$TIME;
        /* falls through */ case $8e1b63b35e874e30$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $laWcq(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $8e1b63b35e874e30$var$OS;
        /* falls through */ case $8e1b63b35e874e30$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $laWcq(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $8e1b63b35e874e30$var$EXLEN;
        /* falls through */ case $8e1b63b35e874e30$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $laWcq(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $8e1b63b35e874e30$var$EXTRA;
        /* falls through */ case $8e1b63b35e874e30$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $1GjYS.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $laWcq(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $8e1b63b35e874e30$var$NAME;
        /* falls through */ case $8e1b63b35e874e30$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $laWcq(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $8e1b63b35e874e30$var$COMMENT;
        /* falls through */ case $8e1b63b35e874e30$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $laWcq(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $8e1b63b35e874e30$var$HCRC;
        /* falls through */ case $8e1b63b35e874e30$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = "header crc mismatch";
                    state.mode = $8e1b63b35e874e30$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $8e1b63b35e874e30$var$TYPE;
            break;
        case $8e1b63b35e874e30$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $8e1b63b35e874e30$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $8e1b63b35e874e30$var$DICT;
        /* falls through */ case $8e1b63b35e874e30$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $8e1b63b35e874e30$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $8e1b63b35e874e30$var$TYPE;
        /* falls through */ case $8e1b63b35e874e30$var$TYPE:
            if (flush === $8e1b63b35e874e30$var$Z_BLOCK || flush === $8e1b63b35e874e30$var$Z_TREES) break inf_leave;
        /* falls through */ case $8e1b63b35e874e30$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $8e1b63b35e874e30$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $8e1b63b35e874e30$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $8e1b63b35e874e30$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $8e1b63b35e874e30$var$LEN_; /* decode codes */ 
                    if (flush === $8e1b63b35e874e30$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $8e1b63b35e874e30$var$TABLE;
                    break;
                case 3:
                    strm.msg = "invalid block type";
                    state.mode = $8e1b63b35e874e30$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $8e1b63b35e874e30$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = "invalid stored block lengths";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $8e1b63b35e874e30$var$COPY_;
            if (flush === $8e1b63b35e874e30$var$Z_TREES) break inf_leave;
        /* falls through */ case $8e1b63b35e874e30$var$COPY_:
            state.mode = $8e1b63b35e874e30$var$COPY;
        /* falls through */ case $8e1b63b35e874e30$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $1GjYS.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $8e1b63b35e874e30$var$TYPE;
            break;
        case $8e1b63b35e874e30$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = "too many length or distance symbols";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $8e1b63b35e874e30$var$LENLENS;
        /* falls through */ case $8e1b63b35e874e30$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $5hFuc($8e1b63b35e874e30$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = "invalid code lengths set";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $8e1b63b35e874e30$var$CODELENS;
        /* falls through */ case $8e1b63b35e874e30$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = "invalid bit length repeat";
                            state.mode = $8e1b63b35e874e30$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = "invalid bit length repeat";
                        state.mode = $8e1b63b35e874e30$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $8e1b63b35e874e30$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = "invalid code -- missing end-of-block";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $5hFuc($8e1b63b35e874e30$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = "invalid literal/lengths set";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $5hFuc($8e1b63b35e874e30$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = "invalid distances set";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $8e1b63b35e874e30$var$LEN_;
            if (flush === $8e1b63b35e874e30$var$Z_TREES) break inf_leave;
        /* falls through */ case $8e1b63b35e874e30$var$LEN_:
            state.mode = $8e1b63b35e874e30$var$LEN;
        /* falls through */ case $8e1b63b35e874e30$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $gmDWF(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $8e1b63b35e874e30$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $8e1b63b35e874e30$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $8e1b63b35e874e30$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = "invalid literal/length code";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $8e1b63b35e874e30$var$LENEXT;
        /* falls through */ case $8e1b63b35e874e30$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $8e1b63b35e874e30$var$DIST;
        /* falls through */ case $8e1b63b35e874e30$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = "invalid distance code";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $8e1b63b35e874e30$var$DISTEXT;
        /* falls through */ case $8e1b63b35e874e30$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = "invalid distance too far back";
                state.mode = $8e1b63b35e874e30$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $8e1b63b35e874e30$var$MATCH;
        /* falls through */ case $8e1b63b35e874e30$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = "invalid distance too far back";
                        state.mode = $8e1b63b35e874e30$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $8e1b63b35e874e30$var$LEN;
            break;
        case $8e1b63b35e874e30$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $8e1b63b35e874e30$var$LEN;
            break;
        case $8e1b63b35e874e30$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $laWcq(state.check, output, _out, put - _out) : $jgTtM(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $8e1b63b35e874e30$var$zswap32(hold)) !== state.check) {
                    strm.msg = "incorrect data check";
                    state.mode = $8e1b63b35e874e30$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $8e1b63b35e874e30$var$LENGTH;
        /* falls through */ case $8e1b63b35e874e30$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = "incorrect length check";
                    state.mode = $8e1b63b35e874e30$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $8e1b63b35e874e30$var$DONE;
        /* falls through */ case $8e1b63b35e874e30$var$DONE:
            ret = $8e1b63b35e874e30$var$Z_STREAM_END;
            break inf_leave;
        case $8e1b63b35e874e30$var$BAD:
            ret = $8e1b63b35e874e30$var$Z_DATA_ERROR;
            break inf_leave;
        case $8e1b63b35e874e30$var$MEM:
            return $8e1b63b35e874e30$var$Z_MEM_ERROR;
        case $8e1b63b35e874e30$var$SYNC:
        /* falls through */ default:
            return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $8e1b63b35e874e30$var$BAD && (state.mode < $8e1b63b35e874e30$var$CHECK || flush !== $8e1b63b35e874e30$var$Z_FINISH)) {
        if ($8e1b63b35e874e30$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $8e1b63b35e874e30$var$MEM;
            return $8e1b63b35e874e30$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $laWcq(state.check, output, _out, strm.next_out - _out) : $jgTtM(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $8e1b63b35e874e30$var$TYPE ? 128 : 0) + (state.mode === $8e1b63b35e874e30$var$LEN_ || state.mode === $8e1b63b35e874e30$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $8e1b63b35e874e30$var$Z_FINISH) && ret === $8e1b63b35e874e30$var$Z_OK) ret = $8e1b63b35e874e30$var$Z_BUF_ERROR;
    return ret;
}
function $8e1b63b35e874e30$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $8e1b63b35e874e30$var$Z_OK;
}
function $8e1b63b35e874e30$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $8e1b63b35e874e30$var$Z_OK;
}
function $8e1b63b35e874e30$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $8e1b63b35e874e30$var$DICT) return $8e1b63b35e874e30$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $8e1b63b35e874e30$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $jgTtM(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $8e1b63b35e874e30$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $8e1b63b35e874e30$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $8e1b63b35e874e30$var$MEM;
        return $8e1b63b35e874e30$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $8e1b63b35e874e30$var$Z_OK;
}
$8e1b63b35e874e30$export$42de45683a92ba94 = $8e1b63b35e874e30$var$inflateReset;
$8e1b63b35e874e30$export$7633ac2cd30f9650 = $8e1b63b35e874e30$var$inflateReset2;
$8e1b63b35e874e30$export$6710ea52c4ec9d6a = $8e1b63b35e874e30$var$inflateResetKeep;
$8e1b63b35e874e30$export$9c140b25e26874f9 = $8e1b63b35e874e30$var$inflateInit;
$8e1b63b35e874e30$export$6792d92addc5c8a0 = $8e1b63b35e874e30$var$inflateInit2;
$8e1b63b35e874e30$export$cae1ce83fe4a1782 = $8e1b63b35e874e30$var$inflate;
$8e1b63b35e874e30$export$224e1a443c3fba76 = $8e1b63b35e874e30$var$inflateEnd;
$8e1b63b35e874e30$export$6d4647cb9e1c75fc = $8e1b63b35e874e30$var$inflateGetHeader;
$8e1b63b35e874e30$export$60da749bed98ccf8 = $8e1b63b35e874e30$var$inflateSetDictionary;
$8e1b63b35e874e30$export$220f6291ca35fd71 = "pako inflate (from Nodeca project)"; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("gmDWF", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $be9dafb651bcdd1c$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $be9dafb651bcdd1c$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = "invalid distance too far back";
                            state.mode = $be9dafb651bcdd1c$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = "invalid distance too far back";
                                    state.mode = $be9dafb651bcdd1c$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = "invalid distance code";
                        state.mode = $be9dafb651bcdd1c$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $be9dafb651bcdd1c$var$TYPE;
                break top;
            } else {
                strm.msg = "invalid literal/length code";
                state.mode = $be9dafb651bcdd1c$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("5hFuc", function(module, exports) {
"use strict";

var $1GjYS = parcelRequire("1GjYS");
var $3d8eb889a2d5182a$var$MAXBITS = 15;
var $3d8eb889a2d5182a$var$ENOUGH_LENS = 852;
var $3d8eb889a2d5182a$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $3d8eb889a2d5182a$var$CODES = 0;
var $3d8eb889a2d5182a$var$LENS = 1;
var $3d8eb889a2d5182a$var$DISTS = 2;
var $3d8eb889a2d5182a$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $3d8eb889a2d5182a$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $3d8eb889a2d5182a$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $3d8eb889a2d5182a$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $1GjYS.Buf16($3d8eb889a2d5182a$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $1GjYS.Buf16($3d8eb889a2d5182a$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $3d8eb889a2d5182a$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $3d8eb889a2d5182a$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $3d8eb889a2d5182a$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $3d8eb889a2d5182a$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $3d8eb889a2d5182a$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $3d8eb889a2d5182a$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $3d8eb889a2d5182a$var$LENS) {
        base = $3d8eb889a2d5182a$var$lbase;
        base_index -= 257;
        extra = $3d8eb889a2d5182a$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $3d8eb889a2d5182a$var$dbase;
        extra = $3d8eb889a2d5182a$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $3d8eb889a2d5182a$var$LENS && used > $3d8eb889a2d5182a$var$ENOUGH_LENS || type === $3d8eb889a2d5182a$var$DISTS && used > $3d8eb889a2d5182a$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $3d8eb889a2d5182a$var$LENS && used > $3d8eb889a2d5182a$var$ENOUGH_LENS || type === $3d8eb889a2d5182a$var$DISTS && used > $3d8eb889a2d5182a$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("bManr", function(module, exports) {
"use strict";
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});






parcelRegister("grbfr", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bf77e4945d09605a$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.normalize = module.exports.recoverPublicKey = module.exports.concatSig = module.exports.legacyToBuffer = module.exports.isNullish = module.exports.padWithZeroes = void 0;

var $fz3Xx = parcelRequire("fz3Xx");

var $deXIT = parcelRequire("deXIT");

var $aFbW5 = parcelRequire("aFbW5");
/**
 * Pads the front of the given hex string with zeroes until it reaches the
 * target length. If the input string is already longer than or equal to the
 * target length, it is returned unmodified.
 *
 * If the input string is "0x"-prefixed or not a hex string, an error will be
 * thrown.
 *
 * @param hexString - The hexadecimal string to pad with zeroes.
 * @param targetLength - The target length of the hexadecimal string.
 * @returns The input string front-padded with zeroes, or the original string
 * if it was already greater than or equal to to the target length.
 */ function $bf77e4945d09605a$var$padWithZeroes(hexString, targetLength) {
    if (hexString !== "" && !/^[a-f0-9]+$/iu.test(hexString)) throw new Error(`Expected an unprefixed hex string. Received: ${hexString}`);
    if (targetLength < 0) throw new Error(`Expected a non-negative integer target length. Received: ${targetLength}`);
    return String.prototype.padStart.call(hexString, targetLength, "0");
}
module.exports.padWithZeroes = $bf77e4945d09605a$var$padWithZeroes;
/**
 * Returns `true` if the given value is nullish.
 *
 * @param value - The value being checked.
 * @returns Whether the value is nullish.
 */ function $bf77e4945d09605a$var$isNullish(value) {
    return value === null || value === undefined;
}
module.exports.isNullish = $bf77e4945d09605a$var$isNullish;
/**
 * Convert a value to a Buffer. This function should be equivalent to the `toBuffer` function in
 * `ethereumjs-util@5.2.1`.
 *
 * @param value - The value to convert to a Buffer.
 * @returns The given value as a Buffer.
 */ function $bf77e4945d09605a$var$legacyToBuffer(value) {
    return typeof value === "string" && !(0, $aFbW5.isHexString)(value) ? $bf77e4945d09605a$require$Buffer.from(value) : (0, $fz3Xx.toBuffer)(value);
}
module.exports.legacyToBuffer = $bf77e4945d09605a$var$legacyToBuffer;
/**
 * Concatenate an extended ECDSA signature into a single '0x'-prefixed hex string.
 *
 * @param v - The 'v' portion of the signature.
 * @param r - The 'r' portion of the signature.
 * @param s - The 's' portion of the signature.
 * @returns The concatenated ECDSA signature as a '0x'-prefixed string.
 */ function $bf77e4945d09605a$var$concatSig(v, r, s) {
    const rSig = (0, $fz3Xx.fromSigned)(r);
    const sSig = (0, $fz3Xx.fromSigned)(s);
    const vSig = (0, $fz3Xx.bufferToInt)(v);
    const rStr = $bf77e4945d09605a$var$padWithZeroes((0, $fz3Xx.toUnsigned)(rSig).toString("hex"), 64);
    const sStr = $bf77e4945d09605a$var$padWithZeroes((0, $fz3Xx.toUnsigned)(sSig).toString("hex"), 64);
    const vStr = (0, $aFbW5.stripHexPrefix)((0, $aFbW5.intToHex)(vSig));
    return (0, $deXIT.add0x)(rStr.concat(sStr, vStr));
}
module.exports.concatSig = $bf77e4945d09605a$var$concatSig;
/**
 * Recover the public key from the given signature and message hash.
 *
 * @param messageHash - The hash of the signed message.
 * @param signature - The signature.
 * @returns The public key of the signer.
 */ function $bf77e4945d09605a$var$recoverPublicKey(messageHash, signature) {
    const sigParams = (0, $fz3Xx.fromRpcSig)(signature);
    return (0, $fz3Xx.ecrecover)(messageHash, sigParams.v, sigParams.r, sigParams.s);
}
module.exports.recoverPublicKey = $bf77e4945d09605a$var$recoverPublicKey;
/**
 * Normalize the input to a lower-cased '0x'-prefixed hex string.
 *
 * @param input - The value to normalize.
 * @returns The normalized value.
 */ function $bf77e4945d09605a$var$normalize(input) {
    if ($bf77e4945d09605a$var$isNullish(input)) return undefined;
    if (typeof input === "number") {
        if (input < 0) return "0x";
        const buffer = (0, $deXIT.numberToBytes)(input);
        input = (0, $deXIT.bytesToHex)(buffer);
    }
    if (typeof input !== "string") {
        let msg = "eth-sig-util.normalize() requires hex string or integer input.";
        msg += ` received ${typeof input}: ${input}`;
        throw new Error(msg);
    }
    return (0, $deXIT.add0x)(input.toLowerCase());
}
module.exports.normalize = $bf77e4945d09605a$var$normalize;

});
parcelRegister("deXIT", function(module, exports) {

$parcel$export(module.exports, "bytesToHex", function () { return $ca1b90d881fce719$export$58b867e287a802c8; });
$parcel$export(module.exports, "add0x", function () { return $ca1b90d881fce719$export$99eb66c70a3abadb; });
$parcel$export(module.exports, "bytesToBigInt", function () { return $ca1b90d881fce719$export$2a52511e4f35930a; });
$parcel$export(module.exports, "bytesToSignedBigInt", function () { return $ca1b90d881fce719$export$ec3ea0d1d8eb730f; });
$parcel$export(module.exports, "bytesToNumber", function () { return $ca1b90d881fce719$export$c0cca17bcf674749; });
$parcel$export(module.exports, "bytesToString", function () { return $ca1b90d881fce719$export$7c746b75f47c9c7d; });
$parcel$export(module.exports, "hexToBytes", function () { return $ca1b90d881fce719$export$31c96b9df38bc8d4; });
$parcel$export(module.exports, "bigIntToBytes", function () { return $ca1b90d881fce719$export$c0f6630717bc20c7; });
$parcel$export(module.exports, "signedBigIntToBytes", function () { return $ca1b90d881fce719$export$11d2ef81978f13a2; });
$parcel$export(module.exports, "numberToBytes", function () { return $ca1b90d881fce719$export$49ad9be85c347998; });
$parcel$export(module.exports, "stringToBytes", function () { return $ca1b90d881fce719$export$c8dd6bc66a63753c; });
$parcel$export(module.exports, "concatBytes", function () { return $ca1b90d881fce719$export$287dd7971339c972; });
$parcel$export(module.exports, "StrictHexStruct", function () { return $ca1b90d881fce719$export$bba61feb448b50e3; });
$parcel$export(module.exports, "isStrictHexString", function () { return $ca1b90d881fce719$export$ffb748597a46b25c; });

var $hLU0Z = parcelRequire("hLU0Z");

var $fYeg3 = parcelRequire("fYeg3");

var $iclp6 = parcelRequire("iclp6");

var $be6gB = parcelRequire("be6gB");

var $ihoyg = parcelRequire("ihoyg");
var $ca1b90d881fce719$require$Buffer = $ihoyg.Buffer;
var $ca1b90d881fce719$var$HEX_MINIMUM_NUMBER_CHARACTER = 48;
var $ca1b90d881fce719$var$HEX_MAXIMUM_NUMBER_CHARACTER = 58;
var $ca1b90d881fce719$var$HEX_CHARACTER_OFFSET = 87;
function $ca1b90d881fce719$var$getPrecomputedHexValuesBuilder() {
    const lookupTable = [];
    return ()=>{
        if (lookupTable.length === 0) for(let i = 0; i < 256; i++)lookupTable.push(i.toString(16).padStart(2, "0"));
        return lookupTable;
    };
}
var $ca1b90d881fce719$var$getPrecomputedHexValues = $ca1b90d881fce719$var$getPrecomputedHexValuesBuilder();
function $ca1b90d881fce719$export$c6fabfbfd097fc30(value) {
    return value instanceof Uint8Array;
}
function $ca1b90d881fce719$export$b7c05e2d1266685(value) {
    (0, $hLU0Z.assert)($ca1b90d881fce719$export$c6fabfbfd097fc30(value), "Value must be a Uint8Array.");
}
function $ca1b90d881fce719$export$58b867e287a802c8(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    if (bytes.length === 0) return "0x";
    const lookupTable = $ca1b90d881fce719$var$getPrecomputedHexValues();
    const hexadecimal = new Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)hexadecimal[i] = lookupTable[bytes[i]];
    return $ca1b90d881fce719$export$99eb66c70a3abadb(hexadecimal.join(""));
}
function $ca1b90d881fce719$export$2a52511e4f35930a(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    const hexadecimal = $ca1b90d881fce719$export$58b867e287a802c8(bytes);
    return BigInt(hexadecimal);
}
function $ca1b90d881fce719$export$ec3ea0d1d8eb730f(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    let value = BigInt(0);
    for (const byte of bytes)value = (value << BigInt(8)) + BigInt(byte);
    return BigInt.asIntN(bytes.length * 8, value);
}
function $ca1b90d881fce719$export$c0cca17bcf674749(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    const bigint = $ca1b90d881fce719$export$2a52511e4f35930a(bytes);
    (0, $hLU0Z.assert)(bigint <= BigInt(Number.MAX_SAFE_INTEGER), "Number is not a safe integer. Use `bytesToBigInt` instead.");
    return Number(bigint);
}
function $ca1b90d881fce719$export$7c746b75f47c9c7d(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    return new TextDecoder().decode(bytes);
}
function $ca1b90d881fce719$export$e54b9bef4a6eddb0(bytes) {
    $ca1b90d881fce719$export$b7c05e2d1266685(bytes);
    return (0, $be6gB.base64).encode(bytes);
}
function $ca1b90d881fce719$export$31c96b9df38bc8d4(value) {
    if (value?.toLowerCase?.() === "0x") return new Uint8Array();
    $ca1b90d881fce719$export$cfc9b5ae6d41356d(value);
    const strippedValue = $ca1b90d881fce719$export$3622b47974a526ba(value).toLowerCase();
    const normalizedValue = strippedValue.length % 2 === 0 ? strippedValue : `0${strippedValue}`;
    const bytes = new Uint8Array(normalizedValue.length / 2);
    for(let i = 0; i < bytes.length; i++){
        const c1 = normalizedValue.charCodeAt(i * 2);
        const c2 = normalizedValue.charCodeAt(i * 2 + 1);
        const n1 = c1 - (c1 < $ca1b90d881fce719$var$HEX_MAXIMUM_NUMBER_CHARACTER ? $ca1b90d881fce719$var$HEX_MINIMUM_NUMBER_CHARACTER : $ca1b90d881fce719$var$HEX_CHARACTER_OFFSET);
        const n2 = c2 - (c2 < $ca1b90d881fce719$var$HEX_MAXIMUM_NUMBER_CHARACTER ? $ca1b90d881fce719$var$HEX_MINIMUM_NUMBER_CHARACTER : $ca1b90d881fce719$var$HEX_CHARACTER_OFFSET);
        bytes[i] = n1 * 16 + n2;
    }
    return bytes;
}
function $ca1b90d881fce719$export$c0f6630717bc20c7(value) {
    (0, $hLU0Z.assert)(typeof value === "bigint", "Value must be a bigint.");
    (0, $hLU0Z.assert)(value >= BigInt(0), "Value must be a non-negative bigint.");
    const hexadecimal = value.toString(16);
    return $ca1b90d881fce719$export$31c96b9df38bc8d4(hexadecimal);
}
function $ca1b90d881fce719$var$bigIntFits(value, bytes) {
    (0, $hLU0Z.assert)(bytes > 0);
    const mask = value >> BigInt(31);
    return !((~value & mask) + (value & ~mask) >> BigInt(bytes * 8 + -1));
}
function $ca1b90d881fce719$export$11d2ef81978f13a2(value, byteLength) {
    (0, $hLU0Z.assert)(typeof value === "bigint", "Value must be a bigint.");
    (0, $hLU0Z.assert)(typeof byteLength === "number", "Byte length must be a number.");
    (0, $hLU0Z.assert)(byteLength > 0, "Byte length must be greater than 0.");
    (0, $hLU0Z.assert)($ca1b90d881fce719$var$bigIntFits(value, byteLength), "Byte length is too small to represent the given value.");
    let numberValue = value;
    const bytes = new Uint8Array(byteLength);
    for(let i = 0; i < bytes.length; i++){
        bytes[i] = Number(BigInt.asUintN(8, numberValue));
        numberValue >>= BigInt(8);
    }
    return bytes.reverse();
}
function $ca1b90d881fce719$export$49ad9be85c347998(value) {
    (0, $hLU0Z.assert)(typeof value === "number", "Value must be a number.");
    (0, $hLU0Z.assert)(value >= 0, "Value must be a non-negative number.");
    (0, $hLU0Z.assert)(Number.isSafeInteger(value), "Value is not a safe integer. Use `bigIntToBytes` instead.");
    const hexadecimal = value.toString(16);
    return $ca1b90d881fce719$export$31c96b9df38bc8d4(hexadecimal);
}
function $ca1b90d881fce719$export$c8dd6bc66a63753c(value) {
    (0, $hLU0Z.assert)(typeof value === "string", "Value must be a string.");
    return new TextEncoder().encode(value);
}
function $ca1b90d881fce719$export$9581c9d544ce8d21(value) {
    (0, $hLU0Z.assert)(typeof value === "string", "Value must be a string.");
    return (0, $be6gB.base64).decode(value);
}
function $ca1b90d881fce719$export$1bbb2220e3194ff7(value) {
    if (typeof value === "bigint") return $ca1b90d881fce719$export$c0f6630717bc20c7(value);
    if (typeof value === "number") return $ca1b90d881fce719$export$49ad9be85c347998(value);
    if (typeof value === "string") {
        if (value.startsWith("0x")) return $ca1b90d881fce719$export$31c96b9df38bc8d4(value);
        return $ca1b90d881fce719$export$c8dd6bc66a63753c(value);
    }
    if ($ca1b90d881fce719$export$c6fabfbfd097fc30(value)) return value;
    throw new TypeError(`Unsupported value type: "${typeof value}".`);
}
function $ca1b90d881fce719$export$287dd7971339c972(values) {
    const normalizedValues = new Array(values.length);
    let byteLength = 0;
    for(let i = 0; i < values.length; i++){
        const value = $ca1b90d881fce719$export$1bbb2220e3194ff7(values[i]);
        normalizedValues[i] = value;
        byteLength += value.length;
    }
    const bytes = new Uint8Array(byteLength);
    for(let i = 0, offset = 0; i < normalizedValues.length; i++){
        bytes.set(normalizedValues[i], offset);
        offset += normalizedValues[i].length;
    }
    return bytes;
}
function $ca1b90d881fce719$export$7277868462c1ba02(bytes) {
    if (typeof $ca1b90d881fce719$require$Buffer !== "undefined" && bytes instanceof $ca1b90d881fce719$require$Buffer) {
        const buffer = bytes.buffer.slice(bytes.byteOffset, bytes.byteOffset + bytes.byteLength);
        return new DataView(buffer);
    }
    return new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}
// src/hex.ts
var $ca1b90d881fce719$export$b864195d511aaf58 = (0, $iclp6.pattern)((0, $iclp6.string)(), /^(?:0x)?[0-9a-f]+$/iu);
var $ca1b90d881fce719$export$bba61feb448b50e3 = (0, $iclp6.pattern)((0, $iclp6.string)(), /^0x[0-9a-f]+$/iu);
var $ca1b90d881fce719$export$90b2d5fa210f6c5e = (0, $iclp6.pattern)((0, $iclp6.string)(), /^0x[0-9a-f]{40}$/u);
var $ca1b90d881fce719$export$61ae952f4a20ac2f = (0, $iclp6.pattern)((0, $iclp6.string)(), /^0x[0-9a-fA-F]{40}$/u);
function $ca1b90d881fce719$export$b02a40aff8e4ad18(value) {
    return (0, $iclp6.is)(value, $ca1b90d881fce719$export$b864195d511aaf58);
}
function $ca1b90d881fce719$export$ffb748597a46b25c(value) {
    return (0, $iclp6.is)(value, $ca1b90d881fce719$export$bba61feb448b50e3);
}
function $ca1b90d881fce719$export$cfc9b5ae6d41356d(value) {
    (0, $hLU0Z.assert)($ca1b90d881fce719$export$b02a40aff8e4ad18(value), "Value must be a hexadecimal string.");
}
function $ca1b90d881fce719$export$98256e0b9e8d3122(value) {
    (0, $hLU0Z.assert)($ca1b90d881fce719$export$ffb748597a46b25c(value), 'Value must be a hexadecimal string, starting with "0x".');
}
function $ca1b90d881fce719$export$4bae053e5318ba08(possibleAddress) {
    return (0, $iclp6.is)(possibleAddress, $ca1b90d881fce719$export$90b2d5fa210f6c5e) || $ca1b90d881fce719$export$e75397a807935220(possibleAddress);
}
function $ca1b90d881fce719$export$c696806606bb1429(address) {
    (0, $hLU0Z.assert)((0, $iclp6.is)(address, $ca1b90d881fce719$export$61ae952f4a20ac2f), "Invalid hex address.");
    const unPrefixed = $ca1b90d881fce719$export$3622b47974a526ba(address.toLowerCase());
    const unPrefixedHash = $ca1b90d881fce719$export$3622b47974a526ba($ca1b90d881fce719$export$58b867e287a802c8((0, $fYeg3.keccak_256)(unPrefixed)));
    return `0x${unPrefixed.split("").map((character, nibbleIndex)=>{
        const hashCharacter = unPrefixedHash[nibbleIndex];
        (0, $hLU0Z.assert)((0, $iclp6.is)(hashCharacter, (0, $iclp6.string)()), "Hash shorter than address.");
        return parseInt(hashCharacter, 16) > 7 ? character.toUpperCase() : character;
    }).join("")}`;
}
function $ca1b90d881fce719$export$e75397a807935220(possibleChecksum) {
    if (!(0, $iclp6.is)(possibleChecksum, $ca1b90d881fce719$export$61ae952f4a20ac2f)) return false;
    return $ca1b90d881fce719$export$c696806606bb1429(possibleChecksum) === possibleChecksum;
}
function $ca1b90d881fce719$export$99eb66c70a3abadb(hexadecimal) {
    if (hexadecimal.startsWith("0x")) return hexadecimal;
    if (hexadecimal.startsWith("0X")) return `0x${hexadecimal.substring(2)}`;
    return `0x${hexadecimal}`;
}
function $ca1b90d881fce719$export$3622b47974a526ba(hexadecimal) {
    if (hexadecimal.startsWith("0x") || hexadecimal.startsWith("0X")) return hexadecimal.substring(2);
    return hexadecimal;
}

});
parcelRegister("hLU0Z", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $5948c47b2179cd9a$export$a7a9523472993e97; });

var $akQCx = parcelRequire("akQCx");

var $iclp6 = parcelRequire("iclp6");
function $5948c47b2179cd9a$var$isConstructable(fn) {
    return Boolean(typeof fn?.prototype?.constructor?.name === "string");
}
function $5948c47b2179cd9a$var$getErrorMessageWithoutTrailingPeriod(error) {
    return (0, $akQCx.getErrorMessage)(error).replace(/\.$/u, "");
}
function $5948c47b2179cd9a$var$getError(ErrorWrapper, message) {
    if ($5948c47b2179cd9a$var$isConstructable(ErrorWrapper)) return new ErrorWrapper({
        message: message
    });
    return ErrorWrapper({
        message: message
    });
}
var $5948c47b2179cd9a$export$7750cdfb4db2c3d = class extends Error {
    constructor(options){
        super(options.message);
        this.code = "ERR_ASSERTION";
    }
};
function $5948c47b2179cd9a$export$a7a9523472993e97(value, message = "Assertion failed.", ErrorWrapper = $5948c47b2179cd9a$export$7750cdfb4db2c3d) {
    if (!value) {
        if (message instanceof Error) throw message;
        throw $5948c47b2179cd9a$var$getError(ErrorWrapper, message);
    }
}
function $5948c47b2179cd9a$export$9028f00ec54b267b(value, struct, errorPrefix = "Assertion failed", ErrorWrapper = $5948c47b2179cd9a$export$7750cdfb4db2c3d) {
    try {
        (0, $iclp6.assert)(value, struct);
    } catch (error) {
        throw $5948c47b2179cd9a$var$getError(ErrorWrapper, `${errorPrefix}: ${$5948c47b2179cd9a$var$getErrorMessageWithoutTrailingPeriod(error)}.`);
    }
}
function $5948c47b2179cd9a$export$16bf6fe03653420f(_object) {
    throw new Error("Invalid branch reached. Should be detected during compilation.");
}

});
parcelRegister("akQCx", function(module, exports) {

$parcel$export(module.exports, "getErrorMessage", function () { return $430472c946e58477$export$82f46aa4e6535a45; });

var $6mp4V = parcelRequire("6mp4V");
parcelRequire("e43ai");
var $4yBDH = parcelRequire("4yBDH");
function $430472c946e58477$var$isError(error) {
    return error instanceof Error || (0, $6mp4V.isObject)(error) && error.constructor.name === "Error";
}
function $430472c946e58477$export$c3e419856772a6b(error) {
    return typeof error === "object" && error !== null && "code" in error;
}
function $430472c946e58477$export$896ffc81198e4315(error) {
    return typeof error === "object" && error !== null && "message" in error;
}
function $430472c946e58477$export$71cb0973409e79f(error) {
    return typeof error === "object" && error !== null && "stack" in error;
}
function $430472c946e58477$export$82f46aa4e6535a45(error) {
    if ($430472c946e58477$export$896ffc81198e4315(error) && typeof error.message === "string") return error.message;
    if ((0, $6mp4V.isNullOrUndefined)(error)) return "";
    return String(error);
}
function $430472c946e58477$export$d32383114b84a36b(originalError, message) {
    if ($430472c946e58477$var$isError(originalError)) {
        const error = Error.length === 2 ? // This branch is getting tested by using the Node version that
        // supports `cause` on the Error constructor.
        // istanbul ignore next
        // Also, for some reason `tsserver` is not complaining that the
        // Error constructor doesn't support a second argument in the editor,
        // but `tsc` does. I'm not sure why, but we disable this in the
        // meantime.
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        new Error(message, {
            cause: originalError
        }) : new (0, $4yBDH.ErrorWithCause)(message, {
            cause: originalError
        });
        if ($430472c946e58477$export$c3e419856772a6b(originalError)) error.code = originalError.code;
        return error;
    }
    if (message.length > 0) return new Error(`${String(originalError)}: ${message}`);
    return new Error(String(originalError));
}

});
parcelRegister("6mp4V", function(module, exports) {

$parcel$export(module.exports, "isNullOrUndefined", function () { return $f7794abdbae5ae9b$export$bedb7023a7733221; });
$parcel$export(module.exports, "isObject", function () { return $f7794abdbae5ae9b$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "hasProperty", function () { return $f7794abdbae5ae9b$export$bf9617eaf5d2451; });
// src/misc.ts
function $f7794abdbae5ae9b$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}
function $f7794abdbae5ae9b$export$bedb7023a7733221(value) {
    return value === null || value === void 0;
}
function $f7794abdbae5ae9b$export$a6cdc56e425d0d0a(value) {
    return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}
var $f7794abdbae5ae9b$export$bf9617eaf5d2451 = (objectToCheck, name)=>Object.hasOwnProperty.call(objectToCheck, name);
function $f7794abdbae5ae9b$export$80b8503184a2d286(object) {
    return Object.getOwnPropertyNames(object);
}
var $f7794abdbae5ae9b$export$da61d0be2af808d = /* @__PURE__ */ ((JsonSize2)=>{
    JsonSize2[JsonSize2["Null"] = 4] = "Null";
    JsonSize2[JsonSize2["Comma"] = 1] = "Comma";
    JsonSize2[JsonSize2["Wrapper"] = 1] = "Wrapper";
    JsonSize2[JsonSize2["True"] = 4] = "True";
    JsonSize2[JsonSize2["False"] = 5] = "False";
    JsonSize2[JsonSize2["Quote"] = 1] = "Quote";
    JsonSize2[JsonSize2["Colon"] = 1] = "Colon";
    JsonSize2[JsonSize2["Date"] = 24] = "Date";
    return JsonSize2;
})($f7794abdbae5ae9b$export$da61d0be2af808d || {});
var $f7794abdbae5ae9b$export$c7d9c940c8699c91 = /"|\\|\n|\r|\t/gu;
function $f7794abdbae5ae9b$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    try {
        let proto = value;
        while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
        return Object.getPrototypeOf(value) === proto;
    } catch (_) {
        return false;
    }
}
function $f7794abdbae5ae9b$export$bda4392048434949(character) {
    return character.charCodeAt(0) <= 127;
}
function $f7794abdbae5ae9b$export$954c89fa6a0ca909(value) {
    const size = value.split("").reduce((total, character)=>{
        if ($f7794abdbae5ae9b$export$bda4392048434949(character)) return total + 1;
        return total + 2;
    }, 0);
    return size + (value.match($f7794abdbae5ae9b$export$c7d9c940c8699c91) ?? []).length;
}
function $f7794abdbae5ae9b$export$8a48ebd7ecf276b9(value) {
    return value.toString().length;
}

});

parcelRegister("e43ai", function(module, exports) {

$parcel$export(module.exports, "ErrorWithCause", function () { return (parcelRequire("4yBDH")).ErrorWithCause; });

var $4yBDH = parcelRequire("4yBDH");

var $jRTde = parcelRequire("jRTde");
"use strict";

});
parcelRegister("4yBDH", function(module, exports) {

$parcel$export(module.exports, "ErrorWithCause", function () { return $c161315eacde1115$export$ff654df971616da8; });
"use strict";
class $c161315eacde1115$export$ff654df971616da8 extends Error {
    /**
   * @param {string} message
   * @param {{ cause?: T }} options
   */ constructor(message, { cause: cause } = {}){
        super(message);
        /** @type {string} */ this.name = $c161315eacde1115$export$ff654df971616da8.name;
        if (cause) /** @type {T} */ this.cause = cause;
        /** @type {string} */ this.message = message;
    }
}

});

parcelRegister("jRTde", function(module, exports) {
"use strict";
const $48c576e4716728f0$export$e7d6c202cfb162da = (err, reference)=>{
    if (!err || !reference) return;
    if (!(err instanceof Error)) return;
    if (!(reference.prototype instanceof Error) && // @ts-ignore
    reference !== Error) return;
    /**
   * Ensures we don't go circular
   *
   * @type {Set<Error>}
   */ const seen = new Set();
    /** @type {Error|undefined} */ let currentErr = err;
    while(currentErr && !seen.has(currentErr)){
        seen.add(currentErr);
        if (currentErr instanceof reference) return currentErr;
        currentErr = $48c576e4716728f0$export$c485382f750e6190(currentErr);
    }
};
const $48c576e4716728f0$export$c485382f750e6190 = (err)=>{
    if (!err || typeof err !== "object" || !("cause" in err)) return;
    // VError / NError style causes
    if (typeof err.cause === "function") {
        const causeResult = err.cause();
        return causeResult instanceof Error ? causeResult : undefined;
    } else return err.cause instanceof Error ? err.cause : undefined;
};
/**
 * Internal method that keeps a track of which error we have already added, to avoid circular recursion
 *
 * @private
 * @param {Error} err
 * @param {Set<Error>} seen
 * @returns {string}
 */ const $48c576e4716728f0$var$_stackWithCauses = (err, seen)=>{
    if (!(err instanceof Error)) return "";
    const stack = err.stack || "";
    // Ensure we don't go circular or crazily deep
    if (seen.has(err)) return stack + "\ncauses have become circular...";
    const cause = $48c576e4716728f0$export$c485382f750e6190(err);
    // TODO: Follow up in https://github.com/nodejs/node/issues/38725#issuecomment-920309092 on how to log stuff
    if (cause) {
        seen.add(err);
        return stack + "\ncaused by: " + $48c576e4716728f0$var$_stackWithCauses(cause, seen);
    } else return stack;
};
const $48c576e4716728f0$export$8b6811d69e9606ef = (err)=>$48c576e4716728f0$var$_stackWithCauses(err, new Set());
/**
 * Internal method that keeps a track of which error we have already added, to avoid circular recursion
 *
 * @private
 * @param {Error} err
 * @param {Set<Error>} seen
 * @param {boolean} [skip]
 * @returns {string}
 */ const $48c576e4716728f0$var$_messageWithCauses = (err, seen, skip)=>{
    if (!(err instanceof Error)) return "";
    const message = skip ? "" : err.message || "";
    // Ensure we don't go circular or crazily deep
    if (seen.has(err)) return message + ": ...";
    const cause = $48c576e4716728f0$export$c485382f750e6190(err);
    if (cause) {
        seen.add(err);
        const skipIfVErrorStyleCause = "cause" in err && typeof err.cause === "function";
        return message + (skipIfVErrorStyleCause ? "" : ": ") + $48c576e4716728f0$var$_messageWithCauses(cause, seen, skipIfVErrorStyleCause);
    } else return message;
};
const $48c576e4716728f0$export$c32483c5e367153a = (err)=>$48c576e4716728f0$var$_messageWithCauses(err, new Set());

});



parcelRegister("iclp6", function(module, exports) {

$parcel$export(module.exports, "StructError", function () { return $70e252e5c893b99a$export$58cc9131e3e8861b; });
$parcel$export(module.exports, "assert", function () { return $70e252e5c893b99a$export$a7a9523472993e97; });
$parcel$export(module.exports, "create", function () { return $70e252e5c893b99a$export$185802fd694ee1f5; });
$parcel$export(module.exports, "is", function () { return $70e252e5c893b99a$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "object", function () { return $70e252e5c893b99a$export$be5493f9613cbbe; });
$parcel$export(module.exports, "bigint", function () { return $70e252e5c893b99a$export$a0f65b52274bcc00; });
$parcel$export(module.exports, "boolean", function () { return $70e252e5c893b99a$export$4a21f16c33752377; });
$parcel$export(module.exports, "instance", function () { return $70e252e5c893b99a$export$9544d5bb712b01ea; });
$parcel$export(module.exports, "literal", function () { return $70e252e5c893b99a$export$c8ec6e1ec9fefcb0; });
$parcel$export(module.exports, "number", function () { return $70e252e5c893b99a$export$98e628dec113755e; });
$parcel$export(module.exports, "string", function () { return $70e252e5c893b99a$export$22b082955e083ec3; });
$parcel$export(module.exports, "union", function () { return $70e252e5c893b99a$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "coerce", function () { return $70e252e5c893b99a$export$8c14e57e778d3873; });
$parcel$export(module.exports, "pattern", function () { return $70e252e5c893b99a$export$24f82734ea047e6f; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $70e252e5c893b99a$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, explanation: explanation, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : `At path: ${path.join(".")} -- ${message}`;
        super(explanation ?? msg);
        if (explanation != null) this.cause = msg;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            return cached ?? (cached = [
                failure,
                ...failures()
            ]);
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $70e252e5c893b99a$var$isIterable(x) {
    return $70e252e5c893b99a$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $70e252e5c893b99a$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $70e252e5c893b99a$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $70e252e5c893b99a$var$print(value) {
    if (typeof value === "symbol") return value.toString();
    return typeof value === "string" ? JSON.stringify(value) : `${value}`;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $70e252e5c893b99a$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $70e252e5c893b99a$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = `Expected a value of type \`${type}\`${refinement ? ` with refinement \`${refinement}\`` : ""}, but received: \`${$70e252e5c893b99a$var$print(value)}\`` } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $70e252e5c893b99a$var$toFailures(result, context, struct, value) {
    if (!$70e252e5c893b99a$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $70e252e5c893b99a$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $70e252e5c893b99a$var$run(value, struct, options = {}) {
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $70e252e5c893b99a$var$isObject(struct.schema) && $70e252e5c893b99a$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let status = "valid";
    for (const failure of struct.validator(value, ctx)){
        failure.explanation = options.message;
        status = "not_valid";
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $70e252e5c893b99a$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask,
            message: options.message
        });
        for (const t of ts){
            if (t[0]) {
                status = t[0].refinement != null ? "not_refined" : "not_valid";
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($70e252e5c893b99a$var$isObject(value)) {
                    if (v !== undefined || k in value) value[k] = v;
                }
            }
        }
    }
    if (status !== "not_valid") for (const failure of struct.refiner(value, ctx)){
        failure.explanation = options.message;
        status = "not_refined";
        yield [
            failure,
            undefined
        ];
    }
    if (status === "valid") yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $70e252e5c893b99a$export$eabc71f011df675a {
    constructor(props){
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $70e252e5c893b99a$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $70e252e5c893b99a$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
     * Assert that a value passes the struct's validation, throwing if it doesn't.
     */ assert(value, message) {
        return $70e252e5c893b99a$export$a7a9523472993e97(value, this, message);
    }
    /**
     * Create a value with the struct's coercion logic, then validate it.
     */ create(value, message) {
        return $70e252e5c893b99a$export$185802fd694ee1f5(value, this, message);
    }
    /**
     * Check if a value passes the struct's validation.
     */ is(value) {
        return $70e252e5c893b99a$export$226b3eccf92c9ed9(value, this);
    }
    /**
     * Mask a value, coercing and validating it, but returning only the subset of
     * properties defined by the struct's schema.
     */ mask(value, message) {
        return $70e252e5c893b99a$export$d99f0801a68bbcf1(value, this, message);
    }
    /**
     * Validate a value with the struct's validation logic, returning a tuple
     * representing the result.
     *
     * You may optionally pass `true` for the `withCoercion` argument to coerce
     * the value before attempting to validate it. If you do, the result will
     * contain the coerced result when successful.
     */ validate(value, options = {}) {
        return $70e252e5c893b99a$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $70e252e5c893b99a$export$a7a9523472993e97(value, struct, message) {
    const result = $70e252e5c893b99a$export$a22775fa5e2eebd9(value, struct, {
        message: message
    });
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $70e252e5c893b99a$export$185802fd694ee1f5(value, struct, message) {
    const result = $70e252e5c893b99a$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $70e252e5c893b99a$export$d99f0801a68bbcf1(value, struct, message) {
    const result = $70e252e5c893b99a$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true,
        message: message
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $70e252e5c893b99a$export$226b3eccf92c9ed9(value, struct) {
    const result = $70e252e5c893b99a$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $70e252e5c893b99a$export$a22775fa5e2eebd9(value, struct, options = {}) {
    const tuples = $70e252e5c893b99a$var$run(value, struct, options);
    const tuple = $70e252e5c893b99a$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $70e252e5c893b99a$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $70e252e5c893b99a$export$e6e34fd1f2686227(...Structs) {
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $70e252e5c893b99a$export$bf9fb029d174d554(schema) : $70e252e5c893b99a$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $70e252e5c893b99a$export$f36d6a7a5c09a23e(name, validator) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $70e252e5c893b99a$export$cdd73fc4100a6ef4(struct, log) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $70e252e5c893b99a$export$7077912c31975674(fn) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $70e252e5c893b99a$export$488013bae63b21da(fn) {
    let struct;
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            struct ?? (struct = fn());
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            struct ?? (struct = fn());
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            struct ?? (struct = fn());
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            struct ?? (struct = fn());
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $70e252e5c893b99a$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $70e252e5c893b99a$export$bf9fb029d174d554(subschema);
        default:
            return $70e252e5c893b99a$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $70e252e5c893b99a$export$e45945969df8035a(struct) {
    const schema = struct instanceof $70e252e5c893b99a$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $70e252e5c893b99a$export$516e28dec6a4b6d4(schema[key]);
    return $70e252e5c893b99a$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $70e252e5c893b99a$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $70e252e5c893b99a$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $70e252e5c893b99a$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $70e252e5c893b99a$export$4154a199d7d90455() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $70e252e5c893b99a$export$2f23118c22fb2630(Element) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array value, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $70e252e5c893b99a$export$a0f65b52274bcc00() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $70e252e5c893b99a$export$4a21f16c33752377() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $70e252e5c893b99a$export$324d90190a8b822a() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || `Expected a valid \`Date\` object, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
function $70e252e5c893b99a$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$70e252e5c893b99a$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || `Expected one of \`${description}\`, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $70e252e5c893b99a$export$86951950244e2001() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || `Expected a function, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $70e252e5c893b99a$export$9544d5bb712b01ea(Class) {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || `Expected a \`${Class.name}\` instance, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
/**
 * Ensure that a value is an integer.
 */ function $70e252e5c893b99a$export$32744b5b3bba4764() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || `Expected an integer, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $70e252e5c893b99a$export$bc86dfbf7795668c(Structs) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $70e252e5c893b99a$export$c8ec6e1ec9fefcb0(constant) {
    const description = $70e252e5c893b99a$var$print(constant);
    const t = typeof constant;
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || `Expected the literal \`${description}\`, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
function $70e252e5c893b99a$export$871de8747c9eaa88(Key, Value) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || `Expected a \`Map\` object, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $70e252e5c893b99a$export$b3e22bcfd64c1022() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $70e252e5c893b99a$export$133fc36489ac9add(struct) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $70e252e5c893b99a$export$98e628dec113755e() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || `Expected a number, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
function $70e252e5c893b99a$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $70e252e5c893b99a$export$b3e22bcfd64c1022();
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $70e252e5c893b99a$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $70e252e5c893b99a$var$isObject(value) || `Expected an object, but received: ${$70e252e5c893b99a$var$print(value)}`;
        },
        coercer (value) {
            return $70e252e5c893b99a$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $70e252e5c893b99a$export$516e28dec6a4b6d4(struct) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $70e252e5c893b99a$export$e5185e241753e543(Key, Value) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($70e252e5c893b99a$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $70e252e5c893b99a$var$isObject(value) || `Expected an object, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $70e252e5c893b99a$export$efdc1e5bdb609bb() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $70e252e5c893b99a$export$adaa4cf7ef1b65be(Element) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || `Expected a \`Set\` object, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $70e252e5c893b99a$export$22b082955e083ec3() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || `Expected a string, but received: ${$70e252e5c893b99a$var$print(value)}`;
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $70e252e5c893b99a$export$65e3907585753458(Structs) {
    const Never = $70e252e5c893b99a$export$b3e22bcfd64c1022();
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || `Expected an array, but received: ${$70e252e5c893b99a$var$print(value)}`;
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $70e252e5c893b99a$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($70e252e5c893b99a$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $70e252e5c893b99a$var$isObject(value) || `Expected an object, but received: ${$70e252e5c893b99a$var$print(value)}`;
        },
        coercer (value) {
            return $70e252e5c893b99a$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $70e252e5c893b99a$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value) {
            for (const S of Structs){
                const [error, coerced] = S.validate(value, {
                    coerce: true
                });
                if (!error) return coerced;
            }
            return value;
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $70e252e5c893b99a$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                `Expected the value to satisfy a union of \`${description}\`, but received: ${$70e252e5c893b99a$var$print(value)}`,
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $70e252e5c893b99a$export$19282c40b967aec6() {
    return $70e252e5c893b99a$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $70e252e5c893b99a$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $70e252e5c893b99a$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $70e252e5c893b99a$export$83c510c4356017ae(struct, fallback, options = {}) {
    return $70e252e5c893b99a$export$8c14e57e778d3873(struct, $70e252e5c893b99a$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $70e252e5c893b99a$var$isPlainObject(x) && $70e252e5c893b99a$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $70e252e5c893b99a$export$41f369984ed28930(struct) {
    return $70e252e5c893b99a$export$8c14e57e778d3873(struct, $70e252e5c893b99a$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $70e252e5c893b99a$export$6e22c362a0406a2c(struct) {
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $70e252e5c893b99a$var$getSize(value);
        return size === 0 || `Expected an empty ${struct.type} but received one with a size of \`${size}\``;
    });
}
function $70e252e5c893b99a$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $70e252e5c893b99a$export$8960430cfd85939f(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || `Expected a ${struct.type} less than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $70e252e5c893b99a$export$96ec731ed4dcb222(struct, threshold, options = {}) {
    const { exclusive: exclusive } = options;
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || `Expected a ${struct.type} greater than ${exclusive ? "" : "or equal to "}${threshold} but received \`${value}\``;
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $70e252e5c893b99a$export$6ce6c9218151d511(struct) {
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $70e252e5c893b99a$var$getSize(value);
        return size > 0 || `Expected a nonempty ${struct.type} but received an empty one`;
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $70e252e5c893b99a$export$24f82734ea047e6f(struct, regexp) {
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || `Expected a ${struct.type} matching \`/${regexp.source}/\` but received "${value}"`;
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $70e252e5c893b99a$export$346677f925de839c(struct, min, max = min) {
    const expected = `Expected a ${struct.type}`;
    const of = min === max ? `of \`${min}\`` : `between \`${min}\` and \`${max}\``;
    return $70e252e5c893b99a$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || `${expected} ${of} but received \`${value}\``;
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || `${expected} with a size ${of} but received one with a size of \`${size}\``;
        } else {
            const { length: length } = value;
            return min <= length && length <= max || `${expected} with a length ${of} but received one with a length of \`${length}\``;
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $70e252e5c893b99a$export$edc9d475108b3212(struct, name, refiner) {
    return new $70e252e5c893b99a$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $70e252e5c893b99a$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});


parcelRegister("fYeg3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

var $6IAO7 = parcelRequire("6IAO7");

var $lWlfy = parcelRequire("lWlfy");

var $jUYJl = parcelRequire("jUYJl");
// SHA3 (keccak) is based on a new design: basically, the internal state is bigger than output size.
// It's called a sponge function.
// Various per round constants calculations
const [$ba0784f1e190ec7b$var$SHA3_PI, $ba0784f1e190ec7b$var$SHA3_ROTL, $ba0784f1e190ec7b$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $ba0784f1e190ec7b$var$_0n = /* @__PURE__ */ BigInt(0);
const $ba0784f1e190ec7b$var$_1n = /* @__PURE__ */ BigInt(1);
const $ba0784f1e190ec7b$var$_2n = /* @__PURE__ */ BigInt(2);
const $ba0784f1e190ec7b$var$_7n = /* @__PURE__ */ BigInt(7);
const $ba0784f1e190ec7b$var$_256n = /* @__PURE__ */ BigInt(256);
const $ba0784f1e190ec7b$var$_0x71n = /* @__PURE__ */ BigInt(0x71);
for(let round = 0, R = $ba0784f1e190ec7b$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $ba0784f1e190ec7b$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $ba0784f1e190ec7b$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $ba0784f1e190ec7b$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $ba0784f1e190ec7b$var$_1n ^ (R >> $ba0784f1e190ec7b$var$_7n) * $ba0784f1e190ec7b$var$_0x71n) % $ba0784f1e190ec7b$var$_256n;
        if (R & $ba0784f1e190ec7b$var$_2n) t ^= $ba0784f1e190ec7b$var$_1n << ($ba0784f1e190ec7b$var$_1n << /* @__PURE__ */ BigInt(j)) - $ba0784f1e190ec7b$var$_1n;
    }
    $ba0784f1e190ec7b$var$_SHA3_IOTA.push(t);
}
const [$ba0784f1e190ec7b$var$SHA3_IOTA_H, $ba0784f1e190ec7b$var$SHA3_IOTA_L] = /* @__PURE__ */ (0, $lWlfy.split)($ba0784f1e190ec7b$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $ba0784f1e190ec7b$var$rotlH = (h, l, s)=>s > 32 ? (0, $lWlfy.rotlBH)(h, l, s) : (0, $lWlfy.rotlSH)(h, l, s);
const $ba0784f1e190ec7b$var$rotlL = (h, l, s)=>s > 32 ? (0, $lWlfy.rotlBL)(h, l, s) : (0, $lWlfy.rotlSL)(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $ba0784f1e190ec7b$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $ba0784f1e190ec7b$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $ba0784f1e190ec7b$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $ba0784f1e190ec7b$var$SHA3_ROTL[t];
            const Th = $ba0784f1e190ec7b$var$rotlH(curH, curL, shift);
            const Tl = $ba0784f1e190ec7b$var$rotlL(curH, curL, shift);
            const PI = $ba0784f1e190ec7b$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $ba0784f1e190ec7b$var$SHA3_IOTA_H[round];
        s[1] ^= $ba0784f1e190ec7b$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $ba0784f1e190ec7b$var$keccakP;
class $ba0784f1e190ec7b$var$Keccak extends $jUYJl.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $6IAO7.number)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $jUYJl.u32)(this.state);
    }
    keccak() {
        $ba0784f1e190ec7b$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        (0, $6IAO7.exists)(this);
        const { blockLen: blockLen, state: state } = this;
        data = (0, $jUYJl.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        (0, $6IAO7.exists)(this, false);
        (0, $6IAO7.bytes)(out);
        this.finish();
        const bufferOut = this.state;
        const { blockLen: blockLen } = this;
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= blockLen) this.keccak();
            const take = Math.min(blockLen - this.posOut, len - pos);
            out.set(bufferOut.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $6IAO7.number)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        (0, $6IAO7.output)(out, this);
        if (this.finished) throw new Error("digest() was already called");
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $ba0784f1e190ec7b$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $ba0784f1e190ec7b$var$Keccak;
const $ba0784f1e190ec7b$var$gen = (suffix, blockLen, outputLen)=>(0, $jUYJl.wrapConstructor)(()=>new $ba0784f1e190ec7b$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $ba0784f1e190ec7b$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $ba0784f1e190ec7b$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $ba0784f1e190ec7b$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $ba0784f1e190ec7b$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $ba0784f1e190ec7b$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $ba0784f1e190ec7b$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $ba0784f1e190ec7b$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $ba0784f1e190ec7b$var$gen(0x01, 72, 64);
const $ba0784f1e190ec7b$var$genShake = (suffix, blockLen, outputLen)=>(0, $jUYJl.wrapXOFConstructorWithOpts)((opts = {})=>new $ba0784f1e190ec7b$var$Keccak(blockLen, suffix, opts.dkLen === undefined ? outputLen : opts.dkLen, true));
module.exports.shake128 = $ba0784f1e190ec7b$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $ba0784f1e190ec7b$var$genShake(0x1f, 136, 32);

});
parcelRegister("6IAO7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.output = module.exports.exists = module.exports.hash = module.exports.bytes = module.exports.bool = module.exports.number = void 0;
function $4e43674c54072424$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
module.exports.number = $4e43674c54072424$var$number;
function $4e43674c54072424$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
module.exports.bool = $4e43674c54072424$var$bool;
function $4e43674c54072424$var$bytes(b, ...lengths) {
    if (!(b instanceof Uint8Array)) throw new Error("Expected Uint8Array");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Expected Uint8Array of length ${lengths}, not of length=${b.length}`);
}
module.exports.bytes = $4e43674c54072424$var$bytes;
function $4e43674c54072424$var$hash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $4e43674c54072424$var$number(hash.outputLen);
    $4e43674c54072424$var$number(hash.blockLen);
}
module.exports.hash = $4e43674c54072424$var$hash;
function $4e43674c54072424$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
module.exports.exists = $4e43674c54072424$var$exists;
function $4e43674c54072424$var$output(out, instance) {
    $4e43674c54072424$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
module.exports.output = $4e43674c54072424$var$output;
const $4e43674c54072424$var$assert = {
    number: $4e43674c54072424$var$number,
    bool: $4e43674c54072424$var$bool,
    bytes: $4e43674c54072424$var$bytes,
    hash: $4e43674c54072424$var$hash,
    exists: $4e43674c54072424$var$exists,
    output: $4e43674c54072424$var$output
};
module.exports.default = $4e43674c54072424$var$assert;

});

parcelRegister("lWlfy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5L = module.exports.add5H = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $ff8f7f8b27569108$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $ff8f7f8b27569108$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $ff8f7f8b27569108$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $ff8f7f8b27569108$var$U32_MASK64),
        l: Number(n >> $ff8f7f8b27569108$var$_32n & $ff8f7f8b27569108$var$U32_MASK64)
    };
    return {
        h: Number(n >> $ff8f7f8b27569108$var$_32n & $ff8f7f8b27569108$var$U32_MASK64) | 0,
        l: Number(n & $ff8f7f8b27569108$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $ff8f7f8b27569108$var$fromBig;
function $ff8f7f8b27569108$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $ff8f7f8b27569108$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $ff8f7f8b27569108$var$split;
const $ff8f7f8b27569108$var$toBig = (h, l)=>BigInt(h >>> 0) << $ff8f7f8b27569108$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $ff8f7f8b27569108$var$toBig;
// for Shift in [0, 32)
const $ff8f7f8b27569108$var$shrSH = (h, _l, s)=>h >>> s;
module.exports.shrSH = $ff8f7f8b27569108$var$shrSH;
const $ff8f7f8b27569108$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $ff8f7f8b27569108$var$shrSL;
// Right rotate for Shift in [1, 32)
const $ff8f7f8b27569108$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $ff8f7f8b27569108$var$rotrSH;
const $ff8f7f8b27569108$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $ff8f7f8b27569108$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ff8f7f8b27569108$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $ff8f7f8b27569108$var$rotrBH;
const $ff8f7f8b27569108$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $ff8f7f8b27569108$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $ff8f7f8b27569108$var$rotr32H = (_h, l)=>l;
module.exports.rotr32H = $ff8f7f8b27569108$var$rotr32H;
const $ff8f7f8b27569108$var$rotr32L = (h, _l)=>h;
module.exports.rotr32L = $ff8f7f8b27569108$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $ff8f7f8b27569108$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $ff8f7f8b27569108$var$rotlSH;
const $ff8f7f8b27569108$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $ff8f7f8b27569108$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $ff8f7f8b27569108$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $ff8f7f8b27569108$var$rotlBH;
const $ff8f7f8b27569108$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $ff8f7f8b27569108$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $ff8f7f8b27569108$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $ff8f7f8b27569108$var$add;
// Addition with more than 2 elements
const $ff8f7f8b27569108$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $ff8f7f8b27569108$var$add3L;
const $ff8f7f8b27569108$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $ff8f7f8b27569108$var$add3H;
const $ff8f7f8b27569108$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $ff8f7f8b27569108$var$add4L;
const $ff8f7f8b27569108$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $ff8f7f8b27569108$var$add4H;
const $ff8f7f8b27569108$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $ff8f7f8b27569108$var$add5L;
const $ff8f7f8b27569108$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $ff8f7f8b27569108$var$add5H;
// prettier-ignore
const $ff8f7f8b27569108$var$u64 = {
    fromBig: $ff8f7f8b27569108$var$fromBig,
    split: $ff8f7f8b27569108$var$split,
    toBig: $ff8f7f8b27569108$var$toBig,
    shrSH: $ff8f7f8b27569108$var$shrSH,
    shrSL: $ff8f7f8b27569108$var$shrSL,
    rotrSH: $ff8f7f8b27569108$var$rotrSH,
    rotrSL: $ff8f7f8b27569108$var$rotrSL,
    rotrBH: $ff8f7f8b27569108$var$rotrBH,
    rotrBL: $ff8f7f8b27569108$var$rotrBL,
    rotr32H: $ff8f7f8b27569108$var$rotr32H,
    rotr32L: $ff8f7f8b27569108$var$rotr32L,
    rotlSH: $ff8f7f8b27569108$var$rotlSH,
    rotlSL: $ff8f7f8b27569108$var$rotlSL,
    rotlBH: $ff8f7f8b27569108$var$rotlBH,
    rotlBL: $ff8f7f8b27569108$var$rotlBL,
    add: $ff8f7f8b27569108$var$add,
    add3L: $ff8f7f8b27569108$var$add3L,
    add3H: $ff8f7f8b27569108$var$add3H,
    add4L: $ff8f7f8b27569108$var$add4L,
    add4H: $ff8f7f8b27569108$var$add4H,
    add5H: $ff8f7f8b27569108$var$add5H,
    add5L: $ff8f7f8b27569108$var$add5L
};
module.exports.default = $ff8f7f8b27569108$var$u64;

});

parcelRegister("jUYJl", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.randomBytes = module.exports.wrapXOFConstructorWithOpts = module.exports.wrapConstructorWithOpts = module.exports.wrapConstructor = module.exports.checkOpts = module.exports.Hash = module.exports.concatBytes = module.exports.toBytes = module.exports.utf8ToBytes = module.exports.asyncLoop = module.exports.nextTick = module.exports.hexToBytes = module.exports.bytesToHex = module.exports.isLE = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;

var $9eCC2 = parcelRequire("9eCC2");
const $e8025b1584630a13$var$u8a = (a)=>a instanceof Uint8Array;
// Cast array to different type
const $e8025b1584630a13$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $e8025b1584630a13$var$u8;
const $e8025b1584630a13$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $e8025b1584630a13$var$u32;
// Cast array to view
const $e8025b1584630a13$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $e8025b1584630a13$var$createView;
// The rotate right (circular right shift) operation for uint32
const $e8025b1584630a13$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $e8025b1584630a13$var$rotr;
// big-endian hardware is rare. Just in case someone still decides to run hashes:
// early-throw an error because we don't support BE yet.
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
if (!module.exports.isLE) throw new Error("Non little-endian hardware is not supported");
const $e8025b1584630a13$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $e8025b1584630a13$var$bytesToHex(bytes) {
    if (!$e8025b1584630a13$var$u8a(bytes)) throw new Error("Uint8Array expected");
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $e8025b1584630a13$var$hexes[bytes[i]];
    return hex;
}
module.exports.bytesToHex = $e8025b1584630a13$var$bytesToHex;
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $e8025b1584630a13$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const len = hex.length;
    if (len % 2) throw new Error("padded hex string expected, got unpadded hex of length " + len);
    const array = new Uint8Array(len / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte) || byte < 0) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
module.exports.hexToBytes = $e8025b1584630a13$var$hexToBytes;
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $e8025b1584630a13$var$nextTick = async ()=>{};
module.exports.nextTick = $e8025b1584630a13$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $e8025b1584630a13$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
module.exports.asyncLoop = $e8025b1584630a13$var$asyncLoop;
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $e8025b1584630a13$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
module.exports.utf8ToBytes = $e8025b1584630a13$var$utf8ToBytes;
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $e8025b1584630a13$var$toBytes(data) {
    if (typeof data === "string") data = $e8025b1584630a13$var$utf8ToBytes(data);
    if (!$e8025b1584630a13$var$u8a(data)) throw new Error(`expected Uint8Array, got ${typeof data}`);
    return data;
}
module.exports.toBytes = $e8025b1584630a13$var$toBytes;
/**
 * Copies several Uint8Arrays into one.
 */ function $e8025b1584630a13$var$concatBytes(...arrays) {
    const r = new Uint8Array(arrays.reduce((sum, a)=>sum + a.length, 0));
    let pad = 0; // walk through each item, ensure they have proper type
    arrays.forEach((a)=>{
        if (!$e8025b1584630a13$var$u8a(a)) throw new Error("Uint8Array expected");
        r.set(a, pad);
        pad += a.length;
    });
    return r;
}
module.exports.concatBytes = $e8025b1584630a13$var$concatBytes;
// For runtime check if class implements interface
class $e8025b1584630a13$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $e8025b1584630a13$var$Hash;
const $e8025b1584630a13$var$toStr = {}.toString;
function $e8025b1584630a13$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $e8025b1584630a13$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
module.exports.checkOpts = $e8025b1584630a13$var$checkOpts;
function $e8025b1584630a13$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($e8025b1584630a13$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
module.exports.wrapConstructor = $e8025b1584630a13$var$wrapConstructor;
function $e8025b1584630a13$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($e8025b1584630a13$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapConstructorWithOpts = $e8025b1584630a13$var$wrapConstructorWithOpts;
function $e8025b1584630a13$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($e8025b1584630a13$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
module.exports.wrapXOFConstructorWithOpts = $e8025b1584630a13$var$wrapXOFConstructorWithOpts;
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $e8025b1584630a13$var$randomBytes(bytesLength = 32) {
    if ($9eCC2.crypto && typeof $9eCC2.crypto.getRandomValues === "function") return $9eCC2.crypto.getRandomValues(new Uint8Array(bytesLength));
    throw new Error("crypto.getRandomValues must be defined");
}
module.exports.randomBytes = $e8025b1584630a13$var$randomBytes;

});
parcelRegister("9eCC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});



parcelRegister("be6gB", function(module, exports) {

$parcel$export(module.exports, "base64", function () { return $82c5dcfc38b90f03$export$b3b2de96497acc47; });
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$chain(...args) {
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = Array.from(args).reverse().reduce((acc, i)=>acc ? wrap(acc, i.encode) : i.encode, undefined);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.reduce((acc, i)=>acc ? wrap(acc, i.decode) : i.decode, undefined);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $82c5dcfc38b90f03$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$padding(bits, chr = "=") {
    $82c5dcfc38b90f03$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $82c5dcfc38b90f03$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            const rounded = Math.floor(digitBase / to);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $82c5dcfc38b90f03$var$gcd = /* @__NO_SIDE_EFFECTS__ */ (a, b)=>!b ? a : $82c5dcfc38b90f03$var$gcd(b, a % b);
const $82c5dcfc38b90f03$var$radix2carry = /*@__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $82c5dcfc38b90f03$var$gcd(from, to));
/**
 * Implemented with numbers, because BigInt is 5x slower
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($82c5dcfc38b90f03$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$82c5dcfc38b90f03$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $82c5dcfc38b90f03$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$radix(num) {
    $82c5dcfc38b90f03$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix.encode input should be Uint8Array");
            return $82c5dcfc38b90f03$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of strings");
            return Uint8Array.from($82c5dcfc38b90f03$var$convertRadix(digits, num, 256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$radix2(bits, revPadding = false) {
    $82c5dcfc38b90f03$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($82c5dcfc38b90f03$var$radix2carry(8, bits) > 32 || $82c5dcfc38b90f03$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!(bytes instanceof Uint8Array)) throw new Error("radix2.encode input should be Uint8Array");
            return $82c5dcfc38b90f03$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of strings");
            return Uint8Array.from($82c5dcfc38b90f03$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$checksum(len, fn) {
    $82c5dcfc38b90f03$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!(data instanceof Uint8Array)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $82c5dcfc38b90f03$export$eab97d15b1788b8d = {
    alphabet: $82c5dcfc38b90f03$var$alphabet,
    chain: $82c5dcfc38b90f03$var$chain,
    checksum: $82c5dcfc38b90f03$var$checksum,
    radix: $82c5dcfc38b90f03$var$radix,
    radix2: $82c5dcfc38b90f03$var$radix2,
    join: $82c5dcfc38b90f03$var$join,
    padding: $82c5dcfc38b90f03$var$padding
};
const $82c5dcfc38b90f03$export$586f61c71cb02fe4 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(4), $82c5dcfc38b90f03$var$alphabet("0123456789ABCDEF"), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$4a4d5965e2738b2a = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(5), $82c5dcfc38b90f03$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $82c5dcfc38b90f03$var$padding(5), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$c57d6760d519c8ac = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(5), $82c5dcfc38b90f03$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $82c5dcfc38b90f03$var$padding(5), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$5fbcb08925249358 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(5), $82c5dcfc38b90f03$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $82c5dcfc38b90f03$var$join(""), $82c5dcfc38b90f03$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $82c5dcfc38b90f03$export$b3b2de96497acc47 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(6), $82c5dcfc38b90f03$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $82c5dcfc38b90f03$var$padding(6), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$7d21597c7bc64465 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(6), $82c5dcfc38b90f03$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $82c5dcfc38b90f03$var$padding(6), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$963cd24a38dd2f90 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(6), $82c5dcfc38b90f03$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $82c5dcfc38b90f03$var$join(""));
// base58 code
// -----------
const $82c5dcfc38b90f03$var$genBase58 = (abc)=>$82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix(58), $82c5dcfc38b90f03$var$alphabet(abc), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$export$61f53211c069eefb = /* @__PURE__ */ $82c5dcfc38b90f03$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $82c5dcfc38b90f03$export$c6a7baed2941aad2 = /* @__PURE__ */ $82c5dcfc38b90f03$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $82c5dcfc38b90f03$export$cbd4c72942a9201d = /* @__PURE__ */ $82c5dcfc38b90f03$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
// xmr ver is done in 8-byte blocks (which equals 11 chars in decoding). Last (non-full) block padded with '1' to size in XMR_BLOCK_LEN.
// Block encoding significantly reduces quadratic complexity of base58.
// Data len (index) -> encoded block len
const $82c5dcfc38b90f03$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $82c5dcfc38b90f03$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $82c5dcfc38b90f03$export$61f53211c069eefb.encode(block).padStart($82c5dcfc38b90f03$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $82c5dcfc38b90f03$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $82c5dcfc38b90f03$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $82c5dcfc38b90f03$export$fff625c574161df6 = /* @__PURE__ */ (sha256)=>$82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$checksum(4, (data)=>sha256(sha256(data))), $82c5dcfc38b90f03$export$61f53211c069eefb);
const $82c5dcfc38b90f03$var$BECH_ALPHABET = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $82c5dcfc38b90f03$var$join(""));
const $82c5dcfc38b90f03$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $82c5dcfc38b90f03$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $82c5dcfc38b90f03$var$POLYMOD_GENERATORS[i];
    return chk;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $82c5dcfc38b90f03$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $82c5dcfc38b90f03$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $82c5dcfc38b90f03$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $82c5dcfc38b90f03$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $82c5dcfc38b90f03$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $82c5dcfc38b90f03$var$BECH_ALPHABET.encode($82c5dcfc38b90f03$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $82c5dcfc38b90f03$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $82c5dcfc38b90f03$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $82c5dcfc38b90f03$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $82c5dcfc38b90f03$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$82c5dcfc38b90f03$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        str = lowered;
        const sepIndex = str.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = str.slice(0, sepIndex);
        const _words = str.slice(sepIndex + 1);
        if (_words.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $82c5dcfc38b90f03$var$BECH_ALPHABET.decode(_words).slice(0, -6);
        const sum = $82c5dcfc38b90f03$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!_words.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $82c5dcfc38b90f03$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    return {
        encode: encode,
        decode: decode,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $82c5dcfc38b90f03$export$27c42482533637da = /* @__PURE__ */ $82c5dcfc38b90f03$var$genBech32("bech32");
const $82c5dcfc38b90f03$export$4963f7e473ccf819 = /* @__PURE__ */ $82c5dcfc38b90f03$var$genBech32("bech32m");
const $82c5dcfc38b90f03$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $82c5dcfc38b90f03$export$834dfc94dde4b3d8 = /* @__PURE__ */ $82c5dcfc38b90f03$var$chain($82c5dcfc38b90f03$var$radix2(4), $82c5dcfc38b90f03$var$alphabet("0123456789abcdef"), $82c5dcfc38b90f03$var$join(""), $82c5dcfc38b90f03$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $82c5dcfc38b90f03$var$CODERS = {
    utf8: $82c5dcfc38b90f03$export$74329b762b589566,
    hex: $82c5dcfc38b90f03$export$834dfc94dde4b3d8,
    base16: $82c5dcfc38b90f03$export$586f61c71cb02fe4,
    base32: $82c5dcfc38b90f03$export$4a4d5965e2738b2a,
    base64: $82c5dcfc38b90f03$export$b3b2de96497acc47,
    base64url: $82c5dcfc38b90f03$export$7d21597c7bc64465,
    base58: $82c5dcfc38b90f03$export$61f53211c069eefb,
    base58xmr: $82c5dcfc38b90f03$export$e86cd8e7f8cff4a6
};
const $82c5dcfc38b90f03$var$coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
const $82c5dcfc38b90f03$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$82c5dcfc38b90f03$var$CODERS.hasOwnProperty(type)) throw new TypeError($82c5dcfc38b90f03$var$coderTypeError);
    if (!(bytes instanceof Uint8Array)) throw new TypeError("bytesToString() expects Uint8Array");
    return $82c5dcfc38b90f03$var$CODERS[type].encode(bytes);
};
const $82c5dcfc38b90f03$export$42d51816ce590c93 = $82c5dcfc38b90f03$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $82c5dcfc38b90f03$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$82c5dcfc38b90f03$var$CODERS.hasOwnProperty(type)) throw new TypeError($82c5dcfc38b90f03$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $82c5dcfc38b90f03$var$CODERS[type].decode(str);
};
const $82c5dcfc38b90f03$export$b3317979f9250576 = $82c5dcfc38b90f03$export$c8dd6bc66a63753c;

});




parcelRegister("oHv2a", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.recoverTypedSignature = module.exports.signTypedData = module.exports.typedSignatureHash = module.exports.TypedDataUtils = module.exports.TYPED_MESSAGE_SCHEMA = module.exports.SignTypedDataVersion = void 0;

var $fz3Xx = parcelRequire("fz3Xx");

var $k5SOY = parcelRequire("k5SOY");

var $1l6y6 = parcelRequire("1l6y6");

var $fB8Qz = parcelRequire("fB8Qz");

var $deXIT = parcelRequire("deXIT");
var $hLU0Z = parcelRequire("hLU0Z");

var $8ytum = parcelRequire("8ytum");

var $grbfr = parcelRequire("grbfr");
/**
 * Represents the version of `signTypedData` being used.
 *
 * V1 is based upon [an early version of
 * EIP-712](https://github.com/ethereum/EIPs/pull/712/commits/21abe254fe0452d8583d5b132b1d7be87c0439ca)
 * that lacked some later security improvements, and should generally be neglected in favor of
 * later versions.
 *
 * V3 is based on EIP-712, except that arrays and recursive data structures are not supported.
 *
 * V4 is based on EIP-712, and includes full support of arrays and recursive data structures.
 */ var $04a3fc1c05953f16$var$SignTypedDataVersion;
(function(SignTypedDataVersion) {
    SignTypedDataVersion["V1"] = "V1";
    SignTypedDataVersion["V3"] = "V3";
    SignTypedDataVersion["V4"] = "V4";
})($04a3fc1c05953f16$var$SignTypedDataVersion = module.exports.SignTypedDataVersion || (module.exports.SignTypedDataVersion = {}));
module.exports.TYPED_MESSAGE_SCHEMA = {
    type: "object",
    properties: {
        types: {
            type: "object",
            additionalProperties: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        name: {
                            type: "string"
                        },
                        type: {
                            type: "string"
                        }
                    },
                    required: [
                        "name",
                        "type"
                    ]
                }
            }
        },
        primaryType: {
            type: "string"
        },
        domain: {
            type: "object"
        },
        message: {
            type: "object"
        }
    },
    required: [
        "types",
        "primaryType",
        "domain",
        "message"
    ]
};
/**
 * Validate that the given value is a valid version string.
 *
 * @param version - The version value to validate.
 * @param allowedVersions - A list of allowed versions. If omitted, all versions are assumed to be
 * allowed.
 */ function $04a3fc1c05953f16$var$validateVersion(version, allowedVersions) {
    if (!Object.keys($04a3fc1c05953f16$var$SignTypedDataVersion).includes(version)) throw new Error(`Invalid version: '${version}'`);
    else if (allowedVersions && !allowedVersions.includes(version)) throw new Error(`SignTypedDataVersion not allowed: '${version}'. Allowed versions are: ${allowedVersions.join(", ")}`);
}
/**
 * Parse a string, number, or bigint value into a `Uint8Array`.
 *
 * @param type - The type of the value.
 * @param value - The value to parse.
 * @returns The parsed value.
 */ function $04a3fc1c05953f16$var$parseNumber(type, value) {
    (0, $hLU0Z.assert)(value !== null, `Unable to encode value: Invalid number. Expected a valid number value, but received "${value}".`);
    const bigIntValue = BigInt(value);
    const length = (0, $1l6y6.getLength)(type);
    const maxValue = BigInt(2) ** BigInt(length) - BigInt(1);
    // Note that this is not accurate, since the actual maximum value for unsigned
    // integers is `2 ^ (length - 1) - 1`, but this is required for backwards
    // compatibility with the old implementation.
    (0, $hLU0Z.assert)(bigIntValue >= -maxValue && bigIntValue <= maxValue, `Unable to encode value: Number "${value}" is out of range for type "${type}".`);
    return bigIntValue;
}
/**
 * Parse an address string to a `Uint8Array`. The behaviour of this is quite
 * strange, in that it does not parse the address as hexadecimal string, nor as
 * UTF-8. It does some weird stuff with the string and char codes, and then
 * returns the result as a `Uint8Array`.
 *
 * This is based on the old `ethereumjs-abi` implementation, which essentially
 * calls `new BN(address, 10)` on the address string, the equivalent of calling
 * `parseInt(address, 10)` in JavaScript. This is not a valid way to parse an
 * address and would result in `NaN` in plain JavaScript, but it is the
 * behaviour of the old implementation, and so we must preserve it for backwards
 * compatibility.
 *
 * @param address - The address to parse.
 * @returns The parsed address.
 */ function $04a3fc1c05953f16$var$reallyStrangeAddressToBytes(address) {
    let addressValue = BigInt(0);
    for(let i = 0; i < address.length; i++){
        const character = BigInt(address.charCodeAt(i) - 48);
        addressValue *= BigInt(10);
        // 'a'
        if (character >= 49) addressValue += character - BigInt(49) + BigInt(0xa);
        else if (character >= 17) addressValue += character - BigInt(17) + BigInt(0xa);
        else addressValue += character;
    }
    return (0, $fB8Qz.padStart)((0, $deXIT.bigIntToBytes)(addressValue), 20);
}
/**
 * Encode a single field.
 *
 * @param types - All type definitions.
 * @param name - The name of the field to encode.
 * @param type - The type of the field being encoded.
 * @param value - The value to encode.
 * @param version - The EIP-712 version the encoding should comply with.
 * @returns Encoded representation of the field.
 */ function $04a3fc1c05953f16$var$encodeField(types, name, type, // TODO: constrain type on `value`
value, version) {
    $04a3fc1c05953f16$var$validateVersion(version, [
        $04a3fc1c05953f16$var$SignTypedDataVersion.V3,
        $04a3fc1c05953f16$var$SignTypedDataVersion.V4
    ]);
    if (types[type] !== undefined) return [
        "bytes32",
        // TODO: return Buffer, remove string from return type
        version === $04a3fc1c05953f16$var$SignTypedDataVersion.V4 && value == null // eslint-disable-line no-eq-null
         ? "0x0000000000000000000000000000000000000000000000000000000000000000" : (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)($04a3fc1c05953f16$var$encodeData(type, value, types, version)))
    ];
    // `function` is supported in `@metamask/abi-utils`, but not allowed by
    // EIP-712, so we throw an error here.
    if (type === "function") throw new Error('Unsupported or invalid type: "function"');
    if (value === undefined) throw new Error(`missing value for field ${name} of type ${type}`);
    if (type === "address") {
        if (typeof value === "number") return [
            "address",
            (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(value), 20)
        ];
        else if ((0, $deXIT.isStrictHexString)(value)) return [
            "address",
            (0, $deXIT.add0x)(value)
        ];
        else if (typeof value === "string") return [
            "address",
            $04a3fc1c05953f16$var$reallyStrangeAddressToBytes(value).subarray(0, 20)
        ];
    }
    if (type === "bool") return [
        "bool",
        Boolean(value)
    ];
    if (type === "bytes") {
        if (typeof value === "number") value = (0, $deXIT.numberToBytes)(value);
        else if ((0, $deXIT.isStrictHexString)(value)) value = (0, $deXIT.hexToBytes)(value);
        else if (typeof value === "string") value = (0, $deXIT.stringToBytes)(value);
        return [
            "bytes32",
            (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)(value))
        ];
    }
    if (type.startsWith("bytes") && type !== "bytes" && !type.includes("[")) {
        if (typeof value === "number") {
            if (value < 0) return [
                "bytes32",
                new Uint8Array(32)
            ];
            return [
                "bytes32",
                (0, $deXIT.bigIntToBytes)(BigInt(value))
            ];
        } else if ((0, $deXIT.isStrictHexString)(value)) return [
            "bytes32",
            (0, $deXIT.hexToBytes)(value)
        ];
        return [
            "bytes32",
            value
        ];
    }
    if (type.startsWith("int") && !type.includes("[")) {
        const bigIntValue = $04a3fc1c05953f16$var$parseNumber(type, value);
        if (bigIntValue >= BigInt(0)) return [
            "uint256",
            bigIntValue
        ];
        return [
            "int256",
            bigIntValue
        ];
    }
    if (type === "string") {
        if (typeof value === "number") value = (0, $deXIT.numberToBytes)(value);
        else value = (0, $deXIT.stringToBytes)(value !== null && value !== void 0 ? value : "");
        return [
            "bytes32",
            (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)(value))
        ];
    }
    if (type.endsWith("]")) {
        if (version === $04a3fc1c05953f16$var$SignTypedDataVersion.V3) throw new Error("Arrays are unimplemented in encodeData; use V4 extension");
        const parsedType = type.slice(0, type.lastIndexOf("["));
        const typeValuePairs = value.map((item)=>$04a3fc1c05953f16$var$encodeField(types, name, parsedType, item, version));
        return [
            "bytes32",
            (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)((0, $k5SOY.encode)(typeValuePairs.map(([t])=>t), typeValuePairs.map(([, v])=>v))))
        ];
    }
    return [
        type,
        value
    ];
}
/**
 * Encodes an object by encoding and concatenating each of its members.
 *
 * @param primaryType - The root type.
 * @param data - The object to encode.
 * @param types - Type definitions for all types included in the message.
 * @param version - The EIP-712 version the encoding should comply with.
 * @returns An encoded representation of an object.
 */ function $04a3fc1c05953f16$var$encodeData(primaryType, data, types, version) {
    $04a3fc1c05953f16$var$validateVersion(version, [
        $04a3fc1c05953f16$var$SignTypedDataVersion.V3,
        $04a3fc1c05953f16$var$SignTypedDataVersion.V4
    ]);
    const encodedTypes = [
        "bytes32"
    ];
    const encodedValues = [
        $04a3fc1c05953f16$var$hashType(primaryType, types)
    ];
    for (const field of types[primaryType]){
        if (version === $04a3fc1c05953f16$var$SignTypedDataVersion.V3 && data[field.name] === undefined) continue;
        const [type, value] = $04a3fc1c05953f16$var$encodeField(types, field.name, field.type, data[field.name], version);
        encodedTypes.push(type);
        encodedValues.push(value);
    }
    return (0, $fz3Xx.arrToBufArr)((0, $k5SOY.encode)(encodedTypes, encodedValues));
}
/**
 * Encodes the type of an object by encoding a comma delimited list of its members.
 *
 * @param primaryType - The root type to encode.
 * @param types - Type definitions for all types included in the message.
 * @returns An encoded representation of the primary type.
 */ function $04a3fc1c05953f16$var$encodeType(primaryType, types) {
    let result = "";
    const unsortedDeps = $04a3fc1c05953f16$var$findTypeDependencies(primaryType, types);
    unsortedDeps.delete(primaryType);
    const deps = [
        primaryType,
        ...Array.from(unsortedDeps).sort()
    ];
    for (const type of deps){
        const children = types[type];
        if (!children) throw new Error(`No type definition specified: ${type}`);
        result += `${type}(${types[type].map(({ name: name, type: t })=>`${t} ${name}`).join(",")})`;
    }
    return result;
}
/**
 * Finds all types within a type definition object.
 *
 * @param primaryType - The root type.
 * @param types - Type definitions for all types included in the message.
 * @param results - The current set of accumulated types.
 * @returns The set of all types found in the type definition.
 */ function $04a3fc1c05953f16$var$findTypeDependencies(primaryType, types, results = new Set()) {
    if (typeof primaryType !== "string") throw new Error(`Invalid findTypeDependencies input ${JSON.stringify(primaryType)}`);
    const match = primaryType.match(/^\w*/u);
    [primaryType] = match;
    if (results.has(primaryType) || types[primaryType] === undefined) return results;
    results.add(primaryType);
    for (const field of types[primaryType])$04a3fc1c05953f16$var$findTypeDependencies(field.type, types, results);
    return results;
}
/**
 * Hashes an object.
 *
 * @param primaryType - The root type.
 * @param data - The object to hash.
 * @param types - Type definitions for all types included in the message.
 * @param version - The EIP-712 version the encoding should comply with.
 * @returns The hash of the object.
 */ function $04a3fc1c05953f16$var$hashStruct(primaryType, data, types, version) {
    $04a3fc1c05953f16$var$validateVersion(version, [
        $04a3fc1c05953f16$var$SignTypedDataVersion.V3,
        $04a3fc1c05953f16$var$SignTypedDataVersion.V4
    ]);
    const encoded = $04a3fc1c05953f16$var$encodeData(primaryType, data, types, version);
    const hashed = (0, $8ytum.keccak256)(encoded);
    const buf = (0, $fz3Xx.arrToBufArr)(hashed);
    return buf;
}
/**
 * Hashes the type of an object.
 *
 * @param primaryType - The root type to hash.
 * @param types - Type definitions for all types included in the message.
 * @returns The hash of the object type.
 */ function $04a3fc1c05953f16$var$hashType(primaryType, types) {
    const encodedHashType = (0, $deXIT.stringToBytes)($04a3fc1c05953f16$var$encodeType(primaryType, types));
    return (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)(encodedHashType));
}
/**
 * Removes properties from a message object that are not defined per EIP-712.
 *
 * @param data - The typed message object.
 * @returns The typed message object with only allowed fields.
 */ function $04a3fc1c05953f16$var$sanitizeData(data) {
    const sanitizedData = {};
    for(const key in module.exports.TYPED_MESSAGE_SCHEMA.properties)if (data[key]) sanitizedData[key] = data[key];
    if ("types" in sanitizedData) // TODO: Fix types
    sanitizedData.types = Object.assign({
        EIP712Domain: []
    }, sanitizedData.types);
    return sanitizedData;
}
/**
 * Create a EIP-712 Domain Hash.
 * This hash is used at the top of the EIP-712 encoding.
 *
 * @param typedData - The typed message to hash.
 * @param version - The EIP-712 version the encoding should comply with.
 * @returns The hash of the domain object.
 */ function $04a3fc1c05953f16$var$eip712DomainHash(typedData, version) {
    $04a3fc1c05953f16$var$validateVersion(version, [
        $04a3fc1c05953f16$var$SignTypedDataVersion.V3,
        $04a3fc1c05953f16$var$SignTypedDataVersion.V4
    ]);
    const sanitizedData = $04a3fc1c05953f16$var$sanitizeData(typedData);
    const { domain: domain } = sanitizedData;
    const domainType = {
        EIP712Domain: sanitizedData.types.EIP712Domain
    };
    return $04a3fc1c05953f16$var$hashStruct("EIP712Domain", domain, domainType, version);
}
/**
 * Hash a typed message according to EIP-712. The returned message starts with the EIP-712 prefix,
 * which is "1901", followed by the hash of the domain separator, then the data (if any).
 * The result is hashed again and returned.
 *
 * This function does not sign the message. The resulting hash must still be signed to create an
 * EIP-712 signature.
 *
 * @param typedData - The typed message to hash.
 * @param version - The EIP-712 version the encoding should comply with.
 * @returns The hash of the typed message.
 */ function $04a3fc1c05953f16$var$eip712Hash(typedData, version) {
    $04a3fc1c05953f16$var$validateVersion(version, [
        $04a3fc1c05953f16$var$SignTypedDataVersion.V3,
        $04a3fc1c05953f16$var$SignTypedDataVersion.V4
    ]);
    const sanitizedData = $04a3fc1c05953f16$var$sanitizeData(typedData);
    const parts = [
        (0, $deXIT.hexToBytes)("1901")
    ];
    parts.push($04a3fc1c05953f16$var$eip712DomainHash(typedData, version));
    if (sanitizedData.primaryType !== "EIP712Domain") parts.push($04a3fc1c05953f16$var$hashStruct(// TODO: Validate that this is a string, so this type cast can be removed.
    sanitizedData.primaryType, sanitizedData.message, sanitizedData.types, version));
    return (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)((0, $deXIT.concatBytes)(parts)));
}
/**
 * A collection of utility functions used for signing typed data.
 */ module.exports.TypedDataUtils = {
    encodeData: $04a3fc1c05953f16$var$encodeData,
    encodeType: $04a3fc1c05953f16$var$encodeType,
    findTypeDependencies: $04a3fc1c05953f16$var$findTypeDependencies,
    hashStruct: $04a3fc1c05953f16$var$hashStruct,
    hashType: $04a3fc1c05953f16$var$hashType,
    sanitizeData: $04a3fc1c05953f16$var$sanitizeData,
    eip712Hash: $04a3fc1c05953f16$var$eip712Hash,
    eip712DomainHash: $04a3fc1c05953f16$var$eip712DomainHash
};
/**
 * Generate the "V1" hash for the provided typed message.
 *
 * The hash will be generated in accordance with an earlier version of the EIP-712
 * specification. This hash is used in `signTypedData_v1`.
 *
 * @param typedData - The typed message.
 * @returns The '0x'-prefixed hex encoded hash representing the type of the provided message.
 */ function $04a3fc1c05953f16$var$typedSignatureHash(typedData) {
    const hashBuffer = $04a3fc1c05953f16$var$_typedSignatureHash(typedData);
    return (0, $deXIT.bytesToHex)(hashBuffer);
}
module.exports.typedSignatureHash = $04a3fc1c05953f16$var$typedSignatureHash;
/**
 * Normalize a value, so that `@metamask/abi-utils` can handle it. This
 * matches the behaviour of the `ethereumjs-abi` library.
 *
 * @param type - The type of the value to normalize.
 * @param value - The value to normalize.
 * @returns The normalized value.
 */ function $04a3fc1c05953f16$var$normalizeValue(type, value) {
    if ((0, $1l6y6.isArrayType)(type) && Array.isArray(value)) {
        const [innerType] = (0, $1l6y6.getArrayType)(type);
        return value.map((item)=>$04a3fc1c05953f16$var$normalizeValue(innerType, item));
    }
    if (type === "address") {
        if (typeof value === "number") return (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(value), 20);
        if ((0, $deXIT.isStrictHexString)(value)) return (0, $fB8Qz.padStart)((0, $deXIT.hexToBytes)(value).subarray(0, 20), 20);
        if (value instanceof Uint8Array) return (0, $fB8Qz.padStart)(value.subarray(0, 20), 20);
    }
    if (type === "bool") return Boolean(value);
    if (type.startsWith("bytes") && type !== "bytes") {
        const length = (0, $1l6y6.getByteLength)(type);
        if (typeof value === "number") {
            if (value < 0) // `solidityPack(['bytesN'], [-1])` returns `0x00..00`.
            return new Uint8Array();
            return (0, $deXIT.numberToBytes)(value).subarray(0, length);
        }
        if ((0, $deXIT.isStrictHexString)(value)) return (0, $deXIT.hexToBytes)(value).subarray(0, length);
        if (value instanceof Uint8Array) return value.subarray(0, length);
    }
    if (type.startsWith("uint")) {
        if (typeof value === "number") return Math.abs(value);
    }
    if (type.startsWith("int")) {
        if (typeof value === "number") {
            const length = (0, $1l6y6.getLength)(type);
            return BigInt.asIntN(length, BigInt(value));
        }
    }
    return value;
}
/**
 * For some reason `ethereumjs-abi` treats `address` and `address[]` differently
 * so we need to normalize `address[]` differently.
 *
 * @param values - The values to normalize.
 * @returns The normalized values.
 */ function $04a3fc1c05953f16$var$normalizeAddresses(values) {
    return values.map((value)=>{
        if (typeof value === "number") return (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(value), 32);
        if ((0, $deXIT.isStrictHexString)(value)) return (0, $fB8Qz.padStart)((0, $deXIT.hexToBytes)(value).subarray(0, 32), 32);
        if (value instanceof Uint8Array) return (0, $fB8Qz.padStart)(value.subarray(0, 32), 32);
        return value;
    });
}
/**
 * For some reason `ethereumjs-abi` treats `intN` and `intN[]` differently
 * so we need to normalize `intN[]` differently.
 *
 * @param type - The type of the value to normalize.
 * @param values - The values to normalize.
 * @returns The normalized values.
 */ function $04a3fc1c05953f16$var$normalizeIntegers(type, values) {
    return values.map((value)=>{
        if (typeof value === "string" || typeof value === "number" || typeof value === "bigint") {
            const bigIntValue = $04a3fc1c05953f16$var$parseNumber(type, value);
            if (bigIntValue >= BigInt(0)) return (0, $fB8Qz.padStart)((0, $deXIT.bigIntToBytes)(bigIntValue), 32);
            const length = (0, $1l6y6.getLength)(type);
            const asIntN = BigInt.asIntN(length, bigIntValue);
            return (0, $deXIT.signedBigIntToBytes)(asIntN, 32);
        }
        return value;
    });
}
/**
 * Generate the "V1" hash for the provided typed message.
 *
 * The hash will be generated in accordance with an earlier version of the EIP-712
 * specification. This hash is used in `signTypedData_v1`.
 *
 * @param typedData - The typed message.
 * @returns The hash representing the type of the provided message.
 */ function $04a3fc1c05953f16$var$_typedSignatureHash(typedData) {
    const error = new Error("Expect argument to be non-empty array");
    if (typeof typedData !== "object" || !("length" in typedData) || !typedData.length) throw error;
    const normalizedData = typedData.map(({ name: name, type: type, value: value })=>{
        // Handle an edge case with `address[]` types.
        if (type === "address[]") return {
            name: name,
            type: "bytes32[]",
            value: $04a3fc1c05953f16$var$normalizeAddresses(value)
        };
        // Handle an edge case with `intN[]` types.
        if (type.startsWith("int") && (0, $1l6y6.isArrayType)(type)) {
            const [innerType, length] = (0, $1l6y6.getArrayType)(type);
            return {
                name: name,
                type: `bytes32[${length !== null && length !== void 0 ? length : ""}]`,
                value: $04a3fc1c05953f16$var$normalizeIntegers(innerType, value)
            };
        }
        return {
            name: name,
            type: type,
            value: $04a3fc1c05953f16$var$normalizeValue(type, value)
        };
    });
    const data = normalizedData.map((e)=>{
        if (e.type !== "bytes") return e.value;
        return (0, $grbfr.legacyToBuffer)(e.value);
    });
    const types = normalizedData.map((e)=>{
        if (e.type === "function") throw new Error('Unsupported or invalid type: "function"');
        return e.type;
    });
    const schema = typedData.map((e)=>{
        if (!e.name) throw error;
        return `${e.type} ${e.name}`;
    });
    return (0, $fz3Xx.arrToBufArr)((0, $8ytum.keccak256)((0, $k5SOY.encodePacked)([
        "bytes32",
        "bytes32"
    ], [
        (0, $8ytum.keccak256)((0, $k5SOY.encodePacked)([
            "string[]"
        ], [
            schema
        ], true)),
        (0, $8ytum.keccak256)((0, $k5SOY.encodePacked)(types, data, true))
    ])));
}
/**
 * Sign typed data according to EIP-712. The signing differs based upon the `version`.
 *
 * V1 is based upon [an early version of
 * EIP-712](https://github.com/ethereum/EIPs/pull/712/commits/21abe254fe0452d8583d5b132b1d7be87c0439ca)
 * that lacked some later security improvements, and should generally be neglected in favor of
 * later versions.
 *
 * V3 is based on [EIP-712](https://eips.ethereum.org/EIPS/eip-712), except that arrays and
 * recursive data structures are not supported.
 *
 * V4 is based on [EIP-712](https://eips.ethereum.org/EIPS/eip-712), and includes full support of
 * arrays and recursive data structures.
 *
 * @param options - The signing options.
 * @param options.privateKey - The private key to sign with.
 * @param options.data - The typed data to sign.
 * @param options.version - The signing version to use.
 * @returns The '0x'-prefixed hex encoded signature.
 */ function $04a3fc1c05953f16$var$signTypedData({ privateKey: privateKey, data: data, version: version }) {
    $04a3fc1c05953f16$var$validateVersion(version);
    if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(privateKey)) throw new Error("Missing private key parameter");
    const messageHash = version === $04a3fc1c05953f16$var$SignTypedDataVersion.V1 ? $04a3fc1c05953f16$var$_typedSignatureHash(data) : module.exports.TypedDataUtils.eip712Hash(data, version);
    const sig = (0, $fz3Xx.ecsign)(messageHash, privateKey);
    return (0, $grbfr.concatSig)((0, $fz3Xx.arrToBufArr)((0, $deXIT.bigIntToBytes)(sig.v)), sig.r, sig.s);
}
module.exports.signTypedData = $04a3fc1c05953f16$var$signTypedData;
/**
 * Recover the address of the account that created the given EIP-712
 * signature. The version provided must match the version used to
 * create the signature.
 *
 * @param options - The signature recovery options.
 * @param options.data - The typed data that was signed.
 * @param options.signature - The '0x-prefixed hex encoded message signature.
 * @param options.version - The signing version to use.
 * @returns The '0x'-prefixed hex address of the signer.
 */ function $04a3fc1c05953f16$var$recoverTypedSignature({ data: data, signature: signature, version: version }) {
    $04a3fc1c05953f16$var$validateVersion(version);
    if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(signature)) throw new Error("Missing signature parameter");
    const messageHash = version === $04a3fc1c05953f16$var$SignTypedDataVersion.V1 ? $04a3fc1c05953f16$var$_typedSignatureHash(data) : module.exports.TypedDataUtils.eip712Hash(data, version);
    const publicKey = (0, $grbfr.recoverPublicKey)(messageHash, signature);
    const sender = (0, $fz3Xx.publicToAddress)(publicKey);
    return (0, $deXIT.bytesToHex)(sender);
}
module.exports.recoverTypedSignature = $04a3fc1c05953f16$var$recoverTypedSignature;

});
parcelRegister("k5SOY", function(module, exports) {
"use strict";
var $ea0ecca1a4584530$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ea0ecca1a4584530$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $ea0ecca1a4584530$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$ea0ecca1a4584530$var$__exportStar((parcelRequire("eXBiX")), module.exports);

$ea0ecca1a4584530$var$__exportStar((parcelRequire("ck8zU")), module.exports);

$ea0ecca1a4584530$var$__exportStar((parcelRequire("7l5Ti")), module.exports);

});
parcelRegister("eXBiX", function(module, exports) {
"use strict";
// ESLint gets confused by the nested list and tables in the docs, so we disable
// the rule for this file.
/* eslint-disable jsdoc/check-indentation, jsdoc/match-description */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decodeSingle = module.exports.decode = module.exports.encodePacked = module.exports.encodeSingle = module.exports.encode = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $5dW8D = parcelRequire("5dW8D");

var $ck8zU = parcelRequire("ck8zU");

var $KpnIb = parcelRequire("KpnIb");
/**
 * Encode the data with the provided types. The types must be valid Solidity
 * ABI types.
 *
 * This will attempt to parse the values into the correct types. For example,
 * if you pass in a hex string for a `uint256`, it will be parsed into a
 * `bigint`. Regular strings are interpreted as UTF-8 strings. If you want to
 * pass in a hex string, you must pass it in as a `Uint8Array`, or use the
 * "0x"-prefix.
 *
 * It will also attempt to infer the types of the values. For example, if you
 * pass in a string for a `uint256`, it will result in a TypeScript compile-time
 * error. This does not work for all types, however. For example, if you use
 * nested arrays or tuples, the type will be inferred as `unknown`.
 *
 * The following types are supported:
 *
 * - `address`: A 20-byte Ethereum address.
 *   - As a 40-character-long hexadecimal string, starting with "0x".
 *   - As a 20-byte-long byte array, i.e., `Uint8Array`.
 * - `bool`: A boolean value.
 *   - As a boolean literal, i.e., `true` or `false`.
 *   - As the strings "true" or "false".
 * - `bytes(n)`: A dynamic byte array.
 *   - As a hexadecimal string, starting with "0x".
 *   - As a byte array, i.e., `Uint8Array`.
 *   - As a regular string, which will be interpreted as UTF-8.
 * - `function`: A Solidity function.
 *   - As a 48-character-long hexadecimal string, starting with "0x".
 *   - As a 24-byte-long byte array, i.e., `Uint8Array`.
 *   - As a {@link SolidityFunction} object.
 * - `int(n)`: A signed integer.
 *   - As a number.
 *   - As a `bigint`.
 *   - As a hexadecimal string, starting with "0x".
 * - `string`: A dynamic UTF-8 string.
 *   - As a regular string.
 *   - As a hexadecimal string, starting with "0x".
 *   - As a byte array, i.e., `Uint8Array`.
 * - `tuple`: A tuple of values.
 *   - As an array of values.
 * - `uint(n)`: An unsigned integer.
 *   - As a number.
 *   - As a `bigint`.
 *   - As a hexadecimal string, starting with "0x".
 *
 * @example
 * ```typescript
 * import { encode, decode } from '@metamask/abi-utils';
 *
 * const types = ['uint256', 'string'];
 * const encoded = encode(types, [42, 'Hello, world!']);
 * const decoded = decode(types, encoded);
 *
 * console.log(decoded); // [42n, 'Hello, world!']
 * ```
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html
 * @param types - The types to encode.
 * @param values - The values to encode. This array must have the same length as
 * the types array.
 * @param packed - Whether to use the non-standard packed mode. Defaults to
 * `false`.
 * @param tight - Whether to pack the values tightly. When enabled, the values
 * will be packed without any padding. This matches the behaviour of
 * `ethereumjs-abi`. Defaults to `false`.
 * @returns The ABI encoded bytes.
 */ const $ae438350d1bff840$var$encode = (types, values, packed, tight)=>{
    try {
        return (0, $KpnIb.pack)({
            types: types,
            values: values,
            packed: packed,
            tight: tight
        });
    } catch (error) {
        if (error instanceof $ck8zU.ParserError) throw new $ck8zU.ParserError(`Unable to encode value: ${error.message}`, error);
        throw new $ck8zU.ParserError(`An unexpected error occurred: ${(0, $ck8zU.getErrorMessage)(error)}`, error);
    }
};
module.exports.encode = $ae438350d1bff840$var$encode;
/**
 * Encode the data with the provided type. The type must be a valid Solidity
 * ABI type.
 *
 * See {@link encode} for more information on how values are parsed.
 *
 * @example
 * ```typescript
 * import { encodeSingle, decodeSingle } from '@metamask/abi-utils';
 *
 * const encoded = encodeSingle('uint256', 42);
 * const decoded = decodeSingle('uint256', encoded);
 *
 * console.log(decoded); // 42n
 * ```
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html#types
 * @param type - The type to encode.
 * @param value - The value to encode.
 * @returns The ABI encoded bytes.
 */ const $ae438350d1bff840$var$encodeSingle = (type, value)=>{
    return (0, module.exports.encode)([
        type
    ], [
        value
    ]);
};
module.exports.encodeSingle = $ae438350d1bff840$var$encodeSingle;
/**
 * Encode the data with the provided types. The types must be valid Solidity
 * ABI types. This is similar to {@link encode}, but the values are encoded in
 * the non-standard packed mode. This differs from the standard encoding in the
 * following ways:
 *
 * - Most values are packed tightly, without alignment padding.
 *   - The exception is array values, which are padded to 32 bytes.
 * - Values are still padded to their full size, i.e., `uint16` values are still
 *  padded to 2 bytes, regardless of the length of the value.
 * - The encoding of dynamic types (`bytes`, `string`) is different. The length
 * of the dynamic type is not included in the encoding, and the dynamic type is
 * not padded to a multiple of 32 bytes.
 * - All values are encoded in-place, without any offsets.
 *
 * The encoding of this is ambiguous as soon as there is more than one dynamic
 * type. That means that these values cannot be decoded with {@link decode} or
 * Solidity's `abi.decode` function.
 *
 * See {@link encode} for more information on how values are parsed.
 *
 * @example
 * ```typescript
 * import { encodePacked } from '@metamask/abi-utils';
 *
 * const encoded = encodePacked(['uint8'], [42]);
 *
 * console.log(encoded); // `Uint8Array [ 42 ]`
 * ```
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html#types
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html#non-standard-packed-mode
 * @param types - The types to encode.
 * @param values - The values to encode.
 * @param tight - Whether to pack the values tightly. When enabled, `bytesN`
 * values in arrays will be packed without any padding. This matches the
 * behaviour of `ethereumjs-abi`. Defaults to `false`.
 * @returns The ABI encoded bytes.
 */ const $ae438350d1bff840$var$encodePacked = (types, values, tight)=>{
    return (0, module.exports.encode)(types, values, true, tight);
};
module.exports.encodePacked = $ae438350d1bff840$var$encodePacked;
/**
 * Decode an ABI encoded buffer with the specified types. The types must be
 * valid Solidity ABI types.
 *
 * This will attempt to infer the output types from the input types. For
 * example, if you use `uint256` as an input type, the output type will be
 * `bigint`. This does not work for all types, however. For example, if you use
 * nested array types or tuple types, the output type will be `unknown`.
 *
 * The resulting types of the values will be as follows:
 *
 * | Contract ABI Type | Resulting JavaScript Type |
 * | ----------------- | ------------------------- |
 * | `address`         | `string`                  |
 * | `bool`            | `boolean`                 |
 * | `bytes(n)`        | `Uint8Array`              |
 * | `function`        | {@link SolidityFunction}  |
 * | `int(n)`          | `bigint`                  |
 * | `string`          | `string`                  |
 * | `tuple`           | `Array`                   |
 * | `array`           | `Array`                   |
 * | `uint(n)`         | `bigint`                  |
 *
 * @example
 * ```typescript
 * import { encode, decode } from '@metamask/abi-utils';
 *
 * const types = ['uint256', 'string'];
 * const encoded = encode(types, [42, 'Hello, world!']);
 * const decoded = decode(types, encoded);
 *
 * console.log(decoded); // [42n, 'Hello, world!']
 * ```
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html#types
 * @param types - The types to decode the bytes with.
 * @param value - The bytes-like value to decode.
 * @returns The decoded values as array.
 */ const $ae438350d1bff840$var$decode = (types, value)=>{
    const bytes = (0, $5dW8D.createBytes)(value);
    try {
        return (0, $KpnIb.unpack)(types, bytes);
    } catch (error) {
        if (error instanceof $ck8zU.ParserError) throw new $ck8zU.ParserError(`Unable to decode value: ${error.message}`, error);
        throw new $ck8zU.ParserError(`An unexpected error occurred: ${(0, $ck8zU.getErrorMessage)(error)}`, error);
    }
};
module.exports.decode = $ae438350d1bff840$var$decode;
/**
 * Decode the data with the provided type. The type must be a valid Solidity
 * ABI type.
 *
 * See {@link decode} for more information on how values are parsed.
 *
 * @example
 * ```typescript
 * import { encodeSingle, decodeSingle } from '@metamask/abi-utils';
 *
 * const encoded = encodeSingle('uint256', 42);
 * const decoded = decodeSingle('uint256', encoded);
 *
 * console.log(decoded); // 42n
 * ```
 * @see https://docs.soliditylang.org/en/v0.8.17/abi-spec.html#types
 * @param type - The type to decode.
 * @param value - The bytes-like value to decode.
 * @returns The decoded value.
 */ const $ae438350d1bff840$var$decodeSingle = (type, value)=>{
    const result = (0, module.exports.decode)([
        type
    ], value);
    (0, $hLU0Z.assert)(result.length === 1, new $ck8zU.ParserError("Decoded value array has unexpected length."));
    return result[0];
};
module.exports.decodeSingle = $ae438350d1bff840$var$decodeSingle;

});
parcelRegister("5dW8D", function(module, exports) {

$parcel$export(module.exports, "createBigInt", function () { return $5d39bff72389c8fb$export$4adb1f4585644a5f; });
$parcel$export(module.exports, "createBytes", function () { return $5d39bff72389c8fb$export$47b4b5de82359b9; });

var $deXIT = parcelRequire("deXIT");

var $hLU0Z = parcelRequire("hLU0Z");

var $iclp6 = parcelRequire("iclp6");
var $5d39bff72389c8fb$var$NumberLikeStruct = (0, $iclp6.union)([
    (0, $iclp6.number)(),
    (0, $iclp6.bigint)(),
    (0, $iclp6.string)(),
    (0, $deXIT.StrictHexStruct)
]);
var $5d39bff72389c8fb$var$NumberCoercer = (0, $iclp6.coerce)((0, $iclp6.number)(), $5d39bff72389c8fb$var$NumberLikeStruct, Number);
var $5d39bff72389c8fb$var$BigIntCoercer = (0, $iclp6.coerce)((0, $iclp6.bigint)(), $5d39bff72389c8fb$var$NumberLikeStruct, BigInt);
var $5d39bff72389c8fb$var$BytesLikeStruct = (0, $iclp6.union)([
    (0, $deXIT.StrictHexStruct),
    (0, $iclp6.instance)(Uint8Array)
]);
var $5d39bff72389c8fb$var$BytesCoercer = (0, $iclp6.coerce)((0, $iclp6.instance)(Uint8Array), (0, $iclp6.union)([
    (0, $deXIT.StrictHexStruct)
]), (0, $deXIT.hexToBytes));
var $5d39bff72389c8fb$var$HexCoercer = (0, $iclp6.coerce)((0, $deXIT.StrictHexStruct), (0, $iclp6.instance)(Uint8Array), (0, $deXIT.bytesToHex));
function $5d39bff72389c8fb$export$763ee9f6477981ab(value) {
    try {
        const result = (0, $iclp6.create)(value, $5d39bff72389c8fb$var$NumberCoercer);
        (0, $hLU0Z.assert)(Number.isFinite(result), `Expected a number-like value, got "${value}".`);
        return result;
    } catch (error) {
        if (error instanceof (0, $iclp6.StructError)) throw new Error(`Expected a number-like value, got "${value}".`);
        throw error;
    }
}
function $5d39bff72389c8fb$export$4adb1f4585644a5f(value) {
    try {
        return (0, $iclp6.create)(value, $5d39bff72389c8fb$var$BigIntCoercer);
    } catch (error) {
        if (error instanceof (0, $iclp6.StructError)) throw new Error(`Expected a number-like value, got "${String(error.value)}".`);
        throw error;
    }
}
function $5d39bff72389c8fb$export$47b4b5de82359b9(value) {
    if (typeof value === "string" && value.toLowerCase() === "0x") return new Uint8Array();
    try {
        return (0, $iclp6.create)(value, $5d39bff72389c8fb$var$BytesCoercer);
    } catch (error) {
        if (error instanceof (0, $iclp6.StructError)) throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
        throw error;
    }
}
function $5d39bff72389c8fb$export$9cafd9970d25a17c(value) {
    if (value instanceof Uint8Array && value.length === 0 || typeof value === "string" && value.toLowerCase() === "0x") return "0x";
    try {
        return (0, $iclp6.create)(value, $5d39bff72389c8fb$var$HexCoercer);
    } catch (error) {
        if (error instanceof (0, $iclp6.StructError)) throw new Error(`Expected a bytes-like value, got "${String(error.value)}".`);
        throw error;
    }
}

});

parcelRegister("ck8zU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ParserError = module.exports.getErrorStack = module.exports.getErrorMessage = void 0;

var $6mp4V = parcelRequire("6mp4V");
/**
 * Attempt to get an error message from a value.
 *
 * - If the value is an error, the error's message is returned.
 * - If the value is an object with a `message` property, the value of that
 * property is returned.
 * - If the value is a string, the value is returned.
 * - Otherwise, "Unknown error." is returned.
 *
 * @param error - The value to get an error message from.
 * @returns The error message.
 * @internal
 */ const $8f8e01be2a22f0ec$var$getErrorMessage = (error)=>{
    if (typeof error === "string") return error;
    if (error instanceof Error) return error.message;
    if ((0, $6mp4V.isObject)(error) && (0, $6mp4V.hasProperty)(error, "message") && typeof error.message === "string") return error.message;
    return "Unknown error.";
};
module.exports.getErrorMessage = $8f8e01be2a22f0ec$var$getErrorMessage;
/**
 * Get the error stack from a value. If the value is an error, the error's stack
 * is returned. Otherwise, it returns `undefined`.
 *
 * @param error - The value to get an error stack from.
 * @returns The error stack, or `undefined` if the value is not an error.
 * @internal
 */ const $8f8e01be2a22f0ec$var$getErrorStack = (error)=>{
    if (error instanceof Error) return error.stack;
    return undefined;
};
module.exports.getErrorStack = $8f8e01be2a22f0ec$var$getErrorStack;
/**
 * An error that is thrown when the ABI encoder or decoder encounters an
 * issue.
 */ class $8f8e01be2a22f0ec$var$ParserError extends Error {
    constructor(message, originalError){
        super(message);
        this.name = "ParserError";
        const originalStack = (0, module.exports.getErrorStack)(originalError);
        if (originalStack) this.stack = originalStack;
    }
}
module.exports.ParserError = $8f8e01be2a22f0ec$var$ParserError;

});

parcelRegister("KpnIb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.unpack = module.exports.pack = module.exports.isDynamicParser = module.exports.getParser = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $deXIT = parcelRequire("deXIT");

var $ck8zU = parcelRequire("ck8zU");

var $1HIrY = parcelRequire("1HIrY");

var $1l6y6 = parcelRequire("1l6y6");

var $fB8Qz = parcelRequire("fB8Qz");
/**
 * Get the parser for the specified type.
 *
 * @param type - The type to get a parser for.
 * @returns The parser.
 * @throws If there is no parser for the specified type.
 */ const $08b7fc3810284389$var$getParser = (type)=>{
    const parsers = {
        address: $1l6y6.address,
        array: $1l6y6.array,
        bool: $1l6y6.bool,
        bytes: $1l6y6.bytes,
        fixedBytes: $1l6y6.fixedBytes,
        function: $1l6y6.fn,
        number: $1l6y6.number,
        string: $1l6y6.string,
        tuple: $1l6y6.tuple
    };
    const staticParser = parsers[type];
    if (staticParser) return staticParser;
    const parser = Object.values(parsers).find((value)=>value.isType(type));
    if (parser) return parser;
    throw new $ck8zU.ParserError(`The type "${type}" is not supported.`);
};
module.exports.getParser = $08b7fc3810284389$var$getParser;
/**
 * Check if the specified parser is dynamic, for the provided types. This is
 * primarily used for parsing tuples, where a tuple can be dynamic based on the
 * types. For other parsers, it will simply use the set `isDynamic` value.
 *
 * @param parser - The parser to check.
 * @param type - The type to check the parser with.
 * @returns Whether the parser is dynamic.
 */ const $08b7fc3810284389$var$isDynamicParser = (parser, type)=>{
    const { isDynamic: isDynamic } = parser;
    if (typeof isDynamic === "function") return isDynamic(type);
    return isDynamic;
};
module.exports.isDynamicParser = $08b7fc3810284389$var$isDynamicParser;
/**
 * Pack the provided values in a buffer, encoded with the specified types. If a
 * buffer is specified, the resulting value will be concatenated with the
 * buffer.
 *
 * @param args - The arguments object.
 * @param args.types - The types of the values to pack.
 * @param args.values - The values to pack.
 * @param args.packed - Whether to use the non-standard packed mode. Defaults to
 * `false`.
 * @param args.arrayPacked - Whether to use the non-standard packed mode for
 * arrays. Defaults to `false`.
 * @param args.byteArray - The byte array to encode the values into. Defaults to
 * an empty array.
 * @param args.tight - Whether to use tight packing mode. Only applicable when
 * `packed` is true. When true, the packed mode will not add any padding bytes.
 * This matches the packing behaviour of `ethereumjs-abi`, but is not standard.
 * @returns The resulting encoded buffer.
 */ const $08b7fc3810284389$var$pack = ({ types: types, values: values, packed: packed = false, tight: tight = false, arrayPacked: arrayPacked = false, byteArray: byteArray = new Uint8Array() })=>{
    (0, $hLU0Z.assert)(types.length === values.length, new $ck8zU.ParserError(`The number of types (${types.length}) does not match the number of values (${values.length}).`));
    const { staticBuffer: staticBuffer, dynamicBuffer: dynamicBuffer, pointers: pointers } = types.reduce(// eslint-disable-next-line @typescript-eslint/no-shadow
    ({ staticBuffer: staticBuffer, dynamicBuffer: dynamicBuffer, pointers: pointers }, type, index)=>{
        const parser = (0, module.exports.getParser)(type);
        const value = values[index];
        // If packed mode is enabled, we can skip the dynamic check, as all
        // values are encoded in the static buffer.
        if (packed || arrayPacked || !(0, module.exports.isDynamicParser)(parser, type)) return {
            staticBuffer: parser.encode({
                buffer: staticBuffer,
                value: value,
                type: type,
                packed: packed,
                tight: tight
            }),
            dynamicBuffer: dynamicBuffer,
            pointers: pointers
        };
        const newStaticBuffer = (0, $deXIT.concatBytes)([
            staticBuffer,
            new Uint8Array(32)
        ]);
        const newDynamicBuffer = parser.encode({
            buffer: dynamicBuffer,
            value: value,
            type: type,
            packed: packed,
            tight: tight
        });
        return {
            staticBuffer: newStaticBuffer,
            dynamicBuffer: newDynamicBuffer,
            pointers: [
                ...pointers,
                {
                    position: staticBuffer.length,
                    pointer: dynamicBuffer.length
                }
            ]
        };
    }, {
        staticBuffer: new Uint8Array(),
        dynamicBuffer: new Uint8Array(),
        pointers: []
    });
    // If packed mode is enabled, there shouldn't be any dynamic values.
    (0, $hLU0Z.assert)(!packed && !arrayPacked || dynamicBuffer.length === 0, new $ck8zU.ParserError("Invalid pack state."));
    const dynamicStart = staticBuffer.length;
    const updatedBuffer = pointers.reduce((target, { pointer: pointer, position: position })=>{
        const offset = (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(dynamicStart + pointer));
        return (0, $fB8Qz.set)(target, offset, position);
    }, staticBuffer);
    return (0, $deXIT.concatBytes)([
        byteArray,
        updatedBuffer,
        dynamicBuffer
    ]);
};
module.exports.pack = $08b7fc3810284389$var$pack;
const $08b7fc3810284389$var$unpack = (types, buffer)=>{
    const iterator = (0, $1HIrY.iterate)(buffer);
    return types.map((type)=>{
        const { value: { value: value, skip: skip }, done: done } = iterator.next();
        (0, $hLU0Z.assert)(!done, new $ck8zU.ParserError(`The encoded value is invalid for the provided types. Reached end of buffer while attempting to parse "${type}".`));
        const parser = (0, module.exports.getParser)(type);
        const isDynamic = (0, module.exports.isDynamicParser)(parser, type);
        if (isDynamic) {
            const pointer = (0, $deXIT.bytesToNumber)(value.subarray(0, 32));
            const target = buffer.subarray(pointer);
            return parser.decode({
                type: type,
                value: target,
                skip: skip
            });
        }
        return parser.decode({
            type: type,
            value: value,
            skip: skip
        });
    });
};
module.exports.unpack = $08b7fc3810284389$var$unpack;

});
parcelRegister("1HIrY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.iterate = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
/**
 * Iterate over a buffer with the specified size. This will yield a part of the
 * buffer starting at an increment of the specified size, until the end of the
 * buffer is reached.
 *
 * Calling the `skip` function will make it skip the specified number of bytes.
 *
 * @param buffer - The buffer to iterate over.
 * @param size - The number of bytes to iterate with.
 * @returns An iterator that yields the parts of the byte array.
 * @yields The parts of the byte array.
 */ const $13dc4975bfa51bfd$var$iterate = function*(buffer, size = 32) {
    for(let pointer = 0; pointer < buffer.length; pointer += size){
        const skip = (length)=>{
            (0, $hLU0Z.assert)(length >= 0, "Cannot skip a negative number of bytes.");
            (0, $hLU0Z.assert)(length % size === 0, "Length must be a multiple of the size.");
            pointer += length;
        };
        const value = buffer.subarray(pointer);
        yield {
            skip: skip,
            value: value
        };
    }
    return {
        skip: ()=>undefined,
        value: new Uint8Array()
    };
};
module.exports.iterate = $13dc4975bfa51bfd$var$iterate;

});

parcelRegister("1l6y6", function(module, exports) {
"use strict";
var $0f9cd522836f0bb6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0f9cd522836f0bb6$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $0f9cd522836f0bb6$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("7NNUI")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("ijySu")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("aXwGf")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("jIhBk")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("6swdJ")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("5sNxb")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("aU3Hu")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("3SC6M")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("4GWZQ")), module.exports);

$0f9cd522836f0bb6$var$__exportStar((parcelRequire("1vZdq")), module.exports);

});
parcelRegister("7NNUI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.address = module.exports.getAddress = void 0;

var $deXIT = parcelRequire("deXIT");
var $hLU0Z = parcelRequire("hLU0Z");
var $5dW8D = parcelRequire("5dW8D");

var $ck8zU = parcelRequire("ck8zU");

var $fB8Qz = parcelRequire("fB8Qz");
/**
 * Normalize an address value. This accepts the address as:
 *
 * - A hex string starting with the `0x` prefix.
 * - A byte array (`Uint8Array` or `Buffer`).
 *
 * It checks that the address is 20 bytes long.
 *
 * @param value - The value to normalize.
 * @returns The normalized address as `Uint8Array`.
 */ const $5ae3d3d914a8ea01$var$getAddress = (value)=>{
    const bytesValue = (0, $5dW8D.createBytes)(value);
    (0, $hLU0Z.assert)(bytesValue.length <= 20, new $ck8zU.ParserError(`Invalid address value. Expected address to be 20 bytes long, but received ${bytesValue.length} bytes.`));
    return (0, $fB8Qz.padStart)(bytesValue, 20);
};
module.exports.getAddress = $5ae3d3d914a8ea01$var$getAddress;
module.exports.address = {
    isDynamic: false,
    /**
     * Get if the given value is a valid address type. Since `address` is a simple
     * type, this is just a check that the value is "address".
     *
     * @param type - The type to check.
     * @returns Whether the type is a valid address type.
     */ isType: (type)=>type === "address",
    /**
     * Get the byte length of an encoded address. Since `address` is a simple
     * type, this always returns 32.
     *
     * Note that actual addresses are only 20 bytes long, but the encoding of
     * the `address` type is always 32 bytes long.
     *
     * @returns The byte length of an encoded address.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode the given address to a 32-byte-long byte array.
     *
     * @param args - The encoding arguments.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The address to encode.
     * @param args.packed - Whether to use packed encoding.
     * @returns The bytes with the encoded address added to it.
     */ encode ({ buffer: buffer, value: value, packed: packed }) {
        const addressValue = (0, module.exports.getAddress)(value);
        // If we're using packed encoding, we can just add the address bytes to the
        // byte array, without adding any padding.
        if (packed) return (0, $deXIT.concatBytes)([
            buffer,
            addressValue
        ]);
        const addressBuffer = (0, $fB8Qz.padStart)(addressValue);
        return (0, $deXIT.concatBytes)([
            buffer,
            addressBuffer
        ]);
    },
    /**
     * Decode the given byte array to an address.
     *
     * @param args - The decoding arguments.
     * @param args.value - The byte array to decode.
     * @returns The decoded address as a hexadecimal string, starting with the
     * "0x"-prefix.
     */ decode ({ value: value }) {
        return (0, $deXIT.add0x)((0, $deXIT.bytesToHex)(value.slice(12, 32)));
    }
};

});
parcelRegister("fB8Qz", function(module, exports) {
"use strict";
var $b5b12c86f8c034e1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b5b12c86f8c034e1$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b5b12c86f8c034e1$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b5b12c86f8c034e1$var$__exportStar((parcelRequire("31QBR")), module.exports);

});
parcelRegister("31QBR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.padEnd = module.exports.padStart = module.exports.set = void 0;

var $deXIT = parcelRequire("deXIT");
const $234a4641fc459a19$var$BUFFER_WIDTH = 32;
/**
 * Set `buffer` in `target` at the specified position.
 *
 * @param target - The buffer to set to.
 * @param buffer - The buffer to set in the target.
 * @param position - The position at which to set the target.
 * @returns The combined buffer.
 */ const $234a4641fc459a19$var$set = (target, buffer, position)=>{
    return (0, $deXIT.concatBytes)([
        target.subarray(0, position),
        buffer,
        target.subarray(position + buffer.length)
    ]);
};
module.exports.set = $234a4641fc459a19$var$set;
/**
 * Add padding to a buffer. If the buffer is larger than `length`, this function won't do anything. If it's smaller, the
 * buffer will be padded to the specified length, with extra zeroes at the start.
 *
 * @param buffer - The buffer to add padding to.
 * @param length - The number of bytes to pad the buffer to.
 * @returns The padded buffer.
 */ const $234a4641fc459a19$var$padStart = (buffer, length = $234a4641fc459a19$var$BUFFER_WIDTH)=>{
    const padding = new Uint8Array(Math.max(length - buffer.length, 0)).fill(0x00);
    return (0, $deXIT.concatBytes)([
        padding,
        buffer
    ]);
};
module.exports.padStart = $234a4641fc459a19$var$padStart;
/**
 * Add padding to a buffer. If the buffer is larger than `length`, this function won't do anything. If it's smaller, the
 * buffer will be padded to the specified length, with extra zeroes at the end.
 *
 * @param buffer - The buffer to add padding to.
 * @param length - The number of bytes to pad the buffer to.
 * @returns The padded buffer.
 */ const $234a4641fc459a19$var$padEnd = (buffer, length = $234a4641fc459a19$var$BUFFER_WIDTH)=>{
    const padding = new Uint8Array(Math.max(length - buffer.length, 0)).fill(0x00);
    return (0, $deXIT.concatBytes)([
        buffer,
        padding
    ]);
};
module.exports.padEnd = $234a4641fc459a19$var$padEnd;

});



parcelRegister("ijySu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.array = module.exports.getTupleType = module.exports.getArrayType = module.exports.isArrayType = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $deXIT = parcelRequire("deXIT");

var $ck8zU = parcelRequire("ck8zU");

var $KpnIb = parcelRequire("KpnIb");

var $fB8Qz = parcelRequire("fB8Qz");

var $6swdJ = parcelRequire("6swdJ");

var $1vZdq = parcelRequire("1vZdq");
const $d5550e605fa965e3$var$ARRAY_REGEX = /^(?<type>.*)\[(?<length>\d*?)\]$/u;
const $d5550e605fa965e3$var$isArrayType = (type)=>$d5550e605fa965e3$var$ARRAY_REGEX.test(type);
module.exports.isArrayType = $d5550e605fa965e3$var$isArrayType;
/**
 * Get the type of the array.
 *
 * @param type - The type to get the array type for.
 * @returns The array type.
 */ const $d5550e605fa965e3$var$getArrayType = (type)=>{
    const match = type.match($d5550e605fa965e3$var$ARRAY_REGEX);
    (0, $hLU0Z.assert)(match?.groups?.type, new $ck8zU.ParserError(`Invalid array type. Expected an array type, but received "${type}".`));
    return [
        match.groups.type,
        match.groups.length ? parseInt(match.groups.length, 10) : undefined
    ];
};
module.exports.getArrayType = $d5550e605fa965e3$var$getArrayType;
/**
 * Get the type of the array as a tuple type. This is used for encoding fixed
 * length arrays, which are encoded as tuples.
 *
 * @param innerType - The type of the array.
 * @param length - The length of the array.
 * @returns The tuple type.
 */ const $d5550e605fa965e3$var$getTupleType = (innerType, length)=>{
    return `(${new Array(length).fill(innerType).join(",")})`;
};
module.exports.getTupleType = $d5550e605fa965e3$var$getTupleType;
module.exports.array = {
    /**
     * Check if the array is dynamic. Arrays are dynamic if the array does not
     * have a fixed length, or if the array type is dynamic.
     *
     * @param type - The type to check.
     * @returns Whether the array is dynamic.
     */ isDynamic (type) {
        const [innerType, length] = (0, module.exports.getArrayType)(type);
        return(// `T[]` is dynamic for any `T`. `T[k]` is dynamic for any dynamic `T` and
        // any `k >= 0`.
        length === undefined || (0, $KpnIb.isDynamicParser)((0, $KpnIb.getParser)(innerType), innerType));
    },
    /**
     * Check if a type is an array type.
     *
     * @param type - The type to check.
     * @returns Whether the type is an array type.
     */ isType (type) {
        return (0, module.exports.isArrayType)(type);
    },
    /**
     * Get the byte length of an encoded array. If the array is dynamic, this
     * returns 32, i.e., the length of the pointer to the array. If the array is
     * static, this returns the byte length of the resulting tuple type.
     *
     * @param type - The type to get the byte length for.
     * @returns The byte length of an encoded array.
     */ getByteLength (type) {
        (0, $hLU0Z.assert)((0, module.exports.isArrayType)(type), new $ck8zU.ParserError(`Expected an array type, but received "${type}".`));
        const [innerType, length] = (0, module.exports.getArrayType)(type);
        if (!(0, $KpnIb.isDynamicParser)(this, type) && length !== undefined) return $1vZdq.tuple.getByteLength((0, module.exports.getTupleType)(innerType, length));
        return 32;
    },
    /**
     * Encode the given array to a byte array. If the array is static, this uses
     * the tuple encoder.
     *
     * @param args - The encoding arguments.
     * @param args.type - The type of the array.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The array to encode.
     * @param args.packed - Whether to use non-standard packed encoding.
     * @param args.tight - Whether to use non-standard tight encoding.
     * @returns The bytes with the encoded array added to it.
     */ encode ({ type: type, buffer: buffer, value: value, packed: packed, tight: tight }) {
        const [arrayType, fixedLength] = (0, module.exports.getArrayType)(type);
        // Packed encoding does not support nested arrays.
        (0, $hLU0Z.assert)(!packed || !(0, module.exports.isArrayType)(arrayType), new $ck8zU.ParserError(`Cannot pack nested arrays.`));
        // Tightly pack `T[]` where `T` is a dynamic type. This is not supported in
        // Solidity, but is commonly used in the Ethereum ecosystem.
        if (packed && (0, $KpnIb.isDynamicParser)((0, $KpnIb.getParser)(arrayType), arrayType)) return (0, $KpnIb.pack)({
            types: new Array(value.length).fill(arrayType),
            values: value,
            byteArray: buffer,
            packed: packed,
            arrayPacked: true,
            tight: tight
        });
        if (fixedLength) {
            (0, $hLU0Z.assert)(fixedLength === value.length, new $ck8zU.ParserError(`Array length does not match type length. Expected a length of ${fixedLength}, but received ${value.length}.`));
            // `T[k]` for any `T` and `k` is encoded as `(T[0], ..., T[k - 1])`.
            return $1vZdq.tuple.encode({
                type: (0, module.exports.getTupleType)(arrayType, fixedLength),
                buffer: buffer,
                value: value,
                // In "tight" mode, we don't pad the values to 32 bytes if the value is
                // of type `bytesN`. This is an edge case in `ethereumjs-abi` that we
                // support to provide compatibility with it.
                packed: $6swdJ.fixedBytes.isType(arrayType) && tight,
                tight: tight
            });
        }
        // For packed encoding, we don't need to encode the length of the array,
        // so we can just encode the values.
        if (packed) return (0, $KpnIb.pack)({
            types: new Array(value.length).fill(arrayType),
            values: value,
            byteArray: buffer,
            // In "tight" mode, we don't pad the values to 32 bytes if the value is
            // of type `bytesN`. This is an edge case in `ethereumjs-abi` that we
            // support to provide compatibility with it.
            packed: $6swdJ.fixedBytes.isType(arrayType) && tight,
            arrayPacked: true,
            tight: tight
        });
        // `T[]` with `k` elements is encoded as `k (T[0], ..., T[k - 1])`. That
        // means that we just need to encode the length of the array, and then the
        // array itself. The pointer is encoded by the {@link pack} function.
        const arrayLength = (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(value.length));
        return (0, $KpnIb.pack)({
            types: new Array(value.length).fill(arrayType),
            values: value,
            byteArray: (0, $deXIT.concatBytes)([
                buffer,
                arrayLength
            ]),
            packed: packed,
            tight: tight
        });
    },
    /**
     * Decode an array from the given byte array.
     *
     * @param args - The decoding arguments.
     * @param args.type - The type of the array.
     * @param args.value - The byte array to decode.
     * @returns The decoded array.
     */ decode ({ type: type, value: value, ...rest }) {
        const [arrayType, fixedLength] = (0, module.exports.getArrayType)(type);
        if (fixedLength) {
            const result = $1vZdq.tuple.decode({
                type: (0, module.exports.getTupleType)(arrayType, fixedLength),
                value: value,
                ...rest
            });
            (0, $hLU0Z.assert)(result.length === fixedLength, new $ck8zU.ParserError(`Array length does not match type length. Expected a length of ${fixedLength}, but received ${result.length}.`));
            return result;
        }
        const arrayLength = (0, $deXIT.bytesToNumber)(value.subarray(0, 32));
        return (0, $KpnIb.unpack)(new Array(arrayLength).fill(arrayType), value.subarray(32));
    }
};

});
parcelRegister("6swdJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fixedBytes = module.exports.getByteLength = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $deXIT = parcelRequire("deXIT");
var $5dW8D = parcelRequire("5dW8D");

var $ck8zU = parcelRequire("ck8zU");

var $fB8Qz = parcelRequire("fB8Qz");
const $4b3e59ec1bd8e9c5$var$BYTES_REGEX = /^bytes([0-9]{1,2})$/u;
/**
 * Get the length of the specified type. If a length is not specified, or if the
 * length is out of range (0 < n <= 32), this will throw an error.
 *
 * @param type - The type to get the length for.
 * @returns The byte length of the type.
 */ const $4b3e59ec1bd8e9c5$var$getByteLength = (type)=>{
    const bytes = type.match($4b3e59ec1bd8e9c5$var$BYTES_REGEX)?.[1];
    (0, $hLU0Z.assert)(bytes, `Invalid byte length. Expected a number between 1 and 32, but received "${type}".`);
    const length = Number(bytes);
    (0, $hLU0Z.assert)(length > 0 && length <= 32, new $ck8zU.ParserError(`Invalid byte length. Expected a number between 1 and 32, but received "${type}".`));
    return length;
};
module.exports.getByteLength = $4b3e59ec1bd8e9c5$var$getByteLength;
module.exports.fixedBytes = {
    isDynamic: false,
    /**
     * Check if a type is a fixed bytes type.
     *
     * @param type - The type to check.
     * @returns Whether the type is a fixed bytes type.
     */ isType (type) {
        return $4b3e59ec1bd8e9c5$var$BYTES_REGEX.test(type);
    },
    /**
     * Get the byte length of an encoded fixed bytes type.
     *
     * @returns The byte length of the type.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode a fixed bytes value.
     *
     * @param args - The arguments to encode.
     * @param args.type - The type of the value.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The value to encode.
     * @param args.packed - Whether to use packed encoding.
     * @returns The bytes with the encoded value added to it.
     */ encode ({ type: type, buffer: buffer, value: value, packed: packed }) {
        const length = (0, module.exports.getByteLength)(type);
        const bufferValue = (0, $5dW8D.createBytes)(value);
        (0, $hLU0Z.assert)(bufferValue.length <= length, new $ck8zU.ParserError(`Expected a value of length ${length}, but received a value of length ${bufferValue.length}.`));
        // For packed encoding, the value is padded to the length of the type, and
        // then added to the byte array.
        if (packed) return (0, $deXIT.concatBytes)([
            buffer,
            (0, $fB8Qz.padEnd)(bufferValue, length)
        ]);
        return (0, $deXIT.concatBytes)([
            buffer,
            (0, $fB8Qz.padEnd)(bufferValue)
        ]);
    },
    /**
     * Decode a fixed bytes value.
     *
     * @param args - The arguments to decode.
     * @param args.type - The type of the value.
     * @param args.value - The value to decode.
     * @returns The decoded value as a `Uint8Array`.
     */ decode ({ type: type, value: value }) {
        const length = (0, module.exports.getByteLength)(type);
        // Since we're returning a `Uint8Array`, we use `slice` to copy the bytes
        // into a new array.
        return value.slice(0, length);
    }
};

});

parcelRegister("1vZdq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tuple = module.exports.getTupleElements = void 0;

var $hLU0Z = parcelRequire("hLU0Z");

var $ck8zU = parcelRequire("ck8zU");

var $KpnIb = parcelRequire("KpnIb");
const $11a82bd57c69c3c0$var$TUPLE_REGEX = /^\((.+)\)$/u;
const $11a82bd57c69c3c0$var$isTupleType = (type)=>$11a82bd57c69c3c0$var$TUPLE_REGEX.test(type);
/**
 * Get elements from a tuple type.
 *
 * @param type - The tuple type to get the types for.
 * @returns The elements of the tuple as string array.
 */ const $11a82bd57c69c3c0$var$getTupleElements = (type)=>{
    (0, $hLU0Z.assert)(type.startsWith("(") && type.endsWith(")"), new $ck8zU.ParserError(`Invalid tuple type. Expected tuple type, but received "${type}".`));
    const elements = [];
    let current = "";
    let depth = 0;
    for(let i = 1; i < type.length - 1; i++){
        const char = type[i];
        if (char === "," && depth === 0) {
            elements.push(current.trim());
            current = "";
        } else {
            current += char;
            if (char === "(") depth += 1;
            else if (char === ")") depth -= 1;
        }
    }
    if (current.trim()) elements.push(current.trim());
    return elements;
};
module.exports.getTupleElements = $11a82bd57c69c3c0$var$getTupleElements;
module.exports.tuple = {
    /**
     * Check if the tuple is dynamic. Tuples are dynamic if one or more elements
     * of the tuple are dynamic.
     *
     * @param type - The type to check.
     * @returns Whether the tuple is dynamic.
     */ isDynamic (type) {
        const elements = (0, module.exports.getTupleElements)(type);
        return elements.some((element)=>{
            const parser = (0, $KpnIb.getParser)(element);
            return (0, $KpnIb.isDynamicParser)(parser, element);
        });
    },
    /**
     * Check if a type is a tuple type.
     *
     * @param type - The type to check.
     * @returns Whether the type is a tuple type.
     */ isType (type) {
        return $11a82bd57c69c3c0$var$isTupleType(type);
    },
    /**
     * Get the byte length of a tuple type. If the tuple is dynamic, this will
     * always return 32. If the tuple is static, this will return the sum of the
     * byte lengths of the tuple elements.
     *
     * @param type - The type to get the byte length for.
     * @returns The byte length of the tuple type.
     */ getByteLength (type) {
        if ((0, $KpnIb.isDynamicParser)(this, type)) return 32;
        const elements = (0, module.exports.getTupleElements)(type);
        return elements.reduce((total, element)=>{
            return total + (0, $KpnIb.getParser)(element).getByteLength(element);
        }, 0);
    },
    /**
     * Encode a tuple value.
     *
     * @param args - The encoding arguments.
     * @param args.type - The type of the value.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The value to encode.
     * @param args.packed - Whether to use non-standard packed encoding.
     * @param args.tight - Whether to use non-standard tight encoding.
     * @returns The bytes with the encoded value added to it.
     */ encode ({ type: type, buffer: buffer, value: value, packed: packed, tight: tight }) {
        const elements = (0, module.exports.getTupleElements)(type);
        return (0, $KpnIb.pack)({
            types: elements,
            values: value,
            byteArray: buffer,
            packed: packed,
            tight: tight
        });
    },
    /**
     * Decode a tuple value.
     *
     * @param args - The decoding arguments.
     * @param args.type - The type of the value.
     * @param args.value - The value to decode.
     * @param args.skip - A function to skip a number of bytes.
     * @returns The decoded value.
     */ decode ({ type: type, value: value, skip: skip }) {
        const elements = (0, module.exports.getTupleElements)(type);
        const length = this.getByteLength(type) - 32;
        skip(length);
        return (0, $KpnIb.unpack)(elements, value);
    }
};

});


parcelRegister("aXwGf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bool = module.exports.getBooleanValue = void 0;

var $deXIT = parcelRequire("deXIT");

var $iclp6 = parcelRequire("iclp6");

var $ck8zU = parcelRequire("ck8zU");

var $aU3Hu = parcelRequire("aU3Hu");
const $7fa8c3b936b5b9e5$var$BooleanCoercer = (0, $iclp6.coerce)((0, $iclp6.boolean)(), (0, $iclp6.union)([
    (0, $iclp6.literal)("true"),
    (0, $iclp6.literal)("false")
]), (value)=>value === "true");
/**
 * Normalize a boolean value. This accepts the boolean as:
 *
 * - A boolean literal.
 * - The string "true" or "false".
 *
 * @param value - The value to get a boolean for.
 * @returns The parsed boolean value. This is `BigInt(1)` for truthy values, or
 * `BigInt(0)` for falsy values.
 */ const $7fa8c3b936b5b9e5$var$getBooleanValue = (value)=>{
    try {
        const booleanValue = (0, $iclp6.create)(value, $7fa8c3b936b5b9e5$var$BooleanCoercer);
        if (booleanValue) return BigInt(1);
        return BigInt(0);
    } catch  {
        throw new $ck8zU.ParserError(`Invalid boolean value. Expected a boolean literal, or the string "true" or "false", but received "${value}".`);
    }
};
module.exports.getBooleanValue = $7fa8c3b936b5b9e5$var$getBooleanValue;
module.exports.bool = {
    isDynamic: false,
    /**
     * Get if the given value is a valid boolean type. Since `bool` is a simple
     * type, this is just a check that the value is "bool".
     *
     * @param type - The type to check.
     * @returns Whether the type is a valid boolean type.
     */ isType: (type)=>type === "bool",
    /**
     * Get the byte length of an encoded boolean. Since `bool` is a simple
     * type, this always returns 32.
     *
     * Note that actual booleans are only 1 byte long, but the encoding of
     * the `bool` type is always 32 bytes long.
     *
     * @returns The byte length of an encoded boolean.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode the given boolean to a byte array.
     *
     * @param args - The encoding arguments.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The boolean to encode.
     * @param args.packed - Whether the value is packed.
     * @param args.tight - Whether to use non-standard tight encoding.
     * @returns The bytes with the encoded boolean added to it.
     */ encode ({ buffer: buffer, value: value, packed: packed, tight: tight }) {
        const booleanValue = (0, module.exports.getBooleanValue)(value);
        // For packed encoding, we add a single byte (`0x00` or `0x01`) to the byte
        // array.
        if (packed) return (0, $deXIT.concatBytes)([
            buffer,
            (0, $deXIT.bigIntToBytes)(booleanValue)
        ]);
        // Booleans are encoded as 32-byte integers, so we use the number parser
        // to encode the boolean value.
        return $aU3Hu.number.encode({
            type: "uint256",
            buffer: buffer,
            value: booleanValue,
            packed: packed,
            tight: tight
        });
    },
    /**
     * Decode the given byte array to a boolean.
     *
     * @param args - The decoding arguments.
     * @returns The decoded boolean.
     */ decode (args) {
        // Booleans are encoded as 32-byte integers, so we use the number parser
        // to decode the boolean value.
        return $aU3Hu.number.decode({
            ...args,
            type: "uint256"
        }) === BigInt(1);
    }
};

});
parcelRegister("aU3Hu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.number = module.exports.getBigInt = module.exports.assertNumberLength = module.exports.getLength = module.exports.isSigned = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $deXIT = parcelRequire("deXIT");
var $5dW8D = parcelRequire("5dW8D");

var $ck8zU = parcelRequire("ck8zU");

var $fB8Qz = parcelRequire("fB8Qz");
const $7f02012c8f9444dc$var$NUMBER_REGEX = /^u?int(?<length>[0-9]*)?$/u;
/**
 * Check if a number type is signed.
 *
 * @param type - The type to check.
 * @returns Whether the type is signed.
 */ const $7f02012c8f9444dc$var$isSigned = (type)=>{
    return !type.startsWith("u");
};
module.exports.isSigned = $7f02012c8f9444dc$var$isSigned;
/**
 * Get the length of the specified type. If a length is not specified, if the
 * length is out of range (8 <= n <= 256), or if the length is not a multiple of
 * 8, this will throw an error.
 *
 * @param type - The type to get the length for.
 * @returns The bit length of the type.
 */ const $7f02012c8f9444dc$var$getLength = (type)=>{
    if (type === "int" || type === "uint") return 256;
    const match = type.match($7f02012c8f9444dc$var$NUMBER_REGEX);
    (0, $hLU0Z.assert)(match?.groups?.length, new $ck8zU.ParserError(`Invalid number type. Expected a number type, but received "${type}".`));
    const length = parseInt(match.groups.length, 10);
    (0, $hLU0Z.assert)(length >= 8 && length <= 256, new $ck8zU.ParserError(`Invalid number length. Expected a number between 8 and 256, but received "${type}".`));
    (0, $hLU0Z.assert)(length % 8 === 0, new $ck8zU.ParserError(`Invalid number length. Expected a multiple of 8, but received "${type}".`));
    return length;
};
module.exports.getLength = $7f02012c8f9444dc$var$getLength;
/**
 * Assert that the byte length of the given value is in range for the given
 * number type.
 *
 * @param value - The value to check.
 * @param type - The type of the value.
 * @throws If the value is out of range for the type.
 */ const $7f02012c8f9444dc$var$assertNumberLength = (value, type)=>{
    const length = (0, module.exports.getLength)(type);
    const maxValue = BigInt(2) ** BigInt(length - ((0, module.exports.isSigned)(type) ? 1 : 0)) - BigInt(1);
    if ((0, module.exports.isSigned)(type)) {
        // Signed types must be in the range of `-(2^(length - 1))` to
        // `2^(length - 1) - 1`.
        (0, $hLU0Z.assert)(value >= -(maxValue + BigInt(1)) && value <= maxValue, new $ck8zU.ParserError(`Number "${value}" is out of range for type "${type}".`));
        return;
    }
    // Unsigned types must be in the range of `0` to `2^length - 1`.
    (0, $hLU0Z.assert)(value <= maxValue, new $ck8zU.ParserError(`Number "${value}" is out of range for type "${type}".`));
};
module.exports.assertNumberLength = $7f02012c8f9444dc$var$assertNumberLength;
/**
 * Normalize a `bigint` value. This accepts the value as:
 *
 * - A `bigint`.
 * - A `number`.
 * - A decimal string, i.e., a string that does not start with "0x".
 * - A hexadecimal string, i.e., a string that starts with "0x".
 *
 * @param value - The number-like value to parse.
 * @returns The value parsed as bigint.
 */ const $7f02012c8f9444dc$var$getBigInt = (value)=>{
    try {
        return (0, $5dW8D.createBigInt)(value);
    } catch  {
        throw new $ck8zU.ParserError(`Invalid number. Expected a valid number value, but received "${value}".`);
    }
};
module.exports.getBigInt = $7f02012c8f9444dc$var$getBigInt;
module.exports.number = {
    isDynamic: false,
    /**
     * Check if a type is a number type.
     *
     * @param type - The type to check.
     * @returns Whether the type is a number type.
     */ isType (type) {
        return $7f02012c8f9444dc$var$NUMBER_REGEX.test(type);
    },
    /**
     * Get the byte length of an encoded number type. Since `int` and `uint` are
     * simple types, this will always return 32.
     *
     * @returns The byte length of the type.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode a number value.
     *
     * @param args - The arguments to encode.
     * @param args.type - The type of the value.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The value to encode.
     * @param args.packed - Whether to use packed encoding.
     * @returns The bytes with the encoded value added to it.
     */ encode ({ type: type, buffer: buffer, value: value, packed: packed }) {
        const bigIntValue = (0, module.exports.getBigInt)(value);
        (0, module.exports.assertNumberLength)(bigIntValue, type);
        if ((0, module.exports.isSigned)(type)) {
            // For packed encoding, the value is padded to the length of the type, and
            // then added to the byte array.
            if (packed) {
                const length = (0, module.exports.getLength)(type) / 8;
                return (0, $deXIT.concatBytes)([
                    buffer,
                    (0, $deXIT.signedBigIntToBytes)(bigIntValue, length)
                ]);
            }
            return (0, $deXIT.concatBytes)([
                buffer,
                (0, $fB8Qz.padStart)((0, $deXIT.signedBigIntToBytes)(bigIntValue, 32))
            ]);
        }
        // For packed encoding, the value is padded to the length of the type, and
        // then added to the byte array.
        if (packed) {
            const length = (0, module.exports.getLength)(type) / 8;
            return (0, $deXIT.concatBytes)([
                buffer,
                (0, $fB8Qz.padStart)((0, $deXIT.bigIntToBytes)(bigIntValue), length)
            ]);
        }
        return (0, $deXIT.concatBytes)([
            buffer,
            (0, $fB8Qz.padStart)((0, $deXIT.bigIntToBytes)(bigIntValue))
        ]);
    },
    /**
     * Decode a number value.
     *
     * @param args - The decoding arguments.
     * @param args.type - The type of the value.
     * @param args.value - The value to decode.
     * @returns The decoded value.
     */ decode ({ type: type, value: value }) {
        const buffer = value.subarray(0, 32);
        if ((0, module.exports.isSigned)(type)) {
            const numberValue = (0, $deXIT.bytesToSignedBigInt)(buffer);
            (0, module.exports.assertNumberLength)(numberValue, type);
            return numberValue;
        }
        const numberValue = (0, $deXIT.bytesToBigInt)(buffer);
        (0, module.exports.assertNumberLength)(numberValue, type);
        return numberValue;
    }
};

});


parcelRegister("jIhBk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bytes = void 0;

var $deXIT = parcelRequire("deXIT");
var $5dW8D = parcelRequire("5dW8D");

var $fB8Qz = parcelRequire("fB8Qz");
module.exports.bytes = {
    isDynamic: true,
    /**
     * Check if a type is a bytes type. Since `bytes` is a simple type, this is
     * just a check that the type is "bytes".
     *
     * @param type - The type to check.
     * @returns Whether the type is a bytes type.
     */ isType: (type)=>type === "bytes",
    /**
     * Get the byte length of an encoded bytes value. Since `bytes` is a simple
     * type, this always returns 32.
     *
     * Note that actual length of a bytes value is variable, but the encoded
     * static value (pointer) is always 32 bytes long.
     *
     * @returns The byte length of an encoded bytes value.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode the given bytes value to a byte array.
     *
     * @param args - The encoding arguments.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The bytes value to encode.
     * @param args.packed - Whether to use packed encoding.
     * @returns The bytes with the encoded bytes value added to it.
     */ encode ({ buffer: buffer, value: value, packed: packed }) {
        const bufferValue = (0, $5dW8D.createBytes)(value);
        // For packed encoding, we can just add the bytes value to the byte array,
        // without adding any padding or alignment. There is also no need to
        // encode the length of the bytes.
        if (packed) return (0, $deXIT.concatBytes)([
            buffer,
            bufferValue
        ]);
        const paddedSize = Math.ceil(bufferValue.byteLength / 32) * 32;
        // Bytes of length `k` are encoded as `k pad_right(bytes)`.
        return (0, $deXIT.concatBytes)([
            buffer,
            (0, $fB8Qz.padStart)((0, $deXIT.numberToBytes)(bufferValue.byteLength)),
            (0, $fB8Qz.padEnd)(bufferValue, paddedSize)
        ]);
    },
    /**
     * Decode the given byte array to a bytes value.
     *
     * @param args - The decoding arguments.
     * @param args.value - The byte array to decode.
     * @returns The decoded bytes value as a `Uint8Array`.
     */ decode ({ value: value }) {
        const bytesValue = value.subarray(0, 32);
        const length = (0, $deXIT.bytesToNumber)(bytesValue);
        // Since we're returning a `Uint8Array`, we use `slice` to copy the bytes
        // into a new array.
        return value.slice(32, 32 + length);
    }
};

});

parcelRegister("5sNxb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fn = module.exports.getFunction = void 0;

var $hLU0Z = parcelRequire("hLU0Z");
var $deXIT = parcelRequire("deXIT");
var $5dW8D = parcelRequire("5dW8D");

var $iclp6 = parcelRequire("iclp6");

var $ck8zU = parcelRequire("ck8zU");

var $6swdJ = parcelRequire("6swdJ");
/**
 * A struct that represents a Solidity function. The value must be a hex string
 * or a byte array. The created value will always be an object with an `address`
 * and `selector` property.
 */ const $3fa5fdbe9175bf4d$var$FunctionStruct = (0, $iclp6.coerce)((0, $iclp6.object)({
    address: $deXIT.StrictHexStruct,
    selector: $deXIT.StrictHexStruct
}), (0, $iclp6.union)([
    $deXIT.StrictHexStruct,
    (0, $iclp6.instance)(Uint8Array)
]), (value)=>{
    const bytes = (0, $5dW8D.createBytes)(value);
    (0, $hLU0Z.assert)(bytes.length === 24, new $ck8zU.ParserError(`Invalid Solidity function. Expected function to be 24 bytes long, but received ${bytes.length} bytes.`));
    return {
        address: (0, $deXIT.bytesToHex)(bytes.subarray(0, 20)),
        selector: (0, $deXIT.bytesToHex)(bytes.subarray(20, 24))
    };
});
/**
 * Normalize a function. This accepts the function as:
 *
 * - A {@link SolidityFunction} object.
 * - A hexadecimal string.
 * - A byte array.
 *
 * @param input - The function-like input.
 * @returns The function as buffer.
 */ const $3fa5fdbe9175bf4d$var$getFunction = (input)=>{
    const value = (0, $iclp6.create)(input, $3fa5fdbe9175bf4d$var$FunctionStruct);
    return (0, $deXIT.concatBytes)([
        (0, $deXIT.hexToBytes)(value.address),
        (0, $deXIT.hexToBytes)(value.selector)
    ]);
};
module.exports.getFunction = $3fa5fdbe9175bf4d$var$getFunction;
module.exports.fn = {
    isDynamic: false,
    /**
     * Check if a type is a function type. Since `function` is a simple type, this
     * is just a check that the type is "function".
     *
     * @param type - The type to check.
     * @returns Whether the type is a function type.
     */ isType: (type)=>type === "function",
    /**
     * Get the byte length of an encoded function. Since `function` is a simple
     * type, this always returns 32.
     *
     * Note that actual functions are only 24 bytes long, but the encoding of
     * the `function` type is always 32 bytes long.
     *
     * @returns The byte length of an encoded function.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode the given function to a byte array.
     *
     * @param args - The encoding arguments.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The function to encode.
     * @param args.packed - Whether to use packed encoding.
     * @param args.tight - Whether to use non-standard tight encoding.
     * @returns The bytes with the encoded function added to it.
     */ encode ({ buffer: buffer, value: value, packed: packed, tight: tight }) {
        const fnValue = (0, module.exports.getFunction)(value);
        // Functions are encoded as `bytes24`, so we use the fixedBytes parser to
        // encode the function.
        return $6swdJ.fixedBytes.encode({
            type: "bytes24",
            buffer: buffer,
            value: fnValue,
            packed: packed,
            tight: tight
        });
    },
    /**
     * Decode the given byte array to a function.
     *
     * @param args - The decoding arguments.
     * @param args.value - The byte array to decode.
     * @returns The decoded function as a {@link SolidityFunction} object.
     */ decode ({ value: value }) {
        return {
            address: (0, $deXIT.bytesToHex)(value.slice(0, 20)),
            selector: (0, $deXIT.bytesToHex)(value.slice(20, 24))
        };
    }
};

});

parcelRegister("3SC6M", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("4GWZQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.string = void 0;

var $deXIT = parcelRequire("deXIT");

var $jIhBk = parcelRequire("jIhBk");
module.exports.string = {
    isDynamic: true,
    /**
     * Check if a type is a string type. Since `string` is a simple type, this
     * is just a check if the type is "string".
     *
     * @param type - The type to check.
     * @returns Whether the type is a string type.
     */ isType: (type)=>type === "string",
    /**
     * Get the byte length of an encoded string type. Since `string` is a simple
     * type, this will always return 32.
     *
     * Note that actual strings are variable in length, but the encoded static
     * value (pointer) is always 32 bytes long.
     *
     * @returns The byte length of an encoded string.
     */ getByteLength () {
        return 32;
    },
    /**
     * Encode the given string value to a byte array.
     *
     * @param args - The encoding arguments.
     * @param args.buffer - The byte array to add to.
     * @param args.value - The string value to encode.
     * @param args.packed - Whether to use packed encoding.
     * @param args.tight - Whether to use non-standard tight encoding.
     * @returns The bytes with the encoded string value added to it.
     */ encode ({ buffer: buffer, value: value, packed: packed, tight: tight }) {
        // Strings are encoded as UTF-8 bytes, so we use the bytes parser to encode
        // the string as bytes.
        return $jIhBk.bytes.encode({
            type: "bytes",
            buffer: buffer,
            value: (0, $deXIT.stringToBytes)(value),
            packed: packed,
            tight: tight
        });
    },
    /**
     * Decode the given byte array to a string value.
     *
     * @param args - The decoding arguments.
     * @returns The decoded string value.
     */ decode (args) {
        // Strings are encoded as UTF-8 bytes, so we use the bytes parser to decode
        // the bytes, and convert them to a string.
        return (0, $deXIT.bytesToString)($jIhBk.bytes.decode(args));
    }
};

});




parcelRegister("7l5Ti", function(module, exports) {
"use strict";
var $557f10611aedec98$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $557f10611aedec98$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $557f10611aedec98$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$557f10611aedec98$var$__exportStar((parcelRequire("902d5")), module.exports);

});
parcelRegister("902d5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});




parcelRegister("4x0IF", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $34cacd5d31d0139e$require$Buffer = $ihoyg.Buffer;
"use strict";
var $34cacd5d31d0139e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $34cacd5d31d0139e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $34cacd5d31d0139e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $34cacd5d31d0139e$var$__createBinding(result, mod, k);
    }
    $34cacd5d31d0139e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEncryptionPublicKey = module.exports.decryptSafely = module.exports.decrypt = module.exports.encryptSafely = module.exports.encrypt = void 0;

const $34cacd5d31d0139e$var$nacl = $34cacd5d31d0139e$var$__importStar((parcelRequire("loMBo")));

const $34cacd5d31d0139e$var$naclUtil = $34cacd5d31d0139e$var$__importStar((parcelRequire("aGiAx")));

var $grbfr = parcelRequire("grbfr");
/**
 * Encrypt a message.
 *
 * @param options - The encryption options.
 * @param options.publicKey - The public key of the message recipient.
 * @param options.data - The message data.
 * @param options.version - The type of encryption to use.
 * @returns The encrypted data.
 */ function $34cacd5d31d0139e$var$encrypt({ publicKey: publicKey, data: data, version: version }) {
    if ((0, $grbfr.isNullish)(publicKey)) throw new Error("Missing publicKey parameter");
    else if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(version)) throw new Error("Missing version parameter");
    switch(version){
        case "x25519-xsalsa20-poly1305":
            {
                if (typeof data !== "string") throw new Error("Message data must be given as a string");
                // generate ephemeral keypair
                const ephemeralKeyPair = $34cacd5d31d0139e$var$nacl.box.keyPair();
                // assemble encryption parameters - from string to UInt8
                let pubKeyUInt8Array;
                try {
                    pubKeyUInt8Array = $34cacd5d31d0139e$var$naclUtil.decodeBase64(publicKey);
                } catch (err) {
                    throw new Error("Bad public key");
                }
                const msgParamsUInt8Array = $34cacd5d31d0139e$var$naclUtil.decodeUTF8(data);
                const nonce = $34cacd5d31d0139e$var$nacl.randomBytes($34cacd5d31d0139e$var$nacl.box.nonceLength);
                // encrypt
                const encryptedMessage = $34cacd5d31d0139e$var$nacl.box(msgParamsUInt8Array, nonce, pubKeyUInt8Array, ephemeralKeyPair.secretKey);
                // handle encrypted data
                const output = {
                    version: "x25519-xsalsa20-poly1305",
                    nonce: $34cacd5d31d0139e$var$naclUtil.encodeBase64(nonce),
                    ephemPublicKey: $34cacd5d31d0139e$var$naclUtil.encodeBase64(ephemeralKeyPair.publicKey),
                    ciphertext: $34cacd5d31d0139e$var$naclUtil.encodeBase64(encryptedMessage)
                };
                // return encrypted msg data
                return output;
            }
        default:
            throw new Error("Encryption type/version not supported");
    }
}
module.exports.encrypt = $34cacd5d31d0139e$var$encrypt;
/**
 * Encrypt a message in a way that obscures the message length.
 *
 * The message is padded to a multiple of 2048 before being encrypted so that the length of the
 * resulting encrypted message can't be used to guess the exact length of the original message.
 *
 * @param options - The encryption options.
 * @param options.publicKey - The public key of the message recipient.
 * @param options.data - The message data.
 * @param options.version - The type of encryption to use.
 * @returns The encrypted data.
 */ function $34cacd5d31d0139e$var$encryptSafely({ publicKey: publicKey, data: data, version: version }) {
    if ((0, $grbfr.isNullish)(publicKey)) throw new Error("Missing publicKey parameter");
    else if ((0, $grbfr.isNullish)(data)) throw new Error("Missing data parameter");
    else if ((0, $grbfr.isNullish)(version)) throw new Error("Missing version parameter");
    const DEFAULT_PADDING_LENGTH = 2048;
    const NACL_EXTRA_BYTES = 16;
    if (typeof data === "object" && data && "toJSON" in data) // remove toJSON attack vector
    // TODO, check all possible children
    throw new Error("Cannot encrypt with toJSON property.  Please remove toJSON property");
    // add padding
    const dataWithPadding = {
        data: data,
        padding: ""
    };
    // calculate padding
    const dataLength = $34cacd5d31d0139e$require$Buffer.byteLength(JSON.stringify(dataWithPadding), "utf-8");
    const modVal = dataLength % DEFAULT_PADDING_LENGTH;
    let padLength = 0;
    // Only pad if necessary
    if (modVal > 0) padLength = DEFAULT_PADDING_LENGTH - modVal - NACL_EXTRA_BYTES; // nacl extra bytes
    dataWithPadding.padding = "0".repeat(padLength);
    const paddedMessage = JSON.stringify(dataWithPadding);
    return $34cacd5d31d0139e$var$encrypt({
        publicKey: publicKey,
        data: paddedMessage,
        version: version
    });
}
module.exports.encryptSafely = $34cacd5d31d0139e$var$encryptSafely;
/**
 * Decrypt a message.
 *
 * @param options - The decryption options.
 * @param options.encryptedData - The encrypted data.
 * @param options.privateKey - The private key to decrypt with.
 * @returns The decrypted message.
 */ function $34cacd5d31d0139e$var$decrypt({ encryptedData: encryptedData, privateKey: privateKey }) {
    if ((0, $grbfr.isNullish)(encryptedData)) throw new Error("Missing encryptedData parameter");
    else if ((0, $grbfr.isNullish)(privateKey)) throw new Error("Missing privateKey parameter");
    switch(encryptedData.version){
        case "x25519-xsalsa20-poly1305":
            {
                // string to buffer to UInt8Array
                const receiverPrivateKeyUint8Array = $34cacd5d31d0139e$var$naclDecodeHex(privateKey);
                const receiverEncryptionPrivateKey = $34cacd5d31d0139e$var$nacl.box.keyPair.fromSecretKey(receiverPrivateKeyUint8Array).secretKey;
                // assemble decryption parameters
                const nonce = $34cacd5d31d0139e$var$naclUtil.decodeBase64(encryptedData.nonce);
                const ciphertext = $34cacd5d31d0139e$var$naclUtil.decodeBase64(encryptedData.ciphertext);
                const ephemPublicKey = $34cacd5d31d0139e$var$naclUtil.decodeBase64(encryptedData.ephemPublicKey);
                // decrypt
                const decryptedMessage = $34cacd5d31d0139e$var$nacl.box.open(ciphertext, nonce, ephemPublicKey, receiverEncryptionPrivateKey);
                // return decrypted msg data
                try {
                    if (!decryptedMessage) throw new Error();
                    const output = $34cacd5d31d0139e$var$naclUtil.encodeUTF8(decryptedMessage);
                    // TODO: This is probably extraneous but was kept to minimize changes during refactor
                    if (!output) throw new Error();
                    return output;
                } catch (err) {
                    if (err && typeof err.message === "string" && err.message.length) throw new Error(`Decryption failed: ${err.message}`);
                    throw new Error(`Decryption failed.`);
                }
            }
        default:
            throw new Error("Encryption type/version not supported.");
    }
}
module.exports.decrypt = $34cacd5d31d0139e$var$decrypt;
/**
 * Decrypt a message that has been encrypted using `encryptSafely`.
 *
 * @param options - The decryption options.
 * @param options.encryptedData - The encrypted data.
 * @param options.privateKey - The private key to decrypt with.
 * @returns The decrypted message.
 */ function $34cacd5d31d0139e$var$decryptSafely({ encryptedData: encryptedData, privateKey: privateKey }) {
    if ((0, $grbfr.isNullish)(encryptedData)) throw new Error("Missing encryptedData parameter");
    else if ((0, $grbfr.isNullish)(privateKey)) throw new Error("Missing privateKey parameter");
    const dataWithPadding = JSON.parse($34cacd5d31d0139e$var$decrypt({
        encryptedData: encryptedData,
        privateKey: privateKey
    }));
    return dataWithPadding.data;
}
module.exports.decryptSafely = $34cacd5d31d0139e$var$decryptSafely;
/**
 * Get the encryption public key for the given key.
 *
 * @param privateKey - The private key to generate the encryption public key with.
 * @returns The encryption public key.
 */ function $34cacd5d31d0139e$var$getEncryptionPublicKey(privateKey) {
    const privateKeyUint8Array = $34cacd5d31d0139e$var$naclDecodeHex(privateKey);
    const encryptionPublicKey = $34cacd5d31d0139e$var$nacl.box.keyPair.fromSecretKey(privateKeyUint8Array).publicKey;
    return $34cacd5d31d0139e$var$naclUtil.encodeBase64(encryptionPublicKey);
}
module.exports.getEncryptionPublicKey = $34cacd5d31d0139e$var$getEncryptionPublicKey;
/**
 * Convert a hex string to the UInt8Array format used by nacl.
 *
 * @param msgHex - The string to convert.
 * @returns The converted string.
 */ function $34cacd5d31d0139e$var$naclDecodeHex(msgHex) {
    const msgBase64 = $34cacd5d31d0139e$require$Buffer.from(msgHex, "hex").toString("base64");
    return $34cacd5d31d0139e$var$naclUtil.decodeBase64(msgBase64);
}

});
parcelRegister("loMBo", function(module, exports) {

(function(nacl) {
    "use strict";
    // Ported in 2014 by Dmitry Chestnykh and Devi Mandiri.
    // Public domain.
    //
    // Implementation derived from TweetNaCl version 20140427.
    // See for details: http://tweetnacl.cr.yp.to/
    var gf = function(init) {
        var i, r = new Float64Array(16);
        if (init) for(i = 0; i < init.length; i++)r[i] = init[i];
        return r;
    };
    //  Pluggable, initialized in high-level API below.
    var randombytes = function() {
        throw new Error("no PRNG");
    };
    var _0 = new Uint8Array(16);
    var _9 = new Uint8Array(32);
    _9[0] = 9;
    var gf0 = gf(), gf1 = gf([
        1
    ]), _121665 = gf([
        0xdb41,
        1
    ]), D = gf([
        0x78a3,
        0x1359,
        0x4dca,
        0x75eb,
        0xd8ab,
        0x4141,
        0x0a4d,
        0x0070,
        0xe898,
        0x7779,
        0x4079,
        0x8cc7,
        0xfe73,
        0x2b6f,
        0x6cee,
        0x5203
    ]), D2 = gf([
        0xf159,
        0x26b2,
        0x9b94,
        0xebd6,
        0xb156,
        0x8283,
        0x149a,
        0x00e0,
        0xd130,
        0xeef3,
        0x80f2,
        0x198e,
        0xfce7,
        0x56df,
        0xd9dc,
        0x2406
    ]), X = gf([
        0xd51a,
        0x8f25,
        0x2d60,
        0xc956,
        0xa7b2,
        0x9525,
        0xc760,
        0x692c,
        0xdc5c,
        0xfdd6,
        0xe231,
        0xc0a4,
        0x53fe,
        0xcd6e,
        0x36d3,
        0x2169
    ]), Y = gf([
        0x6658,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666,
        0x6666
    ]), I = gf([
        0xa0b0,
        0x4a0e,
        0x1b27,
        0xc4ee,
        0xe478,
        0xad2f,
        0x1806,
        0x2f43,
        0xd7a7,
        0x3dfb,
        0x0099,
        0x2b4d,
        0xdf0b,
        0x4fc1,
        0x2480,
        0x2b83
    ]);
    function ts64(x, i, h, l) {
        x[i] = h >> 24 & 0xff;
        x[i + 1] = h >> 16 & 0xff;
        x[i + 2] = h >> 8 & 0xff;
        x[i + 3] = h & 0xff;
        x[i + 4] = l >> 24 & 0xff;
        x[i + 5] = l >> 16 & 0xff;
        x[i + 6] = l >> 8 & 0xff;
        x[i + 7] = l & 0xff;
    }
    function vn(x, xi, y, yi, n) {
        var i, d = 0;
        for(i = 0; i < n; i++)d |= x[xi + i] ^ y[yi + i];
        return (1 & d - 1 >>> 8) - 1;
    }
    function crypto_verify_16(x, xi, y, yi) {
        return vn(x, xi, y, yi, 16);
    }
    function crypto_verify_32(x, xi, y, yi) {
        return vn(x, xi, y, yi, 32);
    }
    function core_salsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        x0 = x0 + j0 | 0;
        x1 = x1 + j1 | 0;
        x2 = x2 + j2 | 0;
        x3 = x3 + j3 | 0;
        x4 = x4 + j4 | 0;
        x5 = x5 + j5 | 0;
        x6 = x6 + j6 | 0;
        x7 = x7 + j7 | 0;
        x8 = x8 + j8 | 0;
        x9 = x9 + j9 | 0;
        x10 = x10 + j10 | 0;
        x11 = x11 + j11 | 0;
        x12 = x12 + j12 | 0;
        x13 = x13 + j13 | 0;
        x14 = x14 + j14 | 0;
        x15 = x15 + j15 | 0;
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x1 >>> 0 & 0xff;
        o[5] = x1 >>> 8 & 0xff;
        o[6] = x1 >>> 16 & 0xff;
        o[7] = x1 >>> 24 & 0xff;
        o[8] = x2 >>> 0 & 0xff;
        o[9] = x2 >>> 8 & 0xff;
        o[10] = x2 >>> 16 & 0xff;
        o[11] = x2 >>> 24 & 0xff;
        o[12] = x3 >>> 0 & 0xff;
        o[13] = x3 >>> 8 & 0xff;
        o[14] = x3 >>> 16 & 0xff;
        o[15] = x3 >>> 24 & 0xff;
        o[16] = x4 >>> 0 & 0xff;
        o[17] = x4 >>> 8 & 0xff;
        o[18] = x4 >>> 16 & 0xff;
        o[19] = x4 >>> 24 & 0xff;
        o[20] = x5 >>> 0 & 0xff;
        o[21] = x5 >>> 8 & 0xff;
        o[22] = x5 >>> 16 & 0xff;
        o[23] = x5 >>> 24 & 0xff;
        o[24] = x6 >>> 0 & 0xff;
        o[25] = x6 >>> 8 & 0xff;
        o[26] = x6 >>> 16 & 0xff;
        o[27] = x6 >>> 24 & 0xff;
        o[28] = x7 >>> 0 & 0xff;
        o[29] = x7 >>> 8 & 0xff;
        o[30] = x7 >>> 16 & 0xff;
        o[31] = x7 >>> 24 & 0xff;
        o[32] = x8 >>> 0 & 0xff;
        o[33] = x8 >>> 8 & 0xff;
        o[34] = x8 >>> 16 & 0xff;
        o[35] = x8 >>> 24 & 0xff;
        o[36] = x9 >>> 0 & 0xff;
        o[37] = x9 >>> 8 & 0xff;
        o[38] = x9 >>> 16 & 0xff;
        o[39] = x9 >>> 24 & 0xff;
        o[40] = x10 >>> 0 & 0xff;
        o[41] = x10 >>> 8 & 0xff;
        o[42] = x10 >>> 16 & 0xff;
        o[43] = x10 >>> 24 & 0xff;
        o[44] = x11 >>> 0 & 0xff;
        o[45] = x11 >>> 8 & 0xff;
        o[46] = x11 >>> 16 & 0xff;
        o[47] = x11 >>> 24 & 0xff;
        o[48] = x12 >>> 0 & 0xff;
        o[49] = x12 >>> 8 & 0xff;
        o[50] = x12 >>> 16 & 0xff;
        o[51] = x12 >>> 24 & 0xff;
        o[52] = x13 >>> 0 & 0xff;
        o[53] = x13 >>> 8 & 0xff;
        o[54] = x13 >>> 16 & 0xff;
        o[55] = x13 >>> 24 & 0xff;
        o[56] = x14 >>> 0 & 0xff;
        o[57] = x14 >>> 8 & 0xff;
        o[58] = x14 >>> 16 & 0xff;
        o[59] = x14 >>> 24 & 0xff;
        o[60] = x15 >>> 0 & 0xff;
        o[61] = x15 >>> 8 & 0xff;
        o[62] = x15 >>> 16 & 0xff;
        o[63] = x15 >>> 24 & 0xff;
    }
    function core_hsalsa20(o, p, k, c) {
        var j0 = c[0] & 0xff | (c[1] & 0xff) << 8 | (c[2] & 0xff) << 16 | (c[3] & 0xff) << 24, j1 = k[0] & 0xff | (k[1] & 0xff) << 8 | (k[2] & 0xff) << 16 | (k[3] & 0xff) << 24, j2 = k[4] & 0xff | (k[5] & 0xff) << 8 | (k[6] & 0xff) << 16 | (k[7] & 0xff) << 24, j3 = k[8] & 0xff | (k[9] & 0xff) << 8 | (k[10] & 0xff) << 16 | (k[11] & 0xff) << 24, j4 = k[12] & 0xff | (k[13] & 0xff) << 8 | (k[14] & 0xff) << 16 | (k[15] & 0xff) << 24, j5 = c[4] & 0xff | (c[5] & 0xff) << 8 | (c[6] & 0xff) << 16 | (c[7] & 0xff) << 24, j6 = p[0] & 0xff | (p[1] & 0xff) << 8 | (p[2] & 0xff) << 16 | (p[3] & 0xff) << 24, j7 = p[4] & 0xff | (p[5] & 0xff) << 8 | (p[6] & 0xff) << 16 | (p[7] & 0xff) << 24, j8 = p[8] & 0xff | (p[9] & 0xff) << 8 | (p[10] & 0xff) << 16 | (p[11] & 0xff) << 24, j9 = p[12] & 0xff | (p[13] & 0xff) << 8 | (p[14] & 0xff) << 16 | (p[15] & 0xff) << 24, j10 = c[8] & 0xff | (c[9] & 0xff) << 8 | (c[10] & 0xff) << 16 | (c[11] & 0xff) << 24, j11 = k[16] & 0xff | (k[17] & 0xff) << 8 | (k[18] & 0xff) << 16 | (k[19] & 0xff) << 24, j12 = k[20] & 0xff | (k[21] & 0xff) << 8 | (k[22] & 0xff) << 16 | (k[23] & 0xff) << 24, j13 = k[24] & 0xff | (k[25] & 0xff) << 8 | (k[26] & 0xff) << 16 | (k[27] & 0xff) << 24, j14 = k[28] & 0xff | (k[29] & 0xff) << 8 | (k[30] & 0xff) << 16 | (k[31] & 0xff) << 24, j15 = c[12] & 0xff | (c[13] & 0xff) << 8 | (c[14] & 0xff) << 16 | (c[15] & 0xff) << 24;
        var x0 = j0, x1 = j1, x2 = j2, x3 = j3, x4 = j4, x5 = j5, x6 = j6, x7 = j7, x8 = j8, x9 = j9, x10 = j10, x11 = j11, x12 = j12, x13 = j13, x14 = j14, x15 = j15, u;
        for(var i = 0; i < 20; i += 2){
            u = x0 + x12 | 0;
            x4 ^= u << 7 | u >>> 25;
            u = x4 + x0 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x4 | 0;
            x12 ^= u << 13 | u >>> 19;
            u = x12 + x8 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x1 | 0;
            x9 ^= u << 7 | u >>> 25;
            u = x9 + x5 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x9 | 0;
            x1 ^= u << 13 | u >>> 19;
            u = x1 + x13 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x6 | 0;
            x14 ^= u << 7 | u >>> 25;
            u = x14 + x10 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x14 | 0;
            x6 ^= u << 13 | u >>> 19;
            u = x6 + x2 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x11 | 0;
            x3 ^= u << 7 | u >>> 25;
            u = x3 + x15 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x3 | 0;
            x11 ^= u << 13 | u >>> 19;
            u = x11 + x7 | 0;
            x15 ^= u << 18 | u >>> 14;
            u = x0 + x3 | 0;
            x1 ^= u << 7 | u >>> 25;
            u = x1 + x0 | 0;
            x2 ^= u << 9 | u >>> 23;
            u = x2 + x1 | 0;
            x3 ^= u << 13 | u >>> 19;
            u = x3 + x2 | 0;
            x0 ^= u << 18 | u >>> 14;
            u = x5 + x4 | 0;
            x6 ^= u << 7 | u >>> 25;
            u = x6 + x5 | 0;
            x7 ^= u << 9 | u >>> 23;
            u = x7 + x6 | 0;
            x4 ^= u << 13 | u >>> 19;
            u = x4 + x7 | 0;
            x5 ^= u << 18 | u >>> 14;
            u = x10 + x9 | 0;
            x11 ^= u << 7 | u >>> 25;
            u = x11 + x10 | 0;
            x8 ^= u << 9 | u >>> 23;
            u = x8 + x11 | 0;
            x9 ^= u << 13 | u >>> 19;
            u = x9 + x8 | 0;
            x10 ^= u << 18 | u >>> 14;
            u = x15 + x14 | 0;
            x12 ^= u << 7 | u >>> 25;
            u = x12 + x15 | 0;
            x13 ^= u << 9 | u >>> 23;
            u = x13 + x12 | 0;
            x14 ^= u << 13 | u >>> 19;
            u = x14 + x13 | 0;
            x15 ^= u << 18 | u >>> 14;
        }
        o[0] = x0 >>> 0 & 0xff;
        o[1] = x0 >>> 8 & 0xff;
        o[2] = x0 >>> 16 & 0xff;
        o[3] = x0 >>> 24 & 0xff;
        o[4] = x5 >>> 0 & 0xff;
        o[5] = x5 >>> 8 & 0xff;
        o[6] = x5 >>> 16 & 0xff;
        o[7] = x5 >>> 24 & 0xff;
        o[8] = x10 >>> 0 & 0xff;
        o[9] = x10 >>> 8 & 0xff;
        o[10] = x10 >>> 16 & 0xff;
        o[11] = x10 >>> 24 & 0xff;
        o[12] = x15 >>> 0 & 0xff;
        o[13] = x15 >>> 8 & 0xff;
        o[14] = x15 >>> 16 & 0xff;
        o[15] = x15 >>> 24 & 0xff;
        o[16] = x6 >>> 0 & 0xff;
        o[17] = x6 >>> 8 & 0xff;
        o[18] = x6 >>> 16 & 0xff;
        o[19] = x6 >>> 24 & 0xff;
        o[20] = x7 >>> 0 & 0xff;
        o[21] = x7 >>> 8 & 0xff;
        o[22] = x7 >>> 16 & 0xff;
        o[23] = x7 >>> 24 & 0xff;
        o[24] = x8 >>> 0 & 0xff;
        o[25] = x8 >>> 8 & 0xff;
        o[26] = x8 >>> 16 & 0xff;
        o[27] = x8 >>> 24 & 0xff;
        o[28] = x9 >>> 0 & 0xff;
        o[29] = x9 >>> 8 & 0xff;
        o[30] = x9 >>> 16 & 0xff;
        o[31] = x9 >>> 24 & 0xff;
    }
    function crypto_core_salsa20(out, inp, k, c) {
        core_salsa20(out, inp, k, c);
    }
    function crypto_core_hsalsa20(out, inp, k, c) {
        core_hsalsa20(out, inp, k, c);
    }
    var sigma = new Uint8Array([
        101,
        120,
        112,
        97,
        110,
        100,
        32,
        51,
        50,
        45,
        98,
        121,
        116,
        101,
        32,
        107
    ]);
    // "expand 32-byte k"
    function crypto_stream_salsa20_xor(c, cpos, m, mpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = m[mpos + i] ^ x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
            mpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = m[mpos + i] ^ x[i];
        }
        return 0;
    }
    function crypto_stream_salsa20(c, cpos, b, n, k) {
        var z = new Uint8Array(16), x = new Uint8Array(64);
        var u, i;
        for(i = 0; i < 16; i++)z[i] = 0;
        for(i = 0; i < 8; i++)z[i] = n[i];
        while(b >= 64){
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < 64; i++)c[cpos + i] = x[i];
            u = 1;
            for(i = 8; i < 16; i++){
                u = u + (z[i] & 0xff) | 0;
                z[i] = u & 0xff;
                u >>>= 8;
            }
            b -= 64;
            cpos += 64;
        }
        if (b > 0) {
            crypto_core_salsa20(x, z, k, sigma);
            for(i = 0; i < b; i++)c[cpos + i] = x[i];
        }
        return 0;
    }
    function crypto_stream(c, cpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20(c, cpos, d, sn, s);
    }
    function crypto_stream_xor(c, cpos, m, mpos, d, n, k) {
        var s = new Uint8Array(32);
        crypto_core_hsalsa20(s, n, k, sigma);
        var sn = new Uint8Array(8);
        for(var i = 0; i < 8; i++)sn[i] = n[i + 16];
        return crypto_stream_salsa20_xor(c, cpos, m, mpos, d, sn, s);
    }
    /*
* Port of Andrew Moon's Poly1305-donna-16. Public domain.
* https://github.com/floodyberry/poly1305-donna
*/ var poly1305 = function(key) {
        this.buffer = new Uint8Array(16);
        this.r = new Uint16Array(10);
        this.h = new Uint16Array(10);
        this.pad = new Uint16Array(8);
        this.leftover = 0;
        this.fin = 0;
        var t0, t1, t2, t3, t4, t5, t6, t7;
        t0 = key[0] & 0xff | (key[1] & 0xff) << 8;
        this.r[0] = t0 & 0x1fff;
        t1 = key[2] & 0xff | (key[3] & 0xff) << 8;
        this.r[1] = (t0 >>> 13 | t1 << 3) & 0x1fff;
        t2 = key[4] & 0xff | (key[5] & 0xff) << 8;
        this.r[2] = (t1 >>> 10 | t2 << 6) & 0x1f03;
        t3 = key[6] & 0xff | (key[7] & 0xff) << 8;
        this.r[3] = (t2 >>> 7 | t3 << 9) & 0x1fff;
        t4 = key[8] & 0xff | (key[9] & 0xff) << 8;
        this.r[4] = (t3 >>> 4 | t4 << 12) & 0x00ff;
        this.r[5] = t4 >>> 1 & 0x1ffe;
        t5 = key[10] & 0xff | (key[11] & 0xff) << 8;
        this.r[6] = (t4 >>> 14 | t5 << 2) & 0x1fff;
        t6 = key[12] & 0xff | (key[13] & 0xff) << 8;
        this.r[7] = (t5 >>> 11 | t6 << 5) & 0x1f81;
        t7 = key[14] & 0xff | (key[15] & 0xff) << 8;
        this.r[8] = (t6 >>> 8 | t7 << 8) & 0x1fff;
        this.r[9] = t7 >>> 5 & 0x007f;
        this.pad[0] = key[16] & 0xff | (key[17] & 0xff) << 8;
        this.pad[1] = key[18] & 0xff | (key[19] & 0xff) << 8;
        this.pad[2] = key[20] & 0xff | (key[21] & 0xff) << 8;
        this.pad[3] = key[22] & 0xff | (key[23] & 0xff) << 8;
        this.pad[4] = key[24] & 0xff | (key[25] & 0xff) << 8;
        this.pad[5] = key[26] & 0xff | (key[27] & 0xff) << 8;
        this.pad[6] = key[28] & 0xff | (key[29] & 0xff) << 8;
        this.pad[7] = key[30] & 0xff | (key[31] & 0xff) << 8;
    };
    poly1305.prototype.blocks = function(m, mpos, bytes) {
        var hibit = this.fin ? 0 : 2048;
        var t0, t1, t2, t3, t4, t5, t6, t7, c;
        var d0, d1, d2, d3, d4, d5, d6, d7, d8, d9;
        var h0 = this.h[0], h1 = this.h[1], h2 = this.h[2], h3 = this.h[3], h4 = this.h[4], h5 = this.h[5], h6 = this.h[6], h7 = this.h[7], h8 = this.h[8], h9 = this.h[9];
        var r0 = this.r[0], r1 = this.r[1], r2 = this.r[2], r3 = this.r[3], r4 = this.r[4], r5 = this.r[5], r6 = this.r[6], r7 = this.r[7], r8 = this.r[8], r9 = this.r[9];
        while(bytes >= 16){
            t0 = m[mpos + 0] & 0xff | (m[mpos + 1] & 0xff) << 8;
            h0 += t0 & 0x1fff;
            t1 = m[mpos + 2] & 0xff | (m[mpos + 3] & 0xff) << 8;
            h1 += (t0 >>> 13 | t1 << 3) & 0x1fff;
            t2 = m[mpos + 4] & 0xff | (m[mpos + 5] & 0xff) << 8;
            h2 += (t1 >>> 10 | t2 << 6) & 0x1fff;
            t3 = m[mpos + 6] & 0xff | (m[mpos + 7] & 0xff) << 8;
            h3 += (t2 >>> 7 | t3 << 9) & 0x1fff;
            t4 = m[mpos + 8] & 0xff | (m[mpos + 9] & 0xff) << 8;
            h4 += (t3 >>> 4 | t4 << 12) & 0x1fff;
            h5 += t4 >>> 1 & 0x1fff;
            t5 = m[mpos + 10] & 0xff | (m[mpos + 11] & 0xff) << 8;
            h6 += (t4 >>> 14 | t5 << 2) & 0x1fff;
            t6 = m[mpos + 12] & 0xff | (m[mpos + 13] & 0xff) << 8;
            h7 += (t5 >>> 11 | t6 << 5) & 0x1fff;
            t7 = m[mpos + 14] & 0xff | (m[mpos + 15] & 0xff) << 8;
            h8 += (t6 >>> 8 | t7 << 8) & 0x1fff;
            h9 += t7 >>> 5 | hibit;
            c = 0;
            d0 = c;
            d0 += h0 * r0;
            d0 += h1 * (5 * r9);
            d0 += h2 * (5 * r8);
            d0 += h3 * (5 * r7);
            d0 += h4 * (5 * r6);
            c = d0 >>> 13;
            d0 &= 0x1fff;
            d0 += h5 * (5 * r5);
            d0 += h6 * (5 * r4);
            d0 += h7 * (5 * r3);
            d0 += h8 * (5 * r2);
            d0 += h9 * (5 * r1);
            c += d0 >>> 13;
            d0 &= 0x1fff;
            d1 = c;
            d1 += h0 * r1;
            d1 += h1 * r0;
            d1 += h2 * (5 * r9);
            d1 += h3 * (5 * r8);
            d1 += h4 * (5 * r7);
            c = d1 >>> 13;
            d1 &= 0x1fff;
            d1 += h5 * (5 * r6);
            d1 += h6 * (5 * r5);
            d1 += h7 * (5 * r4);
            d1 += h8 * (5 * r3);
            d1 += h9 * (5 * r2);
            c += d1 >>> 13;
            d1 &= 0x1fff;
            d2 = c;
            d2 += h0 * r2;
            d2 += h1 * r1;
            d2 += h2 * r0;
            d2 += h3 * (5 * r9);
            d2 += h4 * (5 * r8);
            c = d2 >>> 13;
            d2 &= 0x1fff;
            d2 += h5 * (5 * r7);
            d2 += h6 * (5 * r6);
            d2 += h7 * (5 * r5);
            d2 += h8 * (5 * r4);
            d2 += h9 * (5 * r3);
            c += d2 >>> 13;
            d2 &= 0x1fff;
            d3 = c;
            d3 += h0 * r3;
            d3 += h1 * r2;
            d3 += h2 * r1;
            d3 += h3 * r0;
            d3 += h4 * (5 * r9);
            c = d3 >>> 13;
            d3 &= 0x1fff;
            d3 += h5 * (5 * r8);
            d3 += h6 * (5 * r7);
            d3 += h7 * (5 * r6);
            d3 += h8 * (5 * r5);
            d3 += h9 * (5 * r4);
            c += d3 >>> 13;
            d3 &= 0x1fff;
            d4 = c;
            d4 += h0 * r4;
            d4 += h1 * r3;
            d4 += h2 * r2;
            d4 += h3 * r1;
            d4 += h4 * r0;
            c = d4 >>> 13;
            d4 &= 0x1fff;
            d4 += h5 * (5 * r9);
            d4 += h6 * (5 * r8);
            d4 += h7 * (5 * r7);
            d4 += h8 * (5 * r6);
            d4 += h9 * (5 * r5);
            c += d4 >>> 13;
            d4 &= 0x1fff;
            d5 = c;
            d5 += h0 * r5;
            d5 += h1 * r4;
            d5 += h2 * r3;
            d5 += h3 * r2;
            d5 += h4 * r1;
            c = d5 >>> 13;
            d5 &= 0x1fff;
            d5 += h5 * r0;
            d5 += h6 * (5 * r9);
            d5 += h7 * (5 * r8);
            d5 += h8 * (5 * r7);
            d5 += h9 * (5 * r6);
            c += d5 >>> 13;
            d5 &= 0x1fff;
            d6 = c;
            d6 += h0 * r6;
            d6 += h1 * r5;
            d6 += h2 * r4;
            d6 += h3 * r3;
            d6 += h4 * r2;
            c = d6 >>> 13;
            d6 &= 0x1fff;
            d6 += h5 * r1;
            d6 += h6 * r0;
            d6 += h7 * (5 * r9);
            d6 += h8 * (5 * r8);
            d6 += h9 * (5 * r7);
            c += d6 >>> 13;
            d6 &= 0x1fff;
            d7 = c;
            d7 += h0 * r7;
            d7 += h1 * r6;
            d7 += h2 * r5;
            d7 += h3 * r4;
            d7 += h4 * r3;
            c = d7 >>> 13;
            d7 &= 0x1fff;
            d7 += h5 * r2;
            d7 += h6 * r1;
            d7 += h7 * r0;
            d7 += h8 * (5 * r9);
            d7 += h9 * (5 * r8);
            c += d7 >>> 13;
            d7 &= 0x1fff;
            d8 = c;
            d8 += h0 * r8;
            d8 += h1 * r7;
            d8 += h2 * r6;
            d8 += h3 * r5;
            d8 += h4 * r4;
            c = d8 >>> 13;
            d8 &= 0x1fff;
            d8 += h5 * r3;
            d8 += h6 * r2;
            d8 += h7 * r1;
            d8 += h8 * r0;
            d8 += h9 * (5 * r9);
            c += d8 >>> 13;
            d8 &= 0x1fff;
            d9 = c;
            d9 += h0 * r9;
            d9 += h1 * r8;
            d9 += h2 * r7;
            d9 += h3 * r6;
            d9 += h4 * r5;
            c = d9 >>> 13;
            d9 &= 0x1fff;
            d9 += h5 * r4;
            d9 += h6 * r3;
            d9 += h7 * r2;
            d9 += h8 * r1;
            d9 += h9 * r0;
            c += d9 >>> 13;
            d9 &= 0x1fff;
            c = (c << 2) + c | 0;
            c = c + d0 | 0;
            d0 = c & 0x1fff;
            c = c >>> 13;
            d1 += c;
            h0 = d0;
            h1 = d1;
            h2 = d2;
            h3 = d3;
            h4 = d4;
            h5 = d5;
            h6 = d6;
            h7 = d7;
            h8 = d8;
            h9 = d9;
            mpos += 16;
            bytes -= 16;
        }
        this.h[0] = h0;
        this.h[1] = h1;
        this.h[2] = h2;
        this.h[3] = h3;
        this.h[4] = h4;
        this.h[5] = h5;
        this.h[6] = h6;
        this.h[7] = h7;
        this.h[8] = h8;
        this.h[9] = h9;
    };
    poly1305.prototype.finish = function(mac, macpos) {
        var g = new Uint16Array(10);
        var c, mask, f, i;
        if (this.leftover) {
            i = this.leftover;
            this.buffer[i++] = 1;
            for(; i < 16; i++)this.buffer[i] = 0;
            this.fin = 1;
            this.blocks(this.buffer, 0, 16);
        }
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        for(i = 2; i < 10; i++){
            this.h[i] += c;
            c = this.h[i] >>> 13;
            this.h[i] &= 0x1fff;
        }
        this.h[0] += c * 5;
        c = this.h[0] >>> 13;
        this.h[0] &= 0x1fff;
        this.h[1] += c;
        c = this.h[1] >>> 13;
        this.h[1] &= 0x1fff;
        this.h[2] += c;
        g[0] = this.h[0] + 5;
        c = g[0] >>> 13;
        g[0] &= 0x1fff;
        for(i = 1; i < 10; i++){
            g[i] = this.h[i] + c;
            c = g[i] >>> 13;
            g[i] &= 0x1fff;
        }
        g[9] -= 8192;
        mask = (c ^ 1) - 1;
        for(i = 0; i < 10; i++)g[i] &= mask;
        mask = ~mask;
        for(i = 0; i < 10; i++)this.h[i] = this.h[i] & mask | g[i];
        this.h[0] = (this.h[0] | this.h[1] << 13) & 0xffff;
        this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 0xffff;
        this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 0xffff;
        this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 0xffff;
        this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 0xffff;
        this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 0xffff;
        this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 0xffff;
        this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 0xffff;
        f = this.h[0] + this.pad[0];
        this.h[0] = f & 0xffff;
        for(i = 1; i < 8; i++){
            f = (this.h[i] + this.pad[i] | 0) + (f >>> 16) | 0;
            this.h[i] = f & 0xffff;
        }
        mac[macpos + 0] = this.h[0] >>> 0 & 0xff;
        mac[macpos + 1] = this.h[0] >>> 8 & 0xff;
        mac[macpos + 2] = this.h[1] >>> 0 & 0xff;
        mac[macpos + 3] = this.h[1] >>> 8 & 0xff;
        mac[macpos + 4] = this.h[2] >>> 0 & 0xff;
        mac[macpos + 5] = this.h[2] >>> 8 & 0xff;
        mac[macpos + 6] = this.h[3] >>> 0 & 0xff;
        mac[macpos + 7] = this.h[3] >>> 8 & 0xff;
        mac[macpos + 8] = this.h[4] >>> 0 & 0xff;
        mac[macpos + 9] = this.h[4] >>> 8 & 0xff;
        mac[macpos + 10] = this.h[5] >>> 0 & 0xff;
        mac[macpos + 11] = this.h[5] >>> 8 & 0xff;
        mac[macpos + 12] = this.h[6] >>> 0 & 0xff;
        mac[macpos + 13] = this.h[6] >>> 8 & 0xff;
        mac[macpos + 14] = this.h[7] >>> 0 & 0xff;
        mac[macpos + 15] = this.h[7] >>> 8 & 0xff;
    };
    poly1305.prototype.update = function(m, mpos, bytes) {
        var i, want;
        if (this.leftover) {
            want = 16 - this.leftover;
            if (want > bytes) want = bytes;
            for(i = 0; i < want; i++)this.buffer[this.leftover + i] = m[mpos + i];
            bytes -= want;
            mpos += want;
            this.leftover += want;
            if (this.leftover < 16) return;
            this.blocks(this.buffer, 0, 16);
            this.leftover = 0;
        }
        if (bytes >= 16) {
            want = bytes - bytes % 16;
            this.blocks(m, mpos, want);
            mpos += want;
            bytes -= want;
        }
        if (bytes) {
            for(i = 0; i < bytes; i++)this.buffer[this.leftover + i] = m[mpos + i];
            this.leftover += bytes;
        }
    };
    function crypto_onetimeauth(out, outpos, m, mpos, n, k) {
        var s = new poly1305(k);
        s.update(m, mpos, n);
        s.finish(out, outpos);
        return 0;
    }
    function crypto_onetimeauth_verify(h, hpos, m, mpos, n, k) {
        var x = new Uint8Array(16);
        crypto_onetimeauth(x, 0, m, mpos, n, k);
        return crypto_verify_16(h, hpos, x, 0);
    }
    function crypto_secretbox(c, m, d, n, k) {
        var i;
        if (d < 32) return -1;
        crypto_stream_xor(c, 0, m, 0, d, n, k);
        crypto_onetimeauth(c, 16, c, 32, d - 32, c);
        for(i = 0; i < 16; i++)c[i] = 0;
        return 0;
    }
    function crypto_secretbox_open(m, c, d, n, k) {
        var i;
        var x = new Uint8Array(32);
        if (d < 32) return -1;
        crypto_stream(x, 0, 32, n, k);
        if (crypto_onetimeauth_verify(c, 16, c, 32, d - 32, x) !== 0) return -1;
        crypto_stream_xor(m, 0, c, 0, d, n, k);
        for(i = 0; i < 32; i++)m[i] = 0;
        return 0;
    }
    function set25519(r, a) {
        var i;
        for(i = 0; i < 16; i++)r[i] = a[i] | 0;
    }
    function car25519(o) {
        var i, v, c = 1;
        for(i = 0; i < 16; i++){
            v = o[i] + c + 65535;
            c = Math.floor(v / 65536);
            o[i] = v - c * 65536;
        }
        o[0] += c - 1 + 37 * (c - 1);
    }
    function sel25519(p, q, b) {
        var t, c = ~(b - 1);
        for(var i = 0; i < 16; i++){
            t = c & (p[i] ^ q[i]);
            p[i] ^= t;
            q[i] ^= t;
        }
    }
    function pack25519(o, n) {
        var i, j, b;
        var m = gf(), t = gf();
        for(i = 0; i < 16; i++)t[i] = n[i];
        car25519(t);
        car25519(t);
        car25519(t);
        for(j = 0; j < 2; j++){
            m[0] = t[0] - 0xffed;
            for(i = 1; i < 15; i++){
                m[i] = t[i] - 0xffff - (m[i - 1] >> 16 & 1);
                m[i - 1] &= 0xffff;
            }
            m[15] = t[15] - 0x7fff - (m[14] >> 16 & 1);
            b = m[15] >> 16 & 1;
            m[14] &= 0xffff;
            sel25519(t, m, 1 - b);
        }
        for(i = 0; i < 16; i++){
            o[2 * i] = t[i] & 0xff;
            o[2 * i + 1] = t[i] >> 8;
        }
    }
    function neq25519(a, b) {
        var c = new Uint8Array(32), d = new Uint8Array(32);
        pack25519(c, a);
        pack25519(d, b);
        return crypto_verify_32(c, 0, d, 0);
    }
    function par25519(a) {
        var d = new Uint8Array(32);
        pack25519(d, a);
        return d[0] & 1;
    }
    function unpack25519(o, n) {
        var i;
        for(i = 0; i < 16; i++)o[i] = n[2 * i] + (n[2 * i + 1] << 8);
        o[15] &= 0x7fff;
    }
    function A(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] + b[i];
    }
    function Z(o, a, b) {
        for(var i = 0; i < 16; i++)o[i] = a[i] - b[i];
    }
    function M(o, a, b) {
        var v, c, t0 = 0, t1 = 0, t2 = 0, t3 = 0, t4 = 0, t5 = 0, t6 = 0, t7 = 0, t8 = 0, t9 = 0, t10 = 0, t11 = 0, t12 = 0, t13 = 0, t14 = 0, t15 = 0, t16 = 0, t17 = 0, t18 = 0, t19 = 0, t20 = 0, t21 = 0, t22 = 0, t23 = 0, t24 = 0, t25 = 0, t26 = 0, t27 = 0, t28 = 0, t29 = 0, t30 = 0, b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = b[6], b7 = b[7], b8 = b[8], b9 = b[9], b10 = b[10], b11 = b[11], b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];
        v = a[0];
        t0 += v * b0;
        t1 += v * b1;
        t2 += v * b2;
        t3 += v * b3;
        t4 += v * b4;
        t5 += v * b5;
        t6 += v * b6;
        t7 += v * b7;
        t8 += v * b8;
        t9 += v * b9;
        t10 += v * b10;
        t11 += v * b11;
        t12 += v * b12;
        t13 += v * b13;
        t14 += v * b14;
        t15 += v * b15;
        v = a[1];
        t1 += v * b0;
        t2 += v * b1;
        t3 += v * b2;
        t4 += v * b3;
        t5 += v * b4;
        t6 += v * b5;
        t7 += v * b6;
        t8 += v * b7;
        t9 += v * b8;
        t10 += v * b9;
        t11 += v * b10;
        t12 += v * b11;
        t13 += v * b12;
        t14 += v * b13;
        t15 += v * b14;
        t16 += v * b15;
        v = a[2];
        t2 += v * b0;
        t3 += v * b1;
        t4 += v * b2;
        t5 += v * b3;
        t6 += v * b4;
        t7 += v * b5;
        t8 += v * b6;
        t9 += v * b7;
        t10 += v * b8;
        t11 += v * b9;
        t12 += v * b10;
        t13 += v * b11;
        t14 += v * b12;
        t15 += v * b13;
        t16 += v * b14;
        t17 += v * b15;
        v = a[3];
        t3 += v * b0;
        t4 += v * b1;
        t5 += v * b2;
        t6 += v * b3;
        t7 += v * b4;
        t8 += v * b5;
        t9 += v * b6;
        t10 += v * b7;
        t11 += v * b8;
        t12 += v * b9;
        t13 += v * b10;
        t14 += v * b11;
        t15 += v * b12;
        t16 += v * b13;
        t17 += v * b14;
        t18 += v * b15;
        v = a[4];
        t4 += v * b0;
        t5 += v * b1;
        t6 += v * b2;
        t7 += v * b3;
        t8 += v * b4;
        t9 += v * b5;
        t10 += v * b6;
        t11 += v * b7;
        t12 += v * b8;
        t13 += v * b9;
        t14 += v * b10;
        t15 += v * b11;
        t16 += v * b12;
        t17 += v * b13;
        t18 += v * b14;
        t19 += v * b15;
        v = a[5];
        t5 += v * b0;
        t6 += v * b1;
        t7 += v * b2;
        t8 += v * b3;
        t9 += v * b4;
        t10 += v * b5;
        t11 += v * b6;
        t12 += v * b7;
        t13 += v * b8;
        t14 += v * b9;
        t15 += v * b10;
        t16 += v * b11;
        t17 += v * b12;
        t18 += v * b13;
        t19 += v * b14;
        t20 += v * b15;
        v = a[6];
        t6 += v * b0;
        t7 += v * b1;
        t8 += v * b2;
        t9 += v * b3;
        t10 += v * b4;
        t11 += v * b5;
        t12 += v * b6;
        t13 += v * b7;
        t14 += v * b8;
        t15 += v * b9;
        t16 += v * b10;
        t17 += v * b11;
        t18 += v * b12;
        t19 += v * b13;
        t20 += v * b14;
        t21 += v * b15;
        v = a[7];
        t7 += v * b0;
        t8 += v * b1;
        t9 += v * b2;
        t10 += v * b3;
        t11 += v * b4;
        t12 += v * b5;
        t13 += v * b6;
        t14 += v * b7;
        t15 += v * b8;
        t16 += v * b9;
        t17 += v * b10;
        t18 += v * b11;
        t19 += v * b12;
        t20 += v * b13;
        t21 += v * b14;
        t22 += v * b15;
        v = a[8];
        t8 += v * b0;
        t9 += v * b1;
        t10 += v * b2;
        t11 += v * b3;
        t12 += v * b4;
        t13 += v * b5;
        t14 += v * b6;
        t15 += v * b7;
        t16 += v * b8;
        t17 += v * b9;
        t18 += v * b10;
        t19 += v * b11;
        t20 += v * b12;
        t21 += v * b13;
        t22 += v * b14;
        t23 += v * b15;
        v = a[9];
        t9 += v * b0;
        t10 += v * b1;
        t11 += v * b2;
        t12 += v * b3;
        t13 += v * b4;
        t14 += v * b5;
        t15 += v * b6;
        t16 += v * b7;
        t17 += v * b8;
        t18 += v * b9;
        t19 += v * b10;
        t20 += v * b11;
        t21 += v * b12;
        t22 += v * b13;
        t23 += v * b14;
        t24 += v * b15;
        v = a[10];
        t10 += v * b0;
        t11 += v * b1;
        t12 += v * b2;
        t13 += v * b3;
        t14 += v * b4;
        t15 += v * b5;
        t16 += v * b6;
        t17 += v * b7;
        t18 += v * b8;
        t19 += v * b9;
        t20 += v * b10;
        t21 += v * b11;
        t22 += v * b12;
        t23 += v * b13;
        t24 += v * b14;
        t25 += v * b15;
        v = a[11];
        t11 += v * b0;
        t12 += v * b1;
        t13 += v * b2;
        t14 += v * b3;
        t15 += v * b4;
        t16 += v * b5;
        t17 += v * b6;
        t18 += v * b7;
        t19 += v * b8;
        t20 += v * b9;
        t21 += v * b10;
        t22 += v * b11;
        t23 += v * b12;
        t24 += v * b13;
        t25 += v * b14;
        t26 += v * b15;
        v = a[12];
        t12 += v * b0;
        t13 += v * b1;
        t14 += v * b2;
        t15 += v * b3;
        t16 += v * b4;
        t17 += v * b5;
        t18 += v * b6;
        t19 += v * b7;
        t20 += v * b8;
        t21 += v * b9;
        t22 += v * b10;
        t23 += v * b11;
        t24 += v * b12;
        t25 += v * b13;
        t26 += v * b14;
        t27 += v * b15;
        v = a[13];
        t13 += v * b0;
        t14 += v * b1;
        t15 += v * b2;
        t16 += v * b3;
        t17 += v * b4;
        t18 += v * b5;
        t19 += v * b6;
        t20 += v * b7;
        t21 += v * b8;
        t22 += v * b9;
        t23 += v * b10;
        t24 += v * b11;
        t25 += v * b12;
        t26 += v * b13;
        t27 += v * b14;
        t28 += v * b15;
        v = a[14];
        t14 += v * b0;
        t15 += v * b1;
        t16 += v * b2;
        t17 += v * b3;
        t18 += v * b4;
        t19 += v * b5;
        t20 += v * b6;
        t21 += v * b7;
        t22 += v * b8;
        t23 += v * b9;
        t24 += v * b10;
        t25 += v * b11;
        t26 += v * b12;
        t27 += v * b13;
        t28 += v * b14;
        t29 += v * b15;
        v = a[15];
        t15 += v * b0;
        t16 += v * b1;
        t17 += v * b2;
        t18 += v * b3;
        t19 += v * b4;
        t20 += v * b5;
        t21 += v * b6;
        t22 += v * b7;
        t23 += v * b8;
        t24 += v * b9;
        t25 += v * b10;
        t26 += v * b11;
        t27 += v * b12;
        t28 += v * b13;
        t29 += v * b14;
        t30 += v * b15;
        t0 += 38 * t16;
        t1 += 38 * t17;
        t2 += 38 * t18;
        t3 += 38 * t19;
        t4 += 38 * t20;
        t5 += 38 * t21;
        t6 += 38 * t22;
        t7 += 38 * t23;
        t8 += 38 * t24;
        t9 += 38 * t25;
        t10 += 38 * t26;
        t11 += 38 * t27;
        t12 += 38 * t28;
        t13 += 38 * t29;
        t14 += 38 * t30;
        // t15 left as is
        // first car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        // second car
        c = 1;
        v = t0 + c + 65535;
        c = Math.floor(v / 65536);
        t0 = v - c * 65536;
        v = t1 + c + 65535;
        c = Math.floor(v / 65536);
        t1 = v - c * 65536;
        v = t2 + c + 65535;
        c = Math.floor(v / 65536);
        t2 = v - c * 65536;
        v = t3 + c + 65535;
        c = Math.floor(v / 65536);
        t3 = v - c * 65536;
        v = t4 + c + 65535;
        c = Math.floor(v / 65536);
        t4 = v - c * 65536;
        v = t5 + c + 65535;
        c = Math.floor(v / 65536);
        t5 = v - c * 65536;
        v = t6 + c + 65535;
        c = Math.floor(v / 65536);
        t6 = v - c * 65536;
        v = t7 + c + 65535;
        c = Math.floor(v / 65536);
        t7 = v - c * 65536;
        v = t8 + c + 65535;
        c = Math.floor(v / 65536);
        t8 = v - c * 65536;
        v = t9 + c + 65535;
        c = Math.floor(v / 65536);
        t9 = v - c * 65536;
        v = t10 + c + 65535;
        c = Math.floor(v / 65536);
        t10 = v - c * 65536;
        v = t11 + c + 65535;
        c = Math.floor(v / 65536);
        t11 = v - c * 65536;
        v = t12 + c + 65535;
        c = Math.floor(v / 65536);
        t12 = v - c * 65536;
        v = t13 + c + 65535;
        c = Math.floor(v / 65536);
        t13 = v - c * 65536;
        v = t14 + c + 65535;
        c = Math.floor(v / 65536);
        t14 = v - c * 65536;
        v = t15 + c + 65535;
        c = Math.floor(v / 65536);
        t15 = v - c * 65536;
        t0 += c - 1 + 37 * (c - 1);
        o[0] = t0;
        o[1] = t1;
        o[2] = t2;
        o[3] = t3;
        o[4] = t4;
        o[5] = t5;
        o[6] = t6;
        o[7] = t7;
        o[8] = t8;
        o[9] = t9;
        o[10] = t10;
        o[11] = t11;
        o[12] = t12;
        o[13] = t13;
        o[14] = t14;
        o[15] = t15;
    }
    function S(o, a) {
        M(o, a, a);
    }
    function inv25519(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 253; a >= 0; a--){
            S(c, c);
            if (a !== 2 && a !== 4) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function pow2523(o, i) {
        var c = gf();
        var a;
        for(a = 0; a < 16; a++)c[a] = i[a];
        for(a = 250; a >= 0; a--){
            S(c, c);
            if (a !== 1) M(c, c, i);
        }
        for(a = 0; a < 16; a++)o[a] = c[a];
    }
    function crypto_scalarmult(q, n, p) {
        var z = new Uint8Array(32);
        var x = new Float64Array(80), r, i;
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf();
        for(i = 0; i < 31; i++)z[i] = n[i];
        z[31] = n[31] & 127 | 64;
        z[0] &= 248;
        unpack25519(x, p);
        for(i = 0; i < 16; i++){
            b[i] = x[i];
            d[i] = a[i] = c[i] = 0;
        }
        a[0] = d[0] = 1;
        for(i = 254; i >= 0; --i){
            r = z[i >>> 3] >>> (i & 7) & 1;
            sel25519(a, b, r);
            sel25519(c, d, r);
            A(e, a, c);
            Z(a, a, c);
            A(c, b, d);
            Z(b, b, d);
            S(d, e);
            S(f, a);
            M(a, c, a);
            M(c, b, e);
            A(e, a, c);
            Z(a, a, c);
            S(b, a);
            Z(c, d, f);
            M(a, c, _121665);
            A(a, a, d);
            M(c, c, a);
            M(a, d, f);
            M(d, b, x);
            S(b, e);
            sel25519(a, b, r);
            sel25519(c, d, r);
        }
        for(i = 0; i < 16; i++){
            x[i + 16] = a[i];
            x[i + 32] = c[i];
            x[i + 48] = b[i];
            x[i + 64] = d[i];
        }
        var x32 = x.subarray(32);
        var x16 = x.subarray(16);
        inv25519(x32, x32);
        M(x16, x16, x32);
        pack25519(q, x16);
        return 0;
    }
    function crypto_scalarmult_base(q, n) {
        return crypto_scalarmult(q, n, _9);
    }
    function crypto_box_keypair(y, x) {
        randombytes(x, 32);
        return crypto_scalarmult_base(y, x);
    }
    function crypto_box_beforenm(k, y, x) {
        var s = new Uint8Array(32);
        crypto_scalarmult(s, x, y);
        return crypto_core_hsalsa20(k, _0, s, sigma);
    }
    var crypto_box_afternm = crypto_secretbox;
    var crypto_box_open_afternm = crypto_secretbox_open;
    function crypto_box(c, m, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_afternm(c, m, d, n, k);
    }
    function crypto_box_open(m, c, d, n, y, x) {
        var k = new Uint8Array(32);
        crypto_box_beforenm(k, y, x);
        return crypto_box_open_afternm(m, c, d, n, k);
    }
    var K = [
        0x428a2f98,
        0xd728ae22,
        0x71374491,
        0x23ef65cd,
        0xb5c0fbcf,
        0xec4d3b2f,
        0xe9b5dba5,
        0x8189dbbc,
        0x3956c25b,
        0xf348b538,
        0x59f111f1,
        0xb605d019,
        0x923f82a4,
        0xaf194f9b,
        0xab1c5ed5,
        0xda6d8118,
        0xd807aa98,
        0xa3030242,
        0x12835b01,
        0x45706fbe,
        0x243185be,
        0x4ee4b28c,
        0x550c7dc3,
        0xd5ffb4e2,
        0x72be5d74,
        0xf27b896f,
        0x80deb1fe,
        0x3b1696b1,
        0x9bdc06a7,
        0x25c71235,
        0xc19bf174,
        0xcf692694,
        0xe49b69c1,
        0x9ef14ad2,
        0xefbe4786,
        0x384f25e3,
        0x0fc19dc6,
        0x8b8cd5b5,
        0x240ca1cc,
        0x77ac9c65,
        0x2de92c6f,
        0x592b0275,
        0x4a7484aa,
        0x6ea6e483,
        0x5cb0a9dc,
        0xbd41fbd4,
        0x76f988da,
        0x831153b5,
        0x983e5152,
        0xee66dfab,
        0xa831c66d,
        0x2db43210,
        0xb00327c8,
        0x98fb213f,
        0xbf597fc7,
        0xbeef0ee4,
        0xc6e00bf3,
        0x3da88fc2,
        0xd5a79147,
        0x930aa725,
        0x06ca6351,
        0xe003826f,
        0x14292967,
        0x0a0e6e70,
        0x27b70a85,
        0x46d22ffc,
        0x2e1b2138,
        0x5c26c926,
        0x4d2c6dfc,
        0x5ac42aed,
        0x53380d13,
        0x9d95b3df,
        0x650a7354,
        0x8baf63de,
        0x766a0abb,
        0x3c77b2a8,
        0x81c2c92e,
        0x47edaee6,
        0x92722c85,
        0x1482353b,
        0xa2bfe8a1,
        0x4cf10364,
        0xa81a664b,
        0xbc423001,
        0xc24b8b70,
        0xd0f89791,
        0xc76c51a3,
        0x0654be30,
        0xd192e819,
        0xd6ef5218,
        0xd6990624,
        0x5565a910,
        0xf40e3585,
        0x5771202a,
        0x106aa070,
        0x32bbd1b8,
        0x19a4c116,
        0xb8d2d0c8,
        0x1e376c08,
        0x5141ab53,
        0x2748774c,
        0xdf8eeb99,
        0x34b0bcb5,
        0xe19b48a8,
        0x391c0cb3,
        0xc5c95a63,
        0x4ed8aa4a,
        0xe3418acb,
        0x5b9cca4f,
        0x7763e373,
        0x682e6ff3,
        0xd6b2b8a3,
        0x748f82ee,
        0x5defb2fc,
        0x78a5636f,
        0x43172f60,
        0x84c87814,
        0xa1f0ab72,
        0x8cc70208,
        0x1a6439ec,
        0x90befffa,
        0x23631e28,
        0xa4506ceb,
        0xde82bde9,
        0xbef9a3f7,
        0xb2c67915,
        0xc67178f2,
        0xe372532b,
        0xca273ece,
        0xea26619c,
        0xd186b8c7,
        0x21c0c207,
        0xeada7dd6,
        0xcde0eb1e,
        0xf57d4f7f,
        0xee6ed178,
        0x06f067aa,
        0x72176fba,
        0x0a637dc5,
        0xa2c898a6,
        0x113f9804,
        0xbef90dae,
        0x1b710b35,
        0x131c471b,
        0x28db77f5,
        0x23047d84,
        0x32caab7b,
        0x40c72493,
        0x3c9ebe0a,
        0x15c9bebc,
        0x431d67c4,
        0x9c100d4c,
        0x4cc5d4be,
        0xcb3e42b6,
        0x597f299c,
        0xfc657e2a,
        0x5fcb6fab,
        0x3ad6faec,
        0x6c44198c,
        0x4a475817
    ];
    function crypto_hashblocks_hl(hh, hl, m, n) {
        var wh = new Int32Array(16), wl = new Int32Array(16), bh0, bh1, bh2, bh3, bh4, bh5, bh6, bh7, bl0, bl1, bl2, bl3, bl4, bl5, bl6, bl7, th, tl, i, j, h, l, a, b, c, d;
        var ah0 = hh[0], ah1 = hh[1], ah2 = hh[2], ah3 = hh[3], ah4 = hh[4], ah5 = hh[5], ah6 = hh[6], ah7 = hh[7], al0 = hl[0], al1 = hl[1], al2 = hl[2], al3 = hl[3], al4 = hl[4], al5 = hl[5], al6 = hl[6], al7 = hl[7];
        var pos = 0;
        while(n >= 128){
            for(i = 0; i < 16; i++){
                j = 8 * i + pos;
                wh[i] = m[j + 0] << 24 | m[j + 1] << 16 | m[j + 2] << 8 | m[j + 3];
                wl[i] = m[j + 4] << 24 | m[j + 5] << 16 | m[j + 6] << 8 | m[j + 7];
            }
            for(i = 0; i < 80; i++){
                bh0 = ah0;
                bh1 = ah1;
                bh2 = ah2;
                bh3 = ah3;
                bh4 = ah4;
                bh5 = ah5;
                bh6 = ah6;
                bh7 = ah7;
                bl0 = al0;
                bl1 = al1;
                bl2 = al2;
                bl3 = al3;
                bl4 = al4;
                bl5 = al5;
                bl6 = al6;
                bl7 = al7;
                // add
                h = ah7;
                l = al7;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma1
                h = (ah4 >>> 14 | al4 << 18) ^ (ah4 >>> 18 | al4 << 14) ^ (al4 >>> 9 | ah4 << 23);
                l = (al4 >>> 14 | ah4 << 18) ^ (al4 >>> 18 | ah4 << 14) ^ (ah4 >>> 9 | al4 << 23);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Ch
                h = ah4 & ah5 ^ ~ah4 & ah6;
                l = al4 & al5 ^ ~al4 & al6;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // K
                h = K[i * 2];
                l = K[i * 2 + 1];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // w
                h = wh[i % 16];
                l = wl[i % 16];
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                th = c & 0xffff | d << 16;
                tl = a & 0xffff | b << 16;
                // add
                h = th;
                l = tl;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                // Sigma0
                h = (ah0 >>> 28 | al0 << 4) ^ (al0 >>> 2 | ah0 << 30) ^ (al0 >>> 7 | ah0 << 25);
                l = (al0 >>> 28 | ah0 << 4) ^ (ah0 >>> 2 | al0 << 30) ^ (ah0 >>> 7 | al0 << 25);
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                // Maj
                h = ah0 & ah1 ^ ah0 & ah2 ^ ah1 & ah2;
                l = al0 & al1 ^ al0 & al2 ^ al1 & al2;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh7 = c & 0xffff | d << 16;
                bl7 = a & 0xffff | b << 16;
                // add
                h = bh3;
                l = bl3;
                a = l & 0xffff;
                b = l >>> 16;
                c = h & 0xffff;
                d = h >>> 16;
                h = th;
                l = tl;
                a += l & 0xffff;
                b += l >>> 16;
                c += h & 0xffff;
                d += h >>> 16;
                b += a >>> 16;
                c += b >>> 16;
                d += c >>> 16;
                bh3 = c & 0xffff | d << 16;
                bl3 = a & 0xffff | b << 16;
                ah1 = bh0;
                ah2 = bh1;
                ah3 = bh2;
                ah4 = bh3;
                ah5 = bh4;
                ah6 = bh5;
                ah7 = bh6;
                ah0 = bh7;
                al1 = bl0;
                al2 = bl1;
                al3 = bl2;
                al4 = bl3;
                al5 = bl4;
                al6 = bl5;
                al7 = bl6;
                al0 = bl7;
                if (i % 16 === 15) for(j = 0; j < 16; j++){
                    // add
                    h = wh[j];
                    l = wl[j];
                    a = l & 0xffff;
                    b = l >>> 16;
                    c = h & 0xffff;
                    d = h >>> 16;
                    h = wh[(j + 9) % 16];
                    l = wl[(j + 9) % 16];
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma0
                    th = wh[(j + 1) % 16];
                    tl = wl[(j + 1) % 16];
                    h = (th >>> 1 | tl << 31) ^ (th >>> 8 | tl << 24) ^ th >>> 7;
                    l = (tl >>> 1 | th << 31) ^ (tl >>> 8 | th << 24) ^ (tl >>> 7 | th << 25);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    // sigma1
                    th = wh[(j + 14) % 16];
                    tl = wl[(j + 14) % 16];
                    h = (th >>> 19 | tl << 13) ^ (tl >>> 29 | th << 3) ^ th >>> 6;
                    l = (tl >>> 19 | th << 13) ^ (th >>> 29 | tl << 3) ^ (tl >>> 6 | th << 26);
                    a += l & 0xffff;
                    b += l >>> 16;
                    c += h & 0xffff;
                    d += h >>> 16;
                    b += a >>> 16;
                    c += b >>> 16;
                    d += c >>> 16;
                    wh[j] = c & 0xffff | d << 16;
                    wl[j] = a & 0xffff | b << 16;
                }
            }
            // add
            h = ah0;
            l = al0;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[0];
            l = hl[0];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[0] = ah0 = c & 0xffff | d << 16;
            hl[0] = al0 = a & 0xffff | b << 16;
            h = ah1;
            l = al1;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[1];
            l = hl[1];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[1] = ah1 = c & 0xffff | d << 16;
            hl[1] = al1 = a & 0xffff | b << 16;
            h = ah2;
            l = al2;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[2];
            l = hl[2];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[2] = ah2 = c & 0xffff | d << 16;
            hl[2] = al2 = a & 0xffff | b << 16;
            h = ah3;
            l = al3;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[3];
            l = hl[3];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[3] = ah3 = c & 0xffff | d << 16;
            hl[3] = al3 = a & 0xffff | b << 16;
            h = ah4;
            l = al4;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[4];
            l = hl[4];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[4] = ah4 = c & 0xffff | d << 16;
            hl[4] = al4 = a & 0xffff | b << 16;
            h = ah5;
            l = al5;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[5];
            l = hl[5];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[5] = ah5 = c & 0xffff | d << 16;
            hl[5] = al5 = a & 0xffff | b << 16;
            h = ah6;
            l = al6;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[6];
            l = hl[6];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[6] = ah6 = c & 0xffff | d << 16;
            hl[6] = al6 = a & 0xffff | b << 16;
            h = ah7;
            l = al7;
            a = l & 0xffff;
            b = l >>> 16;
            c = h & 0xffff;
            d = h >>> 16;
            h = hh[7];
            l = hl[7];
            a += l & 0xffff;
            b += l >>> 16;
            c += h & 0xffff;
            d += h >>> 16;
            b += a >>> 16;
            c += b >>> 16;
            d += c >>> 16;
            hh[7] = ah7 = c & 0xffff | d << 16;
            hl[7] = al7 = a & 0xffff | b << 16;
            pos += 128;
            n -= 128;
        }
        return n;
    }
    function crypto_hash(out, m, n) {
        var hh = new Int32Array(8), hl = new Int32Array(8), x = new Uint8Array(256), i, b = n;
        hh[0] = 0x6a09e667;
        hh[1] = 0xbb67ae85;
        hh[2] = 0x3c6ef372;
        hh[3] = 0xa54ff53a;
        hh[4] = 0x510e527f;
        hh[5] = 0x9b05688c;
        hh[6] = 0x1f83d9ab;
        hh[7] = 0x5be0cd19;
        hl[0] = 0xf3bcc908;
        hl[1] = 0x84caa73b;
        hl[2] = 0xfe94f82b;
        hl[3] = 0x5f1d36f1;
        hl[4] = 0xade682d1;
        hl[5] = 0x2b3e6c1f;
        hl[6] = 0xfb41bd6b;
        hl[7] = 0x137e2179;
        crypto_hashblocks_hl(hh, hl, m, n);
        n %= 128;
        for(i = 0; i < n; i++)x[i] = m[b - n + i];
        x[n] = 128;
        n = 256 - 128 * (n < 112 ? 1 : 0);
        x[n - 9] = 0;
        ts64(x, n - 8, b / 0x20000000 | 0, b << 3);
        crypto_hashblocks_hl(hh, hl, x, n);
        for(i = 0; i < 8; i++)ts64(out, 8 * i, hh[i], hl[i]);
        return 0;
    }
    function add(p, q) {
        var a = gf(), b = gf(), c = gf(), d = gf(), e = gf(), f = gf(), g = gf(), h = gf(), t = gf();
        Z(a, p[1], p[0]);
        Z(t, q[1], q[0]);
        M(a, a, t);
        A(b, p[0], p[1]);
        A(t, q[0], q[1]);
        M(b, b, t);
        M(c, p[3], q[3]);
        M(c, c, D2);
        M(d, p[2], q[2]);
        A(d, d, d);
        Z(e, b, a);
        Z(f, d, c);
        A(g, d, c);
        A(h, b, a);
        M(p[0], e, f);
        M(p[1], h, g);
        M(p[2], g, f);
        M(p[3], e, h);
    }
    function cswap(p, q, b) {
        var i;
        for(i = 0; i < 4; i++)sel25519(p[i], q[i], b);
    }
    function pack(r, p) {
        var tx = gf(), ty = gf(), zi = gf();
        inv25519(zi, p[2]);
        M(tx, p[0], zi);
        M(ty, p[1], zi);
        pack25519(r, ty);
        r[31] ^= par25519(tx) << 7;
    }
    function scalarmult(p, q, s) {
        var b, i;
        set25519(p[0], gf0);
        set25519(p[1], gf1);
        set25519(p[2], gf1);
        set25519(p[3], gf0);
        for(i = 255; i >= 0; --i){
            b = s[i / 8 | 0] >> (i & 7) & 1;
            cswap(p, q, b);
            add(q, p);
            add(p, p);
            cswap(p, q, b);
        }
    }
    function scalarbase(p, s) {
        var q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        set25519(q[0], X);
        set25519(q[1], Y);
        set25519(q[2], gf1);
        M(q[3], X, Y);
        scalarmult(p, q, s);
    }
    function crypto_sign_keypair(pk, sk, seeded) {
        var d = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        var i;
        if (!seeded) randombytes(sk, 32);
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        scalarbase(p, d);
        pack(pk, p);
        for(i = 0; i < 32; i++)sk[i + 32] = pk[i];
        return 0;
    }
    var L = new Float64Array([
        0xed,
        0xd3,
        0xf5,
        0x5c,
        0x1a,
        0x63,
        0x12,
        0x58,
        0xd6,
        0x9c,
        0xf7,
        0xa2,
        0xde,
        0xf9,
        0xde,
        0x14,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0x10
    ]);
    function modL(r, x) {
        var carry, i, j, k;
        for(i = 63; i >= 32; --i){
            carry = 0;
            for(j = i - 32, k = i - 12; j < k; ++j){
                x[j] += carry - 16 * x[i] * L[j - (i - 32)];
                carry = Math.floor((x[j] + 128) / 256);
                x[j] -= carry * 256;
            }
            x[j] += carry;
            x[i] = 0;
        }
        carry = 0;
        for(j = 0; j < 32; j++){
            x[j] += carry - (x[31] >> 4) * L[j];
            carry = x[j] >> 8;
            x[j] &= 255;
        }
        for(j = 0; j < 32; j++)x[j] -= carry * L[j];
        for(i = 0; i < 32; i++){
            x[i + 1] += x[i] >> 8;
            r[i] = x[i] & 255;
        }
    }
    function reduce(r) {
        var x = new Float64Array(64), i;
        for(i = 0; i < 64; i++)x[i] = r[i];
        for(i = 0; i < 64; i++)r[i] = 0;
        modL(r, x);
    }
    // Note: difference from C - smlen returned, not passed as argument.
    function crypto_sign(sm, m, n, sk) {
        var d = new Uint8Array(64), h = new Uint8Array(64), r = new Uint8Array(64);
        var i, j, x = new Float64Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        crypto_hash(d, sk, 32);
        d[0] &= 248;
        d[31] &= 127;
        d[31] |= 64;
        var smlen = n + 64;
        for(i = 0; i < n; i++)sm[64 + i] = m[i];
        for(i = 0; i < 32; i++)sm[32 + i] = d[32 + i];
        crypto_hash(r, sm.subarray(32), n + 32);
        reduce(r);
        scalarbase(p, r);
        pack(sm, p);
        for(i = 32; i < 64; i++)sm[i] = sk[i];
        crypto_hash(h, sm, n + 64);
        reduce(h);
        for(i = 0; i < 64; i++)x[i] = 0;
        for(i = 0; i < 32; i++)x[i] = r[i];
        for(i = 0; i < 32; i++)for(j = 0; j < 32; j++)x[i + j] += h[i] * d[j];
        modL(sm.subarray(32), x);
        return smlen;
    }
    function unpackneg(r, p) {
        var t = gf(), chk = gf(), num = gf(), den = gf(), den2 = gf(), den4 = gf(), den6 = gf();
        set25519(r[2], gf1);
        unpack25519(r[1], p);
        S(num, r[1]);
        M(den, num, D);
        Z(num, num, r[2]);
        A(den, r[2], den);
        S(den2, den);
        S(den4, den2);
        M(den6, den4, den2);
        M(t, den6, num);
        M(t, t, den);
        pow2523(t, t);
        M(t, t, num);
        M(t, t, den);
        M(t, t, den);
        M(r[0], t, den);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) M(r[0], r[0], I);
        S(chk, r[0]);
        M(chk, chk, den);
        if (neq25519(chk, num)) return -1;
        if (par25519(r[0]) === p[31] >> 7) Z(r[0], gf0, r[0]);
        M(r[3], r[0], r[1]);
        return 0;
    }
    function crypto_sign_open(m, sm, n, pk) {
        var i;
        var t = new Uint8Array(32), h = new Uint8Array(64);
        var p = [
            gf(),
            gf(),
            gf(),
            gf()
        ], q = [
            gf(),
            gf(),
            gf(),
            gf()
        ];
        if (n < 64) return -1;
        if (unpackneg(q, pk)) return -1;
        for(i = 0; i < n; i++)m[i] = sm[i];
        for(i = 0; i < 32; i++)m[i + 32] = pk[i];
        crypto_hash(h, m, n);
        reduce(h);
        scalarmult(p, q, h);
        scalarbase(q, sm.subarray(32));
        add(p, q);
        pack(t, p);
        n -= 64;
        if (crypto_verify_32(sm, 0, t, 0)) {
            for(i = 0; i < n; i++)m[i] = 0;
            return -1;
        }
        for(i = 0; i < n; i++)m[i] = sm[i + 64];
        return n;
    }
    var crypto_secretbox_KEYBYTES = 32, crypto_secretbox_NONCEBYTES = 24, crypto_secretbox_ZEROBYTES = 32, crypto_secretbox_BOXZEROBYTES = 16, crypto_scalarmult_BYTES = 32, crypto_scalarmult_SCALARBYTES = 32, crypto_box_PUBLICKEYBYTES = 32, crypto_box_SECRETKEYBYTES = 32, crypto_box_BEFORENMBYTES = 32, crypto_box_NONCEBYTES = crypto_secretbox_NONCEBYTES, crypto_box_ZEROBYTES = crypto_secretbox_ZEROBYTES, crypto_box_BOXZEROBYTES = crypto_secretbox_BOXZEROBYTES, crypto_sign_BYTES = 64, crypto_sign_PUBLICKEYBYTES = 32, crypto_sign_SECRETKEYBYTES = 64, crypto_sign_SEEDBYTES = 32, crypto_hash_BYTES = 64;
    nacl.lowlevel = {
        crypto_core_hsalsa20: crypto_core_hsalsa20,
        crypto_stream_xor: crypto_stream_xor,
        crypto_stream: crypto_stream,
        crypto_stream_salsa20_xor: crypto_stream_salsa20_xor,
        crypto_stream_salsa20: crypto_stream_salsa20,
        crypto_onetimeauth: crypto_onetimeauth,
        crypto_onetimeauth_verify: crypto_onetimeauth_verify,
        crypto_verify_16: crypto_verify_16,
        crypto_verify_32: crypto_verify_32,
        crypto_secretbox: crypto_secretbox,
        crypto_secretbox_open: crypto_secretbox_open,
        crypto_scalarmult: crypto_scalarmult,
        crypto_scalarmult_base: crypto_scalarmult_base,
        crypto_box_beforenm: crypto_box_beforenm,
        crypto_box_afternm: crypto_box_afternm,
        crypto_box: crypto_box,
        crypto_box_open: crypto_box_open,
        crypto_box_keypair: crypto_box_keypair,
        crypto_hash: crypto_hash,
        crypto_sign: crypto_sign,
        crypto_sign_keypair: crypto_sign_keypair,
        crypto_sign_open: crypto_sign_open,
        crypto_secretbox_KEYBYTES: crypto_secretbox_KEYBYTES,
        crypto_secretbox_NONCEBYTES: crypto_secretbox_NONCEBYTES,
        crypto_secretbox_ZEROBYTES: crypto_secretbox_ZEROBYTES,
        crypto_secretbox_BOXZEROBYTES: crypto_secretbox_BOXZEROBYTES,
        crypto_scalarmult_BYTES: crypto_scalarmult_BYTES,
        crypto_scalarmult_SCALARBYTES: crypto_scalarmult_SCALARBYTES,
        crypto_box_PUBLICKEYBYTES: crypto_box_PUBLICKEYBYTES,
        crypto_box_SECRETKEYBYTES: crypto_box_SECRETKEYBYTES,
        crypto_box_BEFORENMBYTES: crypto_box_BEFORENMBYTES,
        crypto_box_NONCEBYTES: crypto_box_NONCEBYTES,
        crypto_box_ZEROBYTES: crypto_box_ZEROBYTES,
        crypto_box_BOXZEROBYTES: crypto_box_BOXZEROBYTES,
        crypto_sign_BYTES: crypto_sign_BYTES,
        crypto_sign_PUBLICKEYBYTES: crypto_sign_PUBLICKEYBYTES,
        crypto_sign_SECRETKEYBYTES: crypto_sign_SECRETKEYBYTES,
        crypto_sign_SEEDBYTES: crypto_sign_SEEDBYTES,
        crypto_hash_BYTES: crypto_hash_BYTES,
        gf: gf,
        D: D,
        L: L,
        pack25519: pack25519,
        unpack25519: unpack25519,
        M: M,
        A: A,
        S: S,
        Z: Z,
        pow2523: pow2523,
        add: add,
        set25519: set25519,
        modL: modL,
        scalarmult: scalarmult,
        scalarbase: scalarbase
    };
    /* High-level API */ function checkLengths(k, n) {
        if (k.length !== crypto_secretbox_KEYBYTES) throw new Error("bad key size");
        if (n.length !== crypto_secretbox_NONCEBYTES) throw new Error("bad nonce size");
    }
    function checkBoxLengths(pk, sk) {
        if (pk.length !== crypto_box_PUBLICKEYBYTES) throw new Error("bad public key size");
        if (sk.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
    }
    function checkArrayTypes() {
        for(var i = 0; i < arguments.length; i++){
            if (!(arguments[i] instanceof Uint8Array)) throw new TypeError("unexpected type, use Uint8Array");
        }
    }
    function cleanup(arr) {
        for(var i = 0; i < arr.length; i++)arr[i] = 0;
    }
    nacl.randomBytes = function(n) {
        var b = new Uint8Array(n);
        randombytes(b, n);
        return b;
    };
    nacl.secretbox = function(msg, nonce, key) {
        checkArrayTypes(msg, nonce, key);
        checkLengths(key, nonce);
        var m = new Uint8Array(crypto_secretbox_ZEROBYTES + msg.length);
        var c = new Uint8Array(m.length);
        for(var i = 0; i < msg.length; i++)m[i + crypto_secretbox_ZEROBYTES] = msg[i];
        crypto_secretbox(c, m, m.length, nonce, key);
        return c.subarray(crypto_secretbox_BOXZEROBYTES);
    };
    nacl.secretbox.open = function(box, nonce, key) {
        checkArrayTypes(box, nonce, key);
        checkLengths(key, nonce);
        var c = new Uint8Array(crypto_secretbox_BOXZEROBYTES + box.length);
        var m = new Uint8Array(c.length);
        for(var i = 0; i < box.length; i++)c[i + crypto_secretbox_BOXZEROBYTES] = box[i];
        if (c.length < 32) return null;
        if (crypto_secretbox_open(m, c, c.length, nonce, key) !== 0) return null;
        return m.subarray(crypto_secretbox_ZEROBYTES);
    };
    nacl.secretbox.keyLength = crypto_secretbox_KEYBYTES;
    nacl.secretbox.nonceLength = crypto_secretbox_NONCEBYTES;
    nacl.secretbox.overheadLength = crypto_secretbox_BOXZEROBYTES;
    nacl.scalarMult = function(n, p) {
        checkArrayTypes(n, p);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        if (p.length !== crypto_scalarmult_BYTES) throw new Error("bad p size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult(q, n, p);
        return q;
    };
    nacl.scalarMult.base = function(n) {
        checkArrayTypes(n);
        if (n.length !== crypto_scalarmult_SCALARBYTES) throw new Error("bad n size");
        var q = new Uint8Array(crypto_scalarmult_BYTES);
        crypto_scalarmult_base(q, n);
        return q;
    };
    nacl.scalarMult.scalarLength = crypto_scalarmult_SCALARBYTES;
    nacl.scalarMult.groupElementLength = crypto_scalarmult_BYTES;
    nacl.box = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox(msg, nonce, k);
    };
    nacl.box.before = function(publicKey, secretKey) {
        checkArrayTypes(publicKey, secretKey);
        checkBoxLengths(publicKey, secretKey);
        var k = new Uint8Array(crypto_box_BEFORENMBYTES);
        crypto_box_beforenm(k, publicKey, secretKey);
        return k;
    };
    nacl.box.after = nacl.secretbox;
    nacl.box.open = function(msg, nonce, publicKey, secretKey) {
        var k = nacl.box.before(publicKey, secretKey);
        return nacl.secretbox.open(msg, nonce, k);
    };
    nacl.box.open.after = nacl.secretbox.open;
    nacl.box.keyPair = function() {
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_box_SECRETKEYBYTES);
        crypto_box_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.box.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_box_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_box_PUBLICKEYBYTES);
        crypto_scalarmult_base(pk, secretKey);
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.box.publicKeyLength = crypto_box_PUBLICKEYBYTES;
    nacl.box.secretKeyLength = crypto_box_SECRETKEYBYTES;
    nacl.box.sharedKeyLength = crypto_box_BEFORENMBYTES;
    nacl.box.nonceLength = crypto_box_NONCEBYTES;
    nacl.box.overheadLength = nacl.secretbox.overheadLength;
    nacl.sign = function(msg, secretKey) {
        checkArrayTypes(msg, secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var signedMsg = new Uint8Array(crypto_sign_BYTES + msg.length);
        crypto_sign(signedMsg, msg, msg.length, secretKey);
        return signedMsg;
    };
    nacl.sign.open = function(signedMsg, publicKey) {
        checkArrayTypes(signedMsg, publicKey);
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var tmp = new Uint8Array(signedMsg.length);
        var mlen = crypto_sign_open(tmp, signedMsg, signedMsg.length, publicKey);
        if (mlen < 0) return null;
        var m = new Uint8Array(mlen);
        for(var i = 0; i < m.length; i++)m[i] = tmp[i];
        return m;
    };
    nacl.sign.detached = function(msg, secretKey) {
        var signedMsg = nacl.sign(msg, secretKey);
        var sig = new Uint8Array(crypto_sign_BYTES);
        for(var i = 0; i < sig.length; i++)sig[i] = signedMsg[i];
        return sig;
    };
    nacl.sign.detached.verify = function(msg, sig, publicKey) {
        checkArrayTypes(msg, sig, publicKey);
        if (sig.length !== crypto_sign_BYTES) throw new Error("bad signature size");
        if (publicKey.length !== crypto_sign_PUBLICKEYBYTES) throw new Error("bad public key size");
        var sm = new Uint8Array(crypto_sign_BYTES + msg.length);
        var m = new Uint8Array(crypto_sign_BYTES + msg.length);
        var i;
        for(i = 0; i < crypto_sign_BYTES; i++)sm[i] = sig[i];
        for(i = 0; i < msg.length; i++)sm[i + crypto_sign_BYTES] = msg[i];
        return crypto_sign_open(m, sm, sm.length, publicKey) >= 0;
    };
    nacl.sign.keyPair = function() {
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        crypto_sign_keypair(pk, sk);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.keyPair.fromSecretKey = function(secretKey) {
        checkArrayTypes(secretKey);
        if (secretKey.length !== crypto_sign_SECRETKEYBYTES) throw new Error("bad secret key size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        for(var i = 0; i < pk.length; i++)pk[i] = secretKey[32 + i];
        return {
            publicKey: pk,
            secretKey: new Uint8Array(secretKey)
        };
    };
    nacl.sign.keyPair.fromSeed = function(seed) {
        checkArrayTypes(seed);
        if (seed.length !== crypto_sign_SEEDBYTES) throw new Error("bad seed size");
        var pk = new Uint8Array(crypto_sign_PUBLICKEYBYTES);
        var sk = new Uint8Array(crypto_sign_SECRETKEYBYTES);
        for(var i = 0; i < 32; i++)sk[i] = seed[i];
        crypto_sign_keypair(pk, sk, true);
        return {
            publicKey: pk,
            secretKey: sk
        };
    };
    nacl.sign.publicKeyLength = crypto_sign_PUBLICKEYBYTES;
    nacl.sign.secretKeyLength = crypto_sign_SECRETKEYBYTES;
    nacl.sign.seedLength = crypto_sign_SEEDBYTES;
    nacl.sign.signatureLength = crypto_sign_BYTES;
    nacl.hash = function(msg) {
        checkArrayTypes(msg);
        var h = new Uint8Array(crypto_hash_BYTES);
        crypto_hash(h, msg, msg.length);
        return h;
    };
    nacl.hash.hashLength = crypto_hash_BYTES;
    nacl.verify = function(x, y) {
        checkArrayTypes(x, y);
        // Zero length arguments are considered not equal.
        if (x.length === 0 || y.length === 0) return false;
        if (x.length !== y.length) return false;
        return vn(x, 0, y, 0, x.length) === 0 ? true : false;
    };
    nacl.setPRNG = function(fn) {
        randombytes = fn;
    };
    (function() {
        // Initialize PRNG if environment provides CSPRNG.
        // If not, methods calling randombytes will throw.
        var crypto = typeof self !== "undefined" ? self.crypto || self.msCrypto : null;
        if (crypto && crypto.getRandomValues) {
            // Browsers.
            var QUOTA = 65536;
            nacl.setPRNG(function(x, n) {
                var i, v = new Uint8Array(n);
                for(i = 0; i < n; i += QUOTA)crypto.getRandomValues(v.subarray(i, i + Math.min(n - i, QUOTA)));
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        } else {
            // Node.js.
            crypto = (parcelRequire("5Io6y"));
            if (crypto && crypto.randomBytes) nacl.setPRNG(function(x, n) {
                var i, v = crypto.randomBytes(n);
                for(i = 0; i < n; i++)x[i] = v[i];
                cleanup(v);
            });
        }
    })();
})((0, module.exports) ? module.exports : self.nacl = self.nacl || {});

});

parcelRegister("aGiAx", function(module, exports) {

var $5Io6y = parcelRequire("5Io6y");
var $7c6c3eddb202abe2$require$Buffer = $5Io6y.Buffer;
// Written in 2014-2016 by Dmitry Chestnykh and Devi Mandiri.
// Public domain.
(function(root, f) {
    "use strict";
    if (0, module.exports) module.exports = f();
    else if (root.nacl) root.nacl.util = f();
    else {
        root.nacl = {};
        root.nacl.util = f();
    }
})(module.exports, function() {
    "use strict";
    var util = {};
    function validateBase64(s) {
        if (!/^(?:[A-Za-z0-9+\/]{2}[A-Za-z0-9+\/]{2})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/.test(s)) throw new TypeError("invalid encoding");
    }
    util.decodeUTF8 = function(s) {
        if (typeof s !== "string") throw new TypeError("expected string");
        var i, d = unescape(encodeURIComponent(s)), b = new Uint8Array(d.length);
        for(i = 0; i < d.length; i++)b[i] = d.charCodeAt(i);
        return b;
    };
    util.encodeUTF8 = function(arr) {
        var i, s = [];
        for(i = 0; i < arr.length; i++)s.push(String.fromCharCode(arr[i]));
        return decodeURIComponent(escape(s.join("")));
    };
    if (typeof atob === "undefined") {
        // Node.js
        if (typeof $7c6c3eddb202abe2$require$Buffer.from !== "undefined") {
            // Node v6 and later
            util.encodeBase64 = function(arr) {
                return $7c6c3eddb202abe2$require$Buffer.from(arr).toString("base64");
            };
            util.decodeBase64 = function(s) {
                validateBase64(s);
                return new Uint8Array(Array.prototype.slice.call($7c6c3eddb202abe2$require$Buffer.from(s, "base64"), 0));
            };
        } else {
            // Node earlier than v6
            util.encodeBase64 = function(arr) {
                return new $7c6c3eddb202abe2$require$Buffer(arr).toString("base64");
            };
            util.decodeBase64 = function(s) {
                validateBase64(s);
                return new Uint8Array(Array.prototype.slice.call(new $7c6c3eddb202abe2$require$Buffer(s, "base64"), 0));
            };
        }
    } else {
        // Browsers
        util.encodeBase64 = function(arr) {
            var i, s = [], len = arr.length;
            for(i = 0; i < len; i++)s.push(String.fromCharCode(arr[i]));
            return btoa(s.join(""));
        };
        util.decodeBase64 = function(s) {
            validateBase64(s);
            var i, d = atob(s), b = new Uint8Array(d.length);
            for(i = 0; i < d.length; i++)b[i] = d.charCodeAt(i);
            return b;
        };
    }
    return util;
});

});


parcelRegister("dlCNI", function(module, exports) {
"use strict";

var $5J9vK = parcelRequire("5J9vK");

var $iLz6M = parcelRequire("iLz6M");
module.exports = function(KeccakState) {
    var Keccak = $5J9vK(KeccakState);
    var Shake = $iLz6M(KeccakState);
    return function(algorithm, options) {
        var hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
        switch(hash){
            case "keccak224":
                return new Keccak(1152, 448, null, 224, options);
            case "keccak256":
                return new Keccak(1088, 512, null, 256, options);
            case "keccak384":
                return new Keccak(832, 768, null, 384, options);
            case "keccak512":
                return new Keccak(576, 1024, null, 512, options);
            case "sha3-224":
                return new Keccak(1152, 448, 0x06, 224, options);
            case "sha3-256":
                return new Keccak(1088, 512, 0x06, 256, options);
            case "sha3-384":
                return new Keccak(832, 768, 0x06, 384, options);
            case "sha3-512":
                return new Keccak(576, 1024, 0x06, 512, options);
            case "shake128":
                return new Shake(1344, 256, 0x1f, options);
            case "shake256":
                return new Shake(1088, 512, 0x1f, options);
            default:
                throw new Error("Invald algorithm: " + algorithm);
        }
    };
};

});
parcelRegister("5J9vK", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $42b88864f71cd7f7$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $42b88864f71cd7f7$require$Transform = $bks2w.Transform;

var $eSHUL = parcelRequire("eSHUL");
module.exports = function(KeccakState) {
    function Keccak(rate, capacity, delimitedSuffix, hashBitLength, options) {
        $42b88864f71cd7f7$require$Transform.call(this, options);
        this._rate = rate;
        this._capacity = capacity;
        this._delimitedSuffix = delimitedSuffix;
        this._hashBitLength = hashBitLength;
        this._options = options;
        this._state = new KeccakState();
        this._state.initialize(rate, capacity);
        this._finalized = false;
    }
    $eSHUL(Keccak, $42b88864f71cd7f7$require$Transform);
    Keccak.prototype._transform = function(chunk, encoding, callback) {
        var error = null;
        try {
            this.update(chunk, encoding);
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    Keccak.prototype._flush = function(callback) {
        var error = null;
        try {
            this.push(this.digest());
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    Keccak.prototype.update = function(data, encoding) {
        if (!$42b88864f71cd7f7$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Digest already called");
        if (!$42b88864f71cd7f7$require$Buffer.isBuffer(data)) data = $42b88864f71cd7f7$require$Buffer.from(data, encoding);
        this._state.absorb(data);
        return this;
    };
    Keccak.prototype.digest = function(encoding) {
        if (this._finalized) throw new Error("Digest already called");
        this._finalized = true;
        if (this._delimitedSuffix) this._state.absorbLastFewBits(this._delimitedSuffix);
        var digest = this._state.squeeze(this._hashBitLength / 8);
        if (encoding !== undefined) digest = digest.toString(encoding);
        this._resetState();
        return digest;
    };
    // remove result from memory
    Keccak.prototype._resetState = function() {
        this._state.initialize(this._rate, this._capacity);
        return this;
    };
    // because sometimes we need hash right now and little later
    Keccak.prototype._clone = function() {
        var clone = new Keccak(this._rate, this._capacity, this._delimitedSuffix, this._hashBitLength, this._options);
        this._state.copy(clone._state);
        clone._finalized = this._finalized;
        return clone;
    };
    return Keccak;
};

});

parcelRegister("iLz6M", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $da97d98bf1b29a49$require$Buffer = $6U9mG.Buffer;

var $bks2w = parcelRequire("bks2w");
var $da97d98bf1b29a49$require$Transform = $bks2w.Transform;

var $eSHUL = parcelRequire("eSHUL");
module.exports = function(KeccakState) {
    function Shake(rate, capacity, delimitedSuffix, options) {
        $da97d98bf1b29a49$require$Transform.call(this, options);
        this._rate = rate;
        this._capacity = capacity;
        this._delimitedSuffix = delimitedSuffix;
        this._options = options;
        this._state = new KeccakState();
        this._state.initialize(rate, capacity);
        this._finalized = false;
    }
    $eSHUL(Shake, $da97d98bf1b29a49$require$Transform);
    Shake.prototype._transform = function(chunk, encoding, callback) {
        var error = null;
        try {
            this.update(chunk, encoding);
        } catch (err) {
            error = err;
        }
        callback(error);
    };
    Shake.prototype._flush = function() {};
    Shake.prototype._read = function(size) {
        this.push(this.squeeze(size));
    };
    Shake.prototype.update = function(data, encoding) {
        if (!$da97d98bf1b29a49$require$Buffer.isBuffer(data) && typeof data !== "string") throw new TypeError("Data must be a string or a buffer");
        if (this._finalized) throw new Error("Squeeze already called");
        if (!$da97d98bf1b29a49$require$Buffer.isBuffer(data)) data = $da97d98bf1b29a49$require$Buffer.from(data, encoding);
        this._state.absorb(data);
        return this;
    };
    Shake.prototype.squeeze = function(dataByteLength, encoding) {
        if (!this._finalized) {
            this._finalized = true;
            this._state.absorbLastFewBits(this._delimitedSuffix);
        }
        var data = this._state.squeeze(dataByteLength);
        if (encoding !== undefined) data = data.toString(encoding);
        return data;
    };
    Shake.prototype._resetState = function() {
        this._state.initialize(this._rate, this._capacity);
        return this;
    };
    Shake.prototype._clone = function() {
        var clone = new Shake(this._rate, this._capacity, this._delimitedSuffix, this._options);
        this._state.copy(clone._state);
        clone._finalized = this._finalized;
        return clone;
    };
    return Shake;
};

});


parcelRegister("7XtP2", function(module, exports) {
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $017ecb0d0bdf79bf$require$Buffer = $6U9mG.Buffer;

var $gNS6C = parcelRequire("gNS6C");
function $017ecb0d0bdf79bf$var$Keccak() {
    // much faster than `new Array(50)`
    this.state = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    this.blockSize = null;
    this.count = 0;
    this.squeezing = false;
}
$017ecb0d0bdf79bf$var$Keccak.prototype.initialize = function(rate, capacity) {
    for(var i = 0; i < 50; ++i)this.state[i] = 0;
    this.blockSize = rate / 8;
    this.count = 0;
    this.squeezing = false;
};
$017ecb0d0bdf79bf$var$Keccak.prototype.absorb = function(data) {
    for(var i = 0; i < data.length; ++i){
        this.state[~~(this.count / 4)] ^= data[i] << 8 * (this.count % 4);
        this.count += 1;
        if (this.count === this.blockSize) {
            $gNS6C.p1600(this.state);
            this.count = 0;
        }
    }
};
$017ecb0d0bdf79bf$var$Keccak.prototype.absorbLastFewBits = function(bits) {
    this.state[~~(this.count / 4)] ^= bits << 8 * (this.count % 4);
    if ((bits & 0x80) !== 0 && this.count === this.blockSize - 1) $gNS6C.p1600(this.state);
    this.state[~~((this.blockSize - 1) / 4)] ^= 0x80 << 8 * ((this.blockSize - 1) % 4);
    $gNS6C.p1600(this.state);
    this.count = 0;
    this.squeezing = true;
};
$017ecb0d0bdf79bf$var$Keccak.prototype.squeeze = function(length) {
    if (!this.squeezing) this.absorbLastFewBits(0x01);
    var output = $017ecb0d0bdf79bf$require$Buffer.alloc(length);
    for(var i = 0; i < length; ++i){
        output[i] = this.state[~~(this.count / 4)] >>> 8 * (this.count % 4) & 0xff;
        this.count += 1;
        if (this.count === this.blockSize) {
            $gNS6C.p1600(this.state);
            this.count = 0;
        }
    }
    return output;
};
$017ecb0d0bdf79bf$var$Keccak.prototype.copy = function(dest) {
    for(var i = 0; i < 50; ++i)dest.state[i] = this.state[i];
    dest.blockSize = this.blockSize;
    dest.count = this.count;
    dest.squeezing = this.squeezing;
};
module.exports = $017ecb0d0bdf79bf$var$Keccak;

});
parcelRegister("gNS6C", function(module, exports) {

$parcel$export(module.exports, "p1600", function () { return $c3bb313264b200a4$export$471358fe9e8379c0; }, function (v) { return $c3bb313264b200a4$export$471358fe9e8379c0 = v; });
var $c3bb313264b200a4$export$471358fe9e8379c0;
"use strict";
var $c3bb313264b200a4$var$P1600_ROUND_CONSTANTS = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
$c3bb313264b200a4$export$471358fe9e8379c0 = function(s) {
    for(var round = 0; round < 24; ++round){
        // theta
        var lo0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        var hi0 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        var lo1 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        var hi1 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        var lo2 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        var hi2 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        var lo3 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        var hi3 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        var lo4 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        var hi4 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        var lo = lo4 ^ (lo1 << 1 | hi1 >>> 31);
        var hi = hi4 ^ (hi1 << 1 | lo1 >>> 31);
        var t1slo0 = s[0] ^ lo;
        var t1shi0 = s[1] ^ hi;
        var t1slo5 = s[10] ^ lo;
        var t1shi5 = s[11] ^ hi;
        var t1slo10 = s[20] ^ lo;
        var t1shi10 = s[21] ^ hi;
        var t1slo15 = s[30] ^ lo;
        var t1shi15 = s[31] ^ hi;
        var t1slo20 = s[40] ^ lo;
        var t1shi20 = s[41] ^ hi;
        lo = lo0 ^ (lo2 << 1 | hi2 >>> 31);
        hi = hi0 ^ (hi2 << 1 | lo2 >>> 31);
        var t1slo1 = s[2] ^ lo;
        var t1shi1 = s[3] ^ hi;
        var t1slo6 = s[12] ^ lo;
        var t1shi6 = s[13] ^ hi;
        var t1slo11 = s[22] ^ lo;
        var t1shi11 = s[23] ^ hi;
        var t1slo16 = s[32] ^ lo;
        var t1shi16 = s[33] ^ hi;
        var t1slo21 = s[42] ^ lo;
        var t1shi21 = s[43] ^ hi;
        lo = lo1 ^ (lo3 << 1 | hi3 >>> 31);
        hi = hi1 ^ (hi3 << 1 | lo3 >>> 31);
        var t1slo2 = s[4] ^ lo;
        var t1shi2 = s[5] ^ hi;
        var t1slo7 = s[14] ^ lo;
        var t1shi7 = s[15] ^ hi;
        var t1slo12 = s[24] ^ lo;
        var t1shi12 = s[25] ^ hi;
        var t1slo17 = s[34] ^ lo;
        var t1shi17 = s[35] ^ hi;
        var t1slo22 = s[44] ^ lo;
        var t1shi22 = s[45] ^ hi;
        lo = lo2 ^ (lo4 << 1 | hi4 >>> 31);
        hi = hi2 ^ (hi4 << 1 | lo4 >>> 31);
        var t1slo3 = s[6] ^ lo;
        var t1shi3 = s[7] ^ hi;
        var t1slo8 = s[16] ^ lo;
        var t1shi8 = s[17] ^ hi;
        var t1slo13 = s[26] ^ lo;
        var t1shi13 = s[27] ^ hi;
        var t1slo18 = s[36] ^ lo;
        var t1shi18 = s[37] ^ hi;
        var t1slo23 = s[46] ^ lo;
        var t1shi23 = s[47] ^ hi;
        lo = lo3 ^ (lo0 << 1 | hi0 >>> 31);
        hi = hi3 ^ (hi0 << 1 | lo0 >>> 31);
        var t1slo4 = s[8] ^ lo;
        var t1shi4 = s[9] ^ hi;
        var t1slo9 = s[18] ^ lo;
        var t1shi9 = s[19] ^ hi;
        var t1slo14 = s[28] ^ lo;
        var t1shi14 = s[29] ^ hi;
        var t1slo19 = s[38] ^ lo;
        var t1shi19 = s[39] ^ hi;
        var t1slo24 = s[48] ^ lo;
        var t1shi24 = s[49] ^ hi;
        // rho & pi
        var t2slo0 = t1slo0;
        var t2shi0 = t1shi0;
        var t2slo16 = t1shi5 << 4 | t1slo5 >>> 28;
        var t2shi16 = t1slo5 << 4 | t1shi5 >>> 28;
        var t2slo7 = t1slo10 << 3 | t1shi10 >>> 29;
        var t2shi7 = t1shi10 << 3 | t1slo10 >>> 29;
        var t2slo23 = t1shi15 << 9 | t1slo15 >>> 23;
        var t2shi23 = t1slo15 << 9 | t1shi15 >>> 23;
        var t2slo14 = t1slo20 << 18 | t1shi20 >>> 14;
        var t2shi14 = t1shi20 << 18 | t1slo20 >>> 14;
        var t2slo10 = t1slo1 << 1 | t1shi1 >>> 31;
        var t2shi10 = t1shi1 << 1 | t1slo1 >>> 31;
        var t2slo1 = t1shi6 << 12 | t1slo6 >>> 20;
        var t2shi1 = t1slo6 << 12 | t1shi6 >>> 20;
        var t2slo17 = t1slo11 << 10 | t1shi11 >>> 22;
        var t2shi17 = t1shi11 << 10 | t1slo11 >>> 22;
        var t2slo8 = t1shi16 << 13 | t1slo16 >>> 19;
        var t2shi8 = t1slo16 << 13 | t1shi16 >>> 19;
        var t2slo24 = t1slo21 << 2 | t1shi21 >>> 30;
        var t2shi24 = t1shi21 << 2 | t1slo21 >>> 30;
        var t2slo20 = t1shi2 << 30 | t1slo2 >>> 2;
        var t2shi20 = t1slo2 << 30 | t1shi2 >>> 2;
        var t2slo11 = t1slo7 << 6 | t1shi7 >>> 26;
        var t2shi11 = t1shi7 << 6 | t1slo7 >>> 26;
        var t2slo2 = t1shi12 << 11 | t1slo12 >>> 21;
        var t2shi2 = t1slo12 << 11 | t1shi12 >>> 21;
        var t2slo18 = t1slo17 << 15 | t1shi17 >>> 17;
        var t2shi18 = t1shi17 << 15 | t1slo17 >>> 17;
        var t2slo9 = t1shi22 << 29 | t1slo22 >>> 3;
        var t2shi9 = t1slo22 << 29 | t1shi22 >>> 3;
        var t2slo5 = t1slo3 << 28 | t1shi3 >>> 4;
        var t2shi5 = t1shi3 << 28 | t1slo3 >>> 4;
        var t2slo21 = t1shi8 << 23 | t1slo8 >>> 9;
        var t2shi21 = t1slo8 << 23 | t1shi8 >>> 9;
        var t2slo12 = t1slo13 << 25 | t1shi13 >>> 7;
        var t2shi12 = t1shi13 << 25 | t1slo13 >>> 7;
        var t2slo3 = t1slo18 << 21 | t1shi18 >>> 11;
        var t2shi3 = t1shi18 << 21 | t1slo18 >>> 11;
        var t2slo19 = t1shi23 << 24 | t1slo23 >>> 8;
        var t2shi19 = t1slo23 << 24 | t1shi23 >>> 8;
        var t2slo15 = t1slo4 << 27 | t1shi4 >>> 5;
        var t2shi15 = t1shi4 << 27 | t1slo4 >>> 5;
        var t2slo6 = t1slo9 << 20 | t1shi9 >>> 12;
        var t2shi6 = t1shi9 << 20 | t1slo9 >>> 12;
        var t2slo22 = t1shi14 << 7 | t1slo14 >>> 25;
        var t2shi22 = t1slo14 << 7 | t1shi14 >>> 25;
        var t2slo13 = t1slo19 << 8 | t1shi19 >>> 24;
        var t2shi13 = t1shi19 << 8 | t1slo19 >>> 24;
        var t2slo4 = t1slo24 << 14 | t1shi24 >>> 18;
        var t2shi4 = t1shi24 << 14 | t1slo24 >>> 18;
        // chi
        s[0] = t2slo0 ^ ~t2slo1 & t2slo2;
        s[1] = t2shi0 ^ ~t2shi1 & t2shi2;
        s[10] = t2slo5 ^ ~t2slo6 & t2slo7;
        s[11] = t2shi5 ^ ~t2shi6 & t2shi7;
        s[20] = t2slo10 ^ ~t2slo11 & t2slo12;
        s[21] = t2shi10 ^ ~t2shi11 & t2shi12;
        s[30] = t2slo15 ^ ~t2slo16 & t2slo17;
        s[31] = t2shi15 ^ ~t2shi16 & t2shi17;
        s[40] = t2slo20 ^ ~t2slo21 & t2slo22;
        s[41] = t2shi20 ^ ~t2shi21 & t2shi22;
        s[2] = t2slo1 ^ ~t2slo2 & t2slo3;
        s[3] = t2shi1 ^ ~t2shi2 & t2shi3;
        s[12] = t2slo6 ^ ~t2slo7 & t2slo8;
        s[13] = t2shi6 ^ ~t2shi7 & t2shi8;
        s[22] = t2slo11 ^ ~t2slo12 & t2slo13;
        s[23] = t2shi11 ^ ~t2shi12 & t2shi13;
        s[32] = t2slo16 ^ ~t2slo17 & t2slo18;
        s[33] = t2shi16 ^ ~t2shi17 & t2shi18;
        s[42] = t2slo21 ^ ~t2slo22 & t2slo23;
        s[43] = t2shi21 ^ ~t2shi22 & t2shi23;
        s[4] = t2slo2 ^ ~t2slo3 & t2slo4;
        s[5] = t2shi2 ^ ~t2shi3 & t2shi4;
        s[14] = t2slo7 ^ ~t2slo8 & t2slo9;
        s[15] = t2shi7 ^ ~t2shi8 & t2shi9;
        s[24] = t2slo12 ^ ~t2slo13 & t2slo14;
        s[25] = t2shi12 ^ ~t2shi13 & t2shi14;
        s[34] = t2slo17 ^ ~t2slo18 & t2slo19;
        s[35] = t2shi17 ^ ~t2shi18 & t2shi19;
        s[44] = t2slo22 ^ ~t2slo23 & t2slo24;
        s[45] = t2shi22 ^ ~t2shi23 & t2shi24;
        s[6] = t2slo3 ^ ~t2slo4 & t2slo0;
        s[7] = t2shi3 ^ ~t2shi4 & t2shi0;
        s[16] = t2slo8 ^ ~t2slo9 & t2slo5;
        s[17] = t2shi8 ^ ~t2shi9 & t2shi5;
        s[26] = t2slo13 ^ ~t2slo14 & t2slo10;
        s[27] = t2shi13 ^ ~t2shi14 & t2shi10;
        s[36] = t2slo18 ^ ~t2slo19 & t2slo15;
        s[37] = t2shi18 ^ ~t2shi19 & t2shi15;
        s[46] = t2slo23 ^ ~t2slo24 & t2slo20;
        s[47] = t2shi23 ^ ~t2shi24 & t2shi20;
        s[8] = t2slo4 ^ ~t2slo0 & t2slo1;
        s[9] = t2shi4 ^ ~t2shi0 & t2shi1;
        s[18] = t2slo9 ^ ~t2slo5 & t2slo6;
        s[19] = t2shi9 ^ ~t2shi5 & t2shi6;
        s[28] = t2slo14 ^ ~t2slo10 & t2slo11;
        s[29] = t2shi14 ^ ~t2shi10 & t2shi11;
        s[38] = t2slo19 ^ ~t2slo15 & t2slo16;
        s[39] = t2shi19 ^ ~t2shi15 & t2shi16;
        s[48] = t2slo24 ^ ~t2slo20 & t2slo21;
        s[49] = t2shi24 ^ ~t2shi20 & t2shi21;
        // iota
        s[0] ^= $c3bb313264b200a4$var$P1600_ROUND_CONSTANTS[round * 2];
        s[1] ^= $c3bb313264b200a4$var$P1600_ROUND_CONSTANTS[round * 2 + 1];
    }
};

});


parcelRegister("iA132", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("2blqG", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $196d3b44be9fdb46$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $196d3b44be9fdb46$export$2f872c0f2117be69; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $lsXhr = parcelRequire("lsXhr");
"use strict";
const $196d3b44be9fdb46$var$logger = new (0, $8bxC3.Logger)((0, $lsXhr.version));
function $196d3b44be9fdb46$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $196d3b44be9fdb46$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $196d3b44be9fdb46$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($196d3b44be9fdb46$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $196d3b44be9fdb46$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $ApLZa.isBytesLike)(object)) $196d3b44be9fdb46$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $ApLZa.arrayify)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $196d3b44be9fdb46$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $196d3b44be9fdb46$export$c564cdbbe6da493(object) {
    return (0, $ApLZa.hexlify)($196d3b44be9fdb46$var$_encode(object));
}
function $196d3b44be9fdb46$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $196d3b44be9fdb46$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $196d3b44be9fdb46$var$logger.throwError("child data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $196d3b44be9fdb46$var$_decode(data, offset) {
    if (data.length === 0) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data short segment too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data long segment too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        return $196d3b44be9fdb46$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const length = $196d3b44be9fdb46$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data array too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $ApLZa.hexlify)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $196d3b44be9fdb46$var$logger.throwError("data too short", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {});
        const result = (0, $ApLZa.hexlify)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $ApLZa.hexlify)(data[offset])
    };
}
function $196d3b44be9fdb46$export$2f872c0f2117be69(data) {
    const bytes = (0, $ApLZa.arrayify)(data);
    const decoded = $196d3b44be9fdb46$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $196d3b44be9fdb46$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}

});
parcelRegister("ApLZa", function(module, exports) {

$parcel$export(module.exports, "isBytesLike", function () { return $06d75ae17ce69367$export$9a14abb1a440cd5e; });
$parcel$export(module.exports, "isHexString", function () { return $06d75ae17ce69367$export$b02a40aff8e4ad18; });
$parcel$export(module.exports, "isBytes", function () { return $06d75ae17ce69367$export$c6fabfbfd097fc30; });
$parcel$export(module.exports, "arrayify", function () { return $06d75ae17ce69367$export$3131421a7d01b4fb; });
$parcel$export(module.exports, "concat", function () { return $06d75ae17ce69367$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "stripZeros", function () { return $06d75ae17ce69367$export$a8f4574d0e56446c; });
$parcel$export(module.exports, "zeroPad", function () { return $06d75ae17ce69367$export$3cdc770bf8b2ed3d; });
$parcel$export(module.exports, "hexlify", function () { return $06d75ae17ce69367$export$2b0d6b5fbe698c70; });
$parcel$export(module.exports, "hexDataLength", function () { return $06d75ae17ce69367$export$13882f896d3c0683; });
$parcel$export(module.exports, "hexDataSlice", function () { return $06d75ae17ce69367$export$15da666eba198c18; });
$parcel$export(module.exports, "hexConcat", function () { return $06d75ae17ce69367$export$6d4b99629b38754a; });
$parcel$export(module.exports, "hexValue", function () { return $06d75ae17ce69367$export$6916af760a341dd3; });
$parcel$export(module.exports, "hexStripZeros", function () { return $06d75ae17ce69367$export$967bc0082a978949; });
$parcel$export(module.exports, "hexZeroPad", function () { return $06d75ae17ce69367$export$e9c46a54370b47e8; });
$parcel$export(module.exports, "splitSignature", function () { return $06d75ae17ce69367$export$7fb170f1e457988f; });
$parcel$export(module.exports, "joinSignature", function () { return $06d75ae17ce69367$export$71bb9d78a59bbe25; });

var $8bxC3 = parcelRequire("8bxC3");

var $jmmlD = parcelRequire("jmmlD");
"use strict";
const $06d75ae17ce69367$var$logger = new (0, $8bxC3.Logger)((0, $jmmlD.version));
///////////////////////////////
function $06d75ae17ce69367$var$isHexable(value) {
    return !!value.toHexString;
}
function $06d75ae17ce69367$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $06d75ae17ce69367$export$9a14abb1a440cd5e(value) {
    return $06d75ae17ce69367$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $06d75ae17ce69367$export$c6fabfbfd097fc30(value);
}
function $06d75ae17ce69367$var$isInteger(value) {
    return typeof value === "number" && value == value && value % 1 === 0;
}
function $06d75ae17ce69367$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (!$06d75ae17ce69367$var$isInteger(value.length) || value.length < 0) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (!$06d75ae17ce69367$var$isInteger(v) || v < 0 || v >= 256) return false;
    }
    return true;
}
function $06d75ae17ce69367$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) value = value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0" + hex;
            else if (options.hexPad === "right") hex += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $06d75ae17ce69367$var$addSlice(new Uint8Array(result));
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) return $06d75ae17ce69367$var$addSlice(new Uint8Array(value));
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $06d75ae17ce69367$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$06d75ae17ce69367$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$a8f4574d0e56446c(value) {
    let result = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $06d75ae17ce69367$export$3cdc770bf8b2ed3d(value, length) {
    value = $06d75ae17ce69367$export$3131421a7d01b4fb(value);
    if (value.length > length) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $06d75ae17ce69367$var$addSlice(result);
}
function $06d75ae17ce69367$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $06d75ae17ce69367$var$HexCharacters = "0123456789abcdef";
function $06d75ae17ce69367$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $06d75ae17ce69367$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $06d75ae17ce69367$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($06d75ae17ce69367$var$isHexable(value)) return value.toHexString();
    if ($06d75ae17ce69367$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $06d75ae17ce69367$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($06d75ae17ce69367$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $06d75ae17ce69367$var$HexCharacters[(v & 0xf0) >> 4] + $06d75ae17ce69367$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $06d75ae17ce69367$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $06d75ae17ce69367$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $06d75ae17ce69367$export$2b0d6b5fbe698c70(data);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(data) || data.length % 2) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $06d75ae17ce69367$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $06d75ae17ce69367$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $06d75ae17ce69367$export$6916af760a341dd3(value) {
    const trimmed = $06d75ae17ce69367$export$967bc0082a978949($06d75ae17ce69367$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $06d75ae17ce69367$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $06d75ae17ce69367$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $06d75ae17ce69367$export$2b0d6b5fbe698c70(value);
    else if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(value)) $06d75ae17ce69367$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $06d75ae17ce69367$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $06d75ae17ce69367$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0,
        yParityAndS: "0x",
        compact: "0x"
    };
    if ($06d75ae17ce69367$export$9a14abb1a440cd5e(signature)) {
        let bytes = $06d75ae17ce69367$export$3131421a7d01b4fb(signature);
        // Get the r, s and v
        if (bytes.length === 64) {
            // EIP-2098; pull the v from the top bit of s and clear it
            result.v = 27 + (bytes[32] >> 7);
            bytes[32] &= 0x7f;
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        } else if (bytes.length === 65) {
            result.r = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
            result.s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
            result.v = bytes[64];
        } else $06d75ae17ce69367$var$logger.throwArgumentError("invalid signature string", "signature", signature);
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $06d75ae17ce69367$export$3cdc770bf8b2ed3d($06d75ae17ce69367$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $06d75ae17ce69367$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else if (result.v == null) result.v = 27 + result.recoveryParam;
        else {
            const recId = result.v === 0 || result.v === 1 ? result.v : 1 - result.v % 2;
            if (result.recoveryParam !== recId) $06d75ae17ce69367$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.r)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $06d75ae17ce69367$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$06d75ae17ce69367$export$b02a40aff8e4ad18(result.s)) $06d75ae17ce69367$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $06d75ae17ce69367$export$e9c46a54370b47e8(result.s, 32);
        const vs = $06d75ae17ce69367$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $06d75ae17ce69367$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $06d75ae17ce69367$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$06d75ae17ce69367$export$b02a40aff8e4ad18(result._vs)) $06d75ae17ce69367$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $06d75ae17ce69367$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $06d75ae17ce69367$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    result.yParityAndS = result._vs;
    result.compact = result.r + result.yParityAndS.substring(2);
    return result;
}
function $06d75ae17ce69367$export$71bb9d78a59bbe25(signature) {
    signature = $06d75ae17ce69367$export$7fb170f1e457988f(signature);
    return $06d75ae17ce69367$export$2b0d6b5fbe698c70($06d75ae17ce69367$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}

});
parcelRegister("8bxC3", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $5f596c9584f643ae$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "Logger", function () { return $5f596c9584f643ae$export$efa9a398d6368992; });

var $3U19O = parcelRequire("3U19O");
"use strict";
let $5f596c9584f643ae$var$_permanentCensorErrors = false;
let $5f596c9584f643ae$var$_censorErrors = false;
const $5f596c9584f643ae$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $5f596c9584f643ae$var$_logLevel = $5f596c9584f643ae$var$LogLevels["default"];
let $5f596c9584f643ae$var$_globalLogger = null;
function $5f596c9584f643ae$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $5f596c9584f643ae$var$_normalizeError = $5f596c9584f643ae$var$_checkNormalize();
var $5f596c9584f643ae$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($5f596c9584f643ae$export$243e62d78d3b544d || ($5f596c9584f643ae$export$243e62d78d3b544d = {}));
var $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficient funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
    ///////////////////
    // Interaction Errors
    // The user rejected the action, such as signing a message or sending
    // a transaction
    ErrorCode["ACTION_REJECTED"] = "ACTION_REJECTED";
})($5f596c9584f643ae$export$d4e71bc0b80dc0fb || ($5f596c9584f643ae$export$d4e71bc0b80dc0fb = {}));
const $5f596c9584f643ae$var$HEX = "0123456789abcdef";
class $5f596c9584f643ae$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($5f596c9584f643ae$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($5f596c9584f643ae$var$_logLevel > $5f596c9584f643ae$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($5f596c9584f643ae$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($5f596c9584f643ae$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $5f596c9584f643ae$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            const value = params[key];
            try {
                if (value instanceof Uint8Array) {
                    let hex = "";
                    for(let i = 0; i < value.length; i++){
                        hex += $5f596c9584f643ae$var$HEX[value[i] >> 4];
                        hex += $5f596c9584f643ae$var$HEX[value[i] & 0x0f];
                    }
                    messageDetails.push(key + "=Uint8Array(0x" + hex + ")");
                } else messageDetails.push(key + "=" + JSON.stringify(value));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        let url = "";
        switch(code){
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NUMERIC_FAULT:
                {
                    url = "NUMERIC_FAULT";
                    const fault = message;
                    switch(fault){
                        case "overflow":
                        case "underflow":
                        case "division-by-zero":
                            url += "-" + fault;
                            break;
                        case "negative-power":
                        case "negative-width":
                            url += "-unsupported";
                            break;
                        case "unbound-bitwise-result":
                            url += "-unbound-result";
                            break;
                    }
                    break;
                }
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.CALL_EXCEPTION:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.INSUFFICIENT_FUNDS:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.MISSING_NEW:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.NONCE_EXPIRED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.REPLACEMENT_UNDERPRICED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.TRANSACTION_REPLACED:
            case $5f596c9584f643ae$export$d4e71bc0b80dc0fb.UNPREDICTABLE_GAS_LIMIT:
                url = code;
                break;
        }
        if (url) message += " [ See: https://links.ethers.org/v5-errors-" + url + " ]";
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($5f596c9584f643ae$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $5f596c9584f643ae$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $5f596c9584f643ae$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $5f596c9584f643ae$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $5f596c9584f643ae$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$5f596c9584f643ae$var$_globalLogger) $5f596c9584f643ae$var$_globalLogger = new $5f596c9584f643ae$export$efa9a398d6368992((0, $3U19O.version));
        return $5f596c9584f643ae$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($5f596c9584f643ae$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $5f596c9584f643ae$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $5f596c9584f643ae$var$_censorErrors = !!censorship;
        $5f596c9584f643ae$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $5f596c9584f643ae$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $5f596c9584f643ae$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $5f596c9584f643ae$var$_logLevel = level;
    }
    static from(version) {
        return new $5f596c9584f643ae$export$efa9a398d6368992(version);
    }
}
$5f596c9584f643ae$export$efa9a398d6368992.errors = $5f596c9584f643ae$export$d4e71bc0b80dc0fb;
$5f596c9584f643ae$export$efa9a398d6368992.levels = $5f596c9584f643ae$export$243e62d78d3b544d;

});
parcelRegister("3U19O", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $2d777fddba578925$export$83d89fbfd8236492; });
const $2d777fddba578925$export$83d89fbfd8236492 = "logger/5.7.0";

});


parcelRegister("jmmlD", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e1816841dbe8857e$export$83d89fbfd8236492; });
const $e1816841dbe8857e$export$83d89fbfd8236492 = "bytes/5.7.0";

});


parcelRegister("lsXhr", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $fa0a32506f7ec4cd$export$83d89fbfd8236492; });
const $fa0a32506f7ec4cd$export$83d89fbfd8236492 = "rlp/5.7.0";

});


parcelRegister("fe8vC", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return (parcelRequire("2bJst")).decode; });
$parcel$export(module.exports, "encode", function () { return (parcelRequire("2bJst")).encode; });

var $2bJst = parcelRequire("2bJst");
"use strict";

});
parcelRegister("2bJst", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $197fdee3ede33bf0$export$2f872c0f2117be69; });
$parcel$export(module.exports, "encode", function () { return $197fdee3ede33bf0$export$c564cdbbe6da493; });

var $ApLZa = parcelRequire("ApLZa");
"use strict";
function $197fdee3ede33bf0$export$2f872c0f2117be69(textData) {
    textData = atob(textData);
    const data = [];
    for(let i = 0; i < textData.length; i++)data.push(textData.charCodeAt(i));
    return (0, $ApLZa.arrayify)(data);
}
function $197fdee3ede33bf0$export$c564cdbbe6da493(data) {
    data = (0, $ApLZa.arrayify)(data);
    let textData = "";
    for(let i = 0; i < data.length; i++)textData += String.fromCharCode(data[i]);
    return btoa(textData);
}

});


parcelRegister("9we9E", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("5Io6y")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("5W1f9", function(module, exports) {
"use strict";
(function(root) {
    const MAX_VALUE = 0x7fffffff;
    // The SHA256 and PBKDF2 implementation are from scrypt-async-js:
    // See: https://github.com/dchest/scrypt-async-js
    function SHA256(m) {
        const K = new Uint32Array([
            0x428a2f98,
            0x71374491,
            0xb5c0fbcf,
            0xe9b5dba5,
            0x3956c25b,
            0x59f111f1,
            0x923f82a4,
            0xab1c5ed5,
            0xd807aa98,
            0x12835b01,
            0x243185be,
            0x550c7dc3,
            0x72be5d74,
            0x80deb1fe,
            0x9bdc06a7,
            0xc19bf174,
            0xe49b69c1,
            0xefbe4786,
            0x0fc19dc6,
            0x240ca1cc,
            0x2de92c6f,
            0x4a7484aa,
            0x5cb0a9dc,
            0x76f988da,
            0x983e5152,
            0xa831c66d,
            0xb00327c8,
            0xbf597fc7,
            0xc6e00bf3,
            0xd5a79147,
            0x06ca6351,
            0x14292967,
            0x27b70a85,
            0x2e1b2138,
            0x4d2c6dfc,
            0x53380d13,
            0x650a7354,
            0x766a0abb,
            0x81c2c92e,
            0x92722c85,
            0xa2bfe8a1,
            0xa81a664b,
            0xc24b8b70,
            0xc76c51a3,
            0xd192e819,
            0xd6990624,
            0xf40e3585,
            0x106aa070,
            0x19a4c116,
            0x1e376c08,
            0x2748774c,
            0x34b0bcb5,
            0x391c0cb3,
            0x4ed8aa4a,
            0x5b9cca4f,
            0x682e6ff3,
            0x748f82ee,
            0x78a5636f,
            0x84c87814,
            0x8cc70208,
            0x90befffa,
            0xa4506ceb,
            0xbef9a3f7,
            0xc67178f2
        ]);
        let h0 = 0x6a09e667, h1 = 0xbb67ae85, h2 = 0x3c6ef372, h3 = 0xa54ff53a;
        let h4 = 0x510e527f, h5 = 0x9b05688c, h6 = 0x1f83d9ab, h7 = 0x5be0cd19;
        const w = new Uint32Array(64);
        function blocks(p) {
            let off = 0, len = p.length;
            while(len >= 64){
                let a = h0, b = h1, c = h2, d = h3, e = h4, f = h5, g = h6, h = h7, u, i, j, t1, t2;
                for(i = 0; i < 16; i++){
                    j = off + i * 4;
                    w[i] = (p[j] & 0xff) << 24 | (p[j + 1] & 0xff) << 16 | (p[j + 2] & 0xff) << 8 | p[j + 3] & 0xff;
                }
                for(i = 16; i < 64; i++){
                    u = w[i - 2];
                    t1 = (u >>> 17 | u << 15) ^ (u >>> 19 | u << 13) ^ u >>> 10;
                    u = w[i - 15];
                    t2 = (u >>> 7 | u << 25) ^ (u >>> 18 | u << 14) ^ u >>> 3;
                    w[i] = (t1 + w[i - 7] | 0) + (t2 + w[i - 16] | 0) | 0;
                }
                for(i = 0; i < 64; i++){
                    t1 = (((e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7)) + (e & f ^ ~e & g) | 0) + (h + (K[i] + w[i] | 0) | 0) | 0;
                    t2 = ((a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10)) + (a & b ^ a & c ^ b & c) | 0;
                    h = g;
                    g = f;
                    f = e;
                    e = d + t1 | 0;
                    d = c;
                    c = b;
                    b = a;
                    a = t1 + t2 | 0;
                }
                h0 = h0 + a | 0;
                h1 = h1 + b | 0;
                h2 = h2 + c | 0;
                h3 = h3 + d | 0;
                h4 = h4 + e | 0;
                h5 = h5 + f | 0;
                h6 = h6 + g | 0;
                h7 = h7 + h | 0;
                off += 64;
                len -= 64;
            }
        }
        blocks(m);
        let i, bytesLeft = m.length % 64, bitLenHi = m.length / 0x20000000 | 0, bitLenLo = m.length << 3, numZeros = bytesLeft < 56 ? 56 : 120, p = m.slice(m.length - bytesLeft, m.length);
        p.push(0x80);
        for(i = bytesLeft + 1; i < numZeros; i++)p.push(0);
        p.push(bitLenHi >>> 24 & 0xff);
        p.push(bitLenHi >>> 16 & 0xff);
        p.push(bitLenHi >>> 8 & 0xff);
        p.push(bitLenHi >>> 0 & 0xff);
        p.push(bitLenLo >>> 24 & 0xff);
        p.push(bitLenLo >>> 16 & 0xff);
        p.push(bitLenLo >>> 8 & 0xff);
        p.push(bitLenLo >>> 0 & 0xff);
        blocks(p);
        return [
            h0 >>> 24 & 0xff,
            h0 >>> 16 & 0xff,
            h0 >>> 8 & 0xff,
            h0 >>> 0 & 0xff,
            h1 >>> 24 & 0xff,
            h1 >>> 16 & 0xff,
            h1 >>> 8 & 0xff,
            h1 >>> 0 & 0xff,
            h2 >>> 24 & 0xff,
            h2 >>> 16 & 0xff,
            h2 >>> 8 & 0xff,
            h2 >>> 0 & 0xff,
            h3 >>> 24 & 0xff,
            h3 >>> 16 & 0xff,
            h3 >>> 8 & 0xff,
            h3 >>> 0 & 0xff,
            h4 >>> 24 & 0xff,
            h4 >>> 16 & 0xff,
            h4 >>> 8 & 0xff,
            h4 >>> 0 & 0xff,
            h5 >>> 24 & 0xff,
            h5 >>> 16 & 0xff,
            h5 >>> 8 & 0xff,
            h5 >>> 0 & 0xff,
            h6 >>> 24 & 0xff,
            h6 >>> 16 & 0xff,
            h6 >>> 8 & 0xff,
            h6 >>> 0 & 0xff,
            h7 >>> 24 & 0xff,
            h7 >>> 16 & 0xff,
            h7 >>> 8 & 0xff,
            h7 >>> 0 & 0xff
        ];
    }
    function PBKDF2_HMAC_SHA256_OneIter(password, salt, dkLen) {
        // compress password if it's longer than hash block length
        password = password.length <= 64 ? password : SHA256(password);
        const innerLen = 64 + salt.length + 4;
        const inner = new Array(innerLen);
        const outerKey = new Array(64);
        let i;
        let dk = [];
        // inner = (password ^ ipad) || salt || counter
        for(i = 0; i < 64; i++)inner[i] = 0x36;
        for(i = 0; i < password.length; i++)inner[i] ^= password[i];
        for(i = 0; i < salt.length; i++)inner[64 + i] = salt[i];
        for(i = innerLen - 4; i < innerLen; i++)inner[i] = 0;
        // outerKey = password ^ opad
        for(i = 0; i < 64; i++)outerKey[i] = 0x5c;
        for(i = 0; i < password.length; i++)outerKey[i] ^= password[i];
        // increments counter inside inner
        function incrementCounter() {
            for(let i = innerLen - 1; i >= innerLen - 4; i--){
                inner[i]++;
                if (inner[i] <= 0xff) return;
                inner[i] = 0;
            }
        }
        // output blocks = SHA256(outerKey || SHA256(inner)) ...
        while(dkLen >= 32){
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))));
            dkLen -= 32;
        }
        if (dkLen > 0) {
            incrementCounter();
            dk = dk.concat(SHA256(outerKey.concat(SHA256(inner))).slice(0, dkLen));
        }
        return dk;
    }
    // The following is an adaptation of scryptsy
    // See: https://www.npmjs.com/package/scryptsy
    function blockmix_salsa8(BY, Yi, r, x, _X) {
        let i;
        arraycopy(BY, (2 * r - 1) * 16, _X, 0, 16);
        for(i = 0; i < 2 * r; i++){
            blockxor(BY, i * 16, _X, 16);
            salsa20_8(_X, x);
            arraycopy(_X, 0, BY, Yi + i * 16, 16);
        }
        for(i = 0; i < r; i++)arraycopy(BY, Yi + i * 32, BY, i * 16, 16);
        for(i = 0; i < r; i++)arraycopy(BY, Yi + (i * 2 + 1) * 16, BY, (i + r) * 16, 16);
    }
    function R(a, b) {
        return a << b | a >>> 32 - b;
    }
    function salsa20_8(B, x) {
        arraycopy(B, 0, x, 0, 16);
        for(let i = 8; i > 0; i -= 2){
            x[4] ^= R(x[0] + x[12], 7);
            x[8] ^= R(x[4] + x[0], 9);
            x[12] ^= R(x[8] + x[4], 13);
            x[0] ^= R(x[12] + x[8], 18);
            x[9] ^= R(x[5] + x[1], 7);
            x[13] ^= R(x[9] + x[5], 9);
            x[1] ^= R(x[13] + x[9], 13);
            x[5] ^= R(x[1] + x[13], 18);
            x[14] ^= R(x[10] + x[6], 7);
            x[2] ^= R(x[14] + x[10], 9);
            x[6] ^= R(x[2] + x[14], 13);
            x[10] ^= R(x[6] + x[2], 18);
            x[3] ^= R(x[15] + x[11], 7);
            x[7] ^= R(x[3] + x[15], 9);
            x[11] ^= R(x[7] + x[3], 13);
            x[15] ^= R(x[11] + x[7], 18);
            x[1] ^= R(x[0] + x[3], 7);
            x[2] ^= R(x[1] + x[0], 9);
            x[3] ^= R(x[2] + x[1], 13);
            x[0] ^= R(x[3] + x[2], 18);
            x[6] ^= R(x[5] + x[4], 7);
            x[7] ^= R(x[6] + x[5], 9);
            x[4] ^= R(x[7] + x[6], 13);
            x[5] ^= R(x[4] + x[7], 18);
            x[11] ^= R(x[10] + x[9], 7);
            x[8] ^= R(x[11] + x[10], 9);
            x[9] ^= R(x[8] + x[11], 13);
            x[10] ^= R(x[9] + x[8], 18);
            x[12] ^= R(x[15] + x[14], 7);
            x[13] ^= R(x[12] + x[15], 9);
            x[14] ^= R(x[13] + x[12], 13);
            x[15] ^= R(x[14] + x[13], 18);
        }
        for(let i = 0; i < 16; ++i)B[i] += x[i];
    }
    // naive approach... going back to loop unrolling may yield additional performance
    function blockxor(S, Si, D, len) {
        for(let i = 0; i < len; i++)D[i] ^= S[Si + i];
    }
    function arraycopy(src, srcPos, dest, destPos, length) {
        while(length--)dest[destPos++] = src[srcPos++];
    }
    function checkBufferish(o) {
        if (!o || typeof o.length !== "number") return false;
        for(let i = 0; i < o.length; i++){
            const v = o[i];
            if (typeof v !== "number" || v % 1 || v < 0 || v >= 256) return false;
        }
        return true;
    }
    function ensureInteger(value, name) {
        if (typeof value !== "number" || value % 1) throw new Error("invalid " + name);
        return value;
    }
    // N = Cpu cost, r = Memory cost, p = parallelization cost
    // callback(error, progress, key)
    function _scrypt(password, salt, N, r, p, dkLen, callback) {
        N = ensureInteger(N, "N");
        r = ensureInteger(r, "r");
        p = ensureInteger(p, "p");
        dkLen = ensureInteger(dkLen, "dkLen");
        if (N === 0 || (N & N - 1) !== 0) throw new Error("N must be power of 2");
        if (N > MAX_VALUE / 128 / r) throw new Error("N too large");
        if (r > MAX_VALUE / 128 / p) throw new Error("r too large");
        if (!checkBufferish(password)) throw new Error("password must be an array or buffer");
        password = Array.prototype.slice.call(password);
        if (!checkBufferish(salt)) throw new Error("salt must be an array or buffer");
        salt = Array.prototype.slice.call(salt);
        let b = PBKDF2_HMAC_SHA256_OneIter(password, salt, p * 128 * r);
        const B = new Uint32Array(p * 32 * r);
        for(let i = 0; i < B.length; i++){
            const j = i * 4;
            B[i] = (b[j + 3] & 0xff) << 24 | (b[j + 2] & 0xff) << 16 | (b[j + 1] & 0xff) << 8 | (b[j + 0] & 0xff) << 0;
        }
        const XY = new Uint32Array(64 * r);
        const V = new Uint32Array(32 * r * N);
        const Yi = 32 * r;
        // scratch space
        const x = new Uint32Array(16); // salsa20_8
        const _X = new Uint32Array(16); // blockmix_salsa8
        const totalOps = p * N * 2;
        let currentOp = 0;
        let lastPercent10 = null;
        // Set this to true to abandon the scrypt on the next step
        let stop = false;
        // State information
        let state = 0;
        let i0 = 0, i1;
        let Bi;
        // How many blockmix_salsa8 can we do per step?
        const limit = callback ? parseInt(1000 / r) : 0xffffffff;
        // Trick from scrypt-async; if there is a setImmediate shim in place, use it
        const nextTick = typeof setImmediate !== "undefined" ? setImmediate : setTimeout;
        // This is really all I changed; making scryptsy a state machine so we occasionally
        // stop and give other evnts on the evnt loop a chance to run. ~RicMoo
        const incrementalSMix = function() {
            if (stop) return callback(new Error("cancelled"), currentOp / totalOps);
            let steps;
            switch(state){
                case 0:
                    // for (var i = 0; i < p; i++)...
                    Bi = i0 * 32 * r;
                    arraycopy(B, Bi, XY, 0, Yi); // ROMix - 1
                    state = 1; // Move to ROMix 2
                    i1 = 0;
                // Fall through
                case 1:
                    // Run up to 1000 steps of the first inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        arraycopy(XY, 0, V, (i1 + i) * Yi, Yi) // ROMix - 3
                        ;
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 4
                    }
                    // for (var i = 0; i < N; i++)
                    i1 += steps;
                    currentOp += steps;
                    if (callback) {
                        // Call the callback with the progress (optionally stopping us)
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    i1 = 0; // Move to ROMix 6
                    state = 2;
                // Fall through
                case 2:
                    // Run up to 1000 steps of the second inner smix loop
                    steps = N - i1;
                    if (steps > limit) steps = limit;
                    for(let i = 0; i < steps; i++){
                        const offset = (2 * r - 1) * 16; // ROMix - 7
                        const j = XY[offset] & N - 1;
                        blockxor(V, j * Yi, XY, Yi); // ROMix - 8 (inner)
                        blockmix_salsa8(XY, Yi, r, x, _X); // ROMix - 9 (outer)
                    }
                    // for (var i = 0; i < N; i++)...
                    i1 += steps;
                    currentOp += steps;
                    // Call the callback with the progress (optionally stopping us)
                    if (callback) {
                        const percent10 = parseInt(1000 * currentOp / totalOps);
                        if (percent10 !== lastPercent10) {
                            stop = callback(null, currentOp / totalOps);
                            if (stop) break;
                            lastPercent10 = percent10;
                        }
                    }
                    if (i1 < N) break;
                    arraycopy(XY, 0, B, Bi, Yi); // ROMix - 10
                    // for (var i = 0; i < p; i++)...
                    i0++;
                    if (i0 < p) {
                        state = 0;
                        break;
                    }
                    b = [];
                    for(let i = 0; i < B.length; i++){
                        b.push(B[i] >> 0 & 0xff);
                        b.push(B[i] >> 8 & 0xff);
                        b.push(B[i] >> 16 & 0xff);
                        b.push(B[i] >> 24 & 0xff);
                    }
                    const derivedKey = PBKDF2_HMAC_SHA256_OneIter(password, b, dkLen);
                    // Send the result to the callback
                    if (callback) callback(null, 1.0, derivedKey);
                    // Done; don't break (which would reschedule)
                    return derivedKey;
            }
            // Schedule the next steps
            if (callback) nextTick(incrementalSMix);
        };
        // Run the smix state machine until completion
        if (!callback) while(true){
            const derivedKey = incrementalSMix();
            if (derivedKey != undefined) return derivedKey;
        }
        // Bootstrap the async incremental smix
        incrementalSMix();
    }
    const lib = {
        scrypt: function(password, salt, N, r, p, dkLen, progressCallback) {
            return new Promise(function(resolve, reject) {
                let lastProgress = 0;
                if (progressCallback) progressCallback(0);
                _scrypt(password, salt, N, r, p, dkLen, function(error, progress, key) {
                    if (error) reject(error);
                    else if (key) {
                        if (progressCallback && lastProgress !== 1) progressCallback(1);
                        resolve(new Uint8Array(key));
                    } else if (progressCallback && progress !== lastProgress) {
                        lastProgress = progress;
                        return progressCallback(progress);
                    }
                });
            });
        },
        syncScrypt: function(password, salt, N, r, p, dkLen) {
            return new Uint8Array(_scrypt(password, salt, N, r, p, dkLen));
        }
    };
    // node.js
    if (typeof module.exports !== "undefined") module.exports = lib;
    else if (typeof define === "function" && define.amd) define(lib);
    else if (root) {
        // If there was an existing library "scrypt", make sure it is still available
        if (root.scrypt) root._scrypt = root.scrypt;
        root.scrypt = lib;
    }
})(module.exports);

});

parcelRegister("49Skf", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");

var $aFl9E = parcelRequire("aFl9E");

var $f2yLR = parcelRequire("f2yLR");

var $gI6SA = parcelRequire("gI6SA");

var $8BpjK = parcelRequire("8BpjK");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $307224a3592596f3$var$createInstance(defaultConfig) {
    var context = new $f2yLR(defaultConfig);
    var instance = $aFl9E($f2yLR.prototype.request, context);
    // Copy axios.prototype to instance
    $222tm.extend(instance, $f2yLR.prototype, context);
    // Copy context to instance
    $222tm.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $307224a3592596f3$var$axios = $307224a3592596f3$var$createInstance($8BpjK);
// Expose Axios class to allow class inheritance
$307224a3592596f3$var$axios.Axios = $f2yLR;
// Factory for creating new instances
$307224a3592596f3$var$axios.create = function create(instanceConfig) {
    return $307224a3592596f3$var$createInstance($gI6SA($307224a3592596f3$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$307224a3592596f3$var$axios.Cancel = (parcelRequire("2qNRU"));

$307224a3592596f3$var$axios.CancelToken = (parcelRequire("eYxT4"));

$307224a3592596f3$var$axios.isCancel = (parcelRequire("dAozy"));
// Expose all/spread
$307224a3592596f3$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$307224a3592596f3$var$axios.spread = (parcelRequire("5Hu9i"));

// Expose isAxiosError
$307224a3592596f3$var$axios.isAxiosError = (parcelRequire("5ADQV"));
module.exports = $307224a3592596f3$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $307224a3592596f3$var$axios;

});
parcelRegister("222tm", function(module, exports) {
"use strict";

var $aFl9E = parcelRequire("aFl9E");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $17adafa92ae7fdfd$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $17adafa92ae7fdfd$var$isArray(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object Array]";
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $17adafa92ae7fdfd$var$isUndefined(val) {
    return typeof val === "undefined";
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $17adafa92ae7fdfd$var$isBuffer(val) {
    return val !== null && !$17adafa92ae7fdfd$var$isUndefined(val) && val.constructor !== null && !$17adafa92ae7fdfd$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $17adafa92ae7fdfd$var$isArrayBuffer(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object ArrayBuffer]";
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $17adafa92ae7fdfd$var$isFormData(val) {
    return typeof FormData !== "undefined" && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $17adafa92ae7fdfd$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $17adafa92ae7fdfd$var$isString(val) {
    return typeof val === "string";
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $17adafa92ae7fdfd$var$isNumber(val) {
    return typeof val === "number";
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $17adafa92ae7fdfd$var$isObject(val) {
    return val !== null && typeof val === "object";
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $17adafa92ae7fdfd$var$isPlainObject(val) {
    if ($17adafa92ae7fdfd$var$toString.call(val) !== "[object Object]") return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $17adafa92ae7fdfd$var$isDate(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object Date]";
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $17adafa92ae7fdfd$var$isFile(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object File]";
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $17adafa92ae7fdfd$var$isBlob(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object Blob]";
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $17adafa92ae7fdfd$var$isFunction(val) {
    return $17adafa92ae7fdfd$var$toString.call(val) === "[object Function]";
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $17adafa92ae7fdfd$var$isStream(val) {
    return $17adafa92ae7fdfd$var$isObject(val) && $17adafa92ae7fdfd$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $17adafa92ae7fdfd$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== "undefined" && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $17adafa92ae7fdfd$var$trim(str) {
    return str.replace(/^\s*/, "").replace(/\s*$/, "");
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $17adafa92ae7fdfd$var$isStandardBrowserEnv() {
    if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $17adafa92ae7fdfd$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($17adafa92ae7fdfd$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $17adafa92ae7fdfd$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($17adafa92ae7fdfd$var$isPlainObject(result[key]) && $17adafa92ae7fdfd$var$isPlainObject(val)) result[key] = $17adafa92ae7fdfd$var$merge(result[key], val);
        else if ($17adafa92ae7fdfd$var$isPlainObject(val)) result[key] = $17adafa92ae7fdfd$var$merge({}, val);
        else if ($17adafa92ae7fdfd$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$17adafa92ae7fdfd$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $17adafa92ae7fdfd$var$extend(a, b, thisArg) {
    $17adafa92ae7fdfd$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") a[key] = $aFl9E(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $17adafa92ae7fdfd$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $17adafa92ae7fdfd$var$isArray,
    isArrayBuffer: $17adafa92ae7fdfd$var$isArrayBuffer,
    isBuffer: $17adafa92ae7fdfd$var$isBuffer,
    isFormData: $17adafa92ae7fdfd$var$isFormData,
    isArrayBufferView: $17adafa92ae7fdfd$var$isArrayBufferView,
    isString: $17adafa92ae7fdfd$var$isString,
    isNumber: $17adafa92ae7fdfd$var$isNumber,
    isObject: $17adafa92ae7fdfd$var$isObject,
    isPlainObject: $17adafa92ae7fdfd$var$isPlainObject,
    isUndefined: $17adafa92ae7fdfd$var$isUndefined,
    isDate: $17adafa92ae7fdfd$var$isDate,
    isFile: $17adafa92ae7fdfd$var$isFile,
    isBlob: $17adafa92ae7fdfd$var$isBlob,
    isFunction: $17adafa92ae7fdfd$var$isFunction,
    isStream: $17adafa92ae7fdfd$var$isStream,
    isURLSearchParams: $17adafa92ae7fdfd$var$isURLSearchParams,
    isStandardBrowserEnv: $17adafa92ae7fdfd$var$isStandardBrowserEnv,
    forEach: $17adafa92ae7fdfd$var$forEach,
    merge: $17adafa92ae7fdfd$var$merge,
    extend: $17adafa92ae7fdfd$var$extend,
    trim: $17adafa92ae7fdfd$var$trim,
    stripBOM: $17adafa92ae7fdfd$var$stripBOM
};

});
parcelRegister("aFl9E", function(module, exports) {
"use strict";
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("f2yLR", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");

var $8hPU3 = parcelRequire("8hPU3");

var $k6MlW = parcelRequire("k6MlW");

var $bpLMe = parcelRequire("bpLMe");

var $gI6SA = parcelRequire("gI6SA");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $af3203b01e9a87c2$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $k6MlW(),
        response: new $k6MlW()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $af3203b01e9a87c2$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === "string") {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $gI6SA(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = "get";
    // Hook up interceptors middleware
    var chain = [
        $bpLMe,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$af3203b01e9a87c2$var$Axios.prototype.getUri = function getUri(config) {
    config = $gI6SA(this.defaults, config);
    return $8hPU3(config.url, config.params, config.paramsSerializer).replace(/^\?/, "");
};
// Provide aliases for supported request methods
$222tm.forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $af3203b01e9a87c2$var$Axios.prototype[method] = function(url, config) {
        return this.request($gI6SA(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$222tm.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $af3203b01e9a87c2$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($gI6SA(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $af3203b01e9a87c2$var$Axios;

});
parcelRegister("8hPU3", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
function $60882c2171cdef27$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($222tm.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $222tm.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === "undefined") return;
            if ($222tm.isArray(val)) key = key + "[]";
            else val = [
                val
            ];
            $222tm.forEach(val, function parseValue(v) {
                if ($222tm.isDate(v)) v = v.toISOString();
                else if ($222tm.isObject(v)) v = JSON.stringify(v);
                parts.push($60882c2171cdef27$var$encode(key) + "=" + $60882c2171cdef27$var$encode(v));
            });
        });
        serializedParams = parts.join("&");
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
};

});

parcelRegister("k6MlW", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
function $ea39e00a06b6a5e4$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ea39e00a06b6a5e4$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ea39e00a06b6a5e4$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ea39e00a06b6a5e4$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $222tm.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ea39e00a06b6a5e4$var$InterceptorManager;

});

parcelRegister("bpLMe", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");

var $aegOA = parcelRequire("aegOA");

var $dAozy = parcelRequire("dAozy");

var $8BpjK = parcelRequire("8BpjK");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $84f7170962ea682c$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $84f7170962ea682c$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $aegOA(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $222tm.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $222tm.forEach([
        "delete",
        "get",
        "head",
        "post",
        "put",
        "patch",
        "common"
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $8BpjK.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $84f7170962ea682c$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $aegOA(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$dAozy(reason)) {
            $84f7170962ea682c$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $aegOA(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("aegOA", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $222tm.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("dAozy", function(module, exports) {
"use strict";
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("8BpjK", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
"use strict";

var $222tm = parcelRequire("222tm");

var $eCkFl = parcelRequire("eCkFl");
var $64356af653b29517$var$DEFAULT_CONTENT_TYPE = {
    "Content-Type": "application/x-www-form-urlencoded"
};
function $64356af653b29517$var$setContentTypeIfUnset(headers, value) {
    if (!$222tm.isUndefined(headers) && $222tm.isUndefined(headers["Content-Type"])) headers["Content-Type"] = value;
}


function $64356af653b29517$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== "undefined") // For browsers use XHR adapter
    adapter = (parcelRequire("7KBYK"));
    else if (typeof $4TNnu !== "undefined" && Object.prototype.toString.call($4TNnu) === "[object process]") // For node use HTTP adapter
    adapter = (parcelRequire("7KBYK"));
    return adapter;
}
var $64356af653b29517$var$defaults = {
    adapter: $64356af653b29517$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $eCkFl(headers, "Accept");
            $eCkFl(headers, "Content-Type");
            if ($222tm.isFormData(data) || $222tm.isArrayBuffer(data) || $222tm.isBuffer(data) || $222tm.isStream(data) || $222tm.isFile(data) || $222tm.isBlob(data)) return data;
            if ($222tm.isArrayBufferView(data)) return data.buffer;
            if ($222tm.isURLSearchParams(data)) {
                $64356af653b29517$var$setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
                return data.toString();
            }
            if ($222tm.isObject(data)) {
                $64356af653b29517$var$setContentTypeIfUnset(headers, "application/json;charset=utf-8");
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === "string") try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$64356af653b29517$var$defaults.headers = {
    common: {
        "Accept": "application/json, text/plain, */*"
    }
};
$222tm.forEach([
    "delete",
    "get",
    "head"
], function forEachMethodNoData(method) {
    $64356af653b29517$var$defaults.headers[method] = {};
});
$222tm.forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    $64356af653b29517$var$defaults.headers[method] = $222tm.merge($64356af653b29517$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $64356af653b29517$var$defaults;

});
parcelRegister("eCkFl", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $222tm.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("7KBYK", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");

var $a0NU3 = parcelRequire("a0NU3");

var $8PnDn = parcelRequire("8PnDn");

var $8hPU3 = parcelRequire("8hPU3");

var $geA6u = parcelRequire("geA6u");

var $giEon = parcelRequire("giEon");

var $ffgdS = parcelRequire("ffgdS");

var $gx2Ej = parcelRequire("gx2Ej");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($222tm.isFormData(requestData)) delete requestHeaders["Content-Type"]; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || "";
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = $geA6u(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $8hPU3(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // Prepare the response
            var responseHeaders = "getAllResponseHeaders" in request ? $giEon(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === "text" ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $a0NU3(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($gx2Ej("Request aborted", config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($gx2Ej("Network Error", config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = "timeout of " + config.timeout + "ms exceeded";
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($gx2Ej(timeoutErrorMessage, config, "ECONNABORTED", request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($222tm.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $ffgdS(fullPath)) && config.xsrfCookieName ? $8PnDn.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ("setRequestHeader" in request) $222tm.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$222tm.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== "json") throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("a0NU3", function(module, exports) {
"use strict";

var $gx2Ej = parcelRequire("gx2Ej");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($gx2Ej("Request failed with status code " + response.status, response.config, null, response.request, response));
};

});
parcelRegister("gx2Ej", function(module, exports) {
"use strict";

var $hDWyU = parcelRequire("hDWyU");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $hDWyU(error, config, code, request, response);
};

});
parcelRegister("hDWyU", function(module, exports) {
"use strict";
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8PnDn", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
module.exports = $222tm.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ($222tm.isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ($222tm.isString(path)) cookie.push("path=" + path);
            if ($222tm.isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("geA6u", function(module, exports) {
"use strict";

var $esgCy = parcelRequire("esgCy");

var $6I5Xu = parcelRequire("6I5Xu");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$esgCy(requestedURL)) return $6I5Xu(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("esgCy", function(module, exports) {
"use strict";
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("6I5Xu", function(module, exports) {
"use strict";
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
};

});


parcelRegister("giEon", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $bddda8d29225be09$var$ignoreDuplicateOf = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $222tm.forEach(headers.split("\n"), function parser(line) {
        i = line.indexOf(":");
        key = $222tm.trim(line.substr(0, i)).toLowerCase();
        val = $222tm.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $bddda8d29225be09$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === "set-cookie") parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("ffgdS", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
module.exports = $222tm.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement("a");
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $222tm.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("gI6SA", function(module, exports) {
"use strict";

var $222tm = parcelRequire("222tm");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        "url",
        "method",
        "data"
    ];
    var mergeDeepPropertiesKeys = [
        "headers",
        "auth",
        "proxy",
        "params"
    ];
    var defaultToConfig2Keys = [
        "baseURL",
        "transformRequest",
        "transformResponse",
        "paramsSerializer",
        "timeout",
        "timeoutMessage",
        "withCredentials",
        "adapter",
        "responseType",
        "xsrfCookieName",
        "xsrfHeaderName",
        "onUploadProgress",
        "onDownloadProgress",
        "decompress",
        "maxContentLength",
        "maxBodyLength",
        "maxRedirects",
        "transport",
        "httpAgent",
        "httpsAgent",
        "cancelToken",
        "socketPath",
        "responseEncoding"
    ];
    var directMergeKeys = [
        "validateStatus"
    ];
    function getMergedValue(target, source) {
        if ($222tm.isPlainObject(target) && $222tm.isPlainObject(source)) return $222tm.merge(target, source);
        else if ($222tm.isPlainObject(source)) return $222tm.merge({}, source);
        else if ($222tm.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$222tm.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$222tm.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $222tm.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$222tm.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $222tm.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $222tm.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$222tm.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$222tm.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $222tm.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $222tm.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("2qNRU", function(module, exports) {
"use strict";
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $1c54b157d627ec29$var$Cancel(message) {
    this.message = message;
}
$1c54b157d627ec29$var$Cancel.prototype.toString = function toString() {
    return "Cancel" + (this.message ? ": " + this.message : "");
};
$1c54b157d627ec29$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $1c54b157d627ec29$var$Cancel;

});

parcelRegister("eYxT4", function(module, exports) {
"use strict";

var $2qNRU = parcelRequire("2qNRU");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $ae70f4982257da7a$var$CancelToken(executor) {
    if (typeof executor !== "function") throw new TypeError("executor must be a function.");
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2qNRU(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $ae70f4982257da7a$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $ae70f4982257da7a$var$CancelToken.source = function source() {
    var cancel;
    var token = new $ae70f4982257da7a$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $ae70f4982257da7a$var$CancelToken;

});

parcelRegister("5Hu9i", function(module, exports) {
"use strict";
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("5ADQV", function(module, exports) {
"use strict";
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === "object" && payload.isAxiosError === true;
};

});


parcelRegister("6X6Ju", function(module, exports) {
"use strict";
var $50fd79b9178cc3ca$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $50fd79b9178cc3ca$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $50fd79b9178cc3ca$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $50fd79b9178cc3ca$var$__createBinding(result, mod, k);
    }
    $50fd79b9178cc3ca$var$__setModuleDefault(result, mod);
    return result;
};
var $50fd79b9178cc3ca$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NativeAdapter = void 0;

const $50fd79b9178cc3ca$var$core = $50fd79b9178cc3ca$var$__importStar((parcelRequire("lFpDy")));

const $50fd79b9178cc3ca$var$native = $50fd79b9178cc3ca$var$__importStar((parcelRequire("e6mku")));
class $50fd79b9178cc3ca$var$NativeAdapter {
    constructor(keyring){
        this.keyring = keyring;
    }
    static useKeyring(keyring) {
        return new $50fd79b9178cc3ca$var$NativeAdapter(keyring);
    }
    initialize() {
        return $50fd79b9178cc3ca$var$__awaiter(this, void 0, void 0, function*() {
            return 0;
        });
    }
    pairDevice(deviceId) {
        return $50fd79b9178cc3ca$var$__awaiter(this, void 0, void 0, function*() {
            let wallet = this.keyring.get(deviceId);
            if (!wallet && deviceId) {
                // If a wallet with that ID hasn't been added to the keychain, then create it
                wallet = yield $50fd79b9178cc3ca$var$native.create({
                    deviceId: deviceId
                });
                if (!$50fd79b9178cc3ca$var$native.isNative(wallet)) throw new Error("expected native wallet");
                this.keyring.add(wallet, deviceId);
                this.keyring.decorateEvents(deviceId, wallet.events);
            }
            if (wallet && $50fd79b9178cc3ca$var$native.isNative(wallet)) {
                const id = yield wallet.getDeviceID();
                this.keyring.emit([
                    wallet.getVendor(),
                    id,
                    $50fd79b9178cc3ca$var$core.Events.CONNECT
                ], id);
                return wallet;
            }
            return null;
        });
    }
}
module.exports.NativeAdapter = $50fd79b9178cc3ca$var$NativeAdapter;

});
parcelRegister("e6mku", function(module, exports) {
"use strict";
var $a442f2697296c590$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a442f2697296c590$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a442f2697296c590$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a442f2697296c590$var$__createBinding(result, mod, k);
    }
    $a442f2697296c590$var$__setModuleDefault(result, mod);
    return result;
};
var $a442f2697296c590$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a442f2697296c590$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a442f2697296c590$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a442f2697296c590$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $a442f2697296c590$var$_NativeHDWalletBase_events, $a442f2697296c590$var$_NativeHDWallet_deviceId, $a442f2697296c590$var$_NativeHDWallet_initialized, $a442f2697296c590$var$_NativeHDWallet_masterKey;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.create = module.exports.info = module.exports.isNative = module.exports.NativeHDWallet = module.exports.NativeHDWalletBase = module.exports.NativeHDWalletInfoBase = module.exports.NativeEvents = void 0;

const $a442f2697296c590$var$core = $a442f2697296c590$var$__importStar((parcelRequire("lFpDy")));

const $a442f2697296c590$var$bip39 = $a442f2697296c590$var$__importStar((parcelRequire("5qnT8")));

const $a442f2697296c590$var$eventemitter2 = $a442f2697296c590$var$__importStar((parcelRequire("bYxgp")));

const $a442f2697296c590$var$isObject_1 = $a442f2697296c590$var$__importDefault((parcelRequire("jDBle")));

var $5z3oh = parcelRequire("5z3oh");

var $ejX7X = parcelRequire("ejX7X");

var $jC9XV = parcelRequire("jC9XV");

var $ljZAA = parcelRequire("ljZAA");

const $a442f2697296c590$var$Isolation = $a442f2697296c590$var$__importStar((parcelRequire("aCCM0")));

var $jDbFs = parcelRequire("jDbFs");

var $lhEsR = parcelRequire("lhEsR");

var $1OmgF = parcelRequire("1OmgF");

var $lojr1 = parcelRequire("lojr1");

var $pvQdK = parcelRequire("pvQdK");

var $jcC5O = parcelRequire("jcC5O");

var $6j5gZ = parcelRequire("6j5gZ");

var $9tn5d = parcelRequire("9tn5d");

var $d3XRl = parcelRequire("d3XRl");
var $a442f2697296c590$var$NativeEvents;
(function(NativeEvents) {
    NativeEvents["MNEMONIC_REQUIRED"] = "MNEMONIC_REQUIRED";
    NativeEvents["READY"] = "READY";
})($a442f2697296c590$var$NativeEvents || (module.exports.NativeEvents = $a442f2697296c590$var$NativeEvents = {}));
function $a442f2697296c590$var$isMnemonicInterface(x) {
    return $a442f2697296c590$var$core.isIndexable(x) && typeof x.toSeed === "function";
}
class $a442f2697296c590$var$NativeHDWalletInfoBase {
    getVendor() {
        return "Native";
    }
    hasOnDevicePinEntry() {
        return false;
    }
    hasOnDevicePassphrase() {
        return false;
    }
    hasOnDeviceDisplay() {
        return false;
    }
    hasOnDeviceRecovery() {
        return false;
    }
    hasNativeShapeShift() {
        return false;
    }
    supportsBip44Accounts() {
        return true;
    }
    supportsOfflineSigning() {
        return true;
    }
    supportsBroadcast() {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    describePath(msg) {
        throw new Error("unreachable");
    }
}
module.exports.NativeHDWalletInfoBase = $a442f2697296c590$var$NativeHDWalletInfoBase;
class $a442f2697296c590$var$NativeHDWalletBase extends $a442f2697296c590$var$NativeHDWalletInfoBase {
    constructor(){
        super();
        $a442f2697296c590$var$_NativeHDWalletBase_events.set(this, void 0);
        $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWalletBase_events, new $a442f2697296c590$var$eventemitter2.EventEmitter2(), "f");
    }
    get events() {
        return $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWalletBase_events, "f");
    }
    /**
     * Wrap a function call that needs a mnemonic seed
     * Raise an event if the wallet hasn't been initialized with a mnemonic seed
     */ needsMnemonic(hasMnemonic, callback) {
        if (hasMnemonic) return callback();
        $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWalletBase_events, "f").emit($a442f2697296c590$var$NativeEvents.MNEMONIC_REQUIRED, $a442f2697296c590$var$core.makeEvent({
            message_type: $a442f2697296c590$var$NativeEvents.MNEMONIC_REQUIRED,
            from_wallet: true
        }));
        return null;
    }
}
module.exports.NativeHDWalletBase = $a442f2697296c590$var$NativeHDWalletBase;
$a442f2697296c590$var$_NativeHDWalletBase_events = new WeakMap();
class $a442f2697296c590$var$NativeHDWalletInfo extends (0, $jC9XV.MixinNativeBTCWalletInfo)((0, $lhEsR.MixinNativeFioWalletInfo)((0, $jDbFs.MixinNativeETHWalletInfo)((0, $ljZAA.MixinNativeCosmosWalletInfo)((0, $ejX7X.MixinNativeBinanceWalletInfo)((0, $d3XRl.MixinNativeThorchainWalletInfo)((0, $6j5gZ.MixinNativeSecretWalletInfo)((0, $9tn5d.MixinNativeTerraWalletInfo)((0, $1OmgF.MixinNativeKavaWalletInfo)((0, $5z3oh.MixinNativeArkeoWalletInfo)((0, $jcC5O.MixinNativeOsmosisWalletInfo)((0, $lojr1.MixinNativeMayachainWalletInfo)($a442f2697296c590$var$NativeHDWalletBase)))))))))))) {
    describePath(msg) {
        switch(msg.coin.toLowerCase()){
            case "bitcoin":
            case "bitcoincash":
            case "dash":
            case "digibyte":
            case "dogecoin":
            case "litecoin":
            case "testnet":
                {
                    const unknown = $a442f2697296c590$var$core.unknownUTXOPath(msg.path, msg.coin, msg.scriptType);
                    if (!msg.scriptType) return unknown;
                    if (!super.btcSupportsCoinSync(msg.coin)) return unknown;
                    if (!super.btcSupportsScriptTypeSync(msg.coin, msg.scriptType)) return unknown;
                    return $a442f2697296c590$var$core.describeUTXOPath(msg.path, msg.coin, msg.scriptType);
                }
            case "ethereum":
                return $a442f2697296c590$var$core.describeETHPath(msg.path);
            case "atom":
                return $a442f2697296c590$var$core.cosmosDescribePath(msg.path);
            case "rune":
            case "trune":
            case "thorchain":
                return $a442f2697296c590$var$core.thorchainDescribePath(msg.path);
            case "secret":
            case "scrt":
            case "tscrt":
                return $a442f2697296c590$var$core.secretDescribePath(msg.path);
            case "luna":
            case "terra":
            case "tluna":
                return $a442f2697296c590$var$core.terraDescribePath(msg.path);
            case "kava":
            case "tkava":
                return $a442f2697296c590$var$core.kavaDescribePath(msg.path);
            case "binance":
                return $a442f2697296c590$var$core.binanceDescribePath(msg.path);
            case "osmosis":
            case "osmo":
                return $a442f2697296c590$var$core.osmosisDescribePath(msg.path);
            case "fio":
                return $a442f2697296c590$var$core.fioDescribePath(msg.path);
            case "arkeo":
                return $a442f2697296c590$var$core.arkeoDescribePath(msg.path);
            case "cacao":
            case "scacao":
            case "mayachain":
            case "maya":
                return $a442f2697296c590$var$core.mayachainDescribePath(msg.path);
            default:
                throw new Error("Unsupported path");
        }
    }
}
class $a442f2697296c590$var$NativeHDWallet extends (0, $jC9XV.MixinNativeBTCWallet)((0, $lhEsR.MixinNativeFioWallet)((0, $jDbFs.MixinNativeETHWallet)((0, $ljZAA.MixinNativeCosmosWallet)((0, $ejX7X.MixinNativeBinanceWallet)((0, $d3XRl.MixinNativeThorchainWallet)((0, $6j5gZ.MixinNativeSecretWallet)((0, $9tn5d.MixinNativeTerraWallet)((0, $1OmgF.MixinNativeKavaWallet)((0, $jcC5O.MixinNativeOsmosisWallet)((0, $5z3oh.MixinNativeArkeoWallet)((0, $lojr1.MixinNativeMayachainWallet)($a442f2697296c590$var$NativeHDWalletInfo)))))))))))) {
    constructor({ mnemonic: mnemonic, deviceId: deviceId, masterKey: masterKey }){
        super();
        this._supportsBTC = true;
        this._supportsETH = true;
        this._supportsCosmos = true;
        this._supportsEthSwitchChain = false;
        this._supportsAvalanche = true;
        this._supportsOptimism = true;
        this._supportsBSC = true;
        this._supportsPolygon = true;
        this._supportsGnosis = true;
        this._supportsArbitrum = true;
        this._supportsArbitrumNova = true;
        this._supportsOsmosis = true;
        this._supportsBinance = true;
        this._supportsFio = true;
        this._supportsThorchain = true;
        this._supportsSecret = true;
        this._supportsTerra = true;
        this._supportsKava = true;
        this._supportsArkeo = true;
        this._supportsMayachain = true;
        this._isNative = true;
        $a442f2697296c590$var$_NativeHDWallet_deviceId.set(this, void 0);
        $a442f2697296c590$var$_NativeHDWallet_initialized.set(this, false);
        $a442f2697296c590$var$_NativeHDWallet_masterKey.set(this, undefined);
        if (masterKey) $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, Promise.resolve(masterKey), "f");
        else if (mnemonic) $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, (()=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                const isolatedMnemonic = typeof mnemonic === "string" ? yield $a442f2697296c590$var$Isolation.Engines.Default.BIP39.Mnemonic.create(mnemonic) : mnemonic;
                const seed = yield isolatedMnemonic.toSeed();
                return yield seed.toMasterKey();
            }))(), "f");
        $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_deviceId, deviceId, "f");
    }
    getFeatures() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return {};
        });
    }
    getDeviceID() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_deviceId, "f");
        });
    }
    getFirmwareVersion() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return "Software";
        });
    }
    getModel() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return "Native";
        });
    }
    getLabel() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return "Native";
        });
    }
    /*
     * @see: https://github.com/satoshilabs/slips/blob/master/slip-0132.md
     * to supports different styles of xpubs as can be defined by passing in a network to `fromSeed`
     */ getPublicKeys(msg) {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return this.needsMnemonic(!!$a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, "f"), ()=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const masterKey = yield $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, "f");
                    return yield Promise.all(msg.map((getPublicKey)=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                            const { addressNList: addressNList } = getPublicKey;
                            const network = (0, $pvQdK.getNetwork)(getPublicKey.coin, getPublicKey.scriptType);
                            // TODO: return the xpub that's actually asked for, not the key of the hardened path
                            // It's done this way for hilarious historical reasons and will break ETH if fixed
                            const hardenedPath = $a442f2697296c590$var$core.hardenedPath(addressNList);
                            let node = yield $a442f2697296c590$var$Isolation.Adapters.BIP32.create(masterKey, network);
                            if (hardenedPath.length > 0) node = yield node.derivePath($a442f2697296c590$var$core.addressNListToBIP32(hardenedPath));
                            const xpub = node.neutered().toBase58();
                            return {
                                xpub: xpub
                            };
                        })));
                }));
        });
    }
    isInitialized() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return !!$a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, "f");
        });
    }
    isLocked() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return false;
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    clearSession() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    initialize() {
        const _super = Object.create(null, {
            btcInitializeWallet: {
                get: ()=>super.btcInitializeWallet
            },
            ethInitializeWallet: {
                get: ()=>super.ethInitializeWallet
            },
            cosmosInitializeWallet: {
                get: ()=>super.cosmosInitializeWallet
            },
            osmosisInitializeWallet: {
                get: ()=>super.osmosisInitializeWallet
            },
            binanceInitializeWallet: {
                get: ()=>super.binanceInitializeWallet
            },
            fioInitializeWallet: {
                get: ()=>super.fioInitializeWallet
            },
            thorchainInitializeWallet: {
                get: ()=>super.thorchainInitializeWallet
            },
            secretInitializeWallet: {
                get: ()=>super.secretInitializeWallet
            },
            terraInitializeWallet: {
                get: ()=>super.terraInitializeWallet
            },
            kavaInitializeWallet: {
                get: ()=>super.kavaInitializeWallet
            },
            arkeoInitializeWallet: {
                get: ()=>super.arkeoInitializeWallet
            },
            mayachainInitializeWallet: {
                get: ()=>super.mayachainInitializeWallet
            }
        });
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return this.needsMnemonic(!!$a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, "f"), ()=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const masterKey = yield $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, "f");
                    try {
                        yield Promise.all([
                            _super.btcInitializeWallet.call(this, masterKey),
                            _super.ethInitializeWallet.call(this, masterKey),
                            _super.cosmosInitializeWallet.call(this, masterKey),
                            _super.osmosisInitializeWallet.call(this, masterKey),
                            _super.binanceInitializeWallet.call(this, masterKey),
                            _super.fioInitializeWallet.call(this, masterKey),
                            _super.thorchainInitializeWallet.call(this, masterKey),
                            _super.secretInitializeWallet.call(this, masterKey),
                            _super.terraInitializeWallet.call(this, masterKey),
                            _super.kavaInitializeWallet.call(this, masterKey),
                            _super.arkeoInitializeWallet.call(this, masterKey),
                            _super.mayachainInitializeWallet.call(this, masterKey)
                        ]);
                        $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, true, "f");
                    } catch (e) {
                        console.error("NativeHDWallet:initialize:error", e);
                        $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, false, "f");
                        yield this.wipe();
                    }
                    return $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, "f");
                }));
        });
    }
    ping(msg) {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            return {
                msg: msg.msg
            };
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    sendPin() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    sendPassphrase() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    sendCharacter() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    sendWord() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    cancel() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    wipe() {
        const _super = Object.create(null, {
            btcWipe: {
                get: ()=>super.btcWipe
            },
            ethWipe: {
                get: ()=>super.ethWipe
            },
            cosmosWipe: {
                get: ()=>super.cosmosWipe
            },
            osmosisWipe: {
                get: ()=>super.osmosisWipe
            },
            binanceWipe: {
                get: ()=>super.binanceWipe
            },
            fioWipe: {
                get: ()=>super.fioWipe
            },
            thorchainWipe: {
                get: ()=>super.thorchainWipe
            },
            secretWipe: {
                get: ()=>super.secretWipe
            },
            terraWipe: {
                get: ()=>super.terraWipe
            },
            kavaWipe: {
                get: ()=>super.kavaWipe
            },
            arkeoWipe: {
                get: ()=>super.arkeoWipe
            },
            mayachainWipe: {
                get: ()=>super.mayachainWipe
            }
        });
        var _a, _b;
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            const oldMasterKey = $a442f2697296c590$var$__classPrivateFieldGet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, "f");
            $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, false, "f");
            $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, undefined, "f");
            _super.btcWipe.call(this);
            _super.ethWipe.call(this);
            _super.cosmosWipe.call(this);
            _super.osmosisWipe.call(this);
            _super.binanceWipe.call(this);
            _super.fioWipe.call(this);
            _super.thorchainWipe.call(this);
            _super.secretWipe.call(this);
            _super.terraWipe.call(this);
            _super.kavaWipe.call(this);
            _super.arkeoWipe.call(this);
            _super.mayachainWipe.call(this);
            (_b = (_a = yield oldMasterKey) === null || _a === void 0 ? void 0 : _a.revoke) === null || _b === void 0 || _b.call(_a);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    reset() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    recover() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {});
    }
    loadDevice(msg) {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_masterKey, Promise.resolve((yield ((mnemonic, masterKey)=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b;
                    if (masterKey !== undefined) return masterKey;
                    else if (mnemonic !== undefined) {
                        const isolatedMnemonic = yield (()=>$a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
                                if ($a442f2697296c590$var$isMnemonicInterface(mnemonic)) return mnemonic;
                                if (typeof mnemonic === "string" && $a442f2697296c590$var$bip39.validateMnemonic(mnemonic)) return yield $a442f2697296c590$var$Isolation.Engines.Default.BIP39.Mnemonic.create(mnemonic);
                                throw new Error("Required property [mnemonic] is invalid");
                            }))();
                        const seed = yield isolatedMnemonic.toSeed();
                        (_a = seed.addRevoker) === null || _a === void 0 || _a.call(seed, ()=>{
                            var _a;
                            return (_a = isolatedMnemonic.revoke) === null || _a === void 0 ? void 0 : _a.call(isolatedMnemonic);
                        });
                        const out = yield seed.toMasterKey();
                        (_b = out.addRevoker) === null || _b === void 0 || _b.call(out, ()=>{
                            var _a;
                            return (_a = seed.revoke) === null || _a === void 0 ? void 0 : _a.call(seed);
                        });
                        return out;
                    }
                    throw new Error("Either [mnemonic] or [masterKey] is required");
                }))(msg === null || msg === void 0 ? void 0 : msg.mnemonic, msg === null || msg === void 0 ? void 0 : msg.masterKey))), "f");
            if (typeof (msg === null || msg === void 0 ? void 0 : msg.deviceId) === "string") $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_deviceId, msg === null || msg === void 0 ? void 0 : msg.deviceId, "f");
            $a442f2697296c590$var$__classPrivateFieldSet(this, $a442f2697296c590$var$_NativeHDWallet_initialized, false, "f");
            yield this.initialize();
            // Once we've been seeded with a mnemonic we re-emit the connected event
            this.events.emit($a442f2697296c590$var$NativeEvents.READY, $a442f2697296c590$var$core.makeEvent({
                message_type: $a442f2697296c590$var$NativeEvents.READY,
                from_wallet: true
            }));
        });
    }
    disconnect() {
        return $a442f2697296c590$var$__awaiter(this, void 0, void 0, function*() {
            yield this.wipe();
        });
    }
}
module.exports.NativeHDWallet = $a442f2697296c590$var$NativeHDWallet;
$a442f2697296c590$var$_NativeHDWallet_deviceId = new WeakMap(), $a442f2697296c590$var$_NativeHDWallet_initialized = new WeakMap(), $a442f2697296c590$var$_NativeHDWallet_masterKey = new WeakMap();
function $a442f2697296c590$var$isNative(wallet) {
    return (0, $a442f2697296c590$var$isObject_1.default)(wallet) && wallet._isNative;
}
module.exports.isNative = $a442f2697296c590$var$isNative;
function $a442f2697296c590$var$info() {
    return new $a442f2697296c590$var$NativeHDWalletInfo();
}
module.exports.info = $a442f2697296c590$var$info;
function $a442f2697296c590$var$create(args) {
    return new $a442f2697296c590$var$NativeHDWallet(args);
}
module.exports.create = $a442f2697296c590$var$create;
// This prevents any malicious code from overwriting the prototype
// to potentially steal the mnemonic when calling "loadDevice"
Object.freeze(Object.getPrototypeOf($a442f2697296c590$var$NativeHDWallet));

});
parcelRegister("5z3oh", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $40d2d9f02cd14bf7$require$Buffer = $ihoyg.Buffer;
"use strict";
var $40d2d9f02cd14bf7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $40d2d9f02cd14bf7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $40d2d9f02cd14bf7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $40d2d9f02cd14bf7$var$__createBinding(result, mod, k);
    }
    $40d2d9f02cd14bf7$var$__setModuleDefault(result, mod);
    return result;
};
var $40d2d9f02cd14bf7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $40d2d9f02cd14bf7$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $40d2d9f02cd14bf7$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $40d2d9f02cd14bf7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeArkeoWallet = module.exports.MixinNativeArkeoWalletInfo = void 0;

const $40d2d9f02cd14bf7$var$core = $40d2d9f02cd14bf7$var$__importStar((parcelRequire("lFpDy")));

const $40d2d9f02cd14bf7$var$bech32 = $40d2d9f02cd14bf7$var$__importStar((parcelRequire("5wgCY")));

const $40d2d9f02cd14bf7$var$crypto_js_1 = $40d2d9f02cd14bf7$var$__importDefault((parcelRequire("kWcCv")));

const $40d2d9f02cd14bf7$var$p_lazy_1 = $40d2d9f02cd14bf7$var$__importDefault((parcelRequire("gGdnO")));

const $40d2d9f02cd14bf7$var$Isolation = $40d2d9f02cd14bf7$var$__importStar((parcelRequire("aCCM0")));

const $40d2d9f02cd14bf7$var$util = $40d2d9f02cd14bf7$var$__importStar((parcelRequire("byiQW")));
const $40d2d9f02cd14bf7$var$ARKEO_CHAIN = "arkeo-mainnet-1";

const $40d2d9f02cd14bf7$var$protoTxBuilder = $40d2d9f02cd14bf7$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("eknzC"));
    }).then((res)=>$40d2d9f02cd14bf7$var$__importStar(res)));
function $40d2d9f02cd14bf7$var$MixinNativeArkeoWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeArkeoWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsArkeoInfo = true;
        }
        arkeoSupportsNetwork() {
            return $40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        arkeoSupportsSecureTransfer() {
            return $40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        arkeoSupportsNativeShapeShift() {
            return false;
        }
        arkeoGetAccountPaths(msg) {
            const slip44 = $40d2d9f02cd14bf7$var$core.slip44ByCoin("Arkeo");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        arkeoNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeArkeoWalletInfo = $40d2d9f02cd14bf7$var$MixinNativeArkeoWalletInfo;
function $40d2d9f02cd14bf7$var$MixinNativeArkeoWallet(Base) {
    var _MixinNativeArkeoWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeArkeoWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsArkeo = true;
            _MixinNativeArkeoWallet_masterKey.set(this, void 0);
        }
        arkeoInitializeWallet(masterKey) {
            return $40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                $40d2d9f02cd14bf7$var$__classPrivateFieldSet(this, _MixinNativeArkeoWallet_masterKey, masterKey, "f");
            });
        }
        arkeoWipe() {
            $40d2d9f02cd14bf7$var$__classPrivateFieldSet(this, _MixinNativeArkeoWallet_masterKey, undefined, "f");
        }
        arkeoBech32ify(address, prefix) {
            const words = $40d2d9f02cd14bf7$var$bech32.toWords(address);
            return $40d2d9f02cd14bf7$var$bech32.encode(prefix, words);
        }
        createArkeoAddress(publicKey) {
            const message = $40d2d9f02cd14bf7$var$crypto_js_1.default.SHA256($40d2d9f02cd14bf7$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $40d2d9f02cd14bf7$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $40d2d9f02cd14bf7$require$Buffer.from(hash, `hex`);
            return this.arkeoBech32ify(address, `arkeo`);
        }
        arkeoGetAddress(msg) {
            return $40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$40d2d9f02cd14bf7$var$__classPrivateFieldGet(this, _MixinNativeArkeoWallet_masterKey, "f"), ()=>$40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $40d2d9f02cd14bf7$var$util.getKeyPair($40d2d9f02cd14bf7$var$__classPrivateFieldGet(this, _MixinNativeArkeoWallet_masterKey, "f"), msg.addressNList, "arkeo");
                        return this.createArkeoAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        arkeoSignTx(msg) {
            return $40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$40d2d9f02cd14bf7$var$__classPrivateFieldGet(this, _MixinNativeArkeoWallet_masterKey, "f"), ()=>$40d2d9f02cd14bf7$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $40d2d9f02cd14bf7$var$util.getKeyPair($40d2d9f02cd14bf7$var$__classPrivateFieldGet(this, _MixinNativeArkeoWallet_masterKey, "f"), msg.addressNList, "arkeo");
                        const adapter = yield $40d2d9f02cd14bf7$var$Isolation.Adapters.CosmosDirect.create(keyPair.node, "arkeo");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: $40d2d9f02cd14bf7$var$ARKEO_CHAIN
                        };
                        return (yield $40d2d9f02cd14bf7$var$protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData, "arkeo");
                    }));
            });
        }
    }, _MixinNativeArkeoWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeArkeoWallet = $40d2d9f02cd14bf7$var$MixinNativeArkeoWallet;

});
parcelRegister("aCCM0", function(module, exports) {
"use strict";
var $7bbb878e068b30ba$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7bbb878e068b30ba$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7bbb878e068b30ba$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7bbb878e068b30ba$var$__createBinding(result, mod, k);
    }
    $7bbb878e068b30ba$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Core = module.exports.Engines = module.exports.Adapters = void 0;

module.exports.Adapters = $7bbb878e068b30ba$var$__importStar((parcelRequire("hGbQF")));

module.exports.Engines = $7bbb878e068b30ba$var$__importStar((parcelRequire("kYfJJ")));

module.exports.Core = $7bbb878e068b30ba$var$__importStar((parcelRequire("cVeOu")));

});
parcelRegister("hGbQF", function(module, exports) {
"use strict";
var $cdef8cc41ee1254d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CosmosDirect = module.exports.Cosmos = module.exports.Binance = module.exports.FIO = module.exports.Ethereum = module.exports.BIP32 = module.exports.Bitcoin = void 0;

var $liWrL = parcelRequire("liWrL");
Object.defineProperty(module.exports, "Bitcoin", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($liWrL).default;
    }
});

var $jwzbH = parcelRequire("jwzbH");
Object.defineProperty(module.exports, "BIP32", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($jwzbH).default;
    }
});

var $2rr6y = parcelRequire("2rr6y");
Object.defineProperty(module.exports, "Ethereum", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($2rr6y).default;
    }
});

var $2VqZp = parcelRequire("2VqZp");
Object.defineProperty(module.exports, "FIO", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($2VqZp).default;
    }
});

var $9BvPv = parcelRequire("9BvPv");
Object.defineProperty(module.exports, "Binance", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($9BvPv).default;
    }
});

var $jYjQG = parcelRequire("jYjQG");
Object.defineProperty(module.exports, "Cosmos", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($jYjQG).default;
    }
});

var $hKoqE = parcelRequire("hKoqE");
Object.defineProperty(module.exports, "CosmosDirect", {
    enumerable: true,
    get: function() {
        return $cdef8cc41ee1254d$var$__importDefault($hKoqE).default;
    }
});

});
parcelRegister("liWrL", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f8289dbe9dc6f79e$require$Buffer = $ihoyg.Buffer;
"use strict";
var $f8289dbe9dc6f79e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f8289dbe9dc6f79e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f8289dbe9dc6f79e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f8289dbe9dc6f79e$var$__createBinding(result, mod, k);
    }
    $f8289dbe9dc6f79e$var$__setModuleDefault(result, mod);
    return result;
};
var $f8289dbe9dc6f79e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f8289dbe9dc6f79e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ECPairAdapter = void 0;

const $f8289dbe9dc6f79e$var$p_lazy_1 = $f8289dbe9dc6f79e$var$__importDefault((parcelRequire("gGdnO")));

var $cVeOu = parcelRequire("cVeOu");

var $glOWu = parcelRequire("glOWu");
let $f8289dbe9dc6f79e$var$networksInstance;

const $f8289dbe9dc6f79e$var$networksReady = $f8289dbe9dc6f79e$var$p_lazy_1.default.from(()=>$f8289dbe9dc6f79e$var$__awaiter(void 0, void 0, void 0, function*() {
        $f8289dbe9dc6f79e$var$networksInstance = (yield Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("1JUZg")));
        }).then((res)=>$f8289dbe9dc6f79e$var$__importStar(res))).networks;
    }));
class $f8289dbe9dc6f79e$var$ECPairAdapter {
    constructor(isolatedKey, publicKey, network){
        this.compressed = false;
        this.lowR = false;
        this._isolatedKey = isolatedKey;
        this._publicKey = publicKey;
        this._network = network;
    }
    /**
     * If you're inheriting from this class, be sure to call `await ECPairAdapter.prepare()` in your `create()` overload.
     */ static prepare() {
        return $f8289dbe9dc6f79e$var$__awaiter(this, void 0, void 0, function*() {
            yield $f8289dbe9dc6f79e$var$networksReady;
        });
    }
    static create(isolatedKey, network) {
        return $f8289dbe9dc6f79e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.prepare();
            return new $f8289dbe9dc6f79e$var$ECPairAdapter(isolatedKey, (yield isolatedKey.getPublicKey()), network);
        });
    }
    get network() {
        var _a;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (_a = this._network) !== null && _a !== void 0 ? _a : $f8289dbe9dc6f79e$var$networksInstance.bitcoin;
    }
    get ecdsaSign() {
        return this._isolatedKey.ecdsaSign.bind(this._isolatedKey);
    }
    get ecdh() {
        const isolatedKey = this._isolatedKey;
        if (!("ecdh" in isolatedKey && typeof isolatedKey.ecdh === "function")) return undefined;
        return isolatedKey.ecdh.bind(isolatedKey);
    }
    get ecdhRaw() {
        const isolatedKey = this._isolatedKey;
        if (!("ecdhRaw" in isolatedKey && typeof isolatedKey.ecdhRaw === "function")) return undefined;
        return isolatedKey.ecdhRaw.bind(isolatedKey);
    }
    sign(hash, lowR) {
        return $f8289dbe9dc6f79e$var$__awaiter(this, void 0, void 0, function*() {
            (0, $glOWu.assertType)((0, $glOWu.ByteArray)(), hash);
            lowR = lowR !== null && lowR !== void 0 ? lowR : this.lowR;
            const sig = yield (()=>$f8289dbe9dc6f79e$var$__awaiter(this, void 0, void 0, function*() {
                    if (!hash.algorithm) {
                        (0, $glOWu.assertType)((0, $glOWu.ByteArray)(32), hash);
                        return !lowR ? yield this._isolatedKey.ecdsaSign(null, hash) : yield $cVeOu.SecP256K1.Signature.signCanonically(this._isolatedKey, null, hash);
                    } else return !lowR ? yield this._isolatedKey.ecdsaSign(hash.algorithm, hash.preimage) : yield $cVeOu.SecP256K1.Signature.signCanonically(this._isolatedKey, hash.algorithm, hash.preimage);
                }))();
            return $f8289dbe9dc6f79e$require$Buffer.from(sig);
        });
    }
    get publicKey() {
        return this.getPublicKey();
    }
    getPublicKey() {
        const publicKey = this._publicKey;
        const key = this.compressed ? $cVeOu.SecP256K1.CompressedPoint.from(publicKey) : $cVeOu.SecP256K1.UncompressedPoint.from(publicKey);
        return $f8289dbe9dc6f79e$require$Buffer.from(key);
    }
    toWIF() {
        throw new $cVeOu.IsolationError("WIF");
    }
    verify(hash, signature) {
        $cVeOu.SecP256K1.Signature.assert(signature);
        return $cVeOu.SecP256K1.Signature.verify(signature, null, hash, this._publicKey);
    }
}
module.exports.ECPairAdapter = $f8289dbe9dc6f79e$var$ECPairAdapter;
module.exports.default = $f8289dbe9dc6f79e$var$ECPairAdapter;

});
parcelRegister("cVeOu", function(module, exports) {
"use strict";
var $96864c86692edb19$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $96864c86692edb19$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $96864c86692edb19$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $96864c86692edb19$var$__createBinding(result, mod, k);
    }
    $96864c86692edb19$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IsolationError = module.exports.SecP256K1 = module.exports.Digest = module.exports.BIP39 = module.exports.BIP32 = void 0;

module.exports.BIP32 = $96864c86692edb19$var$__importStar((parcelRequire("bK4PJ")));

module.exports.BIP39 = $96864c86692edb19$var$__importStar((parcelRequire("2Q5oV")));

module.exports.Digest = $96864c86692edb19$var$__importStar((parcelRequire("bkHrJ")));

module.exports.SecP256K1 = $96864c86692edb19$var$__importStar((parcelRequire("feVdj")));
class $96864c86692edb19$var$IsolationError extends Error {
    constructor(name){
        super(`this key is isolated -- no ${name} for you!`);
    }
}
module.exports.IsolationError = $96864c86692edb19$var$IsolationError;

});
parcelRegister("bK4PJ", function(module, exports) {
"use strict";
var $88c7bd640dcfd85e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $88c7bd640dcfd85e$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $88c7bd640dcfd85e$var$__createBinding(exports1, m, p);
};
var $88c7bd640dcfd85e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.derivePath = void 0;

$88c7bd640dcfd85e$var$__exportStar((parcelRequire("g9AM3")), module.exports);

$88c7bd640dcfd85e$var$__exportStar((parcelRequire("6uZnH")), module.exports);

function $88c7bd640dcfd85e$var$derivePath(node, path) {
    return $88c7bd640dcfd85e$var$__awaiter(this, void 0, void 0, function*() {
        // This logic is copied (almost) wholesale from the bip32 package.
        (parcelRequire("g9AM3")).Path.assert(path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") splitPath = splitPath.slice(1);
        const endIndex = splitPath.lastIndexOf("");
        if (endIndex >= 0) splitPath = splitPath.slice(0, endIndex);
        return splitPath.reduce((prevHd, indexStr)=>$88c7bd640dcfd85e$var$__awaiter(this, void 0, void 0, function*() {
                let index;
                if (indexStr.slice(-1) === `'`) {
                    index = parseInt(indexStr.slice(0, -1), 10);
                    return (yield prevHd).derive(index + 0x80000000);
                } else {
                    index = parseInt(indexStr, 10);
                    return (yield prevHd).derive(index);
                }
            }), Promise.resolve(node));
    });
}
module.exports.derivePath = $88c7bd640dcfd85e$var$derivePath;

});
parcelRegister("g9AM3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Path = module.exports.ChainCode = void 0;

var $glOWu = parcelRequire("glOWu");
const $bc2a033076387ffc$var$chainCodeBase = (0, $glOWu.ByteArray)(32);
const $bc2a033076387ffc$var$chainCodeStatic = {};
const $bc2a033076387ffc$var$chainCode = Object.assign($bc2a033076387ffc$var$chainCodeBase, $bc2a033076387ffc$var$chainCodeStatic);
module.exports.ChainCode = $bc2a033076387ffc$var$chainCode;
// https://regex101.com/r/KwmgAp/1
const $bc2a033076387ffc$var$pathBase = (0, $glOWu.BoundedString)(/^((m\/)?(\d+'?\/)*\d+'?)$|^(?![\s\S])/);
const $bc2a033076387ffc$var$pathStatic = {};
const $bc2a033076387ffc$var$path = Object.assign($bc2a033076387ffc$var$pathBase, $bc2a033076387ffc$var$pathStatic);
module.exports.Path = $bc2a033076387ffc$var$path;

});
parcelRegister("glOWu", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $be761f9ed995baa6$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.safeBufferFrom = module.exports.BigEndianInteger = module.exports.ByteArray = module.exports.checkType = module.exports.assertType = module.exports.BoundedString = module.exports.BoundedUint = module.exports.Uint8 = module.exports.Uint16 = module.exports.Uint32 = module.exports.Uint = module.exports.NonNegativeInteger = module.exports.NonPositiveInteger = module.exports.NegativeInteger = module.exports.PositiveInteger = module.exports.Integer = module.exports.integer = module.exports.NonPositive = module.exports.NonNegative = module.exports.Negative = module.exports.Positive = void 0;

var $5Au6L = parcelRequire("5Au6L");
const $be761f9ed995baa6$var$positive = $5Au6L.Number.withConstraint((x)=>x > 0 || `expected ${x} to be positive`, {
    name: "Positive"
});
module.exports.Positive = $be761f9ed995baa6$var$positive;
const $be761f9ed995baa6$var$negative = $5Au6L.Number.withConstraint((x)=>x < 0 || `expected ${x} to be negative`, {
    name: "Negative"
});
module.exports.Negative = $be761f9ed995baa6$var$negative;
const $be761f9ed995baa6$var$nonNegative = $5Au6L.Number.withConstraint((x)=>x >= 0 || `expected ${x} to be non-negative`, {
    name: "NonNegative"
});
module.exports.NonNegative = $be761f9ed995baa6$var$nonNegative;
const $be761f9ed995baa6$var$nonPositive = $5Au6L.Number.withConstraint((x)=>x <= 0 || `expected ${x} to be non-positive`, {
    name: "NonPositive"
});
module.exports.NonPositive = $be761f9ed995baa6$var$nonPositive;
module.exports.integer = $5Au6L.Number.withConstraint((x)=>Number.isSafeInteger(x) || `expected ${x} to be an integer`, {
    name: "Integer"
});
module.exports.Integer = module.exports.integer;
const $be761f9ed995baa6$var$positiveInteger = module.exports.Integer.And(module.exports.Positive);
module.exports.PositiveInteger = $be761f9ed995baa6$var$positiveInteger;
const $be761f9ed995baa6$var$negativeInteger = module.exports.Integer.And(module.exports.Negative);
module.exports.NegativeInteger = $be761f9ed995baa6$var$negativeInteger;
const $be761f9ed995baa6$var$nonPositiveInteger = module.exports.Integer.And(module.exports.NonPositive);
module.exports.NonPositiveInteger = $be761f9ed995baa6$var$nonPositiveInteger;
const $be761f9ed995baa6$var$nonNegativeInteger = module.exports.Integer.And(module.exports.NonNegative);
module.exports.NonNegativeInteger = $be761f9ed995baa6$var$nonNegativeInteger;
const $be761f9ed995baa6$var$uint = module.exports.NonNegativeInteger.Or($5Au6L.Never);
module.exports.Uint = $be761f9ed995baa6$var$uint;
const $be761f9ed995baa6$var$uint32 = $5Au6L.Number.withConstraint((x)=>x === (x & 0xffffffff) >>> 0 || `expected ${x} to be an unsigned 32-bit integer.`, {
    name: "Uint32"
});
module.exports.Uint32 = $be761f9ed995baa6$var$uint32;
const $be761f9ed995baa6$var$uint16 = $5Au6L.Number.withConstraint((x)=>x === (x & 0xffff) >>> 0 || `expected ${x} to be an unsigned 16-bit integer`, {
    name: "Uint16"
});
module.exports.Uint16 = $be761f9ed995baa6$var$uint16;
const $be761f9ed995baa6$var$uint8 = $5Au6L.Number.withConstraint((x)=>x === (x & 0xff) >>> 0 || `expected ${x} to be an unsigned 8-bit integer`, {
    name: "Uint8"
});
module.exports.Uint8 = $be761f9ed995baa6$var$uint8;
function $be761f9ed995baa6$var$boundedUintBase(max) {
    return Object.assign(module.exports.Uint.withConstraint((x)=>x <= max || `expected ${x} to be less than or equal to ${max}`, {
        name: `BoundedUint(${max})`
    }), {
        max: max
    });
}
const $be761f9ed995baa6$var$boundedUintStatic = {};
const $be761f9ed995baa6$var$boundedUint = Object.assign($be761f9ed995baa6$var$boundedUintBase, $be761f9ed995baa6$var$boundedUintStatic);
module.exports.BoundedUint = $be761f9ed995baa6$var$boundedUint;
function $be761f9ed995baa6$var$boundedStringBase(regex) {
    return Object.assign($5Au6L.String.withConstraint((x)=>regex.test(x) || `expected ${x} to match regex ${regex}`, {
        name: `BoundedString(${regex})`
    }), {
        regex: regex
    });
}
const $be761f9ed995baa6$var$boundedStringStatic = {};
const $be761f9ed995baa6$var$boundedString = Object.assign($be761f9ed995baa6$var$boundedStringBase, $be761f9ed995baa6$var$boundedStringStatic);
module.exports.BoundedString = $be761f9ed995baa6$var$boundedString;
function $be761f9ed995baa6$var$assertType(rt, value) {
    rt.assert(value);
}
module.exports.assertType = $be761f9ed995baa6$var$assertType;
function $be761f9ed995baa6$var$checkType(rt, value) {
    $be761f9ed995baa6$var$assertType(rt, value);
    return value;
}
module.exports.checkType = $be761f9ed995baa6$var$checkType;
function $be761f9ed995baa6$var$byteArrayBase(length) {
    length === undefined || module.exports.NonNegativeInteger.assert(length);
    const indefinite = (0, $5Au6L.InstanceOf)(Uint8Array);
    const literalConstraint = length !== undefined ? (0, $5Au6L.Literal)(length) : $5Au6L.Unknown;
    const definite = (0, $5Au6L.InstanceOf)(Uint8Array).And((0, $5Au6L.Object)({
        length: literalConstraint
    }));
    return length === undefined ? indefinite : definite;
}
const $be761f9ed995baa6$var$byteArrayStatic = {
    equal (lhs, rhs) {
        const length = lhs.length;
        if (length !== rhs.length) return false;
        for(let i = 0; i < length; i++){
            if (lhs[i] !== rhs[i]) return false;
        }
        return true;
    }
};
const $be761f9ed995baa6$var$byteArray = Object.assign($be761f9ed995baa6$var$byteArrayBase, $be761f9ed995baa6$var$byteArrayStatic);
module.exports.ByteArray = $be761f9ed995baa6$var$byteArray;
function $be761f9ed995baa6$var$bigEndianIntegerBase(length) {
    return (0, module.exports.ByteArray)(length);
}
const $be761f9ed995baa6$var$bigEndianIntegerStatic = {
    isHigh: (x)=>(x[0] & 0x80) !== 0,
    isOdd: (x)=>(x[x.length - 1] & 1) === 1
};
const $be761f9ed995baa6$var$bigEndianInteger = Object.assign($be761f9ed995baa6$var$bigEndianIntegerBase, module.exports.ByteArray, $be761f9ed995baa6$var$bigEndianIntegerStatic);
module.exports.BigEndianInteger = $be761f9ed995baa6$var$bigEndianInteger;
function $be761f9ed995baa6$var$safeBufferFrom(input) {
    if ($be761f9ed995baa6$require$Buffer.isBuffer(input)) return input;
    input = $be761f9ed995baa6$var$checkType((0, module.exports.ByteArray)(), input);
    return $be761f9ed995baa6$require$Buffer.alloc(input.byteLength).fill(input);
}
module.exports.safeBufferFrom = $be761f9ed995baa6$var$safeBufferFrom;

});
parcelRegister("5Au6L", function(module, exports) {

$parcel$export(module.exports, "Union", function () { return $7110991f3bef45d6$export$6cbb4f8fa0c4c986; });
$parcel$export(module.exports, "Contract", function () { return $7110991f3bef45d6$export$8517d80acf00e19a; });
$parcel$export(module.exports, "Enum", function () { return $7110991f3bef45d6$export$deb82508dd66d288; });
$parcel$export(module.exports, "InstanceOf", function () { return $7110991f3bef45d6$export$1d815128988e5eda; });
$parcel$export(module.exports, "Literal", function () { return $7110991f3bef45d6$export$e175ae9e414693bc; });
$parcel$export(module.exports, "Object", function () { return $7110991f3bef45d6$export$164a3ab98abb171d; });
$parcel$export(module.exports, "Never", function () { return $7110991f3bef45d6$export$d662a44061419a04; });
$parcel$export(module.exports, "Unknown", function () { return $7110991f3bef45d6$export$c8e691818f5132e2; });
$parcel$export(module.exports, "Number", function () { return $7110991f3bef45d6$export$fffa67e515d04022; });
$parcel$export(module.exports, "String", function () { return $7110991f3bef45d6$export$89b8e0fa65f6a914; });
function $7110991f3bef45d6$var$isParsedValueRuntype(e) {
    return "tag" in e && "parsed" === e.tag;
}
function $7110991f3bef45d6$export$af73d895d50c43f(e, t) {
    return $7110991f3bef45d6$var$assertRuntype(e), $7110991f3bef45d6$var$create("parsed", {
        p: (r, n, a)=>((e, t, r)=>{
                if (!e.success) return e;
                if (!e.cycle) {
                    const n = t(e.value);
                    return n.success && r && $7110991f3bef45d6$var$innerGuard(r, n.value, $7110991f3bef45d6$var$createGuardVisitedState()) || n;
                }
                return $7110991f3bef45d6$var$innerMapValidationPlaceholder(Array.isArray(e.placeholder) ? [
                    ...e.placeholder
                ] : {
                    ...e.placeholder
                }, ()=>e.unwrap(), t, r);
            })(a(e, r), (e)=>t.parse(e), t.test),
        t (r, n) {
            return t.test ? n(t.test, r) : $7110991f3bef45d6$var$failure((t.name || `ParsedValue<${$7110991f3bef45d6$export$83b4e480aa048ead(e)}>`) + " does not support Runtype.test");
        },
        s (r, n, a) {
            if (!t.serialize) return $7110991f3bef45d6$var$failure((t.name || `ParsedValue<${$7110991f3bef45d6$export$83b4e480aa048ead(e)}>`) + " does not support Runtype.serialize");
            const s = t.test ? $7110991f3bef45d6$var$innerGuard(t.test, r, $7110991f3bef45d6$var$createGuardVisitedState()) : void 0;
            if (s) return s;
            const i = t.serialize(r);
            return i.success ? a(e, i.value) : i;
        }
    }, {
        underlying: e,
        config: t,
        show () {
            return t.name || `ParsedValue<${$7110991f3bef45d6$export$83b4e480aa048ead(e, !1)}>`;
        }
    });
}
function $7110991f3bef45d6$var$assertRuntype(...e) {
    for (const r of e)if (!r || !r[$7110991f3bef45d6$var$t]) throw new Error("Expected Runtype but got " + $7110991f3bef45d6$export$4dffb421cfcec105(r));
}
function $7110991f3bef45d6$var$create(e, r, n) {
    function safeParse(e) {
        return $7110991f3bef45d6$var$innerValidate(a, e, $7110991f3bef45d6$var$createVisitedState());
    }
    function safeSerialize(e) {
        return $7110991f3bef45d6$var$innerSerialize(a, e, $7110991f3bef45d6$var$createVisitedState());
    }
    const a = {
        ...n,
        tag: e,
        assert (e) {
            const t = $7110991f3bef45d6$var$innerGuard(a, e, $7110991f3bef45d6$var$createGuardVisitedState());
            if (t) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(t);
        },
        parse (e) {
            const t = safeParse(e);
            if (!t.success) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(t);
            return t.value;
        },
        safeParse: safeParse,
        test: (e)=>void 0 === $7110991f3bef45d6$var$innerGuard(a, e, $7110991f3bef45d6$var$createGuardVisitedState()),
        serialize (e) {
            const t = safeSerialize(e);
            if (!t.success) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(t);
            return t.value;
        },
        safeSerialize: safeSerialize,
        Or: (e)=>$7110991f3bef45d6$export$6cbb4f8fa0c4c986(a, e),
        And: (e)=>$7110991f3bef45d6$export$56a6b724e0c8deeb(a, e),
        withConstraint: (e, t)=>$7110991f3bef45d6$export$aec1359a0a40a615(a, e, t),
        withGuard: (e, t)=>$7110991f3bef45d6$export$aec1359a0a40a615(a, e, t),
        withBrand: (e)=>$7110991f3bef45d6$export$75d5b518c51e7fd6(e, a),
        withParser: (e)=>$7110991f3bef45d6$export$af73d895d50c43f(a, e),
        toString: ()=>`Runtype<${$7110991f3bef45d6$export$83b4e480aa048ead(a)}>`,
        [$7110991f3bef45d6$var$t]: "function" == typeof r ? {
            p: r
        } : r
    };
    return a;
}
function $7110991f3bef45d6$var$createValidationPlaceholder(e, t) {
    return $7110991f3bef45d6$var$innerMapValidationPlaceholder(e, ()=>t(e) || $7110991f3bef45d6$var$success(e));
}
function $7110991f3bef45d6$var$innerMapValidationPlaceholder(e, t, r, n) {
    let a, s = !1;
    const i = {
        success: !0,
        cycle: !0,
        placeholder: e,
        unwrap () {
            if (a) return s = !0, a;
            a = $7110991f3bef45d6$var$success(e);
            const o = t(), u = o.success && r ? r(o.value) : o;
            if (!u.success) return a = u;
            if (s) {
                const e = ((e, t)=>e === t ? $7110991f3bef45d6$var$success(t) : Array.isArray(e) && Array.isArray(t) ? (e.splice(0, e.length, ...t), $7110991f3bef45d6$var$success(e)) : e && "object" == typeof e && !Array.isArray(e) && t && "object" == typeof t && !Array.isArray(t) ? (Object.assign(e, t), $7110991f3bef45d6$var$success(e)) : $7110991f3bef45d6$var$failure(`Cannot convert a value of type "${Array.isArray(e) ? "Array" : typeof e}" into a value of type "${null === t ? "null" : Array.isArray(t) ? "Array" : typeof t}" when it contains cycles.`))(a.value, u.value), t = e.success && n && $7110991f3bef45d6$var$innerGuard(n, e.value, $7110991f3bef45d6$var$createGuardVisitedState());
                a = t || e;
            } else {
                const e = n && $7110991f3bef45d6$var$innerGuard(n, u.value, $7110991f3bef45d6$var$createGuardVisitedState());
                a = e || u;
            }
            return a.success && (i.placeholder = a.value), a;
        }
    };
    return i;
}
function $7110991f3bef45d6$var$createVisitedState() {
    return new Map();
}
function $7110991f3bef45d6$var$createGuardVisitedState() {
    return new Map();
}
function $7110991f3bef45d6$var$innerValidate(e, t, r) {
    const n = $7110991f3bef45d6$var$innerValidateToPlaceholder(e, t, r);
    return n.cycle ? n.unwrap() : n;
}
function $7110991f3bef45d6$var$innerValidateToPlaceholder(e, r, n) {
    var a;
    const s = n, i = e[$7110991f3bef45d6$var$t], o = null === (a = s.get(e)) || void 0 === a ? void 0 : a.get(r);
    if (void 0 !== o) return o;
    const u = i.p(r, (e, t)=>$7110991f3bef45d6$var$innerValidate(e, t, n), (e, t)=>$7110991f3bef45d6$var$innerValidateToPlaceholder(e, t, n));
    return u.cycle ? (s.set(e, (s.get(e) || new Map()).set(r, u)), u) : u;
}
function $7110991f3bef45d6$var$innerSerialize(e, t, r) {
    const n = $7110991f3bef45d6$var$innerSerializeToPlaceholder(e, t, r);
    return n.cycle ? n.unwrap() : n;
}
function $7110991f3bef45d6$var$innerSerializeToPlaceholder(e, r, n) {
    var a;
    const s = n, i = e[$7110991f3bef45d6$var$t], o = null === (a = s.get(e)) || void 0 === a ? void 0 : a.get(r);
    if (void 0 !== o) return o;
    let u = (i.s || i.p)(r, (e, t)=>$7110991f3bef45d6$var$innerSerialize(e, t, n), (e, t)=>$7110991f3bef45d6$var$innerSerializeToPlaceholder(e, t, n));
    return u.cycle ? (s.set(e, (s.get(e) || new Map()).set(r, u)), u) : u;
}
function $7110991f3bef45d6$var$innerGuard(e, r, n) {
    var a;
    const s = n, i = e[$7110991f3bef45d6$var$t];
    if (r && ("object" == typeof r || "function" == typeof r)) {
        if (null === (a = s.get(e)) || void 0 === a ? void 0 : a.has(r)) return;
        s.set(e, (s.get(e) || new Set()).add(r));
    }
    if (i.t) return i.t(r, (e, t)=>$7110991f3bef45d6$var$innerGuard(e, t, n));
    let o = i.p(r, (e, t)=>$7110991f3bef45d6$var$innerGuard(e, t, n) || $7110991f3bef45d6$var$success(t), (e, t)=>$7110991f3bef45d6$var$innerGuard(e, t, n) || $7110991f3bef45d6$var$success(t));
    return o.cycle && (o = o.unwrap()), o.success ? void 0 : o;
}
function $7110991f3bef45d6$export$4dffb421cfcec105(e, r = 3, n = 30) {
    switch(typeof e){
        case "bigint":
        case "boolean":
        case "number":
            return "" + e;
        case "string":
            return JSON.stringify(e);
        case "object":
            if (null === e) return "null";
            if (Array.isArray(e)) {
                if (0 === r || 0 === n) return "[Array]";
                {
                    let t = "[", a = 0;
                    for(a = 0; a < e.length && n > t.length; a++)0 !== a && (t += ", "), t += $7110991f3bef45d6$export$4dffb421cfcec105(e[a], r - 1, n - t.length);
                    return a < e.length && (t += " ... "), t += "]", t;
                }
            }
            if (((e)=>"object" == typeof e && null != e && $7110991f3bef45d6$var$t in e)(e)) return e.toString();
            if (0 === r) return "{Object}";
            {
                const t = Object.entries(e);
                let a = "{", s = 0;
                for(s = 0; s < t.length && n > a.length; s++){
                    0 !== s && (a += ", ");
                    const [e, i] = t[s];
                    a += `${/\s/.test(e) ? JSON.stringify(e) : e}: ${$7110991f3bef45d6$export$4dffb421cfcec105(i, r - 1, n - a.length)}`;
                }
                return s < t.length && (a += " ... "), a += "}", a;
            }
        case "function":
        case "symbol":
        case "undefined":
        default:
            return typeof e;
    }
}
function $7110991f3bef45d6$var$success(e) {
    return {
        success: !0,
        value: e
    };
}
function $7110991f3bef45d6$var$failure(e, t = {}) {
    return {
        success: !1,
        message: e,
        ...t
    };
}
function $7110991f3bef45d6$var$expected(e, t, r = {}) {
    return $7110991f3bef45d6$var$failure(`Expected ${"string" == typeof e ? e : $7110991f3bef45d6$export$83b4e480aa048ead(e)}, but was ${$7110991f3bef45d6$export$4dffb421cfcec105(t)}`, r);
}
function $7110991f3bef45d6$var$unableToAssign(e, t, ...r) {
    return [
        `Unable to assign ${$7110991f3bef45d6$export$4dffb421cfcec105(e)} to ${$7110991f3bef45d6$export$83b4e480aa048ead(t)}`,
        ...r.map($7110991f3bef45d6$var$toFullError)
    ];
}
function $7110991f3bef45d6$var$andError([e, ...t]) {
    return [
        `And ${e[0].toLocaleLowerCase()}${e.substr(1)}`,
        ...t
    ];
}
function $7110991f3bef45d6$var$typesAreNotCompatible(e, ...t) {
    return [
        `The types of ${e} are not compatible`,
        ...t.map($7110991f3bef45d6$var$toFullError)
    ];
}
function $7110991f3bef45d6$var$toFullError(e) {
    return "string" == typeof e ? [
        e
    ] : Array.isArray(e) ? e : $7110991f3bef45d6$var$toFullError(e.fullError || e.message);
}
function $7110991f3bef45d6$export$3879b24e8245693d(e) {
    return e.fullError ? $7110991f3bef45d6$var$showFullError(e.fullError) : e.key ? `${e.message} in ${e.key}` : e.message;
}
function $7110991f3bef45d6$var$showFullError([e, ...t], r = "") {
    return [
        `${r}${e}`,
        ...t.map((e)=>$7110991f3bef45d6$var$showFullError(e, r + "  "))
    ].join("\n");
}
function $7110991f3bef45d6$export$256666b33d6d5fb2(e, t) {
    return {
        enforce: (r)=>(...n)=>{
                if (n.length < e.length) return Promise.reject(new $7110991f3bef45d6$export$2191b9da168c6cf0({
                    message: `Expected ${e.length} arguments but only received ${n.length}`
                }));
                const a = $7110991f3bef45d6$var$createVisitedState();
                for(let t = 0; t < e.length; t++){
                    const r = $7110991f3bef45d6$var$innerValidate(e[t], n[t], a);
                    if (!r.success) return Promise.reject(new $7110991f3bef45d6$export$2191b9da168c6cf0(r));
                    n[t] = r.value;
                }
                const s = r(...n);
                return s instanceof Promise ? s.then((e)=>{
                    const r = $7110991f3bef45d6$var$innerGuard(t, e, $7110991f3bef45d6$var$createGuardVisitedState());
                    if (r) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(r);
                    return e;
                }) : Promise.reject(new $7110991f3bef45d6$export$2191b9da168c6cf0({
                    message: "Expected function to return a promise, but instead got " + s
                }));
            }
    };
}
function $7110991f3bef45d6$export$8517d80acf00e19a(e, t) {
    return {
        enforce: (r)=>(...n)=>{
                if (n.length < e.length) throw new $7110991f3bef45d6$export$2191b9da168c6cf0({
                    message: `Expected ${e.length} arguments but only received ${n.length}`
                });
                const a = $7110991f3bef45d6$var$createVisitedState();
                for(let t = 0; t < e.length; t++){
                    const r = $7110991f3bef45d6$var$innerValidate(e[t], n[t], a);
                    if (!r.success) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(r);
                    n[t] = r.value;
                }
                const s = r(...n), i = $7110991f3bef45d6$var$innerGuard(t, s, $7110991f3bef45d6$var$createGuardVisitedState());
                if (i) throw new $7110991f3bef45d6$export$2191b9da168c6cf0(i);
                return s;
            }
    };
}
function $7110991f3bef45d6$export$804de46662e4ac95(e, t) {
    e.assert(t);
}
function $7110991f3bef45d6$var$InternalArr(e, t) {
    $7110991f3bef45d6$var$assertRuntype(e);
    const r = $7110991f3bef45d6$var$create("array", (t, n)=>Array.isArray(t) ? $7110991f3bef45d6$var$createValidationPlaceholder([
            ...t
        ], (a)=>{
            let s, i = void 0;
            for(let o = 0; o < t.length; o++){
                const u = n(e, t[o]);
                u.success ? a[o] = u.value : (i || (i = $7110991f3bef45d6$var$unableToAssign(t, r)), i.push($7110991f3bef45d6$var$typesAreNotCompatible(`[${o}]`, u)), s = s || $7110991f3bef45d6$var$failure(u.message, {
                    key: u.key ? `[${o}].${u.key}` : `[${o}]`,
                    fullError: i
                }));
            }
            return s;
        }) : $7110991f3bef45d6$var$expected("an Array", t), {
        isReadonly: t,
        element: e,
        show () {
            return `${t ? "readonly " : ""}${$7110991f3bef45d6$export$83b4e480aa048ead(e, !0)}[]`;
        }
    });
    return t || (r.asReadonly = ()=>$7110991f3bef45d6$var$InternalArr(e, !0)), r;
}
function $7110991f3bef45d6$export$c4be6576ca6fe4aa(e) {
    return $7110991f3bef45d6$var$InternalArr(e, !1);
}
function $7110991f3bef45d6$export$86044ad13c101648(e) {
    return $7110991f3bef45d6$var$InternalArr(e, !0);
}
function $7110991f3bef45d6$export$aec1359a0a40a615(e, t, r) {
    $7110991f3bef45d6$var$assertRuntype(e);
    const n = $7110991f3bef45d6$var$create("constraint", (a, s)=>{
        const i = r && r.name, o = s(e, a);
        if (!o.success) return o;
        const u = t(o.value);
        if (!u || "string" == typeof u) {
            const e = "string" == typeof u ? u : `${$7110991f3bef45d6$export$4dffb421cfcec105(a)} failed ${i || "constraint"} check`;
            return $7110991f3bef45d6$var$failure(e, {
                fullError: $7110991f3bef45d6$var$unableToAssign(a, n, e)
            });
        }
        return $7110991f3bef45d6$var$success(o.value);
    }, {
        underlying: e,
        constraint: t,
        name: r && r.name,
        args: r && r.args,
        show (t) {
            return r && r.name || `WithConstraint<${$7110991f3bef45d6$export$83b4e480aa048ead(e, t)}>`;
        }
    });
    return n;
}
function $7110991f3bef45d6$export$deb82508dd66d288(e, t) {
    const r = Object.values(t), n = new Set(r.some((e)=>"number" == typeof e) ? r.filter((e)=>"number" == typeof e) : r);
    return $7110991f3bef45d6$var$create("enum", (t)=>n.has(t) ? $7110991f3bef45d6$var$success(t) : $7110991f3bef45d6$var$expected(e, t), {
        enumObject: t,
        show: ()=>e
    });
}
function $7110991f3bef45d6$export$1d815128988e5eda(e) {
    return $7110991f3bef45d6$var$create("instanceof", (t)=>t instanceof e ? $7110991f3bef45d6$var$success(t) : $7110991f3bef45d6$var$expected("" + e.name, t), {
        ctor: e,
        show () {
            return `InstanceOf<${e.name}>`;
        }
    });
}
function $7110991f3bef45d6$export$56a6b724e0c8deeb(...e) {
    return $7110991f3bef45d6$var$assertRuntype(...e), $7110991f3bef45d6$var$create("intersect", (t, r)=>{
        if (Array.isArray(t)) return $7110991f3bef45d6$var$createValidationPlaceholder([
            ...t
        ], (t)=>{
            for (const n of e){
                let e = r(n, t);
                if (!e.success) return e;
                if (!Array.isArray(e.value)) return $7110991f3bef45d6$var$failure(`The validator ${$7110991f3bef45d6$export$83b4e480aa048ead(n)} attempted to convert the type of this value from an array to something else. That conversion is not valid as the child of an intersect`);
                t.splice(0, t.length, ...e.value);
            }
        });
        if (t && "object" == typeof t) return $7110991f3bef45d6$var$createValidationPlaceholder({}, (n)=>{
            for (const a of e){
                let e = r(a, t);
                if (!e.success) return e;
                if (!e.value || "object" != typeof e.value) return $7110991f3bef45d6$var$failure(`The validator ${$7110991f3bef45d6$export$83b4e480aa048ead(a)} attempted to convert the type of this value from an object to something else. That conversion is not valid as the child of an intersect`);
                Object.assign(n, e.value);
            }
        });
        let n = t;
        for (const t of e){
            let e = r(t, n);
            if (!e.success) return e;
            n = e.value;
        }
        return $7110991f3bef45d6$var$success(n);
    }, {
        intersectees: e,
        show (t) {
            return $7110991f3bef45d6$var$parenthesize("" + e.map((e)=>$7110991f3bef45d6$export$83b4e480aa048ead(e, !0)).join(" & "), t);
        }
    });
}
function $7110991f3bef45d6$var$lazyValue(e) {
    let t;
    return ()=>t || (t = e());
}
function $7110991f3bef45d6$export$b624eff549462981(e) {
    const t = $7110991f3bef45d6$var$lazyValue(e);
    return $7110991f3bef45d6$var$create("lazy", (e, r, n)=>n(t(), e), {
        underlying: t,
        show (e) {
            return $7110991f3bef45d6$export$83b4e480aa048ead(t(), e);
        }
    });
}
function $7110991f3bef45d6$var$isLiteralRuntype(e) {
    return "tag" in e && "literal" === e.tag;
}
function $7110991f3bef45d6$export$e175ae9e414693bc(e) {
    return $7110991f3bef45d6$var$create("literal", (t)=>t === e ? $7110991f3bef45d6$var$success(t) : $7110991f3bef45d6$var$failure(`Expected literal ${$7110991f3bef45d6$export$4dffb421cfcec105(e)}, but was ${$7110991f3bef45d6$export$4dffb421cfcec105(t)}${typeof t != typeof e ? ` (i.e. a ${typeof t})` : ""}`), {
        value: e,
        show () {
            return $7110991f3bef45d6$export$4dffb421cfcec105(e);
        }
    });
}
function $7110991f3bef45d6$var$hasKey(e, t) {
    return "object" == typeof t && e in t;
}
function $7110991f3bef45d6$var$isObjectRuntype(e) {
    return "tag" in e && "object" === e.tag;
}
function $7110991f3bef45d6$var$InternalObject(e, t, r) {
    $7110991f3bef45d6$var$assertRuntype(...Object.values(e));
    const n = $7110991f3bef45d6$var$create("object", (r, a)=>null == r || "object" != typeof r ? $7110991f3bef45d6$var$expected(n, r) : Array.isArray(r) ? $7110991f3bef45d6$var$failure(`Expected ${$7110991f3bef45d6$export$83b4e480aa048ead(n)}, but was an Array`) : $7110991f3bef45d6$var$createValidationPlaceholder({}, (s)=>{
            let i, o = void 0;
            for(const u in e)if (!t || $7110991f3bef45d6$var$hasKey(u, r) && void 0 !== r[u]) {
                const l = t || $7110991f3bef45d6$var$hasKey(u, r) ? r[u] : void 0;
                let c = a(e[u], l);
                c.success ? s[u] = c.value : (o || (o = $7110991f3bef45d6$var$unableToAssign(r, n)), o.push($7110991f3bef45d6$var$typesAreNotCompatible(`"${u}"`, c)), i = i || $7110991f3bef45d6$var$failure(c.message, {
                    key: c.key ? `${u}.${c.key}` : u,
                    fullError: o
                }));
            }
            return i;
        }), {
        isPartial: t,
        isReadonly: r,
        fields: e,
        asPartial: ()=>$7110991f3bef45d6$var$InternalObject(n.fields, !0, n.isReadonly),
        asReadonly: ()=>$7110991f3bef45d6$var$InternalObject(n.fields, n.isPartial, !0),
        pick (...n) {
            const a = {};
            for (const t of n)a[t] = e[t];
            return $7110991f3bef45d6$var$InternalObject(a, t, r);
        },
        omit (...n) {
            const a = {
                ...e
            };
            for (const e of n)e in a && delete a[e];
            return $7110991f3bef45d6$var$InternalObject(a, t, r);
        },
        show () {
            const n = Object.keys(e);
            return n.length ? `{ ${n.map((n)=>`${r ? "readonly " : ""}${n}${t ? "?" : ""}: ${$7110991f3bef45d6$export$83b4e480aa048ead(e[n], !1)};`).join(" ")} }` : "{}";
        }
    });
    return n;
}
function $7110991f3bef45d6$export$164a3ab98abb171d(e) {
    return $7110991f3bef45d6$var$InternalObject(e, !1, !1);
}
function $7110991f3bef45d6$export$bedb1bc9b1d8735f(e) {
    return $7110991f3bef45d6$var$InternalObject(e, !0, !1);
}
function $7110991f3bef45d6$var$createPrimative(e) {
    return $7110991f3bef45d6$var$create(e, (t)=>typeof t === e ? $7110991f3bef45d6$var$success(t) : $7110991f3bef45d6$var$failure(`Expected ${e}, but was ${((e)=>`${$7110991f3bef45d6$export$4dffb421cfcec105(e)}${"string" == typeof e ? " (i.e. a string literal)" : ""}`)(t)}`), {});
}
function $7110991f3bef45d6$var$getExpectedBaseType(e) {
    switch(e.tag){
        case "string":
            return "string";
        case "number":
            return "number";
        case "literal":
            return typeof e.value;
        case "union":
            const t = e.alternatives.map($7110991f3bef45d6$var$getExpectedBaseType);
            return t.reduce((e, t)=>e === t ? e : "mixed", t[0]);
        case "constraint":
            return $7110991f3bef45d6$var$getExpectedBaseType(e.underlying);
    }
}
function $7110991f3bef45d6$export$5b163c6d120341e7(e, t) {
    $7110991f3bef45d6$var$assertRuntype(e, t);
    const r = $7110991f3bef45d6$var$lazyValue(()=>$7110991f3bef45d6$var$getExpectedBaseType(e)), n = $7110991f3bef45d6$var$create("record", (a, s)=>null == a || "object" != typeof a ? $7110991f3bef45d6$var$expected(n, a) : Object.getPrototypeOf(a) !== Object.prototype ? Array.isArray(a) ? $7110991f3bef45d6$var$failure("Expected Record, but was Array") : $7110991f3bef45d6$var$failure(`Expected ${$7110991f3bef45d6$export$83b4e480aa048ead(n)}, but was ${Object.getPrototypeOf(a)}`) : $7110991f3bef45d6$var$createValidationPlaceholder({}, (n)=>{
            for(const i in a){
                let o = null;
                if ("number" === r()) {
                    if (isNaN(+i)) return $7110991f3bef45d6$var$expected("record key to be a number", i);
                    o = s(e, +i);
                } else "string" === r() ? o = s(e, i) : (o = s(e, i), o.success || isNaN(+i) || (o = s(e, +i)));
                if (!o.success) return $7110991f3bef45d6$var$expected("record key to be " + $7110991f3bef45d6$export$83b4e480aa048ead(e), i);
                const u = s(t, a[i]);
                if (!u.success) return $7110991f3bef45d6$var$failure(u.message, {
                    key: u.key ? `${i}.${u.key}` : i
                });
                n[o.value] = u.value;
            }
        }), {
        key: e,
        value: t,
        show () {
            return `{ [_: ${$7110991f3bef45d6$export$83b4e480aa048ead(e, !1)}]: ${$7110991f3bef45d6$export$83b4e480aa048ead(t, !1)} }`;
        }
    });
    return n;
}
function $7110991f3bef45d6$var$isTupleRuntype(e) {
    return "tag" in e && "tuple" === e.tag;
}
function $7110991f3bef45d6$export$1908877435b1d5e9(...e) {
    $7110991f3bef45d6$var$assertRuntype(...e);
    const t = $7110991f3bef45d6$var$create("tuple", (r, n)=>Array.isArray(r) ? r.length !== e.length ? $7110991f3bef45d6$var$expected("an array of length " + e.length, r.length) : $7110991f3bef45d6$var$createValidationPlaceholder([
            ...r
        ], (a)=>{
            let s, i = void 0;
            for(let o = 0; o < e.length; o++){
                let u = n(e[o], r[o]);
                u.success ? a[o] = u.value : (i || (i = $7110991f3bef45d6$var$unableToAssign(r, t)), i.push($7110991f3bef45d6$var$typesAreNotCompatible(`[${o}]`, u)), s = s || $7110991f3bef45d6$var$failure(u.message, {
                    key: u.key ? `[${o}].${u.key}` : `[${o}]`,
                    fullError: i
                }));
            }
            return s;
        }) : $7110991f3bef45d6$var$expected("tuple to be an array", r), {
        components: e,
        show () {
            return `[${e.map((e)=>$7110991f3bef45d6$export$83b4e480aa048ead(e, !1)).join(", ")}]`;
        }
    });
    return t;
}
function $7110991f3bef45d6$export$75d5b518c51e7fd6(e, t) {
    return $7110991f3bef45d6$var$assertRuntype(t), $7110991f3bef45d6$var$create("brand", (e, r, n)=>n(t, e), {
        brand: e,
        entity: t,
        show (e) {
            return $7110991f3bef45d6$export$83b4e480aa048ead(t, e);
        }
    });
}
function $7110991f3bef45d6$var$resolveUnderlyingType(e, t) {
    return ((e)=>"tag" in e && "lazy" === e.tag)(e) ? $7110991f3bef45d6$var$resolveUnderlyingType(e.underlying(), t) : ((e)=>"tag" in e && "brand" === e.tag)(e) ? $7110991f3bef45d6$var$resolveUnderlyingType(e.entity, t) : ((e)=>"tag" in e && "constraint" === e.tag)(e) || "p" === t && $7110991f3bef45d6$var$isParsedValueRuntype(e) ? $7110991f3bef45d6$var$resolveUnderlyingType(e.underlying, t) : "t" === t && $7110991f3bef45d6$var$isParsedValueRuntype(e) ? e.config.test ? $7110991f3bef45d6$var$resolveUnderlyingType(e.config.test, t) : $7110991f3bef45d6$export$d662a44061419a04 : "s" === t && $7110991f3bef45d6$var$isParsedValueRuntype(e) ? e.config.serialize ? e.config.test ? $7110991f3bef45d6$var$resolveUnderlyingType(e.config.test, t) : e : $7110991f3bef45d6$export$d662a44061419a04 : e;
}
function $7110991f3bef45d6$export$6cbb4f8fa0c4c986(...e) {
    function validateWithKey(e, t) {
        return (n, a)=>{
            if (!n || "object" != typeof n) return $7110991f3bef45d6$var$expected(r, n);
            const s = t.get(n[e]);
            if (s) {
                const t = a(s, n);
                return t.success ? t : $7110991f3bef45d6$var$failure(t.message, {
                    key: `<${0 === e ? "[0]" : e}: ${$7110991f3bef45d6$export$4dffb421cfcec105(n[e])}>${t.key ? "." + t.key : ""}`,
                    fullError: $7110991f3bef45d6$var$unableToAssign(n, r, t)
                });
            }
            {
                const a = $7110991f3bef45d6$var$expected(Array.from(t.keys()).map((e)=>"string" == typeof e ? `'${e}'` : e).join(" | "), n[e], {
                    key: 0 === e ? "[0]" : e
                });
                return a.fullError = $7110991f3bef45d6$var$unableToAssign(n, r, $7110991f3bef45d6$var$typesAreNotCompatible(0 === e ? "[0]" : `"${e}"`, a.message)), a;
            }
        };
    }
    $7110991f3bef45d6$var$assertRuntype(...e);
    const validatorOf = (t)=>{
        const n = e.filter((e)=>"never" !== $7110991f3bef45d6$var$resolveUnderlyingType(e, t).tag);
        if (n.length) {
            const e = n.map((e)=>$7110991f3bef45d6$var$resolveUnderlyingType(e, t)), r = e.filter($7110991f3bef45d6$var$isObjectRuntype);
            if (r.length === n.length) {
                const e = {};
                for(let a = 0; a < n.length; a++)for(const s in r[a].fields){
                    const i = $7110991f3bef45d6$var$resolveUnderlyingType(r[a].fields[s], t);
                    $7110991f3bef45d6$var$isLiteralRuntype(i) && (e[s] || (e[s] = new Map()), e[s].has(i.value) || e[s].set(i.value, n[a]));
                }
                for (const t of [
                    "type",
                    "kind",
                    "tag",
                    ...Object.keys(e)
                ])if (t in e && e[t].size === n.length) return validateWithKey(t, e[t]);
            }
            const a = e.filter($7110991f3bef45d6$var$isTupleRuntype);
            if (a.length === n.length) {
                const e = new Map();
                for(let r = 0; r < n.length; r++){
                    const s = $7110991f3bef45d6$var$resolveUnderlyingType(a[r].components[0], t);
                    $7110991f3bef45d6$var$isLiteralRuntype(s) && (e.has(s.value) || e.set(s.value, n[r]));
                }
                if (e.size === n.length) return validateWithKey(0, e);
            }
        }
        return (t, n)=>{
            let a, s, i, o = 0;
            for (const u of e){
                const e = n(u, t);
                if (e.success) return e;
                i ? i.push($7110991f3bef45d6$var$andError(e.fullError || $7110991f3bef45d6$var$unableToAssign(t, u, e))) : i = $7110991f3bef45d6$var$unableToAssign(t, r, e.fullError || $7110991f3bef45d6$var$unableToAssign(t, u, e)), e.key && (o++, a = e, s = u);
            }
            return a && s && 1 === o ? $7110991f3bef45d6$var$failure(a.message, {
                key: `<${$7110991f3bef45d6$export$83b4e480aa048ead(s)}>.${a.key}`,
                fullError: i
            }) : $7110991f3bef45d6$var$expected(r, t, {
                fullError: i
            });
        };
    }, t = $7110991f3bef45d6$var$lazyValue(()=>({
            p: validatorOf("p"),
            s: validatorOf("s"),
            t: validatorOf("t")
        })), r = $7110991f3bef45d6$var$create("union", {
        p: (e, r)=>t().p(e, r),
        s: (e, r)=>t().s(e, r),
        t (e, r) {
            const n = t().s(e, (e, t)=>r(e, t) || $7110991f3bef45d6$var$success(t));
            return n.success ? void 0 : n;
        }
    }, {
        alternatives: e,
        match: (...t)=>(n)=>{
                const a = $7110991f3bef45d6$var$createVisitedState();
                for(let r = 0; r < e.length; r++){
                    const s = $7110991f3bef45d6$var$innerValidate(e[r], n, a);
                    if (s.success) return t[r](s.value);
                }
                r.assert(n);
            },
        show (t) {
            return $7110991f3bef45d6$var$parenthesize("" + e.map((e)=>$7110991f3bef45d6$export$83b4e480aa048ead(e, !0)).join(" | "), t);
        }
    });
    return r;
}
const $7110991f3bef45d6$var$parenthesize = (e, t)=>t ? `(${e})` : e, $7110991f3bef45d6$var$e = new Set(), $7110991f3bef45d6$export$83b4e480aa048ead = (t, r = !1)=>{
    if ($7110991f3bef45d6$var$e.has(t) && "lazy" !== t.tag) return $7110991f3bef45d6$var$parenthesize("CIRCULAR " + t.tag, r);
    if (t.show) {
        $7110991f3bef45d6$var$e.add(t);
        try {
            return t.show(r);
        } finally{
            $7110991f3bef45d6$var$e.delete(t);
        }
    }
    return t.tag;
}, $7110991f3bef45d6$var$t = "__internal_runtype_methods__";
class $7110991f3bef45d6$export$2191b9da168c6cf0 extends Error {
    constructor(e){
        super($7110991f3bef45d6$export$3879b24e8245693d(e)), this.name = "ValidationError", this.shortMessage = e.message, this.key = e.key, this.fullError = e.fullError;
    }
}
const $7110991f3bef45d6$export$c8e691818f5132e2 = $7110991f3bef45d6$var$create("unknown", (e)=>$7110991f3bef45d6$var$success(e), {}), $7110991f3bef45d6$export$aaedb44a0fd0f42b = (e, t)=>$7110991f3bef45d6$export$c8e691818f5132e2.withGuard(e, t), $7110991f3bef45d6$export$3bac393b8225adab = $7110991f3bef45d6$export$e175ae9e414693bc(void 0), $7110991f3bef45d6$export$26c9c3a80cd996ae = $7110991f3bef45d6$export$e175ae9e414693bc(null), $7110991f3bef45d6$export$d662a44061419a04 = $7110991f3bef45d6$var$create("never", (e)=>$7110991f3bef45d6$var$expected("nothing", e), {}), $7110991f3bef45d6$export$f9e6d957cb90bdc0 = $7110991f3bef45d6$var$createPrimative("boolean"), $7110991f3bef45d6$export$f3890eeaf6851387 = $7110991f3bef45d6$var$createPrimative("function"), $7110991f3bef45d6$export$fffa67e515d04022 = $7110991f3bef45d6$var$createPrimative("number"), $7110991f3bef45d6$export$89b8e0fa65f6a914 = $7110991f3bef45d6$var$createPrimative("string"), $7110991f3bef45d6$export$3e25e887b7a5b37b = $7110991f3bef45d6$var$createPrimative("symbol");

});



parcelRegister("6uZnH", function(module, exports) {
"use strict";
var $4bb5287213bdd2dc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4bb5287213bdd2dc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4bb5287213bdd2dc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4bb5287213bdd2dc$var$__createBinding(result, mod, k);
    }
    $4bb5287213bdd2dc$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nodeSupportsECDH = void 0;

const $4bb5287213bdd2dc$var$core = $4bb5287213bdd2dc$var$__importStar((parcelRequire("lFpDy")));
function $4bb5287213bdd2dc$var$nodeSupportsECDH(x) {
    return $4bb5287213bdd2dc$var$core.isIndexable(x) && "ecdh" in x && typeof x.ecdh === "function";
}
module.exports.nodeSupportsECDH = $4bb5287213bdd2dc$var$nodeSupportsECDH;

});


parcelRegister("2Q5oV", function(module, exports) {
"use strict";
var $2114a0a71a941137$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2114a0a71a941137$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2114a0a71a941137$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$2114a0a71a941137$var$__exportStar((parcelRequire("ivnJA")), module.exports);

});
parcelRegister("ivnJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});


parcelRegister("bkHrJ", function(module, exports) {
"use strict";
var $84034384c0e96c3b$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $84034384c0e96c3b$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $84034384c0e96c3b$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$84034384c0e96c3b$var$__exportStar((parcelRequire("hBLUP")), module.exports);

$84034384c0e96c3b$var$__exportStar((parcelRequire("g8sqv")), module.exports);

});
parcelRegister("hBLUP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Digest = module.exports.Algorithms = module.exports.AlgorithmName = void 0;

var $5Au6L = parcelRequire("5Au6L");

var $glOWu = parcelRequire("glOWu");

var $glOWu = parcelRequire("glOWu");

var $g8sqv = parcelRequire("g8sqv");
// These names come from the keys on the AlgorithmLength object. We'd prefer not
// to repeat them here, which means we have to build the Enum object in a way that
// type inference can't follow. Luckily, because the names are statically known,
// we can assert the type even though it can't be inferred.
function $cd1b0f65aff45234$var$algorithmNameBase(length) {
    return (0, $5Au6L.Enum)(`AlgorithmName(${length !== null && length !== void 0 ? length : ""})`, Object.entries($g8sqv.AlgorithmLength).filter((x)=>length === undefined || length === x[1]).map((x)=>x[0]).reduce((a, x)=>Object.assign(a, {
            [x]: x
        }), {}));
}
const $cd1b0f65aff45234$var$algorithmNameStatic = {
    forEach (callbackfn, thisarg) {
        Object.keys((0, module.exports.AlgorithmName)().enumObject).forEach(callbackfn, thisarg);
    }
};
const $cd1b0f65aff45234$var$algorithmName = Object.assign($cd1b0f65aff45234$var$algorithmNameBase, $cd1b0f65aff45234$var$algorithmNameBase(), $cd1b0f65aff45234$var$algorithmNameStatic);
module.exports.AlgorithmName = $cd1b0f65aff45234$var$algorithmName;
function $cd1b0f65aff45234$var$specificUnverifiedDigest(name) {
    return (0, $5Au6L.Object)({
        preimage: (0, $glOWu.ByteArray)(),
        algorithm: (0, $5Au6L.Literal)(name)
    }).And((0, $glOWu.ByteArray)($g8sqv.AlgorithmLength[name]));
}
function $cd1b0f65aff45234$var$unverifiedDigestBase(name) {
    if (name !== undefined) return $cd1b0f65aff45234$var$specificUnverifiedDigest(name);
    return Object.keys(module.exports.AlgorithmName.enumObject).reduce((a, x)=>{
        return a.Or($cd1b0f65aff45234$var$specificUnverifiedDigest(x));
    }, $5Au6L.Never);
}
const $cd1b0f65aff45234$var$unverifiedDigestStatic = {};
const $cd1b0f65aff45234$var$unverifiedDigest = Object.assign($cd1b0f65aff45234$var$unverifiedDigestBase, $glOWu.ByteArray, $cd1b0f65aff45234$var$unverifiedDigestStatic);
// We need the UnverifiedDigest type to enable us to build the Algorithm contract without
// trying to recursively verify verified verifications. That said, it's not exported; only
// actual algorithm functions we're wrapping should be able to use it.
const $cd1b0f65aff45234$var$UnverifiedDigest = $cd1b0f65aff45234$var$unverifiedDigest;
const $cd1b0f65aff45234$var$digestStatic = {};
// We use UnverifiedDigest instead of Digest in the contract because the result is implicitly trusted.
function $cd1b0f65aff45234$var$algorithmBase(name) {
    return (0, $5Au6L.Contract)([
        (0, $glOWu.ByteArray)()
    ], $cd1b0f65aff45234$var$UnverifiedDigest(name));
}
const $cd1b0f65aff45234$var$algorithmStatic = {};
const $cd1b0f65aff45234$var$algorithm = Object.assign($cd1b0f65aff45234$var$algorithmBase, $cd1b0f65aff45234$var$algorithmStatic);
// This isn't exported; only the registration function below should be using it.
const $cd1b0f65aff45234$var$Algorithm = $cd1b0f65aff45234$var$algorithm;
module.exports.Algorithms = (()=>{
    const algorithms = {};
    (0, $g8sqv._initializeAlgorithms)((name, fn)=>{
        module.exports.AlgorithmName.assert(name);
        if (name in algorithms) throw new Error(`digest algorithm implementation already provided for ${name}`);
        algorithms[name] = $cd1b0f65aff45234$var$Algorithm(name).enforce((x)=>{
            const out = (0, $glOWu.checkType)((0, $glOWu.ByteArray)($g8sqv.AlgorithmLength[name]), fn(x));
            out.preimage = x;
            out.algorithm = name;
            return (0, $glOWu.checkType)($cd1b0f65aff45234$var$UnverifiedDigest(name), out);
        });
    });
    Object.freeze(algorithms);
    module.exports.AlgorithmName.forEach((x)=>{
        if (!algorithms[x]) throw new Error(`digest algorithm implementation missing for ${x}`);
    });
    return algorithms;
})();
function $cd1b0f65aff45234$var$digestBase(name) {
    return $cd1b0f65aff45234$var$UnverifiedDigest(name).withConstraint((x)=>$glOWu.ByteArray.equal(x, module.exports.Algorithms[x.algorithm](x.preimage)) || `expected ${x} to equal the ${x.algorithm} digest of ${x.preimage}`, {
        name: `Digest(${name})`
    });
}
const $cd1b0f65aff45234$var$digest = Object.assign($cd1b0f65aff45234$var$digestBase, $cd1b0f65aff45234$var$UnverifiedDigest, $cd1b0f65aff45234$var$digestStatic);
module.exports.Digest = $cd1b0f65aff45234$var$digest;

});
parcelRegister("g8sqv", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $bbf37195b2bb5df0$require$Buffer = $ihoyg.Buffer;
"use strict";
var $bbf37195b2bb5df0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._initializeAlgorithms = module.exports.fromWordArray = module.exports.toWordArray = module.exports.AlgorithmLength = void 0;

const $bbf37195b2bb5df0$var$crypto_js_1 = $bbf37195b2bb5df0$var$__importDefault((parcelRequire("kWcCv")));
module.exports.AlgorithmLength = {
    sha1: 20,
    ripemd160: 20,
    hash160: 20,
    sha256: 32,
    hash256: 32,
    keccak256: 32,
    sha512: 64
};
function $bbf37195b2bb5df0$var$toWordArray(x) {
    // TODO: avoid this conversion
    return $bbf37195b2bb5df0$var$crypto_js_1.default.enc.Hex.parse($bbf37195b2bb5df0$require$Buffer.from(x).toString("hex"));
// return (CryptoJS.lib.WordArray.create as unknown as (x: Uint8Array) => CryptoJS.lib.WordArray)(x);
}
module.exports.toWordArray = $bbf37195b2bb5df0$var$toWordArray;
function $bbf37195b2bb5df0$var$fromWordArray(x) {
    // TODO: avoid this conversion
    return $bbf37195b2bb5df0$require$Buffer.from($bbf37195b2bb5df0$var$crypto_js_1.default.enc.Hex.stringify(x), "hex");
// return Buffer.alloc(x.sigBytes).map((_, i) => (x.words[i >>> 2] >>> (32 - (((i + 1) & 0x03) << 3))) & 0xff);
}
module.exports.fromWordArray = $bbf37195b2bb5df0$var$fromWordArray;

function $bbf37195b2bb5df0$var$_initializeAlgorithms(register) {
    // Using an "any" return value overrides static type checking of the length of the digest. This
    // is OK because there's no ambiguity as to what it should be and it will be checked at runtime.
    try {
        // (Can't use a dynamic import here, because the return is needed synchronously; can't use a static import,
        // because we need to fall back tp CryptoJS in browsers)
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const crypto = (parcelRequire("aO8Ot"));
        register("sha1", (x)=>crypto.createHash("sha1").update(x).digest());
        register("ripemd160", (x)=>crypto.createHash("ripemd160").update(x).digest());
        register("hash160", (x)=>crypto.createHash("ripemd160").update(crypto.createHash("sha256").update(x).digest()).digest());
        register("sha256", (x)=>crypto.createHash("sha256").update(x).digest());
        register("hash256", (x)=>crypto.createHash("sha256").update(crypto.createHash("sha256").update(x).digest()).digest());
        // register("keccak256", (x): any => crypto.createHash("sha3-256").update(x).digest());
        register("keccak256", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA3($bbf37195b2bb5df0$var$toWordArray(x), {
                outputLength: 256
            })));
        register("sha512", (x)=>crypto.createHash("sha512").update(x).digest());
    } catch (_a) {
        register("sha1", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA1($bbf37195b2bb5df0$var$toWordArray(x))));
        register("ripemd160", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.RIPEMD160($bbf37195b2bb5df0$var$toWordArray(x))));
        register("hash160", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.RIPEMD160($bbf37195b2bb5df0$var$crypto_js_1.default.SHA256($bbf37195b2bb5df0$var$toWordArray(x)))));
        register("sha256", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA256($bbf37195b2bb5df0$var$toWordArray(x))));
        register("hash256", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA256($bbf37195b2bb5df0$var$crypto_js_1.default.SHA256($bbf37195b2bb5df0$var$toWordArray(x)))));
        register("keccak256", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA3($bbf37195b2bb5df0$var$toWordArray(x), {
                outputLength: 256
            })));
        register("sha512", (x)=>$bbf37195b2bb5df0$var$fromWordArray($bbf37195b2bb5df0$var$crypto_js_1.default.SHA512($bbf37195b2bb5df0$var$toWordArray(x))));
    }
}
module.exports._initializeAlgorithms = $bbf37195b2bb5df0$var$_initializeAlgorithms;

});



parcelRegister("feVdj", function(module, exports) {
"use strict";
var $b1848b45f2f4e675$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b1848b45f2f4e675$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b1848b45f2f4e675$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$b1848b45f2f4e675$var$__exportStar((parcelRequire("kdZHq")), module.exports);

$b1848b45f2f4e675$var$__exportStar((parcelRequire("avj1F")), module.exports);

});
parcelRegister("kdZHq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("avj1F", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $7a5b8ecb3343dbf6$require$Buffer = $ihoyg.Buffer;
"use strict";
var $7a5b8ecb3343dbf6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7a5b8ecb3343dbf6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7a5b8ecb3343dbf6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7a5b8ecb3343dbf6$var$__createBinding(result, mod, k);
    }
    $7a5b8ecb3343dbf6$var$__setModuleDefault(result, mod);
    return result;
};
var $7a5b8ecb3343dbf6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $7a5b8ecb3343dbf6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecoverableSignature = module.exports.Signature = module.exports.Message = module.exports.MessageWithPreimage = module.exports.RecoveryParam = module.exports.CurvePoint = module.exports.CompressedPoint = module.exports.UncompressedPoint = module.exports.FieldElement = void 0;

const $7a5b8ecb3343dbf6$var$core = $7a5b8ecb3343dbf6$var$__importStar((parcelRequire("lFpDy")));

var $5Au6L = parcelRequire("5Au6L");

const $7a5b8ecb3343dbf6$var$p_lazy_1 = $7a5b8ecb3343dbf6$var$__importDefault((parcelRequire("gGdnO")));

const $7a5b8ecb3343dbf6$var$tinyecc = $7a5b8ecb3343dbf6$var$__importStar((parcelRequire("bAAqK")));

var $glOWu = parcelRequire("glOWu");

const $7a5b8ecb3343dbf6$var$Digest = $7a5b8ecb3343dbf6$var$__importStar((parcelRequire("bkHrJ")));

const $7a5b8ecb3343dbf6$var$ethers = $7a5b8ecb3343dbf6$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return Promise.resolve((parcelRequire("2mRwW")));
    }).then((res)=>$7a5b8ecb3343dbf6$var$__importStar(res)));
const $7a5b8ecb3343dbf6$var$_fieldElementBase = (0, $glOWu.BigEndianInteger)(32).withConstraint((x)=>$7a5b8ecb3343dbf6$var$tinyecc.isPrivate((0, $glOWu.safeBufferFrom)(x)) || `expected ${x} to be within the order of the curve`, {
    name: "FieldElement"
});
const $7a5b8ecb3343dbf6$var$_fieldElementStatic = {};
const $7a5b8ecb3343dbf6$var$_fieldElement = Object.assign($7a5b8ecb3343dbf6$var$_fieldElementBase, $glOWu.BigEndianInteger, $7a5b8ecb3343dbf6$var$_fieldElementStatic);
module.exports.FieldElement = $7a5b8ecb3343dbf6$var$_fieldElement;
const $7a5b8ecb3343dbf6$var$_uncompressedPointBase = (0, $glOWu.ByteArray)(65).And((0, $5Au6L.Object)({
    0: (0, $5Au6L.Literal)(0x04)
})).withConstraint((p)=>module.exports.FieldElement.test(p.slice(1, 33)) || `expected ${p}.x to be within the order of the curve`, {
    name: "UncompressedPoint.x"
}).withConstraint((p)=>{
    if (!module.exports.FieldElement.test(p.slice(33, 65))) return `expected ${p}.y to be within the order of the curve`;
    const pBuf = $7a5b8ecb3343dbf6$require$Buffer.from(p);
    if (!$glOWu.ByteArray.equal($7a5b8ecb3343dbf6$var$tinyecc.pointCompress($7a5b8ecb3343dbf6$var$tinyecc.pointCompress(pBuf, true), false), pBuf)) return `expected ${p} to be on the curve`;
    return true;
}, {
    name: "UncompressedPoint.y"
});
const $7a5b8ecb3343dbf6$var$_compressedPointBase = (0, $glOWu.ByteArray)(33).And((0, $5Au6L.Object)({
    0: (0, $5Au6L.Literal)(0x02).Or((0, $5Au6L.Literal)(0x03))
})).withConstraint((p)=>module.exports.FieldElement.test(p.slice(1)) || `expected ${p}.x to be within the order of the curve`, {
    name: "CompressedPoint.x"
});
const $7a5b8ecb3343dbf6$var$_uncompressedPointStatic = {
    from: (p)=>{
        return p.length === 65 ? p : module.exports.UncompressedPoint.fromCompressed((0, $glOWu.checkType)(module.exports.CompressedPoint, p));
    },
    fromCompressed: (p)=>{
        return (0, $glOWu.checkType)(module.exports.UncompressedPoint, $7a5b8ecb3343dbf6$var$tinyecc.pointCompress($7a5b8ecb3343dbf6$require$Buffer.from(p), false));
    },
    x: (p)=>{
        return (0, $glOWu.checkType)(module.exports.FieldElement, p.slice(1, 33));
    },
    y: (p)=>{
        return (0, $glOWu.checkType)(module.exports.FieldElement, p.slice(33, 65));
    },
    yIsOdd: (p)=>{
        return module.exports.FieldElement.isOdd(module.exports.UncompressedPoint.y(p));
    }
};
const $7a5b8ecb3343dbf6$var$_uncompressedPoint = Object.assign($7a5b8ecb3343dbf6$var$_uncompressedPointBase, $glOWu.ByteArray, $7a5b8ecb3343dbf6$var$_uncompressedPointStatic);
module.exports.UncompressedPoint = $7a5b8ecb3343dbf6$var$_uncompressedPoint;
const $7a5b8ecb3343dbf6$var$_compressedPointStatic = {
    from: (p)=>{
        return p.length === 33 ? p : module.exports.CompressedPoint.fromUncompressed((0, $glOWu.checkType)(module.exports.UncompressedPoint, p));
    },
    fromUncompressed: (p)=>{
        const out = new Uint8Array(33);
        out[0] = module.exports.UncompressedPoint.yIsOdd(p) ? 0x03 : 0x02;
        out.set(module.exports.UncompressedPoint.x(p), 1);
        module.exports.CompressedPoint.assert(out);
        return out;
    },
    x: (p)=>{
        return (0, $glOWu.checkType)(module.exports.FieldElement, p.slice(1));
    },
    yIsOdd: (p)=>{
        return p[0] === 0x03;
    }
};
const $7a5b8ecb3343dbf6$var$_compressedPoint = Object.assign($7a5b8ecb3343dbf6$var$_compressedPointBase, $glOWu.ByteArray, $7a5b8ecb3343dbf6$var$_compressedPointStatic);
module.exports.CompressedPoint = $7a5b8ecb3343dbf6$var$_compressedPoint;
const $7a5b8ecb3343dbf6$var$_curvePointBase = module.exports.CompressedPoint.Or(module.exports.UncompressedPoint);
const $7a5b8ecb3343dbf6$var$_curvePointStatic = {
    x: (p)=>p[0] === 0x04 ? module.exports.UncompressedPoint.x(p) : module.exports.CompressedPoint.x(p),
    yIsOdd: (p)=>p[0] === 0x04 ? module.exports.UncompressedPoint.yIsOdd(p) : module.exports.CompressedPoint.yIsOdd(p),
    // Equivalent to CompressedPoint.equal(CompressedPoint.from(lhs), CompressedPoint.from(rhs)), but avoids allocations
    equal: (lhs, rhs)=>module.exports.CurvePoint.yIsOdd(lhs) === module.exports.CurvePoint.yIsOdd(rhs) && module.exports.FieldElement.equal(module.exports.CurvePoint.x(lhs), module.exports.CurvePoint.x(rhs))
};
const $7a5b8ecb3343dbf6$var$_curvePoint = Object.assign($7a5b8ecb3343dbf6$var$_curvePointBase, $7a5b8ecb3343dbf6$var$_curvePointStatic);
module.exports.CurvePoint = $7a5b8ecb3343dbf6$var$_curvePoint;
const $7a5b8ecb3343dbf6$var$_recoveryParamBase = (0, $5Au6L.Union)((0, $5Au6L.Literal)(0), (0, $5Au6L.Literal)(1), (0, $5Au6L.Literal)(2), (0, $5Au6L.Literal)(3));
const $7a5b8ecb3343dbf6$var$_recoveryParamStatic = {};
const $7a5b8ecb3343dbf6$var$_recoveryParam = Object.assign($7a5b8ecb3343dbf6$var$_recoveryParamBase, $7a5b8ecb3343dbf6$var$_recoveryParamStatic);
module.exports.RecoveryParam = $7a5b8ecb3343dbf6$var$_recoveryParam;
const $7a5b8ecb3343dbf6$var$_messageWithPreimageBase = (0, $glOWu.ByteArray)(32).And($7a5b8ecb3343dbf6$var$Digest.Digest());
const $7a5b8ecb3343dbf6$var$_messageWithPreimageStatic = {};
const $7a5b8ecb3343dbf6$var$_messageWithPreimage = Object.assign($7a5b8ecb3343dbf6$var$_messageWithPreimageBase, $glOWu.ByteArray, $7a5b8ecb3343dbf6$var$_messageWithPreimageStatic);
module.exports.MessageWithPreimage = $7a5b8ecb3343dbf6$var$_messageWithPreimage;
const $7a5b8ecb3343dbf6$var$_messageBase = module.exports.MessageWithPreimage.Or((0, $glOWu.ByteArray)());
const $7a5b8ecb3343dbf6$var$_messageStatic = {};
const $7a5b8ecb3343dbf6$var$_message = Object.assign($7a5b8ecb3343dbf6$var$_messageBase, $glOWu.ByteArray, $7a5b8ecb3343dbf6$var$_messageWithPreimageStatic, $7a5b8ecb3343dbf6$var$_messageStatic);
module.exports.Message = $7a5b8ecb3343dbf6$var$_message;
const $7a5b8ecb3343dbf6$var$_signatureBase = (0, $glOWu.ByteArray)(64).withConstraint((x)=>module.exports.FieldElement.test(x.slice(0, 32)) || `expected ${x}.r to be within the order of the curve`, {
    name: "Signature.r"
}).withConstraint((x)=>module.exports.FieldElement.test(x.slice(32, 64)) || `expected ${x}.s to be within the order of the curve`, {
    name: "Signature.s"
});
const $7a5b8ecb3343dbf6$var$_signatureStatic = {
    r: (x)=>{
        return (0, $glOWu.checkType)(module.exports.FieldElement, x.slice(0, 32));
    },
    s: (x)=>{
        return (0, $glOWu.checkType)(module.exports.FieldElement, x.slice(32, 64));
    },
    isLowR: (x)=>{
        return !module.exports.FieldElement.isHigh(module.exports.Signature.r(x));
    },
    isLowS: (x)=>{
        return !module.exports.FieldElement.isHigh(module.exports.Signature.s(x));
    },
    isCanonical: (x)=>{
        return module.exports.Signature.isLowR(x) && module.exports.Signature.isLowS(x);
    },
    signCanonically: (x, digestAlgorithm, message, counter)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
            (0, $glOWu.assertType)((0, $glOWu.ByteArray)(), message);
            counter === undefined || $glOWu.Uint32.assert(counter);
            for(let i = counter; i === undefined || i < (counter !== null && counter !== void 0 ? counter : 0) + 128; i = (i !== null && i !== void 0 ? i : -1) + 1){
                const sig = yield (()=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
                        if (digestAlgorithm === null) {
                            (0, $glOWu.assertType)((0, $glOWu.ByteArray)(32), message);
                            return i === undefined ? yield x.ecdsaSign(digestAlgorithm, message) : yield x.ecdsaSign(digestAlgorithm, message, i);
                        } else return i === undefined ? yield x.ecdsaSign(digestAlgorithm, message) : yield x.ecdsaSign(digestAlgorithm, message, i);
                    }))();
                if (sig === undefined) break;
                //TODO: do integrated lowS correction
                if (module.exports.Signature.isCanonical(sig)) return sig;
            }
            // This is cryptographically impossible (2^-128 chance) if the key is implemented correctly.
            throw new Error(`Unable to generate canonical signature with public key ${x} over message ${message}; is your key implementation broken?`);
        }),
    verify: (x, digestAlgorithm, message, publicKey)=>{
        const msgOrDigest = digestAlgorithm === null ? (0, $glOWu.checkType)((0, $glOWu.ByteArray)(32), message) : $7a5b8ecb3343dbf6$var$Digest.Algorithms[digestAlgorithm]((0, $glOWu.checkType)((0, $glOWu.ByteArray)(), message));
        return $7a5b8ecb3343dbf6$var$tinyecc.verify($7a5b8ecb3343dbf6$require$Buffer.from(msgOrDigest), $7a5b8ecb3343dbf6$require$Buffer.from(publicKey), $7a5b8ecb3343dbf6$require$Buffer.from(x));
    }
};
const $7a5b8ecb3343dbf6$var$_signature = Object.assign($7a5b8ecb3343dbf6$var$_signatureBase, $glOWu.ByteArray, $7a5b8ecb3343dbf6$var$_signatureStatic);
module.exports.Signature = $7a5b8ecb3343dbf6$var$_signature;
const $7a5b8ecb3343dbf6$var$_recoverableSignatureBase = (0, $glOWu.ByteArray)(65).And((0, $5Au6L.Object)({
    64: module.exports.RecoveryParam
})).withConstraint((x)=>module.exports.Signature.test(x.slice(0, 64)) || `expected ${x}.sig to be a valid signature`, {
    name: "Signature"
});
const $7a5b8ecb3343dbf6$var$_recoverableSignatureStatic = {
    from: (x, recoveryParam)=>{
        return (0, $glOWu.checkType)(module.exports.RecoverableSignature, $7a5b8ecb3343dbf6$var$core.compatibleBufferConcat([
            x,
            new Uint8Array([
                recoveryParam
            ])
        ]));
    },
    fromSignature: (x, digestAlgorithm, message, publicKey)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
            for(let recoveryParam = 0; recoveryParam < 4; recoveryParam++){
                const out = module.exports.RecoverableSignature.from(x, recoveryParam);
                if (!module.exports.CurvePoint.equal(publicKey, (yield module.exports.RecoverableSignature.recoverPublicKey(out, digestAlgorithm, message)))) continue;
                return out;
            }
            throw new Error(`couldn't find recovery parameter producing public key ${publicKey} for signature ${x} over message ${message}`);
        }),
    sig: (x)=>(0, $glOWu.checkType)(module.exports.Signature, x.slice(0, 64)),
    recoveryParam: (x)=>(0, $glOWu.checkType)(module.exports.RecoveryParam, x[64]),
    isLowRecoveryParam: (x)=>[
            0,
            1
        ].includes(module.exports.RecoverableSignature.recoveryParam(x)),
    isCanonical: (x)=>module.exports.Signature.isCanonical((0, $glOWu.checkType)(module.exports.Signature, module.exports.RecoverableSignature.sig(x))) && module.exports.RecoverableSignature.isLowRecoveryParam(x),
    signCanonically: (x, digestAlgorithm, message, counter)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
            const publicKey = yield x.getPublicKey();
            (0, $glOWu.assertType)((0, $glOWu.ByteArray)(), message);
            counter === undefined || $glOWu.Uint32.assert(counter);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const isIndexable = (x)=>x !== null && [
                    "object",
                    "function"
                ].includes(typeof x);
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const isECDSARecoverableKey = (x)=>isIndexable(x) && "ecdsaSignRecoverable" in x && typeof x.ecdsaSignRecoverable === "function";
            const ecdsaSignRecoverable = isECDSARecoverableKey(x) ? (digestAlgorithm, message, counter)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
                    if (digestAlgorithm === null) {
                        (0, $glOWu.assertType)((0, $glOWu.ByteArray)(32), message);
                        return counter === undefined ? yield x.ecdsaSignRecoverable(digestAlgorithm, message) : yield x.ecdsaSignRecoverable(digestAlgorithm, message, counter);
                    } else return counter === undefined ? yield x.ecdsaSignRecoverable(digestAlgorithm, message) : yield x.ecdsaSignRecoverable(digestAlgorithm, message, counter);
                }) : (digestAlgorithm, message, counter)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
                    const sig = yield module.exports.Signature.signCanonically(x, digestAlgorithm, message, counter);
                    if (sig === undefined) return undefined;
                    return yield module.exports.RecoverableSignature.fromSignature(sig, digestAlgorithm, message, publicKey);
                });
            // Technically, this may waste cycles; if Signature.signCanonically grinds the counter to find a canonical signature which then
            // ends up to have a non-canonical recovery parameter, those values will all be re-ground. However, signatures can have
            // non-canonical recovery parameters only with negligible probability, so optimization for that case would be silly.
            for(let i = counter; i === undefined || i < (counter !== null && counter !== void 0 ? counter : 0) + 128; i = (i !== null && i !== void 0 ? i : -1) + 1){
                const recoverableSig = yield ecdsaSignRecoverable(digestAlgorithm, message, i);
                if (recoverableSig === undefined) break;
                //TODO: do integrated lowS correction
                if (module.exports.RecoverableSignature.isCanonical(recoverableSig)) return recoverableSig;
            }
            // This is cryptographically impossible (2^-128 chance) if the key is implemented correctly.
            throw new Error(`Unable to generate canonical recoverable signature with public key ${$7a5b8ecb3343dbf6$require$Buffer.from(publicKey).toString("hex")} over message ${$7a5b8ecb3343dbf6$require$Buffer.from(message).toString("hex")}; is your key implementation broken?`);
        }),
    recoverPublicKey: (x, digestAlgorithm, message)=>$7a5b8ecb3343dbf6$var$__awaiter(void 0, void 0, void 0, function*() {
            // TODO: do this better
            const msgOrDigest = digestAlgorithm === null ? (0, $glOWu.checkType)((0, $glOWu.ByteArray)(32), message) : $7a5b8ecb3343dbf6$var$Digest.Algorithms[digestAlgorithm]((0, $glOWu.checkType)((0, $glOWu.ByteArray)(), message));
            const sig = module.exports.RecoverableSignature.sig(x);
            const recoveryParam = module.exports.RecoverableSignature.recoveryParam(x);
            const ethSig = $7a5b8ecb3343dbf6$var$core.compatibleBufferConcat([
                sig,
                $7a5b8ecb3343dbf6$require$Buffer.from([
                    recoveryParam
                ])
            ]);
            const ethRecovered = (yield $7a5b8ecb3343dbf6$var$ethers).utils.recoverPublicKey(msgOrDigest, (yield $7a5b8ecb3343dbf6$var$ethers).utils.splitSignature(ethSig));
            return (0, $glOWu.checkType)(module.exports.UncompressedPoint, $7a5b8ecb3343dbf6$require$Buffer.from(ethRecovered.slice(2), "hex"));
        }),
    r: (x)=>module.exports.Signature.r(module.exports.RecoverableSignature.sig(x)),
    s: (x)=>module.exports.Signature.s(module.exports.RecoverableSignature.sig(x)),
    isLowR: (x)=>module.exports.Signature.isLowR(module.exports.RecoverableSignature.sig(x)),
    isLowS: (x)=>module.exports.Signature.isLowS(module.exports.RecoverableSignature.sig(x)),
    verify: (x, digestAlgorithm, message, publicKey)=>{
        return module.exports.Signature.verify(module.exports.RecoverableSignature.sig(x), digestAlgorithm, message, publicKey);
    }
};
const $7a5b8ecb3343dbf6$var$_recoverableSignature = Object.assign($7a5b8ecb3343dbf6$var$_recoverableSignatureBase, $7a5b8ecb3343dbf6$var$_recoverableSignatureStatic);
module.exports.RecoverableSignature = $7a5b8ecb3343dbf6$var$_recoverableSignature;

});
parcelRegister("2mRwW", function(module, exports) {

$parcel$export(module.exports, "ethers", function () { return (parcelRequire("iuBCc")); });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("oWESm")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("hO0Ij")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("oWESm")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("9cgHG")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("9cgHG")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("chM19")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("chM19")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("chM19")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("esOfL")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("kA3tC")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("hhEgY")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("8bxC3")).ErrorCode; });
$parcel$export(module.exports, "logger", function () { return (parcelRequire("iuBCc")).logger; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("9L4c0")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("12owE")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("8UXwq")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("2BDj9")).Wordlist; });

var $iuBCc = parcelRequire("iuBCc");
var $oWESm = parcelRequire("oWESm");
var $hO0Ij = parcelRequire("hO0Ij");
var $9cgHG = parcelRequire("9cgHG");
var $chM19 = parcelRequire("chM19");
var $esOfL = parcelRequire("esOfL");
var $kA3tC = parcelRequire("kA3tC");
var $hhEgY = parcelRequire("hhEgY");
var $8bxC3 = parcelRequire("8bxC3");
var $9L4c0 = parcelRequire("9L4c0");
var $12owE = parcelRequire("12owE");
var $8UXwq = parcelRequire("8UXwq");
var $2BDj9 = parcelRequire("2BDj9");
"use strict";
try {
    const anyGlobal = window;
    if (anyGlobal._ethers == null) anyGlobal._ethers = $iuBCc;
} catch (error) {}

});
parcelRegister("iuBCc", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $d76834e42ece13f7$export$af88d00dbe7f521; });
$parcel$export(module.exports, "Signer", function () { return (parcelRequire("oWESm")).Signer; });
$parcel$export(module.exports, "Wallet", function () { return (parcelRequire("hO0Ij")).Wallet; });
$parcel$export(module.exports, "VoidSigner", function () { return (parcelRequire("oWESm")).VoidSigner; });
$parcel$export(module.exports, "getDefaultProvider", function () { return (parcelRequire("9cgHG")).getDefaultProvider; });
$parcel$export(module.exports, "providers", function () { return (parcelRequire("9cgHG")); });
$parcel$export(module.exports, "BaseContract", function () { return (parcelRequire("chM19")).BaseContract; });
$parcel$export(module.exports, "Contract", function () { return (parcelRequire("chM19")).Contract; });
$parcel$export(module.exports, "ContractFactory", function () { return (parcelRequire("chM19")).ContractFactory; });
$parcel$export(module.exports, "BigNumber", function () { return (parcelRequire("esOfL")).BigNumber; });
$parcel$export(module.exports, "FixedNumber", function () { return (parcelRequire("kA3tC")).FixedNumber; });
$parcel$export(module.exports, "constants", function () { return (parcelRequire("hhEgY")); });
$parcel$export(module.exports, "errors", function () { return (parcelRequire("8bxC3")).ErrorCode; });
$parcel$export(module.exports, "utils", function () { return (parcelRequire("9L4c0")); });
$parcel$export(module.exports, "wordlists", function () { return (parcelRequire("12owE")).wordlists; });
$parcel$export(module.exports, "version", function () { return (parcelRequire("8UXwq")).version; });
$parcel$export(module.exports, "Wordlist", function () { return (parcelRequire("2BDj9")).Wordlist; });

var $chM19 = parcelRequire("chM19");

var $esOfL = parcelRequire("esOfL");
var $kA3tC = parcelRequire("kA3tC");

var $oWESm = parcelRequire("oWESm");

var $hO0Ij = parcelRequire("hO0Ij");

var $hhEgY = parcelRequire("hhEgY");

var $9cgHG = parcelRequire("9cgHG");

var $2BDj9 = parcelRequire("2BDj9");
var $12owE = parcelRequire("12owE");

var $9L4c0 = parcelRequire("9L4c0");

var $8bxC3 = parcelRequire("8bxC3");

var $8UXwq = parcelRequire("8UXwq");
"use strict";
const $d76834e42ece13f7$export$af88d00dbe7f521 = new (0, $8bxC3.Logger)((0, $8UXwq.version));

});
parcelRegister("chM19", function(module, exports) {

$parcel$export(module.exports, "BaseContract", function () { return $8f1c51d58e4a2402$export$304faa4fc17528db; });
$parcel$export(module.exports, "Contract", function () { return $8f1c51d58e4a2402$export$8517d80acf00e19a; });
$parcel$export(module.exports, "ContractFactory", function () { return $8f1c51d58e4a2402$export$505569a6bf584fd9; });

var $5aOKN = parcelRequire("5aOKN");
var $h8t8t = parcelRequire("h8t8t");

var $dGRwz = parcelRequire("dGRwz");

var $oWESm = parcelRequire("oWESm");

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $aHFYU = parcelRequire("aHFYU");
"use strict";
var $8f1c51d58e4a2402$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $8f1c51d58e4a2402$var$logger = new (0, $8bxC3.Logger)((0, $aHFYU.version));
///////////////////////////////
const $8f1c51d58e4a2402$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    from: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true,
    customData: true,
    ccipReadEnabled: true
};
function $8f1c51d58e4a2402$var$resolveName(resolver, nameOrPromise) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        const name = yield nameOrPromise;
        if (typeof name !== "string") $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid address or ENS name", "name", name);
        // If it is already an address, just use it (after adding checksum)
        try {
            return (0, $7pv2A.getAddress)(name);
        } catch (error) {}
        if (!resolver) $8f1c51d58e4a2402$var$logger.throwError("a provider or signer is needed to resolve ENS names", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resolveName"
        });
        const address = yield resolver.resolveName(name);
        if (address == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("resolver or addr is not configured for ENS name", "name", name);
        return address;
    });
}
// Recursively replaces ENS names with promises to resolve the name and resolves all properties
function $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        if (Array.isArray(paramType)) return yield Promise.all(paramType.map((paramType, index)=>{
            return $8f1c51d58e4a2402$var$resolveAddresses(resolver, Array.isArray(value) ? value[index] : value[paramType.name], paramType);
        }));
        if (paramType.type === "address") return yield $8f1c51d58e4a2402$var$resolveName(resolver, value);
        if (paramType.type === "tuple") return yield $8f1c51d58e4a2402$var$resolveAddresses(resolver, value, paramType.components);
        if (paramType.baseType === "array") {
            if (!Array.isArray(value)) return Promise.reject($8f1c51d58e4a2402$var$logger.makeError("invalid value for array", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "value",
                value: value
            }));
            return yield Promise.all(value.map((v)=>$8f1c51d58e4a2402$var$resolveAddresses(resolver, v, paramType.arrayChildren)));
        }
        return value;
    });
}
function $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args) {
    return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
        // If an extra argument is given, it is overrides
        let overrides = {};
        if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") overrides = (0, $i6lOf.shallowCopy)(args.pop());
        // Make sure the parameter count matches
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, fragment.inputs.length, "passed to contract");
        // Populate "from" override (allow promises)
        if (contract.signer) {
            if (overrides.from) // Contracts with a Signer are from the Signer's frame-of-reference;
            // but we allow overriding "from" if it matches the signer
            overrides.from = (0, $i6lOf.resolveProperties)({
                override: $8f1c51d58e4a2402$var$resolveName(contract.signer, overrides.from),
                signer: contract.signer.getAddress()
            }).then((check)=>$8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
                    if ((0, $7pv2A.getAddress)(check.signer) !== check.override) $8f1c51d58e4a2402$var$logger.throwError("Contract with a Signer cannot override from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "overrides.from"
                    });
                    return check.override;
                }));
            else overrides.from = contract.signer.getAddress();
        } else if (overrides.from) overrides.from = $8f1c51d58e4a2402$var$resolveName(contract.provider, overrides.from);
        // Wait for all dependencies to be resolved (prefer the signer over the provider)
        const resolved = yield (0, $i6lOf.resolveProperties)({
            args: $8f1c51d58e4a2402$var$resolveAddresses(contract.signer || contract.provider, args, fragment.inputs),
            address: contract.resolvedAddress,
            overrides: (0, $i6lOf.resolveProperties)(overrides) || {}
        });
        // The ABI coded transaction
        const data = contract.interface.encodeFunctionData(fragment, resolved.args);
        const tx = {
            data: data,
            to: resolved.address
        };
        // Resolved Overrides
        const ro = resolved.overrides;
        // Populate simple overrides
        if (ro.nonce != null) tx.nonce = (0, $esOfL.BigNumber).from(ro.nonce).toNumber();
        if (ro.gasLimit != null) tx.gasLimit = (0, $esOfL.BigNumber).from(ro.gasLimit);
        if (ro.gasPrice != null) tx.gasPrice = (0, $esOfL.BigNumber).from(ro.gasPrice);
        if (ro.maxFeePerGas != null) tx.maxFeePerGas = (0, $esOfL.BigNumber).from(ro.maxFeePerGas);
        if (ro.maxPriorityFeePerGas != null) tx.maxPriorityFeePerGas = (0, $esOfL.BigNumber).from(ro.maxPriorityFeePerGas);
        if (ro.from != null) tx.from = ro.from;
        if (ro.type != null) tx.type = ro.type;
        if (ro.accessList != null) tx.accessList = (0, $5LK3h.accessListify)(ro.accessList);
        // If there was no "gasLimit" override, but the ABI specifies a default, use it
        if (tx.gasLimit == null && fragment.gas != null) {
            // Compute the intrinsic gas cost for this transaction
            // @TODO: This is based on the yellow paper as of Petersburg; this is something
            // we may wish to parameterize in v6 as part of the Network object. Since this
            // is always a non-nil to address, we can ignore G_create, but may wish to add
            // similar logic to the ContractFactory.
            let intrinsic = 21000;
            const bytes = (0, $ApLZa.arrayify)(data);
            for(let i = 0; i < bytes.length; i++){
                intrinsic += 4;
                if (bytes[i]) intrinsic += 64;
            }
            tx.gasLimit = (0, $esOfL.BigNumber).from(fragment.gas).add(intrinsic);
        }
        // Populate "value" override
        if (ro.value) {
            const roValue = (0, $esOfL.BigNumber).from(ro.value);
            if (!roValue.isZero() && !fragment.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable method cannot override value", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: overrides.value
            });
            tx.value = roValue;
        }
        if (ro.customData) tx.customData = (0, $i6lOf.shallowCopy)(ro.customData);
        if (ro.ccipReadEnabled) tx.ccipReadEnabled = !!ro.ccipReadEnabled;
        // Remove the overrides
        delete overrides.nonce;
        delete overrides.gasLimit;
        delete overrides.gasPrice;
        delete overrides.from;
        delete overrides.value;
        delete overrides.type;
        delete overrides.accessList;
        delete overrides.maxFeePerGas;
        delete overrides.maxPriorityFeePerGas;
        delete overrides.customData;
        delete overrides.ccipReadEnabled;
        // Make sure there are no stray overrides, which may indicate a
        // typo or using an unsupported key.
        const leftovers = Object.keys(overrides).filter((key)=>overrides[key] != null);
        if (leftovers.length) $8f1c51d58e4a2402$var$logger.throwError(`cannot override ${leftovers.map((l)=>JSON.stringify(l)).join(",")}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "overrides",
            overrides: leftovers
        });
        return tx;
    });
}
function $8f1c51d58e4a2402$var$buildPopulate(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
    };
}
function $8f1c51d58e4a2402$var$buildEstimate(contract, fragment) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!signerOrProvider) $8f1c51d58e4a2402$var$logger.throwError("estimate require a provider or signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "estimateGas"
            });
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            return yield signerOrProvider.estimateGas(tx);
        });
    };
}
function $8f1c51d58e4a2402$var$addContractWait(contract, tx) {
    const wait = tx.wait.bind(tx);
    tx.wait = (confirmations)=>{
        return wait(confirmations).then((receipt)=>{
            receipt.events = receipt.logs.map((log)=>{
                let event = (0, $i6lOf.deepCopy)(log);
                let parsed = null;
                try {
                    parsed = contract.interface.parseLog(log);
                } catch (e) {}
                // Successfully parsed the event log; include it
                if (parsed) {
                    event.args = parsed.args;
                    event.decode = (data, topics)=>{
                        return contract.interface.decodeEventLog(parsed.eventFragment, data, topics);
                    };
                    event.event = parsed.name;
                    event.eventSignature = parsed.signature;
                }
                // Useful operations
                event.removeListener = ()=>{
                    return contract.provider;
                };
                event.getBlock = ()=>{
                    return contract.provider.getBlock(receipt.blockHash);
                };
                event.getTransaction = ()=>{
                    return contract.provider.getTransaction(receipt.transactionHash);
                };
                event.getTransactionReceipt = ()=>{
                    return Promise.resolve(receipt);
                };
                return event;
            });
            return receipt;
        });
    };
}
function $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple) {
    const signerOrProvider = contract.signer || contract.provider;
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            // Extract the "blockTag" override if present
            let blockTag = undefined;
            if (args.length === fragment.inputs.length + 1 && typeof args[args.length - 1] === "object") {
                const overrides = (0, $i6lOf.shallowCopy)(args.pop());
                if (overrides.blockTag != null) blockTag = yield overrides.blockTag;
                delete overrides.blockTag;
                args.push(overrides);
            }
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed(blockTag);
            // Call a node and get the result
            const tx = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const result = yield signerOrProvider.call(tx, blockTag);
            try {
                let value = contract.interface.decodeFunctionResult(fragment, result);
                if (collapseSimple && fragment.outputs.length === 1) value = value[0];
                return value;
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) {
                    error.address = contract.address;
                    error.args = args;
                    error.transaction = tx;
                }
                throw error;
            }
        });
    };
}
function $8f1c51d58e4a2402$var$buildSend(contract, fragment) {
    return function(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            if (!contract.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transaction requires a signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "sendTransaction"
            });
            // If the contract was just deployed, wait until it is mined
            if (contract.deployTransaction != null) yield contract._deployed();
            const txRequest = yield $8f1c51d58e4a2402$var$populateTransaction(contract, fragment, args);
            const tx = yield contract.signer.sendTransaction(txRequest);
            // Tweak the tx.wait so the receipt has extra properties
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            return tx;
        });
    };
}
function $8f1c51d58e4a2402$var$buildDefault(contract, fragment, collapseSimple) {
    if (fragment.constant) return $8f1c51d58e4a2402$var$buildCall(contract, fragment, collapseSimple);
    return $8f1c51d58e4a2402$var$buildSend(contract, fragment);
}
function $8f1c51d58e4a2402$var$getEventTag(filter) {
    if (filter.address && (filter.topics == null || filter.topics.length === 0)) return "*";
    return (filter.address || "*") + "@" + (filter.topics ? filter.topics.map((topic)=>{
        if (Array.isArray(topic)) return topic.join("|");
        return topic;
    }).join(":") : "");
}
class $8f1c51d58e4a2402$var$RunningEvent {
    constructor(tag, filter){
        (0, $i6lOf.defineReadOnly)(this, "tag", tag);
        (0, $i6lOf.defineReadOnly)(this, "filter", filter);
        this._listeners = [];
    }
    addListener(listener, once) {
        this._listeners.push({
            listener: listener,
            once: once
        });
    }
    removeListener(listener) {
        let done = false;
        this._listeners = this._listeners.filter((item)=>{
            if (done || item.listener !== listener) return true;
            done = true;
            return false;
        });
    }
    removeAllListeners() {
        this._listeners = [];
    }
    listeners() {
        return this._listeners.map((i)=>i.listener);
    }
    listenerCount() {
        return this._listeners.length;
    }
    run(args) {
        const listenerCount = this.listenerCount();
        this._listeners = this._listeners.filter((item)=>{
            const argsCopy = args.slice();
            // Call the callback in the next event loop
            setTimeout(()=>{
                item.listener.apply(this, argsCopy);
            }, 0);
            // Reschedule it if it not "once"
            return !item.once;
        });
        return listenerCount;
    }
    prepareEvent(event) {}
    // Returns the array that will be applied to an emit
    getEmit(event) {
        return [
            event
        ];
    }
}
class $8f1c51d58e4a2402$var$ErrorRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(){
        super("error", null);
    }
}
// @TODO Fragment should inherit Wildcard? and just override getEmit?
//       or have a common abstract super class, with enough constructor
//       options to configure both.
// A Fragment Event will populate all the properties that Wildcard
// will, and additionally dereference the arguments when emitting
class $8f1c51d58e4a2402$var$FragmentRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface, fragment, topics){
        const filter = {
            address: address
        };
        let topic = contractInterface.getEventTopic(fragment);
        if (topics) {
            if (topic !== topics[0]) $8f1c51d58e4a2402$var$logger.throwArgumentError("topic mismatch", "topics", topics);
            filter.topics = topics.slice();
        } else filter.topics = [
            topic
        ];
        super($8f1c51d58e4a2402$var$getEventTag(filter), filter);
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "interface", contractInterface);
        (0, $i6lOf.defineReadOnly)(this, "fragment", fragment);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        event.event = this.fragment.name;
        event.eventSignature = this.fragment.format();
        event.decode = (data, topics)=>{
            return this.interface.decodeEventLog(this.fragment, data, topics);
        };
        try {
            event.args = this.interface.decodeEventLog(this.fragment, event.data, event.topics);
        } catch (error) {
            event.args = null;
            event.decodeError = error;
        }
    }
    getEmit(event) {
        const errors = (0, $5aOKN.checkResultErrors)(event.args);
        if (errors.length) throw errors[0].error;
        const args = (event.args || []).slice();
        args.push(event);
        return args;
    }
}
// A Wildcard Event will attempt to populate:
//  - event            The name of the event name
//  - eventSignature   The full signature of the event
//  - decode           A function to decode data and topics
//  - args             The decoded data and topics
class $8f1c51d58e4a2402$var$WildcardRunningEvent extends $8f1c51d58e4a2402$var$RunningEvent {
    constructor(address, contractInterface){
        super("*", {
            address: address
        });
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "interface", contractInterface);
    }
    prepareEvent(event) {
        super.prepareEvent(event);
        try {
            const parsed = this.interface.parseLog(event);
            event.event = parsed.name;
            event.eventSignature = parsed.signature;
            event.decode = (data, topics)=>{
                return this.interface.decodeEventLog(parsed.eventFragment, data, topics);
            };
            event.args = parsed.args;
        } catch (error) {
        // No matching event
        }
    }
}
class $8f1c51d58e4a2402$export$304faa4fc17528db {
    constructor(addressOrName, contractInterface, signerOrProvider){
        // @TODO: Maybe still check the addressOrName looks like a valid address or name?
        //address = getAddress(address);
        (0, $i6lOf.defineReadOnly)(this, "interface", (0, $i6lOf.getStatic)(new.target, "getInterface")(contractInterface));
        if (signerOrProvider == null) {
            (0, $i6lOf.defineReadOnly)(this, "provider", null);
            (0, $i6lOf.defineReadOnly)(this, "signer", null);
        } else if ((0, $oWESm.Signer).isSigner(signerOrProvider)) {
            (0, $i6lOf.defineReadOnly)(this, "provider", signerOrProvider.provider || null);
            (0, $i6lOf.defineReadOnly)(this, "signer", signerOrProvider);
        } else if ((0, $dGRwz.Provider).isProvider(signerOrProvider)) {
            (0, $i6lOf.defineReadOnly)(this, "provider", signerOrProvider);
            (0, $i6lOf.defineReadOnly)(this, "signer", null);
        } else $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer or provider", "signerOrProvider", signerOrProvider);
        (0, $i6lOf.defineReadOnly)(this, "callStatic", {});
        (0, $i6lOf.defineReadOnly)(this, "estimateGas", {});
        (0, $i6lOf.defineReadOnly)(this, "functions", {});
        (0, $i6lOf.defineReadOnly)(this, "populateTransaction", {});
        (0, $i6lOf.defineReadOnly)(this, "filters", {});
        {
            const uniqueFilters = {};
            Object.keys(this.interface.events).forEach((eventSignature)=>{
                const event = this.interface.events[eventSignature];
                (0, $i6lOf.defineReadOnly)(this.filters, eventSignature, (...args)=>{
                    return {
                        address: this.address,
                        topics: this.interface.encodeFilterTopics(event, args)
                    };
                });
                if (!uniqueFilters[event.name]) uniqueFilters[event.name] = [];
                uniqueFilters[event.name].push(eventSignature);
            });
            Object.keys(uniqueFilters).forEach((name)=>{
                const filters = uniqueFilters[name];
                if (filters.length === 1) (0, $i6lOf.defineReadOnly)(this.filters, name, this.filters[filters[0]]);
                else $8f1c51d58e4a2402$var$logger.warn(`Duplicate definition of ${name} (${filters.join(", ")})`);
            });
        }
        (0, $i6lOf.defineReadOnly)(this, "_runningEvents", {});
        (0, $i6lOf.defineReadOnly)(this, "_wrappedEmits", {});
        if (addressOrName == null) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid contract address or ENS name", "addressOrName", addressOrName);
        (0, $i6lOf.defineReadOnly)(this, "address", addressOrName);
        if (this.provider) (0, $i6lOf.defineReadOnly)(this, "resolvedAddress", $8f1c51d58e4a2402$var$resolveName(this.provider, addressOrName));
        else try {
            (0, $i6lOf.defineReadOnly)(this, "resolvedAddress", Promise.resolve((0, $7pv2A.getAddress)(addressOrName)));
        } catch (error) {
            // Without a provider, we cannot use ENS names
            $8f1c51d58e4a2402$var$logger.throwError("provider is required to use ENS name as contract address", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "new Contract"
            });
        }
        // Swallow bad ENS names to prevent Unhandled Exceptions
        this.resolvedAddress.catch((e)=>{});
        const uniqueNames = {};
        const uniqueSignatures = {};
        Object.keys(this.interface.functions).forEach((signature)=>{
            const fragment = this.interface.functions[signature];
            // Check that the signature is unique; if not the ABI generation has
            // not been cleaned or may be incorrectly generated
            if (uniqueSignatures[signature]) {
                $8f1c51d58e4a2402$var$logger.warn(`Duplicate ABI entry for ${JSON.stringify(signature)}`);
                return;
            }
            uniqueSignatures[signature] = true;
            // Track unique names; we only expose bare named functions if they
            // are ambiguous
            {
                const name = fragment.name;
                if (!uniqueNames[`%${name}`]) uniqueNames[`%${name}`] = [];
                uniqueNames[`%${name}`].push(signature);
            }
            if (this[signature] == null) (0, $i6lOf.defineReadOnly)(this, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, true));
            // We do not collapse simple calls on this bucket, which allows
            // frameworks to safely use this without introspection as well as
            // allows decoding error recovery.
            if (this.functions[signature] == null) (0, $i6lOf.defineReadOnly)(this.functions, signature, $8f1c51d58e4a2402$var$buildDefault(this, fragment, false));
            if (this.callStatic[signature] == null) (0, $i6lOf.defineReadOnly)(this.callStatic, signature, $8f1c51d58e4a2402$var$buildCall(this, fragment, true));
            if (this.populateTransaction[signature] == null) (0, $i6lOf.defineReadOnly)(this.populateTransaction, signature, $8f1c51d58e4a2402$var$buildPopulate(this, fragment));
            if (this.estimateGas[signature] == null) (0, $i6lOf.defineReadOnly)(this.estimateGas, signature, $8f1c51d58e4a2402$var$buildEstimate(this, fragment));
        });
        Object.keys(uniqueNames).forEach((name)=>{
            // Ambiguous names to not get attached as bare names
            const signatures = uniqueNames[name];
            if (signatures.length > 1) return;
            // Strip off the leading "%" used for prototype protection
            name = name.substring(1);
            const signature = signatures[0];
            // If overwriting a member property that is null, swallow the error
            try {
                if (this[name] == null) (0, $i6lOf.defineReadOnly)(this, name, this[signature]);
            } catch (e) {}
            if (this.functions[name] == null) (0, $i6lOf.defineReadOnly)(this.functions, name, this.functions[signature]);
            if (this.callStatic[name] == null) (0, $i6lOf.defineReadOnly)(this.callStatic, name, this.callStatic[signature]);
            if (this.populateTransaction[name] == null) (0, $i6lOf.defineReadOnly)(this.populateTransaction, name, this.populateTransaction[signature]);
            if (this.estimateGas[name] == null) (0, $i6lOf.defineReadOnly)(this.estimateGas, name, this.estimateGas[signature]);
        });
    }
    static getContractAddress(transaction) {
        return (0, $7pv2A.getContractAddress)(transaction);
    }
    static getInterface(contractInterface) {
        if ((0, $h8t8t.Interface).isInterface(contractInterface)) return contractInterface;
        return new (0, $h8t8t.Interface)(contractInterface);
    }
    // @TODO: Allow timeout?
    deployed() {
        return this._deployed();
    }
    _deployed(blockTag) {
        if (!this._deployedPromise) {
            // If we were just deployed, we know the transaction we should occur in
            if (this.deployTransaction) this._deployedPromise = this.deployTransaction.wait().then(()=>{
                return this;
            });
            else // @TODO: Once we allow a timeout to be passed in, we will wait
            // up to that many blocks for getCode
            // Otherwise, poll for our code to be deployed
            this._deployedPromise = this.provider.getCode(this.address, blockTag).then((code)=>{
                if (code === "0x") $8f1c51d58e4a2402$var$logger.throwError("contract not deployed", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                    contractAddress: this.address,
                    operation: "getDeployed"
                });
                return this;
            });
        }
        return this._deployedPromise;
    }
    // @TODO:
    // estimateFallback(overrides?: TransactionRequest): Promise<BigNumber>
    // @TODO:
    // estimateDeploy(bytecode: string, ...args): Promise<BigNumber>
    fallback(overrides) {
        if (!this.signer) $8f1c51d58e4a2402$var$logger.throwError("sending a transactions require a signer", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "sendTransaction(fallback)"
        });
        const tx = (0, $i6lOf.shallowCopy)(overrides || {});
        [
            "from",
            "to"
        ].forEach(function(key) {
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        tx.to = this.resolvedAddress;
        return this.deployed().then(()=>{
            return this.signer.sendTransaction(tx);
        });
    }
    // Reconnect to a different signer or provider
    connect(signerOrProvider) {
        if (typeof signerOrProvider === "string") signerOrProvider = new (0, $oWESm.VoidSigner)(signerOrProvider, this.provider);
        const contract = new this.constructor(this.address, this.interface, signerOrProvider);
        if (this.deployTransaction) (0, $i6lOf.defineReadOnly)(contract, "deployTransaction", this.deployTransaction);
        return contract;
    }
    // Re-attach to a different on-chain instance of this contract
    attach(addressOrName) {
        return new this.constructor(addressOrName, this.interface, this.signer || this.provider);
    }
    static isIndexed(value) {
        return (0, $h8t8t.Indexed).isIndexed(value);
    }
    _normalizeRunningEvent(runningEvent) {
        // Already have an instance of this event running; we can re-use it
        if (this._runningEvents[runningEvent.tag]) return this._runningEvents[runningEvent.tag];
        return runningEvent;
    }
    _getRunningEvent(eventName) {
        if (typeof eventName === "string") {
            // Listen for "error" events (if your contract has an error event, include
            // the full signature to bypass this special event keyword)
            if (eventName === "error") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$ErrorRunningEvent());
            // Listen for any event that is registered
            if (eventName === "event") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent("event", null));
            // Listen for any event
            if (eventName === "*") return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
            // Get the event Fragment (throws if ambiguous/unknown event)
            const fragment = this.interface.getEvent(eventName);
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment));
        }
        // We have topics to filter by...
        if (eventName.topics && eventName.topics.length > 0) {
            // Is it a known topichash? (throws if no matching topichash)
            try {
                const topic = eventName.topics[0];
                if (typeof topic !== "string") throw new Error("invalid topic"); // @TODO: May happen for anonymous events
                const fragment = this.interface.getEvent(topic);
                return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$FragmentRunningEvent(this.address, this.interface, fragment, eventName.topics));
            } catch (error) {}
            // Filter by the unknown topichash
            const filter = {
                address: this.address,
                topics: eventName.topics
            };
            return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$RunningEvent($8f1c51d58e4a2402$var$getEventTag(filter), filter));
        }
        return this._normalizeRunningEvent(new $8f1c51d58e4a2402$var$WildcardRunningEvent(this.address, this.interface));
    }
    _checkRunningEvents(runningEvent) {
        if (runningEvent.listenerCount() === 0) {
            delete this._runningEvents[runningEvent.tag];
            // If we have a poller for this, remove it
            const emit = this._wrappedEmits[runningEvent.tag];
            if (emit && runningEvent.filter) {
                this.provider.off(runningEvent.filter, emit);
                delete this._wrappedEmits[runningEvent.tag];
            }
        }
    }
    // Subclasses can override this to gracefully recover
    // from parse errors if they wish
    _wrapEvent(runningEvent, log, listener) {
        const event = (0, $i6lOf.deepCopy)(log);
        event.removeListener = ()=>{
            if (!listener) return;
            runningEvent.removeListener(listener);
            this._checkRunningEvents(runningEvent);
        };
        event.getBlock = ()=>{
            return this.provider.getBlock(log.blockHash);
        };
        event.getTransaction = ()=>{
            return this.provider.getTransaction(log.transactionHash);
        };
        event.getTransactionReceipt = ()=>{
            return this.provider.getTransactionReceipt(log.transactionHash);
        };
        // This may throw if the topics and data mismatch the signature
        runningEvent.prepareEvent(event);
        return event;
    }
    _addEventListener(runningEvent, listener, once) {
        if (!this.provider) $8f1c51d58e4a2402$var$logger.throwError("events require a provider or a signer with a provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "once"
        });
        runningEvent.addListener(listener, once);
        // Track this running event and its listeners (may already be there; but no hard in updating)
        this._runningEvents[runningEvent.tag] = runningEvent;
        // If we are not polling the provider, start polling
        if (!this._wrappedEmits[runningEvent.tag]) {
            const wrappedEmit = (log)=>{
                let event = this._wrapEvent(runningEvent, log, listener);
                // Try to emit the result for the parameterized event...
                if (event.decodeError == null) try {
                    const args = runningEvent.getEmit(event);
                    this.emit(runningEvent.filter, ...args);
                } catch (error) {
                    event.decodeError = error.error;
                }
                // Always emit "event" for fragment-base events
                if (runningEvent.filter != null) this.emit("event", event);
                // Emit "error" if there was an error
                if (event.decodeError != null) this.emit("error", event.decodeError, event);
            };
            this._wrappedEmits[runningEvent.tag] = wrappedEmit;
            // Special events, like "error" do not have a filter
            if (runningEvent.filter != null) this.provider.on(runningEvent.filter, wrappedEmit);
        }
    }
    queryFilter(event, fromBlockOrBlockhash, toBlock) {
        const runningEvent = this._getRunningEvent(event);
        const filter = (0, $i6lOf.shallowCopy)(runningEvent.filter);
        if (typeof fromBlockOrBlockhash === "string" && (0, $ApLZa.isHexString)(fromBlockOrBlockhash, 32)) {
            if (toBlock != null) $8f1c51d58e4a2402$var$logger.throwArgumentError("cannot specify toBlock with blockhash", "toBlock", toBlock);
            filter.blockHash = fromBlockOrBlockhash;
        } else {
            filter.fromBlock = fromBlockOrBlockhash != null ? fromBlockOrBlockhash : 0;
            filter.toBlock = toBlock != null ? toBlock : "latest";
        }
        return this.provider.getLogs(filter).then((logs)=>{
            return logs.map((log)=>this._wrapEvent(runningEvent, log, null));
        });
    }
    on(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, false);
        return this;
    }
    once(event, listener) {
        this._addEventListener(this._getRunningEvent(event), listener, true);
        return this;
    }
    emit(eventName, ...args) {
        if (!this.provider) return false;
        const runningEvent = this._getRunningEvent(eventName);
        const result = runningEvent.run(args) > 0;
        // May have drained all the "once" events; check for living events
        this._checkRunningEvents(runningEvent);
        return result;
    }
    listenerCount(eventName) {
        if (!this.provider) return 0;
        if (eventName == null) return Object.keys(this._runningEvents).reduce((accum, key)=>{
            return accum + this._runningEvents[key].listenerCount();
        }, 0);
        return this._getRunningEvent(eventName).listenerCount();
    }
    listeners(eventName) {
        if (!this.provider) return [];
        if (eventName == null) {
            const result = [];
            for(let tag in this._runningEvents)this._runningEvents[tag].listeners().forEach((listener)=>{
                result.push(listener);
            });
            return result;
        }
        return this._getRunningEvent(eventName).listeners();
    }
    removeAllListeners(eventName) {
        if (!this.provider) return this;
        if (eventName == null) {
            for(const tag in this._runningEvents){
                const runningEvent = this._runningEvents[tag];
                runningEvent.removeAllListeners();
                this._checkRunningEvents(runningEvent);
            }
            return this;
        }
        // Delete any listeners
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeAllListeners();
        this._checkRunningEvents(runningEvent);
        return this;
    }
    off(eventName, listener) {
        if (!this.provider) return this;
        const runningEvent = this._getRunningEvent(eventName);
        runningEvent.removeListener(listener);
        this._checkRunningEvents(runningEvent);
        return this;
    }
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
}
class $8f1c51d58e4a2402$export$8517d80acf00e19a extends $8f1c51d58e4a2402$export$304faa4fc17528db {
}
class $8f1c51d58e4a2402$export$505569a6bf584fd9 {
    constructor(contractInterface, bytecode, signer){
        let bytecodeHex = null;
        if (typeof bytecode === "string") bytecodeHex = bytecode;
        else if ((0, $ApLZa.isBytes)(bytecode)) bytecodeHex = (0, $ApLZa.hexlify)(bytecode);
        else if (bytecode && typeof bytecode.object === "string") // Allow the bytecode object from the Solidity compiler
        bytecodeHex = bytecode.object;
        else // Crash in the next verification step
        bytecodeHex = "!";
        // Make sure it is 0x prefixed
        if (bytecodeHex.substring(0, 2) !== "0x") bytecodeHex = "0x" + bytecodeHex;
        // Make sure the final result is valid bytecode
        if (!(0, $ApLZa.isHexString)(bytecodeHex) || bytecodeHex.length % 2) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid bytecode", "bytecode", bytecode);
        // If we have a signer, make sure it is valid
        if (signer && !(0, $oWESm.Signer).isSigner(signer)) $8f1c51d58e4a2402$var$logger.throwArgumentError("invalid signer", "signer", signer);
        (0, $i6lOf.defineReadOnly)(this, "bytecode", bytecodeHex);
        (0, $i6lOf.defineReadOnly)(this, "interface", (0, $i6lOf.getStatic)(new.target, "getInterface")(contractInterface));
        (0, $i6lOf.defineReadOnly)(this, "signer", signer || null);
    }
    // @TODO: Future; rename to populateTransaction?
    getDeployTransaction(...args) {
        let tx = {};
        // If we have 1 additional argument, we allow transaction overrides
        if (args.length === this.interface.deploy.inputs.length + 1 && typeof args[args.length - 1] === "object") {
            tx = (0, $i6lOf.shallowCopy)(args.pop());
            for(const key in tx){
                if (!$8f1c51d58e4a2402$var$allowedTransactionKeys[key]) throw new Error("unknown transaction override " + key);
            }
        }
        // Do not allow these to be overridden in a deployment transaction
        [
            "data",
            "from",
            "to"
        ].forEach((key)=>{
            if (tx[key] == null) return;
            $8f1c51d58e4a2402$var$logger.throwError("cannot override " + key, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: key
            });
        });
        if (tx.value) {
            const value = (0, $esOfL.BigNumber).from(tx.value);
            if (!value.isZero() && !this.interface.deploy.payable) $8f1c51d58e4a2402$var$logger.throwError("non-payable constructor cannot override value", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "overrides.value",
                value: tx.value
            });
        }
        // Make sure the call matches the constructor signature
        $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
        // Set the data to the bytecode + the encoded constructor arguments
        tx.data = (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.bytecode,
            this.interface.encodeDeploy(args)
        ]));
        return tx;
    }
    deploy(...args) {
        return $8f1c51d58e4a2402$var$__awaiter(this, void 0, void 0, function*() {
            let overrides = {};
            // If 1 extra parameter was passed in, it contains overrides
            if (args.length === this.interface.deploy.inputs.length + 1) overrides = args.pop();
            // Make sure the call matches the constructor signature
            $8f1c51d58e4a2402$var$logger.checkArgumentCount(args.length, this.interface.deploy.inputs.length, " in Contract constructor");
            // Resolve ENS names and promises in the arguments
            const params = yield $8f1c51d58e4a2402$var$resolveAddresses(this.signer, args, this.interface.deploy.inputs);
            params.push(overrides);
            // Get the deployment transaction (with optional overrides)
            const unsignedTx = this.getDeployTransaction(...params);
            // Send the deployment transaction
            const tx = yield this.signer.sendTransaction(unsignedTx);
            const address = (0, $i6lOf.getStatic)(this.constructor, "getContractAddress")(tx);
            const contract = (0, $i6lOf.getStatic)(this.constructor, "getContract")(address, this.interface, this.signer);
            // Add the modified wait that wraps events
            $8f1c51d58e4a2402$var$addContractWait(contract, tx);
            (0, $i6lOf.defineReadOnly)(contract, "deployTransaction", tx);
            return contract;
        });
    }
    attach(address) {
        return this.constructor.getContract(address, this.interface, this.signer);
    }
    connect(signer) {
        return new this.constructor(this.interface, this.bytecode, signer);
    }
    static fromSolidity(compilerOutput, signer) {
        if (compilerOutput == null) $8f1c51d58e4a2402$var$logger.throwError("missing compiler output", (0, $8bxC3.Logger).errors.MISSING_ARGUMENT, {
            argument: "compilerOutput"
        });
        if (typeof compilerOutput === "string") compilerOutput = JSON.parse(compilerOutput);
        const abi = compilerOutput.abi;
        let bytecode = null;
        if (compilerOutput.bytecode) bytecode = compilerOutput.bytecode;
        else if (compilerOutput.evm && compilerOutput.evm.bytecode) bytecode = compilerOutput.evm.bytecode;
        return new this(abi, bytecode, signer);
    }
    static getInterface(contractInterface) {
        return $8f1c51d58e4a2402$export$8517d80acf00e19a.getInterface(contractInterface);
    }
    static getContractAddress(tx) {
        return (0, $7pv2A.getContractAddress)(tx);
    }
    static getContract(address, contractInterface, signer) {
        return new $8f1c51d58e4a2402$export$8517d80acf00e19a(address, contractInterface, signer);
    }
}

});
parcelRegister("5aOKN", function(module, exports) {

$parcel$export(module.exports, "checkResultErrors", function () { return $3c454193c1d90bf8$export$5546b9ec21157cc2; });
$parcel$export(module.exports, "Coder", function () { return $3c454193c1d90bf8$export$2c0c39526f8bad46; });
$parcel$export(module.exports, "Writer", function () { return $3c454193c1d90bf8$export$d7a960146e1a269e; });
$parcel$export(module.exports, "Reader", function () { return $3c454193c1d90bf8$export$2f7a2f0e90c07dc4; });

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $3c454193c1d90bf8$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
function $3c454193c1d90bf8$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $3c454193c1d90bf8$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $3c454193c1d90bf8$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $3c454193c1d90bf8$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $i6lOf.defineReadOnly)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $ApLZa.hexConcat)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $ApLZa.concat)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $ApLZa.arrayify)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $ApLZa.concat)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $ApLZa.arrayify)((0, $esOfL.BigNumber).from(value));
        if (bytes.length > this.wordSize) $3c454193c1d90bf8$var$logger.throwError("value out-of-bounds", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $ApLZa.concat)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $3c454193c1d90bf8$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $i6lOf.defineReadOnly)(this, "_data", (0, $ApLZa.arrayify)(data));
        (0, $i6lOf.defineReadOnly)(this, "wordSize", wordSize || 32);
        (0, $i6lOf.defineReadOnly)(this, "_coerceFunc", coerceFunc);
        (0, $i6lOf.defineReadOnly)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $ApLZa.hexlify)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $3c454193c1d90bf8$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $3c454193c1d90bf8$var$logger.throwError("data out-of-bounds", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $3c454193c1d90bf8$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $esOfL.BigNumber).from(this.readBytes(this.wordSize));
    }
}

});
parcelRegister("esOfL", function(module, exports) {

$parcel$export(module.exports, "isBigNumberish", function () { return $a87aa97415e1b917$export$a3d0a7fa9b65683b; });
$parcel$export(module.exports, "BigNumber", function () { return $a87aa97415e1b917$export$d97aa349ed20696; });
$parcel$export(module.exports, "_base36To16", function () { return $a87aa97415e1b917$export$51e4a08295f7770f; });
$parcel$export(module.exports, "_base16To36", function () { return $a87aa97415e1b917$export$1293db5d29c264ff; });

var $iA132 = parcelRequire("iA132");

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $irjnC = parcelRequire("irjnC");
"use strict";
var $a87aa97415e1b917$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($iA132))).BN;
const $a87aa97415e1b917$var$logger = new (0, $8bxC3.Logger)((0, $irjnC.version));
const $a87aa97415e1b917$var$_constructorGuard = {};
const $a87aa97415e1b917$var$MAX_SAFE = 0x1fffffffffffff;
function $a87aa97415e1b917$export$a3d0a7fa9b65683b(value) {
    return value != null && ($a87aa97415e1b917$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $ApLZa.isHexString)(value) || typeof value === "bigint" || (0, $ApLZa.isBytes)(value));
}
// Only warn about passing 10 into radix once
let $a87aa97415e1b917$var$_warnedToStringRadix = false;
class $a87aa97415e1b917$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        if (constructorGuard !== $a87aa97415e1b917$var$_constructorGuard) $a87aa97415e1b917$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $a87aa97415e1b917$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).add($a87aa97415e1b917$var$toBN(other)));
    }
    sub(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).sub($a87aa97415e1b917$var$toBN(other)));
    }
    div(other) {
        const o = $a87aa97415e1b917$export$d97aa349ed20696.from(other);
        if (o.isZero()) $a87aa97415e1b917$var$throwFault("division-by-zero", "div");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).div($a87aa97415e1b917$var$toBN(other)));
    }
    mul(other) {
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).mul($a87aa97415e1b917$var$toBN(other)));
    }
    mod(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("division-by-zero", "mod");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (value.isNeg()) $a87aa97415e1b917$var$throwFault("negative-power", "pow");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "and");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).and(value));
    }
    or(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "or");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $a87aa97415e1b917$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $a87aa97415e1b917$var$throwFault("unbound-bitwise-result", "xor");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "mask");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shl");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $a87aa97415e1b917$var$throwFault("negative-width", "shr");
        return $a87aa97415e1b917$var$toBigNumber($a87aa97415e1b917$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $a87aa97415e1b917$var$toBN(this).eq($a87aa97415e1b917$var$toBN(other));
    }
    lt(other) {
        return $a87aa97415e1b917$var$toBN(this).lt($a87aa97415e1b917$var$toBN(other));
    }
    lte(other) {
        return $a87aa97415e1b917$var$toBN(this).lte($a87aa97415e1b917$var$toBN(other));
    }
    gt(other) {
        return $a87aa97415e1b917$var$toBN(this).gt($a87aa97415e1b917$var$toBN(other));
    }
    gte(other) {
        return $a87aa97415e1b917$var$toBN(this).gte($a87aa97415e1b917$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $a87aa97415e1b917$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $a87aa97415e1b917$var$toBN(this).toNumber();
        } catch (error) {
            $a87aa97415e1b917$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $a87aa97415e1b917$var$logger.throwError("this platform does not support BigInt", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$a87aa97415e1b917$var$_warnedToStringRadix) {
                    $a87aa97415e1b917$var$_warnedToStringRadix = true;
                    $a87aa97415e1b917$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {});
            else $a87aa97415e1b917$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $a87aa97415e1b917$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $a87aa97415e1b917$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $a87aa97415e1b917$export$d97aa349ed20696($a87aa97415e1b917$var$_constructorGuard, $a87aa97415e1b917$var$toHex(new $a87aa97415e1b917$var$BN(value)));
            return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $a87aa97415e1b917$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $a87aa97415e1b917$var$MAX_SAFE || value <= -$a87aa97415e1b917$var$MAX_SAFE) $a87aa97415e1b917$var$throwFault("overflow", "BigNumber.from", value);
            return $a87aa97415e1b917$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $a87aa97415e1b917$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $ApLZa.isBytes)(anyValue)) return $a87aa97415e1b917$export$d97aa349ed20696.from((0, $ApLZa.hexlify)(anyValue));
        if (anyValue) {
            // Hexable interface (takes priority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $ApLZa.isHexString)(hex) || hex[0] === "-" && (0, $ApLZa.isHexString)(hex.substring(1))) return $a87aa97415e1b917$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $a87aa97415e1b917$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $a87aa97415e1b917$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $a87aa97415e1b917$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have multiple negative signs (e.g. "--0x04")
        if (value[0] === "-") $a87aa97415e1b917$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $a87aa97415e1b917$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $a87aa97415e1b917$var$toBigNumber(value) {
    return $a87aa97415e1b917$export$d97aa349ed20696.from($a87aa97415e1b917$var$toHex(value));
}
function $a87aa97415e1b917$var$toBN(value) {
    const hex = $a87aa97415e1b917$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $a87aa97415e1b917$var$BN("-" + hex.substring(3), 16);
    return new $a87aa97415e1b917$var$BN(hex.substring(2), 16);
}
function $a87aa97415e1b917$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $a87aa97415e1b917$var$logger.throwError(fault, (0, $8bxC3.Logger).errors.NUMERIC_FAULT, params);
}
function $a87aa97415e1b917$export$51e4a08295f7770f(value) {
    return new $a87aa97415e1b917$var$BN(value, 36).toString(16);
}
function $a87aa97415e1b917$export$1293db5d29c264ff(value) {
    return new $a87aa97415e1b917$var$BN(value, 16).toString(36);
}

});
parcelRegister("irjnC", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d6c9c8115f7af803$export$83d89fbfd8236492; });
const $d6c9c8115f7af803$export$83d89fbfd8236492 = "bignumber/5.7.0";

});


parcelRegister("i6lOf", function(module, exports) {

$parcel$export(module.exports, "defineReadOnly", function () { return $d2d9b472f7878d5e$export$104236534534f9be; });
$parcel$export(module.exports, "getStatic", function () { return $d2d9b472f7878d5e$export$f695fbbf3cdaaf47; });
$parcel$export(module.exports, "resolveProperties", function () { return $d2d9b472f7878d5e$export$d503dd157d963b60; });
$parcel$export(module.exports, "checkProperties", function () { return $d2d9b472f7878d5e$export$ae5a316ba623b73a; });
$parcel$export(module.exports, "shallowCopy", function () { return $d2d9b472f7878d5e$export$9c13236873b118a5; });
$parcel$export(module.exports, "deepCopy", function () { return $d2d9b472f7878d5e$export$6c40052bed430212; });
$parcel$export(module.exports, "Description", function () { return $d2d9b472f7878d5e$export$393edc798c47379d; });

var $8bxC3 = parcelRequire("8bxC3");

var $b6k6c = parcelRequire("b6k6c");
"use strict";
var $d2d9b472f7878d5e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d2d9b472f7878d5e$var$logger = new (0, $8bxC3.Logger)((0, $b6k6c.version));
function $d2d9b472f7878d5e$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $d2d9b472f7878d5e$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $d2d9b472f7878d5e$export$d503dd157d963b60(object) {
    return $d2d9b472f7878d5e$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $d2d9b472f7878d5e$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $d2d9b472f7878d5e$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $d2d9b472f7878d5e$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $d2d9b472f7878d5e$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $d2d9b472f7878d5e$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $d2d9b472f7878d5e$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            let value = null;
            try {
                value = object[keys[i]];
            } catch (error) {
                continue;
            }
            if (!$d2d9b472f7878d5e$var$_isFrozen(value)) return false;
        }
        return true;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $d2d9b472f7878d5e$var$_deepCopy(object) {
    if ($d2d9b472f7878d5e$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$d2d9b472f7878d5e$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $d2d9b472f7878d5e$export$104236534534f9be(result, key, $d2d9b472f7878d5e$export$6c40052bed430212(value));
        }
        return result;
    }
    return $d2d9b472f7878d5e$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $d2d9b472f7878d5e$export$6c40052bed430212(object) {
    return $d2d9b472f7878d5e$var$_deepCopy(object);
}
class $d2d9b472f7878d5e$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $d2d9b472f7878d5e$export$6c40052bed430212(info[key]);
    }
}

});
parcelRegister("b6k6c", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $814fd87c70d37554$export$83d89fbfd8236492; });
const $814fd87c70d37554$export$83d89fbfd8236492 = "properties/5.7.0";

});


parcelRegister("9kBWa", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6cb368dce1713386$export$83d89fbfd8236492; });
const $6cb368dce1713386$export$83d89fbfd8236492 = "abi/5.7.0";

});


parcelRegister("h8t8t", function(module, exports) {

$parcel$export(module.exports, "LogDescription", function () { return $c799c8c071055c8d$export$c2ab6499be98b3c5; });
$parcel$export(module.exports, "TransactionDescription", function () { return $c799c8c071055c8d$export$7a3223b0fadb690b; });
$parcel$export(module.exports, "Indexed", function () { return $c799c8c071055c8d$export$8ef99100a3c56f8c; });
$parcel$export(module.exports, "Interface", function () { return $c799c8c071055c8d$export$48cefb51a4e315b2; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $1JJGc = parcelRequire("1JJGc");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $5FB8J = parcelRequire("5FB8J");

var $5aOKN = parcelRequire("5aOKN");

var $3PTbz = parcelRequire("3PTbz");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $c799c8c071055c8d$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
class $c799c8c071055c8d$export$c2ab6499be98b3c5 extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$7a3223b0fadb690b extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$cfba08fc0e40e2ab extends (0, $i6lOf.Description) {
}
class $c799c8c071055c8d$export$8ef99100a3c56f8c extends (0, $i6lOf.Description) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
const $c799c8c071055c8d$var$BuiltinErrors = {
    "0x08c379a0": {
        signature: "Error(string)",
        name: "Error",
        inputs: [
            "string"
        ],
        reason: true
    },
    "0x4e487b71": {
        signature: "Panic(uint256)",
        name: "Panic",
        inputs: [
            "uint256"
        ]
    }
};
function $c799c8c071055c8d$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $c799c8c071055c8d$export$48cefb51a4e315b2 {
    constructor(fragments){
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $i6lOf.defineReadOnly)(this, "fragments", abi.map((fragment)=>{
            return (0, $3PTbz.Fragment).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $i6lOf.defineReadOnly)(this, "_abiCoder", (0, $i6lOf.getStatic)(new.target, "getAbiCoder")());
        (0, $i6lOf.defineReadOnly)(this, "functions", {});
        (0, $i6lOf.defineReadOnly)(this, "errors", {});
        (0, $i6lOf.defineReadOnly)(this, "events", {});
        (0, $i6lOf.defineReadOnly)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $c799c8c071055c8d$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $i6lOf.defineReadOnly)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                case "error":
                    bucket = this.errors;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $c799c8c071055c8d$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $i6lOf.defineReadOnly)(this, "deploy", (0, $3PTbz.ConstructorFragment).from({
            payable: false,
            type: "constructor"
        }));
        (0, $i6lOf.defineReadOnly)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $3PTbz.FormatTypes).full;
        if (format === (0, $3PTbz.FormatTypes).sighash) $c799c8c071055c8d$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $3PTbz.FormatTypes).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $5FB8J.defaultAbiCoder;
    }
    static getAddress(address) {
        return (0, $7pv2A.getAddress)(address);
    }
    static getSighash(fragment) {
        return (0, $ApLZa.hexDataSlice)((0, $1JJGc.id)(fragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $1JJGc.id)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.functions[(0, $3PTbz.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.events[(0, $3PTbz.EventFragment).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getError(nameOrSignatureOrSighash) {
        if ((0, $ApLZa.isHexString)(nameOrSignatureOrSighash)) {
            const getSighash = (0, $i6lOf.getStatic)(this.constructor, "getSighash");
            for(const name in this.errors){
                const error = this.errors[name];
                if (nameOrSignatureOrSighash === getSighash(error)) return this.errors[name];
            }
            $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.errors).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "name", name);
            else if (matching.length > 1) $c799c8c071055c8d$var$logger.throwArgumentError("multiple matching errors", "name", name);
            return this.errors[matching[0]];
        }
        // Normalize the signature and lookup the function
        const result = this.errors[(0, $3PTbz.FunctionFragment).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $c799c8c071055c8d$var$logger.throwArgumentError("no matching error", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(fragment) {
        if (typeof fragment === "string") try {
            fragment = this.getFunction(fragment);
        } catch (error) {
            try {
                fragment = this.getError(fragment);
            } catch (_) {
                throw error;
            }
        }
        return (0, $i6lOf.getStatic)(this.constructor, "getSighash")(fragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $i6lOf.getStatic)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    decodeErrorResult(fragment, data) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        const bytes = (0, $ApLZa.arrayify)(data);
        if ((0, $ApLZa.hexlify)(bytes.slice(0, 4)) !== this.getSighash(fragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match error ${fragment.name}.`, "data", (0, $ApLZa.hexlify)(bytes));
        return this._decodeParams(fragment.inputs, bytes.slice(4));
    }
    encodeErrorResult(fragment, values) {
        if (typeof fragment === "string") fragment = this.getError(fragment);
        return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.getSighash(fragment),
            this._encodeParams(fragment.inputs, values || [])
        ]));
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $ApLZa.arrayify)(data);
        if ((0, $ApLZa.hexlify)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $c799c8c071055c8d$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $ApLZa.hexlify)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $ApLZa.arrayify)(data);
        let reason = null;
        let message = "";
        let errorArgs = null;
        let errorName = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                {
                    const selector = (0, $ApLZa.hexlify)(bytes.slice(0, 4));
                    const builtin = $c799c8c071055c8d$var$BuiltinErrors[selector];
                    if (builtin) {
                        errorArgs = this._abiCoder.decode(builtin.inputs, bytes.slice(4));
                        errorName = builtin.name;
                        errorSignature = builtin.signature;
                        if (builtin.reason) reason = errorArgs[0];
                        if (errorName === "Error") message = `; VM Exception while processing transaction: reverted with reason string ${JSON.stringify(errorArgs[0])}`;
                        else if (errorName === "Panic") message = `; VM Exception while processing transaction: reverted with panic code ${errorArgs[0]}`;
                    } else try {
                        const error = this.getError(selector);
                        errorArgs = this._abiCoder.decode(error.inputs, bytes.slice(4));
                        errorName = error.name;
                        errorSignature = error.format();
                    } catch (error) {}
                    break;
                }
        }
        return $c799c8c071055c8d$var$logger.throwError("call revert exception" + message, (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            data: (0, $ApLZa.hexlify)(data),
            errorArgs: errorArgs,
            errorName: errorName,
            errorSignature: errorSignature,
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $ApLZa.hexlify)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $8bxC3.Logger).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $1JJGc.id)(value);
            else if (param.type === "bytes") return (0, $8unkG.keccak256)((0, $ApLZa.hexlify)(value));
            if (param.type === "bool" && typeof value === "boolean") value = value ? "0x01" : "0x00";
            if (param.type.match(/^u?int/)) value = (0, $esOfL.BigNumber).from(value).toHexString();
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $c799c8c071055c8d$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $c799c8c071055c8d$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $c799c8c071055c8d$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $1JJGc.id)(value));
                else if (param.type === "bytes") topics.push((0, $8unkG.keccak256)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TODO
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $ApLZa.isHexString)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $c799c8c071055c8d$var$logger.throwError("fragment/topic mismatch", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $3PTbz.ParamType).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $ApLZa.concat)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $c799c8c071055c8d$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    enumerable: true,
                    get: ()=>{
                        throw $c799c8c071055c8d$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                enumerable: true,
                get: ()=>{
                    throw $c799c8c071055c8d$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $esOfL.BigNumber).from(tx.value || "0")
        });
    }
    // @TODO
    //parseCallResult(data: BytesLike): ??
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe just a fragment?
        return new $c799c8c071055c8d$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    parseError(data) {
        const hexData = (0, $ApLZa.hexlify)(data);
        let fragment = this.getError(hexData.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $c799c8c071055c8d$export$cfba08fc0e40e2ab({
            args: this._abiCoder.decode(fragment.inputs, "0x" + hexData.substring(10)),
            errorFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}

});
parcelRegister("7pv2A", function(module, exports) {

$parcel$export(module.exports, "getAddress", function () { return $5652f239bab101de$export$88411125f012957a; });
$parcel$export(module.exports, "isAddress", function () { return $5652f239bab101de$export$977e255126d763d6; });
$parcel$export(module.exports, "getIcapAddress", function () { return $5652f239bab101de$export$962c4ddada9f668f; });
$parcel$export(module.exports, "getContractAddress", function () { return $5652f239bab101de$export$b7fbffef12272e40; });
$parcel$export(module.exports, "getCreate2Address", function () { return $5652f239bab101de$export$e0b22d96621f73a2; });

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $8unkG = parcelRequire("8unkG");

var $2blqG = parcelRequire("2blqG");

var $8bxC3 = parcelRequire("8bxC3");

var $1GUII = parcelRequire("1GUII");
"use strict";
const $5652f239bab101de$var$logger = new (0, $8bxC3.Logger)((0, $1GUII.version));
function $5652f239bab101de$var$getChecksumAddress(address) {
    if (!(0, $ApLZa.isHexString)(address, 20)) $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $ApLZa.arrayify)((0, $8unkG.keccak256)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $5652f239bab101de$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $5652f239bab101de$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $5652f239bab101de$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$5652f239bab101de$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$5652f239bab101de$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $5652f239bab101de$var$safeDigits = Math.floor($5652f239bab101de$var$log10($5652f239bab101de$var$MAX_SAFE_INTEGER));
function $5652f239bab101de$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $5652f239bab101de$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $5652f239bab101de$var$safeDigits){
        let block = expanded.substring(0, $5652f239bab101de$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $5652f239bab101de$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $5652f239bab101de$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $5652f239bab101de$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $5652f239bab101de$var$ibanChecksum(address)) $5652f239bab101de$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $esOfL._base36To16)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $5652f239bab101de$var$getChecksumAddress("0x" + result);
    } else $5652f239bab101de$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $5652f239bab101de$export$977e255126d763d6(address) {
    try {
        $5652f239bab101de$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $5652f239bab101de$export$962c4ddada9f668f(address) {
    let base36 = (0, $esOfL._base16To36)($5652f239bab101de$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $5652f239bab101de$var$ibanChecksum("XE00" + base36) + base36;
}
function $5652f239bab101de$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $5652f239bab101de$export$88411125f012957a(transaction.from);
    } catch (error) {
        $5652f239bab101de$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)((0, $esOfL.BigNumber).from(transaction.nonce).toHexString()));
    return $5652f239bab101de$export$88411125f012957a((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $2blqG.encode)([
        from,
        nonce
    ])), 12));
}
function $5652f239bab101de$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $ApLZa.hexDataLength)(salt) !== 32) $5652f239bab101de$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $ApLZa.hexDataLength)(initCodeHash) !== 32) $5652f239bab101de$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $5652f239bab101de$export$88411125f012957a((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
        "0xff",
        $5652f239bab101de$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}

});
parcelRegister("8unkG", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $62e3396d458230e9$export$f8151fce47ad1c35; });

var $jHZww = parcelRequire("jHZww");

var $ApLZa = parcelRequire("ApLZa");
"use strict";
function $62e3396d458230e9$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($jHZww))).keccak_256((0, $ApLZa.arrayify)(data));
}

});
parcelRegister("jHZww", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4TNnu === "object" && $4TNnu.versions && $4TNnu.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});


parcelRegister("1GUII", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $13b5b621afd5242c$export$83d89fbfd8236492; });
const $13b5b621afd5242c$export$83d89fbfd8236492 = "address/5.7.0";

});


parcelRegister("1JJGc", function(module, exports) {

$parcel$export(module.exports, "id", function () { return $143d6d71aa960133$export$d560c7e4a29451c2; });

var $8unkG = parcelRequire("8unkG");

var $aCHl8 = parcelRequire("aCHl8");
function $143d6d71aa960133$export$d560c7e4a29451c2(text) {
    return (0, $8unkG.keccak256)((0, $aCHl8.toUtf8Bytes)(text));
}

});
parcelRegister("aCHl8", function(module, exports) {

$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return $7bbf1261c840221b$export$c6986442964129f5; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return $7bbf1261c840221b$export$c285fa6ac15ff6a6; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return $7bbf1261c840221b$export$c6e2180c5bb5bc05; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return $7bbf1261c840221b$export$8feeb310b4b4752f; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return $7bbf1261c840221b$export$a7a0ec15960b9055; });
$parcel$export(module.exports, "_toUtf8String", function () { return $7bbf1261c840221b$export$232e1dab03132235; });
$parcel$export(module.exports, "toUtf8String", function () { return $7bbf1261c840221b$export$7643a1dc2c38d5eb; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return $7bbf1261c840221b$export$ae470a36a31b28c2; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $Rpay7 = parcelRequire("Rpay7");
"use strict";
const $7bbf1261c840221b$var$logger = new (0, $8bxC3.Logger)((0, $Rpay7.version));
var $7bbf1261c840221b$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($7bbf1261c840221b$export$c6986442964129f5 || ($7bbf1261c840221b$export$c6986442964129f5 = {}));
var $7bbf1261c840221b$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong representation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($7bbf1261c840221b$export$c285fa6ac15ff6a6 || ($7bbf1261c840221b$export$c285fa6ac15ff6a6 = {}));
function $7bbf1261c840221b$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $7bbf1261c840221b$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $7bbf1261c840221b$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $7bbf1261c840221b$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $7bbf1261c840221b$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $7bbf1261c840221b$var$errorFunc,
    ignore: $7bbf1261c840221b$var$ignoreFunc,
    replace: $7bbf1261c840221b$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $7bbf1261c840221b$export$c6e2180c5bb5bc05.error;
    bytes = (0, $ApLZa.arrayify)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid continuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($7bbf1261c840221b$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $7bbf1261c840221b$export$8feeb310b4b4752f(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    if (form != $7bbf1261c840221b$export$c6986442964129f5.current) {
        $7bbf1261c840221b$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $ApLZa.arrayify)(result);
}
function $7bbf1261c840221b$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $7bbf1261c840221b$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $7bbf1261c840221b$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $7bbf1261c840221b$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $7bbf1261c840221b$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $7bbf1261c840221b$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $7bbf1261c840221b$export$7643a1dc2c38d5eb(bytes, onError) {
    return $7bbf1261c840221b$export$232e1dab03132235($7bbf1261c840221b$var$getUtf8CodePoints(bytes, onError));
}
function $7bbf1261c840221b$export$ae470a36a31b28c2(str, form = $7bbf1261c840221b$export$c6986442964129f5.current) {
    return $7bbf1261c840221b$var$getUtf8CodePoints($7bbf1261c840221b$export$8feeb310b4b4752f(str, form));
}

});
parcelRegister("Rpay7", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $0a08796bc83cbef6$export$83d89fbfd8236492; });
const $0a08796bc83cbef6$export$83d89fbfd8236492 = "strings/5.7.0";

});



parcelRegister("5FB8J", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return $420d974aae91c4e0$export$fe041e1a83d3efc6; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return $420d974aae91c4e0$export$51d1cfcdb913adff; });

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");

var $5aOKN = parcelRequire("5aOKN");

var $lQ9iu = parcelRequire("lQ9iu");

var $cavNW = parcelRequire("cavNW");

var $EvJOn = parcelRequire("EvJOn");

var $lxjaT = parcelRequire("lxjaT");

var $jxn3L = parcelRequire("jxn3L");

var $4bctB = parcelRequire("4bctB");

var $lNLxd = parcelRequire("lNLxd");

var $jnM6Y = parcelRequire("jnM6Y");

var $9lQAN = parcelRequire("9lQAN");

var $3PTbz = parcelRequire("3PTbz");
"use strict";
const $420d974aae91c4e0$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
const $420d974aae91c4e0$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $420d974aae91c4e0$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $420d974aae91c4e0$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        (0, $i6lOf.defineReadOnly)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $lQ9iu.AddressCoder)(param.name);
            case "bool":
                return new (0, $EvJOn.BooleanCoder)(param.name);
            case "string":
                return new (0, $jnM6Y.StringCoder)(param.name);
            case "bytes":
                return new (0, $lxjaT.BytesCoder)(param.name);
            case "array":
                return new (0, $cavNW.ArrayCoder)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $9lQAN.TupleCoder)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $4bctB.NullCoder)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($420d974aae91c4e0$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $420d974aae91c4e0$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $lNLxd.NumberCoder)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($420d974aae91c4e0$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $420d974aae91c4e0$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $jxn3L.FixedBytesCoder)(size, param.name);
        }
        return $420d974aae91c4e0$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $5aOKN.Reader)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $5aOKN.Writer)(this._getWordSize());
    }
    getDefaultValue(types) {
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        return coder.defaultValue();
    }
    encode(types, values) {
        if (types.length !== values.length) $420d974aae91c4e0$var$logger.throwError("types/values length mismatch", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $3PTbz.ParamType).from(type)));
        const coder = new (0, $9lQAN.TupleCoder)(coders, "_");
        return coder.decode(this._getReader((0, $ApLZa.arrayify)(data), loose));
    }
}
const $420d974aae91c4e0$export$51d1cfcdb913adff = new $420d974aae91c4e0$export$fe041e1a83d3efc6();

});
parcelRegister("lQ9iu", function(module, exports) {

$parcel$export(module.exports, "AddressCoder", function () { return $fe65aa8688b9b674$export$59dbbded7775bfe7; });

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fe65aa8688b9b674$export$59dbbded7775bfe7 extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000";
    }
    encode(writer, value) {
        try {
            value = (0, $7pv2A.getAddress)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $7pv2A.getAddress)((0, $ApLZa.hexZeroPad)(reader.readValue().toHexString(), 20));
    }
}

});

parcelRegister("cavNW", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $8dbf16ede3c8aea2$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $8dbf16ede3c8aea2$export$417857010dc9287f; });
$parcel$export(module.exports, "ArrayCoder", function () { return $8dbf16ede3c8aea2$export$88bc419d2df11f54; });

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");

var $5aOKN = parcelRequire("5aOKN");

var $cuCr6 = parcelRequire("cuCr6");
"use strict";
const $8dbf16ede3c8aea2$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
function $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with missing names", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $8dbf16ede3c8aea2$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $8dbf16ede3c8aea2$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $8dbf16ede3c8aea2$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $5aOKN.Writer)(writer.wordSize);
    let dynamicWriter = new (0, $5aOKN.Writer)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $8bxC3.Logger).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $8bxC3.Logger).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            enumerable: true,
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $8dbf16ede3c8aea2$export$88bc419d2df11f54 extends (0, $5aOKN.Coder) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    defaultValue() {
        // Verifies the child coder is valid (even if the array is dynamic or 0-length)
        const defaultChild = this.coder.defaultValue();
        const result = [];
        for(let i = 0; i < this.length; i++)result.push(defaultChild);
        return result;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $8dbf16ede3c8aea2$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $8dbf16ede3c8aea2$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) {
            count = reader.readValue().toNumber();
            // Check that there is *roughly* enough data to ensure
            // stray random data is not being read as a length. Each
            // slot requires at least 32 bytes for their value (or 32
            // bytes as a link to the data). This could use a much
            // tighter bound, but we are erroring on the side of safety.
            if (count * 32 > reader._data.length) $8dbf16ede3c8aea2$var$logger.throwError("insufficient data length", (0, $8bxC3.Logger).errors.BUFFER_OVERRUN, {
                length: reader._data.length,
                count: count
            });
        }
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $cuCr6.AnonymousCoder)(this.coder));
        return reader.coerce(this.name, $8dbf16ede3c8aea2$export$417857010dc9287f(reader, coders));
    }
}

});
parcelRegister("cuCr6", function(module, exports) {

$parcel$export(module.exports, "AnonymousCoder", function () { return $91861a031176d8c1$export$87c41d1139a03fa2; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $91861a031176d8c1$export$87c41d1139a03fa2 extends (0, $5aOKN.Coder) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    defaultValue() {
        return this.coder.defaultValue();
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}

});


parcelRegister("EvJOn", function(module, exports) {

$parcel$export(module.exports, "BooleanCoder", function () { return $079c5b06dccd461b$export$fe9118d6c093150c; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $079c5b06dccd461b$export$fe9118d6c093150c extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    defaultValue() {
        return false;
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}

});

parcelRegister("lxjaT", function(module, exports) {

$parcel$export(module.exports, "DynamicBytesCoder", function () { return $fadb8dbc86f3f525$export$db9eadd8df12ad2e; });
$parcel$export(module.exports, "BytesCoder", function () { return $fadb8dbc86f3f525$export$e5823e9574df18d2; });

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fadb8dbc86f3f525$export$db9eadd8df12ad2e extends (0, $5aOKN.Coder) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    defaultValue() {
        return "0x";
    }
    encode(writer, value) {
        value = (0, $ApLZa.arrayify)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $fadb8dbc86f3f525$export$e5823e9574df18d2 extends $fadb8dbc86f3f525$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $ApLZa.hexlify)(super.decode(reader)));
    }
}

});

parcelRegister("jxn3L", function(module, exports) {

$parcel$export(module.exports, "FixedBytesCoder", function () { return $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a; });

var $ApLZa = parcelRequire("ApLZa");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $e392fc8f65f4ab4d$export$7dec9db68e6bcf5a extends (0, $5aOKN.Coder) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    defaultValue() {
        return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
    }
    encode(writer, value) {
        let data = (0, $ApLZa.arrayify)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $ApLZa.hexlify)(reader.readBytes(this.size)));
    }
}

});

parcelRegister("4bctB", function(module, exports) {

$parcel$export(module.exports, "NullCoder", function () { return $30b1de167c06c587$export$70982cadf2d6b4ec; });

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $30b1de167c06c587$export$70982cadf2d6b4ec extends (0, $5aOKN.Coder) {
    constructor(localName){
        super("null", "", localName, false);
    }
    defaultValue() {
        return null;
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}

});

parcelRegister("lNLxd", function(module, exports) {

$parcel$export(module.exports, "NumberCoder", function () { return $fdf30bf73ed9cc94$export$b934dc8cfe13938c; });

var $esOfL = parcelRequire("esOfL");

var $dktts = parcelRequire("dktts");

var $5aOKN = parcelRequire("5aOKN");
"use strict";
class $fdf30bf73ed9cc94$export$b934dc8cfe13938c extends (0, $5aOKN.Coder) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    defaultValue() {
        return 0;
    }
    encode(writer, value) {
        let v = (0, $esOfL.BigNumber).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $dktts.MaxUint256).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $dktts.One)).mul((0, $dktts.NegativeOne)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $dktts.Zero)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}

});
parcelRegister("dktts", function(module, exports) {

$parcel$export(module.exports, "NegativeOne", function () { return $9b44019502d48201$export$c83ef0909a6ddeec; });
$parcel$export(module.exports, "Zero", function () { return $9b44019502d48201$export$aaef8a3eae948f03; });
$parcel$export(module.exports, "One", function () { return $9b44019502d48201$export$9aa05a5866350bcf; });
$parcel$export(module.exports, "Two", function () { return $9b44019502d48201$export$9276dd97bf62cc8d; });
$parcel$export(module.exports, "WeiPerEther", function () { return $9b44019502d48201$export$c8db55bd7405209e; });
$parcel$export(module.exports, "MaxUint256", function () { return $9b44019502d48201$export$1b53890de5aabdd0; });
$parcel$export(module.exports, "MinInt256", function () { return $9b44019502d48201$export$963c9b9317b80aaf; });
$parcel$export(module.exports, "MaxInt256", function () { return $9b44019502d48201$export$6f8dbb07ebe6d738; });

var $esOfL = parcelRequire("esOfL");
const $9b44019502d48201$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $esOfL.BigNumber).from(-1);
const $9b44019502d48201$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $esOfL.BigNumber).from(0);
const $9b44019502d48201$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $esOfL.BigNumber).from(1);
const $9b44019502d48201$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $esOfL.BigNumber).from(2);
const $9b44019502d48201$export$c8db55bd7405209e = /*#__PURE__*/ (0, $esOfL.BigNumber).from("1000000000000000000");
const $9b44019502d48201$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $esOfL.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $9b44019502d48201$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $esOfL.BigNumber).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $9b44019502d48201$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $esOfL.BigNumber).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");

});


parcelRegister("jnM6Y", function(module, exports) {

$parcel$export(module.exports, "StringCoder", function () { return $e1c57c3faeb06af6$export$2d1b854518731426; });

var $aCHl8 = parcelRequire("aCHl8");

var $lxjaT = parcelRequire("lxjaT");
"use strict";
class $e1c57c3faeb06af6$export$2d1b854518731426 extends (0, $lxjaT.DynamicBytesCoder) {
    constructor(localName){
        super("string", localName);
    }
    defaultValue() {
        return "";
    }
    encode(writer, value) {
        return super.encode(writer, (0, $aCHl8.toUtf8Bytes)(value));
    }
    decode(reader) {
        return (0, $aCHl8.toUtf8String)(super.decode(reader));
    }
}

});

parcelRegister("9lQAN", function(module, exports) {

$parcel$export(module.exports, "TupleCoder", function () { return $6ceedefd2eee321a$export$e9fceba8f110fea6; });

var $5aOKN = parcelRequire("5aOKN");

var $cavNW = parcelRequire("cavNW");
"use strict";
class $6ceedefd2eee321a$export$e9fceba8f110fea6 extends (0, $5aOKN.Coder) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    defaultValue() {
        const values = [];
        this.coders.forEach((coder)=>{
            values.push(coder.defaultValue());
        });
        // We only output named properties for uniquely named coders
        const uniqueNames = this.coders.reduce((accum, coder)=>{
            const name = coder.localName;
            if (name) {
                if (!accum[name]) accum[name] = 0;
                accum[name]++;
            }
            return accum;
        }, {});
        // Add named values
        this.coders.forEach((coder, index)=>{
            let name = coder.localName;
            if (!name || uniqueNames[name] !== 1) return;
            if (name === "length") name = "_length";
            if (values[name] != null) return;
            values[name] = values[index];
        });
        return Object.freeze(values);
    }
    encode(writer, value) {
        return (0, $cavNW.pack)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $cavNW.unpack)(reader, this.coders));
    }
}

});

parcelRegister("3PTbz", function(module, exports) {

$parcel$export(module.exports, "FormatTypes", function () { return $2cb0f13975c97159$export$f010f239efc4d445; });
$parcel$export(module.exports, "ParamType", function () { return $2cb0f13975c97159$export$426dc07f493a4c47; });
$parcel$export(module.exports, "Fragment", function () { return $2cb0f13975c97159$export$ffb0004e005737fa; });
$parcel$export(module.exports, "FunctionFragment", function () { return $2cb0f13975c97159$export$8d576c928b93668f; });
$parcel$export(module.exports, "EventFragment", function () { return $2cb0f13975c97159$export$958548f08bac2833; });
$parcel$export(module.exports, "ConstructorFragment", function () { return $2cb0f13975c97159$export$3ac5c9504f801ea4; });
$parcel$export(module.exports, "ErrorFragment", function () { return $2cb0f13975c97159$export$2c42c6d543aa9b59; });

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $9kBWa = parcelRequire("9kBWa");
"use strict";
const $2cb0f13975c97159$var$logger = new (0, $8bxC3.Logger)((0, $9kBWa.version));
const $2cb0f13975c97159$var$_constructorGuard = {};
let $2cb0f13975c97159$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $2cb0f13975c97159$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $2cb0f13975c97159$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($2cb0f13975c97159$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($2cb0f13975c97159$var$ModifiersNest[name]) return true;
    }
    if ($2cb0f13975c97159$var$ModifiersBytes[name] || name === "payable") $2cb0f13975c97159$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $2cb0f13975c97159$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $2cb0f13975c97159$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $2cb0f13975c97159$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $2cb0f13975c97159$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $2cb0f13975c97159$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($2cb0f13975c97159$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $2cb0f13975c97159$var$verifyType(parent.type);
    return parent;
}
function $2cb0f13975c97159$var$populate(object, params) {
    for(let key in params)(0, $i6lOf.defineReadOnly)(object, key, params[key]);
}
const $2cb0f13975c97159$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readable with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $2cb0f13975c97159$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $2cb0f13975c97159$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use fromString", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        let match = this.type.match($2cb0f13975c97159$var$paramTypeArray);
        if (match) $2cb0f13975c97159$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $2cb0f13975c97159$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, address bar) indexed baz"
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $2cb0f13975c97159$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $2cb0f13975c97159$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $2cb0f13975c97159$export$426dc07f493a4c47($2cb0f13975c97159$var$_constructorGuard, {
            name: value.name || null,
            type: $2cb0f13975c97159$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $2cb0f13975c97159$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($2cb0f13975c97159$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $2cb0f13975c97159$var$parseParams(value, allowIndex) {
    return $2cb0f13975c97159$var$splitNesting(value).map((param)=>$2cb0f13975c97159$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $2cb0f13975c97159$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $2cb0f13975c97159$var$_constructorGuard) $2cb0f13975c97159$var$logger.throwError("use a static from method", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $2cb0f13975c97159$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $2cb0f13975c97159$export$ffb0004e005737fa.fromString(value);
        return $2cb0f13975c97159$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
            case "error":
                return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $2cb0f13975c97159$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value.trim());
        else if (value.split(" ")[0] === "error") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value.substring(5).trim());
        return $2cb0f13975c97159$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $2cb0f13975c97159$export$958548f08bac2833 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$958548f08bac2833.fromString(value);
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $2cb0f13975c97159$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $2cb0f13975c97159$export$958548f08bac2833($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($2cb0f13975c97159$var$regexParen);
        if (!match) $2cb0f13975c97159$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $2cb0f13975c97159$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $2cb0f13975c97159$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $2cb0f13975c97159$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $2cb0f13975c97159$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $2cb0f13975c97159$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $esOfL.BigNumber).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $2cb0f13975c97159$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $2cb0f13975c97159$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $2cb0f13975c97159$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $2cb0f13975c97159$export$3ac5c9504f801ea4 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.sighash) $2cb0f13975c97159$var$logger.throwError("cannot format a constructor for sighash", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromString(value);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        if (state.constant) $2cb0f13975c97159$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $esOfL.BigNumber).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$3ac5c9504f801ea4($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $2cb0f13975c97159$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2].trim(), false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        return $2cb0f13975c97159$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $2cb0f13975c97159$export$8d576c928b93668f extends $2cb0f13975c97159$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payable: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            outputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$8d576c928b93668f.fromString(value);
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $2cb0f13975c97159$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $2cb0f13975c97159$var$verifyState(value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $esOfL.BigNumber).from(value.gas) : null
        };
        return new $2cb0f13975c97159$export$8d576c928b93668f($2cb0f13975c97159$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $2cb0f13975c97159$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        $2cb0f13975c97159$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($2cb0f13975c97159$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $2cb0f13975c97159$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $2cb0f13975c97159$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $2cb0f13975c97159$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class StructFragment extends Fragment {
//}
function $2cb0f13975c97159$var$checkForbidden(fragment) {
    const sig = fragment.format();
    if (sig === "Error(string)" || sig === "Panic(uint256)") $2cb0f13975c97159$var$logger.throwArgumentError(`cannot specify user defined ${sig} error`, "fragment", fragment);
    return fragment;
}
class $2cb0f13975c97159$export$2c42c6d543aa9b59 extends $2cb0f13975c97159$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $2cb0f13975c97159$export$f010f239efc4d445.sighash;
        if (!$2cb0f13975c97159$export$f010f239efc4d445[format]) $2cb0f13975c97159$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $2cb0f13975c97159$export$f010f239efc4d445.json) return JSON.stringify({
            type: "error",
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $2cb0f13975c97159$export$f010f239efc4d445.sighash) result += "error ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $2cb0f13975c97159$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromString(value);
        return $2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(value);
    }
    static fromObject(value) {
        if ($2cb0f13975c97159$export$2c42c6d543aa9b59.isErrorFragment(value)) return value;
        if (value.type !== "error") $2cb0f13975c97159$var$logger.throwArgumentError("invalid error object", "value", value);
        const params = {
            type: value.type,
            name: $2cb0f13975c97159$var$verifyIdentifier(value.name),
            inputs: value.inputs ? value.inputs.map($2cb0f13975c97159$export$426dc07f493a4c47.fromObject) : []
        };
        return $2cb0f13975c97159$var$checkForbidden(new $2cb0f13975c97159$export$2c42c6d543aa9b59($2cb0f13975c97159$var$_constructorGuard, params));
    }
    static fromString(value) {
        let params = {
            type: "error"
        };
        let parens = value.match($2cb0f13975c97159$var$regexParen);
        if (!parens) $2cb0f13975c97159$var$logger.throwArgumentError("invalid error signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $2cb0f13975c97159$var$verifyIdentifier(params.name);
        params.inputs = $2cb0f13975c97159$var$parseParams(parens[2], false);
        return $2cb0f13975c97159$var$checkForbidden($2cb0f13975c97159$export$2c42c6d543aa9b59.fromObject(params));
    }
    static isErrorFragment(value) {
        return value && value._isFragment && value.type === "error";
    }
}
function $2cb0f13975c97159$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
// See: https://github.com/ethereum/solidity/blob/1f8f1a3db93a548d0555e3e14cfc55a10e25b60e/docs/grammar/SolidityLexer.g4#L234
const $2cb0f13975c97159$var$regexIdentifier = new RegExp("^[a-zA-Z$_][a-zA-Z0-9$_]*$");
function $2cb0f13975c97159$var$verifyIdentifier(value) {
    if (!value || !value.match($2cb0f13975c97159$var$regexIdentifier)) $2cb0f13975c97159$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $2cb0f13975c97159$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $2cb0f13975c97159$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $2cb0f13975c97159$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}

});



parcelRegister("dGRwz", function(module, exports) {

$parcel$export(module.exports, "ForkEvent", function () { return $9f78b76a8aa61745$export$406ece1549ccd00e; });
$parcel$export(module.exports, "Provider", function () { return $9f78b76a8aa61745$export$2881499e37b75b9a; });

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $7hdOf = parcelRequire("7hdOf");
"use strict";
var $9f78b76a8aa61745$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9f78b76a8aa61745$var$logger = new (0, $8bxC3.Logger)((0, $7hdOf.version));
class $9f78b76a8aa61745$export$406ece1549ccd00e extends (0, $i6lOf.Description) {
    static isForkEvent(value) {
        return !!(value && value._isForkEvent);
    }
}
class $9f78b76a8aa61745$export$5b2cada8494f9d99 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(blockHash, expiry){
        if (!(0, $ApLZa.isHexString)(blockHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid blockHash", "blockHash", blockHash);
        super({
            _isForkEvent: true,
            _isBlockForkEvent: true,
            expiry: expiry || 0,
            blockHash: blockHash
        });
    }
}
class $9f78b76a8aa61745$export$26bcd61a55716c98 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(hash, expiry){
        if (!(0, $ApLZa.isHexString)(hash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "hash", hash);
        super({
            _isForkEvent: true,
            _isTransactionForkEvent: true,
            expiry: expiry || 0,
            hash: hash
        });
    }
}
class $9f78b76a8aa61745$export$8f8609bfee47c93 extends $9f78b76a8aa61745$export$406ece1549ccd00e {
    constructor(beforeHash, afterHash, expiry){
        if (!(0, $ApLZa.isHexString)(beforeHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "beforeHash", beforeHash);
        if (!(0, $ApLZa.isHexString)(afterHash, 32)) $9f78b76a8aa61745$var$logger.throwArgumentError("invalid transaction hash", "afterHash", afterHash);
        super({
            _isForkEvent: true,
            _isTransactionOrderForkEvent: true,
            expiry: expiry || 0,
            beforeHash: beforeHash,
            afterHash: afterHash
        });
    }
}
class $9f78b76a8aa61745$export$2881499e37b75b9a {
    constructor(){
        $9f78b76a8aa61745$var$logger.checkAbstract(new.target, $9f78b76a8aa61745$export$2881499e37b75b9a);
        (0, $i6lOf.defineReadOnly)(this, "_isProvider", true);
    }
    getFeeData() {
        return $9f78b76a8aa61745$var$__awaiter(this, void 0, void 0, function*() {
            const { block: block, gasPrice: gasPrice } = yield (0, $i6lOf.resolveProperties)({
                block: this.getBlock("latest"),
                gasPrice: this.getGasPrice().catch((error)=>{
                    // @TODO: Why is this now failing on Calaveras?
                    //console.log(error);
                    return null;
                })
            });
            let lastBaseFeePerGas = null, maxFeePerGas = null, maxPriorityFeePerGas = null;
            if (block && block.baseFeePerGas) {
                // We may want to compute this more accurately in the future,
                // using the formula "check if the base fee is correct".
                // See: https://eips.ethereum.org/EIPS/eip-1559
                lastBaseFeePerGas = block.baseFeePerGas;
                maxPriorityFeePerGas = (0, $esOfL.BigNumber).from("1500000000");
                maxFeePerGas = block.baseFeePerGas.mul(2).add(maxPriorityFeePerGas);
            }
            return {
                lastBaseFeePerGas: lastBaseFeePerGas,
                maxFeePerGas: maxFeePerGas,
                maxPriorityFeePerGas: maxPriorityFeePerGas,
                gasPrice: gasPrice
            };
        });
    }
    // Alias for "on"
    addListener(eventName, listener) {
        return this.on(eventName, listener);
    }
    // Alias for "off"
    removeListener(eventName, listener) {
        return this.off(eventName, listener);
    }
    static isProvider(value) {
        return !!(value && value._isProvider);
    }
}

});
parcelRegister("7hdOf", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $54c4d53839b76b1a$export$83d89fbfd8236492; });
const $54c4d53839b76b1a$export$83d89fbfd8236492 = "abstract-provider/5.7.0";

});


parcelRegister("oWESm", function(module, exports) {

$parcel$export(module.exports, "Signer", function () { return $04afbe51d47fcc12$export$fdf54fdde81cc9f0; });
$parcel$export(module.exports, "VoidSigner", function () { return $04afbe51d47fcc12$export$7dbc56d9b9612bad; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $5qeYy = parcelRequire("5qeYy");
"use strict";
var $04afbe51d47fcc12$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $04afbe51d47fcc12$var$logger = new (0, $8bxC3.Logger)((0, $5qeYy.version));
const $04afbe51d47fcc12$var$allowedTransactionKeys = [
    "accessList",
    "ccipReadEnabled",
    "chainId",
    "customData",
    "data",
    "from",
    "gasLimit",
    "gasPrice",
    "maxFeePerGas",
    "maxPriorityFeePerGas",
    "nonce",
    "to",
    "type",
    "value"
];
const $04afbe51d47fcc12$var$forwardErrors = [
    (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $8bxC3.Logger).errors.NONCE_EXPIRED,
    (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED
];
class $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    ///////////////////
    // Sub-classes MUST call super
    constructor(){
        $04afbe51d47fcc12$var$logger.checkAbstract(new.target, $04afbe51d47fcc12$export$fdf54fdde81cc9f0);
        (0, $i6lOf.defineReadOnly)(this, "_isSigner", true);
    }
    ///////////////////
    // Sub-classes MAY override these
    getBalance(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getBalance");
            return yield this.provider.getBalance(this.getAddress(), blockTag);
        });
    }
    getTransactionCount(blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getTransactionCount");
            return yield this.provider.getTransactionCount(this.getAddress(), blockTag);
        });
    }
    // Populates "from" if unspecified, and estimates the gas for the transaction
    estimateGas(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("estimateGas");
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.estimateGas(tx);
        });
    }
    // Populates "from" if unspecified, and calls with the transaction
    call(transaction, blockTag) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("call");
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            return yield this.provider.call(tx, blockTag);
        });
    }
    // Populates all fields in a transaction, signs it and sends it to the network
    sendTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("sendTransaction");
            const tx = yield this.populateTransaction(transaction);
            const signedTx = yield this.signTransaction(tx);
            return yield this.provider.sendTransaction(signedTx);
        });
    }
    getChainId() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getChainId");
            const network = yield this.provider.getNetwork();
            return network.chainId;
        });
    }
    getGasPrice() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getGasPrice");
            return yield this.provider.getGasPrice();
        });
    }
    getFeeData() {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("getFeeData");
            return yield this.provider.getFeeData();
        });
    }
    resolveName(name) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            this._checkProvider("resolveName");
            return yield this.provider.resolveName(name);
        });
    }
    // Checks a transaction does not contain invalid keys and if
    // no "from" is provided, populates it.
    // - does NOT require a provider
    // - adds "from" is not present
    // - returns a COPY (safe to mutate the result)
    // By default called from: (overriding these prevents it)
    //   - call
    //   - estimateGas
    //   - populateTransaction (and therefor sendTransaction)
    checkTransaction(transaction) {
        for(const key in transaction)if ($04afbe51d47fcc12$var$allowedTransactionKeys.indexOf(key) === -1) $04afbe51d47fcc12$var$logger.throwArgumentError("invalid transaction key: " + key, "transaction", transaction);
        const tx = (0, $i6lOf.shallowCopy)(transaction);
        if (tx.from == null) tx.from = this.getAddress();
        else // Make sure any provided address matches this signer
        tx.from = Promise.all([
            Promise.resolve(tx.from),
            this.getAddress()
        ]).then((result)=>{
            if (result[0].toLowerCase() !== result[1].toLowerCase()) $04afbe51d47fcc12$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            return result[0];
        });
        return tx;
    }
    // Populates ALL keys for a transaction and checks that "from" matches
    // this Signer. Should be used by sendTransaction but NOT by signTransaction.
    // By default called from: (overriding these prevents it)
    //   - sendTransaction
    //
    // Notes:
    //  - We allow gasPrice for EIP-1559 as long as it matches maxFeePerGas
    populateTransaction(transaction) {
        return $04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $i6lOf.resolveProperties)(this.checkTransaction(transaction));
            if (tx.to != null) {
                tx.to = Promise.resolve(tx.to).then((to)=>$04afbe51d47fcc12$var$__awaiter(this, void 0, void 0, function*() {
                        if (to == null) return null;
                        const address = yield this.resolveName(to);
                        if (address == null) $04afbe51d47fcc12$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                        return address;
                    }));
                // Prevent this error from causing an UnhandledPromiseException
                tx.to.catch((error)=>{});
            }
            // Do not allow mixing pre-eip-1559 and eip-1559 properties
            const hasEip1559 = tx.maxFeePerGas != null || tx.maxPriorityFeePerGas != null;
            if (tx.gasPrice != null && (tx.type === 2 || hasEip1559)) $04afbe51d47fcc12$var$logger.throwArgumentError("eip-1559 transaction do not support gasPrice", "transaction", transaction);
            else if ((tx.type === 0 || tx.type === 1) && hasEip1559) $04afbe51d47fcc12$var$logger.throwArgumentError("pre-eip-1559 transaction do not support maxFeePerGas/maxPriorityFeePerGas", "transaction", transaction);
            if ((tx.type === 2 || tx.type == null) && tx.maxFeePerGas != null && tx.maxPriorityFeePerGas != null) // Fully-formed EIP-1559 transaction (skip getFeeData)
            tx.type = 2;
            else if (tx.type === 0 || tx.type === 1) // Explicit Legacy or EIP-2930 transaction
            // Populate missing gasPrice
            {
                if (tx.gasPrice == null) tx.gasPrice = this.getGasPrice();
            } else {
                // We need to get fee data to determine things
                const feeData = yield this.getFeeData();
                if (tx.type == null) {
                    // We need to auto-detect the intended type of this transaction...
                    if (feeData.maxFeePerGas != null && feeData.maxPriorityFeePerGas != null) {
                        // The network supports EIP-1559!
                        // Upgrade transaction from null to eip-1559
                        tx.type = 2;
                        if (tx.gasPrice != null) {
                            // Using legacy gasPrice property on an eip-1559 network,
                            // so use gasPrice as both fee properties
                            const gasPrice = tx.gasPrice;
                            delete tx.gasPrice;
                            tx.maxFeePerGas = gasPrice;
                            tx.maxPriorityFeePerGas = gasPrice;
                        } else {
                            // Populate missing fee data
                            if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                            if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                        }
                    } else if (feeData.gasPrice != null) {
                        // Network doesn't support EIP-1559...
                        // ...but they are trying to use EIP-1559 properties
                        if (hasEip1559) $04afbe51d47fcc12$var$logger.throwError("network does not support EIP-1559", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                            operation: "populateTransaction"
                        });
                        // Populate missing fee data
                        if (tx.gasPrice == null) tx.gasPrice = feeData.gasPrice;
                        // Explicitly set untyped transaction to legacy
                        tx.type = 0;
                    } else // getFeeData has failed us.
                    $04afbe51d47fcc12$var$logger.throwError("failed to get consistent fee data", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                        operation: "signer.getFeeData"
                    });
                } else if (tx.type === 2) {
                    // Explicitly using EIP-1559
                    // Populate missing fee data
                    if (tx.maxFeePerGas == null) tx.maxFeePerGas = feeData.maxFeePerGas;
                    if (tx.maxPriorityFeePerGas == null) tx.maxPriorityFeePerGas = feeData.maxPriorityFeePerGas;
                }
            }
            if (tx.nonce == null) tx.nonce = this.getTransactionCount("pending");
            if (tx.gasLimit == null) tx.gasLimit = this.estimateGas(tx).catch((error)=>{
                if ($04afbe51d47fcc12$var$forwardErrors.indexOf(error.code) >= 0) throw error;
                return $04afbe51d47fcc12$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
                    error: error,
                    tx: tx
                });
            });
            if (tx.chainId == null) tx.chainId = this.getChainId();
            else tx.chainId = Promise.all([
                Promise.resolve(tx.chainId),
                this.getChainId()
            ]).then((results)=>{
                if (results[1] !== 0 && results[0] !== results[1]) $04afbe51d47fcc12$var$logger.throwArgumentError("chainId address mismatch", "transaction", transaction);
                return results[0];
            });
            return yield (0, $i6lOf.resolveProperties)(tx);
        });
    }
    ///////////////////
    // Sub-classes SHOULD leave these alone
    _checkProvider(operation) {
        if (!this.provider) $04afbe51d47fcc12$var$logger.throwError("missing provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: operation || "_checkProvider"
        });
    }
    static isSigner(value) {
        return !!(value && value._isSigner);
    }
}
class $04afbe51d47fcc12$export$7dbc56d9b9612bad extends $04afbe51d47fcc12$export$fdf54fdde81cc9f0 {
    constructor(address, provider){
        super();
        (0, $i6lOf.defineReadOnly)(this, "address", address);
        (0, $i6lOf.defineReadOnly)(this, "provider", provider || null);
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    _fail(message, operation) {
        return Promise.resolve().then(()=>{
            $04afbe51d47fcc12$var$logger.throwError(message, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation
            });
        });
    }
    signMessage(message) {
        return this._fail("VoidSigner cannot sign messages", "signMessage");
    }
    signTransaction(transaction) {
        return this._fail("VoidSigner cannot sign transactions", "signTransaction");
    }
    _signTypedData(domain, types, value) {
        return this._fail("VoidSigner cannot sign typed data", "signTypedData");
    }
    connect(provider) {
        return new $04afbe51d47fcc12$export$7dbc56d9b9612bad(this.address, provider);
    }
}

});
parcelRegister("5qeYy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f2aff55e3d3791c$export$83d89fbfd8236492; });
const $3f2aff55e3d3791c$export$83d89fbfd8236492 = "abstract-signer/5.7.0";

});


parcelRegister("5LK3h", function(module, exports) {

$parcel$export(module.exports, "TransactionTypes", function () { return $4335107f861a4482$export$80349e05e0724e11; });
$parcel$export(module.exports, "computeAddress", function () { return $4335107f861a4482$export$e67e2732ba9803f9; });
$parcel$export(module.exports, "recoverAddress", function () { return $4335107f861a4482$export$23cc18f96d8510e2; });
$parcel$export(module.exports, "accessListify", function () { return $4335107f861a4482$export$6c8662b1600dce2; });
$parcel$export(module.exports, "serialize", function () { return $4335107f861a4482$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "parse", function () { return $4335107f861a4482$export$98e6a39c04603d36; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $dktts = parcelRequire("dktts");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $2blqG = parcelRequire("2blqG");

var $6ltHX = parcelRequire("6ltHX");

var $8bxC3 = parcelRequire("8bxC3");

var $9fjzQ = parcelRequire("9fjzQ");
"use strict";
const $4335107f861a4482$var$logger = new (0, $8bxC3.Logger)((0, $9fjzQ.version));
var $4335107f861a4482$export$80349e05e0724e11;
(function(TransactionTypes) {
    TransactionTypes[TransactionTypes["legacy"] = 0] = "legacy";
    TransactionTypes[TransactionTypes["eip2930"] = 1] = "eip2930";
    TransactionTypes[TransactionTypes["eip1559"] = 2] = "eip1559";
})($4335107f861a4482$export$80349e05e0724e11 || ($4335107f861a4482$export$80349e05e0724e11 = {}));
///////////////////////////////
function $4335107f861a4482$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $7pv2A.getAddress)(value);
}
function $4335107f861a4482$var$handleNumber(value) {
    if (value === "0x") return 0, $dktts.Zero;
    return (0, $esOfL.BigNumber).from(value);
}
// Legacy Transaction Fields
const $4335107f861a4482$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $4335107f861a4482$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    type: true,
    value: true
};
function $4335107f861a4482$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $6ltHX.computePublicKey)(key);
    return (0, $7pv2A.getAddress)((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.hexDataSlice)(publicKey, 1)), 12));
}
function $4335107f861a4482$export$23cc18f96d8510e2(digest, signature) {
    return $4335107f861a4482$export$e67e2732ba9803f9((0, $6ltHX.recoverPublicKey)((0, $ApLZa.arrayify)(digest), signature));
}
function $4335107f861a4482$var$formatNumber(value, name) {
    const result = (0, $ApLZa.stripZeros)((0, $esOfL.BigNumber).from(value).toHexString());
    if (result.length > 32) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $4335107f861a4482$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $7pv2A.getAddress)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $ApLZa.hexDataLength)(storageKey) !== 32) $4335107f861a4482$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $4335107f861a4482$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $4335107f861a4482$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $4335107f861a4482$var$accessSetify(set[0], set[1]);
        }
        return $4335107f861a4482$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $4335107f861a4482$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $4335107f861a4482$var$formatAccessList(value) {
    return $4335107f861a4482$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $4335107f861a4482$var$_serializeEip1559(transaction, signature) {
    // If there is an explicit gasPrice, make sure it matches the
    // EIP-1559 fees; otherwise they may not understand what they
    // think they are setting in terms of fee.
    if (transaction.gasPrice != null) {
        const gasPrice = (0, $esOfL.BigNumber).from(transaction.gasPrice);
        const maxFeePerGas = (0, $esOfL.BigNumber).from(transaction.maxFeePerGas || 0);
        if (!gasPrice.eq(maxFeePerGas)) $4335107f861a4482$var$logger.throwArgumentError("mismatch EIP-1559 gasPrice != maxFeePerGas", "tx", {
            gasPrice: gasPrice,
            maxFeePerGas: maxFeePerGas
        });
    }
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.maxPriorityFeePerGas || 0, "maxPriorityFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.maxFeePerGas || 0, "maxFeePerGas"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $7pv2A.getAddress)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ApLZa.splitSignature)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ApLZa.stripZeros)(sig.r));
        fields.push((0, $ApLZa.stripZeros)(sig.s));
    }
    return (0, $ApLZa.hexConcat)([
        "0x02",
        $2blqG.encode(fields)
    ]);
}
function $4335107f861a4482$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $4335107f861a4482$var$formatNumber(transaction.chainId || 0, "chainId"),
        $4335107f861a4482$var$formatNumber(transaction.nonce || 0, "nonce"),
        $4335107f861a4482$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $4335107f861a4482$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $7pv2A.getAddress)(transaction.to) : "0x",
        $4335107f861a4482$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $4335107f861a4482$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $ApLZa.splitSignature)(signature);
        fields.push($4335107f861a4482$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $ApLZa.stripZeros)(sig.r));
        fields.push((0, $ApLZa.stripZeros)(sig.s));
    }
    return (0, $ApLZa.hexConcat)([
        "0x01",
        $2blqG.encode(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_serialize(transaction, signature) {
    (0, $i6lOf.checkProperties)(transaction, $4335107f861a4482$var$allowedTransactionKeys);
    const raw = [];
    $4335107f861a4482$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $ApLZa.arrayify)((0, $ApLZa.hexlify)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $ApLZa.stripZeros)(value);
            if (value.length > fieldInfo.maxLength) $4335107f861a4482$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $ApLZa.hexlify)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $4335107f861a4482$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $ApLZa.isBytesLike)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $ApLZa.hexlify)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transaction
    if (!signature) return $2blqG.encode(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $ApLZa.splitSignature)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $4335107f861a4482$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $ApLZa.hexlify)(v));
    raw.push((0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)(sig.r)));
    raw.push((0, $ApLZa.stripZeros)((0, $ApLZa.arrayify)(sig.s)));
    return $2blqG.encode(raw);
}
function $4335107f861a4482$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null || transaction.type === 0) {
        if (transaction.accessList != null) $4335107f861a4482$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $4335107f861a4482$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $4335107f861a4482$var$_serializeEip2930(transaction, signature);
        case 2:
            return $4335107f861a4482$var$_serializeEip1559(transaction, signature);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $4335107f861a4482$var$_parseEipSignature(tx, fields, serialize) {
    try {
        const recid = $4335107f861a4482$var$handleNumber(fields[0]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $4335107f861a4482$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", fields[0]);
    }
    tx.r = (0, $ApLZa.hexZeroPad)(fields[1], 32);
    tx.s = (0, $ApLZa.hexZeroPad)(fields[2], 32);
    try {
        const digest = (0, $8unkG.keccak256)(serialize(tx));
        tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {}
}
function $4335107f861a4482$var$_parseEip1559(payload) {
    const transaction = $2blqG.decode(payload.slice(1));
    if (transaction.length !== 9 && transaction.length !== 12) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 2", "payload", (0, $ApLZa.hexlify)(payload));
    const maxPriorityFeePerGas = $4335107f861a4482$var$handleNumber(transaction[2]);
    const maxFeePerGas = $4335107f861a4482$var$handleNumber(transaction[3]);
    const tx = {
        type: 2,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        maxPriorityFeePerGas: maxPriorityFeePerGas,
        maxFeePerGas: maxFeePerGas,
        gasPrice: null,
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[4]),
        to: $4335107f861a4482$var$handleAddress(transaction[5]),
        value: $4335107f861a4482$var$handleNumber(transaction[6]),
        data: transaction[7],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[8])
    };
    // Unsigned EIP-1559 Transaction
    if (transaction.length === 9) return tx;
    tx.hash = (0, $8unkG.keccak256)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(9), $4335107f861a4482$var$_serializeEip1559);
    return tx;
}
function $4335107f861a4482$var$_parseEip2930(payload) {
    const transaction = $2blqG.decode(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $4335107f861a4482$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $ApLZa.hexlify)(payload));
    const tx = {
        type: 1,
        chainId: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        nonce: $4335107f861a4482$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[2]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[3]),
        to: $4335107f861a4482$var$handleAddress(transaction[4]),
        value: $4335107f861a4482$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $4335107f861a4482$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    tx.hash = (0, $8unkG.keccak256)(payload);
    $4335107f861a4482$var$_parseEipSignature(tx, transaction.slice(8), $4335107f861a4482$var$_serializeEip2930);
    return tx;
}
// Legacy Transactions and EIP-155
function $4335107f861a4482$var$_parse(rawTransaction) {
    const transaction = $2blqG.decode(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $4335107f861a4482$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $4335107f861a4482$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $4335107f861a4482$var$handleNumber(transaction[1]),
        gasLimit: $4335107f861a4482$var$handleNumber(transaction[2]),
        to: $4335107f861a4482$var$handleAddress(transaction[3]),
        value: $4335107f861a4482$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $esOfL.BigNumber).from(transaction[6]).toNumber();
    } catch (error) {
        // @TODO: What makes snese to do? The v is too big
        return tx;
    }
    tx.r = (0, $ApLZa.hexZeroPad)(transaction[7], 32);
    tx.s = (0, $ApLZa.hexZeroPad)(transaction[8], 32);
    if ((0, $esOfL.BigNumber).from(tx.r).isZero() && (0, $esOfL.BigNumber).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Transaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $ApLZa.hexlify)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $8unkG.keccak256)($2blqG.encode(raw));
        try {
            tx.from = $4335107f861a4482$export$23cc18f96d8510e2(digest, {
                r: (0, $ApLZa.hexlify)(tx.r),
                s: (0, $ApLZa.hexlify)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {}
        tx.hash = (0, $8unkG.keccak256)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $4335107f861a4482$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $ApLZa.arrayify)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $4335107f861a4482$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $4335107f861a4482$var$_parseEip2930(payload);
        case 2:
            return $4335107f861a4482$var$_parseEip1559(payload);
        default:
            break;
    }
    return $4335107f861a4482$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}

});
parcelRegister("6ltHX", function(module, exports) {

$parcel$export(module.exports, "SigningKey", function () { return $49ebbfa7c2be841e$export$21643ca94aed3e83; });
$parcel$export(module.exports, "computePublicKey", function () { return $49ebbfa7c2be841e$export$4a89473d39301224; });
$parcel$export(module.exports, "recoverPublicKey", function () { return $49ebbfa7c2be841e$export$952dd09fbe0232b7; });

var $3roJS = parcelRequire("3roJS");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $doGL2 = parcelRequire("doGL2");
"use strict";
const $49ebbfa7c2be841e$var$logger = new (0, $8bxC3.Logger)((0, $doGL2.version));
let $49ebbfa7c2be841e$var$_curve = null;
function $49ebbfa7c2be841e$var$getCurve() {
    if (!$49ebbfa7c2be841e$var$_curve) $49ebbfa7c2be841e$var$_curve = new (0, $3roJS.EC)("secp256k1");
    return $49ebbfa7c2be841e$var$_curve;
}
class $49ebbfa7c2be841e$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $i6lOf.defineReadOnly)(this, "curve", "secp256k1");
        (0, $i6lOf.defineReadOnly)(this, "privateKey", (0, $ApLZa.hexlify)(privateKey));
        if ((0, $ApLZa.hexDataLength)(this.privateKey) !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid private key", "privateKey", "[[ REDACTED ]]");
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        (0, $i6lOf.defineReadOnly)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $i6lOf.defineReadOnly)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $i6lOf.defineReadOnly)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)(this.publicKey));
        const p1 = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        const digestBytes = (0, $ApLZa.arrayify)(digest);
        if (digestBytes.length !== 32) $49ebbfa7c2be841e$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $ApLZa.splitSignature)({
            recoveryParam: signature.recoveryParam,
            r: (0, $ApLZa.hexZeroPad)("0x" + signature.r.toString(16), 32),
            s: (0, $ApLZa.hexZeroPad)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPrivate((0, $ApLZa.arrayify)(this.privateKey));
        const otherKeyPair = $49ebbfa7c2be841e$var$getCurve().keyFromPublic((0, $ApLZa.arrayify)($49ebbfa7c2be841e$export$4a89473d39301224(otherKey)));
        return (0, $ApLZa.hexZeroPad)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $49ebbfa7c2be841e$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $ApLZa.splitSignature)(signature);
    const rs = {
        r: (0, $ApLZa.arrayify)(sig.r),
        s: (0, $ApLZa.arrayify)(sig.s)
    };
    return "0x" + $49ebbfa7c2be841e$var$getCurve().recoverPubKey((0, $ApLZa.arrayify)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $49ebbfa7c2be841e$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $ApLZa.arrayify)(key);
    if (bytes.length === 32) {
        const signingKey = new $49ebbfa7c2be841e$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $ApLZa.hexlify)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $ApLZa.hexlify)(bytes);
        return "0x" + $49ebbfa7c2be841e$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $49ebbfa7c2be841e$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}

});
parcelRegister("3roJS", function(module, exports) {

$parcel$export(module.exports, "EC", function () { return $281715568a2bf9a7$export$129fe12d32abc311; });

var $9we9E = parcelRequire("9we9E");

var $leqJp = parcelRequire("leqJp");
var $281715568a2bf9a7$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $281715568a2bf9a7$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $281715568a2bf9a7$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $281715568a2bf9a7$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $281715568a2bf9a7$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $281715568a2bf9a7$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $281715568a2bf9a7$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $281715568a2bf9a7$var$minimalisticAssert = $281715568a2bf9a7$var$assert;
function $281715568a2bf9a7$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$281715568a2bf9a7$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $281715568a2bf9a7$var$utils_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $281715568a2bf9a7$var$utils_1$1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $281715568a2bf9a7$var$minimalisticAssert;
    utils.toArray = $281715568a2bf9a7$var$utils_1.toArray;
    utils.zero2 = $281715568a2bf9a7$var$utils_1.zero2;
    utils.toHex = $281715568a2bf9a7$var$utils_1.toHex;
    utils.encode = $281715568a2bf9a7$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $281715568a2bf9a7$var$getNAF = $281715568a2bf9a7$var$utils_1$1.getNAF;
var $281715568a2bf9a7$var$getJSF = $281715568a2bf9a7$var$utils_1$1.getJSF;
var $281715568a2bf9a7$var$assert$1 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $281715568a2bf9a7$var$base = $281715568a2bf9a7$var$BaseCurve;
$281715568a2bf9a7$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $281715568a2bf9a7$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $281715568a2bf9a7$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $281715568a2bf9a7$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $281715568a2bf9a7$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$281715568a2bf9a7$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $281715568a2bf9a7$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $281715568a2bf9a7$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $281715568a2bf9a7$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $281715568a2bf9a7$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$281715568a2bf9a7$var$BaseCurve.BasePoint = $281715568a2bf9a7$var$BasePoint;
$281715568a2bf9a7$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$281715568a2bf9a7$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$281715568a2bf9a7$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $281715568a2bf9a7$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $281715568a2bf9a7$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$281715568a2bf9a7$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$281715568a2bf9a7$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$281715568a2bf9a7$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $281715568a2bf9a7$var$utils_1$1.encode(this._encode(compact), enc);
};
$281715568a2bf9a7$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$281715568a2bf9a7$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$281715568a2bf9a7$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$281715568a2bf9a7$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$281715568a2bf9a7$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $281715568a2bf9a7$var$inherits_browser = $281715568a2bf9a7$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $281715568a2bf9a7$var$assert$2 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$ShortCurve(conf) {
    $281715568a2bf9a7$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$ShortCurve, $281715568a2bf9a7$var$base);
var $281715568a2bf9a7$var$short_1 = $281715568a2bf9a7$var$ShortCurve;
$281715568a2bf9a7$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $281715568a2bf9a7$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($9we9E))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$281715568a2bf9a7$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$281715568a2bf9a7$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $281715568a2bf9a7$var$Point(curve, x, y, isRed) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$Point, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $281715568a2bf9a7$var$Point(this, x, y, isRed);
};
$281715568a2bf9a7$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $281715568a2bf9a7$var$Point.fromJSON(this, obj, red);
};
$281715568a2bf9a7$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$281715568a2bf9a7$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$281715568a2bf9a7$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$281715568a2bf9a7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$281715568a2bf9a7$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$281715568a2bf9a7$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$281715568a2bf9a7$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$281715568a2bf9a7$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$281715568a2bf9a7$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$281715568a2bf9a7$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$281715568a2bf9a7$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$281715568a2bf9a7$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $281715568a2bf9a7$var$JPoint(curve, x, y, z) {
    $281715568a2bf9a7$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$281715568a2bf9a7$var$inherits_browser($281715568a2bf9a7$var$JPoint, $281715568a2bf9a7$var$base.BasePoint);
$281715568a2bf9a7$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $281715568a2bf9a7$var$JPoint(this, x, y, z);
};
$281715568a2bf9a7$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$281715568a2bf9a7$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$281715568a2bf9a7$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$281715568a2bf9a7$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$281715568a2bf9a7$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$281715568a2bf9a7$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$281715568a2bf9a7$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$281715568a2bf9a7$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$281715568a2bf9a7$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$281715568a2bf9a7$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $281715568a2bf9a7$var$curve_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $281715568a2bf9a7$var$base;
    curve.short = $281715568a2bf9a7$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $281715568a2bf9a7$var$curves_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $281715568a2bf9a7$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $281715568a2bf9a7$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $281715568a2bf9a7$var$curve_1.edwards(options);
        else this.curve = new $281715568a2bf9a7$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $281715568a2bf9a7$var$HmacDRBG(options) {
    if (!(this instanceof $281715568a2bf9a7$var$HmacDRBG)) return new $281715568a2bf9a7$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $281715568a2bf9a7$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $281715568a2bf9a7$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $281715568a2bf9a7$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $281715568a2bf9a7$var$hmacDrbg = $281715568a2bf9a7$var$HmacDRBG;
$281715568a2bf9a7$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$281715568a2bf9a7$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac(this.hash, this.K);
};
$281715568a2bf9a7$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$281715568a2bf9a7$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $281715568a2bf9a7$var$utils_1.toArray(entropy, entropyEnc);
    add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc);
    $281715568a2bf9a7$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$281715568a2bf9a7$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $281715568a2bf9a7$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $281715568a2bf9a7$var$utils_1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$assert$3 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $281715568a2bf9a7$var$key = $281715568a2bf9a7$var$KeyPair;
$281715568a2bf9a7$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $281715568a2bf9a7$var$KeyPair) return pub;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $281715568a2bf9a7$var$KeyPair) return priv;
    return new $281715568a2bf9a7$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$281715568a2bf9a7$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$281715568a2bf9a7$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$281715568a2bf9a7$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$281715568a2bf9a7$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$281715568a2bf9a7$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $281715568a2bf9a7$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $281715568a2bf9a7$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$281715568a2bf9a7$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $281715568a2bf9a7$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$281715568a2bf9a7$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$281715568a2bf9a7$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$281715568a2bf9a7$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $281715568a2bf9a7$var$assert$4 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$Signature(options, enc) {
    if (options instanceof $281715568a2bf9a7$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $281715568a2bf9a7$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $281715568a2bf9a7$var$signature = $281715568a2bf9a7$var$Signature;
function $281715568a2bf9a7$var$Position() {
    this.place = 0;
}
function $281715568a2bf9a7$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $281715568a2bf9a7$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$281715568a2bf9a7$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $281715568a2bf9a7$var$utils_1$1.toArray(data, enc);
    var p = new $281715568a2bf9a7$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $281715568a2bf9a7$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $281715568a2bf9a7$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $281715568a2bf9a7$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(s);
    this.recoveryParam = null;
    return true;
};
function $281715568a2bf9a7$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$281715568a2bf9a7$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $281715568a2bf9a7$var$rmPadding(r);
    s = $281715568a2bf9a7$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $281715568a2bf9a7$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $281715568a2bf9a7$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $281715568a2bf9a7$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $281715568a2bf9a7$var$utils_1$1.encode(res, enc);
};
"use strict";
var $281715568a2bf9a7$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $281715568a2bf9a7$var$assert$5 = $281715568a2bf9a7$var$utils_1$1.assert;
function $281715568a2bf9a7$var$EC(options) {
    if (!(this instanceof $281715568a2bf9a7$var$EC)) return new $281715568a2bf9a7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $281715568a2bf9a7$var$assert$5(Object.prototype.hasOwnProperty.call($281715568a2bf9a7$var$curves_1, options), "Unknown curve " + options);
        options = $281715568a2bf9a7$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $281715568a2bf9a7$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $281715568a2bf9a7$var$ec = $281715568a2bf9a7$var$EC;
$281715568a2bf9a7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $281715568a2bf9a7$var$key(this, options);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $281715568a2bf9a7$var$key.fromPrivate(this, priv, enc);
};
$281715568a2bf9a7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $281715568a2bf9a7$var$key.fromPublic(this, pub, enc);
};
$281715568a2bf9a7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $281715568a2bf9a7$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$281715568a2bf9a7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$281715568a2bf9a7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $281715568a2bf9a7$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $281715568a2bf9a7$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$281715568a2bf9a7$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$281715568a2bf9a7$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $281715568a2bf9a7$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($9we9E)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$281715568a2bf9a7$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $281715568a2bf9a7$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $281715568a2bf9a7$var$elliptic_1 = $281715568a2bf9a7$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $281715568a2bf9a7$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $281715568a2bf9a7$var$curve_1;
    elliptic.curves = $281715568a2bf9a7$var$curves_1;
    // Protocols
    elliptic.ec = $281715568a2bf9a7$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $281715568a2bf9a7$export$129fe12d32abc311 = $281715568a2bf9a7$var$elliptic_1.ec;

});

parcelRegister("doGL2", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9c0eaf0f6b9e8102$export$83d89fbfd8236492; });
const $9c0eaf0f6b9e8102$export$83d89fbfd8236492 = "signing-key/5.7.0";

});


parcelRegister("9fjzQ", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6bb4b35d8ca5d704$export$83d89fbfd8236492; });
const $6bb4b35d8ca5d704$export$83d89fbfd8236492 = "transactions/5.7.0";

});


parcelRegister("aHFYU", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7cae7c27901eb562$export$83d89fbfd8236492; });
const $7cae7c27901eb562$export$83d89fbfd8236492 = "contracts/5.7.0";

});


parcelRegister("kA3tC", function(module, exports) {

$parcel$export(module.exports, "formatFixed", function () { return $efb9ddd3e2b20828$export$cc011b843b5d69f2; });
$parcel$export(module.exports, "parseFixed", function () { return $efb9ddd3e2b20828$export$1b039987e86d7269; });
$parcel$export(module.exports, "FixedNumber", function () { return $efb9ddd3e2b20828$export$d4693c66c2213e45; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $irjnC = parcelRequire("irjnC");

var $esOfL = parcelRequire("esOfL");
"use strict";
const $efb9ddd3e2b20828$var$logger = new (0, $8bxC3.Logger)((0, $irjnC.version));
const $efb9ddd3e2b20828$var$_constructorGuard = {};
const $efb9ddd3e2b20828$var$Zero = (0, $esOfL.BigNumber).from(0);
const $efb9ddd3e2b20828$var$NegativeOne = (0, $esOfL.BigNumber).from(-1);
function $efb9ddd3e2b20828$var$throwFault(message, fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value !== undefined) params.value = value;
    return $efb9ddd3e2b20828$var$logger.throwError(message, (0, $8bxC3.Logger).errors.NUMERIC_FAULT, params);
}
// Constant to pull zeros from for multipliers
let $efb9ddd3e2b20828$var$zeros = "0";
while($efb9ddd3e2b20828$var$zeros.length < 256)$efb9ddd3e2b20828$var$zeros += $efb9ddd3e2b20828$var$zeros;
// Returns a string "1" followed by decimal "0"s
function $efb9ddd3e2b20828$var$getMultiplier(decimals) {
    if (typeof decimals !== "number") try {
        decimals = (0, $esOfL.BigNumber).from(decimals).toNumber();
    } catch (e) {}
    if (typeof decimals === "number" && decimals >= 0 && decimals <= 256 && !(decimals % 1)) return "1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals);
    return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal size", "decimals", decimals);
}
function $efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    // Make sure wei is a big number (convert as necessary)
    value = (0, $esOfL.BigNumber).from(value);
    const negative = value.lt($efb9ddd3e2b20828$var$Zero);
    if (negative) value = value.mul($efb9ddd3e2b20828$var$NegativeOne);
    let fraction = value.mod(multiplier).toString();
    while(fraction.length < multiplier.length - 1)fraction = "0" + fraction;
    // Strip training 0
    fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    const whole = value.div(multiplier).toString();
    if (multiplier.length === 1) value = whole;
    else value = whole + "." + fraction;
    if (negative) value = "-" + value;
    return value;
}
function $efb9ddd3e2b20828$export$1b039987e86d7269(value, decimals) {
    if (decimals == null) decimals = 0;
    const multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
    if (typeof value !== "string" || !value.match(/^-?[0-9.]+$/)) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal value", "value", value);
    // Is it negative?
    const negative = value.substring(0, 1) === "-";
    if (negative) value = value.substring(1);
    if (value === ".") $efb9ddd3e2b20828$var$logger.throwArgumentError("missing value", "value", value);
    // Split it into a whole and fractional part
    const comps = value.split(".");
    if (comps.length > 2) $efb9ddd3e2b20828$var$logger.throwArgumentError("too many decimal points", "value", value);
    let whole = comps[0], fraction = comps[1];
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    // Trim trailing zeros
    while(fraction[fraction.length - 1] === "0")fraction = fraction.substring(0, fraction.length - 1);
    // Check the fraction doesn't exceed our decimals size
    if (fraction.length > multiplier.length - 1) $efb9ddd3e2b20828$var$throwFault("fractional component exceeds decimals", "underflow", "parseFixed");
    // If decimals is 0, we have an empty string for fraction
    if (fraction === "") fraction = "0";
    // Fully pad the string with zeros to get to wei
    while(fraction.length < multiplier.length - 1)fraction += "0";
    const wholeValue = (0, $esOfL.BigNumber).from(whole);
    const fractionValue = (0, $esOfL.BigNumber).from(fraction);
    let wei = wholeValue.mul(multiplier).add(fractionValue);
    if (negative) wei = wei.mul($efb9ddd3e2b20828$var$NegativeOne);
    return wei;
}
class $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d {
    constructor(constructorGuard, signed, width, decimals){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedFormat constructor; use FixedFormat.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.signed = signed;
        this.width = width;
        this.decimals = decimals;
        this.name = (signed ? "" : "u") + "fixed" + String(width) + "x" + String(decimals);
        this._multiplier = $efb9ddd3e2b20828$var$getMultiplier(decimals);
        Object.freeze(this);
    }
    static from(value) {
        if (value instanceof $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d) return value;
        if (typeof value === "number") value = `fixed128x${value}`;
        let signed = true;
        let width = 128;
        let decimals = 18;
        if (typeof value === "string") {
            if (value === "fixed") ;
            else if (value === "ufixed") signed = false;
            else {
                const match = value.match(/^(u?)fixed([0-9]+)x([0-9]+)$/);
                if (!match) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format", "format", value);
                signed = match[1] !== "u";
                width = parseInt(match[2]);
                decimals = parseInt(match[3]);
            }
        } else if (value) {
            const check = (key, type, defaultValue)=>{
                if (value[key] == null) return defaultValue;
                if (typeof value[key] !== type) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (" + key + " not " + type + ")", "format." + key, value[key]);
                return value[key];
            };
            signed = check("signed", "boolean", signed);
            width = check("width", "number", width);
            decimals = check("decimals", "number", decimals);
        }
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format width (not byte aligned)", "format.width", width);
        if (decimals > 80) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid fixed format (decimals too large)", "format.decimals", decimals);
        return new $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d($efb9ddd3e2b20828$var$_constructorGuard, signed, width, decimals);
    }
}
class $efb9ddd3e2b20828$export$d4693c66c2213e45 {
    constructor(constructorGuard, hex, value, format){
        if (constructorGuard !== $efb9ddd3e2b20828$var$_constructorGuard) $efb9ddd3e2b20828$var$logger.throwError("cannot use FixedNumber constructor; use FixedNumber.from", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new FixedFormat"
        });
        this.format = format;
        this._hex = hex;
        this._value = value;
        this._isFixedNumber = true;
        Object.freeze(this);
    }
    _checkFormat(other) {
        if (this.format.name !== other.format.name) $efb9ddd3e2b20828$var$logger.throwArgumentError("incompatible format; use fixedNumber.toFormat", "other", other);
    }
    addUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.add(b), this.format.decimals, this.format);
    }
    subUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.sub(b), this.format.decimals, this.format);
    }
    mulUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(b).div(this.format._multiplier), this.format.decimals, this.format);
    }
    divUnsafe(other) {
        this._checkFormat(other);
        const a = $efb9ddd3e2b20828$export$1b039987e86d7269(this._value, this.format.decimals);
        const b = $efb9ddd3e2b20828$export$1b039987e86d7269(other._value, other.format.decimals);
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(a.mul(this.format._multiplier).div(b), this.format.decimals, this.format);
    }
    floor() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (this.isNegative() && hasFraction) result = result.subUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    ceiling() {
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        let result = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(comps[0], this.format);
        const hasFraction = !comps[1].match(/^(0*)$/);
        if (!this.isNegative() && hasFraction) result = result.addUnsafe($efb9ddd3e2b20828$var$ONE.toFormat(result.format));
        return result;
    }
    // @TODO: Support other rounding algorithms
    round(decimals) {
        if (decimals == null) decimals = 0;
        // If we are already in range, we're done
        const comps = this.toString().split(".");
        if (comps.length === 1) comps.push("0");
        if (decimals < 0 || decimals > 80 || decimals % 1) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid decimal count", "decimals", decimals);
        if (comps[1].length <= decimals) return this;
        const factor = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("1" + $efb9ddd3e2b20828$var$zeros.substring(0, decimals), this.format);
        const bump = $efb9ddd3e2b20828$var$BUMP.toFormat(this.format);
        return this.mulUnsafe(factor).addUnsafe(bump).floor().divUnsafe(factor);
    }
    isZero() {
        return this._value === "0.0" || this._value === "0";
    }
    isNegative() {
        return this._value[0] === "-";
    }
    toString() {
        return this._value;
    }
    toHexString(width) {
        if (width == null) return this._hex;
        if (width % 8) $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid byte width", "width", width);
        const hex = (0, $esOfL.BigNumber).from(this._hex).fromTwos(this.format.width).toTwos(width).toHexString();
        return (0, $ApLZa.hexZeroPad)(hex, width / 8);
    }
    toUnsafeFloat() {
        return parseFloat(this.toString());
    }
    toFormat(format) {
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(this._value, format);
    }
    static fromValue(value, decimals, format) {
        // If decimals looks more like a format, and there is no format, shift the parameters
        if (format == null && decimals != null && !(0, $esOfL.isBigNumberish)(decimals)) {
            format = decimals;
            decimals = null;
        }
        if (decimals == null) decimals = 0;
        if (format == null) format = "fixed";
        return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString($efb9ddd3e2b20828$export$cc011b843b5d69f2(value, decimals), $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format));
    }
    static fromString(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        const numeric = $efb9ddd3e2b20828$export$1b039987e86d7269(value, fixedFormat.decimals);
        if (!fixedFormat.signed && numeric.lt($efb9ddd3e2b20828$var$Zero)) $efb9ddd3e2b20828$var$throwFault("unsigned value cannot be negative", "overflow", "value", value);
        let hex = null;
        if (fixedFormat.signed) hex = numeric.toTwos(fixedFormat.width).toHexString();
        else {
            hex = numeric.toHexString();
            hex = (0, $ApLZa.hexZeroPad)(hex, fixedFormat.width / 8);
        }
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static fromBytes(value, format) {
        if (format == null) format = "fixed";
        const fixedFormat = $efb9ddd3e2b20828$export$1f3ec5b8f47ebd4d.from(format);
        if ((0, $ApLZa.arrayify)(value).length > fixedFormat.width / 8) throw new Error("overflow");
        let numeric = (0, $esOfL.BigNumber).from(value);
        if (fixedFormat.signed) numeric = numeric.fromTwos(fixedFormat.width);
        const hex = numeric.toTwos((fixedFormat.signed ? 0 : 1) + fixedFormat.width).toHexString();
        const decimal = $efb9ddd3e2b20828$export$cc011b843b5d69f2(numeric, fixedFormat.decimals);
        return new $efb9ddd3e2b20828$export$d4693c66c2213e45($efb9ddd3e2b20828$var$_constructorGuard, hex, decimal, fixedFormat);
    }
    static from(value, format) {
        if (typeof value === "string") return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromString(value, format);
        if ((0, $ApLZa.isBytes)(value)) return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromBytes(value, format);
        try {
            return $efb9ddd3e2b20828$export$d4693c66c2213e45.fromValue(value, 0, format);
        } catch (error) {
            // Allow NUMERIC_FAULT to bubble up
            if (error.code !== (0, $8bxC3.Logger).errors.INVALID_ARGUMENT) throw error;
        }
        return $efb9ddd3e2b20828$var$logger.throwArgumentError("invalid FixedNumber value", "value", value);
    }
    static isFixedNumber(value) {
        return !!(value && value._isFixedNumber);
    }
}
const $efb9ddd3e2b20828$var$ONE = $efb9ddd3e2b20828$export$d4693c66c2213e45.from(1);
const $efb9ddd3e2b20828$var$BUMP = $efb9ddd3e2b20828$export$d4693c66c2213e45.from("0.5");

});

parcelRegister("hO0Ij", function(module, exports) {

$parcel$export(module.exports, "Wallet", function () { return $cf67a8ebc5cb0c41$export$bcca3ea514774656; });
$parcel$export(module.exports, "verifyMessage", function () { return $cf67a8ebc5cb0c41$export$228d0e772cc158cb; });
$parcel$export(module.exports, "verifyTypedData", function () { return $cf67a8ebc5cb0c41$export$3603b1c1bcd76798; });

var $7pv2A = parcelRequire("7pv2A");

var $dGRwz = parcelRequire("dGRwz");

var $oWESm = parcelRequire("oWESm");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");
var $6RlV8 = parcelRequire("6RlV8");

var $3NuV3 = parcelRequire("3NuV3");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $UqakH = parcelRequire("UqakH");

var $6ltHX = parcelRequire("6ltHX");

var $cX1MI = parcelRequire("cX1MI");
var $gju9h = parcelRequire("gju9h");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $7zjmI = parcelRequire("7zjmI");
"use strict";
var $cf67a8ebc5cb0c41$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $cf67a8ebc5cb0c41$var$logger = new (0, $8bxC3.Logger)((0, $7zjmI.version));
function $cf67a8ebc5cb0c41$var$isAccount(value) {
    return value != null && (0, $ApLZa.isHexString)(value.privateKey, 32) && value.address != null;
}
function $cf67a8ebc5cb0c41$var$hasMnemonic(value) {
    const mnemonic = value.mnemonic;
    return mnemonic && mnemonic.phrase;
}
class $cf67a8ebc5cb0c41$export$bcca3ea514774656 extends (0, $oWESm.Signer) {
    constructor(privateKey, provider){
        super();
        if ($cf67a8ebc5cb0c41$var$isAccount(privateKey)) {
            const signingKey = new (0, $6ltHX.SigningKey)(privateKey.privateKey);
            (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
            if (this.address !== (0, $7pv2A.getAddress)(privateKey.address)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("privateKey/address mismatch", "privateKey", "[REDACTED]");
            if ($cf67a8ebc5cb0c41$var$hasMnemonic(privateKey)) {
                const srcMnemonic = privateKey.mnemonic;
                (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>({
                        phrase: srcMnemonic.phrase,
                        path: srcMnemonic.path || (0, $3NuV3.defaultPath),
                        locale: srcMnemonic.locale || "en"
                    }));
                const mnemonic = this.mnemonic;
                const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path);
                if ((0, $5LK3h.computeAddress)(node.privateKey) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("mnemonic/address mismatch", "privateKey", "[REDACTED]");
            } else (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>null);
        } else {
            if ((0, $6ltHX.SigningKey).isSigningKey(privateKey)) {
                /* istanbul ignore if */ if (privateKey.curve !== "secp256k1") $cf67a8ebc5cb0c41$var$logger.throwArgumentError("unsupported curve; must be secp256k1", "privateKey", "[REDACTED]");
                (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>privateKey);
            } else {
                // A lot of common tools do not prefix private keys with a 0x (see: #1166)
                if (typeof privateKey === "string") {
                    if (privateKey.match(/^[0-9a-f]*$/i) && privateKey.length === 64) privateKey = "0x" + privateKey;
                }
                const signingKey = new (0, $6ltHX.SigningKey)(privateKey);
                (0, $i6lOf.defineReadOnly)(this, "_signingKey", ()=>signingKey);
            }
            (0, $i6lOf.defineReadOnly)(this, "_mnemonic", ()=>null);
            (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
        }
        /* istanbul ignore if */ if (provider && !(0, $dGRwz.Provider).isProvider(provider)) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("invalid provider", "provider", provider);
        (0, $i6lOf.defineReadOnly)(this, "provider", provider || null);
    }
    get mnemonic() {
        return this._mnemonic();
    }
    get privateKey() {
        return this._signingKey().privateKey;
    }
    get publicKey() {
        return this._signingKey().publicKey;
    }
    getAddress() {
        return Promise.resolve(this.address);
    }
    connect(provider) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(this, provider);
    }
    signTransaction(transaction) {
        return (0, $i6lOf.resolveProperties)(transaction).then((tx)=>{
            if (tx.from != null) {
                if ((0, $7pv2A.getAddress)(tx.from) !== this.address) $cf67a8ebc5cb0c41$var$logger.throwArgumentError("transaction from address mismatch", "transaction.from", transaction.from);
                delete tx.from;
            }
            const signature = this._signingKey().signDigest((0, $8unkG.keccak256)((0, $5LK3h.serialize)(tx)));
            return (0, $5LK3h.serialize)(tx, signature);
        });
    }
    signMessage(message) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $ApLZa.joinSignature)(this._signingKey().signDigest((0, $6RlV8.hashMessage)(message)));
        });
    }
    _signTypedData(domain, types, value) {
        return $cf67a8ebc5cb0c41$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names
            const populated = yield (0, $cKR64.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                if (this.provider == null) $cf67a8ebc5cb0c41$var$logger.throwError("cannot resolve ENS names without a provider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                    operation: "resolveName",
                    value: name
                });
                return this.provider.resolveName(name);
            });
            return (0, $ApLZa.joinSignature)(this._signingKey().signDigest((0, $cKR64.TypedDataEncoder).hash(populated.domain, types, populated.value)));
        });
    }
    encrypt(password, options, progressCallback) {
        if (typeof options === "function" && !progressCallback) {
            progressCallback = options;
            options = {};
        }
        if (progressCallback && typeof progressCallback !== "function") throw new Error("invalid callback");
        if (!options) options = {};
        return (0, $gju9h.encrypt)(this, password, options, progressCallback);
    }
    /**
     *  Static methods to create Wallet instances.
     */ static createRandom(options) {
        let entropy = (0, $UqakH.randomBytes)(16);
        if (!options) options = {};
        if (options.extraEntropy) entropy = (0, $ApLZa.arrayify)((0, $ApLZa.hexDataSlice)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
            entropy,
            options.extraEntropy
        ])), 0, 16));
        const mnemonic = (0, $3NuV3.entropyToMnemonic)(entropy, options.locale);
        return $cf67a8ebc5cb0c41$export$bcca3ea514774656.fromMnemonic(mnemonic, options.path, options.locale);
    }
    static fromEncryptedJson(json, password, progressCallback) {
        return (0, $cX1MI.decryptJsonWallet)(json, password, progressCallback).then((account)=>{
            return new $cf67a8ebc5cb0c41$export$bcca3ea514774656(account);
        });
    }
    static fromEncryptedJsonSync(json, password) {
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $cX1MI.decryptJsonWalletSync)(json, password));
    }
    static fromMnemonic(mnemonic, path, wordlist) {
        if (!path) path = (0, $3NuV3.defaultPath);
        return new $cf67a8ebc5cb0c41$export$bcca3ea514774656((0, $3NuV3.HDNode).fromMnemonic(mnemonic, null, wordlist).derivePath(path));
    }
}
function $cf67a8ebc5cb0c41$export$228d0e772cc158cb(message, signature) {
    return (0, $5LK3h.recoverAddress)((0, $6RlV8.hashMessage)(message), signature);
}
function $cf67a8ebc5cb0c41$export$3603b1c1bcd76798(domain, types, value, signature) {
    return (0, $5LK3h.recoverAddress)((0, $cKR64.TypedDataEncoder).hash(domain, types, value), signature);
}

});
parcelRegister("cKR64", function(module, exports) {

$parcel$export(module.exports, "TypedDataEncoder", function () { return $9492f7dcb2320b2f$export$458ab927ae635c3; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $5rMbp = parcelRequire("5rMbp");

var $1JJGc = parcelRequire("1JJGc");
var $9492f7dcb2320b2f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9492f7dcb2320b2f$var$logger = new (0, $8bxC3.Logger)((0, $5rMbp.version));
const $9492f7dcb2320b2f$var$padding = new Uint8Array(32);
$9492f7dcb2320b2f$var$padding.fill(0);
const $9492f7dcb2320b2f$var$NegativeOne = (0, $esOfL.BigNumber).from(-1);
const $9492f7dcb2320b2f$var$Zero = (0, $esOfL.BigNumber).from(0);
const $9492f7dcb2320b2f$var$One = (0, $esOfL.BigNumber).from(1);
const $9492f7dcb2320b2f$var$MaxUint256 = (0, $esOfL.BigNumber).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
function $9492f7dcb2320b2f$var$hexPadRight(value) {
    const bytes = (0, $ApLZa.arrayify)(value);
    const padOffset = bytes.length % 32;
    if (padOffset) return (0, $ApLZa.hexConcat)([
        bytes,
        $9492f7dcb2320b2f$var$padding.slice(padOffset)
    ]);
    return (0, $ApLZa.hexlify)(bytes);
}
const $9492f7dcb2320b2f$var$hexTrue = (0, $ApLZa.hexZeroPad)($9492f7dcb2320b2f$var$One.toHexString(), 32);
const $9492f7dcb2320b2f$var$hexFalse = (0, $ApLZa.hexZeroPad)($9492f7dcb2320b2f$var$Zero.toHexString(), 32);
const $9492f7dcb2320b2f$var$domainFieldTypes = {
    name: "string",
    version: "string",
    chainId: "uint256",
    verifyingContract: "address",
    salt: "bytes32"
};
const $9492f7dcb2320b2f$var$domainFieldNames = [
    "name",
    "version",
    "chainId",
    "verifyingContract",
    "salt"
];
function $9492f7dcb2320b2f$var$checkString(key) {
    return function(value) {
        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for ${JSON.stringify(key)}`, `domain.${key}`, value);
        return value;
    };
}
const $9492f7dcb2320b2f$var$domainChecks = {
    name: $9492f7dcb2320b2f$var$checkString("name"),
    version: $9492f7dcb2320b2f$var$checkString("version"),
    chainId: function(value) {
        try {
            return (0, $esOfL.BigNumber).from(value).toString();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value for "chainId"`, "domain.chainId", value);
    },
    verifyingContract: function(value) {
        try {
            return (0, $7pv2A.getAddress)(value).toLowerCase();
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "verifyingContract"`, "domain.verifyingContract", value);
    },
    salt: function(value) {
        try {
            const bytes = (0, $ApLZa.arrayify)(value);
            if (bytes.length !== 32) throw new Error("bad length");
            return (0, $ApLZa.hexlify)(bytes);
        } catch (error) {}
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid domain value "salt"`, "domain.salt", value);
    }
};
function $9492f7dcb2320b2f$var$getBaseEncoder(type) {
    // intXX and uintXX
    {
        const match = type.match(/^(u?)int(\d*)$/);
        if (match) {
            const signed = match[1] === "";
            const width = parseInt(match[2] || "256");
            if (width % 8 !== 0 || width > 256 || match[2] && match[2] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid numeric width", "type", type);
            const boundsUpper = $9492f7dcb2320b2f$var$MaxUint256.mask(signed ? width - 1 : width);
            const boundsLower = signed ? boundsUpper.add($9492f7dcb2320b2f$var$One).mul($9492f7dcb2320b2f$var$NegativeOne) : $9492f7dcb2320b2f$var$Zero;
            return function(value) {
                const v = (0, $esOfL.BigNumber).from(value);
                if (v.lt(boundsLower) || v.gt(boundsUpper)) $9492f7dcb2320b2f$var$logger.throwArgumentError(`value out-of-bounds for ${type}`, "value", value);
                return (0, $ApLZa.hexZeroPad)(v.toTwos(256).toHexString(), 32);
            };
        }
    }
    // bytesXX
    {
        const match = type.match(/^bytes(\d+)$/);
        if (match) {
            const width = parseInt(match[1]);
            if (width === 0 || width > 32 || match[1] !== String(width)) $9492f7dcb2320b2f$var$logger.throwArgumentError("invalid bytes width", "type", type);
            return function(value) {
                const bytes = (0, $ApLZa.arrayify)(value);
                if (bytes.length !== width) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid length for ${type}`, "value", value);
                return $9492f7dcb2320b2f$var$hexPadRight(value);
            };
        }
    }
    switch(type){
        case "address":
            return function(value) {
                return (0, $ApLZa.hexZeroPad)((0, $7pv2A.getAddress)(value), 32);
            };
        case "bool":
            return function(value) {
                return !value ? $9492f7dcb2320b2f$var$hexFalse : $9492f7dcb2320b2f$var$hexTrue;
            };
        case "bytes":
            return function(value) {
                return (0, $8unkG.keccak256)(value);
            };
        case "string":
            return function(value) {
                return (0, $1JJGc.id)(value);
            };
    }
    return null;
}
function $9492f7dcb2320b2f$var$encodeType(name, fields) {
    return `${name}(${fields.map(({ name: name, type: type })=>type + " " + name).join(",")})`;
}
class $9492f7dcb2320b2f$export$458ab927ae635c3 {
    constructor(types){
        (0, $i6lOf.defineReadOnly)(this, "types", Object.freeze((0, $i6lOf.deepCopy)(types)));
        (0, $i6lOf.defineReadOnly)(this, "_encoderCache", {});
        (0, $i6lOf.defineReadOnly)(this, "_types", {});
        // Link struct types to their direct child structs
        const links = {};
        // Link structs to structs which contain them as a child
        const parents = {};
        // Link all subtypes within a given struct
        const subtypes = {};
        Object.keys(types).forEach((type)=>{
            links[type] = {};
            parents[type] = [];
            subtypes[type] = {};
        });
        for(const name in types){
            const uniqueNames = {};
            types[name].forEach((field)=>{
                // Check each field has a unique name
                if (uniqueNames[field.name]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`duplicate variable name ${JSON.stringify(field.name)} in ${JSON.stringify(name)}`, "types", types);
                uniqueNames[field.name] = true;
                // Get the base type (drop any array specifiers)
                const baseType = field.type.match(/^([^\x5b]*)(\x5b|$)/)[1];
                if (baseType === name) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(baseType)}`, "types", types);
                // Is this a base encoding type?
                const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(baseType);
                if (encoder) return;
                if (!parents[baseType]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type ${JSON.stringify(baseType)}`, "types", types);
                // Add linkage
                parents[baseType].push(name);
                links[name][baseType] = true;
            });
        }
        // Deduce the primary type
        const primaryTypes = Object.keys(parents).filter((n)=>parents[n].length === 0);
        if (primaryTypes.length === 0) $9492f7dcb2320b2f$var$logger.throwArgumentError("missing primary type", "types", types);
        else if (primaryTypes.length > 1) $9492f7dcb2320b2f$var$logger.throwArgumentError(`ambiguous primary types or unused types: ${primaryTypes.map((t)=>JSON.stringify(t)).join(", ")}`, "types", types);
        (0, $i6lOf.defineReadOnly)(this, "primaryType", primaryTypes[0]);
        // Check for circular type references
        function checkCircular(type, found) {
            if (found[type]) $9492f7dcb2320b2f$var$logger.throwArgumentError(`circular type reference to ${JSON.stringify(type)}`, "types", types);
            found[type] = true;
            Object.keys(links[type]).forEach((child)=>{
                if (!parents[child]) return;
                // Recursively check children
                checkCircular(child, found);
                // Mark all ancestors as having this decendant
                Object.keys(found).forEach((subtype)=>{
                    subtypes[subtype][child] = true;
                });
            });
            delete found[type];
        }
        checkCircular(this.primaryType, {});
        // Compute each fully describe type
        for(const name in subtypes){
            const st = Object.keys(subtypes[name]);
            st.sort();
            this._types[name] = $9492f7dcb2320b2f$var$encodeType(name, types[name]) + st.map((t)=>$9492f7dcb2320b2f$var$encodeType(t, types[t])).join("");
        }
    }
    getEncoder(type) {
        let encoder = this._encoderCache[type];
        if (!encoder) encoder = this._encoderCache[type] = this._getEncoder(type);
        return encoder;
    }
    _getEncoder(type) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return encoder;
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const subEncoder = this.getEncoder(subtype);
            const length = parseInt(match[3]);
            return (value)=>{
                if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
                let result = value.map(subEncoder);
                if (this._types[subtype]) result = result.map((0, $8unkG.keccak256));
                return (0, $8unkG.keccak256)((0, $ApLZa.hexConcat)(result));
            };
        }
        // Struct
        const fields = this.types[type];
        if (fields) {
            const encodedType = (0, $1JJGc.id)(this._types[type]);
            return (value)=>{
                const values = fields.map(({ name: name, type: type })=>{
                    const result = this.getEncoder(type)(value[name]);
                    if (this._types[type]) return (0, $8unkG.keccak256)(result);
                    return result;
                });
                values.unshift(encodedType);
                return (0, $ApLZa.hexConcat)(values);
            };
        }
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    encodeType(name) {
        const result = this._types[name];
        if (!result) $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${JSON.stringify(name)}`, "name", name);
        return result;
    }
    encodeData(type, value) {
        return this.getEncoder(type)(value);
    }
    hashStruct(name, value) {
        return (0, $8unkG.keccak256)(this.encodeData(name, value));
    }
    encode(value) {
        return this.encodeData(this.primaryType, value);
    }
    hash(value) {
        return this.hashStruct(this.primaryType, value);
    }
    _visit(type, value, callback) {
        // Basic encoder type (address, bool, uint256, etc)
        {
            const encoder = $9492f7dcb2320b2f$var$getBaseEncoder(type);
            if (encoder) return callback(type, value);
        }
        // Array
        const match = type.match(/^(.*)(\x5b(\d*)\x5d)$/);
        if (match) {
            const subtype = match[1];
            const length = parseInt(match[3]);
            if (length >= 0 && value.length !== length) $9492f7dcb2320b2f$var$logger.throwArgumentError("array length mismatch; expected length ${ arrayLength }", "value", value);
            return value.map((v)=>this._visit(subtype, v, callback));
        }
        // Struct
        const fields = this.types[type];
        if (fields) return fields.reduce((accum, { name: name, type: type })=>{
            accum[name] = this._visit(type, value[name], callback);
            return accum;
        }, {});
        return $9492f7dcb2320b2f$var$logger.throwArgumentError(`unknown type: ${type}`, "type", type);
    }
    visit(value, callback) {
        return this._visit(this.primaryType, value, callback);
    }
    static from(types) {
        return new $9492f7dcb2320b2f$export$458ab927ae635c3(types);
    }
    static getPrimaryType(types) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).primaryType;
    }
    static hashStruct(name, types, value) {
        return $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hashStruct(name, value);
    }
    static hashDomain(domain) {
        const domainFields = [];
        for(const name in domain){
            const type = $9492f7dcb2320b2f$var$domainFieldTypes[name];
            if (!type) $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid typed-data domain key: ${JSON.stringify(name)}`, "domain", domain);
            domainFields.push({
                name: name,
                type: type
            });
        }
        domainFields.sort((a, b)=>{
            return $9492f7dcb2320b2f$var$domainFieldNames.indexOf(a.name) - $9492f7dcb2320b2f$var$domainFieldNames.indexOf(b.name);
        });
        return $9492f7dcb2320b2f$export$458ab927ae635c3.hashStruct("EIP712Domain", {
            EIP712Domain: domainFields
        }, domain);
    }
    static encode(domain, types, value) {
        return (0, $ApLZa.hexConcat)([
            "0x1901",
            $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain),
            $9492f7dcb2320b2f$export$458ab927ae635c3.from(types).hash(value)
        ]);
    }
    static hash(domain, types, value) {
        return (0, $8unkG.keccak256)($9492f7dcb2320b2f$export$458ab927ae635c3.encode(domain, types, value));
    }
    // Replaces all address types with ENS names with their looked up address
    static resolveNames(domain, types, value, resolveName) {
        return $9492f7dcb2320b2f$var$__awaiter(this, void 0, void 0, function*() {
            // Make a copy to isolate it from the object passed in
            domain = (0, $i6lOf.shallowCopy)(domain);
            // Look up all ENS names
            const ensCache = {};
            // Do we need to look up the domain's verifyingContract?
            if (domain.verifyingContract && !(0, $ApLZa.isHexString)(domain.verifyingContract, 20)) ensCache[domain.verifyingContract] = "0x";
            // We are going to use the encoder to visit all the base values
            const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
            // Get a list of all the addresses
            encoder.visit(value, (type, value)=>{
                if (type === "address" && !(0, $ApLZa.isHexString)(value, 20)) ensCache[value] = "0x";
                return value;
            });
            // Lookup each name
            for(const name in ensCache)ensCache[name] = yield resolveName(name);
            // Replace the domain verifyingContract if needed
            if (domain.verifyingContract && ensCache[domain.verifyingContract]) domain.verifyingContract = ensCache[domain.verifyingContract];
            // Replace all ENS names with their address
            value = encoder.visit(value, (type, value)=>{
                if (type === "address" && ensCache[value]) return ensCache[value];
                return value;
            });
            return {
                domain: domain,
                value: value
            };
        });
    }
    static getPayload(domain, types, value) {
        // Validate the domain fields
        $9492f7dcb2320b2f$export$458ab927ae635c3.hashDomain(domain);
        // Derive the EIP712Domain Struct reference type
        const domainValues = {};
        const domainTypes = [];
        $9492f7dcb2320b2f$var$domainFieldNames.forEach((name)=>{
            const value = domain[name];
            if (value == null) return;
            domainValues[name] = $9492f7dcb2320b2f$var$domainChecks[name](value);
            domainTypes.push({
                name: name,
                type: $9492f7dcb2320b2f$var$domainFieldTypes[name]
            });
        });
        const encoder = $9492f7dcb2320b2f$export$458ab927ae635c3.from(types);
        const typesWithDomain = (0, $i6lOf.shallowCopy)(types);
        if (typesWithDomain.EIP712Domain) $9492f7dcb2320b2f$var$logger.throwArgumentError("types must not contain EIP712Domain type", "types.EIP712Domain", types);
        else typesWithDomain.EIP712Domain = domainTypes;
        // Validate the data structures and types
        encoder.encode(value);
        return {
            types: typesWithDomain,
            domain: domainValues,
            primaryType: encoder.primaryType,
            message: encoder.visit(value, (type, value)=>{
                // bytes
                if (type.match(/^bytes(\d*)/)) return (0, $ApLZa.hexlify)((0, $ApLZa.arrayify)(value));
                // uint or int
                if (type.match(/^u?int/)) return (0, $esOfL.BigNumber).from(value).toString();
                switch(type){
                    case "address":
                        return value.toLowerCase();
                    case "bool":
                        return !!value;
                    case "string":
                        if (typeof value !== "string") $9492f7dcb2320b2f$var$logger.throwArgumentError(`invalid string`, "value", value);
                        return value;
                }
                return $9492f7dcb2320b2f$var$logger.throwArgumentError("unsupported type", "type", type);
            })
        };
    }
}

});
parcelRegister("5rMbp", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $3f74d983611b69f1$export$83d89fbfd8236492; });
const $3f74d983611b69f1$export$83d89fbfd8236492 = "hash/5.7.0";

});


parcelRegister("6RlV8", function(module, exports) {

$parcel$export(module.exports, "hashMessage", function () { return $4fe8b24c78e33d56$export$d4c241cec96564c1; });

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $aCHl8 = parcelRequire("aCHl8");
const $4fe8b24c78e33d56$export$1ff3fdc4802a2ba6 = "\x19Ethereum Signed Message:\n";
function $4fe8b24c78e33d56$export$d4c241cec96564c1(message) {
    if (typeof message === "string") message = (0, $aCHl8.toUtf8Bytes)(message);
    return (0, $8unkG.keccak256)((0, $ApLZa.concat)([
        (0, $aCHl8.toUtf8Bytes)($4fe8b24c78e33d56$export$1ff3fdc4802a2ba6),
        (0, $aCHl8.toUtf8Bytes)(String(message.length)),
        message
    ]));
}

});

parcelRegister("3NuV3", function(module, exports) {

$parcel$export(module.exports, "defaultPath", function () { return $2c3deea0882bd090$export$d48ad89f7e11a603; });
$parcel$export(module.exports, "HDNode", function () { return $2c3deea0882bd090$export$b68640c53e22b952; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return $2c3deea0882bd090$export$4becd65eb23312e6; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return $2c3deea0882bd090$export$135e090d58b310ca; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return $2c3deea0882bd090$export$3dee74f1204ab09f; });
$parcel$export(module.exports, "isValidMnemonic", function () { return $2c3deea0882bd090$export$5eea3393c6119c80; });
$parcel$export(module.exports, "getAccountPath", function () { return $2c3deea0882bd090$export$22b80e4f9eff636d; });

var $6PyTw = parcelRequire("6PyTw");

var $ApLZa = parcelRequire("ApLZa");

var $esOfL = parcelRequire("esOfL");

var $aCHl8 = parcelRequire("aCHl8");

var $75K6s = parcelRequire("75K6s");

var $i6lOf = parcelRequire("i6lOf");

var $6ltHX = parcelRequire("6ltHX");

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");

var $5LK3h = parcelRequire("5LK3h");

var $12owE = parcelRequire("12owE");

var $8bxC3 = parcelRequire("8bxC3");

var $9tEcL = parcelRequire("9tEcL");
"use strict";
const $2c3deea0882bd090$var$logger = new (0, $8bxC3.Logger)((0, $9tEcL.version));
const $2c3deea0882bd090$var$N = (0, $esOfL.BigNumber).from("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
// "Bitcoin seed"
const $2c3deea0882bd090$var$MasterSecret = (0, $aCHl8.toUtf8Bytes)("Bitcoin seed");
const $2c3deea0882bd090$var$HardenedBit = 0x80000000;
// Returns a byte with the MSB bits set
function $2c3deea0882bd090$var$getUpperMask(bits) {
    return (1 << bits) - 1 << 8 - bits;
}
// Returns a byte with the LSB bits set
function $2c3deea0882bd090$var$getLowerMask(bits) {
    return (1 << bits) - 1;
}
function $2c3deea0882bd090$var$bytes32(value) {
    return (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(value), 32);
}
function $2c3deea0882bd090$var$base58check(data) {
    return (0, $6PyTw.Base58).encode((0, $ApLZa.concat)([
        data,
        (0, $ApLZa.hexDataSlice)((0, $eT6wv.sha256)((0, $eT6wv.sha256)(data)), 0, 4)
    ]));
}
function $2c3deea0882bd090$var$getWordlist(wordlist) {
    if (wordlist == null) return (0, $12owE.wordlists)["en"];
    if (typeof wordlist === "string") {
        const words = (0, $12owE.wordlists)[wordlist];
        if (words == null) $2c3deea0882bd090$var$logger.throwArgumentError("unknown locale", "wordlist", wordlist);
        return words;
    }
    return wordlist;
}
const $2c3deea0882bd090$var$_constructorGuard = {};
const $2c3deea0882bd090$export$d48ad89f7e11a603 = "m/44'/60'/0'/0/0";
class $2c3deea0882bd090$export$b68640c53e22b952 {
    /**
     *  This constructor should not be called directly.
     *
     *  Please use:
     *   - fromMnemonic
     *   - fromSeed
     */ constructor(constructorGuard, privateKey, publicKey, parentFingerprint, chainCode, index, depth, mnemonicOrPath){
        /* istanbul ignore if */ if (constructorGuard !== $2c3deea0882bd090$var$_constructorGuard) throw new Error("HDNode constructor cannot be called directly");
        if (privateKey) {
            const signingKey = new (0, $6ltHX.SigningKey)(privateKey);
            (0, $i6lOf.defineReadOnly)(this, "privateKey", signingKey.privateKey);
            (0, $i6lOf.defineReadOnly)(this, "publicKey", signingKey.compressedPublicKey);
        } else {
            (0, $i6lOf.defineReadOnly)(this, "privateKey", null);
            (0, $i6lOf.defineReadOnly)(this, "publicKey", (0, $ApLZa.hexlify)(publicKey));
        }
        (0, $i6lOf.defineReadOnly)(this, "parentFingerprint", parentFingerprint);
        (0, $i6lOf.defineReadOnly)(this, "fingerprint", (0, $ApLZa.hexDataSlice)((0, $eT6wv.ripemd160)((0, $eT6wv.sha256)(this.publicKey)), 0, 4));
        (0, $i6lOf.defineReadOnly)(this, "address", (0, $5LK3h.computeAddress)(this.publicKey));
        (0, $i6lOf.defineReadOnly)(this, "chainCode", chainCode);
        (0, $i6lOf.defineReadOnly)(this, "index", index);
        (0, $i6lOf.defineReadOnly)(this, "depth", depth);
        if (mnemonicOrPath == null) {
            // From a source that does not preserve the path (e.g. extended keys)
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", null);
            (0, $i6lOf.defineReadOnly)(this, "path", null);
        } else if (typeof mnemonicOrPath === "string") {
            // From a source that does not preserve the mnemonic (e.g. neutered)
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", null);
            (0, $i6lOf.defineReadOnly)(this, "path", mnemonicOrPath);
        } else {
            // From a fully qualified source
            (0, $i6lOf.defineReadOnly)(this, "mnemonic", mnemonicOrPath);
            (0, $i6lOf.defineReadOnly)(this, "path", mnemonicOrPath.path);
        }
    }
    get extendedKey() {
        // We only support the mainnet values for now, but if anyone needs
        // testnet values, let me know. I believe current sentiment is that
        // we should always use mainnet, and use BIP-44 to derive the network
        //   - Mainnet: public=0x0488B21E, private=0x0488ADE4
        //   - Testnet: public=0x043587CF, private=0x04358394
        if (this.depth >= 256) throw new Error("Depth too large!");
        return $2c3deea0882bd090$var$base58check((0, $ApLZa.concat)([
            this.privateKey != null ? "0x0488ADE4" : "0x0488B21E",
            (0, $ApLZa.hexlify)(this.depth),
            this.parentFingerprint,
            (0, $ApLZa.hexZeroPad)((0, $ApLZa.hexlify)(this.index), 4),
            this.chainCode,
            this.privateKey != null ? (0, $ApLZa.concat)([
                "0x00",
                this.privateKey
            ]) : this.publicKey
        ]));
    }
    neuter() {
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, this.publicKey, this.parentFingerprint, this.chainCode, this.index, this.depth, this.path);
    }
    _derive(index) {
        if (index > 0xffffffff) throw new Error("invalid index - " + String(index));
        // Base path
        let path = this.path;
        if (path) path += "/" + (index & ~$2c3deea0882bd090$var$HardenedBit);
        const data = new Uint8Array(37);
        if (index & $2c3deea0882bd090$var$HardenedBit) {
            if (!this.privateKey) throw new Error("cannot derive child of neutered node");
            // Data = 0x00 || ser_256(k_par)
            data.set((0, $ApLZa.arrayify)(this.privateKey), 1);
            // Hardened path
            if (path) path += "'";
        } else // Data = ser_p(point(k_par))
        data.set((0, $ApLZa.arrayify)(this.publicKey));
        // Data += ser_32(i)
        for(let i = 24; i >= 0; i -= 8)data[33 + (i >> 3)] = index >> 24 - i & 0xff;
        const I = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)((0, $gSWEZ.SupportedAlgorithm).sha512, this.chainCode, data));
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // The private key
        let ki = null;
        // The public key
        let Ki = null;
        if (this.privateKey) ki = $2c3deea0882bd090$var$bytes32((0, $esOfL.BigNumber).from(IL).add(this.privateKey).mod($2c3deea0882bd090$var$N));
        else {
            const ek = new (0, $6ltHX.SigningKey)((0, $ApLZa.hexlify)(IL));
            Ki = ek._addPoint(this.publicKey);
        }
        let mnemonicOrPath = path;
        const srcMnemonic = this.mnemonic;
        if (srcMnemonic) mnemonicOrPath = Object.freeze({
            phrase: srcMnemonic.phrase,
            path: path,
            locale: srcMnemonic.locale || "en"
        });
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, ki, Ki, this.fingerprint, $2c3deea0882bd090$var$bytes32(IR), index, this.depth + 1, mnemonicOrPath);
    }
    derivePath(path) {
        const components = path.split("/");
        if (components.length === 0 || components[0] === "m" && this.depth !== 0) throw new Error("invalid path - " + path);
        if (components[0] === "m") components.shift();
        let result = this;
        for(let i = 0; i < components.length; i++){
            const component = components[i];
            if (component.match(/^[0-9]+'$/)) {
                const index = parseInt(component.substring(0, component.length - 1));
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive($2c3deea0882bd090$var$HardenedBit + index);
            } else if (component.match(/^[0-9]+$/)) {
                const index = parseInt(component);
                if (index >= $2c3deea0882bd090$var$HardenedBit) throw new Error("invalid path index - " + component);
                result = result._derive(index);
            } else throw new Error("invalid path component - " + component);
        }
        return result;
    }
    static _fromSeed(seed, mnemonic) {
        const seedArray = (0, $ApLZa.arrayify)(seed);
        if (seedArray.length < 16 || seedArray.length > 64) throw new Error("invalid seed");
        const I = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)((0, $gSWEZ.SupportedAlgorithm).sha512, $2c3deea0882bd090$var$MasterSecret, seedArray));
        return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, $2c3deea0882bd090$var$bytes32(I.slice(0, 32)), null, "0x00000000", $2c3deea0882bd090$var$bytes32(I.slice(32)), 0, 0, mnemonic);
    }
    static fromMnemonic(mnemonic, password, wordlist) {
        // If a locale name was passed in, find the associated wordlist
        wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
        // Normalize the case and spacing in the mnemonic (throws if the mnemonic is invalid)
        mnemonic = $2c3deea0882bd090$export$4becd65eb23312e6($2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist), wordlist);
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed($2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password), {
            phrase: mnemonic,
            path: "m",
            locale: wordlist.locale
        });
    }
    static fromSeed(seed) {
        return $2c3deea0882bd090$export$b68640c53e22b952._fromSeed(seed, null);
    }
    static fromExtendedKey(extendedKey) {
        const bytes = (0, $6PyTw.Base58).decode(extendedKey);
        if (bytes.length !== 82 || $2c3deea0882bd090$var$base58check(bytes.slice(0, 78)) !== extendedKey) $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
        const depth = bytes[4];
        const parentFingerprint = (0, $ApLZa.hexlify)(bytes.slice(5, 9));
        const index = parseInt((0, $ApLZa.hexlify)(bytes.slice(9, 13)).substring(2), 16);
        const chainCode = (0, $ApLZa.hexlify)(bytes.slice(13, 45));
        const key = bytes.slice(45, 78);
        switch((0, $ApLZa.hexlify)(bytes.slice(0, 4))){
            // Public Key
            case "0x0488b21e":
            case "0x043587cf":
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, null, (0, $ApLZa.hexlify)(key), parentFingerprint, chainCode, index, depth, null);
            // Private Key
            case "0x0488ade4":
            case "0x04358394 ":
                if (key[0] !== 0) break;
                return new $2c3deea0882bd090$export$b68640c53e22b952($2c3deea0882bd090$var$_constructorGuard, (0, $ApLZa.hexlify)(key.slice(1)), null, parentFingerprint, chainCode, index, depth, null);
        }
        return $2c3deea0882bd090$var$logger.throwArgumentError("invalid extended key", "extendedKey", "[REDACTED]");
    }
}
function $2c3deea0882bd090$export$3dee74f1204ab09f(mnemonic, password) {
    if (!password) password = "";
    const salt = (0, $aCHl8.toUtf8Bytes)("mnemonic" + password, (0, $aCHl8.UnicodeNormalizationForm).NFKD);
    return (0, $75K6s.pbkdf2)((0, $aCHl8.toUtf8Bytes)(mnemonic, (0, $aCHl8.UnicodeNormalizationForm).NFKD), salt, 2048, 64, "sha512");
}
function $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    $2c3deea0882bd090$var$logger.checkNormalize();
    const words = wordlist.split(mnemonic);
    if (words.length % 3 !== 0) throw new Error("invalid mnemonic");
    const entropy = (0, $ApLZa.arrayify)(new Uint8Array(Math.ceil(11 * words.length / 8)));
    let offset = 0;
    for(let i = 0; i < words.length; i++){
        let index = wordlist.getWordIndex(words[i].normalize("NFKD"));
        if (index === -1) throw new Error("invalid mnemonic");
        for(let bit = 0; bit < 11; bit++){
            if (index & 1 << 10 - bit) entropy[offset >> 3] |= 1 << 7 - offset % 8;
            offset++;
        }
    }
    const entropyBits = 32 * words.length / 3;
    const checksumBits = words.length / 3;
    const checksumMask = $2c3deea0882bd090$var$getUpperMask(checksumBits);
    const checksum = (0, $ApLZa.arrayify)((0, $eT6wv.sha256)(entropy.slice(0, entropyBits / 8)))[0] & checksumMask;
    if (checksum !== (entropy[entropy.length - 1] & checksumMask)) throw new Error("invalid checksum");
    return (0, $ApLZa.hexlify)(entropy.slice(0, entropyBits / 8));
}
function $2c3deea0882bd090$export$4becd65eb23312e6(entropy, wordlist) {
    wordlist = $2c3deea0882bd090$var$getWordlist(wordlist);
    entropy = (0, $ApLZa.arrayify)(entropy);
    if (entropy.length % 4 !== 0 || entropy.length < 16 || entropy.length > 32) throw new Error("invalid entropy");
    const indices = [
        0
    ];
    let remainingBits = 11;
    for(let i = 0; i < entropy.length; i++)// Consume the whole byte (with still more to go)
    if (remainingBits > 8) {
        indices[indices.length - 1] <<= 8;
        indices[indices.length - 1] |= entropy[i];
        remainingBits -= 8;
    // This byte will complete an 11-bit index
    } else {
        indices[indices.length - 1] <<= remainingBits;
        indices[indices.length - 1] |= entropy[i] >> 8 - remainingBits;
        // Start the next word
        indices.push(entropy[i] & $2c3deea0882bd090$var$getLowerMask(8 - remainingBits));
        remainingBits += 3;
    }
    // Compute the checksum bits
    const checksumBits = entropy.length / 4;
    const checksum = (0, $ApLZa.arrayify)((0, $eT6wv.sha256)(entropy))[0] & $2c3deea0882bd090$var$getUpperMask(checksumBits);
    // Shift the checksum into the word indices
    indices[indices.length - 1] <<= checksumBits;
    indices[indices.length - 1] |= checksum >> 8 - checksumBits;
    return wordlist.join(indices.map((index)=>wordlist.getWord(index)));
}
function $2c3deea0882bd090$export$5eea3393c6119c80(mnemonic, wordlist) {
    try {
        $2c3deea0882bd090$export$135e090d58b310ca(mnemonic, wordlist);
        return true;
    } catch (error) {}
    return false;
}
function $2c3deea0882bd090$export$22b80e4f9eff636d(index) {
    if (typeof index !== "number" || index < 0 || index >= $2c3deea0882bd090$var$HardenedBit || index % 1) $2c3deea0882bd090$var$logger.throwArgumentError("invalid account index", "index", index);
    return `m/44'/60'/${index}'/0/0`;
}

});
parcelRegister("6PyTw", function(module, exports) {

$parcel$export(module.exports, "Base58", function () { return $4f9292cbf9a48447$export$45a587635c9954b2; });
/**
 * var basex = require("base-x");
 *
 * This implementation is heavily based on base-x. The main reason to
 * deviate was to prevent the dependency of Buffer.
 *
 * Contributors:
 *
 * base-x encoding
 * Forked from https://github.com/cryptocoinjs/bs58
 * Originally written by Mike Hearn for BitcoinJ
 * Copyright (c) 2011 Google Inc
 * Ported to JavaScript by Stefan Thomas
 * Merged Buffer refactorings from base58-native by Stephen Pair
 * Copyright (c) 2013 BitPay Inc
 *
 * The MIT License (MIT)
 *
 * Copyright base-x contributors (c) 2016
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the "Software"),
 * to deal in the Software without restriction, including without limitation
 * the rights to use, copy, modify, merge, publish, distribute, sublicense,
 * and/or sell copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 *
 */ 
var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");
class $4f9292cbf9a48447$export$240043ab8e806ec7 {
    constructor(alphabet){
        (0, $i6lOf.defineReadOnly)(this, "alphabet", alphabet);
        (0, $i6lOf.defineReadOnly)(this, "base", alphabet.length);
        (0, $i6lOf.defineReadOnly)(this, "_alphabetMap", {});
        (0, $i6lOf.defineReadOnly)(this, "_leader", alphabet.charAt(0));
        // pre-compute lookup table
        for(let i = 0; i < alphabet.length; i++)this._alphabetMap[alphabet.charAt(i)] = i;
    }
    encode(value) {
        let source = (0, $ApLZa.arrayify)(value);
        if (source.length === 0) return "";
        let digits = [
            0
        ];
        for(let i = 0; i < source.length; ++i){
            let carry = source[i];
            for(let j = 0; j < digits.length; ++j){
                carry += digits[j] << 8;
                digits[j] = carry % this.base;
                carry = carry / this.base | 0;
            }
            while(carry > 0){
                digits.push(carry % this.base);
                carry = carry / this.base | 0;
            }
        }
        let string = "";
        // deal with leading zeros
        for(let k = 0; source[k] === 0 && k < source.length - 1; ++k)string += this._leader;
        // convert digits to a string
        for(let q = digits.length - 1; q >= 0; --q)string += this.alphabet[digits[q]];
        return string;
    }
    decode(value) {
        if (typeof value !== "string") throw new TypeError("Expected String");
        let bytes = [];
        if (value.length === 0) return new Uint8Array(bytes);
        bytes.push(0);
        for(let i = 0; i < value.length; i++){
            let byte = this._alphabetMap[value[i]];
            if (byte === undefined) throw new Error("Non-base" + this.base + " character");
            let carry = byte;
            for(let j = 0; j < bytes.length; ++j){
                carry += bytes[j] * this.base;
                bytes[j] = carry & 0xff;
                carry >>= 8;
            }
            while(carry > 0){
                bytes.push(carry & 0xff);
                carry >>= 8;
            }
        }
        // deal with leading zeros
        for(let k = 0; value[k] === this._leader && k < value.length - 1; ++k)bytes.push(0);
        return (0, $ApLZa.arrayify)(new Uint8Array(bytes.reverse()));
    }
}
const $4f9292cbf9a48447$export$cfabb2852920f5ec = new $4f9292cbf9a48447$export$240043ab8e806ec7("abcdefghijklmnopqrstuvwxyz234567");
const $4f9292cbf9a48447$export$45a587635c9954b2 = new $4f9292cbf9a48447$export$240043ab8e806ec7("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
 //console.log(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj"))
 //console.log(Base58.encode(Base58.decode("Qmd2V777o5XvJbYMeMb8k2nU5f8d3ciUQ5YpYuWhzv8iDj")))

});

parcelRegister("75K6s", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $529cc323d557cae2$export$448fa22aedc9dbca; });

var $ApLZa = parcelRequire("ApLZa");

var $eT6wv = parcelRequire("eT6wv");
"use strict";
function $529cc323d557cae2$export$448fa22aedc9dbca(password, salt, iterations, keylen, hashAlgorithm) {
    password = (0, $ApLZa.arrayify)(password);
    salt = (0, $ApLZa.arrayify)(salt);
    let hLen;
    let l = 1;
    const DK = new Uint8Array(keylen);
    const block1 = new Uint8Array(salt.length + 4);
    block1.set(salt);
    //salt.copy(block1, 0, 0, salt.length)
    let r;
    let T;
    for(let i = 1; i <= l; i++){
        //block1.writeUInt32BE(i, salt.length)
        block1[salt.length] = i >> 24 & 0xff;
        block1[salt.length + 1] = i >> 16 & 0xff;
        block1[salt.length + 2] = i >> 8 & 0xff;
        block1[salt.length + 3] = i & 0xff;
        //let U = createHmac(password).update(block1).digest();
        let U = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)(hashAlgorithm, password, block1));
        if (!hLen) {
            hLen = U.length;
            T = new Uint8Array(hLen);
            l = Math.ceil(keylen / hLen);
            r = keylen - (l - 1) * hLen;
        }
        //U.copy(T, 0, 0, hLen)
        T.set(U);
        for(let j = 1; j < iterations; j++){
            //U = createHmac(password).update(U).digest();
            U = (0, $ApLZa.arrayify)((0, $eT6wv.computeHmac)(hashAlgorithm, password, U));
            for(let k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        const destPos = (i - 1) * hLen;
        const len = i === l ? r : hLen;
        //T.copy(DK, destPos, 0, len)
        DK.set((0, $ApLZa.arrayify)(T).slice(0, len), destPos);
    }
    return (0, $ApLZa.hexlify)(DK);
}

});
parcelRegister("eT6wv", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e; });
$parcel$export(module.exports, "sha256", function () { return $ad6b4320c60d6c47$export$bced8d2aada2d1c9; });
$parcel$export(module.exports, "sha512", function () { return $ad6b4320c60d6c47$export$a888d2532e6dc7bb; });
$parcel$export(module.exports, "computeHmac", function () { return $ad6b4320c60d6c47$export$967075d2f3b8e7ff; });

var $leqJp = parcelRequire("leqJp");

var $ApLZa = parcelRequire("ApLZa");

var $gSWEZ = parcelRequire("gSWEZ");

var $8bxC3 = parcelRequire("8bxC3");

var $inANY = parcelRequire("inANY");
"use strict";
const $ad6b4320c60d6c47$var$logger = new (0, $8bxC3.Logger)((0, $inANY.version));
function $ad6b4320c60d6c47$export$d1cea0ee4e3f0d3e(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).ripemd160().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$bced8d2aada2d1c9(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$a888d2532e6dc7bb(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512().update((0, $ApLZa.arrayify)(data)).digest("hex");
}
function $ad6b4320c60d6c47$export$967075d2f3b8e7ff(algorithm, key, data) {
    if (!(0, $gSWEZ.SupportedAlgorithm)[algorithm]) $ad6b4320c60d6c47$var$logger.throwError("unsupported algorithm " + algorithm, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "hmac",
        algorithm: algorithm
    });
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac((0, (/*@__PURE__*/$parcel$interopDefault($leqJp)))[algorithm], (0, $ApLZa.arrayify)(key)).update((0, $ApLZa.arrayify)(data)).digest("hex");
}

});
parcelRegister("gSWEZ", function(module, exports) {

$parcel$export(module.exports, "SupportedAlgorithm", function () { return $c4af312545dae30d$export$d2a8849cfb277c; });
var $c4af312545dae30d$export$d2a8849cfb277c;
(function(SupportedAlgorithm) {
    SupportedAlgorithm["sha256"] = "sha256";
    SupportedAlgorithm["sha512"] = "sha512";
})($c4af312545dae30d$export$d2a8849cfb277c || ($c4af312545dae30d$export$d2a8849cfb277c = {}));

});

parcelRegister("inANY", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $d616ecab8a4a7575$export$83d89fbfd8236492; });
const $d616ecab8a4a7575$export$83d89fbfd8236492 = "sha2/5.7.0";

});



parcelRegister("12owE", function(module, exports) {

$parcel$export(module.exports, "wordlists", function () { return $0c19009e3fcf898f$export$e8e1b4711c2d1939; });

var $DhMd2 = parcelRequire("DhMd2");
"use strict";
const $0c19009e3fcf898f$export$e8e1b4711c2d1939 = {
    en: (0, $DhMd2.langEn)
};

});
parcelRegister("DhMd2", function(module, exports) {

$parcel$export(module.exports, "langEn", function () { return $07616eb0958c2519$export$a2c9518710cf1f49; });

var $2BDj9 = parcelRequire("2BDj9");
"use strict";
const $07616eb0958c2519$var$words = "AbandonAbilityAbleAboutAboveAbsentAbsorbAbstractAbsurdAbuseAccessAccidentAccountAccuseAchieveAcidAcousticAcquireAcrossActActionActorActressActualAdaptAddAddictAddressAdjustAdmitAdultAdvanceAdviceAerobicAffairAffordAfraidAgainAgeAgentAgreeAheadAimAirAirportAisleAlarmAlbumAlcoholAlertAlienAllAlleyAllowAlmostAloneAlphaAlreadyAlsoAlterAlwaysAmateurAmazingAmongAmountAmusedAnalystAnchorAncientAngerAngleAngryAnimalAnkleAnnounceAnnualAnotherAnswerAntennaAntiqueAnxietyAnyApartApologyAppearAppleApproveAprilArchArcticAreaArenaArgueArmArmedArmorArmyAroundArrangeArrestArriveArrowArtArtefactArtistArtworkAskAspectAssaultAssetAssistAssumeAsthmaAthleteAtomAttackAttendAttitudeAttractAuctionAuditAugustAuntAuthorAutoAutumnAverageAvocadoAvoidAwakeAwareAwayAwesomeAwfulAwkwardAxisBabyBachelorBaconBadgeBagBalanceBalconyBallBambooBananaBannerBarBarelyBargainBarrelBaseBasicBasketBattleBeachBeanBeautyBecauseBecomeBeefBeforeBeginBehaveBehindBelieveBelowBeltBenchBenefitBestBetrayBetterBetweenBeyondBicycleBidBikeBindBiologyBirdBirthBitterBlackBladeBlameBlanketBlastBleakBlessBlindBloodBlossomBlouseBlueBlurBlushBoardBoatBodyBoilBombBoneBonusBookBoostBorderBoringBorrowBossBottomBounceBoxBoyBracketBrainBrandBrassBraveBreadBreezeBrickBridgeBriefBrightBringBriskBroccoliBrokenBronzeBroomBrotherBrownBrushBubbleBuddyBudgetBuffaloBuildBulbBulkBulletBundleBunkerBurdenBurgerBurstBusBusinessBusyButterBuyerBuzzCabbageCabinCableCactusCageCakeCallCalmCameraCampCanCanalCancelCandyCannonCanoeCanvasCanyonCapableCapitalCaptainCarCarbonCardCargoCarpetCarryCartCaseCashCasinoCastleCasualCatCatalogCatchCategoryCattleCaughtCauseCautionCaveCeilingCeleryCementCensusCenturyCerealCertainChairChalkChampionChangeChaosChapterChargeChaseChatCheapCheckCheeseChefCherryChestChickenChiefChildChimneyChoiceChooseChronicChuckleChunkChurnCigarCinnamonCircleCitizenCityCivilClaimClapClarifyClawClayCleanClerkCleverClickClientCliffClimbClinicClipClockClogCloseClothCloudClownClubClumpClusterClutchCoachCoastCoconutCodeCoffeeCoilCoinCollectColorColumnCombineComeComfortComicCommonCompanyConcertConductConfirmCongressConnectConsiderControlConvinceCookCoolCopperCopyCoralCoreCornCorrectCostCottonCouchCountryCoupleCourseCousinCoverCoyoteCrackCradleCraftCramCraneCrashCraterCrawlCrazyCreamCreditCreekCrewCricketCrimeCrispCriticCropCrossCrouchCrowdCrucialCruelCruiseCrumbleCrunchCrushCryCrystalCubeCultureCupCupboardCuriousCurrentCurtainCurveCushionCustomCuteCycleDadDamageDampDanceDangerDaringDashDaughterDawnDayDealDebateDebrisDecadeDecemberDecideDeclineDecorateDecreaseDeerDefenseDefineDefyDegreeDelayDeliverDemandDemiseDenialDentistDenyDepartDependDepositDepthDeputyDeriveDescribeDesertDesignDeskDespairDestroyDetailDetectDevelopDeviceDevoteDiagramDialDiamondDiaryDiceDieselDietDifferDigitalDignityDilemmaDinnerDinosaurDirectDirtDisagreeDiscoverDiseaseDishDismissDisorderDisplayDistanceDivertDivideDivorceDizzyDoctorDocumentDogDollDolphinDomainDonateDonkeyDonorDoorDoseDoubleDoveDraftDragonDramaDrasticDrawDreamDressDriftDrillDrinkDripDriveDropDrumDryDuckDumbDuneDuringDustDutchDutyDwarfDynamicEagerEagleEarlyEarnEarthEasilyEastEasyEchoEcologyEconomyEdgeEditEducateEffortEggEightEitherElbowElderElectricElegantElementElephantElevatorEliteElseEmbarkEmbodyEmbraceEmergeEmotionEmployEmpowerEmptyEnableEnactEndEndlessEndorseEnemyEnergyEnforceEngageEngineEnhanceEnjoyEnlistEnoughEnrichEnrollEnsureEnterEntireEntryEnvelopeEpisodeEqualEquipEraEraseErodeErosionErrorEruptEscapeEssayEssenceEstateEternalEthicsEvidenceEvilEvokeEvolveExactExampleExcessExchangeExciteExcludeExcuseExecuteExerciseExhaustExhibitExileExistExitExoticExpandExpectExpireExplainExposeExpressExtendExtraEyeEyebrowFabricFaceFacultyFadeFaintFaithFallFalseFameFamilyFamousFanFancyFantasyFarmFashionFatFatalFatherFatigueFaultFavoriteFeatureFebruaryFederalFeeFeedFeelFemaleFenceFestivalFetchFeverFewFiberFictionFieldFigureFileFilmFilterFinalFindFineFingerFinishFireFirmFirstFiscalFishFitFitnessFixFlagFlameFlashFlatFlavorFleeFlightFlipFloatFlockFloorFlowerFluidFlushFlyFoamFocusFogFoilFoldFollowFoodFootForceForestForgetForkFortuneForumForwardFossilFosterFoundFoxFragileFrameFrequentFreshFriendFringeFrogFrontFrostFrownFrozenFruitFuelFunFunnyFurnaceFuryFutureGadgetGainGalaxyGalleryGameGapGarageGarbageGardenGarlicGarmentGasGaspGateGatherGaugeGazeGeneralGeniusGenreGentleGenuineGestureGhostGiantGiftGiggleGingerGiraffeGirlGiveGladGlanceGlareGlassGlideGlimpseGlobeGloomGloryGloveGlowGlueGoatGoddessGoldGoodGooseGorillaGospelGossipGovernGownGrabGraceGrainGrantGrapeGrassGravityGreatGreenGridGriefGritGroceryGroupGrowGruntGuardGuessGuideGuiltGuitarGunGymHabitHairHalfHammerHamsterHandHappyHarborHardHarshHarvestHatHaveHawkHazardHeadHealthHeartHeavyHedgehogHeightHelloHelmetHelpHenHeroHiddenHighHillHintHipHireHistoryHobbyHockeyHoldHoleHolidayHollowHomeHoneyHoodHopeHornHorrorHorseHospitalHostHotelHourHoverHubHugeHumanHumbleHumorHundredHungryHuntHurdleHurryHurtHusbandHybridIceIconIdeaIdentifyIdleIgnoreIllIllegalIllnessImageImitateImmenseImmuneImpactImposeImproveImpulseInchIncludeIncomeIncreaseIndexIndicateIndoorIndustryInfantInflictInformInhaleInheritInitialInjectInjuryInmateInnerInnocentInputInquiryInsaneInsectInsideInspireInstallIntactInterestIntoInvestInviteInvolveIronIslandIsolateIssueItemIvoryJacketJaguarJarJazzJealousJeansJellyJewelJobJoinJokeJourneyJoyJudgeJuiceJumpJungleJuniorJunkJustKangarooKeenKeepKetchupKeyKickKidKidneyKindKingdomKissKitKitchenKiteKittenKiwiKneeKnifeKnockKnowLabLabelLaborLadderLadyLakeLampLanguageLaptopLargeLaterLatinLaughLaundryLavaLawLawnLawsuitLayerLazyLeaderLeafLearnLeaveLectureLeftLegLegalLegendLeisureLemonLendLengthLensLeopardLessonLetterLevelLiarLibertyLibraryLicenseLifeLiftLightLikeLimbLimitLinkLionLiquidListLittleLiveLizardLoadLoanLobsterLocalLockLogicLonelyLongLoopLotteryLoudLoungeLoveLoyalLuckyLuggageLumberLunarLunchLuxuryLyricsMachineMadMagicMagnetMaidMailMainMajorMakeMammalManManageMandateMangoMansionManualMapleMarbleMarchMarginMarineMarketMarriageMaskMassMasterMatchMaterialMathMatrixMatterMaximumMazeMeadowMeanMeasureMeatMechanicMedalMediaMelodyMeltMemberMemoryMentionMenuMercyMergeMeritMerryMeshMessageMetalMethodMiddleMidnightMilkMillionMimicMindMinimumMinorMinuteMiracleMirrorMiseryMissMistakeMixMixedMixtureMobileModelModifyMomMomentMonitorMonkeyMonsterMonthMoonMoralMoreMorningMosquitoMotherMotionMotorMountainMouseMoveMovieMuchMuffinMuleMultiplyMuscleMuseumMushroomMusicMustMutualMyselfMysteryMythNaiveNameNapkinNarrowNastyNationNatureNearNeckNeedNegativeNeglectNeitherNephewNerveNestNetNetworkNeutralNeverNewsNextNiceNightNobleNoiseNomineeNoodleNormalNorthNoseNotableNoteNothingNoticeNovelNowNuclearNumberNurseNutOakObeyObjectObligeObscureObserveObtainObviousOccurOceanOctoberOdorOffOfferOfficeOftenOilOkayOldOliveOlympicOmitOnceOneOnionOnlineOnlyOpenOperaOpinionOpposeOptionOrangeOrbitOrchardOrderOrdinaryOrganOrientOriginalOrphanOstrichOtherOutdoorOuterOutputOutsideOvalOvenOverOwnOwnerOxygenOysterOzonePactPaddlePagePairPalacePalmPandaPanelPanicPantherPaperParadeParentParkParrotPartyPassPatchPathPatientPatrolPatternPausePavePaymentPeacePeanutPearPeasantPelicanPenPenaltyPencilPeoplePepperPerfectPermitPersonPetPhonePhotoPhrasePhysicalPianoPicnicPicturePiecePigPigeonPillPilotPinkPioneerPipePistolPitchPizzaPlacePlanetPlasticPlatePlayPleasePledgePluckPlugPlungePoemPoetPointPolarPolePolicePondPonyPoolPopularPortionPositionPossiblePostPotatoPotteryPovertyPowderPowerPracticePraisePredictPreferPreparePresentPrettyPreventPricePridePrimaryPrintPriorityPrisonPrivatePrizeProblemProcessProduceProfitProgramProjectPromoteProofPropertyProsperProtectProudProvidePublicPuddingPullPulpPulsePumpkinPunchPupilPuppyPurchasePurityPurposePursePushPutPuzzlePyramidQualityQuantumQuarterQuestionQuickQuitQuizQuoteRabbitRaccoonRaceRackRadarRadioRailRainRaiseRallyRampRanchRandomRangeRapidRareRateRatherRavenRawRazorReadyRealReasonRebelRebuildRecallReceiveRecipeRecordRecycleReduceReflectReformRefuseRegionRegretRegularRejectRelaxReleaseReliefRelyRemainRememberRemindRemoveRenderRenewRentReopenRepairRepeatReplaceReportRequireRescueResembleResistResourceResponseResultRetireRetreatReturnReunionRevealReviewRewardRhythmRibRibbonRiceRichRideRidgeRifleRightRigidRingRiotRippleRiskRitualRivalRiverRoadRoastRobotRobustRocketRomanceRoofRookieRoomRoseRotateRoughRoundRouteRoyalRubberRudeRugRuleRunRunwayRuralSadSaddleSadnessSafeSailSaladSalmonSalonSaltSaluteSameSampleSandSatisfySatoshiSauceSausageSaveSayScaleScanScareScatterSceneSchemeSchoolScienceScissorsScorpionScoutScrapScreenScriptScrubSeaSearchSeasonSeatSecondSecretSectionSecuritySeedSeekSegmentSelectSellSeminarSeniorSenseSentenceSeriesServiceSessionSettleSetupSevenShadowShaftShallowShareShedShellSheriffShieldShiftShineShipShiverShockShoeShootShopShortShoulderShoveShrimpShrugShuffleShySiblingSickSideSiegeSightSignSilentSilkSillySilverSimilarSimpleSinceSingSirenSisterSituateSixSizeSkateSketchSkiSkillSkinSkirtSkullSlabSlamSleepSlenderSliceSlideSlightSlimSloganSlotSlowSlushSmallSmartSmileSmokeSmoothSnackSnakeSnapSniffSnowSoapSoccerSocialSockSodaSoftSolarSoldierSolidSolutionSolveSomeoneSongSoonSorrySortSoulSoundSoupSourceSouthSpaceSpareSpatialSpawnSpeakSpecialSpeedSpellSpendSphereSpiceSpiderSpikeSpinSpiritSplitSpoilSponsorSpoonSportSpotSpraySpreadSpringSpySquareSqueezeSquirrelStableStadiumStaffStageStairsStampStandStartStateStaySteakSteelStemStepStereoStickStillStingStockStomachStoneStoolStoryStoveStrategyStreetStrikeStrongStruggleStudentStuffStumbleStyleSubjectSubmitSubwaySuccessSuchSuddenSufferSugarSuggestSuitSummerSunSunnySunsetSuperSupplySupremeSureSurfaceSurgeSurpriseSurroundSurveySuspectSustainSwallowSwampSwapSwarmSwearSweetSwiftSwimSwingSwitchSwordSymbolSymptomSyrupSystemTableTackleTagTailTalentTalkTankTapeTargetTaskTasteTattooTaxiTeachTeamTellTenTenantTennisTentTermTestTextThankThatThemeThenTheoryThereTheyThingThisThoughtThreeThriveThrowThumbThunderTicketTideTigerTiltTimberTimeTinyTipTiredTissueTitleToastTobaccoTodayToddlerToeTogetherToiletTokenTomatoTomorrowToneTongueTonightToolToothTopTopicToppleTorchTornadoTortoiseTossTotalTouristTowardTowerTownToyTrackTradeTrafficTragicTrainTransferTrapTrashTravelTrayTreatTreeTrendTrialTribeTrickTriggerTrimTripTrophyTroubleTruckTrueTrulyTrumpetTrustTruthTryTubeTuitionTumbleTunaTunnelTurkeyTurnTurtleTwelveTwentyTwiceTwinTwistTwoTypeTypicalUglyUmbrellaUnableUnawareUncleUncoverUnderUndoUnfairUnfoldUnhappyUniformUniqueUnitUniverseUnknownUnlockUntilUnusualUnveilUpdateUpgradeUpholdUponUpperUpsetUrbanUrgeUsageUseUsedUsefulUselessUsualUtilityVacantVacuumVagueValidValleyValveVanVanishVaporVariousVastVaultVehicleVelvetVendorVentureVenueVerbVerifyVersionVeryVesselVeteranViableVibrantViciousVictoryVideoViewVillageVintageViolinVirtualVirusVisaVisitVisualVitalVividVocalVoiceVoidVolcanoVolumeVoteVoyageWageWagonWaitWalkWallWalnutWantWarfareWarmWarriorWashWaspWasteWaterWaveWayWealthWeaponWearWeaselWeatherWebWeddingWeekendWeirdWelcomeWestWetWhaleWhatWheatWheelWhenWhereWhipWhisperWideWidthWifeWildWillWinWindowWineWingWinkWinnerWinterWireWisdomWiseWishWitnessWolfWomanWonderWoodWoolWordWorkWorldWorryWorthWrapWreckWrestleWristWriteWrongYardYearYellowYouYoungYouthZebraZeroZoneZoo";
let $07616eb0958c2519$var$wordlist = null;
function $07616eb0958c2519$var$loadWords(lang) {
    if ($07616eb0958c2519$var$wordlist != null) return;
    $07616eb0958c2519$var$wordlist = $07616eb0958c2519$var$words.replace(/([A-Z])/g, " $1").toLowerCase().substring(1).split(" ");
    // Verify the computed list matches the official list
    /* istanbul ignore if */ if ((0, $2BDj9.Wordlist).check(lang) !== "0x3c8acc1e7b08d8e76f9fda015ef48dc8c710a73cb7e0f77b2c18a9b5a7adde60") {
        $07616eb0958c2519$var$wordlist = null;
        throw new Error("BIP39 Wordlist for en (English) FAILED");
    }
}
class $07616eb0958c2519$var$LangEn extends (0, $2BDj9.Wordlist) {
    constructor(){
        super("en");
    }
    getWord(index) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist[index];
    }
    getWordIndex(word) {
        $07616eb0958c2519$var$loadWords(this);
        return $07616eb0958c2519$var$wordlist.indexOf(word);
    }
}
const $07616eb0958c2519$export$a2c9518710cf1f49 = new $07616eb0958c2519$var$LangEn();
(0, $2BDj9.Wordlist).register($07616eb0958c2519$export$a2c9518710cf1f49);

});
parcelRegister("2BDj9", function(module, exports) {

$parcel$export(module.exports, "Wordlist", function () { return $1e5d872ea253eb5d$export$4d9531a8ddb0ebca; });

var $1JJGc = parcelRequire("1JJGc");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $faIFF = parcelRequire("faIFF");
"use strict";
// This gets overridden by rollup
const $1e5d872ea253eb5d$var$exportWordlist = false;
const $1e5d872ea253eb5d$export$af88d00dbe7f521 = new (0, $8bxC3.Logger)((0, $faIFF.version));
class $1e5d872ea253eb5d$export$4d9531a8ddb0ebca {
    constructor(locale){
        $1e5d872ea253eb5d$export$af88d00dbe7f521.checkAbstract(new.target, $1e5d872ea253eb5d$export$4d9531a8ddb0ebca);
        (0, $i6lOf.defineReadOnly)(this, "locale", locale);
    }
    // Subclasses may override this
    split(mnemonic) {
        return mnemonic.toLowerCase().split(/ +/g);
    }
    // Subclasses may override this
    join(words) {
        return words.join(" ");
    }
    static check(wordlist) {
        const words = [];
        for(let i = 0; i < 2048; i++){
            const word = wordlist.getWord(i);
            /* istanbul ignore if */ if (i !== wordlist.getWordIndex(word)) return "0x";
            words.push(word);
        }
        return (0, $1JJGc.id)(words.join("\n") + "\n");
    }
    static register(lang, name) {
        if (!name) name = lang.locale;
        /* istanbul ignore if */ if ($1e5d872ea253eb5d$var$exportWordlist) try {
            const anyGlobal = window;
            if (anyGlobal._ethers && anyGlobal._ethers.wordlists) {
                if (!anyGlobal._ethers.wordlists[name]) (0, $i6lOf.defineReadOnly)(anyGlobal._ethers.wordlists, name, lang);
            }
        } catch (error) {}
    }
}

});
parcelRegister("faIFF", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b0ba70eb749ee0f3$export$83d89fbfd8236492; });
const $b0ba70eb749ee0f3$export$83d89fbfd8236492 = "wordlists/5.7.0";

});




parcelRegister("9tEcL", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $6e6602507bcb9673$export$83d89fbfd8236492; });
const $6e6602507bcb9673$export$83d89fbfd8236492 = "hdnode/5.7.0";

});


parcelRegister("UqakH", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $0a998708283ccc39$export$5f828d93ff035aa8; });

var $ApLZa = parcelRequire("ApLZa");

var $8bxC3 = parcelRequire("8bxC3");

var $fFtwA = parcelRequire("fFtwA");
"use strict";
const $0a998708283ccc39$var$logger = new (0, $8bxC3.Logger)((0, $fFtwA.version));
// Debugging line for testing browser lib in node
//const window = { crypto: { getRandomValues: () => { } } };
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis
function $0a998708283ccc39$var$getGlobal() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("unable to locate global object");
}
const $0a998708283ccc39$var$anyGlobal = $0a998708283ccc39$var$getGlobal();
let $0a998708283ccc39$var$crypto = $0a998708283ccc39$var$anyGlobal.crypto || $0a998708283ccc39$var$anyGlobal.msCrypto;
if (!$0a998708283ccc39$var$crypto || !$0a998708283ccc39$var$crypto.getRandomValues) {
    $0a998708283ccc39$var$logger.warn("WARNING: Missing strong random number source");
    $0a998708283ccc39$var$crypto = {
        getRandomValues: function(buffer) {
            return $0a998708283ccc39$var$logger.throwError("no secure random source avaialble", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "crypto.getRandomValues"
            });
        }
    };
}
function $0a998708283ccc39$export$5f828d93ff035aa8(length) {
    if (length <= 0 || length > 1024 || length % 1 || length != length) $0a998708283ccc39$var$logger.throwArgumentError("invalid length", "length", length);
    const result = new Uint8Array(length);
    $0a998708283ccc39$var$crypto.getRandomValues(result);
    return (0, $ApLZa.arrayify)(result);
}

});
parcelRegister("fFtwA", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $b681964b2c6f088d$export$83d89fbfd8236492; });
const $b681964b2c6f088d$export$83d89fbfd8236492 = "random/5.7.0";

});


parcelRegister("cX1MI", function(module, exports) {

$parcel$export(module.exports, "decryptJsonWallet", function () { return $96dc61236f851eb2$export$e74fcde37488267a; });
$parcel$export(module.exports, "decryptJsonWalletSync", function () { return $96dc61236f851eb2$export$7a81c437a678891a; });

var $9GJ9z = parcelRequire("9GJ9z");

var $3hMhy = parcelRequire("3hMhy");

var $gju9h = parcelRequire("gju9h");
"use strict";
function $96dc61236f851eb2$export$e74fcde37488267a(json, password, progressCallback) {
    if ((0, $3hMhy.isCrowdsaleWallet)(json)) {
        if (progressCallback) progressCallback(0);
        const account = (0, $9GJ9z.decrypt)(json, password);
        if (progressCallback) progressCallback(1);
        return Promise.resolve(account);
    }
    if ((0, $3hMhy.isKeystoreWallet)(json)) return (0, $gju9h.decrypt)(json, password, progressCallback);
    return Promise.reject(new Error("invalid JSON wallet"));
}
function $96dc61236f851eb2$export$7a81c437a678891a(json, password) {
    if ((0, $3hMhy.isCrowdsaleWallet)(json)) return (0, $9GJ9z.decrypt)(json, password);
    if ((0, $3hMhy.isKeystoreWallet)(json)) return (0, $gju9h.decryptSync)(json, password);
    throw new Error("invalid JSON wallet");
}

});
parcelRegister("9GJ9z", function(module, exports) {

$parcel$export(module.exports, "decrypt", function () { return $70db0fcce8592167$export$e85a0c9a1067c5d3; });

var $4iEc2 = parcelRequire("4iEc2");

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $75K6s = parcelRequire("75K6s");

var $aCHl8 = parcelRequire("aCHl8");

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $bwDSW = parcelRequire("bwDSW");

var $fgNdo = parcelRequire("fgNdo");
"use strict";
const $70db0fcce8592167$var$logger = new (0, $8bxC3.Logger)((0, $bwDSW.version));
class $70db0fcce8592167$export$93a76d16f88f2b3 extends (0, $i6lOf.Description) {
    isCrowdsaleAccount(value) {
        return !!(value && value._isCrowdsaleAccount);
    }
}
function $70db0fcce8592167$export$e85a0c9a1067c5d3(json, password) {
    const data = JSON.parse(json);
    password = (0, $fgNdo.getPassword)(password);
    // Ethereum Address
    const ethaddr = (0, $7pv2A.getAddress)((0, $fgNdo.searchPath)(data, "ethaddr"));
    // Encrypted Seed
    const encseed = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "encseed"));
    if (!encseed || encseed.length % 16 !== 0) $70db0fcce8592167$var$logger.throwArgumentError("invalid encseed", "json", json);
    const key = (0, $ApLZa.arrayify)((0, $75K6s.pbkdf2)(password, password, 2000, 32, "sha256")).slice(0, 16);
    const iv = encseed.slice(0, 16);
    const encryptedSeed = encseed.slice(16);
    // Decrypt the seed
    const aesCbc = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.cbc(key, iv);
    const seed = (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).padding.pkcs7.strip((0, $ApLZa.arrayify)(aesCbc.decrypt(encryptedSeed)));
    // This wallet format is weird... Convert the binary encoded hex to a string.
    let seedHex = "";
    for(let i = 0; i < seed.length; i++)seedHex += String.fromCharCode(seed[i]);
    const seedHexBytes = (0, $aCHl8.toUtf8Bytes)(seedHex);
    const privateKey = (0, $8unkG.keccak256)(seedHexBytes);
    return new $70db0fcce8592167$export$93a76d16f88f2b3({
        _isCrowdsaleAccount: true,
        address: ethaddr,
        privateKey: privateKey
    });
}

});
parcelRegister("4iEc2", function(module, exports) {
"use strict";
(function(root) {
    function checkInt(value) {
        return parseInt(value) === value;
    }
    function checkInts(arrayish) {
        if (!checkInt(arrayish.length)) return false;
        for(var i = 0; i < arrayish.length; i++){
            if (!checkInt(arrayish[i]) || arrayish[i] < 0 || arrayish[i] > 255) return false;
        }
        return true;
    }
    function coerceArray(arg, copy) {
        // ArrayBuffer view
        if (arg.buffer && ArrayBuffer.isView(arg) && arg.name === "Uint8Array") {
            if (copy) {
                if (arg.slice) arg = arg.slice();
                else arg = Array.prototype.slice.call(arg);
            }
            return arg;
        }
        // It's an array; check it is a valid representation of a byte
        if (Array.isArray(arg)) {
            if (!checkInts(arg)) throw new Error("Array contains invalid value: " + arg);
            return new Uint8Array(arg);
        }
        // Something else, but behaves like an array (maybe a Buffer? Arguments?)
        if (checkInt(arg.length) && checkInts(arg)) return new Uint8Array(arg);
        throw new Error("unsupported array-like object");
    }
    function createArray(length) {
        return new Uint8Array(length);
    }
    function copyArray(sourceArray, targetArray, targetStart, sourceStart, sourceEnd) {
        if (sourceStart != null || sourceEnd != null) {
            if (sourceArray.slice) sourceArray = sourceArray.slice(sourceStart, sourceEnd);
            else sourceArray = Array.prototype.slice.call(sourceArray, sourceStart, sourceEnd);
        }
        targetArray.set(sourceArray, targetStart);
    }
    var convertUtf8 = function() {
        function toBytes(text) {
            var result = [], i = 0;
            text = encodeURI(text);
            while(i < text.length){
                var c = text.charCodeAt(i++);
                // if it is a % sign, encode the following 2 bytes as a hex value
                if (c === 37) {
                    result.push(parseInt(text.substr(i, 2), 16));
                    i += 2;
                // otherwise, just the actual byte
                } else result.push(c);
            }
            return coerceArray(result);
        }
        function fromBytes(bytes) {
            var result = [], i = 0;
            while(i < bytes.length){
                var c = bytes[i];
                if (c < 128) {
                    result.push(String.fromCharCode(c));
                    i++;
                } else if (c > 191 && c < 224) {
                    result.push(String.fromCharCode((c & 0x1f) << 6 | bytes[i + 1] & 0x3f));
                    i += 2;
                } else {
                    result.push(String.fromCharCode((c & 0x0f) << 12 | (bytes[i + 1] & 0x3f) << 6 | bytes[i + 2] & 0x3f));
                    i += 3;
                }
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    var convertHex = function() {
        function toBytes(text) {
            var result = [];
            for(var i = 0; i < text.length; i += 2)result.push(parseInt(text.substr(i, 2), 16));
            return result;
        }
        // http://ixti.net/development/javascript/2011/11/11/base64-encodedecode-of-utf8-in-browser-with-js.html
        var Hex = "0123456789abcdef";
        function fromBytes(bytes) {
            var result = [];
            for(var i = 0; i < bytes.length; i++){
                var v = bytes[i];
                result.push(Hex[(v & 0xf0) >> 4] + Hex[v & 0x0f]);
            }
            return result.join("");
        }
        return {
            toBytes: toBytes,
            fromBytes: fromBytes
        };
    }();
    // Number of rounds by keysize
    var numberOfRounds = {
        16: 10,
        24: 12,
        32: 14
    };
    // Round constant words
    var rcon = [
        0x01,
        0x02,
        0x04,
        0x08,
        0x10,
        0x20,
        0x40,
        0x80,
        0x1b,
        0x36,
        0x6c,
        0xd8,
        0xab,
        0x4d,
        0x9a,
        0x2f,
        0x5e,
        0xbc,
        0x63,
        0xc6,
        0x97,
        0x35,
        0x6a,
        0xd4,
        0xb3,
        0x7d,
        0xfa,
        0xef,
        0xc5,
        0x91
    ];
    // S-box and Inverse S-box (S is for Substitution)
    var S = [
        0x63,
        0x7c,
        0x77,
        0x7b,
        0xf2,
        0x6b,
        0x6f,
        0xc5,
        0x30,
        0x01,
        0x67,
        0x2b,
        0xfe,
        0xd7,
        0xab,
        0x76,
        0xca,
        0x82,
        0xc9,
        0x7d,
        0xfa,
        0x59,
        0x47,
        0xf0,
        0xad,
        0xd4,
        0xa2,
        0xaf,
        0x9c,
        0xa4,
        0x72,
        0xc0,
        0xb7,
        0xfd,
        0x93,
        0x26,
        0x36,
        0x3f,
        0xf7,
        0xcc,
        0x34,
        0xa5,
        0xe5,
        0xf1,
        0x71,
        0xd8,
        0x31,
        0x15,
        0x04,
        0xc7,
        0x23,
        0xc3,
        0x18,
        0x96,
        0x05,
        0x9a,
        0x07,
        0x12,
        0x80,
        0xe2,
        0xeb,
        0x27,
        0xb2,
        0x75,
        0x09,
        0x83,
        0x2c,
        0x1a,
        0x1b,
        0x6e,
        0x5a,
        0xa0,
        0x52,
        0x3b,
        0xd6,
        0xb3,
        0x29,
        0xe3,
        0x2f,
        0x84,
        0x53,
        0xd1,
        0x00,
        0xed,
        0x20,
        0xfc,
        0xb1,
        0x5b,
        0x6a,
        0xcb,
        0xbe,
        0x39,
        0x4a,
        0x4c,
        0x58,
        0xcf,
        0xd0,
        0xef,
        0xaa,
        0xfb,
        0x43,
        0x4d,
        0x33,
        0x85,
        0x45,
        0xf9,
        0x02,
        0x7f,
        0x50,
        0x3c,
        0x9f,
        0xa8,
        0x51,
        0xa3,
        0x40,
        0x8f,
        0x92,
        0x9d,
        0x38,
        0xf5,
        0xbc,
        0xb6,
        0xda,
        0x21,
        0x10,
        0xff,
        0xf3,
        0xd2,
        0xcd,
        0x0c,
        0x13,
        0xec,
        0x5f,
        0x97,
        0x44,
        0x17,
        0xc4,
        0xa7,
        0x7e,
        0x3d,
        0x64,
        0x5d,
        0x19,
        0x73,
        0x60,
        0x81,
        0x4f,
        0xdc,
        0x22,
        0x2a,
        0x90,
        0x88,
        0x46,
        0xee,
        0xb8,
        0x14,
        0xde,
        0x5e,
        0x0b,
        0xdb,
        0xe0,
        0x32,
        0x3a,
        0x0a,
        0x49,
        0x06,
        0x24,
        0x5c,
        0xc2,
        0xd3,
        0xac,
        0x62,
        0x91,
        0x95,
        0xe4,
        0x79,
        0xe7,
        0xc8,
        0x37,
        0x6d,
        0x8d,
        0xd5,
        0x4e,
        0xa9,
        0x6c,
        0x56,
        0xf4,
        0xea,
        0x65,
        0x7a,
        0xae,
        0x08,
        0xba,
        0x78,
        0x25,
        0x2e,
        0x1c,
        0xa6,
        0xb4,
        0xc6,
        0xe8,
        0xdd,
        0x74,
        0x1f,
        0x4b,
        0xbd,
        0x8b,
        0x8a,
        0x70,
        0x3e,
        0xb5,
        0x66,
        0x48,
        0x03,
        0xf6,
        0x0e,
        0x61,
        0x35,
        0x57,
        0xb9,
        0x86,
        0xc1,
        0x1d,
        0x9e,
        0xe1,
        0xf8,
        0x98,
        0x11,
        0x69,
        0xd9,
        0x8e,
        0x94,
        0x9b,
        0x1e,
        0x87,
        0xe9,
        0xce,
        0x55,
        0x28,
        0xdf,
        0x8c,
        0xa1,
        0x89,
        0x0d,
        0xbf,
        0xe6,
        0x42,
        0x68,
        0x41,
        0x99,
        0x2d,
        0x0f,
        0xb0,
        0x54,
        0xbb,
        0x16
    ];
    var Si = [
        0x52,
        0x09,
        0x6a,
        0xd5,
        0x30,
        0x36,
        0xa5,
        0x38,
        0xbf,
        0x40,
        0xa3,
        0x9e,
        0x81,
        0xf3,
        0xd7,
        0xfb,
        0x7c,
        0xe3,
        0x39,
        0x82,
        0x9b,
        0x2f,
        0xff,
        0x87,
        0x34,
        0x8e,
        0x43,
        0x44,
        0xc4,
        0xde,
        0xe9,
        0xcb,
        0x54,
        0x7b,
        0x94,
        0x32,
        0xa6,
        0xc2,
        0x23,
        0x3d,
        0xee,
        0x4c,
        0x95,
        0x0b,
        0x42,
        0xfa,
        0xc3,
        0x4e,
        0x08,
        0x2e,
        0xa1,
        0x66,
        0x28,
        0xd9,
        0x24,
        0xb2,
        0x76,
        0x5b,
        0xa2,
        0x49,
        0x6d,
        0x8b,
        0xd1,
        0x25,
        0x72,
        0xf8,
        0xf6,
        0x64,
        0x86,
        0x68,
        0x98,
        0x16,
        0xd4,
        0xa4,
        0x5c,
        0xcc,
        0x5d,
        0x65,
        0xb6,
        0x92,
        0x6c,
        0x70,
        0x48,
        0x50,
        0xfd,
        0xed,
        0xb9,
        0xda,
        0x5e,
        0x15,
        0x46,
        0x57,
        0xa7,
        0x8d,
        0x9d,
        0x84,
        0x90,
        0xd8,
        0xab,
        0x00,
        0x8c,
        0xbc,
        0xd3,
        0x0a,
        0xf7,
        0xe4,
        0x58,
        0x05,
        0xb8,
        0xb3,
        0x45,
        0x06,
        0xd0,
        0x2c,
        0x1e,
        0x8f,
        0xca,
        0x3f,
        0x0f,
        0x02,
        0xc1,
        0xaf,
        0xbd,
        0x03,
        0x01,
        0x13,
        0x8a,
        0x6b,
        0x3a,
        0x91,
        0x11,
        0x41,
        0x4f,
        0x67,
        0xdc,
        0xea,
        0x97,
        0xf2,
        0xcf,
        0xce,
        0xf0,
        0xb4,
        0xe6,
        0x73,
        0x96,
        0xac,
        0x74,
        0x22,
        0xe7,
        0xad,
        0x35,
        0x85,
        0xe2,
        0xf9,
        0x37,
        0xe8,
        0x1c,
        0x75,
        0xdf,
        0x6e,
        0x47,
        0xf1,
        0x1a,
        0x71,
        0x1d,
        0x29,
        0xc5,
        0x89,
        0x6f,
        0xb7,
        0x62,
        0x0e,
        0xaa,
        0x18,
        0xbe,
        0x1b,
        0xfc,
        0x56,
        0x3e,
        0x4b,
        0xc6,
        0xd2,
        0x79,
        0x20,
        0x9a,
        0xdb,
        0xc0,
        0xfe,
        0x78,
        0xcd,
        0x5a,
        0xf4,
        0x1f,
        0xdd,
        0xa8,
        0x33,
        0x88,
        0x07,
        0xc7,
        0x31,
        0xb1,
        0x12,
        0x10,
        0x59,
        0x27,
        0x80,
        0xec,
        0x5f,
        0x60,
        0x51,
        0x7f,
        0xa9,
        0x19,
        0xb5,
        0x4a,
        0x0d,
        0x2d,
        0xe5,
        0x7a,
        0x9f,
        0x93,
        0xc9,
        0x9c,
        0xef,
        0xa0,
        0xe0,
        0x3b,
        0x4d,
        0xae,
        0x2a,
        0xf5,
        0xb0,
        0xc8,
        0xeb,
        0xbb,
        0x3c,
        0x83,
        0x53,
        0x99,
        0x61,
        0x17,
        0x2b,
        0x04,
        0x7e,
        0xba,
        0x77,
        0xd6,
        0x26,
        0xe1,
        0x69,
        0x14,
        0x63,
        0x55,
        0x21,
        0x0c,
        0x7d
    ];
    // Transformations for encryption
    var T1 = [
        0xc66363a5,
        0xf87c7c84,
        0xee777799,
        0xf67b7b8d,
        0xfff2f20d,
        0xd66b6bbd,
        0xde6f6fb1,
        0x91c5c554,
        0x60303050,
        0x02010103,
        0xce6767a9,
        0x562b2b7d,
        0xe7fefe19,
        0xb5d7d762,
        0x4dababe6,
        0xec76769a,
        0x8fcaca45,
        0x1f82829d,
        0x89c9c940,
        0xfa7d7d87,
        0xeffafa15,
        0xb25959eb,
        0x8e4747c9,
        0xfbf0f00b,
        0x41adadec,
        0xb3d4d467,
        0x5fa2a2fd,
        0x45afafea,
        0x239c9cbf,
        0x53a4a4f7,
        0xe4727296,
        0x9bc0c05b,
        0x75b7b7c2,
        0xe1fdfd1c,
        0x3d9393ae,
        0x4c26266a,
        0x6c36365a,
        0x7e3f3f41,
        0xf5f7f702,
        0x83cccc4f,
        0x6834345c,
        0x51a5a5f4,
        0xd1e5e534,
        0xf9f1f108,
        0xe2717193,
        0xabd8d873,
        0x62313153,
        0x2a15153f,
        0x0804040c,
        0x95c7c752,
        0x46232365,
        0x9dc3c35e,
        0x30181828,
        0x379696a1,
        0x0a05050f,
        0x2f9a9ab5,
        0x0e070709,
        0x24121236,
        0x1b80809b,
        0xdfe2e23d,
        0xcdebeb26,
        0x4e272769,
        0x7fb2b2cd,
        0xea75759f,
        0x1209091b,
        0x1d83839e,
        0x582c2c74,
        0x341a1a2e,
        0x361b1b2d,
        0xdc6e6eb2,
        0xb45a5aee,
        0x5ba0a0fb,
        0xa45252f6,
        0x763b3b4d,
        0xb7d6d661,
        0x7db3b3ce,
        0x5229297b,
        0xdde3e33e,
        0x5e2f2f71,
        0x13848497,
        0xa65353f5,
        0xb9d1d168,
        0x00000000,
        0xc1eded2c,
        0x40202060,
        0xe3fcfc1f,
        0x79b1b1c8,
        0xb65b5bed,
        0xd46a6abe,
        0x8dcbcb46,
        0x67bebed9,
        0x7239394b,
        0x944a4ade,
        0x984c4cd4,
        0xb05858e8,
        0x85cfcf4a,
        0xbbd0d06b,
        0xc5efef2a,
        0x4faaaae5,
        0xedfbfb16,
        0x864343c5,
        0x9a4d4dd7,
        0x66333355,
        0x11858594,
        0x8a4545cf,
        0xe9f9f910,
        0x04020206,
        0xfe7f7f81,
        0xa05050f0,
        0x783c3c44,
        0x259f9fba,
        0x4ba8a8e3,
        0xa25151f3,
        0x5da3a3fe,
        0x804040c0,
        0x058f8f8a,
        0x3f9292ad,
        0x219d9dbc,
        0x70383848,
        0xf1f5f504,
        0x63bcbcdf,
        0x77b6b6c1,
        0xafdada75,
        0x42212163,
        0x20101030,
        0xe5ffff1a,
        0xfdf3f30e,
        0xbfd2d26d,
        0x81cdcd4c,
        0x180c0c14,
        0x26131335,
        0xc3ecec2f,
        0xbe5f5fe1,
        0x359797a2,
        0x884444cc,
        0x2e171739,
        0x93c4c457,
        0x55a7a7f2,
        0xfc7e7e82,
        0x7a3d3d47,
        0xc86464ac,
        0xba5d5de7,
        0x3219192b,
        0xe6737395,
        0xc06060a0,
        0x19818198,
        0x9e4f4fd1,
        0xa3dcdc7f,
        0x44222266,
        0x542a2a7e,
        0x3b9090ab,
        0x0b888883,
        0x8c4646ca,
        0xc7eeee29,
        0x6bb8b8d3,
        0x2814143c,
        0xa7dede79,
        0xbc5e5ee2,
        0x160b0b1d,
        0xaddbdb76,
        0xdbe0e03b,
        0x64323256,
        0x743a3a4e,
        0x140a0a1e,
        0x924949db,
        0x0c06060a,
        0x4824246c,
        0xb85c5ce4,
        0x9fc2c25d,
        0xbdd3d36e,
        0x43acacef,
        0xc46262a6,
        0x399191a8,
        0x319595a4,
        0xd3e4e437,
        0xf279798b,
        0xd5e7e732,
        0x8bc8c843,
        0x6e373759,
        0xda6d6db7,
        0x018d8d8c,
        0xb1d5d564,
        0x9c4e4ed2,
        0x49a9a9e0,
        0xd86c6cb4,
        0xac5656fa,
        0xf3f4f407,
        0xcfeaea25,
        0xca6565af,
        0xf47a7a8e,
        0x47aeaee9,
        0x10080818,
        0x6fbabad5,
        0xf0787888,
        0x4a25256f,
        0x5c2e2e72,
        0x381c1c24,
        0x57a6a6f1,
        0x73b4b4c7,
        0x97c6c651,
        0xcbe8e823,
        0xa1dddd7c,
        0xe874749c,
        0x3e1f1f21,
        0x964b4bdd,
        0x61bdbddc,
        0x0d8b8b86,
        0x0f8a8a85,
        0xe0707090,
        0x7c3e3e42,
        0x71b5b5c4,
        0xcc6666aa,
        0x904848d8,
        0x06030305,
        0xf7f6f601,
        0x1c0e0e12,
        0xc26161a3,
        0x6a35355f,
        0xae5757f9,
        0x69b9b9d0,
        0x17868691,
        0x99c1c158,
        0x3a1d1d27,
        0x279e9eb9,
        0xd9e1e138,
        0xebf8f813,
        0x2b9898b3,
        0x22111133,
        0xd26969bb,
        0xa9d9d970,
        0x078e8e89,
        0x339494a7,
        0x2d9b9bb6,
        0x3c1e1e22,
        0x15878792,
        0xc9e9e920,
        0x87cece49,
        0xaa5555ff,
        0x50282878,
        0xa5dfdf7a,
        0x038c8c8f,
        0x59a1a1f8,
        0x09898980,
        0x1a0d0d17,
        0x65bfbfda,
        0xd7e6e631,
        0x844242c6,
        0xd06868b8,
        0x824141c3,
        0x299999b0,
        0x5a2d2d77,
        0x1e0f0f11,
        0x7bb0b0cb,
        0xa85454fc,
        0x6dbbbbd6,
        0x2c16163a
    ];
    var T2 = [
        0xa5c66363,
        0x84f87c7c,
        0x99ee7777,
        0x8df67b7b,
        0x0dfff2f2,
        0xbdd66b6b,
        0xb1de6f6f,
        0x5491c5c5,
        0x50603030,
        0x03020101,
        0xa9ce6767,
        0x7d562b2b,
        0x19e7fefe,
        0x62b5d7d7,
        0xe64dabab,
        0x9aec7676,
        0x458fcaca,
        0x9d1f8282,
        0x4089c9c9,
        0x87fa7d7d,
        0x15effafa,
        0xebb25959,
        0xc98e4747,
        0x0bfbf0f0,
        0xec41adad,
        0x67b3d4d4,
        0xfd5fa2a2,
        0xea45afaf,
        0xbf239c9c,
        0xf753a4a4,
        0x96e47272,
        0x5b9bc0c0,
        0xc275b7b7,
        0x1ce1fdfd,
        0xae3d9393,
        0x6a4c2626,
        0x5a6c3636,
        0x417e3f3f,
        0x02f5f7f7,
        0x4f83cccc,
        0x5c683434,
        0xf451a5a5,
        0x34d1e5e5,
        0x08f9f1f1,
        0x93e27171,
        0x73abd8d8,
        0x53623131,
        0x3f2a1515,
        0x0c080404,
        0x5295c7c7,
        0x65462323,
        0x5e9dc3c3,
        0x28301818,
        0xa1379696,
        0x0f0a0505,
        0xb52f9a9a,
        0x090e0707,
        0x36241212,
        0x9b1b8080,
        0x3ddfe2e2,
        0x26cdebeb,
        0x694e2727,
        0xcd7fb2b2,
        0x9fea7575,
        0x1b120909,
        0x9e1d8383,
        0x74582c2c,
        0x2e341a1a,
        0x2d361b1b,
        0xb2dc6e6e,
        0xeeb45a5a,
        0xfb5ba0a0,
        0xf6a45252,
        0x4d763b3b,
        0x61b7d6d6,
        0xce7db3b3,
        0x7b522929,
        0x3edde3e3,
        0x715e2f2f,
        0x97138484,
        0xf5a65353,
        0x68b9d1d1,
        0x00000000,
        0x2cc1eded,
        0x60402020,
        0x1fe3fcfc,
        0xc879b1b1,
        0xedb65b5b,
        0xbed46a6a,
        0x468dcbcb,
        0xd967bebe,
        0x4b723939,
        0xde944a4a,
        0xd4984c4c,
        0xe8b05858,
        0x4a85cfcf,
        0x6bbbd0d0,
        0x2ac5efef,
        0xe54faaaa,
        0x16edfbfb,
        0xc5864343,
        0xd79a4d4d,
        0x55663333,
        0x94118585,
        0xcf8a4545,
        0x10e9f9f9,
        0x06040202,
        0x81fe7f7f,
        0xf0a05050,
        0x44783c3c,
        0xba259f9f,
        0xe34ba8a8,
        0xf3a25151,
        0xfe5da3a3,
        0xc0804040,
        0x8a058f8f,
        0xad3f9292,
        0xbc219d9d,
        0x48703838,
        0x04f1f5f5,
        0xdf63bcbc,
        0xc177b6b6,
        0x75afdada,
        0x63422121,
        0x30201010,
        0x1ae5ffff,
        0x0efdf3f3,
        0x6dbfd2d2,
        0x4c81cdcd,
        0x14180c0c,
        0x35261313,
        0x2fc3ecec,
        0xe1be5f5f,
        0xa2359797,
        0xcc884444,
        0x392e1717,
        0x5793c4c4,
        0xf255a7a7,
        0x82fc7e7e,
        0x477a3d3d,
        0xacc86464,
        0xe7ba5d5d,
        0x2b321919,
        0x95e67373,
        0xa0c06060,
        0x98198181,
        0xd19e4f4f,
        0x7fa3dcdc,
        0x66442222,
        0x7e542a2a,
        0xab3b9090,
        0x830b8888,
        0xca8c4646,
        0x29c7eeee,
        0xd36bb8b8,
        0x3c281414,
        0x79a7dede,
        0xe2bc5e5e,
        0x1d160b0b,
        0x76addbdb,
        0x3bdbe0e0,
        0x56643232,
        0x4e743a3a,
        0x1e140a0a,
        0xdb924949,
        0x0a0c0606,
        0x6c482424,
        0xe4b85c5c,
        0x5d9fc2c2,
        0x6ebdd3d3,
        0xef43acac,
        0xa6c46262,
        0xa8399191,
        0xa4319595,
        0x37d3e4e4,
        0x8bf27979,
        0x32d5e7e7,
        0x438bc8c8,
        0x596e3737,
        0xb7da6d6d,
        0x8c018d8d,
        0x64b1d5d5,
        0xd29c4e4e,
        0xe049a9a9,
        0xb4d86c6c,
        0xfaac5656,
        0x07f3f4f4,
        0x25cfeaea,
        0xafca6565,
        0x8ef47a7a,
        0xe947aeae,
        0x18100808,
        0xd56fbaba,
        0x88f07878,
        0x6f4a2525,
        0x725c2e2e,
        0x24381c1c,
        0xf157a6a6,
        0xc773b4b4,
        0x5197c6c6,
        0x23cbe8e8,
        0x7ca1dddd,
        0x9ce87474,
        0x213e1f1f,
        0xdd964b4b,
        0xdc61bdbd,
        0x860d8b8b,
        0x850f8a8a,
        0x90e07070,
        0x427c3e3e,
        0xc471b5b5,
        0xaacc6666,
        0xd8904848,
        0x05060303,
        0x01f7f6f6,
        0x121c0e0e,
        0xa3c26161,
        0x5f6a3535,
        0xf9ae5757,
        0xd069b9b9,
        0x91178686,
        0x5899c1c1,
        0x273a1d1d,
        0xb9279e9e,
        0x38d9e1e1,
        0x13ebf8f8,
        0xb32b9898,
        0x33221111,
        0xbbd26969,
        0x70a9d9d9,
        0x89078e8e,
        0xa7339494,
        0xb62d9b9b,
        0x223c1e1e,
        0x92158787,
        0x20c9e9e9,
        0x4987cece,
        0xffaa5555,
        0x78502828,
        0x7aa5dfdf,
        0x8f038c8c,
        0xf859a1a1,
        0x80098989,
        0x171a0d0d,
        0xda65bfbf,
        0x31d7e6e6,
        0xc6844242,
        0xb8d06868,
        0xc3824141,
        0xb0299999,
        0x775a2d2d,
        0x111e0f0f,
        0xcb7bb0b0,
        0xfca85454,
        0xd66dbbbb,
        0x3a2c1616
    ];
    var T3 = [
        0x63a5c663,
        0x7c84f87c,
        0x7799ee77,
        0x7b8df67b,
        0xf20dfff2,
        0x6bbdd66b,
        0x6fb1de6f,
        0xc55491c5,
        0x30506030,
        0x01030201,
        0x67a9ce67,
        0x2b7d562b,
        0xfe19e7fe,
        0xd762b5d7,
        0xabe64dab,
        0x769aec76,
        0xca458fca,
        0x829d1f82,
        0xc94089c9,
        0x7d87fa7d,
        0xfa15effa,
        0x59ebb259,
        0x47c98e47,
        0xf00bfbf0,
        0xadec41ad,
        0xd467b3d4,
        0xa2fd5fa2,
        0xafea45af,
        0x9cbf239c,
        0xa4f753a4,
        0x7296e472,
        0xc05b9bc0,
        0xb7c275b7,
        0xfd1ce1fd,
        0x93ae3d93,
        0x266a4c26,
        0x365a6c36,
        0x3f417e3f,
        0xf702f5f7,
        0xcc4f83cc,
        0x345c6834,
        0xa5f451a5,
        0xe534d1e5,
        0xf108f9f1,
        0x7193e271,
        0xd873abd8,
        0x31536231,
        0x153f2a15,
        0x040c0804,
        0xc75295c7,
        0x23654623,
        0xc35e9dc3,
        0x18283018,
        0x96a13796,
        0x050f0a05,
        0x9ab52f9a,
        0x07090e07,
        0x12362412,
        0x809b1b80,
        0xe23ddfe2,
        0xeb26cdeb,
        0x27694e27,
        0xb2cd7fb2,
        0x759fea75,
        0x091b1209,
        0x839e1d83,
        0x2c74582c,
        0x1a2e341a,
        0x1b2d361b,
        0x6eb2dc6e,
        0x5aeeb45a,
        0xa0fb5ba0,
        0x52f6a452,
        0x3b4d763b,
        0xd661b7d6,
        0xb3ce7db3,
        0x297b5229,
        0xe33edde3,
        0x2f715e2f,
        0x84971384,
        0x53f5a653,
        0xd168b9d1,
        0x00000000,
        0xed2cc1ed,
        0x20604020,
        0xfc1fe3fc,
        0xb1c879b1,
        0x5bedb65b,
        0x6abed46a,
        0xcb468dcb,
        0xbed967be,
        0x394b7239,
        0x4ade944a,
        0x4cd4984c,
        0x58e8b058,
        0xcf4a85cf,
        0xd06bbbd0,
        0xef2ac5ef,
        0xaae54faa,
        0xfb16edfb,
        0x43c58643,
        0x4dd79a4d,
        0x33556633,
        0x85941185,
        0x45cf8a45,
        0xf910e9f9,
        0x02060402,
        0x7f81fe7f,
        0x50f0a050,
        0x3c44783c,
        0x9fba259f,
        0xa8e34ba8,
        0x51f3a251,
        0xa3fe5da3,
        0x40c08040,
        0x8f8a058f,
        0x92ad3f92,
        0x9dbc219d,
        0x38487038,
        0xf504f1f5,
        0xbcdf63bc,
        0xb6c177b6,
        0xda75afda,
        0x21634221,
        0x10302010,
        0xff1ae5ff,
        0xf30efdf3,
        0xd26dbfd2,
        0xcd4c81cd,
        0x0c14180c,
        0x13352613,
        0xec2fc3ec,
        0x5fe1be5f,
        0x97a23597,
        0x44cc8844,
        0x17392e17,
        0xc45793c4,
        0xa7f255a7,
        0x7e82fc7e,
        0x3d477a3d,
        0x64acc864,
        0x5de7ba5d,
        0x192b3219,
        0x7395e673,
        0x60a0c060,
        0x81981981,
        0x4fd19e4f,
        0xdc7fa3dc,
        0x22664422,
        0x2a7e542a,
        0x90ab3b90,
        0x88830b88,
        0x46ca8c46,
        0xee29c7ee,
        0xb8d36bb8,
        0x143c2814,
        0xde79a7de,
        0x5ee2bc5e,
        0x0b1d160b,
        0xdb76addb,
        0xe03bdbe0,
        0x32566432,
        0x3a4e743a,
        0x0a1e140a,
        0x49db9249,
        0x060a0c06,
        0x246c4824,
        0x5ce4b85c,
        0xc25d9fc2,
        0xd36ebdd3,
        0xacef43ac,
        0x62a6c462,
        0x91a83991,
        0x95a43195,
        0xe437d3e4,
        0x798bf279,
        0xe732d5e7,
        0xc8438bc8,
        0x37596e37,
        0x6db7da6d,
        0x8d8c018d,
        0xd564b1d5,
        0x4ed29c4e,
        0xa9e049a9,
        0x6cb4d86c,
        0x56faac56,
        0xf407f3f4,
        0xea25cfea,
        0x65afca65,
        0x7a8ef47a,
        0xaee947ae,
        0x08181008,
        0xbad56fba,
        0x7888f078,
        0x256f4a25,
        0x2e725c2e,
        0x1c24381c,
        0xa6f157a6,
        0xb4c773b4,
        0xc65197c6,
        0xe823cbe8,
        0xdd7ca1dd,
        0x749ce874,
        0x1f213e1f,
        0x4bdd964b,
        0xbddc61bd,
        0x8b860d8b,
        0x8a850f8a,
        0x7090e070,
        0x3e427c3e,
        0xb5c471b5,
        0x66aacc66,
        0x48d89048,
        0x03050603,
        0xf601f7f6,
        0x0e121c0e,
        0x61a3c261,
        0x355f6a35,
        0x57f9ae57,
        0xb9d069b9,
        0x86911786,
        0xc15899c1,
        0x1d273a1d,
        0x9eb9279e,
        0xe138d9e1,
        0xf813ebf8,
        0x98b32b98,
        0x11332211,
        0x69bbd269,
        0xd970a9d9,
        0x8e89078e,
        0x94a73394,
        0x9bb62d9b,
        0x1e223c1e,
        0x87921587,
        0xe920c9e9,
        0xce4987ce,
        0x55ffaa55,
        0x28785028,
        0xdf7aa5df,
        0x8c8f038c,
        0xa1f859a1,
        0x89800989,
        0x0d171a0d,
        0xbfda65bf,
        0xe631d7e6,
        0x42c68442,
        0x68b8d068,
        0x41c38241,
        0x99b02999,
        0x2d775a2d,
        0x0f111e0f,
        0xb0cb7bb0,
        0x54fca854,
        0xbbd66dbb,
        0x163a2c16
    ];
    var T4 = [
        0x6363a5c6,
        0x7c7c84f8,
        0x777799ee,
        0x7b7b8df6,
        0xf2f20dff,
        0x6b6bbdd6,
        0x6f6fb1de,
        0xc5c55491,
        0x30305060,
        0x01010302,
        0x6767a9ce,
        0x2b2b7d56,
        0xfefe19e7,
        0xd7d762b5,
        0xababe64d,
        0x76769aec,
        0xcaca458f,
        0x82829d1f,
        0xc9c94089,
        0x7d7d87fa,
        0xfafa15ef,
        0x5959ebb2,
        0x4747c98e,
        0xf0f00bfb,
        0xadadec41,
        0xd4d467b3,
        0xa2a2fd5f,
        0xafafea45,
        0x9c9cbf23,
        0xa4a4f753,
        0x727296e4,
        0xc0c05b9b,
        0xb7b7c275,
        0xfdfd1ce1,
        0x9393ae3d,
        0x26266a4c,
        0x36365a6c,
        0x3f3f417e,
        0xf7f702f5,
        0xcccc4f83,
        0x34345c68,
        0xa5a5f451,
        0xe5e534d1,
        0xf1f108f9,
        0x717193e2,
        0xd8d873ab,
        0x31315362,
        0x15153f2a,
        0x04040c08,
        0xc7c75295,
        0x23236546,
        0xc3c35e9d,
        0x18182830,
        0x9696a137,
        0x05050f0a,
        0x9a9ab52f,
        0x0707090e,
        0x12123624,
        0x80809b1b,
        0xe2e23ddf,
        0xebeb26cd,
        0x2727694e,
        0xb2b2cd7f,
        0x75759fea,
        0x09091b12,
        0x83839e1d,
        0x2c2c7458,
        0x1a1a2e34,
        0x1b1b2d36,
        0x6e6eb2dc,
        0x5a5aeeb4,
        0xa0a0fb5b,
        0x5252f6a4,
        0x3b3b4d76,
        0xd6d661b7,
        0xb3b3ce7d,
        0x29297b52,
        0xe3e33edd,
        0x2f2f715e,
        0x84849713,
        0x5353f5a6,
        0xd1d168b9,
        0x00000000,
        0xeded2cc1,
        0x20206040,
        0xfcfc1fe3,
        0xb1b1c879,
        0x5b5bedb6,
        0x6a6abed4,
        0xcbcb468d,
        0xbebed967,
        0x39394b72,
        0x4a4ade94,
        0x4c4cd498,
        0x5858e8b0,
        0xcfcf4a85,
        0xd0d06bbb,
        0xefef2ac5,
        0xaaaae54f,
        0xfbfb16ed,
        0x4343c586,
        0x4d4dd79a,
        0x33335566,
        0x85859411,
        0x4545cf8a,
        0xf9f910e9,
        0x02020604,
        0x7f7f81fe,
        0x5050f0a0,
        0x3c3c4478,
        0x9f9fba25,
        0xa8a8e34b,
        0x5151f3a2,
        0xa3a3fe5d,
        0x4040c080,
        0x8f8f8a05,
        0x9292ad3f,
        0x9d9dbc21,
        0x38384870,
        0xf5f504f1,
        0xbcbcdf63,
        0xb6b6c177,
        0xdada75af,
        0x21216342,
        0x10103020,
        0xffff1ae5,
        0xf3f30efd,
        0xd2d26dbf,
        0xcdcd4c81,
        0x0c0c1418,
        0x13133526,
        0xecec2fc3,
        0x5f5fe1be,
        0x9797a235,
        0x4444cc88,
        0x1717392e,
        0xc4c45793,
        0xa7a7f255,
        0x7e7e82fc,
        0x3d3d477a,
        0x6464acc8,
        0x5d5de7ba,
        0x19192b32,
        0x737395e6,
        0x6060a0c0,
        0x81819819,
        0x4f4fd19e,
        0xdcdc7fa3,
        0x22226644,
        0x2a2a7e54,
        0x9090ab3b,
        0x8888830b,
        0x4646ca8c,
        0xeeee29c7,
        0xb8b8d36b,
        0x14143c28,
        0xdede79a7,
        0x5e5ee2bc,
        0x0b0b1d16,
        0xdbdb76ad,
        0xe0e03bdb,
        0x32325664,
        0x3a3a4e74,
        0x0a0a1e14,
        0x4949db92,
        0x06060a0c,
        0x24246c48,
        0x5c5ce4b8,
        0xc2c25d9f,
        0xd3d36ebd,
        0xacacef43,
        0x6262a6c4,
        0x9191a839,
        0x9595a431,
        0xe4e437d3,
        0x79798bf2,
        0xe7e732d5,
        0xc8c8438b,
        0x3737596e,
        0x6d6db7da,
        0x8d8d8c01,
        0xd5d564b1,
        0x4e4ed29c,
        0xa9a9e049,
        0x6c6cb4d8,
        0x5656faac,
        0xf4f407f3,
        0xeaea25cf,
        0x6565afca,
        0x7a7a8ef4,
        0xaeaee947,
        0x08081810,
        0xbabad56f,
        0x787888f0,
        0x25256f4a,
        0x2e2e725c,
        0x1c1c2438,
        0xa6a6f157,
        0xb4b4c773,
        0xc6c65197,
        0xe8e823cb,
        0xdddd7ca1,
        0x74749ce8,
        0x1f1f213e,
        0x4b4bdd96,
        0xbdbddc61,
        0x8b8b860d,
        0x8a8a850f,
        0x707090e0,
        0x3e3e427c,
        0xb5b5c471,
        0x6666aacc,
        0x4848d890,
        0x03030506,
        0xf6f601f7,
        0x0e0e121c,
        0x6161a3c2,
        0x35355f6a,
        0x5757f9ae,
        0xb9b9d069,
        0x86869117,
        0xc1c15899,
        0x1d1d273a,
        0x9e9eb927,
        0xe1e138d9,
        0xf8f813eb,
        0x9898b32b,
        0x11113322,
        0x6969bbd2,
        0xd9d970a9,
        0x8e8e8907,
        0x9494a733,
        0x9b9bb62d,
        0x1e1e223c,
        0x87879215,
        0xe9e920c9,
        0xcece4987,
        0x5555ffaa,
        0x28287850,
        0xdfdf7aa5,
        0x8c8c8f03,
        0xa1a1f859,
        0x89898009,
        0x0d0d171a,
        0xbfbfda65,
        0xe6e631d7,
        0x4242c684,
        0x6868b8d0,
        0x4141c382,
        0x9999b029,
        0x2d2d775a,
        0x0f0f111e,
        0xb0b0cb7b,
        0x5454fca8,
        0xbbbbd66d,
        0x16163a2c
    ];
    // Transformations for decryption
    var T5 = [
        0x51f4a750,
        0x7e416553,
        0x1a17a4c3,
        0x3a275e96,
        0x3bab6bcb,
        0x1f9d45f1,
        0xacfa58ab,
        0x4be30393,
        0x2030fa55,
        0xad766df6,
        0x88cc7691,
        0xf5024c25,
        0x4fe5d7fc,
        0xc52acbd7,
        0x26354480,
        0xb562a38f,
        0xdeb15a49,
        0x25ba1b67,
        0x45ea0e98,
        0x5dfec0e1,
        0xc32f7502,
        0x814cf012,
        0x8d4697a3,
        0x6bd3f9c6,
        0x038f5fe7,
        0x15929c95,
        0xbf6d7aeb,
        0x955259da,
        0xd4be832d,
        0x587421d3,
        0x49e06929,
        0x8ec9c844,
        0x75c2896a,
        0xf48e7978,
        0x99583e6b,
        0x27b971dd,
        0xbee14fb6,
        0xf088ad17,
        0xc920ac66,
        0x7dce3ab4,
        0x63df4a18,
        0xe51a3182,
        0x97513360,
        0x62537f45,
        0xb16477e0,
        0xbb6bae84,
        0xfe81a01c,
        0xf9082b94,
        0x70486858,
        0x8f45fd19,
        0x94de6c87,
        0x527bf8b7,
        0xab73d323,
        0x724b02e2,
        0xe31f8f57,
        0x6655ab2a,
        0xb2eb2807,
        0x2fb5c203,
        0x86c57b9a,
        0xd33708a5,
        0x302887f2,
        0x23bfa5b2,
        0x02036aba,
        0xed16825c,
        0x8acf1c2b,
        0xa779b492,
        0xf307f2f0,
        0x4e69e2a1,
        0x65daf4cd,
        0x0605bed5,
        0xd134621f,
        0xc4a6fe8a,
        0x342e539d,
        0xa2f355a0,
        0x058ae132,
        0xa4f6eb75,
        0x0b83ec39,
        0x4060efaa,
        0x5e719f06,
        0xbd6e1051,
        0x3e218af9,
        0x96dd063d,
        0xdd3e05ae,
        0x4de6bd46,
        0x91548db5,
        0x71c45d05,
        0x0406d46f,
        0x605015ff,
        0x1998fb24,
        0xd6bde997,
        0x894043cc,
        0x67d99e77,
        0xb0e842bd,
        0x07898b88,
        0xe7195b38,
        0x79c8eedb,
        0xa17c0a47,
        0x7c420fe9,
        0xf8841ec9,
        0x00000000,
        0x09808683,
        0x322bed48,
        0x1e1170ac,
        0x6c5a724e,
        0xfd0efffb,
        0x0f853856,
        0x3daed51e,
        0x362d3927,
        0x0a0fd964,
        0x685ca621,
        0x9b5b54d1,
        0x24362e3a,
        0x0c0a67b1,
        0x9357e70f,
        0xb4ee96d2,
        0x1b9b919e,
        0x80c0c54f,
        0x61dc20a2,
        0x5a774b69,
        0x1c121a16,
        0xe293ba0a,
        0xc0a02ae5,
        0x3c22e043,
        0x121b171d,
        0x0e090d0b,
        0xf28bc7ad,
        0x2db6a8b9,
        0x141ea9c8,
        0x57f11985,
        0xaf75074c,
        0xee99ddbb,
        0xa37f60fd,
        0xf701269f,
        0x5c72f5bc,
        0x44663bc5,
        0x5bfb7e34,
        0x8b432976,
        0xcb23c6dc,
        0xb6edfc68,
        0xb8e4f163,
        0xd731dcca,
        0x42638510,
        0x13972240,
        0x84c61120,
        0x854a247d,
        0xd2bb3df8,
        0xaef93211,
        0xc729a16d,
        0x1d9e2f4b,
        0xdcb230f3,
        0x0d8652ec,
        0x77c1e3d0,
        0x2bb3166c,
        0xa970b999,
        0x119448fa,
        0x47e96422,
        0xa8fc8cc4,
        0xa0f03f1a,
        0x567d2cd8,
        0x223390ef,
        0x87494ec7,
        0xd938d1c1,
        0x8ccaa2fe,
        0x98d40b36,
        0xa6f581cf,
        0xa57ade28,
        0xdab78e26,
        0x3fadbfa4,
        0x2c3a9de4,
        0x5078920d,
        0x6a5fcc9b,
        0x547e4662,
        0xf68d13c2,
        0x90d8b8e8,
        0x2e39f75e,
        0x82c3aff5,
        0x9f5d80be,
        0x69d0937c,
        0x6fd52da9,
        0xcf2512b3,
        0xc8ac993b,
        0x10187da7,
        0xe89c636e,
        0xdb3bbb7b,
        0xcd267809,
        0x6e5918f4,
        0xec9ab701,
        0x834f9aa8,
        0xe6956e65,
        0xaaffe67e,
        0x21bccf08,
        0xef15e8e6,
        0xbae79bd9,
        0x4a6f36ce,
        0xea9f09d4,
        0x29b07cd6,
        0x31a4b2af,
        0x2a3f2331,
        0xc6a59430,
        0x35a266c0,
        0x744ebc37,
        0xfc82caa6,
        0xe090d0b0,
        0x33a7d815,
        0xf104984a,
        0x41ecdaf7,
        0x7fcd500e,
        0x1791f62f,
        0x764dd68d,
        0x43efb04d,
        0xccaa4d54,
        0xe49604df,
        0x9ed1b5e3,
        0x4c6a881b,
        0xc12c1fb8,
        0x4665517f,
        0x9d5eea04,
        0x018c355d,
        0xfa877473,
        0xfb0b412e,
        0xb3671d5a,
        0x92dbd252,
        0xe9105633,
        0x6dd64713,
        0x9ad7618c,
        0x37a10c7a,
        0x59f8148e,
        0xeb133c89,
        0xcea927ee,
        0xb761c935,
        0xe11ce5ed,
        0x7a47b13c,
        0x9cd2df59,
        0x55f2733f,
        0x1814ce79,
        0x73c737bf,
        0x53f7cdea,
        0x5ffdaa5b,
        0xdf3d6f14,
        0x7844db86,
        0xcaaff381,
        0xb968c43e,
        0x3824342c,
        0xc2a3405f,
        0x161dc372,
        0xbce2250c,
        0x283c498b,
        0xff0d9541,
        0x39a80171,
        0x080cb3de,
        0xd8b4e49c,
        0x6456c190,
        0x7bcb8461,
        0xd532b670,
        0x486c5c74,
        0xd0b85742
    ];
    var T6 = [
        0x5051f4a7,
        0x537e4165,
        0xc31a17a4,
        0x963a275e,
        0xcb3bab6b,
        0xf11f9d45,
        0xabacfa58,
        0x934be303,
        0x552030fa,
        0xf6ad766d,
        0x9188cc76,
        0x25f5024c,
        0xfc4fe5d7,
        0xd7c52acb,
        0x80263544,
        0x8fb562a3,
        0x49deb15a,
        0x6725ba1b,
        0x9845ea0e,
        0xe15dfec0,
        0x02c32f75,
        0x12814cf0,
        0xa38d4697,
        0xc66bd3f9,
        0xe7038f5f,
        0x9515929c,
        0xebbf6d7a,
        0xda955259,
        0x2dd4be83,
        0xd3587421,
        0x2949e069,
        0x448ec9c8,
        0x6a75c289,
        0x78f48e79,
        0x6b99583e,
        0xdd27b971,
        0xb6bee14f,
        0x17f088ad,
        0x66c920ac,
        0xb47dce3a,
        0x1863df4a,
        0x82e51a31,
        0x60975133,
        0x4562537f,
        0xe0b16477,
        0x84bb6bae,
        0x1cfe81a0,
        0x94f9082b,
        0x58704868,
        0x198f45fd,
        0x8794de6c,
        0xb7527bf8,
        0x23ab73d3,
        0xe2724b02,
        0x57e31f8f,
        0x2a6655ab,
        0x07b2eb28,
        0x032fb5c2,
        0x9a86c57b,
        0xa5d33708,
        0xf2302887,
        0xb223bfa5,
        0xba02036a,
        0x5ced1682,
        0x2b8acf1c,
        0x92a779b4,
        0xf0f307f2,
        0xa14e69e2,
        0xcd65daf4,
        0xd50605be,
        0x1fd13462,
        0x8ac4a6fe,
        0x9d342e53,
        0xa0a2f355,
        0x32058ae1,
        0x75a4f6eb,
        0x390b83ec,
        0xaa4060ef,
        0x065e719f,
        0x51bd6e10,
        0xf93e218a,
        0x3d96dd06,
        0xaedd3e05,
        0x464de6bd,
        0xb591548d,
        0x0571c45d,
        0x6f0406d4,
        0xff605015,
        0x241998fb,
        0x97d6bde9,
        0xcc894043,
        0x7767d99e,
        0xbdb0e842,
        0x8807898b,
        0x38e7195b,
        0xdb79c8ee,
        0x47a17c0a,
        0xe97c420f,
        0xc9f8841e,
        0x00000000,
        0x83098086,
        0x48322bed,
        0xac1e1170,
        0x4e6c5a72,
        0xfbfd0eff,
        0x560f8538,
        0x1e3daed5,
        0x27362d39,
        0x640a0fd9,
        0x21685ca6,
        0xd19b5b54,
        0x3a24362e,
        0xb10c0a67,
        0x0f9357e7,
        0xd2b4ee96,
        0x9e1b9b91,
        0x4f80c0c5,
        0xa261dc20,
        0x695a774b,
        0x161c121a,
        0x0ae293ba,
        0xe5c0a02a,
        0x433c22e0,
        0x1d121b17,
        0x0b0e090d,
        0xadf28bc7,
        0xb92db6a8,
        0xc8141ea9,
        0x8557f119,
        0x4caf7507,
        0xbbee99dd,
        0xfda37f60,
        0x9ff70126,
        0xbc5c72f5,
        0xc544663b,
        0x345bfb7e,
        0x768b4329,
        0xdccb23c6,
        0x68b6edfc,
        0x63b8e4f1,
        0xcad731dc,
        0x10426385,
        0x40139722,
        0x2084c611,
        0x7d854a24,
        0xf8d2bb3d,
        0x11aef932,
        0x6dc729a1,
        0x4b1d9e2f,
        0xf3dcb230,
        0xec0d8652,
        0xd077c1e3,
        0x6c2bb316,
        0x99a970b9,
        0xfa119448,
        0x2247e964,
        0xc4a8fc8c,
        0x1aa0f03f,
        0xd8567d2c,
        0xef223390,
        0xc787494e,
        0xc1d938d1,
        0xfe8ccaa2,
        0x3698d40b,
        0xcfa6f581,
        0x28a57ade,
        0x26dab78e,
        0xa43fadbf,
        0xe42c3a9d,
        0x0d507892,
        0x9b6a5fcc,
        0x62547e46,
        0xc2f68d13,
        0xe890d8b8,
        0x5e2e39f7,
        0xf582c3af,
        0xbe9f5d80,
        0x7c69d093,
        0xa96fd52d,
        0xb3cf2512,
        0x3bc8ac99,
        0xa710187d,
        0x6ee89c63,
        0x7bdb3bbb,
        0x09cd2678,
        0xf46e5918,
        0x01ec9ab7,
        0xa8834f9a,
        0x65e6956e,
        0x7eaaffe6,
        0x0821bccf,
        0xe6ef15e8,
        0xd9bae79b,
        0xce4a6f36,
        0xd4ea9f09,
        0xd629b07c,
        0xaf31a4b2,
        0x312a3f23,
        0x30c6a594,
        0xc035a266,
        0x37744ebc,
        0xa6fc82ca,
        0xb0e090d0,
        0x1533a7d8,
        0x4af10498,
        0xf741ecda,
        0x0e7fcd50,
        0x2f1791f6,
        0x8d764dd6,
        0x4d43efb0,
        0x54ccaa4d,
        0xdfe49604,
        0xe39ed1b5,
        0x1b4c6a88,
        0xb8c12c1f,
        0x7f466551,
        0x049d5eea,
        0x5d018c35,
        0x73fa8774,
        0x2efb0b41,
        0x5ab3671d,
        0x5292dbd2,
        0x33e91056,
        0x136dd647,
        0x8c9ad761,
        0x7a37a10c,
        0x8e59f814,
        0x89eb133c,
        0xeecea927,
        0x35b761c9,
        0xede11ce5,
        0x3c7a47b1,
        0x599cd2df,
        0x3f55f273,
        0x791814ce,
        0xbf73c737,
        0xea53f7cd,
        0x5b5ffdaa,
        0x14df3d6f,
        0x867844db,
        0x81caaff3,
        0x3eb968c4,
        0x2c382434,
        0x5fc2a340,
        0x72161dc3,
        0x0cbce225,
        0x8b283c49,
        0x41ff0d95,
        0x7139a801,
        0xde080cb3,
        0x9cd8b4e4,
        0x906456c1,
        0x617bcb84,
        0x70d532b6,
        0x74486c5c,
        0x42d0b857
    ];
    var T7 = [
        0xa75051f4,
        0x65537e41,
        0xa4c31a17,
        0x5e963a27,
        0x6bcb3bab,
        0x45f11f9d,
        0x58abacfa,
        0x03934be3,
        0xfa552030,
        0x6df6ad76,
        0x769188cc,
        0x4c25f502,
        0xd7fc4fe5,
        0xcbd7c52a,
        0x44802635,
        0xa38fb562,
        0x5a49deb1,
        0x1b6725ba,
        0x0e9845ea,
        0xc0e15dfe,
        0x7502c32f,
        0xf012814c,
        0x97a38d46,
        0xf9c66bd3,
        0x5fe7038f,
        0x9c951592,
        0x7aebbf6d,
        0x59da9552,
        0x832dd4be,
        0x21d35874,
        0x692949e0,
        0xc8448ec9,
        0x896a75c2,
        0x7978f48e,
        0x3e6b9958,
        0x71dd27b9,
        0x4fb6bee1,
        0xad17f088,
        0xac66c920,
        0x3ab47dce,
        0x4a1863df,
        0x3182e51a,
        0x33609751,
        0x7f456253,
        0x77e0b164,
        0xae84bb6b,
        0xa01cfe81,
        0x2b94f908,
        0x68587048,
        0xfd198f45,
        0x6c8794de,
        0xf8b7527b,
        0xd323ab73,
        0x02e2724b,
        0x8f57e31f,
        0xab2a6655,
        0x2807b2eb,
        0xc2032fb5,
        0x7b9a86c5,
        0x08a5d337,
        0x87f23028,
        0xa5b223bf,
        0x6aba0203,
        0x825ced16,
        0x1c2b8acf,
        0xb492a779,
        0xf2f0f307,
        0xe2a14e69,
        0xf4cd65da,
        0xbed50605,
        0x621fd134,
        0xfe8ac4a6,
        0x539d342e,
        0x55a0a2f3,
        0xe132058a,
        0xeb75a4f6,
        0xec390b83,
        0xefaa4060,
        0x9f065e71,
        0x1051bd6e,
        0x8af93e21,
        0x063d96dd,
        0x05aedd3e,
        0xbd464de6,
        0x8db59154,
        0x5d0571c4,
        0xd46f0406,
        0x15ff6050,
        0xfb241998,
        0xe997d6bd,
        0x43cc8940,
        0x9e7767d9,
        0x42bdb0e8,
        0x8b880789,
        0x5b38e719,
        0xeedb79c8,
        0x0a47a17c,
        0x0fe97c42,
        0x1ec9f884,
        0x00000000,
        0x86830980,
        0xed48322b,
        0x70ac1e11,
        0x724e6c5a,
        0xfffbfd0e,
        0x38560f85,
        0xd51e3dae,
        0x3927362d,
        0xd9640a0f,
        0xa621685c,
        0x54d19b5b,
        0x2e3a2436,
        0x67b10c0a,
        0xe70f9357,
        0x96d2b4ee,
        0x919e1b9b,
        0xc54f80c0,
        0x20a261dc,
        0x4b695a77,
        0x1a161c12,
        0xba0ae293,
        0x2ae5c0a0,
        0xe0433c22,
        0x171d121b,
        0x0d0b0e09,
        0xc7adf28b,
        0xa8b92db6,
        0xa9c8141e,
        0x198557f1,
        0x074caf75,
        0xddbbee99,
        0x60fda37f,
        0x269ff701,
        0xf5bc5c72,
        0x3bc54466,
        0x7e345bfb,
        0x29768b43,
        0xc6dccb23,
        0xfc68b6ed,
        0xf163b8e4,
        0xdccad731,
        0x85104263,
        0x22401397,
        0x112084c6,
        0x247d854a,
        0x3df8d2bb,
        0x3211aef9,
        0xa16dc729,
        0x2f4b1d9e,
        0x30f3dcb2,
        0x52ec0d86,
        0xe3d077c1,
        0x166c2bb3,
        0xb999a970,
        0x48fa1194,
        0x642247e9,
        0x8cc4a8fc,
        0x3f1aa0f0,
        0x2cd8567d,
        0x90ef2233,
        0x4ec78749,
        0xd1c1d938,
        0xa2fe8cca,
        0x0b3698d4,
        0x81cfa6f5,
        0xde28a57a,
        0x8e26dab7,
        0xbfa43fad,
        0x9de42c3a,
        0x920d5078,
        0xcc9b6a5f,
        0x4662547e,
        0x13c2f68d,
        0xb8e890d8,
        0xf75e2e39,
        0xaff582c3,
        0x80be9f5d,
        0x937c69d0,
        0x2da96fd5,
        0x12b3cf25,
        0x993bc8ac,
        0x7da71018,
        0x636ee89c,
        0xbb7bdb3b,
        0x7809cd26,
        0x18f46e59,
        0xb701ec9a,
        0x9aa8834f,
        0x6e65e695,
        0xe67eaaff,
        0xcf0821bc,
        0xe8e6ef15,
        0x9bd9bae7,
        0x36ce4a6f,
        0x09d4ea9f,
        0x7cd629b0,
        0xb2af31a4,
        0x23312a3f,
        0x9430c6a5,
        0x66c035a2,
        0xbc37744e,
        0xcaa6fc82,
        0xd0b0e090,
        0xd81533a7,
        0x984af104,
        0xdaf741ec,
        0x500e7fcd,
        0xf62f1791,
        0xd68d764d,
        0xb04d43ef,
        0x4d54ccaa,
        0x04dfe496,
        0xb5e39ed1,
        0x881b4c6a,
        0x1fb8c12c,
        0x517f4665,
        0xea049d5e,
        0x355d018c,
        0x7473fa87,
        0x412efb0b,
        0x1d5ab367,
        0xd25292db,
        0x5633e910,
        0x47136dd6,
        0x618c9ad7,
        0x0c7a37a1,
        0x148e59f8,
        0x3c89eb13,
        0x27eecea9,
        0xc935b761,
        0xe5ede11c,
        0xb13c7a47,
        0xdf599cd2,
        0x733f55f2,
        0xce791814,
        0x37bf73c7,
        0xcdea53f7,
        0xaa5b5ffd,
        0x6f14df3d,
        0xdb867844,
        0xf381caaf,
        0xc43eb968,
        0x342c3824,
        0x405fc2a3,
        0xc372161d,
        0x250cbce2,
        0x498b283c,
        0x9541ff0d,
        0x017139a8,
        0xb3de080c,
        0xe49cd8b4,
        0xc1906456,
        0x84617bcb,
        0xb670d532,
        0x5c74486c,
        0x5742d0b8
    ];
    var T8 = [
        0xf4a75051,
        0x4165537e,
        0x17a4c31a,
        0x275e963a,
        0xab6bcb3b,
        0x9d45f11f,
        0xfa58abac,
        0xe303934b,
        0x30fa5520,
        0x766df6ad,
        0xcc769188,
        0x024c25f5,
        0xe5d7fc4f,
        0x2acbd7c5,
        0x35448026,
        0x62a38fb5,
        0xb15a49de,
        0xba1b6725,
        0xea0e9845,
        0xfec0e15d,
        0x2f7502c3,
        0x4cf01281,
        0x4697a38d,
        0xd3f9c66b,
        0x8f5fe703,
        0x929c9515,
        0x6d7aebbf,
        0x5259da95,
        0xbe832dd4,
        0x7421d358,
        0xe0692949,
        0xc9c8448e,
        0xc2896a75,
        0x8e7978f4,
        0x583e6b99,
        0xb971dd27,
        0xe14fb6be,
        0x88ad17f0,
        0x20ac66c9,
        0xce3ab47d,
        0xdf4a1863,
        0x1a3182e5,
        0x51336097,
        0x537f4562,
        0x6477e0b1,
        0x6bae84bb,
        0x81a01cfe,
        0x082b94f9,
        0x48685870,
        0x45fd198f,
        0xde6c8794,
        0x7bf8b752,
        0x73d323ab,
        0x4b02e272,
        0x1f8f57e3,
        0x55ab2a66,
        0xeb2807b2,
        0xb5c2032f,
        0xc57b9a86,
        0x3708a5d3,
        0x2887f230,
        0xbfa5b223,
        0x036aba02,
        0x16825ced,
        0xcf1c2b8a,
        0x79b492a7,
        0x07f2f0f3,
        0x69e2a14e,
        0xdaf4cd65,
        0x05bed506,
        0x34621fd1,
        0xa6fe8ac4,
        0x2e539d34,
        0xf355a0a2,
        0x8ae13205,
        0xf6eb75a4,
        0x83ec390b,
        0x60efaa40,
        0x719f065e,
        0x6e1051bd,
        0x218af93e,
        0xdd063d96,
        0x3e05aedd,
        0xe6bd464d,
        0x548db591,
        0xc45d0571,
        0x06d46f04,
        0x5015ff60,
        0x98fb2419,
        0xbde997d6,
        0x4043cc89,
        0xd99e7767,
        0xe842bdb0,
        0x898b8807,
        0x195b38e7,
        0xc8eedb79,
        0x7c0a47a1,
        0x420fe97c,
        0x841ec9f8,
        0x00000000,
        0x80868309,
        0x2bed4832,
        0x1170ac1e,
        0x5a724e6c,
        0x0efffbfd,
        0x8538560f,
        0xaed51e3d,
        0x2d392736,
        0x0fd9640a,
        0x5ca62168,
        0x5b54d19b,
        0x362e3a24,
        0x0a67b10c,
        0x57e70f93,
        0xee96d2b4,
        0x9b919e1b,
        0xc0c54f80,
        0xdc20a261,
        0x774b695a,
        0x121a161c,
        0x93ba0ae2,
        0xa02ae5c0,
        0x22e0433c,
        0x1b171d12,
        0x090d0b0e,
        0x8bc7adf2,
        0xb6a8b92d,
        0x1ea9c814,
        0xf1198557,
        0x75074caf,
        0x99ddbbee,
        0x7f60fda3,
        0x01269ff7,
        0x72f5bc5c,
        0x663bc544,
        0xfb7e345b,
        0x4329768b,
        0x23c6dccb,
        0xedfc68b6,
        0xe4f163b8,
        0x31dccad7,
        0x63851042,
        0x97224013,
        0xc6112084,
        0x4a247d85,
        0xbb3df8d2,
        0xf93211ae,
        0x29a16dc7,
        0x9e2f4b1d,
        0xb230f3dc,
        0x8652ec0d,
        0xc1e3d077,
        0xb3166c2b,
        0x70b999a9,
        0x9448fa11,
        0xe9642247,
        0xfc8cc4a8,
        0xf03f1aa0,
        0x7d2cd856,
        0x3390ef22,
        0x494ec787,
        0x38d1c1d9,
        0xcaa2fe8c,
        0xd40b3698,
        0xf581cfa6,
        0x7ade28a5,
        0xb78e26da,
        0xadbfa43f,
        0x3a9de42c,
        0x78920d50,
        0x5fcc9b6a,
        0x7e466254,
        0x8d13c2f6,
        0xd8b8e890,
        0x39f75e2e,
        0xc3aff582,
        0x5d80be9f,
        0xd0937c69,
        0xd52da96f,
        0x2512b3cf,
        0xac993bc8,
        0x187da710,
        0x9c636ee8,
        0x3bbb7bdb,
        0x267809cd,
        0x5918f46e,
        0x9ab701ec,
        0x4f9aa883,
        0x956e65e6,
        0xffe67eaa,
        0xbccf0821,
        0x15e8e6ef,
        0xe79bd9ba,
        0x6f36ce4a,
        0x9f09d4ea,
        0xb07cd629,
        0xa4b2af31,
        0x3f23312a,
        0xa59430c6,
        0xa266c035,
        0x4ebc3774,
        0x82caa6fc,
        0x90d0b0e0,
        0xa7d81533,
        0x04984af1,
        0xecdaf741,
        0xcd500e7f,
        0x91f62f17,
        0x4dd68d76,
        0xefb04d43,
        0xaa4d54cc,
        0x9604dfe4,
        0xd1b5e39e,
        0x6a881b4c,
        0x2c1fb8c1,
        0x65517f46,
        0x5eea049d,
        0x8c355d01,
        0x877473fa,
        0x0b412efb,
        0x671d5ab3,
        0xdbd25292,
        0x105633e9,
        0xd647136d,
        0xd7618c9a,
        0xa10c7a37,
        0xf8148e59,
        0x133c89eb,
        0xa927eece,
        0x61c935b7,
        0x1ce5ede1,
        0x47b13c7a,
        0xd2df599c,
        0xf2733f55,
        0x14ce7918,
        0xc737bf73,
        0xf7cdea53,
        0xfdaa5b5f,
        0x3d6f14df,
        0x44db8678,
        0xaff381ca,
        0x68c43eb9,
        0x24342c38,
        0xa3405fc2,
        0x1dc37216,
        0xe2250cbc,
        0x3c498b28,
        0x0d9541ff,
        0xa8017139,
        0x0cb3de08,
        0xb4e49cd8,
        0x56c19064,
        0xcb84617b,
        0x32b670d5,
        0x6c5c7448,
        0xb85742d0
    ];
    // Transformations for decryption key expansion
    var U1 = [
        0x00000000,
        0x0e090d0b,
        0x1c121a16,
        0x121b171d,
        0x3824342c,
        0x362d3927,
        0x24362e3a,
        0x2a3f2331,
        0x70486858,
        0x7e416553,
        0x6c5a724e,
        0x62537f45,
        0x486c5c74,
        0x4665517f,
        0x547e4662,
        0x5a774b69,
        0xe090d0b0,
        0xee99ddbb,
        0xfc82caa6,
        0xf28bc7ad,
        0xd8b4e49c,
        0xd6bde997,
        0xc4a6fe8a,
        0xcaaff381,
        0x90d8b8e8,
        0x9ed1b5e3,
        0x8ccaa2fe,
        0x82c3aff5,
        0xa8fc8cc4,
        0xa6f581cf,
        0xb4ee96d2,
        0xbae79bd9,
        0xdb3bbb7b,
        0xd532b670,
        0xc729a16d,
        0xc920ac66,
        0xe31f8f57,
        0xed16825c,
        0xff0d9541,
        0xf104984a,
        0xab73d323,
        0xa57ade28,
        0xb761c935,
        0xb968c43e,
        0x9357e70f,
        0x9d5eea04,
        0x8f45fd19,
        0x814cf012,
        0x3bab6bcb,
        0x35a266c0,
        0x27b971dd,
        0x29b07cd6,
        0x038f5fe7,
        0x0d8652ec,
        0x1f9d45f1,
        0x119448fa,
        0x4be30393,
        0x45ea0e98,
        0x57f11985,
        0x59f8148e,
        0x73c737bf,
        0x7dce3ab4,
        0x6fd52da9,
        0x61dc20a2,
        0xad766df6,
        0xa37f60fd,
        0xb16477e0,
        0xbf6d7aeb,
        0x955259da,
        0x9b5b54d1,
        0x894043cc,
        0x87494ec7,
        0xdd3e05ae,
        0xd33708a5,
        0xc12c1fb8,
        0xcf2512b3,
        0xe51a3182,
        0xeb133c89,
        0xf9082b94,
        0xf701269f,
        0x4de6bd46,
        0x43efb04d,
        0x51f4a750,
        0x5ffdaa5b,
        0x75c2896a,
        0x7bcb8461,
        0x69d0937c,
        0x67d99e77,
        0x3daed51e,
        0x33a7d815,
        0x21bccf08,
        0x2fb5c203,
        0x058ae132,
        0x0b83ec39,
        0x1998fb24,
        0x1791f62f,
        0x764dd68d,
        0x7844db86,
        0x6a5fcc9b,
        0x6456c190,
        0x4e69e2a1,
        0x4060efaa,
        0x527bf8b7,
        0x5c72f5bc,
        0x0605bed5,
        0x080cb3de,
        0x1a17a4c3,
        0x141ea9c8,
        0x3e218af9,
        0x302887f2,
        0x223390ef,
        0x2c3a9de4,
        0x96dd063d,
        0x98d40b36,
        0x8acf1c2b,
        0x84c61120,
        0xaef93211,
        0xa0f03f1a,
        0xb2eb2807,
        0xbce2250c,
        0xe6956e65,
        0xe89c636e,
        0xfa877473,
        0xf48e7978,
        0xdeb15a49,
        0xd0b85742,
        0xc2a3405f,
        0xccaa4d54,
        0x41ecdaf7,
        0x4fe5d7fc,
        0x5dfec0e1,
        0x53f7cdea,
        0x79c8eedb,
        0x77c1e3d0,
        0x65daf4cd,
        0x6bd3f9c6,
        0x31a4b2af,
        0x3fadbfa4,
        0x2db6a8b9,
        0x23bfa5b2,
        0x09808683,
        0x07898b88,
        0x15929c95,
        0x1b9b919e,
        0xa17c0a47,
        0xaf75074c,
        0xbd6e1051,
        0xb3671d5a,
        0x99583e6b,
        0x97513360,
        0x854a247d,
        0x8b432976,
        0xd134621f,
        0xdf3d6f14,
        0xcd267809,
        0xc32f7502,
        0xe9105633,
        0xe7195b38,
        0xf5024c25,
        0xfb0b412e,
        0x9ad7618c,
        0x94de6c87,
        0x86c57b9a,
        0x88cc7691,
        0xa2f355a0,
        0xacfa58ab,
        0xbee14fb6,
        0xb0e842bd,
        0xea9f09d4,
        0xe49604df,
        0xf68d13c2,
        0xf8841ec9,
        0xd2bb3df8,
        0xdcb230f3,
        0xcea927ee,
        0xc0a02ae5,
        0x7a47b13c,
        0x744ebc37,
        0x6655ab2a,
        0x685ca621,
        0x42638510,
        0x4c6a881b,
        0x5e719f06,
        0x5078920d,
        0x0a0fd964,
        0x0406d46f,
        0x161dc372,
        0x1814ce79,
        0x322bed48,
        0x3c22e043,
        0x2e39f75e,
        0x2030fa55,
        0xec9ab701,
        0xe293ba0a,
        0xf088ad17,
        0xfe81a01c,
        0xd4be832d,
        0xdab78e26,
        0xc8ac993b,
        0xc6a59430,
        0x9cd2df59,
        0x92dbd252,
        0x80c0c54f,
        0x8ec9c844,
        0xa4f6eb75,
        0xaaffe67e,
        0xb8e4f163,
        0xb6edfc68,
        0x0c0a67b1,
        0x02036aba,
        0x10187da7,
        0x1e1170ac,
        0x342e539d,
        0x3a275e96,
        0x283c498b,
        0x26354480,
        0x7c420fe9,
        0x724b02e2,
        0x605015ff,
        0x6e5918f4,
        0x44663bc5,
        0x4a6f36ce,
        0x587421d3,
        0x567d2cd8,
        0x37a10c7a,
        0x39a80171,
        0x2bb3166c,
        0x25ba1b67,
        0x0f853856,
        0x018c355d,
        0x13972240,
        0x1d9e2f4b,
        0x47e96422,
        0x49e06929,
        0x5bfb7e34,
        0x55f2733f,
        0x7fcd500e,
        0x71c45d05,
        0x63df4a18,
        0x6dd64713,
        0xd731dcca,
        0xd938d1c1,
        0xcb23c6dc,
        0xc52acbd7,
        0xef15e8e6,
        0xe11ce5ed,
        0xf307f2f0,
        0xfd0efffb,
        0xa779b492,
        0xa970b999,
        0xbb6bae84,
        0xb562a38f,
        0x9f5d80be,
        0x91548db5,
        0x834f9aa8,
        0x8d4697a3
    ];
    var U2 = [
        0x00000000,
        0x0b0e090d,
        0x161c121a,
        0x1d121b17,
        0x2c382434,
        0x27362d39,
        0x3a24362e,
        0x312a3f23,
        0x58704868,
        0x537e4165,
        0x4e6c5a72,
        0x4562537f,
        0x74486c5c,
        0x7f466551,
        0x62547e46,
        0x695a774b,
        0xb0e090d0,
        0xbbee99dd,
        0xa6fc82ca,
        0xadf28bc7,
        0x9cd8b4e4,
        0x97d6bde9,
        0x8ac4a6fe,
        0x81caaff3,
        0xe890d8b8,
        0xe39ed1b5,
        0xfe8ccaa2,
        0xf582c3af,
        0xc4a8fc8c,
        0xcfa6f581,
        0xd2b4ee96,
        0xd9bae79b,
        0x7bdb3bbb,
        0x70d532b6,
        0x6dc729a1,
        0x66c920ac,
        0x57e31f8f,
        0x5ced1682,
        0x41ff0d95,
        0x4af10498,
        0x23ab73d3,
        0x28a57ade,
        0x35b761c9,
        0x3eb968c4,
        0x0f9357e7,
        0x049d5eea,
        0x198f45fd,
        0x12814cf0,
        0xcb3bab6b,
        0xc035a266,
        0xdd27b971,
        0xd629b07c,
        0xe7038f5f,
        0xec0d8652,
        0xf11f9d45,
        0xfa119448,
        0x934be303,
        0x9845ea0e,
        0x8557f119,
        0x8e59f814,
        0xbf73c737,
        0xb47dce3a,
        0xa96fd52d,
        0xa261dc20,
        0xf6ad766d,
        0xfda37f60,
        0xe0b16477,
        0xebbf6d7a,
        0xda955259,
        0xd19b5b54,
        0xcc894043,
        0xc787494e,
        0xaedd3e05,
        0xa5d33708,
        0xb8c12c1f,
        0xb3cf2512,
        0x82e51a31,
        0x89eb133c,
        0x94f9082b,
        0x9ff70126,
        0x464de6bd,
        0x4d43efb0,
        0x5051f4a7,
        0x5b5ffdaa,
        0x6a75c289,
        0x617bcb84,
        0x7c69d093,
        0x7767d99e,
        0x1e3daed5,
        0x1533a7d8,
        0x0821bccf,
        0x032fb5c2,
        0x32058ae1,
        0x390b83ec,
        0x241998fb,
        0x2f1791f6,
        0x8d764dd6,
        0x867844db,
        0x9b6a5fcc,
        0x906456c1,
        0xa14e69e2,
        0xaa4060ef,
        0xb7527bf8,
        0xbc5c72f5,
        0xd50605be,
        0xde080cb3,
        0xc31a17a4,
        0xc8141ea9,
        0xf93e218a,
        0xf2302887,
        0xef223390,
        0xe42c3a9d,
        0x3d96dd06,
        0x3698d40b,
        0x2b8acf1c,
        0x2084c611,
        0x11aef932,
        0x1aa0f03f,
        0x07b2eb28,
        0x0cbce225,
        0x65e6956e,
        0x6ee89c63,
        0x73fa8774,
        0x78f48e79,
        0x49deb15a,
        0x42d0b857,
        0x5fc2a340,
        0x54ccaa4d,
        0xf741ecda,
        0xfc4fe5d7,
        0xe15dfec0,
        0xea53f7cd,
        0xdb79c8ee,
        0xd077c1e3,
        0xcd65daf4,
        0xc66bd3f9,
        0xaf31a4b2,
        0xa43fadbf,
        0xb92db6a8,
        0xb223bfa5,
        0x83098086,
        0x8807898b,
        0x9515929c,
        0x9e1b9b91,
        0x47a17c0a,
        0x4caf7507,
        0x51bd6e10,
        0x5ab3671d,
        0x6b99583e,
        0x60975133,
        0x7d854a24,
        0x768b4329,
        0x1fd13462,
        0x14df3d6f,
        0x09cd2678,
        0x02c32f75,
        0x33e91056,
        0x38e7195b,
        0x25f5024c,
        0x2efb0b41,
        0x8c9ad761,
        0x8794de6c,
        0x9a86c57b,
        0x9188cc76,
        0xa0a2f355,
        0xabacfa58,
        0xb6bee14f,
        0xbdb0e842,
        0xd4ea9f09,
        0xdfe49604,
        0xc2f68d13,
        0xc9f8841e,
        0xf8d2bb3d,
        0xf3dcb230,
        0xeecea927,
        0xe5c0a02a,
        0x3c7a47b1,
        0x37744ebc,
        0x2a6655ab,
        0x21685ca6,
        0x10426385,
        0x1b4c6a88,
        0x065e719f,
        0x0d507892,
        0x640a0fd9,
        0x6f0406d4,
        0x72161dc3,
        0x791814ce,
        0x48322bed,
        0x433c22e0,
        0x5e2e39f7,
        0x552030fa,
        0x01ec9ab7,
        0x0ae293ba,
        0x17f088ad,
        0x1cfe81a0,
        0x2dd4be83,
        0x26dab78e,
        0x3bc8ac99,
        0x30c6a594,
        0x599cd2df,
        0x5292dbd2,
        0x4f80c0c5,
        0x448ec9c8,
        0x75a4f6eb,
        0x7eaaffe6,
        0x63b8e4f1,
        0x68b6edfc,
        0xb10c0a67,
        0xba02036a,
        0xa710187d,
        0xac1e1170,
        0x9d342e53,
        0x963a275e,
        0x8b283c49,
        0x80263544,
        0xe97c420f,
        0xe2724b02,
        0xff605015,
        0xf46e5918,
        0xc544663b,
        0xce4a6f36,
        0xd3587421,
        0xd8567d2c,
        0x7a37a10c,
        0x7139a801,
        0x6c2bb316,
        0x6725ba1b,
        0x560f8538,
        0x5d018c35,
        0x40139722,
        0x4b1d9e2f,
        0x2247e964,
        0x2949e069,
        0x345bfb7e,
        0x3f55f273,
        0x0e7fcd50,
        0x0571c45d,
        0x1863df4a,
        0x136dd647,
        0xcad731dc,
        0xc1d938d1,
        0xdccb23c6,
        0xd7c52acb,
        0xe6ef15e8,
        0xede11ce5,
        0xf0f307f2,
        0xfbfd0eff,
        0x92a779b4,
        0x99a970b9,
        0x84bb6bae,
        0x8fb562a3,
        0xbe9f5d80,
        0xb591548d,
        0xa8834f9a,
        0xa38d4697
    ];
    var U3 = [
        0x00000000,
        0x0d0b0e09,
        0x1a161c12,
        0x171d121b,
        0x342c3824,
        0x3927362d,
        0x2e3a2436,
        0x23312a3f,
        0x68587048,
        0x65537e41,
        0x724e6c5a,
        0x7f456253,
        0x5c74486c,
        0x517f4665,
        0x4662547e,
        0x4b695a77,
        0xd0b0e090,
        0xddbbee99,
        0xcaa6fc82,
        0xc7adf28b,
        0xe49cd8b4,
        0xe997d6bd,
        0xfe8ac4a6,
        0xf381caaf,
        0xb8e890d8,
        0xb5e39ed1,
        0xa2fe8cca,
        0xaff582c3,
        0x8cc4a8fc,
        0x81cfa6f5,
        0x96d2b4ee,
        0x9bd9bae7,
        0xbb7bdb3b,
        0xb670d532,
        0xa16dc729,
        0xac66c920,
        0x8f57e31f,
        0x825ced16,
        0x9541ff0d,
        0x984af104,
        0xd323ab73,
        0xde28a57a,
        0xc935b761,
        0xc43eb968,
        0xe70f9357,
        0xea049d5e,
        0xfd198f45,
        0xf012814c,
        0x6bcb3bab,
        0x66c035a2,
        0x71dd27b9,
        0x7cd629b0,
        0x5fe7038f,
        0x52ec0d86,
        0x45f11f9d,
        0x48fa1194,
        0x03934be3,
        0x0e9845ea,
        0x198557f1,
        0x148e59f8,
        0x37bf73c7,
        0x3ab47dce,
        0x2da96fd5,
        0x20a261dc,
        0x6df6ad76,
        0x60fda37f,
        0x77e0b164,
        0x7aebbf6d,
        0x59da9552,
        0x54d19b5b,
        0x43cc8940,
        0x4ec78749,
        0x05aedd3e,
        0x08a5d337,
        0x1fb8c12c,
        0x12b3cf25,
        0x3182e51a,
        0x3c89eb13,
        0x2b94f908,
        0x269ff701,
        0xbd464de6,
        0xb04d43ef,
        0xa75051f4,
        0xaa5b5ffd,
        0x896a75c2,
        0x84617bcb,
        0x937c69d0,
        0x9e7767d9,
        0xd51e3dae,
        0xd81533a7,
        0xcf0821bc,
        0xc2032fb5,
        0xe132058a,
        0xec390b83,
        0xfb241998,
        0xf62f1791,
        0xd68d764d,
        0xdb867844,
        0xcc9b6a5f,
        0xc1906456,
        0xe2a14e69,
        0xefaa4060,
        0xf8b7527b,
        0xf5bc5c72,
        0xbed50605,
        0xb3de080c,
        0xa4c31a17,
        0xa9c8141e,
        0x8af93e21,
        0x87f23028,
        0x90ef2233,
        0x9de42c3a,
        0x063d96dd,
        0x0b3698d4,
        0x1c2b8acf,
        0x112084c6,
        0x3211aef9,
        0x3f1aa0f0,
        0x2807b2eb,
        0x250cbce2,
        0x6e65e695,
        0x636ee89c,
        0x7473fa87,
        0x7978f48e,
        0x5a49deb1,
        0x5742d0b8,
        0x405fc2a3,
        0x4d54ccaa,
        0xdaf741ec,
        0xd7fc4fe5,
        0xc0e15dfe,
        0xcdea53f7,
        0xeedb79c8,
        0xe3d077c1,
        0xf4cd65da,
        0xf9c66bd3,
        0xb2af31a4,
        0xbfa43fad,
        0xa8b92db6,
        0xa5b223bf,
        0x86830980,
        0x8b880789,
        0x9c951592,
        0x919e1b9b,
        0x0a47a17c,
        0x074caf75,
        0x1051bd6e,
        0x1d5ab367,
        0x3e6b9958,
        0x33609751,
        0x247d854a,
        0x29768b43,
        0x621fd134,
        0x6f14df3d,
        0x7809cd26,
        0x7502c32f,
        0x5633e910,
        0x5b38e719,
        0x4c25f502,
        0x412efb0b,
        0x618c9ad7,
        0x6c8794de,
        0x7b9a86c5,
        0x769188cc,
        0x55a0a2f3,
        0x58abacfa,
        0x4fb6bee1,
        0x42bdb0e8,
        0x09d4ea9f,
        0x04dfe496,
        0x13c2f68d,
        0x1ec9f884,
        0x3df8d2bb,
        0x30f3dcb2,
        0x27eecea9,
        0x2ae5c0a0,
        0xb13c7a47,
        0xbc37744e,
        0xab2a6655,
        0xa621685c,
        0x85104263,
        0x881b4c6a,
        0x9f065e71,
        0x920d5078,
        0xd9640a0f,
        0xd46f0406,
        0xc372161d,
        0xce791814,
        0xed48322b,
        0xe0433c22,
        0xf75e2e39,
        0xfa552030,
        0xb701ec9a,
        0xba0ae293,
        0xad17f088,
        0xa01cfe81,
        0x832dd4be,
        0x8e26dab7,
        0x993bc8ac,
        0x9430c6a5,
        0xdf599cd2,
        0xd25292db,
        0xc54f80c0,
        0xc8448ec9,
        0xeb75a4f6,
        0xe67eaaff,
        0xf163b8e4,
        0xfc68b6ed,
        0x67b10c0a,
        0x6aba0203,
        0x7da71018,
        0x70ac1e11,
        0x539d342e,
        0x5e963a27,
        0x498b283c,
        0x44802635,
        0x0fe97c42,
        0x02e2724b,
        0x15ff6050,
        0x18f46e59,
        0x3bc54466,
        0x36ce4a6f,
        0x21d35874,
        0x2cd8567d,
        0x0c7a37a1,
        0x017139a8,
        0x166c2bb3,
        0x1b6725ba,
        0x38560f85,
        0x355d018c,
        0x22401397,
        0x2f4b1d9e,
        0x642247e9,
        0x692949e0,
        0x7e345bfb,
        0x733f55f2,
        0x500e7fcd,
        0x5d0571c4,
        0x4a1863df,
        0x47136dd6,
        0xdccad731,
        0xd1c1d938,
        0xc6dccb23,
        0xcbd7c52a,
        0xe8e6ef15,
        0xe5ede11c,
        0xf2f0f307,
        0xfffbfd0e,
        0xb492a779,
        0xb999a970,
        0xae84bb6b,
        0xa38fb562,
        0x80be9f5d,
        0x8db59154,
        0x9aa8834f,
        0x97a38d46
    ];
    var U4 = [
        0x00000000,
        0x090d0b0e,
        0x121a161c,
        0x1b171d12,
        0x24342c38,
        0x2d392736,
        0x362e3a24,
        0x3f23312a,
        0x48685870,
        0x4165537e,
        0x5a724e6c,
        0x537f4562,
        0x6c5c7448,
        0x65517f46,
        0x7e466254,
        0x774b695a,
        0x90d0b0e0,
        0x99ddbbee,
        0x82caa6fc,
        0x8bc7adf2,
        0xb4e49cd8,
        0xbde997d6,
        0xa6fe8ac4,
        0xaff381ca,
        0xd8b8e890,
        0xd1b5e39e,
        0xcaa2fe8c,
        0xc3aff582,
        0xfc8cc4a8,
        0xf581cfa6,
        0xee96d2b4,
        0xe79bd9ba,
        0x3bbb7bdb,
        0x32b670d5,
        0x29a16dc7,
        0x20ac66c9,
        0x1f8f57e3,
        0x16825ced,
        0x0d9541ff,
        0x04984af1,
        0x73d323ab,
        0x7ade28a5,
        0x61c935b7,
        0x68c43eb9,
        0x57e70f93,
        0x5eea049d,
        0x45fd198f,
        0x4cf01281,
        0xab6bcb3b,
        0xa266c035,
        0xb971dd27,
        0xb07cd629,
        0x8f5fe703,
        0x8652ec0d,
        0x9d45f11f,
        0x9448fa11,
        0xe303934b,
        0xea0e9845,
        0xf1198557,
        0xf8148e59,
        0xc737bf73,
        0xce3ab47d,
        0xd52da96f,
        0xdc20a261,
        0x766df6ad,
        0x7f60fda3,
        0x6477e0b1,
        0x6d7aebbf,
        0x5259da95,
        0x5b54d19b,
        0x4043cc89,
        0x494ec787,
        0x3e05aedd,
        0x3708a5d3,
        0x2c1fb8c1,
        0x2512b3cf,
        0x1a3182e5,
        0x133c89eb,
        0x082b94f9,
        0x01269ff7,
        0xe6bd464d,
        0xefb04d43,
        0xf4a75051,
        0xfdaa5b5f,
        0xc2896a75,
        0xcb84617b,
        0xd0937c69,
        0xd99e7767,
        0xaed51e3d,
        0xa7d81533,
        0xbccf0821,
        0xb5c2032f,
        0x8ae13205,
        0x83ec390b,
        0x98fb2419,
        0x91f62f17,
        0x4dd68d76,
        0x44db8678,
        0x5fcc9b6a,
        0x56c19064,
        0x69e2a14e,
        0x60efaa40,
        0x7bf8b752,
        0x72f5bc5c,
        0x05bed506,
        0x0cb3de08,
        0x17a4c31a,
        0x1ea9c814,
        0x218af93e,
        0x2887f230,
        0x3390ef22,
        0x3a9de42c,
        0xdd063d96,
        0xd40b3698,
        0xcf1c2b8a,
        0xc6112084,
        0xf93211ae,
        0xf03f1aa0,
        0xeb2807b2,
        0xe2250cbc,
        0x956e65e6,
        0x9c636ee8,
        0x877473fa,
        0x8e7978f4,
        0xb15a49de,
        0xb85742d0,
        0xa3405fc2,
        0xaa4d54cc,
        0xecdaf741,
        0xe5d7fc4f,
        0xfec0e15d,
        0xf7cdea53,
        0xc8eedb79,
        0xc1e3d077,
        0xdaf4cd65,
        0xd3f9c66b,
        0xa4b2af31,
        0xadbfa43f,
        0xb6a8b92d,
        0xbfa5b223,
        0x80868309,
        0x898b8807,
        0x929c9515,
        0x9b919e1b,
        0x7c0a47a1,
        0x75074caf,
        0x6e1051bd,
        0x671d5ab3,
        0x583e6b99,
        0x51336097,
        0x4a247d85,
        0x4329768b,
        0x34621fd1,
        0x3d6f14df,
        0x267809cd,
        0x2f7502c3,
        0x105633e9,
        0x195b38e7,
        0x024c25f5,
        0x0b412efb,
        0xd7618c9a,
        0xde6c8794,
        0xc57b9a86,
        0xcc769188,
        0xf355a0a2,
        0xfa58abac,
        0xe14fb6be,
        0xe842bdb0,
        0x9f09d4ea,
        0x9604dfe4,
        0x8d13c2f6,
        0x841ec9f8,
        0xbb3df8d2,
        0xb230f3dc,
        0xa927eece,
        0xa02ae5c0,
        0x47b13c7a,
        0x4ebc3774,
        0x55ab2a66,
        0x5ca62168,
        0x63851042,
        0x6a881b4c,
        0x719f065e,
        0x78920d50,
        0x0fd9640a,
        0x06d46f04,
        0x1dc37216,
        0x14ce7918,
        0x2bed4832,
        0x22e0433c,
        0x39f75e2e,
        0x30fa5520,
        0x9ab701ec,
        0x93ba0ae2,
        0x88ad17f0,
        0x81a01cfe,
        0xbe832dd4,
        0xb78e26da,
        0xac993bc8,
        0xa59430c6,
        0xd2df599c,
        0xdbd25292,
        0xc0c54f80,
        0xc9c8448e,
        0xf6eb75a4,
        0xffe67eaa,
        0xe4f163b8,
        0xedfc68b6,
        0x0a67b10c,
        0x036aba02,
        0x187da710,
        0x1170ac1e,
        0x2e539d34,
        0x275e963a,
        0x3c498b28,
        0x35448026,
        0x420fe97c,
        0x4b02e272,
        0x5015ff60,
        0x5918f46e,
        0x663bc544,
        0x6f36ce4a,
        0x7421d358,
        0x7d2cd856,
        0xa10c7a37,
        0xa8017139,
        0xb3166c2b,
        0xba1b6725,
        0x8538560f,
        0x8c355d01,
        0x97224013,
        0x9e2f4b1d,
        0xe9642247,
        0xe0692949,
        0xfb7e345b,
        0xf2733f55,
        0xcd500e7f,
        0xc45d0571,
        0xdf4a1863,
        0xd647136d,
        0x31dccad7,
        0x38d1c1d9,
        0x23c6dccb,
        0x2acbd7c5,
        0x15e8e6ef,
        0x1ce5ede1,
        0x07f2f0f3,
        0x0efffbfd,
        0x79b492a7,
        0x70b999a9,
        0x6bae84bb,
        0x62a38fb5,
        0x5d80be9f,
        0x548db591,
        0x4f9aa883,
        0x4697a38d
    ];
    function convertToInt32(bytes) {
        var result = [];
        for(var i = 0; i < bytes.length; i += 4)result.push(bytes[i] << 24 | bytes[i + 1] << 16 | bytes[i + 2] << 8 | bytes[i + 3]);
        return result;
    }
    var AES = function(key) {
        if (!(this instanceof AES)) throw Error("AES must be instanitated with `new`");
        Object.defineProperty(this, "key", {
            value: coerceArray(key, true)
        });
        this._prepare();
    };
    AES.prototype._prepare = function() {
        var rounds = numberOfRounds[this.key.length];
        if (rounds == null) throw new Error("invalid key size (must be 16, 24 or 32 bytes)");
        // encryption round keys
        this._Ke = [];
        // decryption round keys
        this._Kd = [];
        for(var i = 0; i <= rounds; i++){
            this._Ke.push([
                0,
                0,
                0,
                0
            ]);
            this._Kd.push([
                0,
                0,
                0,
                0
            ]);
        }
        var roundKeyCount = (rounds + 1) * 4;
        var KC = this.key.length / 4;
        // convert the key into ints
        var tk = convertToInt32(this.key);
        // copy values into round key arrays
        var index;
        for(var i = 0; i < KC; i++){
            index = i >> 2;
            this._Ke[index][i % 4] = tk[i];
            this._Kd[rounds - index][i % 4] = tk[i];
        }
        // key expansion (fips-197 section 5.2)
        var rconpointer = 0;
        var t = KC, tt;
        while(t < roundKeyCount){
            tt = tk[KC - 1];
            tk[0] ^= S[tt >> 16 & 0xFF] << 24 ^ S[tt >> 8 & 0xFF] << 16 ^ S[tt & 0xFF] << 8 ^ S[tt >> 24 & 0xFF] ^ rcon[rconpointer] << 24;
            rconpointer += 1;
            // key expansion (for non-256 bit)
            if (KC != 8) for(var i = 1; i < KC; i++)tk[i] ^= tk[i - 1];
            else {
                for(var i = 1; i < KC / 2; i++)tk[i] ^= tk[i - 1];
                tt = tk[KC / 2 - 1];
                tk[KC / 2] ^= S[tt & 0xFF] ^ S[tt >> 8 & 0xFF] << 8 ^ S[tt >> 16 & 0xFF] << 16 ^ S[tt >> 24 & 0xFF] << 24;
                for(var i = KC / 2 + 1; i < KC; i++)tk[i] ^= tk[i - 1];
            }
            // copy values into round key arrays
            var i = 0, r, c;
            while(i < KC && t < roundKeyCount){
                r = t >> 2;
                c = t % 4;
                this._Ke[r][c] = tk[i];
                this._Kd[rounds - r][c] = tk[i++];
                t++;
            }
        }
        // inverse-cipher-ify the decryption round key (fips-197 section 5.3)
        for(var r = 1; r < rounds; r++)for(var c = 0; c < 4; c++){
            tt = this._Kd[r][c];
            this._Kd[r][c] = U1[tt >> 24 & 0xFF] ^ U2[tt >> 16 & 0xFF] ^ U3[tt >> 8 & 0xFF] ^ U4[tt & 0xFF];
        }
    };
    AES.prototype.encrypt = function(plaintext) {
        if (plaintext.length != 16) throw new Error("invalid plaintext size (must be 16 bytes)");
        var rounds = this._Ke.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(plaintext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Ke[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T1[t[i] >> 24 & 0xff] ^ T2[t[(i + 1) % 4] >> 16 & 0xff] ^ T3[t[(i + 2) % 4] >> 8 & 0xff] ^ T4[t[(i + 3) % 4] & 0xff] ^ this._Ke[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Ke[rounds][i];
            result[4 * i] = (S[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (S[t[(i + 1) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (S[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (S[t[(i + 3) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    AES.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length != 16) throw new Error("invalid ciphertext size (must be 16 bytes)");
        var rounds = this._Kd.length - 1;
        var a = [
            0,
            0,
            0,
            0
        ];
        // convert plaintext to (ints ^ key)
        var t = convertToInt32(ciphertext);
        for(var i = 0; i < 4; i++)t[i] ^= this._Kd[0][i];
        // apply round transforms
        for(var r = 1; r < rounds; r++){
            for(var i = 0; i < 4; i++)a[i] = T5[t[i] >> 24 & 0xff] ^ T6[t[(i + 3) % 4] >> 16 & 0xff] ^ T7[t[(i + 2) % 4] >> 8 & 0xff] ^ T8[t[(i + 1) % 4] & 0xff] ^ this._Kd[r][i];
            t = a.slice();
        }
        // the last round is special
        var result = createArray(16), tt;
        for(var i = 0; i < 4; i++){
            tt = this._Kd[rounds][i];
            result[4 * i] = (Si[t[i] >> 24 & 0xff] ^ tt >> 24) & 0xff;
            result[4 * i + 1] = (Si[t[(i + 3) % 4] >> 16 & 0xff] ^ tt >> 16) & 0xff;
            result[4 * i + 2] = (Si[t[(i + 2) % 4] >> 8 & 0xff] ^ tt >> 8) & 0xff;
            result[4 * i + 3] = (Si[t[(i + 1) % 4] & 0xff] ^ tt) & 0xff;
        }
        return result;
    };
    /**
     *  Mode Of Operation - Electonic Codebook (ECB)
     */ var ModeOfOperationECB = function(key) {
        if (!(this instanceof ModeOfOperationECB)) throw Error("AES must be instanitated with `new`");
        this.description = "Electronic Code Block";
        this.name = "ecb";
        this._aes = new AES(key);
    };
    ModeOfOperationECB.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            block = this._aes.encrypt(block);
            copyArray(block, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationECB.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            copyArray(block, plaintext, i);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Block Chaining (CBC)
     */ var ModeOfOperationCBC = function(key, iv) {
        if (!(this instanceof ModeOfOperationCBC)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Block Chaining";
        this.name = "cbc";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastCipherblock = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCBC.prototype.encrypt = function(plaintext) {
        plaintext = coerceArray(plaintext);
        if (plaintext.length % 16 !== 0) throw new Error("invalid plaintext size (must be multiple of 16 bytes)");
        var ciphertext = createArray(plaintext.length);
        var block = createArray(16);
        for(var i = 0; i < plaintext.length; i += 16){
            copyArray(plaintext, block, 0, i, i + 16);
            for(var j = 0; j < 16; j++)block[j] ^= this._lastCipherblock[j];
            this._lastCipherblock = this._aes.encrypt(block);
            copyArray(this._lastCipherblock, ciphertext, i);
        }
        return ciphertext;
    };
    ModeOfOperationCBC.prototype.decrypt = function(ciphertext) {
        ciphertext = coerceArray(ciphertext);
        if (ciphertext.length % 16 !== 0) throw new Error("invalid ciphertext size (must be multiple of 16 bytes)");
        var plaintext = createArray(ciphertext.length);
        var block = createArray(16);
        for(var i = 0; i < ciphertext.length; i += 16){
            copyArray(ciphertext, block, 0, i, i + 16);
            block = this._aes.decrypt(block);
            for(var j = 0; j < 16; j++)plaintext[i + j] = block[j] ^ this._lastCipherblock[j];
            copyArray(ciphertext, this._lastCipherblock, 0, i, i + 16);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Cipher Feedback (CFB)
     */ var ModeOfOperationCFB = function(key, iv, segmentSize) {
        if (!(this instanceof ModeOfOperationCFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Cipher Feedback";
        this.name = "cfb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 size)");
        if (!segmentSize) segmentSize = 1;
        this.segmentSize = segmentSize;
        this._shiftRegister = coerceArray(iv, true);
        this._aes = new AES(key);
    };
    ModeOfOperationCFB.prototype.encrypt = function(plaintext) {
        if (plaintext.length % this.segmentSize != 0) throw new Error("invalid plaintext size (must be segmentSize bytes)");
        var encrypted = coerceArray(plaintext, true);
        var xorSegment;
        for(var i = 0; i < encrypted.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)encrypted[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(encrypted, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return encrypted;
    };
    ModeOfOperationCFB.prototype.decrypt = function(ciphertext) {
        if (ciphertext.length % this.segmentSize != 0) throw new Error("invalid ciphertext size (must be segmentSize bytes)");
        var plaintext = coerceArray(ciphertext, true);
        var xorSegment;
        for(var i = 0; i < plaintext.length; i += this.segmentSize){
            xorSegment = this._aes.encrypt(this._shiftRegister);
            for(var j = 0; j < this.segmentSize; j++)plaintext[i + j] ^= xorSegment[j];
            // Shift the register
            copyArray(this._shiftRegister, this._shiftRegister, 0, this.segmentSize);
            copyArray(ciphertext, this._shiftRegister, 16 - this.segmentSize, i, i + this.segmentSize);
        }
        return plaintext;
    };
    /**
     *  Mode Of Operation - Output Feedback (OFB)
     */ var ModeOfOperationOFB = function(key, iv) {
        if (!(this instanceof ModeOfOperationOFB)) throw Error("AES must be instanitated with `new`");
        this.description = "Output Feedback";
        this.name = "ofb";
        if (!iv) iv = createArray(16);
        else if (iv.length != 16) throw new Error("invalid initialation vector size (must be 16 bytes)");
        this._lastPrecipher = coerceArray(iv, true);
        this._lastPrecipherIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationOFB.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._lastPrecipherIndex === 16) {
                this._lastPrecipher = this._aes.encrypt(this._lastPrecipher);
                this._lastPrecipherIndex = 0;
            }
            encrypted[i] ^= this._lastPrecipher[this._lastPrecipherIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationOFB.prototype.decrypt = ModeOfOperationOFB.prototype.encrypt;
    /**
     *  Counter object for CTR common mode of operation
     */ var Counter = function(initialValue) {
        if (!(this instanceof Counter)) throw Error("Counter must be instanitated with `new`");
        // We allow 0, but anything false-ish uses the default 1
        if (initialValue !== 0 && !initialValue) initialValue = 1;
        if (typeof initialValue === "number") {
            this._counter = createArray(16);
            this.setValue(initialValue);
        } else this.setBytes(initialValue);
    };
    Counter.prototype.setValue = function(value) {
        if (typeof value !== "number" || parseInt(value) != value) throw new Error("invalid counter value (must be an integer)");
        for(var index = 15; index >= 0; --index){
            this._counter[index] = value % 256;
            value = value >> 8;
        }
    };
    Counter.prototype.setBytes = function(bytes) {
        bytes = coerceArray(bytes, true);
        if (bytes.length != 16) throw new Error("invalid counter bytes size (must be 16 bytes)");
        this._counter = bytes;
    };
    Counter.prototype.increment = function() {
        for(var i = 15; i >= 0; i--)if (this._counter[i] === 255) this._counter[i] = 0;
        else {
            this._counter[i]++;
            break;
        }
    };
    /**
     *  Mode Of Operation - Counter (CTR)
     */ var ModeOfOperationCTR = function(key, counter) {
        if (!(this instanceof ModeOfOperationCTR)) throw Error("AES must be instanitated with `new`");
        this.description = "Counter";
        this.name = "ctr";
        if (!(counter instanceof Counter)) counter = new Counter(counter);
        this._counter = counter;
        this._remainingCounter = null;
        this._remainingCounterIndex = 16;
        this._aes = new AES(key);
    };
    ModeOfOperationCTR.prototype.encrypt = function(plaintext) {
        var encrypted = coerceArray(plaintext, true);
        for(var i = 0; i < encrypted.length; i++){
            if (this._remainingCounterIndex === 16) {
                this._remainingCounter = this._aes.encrypt(this._counter._counter);
                this._remainingCounterIndex = 0;
                this._counter.increment();
            }
            encrypted[i] ^= this._remainingCounter[this._remainingCounterIndex++];
        }
        return encrypted;
    };
    // Decryption is symetric
    ModeOfOperationCTR.prototype.decrypt = ModeOfOperationCTR.prototype.encrypt;
    ///////////////////////
    // Padding
    // See:https://tools.ietf.org/html/rfc2315
    function pkcs7pad(data) {
        data = coerceArray(data, true);
        var padder = 16 - data.length % 16;
        var result = createArray(data.length + padder);
        copyArray(data, result);
        for(var i = data.length; i < result.length; i++)result[i] = padder;
        return result;
    }
    function pkcs7strip(data) {
        data = coerceArray(data, true);
        if (data.length < 16) throw new Error("PKCS#7 invalid length");
        var padder = data[data.length - 1];
        if (padder > 16) throw new Error("PKCS#7 padding byte out of range");
        var length = data.length - padder;
        for(var i = 0; i < padder; i++){
            if (data[length + i] !== padder) throw new Error("PKCS#7 invalid padding byte");
        }
        var result = createArray(length);
        copyArray(data, result, 0, 0, length);
        return result;
    }
    ///////////////////////
    // Exporting
    // The block cipher
    var aesjs = {
        AES: AES,
        Counter: Counter,
        ModeOfOperation: {
            ecb: ModeOfOperationECB,
            cbc: ModeOfOperationCBC,
            cfb: ModeOfOperationCFB,
            ofb: ModeOfOperationOFB,
            ctr: ModeOfOperationCTR
        },
        utils: {
            hex: convertHex,
            utf8: convertUtf8
        },
        padding: {
            pkcs7: {
                pad: pkcs7pad,
                strip: pkcs7strip
            }
        },
        _arrayTest: {
            coerceArray: coerceArray,
            createArray: createArray,
            copyArray: copyArray
        }
    };
    module.exports = aesjs;
})(module.exports);

});

parcelRegister("bwDSW", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $86419f3d35c6552e$export$83d89fbfd8236492; });
const $86419f3d35c6552e$export$83d89fbfd8236492 = "json-wallets/5.7.0";

});

parcelRegister("fgNdo", function(module, exports) {

$parcel$export(module.exports, "looseArrayify", function () { return $b1de86b722ca4f68$export$2cde08bde0cfd932; });
$parcel$export(module.exports, "zpad", function () { return $b1de86b722ca4f68$export$67752b99d3bc61c6; });
$parcel$export(module.exports, "getPassword", function () { return $b1de86b722ca4f68$export$350bd33120f7413e; });
$parcel$export(module.exports, "searchPath", function () { return $b1de86b722ca4f68$export$5a5c1dbd910e2c32; });
$parcel$export(module.exports, "uuidV4", function () { return $b1de86b722ca4f68$export$ec7b18ebad55a3a9; });

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $b1de86b722ca4f68$export$2cde08bde0cfd932(hexString) {
    if (typeof hexString === "string" && hexString.substring(0, 2) !== "0x") hexString = "0x" + hexString;
    return (0, $ApLZa.arrayify)(hexString);
}
function $b1de86b722ca4f68$export$67752b99d3bc61c6(value, length) {
    value = String(value);
    while(value.length < length)value = "0" + value;
    return value;
}
function $b1de86b722ca4f68$export$350bd33120f7413e(password) {
    if (typeof password === "string") return (0, $aCHl8.toUtf8Bytes)(password, (0, $aCHl8.UnicodeNormalizationForm).NFKC);
    return (0, $ApLZa.arrayify)(password);
}
function $b1de86b722ca4f68$export$5a5c1dbd910e2c32(object, path) {
    let currentChild = object;
    const comps = path.toLowerCase().split("/");
    for(let i = 0; i < comps.length; i++){
        // Search for a child object with a case-insensitive matching key
        let matchingChild = null;
        for(const key in currentChild)if (key.toLowerCase() === comps[i]) {
            matchingChild = currentChild[key];
            break;
        }
        // Didn't find one. :'(
        if (matchingChild === null) return null;
        // Now check this child...
        currentChild = matchingChild;
    }
    return currentChild;
}
function $b1de86b722ca4f68$export$ec7b18ebad55a3a9(randomBytes) {
    const bytes = (0, $ApLZa.arrayify)(randomBytes);
    // Section: 4.1.3:
    // - time_hi_and_version[12:16] = 0b0100
    bytes[6] = bytes[6] & 0x0f | 0x40;
    // Section 4.4
    // - clock_seq_hi_and_reserved[6] = 0b0
    // - clock_seq_hi_and_reserved[7] = 0b1
    bytes[8] = bytes[8] & 0x3f | 0x80;
    const value = (0, $ApLZa.hexlify)(bytes);
    return [
        value.substring(2, 10),
        value.substring(10, 14),
        value.substring(14, 18),
        value.substring(18, 22),
        value.substring(22, 34)
    ].join("-");
}

});


parcelRegister("3hMhy", function(module, exports) {

$parcel$export(module.exports, "isCrowdsaleWallet", function () { return $26486974307e9818$export$724d6cf6b9fd8578; });
$parcel$export(module.exports, "isKeystoreWallet", function () { return $26486974307e9818$export$67dc926b8e68b2d8; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return $26486974307e9818$export$9a68ee9f8f3afd38; });

var $7pv2A = parcelRequire("7pv2A");
"use strict";
function $26486974307e9818$export$724d6cf6b9fd8578(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    return data.encseed && data.ethaddr;
}
function $26486974307e9818$export$67dc926b8e68b2d8(json) {
    let data = null;
    try {
        data = JSON.parse(json);
    } catch (error) {
        return false;
    }
    if (!data.version || parseInt(data.version) !== data.version || parseInt(data.version) !== 3) return false;
    // @TODO: Put more checks to make sure it has kdf, iv and all that good stuff
    return true;
}
function $26486974307e9818$export$9a68ee9f8f3afd38(json) {
    if ($26486974307e9818$export$724d6cf6b9fd8578(json)) try {
        return (0, $7pv2A.getAddress)(JSON.parse(json).ethaddr);
    } catch (error) {
        return null;
    }
    if ($26486974307e9818$export$67dc926b8e68b2d8(json)) try {
        return (0, $7pv2A.getAddress)(JSON.parse(json).address);
    } catch (error) {
        return null;
    }
    return null;
}

});

parcelRegister("gju9h", function(module, exports) {

$parcel$export(module.exports, "decryptSync", function () { return $be05ce9377ca9978$export$9bd2c37889ee5e36; });
$parcel$export(module.exports, "decrypt", function () { return $be05ce9377ca9978$export$e85a0c9a1067c5d3; });
$parcel$export(module.exports, "encrypt", function () { return $be05ce9377ca9978$export$5b0f6292f11d1d18; });

var $4iEc2 = parcelRequire("4iEc2");

var $5W1f9 = parcelRequire("5W1f9");

var $7pv2A = parcelRequire("7pv2A");

var $ApLZa = parcelRequire("ApLZa");

var $3NuV3 = parcelRequire("3NuV3");

var $8unkG = parcelRequire("8unkG");

var $75K6s = parcelRequire("75K6s");

var $UqakH = parcelRequire("UqakH");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $fgNdo = parcelRequire("fgNdo");

var $8bxC3 = parcelRequire("8bxC3");

var $bwDSW = parcelRequire("bwDSW");
"use strict";
var $be05ce9377ca9978$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $be05ce9377ca9978$var$logger = new (0, $8bxC3.Logger)((0, $bwDSW.version));
// Exported Types
function $be05ce9377ca9978$var$hasMnemonic(value) {
    return value != null && value.mnemonic && value.mnemonic.phrase;
}
class $be05ce9377ca9978$export$cf9dc4fd6dde0315 extends (0, $i6lOf.Description) {
    isKeystoreAccount(value) {
        return !!(value && value._isKeystoreAccount);
    }
}
function $be05ce9377ca9978$var$_decrypt(data, key, ciphertext) {
    const cipher = (0, $fgNdo.searchPath)(data, "crypto/cipher");
    if (cipher === "aes-128-ctr") {
        const iv = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/cipherparams/iv"));
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(key, counter);
        return (0, $ApLZa.arrayify)(aesCtr.decrypt(ciphertext));
    }
    return null;
}
function $be05ce9377ca9978$var$_getAccount(data, key) {
    const ciphertext = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/ciphertext"));
    const computedMAC = (0, $ApLZa.hexlify)((0, $8unkG.keccak256)((0, $ApLZa.concat)([
        key.slice(16, 32),
        ciphertext
    ]))).substring(2);
    if (computedMAC !== (0, $fgNdo.searchPath)(data, "crypto/mac").toLowerCase()) throw new Error("invalid password");
    const privateKey = $be05ce9377ca9978$var$_decrypt(data, key.slice(0, 16), ciphertext);
    if (!privateKey) $be05ce9377ca9978$var$logger.throwError("unsupported cipher", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        operation: "decrypt"
    });
    const mnemonicKey = key.slice(32, 64);
    const address = (0, $5LK3h.computeAddress)(privateKey);
    if (data.address) {
        let check = data.address.toLowerCase();
        if (check.substring(0, 2) !== "0x") check = "0x" + check;
        if ((0, $7pv2A.getAddress)(check) !== address) throw new Error("address mismatch");
    }
    const account = {
        _isKeystoreAccount: true,
        address: address,
        privateKey: (0, $ApLZa.hexlify)(privateKey)
    };
    // Version 0.1 x-ethers metadata must contain an encrypted mnemonic phrase
    if ((0, $fgNdo.searchPath)(data, "x-ethers/version") === "0.1") {
        const mnemonicCiphertext = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "x-ethers/mnemonicCiphertext"));
        const mnemonicIv = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "x-ethers/mnemonicCounter"));
        const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(mnemonicIv);
        const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
        const path = (0, $fgNdo.searchPath)(data, "x-ethers/path") || (0, $3NuV3.defaultPath);
        const locale = (0, $fgNdo.searchPath)(data, "x-ethers/locale") || "en";
        const entropy = (0, $ApLZa.arrayify)(mnemonicAesCtr.decrypt(mnemonicCiphertext));
        try {
            const mnemonic = (0, $3NuV3.entropyToMnemonic)(entropy, locale);
            const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic, null, locale).derivePath(path);
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
            account.mnemonic = node.mnemonic;
        } catch (error) {
            // If we don't have the locale wordlist installed to
            // read this mnemonic, just bail and don't set the
            // mnemonic
            if (error.code !== (0, $8bxC3.Logger).errors.INVALID_ARGUMENT || error.argument !== "wordlist") throw error;
        }
    }
    return new $be05ce9377ca9978$export$cf9dc4fd6dde0315(account);
}
function $be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc) {
    return (0, $ApLZa.arrayify)((0, $75K6s.pbkdf2)(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$pbkdf2(passwordBytes, salt, count, dkLen, prfFunc) {
    return Promise.resolve($be05ce9377ca9978$var$pbkdf2Sync(passwordBytes, salt, count, dkLen, prfFunc));
}
function $be05ce9377ca9978$var$_computeKdfKey(data, password, pbkdf2Func, scryptFunc, progressCallback) {
    const passwordBytes = (0, $fgNdo.getPassword)(password);
    const kdf = (0, $fgNdo.searchPath)(data, "crypto/kdf");
    if (kdf && typeof kdf === "string") {
        const throwError = function(name, value) {
            return $be05ce9377ca9978$var$logger.throwArgumentError("invalid key-derivation function parameters", name, value);
        };
        if (kdf.toLowerCase() === "scrypt") {
            const salt = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/kdfparams/salt"));
            const N = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/n"));
            const r = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/r"));
            const p = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/p"));
            // Check for all required parameters
            if (!N || !r || !p) throwError("kdf", kdf);
            // Make sure N is a power of 2
            if ((N & N - 1) !== 0) throwError("N", N);
            const dkLen = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return scryptFunc(passwordBytes, salt, N, r, p, 64, progressCallback);
        } else if (kdf.toLowerCase() === "pbkdf2") {
            const salt = (0, $fgNdo.looseArrayify)((0, $fgNdo.searchPath)(data, "crypto/kdfparams/salt"));
            let prfFunc = null;
            const prf = (0, $fgNdo.searchPath)(data, "crypto/kdfparams/prf");
            if (prf === "hmac-sha256") prfFunc = "sha256";
            else if (prf === "hmac-sha512") prfFunc = "sha512";
            else throwError("prf", prf);
            const count = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/c"));
            const dkLen = parseInt((0, $fgNdo.searchPath)(data, "crypto/kdfparams/dklen"));
            if (dkLen !== 32) throwError("dklen", dkLen);
            return pbkdf2Func(passwordBytes, salt, count, dkLen, prfFunc);
        }
    }
    return $be05ce9377ca9978$var$logger.throwArgumentError("unsupported key-derivation function", "kdf", kdf);
}
function $be05ce9377ca9978$export$9bd2c37889ee5e36(json, password) {
    const data = JSON.parse(json);
    const key = $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2Sync, (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).syncScrypt);
    return $be05ce9377ca9978$var$_getAccount(data, key);
}
function $be05ce9377ca9978$export$e85a0c9a1067c5d3(json, password, progressCallback) {
    return $be05ce9377ca9978$var$__awaiter(this, void 0, void 0, function*() {
        const data = JSON.parse(json);
        const key = yield $be05ce9377ca9978$var$_computeKdfKey(data, password, $be05ce9377ca9978$var$pbkdf2, (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).scrypt, progressCallback);
        return $be05ce9377ca9978$var$_getAccount(data, key);
    });
}
function $be05ce9377ca9978$export$5b0f6292f11d1d18(account, password, options, progressCallback) {
    try {
        // Check the address matches the private key
        if ((0, $7pv2A.getAddress)(account.address) !== (0, $5LK3h.computeAddress)(account.privateKey)) throw new Error("address/privateKey mismatch");
        // Check the mnemonic (if any) matches the private key
        if ($be05ce9377ca9978$var$hasMnemonic(account)) {
            const mnemonic = account.mnemonic;
            const node = (0, $3NuV3.HDNode).fromMnemonic(mnemonic.phrase, null, mnemonic.locale).derivePath(mnemonic.path || (0, $3NuV3.defaultPath));
            if (node.privateKey != account.privateKey) throw new Error("mnemonic mismatch");
        }
    } catch (e) {
        return Promise.reject(e);
    }
    // The options are optional, so adjust the call as needed
    if (typeof options === "function" && !progressCallback) {
        progressCallback = options;
        options = {};
    }
    if (!options) options = {};
    const privateKey = (0, $ApLZa.arrayify)(account.privateKey);
    const passwordBytes = (0, $fgNdo.getPassword)(password);
    let entropy = null;
    let path = null;
    let locale = null;
    if ($be05ce9377ca9978$var$hasMnemonic(account)) {
        const srcMnemonic = account.mnemonic;
        entropy = (0, $ApLZa.arrayify)((0, $3NuV3.mnemonicToEntropy)(srcMnemonic.phrase, srcMnemonic.locale || "en"));
        path = srcMnemonic.path || (0, $3NuV3.defaultPath);
        locale = srcMnemonic.locale || "en";
    }
    let client = options.client;
    if (!client) client = "ethers.js";
    // Check/generate the salt
    let salt = null;
    if (options.salt) salt = (0, $ApLZa.arrayify)(options.salt);
    else salt = (0, $UqakH.randomBytes)(32);
    // Override initialization vector
    let iv = null;
    if (options.iv) {
        iv = (0, $ApLZa.arrayify)(options.iv);
        if (iv.length !== 16) throw new Error("invalid iv");
    } else iv = (0, $UqakH.randomBytes)(16);
    // Override the uuid
    let uuidRandom = null;
    if (options.uuid) {
        uuidRandom = (0, $ApLZa.arrayify)(options.uuid);
        if (uuidRandom.length !== 16) throw new Error("invalid uuid");
    } else uuidRandom = (0, $UqakH.randomBytes)(16);
    // Override the scrypt password-based key derivation function parameters
    let N = 131072, r = 8, p = 1;
    if (options.scrypt) {
        if (options.scrypt.N) N = options.scrypt.N;
        if (options.scrypt.r) r = options.scrypt.r;
        if (options.scrypt.p) p = options.scrypt.p;
    }
    // We take 64 bytes:
    //   - 32 bytes   As normal for the Web3 secret storage (derivedKey, macPrefix)
    //   - 32 bytes   AES key to encrypt mnemonic with (required here to be Ethers Wallet)
    return (0, (/*@__PURE__*/$parcel$interopDefault($5W1f9))).scrypt(passwordBytes, salt, N, r, p, 64, progressCallback).then((key)=>{
        key = (0, $ApLZa.arrayify)(key);
        // This will be used to encrypt the wallet (as per Web3 secret storage)
        const derivedKey = key.slice(0, 16);
        const macPrefix = key.slice(16, 32);
        // This will be used to encrypt the mnemonic phrase (if any)
        const mnemonicKey = key.slice(32, 64);
        // Encrypt the private key
        const counter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(iv);
        const aesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(derivedKey, counter);
        const ciphertext = (0, $ApLZa.arrayify)(aesCtr.encrypt(privateKey));
        // Compute the message authentication code, used to check the password
        const mac = (0, $8unkG.keccak256)((0, $ApLZa.concat)([
            macPrefix,
            ciphertext
        ]));
        // See: https://github.com/ethereum/wiki/wiki/Web3-Secret-Storage-Definition
        const data = {
            address: account.address.substring(2).toLowerCase(),
            id: (0, $fgNdo.uuidV4)(uuidRandom),
            version: 3,
            crypto: {
                cipher: "aes-128-ctr",
                cipherparams: {
                    iv: (0, $ApLZa.hexlify)(iv).substring(2)
                },
                ciphertext: (0, $ApLZa.hexlify)(ciphertext).substring(2),
                kdf: "scrypt",
                kdfparams: {
                    salt: (0, $ApLZa.hexlify)(salt).substring(2),
                    n: N,
                    dklen: 32,
                    p: p,
                    r: r
                },
                mac: mac.substring(2)
            }
        };
        // If we have a mnemonic, encrypt it into the JSON wallet
        if (entropy) {
            const mnemonicIv = (0, $UqakH.randomBytes)(16);
            const mnemonicCounter = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).Counter(mnemonicIv);
            const mnemonicAesCtr = new (0, (/*@__PURE__*/$parcel$interopDefault($4iEc2))).ModeOfOperation.ctr(mnemonicKey, mnemonicCounter);
            const mnemonicCiphertext = (0, $ApLZa.arrayify)(mnemonicAesCtr.encrypt(entropy));
            const now = new Date();
            const timestamp = now.getUTCFullYear() + "-" + (0, $fgNdo.zpad)(now.getUTCMonth() + 1, 2) + "-" + (0, $fgNdo.zpad)(now.getUTCDate(), 2) + "T" + (0, $fgNdo.zpad)(now.getUTCHours(), 2) + "-" + (0, $fgNdo.zpad)(now.getUTCMinutes(), 2) + "-" + (0, $fgNdo.zpad)(now.getUTCSeconds(), 2) + ".0Z";
            data["x-ethers"] = {
                client: client,
                gethFilename: "UTC--" + timestamp + "--" + data.address,
                mnemonicCounter: (0, $ApLZa.hexlify)(mnemonicIv).substring(2),
                mnemonicCiphertext: (0, $ApLZa.hexlify)(mnemonicCiphertext).substring(2),
                path: path,
                locale: locale,
                version: "0.1"
            };
        }
        return JSON.stringify(data);
    });
}

});


parcelRegister("7zjmI", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $582ad2d6c5eed489$export$83d89fbfd8236492; });
const $582ad2d6c5eed489$export$83d89fbfd8236492 = "wallet/5.7.0";

});


parcelRegister("hhEgY", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return (parcelRequire("1WHFW")).AddressZero; });
$parcel$export(module.exports, "NegativeOne", function () { return (parcelRequire("dktts")).NegativeOne; });
$parcel$export(module.exports, "Zero", function () { return (parcelRequire("dktts")).Zero; });
$parcel$export(module.exports, "One", function () { return (parcelRequire("dktts")).One; });
$parcel$export(module.exports, "Two", function () { return (parcelRequire("dktts")).Two; });
$parcel$export(module.exports, "WeiPerEther", function () { return (parcelRequire("dktts")).WeiPerEther; });
$parcel$export(module.exports, "MaxUint256", function () { return (parcelRequire("dktts")).MaxUint256; });
$parcel$export(module.exports, "MinInt256", function () { return (parcelRequire("dktts")).MinInt256; });
$parcel$export(module.exports, "MaxInt256", function () { return (parcelRequire("dktts")).MaxInt256; });
$parcel$export(module.exports, "HashZero", function () { return (parcelRequire("11T4t")).HashZero; });
$parcel$export(module.exports, "EtherSymbol", function () { return (parcelRequire("4uEnT")).EtherSymbol; });

var $1WHFW = parcelRequire("1WHFW");

var $dktts = parcelRequire("dktts");

var $11T4t = parcelRequire("11T4t");

var $4uEnT = parcelRequire("4uEnT");
"use strict";

});
parcelRegister("1WHFW", function(module, exports) {

$parcel$export(module.exports, "AddressZero", function () { return $16ad1643f931e329$export$badd13187c087617; });
const $16ad1643f931e329$export$badd13187c087617 = "0x0000000000000000000000000000000000000000";

});

parcelRegister("11T4t", function(module, exports) {

$parcel$export(module.exports, "HashZero", function () { return $0c009a6d1ae8a424$export$71c2e4e213dcb7f2; });
const $0c009a6d1ae8a424$export$71c2e4e213dcb7f2 = "0x0000000000000000000000000000000000000000000000000000000000000000";

});

parcelRegister("4uEnT", function(module, exports) {

$parcel$export(module.exports, "EtherSymbol", function () { return $34594a4616895b2a$export$c7e79fcb6f8ac048; });
// NFKC (composed)             // (decomposed)
const $34594a4616895b2a$export$c7e79fcb6f8ac048 = "\u039E"; // "\uD835\uDF63";

});


parcelRegister("9cgHG", function(module, exports) {

$parcel$export(module.exports, "getDefaultProvider", function () { return $6b2231007a47a4de$export$4f77a1d3c1ac6642; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("dGRwz")).Provider; });
$parcel$export(module.exports, "BaseProvider", function () { return (parcelRequire("lts60")).BaseProvider; });
$parcel$export(module.exports, "Resolver", function () { return (parcelRequire("lts60")).Resolver; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return (parcelRequire("cLduf")).UrlJsonRpcProvider; });
$parcel$export(module.exports, "FallbackProvider", function () { return (parcelRequire("8Tv7m")).FallbackProvider; });
$parcel$export(module.exports, "AlchemyProvider", function () { return (parcelRequire("6Yx5T")).AlchemyProvider; });
$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return (parcelRequire("6Yx5T")).AlchemyWebSocketProvider; });
$parcel$export(module.exports, "AnkrProvider", function () { return (parcelRequire("3qcmX")).AnkrProvider; });
$parcel$export(module.exports, "CloudflareProvider", function () { return (parcelRequire("b7SLg")).CloudflareProvider; });
$parcel$export(module.exports, "EtherscanProvider", function () { return (parcelRequire("iXMwy")).EtherscanProvider; });
$parcel$export(module.exports, "InfuraProvider", function () { return (parcelRequire("43Sch")).InfuraProvider; });
$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return (parcelRequire("43Sch")).InfuraWebSocketProvider; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return (parcelRequire("cSErQ")).JsonRpcProvider; });
$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return (parcelRequire("1fGt2")).JsonRpcBatchProvider; });
$parcel$export(module.exports, "NodesmithProvider", function () { return (parcelRequire("7qX7n")).NodesmithProvider; });
$parcel$export(module.exports, "PocketProvider", function () { return (parcelRequire("4loi1")).PocketProvider; });
$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return (parcelRequire("cLduf")).StaticJsonRpcProvider; });
$parcel$export(module.exports, "Web3Provider", function () { return (parcelRequire("k80Oh")).Web3Provider; });
$parcel$export(module.exports, "WebSocketProvider", function () { return (parcelRequire("hZPNa")).WebSocketProvider; });
$parcel$export(module.exports, "IpcProvider", function () { return (parcelRequire("ljauL")).IpcProvider; });
$parcel$export(module.exports, "JsonRpcSigner", function () { return (parcelRequire("cSErQ")).JsonRpcSigner; });
$parcel$export(module.exports, "getNetwork", function () { return (parcelRequire("jL6zU")).getNetwork; });
$parcel$export(module.exports, "isCommunityResource", function () { return (parcelRequire("31PiM")).isCommunityResource; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return (parcelRequire("31PiM")).isCommunityResourcable; });
$parcel$export(module.exports, "showThrottleMessage", function () { return (parcelRequire("31PiM")).showThrottleMessage; });
$parcel$export(module.exports, "Formatter", function () { return (parcelRequire("31PiM")).Formatter; });

var $dGRwz = parcelRequire("dGRwz");

var $jL6zU = parcelRequire("jL6zU");

var $lts60 = parcelRequire("lts60");

var $6Yx5T = parcelRequire("6Yx5T");

var $3qcmX = parcelRequire("3qcmX");

var $b7SLg = parcelRequire("b7SLg");

var $iXMwy = parcelRequire("iXMwy");

var $8Tv7m = parcelRequire("8Tv7m");

var $ljauL = parcelRequire("ljauL");

var $43Sch = parcelRequire("43Sch");

var $cSErQ = parcelRequire("cSErQ");

var $1fGt2 = parcelRequire("1fGt2");

var $7qX7n = parcelRequire("7qX7n");

var $4loi1 = parcelRequire("4loi1");

var $cLduf = parcelRequire("cLduf");

var $k80Oh = parcelRequire("k80Oh");

var $hZPNa = parcelRequire("hZPNa");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $6b2231007a47a4de$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
////////////////////////
// Helper Functions
function $6b2231007a47a4de$export$4f77a1d3c1ac6642(network, options) {
    if (network == null) network = "homestead";
    // If passed a URL, figure out the right type of provider based on the scheme
    if (typeof network === "string") {
        // @TODO: Add support for IpcProvider; maybe if it ends in ".ipc"?
        // Handle http and ws (and their secure variants)
        const match = network.match(/^(ws|http)s?:/i);
        if (match) switch(match[1].toLowerCase()){
            case "http":
            case "https":
                return new (0, $cSErQ.JsonRpcProvider)(network);
            case "ws":
            case "wss":
                return new (0, $hZPNa.WebSocketProvider)(network);
            default:
                $6b2231007a47a4de$var$logger.throwArgumentError("unsupported URL scheme", "network", network);
        }
    }
    const n = (0, $jL6zU.getNetwork)(network);
    if (!n || !n._defaultProvider) $6b2231007a47a4de$var$logger.throwError("unsupported getDefaultProvider network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
        operation: "getDefaultProvider",
        network: network
    });
    return n._defaultProvider({
        FallbackProvider: $8Tv7m.FallbackProvider,
        AlchemyProvider: $6Yx5T.AlchemyProvider,
        AnkrProvider: $3qcmX.AnkrProvider,
        CloudflareProvider: $b7SLg.CloudflareProvider,
        EtherscanProvider: $iXMwy.EtherscanProvider,
        InfuraProvider: $43Sch.InfuraProvider,
        JsonRpcProvider: $cSErQ.JsonRpcProvider,
        NodesmithProvider: $7qX7n.NodesmithProvider,
        PocketProvider: $4loi1.PocketProvider,
        Web3Provider: $k80Oh.Web3Provider,
        IpcProvider: $ljauL.IpcProvider
    }, options);
}

});
parcelRegister("jL6zU", function(module, exports) {

$parcel$export(module.exports, "getNetwork", function () { return $e6278266fc0cd090$export$7de4970ebfd8206d; });

var $8bxC3 = parcelRequire("8bxC3");

var $dN25s = parcelRequire("dN25s");
"use strict";
const $e6278266fc0cd090$var$logger = new (0, $8bxC3.Logger)((0, $dN25s.version));
function $e6278266fc0cd090$var$isRenetworkable(value) {
    return value && typeof value.renetwork === "function";
}
function $e6278266fc0cd090$var$ethDefaultProvider(network) {
    const func = function(providers, options) {
        if (options == null) options = {};
        const providerList = [];
        if (providers.InfuraProvider && options.infura !== "-") try {
            providerList.push(new providers.InfuraProvider(network, options.infura));
        } catch (error) {}
        if (providers.EtherscanProvider && options.etherscan !== "-") try {
            providerList.push(new providers.EtherscanProvider(network, options.etherscan));
        } catch (error) {}
        if (providers.AlchemyProvider && options.alchemy !== "-") try {
            providerList.push(new providers.AlchemyProvider(network, options.alchemy));
        } catch (error) {}
        if (providers.PocketProvider && options.pocket !== "-") {
            // These networks are currently faulty on Pocket as their
            // network does not handle the Berlin hardfork, which is
            // live on these ones.
            // @TODO: This goes away once Pocket has upgraded their nodes
            const skip = [
                "goerli",
                "ropsten",
                "rinkeby",
                "sepolia"
            ];
            try {
                const provider = new providers.PocketProvider(network, options.pocket);
                if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
            } catch (error) {}
        }
        if (providers.CloudflareProvider && options.cloudflare !== "-") try {
            providerList.push(new providers.CloudflareProvider(network));
        } catch (error) {}
        if (providers.AnkrProvider && options.ankr !== "-") try {
            const skip = [
                "ropsten"
            ];
            const provider = new providers.AnkrProvider(network, options.ankr);
            if (provider.network && skip.indexOf(provider.network.name) === -1) providerList.push(provider);
        } catch (error) {}
        if (providerList.length === 0) return null;
        if (providers.FallbackProvider) {
            let quorum = 1;
            if (options.quorum != null) quorum = options.quorum;
            else if (network === "homestead") quorum = 2;
            return new providers.FallbackProvider(providerList, quorum);
        }
        return providerList[0];
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$ethDefaultProvider(network);
    };
    return func;
}
function $e6278266fc0cd090$var$etcDefaultProvider(url, network) {
    const func = function(providers, options) {
        if (providers.JsonRpcProvider) return new providers.JsonRpcProvider(url, network);
        return null;
    };
    func.renetwork = function(network) {
        return $e6278266fc0cd090$var$etcDefaultProvider(url, network);
    };
    return func;
}
const $e6278266fc0cd090$var$homestead = {
    chainId: 1,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "homestead",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("homestead")
};
const $e6278266fc0cd090$var$ropsten = {
    chainId: 3,
    ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
    name: "ropsten",
    _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("ropsten")
};
const $e6278266fc0cd090$var$classicMordor = {
    chainId: 63,
    name: "classicMordor",
    _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/mordor", "classicMordor")
};
// See: https://chainlist.org
const $e6278266fc0cd090$var$networks = {
    unspecified: {
        chainId: 0,
        name: "unspecified"
    },
    homestead: $e6278266fc0cd090$var$homestead,
    mainnet: $e6278266fc0cd090$var$homestead,
    morden: {
        chainId: 2,
        name: "morden"
    },
    ropsten: $e6278266fc0cd090$var$ropsten,
    testnet: $e6278266fc0cd090$var$ropsten,
    rinkeby: {
        chainId: 4,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "rinkeby",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("rinkeby")
    },
    kovan: {
        chainId: 42,
        name: "kovan",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("kovan")
    },
    goerli: {
        chainId: 5,
        ensAddress: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        name: "goerli",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("goerli")
    },
    kintsugi: {
        chainId: 1337702,
        name: "kintsugi"
    },
    sepolia: {
        chainId: 11155111,
        name: "sepolia",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("sepolia")
    },
    // ETC (See: #351)
    classic: {
        chainId: 61,
        name: "classic",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/etc", "classic")
    },
    classicMorden: {
        chainId: 62,
        name: "classicMorden"
    },
    classicMordor: $e6278266fc0cd090$var$classicMordor,
    classicTestnet: $e6278266fc0cd090$var$classicMordor,
    classicKotti: {
        chainId: 6,
        name: "classicKotti",
        _defaultProvider: $e6278266fc0cd090$var$etcDefaultProvider("https://www.ethercluster.com/kotti", "classicKotti")
    },
    xdai: {
        chainId: 100,
        name: "xdai"
    },
    matic: {
        chainId: 137,
        name: "matic",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("matic")
    },
    maticmum: {
        chainId: 80001,
        name: "maticmum"
    },
    optimism: {
        chainId: 10,
        name: "optimism",
        _defaultProvider: $e6278266fc0cd090$var$ethDefaultProvider("optimism")
    },
    "optimism-kovan": {
        chainId: 69,
        name: "optimism-kovan"
    },
    "optimism-goerli": {
        chainId: 420,
        name: "optimism-goerli"
    },
    arbitrum: {
        chainId: 42161,
        name: "arbitrum"
    },
    "arbitrum-rinkeby": {
        chainId: 421611,
        name: "arbitrum-rinkeby"
    },
    "arbitrum-goerli": {
        chainId: 421613,
        name: "arbitrum-goerli"
    },
    bnb: {
        chainId: 56,
        name: "bnb"
    },
    bnbt: {
        chainId: 97,
        name: "bnbt"
    }
};
function $e6278266fc0cd090$export$7de4970ebfd8206d(network) {
    // No network (null)
    if (network == null) return null;
    if (typeof network === "number") {
        for(const name in $e6278266fc0cd090$var$networks){
            const standard = $e6278266fc0cd090$var$networks[name];
            if (standard.chainId === network) return {
                name: standard.name,
                chainId: standard.chainId,
                ensAddress: standard.ensAddress || null,
                _defaultProvider: standard._defaultProvider || null
            };
        }
        return {
            chainId: network,
            name: "unknown"
        };
    }
    if (typeof network === "string") {
        const standard = $e6278266fc0cd090$var$networks[network];
        if (standard == null) return null;
        return {
            name: standard.name,
            chainId: standard.chainId,
            ensAddress: standard.ensAddress,
            _defaultProvider: standard._defaultProvider || null
        };
    }
    const standard = $e6278266fc0cd090$var$networks[network.name];
    // Not a standard network; check that it is a valid network in general
    if (!standard) {
        if (typeof network.chainId !== "number") $e6278266fc0cd090$var$logger.throwArgumentError("invalid network chainId", "network", network);
        return network;
    }
    // Make sure the chainId matches the expected network chainId (or is 0; disable EIP-155)
    if (network.chainId !== 0 && network.chainId !== standard.chainId) $e6278266fc0cd090$var$logger.throwArgumentError("network chainId mismatch", "network", network);
    // @TODO: In the next major version add an attach function to a defaultProvider
    // class and move the _defaultProvider internal to this file (extend Network)
    let defaultProvider = network._defaultProvider || null;
    if (defaultProvider == null && standard._defaultProvider) {
        if ($e6278266fc0cd090$var$isRenetworkable(standard._defaultProvider)) defaultProvider = standard._defaultProvider.renetwork(network);
        else defaultProvider = standard._defaultProvider;
    }
    // Standard Network (allow overriding the ENS address)
    return {
        name: network.name,
        chainId: standard.chainId,
        ensAddress: network.ensAddress || standard.ensAddress || null,
        _defaultProvider: defaultProvider
    };
}

});
parcelRegister("dN25s", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $a0a1786b004c6828$export$83d89fbfd8236492; });
const $a0a1786b004c6828$export$83d89fbfd8236492 = "networks/5.7.1";

});


parcelRegister("lts60", function(module, exports) {

$parcel$export(module.exports, "Resolver", function () { return $fa2219aa02c3e62e$export$8b4c839865b08288; });
$parcel$export(module.exports, "BaseProvider", function () { return $fa2219aa02c3e62e$export$ff3f6dd83125ac45; });

var $dGRwz = parcelRequire("dGRwz");

var $2bJst = parcelRequire("2bJst");

var $6PyTw = parcelRequire("6PyTw");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $11T4t = parcelRequire("11T4t");

var $1e7EA = parcelRequire("1e7EA");

var $jL6zU = parcelRequire("jL6zU");

var $i6lOf = parcelRequire("i6lOf");

var $eT6wv = parcelRequire("eT6wv");

var $aCHl8 = parcelRequire("aCHl8");

var $2GUlC = parcelRequire("2GUlC");

var $5wgCY = parcelRequire("5wgCY");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $31PiM = parcelRequire("31PiM");
"use strict";
var $fa2219aa02c3e62e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $fa2219aa02c3e62e$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS = 10;
//////////////////////////////
// Event Serializeing
function $fa2219aa02c3e62e$var$checkTopic(topic) {
    if (topic == null) return "null";
    if ((0, $ApLZa.hexDataLength)(topic) !== 32) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid topic", "topic", topic);
    return topic.toLowerCase();
}
function $fa2219aa02c3e62e$var$serializeTopics(topics) {
    // Remove trailing null AND-topics; they are redundant
    topics = topics.slice();
    while(topics.length > 0 && topics[topics.length - 1] == null)topics.pop();
    return topics.map((topic)=>{
        if (Array.isArray(topic)) {
            // Only track unique OR-topics
            const unique = {};
            topic.forEach((topic)=>{
                unique[$fa2219aa02c3e62e$var$checkTopic(topic)] = true;
            });
            // The order of OR-topics does not matter
            const sorted = Object.keys(unique);
            sorted.sort();
            return sorted.join("|");
        } else return $fa2219aa02c3e62e$var$checkTopic(topic);
    }).join("&");
}
function $fa2219aa02c3e62e$var$deserializeTopics(data) {
    if (data === "") return [];
    return data.split(/&/g).map((topic)=>{
        if (topic === "") return [];
        const comps = topic.split("|").map((topic)=>{
            return topic === "null" ? null : topic;
        });
        return comps.length === 1 ? comps[0] : comps;
    });
}
function $fa2219aa02c3e62e$var$getEventTag(eventName) {
    if (typeof eventName === "string") {
        eventName = eventName.toLowerCase();
        if ((0, $ApLZa.hexDataLength)(eventName) === 32) return "tx:" + eventName;
        if (eventName.indexOf(":") === -1) return eventName;
    } else if (Array.isArray(eventName)) return "filter:*:" + $fa2219aa02c3e62e$var$serializeTopics(eventName);
    else if ((0, $dGRwz.ForkEvent).isForkEvent(eventName)) {
        $fa2219aa02c3e62e$var$logger.warn("not implemented");
        throw new Error("not implemented");
    } else if (eventName && typeof eventName === "object") return "filter:" + (eventName.address || "*") + ":" + $fa2219aa02c3e62e$var$serializeTopics(eventName.topics || []);
    throw new Error("invalid event - " + eventName);
}
//////////////////////////////
// Helper Object
function $fa2219aa02c3e62e$var$getTime() {
    return new Date().getTime();
}
function $fa2219aa02c3e62e$var$stall(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
//////////////////////////////
// Provider Object
/**
 *  EventType
 *   - "block"
 *   - "poll"
 *   - "didPoll"
 *   - "pending"
 *   - "error"
 *   - "network"
 *   - filter
 *   - topics array
 *   - transaction hash
 */ const $fa2219aa02c3e62e$var$PollableEvents = [
    "block",
    "network",
    "pending",
    "poll"
];
class $fa2219aa02c3e62e$export$d61e24a684f9e51 {
    constructor(tag, listener, once){
        (0, $i6lOf.defineReadOnly)(this, "tag", tag);
        (0, $i6lOf.defineReadOnly)(this, "listener", listener);
        (0, $i6lOf.defineReadOnly)(this, "once", once);
        this._lastBlockNumber = -2;
        this._inflight = false;
    }
    get event() {
        switch(this.type){
            case "tx":
                return this.hash;
            case "filter":
                return this.filter;
        }
        return this.tag;
    }
    get type() {
        return this.tag.split(":")[0];
    }
    get hash() {
        const comps = this.tag.split(":");
        if (comps[0] !== "tx") return null;
        return comps[1];
    }
    get filter() {
        const comps = this.tag.split(":");
        if (comps[0] !== "filter") return null;
        const address = comps[1];
        const topics = $fa2219aa02c3e62e$var$deserializeTopics(comps[2]);
        const filter = {};
        if (topics.length > 0) filter.topics = topics;
        if (address && address !== "*") filter.address = address;
        return filter;
    }
    pollable() {
        return this.tag.indexOf(":") >= 0 || $fa2219aa02c3e62e$var$PollableEvents.indexOf(this.tag) >= 0;
    }
}
// https://github.com/satoshilabs/slips/blob/master/slip-0044.md
const $fa2219aa02c3e62e$var$coinInfos = {
    "0": {
        symbol: "btc",
        p2pkh: 0x00,
        p2sh: 0x05,
        prefix: "bc"
    },
    "2": {
        symbol: "ltc",
        p2pkh: 0x30,
        p2sh: 0x32,
        prefix: "ltc"
    },
    "3": {
        symbol: "doge",
        p2pkh: 0x1e,
        p2sh: 0x16
    },
    "60": {
        symbol: "eth",
        ilk: "eth"
    },
    "61": {
        symbol: "etc",
        ilk: "eth"
    },
    "700": {
        symbol: "xdai",
        ilk: "eth"
    }
};
function $fa2219aa02c3e62e$var$bytes32ify(value) {
    return (0, $ApLZa.hexZeroPad)((0, $esOfL.BigNumber).from(value).toHexString(), 32);
}
// Compute the Base58Check encoded data (checksum is first 4 bytes of sha256d)
function $fa2219aa02c3e62e$var$base58Encode(data) {
    return (0, $6PyTw.Base58).encode((0, $ApLZa.concat)([
        data,
        (0, $ApLZa.hexDataSlice)((0, $eT6wv.sha256)((0, $eT6wv.sha256)(data)), 0, 4)
    ]));
}
const $fa2219aa02c3e62e$var$matcherIpfs = new RegExp("^(ipfs)://(.*)$", "i");
const $fa2219aa02c3e62e$var$matchers = [
    new RegExp("^(https)://(.*)$", "i"),
    new RegExp("^(data):(.*)$", "i"),
    $fa2219aa02c3e62e$var$matcherIpfs,
    new RegExp("^eip155:[0-9]+/(erc[0-9]+):(.*)$", "i")
];
function $fa2219aa02c3e62e$var$_parseString(result, start) {
    try {
        return (0, $aCHl8.toUtf8String)($fa2219aa02c3e62e$var$_parseBytes(result, start));
    } catch (error) {}
    return null;
}
function $fa2219aa02c3e62e$var$_parseBytes(result, start) {
    if (result === "0x") return null;
    const offset = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(result, start, start + 32)).toNumber();
    const length = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(result, offset, offset + 32)).toNumber();
    return (0, $ApLZa.hexDataSlice)(result, offset + 32, offset + 32 + length);
}
// Trim off the ipfs:// prefix and return the default gateway URL
function $fa2219aa02c3e62e$var$getIpfsLink(link) {
    if (link.match(/^ipfs:\/\/ipfs\//i)) link = link.substring(12);
    else if (link.match(/^ipfs:\/\//i)) link = link.substring(7);
    else $fa2219aa02c3e62e$var$logger.throwArgumentError("unsupported IPFS format", "link", link);
    return `https:/\/gateway.ipfs.io/ipfs/${link}`;
}
function $fa2219aa02c3e62e$var$numPad(value) {
    const result = (0, $ApLZa.arrayify)(value);
    if (result.length > 32) throw new Error("internal; should not happen");
    const padded = new Uint8Array(32);
    padded.set(result, 32 - result.length);
    return padded;
}
function $fa2219aa02c3e62e$var$bytesPad(value) {
    if (value.length % 32 === 0) return value;
    const result = new Uint8Array(Math.ceil(value.length / 32) * 32);
    result.set(value);
    return result;
}
// ABI Encodes a series of (bytes, bytes, ...)
function $fa2219aa02c3e62e$var$encodeBytes(datas) {
    const result = [];
    let byteCount = 0;
    // Add place-holders for pointers as we add items
    for(let i = 0; i < datas.length; i++){
        result.push(null);
        byteCount += 32;
    }
    for(let i = 0; i < datas.length; i++){
        const data = (0, $ApLZa.arrayify)(datas[i]);
        // Update the bytes offset
        result[i] = $fa2219aa02c3e62e$var$numPad(byteCount);
        // The length and padded value of data
        result.push($fa2219aa02c3e62e$var$numPad(data.length));
        result.push($fa2219aa02c3e62e$var$bytesPad(data));
        byteCount += 32 + Math.ceil(data.length / 32) * 32;
    }
    return (0, $ApLZa.hexConcat)(result);
}
class $fa2219aa02c3e62e$export$8b4c839865b08288 {
    // The resolvedAddress is only for creating a ReverseLookup resolver
    constructor(provider, address, name, resolvedAddress){
        (0, $i6lOf.defineReadOnly)(this, "provider", provider);
        (0, $i6lOf.defineReadOnly)(this, "name", name);
        (0, $i6lOf.defineReadOnly)(this, "address", provider.formatter.address(address));
        (0, $i6lOf.defineReadOnly)(this, "_resolvedAddress", resolvedAddress);
    }
    supportsWildcard() {
        if (!this._supportsEip2544) // supportsInterface(bytes4 = selector("resolve(bytes,bytes)"))
        this._supportsEip2544 = this.provider.call({
            to: this.address,
            data: "0x01ffc9a79061b92300000000000000000000000000000000000000000000000000000000"
        }).then((result)=>{
            return (0, $esOfL.BigNumber).from(result).eq(1);
        }).catch((error)=>{
            if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return false;
            // Rethrow the error: link is down, etc. Let future attempts retry.
            this._supportsEip2544 = null;
            throw error;
        });
        return this._supportsEip2544;
    }
    _fetch(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // e.g. keccak256("addr(bytes32,uint256)")
            const tx = {
                to: this.address,
                ccipReadEnabled: true,
                data: (0, $ApLZa.hexConcat)([
                    selector,
                    (0, $1e7EA.namehash)(this.name),
                    parameters || "0x"
                ])
            };
            // Wildcard support; use EIP-2544 to resolve the request
            let parseBytes = false;
            if (yield this.supportsWildcard()) {
                parseBytes = true;
                // selector("resolve(bytes,bytes)")
                tx.data = (0, $ApLZa.hexConcat)([
                    "0x9061b923",
                    $fa2219aa02c3e62e$var$encodeBytes([
                        (0, $1e7EA.dnsEncode)(this.name),
                        tx.data
                    ])
                ]);
            }
            try {
                let result = yield this.provider.call(tx);
                if ((0, $ApLZa.arrayify)(result).length % 32 === 4) $fa2219aa02c3e62e$var$logger.throwError("resolver threw error", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    transaction: tx,
                    data: result
                });
                if (parseBytes) result = $fa2219aa02c3e62e$var$_parseBytes(result, 0);
                return result;
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
        });
    }
    _fetchBytes(selector, parameters) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const result = yield this._fetch(selector, parameters);
            if (result != null) return $fa2219aa02c3e62e$var$_parseBytes(result, 0);
            return null;
        });
    }
    _getAddress(coinType, hexBytes) {
        const coinInfo = $fa2219aa02c3e62e$var$coinInfos[String(coinType)];
        if (coinInfo == null) $fa2219aa02c3e62e$var$logger.throwError(`unsupported coin type: ${coinType}`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: `getAddress(${coinType})`
        });
        if (coinInfo.ilk === "eth") return this.provider.formatter.address(hexBytes);
        const bytes = (0, $ApLZa.arrayify)(hexBytes);
        // P2PKH: OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        if (coinInfo.p2pkh != null) {
            const p2pkh = hexBytes.match(/^0x76a9([0-9a-f][0-9a-f])([0-9a-f]*)88ac$/);
            if (p2pkh) {
                const length = parseInt(p2pkh[1], 16);
                if (p2pkh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $ApLZa.concat)([
                    [
                        coinInfo.p2pkh
                    ],
                    "0x" + p2pkh[2]
                ]));
            }
        }
        // P2SH: OP_HASH160 <scriptHash> OP_EQUAL
        if (coinInfo.p2sh != null) {
            const p2sh = hexBytes.match(/^0xa9([0-9a-f][0-9a-f])([0-9a-f]*)87$/);
            if (p2sh) {
                const length = parseInt(p2sh[1], 16);
                if (p2sh[2].length === length * 2 && length >= 1 && length <= 75) return $fa2219aa02c3e62e$var$base58Encode((0, $ApLZa.concat)([
                    [
                        coinInfo.p2sh
                    ],
                    "0x" + p2sh[2]
                ]));
            }
        }
        // Bech32
        if (coinInfo.prefix != null) {
            const length = bytes[1];
            // https://github.com/bitcoin/bips/blob/master/bip-0141.mediawiki#witness-program
            let version = bytes[0];
            if (version === 0x00) {
                if (length !== 20 && length !== 32) version = -1;
            } else version = -1;
            if (version >= 0 && bytes.length === 2 + length && length >= 1 && length <= 75) {
                const words = (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).toWords(bytes.slice(2));
                words.unshift(version);
                return (0, (/*@__PURE__*/$parcel$interopDefault($5wgCY))).encode(coinInfo.prefix, words);
            }
        }
        return null;
    }
    getAddress(coinType) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (coinType == null) coinType = 60;
            // If Ethereum, use the standard `addr(bytes32)`
            if (coinType === 60) try {
                // keccak256("addr(bytes32)")
                const result = yield this._fetch("0x3b3b57de");
                // No address
                if (result === "0x" || result === (0, $11T4t.HashZero)) return null;
                return this.provider.formatter.callAddress(result);
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.CALL_EXCEPTION) return null;
                throw error;
            }
            // keccak256("addr(bytes32,uint256")
            const hexBytes = yield this._fetchBytes("0xf1cb7e06", $fa2219aa02c3e62e$var$bytes32ify(coinType));
            // No address
            if (hexBytes == null || hexBytes === "0x") return null;
            // Compute the address
            const address = this._getAddress(coinType, hexBytes);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported coin data`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `getAddress(${coinType})`,
                coinType: coinType,
                data: hexBytes
            });
            return address;
        });
    }
    getAvatar() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const linkage = [
                {
                    type: "name",
                    content: this.name
                }
            ];
            try {
                // test data for ricmoo.eth
                //const avatar = "eip155:1/erc721:0x265385c7f4132228A0d54EB1A9e7460b91c0cC68/29233";
                const avatar = yield this.getText("avatar");
                if (avatar == null) return null;
                for(let i = 0; i < $fa2219aa02c3e62e$var$matchers.length; i++){
                    const match = avatar.match($fa2219aa02c3e62e$var$matchers[i]);
                    if (match == null) continue;
                    const scheme = match[1].toLowerCase();
                    switch(scheme){
                        case "https":
                            linkage.push({
                                type: "url",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "data":
                            linkage.push({
                                type: "data",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: avatar
                            };
                        case "ipfs":
                            linkage.push({
                                type: "ipfs",
                                content: avatar
                            });
                            return {
                                linkage: linkage,
                                url: $fa2219aa02c3e62e$var$getIpfsLink(avatar)
                            };
                        case "erc721":
                        case "erc1155":
                            {
                                // Depending on the ERC type, use tokenURI(uint256) or url(uint256)
                                const selector = scheme === "erc721" ? "0xc87b56dd" : "0x0e89341c";
                                linkage.push({
                                    type: scheme,
                                    content: avatar
                                });
                                // The owner of this name
                                const owner = this._resolvedAddress || (yield this.getAddress());
                                const comps = (match[2] || "").split("/");
                                if (comps.length !== 2) return null;
                                const addr = yield this.provider.formatter.address(comps[0]);
                                const tokenId = (0, $ApLZa.hexZeroPad)((0, $esOfL.BigNumber).from(comps[1]).toHexString(), 32);
                                // Check that this account owns the token
                                if (scheme === "erc721") {
                                    // ownerOf(uint256 tokenId)
                                    const tokenOwner = this.provider.formatter.callAddress((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ApLZa.hexConcat)([
                                            "0x6352211e",
                                            tokenId
                                        ])
                                    })));
                                    if (owner !== tokenOwner) return null;
                                    linkage.push({
                                        type: "owner",
                                        content: tokenOwner
                                    });
                                } else if (scheme === "erc1155") {
                                    // balanceOf(address owner, uint256 tokenId)
                                    const balance = (0, $esOfL.BigNumber).from((yield this.provider.call({
                                        to: addr,
                                        data: (0, $ApLZa.hexConcat)([
                                            "0x00fdd58e",
                                            (0, $ApLZa.hexZeroPad)(owner, 32),
                                            tokenId
                                        ])
                                    })));
                                    if (balance.isZero()) return null;
                                    linkage.push({
                                        type: "balance",
                                        content: balance.toString()
                                    });
                                }
                                // Call the token contract for the metadata URL
                                const tx = {
                                    to: this.provider.formatter.address(comps[0]),
                                    data: (0, $ApLZa.hexConcat)([
                                        selector,
                                        tokenId
                                    ])
                                };
                                let metadataUrl = $fa2219aa02c3e62e$var$_parseString((yield this.provider.call(tx)), 0);
                                if (metadataUrl == null) return null;
                                linkage.push({
                                    type: "metadata-url-base",
                                    content: metadataUrl
                                });
                                // ERC-1155 allows a generic {id} in the URL
                                if (scheme === "erc1155") {
                                    metadataUrl = metadataUrl.replace("{id}", tokenId.substring(2));
                                    linkage.push({
                                        type: "metadata-url-expanded",
                                        content: metadataUrl
                                    });
                                }
                                // Transform IPFS metadata links
                                if (metadataUrl.match(/^ipfs:/i)) metadataUrl = $fa2219aa02c3e62e$var$getIpfsLink(metadataUrl);
                                linkage.push({
                                    type: "metadata-url",
                                    content: metadataUrl
                                });
                                // Get the token metadata
                                const metadata = yield (0, $2GUlC.fetchJson)(metadataUrl);
                                if (!metadata) return null;
                                linkage.push({
                                    type: "metadata",
                                    content: JSON.stringify(metadata)
                                });
                                // Pull the image URL out
                                let imageUrl = metadata.image;
                                if (typeof imageUrl !== "string") return null;
                                if (imageUrl.match(/^(https:\/\/|data:)/i)) ;
                                else {
                                    // Transform IPFS link to gateway
                                    const ipfs = imageUrl.match($fa2219aa02c3e62e$var$matcherIpfs);
                                    if (ipfs == null) return null;
                                    linkage.push({
                                        type: "url-ipfs",
                                        content: imageUrl
                                    });
                                    imageUrl = $fa2219aa02c3e62e$var$getIpfsLink(imageUrl);
                                }
                                linkage.push({
                                    type: "url",
                                    content: imageUrl
                                });
                                return {
                                    linkage: linkage,
                                    url: imageUrl
                                };
                            }
                    }
                }
            } catch (error) {}
            return null;
        });
    }
    getContentHash() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // keccak256("contenthash()")
            const hexBytes = yield this._fetchBytes("0xbc1c58d1");
            // No contenthash
            if (hexBytes == null || hexBytes === "0x") return null;
            // IPFS (CID: 1, Type: DAG-PB)
            const ipfs = hexBytes.match(/^0xe3010170(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipfs) {
                const length = parseInt(ipfs[3], 16);
                if (ipfs[4].length === length * 2) return "ipfs://" + (0, $6PyTw.Base58).encode("0x" + ipfs[1]);
            }
            // IPNS (CID: 1, Type: libp2p-key)
            const ipns = hexBytes.match(/^0xe5010172(([0-9a-f][0-9a-f])([0-9a-f][0-9a-f])([0-9a-f]*))$/);
            if (ipns) {
                const length = parseInt(ipns[3], 16);
                if (ipns[4].length === length * 2) return "ipns://" + (0, $6PyTw.Base58).encode("0x" + ipns[1]);
            }
            // Swarm (CID: 1, Type: swarm-manifest; hash/length hard-coded to keccak256/32)
            const swarm = hexBytes.match(/^0xe40101fa011b20([0-9a-f]*)$/);
            if (swarm) {
                if (swarm[1].length === 64) return "bzz://" + swarm[1];
            }
            const skynet = hexBytes.match(/^0x90b2c605([0-9a-f]*)$/);
            if (skynet) {
                if (skynet[1].length === 68) {
                    // URL Safe base64; https://datatracker.ietf.org/doc/html/rfc4648#section-5
                    const urlSafe = {
                        "=": "",
                        "+": "-",
                        "/": "_"
                    };
                    const hash = (0, $2bJst.encode)("0x" + skynet[1]).replace(/[=+\/]/g, (a)=>urlSafe[a]);
                    return "sia://" + hash;
                }
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`invalid or unsupported content hash data`, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getContentHash()",
                data: hexBytes
            });
        });
    }
    getText(key) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            // The key encoded as parameter to fetchBytes
            let keyBytes = (0, $aCHl8.toUtf8Bytes)(key);
            // The nodehash consumes the first slot, so the string pointer targets
            // offset 64, with the length at offset 64 and data starting at offset 96
            keyBytes = (0, $ApLZa.concat)([
                $fa2219aa02c3e62e$var$bytes32ify(64),
                $fa2219aa02c3e62e$var$bytes32ify(keyBytes.length),
                keyBytes
            ]);
            // Pad to word-size (32 bytes)
            if (keyBytes.length % 32 !== 0) keyBytes = (0, $ApLZa.concat)([
                keyBytes,
                (0, $ApLZa.hexZeroPad)("0x", 32 - key.length % 32)
            ]);
            const hexBytes = yield this._fetchBytes("0x59d1d43c", (0, $ApLZa.hexlify)(keyBytes));
            if (hexBytes == null || hexBytes === "0x") return null;
            return (0, $aCHl8.toUtf8String)(hexBytes);
        });
    }
}
let $fa2219aa02c3e62e$var$defaultFormatter = null;
let $fa2219aa02c3e62e$var$nextPollId = 1;
class $fa2219aa02c3e62e$export$ff3f6dd83125ac45 extends (0, $dGRwz.Provider) {
    /**
     *  ready
     *
     *  A Promise<Network> that resolves only once the provider is ready.
     *
     *  Sub-classes that call the super with a network without a chainId
     *  MUST set this. Standard named networks have a known chainId.
     *
     */ constructor(network){
        super();
        // Events being listened to
        this._events = [];
        this._emitted = {
            block: -2
        };
        this.disableCcipRead = false;
        this.formatter = new.target.getFormatter();
        // If network is any, this Provider allows the underlying
        // network to change dynamically, and we auto-detect the
        // current network
        (0, $i6lOf.defineReadOnly)(this, "anyNetwork", network === "any");
        if (this.anyNetwork) network = this.detectNetwork();
        if (network instanceof Promise) {
            this._networkPromise = network;
            // Squash any "unhandled promise" errors; that do not need to be handled
            network.catch((error)=>{});
            // Trigger initial network setting (async)
            this._ready().catch((error)=>{});
        } else {
            const knownNetwork = (0, $i6lOf.getStatic)(new.target, "getNetwork")(network);
            if (knownNetwork) {
                (0, $i6lOf.defineReadOnly)(this, "_network", knownNetwork);
                this.emit("network", knownNetwork, null);
            } else $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid network", "network", network);
        }
        this._maxInternalBlockNumber = -1024;
        this._lastBlockNumber = -2;
        this._maxFilterBlockRange = 10;
        this._pollingInterval = 4000;
        this._fastQueryDate = 0;
    }
    _ready() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this._network == null) {
                let network = null;
                if (this._networkPromise) try {
                    network = yield this._networkPromise;
                } catch (error) {}
                // Try the Provider's network detection (this MUST throw if it cannot)
                if (network == null) network = yield this.detectNetwork();
                // This should never happen; every Provider sub-class should have
                // suggested a network by here (or have thrown).
                if (!network) $fa2219aa02c3e62e$var$logger.throwError("no network detected", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {});
                // Possible this call stacked so do not call defineReadOnly again
                if (this._network == null) {
                    if (this.anyNetwork) this._network = network;
                    else (0, $i6lOf.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return this._network;
        });
    }
    // This will always return the most recently established network.
    // For "any", this can change (a "network" event is emitted before
    // any change is reflected); otherwise this cannot change
    get ready() {
        return (0, $2GUlC.poll)(()=>{
            return this._ready().then((network)=>{
                return network;
            }, (error)=>{
                // If the network isn't running yet, we will wait
                if (error.code === (0, $8bxC3.Logger).errors.NETWORK_ERROR && error.event === "noNetwork") return undefined;
                throw error;
            });
        });
    }
    // @TODO: Remove this and just create a singleton formatter
    static getFormatter() {
        if ($fa2219aa02c3e62e$var$defaultFormatter == null) $fa2219aa02c3e62e$var$defaultFormatter = new (0, $31PiM.Formatter)();
        return $fa2219aa02c3e62e$var$defaultFormatter;
    }
    // @TODO: Remove this and just use getNetwork
    static getNetwork(network) {
        return (0, $jL6zU.getNetwork)(network == null ? "homestead" : network);
    }
    ccipReadFetch(tx, calldata, urls) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (this.disableCcipRead || urls.length === 0) return null;
            const sender = tx.to.toLowerCase();
            const data = calldata.toLowerCase();
            const errorMessages = [];
            for(let i = 0; i < urls.length; i++){
                const url = urls[i];
                // URL expansion
                const href = url.replace("{sender}", sender).replace("{data}", data);
                // If no {data} is present, use POST; otherwise GET
                const json = url.indexOf("{data}") >= 0 ? null : JSON.stringify({
                    data: data,
                    sender: sender
                });
                const result = yield (0, $2GUlC.fetchJson)({
                    url: href,
                    errorPassThrough: true
                }, json, (value, response)=>{
                    value.status = response.statusCode;
                    return value;
                });
                if (result.data) return result.data;
                const errorMessage = result.message || "unknown error";
                // 4xx indicates the result is not present; stop
                if (result.status >= 400 && result.status < 500) return $fa2219aa02c3e62e$var$logger.throwError(`response not found during CCIP fetch: ${errorMessage}`, (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    url: url,
                    errorMessage: errorMessage
                });
                // 5xx indicates server issue; try the next url
                errorMessages.push(errorMessage);
            }
            return $fa2219aa02c3e62e$var$logger.throwError(`error encountered during CCIP fetch: ${errorMessages.map((m)=>JSON.stringify(m)).join(", ")}`, (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                urls: urls,
                errorMessages: errorMessages
            });
        });
    }
    // Fetches the blockNumber, but will reuse any result that is less
    // than maxAge old or has been requested since the last request
    _getInternalBlockNumber(maxAge) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this._ready();
            // Allowing stale data up to maxAge old
            if (maxAge > 0) // While there are pending internal block requests...
            while(this._internalBlockNumber){
                // ..."remember" which fetch we started with
                const internalBlockNumber = this._internalBlockNumber;
                try {
                    // Check the result is not too stale
                    const result = yield internalBlockNumber;
                    if ($fa2219aa02c3e62e$var$getTime() - result.respTime <= maxAge) return result.blockNumber;
                    break;
                } catch (error) {
                    // The fetch rejected; if we are the first to get the
                    // rejection, drop through so we replace it with a new
                    // fetch; all others blocked will then get that fetch
                    // which won't match the one they "remembered" and loop
                    if (this._internalBlockNumber === internalBlockNumber) break;
                }
            }
            const reqTime = $fa2219aa02c3e62e$var$getTime();
            const checkInternalBlockNumber = (0, $i6lOf.resolveProperties)({
                blockNumber: this.perform("getBlockNumber", {}),
                networkError: this.getNetwork().then((network)=>null, (error)=>error)
            }).then(({ blockNumber: blockNumber, networkError: networkError })=>{
                if (networkError) {
                    // Unremember this bad internal block number
                    if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
                    throw networkError;
                }
                const respTime = $fa2219aa02c3e62e$var$getTime();
                blockNumber = (0, $esOfL.BigNumber).from(blockNumber).toNumber();
                if (blockNumber < this._maxInternalBlockNumber) blockNumber = this._maxInternalBlockNumber;
                this._maxInternalBlockNumber = blockNumber;
                this._setFastBlockNumber(blockNumber); // @TODO: Still need this?
                return {
                    blockNumber: blockNumber,
                    reqTime: reqTime,
                    respTime: respTime
                };
            });
            this._internalBlockNumber = checkInternalBlockNumber;
            // Swallow unhandled exceptions; if needed they are handled else where
            checkInternalBlockNumber.catch((error)=>{
                // Don't null the dead (rejected) fetch, if it has already been updated
                if (this._internalBlockNumber === checkInternalBlockNumber) this._internalBlockNumber = null;
            });
            return (yield checkInternalBlockNumber).blockNumber;
        });
    }
    poll() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const pollId = $fa2219aa02c3e62e$var$nextPollId++;
            // Track all running promises, so we can trigger a post-poll once they are complete
            const runners = [];
            let blockNumber = null;
            try {
                blockNumber = yield this._getInternalBlockNumber(100 + this.pollingInterval / 2);
            } catch (error) {
                this.emit("error", error);
                return;
            }
            this._setFastBlockNumber(blockNumber);
            // Emit a poll event after we have the latest (fast) block number
            this.emit("poll", pollId, blockNumber);
            // If the block has not changed, meh.
            if (blockNumber === this._lastBlockNumber) {
                this.emit("didPoll", pollId);
                return;
            }
            // First polling cycle, trigger a "block" events
            if (this._emitted.block === -2) this._emitted.block = blockNumber - 1;
            if (Math.abs(this._emitted.block - blockNumber) > 1000) {
                $fa2219aa02c3e62e$var$logger.warn(`network block skew detected; skipping block events (emitted=${this._emitted.block} blockNumber${blockNumber})`);
                this.emit("error", $fa2219aa02c3e62e$var$logger.makeError("network block skew detected", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                    blockNumber: blockNumber,
                    event: "blockSkew",
                    previousBlockNumber: this._emitted.block
                }));
                this.emit("block", blockNumber);
            } else // Notify all listener for each block that has passed
            for(let i = this._emitted.block + 1; i <= blockNumber; i++)this.emit("block", i);
            // The emitted block was updated, check for obsolete events
            if (this._emitted.block !== blockNumber) {
                this._emitted.block = blockNumber;
                Object.keys(this._emitted).forEach((key)=>{
                    // The block event does not expire
                    if (key === "block") return;
                    // The block we were at when we emitted this event
                    const eventBlockNumber = this._emitted[key];
                    // We cannot garbage collect pending transactions or blocks here
                    // They should be garbage collected by the Provider when setting
                    // "pending" events
                    if (eventBlockNumber === "pending") return;
                    // Evict any transaction hashes or block hashes over 12 blocks
                    // old, since they should not return null anyways
                    if (blockNumber - eventBlockNumber > 12) delete this._emitted[key];
                });
            }
            // First polling cycle
            if (this._lastBlockNumber === -2) this._lastBlockNumber = blockNumber - 1;
            // Find all transaction hashes we are waiting on
            this._events.forEach((event)=>{
                switch(event.type){
                    case "tx":
                        {
                            const hash = event.hash;
                            let runner = this.getTransactionReceipt(hash).then((receipt)=>{
                                if (!receipt || receipt.blockNumber == null) return null;
                                this._emitted["t:" + hash] = receipt.blockNumber;
                                this.emit(hash, receipt);
                                return null;
                            }).catch((error)=>{
                                this.emit("error", error);
                            });
                            runners.push(runner);
                            break;
                        }
                    case "filter":
                        // We only allow a single getLogs to be in-flight at a time
                        if (!event._inflight) {
                            event._inflight = true;
                            // This is the first filter for this event, so we want to
                            // restrict events to events that happened no earlier than now
                            if (event._lastBlockNumber === -2) event._lastBlockNumber = blockNumber - 1;
                            // Filter from the last *known* event; due to load-balancing
                            // and some nodes returning updated block numbers before
                            // indexing events, a logs result with 0 entries cannot be
                            // trusted and we must retry a range which includes it again
                            const filter = event.filter;
                            filter.fromBlock = event._lastBlockNumber + 1;
                            filter.toBlock = blockNumber;
                            // Prevent fitler ranges from growing too wild, since it is quite
                            // likely there just haven't been any events to move the lastBlockNumber.
                            const minFromBlock = filter.toBlock - this._maxFilterBlockRange;
                            if (minFromBlock > filter.fromBlock) filter.fromBlock = minFromBlock;
                            if (filter.fromBlock < 0) filter.fromBlock = 0;
                            const runner = this.getLogs(filter).then((logs)=>{
                                // Allow the next getLogs
                                event._inflight = false;
                                if (logs.length === 0) return;
                                logs.forEach((log)=>{
                                    // Only when we get an event for a given block number
                                    // can we trust the events are indexed
                                    if (log.blockNumber > event._lastBlockNumber) event._lastBlockNumber = log.blockNumber;
                                    // Make sure we stall requests to fetch blocks and txs
                                    this._emitted["b:" + log.blockHash] = log.blockNumber;
                                    this._emitted["t:" + log.transactionHash] = log.blockNumber;
                                    this.emit(filter, log);
                                });
                            }).catch((error)=>{
                                this.emit("error", error);
                                // Allow another getLogs (the range was not updated)
                                event._inflight = false;
                            });
                            runners.push(runner);
                        }
                        break;
                }
            });
            this._lastBlockNumber = blockNumber;
            // Once all events for this loop have been processed, emit "didPoll"
            Promise.all(runners).then(()=>{
                this.emit("didPoll", pollId);
            }).catch((error)=>{
                this.emit("error", error);
            });
            return;
        });
    }
    // Deprecated; do not use this
    resetEventsBlock(blockNumber) {
        this._lastBlockNumber = blockNumber - 1;
        if (this.polling) this.poll();
    }
    get network() {
        return this._network;
    }
    // This method should query the network if the underlying network
    // can change, such as when connected to a JSON-RPC backend
    detectNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return $fa2219aa02c3e62e$var$logger.throwError("provider does not support network detection", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "provider.detectNetwork"
            });
        });
    }
    getNetwork() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const network = yield this._ready();
            // Make sure we are still connected to the same network; this is
            // only an external call for backends which can have the underlying
            // network change spontaneously
            const currentNetwork = yield this.detectNetwork();
            if (network.chainId !== currentNetwork.chainId) {
                // We are allowing network changes, things can get complex fast;
                // make sure you know what you are doing if you use "any"
                if (this.anyNetwork) {
                    this._network = currentNetwork;
                    // Reset all internal block number guards and caches
                    this._lastBlockNumber = -2;
                    this._fastBlockNumber = null;
                    this._fastBlockNumberPromise = null;
                    this._fastQueryDate = 0;
                    this._emitted.block = -2;
                    this._maxInternalBlockNumber = -1024;
                    this._internalBlockNumber = null;
                    // The "network" event MUST happen before this method resolves
                    // so any events have a chance to unregister, so we stall an
                    // additional event loop before returning from /this/ call
                    this.emit("network", currentNetwork, network);
                    yield $fa2219aa02c3e62e$var$stall(0);
                    return this._network;
                }
                const error = $fa2219aa02c3e62e$var$logger.makeError("underlying network changed", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                    event: "changed",
                    network: network,
                    detectedNetwork: currentNetwork
                });
                this.emit("error", error);
                throw error;
            }
            return network;
        });
    }
    get blockNumber() {
        this._getInternalBlockNumber(100 + this.pollingInterval / 2).then((blockNumber)=>{
            this._setFastBlockNumber(blockNumber);
        }, (error)=>{});
        return this._fastBlockNumber != null ? this._fastBlockNumber : -1;
    }
    get polling() {
        return this._poller != null;
    }
    set polling(value) {
        if (value && !this._poller) {
            this._poller = setInterval(()=>{
                this.poll();
            }, this.pollingInterval);
            if (!this._bootstrapPoll) this._bootstrapPoll = setTimeout(()=>{
                this.poll();
                // We block additional polls until the polling interval
                // is done, to prevent overwhelming the poll function
                this._bootstrapPoll = setTimeout(()=>{
                    // If polling was disabled, something may require a poke
                    // since starting the bootstrap poll and it was disabled
                    if (!this._poller) this.poll();
                    // Clear out the bootstrap so we can do another
                    this._bootstrapPoll = null;
                }, this.pollingInterval);
            }, 0);
        } else if (!value && this._poller) {
            clearInterval(this._poller);
            this._poller = null;
        }
    }
    get pollingInterval() {
        return this._pollingInterval;
    }
    set pollingInterval(value) {
        if (typeof value !== "number" || value <= 0 || parseInt(String(value)) != value) throw new Error("invalid polling interval");
        this._pollingInterval = value;
        if (this._poller) {
            clearInterval(this._poller);
            this._poller = setInterval(()=>{
                this.poll();
            }, this._pollingInterval);
        }
    }
    _getFastBlockNumber() {
        const now = $fa2219aa02c3e62e$var$getTime();
        // Stale block number, request a newer value
        if (now - this._fastQueryDate > 2 * this._pollingInterval) {
            this._fastQueryDate = now;
            this._fastBlockNumberPromise = this.getBlockNumber().then((blockNumber)=>{
                if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) this._fastBlockNumber = blockNumber;
                return this._fastBlockNumber;
            });
        }
        return this._fastBlockNumberPromise;
    }
    _setFastBlockNumber(blockNumber) {
        // Older block, maybe a stale request
        if (this._fastBlockNumber != null && blockNumber < this._fastBlockNumber) return;
        // Update the time we updated the blocknumber
        this._fastQueryDate = $fa2219aa02c3e62e$var$getTime();
        // Newer block number, use  it
        if (this._fastBlockNumber == null || blockNumber > this._fastBlockNumber) {
            this._fastBlockNumber = blockNumber;
            this._fastBlockNumberPromise = Promise.resolve(blockNumber);
        }
    }
    waitForTransaction(transactionHash, confirmations, timeout) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._waitForTransaction(transactionHash, confirmations == null ? 1 : confirmations, timeout || 0, null);
        });
    }
    _waitForTransaction(transactionHash, confirmations, timeout, replaceable) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const receipt = yield this.getTransactionReceipt(transactionHash);
            // Receipt is already good
            if ((receipt ? receipt.confirmations : 0) >= confirmations) return receipt;
            // Poll until the receipt is good...
            return new Promise((resolve, reject)=>{
                const cancelFuncs = [];
                let done = false;
                const alreadyDone = function() {
                    if (done) return true;
                    done = true;
                    cancelFuncs.forEach((func)=>{
                        func();
                    });
                    return false;
                };
                const minedHandler = (receipt)=>{
                    if (receipt.confirmations < confirmations) return;
                    if (alreadyDone()) return;
                    resolve(receipt);
                };
                this.on(transactionHash, minedHandler);
                cancelFuncs.push(()=>{
                    this.removeListener(transactionHash, minedHandler);
                });
                if (replaceable) {
                    let lastBlockNumber = replaceable.startBlock;
                    let scannedBlock = null;
                    const replaceHandler = (blockNumber)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                            if (done) return;
                            // Wait 1 second; this is only used in the case of a fault, so
                            // we will trade off a little bit of latency for more consistent
                            // results and fewer JSON-RPC calls
                            yield $fa2219aa02c3e62e$var$stall(1000);
                            this.getTransactionCount(replaceable.from).then((nonce)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                                    if (done) return;
                                    if (nonce <= replaceable.nonce) lastBlockNumber = blockNumber;
                                    else {
                                        // First check if the transaction was mined
                                        {
                                            const mined = yield this.getTransaction(transactionHash);
                                            if (mined && mined.blockNumber != null) return;
                                        }
                                        // First time scanning. We start a little earlier for some
                                        // wiggle room here to handle the eventually consistent nature
                                        // of blockchain (e.g. the getTransactionCount was for a
                                        // different block)
                                        if (scannedBlock == null) {
                                            scannedBlock = lastBlockNumber - 3;
                                            if (scannedBlock < replaceable.startBlock) scannedBlock = replaceable.startBlock;
                                        }
                                        while(scannedBlock <= blockNumber){
                                            if (done) return;
                                            const block = yield this.getBlockWithTransactions(scannedBlock);
                                            for(let ti = 0; ti < block.transactions.length; ti++){
                                                const tx = block.transactions[ti];
                                                // Successfully mined!
                                                if (tx.hash === transactionHash) return;
                                                // Matches our transaction from and nonce; its a replacement
                                                if (tx.from === replaceable.from && tx.nonce === replaceable.nonce) {
                                                    if (done) return;
                                                    // Get the receipt of the replacement
                                                    const receipt = yield this.waitForTransaction(tx.hash, confirmations);
                                                    // Already resolved or rejected (prolly a timeout)
                                                    if (alreadyDone()) return;
                                                    // The reason we were replaced
                                                    let reason = "replaced";
                                                    if (tx.data === replaceable.data && tx.to === replaceable.to && tx.value.eq(replaceable.value)) reason = "repriced";
                                                    else if (tx.data === "0x" && tx.from === tx.to && tx.value.isZero()) reason = "cancelled";
                                                    // Explain why we were replaced
                                                    reject($fa2219aa02c3e62e$var$logger.makeError("transaction was replaced", (0, $8bxC3.Logger).errors.TRANSACTION_REPLACED, {
                                                        cancelled: reason === "replaced" || reason === "cancelled",
                                                        reason: reason,
                                                        replacement: this._wrapTransaction(tx),
                                                        hash: transactionHash,
                                                        receipt: receipt
                                                    }));
                                                    return;
                                                }
                                            }
                                            scannedBlock++;
                                        }
                                    }
                                    if (done) return;
                                    this.once("block", replaceHandler);
                                }), (error)=>{
                                if (done) return;
                                this.once("block", replaceHandler);
                            });
                        });
                    if (done) return;
                    this.once("block", replaceHandler);
                    cancelFuncs.push(()=>{
                        this.removeListener("block", replaceHandler);
                    });
                }
                if (typeof timeout === "number" && timeout > 0) {
                    const timer = setTimeout(()=>{
                        if (alreadyDone()) return;
                        reject($fa2219aa02c3e62e$var$logger.makeError("timeout exceeded", (0, $8bxC3.Logger).errors.TIMEOUT, {
                            timeout: timeout
                        }));
                    }, timeout);
                    if (timer.unref) timer.unref();
                    cancelFuncs.push(()=>{
                        clearTimeout(timer);
                    });
                }
            });
        });
    }
    getBlockNumber() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            return this._getInternalBlockNumber(0);
        });
    }
    getGasPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const result = yield this.perform("getGasPrice", {});
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getGasPrice",
                    result: result,
                    error: error
                });
            }
        });
    }
    getBalance(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getBalance", params);
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getBalance",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getTransactionCount(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getTransactionCount", params);
            try {
                return (0, $esOfL.BigNumber).from(result).toNumber();
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getTransactionCount",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getCode(addressOrName, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag)
            });
            const result = yield this.perform("getCode", params);
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getCode",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    getStorageAt(addressOrName, position, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                address: this._getAddress(addressOrName),
                blockTag: this._getBlockTag(blockTag),
                position: Promise.resolve(position).then((p)=>(0, $ApLZa.hexValue)(p))
            });
            const result = yield this.perform("getStorageAt", params);
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "getStorageAt",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    // This should be called by any subclass wrapping a TransactionResponse
    _wrapTransaction(tx, hash, startBlock) {
        if (hash != null && (0, $ApLZa.hexDataLength)(hash) !== 32) throw new Error("invalid response - sendTransaction");
        const result = tx;
        // Check the hash we expect is the same as the hash the server reported
        if (hash != null && tx.hash !== hash) $fa2219aa02c3e62e$var$logger.throwError("Transaction hash mismatch from Provider.sendTransaction.", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {
            expectedHash: tx.hash,
            returnedHash: hash
        });
        result.wait = (confirms, timeout)=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                if (confirms == null) confirms = 1;
                if (timeout == null) timeout = 0;
                // Get the details to detect replacement
                let replacement = undefined;
                if (confirms !== 0 && startBlock != null) replacement = {
                    data: tx.data,
                    from: tx.from,
                    nonce: tx.nonce,
                    to: tx.to,
                    value: tx.value,
                    startBlock: startBlock
                };
                const receipt = yield this._waitForTransaction(tx.hash, confirms, timeout, replacement);
                if (receipt == null && confirms === 0) return null;
                // No longer pending, allow the polling loop to garbage collect this
                this._emitted["t:" + tx.hash] = receipt.blockNumber;
                if (receipt.status === 0) $fa2219aa02c3e62e$var$logger.throwError("transaction failed", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    transactionHash: tx.hash,
                    transaction: tx,
                    receipt: receipt
                });
                return receipt;
            });
        return result;
    }
    sendTransaction(signedTransaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const hexTx = yield Promise.resolve(signedTransaction).then((t)=>(0, $ApLZa.hexlify)(t));
            const tx = this.formatter.transaction(signedTransaction);
            if (tx.confirmations == null) tx.confirmations = 0;
            const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
            try {
                const hash = yield this.perform("sendTransaction", {
                    signedTransaction: hexTx
                });
                return this._wrapTransaction(tx, hash, blockNumber);
            } catch (error) {
                error.transaction = tx;
                error.transactionHash = tx.hash;
                throw error;
            }
        });
    }
    _getTransactionRequest(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            const values = yield transaction;
            const tx = {};
            [
                "from",
                "to"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? this._getAddress(v) : null);
            });
            [
                "gasLimit",
                "gasPrice",
                "maxFeePerGas",
                "maxPriorityFeePerGas",
                "value"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $esOfL.BigNumber).from(v) : null);
            });
            [
                "type"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v != null ? v : null);
            });
            if (values.accessList) tx.accessList = this.formatter.accessList(values.accessList);
            [
                "data"
            ].forEach((key)=>{
                if (values[key] == null) return;
                tx[key] = Promise.resolve(values[key]).then((v)=>v ? (0, $ApLZa.hexlify)(v) : null);
            });
            return this.formatter.transactionRequest((yield (0, $i6lOf.resolveProperties)(tx)));
        });
    }
    _getFilter(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            filter = yield filter;
            const result = {};
            if (filter.address != null) result.address = this._getAddress(filter.address);
            [
                "blockHash",
                "topics"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = filter[key];
            });
            [
                "fromBlock",
                "toBlock"
            ].forEach((key)=>{
                if (filter[key] == null) return;
                result[key] = this._getBlockTag(filter[key]);
            });
            return this.formatter.filter((yield (0, $i6lOf.resolveProperties)(result)));
        });
    }
    _call(transaction, blockTag, attempt) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (attempt >= $fa2219aa02c3e62e$var$MAX_CCIP_REDIRECTS) $fa2219aa02c3e62e$var$logger.throwError("CCIP read exceeded maximum redirections", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                redirects: attempt,
                transaction: transaction
            });
            const txSender = transaction.to;
            const result = yield this.perform("call", {
                transaction: transaction,
                blockTag: blockTag
            });
            // CCIP Read request via OffchainLookup(address,string[],bytes,bytes4,bytes)
            if (attempt >= 0 && blockTag === "latest" && txSender != null && result.substring(0, 10) === "0x556f1830" && (0, $ApLZa.hexDataLength)(result) % 32 === 4) try {
                const data = (0, $ApLZa.hexDataSlice)(result, 4);
                // Check the sender of the OffchainLookup matches the transaction
                const sender = (0, $ApLZa.hexDataSlice)(data, 0, 32);
                if (!(0, $esOfL.BigNumber).from(sender).eq(txSender)) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read sender did not match", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                // Read the URLs from the response
                const urls = [];
                const urlsOffset = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, 32, 64)).toNumber();
                const urlsLength = (0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, urlsOffset, urlsOffset + 32)).toNumber();
                const urlsData = (0, $ApLZa.hexDataSlice)(data, urlsOffset + 32);
                for(let u = 0; u < urlsLength; u++){
                    const url = $fa2219aa02c3e62e$var$_parseString(urlsData, u * 32);
                    if (url == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read contained corrupt URL string", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                        name: "OffchainLookup",
                        signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                        transaction: transaction,
                        data: result
                    });
                    urls.push(url);
                }
                // Get the CCIP calldata to forward
                const calldata = $fa2219aa02c3e62e$var$_parseBytes(data, 64);
                // Get the callbackSelector (bytes4)
                if (!(0, $esOfL.BigNumber).from((0, $ApLZa.hexDataSlice)(data, 100, 128)).isZero()) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read callback selector included junk", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const callbackSelector = (0, $ApLZa.hexDataSlice)(data, 96, 100);
                // Get the extra data to send back to the contract as context
                const extraData = $fa2219aa02c3e62e$var$_parseBytes(data, 128);
                const ccipResult = yield this.ccipReadFetch(transaction, calldata, urls);
                if (ccipResult == null) $fa2219aa02c3e62e$var$logger.throwError("CCIP Read disabled or provided no URLs", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                    name: "OffchainLookup",
                    signature: "OffchainLookup(address,string[],bytes,bytes4,bytes)",
                    transaction: transaction,
                    data: result
                });
                const tx = {
                    to: txSender,
                    data: (0, $ApLZa.hexConcat)([
                        callbackSelector,
                        $fa2219aa02c3e62e$var$encodeBytes([
                            ccipResult,
                            extraData
                        ])
                    ])
                };
                return this._call(tx, blockTag, attempt + 1);
            } catch (error) {
                if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) throw error;
            }
            try {
                return (0, $ApLZa.hexlify)(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "call",
                    params: {
                        transaction: transaction,
                        blockTag: blockTag
                    },
                    result: result,
                    error: error
                });
            }
        });
    }
    call(transaction, blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const resolved = yield (0, $i6lOf.resolveProperties)({
                transaction: this._getTransactionRequest(transaction),
                blockTag: this._getBlockTag(blockTag),
                ccipReadEnabled: Promise.resolve(transaction.ccipReadEnabled)
            });
            return this._call(resolved.transaction, resolved.blockTag, resolved.ccipReadEnabled ? 0 : -1);
        });
    }
    estimateGas(transaction) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                transaction: this._getTransactionRequest(transaction)
            });
            const result = yield this.perform("estimateGas", params);
            try {
                return (0, $esOfL.BigNumber).from(result);
            } catch (error) {
                return $fa2219aa02c3e62e$var$logger.throwError("bad result from backend", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                    method: "estimateGas",
                    params: params,
                    result: result,
                    error: error
                });
            }
        });
    }
    _getAddress(addressOrName) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            addressOrName = yield addressOrName;
            if (typeof addressOrName !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid address or ENS name", "name", addressOrName);
            const address = yield this.resolveName(addressOrName);
            if (address == null) $fa2219aa02c3e62e$var$logger.throwError("ENS name not configured", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: `resolveName(${JSON.stringify(addressOrName)})`
            });
            return address;
        });
    }
    _getBlock(blockHashOrBlockTag, includeTransactions) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            blockHashOrBlockTag = yield blockHashOrBlockTag;
            // If blockTag is a number (not "latest", etc), this is the block number
            let blockNumber = -128;
            const params = {
                includeTransactions: !!includeTransactions
            };
            if ((0, $ApLZa.isHexString)(blockHashOrBlockTag, 32)) params.blockHash = blockHashOrBlockTag;
            else try {
                params.blockTag = yield this._getBlockTag(blockHashOrBlockTag);
                if ((0, $ApLZa.isHexString)(params.blockTag)) blockNumber = parseInt(params.blockTag.substring(2), 16);
            } catch (error) {
                $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid block hash or block tag", "blockHashOrBlockTag", blockHashOrBlockTag);
            }
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const block = yield this.perform("getBlock", params);
                    // Block was not found
                    if (block == null) {
                        // For blockhashes, if we didn't say it existed, that blockhash may
                        // not exist. If we did see it though, perhaps from a log, we know
                        // it exists, and this node is just not caught up yet.
                        if (params.blockHash != null) {
                            if (this._emitted["b:" + params.blockHash] == null) return null;
                        }
                        // For block tags, if we are asking for a future block, we return null
                        if (params.blockTag != null) {
                            if (blockNumber > this._emitted.block) return null;
                        }
                        // Retry on the next block
                        return undefined;
                    }
                    // Add transactions
                    if (includeTransactions) {
                        let blockNumber = null;
                        for(let i = 0; i < block.transactions.length; i++){
                            const tx = block.transactions[i];
                            if (tx.blockNumber == null) tx.confirmations = 0;
                            else if (tx.confirmations == null) {
                                if (blockNumber == null) blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                                // Add the confirmations using the fast block number (pessimistic)
                                let confirmations = blockNumber - tx.blockNumber + 1;
                                if (confirmations <= 0) confirmations = 1;
                                tx.confirmations = confirmations;
                            }
                        }
                        const blockWithTxs = this.formatter.blockWithTransactions(block);
                        blockWithTxs.transactions = blockWithTxs.transactions.map((tx)=>this._wrapTransaction(tx));
                        return blockWithTxs;
                    }
                    return this.formatter.block(block);
                }), {
                oncePoll: this
            });
        });
    }
    getBlock(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, false);
    }
    getBlockWithTransactions(blockHashOrBlockTag) {
        return this._getBlock(blockHashOrBlockTag, true);
    }
    getTransaction(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransaction", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    const tx = this.formatter.transactionResponse(result);
                    if (tx.blockNumber == null) tx.confirmations = 0;
                    else if (tx.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - tx.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        tx.confirmations = confirmations;
                    }
                    return this._wrapTransaction(tx);
                }), {
                oncePoll: this
            });
        });
    }
    getTransactionReceipt(transactionHash) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            transactionHash = yield transactionHash;
            const params = {
                transactionHash: this.formatter.hash(transactionHash, true)
            };
            return (0, $2GUlC.poll)(()=>$fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
                    const result = yield this.perform("getTransactionReceipt", params);
                    if (result == null) {
                        if (this._emitted["t:" + transactionHash] == null) return null;
                        return undefined;
                    }
                    // "geth-etc" returns receipts before they are ready
                    if (result.blockHash == null) return undefined;
                    const receipt = this.formatter.receipt(result);
                    if (receipt.blockNumber == null) receipt.confirmations = 0;
                    else if (receipt.confirmations == null) {
                        const blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                        // Add the confirmations using the fast block number (pessimistic)
                        let confirmations = blockNumber - receipt.blockNumber + 1;
                        if (confirmations <= 0) confirmations = 1;
                        receipt.confirmations = confirmations;
                    }
                    return receipt;
                }), {
                oncePoll: this
            });
        });
    }
    getLogs(filter) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            const params = yield (0, $i6lOf.resolveProperties)({
                filter: this._getFilter(filter)
            });
            const logs = yield this.perform("getLogs", params);
            logs.forEach((log)=>{
                if (log.removed == null) log.removed = false;
            });
            return (0, $31PiM.Formatter).arrayOf(this.formatter.filterLog.bind(this.formatter))(logs);
        });
    }
    getEtherPrice() {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            yield this.getNetwork();
            return this.perform("getEtherPrice", {});
        });
    }
    _getBlockTag(blockTag) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            blockTag = yield blockTag;
            if (typeof blockTag === "number" && blockTag < 0) {
                if (blockTag % 1) $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid BlockTag", "blockTag", blockTag);
                let blockNumber = yield this._getInternalBlockNumber(100 + 2 * this.pollingInterval);
                blockNumber += blockTag;
                if (blockNumber < 0) blockNumber = 0;
                return this.formatter.blockTag(blockNumber);
            }
            return this.formatter.blockTag(blockTag);
        });
    }
    getResolver(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let currentName = name;
            while(true){
                if (currentName === "" || currentName === ".") return null;
                // Optimization since the eth node cannot change and does
                // not have a wildcard resolver
                if (name !== "eth" && currentName === "eth") return null;
                // Check the current node for a resolver
                const addr = yield this._getResolver(currentName, "getResolver");
                // Found a resolver!
                if (addr != null) {
                    const resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, addr, name);
                    // Legacy resolver found, using EIP-2544 so it isn't safe to use
                    if (currentName !== name && !(yield resolver.supportsWildcard())) return null;
                    return resolver;
                }
                // Get the parent node
                currentName = currentName.split(".").slice(1).join(".");
            }
        });
    }
    _getResolver(name, operation) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            if (operation == null) operation = "ENS";
            const network = yield this.getNetwork();
            // No ENS...
            if (!network.ensAddress) $fa2219aa02c3e62e$var$logger.throwError("network does not support ENS", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: operation,
                network: network.name
            });
            try {
                // keccak256("resolver(bytes32)")
                const addrData = yield this.call({
                    to: network.ensAddress,
                    data: "0x0178b8bf" + (0, $1e7EA.namehash)(name).substring(2)
                });
                return this.formatter.callAddress(addrData);
            } catch (error) {
            // ENS registry cannot throw errors on resolver(bytes32)
            }
            return null;
        });
    }
    resolveName(name) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            name = yield name;
            // If it is already an address, nothing to resolve
            try {
                return Promise.resolve(this.formatter.address(name));
            } catch (error) {
                // If is is a hexstring, the address is bad (See #694)
                if ((0, $ApLZa.isHexString)(name)) throw error;
            }
            if (typeof name !== "string") $fa2219aa02c3e62e$var$logger.throwArgumentError("invalid ENS name", "name", name);
            // Get the addr from the resolver
            const resolver = yield this.getResolver(name);
            if (!resolver) return null;
            return yield resolver.getAddress();
        });
    }
    lookupAddress(address) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            address = yield address;
            address = this.formatter.address(address);
            const node = address.substring(2).toLowerCase() + ".addr.reverse";
            const resolverAddr = yield this._getResolver(node, "lookupAddress");
            if (resolverAddr == null) return null;
            // keccak("name(bytes32)")
            const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                to: resolverAddr,
                data: "0x691f3431" + (0, $1e7EA.namehash)(node).substring(2)
            })), 0);
            const addr = yield this.resolveName(name);
            if (addr != address) return null;
            return name;
        });
    }
    getAvatar(nameOrAddress) {
        return $fa2219aa02c3e62e$var$__awaiter(this, void 0, void 0, function*() {
            let resolver = null;
            if ((0, $ApLZa.isHexString)(nameOrAddress)) {
                // Address; reverse lookup
                const address = this.formatter.address(nameOrAddress);
                const node = address.substring(2).toLowerCase() + ".addr.reverse";
                const resolverAddress = yield this._getResolver(node, "getAvatar");
                if (!resolverAddress) return null;
                // Try resolving the avatar against the addr.reverse resolver
                resolver = new $fa2219aa02c3e62e$export$8b4c839865b08288(this, resolverAddress, node);
                try {
                    const avatar = yield resolver.getAvatar();
                    if (avatar) return avatar.url;
                } catch (error) {
                    if (error.code !== (0, $8bxC3.Logger).errors.CALL_EXCEPTION) throw error;
                }
                // Try getting the name and performing forward lookup; allowing wildcards
                try {
                    // keccak("name(bytes32)")
                    const name = $fa2219aa02c3e62e$var$_parseString((yield this.call({
                        to: resolverAddress,
                        data: "0x691f3431" + (0, $1e7EA.namehash)(node).substring(2)
                    })), 0);
                    resolver = yield this.getResolver(name);
                } catch (error) {
                    if (error.code !== (0, $8bxC3.Logger).errors.CALL_EXCEPTION) throw error;
                    return null;
                }
            } else {
                // ENS name; forward lookup with wildcard
                resolver = yield this.getResolver(nameOrAddress);
                if (!resolver) return null;
            }
            const avatar = yield resolver.getAvatar();
            if (avatar == null) return null;
            return avatar.url;
        });
    }
    perform(method, params) {
        return $fa2219aa02c3e62e$var$logger.throwError(method + " not implemented", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
            operation: method
        });
    }
    _startEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _stopEvent(event) {
        this.polling = this._events.filter((e)=>e.pollable()).length > 0;
    }
    _addEventListener(eventName, listener, once) {
        const event = new $fa2219aa02c3e62e$export$d61e24a684f9e51($fa2219aa02c3e62e$var$getEventTag(eventName), listener, once);
        this._events.push(event);
        this._startEvent(event);
        return this;
    }
    on(eventName, listener) {
        return this._addEventListener(eventName, listener, false);
    }
    once(eventName, listener) {
        return this._addEventListener(eventName, listener, true);
    }
    emit(eventName, ...args) {
        let result = false;
        let stopped = [];
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag) return true;
            setTimeout(()=>{
                event.listener.apply(this, args);
            }, 0);
            result = true;
            if (event.once) {
                stopped.push(event);
                return false;
            }
            return true;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return result;
    }
    listenerCount(eventName) {
        if (!eventName) return this._events.length;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>{
            return event.tag === eventTag;
        }).length;
    }
    listeners(eventName) {
        if (eventName == null) return this._events.map((event)=>event.listener);
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        return this._events.filter((event)=>event.tag === eventTag).map((event)=>event.listener);
    }
    off(eventName, listener) {
        if (listener == null) return this.removeAllListeners(eventName);
        const stopped = [];
        let found = false;
        let eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
        this._events = this._events.filter((event)=>{
            if (event.tag !== eventTag || event.listener != listener) return true;
            if (found) return true;
            found = true;
            stopped.push(event);
            return false;
        });
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
    removeAllListeners(eventName) {
        let stopped = [];
        if (eventName == null) {
            stopped = this._events;
            this._events = [];
        } else {
            const eventTag = $fa2219aa02c3e62e$var$getEventTag(eventName);
            this._events = this._events.filter((event)=>{
                if (event.tag !== eventTag) return true;
                stopped.push(event);
                return false;
            });
        }
        stopped.forEach((event)=>{
            this._stopEvent(event);
        });
        return this;
    }
}

});
parcelRegister("1e7EA", function(module, exports) {

$parcel$export(module.exports, "isValidName", function () { return $0e4d091b6edb4637$export$cce2300886e7ace6; });
$parcel$export(module.exports, "namehash", function () { return $0e4d091b6edb4637$export$91d651ee363e1209; });
$parcel$export(module.exports, "dnsEncode", function () { return $0e4d091b6edb4637$export$6c0a8cdae51cb512; });

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");

var $8unkG = parcelRequire("8unkG");

var $8bxC3 = parcelRequire("8bxC3");

var $5rMbp = parcelRequire("5rMbp");

var $hKKRA = parcelRequire("hKKRA");
const $0e4d091b6edb4637$var$logger = new (0, $8bxC3.Logger)((0, $5rMbp.version));
const $0e4d091b6edb4637$var$Zeros = new Uint8Array(32);
$0e4d091b6edb4637$var$Zeros.fill(0);
function $0e4d091b6edb4637$var$checkComponent(comp) {
    if (comp.length === 0) throw new Error("invalid ENS name; empty component");
    return comp;
}
function $0e4d091b6edb4637$var$ensNameSplit(name) {
    const bytes = (0, $aCHl8.toUtf8Bytes)((0, $hKKRA.ens_normalize)(name));
    const comps = [];
    if (name.length === 0) return comps;
    let last = 0;
    for(let i = 0; i < bytes.length; i++){
        const d = bytes[i];
        // A separator (i.e. "."); copy this component
        if (d === 0x2e) {
            comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last, i)));
            last = i + 1;
        }
    }
    // There was a stray separator at the end of the name
    if (last >= bytes.length) throw new Error("invalid ENS name; empty component");
    comps.push($0e4d091b6edb4637$var$checkComponent(bytes.slice(last)));
    return comps;
}
function $0e4d091b6edb4637$export$5f232fd2f1a1e8ac(name) {
    return $0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>(0, $aCHl8.toUtf8String)(comp)).join(".");
}
function $0e4d091b6edb4637$export$cce2300886e7ace6(name) {
    try {
        return $0e4d091b6edb4637$var$ensNameSplit(name).length !== 0;
    } catch (error) {}
    return false;
}
function $0e4d091b6edb4637$export$91d651ee363e1209(name) {
    /* istanbul ignore if */ if (typeof name !== "string") $0e4d091b6edb4637$var$logger.throwArgumentError("invalid ENS name; not a string", "name", name);
    let result = $0e4d091b6edb4637$var$Zeros;
    const comps = $0e4d091b6edb4637$var$ensNameSplit(name);
    while(comps.length)result = (0, $8unkG.keccak256)((0, $ApLZa.concat)([
        result,
        (0, $8unkG.keccak256)(comps.pop())
    ]));
    return (0, $ApLZa.hexlify)(result);
}
function $0e4d091b6edb4637$export$6c0a8cdae51cb512(name) {
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)($0e4d091b6edb4637$var$ensNameSplit(name).map((comp)=>{
        // DNS does not allow components over 63 bytes in length
        if (comp.length > 63) throw new Error("invalid DNS encoded entry; length exceeds 63 bytes");
        const bytes = new Uint8Array(comp.length + 1);
        bytes.set(comp, 1);
        bytes[0] = bytes.length - 1;
        return bytes;
    }))) + "00";
}

});
parcelRegister("hKKRA", function(module, exports) {

$parcel$export(module.exports, "ens_normalize", function () { return $cecb159d53c0fe21$export$499f715881831a51; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $aCHl8 = parcelRequire("aCHl8");

var $7A525 = parcelRequire("7A525");

var $3qhZu = parcelRequire("3qhZu");
const $cecb159d53c0fe21$var$r = (0, $7A525.getData)();
// @TODO: This should be lazily loaded
const $cecb159d53c0fe21$var$VALID = new Set((0, $3qhZu.read_member_array)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$IGNORED = new Set((0, $3qhZu.read_member_array)($cecb159d53c0fe21$var$r));
const $cecb159d53c0fe21$var$MAPPED = (0, $3qhZu.read_mapped_map)($cecb159d53c0fe21$var$r);
const $cecb159d53c0fe21$var$EMOJI_ROOT = (0, $3qhZu.read_emoji_trie)($cecb159d53c0fe21$var$r);
//const NFC_CHECK = new Set(read_member_array(r, Array.from(VALID.values()).sort((a, b) => a - b)));
//const STOP = 0x2E;
const $cecb159d53c0fe21$var$HYPHEN = 0x2D;
const $cecb159d53c0fe21$var$UNDERSCORE = 0x5F;
function $cecb159d53c0fe21$var$explode_cp(name) {
    return (0, $aCHl8.toUtf8CodePoints)(name);
}
function $cecb159d53c0fe21$var$filter_fe0f(cps) {
    return cps.filter((cp)=>cp != 0xFE0F);
}
function $cecb159d53c0fe21$export$5252e54b57fcf4fd(name) {
    for (let label of name.split(".")){
        let cps = $cecb159d53c0fe21$var$explode_cp(label);
        try {
            for(let i = cps.lastIndexOf($cecb159d53c0fe21$var$UNDERSCORE) - 1; i >= 0; i--){
                if (cps[i] !== $cecb159d53c0fe21$var$UNDERSCORE) throw new Error(`underscore only allowed at start`);
            }
            if (cps.length >= 4 && cps.every((cp)=>cp < 0x80) && cps[2] === $cecb159d53c0fe21$var$HYPHEN && cps[3] === $cecb159d53c0fe21$var$HYPHEN) throw new Error(`invalid label extension`);
        } catch (err) {
            throw new Error(`Invalid label "${label}": ${err.message}`);
        }
    }
    return name;
}
function $cecb159d53c0fe21$export$499f715881831a51(name) {
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$normalize(name, $cecb159d53c0fe21$var$filter_fe0f));
}
function $cecb159d53c0fe21$var$normalize(name, emoji_filter) {
    let input = $cecb159d53c0fe21$var$explode_cp(name).reverse(); // flip for pop
    let output = [];
    while(input.length){
        let emoji = $cecb159d53c0fe21$var$consume_emoji_reversed(input);
        if (emoji) {
            output.push(...emoji_filter(emoji));
            continue;
        }
        let cp = input.pop();
        if ($cecb159d53c0fe21$var$VALID.has(cp)) {
            output.push(cp);
            continue;
        }
        if ($cecb159d53c0fe21$var$IGNORED.has(cp)) continue;
        let cps = $cecb159d53c0fe21$var$MAPPED[cp];
        if (cps) {
            output.push(...cps);
            continue;
        }
        throw new Error(`Disallowed codepoint: 0x${cp.toString(16).toUpperCase()}`);
    }
    return $cecb159d53c0fe21$export$5252e54b57fcf4fd($cecb159d53c0fe21$var$nfc(String.fromCodePoint(...output)));
}
function $cecb159d53c0fe21$var$nfc(s) {
    return s.normalize("NFC");
}
function $cecb159d53c0fe21$var$consume_emoji_reversed(cps, eaten) {
    var _a;
    let node = $cecb159d53c0fe21$var$EMOJI_ROOT;
    let emoji;
    let saved;
    let stack = [];
    let pos = cps.length;
    if (eaten) eaten.length = 0; // clear input buffer (if needed)
    while(pos){
        let cp = cps[--pos];
        node = (_a = node.branches.find((x)=>x.set.has(cp))) === null || _a === void 0 ? void 0 : _a.node;
        if (!node) break;
        if (node.save) saved = cp;
        else if (node.check) {
            if (cp === saved) break;
        }
        stack.push(cp);
        if (node.fe0f) {
            stack.push(0xFE0F);
            if (pos > 0 && cps[pos - 1] == 0xFE0F) pos--; // consume optional FE0F
        }
        if (node.valid) {
            emoji = stack.slice(); // copy stack
            if (node.valid == 2) emoji.splice(1, 1); // delete FE0F at position 1 (RGI ZWJ don't follow spec!)
            if (eaten) eaten.push(...cps.slice(pos).reverse()); // copy input (if needed)
            cps.length = pos; // truncate
        }
    }
    return emoji;
}

});
parcelRegister("7A525", function(module, exports) {

$parcel$export(module.exports, "getData", function () { return $584fcc90974ab591$export$7a171f172be0782e; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ 
var $2bJst = parcelRequire("2bJst");

var $3qhZu = parcelRequire("3qhZu");
function $584fcc90974ab591$export$7a171f172be0782e() {
    return (0, $3qhZu.read_compressed_payload)((0, $2bJst.decode)("AEQF2AO2DEsA2wIrAGsBRABxAN8AZwCcAEwAqgA0AGwAUgByADcATAAVAFYAIQAyACEAKAAYAFgAGwAjABQAMAAmADIAFAAfABQAKwATACoADgAbAA8AHQAYABoAGQAxADgALAAoADwAEwA9ABMAGgARAA4ADwAWABMAFgAIAA8AHgQXBYMA5BHJAS8JtAYoAe4AExozi0UAH21tAaMnBT8CrnIyhrMDhRgDygIBUAEHcoFHUPe8AXBjAewCjgDQR8IICIcEcQLwATXCDgzvHwBmBoHNAqsBdBcUAykgDhAMShskMgo8AY8jqAQfAUAfHw8BDw87MioGlCIPBwZCa4ELatMAAMspJVgsDl8AIhckSg8XAHdvTwBcIQEiDT4OPhUqbyECAEoAS34Aej8Ybx83JgT/Xw8gHxZ/7w8RICxPHA9vBw+Pfw8PHwAPFv+fAsAvCc8vEr8ivwD/EQ8Bol8OEBa/A78hrwAPCU8vESNvvwWfHwNfAVoDHr+ZAAED34YaAdJPAK7PLwSEgDLHAGo1Pz8Pvx9fUwMrpb8O/58VTzAPIBoXIyQJNF8hpwIVAT8YGAUADDNBaX3RAMomJCg9EhUeA29MABsZBTMNJipjOhc19gcIDR8bBwQHEggCWi6DIgLuAQYA+BAFCha3A5XiAEsqM7UFFgFLhAMjFTMYE1Klnw74nRVBG/ASCm0BYRN/BrsU3VoWy+S0vV8LQx+vN8gF2AC2AK5EAWwApgYDKmAAroQ0NDQ0AT+OCg7wAAIHRAbpNgVcBV0APTA5BfbPFgMLzcYL/QqqA82eBALKCjQCjqYCht0/k2+OAsXQAoP3ASTKDgDw6ACKAUYCMpIKJpRaAE4A5womABzZvs0REEKiACIQAd5QdAECAj4Ywg/wGqY2AVgAYADYvAoCGAEubA0gvAY2ALAAbpbvqpyEAGAEpgQAJgAG7gAgAEACmghUFwCqAMpAINQIwC4DthRAAPcycKgApoIdABwBfCisABoATwBqASIAvhnSBP8aH/ECeAKXAq40NjgDBTwFYQU6AXs3oABgAD4XNgmcCY1eCl5tIFZeUqGgyoNHABgAEQAaABNwWQAmABMATPMa3T34ADldyprmM1M2XociUQgLzvwAXT3xABgAEQAaABNwIGFAnADD8AAgAD4BBJWzaCcIAIEBFMAWwKoAAdq9BWAF5wLQpALEtQAKUSGkahR4GnJM+gsAwCgeFAiUAECQ0BQuL8AAIAAAADKeIheclvFqQAAETr4iAMxIARMgAMIoHhQIAn0E0pDQFC4HhznoAAAAIAI2C0/4lvFqQAAETgBJJwYCAy4ABgYAFAA8MBKYEH4eRhTkAjYeFcgACAYAeABsOqyQ5gRwDayqugEgaIIAtgoACgDmEABmBAWGme5OBJJA2m4cDeoAmITWAXwrMgOgAGwBCh6CBXYF1Tzg1wKAAFdiuABRAFwAXQBsAG8AdgBrAHYAbwCEAHEwfxQBVE5TEQADVFhTBwBDANILAqcCzgLTApQCrQL6vAAMAL8APLhNBKkE6glGKTAU4Dr4N2EYEwBCkABKk8rHAbYBmwIoAiU4Ajf/Aq4CowCAANIChzgaNBsCsTgeODcFXrgClQKdAqQBiQGYAqsCsjTsNHsfNPA0ixsAWTWiOAMFPDQSNCk2BDZHNow2TTZUNhk28Jk9VzI3QkEoAoICoQKwAqcAQAAxBV4FXbS9BW47YkIXP1ciUqs05DS/FwABUwJW11e6nHuYZmSh/RAYA8oMKvZ8KASoUAJYWAJ6ILAsAZSoqjpgA0ocBIhmDgDWAAawRDQoAAcuAj5iAHABZiR2AIgiHgCaAU68ACxuHAG0ygM8MiZIAlgBdF4GagJqAPZOHAMuBgoATkYAsABiAHgAMLoGDPj0HpKEBAAOJgAuALggTAHWAeAMEDbd20Uege0ADwAWADkAQgA9OHd+2MUQZBBhBgNNDkxxPxUQArEPqwvqERoM1irQ090ANK4H8ANYB/ADWANYB/AH8ANYB/ADWANYA1gDWBwP8B/YxRBkD00EcgWTBZAE2wiIJk4RhgctCNdUEnQjHEwDSgEBIypJITuYMxAlR0wRTQgIATZHbKx9PQNMMbBU+pCnA9AyVDlxBgMedhKlAC8PeCE1uk6DekxxpQpQT7NX9wBFBgASqwAS5gBJDSgAUCwGPQBI4zTYABNGAE2bAE3KAExdGABKaAbgAFBXAFCOAFBJABI2SWdObALDOq0//QomCZhvwHdTBkIQHCemEPgMNAG2ATwN7kvZBPIGPATKH34ZGg/OlZ0Ipi3eDO4m5C6igFsj9iqEBe5L9TzeC05RaQ9aC2YJ5DpkgU8DIgEOIowK3g06CG4Q9ArKbA3mEUYHOgPWSZsApgcCCxIdNhW2JhFirQsKOXgG/Br3C5AmsBMqev0F1BoiBk4BKhsAANAu6IWxWjJcHU9gBgQLJiPIFKlQIQ0mQLh4SRocBxYlqgKSQ3FKiFE3HpQh9zw+DWcuFFF9B/Y8BhlQC4I8n0asRQ8R0z6OPUkiSkwtBDaALDAnjAnQD4YMunxzAVoJIgmyDHITMhEYN8YIOgcaLpclJxYIIkaWYJsE+KAD9BPSAwwFQAlCBxQDthwuEy8VKgUOgSXYAvQ21i60ApBWgQEYBcwPJh/gEFFH4Q7qCJwCZgOEJewALhUiABginAhEZABgj9lTBi7MCMhqbSN1A2gU6GIRdAeSDlgHqBw0FcAc4nDJXgyGCSiksAlcAXYJmgFgBOQICjVcjKEgQmdUi1kYnCBiQUBd/QIyDGYVoES+h3kCjA9sEhwBNgF0BzoNAgJ4Ee4RbBCWCOyGBTW2M/k6JgRQIYQgEgooA1BszwsoJvoM+WoBpBJjAw00PnfvZ6xgtyUX/gcaMsZBYSHyC5NPzgydGsIYQ1QvGeUHwAP0GvQn60FYBgADpAQUOk4z7wS+C2oIjAlAAEoOpBgH2BhrCnKM0QEyjAG4mgNYkoQCcJAGOAcMAGgMiAV65gAeAqgIpAAGANADWAA6Aq4HngAaAIZCAT4DKDABIuYCkAOUCDLMAZYwAfQqBBzEDBYA+DhuSwLDsgKAa2ajBd5ZAo8CSjYBTiYEBk9IUgOwcuIA3ABMBhTgSAEWrEvMG+REAeBwLADIAPwABjYHBkIBzgH0bgC4AWALMgmjtLYBTuoqAIQAFmwB2AKKAN4ANgCA8gFUAE4FWvoF1AJQSgESMhksWGIBvAMgATQBDgB6BsyOpsoIIARuB9QCEBwV4gLvLwe2AgMi4BPOQsYCvd9WADIXUu5eZwqoCqdeaAC0YTQHMnM9UQAPH6k+yAdy/BZIiQImSwBQ5gBQQzSaNTFWSTYBpwGqKQK38AFtqwBI/wK37gK3rQK3sAK6280C0gK33AK3zxAAUEIAUD9SklKDArekArw5AEQAzAHCO147WTteO1k7XjtZO147WTteO1kDmChYI03AVU0oJqkKbV9GYewMpw3VRMk6ShPcYFJgMxPJLbgUwhXPJVcZPhq9JwYl5VUKDwUt1GYxCC00dhe9AEApaYNCY4ceMQpMHOhTklT5LRwAskujM7ANrRsWREEFSHXuYisWDwojAmSCAmJDXE6wXDchAqH4AmiZAmYKAp+FOBwMAmY8AmYnBG8EgAN/FAN+kzkHOXgYOYM6JCQCbB4CMjc4CwJtyAJtr/CLADRoRiwBaADfAOIASwYHmQyOAP8MwwAOtgJ3MAJ2o0ACeUxEAni7Hl3cRa9G9AJ8QAJ6yQJ9CgJ88UgBSH5kJQAsFklZSlwWGErNAtECAtDNSygDiFADh+dExpEzAvKiXQQDA69Lz0wuJgTQTU1NsAKLQAKK2cIcCB5EaAa4Ao44Ao5dQZiCAo7aAo5deVG1UzYLUtVUhgKT/AKTDQDqAB1VH1WwVdEHLBwplocy4nhnRTw6ApegAu+zWCKpAFomApaQApZ9nQCqWa1aCoJOADwClrYClk9cRVzSApnMApllXMtdCBoCnJw5wzqeApwXAp+cAp65iwAeEDIrEAKd8gKekwC2PmE1YfACntQCoG8BqgKeoCACnk+mY8lkKCYsAiewAiZ/AqD8AqBN2AKmMAKlzwKoAAB+AqfzaH1osgAESmodatICrOQCrK8CrWgCrQMCVx4CVd0CseLYAx9PbJgCsr4OArLpGGzhbWRtSWADJc4Ctl08QG6RAylGArhfArlIFgK5K3hwN3DiAr0aAy2zAzISAr6JcgMDM3ICvhtzI3NQAsPMAsMFc4N0TDZGdOEDPKgDPJsDPcACxX0CxkgCxhGKAshqUgLIRQLJUALJLwJkngLd03h6YniveSZL0QMYpGcDAmH1GfSVJXsMXpNevBICz2wCz20wTFTT9BSgAMeuAs90ASrrA04TfkwGAtwoAtuLAtJQA1JdA1NgAQIDVY2AikABzBfuYUZ2AILPg44C2sgC2d+EEYRKpz0DhqYAMANkD4ZyWvoAVgLfZgLeuXR4AuIw7RUB8zEoAfScAfLTiALr9ALpcXoAAur6AurlAPpIAboC7ooC652Wq5cEAu5AA4XhmHpw4XGiAvMEAGoDjheZlAL3FAORbwOSiAL3mQL52gL4Z5odmqy8OJsfA52EAv77ARwAOp8dn7QDBY4DpmsDptoA0sYDBmuhiaIGCgMMSgFgASACtgNGAJwEgLpoBgC8BGzAEowcggCEDC6kdjoAJAM0C5IKRoABZCgiAIzw3AYBLACkfng9ogigkgNmWAN6AEQCvrkEVqTGAwCsBRbAA+4iQkMCHR072jI2PTbUNsk2RjY5NvA23TZKNiU3EDcZN5I+RTxDRTBCJkK5VBYKFhZfwQCWygU3AJBRHpu+OytgNxa61A40GMsYjsn7BVwFXQVcBV0FaAVdBVwFXQVcBV0FXAVdBVwFXUsaCNyKAK4AAQUHBwKU7oICoW1e7jAEzgPxA+YDwgCkBFDAwADABKzAAOxFLhitA1UFTDeyPkM+bj51QkRCuwTQWWQ8X+0AWBYzsACNA8xwzAGm7EZ/QisoCTAbLDs6fnLfb8H2GccsbgFw13M1HAVkBW/Jxsm9CNRO8E8FDD0FBQw9FkcClOYCoMFegpDfADgcMiA2AJQACB8AsigKAIzIEAJKeBIApY5yPZQIAKQiHb4fvj5BKSRPQrZCOz0oXyxgOywfKAnGbgMClQaCAkILXgdeCD9IIGUgQj5fPoY+dT52Ao5CM0dAX9BTVG9SDzFwWTQAbxBzJF/lOEIQQglCCkKJIAls5AcClQICoKPMODEFxhi6KSAbiyfIRrMjtCgdWCAkPlFBIitCsEJRzAbMAV/OEyQzDg0OAQQEJ36i328/Mk9AybDJsQlq3tDRApUKAkFzXf1d/j9uALYP6hCoFgCTGD8kPsFKQiobrm0+zj0KSD8kPnVCRBwMDyJRTHFgMTJa5rwXQiQ2YfI/JD7BMEJEHGINTw4TOFlIRzwJO0icMQpyPyQ+wzJCRBv6DVgnKB01NgUKj2bwYzMqCoBkznBgEF+zYDIocwRIX+NgHj4HICNfh2C4CwdwFWpTG/lgUhYGAwRfv2Ts8mAaXzVgml/XYIJfuWC4HI1gUF9pYJZgMR6ilQHMAOwLAlDRefC0in4AXAEJA6PjCwc0IamOANMMCAECRQDFNRTZBgd+CwQlRA+r6+gLBDEFBnwUBXgKATIArwAGRAAHA3cDdAN2A3kDdwN9A3oDdQN7A30DfAN4A3oDfQAYEAAlAtYASwMAUAFsAHcKAHcAmgB3AHUAdQB2AHVu8UgAygDAAHcAdQB1AHYAdQALCgB3AAsAmgB3AAsCOwB3AAtu8UgAygDAAHgKAJoAdwB3AHUAdQB2AHUAeAB1AHUAdgB1bvFIAMoAwAALCgCaAHcACwB3AAsCOwB3AAtu8UgAygDAAH4ACwGgALcBpwC6AahdAu0COwLtbvFIAMoAwAALCgCaAu0ACwLtAAsCOwLtAAtu8UgAygDAA24ACwNvAAu0VsQAAzsAABCkjUIpAAsAUIusOggWcgMeBxVsGwL67U/2HlzmWOEeOgALASvuAAseAfpKUpnpGgYJDCIZM6YyARUE9ThqAD5iXQgnAJYJPnOzw0ZAEZxEKsIAkA4DhAHnTAIDxxUDK0lxCQlPYgIvIQVYJQBVqE1GakUAKGYiDToSBA1EtAYAXQJYAIF8GgMHRyAAIAjOe9YncekRAA0KACUrjwE7Ayc6AAYWAqaiKG4McEcqANoN3+Mg9TwCBhIkuCny+JwUQ29L008JluRxu3K+oAdqiHOqFH0AG5SUIfUJ5SxCGfxdipRzqTmT4V5Zb+r1Uo4Vm+NqSSEl2mNvR2JhIa8SpYO6ntdwFXHCWTCK8f2+Hxo7uiG3drDycAuKIMP5bhi06ACnqArH1rz4Rqg//lm6SgJGEVbF9xJHISaR6HxqxSnkw6shDnelHKNEfGUXSJRJ1GcsmtJw25xrZMDK9gXSm1/YMkdX4/6NKYOdtk/NQ3/NnDASjTc3fPjIjW/5sVfVObX2oTDWkr1dF9f3kxBsD3/3aQO8hPfRz+e0uEiJqt1161griu7gz8hDDwtpy+F+BWtefnKHZPAxcZoWbnznhJpy0e842j36bcNzGnIEusgGX0a8ZxsnjcSsPDZ09yZ36fCQbriHeQ72JRMILNl6ePPf2HWoVwgWAm1fb3V2sAY0+B6rAXqSwPBgseVmoqsBTSrm91+XasMYYySI8eeRxH3ZvHkMz3BQ5aJ3iUVbYPNM3/7emRtjlsMgv/9VyTsyt/mK+8fgWeT6SoFaclXqn42dAIsvAarF5vNNWHzKSkKQ/8Hfk5ZWK7r9yliOsooyBjRhfkHP4Q2DkWXQi6FG/9r/IwbmkV5T7JSopHKn1pJwm9tb5Ot0oyN1Z2mPpKXHTxx2nlK08fKk1hEYA8WgVVWL5lgx0iTv+KdojJeU23ZDjmiubXOxVXJKKi2Wjuh2HLZOFLiSC7Tls5SMh4f+Pj6xUSrNjFqLGehRNB8lC0QSLNmkJJx/wSG3MnjE9T1CkPwJI0wH2lfzwETIiVqUxg0dfu5q39Gt+hwdcxkhhNvQ4TyrBceof3Mhs/IxFci1HmHr4FMZgXEEczPiGCx0HRwzAqDq2j9AVm1kwN0mRVLWLylgtoPNapF5cY4Y1wJh/e0BBwZj44YgZrDNqvD/9Hv7GFYdUQeDJuQ3EWI4HaKqavU1XjC/n41kT4L79kqGq0kLhdTZvgP3TA3fS0ozVz+5piZsoOtIvBUFoMKbNcmBL6YxxaUAusHB38XrS8dQMnQwJfUUkpRoGr5AUeWicvBTzyK9g77+yCkf5PAysL7r/JjcZgrbvRpMW9iyaxZvKO6ceZN2EwIxKwVFPuvFuiEPGCoagbMo+SpydLrXqBzNCDGFCrO/rkcwa2xhokQZ5CdZ0AsU3JfSqJ6n5I14YA+P/uAgfhPU84Tlw7cEFfp7AEE8ey4sP12PTt4Cods1GRgDOB5xvyiR5m+Bx8O5nBCNctU8BevfV5A08x6RHd5jcwPTMDSZJOedIZ1cGQ704lxbAzqZOP05ZxaOghzSdvFBHYqomATARyAADK4elP8Ly3IrUZKfWh23Xy20uBUmLS4Pfagu9+oyVa2iPgqRP3F2CTUsvJ7+RYnN8fFZbU/HVvxvcFFDKkiTqV5UBZ3Gz54JAKByi9hkKMZJvuGgcSYXFmw08UyoQyVdfTD1/dMkCHXcTGAKeROgArsvmRrQTLUOXioOHGK2QkjHuoYFgXciZoTJd6Fs5q1QX1G+p/e26hYsEf7QZD1nnIyl/SFkNtYYmmBhpBrxl9WbY0YpHWRuw2Ll/tj9mD8P4snVzJl4F9J+1arVeTb9E5r2ILH04qStjxQNwn3m4YNqxmaNbLAqW2TN6LidwuJRqS+NXbtqxoeDXpxeGWmxzSkWxjkyCkX4NQRme6q5SAcC+M7+9ETfA/EwrzQajKakCwYyeunP6ZFlxU2oMEn1Pz31zeStW74G406ZJFCl1wAXIoUKkWotYEpOuXB1uVNxJ63dpJEqfxBeptwIHNrPz8BllZoIcBoXwgfJ+8VAUnVPvRvexnw0Ma/WiGYuJO5y8QTvEYBigFmhUxY5RqzE8OcywN/8m4UYrlaniJO75XQ6KSo9+tWHlu+hMi0UVdiKQp7NelnoZUzNaIyBPVeOwK6GNp+FfHuPOoyhaWuNvTYFkvxscMQWDh+zeFCFkgwbXftiV23ywJ4+uwRqmg9k3KzwIQpzppt8DBBOMbrqwQM5Gb05sEwdKzMiAqOloaA/lr0KA+1pr0/+HiWoiIjHA/wir2nIuS3PeU/ji3O6ZwoxcR1SZ9FhtLC5S0FIzFhbBWcGVP/KpxOPSiUoAdWUpqKH++6Scz507iCcxYI6rdMBICPJZea7OcmeFw5mObJSiqpjg2UoWNIs+cFhyDSt6geV5qgi3FunmwwDoGSMgerFOZGX1m0dMCYo5XOruxO063dwENK9DbnVM9wYFREzh4vyU1WYYJ/LRRp6oxgjqP/X5a8/4Af6p6NWkQferzBmXme0zY/4nwMJm/wd1tIqSwGz+E3xPEAOoZlJit3XddD7/BT1pllzOx+8bmQtANQ/S6fZexc6qi3W+Q2xcmXTUhuS5mpHQRvcxZUN0S5+PL9lXWUAaRZhEH8hTdAcuNMMCuVNKTEGtSUKNi3O6KhSaTzck8csZ2vWRZ+d7mW8c4IKwXIYd25S/zIftPkwPzufjEvOHWVD1m+FjpDVUTV0DGDuHj6QnaEwLu/dEgdLQOg9E1Sro9XHJ8ykLAwtPu+pxqKDuFexqON1sKQm7rwbE1E68UCfA/erovrTCG+DBSNg0l4goDQvZN6uNlbyLpcZAwj2UclycvLpIZMgv4yRlpb3YuMftozorbcGVHt/VeDV3+Fdf1TP0iuaCsPi2G4XeGhsyF1ubVDxkoJhmniQ0/jSg/eYML9KLfnCFgISWkp91eauR3IQvED0nAPXK+6hPCYs+n3+hCZbiskmVMG2da+0EsZPonUeIY8EbfusQXjsK/eFDaosbPjEfQS0RKG7yj5GG69M7MeO1HmiUYocgygJHL6M1qzUDDwUSmr99V7Sdr2F3JjQAJY+F0yH33Iv3+C9M38eML7gTgmNu/r2bUMiPvpYbZ6v1/IaESirBHNa7mPKn4dEmYg7v/+HQgPN1G79jBQ1+soydfDC2r+h2Bl/KIc5KjMK7OH6nb1jLsNf0EHVe2KBiE51ox636uyG6Lho0t3J34L5QY/ilE3mikaF4HKXG1mG1rCevT1Vv6GavltxoQe/bMrpZvRggnBxSEPEeEzkEdOxTnPXHVjUYdw8JYvjB/o7Eegc3Ma+NUxLLnsK0kJlinPmUHzHGtrk5+CAbVzFOBqpyy3QVUnzTDfC/0XD94/okH+OB+i7g9lolhWIjSnfIb+Eq43ZXOWmwvjyV/qqD+t0e+7mTEM74qP/Ozt8nmC7mRpyu63OB4KnUzFc074SqoyPUAgM+/TJGFo6T44EHnQU4X4z6qannVqgw/U7zCpwcmXV1AubIrvOmkKHazJAR55ePjp5tLBsN8vAqs3NAHdcEHOR2xQ0lsNAFzSUuxFQCFYvXLZJdOj9p4fNq6p0HBGUik2YzaI4xySy91KzhQ0+q1hjxvImRwPRf76tChlRkhRCi74NXZ9qUNeIwP+s5p+3m5nwPdNOHgSLD79n7O9m1n1uDHiMntq4nkYwV5OZ1ENbXxFd4PgrlvavZsyUO4MqYlqqn1O8W/I1dEZq5dXhrbETLaZIbC2Kj/Aa/QM+fqUOHdf0tXAQ1huZ3cmWECWSXy/43j35+Mvq9xws7JKseriZ1pEWKc8qlzNrGPUGcVgOa9cPJYIJsGnJTAUsEcDOEVULO5x0rXBijc1lgXEzQQKhROf8zIV82w8eswc78YX11KYLWQRcgHNJElBxfXr72lS2RBSl07qTKorO2uUDZr3sFhYsvnhLZn0A94KRzJ/7DEGIAhW5ZWFpL8gEwu1aLA9MuWZzNwl8Oze9Y+bX+v9gywRVnoB5I/8kXTXU3141yRLYrIOOz6SOnyHNy4SieqzkBXharjfjqq1q6tklaEbA8Qfm2DaIPs7OTq/nvJBjKfO2H9bH2cCMh1+5gspfycu8f/cuuRmtDjyqZ7uCIMyjdV3a+p3fqmXsRx4C8lujezIFHnQiVTXLXuI1XrwN3+siYYj2HHTvESUx8DlOTXpak9qFRK+L3mgJ1WsD7F4cu1aJoFoYQnu+wGDMOjJM3kiBQWHCcvhJ/HRdxodOQp45YZaOTA22Nb4XKCVxqkbwMYFhzYQYIAnCW8FW14uf98jhUG2zrKhQQ0q0CEq0t5nXyvUyvR8DvD69LU+g3i+HFWQMQ8PqZuHD+sNKAV0+M6EJC0szq7rEr7B5bQ8BcNHzvDMc9eqB5ZCQdTf80Obn4uzjwpYU7SISdtV0QGa9D3Wrh2BDQtpBKxaNFV+/Cy2P/Sv+8s7Ud0Fd74X4+o/TNztWgETUapy+majNQ68Lq3ee0ZO48VEbTZYiH1Co4OlfWef82RWeyUXo7woM03PyapGfikTnQinoNq5z5veLpeMV3HCAMTaZmA1oGLAn7XS3XYsz+XK7VMQsc4XKrmDXOLU/pSXVNUq8dIqTba///3x6LiLS6xs1xuCAYSfcQ3+rQgmu7uvf3THKt5Ooo97TqcbRqxx7EASizaQCBQllG/rYxVapMLgtLbZS64w1MDBMXX+PQpBKNwqUKOf2DDRDUXQf9EhOS0Qj4nTmlA8dzSLz/G1d+Ud8MTy/6ghhdiLpeerGY/UlDOfiuqFsMUU5/UYlP+BAmgRLuNpvrUaLlVkrqDievNVEAwF+4CoM1MZTmjxjJMsKJq+u8Zd7tNCUFy6LiyYXRJQ4VyvEQFFaCGKsxIwQkk7EzZ6LTJq2hUuPhvAW+gQnSG6J+MszC+7QCRHcnqDdyNRJ6T9xyS87A6MDutbzKGvGktpbXqtzWtXb9HsfK2cBMomjN9a4y+TaJLnXxAeX/HWzmf4cR4vALt/P4w4qgKY04ml4ZdLOinFYS6cup3G/1ie4+t1eOnpBNlqGqs75ilzkT4+DsZQxNvaSKJ//6zIbbk/M7LOhFmRc/1R+kBtz7JFGdZm/COotIdvQoXpTqP/1uqEUmCb/QWoGLMwO5ANcHzxdY48IGP5+J+zKOTBFZ4Pid+GTM+Wq12MV/H86xEJptBa6T+p3kgpwLedManBHC2GgNrFpoN2xnrMz9WFWX/8/ygSBkavq2Uv7FdCsLEYLu9LLIvAU0bNRDtzYl+/vXmjpIvuJFYjmI0im6QEYqnIeMsNjXG4vIutIGHijeAG/9EDBozKV5cldkHbLxHh25vT+ZEzbhXlqvpzKJwcEgfNwLAKFeo0/pvEE10XDB+EXRTXtSzJozQKFFAJhMxYkVaCW+E9AL7tMeU8acxidHqzb6lX4691UsDpy/LLRmT+epgW56+5Cw8tB4kMUv6s9lh3eRKbyGs+H/4mQMaYzPTf2OOdokEn+zzgvoD3FqNKk8QqGAXVsqcGdXrT62fSPkR2vROFi68A6se86UxRUk4cajfPyCC4G5wDhD+zNq4jodQ4u4n/m37Lr36n4LIAAsVr02dFi9AiwA81MYs2rm4eDlDNmdMRvEKRHfBwW5DdMNp0jPFZMeARqF/wL4XBfd+EMLBfMzpH5GH6NaW+1vrvMdg+VxDzatk3MXgO3ro3P/DpcC6+Mo4MySJhKJhSR01SGGGp5hPWmrrUgrv3lDnP+HhcI3nt3YqBoVAVTBAQT5iuhTg8nvPtd8ZeYj6w1x6RqGUBrSku7+N1+BaasZvjTk64RoIDlL8brpEcJx3OmY7jLoZsswdtmhfC/G21llXhITOwmvRDDeTTPbyASOa16cF5/A1fZAidJpqju3wYAy9avPR1ya6eNp9K8XYrrtuxlqi+bDKwlfrYdR0RRiKRVTLOH85+ZY7XSmzRpfZBJjaTa81VDcJHpZnZnSQLASGYW9l51ZV/h7eVzTi3Hv6hUsgc/51AqJRTkpbFVLXXszoBL8nBX0u/0jBLT8nH+fJePbrwURT58OY+UieRjd1vs04w0VG5VN2U6MoGZkQzKN/ptz0Q366dxoTGmj7i1NQGHi9GgnquXFYdrCfZBmeb7s0T6yrdlZH5cZuwHFyIJ/kAtGsTg0xH5taAAq44BAk1CPk9KVVbqQzrCUiFdF/6gtlPQ8bHHc1G1W92MXGZ5HEHftyLYs8mbD/9xYRUWkHmlM0zC2ilJlnNgV4bfALpQghxOUoZL7VTqtCHIaQSXm+YUMnpkXybnV+A6xlm2CVy8fn0Xlm2XRa0+zzOa21JWWmixfiPMSCZ7qA4rS93VN3pkpF1s5TonQjisHf7iU9ZGvUPOAKZcR1pbeVf/Ul7OhepGCaId9wOtqo7pJ7yLcBZ0pFkOF28y4zEI/kcUNmutBHaQpBdNM8vjCS6HZRokkeo88TBAjGyG7SR+6vUgTcyK9Imalj0kuxz0wmK+byQU11AiJFk/ya5dNduRClcnU64yGu/ieWSeOos1t3ep+RPIWQ2pyTYVbZltTbsb7NiwSi3AV+8KLWk7LxCnfZUetEM8ThnsSoGH38/nyAwFguJp8FjvlHtcWZuU4hPva0rHfr0UhOOJ/F6vS62FW7KzkmRll2HEc7oUq4fyi5T70Vl7YVIfsPHUCdHesf9Lk7WNVWO75JDkYbMI8TOW8JKVtLY9d6UJRITO8oKo0xS+o99Yy04iniGHAaGj88kEWgwv0OrHdY/nr76DOGNS59hXCGXzTKUvDl9iKpLSWYN1lxIeyywdNpTkhay74w2jFT6NS8qkjo5CxA1yfSYwp6AJIZNKIeEK5PJAW7ORgWgwp0VgzYpqovMrWxbu+DGZ6Lhie1RAqpzm8VUzKJOH3mCzWuTOLsN3VT/dv2eeYe9UjbR8YTBsLz7q60VN1sU51k+um1f8JxD5pPhbhSC8rRaB454tmh6YUWrJI3+GWY0qeWioj/tbkYITOkJaeuGt4JrJvHA+l0Gu7kY7XOaa05alMnRWVCXqFgLIwSY4uF59Ue5SU4QKuc/HamDxbr0x6csCetXGoP7Qn1Bk/J9DsynO/UD6iZ1Hyrz+jit0hDCwi/E9OjgKTbB3ZQKQ/0ZOvevfNHG0NK4Aj3Cp7NpRk07RT1i/S0EL93Ag8GRgKI9CfpajKyK6+Jj/PI1KO5/85VAwz2AwzP8FTBb075IxCXv6T9RVvWT2tUaqxDS92zrGUbWzUYk9mSs82pECH+fkqsDt93VW++4YsR/dHCYcQSYTO/KaBMDj9LSD/J/+z20Kq8XvZUAIHtm9hRPP3ItbuAu2Hm5lkPs92pd7kCxgRs0xOVBnZ13ccdA0aunrwv9SdqElJRC3g+oCu+nXyCgmXUs9yMjTMAIHfxZV+aPKcZeUBWt057Xo85Ks1Ir5gzEHCWqZEhrLZMuF11ziGtFQUds/EESajhagzcKsxamcSZxGth4UII+adPhQkUnx2WyN+4YWR+r3f8MnkyGFuR4zjzxJS8WsQYR5PTyRaD9ixa6Mh741nBHbzfjXHskGDq179xaRNrCIB1z1xRfWfjqw2pHc1zk9xlPpL8sQWAIuETZZhbnmL54rceXVNRvUiKrrqIkeogsl0XXb17ylNb0f4GA9Wd44vffEG8FSZGHEL2fbaTGRcSiCeA8PmA/f6Hz8HCS76fXUHwgwkzSwlI71ekZ7Fapmlk/KC+Hs8hUcw3N2LN5LhkVYyizYFl/uPeVP5lsoJHhhfWvvSWruCUW1ZcJOeuTbrDgywJ/qG07gZJplnTvLcYdNaH0KMYOYMGX+rB4NGPFmQsNaIwlWrfCezxre8zXBrsMT+edVLbLqN1BqB76JH4BvZTqUIMfGwPGEn+EnmTV86fPBaYbFL3DFEhjB45CewkXEAtJxk4/Ms2pPXnaRqdky0HOYdcUcE2zcXq4vaIvW2/v0nHFJH2XXe22ueDmq/18XGtELSq85j9X8q0tcNSSKJIX8FTuJF/Pf8j5PhqG2u+osvsLxYrvvfeVJL+4tkcXcr9JV7v0ERmj/X6fM3NC4j6dS1+9Umr2oPavqiAydTZPLMNRGY23LO9zAVDly7jD+70G5TPPLdhRIl4WxcYjLnM+SNcJ26FOrkrISUtPObIz5Zb3AG612krnpy15RMW+1cQjlnWFI6538qky9axd2oJmHIHP08KyP0ubGO+TQNOYuv2uh17yCIvR8VcStw7o1g0NM60sk+8Tq7YfIBJrtp53GkvzXH7OA0p8/n/u1satf/VJhtR1l8Wa6Gmaug7haSpaCaYQax6ta0mkutlb+eAOSG1aobM81D9A4iS1RRlzBBoVX6tU1S6WE2N9ORY6DfeLRC4l9Rvr5h95XDWB2mR1d4WFudpsgVYwiTwT31ljskD8ZyDOlm5DkGh9N/UB/0AI5Xvb8ZBmai2hQ4BWMqFwYnzxwB26YHSOv9WgY3JXnvoN+2R4rqGVh/LLDMtpFP+SpMGJNWvbIl5SOodbCczW2RKleksPoUeGEzrjtKHVdtZA+kfqO+rVx/iclCqwoopepvJpSTDjT+b9GWylGRF8EDbGlw6eUzmJM95Ovoz+kwLX3c2fTjFeYEsE7vUZm3mqdGJuKh2w9/QGSaqRHs99aScGOdDqkFcACoqdbBoQqqjamhH6Q9ng39JCg3lrGJwd50Qk9ovnqBTr8MME7Ps2wiVfygUmPoUBJJfJWX5Nda0nuncbFkA=="));
}

});
parcelRegister("3qhZu", function(module, exports) {

$parcel$export(module.exports, "read_compressed_payload", function () { return $27e1c16409ffff0a$export$671d8b4ebc0c42ad; });
$parcel$export(module.exports, "read_member_array", function () { return $27e1c16409ffff0a$export$9303bf4e1ede4914; });
$parcel$export(module.exports, "read_mapped_map", function () { return $27e1c16409ffff0a$export$824d00fb01c38bd9; });
$parcel$export(module.exports, "read_emoji_trie", function () { return $27e1c16409ffff0a$export$d7b24c6ce369e1b7; });
/**
 * MIT License
 *
 * Copyright (c) 2021 Andrew Raffensperger
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 * This is a near carbon-copy of the original source (link below) with the
 * TypeScript typings added and a few tweaks to make it ES3-compatible.
 *
 * See: https://github.com/adraffy/ens-normalize.js
 */ // https://github.com/behnammodi/polyfill/blob/master/array.polyfill.js
function $27e1c16409ffff0a$var$flat(array, depth) {
    if (depth == null) depth = 1;
    const result = [];
    const forEach = result.forEach;
    const flatDeep = function(arr, depth) {
        forEach.call(arr, function(val) {
            if (depth > 0 && Array.isArray(val)) flatDeep(val, depth - 1);
            else result.push(val);
        });
    };
    flatDeep(array, depth);
    return result;
}
function $27e1c16409ffff0a$var$fromEntries(array) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const value = array[i];
        result[value[0]] = value[1];
    }
    return result;
}
function $27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes) {
    let pos = 0;
    function u16() {
        return bytes[pos++] << 8 | bytes[pos++];
    }
    // decode the frequency table
    let symbol_count = u16();
    let total = 1;
    let acc = [
        0,
        1
    ]; // first symbol has frequency 1
    for(let i = 1; i < symbol_count; i++)acc.push(total += u16());
    // skip the sized-payload that the last 3 symbols index into
    let skip = u16();
    let pos_payload = pos;
    pos += skip;
    let read_width = 0;
    let read_buffer = 0;
    function read_bit() {
        if (read_width == 0) {
            // this will read beyond end of buffer
            // but (undefined|0) => zero pad
            read_buffer = read_buffer << 8 | bytes[pos++];
            read_width = 8;
        }
        return read_buffer >> --read_width & 1;
    }
    const N = 31;
    const FULL = Math.pow(2, N);
    const HALF = FULL >>> 1;
    const QRTR = HALF >> 1;
    const MASK = FULL - 1;
    // fill register
    let register = 0;
    for(let i = 0; i < N; i++)register = register << 1 | read_bit();
    let symbols = [];
    let low = 0;
    let range = FULL; // treat like a float
    while(true){
        let value = Math.floor(((register - low + 1) * total - 1) / range);
        let start = 0;
        let end = symbol_count;
        while(end - start > 1){
            let mid = start + end >>> 1;
            if (value < acc[mid]) end = mid;
            else start = mid;
        }
        if (start == 0) break; // first symbol is end mark
        symbols.push(start);
        let a = low + Math.floor(range * acc[start] / total);
        let b = low + Math.floor(range * acc[start + 1] / total) - 1;
        while(((a ^ b) & HALF) == 0){
            register = register << 1 & MASK | read_bit();
            a = a << 1 & MASK;
            b = b << 1 & MASK | 1;
        }
        while(a & ~b & QRTR){
            register = register & HALF | register << 1 & MASK >>> 1 | read_bit();
            a = a << 1 ^ HALF;
            b = (b ^ HALF) << 1 | HALF | 1;
        }
        low = a;
        range = 1 + b - a;
    }
    let offset = symbol_count - 4;
    return symbols.map((x)=>{
        switch(x - offset){
            case 3:
                return offset + 0x10100 + (bytes[pos_payload++] << 16 | bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 2:
                return offset + 0x100 + (bytes[pos_payload++] << 8 | bytes[pos_payload++]);
            case 1:
                return offset + bytes[pos_payload++];
            default:
                return x - 1;
        }
    });
}
function $27e1c16409ffff0a$export$2cda812f22276871(v) {
    let pos = 0;
    return ()=>v[pos++];
}
function $27e1c16409ffff0a$export$671d8b4ebc0c42ad(bytes) {
    return $27e1c16409ffff0a$export$2cda812f22276871($27e1c16409ffff0a$export$956eeed0f8f2ceff(bytes));
}
function $27e1c16409ffff0a$export$a785de3a2a8dd1aa(i) {
    return i & 1 ? ~i >> 1 : i >> 1;
}
function $27e1c16409ffff0a$var$read_counts(n, next) {
    let v = Array(n);
    for(let i = 0; i < n; i++)v[i] = 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_ascending(n, next) {
    let v = Array(n);
    for(let i = 0, x = -1; i < n; i++)v[i] = x += 1 + next();
    return v;
}
function $27e1c16409ffff0a$var$read_deltas(n, next) {
    let v = Array(n);
    for(let i = 0, x = 0; i < n; i++)v[i] = x += $27e1c16409ffff0a$export$a785de3a2a8dd1aa(next());
    return v;
}
function $27e1c16409ffff0a$export$9303bf4e1ede4914(next, lookup) {
    let v = $27e1c16409ffff0a$var$read_ascending(next(), next);
    let n = next();
    let vX = $27e1c16409ffff0a$var$read_ascending(n, next);
    let vN = $27e1c16409ffff0a$var$read_counts(n, next);
    for(let i = 0; i < n; i++)for(let j = 0; j < vN[i]; j++)v.push(vX[i] + j);
    return lookup ? v.map((x)=>lookup[x]) : v;
}
function $27e1c16409ffff0a$export$824d00fb01c38bd9(next) {
    let ret = [];
    while(true){
        let w = next();
        if (w == 0) break;
        ret.push($27e1c16409ffff0a$var$read_linear_table(w, next));
    }
    while(true){
        let w = next() - 1;
        if (w < 0) break;
        ret.push($27e1c16409ffff0a$var$read_replacement_table(w, next));
    }
    return $27e1c16409ffff0a$var$fromEntries($27e1c16409ffff0a$var$flat(ret));
}
function $27e1c16409ffff0a$export$e9011071590ab431(next) {
    let v = [];
    while(true){
        let i = next();
        if (i == 0) break;
        v.push(i);
    }
    return v;
}
function $27e1c16409ffff0a$var$read_transposed(n, w, next) {
    let m = Array(n).fill(undefined).map(()=>[]);
    for(let i = 0; i < w; i++)$27e1c16409ffff0a$var$read_deltas(n, next).forEach((x, j)=>m[j].push(x));
    return m;
}
function $27e1c16409ffff0a$var$read_linear_table(w, next) {
    let dx = 1 + next();
    let dy = next();
    let vN = $27e1c16409ffff0a$export$e9011071590ab431(next);
    let m = $27e1c16409ffff0a$var$read_transposed(vN.length, 1 + w, next);
    return $27e1c16409ffff0a$var$flat(m.map((v, i)=>{
        const x = v[0], ys = v.slice(1);
        //let [x, ...ys] = v;
        //return Array(vN[i]).fill().map((_, j) => {
        return Array(vN[i]).fill(undefined).map((_, j)=>{
            let j_dy = j * dy;
            return [
                x + j * dx,
                ys.map((y)=>y + j_dy)
            ];
        });
    }));
}
function $27e1c16409ffff0a$var$read_replacement_table(w, next) {
    let n = 1 + next();
    let m = $27e1c16409ffff0a$var$read_transposed(n, 1 + w, next);
    return m.map((v)=>[
            v[0],
            v.slice(1)
        ]);
}
function $27e1c16409ffff0a$export$d7b24c6ce369e1b7(next) {
    let sorted = $27e1c16409ffff0a$export$9303bf4e1ede4914(next).sort((a, b)=>a - b);
    return read();
    function read() {
        let branches = [];
        while(true){
            let keys = $27e1c16409ffff0a$export$9303bf4e1ede4914(next, sorted);
            if (keys.length == 0) break;
            branches.push({
                set: new Set(keys),
                node: read()
            });
        }
        branches.sort((a, b)=>b.set.size - a.set.size); // sort by likelihood
        let temp = next();
        let valid = temp % 3;
        temp = temp / 3 | 0;
        let fe0f = !!(temp & 1);
        temp >>= 1;
        let save = temp == 1;
        let check = temp == 2;
        return {
            branches: branches,
            valid: valid,
            fe0f: fe0f,
            save: save,
            check: check
        };
    }
}

});




parcelRegister("2GUlC", function(module, exports) {

$parcel$export(module.exports, "_fetchData", function () { return $1f5b367caa9efc4a$export$e37fa27017c6c012; });
$parcel$export(module.exports, "fetchJson", function () { return $1f5b367caa9efc4a$export$6d71b655afe1638d; });
$parcel$export(module.exports, "poll", function () { return $1f5b367caa9efc4a$export$e0c10349b2c5e1d4; });

var $2bJst = parcelRequire("2bJst");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $aCHl8 = parcelRequire("aCHl8");

var $8bxC3 = parcelRequire("8bxC3");

var $jvwaW = parcelRequire("jvwaW");

var $4usEz = parcelRequire("4usEz");
"use strict";
var $1f5b367caa9efc4a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $1f5b367caa9efc4a$var$logger = new (0, $8bxC3.Logger)((0, $jvwaW.version));
function $1f5b367caa9efc4a$var$staller(duration) {
    return new Promise((resolve)=>{
        setTimeout(resolve, duration);
    });
}
function $1f5b367caa9efc4a$var$bodyify(value, type) {
    if (value == null) return null;
    if (typeof value === "string") return value;
    if ((0, $ApLZa.isBytesLike)(value)) {
        if (type && (type.split("/")[0] === "text" || type.split(";")[0].trim() === "application/json")) try {
            return (0, $aCHl8.toUtf8String)(value);
        } catch (error) {}
        return (0, $ApLZa.hexlify)(value);
    }
    return value;
}
function $1f5b367caa9efc4a$var$unpercent(value) {
    return (0, $aCHl8.toUtf8Bytes)(value.replace(/%([0-9a-f][0-9a-f])/gi, (all, code)=>{
        return String.fromCharCode(parseInt(code, 16));
    }));
}
function $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processFunc) {
    // How many times to retry in the event of a throttle
    const attemptLimit = typeof connection === "object" && connection.throttleLimit != null ? connection.throttleLimit : 12;
    $1f5b367caa9efc4a$var$logger.assertArgument(attemptLimit > 0 && attemptLimit % 1 === 0, "invalid connection throttle limit", "connection.throttleLimit", attemptLimit);
    const throttleCallback = typeof connection === "object" ? connection.throttleCallback : null;
    const throttleSlotInterval = typeof connection === "object" && typeof connection.throttleSlotInterval === "number" ? connection.throttleSlotInterval : 100;
    $1f5b367caa9efc4a$var$logger.assertArgument(throttleSlotInterval > 0 && throttleSlotInterval % 1 === 0, "invalid connection throttle slot interval", "connection.throttleSlotInterval", throttleSlotInterval);
    const errorPassThrough = typeof connection === "object" ? !!connection.errorPassThrough : false;
    const headers = {};
    let url = null;
    // @TODO: Allow ConnectionInfo to override some of these values
    const options = {
        method: "GET"
    };
    let allow304 = false;
    let timeout = 120000;
    if (typeof connection === "string") url = connection;
    else if (typeof connection === "object") {
        if (connection == null || connection.url == null) $1f5b367caa9efc4a$var$logger.throwArgumentError("missing URL", "connection.url", connection);
        url = connection.url;
        if (typeof connection.timeout === "number" && connection.timeout > 0) timeout = connection.timeout;
        if (connection.headers) for(const key in connection.headers){
            headers[key.toLowerCase()] = {
                key: key,
                value: String(connection.headers[key])
            };
            if ([
                "if-none-match",
                "if-modified-since"
            ].indexOf(key.toLowerCase()) >= 0) allow304 = true;
        }
        options.allowGzip = !!connection.allowGzip;
        if (connection.user != null && connection.password != null) {
            if (url.substring(0, 6) !== "https:" && connection.allowInsecureAuthentication !== true) $1f5b367caa9efc4a$var$logger.throwError("basic authentication requires a secure https url", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                argument: "url",
                url: url,
                user: connection.user,
                password: "[REDACTED]"
            });
            const authorization = connection.user + ":" + connection.password;
            headers["authorization"] = {
                key: "Authorization",
                value: "Basic " + (0, $2bJst.encode)((0, $aCHl8.toUtf8Bytes)(authorization))
            };
        }
        if (connection.skipFetchSetup != null) options.skipFetchSetup = !!connection.skipFetchSetup;
        if (connection.fetchOptions != null) options.fetchOptions = (0, $i6lOf.shallowCopy)(connection.fetchOptions);
    }
    const reData = new RegExp("^data:([^;:]*)?(;base64)?,(.*)$", "i");
    const dataMatch = url ? url.match(reData) : null;
    if (dataMatch) try {
        const response = {
            statusCode: 200,
            statusMessage: "OK",
            headers: {
                "content-type": dataMatch[1] || "text/plain"
            },
            body: dataMatch[2] ? (0, $2bJst.decode)(dataMatch[3]) : $1f5b367caa9efc4a$var$unpercent(dataMatch[3])
        };
        let result = response.body;
        if (processFunc) result = processFunc(response.body, response);
        return Promise.resolve(result);
    } catch (error) {
        $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
            body: $1f5b367caa9efc4a$var$bodyify(dataMatch[1], dataMatch[2]),
            error: error,
            requestBody: null,
            requestMethod: "GET",
            url: url
        });
    }
    if (body) {
        options.method = "POST";
        options.body = body;
        if (headers["content-type"] == null) headers["content-type"] = {
            key: "Content-Type",
            value: "application/octet-stream"
        };
        if (headers["content-length"] == null) headers["content-length"] = {
            key: "Content-Length",
            value: String(body.length)
        };
    }
    const flatHeaders = {};
    Object.keys(headers).forEach((key)=>{
        const header = headers[key];
        flatHeaders[header.key] = header.value;
    });
    options.headers = flatHeaders;
    const runningTimeout = function() {
        let timer = null;
        const promise = new Promise(function(resolve, reject) {
            if (timeout) timer = setTimeout(()=>{
                if (timer == null) return;
                timer = null;
                reject($1f5b367caa9efc4a$var$logger.makeError("timeout", (0, $8bxC3.Logger).errors.TIMEOUT, {
                    requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                    requestMethod: options.method,
                    timeout: timeout,
                    url: url
                }));
            }, timeout);
        });
        const cancel = function() {
            if (timer == null) return;
            clearTimeout(timer);
            timer = null;
        };
        return {
            promise: promise,
            cancel: cancel
        };
    }();
    const runningFetch = function() {
        return $1f5b367caa9efc4a$var$__awaiter(this, void 0, void 0, function*() {
            for(let attempt = 0; attempt < attemptLimit; attempt++){
                let response = null;
                try {
                    response = yield (0, $4usEz.getUrl)(url, options);
                    if (attempt < attemptLimit) {
                        if (response.statusCode === 301 || response.statusCode === 302) {
                            // Redirection; for now we only support absolute locataions
                            const location = response.headers.location || "";
                            if (options.method === "GET" && location.match(/^https:/)) {
                                url = response.headers.location;
                                continue;
                            }
                        } else if (response.statusCode === 429) {
                            // Exponential back-off throttling
                            let tryAgain = true;
                            if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                            if (tryAgain) {
                                let stall = 0;
                                const retryAfter = response.headers["retry-after"];
                                if (typeof retryAfter === "string" && retryAfter.match(/^[1-9][0-9]*$/)) stall = parseInt(retryAfter) * 1000;
                                else stall = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                                //console.log("Stalling 429");
                                yield $1f5b367caa9efc4a$var$staller(stall);
                                continue;
                            }
                        }
                    }
                } catch (error) {
                    response = error.response;
                    if (response == null) {
                        runningTimeout.cancel();
                        $1f5b367caa9efc4a$var$logger.throwError("missing response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                            requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                            requestMethod: options.method,
                            serverError: error,
                            url: url
                        });
                    }
                }
                let body = response.body;
                if (allow304 && response.statusCode === 304) body = null;
                else if (!errorPassThrough && (response.statusCode < 200 || response.statusCode >= 300)) {
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("bad response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                        status: response.statusCode,
                        headers: response.headers,
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                if (processFunc) try {
                    const result = yield processFunc(body, response);
                    runningTimeout.cancel();
                    return result;
                } catch (error) {
                    // Allow the processFunc to trigger a throttle
                    if (error.throttleRetry && attempt < attemptLimit) {
                        let tryAgain = true;
                        if (throttleCallback) tryAgain = yield throttleCallback(attempt, url);
                        if (tryAgain) {
                            const timeout = throttleSlotInterval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                            //console.log("Stalling callback");
                            yield $1f5b367caa9efc4a$var$staller(timeout);
                            continue;
                        }
                    }
                    runningTimeout.cancel();
                    $1f5b367caa9efc4a$var$logger.throwError("processing response error", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                        body: $1f5b367caa9efc4a$var$bodyify(body, response.headers ? response.headers["content-type"] : null),
                        error: error,
                        requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                        requestMethod: options.method,
                        url: url
                    });
                }
                runningTimeout.cancel();
                // If we had a processFunc, it either returned a T or threw above.
                // The "body" is now a Uint8Array.
                return body;
            }
            return $1f5b367caa9efc4a$var$logger.throwError("failed response", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                requestBody: $1f5b367caa9efc4a$var$bodyify(options.body, flatHeaders["content-type"]),
                requestMethod: options.method,
                url: url
            });
        });
    }();
    return Promise.race([
        runningTimeout.promise,
        runningFetch
    ]);
}
function $1f5b367caa9efc4a$export$6d71b655afe1638d(connection, json, processFunc) {
    let processJsonFunc = (value, response)=>{
        let result = null;
        if (value != null) try {
            result = JSON.parse((0, $aCHl8.toUtf8String)(value));
        } catch (error) {
            $1f5b367caa9efc4a$var$logger.throwError("invalid JSON", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                body: value,
                error: error
            });
        }
        if (processFunc) result = processFunc(result, response);
        return result;
    };
    // If we have json to send, we must
    // - add content-type of application/json (unless already overridden)
    // - convert the json to bytes
    let body = null;
    if (json != null) {
        body = (0, $aCHl8.toUtf8Bytes)(json);
        // Create a connection with the content-type set for JSON
        const updated = typeof connection === "string" ? {
            url: connection
        } : (0, $i6lOf.shallowCopy)(connection);
        if (updated.headers) {
            const hasContentType = Object.keys(updated.headers).filter((k)=>k.toLowerCase() === "content-type").length !== 0;
            if (!hasContentType) {
                updated.headers = (0, $i6lOf.shallowCopy)(updated.headers);
                updated.headers["content-type"] = "application/json";
            }
        } else updated.headers = {
            "content-type": "application/json"
        };
        connection = updated;
    }
    return $1f5b367caa9efc4a$export$e37fa27017c6c012(connection, body, processJsonFunc);
}
function $1f5b367caa9efc4a$export$e0c10349b2c5e1d4(func, options) {
    if (!options) options = {};
    options = (0, $i6lOf.shallowCopy)(options);
    if (options.floor == null) options.floor = 0;
    if (options.ceiling == null) options.ceiling = 10000;
    if (options.interval == null) options.interval = 250;
    return new Promise(function(resolve, reject) {
        let timer = null;
        let done = false;
        // Returns true if cancel was successful. Unsuccessful cancel means we're already done.
        const cancel = ()=>{
            if (done) return false;
            done = true;
            if (timer) clearTimeout(timer);
            return true;
        };
        if (options.timeout) timer = setTimeout(()=>{
            if (cancel()) reject(new Error("timeout"));
        }, options.timeout);
        const retryLimit = options.retryLimit;
        let attempt = 0;
        function check() {
            return func().then(function(result) {
                // If we have a result, or are allowed null then we're done
                if (result !== undefined) {
                    if (cancel()) resolve(result);
                } else if (options.oncePoll) options.oncePoll.once("poll", check);
                else if (options.onceBlock) options.onceBlock.once("block", check);
                else if (!done) {
                    attempt++;
                    if (attempt > retryLimit) {
                        if (cancel()) reject(new Error("retry limit reached"));
                        return;
                    }
                    let timeout = options.interval * parseInt(String(Math.random() * Math.pow(2, attempt)));
                    if (timeout < options.floor) timeout = options.floor;
                    if (timeout > options.ceiling) timeout = options.ceiling;
                    setTimeout(check, timeout);
                }
                return null;
            }, function(error) {
                if (cancel()) reject(error);
            });
        }
        check();
    });
}

});
parcelRegister("jvwaW", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e339deefa12d3888$export$83d89fbfd8236492; });
const $e339deefa12d3888$export$83d89fbfd8236492 = "web/5.7.1";

});

parcelRegister("4usEz", function(module, exports) {

$parcel$export(module.exports, "getUrl", function () { return $345030b65075326d$export$94df0e59ebebf4a7; });

var $ApLZa = parcelRequire("ApLZa");
"use strict";
var $345030b65075326d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $345030b65075326d$export$94df0e59ebebf4a7(href, options) {
    return $345030b65075326d$var$__awaiter(this, void 0, void 0, function*() {
        if (options == null) options = {};
        const request = {
            method: options.method || "GET",
            headers: options.headers || {},
            body: options.body || undefined
        };
        if (options.skipFetchSetup !== true) {
            request.mode = "cors"; // no-cors, cors, *same-origin
            request.cache = "no-cache"; // *default, no-cache, reload, force-cache, only-if-cached
            request.credentials = "same-origin"; // include, *same-origin, omit
            request.redirect = "follow"; // manual, *follow, error
            request.referrer = "client"; // no-referrer, *client
        }
        if (options.fetchOptions != null) {
            const opts = options.fetchOptions;
            if (opts.mode) request.mode = opts.mode;
            if (opts.cache) request.cache = opts.cache;
            if (opts.credentials) request.credentials = opts.credentials;
            if (opts.redirect) request.redirect = opts.redirect;
            if (opts.referrer) request.referrer = opts.referrer;
        }
        const response = yield fetch(href, request);
        const body = yield response.arrayBuffer();
        const headers = {};
        if (response.headers.forEach) response.headers.forEach((value, key)=>{
            headers[key.toLowerCase()] = value;
        });
        else response.headers.keys().forEach((key)=>{
            headers[key.toLowerCase()] = response.headers.get(key);
        });
        return {
            headers: headers,
            statusCode: response.status,
            statusMessage: response.statusText,
            body: (0, $ApLZa.arrayify)(new Uint8Array(body))
        };
    });
}

});


parcelRegister("k5bHX", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $e9ed5b422bb4952f$export$83d89fbfd8236492; });
const $e9ed5b422bb4952f$export$83d89fbfd8236492 = "providers/5.7.2";

});

parcelRegister("31PiM", function(module, exports) {

$parcel$export(module.exports, "Formatter", function () { return $23494291de5f329b$export$a06636add2a09fd8; });
$parcel$export(module.exports, "isCommunityResourcable", function () { return $23494291de5f329b$export$3091239f5b20b896; });
$parcel$export(module.exports, "isCommunityResource", function () { return $23494291de5f329b$export$d93d5f61c2498b6; });
$parcel$export(module.exports, "showThrottleMessage", function () { return $23494291de5f329b$export$4c41bd49e82e82ab; });

var $7pv2A = parcelRequire("7pv2A");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $1WHFW = parcelRequire("1WHFW");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $23494291de5f329b$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $23494291de5f329b$export$a06636add2a09fd8 {
    constructor(){
        this.formats = this.getDefaultFormats();
    }
    getDefaultFormats() {
        const formats = {};
        const address = this.address.bind(this);
        const bigNumber = this.bigNumber.bind(this);
        const blockTag = this.blockTag.bind(this);
        const data = this.data.bind(this);
        const hash = this.hash.bind(this);
        const hex = this.hex.bind(this);
        const number = this.number.bind(this);
        const type = this.type.bind(this);
        const strictData = (v)=>{
            return this.data(v, true);
        };
        formats.transaction = {
            hash: hash,
            type: type,
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, null),
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            transactionIndex: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            from: address,
            // either (gasPrice) or (maxPriorityFeePerGas + maxFeePerGas)
            // must be set
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasLimit: bigNumber,
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            value: bigNumber,
            nonce: number,
            data: data,
            r: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            s: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.uint256),
            v: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            creates: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            raw: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data)
        };
        formats.transactionRequest = {
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            gasLimit: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            gasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxPriorityFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            maxFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            value: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            data: $23494291de5f329b$export$a06636add2a09fd8.allowNull(strictData),
            type: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            accessList: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.accessList.bind(this), null)
        };
        formats.receiptLog = {
            transactionIndex: number,
            blockNumber: number,
            transactionHash: hash,
            address: address,
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            data: data,
            logIndex: number,
            blockHash: hash
        };
        formats.receipt = {
            to: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            from: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.address, null),
            contractAddress: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, null),
            transactionIndex: number,
            // should be allowNull(hash), but broken-EIP-658 support is handled in receipt
            root: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            gasUsed: bigNumber,
            logsBloom: $23494291de5f329b$export$a06636add2a09fd8.allowNull(data),
            blockHash: hash,
            transactionHash: hash,
            logs: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.receiptLog.bind(this)),
            blockNumber: number,
            confirmations: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number, null),
            cumulativeGasUsed: bigNumber,
            effectiveGasPrice: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber),
            status: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            type: type
        };
        formats.block = {
            hash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            parentHash: hash,
            number: number,
            timestamp: number,
            nonce: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hex),
            difficulty: this.difficulty.bind(this),
            gasLimit: bigNumber,
            gasUsed: bigNumber,
            miner: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address),
            extraData: data,
            transactions: $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash)),
            baseFeePerGas: $23494291de5f329b$export$a06636add2a09fd8.allowNull(bigNumber)
        };
        formats.blockWithTransactions = (0, $i6lOf.shallowCopy)(formats.block);
        formats.blockWithTransactions.transactions = $23494291de5f329b$export$a06636add2a09fd8.allowNull($23494291de5f329b$export$a06636add2a09fd8.arrayOf(this.transactionResponse.bind(this)));
        formats.filter = {
            fromBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            toBlock: $23494291de5f329b$export$a06636add2a09fd8.allowNull(blockTag, undefined),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash, undefined),
            address: $23494291de5f329b$export$a06636add2a09fd8.allowNull(address, undefined),
            topics: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.topics.bind(this), undefined)
        };
        formats.filterLog = {
            blockNumber: $23494291de5f329b$export$a06636add2a09fd8.allowNull(number),
            blockHash: $23494291de5f329b$export$a06636add2a09fd8.allowNull(hash),
            transactionIndex: number,
            removed: $23494291de5f329b$export$a06636add2a09fd8.allowNull(this.boolean.bind(this)),
            address: address,
            data: $23494291de5f329b$export$a06636add2a09fd8.allowFalsish(data, "0x"),
            topics: $23494291de5f329b$export$a06636add2a09fd8.arrayOf(hash),
            transactionHash: hash,
            logIndex: number
        };
        return formats;
    }
    accessList(accessList) {
        return (0, $5LK3h.accessListify)(accessList || []);
    }
    // Requires a BigNumberish that is within the IEEE754 safe integer range; returns a number
    // Strict! Used on input.
    number(number) {
        if (number === "0x") return 0;
        return (0, $esOfL.BigNumber).from(number).toNumber();
    }
    type(number) {
        if (number === "0x" || number == null) return 0;
        return (0, $esOfL.BigNumber).from(number).toNumber();
    }
    // Strict! Used on input.
    bigNumber(value) {
        return (0, $esOfL.BigNumber).from(value);
    }
    // Requires a boolean, "true" or  "false"; returns a boolean
    boolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") {
            value = value.toLowerCase();
            if (value === "true") return true;
            if (value === "false") return false;
        }
        throw new Error("invalid boolean - " + value);
    }
    hex(value, strict) {
        if (typeof value === "string") {
            if (!strict && value.substring(0, 2) !== "0x") value = "0x" + value;
            if ((0, $ApLZa.isHexString)(value)) return value.toLowerCase();
        }
        return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
    }
    data(value, strict) {
        const result = this.hex(value, strict);
        if (result.length % 2 !== 0) throw new Error("invalid data; odd-length - " + value);
        return result;
    }
    // Requires an address
    // Strict! Used on input.
    address(value) {
        return (0, $7pv2A.getAddress)(value);
    }
    callAddress(value) {
        if (!(0, $ApLZa.isHexString)(value, 32)) return null;
        const address = (0, $7pv2A.getAddress)((0, $ApLZa.hexDataSlice)(value, 12));
        return address === (0, $1WHFW.AddressZero) ? null : address;
    }
    contractAddress(value) {
        return (0, $7pv2A.getContractAddress)(value);
    }
    // Strict! Used on input.
    blockTag(blockTag) {
        if (blockTag == null) return "latest";
        if (blockTag === "earliest") return "0x0";
        switch(blockTag){
            case "earliest":
                return "0x0";
            case "latest":
            case "pending":
            case "safe":
            case "finalized":
                return blockTag;
        }
        if (typeof blockTag === "number" || (0, $ApLZa.isHexString)(blockTag)) return (0, $ApLZa.hexValue)(blockTag);
        throw new Error("invalid blockTag");
    }
    // Requires a hash, optionally requires 0x prefix; returns prefixed lowercase hash.
    hash(value, strict) {
        const result = this.hex(value, strict);
        if ((0, $ApLZa.hexDataLength)(result) !== 32) return $23494291de5f329b$var$logger.throwArgumentError("invalid hash", "value", value);
        return result;
    }
    // Returns the difficulty as a number, or if too large (i.e. PoA network) null
    difficulty(value) {
        if (value == null) return null;
        const v = (0, $esOfL.BigNumber).from(value);
        try {
            return v.toNumber();
        } catch (error) {}
        return null;
    }
    uint256(value) {
        if (!(0, $ApLZa.isHexString)(value)) throw new Error("invalid uint256");
        return (0, $ApLZa.hexZeroPad)(value, 32);
    }
    _block(value, format) {
        if (value.author != null && value.miner == null) value.miner = value.author;
        // The difficulty may need to come from _difficulty in recursed blocks
        const difficulty = value._difficulty != null ? value._difficulty : value.difficulty;
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(format, value);
        result._difficulty = difficulty == null ? null : (0, $esOfL.BigNumber).from(difficulty);
        return result;
    }
    block(value) {
        return this._block(value, this.formats.block);
    }
    blockWithTransactions(value) {
        return this._block(value, this.formats.blockWithTransactions);
    }
    // Strict! Used on input.
    transactionRequest(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transactionRequest, value);
    }
    transactionResponse(transaction) {
        // Rename gas to gasLimit
        if (transaction.gas != null && transaction.gasLimit == null) transaction.gasLimit = transaction.gas;
        // Some clients (TestRPC) do strange things like return 0x0 for the
        // 0 address; correct this to be a real address
        if (transaction.to && (0, $esOfL.BigNumber).from(transaction.to).isZero()) transaction.to = "0x0000000000000000000000000000000000000000";
        // Rename input to data
        if (transaction.input != null && transaction.data == null) transaction.data = transaction.input;
        // If to and creates are empty, populate the creates from the transaction
        if (transaction.to == null && transaction.creates == null) transaction.creates = this.contractAddress(transaction);
        if ((transaction.type === 1 || transaction.type === 2) && transaction.accessList == null) transaction.accessList = [];
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.transaction, transaction);
        if (transaction.chainId != null) {
            let chainId = transaction.chainId;
            if ((0, $ApLZa.isHexString)(chainId)) chainId = (0, $esOfL.BigNumber).from(chainId).toNumber();
            result.chainId = chainId;
        } else {
            let chainId = transaction.networkId;
            // geth-etc returns chainId
            if (chainId == null && result.v == null) chainId = transaction.chainId;
            if ((0, $ApLZa.isHexString)(chainId)) chainId = (0, $esOfL.BigNumber).from(chainId).toNumber();
            if (typeof chainId !== "number" && result.v != null) {
                chainId = (result.v - 35) / 2;
                if (chainId < 0) chainId = 0;
                chainId = parseInt(chainId);
            }
            if (typeof chainId !== "number") chainId = 0;
            result.chainId = chainId;
        }
        // 0x0000... should actually be null
        if (result.blockHash && result.blockHash.replace(/0/g, "") === "x") result.blockHash = null;
        return result;
    }
    transaction(value) {
        return (0, $5LK3h.parse)(value);
    }
    receiptLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receiptLog, value);
    }
    receipt(value) {
        const result = $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.receipt, value);
        // RSK incorrectly implemented EIP-658, so we munge things a bit here for it
        if (result.root != null) {
            if (result.root.length <= 4) {
                // Could be 0x00, 0x0, 0x01 or 0x1
                const value = (0, $esOfL.BigNumber).from(result.root).toNumber();
                if (value === 0 || value === 1) {
                    // Make sure if both are specified, they match
                    if (result.status != null && result.status !== value) $23494291de5f329b$var$logger.throwArgumentError("alt-root-status/status mismatch", "value", {
                        root: result.root,
                        status: result.status
                    });
                    result.status = value;
                    delete result.root;
                } else $23494291de5f329b$var$logger.throwArgumentError("invalid alt-root-status", "value.root", result.root);
            } else if (result.root.length !== 66) // Must be a valid bytes32
            $23494291de5f329b$var$logger.throwArgumentError("invalid root hash", "value.root", result.root);
        }
        if (result.status != null) result.byzantium = true;
        return result;
    }
    topics(value) {
        if (Array.isArray(value)) return value.map((v)=>this.topics(v));
        else if (value != null) return this.hash(value, true);
        return null;
    }
    filter(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filter, value);
    }
    filterLog(value) {
        return $23494291de5f329b$export$a06636add2a09fd8.check(this.formats.filterLog, value);
    }
    static check(format, object) {
        const result = {};
        for(const key in format)try {
            const value = format[key](object[key]);
            if (value !== undefined) result[key] = value;
        } catch (error) {
            error.checkKey = key;
            error.checkValue = object[key];
            throw error;
        }
        return result;
    }
    // if value is null-ish, nullValue is returned
    static allowNull(format, nullValue) {
        return function(value) {
            if (value == null) return nullValue;
            return format(value);
        };
    }
    // If value is false-ish, replaceValue is returned
    static allowFalsish(format, replaceValue) {
        return function(value) {
            if (!value) return replaceValue;
            return format(value);
        };
    }
    // Requires an Array satisfying check
    static arrayOf(format) {
        return function(array) {
            if (!Array.isArray(array)) throw new Error("not an array");
            const result = [];
            array.forEach(function(value) {
                result.push(format(value));
            });
            return result;
        };
    }
}
function $23494291de5f329b$export$3091239f5b20b896(value) {
    return value && typeof value.isCommunityResource === "function";
}
function $23494291de5f329b$export$d93d5f61c2498b6(value) {
    return $23494291de5f329b$export$3091239f5b20b896(value) && value.isCommunityResource();
}
// Show the throttle message only once
let $23494291de5f329b$var$throttleMessage = false;
function $23494291de5f329b$export$4c41bd49e82e82ab() {
    if ($23494291de5f329b$var$throttleMessage) return;
    $23494291de5f329b$var$throttleMessage = true;
    console.log("========= NOTICE =========");
    console.log("Request-Rate Exceeded  (this message will not be repeated)");
    console.log("");
    console.log("The default API keys for each service are provided as a highly-throttled,");
    console.log("community resource for low-traffic projects and early prototyping.");
    console.log("");
    console.log("While your application will continue to function, we highly recommended");
    console.log("signing up for your own API keys to improve performance, increase your");
    console.log("request rate/limit and enable other perks, such as metrics and advanced APIs.");
    console.log("");
    console.log("For more details: https://docs.ethers.io/api-keys/");
    console.log("==========================");
}

});


parcelRegister("6Yx5T", function(module, exports) {

$parcel$export(module.exports, "AlchemyWebSocketProvider", function () { return $5142047284b3daba$export$f6c13301c7b76371; });
$parcel$export(module.exports, "AlchemyProvider", function () { return $5142047284b3daba$export$999cc40da3fbc6f; });

var $i6lOf = parcelRequire("i6lOf");

var $31PiM = parcelRequire("31PiM");

var $hZPNa = parcelRequire("hZPNa");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $5142047284b3daba$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// This key was provided to ethers.js by Alchemy to be used by the
// default provider, but it is recommended that for your own
// production environments, that you acquire your own API key at:
//   https://dashboard.alchemyapi.io
const $5142047284b3daba$var$defaultApiKey = "_gg7wSSi0KMBsdKnGVfHDueq6xMB9EkC";
class $5142047284b3daba$export$f6c13301c7b76371 extends (0, $hZPNa.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $5142047284b3daba$export$999cc40da3fbc6f(network, apiKey);
        const url = provider.connection.url.replace(/^http/i, "ws").replace(".alchemyapi.", ".ws.alchemyapi.");
        super(url, provider.network);
        (0, $i6lOf.defineReadOnly)(this, "apiKey", provider.apiKey);
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}
class $5142047284b3daba$export$999cc40da3fbc6f extends (0, $cLduf.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $5142047284b3daba$export$f6c13301c7b76371(network, apiKey);
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $5142047284b3daba$var$defaultApiKey;
        if (apiKey && typeof apiKey !== "string") $5142047284b3daba$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "eth-mainnet.alchemyapi.io/v2/";
                break;
            case "goerli":
                host = "eth-goerli.g.alchemy.com/v2/";
                break;
            case "matic":
                host = "polygon-mainnet.g.alchemy.com/v2/";
                break;
            case "maticmum":
                host = "polygon-mumbai.g.alchemy.com/v2/";
                break;
            case "arbitrum":
                host = "arb-mainnet.g.alchemy.com/v2/";
                break;
            case "arbitrum-goerli":
                host = "arb-goerli.g.alchemy.com/v2/";
                break;
            case "optimism":
                host = "opt-mainnet.g.alchemy.com/v2/";
                break;
            case "optimism-goerli":
                host = "opt-goerli.g.alchemy.com/v2/";
                break;
            default:
                $5142047284b3daba$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return {
            allowGzip: true,
            url: "https://" + host + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey === $5142047284b3daba$var$defaultApiKey) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
    }
    isCommunityResource() {
        return this.apiKey === $5142047284b3daba$var$defaultApiKey;
    }
}

});
parcelRegister("hZPNa", function(module, exports) {

$parcel$export(module.exports, "WebSocketProvider", function () { return $d1a04efa16266f30$export$bfafe629242f30bd; });

var $esOfL = parcelRequire("esOfL");

var $i6lOf = parcelRequire("i6lOf");

var $cSErQ = parcelRequire("cSErQ");

var $edLD6 = parcelRequire("edLD6");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $d1a04efa16266f30$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $d1a04efa16266f30$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
/**
 *  Notes:
 *
 *  This provider differs a bit from the polling providers. One main
 *  difference is how it handles consistency. The polling providers
 *  will stall responses to ensure a consistent state, while this
 *  WebSocket provider assumes the connected backend will manage this.
 *
 *  For example, if a polling provider emits an event which indicates
 *  the event occurred in blockhash XXX, a call to fetch that block by
 *  its hash XXX, if not present will retry until it is present. This
 *  can occur when querying a pool of nodes that are mildly out of sync
 *  with each other.
 */ let $d1a04efa16266f30$var$NextId = 1;
class $d1a04efa16266f30$export$bfafe629242f30bd extends (0, $cSErQ.JsonRpcProvider) {
    constructor(url, network){
        // This will be added in the future; please open an issue to expedite
        if (network === "any") $d1a04efa16266f30$var$logger.throwError("WebSocketProvider does not support 'any' network yet", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "network:any"
        });
        if (typeof url === "string") super(url, network);
        else super("_websocket", network);
        this._pollingInterval = -1;
        this._wsReady = false;
        if (typeof url === "string") (0, $i6lOf.defineReadOnly)(this, "_websocket", new (0, $edLD6.WebSocket)(this.connection.url));
        else (0, $i6lOf.defineReadOnly)(this, "_websocket", url);
        (0, $i6lOf.defineReadOnly)(this, "_requests", {});
        (0, $i6lOf.defineReadOnly)(this, "_subs", {});
        (0, $i6lOf.defineReadOnly)(this, "_subIds", {});
        (0, $i6lOf.defineReadOnly)(this, "_detectNetwork", super.detectNetwork());
        // Stall sending requests until the socket is open...
        this.websocket.onopen = ()=>{
            this._wsReady = true;
            Object.keys(this._requests).forEach((id)=>{
                this.websocket.send(this._requests[id].payload);
            });
        };
        this.websocket.onmessage = (messageEvent)=>{
            const data = messageEvent.data;
            const result = JSON.parse(data);
            if (result.id != null) {
                const id = String(result.id);
                const request = this._requests[id];
                delete this._requests[id];
                if (result.result !== undefined) {
                    request.callback(null, result.result);
                    this.emit("debug", {
                        action: "response",
                        request: JSON.parse(request.payload),
                        response: result.result,
                        provider: this
                    });
                } else {
                    let error = null;
                    if (result.error) {
                        error = new Error(result.error.message || "unknown error");
                        (0, $i6lOf.defineReadOnly)(error, "code", result.error.code || null);
                        (0, $i6lOf.defineReadOnly)(error, "response", data);
                    } else error = new Error("unknown error");
                    request.callback(error, undefined);
                    this.emit("debug", {
                        action: "response",
                        error: error,
                        request: JSON.parse(request.payload),
                        provider: this
                    });
                }
            } else if (result.method === "eth_subscription") {
                // Subscription...
                const sub = this._subs[result.params.subscription];
                if (sub) //this.emit.apply(this,                  );
                sub.processFunc(result.params.result);
            } else console.warn("this should not happen");
        };
        // This Provider does not actually poll, but we want to trigger
        // poll events for things that depend on them (like stalling for
        // block and transaction lookups)
        const fauxPoll = setInterval(()=>{
            this.emit("poll");
        }, 1000);
        if (fauxPoll.unref) fauxPoll.unref();
    }
    // Cannot narrow the type of _websocket, as that is not backwards compatible
    // so we add a getter and let the WebSocket be a public API.
    get websocket() {
        return this._websocket;
    }
    detectNetwork() {
        return this._detectNetwork;
    }
    get pollingInterval() {
        return 0;
    }
    resetEventsBlock(blockNumber) {
        $d1a04efa16266f30$var$logger.throwError("cannot reset events block on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "resetEventBlock"
        });
    }
    set pollingInterval(value) {
        $d1a04efa16266f30$var$logger.throwError("cannot set polling interval on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPollingInterval"
        });
    }
    poll() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            return null;
        });
    }
    set polling(value) {
        if (!value) return;
        $d1a04efa16266f30$var$logger.throwError("cannot set polling on WebSocketProvider", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "setPolling"
        });
    }
    send(method, params) {
        const rid = $d1a04efa16266f30$var$NextId++;
        return new Promise((resolve, reject)=>{
            function callback(error, result) {
                if (error) return reject(error);
                return resolve(result);
            }
            const payload = JSON.stringify({
                method: method,
                params: params,
                id: rid,
                jsonrpc: "2.0"
            });
            this.emit("debug", {
                action: "request",
                request: JSON.parse(payload),
                provider: this
            });
            this._requests[String(rid)] = {
                callback: callback,
                payload: payload
            };
            if (this._wsReady) this.websocket.send(payload);
        });
    }
    static defaultUrl() {
        return "ws://localhost:8546";
    }
    _subscribe(tag, param, processFunc) {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            let subIdPromise = this._subIds[tag];
            if (subIdPromise == null) {
                subIdPromise = Promise.all(param).then((param)=>{
                    return this.send("eth_subscribe", param);
                });
                this._subIds[tag] = subIdPromise;
            }
            const subId = yield subIdPromise;
            this._subs[subId] = {
                tag: tag,
                processFunc: processFunc
            };
        });
    }
    _startEvent(event) {
        switch(event.type){
            case "block":
                this._subscribe("block", [
                    "newHeads"
                ], (result)=>{
                    const blockNumber = (0, $esOfL.BigNumber).from(result.number).toNumber();
                    this._emitted.block = blockNumber;
                    this.emit("block", blockNumber);
                });
                break;
            case "pending":
                this._subscribe("pending", [
                    "newPendingTransactions"
                ], (result)=>{
                    this.emit("pending", result);
                });
                break;
            case "filter":
                this._subscribe(event.tag, [
                    "logs",
                    this._getFilter(event.filter)
                ], (result)=>{
                    if (result.removed == null) result.removed = false;
                    this.emit(event.filter, this.formatter.filterLog(result));
                });
                break;
            case "tx":
                {
                    const emitReceipt = (event)=>{
                        const hash = event.hash;
                        this.getTransactionReceipt(hash).then((receipt)=>{
                            if (!receipt) return;
                            this.emit(hash, receipt);
                        });
                    };
                    // In case it is already mined
                    emitReceipt(event);
                    // To keep things simple, we start up a single newHeads subscription
                    // to keep an eye out for transactions we are watching for.
                    // Starting a subscription for an event (i.e. "tx") that is already
                    // running is (basically) a nop.
                    this._subscribe("tx", [
                        "newHeads"
                    ], (result)=>{
                        this._events.filter((e)=>e.type === "tx").forEach(emitReceipt);
                    });
                    break;
                }
            // Nothing is needed
            case "debug":
            case "poll":
            case "willPoll":
            case "didPoll":
            case "error":
                break;
            default:
                console.log("unhandled:", event);
                break;
        }
    }
    _stopEvent(event) {
        let tag = event.tag;
        if (event.type === "tx") {
            // There are remaining transaction event listeners
            if (this._events.filter((e)=>e.type === "tx").length) return;
            tag = "tx";
        } else if (this.listenerCount(event.event)) // There are remaining event listeners
        return;
        const subId = this._subIds[tag];
        if (!subId) return;
        delete this._subIds[tag];
        subId.then((subId)=>{
            if (!this._subs[subId]) return;
            delete this._subs[subId];
            this.send("eth_unsubscribe", [
                subId
            ]);
        });
    }
    destroy() {
        return $d1a04efa16266f30$var$__awaiter(this, void 0, void 0, function*() {
            // Wait until we have connected before trying to disconnect
            if (this.websocket.readyState === (0, $edLD6.WebSocket).CONNECTING) yield new Promise((resolve)=>{
                this.websocket.onopen = function() {
                    resolve(true);
                };
                this.websocket.onerror = function() {
                    resolve(false);
                };
            });
            // Hangup
            // See: https://developer.mozilla.org/en-US/docs/Web/API/CloseEvent#Status_codes
            this.websocket.close(1000);
        });
    }
}

});
parcelRegister("cSErQ", function(module, exports) {

$parcel$export(module.exports, "JsonRpcSigner", function () { return $9609e75996f2bd40$export$5f7b5fca3508545a; });
$parcel$export(module.exports, "JsonRpcProvider", function () { return $9609e75996f2bd40$export$da28308012bf6748; });

var $oWESm = parcelRequire("oWESm");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");

var $i6lOf = parcelRequire("i6lOf");

var $aCHl8 = parcelRequire("aCHl8");

var $5LK3h = parcelRequire("5LK3h");

var $2GUlC = parcelRequire("2GUlC");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $lts60 = parcelRequire("lts60");
"use strict";
var $9609e75996f2bd40$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $9609e75996f2bd40$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $9609e75996f2bd40$var$errorGas = [
    "call",
    "estimateGas"
];
function $9609e75996f2bd40$var$spelunk(value, requireData) {
    if (value == null) return null;
    // These *are* the droids we're looking for.
    if (typeof value.message === "string" && value.message.match("reverted")) {
        const data = (0, $ApLZa.isHexString)(value.data) ? value.data : null;
        if (!requireData || data) return {
            message: value.message,
            data: data
        };
    }
    // Spelunk further...
    if (typeof value === "object") {
        for(const key in value){
            const result = $9609e75996f2bd40$var$spelunk(value[key], requireData);
            if (result) return result;
        }
        return null;
    }
    // Might be a JSON string we can further descend...
    if (typeof value === "string") try {
        return $9609e75996f2bd40$var$spelunk(JSON.parse(value), requireData);
    } catch (error) {}
    return null;
}
function $9609e75996f2bd40$var$checkError(method, error, params) {
    const transaction = params.transaction || params.signedTransaction;
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call") {
        const result = $9609e75996f2bd40$var$spelunk(error, true);
        if (result) return result.data;
        // Nothing descriptive..
        $9609e75996f2bd40$var$logger.throwError("missing revert data in call exception; Transaction reverted without a reason string", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
            data: "0x",
            transaction: transaction,
            error: error
        });
    }
    if (method === "estimateGas") {
        // Try to find something, with a preference on SERVER_ERROR body
        let result = $9609e75996f2bd40$var$spelunk(error.body, false);
        if (result == null) result = $9609e75996f2bd40$var$spelunk(error, false);
        // Found "reverted", this is a CALL_EXCEPTION
        if (result) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
            reason: result.message,
            method: method,
            transaction: transaction,
            error: error
        });
    }
    // @TODO: Should we spelunk for message too?
    let message = error.message;
    if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR && error.error && typeof error.error.message === "string") message = error.error.message;
    else if (typeof error.body === "string") message = error.body;
    else if (typeof error.responseText === "string") message = error.responseText;
    message = (message || "").toLowerCase();
    // "insufficient funds for gas * price + value + cost(data)"
    if (message.match(/insufficient funds|base fee exceeds gas limit|InsufficientFunds/i)) $9609e75996f2bd40$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "nonce too low"
    if (message.match(/nonce (is )?too low/i)) $9609e75996f2bd40$var$logger.throwError("nonce has already been used", (0, $8bxC3.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/replacement transaction underpriced|transaction gas price.*too low/i)) $9609e75996f2bd40$var$logger.throwError("replacement fee too low", (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "replacement transaction underpriced"
    if (message.match(/only replay-protected/i)) $9609e75996f2bd40$var$logger.throwError("legacy pre-eip-155 transactions not supported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
        error: error,
        method: method,
        transaction: transaction
    });
    if ($9609e75996f2bd40$var$errorGas.indexOf(method) >= 0 && message.match(/gas required exceeds allowance|always failing transaction|execution reverted|revert/)) $9609e75996f2bd40$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
function $9609e75996f2bd40$var$timer(timeout) {
    return new Promise(function(resolve) {
        setTimeout(resolve, timeout);
    });
}
function $9609e75996f2bd40$var$getResult(payload) {
    if (payload.error) {
        // @TODO: not any
        const error = new Error(payload.error.message);
        error.code = payload.error.code;
        error.data = payload.error.data;
        throw error;
    }
    return payload.result;
}
function $9609e75996f2bd40$var$getLowerCase(value) {
    if (value) return value.toLowerCase();
    return value;
}
const $9609e75996f2bd40$var$_constructorGuard = {};
class $9609e75996f2bd40$export$5f7b5fca3508545a extends (0, $oWESm.Signer) {
    constructor(constructorGuard, provider, addressOrIndex){
        super();
        if (constructorGuard !== $9609e75996f2bd40$var$_constructorGuard) throw new Error("do not call the JsonRpcSigner constructor directly; use provider.getSigner");
        (0, $i6lOf.defineReadOnly)(this, "provider", provider);
        if (addressOrIndex == null) addressOrIndex = 0;
        if (typeof addressOrIndex === "string") {
            (0, $i6lOf.defineReadOnly)(this, "_address", this.provider.formatter.address(addressOrIndex));
            (0, $i6lOf.defineReadOnly)(this, "_index", null);
        } else if (typeof addressOrIndex === "number") {
            (0, $i6lOf.defineReadOnly)(this, "_index", addressOrIndex);
            (0, $i6lOf.defineReadOnly)(this, "_address", null);
        } else $9609e75996f2bd40$var$logger.throwArgumentError("invalid address or index", "addressOrIndex", addressOrIndex);
    }
    connect(provider) {
        return $9609e75996f2bd40$var$logger.throwError("cannot alter JSON-RPC Signer connection", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "connect"
        });
    }
    connectUnchecked() {
        return new $9609e75996f2bd40$var$UncheckedJsonRpcSigner($9609e75996f2bd40$var$_constructorGuard, this.provider, this._address || this._index);
    }
    getAddress() {
        if (this._address) return Promise.resolve(this._address);
        return this.provider.send("eth_accounts", []).then((accounts)=>{
            if (accounts.length <= this._index) $9609e75996f2bd40$var$logger.throwError("unknown account #" + this._index, (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                operation: "getAddress"
            });
            return this.provider.formatter.address(accounts[this._index]);
        });
    }
    sendUncheckedTransaction(transaction) {
        transaction = (0, $i6lOf.shallowCopy)(transaction);
        const fromAddress = this.getAddress().then((address)=>{
            if (address) address = address.toLowerCase();
            return address;
        });
        // The JSON-RPC for eth_sendTransaction uses 90000 gas; if the user
        // wishes to use this, it is easy to specify explicitly, otherwise
        // we look it up for them.
        if (transaction.gasLimit == null) {
            const estimate = (0, $i6lOf.shallowCopy)(transaction);
            estimate.from = fromAddress;
            transaction.gasLimit = this.provider.estimateGas(estimate);
        }
        if (transaction.to != null) transaction.to = Promise.resolve(transaction.to).then((to)=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                if (to == null) return null;
                const address = yield this.provider.resolveName(to);
                if (address == null) $9609e75996f2bd40$var$logger.throwArgumentError("provided ENS name resolves to null", "tx.to", to);
                return address;
            }));
        return (0, $i6lOf.resolveProperties)({
            tx: (0, $i6lOf.resolveProperties)(transaction),
            sender: fromAddress
        }).then(({ tx: tx, sender: sender })=>{
            if (tx.from != null) {
                if (tx.from.toLowerCase() !== sender) $9609e75996f2bd40$var$logger.throwArgumentError("from address mismatch", "transaction", transaction);
            } else tx.from = sender;
            const hexTx = this.provider.constructor.hexlifyTransaction(tx, {
                from: true
            });
            return this.provider.send("eth_sendTransaction", [
                hexTx
            ]).then((hash)=>{
                return hash;
            }, (error)=>{
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected transaction", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "sendTransaction",
                    transaction: tx
                });
                return $9609e75996f2bd40$var$checkError("sendTransaction", error, hexTx);
            });
        });
    }
    signTransaction(transaction) {
        return $9609e75996f2bd40$var$logger.throwError("signing transactions is unsupported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "signTransaction"
        });
    }
    sendTransaction(transaction) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // This cannot be mined any earlier than any recent block
            const blockNumber = yield this.provider._getInternalBlockNumber(100 + 2 * this.provider.pollingInterval);
            // Send the transaction
            const hash = yield this.sendUncheckedTransaction(transaction);
            try {
                // Unfortunately, JSON-RPC only provides and opaque transaction hash
                // for a response, and we need the actual transaction, so we poll
                // for it; it should show up very quickly
                return yield (0, $2GUlC.poll)(()=>$9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
                        const tx = yield this.provider.getTransaction(hash);
                        if (tx === null) return undefined;
                        return this.provider._wrapTransaction(tx, hash, blockNumber);
                    }), {
                    oncePoll: this.provider
                });
            } catch (error) {
                error.transactionHash = hash;
                throw error;
            }
        });
    }
    signMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $aCHl8.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("personal_sign", [
                    (0, $ApLZa.hexlify)(data),
                    address.toLowerCase()
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "signMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _legacySignMessage(message) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const data = typeof message === "string" ? (0, $aCHl8.toUtf8Bytes)(message) : message;
            const address = yield this.getAddress();
            try {
                // https://github.com/ethereum/wiki/wiki/JSON-RPC#eth_sign
                return yield this.provider.send("eth_sign", [
                    address.toLowerCase(),
                    (0, $ApLZa.hexlify)(data)
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "_legacySignMessage",
                    from: address,
                    messageData: message
                });
                throw error;
            }
        });
    }
    _signTypedData(domain, types, value) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Populate any ENS names (in-place)
            const populated = yield (0, $cKR64.TypedDataEncoder).resolveNames(domain, types, value, (name)=>{
                return this.provider.resolveName(name);
            });
            const address = yield this.getAddress();
            try {
                return yield this.provider.send("eth_signTypedData_v4", [
                    address.toLowerCase(),
                    JSON.stringify((0, $cKR64.TypedDataEncoder).getPayload(populated.domain, types, populated.value))
                ]);
            } catch (error) {
                if (typeof error.message === "string" && error.message.match(/user denied/i)) $9609e75996f2bd40$var$logger.throwError("user rejected signing", (0, $8bxC3.Logger).errors.ACTION_REJECTED, {
                    action: "_signTypedData",
                    from: address,
                    messageData: {
                        domain: populated.domain,
                        types: types,
                        value: populated.value
                    }
                });
                throw error;
            }
        });
    }
    unlock(password) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            const provider = this.provider;
            const address = yield this.getAddress();
            return provider.send("personal_unlockAccount", [
                address.toLowerCase(),
                password,
                null
            ]);
        });
    }
}
class $9609e75996f2bd40$var$UncheckedJsonRpcSigner extends $9609e75996f2bd40$export$5f7b5fca3508545a {
    sendTransaction(transaction) {
        return this.sendUncheckedTransaction(transaction).then((hash)=>{
            return {
                hash: hash,
                nonce: null,
                gasLimit: null,
                gasPrice: null,
                data: null,
                value: null,
                chainId: null,
                confirmations: 0,
                from: null,
                wait: (confirmations)=>{
                    return this.provider.waitForTransaction(hash, confirmations);
                }
            };
        });
    }
}
const $9609e75996f2bd40$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true,
    type: true,
    accessList: true,
    maxFeePerGas: true,
    maxPriorityFeePerGas: true
};
class $9609e75996f2bd40$export$da28308012bf6748 extends (0, $lts60.BaseProvider) {
    constructor(url, network){
        let networkOrReady = network;
        // The network is unknown, query the JSON-RPC for it
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then((network)=>{
                    resolve(network);
                }, (error)=>{
                    reject(error);
                });
            }, 0);
        });
        super(networkOrReady);
        // Default URL
        if (!url) url = (0, $i6lOf.getStatic)(this.constructor, "defaultUrl")();
        if (typeof url === "string") (0, $i6lOf.defineReadOnly)(this, "connection", Object.freeze({
            url: url
        }));
        else (0, $i6lOf.defineReadOnly)(this, "connection", Object.freeze((0, $i6lOf.shallowCopy)(url)));
        this._nextId = 42;
    }
    get _cache() {
        if (this._eventLoopCache == null) this._eventLoopCache = {};
        return this._eventLoopCache;
    }
    static defaultUrl() {
        return "http://localhost:8545";
    }
    detectNetwork() {
        if (!this._cache["detectNetwork"]) {
            this._cache["detectNetwork"] = this._uncachedDetectNetwork();
            // Clear this cache at the beginning of the next event loop
            setTimeout(()=>{
                this._cache["detectNetwork"] = null;
            }, 0);
        }
        return this._cache["detectNetwork"];
    }
    _uncachedDetectNetwork() {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            yield $9609e75996f2bd40$var$timer(0);
            let chainId = null;
            try {
                chainId = yield this.send("eth_chainId", []);
            } catch (error) {
                try {
                    chainId = yield this.send("net_version", []);
                } catch (error) {}
            }
            if (chainId != null) {
                const getNetwork = (0, $i6lOf.getStatic)(this.constructor, "getNetwork");
                try {
                    return getNetwork((0, $esOfL.BigNumber).from(chainId).toNumber());
                } catch (error) {
                    return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                        chainId: chainId,
                        event: "invalidNetwork",
                        serverError: error
                    });
                }
            }
            return $9609e75996f2bd40$var$logger.throwError("could not detect network", (0, $8bxC3.Logger).errors.NETWORK_ERROR, {
                event: "noNetwork"
            });
        });
    }
    getSigner(addressOrIndex) {
        return new $9609e75996f2bd40$export$5f7b5fca3508545a($9609e75996f2bd40$var$_constructorGuard, this, addressOrIndex);
    }
    getUncheckedSigner(addressOrIndex) {
        return this.getSigner(addressOrIndex).connectUnchecked();
    }
    listAccounts() {
        return this.send("eth_accounts", []).then((accounts)=>{
            return accounts.map((a)=>this.formatter.address(a));
        });
    }
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        this.emit("debug", {
            action: "request",
            request: (0, $i6lOf.deepCopy)(request),
            provider: this
        });
        // We can expand this in the future to any call, but for now these
        // are the biggest wins and do not require any serializing parameters.
        const cache = [
            "eth_chainId",
            "eth_blockNumber"
        ].indexOf(method) >= 0;
        if (cache && this._cache[method]) return this._cache[method];
        const result = (0, $2GUlC.fetchJson)(this.connection, JSON.stringify(request), $9609e75996f2bd40$var$getResult).then((result)=>{
            this.emit("debug", {
                action: "response",
                request: request,
                response: result,
                provider: this
            });
            return result;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                error: error,
                request: request,
                provider: this
            });
            throw error;
        });
        // Cache the fetch, but clear it on the next event loop
        if (cache) {
            this._cache[method] = result;
            setTimeout(()=>{
                this._cache[method] = null;
            }, 0);
        }
        return result;
    }
    prepareRequest(method, params) {
        switch(method){
            case "getBlockNumber":
                return [
                    "eth_blockNumber",
                    []
                ];
            case "getGasPrice":
                return [
                    "eth_gasPrice",
                    []
                ];
            case "getBalance":
                return [
                    "eth_getBalance",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getTransactionCount":
                return [
                    "eth_getTransactionCount",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getCode":
                return [
                    "eth_getCode",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        params.blockTag
                    ]
                ];
            case "getStorageAt":
                return [
                    "eth_getStorageAt",
                    [
                        $9609e75996f2bd40$var$getLowerCase(params.address),
                        (0, $ApLZa.hexZeroPad)(params.position, 32),
                        params.blockTag
                    ]
                ];
            case "sendTransaction":
                return [
                    "eth_sendRawTransaction",
                    [
                        params.signedTransaction
                    ]
                ];
            case "getBlock":
                if (params.blockTag) return [
                    "eth_getBlockByNumber",
                    [
                        params.blockTag,
                        !!params.includeTransactions
                    ]
                ];
                else if (params.blockHash) return [
                    "eth_getBlockByHash",
                    [
                        params.blockHash,
                        !!params.includeTransactions
                    ]
                ];
                return null;
            case "getTransaction":
                return [
                    "eth_getTransactionByHash",
                    [
                        params.transactionHash
                    ]
                ];
            case "getTransactionReceipt":
                return [
                    "eth_getTransactionReceipt",
                    [
                        params.transactionHash
                    ]
                ];
            case "call":
                {
                    const hexlifyTransaction = (0, $i6lOf.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_call",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            }),
                            params.blockTag
                        ]
                    ];
                }
            case "estimateGas":
                {
                    const hexlifyTransaction = (0, $i6lOf.getStatic)(this.constructor, "hexlifyTransaction");
                    return [
                        "eth_estimateGas",
                        [
                            hexlifyTransaction(params.transaction, {
                                from: true
                            })
                        ]
                    ];
                }
            case "getLogs":
                if (params.filter && params.filter.address != null) params.filter.address = $9609e75996f2bd40$var$getLowerCase(params.filter.address);
                return [
                    "eth_getLogs",
                    [
                        params.filter
                    ]
                ];
            default:
                break;
        }
        return null;
    }
    perform(method, params) {
        return $9609e75996f2bd40$var$__awaiter(this, void 0, void 0, function*() {
            // Legacy networks do not like the type field being passed along (which
            // is fair), so we delete type if it is 0 and a non-EIP-1559 network
            if (method === "call" || method === "estimateGas") {
                const tx = params.transaction;
                if (tx && tx.type != null && (0, $esOfL.BigNumber).from(tx.type).isZero()) // If there are no EIP-1559 properties, it might be non-EIP-1559
                {
                    if (tx.maxFeePerGas == null && tx.maxPriorityFeePerGas == null) {
                        const feeData = yield this.getFeeData();
                        if (feeData.maxFeePerGas == null && feeData.maxPriorityFeePerGas == null) {
                            // Network doesn't know about EIP-1559 (and hence type)
                            params = (0, $i6lOf.shallowCopy)(params);
                            params.transaction = (0, $i6lOf.shallowCopy)(tx);
                            delete params.transaction.type;
                        }
                    }
                }
            }
            const args = this.prepareRequest(method, params);
            if (args == null) $9609e75996f2bd40$var$logger.throwError(method + " not implemented", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
                operation: method
            });
            try {
                return yield this.send(args[0], args[1]);
            } catch (error) {
                return $9609e75996f2bd40$var$checkError(method, error, params);
            }
        });
    }
    _startEvent(event) {
        if (event.tag === "pending") this._startPending();
        super._startEvent(event);
    }
    _startPending() {
        if (this._pendingFilter != null) return;
        const self = this;
        const pendingFilter = this.send("eth_newPendingTransactionFilter", []);
        this._pendingFilter = pendingFilter;
        pendingFilter.then(function(filterId) {
            function poll() {
                self.send("eth_getFilterChanges", [
                    filterId
                ]).then(function(hashes) {
                    if (self._pendingFilter != pendingFilter) return null;
                    let seq = Promise.resolve();
                    hashes.forEach(function(hash) {
                        // @TODO: This should be garbage collected at some point... How? When?
                        self._emitted["t:" + hash.toLowerCase()] = "pending";
                        seq = seq.then(function() {
                            return self.getTransaction(hash).then(function(tx) {
                                self.emit("pending", tx);
                                return null;
                            });
                        });
                    });
                    return seq.then(function() {
                        return $9609e75996f2bd40$var$timer(1000);
                    });
                }).then(function() {
                    if (self._pendingFilter != pendingFilter) {
                        self.send("eth_uninstallFilter", [
                            filterId
                        ]);
                        return;
                    }
                    setTimeout(function() {
                        poll();
                    }, 0);
                    return null;
                }).catch((error)=>{});
            }
            poll();
            return filterId;
        }).catch((error)=>{});
    }
    _stopEvent(event) {
        if (event.tag === "pending" && this.listenerCount("pending") === 0) this._pendingFilter = null;
        super._stopEvent(event);
    }
    // Convert an ethers.js transaction into a JSON-RPC transaction
    //  - gasLimit => gas
    //  - All values hexlified
    //  - All numeric values zero-striped
    //  - All addresses are lowercased
    // NOTE: This allows a TransactionRequest, but all values should be resolved
    //       before this is called
    // @TODO: This will likely be removed in future versions and prepareRequest
    //        will be the preferred method for this.
    static hexlifyTransaction(transaction, allowExtra) {
        // Check only allowed properties are given
        const allowed = (0, $i6lOf.shallowCopy)($9609e75996f2bd40$var$allowedTransactionKeys);
        if (allowExtra) {
            for(const key in allowExtra)if (allowExtra[key]) allowed[key] = true;
        }
        (0, $i6lOf.checkProperties)(transaction, allowed);
        const result = {};
        // JSON-RPC now requires numeric values to be "quantity" values
        [
            "chainId",
            "gasLimit",
            "gasPrice",
            "type",
            "maxFeePerGas",
            "maxPriorityFeePerGas",
            "nonce",
            "value"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            const value = (0, $ApLZa.hexValue)((0, $esOfL.BigNumber).from(transaction[key]));
            if (key === "gasLimit") key = "gas";
            result[key] = value;
        });
        [
            "from",
            "to",
            "data"
        ].forEach(function(key) {
            if (transaction[key] == null) return;
            result[key] = (0, $ApLZa.hexlify)(transaction[key]);
        });
        if (transaction.accessList) result["accessList"] = (0, $5LK3h.accessListify)(transaction.accessList);
        return result;
    }
}

});

parcelRegister("edLD6", function(module, exports) {

$parcel$export(module.exports, "WebSocket", function () { return $a5a739e019737409$export$3909fb301d3dc8c9; });

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
let $a5a739e019737409$export$3909fb301d3dc8c9 = null;
try {
    $a5a739e019737409$export$3909fb301d3dc8c9 = WebSocket;
    if ($a5a739e019737409$export$3909fb301d3dc8c9 == null) throw new Error("inject please");
} catch (error) {
    const logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
    $a5a739e019737409$export$3909fb301d3dc8c9 = function() {
        logger.throwError("WebSockets not supported in this environment", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "new WebSocket()"
        });
    };
}

});


parcelRegister("cLduf", function(module, exports) {

$parcel$export(module.exports, "StaticJsonRpcProvider", function () { return $94a45602d091e5d2$export$b3d647c1c29df44d; });
$parcel$export(module.exports, "UrlJsonRpcProvider", function () { return $94a45602d091e5d2$export$664128d6239ccf96; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cSErQ = parcelRequire("cSErQ");
"use strict";
var $94a45602d091e5d2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $94a45602d091e5d2$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $94a45602d091e5d2$export$b3d647c1c29df44d extends (0, $cSErQ.JsonRpcProvider) {
    detectNetwork() {
        const _super = Object.create(null, {
            detectNetwork: {
                get: ()=>super.detectNetwork
            }
        });
        return $94a45602d091e5d2$var$__awaiter(this, void 0, void 0, function*() {
            let network = this.network;
            if (network == null) {
                network = yield _super.detectNetwork.call(this);
                if (!network) $94a45602d091e5d2$var$logger.throwError("no network detected", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {});
                // If still not set, set it
                if (this._network == null) {
                    // A static network does not support "any"
                    (0, $i6lOf.defineReadOnly)(this, "_network", network);
                    this.emit("network", network, null);
                }
            }
            return network;
        });
    }
}
class $94a45602d091e5d2$export$664128d6239ccf96 extends $94a45602d091e5d2$export$b3d647c1c29df44d {
    constructor(network, apiKey){
        $94a45602d091e5d2$var$logger.checkAbstract(new.target, $94a45602d091e5d2$export$664128d6239ccf96);
        // Normalize the Network and API Key
        network = (0, $i6lOf.getStatic)(new.target, "getNetwork")(network);
        apiKey = (0, $i6lOf.getStatic)(new.target, "getApiKey")(apiKey);
        const connection = (0, $i6lOf.getStatic)(new.target, "getUrl")(network, apiKey);
        super(connection, network);
        if (typeof apiKey === "string") (0, $i6lOf.defineReadOnly)(this, "apiKey", apiKey);
        else if (apiKey != null) Object.keys(apiKey).forEach((key)=>{
            (0, $i6lOf.defineReadOnly)(this, key, apiKey[key]);
        });
    }
    _startPending() {
        $94a45602d091e5d2$var$logger.warn("WARNING: API provider does not support pending filters");
    }
    isCommunityResource() {
        return false;
    }
    getSigner(address) {
        return $94a45602d091e5d2$var$logger.throwError("API provider does not support signing", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "getSigner"
        });
    }
    listAccounts() {
        return Promise.resolve([]);
    }
    // Return a defaultApiKey if null, otherwise validate the API key
    static getApiKey(apiKey) {
        return apiKey;
    }
    // Returns the url or connection for the given network and API key. The
    // API key will have been sanitized by the getApiKey first, so any validation
    // or transformations can be done there.
    static getUrl(network, apiKey) {
        return $94a45602d091e5d2$var$logger.throwError("not implemented; sub-classes must override getUrl", (0, $8bxC3.Logger).errors.NOT_IMPLEMENTED, {
            operation: "getUrl"
        });
    }
}

});


parcelRegister("3qcmX", function(module, exports) {

$parcel$export(module.exports, "AnkrProvider", function () { return $27dd6519e1beec55$export$72783b2aefa72a45; });

var $31PiM = parcelRequire("31PiM");

var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
const $27dd6519e1beec55$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $27dd6519e1beec55$var$defaultApiKey = "9f7d929b018cdffb338517efa06f58359e86ff1ffd350bc889738523659e7972";
function $27dd6519e1beec55$var$getHost(name) {
    switch(name){
        case "homestead":
            return "rpc.ankr.com/eth/";
        case "ropsten":
            return "rpc.ankr.com/eth_ropsten/";
        case "rinkeby":
            return "rpc.ankr.com/eth_rinkeby/";
        case "goerli":
            return "rpc.ankr.com/eth_goerli/";
        case "matic":
            return "rpc.ankr.com/polygon/";
        case "arbitrum":
            return "rpc.ankr.com/arbitrum/";
    }
    return $27dd6519e1beec55$var$logger.throwArgumentError("unsupported network", "name", name);
}
class $27dd6519e1beec55$export$72783b2aefa72a45 extends (0, $cLduf.UrlJsonRpcProvider) {
    isCommunityResource() {
        return this.apiKey === $27dd6519e1beec55$var$defaultApiKey;
    }
    static getApiKey(apiKey) {
        if (apiKey == null) return $27dd6519e1beec55$var$defaultApiKey;
        return apiKey;
    }
    static getUrl(network, apiKey) {
        if (apiKey == null) apiKey = $27dd6519e1beec55$var$defaultApiKey;
        const connection = {
            allowGzip: true,
            url: "https://" + $27dd6519e1beec55$var$getHost(network.name) + apiKey,
            throttleCallback: (attempt, url)=>{
                if (apiKey.apiKey === $27dd6519e1beec55$var$defaultApiKey) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
}

});

parcelRegister("b7SLg", function(module, exports) {

$parcel$export(module.exports, "CloudflareProvider", function () { return $819ad3a08ca08517$export$7113381f8f264fc0; });

var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $819ad3a08ca08517$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $819ad3a08ca08517$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
class $819ad3a08ca08517$export$7113381f8f264fc0 extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey != null) $819ad3a08ca08517$var$logger.throwArgumentError("apiKey not supported for cloudflare", "apiKey", apiKey);
        return null;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://cloudflare-eth.com/";
                break;
            default:
                $819ad3a08ca08517$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host;
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $819ad3a08ca08517$var$__awaiter(this, void 0, void 0, function*() {
            // The Cloudflare provider does not support eth_blockNumber,
            // so we get the latest block and pull it from that
            if (method === "getBlockNumber") {
                const block = yield _super.perform.call(this, "getBlock", {
                    blockTag: "latest"
                });
                return block.number;
            }
            return _super.perform.call(this, method, params);
        });
    }
}

});

parcelRegister("iXMwy", function(module, exports) {

$parcel$export(module.exports, "EtherscanProvider", function () { return $dce3608ad1ddcc3f$export$dd1d942a536c7912; });

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $5LK3h = parcelRequire("5LK3h");

var $2GUlC = parcelRequire("2GUlC");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $lts60 = parcelRequire("lts60");
"use strict";
var $dce3608ad1ddcc3f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $dce3608ad1ddcc3f$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// The transaction has already been sanitized by the calls in Provider
function $dce3608ad1ddcc3f$var$getTransactionPostData(transaction) {
    const result = {};
    for(let key in transaction){
        if (transaction[key] == null) continue;
        let value = transaction[key];
        if (key === "type" && value === 0) continue;
        // Quantity-types require no leading zero, unless 0
        if (({
            type: true,
            gasLimit: true,
            gasPrice: true,
            maxFeePerGs: true,
            maxPriorityFeePerGas: true,
            nonce: true,
            value: true
        })[key]) value = (0, $ApLZa.hexValue)((0, $ApLZa.hexlify)(value));
        else if (key === "accessList") value = "[" + (0, $5LK3h.accessListify)(value).map((set)=>{
            return `{address:"${set.address}",storageKeys:["${set.storageKeys.join('","')}"]}`;
        }).join(",") + "]";
        else value = (0, $ApLZa.hexlify)(value);
        result[key] = value;
    }
    return result;
}
function $dce3608ad1ddcc3f$var$getResult(result) {
    // getLogs, getHistory have weird success responses
    if (result.status == 0 && (result.message === "No records found" || result.message === "No transactions found")) return result.result;
    if (result.status != 1 || typeof result.message !== "string" || !result.message.match(/^OK/)) {
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        if ((result.result || "").toLowerCase().indexOf("rate limit") >= 0) error.throttleRetry = true;
        throw error;
    }
    return result.result;
}
function $dce3608ad1ddcc3f$var$getJsonResult(result) {
    // This response indicates we are being throttled
    if (result && result.status == 0 && result.message == "NOTOK" && (result.result || "").toLowerCase().indexOf("rate limit") >= 0) {
        const error = new Error("throttled response");
        error.result = JSON.stringify(result);
        error.throttleRetry = true;
        throw error;
    }
    if (result.jsonrpc != "2.0") {
        // @TODO: not any
        const error = new Error("invalid response");
        error.result = JSON.stringify(result);
        throw error;
    }
    if (result.error) {
        // @TODO: not any
        const error = new Error(result.error.message || "unknown error");
        if (result.error.code) error.code = result.error.code;
        if (result.error.data) error.data = result.error.data;
        throw error;
    }
    return result.result;
}
// The blockTag was normalized as a string by the Provider pre-perform operations
function $dce3608ad1ddcc3f$var$checkLogTag(blockTag) {
    if (blockTag === "pending") throw new Error("pending not supported");
    if (blockTag === "latest") return blockTag;
    return parseInt(blockTag.substring(2), 16);
}
function $dce3608ad1ddcc3f$var$checkError(method, error, transaction) {
    // Undo the "convenience" some nodes are attempting to prevent backwards
    // incompatibility; maybe for v6 consider forwarding reverts as errors
    if (method === "call" && error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) {
        const e = error.error;
        // Etherscan keeps changing their string
        if (e && (e.message.match(/reverted/i) || e.message.match(/VM execution error/i))) {
            // Etherscan prefixes the data like "Reverted 0x1234"
            let data = e.data;
            if (data) data = "0x" + data.replace(/^.*0x/i, "");
            if ((0, $ApLZa.isHexString)(data)) return data;
            $dce3608ad1ddcc3f$var$logger.throwError("missing revert data in call exception", (0, $8bxC3.Logger).errors.CALL_EXCEPTION, {
                error: error,
                data: "0x"
            });
        }
    }
    // Get the message from any nested error structure
    let message = error.message;
    if (error.code === (0, $8bxC3.Logger).errors.SERVER_ERROR) {
        if (error.error && typeof error.error.message === "string") message = error.error.message;
        else if (typeof error.body === "string") message = error.body;
        else if (typeof error.responseText === "string") message = error.responseText;
    }
    message = (message || "").toLowerCase();
    // "Insufficient funds. The account you tried to send transaction from does not have enough funds. Required 21464000000000 and got: 0"
    if (message.match(/insufficient funds/)) $dce3608ad1ddcc3f$var$logger.throwError("insufficient funds for intrinsic transaction cost", (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction with the same hash was already imported."
    if (message.match(/same hash was already imported|transaction nonce is too low|nonce too low/)) $dce3608ad1ddcc3f$var$logger.throwError("nonce has already been used", (0, $8bxC3.Logger).errors.NONCE_EXPIRED, {
        error: error,
        method: method,
        transaction: transaction
    });
    // "Transaction gas price is too low. There is another transaction with same nonce in the queue. Try increasing the gas price or incrementing the nonce."
    if (message.match(/another transaction with same nonce/)) $dce3608ad1ddcc3f$var$logger.throwError("replacement fee too low", (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED, {
        error: error,
        method: method,
        transaction: transaction
    });
    if (message.match(/execution failed due to an exception|execution reverted/)) $dce3608ad1ddcc3f$var$logger.throwError("cannot estimate gas; transaction may fail or may require manual gas limit", (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT, {
        error: error,
        method: method,
        transaction: transaction
    });
    throw error;
}
class $dce3608ad1ddcc3f$export$dd1d942a536c7912 extends (0, $lts60.BaseProvider) {
    constructor(network, apiKey){
        super(network);
        (0, $i6lOf.defineReadOnly)(this, "baseUrl", this.getBaseUrl());
        (0, $i6lOf.defineReadOnly)(this, "apiKey", apiKey || null);
    }
    getBaseUrl() {
        switch(this.network ? this.network.name : "invalid"){
            case "homestead":
                return "https://api.etherscan.io";
            case "goerli":
                return "https://api-goerli.etherscan.io";
            case "sepolia":
                return "https://api-sepolia.etherscan.io";
            case "matic":
                return "https://api.polygonscan.com";
            case "maticmum":
                return "https://api-testnet.polygonscan.com";
            case "arbitrum":
                return "https://api.arbiscan.io";
            case "arbitrum-goerli":
                return "https://api-goerli.arbiscan.io";
            case "optimism":
                return "https://api-optimistic.etherscan.io";
            case "optimism-goerli":
                return "https://api-goerli-optimistic.etherscan.io";
            default:
        }
        return $dce3608ad1ddcc3f$var$logger.throwArgumentError("unsupported network", "network", this.network.name);
    }
    getUrl(module, params) {
        const query = Object.keys(params).reduce((accum, key)=>{
            const value = params[key];
            if (value != null) accum += `&${key}=${value}`;
            return accum;
        }, "");
        const apiKey = this.apiKey ? `&apikey=${this.apiKey}` : "";
        return `${this.baseUrl}/api?module=${module}${query}${apiKey}`;
    }
    getPostUrl() {
        return `${this.baseUrl}/api`;
    }
    getPostData(module, params) {
        params.module = module;
        params.apikey = this.apiKey;
        return params;
    }
    fetch(module, params, post) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const url = post ? this.getPostUrl() : this.getUrl(module, params);
            const payload = post ? this.getPostData(module, params) : null;
            const procFunc = module === "proxy" ? $dce3608ad1ddcc3f$var$getJsonResult : $dce3608ad1ddcc3f$var$getResult;
            this.emit("debug", {
                action: "request",
                request: url,
                provider: this
            });
            const connection = {
                url: url,
                throttleSlotInterval: 1000,
                throttleCallback: (attempt, url)=>{
                    if (this.isCommunityResource()) (0, $31PiM.showThrottleMessage)();
                    return Promise.resolve(true);
                }
            };
            let payloadStr = null;
            if (payload) {
                connection.headers = {
                    "content-type": "application/x-www-form-urlencoded; charset=UTF-8"
                };
                payloadStr = Object.keys(payload).map((key)=>{
                    return `${key}=${payload[key]}`;
                }).join("&");
            }
            const result = yield (0, $2GUlC.fetchJson)(connection, payloadStr, procFunc || $dce3608ad1ddcc3f$var$getJsonResult);
            this.emit("debug", {
                action: "response",
                request: url,
                response: (0, $i6lOf.deepCopy)(result),
                provider: this
            });
            return result;
        });
    }
    detectNetwork() {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            return this.network;
        });
    }
    perform(method, params) {
        const _super = Object.create(null, {
            perform: {
                get: ()=>super.perform
            }
        });
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            switch(method){
                case "getBlockNumber":
                    return this.fetch("proxy", {
                        action: "eth_blockNumber"
                    });
                case "getGasPrice":
                    return this.fetch("proxy", {
                        action: "eth_gasPrice"
                    });
                case "getBalance":
                    // Returns base-10 result
                    return this.fetch("account", {
                        action: "balance",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getTransactionCount":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionCount",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getCode":
                    return this.fetch("proxy", {
                        action: "eth_getCode",
                        address: params.address,
                        tag: params.blockTag
                    });
                case "getStorageAt":
                    return this.fetch("proxy", {
                        action: "eth_getStorageAt",
                        address: params.address,
                        position: params.position,
                        tag: params.blockTag
                    });
                case "sendTransaction":
                    return this.fetch("proxy", {
                        action: "eth_sendRawTransaction",
                        hex: params.signedTransaction
                    }, true).catch((error)=>{
                        return $dce3608ad1ddcc3f$var$checkError("sendTransaction", error, params.signedTransaction);
                    });
                case "getBlock":
                    if (params.blockTag) return this.fetch("proxy", {
                        action: "eth_getBlockByNumber",
                        tag: params.blockTag,
                        boolean: params.includeTransactions ? "true" : "false"
                    });
                    throw new Error("getBlock by blockHash not implemented");
                case "getTransaction":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionByHash",
                        txhash: params.transactionHash
                    });
                case "getTransactionReceipt":
                    return this.fetch("proxy", {
                        action: "eth_getTransactionReceipt",
                        txhash: params.transactionHash
                    });
                case "call":
                    {
                        if (params.blockTag !== "latest") throw new Error("EtherscanProvider does not support blockTag for call");
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_call";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("call", error, params.transaction);
                        }
                    }
                case "estimateGas":
                    {
                        const postData = $dce3608ad1ddcc3f$var$getTransactionPostData(params.transaction);
                        postData.module = "proxy";
                        postData.action = "eth_estimateGas";
                        try {
                            return yield this.fetch("proxy", postData, true);
                        } catch (error) {
                            return $dce3608ad1ddcc3f$var$checkError("estimateGas", error, params.transaction);
                        }
                    }
                case "getLogs":
                    {
                        const args = {
                            action: "getLogs"
                        };
                        if (params.filter.fromBlock) args.fromBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.fromBlock);
                        if (params.filter.toBlock) args.toBlock = $dce3608ad1ddcc3f$var$checkLogTag(params.filter.toBlock);
                        if (params.filter.address) args.address = params.filter.address;
                        // @TODO: We can handle slightly more complicated logs using the logs API
                        if (params.filter.topics && params.filter.topics.length > 0) {
                            if (params.filter.topics.length > 1) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic count", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                                topics: params.filter.topics
                            });
                            if (params.filter.topics.length === 1) {
                                const topic0 = params.filter.topics[0];
                                if (typeof topic0 !== "string" || topic0.length !== 66) $dce3608ad1ddcc3f$var$logger.throwError("unsupported topic format", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
                                    topic0: topic0
                                });
                                args.topic0 = topic0;
                            }
                        }
                        const logs = yield this.fetch("logs", args);
                        // Cache txHash => blockHash
                        let blocks = {};
                        // Add any missing blockHash to the logs
                        for(let i = 0; i < logs.length; i++){
                            const log = logs[i];
                            if (log.blockHash != null) continue;
                            if (blocks[log.blockNumber] == null) {
                                const block = yield this.getBlock(log.blockNumber);
                                if (block) blocks[log.blockNumber] = block.hash;
                            }
                            log.blockHash = blocks[log.blockNumber];
                        }
                        return logs;
                    }
                case "getEtherPrice":
                    if (this.network.name !== "homestead") return 0.0;
                    return parseFloat((yield this.fetch("stats", {
                        action: "ethprice"
                    })).ethusd);
                default:
                    break;
            }
            return _super.perform.call(this, method, params);
        });
    }
    // Note: The `page` page parameter only allows pagination within the
    //       10,000 window available without a page and offset parameter
    //       Error: Result window is too large, PageNo x Offset size must
    //              be less than or equal to 10000
    getHistory(addressOrName, startBlock, endBlock) {
        return $dce3608ad1ddcc3f$var$__awaiter(this, void 0, void 0, function*() {
            const params = {
                action: "txlist",
                address: yield this.resolveName(addressOrName),
                startblock: startBlock == null ? 0 : startBlock,
                endblock: endBlock == null ? 99999999 : endBlock,
                sort: "asc"
            };
            const result = yield this.fetch("account", params);
            return result.map((tx)=>{
                [
                    "contractAddress",
                    "to"
                ].forEach(function(key) {
                    if (tx[key] == "") delete tx[key];
                });
                if (tx.creates == null && tx.contractAddress != null) tx.creates = tx.contractAddress;
                const item = this.formatter.transactionResponse(tx);
                if (tx.timeStamp) item.timestamp = parseInt(tx.timeStamp);
                return item;
            });
        });
    }
    isCommunityResource() {
        return this.apiKey == null;
    }
}

});

parcelRegister("8Tv7m", function(module, exports) {

$parcel$export(module.exports, "FallbackProvider", function () { return $679b99176172981c$export$cb1d0beacb55feb7; });

var $dGRwz = parcelRequire("dGRwz");

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $i6lOf = parcelRequire("i6lOf");

var $aTUBO = parcelRequire("aTUBO");

var $2GUlC = parcelRequire("2GUlC");

var $lts60 = parcelRequire("lts60");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
var $679b99176172981c$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $679b99176172981c$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
function $679b99176172981c$var$now() {
    return new Date().getTime();
}
// Returns to network as long as all agree, or null if any is null.
// Throws an error if any two networks do not match.
function $679b99176172981c$var$checkNetworks(networks) {
    let result = null;
    for(let i = 0; i < networks.length; i++){
        const network = networks[i];
        // Null! We do not know our network; bail.
        if (network == null) return null;
        if (result) // Make sure the network matches the previous networks
        {
            if (!(result.name === network.name && result.chainId === network.chainId && (result.ensAddress === network.ensAddress || result.ensAddress == null && network.ensAddress == null))) $679b99176172981c$var$logger.throwArgumentError("provider mismatch", "networks", networks);
        } else result = network;
    }
    return result;
}
function $679b99176172981c$var$median(values, maxDelta) {
    values = values.slice().sort();
    const middle = Math.floor(values.length / 2);
    // Odd length; take the middle
    if (values.length % 2) return values[middle];
    // Even length; take the average of the two middle
    const a = values[middle - 1], b = values[middle];
    if (maxDelta != null && Math.abs(a - b) > maxDelta) return null;
    return (a + b) / 2;
}
function $679b99176172981c$var$serialize(value) {
    if (value === null) return "null";
    else if (typeof value === "number" || typeof value === "boolean") return JSON.stringify(value);
    else if (typeof value === "string") return value;
    else if ((0, $esOfL.BigNumber).isBigNumber(value)) return value.toString();
    else if (Array.isArray(value)) return JSON.stringify(value.map((i)=>$679b99176172981c$var$serialize(i)));
    else if (typeof value === "object") {
        const keys = Object.keys(value);
        keys.sort();
        return "{" + keys.map((key)=>{
            let v = value[key];
            if (typeof v === "function") v = "[function]";
            else v = $679b99176172981c$var$serialize(v);
            return JSON.stringify(key) + ":" + v;
        }).join(",") + "}";
    }
    throw new Error("unknown value type: " + typeof value);
}
// Next request ID to use for emitting debug info
let $679b99176172981c$var$nextRid = 1;
function $679b99176172981c$var$stall(duration) {
    let cancel = null;
    let timer = null;
    let promise = new Promise((resolve)=>{
        cancel = function() {
            if (timer) {
                clearTimeout(timer);
                timer = null;
            }
            resolve();
        };
        timer = setTimeout(cancel, duration);
    });
    const wait = (func)=>{
        promise = promise.then(func);
        return promise;
    };
    function getPromise() {
        return promise;
    }
    return {
        cancel: cancel,
        getPromise: getPromise,
        wait: wait
    };
}
const $679b99176172981c$var$ForwardErrors = [
    (0, $8bxC3.Logger).errors.CALL_EXCEPTION,
    (0, $8bxC3.Logger).errors.INSUFFICIENT_FUNDS,
    (0, $8bxC3.Logger).errors.NONCE_EXPIRED,
    (0, $8bxC3.Logger).errors.REPLACEMENT_UNDERPRICED,
    (0, $8bxC3.Logger).errors.UNPREDICTABLE_GAS_LIMIT
];
const $679b99176172981c$var$ForwardProperties = [
    "address",
    "args",
    "errorArgs",
    "errorSignature",
    "method",
    "transaction"
];
function $679b99176172981c$var$exposeDebugConfig(config, now) {
    const result = {
        weight: config.weight
    };
    Object.defineProperty(result, "provider", {
        get: ()=>config.provider
    });
    if (config.start) result.start = config.start;
    if (now) result.duration = now - config.start;
    if (config.done) {
        if (config.error) result.error = config.error;
        else result.result = config.result || null;
    }
    return result;
}
function $679b99176172981c$var$normalizedTally(normalize, quorum) {
    return function(configs) {
        // Count the votes for each result
        const tally = {};
        configs.forEach((c)=>{
            const value = normalize(c.result);
            if (!tally[value]) tally[value] = {
                count: 0,
                result: c.result
            };
            tally[value].count++;
        });
        // Check for a quorum on any given result
        const keys = Object.keys(tally);
        for(let i = 0; i < keys.length; i++){
            const check = tally[keys[i]];
            if (check.count >= quorum) return check.result;
        }
        // No quroum
        return undefined;
    };
}
function $679b99176172981c$var$getProcessFunc(provider, method, params) {
    let normalize = $679b99176172981c$var$serialize;
    switch(method){
        case "getBlockNumber":
            // Return the median value, unless there is (median + 1) is also
            // present, in which case that is probably true and the median
            // is going to be stale soon. In the event of a malicious node,
            // the lie will be true soon enough.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                // Get the median block number
                let blockNumber = $679b99176172981c$var$median(configs.map((c)=>c.result), 2);
                if (blockNumber == null) return undefined;
                blockNumber = Math.ceil(blockNumber);
                // If the next block height is present, its prolly safe to use
                if (values.indexOf(blockNumber + 1) >= 0) blockNumber++;
                // Don't ever roll back the blockNumber
                if (blockNumber >= provider._highestBlockNumber) provider._highestBlockNumber = blockNumber;
                return provider._highestBlockNumber;
            };
        case "getGasPrice":
            // Return the middle (round index up) value, similar to median
            // but do not average even entries and choose the higher.
            // Malicious actors must compromise 50% of the nodes to lie.
            return function(configs) {
                const values = configs.map((c)=>c.result);
                values.sort();
                return values[Math.floor(values.length / 2)];
            };
        case "getEtherPrice":
            // Returns the median price. Malicious actors must compromise at
            // least 50% of the nodes to lie (in a meaningful way).
            return function(configs) {
                return $679b99176172981c$var$median(configs.map((c)=>c.result));
            };
        // No additional normalizing required; serialize is enough
        case "getBalance":
        case "getTransactionCount":
        case "getCode":
        case "getStorageAt":
        case "call":
        case "estimateGas":
        case "getLogs":
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getTransaction":
        case "getTransactionReceipt":
            normalize = function(tx) {
                if (tx == null) return null;
                tx = (0, $i6lOf.shallowCopy)(tx);
                tx.confirmations = -1;
                return $679b99176172981c$var$serialize(tx);
            };
            break;
        // We drop the confirmations from transactions as it is approximate
        case "getBlock":
            // We drop the confirmations from transactions as it is approximate
            if (params.includeTransactions) normalize = function(block) {
                if (block == null) return null;
                block = (0, $i6lOf.shallowCopy)(block);
                block.transactions = block.transactions.map((tx)=>{
                    tx = (0, $i6lOf.shallowCopy)(tx);
                    tx.confirmations = -1;
                    return tx;
                });
                return $679b99176172981c$var$serialize(block);
            };
            else normalize = function(block) {
                if (block == null) return null;
                return $679b99176172981c$var$serialize(block);
            };
            break;
        default:
            throw new Error("unknown method: " + method);
    }
    // Return the result if and only if the expected quorum is
    // satisfied and agreed upon for the final result.
    return $679b99176172981c$var$normalizedTally(normalize, provider.quorum);
}
// If we are doing a blockTag query, we need to make sure the backend is
// caught up to the FallbackProvider, before sending a request to it.
function $679b99176172981c$var$waitForSync(config, blockNumber) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        const provider = config.provider;
        if (provider.blockNumber != null && provider.blockNumber >= blockNumber || blockNumber === -1) return provider;
        return (0, $2GUlC.poll)(()=>{
            return new Promise((resolve, reject)=>{
                setTimeout(function() {
                    // We are synced
                    if (provider.blockNumber >= blockNumber) return resolve(provider);
                    // We're done; just quit
                    if (config.cancelled) return resolve(null);
                    // Try again, next block
                    return resolve(undefined);
                }, 0);
            });
        }, {
            oncePoll: provider
        });
    });
}
function $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params) {
    return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
        let provider = config.provider;
        switch(method){
            case "getBlockNumber":
            case "getGasPrice":
                return provider[method]();
            case "getEtherPrice":
                if (provider.getEtherPrice) return provider.getEtherPrice();
                break;
            case "getBalance":
            case "getTransactionCount":
            case "getCode":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[method](params.address, params.blockTag || "latest");
            case "getStorageAt":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider.getStorageAt(params.address, params.position, params.blockTag || "latest");
            case "getBlock":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                return provider[params.includeTransactions ? "getBlockWithTransactions" : "getBlock"](params.blockTag || params.blockHash);
            case "call":
            case "estimateGas":
                if (params.blockTag && (0, $ApLZa.isHexString)(params.blockTag)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                if (method === "call" && params.blockTag) return provider[method](params.transaction, params.blockTag);
                return provider[method](params.transaction);
            case "getTransaction":
            case "getTransactionReceipt":
                return provider[method](params.transactionHash);
            case "getLogs":
                {
                    let filter = params.filter;
                    if (filter.fromBlock && (0, $ApLZa.isHexString)(filter.fromBlock) || filter.toBlock && (0, $ApLZa.isHexString)(filter.toBlock)) provider = yield $679b99176172981c$var$waitForSync(config, currentBlockNumber);
                    return provider.getLogs(filter);
                }
        }
        return $679b99176172981c$var$logger.throwError("unknown method error", (0, $8bxC3.Logger).errors.UNKNOWN_ERROR, {
            method: method,
            params: params
        });
    });
}
class $679b99176172981c$export$cb1d0beacb55feb7 extends (0, $lts60.BaseProvider) {
    constructor(providers, quorum){
        if (providers.length === 0) $679b99176172981c$var$logger.throwArgumentError("missing providers", "providers", providers);
        const providerConfigs = providers.map((configOrProvider, index)=>{
            if ((0, $dGRwz.Provider).isProvider(configOrProvider)) {
                const stallTimeout = (0, $31PiM.isCommunityResource)(configOrProvider) ? 2000 : 750;
                const priority = 1;
                return Object.freeze({
                    provider: configOrProvider,
                    weight: 1,
                    stallTimeout: stallTimeout,
                    priority: priority
                });
            }
            const config = (0, $i6lOf.shallowCopy)(configOrProvider);
            if (config.priority == null) config.priority = 1;
            if (config.stallTimeout == null) config.stallTimeout = (0, $31PiM.isCommunityResource)(configOrProvider) ? 2000 : 750;
            if (config.weight == null) config.weight = 1;
            const weight = config.weight;
            if (weight % 1 || weight > 512 || weight < 1) $679b99176172981c$var$logger.throwArgumentError("invalid weight; must be integer in [1, 512]", `providers[${index}].weight`, weight);
            return Object.freeze(config);
        });
        const total = providerConfigs.reduce((accum, c)=>accum + c.weight, 0);
        if (quorum == null) quorum = total / 2;
        else if (quorum > total) $679b99176172981c$var$logger.throwArgumentError("quorum will always fail; larger than total weight", "quorum", quorum);
        // Are all providers' networks are known
        let networkOrReady = $679b99176172981c$var$checkNetworks(providerConfigs.map((c)=>c.provider.network));
        // Not all networks are known; we must stall
        if (networkOrReady == null) networkOrReady = new Promise((resolve, reject)=>{
            setTimeout(()=>{
                this.detectNetwork().then(resolve, reject);
            }, 0);
        });
        super(networkOrReady);
        // Preserve a copy, so we do not get mutated
        (0, $i6lOf.defineReadOnly)(this, "providerConfigs", Object.freeze(providerConfigs));
        (0, $i6lOf.defineReadOnly)(this, "quorum", quorum);
        this._highestBlockNumber = -1;
    }
    detectNetwork() {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            const networks = yield Promise.all(this.providerConfigs.map((c)=>c.provider.getNetwork()));
            return $679b99176172981c$var$checkNetworks(networks);
        });
    }
    perform(method, params) {
        return $679b99176172981c$var$__awaiter(this, void 0, void 0, function*() {
            // Sending transactions is special; always broadcast it to all backends
            if (method === "sendTransaction") {
                const results = yield Promise.all(this.providerConfigs.map((c)=>{
                    return c.provider.sendTransaction(params.signedTransaction).then((result)=>{
                        return result.hash;
                    }, (error)=>{
                        return error;
                    });
                }));
                // Any success is good enough (other errors are likely "already seen" errors
                for(let i = 0; i < results.length; i++){
                    const result = results[i];
                    if (typeof result === "string") return result;
                }
                // They were all an error; pick the first error
                throw results[0];
            }
            // We need to make sure we are in sync with our backends, so we need
            // to know this before we can make a lot of calls
            if (this._highestBlockNumber === -1 && method !== "getBlockNumber") yield this.getBlockNumber();
            const processFunc = $679b99176172981c$var$getProcessFunc(this, method, params);
            // Shuffle the providers and then sort them by their priority; we
            // shallowCopy them since we will store the result in them too
            const configs = (0, $aTUBO.shuffled)(this.providerConfigs.map((0, $i6lOf.shallowCopy)));
            configs.sort((a, b)=>a.priority - b.priority);
            const currentBlockNumber = this._highestBlockNumber;
            let i = 0;
            let first = true;
            while(true){
                const t0 = $679b99176172981c$var$now();
                // Compute the inflight weight (exclude anything past)
                let inflightWeight = configs.filter((c)=>c.runner && t0 - c.start < c.stallTimeout).reduce((accum, c)=>accum + c.weight, 0);
                // Start running enough to meet quorum
                while(inflightWeight < this.quorum && i < configs.length){
                    const config = configs[i++];
                    const rid = $679b99176172981c$var$nextRid++;
                    config.start = $679b99176172981c$var$now();
                    config.staller = $679b99176172981c$var$stall(config.stallTimeout);
                    config.staller.wait(()=>{
                        config.staller = null;
                    });
                    config.runner = $679b99176172981c$var$getRunner(config, currentBlockNumber, method, params).then((result)=>{
                        config.done = true;
                        config.result = result;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $i6lOf.deepCopy)(params)
                            },
                            provider: this
                        });
                    }, (error)=>{
                        config.done = true;
                        config.error = error;
                        if (this.listenerCount("debug")) this.emit("debug", {
                            action: "request",
                            rid: rid,
                            backend: $679b99176172981c$var$exposeDebugConfig(config, $679b99176172981c$var$now()),
                            request: {
                                method: method,
                                params: (0, $i6lOf.deepCopy)(params)
                            },
                            provider: this
                        });
                    });
                    if (this.listenerCount("debug")) this.emit("debug", {
                        action: "request",
                        rid: rid,
                        backend: $679b99176172981c$var$exposeDebugConfig(config, null),
                        request: {
                            method: method,
                            params: (0, $i6lOf.deepCopy)(params)
                        },
                        provider: this
                    });
                    inflightWeight += config.weight;
                }
                // Wait for anything meaningful to finish or stall out
                const waiting = [];
                configs.forEach((c)=>{
                    if (c.done || !c.runner) return;
                    waiting.push(c.runner);
                    if (c.staller) waiting.push(c.staller.getPromise());
                });
                if (waiting.length) yield Promise.race(waiting);
                // Check the quorum and process the results; the process function
                // may additionally decide the quorum is not met
                const results = configs.filter((c)=>c.done && c.error == null);
                if (results.length >= this.quorum) {
                    const result = processFunc(results);
                    if (result !== undefined) {
                        // Shut down any stallers
                        configs.forEach((c)=>{
                            if (c.staller) c.staller.cancel();
                            c.cancelled = true;
                        });
                        return result;
                    }
                    if (!first) yield $679b99176172981c$var$stall(100).getPromise();
                    first = false;
                }
                // No result, check for errors that should be forwarded
                const errors = configs.reduce((accum, c)=>{
                    if (!c.done || c.error == null) return accum;
                    const code = c.error.code;
                    if ($679b99176172981c$var$ForwardErrors.indexOf(code) >= 0) {
                        if (!accum[code]) accum[code] = {
                            error: c.error,
                            weight: 0
                        };
                        accum[code].weight += c.weight;
                    }
                    return accum;
                }, {});
                Object.keys(errors).forEach((errorCode)=>{
                    const tally = errors[errorCode];
                    if (tally.weight < this.quorum) return;
                    // Shut down any stallers
                    configs.forEach((c)=>{
                        if (c.staller) c.staller.cancel();
                        c.cancelled = true;
                    });
                    const e = tally.error;
                    const props = {};
                    $679b99176172981c$var$ForwardProperties.forEach((name)=>{
                        if (e[name] == null) return;
                        props[name] = e[name];
                    });
                    $679b99176172981c$var$logger.throwError(e.reason || e.message, errorCode, props);
                });
                // All configs have run to completion; we will never get more data
                if (configs.filter((c)=>!c.done).length === 0) break;
            }
            // Shut down any stallers; shouldn't be any
            configs.forEach((c)=>{
                if (c.staller) c.staller.cancel();
                c.cancelled = true;
            });
            return $679b99176172981c$var$logger.throwError("failed to meet quorum", (0, $8bxC3.Logger).errors.SERVER_ERROR, {
                method: method,
                params: params,
                //results: configs.map((c) => c.result),
                //errors: configs.map((c) => c.error),
                results: configs.map((c)=>$679b99176172981c$var$exposeDebugConfig(c)),
                provider: this
            });
        });
    }
}

});
parcelRegister("aTUBO", function(module, exports) {

$parcel$export(module.exports, "shuffled", function () { return $7efaf3cc8a62189f$export$e6c7296801b9b341; });
"use strict";
function $7efaf3cc8a62189f$export$e6c7296801b9b341(array) {
    array = array.slice();
    for(let i = array.length - 1; i > 0; i--){
        const j = Math.floor(Math.random() * (i + 1));
        const tmp = array[i];
        array[i] = array[j];
        array[j] = tmp;
    }
    return array;
}

});


parcelRegister("ljauL", function(module, exports) {

$parcel$export(module.exports, "IpcProvider", function () { return $f8338370fa8a55b7$export$fbe151f90a1ece01; });
"use strict";
const $f8338370fa8a55b7$export$fbe151f90a1ece01 = null;

});

parcelRegister("43Sch", function(module, exports) {

$parcel$export(module.exports, "InfuraWebSocketProvider", function () { return $2f517ba1fc7b9c0f$export$dd168a807d60da4f; });
$parcel$export(module.exports, "InfuraProvider", function () { return $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd; });

var $i6lOf = parcelRequire("i6lOf");

var $hZPNa = parcelRequire("hZPNa");

var $31PiM = parcelRequire("31PiM");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $2f517ba1fc7b9c0f$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $2f517ba1fc7b9c0f$var$defaultProjectId = "84842078b09946638c03157f83405213";
class $2f517ba1fc7b9c0f$export$dd168a807d60da4f extends (0, $hZPNa.WebSocketProvider) {
    constructor(network, apiKey){
        const provider = new $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd(network, apiKey);
        const connection = provider.connection;
        if (connection.password) $2f517ba1fc7b9c0f$var$logger.throwError("INFURA WebSocket project secrets unsupported", (0, $8bxC3.Logger).errors.UNSUPPORTED_OPERATION, {
            operation: "InfuraProvider.getWebSocketProvider()"
        });
        const url = connection.url.replace(/^http/i, "ws").replace("/v3/", "/ws/v3/");
        super(url, network);
        (0, $i6lOf.defineReadOnly)(this, "apiKey", provider.projectId);
        (0, $i6lOf.defineReadOnly)(this, "projectId", provider.projectId);
        (0, $i6lOf.defineReadOnly)(this, "projectSecret", provider.projectSecret);
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}
class $2f517ba1fc7b9c0f$export$60ff1a559b5c6ebd extends (0, $cLduf.UrlJsonRpcProvider) {
    static getWebSocketProvider(network, apiKey) {
        return new $2f517ba1fc7b9c0f$export$dd168a807d60da4f(network, apiKey);
    }
    static getApiKey(apiKey) {
        const apiKeyObj = {
            apiKey: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectId: $2f517ba1fc7b9c0f$var$defaultProjectId,
            projectSecret: null
        };
        if (apiKey == null) return apiKeyObj;
        if (typeof apiKey === "string") apiKeyObj.projectId = apiKey;
        else if (apiKey.projectSecret != null) {
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectId === "string", "projectSecret requires a projectId", "projectId", apiKey.projectId);
            $2f517ba1fc7b9c0f$var$logger.assertArgument(typeof apiKey.projectSecret === "string", "invalid projectSecret", "projectSecret", "[REDACTED]");
            apiKeyObj.projectId = apiKey.projectId;
            apiKeyObj.projectSecret = apiKey.projectSecret;
        } else if (apiKey.projectId) apiKeyObj.projectId = apiKey.projectId;
        apiKeyObj.apiKey = apiKeyObj.projectId;
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "homestead":
                host = "mainnet.infura.io";
                break;
            case "goerli":
                host = "goerli.infura.io";
                break;
            case "sepolia":
                host = "sepolia.infura.io";
                break;
            case "matic":
                host = "polygon-mainnet.infura.io";
                break;
            case "maticmum":
                host = "polygon-mumbai.infura.io";
                break;
            case "optimism":
                host = "optimism-mainnet.infura.io";
                break;
            case "optimism-goerli":
                host = "optimism-goerli.infura.io";
                break;
            case "arbitrum":
                host = "arbitrum-mainnet.infura.io";
                break;
            case "arbitrum-goerli":
                host = "arbitrum-goerli.infura.io";
                break;
            default:
                $2f517ba1fc7b9c0f$var$logger.throwError("unsupported network", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const connection = {
            allowGzip: true,
            url: "https://" + host + "/v3/" + apiKey.projectId,
            throttleCallback: (attempt, url)=>{
                if (apiKey.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId) (0, $31PiM.showThrottleMessage)();
                return Promise.resolve(true);
            }
        };
        if (apiKey.projectSecret != null) {
            connection.user = "";
            connection.password = apiKey.projectSecret;
        }
        return connection;
    }
    isCommunityResource() {
        return this.projectId === $2f517ba1fc7b9c0f$var$defaultProjectId;
    }
}

});

parcelRegister("1fGt2", function(module, exports) {

$parcel$export(module.exports, "JsonRpcBatchProvider", function () { return $0e9822498cccaf3d$export$5a16092bf20edf97; });

var $i6lOf = parcelRequire("i6lOf");

var $2GUlC = parcelRequire("2GUlC");

var $cSErQ = parcelRequire("cSErQ");
class $0e9822498cccaf3d$export$5a16092bf20edf97 extends (0, $cSErQ.JsonRpcProvider) {
    send(method, params) {
        const request = {
            method: method,
            params: params,
            id: this._nextId++,
            jsonrpc: "2.0"
        };
        if (this._pendingBatch == null) this._pendingBatch = [];
        const inflightRequest = {
            request: request,
            resolve: null,
            reject: null
        };
        const promise = new Promise((resolve, reject)=>{
            inflightRequest.resolve = resolve;
            inflightRequest.reject = reject;
        });
        this._pendingBatch.push(inflightRequest);
        if (!this._pendingBatchAggregator) // Schedule batch for next event loop + short duration
        this._pendingBatchAggregator = setTimeout(()=>{
            // Get teh current batch and clear it, so new requests
            // go into the next batch
            const batch = this._pendingBatch;
            this._pendingBatch = null;
            this._pendingBatchAggregator = null;
            // Get the request as an array of requests
            const request = batch.map((inflight)=>inflight.request);
            this.emit("debug", {
                action: "requestBatch",
                request: (0, $i6lOf.deepCopy)(request),
                provider: this
            });
            return (0, $2GUlC.fetchJson)(this.connection, JSON.stringify(request)).then((result)=>{
                this.emit("debug", {
                    action: "response",
                    request: request,
                    response: result,
                    provider: this
                });
                // For each result, feed it to the correct Promise, depending
                // on whether it was a success or error
                batch.forEach((inflightRequest, index)=>{
                    const payload = result[index];
                    if (payload.error) {
                        const error = new Error(payload.error.message);
                        error.code = payload.error.code;
                        error.data = payload.error.data;
                        inflightRequest.reject(error);
                    } else inflightRequest.resolve(payload.result);
                });
            }, (error)=>{
                this.emit("debug", {
                    action: "response",
                    error: error,
                    request: request,
                    provider: this
                });
                batch.forEach((inflightRequest)=>{
                    inflightRequest.reject(error);
                });
            });
        }, 10);
        return promise;
    }
}

});

parcelRegister("7qX7n", function(module, exports) {

$parcel$export(module.exports, "NodesmithProvider", function () { return $5698d1b59ff58cae$export$8235cbce3ce273bd; });
/* istanbul ignore file */ 
var $cLduf = parcelRequire("cLduf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");
"use strict";
const $5698d1b59ff58cae$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
// Special API key provided by Nodesmith for ethers.js
const $5698d1b59ff58cae$var$defaultApiKey = "ETHERS_JS_SHARED";
class $5698d1b59ff58cae$export$8235cbce3ce273bd extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        if (apiKey && typeof apiKey !== "string") $5698d1b59ff58cae$var$logger.throwArgumentError("invalid apiKey", "apiKey", apiKey);
        return apiKey || $5698d1b59ff58cae$var$defaultApiKey;
    }
    static getUrl(network, apiKey) {
        $5698d1b59ff58cae$var$logger.warn("NodeSmith will be discontinued on 2019-12-20; please migrate to another platform.");
        let host = null;
        switch(network.name){
            case "homestead":
                host = "https://ethereum.api.nodesmith.io/v1/mainnet/jsonrpc";
                break;
            case "ropsten":
                host = "https://ethereum.api.nodesmith.io/v1/ropsten/jsonrpc";
                break;
            case "rinkeby":
                host = "https://ethereum.api.nodesmith.io/v1/rinkeby/jsonrpc";
                break;
            case "goerli":
                host = "https://ethereum.api.nodesmith.io/v1/goerli/jsonrpc";
                break;
            case "kovan":
                host = "https://ethereum.api.nodesmith.io/v1/kovan/jsonrpc";
                break;
            default:
                $5698d1b59ff58cae$var$logger.throwArgumentError("unsupported network", "network", arguments[0]);
        }
        return host + "?apiKey=" + apiKey;
    }
}

});

parcelRegister("4loi1", function(module, exports) {

$parcel$export(module.exports, "PocketProvider", function () { return $329bf708d9366864$export$58bb47e42f6b092e; });

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cLduf = parcelRequire("cLduf");
"use strict";
const $329bf708d9366864$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
const $329bf708d9366864$var$defaultApplicationId = "62e1ad51b37b8e00394bda3b";
class $329bf708d9366864$export$58bb47e42f6b092e extends (0, $cLduf.UrlJsonRpcProvider) {
    static getApiKey(apiKey) {
        const apiKeyObj = {
            applicationId: null,
            loadBalancer: true,
            applicationSecretKey: null
        };
        // Parse applicationId and applicationSecretKey
        if (apiKey == null) apiKeyObj.applicationId = $329bf708d9366864$var$defaultApplicationId;
        else if (typeof apiKey === "string") apiKeyObj.applicationId = apiKey;
        else if (apiKey.applicationSecretKey != null) {
            apiKeyObj.applicationId = apiKey.applicationId;
            apiKeyObj.applicationSecretKey = apiKey.applicationSecretKey;
        } else if (apiKey.applicationId) apiKeyObj.applicationId = apiKey.applicationId;
        else $329bf708d9366864$var$logger.throwArgumentError("unsupported PocketProvider apiKey", "apiKey", apiKey);
        return apiKeyObj;
    }
    static getUrl(network, apiKey) {
        let host = null;
        switch(network ? network.name : "unknown"){
            case "goerli":
                host = "eth-goerli.gateway.pokt.network";
                break;
            case "homestead":
                host = "eth-mainnet.gateway.pokt.network";
                break;
            case "kovan":
                host = "poa-kovan.gateway.pokt.network";
                break;
            case "matic":
                host = "poly-mainnet.gateway.pokt.network";
                break;
            case "maticmum":
                host = "polygon-mumbai-rpc.gateway.pokt.network";
                break;
            case "rinkeby":
                host = "eth-rinkeby.gateway.pokt.network";
                break;
            case "ropsten":
                host = "eth-ropsten.gateway.pokt.network";
                break;
            default:
                $329bf708d9366864$var$logger.throwError("unsupported network", (0, $8bxC3.Logger).errors.INVALID_ARGUMENT, {
                    argument: "network",
                    value: network
                });
        }
        const url = `https:/\/${host}/v1/lb/${apiKey.applicationId}`;
        const connection = {
            headers: {},
            url: url
        };
        if (apiKey.applicationSecretKey != null) {
            connection.user = "";
            connection.password = apiKey.applicationSecretKey;
        }
        return connection;
    }
    isCommunityResource() {
        return this.applicationId === $329bf708d9366864$var$defaultApplicationId;
    }
}

});

parcelRegister("k80Oh", function(module, exports) {

$parcel$export(module.exports, "Web3Provider", function () { return $ea752ed8b721343a$export$d05096c9fd9d936d; });

var $i6lOf = parcelRequire("i6lOf");

var $8bxC3 = parcelRequire("8bxC3");

var $k5bHX = parcelRequire("k5bHX");

var $cSErQ = parcelRequire("cSErQ");
"use strict";
const $ea752ed8b721343a$var$logger = new (0, $8bxC3.Logger)((0, $k5bHX.version));
let $ea752ed8b721343a$var$_nextId = 1;
function $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, sendFunc) {
    const fetcher = "Web3LegacyFetcher";
    return function(method, params) {
        const request = {
            method: method,
            params: params,
            id: $ea752ed8b721343a$var$_nextId++,
            jsonrpc: "2.0"
        };
        return new Promise((resolve, reject)=>{
            this.emit("debug", {
                action: "request",
                fetcher: fetcher,
                request: (0, $i6lOf.deepCopy)(request),
                provider: this
            });
            sendFunc(request, (error, response)=>{
                if (error) {
                    this.emit("debug", {
                        action: "response",
                        fetcher: fetcher,
                        error: error,
                        request: request,
                        provider: this
                    });
                    return reject(error);
                }
                this.emit("debug", {
                    action: "response",
                    fetcher: fetcher,
                    request: request,
                    response: response,
                    provider: this
                });
                if (response.error) {
                    const error = new Error(response.error.message);
                    error.code = response.error.code;
                    error.data = response.error.data;
                    return reject(error);
                }
                resolve(response.result);
            });
        });
    };
}
function $ea752ed8b721343a$var$buildEip1193Fetcher(provider) {
    return function(method, params) {
        if (params == null) params = [];
        const request = {
            method: method,
            params: params
        };
        this.emit("debug", {
            action: "request",
            fetcher: "Eip1193Fetcher",
            request: (0, $i6lOf.deepCopy)(request),
            provider: this
        });
        return provider.request(request).then((response)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                response: response,
                provider: this
            });
            return response;
        }, (error)=>{
            this.emit("debug", {
                action: "response",
                fetcher: "Eip1193Fetcher",
                request: request,
                error: error,
                provider: this
            });
            throw error;
        });
    };
}
class $ea752ed8b721343a$export$d05096c9fd9d936d extends (0, $cSErQ.JsonRpcProvider) {
    constructor(provider, network){
        if (provider == null) $ea752ed8b721343a$var$logger.throwArgumentError("missing provider", "provider", provider);
        let path = null;
        let jsonRpcFetchFunc = null;
        let subprovider = null;
        if (typeof provider === "function") {
            path = "unknown:";
            jsonRpcFetchFunc = provider;
        } else {
            path = provider.host || provider.path || "";
            if (!path && provider.isMetaMask) path = "metamask";
            subprovider = provider;
            if (provider.request) {
                if (path === "") path = "eip-1193:";
                jsonRpcFetchFunc = $ea752ed8b721343a$var$buildEip1193Fetcher(provider);
            } else if (provider.sendAsync) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.sendAsync.bind(provider));
            else if (provider.send) jsonRpcFetchFunc = $ea752ed8b721343a$var$buildWeb3LegacyFetcher(provider, provider.send.bind(provider));
            else $ea752ed8b721343a$var$logger.throwArgumentError("unsupported provider", "provider", provider);
            if (!path) path = "unknown:";
        }
        super(path, network);
        (0, $i6lOf.defineReadOnly)(this, "jsonRpcFetchFunc", jsonRpcFetchFunc);
        (0, $i6lOf.defineReadOnly)(this, "provider", subprovider);
    }
    send(method, params) {
        return this.jsonRpcFetchFunc(method, params);
    }
}

});


parcelRegister("9L4c0", function(module, exports) {

$parcel$export(module.exports, "AbiCoder", function () { return (parcelRequire("5FB8J")).AbiCoder; });
$parcel$export(module.exports, "defaultAbiCoder", function () { return (parcelRequire("5FB8J")).defaultAbiCoder; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("3PTbz")).Fragment; });
$parcel$export(module.exports, "ConstructorFragment", function () { return (parcelRequire("3PTbz")).ConstructorFragment; });
$parcel$export(module.exports, "ErrorFragment", function () { return (parcelRequire("3PTbz")).ErrorFragment; });
$parcel$export(module.exports, "EventFragment", function () { return (parcelRequire("3PTbz")).EventFragment; });
$parcel$export(module.exports, "FunctionFragment", function () { return (parcelRequire("3PTbz")).FunctionFragment; });
$parcel$export(module.exports, "ParamType", function () { return (parcelRequire("3PTbz")).ParamType; });
$parcel$export(module.exports, "FormatTypes", function () { return (parcelRequire("3PTbz")).FormatTypes; });
$parcel$export(module.exports, "checkResultErrors", function () { return (parcelRequire("5aOKN")).checkResultErrors; });
$parcel$export(module.exports, "Logger", function () { return (parcelRequire("8bxC3")).Logger; });
$parcel$export(module.exports, "RLP", function () { return (parcelRequire("2blqG")); });
$parcel$export(module.exports, "_fetchData", function () { return (parcelRequire("2GUlC"))._fetchData; });
$parcel$export(module.exports, "fetchJson", function () { return (parcelRequire("2GUlC")).fetchJson; });
$parcel$export(module.exports, "poll", function () { return (parcelRequire("2GUlC")).poll; });
$parcel$export(module.exports, "checkProperties", function () { return (parcelRequire("i6lOf")).checkProperties; });
$parcel$export(module.exports, "deepCopy", function () { return (parcelRequire("i6lOf")).deepCopy; });
$parcel$export(module.exports, "defineReadOnly", function () { return (parcelRequire("i6lOf")).defineReadOnly; });
$parcel$export(module.exports, "getStatic", function () { return (parcelRequire("i6lOf")).getStatic; });
$parcel$export(module.exports, "resolveProperties", function () { return (parcelRequire("i6lOf")).resolveProperties; });
$parcel$export(module.exports, "shallowCopy", function () { return (parcelRequire("i6lOf")).shallowCopy; });
$parcel$export(module.exports, "arrayify", function () { return (parcelRequire("ApLZa")).arrayify; });
$parcel$export(module.exports, "concat", function () { return (parcelRequire("ApLZa")).concat; });
$parcel$export(module.exports, "stripZeros", function () { return (parcelRequire("ApLZa")).stripZeros; });
$parcel$export(module.exports, "zeroPad", function () { return (parcelRequire("ApLZa")).zeroPad; });
$parcel$export(module.exports, "isBytes", function () { return (parcelRequire("ApLZa")).isBytes; });
$parcel$export(module.exports, "isBytesLike", function () { return (parcelRequire("ApLZa")).isBytesLike; });
$parcel$export(module.exports, "defaultPath", function () { return (parcelRequire("3NuV3")).defaultPath; });
$parcel$export(module.exports, "HDNode", function () { return (parcelRequire("3NuV3")).HDNode; });
$parcel$export(module.exports, "SigningKey", function () { return (parcelRequire("6ltHX")).SigningKey; });
$parcel$export(module.exports, "Interface", function () { return (parcelRequire("h8t8t")).Interface; });
$parcel$export(module.exports, "LogDescription", function () { return (parcelRequire("h8t8t")).LogDescription; });
$parcel$export(module.exports, "TransactionDescription", function () { return (parcelRequire("h8t8t")).TransactionDescription; });
$parcel$export(module.exports, "base58", function () { return (parcelRequire("6PyTw")).Base58; });
$parcel$export(module.exports, "base64", function () { return (parcelRequire("fe8vC")); });
$parcel$export(module.exports, "hexlify", function () { return (parcelRequire("ApLZa")).hexlify; });
$parcel$export(module.exports, "isHexString", function () { return (parcelRequire("ApLZa")).isHexString; });
$parcel$export(module.exports, "hexConcat", function () { return (parcelRequire("ApLZa")).hexConcat; });
$parcel$export(module.exports, "hexStripZeros", function () { return (parcelRequire("ApLZa")).hexStripZeros; });
$parcel$export(module.exports, "hexValue", function () { return (parcelRequire("ApLZa")).hexValue; });
$parcel$export(module.exports, "hexZeroPad", function () { return (parcelRequire("ApLZa")).hexZeroPad; });
$parcel$export(module.exports, "hexDataLength", function () { return (parcelRequire("ApLZa")).hexDataLength; });
$parcel$export(module.exports, "hexDataSlice", function () { return (parcelRequire("ApLZa")).hexDataSlice; });
$parcel$export(module.exports, "nameprep", function () { return (parcelRequire("hayKj")).nameprep; });
$parcel$export(module.exports, "_toEscapedUtf8String", function () { return (parcelRequire("aCHl8"))._toEscapedUtf8String; });
$parcel$export(module.exports, "toUtf8Bytes", function () { return (parcelRequire("aCHl8")).toUtf8Bytes; });
$parcel$export(module.exports, "toUtf8CodePoints", function () { return (parcelRequire("aCHl8")).toUtf8CodePoints; });
$parcel$export(module.exports, "toUtf8String", function () { return (parcelRequire("aCHl8")).toUtf8String; });
$parcel$export(module.exports, "Utf8ErrorFuncs", function () { return (parcelRequire("aCHl8")).Utf8ErrorFuncs; });
$parcel$export(module.exports, "formatBytes32String", function () { return (parcelRequire("2txLu")).formatBytes32String; });
$parcel$export(module.exports, "parseBytes32String", function () { return (parcelRequire("2txLu")).parseBytes32String; });
$parcel$export(module.exports, "dnsEncode", function () { return (parcelRequire("1e7EA")).dnsEncode; });
$parcel$export(module.exports, "hashMessage", function () { return (parcelRequire("6RlV8")).hashMessage; });
$parcel$export(module.exports, "namehash", function () { return (parcelRequire("1e7EA")).namehash; });
$parcel$export(module.exports, "isValidName", function () { return (parcelRequire("1e7EA")).isValidName; });
$parcel$export(module.exports, "id", function () { return (parcelRequire("1JJGc")).id; });
$parcel$export(module.exports, "_TypedDataEncoder", function () { return (parcelRequire("cKR64")).TypedDataEncoder; });
$parcel$export(module.exports, "getAddress", function () { return (parcelRequire("7pv2A")).getAddress; });
$parcel$export(module.exports, "getIcapAddress", function () { return (parcelRequire("7pv2A")).getIcapAddress; });
$parcel$export(module.exports, "getContractAddress", function () { return (parcelRequire("7pv2A")).getContractAddress; });
$parcel$export(module.exports, "getCreate2Address", function () { return (parcelRequire("7pv2A")).getCreate2Address; });
$parcel$export(module.exports, "isAddress", function () { return (parcelRequire("7pv2A")).isAddress; });
$parcel$export(module.exports, "formatEther", function () { return (parcelRequire("aGsqH")).formatEther; });
$parcel$export(module.exports, "parseEther", function () { return (parcelRequire("aGsqH")).parseEther; });
$parcel$export(module.exports, "formatUnits", function () { return (parcelRequire("aGsqH")).formatUnits; });
$parcel$export(module.exports, "parseUnits", function () { return (parcelRequire("aGsqH")).parseUnits; });
$parcel$export(module.exports, "commify", function () { return (parcelRequire("aGsqH")).commify; });
$parcel$export(module.exports, "computeHmac", function () { return (parcelRequire("eT6wv")).computeHmac; });
$parcel$export(module.exports, "keccak256", function () { return (parcelRequire("8unkG")).keccak256; });
$parcel$export(module.exports, "ripemd160", function () { return (parcelRequire("eT6wv")).ripemd160; });
$parcel$export(module.exports, "sha256", function () { return (parcelRequire("eT6wv")).sha256; });
$parcel$export(module.exports, "sha512", function () { return (parcelRequire("eT6wv")).sha512; });
$parcel$export(module.exports, "randomBytes", function () { return (parcelRequire("UqakH")).randomBytes; });
$parcel$export(module.exports, "shuffled", function () { return (parcelRequire("aTUBO")).shuffled; });
$parcel$export(module.exports, "solidityPack", function () { return (parcelRequire("bQUCt")).pack; });
$parcel$export(module.exports, "solidityKeccak256", function () { return (parcelRequire("bQUCt")).keccak256; });
$parcel$export(module.exports, "soliditySha256", function () { return (parcelRequire("bQUCt")).sha256; });
$parcel$export(module.exports, "splitSignature", function () { return (parcelRequire("ApLZa")).splitSignature; });
$parcel$export(module.exports, "joinSignature", function () { return (parcelRequire("ApLZa")).joinSignature; });
$parcel$export(module.exports, "accessListify", function () { return (parcelRequire("5LK3h")).accessListify; });
$parcel$export(module.exports, "parseTransaction", function () { return (parcelRequire("5LK3h")).parse; });
$parcel$export(module.exports, "serializeTransaction", function () { return (parcelRequire("5LK3h")).serialize; });
$parcel$export(module.exports, "TransactionTypes", function () { return (parcelRequire("5LK3h")).TransactionTypes; });
$parcel$export(module.exports, "getJsonWalletAddress", function () { return (parcelRequire("3hMhy")).getJsonWalletAddress; });
$parcel$export(module.exports, "computeAddress", function () { return (parcelRequire("5LK3h")).computeAddress; });
$parcel$export(module.exports, "recoverAddress", function () { return (parcelRequire("5LK3h")).recoverAddress; });
$parcel$export(module.exports, "computePublicKey", function () { return (parcelRequire("6ltHX")).computePublicKey; });
$parcel$export(module.exports, "recoverPublicKey", function () { return (parcelRequire("6ltHX")).recoverPublicKey; });
$parcel$export(module.exports, "verifyMessage", function () { return (parcelRequire("hO0Ij")).verifyMessage; });
$parcel$export(module.exports, "verifyTypedData", function () { return (parcelRequire("hO0Ij")).verifyTypedData; });
$parcel$export(module.exports, "getAccountPath", function () { return (parcelRequire("3NuV3")).getAccountPath; });
$parcel$export(module.exports, "mnemonicToEntropy", function () { return (parcelRequire("3NuV3")).mnemonicToEntropy; });
$parcel$export(module.exports, "entropyToMnemonic", function () { return (parcelRequire("3NuV3")).entropyToMnemonic; });
$parcel$export(module.exports, "isValidMnemonic", function () { return (parcelRequire("3NuV3")).isValidMnemonic; });
$parcel$export(module.exports, "mnemonicToSeed", function () { return (parcelRequire("3NuV3")).mnemonicToSeed; });
$parcel$export(module.exports, "SupportedAlgorithm", function () { return (parcelRequire("gSWEZ")).SupportedAlgorithm; });
$parcel$export(module.exports, "UnicodeNormalizationForm", function () { return (parcelRequire("aCHl8")).UnicodeNormalizationForm; });
$parcel$export(module.exports, "Utf8ErrorReason", function () { return (parcelRequire("aCHl8")).Utf8ErrorReason; });
$parcel$export(module.exports, "Indexed", function () { return (parcelRequire("h8t8t")).Indexed; });

var $5FB8J = parcelRequire("5FB8J");
var $5aOKN = parcelRequire("5aOKN");
var $3PTbz = parcelRequire("3PTbz");
var $h8t8t = parcelRequire("h8t8t");

var $7pv2A = parcelRequire("7pv2A");

var $fe8vC = parcelRequire("fe8vC");

var $6PyTw = parcelRequire("6PyTw");

var $ApLZa = parcelRequire("ApLZa");

var $cKR64 = parcelRequire("cKR64");
var $1e7EA = parcelRequire("1e7EA");
var $6RlV8 = parcelRequire("6RlV8");
var $1JJGc = parcelRequire("1JJGc");

var $3NuV3 = parcelRequire("3NuV3");

var $3hMhy = parcelRequire("3hMhy");

var $8unkG = parcelRequire("8unkG");

var $8bxC3 = parcelRequire("8bxC3");

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");

var $bQUCt = parcelRequire("bQUCt");

var $UqakH = parcelRequire("UqakH");
var $aTUBO = parcelRequire("aTUBO");

var $i6lOf = parcelRequire("i6lOf");

var $2blqG = parcelRequire("2blqG");

var $6ltHX = parcelRequire("6ltHX");

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");

var $5LK3h = parcelRequire("5LK3h");

var $aGsqH = parcelRequire("aGsqH");

var $hO0Ij = parcelRequire("hO0Ij");

var $2GUlC = parcelRequire("2GUlC");
"use strict";

});
parcelRegister("bQUCt", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $8a107881e49b51a3$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "keccak256", function () { return $8a107881e49b51a3$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "sha256", function () { return $8a107881e49b51a3$export$bced8d2aada2d1c9; });

var $esOfL = parcelRequire("esOfL");

var $ApLZa = parcelRequire("ApLZa");

var $8unkG = parcelRequire("8unkG");

var $eT6wv = parcelRequire("eT6wv");

var $aCHl8 = parcelRequire("aCHl8");

var $8bxC3 = parcelRequire("8bxC3");

var $cCEYy = parcelRequire("cCEYy");
"use strict";
const $8a107881e49b51a3$var$regexBytes = new RegExp("^bytes([0-9]+)$");
const $8a107881e49b51a3$var$regexNumber = new RegExp("^(u?int)([0-9]*)$");
const $8a107881e49b51a3$var$regexArray = new RegExp("^(.*)\\[([0-9]*)\\]$");
const $8a107881e49b51a3$var$Zeros = "0000000000000000000000000000000000000000000000000000000000000000";
const $8a107881e49b51a3$var$logger = new (0, $8bxC3.Logger)((0, $cCEYy.version));
function $8a107881e49b51a3$var$_pack(type, value, isArray) {
    switch(type){
        case "address":
            if (isArray) return (0, $ApLZa.zeroPad)(value, 32);
            return (0, $ApLZa.arrayify)(value);
        case "string":
            return (0, $aCHl8.toUtf8Bytes)(value);
        case "bytes":
            return (0, $ApLZa.arrayify)(value);
        case "bool":
            value = value ? "0x01" : "0x00";
            if (isArray) return (0, $ApLZa.zeroPad)(value, 32);
            return (0, $ApLZa.arrayify)(value);
    }
    let match = type.match($8a107881e49b51a3$var$regexNumber);
    if (match) {
        //let signed = (match[1] === "int")
        let size = parseInt(match[2] || "256");
        if (match[2] && String(size) !== match[2] || size % 8 !== 0 || size === 0 || size > 256) $8a107881e49b51a3$var$logger.throwArgumentError("invalid number type", "type", type);
        if (isArray) size = 256;
        value = (0, $esOfL.BigNumber).from(value).toTwos(size);
        return (0, $ApLZa.zeroPad)(value, size / 8);
    }
    match = type.match($8a107881e49b51a3$var$regexBytes);
    if (match) {
        const size = parseInt(match[1]);
        if (String(size) !== match[1] || size === 0 || size > 32) $8a107881e49b51a3$var$logger.throwArgumentError("invalid bytes type", "type", type);
        if ((0, $ApLZa.arrayify)(value).byteLength !== size) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid value for ${type}`, "value", value);
        if (isArray) return (0, $ApLZa.arrayify)((value + $8a107881e49b51a3$var$Zeros).substring(0, 66));
        return value;
    }
    match = type.match($8a107881e49b51a3$var$regexArray);
    if (match && Array.isArray(value)) {
        const baseType = match[1];
        const count = parseInt(match[2] || String(value.length));
        if (count != value.length) $8a107881e49b51a3$var$logger.throwArgumentError(`invalid array length for ${type}`, "value", value);
        const result = [];
        value.forEach(function(value) {
            result.push($8a107881e49b51a3$var$_pack(baseType, value, true));
        });
        return (0, $ApLZa.concat)(result);
    }
    return $8a107881e49b51a3$var$logger.throwArgumentError("invalid type", "type", type);
}
function $8a107881e49b51a3$export$2a703dbb0cb35339(types, values) {
    if (types.length != values.length) $8a107881e49b51a3$var$logger.throwArgumentError("wrong number of values; expected ${ types.length }", "values", values);
    const tight = [];
    types.forEach(function(type, index) {
        tight.push($8a107881e49b51a3$var$_pack(type, values[index]));
    });
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)(tight));
}
function $8a107881e49b51a3$export$f8151fce47ad1c35(types, values) {
    return (0, $8unkG.keccak256)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}
function $8a107881e49b51a3$export$bced8d2aada2d1c9(types, values) {
    return (0, $eT6wv.sha256)($8a107881e49b51a3$export$2a703dbb0cb35339(types, values));
}

});
parcelRegister("cCEYy", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $9308d195935c559a$export$83d89fbfd8236492; });
const $9308d195935c559a$export$83d89fbfd8236492 = "solidity/5.7.0";

});


parcelRegister("2txLu", function(module, exports) {

$parcel$export(module.exports, "formatBytes32String", function () { return $1cd87b34e852dc8f$export$b97e949c0076e971; });
$parcel$export(module.exports, "parseBytes32String", function () { return $1cd87b34e852dc8f$export$49340cb8f3954db8; });

var $11T4t = parcelRequire("11T4t");

var $ApLZa = parcelRequire("ApLZa");

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $1cd87b34e852dc8f$export$b97e949c0076e971(text) {
    // Get the bytes
    const bytes = (0, $aCHl8.toUtf8Bytes)(text);
    // Check we have room for null-termination
    if (bytes.length > 31) throw new Error("bytes32 string must be less than 32 bytes");
    // Zero-pad (implicitly null-terminates)
    return (0, $ApLZa.hexlify)((0, $ApLZa.concat)([
        bytes,
        (0, $11T4t.HashZero)
    ]).slice(0, 32));
}
function $1cd87b34e852dc8f$export$49340cb8f3954db8(bytes) {
    const data = (0, $ApLZa.arrayify)(bytes);
    // Must be 32 bytes with a null-termination
    if (data.length !== 32) throw new Error("invalid bytes32 - not 32 bytes long");
    if (data[31] !== 0) throw new Error("invalid bytes32 string - no null terminator");
    // Find the null termination
    let length = 31;
    while(data[length - 1] === 0)length--;
    // Determine the string value
    return (0, $aCHl8.toUtf8String)(data.slice(0, length));
}

});

parcelRegister("hayKj", function(module, exports) {

$parcel$export(module.exports, "nameprep", function () { return $c7fe52ac76e0a919$export$94f0b6f93c619bc; });

var $aCHl8 = parcelRequire("aCHl8");
"use strict";
function $c7fe52ac76e0a919$var$bytes2(data) {
    if (data.length % 4 !== 0) throw new Error("bad data");
    let result = [];
    for(let i = 0; i < data.length; i += 4)result.push(parseInt(data.substring(i, i + 4), 16));
    return result;
}
function $c7fe52ac76e0a919$var$createTable(data, func) {
    if (!func) func = function(value) {
        return [
            parseInt(value, 16)
        ];
    };
    let lo = 0;
    let result = {};
    data.split(",").forEach((pair)=>{
        let comps = pair.split(":");
        lo += parseInt(comps[0], 16);
        result[lo] = func(comps[1]);
    });
    return result;
}
function $c7fe52ac76e0a919$var$createRangeTable(data) {
    let hi = 0;
    return data.split(",").map((v)=>{
        let comps = v.split("-");
        if (comps.length === 1) comps[1] = "0";
        else if (comps[1] === "") comps[1] = "1";
        let lo = hi + parseInt(comps[0], 16);
        hi = parseInt(comps[1], 16);
        return {
            l: lo,
            h: hi
        };
    });
}
function $c7fe52ac76e0a919$var$matchMap(value, ranges) {
    let lo = 0;
    for(let i = 0; i < ranges.length; i++){
        let range = ranges[i];
        lo += range.l;
        if (value >= lo && value <= lo + range.h && (value - lo) % (range.d || 1) === 0) {
            if (range.e && range.e.indexOf(value - lo) !== -1) continue;
            return range;
        }
    }
    return null;
}
const $c7fe52ac76e0a919$var$Table_A_1_ranges = $c7fe52ac76e0a919$var$createRangeTable("221,13-1b,5f-,40-10,51-f,11-3,3-3,2-2,2-4,8,2,15,2d,28-8,88,48,27-,3-5,11-20,27-,8,28,3-5,12,18,b-a,1c-4,6-16,2-d,2-2,2,1b-4,17-9,8f-,10,f,1f-2,1c-34,33-14e,4,36-,13-,6-2,1a-f,4,9-,3-,17,8,2-2,5-,2,8-,3-,4-8,2-3,3,6-,16-6,2-,7-3,3-,17,8,3,3,3-,2,6-3,3-,4-a,5,2-6,10-b,4,8,2,4,17,8,3,6-,b,4,4-,2-e,2-4,b-10,4,9-,3-,17,8,3-,5-,9-2,3-,4-7,3-3,3,4-3,c-10,3,7-2,4,5-2,3,2,3-2,3-2,4-2,9,4-3,6-2,4,5-8,2-e,d-d,4,9,4,18,b,6-3,8,4,5-6,3-8,3-3,b-11,3,9,4,18,b,6-3,8,4,5-6,3-6,2,3-3,b-11,3,9,4,18,11-3,7-,4,5-8,2-7,3-3,b-11,3,13-2,19,a,2-,8-2,2-3,7,2,9-11,4-b,3b-3,1e-24,3,2-,3,2-,2-5,5,8,4,2,2-,3,e,4-,6,2,7-,b-,3-21,49,23-5,1c-3,9,25,10-,2-2f,23,6,3,8-2,5-5,1b-45,27-9,2a-,2-3,5b-4,45-4,53-5,8,40,2,5-,8,2,5-,28,2,5-,20,2,5-,8,2,5-,8,8,18,20,2,5-,8,28,14-5,1d-22,56-b,277-8,1e-2,52-e,e,8-a,18-8,15-b,e,4,3-b,5e-2,b-15,10,b-5,59-7,2b-555,9d-3,5b-5,17-,7-,27-,7-,9,2,2,2,20-,36,10,f-,7,14-,4,a,54-3,2-6,6-5,9-,1c-10,13-1d,1c-14,3c-,10-6,32-b,240-30,28-18,c-14,a0,115-,3,66-,b-76,5,5-,1d,24,2,5-2,2,8-,35-2,19,f-10,1d-3,311-37f,1b,5a-b,d7-19,d-3,41,57-,68-4,29-3,5f,29-37,2e-2,25-c,2c-2,4e-3,30,78-3,64-,20,19b7-49,51a7-59,48e-2,38-738,2ba5-5b,222f-,3c-94,8-b,6-4,1b,6,2,3,3,6d-20,16e-f,41-,37-7,2e-2,11-f,5-b,18-,b,14,5-3,6,88-,2,bf-2,7-,7-,7-,4-2,8,8-9,8-2ff,20,5-b,1c-b4,27-,27-cbb1,f7-9,28-2,b5-221,56,48,3-,2-,3-,5,d,2,5,3,42,5-,9,8,1d,5,6,2-2,8,153-3,123-3,33-27fd,a6da-5128,21f-5df,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3-fffd,3,2-1d,61-ff7d");
// @TODO: Make this relative...
const $c7fe52ac76e0a919$var$Table_B_1_flags = "ad,34f,1806,180b,180c,180d,200b,200c,200d,2060,feff".split(",").map((v)=>parseInt(v, 16));
const $c7fe52ac76e0a919$var$Table_B_2_ranges = [
    {
        h: 25,
        s: 32,
        l: 65
    },
    {
        h: 30,
        s: 32,
        e: [
            23
        ],
        l: 127
    },
    {
        h: 54,
        s: 1,
        e: [
            48
        ],
        l: 64,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 57,
        d: 2
    },
    {
        h: 44,
        s: 1,
        l: 17,
        d: 2
    },
    {
        h: 10,
        s: 1,
        e: [
            2,
            6,
            8
        ],
        l: 61,
        d: 2
    },
    {
        h: 16,
        s: 1,
        l: 68,
        d: 2
    },
    {
        h: 84,
        s: 1,
        e: [
            18,
            24,
            66
        ],
        l: 19,
        d: 2
    },
    {
        h: 26,
        s: 32,
        e: [
            17
        ],
        l: 435
    },
    {
        h: 22,
        s: 1,
        l: 71,
        d: 2
    },
    {
        h: 15,
        s: 80,
        l: 40
    },
    {
        h: 31,
        s: 32,
        l: 16
    },
    {
        h: 32,
        s: 1,
        l: 80,
        d: 2
    },
    {
        h: 52,
        s: 1,
        l: 42,
        d: 2
    },
    {
        h: 12,
        s: 1,
        l: 55,
        d: 2
    },
    {
        h: 40,
        s: 1,
        e: [
            38
        ],
        l: 15,
        d: 2
    },
    {
        h: 14,
        s: 1,
        l: 48,
        d: 2
    },
    {
        h: 37,
        s: 48,
        l: 49
    },
    {
        h: 148,
        s: 1,
        l: 6351,
        d: 2
    },
    {
        h: 88,
        s: 1,
        l: 160,
        d: 2
    },
    {
        h: 15,
        s: 16,
        l: 704
    },
    {
        h: 25,
        s: 26,
        l: 854
    },
    {
        h: 25,
        s: 32,
        l: 55915
    },
    {
        h: 37,
        s: 40,
        l: 1247
    },
    {
        h: 25,
        s: -119711,
        l: 53248
    },
    {
        h: 25,
        s: -119763,
        l: 52
    },
    {
        h: 25,
        s: -119815,
        l: 52
    },
    {
        h: 25,
        s: -119867,
        e: [
            1,
            4,
            5,
            7,
            8,
            11,
            12,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -119919,
        l: 52
    },
    {
        h: 24,
        s: -119971,
        e: [
            2,
            7,
            8,
            17
        ],
        l: 52
    },
    {
        h: 24,
        s: -120023,
        e: [
            2,
            7,
            13,
            15,
            16,
            17
        ],
        l: 52
    },
    {
        h: 25,
        s: -120075,
        l: 52
    },
    {
        h: 25,
        s: -120127,
        l: 52
    },
    {
        h: 25,
        s: -120179,
        l: 52
    },
    {
        h: 25,
        s: -120231,
        l: 52
    },
    {
        h: 25,
        s: -120283,
        l: 52
    },
    {
        h: 25,
        s: -120335,
        l: 52
    },
    {
        h: 24,
        s: -119543,
        e: [
            17
        ],
        l: 56
    },
    {
        h: 24,
        s: -119601,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119659,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119717,
        e: [
            17
        ],
        l: 58
    },
    {
        h: 24,
        s: -119775,
        e: [
            17
        ],
        l: 58
    }
];
const $c7fe52ac76e0a919$var$Table_B_2_lut_abs = $c7fe52ac76e0a919$var$createTable("b5:3bc,c3:ff,7:73,2:253,5:254,3:256,1:257,5:259,1:25b,3:260,1:263,2:269,1:268,5:26f,1:272,2:275,7:280,3:283,5:288,3:28a,1:28b,5:292,3f:195,1:1bf,29:19e,125:3b9,8b:3b2,1:3b8,1:3c5,3:3c6,1:3c0,1a:3ba,1:3c1,1:3c3,2:3b8,1:3b5,1bc9:3b9,1c:1f76,1:1f77,f:1f7a,1:1f7b,d:1f78,1:1f79,1:1f7c,1:1f7d,107:63,5:25b,4:68,1:68,1:68,3:69,1:69,1:6c,3:6e,4:70,1:71,1:72,1:72,1:72,7:7a,2:3c9,2:7a,2:6b,1:e5,1:62,1:63,3:65,1:66,2:6d,b:3b3,1:3c0,6:64,1b574:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3,20:3b8,1a:3c3");
const $c7fe52ac76e0a919$var$Table_B_2_lut_rel = $c7fe52ac76e0a919$var$createTable("179:1,2:1,2:1,5:1,2:1,a:4f,a:1,8:1,2:1,2:1,3:1,5:1,3:1,4:1,2:1,3:1,4:1,8:2,1:1,2:2,1:1,2:2,27:2,195:26,2:25,1:25,1:25,2:40,2:3f,1:3f,33:1,11:-6,1:-9,1ac7:-3a,6d:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,b:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,c:-8,2:-8,2:-8,2:-8,9:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,1:-8,49:-8,1:-8,1:-4a,1:-4a,d:-56,1:-56,1:-56,1:-56,d:-8,1:-8,f:-8,1:-8,3:-7");
const $c7fe52ac76e0a919$var$Table_B_2_complex = $c7fe52ac76e0a919$var$createTable("df:00730073,51:00690307,19:02BC006E,a7:006A030C,18a:002003B9,16:03B903080301,20:03C503080301,1d7:05650582,190f:00680331,1:00740308,1:0077030A,1:0079030A,1:006102BE,b6:03C50313,2:03C503130300,2:03C503130301,2:03C503130342,2a:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F0003B9,1:1F0103B9,1:1F0203B9,1:1F0303B9,1:1F0403B9,1:1F0503B9,1:1F0603B9,1:1F0703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F2003B9,1:1F2103B9,1:1F2203B9,1:1F2303B9,1:1F2403B9,1:1F2503B9,1:1F2603B9,1:1F2703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,1:1F6003B9,1:1F6103B9,1:1F6203B9,1:1F6303B9,1:1F6403B9,1:1F6503B9,1:1F6603B9,1:1F6703B9,3:1F7003B9,1:03B103B9,1:03AC03B9,2:03B10342,1:03B1034203B9,5:03B103B9,6:1F7403B9,1:03B703B9,1:03AE03B9,2:03B70342,1:03B7034203B9,5:03B703B9,6:03B903080300,1:03B903080301,3:03B90342,1:03B903080342,b:03C503080300,1:03C503080301,1:03C10313,2:03C50342,1:03C503080342,b:1F7C03B9,1:03C903B9,1:03CE03B9,2:03C90342,1:03C9034203B9,5:03C903B9,ac:00720073,5b:00B00063,6:00B00066,d:006E006F,a:0073006D,1:00740065006C,1:0074006D,124f:006800700061,2:00610075,2:006F0076,b:00700061,1:006E0061,1:03BC0061,1:006D0061,1:006B0061,1:006B0062,1:006D0062,1:00670062,3:00700066,1:006E0066,1:03BC0066,4:0068007A,1:006B0068007A,1:006D0068007A,1:00670068007A,1:00740068007A,15:00700061,1:006B00700061,1:006D00700061,1:006700700061,8:00700076,1:006E0076,1:03BC0076,1:006D0076,1:006B0076,1:006D0076,1:00700077,1:006E0077,1:03BC0077,1:006D0077,1:006B0077,1:006D0077,1:006B03C9,1:006D03C9,2:00620071,3:00632215006B0067,1:0063006F002E,1:00640062,1:00670079,2:00680070,2:006B006B,1:006B006D,9:00700068,2:00700070006D,1:00700072,2:00730076,1:00770062,c723:00660066,1:00660069,1:0066006C,1:006600660069,1:00660066006C,1:00730074,1:00730074,d:05740576,1:05740565,1:0574056B,1:057E0576,1:0574056D", $c7fe52ac76e0a919$var$bytes2);
const $c7fe52ac76e0a919$var$Table_C_ranges = $c7fe52ac76e0a919$var$createRangeTable("80-20,2a0-,39c,32,f71,18e,7f2-f,19-7,30-4,7-5,f81-b,5,a800-20ff,4d1-1f,110,fa-6,d174-7,2e84-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,ffff-,2,1f-5f,ff7f-20001");
function $c7fe52ac76e0a919$var$flatten(values) {
    return values.reduce((accum, value)=>{
        value.forEach((value)=>{
            accum.push(value);
        });
        return accum;
    }, []);
}
function $c7fe52ac76e0a919$export$d1ae0d802533bef0(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_A_1_ranges);
}
function $c7fe52ac76e0a919$export$9630a1f26a43b76c(codepoint) {
    let range = $c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_B_2_ranges);
    if (range) return [
        codepoint + range.s
    ];
    let codes = $c7fe52ac76e0a919$var$Table_B_2_lut_abs[codepoint];
    if (codes) return codes;
    let shift = $c7fe52ac76e0a919$var$Table_B_2_lut_rel[codepoint];
    if (shift) return [
        codepoint + shift[0]
    ];
    let complex = $c7fe52ac76e0a919$var$Table_B_2_complex[codepoint];
    if (complex) return complex;
    return null;
}
function $c7fe52ac76e0a919$export$e07a548cae6d1553(codepoint) {
    return !!$c7fe52ac76e0a919$var$matchMap(codepoint, $c7fe52ac76e0a919$var$Table_C_ranges);
}
function $c7fe52ac76e0a919$export$94f0b6f93c619bc(value) {
    // This allows platforms with incomplete normalize to bypass
    // it for very basic names which the built-in toLowerCase
    // will certainly handle correctly
    if (value.match(/^[a-z0-9-]*$/i) && value.length <= 59) return value.toLowerCase();
    // Get the code points (keeping the current normalization)
    let codes = (0, $aCHl8.toUtf8CodePoints)(value);
    codes = $c7fe52ac76e0a919$var$flatten(codes.map((code)=>{
        // Substitute Table B.1 (Maps to Nothing)
        if ($c7fe52ac76e0a919$var$Table_B_1_flags.indexOf(code) >= 0) return [];
        if (code >= 0xfe00 && code <= 0xfe0f) return [];
        // Substitute Table B.2 (Case Folding)
        let codesTableB2 = $c7fe52ac76e0a919$export$9630a1f26a43b76c(code);
        if (codesTableB2) return codesTableB2;
        // No Substitution
        return [
            code
        ];
    }));
    // Normalize using form KC
    codes = (0, $aCHl8.toUtf8CodePoints)((0, $aCHl8._toUtf8String)(codes), (0, $aCHl8.UnicodeNormalizationForm).NFKC);
    // Prohibit Tables C.1.2, C.2.2, C.3, C.4, C.5, C.6, C.7, C.8, C.9
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$e07a548cae6d1553(code)) throw new Error("STRINGPREP_CONTAINS_PROHIBITED");
    });
    // Prohibit Unassigned Code Points (Table A.1)
    codes.forEach((code)=>{
        if ($c7fe52ac76e0a919$export$d1ae0d802533bef0(code)) throw new Error("STRINGPREP_CONTAINS_UNASSIGNED");
    });
    // IDNA extras
    let name = (0, $aCHl8._toUtf8String)(codes);
    // IDNA: 4.2.3.1
    if (name.substring(0, 1) === "-" || name.substring(2, 4) === "--" || name.substring(name.length - 1) === "-") throw new Error("invalid hyphen");
    return name;
}

});

parcelRegister("aGsqH", function(module, exports) {

$parcel$export(module.exports, "commify", function () { return $7c73e12934bd116b$export$de1294767e6ef661; });
$parcel$export(module.exports, "formatUnits", function () { return $7c73e12934bd116b$export$bd39b96f71da1885; });
$parcel$export(module.exports, "parseUnits", function () { return $7c73e12934bd116b$export$203ae30b4f6490b3; });
$parcel$export(module.exports, "formatEther", function () { return $7c73e12934bd116b$export$11bc63b4c03ea518; });
$parcel$export(module.exports, "parseEther", function () { return $7c73e12934bd116b$export$642c4e67bbdc0bc7; });

var $kA3tC = parcelRequire("kA3tC");

var $8bxC3 = parcelRequire("8bxC3");

var $1vVbB = parcelRequire("1vVbB");
"use strict";
const $7c73e12934bd116b$var$logger = new (0, $8bxC3.Logger)((0, $1vVbB.version));
const $7c73e12934bd116b$var$names = [
    "wei",
    "kwei",
    "mwei",
    "gwei",
    "szabo",
    "finney",
    "ether"
];
function $7c73e12934bd116b$export$de1294767e6ef661(value) {
    const comps = String(value).split(".");
    if (comps.length > 2 || !comps[0].match(/^-?[0-9]*$/) || comps[1] && !comps[1].match(/^[0-9]*$/) || value === "." || value === "-.") $7c73e12934bd116b$var$logger.throwArgumentError("invalid value", "value", value);
    // Make sure we have at least one whole digit (0 if none)
    let whole = comps[0];
    let negative = "";
    if (whole.substring(0, 1) === "-") {
        negative = "-";
        whole = whole.substring(1);
    }
    // Make sure we have at least 1 whole digit with no leading zeros
    while(whole.substring(0, 1) === "0")whole = whole.substring(1);
    if (whole === "") whole = "0";
    let suffix = "";
    if (comps.length === 2) suffix = "." + (comps[1] || "0");
    while(suffix.length > 2 && suffix[suffix.length - 1] === "0")suffix = suffix.substring(0, suffix.length - 1);
    const formatted = [];
    while(whole.length)if (whole.length <= 3) {
        formatted.unshift(whole);
        break;
    } else {
        const index = whole.length - 3;
        formatted.unshift(whole.substring(index));
        whole = whole.substring(0, index);
    }
    return negative + formatted.join(",") + suffix;
}
function $7c73e12934bd116b$export$bd39b96f71da1885(value, unitName) {
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $kA3tC.formatFixed)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$203ae30b4f6490b3(value, unitName) {
    if (typeof value !== "string") $7c73e12934bd116b$var$logger.throwArgumentError("value must be a string", "value", value);
    if (typeof unitName === "string") {
        const index = $7c73e12934bd116b$var$names.indexOf(unitName);
        if (index !== -1) unitName = 3 * index;
    }
    return (0, $kA3tC.parseFixed)(value, unitName != null ? unitName : 18);
}
function $7c73e12934bd116b$export$11bc63b4c03ea518(wei) {
    return $7c73e12934bd116b$export$bd39b96f71da1885(wei, 18);
}
function $7c73e12934bd116b$export$642c4e67bbdc0bc7(ether) {
    return $7c73e12934bd116b$export$203ae30b4f6490b3(ether, 18);
}

});
parcelRegister("1vVbB", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $11a50bae04d522a1$export$83d89fbfd8236492; });
const $11a50bae04d522a1$export$83d89fbfd8236492 = "units/5.7.0";

});



parcelRegister("8UXwq", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $67e1b984ae1fe502$export$83d89fbfd8236492; });
const $67e1b984ae1fe502$export$83d89fbfd8236492 = "ethers/5.7.2";

});







parcelRegister("jwzbH", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e36c4d06e1a0341c$require$Buffer = $ihoyg.Buffer;
"use strict";
var $e36c4d06e1a0341c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e36c4d06e1a0341c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e36c4d06e1a0341c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e36c4d06e1a0341c$var$__createBinding(result, mod, k);
    }
    $e36c4d06e1a0341c$var$__setModuleDefault(result, mod);
    return result;
};
var $e36c4d06e1a0341c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e36c4d06e1a0341c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BIP32Adapter = void 0;
parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

const $e36c4d06e1a0341c$var$bip32 = $e36c4d06e1a0341c$var$__importStar((parcelRequire("8AB7q")));

const $e36c4d06e1a0341c$var$bs58check_1 = $e36c4d06e1a0341c$var$__importDefault((parcelRequire("1Vf4C")));

const $e36c4d06e1a0341c$var$p_lazy_1 = $e36c4d06e1a0341c$var$__importDefault((parcelRequire("gGdnO")));

var $cVeOu = parcelRequire("cVeOu");

var $g9AM3 = parcelRequire("g9AM3");

var $liWrL = parcelRequire("liWrL");
let $e36c4d06e1a0341c$var$btccryptoInstance;

const $e36c4d06e1a0341c$var$btccryptoReady = $e36c4d06e1a0341c$var$p_lazy_1.default.from(()=>$e36c4d06e1a0341c$var$__awaiter(void 0, void 0, void 0, function*() {
        $e36c4d06e1a0341c$var$btccryptoInstance = (yield Promise.resolve().then(function() {
            return Promise.resolve((parcelRequire("1JUZg")));
        }).then((res)=>$e36c4d06e1a0341c$var$__importStar(res))).crypto;
    }));
class $e36c4d06e1a0341c$var$BIP32Adapter extends $liWrL.ECPairAdapter {
    /**
     * If you're inheriting from this class, be sure to call `await BIP32Adapter.prepare()` in your `create()` overload.
     */ constructor(node, chainCode, publicKey, networkOrParent, index){
        super(node, publicKey, networkOrParent instanceof $e36c4d06e1a0341c$var$BIP32Adapter ? networkOrParent.network : networkOrParent);
        this._children = new Map();
        this.node = node;
        this._chainCode = chainCode;
        this._publicKey = publicKey;
        this.index = index !== null && index !== void 0 ? index : 0;
        if (networkOrParent instanceof $e36c4d06e1a0341c$var$BIP32Adapter) this._parent = networkOrParent;
        if (node.explicitPath) {
            $g9AM3.Path.assert(node.explicitPath);
            this._explicitPath = node.explicitPath;
        }
    }
    static prepare() {
        return $e36c4d06e1a0341c$var$__awaiter(this, void 0, void 0, function*() {
            // Must await superclass's prepare() so it can do its lazy-loading.
            yield Promise.all([
                (yield $e36c4d06e1a0341c$var$btccryptoReady),
                $liWrL.ECPairAdapter.prepare()
            ]);
        });
    }
    static create(isolatedNode, networkOrParent, index) {
        return $e36c4d06e1a0341c$var$__awaiter(this, void 0, void 0, function*() {
            yield this.prepare();
            return new $e36c4d06e1a0341c$var$BIP32Adapter(isolatedNode, (yield isolatedNode.getChainCode()), (yield isolatedNode.getPublicKey()), networkOrParent, index);
        });
    }
    get depth() {
        return this.path ? (0, $7NkOr.bip32ToAddressNList)(this.path).length : 0;
    }
    get chainCode() {
        return $e36c4d06e1a0341c$require$Buffer.from(this._chainCode);
    }
    getChainCode() {
        return this.chainCode;
    }
    get identifier() {
        var _a;
        return this._identifier = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (_a = this._identifier) !== null && _a !== void 0 ? _a : $e36c4d06e1a0341c$var$btccryptoInstance.hash160($e36c4d06e1a0341c$require$Buffer.from($cVeOu.SecP256K1.CompressedPoint.from(this.publicKey)));
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get parentFingerprint() {
        return this._parent ? this._parent.fingerprint.readUInt32BE(0) : 0;
    }
    get path() {
        var _a;
        if (this._explicitPath) return this._explicitPath;
        if (!this._parent) return "";
        let parentPath = (_a = this._parent.path) !== null && _a !== void 0 ? _a : "";
        if (parentPath === "") parentPath = "m";
        const hardened = this.index >= 0x80000000;
        const index = hardened ? this.index - 0x80000000 : this.index;
        return `${parentPath}/${index}${hardened ? "'" : ""}`;
    }
    get publicKey() {
        return $e36c4d06e1a0341c$require$Buffer.from($cVeOu.SecP256K1.CompressedPoint.from(this._publicKey));
    }
    getPublicKey() {
        return this.publicKey;
    }
    isNeutered() {
        return false;
    }
    neutered() {
        if (!this._base58) {
            const xpub = $e36c4d06e1a0341c$require$Buffer.alloc(78);
            xpub.writeUInt32BE(this.network.bip32.public, 0);
            xpub.writeUInt8(this.depth, 4);
            xpub.writeUInt32BE(this.parentFingerprint, 5);
            xpub.writeUInt32BE(this.index, 9);
            xpub.set(this.chainCode, 13);
            xpub.set(this.publicKey, 45);
            this._base58 = $e36c4d06e1a0341c$var$bs58check_1.default.encode(xpub);
        }
        return $e36c4d06e1a0341c$var$bip32.fromBase58(this._base58, this.network);
    }
    toBase58() {
        throw new $cVeOu.IsolationError("xprv");
    }
    derive(index) {
        return $e36c4d06e1a0341c$var$__awaiter(this, void 0, void 0, function*() {
            let out = this._children.get(index);
            if (!out) {
                out = yield $e36c4d06e1a0341c$var$BIP32Adapter.create((yield this.node.derive(index)), this, index);
                this._children.set(index, out);
            }
            return out;
        });
    }
    deriveHardened(index) {
        return $e36c4d06e1a0341c$var$__awaiter(this, void 0, void 0, function*() {
            return yield this.derive(index + 0x80000000);
        });
    }
    derivePath(path) {
        return $e36c4d06e1a0341c$var$__awaiter(this, void 0, void 0, function*() {
            /**
             * If a non-root explicit path has been set, we cannot construct
             * a full representation of the BIP32 key tree and therefore may
             * only derive keys for nodes that are children of this one.
             */ if (this._explicitPath) {
                if (!(path.startsWith(this._explicitPath) && path.length >= this._explicitPath.length)) throw new Error("path is not a child of this node");
            }
            const ownPath = this.path;
            if (path.startsWith(ownPath)) path = path.slice(ownPath.length);
            if (path.startsWith("/")) path = path.slice(1);
            if (/^m/.test(path) && this._parent) throw new Error("expected master, got child");
            return yield $cVeOu.BIP32.derivePath(this, path);
        });
    }
}
module.exports.BIP32Adapter = $e36c4d06e1a0341c$var$BIP32Adapter;
module.exports.default = $e36c4d06e1a0341c$var$BIP32Adapter;

});

parcelRegister("2rr6y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $1c7320d6c2f2e2c7$require$Buffer = $ihoyg.Buffer;
"use strict";
var $1c7320d6c2f2e2c7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1c7320d6c2f2e2c7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $1c7320d6c2f2e2c7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1c7320d6c2f2e2c7$var$__createBinding(result, mod, k);
    }
    $1c7320d6c2f2e2c7$var$__setModuleDefault(result, mod);
    return result;
};
var $1c7320d6c2f2e2c7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignerAdapter = void 0;

const $1c7320d6c2f2e2c7$var$core = $1c7320d6c2f2e2c7$var$__importStar((parcelRequire("lFpDy")));

var $frVBT = parcelRequire("frVBT");

var $esOfL = parcelRequire("esOfL");

var $8iu5n = parcelRequire("8iu5n");

var $byiQW = parcelRequire("byiQW");

var $cVeOu = parcelRequire("cVeOu");
function $1c7320d6c2f2e2c7$var$ethSigFromRecoverableSig(x) {
    const sig = $cVeOu.SecP256K1.RecoverableSignature.sig(x);
    const recoveryParam = $cVeOu.SecP256K1.RecoverableSignature.recoveryParam(x);
    return (0, $8iu5n.splitSignature)($1c7320d6c2f2e2c7$var$core.compatibleBufferConcat([
        sig,
        $1c7320d6c2f2e2c7$require$Buffer.from([
            recoveryParam
        ])
    ]));
}
class $1c7320d6c2f2e2c7$var$SignerAdapter {
    constructor(nodeAdapter, provider){
        this.nodeAdapter = nodeAdapter;
        this.provider = provider;
    }
    // This throws (as allowed by ethers.Signer) to avoid having to return an object which is initialized asynchronously
    // from a synchronous function. Because all the (other) methods on SignerAdapter are async, one could construct a
    // wrapper that deferred its initialization and awaited it before calling through to a "real" method, but that's
    // a lot of complexity just to implement this one method we don't actually use.
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    connect(_provider) {
        throw new Error("changing providers on a SignerAdapter is unsupported");
    }
    getAddress(addressNList) {
        return $1c7320d6c2f2e2c7$var$__awaiter(this, void 0, void 0, function*() {
            const nodeAdapter = yield this.nodeAdapter.derivePath($1c7320d6c2f2e2c7$var$core.addressNListToBIP32(addressNList));
            return (0, $8iu5n.computeAddress)($cVeOu.SecP256K1.UncompressedPoint.from(nodeAdapter.getPublicKey()));
        });
    }
    signDigest(digest, addressNList) {
        return $1c7320d6c2f2e2c7$var$__awaiter(this, void 0, void 0, function*() {
            const nodeAdapter = yield this.nodeAdapter.derivePath($1c7320d6c2f2e2c7$var$core.addressNListToBIP32(addressNList));
            const recoverableSig = yield $cVeOu.SecP256K1.RecoverableSignature.signCanonically(nodeAdapter.node, null, digest instanceof Uint8Array ? digest : (0, $8iu5n.arrayify)(digest));
            const sig = $cVeOu.SecP256K1.RecoverableSignature.sig(recoverableSig);
            const recoveryParam = $cVeOu.SecP256K1.RecoverableSignature.recoveryParam(recoverableSig);
            return (0, $8iu5n.splitSignature)($1c7320d6c2f2e2c7$var$core.compatibleBufferConcat([
                sig,
                $1c7320d6c2f2e2c7$require$Buffer.from([
                    recoveryParam
                ])
            ]));
        });
    }
    signTransaction(transaction, addressNList) {
        return $1c7320d6c2f2e2c7$var$__awaiter(this, void 0, void 0, function*() {
            const tx = yield (0, $8iu5n.resolveProperties)(transaction);
            if (tx.from != null) {
                if ((0, $8iu5n.getAddress)(tx.from) !== (yield this.getAddress(addressNList))) throw new Error("transaction from address mismatch");
                delete tx.from;
            }
            const unsignedTx = Object.assign(Object.assign({}, tx), {
                nonce: tx.nonce !== undefined ? $esOfL.BigNumber.from(tx.nonce).toNumber() : undefined
            });
            const nodeAdapter = yield this.nodeAdapter.derivePath($1c7320d6c2f2e2c7$var$core.addressNListToBIP32(addressNList));
            const txBuf = (0, $8iu5n.arrayify)((0, $8iu5n.serializeTransaction)(unsignedTx));
            const rawSig = yield $cVeOu.SecP256K1.RecoverableSignature.signCanonically(nodeAdapter.node, "keccak256", txBuf);
            return (0, $8iu5n.serializeTransaction)(unsignedTx, $1c7320d6c2f2e2c7$var$ethSigFromRecoverableSig(rawSig));
        });
    }
    signMessage(messageData, addressNList) {
        return $1c7320d6c2f2e2c7$var$__awaiter(this, void 0, void 0, function*() {
            const messageBuf = (0, $byiQW.buildMessage)(messageData);
            const nodeAdapter = yield this.nodeAdapter.derivePath($1c7320d6c2f2e2c7$var$core.addressNListToBIP32(addressNList));
            const rawSig = yield $cVeOu.SecP256K1.RecoverableSignature.signCanonically(nodeAdapter.node, "keccak256", messageBuf);
            return (0, $8iu5n.joinSignature)($1c7320d6c2f2e2c7$var$ethSigFromRecoverableSig(rawSig));
        });
    }
    signTypedData(typedData, addressNList) {
        return $1c7320d6c2f2e2c7$var$__awaiter(this, void 0, void 0, function*() {
            const address = yield this.getAddress(addressNList);
            const messageArray = (0, $frVBT.getMessage)(typedData);
            const nodeAdapter = yield this.nodeAdapter.derivePath($1c7320d6c2f2e2c7$var$core.addressNListToBIP32(addressNList));
            const rawSig = yield $cVeOu.SecP256K1.RecoverableSignature.signCanonically(nodeAdapter.node, "keccak256", messageArray);
            const signature = (0, $8iu5n.joinSignature)($1c7320d6c2f2e2c7$var$ethSigFromRecoverableSig(rawSig));
            return {
                address: address,
                signature: signature
            };
        });
    }
}
module.exports.SignerAdapter = $1c7320d6c2f2e2c7$var$SignerAdapter;
module.exports.default = $1c7320d6c2f2e2c7$var$SignerAdapter;

});
parcelRegister("frVBT", function(module, exports) {

$parcel$export(module.exports, "getMessage", function () { return $b3f610d08b3c1b41$export$2e51780da3c3a61; });

var $dx9Gq = parcelRequire("dx9Gq");

var $aMYPV = parcelRequire("aMYPV");

var $gDy7n = parcelRequire("gDy7n");
var $5Xayl = parcelRequire("5Xayl");
var $9dLGH = parcelRequire("9dLGH");

var $ihoyg = parcelRequire("ihoyg");
var $b3f610d08b3c1b41$require$Buffer = $ihoyg.Buffer;
const $b3f610d08b3c1b41$var$EIP_191_PREFIX = $b3f610d08b3c1b41$require$Buffer.from("1901", "hex");
const $b3f610d08b3c1b41$export$75915f81f2a6540a = (typedData, type, options, dependencies = [])=>{
    if (!(0, $9dLGH.validateTypedData)(typedData, options)) throw new Error("Typed data does not match JSON schema");
    const match = type.match((0, $aMYPV.TYPE_REGEX));
    const actualType = match[0];
    if (dependencies.includes(actualType)) return dependencies;
    if (!typedData.types[actualType]) return dependencies;
    return [
        actualType,
        ...typedData.types[actualType].reduce((previous, type)=>[
                ...previous,
                ...$b3f610d08b3c1b41$export$75915f81f2a6540a(typedData, type.type, options, previous).filter((dependency)=>!previous.includes(dependency))
            ], [])
    ];
};
const $b3f610d08b3c1b41$export$432cbecf661dce2b = (typedData, type, options)=>{
    const [primary, ...dependencies] = $b3f610d08b3c1b41$export$75915f81f2a6540a(typedData, type, options);
    const types = [
        primary,
        ...dependencies.sort()
    ];
    return types.map((dependency)=>{
        return `${dependency}(${typedData.types[dependency].map((type)=>`${type.type} ${type.name}`)})`;
    }).join("");
};
const $b3f610d08b3c1b41$export$7153e7a026dc35b8 = (typedData, type, options)=>{
    return (0, $5Xayl.keccak256)($b3f610d08b3c1b41$export$432cbecf661dce2b(typedData, type, options), "utf8");
};
const $b3f610d08b3c1b41$var$encodeValue = (typedData, type, data, options)=>{
    const match = type.match((0, $aMYPV.ARRAY_REGEX));
    if (match) {
        const arrayType = match[1];
        const length = Number(match[2]) || undefined;
        if (!Array.isArray(data)) throw new Error("Cannot encode data: value is not of array type");
        if (length && data.length !== length) throw new Error(`Cannot encode data: expected length of ${length}, but got ${data.length}`);
        const encodedData = data.map((item)=>$b3f610d08b3c1b41$var$encodeValue(typedData, arrayType, item, options));
        const types = encodedData.map((item)=>item[0]);
        const values = encodedData.map((item)=>item[1]);
        return [
            "bytes32",
            (0, $5Xayl.keccak256)((0, $gDy7n.encode)(types, values))
        ];
    }
    if (typedData.types[type]) return [
        "bytes32",
        $b3f610d08b3c1b41$export$e97e09dfa54f07bc(typedData, type, data, options)
    ];
    if (type === "string") return [
        "bytes32",
        (0, $5Xayl.keccak256)(data, "utf8")
    ];
    if (type === "bytes") return [
        "bytes32",
        (0, $5Xayl.keccak256)($b3f610d08b3c1b41$require$Buffer.isBuffer(data) ? data : (0, $5Xayl.toBuffer)(data), "hex")
    ];
    return [
        type,
        data
    ];
};
const $b3f610d08b3c1b41$export$cfdd1f2478131e3d = (typedData, type, data, options)=>{
    const [types, values] = typedData.types[type].reduce(([types, values], field)=>{
        if (data[field.name] === undefined || data[field.name] === null) throw new Error(`Cannot encode data: missing data for '${field.name}'`);
        const value = data[field.name];
        const [type, encodedValue] = $b3f610d08b3c1b41$var$encodeValue(typedData, field.type, value, options);
        return [
            [
                ...types,
                type
            ],
            [
                ...values,
                encodedValue
            ]
        ];
    }, [
        [
            "bytes32"
        ],
        [
            $b3f610d08b3c1b41$export$7153e7a026dc35b8(typedData, type, options)
        ]
    ]);
    return (0, $gDy7n.encode)(types, values);
};
const $b3f610d08b3c1b41$export$e97e09dfa54f07bc = (typedData, type, data, options)=>{
    return (0, $5Xayl.keccak256)($b3f610d08b3c1b41$export$cfdd1f2478131e3d(typedData, type, data, options));
};
const $b3f610d08b3c1b41$export$2e51780da3c3a61 = (typedData, hash, options)=>{
    const { domain: domain } = (0, $dx9Gq.getOptions)(options);
    const message = $b3f610d08b3c1b41$require$Buffer.concat([
        $b3f610d08b3c1b41$var$EIP_191_PREFIX,
        $b3f610d08b3c1b41$export$e97e09dfa54f07bc(typedData, domain, typedData.domain, options),
        $b3f610d08b3c1b41$export$e97e09dfa54f07bc(typedData, typedData.primaryType, typedData.message, options)
    ]);
    if (hash) return (0, $5Xayl.keccak256)(message);
    return message;
};
const $b3f610d08b3c1b41$export$75093a47a9fa838d = (typedData, type = typedData.primaryType, data = typedData.message, options)=>{
    if (!(0, $9dLGH.validateTypedData)(typedData, options)) throw new Error("Typed data does not match JSON schema");
    if (!typedData.types[type]) throw new Error("Cannot get data as array: type does not exist");
    return typedData.types[type].reduce((array, { name: name, type: type })=>{
        if (typedData.types[type]) {
            if (!data[name]) throw new Error(`Cannot get data as array: missing data for '${name}'`);
            return [
                ...array,
                $b3f610d08b3c1b41$export$75093a47a9fa838d(typedData, type, data[name], options)
            ];
        }
        const value = data[name];
        return [
            ...array,
            value
        ];
    }, []);
};

});
parcelRegister("dx9Gq", function(module, exports) {

$parcel$export(module.exports, "getOptions", function () { return $9da5de560ea3512d$export$d2312e68e1f5ad00; });

var $g3KvW = parcelRequire("g3KvW");
const $9da5de560ea3512d$export$11e9d0948f9cbf3 = (0, $g3KvW.object)({
    domain: (0, $g3KvW.defaulted)((0, $g3KvW.string)(), "EIP712Domain"),
    verifyDomain: (0, $g3KvW.defaulted)((0, $g3KvW.boolean)(), true)
});
const $9da5de560ea3512d$export$d2312e68e1f5ad00 = (options)=>{
    return (0, $g3KvW.create)(options ?? {}, $9da5de560ea3512d$export$11e9d0948f9cbf3);
};

});
parcelRegister("g3KvW", function(module, exports) {

$parcel$export(module.exports, "create", function () { return $bb1101e69dcd6f1d$export$185802fd694ee1f5; });
$parcel$export(module.exports, "is", function () { return $bb1101e69dcd6f1d$export$226b3eccf92c9ed9; });
$parcel$export(module.exports, "assign", function () { return $bb1101e69dcd6f1d$export$e6e34fd1f2686227; });
$parcel$export(module.exports, "object", function () { return $bb1101e69dcd6f1d$export$be5493f9613cbbe; });
$parcel$export(module.exports, "optional", function () { return $bb1101e69dcd6f1d$export$516e28dec6a4b6d4; });
$parcel$export(module.exports, "array", function () { return $bb1101e69dcd6f1d$export$2f23118c22fb2630; });
$parcel$export(module.exports, "boolean", function () { return $bb1101e69dcd6f1d$export$4a21f16c33752377; });
$parcel$export(module.exports, "number", function () { return $bb1101e69dcd6f1d$export$98e628dec113755e; });
$parcel$export(module.exports, "record", function () { return $bb1101e69dcd6f1d$export$e5185e241753e543; });
$parcel$export(module.exports, "string", function () { return $bb1101e69dcd6f1d$export$22b082955e083ec3; });
$parcel$export(module.exports, "union", function () { return $bb1101e69dcd6f1d$export$971dd5b0dfd021b6; });
$parcel$export(module.exports, "defaulted", function () { return $bb1101e69dcd6f1d$export$83c510c4356017ae; });
$parcel$export(module.exports, "refine", function () { return $bb1101e69dcd6f1d$export$edc9d475108b3212; });
$parcel$export(module.exports, "pattern", function () { return $bb1101e69dcd6f1d$export$24f82734ea047e6f; });
/**
 * A `StructFailure` represents a single specific failure in validation.
 */ /**
 * `StructError` objects are thrown (or returned) when validation fails.
 *
 * Validation logic is design to exit early for maximum performance. The error
 * represents the first error encountered during validation. For more detail,
 * the `error.failures` property is a generator function that can be run to
 * continue validation and receive all the failures in the data.
 */ class $bb1101e69dcd6f1d$export$58cc9131e3e8861b extends TypeError {
    constructor(failure, failures){
        let cached;
        const { message: message, ...rest } = failure;
        const { path: path } = failure;
        const msg = path.length === 0 ? message : "At path: " + path.join(".") + " -- " + message;
        super(msg);
        this.value = void 0;
        this.key = void 0;
        this.type = void 0;
        this.refinement = void 0;
        this.path = void 0;
        this.branch = void 0;
        this.failures = void 0;
        Object.assign(this, rest);
        this.name = this.constructor.name;
        this.failures = ()=>{
            var _cached;
            return (_cached = cached) != null ? _cached : cached = [
                failure,
                ...failures()
            ];
        };
    }
}
/**
 * Check if a value is an iterator.
 */ function $bb1101e69dcd6f1d$var$isIterable(x) {
    return $bb1101e69dcd6f1d$var$isObject(x) && typeof x[Symbol.iterator] === "function";
}
/**
 * Check if a value is a plain object.
 */ function $bb1101e69dcd6f1d$var$isObject(x) {
    return typeof x === "object" && x != null;
}
/**
 * Check if a value is a plain object.
 */ function $bb1101e69dcd6f1d$var$isPlainObject(x) {
    if (Object.prototype.toString.call(x) !== "[object Object]") return false;
    const prototype = Object.getPrototypeOf(x);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Return a value as a printable string.
 */ function $bb1101e69dcd6f1d$var$print(value) {
    return typeof value === "string" ? JSON.stringify(value) : "" + value;
}
/**
 * Shifts (removes and returns) the first value from the `input` iterator.
 * Like `Array.prototype.shift()` but for an `Iterator`.
 */ function $bb1101e69dcd6f1d$var$shiftIterator(input) {
    const { done: done, value: value } = input.next();
    return done ? undefined : value;
}
/**
 * Convert a single validation result to a failure.
 */ function $bb1101e69dcd6f1d$var$toFailure(result, context, struct, value) {
    if (result === true) return;
    else if (result === false) result = {};
    else if (typeof result === "string") result = {
        message: result
    };
    const { path: path, branch: branch } = context;
    const { type: type } = struct;
    const { refinement: refinement, message: message = "Expected a value of type `" + type + "`" + (refinement ? " with refinement `" + refinement + "`" : "") + ", but received: `" + $bb1101e69dcd6f1d$var$print(value) + "`" } = result;
    return {
        value: value,
        type: type,
        refinement: refinement,
        key: path[path.length - 1],
        path: path,
        branch: branch,
        ...result,
        message: message
    };
}
/**
 * Convert a validation result to an iterable of failures.
 */ function* $bb1101e69dcd6f1d$var$toFailures(result, context, struct, value) {
    if (!$bb1101e69dcd6f1d$var$isIterable(result)) result = [
        result
    ];
    for (const r of result){
        const failure = $bb1101e69dcd6f1d$var$toFailure(r, context, struct, value);
        if (failure) yield failure;
    }
}
/**
 * Check a value against a struct, traversing deeply into nested values, and
 * returning an iterator of failures or success.
 */ function* $bb1101e69dcd6f1d$var$run(value, struct, options) {
    if (options === void 0) options = {};
    const { path: path = [], branch: branch = [
        value
    ], coerce: coerce = false, mask: mask = false } = options;
    const ctx = {
        path: path,
        branch: branch
    };
    if (coerce) {
        value = struct.coercer(value, ctx);
        if (mask && struct.type !== "type" && $bb1101e69dcd6f1d$var$isObject(struct.schema) && $bb1101e69dcd6f1d$var$isObject(value) && !Array.isArray(value)) {
            for(const key in value)if (struct.schema[key] === undefined) delete value[key];
        }
    }
    let valid = true;
    for (const failure of struct.validator(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    for (let [k, v, s] of struct.entries(value, ctx)){
        const ts = $bb1101e69dcd6f1d$var$run(v, s, {
            path: k === undefined ? path : [
                ...path,
                k
            ],
            branch: k === undefined ? branch : [
                ...branch,
                v
            ],
            coerce: coerce,
            mask: mask
        });
        for (const t of ts){
            if (t[0]) {
                valid = false;
                yield [
                    t[0],
                    undefined
                ];
            } else if (coerce) {
                v = t[1];
                if (k === undefined) value = v;
                else if (value instanceof Map) value.set(k, v);
                else if (value instanceof Set) value.add(v);
                else if ($bb1101e69dcd6f1d$var$isObject(value)) value[k] = v;
            }
        }
    }
    if (valid) for (const failure of struct.refiner(value, ctx)){
        valid = false;
        yield [
            failure,
            undefined
        ];
    }
    if (valid) yield [
        undefined,
        value
    ];
}
/**
 * `Struct` objects encapsulate the validation logic for a specific type of
 * values. Once constructed, you use the `assert`, `is` or `validate` helpers to
 * validate unknown input data against the struct.
 */ class $bb1101e69dcd6f1d$export$eabc71f011df675a {
    constructor(props){
        this.TYPE = void 0;
        this.type = void 0;
        this.schema = void 0;
        this.coercer = void 0;
        this.validator = void 0;
        this.refiner = void 0;
        this.entries = void 0;
        const { type: type, schema: schema, validator: validator, refiner: refiner, coercer: coercer = (value)=>value, entries: entries = function*() {} } = props;
        this.type = type;
        this.schema = schema;
        this.entries = entries;
        this.coercer = coercer;
        if (validator) this.validator = (value, context)=>{
            const result = validator(value, context);
            return $bb1101e69dcd6f1d$var$toFailures(result, context, this, value);
        };
        else this.validator = ()=>[];
        if (refiner) this.refiner = (value, context)=>{
            const result = refiner(value, context);
            return $bb1101e69dcd6f1d$var$toFailures(result, context, this, value);
        };
        else this.refiner = ()=>[];
    }
    /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */ assert(value) {
        return $bb1101e69dcd6f1d$export$a7a9523472993e97(value, this);
    }
    /**
   * Create a value with the struct's coercion logic, then validate it.
   */ create(value) {
        return $bb1101e69dcd6f1d$export$185802fd694ee1f5(value, this);
    }
    /**
   * Check if a value passes the struct's validation.
   */ is(value) {
        return $bb1101e69dcd6f1d$export$226b3eccf92c9ed9(value, this);
    }
    /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */ mask(value) {
        return $bb1101e69dcd6f1d$export$d99f0801a68bbcf1(value, this);
    }
    /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */ validate(value, options) {
        if (options === void 0) options = {};
        return $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, this, options);
    }
}
/**
 * Assert that a value passes a struct, throwing if it doesn't.
 */ function $bb1101e69dcd6f1d$export$a7a9523472993e97(value, struct) {
    const result = $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, struct);
    if (result[0]) throw result[0];
}
/**
 * Create a value with the coercion logic of struct and validate it.
 */ function $bb1101e69dcd6f1d$export$185802fd694ee1f5(value, struct) {
    const result = $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, struct, {
        coerce: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Mask a value, returning only the subset of properties defined by a struct.
 */ function $bb1101e69dcd6f1d$export$d99f0801a68bbcf1(value, struct) {
    const result = $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, struct, {
        coerce: true,
        mask: true
    });
    if (result[0]) throw result[0];
    else return result[1];
}
/**
 * Check if a value passes a struct.
 */ function $bb1101e69dcd6f1d$export$226b3eccf92c9ed9(value, struct) {
    const result = $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, struct);
    return !result[0];
}
/**
 * Validate a value against a struct, returning an error if invalid, or the
 * value (with potential coercion) if valid.
 */ function $bb1101e69dcd6f1d$export$a22775fa5e2eebd9(value, struct, options) {
    if (options === void 0) options = {};
    const tuples = $bb1101e69dcd6f1d$var$run(value, struct, options);
    const tuple = $bb1101e69dcd6f1d$var$shiftIterator(tuples);
    if (tuple[0]) {
        const error = new $bb1101e69dcd6f1d$export$58cc9131e3e8861b(tuple[0], function*() {
            for (const t of tuples)if (t[0]) yield t[0];
        });
        return [
            error,
            undefined
        ];
    } else {
        const v = tuple[1];
        return [
            undefined,
            v
        ];
    }
}
function $bb1101e69dcd6f1d$export$e6e34fd1f2686227() {
    for(var _len = arguments.length, Structs = new Array(_len), _key = 0; _key < _len; _key++)Structs[_key] = arguments[_key];
    const isType = Structs[0].type === "type";
    const schemas = Structs.map((s)=>s.schema);
    const schema = Object.assign({}, ...schemas);
    return isType ? $bb1101e69dcd6f1d$export$bf9fb029d174d554(schema) : $bb1101e69dcd6f1d$export$be5493f9613cbbe(schema);
}
/**
 * Define a new struct type with a custom validation function.
 */ function $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e(name, validator) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: name,
        schema: null,
        validator: validator
    });
}
/**
 * Create a new struct based on an existing struct, but the value is allowed to
 * be `undefined`. `log` will be called if the value is not `undefined`.
 */ function $bb1101e69dcd6f1d$export$cdd73fc4100a6ef4(struct, log) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        ...struct,
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx),
        validator (value, ctx) {
            if (value === undefined) return true;
            else {
                log(value, ctx);
                return struct.validator(value, ctx);
            }
        }
    });
}
/**
 * Create a struct with dynamic validation logic.
 *
 * The callback will receive the value currently being validated, and must
 * return a struct object to validate it with. This can be useful to model
 * validation logic that changes based on its input.
 */ function $bb1101e69dcd6f1d$export$7077912c31975674(fn) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "dynamic",
        schema: null,
        *entries (value, ctx) {
            const struct = fn(value, ctx);
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            const struct = fn(value, ctx);
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            const struct = fn(value, ctx);
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            const struct = fn(value, ctx);
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a struct with lazily evaluated validation logic.
 *
 * The first time validation is run with the struct, the callback will be called
 * and must return a struct object to use. This is useful for cases where you
 * want to have self-referential structs for nested data structures to avoid a
 * circular definition problem.
 */ function $bb1101e69dcd6f1d$export$488013bae63b21da(fn) {
    let struct;
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "lazy",
        schema: null,
        *entries (value, ctx) {
            var _struct;
            (_struct = struct) != null ? _struct : struct = fn();
            yield* struct.entries(value, ctx);
        },
        validator (value, ctx) {
            var _struct2;
            (_struct2 = struct) != null ? _struct2 : struct = fn();
            return struct.validator(value, ctx);
        },
        coercer (value, ctx) {
            var _struct3;
            (_struct3 = struct) != null ? _struct3 : struct = fn();
            return struct.coercer(value, ctx);
        },
        refiner (value, ctx) {
            var _struct4;
            (_struct4 = struct) != null ? _struct4 : struct = fn();
            return struct.refiner(value, ctx);
        }
    });
}
/**
 * Create a new struct based on an existing object struct, but excluding
 * specific properties.
 *
 * Like TypeScript's `Omit` utility.
 */ function $bb1101e69dcd6f1d$export$30a06c8d3562193f(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {
        ...schema
    };
    for (const key of keys)delete subschema[key];
    switch(struct.type){
        case "type":
            return $bb1101e69dcd6f1d$export$bf9fb029d174d554(subschema);
        default:
            return $bb1101e69dcd6f1d$export$be5493f9613cbbe(subschema);
    }
}
/**
 * Create a new struct based on an existing object struct, but with all of its
 * properties allowed to be `undefined`.
 *
 * Like TypeScript's `Partial` utility.
 */ function $bb1101e69dcd6f1d$export$e45945969df8035a(struct) {
    const schema = struct instanceof $bb1101e69dcd6f1d$export$eabc71f011df675a ? {
        ...struct.schema
    } : {
        ...struct
    };
    for(const key in schema)schema[key] = $bb1101e69dcd6f1d$export$516e28dec6a4b6d4(schema[key]);
    return $bb1101e69dcd6f1d$export$be5493f9613cbbe(schema);
}
/**
 * Create a new struct based on an existing object struct, but only including
 * specific properties.
 *
 * Like TypeScript's `Pick` utility.
 */ function $bb1101e69dcd6f1d$export$357523c63a2253b9(struct, keys) {
    const { schema: schema } = struct;
    const subschema = {};
    for (const key of keys)subschema[key] = schema[key];
    return $bb1101e69dcd6f1d$export$be5493f9613cbbe(subschema);
}
/**
 * Define a new struct type with a custom validation function.
 *
 * @deprecated This function has been renamed to `define`.
 */ function $bb1101e69dcd6f1d$export$8cf3da7c1c9174ea(name, validator) {
    console.warn("superstruct@0.11 - The `struct` helper has been renamed to `define`.");
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e(name, validator);
}
/**
 * Ensure that any value passes validation.
 */ function $bb1101e69dcd6f1d$export$4154a199d7d90455() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("any", ()=>true);
}
function $bb1101e69dcd6f1d$export$2f23118c22fb2630(Element) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "array",
        schema: Element,
        *entries (value) {
            if (Element && Array.isArray(value)) for (const [i, v] of value.entries())yield [
                i,
                v,
                Element
            ];
        },
        coercer (value) {
            return Array.isArray(value) ? value.slice() : value;
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array value, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a bigint.
 */ function $bb1101e69dcd6f1d$export$a0f65b52274bcc00() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("bigint", (value)=>{
        return typeof value === "bigint";
    });
}
/**
 * Ensure that a value is a boolean.
 */ function $bb1101e69dcd6f1d$export$4a21f16c33752377() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("boolean", (value)=>{
        return typeof value === "boolean";
    });
}
/**
 * Ensure that a value is a valid `Date`.
 *
 * Note: this also ensures that the value is *not* an invalid `Date` object,
 * which can occur when parsing a date fails but still returns a `Date`.
 */ function $bb1101e69dcd6f1d$export$324d90190a8b822a() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("date", (value)=>{
        return value instanceof Date && !isNaN(value.getTime()) || "Expected a valid `Date` object, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
function $bb1101e69dcd6f1d$export$9b16c434df8cc259(values) {
    const schema = {};
    const description = values.map((v)=>$bb1101e69dcd6f1d$var$print(v)).join();
    for (const key of values)schema[key] = key;
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "enums",
        schema: schema,
        validator (value) {
            return values.includes(value) || "Expected one of `" + description + "`, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a function.
 */ function $bb1101e69dcd6f1d$export$86951950244e2001() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("func", (value)=>{
        return typeof value === "function" || "Expected a function, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
/**
 * Ensure that a value is an instance of a specific class.
 */ function $bb1101e69dcd6f1d$export$9544d5bb712b01ea(Class) {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("instance", (value)=>{
        return value instanceof Class || "Expected a `" + Class.name + "` instance, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
/**
 * Ensure that a value is an integer.
 */ function $bb1101e69dcd6f1d$export$32744b5b3bba4764() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("integer", (value)=>{
        return typeof value === "number" && !isNaN(value) && Number.isInteger(value) || "Expected an integer, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
/**
 * Ensure that a value matches all of a set of types.
 */ function $bb1101e69dcd6f1d$export$bc86dfbf7795668c(Structs) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "intersection",
        schema: null,
        *entries (value, ctx) {
            for (const S of Structs)yield* S.entries(value, ctx);
        },
        *validator (value, ctx) {
            for (const S of Structs)yield* S.validator(value, ctx);
        },
        *refiner (value, ctx) {
            for (const S of Structs)yield* S.refiner(value, ctx);
        }
    });
}
function $bb1101e69dcd6f1d$export$c8ec6e1ec9fefcb0(constant) {
    const description = $bb1101e69dcd6f1d$var$print(constant);
    const t = typeof constant;
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "literal",
        schema: t === "string" || t === "number" || t === "boolean" ? constant : null,
        validator (value) {
            return value === constant || "Expected the literal `" + description + "`, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
function $bb1101e69dcd6f1d$export$871de8747c9eaa88(Key, Value) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "map",
        schema: null,
        *entries (value) {
            if (Key && Value && value instanceof Map) for (const [k, v] of value.entries()){
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        coercer (value) {
            return value instanceof Map ? new Map(value) : value;
        },
        validator (value) {
            return value instanceof Map || "Expected a `Map` object, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that no value ever passes validation.
 */ function $bb1101e69dcd6f1d$export$b3e22bcfd64c1022() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("never", ()=>false);
}
/**
 * Augment an existing struct to allow `null` values.
 */ function $bb1101e69dcd6f1d$export$133fc36489ac9add(struct) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === null || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === null || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is a number.
 */ function $bb1101e69dcd6f1d$export$98e628dec113755e() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("number", (value)=>{
        return typeof value === "number" && !isNaN(value) || "Expected a number, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
function $bb1101e69dcd6f1d$export$be5493f9613cbbe(schema) {
    const knowns = schema ? Object.keys(schema) : [];
    const Never = $bb1101e69dcd6f1d$export$b3e22bcfd64c1022();
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "object",
        schema: schema ? schema : null,
        *entries (value) {
            if (schema && $bb1101e69dcd6f1d$var$isObject(value)) {
                const unknowns = new Set(Object.keys(value));
                for (const key of knowns){
                    unknowns.delete(key);
                    yield [
                        key,
                        value[key],
                        schema[key]
                    ];
                }
                for (const key of unknowns)yield [
                    key,
                    value[key],
                    Never
                ];
            }
        },
        validator (value) {
            return $bb1101e69dcd6f1d$var$isObject(value) || "Expected an object, but received: " + $bb1101e69dcd6f1d$var$print(value);
        },
        coercer (value) {
            return $bb1101e69dcd6f1d$var$isObject(value) ? {
                ...value
            } : value;
        }
    });
}
/**
 * Augment a struct to allow `undefined` values.
 */ function $bb1101e69dcd6f1d$export$516e28dec6a4b6d4(struct) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        ...struct,
        validator: (value, ctx)=>value === undefined || struct.validator(value, ctx),
        refiner: (value, ctx)=>value === undefined || struct.refiner(value, ctx)
    });
}
/**
 * Ensure that a value is an object with keys and values of specific types, but
 * without ensuring any specific shape of properties.
 *
 * Like TypeScript's `Record` utility.
 */ function $bb1101e69dcd6f1d$export$e5185e241753e543(Key, Value) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "record",
        schema: null,
        *entries (value) {
            if ($bb1101e69dcd6f1d$var$isObject(value)) for(const k in value){
                const v = value[k];
                yield [
                    k,
                    k,
                    Key
                ];
                yield [
                    k,
                    v,
                    Value
                ];
            }
        },
        validator (value) {
            return $bb1101e69dcd6f1d$var$isObject(value) || "Expected an object, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a `RegExp`.
 *
 * Note: this does not test the value against the regular expression! For that
 * you need to use the `pattern()` refinement.
 */ function $bb1101e69dcd6f1d$export$efdc1e5bdb609bb() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("regexp", (value)=>{
        return value instanceof RegExp;
    });
}
function $bb1101e69dcd6f1d$export$adaa4cf7ef1b65be(Element) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "set",
        schema: null,
        *entries (value) {
            if (Element && value instanceof Set) for (const v of value)yield [
                v,
                v,
                Element
            ];
        },
        coercer (value) {
            return value instanceof Set ? new Set(value) : value;
        },
        validator (value) {
            return value instanceof Set || "Expected a `Set` object, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value is a string.
 */ function $bb1101e69dcd6f1d$export$22b082955e083ec3() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("string", (value)=>{
        return typeof value === "string" || "Expected a string, but received: " + $bb1101e69dcd6f1d$var$print(value);
    });
}
/**
 * Ensure that a value is a tuple of a specific length, and that each of its
 * elements is of a specific type.
 */ function $bb1101e69dcd6f1d$export$65e3907585753458(Structs) {
    const Never = $bb1101e69dcd6f1d$export$b3e22bcfd64c1022();
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "tuple",
        schema: null,
        *entries (value) {
            if (Array.isArray(value)) {
                const length = Math.max(Structs.length, value.length);
                for(let i = 0; i < length; i++)yield [
                    i,
                    value[i],
                    Structs[i] || Never
                ];
            }
        },
        validator (value) {
            return Array.isArray(value) || "Expected an array, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value has a set of known properties of specific types.
 *
 * Note: Unrecognized properties are allowed and untouched. This is similar to
 * how TypeScript's structural typing works.
 */ function $bb1101e69dcd6f1d$export$bf9fb029d174d554(schema) {
    const keys = Object.keys(schema);
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "type",
        schema: schema,
        *entries (value) {
            if ($bb1101e69dcd6f1d$var$isObject(value)) for (const k of keys)yield [
                k,
                value[k],
                schema[k]
            ];
        },
        validator (value) {
            return $bb1101e69dcd6f1d$var$isObject(value) || "Expected an object, but received: " + $bb1101e69dcd6f1d$var$print(value);
        }
    });
}
/**
 * Ensure that a value matches one of a set of types.
 */ function $bb1101e69dcd6f1d$export$971dd5b0dfd021b6(Structs) {
    const description = Structs.map((s)=>s.type).join(" | ");
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        type: "union",
        schema: null,
        coercer (value, ctx) {
            const firstMatch = Structs.find((s)=>{
                const [e] = s.validate(value, {
                    coerce: true
                });
                return !e;
            }) || $bb1101e69dcd6f1d$export$19282c40b967aec6();
            return firstMatch.coercer(value, ctx);
        },
        validator (value, ctx) {
            const failures = [];
            for (const S of Structs){
                const [...tuples] = $bb1101e69dcd6f1d$var$run(value, S, ctx);
                const [first] = tuples;
                if (!first[0]) return [];
                else {
                    for (const [failure] of tuples)if (failure) failures.push(failure);
                }
            }
            return [
                "Expected the value to satisfy a union of `" + description + "`, but received: " + $bb1101e69dcd6f1d$var$print(value),
                ...failures
            ];
        }
    });
}
/**
 * Ensure that any value passes validation, without widening its type to `any`.
 */ function $bb1101e69dcd6f1d$export$19282c40b967aec6() {
    return $bb1101e69dcd6f1d$export$f36d6a7a5c09a23e("unknown", ()=>true);
}
/**
 * Augment a `Struct` to add an additional coercion step to its input.
 *
 * This allows you to transform input data before validating it, to increase the
 * likelihood that it passes validation—for example for default values, parsing
 * different formats, etc.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $bb1101e69dcd6f1d$export$8c14e57e778d3873(struct, condition, coercer) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        ...struct,
        coercer: (value, ctx)=>{
            return $bb1101e69dcd6f1d$export$226b3eccf92c9ed9(value, condition) ? struct.coercer(coercer(value, ctx), ctx) : struct.coercer(value, ctx);
        }
    });
}
/**
 * Augment a struct to replace `undefined` values with a default.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $bb1101e69dcd6f1d$export$83c510c4356017ae(struct, fallback, options) {
    if (options === void 0) options = {};
    return $bb1101e69dcd6f1d$export$8c14e57e778d3873(struct, $bb1101e69dcd6f1d$export$19282c40b967aec6(), (x)=>{
        const f = typeof fallback === "function" ? fallback() : fallback;
        if (x === undefined) return f;
        if (!options.strict && $bb1101e69dcd6f1d$var$isPlainObject(x) && $bb1101e69dcd6f1d$var$isPlainObject(f)) {
            const ret = {
                ...x
            };
            let changed = false;
            for(const key in f)if (ret[key] === undefined) {
                ret[key] = f[key];
                changed = true;
            }
            if (changed) return ret;
        }
        return x;
    });
}
/**
 * Augment a struct to trim string inputs.
 *
 * Note: You must use `create(value, Struct)` on the value to have the coercion
 * take effect! Using simply `assert()` or `is()` will not use coercion.
 */ function $bb1101e69dcd6f1d$export$41f369984ed28930(struct) {
    return $bb1101e69dcd6f1d$export$8c14e57e778d3873(struct, $bb1101e69dcd6f1d$export$22b082955e083ec3(), (x)=>x.trim());
}
/**
 * Ensure that a string, array, map, or set is empty.
 */ function $bb1101e69dcd6f1d$export$6e22c362a0406a2c(struct) {
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "empty", (value)=>{
        const size = $bb1101e69dcd6f1d$var$getSize(value);
        return size === 0 || "Expected an empty " + struct.type + " but received one with a size of `" + size + "`";
    });
}
function $bb1101e69dcd6f1d$var$getSize(value) {
    if (value instanceof Map || value instanceof Set) return value.size;
    else return value.length;
}
/**
 * Ensure that a number or date is below a threshold.
 */ function $bb1101e69dcd6f1d$export$8960430cfd85939f(struct, threshold, options) {
    if (options === void 0) options = {};
    const { exclusive: exclusive } = options;
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "max", (value)=>{
        return exclusive ? value < threshold : value <= threshold || "Expected a " + struct.type + " less than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a number or date is above a threshold.
 */ function $bb1101e69dcd6f1d$export$96ec731ed4dcb222(struct, threshold, options) {
    if (options === void 0) options = {};
    const { exclusive: exclusive } = options;
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "min", (value)=>{
        return exclusive ? value > threshold : value >= threshold || "Expected a " + struct.type + " greater than " + (exclusive ? "" : "or equal to ") + threshold + " but received `" + value + "`";
    });
}
/**
 * Ensure that a string, array, map or set is not empty.
 */ function $bb1101e69dcd6f1d$export$6ce6c9218151d511(struct) {
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "nonempty", (value)=>{
        const size = $bb1101e69dcd6f1d$var$getSize(value);
        return size > 0 || "Expected a nonempty " + struct.type + " but received an empty one";
    });
}
/**
 * Ensure that a string matches a regular expression.
 */ function $bb1101e69dcd6f1d$export$24f82734ea047e6f(struct, regexp) {
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "pattern", (value)=>{
        return regexp.test(value) || "Expected a " + struct.type + " matching `/" + regexp.source + '/` but received "' + value + '"';
    });
}
/**
 * Ensure that a string, array, number, date, map, or set has a size (or length, or time) between `min` and `max`.
 */ function $bb1101e69dcd6f1d$export$346677f925de839c(struct, min, max) {
    if (max === void 0) max = min;
    const expected = "Expected a " + struct.type;
    const of = min === max ? "of `" + min + "`" : "between `" + min + "` and `" + max + "`";
    return $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, "size", (value)=>{
        if (typeof value === "number" || value instanceof Date) return min <= value && value <= max || expected + " " + of + " but received `" + value + "`";
        else if (value instanceof Map || value instanceof Set) {
            const { size: size } = value;
            return min <= size && size <= max || expected + " with a size " + of + " but received one with a size of `" + size + "`";
        } else {
            const { length: length } = value;
            return min <= length && length <= max || expected + " with a length " + of + " but received one with a length of `" + length + "`";
        }
    });
}
/**
 * Augment a `Struct` to add an additional refinement to the validation.
 *
 * The refiner function is guaranteed to receive a value of the struct's type,
 * because the struct's existing validation will already have passed. This
 * allows you to layer additional validation on top of existing structs.
 */ function $bb1101e69dcd6f1d$export$edc9d475108b3212(struct, name, refiner) {
    return new $bb1101e69dcd6f1d$export$eabc71f011df675a({
        ...struct,
        *refiner (value, ctx) {
            yield* struct.refiner(value, ctx);
            const result = refiner(value, ctx);
            const failures = $bb1101e69dcd6f1d$var$toFailures(result, ctx, struct, value);
            for (const failure of failures)yield {
                ...failure,
                refinement: name
            };
        }
    });
}

});


parcelRegister("aMYPV", function(module, exports) {

$parcel$export(module.exports, "TYPE_REGEX", function () { return $7dad93ed87c51b7e$export$33283573e8091de6; });
$parcel$export(module.exports, "ARRAY_REGEX", function () { return $7dad93ed87c51b7e$export$88f89e30f2d8e05a; });
$parcel$export(module.exports, "EIP_712_TYPED_DATA_TYPE", function () { return $7dad93ed87c51b7e$export$61d439d0433b2752; });
$parcel$export(module.exports, "EIP_712_STRICT_TYPED_DATA_TYPE", function () { return $7dad93ed87c51b7e$export$467f65e682cf59ee; });

var $g3KvW = parcelRequire("g3KvW");
const $7dad93ed87c51b7e$export$33283573e8091de6 = /^\w+/;
const $7dad93ed87c51b7e$export$88f89e30f2d8e05a = /^(.*)\[([0-9]*?)]$/;
const $7dad93ed87c51b7e$export$486fecec36a45b48 = /^bytes([0-9]{1,2})$/;
const $7dad93ed87c51b7e$export$ab906ef4f3796729 = /^u?int([0-9]{0,3})$/;
const $7dad93ed87c51b7e$export$e0159343c2429ddf = [
    "address",
    "bool",
    "bytes",
    "string"
];
const $7dad93ed87c51b7e$var$TYPE = (0, $g3KvW.refine)((0, $g3KvW.string)(), "Type", (type, context)=>{
    return $7dad93ed87c51b7e$export$2698d5b4be829db6(context.branch[0].types, type);
});
const $7dad93ed87c51b7e$export$21bcd407835ac766 = (0, $g3KvW.object)({
    name: (0, $g3KvW.string)(),
    type: $7dad93ed87c51b7e$var$TYPE
});
const $7dad93ed87c51b7e$export$9e206f2f216242e9 = (0, $g3KvW.object)({
    name: (0, $g3KvW.optional)((0, $g3KvW.string)()),
    version: (0, $g3KvW.optional)((0, $g3KvW.string)()),
    chainId: (0, $g3KvW.optional)((0, $g3KvW.union)([
        (0, $g3KvW.string)(),
        (0, $g3KvW.number)()
    ])),
    verifyingContract: (0, $g3KvW.optional)((0, $g3KvW.pattern)((0, $g3KvW.string)(), /^0x[0-9a-z]{40}$/i)),
    salt: (0, $g3KvW.optional)((0, $g3KvW.union)([
        (0, $g3KvW.array)((0, $g3KvW.number)()),
        (0, $g3KvW.pattern)((0, $g3KvW.string)(), /^0x[0-9a-z]{64}$/i)
    ]))
});
const $7dad93ed87c51b7e$export$61d439d0433b2752 = (0, $g3KvW.object)({
    types: (0, $g3KvW.record)((0, $g3KvW.string)(), (0, $g3KvW.array)($7dad93ed87c51b7e$export$21bcd407835ac766)),
    primaryType: (0, $g3KvW.string)(),
    domain: (0, $g3KvW.object)(),
    message: (0, $g3KvW.object)()
});
const $7dad93ed87c51b7e$export$467f65e682cf59ee = (0, $g3KvW.assign)($7dad93ed87c51b7e$export$61d439d0433b2752, (0, $g3KvW.object)({
    domain: $7dad93ed87c51b7e$export$9e206f2f216242e9
}));
const $7dad93ed87c51b7e$export$2698d5b4be829db6 = (types, type)=>{
    if ($7dad93ed87c51b7e$export$e0159343c2429ddf.includes(type)) return true;
    if (types[type]) return true;
    if (type.match($7dad93ed87c51b7e$export$88f89e30f2d8e05a)) {
        const match = type.match($7dad93ed87c51b7e$export$33283573e8091de6);
        if (match) {
            const innerType = match[0];
            return $7dad93ed87c51b7e$export$2698d5b4be829db6(types, innerType);
        }
    }
    const bytesMatch = type.match($7dad93ed87c51b7e$export$486fecec36a45b48);
    if (bytesMatch) {
        const length = Number(bytesMatch[1]);
        if (length >= 1 && length <= 32) return true;
    }
    const numberMatch = type.match($7dad93ed87c51b7e$export$ab906ef4f3796729);
    if (numberMatch) {
        const length = Number(numberMatch[1]);
        if (length >= 8 && length <= 256 && length % 8 === 0) return true;
    }
    return false;
};

});

parcelRegister("gDy7n", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $c1cac0f8d4064c0f$export$c564cdbbe6da493; });

var $4RgEQ = parcelRequire("4RgEQ");
const $c1cac0f8d4064c0f$export$c564cdbbe6da493 = (types, values)=>{
    return (0, $4RgEQ.encode)(types, values);
};

});
parcelRegister("4RgEQ", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $38990889a3243539$export$c564cdbbe6da493; });

var $7993z = parcelRequire("7993z");

var $btMsn = parcelRequire("btMsn");

var $3IAzE = parcelRequire("3IAzE");

var $ihoyg = parcelRequire("ihoyg");
var $38990889a3243539$require$Buffer = $ihoyg.Buffer;
const $38990889a3243539$export$c564cdbbe6da493 = (input, values)=>{
    const types = input.map((type)=>{
        if (typeof type === "string") return type;
        return type.type;
    });
    return (0, $btMsn.pack)($38990889a3243539$require$Buffer.alloc(0), values, types);
};
const $38990889a3243539$export$935093aea47bb3eb = (contractFunction, values)=>{
    const identifier = $38990889a3243539$require$Buffer.from((0, $7993z.getIdentifier)(contractFunction), "hex");
    const encoded = $38990889a3243539$export$c564cdbbe6da493(contractFunction.inputs, values);
    return (0, $3IAzE.concat)(identifier, encoded);
};
const $38990889a3243539$export$2f872c0f2117be69 = (input, buffer)=>{
    const types = input.map((type)=>{
        if (typeof type === "string") return type;
        return type.type;
    });
    return (0, $btMsn.unpack)(buffer, types);
};

});
parcelRegister("7993z", function(module, exports) {

$parcel$export(module.exports, "getIdentifier", function () { return $5340661ed2cc6361$export$adb27ddab077e944; });

var $8quKY = parcelRequire("8quKY");
const $5340661ed2cc6361$var$isTuple = (input)=>{
    return input.type === "tuple";
};
const $5340661ed2cc6361$export$28b8f402ccc88182 = (input)=>{
    if ($5340661ed2cc6361$var$isTuple(input)) return `(${input.components.map($5340661ed2cc6361$export$28b8f402ccc88182)})`;
    return input.type;
};
const $5340661ed2cc6361$export$adb27ddab077e944 = (contractFunction)=>{
    const types = contractFunction.inputs.map($5340661ed2cc6361$export$28b8f402ccc88182).join(",");
    return (0, $8quKY.keccak256)(`${contractFunction.name}(${types})`).slice(0, 8);
};

});
parcelRegister("8quKY", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $62289c142e1174da$export$f8151fce47ad1c35; });

var $bwBbC = parcelRequire("bwBbC");
const $62289c142e1174da$export$f8151fce47ad1c35 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bwBbC)))("keccak256").update(input).digest().toString("hex");
};

});


parcelRegister("btMsn", function(module, exports) {

$parcel$export(module.exports, "pack", function () { return $85b7fda1fded4082$export$2a703dbb0cb35339; });
$parcel$export(module.exports, "unpack", function () { return $85b7fda1fded4082$export$417857010dc9287f; });

var $3IAzE = parcelRequire("3IAzE");

var $fSrlV = parcelRequire("fSrlV");

var $kYFvJ = parcelRequire("kYFvJ");

var $lKvSw = parcelRequire("lKvSw");

var $j6JlA = parcelRequire("j6JlA");

var $5i6iJ = parcelRequire("5i6iJ");

var $ihoyg = parcelRequire("ihoyg");
var $85b7fda1fded4082$require$Buffer = $ihoyg.Buffer;
const $85b7fda1fded4082$var$ARRAY_REGEX = /^(.*)\[]$/;
const $85b7fda1fded4082$export$43bee75e5e14138e = (type)=>{
    return $85b7fda1fded4082$var$ARRAY_REGEX.test(type);
};
const $85b7fda1fded4082$export$e2b5c5db9e2009fd = (type)=>{
    return type.match($85b7fda1fded4082$var$ARRAY_REGEX)[1];
};
const $85b7fda1fded4082$export$5953f05715bb15e3 = (buffer, values, type)=>{
    if (!$85b7fda1fded4082$export$43bee75e5e14138e(type)) throw new Error("Invalid type: type is not array");
    const actualType = $85b7fda1fded4082$export$e2b5c5db9e2009fd(type);
    const length = (0, $3IAzE.toBuffer)(values.length);
    const arrayBuffer = (0, $3IAzE.concat)(buffer, length);
    return $85b7fda1fded4082$export$2a703dbb0cb35339(arrayBuffer, values, new Array(values.length).fill(actualType));
};
const $85b7fda1fded4082$export$81879b02e9646afe = (value, buffer, type)=>{
    if (!$85b7fda1fded4082$export$43bee75e5e14138e(type)) throw new Error("Invalid type: type is not array");
    const actualType = $85b7fda1fded4082$export$e2b5c5db9e2009fd(type);
    const pointer = Number((0, $3IAzE.toNumber)(value));
    const length = Number((0, $3IAzE.toNumber)(buffer.subarray(pointer, pointer + 32)));
    const arrayPointer = pointer + 32;
    const arrayBuffer = buffer.subarray(arrayPointer);
    return $85b7fda1fded4082$export$417857010dc9287f(arrayBuffer, new Array(length).fill(actualType));
};
const $85b7fda1fded4082$var$parsers = {
    address: {
        encode: (0, $fSrlV.encodeAddress),
        decode: (0, $fSrlV.decodeAddress)
    },
    array: {
        dynamic: true,
        encode: $85b7fda1fded4082$export$5953f05715bb15e3,
        decode: $85b7fda1fded4082$export$81879b02e9646afe
    },
    bytes: {
        dynamic: true,
        encode: (0, $kYFvJ.encodeBytes),
        decode: (0, $kYFvJ.decodeBytes)
    },
    fixedBytes: {
        encode: (0, $lKvSw.encodeFixedBytes),
        decode: (0, $lKvSw.decodeFixedBytes)
    },
    number: {
        encode: (0, $j6JlA.encodeNumber),
        decode: (0, $j6JlA.decodeNumber)
    },
    string: {
        dynamic: true,
        encode: (0, $5i6iJ.encodeString),
        decode: (0, $5i6iJ.decodeString)
    }
};
const $85b7fda1fded4082$export$d003a19ab753048 = (type)=>{
    if ($85b7fda1fded4082$var$parsers[type]) return $85b7fda1fded4082$var$parsers[type];
    if ((0, $lKvSw.isFixedBytes)(type)) return $85b7fda1fded4082$var$parsers.fixedBytes;
    if ((0, $j6JlA.isNumber)(type) || type === "bool") return $85b7fda1fded4082$var$parsers.number;
    if ($85b7fda1fded4082$export$43bee75e5e14138e(type)) return $85b7fda1fded4082$var$parsers.array;
    throw new Error(`type "${type}" is not supported`);
};
const $85b7fda1fded4082$export$2a703dbb0cb35339 = (buffer, values, types)=>{
    const { staticBuffer: packedStaticBuffer, dynamicBuffer: packedDynamicBuffer, updateFunctions: packedUpdateFunctions } = types.reduce(({ staticBuffer: staticBuffer, dynamicBuffer: dynamicBuffer, updateFunctions: updateFunctions }, type, index)=>{
        const parser = $85b7fda1fded4082$export$d003a19ab753048(type);
        const value = values[index];
        if (parser.dynamic) {
            const offset = dynamicBuffer.length;
            const staticOffset = staticBuffer.length;
            const newStaticBuffer = (0, $3IAzE.concat)(staticBuffer, $85b7fda1fded4082$require$Buffer.alloc(32, 0));
            const newDynamicBuffer = parser.encode(dynamicBuffer, value, type);
            const update = (oldBuffer)=>{
                return (0, $3IAzE.concatMultiple)([
                    oldBuffer.subarray(0, staticOffset),
                    (0, $3IAzE.toBuffer)(oldBuffer.length + offset),
                    oldBuffer.subarray(staticOffset + 32)
                ]);
            };
            return {
                staticBuffer: newStaticBuffer,
                dynamicBuffer: newDynamicBuffer,
                updateFunctions: [
                    ...updateFunctions,
                    update
                ]
            };
        }
        const newBuffer = parser.encode(staticBuffer, value, type);
        return {
            staticBuffer: newBuffer,
            dynamicBuffer: dynamicBuffer,
            updateFunctions: updateFunctions
        };
    }, {
        staticBuffer: new Uint8Array(0),
        dynamicBuffer: new Uint8Array(0),
        updateFunctions: []
    });
    const updatedStaticBuffer = packedUpdateFunctions.reduce((target, update)=>update(target), packedStaticBuffer);
    return (0, $3IAzE.concatMultiple)([
        buffer,
        updatedStaticBuffer,
        packedDynamicBuffer
    ]);
};
function* $85b7fda1fded4082$export$c1a059043cc9c119(buffer, chunkSize) {
    for(let i = 0; i < buffer.length; i += chunkSize)yield buffer.slice(i, i + chunkSize);
    return buffer;
}
const $85b7fda1fded4082$export$417857010dc9287f = (buffer, types)=>{
    const iterator = $85b7fda1fded4082$export$c1a059043cc9c119(buffer, 32);
    return types.map((type)=>{
        const { value: value, done: done } = iterator.next();
        if (done) throw new Error("input data has an invalid length");
        const parser = $85b7fda1fded4082$export$d003a19ab753048(type);
        return parser.decode(value, buffer, type);
    });
};

});
parcelRegister("3IAzE", function(module, exports) {

$parcel$export(module.exports, "concat", function () { return $2b51da013f5d9a60$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "concatMultiple", function () { return $2b51da013f5d9a60$export$d8540908850d616f; });
$parcel$export(module.exports, "addPadding", function () { return $2b51da013f5d9a60$export$adf255e13b40f23f; });
$parcel$export(module.exports, "toBuffer", function () { return $2b51da013f5d9a60$export$fc336dbfaf62f18f; });
$parcel$export(module.exports, "toString", function () { return $2b51da013f5d9a60$export$f84e8e69fd4488a5; });
$parcel$export(module.exports, "toNumber", function () { return $2b51da013f5d9a60$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "toHex", function () { return $2b51da013f5d9a60$export$7ea66e3774a60b67; });

var $ihoyg = parcelRequire("ihoyg");
var $2b51da013f5d9a60$require$Buffer = $ihoyg.Buffer;
const $2b51da013f5d9a60$var$BUFFER_WIDTH = 32;
const $2b51da013f5d9a60$export$ee1b3e54f0441b22 = (target, value, position)=>{
    return new Uint8Array([
        ...target.subarray(0, position !== null && position !== void 0 ? position : target.length),
        ...value,
        ...target.subarray(position !== null && position !== void 0 ? position : target.length)
    ]);
};
const $2b51da013f5d9a60$export$d8540908850d616f = (buffers)=>{
    return buffers.reduce((target, buffer)=>{
        const array = new Uint8Array(target.length + buffer.length);
        array.set(target, 0);
        array.set(buffer, target.length);
        return array;
    }, new Uint8Array(0));
};
const $2b51da013f5d9a60$export$adf255e13b40f23f = (buffer, length = 32)=>{
    const padding = $2b51da013f5d9a60$require$Buffer.alloc(Math.max(length - buffer.length, 0), 0);
    return $2b51da013f5d9a60$export$ee1b3e54f0441b22(buffer, padding);
};
const $2b51da013f5d9a60$export$fc336dbfaf62f18f = (value)=>{
    if ($2b51da013f5d9a60$require$Buffer.isBuffer(value) || value instanceof Uint8Array) return value;
    if (typeof value === "string") {
        const stringValue = value.startsWith("0x") ? value.substring(2) : value;
        return $2b51da013f5d9a60$require$Buffer.from(stringValue, "hex");
    }
    const hex = value.toString(16);
    return $2b51da013f5d9a60$require$Buffer.from(hex.padStart($2b51da013f5d9a60$var$BUFFER_WIDTH * 2, "0").slice(0, $2b51da013f5d9a60$var$BUFFER_WIDTH * 2), "hex");
};

const $2b51da013f5d9a60$export$f84e8e69fd4488a5 = (value)=>{
    if (typeof window !== "undefined" && window.TextDecoder) return new TextDecoder("utf-8").decode(value);
    return new (parcelRequire("4zyeF")).TextDecoder("utf-8").decode(value);
};
const $2b51da013f5d9a60$export$a0a81dc3380ce7d3 = (buffer)=>{
    const hex = $2b51da013f5d9a60$export$7ea66e3774a60b67(buffer);
    if (hex.length === 0) return BigInt(0);
    return BigInt(`0x${hex}`);
};
const $2b51da013f5d9a60$var$numberToHex = (value)=>{
    return ("0" + value.toString(16)).slice(-2);
};
const $2b51da013f5d9a60$export$7ea66e3774a60b67 = (buffer)=>{
    return Array.from(buffer).map($2b51da013f5d9a60$var$numberToHex).join("");
};

});

parcelRegister("fSrlV", function(module, exports) {

$parcel$export(module.exports, "encodeAddress", function () { return $b8f11dd7c8e72484$export$b149ba8ff44e4e70; });
$parcel$export(module.exports, "decodeAddress", function () { return $b8f11dd7c8e72484$export$63e61a72b498228b; });

var $3IAzE = parcelRequire("3IAzE");

var $ihoyg = parcelRequire("ihoyg");
var $b8f11dd7c8e72484$require$Buffer = $ihoyg.Buffer;
const $b8f11dd7c8e72484$export$b149ba8ff44e4e70 = (buffer, value)=>{
    if (value.length !== 42) throw new Error("Invalid address length");
    const addressBuffer = $b8f11dd7c8e72484$require$Buffer.alloc(32);
    addressBuffer.write(value.substring(2), 12, "hex");
    return (0, $3IAzE.concat)(buffer, addressBuffer);
};
const $b8f11dd7c8e72484$export$63e61a72b498228b = (value)=>{
    const addressBuffer = value.subarray(-20);
    return `0x${(0, $3IAzE.toHex)(addressBuffer)}`;
};

});

parcelRegister("kYFvJ", function(module, exports) {

$parcel$export(module.exports, "encodeBytes", function () { return $f4599c6e5ee9ad92$export$2589e87d78677b0d; });
$parcel$export(module.exports, "decodeBytes", function () { return $f4599c6e5ee9ad92$export$c97600adfa527f5b; });

var $3IAzE = parcelRequire("3IAzE");

var $ihoyg = parcelRequire("ihoyg");
var $f4599c6e5ee9ad92$require$Buffer = $ihoyg.Buffer;
const $f4599c6e5ee9ad92$export$2589e87d78677b0d = (buffer, value)=>{
    const bufferValue = (0, $3IAzE.toBuffer)(value);
    const paddedSize = Math.ceil(bufferValue.byteLength / 32) * 32;
    return (0, $3IAzE.concat)(buffer, $f4599c6e5ee9ad92$require$Buffer.concat([
        (0, $3IAzE.toBuffer)(bufferValue.byteLength),
        (0, $3IAzE.addPadding)(bufferValue, paddedSize)
    ]));
};
const $f4599c6e5ee9ad92$export$c97600adfa527f5b = (value, buffer)=>{
    const pointer = Number((0, $3IAzE.toNumber)(value.subarray(0, 32)));
    const length = (0, $3IAzE.toNumber)(value.subarray(pointer, pointer + 32));
    return buffer.subarray(32, 32 + Number(length));
};

});

parcelRegister("lKvSw", function(module, exports) {

$parcel$export(module.exports, "isFixedBytes", function () { return $fd569f367a84a353$export$25cdbbb737c953f; });
$parcel$export(module.exports, "encodeFixedBytes", function () { return $fd569f367a84a353$export$7c6ff6257954d015; });
$parcel$export(module.exports, "decodeFixedBytes", function () { return $fd569f367a84a353$export$5e800b96c6a0c3b4; });

var $3IAzE = parcelRequire("3IAzE");
const $fd569f367a84a353$var$BYTES_REGEX = /^bytes([0-9]{1,2})$/;
const $fd569f367a84a353$export$25cdbbb737c953f = (type)=>{
    return $fd569f367a84a353$var$BYTES_REGEX.test(type);
};
const $fd569f367a84a353$export$cc8c3b705bb8e6e2 = (type)=>{
    var _type$match;
    const bytes = (_type$match = type.match($fd569f367a84a353$var$BYTES_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match[1];
    if (bytes) {
        const length = Number(bytes);
        if (length <= 0 || length > 32) throw new Error("Invalid type: length is out of range");
        return length;
    }
    throw new Error("Invalid type: no length");
};
const $fd569f367a84a353$export$7c6ff6257954d015 = (buffer, value, type)=>{
    const length = $fd569f367a84a353$export$cc8c3b705bb8e6e2(type);
    const bufferValue = (0, $3IAzE.toBuffer)(value);
    if (bufferValue.length > length) throw new Error(`Buffer is too long, expected ${length}, got ${bufferValue.length}`);
    return (0, $3IAzE.concat)(buffer, (0, $3IAzE.addPadding)(bufferValue));
};
const $fd569f367a84a353$export$5e800b96c6a0c3b4 = (value, _, type)=>{
    const length = $fd569f367a84a353$export$cc8c3b705bb8e6e2(type);
    return value.subarray(0, length);
};

});

parcelRegister("j6JlA", function(module, exports) {

$parcel$export(module.exports, "isNumber", function () { return $de91c0dfe59a276c$export$7e4aa119212bc614; });
$parcel$export(module.exports, "encodeNumber", function () { return $de91c0dfe59a276c$export$ed41c27e89606957; });
$parcel$export(module.exports, "decodeNumber", function () { return $de91c0dfe59a276c$export$874d75d651b25595; });

var $3IAzE = parcelRequire("3IAzE");

var $dOeUJ = parcelRequire("dOeUJ");
const $de91c0dfe59a276c$var$NUMBER_REGEX = /^u?int([0-9]*)?$/;
const $de91c0dfe59a276c$var$isSigned = (type)=>{
    return type.startsWith("i");
};
const $de91c0dfe59a276c$export$7e4aa119212bc614 = (type)=>{
    return $de91c0dfe59a276c$var$NUMBER_REGEX.test(type);
};
const $de91c0dfe59a276c$export$30bc37a95cad6ab5 = (type)=>{
    var _type$match$, _type$match;
    const rawBits = (_type$match$ = (_type$match = type.match($de91c0dfe59a276c$var$NUMBER_REGEX)) === null || _type$match === void 0 ? void 0 : _type$match[1]) !== null && _type$match$ !== void 0 ? _type$match$ : "256";
    return Number(rawBits);
};
const $de91c0dfe59a276c$export$ddf89a9c5af38f94 = (value, type)=>{
    const bits = BigInt($de91c0dfe59a276c$export$30bc37a95cad6ab5(type));
    if ($de91c0dfe59a276c$var$isSigned(type)) {
        const maxSignedValue = 2n ** (bits - 1n) - 1n;
        return value >= -maxSignedValue - 1n && value <= maxSignedValue;
    }
    const maxValue = 2n ** bits - 1n;
    return value >= 0n && value <= maxValue;
};
const $de91c0dfe59a276c$var$asNumber = (value)=>{
    if (typeof value === "bigint") return value;
    return BigInt(value);
};
const $de91c0dfe59a276c$export$ed41c27e89606957 = (buffer, value, type)=>{
    const numberValue = $de91c0dfe59a276c$var$asNumber(value);
    if (!$de91c0dfe59a276c$export$ddf89a9c5af38f94(numberValue, type)) throw new Error(`Cannot encode number: value is out of range for type ${type}`);
    if ($de91c0dfe59a276c$var$isSigned(type)) return (0, $3IAzE.concat)(buffer, (0, $dOeUJ.toTwosComplement)(numberValue, 32));
    return (0, $3IAzE.concat)(buffer, (0, $3IAzE.toBuffer)(numberValue));
};
const $de91c0dfe59a276c$export$874d75d651b25595 = (value, _, type)=>{
    if ($de91c0dfe59a276c$var$isSigned(type)) return (0, $dOeUJ.fromTwosComplement)(value);
    return (0, $3IAzE.toNumber)(value);
};

});
parcelRegister("dOeUJ", function(module, exports) {

$parcel$export(module.exports, "fromTwosComplement", function () { return $a0db83833f9760af$export$e7e6ad7485b3894c; });
$parcel$export(module.exports, "toTwosComplement", function () { return $a0db83833f9760af$export$5614c14447562f56; });

var $3IAzE = parcelRequire("3IAzE");
const $a0db83833f9760af$export$e7e6ad7485b3894c = (buffer)=>{
    const bufferValue = (0, $3IAzE.toBuffer)(buffer);
    let value = 0n;
    for (const byte of bufferValue)value = (value << 8n) + BigInt(byte);
    return BigInt.asIntN(bufferValue.length * 8, value);
};
const $a0db83833f9760af$export$5614c14447562f56 = (value, length)=>{
    const buffer = new Uint8Array(length);
    for(let i = 0; i < buffer.length; i++){
        buffer[i] = Number(BigInt.asUintN(8, value));
        value = value >> 8n;
    }
    return buffer.reverse();
};

});


parcelRegister("5i6iJ", function(module, exports) {

$parcel$export(module.exports, "encodeString", function () { return $3da3857cbe5daef3$export$8146d2e653b87d6a; });
$parcel$export(module.exports, "decodeString", function () { return $3da3857cbe5daef3$export$a0fb664af7d0cc44; });

var $3IAzE = parcelRequire("3IAzE");

var $kYFvJ = parcelRequire("kYFvJ");

var $ihoyg = parcelRequire("ihoyg");
var $3da3857cbe5daef3$require$Buffer = $ihoyg.Buffer;
const $3da3857cbe5daef3$export$8146d2e653b87d6a = (buffer, value)=>{
    const bufferValue = $3da3857cbe5daef3$require$Buffer.from(value, "utf8");
    return (0, $kYFvJ.encodeBytes)(buffer, bufferValue, "bytes");
};
const $3da3857cbe5daef3$export$a0fb664af7d0cc44 = (value, buffer)=>{
    return (0, $3IAzE.toString)((0, $kYFvJ.decodeBytes)(value, buffer, "string"));
};

});




parcelRegister("5Xayl", function(module, exports) {

$parcel$export(module.exports, "keccak256", function () { return $455aa60cb31f3b80$export$f8151fce47ad1c35; });
$parcel$export(module.exports, "toBuffer", function () { return $455aa60cb31f3b80$export$fc336dbfaf62f18f; });

var $jDAn2 = parcelRequire("jDAn2");

var $ebEok = parcelRequire("ebEok");
const $455aa60cb31f3b80$export$f8151fce47ad1c35 = (data, encoding)=>{
    if (typeof data === "string" && encoding === "utf8") return (0, $jDAn2.keccak_256)($455aa60cb31f3b80$export$fc336dbfaf62f18f(data, encoding));
    return (0, $jDAn2.keccak_256)(data);
};
const $455aa60cb31f3b80$export$fc336dbfaf62f18f = (data, encoding = "hex")=>{
    if (encoding === "hex") {
        if (data.startsWith("0x")) return (0, $ebEok.hexToBytes)(data.substring(2));
        return (0, $ebEok.hexToBytes)(data);
    }
    return (0, $ebEok.utf8ToBytes)(data);
};

});
parcelRegister("jDAn2", function(module, exports) {
"use strict";
var $e4bddf487eff4619$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4bddf487eff4619$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e4bddf487eff4619$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e4bddf487eff4619$var$__createBinding(result, mod, k);
    }
    $e4bddf487eff4619$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shake256 = module.exports.shake128 = module.exports.keccak_512 = module.exports.keccak_384 = module.exports.keccak_256 = module.exports.keccak_224 = module.exports.sha3_512 = module.exports.sha3_384 = module.exports.sha3_256 = module.exports.sha3_224 = module.exports.Keccak = module.exports.keccakP = void 0;

const $e4bddf487eff4619$var$u64 = $e4bddf487eff4619$var$__importStar((parcelRequire("gXXaj")));

var $ebEok = parcelRequire("ebEok");
// Various per round constants calculations
const [$e4bddf487eff4619$var$SHA3_PI, $e4bddf487eff4619$var$SHA3_ROTL, $e4bddf487eff4619$var$_SHA3_IOTA] = [
    [],
    [],
    []
];
const $e4bddf487eff4619$var$_0n = BigInt(0);
const $e4bddf487eff4619$var$_1n = BigInt(1);
const $e4bddf487eff4619$var$_2n = BigInt(2);
const $e4bddf487eff4619$var$_7n = BigInt(7);
const $e4bddf487eff4619$var$_256n = BigInt(256);
const $e4bddf487eff4619$var$_0x71n = BigInt(0x71);
for(let round = 0, R = $e4bddf487eff4619$var$_1n, x = 1, y = 0; round < 24; round++){
    // Pi
    [x, y] = [
        y,
        (2 * x + 3 * y) % 5
    ];
    $e4bddf487eff4619$var$SHA3_PI.push(2 * (5 * y + x));
    // Rotational
    $e4bddf487eff4619$var$SHA3_ROTL.push((round + 1) * (round + 2) / 2 % 64);
    // Iota
    let t = $e4bddf487eff4619$var$_0n;
    for(let j = 0; j < 7; j++){
        R = (R << $e4bddf487eff4619$var$_1n ^ (R >> $e4bddf487eff4619$var$_7n) * $e4bddf487eff4619$var$_0x71n) % $e4bddf487eff4619$var$_256n;
        if (R & $e4bddf487eff4619$var$_2n) t ^= $e4bddf487eff4619$var$_1n << ($e4bddf487eff4619$var$_1n << BigInt(j)) - $e4bddf487eff4619$var$_1n;
    }
    $e4bddf487eff4619$var$_SHA3_IOTA.push(t);
}
const [$e4bddf487eff4619$var$SHA3_IOTA_H, $e4bddf487eff4619$var$SHA3_IOTA_L] = $e4bddf487eff4619$var$u64.split($e4bddf487eff4619$var$_SHA3_IOTA, true);
// Left rotation (without 0, 32, 64)
const $e4bddf487eff4619$var$rotlH = (h, l, s)=>s > 32 ? $e4bddf487eff4619$var$u64.rotlBH(h, l, s) : $e4bddf487eff4619$var$u64.rotlSH(h, l, s);
const $e4bddf487eff4619$var$rotlL = (h, l, s)=>s > 32 ? $e4bddf487eff4619$var$u64.rotlBL(h, l, s) : $e4bddf487eff4619$var$u64.rotlSL(h, l, s);
// Same as keccakf1600, but allows to skip some rounds
function $e4bddf487eff4619$var$keccakP(s, rounds = 24) {
    const B = new Uint32Array(10);
    // NOTE: all indices are x2 since we store state as u32 instead of u64 (bigints to slow in js)
    for(let round = 24 - rounds; round < 24; round++){
        // Theta θ
        for(let x = 0; x < 10; x++)B[x] = s[x] ^ s[x + 10] ^ s[x + 20] ^ s[x + 30] ^ s[x + 40];
        for(let x = 0; x < 10; x += 2){
            const idx1 = (x + 8) % 10;
            const idx0 = (x + 2) % 10;
            const B0 = B[idx0];
            const B1 = B[idx0 + 1];
            const Th = $e4bddf487eff4619$var$rotlH(B0, B1, 1) ^ B[idx1];
            const Tl = $e4bddf487eff4619$var$rotlL(B0, B1, 1) ^ B[idx1 + 1];
            for(let y = 0; y < 50; y += 10){
                s[x + y] ^= Th;
                s[x + y + 1] ^= Tl;
            }
        }
        // Rho (ρ) and Pi (π)
        let curH = s[2];
        let curL = s[3];
        for(let t = 0; t < 24; t++){
            const shift = $e4bddf487eff4619$var$SHA3_ROTL[t];
            const Th = $e4bddf487eff4619$var$rotlH(curH, curL, shift);
            const Tl = $e4bddf487eff4619$var$rotlL(curH, curL, shift);
            const PI = $e4bddf487eff4619$var$SHA3_PI[t];
            curH = s[PI];
            curL = s[PI + 1];
            s[PI] = Th;
            s[PI + 1] = Tl;
        }
        // Chi (χ)
        for(let y = 0; y < 50; y += 10){
            for(let x = 0; x < 10; x++)B[x] = s[y + x];
            for(let x = 0; x < 10; x++)s[y + x] ^= ~B[(x + 2) % 10] & B[(x + 4) % 10];
        }
        // Iota (ι)
        s[0] ^= $e4bddf487eff4619$var$SHA3_IOTA_H[round];
        s[1] ^= $e4bddf487eff4619$var$SHA3_IOTA_L[round];
    }
    B.fill(0);
}
module.exports.keccakP = $e4bddf487eff4619$var$keccakP;
class $e4bddf487eff4619$var$Keccak extends $ebEok.Hash {
    // NOTE: we accept arguments in bytes instead of bits here.
    constructor(blockLen, suffix, outputLen, enableXOF = false, rounds = 24){
        super();
        this.blockLen = blockLen;
        this.suffix = suffix;
        this.outputLen = outputLen;
        this.enableXOF = enableXOF;
        this.rounds = rounds;
        this.pos = 0;
        this.posOut = 0;
        this.finished = false;
        this.destroyed = false;
        // Can be passed from user as dkLen
        (0, $ebEok.assertNumber)(outputLen);
        // 1600 = 5x5 matrix of 64bit.  1600 bits === 200 bytes
        if (0 >= this.blockLen || this.blockLen >= 200) throw new Error("Sha3 supports only keccak-f1600 function");
        this.state = new Uint8Array(200);
        this.state32 = (0, $ebEok.u32)(this.state);
    }
    keccak() {
        $e4bddf487eff4619$var$keccakP(this.state32, this.rounds);
        this.posOut = 0;
        this.pos = 0;
    }
    update(data) {
        if (this.destroyed) throw new Error("instance is destroyed");
        if (this.finished) throw new Error("digest() was already called");
        const { blockLen: blockLen, state: state } = this;
        data = (0, $ebEok.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            for(let i = 0; i < take; i++)state[this.pos++] ^= data[pos++];
            if (this.pos === blockLen) this.keccak();
        }
        return this;
    }
    finish() {
        if (this.finished) return;
        this.finished = true;
        const { state: state, suffix: suffix, pos: pos, blockLen: blockLen } = this;
        // Do the padding
        state[pos] ^= suffix;
        if ((suffix & 0x80) !== 0 && pos === blockLen - 1) this.keccak();
        state[blockLen - 1] ^= 0x80;
        this.keccak();
    }
    writeInto(out) {
        if (this.destroyed) throw new Error("instance is destroyed");
        if (!(out instanceof Uint8Array)) throw new Error("Keccak: invalid output buffer");
        this.finish();
        for(let pos = 0, len = out.length; pos < len;){
            if (this.posOut >= this.blockLen) this.keccak();
            const take = Math.min(this.blockLen - this.posOut, len - pos);
            out.set(this.state.subarray(this.posOut, this.posOut + take), pos);
            this.posOut += take;
            pos += take;
        }
        return out;
    }
    xofInto(out) {
        // Sha3/Keccak usage with XOF is probably mistake, only SHAKE instances can do XOF
        if (!this.enableXOF) throw new Error("XOF is not possible for this instance");
        return this.writeInto(out);
    }
    xof(bytes) {
        (0, $ebEok.assertNumber)(bytes);
        return this.xofInto(new Uint8Array(bytes));
    }
    digestInto(out) {
        if (out.length < this.outputLen) throw new Error("Keccak: invalid output buffer");
        if (this.finished) throw new Error("digest() was already called");
        this.finish();
        this.writeInto(out);
        this.destroy();
        return out;
    }
    digest() {
        return this.digestInto(new Uint8Array(this.outputLen));
    }
    destroy() {
        this.destroyed = true;
        this.state.fill(0);
    }
    _cloneInto(to) {
        const { blockLen: blockLen, suffix: suffix, outputLen: outputLen, rounds: rounds, enableXOF: enableXOF } = this;
        to || (to = new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen, enableXOF, rounds));
        to.state32.set(this.state32);
        to.pos = this.pos;
        to.posOut = this.posOut;
        to.finished = this.finished;
        to.rounds = rounds;
        // Suffix can change in cSHAKE
        to.suffix = suffix;
        to.outputLen = outputLen;
        to.enableXOF = enableXOF;
        to.destroyed = this.destroyed;
        return to;
    }
}
module.exports.Keccak = $e4bddf487eff4619$var$Keccak;
const $e4bddf487eff4619$var$gen = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapConstructor)(()=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, outputLen));
module.exports.sha3_224 = $e4bddf487eff4619$var$gen(0x06, 144, 28);
/**
 * SHA3-256 hash function
 * @param message - that would be hashed
 */ module.exports.sha3_256 = $e4bddf487eff4619$var$gen(0x06, 136, 32);
module.exports.sha3_384 = $e4bddf487eff4619$var$gen(0x06, 104, 48);
module.exports.sha3_512 = $e4bddf487eff4619$var$gen(0x06, 72, 64);
module.exports.keccak_224 = $e4bddf487eff4619$var$gen(0x01, 144, 28);
/**
 * keccak-256 hash function. Different from SHA3-256.
 * @param message - that would be hashed
 */ module.exports.keccak_256 = $e4bddf487eff4619$var$gen(0x01, 136, 32);
module.exports.keccak_384 = $e4bddf487eff4619$var$gen(0x01, 104, 48);
module.exports.keccak_512 = $e4bddf487eff4619$var$gen(0x01, 72, 64);
const $e4bddf487eff4619$var$genShake = (suffix, blockLen, outputLen)=>(0, $ebEok.wrapConstructorWithOpts)((opts = {})=>new $e4bddf487eff4619$var$Keccak(blockLen, suffix, opts.dkLen !== undefined ? opts.dkLen : outputLen, true));
module.exports.shake128 = $e4bddf487eff4619$var$genShake(0x1f, 168, 16);
module.exports.shake256 = $e4bddf487eff4619$var$genShake(0x1f, 136, 32);

});
parcelRegister("gXXaj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add5H = module.exports.add5L = module.exports.add4H = module.exports.add4L = module.exports.add3H = module.exports.add3L = module.exports.add = module.exports.rotlBL = module.exports.rotlBH = module.exports.rotlSL = module.exports.rotlSH = module.exports.rotr32L = module.exports.rotr32H = module.exports.rotrBL = module.exports.rotrBH = module.exports.rotrSL = module.exports.rotrSH = module.exports.shrSL = module.exports.shrSH = module.exports.toBig = module.exports.split = module.exports.fromBig = void 0;
const $c5a00d09d36d1ee1$var$U32_MASK64 = BigInt(2 ** 32 - 1);
const $c5a00d09d36d1ee1$var$_32n = BigInt(32);
function $c5a00d09d36d1ee1$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64),
        l: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64)
    };
    return {
        h: Number(n >> $c5a00d09d36d1ee1$var$_32n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0,
        l: Number(n & $c5a00d09d36d1ee1$var$U32_MASK64) | 0
    };
}
module.exports.fromBig = $c5a00d09d36d1ee1$var$fromBig;
function $c5a00d09d36d1ee1$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $c5a00d09d36d1ee1$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
module.exports.split = $c5a00d09d36d1ee1$var$split;
const $c5a00d09d36d1ee1$var$toBig = (h, l)=>BigInt(h >>> 0) << $c5a00d09d36d1ee1$var$_32n | BigInt(l >>> 0);
module.exports.toBig = $c5a00d09d36d1ee1$var$toBig;
// for Shift in [0, 32)
const $c5a00d09d36d1ee1$var$shrSH = (h, l, s)=>h >>> s;
module.exports.shrSH = $c5a00d09d36d1ee1$var$shrSH;
const $c5a00d09d36d1ee1$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.shrSL = $c5a00d09d36d1ee1$var$shrSL;
// Right rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
module.exports.rotrSH = $c5a00d09d36d1ee1$var$rotrSH;
const $c5a00d09d36d1ee1$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
module.exports.rotrSL = $c5a00d09d36d1ee1$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
module.exports.rotrBH = $c5a00d09d36d1ee1$var$rotrBH;
const $c5a00d09d36d1ee1$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
module.exports.rotrBL = $c5a00d09d36d1ee1$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $c5a00d09d36d1ee1$var$rotr32H = (h, l)=>l;
module.exports.rotr32H = $c5a00d09d36d1ee1$var$rotr32H;
const $c5a00d09d36d1ee1$var$rotr32L = (h, l)=>h;
module.exports.rotr32L = $c5a00d09d36d1ee1$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $c5a00d09d36d1ee1$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
module.exports.rotlSH = $c5a00d09d36d1ee1$var$rotlSH;
const $c5a00d09d36d1ee1$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
module.exports.rotlSL = $c5a00d09d36d1ee1$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $c5a00d09d36d1ee1$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
module.exports.rotlBH = $c5a00d09d36d1ee1$var$rotlBH;
const $c5a00d09d36d1ee1$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
module.exports.rotlBL = $c5a00d09d36d1ee1$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $c5a00d09d36d1ee1$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
module.exports.add = $c5a00d09d36d1ee1$var$add;
// Addition with more than 2 elements
const $c5a00d09d36d1ee1$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
module.exports.add3L = $c5a00d09d36d1ee1$var$add3L;
const $c5a00d09d36d1ee1$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
module.exports.add3H = $c5a00d09d36d1ee1$var$add3H;
const $c5a00d09d36d1ee1$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
module.exports.add4L = $c5a00d09d36d1ee1$var$add4L;
const $c5a00d09d36d1ee1$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
module.exports.add4H = $c5a00d09d36d1ee1$var$add4H;
const $c5a00d09d36d1ee1$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
module.exports.add5L = $c5a00d09d36d1ee1$var$add5L;
const $c5a00d09d36d1ee1$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
module.exports.add5H = $c5a00d09d36d1ee1$var$add5H;

});

parcelRegister("ebEok", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.randomBytes = exports.wrapConstructorWithOpts = exports.wrapConstructor = exports.checkOpts = exports.Hash = exports.assertHash = exports.assertBytes = exports.assertBool = exports.assertNumber = exports.concatBytes = exports.toBytes = exports.utf8ToBytes = exports.asyncLoop = exports.nextTick = exports.hexToBytes = exports.bytesToHex = exports.isLE = exports.rotr = exports.createView = exports.u32 = exports.u8 = void 0;

var $8NxPu = parcelRequire("8NxPu");
// Cast array to different type
const u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
exports.u8 = u8;
const u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
exports.u32 = u32;
// Cast array to view
const createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
exports.createView = createView;
// The rotate right (circular right shift) operation for uint32
const rotr = (word, shift)=>word << 32 - shift | word >>> shift;
exports.rotr = rotr;
exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// There is almost no big endian hardware, but js typed arrays uses platform specific endianess.
// So, just to be sure not to corrupt anything.
if (!exports.isLE) throw new Error("Non little-endian hardware is not supported");
const hexes = Array.from({
    length: 256
}, (v, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xde, 0xad, 0xbe, 0xef]))
 */ function bytesToHex(uint8a) {
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < uint8a.length; i++)hex += hexes[uint8a[i]];
    return hex;
}
exports.bytesToHex = bytesToHex;
/**
 * @example hexToBytes('deadbeef')
 */ function hexToBytes(hex) {
    if (typeof hex !== "string") throw new TypeError("hexToBytes: expected string, got " + typeof hex);
    if (hex.length % 2) throw new Error("hexToBytes: received invalid unpadded hex");
    const array = new Uint8Array(hex.length / 2);
    for(let i = 0; i < array.length; i++){
        const j = i * 2;
        const hexByte = hex.slice(j, j + 2);
        const byte = Number.parseInt(hexByte, 16);
        if (Number.isNaN(byte)) throw new Error("Invalid byte sequence");
        array[i] = byte;
    }
    return array;
}
exports.hexToBytes = hexToBytes;
// Currently avoid insertion of polyfills with packers (browserify/webpack/etc)
// But setTimeout is pretty slow, maybe worth to investigate howto do minimal polyfill here
exports.nextTick = (()=>{
    const nodeRequire = typeof module.require === "function" && module.require.bind(module);
    try {
        if (nodeRequire) {
            const { setImmediate } = nodeRequire("timers");
            return ()=>new Promise((resolve)=>setImmediate(resolve));
        }
    } catch (e) {}
    return ()=>new Promise((resolve)=>setTimeout(resolve, 0));
})();
// Returns control to thread each 'tick' ms to avoid blocking
async function asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, exports.nextTick)();
        ts += diff;
    }
}
exports.asyncLoop = asyncLoop;
function utf8ToBytes(str) {
    if (typeof str !== "string") throw new TypeError(`utf8ToBytes expected string, got ${typeof str}`);
    return new TextEncoder().encode(str);
}
exports.utf8ToBytes = utf8ToBytes;
function toBytes(data) {
    if (typeof data === "string") data = utf8ToBytes(data);
    if (!(data instanceof Uint8Array)) throw new TypeError(`Expected input type is Uint8Array (got ${typeof data})`);
    return data;
}
exports.toBytes = toBytes;
/**
 * Concats Uint8Array-s into one; like `Buffer.concat([buf1, buf2])`
 * @example concatBytes(buf1, buf2)
 */ function concatBytes(...arrays) {
    if (!arrays.every((a)=>a instanceof Uint8Array)) throw new Error("Uint8Array list expected");
    if (arrays.length === 1) return arrays[0];
    const length = arrays.reduce((a, arr)=>a + arr.length, 0);
    const result = new Uint8Array(length);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const arr = arrays[i];
        result.set(arr, pad);
        pad += arr.length;
    }
    return result;
}
exports.concatBytes = concatBytes;
function assertNumber(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`Wrong positive integer: ${n}`);
}
exports.assertNumber = assertNumber;
function assertBool(b) {
    if (typeof b !== "boolean") throw new Error(`Expected boolean, not ${b}`);
}
exports.assertBool = assertBool;
function assertBytes(bytes, ...lengths) {
    if (bytes instanceof Uint8Array && (!lengths.length || lengths.includes(bytes.length))) return;
    throw new TypeError(`Expected ${lengths} bytes, not ${typeof bytes} with length=${bytes.length}`);
}
exports.assertBytes = assertBytes;
function assertHash(hash) {
    if (typeof hash !== "function" || typeof hash.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    assertNumber(hash.outputLen);
    assertNumber(hash.blockLen);
}
exports.assertHash = assertHash;
// For runtime check if class implements interface
class Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
exports.Hash = Hash;
// Check if object doens't have custom constructor (like Uint8Array/Array)
const isPlainObject = (obj)=>Object.prototype.toString.call(obj) === "[object Object]" && obj.constructor === Object;
function checkOpts(def, _opts) {
    if (_opts !== undefined && (typeof _opts !== "object" || !isPlainObject(_opts))) throw new TypeError("Options should be object or undefined");
    const opts = Object.assign(def, _opts);
    return opts;
}
exports.checkOpts = checkOpts;
function wrapConstructor(hashConstructor) {
    const hashC = (message)=>hashConstructor().update(toBytes(message)).digest();
    const tmp = hashConstructor();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashConstructor();
    return hashC;
}
exports.wrapConstructor = wrapConstructor;
function wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update(toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
exports.wrapConstructorWithOpts = wrapConstructorWithOpts;
/**
 * Secure PRNG
 */ function randomBytes(bytesLength = 32) {
    if ($8NxPu.crypto.web) return $8NxPu.crypto.web.getRandomValues(new Uint8Array(bytesLength));
    else if ($8NxPu.crypto.node) return new Uint8Array($8NxPu.crypto.node.randomBytes(bytesLength).buffer);
    else throw new Error("The environment doesn't have randomBytes function");
}
exports.randomBytes = randomBytes;

});
parcelRegister("8NxPu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = {
    node: undefined,
    web: typeof self === "object" && "crypto" in self ? self.crypto : undefined
};

});




parcelRegister("9dLGH", function(module, exports) {

$parcel$export(module.exports, "validateTypedData", function () { return $6b6a51bd093379e8$export$fac174f558903e26; });

var $g3KvW = parcelRequire("g3KvW");

var $dx9Gq = parcelRequire("dx9Gq");

var $aMYPV = parcelRequire("aMYPV");
const $6b6a51bd093379e8$export$fac174f558903e26 = (data, options)=>{
    const { verifyDomain: verifyDomain } = (0, $dx9Gq.getOptions)(options);
    if (verifyDomain) return (0, $g3KvW.is)(data, (0, $aMYPV.EIP_712_STRICT_TYPED_DATA_TYPE));
    return (0, $g3KvW.is)(data, (0, $aMYPV.EIP_712_TYPED_DATA_TYPE));
};

});


parcelRegister("8iu5n", function(module, exports) {
"use strict";
var $60a757974b123d1f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $60a757974b123d1f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $60a757974b123d1f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $60a757974b123d1f$var$__createBinding(result, mod, k);
    }
    $60a757974b123d1f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatBytes32String = module.exports.Utf8ErrorFuncs = module.exports.toUtf8String = module.exports.toUtf8CodePoints = module.exports.toUtf8Bytes = module.exports._toEscapedUtf8String = module.exports.nameprep = module.exports.hexDataSlice = module.exports.hexDataLength = module.exports.hexZeroPad = module.exports.hexValue = module.exports.hexStripZeros = module.exports.hexConcat = module.exports.isHexString = module.exports.hexlify = module.exports.base64 = module.exports.base58 = module.exports.TransactionDescription = module.exports.LogDescription = module.exports.Interface = module.exports.SigningKey = module.exports.HDNode = module.exports.defaultPath = module.exports.isBytesLike = module.exports.isBytes = module.exports.zeroPad = module.exports.stripZeros = module.exports.concat = module.exports.arrayify = module.exports.shallowCopy = module.exports.resolveProperties = module.exports.getStatic = module.exports.defineReadOnly = module.exports.deepCopy = module.exports.checkProperties = module.exports.poll = module.exports.fetchJson = module.exports._fetchData = module.exports.RLP = module.exports.Logger = module.exports.checkResultErrors = module.exports.FormatTypes = module.exports.ParamType = module.exports.FunctionFragment = module.exports.EventFragment = module.exports.ErrorFragment = module.exports.ConstructorFragment = module.exports.Fragment = module.exports.defaultAbiCoder = module.exports.AbiCoder = void 0;
module.exports.Indexed = module.exports.Utf8ErrorReason = module.exports.UnicodeNormalizationForm = module.exports.SupportedAlgorithm = module.exports.mnemonicToSeed = module.exports.isValidMnemonic = module.exports.entropyToMnemonic = module.exports.mnemonicToEntropy = module.exports.getAccountPath = module.exports.verifyTypedData = module.exports.verifyMessage = module.exports.recoverPublicKey = module.exports.computePublicKey = module.exports.recoverAddress = module.exports.computeAddress = module.exports.getJsonWalletAddress = module.exports.TransactionTypes = module.exports.serializeTransaction = module.exports.parseTransaction = module.exports.accessListify = module.exports.joinSignature = module.exports.splitSignature = module.exports.soliditySha256 = module.exports.solidityKeccak256 = module.exports.solidityPack = module.exports.shuffled = module.exports.randomBytes = module.exports.sha512 = module.exports.sha256 = module.exports.ripemd160 = module.exports.keccak256 = module.exports.computeHmac = module.exports.commify = module.exports.parseUnits = module.exports.formatUnits = module.exports.parseEther = module.exports.formatEther = module.exports.isAddress = module.exports.getCreate2Address = module.exports.getContractAddress = module.exports.getIcapAddress = module.exports.getAddress = module.exports._TypedDataEncoder = module.exports.id = module.exports.isValidName = module.exports.namehash = module.exports.hashMessage = module.exports.dnsEncode = module.exports.parseBytes32String = void 0;

var $5FB8J = parcelRequire("5FB8J");
var $5aOKN = parcelRequire("5aOKN");
var $3PTbz = parcelRequire("3PTbz");
var $h8t8t = parcelRequire("h8t8t");
Object.defineProperty(module.exports, "AbiCoder", {
    enumerable: true,
    get: function() {
        return $5FB8J.AbiCoder;
    }
});
Object.defineProperty(module.exports, "checkResultErrors", {
    enumerable: true,
    get: function() {
        return $5aOKN.checkResultErrors;
    }
});
Object.defineProperty(module.exports, "ConstructorFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.ConstructorFragment;
    }
});
Object.defineProperty(module.exports, "defaultAbiCoder", {
    enumerable: true,
    get: function() {
        return $5FB8J.defaultAbiCoder;
    }
});
Object.defineProperty(module.exports, "ErrorFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.ErrorFragment;
    }
});
Object.defineProperty(module.exports, "EventFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.EventFragment;
    }
});
Object.defineProperty(module.exports, "FormatTypes", {
    enumerable: true,
    get: function() {
        return $3PTbz.FormatTypes;
    }
});
Object.defineProperty(module.exports, "Fragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.Fragment;
    }
});
Object.defineProperty(module.exports, "FunctionFragment", {
    enumerable: true,
    get: function() {
        return $3PTbz.FunctionFragment;
    }
});
Object.defineProperty(module.exports, "Indexed", {
    enumerable: true,
    get: function() {
        return $h8t8t.Indexed;
    }
});
Object.defineProperty(module.exports, "Interface", {
    enumerable: true,
    get: function() {
        return $h8t8t.Interface;
    }
});
Object.defineProperty(module.exports, "LogDescription", {
    enumerable: true,
    get: function() {
        return $h8t8t.LogDescription;
    }
});
Object.defineProperty(module.exports, "ParamType", {
    enumerable: true,
    get: function() {
        return $3PTbz.ParamType;
    }
});
Object.defineProperty(module.exports, "TransactionDescription", {
    enumerable: true,
    get: function() {
        return $h8t8t.TransactionDescription;
    }
});

var $7pv2A = parcelRequire("7pv2A");
Object.defineProperty(module.exports, "getAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getAddress;
    }
});
Object.defineProperty(module.exports, "getCreate2Address", {
    enumerable: true,
    get: function() {
        return $7pv2A.getCreate2Address;
    }
});
Object.defineProperty(module.exports, "getContractAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getContractAddress;
    }
});
Object.defineProperty(module.exports, "getIcapAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.getIcapAddress;
    }
});
Object.defineProperty(module.exports, "isAddress", {
    enumerable: true,
    get: function() {
        return $7pv2A.isAddress;
    }
});

var $60a757974b123d1f$var$base64 = $60a757974b123d1f$var$__importStar((parcelRequire("fe8vC")));
module.exports.base64 = $60a757974b123d1f$var$base64;

var $6PyTw = parcelRequire("6PyTw");
Object.defineProperty(module.exports, "base58", {
    enumerable: true,
    get: function() {
        return $6PyTw.Base58;
    }
});

var $ApLZa = parcelRequire("ApLZa");
Object.defineProperty(module.exports, "arrayify", {
    enumerable: true,
    get: function() {
        return $ApLZa.arrayify;
    }
});
Object.defineProperty(module.exports, "concat", {
    enumerable: true,
    get: function() {
        return $ApLZa.concat;
    }
});
Object.defineProperty(module.exports, "hexConcat", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexConcat;
    }
});
Object.defineProperty(module.exports, "hexDataSlice", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexDataSlice;
    }
});
Object.defineProperty(module.exports, "hexDataLength", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexDataLength;
    }
});
Object.defineProperty(module.exports, "hexlify", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexlify;
    }
});
Object.defineProperty(module.exports, "hexStripZeros", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexStripZeros;
    }
});
Object.defineProperty(module.exports, "hexValue", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexValue;
    }
});
Object.defineProperty(module.exports, "hexZeroPad", {
    enumerable: true,
    get: function() {
        return $ApLZa.hexZeroPad;
    }
});
Object.defineProperty(module.exports, "isBytes", {
    enumerable: true,
    get: function() {
        return $ApLZa.isBytes;
    }
});
Object.defineProperty(module.exports, "isBytesLike", {
    enumerable: true,
    get: function() {
        return $ApLZa.isBytesLike;
    }
});
Object.defineProperty(module.exports, "isHexString", {
    enumerable: true,
    get: function() {
        return $ApLZa.isHexString;
    }
});
Object.defineProperty(module.exports, "joinSignature", {
    enumerable: true,
    get: function() {
        return $ApLZa.joinSignature;
    }
});
Object.defineProperty(module.exports, "zeroPad", {
    enumerable: true,
    get: function() {
        return $ApLZa.zeroPad;
    }
});
Object.defineProperty(module.exports, "splitSignature", {
    enumerable: true,
    get: function() {
        return $ApLZa.splitSignature;
    }
});
Object.defineProperty(module.exports, "stripZeros", {
    enumerable: true,
    get: function() {
        return $ApLZa.stripZeros;
    }
});

var $cKR64 = parcelRequire("cKR64");
var $1e7EA = parcelRequire("1e7EA");
var $6RlV8 = parcelRequire("6RlV8");
var $1JJGc = parcelRequire("1JJGc");
Object.defineProperty(module.exports, "_TypedDataEncoder", {
    enumerable: true,
    get: function() {
        return $cKR64.TypedDataEncoder;
    }
});
Object.defineProperty(module.exports, "dnsEncode", {
    enumerable: true,
    get: function() {
        return $1e7EA.dnsEncode;
    }
});
Object.defineProperty(module.exports, "hashMessage", {
    enumerable: true,
    get: function() {
        return $6RlV8.hashMessage;
    }
});
Object.defineProperty(module.exports, "id", {
    enumerable: true,
    get: function() {
        return $1JJGc.id;
    }
});
Object.defineProperty(module.exports, "isValidName", {
    enumerable: true,
    get: function() {
        return $1e7EA.isValidName;
    }
});
Object.defineProperty(module.exports, "namehash", {
    enumerable: true,
    get: function() {
        return $1e7EA.namehash;
    }
});

var $3NuV3 = parcelRequire("3NuV3");
Object.defineProperty(module.exports, "defaultPath", {
    enumerable: true,
    get: function() {
        return $3NuV3.defaultPath;
    }
});
Object.defineProperty(module.exports, "entropyToMnemonic", {
    enumerable: true,
    get: function() {
        return $3NuV3.entropyToMnemonic;
    }
});
Object.defineProperty(module.exports, "getAccountPath", {
    enumerable: true,
    get: function() {
        return $3NuV3.getAccountPath;
    }
});
Object.defineProperty(module.exports, "HDNode", {
    enumerable: true,
    get: function() {
        return $3NuV3.HDNode;
    }
});
Object.defineProperty(module.exports, "isValidMnemonic", {
    enumerable: true,
    get: function() {
        return $3NuV3.isValidMnemonic;
    }
});
Object.defineProperty(module.exports, "mnemonicToEntropy", {
    enumerable: true,
    get: function() {
        return $3NuV3.mnemonicToEntropy;
    }
});
Object.defineProperty(module.exports, "mnemonicToSeed", {
    enumerable: true,
    get: function() {
        return $3NuV3.mnemonicToSeed;
    }
});

var $3hMhy = parcelRequire("3hMhy");
Object.defineProperty(module.exports, "getJsonWalletAddress", {
    enumerable: true,
    get: function() {
        return $3hMhy.getJsonWalletAddress;
    }
});

var $8unkG = parcelRequire("8unkG");
Object.defineProperty(module.exports, "keccak256", {
    enumerable: true,
    get: function() {
        return $8unkG.keccak256;
    }
});

var $8bxC3 = parcelRequire("8bxC3");
Object.defineProperty(module.exports, "Logger", {
    enumerable: true,
    get: function() {
        return $8bxC3.Logger;
    }
});

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");
Object.defineProperty(module.exports, "computeHmac", {
    enumerable: true,
    get: function() {
        return $eT6wv.computeHmac;
    }
});
Object.defineProperty(module.exports, "ripemd160", {
    enumerable: true,
    get: function() {
        return $eT6wv.ripemd160;
    }
});
Object.defineProperty(module.exports, "sha256", {
    enumerable: true,
    get: function() {
        return $eT6wv.sha256;
    }
});
Object.defineProperty(module.exports, "sha512", {
    enumerable: true,
    get: function() {
        return $eT6wv.sha512;
    }
});

var $bQUCt = parcelRequire("bQUCt");
Object.defineProperty(module.exports, "solidityKeccak256", {
    enumerable: true,
    get: function() {
        return $bQUCt.keccak256;
    }
});
Object.defineProperty(module.exports, "solidityPack", {
    enumerable: true,
    get: function() {
        return $bQUCt.pack;
    }
});
Object.defineProperty(module.exports, "soliditySha256", {
    enumerable: true,
    get: function() {
        return $bQUCt.sha256;
    }
});

var $UqakH = parcelRequire("UqakH");
var $aTUBO = parcelRequire("aTUBO");
Object.defineProperty(module.exports, "randomBytes", {
    enumerable: true,
    get: function() {
        return $UqakH.randomBytes;
    }
});
Object.defineProperty(module.exports, "shuffled", {
    enumerable: true,
    get: function() {
        return $aTUBO.shuffled;
    }
});

var $i6lOf = parcelRequire("i6lOf");
Object.defineProperty(module.exports, "checkProperties", {
    enumerable: true,
    get: function() {
        return $i6lOf.checkProperties;
    }
});
Object.defineProperty(module.exports, "deepCopy", {
    enumerable: true,
    get: function() {
        return $i6lOf.deepCopy;
    }
});
Object.defineProperty(module.exports, "defineReadOnly", {
    enumerable: true,
    get: function() {
        return $i6lOf.defineReadOnly;
    }
});
Object.defineProperty(module.exports, "getStatic", {
    enumerable: true,
    get: function() {
        return $i6lOf.getStatic;
    }
});
Object.defineProperty(module.exports, "resolveProperties", {
    enumerable: true,
    get: function() {
        return $i6lOf.resolveProperties;
    }
});
Object.defineProperty(module.exports, "shallowCopy", {
    enumerable: true,
    get: function() {
        return $i6lOf.shallowCopy;
    }
});

var $60a757974b123d1f$var$RLP = $60a757974b123d1f$var$__importStar((parcelRequire("2blqG")));
module.exports.RLP = $60a757974b123d1f$var$RLP;

var $6ltHX = parcelRequire("6ltHX");
Object.defineProperty(module.exports, "computePublicKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.computePublicKey;
    }
});
Object.defineProperty(module.exports, "recoverPublicKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.recoverPublicKey;
    }
});
Object.defineProperty(module.exports, "SigningKey", {
    enumerable: true,
    get: function() {
        return $6ltHX.SigningKey;
    }
});

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");
Object.defineProperty(module.exports, "formatBytes32String", {
    enumerable: true,
    get: function() {
        return $2txLu.formatBytes32String;
    }
});
Object.defineProperty(module.exports, "nameprep", {
    enumerable: true,
    get: function() {
        return $hayKj.nameprep;
    }
});
Object.defineProperty(module.exports, "parseBytes32String", {
    enumerable: true,
    get: function() {
        return $2txLu.parseBytes32String;
    }
});
Object.defineProperty(module.exports, "_toEscapedUtf8String", {
    enumerable: true,
    get: function() {
        return $aCHl8._toEscapedUtf8String;
    }
});
Object.defineProperty(module.exports, "toUtf8Bytes", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8Bytes;
    }
});
Object.defineProperty(module.exports, "toUtf8CodePoints", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8CodePoints;
    }
});
Object.defineProperty(module.exports, "toUtf8String", {
    enumerable: true,
    get: function() {
        return $aCHl8.toUtf8String;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorFuncs", {
    enumerable: true,
    get: function() {
        return $aCHl8.Utf8ErrorFuncs;
    }
});

var $5LK3h = parcelRequire("5LK3h");
Object.defineProperty(module.exports, "accessListify", {
    enumerable: true,
    get: function() {
        return $5LK3h.accessListify;
    }
});
Object.defineProperty(module.exports, "computeAddress", {
    enumerable: true,
    get: function() {
        return $5LK3h.computeAddress;
    }
});
Object.defineProperty(module.exports, "parseTransaction", {
    enumerable: true,
    get: function() {
        return $5LK3h.parse;
    }
});
Object.defineProperty(module.exports, "recoverAddress", {
    enumerable: true,
    get: function() {
        return $5LK3h.recoverAddress;
    }
});
Object.defineProperty(module.exports, "serializeTransaction", {
    enumerable: true,
    get: function() {
        return $5LK3h.serialize;
    }
});
Object.defineProperty(module.exports, "TransactionTypes", {
    enumerable: true,
    get: function() {
        return $5LK3h.TransactionTypes;
    }
});

var $aGsqH = parcelRequire("aGsqH");
Object.defineProperty(module.exports, "commify", {
    enumerable: true,
    get: function() {
        return $aGsqH.commify;
    }
});
Object.defineProperty(module.exports, "formatEther", {
    enumerable: true,
    get: function() {
        return $aGsqH.formatEther;
    }
});
Object.defineProperty(module.exports, "parseEther", {
    enumerable: true,
    get: function() {
        return $aGsqH.parseEther;
    }
});
Object.defineProperty(module.exports, "formatUnits", {
    enumerable: true,
    get: function() {
        return $aGsqH.formatUnits;
    }
});
Object.defineProperty(module.exports, "parseUnits", {
    enumerable: true,
    get: function() {
        return $aGsqH.parseUnits;
    }
});

var $hO0Ij = parcelRequire("hO0Ij");
Object.defineProperty(module.exports, "verifyMessage", {
    enumerable: true,
    get: function() {
        return $hO0Ij.verifyMessage;
    }
});
Object.defineProperty(module.exports, "verifyTypedData", {
    enumerable: true,
    get: function() {
        return $hO0Ij.verifyTypedData;
    }
});

var $2GUlC = parcelRequire("2GUlC");
Object.defineProperty(module.exports, "_fetchData", {
    enumerable: true,
    get: function() {
        return $2GUlC._fetchData;
    }
});
Object.defineProperty(module.exports, "fetchJson", {
    enumerable: true,
    get: function() {
        return $2GUlC.fetchJson;
    }
});
Object.defineProperty(module.exports, "poll", {
    enumerable: true,
    get: function() {
        return $2GUlC.poll;
    }
});

var $eT6wv = parcelRequire("eT6wv");
var $gSWEZ = parcelRequire("gSWEZ");
Object.defineProperty(module.exports, "SupportedAlgorithm", {
    enumerable: true,
    get: function() {
        return $gSWEZ.SupportedAlgorithm;
    }
});

var $aCHl8 = parcelRequire("aCHl8");
var $2txLu = parcelRequire("2txLu");
var $hayKj = parcelRequire("hayKj");
Object.defineProperty(module.exports, "UnicodeNormalizationForm", {
    enumerable: true,
    get: function() {
        return $aCHl8.UnicodeNormalizationForm;
    }
});
Object.defineProperty(module.exports, "Utf8ErrorReason", {
    enumerable: true,
    get: function() {
        return $aCHl8.Utf8ErrorReason;
    }
});

});

parcelRegister("byiQW", function(module, exports) {
"use strict";
var $86917e7b57320489$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $86917e7b57320489$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $86917e7b57320489$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $86917e7b57320489$var$__createBinding(result, mod, k);
    }
    $86917e7b57320489$var$__setModuleDefault(result, mod);
    return result;
};
var $86917e7b57320489$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buildMessage = module.exports.getKeyPair = void 0;

const $86917e7b57320489$var$core = $86917e7b57320489$var$__importStar((parcelRequire("lFpDy")));
parcelRequire("2mRwW");
var $iuBCc = parcelRequire("iuBCc");

const $86917e7b57320489$var$Isolation = $86917e7b57320489$var$__importStar((parcelRequire("aCCM0")));

var $pvQdK = parcelRequire("pvQdK");
function $86917e7b57320489$var$getKeyPair(node, addressNList, coin, scriptType) {
    return $86917e7b57320489$var$__awaiter(this, void 0, void 0, function*() {
        const network = (0, $pvQdK.getNetwork)(coin, scriptType);
        const wallet = yield $86917e7b57320489$var$Isolation.Adapters.BIP32.create(node, network);
        const path = $86917e7b57320489$var$core.addressNListToBIP32(addressNList);
        return yield wallet.derivePath(path);
    });
}
module.exports.getKeyPair = $86917e7b57320489$var$getKeyPair;
function $86917e7b57320489$var$buildMessage(message) {
    const messageBytes = typeof message === "string" && !$iuBCc.utils.isHexString(message) ? $iuBCc.utils.toUtf8Bytes(message) : $iuBCc.utils.arrayify(message);
    return $iuBCc.utils.concat([
        $iuBCc.utils.toUtf8Bytes("\x19Ethereum Signed Message:\n"),
        $iuBCc.utils.toUtf8Bytes(String(messageBytes.length)),
        messageBytes
    ]);
}
module.exports.buildMessage = $86917e7b57320489$var$buildMessage;

});
parcelRegister("pvQdK", function(module, exports) {
"use strict";
var $04cb08ed4a28d97f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04cb08ed4a28d97f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $04cb08ed4a28d97f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $04cb08ed4a28d97f$var$__createBinding(result, mod, k);
    }
    $04cb08ed4a28d97f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getNetwork = void 0;

const $04cb08ed4a28d97f$var$core = $04cb08ed4a28d97f$var$__importStar((parcelRequire("lFpDy")));
const $04cb08ed4a28d97f$var$bip32BTC = {
    p2sh: {
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        }
    },
    p2pkh: {
        bip32: {
            public: 0x0488b21e,
            private: 0x0488ade4
        }
    },
    "p2sh-p2wpkh": {
        bip32: {
            public: 0x049d7cb2,
            private: 0x049d7878
        }
    },
    p2wpkh: {
        bip32: {
            public: 0x04b24746,
            private: 0x04b2430c
        }
    }
};
const $04cb08ed4a28d97f$var$networks = {
    bitcoin: Object.assign({
        base: {
            messagePrefix: "\x18Bitcoin Signed Message:\n",
            bech32: "bc",
            pubKeyHash: 0x00,
            scriptHash: 0x05,
            wif: 0x80
        }
    }, $04cb08ed4a28d97f$var$bip32BTC),
    dash: {
        base: {
            messagePrefix: "unused",
            bech32: "",
            pubKeyHash: 0x4c,
            scriptHash: 0x10,
            wif: 0xcc
        },
        p2sh: $04cb08ed4a28d97f$var$bip32BTC.p2sh,
        p2pkh: $04cb08ed4a28d97f$var$bip32BTC.p2pkh
    },
    digibyte: Object.assign({
        base: {
            messagePrefix: "\x19Digibyte Signed Message:\n",
            bech32: "dgb",
            pubKeyHash: 0x1e,
            scriptHash: 0x3f,
            wif: 0x80
        }
    }, $04cb08ed4a28d97f$var$bip32BTC),
    dogecoin: {
        base: {
            messagePrefix: "\x19Dogecoin Signed Message:\n",
            bech32: "",
            pubKeyHash: 0x1e,
            scriptHash: 0x16,
            wif: 0x9e
        },
        p2sh: {
            bip32: {
                public: 0x02facafd,
                private: 0x02fac398
            }
        },
        p2pkh: {
            bip32: {
                public: 0x02facafd,
                private: 0x02fac398
            }
        }
    },
    litecoin: {
        base: {
            messagePrefix: "\x19Litecoin Signed Message:\n",
            bech32: "ltc",
            pubKeyHash: 0x30,
            scriptHash: 0x32,
            wif: 0xb0
        },
        p2sh: {
            bip32: {
                public: 0x019da462,
                private: 0x019d9cfe
            }
        },
        p2pkh: {
            bip32: {
                public: 0x019da462,
                private: 0x019d9cfe
            }
        },
        "p2sh-p2wpkh": {
            bip32: {
                public: 0x01b26ef6,
                private: 0x01b26792
            }
        },
        p2wpkh: $04cb08ed4a28d97f$var$bip32BTC.p2wpkh
    },
    testnet: {
        base: {
            messagePrefix: "\x18Bitcoin Signed Message:\n",
            bech32: "tb",
            pubKeyHash: 0x6f,
            scriptHash: 0xc4,
            wif: 0xef
        },
        p2sh: {
            bip32: {
                public: 0x043587cf,
                private: 0x04358394
            }
        },
        p2pkh: {
            bip32: {
                public: 0x043587cf,
                private: 0x04358394
            }
        },
        "p2sh-p2wpkh": {
            bip32: {
                public: 0x044a5262,
                private: 0x044a4e28
            }
        },
        p2wpkh: {
            bip32: {
                public: 0x045f1cf6,
                private: 0x045f18bc
            }
        }
    }
};
//TODO: all below are missing network data
for (const coin of [
    "bitcoincash",
    "thorchain",
    "secret",
    "terra",
    "kava",
    "cardano",
    "cosmos",
    "osmosis",
    "binance",
    "ethereum",
    "arkeo",
    "mayachain"
])$04cb08ed4a28d97f$var$networks[coin] = $04cb08ed4a28d97f$var$networks.bitcoin;
function $04cb08ed4a28d97f$var$getNetwork(coin, scriptType) {
    coin = coin.toLowerCase();
    scriptType = scriptType || $04cb08ed4a28d97f$var$core.BTCOutputScriptType.PayToMultisig;
    if (!(coin in $04cb08ed4a28d97f$var$networks)) throw new Error(`${coin} network not supported`);
    const network = $04cb08ed4a28d97f$var$networks[coin];
    const bip32 = network[scriptType];
    if (!bip32) throw new Error(`${scriptType} not supported for ${coin} network`);
    return Object.assign(Object.assign({}, network.base), bip32);
}
module.exports.getNetwork = $04cb08ed4a28d97f$var$getNetwork;

});



parcelRegister("2VqZp", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $2215d72b8cffefcf$require$Buffer = $ihoyg.Buffer;
"use strict";
var $2215d72b8cffefcf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2215d72b8cffefcf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2215d72b8cffefcf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2215d72b8cffefcf$var$__createBinding(result, mod, k);
    }
    $2215d72b8cffefcf$var$__setModuleDefault(result, mod);
    return result;
};
var $2215d72b8cffefcf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2215d72b8cffefcf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalSignerAdapter = void 0;

const $2215d72b8cffefcf$var$core = $2215d72b8cffefcf$var$__importStar((parcelRequire("lFpDy")));

const $2215d72b8cffefcf$var$bs58_1 = $2215d72b8cffefcf$var$__importDefault((parcelRequire("hZS7n")));

var $cVeOu = parcelRequire("cVeOu");

const $2215d72b8cffefcf$var$Digest = $2215d72b8cffefcf$var$__importStar((parcelRequire("bkHrJ")));

var $feVdj = parcelRequire("feVdj");

var $glOWu = parcelRequire("glOWu");
function $2215d72b8cffefcf$var$bs58FioEncode(raw, keyType = "") {
    const typeBuf = $2215d72b8cffefcf$require$Buffer.from(keyType, "utf8");
    const checksum = $2215d72b8cffefcf$var$Digest.Algorithms["ripemd160"]($2215d72b8cffefcf$var$core.compatibleBufferConcat([
        raw,
        typeBuf
    ])).slice(0, 4);
    return $2215d72b8cffefcf$var$bs58_1.default.encode($2215d72b8cffefcf$var$core.compatibleBufferConcat([
        raw,
        checksum
    ]));
}
class $2215d72b8cffefcf$var$ExternalSignerAdapter {
    constructor(isolatedKey, publicKey){
        this._isolatedKey = isolatedKey;
        this._publicKey = publicKey;
    }
    static create(isolatedKey) {
        return $2215d72b8cffefcf$var$__awaiter(this, void 0, void 0, function*() {
            return new $2215d72b8cffefcf$var$ExternalSignerAdapter(isolatedKey, (yield isolatedKey.getPublicKey()));
        });
    }
    get publicKey() {
        const raw = $cVeOu.SecP256K1.CompressedPoint.from(this._publicKey);
        return `FIO${$2215d72b8cffefcf$var$bs58FioEncode(raw)}`;
    }
    sign(signBuf) {
        return $2215d72b8cffefcf$var$__awaiter(this, void 0, void 0, function*() {
            const sig = yield $cVeOu.SecP256K1.RecoverableSignature.signCanonically(this._isolatedKey, "sha256", signBuf);
            const fioSigBuf = $2215d72b8cffefcf$var$core.compatibleBufferConcat([
                $2215d72b8cffefcf$require$Buffer.from([
                    $feVdj.RecoverableSignature.recoveryParam(sig) + 4 + 27
                ]),
                $cVeOu.SecP256K1.RecoverableSignature.r(sig),
                $cVeOu.SecP256K1.RecoverableSignature.s(sig)
            ]);
            return `SIG_K1_${$2215d72b8cffefcf$var$bs58FioEncode(fioSigBuf, "K1")}`;
        });
    }
    getSharedSecret(publicKey) {
        return $2215d72b8cffefcf$var$__awaiter(this, void 0, void 0, function*() {
            return $2215d72b8cffefcf$require$Buffer.from($2215d72b8cffefcf$var$Digest.Algorithms["sha512"]((yield this._isolatedKey.ecdh((0, $glOWu.checkType)($cVeOu.SecP256K1.CurvePoint, publicKey.toBuffer())))));
        });
    }
}
module.exports.ExternalSignerAdapter = $2215d72b8cffefcf$var$ExternalSignerAdapter;
module.exports.default = $2215d72b8cffefcf$var$ExternalSignerAdapter;

});

parcelRegister("9BvPv", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $6fe042775c858fef$require$Buffer = $ihoyg.Buffer;
"use strict";
var $6fe042775c858fef$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6fe042775c858fef$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6fe042775c858fef$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6fe042775c858fef$var$__createBinding(result, mod, k);
    }
    $6fe042775c858fef$var$__setModuleDefault(result, mod);
    return result;
};
var $6fe042775c858fef$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6fe042775c858fef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6fe042775c858fef$var$p_lazy_1 = $6fe042775c858fef$var$__importDefault((parcelRequire("gGdnO")));

var $cVeOu = parcelRequire("cVeOu");

const $6fe042775c858fef$var$bnbSdk = $6fe042775c858fef$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return Promise.resolve((parcelRequire("hQ2c4")));
    }).then((res)=>$6fe042775c858fef$var$__importStar(res)));
module.exports.default = {
    create (keyPair) {
        return $6fe042775c858fef$var$__awaiter(this, void 0, void 0, function*() {
            return (tx, signMsg)=>$6fe042775c858fef$var$__awaiter(this, void 0, void 0, function*() {
                    const signBytes = tx.getSignBytes(signMsg);
                    const pubKey = (yield $6fe042775c858fef$var$bnbSdk).crypto.getPublicKey($6fe042775c858fef$require$Buffer.from((yield keyPair.getPublicKey())).toString("hex"));
                    const sig = $6fe042775c858fef$require$Buffer.from((yield $cVeOu.SecP256K1.Signature.signCanonically(keyPair, "sha256", signBytes)));
                    tx.addSignature(pubKey, sig);
                    return tx;
                });
        });
    }
};

});

parcelRegister("jYjQG", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e8a3047980083c2f$require$Buffer = $ihoyg.Buffer;
"use strict";
var $e8a3047980083c2f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WalletAdapter = void 0;
class $e8a3047980083c2f$var$WalletAdapter {
    constructor(isolatedKey, publicKey){
        this._isolatedKey = isolatedKey;
        this._publicKey = publicKey;
    }
    static create(isolatedKey) {
        return $e8a3047980083c2f$var$__awaiter(this, void 0, void 0, function*() {
            return new $e8a3047980083c2f$var$WalletAdapter(isolatedKey, (yield isolatedKey.getPublicKey()));
        });
    }
    get publicKey() {
        return $e8a3047980083c2f$require$Buffer.from(this._publicKey).toString("hex");
    }
    sign(signMessage) {
        return $e8a3047980083c2f$var$__awaiter(this, void 0, void 0, function*() {
            const signBuf = $e8a3047980083c2f$require$Buffer.from(signMessage.normalize("NFKD"), "utf8");
            return $e8a3047980083c2f$require$Buffer.from((yield this._isolatedKey.ecdsaSign("sha256", signBuf)));
        });
    }
}
module.exports.WalletAdapter = $e8a3047980083c2f$var$WalletAdapter;
module.exports.default = $e8a3047980083c2f$var$WalletAdapter;

});

parcelRegister("hKoqE", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $ceb9ae9d7c752912$require$Buffer = $ihoyg.Buffer;
"use strict";
var $ceb9ae9d7c752912$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ceb9ae9d7c752912$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ceb9ae9d7c752912$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ceb9ae9d7c752912$var$__createBinding(result, mod, k);
    }
    $ceb9ae9d7c752912$var$__setModuleDefault(result, mod);
    return result;
};
var $ceb9ae9d7c752912$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $ceb9ae9d7c752912$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.OfflineDirectSignerAdapter = void 0;

const $ceb9ae9d7c752912$var$bech32 = $ceb9ae9d7c752912$var$__importStar((parcelRequire("5wgCY")));

const $ceb9ae9d7c752912$var$p_lazy_1 = $ceb9ae9d7c752912$var$__importDefault((parcelRequire("gGdnO")));

var $cVeOu = parcelRequire("cVeOu");

const $ceb9ae9d7c752912$var$cosmJsProtoSigning = $ceb9ae9d7c752912$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("hA0xz"));
    }).then((res)=>$ceb9ae9d7c752912$var$__importStar(res)));
class $ceb9ae9d7c752912$var$OfflineDirectSignerAdapter {
    constructor(isolatedKey, pubkey, address){
        this._isolatedKey = isolatedKey;
        this._pubkey = pubkey;
        this.address = address;
    }
    static create(isolatedKey, prefix) {
        return $ceb9ae9d7c752912$var$__awaiter(this, void 0, void 0, function*() {
            const pubkey = yield isolatedKey.getPublicKey();
            const address = $ceb9ae9d7c752912$var$bech32.encode(prefix, $ceb9ae9d7c752912$var$bech32.toWords($cVeOu.Digest.Algorithms.ripemd160($cVeOu.Digest.Algorithms.sha256((yield isolatedKey.getPublicKey())))));
            return new $ceb9ae9d7c752912$var$OfflineDirectSignerAdapter(isolatedKey, pubkey, address);
        });
    }
    getAccounts() {
        return $ceb9ae9d7c752912$var$__awaiter(this, void 0, void 0, function*() {
            return [
                {
                    address: this.address,
                    algo: "secp256k1",
                    pubkey: this._pubkey
                }
            ];
        });
    }
    signDirect(signerAddress, signDoc) {
        return $ceb9ae9d7c752912$var$__awaiter(this, void 0, void 0, function*() {
            if (signerAddress !== this.address) throw new Error("signerAddress mismatch");
            const signBytes = (yield $ceb9ae9d7c752912$var$cosmJsProtoSigning).makeSignBytes(signDoc);
            const signatureBytes = yield this._isolatedKey.ecdsaSign("sha256", signBytes);
            return {
                signed: signDoc,
                signature: {
                    pub_key: {
                        type: "tendermint/PubKeySecp256k1",
                        value: $ceb9ae9d7c752912$require$Buffer.from(this._pubkey).toString("base64")
                    },
                    signature: $ceb9ae9d7c752912$require$Buffer.from(signatureBytes).toString("base64")
                }
            };
        });
    }
}
module.exports.OfflineDirectSignerAdapter = $ceb9ae9d7c752912$var$OfflineDirectSignerAdapter;
module.exports.default = $ceb9ae9d7c752912$var$OfflineDirectSignerAdapter;

});
parcelRegister("hA0xz", function(module, exports) {

var $hffE7 = parcelRequire("hffE7");
module.exports = Promise.all([
    $hffE7("7f0Rw"),
    $hffE7("937ca")
]).then(()=>parcelRequire("gxwRv"));

});



parcelRegister("kYfJJ", function(module, exports) {
"use strict";
var $f4459e32871f9f97$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f4459e32871f9f97$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f4459e32871f9f97$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f4459e32871f9f97$var$__createBinding(result, mod, k);
    }
    $f4459e32871f9f97$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Dummy = module.exports.Default = void 0;

module.exports.Default = $f4459e32871f9f97$var$__importStar((parcelRequire("bhKwM")));

module.exports.Dummy = $f4459e32871f9f97$var$__importStar((parcelRequire("iLQ2g")));

});
parcelRegister("bhKwM", function(module, exports) {
"use strict";
var $83755fa6f3f429e0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $83755fa6f3f429e0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $83755fa6f3f429e0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $83755fa6f3f429e0$var$__createBinding(result, mod, k);
    }
    $83755fa6f3f429e0$var$__setModuleDefault(result, mod);
    return result;
};
var $83755fa6f3f429e0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $83755fa6f3f429e0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BIP39 = module.exports.BIP32 = void 0;

module.exports.BIP32 = $83755fa6f3f429e0$var$__importStar((parcelRequire("h1U0y")));

module.exports.BIP39 = $83755fa6f3f429e0$var$__importStar((parcelRequire("5Q9T4")));

$83755fa6f3f429e0$var$__exportStar((parcelRequire("g242c")), module.exports);

});
parcelRegister("h1U0y", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $c65df9b1b3444473$require$Buffer = $ihoyg.Buffer;
"use strict";
var $c65df9b1b3444473$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c65df9b1b3444473$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c65df9b1b3444473$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c65df9b1b3444473$var$__createBinding(result, mod, k);
    }
    $c65df9b1b3444473$var$__setModuleDefault(result, mod);
    return result;
};
var $c65df9b1b3444473$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $c65df9b1b3444473$var$__createBinding(exports1, m, p);
};
var $c65df9b1b3444473$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c65df9b1b3444473$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $c65df9b1b3444473$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c65df9b1b3444473$var$_Node_privateKey, $c65df9b1b3444473$var$_Node_publicKey, $c65df9b1b3444473$var$_Seed_seed;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Seed = module.exports.Node = void 0;

const $c65df9b1b3444473$var$bip32crypto = $c65df9b1b3444473$var$__importStar((parcelRequire("fuOE5")));

const $c65df9b1b3444473$var$tinyecc = $c65df9b1b3444473$var$__importStar((parcelRequire("bAAqK")));

var $3Ea7J = parcelRequire("3Ea7J");

var $cVeOu = parcelRequire("cVeOu");

var $glOWu = parcelRequire("glOWu");

var $g242c = parcelRequire("g242c");

$c65df9b1b3444473$var$__exportStar((parcelRequire("bK4PJ")), module.exports);
class $c65df9b1b3444473$var$Node extends (0, $g242c.Revocable)(class {
}) {
    constructor(privateKey, chainCode, explicitPath){
        super();
        $c65df9b1b3444473$var$_Node_privateKey.set(this, void 0);
        $c65df9b1b3444473$var$_Node_publicKey.set(this, void 0);
        // We avoid handing the private key to any non-platform code -- including our type-checking machinery.
        if (privateKey.length !== 32) throw new Error("bad private key length");
        $c65df9b1b3444473$var$__classPrivateFieldSet(this, $c65df9b1b3444473$var$_Node_privateKey, (0, $glOWu.safeBufferFrom)(privateKey), "f");
        this.addRevoker(()=>$c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f").fill(0));
        this.chainCode = (0, $glOWu.safeBufferFrom)((0, $glOWu.checkType)($cVeOu.BIP32.ChainCode, chainCode));
        this.explicitPath = explicitPath;
    }
    static create(privateKey, chainCode, explicitPath) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            const obj = new $c65df9b1b3444473$var$Node(privateKey, chainCode, explicitPath);
            return (0, $g242c.revocable)(obj, (x)=>obj.addRevoker(x));
        });
    }
    getPublicKey() {
        var _a;
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            $c65df9b1b3444473$var$__classPrivateFieldSet(this, $c65df9b1b3444473$var$_Node_publicKey, (_a = $c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_publicKey, "f")) !== null && _a !== void 0 ? _a : (0, $glOWu.checkType)($cVeOu.SecP256K1.CompressedPoint, $c65df9b1b3444473$var$tinyecc.pointFromScalar($c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f"), true)), "f");
            return $c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_publicKey, "f");
        });
    }
    getChainCode() {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            return this.chainCode;
        });
    }
    ecdsaSign(digestAlgorithm, msg, counter) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            const recoverableSig = yield (()=>$c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
                    if (digestAlgorithm === null) {
                        (0, $glOWu.assertType)((0, $glOWu.ByteArray)(32), msg);
                        return yield this.ecdsaSignRecoverable(digestAlgorithm, msg, counter);
                    } else return yield this.ecdsaSignRecoverable(digestAlgorithm, msg, counter);
                }))();
            return $cVeOu.SecP256K1.RecoverableSignature.sig(recoverableSig);
        });
    }
    ecdsaSignRecoverable(digestAlgorithm, msg, counter) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            counter === undefined || $glOWu.Uint32.assert(counter);
            digestAlgorithm === null || $cVeOu.Digest.AlgorithmName(32).assert(digestAlgorithm);
            if ($c65df9b1b3444473$var$Node.requirePreimage && digestAlgorithm === null) throw TypeError("preimage required");
            const msgOrDigest = digestAlgorithm === null ? (0, $glOWu.checkType)((0, $glOWu.ByteArray)(32), msg) : $cVeOu.Digest.Algorithms[digestAlgorithm]((0, $glOWu.checkType)((0, $glOWu.ByteArray)(), msg));
            const entropy = counter === undefined ? undefined : $c65df9b1b3444473$require$Buffer.alloc(32);
            entropy === null || entropy === void 0 || entropy.writeUInt32BE(counter !== null && counter !== void 0 ? counter : 0, 24);
            return yield $cVeOu.SecP256K1.RecoverableSignature.fromSignature((0, $glOWu.checkType)($cVeOu.SecP256K1.Signature, $c65df9b1b3444473$var$tinyecc.signWithEntropy($c65df9b1b3444473$require$Buffer.from(msgOrDigest), $c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f"), entropy)), null, msgOrDigest, (yield this.getPublicKey()));
        });
    }
    derive(index) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            $glOWu.Uint32.assert(index);
            const serP = $c65df9b1b3444473$require$Buffer.alloc(37);
            if (index < 0x80000000) serP.set($cVeOu.SecP256K1.CompressedPoint.from((yield this.getPublicKey())), 0);
            else serP.set($c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f"), 1);
            serP.writeUInt32BE(index, 33);
            const I = $c65df9b1b3444473$var$bip32crypto.hmacSHA512(this.chainCode, serP);
            const IL = I.slice(0, 32);
            const IR = I.slice(32, 64);
            const ki = $c65df9b1b3444473$var$tinyecc.privateAdd($c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f"), IL);
            if (ki === null) throw new Error("ki is null; this should be cryptographically impossible");
            const out = yield $c65df9b1b3444473$var$Node.create(ki, IR);
            this.addRevoker(()=>{
                var _a;
                return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out);
            });
            return out;
        });
    }
    ecdh(publicKey, digestAlgorithm) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            $cVeOu.SecP256K1.CurvePoint.assert(publicKey);
            digestAlgorithm === undefined || $cVeOu.Digest.AlgorithmName(32).assert(digestAlgorithm);
            return (0, $glOWu.checkType)((0, $glOWu.ByteArray)(32), (yield this._ecdh(publicKey, digestAlgorithm)));
        });
    }
    ecdhRaw(publicKey) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            return (0, $glOWu.checkType)($cVeOu.SecP256K1.UncompressedPoint, (yield this._ecdh(publicKey, null)));
        });
    }
    _ecdh(publicKey, digestAlgorithm) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            $cVeOu.SecP256K1.CurvePoint.assert(publicKey);
            digestAlgorithm === undefined || digestAlgorithm === null || $cVeOu.Digest.AlgorithmName(32).assert(digestAlgorithm);
            const sharedFieldElement = (0, $glOWu.checkType)($cVeOu.SecP256K1.UncompressedPoint, $c65df9b1b3444473$var$tinyecc.pointMultiply($c65df9b1b3444473$require$Buffer.from(publicKey), $c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Node_privateKey, "f"), false));
            if (digestAlgorithm === null) return sharedFieldElement;
            let out = $cVeOu.SecP256K1.CurvePoint.x(sharedFieldElement);
            if (digestAlgorithm !== undefined) out = $cVeOu.Digest.Algorithms[digestAlgorithm](out);
            return out;
        });
    }
}
module.exports.Node = $c65df9b1b3444473$var$Node;
$c65df9b1b3444473$var$_Node_privateKey = new WeakMap(), $c65df9b1b3444473$var$_Node_publicKey = new WeakMap();
// When running tests, this will keep us aware of any codepaths that don't pass in the preimage
$c65df9b1b3444473$var$Node.requirePreimage = typeof expect === "function";
class $c65df9b1b3444473$var$Seed extends (0, $g242c.Revocable)(class {
}) {
    constructor(seed){
        super();
        $c65df9b1b3444473$var$_Seed_seed.set(this, void 0);
        $c65df9b1b3444473$var$__classPrivateFieldSet(this, $c65df9b1b3444473$var$_Seed_seed, (0, $glOWu.safeBufferFrom)(seed), "f");
        this.addRevoker(()=>$c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Seed_seed, "f").fill(0));
    }
    static create(seed) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            const obj = new $c65df9b1b3444473$var$Seed(seed);
            return (0, $g242c.revocable)(obj, (x)=>obj.addRevoker(x));
        });
    }
    toMasterKey(hmacKey) {
        return $c65df9b1b3444473$var$__awaiter(this, void 0, void 0, function*() {
            if (hmacKey !== undefined && typeof hmacKey !== "string" && !(hmacKey instanceof Uint8Array)) throw new Error("bad hmacKey type");
            // AFAIK all BIP32 implementations use the "Bitcoin seed" string for this derivation, even if they aren't otherwise Bitcoin-related
            hmacKey = hmacKey !== null && hmacKey !== void 0 ? hmacKey : "Bitcoin seed";
            if (typeof hmacKey === "string") hmacKey = new $3Ea7J.TextEncoder().encode(hmacKey.normalize("NFKD"));
            const I = (0, $glOWu.safeBufferFrom)($c65df9b1b3444473$var$bip32crypto.hmacSHA512((0, $glOWu.safeBufferFrom)(hmacKey), $c65df9b1b3444473$var$__classPrivateFieldGet(this, $c65df9b1b3444473$var$_Seed_seed, "f")));
            const IL = I.slice(0, 32);
            const IR = I.slice(32, 64);
            const out = yield $c65df9b1b3444473$var$Node.create(IL, IR);
            this.addRevoker(()=>{
                var _a;
                return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out);
            });
            return out;
        });
    }
}
module.exports.Seed = $c65df9b1b3444473$var$Seed;
$c65df9b1b3444473$var$_Seed_seed = new WeakMap();

});
parcelRegister("3Ea7J", function(module, exports) {

$parcel$export(module.exports, "TextEncoder", function () { return $2a7cf5e74778ba3f$export$88fb0cfd153261a7; }, function (v) { return $2a7cf5e74778ba3f$export$88fb0cfd153261a7 = v; });
$parcel$export(module.exports, "TextDecoder", function () { return $2a7cf5e74778ba3f$export$9c6b53e35bc51b5c; }, function (v) { return $2a7cf5e74778ba3f$export$9c6b53e35bc51b5c = v; });
var $2a7cf5e74778ba3f$export$88fb0cfd153261a7;
var $2a7cf5e74778ba3f$export$9c6b53e35bc51b5c;
"use strict";

$2a7cf5e74778ba3f$export$88fb0cfd153261a7 = typeof TextEncoder !== "undefined" ? TextEncoder : (parcelRequire("4zyeF")).TextEncoder;

$2a7cf5e74778ba3f$export$9c6b53e35bc51b5c = typeof TextDecoder !== "undefined" ? TextDecoder : (parcelRequire("4zyeF")).TextDecoder;

});

parcelRegister("g242c", function(module, exports) {
"use strict";
var $babff668b879087d$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $babff668b879087d$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Revocable = module.exports.revocable = void 0;
const $babff668b879087d$var$_Set = Set;
const $babff668b879087d$var$_freeze = Object.freeze.bind(Object);
const $babff668b879087d$var$_revocable = Proxy.revocable.bind(Proxy);
/*
Proxy handler invariants (per MDN):
  apply
    The target must be a callable itself. That is, it must be a function object.
  construct
    The result must be an Object.
  defineProperty
    A property cannot be added, if the target object is not extensible.
    A property cannot be added as or modified to be non-configurable, if it does not exists as a non-configurable own property of the target object.
    A property may not be non-configurable, if a corresponding configurable property of the target object exists.
    If a property has a corresponding target object property then Object.defineProperty(target, prop, descriptor) will not throw an exception.
    In strict mode, a false return value from the defineProperty() handler will throw a TypeError exception.
  deleteProperty
    A property cannot be deleted, if it exists as a non-configurable own property of the target object.
  get
    The value reported for a property must be the same as the value of the corresponding target object property if the target object property is a non-writable, non-configurable own data property.
    The value reported for a property must be undefined if the corresponding target object property is a non-configurable own accessor property that has undefined as its [[Get]] attribute.
  getOwnPropertyDescriptor
    getOwnPropertyDescriptor() must return an object or undefined.
    A property cannot be reported as non-existent, if it exists as a non-configurable own property of the target object.
    A property cannot be reported as non-existent, if it exists as an own property of the target object and the target object is not extensible.
    A property cannot be reported as existent, if it does not exists as an own property of the target object and the target object is not extensible.
    A property cannot be reported as non-configurable, if it does not exists as an own property of the target object or if it exists as a configurable own property of the target object.
    The result of Object.getOwnPropertyDescriptor(target) can be applied to the target object using Object.defineProperty() and will not throw an exception.
  getPrototypeOf
    getPrototypeOf() method must return an object or null.
    If target is not extensible, Object.getPrototypeOf(proxy) method must return the same value as Object.getPrototypeOf(target).
  has
    A property cannot be reported as non-existent, if it exists as a non-configurable own property of the target object.
    A property cannot be reported as non-existent, if it exists as an own property of the target object and the target object is not extensible.
  isExtensible
    Object.isExtensible(proxy) must return the same value as Object.isExtensible(target).
  ownKeys
    The result of ownKeys() must be an array.
    The type of each array element is either a String or a Symbol.
    The result List must contain the keys of all non-configurable own properties of the target object.
    If the target object is not extensible, then the result List must contain all the keys of the own properties of the target object and no other values.
  preventExtensions
    Object.preventExtensions(proxy) only returns true if Object.isExtensible(proxy) is false.
  set
    Return true to indicate that assignment succeeded.
    If the set() method returns false, and the assignment happened in strict-mode code, a TypeError will be thrown.
  setPrototypeOf
    If target is not extensible, the prototype parameter must be the same value as Object.getPrototypeOf(target).
*/ module.exports.revocable = $babff668b879087d$var$_freeze((x, addRevoker)=>{
    const universalProxyHandler = (pseudoTarget)=>new Proxy({}, {
            get (_, p) {
                return (_t, p2, r)=>{
                    switch(p){
                        case "get":
                            {
                                const out = Reflect.get(pseudoTarget, p2, r);
                                if (typeof out === "function") return out.bind(x);
                                return out;
                            }
                        case "getOwnPropertyDescriptor":
                            {
                                const out = Reflect.getOwnPropertyDescriptor(pseudoTarget, p2);
                                if (out) out.configurable = true;
                                return out;
                            }
                        case "isExtensible":
                            return true;
                        case "preventExtensions":
                            return false;
                        default:
                            return Reflect[p](pseudoTarget, p2, r);
                    }
                };
            }
        });
    const { proxy: proxy, revoke: revoke } = $babff668b879087d$var$_revocable({}, universalProxyHandler(x));
    addRevoker(revoke);
    return proxy;
});
module.exports.Revocable = $babff668b879087d$var$_freeze((x)=>{
    var _Revocable_revokers, _Revocable_revoked, _a;
    const out = $babff668b879087d$var$_freeze((_a = // eslint-disable-next-line @typescript-eslint/no-shadow
    class Revocable extends x {
        constructor(){
            super(...arguments);
            _Revocable_revokers.set(this, new $babff668b879087d$var$_Set());
            _Revocable_revoked.set(this, false);
            this.revoke = ()=>{
                $babff668b879087d$var$__classPrivateFieldSet(this, _Revocable_revoked, true, "f");
                $babff668b879087d$var$__classPrivateFieldGet(this, _Revocable_revokers, "f").forEach((revoker)=>{
                    try {
                        revoker();
                    } catch (_b) {
                    // revoker errors get swallowed.
                    }
                });
                $babff668b879087d$var$__classPrivateFieldGet(this, _Revocable_revokers, "f").clear();
            };
            this.addRevoker = (revoker)=>{
                if ($babff668b879087d$var$__classPrivateFieldGet(this, _Revocable_revoked, "f")) try {
                    revoker();
                } catch (_b) {
                // revoker errors get swallowed.
                }
                else $babff668b879087d$var$__classPrivateFieldGet(this, _Revocable_revokers, "f").add(revoker);
            };
        }
    }, _Revocable_revokers = new WeakMap(), _Revocable_revoked = new WeakMap(), _a));
    $babff668b879087d$var$_freeze(out.prototype);
    return out;
});

});


parcelRegister("5Q9T4", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $44097a77dd19a3b5$require$Buffer = $ihoyg.Buffer;
"use strict";
/// <reference types="bip32/types/crypto" />
var $44097a77dd19a3b5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $44097a77dd19a3b5$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $44097a77dd19a3b5$var$__createBinding(exports1, m, p);
};
var $44097a77dd19a3b5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $44097a77dd19a3b5$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $44097a77dd19a3b5$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $44097a77dd19a3b5$var$_Mnemonic_mnemonic;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;

var $1gmqI = parcelRequire("1gmqI");

var $3Ea7J = parcelRequire("3Ea7J");

var $h1U0y = parcelRequire("h1U0y");

var $g242c = parcelRequire("g242c");

$44097a77dd19a3b5$var$__exportStar((parcelRequire("2Q5oV")), module.exports);
class $44097a77dd19a3b5$var$Mnemonic extends (0, $g242c.Revocable)(class {
}) {
    constructor(mnemonic){
        super();
        $44097a77dd19a3b5$var$_Mnemonic_mnemonic.set(this, void 0);
        $44097a77dd19a3b5$var$__classPrivateFieldSet(this, $44097a77dd19a3b5$var$_Mnemonic_mnemonic, mnemonic.normalize("NFKD"), "f");
    }
    static create(mnemonic) {
        return $44097a77dd19a3b5$var$__awaiter(this, void 0, void 0, function*() {
            const obj = new $44097a77dd19a3b5$var$Mnemonic(mnemonic);
            return (0, $g242c.revocable)(obj, (x)=>obj.addRevoker(x));
        });
    }
    toSeed(passphrase) {
        return $44097a77dd19a3b5$var$__awaiter(this, void 0, void 0, function*() {
            const mnemonic = $44097a77dd19a3b5$var$__classPrivateFieldGet(this, $44097a77dd19a3b5$var$_Mnemonic_mnemonic, "f");
            const salt = new $3Ea7J.TextEncoder().encode(`mnemonic${passphrase !== null && passphrase !== void 0 ? passphrase : ""}`.normalize("NFKD"));
            const out = yield $h1U0y.Seed.create($44097a77dd19a3b5$require$Buffer.from((yield (0, $1gmqI.pbkdf2)({
                password: mnemonic,
                salt: salt,
                iterations: 2048,
                hashLength: 64,
                hashFunction: (0, $1gmqI.createSHA512)(),
                outputType: "binary"
            }))));
            this.addRevoker(()=>{
                var _a;
                return (_a = out.revoke) === null || _a === void 0 ? void 0 : _a.call(out);
            });
            return out;
        });
    }
}
module.exports.Mnemonic = $44097a77dd19a3b5$var$Mnemonic;
$44097a77dd19a3b5$var$_Mnemonic_mnemonic = new WeakMap();

});
parcelRegister("1gmqI", function(module, exports) {

$parcel$export(module.exports, "createSHA512", function () { return $0eb8af2968e12ba8$export$539d5a676a732b9; });
$parcel$export(module.exports, "pbkdf2", function () { return $0eb8af2968e12ba8$export$448fa22aedc9dbca; });
/*!
 * hash-wasm (https://www.npmjs.com/package/hash-wasm)
 * (c) Dani Biro
 * @license MIT
 */ /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $0eb8af2968e12ba8$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
class $0eb8af2968e12ba8$var$Mutex {
    constructor(){
        this.mutex = Promise.resolve();
    }
    lock() {
        let begin = ()=>{};
        this.mutex = this.mutex.then(()=>new Promise(begin));
        return new Promise((res)=>{
            begin = res;
        });
    }
    dispatch(fn) {
        return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
            const unlock = yield this.lock();
            try {
                return yield Promise.resolve(fn());
            } finally{
                unlock();
            }
        });
    }
}
/* eslint-disable import/prefer-default-export */ /* eslint-disable no-bitwise */ var $0eb8af2968e12ba8$var$_a;
function $0eb8af2968e12ba8$var$getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    // eslint-disable-next-line no-restricted-globals
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    return $parcel$global;
}
const $0eb8af2968e12ba8$var$globalObject = $0eb8af2968e12ba8$var$getGlobal();
const $0eb8af2968e12ba8$var$nodeBuffer = ($0eb8af2968e12ba8$var$_a = $0eb8af2968e12ba8$var$globalObject.Buffer) !== null && $0eb8af2968e12ba8$var$_a !== void 0 ? $0eb8af2968e12ba8$var$_a : null;
const $0eb8af2968e12ba8$var$textEncoder = $0eb8af2968e12ba8$var$globalObject.TextEncoder ? new $0eb8af2968e12ba8$var$globalObject.TextEncoder() : null;
function $0eb8af2968e12ba8$var$intArrayToString(arr, len) {
    return String.fromCharCode(...arr.subarray(0, len));
}
function $0eb8af2968e12ba8$var$hexCharCodesToInt(a, b) {
    return (a & 0xF) + (a >> 6 | a >> 3 & 0x8) << 4 | (b & 0xF) + (b >> 6 | b >> 3 & 0x8);
}
function $0eb8af2968e12ba8$var$writeHexToUInt8(buf, str) {
    const size = str.length >> 1;
    for(let i = 0; i < size; i++){
        const index = i << 1;
        buf[i] = $0eb8af2968e12ba8$var$hexCharCodesToInt(str.charCodeAt(index), str.charCodeAt(index + 1));
    }
}
function $0eb8af2968e12ba8$var$hexStringEqualsUInt8(str, buf) {
    if (str.length !== buf.length * 2) return false;
    for(let i = 0; i < buf.length; i++){
        const strIndex = i << 1;
        if (buf[i] !== $0eb8af2968e12ba8$var$hexCharCodesToInt(str.charCodeAt(strIndex), str.charCodeAt(strIndex + 1))) return false;
    }
    return true;
}
const $0eb8af2968e12ba8$var$alpha = "a".charCodeAt(0) - 10;
const $0eb8af2968e12ba8$var$digit = "0".charCodeAt(0);
function $0eb8af2968e12ba8$var$getDigestHex(tmpBuffer, input, hashLength) {
    let p = 0;
    /* eslint-disable no-plusplus */ for(let i = 0; i < hashLength; i++){
        let nibble = input[i] >>> 4;
        tmpBuffer[p++] = nibble > 9 ? nibble + $0eb8af2968e12ba8$var$alpha : nibble + $0eb8af2968e12ba8$var$digit;
        nibble = input[i] & 0xF;
        tmpBuffer[p++] = nibble > 9 ? nibble + $0eb8af2968e12ba8$var$alpha : nibble + $0eb8af2968e12ba8$var$digit;
    }
    /* eslint-enable no-plusplus */ return String.fromCharCode.apply(null, tmpBuffer);
}
const $0eb8af2968e12ba8$var$getUInt8Buffer = $0eb8af2968e12ba8$var$nodeBuffer !== null ? (data)=>{
    if (typeof data === "string") {
        const buf = $0eb8af2968e12ba8$var$nodeBuffer.from(data, "utf8");
        return new Uint8Array(buf.buffer, buf.byteOffset, buf.length);
    }
    if ($0eb8af2968e12ba8$var$nodeBuffer.isBuffer(data)) return new Uint8Array(data.buffer, data.byteOffset, data.length);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    throw new Error("Invalid data type!");
} : (data)=>{
    if (typeof data === "string") return $0eb8af2968e12ba8$var$textEncoder.encode(data);
    if (ArrayBuffer.isView(data)) return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
    throw new Error("Invalid data type!");
};
const $0eb8af2968e12ba8$var$base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const $0eb8af2968e12ba8$var$base64Lookup = new Uint8Array(256);
for(let i = 0; i < $0eb8af2968e12ba8$var$base64Chars.length; i++)$0eb8af2968e12ba8$var$base64Lookup[$0eb8af2968e12ba8$var$base64Chars.charCodeAt(i)] = i;
function $0eb8af2968e12ba8$var$encodeBase64(data, pad = true) {
    const len = data.length;
    const extraBytes = len % 3;
    const parts = [];
    const len2 = len - extraBytes;
    for(let i = 0; i < len2; i += 3){
        const tmp = (data[i] << 16 & 0xFF0000) + (data[i + 1] << 8 & 0xFF00) + (data[i + 2] & 0xFF);
        const triplet = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 18 & 0x3F) + $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 12 & 0x3F) + $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 6 & 0x3F) + $0eb8af2968e12ba8$var$base64Chars.charAt(tmp & 0x3F);
        parts.push(triplet);
    }
    if (extraBytes === 1) {
        const tmp = data[len - 1];
        const a = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 2);
        const b = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp << 4 & 0x3F);
        parts.push(`${a}${b}`);
        if (pad) parts.push("==");
    } else if (extraBytes === 2) {
        const tmp = (data[len - 2] << 8) + data[len - 1];
        const a = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 10);
        const b = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp >> 4 & 0x3F);
        const c = $0eb8af2968e12ba8$var$base64Chars.charAt(tmp << 2 & 0x3F);
        parts.push(`${a}${b}${c}`);
        if (pad) parts.push("=");
    }
    return parts.join("");
}
function $0eb8af2968e12ba8$var$getDecodeBase64Length(data) {
    let bufferLength = Math.floor(data.length * 0.75);
    const len = data.length;
    if (data[len - 1] === "=") {
        bufferLength -= 1;
        if (data[len - 2] === "=") bufferLength -= 1;
    }
    return bufferLength;
}
function $0eb8af2968e12ba8$var$decodeBase64(data) {
    const bufferLength = $0eb8af2968e12ba8$var$getDecodeBase64Length(data);
    const len = data.length;
    const bytes = new Uint8Array(bufferLength);
    let p = 0;
    for(let i = 0; i < len; i += 4){
        const encoded1 = $0eb8af2968e12ba8$var$base64Lookup[data.charCodeAt(i)];
        const encoded2 = $0eb8af2968e12ba8$var$base64Lookup[data.charCodeAt(i + 1)];
        const encoded3 = $0eb8af2968e12ba8$var$base64Lookup[data.charCodeAt(i + 2)];
        const encoded4 = $0eb8af2968e12ba8$var$base64Lookup[data.charCodeAt(i + 3)];
        bytes[p] = encoded1 << 2 | encoded2 >> 4;
        p += 1;
        bytes[p] = (encoded2 & 15) << 4 | encoded3 >> 2;
        p += 1;
        bytes[p] = (encoded3 & 3) << 6 | encoded4 & 63;
        p += 1;
    }
    return bytes;
}
const $0eb8af2968e12ba8$var$MAX_HEAP = 16384;
const $0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH = 4;
const $0eb8af2968e12ba8$var$wasmMutex = new $0eb8af2968e12ba8$var$Mutex();
const $0eb8af2968e12ba8$var$wasmModuleCache = new Map();
function $0eb8af2968e12ba8$var$WASMInterface(binary, hashLength) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        let wasmInstance = null;
        let memoryView = null;
        let initialized = false;
        if (typeof WebAssembly === "undefined") throw new Error("WebAssembly is not supported in this environment!");
        const writeMemory = (data, offset = 0)=>{
            memoryView.set(data, offset);
        };
        const getMemory = ()=>memoryView;
        const getExports = ()=>wasmInstance.exports;
        const setMemorySize = (totalSize)=>{
            wasmInstance.exports.Hash_SetMemorySize(totalSize);
            const arrayOffset = wasmInstance.exports.Hash_GetBuffer();
            const memoryBuffer = wasmInstance.exports.memory.buffer;
            memoryView = new Uint8Array(memoryBuffer, arrayOffset, totalSize);
        };
        const getStateSize = ()=>{
            const view = new DataView(wasmInstance.exports.memory.buffer);
            const stateSize = view.getUint32(wasmInstance.exports.STATE_SIZE, true);
            return stateSize;
        };
        const loadWASMPromise = $0eb8af2968e12ba8$var$wasmMutex.dispatch(()=>$0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
                if (!$0eb8af2968e12ba8$var$wasmModuleCache.has(binary.name)) {
                    const asm = $0eb8af2968e12ba8$var$decodeBase64(binary.data);
                    const promise = WebAssembly.compile(asm);
                    $0eb8af2968e12ba8$var$wasmModuleCache.set(binary.name, promise);
                }
                const module = yield $0eb8af2968e12ba8$var$wasmModuleCache.get(binary.name);
                wasmInstance = yield WebAssembly.instantiate(module, {
                });
            // wasmInstance.exports._start();
            }));
        const setupInterface = ()=>$0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
                if (!wasmInstance) yield loadWASMPromise;
                const arrayOffset = wasmInstance.exports.Hash_GetBuffer();
                const memoryBuffer = wasmInstance.exports.memory.buffer;
                memoryView = new Uint8Array(memoryBuffer, arrayOffset, $0eb8af2968e12ba8$var$MAX_HEAP);
            });
        const init = (bits = null)=>{
            initialized = true;
            wasmInstance.exports.Hash_Init(bits);
        };
        const updateUInt8Array = (data)=>{
            let read = 0;
            while(read < data.length){
                const chunk = data.subarray(read, read + $0eb8af2968e12ba8$var$MAX_HEAP);
                read += chunk.length;
                memoryView.set(chunk);
                wasmInstance.exports.Hash_Update(chunk.length);
            }
        };
        const update = (data)=>{
            if (!initialized) throw new Error("update() called before init()");
            const Uint8Buffer = $0eb8af2968e12ba8$var$getUInt8Buffer(data);
            updateUInt8Array(Uint8Buffer);
        };
        const digestChars = new Uint8Array(hashLength * 2);
        const digest = (outputType, padding = null)=>{
            if (!initialized) throw new Error("digest() called before init()");
            initialized = false;
            wasmInstance.exports.Hash_Final(padding);
            if (outputType === "binary") // the data is copied to allow GC of the original memory object
            return memoryView.slice(0, hashLength);
            return $0eb8af2968e12ba8$var$getDigestHex(digestChars, memoryView, hashLength);
        };
        const save = ()=>{
            if (!initialized) throw new Error("save() can only be called after init() and before digest()");
            const stateOffset = wasmInstance.exports.Hash_GetState();
            const stateLength = getStateSize();
            const memoryBuffer = wasmInstance.exports.memory.buffer;
            const internalState = new Uint8Array(memoryBuffer, stateOffset, stateLength);
            // prefix is 4 bytes from SHA1 hash of the WASM binary
            // it is used to detect incompatible internal states between different versions of hash-wasm
            const prefixedState = new Uint8Array($0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH + stateLength);
            $0eb8af2968e12ba8$var$writeHexToUInt8(prefixedState, binary.hash);
            prefixedState.set(internalState, $0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH);
            return prefixedState;
        };
        const load = (state)=>{
            if (!(state instanceof Uint8Array)) throw new Error("load() expects an Uint8Array generated by save()");
            const stateOffset = wasmInstance.exports.Hash_GetState();
            const stateLength = getStateSize();
            const overallLength = $0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH + stateLength;
            const memoryBuffer = wasmInstance.exports.memory.buffer;
            if (state.length !== overallLength) throw new Error(`Bad state length (expected ${overallLength} bytes, got ${state.length})`);
            if (!$0eb8af2968e12ba8$var$hexStringEqualsUInt8(binary.hash, state.subarray(0, $0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH))) throw new Error("This state was written by an incompatible hash implementation");
            const internalState = state.subarray($0eb8af2968e12ba8$var$WASM_FUNC_HASH_LENGTH);
            new Uint8Array(memoryBuffer, stateOffset, stateLength).set(internalState);
            initialized = true;
        };
        const isDataShort = (data)=>{
            if (typeof data === "string") // worst case is 4 bytes / char
            return data.length < $0eb8af2968e12ba8$var$MAX_HEAP / 4;
            return data.byteLength < $0eb8af2968e12ba8$var$MAX_HEAP;
        };
        let canSimplify = isDataShort;
        switch(binary.name){
            case "argon2":
            case "scrypt":
                canSimplify = ()=>true;
                break;
            case "blake2b":
            case "blake2s":
                // if there is a key at blake2 then cannot simplify
                canSimplify = (data, initParam)=>initParam <= 512 && isDataShort(data);
                break;
            case "blake3":
                // if there is a key at blake3 then cannot simplify
                canSimplify = (data, initParam)=>initParam === 0 && isDataShort(data);
                break;
            case "xxhash64":
            case "xxhash3":
            case "xxhash128":
                canSimplify = ()=>false;
                break;
        }
        // shorthand for (init + update + digest) for better performance
        const calculate = (data, initParam = null, digestParam = null)=>{
            if (!canSimplify(data, initParam)) {
                init(initParam);
                update(data);
                return digest("hex", digestParam);
            }
            const buffer = $0eb8af2968e12ba8$var$getUInt8Buffer(data);
            memoryView.set(buffer);
            wasmInstance.exports.Hash_Calculate(buffer.length, initParam, digestParam);
            return $0eb8af2968e12ba8$var$getDigestHex(digestChars, memoryView, hashLength);
        };
        yield setupInterface();
        return {
            getMemory: getMemory,
            writeMemory: writeMemory,
            getExports: getExports,
            setMemorySize: setMemorySize,
            init: init,
            update: update,
            digest: digest,
            save: save,
            load: load,
            calculate: calculate,
            hashLength: hashLength
        };
    });
}
var $0eb8af2968e12ba8$var$name$k = "adler32";
var $0eb8af2968e12ba8$var$data$k = "AGFzbQEAAAABDANgAAF/YAAAYAF/AAMHBgABAgEAAgQFAXABAQEFBAEBAgIGDgJ/AUGAiQULfwBBgAgLB3AIBm1lbW9yeQIADkhhc2hfR2V0QnVmZmVyAAAJSGFzaF9Jbml0AAELSGFzaF9VcGRhdGUAAgpIYXNoX0ZpbmFsAAMNSGFzaF9HZXRTdGF0ZQAEDkhhc2hfQ2FsY3VsYXRlAAUKU1RBVEVfU0laRQMBCoAIBgUAQYAJCwoAQQBBATYChAgL9gYBBn9BACgChAgiAUH//wNxIQIgAUEQdiEDAkACQCAAQQFHDQAgAkEALQCACWoiAUGPgHxqIAEgAUHw/wNLGyIBIANqIgRBEHQiBUGAgDxqIAUgBEHw/wNLGyABciEBDAELAkACQAJAAkACQCAAQRBJDQBBgAkhBiAAQbArSQ0BQYAJIQYDQEEAIQUDQCAGIAVqIgEoAgAiBEH/AXEgAmoiAiADaiACIARBCHZB/wFxaiICaiACIARBEHZB/wFxaiICaiACIARBGHZqIgJqIAIgAUEEaigCACIEQf8BcWoiAmogAiAEQQh2Qf8BcWoiAmogAiAEQRB2Qf8BcWoiAmogAiAEQRh2aiICaiACIAFBCGooAgAiBEH/AXFqIgJqIAIgBEEIdkH/AXFqIgJqIAIgBEEQdkH/AXFqIgJqIAIgBEEYdmoiBGogBCABQQxqKAIAIgFB/wFxaiIEaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgJqIQMgBUEQaiIFQbArRw0ACyADQfH/A3AhAyACQfH/A3AhAiAGQbAraiEGIABB0FRqIgBBrytLDQALIABFDQQgAEEPSw0BDAILAkAgAEUNAEEAIQEDQCACIAFBgAlqLQAAaiICIANqIQMgACABQQFqIgFHDQALCyACQY+AfGogAiACQfD/A0sbIANB8f8DcEEQdHIhAQwECwNAIAYoAgAiAUH/AXEgAmoiBCADaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgRqIAQgBkEEaigCACIBQf8BcWoiBGogBCABQQh2Qf8BcWoiBGogBCABQRB2Qf8BcWoiBGogBCABQRh2aiIEaiAEIAZBCGooAgAiAUH/AXFqIgRqIAQgAUEIdkH/AXFqIgRqIAQgAUEQdkH/AXFqIgRqIAQgAUEYdmoiBGogBCAGQQxqKAIAIgFB/wFxaiIEaiAEIAFBCHZB/wFxaiIEaiAEIAFBEHZB/wFxaiIEaiAEIAFBGHZqIgJqIQMgBkEQaiEGIABBcGoiAEEPSw0ACyAARQ0BCwNAIAIgBi0AAGoiAiADaiEDIAZBAWohBiAAQX9qIgANAAsLIANB8f8DcCEDIAJB8f8DcCECCyACIANBEHRyIQELQQAgATYChAgLMgEBf0EAQQAoAoQIIgBBGHQgAEEIdEGAgPwHcXIgAEEIdkGA/gNxIABBGHZycjYCgAkLBQBBhAgLPABBAEEBNgKECCAAEAJBAEEAKAKECCIAQRh0IABBCHRBgID8B3FyIABBCHZBgP4DcSAAQRh2cnI2AoAJCwsVAgBBgAgLBAQAAAAAQYQICwQBAAAA";
var $0eb8af2968e12ba8$var$hash$k = "321174b4";
var $0eb8af2968e12ba8$var$wasmJson$k = {
    name: $0eb8af2968e12ba8$var$name$k,
    data: $0eb8af2968e12ba8$var$data$k,
    hash: $0eb8af2968e12ba8$var$hash$k
};
function $0eb8af2968e12ba8$var$lockedCreate(mutex, binary, hashLength) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        const unlock = yield mutex.lock();
        const wasm = yield $0eb8af2968e12ba8$var$WASMInterface(binary, hashLength);
        unlock();
        return wasm;
    });
}
const $0eb8af2968e12ba8$var$mutex$l = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$l = null;
/**
 * Calculates Adler-32 hash. The resulting 32-bit hash is stored in
 * network byte order (big-endian).
 *
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$f017985ecc6cb33f(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$l === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$l, $0eb8af2968e12ba8$var$wasmJson$k, 4).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$l = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$l.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$l.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new Adler-32 hash instance
 */ function $0eb8af2968e12ba8$export$91ca2745c3d4e0f9() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$k, 4).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 4,
            digestSize: 4
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$j = "blake2b";
var $0eb8af2968e12ba8$var$data$j = "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";
var $0eb8af2968e12ba8$var$hash$j = "68afc9cf";
var $0eb8af2968e12ba8$var$wasmJson$j = {
    name: $0eb8af2968e12ba8$var$name$j,
    data: $0eb8af2968e12ba8$var$data$j,
    hash: $0eb8af2968e12ba8$var$hash$j
};
const $0eb8af2968e12ba8$var$mutex$k = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$k = null;
function $0eb8af2968e12ba8$var$validateBits$4(bits) {
    if (!Number.isInteger(bits) || bits < 8 || bits > 512 || bits % 8 !== 0) return new Error("Invalid variant! Valid values: 8, 16, ..., 512");
    return null;
}
function $0eb8af2968e12ba8$var$getInitParam$1(outputBits, keyBits) {
    // eslint-disable-next-line no-bitwise
    return outputBits | keyBits << 16;
}
/**
 * Calculates BLAKE2b hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8, between 8 and 512. Defaults to 512.
 * @param key Optional key (string, Buffer or TypedArray). Maximum length is 64 bytes.
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$31406b37573ddf7(data, bits = 512, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$4(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$4(bits));
    let keyBuffer = null;
    let initParam = bits;
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length > 64) return Promise.reject(new Error("Max key length is 64 bytes"));
        initParam = $0eb8af2968e12ba8$var$getInitParam$1(bits, keyBuffer.length);
    }
    const hashLength = bits / 8;
    if ($0eb8af2968e12ba8$var$wasmCache$k === null || $0eb8af2968e12ba8$var$wasmCache$k.hashLength !== hashLength) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$k, $0eb8af2968e12ba8$var$wasmJson$j, hashLength).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$k = wasm;
        if (initParam > 512) $0eb8af2968e12ba8$var$wasmCache$k.writeMemory(keyBuffer);
        return $0eb8af2968e12ba8$var$wasmCache$k.calculate(data, initParam);
    });
    try {
        if (initParam > 512) $0eb8af2968e12ba8$var$wasmCache$k.writeMemory(keyBuffer);
        const hash = $0eb8af2968e12ba8$var$wasmCache$k.calculate(data, initParam);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new BLAKE2b hash instance
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8, between 8 and 512. Defaults to 512.
 * @param key Optional key (string, Buffer or TypedArray). Maximum length is 64 bytes.
 */ function $0eb8af2968e12ba8$export$fbc5ef50a60ce893(bits = 512, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$4(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$4(bits));
    let keyBuffer = null;
    let initParam = bits;
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length > 64) return Promise.reject(new Error("Max key length is 64 bytes"));
        initParam = $0eb8af2968e12ba8$var$getInitParam$1(bits, keyBuffer.length);
    }
    const outputSize = bits / 8;
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$j, outputSize).then((wasm)=>{
        if (initParam > 512) wasm.writeMemory(keyBuffer);
        wasm.init(initParam);
        const obj = {
            init: initParam > 512 ? ()=>{
                wasm.writeMemory(keyBuffer);
                wasm.init(initParam);
                return obj;
            } : ()=>{
                wasm.init(initParam);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 128,
            digestSize: outputSize
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$i = "argon2";
var $0eb8af2968e12ba8$var$data$i = "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";
var $0eb8af2968e12ba8$var$hash$i = "59aa4fb4";
var $0eb8af2968e12ba8$var$wasmJson$i = {
    name: $0eb8af2968e12ba8$var$name$i,
    data: $0eb8af2968e12ba8$var$data$i,
    hash: $0eb8af2968e12ba8$var$hash$i
};
function $0eb8af2968e12ba8$var$encodeResult(salt, options, res) {
    const parameters = [
        `m=${options.memorySize}`,
        `t=${options.iterations}`,
        `p=${options.parallelism}`
    ].join(",");
    return `$argon2${options.hashType}$v=19$${parameters}$${$0eb8af2968e12ba8$var$encodeBase64(salt, false)}$${$0eb8af2968e12ba8$var$encodeBase64(res, false)}`;
}
const $0eb8af2968e12ba8$var$uint32View = new DataView(new ArrayBuffer(4));
function $0eb8af2968e12ba8$var$int32LE(x) {
    $0eb8af2968e12ba8$var$uint32View.setInt32(0, x, true);
    return new Uint8Array($0eb8af2968e12ba8$var$uint32View.buffer);
}
function $0eb8af2968e12ba8$var$hashFunc(blake512, buf, len) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        if (len <= 64) {
            const blake = yield $0eb8af2968e12ba8$export$fbc5ef50a60ce893(len * 8);
            blake.update($0eb8af2968e12ba8$var$int32LE(len));
            blake.update(buf);
            return blake.digest("binary");
        }
        const r = Math.ceil(len / 32) - 2;
        const ret = new Uint8Array(len);
        blake512.init();
        blake512.update($0eb8af2968e12ba8$var$int32LE(len));
        blake512.update(buf);
        let vp = blake512.digest("binary");
        ret.set(vp.subarray(0, 32), 0);
        for(let i = 1; i < r; i++){
            blake512.init();
            blake512.update(vp);
            vp = blake512.digest("binary");
            ret.set(vp.subarray(0, 32), i * 32);
        }
        const partialBytesNeeded = len - 32 * r;
        let blakeSmall;
        if (partialBytesNeeded === 64) {
            blakeSmall = blake512;
            blakeSmall.init();
        } else blakeSmall = yield $0eb8af2968e12ba8$export$fbc5ef50a60ce893(partialBytesNeeded * 8);
        blakeSmall.update(vp);
        vp = blakeSmall.digest("binary");
        ret.set(vp.subarray(0, partialBytesNeeded), r * 32);
        return ret;
    });
}
function $0eb8af2968e12ba8$var$getHashType(type) {
    switch(type){
        case "d":
            return 0;
        case "i":
            return 1;
        default:
            return 2;
    }
}
function $0eb8af2968e12ba8$var$argon2Internal(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        const { parallelism: parallelism, iterations: iterations, hashLength: hashLength } = options;
        const password = $0eb8af2968e12ba8$var$getUInt8Buffer(options.password);
        const salt = $0eb8af2968e12ba8$var$getUInt8Buffer(options.salt);
        const version = 0x13;
        const hashType = $0eb8af2968e12ba8$var$getHashType(options.hashType);
        const { memorySize: memorySize } = options; // in KB
        const [argon2Interface, blake512] = yield Promise.all([
            $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$i, 1024),
            $0eb8af2968e12ba8$export$fbc5ef50a60ce893(512)
        ]);
        // last block is for storing the init vector
        argon2Interface.setMemorySize(memorySize * 1024 + 1024);
        const initVector = new Uint8Array(24);
        const initVectorView = new DataView(initVector.buffer);
        initVectorView.setInt32(0, parallelism, true);
        initVectorView.setInt32(4, hashLength, true);
        initVectorView.setInt32(8, memorySize, true);
        initVectorView.setInt32(12, iterations, true);
        initVectorView.setInt32(16, version, true);
        initVectorView.setInt32(20, hashType, true);
        argon2Interface.writeMemory(initVector, memorySize * 1024);
        blake512.init();
        blake512.update(initVector);
        blake512.update($0eb8af2968e12ba8$var$int32LE(password.length));
        blake512.update(password);
        blake512.update($0eb8af2968e12ba8$var$int32LE(salt.length));
        blake512.update(salt);
        blake512.update($0eb8af2968e12ba8$var$int32LE(0)); // key length + key
        blake512.update($0eb8af2968e12ba8$var$int32LE(0)); // associatedData length + associatedData
        const segments = Math.floor(memorySize / (parallelism * 4)); // length of each lane
        const lanes = segments * 4;
        const param = new Uint8Array(72);
        const H0 = blake512.digest("binary");
        param.set(H0);
        for(let lane = 0; lane < parallelism; lane++){
            param.set($0eb8af2968e12ba8$var$int32LE(0), 64);
            param.set($0eb8af2968e12ba8$var$int32LE(lane), 68);
            let position = lane * lanes;
            let chunk = yield $0eb8af2968e12ba8$var$hashFunc(blake512, param, 1024);
            argon2Interface.writeMemory(chunk, position * 1024);
            position += 1;
            param.set($0eb8af2968e12ba8$var$int32LE(1), 64);
            chunk = yield $0eb8af2968e12ba8$var$hashFunc(blake512, param, 1024);
            argon2Interface.writeMemory(chunk, position * 1024);
        }
        const C = new Uint8Array(1024);
        $0eb8af2968e12ba8$var$writeHexToUInt8(C, argon2Interface.calculate(new Uint8Array([]), memorySize));
        const res = yield $0eb8af2968e12ba8$var$hashFunc(blake512, C, hashLength);
        if (options.outputType === "hex") {
            const digestChars = new Uint8Array(hashLength * 2);
            return $0eb8af2968e12ba8$var$getDigestHex(digestChars, res, hashLength);
        }
        if (options.outputType === "encoded") return $0eb8af2968e12ba8$var$encodeResult(salt, options, res);
        // return binary format
        return res;
    });
}
const $0eb8af2968e12ba8$var$validateOptions$3 = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (!options.password) throw new Error("Password must be specified");
    options.password = $0eb8af2968e12ba8$var$getUInt8Buffer(options.password);
    if (options.password.length < 1) throw new Error("Password must be specified");
    if (!options.salt) throw new Error("Salt must be specified");
    options.salt = $0eb8af2968e12ba8$var$getUInt8Buffer(options.salt);
    if (options.salt.length < 8) throw new Error("Salt should be at least 8 bytes long");
    if (!Number.isInteger(options.iterations) || options.iterations < 1) throw new Error("Iterations should be a positive number");
    if (!Number.isInteger(options.parallelism) || options.parallelism < 1) throw new Error("Parallelism should be a positive number");
    if (!Number.isInteger(options.hashLength) || options.hashLength < 4) throw new Error("Hash length should be at least 4 bytes.");
    if (!Number.isInteger(options.memorySize)) throw new Error("Memory size should be specified.");
    if (options.memorySize < 8 * options.parallelism) throw new Error("Memory size should be at least 8 * parallelism.");
    if (options.outputType === undefined) options.outputType = "hex";
    if (![
        "hex",
        "binary",
        "encoded"
    ].includes(options.outputType)) throw new Error(`Insupported output type ${options.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
/**
 * Calculates hash using the argon2i password-hashing function
 * @returns Computed hash
 */ function $0eb8af2968e12ba8$export$b6ab5145aebd023d(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions$3(options);
        return $0eb8af2968e12ba8$var$argon2Internal(Object.assign(Object.assign({}, options), {
            hashType: "i"
        }));
    });
}
/**
 * Calculates hash using the argon2id password-hashing function
 * @returns Computed hash
 */ function $0eb8af2968e12ba8$export$8c335ebd3ce6f4(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions$3(options);
        return $0eb8af2968e12ba8$var$argon2Internal(Object.assign(Object.assign({}, options), {
            hashType: "id"
        }));
    });
}
/**
 * Calculates hash using the argon2d password-hashing function
 * @returns Computed hash
 */ function $0eb8af2968e12ba8$export$2ae0bd5069c34699(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions$3(options);
        return $0eb8af2968e12ba8$var$argon2Internal(Object.assign(Object.assign({}, options), {
            hashType: "d"
        }));
    });
}
const $0eb8af2968e12ba8$var$getHashParameters = (password, encoded)=>{
    const regex = /^\$argon2(id|i|d)\$v=([0-9]+)\$((?:[mtp]=[0-9]+,){2}[mtp]=[0-9]+)\$([A-Za-z0-9+/]+)\$([A-Za-z0-9+/]+)$/;
    const match = encoded.match(regex);
    if (!match) throw new Error("Invalid hash");
    const [, hashType, version, parameters, salt, hash] = match;
    if (version !== "19") throw new Error(`Unsupported version: ${version}`);
    const parsedParameters = {};
    const paramMap = {
        m: "memorySize",
        p: "parallelism",
        t: "iterations"
    };
    parameters.split(",").forEach((x)=>{
        const [n, v] = x.split("=");
        parsedParameters[paramMap[n]] = parseInt(v, 10);
    });
    return Object.assign(Object.assign({}, parsedParameters), {
        password: password,
        hashType: hashType,
        salt: $0eb8af2968e12ba8$var$decodeBase64(salt),
        hashLength: $0eb8af2968e12ba8$var$getDecodeBase64Length(hash),
        outputType: "encoded"
    });
};
const $0eb8af2968e12ba8$var$validateVerifyOptions$1 = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (options.hash === undefined || typeof options.hash !== "string") throw new Error("Hash should be specified");
};
/**
 * Verifies password using the argon2 password-hashing function
 * @returns True if the encoded hash matches the password
 */ function $0eb8af2968e12ba8$export$d7991f27c94917a4(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateVerifyOptions$1(options);
        const params = $0eb8af2968e12ba8$var$getHashParameters(options.password, options.hash);
        $0eb8af2968e12ba8$var$validateOptions$3(params);
        const hashStart = options.hash.lastIndexOf("$") + 1;
        const result = yield $0eb8af2968e12ba8$var$argon2Internal(params);
        return result.substring(hashStart) === options.hash.substring(hashStart);
    });
}
var $0eb8af2968e12ba8$var$name$h = "blake2s";
var $0eb8af2968e12ba8$var$data$h = "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";
var $0eb8af2968e12ba8$var$hash$h = "0f570f49";
var $0eb8af2968e12ba8$var$wasmJson$h = {
    name: $0eb8af2968e12ba8$var$name$h,
    data: $0eb8af2968e12ba8$var$data$h,
    hash: $0eb8af2968e12ba8$var$hash$h
};
const $0eb8af2968e12ba8$var$mutex$j = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$j = null;
function $0eb8af2968e12ba8$var$validateBits$3(bits) {
    if (!Number.isInteger(bits) || bits < 8 || bits > 256 || bits % 8 !== 0) return new Error("Invalid variant! Valid values: 8, 16, ..., 256");
    return null;
}
function $0eb8af2968e12ba8$var$getInitParam(outputBits, keyBits) {
    // eslint-disable-next-line no-bitwise
    return outputBits | keyBits << 16;
}
/**
 * Calculates BLAKE2s hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8, between 8 and 256. Defaults to 256.
 * @param key Optional key (string, Buffer or TypedArray). Maximum length is 32 bytes.
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$a1a84715903b3950(data, bits = 256, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$3(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$3(bits));
    let keyBuffer = null;
    let initParam = bits;
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length > 32) return Promise.reject(new Error("Max key length is 32 bytes"));
        initParam = $0eb8af2968e12ba8$var$getInitParam(bits, keyBuffer.length);
    }
    const hashLength = bits / 8;
    if ($0eb8af2968e12ba8$var$wasmCache$j === null || $0eb8af2968e12ba8$var$wasmCache$j.hashLength !== hashLength) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$j, $0eb8af2968e12ba8$var$wasmJson$h, hashLength).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$j = wasm;
        if (initParam > 512) $0eb8af2968e12ba8$var$wasmCache$j.writeMemory(keyBuffer);
        return $0eb8af2968e12ba8$var$wasmCache$j.calculate(data, initParam);
    });
    try {
        if (initParam > 512) $0eb8af2968e12ba8$var$wasmCache$j.writeMemory(keyBuffer);
        const hash = $0eb8af2968e12ba8$var$wasmCache$j.calculate(data, initParam);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new BLAKE2s hash instance
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8, between 8 and 256. Defaults to 256.
 * @param key Optional key (string, Buffer or TypedArray). Maximum length is 32 bytes.
 */ function $0eb8af2968e12ba8$export$19a79100d402dd1e(bits = 256, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$3(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$3(bits));
    let keyBuffer = null;
    let initParam = bits;
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length > 32) return Promise.reject(new Error("Max key length is 32 bytes"));
        initParam = $0eb8af2968e12ba8$var$getInitParam(bits, keyBuffer.length);
    }
    const outputSize = bits / 8;
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$h, outputSize).then((wasm)=>{
        if (initParam > 512) wasm.writeMemory(keyBuffer);
        wasm.init(initParam);
        const obj = {
            init: initParam > 512 ? ()=>{
                wasm.writeMemory(keyBuffer);
                wasm.init(initParam);
                return obj;
            } : ()=>{
                wasm.init(initParam);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: outputSize
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$g = "blake3";
var $0eb8af2968e12ba8$var$data$g = "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";
var $0eb8af2968e12ba8$var$hash$g = "e8655383";
var $0eb8af2968e12ba8$var$wasmJson$g = {
    name: $0eb8af2968e12ba8$var$name$g,
    data: $0eb8af2968e12ba8$var$data$g,
    hash: $0eb8af2968e12ba8$var$hash$g
};
const $0eb8af2968e12ba8$var$mutex$i = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$i = null;
function $0eb8af2968e12ba8$var$validateBits$2(bits) {
    if (!Number.isInteger(bits) || bits < 8 || bits % 8 !== 0) return new Error("Invalid variant! Valid values: 8, 16, ...");
    return null;
}
/**
 * Calculates BLAKE3 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8. Defaults to 256.
 * @param key Optional key (string, Buffer or TypedArray). Length should be 32 bytes.
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$839975d6da5db07b(data, bits = 256, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$2(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$2(bits));
    let keyBuffer = null;
    let initParam = 0; // key is empty by default
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length !== 32) return Promise.reject(new Error("Key length must be exactly 32 bytes"));
        initParam = 32;
    }
    const hashLength = bits / 8;
    const digestParam = hashLength;
    if ($0eb8af2968e12ba8$var$wasmCache$i === null || $0eb8af2968e12ba8$var$wasmCache$i.hashLength !== hashLength) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$i, $0eb8af2968e12ba8$var$wasmJson$g, hashLength).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$i = wasm;
        if (initParam === 32) $0eb8af2968e12ba8$var$wasmCache$i.writeMemory(keyBuffer);
        return $0eb8af2968e12ba8$var$wasmCache$i.calculate(data, initParam, digestParam);
    });
    try {
        if (initParam === 32) $0eb8af2968e12ba8$var$wasmCache$i.writeMemory(keyBuffer);
        const hash = $0eb8af2968e12ba8$var$wasmCache$i.calculate(data, initParam, digestParam);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new BLAKE3 hash instance
 * @param bits Number of output bits, which has to be a number
 *             divisible by 8. Defaults to 256.
 * @param key Optional key (string, Buffer or TypedArray). Length should be 32 bytes.
 */ function $0eb8af2968e12ba8$export$4ede2c940c75bba5(bits = 256, key = null) {
    if ($0eb8af2968e12ba8$var$validateBits$2(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$2(bits));
    let keyBuffer = null;
    let initParam = 0; // key is empty by default
    if (key !== null) {
        keyBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
        if (keyBuffer.length !== 32) return Promise.reject(new Error("Key length must be exactly 32 bytes"));
        initParam = 32;
    }
    const outputSize = bits / 8;
    const digestParam = outputSize;
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$g, outputSize).then((wasm)=>{
        if (initParam === 32) wasm.writeMemory(keyBuffer);
        wasm.init(initParam);
        const obj = {
            init: initParam === 32 ? ()=>{
                wasm.writeMemory(keyBuffer);
                wasm.init(initParam);
                return obj;
            } : ()=>{
                wasm.init(initParam);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType, digestParam),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: outputSize
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$f = "crc32";
var $0eb8af2968e12ba8$var$data$f = "AGFzbQEAAAABEQRgAAF/YAF/AGAAAGACf38AAwgHAAEBAQIAAwQFAXABAQEFBAEBAgIGDgJ/AUGQyQULfwBBgAgLB3AIBm1lbW9yeQIADkhhc2hfR2V0QnVmZmVyAAAJSGFzaF9Jbml0AAILSGFzaF9VcGRhdGUAAwpIYXNoX0ZpbmFsAAQNSGFzaF9HZXRTdGF0ZQAFDkhhc2hfQ2FsY3VsYXRlAAYKU1RBVEVfU0laRQMBCq0HBwUAQYAJC8MDAQN/QYCJASEBQQAhAgNAIAFBAEEAQQBBAEEAQQBBAEEAIAJBAXFrIABxIAJBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzIgNBAXFrIABxIANBAXZzNgIAIAFBBGohASACQQFqIgJBgAJHDQALQQAhAANAIABBhJEBaiAAQYSJAWooAgAiAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhJkBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEoQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYSpAWogAkH/AXFBAnRBgIkBaigCACACQQh2cyICNgIAIABBhLEBaiACQf8BcUECdEGAiQFqKAIAIAJBCHZzIgI2AgAgAEGEuQFqIAJB/wFxQQJ0QYCJAWooAgAgAkEIdnMiAjYCACAAQYTBAWogAkH/AXFBAnRBgIkBaigCACACQQh2czYCACAAQQRqIgBB/AdHDQALCycAAkBBACgCgMkBIABGDQAgABABQQAgADYCgMkBC0EAQQA2AoTJAQuhAgEDf0EAKAKEyQFBf3MhAUGACSECAkAgAEEISQ0AQYAJIQIDQCACQQRqKAIAIgNBDnZB/AdxQYCRAWooAgAgA0EWdkH8B3FBgIkBaigCAHMgA0EGdkH8B3FBgJkBaigCAHMgA0H/AXFBAnRBgKEBaigCAHMgAigCACABcyIBQRZ2QfwHcUGAqQFqKAIAcyABQQ52QfwHcUGAsQFqKAIAcyABQQZ2QfwHcUGAuQFqKAIAcyABQf8BcUECdEGAwQFqKAIAcyEBIAJBCGohAiAAQXhqIgBBB0sNAAsLAkAgAEUNAANAIAFB/wFxIAItAABzQQJ0QYCJAWooAgAgAUEIdnMhASACQQFqIQIgAEF/aiIADQALC0EAIAFBf3M2AoTJAQszAQF/QQBBACgChMkBIgBBGHQgAEEIdEGAgPwHcXIgAEEIdkGA/gNxIABBGHZycjYCgAkLBgBBhMkBC1oAAkBBACgCgMkBIAFGDQAgARABQQAgATYCgMkBC0EAQQA2AoTJASAAEANBAEEAKAKEyQEiAUEYdCABQQh0QYCA/AdxciABQQh2QYD+A3EgAUEYdnJyNgKACQsLCwEAQYAICwQEAAAA";
var $0eb8af2968e12ba8$var$hash$f = "749723dc";
var $0eb8af2968e12ba8$var$wasmJson$f = {
    name: $0eb8af2968e12ba8$var$name$f,
    data: $0eb8af2968e12ba8$var$data$f,
    hash: $0eb8af2968e12ba8$var$hash$f
};
const $0eb8af2968e12ba8$var$mutex$h = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$h = null;
/**
 * Calculates CRC-32 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$1cd93882633e45f5(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$h === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$h, $0eb8af2968e12ba8$var$wasmJson$f, 4).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$h = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$h.calculate(data, 0xEDB88320);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$h.calculate(data, 0xEDB88320);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new CRC-32 hash instance
 */ function $0eb8af2968e12ba8$export$18533374010341d9() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$f, 4).then((wasm)=>{
        wasm.init(0xEDB88320);
        const obj = {
            init: ()=>{
                wasm.init(0xEDB88320);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 4,
            digestSize: 4
        };
        return obj;
    });
}
const $0eb8af2968e12ba8$var$mutex$g = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$g = null;
/**
 * Calculates CRC-32C hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$dd68a1888523627e(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$g === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$g, $0eb8af2968e12ba8$var$wasmJson$f, 4).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$g = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$g.calculate(data, 0x82F63B78);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$g.calculate(data, 0x82F63B78);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new CRC-32C hash instance
 */ function $0eb8af2968e12ba8$export$281fc6aed9df1fc9() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$f, 4).then((wasm)=>{
        wasm.init(0x82F63B78);
        const obj = {
            init: ()=>{
                wasm.init(0x82F63B78);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 4,
            digestSize: 4
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$e = "md4";
var $0eb8af2968e12ba8$var$data$e = "AGFzbQEAAAABEgRgAAF/YAAAYAF/AGACf38BfwMIBwABAgMBAAIEBQFwAQEBBQQBAQICBg4CfwFBoIoFC38AQYAICwdwCAZtZW1vcnkCAA5IYXNoX0dldEJ1ZmZlcgAACUhhc2hfSW5pdAABC0hhc2hfVXBkYXRlAAIKSGFzaF9GaW5hbAAEDUhhc2hfR2V0U3RhdGUABQ5IYXNoX0NhbGN1bGF0ZQAGClNUQVRFX1NJWkUDAQqXEQcFAEGACQstAEEAQv6568XpjpWZEDcCkIkBQQBCgcaUupbx6uZvNwKIiQFBAEIANwKAiQEL6AIBA39BAEEAKAKAiQEiASAAakH/////AXEiAjYCgIkBQQAoAoSJASEDAkAgAiABTw0AQQAgA0EBaiIDNgKEiQELQQAgAyAAQR12ajYChIkBAkACQAJAAkACQAJAIAFBP3EiAw0AQYAJIQIMAQtBwAAgA2siAiAASw0BIANBGGohA0EAIQEDQCADIAFqQYCJAWogAUGACWotAAA6AAAgAyABQQFqIgFqQdgARw0AC0GYiQFBwAAQAxogACACayEAIAJBgAlqIQILIABBwABPDQEgACEDDAILIABFDQJBACEBIANBmIkBakEALQCACToAACAAQQFGDQIgA0GZiQFqIQMgAEF/aiECA0AgAyABaiABQYEJai0AADoAACACIAFBAWoiAUcNAAwDCwsgAEE/cSEDIAIgAEFAcRADIQILIANFDQBBACEBA0AgAUGYiQFqIAIgAWotAAA6AAAgAyABQQFqIgFHDQALCwuYCwEXf0EAKAKUiQEhAkEAKAKQiQEhA0EAKAKMiQEhBEEAKAKIiQEhBQNAIABBHGooAgAiBiAAQRRqKAIAIgcgAEEYaigCACIIIABBEGooAgAiCSAAQSxqKAIAIgogAEEoaigCACILIABBJGooAgAiDCAAQSBqKAIAIg0gCyAIIABBCGooAgAiDiADaiAAQQRqKAIAIg8gAmogBCADIAJzcSACcyAFaiAAKAIAIhBqQQN3IhEgBCADc3EgA3NqQQd3IhIgESAEc3EgBHNqQQt3IhNqIBIgB2ogESAJaiAAQQxqKAIAIhQgBGogEyASIBFzcSARc2pBE3ciESATIBJzcSASc2pBA3ciEiARIBNzcSATc2pBB3ciEyASIBFzcSARc2pBC3ciFWogEyAMaiASIA1qIBEgBmogFSATIBJzcSASc2pBE3ciESAVIBNzcSATc2pBA3ciEiARIBVzcSAVc2pBB3ciEyASIBFzcSARc2pBC3ciFSAAQThqKAIAIhZqIBMgAEE0aigCACIXaiASIABBMGooAgAiGGogESAKaiAVIBMgEnNxIBJzakETdyISIBUgE3NxIBNzakEDdyITIBIgFXNxIBVzakEHdyIVIBMgEnNxIBJzakELdyIRaiAJIBVqIBAgE2ogEiAAQTxqKAIAIglqIBEgFSATc3EgE3NqQRN3IhIgESAVcnEgESAVcXJqQZnzidQFakEDdyITIBIgEXJxIBIgEXFyakGZ84nUBWpBBXciESATIBJycSATIBJxcmpBmfOJ1AVqQQl3IhVqIAcgEWogDyATaiAYIBJqIBUgESATcnEgESATcXJqQZnzidQFakENdyISIBUgEXJxIBUgEXFyakGZ84nUBWpBA3ciESASIBVycSASIBVxcmpBmfOJ1AVqQQV3IhMgESAScnEgESAScXJqQZnzidQFakEJdyIVaiAIIBNqIA4gEWogFyASaiAVIBMgEXJxIBMgEXFyakGZ84nUBWpBDXciESAVIBNycSAVIBNxcmpBmfOJ1AVqQQN3IhIgESAVcnEgESAVcXJqQZnzidQFakEFdyITIBIgEXJxIBIgEXFyakGZ84nUBWpBCXciFWogBiATaiAUIBJqIBYgEWogFSATIBJycSATIBJxcmpBmfOJ1AVqQQ13IhEgFSATcnEgFSATcXJqQZnzidQFakEDdyISIBEgFXJxIBEgFXFyakGZ84nUBWpBBXciEyASIBFycSASIBFxcmpBmfOJ1AVqQQl3IhVqIBAgEmogCSARaiAVIBMgEnJxIBMgEnFyakGZ84nUBWpBDXciBiAVcyISIBNzakGh1+f2BmpBA3ciESAGcyANIBNqIBIgEXNqQaHX5/YGakEJdyISc2pBodfn9gZqQQt3IhNqIA4gEWogEyAScyAYIAZqIBIgEXMgE3NqQaHX5/YGakEPdyIRc2pBodfn9gZqQQN3IhUgEXMgCyASaiARIBNzIBVzakGh1+f2BmpBCXciEnNqQaHX5/YGakELdyITaiAPIBVqIBMgEnMgFiARaiASIBVzIBNzakGh1+f2BmpBD3ciEXNqQaHX5/YGakEDdyIVIBFzIAwgEmogESATcyAVc2pBodfn9gZqQQl3IhJzakGh1+f2BmpBC3ciE2ogFCAVaiATIBJzIBcgEWogEiAVcyATc2pBodfn9gZqQQ93IhFzakGh1+f2BmpBA3ciFSARcyAKIBJqIBEgE3MgFXNqQaHX5/YGakEJdyISc2pBodfn9gZqQQt3IhMgA2ohAyAJIBFqIBIgFXMgE3NqQaHX5/YGakEPdyAEaiEEIBIgAmohAiAVIAVqIQUgAEHAAGohACABQUBqIgENAAtBACACNgKUiQFBACADNgKQiQFBACAENgKMiQFBACAFNgKIiQEgAAuhAgEDf0EAKAKAiQEiAEE/cSIBQZiJAWpBgAE6AAACQAJAAkAgAUE/cyICQQdLDQACQCACRQ0AIAFBmYkBaiEAA0AgAEEAOgAAIABBAWohACACQX9qIgINAAsLQcAAIQJBmIkBQcAAEAMaQQAhAAwBCyACQQhGDQEgAUEBaiEACyAAQY+JAWohAQNAIAEgAmpBADoAACACQXdqIQAgAkF/aiECIABBAEoNAAtBACgCgIkBIQALQQAgAEEVdjoA04kBQQAgAEENdjoA0okBQQAgAEEFdjoA0YkBQQAgAEEDdCICOgDQiQFBACACNgKAiQFBAEEAKAKEiQE2AtSJAUGYiQFBwAAQAxpBAEEAKQKIiQE3A4AJQQBBACkCkIkBNwOICQsGAEGAiQELMwBBAEL+uevF6Y6VmRA3ApCJAUEAQoHGlLqW8ermbzcCiIkBQQBCADcCgIkBIAAQAhAECwsLAQBBgAgLBJgAAAA=";
var $0eb8af2968e12ba8$var$hash$e = "1bf01052";
var $0eb8af2968e12ba8$var$wasmJson$e = {
    name: $0eb8af2968e12ba8$var$name$e,
    data: $0eb8af2968e12ba8$var$data$e,
    hash: $0eb8af2968e12ba8$var$hash$e
};
const $0eb8af2968e12ba8$var$mutex$f = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$f = null;
/**
 * Calculates MD4 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$aa576d0d2ca814fe(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$f === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$f, $0eb8af2968e12ba8$var$wasmJson$e, 16).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$f = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$f.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$f.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new MD4 hash instance
 */ function $0eb8af2968e12ba8$export$3600daed48d86634() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$e, 16).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 16
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$d = "md5";
var $0eb8af2968e12ba8$var$data$d = "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";
var $0eb8af2968e12ba8$var$hash$d = "9b0fac7d";
var $0eb8af2968e12ba8$var$wasmJson$d = {
    name: $0eb8af2968e12ba8$var$name$d,
    data: $0eb8af2968e12ba8$var$data$d,
    hash: $0eb8af2968e12ba8$var$hash$d
};
const $0eb8af2968e12ba8$var$mutex$e = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$e = null;
/**
 * Calculates MD5 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$a58ec6a60c09ca72(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$e === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$e, $0eb8af2968e12ba8$var$wasmJson$d, 16).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$e = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$e.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$e.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new MD5 hash instance
 */ function $0eb8af2968e12ba8$export$5f3e73607340e598() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$d, 16).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 16
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$c = "sha1";
var $0eb8af2968e12ba8$var$data$c = "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";
var $0eb8af2968e12ba8$var$hash$c = "40d92e5d";
var $0eb8af2968e12ba8$var$wasmJson$c = {
    name: $0eb8af2968e12ba8$var$name$c,
    data: $0eb8af2968e12ba8$var$data$c,
    hash: $0eb8af2968e12ba8$var$hash$c
};
const $0eb8af2968e12ba8$var$mutex$d = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$d = null;
/**
 * Calculates SHA-1 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$5091bdda49ba90f5(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$d === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$d, $0eb8af2968e12ba8$var$wasmJson$c, 20).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$d = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$d.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$d.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-1 hash instance
 */ function $0eb8af2968e12ba8$export$3f6d23435a00ea8c() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$c, 20).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 20
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$b = "sha3";
var $0eb8af2968e12ba8$var$data$b = "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";
var $0eb8af2968e12ba8$var$hash$b = "ec266d91";
var $0eb8af2968e12ba8$var$wasmJson$b = {
    name: $0eb8af2968e12ba8$var$name$b,
    data: $0eb8af2968e12ba8$var$data$b,
    hash: $0eb8af2968e12ba8$var$hash$b
};
const $0eb8af2968e12ba8$var$mutex$c = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$c = null;
function $0eb8af2968e12ba8$var$validateBits$1(bits) {
    if (![
        224,
        256,
        384,
        512
    ].includes(bits)) return new Error("Invalid variant! Valid values: 224, 256, 384, 512");
    return null;
}
/**
 * Calculates SHA-3 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param bits Number of output bits. Valid values: 224, 256, 384, 512
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$b271ea59225a06a5(data, bits = 512) {
    if ($0eb8af2968e12ba8$var$validateBits$1(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$1(bits));
    const hashLength = bits / 8;
    if ($0eb8af2968e12ba8$var$wasmCache$c === null || $0eb8af2968e12ba8$var$wasmCache$c.hashLength !== hashLength) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$c, $0eb8af2968e12ba8$var$wasmJson$b, hashLength).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$c = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$c.calculate(data, bits, 0x06);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$c.calculate(data, bits, 0x06);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-3 hash instance
 * @param bits Number of output bits. Valid values: 224, 256, 384, 512
 */ function $0eb8af2968e12ba8$export$d822ac3c2557e231(bits = 512) {
    if ($0eb8af2968e12ba8$var$validateBits$1(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits$1(bits));
    const outputSize = bits / 8;
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$b, outputSize).then((wasm)=>{
        wasm.init(bits);
        const obj = {
            init: ()=>{
                wasm.init(bits);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType, 0x06),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 200 - 2 * outputSize,
            digestSize: outputSize
        };
        return obj;
    });
}
const $0eb8af2968e12ba8$var$mutex$b = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$b = null;
function $0eb8af2968e12ba8$var$validateBits(bits) {
    if (![
        224,
        256,
        384,
        512
    ].includes(bits)) return new Error("Invalid variant! Valid values: 224, 256, 384, 512");
    return null;
}
/**
 * Calculates Keccak hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param bits Number of output bits. Valid values: 224, 256, 384, 512
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$5c976938b424edc7(data, bits = 512) {
    if ($0eb8af2968e12ba8$var$validateBits(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits(bits));
    const hashLength = bits / 8;
    if ($0eb8af2968e12ba8$var$wasmCache$b === null || $0eb8af2968e12ba8$var$wasmCache$b.hashLength !== hashLength) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$b, $0eb8af2968e12ba8$var$wasmJson$b, hashLength).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$b = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$b.calculate(data, bits, 0x01);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$b.calculate(data, bits, 0x01);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new Keccak hash instance
 * @param bits Number of output bits. Valid values: 224, 256, 384, 512
 */ function $0eb8af2968e12ba8$export$d55c10d19c4de237(bits = 512) {
    if ($0eb8af2968e12ba8$var$validateBits(bits)) return Promise.reject($0eb8af2968e12ba8$var$validateBits(bits));
    const outputSize = bits / 8;
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$b, outputSize).then((wasm)=>{
        wasm.init(bits);
        const obj = {
            init: ()=>{
                wasm.init(bits);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType, 0x01),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 200 - 2 * outputSize,
            digestSize: outputSize
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$a = "sha256";
var $0eb8af2968e12ba8$var$data$a = "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";
var $0eb8af2968e12ba8$var$hash$a = "817d957e";
var $0eb8af2968e12ba8$var$wasmJson$a = {
    name: $0eb8af2968e12ba8$var$name$a,
    data: $0eb8af2968e12ba8$var$data$a,
    hash: $0eb8af2968e12ba8$var$hash$a
};
const $0eb8af2968e12ba8$var$mutex$a = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$a = null;
/**
 * Calculates SHA-2 (SHA-224) hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$97b70509d4e397ea(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$a === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$a, $0eb8af2968e12ba8$var$wasmJson$a, 28).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$a = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$a.calculate(data, 224);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$a.calculate(data, 224);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-2 (SHA-224) hash instance
 */ function $0eb8af2968e12ba8$export$dc007304aa70bdf5() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$a, 28).then((wasm)=>{
        wasm.init(224);
        const obj = {
            init: ()=>{
                wasm.init(224);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 28
        };
        return obj;
    });
}
const $0eb8af2968e12ba8$var$mutex$9 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$9 = null;
/**
 * Calculates SHA-2 (SHA-256) hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$bced8d2aada2d1c9(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$9 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$9, $0eb8af2968e12ba8$var$wasmJson$a, 32).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$9 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$9.calculate(data, 256);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$9.calculate(data, 256);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-2 (SHA-256) hash instance
 */ function $0eb8af2968e12ba8$export$21f470e5f937cac3() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$a, 32).then((wasm)=>{
        wasm.init(256);
        const obj = {
            init: ()=>{
                wasm.init(256);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 32
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$9 = "sha512";
var $0eb8af2968e12ba8$var$data$9 = "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";
var $0eb8af2968e12ba8$var$hash$9 = "a5d1ca7c";
var $0eb8af2968e12ba8$var$wasmJson$9 = {
    name: $0eb8af2968e12ba8$var$name$9,
    data: $0eb8af2968e12ba8$var$data$9,
    hash: $0eb8af2968e12ba8$var$hash$9
};
const $0eb8af2968e12ba8$var$mutex$8 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$8 = null;
/**
 * Calculates SHA-2 (SHA-384) hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$612d47d55dedde45(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$8 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$8, $0eb8af2968e12ba8$var$wasmJson$9, 48).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$8 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$8.calculate(data, 384);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$8.calculate(data, 384);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-2 (SHA-384) hash instance
 */ function $0eb8af2968e12ba8$export$1bc389470e6c803b() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$9, 48).then((wasm)=>{
        wasm.init(384);
        const obj = {
            init: ()=>{
                wasm.init(384);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 128,
            digestSize: 48
        };
        return obj;
    });
}
const $0eb8af2968e12ba8$var$mutex$7 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$7 = null;
/**
 * Calculates SHA-2 (SHA-512) hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$a888d2532e6dc7bb(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$7 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$7, $0eb8af2968e12ba8$var$wasmJson$9, 64).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$7 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$7.calculate(data, 512);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$7.calculate(data, 512);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SHA-2 (SHA-512) hash instance
 */ function $0eb8af2968e12ba8$export$539d5a676a732b9() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$9, 64).then((wasm)=>{
        wasm.init(512);
        const obj = {
            init: ()=>{
                wasm.init(512);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 128,
            digestSize: 64
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$8 = "xxhash32";
var $0eb8af2968e12ba8$var$data$8 = "AGFzbQEAAAABEQRgAAF/YAF/AGAAAGACf38AAwcGAAEBAgADBAUBcAEBAQUEAQECAgYOAn8BQbCJBQt/AEGACAsHcAgGbWVtb3J5AgAOSGFzaF9HZXRCdWZmZXIAAAlIYXNoX0luaXQAAQtIYXNoX1VwZGF0ZQACCkhhc2hfRmluYWwAAw1IYXNoX0dldFN0YXRlAAQOSGFzaF9DYWxjdWxhdGUABQpTVEFURV9TSVpFAwEKswkGBQBBgAkLTQBBAEIANwOoiQFBACAANgKIiQFBACAAQc+Moo4GajYCjIkBQQAgAEH3lK+veGo2AoSJAUEAIABBqIiNoQJqNgKAiQFBAEEANgKgiQELswUBBn8CQCAARQ0AQQBBACkDqIkBIACtfDcDqIkBAkBBACgCoIkBIgEgAGpBD0sNAEEAIAFBAWo2AqCJASABQZCJAWpBAC0AgAk6AAAgAEEBRg0BQQEhAgNAQQBBACgCoIkBIgFBAWo2AqCJASABQZCJAWogAkGACWotAAA6AAAgACACQQFqIgJHDQAMAgsLIABB8AhqIQMCQAJAIAENAEEAKAKMiQEhAUEAKAKIiQEhBEEAKAKEiQEhBUEAKAKAiQEhBkGACSECDAELQYAJIQICQCABQQ9LDQBBgAkhAgNAIAItAAAhBEEAIAFBAWo2AqCJASABQZCJAWogBDoAACACQQFqIQJBACgCoIkBIgFBEEkNAAsLQQBBACgCkIkBQfeUr694bEEAKAKAiQFqQQ13QbHz3fF5bCIGNgKAiQFBAEEAKAKUiQFB95Svr3hsQQAoAoSJAWpBDXdBsfPd8XlsIgU2AoSJAUEAQQAoApiJAUH3lK+veGxBACgCiIkBakENd0Gx893xeWwiBDYCiIkBQQBBACgCnIkBQfeUr694bEEAKAKMiQFqQQ13QbHz3fF5bCIBNgKMiQELIABBgAlqIQACQCACIANLDQADQCACKAIAQfeUr694bCAGakENd0Gx893xeWwhBiACQQxqKAIAQfeUr694bCABakENd0Gx893xeWwhASACQQhqKAIAQfeUr694bCAEakENd0Gx893xeWwhBCACQQRqKAIAQfeUr694bCAFakENd0Gx893xeWwhBSACQRBqIgIgA00NAAsLQQAgATYCjIkBQQAgBDYCiIkBQQAgBTYChIkBQQAgBjYCgIkBQQAgACACayIBNgKgiQEgAUUNAEEAIQEDQCABQZCJAWogAiABai0AADoAACABQQFqIgFBACgCoIkBSQ0ACwsLzAICAX4Gf0EAKQOoiQEiAKchAQJAAkAgAEIQVA0AQQAoAoSJAUEHd0EAKAKAiQFBAXdqQQAoAoiJAUEMd2pBACgCjIkBQRJ3aiECDAELQQAoAoiJAUGxz9myAWohAgsgAiABaiECQZCJASEBQQAoAqCJASIDQZCJAWohBAJAIANBBEgNAEGQiQEhBQNAIAUoAgBBvdzKlXxsIAJqQRF3Qa/W074CbCECIAVBCGohBiAFQQRqIgEhBSAGIARNDQALCwJAIAEgBEYNACADQZCJAWohBQNAIAEtAABBsc/ZsgFsIAJqQQt3QbHz3fF5bCECIAUgAUEBaiIBRw0ACwtBACACQQ92IAJzQfeUr694bCIBQQ12IAFzQb3cypV8bCIBQRB2IAFzIgFBGHQgAUEIdEGAgPwHcXIgAUEIdkGA/gNxIAFBGHZycq03A4AJCwYAQYCJAQtTAEEAQgA3A6iJAUEAIAE2AoiJAUEAIAFBz4yijgZqNgKMiQFBACABQfeUr694ajYChIkBQQAgAUGoiI2hAmo2AoCJAUEAQQA2AqCJASAAEAIQAwsLCwEAQYAICwQwAAAA";
var $0eb8af2968e12ba8$var$hash$8 = "5b6a5062";
var $0eb8af2968e12ba8$var$wasmJson$8 = {
    name: $0eb8af2968e12ba8$var$name$8,
    data: $0eb8af2968e12ba8$var$data$8,
    hash: $0eb8af2968e12ba8$var$hash$8
};
const $0eb8af2968e12ba8$var$mutex$6 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$6 = null;
function $0eb8af2968e12ba8$var$validateSeed$3(seed) {
    if (!Number.isInteger(seed) || seed < 0 || seed > 0xFFFFFFFF) return new Error("Seed must be a valid 32-bit long unsigned integer.");
    return null;
}
/**
 * Calculates xxHash32 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param seed Number used to initialize the internal state of the algorithm (defaults to 0)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$382456ef6f7ee6bc(data, seed = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$3(seed)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$3(seed));
    if ($0eb8af2968e12ba8$var$wasmCache$6 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$6, $0eb8af2968e12ba8$var$wasmJson$8, 4).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$6 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$6.calculate(data, seed);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$6.calculate(data, seed);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new xxHash32 hash instance
 * @param data Input data (string, Buffer or TypedArray)
 * @param seed Number used to initialize the internal state of the algorithm (defaults to 0)
 */ function $0eb8af2968e12ba8$export$f23852e6059e6f76(seed = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$3(seed)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$3(seed));
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$8, 4).then((wasm)=>{
        wasm.init(seed);
        const obj = {
            init: ()=>{
                wasm.init(seed);
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 16,
            digestSize: 4
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$7 = "xxhash64";
var $0eb8af2968e12ba8$var$data$7 = "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";
var $0eb8af2968e12ba8$var$hash$7 = "bc315b2a";
var $0eb8af2968e12ba8$var$wasmJson$7 = {
    name: $0eb8af2968e12ba8$var$name$7,
    data: $0eb8af2968e12ba8$var$data$7,
    hash: $0eb8af2968e12ba8$var$hash$7
};
const $0eb8af2968e12ba8$var$mutex$5 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$5 = null;
const $0eb8af2968e12ba8$var$seedBuffer$2 = new ArrayBuffer(8);
function $0eb8af2968e12ba8$var$validateSeed$2(seed) {
    if (!Number.isInteger(seed) || seed < 0 || seed > 0xFFFFFFFF) return new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).");
    return null;
}
function $0eb8af2968e12ba8$var$writeSeed$2(arr, low, high) {
    // write in little-endian format
    const buffer = new DataView(arr);
    buffer.setUint32(0, low, true);
    buffer.setUint32(4, high, true);
}
/**
 * Calculates xxHash64 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$6f9f586567871a11(data, seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$2(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$2(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed$2(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$2(seedHigh));
    if ($0eb8af2968e12ba8$var$wasmCache$5 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$5, $0eb8af2968e12ba8$var$wasmJson$7, 8).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$5 = wasm;
        $0eb8af2968e12ba8$var$writeSeed$2($0eb8af2968e12ba8$var$seedBuffer$2, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$5.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer$2));
        return $0eb8af2968e12ba8$var$wasmCache$5.calculate(data);
    });
    try {
        $0eb8af2968e12ba8$var$writeSeed$2($0eb8af2968e12ba8$var$seedBuffer$2, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$5.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer$2));
        const hash = $0eb8af2968e12ba8$var$wasmCache$5.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new xxHash64 hash instance
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 */ function $0eb8af2968e12ba8$export$67b2a024ea9eb975(seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$2(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$2(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed$2(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$2(seedHigh));
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$7, 8).then((wasm)=>{
        const instanceBuffer = new ArrayBuffer(8);
        $0eb8af2968e12ba8$var$writeSeed$2(instanceBuffer, seedLow, seedHigh);
        wasm.writeMemory(new Uint8Array(instanceBuffer));
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.writeMemory(new Uint8Array(instanceBuffer));
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 32,
            digestSize: 8
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$6 = "xxhash3";
var $0eb8af2968e12ba8$var$data$6 = "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";
var $0eb8af2968e12ba8$var$hash$6 = "187bc2c6";
var $0eb8af2968e12ba8$var$wasmJson$6 = {
    name: $0eb8af2968e12ba8$var$name$6,
    data: $0eb8af2968e12ba8$var$data$6,
    hash: $0eb8af2968e12ba8$var$hash$6
};
const $0eb8af2968e12ba8$var$mutex$4 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$4 = null;
const $0eb8af2968e12ba8$var$seedBuffer$1 = new ArrayBuffer(8);
function $0eb8af2968e12ba8$var$validateSeed$1(seed) {
    if (!Number.isInteger(seed) || seed < 0 || seed > 0xFFFFFFFF) return new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).");
    return null;
}
function $0eb8af2968e12ba8$var$writeSeed$1(arr, low, high) {
    // write in little-endian format
    const buffer = new DataView(arr);
    buffer.setUint32(0, low, true);
    buffer.setUint32(4, high, true);
}
/**
 * Calculates xxHash3 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$cc089fc0fad6a358(data, seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$1(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$1(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed$1(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$1(seedHigh));
    if ($0eb8af2968e12ba8$var$wasmCache$4 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$4, $0eb8af2968e12ba8$var$wasmJson$6, 8).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$4 = wasm;
        $0eb8af2968e12ba8$var$writeSeed$1($0eb8af2968e12ba8$var$seedBuffer$1, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$4.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer$1));
        return $0eb8af2968e12ba8$var$wasmCache$4.calculate(data);
    });
    try {
        $0eb8af2968e12ba8$var$writeSeed$1($0eb8af2968e12ba8$var$seedBuffer$1, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$4.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer$1));
        const hash = $0eb8af2968e12ba8$var$wasmCache$4.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new xxHash3 hash instance
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 */ function $0eb8af2968e12ba8$export$ea8f19dacd097f52(seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed$1(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$1(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed$1(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed$1(seedHigh));
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$6, 8).then((wasm)=>{
        const instanceBuffer = new ArrayBuffer(8);
        $0eb8af2968e12ba8$var$writeSeed$1(instanceBuffer, seedLow, seedHigh);
        wasm.writeMemory(new Uint8Array(instanceBuffer));
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.writeMemory(new Uint8Array(instanceBuffer));
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 512,
            digestSize: 8
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$5 = "xxhash128";
var $0eb8af2968e12ba8$var$data$5 = "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";
var $0eb8af2968e12ba8$var$hash$5 = "e8e3fcf8";
var $0eb8af2968e12ba8$var$wasmJson$5 = {
    name: $0eb8af2968e12ba8$var$name$5,
    data: $0eb8af2968e12ba8$var$data$5,
    hash: $0eb8af2968e12ba8$var$hash$5
};
const $0eb8af2968e12ba8$var$mutex$3 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$3 = null;
const $0eb8af2968e12ba8$var$seedBuffer = new ArrayBuffer(8);
function $0eb8af2968e12ba8$var$validateSeed(seed) {
    if (!Number.isInteger(seed) || seed < 0 || seed > 0xFFFFFFFF) return new Error("Seed must be given as two valid 32-bit long unsigned integers (lo + high).");
    return null;
}
function $0eb8af2968e12ba8$var$writeSeed(arr, low, high) {
    // write in little-endian format
    const buffer = new DataView(arr);
    buffer.setUint32(0, low, true);
    buffer.setUint32(4, high, true);
}
/**
 * Calculates xxHash128 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$744487e4502bfb17(data, seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed(seedHigh));
    if ($0eb8af2968e12ba8$var$wasmCache$3 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$3, $0eb8af2968e12ba8$var$wasmJson$5, 16).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$3 = wasm;
        $0eb8af2968e12ba8$var$writeSeed($0eb8af2968e12ba8$var$seedBuffer, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$3.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer));
        return $0eb8af2968e12ba8$var$wasmCache$3.calculate(data);
    });
    try {
        $0eb8af2968e12ba8$var$writeSeed($0eb8af2968e12ba8$var$seedBuffer, seedLow, seedHigh);
        $0eb8af2968e12ba8$var$wasmCache$3.writeMemory(new Uint8Array($0eb8af2968e12ba8$var$seedBuffer));
        const hash = $0eb8af2968e12ba8$var$wasmCache$3.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new xxHash128 hash instance
 * @param seedLow Lower 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 * @param seedHigh Higher 32 bits of the number used to
 *  initialize the internal state of the algorithm (defaults to 0)
 */ function $0eb8af2968e12ba8$export$9995a0710efe6210(seedLow = 0, seedHigh = 0) {
    if ($0eb8af2968e12ba8$var$validateSeed(seedLow)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed(seedLow));
    if ($0eb8af2968e12ba8$var$validateSeed(seedHigh)) return Promise.reject($0eb8af2968e12ba8$var$validateSeed(seedHigh));
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$5, 16).then((wasm)=>{
        const instanceBuffer = new ArrayBuffer(8);
        $0eb8af2968e12ba8$var$writeSeed(instanceBuffer, seedLow, seedHigh);
        wasm.writeMemory(new Uint8Array(instanceBuffer));
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.writeMemory(new Uint8Array(instanceBuffer));
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 512,
            digestSize: 16
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name$4 = "ripemd160";
var $0eb8af2968e12ba8$var$data$4 = "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";
var $0eb8af2968e12ba8$var$hash$4 = "42f1de39";
var $0eb8af2968e12ba8$var$wasmJson$4 = {
    name: $0eb8af2968e12ba8$var$name$4,
    data: $0eb8af2968e12ba8$var$data$4,
    hash: $0eb8af2968e12ba8$var$hash$4
};
const $0eb8af2968e12ba8$var$mutex$2 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$2 = null;
/**
 * Calculates RIPEMD-160 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$d1cea0ee4e3f0d3e(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$2 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$2, $0eb8af2968e12ba8$var$wasmJson$4, 20).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$2 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$2.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$2.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new RIPEMD-160 hash instance
 */ function $0eb8af2968e12ba8$export$a76d842b1183a3f3() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$4, 20).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 20
        };
        return obj;
    });
}
function $0eb8af2968e12ba8$var$calculateKeyBuffer(hasher, key) {
    const { blockSize: blockSize } = hasher;
    const buf = $0eb8af2968e12ba8$var$getUInt8Buffer(key);
    if (buf.length > blockSize) {
        hasher.update(buf);
        const uintArr = hasher.digest("binary");
        hasher.init();
        return uintArr;
    }
    return new Uint8Array(buf.buffer, buf.byteOffset, buf.length);
}
function $0eb8af2968e12ba8$var$calculateHmac(hasher, key) {
    hasher.init();
    const { blockSize: blockSize } = hasher;
    const keyBuf = $0eb8af2968e12ba8$var$calculateKeyBuffer(hasher, key);
    const keyBuffer = new Uint8Array(blockSize);
    keyBuffer.set(keyBuf);
    const opad = new Uint8Array(blockSize);
    for(let i = 0; i < blockSize; i++){
        const v = keyBuffer[i];
        opad[i] = v ^ 0x5C;
        keyBuffer[i] = v ^ 0x36;
    }
    hasher.update(keyBuffer);
    const obj = {
        init: ()=>{
            hasher.init();
            hasher.update(keyBuffer);
            return obj;
        },
        update: (data)=>{
            hasher.update(data);
            return obj;
        },
        digest: (outputType)=>{
            const uintArr = hasher.digest("binary");
            hasher.init();
            hasher.update(opad);
            hasher.update(uintArr);
            return hasher.digest(outputType);
        },
        save: ()=>{
            throw new Error("save() not supported");
        },
        load: ()=>{
            throw new Error("load() not supported");
        },
        blockSize: hasher.blockSize,
        digestSize: hasher.digestSize
    };
    return obj;
}
/**
 * Calculates HMAC hash
 * @param hash Hash algorithm to use. It has to be the return value of a function like createSHA1()
 * @param key Key (string, Buffer or TypedArray)
 */ function $0eb8af2968e12ba8$export$b87ab4ad370984b(hash, key) {
    if (!hash || !hash.then) throw new Error('Invalid hash function is provided! Usage: createHMAC(createMD5(), "key").');
    return hash.then((hasher)=>$0eb8af2968e12ba8$var$calculateHmac(hasher, key));
}
function $0eb8af2968e12ba8$var$calculatePBKDF2(digest, salt, iterations, hashLength, outputType) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        const DK = new Uint8Array(hashLength);
        const block1 = new Uint8Array(salt.length + 4);
        const block1View = new DataView(block1.buffer);
        const saltBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(salt);
        const saltUIntBuffer = new Uint8Array(saltBuffer.buffer, saltBuffer.byteOffset, saltBuffer.length);
        block1.set(saltUIntBuffer);
        let destPos = 0;
        const hLen = digest.digestSize;
        const l = Math.ceil(hashLength / hLen);
        let T = null;
        let U = null;
        for(let i = 1; i <= l; i++){
            block1View.setUint32(salt.length, i);
            digest.init();
            digest.update(block1);
            T = digest.digest("binary");
            U = T.slice();
            for(let j = 1; j < iterations; j++){
                digest.init();
                digest.update(U);
                U = digest.digest("binary");
                for(let k = 0; k < hLen; k++)T[k] ^= U[k];
            }
            DK.set(T.subarray(0, hashLength - destPos), destPos);
            destPos += hLen;
        }
        if (outputType === "binary") return DK;
        const digestChars = new Uint8Array(hashLength * 2);
        return $0eb8af2968e12ba8$var$getDigestHex(digestChars, DK, hashLength);
    });
}
const $0eb8af2968e12ba8$var$validateOptions$2 = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (!options.hashFunction || !options.hashFunction.then) throw new Error('Invalid hash function is provided! Usage: pbkdf2("password", "salt", 1000, 32, createSHA1()).');
    if (!Number.isInteger(options.iterations) || options.iterations < 1) throw new Error("Iterations should be a positive number");
    if (!Number.isInteger(options.hashLength) || options.hashLength < 1) throw new Error("Hash length should be a positive number");
    if (options.outputType === undefined) options.outputType = "hex";
    if (![
        "hex",
        "binary"
    ].includes(options.outputType)) throw new Error(`Insupported output type ${options.outputType}. Valid values: ['hex', 'binary']`);
};
/**
 * Generates a new PBKDF2 hash for the supplied password
 */ function $0eb8af2968e12ba8$export$448fa22aedc9dbca(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions$2(options);
        const hmac = yield $0eb8af2968e12ba8$export$b87ab4ad370984b(options.hashFunction, options.password);
        return $0eb8af2968e12ba8$var$calculatePBKDF2(hmac, options.salt, options.iterations, options.hashLength, options.outputType);
    });
}
var $0eb8af2968e12ba8$var$name$3 = "scrypt";
var $0eb8af2968e12ba8$var$data$3 = "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";
var $0eb8af2968e12ba8$var$hash$3 = "d96fb75f";
var $0eb8af2968e12ba8$var$wasmJson$3 = {
    name: $0eb8af2968e12ba8$var$name$3,
    data: $0eb8af2968e12ba8$var$data$3,
    hash: $0eb8af2968e12ba8$var$hash$3
};
function $0eb8af2968e12ba8$var$scryptInternal(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        const { costFactor: costFactor, blockSize: blockSize, parallelism: parallelism, hashLength: hashLength } = options;
        const SHA256Hasher = $0eb8af2968e12ba8$export$21f470e5f937cac3();
        const blockData = yield $0eb8af2968e12ba8$export$448fa22aedc9dbca({
            password: options.password,
            salt: options.salt,
            iterations: 1,
            hashLength: 128 * blockSize * parallelism,
            hashFunction: SHA256Hasher,
            outputType: "binary"
        });
        const scryptInterface = yield $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$3, 0);
        // last block is for storing the temporary vectors
        const VSize = 128 * blockSize * costFactor;
        const XYSize = 256 * blockSize;
        scryptInterface.setMemorySize(blockData.length + VSize + XYSize);
        scryptInterface.writeMemory(blockData, 0);
        // mix blocks
        scryptInterface.getExports().scrypt(blockSize, costFactor, parallelism);
        const expensiveSalt = scryptInterface.getMemory().subarray(0, 128 * blockSize * parallelism);
        const outputData = yield $0eb8af2968e12ba8$export$448fa22aedc9dbca({
            password: options.password,
            salt: expensiveSalt,
            iterations: 1,
            hashLength: hashLength,
            hashFunction: SHA256Hasher,
            outputType: "binary"
        });
        if (options.outputType === "hex") {
            const digestChars = new Uint8Array(hashLength * 2);
            return $0eb8af2968e12ba8$var$getDigestHex(digestChars, outputData, hashLength);
        }
        // return binary format
        return outputData;
    });
}
// eslint-disable-next-line no-bitwise
const $0eb8af2968e12ba8$var$isPowerOfTwo = (v)=>v && !(v & v - 1);
const $0eb8af2968e12ba8$var$validateOptions$1 = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (!Number.isInteger(options.blockSize) || options.blockSize < 1) throw new Error("Block size should be a positive number");
    if (!Number.isInteger(options.costFactor) || options.costFactor < 2 || !$0eb8af2968e12ba8$var$isPowerOfTwo(options.costFactor)) throw new Error("Cost factor should be a power of 2, greater than 1");
    if (!Number.isInteger(options.parallelism) || options.parallelism < 1) throw new Error("Parallelism should be a positive number");
    if (!Number.isInteger(options.hashLength) || options.hashLength < 1) throw new Error("Hash length should be a positive number.");
    if (options.outputType === undefined) options.outputType = "hex";
    if (![
        "hex",
        "binary"
    ].includes(options.outputType)) throw new Error(`Insupported output type ${options.outputType}. Valid values: ['hex', 'binary']`);
};
/**
 * Calculates hash using the scrypt password-based key derivation function
 * @returns Computed hash as a hexadecimal string or as
 *          Uint8Array depending on the outputType option
 */ function $0eb8af2968e12ba8$export$7cf7c2f1ec457bf3(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions$1(options);
        return $0eb8af2968e12ba8$var$scryptInternal(options);
    });
}
var $0eb8af2968e12ba8$var$name$2 = "bcrypt";
var $0eb8af2968e12ba8$var$data$2 = "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";
var $0eb8af2968e12ba8$var$hash$2 = "9f4c7b9e";
var $0eb8af2968e12ba8$var$wasmJson$2 = {
    name: $0eb8af2968e12ba8$var$name$2,
    data: $0eb8af2968e12ba8$var$data$2,
    hash: $0eb8af2968e12ba8$var$hash$2
};
function $0eb8af2968e12ba8$var$bcryptInternal(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        const { costFactor: costFactor, password: password, salt: salt } = options;
        const bcryptInterface = yield $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$2, 0);
        bcryptInterface.writeMemory($0eb8af2968e12ba8$var$getUInt8Buffer(salt), 0);
        const passwordBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(password);
        bcryptInterface.writeMemory(passwordBuffer, 16);
        const shouldEncode = options.outputType === "encoded" ? 1 : 0;
        bcryptInterface.getExports().bcrypt(passwordBuffer.length, costFactor, shouldEncode);
        const memory = bcryptInterface.getMemory();
        if (options.outputType === "encoded") return $0eb8af2968e12ba8$var$intArrayToString(memory, 60);
        if (options.outputType === "hex") {
            const digestChars = new Uint8Array(48);
            return $0eb8af2968e12ba8$var$getDigestHex(digestChars, memory, 24);
        }
        // return binary format
        // the data is copied to allow GC of the original memory buffer
        return memory.slice(0, 24);
    });
}
const $0eb8af2968e12ba8$var$validateOptions = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (!Number.isInteger(options.costFactor) || options.costFactor < 4 || options.costFactor > 31) throw new Error("Cost factor should be a number between 4 and 31");
    options.password = $0eb8af2968e12ba8$var$getUInt8Buffer(options.password);
    if (options.password.length < 1) throw new Error("Password should be at least 1 byte long");
    if (options.password.length > 72) throw new Error("Password should be at most 72 bytes long");
    options.salt = $0eb8af2968e12ba8$var$getUInt8Buffer(options.salt);
    if (options.salt.length !== 16) throw new Error("Salt should be 16 bytes long");
    if (options.outputType === undefined) options.outputType = "encoded";
    if (![
        "hex",
        "binary",
        "encoded"
    ].includes(options.outputType)) throw new Error(`Insupported output type ${options.outputType}. Valid values: ['hex', 'binary', 'encoded']`);
};
/**
 * Calculates hash using the bcrypt password-hashing function
 * @returns Computed hash
 */ function $0eb8af2968e12ba8$export$31330d15d18c9467(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateOptions(options);
        return $0eb8af2968e12ba8$var$bcryptInternal(options);
    });
}
const $0eb8af2968e12ba8$var$validateHashCharacters = (hash)=>{
    if (!/^\$2[axyb]\$[0-3][0-9]\$[./A-Za-z0-9]{53}$/.test(hash)) return false;
    if (hash[4] === "0" && parseInt(hash[5], 10) < 4) return false;
    if (hash[4] === "3" && parseInt(hash[5], 10) > 1) return false;
    return true;
};
const $0eb8af2968e12ba8$var$validateVerifyOptions = (options)=>{
    if (!options || typeof options !== "object") throw new Error("Invalid options parameter. It requires an object.");
    if (options.hash === undefined || typeof options.hash !== "string") throw new Error("Hash should be specified");
    if (options.hash.length !== 60) throw new Error("Hash should be 60 bytes long");
    if (!$0eb8af2968e12ba8$var$validateHashCharacters(options.hash)) throw new Error("Invalid hash");
    options.password = $0eb8af2968e12ba8$var$getUInt8Buffer(options.password);
    if (options.password.length < 1) throw new Error("Password should be at least 1 byte long");
    if (options.password.length > 72) throw new Error("Password should be at most 72 bytes long");
};
/**
 * Verifies password using bcrypt password-hashing function
 * @returns True if the encoded hash matches the password
 */ function $0eb8af2968e12ba8$export$daa9683f27bb9b3a(options) {
    return $0eb8af2968e12ba8$var$__awaiter(this, void 0, void 0, function*() {
        $0eb8af2968e12ba8$var$validateVerifyOptions(options);
        const { hash: hash, password: password } = options;
        const bcryptInterface = yield $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$2, 0);
        bcryptInterface.writeMemory($0eb8af2968e12ba8$var$getUInt8Buffer(hash), 0);
        const passwordBuffer = $0eb8af2968e12ba8$var$getUInt8Buffer(password);
        bcryptInterface.writeMemory(passwordBuffer, 60);
        return !!bcryptInterface.getExports().bcrypt_verify(passwordBuffer.length);
    });
}
var $0eb8af2968e12ba8$var$name$1 = "whirlpool";
var $0eb8af2968e12ba8$var$data$1 = "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";
var $0eb8af2968e12ba8$var$hash$1 = "358808f8";
var $0eb8af2968e12ba8$var$wasmJson$1 = {
    name: $0eb8af2968e12ba8$var$name$1,
    data: $0eb8af2968e12ba8$var$data$1,
    hash: $0eb8af2968e12ba8$var$hash$1
};
const $0eb8af2968e12ba8$var$mutex$1 = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache$1 = null;
/**
 * Calculates Whirlpool hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$3161c1ded0168e00(data) {
    if ($0eb8af2968e12ba8$var$wasmCache$1 === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex$1, $0eb8af2968e12ba8$var$wasmJson$1, 64).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache$1 = wasm;
        return $0eb8af2968e12ba8$var$wasmCache$1.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache$1.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new Whirlpool hash instance
 */ function $0eb8af2968e12ba8$export$4c306358c11c96bb() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson$1, 64).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 64
        };
        return obj;
    });
}
var $0eb8af2968e12ba8$var$name = "sm3";
var $0eb8af2968e12ba8$var$data = "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";
var $0eb8af2968e12ba8$var$hash = "6e6f46ad";
var $0eb8af2968e12ba8$var$wasmJson = {
    name: $0eb8af2968e12ba8$var$name,
    data: $0eb8af2968e12ba8$var$data,
    hash: $0eb8af2968e12ba8$var$hash
};
const $0eb8af2968e12ba8$var$mutex = new $0eb8af2968e12ba8$var$Mutex();
let $0eb8af2968e12ba8$var$wasmCache = null;
/**
 * Calculates SM3 hash
 * @param data Input data (string, Buffer or TypedArray)
 * @returns Computed hash as a hexadecimal string
 */ function $0eb8af2968e12ba8$export$67bd2c16e1aba6b3(data) {
    if ($0eb8af2968e12ba8$var$wasmCache === null) return $0eb8af2968e12ba8$var$lockedCreate($0eb8af2968e12ba8$var$mutex, $0eb8af2968e12ba8$var$wasmJson, 32).then((wasm)=>{
        $0eb8af2968e12ba8$var$wasmCache = wasm;
        return $0eb8af2968e12ba8$var$wasmCache.calculate(data);
    });
    try {
        const hash = $0eb8af2968e12ba8$var$wasmCache.calculate(data);
        return Promise.resolve(hash);
    } catch (err) {
        return Promise.reject(err);
    }
}
/**
 * Creates a new SM3 hash instance
 */ function $0eb8af2968e12ba8$export$7801f78fd9af496a() {
    return $0eb8af2968e12ba8$var$WASMInterface($0eb8af2968e12ba8$var$wasmJson, 32).then((wasm)=>{
        wasm.init();
        const obj = {
            init: ()=>{
                wasm.init();
                return obj;
            },
            update: (data)=>{
                wasm.update(data);
                return obj;
            },
            digest: (outputType)=>wasm.digest(outputType),
            save: ()=>wasm.save(),
            load: (data)=>{
                wasm.load(data);
                return obj;
            },
            blockSize: 64,
            digestSize: 32
        };
        return obj;
    });
}

});



parcelRegister("iLQ2g", function(module, exports) {
"use strict";
var $daa4faf97121f62e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $daa4faf97121f62e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $daa4faf97121f62e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $daa4faf97121f62e$var$__createBinding(result, mod, k);
    }
    $daa4faf97121f62e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DummyEngineError = module.exports.BIP39 = module.exports.BIP32 = void 0;

module.exports.BIP32 = $daa4faf97121f62e$var$__importStar((parcelRequire("des9Q")));

module.exports.BIP39 = $daa4faf97121f62e$var$__importStar((parcelRequire("3goDU")));

var $b9G7Z = parcelRequire("b9G7Z");
Object.defineProperty(module.exports, "DummyEngineError", {
    enumerable: true,
    get: function() {
        return $b9G7Z.DummyEngineError;
    }
});

});
parcelRegister("des9Q", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $9a226cbc1022fa50$require$Buffer = $ihoyg.Buffer;
"use strict";
var $9a226cbc1022fa50$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9a226cbc1022fa50$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9a226cbc1022fa50$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9a226cbc1022fa50$var$__createBinding(result, mod, k);
    }
    $9a226cbc1022fa50$var$__setModuleDefault(result, mod);
    return result;
};
var $9a226cbc1022fa50$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $9a226cbc1022fa50$var$__createBinding(exports1, m, p);
};
var $9a226cbc1022fa50$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Seed = module.exports.Node = void 0;
parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

const $9a226cbc1022fa50$var$bip32crypto = $9a226cbc1022fa50$var$__importStar((parcelRequire("fuOE5")));

const $9a226cbc1022fa50$var$tinyecc = $9a226cbc1022fa50$var$__importStar((parcelRequire("bAAqK")));

var $cVeOu = parcelRequire("cVeOu");

var $glOWu = parcelRequire("glOWu");

var $b9G7Z = parcelRequire("b9G7Z");

$9a226cbc1022fa50$var$__exportStar((parcelRequire("bK4PJ")), module.exports);
class $9a226cbc1022fa50$var$Node {
    constructor(xpubTree){
        this.xpubTree = xpubTree;
    }
    static create(xpubTree) {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            return new $9a226cbc1022fa50$var$Node(xpubTree);
        });
    }
    getPublicKey() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            return this.xpubTree.publicKey;
        });
    }
    getChainCode() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            return this.xpubTree.chainCode;
        });
    }
    ecdsaSign() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            throw new $b9G7Z.DummyEngineError();
        });
    }
    ecdsaSignRecoverable() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            throw new $b9G7Z.DummyEngineError();
        });
    }
    derive(index) {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            $glOWu.Uint32.assert(index);
            const child = (()=>{
                const existingChild = this.xpubTree.children.get(index);
                if (existingChild) return existingChild;
                if (index >= 0x80000000) throw new $b9G7Z.DummyEngineError();
                const serP = $9a226cbc1022fa50$require$Buffer.alloc(37);
                serP.set(this.xpubTree.publicKey, 0);
                serP.writeUInt32BE(index, 33);
                const I = $9a226cbc1022fa50$var$bip32crypto.hmacSHA512((0, $glOWu.safeBufferFrom)(this.xpubTree.chainCode), serP);
                const IL = I.slice(0, 32);
                const IR = I.slice(32, 64);
                const Ki = $9a226cbc1022fa50$var$tinyecc.pointAddScalar((0, $glOWu.safeBufferFrom)(this.xpubTree.publicKey), IL);
                if (Ki === null) throw new Error("Ki is null; this should be cryptographically impossible");
                const newChild = {
                    version: this.xpubTree.version,
                    depth: this.xpubTree.depth + 1,
                    parentFp: this.xpubTree.fingerprint,
                    childNum: index,
                    chainCode: (0, $glOWu.checkType)($cVeOu.BIP32.ChainCode, IR),
                    publicKey: (0, $glOWu.checkType)($cVeOu.SecP256K1.CompressedPoint, Ki),
                    fingerprint: new DataView((0, $7NkOr.toArrayBuffer)($cVeOu.Digest.Algorithms.hash160(Ki))).getUint32(0),
                    children: new Map()
                };
                this.xpubTree.children.set(index, newChild);
                return newChild;
            })();
            const out = yield $9a226cbc1022fa50$var$Node.create(child);
            return out;
        });
    }
    ecdh() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            throw new $b9G7Z.DummyEngineError();
        });
    }
    ecdhRaw() {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            throw new $b9G7Z.DummyEngineError();
        });
    }
}
module.exports.Node = $9a226cbc1022fa50$var$Node;
class $9a226cbc1022fa50$var$Seed {
    constructor(xpubTree){
        this.xpubTree = xpubTree;
    }
    static create(xpubTree) {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            return new $9a226cbc1022fa50$var$Seed(xpubTree);
        });
    }
    toMasterKey(hmacKey) {
        return $9a226cbc1022fa50$var$__awaiter(this, void 0, void 0, function*() {
            if (hmacKey !== undefined) throw new Error("bad hmacKey type");
            return yield $9a226cbc1022fa50$var$Node.create(this.xpubTree);
        });
    }
}
module.exports.Seed = $9a226cbc1022fa50$var$Seed;

});
parcelRegister("b9G7Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DummyEngineError = void 0;
class $81f136abc4db3b6e$var$DummyEngineError extends Error {
    constructor(){
        super("Isolation.Engines.Dummy - Invalid operation: private key not available");
    }
}
module.exports.DummyEngineError = $81f136abc4db3b6e$var$DummyEngineError;

});


parcelRegister("3goDU", function(module, exports) {
"use strict";
var $2605fb41111a76cd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2605fb41111a76cd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2605fb41111a76cd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2605fb41111a76cd$var$__createBinding(result, mod, k);
    }
    $2605fb41111a76cd$var$__setModuleDefault(result, mod);
    return result;
};
var $2605fb41111a76cd$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $2605fb41111a76cd$var$__createBinding(exports1, m, p);
};
var $2605fb41111a76cd$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Mnemonic = void 0;
parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

const $2605fb41111a76cd$var$bs58check = $2605fb41111a76cd$var$__importStar((parcelRequire("1Vf4C")));

const $2605fb41111a76cd$var$BIP32 = $2605fb41111a76cd$var$__importStar((parcelRequire("bK4PJ")));

const $2605fb41111a76cd$var$Digest = $2605fb41111a76cd$var$__importStar((parcelRequire("bkHrJ")));

const $2605fb41111a76cd$var$SecP256K1 = $2605fb41111a76cd$var$__importStar((parcelRequire("feVdj")));

var $glOWu = parcelRequire("glOWu");

const $2605fb41111a76cd$var$BIP32Engine = $2605fb41111a76cd$var$__importStar((parcelRequire("des9Q")));

$2605fb41111a76cd$var$__exportStar((parcelRequire("2Q5oV")), module.exports);
class $2605fb41111a76cd$var$Mnemonic {
    constructor(xpubTree){
        this.xpubTree = xpubTree;
    }
    static create(xpubList) {
        return $2605fb41111a76cd$var$__awaiter(this, void 0, void 0, function*() {
            const parsedXpubs = xpubList.split(" ").map((xpub)=>{
                const xpubBuf = $2605fb41111a76cd$var$bs58check.decode(xpub);
                if (xpubBuf.length !== 78) throw new Error("Isolation.Engine.Dummy.BIP39.create - Invalid xpub");
                const xpubView = new DataView((0, $7NkOr.toArrayBuffer)(xpubBuf));
                const pk = (0, $glOWu.checkType)($2605fb41111a76cd$var$SecP256K1.CompressedPoint, xpubBuf.slice(45));
                return {
                    version: xpubView.getUint32(0),
                    depth: xpubView.getUint8(4),
                    parentFp: xpubView.getUint32(5),
                    childNum: xpubView.getUint32(9),
                    chainCode: (0, $glOWu.checkType)($2605fb41111a76cd$var$BIP32.ChainCode, xpubBuf.slice(13, 45)),
                    publicKey: pk,
                    fingerprint: new DataView((0, $7NkOr.toArrayBuffer)($2605fb41111a76cd$var$Digest.Algorithms.hash160(pk))).getUint32(0),
                    children: new Map()
                };
            });
            const tree = (()=>{
                const rootXpubs = parsedXpubs.filter((x)=>x.parentFp === 0x00000000);
                if (rootXpubs.length === 0) throw new Error("can't find root xpub");
                if (rootXpubs.length > 1) throw new Error("more than one root xpub");
                return rootXpubs[0];
            })();
            const xpubsByFp = parsedXpubs.map((xpub)=>{
                return [
                    xpub.fingerprint,
                    xpub
                ];
            }).reduce((a, [k, v])=>{
                if (k in a) throw new Error("key fingerprint collision");
                a[k] = v;
                return a;
            }, {});
            for (const xpub of parsedXpubs.filter((x)=>x !== tree)){
                if (!(xpub.parentFp in xpubsByFp)) throw new Error("found xpub, but not its parent");
                xpubsByFp[xpub.parentFp].children.set(xpub.childNum, xpub);
            }
            return new $2605fb41111a76cd$var$Mnemonic(tree);
        });
    }
    toSeed(passphrase) {
        return $2605fb41111a76cd$var$__awaiter(this, void 0, void 0, function*() {
            if (passphrase !== undefined && passphrase !== "") throw new Error("bad passphrase type");
            return yield $2605fb41111a76cd$var$BIP32Engine.Seed.create(this.xpubTree);
        });
    }
}
module.exports.Mnemonic = $2605fb41111a76cd$var$Mnemonic;

});





parcelRegister("ejX7X", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $a6d0b4842d2d8f3f$require$Buffer = $ihoyg.Buffer;
"use strict";
var $a6d0b4842d2d8f3f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a6d0b4842d2d8f3f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a6d0b4842d2d8f3f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a6d0b4842d2d8f3f$var$__createBinding(result, mod, k);
    }
    $a6d0b4842d2d8f3f$var$__setModuleDefault(result, mod);
    return result;
};
var $a6d0b4842d2d8f3f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a6d0b4842d2d8f3f$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $a6d0b4842d2d8f3f$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $a6d0b4842d2d8f3f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeBinanceWallet = module.exports.MixinNativeBinanceWalletInfo = void 0;

const $a6d0b4842d2d8f3f$var$core = $a6d0b4842d2d8f3f$var$__importStar((parcelRequire("lFpDy")));

const $a6d0b4842d2d8f3f$var$bech32 = $a6d0b4842d2d8f3f$var$__importStar((parcelRequire("5wgCY")));

const $a6d0b4842d2d8f3f$var$bignumber_js_1 = $a6d0b4842d2d8f3f$var$__importDefault((parcelRequire("hqAsy")));

const $a6d0b4842d2d8f3f$var$crypto_js_1 = $a6d0b4842d2d8f3f$var$__importDefault((parcelRequire("kWcCv")));

const $a6d0b4842d2d8f3f$var$p_lazy_1 = $a6d0b4842d2d8f3f$var$__importDefault((parcelRequire("gGdnO")));

const $a6d0b4842d2d8f3f$var$Isolation = $a6d0b4842d2d8f3f$var$__importStar((parcelRequire("aCCM0")));

const $a6d0b4842d2d8f3f$var$util = $a6d0b4842d2d8f3f$var$__importStar((parcelRequire("byiQW")));

const $a6d0b4842d2d8f3f$var$bnbSdk = $a6d0b4842d2d8f3f$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return Promise.resolve((parcelRequire("hQ2c4")));
    }).then((res)=>$a6d0b4842d2d8f3f$var$__importStar(res)));
function $a6d0b4842d2d8f3f$var$MixinNativeBinanceWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeBinanceWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsBinanceInfo = true;
        }
        binanceSupportsNetwork() {
            return $a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        binanceSupportsSecureTransfer() {
            return $a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        binanceSupportsNativeShapeShift() {
            return false;
        }
        binanceGetAccountPaths(msg) {
            const slip44 = $a6d0b4842d2d8f3f$var$core.slip44ByCoin("Binance");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        binanceNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeBinanceWalletInfo = $a6d0b4842d2d8f3f$var$MixinNativeBinanceWalletInfo;
function $a6d0b4842d2d8f3f$var$MixinNativeBinanceWallet(Base) {
    var _MixinNativeBinanceWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeBinanceWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsBinance = true;
            _MixinNativeBinanceWallet_masterKey.set(this, void 0);
        }
        binanceInitializeWallet(masterKey) {
            return $a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                $a6d0b4842d2d8f3f$var$__classPrivateFieldSet(this, _MixinNativeBinanceWallet_masterKey, masterKey, "f");
            });
        }
        binanceWipe() {
            $a6d0b4842d2d8f3f$var$__classPrivateFieldSet(this, _MixinNativeBinanceWallet_masterKey, undefined, "f");
        }
        binanceBech32ify(address, prefix) {
            const words = $a6d0b4842d2d8f3f$var$bech32.toWords(address);
            return $a6d0b4842d2d8f3f$var$bech32.encode(prefix, words);
        }
        createBinanceAddress(publicKey, testnet) {
            const message = $a6d0b4842d2d8f3f$var$crypto_js_1.default.SHA256($a6d0b4842d2d8f3f$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $a6d0b4842d2d8f3f$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $a6d0b4842d2d8f3f$require$Buffer.from(hash, `hex`);
            return this.binanceBech32ify(address, `${testnet ? "t" : ""}bnb`);
        }
        binanceGetAddress(msg) {
            return $a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$a6d0b4842d2d8f3f$var$__classPrivateFieldGet(this, _MixinNativeBinanceWallet_masterKey, "f"), ()=>$a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                        var _b;
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $a6d0b4842d2d8f3f$var$util.getKeyPair($a6d0b4842d2d8f3f$var$__classPrivateFieldGet(this, _MixinNativeBinanceWallet_masterKey, "f"), msg.addressNList, "binance");
                        return this.createBinanceAddress(keyPair.publicKey.toString("hex"), (_b = msg.testnet) !== null && _b !== void 0 ? _b : false);
                    }));
            });
        }
        binanceSignTx(msg) {
            return $a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$a6d0b4842d2d8f3f$var$__classPrivateFieldGet(this, _MixinNativeBinanceWallet_masterKey, "f"), ()=>$a6d0b4842d2d8f3f$var$__awaiter(this, void 0, void 0, function*() {
                        var _b, _c, _d, _e, _f, _g;
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $a6d0b4842d2d8f3f$var$util.getKeyPair($a6d0b4842d2d8f3f$var$__classPrivateFieldGet(this, _MixinNativeBinanceWallet_masterKey, "f"), msg.addressNList, "binance");
                        const tx = Object.assign({}, msg.tx);
                        if (!tx.data) tx.data = null;
                        if (!tx.memo) tx.memo = "";
                        if (!tx.sequence) tx.sequence = "0";
                        if (!tx.source) tx.source = "0";
                        const client = new (yield $a6d0b4842d2d8f3f$var$bnbSdk).BncClient(msg.testnet ? "https://testnet-dex.binance.org" : "https://dex.binance.org"); // broadcast not used but available
                        yield client.chooseNetwork(msg.testnet ? "testnet" : "mainnet");
                        const haveAccountNumber = !!msg.tx.account_number && Number.isInteger(Number(msg.tx.account_number));
                        if (haveAccountNumber) yield client.setAccountNumber(Number(msg.tx.account_number));
                        client.setSigningDelegate((yield $a6d0b4842d2d8f3f$var$Isolation.Adapters.Binance.create(keyPair.node)));
                        yield client.initChain();
                        if (!tx.chain_id) {
                            const { chainId: chainId } = client;
                            if (!chainId) throw new Error("unable to load chain id");
                            tx.chain_id = chainId;
                        }
                        if (!tx.account_number) {
                            const { account_number: account_number } = client;
                            if (account_number) tx.account_number = account_number.toString();
                        }
                        if (((_b = tx.msgs) === null || _b === void 0 ? void 0 : _b.length) !== 1 || ((_c = tx.msgs[0].inputs) === null || _c === void 0 ? void 0 : _c.length) !== 1 || ((_d = tx.msgs[0].inputs[0].coins) === null || _d === void 0 ? void 0 : _d.length) !== 1 || ((_e = tx.msgs[0].outputs) === null || _e === void 0 ? void 0 : _e.length) !== 1 || ((_f = tx.msgs[0].outputs[0].coins) === null || _f === void 0 ? void 0 : _f.length) !== 1) throw new Error("malformed or unsupported tx message");
                        const addressTo = tx.msgs[0].outputs[0].address;
                        const addressFrom = tx.msgs[0].inputs[0].address;
                        const addressFromVerify = this.createBinanceAddress(keyPair.publicKey.toString("hex"), !!msg.testnet);
                        if (addressFrom !== addressFromVerify) throw Error("Invalid permissions to sign for address");
                        if (!tx.account_number) {
                            const { result: result, status: status } = $a6d0b4842d2d8f3f$var$core.mustBeDefined((yield client.getAccount(addressFrom)));
                            if (!(status === 200 && "account_number" in result && typeof result.account_number === "number")) throw new Error("unable to load account number");
                            tx.account_number = result.account_number.toString();
                        }
                        // The Binance SDK takes amounts as decimal strings.
                        const amount = new $a6d0b4842d2d8f3f$var$bignumber_js_1.default(tx.msgs[0].inputs[0].coins[0].amount);
                        if (!amount.isInteger()) throw new Error("amount must be an integer");
                        if (!amount.isEqualTo(tx.msgs[0].outputs[0].coins[0].amount)) throw new Error("amount in input and output must be equal");
                        const asset = tx.msgs[0].inputs[0].coins[0].denom;
                        if (asset !== tx.msgs[0].outputs[0].coins[0].denom) throw new Error("denomination in input and output must be the same");
                        const result = yield client.transfer(addressFrom, addressTo, amount.shiftedBy(-8).toString(), asset, tx.memo, (_g = Number(tx.sequence)) !== null && _g !== void 0 ? _g : null);
                        const serialized = result.serialize();
                        const aminoPubKey = result.signatures[0].pub_key;
                        const signature = $a6d0b4842d2d8f3f$require$Buffer.from(result.signatures[0].signature, "base64").toString("base64");
                        // The BNB SDK returns public keys serialized in its own format. The first four bytes are a type
                        // tag, and the fifth is the length of the rest of the data, which is always exactly 33 bytes.
                        if (aminoPubKey.length !== 38 || aminoPubKey.readUInt32BE(0) !== 0xeb5ae987 || aminoPubKey.readUInt8(4) !== 33) throw new Error("Binance SDK returned public key in an incorrect format");
                        const pub_key = aminoPubKey.slice(5).toString("base64");
                        return Object.assign({
                            account_number: result.accountNumber
                        }, tx, {
                            // msgs: result.msgs,
                            signatures: {
                                pub_key: pub_key,
                                signature: signature
                            },
                            serialized: serialized,
                            txid: $a6d0b4842d2d8f3f$var$crypto_js_1.default.SHA256($a6d0b4842d2d8f3f$var$crypto_js_1.default.enc.Hex.parse(serialized)).toString()
                        });
                    }));
            });
        }
    }, _MixinNativeBinanceWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeBinanceWallet = $a6d0b4842d2d8f3f$var$MixinNativeBinanceWallet;

});

parcelRegister("jC9XV", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $e4794bdabefac8c0$require$Buffer = $ihoyg.Buffer;
"use strict";
var $e4794bdabefac8c0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4794bdabefac8c0$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e4794bdabefac8c0$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e4794bdabefac8c0$var$__createBinding(result, mod, k);
    }
    $e4794bdabefac8c0$var$__setModuleDefault(result, mod);
    return result;
};
var $e4794bdabefac8c0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e4794bdabefac8c0$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e4794bdabefac8c0$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeBTCWallet = module.exports.MixinNativeBTCWalletInfo = void 0;

const $e4794bdabefac8c0$var$bitcoin = $e4794bdabefac8c0$var$__importStar((parcelRequire("1JUZg")));

const $e4794bdabefac8c0$var$core = $e4794bdabefac8c0$var$__importStar((parcelRequire("lFpDy")));

const $e4794bdabefac8c0$var$bchAddr = $e4794bdabefac8c0$var$__importStar((parcelRequire("1CA4f")));

var $pvQdK = parcelRequire("pvQdK");

const $e4794bdabefac8c0$var$util = $e4794bdabefac8c0$var$__importStar((parcelRequire("byiQW")));
const $e4794bdabefac8c0$var$supportedCoins = [
    "bitcoin",
    "dash",
    "digibyte",
    "dogecoin",
    "litecoin",
    "bitcoincash",
    "testnet"
];
const $e4794bdabefac8c0$var$segwit = [
    "p2wpkh",
    "p2sh-p2wpkh",
    "bech32"
];
function $e4794bdabefac8c0$var$MixinNativeBTCWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeBTCWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsBTCInfo = true;
        }
        btcSupportsCoinSync(coin) {
            return $e4794bdabefac8c0$var$supportedCoins.includes(String(coin).toLowerCase());
        }
        btcSupportsCoin(coin) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return this.btcSupportsCoinSync(coin);
            });
        }
        btcSupportsScriptTypeSync(coin, scriptType) {
            if (!this.btcSupportsCoinSync(coin)) return false;
            switch(scriptType){
                case $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendMultisig:
                case $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendAddress:
                case $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendWitness:
                case $e4794bdabefac8c0$var$core.BTCInputScriptType.Bech32:
                case $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendP2SHWitness:
                    return true;
                default:
                    return false;
            }
        }
        btcSupportsScriptType(coin, scriptType) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return this.btcSupportsScriptTypeSync(coin, scriptType);
            });
        }
        btcSupportsSecureTransfer() {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        btcSupportsNativeShapeShift() {
            return false;
        }
        btcGetAccountPaths(msg) {
            const slip44 = $e4794bdabefac8c0$var$core.slip44ByCoin(msg.coin);
            if (slip44 === undefined) return [];
            const bip44 = $e4794bdabefac8c0$var$core.legacyAccount(msg.coin, slip44, msg.accountIdx);
            const bip49 = $e4794bdabefac8c0$var$core.segwitAccount(msg.coin, slip44, msg.accountIdx);
            const bip84 = $e4794bdabefac8c0$var$core.segwitNativeAccount(msg.coin, slip44, msg.accountIdx);
            const coinPaths = {
                bitcoin: [
                    bip44,
                    bip49,
                    bip84
                ],
                bitcoincash: [
                    bip44,
                    bip49,
                    bip84
                ],
                dash: [
                    bip44
                ],
                digibyte: [
                    bip44,
                    bip49,
                    bip84
                ],
                dogecoin: [
                    bip44
                ],
                litecoin: [
                    bip44,
                    bip49,
                    bip84
                ],
                testnet: [
                    bip44,
                    bip49,
                    bip84
                ]
            };
            let paths = coinPaths[msg.coin.toLowerCase()] || [];
            if (msg.scriptType !== undefined) paths = paths.filter((path)=>{
                return path.scriptType === msg.scriptType;
            });
            return paths;
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        btcIsSameAccount(msg) {
            // TODO: support at some point
            return false;
        }
        btcNextAccountPath(msg) {
            const description = $e4794bdabefac8c0$var$core.describeUTXOPath(msg.addressNList, msg.coin, msg.scriptType);
            if (!description.isKnown) return undefined;
            const addressNList = msg.addressNList;
            if (addressNList[0] === 2147483692 && msg.scriptType == $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendAddress || addressNList[0] === 2147483697 && msg.scriptType == $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendP2SHWitness || addressNList[0] === 2147483732 && msg.scriptType == $e4794bdabefac8c0$var$core.BTCInputScriptType.SpendWitness) {
                addressNList[2] += 1;
                return Object.assign(Object.assign({}, msg), {
                    addressNList: addressNList
                });
            }
            return undefined;
        }
    };
}
module.exports.MixinNativeBTCWalletInfo = $e4794bdabefac8c0$var$MixinNativeBTCWalletInfo;
function $e4794bdabefac8c0$var$MixinNativeBTCWallet(Base) {
    var _MixinNativeBTCWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeBTCWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsBTC = true;
            _MixinNativeBTCWallet_masterKey.set(this, void 0);
        }
        btcInitializeWallet(masterKey) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                $e4794bdabefac8c0$var$__classPrivateFieldSet(this, _MixinNativeBTCWallet_masterKey, masterKey, "f");
            });
        }
        btcWipe() {
            $e4794bdabefac8c0$var$__classPrivateFieldSet(this, _MixinNativeBTCWallet_masterKey, undefined, "f");
        }
        createPayment(pubkey, scriptType, network) {
            switch(scriptType){
                case "p2sh":
                    return $e4794bdabefac8c0$var$bitcoin.payments.p2sh({
                        pubkey: pubkey,
                        network: network
                    });
                case "p2pkh":
                    return $e4794bdabefac8c0$var$bitcoin.payments.p2pkh({
                        pubkey: pubkey,
                        network: network
                    });
                case "p2wpkh":
                    return $e4794bdabefac8c0$var$bitcoin.payments.p2wpkh({
                        pubkey: pubkey,
                        network: network
                    });
                case "p2sh-p2wpkh":
                    return $e4794bdabefac8c0$var$bitcoin.payments.p2sh({
                        redeem: $e4794bdabefac8c0$var$bitcoin.payments.p2wpkh({
                            pubkey: pubkey,
                            network: network
                        }),
                        network: network
                    });
                case "bech32":
                    return $e4794bdabefac8c0$var$bitcoin.payments.p2wsh({
                        redeem: $e4794bdabefac8c0$var$bitcoin.payments.p2wsh({
                            pubkey: pubkey,
                            network: network
                        }),
                        network: network
                    });
                default:
                    throw new Error(`no implementation for script type: ${scriptType}`);
            }
        }
        validateVoutOrdering(msg, tx) {
            // From THORChain specification:
            /* ignoreTx checks if we can already ignore a tx according to preset rules
          
                   we expect array of "vout" for a BTC to have this format
                   OP_RETURN is mandatory only on inbound tx
                   vout:0 is our vault
                   vout:1 is any any change back to themselves
                   vout:2 is OP_RETURN (first 80 bytes)
                   vout:3 is OP_RETURN (next 80 bytes)
          
                   Rules to ignore a tx are:
                   - vout:0 doesn't have coins (value)
                   - vout:0 doesn't have address
                   - count vouts > 4
                   - count vouts with coins (value) > 2
                */ var _b;
            // Check that vout:0 contains the vault address
            if ($e4794bdabefac8c0$var$bitcoin.address.fromOutputScript(tx.outs[0].script) != msg.vaultAddress) {
                console.error("Vout:0 does not contain vault address.");
                return false;
            }
            // TODO: Can we check and  make sure vout:1 is our address?
            // Check and make sure vout:2 exists
            if (tx.outs.length < 3) {
                console.error("Not enough outputs found in transaction.", msg);
                return false;
            }
            // Check and make sure vout:2 has OP_RETURN data
            const opcode = (_b = $e4794bdabefac8c0$var$bitcoin.script.decompile(tx.outs[2].script)) === null || _b === void 0 ? void 0 : _b[0];
            if (Object.keys($e4794bdabefac8c0$var$bitcoin.script.OPS).find((k)=>$e4794bdabefac8c0$var$bitcoin.script.OPS[k] === opcode) != "OP_RETURN") {
                console.error("OP_RETURN output not found for transaction.");
                return false;
            }
            // Make sure vout:3 does not exist
            if (tx.outs[3]) {
                console.error("Illegal second op_return output found.");
                return false;
            }
            return true;
        }
        buildInput(coin, input) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), ()=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                        var _b;
                        const { addressNList: addressNList, amount: amount, hex: hex, scriptType: scriptType } = input;
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $e4794bdabefac8c0$var$util.getKeyPair($e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), addressNList, coin, scriptType);
                        const isSegwit = !!scriptType && $e4794bdabefac8c0$var$segwit.includes(scriptType);
                        const nonWitnessUtxo = hex && $e4794bdabefac8c0$require$Buffer.from(hex, "hex");
                        const witnessUtxo = input.tx && {
                            script: $e4794bdabefac8c0$require$Buffer.from(input.tx.vout[input.vout].scriptPubKey.hex, "hex"),
                            value: Number(amount)
                        };
                        const utxoData = isSegwit && witnessUtxo ? {
                            witnessUtxo: witnessUtxo
                        } : {
                            nonWitnessUtxo: nonWitnessUtxo
                        };
                        if (!(utxoData.witnessUtxo || utxoData.nonWitnessUtxo)) throw new Error("failed to build input - must provide prev rawTx (segwit input can provide scriptPubKey hex and value instead)");
                        const { publicKey: publicKey, network: network } = keyPair;
                        const payment = this.createPayment(publicKey, scriptType, network);
                        const scriptData = {};
                        switch(scriptType){
                            case "p2sh-p2wpkh":
                            case "p2sh":
                            case "bech32":
                                scriptData.redeemScript = (_b = payment.redeem) === null || _b === void 0 ? void 0 : _b.output;
                                break;
                        }
                        const bchData = {};
                        if (coin.toLowerCase() === "bitcoincash") bchData.sighashType = $e4794bdabefac8c0$var$bitcoin.Transaction.SIGHASH_ALL | $e4794bdabefac8c0$var$bitcoin.Transaction.SIGHASH_BITCOINCASHBIP143;
                        return Object.assign(Object.assign(Object.assign({}, utxoData), bchData), scriptData);
                    }));
            });
        }
        btcGetAddress(msg) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), ()=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                        const { addressNList: addressNList, coin: coin, scriptType: scriptType } = msg;
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $e4794bdabefac8c0$var$util.getKeyPair($e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), addressNList, coin, scriptType);
                        const { address: address } = this.createPayment(keyPair.publicKey, scriptType, keyPair.network);
                        if (!address) return null;
                        return coin.toLowerCase() === "bitcoincash" ? $e4794bdabefac8c0$var$bchAddr.toCashAddress(address) : address;
                    }));
            });
        }
        btcSignTx(msg) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), ()=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                        const { coin: coin, inputs: inputs, outputs: outputs, version: version, locktime: locktime } = msg;
                        const psbt = new $e4794bdabefac8c0$var$bitcoin.Psbt({
                            network: (0, $pvQdK.getNetwork)(coin)
                        });
                        psbt.setVersion(version !== null && version !== void 0 ? version : 1);
                        locktime && psbt.setLocktime(locktime);
                        yield Promise.all(inputs.map((input)=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                                try {
                                    const inputData = yield this.buildInput(coin, input);
                                    psbt.addInput(Object.assign({
                                        hash: input.txid,
                                        index: input.vout
                                    }, inputData));
                                } catch (e) {
                                    throw new Error(`failed to add input: ${e}`);
                                }
                            })));
                        yield Promise.all(outputs.map((output)=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                                try {
                                    const { amount: amount } = output;
                                    let address;
                                    if (output.address !== undefined) address = output.address;
                                    else if (output.addressNList !== undefined) {
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        const keyPair = yield $e4794bdabefac8c0$var$util.getKeyPair($e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), output.addressNList, coin, output.scriptType);
                                        const { publicKey: publicKey, network: network } = keyPair;
                                        const payment = this.createPayment(publicKey, output.scriptType, network);
                                        if (!payment.address) throw new Error("could not get payment address");
                                        address = payment.address;
                                    } else throw new Error("unsupported output type");
                                    if (coin.toLowerCase() === "bitcoincash") address = $e4794bdabefac8c0$var$bchAddr.toLegacyAddress(address);
                                    psbt.addOutput({
                                        address: address,
                                        value: Number(amount)
                                    });
                                } catch (e) {
                                    throw new Error(`failed to add output: ${e}`);
                                }
                            })));
                        if (msg.opReturnData) {
                            const data = $e4794bdabefac8c0$require$Buffer.from(msg.opReturnData, "utf-8");
                            const embed = $e4794bdabefac8c0$var$bitcoin.payments.embed({
                                data: [
                                    data
                                ]
                            });
                            const script = embed.output;
                            if (!script) throw new Error("unable to build OP_RETURN script");
                            psbt.addOutput({
                                script: script,
                                value: 0
                            });
                        }
                        yield Promise.all(inputs.map((input, idx)=>$e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                                try {
                                    const { addressNList: addressNList, scriptType: scriptType } = input;
                                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                    const keyPair = yield $e4794bdabefac8c0$var$util.getKeyPair($e4794bdabefac8c0$var$__classPrivateFieldGet(this, _MixinNativeBTCWallet_masterKey, "f"), addressNList, coin, scriptType);
                                    yield psbt.signInputAsync(idx, keyPair);
                                } catch (e) {
                                    throw new Error(`failed to sign input: ${e}`);
                                }
                            })));
                        psbt.finalizeAllInputs();
                        const tx = psbt.extractTransaction(true);
                        // If this is a THORChain transaction, validate the vout ordering
                        if (msg.vaultAddress && !this.validateVoutOrdering(msg, tx)) throw new Error("Improper vout ordering for BTC Thorchain transaction");
                        const signatures = tx.ins.map((input)=>{
                            if (input.witness.length > 0) return input.witness[0].toString("hex");
                            else {
                                const sigLen = input.script[0];
                                return input.script.slice(1, sigLen).toString("hex");
                            }
                        });
                        return {
                            signatures: signatures,
                            serializedTx: tx.toHex()
                        };
                    }));
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        btcSignMessage(msg) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                throw new Error("function not implemented");
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        btcVerifyMessage(msg) {
            return $e4794bdabefac8c0$var$__awaiter(this, void 0, void 0, function*() {
                throw new Error("function not implemented");
            });
        }
    }, _MixinNativeBTCWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeBTCWallet = $e4794bdabefac8c0$var$MixinNativeBTCWallet;

});
parcelRegister("1CA4f", function(module, exports) {
/***
 * @license
 * https://github.com/ealmansi/bchaddrjs
 * Copyright (c) 2018-2020 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $12e5514de6f3daec$require$Buffer = $ihoyg.Buffer;

var $1Vf4C = parcelRequire("1Vf4C");

var $1TIhD = parcelRequire("1TIhD");
/**
 * General purpose Bitcoin Cash address detection and translation.<br />
 * Supports all major Bitcoin Cash address formats.<br />
 * Currently:
 * <ul>
 *    <li> Legacy format </li>
 *    <li> Bitpay format </li>
 *    <li> Cashaddr format </li>
 * </ul>
 * @module bchaddr
 */ /**
 * @static
 * Supported Bitcoin Cash address formats.
 */ var $12e5514de6f3daec$var$Format = {};
$12e5514de6f3daec$var$Format.Legacy = "legacy";
$12e5514de6f3daec$var$Format.Bitpay = "bitpay";
$12e5514de6f3daec$var$Format.Cashaddr = "cashaddr";
/**
 * @static
 * Supported networks.
 */ var $12e5514de6f3daec$var$Network = {};
$12e5514de6f3daec$var$Network.Mainnet = "mainnet";
$12e5514de6f3daec$var$Network.Testnet = "testnet";
/**
 * @static
 * Supported address types.
 */ var $12e5514de6f3daec$var$Type = {};
$12e5514de6f3daec$var$Type.P2PKH = "p2pkh";
$12e5514de6f3daec$var$Type.P2SH = "p2sh";
/**
 * Returns a boolean indicating whether the given input is a valid Bitcoin Cash address.
 * @static
 * @param {*} input - Any input to check for validity.
 * @returns {boolean}
 */ function $12e5514de6f3daec$var$isValidAddress(input) {
    try {
        $12e5514de6f3daec$var$decodeAddress(input);
        return true;
    } catch (error) {
        return false;
    }
}
/**
 * Detects what is the given address' format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$detectAddressFormat(address) {
    return $12e5514de6f3daec$var$decodeAddress(address).format;
}
/**
 * Detects what is the given address' network.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$detectAddressNetwork(address) {
    return $12e5514de6f3daec$var$decodeAddress(address).network;
}
/**
 * Detects what is the given address' type.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$detectAddressType(address) {
    return $12e5514de6f3daec$var$decodeAddress(address).type;
}
/**
 * Translates the given address into legacy format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$toLegacyAddress(address) {
    var decoded = $12e5514de6f3daec$var$decodeAddress(address);
    if (decoded.format === $12e5514de6f3daec$var$Format.Legacy) return address;
    return $12e5514de6f3daec$var$encodeAsLegacy(decoded);
}
/**
 * Translates the given address into bitpay format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$toBitpayAddress(address) {
    var decoded = $12e5514de6f3daec$var$decodeAddress(address);
    if (decoded.format === $12e5514de6f3daec$var$Format.Bitpay) return address;
    return $12e5514de6f3daec$var$encodeAsBitpay(decoded);
}
/**
 * Translates the given address into cashaddr format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {string}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$toCashAddress(address) {
    var decoded = $12e5514de6f3daec$var$decodeAddress(address);
    return $12e5514de6f3daec$var$encodeAsCashaddr(decoded);
}
/**
 * Version byte table for base58 formats.
 * @private
 */ var $12e5514de6f3daec$var$VERSION_BYTE = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Mainnet] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2PKH] = 0;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2SH] = 5;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Testnet] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2PKH] = 111;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2SH] = 196;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Mainnet] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2PKH] = 28;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2SH] = 40;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Testnet] = {};
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2PKH] = 111;
$12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2SH] = 196;
/**
 * Decodes the given address into its constituting hash, format, network and type.
 * @private
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {object}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$decodeAddress(address) {
    try {
        return $12e5514de6f3daec$var$decodeBase58Address(address);
    } catch (error) {}
    try {
        return $12e5514de6f3daec$var$decodeCashAddress(address);
    } catch (error) {}
    throw new $12e5514de6f3daec$var$InvalidAddressError();
}
/**
 * Length of a valid base58check encoding payload: 1 byte for
 * the version byte plus 20 bytes for a RIPEMD-160 hash.
 * @private
 */ var $12e5514de6f3daec$var$BASE_58_CHECK_PAYLOAD_LENGTH = 21;
/**
 * Attempts to decode the given address assuming it is a base58 address.
 * @private
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {object}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$decodeBase58Address(address) {
    try {
        var payload = $1Vf4C.decode(address);
        if (payload.length !== $12e5514de6f3daec$var$BASE_58_CHECK_PAYLOAD_LENGTH) throw new $12e5514de6f3daec$var$InvalidAddressError();
        var versionByte = payload[0];
        var hash = Array.prototype.slice.call(payload, 1);
        switch(versionByte){
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2PKH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Legacy,
                    network: $12e5514de6f3daec$var$Network.Mainnet,
                    type: $12e5514de6f3daec$var$Type.P2PKH
                };
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2SH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Legacy,
                    network: $12e5514de6f3daec$var$Network.Mainnet,
                    type: $12e5514de6f3daec$var$Type.P2SH
                };
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2PKH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Legacy,
                    network: $12e5514de6f3daec$var$Network.Testnet,
                    type: $12e5514de6f3daec$var$Type.P2PKH
                };
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][$12e5514de6f3daec$var$Network.Testnet][$12e5514de6f3daec$var$Type.P2SH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Legacy,
                    network: $12e5514de6f3daec$var$Network.Testnet,
                    type: $12e5514de6f3daec$var$Type.P2SH
                };
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2PKH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Bitpay,
                    network: $12e5514de6f3daec$var$Network.Mainnet,
                    type: $12e5514de6f3daec$var$Type.P2PKH
                };
            case $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][$12e5514de6f3daec$var$Network.Mainnet][$12e5514de6f3daec$var$Type.P2SH]:
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Bitpay,
                    network: $12e5514de6f3daec$var$Network.Mainnet,
                    type: $12e5514de6f3daec$var$Type.P2SH
                };
        }
    } catch (error) {}
    throw new $12e5514de6f3daec$var$InvalidAddressError();
}
/**
 * Attempts to decode the given address assuming it is a cashaddr address.
 * @private
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {object}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$decodeCashAddress(address) {
    if (address.indexOf(":") !== -1) try {
        return $12e5514de6f3daec$var$decodeCashAddressWithPrefix(address);
    } catch (error) {}
    else {
        var prefixes = [
            "bitcoincash",
            "bchtest",
            "bchreg"
        ];
        for(var i = 0; i < prefixes.length; ++i)try {
            var prefix = prefixes[i];
            return $12e5514de6f3daec$var$decodeCashAddressWithPrefix(prefix + ":" + address);
        } catch (error) {}
    }
    throw new $12e5514de6f3daec$var$InvalidAddressError();
}
/**
 * Attempts to decode the given address assuming it is a cashaddr address with explicit prefix.
 * @private
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @return {object}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$decodeCashAddressWithPrefix(address) {
    try {
        var decoded = $1TIhD.decode(address);
        var hash = Array.prototype.slice.call(decoded.hash, 0);
        var type = decoded.type === "P2PKH" ? $12e5514de6f3daec$var$Type.P2PKH : $12e5514de6f3daec$var$Type.P2SH;
        switch(decoded.prefix){
            case "bitcoincash":
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Cashaddr,
                    network: $12e5514de6f3daec$var$Network.Mainnet,
                    type: type
                };
            case "bchtest":
            case "bchreg":
                return {
                    hash: hash,
                    format: $12e5514de6f3daec$var$Format.Cashaddr,
                    network: $12e5514de6f3daec$var$Network.Testnet,
                    type: type
                };
        }
    } catch (error) {}
    throw new $12e5514de6f3daec$var$InvalidAddressError();
}
/**
 * Encodes the given decoded address into legacy format.
 * @private
 * @param {object} decoded
 * @returns {string}
 */ function $12e5514de6f3daec$var$encodeAsLegacy(decoded) {
    var versionByte = $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Legacy][decoded.network][decoded.type];
    var buffer = $12e5514de6f3daec$require$Buffer.alloc(1 + decoded.hash.length);
    buffer[0] = versionByte;
    buffer.set(decoded.hash, 1);
    return $1Vf4C.encode(buffer);
}
/**
 * Encodes the given decoded address into bitpay format.
 * @private
 * @param {object} decoded
 * @returns {string}
 */ function $12e5514de6f3daec$var$encodeAsBitpay(decoded) {
    var versionByte = $12e5514de6f3daec$var$VERSION_BYTE[$12e5514de6f3daec$var$Format.Bitpay][decoded.network][decoded.type];
    var buffer = $12e5514de6f3daec$require$Buffer.alloc(1 + decoded.hash.length);
    buffer[0] = versionByte;
    buffer.set(decoded.hash, 1);
    return $1Vf4C.encode(buffer);
}
/**
 * Encodes the given decoded address into cashaddr format.
 * @private
 * @param {object} decoded
 * @returns {string}
 */ function $12e5514de6f3daec$var$encodeAsCashaddr(decoded) {
    var prefix = decoded.network === $12e5514de6f3daec$var$Network.Mainnet ? "bitcoincash" : "bchtest";
    var type = decoded.type === $12e5514de6f3daec$var$Type.P2PKH ? "P2PKH" : "P2SH";
    var hash = new Uint8Array(decoded.hash);
    return $1TIhD.encode(prefix, type, hash);
}
/**
 * Returns a boolean indicating whether the address is in legacy format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isLegacyAddress(address) {
    return $12e5514de6f3daec$var$detectAddressFormat(address) === $12e5514de6f3daec$var$Format.Legacy;
}
/**
 * Returns a boolean indicating whether the address is in bitpay format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isBitpayAddress(address) {
    return $12e5514de6f3daec$var$detectAddressFormat(address) === $12e5514de6f3daec$var$Format.Bitpay;
}
/**
 * Returns a boolean indicating whether the address is in cashaddr format.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isCashAddress(address) {
    return $12e5514de6f3daec$var$detectAddressFormat(address) === $12e5514de6f3daec$var$Format.Cashaddr;
}
/**
 * Returns a boolean indicating whether the address is a mainnet address.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isMainnetAddress(address) {
    return $12e5514de6f3daec$var$detectAddressNetwork(address) === $12e5514de6f3daec$var$Network.Mainnet;
}
/**
 * Returns a boolean indicating whether the address is a testnet address.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isTestnetAddress(address) {
    return $12e5514de6f3daec$var$detectAddressNetwork(address) === $12e5514de6f3daec$var$Network.Testnet;
}
/**
 * Returns a boolean indicating whether the address is a p2pkh address.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isP2PKHAddress(address) {
    return $12e5514de6f3daec$var$detectAddressType(address) === $12e5514de6f3daec$var$Type.P2PKH;
}
/**
 * Returns a boolean indicating whether the address is a p2sh address.
 * @static
 * @param {string} address - A valid Bitcoin Cash address in any format.
 * @returns {boolean}
 * @throws {InvalidAddressError}
 */ function $12e5514de6f3daec$var$isP2SHAddress(address) {
    return $12e5514de6f3daec$var$detectAddressType(address) === $12e5514de6f3daec$var$Type.P2SH;
}
/**
 * Error thrown when the address given as input is not a valid Bitcoin Cash address.
 * @constructor
 * InvalidAddressError
 */ function $12e5514de6f3daec$var$InvalidAddressError() {
    var error = new Error();
    this.name = error.name = "InvalidAddressError";
    this.message = error.message = "Received an invalid Bitcoin Cash address as input.";
    this.stack = error.stack;
}
$12e5514de6f3daec$var$InvalidAddressError.prototype = Object.create(Error.prototype);
module.exports = {
    Format: $12e5514de6f3daec$var$Format,
    Network: $12e5514de6f3daec$var$Network,
    Type: $12e5514de6f3daec$var$Type,
    isValidAddress: $12e5514de6f3daec$var$isValidAddress,
    detectAddressFormat: $12e5514de6f3daec$var$detectAddressFormat,
    detectAddressNetwork: $12e5514de6f3daec$var$detectAddressNetwork,
    detectAddressType: $12e5514de6f3daec$var$detectAddressType,
    toLegacyAddress: $12e5514de6f3daec$var$toLegacyAddress,
    toBitpayAddress: $12e5514de6f3daec$var$toBitpayAddress,
    toCashAddress: $12e5514de6f3daec$var$toCashAddress,
    isLegacyAddress: $12e5514de6f3daec$var$isLegacyAddress,
    isBitpayAddress: $12e5514de6f3daec$var$isBitpayAddress,
    isCashAddress: $12e5514de6f3daec$var$isCashAddress,
    isMainnetAddress: $12e5514de6f3daec$var$isMainnetAddress,
    isTestnetAddress: $12e5514de6f3daec$var$isTestnetAddress,
    isP2PKHAddress: $12e5514de6f3daec$var$isP2PKHAddress,
    isP2SHAddress: $12e5514de6f3daec$var$isP2SHAddress,
    InvalidAddressError: $12e5514de6f3daec$var$InvalidAddressError
};

});
parcelRegister("1TIhD", function(module, exports) {
/**
 * @license
 * https://github.com/ealmansi/cashaddrjs
 * Copyright (c) 2017-2020 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ "use strict";

var $7B8me = parcelRequire("7B8me");

var $fXIoB = parcelRequire("fXIoB");

var $9epC7 = parcelRequire("9epC7");

var $eap7I = parcelRequire("eap7I");
var $161d4743991dd30b$var$validate = $eap7I.validate;
/**
 * Encoding and decoding of the new Cash Address format for Bitcoin Cash. <br />
 * Compliant with the original cashaddr specification:
 * {@link https://github.com/Bitcoin-UAHF/spec/blob/master/cashaddr.md}
 * @module cashaddr
 */ /**
 * Encodes a hash from a given type into a Bitcoin Cash address with the given prefix.
 * 
 * @static
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'.
 * @param {string} type Type of address to generate. Either 'P2PKH' or 'P2SH'.
 * @param {Uint8Array} hash Hash to encode represented as an array of 8-bit integers.
 * @returns {string}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$encode(prefix, type, hash) {
    $161d4743991dd30b$var$validate(typeof prefix === "string" && $161d4743991dd30b$var$isValidPrefix(prefix), "Invalid prefix: " + prefix + ".");
    $161d4743991dd30b$var$validate(typeof type === "string", "Invalid type: " + type + ".");
    $161d4743991dd30b$var$validate(hash instanceof Uint8Array, "Invalid hash: " + hash + ".");
    var prefixData = $161d4743991dd30b$var$concat($161d4743991dd30b$var$prefixToUint5Array(prefix), new Uint8Array(1));
    var versionByte = $161d4743991dd30b$var$getTypeBits(type) + $161d4743991dd30b$var$getHashSizeBits(hash);
    var payloadData = $161d4743991dd30b$var$toUint5Array($161d4743991dd30b$var$concat(new Uint8Array([
        versionByte
    ]), hash));
    var checksumData = $161d4743991dd30b$var$concat($161d4743991dd30b$var$concat(prefixData, payloadData), new Uint8Array(8));
    var payload = $161d4743991dd30b$var$concat(payloadData, $161d4743991dd30b$var$checksumToUint5Array($161d4743991dd30b$var$polymod(checksumData)));
    return prefix + ":" + $7B8me.encode(payload);
}
/**
 * Decodes the given address into its constituting prefix, type and hash. See [#encode()]{@link encode}.
 * 
 * @static
 * @param {string} address Address to decode. E.g.: 'bitcoincash:qpm2qsznhks23z7629mms6s4cwef74vcwvy22gdx6a'.
 * @returns {object}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$decode(address) {
    $161d4743991dd30b$var$validate(typeof address === "string" && $161d4743991dd30b$var$hasSingleCase(address), "Invalid address: " + address + ".");
    var pieces = address.toLowerCase().split(":");
    $161d4743991dd30b$var$validate(pieces.length === 2, "Missing prefix: " + address + ".");
    var prefix = pieces[0];
    var payload = $7B8me.decode(pieces[1]);
    $161d4743991dd30b$var$validate($161d4743991dd30b$var$validChecksum(prefix, payload), "Invalid checksum: " + address + ".");
    var payloadData = $161d4743991dd30b$var$fromUint5Array(payload.subarray(0, -8));
    var versionByte = payloadData[0];
    var hash = payloadData.subarray(1);
    $161d4743991dd30b$var$validate($161d4743991dd30b$var$getHashSize(versionByte) === hash.length * 8, "Invalid hash size: " + address + ".");
    var type = $161d4743991dd30b$var$getType(versionByte);
    return {
        prefix: prefix,
        type: type,
        hash: hash
    };
}
/**
 * Error thrown when encoding or decoding fail due to invalid input.
 *
 * @constructor ValidationError
 * @param {string} message Error description.
 */ var $161d4743991dd30b$var$ValidationError = $eap7I.ValidationError;
/**
 * Valid address prefixes.
 *
 * @private
 */ var $161d4743991dd30b$var$VALID_PREFIXES = [
    "bitcoincash",
    "bchtest",
    "bchreg"
];
/**
 * Checks whether a string is a valid prefix; ie., it has a single letter case
 * and is one of 'bitcoincash', 'bchtest', or 'bchreg'.
 *
 * @private
 * @param {string} prefix 
 * @returns {boolean}
 */ function $161d4743991dd30b$var$isValidPrefix(prefix) {
    return $161d4743991dd30b$var$hasSingleCase(prefix) && $161d4743991dd30b$var$VALID_PREFIXES.indexOf(prefix.toLowerCase()) !== -1;
}
/**
 * Derives an array from the given prefix to be used in the computation
 * of the address' checksum.
 *
 * @private
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'. 
 * @returns {Uint8Array}
 */ function $161d4743991dd30b$var$prefixToUint5Array(prefix) {
    var result = new Uint8Array(prefix.length);
    for(var i = 0; i < prefix.length; ++i)result[i] = prefix[i].charCodeAt(0) & 31;
    return result;
}
/**
 * Returns an array representation of the given checksum to be encoded
 * within the address' payload.
 *
 * @private
 * @param {BigInteger} checksum Computed checksum.
 * @returns {Uint8Array}
 */ function $161d4743991dd30b$var$checksumToUint5Array(checksum) {
    var result = new Uint8Array(8);
    for(var i = 0; i < 8; ++i){
        result[7 - i] = checksum.and(31).toJSNumber();
        checksum = checksum.shiftRight(5);
    }
    return result;
}
/**
 * Returns the bit representation of the given type within the version
 * byte.
 *
 * @private
 * @param {string} type Address type. Either 'P2PKH' or 'P2SH'.
 * @returns {number}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$getTypeBits(type) {
    switch(type){
        case "P2PKH":
            return 0;
        case "P2SH":
            return 8;
        default:
            throw new $161d4743991dd30b$var$ValidationError("Invalid type: " + type + ".");
    }
}
/**
 * Retrieves the address type from its bit representation within the
 * version byte.
 *
 * @private
 * @param {number} versionByte
 * @returns {string}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$getType(versionByte) {
    switch(versionByte & 120){
        case 0:
            return "P2PKH";
        case 8:
            return "P2SH";
        default:
            throw new $161d4743991dd30b$var$ValidationError("Invalid address type in version byte: " + versionByte + ".");
    }
}
/**
 * Returns the bit representation of the length in bits of the given
 * hash within the version byte.
 *
 * @private
 * @param {Uint8Array} hash Hash to encode represented as an array of 8-bit integers.
 * @returns {number}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$getHashSizeBits(hash) {
    switch(hash.length * 8){
        case 160:
            return 0;
        case 192:
            return 1;
        case 224:
            return 2;
        case 256:
            return 3;
        case 320:
            return 4;
        case 384:
            return 5;
        case 448:
            return 6;
        case 512:
            return 7;
        default:
            throw new $161d4743991dd30b$var$ValidationError("Invalid hash size: " + hash.length + ".");
    }
}
/**
 * Retrieves the the length in bits of the encoded hash from its bit
 * representation within the version byte.
 *
 * @private
 * @param {number} versionByte
 * @returns {number}
 */ function $161d4743991dd30b$var$getHashSize(versionByte) {
    switch(versionByte & 7){
        case 0:
            return 160;
        case 1:
            return 192;
        case 2:
            return 224;
        case 3:
            return 256;
        case 4:
            return 320;
        case 5:
            return 384;
        case 6:
            return 448;
        case 7:
            return 512;
    }
}
/**
 * Converts an array of 8-bit integers into an array of 5-bit integers,
 * right-padding with zeroes if necessary.
 *
 * @private
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 */ function $161d4743991dd30b$var$toUint5Array(data) {
    return $9epC7(data, 8, 5);
}
/**
 * Converts an array of 5-bit integers back into an array of 8-bit integers,
 * removing extra zeroes left from padding if necessary.
 * Throws a {@link ValidationError} if input is not a zero-padded array of 8-bit integers.
 *
 * @private
 * @param {Uint8Array} data
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$fromUint5Array(data) {
    return $9epC7(data, 5, 8, true);
}
/**
 * Returns the concatenation a and b.
 *
 * @private
 * @param {Uint8Array} a 
 * @param {Uint8Array} b 
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $161d4743991dd30b$var$concat(a, b) {
    var ab = new Uint8Array(a.length + b.length);
    ab.set(a);
    ab.set(b, a.length);
    return ab;
}
/**
 * Computes a checksum from the given input data as specified for the CashAddr
 * format: https://github.com/Bitcoin-UAHF/spec/blob/master/cashaddr.md.
 *
 * @private
 * @param {Uint8Array} data Array of 5-bit integers over which the checksum is to be computed.
 * @returns {BigInteger}
 */ function $161d4743991dd30b$var$polymod(data) {
    var GENERATOR = [
        0x98f2bc8e61,
        0x79b76d99e2,
        0xf33e5fb3c4,
        0xae2eabe2a8,
        0x1e4f43e470
    ];
    var checksum = $fXIoB(1);
    for(var i = 0; i < data.length; ++i){
        var value = data[i];
        var topBits = checksum.shiftRight(35);
        checksum = checksum.and(0x07ffffffff).shiftLeft(5).xor(value);
        for(var j = 0; j < GENERATOR.length; ++j)if (topBits.shiftRight(j).and(1).equals(1)) checksum = checksum.xor(GENERATOR[j]);
    }
    return checksum.xor(1);
}
/**
 * Verify that the payload has not been corrupted by checking that the
 * checksum is valid.
 * 
 * @private
 * @param {string} prefix Network prefix. E.g.: 'bitcoincash'.
 * @param {Uint8Array} payload Array of 5-bit integers containing the address' payload.
 * @returns {boolean}
 */ function $161d4743991dd30b$var$validChecksum(prefix, payload) {
    var prefixData = $161d4743991dd30b$var$concat($161d4743991dd30b$var$prefixToUint5Array(prefix), new Uint8Array(1));
    var checksumData = $161d4743991dd30b$var$concat(prefixData, payload);
    return $161d4743991dd30b$var$polymod(checksumData).equals(0);
}
/**
 * Returns true if, and only if, the given string contains either uppercase
 * or lowercase letters, but not both.
 *
 * @private
 * @param {string} string Input string.
 * @returns {boolean}
 */ function $161d4743991dd30b$var$hasSingleCase(string) {
    return string === string.toLowerCase() || string === string.toUpperCase();
}
module.exports = {
    encode: $161d4743991dd30b$var$encode,
    decode: $161d4743991dd30b$var$decode,
    ValidationError: $161d4743991dd30b$var$ValidationError
};

});
parcelRegister("7B8me", function(module, exports) {
/**
 * @license
 * https://github.com/ealmansi/cashaddrjs
 * Copyright (c) 2017-2020 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ "use strict";

var $eap7I = parcelRequire("eap7I");
var $588278c47cebdc0c$require$validate = $eap7I.validate;
/**
 * Base32 encoding and decoding.
 *
 * @module base32
 */ /**
 * Charset containing the 32 symbols used in the base32 encoding.
 * @private
 */ var $588278c47cebdc0c$var$CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
/**
 * Inverted index mapping each symbol into its index within the charset.
 * @private
 */ var $588278c47cebdc0c$var$CHARSET_INVERSE_INDEX = {
    "q": 0,
    "p": 1,
    "z": 2,
    "r": 3,
    "y": 4,
    "9": 5,
    "x": 6,
    "8": 7,
    "g": 8,
    "f": 9,
    "2": 10,
    "t": 11,
    "v": 12,
    "d": 13,
    "w": 14,
    "0": 15,
    "s": 16,
    "3": 17,
    "j": 18,
    "n": 19,
    "5": 20,
    "4": 21,
    "k": 22,
    "h": 23,
    "c": 24,
    "e": 25,
    "6": 26,
    "m": 27,
    "u": 28,
    "a": 29,
    "7": 30,
    "l": 31
};
/**
 * Encodes the given array of 5-bit integers as a base32-encoded string.
 *
 * @static
 * @param {Uint8Array} data Array of integers between 0 and 31 inclusive.
 * @returns {string}
 * @throws {ValidationError}
 */ function $588278c47cebdc0c$var$encode(data) {
    $588278c47cebdc0c$require$validate(data instanceof Uint8Array, "Invalid data: " + data + ".");
    var base32 = "";
    for(var i = 0; i < data.length; ++i){
        var value = data[i];
        $588278c47cebdc0c$require$validate(0 <= value && value < 32, "Invalid value: " + value + ".");
        base32 += $588278c47cebdc0c$var$CHARSET[value];
    }
    return base32;
}
/**
 * Decodes the given base32-encoded string into an array of 5-bit integers.
 *
 * @static
 * @param {string} string
 * @returns {Uint8Array}
 * @throws {ValidationError}
 */ function $588278c47cebdc0c$var$decode(string) {
    $588278c47cebdc0c$require$validate(typeof string === "string", "Invalid base32-encoded string: " + string + ".");
    var data = new Uint8Array(string.length);
    for(var i = 0; i < string.length; ++i){
        var value = string[i];
        $588278c47cebdc0c$require$validate(value in $588278c47cebdc0c$var$CHARSET_INVERSE_INDEX, "Invalid value: " + value + ".");
        data[i] = $588278c47cebdc0c$var$CHARSET_INVERSE_INDEX[value];
    }
    return data;
}
module.exports = {
    encode: $588278c47cebdc0c$var$encode,
    decode: $588278c47cebdc0c$var$decode
};

});
parcelRegister("eap7I", function(module, exports) {
/**
 * @license
 * https://github.com/ealmansi/cashaddrjs
 * Copyright (c) 2017-2020 Emilio Almansi
 * Distributed under the MIT software license, see the accompanying
 * file LICENSE or http://www.opensource.org/licenses/mit-license.php.
 */ "use strict";
/**
 * Validation utility.
 *
 * @module validation
 */ /**
 * Error thrown when encoding or decoding fail due to invalid input.
 *
 * @constructor ValidationError
 * @param {string} message Error description.
 */ function $a5057ce0467c3f8e$var$ValidationError(message) {
    var error = new Error();
    this.name = error.name = "ValidationError";
    this.message = error.message = message;
    this.stack = error.stack;
}
$a5057ce0467c3f8e$var$ValidationError.prototype = Object.create(Error.prototype);
/**
 * Validates a given condition, throwing a {@link ValidationError} if
 * the given condition does not hold.
 *
 * @static
 * @param {boolean} condition Condition to validate.
 * @param {string} message Error message in case the condition does not hold.
 */ function $a5057ce0467c3f8e$var$validate(condition, message) {
    if (!condition) throw new $a5057ce0467c3f8e$var$ValidationError(message);
}
module.exports = {
    ValidationError: $a5057ce0467c3f8e$var$ValidationError,
    validate: $a5057ce0467c3f8e$var$validate
};

});


parcelRegister("fXIoB", function(module, exports) {
var bigInt = function(undefined) {
    "use strict";
    var BASE = 1e7, LOG_BASE = 7, MAX_INT = 9007199254740992, MAX_INT_ARR = smallToArray(MAX_INT), LOG_MAX_INT = Math.log(MAX_INT);
    function Integer(v, radix) {
        if (typeof v === "undefined") return Integer[0];
        if (typeof radix !== "undefined") return +radix === 10 ? parseValue(v) : parseBase(v, radix);
        return parseValue(v);
    }
    function BigInteger(value, sign) {
        this.value = value;
        this.sign = sign;
        this.isSmall = false;
    }
    BigInteger.prototype = Object.create(Integer.prototype);
    function SmallInteger(value) {
        this.value = value;
        this.sign = value < 0;
        this.isSmall = true;
    }
    SmallInteger.prototype = Object.create(Integer.prototype);
    function isPrecise(n) {
        return -MAX_INT < n && n < MAX_INT;
    }
    function smallToArray(n) {
        if (n < 1e7) return [
            n
        ];
        if (n < 1e14) return [
            n % 1e7,
            Math.floor(n / 1e7)
        ];
        return [
            n % 1e7,
            Math.floor(n / 1e7) % 1e7,
            Math.floor(n / 1e14)
        ];
    }
    function arrayToSmall(arr) {
        trim(arr);
        var length = arr.length;
        if (length < 4 && compareAbs(arr, MAX_INT_ARR) < 0) switch(length){
            case 0:
                return 0;
            case 1:
                return arr[0];
            case 2:
                return arr[0] + arr[1] * BASE;
            default:
                return arr[0] + (arr[1] + arr[2] * BASE) * BASE;
        }
        return arr;
    }
    function trim(v) {
        var i = v.length;
        while(v[--i] === 0);
        v.length = i + 1;
    }
    function createArray(length) {
        var x = new Array(length);
        var i = -1;
        while(++i < length)x[i] = 0;
        return x;
    }
    function truncate(n) {
        if (n > 0) return Math.floor(n);
        return Math.ceil(n);
    }
    function add(a, b) {
        var l_a = a.length, l_b = b.length, r = new Array(l_a), carry = 0, base = BASE, sum, i;
        for(i = 0; i < l_b; i++){
            sum = a[i] + b[i] + carry;
            carry = sum >= base ? 1 : 0;
            r[i] = sum - carry * base;
        }
        while(i < l_a){
            sum = a[i] + carry;
            carry = sum === base ? 1 : 0;
            r[i++] = sum - carry * base;
        }
        if (carry > 0) r.push(carry);
        return r;
    }
    function addAny(a, b) {
        if (a.length >= b.length) return add(a, b);
        return add(b, a);
    }
    function addSmall(a, carry) {
        var l = a.length, r = new Array(l), base = BASE, sum, i;
        for(i = 0; i < l; i++){
            sum = a[i] - base + carry;
            carry = Math.floor(sum / base);
            r[i] = sum - carry * base;
            carry += 1;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    BigInteger.prototype.add = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.subtract(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return new BigInteger(addSmall(a, Math.abs(b)), this.sign);
        return new BigInteger(addAny(a, b), this.sign);
    };
    BigInteger.prototype.plus = BigInteger.prototype.add;
    SmallInteger.prototype.add = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.subtract(n.negate());
        var b = n.value;
        if (n.isSmall) {
            if (isPrecise(a + b)) return new SmallInteger(a + b);
            b = smallToArray(Math.abs(b));
        }
        return new BigInteger(addSmall(b, Math.abs(a)), a < 0);
    };
    SmallInteger.prototype.plus = SmallInteger.prototype.add;
    function subtract(a, b) {
        var a_l = a.length, b_l = b.length, r = new Array(a_l), borrow = 0, base = BASE, i, difference;
        for(i = 0; i < b_l; i++){
            difference = a[i] - borrow - b[i];
            if (difference < 0) {
                difference += base;
                borrow = 1;
            } else borrow = 0;
            r[i] = difference;
        }
        for(i = b_l; i < a_l; i++){
            difference = a[i] - borrow;
            if (difference < 0) difference += base;
            else {
                r[i++] = difference;
                break;
            }
            r[i] = difference;
        }
        for(; i < a_l; i++)r[i] = a[i];
        trim(r);
        return r;
    }
    function subtractAny(a, b, sign) {
        var value;
        if (compareAbs(a, b) >= 0) value = subtract(a, b);
        else {
            value = subtract(b, a);
            sign = !sign;
        }
        value = arrayToSmall(value);
        if (typeof value === "number") {
            if (sign) value = -value;
            return new SmallInteger(value);
        }
        return new BigInteger(value, sign);
    }
    function subtractSmall(a, b, sign) {
        var l = a.length, r = new Array(l), carry = -b, base = BASE, i, difference;
        for(i = 0; i < l; i++){
            difference = a[i] + carry;
            carry = Math.floor(difference / base);
            difference %= base;
            r[i] = difference < 0 ? difference + base : difference;
        }
        r = arrayToSmall(r);
        if (typeof r === "number") {
            if (sign) r = -r;
            return new SmallInteger(r);
        }
        return new BigInteger(r, sign);
    }
    BigInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        if (this.sign !== n.sign) return this.add(n.negate());
        var a = this.value, b = n.value;
        if (n.isSmall) return subtractSmall(a, Math.abs(b), this.sign);
        return subtractAny(a, b, this.sign);
    };
    BigInteger.prototype.minus = BigInteger.prototype.subtract;
    SmallInteger.prototype.subtract = function(v) {
        var n = parseValue(v);
        var a = this.value;
        if (a < 0 !== n.sign) return this.add(n.negate());
        var b = n.value;
        if (n.isSmall) return new SmallInteger(a - b);
        return subtractSmall(b, Math.abs(a), a >= 0);
    };
    SmallInteger.prototype.minus = SmallInteger.prototype.subtract;
    BigInteger.prototype.negate = function() {
        return new BigInteger(this.value, !this.sign);
    };
    SmallInteger.prototype.negate = function() {
        var sign = this.sign;
        var small = new SmallInteger(-this.value);
        small.sign = !sign;
        return small;
    };
    BigInteger.prototype.abs = function() {
        return new BigInteger(this.value, false);
    };
    SmallInteger.prototype.abs = function() {
        return new SmallInteger(Math.abs(this.value));
    };
    function multiplyLong(a, b) {
        var a_l = a.length, b_l = b.length, l = a_l + b_l, r = createArray(l), base = BASE, product, carry, i, a_i, b_j;
        for(i = 0; i < a_l; ++i){
            a_i = a[i];
            for(var j = 0; j < b_l; ++j){
                b_j = b[j];
                product = a_i * b_j + r[i + j];
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
                r[i + j + 1] += carry;
            }
        }
        trim(r);
        return r;
    }
    function multiplySmall(a, b) {
        var l = a.length, r = new Array(l), base = BASE, carry = 0, product, i;
        for(i = 0; i < l; i++){
            product = a[i] * b + carry;
            carry = Math.floor(product / base);
            r[i] = product - carry * base;
        }
        while(carry > 0){
            r[i++] = carry % base;
            carry = Math.floor(carry / base);
        }
        return r;
    }
    function shiftLeft(x, n) {
        var r = [];
        while(n-- > 0)r.push(0);
        return r.concat(x);
    }
    function multiplyKaratsuba(x, y) {
        var n = Math.max(x.length, y.length);
        if (n <= 30) return multiplyLong(x, y);
        n = Math.ceil(n / 2);
        var b = x.slice(n), a = x.slice(0, n), d = y.slice(n), c = y.slice(0, n);
        var ac = multiplyKaratsuba(a, c), bd = multiplyKaratsuba(b, d), abcd = multiplyKaratsuba(addAny(a, b), addAny(c, d));
        var product = addAny(addAny(ac, shiftLeft(subtract(subtract(abcd, ac), bd), n)), shiftLeft(bd, 2 * n));
        trim(product);
        return product;
    }
    // The following function is derived from a surface fit of a graph plotting the performance difference
    // between long multiplication and karatsuba multiplication versus the lengths of the two arrays.
    function useKaratsuba(l1, l2) {
        return -0.012 * l1 - 0.012 * l2 + 0.000015 * l1 * l2 > 0;
    }
    BigInteger.prototype.multiply = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, sign = this.sign !== n.sign, abs;
        if (n.isSmall) {
            if (b === 0) return Integer[0];
            if (b === 1) return this;
            if (b === -1) return this.negate();
            abs = Math.abs(b);
            if (abs < BASE) return new BigInteger(multiplySmall(a, abs), sign);
            b = smallToArray(abs);
        }
        if (useKaratsuba(a.length, b.length)) return new BigInteger(multiplyKaratsuba(a, b), sign);
        return new BigInteger(multiplyLong(a, b), sign);
    };
    BigInteger.prototype.times = BigInteger.prototype.multiply;
    function multiplySmallAndArray(a, b, sign) {
        if (a < BASE) return new BigInteger(multiplySmall(b, a), sign);
        return new BigInteger(multiplyLong(b, smallToArray(a)), sign);
    }
    SmallInteger.prototype._multiplyBySmall = function(a) {
        if (isPrecise(a.value * this.value)) return new SmallInteger(a.value * this.value);
        return multiplySmallAndArray(Math.abs(a.value), smallToArray(Math.abs(this.value)), this.sign !== a.sign);
    };
    BigInteger.prototype._multiplyBySmall = function(a) {
        if (a.value === 0) return Integer[0];
        if (a.value === 1) return this;
        if (a.value === -1) return this.negate();
        return multiplySmallAndArray(Math.abs(a.value), this.value, this.sign !== a.sign);
    };
    SmallInteger.prototype.multiply = function(v) {
        return parseValue(v)._multiplyBySmall(this);
    };
    SmallInteger.prototype.times = SmallInteger.prototype.multiply;
    function square(a) {
        //console.assert(2 * BASE * BASE < MAX_INT);
        var l = a.length, r = createArray(l + l), base = BASE, product, carry, i, a_i, a_j;
        for(i = 0; i < l; i++){
            a_i = a[i];
            carry = 0 - a_i * a_i;
            for(var j = i; j < l; j++){
                a_j = a[j];
                product = 2 * (a_i * a_j) + r[i + j] + carry;
                carry = Math.floor(product / base);
                r[i + j] = product - carry * base;
            }
            r[i + l] = carry;
        }
        trim(r);
        return r;
    }
    BigInteger.prototype.square = function() {
        return new BigInteger(square(this.value), false);
    };
    SmallInteger.prototype.square = function() {
        var value = this.value * this.value;
        if (isPrecise(value)) return new SmallInteger(value);
        return new BigInteger(square(smallToArray(Math.abs(this.value))), false);
    };
    function divMod1(a, b) {
        var a_l = a.length, b_l = b.length, base = BASE, result = createArray(b.length), divisorMostSignificantDigit = b[b_l - 1], // normalization
        lambda = Math.ceil(base / (2 * divisorMostSignificantDigit)), remainder = multiplySmall(a, lambda), divisor = multiplySmall(b, lambda), quotientDigit, shift, carry, borrow, i, l, q;
        if (remainder.length <= a_l) remainder.push(0);
        divisor.push(0);
        divisorMostSignificantDigit = divisor[b_l - 1];
        for(shift = a_l - b_l; shift >= 0; shift--){
            quotientDigit = base - 1;
            if (remainder[shift + b_l] !== divisorMostSignificantDigit) quotientDigit = Math.floor((remainder[shift + b_l] * base + remainder[shift + b_l - 1]) / divisorMostSignificantDigit);
            // quotientDigit <= base - 1
            carry = 0;
            borrow = 0;
            l = divisor.length;
            for(i = 0; i < l; i++){
                carry += quotientDigit * divisor[i];
                q = Math.floor(carry / base);
                borrow += remainder[shift + i] - (carry - q * base);
                carry = q;
                if (borrow < 0) {
                    remainder[shift + i] = borrow + base;
                    borrow = -1;
                } else {
                    remainder[shift + i] = borrow;
                    borrow = 0;
                }
            }
            while(borrow !== 0){
                quotientDigit -= 1;
                carry = 0;
                for(i = 0; i < l; i++){
                    carry += remainder[shift + i] - base + divisor[i];
                    if (carry < 0) {
                        remainder[shift + i] = carry + base;
                        carry = 0;
                    } else {
                        remainder[shift + i] = carry;
                        carry = 1;
                    }
                }
                borrow += carry;
            }
            result[shift] = quotientDigit;
        }
        // denormalization
        remainder = divModSmall(remainder, lambda)[0];
        return [
            arrayToSmall(result),
            arrayToSmall(remainder)
        ];
    }
    function divMod2(a, b) {
        // Performs faster than divMod1 on larger input sizes.
        var a_l = a.length, b_l = b.length, result = [], part = [], base = BASE, guess, xlen, highx, highy, check;
        while(a_l){
            part.unshift(a[--a_l]);
            trim(part);
            if (compareAbs(part, b) < 0) {
                result.push(0);
                continue;
            }
            xlen = part.length;
            highx = part[xlen - 1] * base + part[xlen - 2];
            highy = b[b_l - 1] * base + b[b_l - 2];
            if (xlen > b_l) highx = (highx + 1) * base;
            guess = Math.ceil(highx / highy);
            do {
                check = multiplySmall(b, guess);
                if (compareAbs(check, part) <= 0) break;
                guess--;
            }while (guess);
            result.push(guess);
            part = subtract(part, check);
        }
        result.reverse();
        return [
            arrayToSmall(result),
            arrayToSmall(part)
        ];
    }
    function divModSmall(value, lambda) {
        var length = value.length, quotient = createArray(length), base = BASE, i, q, remainder, divisor;
        remainder = 0;
        for(i = length - 1; i >= 0; --i){
            divisor = remainder * base + value[i];
            q = truncate(divisor / lambda);
            remainder = divisor - q * lambda;
            quotient[i] = q | 0;
        }
        return [
            quotient,
            remainder | 0
        ];
    }
    function divModAny(self, v) {
        var value, n = parseValue(v);
        var a = self.value, b = n.value;
        var quotient;
        if (b === 0) throw new Error("Cannot divide by zero");
        if (self.isSmall) {
            if (n.isSmall) return [
                new SmallInteger(truncate(a / b)),
                new SmallInteger(a % b)
            ];
            return [
                Integer[0],
                self
            ];
        }
        if (n.isSmall) {
            if (b === 1) return [
                self,
                Integer[0]
            ];
            if (b == -1) return [
                self.negate(),
                Integer[0]
            ];
            var abs = Math.abs(b);
            if (abs < BASE) {
                value = divModSmall(a, abs);
                quotient = arrayToSmall(value[0]);
                var remainder = value[1];
                if (self.sign) remainder = -remainder;
                if (typeof quotient === "number") {
                    if (self.sign !== n.sign) quotient = -quotient;
                    return [
                        new SmallInteger(quotient),
                        new SmallInteger(remainder)
                    ];
                }
                return [
                    new BigInteger(quotient, self.sign !== n.sign),
                    new SmallInteger(remainder)
                ];
            }
            b = smallToArray(abs);
        }
        var comparison = compareAbs(a, b);
        if (comparison === -1) return [
            Integer[0],
            self
        ];
        if (comparison === 0) return [
            Integer[self.sign === n.sign ? 1 : -1],
            Integer[0]
        ];
        // divMod1 is faster on smaller input sizes
        if (a.length + b.length <= 200) value = divMod1(a, b);
        else value = divMod2(a, b);
        quotient = value[0];
        var qSign = self.sign !== n.sign, mod = value[1], mSign = self.sign;
        if (typeof quotient === "number") {
            if (qSign) quotient = -quotient;
            quotient = new SmallInteger(quotient);
        } else quotient = new BigInteger(quotient, qSign);
        if (typeof mod === "number") {
            if (mSign) mod = -mod;
            mod = new SmallInteger(mod);
        } else mod = new BigInteger(mod, mSign);
        return [
            quotient,
            mod
        ];
    }
    BigInteger.prototype.divmod = function(v) {
        var result = divModAny(this, v);
        return {
            quotient: result[0],
            remainder: result[1]
        };
    };
    SmallInteger.prototype.divmod = BigInteger.prototype.divmod;
    BigInteger.prototype.divide = function(v) {
        return divModAny(this, v)[0];
    };
    SmallInteger.prototype.over = SmallInteger.prototype.divide = BigInteger.prototype.over = BigInteger.prototype.divide;
    BigInteger.prototype.mod = function(v) {
        return divModAny(this, v)[1];
    };
    SmallInteger.prototype.remainder = SmallInteger.prototype.mod = BigInteger.prototype.remainder = BigInteger.prototype.mod;
    BigInteger.prototype.pow = function(v) {
        var n = parseValue(v), a = this.value, b = n.value, value, x, y;
        if (b === 0) return Integer[1];
        if (a === 0) return Integer[0];
        if (a === 1) return Integer[1];
        if (a === -1) return n.isEven() ? Integer[1] : Integer[-1];
        if (n.sign) return Integer[0];
        if (!n.isSmall) throw new Error("The exponent " + n.toString() + " is too large.");
        if (this.isSmall) {
            if (isPrecise(value = Math.pow(a, b))) return new SmallInteger(truncate(value));
        }
        x = this;
        y = Integer[1];
        while(true){
            if (b & true) {
                y = y.times(x);
                --b;
            }
            if (b === 0) break;
            b /= 2;
            x = x.square();
        }
        return y;
    };
    SmallInteger.prototype.pow = BigInteger.prototype.pow;
    BigInteger.prototype.modPow = function(exp, mod) {
        exp = parseValue(exp);
        mod = parseValue(mod);
        if (mod.isZero()) throw new Error("Cannot take modPow with modulus 0");
        var r = Integer[1], base = this.mod(mod);
        while(exp.isPositive()){
            if (base.isZero()) return Integer[0];
            if (exp.isOdd()) r = r.multiply(base).mod(mod);
            exp = exp.divide(2);
            base = base.square().mod(mod);
        }
        return r;
    };
    SmallInteger.prototype.modPow = BigInteger.prototype.modPow;
    function compareAbs(a, b) {
        if (a.length !== b.length) return a.length > b.length ? 1 : -1;
        for(var i = a.length - 1; i >= 0; i--){
            if (a[i] !== b[i]) return a[i] > b[i] ? 1 : -1;
        }
        return 0;
    }
    BigInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return 1;
        return compareAbs(a, b);
    };
    SmallInteger.prototype.compareAbs = function(v) {
        var n = parseValue(v), a = Math.abs(this.value), b = n.value;
        if (n.isSmall) {
            b = Math.abs(b);
            return a === b ? 0 : a > b ? 1 : -1;
        }
        return -1;
    };
    BigInteger.prototype.compare = function(v) {
        // See discussion about comparison with Infinity:
        // https://github.com/peterolson/BigInteger.js/issues/61
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (this.sign !== n.sign) return n.sign ? 1 : -1;
        if (n.isSmall) return this.sign ? -1 : 1;
        return compareAbs(a, b) * (this.sign ? -1 : 1);
    };
    BigInteger.prototype.compareTo = BigInteger.prototype.compare;
    SmallInteger.prototype.compare = function(v) {
        if (v === Infinity) return -1;
        if (v === -Infinity) return 1;
        var n = parseValue(v), a = this.value, b = n.value;
        if (n.isSmall) return a == b ? 0 : a > b ? 1 : -1;
        if (a < 0 !== n.sign) return a < 0 ? -1 : 1;
        return a < 0 ? 1 : -1;
    };
    SmallInteger.prototype.compareTo = SmallInteger.prototype.compare;
    BigInteger.prototype.equals = function(v) {
        return this.compare(v) === 0;
    };
    SmallInteger.prototype.eq = SmallInteger.prototype.equals = BigInteger.prototype.eq = BigInteger.prototype.equals;
    BigInteger.prototype.notEquals = function(v) {
        return this.compare(v) !== 0;
    };
    SmallInteger.prototype.neq = SmallInteger.prototype.notEquals = BigInteger.prototype.neq = BigInteger.prototype.notEquals;
    BigInteger.prototype.greater = function(v) {
        return this.compare(v) > 0;
    };
    SmallInteger.prototype.gt = SmallInteger.prototype.greater = BigInteger.prototype.gt = BigInteger.prototype.greater;
    BigInteger.prototype.lesser = function(v) {
        return this.compare(v) < 0;
    };
    SmallInteger.prototype.lt = SmallInteger.prototype.lesser = BigInteger.prototype.lt = BigInteger.prototype.lesser;
    BigInteger.prototype.greaterOrEquals = function(v) {
        return this.compare(v) >= 0;
    };
    SmallInteger.prototype.geq = SmallInteger.prototype.greaterOrEquals = BigInteger.prototype.geq = BigInteger.prototype.greaterOrEquals;
    BigInteger.prototype.lesserOrEquals = function(v) {
        return this.compare(v) <= 0;
    };
    SmallInteger.prototype.leq = SmallInteger.prototype.lesserOrEquals = BigInteger.prototype.leq = BigInteger.prototype.lesserOrEquals;
    BigInteger.prototype.isEven = function() {
        return (this.value[0] & 1) === 0;
    };
    SmallInteger.prototype.isEven = function() {
        return (this.value & 1) === 0;
    };
    BigInteger.prototype.isOdd = function() {
        return (this.value[0] & 1) === 1;
    };
    SmallInteger.prototype.isOdd = function() {
        return (this.value & 1) === 1;
    };
    BigInteger.prototype.isPositive = function() {
        return !this.sign;
    };
    SmallInteger.prototype.isPositive = function() {
        return this.value > 0;
    };
    BigInteger.prototype.isNegative = function() {
        return this.sign;
    };
    SmallInteger.prototype.isNegative = function() {
        return this.value < 0;
    };
    BigInteger.prototype.isUnit = function() {
        return false;
    };
    SmallInteger.prototype.isUnit = function() {
        return Math.abs(this.value) === 1;
    };
    BigInteger.prototype.isZero = function() {
        return false;
    };
    SmallInteger.prototype.isZero = function() {
        return this.value === 0;
    };
    BigInteger.prototype.isDivisibleBy = function(v) {
        var n = parseValue(v);
        var value = n.value;
        if (value === 0) return false;
        if (value === 1) return true;
        if (value === 2) return this.isEven();
        return this.mod(n).equals(Integer[0]);
    };
    SmallInteger.prototype.isDivisibleBy = BigInteger.prototype.isDivisibleBy;
    function isBasicPrime(v) {
        var n = v.abs();
        if (n.isUnit()) return false;
        if (n.equals(2) || n.equals(3) || n.equals(5)) return true;
        if (n.isEven() || n.isDivisibleBy(3) || n.isDivisibleBy(5)) return false;
        if (n.lesser(49)) return true;
    // we don't know if it's prime: let the other functions figure it out
    }
    function millerRabinTest(n, a) {
        var nPrev = n.prev(), b = nPrev, r = 0, d, t, i, x;
        while(b.isEven())b = b.divide(2), r++;
        next: for(i = 0; i < a.length; i++){
            if (n.lesser(a[i])) continue;
            x = bigInt(a[i]).modPow(b, n);
            if (x.equals(Integer[1]) || x.equals(nPrev)) continue;
            for(d = r - 1; d != 0; d--){
                x = x.square().mod(n);
                if (x.isUnit()) return false;
                if (x.equals(nPrev)) continue next;
            }
            return false;
        }
        return true;
    }
    // Set "strict" to true to force GRH-supported lower bound of 2*log(N)^2
    BigInteger.prototype.isPrime = function(strict) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var bits = n.bitLength();
        if (bits <= 64) return millerRabinTest(n, [
            2,
            325,
            9375,
            28178,
            450775,
            9780504,
            1795265022
        ]);
        var logN = Math.log(2) * bits;
        var t = Math.ceil(strict === true ? 2 * Math.pow(logN, 2) : logN);
        for(var a = [], i = 0; i < t; i++)a.push(bigInt(i + 2));
        return millerRabinTest(n, a);
    };
    SmallInteger.prototype.isPrime = BigInteger.prototype.isPrime;
    BigInteger.prototype.isProbablePrime = function(iterations) {
        var isPrime = isBasicPrime(this);
        if (isPrime !== undefined) return isPrime;
        var n = this.abs();
        var t = iterations === undefined ? 5 : iterations;
        for(var a = [], i = 0; i < t; i++)a.push(bigInt.randBetween(2, n.minus(2)));
        return millerRabinTest(n, a);
    };
    SmallInteger.prototype.isProbablePrime = BigInteger.prototype.isProbablePrime;
    BigInteger.prototype.modInv = function(n) {
        var t = bigInt.zero, newT = bigInt.one, r = parseValue(n), newR = this.abs(), q, lastT, lastR;
        while(!newR.equals(bigInt.zero)){
            q = r.divide(newR);
            lastT = t;
            lastR = r;
            t = newT;
            r = newR;
            newT = lastT.subtract(q.multiply(newT));
            newR = lastR.subtract(q.multiply(newR));
        }
        if (!r.equals(1)) throw new Error(this.toString() + " and " + n.toString() + " are not co-prime");
        if (t.compare(0) === -1) t = t.add(n);
        if (this.isNegative()) return t.negate();
        return t;
    };
    SmallInteger.prototype.modInv = BigInteger.prototype.modInv;
    BigInteger.prototype.next = function() {
        var value = this.value;
        if (this.sign) return subtractSmall(value, 1, this.sign);
        return new BigInteger(addSmall(value, 1), this.sign);
    };
    SmallInteger.prototype.next = function() {
        var value = this.value;
        if (value + 1 < MAX_INT) return new SmallInteger(value + 1);
        return new BigInteger(MAX_INT_ARR, false);
    };
    BigInteger.prototype.prev = function() {
        var value = this.value;
        if (this.sign) return new BigInteger(addSmall(value, 1), true);
        return subtractSmall(value, 1, this.sign);
    };
    SmallInteger.prototype.prev = function() {
        var value = this.value;
        if (value - 1 > -MAX_INT) return new SmallInteger(value - 1);
        return new BigInteger(MAX_INT_ARR, true);
    };
    var powersOfTwo = [
        1
    ];
    while(2 * powersOfTwo[powersOfTwo.length - 1] <= BASE)powersOfTwo.push(2 * powersOfTwo[powersOfTwo.length - 1]);
    var powers2Length = powersOfTwo.length, highestPower2 = powersOfTwo[powers2Length - 1];
    function shift_isSmall(n) {
        return (typeof n === "number" || typeof n === "string") && +Math.abs(n) <= BASE || n instanceof BigInteger && n.value.length <= 1;
    }
    BigInteger.prototype.shiftLeft = function(n) {
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        n = +n;
        if (n < 0) return this.shiftRight(-n);
        var result = this;
        if (result.isZero()) return result;
        while(n >= powers2Length){
            result = result.multiply(highestPower2);
            n -= powers2Length - 1;
        }
        return result.multiply(powersOfTwo[n]);
    };
    SmallInteger.prototype.shiftLeft = BigInteger.prototype.shiftLeft;
    BigInteger.prototype.shiftRight = function(n) {
        var remQuo;
        if (!shift_isSmall(n)) throw new Error(String(n) + " is too large for shifting.");
        n = +n;
        if (n < 0) return this.shiftLeft(-n);
        var result = this;
        while(n >= powers2Length){
            if (result.isZero() || result.isNegative() && result.isUnit()) return result;
            remQuo = divModAny(result, highestPower2);
            result = remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
            n -= powers2Length - 1;
        }
        remQuo = divModAny(result, powersOfTwo[n]);
        return remQuo[1].isNegative() ? remQuo[0].prev() : remQuo[0];
    };
    SmallInteger.prototype.shiftRight = BigInteger.prototype.shiftRight;
    function bitwise(x, y, fn) {
        y = parseValue(y);
        var xSign = x.isNegative(), ySign = y.isNegative();
        var xRem = xSign ? x.not() : x, yRem = ySign ? y.not() : y;
        var xDigit = 0, yDigit = 0;
        var xDivMod = null, yDivMod = null;
        var result = [];
        while(!xRem.isZero() || !yRem.isZero()){
            xDivMod = divModAny(xRem, highestPower2);
            xDigit = xDivMod[1].toJSNumber();
            if (xSign) xDigit = highestPower2 - 1 - xDigit; // two's complement for negative numbers
            yDivMod = divModAny(yRem, highestPower2);
            yDigit = yDivMod[1].toJSNumber();
            if (ySign) yDigit = highestPower2 - 1 - yDigit; // two's complement for negative numbers
            xRem = xDivMod[0];
            yRem = yDivMod[0];
            result.push(fn(xDigit, yDigit));
        }
        var sum = fn(xSign ? 1 : 0, ySign ? 1 : 0) !== 0 ? bigInt(-1) : bigInt(0);
        for(var i = result.length - 1; i >= 0; i -= 1)sum = sum.multiply(highestPower2).add(bigInt(result[i]));
        return sum;
    }
    BigInteger.prototype.not = function() {
        return this.negate().prev();
    };
    SmallInteger.prototype.not = BigInteger.prototype.not;
    BigInteger.prototype.and = function(n) {
        return bitwise(this, n, function(a, b) {
            return a & b;
        });
    };
    SmallInteger.prototype.and = BigInteger.prototype.and;
    BigInteger.prototype.or = function(n) {
        return bitwise(this, n, function(a, b) {
            return a | b;
        });
    };
    SmallInteger.prototype.or = BigInteger.prototype.or;
    BigInteger.prototype.xor = function(n) {
        return bitwise(this, n, function(a, b) {
            return a ^ b;
        });
    };
    SmallInteger.prototype.xor = BigInteger.prototype.xor;
    var LOBMASK_I = 1073741824, LOBMASK_BI = (BASE & -BASE) * (BASE & -BASE) | LOBMASK_I;
    function roughLOB(n) {
        // SmallInteger: return Min(lowestOneBit(n), 1 << 30)
        // BigInteger: return Min(lowestOneBit(n), 1 << 14) [BASE=1e7]
        var v = n.value, x = typeof v === "number" ? v | LOBMASK_I : v[0] + v[1] * BASE | LOBMASK_BI;
        return x & -x;
    }
    function integerLogarithm(value, base) {
        if (base.compareTo(value) <= 0) {
            var tmp = integerLogarithm(value, base.square(base));
            var p = tmp.p;
            var e = tmp.e;
            var t = p.multiply(base);
            return t.compareTo(value) <= 0 ? {
                p: t,
                e: e * 2 + 1
            } : {
                p: p,
                e: e * 2
            };
        }
        return {
            p: bigInt(1),
            e: 0
        };
    }
    BigInteger.prototype.bitLength = function() {
        var n = this;
        if (n.compareTo(bigInt(0)) < 0) n = n.negate().subtract(bigInt(1));
        if (n.compareTo(bigInt(0)) === 0) return bigInt(0);
        return bigInt(integerLogarithm(n, bigInt(2)).e).add(bigInt(1));
    };
    SmallInteger.prototype.bitLength = BigInteger.prototype.bitLength;
    function max(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.greater(b) ? a : b;
    }
    function min(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        return a.lesser(b) ? a : b;
    }
    function gcd(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        if (a.equals(b)) return a;
        if (a.isZero()) return b;
        if (b.isZero()) return a;
        var c = Integer[1], d, t;
        while(a.isEven() && b.isEven()){
            d = Math.min(roughLOB(a), roughLOB(b));
            a = a.divide(d);
            b = b.divide(d);
            c = c.multiply(d);
        }
        while(a.isEven())a = a.divide(roughLOB(a));
        do {
            while(b.isEven())b = b.divide(roughLOB(b));
            if (a.greater(b)) {
                t = b;
                b = a;
                a = t;
            }
            b = b.subtract(a);
        }while (!b.isZero());
        return c.isUnit() ? a : a.multiply(c);
    }
    function lcm(a, b) {
        a = parseValue(a).abs();
        b = parseValue(b).abs();
        return a.divide(gcd(a, b)).multiply(b);
    }
    function randBetween(a, b) {
        a = parseValue(a);
        b = parseValue(b);
        var low = min(a, b), high = max(a, b);
        var range = high.subtract(low).add(1);
        if (range.isSmall) return low.add(Math.floor(Math.random() * range));
        var length = range.value.length - 1;
        var result = [], restricted = true;
        for(var i = length; i >= 0; i--){
            var top = restricted ? range.value[i] : BASE;
            var digit = truncate(Math.random() * top);
            result.unshift(digit);
            if (digit < top) restricted = false;
        }
        result = arrayToSmall(result);
        return low.add(typeof result === "number" ? new SmallInteger(result) : new BigInteger(result, false));
    }
    var parseBase = function(text, base) {
        var length = text.length;
        var i;
        var absBase = Math.abs(base);
        for(var i = 0; i < length; i++){
            var c = text[i].toLowerCase();
            if (c === "-") continue;
            if (/[a-z0-9]/.test(c)) {
                if (/[0-9]/.test(c) && +c >= absBase) {
                    if (c === "1" && absBase === 1) continue;
                    throw new Error(c + " is not a valid digit in base " + base + ".");
                } else if (c.charCodeAt(0) - 87 >= absBase) throw new Error(c + " is not a valid digit in base " + base + ".");
            }
        }
        if (2 <= base && base <= 36) {
            if (length <= LOG_MAX_INT / Math.log(base)) {
                var result = parseInt(text, base);
                if (isNaN(result)) throw new Error(c + " is not a valid digit in base " + base + ".");
                return new SmallInteger(parseInt(text, base));
            }
        }
        base = parseValue(base);
        var digits = [];
        var isNegative = text[0] === "-";
        for(i = isNegative ? 1 : 0; i < text.length; i++){
            var c = text[i].toLowerCase(), charCode = c.charCodeAt(0);
            if (48 <= charCode && charCode <= 57) digits.push(parseValue(c));
            else if (97 <= charCode && charCode <= 122) digits.push(parseValue(c.charCodeAt(0) - 87));
            else if (c === "<") {
                var start = i;
                do i++;
                while (text[i] !== ">");
                digits.push(parseValue(text.slice(start + 1, i)));
            } else throw new Error(c + " is not a valid character");
        }
        return parseBaseFromArray(digits, base, isNegative);
    };
    function parseBaseFromArray(digits, base, isNegative) {
        var val = Integer[0], pow = Integer[1], i;
        for(i = digits.length - 1; i >= 0; i--){
            val = val.add(digits[i].times(pow));
            pow = pow.times(base);
        }
        return isNegative ? val.negate() : val;
    }
    function stringify(digit) {
        if (digit <= 35) return "0123456789abcdefghijklmnopqrstuvwxyz".charAt(digit);
        return "<" + digit + ">";
    }
    function toBase(n, base) {
        base = bigInt(base);
        if (base.isZero()) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (base.equals(-1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            if (n.isNegative()) return {
                value: [].concat.apply([], Array.apply(null, Array(-n)).map(Array.prototype.valueOf, [
                    1,
                    0
                ])),
                isNegative: false
            };
            var arr = Array.apply(null, Array(+n - 1)).map(Array.prototype.valueOf, [
                0,
                1
            ]);
            arr.unshift([
                1
            ]);
            return {
                value: [].concat.apply([], arr),
                isNegative: false
            };
        }
        var neg = false;
        if (n.isNegative() && base.isPositive()) {
            neg = true;
            n = n.abs();
        }
        if (base.equals(1)) {
            if (n.isZero()) return {
                value: [
                    0
                ],
                isNegative: false
            };
            return {
                value: Array.apply(null, Array(+n)).map(Number.prototype.valueOf, 1),
                isNegative: neg
            };
        }
        var out = [];
        var left = n, divmod;
        while(left.isNegative() || left.compareAbs(base) >= 0){
            divmod = left.divmod(base);
            left = divmod.quotient;
            var digit = divmod.remainder;
            if (digit.isNegative()) {
                digit = base.minus(digit).abs();
                left = left.next();
            }
            out.push(digit.toJSNumber());
        }
        out.push(left.toJSNumber());
        return {
            value: out.reverse(),
            isNegative: neg
        };
    }
    function toBaseString(n, base) {
        var arr = toBase(n, base);
        return (arr.isNegative ? "-" : "") + arr.value.map(stringify).join("");
    }
    BigInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    SmallInteger.prototype.toArray = function(radix) {
        return toBase(this, radix);
    };
    BigInteger.prototype.toString = function(radix) {
        if (radix === undefined) radix = 10;
        if (radix !== 10) return toBaseString(this, radix);
        var v = this.value, l = v.length, str = String(v[--l]), zeros = "0000000", digit;
        while(--l >= 0){
            digit = String(v[l]);
            str += zeros.slice(digit.length) + digit;
        }
        var sign = this.sign ? "-" : "";
        return sign + str;
    };
    SmallInteger.prototype.toString = function(radix) {
        if (radix === undefined) radix = 10;
        if (radix != 10) return toBaseString(this, radix);
        return String(this.value);
    };
    BigInteger.prototype.toJSON = SmallInteger.prototype.toJSON = function() {
        return this.toString();
    };
    BigInteger.prototype.valueOf = function() {
        return parseInt(this.toString(), 10);
    };
    BigInteger.prototype.toJSNumber = BigInteger.prototype.valueOf;
    SmallInteger.prototype.valueOf = function() {
        return this.value;
    };
    SmallInteger.prototype.toJSNumber = SmallInteger.prototype.valueOf;
    function parseStringValue(v) {
        if (isPrecise(+v)) {
            var x = +v;
            if (x === truncate(x)) return new SmallInteger(x);
            throw new Error("Invalid integer: " + v);
        }
        var sign = v[0] === "-";
        if (sign) v = v.slice(1);
        var split = v.split(/e/i);
        if (split.length > 2) throw new Error("Invalid integer: " + split.join("e"));
        if (split.length === 2) {
            var exp = split[1];
            if (exp[0] === "+") exp = exp.slice(1);
            exp = +exp;
            if (exp !== truncate(exp) || !isPrecise(exp)) throw new Error("Invalid integer: " + exp + " is not a valid exponent.");
            var text = split[0];
            var decimalPlace = text.indexOf(".");
            if (decimalPlace >= 0) {
                exp -= text.length - decimalPlace - 1;
                text = text.slice(0, decimalPlace) + text.slice(decimalPlace + 1);
            }
            if (exp < 0) throw new Error("Cannot include negative exponent part for integers");
            text += new Array(exp + 1).join("0");
            v = text;
        }
        var isValid = /^([0-9][0-9]*)$/.test(v);
        if (!isValid) throw new Error("Invalid integer: " + v);
        var r = [], max = v.length, l = LOG_BASE, min = max - l;
        while(max > 0){
            r.push(+v.slice(min, max));
            min -= l;
            if (min < 0) min = 0;
            max -= l;
        }
        trim(r);
        return new BigInteger(r, sign);
    }
    function parseNumberValue(v) {
        if (isPrecise(v)) {
            if (v !== truncate(v)) throw new Error(v + " is not an integer.");
            return new SmallInteger(v);
        }
        return parseStringValue(v.toString());
    }
    function parseValue(v) {
        if (typeof v === "number") return parseNumberValue(v);
        if (typeof v === "string") return parseStringValue(v);
        return v;
    }
    // Pre-define numbers in range [-999,999]
    for(var i = 0; i < 1000; i++){
        Integer[i] = new SmallInteger(i);
        if (i > 0) Integer[-i] = new SmallInteger(-i);
    }
    // Backwards compatibility
    Integer.one = Integer[1];
    Integer.zero = Integer[0];
    Integer.minusOne = Integer[-1];
    Integer.max = max;
    Integer.min = min;
    Integer.gcd = gcd;
    Integer.lcm = lcm;
    Integer.isInstance = function(x) {
        return x instanceof BigInteger || x instanceof SmallInteger;
    };
    Integer.randBetween = randBetween;
    Integer.fromArray = function(digits, base, isNegative) {
        return parseBaseFromArray(digits.map(parseValue), parseValue(base || 10), isNegative);
    };
    return Integer;
}();
// Node.js check
if (module.hasOwnProperty("exports")) module.exports = bigInt;
//amd check
if (typeof define === "function" && define.amd) define("big-integer", [], function() {
    return bigInt;
});

});

parcelRegister("9epC7", function(module, exports) {
// Copyright (c) 2017-2018 Emilio Almansi
// Copyright (c) 2017 Pieter Wuille
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
"use strict";

var $eap7I = parcelRequire("eap7I");
var $6b894a3693a3b5a5$require$validate = $eap7I.validate;
/**
 * Converts an array of integers made up of 'from' bits into an
 * array of integers made up of 'to' bits. The output array is
 * zero-padded if necessary, unless strict mode is true.
 * Throws a {@link ValidationError} if input is invalid.
 * Original by Pieter Wuille: https://github.com/sipa/bech32.
 *
 * @param {Uint8Array} data Array of integers made up of 'from' bits.
 * @param {number} from Length in bits of elements in the input array.
 * @param {number} to Length in bits of elements in the output array.
 * @param {bool} strictMode Require the conversion to be completed without padding.
 * @returns {Uint8Array}
 */ module.exports = function(data, from, to, strictMode) {
    var length = strictMode ? Math.floor(data.length * from / to) : Math.ceil(data.length * from / to);
    var mask = (1 << to) - 1;
    var result = new Uint8Array(length);
    var index = 0;
    var accumulator = 0;
    var bits = 0;
    for(var i = 0; i < data.length; ++i){
        var value = data[i];
        $6b894a3693a3b5a5$require$validate(0 <= value && value >> from === 0, "Invalid value: " + value + ".");
        accumulator = accumulator << from | value;
        bits += from;
        while(bits >= to){
            bits -= to;
            result[index] = accumulator >> bits & mask;
            ++index;
        }
    }
    if (!strictMode) {
        if (bits > 0) {
            result[index] = accumulator << to - bits & mask;
            ++index;
        }
    } else $6b894a3693a3b5a5$require$validate(bits < from && (accumulator << to - bits & mask) === 0, "Input cannot be converted to " + to + " bits without padding, but strict mode was used.");
    return result;
};

});




parcelRegister("ljZAA", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f85b259e457e2589$require$Buffer = $ihoyg.Buffer;
"use strict";
var $f85b259e457e2589$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f85b259e457e2589$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f85b259e457e2589$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f85b259e457e2589$var$__createBinding(result, mod, k);
    }
    $f85b259e457e2589$var$__setModuleDefault(result, mod);
    return result;
};
var $f85b259e457e2589$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f85b259e457e2589$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f85b259e457e2589$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f85b259e457e2589$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeCosmosWallet = module.exports.MixinNativeCosmosWalletInfo = void 0;

const $f85b259e457e2589$var$core = $f85b259e457e2589$var$__importStar((parcelRequire("lFpDy")));

const $f85b259e457e2589$var$bech32 = $f85b259e457e2589$var$__importStar((parcelRequire("5wgCY")));

const $f85b259e457e2589$var$crypto_js_1 = $f85b259e457e2589$var$__importDefault((parcelRequire("kWcCv")));

const $f85b259e457e2589$var$p_lazy_1 = $f85b259e457e2589$var$__importDefault((parcelRequire("gGdnO")));

const $f85b259e457e2589$var$Isolation = $f85b259e457e2589$var$__importStar((parcelRequire("aCCM0")));

const $f85b259e457e2589$var$util = $f85b259e457e2589$var$__importStar((parcelRequire("byiQW")));
const $f85b259e457e2589$var$ATOM_CHAIN = "cosmoshub-4";

const $f85b259e457e2589$var$protoTxBuilder = $f85b259e457e2589$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("eknzC"));
    }).then((res)=>$f85b259e457e2589$var$__importStar(res)));
function $f85b259e457e2589$var$MixinNativeCosmosWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeCosmosWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsCosmosInfo = true;
        }
        cosmosSupportsNetwork() {
            return $f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        cosmosSupportsSecureTransfer() {
            return $f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        cosmosSupportsNativeShapeShift() {
            return false;
        }
        cosmosGetAccountPaths(msg) {
            const slip44 = $f85b259e457e2589$var$core.slip44ByCoin("Atom");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        cosmosNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeCosmosWalletInfo = $f85b259e457e2589$var$MixinNativeCosmosWalletInfo;
function $f85b259e457e2589$var$MixinNativeCosmosWallet(Base) {
    var _MixinNativeCosmosWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeCosmosWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsCosmos = true;
            _MixinNativeCosmosWallet_masterKey.set(this, void 0);
        }
        cosmosInitializeWallet(masterKey) {
            return $f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                $f85b259e457e2589$var$__classPrivateFieldSet(this, _MixinNativeCosmosWallet_masterKey, masterKey, "f");
            });
        }
        cosmosWipe() {
            $f85b259e457e2589$var$__classPrivateFieldSet(this, _MixinNativeCosmosWallet_masterKey, undefined, "f");
        }
        cosmosBech32ify(address, prefix) {
            const words = $f85b259e457e2589$var$bech32.toWords(address);
            return $f85b259e457e2589$var$bech32.encode(prefix, words);
        }
        createCosmosAddress(publicKey) {
            const message = $f85b259e457e2589$var$crypto_js_1.default.SHA256($f85b259e457e2589$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $f85b259e457e2589$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $f85b259e457e2589$require$Buffer.from(hash, `hex`);
            return this.cosmosBech32ify(address, `cosmos`);
        }
        cosmosGetAddress(msg) {
            return $f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f85b259e457e2589$var$__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), ()=>$f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $f85b259e457e2589$var$util.getKeyPair($f85b259e457e2589$var$__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), msg.addressNList, "cosmos");
                        return this.createCosmosAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        cosmosSignTx(msg) {
            return $f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f85b259e457e2589$var$__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), ()=>$f85b259e457e2589$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $f85b259e457e2589$var$util.getKeyPair($f85b259e457e2589$var$__classPrivateFieldGet(this, _MixinNativeCosmosWallet_masterKey, "f"), msg.addressNList, "cosmos");
                        const adapter = yield $f85b259e457e2589$var$Isolation.Adapters.CosmosDirect.create(keyPair.node, "cosmos");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: $f85b259e457e2589$var$ATOM_CHAIN
                        };
                        return (yield $f85b259e457e2589$var$protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData);
                    }));
            });
        }
    }, _MixinNativeCosmosWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeCosmosWallet = $f85b259e457e2589$var$MixinNativeCosmosWallet;

});

parcelRegister("jDbFs", function(module, exports) {
"use strict";
var $e4aab5ca868b3938$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e4aab5ca868b3938$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e4aab5ca868b3938$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e4aab5ca868b3938$var$__createBinding(result, mod, k);
    }
    $e4aab5ca868b3938$var$__setModuleDefault(result, mod);
    return result;
};
var $e4aab5ca868b3938$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $e4aab5ca868b3938$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $e4aab5ca868b3938$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $e4aab5ca868b3938$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeETHWallet = module.exports.MixinNativeETHWalletInfo = void 0;

const $e4aab5ca868b3938$var$core = $e4aab5ca868b3938$var$__importStar((parcelRequire("lFpDy")));

var $8iu5n = parcelRequire("8iu5n");

const $e4aab5ca868b3938$var$Isolation = $e4aab5ca868b3938$var$__importStar((parcelRequire("aCCM0")));

const $e4aab5ca868b3938$var$ethereum_1 = $e4aab5ca868b3938$var$__importDefault((parcelRequire("2rr6y")));

var $byiQW = parcelRequire("byiQW");
function $e4aab5ca868b3938$var$MixinNativeETHWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeETHWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsETHInfo = true;
            this._chainId = 1;
        }
        ethSupportsNetwork() {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        ethSupportsSecureTransfer() {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        ethSupportsNativeShapeShift() {
            return false;
        }
        ethSupportsEIP1559() {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        ethGetAccountPaths(msg) {
            const slip44 = $e4aab5ca868b3938$var$core.slip44ByCoin(msg.coin);
            if (slip44 === undefined) return [];
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ],
                    hardenedPath: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx
                    ],
                    relPath: [
                        0,
                        0
                    ],
                    description: "Native"
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ethNextAccountPath(msg) {
            // Only support one account for now (like portis).
            // the ethers library supports paths so it shouldnt be too hard if we decide multiple accounts are needed
            return undefined;
        }
    };
}
module.exports.MixinNativeETHWalletInfo = $e4aab5ca868b3938$var$MixinNativeETHWalletInfo;
function $e4aab5ca868b3938$var$MixinNativeETHWallet(Base) {
    var _MixinNativeETHWallet_ethSigner, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeETHWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsETH = true;
            _MixinNativeETHWallet_ethSigner.set(this, void 0);
        }
        ethInitializeWallet(masterKey) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                const nodeAdapter = yield $e4aab5ca868b3938$var$Isolation.Adapters.BIP32.create(masterKey);
                $e4aab5ca868b3938$var$__classPrivateFieldSet(this, _MixinNativeETHWallet_ethSigner, new $e4aab5ca868b3938$var$ethereum_1.default(nodeAdapter), "f");
            });
        }
        ethWipe() {
            $e4aab5ca868b3938$var$__classPrivateFieldSet(this, _MixinNativeETHWallet_ethSigner, undefined, "f");
        }
        ethGetAddress(msg) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                if (msg.addressNList.length < 5) throw new Error(`path not supported length: ${msg.addressNList.length}`);
                return this.needsMnemonic(!!$e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), ()=>{
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    return $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList);
                });
            });
        }
        ethSignTx(msg) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), ()=>$e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                        const utx = {
                            to: msg.to,
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            from: yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList),
                            nonce: msg.nonce,
                            gasLimit: msg.gasLimit,
                            data: msg.data,
                            value: msg.value,
                            chainId: msg.chainId
                        };
                        const result = msg.maxFeePerGas ? yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTransaction(Object.assign(Object.assign({}, utx), {
                            maxFeePerGas: msg.maxFeePerGas,
                            maxPriorityFeePerGas: msg.maxPriorityFeePerGas,
                            type: $e4aab5ca868b3938$var$core.ETHTransactionType.ETH_TX_TYPE_EIP_1559
                        }), msg.addressNList) : yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTransaction(Object.assign(Object.assign({}, utx), {
                            gasPrice: msg.gasPrice,
                            type: $e4aab5ca868b3938$var$core.ETHTransactionType.ETH_TX_TYPE_LEGACY
                        }), msg.addressNList);
                        const decoded = (0, $8iu5n.parseTransaction)(result);
                        return {
                            v: $e4aab5ca868b3938$var$core.mustBeDefined(decoded.v),
                            r: $e4aab5ca868b3938$var$core.mustBeDefined(decoded.r),
                            s: $e4aab5ca868b3938$var$core.mustBeDefined(decoded.s),
                            serialized: result
                        };
                    }));
            });
        }
        ethSignMessage(msg) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), ()=>$e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const result = yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signMessage(msg.message, msg.addressNList);
                        return {
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            address: yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").getAddress(msg.addressNList),
                            signature: result
                        };
                    }));
            });
        }
        ethSignTypedData(msg) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f"), ()=>$e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        return yield $e4aab5ca868b3938$var$__classPrivateFieldGet(this, _MixinNativeETHWallet_ethSigner, "f").signTypedData(msg.typedData, msg.addressNList);
                    }));
            });
        }
        ethVerifyMessage({ address: address, message: message, signature: signature }) {
            return $e4aab5ca868b3938$var$__awaiter(this, void 0, void 0, function*() {
                if (!signature.startsWith("0x")) signature = `0x${signature}`;
                const digest = (0, $8iu5n.keccak256)((0, $byiQW.buildMessage)(message));
                return (0, $8iu5n.recoverAddress)(digest, signature) === address;
            });
        }
    }, _MixinNativeETHWallet_ethSigner = new WeakMap(), _a;
}
module.exports.MixinNativeETHWallet = $e4aab5ca868b3938$var$MixinNativeETHWallet;

});

parcelRegister("lhEsR", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f7ea92e515adc459$require$Buffer = $ihoyg.Buffer;
"use strict";
var $f7ea92e515adc459$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f7ea92e515adc459$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f7ea92e515adc459$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f7ea92e515adc459$var$__createBinding(result, mod, k);
    }
    $f7ea92e515adc459$var$__setModuleDefault(result, mod);
    return result;
};
var $f7ea92e515adc459$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f7ea92e515adc459$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f7ea92e515adc459$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f7ea92e515adc459$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeFioWallet = module.exports.MixinNativeFioWalletInfo = void 0;

const $f7ea92e515adc459$var$fio = $f7ea92e515adc459$var$__importStar((parcelRequire("bR62V")));

const $f7ea92e515adc459$var$core = $f7ea92e515adc459$var$__importStar((parcelRequire("lFpDy")));

const $f7ea92e515adc459$var$node_fetch_1 = $f7ea92e515adc459$var$__importDefault((parcelRequire("6fIKZ")));

const $f7ea92e515adc459$var$Isolation = $f7ea92e515adc459$var$__importStar((parcelRequire("aCCM0")));
const $f7ea92e515adc459$var$fetchJson = (uri, opts)=>$f7ea92e515adc459$var$__awaiter(void 0, void 0, void 0, function*() {
        return (0, $f7ea92e515adc459$var$node_fetch_1.default)(uri, opts);
    });
function $f7ea92e515adc459$var$getKeyPair(masterKey, addressNList) {
    return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
        const out = yield addressNList.reduce((a, x)=>$f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return (yield a).derive(x);
            }), Promise.resolve(masterKey));
        if (!$f7ea92e515adc459$var$Isolation.Core.BIP32.nodeSupportsECDH(out)) throw new Error("fio requires keys that implement ECDH");
        return yield $f7ea92e515adc459$var$Isolation.Adapters.FIO.create(out);
    });
}
function $f7ea92e515adc459$var$MixinNativeFioWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeFioWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsFioInfo = true;
        }
        fioSupportsNetwork() {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        fioSupportsSecureTransfer() {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        fioSupportsNativeShapeShift() {
            return false;
        }
        fioGetAccountPaths(msg) {
            return [
                {
                    addressNList: [
                        2147483692,
                        2147483883,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        fioNextAccountPath(msg) {
            // Only support one account for now (like portis).
            // the fioers library supports paths so it shouldnt be too hard if we decide multiple accounts are needed
            return undefined;
        }
    };
}
module.exports.MixinNativeFioWalletInfo = $f7ea92e515adc459$var$MixinNativeFioWalletInfo;
function $f7ea92e515adc459$var$MixinNativeFioWallet(Base) {
    var _MixinNativeFioWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeFioWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsFio = true;
            this.baseUrl = "https://fio.eu.eosamsterdam.net/v1/";
            _MixinNativeFioWallet_masterKey.set(this, void 0);
        }
        fioInitializeWallet(masterKey) {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                $f7ea92e515adc459$var$__classPrivateFieldSet(this, _MixinNativeFioWallet_masterKey, masterKey, "f");
            });
        }
        fioWipe() {
            $f7ea92e515adc459$var$__classPrivateFieldSet(this, _MixinNativeFioWallet_masterKey, undefined, "f");
        }
        getFioSdk(addressNList) {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), ()=>$f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const key = yield $f7ea92e515adc459$var$getKeyPair($f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), addressNList);
                        const sdk = new $f7ea92e515adc459$var$fio.FIOSDK(key, key.publicKey, this.baseUrl, $f7ea92e515adc459$var$fetchJson);
                        sdk.setSignedTrxReturnOption(true);
                        return sdk;
                    }));
            });
        }
        fioGetAddress(msg) {
            var _b;
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                const sdk = yield this.getFioSdk(msg.addressNList);
                return (_b = sdk === null || sdk === void 0 ? void 0 : sdk.getFioPublicKey()) !== null && _b !== void 0 ? _b : null;
            });
        }
        fioSignTx(msg) {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                const sdk = yield this.getFioSdk(msg.addressNList);
                if (!sdk) return null;
                const action = msg.actions[0];
                if (!action.account || !action.name || !action.data) throw new Error("account, name, and data required");
                let genericAction = "";
                let genericActionParams = {};
                switch(action.name){
                    case "addaddress":
                        genericAction = "addPublicAddresses";
                        genericActionParams = {
                            fioAddress: action.data.fio_address,
                            publicAddresses: action.data.public_addresses,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "newfundsreq":
                        {
                            genericAction = "requestFunds";
                            const payerPublicKey = (yield sdk.getFioPublicAddress(action.data.payer_fio_address)).public_address;
                            const decryptedContent = $f7ea92e515adc459$var$core.mustBeDefined((yield this.fioDecryptRequestContent({
                                contentType: $f7ea92e515adc459$var$core.Fio.ContentType.REQUEST,
                                content: action.data.content,
                                addressNList: msg.addressNList,
                                publicKey: payerPublicKey
                            })));
                            genericActionParams = {
                                payerFioAddress: action.data.payer_fio_address,
                                payeeFioAddress: action.data.payee_fio_address,
                                payeeTokenPublicAddress: decryptedContent.payee_public_address,
                                amount: decryptedContent.amount,
                                chainCode: decryptedContent.chain_code,
                                tokenCode: decryptedContent.token_code,
                                memo: decryptedContent.memo,
                                maxFee: action.data.max_fee,
                                payerFioPublicKey: null,
                                technologyProviderId: action.data.tpid,
                                hash: decryptedContent.hash,
                                offlineUrl: decryptedContent.offline_url
                            };
                            break;
                        }
                    case "recordobt":
                        {
                            genericAction = "recordObtData";
                            const payeePublicKey = (yield sdk.getFioPublicAddress(action.data.payee_fio_address)).public_address;
                            const decryptedContent = $f7ea92e515adc459$var$core.mustBeDefined((yield this.fioDecryptRequestContent({
                                contentType: $f7ea92e515adc459$var$core.Fio.ContentType.OBT,
                                content: action.data.content,
                                addressNList: msg.addressNList,
                                publicKey: payeePublicKey
                            })));
                            genericActionParams = {
                                fioRequestId: action.data.fio_request_id ? Number(action.data.fio_request_id) : null,
                                payerFioAddress: action.data.payer_fio_address,
                                payeeFioAddress: action.data.payee_fio_address,
                                payerTokenPublicAddress: decryptedContent.payer_public_address,
                                payeeTokenPublicAddress: decryptedContent.payee_public_address,
                                amount: decryptedContent.amount,
                                chainCode: decryptedContent.chain_code,
                                tokenCode: decryptedContent.token_code,
                                status: decryptedContent.status,
                                obtId: decryptedContent.obt_id,
                                maxFee: action.data.max_fee,
                                technologyProviderId: action.data.tpid,
                                payeeFioPublicKey: null,
                                memo: decryptedContent.memo,
                                hash: decryptedContent.hash,
                                offLineUrl: decryptedContent.offline_url
                            };
                            break;
                        }
                    case "regaddress":
                        genericAction = "registerOwnerFioAddress";
                        genericActionParams = {
                            fioAddress: action.data.fio_address,
                            ownerPublicKey: action.data.owner_fio_public_key,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "regdomain":
                        genericAction = "registerOwnerFioDomain";
                        genericActionParams = {
                            fioDomain: action.data.fio_domain,
                            ownerPublicKey: action.data.owner_fio_public_key,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "rejectfndreq":
                        genericAction = "rejectFundsRequest";
                        genericActionParams = {
                            fioRequestId: Number(action.data.fio_request_id),
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "renewaddress":
                        genericAction = "renewFioAddress";
                        genericActionParams = {
                            fioAddress: action.data.fio_address,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "renewdomain":
                        genericAction = "renewFioDomain";
                        genericActionParams = {
                            fioDomain: action.data.fio_domain,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "setdomainpub":
                        genericAction = "setFioDomainVisibility";
                        genericActionParams = {
                            fioDomain: action.data.fio_domain,
                            isPublic: action.data.is_public,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    case "trnsfiopubky":
                        genericAction = "transferTokens";
                        genericActionParams = {
                            payeeFioPublicKey: action.data.payee_public_key,
                            amount: action.data.amount,
                            maxFee: action.data.max_fee,
                            technologyProviderId: action.data.tpid
                        };
                        break;
                    default:
                        throw new Error(`unsupported FIO action: ${JSON.stringify(action)}`);
                }
                const res = yield sdk.genericAction(genericAction, genericActionParams);
                return {
                    serialized: res.packed_trx,
                    signature: res.signatures[0]
                };
            });
        }
        fioEncryptRequestContent(msg) {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), ()=>$f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const privateKey = yield $f7ea92e515adc459$var$getKeyPair($f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), msg.addressNList);
                        const sdk = $f7ea92e515adc459$var$core.mustBeDefined((yield this.getFioSdk(msg.addressNList)));
                        return yield sdk.transactions.getCipherContent(msg.contentType, msg.content, privateKey, msg.publicKey, msg.iv && $f7ea92e515adc459$require$Buffer.from(msg.iv));
                    }));
            });
        }
        fioDecryptRequestContent(msg) {
            return $f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), ()=>$f7ea92e515adc459$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const privateKey = yield $f7ea92e515adc459$var$getKeyPair($f7ea92e515adc459$var$__classPrivateFieldGet(this, _MixinNativeFioWallet_masterKey, "f"), msg.addressNList);
                        const sdk = $f7ea92e515adc459$var$core.mustBeDefined((yield this.getFioSdk(msg.addressNList)));
                        return yield sdk.transactions.getUnCipherContent(msg.contentType, JSON.stringify(msg.content), privateKey, msg.publicKey);
                    }));
            });
        }
    }, _MixinNativeFioWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeFioWallet = $f7ea92e515adc459$var$MixinNativeFioWallet;

});
parcelRegister("bR62V", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8a1955991d3656b8$require$Buffer = $ihoyg.Buffer;
"use strict";
var $8a1955991d3656b8$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FIOSDK = void 0;

var $fXcze = parcelRequire("fXcze");

var $2NvO7 = parcelRequire("2NvO7");

var $PZcro = parcelRequire("PZcro");

var $vwBbb = parcelRequire("vwBbb");

var $dhMfH = parcelRequire("dhMfH");

var $5Wi28 = parcelRequire("5Wi28");

var $dtGp3 = parcelRequire("dtGp3");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");

var $jxok1 = parcelRequire("jxok1");

var $fXcze = parcelRequire("fXcze");
var $8a1955991d3656b8$require$Ecc = $fXcze.Ecc;




class $8a1955991d3656b8$var$FIOSDK {
    /**
     * // how to instantiate fetchJson parameter
     * i.e.
     * fetch = require('node-fetch')
     *
     * const fetchJson = async (uri, opts = {}) => {
     *  return fetch(uri, opts)
     * }
     *
     * @param privateKey the fio private key of the client sending requests to FIO API.
     * @param publicKey the fio public key of the client sending requests to FIO API.
     * @param baseUrl the url to the FIO API.
     * @param fetchjson - the module to use for HTTP Post/Get calls (see above for example)
     * @param registerMockUrl the url to the mock server
     * @param technologyProviderId Default FIO Address of the wallet which generates transactions.
     */ constructor(privateKey, publicKey, baseUrl, fetchjson, registerMockUrl = "", technologyProviderId = "", returnPreparedTrx = false){
        /**
         * Defines whether SignedTransaction would execute or return prepared transaction
         */ this.returnPreparedTrx = false;
        this.transactions = new $dtGp3.Transactions();
        $dtGp3.Transactions.baseUrl = baseUrl;
        $dtGp3.Transactions.FioProvider = $fXcze.Fio;
        $dtGp3.Transactions.fetchJson = fetchjson;
        this.registerMockUrl = registerMockUrl;
        this.privateKey = privateKey;
        this.publicKey = publicKey;
        this.technologyProviderId = technologyProviderId;
        this.returnPreparedTrx = returnPreparedTrx;
        for (const accountName of $6I0rv.Constants.rawAbiAccountName)this.getAbi(accountName).then((response)=>{
            $dtGp3.Transactions.abiMap.set(response.account_name, response);
        }).catch((error)=>{
            throw error;
        });
    }
    /**
     * @ignore
     */ static createPrivateKey(entropy) {
        return $8a1955991d3656b8$var$__awaiter(this, void 0, void 0, function*() {
            const bip39 = (parcelRequire("5qnT8"));
            const mnemonic = bip39.entropyToMnemonic(entropy);
            return yield $8a1955991d3656b8$var$FIOSDK.createPrivateKeyMnemonic(mnemonic);
        });
    }
    /**
     * Create a FIO private key.
     *
     * @param mnemonic mnemonic used to generate a random unique private key.
     * @example real flame win provide layer trigger soda erode upset rate beef wrist fame design merit
     *
     * @returns New FIO private key
     */ static createPrivateKeyMnemonic(mnemonic) {
        return $8a1955991d3656b8$var$__awaiter(this, void 0, void 0, function*() {
            const hdkey = (parcelRequire("5NC09"));
            const wif = (parcelRequire("bTFmB"));
            const bip39 = (parcelRequire("5qnT8"));
            const seedBytes = yield bip39.mnemonicToSeed(mnemonic);
            const seed = yield seedBytes.toString("hex");
            const master = hdkey.fromMasterSeed(new $8a1955991d3656b8$require$Buffer(seed, "hex"));
            const node = master.derive("m/44'/235'/0'/0/0");
            const fioKey = wif.encode(128, node._privateKey, false);
            return {
                fioKey: fioKey,
                mnemonic: mnemonic
            };
        });
    }
    /**
     * Create a FIO public key.
     *
     * @param fioPrivateKey FIO private key.
     *
     * @returns FIO public key derived from the FIO private key.
     */ static derivedPublicKey(fioPrivateKey) {
        const publicKey = $8a1955991d3656b8$require$Ecc.privateToPublic(fioPrivateKey);
        return {
            publicKey: publicKey
        };
    }
    /**
     * Is the Chain Code Valid?
     *
     * @param chainCode
     *
     * @returns Chain Code is Valid
     */ static isChainCodeValid(chainCode) {
        const validation = $g14qE.validate({
            chainCode: chainCode
        }, {
            chainCode: $g14qE.allRules.chain
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors, `Validation error`);
        return true;
    }
    /**
     * Is the Token Code Valid?
     *
     * @param tokenCode
     *
     * @returns Token Code is Valid
     */ static isTokenCodeValid(tokenCode) {
        const validation = $g14qE.validate({
            tokenCode: tokenCode
        }, {
            tokenCode: $g14qE.allRules.chain
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors);
        return true;
    }
    /**
     * Is the FIO Address Valid?
     *
     * @param fioAddress
     *
     * @returns Fio Address is Valid
     */ static isFioAddressValid(fioAddress) {
        const validation = $g14qE.validate({
            fioAddress: fioAddress
        }, {
            fioAddress: $g14qE.allRules.fioAddress
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors);
        return true;
    }
    /**
     * Is the FIO Domain Valid?
     *
     * @param fioDomain
     *
     * @returns FIO Domain is Valid
     */ static isFioDomainValid(fioDomain) {
        const validation = $g14qE.validate({
            fioDomain: fioDomain
        }, {
            fioDomain: $g14qE.allRules.fioDomain
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors);
        return true;
    }
    /**
     * Is the FIO Public Key Valid?
     *
     * @param fioPublicKey
     *
     * @returns FIO Public Key is Valid
     */ static isFioPublicKeyValid(fioPublicKey) {
        const validation = $g14qE.validate({
            fioPublicKey: fioPublicKey
        }, {
            fioPublicKey: $g14qE.allRules.fioPublicKey
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors);
        return true;
    }
    /**
     * Is the Public Address Valid?
     *
     * @param publicAddress
     *
     * @returns Public Address is Valid
     */ static isPublicAddressValid(publicAddress) {
        const validation = $g14qE.validate({
            publicAddress: publicAddress
        }, {
            publicAddress: $g14qE.allRules.nativeBlockchainPublicAddress
        });
        if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors);
        return true;
    }
    /**
     * Convert a FIO Token Amount to FIO SUFs
     *
     * @param amount
     *
     * 2.568 FIO should be 2568000000 SUFs
     *
     * @returns FIO SUFs
     */ static amountToSUF(amount) {
        // get integer part
        var floor = Math.floor(amount);
        var tempResult = floor * this.SUFUnit;
        // get remainder
        var remainder = amount % 1;
        var remainderResult = remainder * this.SUFUnit;
        var floorRemainder = Math.floor(remainderResult);
        // add integer and remainder
        return tempResult + floorRemainder;
    }
    /**
     * Convert FIO SUFs to a FIO Token amount
     *
     * @param suf
     *
     * @returns FIO Token amount
     */ static SUFToAmount(suf) {
        return parseInt(`${suf}`) / this.SUFUnit;
    }
    /**
     * Retrieves the FIO public key assigned to the FIOSDK instance.
     */ getFioPublicKey() {
        return this.publicKey;
    }
    /**
     * Returns technologyProviderId or default
     */ getTechnologyProviderId(technologyProviderId) {
        return technologyProviderId !== null ? technologyProviderId : this.technologyProviderId;
    }
    /**
     * Set returnPreparedTrx
     */ setSignedTrxReturnOption(returnPreparedTrx) {
        this.returnPreparedTrx = returnPreparedTrx;
    }
    /**
     * Execute prepared transaction.
     *
     * @param endPoint endpoint.
     * @param preparedTrx
     */ executePreparedTrx(endPoint, preparedTrx) {
        return $8a1955991d3656b8$var$__awaiter(this, void 0, void 0, function*() {
            const response = yield this.transactions.executeCall(`chain/${endPoint}`, JSON.stringify(preparedTrx));
            return $dhMfH.SignedTransaction.prepareResponse(response, true);
        });
    }
    /**
     * Registers a FIO Address on the FIO blockchain. The owner will be the public key associated with the FIO SDK instance.
     *
     * @param fioAddress FIO Address to register.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ registerFioAddress(fioAddress, maxFee, technologyProviderId = null) {
        const registerFioAddress = new $vwBbb.RegisterFioAddress(fioAddress, null, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return registerFioAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Registers a Fio Address on behalf of the owner FIO Public key parameter. Owner FIO Public key owns the FIO address
     *
     * @param fioAddress FIO Address to register.
     * @param ownerPublicKey Owner FIO Public Key.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ registerOwnerFioAddress(fioAddress, ownerPublicKey, maxFee, technologyProviderId = null) {
        const registerFioAddress = new $vwBbb.RegisterFioAddress(fioAddress, ownerPublicKey, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return registerFioAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Registers a FIO Domain on the FIO blockchain.
     *
     * @param fioDomain FIO Domain to register. The owner will be the public key associated with the FIO SDK instance.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ registerFioDomain(fioDomain, maxFee, technologyProviderId = null) {
        const registerFioDomain = new $vwBbb.RegisterFioDomain(fioDomain, null, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return registerFioDomain.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Registers a FIO Domain on behalf of the owner FIO Public key parameter. Owner FIO Public key owns the FIO domain.
     *
     * @param fioDomain FIO Domain to register. The owner will be the public key associated with the FIO SDK instance.
     * @param ownerPublicKey Owner FIO Public Key.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ registerOwnerFioDomain(fioDomain, ownerPublicKey, maxFee, technologyProviderId = null) {
        const registerFioDomain = new $vwBbb.RegisterFioDomain(fioDomain, ownerPublicKey, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return registerFioDomain.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Burns a FIO Address on the FIO blockchain.
     *
     * @param fioAddress FIO Address to burn. The owner will be the public key associated with the FIO SDK instance.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ burnFioAddress(fioAddress, maxFee, technologyProviderId = null) {
        const burnFioAddress = new $vwBbb.BurnFioAddress(fioAddress, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return burnFioAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Transfers a FIO Domain on the FIO blockchain.
     *
     * @param fioDomain FIO Domain to transfer. The owner will be the public key associated with the FIO SDK instance.
     * @param newOwnerKey FIO Public Key of the new owner.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ transferFioDomain(fioDomain, newOwnerKey, maxFee, technologyProviderId = null) {
        const transferFioDomain = new $vwBbb.TransferFioDomain(fioDomain, newOwnerKey, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return transferFioDomain.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Transfers a FIO Address on the FIO blockchain.
     *
     * @param fioAddress FIO Address to transfer. The owner will be the public key associated with the FIO SDK instance.
     * @param newOwnerKey FIO Public Key of the new owner.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ transferFioAddress(fioAddress, newOwnerKey, maxFee, technologyProviderId = null) {
        const transferFioAddress = new $vwBbb.TransferFioAddress(fioAddress, newOwnerKey, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return transferFioAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Renew a FIO Address on the FIO blockchain.
     *
     * @param fioAddress FIO Address to renew.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ renewFioAddress(fioAddress, maxFee, technologyProviderId = null) {
        const renewFioAddress = new $vwBbb.RenewFioAddress(fioAddress, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return renewFioAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Renew a FIO Domain on the FIO blockchain.
     *
     * @param fioDomain FIO Domain to renew.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by @ [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ renewFioDomain(fioDomain, maxFee, technologyProviderId = null) {
        const renewFioDomain = new $vwBbb.RenewFioDomain(fioDomain, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return renewFioDomain.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * This call allows a public address of the specific blockchain type to be added to the FIO Address.
     *
     * @param fioAddress FIO Address which will be mapped to public address.
     * @param chainCode Blockchain code for blockchain hosting this token.
     * @param tokenCode Token code to be used with that public address.
     * @param publicAddress The public address to be added to the FIO Address for the specified token.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ addPublicAddress(fioAddress, chainCode, tokenCode, publicAddress, maxFee, technologyProviderId = null) {
        const addPublicAddress = new $vwBbb.AddPublicAddress(fioAddress, [
            {
                chain_code: chainCode,
                token_code: tokenCode,
                public_address: publicAddress
            }
        ], maxFee, this.getTechnologyProviderId(technologyProviderId));
        return addPublicAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * This call cancels the specified fio funds request..
     *
     * @param fioRequestID The id of the request.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ cancelFundsRequest(fioRequestId, maxFee, technologyProviderId = null) {
        const cancelFundsRequest = new $vwBbb.CancelFundsRequest(fioRequestId, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return cancelFundsRequest.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * This call allows a any number of public addresses matching the blockchain code, the token code and the public address to be removed from the FIO Address.
     *
     * @param fioAddress FIO Address which will be mapped to public address.
     * @param publicAddresses a list of publicAddresses, each containing chain_code, token_code, and public_address.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ removePublicAddresses(fioAddress, publicAddresses, maxFee, technologyProviderId = null) {
        const removePublicAddresses = new $vwBbb.RemovePublicAddresses(fioAddress, publicAddresses, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return removePublicAddresses.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * This call allows a user to remove all addresses from the specified FIO Address, all addresses except the FIO address will be removed.
     *
     * @param fioAddress FIO Address which will be mapped to public address.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ removeAllPublicAddresses(fioAddress, maxFee, technologyProviderId = null) {
        const removeAllPublicAddresses = new $vwBbb.RemoveAllPublicAddresses(fioAddress, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return removeAllPublicAddresses.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * This call allows a public addresses of the specific blockchain type to be added to the FIO Address.
     *
     * @param fioAddress FIO Address which will be mapped to public addresses.
     * @param publicAddresses Array of public addresses to be added to the FIO Address for the specified token.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ addPublicAddresses(fioAddress, publicAddresses, maxFee, technologyProviderId = null) {
        const addPublicAddress = new $vwBbb.AddPublicAddress(fioAddress, publicAddresses, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return addPublicAddress.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * By default all FIO Domains are non-public, meaning only the owner can register FIO Addresses on that domain. Setting them to public allows anyone to register a FIO Address on that domain.
     *
     * @param fioDomain FIO Domain to change visibility.
     * @param isPublic 1 - allows anyone to register FIO Address, 0 - only owner of domain can register FIO Address.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ setFioDomainVisibility(fioDomain, isPublic, maxFee, technologyProviderId = null) {
        const SetFioDomainVisibility = new $vwBbb.SetFioDomainVisibility(fioDomain, isPublic, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return SetFioDomainVisibility.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     *
     * Records information on the FIO blockchain about a transaction that occurred on other blockchain, i.e. 1 BTC was sent on Bitcoin Blockchain, and both
     * sender and receiver have FIO Addresses. OBT stands for Other Blockchain Transaction
     *
     * @param fioRequestId ID of funds request, if this Record Send transaction is in response to a previously received funds request.  Send empty if no FIO Request ID
     * @param payerFioAddress FIO Address of the payer. This address initiated payment.
     * @param payeeFioAddress FIO Address of the payee. This address is receiving payment.
     * @param payerTokenPublicAddress Public address on other blockchain of user sending funds.
     * @param payeeTokenPublicAddress Public address on other blockchain of user receiving funds.
     * @param amount Amount sent.
     * @param chainCode Blockchain code for blockchain hosting this token.
     * @param tokenCode Code of the token represented in Amount requested, i.e. BTC.
     * @param status Status of this OBT. Allowed statuses are: sent_to_blockchain.
     * @param obtId Other Blockchain Transaction ID (OBT ID), i.e Bitcoin transaction ID.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     * @param payeeFioPublicKey Public address on other blockchain of user receiving funds.
     * @param memo
     * @param hash
     * @param offlineUrl
     */ recordObtData(fioRequestId, payerFioAddress, payeeFioAddress, payerTokenPublicAddress, payeeTokenPublicAddress, amount, chainCode, tokenCode, status, obtId, maxFee, technologyProviderId = null, payeeFioPublicKey = null, memo = null, hash = null, offLineUrl = null) {
        return $8a1955991d3656b8$var$__awaiter(this, void 0, void 0, function*() {
            let payeeKey = {
                public_address: ""
            };
            if (!payeeFioPublicKey && typeof payeeFioPublicKey !== "string") payeeKey = yield this.getFioPublicAddress(payeeFioAddress);
            else payeeKey.public_address = payeeFioPublicKey;
            const recordObtData = new $vwBbb.RecordObtData(fioRequestId, payerFioAddress, payeeFioAddress, payerTokenPublicAddress, payeeTokenPublicAddress, amount, chainCode, tokenCode, obtId, maxFee, status, this.getTechnologyProviderId(technologyProviderId), payeeKey.public_address, memo, hash, offLineUrl);
            return recordObtData.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
        });
    }
    /**
     * Retrives OBT metadata data stored using record send.
     *
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     * @param tokenCode Code of the token to filter results
     */ getObtData(limit, offset, tokenCode) {
        const getObtDataRequest = new $PZcro.GetObtData(this.publicKey, limit, offset, tokenCode);
        return getObtDataRequest.execute(this.publicKey, this.privateKey);
    }
    /**
     * Reject funds request.
     *
     * @param fioRequestId Existing funds request Id
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by [getFee] for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ rejectFundsRequest(fioRequestId, maxFee, technologyProviderId = null) {
        const rejectFundsRequest = new $vwBbb.RejectFundsRequest(fioRequestId, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return rejectFundsRequest.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Create a new funds request on the FIO chain.
     *
     * @param payerFioAddress FIO Address of the payer. This address will receive the request and will initiate payment.
     * @param payeeFioAddress FIO Address of the payee. This address is sending the request and will receive payment.
     * @param payeeTokenPublicAddress Payee's public address where they want funds sent.
     * @param amount Amount requested.
     * @param chainCode Blockchain code for blockchain hosting this token.
     * @param tokenCode Code of the token represented in amount requested.
     * @param memo
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by [getFee] for correct value.
     * @param payerFioPublicKey Public address on other blockchain of user sending funds.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     * @param hash
     * @param offlineUrl
     */ requestFunds(payerFioAddress, payeeFioAddress, payeeTokenPublicAddress, amount, chainCode, tokenCode, memo, maxFee, payerFioPublicKey = null, technologyProviderId = null, hash, offlineUrl) {
        return $8a1955991d3656b8$var$__awaiter(this, void 0, void 0, function*() {
            let payerKey = {
                public_address: ""
            };
            if (!payerFioPublicKey && typeof payerFioPublicKey !== "string") payerKey = yield this.getFioPublicAddress(payerFioAddress);
            else payerKey.public_address = payerFioPublicKey;
            const requestNewFunds = new $vwBbb.RequestNewFunds(payerFioAddress, payerKey.public_address, payeeFioAddress, this.getTechnologyProviderId(technologyProviderId), maxFee, payeeTokenPublicAddress, amount, chainCode, tokenCode, memo, hash, offlineUrl);
            return requestNewFunds.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
        });
    }
    /**
     * Checks if a FIO Address or FIO Domain is available for registration.
     *
     * @param fioName FIO Address or FIO Domain to check.
     */ isAvailable(fioName) {
        const availabilityCheck = new $PZcro.AvailabilityCheck(fioName);
        return availabilityCheck.execute(this.publicKey);
    }
    /**
     * Retrieves balance of FIO tokens
     *
     * @param fioPublicKey FIO public key.
     */ getFioBalance(fioPublicKey) {
        const getFioBalance = new $PZcro.GetFioBalance(fioPublicKey);
        return getFioBalance.execute(this.publicKey);
    }
    /**
     * Returns FIO Addresses and FIO Domains owned by this public key.
     *
     * @param fioPublicKey FIO public key of owner.
     */ getFioNames(fioPublicKey) {
        const getNames = new $PZcro.GetNames(fioPublicKey);
        return getNames.execute(this.publicKey);
    }
    /**
     * Returns FIO Addresses  owned by this public key.
     *
     * @param fioPublicKey FIO public key of owner.
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     */ getFioAddresses(fioPublicKey, limit, offset) {
        const getNames = new $PZcro.GetAddresses(fioPublicKey, limit, offset);
        return getNames.execute(this.publicKey);
    }
    /**
     * Returns FIO domains  owned by this public key.
     *
     * @param fioPublicKey FIO public key of owner.
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     */ getFioDomains(fioPublicKey, limit, offset) {
        const getNames = new $PZcro.GetDomains(fioPublicKey, limit, offset);
        return getNames.execute(this.publicKey);
    }
    /**
     * Polls for any pending requests sent to public key associated with the FIO SDK instance.
     *
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     */ getPendingFioRequests(limit, offset) {
        const pendingFioRequests = new $PZcro.PendingFioRequests(this.publicKey, limit, offset);
        return pendingFioRequests.execute(this.publicKey, this.privateKey);
    }
    /**
     * Polls for any sent requests sent by public key associated with the FIO SDK instance.
     *
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     */ getSentFioRequests(limit, offset) {
        const sentFioRequest = new $PZcro.SentFioRequests(this.publicKey, limit, offset);
        return sentFioRequest.execute(this.publicKey, this.privateKey);
    }
    /**
     * Polls for any cancelled requests sent by public key associated with the FIO SDK instance.
     *
     * @param limit Number of request to return. If omitted, all requests will be returned.
     * @param offset First request from list to return. If omitted, 0 is assumed.
     */ getCancelledFioRequests(limit, offset) {
        const cancelledFioRequest = new $PZcro.CancelledFioRequests(this.publicKey, limit, offset);
        return cancelledFioRequest.execute(this.publicKey, this.privateKey);
    }
    /**
     * Returns a token public address for specified token code and FIO Address.
     *
     * @param fioAddress FIO Address for which the token public address is to be returned.
     * @param chainCode Blockchain code for which public address is to be returned.
     * @param tokenCode Token code for which public address is to be returned.
     */ getPublicAddress(fioAddress, chainCode, tokenCode) {
        const publicAddressLookUp = new $PZcro.GetPublicAddress(fioAddress, chainCode, tokenCode);
        return publicAddressLookUp.execute(this.publicKey);
    }
    /**
     * Returns the FIO token public address for specified FIO Address.
     *
     * @param fioAddress FIO Address for which fio token public address is to be returned.
     */ getFioPublicAddress(fioAddress) {
        return this.getPublicAddress(fioAddress, "FIO", "FIO");
    }
    /**
     *
     * Transfers FIO tokens from public key associated with the FIO SDK instance to
     * the payeePublicKey.
     *
     * @param payeeFioPublicKey FIO public Address of the one receiving the tokens.
     * @param amount Amount sent in SUFs.
     * @param maxFee Maximum amount of SUFs the user is willing to pay for fee. Should be preceded by /get_fee for correct value.
     * @param technologyProviderId FIO Address of the wallet which generates this transaction.
     */ transferTokens(payeeFioPublicKey, amount, maxFee, technologyProviderId = null) {
        const transferTokens = new $vwBbb.TransferTokens(payeeFioPublicKey, amount, maxFee, this.getTechnologyProviderId(technologyProviderId));
        return transferTokens.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param endPoint Name of API call end point, e.g. add_pub_address.
     * @param fioAddress
     *        if endPointName is RenewFioAddress, FIO Address incurring the fee and owned by signer.
     *        if endPointName is RenewFioDomain, FIO Domain incurring the fee and owned by signer.
     *        if endPointName is RecordObtData, Payer FIO Address incurring the fee and owned by signer.
     *
     *        Omit for:
     *        - register_fio_domain
     *        - register_fio_address
     *        - transfer_tokens_pub_key
     */ getFee(endPoint, fioAddress = "") {
        const fioFee = new $PZcro.GetFee(endPoint, fioAddress);
        return fioFee.execute(this.publicKey);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param payerFioAddress, Payer FIO Address incurring the fee and owned by signer.
     */ getFeeForRecordObtData(payerFioAddress) {
        return this.getFee($2NvO7.EndPoint.recordObtData, payerFioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param payeeFioAddress Payee FIO Address incurring the fee and owned by signer.
     */ getFeeForNewFundsRequest(payeeFioAddress) {
        return this.getFee($2NvO7.EndPoint.newFundsRequest, payeeFioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param payerFioAddress Payer FIO Address incurring the fee and owned by signer.
     */ getFeeForRejectFundsRequest(payerFioAddress) {
        return this.getFee($2NvO7.EndPoint.rejectFundsRequest, payerFioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForAddPublicAddress(fioAddress) {
        return this.getFee($2NvO7.EndPoint.addPubAddress, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForCancelFundsRequest(fioAddress) {
        return this.getFee($2NvO7.EndPoint.cancelFundsRequest, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForRemovePublicAddresses(fioAddress) {
        return this.getFee($2NvO7.EndPoint.removePubAddress, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForRemoveAllPublicAddresses(fioAddress) {
        return this.getFee($2NvO7.EndPoint.removeAllPubAddresses, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForBurnFioAddress(fioAddress) {
        return this.getFee($2NvO7.EndPoint.burnFioAddress, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForTransferFioAddress(fioAddress) {
        return this.getFee($2NvO7.EndPoint.transferFioAddress, fioAddress);
    }
    /**
     * Compute and return fee amount for specific call and specific user
     *
     * @param fioAddress FIO Address incurring the fee and owned by signer.
     */ getFeeForTransferFioDomain(fioAddress) {
        return this.getFee($2NvO7.EndPoint.transferFioDomain, fioAddress);
    }
    /**
     * @ignore
     */ registerFioNameOnBehalfOfUser(fioName, publicKey) {
        const server = this.registerMockUrl; // "mock.dapix.io/mockd/DEV2"
        const mockRegisterFioName = new $5Wi28.MockRegisterFioName(fioName, publicKey, server);
        return mockRegisterFioName.execute();
    }
    /**
     * @ignore
     */ getMultiplier() {
        return $6I0rv.Constants.multiplier;
    }
    /**
     * Allows advance user to send their own content directly to FIO contracts
     *
     * @param account Account name
     * @param action Name of action
     * @param data JSON object with params for action
     */ pushTransaction(account, action, data) {
        data.tpid = this.getTechnologyProviderId(data.tpid);
        const pushTransaction = new $vwBbb.PushTransaction(action, account, data);
        return pushTransaction.execute(this.privateKey, this.publicKey, this.returnPreparedTrx);
    }
    /**
     * @ignore
     */ genericAction(action, params) {
        switch(action){
            case "getFioPublicKey":
                return this.getFioPublicKey();
            case "registerFioAddress":
                if (params.ownerPublicKey) return this.registerOwnerFioAddress(params.fioAddress, params.ownerPublicKey, params.maxFee, params.technologyProviderId);
                else return this.registerFioAddress(params.fioAddress, params.maxFee, params.technologyProviderId);
            case "registerOwnerFioAddress":
                return this.registerOwnerFioAddress(params.fioAddress, params.ownerPublicKey, params.maxFee, params.technologyProviderId);
            case "registerFioDomain":
                return this.registerFioDomain(params.fioDomain, params.maxFee, params.technologyProviderId);
            case "registerOwnerFioDomain":
                return this.registerOwnerFioDomain(params.fioDomain, params.ownerPublicKey, params.maxFee, params.technologyProviderId);
            case "renewFioDomain":
                return this.renewFioDomain(params.fioDomain, params.maxFee, params.technologyProviderId);
            case "renewFioAddress":
                return this.renewFioAddress(params.fioAddress, params.maxFee, params.technologyProviderId);
            case "burnFioAddress":
                return this.burnFioAddress(params.fioAddress, params.maxFee, params.technologyProviderId);
            case "transferFioAddress":
                return this.transferFioAddress(params.fioAddress, params.newOwnerKey, params.maxFee, params.technologyProviderId);
            case "transferFioDomain":
                return this.transferFioDomain(params.fioDomain, params.newOwnerKey, params.maxFee, params.technologyProviderId);
            case "addPublicAddress":
                return this.addPublicAddress(params.fioAddress, params.chainCode, params.tokenCode, params.publicAddress, params.maxFee, params.technologyProviderId);
            case "addPublicAddresses":
                return this.addPublicAddresses(params.fioAddress, params.publicAddresses, params.maxFee, params.technologyProviderId);
            case "removePublicAddresses":
                return this.removePublicAddresses(params.fioAddress, params.publicAddresses, params.maxFee, params.technologyProviderId);
            case "cancelFundsRequest":
                return this.cancelFundsRequest(params.fioRequestId, params.maxFee, params.technologyProviderId);
            case "removeAllPublicAddresses":
                return this.removeAllPublicAddresses(params.fioAddress, params.maxFee, params.technologyProviderId);
            case "setFioDomainVisibility":
                return this.setFioDomainVisibility(params.fioDomain, params.isPublic, params.maxFee, params.technologyProviderId);
            case "recordObtData":
                return this.recordObtData(params.fioRequestId || null, params.payerFioAddress, params.payeeFioAddress, params.payerTokenPublicAddress, params.payeeTokenPublicAddress, params.amount, params.chainCode, params.tokenCode, params.status || "", params.obtId, params.maxFee, params.technologyProviderId, params.payeeFioPublicKey, params.memo, params.hash, params.offLineUrl);
            case "getObtData":
                return this.getObtData(params.limit, params.offset, params.tokenCode);
            case "rejectFundsRequest":
                return this.rejectFundsRequest(params.fioRequestId, params.maxFee, params.technologyProviderId);
            case "requestFunds":
                return this.requestFunds(params.payerFioAddress, params.payeeFioAddress, params.payeeTokenPublicAddress, params.amount, params.chainCode, params.tokenCode, params.memo, params.maxFee, params.payerFioPublicKey, params.technologyProviderId, params.hash, params.offlineUrl);
            case "isAvailable":
                return this.isAvailable(params.fioName);
            case "getFioBalance":
                if (params) return this.getFioBalance(params.fioPublicKey);
                else return this.getFioBalance();
            case "getFioNames":
                return this.getFioNames(params.fioPublicKey);
            case "getFioDomains":
                return this.getFioDomains(params.fioPublicKey, params.limit, params.offset);
            case "getFioAddresses":
                return this.getFioAddresses(params.fioPublicKey, params.limit, params.offset);
            case "getPendingFioRequests":
                return this.getPendingFioRequests(params.limit, params.offset);
            case "getCancelledFioRequests":
                return this.getCancelledFioRequests(params.limit, params.offset);
            case "getSentFioRequests":
                return this.getSentFioRequests(params.limit, params.offset);
            case "getPublicAddress":
                return this.getPublicAddress(params.fioAddress, params.chainCode, params.tokenCode);
            case "transferTokens":
                return this.transferTokens(params.payeeFioPublicKey, params.amount, params.maxFee, params.technologyProviderId);
            case "getFee":
                return this.getFee(params.endPoint, params.fioAddress);
            case "getFeeForRecordObtData":
                return this.getFeeForRecordObtData(params.payerFioAddress);
            case "getFeeForNewFundsRequest":
                return this.getFeeForNewFundsRequest(params.payeeFioAddress);
            case "getFeeForRejectFundsRequest":
                return this.getFeeForRejectFundsRequest(params.payerFioAddress);
            case "getFeeForBurnFioAddress":
                return this.getFeeForBurnFioAddress(params.fioAddress);
            case "getFeeForTransferFioAddress":
                return this.getFeeForTransferFioAddress(params.fioAddress);
            case "getFeeForTransferFioDomain":
                return this.getFeeForTransferFioDomain(params.fioAddress);
            case "getFeeForAddPublicAddress":
                return this.getFeeForAddPublicAddress(params.fioAddress);
            case "getFeeForCancelFundsRequest":
                return this.getFeeForCancelFundsRequest(params.fioAddress);
            case "getFeeForRemovePublicAddresses":
                return this.getFeeForRemovePublicAddresses(params.fioAddress);
            case "getFeeForRemoveAllPublicAddresses":
                return this.getFeeForRemoveAllPublicAddresses(params.fioAddress);
            case "getMultiplier":
                return this.getMultiplier();
            case "pushTransaction":
                return this.pushTransaction(params.account, params.action, params.data);
        }
    }
    /**
     * @ignore
     */ getAbi(accountName) {
        const abi = new $PZcro.GetAbi(accountName);
        return abi.execute(this.publicKey);
    }
}
module.exports.FIOSDK = $8a1955991d3656b8$var$FIOSDK;
/**
 * SUFs = Smallest Units of FIO
 */ $8a1955991d3656b8$var$FIOSDK.SUFUnit = 1000000000;

});
parcelRegister("fXcze", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3I0qg = parcelRequire("3I0qg");
module.exports.Api = $3I0qg.Api;

var $1gRhS = parcelRequire("1gRhS");
module.exports.Fio = $1gRhS;

var $lTpt4 = parcelRequire("lTpt4");
module.exports.ApiInterfaces = $lTpt4;

var $ltQVr = parcelRequire("ltQVr");
module.exports.Numeric = $ltQVr;

var $03gud = parcelRequire("03gud");
module.exports.RpcInterfaces = $03gud;

var $hXehy = parcelRequire("hXehy");
module.exports.RpcError = $hXehy.RpcError;

var $bF5vy = parcelRequire("bF5vy");
module.exports.Serialize = $bF5vy;

var $jOsMe = parcelRequire("jOsMe");
module.exports.Ecc = $jOsMe;

});
parcelRegister("3I0qg", function(module, exports) {
"use strict";
/**
 * @module FIO
 */ // copyright defined in fiojs/LICENSE.txt
var $2b35cf170b69c5b1$var$__assign = module.exports && module.exports.__assign || function() {
    $2b35cf170b69c5b1$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2b35cf170b69c5b1$var$__assign.apply(this, arguments);
};
var $2b35cf170b69c5b1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2b35cf170b69c5b1$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2b35cf170b69c5b1$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2b35cf170b69c5b1$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $2b35cf170b69c5b1$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2b35cf170b69c5b1$var$__read(arguments[i]));
    return ar;
};
var $2b35cf170b69c5b1$var$__values = module.exports && module.exports.__values || function(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bF5vy = parcelRequire("bF5vy");

var $5ZH60 = parcelRequire("5ZH60");

var $5jtNL = parcelRequire("5jtNL");
var $2b35cf170b69c5b1$var$Api = /** @class */ function() {
    /**
     * @param args
     *    * `authorityProvider`: Get public keys needed to meet authorities in a transaction
     *    * `abiProvider`: Supplies ABIs in raw form (binary)
     *    * `signatureProvider`: Signs transactions
     *    * `chainId`: Identifies chain
     *    * `textEncoder`: `TextEncoder` instance to use. Pass in `null` if running in a browser
     *    * `textDecoder`: `TextDecoder` instance to use. Pass in `null` if running in a browser
     */ function Api(args) {
        /** Holds information needed to serialize contract actions */ this.contracts = new Map();
        /** Fetched abis */ this.cachedAbis = new Map();
        this.authorityProvider = args.authorityProvider;
        this.abiProvider = args.abiProvider;
        this.signatureProvider = args.signatureProvider;
        this.chainId = args.chainId;
        this.textEncoder = args.textEncoder;
        this.textDecoder = args.textDecoder;
        this.abiTypes = $bF5vy.getTypesFromAbi($bF5vy.createInitialTypes(), $5ZH60);
        this.transactionTypes = $bF5vy.getTypesFromAbi($bF5vy.createInitialTypes(), $5jtNL);
    }
    /** Decodes an abi as Uint8Array into json. */ Api.prototype.rawAbiToJson = function(rawAbi) {
        var buffer = new $bF5vy.SerialBuffer({
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder,
            array: rawAbi
        });
        if (!$bF5vy.supportedAbiVersion(buffer.getString())) throw new Error("Unsupported abi version");
        buffer.restartRead();
        return this.abiTypes.get("abi_def").deserialize(buffer);
    };
    /** Get abi in both binary and structured forms. Reload from AbiProvider when needed. */ Api.prototype.getCachedAbi = function(accountName, reload) {
        if (reload === void 0) reload = false;
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var cachedAbi, rawAbi, abi, e_1;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!reload && this.cachedAbis.get(accountName)) return [
                            2 /*return*/ ,
                            this.cachedAbis.get(accountName)
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.abiProvider.getRawAbi(accountName)
                        ];
                    case 2:
                        rawAbi = _a.sent().abi;
                        abi = this.rawAbiToJson(rawAbi);
                        cachedAbi = {
                            rawAbi: rawAbi,
                            abi: abi
                        };
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        e_1 = _a.sent();
                        e_1.message = "abiProvider for " + accountName + ": " + e_1.message;
                        throw e_1;
                    case 4:
                        if (!cachedAbi) throw new Error("Missing abi for " + accountName);
                        this.cachedAbis.set(accountName, cachedAbi);
                        return [
                            2 /*return*/ ,
                            cachedAbi
                        ];
                }
            });
        });
    };
    /** Get abi in structured form. Reload from AbiProvider when needed. */ Api.prototype.getAbi = function(accountName, reload) {
        if (reload === void 0) reload = false;
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getCachedAbi(accountName, reload)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent().abi
                        ];
                }
            });
        });
    };
    /** Get abis needed by a transaction */ Api.prototype.getTransactionAbis = function(transaction, reload) {
        if (reload === void 0) reload = false;
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var actions, accounts, uniqueAccounts, actionPromises;
            var _this = this;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                actions = (transaction.context_free_actions || []).concat(transaction.actions);
                accounts = actions.map(function(action) {
                    return action.account;
                });
                uniqueAccounts = new Set(accounts);
                actionPromises = $2b35cf170b69c5b1$var$__spread(uniqueAccounts).map(function(account) {
                    return $2b35cf170b69c5b1$var$__awaiter(_this, void 0, void 0, function() {
                        var _a;
                        return $2b35cf170b69c5b1$var$__generator(this, function(_b) {
                            switch(_b.label){
                                case 0:
                                    _a = {
                                        accountName: account
                                    };
                                    return [
                                        4 /*yield*/ ,
                                        this.getCachedAbi(account, reload)
                                    ];
                                case 1:
                                    return [
                                        2 /*return*/ ,
                                        (_a.abi = _b.sent().rawAbi, _a)
                                    ];
                            }
                        });
                    });
                });
                return [
                    2 /*return*/ ,
                    Promise.all(actionPromises)
                ];
            });
        });
    };
    /** Get data needed to serialize actions in a contract */ Api.prototype.getContract = function(accountName, reload) {
        if (reload === void 0) reload = false;
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var e_2, _a, abi, types, actions, _b, _c, _d, name_1, type, result;
            return $2b35cf170b69c5b1$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!reload && this.contracts.get(accountName)) return [
                            2 /*return*/ ,
                            this.contracts.get(accountName)
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAbi(accountName, reload)
                        ];
                    case 1:
                        abi = _e.sent();
                        types = $bF5vy.getTypesFromAbi($bF5vy.createInitialTypes(), abi);
                        actions = new Map();
                        try {
                            for(_b = $2b35cf170b69c5b1$var$__values(abi.actions), _c = _b.next(); !_c.done; _c = _b.next()){
                                _d = _c.value, name_1 = _d.name, type = _d.type;
                                actions.set(name_1, $bF5vy.getType(types, type));
                            }
                        } catch (e_2_1) {
                            e_2 = {
                                error: e_2_1
                            };
                        } finally{
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            } finally{
                                if (e_2) throw e_2.error;
                            }
                        }
                        result = {
                            types: types,
                            actions: actions
                        };
                        this.contracts.set(accountName, result);
                        return [
                            2 /*return*/ ,
                            result
                        ];
                }
            });
        });
    };
    /** Convert `value` to binary form. `type` must be a built-in abi type or in `transaction.abi.json`. */ Api.prototype.serialize = function(buffer, type, value) {
        this.transactionTypes.get(type).serialize(buffer, value);
    };
    /** Convert data in `buffer` to structured form. `type` must be a built-in abi type or in `transaction.abi.json`. */ Api.prototype.deserialize = function(buffer, type) {
        return this.transactionTypes.get(type).deserialize(buffer);
    };
    /** Convert a transaction to binary */ Api.prototype.serializeTransaction = function(transaction) {
        var buffer = new $bF5vy.SerialBuffer({
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder
        });
        this.serialize(buffer, "transaction", $2b35cf170b69c5b1$var$__assign({
            max_net_usage_words: 0,
            max_cpu_usage_ms: 0,
            delay_sec: 0,
            context_free_actions: [],
            actions: [],
            transaction_extensions: []
        }, transaction));
        return buffer.asUint8Array();
    };
    /** Serialize context-free data */ Api.prototype.serializeContextFreeData = function(contextFreeData) {
        var e_3, _a;
        if (!contextFreeData || !contextFreeData.length) return null;
        var buffer = new $bF5vy.SerialBuffer({
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder
        });
        buffer.pushVaruint32(contextFreeData.length);
        try {
            for(var contextFreeData_1 = $2b35cf170b69c5b1$var$__values(contextFreeData), contextFreeData_1_1 = contextFreeData_1.next(); !contextFreeData_1_1.done; contextFreeData_1_1 = contextFreeData_1.next()){
                var data = contextFreeData_1_1.value;
                buffer.pushBytes(data);
            }
        } catch (e_3_1) {
            e_3 = {
                error: e_3_1
            };
        } finally{
            try {
                if (contextFreeData_1_1 && !contextFreeData_1_1.done && (_a = contextFreeData_1.return)) _a.call(contextFreeData_1);
            } finally{
                if (e_3) throw e_3.error;
            }
        }
        return buffer.asUint8Array();
    };
    /** Convert a transaction from binary. Leaves actions in hex. */ Api.prototype.deserializeTransaction = function(transaction) {
        var buffer = new $bF5vy.SerialBuffer({
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder
        });
        buffer.pushArray(transaction);
        return this.deserialize(buffer, "transaction");
    };
    /** Convert actions to hex */ Api.prototype.serializeActions = function(actions) {
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(actions.map(function(_a) {
                                var account = _a.account, name = _a.name, authorization = _a.authorization, data = _a.data;
                                return $2b35cf170b69c5b1$var$__awaiter(_this, void 0, void 0, function() {
                                    var contract;
                                    return $2b35cf170b69c5b1$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getContract(account)
                                                ];
                                            case 1:
                                                contract = _b.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    $bF5vy.serializeAction(contract, account, name, authorization, data, this.textEncoder, this.textDecoder)
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** Convert actions from hex */ Api.prototype.deserializeActions = function(actions) {
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            Promise.all(actions.map(function(_a) {
                                var account = _a.account, name = _a.name, authorization = _a.authorization, data = _a.data;
                                return $2b35cf170b69c5b1$var$__awaiter(_this, void 0, void 0, function() {
                                    var contract;
                                    return $2b35cf170b69c5b1$var$__generator(this, function(_b) {
                                        switch(_b.label){
                                            case 0:
                                                return [
                                                    4 /*yield*/ ,
                                                    this.getContract(account)
                                                ];
                                            case 1:
                                                contract = _b.sent();
                                                return [
                                                    2 /*return*/ ,
                                                    $bF5vy.deserializeAction(contract, account, name, authorization, data, this.textEncoder, this.textDecoder)
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    /** Convert a transaction from binary. Also deserializes actions. */ Api.prototype.deserializeTransactionWithActions = function(transaction) {
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var deserializedTransaction, deserializedCFActions, deserializedActions;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (typeof transaction === "string") transaction = $bF5vy.hexToUint8Array(transaction);
                        deserializedTransaction = this.deserializeTransaction(transaction);
                        return [
                            4 /*yield*/ ,
                            this.deserializeActions(deserializedTransaction.context_free_actions)
                        ];
                    case 1:
                        deserializedCFActions = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.deserializeActions(deserializedTransaction.actions)
                        ];
                    case 2:
                        deserializedActions = _a.sent();
                        return [
                            2 /*return*/ ,
                            $2b35cf170b69c5b1$var$__assign({}, deserializedTransaction, {
                                context_free_actions: deserializedCFActions,
                                actions: deserializedActions
                            })
                        ];
                }
            });
        });
    };
    /**
     * Create a transaction.
     *
     * Named Parameters:
     *    * `sign`: sign this transaction?
     * @returns `{signatures, serializedTransaction}`
     */ Api.prototype.transact = function(transaction, _a) {
        var _b = (_a === void 0 ? {} : _a).sign, sign = _b === void 0 ? true : _b;
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var info, abis, _c, _d, serializedTransaction, serializedContextFreeData, pushTransactionArgs, availableKeys, requiredKeys;
            return $2b35cf170b69c5b1$var$__generator(this, function(_e) {
                switch(_e.label){
                    case 0:
                        if (!this.hasRequiredTaposFields(transaction)) throw new Error("Required configuration or TAPOS fields are not present");
                        return [
                            4 /*yield*/ ,
                            this.getTransactionAbis(transaction)
                        ];
                    case 1:
                        abis = _e.sent();
                        _c = [
                            {},
                            transaction
                        ];
                        _d = {};
                        return [
                            4 /*yield*/ ,
                            this.serializeActions(transaction.context_free_actions || [])
                        ];
                    case 2:
                        _d.context_free_actions = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this.serializeActions(transaction.actions)
                        ];
                    case 3:
                        transaction = $2b35cf170b69c5b1$var$__assign.apply(void 0, _c.concat([
                            (_d.actions = _e.sent(), _d)
                        ]));
                        serializedTransaction = this.serializeTransaction(transaction);
                        serializedContextFreeData = this.serializeContextFreeData(transaction.context_free_data);
                        pushTransactionArgs = {
                            serializedTransaction: serializedTransaction,
                            serializedContextFreeData: serializedContextFreeData,
                            signatures: []
                        };
                        if (!sign) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            this.signatureProvider.getAvailableKeys()
                        ];
                    case 4:
                        availableKeys = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this.authorityProvider.getRequiredKeys({
                                transaction: transaction,
                                availableKeys: availableKeys
                            })
                        ];
                    case 5:
                        requiredKeys = _e.sent();
                        return [
                            4 /*yield*/ ,
                            this.signatureProvider.sign({
                                chainId: this.chainId,
                                requiredKeys: requiredKeys,
                                serializedTransaction: serializedTransaction,
                                serializedContextFreeData: serializedContextFreeData,
                                abis: abis
                            })
                        ];
                    case 6:
                        pushTransactionArgs = _e.sent();
                        _e.label = 7;
                    case 7:
                        return [
                            2 /*return*/ ,
                            pushTransactionArgs
                        ];
                }
            });
        });
    };
    // eventually break out into TransactionValidator class
    Api.prototype.hasRequiredTaposFields = function(_a) {
        var expiration = _a.expiration, ref_block_num = _a.ref_block_num, ref_block_prefix = _a.ref_block_prefix, transaction = $2b35cf170b69c5b1$var$__rest(_a, [
            "expiration",
            "ref_block_num",
            "ref_block_prefix"
        ]);
        return !!(expiration && ref_block_num && ref_block_prefix);
    };
    return Api;
}(); // Api
module.exports.Api = $2b35cf170b69c5b1$var$Api;
/**
    Simple authority provider that signs with all provided keys.

    If their more availableKeys than are required to sign then the get_required_keys
    rpc call is required to filter them (tests/chain-jsonrpc.ts
    getRequiredKeys(authorityProviderArgs))
*/ module.exports.signAllAuthorityProvider = {
    getRequiredKeys: function(authorityProviderArgs) {
        return $2b35cf170b69c5b1$var$__awaiter(this, void 0, void 0, function() {
            var availableKeys;
            return $2b35cf170b69c5b1$var$__generator(this, function(_a) {
                availableKeys = authorityProviderArgs.availableKeys;
                return [
                    2 /*return*/ ,
                    availableKeys
                ];
            });
        });
    }
};

});
parcelRegister("bF5vy", function(module, exports) {
"use strict";
/**
 * @module Serialize
 */ // copyright defined in fiojs/LICENSE.txt
var $87d7cbc9cdedc1f2$var$__assign = module.exports && module.exports.__assign || function() {
    $87d7cbc9cdedc1f2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $87d7cbc9cdedc1f2$var$__assign.apply(this, arguments);
};
var $87d7cbc9cdedc1f2$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $87d7cbc9cdedc1f2$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($87d7cbc9cdedc1f2$var$__read(arguments[i]));
    return ar;
};
var $87d7cbc9cdedc1f2$var$__values = module.exports && module.exports.__values || function(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ltQVr = parcelRequire("ltQVr");
/** State for serialize() and deserialize() */ var $87d7cbc9cdedc1f2$var$SerializerState = /** @class */ function() {
    function SerializerState(options) {
        if (options === void 0) options = {};
        /** Have any binary extensions been skipped? */ this.skippedBinaryExtension = false;
        this.options = options;
    }
    return SerializerState;
}();
module.exports.SerializerState = $87d7cbc9cdedc1f2$var$SerializerState;
/** Serialize and deserialize data */ var $87d7cbc9cdedc1f2$var$SerialBuffer = /** @class */ function() {
    /**
     * @param __namedParameters
     *    * `array`: `null` if serializing, or binary data to deserialize
     *    * `textEncoder`: `TextEncoder` instance to use. Pass in `null` if running in a browser
     *    * `textDecoder`: `TextDecider` instance to use. Pass in `null` if running in a browser
     */ function SerialBuffer(_a) {
        var _b = _a === void 0 ? {} : _a, textEncoder = _b.textEncoder, textDecoder = _b.textDecoder, array = _b.array;
        /** Current position while reading (deserializing) */ this.readPos = 0;
        this.array = array || new Uint8Array(1024);
        this.length = array ? array.length : 0;
        this.textEncoder = textEncoder || new TextEncoder();
        this.textDecoder = textDecoder || new TextDecoder("utf-8", {
            fatal: true
        });
    }
    /** Resize `array` if needed to have at least `size` bytes free */ SerialBuffer.prototype.reserve = function(size) {
        if (this.length + size <= this.array.length) return;
        var l = this.array.length;
        while(this.length + size > l)l = Math.ceil(l * 1.5);
        var newArray = new Uint8Array(l);
        newArray.set(this.array);
        this.array = newArray;
    };
    /** Is there data available to read? */ SerialBuffer.prototype.haveReadData = function() {
        return this.readPos < this.length;
    };
    /** Restart reading from the beginning */ SerialBuffer.prototype.restartRead = function() {
        this.readPos = 0;
    };
    /** Return data with excess storage trimmed away */ SerialBuffer.prototype.asUint8Array = function() {
        return new Uint8Array(this.array.buffer, this.array.byteOffset, this.length);
    };
    /** Append bytes */ SerialBuffer.prototype.pushArray = function(v) {
        this.reserve(v.length);
        this.array.set(v, this.length);
        this.length += v.length;
    };
    /** Append bytes */ SerialBuffer.prototype.push = function() {
        var v = [];
        for(var _i = 0; _i < arguments.length; _i++)v[_i] = arguments[_i];
        this.pushArray(v);
    };
    /** Get a single byte */ SerialBuffer.prototype.get = function() {
        if (this.readPos < this.length) return this.array[this.readPos++];
        throw new Error("Read past end of buffer");
    };
    /** Append bytes in `v`. Throws if `len` doesn't match `v.length` */ SerialBuffer.prototype.pushUint8ArrayChecked = function(v, len) {
        if (v.length !== len) throw new Error("Binary data has incorrect size");
        this.pushArray(v);
    };
    /** Get `len` bytes */ SerialBuffer.prototype.getUint8Array = function(len) {
        if (this.readPos + len > this.length) throw new Error("Read past end of buffer");
        var result = new Uint8Array(this.array.buffer, this.array.byteOffset + this.readPos, len);
        this.readPos += len;
        return result;
    };
    /** Append a `uint16` */ SerialBuffer.prototype.pushUint16 = function(v) {
        this.push(v >> 0 & 0xff, v >> 8 & 0xff);
    };
    /** Get a `uint16` */ SerialBuffer.prototype.getUint16 = function() {
        var v = 0;
        v |= this.get() << 0;
        v |= this.get() << 8;
        return v;
    };
    /** Append a `uint32` */ SerialBuffer.prototype.pushUint32 = function(v) {
        this.push(v >> 0 & 0xff, v >> 8 & 0xff, v >> 16 & 0xff, v >> 24 & 0xff);
    };
    /** Get a `uint32` */ SerialBuffer.prototype.getUint32 = function() {
        var v = 0;
        v |= this.get() << 0;
        v |= this.get() << 8;
        v |= this.get() << 16;
        v |= this.get() << 24;
        return v >>> 0;
    };
    /** Append a `uint64`. *Caution*: `number` only has 53 bits of precision */ SerialBuffer.prototype.pushNumberAsUint64 = function(v) {
        this.pushUint32(v >>> 0);
        this.pushUint32(Math.floor(v / 4294967296) >>> 0);
    };
    /**
     * Get a `uint64` as a `number`. *Caution*: `number` only has 53 bits of precision; some values will change.
     * `numeric.binaryToDecimal(serialBuffer.getUint8Array(8))` recommended instead
     */ SerialBuffer.prototype.getUint64AsNumber = function() {
        var low = this.getUint32();
        var high = this.getUint32();
        return (high >>> 0) * 4294967296 + (low >>> 0);
    };
    /** Append a `varuint32` */ SerialBuffer.prototype.pushVaruint32 = function(v) {
        while(true)if (v >>> 7) {
            this.push(0x80 | v & 0x7f);
            v = v >>> 7;
        } else {
            this.push(v);
            break;
        }
    };
    /** Get a `varuint32` */ SerialBuffer.prototype.getVaruint32 = function() {
        var v = 0;
        var bit = 0;
        while(true){
            var b = this.get();
            v |= (b & 0x7f) << bit;
            bit += 7;
            if (!(b & 0x80)) break;
        }
        return v >>> 0;
    };
    /** Append a `varint32` */ SerialBuffer.prototype.pushVarint32 = function(v) {
        this.pushVaruint32(v << 1 ^ v >> 31);
    };
    /** Get a `varint32` */ SerialBuffer.prototype.getVarint32 = function() {
        var v = this.getVaruint32();
        if (v & 1) return ~v >> 1 | 2147483648;
        else return v >>> 1;
    };
    /** Append a `float32` */ SerialBuffer.prototype.pushFloat32 = function(v) {
        this.pushArray(new Uint8Array(new Float32Array([
            v
        ]).buffer));
    };
    /** Get a `float32` */ SerialBuffer.prototype.getFloat32 = function() {
        return new Float32Array(this.getUint8Array(4).slice().buffer)[0];
    };
    /** Append a `float64` */ SerialBuffer.prototype.pushFloat64 = function(v) {
        this.pushArray(new Uint8Array(new Float64Array([
            v
        ]).buffer));
    };
    /** Get a `float64` */ SerialBuffer.prototype.getFloat64 = function() {
        return new Float64Array(this.getUint8Array(8).slice().buffer)[0];
    };
    /** Append a `name` */ SerialBuffer.prototype.pushName = function(s) {
        if (typeof s !== "string") throw new Error("Expected string containing name");
        function charToSymbol(c) {
            if (c >= "a".charCodeAt(0) && c <= "z".charCodeAt(0)) return c - "a".charCodeAt(0) + 6;
            if (c >= "1".charCodeAt(0) && c <= "5".charCodeAt(0)) return c - "1".charCodeAt(0) + 1;
            return 0;
        }
        var a = new Uint8Array(8);
        var bit = 63;
        for(var i = 0; i < s.length; ++i){
            var c = charToSymbol(s.charCodeAt(i));
            if (bit < 5) c = c << 1;
            for(var j = 4; j >= 0; --j)if (bit >= 0) {
                a[Math.floor(bit / 8)] |= (c >> j & 1) << bit % 8;
                --bit;
            }
        }
        this.pushArray(a);
    };
    /** Get a `name` */ SerialBuffer.prototype.getName = function() {
        var a = this.getUint8Array(8);
        var result = "";
        for(var bit = 63; bit >= 0;){
            var c = 0;
            for(var i = 0; i < 5; ++i)if (bit >= 0) {
                c = c << 1 | a[Math.floor(bit / 8)] >> bit % 8 & 1;
                --bit;
            }
            if (c >= 6) result += String.fromCharCode(c + "a".charCodeAt(0) - 6);
            else if (c >= 1) result += String.fromCharCode(c + "1".charCodeAt(0) - 1);
            else result += ".";
        }
        while(result.endsWith("."))result = result.substr(0, result.length - 1);
        return result;
    };
    /** Append length-prefixed binary data */ SerialBuffer.prototype.pushBytes = function(v) {
        this.pushVaruint32(v.length);
        this.pushArray(v);
    };
    /** Get length-prefixed binary data */ SerialBuffer.prototype.getBytes = function() {
        return this.getUint8Array(this.getVaruint32());
    };
    /** Append a string */ SerialBuffer.prototype.pushString = function(v) {
        this.pushBytes(this.textEncoder.encode(v));
    };
    /** Get a string */ SerialBuffer.prototype.getString = function() {
        return this.textDecoder.decode(this.getBytes());
    };
    /** Append a `symbol_code`. Unlike `symbol`, `symbol_code` doesn't include a precision. */ SerialBuffer.prototype.pushSymbolCode = function(name) {
        if (typeof name !== "string") throw new Error("Expected string containing symbol_code");
        var a = [];
        a.push.apply(a, $87d7cbc9cdedc1f2$var$__spread(this.textEncoder.encode(name)));
        while(a.length < 8)a.push(0);
        this.pushArray(a.slice(0, 8));
    };
    /** Get a `symbol_code`. Unlike `symbol`, `symbol_code` doesn't include a precision. */ SerialBuffer.prototype.getSymbolCode = function() {
        var a = this.getUint8Array(8);
        var len;
        for(len = 0; len < a.length; ++len){
            if (!a[len]) break;
        }
        var name = this.textDecoder.decode(new Uint8Array(a.buffer, a.byteOffset, len));
        return name;
    };
    /** Append a `symbol` */ SerialBuffer.prototype.pushSymbol = function(_a) {
        var name = _a.name, precision = _a.precision;
        var a = [
            precision & 0xff
        ];
        a.push.apply(a, $87d7cbc9cdedc1f2$var$__spread(this.textEncoder.encode(name)));
        while(a.length < 8)a.push(0);
        this.pushArray(a.slice(0, 8));
    };
    /** Get a `symbol` */ SerialBuffer.prototype.getSymbol = function() {
        var precision = this.get();
        var a = this.getUint8Array(7);
        var len;
        for(len = 0; len < a.length; ++len){
            if (!a[len]) break;
        }
        var name = this.textDecoder.decode(new Uint8Array(a.buffer, a.byteOffset, len));
        return {
            name: name,
            precision: precision
        };
    };
    /** Append an asset */ SerialBuffer.prototype.pushAsset = function(s) {
        if (typeof s !== "string") throw new Error("Expected string containing asset");
        s = s.trim();
        var pos = 0;
        var amount = "";
        var precision = 0;
        if (s[pos] === "-") {
            amount += "-";
            ++pos;
        }
        var foundDigit = false;
        while(pos < s.length && s.charCodeAt(pos) >= "0".charCodeAt(0) && s.charCodeAt(pos) <= "9".charCodeAt(0)){
            foundDigit = true;
            amount += s[pos];
            ++pos;
        }
        if (!foundDigit) throw new Error("Asset must begin with a number");
        if (s[pos] === ".") {
            ++pos;
            while(pos < s.length && s.charCodeAt(pos) >= "0".charCodeAt(0) && s.charCodeAt(pos) <= "9".charCodeAt(0)){
                amount += s[pos];
                ++precision;
                ++pos;
            }
        }
        var name = s.substr(pos).trim();
        this.pushArray($ltQVr.signedDecimalToBinary(8, amount));
        this.pushSymbol({
            name: name,
            precision: precision
        });
    };
    /** Get an asset */ SerialBuffer.prototype.getAsset = function() {
        var amount = this.getUint8Array(8);
        var _a = this.getSymbol(), name = _a.name, precision = _a.precision;
        var s = $ltQVr.signedBinaryToDecimal(amount, precision + 1);
        if (precision) s = s.substr(0, s.length - precision) + "." + s.substr(s.length - precision);
        return s + " " + name;
    };
    /** Append a public key */ SerialBuffer.prototype.pushPublicKey = function(s) {
        var key = $ltQVr.stringToPublicKey(s);
        this.push(key.type);
        this.pushArray(key.data);
    };
    /** Get a public key */ SerialBuffer.prototype.getPublicKey = function() {
        var type = this.get();
        var data = this.getUint8Array($ltQVr.publicKeyDataSize);
        return $ltQVr.publicKeyToString({
            type: type,
            data: data
        });
    };
    /** Append a private key */ SerialBuffer.prototype.pushPrivateKey = function(s) {
        var key = $ltQVr.stringToPrivateKey(s);
        this.push(key.type);
        this.pushArray(key.data);
    };
    /** Get a private key */ SerialBuffer.prototype.getPrivateKey = function() {
        var type = this.get();
        var data = this.getUint8Array($ltQVr.privateKeyDataSize);
        return $ltQVr.privateKeyToString({
            type: type,
            data: data
        });
    };
    /** Append a signature */ SerialBuffer.prototype.pushSignature = function(s) {
        var key = $ltQVr.stringToSignature(s);
        this.push(key.type);
        this.pushArray(key.data);
    };
    /** Get a signature */ SerialBuffer.prototype.getSignature = function() {
        var type = this.get();
        var data = this.getUint8Array($ltQVr.signatureDataSize);
        return $ltQVr.signatureToString({
            type: type,
            data: data
        });
    };
    return SerialBuffer;
}(); // SerialBuffer
module.exports.SerialBuffer = $87d7cbc9cdedc1f2$var$SerialBuffer;
/** Is this a supported ABI version? */ function $87d7cbc9cdedc1f2$var$supportedAbiVersion(version) {
    return version.startsWith("eosio::abi/1.");
}
module.exports.supportedAbiVersion = $87d7cbc9cdedc1f2$var$supportedAbiVersion;
function $87d7cbc9cdedc1f2$var$checkDateParse(date) {
    var result = Date.parse(date);
    if (Number.isNaN(result)) throw new Error("Invalid time format");
    return result;
}
/** Convert date in ISO format to `time_point` (miliseconds since epoch) */ function $87d7cbc9cdedc1f2$var$dateToTimePoint(date) {
    return Math.round($87d7cbc9cdedc1f2$var$checkDateParse(date + "Z") * 1000);
}
module.exports.dateToTimePoint = $87d7cbc9cdedc1f2$var$dateToTimePoint;
/** Convert `time_point` (miliseconds since epoch) to date in ISO format */ function $87d7cbc9cdedc1f2$var$timePointToDate(us) {
    var s = new Date(us / 1000).toISOString();
    return s.substr(0, s.length - 1);
}
module.exports.timePointToDate = $87d7cbc9cdedc1f2$var$timePointToDate;
/** Convert date in ISO format to `time_point_sec` (seconds since epoch) */ function $87d7cbc9cdedc1f2$var$dateToTimePointSec(date) {
    return Math.round($87d7cbc9cdedc1f2$var$checkDateParse(date + "Z") / 1000);
}
module.exports.dateToTimePointSec = $87d7cbc9cdedc1f2$var$dateToTimePointSec;
/** Convert `time_point_sec` (seconds since epoch) to to date in ISO format */ function $87d7cbc9cdedc1f2$var$timePointSecToDate(sec) {
    var s = new Date(sec * 1000).toISOString();
    return s.substr(0, s.length - 1);
}
module.exports.timePointSecToDate = $87d7cbc9cdedc1f2$var$timePointSecToDate;
/** Convert date in ISO format to `block_timestamp_type` (half-seconds since a different epoch) */ function $87d7cbc9cdedc1f2$var$dateToBlockTimestamp(date) {
    return Math.round(($87d7cbc9cdedc1f2$var$checkDateParse(date + "Z") - 946684800000) / 500);
}
module.exports.dateToBlockTimestamp = $87d7cbc9cdedc1f2$var$dateToBlockTimestamp;
/** Convert `block_timestamp_type` (half-seconds since a different epoch) to to date in ISO format */ function $87d7cbc9cdedc1f2$var$blockTimestampToDate(slot) {
    var s = new Date(slot * 500 + 946684800000).toISOString();
    return s.substr(0, s.length - 1);
}
module.exports.blockTimestampToDate = $87d7cbc9cdedc1f2$var$blockTimestampToDate;
/** Convert `string` to `Symbol`. format: `precision,NAME`. */ function $87d7cbc9cdedc1f2$var$stringToSymbol(s) {
    if (typeof s !== "string") throw new Error("Expected string containing symbol");
    var m = s.match(/^([0-9]+),([A-Z]+)$/);
    if (!m) throw new Error("Invalid symbol");
    return {
        name: m[2],
        precision: +m[1]
    };
}
module.exports.stringToSymbol = $87d7cbc9cdedc1f2$var$stringToSymbol;
/** Convert `Symbol` to `string`. format: `precision,NAME`. */ function $87d7cbc9cdedc1f2$var$symbolToString(_a) {
    var name = _a.name, precision = _a.precision;
    return precision + "," + name;
}
module.exports.symbolToString = $87d7cbc9cdedc1f2$var$symbolToString;
/** Convert binary data to hex */ function $87d7cbc9cdedc1f2$var$arrayToHex(data) {
    var e_1, _a;
    var result = "";
    try {
        for(var data_1 = $87d7cbc9cdedc1f2$var$__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
            var x = data_1_1.value;
            result += ("00" + x.toString(16)).slice(-2);
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    return result.toUpperCase();
}
module.exports.arrayToHex = $87d7cbc9cdedc1f2$var$arrayToHex;
/** Convert hex to binary data */ function $87d7cbc9cdedc1f2$var$hexToUint8Array(hex) {
    if (typeof hex !== "string") throw new Error("Expected string containing hex digits");
    if (hex.length % 2) throw new Error("Odd number of hex digits");
    var l = hex.length / 2;
    var result = new Uint8Array(l);
    for(var i = 0; i < l; ++i){
        var x = parseInt(hex.substr(i * 2, 2), 16);
        if (Number.isNaN(x)) throw new Error("Expected hex string");
        result[i] = x;
    }
    return result;
}
module.exports.hexToUint8Array = $87d7cbc9cdedc1f2$var$hexToUint8Array;
function $87d7cbc9cdedc1f2$var$serializeUnknown(buffer, data) {
    throw new Error("Don't know how to serialize " + this.name);
}
function $87d7cbc9cdedc1f2$var$deserializeUnknown(buffer) {
    throw new Error("Don't know how to deserialize " + this.name);
}
function $87d7cbc9cdedc1f2$var$serializeStruct(buffer, data, state, allowExtensions) {
    if (state === void 0) state = new $87d7cbc9cdedc1f2$var$SerializerState();
    if (allowExtensions === void 0) allowExtensions = true;
    var e_2, _a;
    if (typeof data !== "object") throw new Error("expected object containing data: " + JSON.stringify(data));
    if (this.base) this.base.serialize(buffer, data, state, allowExtensions);
    try {
        for(var _b = $87d7cbc9cdedc1f2$var$__values(this.fields), _c = _b.next(); !_c.done; _c = _b.next()){
            var field = _c.value;
            if (field.name in data) {
                if (state.skippedBinaryExtension) throw new Error("unexpected " + this.name + "." + field.name);
                field.type.serialize(buffer, data[field.name], state, allowExtensions && field === this.fields[this.fields.length - 1]);
            } else {
                if (allowExtensions && field.type.extensionOf) state.skippedBinaryExtension = true;
                else throw new Error("missing " + this.name + "." + field.name + " (type=" + field.type.name + ")");
            }
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
}
function $87d7cbc9cdedc1f2$var$deserializeStruct(buffer, state, allowExtensions) {
    if (state === void 0) state = new $87d7cbc9cdedc1f2$var$SerializerState();
    if (allowExtensions === void 0) allowExtensions = true;
    var e_3, _a;
    var result;
    if (this.base) result = this.base.deserialize(buffer, state, allowExtensions);
    else result = {};
    try {
        for(var _b = $87d7cbc9cdedc1f2$var$__values(this.fields), _c = _b.next(); !_c.done; _c = _b.next()){
            var field = _c.value;
            if (allowExtensions && field.type.extensionOf && !buffer.haveReadData()) state.skippedBinaryExtension = true;
            else result[field.name] = field.type.deserialize(buffer, state, allowExtensions);
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return result;
}
function $87d7cbc9cdedc1f2$var$serializeVariant(buffer, data, state, allowExtensions) {
    if (!Array.isArray(data) || data.length !== 2 || typeof data[0] !== "string") throw new Error('expected variant: ["type", value]');
    var i = this.fields.findIndex(function(field) {
        return field.name === data[0];
    });
    if (i < 0) throw new Error('type "' + data[0] + '" is not valid for variant');
    buffer.pushVaruint32(i);
    this.fields[i].type.serialize(buffer, data[1], state, allowExtensions);
}
function $87d7cbc9cdedc1f2$var$deserializeVariant(buffer, state, allowExtensions) {
    var i = buffer.getVaruint32();
    if (i >= this.fields.length) throw new Error("type index " + i + " is not valid for variant");
    var field = this.fields[i];
    return [
        field.name,
        field.type.deserialize(buffer, state, allowExtensions)
    ];
}
function $87d7cbc9cdedc1f2$var$serializeArray(buffer, data, state, allowExtensions) {
    var e_4, _a;
    buffer.pushVaruint32(data.length);
    try {
        for(var data_2 = $87d7cbc9cdedc1f2$var$__values(data), data_2_1 = data_2.next(); !data_2_1.done; data_2_1 = data_2.next()){
            var item = data_2_1.value;
            this.arrayOf.serialize(buffer, item, state, false);
        }
    } catch (e_4_1) {
        e_4 = {
            error: e_4_1
        };
    } finally{
        try {
            if (data_2_1 && !data_2_1.done && (_a = data_2.return)) _a.call(data_2);
        } finally{
            if (e_4) throw e_4.error;
        }
    }
}
function $87d7cbc9cdedc1f2$var$deserializeArray(buffer, state, allowExtensions) {
    var len = buffer.getVaruint32();
    var result = [];
    for(var i = 0; i < len; ++i)result.push(this.arrayOf.deserialize(buffer, state, false));
    return result;
}
function $87d7cbc9cdedc1f2$var$serializeOptional(buffer, data, state, allowExtensions) {
    if (data === null || data === undefined) buffer.push(0);
    else {
        buffer.push(1);
        this.optionalOf.serialize(buffer, data, state, allowExtensions);
    }
}
function $87d7cbc9cdedc1f2$var$deserializeOptional(buffer, state, allowExtensions) {
    if (buffer.get()) return this.optionalOf.deserialize(buffer, state, allowExtensions);
    else return null;
}
function $87d7cbc9cdedc1f2$var$serializeExtension(buffer, data, state, allowExtensions) {
    this.extensionOf.serialize(buffer, data, state, allowExtensions);
}
function $87d7cbc9cdedc1f2$var$deserializeExtension(buffer, state, allowExtensions) {
    return this.extensionOf.deserialize(buffer, state, allowExtensions);
}
function $87d7cbc9cdedc1f2$var$createType(attrs) {
    return $87d7cbc9cdedc1f2$var$__assign({
        name: "<missing name>",
        aliasOfName: "",
        arrayOf: null,
        optionalOf: null,
        extensionOf: null,
        baseName: "",
        base: null,
        fields: [],
        serialize: $87d7cbc9cdedc1f2$var$serializeUnknown,
        deserialize: $87d7cbc9cdedc1f2$var$deserializeUnknown
    }, attrs);
}
function $87d7cbc9cdedc1f2$var$checkRange(orig, converted) {
    if (Number.isNaN(+orig) || Number.isNaN(+converted) || typeof orig !== "number" && typeof orig !== "string") throw new Error("Expected number");
    if (+orig !== +converted) throw new Error("Number is out of range");
    return +orig;
}
/** Create the set of types built-in to the abi format */ function $87d7cbc9cdedc1f2$var$createInitialTypes() {
    var result = new Map(Object.entries({
        bool: $87d7cbc9cdedc1f2$var$createType({
            name: "bool",
            serialize: function(buffer, data) {
                if (typeof data !== "boolean") throw new Error("Expected true or false");
                buffer.push(data ? 1 : 0);
            },
            deserialize: function(buffer) {
                return !!buffer.get();
            }
        }),
        uint8: $87d7cbc9cdedc1f2$var$createType({
            name: "uint8",
            serialize: function(buffer, data) {
                buffer.push($87d7cbc9cdedc1f2$var$checkRange(data, data & 0xff));
            },
            deserialize: function(buffer) {
                return buffer.get();
            }
        }),
        int8: $87d7cbc9cdedc1f2$var$createType({
            name: "int8",
            serialize: function(buffer, data) {
                buffer.push($87d7cbc9cdedc1f2$var$checkRange(data, data << 24 >> 24));
            },
            deserialize: function(buffer) {
                return buffer.get() << 24 >> 24;
            }
        }),
        uint16: $87d7cbc9cdedc1f2$var$createType({
            name: "uint16",
            serialize: function(buffer, data) {
                buffer.pushUint16($87d7cbc9cdedc1f2$var$checkRange(data, data & 0xffff));
            },
            deserialize: function(buffer) {
                return buffer.getUint16();
            }
        }),
        int16: $87d7cbc9cdedc1f2$var$createType({
            name: "int16",
            serialize: function(buffer, data) {
                buffer.pushUint16($87d7cbc9cdedc1f2$var$checkRange(data, data << 16 >> 16));
            },
            deserialize: function(buffer) {
                return buffer.getUint16() << 16 >> 16;
            }
        }),
        uint32: $87d7cbc9cdedc1f2$var$createType({
            name: "uint32",
            serialize: function(buffer, data) {
                buffer.pushUint32($87d7cbc9cdedc1f2$var$checkRange(data, data >>> 0));
            },
            deserialize: function(buffer) {
                return buffer.getUint32();
            }
        }),
        uint64: $87d7cbc9cdedc1f2$var$createType({
            name: "uint64",
            serialize: function(buffer, data) {
                buffer.pushArray($ltQVr.decimalToBinary(8, "" + data));
            },
            deserialize: function(buffer) {
                return $ltQVr.binaryToDecimal(buffer.getUint8Array(8));
            }
        }),
        int64: $87d7cbc9cdedc1f2$var$createType({
            name: "int64",
            serialize: function(buffer, data) {
                buffer.pushArray($ltQVr.signedDecimalToBinary(8, "" + data));
            },
            deserialize: function(buffer) {
                return $ltQVr.signedBinaryToDecimal(buffer.getUint8Array(8));
            }
        }),
        int32: $87d7cbc9cdedc1f2$var$createType({
            name: "int32",
            serialize: function(buffer, data) {
                buffer.pushUint32($87d7cbc9cdedc1f2$var$checkRange(data, data | 0));
            },
            deserialize: function(buffer) {
                return buffer.getUint32() | 0;
            }
        }),
        varuint32: $87d7cbc9cdedc1f2$var$createType({
            name: "varuint32",
            serialize: function(buffer, data) {
                buffer.pushVaruint32($87d7cbc9cdedc1f2$var$checkRange(data, data >>> 0));
            },
            deserialize: function(buffer) {
                return buffer.getVaruint32();
            }
        }),
        varint32: $87d7cbc9cdedc1f2$var$createType({
            name: "varint32",
            serialize: function(buffer, data) {
                buffer.pushVarint32($87d7cbc9cdedc1f2$var$checkRange(data, data | 0));
            },
            deserialize: function(buffer) {
                return buffer.getVarint32();
            }
        }),
        uint128: $87d7cbc9cdedc1f2$var$createType({
            name: "uint128",
            serialize: function(buffer, data) {
                buffer.pushArray($ltQVr.decimalToBinary(16, "" + data));
            },
            deserialize: function(buffer) {
                return $ltQVr.binaryToDecimal(buffer.getUint8Array(16));
            }
        }),
        int128: $87d7cbc9cdedc1f2$var$createType({
            name: "int128",
            serialize: function(buffer, data) {
                buffer.pushArray($ltQVr.signedDecimalToBinary(16, "" + data));
            },
            deserialize: function(buffer) {
                return $ltQVr.signedBinaryToDecimal(buffer.getUint8Array(16));
            }
        }),
        float32: $87d7cbc9cdedc1f2$var$createType({
            name: "float32",
            serialize: function(buffer, data) {
                buffer.pushFloat32(data);
            },
            deserialize: function(buffer) {
                return buffer.getFloat32();
            }
        }),
        float64: $87d7cbc9cdedc1f2$var$createType({
            name: "float64",
            serialize: function(buffer, data) {
                buffer.pushFloat64(data);
            },
            deserialize: function(buffer) {
                return buffer.getFloat64();
            }
        }),
        float128: $87d7cbc9cdedc1f2$var$createType({
            name: "float128",
            serialize: function(buffer, data) {
                buffer.pushUint8ArrayChecked($87d7cbc9cdedc1f2$var$hexToUint8Array(data), 16);
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.getUint8Array(16));
            }
        }),
        bytes: $87d7cbc9cdedc1f2$var$createType({
            name: "bytes",
            serialize: function(buffer, data) {
                if (data instanceof Uint8Array || Array.isArray(data)) buffer.pushBytes(data);
                else buffer.pushBytes($87d7cbc9cdedc1f2$var$hexToUint8Array(data));
            },
            deserialize: function(buffer, state) {
                if (state && state.options.bytesAsUint8Array) return buffer.getBytes();
                else return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.getBytes());
            }
        }),
        string: $87d7cbc9cdedc1f2$var$createType({
            name: "string",
            serialize: function(buffer, data) {
                buffer.pushString(data);
            },
            deserialize: function(buffer) {
                return buffer.getString();
            }
        }),
        name: $87d7cbc9cdedc1f2$var$createType({
            name: "name",
            serialize: function(buffer, data) {
                buffer.pushName(data);
            },
            deserialize: function(buffer) {
                return buffer.getName();
            }
        }),
        time_point: $87d7cbc9cdedc1f2$var$createType({
            name: "time_point",
            serialize: function(buffer, data) {
                buffer.pushNumberAsUint64($87d7cbc9cdedc1f2$var$dateToTimePoint(data));
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$timePointToDate(buffer.getUint64AsNumber());
            }
        }),
        time_point_sec: $87d7cbc9cdedc1f2$var$createType({
            name: "time_point_sec",
            serialize: function(buffer, data) {
                buffer.pushUint32($87d7cbc9cdedc1f2$var$dateToTimePointSec(data));
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$timePointSecToDate(buffer.getUint32());
            }
        }),
        block_timestamp_type: $87d7cbc9cdedc1f2$var$createType({
            name: "block_timestamp_type",
            serialize: function(buffer, data) {
                buffer.pushUint32($87d7cbc9cdedc1f2$var$dateToBlockTimestamp(data));
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$blockTimestampToDate(buffer.getUint32());
            }
        }),
        symbol_code: $87d7cbc9cdedc1f2$var$createType({
            name: "symbol_code",
            serialize: function(buffer, data) {
                buffer.pushSymbolCode(data);
            },
            deserialize: function(buffer) {
                return buffer.getSymbolCode();
            }
        }),
        symbol: $87d7cbc9cdedc1f2$var$createType({
            name: "symbol",
            serialize: function(buffer, data) {
                buffer.pushSymbol($87d7cbc9cdedc1f2$var$stringToSymbol(data));
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$symbolToString(buffer.getSymbol());
            }
        }),
        asset: $87d7cbc9cdedc1f2$var$createType({
            name: "asset",
            serialize: function(buffer, data) {
                buffer.pushAsset(data);
            },
            deserialize: function(buffer) {
                return buffer.getAsset();
            }
        }),
        checksum160: $87d7cbc9cdedc1f2$var$createType({
            name: "checksum160",
            serialize: function(buffer, data) {
                buffer.pushUint8ArrayChecked($87d7cbc9cdedc1f2$var$hexToUint8Array(data), 20);
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.getUint8Array(20));
            }
        }),
        checksum256: $87d7cbc9cdedc1f2$var$createType({
            name: "checksum256",
            serialize: function(buffer, data) {
                buffer.pushUint8ArrayChecked($87d7cbc9cdedc1f2$var$hexToUint8Array(data), 32);
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.getUint8Array(32));
            }
        }),
        checksum512: $87d7cbc9cdedc1f2$var$createType({
            name: "checksum512",
            serialize: function(buffer, data) {
                buffer.pushUint8ArrayChecked($87d7cbc9cdedc1f2$var$hexToUint8Array(data), 64);
            },
            deserialize: function(buffer) {
                return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.getUint8Array(64));
            }
        }),
        public_key: $87d7cbc9cdedc1f2$var$createType({
            name: "public_key",
            serialize: function(buffer, data) {
                buffer.pushPublicKey(data);
            },
            deserialize: function(buffer) {
                return buffer.getPublicKey();
            }
        }),
        private_key: $87d7cbc9cdedc1f2$var$createType({
            name: "private_key",
            serialize: function(buffer, data) {
                buffer.pushPrivateKey(data);
            },
            deserialize: function(buffer) {
                return buffer.getPrivateKey();
            }
        }),
        signature: $87d7cbc9cdedc1f2$var$createType({
            name: "signature",
            serialize: function(buffer, data) {
                buffer.pushSignature(data);
            },
            deserialize: function(buffer) {
                return buffer.getSignature();
            }
        })
    }));
    result.set("extended_asset", $87d7cbc9cdedc1f2$var$createType({
        name: "extended_asset",
        baseName: "",
        fields: [
            {
                name: "quantity",
                typeName: "asset",
                type: result.get("asset")
            },
            {
                name: "contract",
                typeName: "name",
                type: result.get("name")
            }
        ],
        serialize: $87d7cbc9cdedc1f2$var$serializeStruct,
        deserialize: $87d7cbc9cdedc1f2$var$deserializeStruct
    }));
    return result;
} // createInitialTypes()
module.exports.createInitialTypes = $87d7cbc9cdedc1f2$var$createInitialTypes;
/** Get type from `types` */ function $87d7cbc9cdedc1f2$var$getType(types, name) {
    var type = types.get(name);
    if (type && type.aliasOfName) return $87d7cbc9cdedc1f2$var$getType(types, type.aliasOfName);
    if (type) return type;
    if (name.endsWith("[]")) return $87d7cbc9cdedc1f2$var$createType({
        name: name,
        arrayOf: $87d7cbc9cdedc1f2$var$getType(types, name.substr(0, name.length - 2)),
        serialize: $87d7cbc9cdedc1f2$var$serializeArray,
        deserialize: $87d7cbc9cdedc1f2$var$deserializeArray
    });
    if (name.endsWith("?")) return $87d7cbc9cdedc1f2$var$createType({
        name: name,
        optionalOf: $87d7cbc9cdedc1f2$var$getType(types, name.substr(0, name.length - 1)),
        serialize: $87d7cbc9cdedc1f2$var$serializeOptional,
        deserialize: $87d7cbc9cdedc1f2$var$deserializeOptional
    });
    if (name.endsWith("$")) return $87d7cbc9cdedc1f2$var$createType({
        name: name,
        extensionOf: $87d7cbc9cdedc1f2$var$getType(types, name.substr(0, name.length - 1)),
        serialize: $87d7cbc9cdedc1f2$var$serializeExtension,
        deserialize: $87d7cbc9cdedc1f2$var$deserializeExtension
    });
    throw new Error("Unknown type: " + name);
}
module.exports.getType = $87d7cbc9cdedc1f2$var$getType;
/**
 * Get types from abi
 * @param initialTypes Set of types to build on.
 *     In most cases, it's best to fill this from a fresh call to `getTypesFromAbi()`.
 */ function $87d7cbc9cdedc1f2$var$getTypesFromAbi(initialTypes, abi) {
    var e_5, _a, e_6, _b, e_7, _c, e_8, _d, e_9, _e;
    var types = new Map(initialTypes);
    if (abi.types) try {
        for(var _f = $87d7cbc9cdedc1f2$var$__values(abi.types), _g = _f.next(); !_g.done; _g = _f.next()){
            var _h = _g.value, new_type_name = _h.new_type_name, type = _h.type;
            types.set(new_type_name, $87d7cbc9cdedc1f2$var$createType({
                name: new_type_name,
                aliasOfName: type
            }));
        }
    } catch (e_5_1) {
        e_5 = {
            error: e_5_1
        };
    } finally{
        try {
            if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
        } finally{
            if (e_5) throw e_5.error;
        }
    }
    if (abi.structs) try {
        for(var _j = $87d7cbc9cdedc1f2$var$__values(abi.structs), _k = _j.next(); !_k.done; _k = _j.next()){
            var _l = _k.value, name_1 = _l.name, base = _l.base, fields = _l.fields;
            types.set(name_1, $87d7cbc9cdedc1f2$var$createType({
                name: name_1,
                baseName: base,
                fields: fields.map(function(_a) {
                    var n = _a.name, type = _a.type;
                    return {
                        name: n,
                        typeName: type,
                        type: null
                    };
                }),
                serialize: $87d7cbc9cdedc1f2$var$serializeStruct,
                deserialize: $87d7cbc9cdedc1f2$var$deserializeStruct
            }));
        }
    } catch (e_6_1) {
        e_6 = {
            error: e_6_1
        };
    } finally{
        try {
            if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
        } finally{
            if (e_6) throw e_6.error;
        }
    }
    if (abi.variants) try {
        for(var _m = $87d7cbc9cdedc1f2$var$__values(abi.variants), _o = _m.next(); !_o.done; _o = _m.next()){
            var _p = _o.value, name_2 = _p.name, t = _p.types;
            types.set(name_2, $87d7cbc9cdedc1f2$var$createType({
                name: name_2,
                fields: t.map(function(s) {
                    return {
                        name: s,
                        typeName: s,
                        type: null
                    };
                }),
                serialize: $87d7cbc9cdedc1f2$var$serializeVariant,
                deserialize: $87d7cbc9cdedc1f2$var$deserializeVariant
            }));
        }
    } catch (e_7_1) {
        e_7 = {
            error: e_7_1
        };
    } finally{
        try {
            if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
        } finally{
            if (e_7) throw e_7.error;
        }
    }
    try {
        for(var types_1 = $87d7cbc9cdedc1f2$var$__values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()){
            var _q = $87d7cbc9cdedc1f2$var$__read(types_1_1.value, 2), name_3 = _q[0], type = _q[1];
            if (type.baseName) type.base = $87d7cbc9cdedc1f2$var$getType(types, type.baseName);
            try {
                for(var _r = $87d7cbc9cdedc1f2$var$__values(type.fields), _s = _r.next(); !_s.done; _s = _r.next()){
                    var field = _s.value;
                    field.type = $87d7cbc9cdedc1f2$var$getType(types, field.typeName);
                }
            } catch (e_9_1) {
                e_9 = {
                    error: e_9_1
                };
            } finally{
                try {
                    if (_s && !_s.done && (_e = _r.return)) _e.call(_r);
                } finally{
                    if (e_9) throw e_9.error;
                }
            }
        }
    } catch (e_8_1) {
        e_8 = {
            error: e_8_1
        };
    } finally{
        try {
            if (types_1_1 && !types_1_1.done && (_d = types_1.return)) _d.call(types_1);
        } finally{
            if (e_8) throw e_8.error;
        }
    }
    return types;
} // getTypesFromAbi
module.exports.getTypesFromAbi = $87d7cbc9cdedc1f2$var$getTypesFromAbi;
/** TAPoS: Return transaction fields which reference `refBlock` and expire `expireSeconds` after `refBlock.timestamp` */ function $87d7cbc9cdedc1f2$var$transactionHeader(refBlock, expireSeconds) {
    return {
        expiration: $87d7cbc9cdedc1f2$var$timePointSecToDate($87d7cbc9cdedc1f2$var$dateToTimePointSec(refBlock.timestamp) + expireSeconds),
        ref_block_num: refBlock.block_num & 0xffff,
        ref_block_prefix: refBlock.ref_block_prefix
    };
}
module.exports.transactionHeader = $87d7cbc9cdedc1f2$var$transactionHeader;
/** Convert action data to serialized form (hex) */ function $87d7cbc9cdedc1f2$var$serializeActionData(contract, account, name, data, textEncoder, textDecoder) {
    var action = contract.actions.get(name);
    if (!action) throw new Error("Unknown action " + name + " in contract " + account);
    var buffer = new $87d7cbc9cdedc1f2$var$SerialBuffer({
        textEncoder: textEncoder,
        textDecoder: textDecoder
    });
    action.serialize(buffer, data);
    return $87d7cbc9cdedc1f2$var$arrayToHex(buffer.asUint8Array());
}
module.exports.serializeActionData = $87d7cbc9cdedc1f2$var$serializeActionData;
/** Return action in serialized form */ function $87d7cbc9cdedc1f2$var$serializeAction(contract, account, name, authorization, data, textEncoder, textDecoder) {
    return {
        account: account,
        name: name,
        authorization: authorization,
        data: $87d7cbc9cdedc1f2$var$serializeActionData(contract, account, name, data, textEncoder, textDecoder)
    };
}
module.exports.serializeAction = $87d7cbc9cdedc1f2$var$serializeAction;
/** Deserialize action data. If `data` is a `string`, then it's assumed to be in hex. */ function $87d7cbc9cdedc1f2$var$deserializeActionData(contract, account, name, data, textEncoder, textDecoder) {
    var action = contract.actions.get(name);
    if (typeof data === "string") data = $87d7cbc9cdedc1f2$var$hexToUint8Array(data);
    if (!action) throw new Error("Unknown action " + name + " in contract " + account);
    var buffer = new $87d7cbc9cdedc1f2$var$SerialBuffer({
        textDecoder: textDecoder,
        textEncoder: textEncoder
    });
    buffer.pushArray(data);
    return action.deserialize(buffer);
}
module.exports.deserializeActionData = $87d7cbc9cdedc1f2$var$deserializeActionData;
/** Deserialize action. If `data` is a `string`, then it's assumed to be in hex. */ function $87d7cbc9cdedc1f2$var$deserializeAction(contract, account, name, authorization, data, textEncoder, textDecoder) {
    return {
        account: account,
        name: name,
        authorization: authorization,
        data: $87d7cbc9cdedc1f2$var$deserializeActionData(contract, account, name, data, textEncoder, textDecoder)
    };
}
module.exports.deserializeAction = $87d7cbc9cdedc1f2$var$deserializeAction;

});
parcelRegister("ltQVr", function(module, exports) {
"use strict";
/**
 * @module Numeric
 */ // copyright defined in fiojs/LICENSE.txt
var $fa355c48c06c94fb$var$__read = module.exports && module.exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fa355c48c06c94fb$var$__spread = module.exports && module.exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($fa355c48c06c94fb$var$__read(arguments[i]));
    return ar;
};
var $fa355c48c06c94fb$var$__values = module.exports && module.exports.__values || function(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fa355c48c06c94fb$var$ripemd160 = (parcelRequire("9EFEW")).RIPEMD160.hash;
var $fa355c48c06c94fb$var$base58Chars = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var $fa355c48c06c94fb$var$base64Chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
function $fa355c48c06c94fb$var$create_base58_map() {
    var base58M = Array(256).fill(-1);
    for(var i = 0; i < $fa355c48c06c94fb$var$base58Chars.length; ++i)base58M[$fa355c48c06c94fb$var$base58Chars.charCodeAt(i)] = i;
    return base58M;
}
var $fa355c48c06c94fb$var$base58Map = $fa355c48c06c94fb$var$create_base58_map();
function $fa355c48c06c94fb$var$create_base64_map() {
    var base64M = Array(256).fill(-1);
    for(var i = 0; i < $fa355c48c06c94fb$var$base64Chars.length; ++i)base64M[$fa355c48c06c94fb$var$base64Chars.charCodeAt(i)] = i;
    base64M["=".charCodeAt(0)] = 0;
    return base64M;
}
var $fa355c48c06c94fb$var$base64Map = $fa355c48c06c94fb$var$create_base64_map();
/** Is `bignum` a negative number? */ function $fa355c48c06c94fb$var$isNegative(bignum) {
    return (bignum[bignum.length - 1] & 0x80) !== 0;
}
module.exports.isNegative = $fa355c48c06c94fb$var$isNegative;
/** Negate `bignum` */ function $fa355c48c06c94fb$var$negate(bignum) {
    var carry = 1;
    for(var i = 0; i < bignum.length; ++i){
        var x = (~bignum[i] & 0xff) + carry;
        bignum[i] = x;
        carry = x >> 8;
    }
}
module.exports.negate = $fa355c48c06c94fb$var$negate;
/**
 * Convert an unsigned decimal number in `s` to a bignum
 * @param size bignum size (bytes)
 */ function $fa355c48c06c94fb$var$decimalToBinary(size, s) {
    var result = new Uint8Array(size);
    for(var i = 0; i < s.length; ++i){
        var srcDigit = s.charCodeAt(i);
        if (srcDigit < "0".charCodeAt(0) || srcDigit > "9".charCodeAt(0)) throw new Error("invalid number");
        var carry = srcDigit - "0".charCodeAt(0);
        for(var j = 0; j < size; ++j){
            var x = result[j] * 10 + carry;
            result[j] = x;
            carry = x >> 8;
        }
        if (carry) throw new Error("number is out of range");
    }
    return result;
}
module.exports.decimalToBinary = $fa355c48c06c94fb$var$decimalToBinary;
/**
 * Convert a signed decimal number in `s` to a bignum
 * @param size bignum size (bytes)
 */ function $fa355c48c06c94fb$var$signedDecimalToBinary(size, s) {
    var negative = s[0] === "-";
    if (negative) s = s.substr(1);
    var result = $fa355c48c06c94fb$var$decimalToBinary(size, s);
    if (negative) {
        $fa355c48c06c94fb$var$negate(result);
        if (!$fa355c48c06c94fb$var$isNegative(result)) throw new Error("number is out of range");
    } else if ($fa355c48c06c94fb$var$isNegative(result)) throw new Error("number is out of range");
    return result;
}
module.exports.signedDecimalToBinary = $fa355c48c06c94fb$var$signedDecimalToBinary;
/**
 * Convert `bignum` to an unsigned decimal number
 * @param minDigits 0-pad result to this many digits
 */ function $fa355c48c06c94fb$var$binaryToDecimal(bignum, minDigits) {
    if (minDigits === void 0) minDigits = 1;
    var result = Array(minDigits).fill("0".charCodeAt(0));
    for(var i = bignum.length - 1; i >= 0; --i){
        var carry = bignum[i];
        for(var j = 0; j < result.length; ++j){
            var x = (result[j] - "0".charCodeAt(0) << 8) + carry;
            result[j] = "0".charCodeAt(0) + x % 10;
            carry = x / 10 | 0;
        }
        while(carry){
            result.push("0".charCodeAt(0) + carry % 10);
            carry = carry / 10 | 0;
        }
    }
    result.reverse();
    return String.fromCharCode.apply(String, $fa355c48c06c94fb$var$__spread(result));
}
module.exports.binaryToDecimal = $fa355c48c06c94fb$var$binaryToDecimal;
/**
 * Convert `bignum` to a signed decimal number
 * @param minDigits 0-pad result to this many digits
 */ function $fa355c48c06c94fb$var$signedBinaryToDecimal(bignum, minDigits) {
    if (minDigits === void 0) minDigits = 1;
    if ($fa355c48c06c94fb$var$isNegative(bignum)) {
        var x = bignum.slice();
        $fa355c48c06c94fb$var$negate(x);
        return "-" + $fa355c48c06c94fb$var$binaryToDecimal(x, minDigits);
    }
    return $fa355c48c06c94fb$var$binaryToDecimal(bignum, minDigits);
}
module.exports.signedBinaryToDecimal = $fa355c48c06c94fb$var$signedBinaryToDecimal;
/**
 * Convert an unsigned base-58 number in `s` to a bignum
 * @param size bignum size (bytes)
 */ function $fa355c48c06c94fb$var$base58ToBinary(size, s) {
    var result = new Uint8Array(size);
    for(var i = 0; i < s.length; ++i){
        var carry = $fa355c48c06c94fb$var$base58Map[s.charCodeAt(i)];
        if (carry < 0) throw new Error("invalid base-58 value");
        for(var j = 0; j < size; ++j){
            var x = result[j] * 58 + carry;
            result[j] = x;
            carry = x >> 8;
        }
        if (carry) throw new Error("base-58 value is out of range");
    }
    result.reverse();
    return result;
}
module.exports.base58ToBinary = $fa355c48c06c94fb$var$base58ToBinary;
/**
 * Convert `bignum` to a base-58 number
 * @param minDigits 0-pad result to this many digits
 */ function $fa355c48c06c94fb$var$binaryToBase58(bignum, minDigits) {
    if (minDigits === void 0) minDigits = 1;
    var e_1, _a, e_2, _b;
    var result = [];
    try {
        for(var bignum_1 = $fa355c48c06c94fb$var$__values(bignum), bignum_1_1 = bignum_1.next(); !bignum_1_1.done; bignum_1_1 = bignum_1.next()){
            var byte = bignum_1_1.value;
            var carry = byte;
            for(var j = 0; j < result.length; ++j){
                var x = ($fa355c48c06c94fb$var$base58Map[result[j]] << 8) + carry;
                result[j] = $fa355c48c06c94fb$var$base58Chars.charCodeAt(x % 58);
                carry = x / 58 | 0;
            }
            while(carry){
                result.push($fa355c48c06c94fb$var$base58Chars.charCodeAt(carry % 58));
                carry = carry / 58 | 0;
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (bignum_1_1 && !bignum_1_1.done && (_a = bignum_1.return)) _a.call(bignum_1);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
    try {
        for(var bignum_2 = $fa355c48c06c94fb$var$__values(bignum), bignum_2_1 = bignum_2.next(); !bignum_2_1.done; bignum_2_1 = bignum_2.next()){
            var byte = bignum_2_1.value;
            if (byte) break;
            else result.push("1".charCodeAt(0));
        }
    } catch (e_2_1) {
        e_2 = {
            error: e_2_1
        };
    } finally{
        try {
            if (bignum_2_1 && !bignum_2_1.done && (_b = bignum_2.return)) _b.call(bignum_2);
        } finally{
            if (e_2) throw e_2.error;
        }
    }
    result.reverse();
    return String.fromCharCode.apply(String, $fa355c48c06c94fb$var$__spread(result));
}
module.exports.binaryToBase58 = $fa355c48c06c94fb$var$binaryToBase58;
/** Convert an unsigned base-64 number in `s` to a bignum */ function $fa355c48c06c94fb$var$base64ToBinary(s) {
    var len = s.length;
    if ((len & 3) === 1 && s[len - 1] === "=") len -= 1;
     // fc appends an extra '='
    if ((len & 3) !== 0) throw new Error("base-64 value is not padded correctly");
    var groups = len >> 2;
    var bytes = groups * 3;
    if (len > 0 && s[len - 1] === "=") {
        if (s[len - 2] === "=") bytes -= 2;
        else bytes -= 1;
    }
    var result = new Uint8Array(bytes);
    for(var group = 0; group < groups; ++group){
        var digit0 = $fa355c48c06c94fb$var$base64Map[s.charCodeAt(group * 4 + 0)];
        var digit1 = $fa355c48c06c94fb$var$base64Map[s.charCodeAt(group * 4 + 1)];
        var digit2 = $fa355c48c06c94fb$var$base64Map[s.charCodeAt(group * 4 + 2)];
        var digit3 = $fa355c48c06c94fb$var$base64Map[s.charCodeAt(group * 4 + 3)];
        result[group * 3 + 0] = digit0 << 2 | digit1 >> 4;
        if (group * 3 + 1 < bytes) result[group * 3 + 1] = (digit1 & 15) << 4 | digit2 >> 2;
        if (group * 3 + 2 < bytes) result[group * 3 + 2] = (digit2 & 3) << 6 | digit3;
    }
    return result;
}
module.exports.base64ToBinary = $fa355c48c06c94fb$var$base64ToBinary;
/** Key types this library supports */ var $fa355c48c06c94fb$var$KeyType;
(function(KeyType) {
    KeyType[KeyType["k1"] = 0] = "k1";
    KeyType[KeyType["r1"] = 1] = "r1";
})($fa355c48c06c94fb$var$KeyType = module.exports.KeyType || (module.exports.KeyType = {}));
/** Public key data size, excluding type field */ module.exports.publicKeyDataSize = 33;
/** Private key data size, excluding type field */ module.exports.privateKeyDataSize = 32;
/** Signature data size, excluding type field */ module.exports.signatureDataSize = 65;
function $fa355c48c06c94fb$var$digestSuffixRipemd160(data, suffix) {
    var d = new Uint8Array(data.length + suffix.length);
    for(var i = 0; i < data.length; ++i)d[i] = data[i];
    for(var i = 0; i < suffix.length; ++i)d[data.length + i] = suffix.charCodeAt(i);
    return $fa355c48c06c94fb$var$ripemd160(d);
}
function $fa355c48c06c94fb$var$stringToKey(s, type, size, suffix) {
    var whole = $fa355c48c06c94fb$var$base58ToBinary(size + 4, s);
    var result = {
        type: type,
        data: new Uint8Array(whole.buffer, 0, size)
    };
    var digest = new Uint8Array($fa355c48c06c94fb$var$digestSuffixRipemd160(result.data, suffix));
    if (digest[0] !== whole[size + 0] || digest[1] !== whole[size + 1] || digest[2] !== whole[size + 2] || digest[3] !== whole[size + 3]) throw new Error("checksum doesn't match");
    return result;
}
function $fa355c48c06c94fb$var$keyToString(key, suffix, prefix) {
    var digest = new Uint8Array($fa355c48c06c94fb$var$digestSuffixRipemd160(key.data, suffix));
    var whole = new Uint8Array(key.data.length + 4);
    for(var i = 0; i < key.data.length; ++i)whole[i] = key.data[i];
    for(var i = 0; i < 4; ++i)whole[i + key.data.length] = digest[i];
    return prefix + $fa355c48c06c94fb$var$binaryToBase58(whole);
}
/** Convert key in `s` to binary form */ function $fa355c48c06c94fb$var$stringToPublicKey(s) {
    if (typeof s !== "string") throw new Error("expected string containing public key");
    if (s.substr(0, 3) === "FIO") {
        var whole = $fa355c48c06c94fb$var$base58ToBinary(module.exports.publicKeyDataSize + 4, s.substr(3));
        var key = {
            type: $fa355c48c06c94fb$var$KeyType.k1,
            data: new Uint8Array(module.exports.publicKeyDataSize)
        };
        for(var i = 0; i < module.exports.publicKeyDataSize; ++i)key.data[i] = whole[i];
        var digest = new Uint8Array($fa355c48c06c94fb$var$ripemd160(key.data));
        if (digest[0] !== whole[module.exports.publicKeyDataSize] || digest[1] !== whole[34] || digest[2] !== whole[35] || digest[3] !== whole[36]) throw new Error("checksum doesn't match");
        return key;
    } else if (s.substr(0, 7) === "PUB_K1_") return $fa355c48c06c94fb$var$stringToKey(s.substr(7), $fa355c48c06c94fb$var$KeyType.k1, module.exports.publicKeyDataSize, "K1");
    else if (s.substr(0, 7) === "PUB_R1_") return $fa355c48c06c94fb$var$stringToKey(s.substr(7), $fa355c48c06c94fb$var$KeyType.r1, module.exports.publicKeyDataSize, "R1");
    else throw new Error("unrecognized public key format");
}
module.exports.stringToPublicKey = $fa355c48c06c94fb$var$stringToPublicKey;
/** Convert `key` to string (base-58) form */ function $fa355c48c06c94fb$var$publicKeyToString(key) {
    if (key.type === $fa355c48c06c94fb$var$KeyType.k1 && key.data.length === module.exports.publicKeyDataSize) return $fa355c48c06c94fb$var$keyToString(key, "K1", "PUB_K1_");
    else if (key.type === $fa355c48c06c94fb$var$KeyType.r1 && key.data.length === module.exports.publicKeyDataSize) return $fa355c48c06c94fb$var$keyToString(key, "R1", "PUB_R1_");
    else throw new Error("unrecognized public key format");
}
module.exports.publicKeyToString = $fa355c48c06c94fb$var$publicKeyToString;
/** If a key is in the legacy format (`FIO` prefix), then convert it to the new format (`PUB_K1_`).
 * Leaves other formats untouched
 */ function $fa355c48c06c94fb$var$convertLegacyPublicKey(s) {
    if (s.substr(0, 3) === "FIO") return $fa355c48c06c94fb$var$publicKeyToString($fa355c48c06c94fb$var$stringToPublicKey(s));
    return s;
}
module.exports.convertLegacyPublicKey = $fa355c48c06c94fb$var$convertLegacyPublicKey;
/** If a key is in the legacy format (`FIO` prefix), then convert it to the new format (`PUB_K1_`).
 * Leaves other formats untouched
 */ function $fa355c48c06c94fb$var$convertLegacyPublicKeys(keys) {
    return keys.map($fa355c48c06c94fb$var$convertLegacyPublicKey);
}
module.exports.convertLegacyPublicKeys = $fa355c48c06c94fb$var$convertLegacyPublicKeys;
/** Convert key in `s` to binary form */ function $fa355c48c06c94fb$var$stringToPrivateKey(s) {
    if (typeof s !== "string") throw new Error("expected string containing private key");
    if (s.substr(0, 7) === "PVT_R1_") return $fa355c48c06c94fb$var$stringToKey(s.substr(7), $fa355c48c06c94fb$var$KeyType.r1, module.exports.privateKeyDataSize, "R1");
    else throw new Error("unrecognized private key format");
}
module.exports.stringToPrivateKey = $fa355c48c06c94fb$var$stringToPrivateKey;
/** Convert `key` to string (base-58) form */ function $fa355c48c06c94fb$var$privateKeyToString(key) {
    if (key.type === $fa355c48c06c94fb$var$KeyType.r1) return $fa355c48c06c94fb$var$keyToString(key, "R1", "PVT_R1_");
    else throw new Error("unrecognized private key format");
}
module.exports.privateKeyToString = $fa355c48c06c94fb$var$privateKeyToString;
/** Convert key in `s` to binary form */ function $fa355c48c06c94fb$var$stringToSignature(s) {
    if (typeof s !== "string") throw new Error("expected string containing signature");
    if (s.substr(0, 7) === "SIG_K1_") return $fa355c48c06c94fb$var$stringToKey(s.substr(7), $fa355c48c06c94fb$var$KeyType.k1, module.exports.signatureDataSize, "K1");
    else if (s.substr(0, 7) === "SIG_R1_") return $fa355c48c06c94fb$var$stringToKey(s.substr(7), $fa355c48c06c94fb$var$KeyType.r1, module.exports.signatureDataSize, "R1");
    else throw new Error("unrecognized signature format");
}
module.exports.stringToSignature = $fa355c48c06c94fb$var$stringToSignature;
/** Convert `signature` to string (base-58) form */ function $fa355c48c06c94fb$var$signatureToString(signature) {
    if (signature.type === $fa355c48c06c94fb$var$KeyType.k1) return $fa355c48c06c94fb$var$keyToString(signature, "K1", "SIG_K1_");
    else if (signature.type === $fa355c48c06c94fb$var$KeyType.r1) return $fa355c48c06c94fb$var$keyToString(signature, "R1", "SIG_R1_");
    else throw new Error("unrecognized signature format");
}
module.exports.signatureToString = $fa355c48c06c94fb$var$signatureToString;
function $fa355c48c06c94fb$var$arrayToHex(data) {
    var e_3, _a;
    var result = "";
    try {
        for(var data_1 = $fa355c48c06c94fb$var$__values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()){
            var x = data_1_1.value;
            result += ("00" + x.toString(16)).slice(-2);
        }
    } catch (e_3_1) {
        e_3 = {
            error: e_3_1
        };
    } finally{
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        } finally{
            if (e_3) throw e_3.error;
        }
    }
    return result;
}
module.exports.arrayToHex = $fa355c48c06c94fb$var$arrayToHex;

});
parcelRegister("9EFEW", function(module, exports) {
// https://gist.githubusercontent.com/wlzla000/bac83df6d3c51916c4dd0bc947e46947/raw/7ee3462b095ab22580ddaf191f44a590da6fe33b/RIPEMD-160.js
/*
	RIPEMD-160.js

		developed
			by K. (https://github.com/wlzla000)
			on December 27-29, 2017,

		licensed under


		the MIT license

		Copyright (c) 2017 K.

		 Permission is hereby granted, free of charge, to any person
		obtaining a copy of this software and associated documentation
		files (the "Software"), to deal in the Software without
		restriction, including without limitation the rights to use,
		copy, modify, merge, publish, distribute, sublicense, and/or
		sell copies of the Software, and to permit persons to whom the
		Software is furnished to do so, subject to the following
		conditions:

		 The above copyright notice and this permission notice shall be
		included in all copies or substantial portions of the Software.

		 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
		EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
		OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
		NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
		HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
		WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
		FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
		OTHER DEALINGS IN THE SOFTWARE.
*/ "use strict";
var $70782a28c592e4f0$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $70782a28c592e4f0$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $70782a28c592e4f0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
var $70782a28c592e4f0$var$RIPEMD160 = function() {
    function RIPEMD160() {
        // https://webcache.googleusercontent.com/search?q=cache:CnLOgolTHYEJ:https://www.cosic.esat.kuleuven.be/publications/article-317.pdf
        // http://shodhganga.inflibnet.ac.in/bitstream/10603/22978/13/13_appendix.pdf
        $70782a28c592e4f0$var$_classCallCheck(this, RIPEMD160);
    }
    $70782a28c592e4f0$var$_createClass(RIPEMD160, null, [
        {
            key: "get_n_pad_bytes",
            value: function get_n_pad_bytes(message_size /* in bytes, 1 byte is 8 bits. */ ) {
                //  Obtain the number of bytes needed to pad the message.
                // It does not contain the size of the message size information.
                /*
   	https://webcache.googleusercontent.com/search?q=cache:CnLOgolTHYEJ:https://www.cosic.esat.kuleuven.be/publications/article-317.pdf
   		The Cryptographic Hash Function RIPEMD-160
   		written by
   		Bart Preneel,
   		Hans Dobbertin,
   		Antoon Bosselaers
   	in
   		1997.
   		--------------------------------------------------
   		§5     Description of RIPEMD-160
   		......
   		 In order to guarantee that the total input size is a
   	multiple of 512 bits, the input is padded in the same
   	way as for all the members of the MD4-family: one
   	appends a single 1 followed by a string of 0s (the
   	number of 0s lies between 0 and 511); the last 64 bits
   	of the extended input contain the binary representation
   	of the input size in bits, least significant byte first.
   */ /*
   	https://tools.ietf.org/rfc/rfc1186.txt
   		RFC 1186: MD4 Message Digest Algorithm.
   		written by
   		Ronald Linn Rivest
   	in
   		October 1990.
   		--------------------------------------------------
   		§3     MD4 Algorithm Description
   		......
   		Step 1. Append padding bits
   		 The message is "padded" (extended) so that its length
   	(in bits) is congruent to 448, modulo 512. That is, the
   	message is extended so that it is just 64 bits shy of
   	being a multiple of 512 bits long. Padding is always
   	performed, even if the length of the message is already
   	congruent to 448, modulo 512 (in which case 512 bits of
   	padding are added).
   		 Padding is performed as follows: a single "1" bit is
   	appended to the message, and then enough zero bits are
   	appended so that the length in bits of the padded
   	message becomes congruent to 448, modulo 512.
   		Step 2. Append length
   		 A 64-bit representation of b (the length of the message
   	before the padding bits were added) is appended to the
   	result of the previous step. In the unlikely event that
   	b is greater than 2^64, then only the low-order 64 bits
   	of b are used. (These bits are appended as two 32-bit
   	words and appended low-order word first in accordance
   	with the previous conventions.)
   		 At this point the resulting message (after padding with
   	bits and with b) has a length that is an exact multiple
   	of 512 bits. Equivalently, this message has a length
   	that is an exact multiple of 16 (32-bit) words. Let
   	M[0 ... N-1] denote the words of the resulting message,
   	where N is a multiple of 16.
   */ // https://crypto.stackexchange.com/a/32407/54568
                /*
   	Example case  # 1
   		[0 bit: message.]
   		[1 bit: 1.]
   		[447 bits: 0.]
   		[64 bits: message size information.]
   		Example case  # 2
   		[512-bits: message]
   		[1 bit: 1.]
   		[447 bits: 0.]
   		[64 bits: message size information.]
   		Example case  # 3
   		[(512 - 64 = 448) bits: message.]
   		[1 bit: 1.]
   		[511 bits: 0.]
   		[64 bits: message size information.]
   		Example case  # 4
   		[(512 - 65 = 447) bits: message.]
   		[1 bit: 1.]
   		[0 bit: 0.]
   		[64 bits: message size information.]
   */ // The number of padding zero bits:
                //      511 - [{(message size in bits) + 64} (mod 512)]
                return 64 - (message_size + 8 & 63 /* 63 */ );
            }
        },
        {
            key: "pad",
            value: function pad(message /* An ArrayBuffer. */ ) {
                var message_size = message.byteLength;
                var n_pad = RIPEMD160.get_n_pad_bytes(message_size);
                //  `Number.MAX_SAFE_INTEGER` is ((2 ** 53) - 1) and
                // bitwise operation in Javascript is done on 32-bits operands.
                var divmod = function divmod(dividend, divisor) {
                    return [
                        Math.floor(dividend / divisor),
                        dividend % divisor
                    ];
                };
                /*
   To shift
     00000000 000????? ???????? ???????? ???????? ???????? ???????? ????????
                                      t o
    00000000 ???????? ???????? ???????? ???????? ???????? ???????? ?????000
   --------------------------------------------------------------------------------
   Method #1
      00000000 000????? ???????? ????????  ???????? ???????? ???????? ????????
    [00000000 000AAAAA AAAAAAAA AAAAAAAA] (<A> captured)
    [00000000 AAAAAAAA AAAAAAAA AAAAA000] (<A> shifted)
                          (<B> captured) [BBBBBBBB BBBBBBBB BBBBBBBB BBBBBBBB]
                      (<B> shifted) [BBB][BBBBBBBB BBBBBBBB BBBBBBBB BBBBB000]
    [00000000 AAAAAAAA AAAAAAAA AAAAABBB] (<A> & <B_2> merged)
    [00000000 AAAAAAAA AAAAAAAA AAAAABBB][BBBBBBBB BBBBBBBB BBBBBBBB BBBBB000]
     00000000 ???????? ???????? ????????  ???????? ???????? ???????? ?????000
   	const uint32_max_plus_1 = 0x100000000; // (2 ** 32)
   const [
   	msg_byte_size_most, // Value range [0, (2 ** 21) - 1].
   	msg_byte_size_least // Value range [0, (2 ** 32) - 1].
   ] = divmod(message_size, uint32_max_plus_1);
   const [
   	carry, // Value range [0, 7].
   	msg_bit_size_least // Value range [0, (2 ** 32) - 8].
   ] = divmod(message_byte_size_least * 8, uint32_max_plus_1);
   const message_bit_size_most = message_byte_size_most * 8
   	+ carry; // Value range [0, (2 ** 24) - 1].
   --------------------------------------------------------------------------------
   Method #2
     00000000 000????? ???????? ????????  ???????? ???????? ???????? ????????
       [00000 000AAAAA AAAAAAAA AAAAAAAA  AAA] (<A> captured)
                          (<B> captured) [000BBBBB BBBBBBBB BBBBBBBB BBBBBBBB]
                           (<B> shifted) [BBBBBBBB BBBBBBBB BBBBBBBB BBBBB000]
    [00000000 AAAAAAAA AAAAAAAA AAAAAAAA][BBBBBBBB BBBBBBBB BBBBBBBB BBBBB000]
     00000000 ???????? ???????? ????????  ???????? ???????? ???????? ?????000
   	*/ var _divmod$map = divmod(message_size, 536870912 /* (2 ** 29) */ ).map(function(x, index) {
                    return index ? x * 8 : x;
                }), _divmod$map2 = $70782a28c592e4f0$var$_slicedToArray(_divmod$map, 2), msg_bit_size_most = _divmod$map2[0], msg_bit_size_least = _divmod$map2[1];
                // `ArrayBuffer.transfer()` is not supported.
                var padded = new Uint8Array(message_size + n_pad + 8);
                padded.set(new Uint8Array(message), 0);
                var data_view = new DataView(padded.buffer);
                data_view.setUint8(message_size, 128);
                data_view.setUint32(message_size + n_pad, msg_bit_size_least, true // Little-endian
                );
                data_view.setUint32(message_size + n_pad + 4, msg_bit_size_most, true // Little-endian
                );
                return padded.buffer;
            }
        },
        {
            key: "f",
            value: function f(j, x, y, z) {
                if (0 <= j && j <= 15) // Exclusive-OR
                return x ^ y ^ z;
                if (16 <= j && j <= 31) // Multiplexing (muxing)
                return x & y | ~x & z;
                if (32 <= j && j <= 47) return (x | ~y) ^ z;
                if (48 <= j && j <= 63) // Multiplexing (muxing)
                return x & z | y & ~z;
                if (64 <= j && j <= 79) return x ^ (y | ~z);
            }
        },
        {
            key: "K",
            value: function K(j) {
                if (0 <= j && j <= 15) return 0x00000000;
                if (16 <= j && j <= 31) // Math.floor((2 ** 30) * Math.SQRT2)
                return 0x5A827999;
                if (32 <= j && j <= 47) // Math.floor((2 ** 30) * Math.sqrt(3))
                return 0x6ED9EBA1;
                if (48 <= j && j <= 63) // Math.floor((2 ** 30) * Math.sqrt(5))
                return 0x8F1BBCDC;
                if (64 <= j && j <= 79) // Math.floor((2 ** 30) * Math.sqrt(7))
                return 0xA953FD4E;
            }
        },
        {
            key: "KP",
            value: function KP(j) {
                if (0 <= j && j <= 15) // Math.floor((2 ** 30) * Math.cbrt(2))
                return 0x50A28BE6;
                if (16 <= j && j <= 31) // Math.floor((2 ** 30) * Math.cbrt(3))
                return 0x5C4DD124;
                if (32 <= j && j <= 47) // Math.floor((2 ** 30) * Math.cbrt(5))
                return 0x6D703EF3;
                if (48 <= j && j <= 63) // Math.floor((2 ** 30) * Math.cbrt(7))
                return 0x7A6D76E9;
                if (64 <= j && j <= 79) return 0x00000000;
            }
        },
        {
            key: "add_modulo32",
            value: function add_modulo32() /* ...... */ {
                // 1.  Modulo addition (addition modulo) is associative.
                //    https://proofwiki.org/wiki/Modulo_Addition_is_Associative
                // 2.  Bitwise operation in Javascript
                //    is done on 32-bits operands
                //    and results in a 32-bits value.
                return Array.from(arguments).reduce(function(a, b) {
                    return a + b;
                }, 0) | 0;
            }
        },
        {
            key: "rol32",
            value: function rol32(value, count) {
                // Cyclic left shift (rotate) on 32-bits value.
                return value << count | value >>> 32 - count;
            }
        },
        {
            key: "hash",
            value: function hash(message /* An ArrayBuffer. */ ) {
                //////////       Padding       //////////
                // The padded message.
                var padded = RIPEMD160.pad(message);
                //////////     Compression     //////////
                // Message word selectors.
                var r = [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    7,
                    4,
                    13,
                    1,
                    10,
                    6,
                    15,
                    3,
                    12,
                    0,
                    9,
                    5,
                    2,
                    14,
                    11,
                    8,
                    3,
                    10,
                    14,
                    4,
                    9,
                    15,
                    8,
                    1,
                    2,
                    7,
                    0,
                    6,
                    13,
                    11,
                    5,
                    12,
                    1,
                    9,
                    11,
                    10,
                    0,
                    8,
                    12,
                    4,
                    13,
                    3,
                    7,
                    15,
                    14,
                    5,
                    6,
                    2,
                    4,
                    0,
                    5,
                    9,
                    7,
                    12,
                    2,
                    10,
                    14,
                    1,
                    3,
                    8,
                    11,
                    6,
                    15,
                    13
                ];
                var rP = [
                    5,
                    14,
                    7,
                    0,
                    9,
                    2,
                    11,
                    4,
                    13,
                    6,
                    15,
                    8,
                    1,
                    10,
                    3,
                    12,
                    6,
                    11,
                    3,
                    7,
                    0,
                    13,
                    5,
                    10,
                    14,
                    15,
                    8,
                    12,
                    4,
                    9,
                    1,
                    2,
                    15,
                    5,
                    1,
                    3,
                    7,
                    14,
                    6,
                    9,
                    11,
                    8,
                    12,
                    2,
                    10,
                    0,
                    4,
                    13,
                    8,
                    6,
                    4,
                    1,
                    3,
                    11,
                    15,
                    0,
                    5,
                    12,
                    2,
                    13,
                    9,
                    7,
                    10,
                    14,
                    12,
                    15,
                    10,
                    4,
                    1,
                    5,
                    8,
                    7,
                    6,
                    2,
                    13,
                    14,
                    0,
                    3,
                    9,
                    11
                ];
                // Amounts for 'rotate left' operation.
                var s = [
                    11,
                    14,
                    15,
                    12,
                    5,
                    8,
                    7,
                    9,
                    11,
                    13,
                    14,
                    15,
                    6,
                    7,
                    9,
                    8,
                    7,
                    6,
                    8,
                    13,
                    11,
                    9,
                    7,
                    15,
                    7,
                    12,
                    15,
                    9,
                    11,
                    7,
                    13,
                    12,
                    11,
                    13,
                    6,
                    7,
                    14,
                    9,
                    13,
                    15,
                    14,
                    8,
                    13,
                    6,
                    5,
                    12,
                    7,
                    5,
                    11,
                    12,
                    14,
                    15,
                    14,
                    15,
                    9,
                    8,
                    9,
                    14,
                    5,
                    6,
                    8,
                    6,
                    5,
                    12,
                    9,
                    15,
                    5,
                    11,
                    6,
                    8,
                    13,
                    12,
                    5,
                    12,
                    13,
                    14,
                    11,
                    8,
                    5,
                    6
                ];
                var sP = [
                    8,
                    9,
                    9,
                    11,
                    13,
                    15,
                    15,
                    5,
                    7,
                    7,
                    8,
                    11,
                    14,
                    14,
                    12,
                    6,
                    9,
                    13,
                    15,
                    7,
                    12,
                    8,
                    9,
                    11,
                    7,
                    7,
                    12,
                    7,
                    6,
                    15,
                    13,
                    11,
                    9,
                    7,
                    15,
                    11,
                    8,
                    6,
                    6,
                    14,
                    12,
                    13,
                    5,
                    14,
                    13,
                    13,
                    7,
                    5,
                    15,
                    5,
                    8,
                    11,
                    14,
                    14,
                    6,
                    14,
                    6,
                    9,
                    12,
                    9,
                    12,
                    5,
                    15,
                    8,
                    8,
                    5,
                    12,
                    9,
                    12,
                    5,
                    14,
                    6,
                    8,
                    13,
                    6,
                    5,
                    15,
                    13,
                    11,
                    11
                ];
                // The size, in bytes, of a word.
                var word_size = 4;
                // The size, in bytes, of a 16-words block.
                var block_size = 64;
                // The number of the 16-words blocks.
                var t = padded.byteLength / block_size;
                //  The message after padding consists of t 16-word blocks that
                // are denoted with X_i[j], with 0≤i≤(t − 1) and 0≤j≤15.
                var X = new Array(t).fill(undefined).map(function(_, i) {
                    return function(j) {
                        return new DataView(padded, i * block_size, block_size).getUint32(j * word_size, true // Little-endian
                        );
                    };
                });
                //  The result of RIPEMD-160 is contained in five 32-bit words,
                // which form the internal state of the algorithm. The final
                // content of these five 32-bit words is converted to a 160-bit
                // string, again using the little-endian convention.
                var h = [
                    0x67452301,
                    0xEFCDAB89,
                    0x98BADCFE,
                    0x10325476,
                    0xC3D2E1F0 // h_4
                ];
                for(var i = 0; i < t; ++i){
                    var A = h[0], B = h[1], C = h[2], D = h[3], E = h[4];
                    var AP = A, BP = B, CP = C, DP = D, EP = E;
                    for(var j = 0; j < 80; ++j){
                        // Left rounds
                        var _T = RIPEMD160.add_modulo32(RIPEMD160.rol32(RIPEMD160.add_modulo32(A, RIPEMD160.f(j, B, C, D), X[i](r[j]), RIPEMD160.K(j)), s[j]), E);
                        A = E;
                        E = D;
                        D = RIPEMD160.rol32(C, 10);
                        C = B;
                        B = _T;
                        // Right rounds
                        _T = RIPEMD160.add_modulo32(RIPEMD160.rol32(RIPEMD160.add_modulo32(AP, RIPEMD160.f(79 - j, BP, CP, DP), X[i](rP[j]), RIPEMD160.KP(j)), sP[j]), EP);
                        AP = EP;
                        EP = DP;
                        DP = RIPEMD160.rol32(CP, 10);
                        CP = BP;
                        BP = _T;
                    }
                    var T = RIPEMD160.add_modulo32(h[1], C, DP);
                    h[1] = RIPEMD160.add_modulo32(h[2], D, EP);
                    h[2] = RIPEMD160.add_modulo32(h[3], E, AP);
                    h[3] = RIPEMD160.add_modulo32(h[4], A, BP);
                    h[4] = RIPEMD160.add_modulo32(h[0], B, CP);
                    h[0] = T;
                }
                //  The final output string then consists of the concatenatation
                // of h_0, h_1, h_2, h_3, and h_4 after converting each h_i to a
                // 4-byte string using the little-endian convention.
                var result = new ArrayBuffer(20);
                var data_view = new DataView(result);
                h.forEach(function(h_i, i) {
                    return data_view.setUint32(i * 4, h_i, true);
                });
                return result;
            }
        }
    ]);
    return RIPEMD160;
}();
module.exports = {
    RIPEMD160: $70782a28c592e4f0$var$RIPEMD160
};

});



parcelRegister("5ZH60", function(module, exports) {
module.exports = JSON.parse('{"version":"eosio::abi/1.1","structs":[{"name":"extensions_entry","base":"","fields":[{"name":"tag","type":"uint16"},{"name":"value","type":"bytes"}]},{"name":"type_def","base":"","fields":[{"name":"new_type_name","type":"string"},{"name":"type","type":"string"}]},{"name":"field_def","base":"","fields":[{"name":"name","type":"string"},{"name":"type","type":"string"}]},{"name":"struct_def","base":"","fields":[{"name":"name","type":"string"},{"name":"base","type":"string"},{"name":"fields","type":"field_def[]"}]},{"name":"action_def","base":"","fields":[{"name":"name","type":"name"},{"name":"type","type":"string"},{"name":"ricardian_contract","type":"string"}]},{"name":"table_def","base":"","fields":[{"name":"name","type":"name"},{"name":"index_type","type":"string"},{"name":"key_names","type":"string[]"},{"name":"key_types","type":"string[]"},{"name":"type","type":"string"}]},{"name":"clause_pair","base":"","fields":[{"name":"id","type":"string"},{"name":"body","type":"string"}]},{"name":"error_message","base":"","fields":[{"name":"error_code","type":"uint64"},{"name":"error_msg","type":"string"}]},{"name":"variant_def","base":"","fields":[{"name":"name","type":"string"},{"name":"types","type":"string[]"}]},{"name":"abi_def","base":"","fields":[{"name":"version","type":"string"},{"name":"types","type":"type_def[]"},{"name":"structs","type":"struct_def[]"},{"name":"actions","type":"action_def[]"},{"name":"tables","type":"table_def[]"},{"name":"ricardian_clauses","type":"clause_pair[]"},{"name":"error_messages","type":"error_message[]"},{"name":"abi_extensions","type":"extensions_entry[]"},{"name":"variants","type":"variant_def[]$"}]}]}');

});

parcelRegister("5jtNL", function(module, exports) {
module.exports = JSON.parse('{"version":"eosio::abi/1.0","types":[{"new_type_name":"account_name","type":"name"},{"new_type_name":"action_name","type":"name"},{"new_type_name":"permission_name","type":"name"}],"structs":[{"name":"permission_level","base":"","fields":[{"name":"actor","type":"account_name"},{"name":"permission","type":"permission_name"}]},{"name":"action","base":"","fields":[{"name":"account","type":"account_name"},{"name":"name","type":"action_name"},{"name":"authorization","type":"permission_level[]"},{"name":"data","type":"bytes"}]},{"name":"extension","base":"","fields":[{"name":"type","type":"uint16"},{"name":"data","type":"bytes"}]},{"name":"transaction_header","base":"","fields":[{"name":"expiration","type":"time_point_sec"},{"name":"ref_block_num","type":"uint16"},{"name":"ref_block_prefix","type":"uint32"},{"name":"max_net_usage_words","type":"varuint32"},{"name":"max_cpu_usage_ms","type":"uint8"},{"name":"delay_sec","type":"varuint32"}]},{"name":"transaction","base":"transaction_header","fields":[{"name":"context_free_actions","type":"action[]"},{"name":"actions","type":"action[]"},{"name":"transaction_extensions","type":"extension[]"}]}]}');

});


parcelRegister("1gRhS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $19Xnb = parcelRequire("19Xnb");
module.exports.prepareTransaction = $19Xnb.prepareTransaction;

var $azagM = parcelRequire("azagM");
module.exports.accountHash = $azagM.accountHash;

var $6ZrYO = parcelRequire("6ZrYO");
module.exports.createSharedCipher = $6ZrYO.createSharedCipher;

});
parcelRegister("19Xnb", function(module, exports) {
"use strict";
var $0d84afeb788ff196$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0d84afeb788ff196$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3I0qg = parcelRequire("3I0qg");

var $c2Udc = parcelRequire("c2Udc");

var $ltQVr = parcelRequire("ltQVr");
/** @return a packed and signed transaction formatted ready to be pushed to chain. */ function $0d84afeb788ff196$var$prepareTransaction(_a) {
    var transaction = _a.transaction, chainId = _a.chainId, privateKeys = _a.privateKeys, abiMap = _a.abiMap, textDecoder = _a.textDecoder, textEncoder = _a.textEncoder;
    return $0d84afeb788ff196$var$__awaiter(this, void 0, void 0, function() {
        var signatureProvider, authorityProvider, abiProvider, api, _b, signatures, serializedTransaction, serializedContextFreeData;
        return $0d84afeb788ff196$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    signatureProvider = new $c2Udc.JsSignatureProvider(privateKeys);
                    authorityProvider = $3I0qg.signAllAuthorityProvider;
                    abiProvider = {
                        getRawAbi: function(accountName) {
                            return $0d84afeb788ff196$var$__awaiter(this, void 0, void 0, function() {
                                var rawAbi, abi, binaryAbi;
                                return $0d84afeb788ff196$var$__generator(this, function(_a) {
                                    rawAbi = abiMap.get(accountName);
                                    if (!rawAbi) throw new Error("Missing ABI for account " + accountName);
                                    abi = $ltQVr.base64ToBinary(rawAbi.abi);
                                    binaryAbi = {
                                        accountName: rawAbi.account_name,
                                        abi: abi
                                    };
                                    return [
                                        2 /*return*/ ,
                                        binaryAbi
                                    ];
                                });
                            });
                        }
                    };
                    api = new $3I0qg.Api({
                        signatureProvider: signatureProvider,
                        authorityProvider: authorityProvider,
                        abiProvider: abiProvider,
                        chainId: chainId,
                        textDecoder: textDecoder,
                        textEncoder: textEncoder
                    });
                    return [
                        4 /*yield*/ ,
                        api.transact(transaction)
                    ];
                case 1:
                    _b = _c.sent(), signatures = _b.signatures, serializedTransaction = _b.serializedTransaction, serializedContextFreeData = _b.serializedContextFreeData;
                    return [
                        2 /*return*/ ,
                        {
                            signatures: signatures,
                            compression: 0,
                            packed_context_free_data: $ltQVr.arrayToHex(serializedContextFreeData || new Uint8Array(0)),
                            packed_trx: $ltQVr.arrayToHex(serializedTransaction)
                        }
                    ];
            }
        });
    });
}
module.exports.prepareTransaction = $0d84afeb788ff196$var$prepareTransaction;

});
parcelRegister("c2Udc", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $8c514677cfcbefcf$require$Buffer = $ihoyg.Buffer;
"use strict";
/**
 * @module JS-Sig
 */ // copyright defined in fiojs/LICENSE.txt
var $8c514677cfcbefcf$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $8c514677cfcbefcf$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $8c514677cfcbefcf$var$__values = module.exports && module.exports.__values || function(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $ltQVr = parcelRequire("ltQVr");

var $jOsMe = parcelRequire("jOsMe");
function $8c514677cfcbefcf$var$hexToUint8Array(hex) {
    if (typeof hex !== "string") throw new Error("Expected string containing hex digits");
    if (hex.length % 2) throw new Error("Odd number of hex digits");
    var l = hex.length / 2;
    var result = new Uint8Array(l);
    for(var i = 0; i < l; ++i){
        var x = parseInt(hex.substr(i * 2, 2), 16);
        if (Number.isNaN(x)) throw new Error("Expected hex string");
        result[i] = x;
    }
    return result;
}
function $8c514677cfcbefcf$var$isExternalPrivateKey(x) {
    return (typeof x === "object" || typeof x === "function") && "publicKey" in x && typeof x.publicKey === "string" && "sign" in x && typeof x.sign === "function" && "getSharedSecret" in x && typeof x.getSharedSecret === "function";
}
module.exports.isExternalPrivateKey = $8c514677cfcbefcf$var$isExternalPrivateKey;
/** Signs transactions using in-process private keys */ var $8c514677cfcbefcf$var$JsSignatureProvider = /** @class */ function() {
    /** @param privateKeys private keys to sign with */ function JsSignatureProvider(privateKeys) {
        var e_1, _a;
        /** map public to private keys */ this.keys = new Map();
        /** public keys */ this.availableKeys = [];
        try {
            for(var privateKeys_1 = $8c514677cfcbefcf$var$__values(privateKeys), privateKeys_1_1 = privateKeys_1.next(); !privateKeys_1_1.done; privateKeys_1_1 = privateKeys_1.next()){
                var k = privateKeys_1_1.value;
                var pub = $ltQVr.convertLegacyPublicKey($8c514677cfcbefcf$var$isExternalPrivateKey(k) ? k.publicKey : $jOsMe.PrivateKey.fromString(k).toPublic().toString());
                this.keys.set(pub, k);
                this.availableKeys.push(pub);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (privateKeys_1_1 && !privateKeys_1_1.done && (_a = privateKeys_1.return)) _a.call(privateKeys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    }
    /** Public keys associated with the private keys that the `SignatureProvider` holds */ JsSignatureProvider.prototype.getAvailableKeys = function() {
        return $8c514677cfcbefcf$var$__awaiter(this, void 0, void 0, function() {
            return $8c514677cfcbefcf$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.availableKeys
                ];
            });
        });
    };
    /** Sign a transaction */ JsSignatureProvider.prototype.sign = function(_a) {
        var chainId = _a.chainId, requiredKeys = _a.requiredKeys, serializedTransaction = _a.serializedTransaction, serializedContextFreeData = _a.serializedContextFreeData;
        return $8c514677cfcbefcf$var$__awaiter(this, void 0, void 0, function() {
            var signBuf, signatures;
            var _this = this;
            return $8c514677cfcbefcf$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        signBuf = $8c514677cfcbefcf$require$Buffer.concat([
                            new $8c514677cfcbefcf$require$Buffer(chainId, "hex"),
                            new $8c514677cfcbefcf$require$Buffer(serializedTransaction),
                            new $8c514677cfcbefcf$require$Buffer(serializedContextFreeData ? $8c514677cfcbefcf$var$hexToUint8Array($jOsMe.sha256(serializedContextFreeData)) : new Uint8Array(32))
                        ]);
                        return [
                            4 /*yield*/ ,
                            Promise.all(requiredKeys.map(function(pub) {
                                return $8c514677cfcbefcf$var$__awaiter(_this, void 0, void 0, function() {
                                    var priv;
                                    return $8c514677cfcbefcf$var$__generator(this, function(_a) {
                                        switch(_a.label){
                                            case 0:
                                                priv = this.keys.get($ltQVr.convertLegacyPublicKey(pub));
                                                if (!$8c514677cfcbefcf$var$isExternalPrivateKey(priv)) return [
                                                    3 /*break*/ ,
                                                    2
                                                ];
                                                return [
                                                    4 /*yield*/ ,
                                                    priv.sign(signBuf)
                                                ];
                                            case 1:
                                                return [
                                                    2 /*return*/ ,
                                                    _a.sent()
                                                ];
                                            case 2:
                                                return [
                                                    2 /*return*/ ,
                                                    $jOsMe.Signature.sign(signBuf, priv).toString()
                                                ];
                                        }
                                    });
                                });
                            }))
                        ];
                    case 1:
                        signatures = _b.sent();
                        return [
                            2 /*return*/ ,
                            {
                                signatures: signatures,
                                serializedTransaction: serializedTransaction,
                                serializedContextFreeData: serializedContextFreeData
                            }
                        ];
                }
            });
        });
    };
    return JsSignatureProvider;
}();
module.exports.JsSignatureProvider = $8c514677cfcbefcf$var$JsSignatureProvider;

});
parcelRegister("jOsMe", function(module, exports) {

var $j645c = parcelRequire("j645c");

var $cGPwy = parcelRequire("cGPwy");
const $e6c90254dd944201$var$ecc = Object.assign({}, $j645c, $cGPwy);
module.exports = $e6c90254dd944201$var$ecc;

});
parcelRegister("j645c", function(module, exports) {

var $6CIJR = parcelRequire("6CIJR");

var $d3MuN = parcelRequire("d3MuN");

var $9maPk = parcelRequire("9maPk");
parcelRequire("9YYFe");

var $jJ9gD = parcelRequire("jJ9gD");
/**
    [Wallet Import Format](https://en.bitcoin.it/wiki/Wallet_import_format)
    @typedef {string} wif
*/ /**
    FIOKey..
    @typedef {string} pubkey
*/ /** @namespace */ const $de71be9fb04697e9$var$ecc = {
    /**
      Initialize by running some self-checking code.  This should take a
      second to gather additional CPU entropy used during private key
      generation.

      Initialization happens once even if called multiple times.

      @return {Promise}
    */ initialize: $6CIJR.initialize,
    /**
      Does not pause to gather CPU entropy.
      @return {Promise<PrivateKey>} test key
    */ unsafeRandomKey: ()=>$6CIJR.unsafeRandomKey().then((key)=>key.toString()),
    /**
        @arg {number} [cpuEntropyBits = 0] gather additional entropy
        from a CPU mining algorithm.  This will already happen once by
        default.

        @return {Promise<wif>}

        @example
ecc.randomKey().then(privateKey => {
  console.log('Private Key:\t', privateKey) // wif
  console.log('Public Key:\t', ecc.privateToPublic(privateKey)) // FIOkey...
})
    */ randomKey: (cpuEntropyBits)=>$6CIJR.randomKey(cpuEntropyBits).then((key)=>key.toString()),
    /**

        @arg {string} seed - any length string.  This is private.  The same
        seed produces the same private key every time.  At least 128 random
        bits should be used to produce a good private key.
        @return {wif}

        @example ecc.seedPrivate('secret') === wif
    */ seedPrivate: (seed)=>$6CIJR.fromSeed(seed).toString(),
    /**
        @arg {wif} wif
        @arg {string} [pubkey_prefix = 'FIO'] - public key prefix

        @return {pubkey}

        @example ecc.privateToPublic(wif) === pubkey
    */ privateToPublic: (wif, pubkey_prefix = "FIO")=>$6CIJR(wif).toPublic().toString(pubkey_prefix),
    /**
        @arg {pubkey} pubkey - like FIOKey..
        @arg {string} [pubkey_prefix = 'FIO']

        @return {boolean} valid

        @example ecc.isValidPublic(pubkey) === true
    */ isValidPublic: (pubkey, pubkey_prefix = "FIO")=>$d3MuN.isValid(pubkey, pubkey_prefix),
    /**
        @arg {wif} wif
        @return {boolean} valid

        @example ecc.isValidPrivate(wif) === true
    */ isValidPrivate: (wif)=>$6CIJR.isValid(wif),
    /**
        Create a signature using data or a hash.

        @arg {string|Buffer} data
        @arg {wif|PrivateKey} privateKey
        @arg {String} [encoding = 'utf8'] - data encoding (if string)

        @return {string} string signature

        @example ecc.sign('I am alive', wif)
    */ sign: (data, privateKey, encoding = "utf8")=>{
        if (encoding === true) throw new TypeError("API changed, use signHash(..) instead");
        else if (encoding === false) console.log("Warning: ecc.sign hashData parameter was removed");
        return $9maPk.sign(data, privateKey, encoding).toString();
    },
    /**
        @arg {String|Buffer} dataSha256 - sha256 hash 32 byte buffer or string
        @arg {wif|PrivateKey} privateKey
        @arg {String} [encoding = 'hex'] - dataSha256 encoding (if string)

        @return {string} string signature
    */ signHash: (dataSha256, privateKey, encoding = "hex")=>{
        return $9maPk.signHash(dataSha256, privateKey, encoding).toString();
    },
    /**
        Verify signed data.

        @arg {string|Buffer} signature - buffer or hex string
        @arg {string|Buffer} data
        @arg {pubkey|PublicKey} pubkey
        @arg {boolean} [hashData = true] - sha256 hash data before verify
        @return {boolean}

        @example ecc.verify(signature, 'I am alive', pubkey) === true
    */ verify: (signature, data, pubkey, encoding = "utf8")=>{
        if (encoding === true) throw new TypeError("API changed, use verifyHash(..) instead");
        else if (encoding === false) console.log("Warning: ecc.verify hashData parameter was removed");
        signature = $9maPk.from(signature);
        return signature.verify(data, pubkey, encoding);
    },
    verifyHash (signature, dataSha256, pubkey, encoding = "hex") {
        signature = $9maPk.from(signature);
        return signature.verifyHash(dataSha256, pubkey, encoding);
    },
    /**
        Recover the public key used to create the signature.

        @arg {String|Buffer} signature (FIObase58sig.., Hex, Buffer)
        @arg {String|Buffer} data - full data
        @arg {String} [encoding = 'utf8'] - data encoding (if data is a string)

        @return {pubkey}

        @example ecc.recover(signature, 'I am alive') === pubkey
    */ recover: (signature, data, encoding = "utf8")=>{
        if (encoding === true) throw new TypeError("API changed, use recoverHash(signature, data) instead");
        else if (encoding === false) console.log("Warning: ecc.recover hashData parameter was removed");
        signature = $9maPk.from(signature);
        return signature.recover(data, encoding).toString();
    },
    /**
        @arg {String|Buffer} signature (FIObase58sig.., Hex, Buffer)
        @arg {String|Buffer} dataSha256 - sha256 hash 32 byte buffer or hex string
        @arg {String} [encoding = 'hex'] - dataSha256 encoding (if dataSha256 is a string)

        @return {PublicKey}
    */ recoverHash: (signature, dataSha256, encoding = "hex")=>{
        signature = $9maPk.from(signature);
        return signature.recoverHash(dataSha256, encoding).toString();
    },
    /** @arg {string|Buffer} data - always binary, you may need Buffer.from(data, 'hex')
        @arg {string} [encoding = 'hex'] - result encoding 'hex', 'binary' or 'base64'
        @return {string|Buffer} - Buffer when encoding is null, or string

        @example ecc.sha256('hashme') === '02208b..'
        @example ecc.sha256(Buffer.from('02208b', 'hex')) === '29a23..'
    */ sha256: (data, resultEncoding = "hex")=>$jJ9gD.sha256(data, resultEncoding)
};
module.exports = $de71be9fb04697e9$var$ecc;

});
parcelRegister("6CIJR", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4d28fed617d29f0a$require$Buffer = $ihoyg.Buffer;

var $hT5Tn = parcelRequire("hT5Tn");
const $4d28fed617d29f0a$var$Point = $hT5Tn.Point;
const $4d28fed617d29f0a$var$secp256k1 = $hT5Tn.getCurveByName("secp256k1");

var $66llh = parcelRequire("66llh");

var $bhJ7Q = parcelRequire("bhJ7Q");

var $jJ9gD = parcelRequire("jJ9gD");

var $d3MuN = parcelRequire("d3MuN");

var $9YYFe = parcelRequire("9YYFe");

var $3FiLE = parcelRequire("3FiLE");

var $70BmP = parcelRequire("70BmP");
const $4d28fed617d29f0a$var$G = $4d28fed617d29f0a$var$secp256k1.G;
const $4d28fed617d29f0a$var$n = $4d28fed617d29f0a$var$secp256k1.n;
module.exports = $4d28fed617d29f0a$var$PrivateKey;
/**
  @typedef {string} wif - https://en.bitcoin.it/wiki/Wallet_import_format
  @typedef {string} pubkey - FIOKey..
  @typedef {ecurve.Point} Point
*/ /**
  @param {BigInteger} d
*/ function $4d28fed617d29f0a$var$PrivateKey(d) {
    if (typeof d === "string") return $4d28fed617d29f0a$var$PrivateKey.fromString(d);
    else if ($4d28fed617d29f0a$require$Buffer.isBuffer(d)) return $4d28fed617d29f0a$var$PrivateKey.fromBuffer(d);
    else if (typeof d === "object" && $66llh.isBigInteger(d.d)) return $4d28fed617d29f0a$var$PrivateKey(d.d);
    if (!$66llh.isBigInteger(d)) throw new TypeError("Invalid private key");
    /** @return {string} private key like PVT_K1_base58privatekey.. */ function toString() {
        // todo, use PVT_K1_
        // return 'PVT_K1_' + keyUtils.checkEncode(toBuffer(), 'K1')
        return toWif();
    }
    /**
        @return  {wif}
    */ function toWif() {
        var private_key = toBuffer();
        // checksum includes the version
        private_key = $4d28fed617d29f0a$require$Buffer.concat([
            new $4d28fed617d29f0a$require$Buffer([
                0x80
            ]),
            private_key
        ]);
        return $9YYFe.checkEncode(private_key, "sha256x2");
    }
    let public_key;
    /**
        @return {Point}
    */ function toPublic() {
        if (public_key) // cache
        // S L O W in the browser
        return public_key;
        const Q = $4d28fed617d29f0a$var$secp256k1.G.multiply(d);
        return public_key = $d3MuN.fromPoint(Q);
    }
    function toBuffer() {
        return d.toBuffer(32);
    }
    /**
      ECIES
      @arg {string|Object} pubkey wif, PublicKey object
      @return {Buffer} 64 byte shared secret
    */ function getSharedSecret(public_key) {
        public_key = $d3MuN(public_key);
        let KB = public_key.toUncompressed().toBuffer();
        let KBP = $4d28fed617d29f0a$var$Point.fromAffine($4d28fed617d29f0a$var$secp256k1, $66llh.fromBuffer(KB.slice(1, 33)), $66llh.fromBuffer(KB.slice(33, 65)) // y
        );
        let r = toBuffer();
        let P = KBP.multiply($66llh.fromBuffer(r));
        let S = P.affineX.toBuffer({
            size: 32
        });
        // SHA512 used in ECIES
        return $jJ9gD.sha512(S);
    }
    // /** ECIES TODO unit test
    //   @arg {string|Object} pubkey wif, PublicKey object
    //   @return {Buffer} 64 byte shared secret
    // */
    // function getSharedSecret(public_key) {
    //     public_key = PublicKey(public_key).toUncompressed()
    //     var P = public_key.Q.multiply( d );
    //     var S = P.affineX.toBuffer({size: 32});
    //     // ECIES, adds an extra sha512
    //     return hash.sha512(S);
    // }
    /**
      @arg {string} name - child key name.
      @return {PrivateKey}

      @example activePrivate = masterPrivate.getChildKey('owner').getChildKey('active')
      @example activePrivate.getChildKey('mycontract').getChildKey('myperm')
    */ function getChildKey(name) {
        // console.error('WARNING: getChildKey untested against eosd'); // no eosd impl yet
        const index = $3FiLE("sha256").update(toBuffer()).update(name).digest();
        return $4d28fed617d29f0a$var$PrivateKey(index);
    }
    function toHex() {
        return toBuffer().toString("hex");
    }
    return {
        d: d,
        toWif: toWif,
        toString: toString,
        toPublic: toPublic,
        toBuffer: toBuffer,
        getSharedSecret: getSharedSecret,
        getChildKey: getChildKey
    };
}
/** @private */ function $4d28fed617d29f0a$var$parseKey(privateStr) {
    $bhJ7Q.equal(typeof privateStr, "string", "privateStr");
    const match = privateStr.match(/^PVT_([A-Za-z0-9]+)_([A-Za-z0-9]+)$/);
    if (match === null) {
        // legacy WIF - checksum includes the version
        const versionKey = $9YYFe.checkDecode(privateStr, "sha256x2");
        const version = versionKey.readUInt8(0);
        $bhJ7Q.equal(0x80, version, `Expected version ${0x80}, instead got ${version}`);
        const privateKey = $4d28fed617d29f0a$var$PrivateKey.fromBuffer(versionKey.slice(1));
        const keyType = "K1";
        const format = "WIF";
        return {
            privateKey: privateKey,
            format: format,
            keyType: keyType
        };
    }
    $bhJ7Q(match.length === 3, "Expecting private key like: PVT_K1_base58privateKey..");
    const [, keyType, keyString] = match;
    $bhJ7Q.equal(keyType, "K1", "K1 private key expected");
    const privateKey = $4d28fed617d29f0a$var$PrivateKey.fromBuffer($9YYFe.checkDecode(keyString, keyType));
    return {
        privateKey: privateKey,
        format: "PVT",
        keyType: keyType
    };
}
$4d28fed617d29f0a$var$PrivateKey.fromHex = function(hex) {
    return $4d28fed617d29f0a$var$PrivateKey.fromBuffer(new $4d28fed617d29f0a$require$Buffer(hex, "hex"));
};
$4d28fed617d29f0a$var$PrivateKey.fromBuffer = function(buf) {
    if (!$4d28fed617d29f0a$require$Buffer.isBuffer(buf)) throw new Error("Expecting parameter to be a Buffer type");
    if (buf.length === 33 && buf[32] === 1) // remove compression flag
    buf = buf.slice(0, -1);
    if (32 !== buf.length) throw new Error(`Expecting 32 bytes, instead got ${buf.length}`);
    return $4d28fed617d29f0a$var$PrivateKey($66llh.fromBuffer(buf));
};
/**
    @arg {string} seed - any length string.  This is private, the same seed
    produces the same private key every time.

    @return {PrivateKey}
*/ $4d28fed617d29f0a$var$PrivateKey.fromSeed = function(seed) {
    if (!(typeof seed === "string")) throw new Error("seed must be of type string");
    return $4d28fed617d29f0a$var$PrivateKey.fromBuffer($jJ9gD.sha256(seed));
};
/**
  @arg {wif} key
  @return {boolean} true if key is in the Wallet Import Format
*/ $4d28fed617d29f0a$var$PrivateKey.isWif = function(text) {
    try {
        $bhJ7Q($4d28fed617d29f0a$var$parseKey(text).format === "WIF");
        return true;
    } catch (e) {
        return false;
    }
};
/**
  @arg {wif|Buffer|PrivateKey} key
  @return {boolean} true if key is convertable to a private key object.
*/ $4d28fed617d29f0a$var$PrivateKey.isValid = function(key) {
    try {
        $4d28fed617d29f0a$var$PrivateKey(key);
        return true;
    } catch (e) {
        return false;
    }
};
/** @deprecated */ $4d28fed617d29f0a$var$PrivateKey.fromWif = function(str) {
    console.log("PrivateKey.fromWif is deprecated, please use PrivateKey.fromString");
    return $4d28fed617d29f0a$var$PrivateKey.fromString(str);
};
/**
    @throws {AssertError|Error} parsing key
    @arg {string} privateStr Eosio or Wallet Import Format (wif) -- a secret
*/ $4d28fed617d29f0a$var$PrivateKey.fromString = function(privateStr) {
    return $4d28fed617d29f0a$var$parseKey(privateStr).privateKey;
};
/**
  Create a new random private key.

  Call initialize() first to run some self-checking code and gather some CPU
  entropy.

  @arg {number} [cpuEntropyBits = 0] - additional CPU entropy, this already
  happens once so it should not be needed again.

  @return {Promise<PrivateKey>} - random private key
*/ $4d28fed617d29f0a$var$PrivateKey.randomKey = function(cpuEntropyBits = 0) {
    return $4d28fed617d29f0a$var$PrivateKey.initialize().then(()=>$4d28fed617d29f0a$var$PrivateKey.fromBuffer($9YYFe.random32ByteBuffer({
            cpuEntropyBits: cpuEntropyBits
        })));
};
/**
  @return {Promise<PrivateKey>} for testing, does not require initialize().
*/ $4d28fed617d29f0a$var$PrivateKey.unsafeRandomKey = function() {
    return Promise.resolve($4d28fed617d29f0a$var$PrivateKey.fromBuffer($9YYFe.random32ByteBuffer({
        safe: false
    })));
};
let $4d28fed617d29f0a$var$initialized = false, $4d28fed617d29f0a$var$unitTested = false;
/**
  Run self-checking code and gather CPU entropy.

  Initialization happens once even if called multiple times.

  @return {Promise}
*/ function $4d28fed617d29f0a$var$initialize() {
    if ($4d28fed617d29f0a$var$initialized) return;
    $4d28fed617d29f0a$var$unitTest();
    $9YYFe.addEntropy(...$9YYFe.cpuEntropy());
    $bhJ7Q($9YYFe.entropyCount() >= 128, "insufficient entropy");
    $4d28fed617d29f0a$var$initialized = true;
}
$4d28fed617d29f0a$var$PrivateKey.initialize = $70BmP($4d28fed617d29f0a$var$initialize);
/**
  Unit test basic private and public key functionality.

  @throws {AssertError}
*/ function $4d28fed617d29f0a$var$unitTest() {
    const pvt = $4d28fed617d29f0a$var$PrivateKey($jJ9gD.sha256(""));
    const pvtError = "key comparison test failed on a known private key";
    $bhJ7Q.equal(pvt.toWif(), "5KYZdUEo39z3FPrtuX2QbbwGnNP5zTd7yyr2SC1j299sBCnWjss", pvtError);
    $bhJ7Q.equal(pvt.toString(), "5KYZdUEo39z3FPrtuX2QbbwGnNP5zTd7yyr2SC1j299sBCnWjss", pvtError);
    // assert.equal(pvt.toString(), 'PVT_K1_2jH3nnhxhR3zPUcsKaWWZC9ZmZAnKm3GAnFD1xynGJE1Znuvjd', pvtError)
    const pub = pvt.toPublic();
    const pubError = "pubkey string comparison test failed on a known public key";
    $bhJ7Q.equal(pub.toString(), "FIO859gxfnXyUriMgUeThh1fWv3oqcpLFyHa3TfFYC4PK2HqhToVM", pubError);
    // assert.equal(pub.toString(), 'PUB_K1_859gxfnXyUriMgUeThh1fWv3oqcpLFyHa3TfFYC4PK2Ht7beeX', pubError)
    // assert.equal(pub.toStringLegacy(), 'FIO859gxfnXyUriMgUeThh1fWv3oqcpLFyHa3TfFYC4PK2HqhToVM', pubError)
    $4d28fed617d29f0a$var$doesNotThrow(()=>$4d28fed617d29f0a$var$PrivateKey.fromString(pvt.toWif()), "converting known wif from string");
    $4d28fed617d29f0a$var$doesNotThrow(()=>$4d28fed617d29f0a$var$PrivateKey.fromString(pvt.toString()), "converting known pvt from string");
    $4d28fed617d29f0a$var$doesNotThrow(()=>$d3MuN.fromString(pub.toString()), "converting known public key from string");
    // doesNotThrow(() => PublicKey.fromString(pub.toStringLegacy()), 'converting known public key from string')
    $4d28fed617d29f0a$var$unitTested = true;
}
/** @private */ const $4d28fed617d29f0a$var$doesNotThrow = (cb, msg)=>{
    try {
        cb();
    } catch (error) {
        error.message = `${msg} ==> ${error.message}`;
        throw error;
    }
};

});
parcelRegister("hT5Tn", function(module, exports) {

var $BJzX3 = parcelRequire("BJzX3");

var $iTDkh = parcelRequire("iTDkh");

var $igaWv = parcelRequire("igaWv");
module.exports = {
    Curve: $iTDkh,
    Point: $BJzX3,
    getCurveByName: $igaWv
};

});
parcelRegister("BJzX3", function(module, exports) {

var $bhJ7Q = parcelRequire("bhJ7Q");

var $6U9mG = parcelRequire("6U9mG");
var $0716cfd437331676$require$Buffer = $6U9mG.Buffer;

var $66llh = parcelRequire("66llh");
var $0716cfd437331676$var$THREE = $66llh.valueOf(3);
function $0716cfd437331676$var$Point(curve, x, y, z) {
    $bhJ7Q.notStrictEqual(z, undefined, "Missing Z coordinate");
    this.curve = curve;
    this.x = x;
    this.y = y;
    this.z = z;
    this._zInv = null;
    this.compressed = true;
}
Object.defineProperty($0716cfd437331676$var$Point.prototype, "zInv", {
    get: function() {
        if (this._zInv === null) this._zInv = this.z.modInverse(this.curve.p);
        return this._zInv;
    }
});
Object.defineProperty($0716cfd437331676$var$Point.prototype, "affineX", {
    get: function() {
        return this.x.multiply(this.zInv).mod(this.curve.p);
    }
});
Object.defineProperty($0716cfd437331676$var$Point.prototype, "affineY", {
    get: function() {
        return this.y.multiply(this.zInv).mod(this.curve.p);
    }
});
$0716cfd437331676$var$Point.fromAffine = function(curve, x, y) {
    return new $0716cfd437331676$var$Point(curve, x, y, $66llh.ONE);
};
$0716cfd437331676$var$Point.prototype.equals = function(other) {
    if (other === this) return true;
    if (this.curve.isInfinity(this)) return this.curve.isInfinity(other);
    if (this.curve.isInfinity(other)) return this.curve.isInfinity(this);
    // u = Y2 * Z1 - Y1 * Z2
    var u = other.y.multiply(this.z).subtract(this.y.multiply(other.z)).mod(this.curve.p);
    if (u.signum() !== 0) return false;
    // v = X2 * Z1 - X1 * Z2
    var v = other.x.multiply(this.z).subtract(this.x.multiply(other.z)).mod(this.curve.p);
    return v.signum() === 0;
};
$0716cfd437331676$var$Point.prototype.negate = function() {
    var y = this.curve.p.subtract(this.y);
    return new $0716cfd437331676$var$Point(this.curve, this.x, y, this.z);
};
$0716cfd437331676$var$Point.prototype.add = function(b) {
    if (this.curve.isInfinity(this)) return b;
    if (this.curve.isInfinity(b)) return this;
    var x1 = this.x;
    var y1 = this.y;
    var x2 = b.x;
    var y2 = b.y;
    // u = Y2 * Z1 - Y1 * Z2
    var u = y2.multiply(this.z).subtract(y1.multiply(b.z)).mod(this.curve.p);
    // v = X2 * Z1 - X1 * Z2
    var v = x2.multiply(this.z).subtract(x1.multiply(b.z)).mod(this.curve.p);
    if (v.signum() === 0) {
        if (u.signum() === 0) return this.twice() // this == b, so double
        ;
        return this.curve.infinity // this = -b, so infinity
        ;
    }
    var v2 = v.square();
    var v3 = v2.multiply(v);
    var x1v2 = x1.multiply(v2);
    var zu2 = u.square().multiply(this.z);
    // x3 = v * (z2 * (z1 * u^2 - 2 * x1 * v^2) - v^3)
    var x3 = zu2.subtract(x1v2.shiftLeft(1)).multiply(b.z).subtract(v3).multiply(v).mod(this.curve.p);
    // y3 = z2 * (3 * x1 * u * v^2 - y1 * v^3 - z1 * u^3) + u * v^3
    var y3 = x1v2.multiply($0716cfd437331676$var$THREE).multiply(u).subtract(y1.multiply(v3)).subtract(zu2.multiply(u)).multiply(b.z).add(u.multiply(v3)).mod(this.curve.p);
    // z3 = v^3 * z1 * z2
    var z3 = v3.multiply(this.z).multiply(b.z).mod(this.curve.p);
    return new $0716cfd437331676$var$Point(this.curve, x3, y3, z3);
};
$0716cfd437331676$var$Point.prototype.twice = function() {
    if (this.curve.isInfinity(this)) return this;
    if (this.y.signum() === 0) return this.curve.infinity;
    var x1 = this.x;
    var y1 = this.y;
    var y1z1 = y1.multiply(this.z).mod(this.curve.p);
    var y1sqz1 = y1z1.multiply(y1).mod(this.curve.p);
    var a = this.curve.a;
    // w = 3 * x1^2 + a * z1^2
    var w = x1.square().multiply($0716cfd437331676$var$THREE);
    if (a.signum() !== 0) w = w.add(this.z.square().multiply(a));
    w = w.mod(this.curve.p);
    // x3 = 2 * y1 * z1 * (w^2 - 8 * x1 * y1^2 * z1)
    var x3 = w.square().subtract(x1.shiftLeft(3).multiply(y1sqz1)).shiftLeft(1).multiply(y1z1).mod(this.curve.p);
    // y3 = 4 * y1^2 * z1 * (3 * w * x1 - 2 * y1^2 * z1) - w^3
    var y3 = w.multiply($0716cfd437331676$var$THREE).multiply(x1).subtract(y1sqz1.shiftLeft(1)).shiftLeft(2).multiply(y1sqz1).subtract(w.pow(3)).mod(this.curve.p);
    // z3 = 8 * (y1 * z1)^3
    var z3 = y1z1.pow(3).shiftLeft(3).mod(this.curve.p);
    return new $0716cfd437331676$var$Point(this.curve, x3, y3, z3);
};
// Simple NAF (Non-Adjacent Form) multiplication algorithm
// TODO: modularize the multiplication algorithm
$0716cfd437331676$var$Point.prototype.multiply = function(k) {
    if (this.curve.isInfinity(this)) return this;
    if (k.signum() === 0) return this.curve.infinity;
    var e = k;
    var h = e.multiply($0716cfd437331676$var$THREE);
    var neg = this.negate();
    var R = this;
    for(var i = h.bitLength() - 2; i > 0; --i){
        var hBit = h.testBit(i);
        var eBit = e.testBit(i);
        R = R.twice();
        if (hBit !== eBit) R = R.add(hBit ? this : neg);
    }
    return R;
};
// Compute this*j + x*k (simultaneous multiplication)
$0716cfd437331676$var$Point.prototype.multiplyTwo = function(j, x, k) {
    var i = Math.max(j.bitLength(), k.bitLength()) - 1;
    var R = this.curve.infinity;
    var both = this.add(x);
    while(i >= 0){
        var jBit = j.testBit(i);
        var kBit = k.testBit(i);
        R = R.twice();
        if (jBit) {
            if (kBit) R = R.add(both);
            else R = R.add(this);
        } else if (kBit) R = R.add(x);
        --i;
    }
    return R;
};
$0716cfd437331676$var$Point.prototype.getEncoded = function(compressed) {
    if (compressed == null) compressed = this.compressed;
    if (this.curve.isInfinity(this)) return $0716cfd437331676$require$Buffer.alloc(1, 0) // Infinity point encoded is simply '00'
    ;
    var x = this.affineX;
    var y = this.affineY;
    var byteLength = this.curve.pLength;
    var buffer;
    // 0x02/0x03 | X
    if (compressed) {
        buffer = $0716cfd437331676$require$Buffer.allocUnsafe(1 + byteLength);
        buffer.writeUInt8(y.isEven() ? 0x02 : 0x03, 0);
    // 0x04 | X | Y
    } else {
        buffer = $0716cfd437331676$require$Buffer.allocUnsafe(1 + byteLength + byteLength);
        buffer.writeUInt8(0x04, 0);
        y.toBuffer(byteLength).copy(buffer, 1 + byteLength);
    }
    x.toBuffer(byteLength).copy(buffer, 1);
    return buffer;
};
$0716cfd437331676$var$Point.decodeFrom = function(curve, buffer) {
    var type = buffer.readUInt8(0);
    var compressed = type !== 4;
    var byteLength = Math.floor((curve.p.bitLength() + 7) / 8);
    var x = $66llh.fromBuffer(buffer.slice(1, 1 + byteLength));
    var Q;
    if (compressed) {
        $bhJ7Q.equal(buffer.length, byteLength + 1, "Invalid sequence length");
        $bhJ7Q(type === 0x02 || type === 0x03, "Invalid sequence tag");
        var isOdd = type === 0x03;
        Q = curve.pointFromX(isOdd, x);
    } else {
        $bhJ7Q.equal(buffer.length, 1 + byteLength + byteLength, "Invalid sequence length");
        var y = $66llh.fromBuffer(buffer.slice(1 + byteLength));
        Q = $0716cfd437331676$var$Point.fromAffine(curve, x, y);
    }
    Q.compressed = compressed;
    return Q;
};
$0716cfd437331676$var$Point.prototype.toString = function() {
    if (this.curve.isInfinity(this)) return "(INFINITY)";
    return "(" + this.affineX.toString() + "," + this.affineY.toString() + ")";
};
module.exports = $0716cfd437331676$var$Point;

});
parcelRegister("66llh", function(module, exports) {

var $c0yxm = parcelRequire("c0yxm");
parcelRequire("4pBvL");
module.exports = $c0yxm;

});
parcelRegister("c0yxm", function(module, exports) {
// (public) Constructor
function $8be04678a11e1e44$var$BigInteger(a, b, c) {
    if (!(this instanceof $8be04678a11e1e44$var$BigInteger)) return new $8be04678a11e1e44$var$BigInteger(a, b, c);
    if (a != null) {
        if ("number" == typeof a) this.fromNumber(a, b, c);
        else if (b == null && "string" != typeof a) this.fromString(a, 256);
        else this.fromString(a, b);
    }
}
var $8be04678a11e1e44$var$proto = $8be04678a11e1e44$var$BigInteger.prototype;

// duck-typed isBigInteger
$8be04678a11e1e44$var$proto.__bigi = (parcelRequire("c1OqS")).version;
$8be04678a11e1e44$var$BigInteger.isBigInteger = function(obj, check_ver) {
    return obj && obj.__bigi && (!check_ver || obj.__bigi === $8be04678a11e1e44$var$proto.__bigi);
};
// Bits per digit
var $8be04678a11e1e44$var$dbits;
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function $8be04678a11e1e44$var$am1(i, x, w, j, c, n) {
    while(--n >= 0){
        var v = x * this[i++] + w[j] + c;
        c = Math.floor(v / 0x4000000);
        w[j++] = v & 0x3ffffff;
    }
    return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function $8be04678a11e1e44$var$am2(i, x, w, j, c, n) {
    var xl = x & 0x7fff, xh = x >> 15;
    while(--n >= 0){
        var l = this[i] & 0x7fff;
        var h = this[i++] >> 15;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
        c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
        w[j++] = l & 0x3fffffff;
    }
    return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function $8be04678a11e1e44$var$am3(i, x, w, j, c, n) {
    var xl = x & 0x3fff, xh = x >> 14;
    while(--n >= 0){
        var l = this[i] & 0x3fff;
        var h = this[i++] >> 14;
        var m = xh * l + h * xl;
        l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
        c = (l >> 28) + (m >> 14) + xh * h;
        w[j++] = l & 0xfffffff;
    }
    return c;
}
// wtf?
$8be04678a11e1e44$var$BigInteger.prototype.am = $8be04678a11e1e44$var$am1;
$8be04678a11e1e44$var$dbits = 26;
$8be04678a11e1e44$var$BigInteger.prototype.DB = $8be04678a11e1e44$var$dbits;
$8be04678a11e1e44$var$BigInteger.prototype.DM = (1 << $8be04678a11e1e44$var$dbits) - 1;
var $8be04678a11e1e44$var$DV = $8be04678a11e1e44$var$BigInteger.prototype.DV = 1 << $8be04678a11e1e44$var$dbits;
var $8be04678a11e1e44$var$BI_FP = 52;
$8be04678a11e1e44$var$BigInteger.prototype.FV = Math.pow(2, $8be04678a11e1e44$var$BI_FP);
$8be04678a11e1e44$var$BigInteger.prototype.F1 = $8be04678a11e1e44$var$BI_FP - $8be04678a11e1e44$var$dbits;
$8be04678a11e1e44$var$BigInteger.prototype.F2 = 2 * $8be04678a11e1e44$var$dbits - $8be04678a11e1e44$var$BI_FP;
// Digit conversions
var $8be04678a11e1e44$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var $8be04678a11e1e44$var$BI_RC = new Array();
var $8be04678a11e1e44$var$rr, $8be04678a11e1e44$var$vv;
$8be04678a11e1e44$var$rr = "0".charCodeAt(0);
for($8be04678a11e1e44$var$vv = 0; $8be04678a11e1e44$var$vv <= 9; ++$8be04678a11e1e44$var$vv)$8be04678a11e1e44$var$BI_RC[$8be04678a11e1e44$var$rr++] = $8be04678a11e1e44$var$vv;
$8be04678a11e1e44$var$rr = "a".charCodeAt(0);
for($8be04678a11e1e44$var$vv = 10; $8be04678a11e1e44$var$vv < 36; ++$8be04678a11e1e44$var$vv)$8be04678a11e1e44$var$BI_RC[$8be04678a11e1e44$var$rr++] = $8be04678a11e1e44$var$vv;
$8be04678a11e1e44$var$rr = "A".charCodeAt(0);
for($8be04678a11e1e44$var$vv = 10; $8be04678a11e1e44$var$vv < 36; ++$8be04678a11e1e44$var$vv)$8be04678a11e1e44$var$BI_RC[$8be04678a11e1e44$var$rr++] = $8be04678a11e1e44$var$vv;
function $8be04678a11e1e44$var$int2char(n) {
    return $8be04678a11e1e44$var$BI_RM.charAt(n);
}
function $8be04678a11e1e44$var$intAt(s, i) {
    var c = $8be04678a11e1e44$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
// (protected) copy this to r
function $8be04678a11e1e44$var$bnpCopyTo(r) {
    for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
    r.t = this.t;
    r.s = this.s;
}
// (protected) set from integer value x, -DV <= x < DV
function $8be04678a11e1e44$var$bnpFromInt(x) {
    this.t = 1;
    this.s = x < 0 ? -1 : 0;
    if (x > 0) this[0] = x;
    else if (x < -1) this[0] = x + $8be04678a11e1e44$var$DV;
    else this.t = 0;
}
// return bigint initialized to value
function $8be04678a11e1e44$var$nbv(i) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    r.fromInt(i);
    return r;
}
// (protected) set from string and radix
function $8be04678a11e1e44$var$bnpFromString(s, b) {
    var self = this;
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 256) k = 8; // byte array
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else {
        self.fromRadix(s, b);
        return;
    }
    self.t = 0;
    self.s = 0;
    var i = s.length, mi = false, sh = 0;
    while(--i >= 0){
        var x = k == 8 ? s[i] & 0xff : $8be04678a11e1e44$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-") mi = true;
            continue;
        }
        mi = false;
        if (sh == 0) self[self.t++] = x;
        else if (sh + k > self.DB) {
            self[self.t - 1] |= (x & (1 << self.DB - sh) - 1) << sh;
            self[self.t++] = x >> self.DB - sh;
        } else self[self.t - 1] |= x << sh;
        sh += k;
        if (sh >= self.DB) sh -= self.DB;
    }
    if (k == 8 && (s[0] & 0x80) != 0) {
        self.s = -1;
        if (sh > 0) self[self.t - 1] |= (1 << self.DB - sh) - 1 << sh;
    }
    self.clamp();
    if (mi) $8be04678a11e1e44$var$BigInteger.ZERO.subTo(self, self);
}
// (protected) clamp off excess high words
function $8be04678a11e1e44$var$bnpClamp() {
    var c = this.s & this.DM;
    while(this.t > 0 && this[this.t - 1] == c)--this.t;
}
// (public) return string representation in given radix
function $8be04678a11e1e44$var$bnToString(b) {
    var self = this;
    if (self.s < 0) return "-" + self.negate().toString(b);
    var k;
    if (b == 16) k = 4;
    else if (b == 8) k = 3;
    else if (b == 2) k = 1;
    else if (b == 32) k = 5;
    else if (b == 4) k = 2;
    else return self.toRadix(b);
    var km = (1 << k) - 1, d, m = false, r = "", i = self.t;
    var p = self.DB - i * self.DB % k;
    if (i-- > 0) {
        if (p < self.DB && (d = self[i] >> p) > 0) {
            m = true;
            r = $8be04678a11e1e44$var$int2char(d);
        }
        while(i >= 0){
            if (p < k) {
                d = (self[i] & (1 << p) - 1) << k - p;
                d |= self[--i] >> (p += self.DB - k);
            } else {
                d = self[i] >> (p -= k) & km;
                if (p <= 0) {
                    p += self.DB;
                    --i;
                }
            }
            if (d > 0) m = true;
            if (m) r += $8be04678a11e1e44$var$int2char(d);
        }
    }
    return m ? r : "0";
}
// (public) -this
function $8be04678a11e1e44$var$bnNegate() {
    var r = new $8be04678a11e1e44$var$BigInteger();
    $8be04678a11e1e44$var$BigInteger.ZERO.subTo(this, r);
    return r;
}
// (public) |this|
function $8be04678a11e1e44$var$bnAbs() {
    return this.s < 0 ? this.negate() : this;
}
// (public) return + if this > a, - if this < a, 0 if equal
function $8be04678a11e1e44$var$bnCompareTo(a) {
    var r = this.s - a.s;
    if (r != 0) return r;
    var i = this.t;
    r = i - a.t;
    if (r != 0) return this.s < 0 ? -r : r;
    while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
    return 0;
}
// returns bit length of the integer x
function $8be04678a11e1e44$var$nbits(x) {
    var r = 1, t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// (public) return the number of bits in "this"
function $8be04678a11e1e44$var$bnBitLength() {
    if (this.t <= 0) return 0;
    return this.DB * (this.t - 1) + $8be04678a11e1e44$var$nbits(this[this.t - 1] ^ this.s & this.DM);
}
// (public) return the number of bytes in "this"
function $8be04678a11e1e44$var$bnByteLength() {
    return this.bitLength() >> 3;
}
// (protected) r = this << n*DB
function $8be04678a11e1e44$var$bnpDLShiftTo(n, r) {
    var i;
    for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
    for(i = n - 1; i >= 0; --i)r[i] = 0;
    r.t = this.t + n;
    r.s = this.s;
}
// (protected) r = this >> n*DB
function $8be04678a11e1e44$var$bnpDRShiftTo(n, r) {
    for(var i = n; i < this.t; ++i)r[i - n] = this[i];
    r.t = Math.max(this.t - n, 0);
    r.s = this.s;
}
// (protected) r = this << n
function $8be04678a11e1e44$var$bnpLShiftTo(n, r) {
    var self = this;
    var bs = n % self.DB;
    var cbs = self.DB - bs;
    var bm = (1 << cbs) - 1;
    var ds = Math.floor(n / self.DB), c = self.s << bs & self.DM, i;
    for(i = self.t - 1; i >= 0; --i){
        r[i + ds + 1] = self[i] >> cbs | c;
        c = (self[i] & bm) << bs;
    }
    for(i = ds - 1; i >= 0; --i)r[i] = 0;
    r[ds] = c;
    r.t = self.t + ds + 1;
    r.s = self.s;
    r.clamp();
}
// (protected) r = this >> n
function $8be04678a11e1e44$var$bnpRShiftTo(n, r) {
    var self = this;
    r.s = self.s;
    var ds = Math.floor(n / self.DB);
    if (ds >= self.t) {
        r.t = 0;
        return;
    }
    var bs = n % self.DB;
    var cbs = self.DB - bs;
    var bm = (1 << bs) - 1;
    r[0] = self[ds] >> bs;
    for(var i = ds + 1; i < self.t; ++i){
        r[i - ds - 1] |= (self[i] & bm) << cbs;
        r[i - ds] = self[i] >> bs;
    }
    if (bs > 0) r[self.t - ds - 1] |= (self.s & bm) << cbs;
    r.t = self.t - ds;
    r.clamp();
}
// (protected) r = this - a
function $8be04678a11e1e44$var$bnpSubTo(a, r) {
    var self = this;
    var i = 0, c = 0, m = Math.min(a.t, self.t);
    while(i < m){
        c += self[i] - a[i];
        r[i++] = c & self.DM;
        c >>= self.DB;
    }
    if (a.t < self.t) {
        c -= a.s;
        while(i < self.t){
            c += self[i];
            r[i++] = c & self.DM;
            c >>= self.DB;
        }
        c += self.s;
    } else {
        c += self.s;
        while(i < a.t){
            c -= a[i];
            r[i++] = c & self.DM;
            c >>= self.DB;
        }
        c -= a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c < -1) r[i++] = self.DV + c;
    else if (c > 0) r[i++] = c;
    r.t = i;
    r.clamp();
}
// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function $8be04678a11e1e44$var$bnpMultiplyTo(a, r) {
    var x = this.abs(), y = a.abs();
    var i = x.t;
    r.t = i + y.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
    r.s = 0;
    r.clamp();
    if (this.s != a.s) $8be04678a11e1e44$var$BigInteger.ZERO.subTo(r, r);
}
// (protected) r = this^2, r != this (HAC 14.16)
function $8be04678a11e1e44$var$bnpSquareTo(r) {
    var x = this.abs();
    var i = r.t = 2 * x.t;
    while(--i >= 0)r[i] = 0;
    for(i = 0; i < x.t - 1; ++i){
        var c = x.am(i, x[i], r, 2 * i, 0, 1);
        if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
            r[i + x.t] -= x.DV;
            r[i + x.t + 1] = 1;
        }
    }
    if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
    r.s = 0;
    r.clamp();
}
// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function $8be04678a11e1e44$var$bnpDivRemTo(m, q, r) {
    var self = this;
    var pm = m.abs();
    if (pm.t <= 0) return;
    var pt = self.abs();
    if (pt.t < pm.t) {
        if (q != null) q.fromInt(0);
        if (r != null) self.copyTo(r);
        return;
    }
    if (r == null) r = new $8be04678a11e1e44$var$BigInteger();
    var y = new $8be04678a11e1e44$var$BigInteger(), ts = self.s, ms = m.s;
    var nsh = self.DB - $8be04678a11e1e44$var$nbits(pm[pm.t - 1]); // normalize modulus
    if (nsh > 0) {
        pm.lShiftTo(nsh, y);
        pt.lShiftTo(nsh, r);
    } else {
        pm.copyTo(y);
        pt.copyTo(r);
    }
    var ys = y.t;
    var y0 = y[ys - 1];
    if (y0 == 0) return;
    var yt = y0 * (1 << self.F1) + (ys > 1 ? y[ys - 2] >> self.F2 : 0);
    var d1 = self.FV / yt, d2 = (1 << self.F1) / yt, e = 1 << self.F2;
    var i = r.t, j = i - ys, t = q == null ? new $8be04678a11e1e44$var$BigInteger() : q;
    y.dlShiftTo(j, t);
    if (r.compareTo(t) >= 0) {
        r[r.t++] = 1;
        r.subTo(t, r);
    }
    $8be04678a11e1e44$var$BigInteger.ONE.dlShiftTo(ys, t);
    t.subTo(y, y); // "negative" y so we can replace sub with am later
    while(y.t < ys)y[y.t++] = 0;
    while(--j >= 0){
        // Estimate quotient digit
        var qd = r[--i] == y0 ? self.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
        if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
            y.dlShiftTo(j, t);
            r.subTo(t, r);
            while(r[i] < --qd)r.subTo(t, r);
        }
    }
    if (q != null) {
        r.drShiftTo(ys, q);
        if (ts != ms) $8be04678a11e1e44$var$BigInteger.ZERO.subTo(q, q);
    }
    r.t = ys;
    r.clamp();
    if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
    if (ts < 0) $8be04678a11e1e44$var$BigInteger.ZERO.subTo(r, r);
}
// (public) this mod a
function $8be04678a11e1e44$var$bnMod(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.abs().divRemTo(a, null, r);
    if (this.s < 0 && r.compareTo($8be04678a11e1e44$var$BigInteger.ZERO) > 0) a.subTo(r, r);
    return r;
}
// Modular reduction using "classic" algorithm
function $8be04678a11e1e44$var$Classic(m) {
    this.m = m;
}
function $8be04678a11e1e44$var$cConvert(x) {
    if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
    else return x;
}
function $8be04678a11e1e44$var$cRevert(x) {
    return x;
}
function $8be04678a11e1e44$var$cReduce(x) {
    x.divRemTo(this.m, null, x);
}
function $8be04678a11e1e44$var$cMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
function $8be04678a11e1e44$var$cSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
$8be04678a11e1e44$var$Classic.prototype.convert = $8be04678a11e1e44$var$cConvert;
$8be04678a11e1e44$var$Classic.prototype.revert = $8be04678a11e1e44$var$cRevert;
$8be04678a11e1e44$var$Classic.prototype.reduce = $8be04678a11e1e44$var$cReduce;
$8be04678a11e1e44$var$Classic.prototype.mulTo = $8be04678a11e1e44$var$cMulTo;
$8be04678a11e1e44$var$Classic.prototype.sqrTo = $8be04678a11e1e44$var$cSqrTo;
// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function $8be04678a11e1e44$var$bnpInvDigit() {
    if (this.t < 1) return 0;
    var x = this[0];
    if ((x & 1) == 0) return 0;
    var y = x & 3; // y == 1/x mod 2^2
    y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
    y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
    y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
    // last step - calculate inverse mod DV directly
    // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
    y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
    // we really want the negative inverse, and -DV < y < DV
    return y > 0 ? this.DV - y : -y;
}
// Montgomery reduction
function $8be04678a11e1e44$var$Montgomery(m) {
    this.m = m;
    this.mp = m.invDigit();
    this.mpl = this.mp & 0x7fff;
    this.mph = this.mp >> 15;
    this.um = (1 << m.DB - 15) - 1;
    this.mt2 = 2 * m.t;
}
// xR mod m
function $8be04678a11e1e44$var$montConvert(x) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    x.abs().dlShiftTo(this.m.t, r);
    r.divRemTo(this.m, null, r);
    if (x.s < 0 && r.compareTo($8be04678a11e1e44$var$BigInteger.ZERO) > 0) this.m.subTo(r, r);
    return r;
}
// x/R mod m
function $8be04678a11e1e44$var$montRevert(x) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    x.copyTo(r);
    this.reduce(r);
    return r;
}
// x = x/R mod m (HAC 14.32)
function $8be04678a11e1e44$var$montReduce(x) {
    while(x.t <= this.mt2)x[x.t++] = 0;
    for(var i = 0; i < this.m.t; ++i){
        // faster way of calculating u0 = x[i]*mp mod DV
        var j = x[i] & 0x7fff;
        var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
        // use am to combine the multiply-shift-add into one call
        j = i + this.m.t;
        x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
        // propagate carry
        while(x[j] >= x.DV){
            x[j] -= x.DV;
            x[++j]++;
        }
    }
    x.clamp();
    x.drShiftTo(this.m.t, x);
    if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
}
// r = "x^2/R mod m"; x != r
function $8be04678a11e1e44$var$montSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = "xy/R mod m"; x,y != r
function $8be04678a11e1e44$var$montMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$8be04678a11e1e44$var$Montgomery.prototype.convert = $8be04678a11e1e44$var$montConvert;
$8be04678a11e1e44$var$Montgomery.prototype.revert = $8be04678a11e1e44$var$montRevert;
$8be04678a11e1e44$var$Montgomery.prototype.reduce = $8be04678a11e1e44$var$montReduce;
$8be04678a11e1e44$var$Montgomery.prototype.mulTo = $8be04678a11e1e44$var$montMulTo;
$8be04678a11e1e44$var$Montgomery.prototype.sqrTo = $8be04678a11e1e44$var$montSqrTo;
// (protected) true iff this is even
function $8be04678a11e1e44$var$bnpIsEven() {
    return (this.t > 0 ? this[0] & 1 : this.s) == 0;
}
// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function $8be04678a11e1e44$var$bnpExp(e, z) {
    if (e > 0xffffffff || e < 1) return $8be04678a11e1e44$var$BigInteger.ONE;
    var r = new $8be04678a11e1e44$var$BigInteger(), r2 = new $8be04678a11e1e44$var$BigInteger(), g = z.convert(this), i = $8be04678a11e1e44$var$nbits(e) - 1;
    g.copyTo(r);
    while(--i >= 0){
        z.sqrTo(r, r2);
        if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
        else {
            var t = r;
            r = r2;
            r2 = t;
        }
    }
    return z.revert(r);
}
// (public) this^e % m, 0 <= e < 2^32
function $8be04678a11e1e44$var$bnModPowInt(e, m) {
    var z;
    if (e < 256 || m.isEven()) z = new $8be04678a11e1e44$var$Classic(m);
    else z = new $8be04678a11e1e44$var$Montgomery(m);
    return this.exp(e, z);
}
// protected
$8be04678a11e1e44$var$proto.copyTo = $8be04678a11e1e44$var$bnpCopyTo;
$8be04678a11e1e44$var$proto.fromInt = $8be04678a11e1e44$var$bnpFromInt;
$8be04678a11e1e44$var$proto.fromString = $8be04678a11e1e44$var$bnpFromString;
$8be04678a11e1e44$var$proto.clamp = $8be04678a11e1e44$var$bnpClamp;
$8be04678a11e1e44$var$proto.dlShiftTo = $8be04678a11e1e44$var$bnpDLShiftTo;
$8be04678a11e1e44$var$proto.drShiftTo = $8be04678a11e1e44$var$bnpDRShiftTo;
$8be04678a11e1e44$var$proto.lShiftTo = $8be04678a11e1e44$var$bnpLShiftTo;
$8be04678a11e1e44$var$proto.rShiftTo = $8be04678a11e1e44$var$bnpRShiftTo;
$8be04678a11e1e44$var$proto.subTo = $8be04678a11e1e44$var$bnpSubTo;
$8be04678a11e1e44$var$proto.multiplyTo = $8be04678a11e1e44$var$bnpMultiplyTo;
$8be04678a11e1e44$var$proto.squareTo = $8be04678a11e1e44$var$bnpSquareTo;
$8be04678a11e1e44$var$proto.divRemTo = $8be04678a11e1e44$var$bnpDivRemTo;
$8be04678a11e1e44$var$proto.invDigit = $8be04678a11e1e44$var$bnpInvDigit;
$8be04678a11e1e44$var$proto.isEven = $8be04678a11e1e44$var$bnpIsEven;
$8be04678a11e1e44$var$proto.exp = $8be04678a11e1e44$var$bnpExp;
// public
$8be04678a11e1e44$var$proto.toString = $8be04678a11e1e44$var$bnToString;
$8be04678a11e1e44$var$proto.negate = $8be04678a11e1e44$var$bnNegate;
$8be04678a11e1e44$var$proto.abs = $8be04678a11e1e44$var$bnAbs;
$8be04678a11e1e44$var$proto.compareTo = $8be04678a11e1e44$var$bnCompareTo;
$8be04678a11e1e44$var$proto.bitLength = $8be04678a11e1e44$var$bnBitLength;
$8be04678a11e1e44$var$proto.byteLength = $8be04678a11e1e44$var$bnByteLength;
$8be04678a11e1e44$var$proto.mod = $8be04678a11e1e44$var$bnMod;
$8be04678a11e1e44$var$proto.modPowInt = $8be04678a11e1e44$var$bnModPowInt;
// (public)
function $8be04678a11e1e44$var$bnClone() {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.copyTo(r);
    return r;
}
// (public) return value as integer
function $8be04678a11e1e44$var$bnIntValue() {
    if (this.s < 0) {
        if (this.t == 1) return this[0] - this.DV;
        else if (this.t == 0) return -1;
    } else if (this.t == 1) return this[0];
    else if (this.t == 0) return 0;
    // assumes 16 < DB < 32
    return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
}
// (public) return value as byte
function $8be04678a11e1e44$var$bnByteValue() {
    return this.t == 0 ? this.s : this[0] << 24 >> 24;
}
// (public) return value as short (assumes DB>=16)
function $8be04678a11e1e44$var$bnShortValue() {
    return this.t == 0 ? this.s : this[0] << 16 >> 16;
}
// (protected) return x s.t. r^x < DV
function $8be04678a11e1e44$var$bnpChunkSize(r) {
    return Math.floor(Math.LN2 * this.DB / Math.log(r));
}
// (public) 0 if this == 0, 1 if this > 0
function $8be04678a11e1e44$var$bnSigNum() {
    if (this.s < 0) return -1;
    else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
    else return 1;
}
// (protected) convert to radix string
function $8be04678a11e1e44$var$bnpToRadix(b) {
    if (b == null) b = 10;
    if (this.signum() == 0 || b < 2 || b > 36) return "0";
    var cs = this.chunkSize(b);
    var a = Math.pow(b, cs);
    var d = $8be04678a11e1e44$var$nbv(a), y = new $8be04678a11e1e44$var$BigInteger(), z = new $8be04678a11e1e44$var$BigInteger(), r = "";
    this.divRemTo(d, y, z);
    while(y.signum() > 0){
        r = (a + z.intValue()).toString(b).substr(1) + r;
        y.divRemTo(d, y, z);
    }
    return z.intValue().toString(b) + r;
}
// (protected) convert from radix string
function $8be04678a11e1e44$var$bnpFromRadix(s, b) {
    var self = this;
    self.fromInt(0);
    if (b == null) b = 10;
    var cs = self.chunkSize(b);
    var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
    for(var i = 0; i < s.length; ++i){
        var x = $8be04678a11e1e44$var$intAt(s, i);
        if (x < 0) {
            if (s.charAt(i) == "-" && self.signum() == 0) mi = true;
            continue;
        }
        w = b * w + x;
        if (++j >= cs) {
            self.dMultiply(d);
            self.dAddOffset(w, 0);
            j = 0;
            w = 0;
        }
    }
    if (j > 0) {
        self.dMultiply(Math.pow(b, j));
        self.dAddOffset(w, 0);
    }
    if (mi) $8be04678a11e1e44$var$BigInteger.ZERO.subTo(self, self);
}
// (protected) alternate constructor
function $8be04678a11e1e44$var$bnpFromNumber(a, b, c) {
    var self = this;
    if ("number" == typeof b) {
        // new BigInteger(int,int,RNG)
        if (a < 2) self.fromInt(1);
        else {
            self.fromNumber(a, c);
            if (!self.testBit(a - 1)) self.bitwiseTo($8be04678a11e1e44$var$BigInteger.ONE.shiftLeft(a - 1), $8be04678a11e1e44$var$op_or, self);
            if (self.isEven()) self.dAddOffset(1, 0); // force odd
            while(!self.isProbablePrime(b)){
                self.dAddOffset(2, 0);
                if (self.bitLength() > a) self.subTo($8be04678a11e1e44$var$BigInteger.ONE.shiftLeft(a - 1), self);
            }
        }
    } else {
        // new BigInteger(int,RNG)
        var x = new Array(), t = a & 7;
        x.length = (a >> 3) + 1;
        b.nextBytes(x);
        if (t > 0) x[0] &= (1 << t) - 1;
        else x[0] = 0;
        self.fromString(x, 256);
    }
}
// (public) convert to bigendian byte array
function $8be04678a11e1e44$var$bnToByteArray() {
    var self = this;
    var i = self.t, r = new Array();
    r[0] = self.s;
    var p = self.DB - i * self.DB % 8, d, k = 0;
    if (i-- > 0) {
        if (p < self.DB && (d = self[i] >> p) != (self.s & self.DM) >> p) r[k++] = d | self.s << self.DB - p;
        while(i >= 0){
            if (p < 8) {
                d = (self[i] & (1 << p) - 1) << 8 - p;
                d |= self[--i] >> (p += self.DB - 8);
            } else {
                d = self[i] >> (p -= 8) & 0xff;
                if (p <= 0) {
                    p += self.DB;
                    --i;
                }
            }
            if ((d & 0x80) != 0) d |= -256;
            if (k === 0 && (self.s & 0x80) != (d & 0x80)) ++k;
            if (k > 0 || d != self.s) r[k++] = d;
        }
    }
    return r;
}
function $8be04678a11e1e44$var$bnEquals(a) {
    return this.compareTo(a) == 0;
}
function $8be04678a11e1e44$var$bnMin(a) {
    return this.compareTo(a) < 0 ? this : a;
}
function $8be04678a11e1e44$var$bnMax(a) {
    return this.compareTo(a) > 0 ? this : a;
}
// (protected) r = this op a (bitwise)
function $8be04678a11e1e44$var$bnpBitwiseTo(a, op, r) {
    var self = this;
    var i, f, m = Math.min(a.t, self.t);
    for(i = 0; i < m; ++i)r[i] = op(self[i], a[i]);
    if (a.t < self.t) {
        f = a.s & self.DM;
        for(i = m; i < self.t; ++i)r[i] = op(self[i], f);
        r.t = self.t;
    } else {
        f = self.s & self.DM;
        for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
        r.t = a.t;
    }
    r.s = op(self.s, a.s);
    r.clamp();
}
// (public) this & a
function $8be04678a11e1e44$var$op_and(x, y) {
    return x & y;
}
function $8be04678a11e1e44$var$bnAnd(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.bitwiseTo(a, $8be04678a11e1e44$var$op_and, r);
    return r;
}
// (public) this | a
function $8be04678a11e1e44$var$op_or(x, y) {
    return x | y;
}
function $8be04678a11e1e44$var$bnOr(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.bitwiseTo(a, $8be04678a11e1e44$var$op_or, r);
    return r;
}
// (public) this ^ a
function $8be04678a11e1e44$var$op_xor(x, y) {
    return x ^ y;
}
function $8be04678a11e1e44$var$bnXor(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.bitwiseTo(a, $8be04678a11e1e44$var$op_xor, r);
    return r;
}
// (public) this & ~a
function $8be04678a11e1e44$var$op_andnot(x, y) {
    return x & ~y;
}
function $8be04678a11e1e44$var$bnAndNot(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.bitwiseTo(a, $8be04678a11e1e44$var$op_andnot, r);
    return r;
}
// (public) ~this
function $8be04678a11e1e44$var$bnNot() {
    var r = new $8be04678a11e1e44$var$BigInteger();
    for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
    r.t = this.t;
    r.s = ~this.s;
    return r;
}
// (public) this << n
function $8be04678a11e1e44$var$bnShiftLeft(n) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    if (n < 0) this.rShiftTo(-n, r);
    else this.lShiftTo(n, r);
    return r;
}
// (public) this >> n
function $8be04678a11e1e44$var$bnShiftRight(n) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    if (n < 0) this.lShiftTo(-n, r);
    else this.rShiftTo(n, r);
    return r;
}
// return index of lowest 1-bit in x, x < 2^31
function $8be04678a11e1e44$var$lbit(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
// (public) returns index of lowest 1-bit (or -1 if none)
function $8be04678a11e1e44$var$bnGetLowestSetBit() {
    for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + $8be04678a11e1e44$var$lbit(this[i]);
    if (this.s < 0) return this.t * this.DB;
    return -1;
}
// return number of 1 bits in x
function $8be04678a11e1e44$var$cbit(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
}
// (public) return number of set bits
function $8be04678a11e1e44$var$bnBitCount() {
    var r = 0, x = this.s & this.DM;
    for(var i = 0; i < this.t; ++i)r += $8be04678a11e1e44$var$cbit(this[i] ^ x);
    return r;
}
// (public) true iff nth bit is set
function $8be04678a11e1e44$var$bnTestBit(n) {
    var j = Math.floor(n / this.DB);
    if (j >= this.t) return this.s != 0;
    return (this[j] & 1 << n % this.DB) != 0;
}
// (protected) this op (1<<n)
function $8be04678a11e1e44$var$bnpChangeBit(n, op) {
    var r = $8be04678a11e1e44$var$BigInteger.ONE.shiftLeft(n);
    this.bitwiseTo(r, op, r);
    return r;
}
// (public) this | (1<<n)
function $8be04678a11e1e44$var$bnSetBit(n) {
    return this.changeBit(n, $8be04678a11e1e44$var$op_or);
}
// (public) this & ~(1<<n)
function $8be04678a11e1e44$var$bnClearBit(n) {
    return this.changeBit(n, $8be04678a11e1e44$var$op_andnot);
}
// (public) this ^ (1<<n)
function $8be04678a11e1e44$var$bnFlipBit(n) {
    return this.changeBit(n, $8be04678a11e1e44$var$op_xor);
}
// (protected) r = this + a
function $8be04678a11e1e44$var$bnpAddTo(a, r) {
    var self = this;
    var i = 0, c = 0, m = Math.min(a.t, self.t);
    while(i < m){
        c += self[i] + a[i];
        r[i++] = c & self.DM;
        c >>= self.DB;
    }
    if (a.t < self.t) {
        c += a.s;
        while(i < self.t){
            c += self[i];
            r[i++] = c & self.DM;
            c >>= self.DB;
        }
        c += self.s;
    } else {
        c += self.s;
        while(i < a.t){
            c += a[i];
            r[i++] = c & self.DM;
            c >>= self.DB;
        }
        c += a.s;
    }
    r.s = c < 0 ? -1 : 0;
    if (c > 0) r[i++] = c;
    else if (c < -1) r[i++] = self.DV + c;
    r.t = i;
    r.clamp();
}
// (public) this + a
function $8be04678a11e1e44$var$bnAdd(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.addTo(a, r);
    return r;
}
// (public) this - a
function $8be04678a11e1e44$var$bnSubtract(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.subTo(a, r);
    return r;
}
// (public) this * a
function $8be04678a11e1e44$var$bnMultiply(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.multiplyTo(a, r);
    return r;
}
// (public) this^2
function $8be04678a11e1e44$var$bnSquare() {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.squareTo(r);
    return r;
}
// (public) this / a
function $8be04678a11e1e44$var$bnDivide(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.divRemTo(a, r, null);
    return r;
}
// (public) this % a
function $8be04678a11e1e44$var$bnRemainder(a) {
    var r = new $8be04678a11e1e44$var$BigInteger();
    this.divRemTo(a, null, r);
    return r;
}
// (public) [this/a,this%a]
function $8be04678a11e1e44$var$bnDivideAndRemainder(a) {
    var q = new $8be04678a11e1e44$var$BigInteger(), r = new $8be04678a11e1e44$var$BigInteger();
    this.divRemTo(a, q, r);
    return new Array(q, r);
}
// (protected) this *= n, this >= 0, 1 < n < DV
function $8be04678a11e1e44$var$bnpDMultiply(n) {
    this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
    ++this.t;
    this.clamp();
}
// (protected) this += n << w words, this >= 0
function $8be04678a11e1e44$var$bnpDAddOffset(n, w) {
    if (n == 0) return;
    while(this.t <= w)this[this.t++] = 0;
    this[w] += n;
    while(this[w] >= this.DV){
        this[w] -= this.DV;
        if (++w >= this.t) this[this.t++] = 0;
        ++this[w];
    }
}
// A "null" reducer
function $8be04678a11e1e44$var$NullExp() {}
function $8be04678a11e1e44$var$nNop(x) {
    return x;
}
function $8be04678a11e1e44$var$nMulTo(x, y, r) {
    x.multiplyTo(y, r);
}
function $8be04678a11e1e44$var$nSqrTo(x, r) {
    x.squareTo(r);
}
$8be04678a11e1e44$var$NullExp.prototype.convert = $8be04678a11e1e44$var$nNop;
$8be04678a11e1e44$var$NullExp.prototype.revert = $8be04678a11e1e44$var$nNop;
$8be04678a11e1e44$var$NullExp.prototype.mulTo = $8be04678a11e1e44$var$nMulTo;
$8be04678a11e1e44$var$NullExp.prototype.sqrTo = $8be04678a11e1e44$var$nSqrTo;
// (public) this^e
function $8be04678a11e1e44$var$bnPow(e) {
    return this.exp(e, new $8be04678a11e1e44$var$NullExp());
}
// (protected) r = lower n words of "this * a", a.t <= n
// "this" should be the larger one if appropriate.
function $8be04678a11e1e44$var$bnpMultiplyLowerTo(a, n, r) {
    var i = Math.min(this.t + a.t, n);
    r.s = 0; // assumes a,this >= 0
    r.t = i;
    while(i > 0)r[--i] = 0;
    var j;
    for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
    for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
    r.clamp();
}
// (protected) r = "this * a" without lower n words, n > 0
// "this" should be the larger one if appropriate.
function $8be04678a11e1e44$var$bnpMultiplyUpperTo(a, n, r) {
    --n;
    var i = r.t = this.t + a.t - n;
    r.s = 0; // assumes a,this >= 0
    while(--i >= 0)r[i] = 0;
    for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
    r.clamp();
    r.drShiftTo(1, r);
}
// Barrett modular reduction
function $8be04678a11e1e44$var$Barrett(m) {
    // setup Barrett
    this.r2 = new $8be04678a11e1e44$var$BigInteger();
    this.q3 = new $8be04678a11e1e44$var$BigInteger();
    $8be04678a11e1e44$var$BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
    this.mu = this.r2.divide(m);
    this.m = m;
}
function $8be04678a11e1e44$var$barrettConvert(x) {
    if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
    else if (x.compareTo(this.m) < 0) return x;
    else {
        var r = new $8be04678a11e1e44$var$BigInteger();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
}
function $8be04678a11e1e44$var$barrettRevert(x) {
    return x;
}
// x = x mod m (HAC 14.42)
function $8be04678a11e1e44$var$barrettReduce(x) {
    var self = this;
    x.drShiftTo(self.m.t - 1, self.r2);
    if (x.t > self.m.t + 1) {
        x.t = self.m.t + 1;
        x.clamp();
    }
    self.mu.multiplyUpperTo(self.r2, self.m.t + 1, self.q3);
    self.m.multiplyLowerTo(self.q3, self.m.t + 1, self.r2);
    while(x.compareTo(self.r2) < 0)x.dAddOffset(1, self.m.t + 1);
    x.subTo(self.r2, x);
    while(x.compareTo(self.m) >= 0)x.subTo(self.m, x);
}
// r = x^2 mod m; x != r
function $8be04678a11e1e44$var$barrettSqrTo(x, r) {
    x.squareTo(r);
    this.reduce(r);
}
// r = x*y mod m; x,y != r
function $8be04678a11e1e44$var$barrettMulTo(x, y, r) {
    x.multiplyTo(y, r);
    this.reduce(r);
}
$8be04678a11e1e44$var$Barrett.prototype.convert = $8be04678a11e1e44$var$barrettConvert;
$8be04678a11e1e44$var$Barrett.prototype.revert = $8be04678a11e1e44$var$barrettRevert;
$8be04678a11e1e44$var$Barrett.prototype.reduce = $8be04678a11e1e44$var$barrettReduce;
$8be04678a11e1e44$var$Barrett.prototype.mulTo = $8be04678a11e1e44$var$barrettMulTo;
$8be04678a11e1e44$var$Barrett.prototype.sqrTo = $8be04678a11e1e44$var$barrettSqrTo;
// (public) this^e % m (HAC 14.85)
function $8be04678a11e1e44$var$bnModPow(e, m) {
    var i = e.bitLength(), k, r = $8be04678a11e1e44$var$nbv(1), z;
    if (i <= 0) return r;
    else if (i < 18) k = 1;
    else if (i < 48) k = 3;
    else if (i < 144) k = 4;
    else if (i < 768) k = 5;
    else k = 6;
    if (i < 8) z = new $8be04678a11e1e44$var$Classic(m);
    else if (m.isEven()) z = new $8be04678a11e1e44$var$Barrett(m);
    else z = new $8be04678a11e1e44$var$Montgomery(m);
    // precomputation
    var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
    g[1] = z.convert(this);
    if (k > 1) {
        var g2 = new $8be04678a11e1e44$var$BigInteger();
        z.sqrTo(g[1], g2);
        while(n <= km){
            g[n] = new $8be04678a11e1e44$var$BigInteger();
            z.mulTo(g2, g[n - 2], g[n]);
            n += 2;
        }
    }
    var j = e.t - 1, w, is1 = true, r2 = new $8be04678a11e1e44$var$BigInteger(), t;
    i = $8be04678a11e1e44$var$nbits(e[j]) - 1;
    while(j >= 0){
        if (i >= k1) w = e[j] >> i - k1 & km;
        else {
            w = (e[j] & (1 << i + 1) - 1) << k1 - i;
            if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
        }
        n = k;
        while((w & 1) == 0){
            w >>= 1;
            --n;
        }
        if ((i -= n) < 0) {
            i += this.DB;
            --j;
        }
        if (is1) {
            g[w].copyTo(r);
            is1 = false;
        } else {
            while(n > 1){
                z.sqrTo(r, r2);
                z.sqrTo(r2, r);
                n -= 2;
            }
            if (n > 0) z.sqrTo(r, r2);
            else {
                t = r;
                r = r2;
                r2 = t;
            }
            z.mulTo(r2, g[w], r);
        }
        while(j >= 0 && (e[j] & 1 << i) == 0){
            z.sqrTo(r, r2);
            t = r;
            r = r2;
            r2 = t;
            if (--i < 0) {
                i = this.DB - 1;
                --j;
            }
        }
    }
    return z.revert(r);
}
// (public) gcd(this,a) (HAC 14.54)
function $8be04678a11e1e44$var$bnGCD(a) {
    var x = this.s < 0 ? this.negate() : this.clone();
    var y = a.s < 0 ? a.negate() : a.clone();
    if (x.compareTo(y) < 0) {
        var t = x;
        x = y;
        y = t;
    }
    var i = x.getLowestSetBit(), g = y.getLowestSetBit();
    if (g < 0) return x;
    if (i < g) g = i;
    if (g > 0) {
        x.rShiftTo(g, x);
        y.rShiftTo(g, y);
    }
    while(x.signum() > 0){
        if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
        if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
        if (x.compareTo(y) >= 0) {
            x.subTo(y, x);
            x.rShiftTo(1, x);
        } else {
            y.subTo(x, y);
            y.rShiftTo(1, y);
        }
    }
    if (g > 0) y.lShiftTo(g, y);
    return y;
}
// (protected) this % n, n < 2^26
function $8be04678a11e1e44$var$bnpModInt(n) {
    if (n <= 0) return 0;
    var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
    if (this.t > 0) {
        if (d == 0) r = this[0] % n;
        else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
    }
    return r;
}
// (public) 1/this % m (HAC 14.61)
function $8be04678a11e1e44$var$bnModInverse(m) {
    var ac = m.isEven();
    if (this.signum() === 0) throw new Error("division by zero");
    if (this.isEven() && ac || m.signum() == 0) return $8be04678a11e1e44$var$BigInteger.ZERO;
    var u = m.clone(), v = this.clone();
    var a = $8be04678a11e1e44$var$nbv(1), b = $8be04678a11e1e44$var$nbv(0), c = $8be04678a11e1e44$var$nbv(0), d = $8be04678a11e1e44$var$nbv(1);
    while(u.signum() != 0){
        while(u.isEven()){
            u.rShiftTo(1, u);
            if (ac) {
                if (!a.isEven() || !b.isEven()) {
                    a.addTo(this, a);
                    b.subTo(m, b);
                }
                a.rShiftTo(1, a);
            } else if (!b.isEven()) b.subTo(m, b);
            b.rShiftTo(1, b);
        }
        while(v.isEven()){
            v.rShiftTo(1, v);
            if (ac) {
                if (!c.isEven() || !d.isEven()) {
                    c.addTo(this, c);
                    d.subTo(m, d);
                }
                c.rShiftTo(1, c);
            } else if (!d.isEven()) d.subTo(m, d);
            d.rShiftTo(1, d);
        }
        if (u.compareTo(v) >= 0) {
            u.subTo(v, u);
            if (ac) a.subTo(c, a);
            b.subTo(d, b);
        } else {
            v.subTo(u, v);
            if (ac) c.subTo(a, c);
            d.subTo(b, d);
        }
    }
    if (v.compareTo($8be04678a11e1e44$var$BigInteger.ONE) != 0) return $8be04678a11e1e44$var$BigInteger.ZERO;
    while(d.compareTo(m) >= 0)d.subTo(m, d);
    while(d.signum() < 0)d.addTo(m, d);
    return d;
}
var $8be04678a11e1e44$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509,
    521,
    523,
    541,
    547,
    557,
    563,
    569,
    571,
    577,
    587,
    593,
    599,
    601,
    607,
    613,
    617,
    619,
    631,
    641,
    643,
    647,
    653,
    659,
    661,
    673,
    677,
    683,
    691,
    701,
    709,
    719,
    727,
    733,
    739,
    743,
    751,
    757,
    761,
    769,
    773,
    787,
    797,
    809,
    811,
    821,
    823,
    827,
    829,
    839,
    853,
    857,
    859,
    863,
    877,
    881,
    883,
    887,
    907,
    911,
    919,
    929,
    937,
    941,
    947,
    953,
    967,
    971,
    977,
    983,
    991,
    997
];
var $8be04678a11e1e44$var$lplim = 67108864 / $8be04678a11e1e44$var$lowprimes[$8be04678a11e1e44$var$lowprimes.length - 1];
// (public) test primality with certainty >= 1-.5^t
function $8be04678a11e1e44$var$bnIsProbablePrime(t) {
    var i, x = this.abs();
    if (x.t == 1 && x[0] <= $8be04678a11e1e44$var$lowprimes[$8be04678a11e1e44$var$lowprimes.length - 1]) {
        for(i = 0; i < $8be04678a11e1e44$var$lowprimes.length; ++i)if (x[0] == $8be04678a11e1e44$var$lowprimes[i]) return true;
        return false;
    }
    if (x.isEven()) return false;
    i = 1;
    while(i < $8be04678a11e1e44$var$lowprimes.length){
        var m = $8be04678a11e1e44$var$lowprimes[i], j = i + 1;
        while(j < $8be04678a11e1e44$var$lowprimes.length && m < $8be04678a11e1e44$var$lplim)m *= $8be04678a11e1e44$var$lowprimes[j++];
        m = x.modInt(m);
        while(i < j)if (m % $8be04678a11e1e44$var$lowprimes[i++] == 0) return false;
    }
    return x.millerRabin(t);
}
// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
function $8be04678a11e1e44$var$bnpMillerRabin(t) {
    var n1 = this.subtract($8be04678a11e1e44$var$BigInteger.ONE);
    var k = n1.getLowestSetBit();
    if (k <= 0) return false;
    var r = n1.shiftRight(k);
    t = t + 1 >> 1;
    if (t > $8be04678a11e1e44$var$lowprimes.length) t = $8be04678a11e1e44$var$lowprimes.length;
    var a = new $8be04678a11e1e44$var$BigInteger(null);
    var j, bases = [];
    for(var i = 0; i < t; ++i){
        for(;;){
            j = $8be04678a11e1e44$var$lowprimes[Math.floor(Math.random() * $8be04678a11e1e44$var$lowprimes.length)];
            if (bases.indexOf(j) == -1) break;
        }
        bases.push(j);
        a.fromInt(j);
        var y = a.modPow(r, this);
        if (y.compareTo($8be04678a11e1e44$var$BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
            var j = 1;
            while(j++ < k && y.compareTo(n1) != 0){
                y = y.modPowInt(2, this);
                if (y.compareTo($8be04678a11e1e44$var$BigInteger.ONE) == 0) return false;
            }
            if (y.compareTo(n1) != 0) return false;
        }
    }
    return true;
}
// protected
$8be04678a11e1e44$var$proto.chunkSize = $8be04678a11e1e44$var$bnpChunkSize;
$8be04678a11e1e44$var$proto.toRadix = $8be04678a11e1e44$var$bnpToRadix;
$8be04678a11e1e44$var$proto.fromRadix = $8be04678a11e1e44$var$bnpFromRadix;
$8be04678a11e1e44$var$proto.fromNumber = $8be04678a11e1e44$var$bnpFromNumber;
$8be04678a11e1e44$var$proto.bitwiseTo = $8be04678a11e1e44$var$bnpBitwiseTo;
$8be04678a11e1e44$var$proto.changeBit = $8be04678a11e1e44$var$bnpChangeBit;
$8be04678a11e1e44$var$proto.addTo = $8be04678a11e1e44$var$bnpAddTo;
$8be04678a11e1e44$var$proto.dMultiply = $8be04678a11e1e44$var$bnpDMultiply;
$8be04678a11e1e44$var$proto.dAddOffset = $8be04678a11e1e44$var$bnpDAddOffset;
$8be04678a11e1e44$var$proto.multiplyLowerTo = $8be04678a11e1e44$var$bnpMultiplyLowerTo;
$8be04678a11e1e44$var$proto.multiplyUpperTo = $8be04678a11e1e44$var$bnpMultiplyUpperTo;
$8be04678a11e1e44$var$proto.modInt = $8be04678a11e1e44$var$bnpModInt;
$8be04678a11e1e44$var$proto.millerRabin = $8be04678a11e1e44$var$bnpMillerRabin;
// public
$8be04678a11e1e44$var$proto.clone = $8be04678a11e1e44$var$bnClone;
$8be04678a11e1e44$var$proto.intValue = $8be04678a11e1e44$var$bnIntValue;
$8be04678a11e1e44$var$proto.byteValue = $8be04678a11e1e44$var$bnByteValue;
$8be04678a11e1e44$var$proto.shortValue = $8be04678a11e1e44$var$bnShortValue;
$8be04678a11e1e44$var$proto.signum = $8be04678a11e1e44$var$bnSigNum;
$8be04678a11e1e44$var$proto.toByteArray = $8be04678a11e1e44$var$bnToByteArray;
$8be04678a11e1e44$var$proto.equals = $8be04678a11e1e44$var$bnEquals;
$8be04678a11e1e44$var$proto.min = $8be04678a11e1e44$var$bnMin;
$8be04678a11e1e44$var$proto.max = $8be04678a11e1e44$var$bnMax;
$8be04678a11e1e44$var$proto.and = $8be04678a11e1e44$var$bnAnd;
$8be04678a11e1e44$var$proto.or = $8be04678a11e1e44$var$bnOr;
$8be04678a11e1e44$var$proto.xor = $8be04678a11e1e44$var$bnXor;
$8be04678a11e1e44$var$proto.andNot = $8be04678a11e1e44$var$bnAndNot;
$8be04678a11e1e44$var$proto.not = $8be04678a11e1e44$var$bnNot;
$8be04678a11e1e44$var$proto.shiftLeft = $8be04678a11e1e44$var$bnShiftLeft;
$8be04678a11e1e44$var$proto.shiftRight = $8be04678a11e1e44$var$bnShiftRight;
$8be04678a11e1e44$var$proto.getLowestSetBit = $8be04678a11e1e44$var$bnGetLowestSetBit;
$8be04678a11e1e44$var$proto.bitCount = $8be04678a11e1e44$var$bnBitCount;
$8be04678a11e1e44$var$proto.testBit = $8be04678a11e1e44$var$bnTestBit;
$8be04678a11e1e44$var$proto.setBit = $8be04678a11e1e44$var$bnSetBit;
$8be04678a11e1e44$var$proto.clearBit = $8be04678a11e1e44$var$bnClearBit;
$8be04678a11e1e44$var$proto.flipBit = $8be04678a11e1e44$var$bnFlipBit;
$8be04678a11e1e44$var$proto.add = $8be04678a11e1e44$var$bnAdd;
$8be04678a11e1e44$var$proto.subtract = $8be04678a11e1e44$var$bnSubtract;
$8be04678a11e1e44$var$proto.multiply = $8be04678a11e1e44$var$bnMultiply;
$8be04678a11e1e44$var$proto.divide = $8be04678a11e1e44$var$bnDivide;
$8be04678a11e1e44$var$proto.remainder = $8be04678a11e1e44$var$bnRemainder;
$8be04678a11e1e44$var$proto.divideAndRemainder = $8be04678a11e1e44$var$bnDivideAndRemainder;
$8be04678a11e1e44$var$proto.modPow = $8be04678a11e1e44$var$bnModPow;
$8be04678a11e1e44$var$proto.modInverse = $8be04678a11e1e44$var$bnModInverse;
$8be04678a11e1e44$var$proto.pow = $8be04678a11e1e44$var$bnPow;
$8be04678a11e1e44$var$proto.gcd = $8be04678a11e1e44$var$bnGCD;
$8be04678a11e1e44$var$proto.isProbablePrime = $8be04678a11e1e44$var$bnIsProbablePrime;
// JSBN-specific extension
$8be04678a11e1e44$var$proto.square = $8be04678a11e1e44$var$bnSquare;
// constants
$8be04678a11e1e44$var$BigInteger.ZERO = $8be04678a11e1e44$var$nbv(0);
$8be04678a11e1e44$var$BigInteger.ONE = $8be04678a11e1e44$var$nbv(1);
$8be04678a11e1e44$var$BigInteger.valueOf = $8be04678a11e1e44$var$nbv;
module.exports = $8be04678a11e1e44$var$BigInteger;

});
parcelRegister("c1OqS", function(module, exports) {
module.exports = JSON.parse('{"name":"bigi","version":"1.4.2","description":"Big integers.","keywords":["cryptography","math","bitcoin","arbitrary","precision","arithmetic","big","integer","int","number","biginteger","bigint","bignumber","decimal","float"],"devDependencies":{"coveralls":"^2.11.2","istanbul":"^0.3.5","jshint":"^2.5.1","mocha":"^2.1.0","mochify":"^2.1.0"},"repository":{"url":"https://github.com/cryptocoinjs/bigi","type":"git"},"main":"./lib/index.js","scripts":{"browser-test":"./node_modules/.bin/mochify --wd -R spec","test":"./node_modules/.bin/_mocha -- test/*.js","jshint":"./node_modules/.bin/jshint --config jshint.json lib/*.js ; true","unit":"./node_modules/.bin/mocha","coverage":"./node_modules/.bin/istanbul cover ./node_modules/.bin/_mocha -- --reporter list test/*.js","coveralls":"npm run-script coverage && node ./node_modules/.bin/coveralls < coverage/lcov.info"},"dependencies":{},"testling":{"files":"test/*.js","harness":"mocha","browsers":["ie/9..latest","firefox/latest","chrome/latest","safari/6.0..latest","iphone/6.0..latest","android-browser/4.2..latest"]}}');

});


parcelRegister("4pBvL", function(module, exports) {
// FIXME: Kind of a weird way to throw exceptions, consider removing

var $ihoyg = parcelRequire("ihoyg");
var $3366982e9fdd1a3c$require$Buffer = $ihoyg.Buffer;

var $bhJ7Q = parcelRequire("bhJ7Q");

var $c0yxm = parcelRequire("c0yxm");
/**
 * Turns a byte array into a big integer.
 *
 * This function will interpret a byte array as a big integer in big
 * endian notation.
 */ $c0yxm.fromByteArrayUnsigned = function(byteArray) {
    // BigInteger expects a DER integer conformant byte array
    if (byteArray[0] & 0x80) return new $c0yxm([
        0
    ].concat(byteArray));
    return new $c0yxm(byteArray);
};
/**
 * Returns a byte array representation of the big integer.
 *
 * This returns the absolute of the contained value in big endian
 * form. A value of zero results in an empty array.
 */ $c0yxm.prototype.toByteArrayUnsigned = function() {
    var byteArray = this.toByteArray();
    return byteArray[0] === 0 ? byteArray.slice(1) : byteArray;
};
$c0yxm.fromDERInteger = function(byteArray) {
    return new $c0yxm(byteArray);
};
/*
 * Converts BigInteger to a DER integer representation.
 *
 * The format for this value uses the most significant bit as a sign
 * bit.  If the most significant bit is already set and the integer is
 * positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
*/ $c0yxm.prototype.toDERInteger = $c0yxm.prototype.toByteArray;
$c0yxm.fromBuffer = function(buffer) {
    // BigInteger expects a DER integer conformant byte array
    if (buffer[0] & 0x80) {
        var byteArray = Array.prototype.slice.call(buffer);
        return new $c0yxm([
            0
        ].concat(byteArray));
    }
    return new $c0yxm(buffer);
};
$c0yxm.fromHex = function(hex) {
    if (hex === "") return $c0yxm.ZERO;
    $bhJ7Q.equal(hex, hex.match(/^[A-Fa-f0-9]+/), "Invalid hex string");
    $bhJ7Q.equal(hex.length % 2, 0, "Incomplete hex");
    return new $c0yxm(hex, 16);
};
$c0yxm.prototype.toBuffer = function(size) {
    var byteArray = this.toByteArrayUnsigned();
    var zeros = [];
    var padding = size - byteArray.length;
    while(zeros.length < padding)zeros.push(0);
    return new $3366982e9fdd1a3c$require$Buffer(zeros.concat(byteArray));
};
$c0yxm.prototype.toHex = function(size) {
    return this.toBuffer(size).toString("hex");
};

});



parcelRegister("iTDkh", function(module, exports) {

var $bhJ7Q = parcelRequire("bhJ7Q");

var $66llh = parcelRequire("66llh");

var $BJzX3 = parcelRequire("BJzX3");
function $dc1bde66e1781a06$var$Curve(p, a, b, Gx, Gy, n, h) {
    this.p = p;
    this.a = a;
    this.b = b;
    this.G = $BJzX3.fromAffine(this, Gx, Gy);
    this.n = n;
    this.h = h;
    this.infinity = new $BJzX3(this, null, null, $66llh.ZERO);
    // result caching
    this.pOverFour = p.add($66llh.ONE).shiftRight(2);
    // determine size of p in bytes
    this.pLength = Math.floor((this.p.bitLength() + 7) / 8);
}
$dc1bde66e1781a06$var$Curve.prototype.pointFromX = function(isOdd, x) {
    var alpha = x.pow(3).add(this.a.multiply(x)).add(this.b).mod(this.p);
    var beta = alpha.modPow(this.pOverFour, this.p) // XXX: not compatible with all curves
    ;
    var y = beta;
    if (beta.isEven() ^ !isOdd) y = this.p.subtract(y) // -y % p
    ;
    return $BJzX3.fromAffine(this, x, y);
};
$dc1bde66e1781a06$var$Curve.prototype.isInfinity = function(Q) {
    if (Q === this.infinity) return true;
    return Q.z.signum() === 0 && Q.y.signum() !== 0;
};
$dc1bde66e1781a06$var$Curve.prototype.isOnCurve = function(Q) {
    if (this.isInfinity(Q)) return true;
    var x = Q.affineX;
    var y = Q.affineY;
    var a = this.a;
    var b = this.b;
    var p = this.p;
    // Check that xQ and yQ are integers in the interval [0, p - 1]
    if (x.signum() < 0 || x.compareTo(p) >= 0) return false;
    if (y.signum() < 0 || y.compareTo(p) >= 0) return false;
    // and check that y^2 = x^3 + ax + b (mod p)
    var lhs = y.square().mod(p);
    var rhs = x.pow(3).add(a.multiply(x)).add(b).mod(p);
    return lhs.equals(rhs);
};
/**
 * Validate an elliptic curve point.
 *
 * See SEC 1, section 3.2.2.1: Elliptic Curve Public Key Validation Primitive
 */ $dc1bde66e1781a06$var$Curve.prototype.validate = function(Q) {
    // Check Q != O
    $bhJ7Q(!this.isInfinity(Q), "Point is at infinity");
    $bhJ7Q(this.isOnCurve(Q), "Point is not on the curve");
    // Check nQ = O (where Q is a scalar multiple of G)
    var nQ = Q.multiply(this.n);
    $bhJ7Q(this.isInfinity(nQ), "Point is not a scalar multiple of G");
    return true;
};
module.exports = $dc1bde66e1781a06$var$Curve;

});

parcelRegister("igaWv", function(module, exports) {

var $66llh = parcelRequire("66llh");

var $kiBck = parcelRequire("kiBck");

var $iTDkh = parcelRequire("iTDkh");
function $d4b2359c82a18d57$var$getCurveByName(name) {
    var curve = $kiBck[name];
    if (!curve) return null;
    var p = new $66llh(curve.p, 16);
    var a = new $66llh(curve.a, 16);
    var b = new $66llh(curve.b, 16);
    var n = new $66llh(curve.n, 16);
    var h = new $66llh(curve.h, 16);
    var Gx = new $66llh(curve.Gx, 16);
    var Gy = new $66llh(curve.Gy, 16);
    return new $iTDkh(p, a, b, Gx, Gy, n, h);
}
module.exports = $d4b2359c82a18d57$var$getCurveByName;

});
parcelRegister("kiBck", function(module, exports) {
module.exports = JSON.parse('{"secp128r1":{"p":"fffffffdffffffffffffffffffffffff","a":"fffffffdfffffffffffffffffffffffc","b":"e87579c11079f43dd824993c2cee5ed3","n":"fffffffe0000000075a30d1b9038a115","h":"01","Gx":"161ff7528b899b2d0c28607ca52c5b86","Gy":"cf5ac8395bafeb13c02da292dded7a83"},"secp160k1":{"p":"fffffffffffffffffffffffffffffffeffffac73","a":"00","b":"07","n":"0100000000000000000001b8fa16dfab9aca16b6b3","h":"01","Gx":"3b4c382ce37aa192a4019e763036f4f5dd4d7ebb","Gy":"938cf935318fdced6bc28286531733c3f03c4fee"},"secp160r1":{"p":"ffffffffffffffffffffffffffffffff7fffffff","a":"ffffffffffffffffffffffffffffffff7ffffffc","b":"1c97befc54bd7a8b65acf89f81d4d4adc565fa45","n":"0100000000000000000001f4c8f927aed3ca752257","h":"01","Gx":"4a96b5688ef573284664698968c38bb913cbfc82","Gy":"23a628553168947d59dcc912042351377ac5fb32"},"secp192k1":{"p":"fffffffffffffffffffffffffffffffffffffffeffffee37","a":"00","b":"03","n":"fffffffffffffffffffffffe26f2fc170f69466a74defd8d","h":"01","Gx":"db4ff10ec057e9ae26b07d0280b7f4341da5d1b1eae06c7d","Gy":"9b2f2f6d9c5628a7844163d015be86344082aa88d95e2f9d"},"secp192r1":{"p":"fffffffffffffffffffffffffffffffeffffffffffffffff","a":"fffffffffffffffffffffffffffffffefffffffffffffffc","b":"64210519e59c80e70fa7e9ab72243049feb8deecc146b9b1","n":"ffffffffffffffffffffffff99def836146bc9b1b4d22831","h":"01","Gx":"188da80eb03090f67cbf20eb43a18800f4ff0afd82ff1012","Gy":"07192b95ffc8da78631011ed6b24cdd573f977a11e794811"},"secp256k1":{"p":"fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f","a":"00","b":"07","n":"fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141","h":"01","Gx":"79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","Gy":"483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8"},"secp256r1":{"p":"ffffffff00000001000000000000000000000000ffffffffffffffffffffffff","a":"ffffffff00000001000000000000000000000000fffffffffffffffffffffffc","b":"5ac635d8aa3a93e7b3ebbd55769886bc651d06b0cc53b0f63bce3c3e27d2604b","n":"ffffffff00000000ffffffffffffffffbce6faada7179e84f3b9cac2fc632551","h":"01","Gx":"6b17d1f2e12c4247f8bce6e563a440f277037d812deb33a0f4a13945d898c296","Gy":"4fe342e2fe1a7f9b8ee7eb4a7c0f9e162bce33576b315ececbb6406837bf51f5"}}');

});



parcelRegister("jJ9gD", function(module, exports) {

var $3FiLE = parcelRequire("3FiLE");

var $cUvgf = parcelRequire("cUvgf");
/** @namespace hash */ /** @arg {string|Buffer} data
    @arg {string} [resultEncoding = null] - 'hex', 'binary' or 'base64'
    @return {string|Buffer} - Buffer when resultEncoding is null, or string
*/ function $e5c968959b865614$var$sha1(data, resultEncoding) {
    return $3FiLE("sha1").update(data).digest(resultEncoding);
}
/** @arg {string|Buffer} data
    @arg {string} [resultEncoding = null] - 'hex', 'binary' or 'base64'
    @return {string|Buffer} - Buffer when resultEncoding is null, or string
*/ function $e5c968959b865614$var$sha256(data, resultEncoding) {
    return $3FiLE("sha256").update(data).digest(resultEncoding);
}
/** @arg {string|Buffer} data
    @arg {string} [resultEncoding = null] - 'hex', 'binary' or 'base64'
    @return {string|Buffer} - Buffer when resultEncoding is null, or string
*/ function $e5c968959b865614$var$sha512(data, resultEncoding) {
    return $3FiLE("sha512").update(data).digest(resultEncoding);
}
function $e5c968959b865614$var$HmacSHA256(buffer, secret) {
    return $cUvgf("sha256", secret).update(buffer).digest();
}
function $e5c968959b865614$var$ripemd160(data) {
    try {
        return $3FiLE("rmd160").update(data).digest();
    } catch (e) {
        return $3FiLE("ripemd160").update(data).digest();
    }
}
// function hash160(buffer) {
//   return ripemd160(sha256(buffer))
// }
//
// function hash256(buffer) {
//   return sha256(sha256(buffer))
// }
//
// function HmacSHA512(buffer, secret) {
//   return crypto.createHmac('sha512', secret).update(buffer).digest()
// }
module.exports = {
    sha1: $e5c968959b865614$var$sha1,
    sha256: $e5c968959b865614$var$sha256,
    sha512: $e5c968959b865614$var$sha512,
    HmacSHA256: $e5c968959b865614$var$HmacSHA256,
    ripemd160: $e5c968959b865614$var$ripemd160
};

});

parcelRegister("d3MuN", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $98212c6a914cd499$require$Buffer = $ihoyg.Buffer;

var $bhJ7Q = parcelRequire("bhJ7Q");

var $hT5Tn = parcelRequire("hT5Tn");

var $66llh = parcelRequire("66llh");
const $98212c6a914cd499$var$secp256k1 = $hT5Tn.getCurveByName("secp256k1");

var $jJ9gD = parcelRequire("jJ9gD");

var $9YYFe = parcelRequire("9YYFe");
var $98212c6a914cd499$var$G = $98212c6a914cd499$var$secp256k1.G;
var $98212c6a914cd499$var$n = $98212c6a914cd499$var$secp256k1.n;
module.exports = $98212c6a914cd499$var$PublicKey;
/**
  @param {string|Buffer|PublicKey|ecurve.Point} public key
  @param {string} [pubkey_prefix = 'FIO']
*/ function $98212c6a914cd499$var$PublicKey(Q, pubkey_prefix = "FIO") {
    if (typeof Q === "string") {
        const publicKey = $98212c6a914cd499$var$PublicKey.fromString(Q, pubkey_prefix);
        $bhJ7Q(publicKey != null, "Invalid public key");
        return publicKey;
    } else if ($98212c6a914cd499$require$Buffer.isBuffer(Q)) return $98212c6a914cd499$var$PublicKey.fromBuffer(Q);
    else if (typeof Q === "object" && Q.Q) return $98212c6a914cd499$var$PublicKey(Q.Q);
    $bhJ7Q.equal(typeof Q, "object", "Invalid public key");
    $bhJ7Q.equal(typeof Q.compressed, "boolean", "Invalid public key");
    function toBuffer(compressed = Q.compressed) {
        return Q.getEncoded(compressed);
    }
    let pubdata // cache
    ;
    // /**
    //     @todo secp224r1
    //     @return {string} PUB_K1_base58pubkey..
    // */
    // function toString() {
    //     if(pubdata) {
    //         return pubdata
    //     }
    //     pubdata = `PUB_K1_` + keyUtils.checkEncode(toBuffer(), 'K1')
    //     return pubdata;
    // }
    /** @todo rename to toStringLegacy
     * @arg {string} [pubkey_prefix = 'FIO'] - public key prefix
    */ function toString(pubkey_prefix = "FIO") {
        return pubkey_prefix + $9YYFe.checkEncode(toBuffer());
    }
    function toUncompressed() {
        var buf = Q.getEncoded(false);
        var point = $hT5Tn.Point.decodeFrom($98212c6a914cd499$var$secp256k1, buf);
        return $98212c6a914cd499$var$PublicKey.fromPoint(point);
    }
    /** @deprecated */ function child(offset) {
        console.error("Deprecated warning: PublicKey.child");
        $bhJ7Q($98212c6a914cd499$require$Buffer.isBuffer(offset), "Buffer required: offset");
        $bhJ7Q.equal(offset.length, 32, "offset length");
        offset = $98212c6a914cd499$require$Buffer.concat([
            toBuffer(),
            offset
        ]);
        offset = $jJ9gD.sha256(offset);
        let c = $66llh.fromBuffer(offset);
        if (c.compareTo($98212c6a914cd499$var$n) >= 0) throw new Error("Child offset went out of bounds, try again");
        let cG = $98212c6a914cd499$var$G.multiply(c);
        let Qprime = Q.add(cG);
        if ($98212c6a914cd499$var$secp256k1.isInfinity(Qprime)) throw new Error("Child offset derived to an invalid key, try again");
        return $98212c6a914cd499$var$PublicKey.fromPoint(Qprime);
    }
    function toHex() {
        return toBuffer().toString("hex");
    }
    return {
        Q: Q,
        toString: toString,
        toUncompressed: // toStringLegacy,
        toUncompressed,
        toBuffer: toBuffer,
        child: child,
        toHex: toHex
    };
}
/**
  @param {string|Buffer|PublicKey|ecurve.Point} pubkey - public key
  @param {string} [pubkey_prefix = 'FIO']
*/ $98212c6a914cd499$var$PublicKey.isValid = function(pubkey, pubkey_prefix = "FIO") {
    try {
        $98212c6a914cd499$var$PublicKey(pubkey, pubkey_prefix);
        return true;
    } catch (e) {
        return false;
    }
};
$98212c6a914cd499$var$PublicKey.fromBinary = function(bin) {
    return $98212c6a914cd499$var$PublicKey.fromBuffer(new $98212c6a914cd499$require$Buffer(bin, "binary"));
};
$98212c6a914cd499$var$PublicKey.fromBuffer = function(buffer) {
    return $98212c6a914cd499$var$PublicKey($hT5Tn.Point.decodeFrom($98212c6a914cd499$var$secp256k1, buffer));
};
$98212c6a914cd499$var$PublicKey.fromPoint = function(point) {
    return $98212c6a914cd499$var$PublicKey(point);
};
/**
    @arg {string} public_key - like PUB_K1_base58pubkey..
    @arg {string} [pubkey_prefix = 'FIO'] - public key prefix
    @return PublicKey or `null` (invalid)
*/ $98212c6a914cd499$var$PublicKey.fromString = function(public_key, pubkey_prefix = "FIO") {
    try {
        return $98212c6a914cd499$var$PublicKey.fromStringOrThrow(public_key, pubkey_prefix);
    } catch (e) {
        return null;
    }
};
/**
    @arg {string} public_key - like PUB_K1_base58pubkey..
    @arg {string} [pubkey_prefix = 'FIO'] - public key prefix

    @throws {Error} if public key is invalid

    @return PublicKey
*/ $98212c6a914cd499$var$PublicKey.fromStringOrThrow = function(public_key, pubkey_prefix = "FIO") {
    $bhJ7Q.equal(typeof public_key, "string", "public_key");
    const match = public_key.match(/^PUB_([A-Za-z0-9]+)_([A-Za-z0-9]+)$/);
    if (match === null) {
        // legacy
        var prefix_match = new RegExp("^" + pubkey_prefix);
        if (prefix_match.test(public_key)) public_key = public_key.substring(pubkey_prefix.length);
        return $98212c6a914cd499$var$PublicKey.fromBuffer($9YYFe.checkDecode(public_key));
    }
    $bhJ7Q(match.length === 3, "Expecting public key like: PUB_K1_base58pubkey..");
    const [, keyType, keyString] = match;
    $bhJ7Q.equal(keyType, "K1", "K1 private key expected");
    return $98212c6a914cd499$var$PublicKey.fromBuffer($9YYFe.checkDecode(keyString, keyType));
};
$98212c6a914cd499$var$PublicKey.fromHex = function(hex) {
    return $98212c6a914cd499$var$PublicKey.fromBuffer(new $98212c6a914cd499$require$Buffer(hex, "hex"));
};
$98212c6a914cd499$var$PublicKey.fromStringHex = function(hex) {
    return $98212c6a914cd499$var$PublicKey.fromString(new $98212c6a914cd499$require$Buffer(hex, "hex"));
};

});
parcelRegister("9YYFe", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $7448c6473e56fc11$require$Buffer = $ihoyg.Buffer;

var $hZS7n = parcelRequire("hZS7n");

var $bhJ7Q = parcelRequire("bhJ7Q");

var $5rfiH = parcelRequire("5rfiH");

var $jJ9gD = parcelRequire("jJ9gD");
module.exports = {
    random32ByteBuffer: $7448c6473e56fc11$var$random32ByteBuffer,
    addEntropy: $7448c6473e56fc11$var$addEntropy,
    cpuEntropy: $7448c6473e56fc11$var$cpuEntropy,
    entropyCount: ()=>$7448c6473e56fc11$var$entropyCount,
    checkDecode: $7448c6473e56fc11$var$checkDecode,
    checkEncode: $7448c6473e56fc11$var$checkEncode
};
let $7448c6473e56fc11$var$entropyPos = 0, $7448c6473e56fc11$var$entropyCount = 0;
const $7448c6473e56fc11$var$externalEntropyArray = $5rfiH(101);
/**
    Additional forms of entropy are used.  A week random number generator can run out of entropy.  This should ensure even the worst random number implementation will be reasonably safe.

    @arg {number} [cpuEntropyBits = 0] generate entropy on the fly.  This is
    not required, entropy can be added in advanced via addEntropy or initialize().

    @arg {boolean} [safe = true] false for testing, otherwise this will be
    true to ensure initialize() was called.

    @return a random buffer obtained from the secure random number generator.  Additional entropy is used.
*/ function $7448c6473e56fc11$var$random32ByteBuffer({ cpuEntropyBits: cpuEntropyBits = 0, safe: safe = true } = {}) {
    $bhJ7Q.equal(typeof cpuEntropyBits, "number", "cpuEntropyBits");
    $bhJ7Q.equal(typeof safe, "boolean", "boolean");
    if (safe) $bhJ7Q($7448c6473e56fc11$var$entropyCount >= 128, "Call initialize() to add entropy");
    // if(entropyCount > 0) {
    //     console.log(`Additional private key entropy: ${entropyCount} events`)
    // }
    const hash_array = [];
    hash_array.push($5rfiH(32));
    hash_array.push($7448c6473e56fc11$require$Buffer.from($7448c6473e56fc11$var$cpuEntropy(cpuEntropyBits)));
    hash_array.push($7448c6473e56fc11$var$externalEntropyArray);
    hash_array.push($7448c6473e56fc11$var$browserEntropy());
    return $jJ9gD.sha256($7448c6473e56fc11$require$Buffer.concat(hash_array));
}
/**
    Adds entropy.  This may be called many times while the amount of data saved
    is accumulatively reduced to 101 integers.  Data is retained in RAM for the
    life of this module.

    @example React <code>
    componentDidMount() {
        this.refs.MyComponent.addEventListener("mousemove", this.onEntropyEvent, {capture: false, passive: true})
    }
    componentWillUnmount() {
        this.refs.MyComponent.removeEventListener("mousemove", this.onEntropyEvent);
    }
    onEntropyEvent = (e) => {
        if(e.type === 'mousemove')
            key_utils.addEntropy(e.pageX, e.pageY, e.screenX, e.screenY)
        else
            console.log('onEntropyEvent Unknown', e.type, e)
    }
    </code>
*/ function $7448c6473e56fc11$var$addEntropy(...ints) {
    $bhJ7Q.equal($7448c6473e56fc11$var$externalEntropyArray.length, 101, "externalEntropyArray");
    $7448c6473e56fc11$var$entropyCount += ints.length;
    for (const i of ints){
        const pos = $7448c6473e56fc11$var$entropyPos++ % 101;
        const i2 = $7448c6473e56fc11$var$externalEntropyArray[pos] += i;
        if (i2 > 9007199254740991) $7448c6473e56fc11$var$externalEntropyArray[pos] = 0;
    }
}
/**
    This runs in just under 1 second and ensures a minimum of cpuEntropyBits
    bits of entropy are gathered.

    Based on more-entropy. @see https://github.com/keybase/more-entropy/blob/master/src/generator.iced

    @arg {number} [cpuEntropyBits = 128]
    @return {array} counts gathered by measuring variations in the CPU speed during floating point operations.
*/ function $7448c6473e56fc11$var$cpuEntropy(cpuEntropyBits = 128) {
    let collected = [];
    let lastCount = null;
    let lowEntropySamples = 0;
    while(collected.length < cpuEntropyBits){
        const count = $7448c6473e56fc11$var$floatingPointCount();
        if (lastCount != null) {
            const delta = count - lastCount;
            if (Math.abs(delta) < 1) {
                lowEntropySamples++;
                continue;
            }
            // how many bits of entropy were in this sample
            const bits = Math.floor($7448c6473e56fc11$var$log2(Math.abs(delta)) + 1);
            if (bits < 4) {
                if (bits < 2) lowEntropySamples++;
                continue;
            }
            collected.push(delta);
        }
        lastCount = count;
    }
    if (lowEntropySamples > 10) {
        const pct = Number(lowEntropySamples / cpuEntropyBits * 100).toFixed(2);
        // Is this algorithm getting inefficient?
        console.warn(`WARN: ${pct}% low CPU entropy re-sampled`);
    }
    return collected;
}
/**
    @private
    Count while performing floating point operations during a fixed time
    (7 ms for example).  Using a fixed time makes this algorithm
    predictable in runtime.
*/ function $7448c6473e56fc11$var$floatingPointCount() {
    const workMinMs = 7;
    const d = Date.now();
    let i = 0, x = 0;
    while(Date.now() < d + workMinMs + 1)x = Math.sin(Math.sqrt(Math.log(++i + x)));
    return i;
}
const $7448c6473e56fc11$var$log2 = (x)=>Math.log(x) / Math.LN2;
/**
    @private
    Attempt to gather and hash information from the browser's window, history, and supported mime types.  For non-browser environments this simply includes secure random data.  In any event, the information is re-hashed in a loop for 25 milliseconds seconds.

    @return {Buffer} 32 bytes
*/ function $7448c6473e56fc11$var$browserEntropy() {
    let entropyStr = Array($5rfiH(101)).join();
    try {
        entropyStr += new Date().toString() + " " + window.screen.height + " " + window.screen.width + " " + window.screen.colorDepth + " " + " " + window.screen.availHeight + " " + window.screen.availWidth + " " + window.screen.pixelDepth + navigator.language + " " + window.location + " " + window.history.length;
        for(let i = 0, mimeType; i < navigator.mimeTypes.length; i++){
            mimeType = navigator.mimeTypes[i];
            entropyStr += mimeType.description + " " + mimeType.type + " " + mimeType.suffixes + " ";
        }
    } catch (error) {
        //nodejs:ReferenceError: window is not defined
        entropyStr += $jJ9gD.sha256(new Date().toString());
    }
    const b = new $7448c6473e56fc11$require$Buffer(entropyStr);
    entropyStr += b.toString("binary") + " " + new Date().toString();
    let entropy = entropyStr;
    const start_t = Date.now();
    while(Date.now() - start_t < 25)entropy = $jJ9gD.sha256(entropy);
    return entropy;
}
/**
  @arg {Buffer} keyBuffer data
  @arg {string} keyType = sha256x2, K1, etc
  @return {string} checksum encoded base58 string
*/ function $7448c6473e56fc11$var$checkEncode(keyBuffer, keyType = null) {
    $bhJ7Q($7448c6473e56fc11$require$Buffer.isBuffer(keyBuffer), "expecting keyBuffer<Buffer>");
    if (keyType === "sha256x2") {
        const checksum = $jJ9gD.sha256($jJ9gD.sha256(keyBuffer)).slice(0, 4);
        return $hZS7n.encode($7448c6473e56fc11$require$Buffer.concat([
            keyBuffer,
            checksum
        ]));
    } else {
        const check = [
            keyBuffer
        ];
        if (keyType) check.push($7448c6473e56fc11$require$Buffer.from(keyType));
        const checksum = $jJ9gD.ripemd160($7448c6473e56fc11$require$Buffer.concat(check)).slice(0, 4);
        return $hZS7n.encode($7448c6473e56fc11$require$Buffer.concat([
            keyBuffer,
            checksum
        ]));
    }
}
/**
  @arg {Buffer} keyString data
  @arg {string} keyType = sha256x2, K1, etc
  @return {string} checksum encoded base58 string
*/ function $7448c6473e56fc11$var$checkDecode(keyString, keyType = null) {
    $bhJ7Q(keyString != null, "private key expected");
    const buffer = new $7448c6473e56fc11$require$Buffer($hZS7n.decode(keyString));
    const checksum = buffer.slice(-4);
    const key = buffer.slice(0, -4);
    let newCheck;
    if (keyType === "sha256x2") newCheck = $jJ9gD.sha256($jJ9gD.sha256(key)).slice(0, 4) // WIF (legacy)
    ;
    else {
        const check = [
            key
        ];
        if (keyType) check.push($7448c6473e56fc11$require$Buffer.from(keyType));
        newCheck = $jJ9gD.ripemd160($7448c6473e56fc11$require$Buffer.concat(check)).slice(0, 4) //PVT
        ;
    }
    if (checksum.toString() !== newCheck.toString()) throw new Error("Invalid checksum, " + `${checksum.toString("hex")} != ${newCheck.toString("hex")}`);
    return key;
}

});


parcelRegister("70BmP", function(module, exports) {
/**
  Convert a synchronous function into a asynchronous one (via setTimeout)
  wrapping it in a promise.  This does not expect the function to have a
  callback paramter.

  @arg {function} func - non-callback function

  @example promiseAsync(myfunction)
*/ module.exports = (func)=>(...args)=>new Promise((resolve, reject)=>{
            setTimeout(()=>{
                try {
                    resolve(func(...args));
                } catch (err) {
                    reject(err);
                }
            });
        });

});


parcelRegister("9maPk", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $6cfe9121bf0dab90$require$Buffer = $ihoyg.Buffer;

var $aOutR = parcelRequire("aOutR");

var $jJ9gD = parcelRequire("jJ9gD");

const $6cfe9121bf0dab90$var$curve = (parcelRequire("hT5Tn")).getCurveByName("secp256k1");

var $bhJ7Q = parcelRequire("bhJ7Q");

var $66llh = parcelRequire("66llh");

var $9YYFe = parcelRequire("9YYFe");

var $d3MuN = parcelRequire("d3MuN");

var $6CIJR = parcelRequire("6CIJR");
module.exports = $6cfe9121bf0dab90$var$Signature;
function $6cfe9121bf0dab90$var$Signature(r, s, i) {
    $bhJ7Q.equal(r != null, true, "Missing parameter");
    $bhJ7Q.equal(s != null, true, "Missing parameter");
    $bhJ7Q.equal(i != null, true, "Missing parameter");
    /**
        Verify signed data.

        @arg {String|Buffer} data - full data
        @arg {pubkey|PublicKey} pubkey - FIOKey..
        @arg {String} [encoding = 'utf8'] - data encoding (if data is a string)

        @return {boolean}
    */ function verify(data, pubkey, encoding = "utf8") {
        if (typeof data === "string") data = $6cfe9121bf0dab90$require$Buffer.from(data, encoding);
        $bhJ7Q($6cfe9121bf0dab90$require$Buffer.isBuffer(data), "data is a required String or Buffer");
        data = $jJ9gD.sha256(data);
        return verifyHash(data, pubkey);
    }
    /**
        Verify a buffer of exactally 32 bytes in size (sha256(text))

        @arg {String|Buffer} dataSha256 - 32 byte buffer or string
        @arg {String|PublicKey} pubkey - FIOKey..
        @arg {String} [encoding = 'hex'] - dataSha256 encoding (if string)

        @return {boolean}
    */ function verifyHash(dataSha256, pubkey, encoding = "hex") {
        if (typeof dataSha256 === "string") dataSha256 = $6cfe9121bf0dab90$require$Buffer.from(dataSha256, encoding);
        if (dataSha256.length !== 32 || !$6cfe9121bf0dab90$require$Buffer.isBuffer(dataSha256)) throw new Error("dataSha256: 32 bytes required");
        const publicKey = $d3MuN(pubkey);
        $bhJ7Q(publicKey, "pubkey required");
        return $aOutR.verify($6cfe9121bf0dab90$var$curve, dataSha256, {
            r: r,
            s: s
        }, publicKey.Q);
    }
    /** @deprecated

        Verify hex data by converting to a buffer then hashing.

        @return {boolean}
    */ function verifyHex(hex, pubkey) {
        console.log('Deprecated: use verify(data, pubkey, "hex")');
        const buf = $6cfe9121bf0dab90$require$Buffer.from(hex, "hex");
        return verify(buf, pubkey);
    }
    /**
        Recover the public key used to create this signature using full data.

        @arg {String|Buffer} data - full data
        @arg {String} [encoding = 'utf8'] - data encoding (if string)

        @return {PublicKey}
    */ function recover(data, encoding = "utf8") {
        if (typeof data === "string") data = $6cfe9121bf0dab90$require$Buffer.from(data, encoding);
        $bhJ7Q($6cfe9121bf0dab90$require$Buffer.isBuffer(data), "data is a required String or Buffer");
        data = $jJ9gD.sha256(data);
        return recoverHash(data);
    }
    /**
        @arg {String|Buffer} dataSha256 - sha256 hash 32 byte buffer or hex string
        @arg {String} [encoding = 'hex'] - dataSha256 encoding (if string)

        @return {PublicKey}
    */ function recoverHash(dataSha256, encoding = "hex") {
        if (typeof dataSha256 === "string") dataSha256 = $6cfe9121bf0dab90$require$Buffer.from(dataSha256, encoding);
        if (dataSha256.length !== 32 || !$6cfe9121bf0dab90$require$Buffer.isBuffer(dataSha256)) throw new Error("dataSha256: 32 byte String or buffer requred");
        const e = $66llh.fromBuffer(dataSha256);
        let i2 = i;
        i2 -= 27;
        i2 = i2 & 3;
        const Q = $aOutR.recoverPubKey($6cfe9121bf0dab90$var$curve, e, {
            r: r,
            s: s,
            i: i
        }, i2);
        return $d3MuN.fromPoint(Q);
    }
    function toBuffer() {
        var buf;
        buf = new $6cfe9121bf0dab90$require$Buffer(65);
        buf.writeUInt8(i, 0);
        r.toBuffer(32).copy(buf, 1);
        s.toBuffer(32).copy(buf, 33);
        return buf;
    }
    function toHex() {
        return toBuffer().toString("hex");
    }
    let signatureCache;
    function toString() {
        if (signatureCache) return signatureCache;
        signatureCache = "SIG_K1_" + $9YYFe.checkEncode(toBuffer(), "K1");
        return signatureCache;
    }
    return {
        r: r,
        s: s,
        i: i,
        toBuffer: toBuffer,
        verify: verify,
        verifyHash: verifyHash,
        verifyHex: verifyHex,
        recover: recover,
        recoverHash: recoverHash,
        toHex: toHex,
        toString: toString,
        /** @deprecated use verify (same arguments and return) */ verifyBuffer: (...args)=>{
            console.log("Deprecated: use signature.verify instead (same arguments)");
            return verify(...args);
        },
        /** @deprecated use recover (same arguments and return) */ recoverPublicKey: (...args)=>{
            console.log("Deprecated: use signature.recover instead (same arguments)");
            return recover(...args);
        },
        /** @deprecated use recoverHash (same arguments and return) */ recoverPublicKeyFromBuffer: (...args)=>{
            console.log("Deprecated: use signature.recoverHash instead (same arguments)");
            return recoverHash(...args);
        }
    };
}
/**
    Hash and sign arbitrary data.

    @arg {string|Buffer} data - full data
    @arg {wif|PrivateKey} privateKey
    @arg {String} [encoding = 'utf8'] - data encoding (if string)

    @return {Signature}
*/ $6cfe9121bf0dab90$var$Signature.sign = function(data, privateKey, encoding = "utf8") {
    if (typeof data === "string") data = $6cfe9121bf0dab90$require$Buffer.from(data, encoding);
    $bhJ7Q($6cfe9121bf0dab90$require$Buffer.isBuffer(data), "data is a required String or Buffer");
    data = $jJ9gD.sha256(data);
    return $6cfe9121bf0dab90$var$Signature.signHash(data, privateKey);
};
/**
    Sign a buffer of exactally 32 bytes in size (sha256(text))

    @arg {string|Buffer} dataSha256 - 32 byte buffer or string
    @arg {wif|PrivateKey} privateKey
    @arg {String} [encoding = 'hex'] - dataSha256 encoding (if string)

    @return {Signature}
*/ $6cfe9121bf0dab90$var$Signature.signHash = function(dataSha256, privateKey, encoding = "hex") {
    if (typeof dataSha256 === "string") dataSha256 = $6cfe9121bf0dab90$require$Buffer.from(dataSha256, encoding);
    if (dataSha256.length !== 32 || !$6cfe9121bf0dab90$require$Buffer.isBuffer(dataSha256)) throw new Error("dataSha256: 32 byte buffer requred");
    privateKey = $6CIJR(privateKey);
    $bhJ7Q(privateKey, "privateKey required");
    var der, e, ecsignature, i, lenR, lenS, nonce;
    i = null;
    nonce = 0;
    e = $66llh.fromBuffer(dataSha256);
    while(true){
        ecsignature = $aOutR.sign($6cfe9121bf0dab90$var$curve, dataSha256, privateKey.d, nonce++);
        der = ecsignature.toDER();
        lenR = der[3];
        lenS = der[5 + lenR];
        if (lenR === 32 && lenS === 32) {
            i = $aOutR.calcPubKeyRecoveryParam($6cfe9121bf0dab90$var$curve, e, ecsignature, privateKey.toPublic().Q);
            i += 4; // compressed
            i += 27; // compact  //  24 or 27 :( forcing odd-y 2nd key candidate)
            break;
        }
        if (nonce % 10 === 0) console.log("WARN: " + nonce + " attempts to find canonical signature");
    }
    return $6cfe9121bf0dab90$var$Signature(ecsignature.r, ecsignature.s, i);
};
$6cfe9121bf0dab90$var$Signature.fromBuffer = function(buf) {
    var i, r, s;
    $bhJ7Q($6cfe9121bf0dab90$require$Buffer.isBuffer(buf), "Buffer is required");
    $bhJ7Q.equal(buf.length, 65, "Invalid signature length");
    i = buf.readUInt8(0);
    $bhJ7Q.equal(i - 27, i - 27 & 7, "Invalid signature parameter");
    r = $66llh.fromBuffer(buf.slice(1, 33));
    s = $66llh.fromBuffer(buf.slice(33));
    return $6cfe9121bf0dab90$var$Signature(r, s, i);
};
$6cfe9121bf0dab90$var$Signature.fromHex = function(hex) {
    return $6cfe9121bf0dab90$var$Signature.fromBuffer($6cfe9121bf0dab90$require$Buffer.from(hex, "hex"));
};
/**
    @arg {string} signature - like SIG_K1_base58signature..
    @return {Signature} or `null` (invalid)
*/ $6cfe9121bf0dab90$var$Signature.fromString = function(signature) {
    try {
        return $6cfe9121bf0dab90$var$Signature.fromStringOrThrow(signature);
    } catch (e) {
        return null;
    }
};
/**
    @arg {string} signature - like SIG_K1_base58signature..
    @throws {Error} invalid
    @return {Signature}
*/ $6cfe9121bf0dab90$var$Signature.fromStringOrThrow = function(signature) {
    $bhJ7Q.equal(typeof signature, "string", "signature");
    const match = signature.match(/^SIG_([A-Za-z0-9]+)_([A-Za-z0-9]+)$/);
    $bhJ7Q(match != null && match.length === 3, "Expecting signature like: SIG_K1_base58signature..");
    const [, keyType, keyString] = match;
    $bhJ7Q.equal(keyType, "K1", "K1 signature expected");
    return $6cfe9121bf0dab90$var$Signature.fromBuffer($9YYFe.checkDecode(keyString, keyType));
};
/**
    @arg {String|Signature} o - hex string
    @return {Signature}
*/ $6cfe9121bf0dab90$var$Signature.from = (o)=>{
    const signature = o ? o.r && o.s && o.i ? o : typeof o === "string" && o.length === 130 ? $6cfe9121bf0dab90$var$Signature.fromHex(o) : typeof o === "string" && o.length !== 130 ? $6cfe9121bf0dab90$var$Signature.fromStringOrThrow(o) : $6cfe9121bf0dab90$require$Buffer.isBuffer(o) ? $6cfe9121bf0dab90$var$Signature.fromBuffer(o) : null : o /*null or undefined*/ ;
    if (!signature) throw new TypeError("signature should be a hex string or buffer");
    return signature;
};

});
parcelRegister("aOutR", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $7df637b547651577$require$Buffer = $ihoyg.Buffer;

var $bhJ7Q = parcelRequire("bhJ7Q");

var $jJ9gD = parcelRequire("jJ9gD");

var $65tNq = parcelRequire("65tNq");

var $66llh = parcelRequire("66llh");

var $6rYI7 = parcelRequire("6rYI7");
// https://tools.ietf.org/html/rfc6979#section-3.2
function $7df637b547651577$var$deterministicGenerateK(curve, hash, d, checkSig, nonce) {
    $65tNq("Buffer", hash);
    $65tNq($66llh, d);
    if (nonce) hash = $jJ9gD.sha256($7df637b547651577$require$Buffer.concat([
        hash,
        new $7df637b547651577$require$Buffer(nonce)
    ]));
    // sanity check
    $bhJ7Q.equal(hash.length, 32, "Hash must be 256 bit");
    var x = d.toBuffer(32);
    var k = new $7df637b547651577$require$Buffer(32);
    var v = new $7df637b547651577$require$Buffer(32);
    // Step B
    v.fill(1);
    // Step C
    k.fill(0);
    // Step D
    k = $jJ9gD.HmacSHA256($7df637b547651577$require$Buffer.concat([
        v,
        new $7df637b547651577$require$Buffer([
            0
        ]),
        x,
        hash
    ]), k);
    // Step E
    v = $jJ9gD.HmacSHA256(v, k);
    // Step F
    k = $jJ9gD.HmacSHA256($7df637b547651577$require$Buffer.concat([
        v,
        new $7df637b547651577$require$Buffer([
            1
        ]),
        x,
        hash
    ]), k);
    // Step G
    v = $jJ9gD.HmacSHA256(v, k);
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $jJ9gD.HmacSHA256(v, k);
    var T = $66llh.fromBuffer(v);
    // Step H3, repeat until T is within the interval [1, n - 1]
    while(T.signum() <= 0 || T.compareTo(curve.n) >= 0 || !checkSig(T)){
        k = $jJ9gD.HmacSHA256($7df637b547651577$require$Buffer.concat([
            v,
            new $7df637b547651577$require$Buffer([
                0
            ])
        ]), k);
        v = $jJ9gD.HmacSHA256(v, k);
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $jJ9gD.HmacSHA256(v, k);
        T = $66llh.fromBuffer(v);
    }
    return T;
}
function $7df637b547651577$var$sign(curve, hash, d, nonce) {
    var e = $66llh.fromBuffer(hash);
    var n = curve.n;
    var G = curve.G;
    var r, s;
    var k = $7df637b547651577$var$deterministicGenerateK(curve, hash, d, function(k) {
        // find canonically valid signature
        var Q = G.multiply(k);
        if (curve.isInfinity(Q)) return false;
        r = Q.affineX.mod(n);
        if (r.signum() === 0) return false;
        s = k.modInverse(n).multiply(e.add(d.multiply(r))).mod(n);
        if (s.signum() === 0) return false;
        return true;
    }, nonce);
    var N_OVER_TWO = n.shiftRight(1);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.compareTo(N_OVER_TWO) > 0) s = n.subtract(s);
    return $6rYI7(r, s);
}
function $7df637b547651577$var$verifyRaw(curve, e, signature, Q) {
    var n = curve.n;
    var G = curve.G;
    var r = signature.r;
    var s = signature.s;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1]
    if (r.signum() <= 0 || r.compareTo(n) >= 0) return false;
    if (s.signum() <= 0 || s.compareTo(n) >= 0) return false;
    // c = s^-1 mod n
    var c = s.modInverse(n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    var u1 = e.multiply(c).mod(n);
    var u2 = r.multiply(c).mod(n);
    // 1.4.5 Compute R = (xR, yR) = u1G + u2Q
    var R = G.multiplyTwo(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (curve.isInfinity(R)) return false;
    // 1.4.6 Convert the field element R.x to an integer
    var xR = R.affineX;
    // 1.4.7 Set v = xR mod n
    var v = xR.mod(n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.equals(r);
}
function $7df637b547651577$var$verify(curve, hash, signature, Q) {
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    var e = $66llh.fromBuffer(hash);
    return $7df637b547651577$var$verifyRaw(curve, e, signature, Q);
}
/**
  * Recover a public key from a signature.
  *
  * See SEC 1: Elliptic Curve Cryptography, section 4.1.6, "Public
  * Key Recovery Operation".
  *
  * http://www.secg.org/download/aid-780/sec1-v2.pdf
  */ function $7df637b547651577$var$recoverPubKey(curve, e, signature, i) {
    $bhJ7Q.strictEqual(i & 3, i, "Recovery param is more than two bits");
    var n = curve.n;
    var G = curve.G;
    var r = signature.r;
    var s = signature.s;
    $bhJ7Q(r.signum() > 0 && r.compareTo(n) < 0, "Invalid r value");
    $bhJ7Q(s.signum() > 0 && s.compareTo(n) < 0, "Invalid s value");
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = i & 1;
    // The more significant bit specifies whether we should use the
    // first or second candidate key.
    var isSecondKey = i >> 1;
    // 1.1 Let x = r + jn
    var x = isSecondKey ? r.add(n) : r;
    var R = curve.pointFromX(isYOdd, x);
    // 1.4 Check that nR is at infinity
    var nR = R.multiply(n);
    $bhJ7Q(curve.isInfinity(nR), "nR is not a valid curve point");
    // Compute -e from e
    var eNeg = e.negate().mod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    var rInv = r.modInverse(n);
    var Q = R.multiplyTwo(s, G, eNeg).multiply(rInv);
    curve.validate(Q);
    return Q;
}
/**
  * Calculate pubkey extraction parameter.
  *
  * When extracting a pubkey from a signature, we have to
  * distinguish four different cases. Rather than putting this
  * burden on the verifier, Bitcoin includes a 2-bit value with the
  * signature.
  *
  * This function simply tries all four cases and returns the value
  * that resulted in a successful pubkey recovery.
  */ function $7df637b547651577$var$calcPubKeyRecoveryParam(curve, e, signature, Q) {
    for(var i = 0; i < 4; i++){
        var Qprime = $7df637b547651577$var$recoverPubKey(curve, e, signature, i);
        // 1.6.2 Verify Q
        if (Qprime.equals(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
}
module.exports = {
    calcPubKeyRecoveryParam: $7df637b547651577$var$calcPubKeyRecoveryParam,
    deterministicGenerateK: $7df637b547651577$var$deterministicGenerateK,
    recoverPubKey: $7df637b547651577$var$recoverPubKey,
    sign: $7df637b547651577$var$sign,
    verify: $7df637b547651577$var$verify,
    verifyRaw: $7df637b547651577$var$verifyRaw
};

});
parcelRegister("65tNq", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $46ea5298db9eb21f$require$Buffer = $ihoyg.Buffer;
module.exports = function enforce(type, value) {
    switch(type){
        case "Array":
            if (Array.isArray(value)) return;
            break;
        case "Boolean":
            if (typeof value === "boolean") return;
            break;
        case "Buffer":
            if ($46ea5298db9eb21f$require$Buffer.isBuffer(value)) return;
            break;
        case "Number":
            if (typeof value === "number") return;
            break;
        case "String":
            if (typeof value === "string") return;
            break;
        default:
            if ($46ea5298db9eb21f$var$getName(value.constructor) === $46ea5298db9eb21f$var$getName(type)) return;
    }
    throw new TypeError("Expected " + ($46ea5298db9eb21f$var$getName(type) || type) + ", got " + value);
};
function $46ea5298db9eb21f$var$getName(fn) {
    // Why not fn.name: https://kangax.github.io/compat-table/es6/#function_name_property
    var match = fn.toString().match(/function (.*?)\(/);
    return match ? match[1] : null;
}

});

parcelRegister("6rYI7", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $4b245b891e96832c$require$Buffer = $ihoyg.Buffer;

var $bhJ7Q = parcelRequire("bhJ7Q");

var $65tNq = parcelRequire("65tNq");

var $66llh = parcelRequire("66llh");
function $4b245b891e96832c$var$ECSignature(r, s) {
    $65tNq($66llh, r);
    $65tNq($66llh, s);
    function toCompact(i, compressed) {
        if (compressed) i += 4;
        i += 27;
        var buffer = new $4b245b891e96832c$require$Buffer(65);
        buffer.writeUInt8(i, 0);
        r.toBuffer(32).copy(buffer, 1);
        s.toBuffer(32).copy(buffer, 33);
        return buffer;
    }
    function toDER() {
        var rBa = r.toDERInteger();
        var sBa = s.toDERInteger();
        var sequence = [];
        // INTEGER
        sequence.push(0x02, rBa.length);
        sequence = sequence.concat(rBa);
        // INTEGER
        sequence.push(0x02, sBa.length);
        sequence = sequence.concat(sBa);
        // SEQUENCE
        sequence.unshift(0x30, sequence.length);
        return new $4b245b891e96832c$require$Buffer(sequence);
    }
    function toScriptSignature(hashType) {
        var hashTypeBuffer = new $4b245b891e96832c$require$Buffer(1);
        hashTypeBuffer.writeUInt8(hashType, 0);
        return $4b245b891e96832c$require$Buffer.concat([
            toDER(),
            hashTypeBuffer
        ]);
    }
    return {
        r: r,
        s: s,
        toCompact: toCompact,
        toDER: toDER,
        toScriptSignature: toScriptSignature
    };
}
// Import operations
$4b245b891e96832c$var$ECSignature.parseCompact = function(buffer) {
    $bhJ7Q.equal(buffer.length, 65, "Invalid signature length");
    var i = buffer.readUInt8(0) - 27;
    // At most 3 bits
    $bhJ7Q.equal(i, i & 7, "Invalid signature parameter");
    var compressed = !!(i & 4);
    // Recovery param only
    i = i & 3;
    var r = $66llh.fromBuffer(buffer.slice(1, 33));
    var s = $66llh.fromBuffer(buffer.slice(33));
    return {
        compressed: compressed,
        i: i,
        signature: $4b245b891e96832c$var$ECSignature(r, s)
    };
};
$4b245b891e96832c$var$ECSignature.fromDER = function(buffer) {
    $bhJ7Q.equal(buffer.readUInt8(0), 0x30, "Not a DER sequence");
    $bhJ7Q.equal(buffer.readUInt8(1), buffer.length - 2, "Invalid sequence length");
    $bhJ7Q.equal(buffer.readUInt8(2), 0x02, "Expected a DER integer");
    var rLen = buffer.readUInt8(3);
    $bhJ7Q(rLen > 0, "R length is zero");
    var offset = 4 + rLen;
    $bhJ7Q.equal(buffer.readUInt8(offset), 0x02, "Expected a DER integer (2)");
    var sLen = buffer.readUInt8(offset + 1);
    $bhJ7Q(sLen > 0, "S length is zero");
    var rB = buffer.slice(4, offset);
    var sB = buffer.slice(offset + 2);
    offset += 2 + sLen;
    if (rLen > 1 && rB.readUInt8(0) === 0x00) $bhJ7Q(rB.readUInt8(1) & 0x80, "R value excessively padded");
    if (sLen > 1 && sB.readUInt8(0) === 0x00) $bhJ7Q(sB.readUInt8(1) & 0x80, "S value excessively padded");
    $bhJ7Q.equal(offset, buffer.length, "Invalid DER encoding");
    var r = $66llh.fromDERInteger(rB);
    var s = $66llh.fromDERInteger(sB);
    $bhJ7Q(r.signum() >= 0, "R value is negative");
    $bhJ7Q(s.signum() >= 0, "S value is negative");
    return $4b245b891e96832c$var$ECSignature(r, s);
};
// FIXME: 0x00, 0x04, 0x80 are SIGHASH_* boundary constants, importing Transaction causes a circular dependency
$4b245b891e96832c$var$ECSignature.parseScriptSignature = function(buffer) {
    var hashType = buffer.readUInt8(buffer.length - 1);
    var hashTypeMod = hashType & -129;
    $bhJ7Q(hashTypeMod > 0x00 && hashTypeMod < 0x04, "Invalid hashType");
    return {
        signature: $4b245b891e96832c$var$ECSignature.fromDER(buffer.slice(0, -1)),
        hashType: hashType
    };
};
module.exports = $4b245b891e96832c$var$ECSignature;

});




parcelRegister("cGPwy", function(module, exports) {
// const Aes = require("./aes")

var $6CIJR = parcelRequire("6CIJR");

var $d3MuN = parcelRequire("d3MuN");

var $9maPk = parcelRequire("9maPk");

var $9YYFe = parcelRequire("9YYFe");
module.exports = {
    PrivateKey: $6CIJR,
    PublicKey: $d3MuN,
    Signature: $9maPk,
    key_utils: $9YYFe
};

});




parcelRegister("azagM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hZS7n = parcelRequire("hZS7n");

var $jRkuS = parcelRequire("jRkuS");

var $jOsMe = parcelRequire("jOsMe");
var $7b1523a11206f08b$require$PublicKey = $jOsMe.PublicKey;
/**
    Hashes a public key to a valid FIOIO account name.

    @arg {string} pubkey
    @return {string} valid FIOIO account name
*/ function $7b1523a11206f08b$var$accountHash(pubkey) {
    if (!$7b1523a11206f08b$require$PublicKey.isValid(pubkey, "FIO")) throw new TypeError("invalid public key");
    pubkey = pubkey.substring(3, pubkey.length);
    var decoded58 = $hZS7n.decode(pubkey);
    var long = $7b1523a11206f08b$var$shortenKey(decoded58);
    var output = $7b1523a11206f08b$var$stringFromUInt64T(long);
    return output;
}
module.exports.accountHash = $7b1523a11206f08b$var$accountHash;
function $7b1523a11206f08b$var$shortenKey(key) {
    var res = $jRkuS.fromValue(0, true);
    var temp = $jRkuS.fromValue(0, true);
    var toShift = 0;
    var i = 1;
    var len = 0;
    while(len <= 12){
        //assert(i < 33, "Means the key has > 20 bytes with trailing zeroes...")
        temp = $jRkuS.fromValue(key[i], true).and(len == 12 ? 0x0f : 0x1f);
        if (temp == 0) {
            i += 1;
            continue;
        }
        if (len == 12) toShift = 0;
        else toShift = 5 * (12 - len) - 1;
        temp = $jRkuS.fromValue(temp, true).shiftLeft(toShift);
        res = $jRkuS.fromValue(res, true).or(temp);
        len += 1;
        i += 1;
    }
    return res;
}
function $7b1523a11206f08b$var$stringFromUInt64T(temp) {
    var charmap = ".12345abcdefghijklmnopqrstuvwxyz".split("");
    var str = new Array(13);
    str[12] = charmap[$jRkuS.fromValue(temp, true).and(0x0f)];
    temp = $jRkuS.fromValue(temp, true).shiftRight(4);
    for(var i = 1; i <= 12; i++){
        var c = charmap[$jRkuS.fromValue(temp, true).and(0x1f)];
        str[12 - i] = c;
        temp = $jRkuS.fromValue(temp, true).shiftRight(5);
    }
    var result = str.join("");
    if (result.length > 12) result = result.substring(0, 12);
    return result;
}

});

parcelRegister("6ZrYO", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $516e24d04a2ff66e$require$Buffer = $ihoyg.Buffer;
"use strict";
var $516e24d04a2ff66e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : new P(function(resolve) {
                resolve(result.value);
            }).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $516e24d04a2ff66e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hBqwu = parcelRequire("hBqwu");

var $bF5vy = parcelRequire("bF5vy");

var $c2Udc = parcelRequire("c2Udc");

var $jOsMe = parcelRequire("jOsMe");
var $516e24d04a2ff66e$var$PublicKey = $jOsMe.PublicKey, $516e24d04a2ff66e$var$EccPrivateKey = $jOsMe.PrivateKey;

var $7I41A = parcelRequire("7I41A");

var $cUvgf = parcelRequire("cUvgf");
var $516e24d04a2ff66e$var$fioTypes = $bF5vy.getTypesFromAbi($bF5vy.createInitialTypes(), $7I41A);
/** Convert `value` to binary form. `type` must be a built-in abi type. */ function $516e24d04a2ff66e$var$serialize(serialBuffer, type, value) {
    $516e24d04a2ff66e$var$fioTypes.get(type).serialize(serialBuffer, value);
}
module.exports.serialize = $516e24d04a2ff66e$var$serialize;
/** Convert data in `buffer` to structured form. `type` must be a built-in abi type. */ function $516e24d04a2ff66e$var$deserialize(serialBuffer, type) {
    return $516e24d04a2ff66e$var$fioTypes.get(type).deserialize(serialBuffer);
}
module.exports.deserialize = $516e24d04a2ff66e$var$deserialize;
function $516e24d04a2ff66e$var$createSharedCipher(_a) {
    var _b = _a === void 0 ? {} : _a, privateKey = _b.privateKey, publicKey = _b.publicKey, textEncoder = _b.textEncoder, textDecoder = _b.textDecoder;
    return $516e24d04a2ff66e$var$__awaiter(this, void 0, void 0, function() {
        var sharedSecret;
        return $516e24d04a2ff66e$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    publicKey = $516e24d04a2ff66e$var$PublicKey(publicKey);
                    if (!$c2Udc.isExternalPrivateKey(privateKey)) return [
                        3 /*break*/ ,
                        2
                    ];
                    return [
                        4 /*yield*/ ,
                        privateKey.getSharedSecret(publicKey)
                    ];
                case 1:
                    sharedSecret = _c.sent();
                    return [
                        3 /*break*/ ,
                        3
                    ];
                case 2:
                    sharedSecret = $516e24d04a2ff66e$var$EccPrivateKey(privateKey).getSharedSecret(publicKey);
                    _c.label = 3;
                case 3:
                    return [
                        2 /*return*/ ,
                        new $516e24d04a2ff66e$var$SharedCipher({
                            sharedSecret: sharedSecret,
                            textEncoder: textEncoder,
                            textDecoder: textDecoder
                        })
                    ];
            }
        });
    });
}
module.exports.createSharedCipher = $516e24d04a2ff66e$var$createSharedCipher;
var $516e24d04a2ff66e$var$SharedCipher = /** @class */ function() {
    function SharedCipher(_a) {
        var _b = _a === void 0 ? {} : _a, sharedSecret = _b.sharedSecret, textEncoder = _b.textEncoder, textDecoder = _b.textDecoder;
        this.sharedSecret = sharedSecret;
        this.textEncoder = textEncoder;
        this.textDecoder = textDecoder;
    }
    /**
        Encrypt the content of a FIO message.

        @arg {string} fioContentType - `new_funds_content`, etc
        @arg {object} content
        @arg {Buffer} [IV = randomBytes(16)] - An unpredictable strong random value
            is required and supplied by default.  Unit tests may provide a static value
            to achieve predictable results.
        @return {string} cipher base64
    */ SharedCipher.prototype.encrypt = function(fioContentType, content, IV) {
        var buffer = new $bF5vy.SerialBuffer({
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder
        });
        $516e24d04a2ff66e$var$serialize(buffer, fioContentType, content);
        var message = $516e24d04a2ff66e$require$Buffer.from(buffer.asUint8Array());
        var cipherbuffer = $hBqwu.checkEncrypt(this.sharedSecret, message, IV);
        // checkDecrypt(this.sharedSecret, cipherbuffer);
        return cipherbuffer.toString("base64");
    };
    /**
        Decrypt the content of a FIO message.

        @arg {string} fioContentType - `new_funds_content`, etc
        @arg {object} content - cipher base64
        @return {object} decrypted FIO object
    */ SharedCipher.prototype.decrypt = function(fioContentType, content) {
        var message = $hBqwu.checkDecrypt(this.sharedSecret, $516e24d04a2ff66e$require$Buffer.from(content, "base64"));
        var messageArray = Uint8Array.from(message);
        var buffer = new $bF5vy.SerialBuffer({
            array: messageArray,
            textEncoder: this.textEncoder,
            textDecoder: this.textDecoder
        });
        return $516e24d04a2ff66e$var$deserialize(buffer, fioContentType);
    };
    /**
        @example hashA(PublicKey.toBuffer())
        @arg {string|Buffer} key buffer
        @return {string} hex, one-way hash unique to this SharedCipher and key
    */ SharedCipher.prototype.hashA = function(key) {
        var hash = $cUvgf("sha1", this.sharedSecret).update(key).digest();
        return "0x" + hash.slice(0, 16).toString("hex");
    };
    return SharedCipher;
}();

});
parcelRegister("hBqwu", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $cd0a774a2173c379$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k1gB1 = parcelRequire("k1gB1");

var $5rfiH = parcelRequire("5rfiH");

var $cUvgf = parcelRequire("cUvgf");

var $3FiLE = parcelRequire("3FiLE");
/**
    Provides AES-256-CBC encryption and message authentication. The CBC cipher is
    used for good platform native compatability.

    @see https://security.stackexchange.com/a/63134
    @see https://security.stackexchange.com/a/20493

    @arg {Buffer} secret - See PrivateKey.getSharedSecret()
    @arg {Buffer} message - plaintext
    @arg {Buffer} [IV = randomBytes(16)] - An unpredictable strong random value
        is required and supplied by default.  Unit tests may provide a static value
        to achieve predictable results.

    @throws {Error} IV must be 16 bytes
*/ function $cd0a774a2173c379$var$checkEncrypt(secret, message, IV) {
    var K = $3FiLE("sha512").update(secret).digest();
    var Ke = K.slice(0, 32); // Encryption
    var Km = K.slice(32); // MAC
    if (IV == null) IV = $5rfiH(16);
    else {
        if (IV.length !== 16) throw new TypeError("IV must be 16 bytes");
    }
    // Cipher performs PKCS#5 padded automatically
    var cipher = $k1gB1.createCipheriv("aes-256-cbc", Ke, IV);
    var C = $cd0a774a2173c379$require$Buffer.concat([
        cipher.update(message),
        cipher.final()
    ]);
    // Include in the HMAC input everything that impacts the decryption
    var M = $cUvgf("sha256", Km).update($cd0a774a2173c379$require$Buffer.concat([
        IV,
        C
    ])).digest(); // AuthTag
    return $cd0a774a2173c379$require$Buffer.concat([
        IV,
        C,
        M
    ]);
}
module.exports.checkEncrypt = $cd0a774a2173c379$var$checkEncrypt;
/**
    Provides AES-256-CBC message authentication then decryption.

    @arg {Buffer} secret - See PrivateKey.getSharedSecret()
    @arg {Buffer} message - ciphertext (from checkEncrypt)

    @throws {Error} decrypt failed
*/ function $cd0a774a2173c379$var$checkDecrypt(secret, message) {
    var K = $3FiLE("sha512").update(secret).digest();
    var Ke = K.slice(0, 32); // Encryption
    var Km = K.slice(32); // MAC
    var IV = message.slice(0, 16);
    var C = message.slice(16, message.length - 32);
    var M = message.slice(message.length - 32);
    // Side-channel attack protection: First verify the HMAC, then and only then proceed to the decryption step
    var Mc = $cUvgf("sha256", Km).update($cd0a774a2173c379$require$Buffer.concat([
        IV,
        C
    ])).digest();
    if ($cd0a774a2173c379$require$Buffer.compare(M, Mc) !== 0) throw new Error("decrypt failed");
    // Cipher performs PKCS#5 padded automatically
    var cipher = $k1gB1.createDecipheriv("aes-256-cbc", Ke, IV);
    return $cd0a774a2173c379$require$Buffer.concat([
        cipher.update(C, "binary"),
        cipher.final()
    ]);
}
module.exports.checkDecrypt = $cd0a774a2173c379$var$checkDecrypt;

});

parcelRegister("7I41A", function(module, exports) {
module.exports = JSON.parse('{"version":"eosio::abi/1.0","types":[],"structs":[{"name":"new_funds_content","base":"","fields":[{"name":"payee_public_address","type":"string"},{"name":"amount","type":"string"},{"name":"chain_code","type":"string"},{"name":"token_code","type":"string"},{"name":"memo","type":"string?"},{"name":"hash","type":"string?"},{"name":"offline_url","type":"string?"}]},{"name":"record_obt_data_content","base":"","fields":[{"name":"payer_public_address","type":"string"},{"name":"payee_public_address","type":"string"},{"name":"amount","type":"string"},{"name":"chain_code","type":"string"},{"name":"token_code","type":"string"},{"name":"status","type":"string"},{"name":"obt_id","type":"string"},{"name":"memo","type":"string?"},{"name":"hash","type":"string?"},{"name":"offline_url","type":"string?"}]}]}');

});



parcelRegister("lTpt4", function(module, exports) {
"use strict";
// copyright defined in fiojs/LICENSE.txt
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("03gud", function(module, exports) {
"use strict";
// copyright defined in fiojs/LICENSE.txt
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("hXehy", function(module, exports) {
"use strict";
/**
 * @module RPC-Error
 */ // copyright defined in fiojs/LICENSE.txt
var $d123067f0d586ec5$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/** Holds detailed error information */ var $d123067f0d586ec5$var$RpcError = /** @class */ function(_super) {
    $d123067f0d586ec5$var$__extends(RpcError, _super);
    function RpcError(json) {
        var _this = this;
        if (json.error && json.error.details && json.error.details.length && json.error.details[0].message) _this = _super.call(this, json.error.details[0].message) || this;
        else if (json.processed && json.processed.except && json.processed.except.message) _this = _super.call(this, json.processed.except.message) || this;
        else _this = _super.call(this, json.message) || this;
        Object.setPrototypeOf(_this, RpcError.prototype);
        _this.json = json;
        return _this;
    }
    return RpcError;
}(Error);
module.exports.RpcError = $d123067f0d586ec5$var$RpcError;

});


parcelRegister("2NvO7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EndPoint = void 0;
var $2098d4abf693c677$var$EndPoint;
(function(EndPoint) {
    EndPoint["newFundsRequest"] = "new_funds_request";
    EndPoint["registerFioAddress"] = "register_fio_address";
    EndPoint["registerFioDomain"] = "register_fio_domain";
    EndPoint["renewFioDomain"] = "renew_fio_domain";
    EndPoint["renewFioAddress"] = "renew_fio_address";
    EndPoint["burnFioAddress"] = "burn_fio_address";
    EndPoint["transferFioAddress"] = "transfer_fio_address";
    EndPoint["transferFioDomain"] = "transfer_fio_domain";
    EndPoint["addPubAddress"] = "add_pub_address";
    EndPoint["removePubAddress"] = "remove_pub_address";
    EndPoint["removeAllPubAddresses"] = "remove_all_pub_addresses";
    EndPoint["setFioDomainPublic"] = "set_fio_domain_public";
    EndPoint["rejectFundsRequest"] = "reject_funds_request";
    EndPoint["recordObtData"] = "record_obt_data";
    EndPoint["transferTokens"] = "transfer_tokens_pub_key";
    EndPoint["cancelFundsRequest"] = "cancel_funds_request";
})($2098d4abf693c677$var$EndPoint = module.exports.EndPoint || (module.exports.EndPoint = {}));

});

parcelRegister("PZcro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $19crV = parcelRequire("19crV");
Object.defineProperty(module.exports, "AvailabilityCheck", {
    enumerable: true,
    get: function() {
        return $19crV.AvailabilityCheck;
    }
});

var $8nesY = parcelRequire("8nesY");
Object.defineProperty(module.exports, "GetPublicAddress", {
    enumerable: true,
    get: function() {
        return $8nesY.GetPublicAddress;
    }
});

var $hZI5S = parcelRequire("hZI5S");
Object.defineProperty(module.exports, "SentFioRequests", {
    enumerable: true,
    get: function() {
        return $hZI5S.SentFioRequests;
    }
});

var $glTRs = parcelRequire("glTRs");
Object.defineProperty(module.exports, "GetNames", {
    enumerable: true,
    get: function() {
        return $glTRs.GetNames;
    }
});

var $ja3UY = parcelRequire("ja3UY");
Object.defineProperty(module.exports, "GetFioBalance", {
    enumerable: true,
    get: function() {
        return $ja3UY.GetFioBalance;
    }
});

var $lScxz = parcelRequire("lScxz");
Object.defineProperty(module.exports, "PendingFioRequests", {
    enumerable: true,
    get: function() {
        return $lScxz.PendingFioRequests;
    }
});

var $hnokO = parcelRequire("hnokO");
Object.defineProperty(module.exports, "GetFee", {
    enumerable: true,
    get: function() {
        return $hnokO.GetFee;
    }
});

var $i7uaM = parcelRequire("i7uaM");
Object.defineProperty(module.exports, "GetAbi", {
    enumerable: true,
    get: function() {
        return $i7uaM.GetAbi;
    }
});

var $4vVnW = parcelRequire("4vVnW");
Object.defineProperty(module.exports, "GetObtData", {
    enumerable: true,
    get: function() {
        return $4vVnW.GetObtData;
    }
});

var $lq7tX = parcelRequire("lq7tX");
Object.defineProperty(module.exports, "CancelledFioRequests", {
    enumerable: true,
    get: function() {
        return $lq7tX.CancelledFioRequests;
    }
});

var $zHZDk = parcelRequire("zHZDk");
Object.defineProperty(module.exports, "GetAddresses", {
    enumerable: true,
    get: function() {
        return $zHZDk.GetAddresses;
    }
});

var $kyHUp = parcelRequire("kyHUp");
Object.defineProperty(module.exports, "GetDomains", {
    enumerable: true,
    get: function() {
        return $kyHUp.GetDomains;
    }
});

});
parcelRegister("19crV", function(module, exports) {
"use strict";
var $0d6049e842ecb0ec$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AvailabilityCheck = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $0d6049e842ecb0ec$var$AvailabilityCheck extends $ksv7D.Query {
    constructor(fioName){
        super();
        this.ENDPOINT = "chain/avail_check";
        this.fioName = fioName;
    }
    getData() {
        return $0d6049e842ecb0ec$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_name: this.fioName
            };
        });
    }
}
module.exports.AvailabilityCheck = $0d6049e842ecb0ec$var$AvailabilityCheck;

});
parcelRegister("ksv7D", function(module, exports) {
"use strict";
var $ee4e905cd0999a34$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Query = void 0;

var $dtGp3 = parcelRequire("dtGp3");
class $ee4e905cd0999a34$var$Query extends $dtGp3.Transactions {
    constructor(){
        super(...arguments);
        this.isEncrypted = false;
    }
    decrypt(result) {
        return $ee4e905cd0999a34$var$__awaiter(this, void 0, void 0, function*() {});
    }
    execute(publicKey, privateKey = "") {
        return $ee4e905cd0999a34$var$__awaiter(this, void 0, void 0, function*() {
            this.publicKey = publicKey;
            this.privateKey = privateKey;
            if (!this.isEncrypted) return this.executeCall(this.getEndPoint(), JSON.stringify((yield this.getData())));
            else try {
                const result = yield this.executeCall(this.getEndPoint(), JSON.stringify((yield this.getData())));
                return yield this.decrypt(result);
            } catch (error) {
                throw error;
            }
        });
    }
    getEndPoint() {
        return this.ENDPOINT;
    }
}
module.exports.Query = $ee4e905cd0999a34$var$Query;

});
parcelRegister("dtGp3", function(module, exports) {
"use strict";
var $9cfee02d5df5b582$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transactions = void 0;

var $fXcze = parcelRequire("fXcze");

var $3Ea7J = parcelRequire("3Ea7J");

var $jxok1 = parcelRequire("jxok1");

var $g14qE = parcelRequire("g14qE");
const $9cfee02d5df5b582$var$textEncoder = new $3Ea7J.TextEncoder();
const $9cfee02d5df5b582$var$textDecoder = new $3Ea7J.TextDecoder();
class $9cfee02d5df5b582$var$Transactions {
    constructor(){
        this.publicKey = "";
        this.privateKey = "";
        this.serilizeEndpoint = "chain/serialize_json";
        this.validationData = {};
        this.validationRules = null;
    }
    getActor(publicKey = "") {
        const actor = $9cfee02d5df5b582$var$Transactions.FioProvider.accountHash(publicKey == "" ? this.publicKey : publicKey);
        return actor;
    }
    getChainInfo() {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            const options = {
                method: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                }
            };
            const res = yield $9cfee02d5df5b582$var$Transactions.fetchJson($9cfee02d5df5b582$var$Transactions.baseUrl + "chain/get_info", options);
            return yield res.json();
        });
    }
    getBlock(chain) {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            if (chain == undefined) throw new Error("chain undefined");
            if (chain.last_irreversible_block_num == undefined) throw new Error("chain.last_irreversible_block_num undefined");
            const res = yield $9cfee02d5df5b582$var$Transactions.fetchJson($9cfee02d5df5b582$var$Transactions.baseUrl + "chain/get_block", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    block_num_or_id: chain.last_irreversible_block_num
                })
            });
            return yield res.json();
        });
    }
    pushToServer(transaction, endpoint, dryRun) {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            const privky = new Array();
            privky.push(this.privateKey);
            let chain, block;
            try {
                chain = yield this.getChainInfo();
            } catch (error) {
                console.error("chain:: " + error);
                const e = new Error(`Error while fetching chain info`);
                e.errorCode = 800;
                throw e;
            }
            try {
                block = yield this.getBlock(chain);
            } catch (error) {
                console.error("block: " + error);
                const e = new Error(`Error while fetching block`);
                e.errorCode = 801;
                throw e;
            }
            transaction.ref_block_num = block.block_num & 0xFFFF;
            transaction.ref_block_prefix = block.ref_block_prefix;
            const expiration = new Date(chain.head_block_time + "Z");
            expiration.setSeconds(expiration.getSeconds() + 180);
            const expirationStr = expiration.toISOString();
            transaction.expiration = expirationStr.substr(0, expirationStr.length - 1);
            if (dryRun) return $9cfee02d5df5b582$var$Transactions.FioProvider.prepareTransaction({
                transaction: transaction,
                chainId: chain.chain_id,
                privateKeys: privky,
                abiMap: $9cfee02d5df5b582$var$Transactions.abiMap,
                textDecoder: new $3Ea7J.TextDecoder(),
                textEncoder: new $3Ea7J.TextEncoder()
            });
            else {
                const signedTransaction = yield $9cfee02d5df5b582$var$Transactions.FioProvider.prepareTransaction({
                    transaction: transaction,
                    chainId: chain.chain_id,
                    privateKeys: privky,
                    abiMap: $9cfee02d5df5b582$var$Transactions.abiMap,
                    textDecoder: new $3Ea7J.TextDecoder(),
                    textEncoder: new $3Ea7J.TextEncoder()
                });
                return this.executeCall(endpoint, JSON.stringify(signedTransaction));
            }
        });
    }
    executeCall(endPoint, body, fetchOptions) {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            let options;
            this.validate();
            if (fetchOptions != null) {
                options = fetchOptions;
                if (body != null) options.body = body;
            } else options = {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: body
            };
            try {
                const res = yield $9cfee02d5df5b582$var$Transactions.fetchJson($9cfee02d5df5b582$var$Transactions.baseUrl + endPoint, options);
                if (!res.ok) {
                    const error = new Error(`Error ${res.status} while fetching ${$9cfee02d5df5b582$var$Transactions.baseUrl + endPoint}`);
                    try {
                        error.json = yield res.json();
                    } catch (e) {
                        console.log(e);
                        error.json = {};
                    }
                    error.errorCode = res.status;
                    throw error;
                }
                return res.json();
            } catch (e) {
                e.requestParams = {
                    endPoint: endPoint,
                    body: body,
                    fetchOptions: fetchOptions
                };
                throw e;
            }
        });
    }
    getCipherContent(contentType, content, privateKey, publicKey, iv) {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            const cipher = yield $fXcze.Fio.createSharedCipher({
                privateKey: privateKey,
                publicKey: publicKey,
                textEncoder: $9cfee02d5df5b582$var$textEncoder,
                textDecoder: $9cfee02d5df5b582$var$textDecoder
            });
            return cipher.encrypt(contentType, content, iv);
        });
    }
    getUnCipherContent(contentType, content, privateKey, publicKey) {
        return $9cfee02d5df5b582$var$__awaiter(this, void 0, void 0, function*() {
            const cipher = yield $fXcze.Fio.createSharedCipher({
                privateKey: privateKey,
                publicKey: publicKey,
                textEncoder: $9cfee02d5df5b582$var$textEncoder,
                textDecoder: $9cfee02d5df5b582$var$textDecoder
            });
            return cipher.decrypt(contentType, content);
        });
    }
    validate() {
        if (this.validationRules) {
            const validation = $g14qE.validate(this.validationData, this.validationRules);
            if (!validation.isValid) throw new $jxok1.ValidationError(validation.errors, `Validation error`);
        }
    }
}
module.exports.Transactions = $9cfee02d5df5b582$var$Transactions;
$9cfee02d5df5b582$var$Transactions.abiMap = new Map();

});
parcelRegister("jxok1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValidationError = void 0;
class $e393f73427b7232a$var$ValidationError extends Error {
    constructor(list, ...params){
        super(...params);
        this.list = [];
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e393f73427b7232a$var$ValidationError);
        this.name = "ValidationError";
        this.list = list;
    }
}
module.exports.ValidationError = $e393f73427b7232a$var$ValidationError;

});

parcelRegister("g14qE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validate = module.exports.validationRules = module.exports.allRules = void 0;

var $9MiAi = parcelRequire("9MiAi");
module.exports.allRules = {
    chain: {
        required: true,
        type: String,
        length: {
            min: 1,
            max: 10
        },
        matchParams: {
            regex: "^[a-z0-9]+$",
            opt: "i"
        }
    },
    fioAddress: {
        required: true,
        type: String,
        length: {
            min: 3,
            max: 64
        },
        matchParams: {
            regex: "^(?:(?=.{3,64}$)[a-zA-Z0-9]{1}(?:(?:(?!-{2,}))[a-zA-Z0-9-]*[a-zA-Z0-9]+){0,1}@[a-zA-Z0-9]{1}(?:(?:(?!-{2,}))[a-zA-Z0-9-]*[a-zA-Z0-9]+){0,1}$)",
            opt: "gim"
        }
    },
    tpid: {
        type: String,
        length: {
            min: 3,
            max: 64
        },
        matchParams: {
            regex: "^(?:(?=.{3,64}$)[a-zA-Z0-9]{1}(?:(?:(?!-{2,}))[a-zA-Z0-9-]*[a-zA-Z0-9]+){0,1}@[a-zA-Z0-9]{1}(?:(?:(?!-{2,}))[a-zA-Z0-9-]*[a-zA-Z0-9]+){0,1}$)",
            opt: "gim"
        }
    },
    fioDomain: {
        required: true,
        type: String,
        length: {
            min: 1,
            max: 62
        },
        matchParams: {
            regex: "^[a-z0-9\\-]+$",
            opt: "i"
        }
    },
    fioPublicKey: {
        required: true,
        type: String,
        length: {
            min: 1,
            max: 62
        },
        matchParams: {
            regex: "^FIO\\w+$"
        }
    },
    nativeBlockchainPublicAddress: {
        required: true,
        type: String,
        length: {
            min: 1,
            max: 128
        },
        matchParams: {
            regex: "^\\w+$"
        }
    }
};
module.exports.validationRules = {
    addPublicAddressRules: {
        fioAddress: module.exports.allRules.fioAddress,
        tpid: module.exports.allRules.tpid
    },
    cancelFundsRequestRules: {
        tpid: module.exports.allRules.tpid
    },
    registerFioAddress: {
        fioAddress: module.exports.allRules.fioAddress,
        tpid: module.exports.allRules.tpid
    },
    registerFioDomain: {
        fioDomain: module.exports.allRules.fioDomain,
        tpid: module.exports.allRules.tpid
    },
    renewFioAddress: {
        fioAddress: module.exports.allRules.fioAddress,
        tpid: module.exports.allRules.tpid
    },
    renewFioDomain: {
        fioDomain: module.exports.allRules.fioDomain,
        tpid: module.exports.allRules.tpid
    },
    setFioDomainVisibility: {
        fioDomain: module.exports.allRules.fioDomain,
        tpid: module.exports.allRules.tpid
    },
    newFundsRequest: {
        payerFioAddress: module.exports.allRules.fioAddress,
        payeeFioAddress: module.exports.allRules.fioAddress,
        tokenCode: module.exports.allRules.chain,
        tpid: module.exports.allRules.tpid
    },
    rejectFunds: {
        tpid: module.exports.allRules.tpid
    },
    recordObtData: {
        payerFioAddress: module.exports.allRules.fioAddress,
        payeeFioAddress: module.exports.allRules.fioAddress,
        tpid: module.exports.allRules.tpid,
        tokenCode: module.exports.allRules.chain
    },
    transferTokens: {
        tpid: module.exports.allRules.tpid
    },
    getFee: {
        fioAddress: module.exports.allRules.fioAddress
    }
};
function $ba902cd27619b827$var$validate(data, rules) {
    const schema = {};
    for(const ruleKey in rules){
        schema[ruleKey] = Object.assign({}, rules[ruleKey]);
        if (rules[ruleKey].matchParams && rules[ruleKey].matchParams.regex) {
            schema[ruleKey].match = new RegExp(rules[ruleKey].matchParams.regex, rules[ruleKey].matchParams.opt);
            delete schema[ruleKey].matchParams;
        }
    }
    const validator = new $9MiAi(schema);
    const errors = validator.validate(data);
    const validationResult = {
        isValid: true,
        errors: []
    };
    if (errors.length) {
        validationResult.isValid = false;
        validationResult.errors = errors.map((err)=>({
                field: err.path,
                message: err.message
            }));
    }
    return validationResult;
}
module.exports.validate = $ba902cd27619b827$var$validate;

});
parcelRegister("9MiAi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $71e703419a8e6e56$var$_componentType = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("5G6Ji")));

var $71e703419a8e6e56$var$_eivindfjeldstadDot = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("kOsLh")));

var $71e703419a8e6e56$var$_typecast = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("6Zab4")));

var $71e703419a8e6e56$var$_property = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("gCyLz")));

var $71e703419a8e6e56$var$_messages = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("kwqQW")));

var $71e703419a8e6e56$var$_validators = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("6AqR8")));

var $71e703419a8e6e56$var$_error = $71e703419a8e6e56$var$_interopRequireDefault((parcelRequire("9z9wJ")));

var $8MROJ = parcelRequire("8MROJ");
function $71e703419a8e6e56$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $71e703419a8e6e56$var$_slicedToArray(arr, i) {
    return $71e703419a8e6e56$var$_arrayWithHoles(arr) || $71e703419a8e6e56$var$_iterableToArrayLimit(arr, i) || $71e703419a8e6e56$var$_nonIterableRest();
}
function $71e703419a8e6e56$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $71e703419a8e6e56$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $71e703419a8e6e56$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $71e703419a8e6e56$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $71e703419a8e6e56$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $71e703419a8e6e56$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $71e703419a8e6e56$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $71e703419a8e6e56$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * A Schema defines the structure that objects should be validated against.
 *
 * @example
 * const post = new Schema({
 *   title: {
 *     type: String,
 *     required: true,
 *     length: { min: 1, max: 255 }
 *   },
 *   content: {
 *     type: String,
 *     required: true
 *   },
 *   published: {
 *     type: Date,
 *     required: true
 *   },
 *   keywords: [{ type: String }]
 * })
 *
 * @example
 * const author = new Schema({
 *   name: {
 *     type: String,
 *     required: true
 *   },
 *   email: {
 *     type: String,
 *     required: true
 *   },
 *   posts: [post]
 * })
 *
 * @param {Object} [obj] - schema definition
 * @param {Object} [opts] - options
 * @param {Boolean} [opts.typecast=false] - typecast values before validation
 * @param {Boolean} [opts.strip=true] - strip properties not defined in the schema
 */ var $71e703419a8e6e56$var$Schema = /*#__PURE__*/ function() {
    function Schema() {
        var _this = this;
        var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        $71e703419a8e6e56$var$_classCallCheck(this, Schema);
        this.opts = opts;
        this.hooks = [];
        this.props = {};
        this.messages = Object.assign({}, $71e703419a8e6e56$var$_messages["default"]);
        this.validators = Object.assign({}, $71e703419a8e6e56$var$_validators["default"]);
        this.typecasters = Object.assign({}, $71e703419a8e6e56$var$_typecast["default"]);
        Object.keys(obj).forEach(function(k) {
            return _this.path(k, obj[k]);
        });
    }
    /**
   * Create or update `path` with given `rules`.
   *
   * @example
   * const schema = new Schema()
   * schema.path('name.first', { type: String })
   * schema.path('name.last').type(String).required()
   *
   * @param {String} path - full path using dot-notation
   * @param {Object|Array|String|Schema|Property} [rules] - rules to apply
   * @return {Property}
   */ $71e703419a8e6e56$var$_createClass(Schema, [
        {
            key: "path",
            value: function path(_path, rules) {
                var _this2 = this;
                var parts = _path.split(".");
                var suffix = parts.pop();
                var prefix = parts.join("."); // Make sure full path is created
                if (prefix) this.path(prefix);
                 // Array index placeholder
                if (suffix === "$") this.path(prefix).type(Array);
                 // Nested schema
                if (rules instanceof Schema) {
                    rules.hook(function(k, v) {
                        return _this2.path((0, $8MROJ.join)(k, _path), v);
                    });
                    return this.path(_path, rules.props);
                } // Return early when given a `Property`
                if (rules instanceof $71e703419a8e6e56$var$_property["default"]) {
                    this.props[_path] = rules; // Notify parents if mounted
                    this.propagate(_path, rules);
                    return rules;
                }
                var prop = this.props[_path] || new $71e703419a8e6e56$var$_property["default"](_path, this);
                this.props[_path] = prop; // Notify parents if mounted
                this.propagate(_path, prop); // No rules?
                if (!rules) return prop; // type shorthand
                // `{ name: String }`
                if (typeof rules == "string" || typeof rules == "function") {
                    prop.type(rules);
                    return prop;
                } // Allow arrays to be passed implicitly:
                // `{ keywords: [String] }`
                // `{ keyVal: [[String, Number]] }`
                if (Array.isArray(rules)) {
                    prop.type(Array);
                    if (rules.length === 1) prop.each(rules[0]);
                    else prop.elements(rules);
                    return prop;
                }
                var nested = false; // Check for nested objects
                for(var key in rules){
                    if (!rules.hasOwnProperty(key)) continue;
                    if (typeof prop[key] == "function") continue;
                    prop.type(Object);
                    nested = true;
                    break;
                }
                Object.keys(rules).forEach(function(key) {
                    var rule = rules[key];
                    if (nested) return _this2.path((0, $8MROJ.join)(key, _path), rule);
                    prop[key](rule);
                });
                return prop;
            }
        },
        {
            key: "typecast",
            value: function typecast(obj) {
                var _loop = function _loop() {
                    var _Object$entries$_i = $71e703419a8e6e56$var$_slicedToArray(_Object$entries[_i], 2), path = _Object$entries$_i[0], prop = _Object$entries$_i[1];
                    (0, $8MROJ.walk)(path, obj, function(key, value) {
                        if (value == null) return;
                        var cast = prop.typecast(value);
                        if (cast === value) return;
                        $71e703419a8e6e56$var$_eivindfjeldstadDot["default"].set(obj, key, cast);
                    });
                };
                for(var _i = 0, _Object$entries = Object.entries(this.props); _i < _Object$entries.length; _i++)_loop();
                return this;
            }
        },
        {
            key: "strip",
            value: function strip(obj, prefix) {
                var _this3 = this;
                var type = (0, $71e703419a8e6e56$var$_componentType["default"])(obj);
                if (type === "array") {
                    obj.forEach(function(v, i) {
                        return _this3.strip(v, (0, $8MROJ.join)("$", prefix));
                    });
                    return this;
                }
                if (type !== "object") return this;
                for(var _i2 = 0, _Object$entries2 = Object.entries(obj); _i2 < _Object$entries2.length; _i2++){
                    var _Object$entries2$_i = $71e703419a8e6e56$var$_slicedToArray(_Object$entries2[_i2], 2), key = _Object$entries2$_i[0], val = _Object$entries2$_i[1];
                    var path = (0, $8MROJ.join)(key, prefix);
                    if (!this.props[path]) {
                        delete obj[key];
                        continue;
                    }
                    this.strip(val, path);
                }
                return this;
            }
        },
        {
            key: "validate",
            value: function validate(obj) {
                var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                opts = Object.assign(this.opts, opts);
                var errors = [];
                if (opts.typecast) this.typecast(obj);
                if (opts.strip !== false) this.strip(obj);
                var _loop2 = function _loop2() {
                    var _Object$entries3$_i = $71e703419a8e6e56$var$_slicedToArray(_Object$entries3[_i3], 2), path = _Object$entries3$_i[0], prop = _Object$entries3$_i[1];
                    (0, $8MROJ.walk)(path, obj, function(key, value) {
                        var err = prop.validate(value, obj, key);
                        if (err) errors.push(err);
                    });
                };
                for(var _i3 = 0, _Object$entries3 = Object.entries(this.props); _i3 < _Object$entries3.length; _i3++)_loop2();
                return errors;
            }
        },
        {
            key: "assert",
            value: function assert(obj, opts) {
                var _this$validate = this.validate(obj, opts), _this$validate2 = $71e703419a8e6e56$var$_slicedToArray(_this$validate, 1), err = _this$validate2[0];
                if (err) throw err;
            }
        },
        {
            key: "message",
            value: function message(name, _message) {
                (0, $8MROJ.assign)(name, _message, this.messages);
                return this;
            }
        },
        {
            key: "validator",
            value: function validator(name, fn) {
                (0, $8MROJ.assign)(name, fn, this.validators);
                return this;
            }
        },
        {
            key: "typecaster",
            value: function typecaster(name, fn) {
                (0, $8MROJ.assign)(name, fn, this.typecasters);
                return this;
            }
        },
        {
            key: "hook",
            value: function hook(fn) {
                this.hooks.push(fn);
                return this;
            }
        },
        {
            key: "propagate",
            value: function propagate(path, prop) {
                this.hooks.forEach(function(fn) {
                    return fn(path, prop);
                });
                return this;
            }
        }
    ]);
    return Schema;
}(); // Export ValidationError
module.exports["default"] = $71e703419a8e6e56$var$Schema;
$71e703419a8e6e56$var$Schema.ValidationError = $71e703419a8e6e56$var$_error["default"];
module.exports = module.exports.default;

});
parcelRegister("5G6Ji", function(module, exports) {
/**
 * toString ref.
 */ var $4226185a0348c722$var$toString = Object.prototype.toString;
/**
 * Return the type of `val`.
 *
 * @param {Mixed} val
 * @return {String}
 * @api public
 */ module.exports = function(val) {
    switch($4226185a0348c722$var$toString.call(val)){
        case "[object Date]":
            return "date";
        case "[object RegExp]":
            return "regexp";
        case "[object Arguments]":
            return "arguments";
        case "[object Array]":
            return "array";
        case "[object Error]":
            return "error";
    }
    if (val === null) return "null";
    if (val === undefined) return "undefined";
    if (val !== val) return "nan";
    if (val && val.nodeType === 1) return "element";
    if ($4226185a0348c722$var$isBuffer(val)) return "buffer";
    val = val.valueOf ? val.valueOf() : Object.prototype.valueOf.apply(val);
    return typeof val;
};
// code borrowed from https://github.com/feross/is-buffer/blob/master/index.js
function $4226185a0348c722$var$isBuffer(obj) {
    return !!(obj != null && (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
    obj.constructor && typeof obj.constructor.isBuffer === "function" && obj.constructor.isBuffer(obj)));
}

});

parcelRegister("kOsLh", function(module, exports) {

$parcel$export(module.exports, "set", function () { return $f26ec9a14aa867c3$export$adaa4cf7ef1b65be; }, function (v) { return $f26ec9a14aa867c3$export$adaa4cf7ef1b65be = v; });
$parcel$export(module.exports, "get", function () { return $f26ec9a14aa867c3$export$3988ae62b71be9a3; }, function (v) { return $f26ec9a14aa867c3$export$3988ae62b71be9a3 = v; });
/**
 * Set given `path`
 *
 * @param {Object} obj
 * @param {String} path
 * @param {Mixed} val
 * @api public
 */ var $f26ec9a14aa867c3$export$adaa4cf7ef1b65be;
/**
 * Get given `path`
 *
 * @param {Object} obj
 * @param {String} path
 * @return {Mixed}
 * @api public
 */ var $f26ec9a14aa867c3$export$3988ae62b71be9a3;
$f26ec9a14aa867c3$export$adaa4cf7ef1b65be = function(obj, path, val) {
    var segs = path.split(".");
    var attr = segs.pop();
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        obj[seg] = obj[seg] || {};
        obj = obj[seg];
    }
    obj[attr] = val;
};
$f26ec9a14aa867c3$export$3988ae62b71be9a3 = function(obj, path) {
    var segs = path.split(".");
    var attr = segs.pop();
    for(var i = 0; i < segs.length; i++){
        var seg = segs[i];
        if (!obj[seg]) return;
        obj = obj[seg];
    }
    return obj[attr];
};

});

parcelRegister("6Zab4", function(module, exports) {
module.exports = $5160559be031f5c8$var$typecast;
/**
 * Cast given `val` to `type`
 *
 * @param {Mixed} val
 * @param {String} type
 * @api public
 */ function $5160559be031f5c8$var$typecast(val, type) {
    var fn = $5160559be031f5c8$var$typecast[type];
    if (typeof fn != "function") throw new Error("cannot cast to " + type);
    return fn(val);
}
/**
 * Cast `val` to `String`
 *
 * @param {Mixed} val
 * @api public
 */ $5160559be031f5c8$var$typecast.string = function(val) {
    return val.toString();
};
/**
 * Cast `val` to `Number`
 *
 * @param {Mixed} val
 * @api public
 */ $5160559be031f5c8$var$typecast.number = function(val) {
    var num = parseFloat(val);
    return isNaN(num) ? null : num;
};
/**
 * Cast `val` to a`Date`
 *
 * @param {Mixed} val
 * @api public
 */ $5160559be031f5c8$var$typecast.date = function(val) {
    var date = new Date(val);
    return isNaN(date.valueOf()) ? null : date;
};
/**
 * Cast `val` to `Array`
 *
 * @param {Mixed} val
 * @api public
 */ $5160559be031f5c8$var$typecast.array = function(val) {
    if (val instanceof Array) return val;
    var arr = val.toString().split(",");
    for(var i = 0; i < arr.length; i++)arr[i] = arr[i].trim();
    return arr;
};
/**
 * Cast `val` to `Boolean`
 *
 * @param {Mixed} val
 * @api public
 */ $5160559be031f5c8$var$typecast.boolean = function(val) {
    return !!val && val !== "false";
};

});

parcelRegister("gCyLz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $c19b29c9b23af798$var$_error2 = $c19b29c9b23af798$var$_interopRequireDefault((parcelRequire("9z9wJ")));

var $8MROJ = parcelRequire("8MROJ");
function $c19b29c9b23af798$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $c19b29c9b23af798$var$_toConsumableArray(arr) {
    return $c19b29c9b23af798$var$_arrayWithoutHoles(arr) || $c19b29c9b23af798$var$_iterableToArray(arr) || $c19b29c9b23af798$var$_nonIterableSpread();
}
function $c19b29c9b23af798$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function $c19b29c9b23af798$var$_iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function $c19b29c9b23af798$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    }
}
function $c19b29c9b23af798$var$_slicedToArray(arr, i) {
    return $c19b29c9b23af798$var$_arrayWithHoles(arr) || $c19b29c9b23af798$var$_iterableToArrayLimit(arr, i) || $c19b29c9b23af798$var$_nonIterableRest();
}
function $c19b29c9b23af798$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function $c19b29c9b23af798$var$_iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c19b29c9b23af798$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c19b29c9b23af798$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c19b29c9b23af798$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c19b29c9b23af798$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c19b29c9b23af798$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c19b29c9b23af798$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
/**
 * A property instance gets returned whenever you call `schema.path()`.
 * Properties are also created internally when an object is passed to the Schema constructor.
 *
 * @param {String} name - the name of the property
 * @param {Schema} schema - parent schema
 */ var $c19b29c9b23af798$var$Property = /*#__PURE__*/ function() {
    function Property(name, schema) {
        $c19b29c9b23af798$var$_classCallCheck(this, Property);
        this.name = name;
        this.registry = {};
        this._schema = schema;
        this._type = null;
        this.messages = {};
    }
    /**
   * Registers messages.
   *
   * @example
   * prop.message('something is wrong')
   * prop.message({ required: 'thing is required.' })
   *
   * @param {Object|String} messages
   * @return {Property}
   */ $c19b29c9b23af798$var$_createClass(Property, [
        {
            key: "message",
            value: function message(messages) {
                if (typeof messages == "string") messages = {
                    "default": messages
                };
                var entries = Object.entries(messages);
                for(var _i = 0, _entries = entries; _i < _entries.length; _i++){
                    var _entries$_i = $c19b29c9b23af798$var$_slicedToArray(_entries[_i], 2), key = _entries$_i[0], val = _entries$_i[1];
                    this.messages[key] = val;
                }
                return this;
            }
        },
        {
            key: "schema",
            value: function schema(_schema) {
                this._schema.path(this.name, _schema);
                return this;
            }
        },
        {
            key: "use",
            value: function use(fns) {
                var _this = this;
                Object.keys(fns).forEach(function(name) {
                    var arr = fns[name];
                    if (!Array.isArray(arr)) arr = [
                        arr
                    ];
                    var fn = arr.shift();
                    _this._register(name, arr, fn);
                });
                return this;
            }
        },
        {
            key: "required",
            value: function required() {
                var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                return this._register("required", [
                    bool
                ]);
            }
        },
        {
            key: "type",
            value: function type(_type) {
                this._type = _type;
                return this._register("type", [
                    _type
                ]);
            }
        },
        {
            key: "string",
            value: function string() {
                return this.type(String);
            }
        },
        {
            key: "number",
            value: function number() {
                return this.type(Number);
            }
        },
        {
            key: "array",
            value: function array() {
                return this.type(Array);
            }
        },
        {
            key: "date",
            value: function date() {
                return this.type(Date);
            }
        },
        {
            key: "length",
            value: function length(rules) {
                return this._register("length", [
                    rules
                ]);
            }
        },
        {
            key: "size",
            value: function size(rules) {
                return this._register("size", [
                    rules
                ]);
            }
        },
        {
            key: "enum",
            value: function _enum(enums) {
                return this._register("enum", [
                    enums
                ]);
            }
        },
        {
            key: "match",
            value: function match(regexp) {
                return this._register("match", [
                    regexp
                ]);
            }
        },
        {
            key: "each",
            value: function each(rules) {
                this._schema.path((0, $8MROJ.join)("$", this.name), rules);
                return this;
            }
        },
        {
            key: "elements",
            value: function elements(arr) {
                var _this2 = this;
                arr.forEach(function(rules, i) {
                    _this2._schema.path((0, $8MROJ.join)(i, _this2.name), rules);
                });
                return this;
            }
        },
        {
            key: "properties",
            value: function properties(props) {
                for(var _i2 = 0, _Object$entries = Object.entries(props); _i2 < _Object$entries.length; _i2++){
                    var _Object$entries$_i = $c19b29c9b23af798$var$_slicedToArray(_Object$entries[_i2], 2), prop = _Object$entries$_i[0], rule = _Object$entries$_i[1];
                    this._schema.path((0, $8MROJ.join)(prop, this.name), rule);
                }
                return this;
            }
        },
        {
            key: "path",
            value: function path() {
                var _this$_schema;
                return (_this$_schema = this._schema).path.apply(_this$_schema, arguments);
            }
        },
        {
            key: "typecast",
            value: function typecast(value) {
                var schema = this._schema;
                var type = this._type;
                if (!type) return value;
                if (typeof type == "function") type = type.name;
                var cast = schema.typecasters[type] || schema.typecasters[type.toLowerCase()];
                if (typeof cast != "function") throw new Error("Typecasting failed: No typecaster defined for ".concat(type, "."));
                return cast(value);
            }
        },
        {
            key: "validate",
            value: function validate(value, ctx) {
                var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.name;
                var types = Object.keys(this.registry);
                for(var _i3 = 0, _types = types; _i3 < _types.length; _i3++){
                    var type = _types[_i3];
                    var err = this._run(type, value, ctx, path);
                    if (err) return err;
                }
                return null;
            }
        },
        {
            key: "_run",
            value: function _run(type, value, ctx, path) {
                if (!this.registry[type]) return;
                var schema = this._schema;
                var _this$registry$type = this.registry[type], args = _this$registry$type.args, fn = _this$registry$type.fn;
                var validator = fn || schema.validators[type];
                var valid = validator.apply(void 0, [
                    value,
                    ctx
                ].concat($c19b29c9b23af798$var$_toConsumableArray(args), [
                    path
                ]));
                if (!valid) return this._error(type, ctx, args, path);
            }
        },
        {
            key: "_register",
            value: function _register(type, args, fn) {
                this.registry[type] = {
                    args: args,
                    fn: fn
                };
                return this;
            }
        },
        {
            key: "_error",
            value: function _error(type, ctx, args, path) {
                var schema = this._schema;
                var message = this.messages[type] || this.messages["default"] || schema.messages[type] || schema.messages["default"];
                if (typeof message == "function") message = message.apply(void 0, [
                    path,
                    ctx
                ].concat($c19b29c9b23af798$var$_toConsumableArray(args)));
                return new $c19b29c9b23af798$var$_error2["default"](message, path);
            }
        }
    ]);
    return Property;
}();
module.exports["default"] = $c19b29c9b23af798$var$Property;
module.exports = module.exports.default;

});
parcelRegister("9z9wJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
function $6f6ec5c7da49b90d$var$_typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $6f6ec5c7da49b90d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $6f6ec5c7da49b90d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $6f6ec5c7da49b90d$var$_typeof(obj);
}
function $6f6ec5c7da49b90d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6f6ec5c7da49b90d$var$_possibleConstructorReturn(self, call) {
    if (call && ($6f6ec5c7da49b90d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $6f6ec5c7da49b90d$var$_assertThisInitialized(self);
}
function $6f6ec5c7da49b90d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6f6ec5c7da49b90d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $6f6ec5c7da49b90d$var$_setPrototypeOf(subClass, superClass);
}
function $6f6ec5c7da49b90d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $6f6ec5c7da49b90d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$6f6ec5c7da49b90d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $6f6ec5c7da49b90d$var$_construct(Class, arguments, $6f6ec5c7da49b90d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $6f6ec5c7da49b90d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $6f6ec5c7da49b90d$var$_wrapNativeSuper(Class);
}
function $6f6ec5c7da49b90d$var$isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6f6ec5c7da49b90d$var$_construct(Parent, args, Class) {
    if ($6f6ec5c7da49b90d$var$isNativeReflectConstruct()) $6f6ec5c7da49b90d$var$_construct = Reflect.construct;
    else $6f6ec5c7da49b90d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $6f6ec5c7da49b90d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $6f6ec5c7da49b90d$var$_construct.apply(null, arguments);
}
function $6f6ec5c7da49b90d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $6f6ec5c7da49b90d$var$_setPrototypeOf(o, p) {
    $6f6ec5c7da49b90d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6f6ec5c7da49b90d$var$_setPrototypeOf(o, p);
}
function $6f6ec5c7da49b90d$var$_getPrototypeOf(o) {
    $6f6ec5c7da49b90d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6f6ec5c7da49b90d$var$_getPrototypeOf(o);
}
/**
 * Custom errors.
 *
 * @private
 */ var $6f6ec5c7da49b90d$var$ValidationError = /*#__PURE__*/ function(_Error) {
    $6f6ec5c7da49b90d$var$_inherits(ValidationError, _Error);
    function ValidationError(message, path) {
        var _this;
        $6f6ec5c7da49b90d$var$_classCallCheck(this, ValidationError);
        _this = $6f6ec5c7da49b90d$var$_possibleConstructorReturn(this, $6f6ec5c7da49b90d$var$_getPrototypeOf(ValidationError).call(this, message));
        $6f6ec5c7da49b90d$var$defineProp($6f6ec5c7da49b90d$var$_assertThisInitialized(_this), "path", path);
        $6f6ec5c7da49b90d$var$defineProp($6f6ec5c7da49b90d$var$_assertThisInitialized(_this), "expose", true);
        $6f6ec5c7da49b90d$var$defineProp($6f6ec5c7da49b90d$var$_assertThisInitialized(_this), "status", 400);
        if (Error.captureStackTrace) Error.captureStackTrace($6f6ec5c7da49b90d$var$_assertThisInitialized(_this), ValidationError);
        return _this;
    }
    return ValidationError;
}($6f6ec5c7da49b90d$var$_wrapNativeSuper(Error));
module.exports["default"] = $6f6ec5c7da49b90d$var$ValidationError;
var $6f6ec5c7da49b90d$var$defineProp = function defineProp(obj, prop, val) {
    Object.defineProperty(obj, prop, {
        enumerable: false,
        configurable: true,
        writable: true,
        value: val
    });
};
module.exports = module.exports.default;

});

parcelRegister("8MROJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assign = $665c8d64baed22aa$var$assign;
module.exports.walk = $665c8d64baed22aa$var$walk;
module.exports.join = $665c8d64baed22aa$var$join;

var $665c8d64baed22aa$var$_eivindfjeldstadDot = $665c8d64baed22aa$var$_interopRequireDefault((parcelRequire("kOsLh")));
function $665c8d64baed22aa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Assign given key and value (or object) to given object
 *
 * @private
 */ function $665c8d64baed22aa$var$assign(key, val, obj) {
    if (typeof key == "string") {
        obj[key] = val;
        return;
    }
    Object.keys(key).forEach(function(k) {
        return obj[k] = key[k];
    });
}
/**
 * Walk path
 *
 * @private
 */ function $665c8d64baed22aa$var$walk(path, obj, callback) {
    var parts = path.split(/\.\$(?=\.|$)/);
    var first = parts.shift();
    var arr = $665c8d64baed22aa$var$_eivindfjeldstadDot["default"].get(obj, first);
    if (!parts.length) return callback(first, arr);
    if (!Array.isArray(arr)) return;
    for(var i = 0; i < arr.length; i++){
        var current = $665c8d64baed22aa$var$join(i, first);
        var next = current + parts.join(".$");
        $665c8d64baed22aa$var$walk(next, obj, callback);
    }
}
/**
 * Join `path` with `prefix`
 *
 * @private
 */ function $665c8d64baed22aa$var$join(path, prefix) {
    return prefix ? "".concat(prefix, ".").concat(path) : path;
}

});


parcelRegister("kwqQW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;
/**
 * Default error messages.
 *
 * @private
 */ var $ef0ba041356ec4c3$var$Messages = {
    // Type message
    type: function type(prop, ctx, _type) {
        if (typeof _type == "function") _type = _type.name;
        return "".concat(prop, " must be of type ").concat(_type, ".");
    },
    // Required message
    required: function required(prop) {
        return "".concat(prop, " is required.");
    },
    // Match message
    match: function match(prop, ctx, regexp) {
        return "".concat(prop, " must match ").concat(regexp, ".");
    },
    // Length message
    length: function length(prop, ctx, len) {
        if (typeof len == "number") return "".concat(prop, " must have a length of ").concat(len, ".");
        var min = len.min, max = len.max;
        if (min && max) return "".concat(prop, " must have a length between ").concat(min, " and ").concat(max, ".");
        if (max) return "".concat(prop, " must have a maximum length of ").concat(max, ".");
        if (min) return "".concat(prop, " must have a minimum length of ").concat(min, ".");
    },
    // Size message
    size: function size(prop, ctx, _size) {
        if (typeof _size == "number") return "".concat(prop, " must have a size of ").concat(_size, ".");
        var min = _size.min, max = _size.max;
        if (min !== undefined && max !== undefined) return "".concat(prop, " must be between ").concat(min, " and ").concat(max, ".");
        if (max !== undefined) return "".concat(prop, " must be less than ").concat(max, ".");
        if (min !== undefined) return "".concat(prop, " must be greater than ").concat(min, ".");
    },
    // Enum message
    "enum": function _enum(prop, ctx, enums) {
        var copy = enums.slice();
        var last = copy.pop();
        return "".concat(prop, " must be either ").concat(copy.join(", "), " or ").concat(last, ".");
    },
    // Default message
    "default": function _default(prop) {
        return "Validation failed for ".concat(prop, ".");
    }
};
var $ef0ba041356ec4c3$var$_default2 = $ef0ba041356ec4c3$var$Messages;
module.exports["default"] = $ef0ba041356ec4c3$var$_default2;
module.exports = module.exports.default;

});

parcelRegister("6AqR8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $4cbaefe732ea460c$var$_componentType = $4cbaefe732ea460c$var$_interopRequireDefault((parcelRequire("5G6Ji")));
function $4cbaefe732ea460c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
/**
 * Default validators.
 *
 * @private
 */ var $4cbaefe732ea460c$var$Validators = {
    /**
   * Validates presence.
   *
   * @param {Mixed} value - the value being validated
   * @param {Object} ctx - the object being validated
   * @param {Bolean} required
   * @return {Boolean}
   */ required: function required(value, ctx, _required) {
        if (_required === false) return true;
        return value != null && value !== "";
    },
    /**
   * Validates type.
   *
   * @param {Mixed} value - the value being validated
   * @param {Object} ctx - the object being validated
   * @param {String|Function} name name of the type or a constructor
   * @return {Boolean}
   */ type: function type(value, ctx, name) {
        if (value == null) return true;
        if (typeof name == "function") return value.constructor === name;
        return (0, $4cbaefe732ea460c$var$_componentType["default"])(value) === name;
    },
    /**
   * Validates length.
   *
   * @param {String} value the string being validated
   * @param {Object} ctx the object being validated
   * @param {Object|Number} rules object with .min and/or .max props or a number
   * @param {Number} [rules.min] - minimum length
   * @param {Number} [rules.max] - maximum length
   * @return {Boolean}
   */ length: function length(value, ctx, len) {
        if (value == null) return true;
        if (typeof len == "number") return value.length === len;
        var min = len.min, max = len.max;
        if (min && value.length < min) return false;
        if (max && value.length > max) return false;
        return true;
    },
    /**
   * Validates size.
   *
   * @param {Number} value the number being validated
   * @param {Object} ctx the object being validated
   * @param {Object|Number} size object with .min and/or .max props or a number
   * @param {String|Number} [size.min] - minimum size
   * @param {String|Number} [size.max] - maximum size
   * @return {Boolean}
   */ size: function size(value, ctx, _size) {
        if (value == null) return true;
        if (typeof _size == "number") return value === _size;
        var min = _size.min, max = _size.max;
        if (parseInt(min) != null && value < min) return false;
        if (parseInt(max) != null && value > max) return false;
        return true;
    },
    /**
   * Validates enums.
   *
   * @param {String} value the string being validated
   * @param {Object} ctx the object being validated
   * @param {Array} enums array with allowed values
   * @return {Boolean}
   */ "enum": function _enum(value, ctx, enums) {
        if (value == null) return true;
        return enums.includes(value);
    },
    /**
   * Validates against given `regexp`.
   *
   * @param {String} value the string beign validated
   * @param {Object} ctx the object being validated
   * @param {RegExp} regexp the regexp to validate against
   * @return {Boolean}
   */ match: function match(value, ctx, regexp) {
        if (value == null) return true;
        return regexp.test(value);
    }
};
var $4cbaefe732ea460c$var$_default = $4cbaefe732ea460c$var$Validators;
module.exports["default"] = $4cbaefe732ea460c$var$_default;
module.exports = module.exports.default;

});






parcelRegister("8nesY", function(module, exports) {
"use strict";
var $618bb1677c4789d3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetPublicAddress = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $618bb1677c4789d3$var$GetPublicAddress extends $ksv7D.Query {
    constructor(fioAddress, chainCode, tokenCode){
        super();
        this.ENDPOINT = "chain/get_pub_address";
        this.fioAddress = fioAddress;
        this.chainCode = chainCode;
        this.tokenCode = tokenCode;
    }
    getData() {
        return $618bb1677c4789d3$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_address: this.fioAddress,
                chain_code: this.chainCode,
                token_code: this.tokenCode
            };
        });
    }
}
module.exports.GetPublicAddress = $618bb1677c4789d3$var$GetPublicAddress;

});

parcelRegister("hZI5S", function(module, exports) {
"use strict";
var $d19a564c565f5e21$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SentFioRequests = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $d19a564c565f5e21$var$SentFioRequests extends $ksv7D.Query {
    constructor(fioPublicKey, limit = null, offset = null){
        super();
        this.ENDPOINT = "chain/get_sent_fio_requests";
        this.isEncrypted = true;
        this.fioPublicKey = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
    }
    getData() {
        return $d19a564c565f5e21$var$__awaiter(this, void 0, void 0, function*() {
            const data = {
                fio_public_key: this.fioPublicKey,
                limit: this.limit || null,
                offset: this.offset || null
            };
            return data;
        });
    }
    decrypt(result) {
        return $d19a564c565f5e21$var$__awaiter(this, void 0, void 0, function*() {
            if (result.requests.length > 0) {
                const requests = [];
                for (const value of result.requests)try {
                    let content;
                    if (value.payer_fio_public_key === this.publicKey) content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payee_fio_public_key);
                    else content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payer_fio_public_key);
                    value.content = content;
                    requests.push(value);
                } catch (e) {
                //
                }
                return {
                    requests: requests,
                    more: result.more
                };
            }
        });
    }
}
module.exports.SentFioRequests = $d19a564c565f5e21$var$SentFioRequests;

});

parcelRegister("glTRs", function(module, exports) {
"use strict";
var $be79f0660657681f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetNames = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $be79f0660657681f$var$GetNames extends $ksv7D.Query {
    constructor(fioPublicKey){
        super();
        this.ENDPOINT = "chain/get_fio_names";
        this.fioPublicKey = fioPublicKey;
    }
    getData() {
        return $be79f0660657681f$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_public_key: this.fioPublicKey
            };
        });
    }
}
module.exports.GetNames = $be79f0660657681f$var$GetNames;

});

parcelRegister("ja3UY", function(module, exports) {
"use strict";
var $df31fd855b4f38bb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetFioBalance = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $df31fd855b4f38bb$var$GetFioBalance extends $ksv7D.Query {
    constructor(othersBalance){
        super();
        this.ENDPOINT = "chain/get_fio_balance";
        this.keyToUse = othersBalance || "";
    }
    getData() {
        return $df31fd855b4f38bb$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_public_key: this.keyToUse || this.publicKey
            };
        });
    }
}
module.exports.GetFioBalance = $df31fd855b4f38bb$var$GetFioBalance;

});

parcelRegister("lScxz", function(module, exports) {
"use strict";
var $fec85e6a4c563859$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PendingFioRequests = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $fec85e6a4c563859$var$PendingFioRequests extends $ksv7D.Query {
    constructor(fioPublicKey, limit = null, offset = null){
        super();
        this.ENDPOINT = "chain/get_pending_fio_requests";
        this.isEncrypted = true;
        this.fioPublicKey = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
    }
    getData() {
        return $fec85e6a4c563859$var$__awaiter(this, void 0, void 0, function*() {
            const data = {
                fio_public_key: this.fioPublicKey,
                limit: this.limit || null,
                offset: this.offset || null
            };
            return data;
        });
    }
    decrypt(result) {
        return $fec85e6a4c563859$var$__awaiter(this, void 0, void 0, function*() {
            if (result.requests.length > 0) {
                const requests = [];
                for (const value of result.requests)try {
                    let content;
                    if (value.payer_fio_public_key === this.publicKey) content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payee_fio_public_key);
                    else content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payer_fio_public_key);
                    value.content = content;
                    requests.push(value);
                } catch (e) {
                //
                }
                return {
                    requests: requests,
                    more: result.more
                };
            }
        });
    }
}
module.exports.PendingFioRequests = $fec85e6a4c563859$var$PendingFioRequests;

});

parcelRegister("hnokO", function(module, exports) {
"use strict";
var $ca67760284769450$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetFee = void 0;

var $6I0rv = parcelRequire("6I0rv");

var $ksv7D = parcelRequire("ksv7D");

var $g14qE = parcelRequire("g14qE");
class $ca67760284769450$var$GetFee extends $ksv7D.Query {
    constructor(endPoint, fioAddress = ""){
        super();
        this.ENDPOINT = "chain/get_fee";
        this.endPoint = endPoint;
        this.fioAddress = fioAddress;
        if ($6I0rv.Constants.feeNoAddressOperation.findIndex((element)=>element === endPoint) > -1 && fioAddress.length > 0) throw new Error("End point " + endPoint + " should not have any fio address, when requesting fee");
        if (fioAddress) {
            this.validationData = {
                fioAddress: fioAddress
            };
            this.validationRules = $g14qE.validationRules.getFee;
        }
    }
    getData() {
        return $ca67760284769450$var$__awaiter(this, void 0, void 0, function*() {
            const data = {
                end_point: this.endPoint,
                fio_address: this.fioAddress || null
            };
            return data;
        });
    }
}
module.exports.GetFee = $ca67760284769450$var$GetFee;

});
parcelRegister("6I0rv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Constants = void 0;
class $4e273205a2cf6589$var$Constants {
}
module.exports.Constants = $4e273205a2cf6589$var$Constants;
$4e273205a2cf6589$var$Constants.endPoints = {
    AddPublicAddress: "add_pub_address",
    SetFioDomainVisibility: "set_fio_domain_public",
    RecordObtData: "record_obt_data",
    RegisterFioAddress: "register_fio_address",
    RegisterFioDomain: "register_fio_domain",
    RejectFundsRequest: "reject_funds_request",
    RequestNewFunds: "new_funds_request",
    TransferTokensKey: "transfer_tokens_pub_key",
    TransferTokensFioAddress: "transfer_tokens_fio_address"
};
$4e273205a2cf6589$var$Constants.feeNoAddressOperation = [
    $4e273205a2cf6589$var$Constants.endPoints.RegisterFioDomain,
    $4e273205a2cf6589$var$Constants.endPoints.RegisterFioAddress,
    $4e273205a2cf6589$var$Constants.endPoints.TransferTokensKey,
    $4e273205a2cf6589$var$Constants.endPoints.TransferTokensFioAddress
];
$4e273205a2cf6589$var$Constants.rawAbiAccountName = [
    "fio.address",
    "fio.reqobt",
    "fio.token",
    "eosio",
    "fio.fee",
    "eosio.msig"
];
$4e273205a2cf6589$var$Constants.multiplier = 1000000000;
$4e273205a2cf6589$var$Constants.defaultAccount = "fio.address";

});


parcelRegister("i7uaM", function(module, exports) {
"use strict";
var $d310492351c9a3c0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetAbi = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $d310492351c9a3c0$var$GetAbi extends $ksv7D.Query {
    constructor(accountName){
        super();
        this.ENDPOINT = "chain/get_raw_abi";
        this.accountName = accountName;
    }
    getData() {
        return $d310492351c9a3c0$var$__awaiter(this, void 0, void 0, function*() {
            return {
                account_name: this.accountName
            };
        });
    }
}
module.exports.GetAbi = $d310492351c9a3c0$var$GetAbi;

});

parcelRegister("4vVnW", function(module, exports) {
"use strict";
var $3496922e7c3fe7a1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetObtData = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $3496922e7c3fe7a1$var$GetObtData extends $ksv7D.Query {
    constructor(fioPublicKey, limit = 0, offset = 0, tokenCode = ""){
        super();
        this.ENDPOINT = "chain/get_obt_data";
        this.isEncrypted = true;
        this.fio_public_key = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
        this.tokenCode = tokenCode;
    }
    getData() {
        return $3496922e7c3fe7a1$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_public_key: this.fio_public_key,
                limit: this.limit || null,
                offset: this.offset || null
            };
        });
    }
    decrypt(result) {
        return $3496922e7c3fe7a1$var$__awaiter(this, void 0, void 0, function*() {
            if (result.obt_data_records && result.obt_data_records.length > 0) {
                const obtDataRecords = [];
                for (const obtDataRecord of result.obt_data_records){
                    let content;
                    const contentType = "record_obt_data_content";
                    try {
                        if (obtDataRecord.payer_fio_public_key === this.publicKey) content = yield this.getUnCipherContent(contentType, obtDataRecord.content, this.privateKey, obtDataRecord.payee_fio_public_key);
                        else content = yield this.getUnCipherContent(contentType, obtDataRecord.content, this.privateKey, obtDataRecord.payer_fio_public_key);
                    } catch (e) {
                    // UnCipherContent error
                    // console.log(e)
                    }
                    if (content) {
                        if (this.tokenCode && content.token_code && content.token_code !== this.tokenCode) return;
                        obtDataRecord.content = content;
                    }
                    obtDataRecords.push(obtDataRecord);
                }
                return {
                    obt_data_records: obtDataRecords,
                    more: result.more
                };
            } else return result;
        });
    }
}
module.exports.GetObtData = $3496922e7c3fe7a1$var$GetObtData;

});

parcelRegister("lq7tX", function(module, exports) {
"use strict";
var $f981d4791f4aea61$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelledFioRequests = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $f981d4791f4aea61$var$CancelledFioRequests extends $ksv7D.Query {
    constructor(fioPublicKey, limit = null, offset = null){
        super();
        this.ENDPOINT = "chain/get_cancelled_fio_requests";
        this.isEncrypted = true;
        this.fioPublicKey = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
    }
    getData() {
        return $f981d4791f4aea61$var$__awaiter(this, void 0, void 0, function*() {
            const data = {
                fio_public_key: this.fioPublicKey,
                limit: this.limit || null,
                offset: this.offset || null
            };
            return data;
        });
    }
    decrypt(result) {
        return $f981d4791f4aea61$var$__awaiter(this, void 0, void 0, function*() {
            if (result.requests.length > 0) {
                const requests = [];
                for (const value of result.requests)try {
                    let content;
                    if (value.payer_fio_public_key === this.publicKey) content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payee_fio_public_key);
                    else content = yield this.getUnCipherContent("new_funds_content", value.content, this.privateKey, value.payer_fio_public_key);
                    value.content = content;
                    requests.push(value);
                } catch (e) {
                //
                }
                return {
                    requests: requests,
                    more: result.more
                };
            }
        });
    }
}
module.exports.CancelledFioRequests = $f981d4791f4aea61$var$CancelledFioRequests;

});

parcelRegister("zHZDk", function(module, exports) {
"use strict";
var $06b5651c20246695$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetAddresses = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $06b5651c20246695$var$GetAddresses extends $ksv7D.Query {
    constructor(fioPublicKey, limit = null, offset = null){
        super();
        this.ENDPOINT = "chain/get_fio_addresses";
        this.fioPublicKey = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
    }
    getData() {
        return $06b5651c20246695$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_public_key: this.fioPublicKey,
                limit: this.limit || null,
                offset: this.offset || null
            };
        });
    }
}
module.exports.GetAddresses = $06b5651c20246695$var$GetAddresses;

});

parcelRegister("kyHUp", function(module, exports) {
"use strict";
var $ef790b00ce87585e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GetDomains = void 0;

var $ksv7D = parcelRequire("ksv7D");
class $ef790b00ce87585e$var$GetDomains extends $ksv7D.Query {
    constructor(fioPublicKey, limit = null, offset = null){
        super();
        this.ENDPOINT = "chain/get_fio_domains";
        this.fioPublicKey = fioPublicKey;
        this.limit = limit;
        this.offset = offset;
    }
    getData() {
        return $ef790b00ce87585e$var$__awaiter(this, void 0, void 0, function*() {
            return {
                fio_public_key: this.fioPublicKey,
                limit: this.limit || null,
                offset: this.offset || null
            };
        });
    }
}
module.exports.GetDomains = $ef790b00ce87585e$var$GetDomains;

});


parcelRegister("vwBbb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gXcyQ = parcelRequire("gXcyQ");
Object.defineProperty(module.exports, "AddPublicAddress", {
    enumerable: true,
    get: function() {
        return $gXcyQ.AddPublicAddress;
    }
});

var $f4PRe = parcelRequire("f4PRe");
Object.defineProperty(module.exports, "RemovePublicAddresses", {
    enumerable: true,
    get: function() {
        return $f4PRe.RemovePublicAddresses;
    }
});

var $hKjEb = parcelRequire("hKjEb");
Object.defineProperty(module.exports, "RemoveAllPublicAddresses", {
    enumerable: true,
    get: function() {
        return $hKjEb.RemoveAllPublicAddresses;
    }
});

var $9Qq6h = parcelRequire("9Qq6h");
Object.defineProperty(module.exports, "SetFioDomainVisibility", {
    enumerable: true,
    get: function() {
        return $9Qq6h.SetFioDomainVisibility;
    }
});

var $4xszx = parcelRequire("4xszx");
Object.defineProperty(module.exports, "RequestNewFunds", {
    enumerable: true,
    get: function() {
        return $4xszx.RequestNewFunds;
    }
});

var $koFeq = parcelRequire("koFeq");
Object.defineProperty(module.exports, "RejectFundsRequest", {
    enumerable: true,
    get: function() {
        return $koFeq.RejectFundsRequest;
    }
});

var $23JMt = parcelRequire("23JMt");
Object.defineProperty(module.exports, "RecordObtData", {
    enumerable: true,
    get: function() {
        return $23JMt.RecordObtData;
    }
});

var $gzO4N = parcelRequire("gzO4N");
Object.defineProperty(module.exports, "TransferTokens", {
    enumerable: true,
    get: function() {
        return $gzO4N.TransferTokens;
    }
});

var $jHNU8 = parcelRequire("jHNU8");
Object.defineProperty(module.exports, "RegisterFioAddress", {
    enumerable: true,
    get: function() {
        return $jHNU8.RegisterFioAddress;
    }
});

var $kVK11 = parcelRequire("kVK11");
Object.defineProperty(module.exports, "RegisterFioDomain", {
    enumerable: true,
    get: function() {
        return $kVK11.RegisterFioDomain;
    }
});

var $5Wi28 = parcelRequire("5Wi28");
Object.defineProperty(module.exports, "MockRegisterFioName", {
    enumerable: true,
    get: function() {
        return $5Wi28.MockRegisterFioName;
    }
});

var $99Fly = parcelRequire("99Fly");
Object.defineProperty(module.exports, "RenewFioAddress", {
    enumerable: true,
    get: function() {
        return $99Fly.RenewFioAddress;
    }
});

var $dAALW = parcelRequire("dAALW");
Object.defineProperty(module.exports, "RenewFioDomain", {
    enumerable: true,
    get: function() {
        return $dAALW.RenewFioDomain;
    }
});

var $cUzRn = parcelRequire("cUzRn");
Object.defineProperty(module.exports, "BurnFioAddress", {
    enumerable: true,
    get: function() {
        return $cUzRn.BurnFioAddress;
    }
});

var $E9Cxi = parcelRequire("E9Cxi");
Object.defineProperty(module.exports, "TransferFioDomain", {
    enumerable: true,
    get: function() {
        return $E9Cxi.TransferFioDomain;
    }
});

var $3UC7Y = parcelRequire("3UC7Y");
Object.defineProperty(module.exports, "TransferFioAddress", {
    enumerable: true,
    get: function() {
        return $3UC7Y.TransferFioAddress;
    }
});

var $322m0 = parcelRequire("322m0");
Object.defineProperty(module.exports, "PushTransaction", {
    enumerable: true,
    get: function() {
        return $322m0.PushTransaction;
    }
});

var $ilRkB = parcelRequire("ilRkB");
Object.defineProperty(module.exports, "CancelFundsRequest", {
    enumerable: true,
    get: function() {
        return $ilRkB.CancelFundsRequest;
    }
});

});
parcelRegister("gXcyQ", function(module, exports) {
"use strict";
var $c57be66161c02553$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddPublicAddress = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $c57be66161c02553$var$AddPublicAddress extends $dhMfH.SignedTransaction {
    constructor(fioAddress, publicAddresses, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/add_pub_address";
        this.ACTION = "addaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.publicAddresses = publicAddresses;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.addPublicAddressRules;
    }
    getData() {
        return $c57be66161c02553$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                public_addresses: this.publicAddresses,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.AddPublicAddress = $c57be66161c02553$var$AddPublicAddress;

});
parcelRegister("dhMfH", function(module, exports) {
"use strict";
var $027f0134b67c656b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SignedTransaction = void 0;

var $iriqJ = parcelRequire("iriqJ");

var $kmC8Q = parcelRequire("kmC8Q");

var $61G3t = parcelRequire("61G3t");

var $dtGp3 = parcelRequire("dtGp3");
class $027f0134b67c656b$var$SignedTransaction extends $dtGp3.Transactions {
    execute(privateKey, publicKey, dryRun = false) {
        return $027f0134b67c656b$var$__awaiter(this, void 0, void 0, function*() {
            this.privateKey = privateKey;
            this.publicKey = publicKey;
            const rawTransaction = new $61G3t.RawTransaction();
            const rawaction = new $kmC8Q.RawAction();
            rawaction.account = this.getAccount();
            const actor = yield this.getActor();
            rawaction.authorization.push(new $iriqJ.Authorization(actor));
            rawaction.account = this.getAccount();
            rawaction.name = this.getAction();
            rawaction.data = yield this.getData();
            rawTransaction.actions.push(rawaction);
            const result = yield this.pushToServer(rawTransaction, this.getEndPoint(), dryRun);
            return this.prepareResponse(result);
        });
    }
    prepareResponse(result) {
        return $027f0134b67c656b$var$SignedTransaction.prepareResponse(result);
    }
    static prepareResponse(result, includeTrxId = false) {
        if (result.processed) {
            const processed = $027f0134b67c656b$var$SignedTransaction.parseProcessedResult(result.processed);
            if (includeTrxId) return Object.assign({
                transaction_id: result.transaction_id,
                block_num: result.processed.block_num
            }, processed);
            return processed;
        }
        return result;
    }
    static parseProcessedResult(processed) {
        return JSON.parse(processed.action_traces[0].receipt.response);
    }
    getAction() {
        return this.ACTION;
    }
    getAccount() {
        return this.ACCOUNT;
    }
    getEndPoint() {
        return this.ENDPOINT;
    }
}
module.exports.SignedTransaction = $027f0134b67c656b$var$SignedTransaction;

});
parcelRegister("iriqJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Authorization = void 0;
class $d6c90b716ea153d4$var$Authorization {
    constructor(actor, permission = "active"){
        this.actor = actor;
        this.permission = permission;
    }
}
module.exports.Authorization = $d6c90b716ea153d4$var$Authorization;

});

parcelRegister("kmC8Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawAction = void 0;
class $ed3372dbf17ca94b$var$RawAction {
    constructor(){
        this.account = ""; //'testeostoken',
        this.name = ""; //'transfer',
        this.authorization = new Array();
    }
}
module.exports.RawAction = $ed3372dbf17ca94b$var$RawAction;

});

parcelRegister("61G3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RawTransaction = void 0;
class $4633754df67ffd5a$var$RawTransaction {
    constructor(){
        this.expiration = ""; //'2018-09-04T18:42:49',
        this.ref_block_num = 0; //38096,
        this.ref_block_prefix = 0; //505360011,
        this.max_net_usage_words = 0;
        this.max_cpu_usage_ms = 0;
        this.delay_sec = 0;
        this.context_free_actions = [];
        this.actions = new Array();
        this.transaction_extensions = [];
    }
}
module.exports.RawTransaction = $4633754df67ffd5a$var$RawTransaction;

});



parcelRegister("f4PRe", function(module, exports) {
"use strict";
var $af9f7496a3b2d480$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemovePublicAddresses = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $af9f7496a3b2d480$var$RemovePublicAddresses extends $dhMfH.SignedTransaction {
    constructor(fioAddress, publicAddresses, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/remove_pub_address";
        this.ACTION = "remaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.publicAddresses = publicAddresses;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.addPublicAddressRules;
    }
    getData() {
        return $af9f7496a3b2d480$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                public_addresses: this.publicAddresses,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.RemovePublicAddresses = $af9f7496a3b2d480$var$RemovePublicAddresses;

});

parcelRegister("hKjEb", function(module, exports) {
"use strict";
var $ceb5f913fc2b7623$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RemoveAllPublicAddresses = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $ceb5f913fc2b7623$var$RemoveAllPublicAddresses extends $dhMfH.SignedTransaction {
    constructor(fioAddress, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/remove_all_pub_addresses";
        this.ACTION = "remalladdr";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.addPublicAddressRules;
    }
    getData() {
        return $ceb5f913fc2b7623$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.RemoveAllPublicAddresses = $ceb5f913fc2b7623$var$RemoveAllPublicAddresses;

});

parcelRegister("9Qq6h", function(module, exports) {
"use strict";
var $72ad3759fb566b7c$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SetFioDomainVisibility = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");

var $6I0rv = parcelRequire("6I0rv");
class $72ad3759fb566b7c$var$SetFioDomainVisibility extends $dhMfH.SignedTransaction {
    constructor(fioDomain, isPublic, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/set_fio_domain_public";
        this.ACTION = "setdomainpub";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioDomain = fioDomain;
        this.isPublic = isPublic ? 1 : 0;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
    }
    getData() {
        return $72ad3759fb566b7c$var$__awaiter(this, void 0, void 0, function*() {
            this.validationData = {
                fioDomain: this.fioDomain,
                tpid: this.technologyProviderId || null
            };
            this.validationRules = $g14qE.validationRules.registerFioDomain;
            const actor = this.getActor();
            const data = {
                fio_domain: this.fioDomain,
                is_public: this.isPublic,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.SetFioDomainVisibility = $72ad3759fb566b7c$var$SetFioDomainVisibility;

});

parcelRegister("4xszx", function(module, exports) {
"use strict";
var $34e06852df3d36c5$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RequestNewFunds = void 0;

var $g14qE = parcelRequire("g14qE");

var $dhMfH = parcelRequire("dhMfH");
class $34e06852df3d36c5$var$RequestNewFunds extends $dhMfH.SignedTransaction {
    constructor(payerFioAddress, payerFioPublicKey, payeeFioAddress, technologyProviderId = "", maxFee, payeeTokenPublicAddress, amount, chainCode, tokenCode, memo = null, hash = null, offlineUrl = null){
        super();
        this.ENDPOINT = "chain/new_funds_request";
        this.ACTION = "newfundsreq";
        this.ACCOUNT = "fio.reqobt";
        this.validationData = {
            payerFioAddress: payerFioAddress,
            payeeFioAddress: payeeFioAddress,
            tokenCode: tokenCode,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.newFundsRequest;
        this.payerFioAddress = payerFioAddress;
        this.payerFioPublicKey = payerFioPublicKey;
        this.payeeFioAddress = payeeFioAddress;
        this.chainCode = chainCode;
        this.tokenCode = tokenCode;
        this.maxFee = maxFee;
        this.content = {
            payee_public_address: payeeTokenPublicAddress,
            amount: `${amount}`,
            chain_code: chainCode,
            token_code: tokenCode,
            memo: memo,
            hash: hash,
            offline_url: offlineUrl
        };
        if (technologyProviderId) this.technologyProviderId = technologyProviderId;
        else this.technologyProviderId = "";
    }
    getData() {
        return $34e06852df3d36c5$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const cipherContent = yield this.getCipherContent("new_funds_content", this.content, this.privateKey, this.payerFioPublicKey);
            const data = {
                payer_fio_address: this.payerFioAddress,
                payee_fio_address: this.payeeFioAddress,
                content: cipherContent,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RequestNewFunds = $34e06852df3d36c5$var$RequestNewFunds;

});

parcelRegister("koFeq", function(module, exports) {
"use strict";
var $ed96084f4b74e406$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RejectFundsRequest = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");
class $ed96084f4b74e406$var$RejectFundsRequest extends $dhMfH.SignedTransaction {
    constructor(fioreqid, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/reject_funds_request";
        this.ACTION = "rejectfndreq";
        this.ACCOUNT = "fio.reqobt";
        this.fioreqid = fioreqid;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.rejectFunds;
    }
    getData() {
        return $ed96084f4b74e406$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = {
                fio_request_id: this.fioreqid,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RejectFundsRequest = $ed96084f4b74e406$var$RejectFundsRequest;

});

parcelRegister("23JMt", function(module, exports) {
"use strict";
var $17ff5fb2905d98e0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RecordObtData = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");
class $17ff5fb2905d98e0$var$RecordObtData extends $dhMfH.SignedTransaction {
    constructor(fioRequestId, payerFioAddress, payeeFioAddress, payerPublicAddress, payeePublicAddress, amount, chainCode, tokenCode, obtID, maxFee, status, technologyProviderId = "", payeeFioPublicKey, memo = null, hash = null, offLineUrl = null){
        super();
        this.ENDPOINT = "chain/record_obt_data";
        this.ACTION = "recordobt";
        this.ACCOUNT = "fio.reqobt";
        this.fioRequestId = null;
        this.technologyProviderId = "";
        this.defaultStatus = "sent_to_blockchain";
        this.fioRequestId = fioRequestId;
        this.payerFioAddress = payerFioAddress;
        this.payeeFioPublicKey = payeeFioPublicKey;
        this.payeeFioAddress = payeeFioAddress;
        this.payerPublicAddress = payerPublicAddress;
        this.payeePublicAddress = payeePublicAddress;
        if (technologyProviderId) this.technologyProviderId = technologyProviderId;
        else this.technologyProviderId = "";
        this.maxFee = maxFee;
        this.content = {
            payer_public_address: this.payerPublicAddress,
            payee_public_address: this.payeePublicAddress,
            amount: `${amount}`,
            chain_code: chainCode,
            token_code: tokenCode,
            status: status || this.defaultStatus,
            obt_id: obtID,
            memo: memo,
            hash: hash,
            offline_url: offLineUrl
        };
        this.validationData = {
            payerFioAddress: payerFioAddress,
            payeeFioAddress: payeeFioAddress,
            tpid: technologyProviderId || null,
            tokenCode: tokenCode
        };
        this.validationRules = $g14qE.validationRules.recordObtData;
    }
    getData() {
        return $17ff5fb2905d98e0$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            const cipherContent = yield this.getCipherContent("record_obt_data_content", this.content, this.privateKey, this.payeeFioPublicKey);
            let data = {
                payer_fio_address: this.payerFioAddress,
                payee_fio_address: this.payeeFioAddress,
                content: cipherContent,
                fio_request_id: this.fioRequestId || "",
                max_fee: this.maxFee,
                actor: actor,
                tpid: this.technologyProviderId
            };
            return data;
        });
    }
}
module.exports.RecordObtData = $17ff5fb2905d98e0$var$RecordObtData;

});

parcelRegister("gzO4N", function(module, exports) {
"use strict";
var $c116c25a947b7163$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferTokens = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");
class $c116c25a947b7163$var$TransferTokens extends $dhMfH.SignedTransaction {
    constructor(payeePublicKey, amount, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/transfer_tokens_pub_key";
        this.ACTION = "trnsfiopubky";
        this.ACCOUNT = "fio.token";
        this.payeePublicKey = payeePublicKey;
        this.amount = `${amount}`;
        this.technologyProviderId = technologyProviderId;
        this.maxFee = maxFee;
        this.validationData = {
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.transferTokens;
    }
    prepareResponse(result) {
        if (!result.processed) return result;
        const apiResponse = $dhMfH.SignedTransaction.parseProcessedResult(result.processed);
        return Object.assign({
            transaction_id: result.transaction_id,
            block_num: result.processed.block_num
        }, apiResponse);
    }
    getData() {
        return $c116c25a947b7163$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = {
                payee_public_key: this.payeePublicKey,
                amount: this.amount,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.TransferTokens = $c116c25a947b7163$var$TransferTokens;

});

parcelRegister("jHNU8", function(module, exports) {
"use strict";
var $e588be6ea9449ceb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegisterFioAddress = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");

var $6I0rv = parcelRequire("6I0rv");
class $e588be6ea9449ceb$var$RegisterFioAddress extends $dhMfH.SignedTransaction {
    constructor(fioAddress, ownerPublicKey, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/register_fio_address";
        this.ACTION = "regaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.ownerPublicKey = ownerPublicKey || "";
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.registerFioAddress;
    }
    getData() {
        return $e588be6ea9449ceb$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                owner_fio_public_key: this.ownerPublicKey || this.publicKey,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RegisterFioAddress = $e588be6ea9449ceb$var$RegisterFioAddress;

});

parcelRegister("kVK11", function(module, exports) {
"use strict";
var $f3ccd3379634e250$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RegisterFioDomain = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $f3ccd3379634e250$var$RegisterFioDomain extends $dhMfH.SignedTransaction {
    constructor(fioDomain, ownerPublicKey, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/register_fio_domain";
        this.ACTION = "regdomain";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioDomain = fioDomain;
        this.ownerPublicKey = ownerPublicKey || "";
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioDomain: fioDomain,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.registerFioDomain;
    }
    getData() {
        return $f3ccd3379634e250$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = {
                fio_domain: this.fioDomain,
                owner_fio_public_key: this.ownerPublicKey || this.publicKey,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RegisterFioDomain = $f3ccd3379634e250$var$RegisterFioDomain;

});

parcelRegister("5Wi28", function(module, exports) {
"use strict";
var $45305b983e5afed6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MockRegisterFioName = void 0;

var $6I0rv = parcelRequire("6I0rv");
class $45305b983e5afed6$var$MockRegisterFioName {
    constructor(fioName, publicKey, server){
        this.ENDPOINT = "/register_fio_name";
        this.ACTION = "regaddress";
        this.ACOUNT = $6I0rv.Constants.defaultAccount;
        this.fioName = fioName;
        this.publicKey = publicKey;
        this.server = server;
    }
    execute() {
        return $45305b983e5afed6$var$__awaiter(this, void 0, void 0, function*() {
            let body = {
                fio_name: this.fioName,
                owner_fio_public_key: this.publicKey
            };
            let options = {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(body)
            };
            return fetch(this.server + this.ENDPOINT, options).then((response)=>{
                let statusCode = response.status;
                let data = response.json();
                return Promise.all([
                    statusCode,
                    data
                ]);
            }).then(([status, data])=>{
                if (status < 200 || status > 300) throw new Error(JSON.stringify({
                    errorCode: status,
                    msg: data
                }));
                else return data;
            });
        });
    }
}
module.exports.MockRegisterFioName = $45305b983e5afed6$var$MockRegisterFioName;

});

parcelRegister("99Fly", function(module, exports) {
"use strict";
var $6aa506eaefadbab0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RenewFioAddress = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $6aa506eaefadbab0$var$RenewFioAddress extends $dhMfH.SignedTransaction {
    constructor(fioAddress, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/renew_fio_address";
        this.ACTION = "renewaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.renewFioAddress;
    }
    getData() {
        return $6aa506eaefadbab0$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = {
                fio_address: this.fioAddress,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RenewFioAddress = $6aa506eaefadbab0$var$RenewFioAddress;

});

parcelRegister("dAALW", function(module, exports) {
"use strict";
var $9e4b29579a0fa248$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RenewFioDomain = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $9e4b29579a0fa248$var$RenewFioDomain extends $dhMfH.SignedTransaction {
    constructor(fioDomain, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/renew_fio_domain";
        this.ACTION = "renewdomain";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioDomain = fioDomain;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioDomain: fioDomain,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.renewFioDomain;
    }
    getData() {
        return $9e4b29579a0fa248$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = {
                fio_domain: this.fioDomain,
                max_fee: this.maxFee,
                tpid: this.technologyProviderId,
                actor: actor
            };
            return data;
        });
    }
}
module.exports.RenewFioDomain = $9e4b29579a0fa248$var$RenewFioDomain;

});

parcelRegister("cUzRn", function(module, exports) {
"use strict";
var $9666880c0623b805$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BurnFioAddress = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $9666880c0623b805$var$BurnFioAddress extends $dhMfH.SignedTransaction {
    constructor(fioAddress, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/burn_fio_address";
        this.ACTION = "burnaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.registerFioAddress;
    }
    getData() {
        return $9666880c0623b805$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.BurnFioAddress = $9666880c0623b805$var$BurnFioAddress;

});

parcelRegister("E9Cxi", function(module, exports) {
"use strict";
var $078b32fb7d3420ae$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferFioDomain = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $078b32fb7d3420ae$var$TransferFioDomain extends $dhMfH.SignedTransaction {
    constructor(fioDomain, newOwnerKey, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/transfer_fio_domain";
        this.ACTION = "xferdomain";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioDomain = fioDomain;
        this.newOwnerKey = newOwnerKey;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioDomain: fioDomain,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.registerFioDomain;
    }
    getData() {
        return $078b32fb7d3420ae$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_domain: this.fioDomain,
                new_owner_fio_public_key: this.newOwnerKey,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.TransferFioDomain = $078b32fb7d3420ae$var$TransferFioDomain;

});

parcelRegister("3UC7Y", function(module, exports) {
"use strict";
var $2d942d6e28e42e6d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransferFioAddress = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");

var $g14qE = parcelRequire("g14qE");
class $2d942d6e28e42e6d$var$TransferFioAddress extends $dhMfH.SignedTransaction {
    constructor(fioAddress, newOwnerKey, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/transfer_fio_address";
        this.ACTION = "xferaddress";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.fioAddress = fioAddress;
        this.newOwnerKey = newOwnerKey;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            fioAddress: fioAddress,
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.registerFioAddress;
    }
    getData() {
        return $2d942d6e28e42e6d$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_address: this.fioAddress,
                new_owner_fio_public_key: this.newOwnerKey,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.TransferFioAddress = $2d942d6e28e42e6d$var$TransferFioAddress;

});

parcelRegister("322m0", function(module, exports) {
"use strict";
var $23536276a18afd37$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PushTransaction = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $6I0rv = parcelRequire("6I0rv");
class $23536276a18afd37$var$PushTransaction extends $dhMfH.SignedTransaction {
    constructor(action, account, data){
        super();
        this.ENDPOINT = "chain/push_transaction";
        this.ACTION = "";
        this.ACCOUNT = $6I0rv.Constants.defaultAccount;
        this.ACTION = action;
        if (account) this.ACCOUNT = account;
        this.data = data;
    }
    getData() {
        return $23536276a18afd37$var$__awaiter(this, void 0, void 0, function*() {
            let actor = this.getActor();
            let data = Object.assign(Object.assign({}, this.data), {
                actor: actor
            });
            return data;
        });
    }
}
module.exports.PushTransaction = $23536276a18afd37$var$PushTransaction;

});

parcelRegister("ilRkB", function(module, exports) {
"use strict";
var $d5c38ea11429d9e3$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelFundsRequest = void 0;

var $dhMfH = parcelRequire("dhMfH");

var $g14qE = parcelRequire("g14qE");
class $d5c38ea11429d9e3$var$CancelFundsRequest extends $dhMfH.SignedTransaction {
    constructor(fioRequestId, maxFee, technologyProviderId = ""){
        super();
        this.ENDPOINT = "chain/cancel_funds_request";
        this.ACTION = "cancelfndreq";
        this.ACCOUNT = "fio.reqobt";
        this.fioRequestId = fioRequestId;
        this.maxFee = maxFee;
        this.technologyProviderId = technologyProviderId;
        this.validationData = {
            tpid: technologyProviderId || null
        };
        this.validationRules = $g14qE.validationRules.cancelFundsRequestRules;
    }
    getData() {
        return $d5c38ea11429d9e3$var$__awaiter(this, void 0, void 0, function*() {
            const actor = this.getActor();
            const data = {
                fio_request_id: this.fioRequestId,
                actor: actor,
                tpid: this.technologyProviderId,
                max_fee: this.maxFee
            };
            return data;
        });
    }
}
module.exports.CancelFundsRequest = $d5c38ea11429d9e3$var$CancelFundsRequest;

});


parcelRegister("5NC09", function(module, exports) {

var $bhJ7Q = parcelRequire("bhJ7Q");

var $6U9mG = parcelRequire("6U9mG");
var $438f01a446f2518b$require$Buffer = $6U9mG.Buffer;

var $aO8Ot = parcelRequire("aO8Ot");

var $1Vf4C = parcelRequire("1Vf4C");

var $aQkCV = parcelRequire("aQkCV");
var $438f01a446f2518b$var$MASTER_SECRET = $438f01a446f2518b$require$Buffer.from("Bitcoin seed", "utf8");
var $438f01a446f2518b$var$HARDENED_OFFSET = 0x80000000;
var $438f01a446f2518b$var$LEN = 78;
// Bitcoin hardcoded by default, can use package `coininfo` for others
var $438f01a446f2518b$var$BITCOIN_VERSIONS = {
    private: 0x0488ADE4,
    public: 0x0488B21E
};
function $438f01a446f2518b$var$HDKey(versions) {
    this.versions = versions || $438f01a446f2518b$var$BITCOIN_VERSIONS;
    this.depth = 0;
    this.index = 0;
    this._privateKey = null;
    this._publicKey = null;
    this.chainCode = null;
    this._fingerprint = 0;
    this.parentFingerprint = 0;
}
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "fingerprint", {
    get: function() {
        return this._fingerprint;
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "identifier", {
    get: function() {
        return this._identifier;
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "pubKeyHash", {
    get: function() {
        return this.identifier;
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "privateKey", {
    get: function() {
        return this._privateKey;
    },
    set: function(value) {
        $bhJ7Q.equal(value.length, 32, "Private key must be 32 bytes.");
        $bhJ7Q($aQkCV.privateKeyVerify(value) === true, "Invalid private key");
        this._privateKey = value;
        this._publicKey = $aQkCV.publicKeyCreate(value, true);
        this._identifier = $438f01a446f2518b$var$hash160(this.publicKey);
        this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "publicKey", {
    get: function() {
        return this._publicKey;
    },
    set: function(value) {
        $bhJ7Q(value.length === 33 || value.length === 65, "Public key must be 33 or 65 bytes.");
        $bhJ7Q($aQkCV.publicKeyVerify(value) === true, "Invalid public key");
        this._publicKey = $aQkCV.publicKeyConvert(value, true) // force compressed point
        ;
        this._identifier = $438f01a446f2518b$var$hash160(this.publicKey);
        this._fingerprint = this._identifier.slice(0, 4).readUInt32BE(0);
        this._privateKey = null;
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "privateExtendedKey", {
    get: function() {
        if (this._privateKey) return $1Vf4C.encode($438f01a446f2518b$var$serialize(this, this.versions.private, $438f01a446f2518b$require$Buffer.concat([
            $438f01a446f2518b$require$Buffer.alloc(1, 0),
            this.privateKey
        ])));
        else return null;
    }
});
Object.defineProperty($438f01a446f2518b$var$HDKey.prototype, "publicExtendedKey", {
    get: function() {
        return $1Vf4C.encode($438f01a446f2518b$var$serialize(this, this.versions.public, this.publicKey));
    }
});
$438f01a446f2518b$var$HDKey.prototype.derive = function(path) {
    if (path === "m" || path === "M" || path === "m'" || path === "M'") return this;
    var entries = path.split("/");
    var hdkey = this;
    entries.forEach(function(c, i) {
        if (i === 0) {
            $bhJ7Q(/^[mM]{1}/.test(c), 'Path must start with "m" or "M"');
            return;
        }
        var hardened = c.length > 1 && c[c.length - 1] === "'";
        var childIndex = parseInt(c, 10) // & (HARDENED_OFFSET - 1)
        ;
        $bhJ7Q(childIndex < $438f01a446f2518b$var$HARDENED_OFFSET, "Invalid index");
        if (hardened) childIndex += $438f01a446f2518b$var$HARDENED_OFFSET;
        hdkey = hdkey.deriveChild(childIndex);
    });
    return hdkey;
};
$438f01a446f2518b$var$HDKey.prototype.deriveChild = function(index) {
    var isHardened = index >= $438f01a446f2518b$var$HARDENED_OFFSET;
    var indexBuffer = $438f01a446f2518b$require$Buffer.allocUnsafe(4);
    indexBuffer.writeUInt32BE(index, 0);
    var data;
    if (isHardened) {
        $bhJ7Q(this.privateKey, "Could not derive hardened child key");
        var pk = this.privateKey;
        var zb = $438f01a446f2518b$require$Buffer.alloc(1, 0);
        pk = $438f01a446f2518b$require$Buffer.concat([
            zb,
            pk
        ]);
        // data = 0x00 || ser256(kpar) || ser32(index)
        data = $438f01a446f2518b$require$Buffer.concat([
            pk,
            indexBuffer
        ]);
    } else // data = serP(point(kpar)) || ser32(index)
    //      = serP(Kpar) || ser32(index)
    data = $438f01a446f2518b$require$Buffer.concat([
        this.publicKey,
        indexBuffer
    ]);
    var I = $aO8Ot.createHmac("sha512", this.chainCode).update(data).digest();
    var IL = I.slice(0, 32);
    var IR = I.slice(32);
    var hd = new $438f01a446f2518b$var$HDKey(this.versions);
    // Private parent key -> private child key
    if (this.privateKey) // ki = parse256(IL) + kpar (mod n)
    try {
        hd.privateKey = $aQkCV.privateKeyTweakAdd(this.privateKey, IL);
    // throw if IL >= n || (privateKey + IL) === 0
    } catch (err) {
        // In case parse256(IL) >= n or ki == 0, one should proceed with the next value for i
        return this.deriveChild(index + 1);
    }
    else // Ki = point(parse256(IL)) + Kpar
    //    = G*IL + Kpar
    try {
        hd.publicKey = $aQkCV.publicKeyTweakAdd(this.publicKey, IL, true);
    // throw if IL >= n || (g**IL + publicKey) is infinity
    } catch (err) {
        // In case parse256(IL) >= n or Ki is the point at infinity, one should proceed with the next value for i
        return this.deriveChild(index + 1);
    }
    hd.chainCode = IR;
    hd.depth = this.depth + 1;
    hd.parentFingerprint = this.fingerprint // .readUInt32BE(0)
    ;
    hd.index = index;
    return hd;
};
$438f01a446f2518b$var$HDKey.prototype.sign = function(hash) {
    return $aQkCV.sign(hash, this.privateKey).signature;
};
$438f01a446f2518b$var$HDKey.prototype.verify = function(hash, signature) {
    return $aQkCV.verify(hash, signature, this.publicKey);
};
$438f01a446f2518b$var$HDKey.prototype.wipePrivateData = function() {
    if (this._privateKey) $aO8Ot.randomBytes(this._privateKey.length).copy(this._privateKey);
    this._privateKey = null;
    return this;
};
$438f01a446f2518b$var$HDKey.prototype.toJSON = function() {
    return {
        xpriv: this.privateExtendedKey,
        xpub: this.publicExtendedKey
    };
};
$438f01a446f2518b$var$HDKey.fromMasterSeed = function(seedBuffer, versions) {
    var I = $aO8Ot.createHmac("sha512", $438f01a446f2518b$var$MASTER_SECRET).update(seedBuffer).digest();
    var IL = I.slice(0, 32);
    var IR = I.slice(32);
    var hdkey = new $438f01a446f2518b$var$HDKey(versions);
    hdkey.chainCode = IR;
    hdkey.privateKey = IL;
    return hdkey;
};
$438f01a446f2518b$var$HDKey.fromExtendedKey = function(base58key, versions) {
    // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
    versions = versions || $438f01a446f2518b$var$BITCOIN_VERSIONS;
    var hdkey = new $438f01a446f2518b$var$HDKey(versions);
    var keyBuffer = $1Vf4C.decode(base58key);
    var version = keyBuffer.readUInt32BE(0);
    $bhJ7Q(version === versions.private || version === versions.public, "Version mismatch: does not match private or public");
    hdkey.depth = keyBuffer.readUInt8(4);
    hdkey.parentFingerprint = keyBuffer.readUInt32BE(5);
    hdkey.index = keyBuffer.readUInt32BE(9);
    hdkey.chainCode = keyBuffer.slice(13, 45);
    var key = keyBuffer.slice(45);
    if (key.readUInt8(0) === 0) {
        $bhJ7Q(version === versions.private, "Version mismatch: version does not match private");
        hdkey.privateKey = key.slice(1) // cut off first 0x0 byte
        ;
    } else {
        $bhJ7Q(version === versions.public, "Version mismatch: version does not match public");
        hdkey.publicKey = key;
    }
    return hdkey;
};
$438f01a446f2518b$var$HDKey.fromJSON = function(obj) {
    return $438f01a446f2518b$var$HDKey.fromExtendedKey(obj.xpriv);
};
function $438f01a446f2518b$var$serialize(hdkey, version, key) {
    // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
    var buffer = $438f01a446f2518b$require$Buffer.allocUnsafe($438f01a446f2518b$var$LEN);
    buffer.writeUInt32BE(version, 0);
    buffer.writeUInt8(hdkey.depth, 4);
    var fingerprint = hdkey.depth ? hdkey.parentFingerprint : 0x00000000;
    buffer.writeUInt32BE(fingerprint, 5);
    buffer.writeUInt32BE(hdkey.index, 9);
    hdkey.chainCode.copy(buffer, 13);
    key.copy(buffer, 45);
    return buffer;
}
function $438f01a446f2518b$var$hash160(buf) {
    var sha = $aO8Ot.createHash("sha256").update(buf).digest();
    return $aO8Ot.createHash("ripemd160").update(sha).digest();
}
$438f01a446f2518b$var$HDKey.HARDENED_OFFSET = $438f01a446f2518b$var$HARDENED_OFFSET;
module.exports = $438f01a446f2518b$var$HDKey;

});
parcelRegister("aQkCV", function(module, exports) {
"use strict";


module.exports = (parcelRequire("cznCM"))((parcelRequire("bwAtR")));

});
parcelRegister("cznCM", function(module, exports) {
"use strict";

var $aPC7V = parcelRequire("aPC7V");

var $9Mrqr = parcelRequire("9Mrqr");

var $3sknh = parcelRequire("3sknh");
function $926b14420e43a0ea$var$initCompressedValue(value, defaultValue) {
    if (value === undefined) return defaultValue;
    $aPC7V.isBoolean(value, $3sknh.COMPRESSED_TYPE_INVALID);
    return value;
}
module.exports = function(secp256k1) {
    return {
        privateKeyVerify: function(privateKey) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            return privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey);
        },
        privateKeyExport: function(privateKey, compressed) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            var publicKey = secp256k1.privateKeyExport(privateKey, compressed);
            return $9Mrqr.privateKeyExport(privateKey, publicKey, compressed);
        },
        privateKeyImport: function(privateKey) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            privateKey = $9Mrqr.privateKeyImport(privateKey);
            if (privateKey && privateKey.length === 32 && secp256k1.privateKeyVerify(privateKey)) return privateKey;
            throw new Error($3sknh.EC_PRIVATE_KEY_IMPORT_DER_FAIL);
        },
        privateKeyNegate: function(privateKey) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            return secp256k1.privateKeyNegate(privateKey);
        },
        privateKeyModInverse: function(privateKey) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            return secp256k1.privateKeyModInverse(privateKey);
        },
        privateKeyTweakAdd: function(privateKey, tweak) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(tweak, $3sknh.TWEAK_TYPE_INVALID);
            $aPC7V.isBufferLength(tweak, 32, $3sknh.TWEAK_LENGTH_INVALID);
            return secp256k1.privateKeyTweakAdd(privateKey, tweak);
        },
        privateKeyTweakMul: function(privateKey, tweak) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(tweak, $3sknh.TWEAK_TYPE_INVALID);
            $aPC7V.isBufferLength(tweak, 32, $3sknh.TWEAK_LENGTH_INVALID);
            return secp256k1.privateKeyTweakMul(privateKey, tweak);
        },
        publicKeyCreate: function(privateKey, compressed) {
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.publicKeyCreate(privateKey, compressed);
        },
        publicKeyConvert: function(publicKey, compressed) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.publicKeyConvert(publicKey, compressed);
        },
        publicKeyVerify: function(publicKey) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            return secp256k1.publicKeyVerify(publicKey);
        },
        publicKeyTweakAdd: function(publicKey, tweak, compressed) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(tweak, $3sknh.TWEAK_TYPE_INVALID);
            $aPC7V.isBufferLength(tweak, 32, $3sknh.TWEAK_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.publicKeyTweakAdd(publicKey, tweak, compressed);
        },
        publicKeyTweakMul: function(publicKey, tweak, compressed) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(tweak, $3sknh.TWEAK_TYPE_INVALID);
            $aPC7V.isBufferLength(tweak, 32, $3sknh.TWEAK_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.publicKeyTweakMul(publicKey, tweak, compressed);
        },
        publicKeyCombine: function(publicKeys, compressed) {
            $aPC7V.isArray(publicKeys, $3sknh.EC_PUBLIC_KEYS_TYPE_INVALID);
            $aPC7V.isLengthGTZero(publicKeys, $3sknh.EC_PUBLIC_KEYS_LENGTH_INVALID);
            for(var i = 0; i < publicKeys.length; ++i){
                $aPC7V.isBuffer(publicKeys[i], $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
                $aPC7V.isBufferLength2(publicKeys[i], 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            }
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.publicKeyCombine(publicKeys, compressed);
        },
        signatureNormalize: function(signature) {
            $aPC7V.isBuffer(signature, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isBufferLength(signature, 64, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            return secp256k1.signatureNormalize(signature);
        },
        signatureExport: function(signature) {
            $aPC7V.isBuffer(signature, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isBufferLength(signature, 64, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            var sigObj = secp256k1.signatureExport(signature);
            return $9Mrqr.signatureExport(sigObj);
        },
        signatureImport: function(sig) {
            $aPC7V.isBuffer(sig, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isLengthGTZero(sig, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            var sigObj = $9Mrqr.signatureImport(sig);
            if (sigObj) return secp256k1.signatureImport(sigObj);
            throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        signatureImportLax: function(sig) {
            $aPC7V.isBuffer(sig, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isLengthGTZero(sig, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            var sigObj = $9Mrqr.signatureImportLax(sig);
            if (sigObj) return secp256k1.signatureImport(sigObj);
            throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_DER_FAIL);
        },
        sign: function(message, privateKey, options) {
            $aPC7V.isBuffer(message, $3sknh.MSG32_TYPE_INVALID);
            $aPC7V.isBufferLength(message, 32, $3sknh.MSG32_LENGTH_INVALID);
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            var data = null;
            var noncefn = null;
            if (options !== undefined) {
                $aPC7V.isObject(options, $3sknh.OPTIONS_TYPE_INVALID);
                if (options.data !== undefined) {
                    $aPC7V.isBuffer(options.data, $3sknh.OPTIONS_DATA_TYPE_INVALID);
                    $aPC7V.isBufferLength(options.data, 32, $3sknh.OPTIONS_DATA_LENGTH_INVALID);
                    data = options.data;
                }
                if (options.noncefn !== undefined) {
                    $aPC7V.isFunction(options.noncefn, $3sknh.OPTIONS_NONCEFN_TYPE_INVALID);
                    noncefn = options.noncefn;
                }
            }
            return secp256k1.sign(message, privateKey, noncefn, data);
        },
        verify: function(message, signature, publicKey) {
            $aPC7V.isBuffer(message, $3sknh.MSG32_TYPE_INVALID);
            $aPC7V.isBufferLength(message, 32, $3sknh.MSG32_LENGTH_INVALID);
            $aPC7V.isBuffer(signature, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isBufferLength(signature, 64, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            return secp256k1.verify(message, signature, publicKey);
        },
        recover: function(message, signature, recovery, compressed) {
            $aPC7V.isBuffer(message, $3sknh.MSG32_TYPE_INVALID);
            $aPC7V.isBufferLength(message, 32, $3sknh.MSG32_LENGTH_INVALID);
            $aPC7V.isBuffer(signature, $3sknh.ECDSA_SIGNATURE_TYPE_INVALID);
            $aPC7V.isBufferLength(signature, 64, $3sknh.ECDSA_SIGNATURE_LENGTH_INVALID);
            $aPC7V.isNumber(recovery, $3sknh.RECOVERY_ID_TYPE_INVALID);
            $aPC7V.isNumberInInterval(recovery, -1, 4, $3sknh.RECOVERY_ID_VALUE_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.recover(message, signature, recovery, compressed);
        },
        ecdh: function(publicKey, privateKey) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            return secp256k1.ecdh(publicKey, privateKey);
        },
        ecdhUnsafe: function(publicKey, privateKey, compressed) {
            $aPC7V.isBuffer(publicKey, $3sknh.EC_PUBLIC_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength2(publicKey, 33, 65, $3sknh.EC_PUBLIC_KEY_LENGTH_INVALID);
            $aPC7V.isBuffer(privateKey, $3sknh.EC_PRIVATE_KEY_TYPE_INVALID);
            $aPC7V.isBufferLength(privateKey, 32, $3sknh.EC_PRIVATE_KEY_LENGTH_INVALID);
            compressed = $926b14420e43a0ea$var$initCompressedValue(compressed, true);
            return secp256k1.ecdhUnsafe(publicKey, privateKey, compressed);
        }
    };
};

});
parcelRegister("aPC7V", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $7e2c3e004eef5b04$export$43bee75e5e14138e; }, function (v) { return $7e2c3e004eef5b04$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $7e2c3e004eef5b04$export$f9ce7b637dfbe238; }, function (v) { return $7e2c3e004eef5b04$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isBuffer", function () { return $7e2c3e004eef5b04$export$a7884ebc965f8f54; }, function (v) { return $7e2c3e004eef5b04$export$a7884ebc965f8f54 = v; });
$parcel$export(module.exports, "isFunction", function () { return $7e2c3e004eef5b04$export$f6e2535fb5126e54; }, function (v) { return $7e2c3e004eef5b04$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isNumber", function () { return $7e2c3e004eef5b04$export$7e4aa119212bc614; }, function (v) { return $7e2c3e004eef5b04$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isObject", function () { return $7e2c3e004eef5b04$export$a6cdc56e425d0d0a; }, function (v) { return $7e2c3e004eef5b04$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isBufferLength", function () { return $7e2c3e004eef5b04$export$74f50dd2ead4f1fe; }, function (v) { return $7e2c3e004eef5b04$export$74f50dd2ead4f1fe = v; });
$parcel$export(module.exports, "isBufferLength2", function () { return $7e2c3e004eef5b04$export$e372dc7853a56b71; }, function (v) { return $7e2c3e004eef5b04$export$e372dc7853a56b71 = v; });
$parcel$export(module.exports, "isLengthGTZero", function () { return $7e2c3e004eef5b04$export$53c68932468c0e2; }, function (v) { return $7e2c3e004eef5b04$export$53c68932468c0e2 = v; });
$parcel$export(module.exports, "isNumberInInterval", function () { return $7e2c3e004eef5b04$export$a6a0511d4e36c94c; }, function (v) { return $7e2c3e004eef5b04$export$a6a0511d4e36c94c = v; });
// TypeError
var $7e2c3e004eef5b04$export$43bee75e5e14138e;
var $7e2c3e004eef5b04$export$f9ce7b637dfbe238;
var $7e2c3e004eef5b04$export$a7884ebc965f8f54;
var $7e2c3e004eef5b04$export$f6e2535fb5126e54;
var $7e2c3e004eef5b04$export$7e4aa119212bc614;
var $7e2c3e004eef5b04$export$a6cdc56e425d0d0a;
// RangeError
var $7e2c3e004eef5b04$export$74f50dd2ead4f1fe;
var $7e2c3e004eef5b04$export$e372dc7853a56b71;
var $7e2c3e004eef5b04$export$53c68932468c0e2;
var $7e2c3e004eef5b04$export$a6a0511d4e36c94c;

var $ihoyg = parcelRequire("ihoyg");
var $7e2c3e004eef5b04$require$Buffer = $ihoyg.Buffer;
"use strict";
var $7e2c3e004eef5b04$var$toString = Object.prototype.toString;
$7e2c3e004eef5b04$export$43bee75e5e14138e = function(value, message) {
    if (!Array.isArray(value)) throw TypeError(message);
};
$7e2c3e004eef5b04$export$f9ce7b637dfbe238 = function(value, message) {
    if ($7e2c3e004eef5b04$var$toString.call(value) !== "[object Boolean]") throw TypeError(message);
};
$7e2c3e004eef5b04$export$a7884ebc965f8f54 = function(value, message) {
    if (!$7e2c3e004eef5b04$require$Buffer.isBuffer(value)) throw TypeError(message);
};
$7e2c3e004eef5b04$export$f6e2535fb5126e54 = function(value, message) {
    if ($7e2c3e004eef5b04$var$toString.call(value) !== "[object Function]") throw TypeError(message);
};
$7e2c3e004eef5b04$export$7e4aa119212bc614 = function(value, message) {
    if ($7e2c3e004eef5b04$var$toString.call(value) !== "[object Number]") throw TypeError(message);
};
$7e2c3e004eef5b04$export$a6cdc56e425d0d0a = function(value, message) {
    if ($7e2c3e004eef5b04$var$toString.call(value) !== "[object Object]") throw TypeError(message);
};
$7e2c3e004eef5b04$export$74f50dd2ead4f1fe = function(buffer, length, message) {
    if (buffer.length !== length) throw RangeError(message);
};
$7e2c3e004eef5b04$export$e372dc7853a56b71 = function(buffer, length1, length2, message) {
    if (buffer.length !== length1 && buffer.length !== length2) throw RangeError(message);
};
$7e2c3e004eef5b04$export$53c68932468c0e2 = function(value, message) {
    if (value.length === 0) throw RangeError(message);
};
$7e2c3e004eef5b04$export$a6a0511d4e36c94c = function(number, x, y, message) {
    if (number <= x || number >= y) throw RangeError(message);
};

});

parcelRegister("9Mrqr", function(module, exports) {

$parcel$export(module.exports, "privateKeyExport", function () { return $71eddee0a0b4321b$export$da25363cc147da82; }, function (v) { return $71eddee0a0b4321b$export$da25363cc147da82 = v; });
$parcel$export(module.exports, "privateKeyImport", function () { return $71eddee0a0b4321b$export$16ef149d7968ce6c; }, function (v) { return $71eddee0a0b4321b$export$16ef149d7968ce6c = v; });
$parcel$export(module.exports, "signatureExport", function () { return $71eddee0a0b4321b$export$4ffad7338677afea; }, function (v) { return $71eddee0a0b4321b$export$4ffad7338677afea = v; });
$parcel$export(module.exports, "signatureImport", function () { return $71eddee0a0b4321b$export$427e0c30f94850c1; }, function (v) { return $71eddee0a0b4321b$export$427e0c30f94850c1 = v; });
$parcel$export(module.exports, "signatureImportLax", function () { return $71eddee0a0b4321b$export$f3974ff10c129f6b; }, function (v) { return $71eddee0a0b4321b$export$f3974ff10c129f6b = v; });
var $71eddee0a0b4321b$export$da25363cc147da82;
var $71eddee0a0b4321b$export$16ef149d7968ce6c;
var $71eddee0a0b4321b$export$4ffad7338677afea;
var $71eddee0a0b4321b$export$427e0c30f94850c1;
var $71eddee0a0b4321b$export$f3974ff10c129f6b;
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $71eddee0a0b4321b$require$Buffer = $6U9mG.Buffer;

var $1iXiz = parcelRequire("1iXiz");
var $71eddee0a0b4321b$var$EC_PRIVKEY_EXPORT_DER_COMPRESSED = $71eddee0a0b4321b$require$Buffer.from([
    // begin
    0x30,
    0x81,
    0xd3,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0x85,
    0x30,
    0x81,
    0x82,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xcE,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfE,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x21,
    0x02,
    0x79,
    0xbE,
    0x66,
    0x7E,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xcE,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xcE,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfE,
    0xba,
    0xaE,
    0xdc,
    0xE6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5E,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x24,
    0x03,
    0x22,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
var $71eddee0a0b4321b$var$EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED = $71eddee0a0b4321b$require$Buffer.from([
    // begin
    0x30,
    0x82,
    0x01,
    0x13,
    0x02,
    0x01,
    0x01,
    0x04,
    0x20,
    // private key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    // middle
    0xa0,
    0x81,
    0xa5,
    0x30,
    0x81,
    0xa2,
    0x02,
    0x01,
    0x01,
    0x30,
    0x2c,
    0x06,
    0x07,
    0x2a,
    0x86,
    0x48,
    0xcE,
    0x3d,
    0x01,
    0x01,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfE,
    0xff,
    0xff,
    0xfc,
    0x2f,
    0x30,
    0x06,
    0x04,
    0x01,
    0x00,
    0x04,
    0x01,
    0x07,
    0x04,
    0x41,
    0x04,
    0x79,
    0xbE,
    0x66,
    0x7E,
    0xf9,
    0xdc,
    0xbb,
    0xac,
    0x55,
    0xa0,
    0x62,
    0x95,
    0xcE,
    0x87,
    0x0b,
    0x07,
    0x02,
    0x9b,
    0xfc,
    0xdb,
    0x2d,
    0xcE,
    0x28,
    0xd9,
    0x59,
    0xf2,
    0x81,
    0x5b,
    0x16,
    0xf8,
    0x17,
    0x98,
    0x48,
    0x3a,
    0xda,
    0x77,
    0x26,
    0xa3,
    0xc4,
    0x65,
    0x5d,
    0xa4,
    0xfb,
    0xfc,
    0x0E,
    0x11,
    0x08,
    0xa8,
    0xfd,
    0x17,
    0xb4,
    0x48,
    0xa6,
    0x85,
    0x54,
    0x19,
    0x9c,
    0x47,
    0xd0,
    0x8f,
    0xfb,
    0x10,
    0xd4,
    0xb8,
    0x02,
    0x21,
    0x00,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xff,
    0xfE,
    0xba,
    0xaE,
    0xdc,
    0xE6,
    0xaf,
    0x48,
    0xa0,
    0x3b,
    0xbf,
    0xd2,
    0x5E,
    0x8c,
    0xd0,
    0x36,
    0x41,
    0x41,
    0x02,
    0x01,
    0x01,
    0xa1,
    0x44,
    0x03,
    0x42,
    0x00,
    // public key
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00
]);
$71eddee0a0b4321b$export$da25363cc147da82 = function(privateKey, publicKey, compressed) {
    var result = $71eddee0a0b4321b$require$Buffer.from(compressed ? $71eddee0a0b4321b$var$EC_PRIVKEY_EXPORT_DER_COMPRESSED : $71eddee0a0b4321b$var$EC_PRIVKEY_EXPORT_DER_UNCOMPRESSED);
    privateKey.copy(result, compressed ? 8 : 9);
    publicKey.copy(result, compressed ? 181 : 214);
    return result;
};
$71eddee0a0b4321b$export$16ef149d7968ce6c = function(privateKey) {
    var length = privateKey.length;
    // sequence header
    var index = 0;
    if (length < index + 1 || privateKey[index] !== 0x30) return;
    index += 1;
    // sequence length constructor
    if (length < index + 1 || !(privateKey[index] & 0x80)) return;
    var lenb = privateKey[index] & 0x7f;
    index += 1;
    if (lenb < 1 || lenb > 2) return;
    if (length < index + lenb) return;
    // sequence length
    var len = privateKey[index + lenb - 1] | (lenb > 1 ? privateKey[index + lenb - 2] << 8 : 0);
    index += lenb;
    if (length < index + len) return;
    // sequence element 0: version number (=1)
    if (length < index + 3 || privateKey[index] !== 0x02 || privateKey[index + 1] !== 0x01 || privateKey[index + 2] !== 0x01) return;
    index += 3;
    // sequence element 1: octet string, up to 32 bytes
    if (length < index + 2 || privateKey[index] !== 0x04 || privateKey[index + 1] > 0x20 || length < index + 2 + privateKey[index + 1]) return;
    return privateKey.slice(index + 2, index + 2 + privateKey[index + 1]);
};
$71eddee0a0b4321b$export$4ffad7338677afea = function(sigObj) {
    var r = $71eddee0a0b4321b$require$Buffer.concat([
        $71eddee0a0b4321b$require$Buffer.from([
            0
        ]),
        sigObj.r
    ]);
    for(var lenR = 33, posR = 0; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
    var s = $71eddee0a0b4321b$require$Buffer.concat([
        $71eddee0a0b4321b$require$Buffer.from([
            0
        ]),
        sigObj.s
    ]);
    for(var lenS = 33, posS = 0; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
    return $1iXiz.encode(r.slice(posR), s.slice(posS));
};
$71eddee0a0b4321b$export$427e0c30f94850c1 = function(sig) {
    var r = $71eddee0a0b4321b$require$Buffer.alloc(32, 0);
    var s = $71eddee0a0b4321b$require$Buffer.alloc(32, 0);
    try {
        var sigObj = $1iXiz.decode(sig);
        if (sigObj.r.length === 33 && sigObj.r[0] === 0x00) sigObj.r = sigObj.r.slice(1);
        if (sigObj.r.length > 32) throw new Error("R length is too long");
        if (sigObj.s.length === 33 && sigObj.s[0] === 0x00) sigObj.s = sigObj.s.slice(1);
        if (sigObj.s.length > 32) throw new Error("S length is too long");
    } catch (err) {
        return;
    }
    sigObj.r.copy(r, 32 - sigObj.r.length);
    sigObj.s.copy(s, 32 - sigObj.s.length);
    return {
        r: r,
        s: s
    };
};
$71eddee0a0b4321b$export$f3974ff10c129f6b = function(sig) {
    var r = $71eddee0a0b4321b$require$Buffer.alloc(32, 0);
    var s = $71eddee0a0b4321b$require$Buffer.alloc(32, 0);
    var length = sig.length;
    var index = 0;
    // sequence tag byte
    if (sig[index++] !== 0x30) return;
    // sequence length byte
    var lenbyte = sig[index++];
    if (lenbyte & 0x80) {
        index += lenbyte - 0x80;
        if (index > length) return;
    }
    // sequence tag byte for r
    if (sig[index++] !== 0x02) return;
    // length for r
    var rlen = sig[index++];
    if (rlen & 0x80) {
        lenbyte = rlen - 0x80;
        if (index + lenbyte > length) return;
        for(; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
        for(rlen = 0; lenbyte > 0; index += 1, lenbyte -= 1)rlen = (rlen << 8) + sig[index];
    }
    if (rlen > length - index) return;
    var rindex = index;
    index += rlen;
    // sequence tag byte for s
    if (sig[index++] !== 0x02) return;
    // length for s
    var slen = sig[index++];
    if (slen & 0x80) {
        lenbyte = slen - 0x80;
        if (index + lenbyte > length) return;
        for(; lenbyte > 0 && sig[index] === 0x00; index += 1, lenbyte -= 1);
        for(slen = 0; lenbyte > 0; index += 1, lenbyte -= 1)slen = (slen << 8) + sig[index];
    }
    if (slen > length - index) return;
    var sindex = index;
    index += slen;
    // ignore leading zeros in r
    for(; rlen > 0 && sig[rindex] === 0x00; rlen -= 1, rindex += 1);
    // copy r value
    if (rlen > 32) return;
    var rvalue = sig.slice(rindex, rindex + rlen);
    rvalue.copy(r, 32 - rvalue.length);
    // ignore leading zeros in s
    for(; slen > 0 && sig[sindex] === 0x00; slen -= 1, sindex += 1);
    // copy s value
    if (slen > 32) return;
    var svalue = sig.slice(sindex, sindex + slen);
    svalue.copy(s, 32 - svalue.length);
    return {
        r: r,
        s: s
    };
};

});

parcelRegister("3sknh", function(module, exports) {
module.exports = JSON.parse('{"COMPRESSED_TYPE_INVALID":"compressed should be a boolean","EC_PRIVATE_KEY_TYPE_INVALID":"private key should be a Buffer","EC_PRIVATE_KEY_LENGTH_INVALID":"private key length is invalid","EC_PRIVATE_KEY_RANGE_INVALID":"private key range is invalid","EC_PRIVATE_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting private key is invalid","EC_PRIVATE_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PRIVATE_KEY_EXPORT_DER_FAIL":"couldn\'t export to DER format","EC_PRIVATE_KEY_IMPORT_DER_FAIL":"couldn\'t import from DER format","EC_PUBLIC_KEYS_TYPE_INVALID":"public keys should be an Array","EC_PUBLIC_KEYS_LENGTH_INVALID":"public keys Array should have at least 1 element","EC_PUBLIC_KEY_TYPE_INVALID":"public key should be a Buffer","EC_PUBLIC_KEY_LENGTH_INVALID":"public key length is invalid","EC_PUBLIC_KEY_PARSE_FAIL":"the public key could not be parsed or is invalid","EC_PUBLIC_KEY_CREATE_FAIL":"private was invalid, try again","EC_PUBLIC_KEY_TWEAK_ADD_FAIL":"tweak out of range or resulting public key is invalid","EC_PUBLIC_KEY_TWEAK_MUL_FAIL":"tweak out of range","EC_PUBLIC_KEY_COMBINE_FAIL":"the sum of the public keys is not valid","ECDH_FAIL":"scalar was invalid (zero or overflow)","ECDSA_SIGNATURE_TYPE_INVALID":"signature should be a Buffer","ECDSA_SIGNATURE_LENGTH_INVALID":"signature length is invalid","ECDSA_SIGNATURE_PARSE_FAIL":"couldn\'t parse signature","ECDSA_SIGNATURE_PARSE_DER_FAIL":"couldn\'t parse DER signature","ECDSA_SIGNATURE_SERIALIZE_DER_FAIL":"couldn\'t serialize signature to DER format","ECDSA_SIGN_FAIL":"nonce generation function failed or private key is invalid","ECDSA_RECOVER_FAIL":"couldn\'t recover public key from signature","MSG32_TYPE_INVALID":"message should be a Buffer","MSG32_LENGTH_INVALID":"message length is invalid","OPTIONS_TYPE_INVALID":"options should be an Object","OPTIONS_DATA_TYPE_INVALID":"options.data should be a Buffer","OPTIONS_DATA_LENGTH_INVALID":"options.data length is invalid","OPTIONS_NONCEFN_TYPE_INVALID":"options.noncefn should be a Function","RECOVERY_ID_TYPE_INVALID":"recovery should be a Number","RECOVERY_ID_VALUE_INVALID":"recovery should have value between -1 and 4","TWEAK_TYPE_INVALID":"tweak should be a Buffer","TWEAK_LENGTH_INVALID":"tweak length is invalid"}');

});


parcelRegister("bwAtR", function(module, exports) {

$parcel$export(module.exports, "privateKeyVerify", function () { return $863efb2b6ba4a23f$export$43387a42c47703b8; }, function (v) { return $863efb2b6ba4a23f$export$43387a42c47703b8 = v; });
$parcel$export(module.exports, "privateKeyExport", function () { return $863efb2b6ba4a23f$export$da25363cc147da82; }, function (v) { return $863efb2b6ba4a23f$export$da25363cc147da82 = v; });
$parcel$export(module.exports, "privateKeyNegate", function () { return $863efb2b6ba4a23f$export$3bbd5c7db180be03; }, function (v) { return $863efb2b6ba4a23f$export$3bbd5c7db180be03 = v; });
$parcel$export(module.exports, "privateKeyModInverse", function () { return $863efb2b6ba4a23f$export$52775cb7d64c9e44; }, function (v) { return $863efb2b6ba4a23f$export$52775cb7d64c9e44 = v; });
$parcel$export(module.exports, "privateKeyTweakAdd", function () { return $863efb2b6ba4a23f$export$1a2ef6d344529e2d; }, function (v) { return $863efb2b6ba4a23f$export$1a2ef6d344529e2d = v; });
$parcel$export(module.exports, "privateKeyTweakMul", function () { return $863efb2b6ba4a23f$export$a4e255c77ae80f51; }, function (v) { return $863efb2b6ba4a23f$export$a4e255c77ae80f51 = v; });
$parcel$export(module.exports, "publicKeyCreate", function () { return $863efb2b6ba4a23f$export$66be53936583a0f6; }, function (v) { return $863efb2b6ba4a23f$export$66be53936583a0f6 = v; });
$parcel$export(module.exports, "publicKeyConvert", function () { return $863efb2b6ba4a23f$export$1524988fa2424749; }, function (v) { return $863efb2b6ba4a23f$export$1524988fa2424749 = v; });
$parcel$export(module.exports, "publicKeyVerify", function () { return $863efb2b6ba4a23f$export$7a28c8da66b1f923; }, function (v) { return $863efb2b6ba4a23f$export$7a28c8da66b1f923 = v; });
$parcel$export(module.exports, "publicKeyTweakAdd", function () { return $863efb2b6ba4a23f$export$3d699fd11585899e; }, function (v) { return $863efb2b6ba4a23f$export$3d699fd11585899e = v; });
$parcel$export(module.exports, "publicKeyTweakMul", function () { return $863efb2b6ba4a23f$export$dc654edde107d334; }, function (v) { return $863efb2b6ba4a23f$export$dc654edde107d334 = v; });
$parcel$export(module.exports, "publicKeyCombine", function () { return $863efb2b6ba4a23f$export$a26edd07cc3f88a5; }, function (v) { return $863efb2b6ba4a23f$export$a26edd07cc3f88a5 = v; });
$parcel$export(module.exports, "signatureNormalize", function () { return $863efb2b6ba4a23f$export$19c6a8d4606756cb; }, function (v) { return $863efb2b6ba4a23f$export$19c6a8d4606756cb = v; });
$parcel$export(module.exports, "signatureExport", function () { return $863efb2b6ba4a23f$export$4ffad7338677afea; }, function (v) { return $863efb2b6ba4a23f$export$4ffad7338677afea = v; });
$parcel$export(module.exports, "signatureImport", function () { return $863efb2b6ba4a23f$export$427e0c30f94850c1; }, function (v) { return $863efb2b6ba4a23f$export$427e0c30f94850c1 = v; });
$parcel$export(module.exports, "sign", function () { return $863efb2b6ba4a23f$export$c5552dfdbc7cec71; }, function (v) { return $863efb2b6ba4a23f$export$c5552dfdbc7cec71 = v; });
$parcel$export(module.exports, "verify", function () { return $863efb2b6ba4a23f$export$532244b5b8b0b4b6; }, function (v) { return $863efb2b6ba4a23f$export$532244b5b8b0b4b6 = v; });
$parcel$export(module.exports, "recover", function () { return $863efb2b6ba4a23f$export$93ab2aa612d670ae; }, function (v) { return $863efb2b6ba4a23f$export$93ab2aa612d670ae = v; });
$parcel$export(module.exports, "ecdh", function () { return $863efb2b6ba4a23f$export$cb44b25bcf287f5d; }, function (v) { return $863efb2b6ba4a23f$export$cb44b25bcf287f5d = v; });
$parcel$export(module.exports, "ecdhUnsafe", function () { return $863efb2b6ba4a23f$export$db6ba80d232d5f1a; }, function (v) { return $863efb2b6ba4a23f$export$db6ba80d232d5f1a = v; });
var $863efb2b6ba4a23f$export$43387a42c47703b8;
var $863efb2b6ba4a23f$export$da25363cc147da82;
var $863efb2b6ba4a23f$export$3bbd5c7db180be03;
var $863efb2b6ba4a23f$export$52775cb7d64c9e44;
var $863efb2b6ba4a23f$export$1a2ef6d344529e2d;
var $863efb2b6ba4a23f$export$a4e255c77ae80f51;
var $863efb2b6ba4a23f$export$66be53936583a0f6;
var $863efb2b6ba4a23f$export$1524988fa2424749;
var $863efb2b6ba4a23f$export$7a28c8da66b1f923;
var $863efb2b6ba4a23f$export$3d699fd11585899e;
var $863efb2b6ba4a23f$export$dc654edde107d334;
var $863efb2b6ba4a23f$export$a26edd07cc3f88a5;
var $863efb2b6ba4a23f$export$19c6a8d4606756cb;
var $863efb2b6ba4a23f$export$4ffad7338677afea;
var $863efb2b6ba4a23f$export$427e0c30f94850c1;
var $863efb2b6ba4a23f$export$c5552dfdbc7cec71;
var $863efb2b6ba4a23f$export$532244b5b8b0b4b6;
var $863efb2b6ba4a23f$export$93ab2aa612d670ae;
var $863efb2b6ba4a23f$export$cb44b25bcf287f5d;
var $863efb2b6ba4a23f$export$db6ba80d232d5f1a;
"use strict";

var $6U9mG = parcelRequire("6U9mG");
var $863efb2b6ba4a23f$require$Buffer = $6U9mG.Buffer;

var $3FiLE = parcelRequire("3FiLE");

var $7vYz3 = parcelRequire("7vYz3");

var $8J1ou = parcelRequire("8J1ou");
var $863efb2b6ba4a23f$require$EC = $8J1ou.ec;

var $3sknh = parcelRequire("3sknh");
var $863efb2b6ba4a23f$var$ec = new $863efb2b6ba4a23f$require$EC("secp256k1");
var $863efb2b6ba4a23f$var$ecparams = $863efb2b6ba4a23f$var$ec.curve;
function $863efb2b6ba4a23f$var$loadCompressedPublicKey(first, xBuffer) {
    var x = new $7vYz3(xBuffer);
    // overflow
    if (x.cmp($863efb2b6ba4a23f$var$ecparams.p) >= 0) return null;
    x = x.toRed($863efb2b6ba4a23f$var$ecparams.red);
    // compute corresponding Y
    var y = x.redSqr().redIMul(x).redIAdd($863efb2b6ba4a23f$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    return $863efb2b6ba4a23f$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $863efb2b6ba4a23f$var$loadUncompressedPublicKey(first, xBuffer, yBuffer) {
    var x = new $7vYz3(xBuffer);
    var y = new $7vYz3(yBuffer);
    // overflow
    if (x.cmp($863efb2b6ba4a23f$var$ecparams.p) >= 0 || y.cmp($863efb2b6ba4a23f$var$ecparams.p) >= 0) return null;
    x = x.toRed($863efb2b6ba4a23f$var$ecparams.red);
    y = y.toRed($863efb2b6ba4a23f$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    var x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($863efb2b6ba4a23f$var$ecparams.b)).isZero()) return null;
    return $863efb2b6ba4a23f$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $863efb2b6ba4a23f$var$loadPublicKey(publicKey) {
    var first = publicKey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (publicKey.length !== 33) return null;
            return $863efb2b6ba4a23f$var$loadCompressedPublicKey(first, publicKey.slice(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (publicKey.length !== 65) return null;
            return $863efb2b6ba4a23f$var$loadUncompressedPublicKey(first, publicKey.slice(1, 33), publicKey.slice(33, 65));
        default:
            return null;
    }
}
$863efb2b6ba4a23f$export$43387a42c47703b8 = function(privateKey) {
    var bn = new $7vYz3(privateKey);
    return bn.cmp($863efb2b6ba4a23f$var$ecparams.n) < 0 && !bn.isZero();
};
$863efb2b6ba4a23f$export$da25363cc147da82 = function(privateKey, compressed) {
    var d = new $7vYz3(privateKey);
    if (d.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || d.isZero()) throw new Error($3sknh.EC_PRIVATE_KEY_EXPORT_DER_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from($863efb2b6ba4a23f$var$ec.keyFromPrivate(privateKey).getPublic(compressed, true));
};
$863efb2b6ba4a23f$export$3bbd5c7db180be03 = function(privateKey) {
    var bn = new $7vYz3(privateKey);
    return bn.isZero() ? $863efb2b6ba4a23f$require$Buffer.alloc(32) : $863efb2b6ba4a23f$var$ecparams.n.sub(bn).umod($863efb2b6ba4a23f$var$ecparams.n).toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32);
};
$863efb2b6ba4a23f$export$52775cb7d64c9e44 = function(privateKey) {
    var bn = new $7vYz3(privateKey);
    if (bn.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || bn.isZero()) throw new Error($3sknh.EC_PRIVATE_KEY_RANGE_INVALID);
    return bn.invm($863efb2b6ba4a23f$var$ecparams.n).toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32);
};
$863efb2b6ba4a23f$export$1a2ef6d344529e2d = function(privateKey, tweak) {
    var bn = new $7vYz3(tweak);
    if (bn.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
    bn.iadd(new $7vYz3(privateKey));
    if (bn.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) bn.isub($863efb2b6ba4a23f$var$ecparams.n);
    if (bn.isZero()) throw new Error($3sknh.EC_PRIVATE_KEY_TWEAK_ADD_FAIL);
    return bn.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32);
};
$863efb2b6ba4a23f$export$a4e255c77ae80f51 = function(privateKey, tweak) {
    var bn = new $7vYz3(tweak);
    if (bn.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || bn.isZero()) throw new Error($3sknh.EC_PRIVATE_KEY_TWEAK_MUL_FAIL);
    bn.imul(new $7vYz3(privateKey));
    if (bn.cmp($863efb2b6ba4a23f$var$ecparams.n)) bn = bn.umod($863efb2b6ba4a23f$var$ecparams.n);
    return bn.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32);
};
$863efb2b6ba4a23f$export$66be53936583a0f6 = function(privateKey, compressed) {
    var d = new $7vYz3(privateKey);
    if (d.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || d.isZero()) throw new Error($3sknh.EC_PUBLIC_KEY_CREATE_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from($863efb2b6ba4a23f$var$ec.keyFromPrivate(privateKey).getPublic(compressed, true));
};
$863efb2b6ba4a23f$export$1524988fa2424749 = function(publicKey, compressed) {
    var pair = $863efb2b6ba4a23f$var$loadPublicKey(publicKey);
    if (pair === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from(pair.getPublic(compressed, true));
};
$863efb2b6ba4a23f$export$7a28c8da66b1f923 = function(publicKey) {
    return $863efb2b6ba4a23f$var$loadPublicKey(publicKey) !== null;
};
$863efb2b6ba4a23f$export$3d699fd11585899e = function(publicKey, tweak, compressed) {
    var pair = $863efb2b6ba4a23f$var$loadPublicKey(publicKey);
    if (pair === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    tweak = new $7vYz3(tweak);
    if (tweak.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
    var point = $863efb2b6ba4a23f$var$ecparams.g.mul(tweak).add(pair.pub);
    if (point.isInfinity()) throw new Error($3sknh.EC_PUBLIC_KEY_TWEAK_ADD_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from(point.encode(true, compressed));
};
$863efb2b6ba4a23f$export$dc654edde107d334 = function(publicKey, tweak, compressed) {
    var pair = $863efb2b6ba4a23f$var$loadPublicKey(publicKey);
    if (pair === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    tweak = new $7vYz3(tweak);
    if (tweak.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || tweak.isZero()) throw new Error($3sknh.EC_PUBLIC_KEY_TWEAK_MUL_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from(pair.pub.mul(tweak).encode(true, compressed));
};
$863efb2b6ba4a23f$export$a26edd07cc3f88a5 = function(publicKeys, compressed) {
    var pairs = new Array(publicKeys.length);
    for(var i = 0; i < publicKeys.length; ++i){
        pairs[i] = $863efb2b6ba4a23f$var$loadPublicKey(publicKeys[i]);
        if (pairs[i] === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    }
    var point = pairs[0].pub;
    for(var j = 1; j < pairs.length; ++j)point = point.add(pairs[j].pub);
    if (point.isInfinity()) throw new Error($3sknh.EC_PUBLIC_KEY_COMBINE_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from(point.encode(true, compressed));
};
$863efb2b6ba4a23f$export$19c6a8d4606756cb = function(signature) {
    var r = new $7vYz3(signature.slice(0, 32));
    var s = new $7vYz3(signature.slice(32, 64));
    if (r.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || s.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_FAIL);
    var result = $863efb2b6ba4a23f$require$Buffer.from(signature);
    if (s.cmp($863efb2b6ba4a23f$var$ec.nh) === 1) $863efb2b6ba4a23f$var$ecparams.n.sub(s).toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32).copy(result, 32);
    return result;
};
$863efb2b6ba4a23f$export$4ffad7338677afea = function(signature) {
    var r = signature.slice(0, 32);
    var s = signature.slice(32, 64);
    if (new $7vYz3(r).cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || new $7vYz3(s).cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_FAIL);
    return {
        r: r,
        s: s
    };
};
$863efb2b6ba4a23f$export$427e0c30f94850c1 = function(sigObj) {
    var r = new $7vYz3(sigObj.r);
    if (r.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) r = new $7vYz3(0);
    var s = new $7vYz3(sigObj.s);
    if (s.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) s = new $7vYz3(0);
    return $863efb2b6ba4a23f$require$Buffer.concat([
        r.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32),
        s.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32)
    ]);
};
$863efb2b6ba4a23f$export$c5552dfdbc7cec71 = function(message, privateKey, noncefn, data) {
    if (typeof noncefn === "function") {
        var getNonce = noncefn;
        noncefn = function(counter) {
            var nonce = getNonce(message, privateKey, null, data, counter);
            if (!$863efb2b6ba4a23f$require$Buffer.isBuffer(nonce) || nonce.length !== 32) throw new Error($3sknh.ECDSA_SIGN_FAIL);
            return new $7vYz3(nonce);
        };
    }
    var d = new $7vYz3(privateKey);
    if (d.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || d.isZero()) throw new Error($3sknh.ECDSA_SIGN_FAIL);
    var result = $863efb2b6ba4a23f$var$ec.sign(message, privateKey, {
        canonical: true,
        k: noncefn,
        pers: data
    });
    return {
        signature: $863efb2b6ba4a23f$require$Buffer.concat([
            result.r.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32),
            result.s.toArrayLike($863efb2b6ba4a23f$require$Buffer, "be", 32)
        ]),
        recovery: result.recoveryParam
    };
};
$863efb2b6ba4a23f$export$532244b5b8b0b4b6 = function(message, signature, publicKey) {
    var sigObj = {
        r: signature.slice(0, 32),
        s: signature.slice(32, 64)
    };
    var sigr = new $7vYz3(sigObj.r);
    var sigs = new $7vYz3(sigObj.s);
    if (sigr.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || sigs.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_FAIL);
    if (sigs.cmp($863efb2b6ba4a23f$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return false;
    var pair = $863efb2b6ba4a23f$var$loadPublicKey(publicKey);
    if (pair === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    return $863efb2b6ba4a23f$var$ec.verify(message, sigObj, {
        x: pair.pub.x,
        y: pair.pub.y
    });
};
$863efb2b6ba4a23f$export$93ab2aa612d670ae = function(message, signature, recovery, compressed) {
    var sigObj = {
        r: signature.slice(0, 32),
        s: signature.slice(32, 64)
    };
    var sigr = new $7vYz3(sigObj.r);
    var sigs = new $7vYz3(sigObj.s);
    if (sigr.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || sigs.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0) throw new Error($3sknh.ECDSA_SIGNATURE_PARSE_FAIL);
    try {
        if (sigr.isZero() || sigs.isZero()) throw new Error();
        var point = $863efb2b6ba4a23f$var$ec.recoverPubKey(message, sigObj, recovery);
        return $863efb2b6ba4a23f$require$Buffer.from(point.encode(true, compressed));
    } catch (err) {
        throw new Error($3sknh.ECDSA_RECOVER_FAIL);
    }
};
$863efb2b6ba4a23f$export$cb44b25bcf287f5d = function(publicKey, privateKey) {
    var shared = $863efb2b6ba4a23f$export$db6ba80d232d5f1a(publicKey, privateKey, true);
    return $3FiLE("sha256").update(shared).digest();
};
$863efb2b6ba4a23f$export$db6ba80d232d5f1a = function(publicKey, privateKey, compressed) {
    var pair = $863efb2b6ba4a23f$var$loadPublicKey(publicKey);
    if (pair === null) throw new Error($3sknh.EC_PUBLIC_KEY_PARSE_FAIL);
    var scalar = new $7vYz3(privateKey);
    if (scalar.cmp($863efb2b6ba4a23f$var$ecparams.n) >= 0 || scalar.isZero()) throw new Error($3sknh.ECDH_FAIL);
    return $863efb2b6ba4a23f$require$Buffer.from(pair.pub.mul(scalar).encode(true, compressed));
};

});




parcelRegister("6fIKZ", function(module, exports) {
"use strict";
// ref: https://github.com/tc39/proposal-global
var getGlobal = function() {
    // the only reliable means to get the global object is
    // `Function('return this')()`
    // However, this causes CSP violations in Chrome apps.
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof global !== "undefined") return global;
    throw new Error("unable to locate global object");
};
var global = getGlobal();
module.exports = exports = global.fetch;
// Needed for TypeScript and Webpack.
if (global.fetch) exports.default = global.fetch.bind(global);
exports.Headers = global.Headers;
exports.Request = global.Request;
exports.Response = global.Response;

});


parcelRegister("1OmgF", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $151bbbe50b950f28$require$Buffer = $ihoyg.Buffer;
"use strict";
var $151bbbe50b950f28$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $151bbbe50b950f28$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $151bbbe50b950f28$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $151bbbe50b950f28$var$__createBinding(result, mod, k);
    }
    $151bbbe50b950f28$var$__setModuleDefault(result, mod);
    return result;
};
var $151bbbe50b950f28$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $151bbbe50b950f28$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $151bbbe50b950f28$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $151bbbe50b950f28$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeKavaWallet = module.exports.MixinNativeKavaWalletInfo = void 0;

const $151bbbe50b950f28$var$core = $151bbbe50b950f28$var$__importStar((parcelRequire("lFpDy")));

const $151bbbe50b950f28$var$bech32 = $151bbbe50b950f28$var$__importStar((parcelRequire("5wgCY")));

const $151bbbe50b950f28$var$crypto_js_1 = $151bbbe50b950f28$var$__importDefault((parcelRequire("kWcCv")));

const $151bbbe50b950f28$var$txBuilder = $151bbbe50b950f28$var$__importStar((parcelRequire("1Zjh6")));

const $151bbbe50b950f28$var$Isolation = $151bbbe50b950f28$var$__importStar((parcelRequire("aCCM0")));

const $151bbbe50b950f28$var$util = $151bbbe50b950f28$var$__importStar((parcelRequire("byiQW")));
function $151bbbe50b950f28$var$MixinNativeKavaWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeKavaWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsKavaInfo = true;
        }
        kavaSupportsNetwork() {
            return $151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        kavaSupportsSecureTransfer() {
            return $151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        kavaSupportsNativeShapeShift() {
            return false;
        }
        kavaGetAccountPaths(msg) {
            const slip44 = $151bbbe50b950f28$var$core.slip44ByCoin("Kava");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        kavaNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeKavaWalletInfo = $151bbbe50b950f28$var$MixinNativeKavaWalletInfo;
function $151bbbe50b950f28$var$MixinNativeKavaWallet(Base) {
    var _MixinNativeKavaWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeKavaWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsKava = true;
            _MixinNativeKavaWallet_masterKey.set(this, void 0);
        }
        kavaInitializeWallet(masterKey) {
            return $151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                $151bbbe50b950f28$var$__classPrivateFieldSet(this, _MixinNativeKavaWallet_masterKey, masterKey, "f");
            });
        }
        kavaWipe() {
            $151bbbe50b950f28$var$__classPrivateFieldSet(this, _MixinNativeKavaWallet_masterKey, undefined, "f");
        }
        kavaBech32ify(address, prefix) {
            const words = $151bbbe50b950f28$var$bech32.toWords(address);
            return $151bbbe50b950f28$var$bech32.encode(prefix, words);
        }
        createKavaAddress(publicKey) {
            const message = $151bbbe50b950f28$var$crypto_js_1.default.SHA256($151bbbe50b950f28$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $151bbbe50b950f28$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $151bbbe50b950f28$require$Buffer.from(hash, `hex`);
            return this.kavaBech32ify(address, `kava`);
        }
        kavaGetAddress(msg) {
            return $151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$151bbbe50b950f28$var$__classPrivateFieldGet(this, _MixinNativeKavaWallet_masterKey, "f"), ()=>$151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $151bbbe50b950f28$var$util.getKeyPair($151bbbe50b950f28$var$__classPrivateFieldGet(this, _MixinNativeKavaWallet_masterKey, "f"), msg.addressNList, "kava");
                        return this.createKavaAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        kavaSignTx(msg) {
            return $151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$151bbbe50b950f28$var$__classPrivateFieldGet(this, _MixinNativeKavaWallet_masterKey, "f"), ()=>$151bbbe50b950f28$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $151bbbe50b950f28$var$util.getKeyPair($151bbbe50b950f28$var$__classPrivateFieldGet(this, _MixinNativeKavaWallet_masterKey, "f"), msg.addressNList, "kava");
                        // @TODO: This needs to be fixed after the change to tendermint serialization
                        const adapter = yield $151bbbe50b950f28$var$Isolation.Adapters.Cosmos.create(keyPair);
                        const result = yield $151bbbe50b950f28$var$txBuilder.sign(msg.tx, adapter, msg.sequence, msg.account_number, msg.chain_id);
                        return $151bbbe50b950f28$var$txBuilder.createSignedTx(msg.tx, result);
                    }));
            });
        }
    }, _MixinNativeKavaWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeKavaWallet = $151bbbe50b950f28$var$MixinNativeKavaWallet;

});
parcelRegister("1Zjh6", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $172a7084ee847d4e$require$Buffer = $ihoyg.Buffer;
"use strict";
var $172a7084ee847d4e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $172a7084ee847d4e$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createSignedTx = module.exports.sign = void 0;

var $aQkCV = parcelRequire("aQkCV");

var $hNROW = parcelRequire("hNROW");
function $172a7084ee847d4e$var$sign(jsonTx, wallet, sequence, account_number, chain_id) {
    return $172a7084ee847d4e$var$__awaiter(this, void 0, void 0, function() {
        var tag, signMessage, signatureBuffer, pubKeyBuffer, e_1;
        return $172a7084ee847d4e$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    tag = " | sign | ";
                    _a.label = 1;
                case 1:
                    _a.trys.push([
                        1,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        $172a7084ee847d4e$var$create_sign_message(jsonTx, sequence, account_number, chain_id)
                    ];
                case 2:
                    signMessage = _a.sent();
                    return [
                        4 /*yield*/ ,
                        $172a7084ee847d4e$var$sign_with_privkey(signMessage, wallet.privateKey !== undefined ? wallet.privateKey : wallet)
                    ];
                case 3:
                    signatureBuffer = _a.sent();
                    pubKeyBuffer = $172a7084ee847d4e$require$Buffer.from(wallet.publicKey, "hex");
                    return [
                        2 /*return*/ ,
                        $172a7084ee847d4e$var$format_signature(signatureBuffer, pubKeyBuffer)
                    ];
                case 4:
                    e_1 = _a.sent();
                    console.error(tag, "e: ", e_1);
                    return [
                        2 /*return*/ ,
                        {}
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
module.exports.sign = $172a7084ee847d4e$var$sign;
function $172a7084ee847d4e$var$createSignedTx(tx, signature) {
    return $172a7084ee847d4e$var$__awaiter(this, void 0, void 0, function() {
        return $172a7084ee847d4e$var$__generator(this, function(_a) {
            if (!tx.signatures) tx.signatures = [];
            tx.signatures = [
                signature
            ];
            return [
                2 /*return*/ ,
                tx
            ];
        });
    });
}
module.exports.createSignedTx = $172a7084ee847d4e$var$createSignedTx;
var $172a7084ee847d4e$var$create_sign_message = function(jsonTx, sequence, account_number, chain_id) {
    return $172a7084ee847d4e$var$__awaiter(this, void 0, void 0, function() {
        var tag, fee;
        return $172a7084ee847d4e$var$__generator(this, function(_a) {
            tag = " | create_sign_message | ";
            try {
                fee = {
                    amount: jsonTx.fee.amount || [],
                    gas: jsonTx.fee.gas
                };
                return [
                    2 /*return*/ ,
                    JSON.stringify($172a7084ee847d4e$var$prepareSignBytes({
                        //@ts-ignore
                        fee: fee,
                        memo: jsonTx.memo,
                        msgs: jsonTx.msg,
                        sequence: sequence,
                        account_number: account_number,
                        chain_id: chain_id
                    }))
                ];
            } catch (e) {
                console.error(e);
                throw Error(e);
            }
            return [
                2 /*return*/ 
            ];
        });
    });
};
var $172a7084ee847d4e$var$prepareSignBytes = function(jsonTx) {
    if (Array.isArray(jsonTx)) return jsonTx.map($172a7084ee847d4e$var$prepareSignBytes);
    // string or number
    if (typeof jsonTx !== "object") return jsonTx;
    var sorted = {};
    Object.keys(jsonTx).sort().forEach(function(key) {
        if (jsonTx[key] === undefined || jsonTx[key] === null) return;
        sorted[key] = $172a7084ee847d4e$var$prepareSignBytes(jsonTx[key]);
    });
    return sorted;
};
var $172a7084ee847d4e$var$sign_with_privkey = function(signMessage, privateKey) {
    return $172a7084ee847d4e$var$__awaiter(this, void 0, void 0, function() {
        var tag, signature;
        return $172a7084ee847d4e$var$__generator(this, function(_a) {
            tag = " | sign_with_privkey | ";
            try {
                if (!signMessage) throw Error("signMessage required!");
                signature = typeof privateKey.sign === "function" ? privateKey.sign(signMessage) : function() {
                    var signHash = $172a7084ee847d4e$require$Buffer.from($hNROW(signMessage).toString(), "hex");
                    return $aQkCV.sign(signHash, $172a7084ee847d4e$require$Buffer.from(privateKey, "hex")).signature;
                }();
                return [
                    2 /*return*/ ,
                    signature
                ];
            } catch (e) {
                console.error(e);
                throw Error(e);
            }
            return [
                2 /*return*/ 
            ];
        });
    });
};
// signature, sequence, account_number, publicKey
var $172a7084ee847d4e$var$format_signature = function(signature, publicKey) {
    return $172a7084ee847d4e$var$__awaiter(this, void 0, void 0, function() {
        var tag;
        return $172a7084ee847d4e$var$__generator(this, function(_a) {
            tag = " | format_signature | ";
            try {
                return [
                    2 /*return*/ ,
                    {
                        signature: signature.toString("base64"),
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: publicKey.toString("base64")
                        }
                    }
                ];
            } catch (e) {
                console.error(e);
                throw Error(e);
            }
            return [
                2 /*return*/ 
            ];
        });
    });
};

});


parcelRegister("lojr1", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $f92aea3902c38d81$require$Buffer = $ihoyg.Buffer;
"use strict";
var $f92aea3902c38d81$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f92aea3902c38d81$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f92aea3902c38d81$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f92aea3902c38d81$var$__createBinding(result, mod, k);
    }
    $f92aea3902c38d81$var$__setModuleDefault(result, mod);
    return result;
};
var $f92aea3902c38d81$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $f92aea3902c38d81$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $f92aea3902c38d81$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $f92aea3902c38d81$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeMayachainWallet = module.exports.MixinNativeMayachainWalletInfo = void 0;

const $f92aea3902c38d81$var$core = $f92aea3902c38d81$var$__importStar((parcelRequire("lFpDy")));

const $f92aea3902c38d81$var$bech32 = $f92aea3902c38d81$var$__importStar((parcelRequire("5wgCY")));

const $f92aea3902c38d81$var$crypto_js_1 = $f92aea3902c38d81$var$__importDefault((parcelRequire("kWcCv")));

const $f92aea3902c38d81$var$p_lazy_1 = $f92aea3902c38d81$var$__importDefault((parcelRequire("gGdnO")));

const $f92aea3902c38d81$var$Isolation = $f92aea3902c38d81$var$__importStar((parcelRequire("aCCM0")));

const $f92aea3902c38d81$var$util = $f92aea3902c38d81$var$__importStar((parcelRequire("byiQW")));
const $f92aea3902c38d81$var$MAYA_CHAIN = "mayachain-mainnet-v1";

const $f92aea3902c38d81$var$protoTxBuilder = $f92aea3902c38d81$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("eknzC"));
    }).then((res)=>$f92aea3902c38d81$var$__importStar(res)));
function $f92aea3902c38d81$var$MixinNativeMayachainWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeMayachainWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsMayachainInfo = true;
        }
        mayachainSupportsNetwork() {
            return $f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        mayachainSupportsSecureTransfer() {
            return $f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        mayachainSupportsNativeShapeShift() {
            return false;
        }
        mayachainGetAccountPaths(msg) {
            const slip44 = $f92aea3902c38d81$var$core.slip44ByCoin("Mayachain");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        mayachainNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeMayachainWalletInfo = $f92aea3902c38d81$var$MixinNativeMayachainWalletInfo;
function $f92aea3902c38d81$var$MixinNativeMayachainWallet(Base) {
    var _MixinNativeMayachainWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeMayachainWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsMayachain = true;
            _MixinNativeMayachainWallet_masterKey.set(this, void 0);
        }
        mayachainInitializeWallet(masterKey) {
            return $f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                $f92aea3902c38d81$var$__classPrivateFieldSet(this, _MixinNativeMayachainWallet_masterKey, masterKey, "f");
            });
        }
        mayachainWipe() {
            $f92aea3902c38d81$var$__classPrivateFieldSet(this, _MixinNativeMayachainWallet_masterKey, undefined, "f");
        }
        mayachainBech32ify(address, prefix) {
            const words = $f92aea3902c38d81$var$bech32.toWords(address);
            return $f92aea3902c38d81$var$bech32.encode(prefix, words);
        }
        createMayachainAddress(publicKey) {
            const message = $f92aea3902c38d81$var$crypto_js_1.default.SHA256($f92aea3902c38d81$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $f92aea3902c38d81$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $f92aea3902c38d81$require$Buffer.from(hash, `hex`);
            return this.mayachainBech32ify(address, `maya`);
        }
        mayachainGetAddress(msg) {
            return $f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f92aea3902c38d81$var$__classPrivateFieldGet(this, _MixinNativeMayachainWallet_masterKey, "f"), ()=>$f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $f92aea3902c38d81$var$util.getKeyPair($f92aea3902c38d81$var$__classPrivateFieldGet(this, _MixinNativeMayachainWallet_masterKey, "f"), msg.addressNList, "mayachain");
                        return this.createMayachainAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        mayachainSignTx(msg) {
            return $f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$f92aea3902c38d81$var$__classPrivateFieldGet(this, _MixinNativeMayachainWallet_masterKey, "f"), ()=>$f92aea3902c38d81$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $f92aea3902c38d81$var$util.getKeyPair($f92aea3902c38d81$var$__classPrivateFieldGet(this, _MixinNativeMayachainWallet_masterKey, "f"), msg.addressNList, "mayachain");
                        const adapter = yield $f92aea3902c38d81$var$Isolation.Adapters.CosmosDirect.create(keyPair.node, "maya");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: $f92aea3902c38d81$var$MAYA_CHAIN
                        };
                        return (yield $f92aea3902c38d81$var$protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData, "maya");
                    }));
            });
        }
    }, _MixinNativeMayachainWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeMayachainWallet = $f92aea3902c38d81$var$MixinNativeMayachainWallet;

});

parcelRegister("jcC5O", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $dfacafb7b6a675ee$require$Buffer = $ihoyg.Buffer;
"use strict";
var $dfacafb7b6a675ee$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $dfacafb7b6a675ee$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $dfacafb7b6a675ee$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $dfacafb7b6a675ee$var$__createBinding(result, mod, k);
    }
    $dfacafb7b6a675ee$var$__setModuleDefault(result, mod);
    return result;
};
var $dfacafb7b6a675ee$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $dfacafb7b6a675ee$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $dfacafb7b6a675ee$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $dfacafb7b6a675ee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeOsmosisWallet = module.exports.MixinNativeOsmosisWalletInfo = void 0;

const $dfacafb7b6a675ee$var$core = $dfacafb7b6a675ee$var$__importStar((parcelRequire("lFpDy")));

const $dfacafb7b6a675ee$var$bech32 = $dfacafb7b6a675ee$var$__importStar((parcelRequire("5wgCY")));

const $dfacafb7b6a675ee$var$crypto_js_1 = $dfacafb7b6a675ee$var$__importDefault((parcelRequire("kWcCv")));

const $dfacafb7b6a675ee$var$p_lazy_1 = $dfacafb7b6a675ee$var$__importDefault((parcelRequire("gGdnO")));

const $dfacafb7b6a675ee$var$Isolation = $dfacafb7b6a675ee$var$__importStar((parcelRequire("aCCM0")));

const $dfacafb7b6a675ee$var$util = $dfacafb7b6a675ee$var$__importStar((parcelRequire("byiQW")));
const $dfacafb7b6a675ee$var$OSMOSIS_CHAIN = "osmosis-1";

const $dfacafb7b6a675ee$var$protoTxBuilder = $dfacafb7b6a675ee$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("eknzC"));
    }).then((res)=>$dfacafb7b6a675ee$var$__importStar(res)));
function $dfacafb7b6a675ee$var$MixinNativeOsmosisWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeOsmosisWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsOsmosisInfo = true;
        }
        osmosisSupportsNetwork() {
            return $dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        osmosisSupportsSecureTransfer() {
            return $dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        osmosisSupportsNativeShapeShift() {
            return false;
        }
        osmosisGetAccountPaths(msg) {
            const slip44 = $dfacafb7b6a675ee$var$core.slip44ByCoin("Osmo");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        osmosisNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeOsmosisWalletInfo = $dfacafb7b6a675ee$var$MixinNativeOsmosisWalletInfo;
function $dfacafb7b6a675ee$var$MixinNativeOsmosisWallet(Base) {
    var _MixinNativeOsmosisWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeOsmosisWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsOsmosis = true;
            _MixinNativeOsmosisWallet_masterKey.set(this, void 0);
        }
        osmosisInitializeWallet(masterKey) {
            return $dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                $dfacafb7b6a675ee$var$__classPrivateFieldSet(this, _MixinNativeOsmosisWallet_masterKey, masterKey, "f");
            });
        }
        osmosisWipe() {
            $dfacafb7b6a675ee$var$__classPrivateFieldSet(this, _MixinNativeOsmosisWallet_masterKey, undefined, "f");
        }
        osmosisBech32ify(address, prefix) {
            const words = $dfacafb7b6a675ee$var$bech32.toWords(address);
            return $dfacafb7b6a675ee$var$bech32.encode(prefix, words);
        }
        createOsmosisAddress(publicKey) {
            const message = $dfacafb7b6a675ee$var$crypto_js_1.default.SHA256($dfacafb7b6a675ee$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $dfacafb7b6a675ee$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $dfacafb7b6a675ee$require$Buffer.from(hash, `hex`);
            return this.osmosisBech32ify(address, `osmo`);
        }
        osmosisGetAddress(msg) {
            return $dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$dfacafb7b6a675ee$var$__classPrivateFieldGet(this, _MixinNativeOsmosisWallet_masterKey, "f"), ()=>$dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $dfacafb7b6a675ee$var$util.getKeyPair($dfacafb7b6a675ee$var$__classPrivateFieldGet(this, _MixinNativeOsmosisWallet_masterKey, "f"), msg.addressNList, "osmosis");
                        return this.createOsmosisAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        osmosisSignTx(msg) {
            return $dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$dfacafb7b6a675ee$var$__classPrivateFieldGet(this, _MixinNativeOsmosisWallet_masterKey, "f"), ()=>$dfacafb7b6a675ee$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $dfacafb7b6a675ee$var$util.getKeyPair($dfacafb7b6a675ee$var$__classPrivateFieldGet(this, _MixinNativeOsmosisWallet_masterKey, "f"), msg.addressNList, "osmosis");
                        const adapter = yield $dfacafb7b6a675ee$var$Isolation.Adapters.CosmosDirect.create(keyPair.node, "osmo");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: $dfacafb7b6a675ee$var$OSMOSIS_CHAIN
                        };
                        return (yield $dfacafb7b6a675ee$var$protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData, "osmos");
                    }));
            });
        }
    }, _MixinNativeOsmosisWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeOsmosisWallet = $dfacafb7b6a675ee$var$MixinNativeOsmosisWallet;

});

parcelRegister("6j5gZ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $49789b8af8ffd821$require$Buffer = $ihoyg.Buffer;
"use strict";
var $49789b8af8ffd821$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $49789b8af8ffd821$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $49789b8af8ffd821$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $49789b8af8ffd821$var$__createBinding(result, mod, k);
    }
    $49789b8af8ffd821$var$__setModuleDefault(result, mod);
    return result;
};
var $49789b8af8ffd821$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $49789b8af8ffd821$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $49789b8af8ffd821$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $49789b8af8ffd821$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeSecretWallet = module.exports.MixinNativeSecretWalletInfo = void 0;

const $49789b8af8ffd821$var$core = $49789b8af8ffd821$var$__importStar((parcelRequire("lFpDy")));

const $49789b8af8ffd821$var$bech32 = $49789b8af8ffd821$var$__importStar((parcelRequire("5wgCY")));

const $49789b8af8ffd821$var$crypto_js_1 = $49789b8af8ffd821$var$__importDefault((parcelRequire("kWcCv")));

const $49789b8af8ffd821$var$txBuilder = $49789b8af8ffd821$var$__importStar((parcelRequire("1Zjh6")));

const $49789b8af8ffd821$var$Isolation = $49789b8af8ffd821$var$__importStar((parcelRequire("aCCM0")));

const $49789b8af8ffd821$var$util = $49789b8af8ffd821$var$__importStar((parcelRequire("byiQW")));
function $49789b8af8ffd821$var$MixinNativeSecretWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeSecretWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsSecretInfo = true;
        }
        secretSupportsNetwork() {
            return $49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        secretSupportsSecureTransfer() {
            return $49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        secretSupportsNativeShapeShift() {
            return false;
        }
        secretGetAccountPaths(msg) {
            const slip44 = $49789b8af8ffd821$var$core.slip44ByCoin("Secret");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        secretNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeSecretWalletInfo = $49789b8af8ffd821$var$MixinNativeSecretWalletInfo;
function $49789b8af8ffd821$var$MixinNativeSecretWallet(Base) {
    var _MixinNativeSecretWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeSecretWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsSecret = true;
            _MixinNativeSecretWallet_masterKey.set(this, void 0);
        }
        secretInitializeWallet(masterKey) {
            return $49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                $49789b8af8ffd821$var$__classPrivateFieldSet(this, _MixinNativeSecretWallet_masterKey, masterKey, "f");
            });
        }
        secretWipe() {
            $49789b8af8ffd821$var$__classPrivateFieldSet(this, _MixinNativeSecretWallet_masterKey, undefined, "f");
        }
        secretBech32ify(address, prefix) {
            const words = $49789b8af8ffd821$var$bech32.toWords(address);
            return $49789b8af8ffd821$var$bech32.encode(prefix, words);
        }
        createSecretAddress(publicKey) {
            const message = $49789b8af8ffd821$var$crypto_js_1.default.SHA256($49789b8af8ffd821$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $49789b8af8ffd821$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $49789b8af8ffd821$require$Buffer.from(hash, `hex`);
            return this.secretBech32ify(address, `secret`);
        }
        secretGetAddress(msg) {
            return $49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$49789b8af8ffd821$var$__classPrivateFieldGet(this, _MixinNativeSecretWallet_masterKey, "f"), ()=>$49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $49789b8af8ffd821$var$util.getKeyPair($49789b8af8ffd821$var$__classPrivateFieldGet(this, _MixinNativeSecretWallet_masterKey, "f"), msg.addressNList, "secret");
                        return this.createSecretAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        secretSignTx(msg) {
            return $49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$49789b8af8ffd821$var$__classPrivateFieldGet(this, _MixinNativeSecretWallet_masterKey, "f"), ()=>$49789b8af8ffd821$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $49789b8af8ffd821$var$util.getKeyPair($49789b8af8ffd821$var$__classPrivateFieldGet(this, _MixinNativeSecretWallet_masterKey, "f"), msg.addressNList, "secret");
                        // @TODO: This needs to be fixed after the change to tendermint serialization
                        const adapter = yield $49789b8af8ffd821$var$Isolation.Adapters.Cosmos.create(keyPair);
                        const result = yield $49789b8af8ffd821$var$txBuilder.sign(msg.tx, adapter, String(msg.sequence), String(msg.account_number), msg.chain_id);
                        return $49789b8af8ffd821$var$txBuilder.createSignedTx(msg.tx, result);
                    }));
            });
        }
    }, _MixinNativeSecretWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeSecretWallet = $49789b8af8ffd821$var$MixinNativeSecretWallet;

});

parcelRegister("9tn5d", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $6e58ba4df1cef2d2$require$Buffer = $ihoyg.Buffer;
"use strict";
var $6e58ba4df1cef2d2$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6e58ba4df1cef2d2$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $6e58ba4df1cef2d2$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $6e58ba4df1cef2d2$var$__createBinding(result, mod, k);
    }
    $6e58ba4df1cef2d2$var$__setModuleDefault(result, mod);
    return result;
};
var $6e58ba4df1cef2d2$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6e58ba4df1cef2d2$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $6e58ba4df1cef2d2$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $6e58ba4df1cef2d2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeTerraWallet = module.exports.MixinNativeTerraWalletInfo = void 0;

const $6e58ba4df1cef2d2$var$core = $6e58ba4df1cef2d2$var$__importStar((parcelRequire("lFpDy")));

const $6e58ba4df1cef2d2$var$bech32 = $6e58ba4df1cef2d2$var$__importStar((parcelRequire("5wgCY")));

const $6e58ba4df1cef2d2$var$crypto_js_1 = $6e58ba4df1cef2d2$var$__importDefault((parcelRequire("kWcCv")));

const $6e58ba4df1cef2d2$var$txBuilder = $6e58ba4df1cef2d2$var$__importStar((parcelRequire("1Zjh6")));

const $6e58ba4df1cef2d2$var$Isolation = $6e58ba4df1cef2d2$var$__importStar((parcelRequire("aCCM0")));

const $6e58ba4df1cef2d2$var$util = $6e58ba4df1cef2d2$var$__importStar((parcelRequire("byiQW")));
function $6e58ba4df1cef2d2$var$MixinNativeTerraWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeTerraWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsTerraInfo = true;
        }
        terraSupportsNetwork() {
            return $6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        terraSupportsSecureTransfer() {
            return $6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        terraSupportsNativeShapeShift() {
            return false;
        }
        terraGetAccountPaths(msg) {
            const slip44 = $6e58ba4df1cef2d2$var$core.slip44ByCoin("Terra");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        terraNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeTerraWalletInfo = $6e58ba4df1cef2d2$var$MixinNativeTerraWalletInfo;
function $6e58ba4df1cef2d2$var$MixinNativeTerraWallet(Base) {
    var _MixinNativeTerraWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeTerraWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsTerra = true;
            _MixinNativeTerraWallet_masterKey.set(this, void 0);
        }
        terraInitializeWallet(masterKey) {
            return $6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                $6e58ba4df1cef2d2$var$__classPrivateFieldSet(this, _MixinNativeTerraWallet_masterKey, masterKey, "f");
            });
        }
        terraWipe() {
            $6e58ba4df1cef2d2$var$__classPrivateFieldSet(this, _MixinNativeTerraWallet_masterKey, undefined, "f");
        }
        terraBech32ify(address, prefix) {
            const words = $6e58ba4df1cef2d2$var$bech32.toWords(address);
            return $6e58ba4df1cef2d2$var$bech32.encode(prefix, words);
        }
        createTerraAddress(publicKey) {
            const message = $6e58ba4df1cef2d2$var$crypto_js_1.default.SHA256($6e58ba4df1cef2d2$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $6e58ba4df1cef2d2$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $6e58ba4df1cef2d2$require$Buffer.from(hash, `hex`);
            return this.terraBech32ify(address, `terra`);
        }
        terraGetAddress(msg) {
            return $6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$6e58ba4df1cef2d2$var$__classPrivateFieldGet(this, _MixinNativeTerraWallet_masterKey, "f"), ()=>$6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $6e58ba4df1cef2d2$var$util.getKeyPair($6e58ba4df1cef2d2$var$__classPrivateFieldGet(this, _MixinNativeTerraWallet_masterKey, "f"), msg.addressNList, "terra");
                        return this.createTerraAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        terraSignTx(msg) {
            return $6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$6e58ba4df1cef2d2$var$__classPrivateFieldGet(this, _MixinNativeTerraWallet_masterKey, "f"), ()=>$6e58ba4df1cef2d2$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $6e58ba4df1cef2d2$var$util.getKeyPair($6e58ba4df1cef2d2$var$__classPrivateFieldGet(this, _MixinNativeTerraWallet_masterKey, "f"), msg.addressNList, "terra");
                        // @TODO: This needs to be fixed after the change to tendermint serialization
                        const adapter = yield $6e58ba4df1cef2d2$var$Isolation.Adapters.Cosmos.create(keyPair);
                        const result = yield $6e58ba4df1cef2d2$var$txBuilder.sign(msg.tx, adapter, msg.sequence, msg.account_number, "terra");
                        return $6e58ba4df1cef2d2$var$txBuilder.createSignedTx(msg.tx, result);
                    }));
            });
        }
    }, _MixinNativeTerraWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeTerraWallet = $6e58ba4df1cef2d2$var$MixinNativeTerraWallet;

});

parcelRegister("d3XRl", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $9829fd03321687a1$require$Buffer = $ihoyg.Buffer;
"use strict";
var $9829fd03321687a1$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9829fd03321687a1$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9829fd03321687a1$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9829fd03321687a1$var$__createBinding(result, mod, k);
    }
    $9829fd03321687a1$var$__setModuleDefault(result, mod);
    return result;
};
var $9829fd03321687a1$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9829fd03321687a1$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $9829fd03321687a1$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $9829fd03321687a1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MixinNativeThorchainWallet = module.exports.MixinNativeThorchainWalletInfo = void 0;

const $9829fd03321687a1$var$core = $9829fd03321687a1$var$__importStar((parcelRequire("lFpDy")));

const $9829fd03321687a1$var$bech32 = $9829fd03321687a1$var$__importStar((parcelRequire("5wgCY")));

const $9829fd03321687a1$var$crypto_js_1 = $9829fd03321687a1$var$__importDefault((parcelRequire("kWcCv")));

const $9829fd03321687a1$var$p_lazy_1 = $9829fd03321687a1$var$__importDefault((parcelRequire("gGdnO")));

const $9829fd03321687a1$var$Isolation = $9829fd03321687a1$var$__importStar((parcelRequire("aCCM0")));

const $9829fd03321687a1$var$util = $9829fd03321687a1$var$__importStar((parcelRequire("byiQW")));
const $9829fd03321687a1$var$THOR_CHAIN = "thorchain-mainnet-v1";

const $9829fd03321687a1$var$protoTxBuilder = $9829fd03321687a1$var$p_lazy_1.default.from(()=>Promise.resolve().then(function() {
        return (parcelRequire("eknzC"));
    }).then((res)=>$9829fd03321687a1$var$__importStar(res)));
function $9829fd03321687a1$var$MixinNativeThorchainWalletInfo(Base) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return class MixinNativeThorchainWalletInfo extends Base {
        constructor(){
            super(...arguments);
            this._supportsThorchainInfo = true;
        }
        thorchainSupportsNetwork() {
            return $9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                return true;
            });
        }
        thorchainSupportsSecureTransfer() {
            return $9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                return false;
            });
        }
        thorchainSupportsNativeShapeShift() {
            return false;
        }
        thorchainGetAccountPaths(msg) {
            const slip44 = $9829fd03321687a1$var$core.slip44ByCoin("Thorchain");
            return [
                {
                    addressNList: [
                        2147483692,
                        0x80000000 + slip44,
                        0x80000000 + msg.accountIdx,
                        0,
                        0
                    ]
                }
            ];
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        thorchainNextAccountPath(msg) {
            // Only support one account for now (like portis).
            return undefined;
        }
    };
}
module.exports.MixinNativeThorchainWalletInfo = $9829fd03321687a1$var$MixinNativeThorchainWalletInfo;
function $9829fd03321687a1$var$MixinNativeThorchainWallet(Base) {
    var _MixinNativeThorchainWallet_masterKey, _a;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    return _a = class MixinNativeThorchainWallet extends Base {
        constructor(){
            super(...arguments);
            this._supportsThorchain = true;
            _MixinNativeThorchainWallet_masterKey.set(this, void 0);
        }
        thorchainInitializeWallet(masterKey) {
            return $9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                $9829fd03321687a1$var$__classPrivateFieldSet(this, _MixinNativeThorchainWallet_masterKey, masterKey, "f");
            });
        }
        thorchainWipe() {
            $9829fd03321687a1$var$__classPrivateFieldSet(this, _MixinNativeThorchainWallet_masterKey, undefined, "f");
        }
        thorchainBech32ify(address, prefix) {
            const words = $9829fd03321687a1$var$bech32.toWords(address);
            return $9829fd03321687a1$var$bech32.encode(prefix, words);
        }
        createThorchainAddress(publicKey) {
            const message = $9829fd03321687a1$var$crypto_js_1.default.SHA256($9829fd03321687a1$var$crypto_js_1.default.enc.Hex.parse(publicKey));
            const hash = $9829fd03321687a1$var$crypto_js_1.default.RIPEMD160(message).toString();
            const address = $9829fd03321687a1$require$Buffer.from(hash, `hex`);
            return this.thorchainBech32ify(address, `thor`);
        }
        thorchainGetAddress(msg) {
            return $9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$9829fd03321687a1$var$__classPrivateFieldGet(this, _MixinNativeThorchainWallet_masterKey, "f"), ()=>$9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $9829fd03321687a1$var$util.getKeyPair($9829fd03321687a1$var$__classPrivateFieldGet(this, _MixinNativeThorchainWallet_masterKey, "f"), msg.addressNList, "thorchain");
                        return this.createThorchainAddress(keyPair.publicKey.toString("hex"));
                    }));
            });
        }
        thorchainSignTx(msg) {
            return $9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                return this.needsMnemonic(!!$9829fd03321687a1$var$__classPrivateFieldGet(this, _MixinNativeThorchainWallet_masterKey, "f"), ()=>$9829fd03321687a1$var$__awaiter(this, void 0, void 0, function*() {
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const keyPair = yield $9829fd03321687a1$var$util.getKeyPair($9829fd03321687a1$var$__classPrivateFieldGet(this, _MixinNativeThorchainWallet_masterKey, "f"), msg.addressNList, "thorchain");
                        const adapter = yield $9829fd03321687a1$var$Isolation.Adapters.CosmosDirect.create(keyPair.node, "thor");
                        const signerData = {
                            sequence: Number(msg.sequence),
                            accountNumber: Number(msg.account_number),
                            chainId: $9829fd03321687a1$var$THOR_CHAIN
                        };
                        return (yield $9829fd03321687a1$var$protoTxBuilder).sign(adapter.address, msg.tx, adapter, signerData, "thor");
                    }));
            });
        }
    }, _MixinNativeThorchainWallet_masterKey = new WeakMap(), _a;
}
module.exports.MixinNativeThorchainWallet = $9829fd03321687a1$var$MixinNativeThorchainWallet;

});



parcelRegister("4GN4F", function(module, exports) {
"use strict";
var $36a126c9ce320266$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $36a126c9ce320266$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $36a126c9ce320266$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $36a126c9ce320266$var$__createBinding(exports1, m, p);
};
var $36a126c9ce320266$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $36a126c9ce320266$var$__createBinding(result, mod, k);
    }
    $36a126c9ce320266$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Isolation = module.exports.engines = void 0;

$36a126c9ce320266$var$__exportStar((parcelRequire("4v7ZP")), module.exports);

module.exports.engines = $36a126c9ce320266$var$__importStar((parcelRequire("ekQwl")));

module.exports.Isolation = $36a126c9ce320266$var$__importStar((parcelRequire("aCCM0")));

});
parcelRegister("4v7ZP", function(module, exports) {
"use strict";
var $3470428c101bcc55$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $3470428c101bcc55$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $3470428c101bcc55$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $3470428c101bcc55$var$__createBinding(result, mod, k);
    }
    $3470428c101bcc55$var$__setModuleDefault(result, mod);
    return result;
};
var $3470428c101bcc55$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3470428c101bcc55$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $3470428c101bcc55$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $3470428c101bcc55$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $3470428c101bcc55$var$_EncryptedWallet_engine, $3470428c101bcc55$var$_EncryptedWallet_helper, $3470428c101bcc55$var$_EncryptedWallet_deviceId, $3470428c101bcc55$var$_EncryptedWallet_email, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, $3470428c101bcc55$var$_EncryptedWallet_key, $3470428c101bcc55$var$_EncryptedWallet_password;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EncryptedWallet = void 0;

const $3470428c101bcc55$var$core = $3470428c101bcc55$var$__importStar((parcelRequire("lFpDy")));

const $3470428c101bcc55$var$bip39 = $3470428c101bcc55$var$__importStar((parcelRequire("5qnT8")));

var $j8prU = parcelRequire("j8prU");

const $3470428c101bcc55$var$CryptoHelper_1 = $3470428c101bcc55$var$__importDefault((parcelRequire("d6YsJ")));

const $3470428c101bcc55$var$utils = $3470428c101bcc55$var$__importStar((parcelRequire("31Tid")));
class $3470428c101bcc55$var$EncryptedWallet {
    constructor(engine){
        $3470428c101bcc55$var$_EncryptedWallet_engine.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_helper.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_deviceId.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_email.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_key.set(this, void 0);
        $3470428c101bcc55$var$_EncryptedWallet_password.set(this, void 0);
        if (!engine) throw new Error("Missing cryptography engine");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_engine, engine, "f");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, new $3470428c101bcc55$var$CryptoHelper_1.default($3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_engine, "f")), "f");
    }
    /**
     * Whether or not the wallet has been initialized with an email and password
     */ get isInitialized() {
        return Boolean($3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_email, "f") && $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_password, "f") && $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f"));
    }
    /**
     * The email provided to the `init` function
     */ get email() {
        return $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_email, "f");
    }
    /**
     * A hash derived from the email and password to be used for authentication
     */ get passwordHash() {
        var _a;
        return (_a = $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f")) === null || _a === void 0 ? void 0 : _a.hashKeyB64;
    }
    /**
     * A string representation of the encrypted seed phrase
     */ get encryptedWallet() {
        return $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, "f");
    }
    /**
     * Set the encrypted wallet by providing a string representation
     * @throws {Error} throws if `wallet` is not a valid encrypted wallet string
     */ set encryptedWallet(wallet) {
        if (wallet === undefined) throw new Error("Invalid cipher string");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, new $j8prU.CipherString(wallet).encryptedString, "f");
    }
    /**
     * Get an ID based on the mnemonic
     * Calling `decrypt` will set this value after decryption is successful
     */ get deviceId() {
        return $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_deviceId, "f");
    }
    /**
     * Initialize the wallet with and email and password
     *
     * This cannot be done in the constructor because it performs async operations
     */ init(email, password, encryptedWallet) {
        return $3470428c101bcc55$var$__awaiter(this, void 0, void 0, function*() {
            if (!(email && typeof email === "string" && email.length > 0)) throw new Error("Invalid email address");
            if (!(password && typeof password === "string" && password.length > 0)) throw new Error("Invalid password");
            $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_email, email.normalize("NFKC").trim().toLowerCase(), "f");
            $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_password, password.normalize("NFKC"), "f");
            $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_key, (yield $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, "f").makeKey($3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_password, "f"), $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_email, "f"))), "f");
            if (encryptedWallet) this.encryptedWallet = encryptedWallet;
            return this;
        });
    }
    /**
     * Generate a new mnemonic and encrypt it with the email and password
     */ createWallet(mnemonic) {
        return $3470428c101bcc55$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isInitialized) throw new Error("Wallet is not initialized");
            mnemonic = mnemonic !== null && mnemonic !== void 0 ? mnemonic : yield $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, "f").generateMnemonic();
            if (!$3470428c101bcc55$var$bip39.validateMnemonic(mnemonic)) throw new Error("Invalid mnemonic");
            if (!$3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f")) throw new Error("Wallet does not contain a key");
            $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, (yield $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, "f").aesEncrypt($3470428c101bcc55$var$core.toArrayBuffer($3470428c101bcc55$var$utils.fromUtf8ToArray(mnemonic)), $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f"))).toString(), "f");
            return this;
        });
    }
    /**
     * Decrypt the encrypted wallet
     * @throws {Error} if the wallet hasn't been initialized or doesn't have an encryptedWallet
     */ decrypt(encryptedWallet = $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, "f")) {
        return $3470428c101bcc55$var$__awaiter(this, void 0, void 0, function*() {
            if (!this.isInitialized) throw new Error("Wallet is not initialized");
            if (!encryptedWallet) throw new Error("Wallet does not contain an encrypted wallet");
            if (!$3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f")) throw new Error("Wallet does not contain a key");
            const decrypted = yield $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, "f").decrypt(new $j8prU.CipherString(encryptedWallet), $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_key, "f"));
            if (typeof decrypted === "string" && decrypted.length > 0) {
                $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_deviceId, (yield $3470428c101bcc55$var$__classPrivateFieldGet(this, $3470428c101bcc55$var$_EncryptedWallet_helper, "f").getDeviceId(decrypted)), "f");
                return decrypted;
            }
            throw new Error("Decryption failed");
        });
    }
    /**
     * Clear all private data to allow it to be garbage collected
     */ reset() {
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_deviceId, undefined, "f");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_email, undefined, "f");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet, undefined, "f");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_key, undefined, "f");
        $3470428c101bcc55$var$__classPrivateFieldSet(this, $3470428c101bcc55$var$_EncryptedWallet_password, undefined, "f");
    }
}
module.exports.EncryptedWallet = $3470428c101bcc55$var$EncryptedWallet;
$3470428c101bcc55$var$_EncryptedWallet_engine = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_helper = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_deviceId = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_email = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_encryptedWallet = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_key = new WeakMap(), $3470428c101bcc55$var$_EncryptedWallet_password = new WeakMap();

});
parcelRegister("j8prU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SymmetricCryptoKey = module.exports.EncryptionType = module.exports.EncryptedObject = module.exports.CipherString = void 0;

var $8LEsT = parcelRequire("8LEsT");
Object.defineProperty(module.exports, "CipherString", {
    enumerable: true,
    get: function() {
        return $8LEsT.CipherString;
    }
});

var $lbB5g = parcelRequire("lbB5g");
Object.defineProperty(module.exports, "EncryptedObject", {
    enumerable: true,
    get: function() {
        return $lbB5g.EncryptedObject;
    }
});

var $7eA9h = parcelRequire("7eA9h");
Object.defineProperty(module.exports, "EncryptionType", {
    enumerable: true,
    get: function() {
        return $7eA9h.EncryptionType;
    }
});

var $03n3e = parcelRequire("03n3e");
Object.defineProperty(module.exports, "SymmetricCryptoKey", {
    enumerable: true,
    get: function() {
        return $03n3e.SymmetricCryptoKey;
    }
});

});
parcelRegister("8LEsT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CipherString = void 0;

var $31Tid = parcelRequire("31Tid");

var $lbB5g = parcelRequire("lbB5g");

var $7eA9h = parcelRequire("7eA9h");
class $66221a08fe58c6d0$var$CipherString {
    constructor(cipher){
        this.encryptionType = $7eA9h.EncryptionType.AesCbc256_HmacSha256_B64;
        let data, iv, mac;
        if (typeof cipher === "string") try {
            const header = cipher.split(".");
            this.encryptionType = Number(header[0]);
            [data, iv, mac] = header[1].split("|");
        } catch (e) {
            throw new Error("Invalid cipher string");
        }
        else if (cipher instanceof $lbB5g.EncryptedObject) try {
            this.encryptionType = cipher.key.encType;
            if (cipher.iv) iv = (0, $31Tid.fromBufferToB64)(cipher.iv);
            if (cipher.data) data = (0, $31Tid.fromBufferToB64)(cipher.data);
            if (cipher.mac) mac = (0, $31Tid.fromBufferToB64)(cipher.mac);
        } catch (_a) {
            throw new Error("Invalid encryption object");
        }
        else throw new Error("Invalid cipher data. You must provide a string or Encrypted Object");
        if (!$7eA9h.EncryptionType[this.encryptionType]) throw new Error("Unsupported encryption method");
        if (!data) throw new Error("Encrypted data is missing");
        this.data = data;
        if (!iv) throw new Error("IV is missing");
        this.iv = iv;
        if (!mac) throw new Error("HMAC signature is missing");
        this.mac = mac;
    }
    get encryptedString() {
        return `${this.encryptionType}.${[
            this.data,
            this.iv,
            this.mac
        ].join("|")}`;
    }
    toEncryptedObject(key) {
        return new $lbB5g.EncryptedObject({
            data: (0, $31Tid.fromB64ToArray)(this.data),
            iv: (0, $31Tid.fromB64ToArray)(this.iv),
            mac: (0, $31Tid.fromB64ToArray)(this.mac),
            key: key
        });
    }
}
module.exports.CipherString = $66221a08fe58c6d0$var$CipherString;

});
parcelRegister("31Tid", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $234c5b168f35bd31$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fromB64ToArray = module.exports.fromBufferToUtf8 = module.exports.fromBufferToB64 = module.exports.fromUtf8ToArray = void 0;

var $3Ea7J = parcelRequire("3Ea7J");
function $234c5b168f35bd31$var$fromUtf8ToArray(str) {
    return new $3Ea7J.TextEncoder().encode(str);
}
module.exports.fromUtf8ToArray = $234c5b168f35bd31$var$fromUtf8ToArray;
function $234c5b168f35bd31$var$fromBufferToB64(buffer) {
    return $234c5b168f35bd31$require$Buffer.from(buffer).toString("base64");
}
module.exports.fromBufferToB64 = $234c5b168f35bd31$var$fromBufferToB64;
function $234c5b168f35bd31$var$fromBufferToUtf8(buffer) {
    return new $3Ea7J.TextDecoder().decode(buffer);
}
module.exports.fromBufferToUtf8 = $234c5b168f35bd31$var$fromBufferToUtf8;
function $234c5b168f35bd31$var$fromB64ToArray(str) {
    return $234c5b168f35bd31$require$Buffer.from(str, "base64");
}
module.exports.fromB64ToArray = $234c5b168f35bd31$var$fromB64ToArray;

});

parcelRegister("lbB5g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EncryptedObject = void 0;

var $8LEsT = parcelRequire("8LEsT");
class $f6c764266e403d6a$var$EncryptedObject {
    constructor({ key: key, iv: iv, data: data, mac: mac }){
        this.key = key;
        this.iv = iv;
        this.data = data;
        this.mac = mac;
    }
    toString() {
        return new $8LEsT.CipherString(this).encryptedString;
    }
}
module.exports.EncryptedObject = $f6c764266e403d6a$var$EncryptedObject;

});

parcelRegister("7eA9h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EncryptionType = void 0;
/*
 Copied from portis: packages/portis-crypto/src/enums/encryptionType.ts
 */ var $5445e19a557881ae$var$EncryptionType;
(function(EncryptionType) {
    EncryptionType[EncryptionType["AesCbc256_HmacSha256_B64"] = 2] = "AesCbc256_HmacSha256_B64";
})($5445e19a557881ae$var$EncryptionType || (module.exports.EncryptionType = $5445e19a557881ae$var$EncryptionType = {}));

});


parcelRegister("03n3e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SymmetricCryptoKey = void 0;

var $31Tid = parcelRequire("31Tid");

var $7eA9h = parcelRequire("7eA9h");
class $00a22960e4497e98$var$SymmetricCryptoKey {
    constructor(hashKey, encKey, mac){
        this.encType = $7eA9h.EncryptionType.AesCbc256_HmacSha256_B64;
        if (hashKey == null) throw new Error("Required parameter [hashKey] was not provided");
        if (encKey == null) throw new Error("Required parameter [encKey] was not provided");
        if (mac == null) throw new Error("Required parameter [mac] was not provided");
        if (hashKey.byteLength !== 32 || encKey.byteLength !== 32 || mac.byteLength !== 32) throw new Error("Keys must be 32 bytes");
        this.hashKey = hashKey;
        this.encKey = encKey;
        this.macKey = mac;
        this.hashKeyB64 = (0, $31Tid.fromBufferToB64)(this.hashKey);
        this.encKeyB64 = (0, $31Tid.fromBufferToB64)(this.encKey);
        this.macKeyB64 = (0, $31Tid.fromBufferToB64)(this.macKey);
    }
}
module.exports.SymmetricCryptoKey = $00a22960e4497e98$var$SymmetricCryptoKey;

});


parcelRegister("d6YsJ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $98babc7f05980dbb$require$Buffer = $ihoyg.Buffer;
"use strict";
var $98babc7f05980dbb$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $98babc7f05980dbb$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $98babc7f05980dbb$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $98babc7f05980dbb$var$__createBinding(result, mod, k);
    }
    $98babc7f05980dbb$var$__setModuleDefault(result, mod);
    return result;
};
var $98babc7f05980dbb$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $98babc7f05980dbb$var$__classPrivateFieldSet = module.exports && module.exports.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
var $98babc7f05980dbb$var$__classPrivateFieldGet = module.exports && module.exports.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $98babc7f05980dbb$var$_CryptoHelper_engine;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $98babc7f05980dbb$var$core = $98babc7f05980dbb$var$__importStar((parcelRequire("lFpDy")));

const $98babc7f05980dbb$var$bip39 = $98babc7f05980dbb$var$__importStar((parcelRequire("5qnT8")));

var $j8prU = parcelRequire("j8prU");

var $ekQwl = parcelRequire("ekQwl");

const $98babc7f05980dbb$var$utils = $98babc7f05980dbb$var$__importStar((parcelRequire("31Tid")));
/**
 * This class is only intended to be used by the EncryptedWallet class
 */ class $98babc7f05980dbb$var$CryptoHelper {
    constructor(engine){
        $98babc7f05980dbb$var$_CryptoHelper_engine.set(this, void 0);
        if (!engine) throw new Error("Missing cryptography engine");
        $98babc7f05980dbb$var$__classPrivateFieldSet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, engine, "f");
    }
    // Safely compare two values in a way that protects against timing attacks (Double HMAC Verification).
    // ref: https://www.nccgroup.trust/us/about-us/newsroom-and-events/blog/2011/february/double-hmac-verification/
    // ref: https://paragonie.com/blog/2015/11/preventing-timing-attacks-on-string-comparison-with-double-hmac-strategy
    compare(a, b) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            const macKey = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").randomBytes(32);
            const mac1 = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").hmac(a, macKey);
            const mac2 = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").hmac(b, macKey);
            if (mac1.byteLength !== mac2.byteLength) return false;
            const arr1 = new Uint8Array(mac1);
            const arr2 = new Uint8Array(mac2);
            for(let i = 0; i < arr2.length; i++){
                if (arr1[i] !== arr2[i]) return false;
            }
            return true;
        });
    }
    aesEncrypt(data, key) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            if (data == null || !(data instanceof ArrayBuffer || data instanceof Uint8Array)) throw new Error("Required parameter [data] is not of type ArrayBuffer or Uint8Array");
            if (data instanceof Uint8Array) data = $98babc7f05980dbb$var$core.toArrayBuffer(data);
            if (key == null || key.encKey == null || key.macKey == null) throw new Error("Required parameter [key] is not of type SymmetricCryptoKey");
            const iv = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").randomBytes(16);
            const encData = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").encrypt(data, key.encKey, iv);
            const macData = new Uint8Array(iv.byteLength + encData.byteLength);
            macData.set(new Uint8Array(iv), 0);
            macData.set(new Uint8Array(encData), iv.byteLength);
            const mac = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").hmac(macData.buffer.slice(macData.byteOffset, macData.byteOffset + macData.byteLength), key.macKey);
            return new $j8prU.EncryptedObject({
                key: key,
                iv: iv,
                data: encData,
                mac: mac
            });
        });
    }
    aesDecrypt(data, iv, mac, key) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            if (data == null || !(data instanceof ArrayBuffer || data instanceof Uint8Array)) throw new Error("Required parameter [data] is not of type ArrayBuffer or Uint8Array");
            if (data instanceof Uint8Array) data = $98babc7f05980dbb$var$core.toArrayBuffer(data);
            if (iv == null || !(iv instanceof ArrayBuffer || iv instanceof Uint8Array)) throw new Error("Required parameter [iv] is not of type ArrayBuffer or Uint8Array");
            if (iv instanceof Uint8Array) iv = $98babc7f05980dbb$var$core.toArrayBuffer(iv);
            if (mac == null || !(mac instanceof ArrayBuffer || mac instanceof Uint8Array)) throw new Error("Required parameter [mac] is not of type ArrayBuffer or Uint8Array");
            if (mac instanceof Uint8Array) mac = $98babc7f05980dbb$var$core.toArrayBuffer(mac);
            if (key == null || key.encKey == null || key.macKey == null) throw new Error("Required parameter [key] is not of type SymmetricCryptoKey");
            const macData = new Uint8Array(iv.byteLength + data.byteLength);
            macData.set(new Uint8Array(iv), 0);
            macData.set(new Uint8Array(data), iv.byteLength);
            const computedMac = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").hmac($98babc7f05980dbb$var$core.toArrayBuffer(macData), key.macKey);
            const macsMatch = yield this.compare(mac, computedMac);
            if (!macsMatch) throw new Error("HMAC signature is not valid or data has been tampered with");
            return $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").decrypt(data, key.encKey, iv);
        });
    }
    // @see: https://tools.ietf.org/html/rfc5869
    hkdfExpand(prk, info, size) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            const hashLen = 32; // sha256
            const okm = new Uint8Array(size);
            let previousT = new Uint8Array(0);
            const n = Math.ceil(size / hashLen);
            for(let i = 0; i < n; i++){
                const t = new Uint8Array(previousT.length + info.length + 1);
                t.set(previousT);
                t.set(info, previousT.length);
                t.set([
                    i + 1
                ], t.length - 1);
                previousT = new Uint8Array((yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").hmac($98babc7f05980dbb$var$core.toArrayBuffer(t), prk)));
                okm.set(previousT, i * hashLen);
            }
            return okm;
        });
    }
    pbkdf2(password, salt, iterations) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            password = typeof password !== "string" ? password : $98babc7f05980dbb$var$core.toArrayBuffer($98babc7f05980dbb$var$utils.fromUtf8ToArray(password));
            salt = typeof salt !== "string" ? salt : $98babc7f05980dbb$var$core.toArrayBuffer($98babc7f05980dbb$var$utils.fromUtf8ToArray(salt));
            return $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").pbkdf2(password, salt, {
                iterations: iterations,
                keyLen: 32
            });
        });
    }
    makeKey(password, email) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            if (!(password && email && typeof password === "string" && typeof email === "string")) throw new Error("A password and email are required to make a symmetric crypto key.");
            const salt = $98babc7f05980dbb$var$core.toArrayBuffer($98babc7f05980dbb$var$utils.fromUtf8ToArray(email));
            // The same email/password MUST always generate the same encryption key, so
            // scrypt parameters are hard-coded to ensure compatibility across implementations
            const key = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").scrypt($98babc7f05980dbb$var$core.toArrayBuffer($98babc7f05980dbb$var$utils.fromUtf8ToArray(password)), salt, {
                iterations: 16384,
                blockSize: 8,
                parallelism: 1,
                keyLength: 32
            });
            const hashKey = yield this.pbkdf2(key, password, 1);
            const stretchedKey = yield this.hkdfExpand(key, $98babc7f05980dbb$var$utils.fromUtf8ToArray("enc"), 32);
            const macKey = yield this.hkdfExpand(key, $98babc7f05980dbb$var$utils.fromUtf8ToArray("mac"), 32);
            return new $j8prU.SymmetricCryptoKey(hashKey, stretchedKey, macKey);
        });
    }
    decrypt(cipherString, key) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            const data = $98babc7f05980dbb$var$utils.fromB64ToArray(cipherString.data);
            const iv = $98babc7f05980dbb$var$utils.fromB64ToArray(cipherString.iv);
            const mac = $98babc7f05980dbb$var$utils.fromB64ToArray(cipherString.mac);
            const decipher = yield this.aesDecrypt(data, iv, mac, key);
            return $98babc7f05980dbb$var$utils.fromBufferToUtf8(decipher);
        });
    }
    // use entropyToMnemonic to generate mnemonic so we can utilize provided randomBytes function
    generateMnemonic(strength = 128) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            const entropy = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").randomBytes(strength / 8);
            return $98babc7f05980dbb$var$bip39.entropyToMnemonic($98babc7f05980dbb$require$Buffer.from(entropy));
        });
    }
    /**
     * Generates a base64 hash based on the provided data
     * Should be used to calculate a device ID for the wallet based on the mnemonic
     */ getDeviceId(data) {
        return $98babc7f05980dbb$var$__awaiter(this, void 0, void 0, function*() {
            if (!(typeof data === "string" && data.length > 0)) throw new Error("Invalid data to hash");
            const digest = yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").digest($ekQwl.DigestAlgorithm.SHA256, (yield $98babc7f05980dbb$var$__classPrivateFieldGet(this, $98babc7f05980dbb$var$_CryptoHelper_engine, "f").digest($ekQwl.DigestAlgorithm.SHA512, $98babc7f05980dbb$require$Buffer.from(data))));
            return $98babc7f05980dbb$var$utils.fromBufferToB64(digest);
        });
    }
}
$98babc7f05980dbb$var$_CryptoHelper_engine = new WeakMap();
module.exports.default = $98babc7f05980dbb$var$CryptoHelper;

});
parcelRegister("ekQwl", function(module, exports) {
"use strict";
var $a6fbac76b8e56282$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a6fbac76b8e56282$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $a6fbac76b8e56282$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$a6fbac76b8e56282$var$__exportStar((parcelRequire("j5TVU")), module.exports);

$a6fbac76b8e56282$var$__exportStar((parcelRequire("a2ORK")), module.exports);

});
parcelRegister("j5TVU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DigestAlgorithm = void 0;
var $de69df13d9a1a70f$var$DigestAlgorithm;
(function(DigestAlgorithm) {
    DigestAlgorithm[DigestAlgorithm["SHA256"] = 0] = "SHA256";
    DigestAlgorithm[DigestAlgorithm["SHA512"] = 1] = "SHA512";
})($de69df13d9a1a70f$var$DigestAlgorithm || (module.exports.DigestAlgorithm = $de69df13d9a1a70f$var$DigestAlgorithm = {}));

});

parcelRegister("a2ORK", function(module, exports) {
"use strict";
var $75018c3163504356$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $75018c3163504356$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $75018c3163504356$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $75018c3163504356$var$__createBinding(result, mod, k);
    }
    $75018c3163504356$var$__setModuleDefault(result, mod);
    return result;
};
var $75018c3163504356$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WebCryptoEngine = void 0;

const $75018c3163504356$var$core = $75018c3163504356$var$__importStar((parcelRequire("lFpDy")));

const $75018c3163504356$var$scryptJs = $75018c3163504356$var$__importStar((parcelRequire("5W1f9")));

var $j5TVU = parcelRequire("j5TVU");
class $75018c3163504356$var$WebCryptoEngine {
    decrypt(data, key, iv) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            const impKey = yield globalThis.crypto.subtle.importKey("raw", key, {
                name: "AES-CBC"
            }, false, [
                "decrypt"
            ]);
            return globalThis.crypto.subtle.decrypt({
                name: "AES-CBC",
                iv: iv
            }, impKey, data);
        });
    }
    digest(algorithm, data) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            const alg = algorithm === $j5TVU.DigestAlgorithm.SHA512 ? "SHA-512" : "SHA-256";
            return globalThis.crypto.subtle.digest(alg, data);
        });
    }
    encrypt(data, key, iv) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            const impKey = yield globalThis.crypto.subtle.importKey("raw", key, {
                name: "AES-CBC"
            }, false, [
                "encrypt"
            ]);
            return globalThis.crypto.subtle.encrypt({
                name: "AES-CBC",
                iv: iv
            }, impKey, data);
        });
    }
    hmac(value, key) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            const signingAlgorithm = {
                name: "HMAC",
                hash: {
                    name: "SHA-256"
                }
            };
            const impKey = yield globalThis.crypto.subtle.importKey("raw", key, signingAlgorithm, false, [
                "sign"
            ]);
            return globalThis.crypto.subtle.sign(signingAlgorithm, impKey, value);
        });
    }
    pbkdf2(password, salt, options) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            const pbkdf2Params = Object.assign({
                name: "PBKDF2",
                salt: new Uint8Array(salt),
                hash: {
                    name: "SHA-256"
                }
            }, options);
            const impKey = yield globalThis.crypto.subtle.importKey("raw", password, {
                name: "PBKDF2"
            }, false, [
                "deriveBits"
            ]);
            return globalThis.crypto.subtle.deriveBits(pbkdf2Params, impKey, 256);
        });
    }
    randomBytes(size) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            return $75018c3163504356$var$core.toArrayBuffer(globalThis.crypto.getRandomValues(new Uint8Array(size)));
        });
    }
    scrypt(password, salt, params) {
        return $75018c3163504356$var$__awaiter(this, void 0, void 0, function*() {
            return $75018c3163504356$var$core.toArrayBuffer((yield $75018c3163504356$var$scryptJs.scrypt(new Uint8Array(password), new Uint8Array(salt), params.iterations, params.blockSize, params.parallelism, params.keyLength)));
        });
    }
}
module.exports.WebCryptoEngine = $75018c3163504356$var$WebCryptoEngine;

});





parcelRegister("iwkA7", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("ihoyg")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("dQ123", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        Buffer = (parcelRequire("ihoyg")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") start++;
        if (base === 16) this._parseHex(number, start);
        else this._parseBase(number, base, start);
        if (number[0] === "-") this.negative = 1;
        this.strip();
        if (endian !== "le") return;
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex(str, start, end) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r <<= 4;
            // 'a' - 'f'
            if (c >= 49 && c <= 54) r |= c - 49 + 0xa;
            else if (c >= 17 && c <= 22) r |= c - 17 + 0xa;
            else r |= c & 0xf;
        }
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        // Scan 24-bit chunks and add them to the number
        var off = 0;
        for(i = number.length - 6, j = 0; i >= start; i -= 6){
            w = parseHex(number, i, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            // NOTE: `0x3fffff` is intentional here, 26bits max shift + 24bit hex limb
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        if (i + 6 !== start) {
            w = parseHex(number, start, i + 6);
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] |= w >>> 26 - off & 0x3fffff;
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else r.strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("6iS4i", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file WebsocketProvider.js
 * @authors: Samuel Furter <samuel@ethereum.org>, Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2019
 */ "use strict";

var $6p5EE = parcelRequire("6p5EE");

var $jYAnN = parcelRequire("jYAnN");

var $heyrh = parcelRequire("heyrh");
var $496e5d59d5ca59be$require$errors = $heyrh.errors;

var $bAl6e = parcelRequire("bAl6e");
var $496e5d59d5ca59be$require$Ws = $bAl6e.w3cwebsocket;
/**
 * @param {string} url
 * @param {Object} options
 *
 * @constructor
 */ var $496e5d59d5ca59be$var$WebsocketProvider = function WebsocketProvider(url, options) {
    $6p5EE.call(this);
    options = options || {};
    this.url = url;
    this._customTimeout = options.timeout || 15000;
    this.headers = options.headers || {};
    this.protocol = options.protocol || undefined;
    this.reconnectOptions = Object.assign({
        auto: false,
        delay: 5000,
        maxAttempts: false,
        onTimeout: false
    }, options.reconnect);
    this.clientConfig = options.clientConfig || undefined; // Allow a custom client configuration
    this.requestOptions = options.requestOptions || undefined; // Allow a custom request options (https://github.com/theturtle32/WebSocket-Node/blob/master/docs/WebSocketClient.md#connectrequesturl-requestedprotocols-origin-headers-requestoptions)
    this.DATA = "data";
    this.CLOSE = "close";
    this.ERROR = "error";
    this.CONNECT = "connect";
    this.RECONNECT = "reconnect";
    this.connection = null;
    this.requestQueue = new Map();
    this.responseQueue = new Map();
    this.reconnectAttempts = 0;
    this.reconnecting = false;
    // The w3cwebsocket implementation does not support Basic Auth
    // username/password in the URL. So generate the basic auth header, and
    // pass through with any additional headers supplied in constructor
    var parsedURL = $jYAnN.parseURL(url);
    if (parsedURL.username && parsedURL.password) this.headers.authorization = "Basic " + $jYAnN.btoa(parsedURL.username + ":" + parsedURL.password);
    // When all node core implementations that do not have the
    // WHATWG compatible URL parser go out of service this line can be removed.
    if (parsedURL.auth) this.headers.authorization = "Basic " + $jYAnN.btoa(parsedURL.auth);
    // make property `connected` which will return the current connection status
    Object.defineProperty(this, "connected", {
        get: function() {
            return this.connection && this.connection.readyState === this.connection.OPEN;
        },
        enumerable: true
    });
    this.connect();
};
// Inherit from EventEmitter
$496e5d59d5ca59be$var$WebsocketProvider.prototype = Object.create($6p5EE.prototype);
$496e5d59d5ca59be$var$WebsocketProvider.prototype.constructor = $496e5d59d5ca59be$var$WebsocketProvider;
/**
 * Connects to the configured node
 *
 * @method connect
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.connect = function() {
    this.connection = new $496e5d59d5ca59be$require$Ws(this.url, this.protocol, undefined, this.headers, this.requestOptions, this.clientConfig);
    this._addSocketListeners();
};
/**
 * Listener for the `data` event of the underlying WebSocket object
 *
 * @method _onMessage
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._onMessage = function(e) {
    var _this = this;
    this._parseResponse(typeof e.data === "string" ? e.data : "").forEach(function(result) {
        if (result.method && result.method.indexOf("_subscription") !== -1) {
            _this.emit(_this.DATA, result);
            return;
        }
        var id = result.id;
        // get the id which matches the returned id
        if (Array.isArray(result)) id = result[0].id;
        if (_this.responseQueue.has(id)) {
            if (_this.responseQueue.get(id).callback !== undefined) _this.responseQueue.get(id).callback(false, result);
            _this.responseQueue.delete(id);
        }
    });
};
/**
 * Listener for the `open` event of the underlying WebSocket object
 *
 * @method _onConnect
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._onConnect = function() {
    this.emit(this.CONNECT);
    this.reconnectAttempts = 0;
    this.reconnecting = false;
    if (this.requestQueue.size > 0) {
        var _this = this;
        this.requestQueue.forEach(function(request, key) {
            _this.send(request.payload, request.callback);
            _this.requestQueue.delete(key);
        });
    }
};
/**
 * Listener for the `close` event of the underlying WebSocket object
 *
 * @method _onClose
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._onClose = function(event) {
    var _this = this;
    if (this.reconnectOptions.auto && (![
        1000,
        1001
    ].includes(event.code) || event.wasClean === false)) {
        this.reconnect();
        return;
    }
    this.emit(this.CLOSE, event);
    if (this.requestQueue.size > 0) this.requestQueue.forEach(function(request, key) {
        request.callback($496e5d59d5ca59be$require$errors.ConnectionNotOpenError(event));
        _this.requestQueue.delete(key);
    });
    if (this.responseQueue.size > 0) this.responseQueue.forEach(function(request, key) {
        request.callback($496e5d59d5ca59be$require$errors.InvalidConnection("on WS", event));
        _this.responseQueue.delete(key);
    });
    this._removeSocketListeners();
    this.removeAllListeners();
};
/**
 * Will add the required socket listeners
 *
 * @method _addSocketListeners
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._addSocketListeners = function() {
    this.connection.addEventListener("message", this._onMessage.bind(this));
    this.connection.addEventListener("open", this._onConnect.bind(this));
    this.connection.addEventListener("close", this._onClose.bind(this));
};
/**
 * Will remove all socket listeners
 *
 * @method _removeSocketListeners
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._removeSocketListeners = function() {
    this.connection.removeEventListener("message", this._onMessage);
    this.connection.removeEventListener("open", this._onConnect);
    this.connection.removeEventListener("close", this._onClose);
};
/**
 * Will parse the response and make an array out of it.
 *
 * @method _parseResponse
 *
 * @param {String} data
 *
 * @returns {Array}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype._parseResponse = function(data) {
    var _this = this, returnValues = [];
    // DE-CHUNKER
    var dechunkedData = data.replace(/\}[\n\r]?\{/g, "}|--|{") // }{
    .replace(/\}\][\n\r]?\[\{/g, "}]|--|[{") // }][{
    .replace(/\}[\n\r]?\[\{/g, "}|--|[{") // }[{
    .replace(/\}\][\n\r]?\{/g, "}]|--|{") // }]{
    .split("|--|");
    dechunkedData.forEach(function(data) {
        // prepend the last chunk
        if (_this.lastChunk) data = _this.lastChunk + data;
        var result = null;
        try {
            result = JSON.parse(data);
        } catch (e) {
            _this.lastChunk = data;
            // start timeout to cancel all requests
            clearTimeout(_this.lastChunkTimeout);
            _this.lastChunkTimeout = setTimeout(function() {
                if (_this.reconnectOptions.auto && _this.reconnectOptions.onTimeout) {
                    _this.reconnect();
                    return;
                }
                _this.emit(_this.ERROR, $496e5d59d5ca59be$require$errors.ConnectionTimeout(_this._customTimeout));
                if (_this.requestQueue.size > 0) _this.requestQueue.forEach(function(request, key) {
                    request.callback($496e5d59d5ca59be$require$errors.ConnectionTimeout(_this._customTimeout));
                    _this.requestQueue.delete(key);
                });
            }, _this._customTimeout);
            return;
        }
        // cancel timeout and set chunk to null
        clearTimeout(_this.lastChunkTimeout);
        _this.lastChunk = null;
        if (result) returnValues.push(result);
    });
    return returnValues;
};
/**
 * Does check if the provider is connecting and will add it to the queue or will send it directly
 *
 * @method send
 *
 * @param {Object} payload
 * @param {Function} callback
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.send = function(payload, callback) {
    var _this = this;
    var id = payload.id;
    var request = {
        payload: payload,
        callback: callback
    };
    if (Array.isArray(payload)) id = payload[0].id;
    if (this.connection.readyState === this.connection.CONNECTING || this.reconnecting) {
        this.requestQueue.set(id, request);
        return;
    }
    if (this.connection.readyState !== this.connection.OPEN) {
        this.requestQueue.delete(id);
        this.emit(this.ERROR, $496e5d59d5ca59be$require$errors.ConnectionNotOpenError());
        request.callback($496e5d59d5ca59be$require$errors.ConnectionNotOpenError());
        return;
    }
    this.responseQueue.set(id, request);
    this.requestQueue.delete(id);
    try {
        this.connection.send(JSON.stringify(request.payload));
    } catch (error) {
        request.callback(error);
        _this.responseQueue.delete(id);
    }
};
/**
 * Resets the providers, clears all callbacks
 *
 * @method reset
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.reset = function() {
    this.responseQueue.clear();
    this.requestQueue.clear();
    this.removeAllListeners();
    this._removeSocketListeners();
    this._addSocketListeners();
};
/**
 * Closes the current connection with the given code and reason arguments
 *
 * @method disconnect
 *
 * @param {number} code
 * @param {string} reason
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.disconnect = function(code, reason) {
    this._removeSocketListeners();
    this.connection.close(code || 1000, reason);
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 *
 * @returns {boolean}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.supportsSubscriptions = function() {
    return true;
};
/**
 * Removes the listeners and reconnects to the socket.
 *
 * @method reconnect
 *
 * @returns {void}
 */ $496e5d59d5ca59be$var$WebsocketProvider.prototype.reconnect = function() {
    var _this = this;
    this.reconnecting = true;
    if (this.responseQueue.size > 0) this.responseQueue.forEach(function(request, key) {
        request.callback($496e5d59d5ca59be$require$errors.PendingRequestsOnReconnectingError());
        _this.responseQueue.delete(key);
    });
    if (!this.reconnectOptions.maxAttempts || this.reconnectAttempts < this.reconnectOptions.maxAttempts) {
        setTimeout(function() {
            _this.reconnectAttempts++;
            _this._removeSocketListeners();
            _this.emit(_this.RECONNECT, _this.reconnectAttempts);
            _this.connect();
        }, this.reconnectOptions.delay);
        return;
    }
    this.emit(this.ERROR, $496e5d59d5ca59be$require$errors.MaxAttemptsReachedOnReconnectingError());
    this.reconnecting = false;
    if (this.requestQueue.size > 0) this.requestQueue.forEach(function(request, key) {
        request.callback($496e5d59d5ca59be$require$errors.MaxAttemptsReachedOnReconnectingError());
        _this.requestQueue.delete(key);
    });
};
module.exports = $496e5d59d5ca59be$var$WebsocketProvider;

});
parcelRegister("6p5EE", function(module, exports) {
"use strict";
var $4a9976ca6ebf6735$var$has = Object.prototype.hasOwnProperty, $4a9976ca6ebf6735$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $4a9976ca6ebf6735$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $4a9976ca6ebf6735$var$Events().__proto__) $4a9976ca6ebf6735$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $4a9976ca6ebf6735$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $4a9976ca6ebf6735$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $4a9976ca6ebf6735$var$EE(fn, context || emitter, once), evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $4a9976ca6ebf6735$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $4a9976ca6ebf6735$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $4a9976ca6ebf6735$var$EventEmitter() {
    this._events = new $4a9976ca6ebf6735$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($4a9976ca6ebf6735$var$has.call(events, name)) names.push($4a9976ca6ebf6735$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $4a9976ca6ebf6735$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $4a9976ca6ebf6735$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $4a9976ca6ebf6735$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $4a9976ca6ebf6735$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $4a9976ca6ebf6735$var$prefix ? $4a9976ca6ebf6735$var$prefix + event : event;
        if (this._events[evt]) $4a9976ca6ebf6735$var$clearEvent(this, evt);
    } else {
        this._events = new $4a9976ca6ebf6735$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$4a9976ca6ebf6735$var$EventEmitter.prototype.off = $4a9976ca6ebf6735$var$EventEmitter.prototype.removeListener;
$4a9976ca6ebf6735$var$EventEmitter.prototype.addListener = $4a9976ca6ebf6735$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$4a9976ca6ebf6735$var$EventEmitter.prefixed = $4a9976ca6ebf6735$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$4a9976ca6ebf6735$var$EventEmitter.EventEmitter = $4a9976ca6ebf6735$var$EventEmitter;
module.exports = $4a9976ca6ebf6735$var$EventEmitter;

});

parcelRegister("jYAnN", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $ihoyg = parcelRequire("ihoyg");
var $e8afd7c873f26482$require$Buffer = $ihoyg.Buffer;
var $e8afd7c873f26482$var$isNode = Object.prototype.toString.call(typeof $4TNnu !== "undefined" ? $4TNnu : 0) === "[object process]";
var $e8afd7c873f26482$var$isRN = typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $e8afd7c873f26482$var$_btoa = null;
var $e8afd7c873f26482$var$helpers = null;


if ($e8afd7c873f26482$var$isNode || $e8afd7c873f26482$var$isRN) {
    $e8afd7c873f26482$var$_btoa = function(str) {
        return $e8afd7c873f26482$require$Buffer.from(str).toString("base64");
    };
    var $e8afd7c873f26482$var$url = (parcelRequire("hH01d"));
    if ($e8afd7c873f26482$var$url.URL) {
        // Use the new Node 6+ API for parsing URLs that supports username/password
        var $e8afd7c873f26482$var$newURL = $e8afd7c873f26482$var$url.URL;
        $e8afd7c873f26482$var$helpers = function(url) {
            return new $e8afd7c873f26482$var$newURL(url);
        };
    } else // Web3 supports Node.js 5, so fall back to the legacy URL API if necessary
    $e8afd7c873f26482$var$helpers = (parcelRequire("hH01d")).parse;
} else {
    $e8afd7c873f26482$var$_btoa = btoa.bind(window);
    $e8afd7c873f26482$var$helpers = function(url) {
        return new URL(url);
    };
}
module.exports = {
    parseURL: $e8afd7c873f26482$var$helpers,
    btoa: $e8afd7c873f26482$var$_btoa
};

});

parcelRegister("heyrh", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $dmsQh = parcelRequire("dmsQh");

var $59lZZ = parcelRequire("59lZZ");
module.exports = {
    errors: $dmsQh,
    formatters: $59lZZ
};

});
parcelRegister("dmsQh", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file errors.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";
module.exports = {
    ErrorResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : JSON.stringify(result);
        var data = !!result.error && !!result.error.data ? result.error.data : null;
        var err = new Error("Returned error: " + message);
        err.data = data;
        return err;
    },
    InvalidNumberOfParams: function(got, expected, method) {
        return new Error('Invalid number of parameters for "' + method + '". Got ' + got + " expected " + expected + "!");
    },
    InvalidConnection: function(host, event) {
        return this.ConnectionError("CONNECTION ERROR: Couldn't connect to node " + host + ".", event);
    },
    InvalidProvider: function() {
        return new Error("Provider not set or invalid");
    },
    InvalidResponse: function(result) {
        var message = !!result && !!result.error && !!result.error.message ? result.error.message : "Invalid JSON RPC response: " + JSON.stringify(result);
        return new Error(message);
    },
    ConnectionTimeout: function(ms) {
        return new Error("CONNECTION TIMEOUT: timeout of " + ms + " ms achived");
    },
    ConnectionNotOpenError: function(event) {
        return this.ConnectionError("connection not open on send()", event);
    },
    ConnectionCloseError: function(event) {
        if (typeof event === "object" && event.code && event.reason) return this.ConnectionError("CONNECTION ERROR: The connection got closed with the close code `" + event.code + "` and the following " + "reason string `" + event.reason + "`", event);
        return new Error("CONNECTION ERROR: The connection closed unexpectedly");
    },
    MaxAttemptsReachedOnReconnectingError: function() {
        return new Error("Maximum number of reconnect attempts reached!");
    },
    PendingRequestsOnReconnectingError: function() {
        return new Error("CONNECTION ERROR: Provider started to reconnect before the response got received!");
    },
    ConnectionError: function(msg, event) {
        const error = new Error(msg);
        if (event) {
            error.code = event.code;
            error.reason = event.reason;
        }
        return error;
    },
    RevertInstructionError: function(reason, signature) {
        var error = new Error("Your request got reverted with the following reason string: " + reason);
        error.reason = reason;
        error.signature = signature;
        return error;
    },
    TransactionRevertInstructionError: function(reason, signature, receipt) {
        var error = new Error("Transaction has been reverted by the EVM:\n" + JSON.stringify(receipt, null, 2));
        error.reason = reason;
        error.signature = signature;
        error.receipt = receipt;
        return error;
    },
    TransactionError: function(message, receipt) {
        var error = new Error(message);
        error.receipt = receipt;
        return error;
    },
    NoContractAddressFoundError: function(receipt) {
        return this.TransactionError("The transaction receipt didn't contain a contract address.", receipt);
    },
    ContractCodeNotStoredError: function(receipt) {
        return this.TransactionError("The contract code couldn't be stored, please check your gas limit.", receipt);
    },
    TransactionRevertedWithoutReasonError: function(receipt) {
        return this.TransactionError("Transaction has been reverted by the EVM:\n" + JSON.stringify(receipt, null, 2), receipt);
    },
    TransactionOutOfGasError: function(receipt) {
        return this.TransactionError("Transaction ran out of gas. Please provide more gas:\n" + JSON.stringify(receipt, null, 2), receipt);
    },
    ResolverMethodMissingError: function(address, name) {
        return new Error("The resolver at " + address + 'does not implement requested method: "' + name + '".');
    },
    ContractMissingABIError: function() {
        return new Error("You must provide the json interface of the contract when instantiating a contract object.");
    },
    ContractOnceRequiresCallbackError: function() {
        return new Error("Once requires a callback as the second parameter.");
    },
    ContractEventDoesNotExistError: function(eventName) {
        return new Error('Event "' + eventName + "\" doesn't exist in this contract.");
    },
    ContractReservedEventError: function(type) {
        return new Error('The event "' + type + "\" is a reserved event name, you can't use it.");
    },
    ContractMissingDeployDataError: function() {
        return new Error('No "data" specified in neither the given options, nor the default options.');
    },
    ContractNoAddressDefinedError: function() {
        return new Error("This contract object doesn't have address set yet, please set an address first.");
    },
    ContractNoFromAddressDefinedError: function() {
        return new Error('No "from" address specified in neither the given options, nor the default options.');
    }
};

});

parcelRegister("59lZZ", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file formatters.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";

var $hpg7W = parcelRequire("hpg7W");

var $j6ZZu = parcelRequire("j6ZZu");
/**
 * Will format the given storage key array values to hex strings.
 *
 * @method inputStorageKeysFormatter
 *
 * @param {Array<Number|String|BN|BigNumber>} keys
 *
 * @returns {Array<String>}
 */ var $3bfedb826805f071$var$inputStorageKeysFormatter = function(keys) {
    return keys.map($hpg7W.numberToHex);
};
/**
 * Will format the given proof response from the node.
 *
 * @method outputProofFormatter
 *
 * @param {object} proof
 *
 * @returns {object}
 */ var $3bfedb826805f071$var$outputProofFormatter = function(proof) {
    proof.address = $hpg7W.toChecksumAddress(proof.address);
    proof.nonce = $hpg7W.hexToNumberString(proof.nonce);
    proof.balance = $hpg7W.hexToNumberString(proof.balance);
    return proof;
};
/**
 * Should the format output to a big number
 *
 * @method outputBigNumberFormatter
 *
 * @param {String|Number|BigNumber|BN} number
 *
 * @returns {BN} object
 */ var $3bfedb826805f071$var$outputBigNumberFormatter = function(number) {
    return $hpg7W.toBN(number).toString(10);
};
/**
 * Returns true if the given blockNumber is 'latest', 'pending', or 'earliest.
 *
 * @method isPredefinedBlockNumber
 *
 * @param {String} blockNumber
 *
 * @returns {Boolean}
 */ var $3bfedb826805f071$var$isPredefinedBlockNumber = function(blockNumber) {
    return blockNumber === "latest" || blockNumber === "pending" || blockNumber === "earliest";
};
/**
 * Returns the given block number as hex string or does return the defaultBlock property of the current module
 *
 * @method inputDefaultBlockNumberFormatter
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var $3bfedb826805f071$var$inputDefaultBlockNumberFormatter = function(blockNumber) {
    if (this && (blockNumber === undefined || blockNumber === null)) return $3bfedb826805f071$var$inputBlockNumberFormatter(this.defaultBlock);
    return $3bfedb826805f071$var$inputBlockNumberFormatter(blockNumber);
};
/**
 * Returns the given block number as hex string or the predefined block number 'latest', 'pending', 'earliest', 'genesis'
 *
 * @param {String|Number|BN|BigNumber} blockNumber
 *
 * @returns {String}
 */ var $3bfedb826805f071$var$inputBlockNumberFormatter = function(blockNumber) {
    if (blockNumber === undefined) return undefined;
    if ($3bfedb826805f071$var$isPredefinedBlockNumber(blockNumber)) return blockNumber;
    if (blockNumber === "genesis") return "0x0";
    return $hpg7W.isHexStrict(blockNumber) ? typeof blockNumber === "string" ? blockNumber.toLowerCase() : blockNumber : $hpg7W.numberToHex(blockNumber);
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method _txInputFormatter
 * @param {Object} transaction options
 * @returns object
 */ var $3bfedb826805f071$var$_txInputFormatter = function(options) {
    if (options.to) options.to = $3bfedb826805f071$var$inputAddressFormatter(options.to);
    if (options.data && options.input) throw new Error('You can\'t have "data" and "input" as properties of transactions at the same time, please use either "data" or "input" instead.');
    if (!options.data && options.input) {
        options.data = options.input;
        delete options.input;
    }
    if (options.data && !options.data.startsWith("0x")) options.data = "0x" + options.data;
    if (options.data && !$hpg7W.isHex(options.data)) throw new Error("The data field must be HEX encoded data.");
    // allow both
    if (options.gas || options.gasLimit) options.gas = options.gas || options.gasLimit;
    if (options.maxPriorityFeePerGas || options.maxFeePerGas) delete options.gasPrice;
    [
        "gasPrice",
        "gas",
        "value",
        "maxPriorityFeePerGas",
        "maxFeePerGas",
        "nonce"
    ].filter(function(key) {
        return options[key] !== undefined;
    }).forEach(function(key) {
        options[key] = $hpg7W.numberToHex(options[key]);
    });
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputCallFormatter
 * @param {Object} transaction options
 * @returns object
 */ var $3bfedb826805f071$var$inputCallFormatter = function(options) {
    options = $3bfedb826805f071$var$_txInputFormatter(options);
    var from = options.from || (this ? this.defaultAccount : null);
    if (from) options.from = $3bfedb826805f071$var$inputAddressFormatter(from);
    return options;
};
/**
 * Formats the input of a transaction and converts all values to HEX
 *
 * @method inputTransactionFormatter
 * @param {Object} options
 * @returns object
 */ var $3bfedb826805f071$var$inputTransactionFormatter = function(options) {
    options = $3bfedb826805f071$var$_txInputFormatter(options);
    // check from, only if not number, or object
    if (!(typeof options.from === "number") && !(!!options.from && typeof options.from === "object")) {
        options.from = options.from || (this ? this.defaultAccount : null);
        if (!options.from && !(typeof options.from === "number")) throw new Error('The send transactions "from" field must be defined!');
        options.from = $3bfedb826805f071$var$inputAddressFormatter(options.from);
    }
    return options;
};
/**
 * Hex encodes the data passed to eth_sign and personal_sign
 *
 * @method inputSignFormatter
 * @param {String} data
 * @returns {String}
 */ var $3bfedb826805f071$var$inputSignFormatter = function(data) {
    return $hpg7W.isHexStrict(data) ? data : $hpg7W.utf8ToHex(data);
};
/**
 * Formats the output of a transaction to its proper values
 *
 * @method outputTransactionFormatter
 * @param {Object} tx
 * @returns {Object}
 */ var $3bfedb826805f071$var$outputTransactionFormatter = function(tx) {
    if (tx.blockNumber !== null) tx.blockNumber = $hpg7W.hexToNumber(tx.blockNumber);
    if (tx.transactionIndex !== null) tx.transactionIndex = $hpg7W.hexToNumber(tx.transactionIndex);
    tx.nonce = $hpg7W.hexToNumber(tx.nonce);
    tx.gas = $hpg7W.hexToNumber(tx.gas);
    if (tx.gasPrice) tx.gasPrice = $3bfedb826805f071$var$outputBigNumberFormatter(tx.gasPrice);
    if (tx.maxFeePerGas) tx.maxFeePerGas = $3bfedb826805f071$var$outputBigNumberFormatter(tx.maxFeePerGas);
    if (tx.maxPriorityFeePerGas) tx.maxPriorityFeePerGas = $3bfedb826805f071$var$outputBigNumberFormatter(tx.maxPriorityFeePerGas);
    if (tx.type) tx.type = $hpg7W.hexToNumber(tx.type);
    tx.value = $3bfedb826805f071$var$outputBigNumberFormatter(tx.value);
    if (tx.to && $hpg7W.isAddress(tx.to)) tx.to = $hpg7W.toChecksumAddress(tx.to);
    else tx.to = null; // set to `null` if invalid address
    if (tx.from) tx.from = $hpg7W.toChecksumAddress(tx.from);
    return tx;
};
/**
 * Formats the output of a transaction receipt to its proper values
 *
 * @method outputTransactionReceiptFormatter
 * @param {Object} receipt
 * @returns {Object}
 */ var $3bfedb826805f071$var$outputTransactionReceiptFormatter = function(receipt) {
    if (typeof receipt !== "object") throw new Error("Received receipt is invalid: " + receipt);
    if (receipt.blockNumber !== null) receipt.blockNumber = $hpg7W.hexToNumber(receipt.blockNumber);
    if (receipt.transactionIndex !== null) receipt.transactionIndex = $hpg7W.hexToNumber(receipt.transactionIndex);
    receipt.cumulativeGasUsed = $hpg7W.hexToNumber(receipt.cumulativeGasUsed);
    receipt.gasUsed = $hpg7W.hexToNumber(receipt.gasUsed);
    if (Array.isArray(receipt.logs)) receipt.logs = receipt.logs.map($3bfedb826805f071$var$outputLogFormatter);
    if (receipt.contractAddress) receipt.contractAddress = $hpg7W.toChecksumAddress(receipt.contractAddress);
    if (typeof receipt.status !== "undefined" && receipt.status !== null) receipt.status = Boolean(parseInt(receipt.status));
    return receipt;
};
/**
 * Formats the output of a block to its proper values
 *
 * @method outputBlockFormatter
 * @param {Object} block
 * @returns {Object}
 */ var $3bfedb826805f071$var$outputBlockFormatter = function(block) {
    // transform to number
    block.gasLimit = $hpg7W.hexToNumber(block.gasLimit);
    block.gasUsed = $hpg7W.hexToNumber(block.gasUsed);
    block.size = $hpg7W.hexToNumber(block.size);
    block.timestamp = $hpg7W.hexToNumber(block.timestamp);
    if (block.number !== null) block.number = $hpg7W.hexToNumber(block.number);
    if (block.difficulty) block.difficulty = $3bfedb826805f071$var$outputBigNumberFormatter(block.difficulty);
    if (block.totalDifficulty) block.totalDifficulty = $3bfedb826805f071$var$outputBigNumberFormatter(block.totalDifficulty);
    if (Array.isArray(block.transactions)) block.transactions.forEach(function(item) {
        if (!(typeof item === "string")) return $3bfedb826805f071$var$outputTransactionFormatter(item);
    });
    if (block.miner) block.miner = $hpg7W.toChecksumAddress(block.miner);
    return block;
};
/**
 * Formats the input of a log
 *
 * @method inputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var $3bfedb826805f071$var$inputLogFormatter = function(options) {
    var toTopic = function(value) {
        if (value === null || typeof value === "undefined") return null;
        value = String(value);
        if (value.indexOf("0x") === 0) return value;
        else return $hpg7W.fromUtf8(value);
    };
    if (options === undefined) options = {};
    // If options !== undefined, don't blow out existing data
    if (options.fromBlock === undefined) options = {
        ...options,
        fromBlock: "latest"
    };
    if (options.fromBlock || options.fromBlock === 0) options.fromBlock = $3bfedb826805f071$var$inputBlockNumberFormatter(options.fromBlock);
    if (options.toBlock || options.toBlock === 0) options.toBlock = $3bfedb826805f071$var$inputBlockNumberFormatter(options.toBlock);
    // make sure topics, get converted to hex
    options.topics = options.topics || [];
    options.topics = options.topics.map(function(topic) {
        return Array.isArray(topic) ? topic.map(toTopic) : toTopic(topic);
    });
    toTopic = null;
    if (options.address) options.address = Array.isArray(options.address) ? options.address.map(function(addr) {
        return $3bfedb826805f071$var$inputAddressFormatter(addr);
    }) : $3bfedb826805f071$var$inputAddressFormatter(options.address);
    return options;
};
/**
 * Formats the output of a log
 *
 * @method outputLogFormatter
 * @param {Object} log object
 * @returns {Object} log
 */ var $3bfedb826805f071$var$outputLogFormatter = function(log) {
    // generate a custom log id
    if (typeof log.blockHash === "string" && typeof log.transactionHash === "string" && typeof log.logIndex === "string") {
        var shaId = $hpg7W.sha3(log.blockHash.replace("0x", "") + log.transactionHash.replace("0x", "") + log.logIndex.replace("0x", ""));
        log.id = "log_" + shaId.replace("0x", "").substr(0, 8);
    } else if (!log.id) log.id = null;
    if (log.blockNumber !== null) log.blockNumber = $hpg7W.hexToNumber(log.blockNumber);
    if (log.transactionIndex !== null) log.transactionIndex = $hpg7W.hexToNumber(log.transactionIndex);
    if (log.logIndex !== null) log.logIndex = $hpg7W.hexToNumber(log.logIndex);
    if (log.address) log.address = $hpg7W.toChecksumAddress(log.address);
    return log;
};
/**
 * Formats the input of a whisper post and converts all values to HEX
 *
 * @method inputPostFormatter
 * @param {Object} transaction object
 * @returns {Object}
 */ var $3bfedb826805f071$var$inputPostFormatter = function(post) {
    // post.payload = utils.toHex(post.payload);
    if (post.ttl) post.ttl = $hpg7W.numberToHex(post.ttl);
    if (post.workToProve) post.workToProve = $hpg7W.numberToHex(post.workToProve);
    if (post.priority) post.priority = $hpg7W.numberToHex(post.priority);
    // fallback
    if (!Array.isArray(post.topics)) post.topics = post.topics ? [
        post.topics
    ] : [];
    // format the following options
    post.topics = post.topics.map(function(topic) {
        // convert only if not hex
        return topic.indexOf("0x") === 0 ? topic : $hpg7W.fromUtf8(topic);
    });
    return post;
};
/**
 * Formats the output of a received post message
 *
 * @method outputPostFormatter
 * @param {Object}
 * @returns {Object}
 */ var $3bfedb826805f071$var$outputPostFormatter = function(post) {
    post.expiry = $hpg7W.hexToNumber(post.expiry);
    post.sent = $hpg7W.hexToNumber(post.sent);
    post.ttl = $hpg7W.hexToNumber(post.ttl);
    post.workProved = $hpg7W.hexToNumber(post.workProved);
    // post.payloadRaw = post.payload;
    // post.payload = utils.hexToAscii(post.payload);
    // if (utils.isJson(post.payload)) {
    //     post.payload = JSON.parse(post.payload);
    // }
    // format the following options
    if (!post.topics) post.topics = [];
    post.topics = post.topics.map(function(topic) {
        return $hpg7W.toUtf8(topic);
    });
    return post;
};
var $3bfedb826805f071$var$inputAddressFormatter = function(address) {
    var iban = new $j6ZZu(address);
    if (iban.isValid() && iban.isDirect()) return iban.toAddress().toLowerCase();
    else if ($hpg7W.isAddress(address)) return "0x" + address.toLowerCase().replace("0x", "");
    throw new Error(`Provided address ${address} is invalid, the capitalization checksum test failed, or it's an indirect IBAN address which can't be converted.`);
};
var $3bfedb826805f071$var$outputSyncingFormatter = function(result) {
    result.startingBlock = $hpg7W.hexToNumber(result.startingBlock);
    result.currentBlock = $hpg7W.hexToNumber(result.currentBlock);
    result.highestBlock = $hpg7W.hexToNumber(result.highestBlock);
    if (result.knownStates) {
        result.knownStates = $hpg7W.hexToNumber(result.knownStates);
        result.pulledStates = $hpg7W.hexToNumber(result.pulledStates);
    }
    return result;
};
module.exports = {
    inputDefaultBlockNumberFormatter: $3bfedb826805f071$var$inputDefaultBlockNumberFormatter,
    inputBlockNumberFormatter: $3bfedb826805f071$var$inputBlockNumberFormatter,
    inputCallFormatter: $3bfedb826805f071$var$inputCallFormatter,
    inputTransactionFormatter: $3bfedb826805f071$var$inputTransactionFormatter,
    inputAddressFormatter: $3bfedb826805f071$var$inputAddressFormatter,
    inputPostFormatter: $3bfedb826805f071$var$inputPostFormatter,
    inputLogFormatter: $3bfedb826805f071$var$inputLogFormatter,
    inputSignFormatter: $3bfedb826805f071$var$inputSignFormatter,
    inputStorageKeysFormatter: $3bfedb826805f071$var$inputStorageKeysFormatter,
    outputProofFormatter: $3bfedb826805f071$var$outputProofFormatter,
    outputBigNumberFormatter: $3bfedb826805f071$var$outputBigNumberFormatter,
    outputTransactionFormatter: $3bfedb826805f071$var$outputTransactionFormatter,
    outputTransactionReceiptFormatter: $3bfedb826805f071$var$outputTransactionReceiptFormatter,
    outputBlockFormatter: $3bfedb826805f071$var$outputBlockFormatter,
    outputLogFormatter: $3bfedb826805f071$var$outputLogFormatter,
    outputPostFormatter: $3bfedb826805f071$var$outputPostFormatter,
    outputSyncingFormatter: $3bfedb826805f071$var$outputSyncingFormatter
};

});
parcelRegister("hpg7W", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $e569m = parcelRequire("e569m");

var $as7K2 = parcelRequire("as7K2");

var $cV2C1 = parcelRequire("cV2C1");

var $5rfiH = parcelRequire("5rfiH");

var $7vYz3 = parcelRequire("7vYz3");
/**
 * Fires an error in an event emitter and callback and returns the eventemitter
 *
 * @method _fireError
 * @param {Object} error a string, a error, or an object with {message, data}
 * @param {Object} emitter
 * @param {Function} reject
 * @param {Function} callback
 * @param {any} optionalData
 * @return {Object} the emitter
 */ var $cac147f8ec1d9ca9$var$_fireError = function(error, emitter, reject, callback, optionalData) {
    /*jshint maxcomplexity: 10 */ // add data if given
    if (!!error && typeof error === "object" && !(error instanceof Error) && error.data) {
        if (!!error.data && typeof error.data === "object" || Array.isArray(error.data)) error.data = JSON.stringify(error.data, null, 2);
        error = error.message + "\n" + error.data;
    }
    if (typeof error === "string") error = new Error(error);
    if (typeof callback === "function") callback(error, optionalData);
    if (typeof reject === "function") {
        // suppress uncatched error if an error listener is present
        // OR suppress uncatched error if an callback listener is present
        if (emitter && typeof emitter.listeners === "function" && emitter.listeners("error").length || typeof callback === "function") emitter.catch(function() {});
        // reject later, to be able to return emitter
        setTimeout(function() {
            reject(error);
        }, 1);
    }
    if (emitter && typeof emitter.emit === "function") // emit later, to be able to return emitter
    setTimeout(function() {
        emitter.emit("error", error, optionalData);
        emitter.removeAllListeners();
    }, 1);
    return emitter;
};
/**
 * Should be used to create full function/event name from json abi
 *
 * @method _jsonInterfaceMethodToString
 * @param {Object} json
 * @return {String} full function/event name
 */ var $cac147f8ec1d9ca9$var$_jsonInterfaceMethodToString = function(json) {
    if (!!json && typeof json === "object" && json.name && json.name.indexOf("(") !== -1) return json.name;
    return json.name + "(" + $cac147f8ec1d9ca9$var$_flattenTypes(false, json.inputs).join(",") + ")";
};
/**
 * Should be used to flatten json abi inputs/outputs into an array of type-representing-strings
 *
 * @method _flattenTypes
 * @param {bool} includeTuple
 * @param {Object} puts
 * @return {Array} parameters as strings
 */ var $cac147f8ec1d9ca9$var$_flattenTypes = function(includeTuple, puts) {
    // console.log("entered _flattenTypes. inputs/outputs: " + puts)
    var types = [];
    puts.forEach(function(param) {
        if (typeof param.components === "object") {
            if (param.type.substring(0, 5) !== "tuple") throw new Error("components found but type is not tuple; report on GitHub");
            var suffix = "";
            var arrayBracket = param.type.indexOf("[");
            if (arrayBracket >= 0) suffix = param.type.substring(arrayBracket);
            var result = $cac147f8ec1d9ca9$var$_flattenTypes(includeTuple, param.components);
            // console.log("result should have things: " + result)
            if (Array.isArray(result) && includeTuple) // console.log("include tuple word, and its an array. joining...: " + result.types)
            types.push("tuple(" + result.join(",") + ")" + suffix);
            else if (!includeTuple) // console.log("don't include tuple, but its an array. joining...: " + result)
            types.push("(" + result.join(",") + ")" + suffix);
            else // console.log("its a single type within a tuple: " + result.types)
            types.push("(" + result + ")");
        } else // console.log("its a type and not directly in a tuple: " + param.type)
        types.push(param.type);
    });
    return types;
};
/**
 * Returns a random hex string by the given bytes size
 *
 * @param {Number} size
 * @returns {string}
 */ var $cac147f8ec1d9ca9$var$randomHex = function(size) {
    return "0x" + $5rfiH(size).toString("hex");
};
/**
 * Should be called to get ascii from it's hex representation
 *
 * @method hexToAscii
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var $cac147f8ec1d9ca9$var$hexToAscii = function(hex) {
    if (!$as7K2.isHexStrict(hex)) throw new Error("The parameter must be a valid HEX string.");
    var str = "";
    var i = 0, l = hex.length;
    if (hex.substring(0, 2) === "0x") i = 2;
    for(; i < l; i += 2){
        var code = parseInt(hex.substr(i, 2), 16);
        str += String.fromCharCode(code);
    }
    return str;
};
/**
 * Should be called to get hex representation (prefixed by 0x) of ascii string
 *
 * @method asciiToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var $cac147f8ec1d9ca9$var$asciiToHex = function(str) {
    if (!str) return "0x00";
    var hex = "";
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    }
    return "0x" + hex;
};
/**
 * Returns value of unit in Wei
 *
 * @method getUnitValue
 * @param {String} unit the unit to convert to, default ether
 * @returns {BN} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ var $cac147f8ec1d9ca9$var$getUnitValue = function(unit) {
    unit = unit ? unit.toLowerCase() : "ether";
    if (!$e569m.unitMap[unit]) throw new Error('This unit "' + unit + "\" doesn't exist, please use the one of the following units" + JSON.stringify($e569m.unitMap, null, 2));
    return unit;
};
/**
 * Takes a number of wei and converts it to any other ether unit.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method fromWei
 * @param {Number|String} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert to, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var $cac147f8ec1d9ca9$var$fromWei = function(number, unit) {
    unit = $cac147f8ec1d9ca9$var$getUnitValue(unit);
    if (!$as7K2.isBN(number) && !(typeof number === "string")) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return $as7K2.isBN(number) ? $e569m.fromWei(number, unit) : $e569m.fromWei(number, unit).toString(10);
};
/**
 * Takes a number of a unit and converts it to wei.
 *
 * Possible units are:
 *   SI Short   SI Full        Effigy       Other
 * - kwei       femtoether     babbage
 * - mwei       picoether      lovelace
 * - gwei       nanoether      shannon      nano
 * - --         microether     szabo        micro
 * - --         microether     szabo        micro
 * - --         milliether     finney       milli
 * - ether      --             --
 * - kether                    --           grand
 * - mether
 * - gether
 * - tether
 *
 * @method toWei
 * @param {Number|String|BN} number can be a number, number string or a HEX of a decimal
 * @param {String} unit the unit to convert from, default ether
 * @return {String|Object} When given a BN object it returns one as well, otherwise a number
 */ var $cac147f8ec1d9ca9$var$toWei = function(number, unit) {
    unit = $cac147f8ec1d9ca9$var$getUnitValue(unit);
    if (!$as7K2.isBN(number) && !(typeof number === "string")) throw new Error("Please pass numbers as strings or BN objects to avoid precision errors.");
    return $as7K2.isBN(number) ? $e569m.toWei(number, unit) : $e569m.toWei(number, unit).toString(10);
};
/**
 * Converts to a checksum address
 *
 * @method toChecksumAddress
 * @param {String} address the given HEX address
 * @return {String}
 */ var $cac147f8ec1d9ca9$var$toChecksumAddress = function(address) {
    if (typeof address === "undefined") return "";
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) throw new Error('Given address "' + address + '" is not a valid Ethereum address.');
    address = address.toLowerCase().replace(/^0x/i, "");
    var addressHash = $as7K2.sha3(address).replace(/^0x/i, "");
    var checksumAddress = "0x";
    for(var i = 0; i < address.length; i++)// If ith character is 8 to f then make it uppercase
    if (parseInt(addressHash[i], 16) > 7) checksumAddress += address[i].toUpperCase();
    else checksumAddress += address[i];
    return checksumAddress;
};
/**
 * Returns -1 if a<b, 1 if a>b; 0 if a == b.
 * For more details on this type of function, see
 * developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
 *
 * @method compareBlockNumbers
 *
 * @param {String|Number|BN} a
 *
 * @param {String|Number|BN} b
 *
 * @returns {Number} -1, 0, or 1
 */ var $cac147f8ec1d9ca9$var$compareBlockNumbers = function(a, b) {
    if (a == b) return 0;
    else if (("genesis" == a || "earliest" == a || 0 == a) && ("genesis" == b || "earliest" == b || 0 == b)) return 0;
    else if ("genesis" == a || "earliest" == a) // b !== a, thus a < b
    return -1;
    else if ("genesis" == b || "earliest" == b) // b !== a, thus a > b
    return 1;
    else if (a == "latest") {
        if (b == "pending") return -1;
        else // b !== ("pending" OR "latest"), thus a > b
        return 1;
    } else if (b === "latest") {
        if (a == "pending") return 1;
        else // b !== ("pending" OR "latest"), thus a > b
        return -1;
    } else if (a == "pending") // b (== OR <) "latest", thus a > b
    return 1;
    else if (b == "pending") return -1;
    else {
        let bnA = new $7vYz3(a);
        let bnB = new $7vYz3(b);
        if (bnA.lt(bnB)) return -1;
        else if (bnA.eq(bnB)) return 0;
        else return 1;
    }
};
module.exports = {
    _fireError: $cac147f8ec1d9ca9$var$_fireError,
    _jsonInterfaceMethodToString: $cac147f8ec1d9ca9$var$_jsonInterfaceMethodToString,
    _flattenTypes: $cac147f8ec1d9ca9$var$_flattenTypes,
    // extractDisplayName: extractDisplayName,
    // extractTypeName: extractTypeName,
    randomHex: $cac147f8ec1d9ca9$var$randomHex,
    BN: $as7K2.BN,
    isBN: $as7K2.isBN,
    isBigNumber: $as7K2.isBigNumber,
    isHex: $as7K2.isHex,
    isHexStrict: $as7K2.isHexStrict,
    sha3: $as7K2.sha3,
    sha3Raw: $as7K2.sha3Raw,
    keccak256: $as7K2.sha3,
    soliditySha3: $cV2C1.soliditySha3,
    soliditySha3Raw: $cV2C1.soliditySha3Raw,
    encodePacked: $cV2C1.encodePacked,
    isAddress: $as7K2.isAddress,
    checkAddressChecksum: $as7K2.checkAddressChecksum,
    toChecksumAddress: $cac147f8ec1d9ca9$var$toChecksumAddress,
    toHex: $as7K2.toHex,
    toBN: $as7K2.toBN,
    bytesToHex: $as7K2.bytesToHex,
    hexToBytes: $as7K2.hexToBytes,
    hexToNumberString: $as7K2.hexToNumberString,
    hexToNumber: $as7K2.hexToNumber,
    toDecimal: $as7K2.hexToNumber,
    numberToHex: $as7K2.numberToHex,
    fromDecimal: $as7K2.numberToHex,
    hexToUtf8: $as7K2.hexToUtf8,
    hexToString: $as7K2.hexToUtf8,
    toUtf8: $as7K2.hexToUtf8,
    stripHexPrefix: $as7K2.stripHexPrefix,
    utf8ToHex: $as7K2.utf8ToHex,
    stringToHex: $as7K2.utf8ToHex,
    fromUtf8: $as7K2.utf8ToHex,
    hexToAscii: $cac147f8ec1d9ca9$var$hexToAscii,
    toAscii: $cac147f8ec1d9ca9$var$hexToAscii,
    asciiToHex: $cac147f8ec1d9ca9$var$asciiToHex,
    fromAscii: $cac147f8ec1d9ca9$var$asciiToHex,
    unitMap: $e569m.unitMap,
    toWei: $cac147f8ec1d9ca9$var$toWei,
    fromWei: $cac147f8ec1d9ca9$var$fromWei,
    padLeft: $as7K2.leftPad,
    leftPad: $as7K2.leftPad,
    padRight: $as7K2.rightPad,
    rightPad: $as7K2.rightPad,
    toTwosComplement: $as7K2.toTwosComplement,
    isBloom: $as7K2.isBloom,
    isUserEthereumAddressInBloom: $as7K2.isUserEthereumAddressInBloom,
    isContractAddressInBloom: $as7K2.isContractAddressInBloom,
    isTopic: $as7K2.isTopic,
    isTopicInBloom: $as7K2.isTopicInBloom,
    isInBloom: $as7K2.isInBloom,
    compareBlockNumbers: $cac147f8ec1d9ca9$var$compareBlockNumbers,
    toNumber: $as7K2.toNumber
};

});
parcelRegister("e569m", function(module, exports) {
"use strict";

var $iwkA7 = parcelRequire("iwkA7");

var $jSsAl = parcelRequire("jSsAl");
var $a4064d95cc7d1b84$var$zero = new $iwkA7(0);
var $a4064d95cc7d1b84$var$negative1 = new $iwkA7(-1);
// complete ethereum unit map
var $a4064d95cc7d1b84$var$unitMap = {
    "noether": "0",
    "wei": "1",
    "kwei": "1000",
    "Kwei": "1000",
    "babbage": "1000",
    "femtoether": "1000",
    "mwei": "1000000",
    "Mwei": "1000000",
    "lovelace": "1000000",
    "picoether": "1000000",
    "gwei": "1000000000",
    "Gwei": "1000000000",
    "shannon": "1000000000",
    "nanoether": "1000000000",
    "nano": "1000000000",
    "szabo": "1000000000000",
    "microether": "1000000000000",
    "micro": "1000000000000",
    "finney": "1000000000000000",
    "milliether": "1000000000000000",
    "milli": "1000000000000000",
    "ether": "1000000000000000000",
    "kether": "1000000000000000000000",
    "grand": "1000000000000000000000",
    "mether": "1000000000000000000000000",
    "gether": "1000000000000000000000000000",
    "tether": "1000000000000000000000000000000"
};
/**
 * Returns value of unit in Wei
 *
 * @method getValueOfUnit
 * @param {String} unit the unit to convert to, default ether
 * @returns {BigNumber} value of the unit (in Wei)
 * @throws error if the unit is not correct:w
 */ function $a4064d95cc7d1b84$var$getValueOfUnit(unitInput) {
    var unit = unitInput ? unitInput.toLowerCase() : "ether";
    var unitValue = $a4064d95cc7d1b84$var$unitMap[unit]; // eslint-disable-line
    if (typeof unitValue !== "string") throw new Error("[ethjs-unit] the unit provided " + unitInput + " doesn't exists, please use the one of the following units " + JSON.stringify($a4064d95cc7d1b84$var$unitMap, null, 2));
    return new $iwkA7(unitValue, 10);
}
function $a4064d95cc7d1b84$var$numberToString(arg) {
    if (typeof arg === "string") {
        if (!arg.match(/^-?[0-9.]+$/)) throw new Error("while converting number to string, invalid number value '" + arg + "', should be a number matching (^-?[0-9.]+).");
        return arg;
    } else if (typeof arg === "number") return String(arg);
    else if (typeof arg === "object" && arg.toString && (arg.toTwos || arg.dividedToIntegerBy)) {
        if (arg.toPrecision) return String(arg.toPrecision());
        else // eslint-disable-line
        return arg.toString(10);
    }
    throw new Error("while converting number to string, invalid number value '" + arg + "' type " + typeof arg + ".");
}
function $a4064d95cc7d1b84$var$fromWei(weiInput, unit, optionsInput) {
    var wei = $jSsAl(weiInput); // eslint-disable-line
    var negative = wei.lt($a4064d95cc7d1b84$var$zero); // eslint-disable-line
    var base = $a4064d95cc7d1b84$var$getValueOfUnit(unit);
    var baseLength = $a4064d95cc7d1b84$var$unitMap[unit].length - 1 || 1;
    var options = optionsInput || {};
    if (negative) wei = wei.mul($a4064d95cc7d1b84$var$negative1);
    var fraction = wei.mod(base).toString(10); // eslint-disable-line
    while(fraction.length < baseLength)fraction = "0" + fraction;
    if (!options.pad) fraction = fraction.match(/^([0-9]*[1-9]|0)(0*)/)[1];
    var whole = wei.div(base).toString(10); // eslint-disable-line
    if (options.commify) whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var value = "" + whole + (fraction == "0" ? "" : "." + fraction); // eslint-disable-line
    if (negative) value = "-" + value;
    return value;
}
function $a4064d95cc7d1b84$var$toWei(etherInput, unit) {
    var ether = $a4064d95cc7d1b84$var$numberToString(etherInput); // eslint-disable-line
    var base = $a4064d95cc7d1b84$var$getValueOfUnit(unit);
    var baseLength = $a4064d95cc7d1b84$var$unitMap[unit].length - 1 || 1;
    // Is it negative?
    var negative = ether.substring(0, 1) === "-"; // eslint-disable-line
    if (negative) ether = ether.substring(1);
    if (ether === ".") throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei, invalid value");
    // Split it into a whole and fractional part
    var comps = ether.split("."); // eslint-disable-line
    if (comps.length > 2) throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei,  too many decimal points");
    var whole = comps[0], fraction = comps[1]; // eslint-disable-line
    if (!whole) whole = "0";
    if (!fraction) fraction = "0";
    if (fraction.length > baseLength) throw new Error("[ethjs-unit] while converting number " + etherInput + " to wei, too many decimal places");
    while(fraction.length < baseLength)fraction += "0";
    whole = new $iwkA7(whole);
    fraction = new $iwkA7(fraction);
    var wei = whole.mul(base).add(fraction); // eslint-disable-line
    if (negative) wei = wei.mul($a4064d95cc7d1b84$var$negative1);
    return new $iwkA7(wei.toString(10), 10);
}
module.exports = {
    unitMap: $a4064d95cc7d1b84$var$unitMap,
    numberToString: $a4064d95cc7d1b84$var$numberToString,
    getValueOfUnit: $a4064d95cc7d1b84$var$getValueOfUnit,
    fromWei: $a4064d95cc7d1b84$var$fromWei,
    toWei: $a4064d95cc7d1b84$var$toWei
};

});
parcelRegister("jSsAl", function(module, exports) {

var $dQ123 = parcelRequire("dQ123");

var $gZv7G = parcelRequire("gZv7G");
/**
 * Returns a BN object, converts a number value to a BN
 * @param {String|Number|Object} `arg` input a string number, hex string number, number, BigNumber or BN object
 * @return {Object} `output` BN object of the number
 * @throws if the argument is not an array, object that isn't a bignumber, not a string number or number
 */ module.exports = function numberToBN(arg) {
    if (typeof arg === "string" || typeof arg === "number") {
        var multiplier = new $dQ123(1); // eslint-disable-line
        var formattedString = String(arg).toLowerCase().trim();
        var isHexPrefixed = formattedString.substr(0, 2) === "0x" || formattedString.substr(0, 3) === "-0x";
        var stringArg = $gZv7G(formattedString); // eslint-disable-line
        if (stringArg.substr(0, 1) === "-") {
            stringArg = $gZv7G(stringArg.slice(1));
            multiplier = new $dQ123(-1, 10);
        }
        stringArg = stringArg === "" ? "0" : stringArg;
        if (!stringArg.match(/^-?[0-9]+$/) && stringArg.match(/^[0-9A-Fa-f]+$/) || stringArg.match(/^[a-fA-F]+$/) || isHexPrefixed === true && stringArg.match(/^[0-9A-Fa-f]+$/)) return new $dQ123(stringArg, 16).mul(multiplier);
        if ((stringArg.match(/^-?[0-9]+$/) || stringArg === "") && isHexPrefixed === false) return new $dQ123(stringArg, 10).mul(multiplier);
    } else if (typeof arg === "object" && arg.toString && !arg.pop && !arg.push) {
        if (arg.toString(10).match(/^-?[0-9]+$/) && (arg.mul || arg.dividedToIntegerBy)) return new $dQ123(arg.toString(10), 10);
    }
    throw new Error("[number-to-bn] while converting number " + JSON.stringify(arg) + " to BN.js instance, error: invalid number value. Value must be an integer, hex string, BN or BigNumber instance. Note, decimals are not supported.");
};

});


parcelRegister("as7K2", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file utils.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $79c2863a9083ef41$require$Buffer = $ihoyg.Buffer;

var $7vYz3 = parcelRequire("7vYz3");

var $jSsAl = parcelRequire("jSsAl");

var $1mO22 = parcelRequire("1mO22");

var $kA8g9 = parcelRequire("kA8g9");

var $6jIAb = parcelRequire("6jIAb");
/**
 * Returns true if object is BN, otherwise false
 *
 * @method isBN
 * @param {Object} object
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isBN = function(object) {
    return $7vYz3.isBN(object);
};
/**
 * Returns true if object is BigNumber, otherwise false
 *
 * @method isBigNumber
 * @param {Object} object
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isBigNumber = function(object) {
    return object && object.constructor && object.constructor.name === "BigNumber";
};
/**
 * Takes an input and transforms it into an BN
 *
 * @method toBN
 * @param {Number|String|BN} number, string, HEX string or BN
 * @return {BN} BN
 */ var $79c2863a9083ef41$var$toBN = function(number) {
    try {
        return $jSsAl.apply(null, arguments);
    } catch (e) {
        throw new Error(e + ' Given value: "' + number + '"');
    }
};
/**
 * Takes and input transforms it into BN and if it is negative value, into two's complement
 *
 * @method toTwosComplement
 * @param {Number|String|BN} number
 * @return {String}
 */ var $79c2863a9083ef41$var$toTwosComplement = function(number) {
    return "0x" + $79c2863a9083ef41$var$toBN(number).toTwos(256).toString(16, 64);
};
/**
 * Checks if the given string is an address
 *
 * @method isAddress
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isAddress = function(address) {
    // check if it has the basic requirements of an address
    if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) return false;
    else if (/^(0x|0X)?[0-9a-f]{40}$/.test(address) || /^(0x|0X)?[0-9A-F]{40}$/.test(address)) return true;
    else return $79c2863a9083ef41$var$checkAddressChecksum(address);
};
/**
 * Checks if the given string is a checksummed address
 *
 * @method checkAddressChecksum
 * @param {String} address the given HEX address
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$checkAddressChecksum = function(address) {
    // Check each case
    address = address.replace(/^0x/i, "");
    var addressHash = $79c2863a9083ef41$var$sha3(address.toLowerCase()).replace(/^0x/i, "");
    for(var i = 0; i < 40; i++){
        // the nth letter should be uppercase if the nth digit of casemap is 1
        if (parseInt(addressHash[i], 16) > 7 && address[i].toUpperCase() !== address[i] || parseInt(addressHash[i], 16) <= 7 && address[i].toLowerCase() !== address[i]) return false;
    }
    return true;
};
/**
 * Should be called to pad string to expected length
 *
 * @method leftPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var $79c2863a9083ef41$var$leftPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === "number";
    string = string.toString(16).replace(/^0x/i, "");
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + new Array(padding).join(sign ? sign : "0") + string;
};
/**
 * Should be called to pad string to expected length
 *
 * @method rightPad
 * @param {String} string to be padded
 * @param {Number} chars that result string should have
 * @param {String} sign, by default 0
 * @returns {String} right aligned string
 */ var $79c2863a9083ef41$var$rightPad = function(string, chars, sign) {
    var hasPrefix = /^0x/i.test(string) || typeof string === "number";
    string = string.toString(16).replace(/^0x/i, "");
    var padding = chars - string.length + 1 >= 0 ? chars - string.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + string + new Array(padding).join(sign ? sign : "0");
};
/**
 * Should be called to get hex representation (prefixed by 0x) of utf8 string
 *
 * @method utf8ToHex
 * @param {String} str
 * @returns {String} hex representation of input string
 */ var $79c2863a9083ef41$var$utf8ToHex = function(str) {
    str = $1mO22.encode(str);
    var hex = "";
    // remove \u0000 padding from either side
    str = str.replace(/^(?:\u0000)*/, "");
    str = str.split("").reverse().join("");
    str = str.replace(/^(?:\u0000)*/, "");
    str = str.split("").reverse().join("");
    for(var i = 0; i < str.length; i++){
        var code = str.charCodeAt(i);
        // if (code !== 0) {
        var n = code.toString(16);
        hex += n.length < 2 ? "0" + n : n;
    // }
    }
    return "0x" + hex;
};
/**
 * Should be called to get utf8 from it's hex representation
 *
 * @method hexToUtf8
 * @param {String} hex
 * @returns {String} ascii string representation of hex value
 */ var $79c2863a9083ef41$var$hexToUtf8 = function(hex) {
    if (!$79c2863a9083ef41$var$isHexStrict(hex)) throw new Error('The parameter "' + hex + '" must be a valid HEX string.');
    var str = "";
    var code = 0;
    hex = hex.replace(/^0x/i, "");
    // remove 00 padding from either side
    hex = hex.replace(/^(?:00)*/, "");
    hex = hex.split("").reverse().join("");
    hex = hex.replace(/^(?:00)*/, "");
    hex = hex.split("").reverse().join("");
    var l = hex.length;
    for(var i = 0; i < l; i += 2){
        code = parseInt(hex.substr(i, 2), 16);
        // if (code !== 0) {
        str += String.fromCharCode(code);
    // }
    }
    return $1mO22.decode(str);
};
/**
 * Converts value to it's number representation
 *
 * @method hexToNumber
 * @param {String|Number|BN} value
 * @return {String}
 */ var $79c2863a9083ef41$var$hexToNumber = function(value) {
    if (!value) return value;
    if (typeof value === "string" && !$79c2863a9083ef41$var$isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    return $79c2863a9083ef41$var$toBN(value).toNumber();
};
/**
 * Converts value to it's decimal representation in string
 *
 * @method hexToNumberString
 * @param {String|Number|BN} value
 * @return {String}
 */ var $79c2863a9083ef41$var$hexToNumberString = function(value) {
    if (!value) return value;
    if (typeof value === "string" && !$79c2863a9083ef41$var$isHexStrict(value)) throw new Error('Given value "' + value + '" is not a valid hex string.');
    return $79c2863a9083ef41$var$toBN(value).toString(10);
};
/**
 * Converts value to it's hex representation
 *
 * @method numberToHex
 * @param {String|Number|BN} value
 * @return {String}
 */ var $79c2863a9083ef41$var$numberToHex = function(value) {
    if (value === null || value === undefined) return value;
    if (!isFinite(value) && !$79c2863a9083ef41$var$isHexStrict(value)) throw new Error('Given input "' + value + '" is not a number.');
    var number = $79c2863a9083ef41$var$toBN(value);
    var result = number.toString(16);
    return number.lt(new $7vYz3(0)) ? "-0x" + result.substr(1) : "0x" + result;
};
/**
 * Convert a byte array to a hex string
 *
 * Note: Implementation from crypto-js
 *
 * @method bytesToHex
 * @param {Array} bytes
 * @return {String} the hex string
 */ var $79c2863a9083ef41$var$bytesToHex = function(bytes) {
    for(var hex = [], i = 0; i < bytes.length; i++){
        /* jshint ignore:start */ hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xF).toString(16));
    /* jshint ignore:end */ }
    return "0x" + hex.join("");
};
/**
 * Convert a hex string to a byte array
 *
 * Note: Implementation from crypto-js
 *
 * @method hexToBytes
 * @param {string} hex
 * @return {Array} the byte array
 */ var $79c2863a9083ef41$var$hexToBytes = function(hex) {
    hex = hex.toString(16);
    if (!$79c2863a9083ef41$var$isHexStrict(hex)) throw new Error('Given value "' + hex + '" is not a valid hex string.');
    hex = hex.replace(/^0x/i, "");
    for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
    return bytes;
};
/**
 * Auto converts any given value into it's hex representation.
 *
 * And even stringifys objects before.
 *
 * @method toHex
 * @param {String|Number|BN|Object|Buffer} value
 * @param {Boolean} returnType
 * @return {String}
 */ var $79c2863a9083ef41$var$toHex = function(value, returnType) {
    /*jshint maxcomplexity: false */ if ($79c2863a9083ef41$var$isAddress(value)) return returnType ? "address" : "0x" + value.toLowerCase().replace(/^0x/i, "");
    if (typeof value === "boolean") return returnType ? "bool" : value ? "0x01" : "0x00";
    if ($79c2863a9083ef41$require$Buffer.isBuffer(value)) return "0x" + value.toString("hex");
    if (typeof value === "object" && !!value && !$79c2863a9083ef41$var$isBigNumber(value) && !$79c2863a9083ef41$var$isBN(value)) return returnType ? "string" : $79c2863a9083ef41$var$utf8ToHex(JSON.stringify(value));
    // if its a negative number, pass it through numberToHex
    if (typeof value === "string") {
        if (value.indexOf("-0x") === 0 || value.indexOf("-0X") === 0) return returnType ? "int256" : $79c2863a9083ef41$var$numberToHex(value);
        else if (value.indexOf("0x") === 0 || value.indexOf("0X") === 0) return returnType ? "bytes" : value;
        else if (!isFinite(value)) return returnType ? "string" : $79c2863a9083ef41$var$utf8ToHex(value);
    }
    return returnType ? value < 0 ? "int256" : "uint256" : $79c2863a9083ef41$var$numberToHex(value);
};
/**
 * Check if string is HEX, requires a 0x in front
 *
 * @method isHexStrict
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var $79c2863a9083ef41$var$isHexStrict = function(hex) {
    return (typeof hex === "string" || typeof hex === "number") && /^(-)?0x[0-9a-f]*$/i.test(hex);
};
/**
 * Check if string is HEX
 *
 * @method isHex
 * @param {String} hex to be checked
 * @returns {Boolean}
 */ var $79c2863a9083ef41$var$isHex = function(hex) {
    return (typeof hex === "string" || typeof hex === "number") && /^(-0x|0x)?[0-9a-f]*$/i.test(hex);
};
/**
 * Remove 0x prefix from string
 *
 * @method stripHexPrefix
 * @param {String} str to be checked
 * @returns {String}
 */ var $79c2863a9083ef41$var$stripHexPrefix = function(str) {
    if (str !== 0 && $79c2863a9083ef41$var$isHex(str)) return str.replace(/^(-)?0x/i, "$1");
    return str;
};
/**
 * Returns true if given string is a valid Ethereum block header bloom.
 *
 * @method isBloom
 * @param {String} bloom encoded bloom filter
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isBloom = function(bloom) {
    return $6jIAb.isBloom(bloom);
};
/**
 * Returns true if the ethereum users address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} ethereumAddress encoded bloom filter
 * @param {String} bloom ethereum addresss
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isUserEthereumAddressInBloom = function(bloom, ethereumAddress) {
    return $6jIAb.isUserEthereumAddressInBloom(bloom, ethereumAddress);
};
/**
 * Returns true if the contract address is part of the given bloom
 * note: false positives are possible.
 *
 * @method isUserEthereumAddressInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} contractAddress contract addresss
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isContractAddressInBloom = function(bloom, contractAddress) {
    return $6jIAb.isContractAddressInBloom(bloom, contractAddress);
};
/**
 * Returns true if given string is a valid log topic.
 *
 * @method isTopic
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isTopic = function(topic) {
    return $6jIAb.isTopic(topic);
};
/**
 * Returns true if the topic is part of the given bloom
 * note: false positives are possible.
 *
 * @method isTopicInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String} topic encoded topic
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isTopicInBloom = function(bloom, topic) {
    return $6jIAb.isTopicInBloom(bloom, topic);
};
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 *
 * @method isInBloom
 * @param {String} bloom encoded bloom filter
 * @param {String | Uint8Array} topic encoded value
 * @return {Boolean}
 */ var $79c2863a9083ef41$var$isInBloom = function(bloom, topic) {
    return $6jIAb.isInBloom(bloom, topic);
};
/**
 * Hashes values to a sha3 hash using keccak 256
 *
 * To hash a HEX string the hex must have 0x in front.
 *
 * @method sha3
 * @return {String} the sha3 string
 */ var $79c2863a9083ef41$var$SHA3_NULL_S = "0xc5d2460186f7233c927e7db2dcc703c0e500b653ca82273b7bfad8045d85a470";
var $79c2863a9083ef41$var$sha3 = function(value) {
    if ($79c2863a9083ef41$var$isBN(value)) value = value.toString();
    if ($79c2863a9083ef41$var$isHexStrict(value) && /^0x/i.test(value.toString())) value = $79c2863a9083ef41$var$hexToBytes(value);
    var returnValue = $kA8g9.keccak256(value); // jshint ignore:line
    if (returnValue === $79c2863a9083ef41$var$SHA3_NULL_S) return null;
    else return returnValue;
};
// expose the under the hood keccak256
$79c2863a9083ef41$var$sha3._Hash = $kA8g9;
/**
 * @method sha3Raw
 *
 * @param value
 *
 * @returns {string}
 */ var $79c2863a9083ef41$var$sha3Raw = function(value) {
    value = $79c2863a9083ef41$var$sha3(value);
    if (value === null) return $79c2863a9083ef41$var$SHA3_NULL_S;
    return value;
};
/**
 * Auto converts any given value into it's hex representation,
 * then converts hex to number.
 *
 * @method toNumber
 * @param {String|Number|BN} value
 * @return {Number}
 */ var $79c2863a9083ef41$var$toNumber = function(value) {
    return typeof value === "number" ? value : $79c2863a9083ef41$var$hexToNumber($79c2863a9083ef41$var$toHex(value));
};
module.exports = {
    BN: $7vYz3,
    isBN: $79c2863a9083ef41$var$isBN,
    isBigNumber: $79c2863a9083ef41$var$isBigNumber,
    toBN: $79c2863a9083ef41$var$toBN,
    isAddress: $79c2863a9083ef41$var$isAddress,
    isBloom: $79c2863a9083ef41$var$isBloom,
    isUserEthereumAddressInBloom: $79c2863a9083ef41$var$isUserEthereumAddressInBloom,
    isContractAddressInBloom: $79c2863a9083ef41$var$isContractAddressInBloom,
    isTopic: $79c2863a9083ef41$var$isTopic,
    isTopicInBloom: $79c2863a9083ef41$var$isTopicInBloom,
    isInBloom: $79c2863a9083ef41$var$isInBloom,
    checkAddressChecksum: $79c2863a9083ef41$var$checkAddressChecksum,
    utf8ToHex: $79c2863a9083ef41$var$utf8ToHex,
    hexToUtf8: $79c2863a9083ef41$var$hexToUtf8,
    hexToNumber: $79c2863a9083ef41$var$hexToNumber,
    hexToNumberString: $79c2863a9083ef41$var$hexToNumberString,
    numberToHex: $79c2863a9083ef41$var$numberToHex,
    toHex: $79c2863a9083ef41$var$toHex,
    hexToBytes: $79c2863a9083ef41$var$hexToBytes,
    bytesToHex: $79c2863a9083ef41$var$bytesToHex,
    isHex: $79c2863a9083ef41$var$isHex,
    isHexStrict: $79c2863a9083ef41$var$isHexStrict,
    stripHexPrefix: $79c2863a9083ef41$var$stripHexPrefix,
    leftPad: $79c2863a9083ef41$var$leftPad,
    rightPad: $79c2863a9083ef41$var$rightPad,
    toTwosComplement: $79c2863a9083ef41$var$toTwosComplement,
    sha3: $79c2863a9083ef41$var$sha3,
    sha3Raw: $79c2863a9083ef41$var$sha3Raw,
    toNumber: $79c2863a9083ef41$var$toNumber
};

});
parcelRegister("1mO22", function(module, exports) {
(function(root) {
    var stringFromCharCode = String.fromCharCode;
    // Taken from https://mths.be/punycode
    function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        var value;
        var extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    // Taken from https://mths.be/punycode
    function ucs2encode(array) {
        var length = array.length;
        var index = -1;
        var value;
        var output = "";
        while(++index < length){
            value = array[index];
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
        }
        return output;
    }
    function checkScalarValue(codePoint) {
        if (codePoint >= 0xD800 && codePoint <= 0xDFFF) throw Error("Lone surrogate U+" + codePoint.toString(16).toUpperCase() + " is not a scalar value");
    }
    /*--------------------------------------------------------------------------*/ function createByte(codePoint, shift) {
        return stringFromCharCode(codePoint >> shift & 0x3F | 0x80);
    }
    function encodeCodePoint(codePoint) {
        if ((codePoint & 0xFFFFFF80) == 0) return stringFromCharCode(codePoint);
        var symbol = "";
        if ((codePoint & 0xFFFFF800) == 0) symbol = stringFromCharCode(codePoint >> 6 & 0x1F | 0xC0);
        else if ((codePoint & 0xFFFF0000) == 0) {
            checkScalarValue(codePoint);
            symbol = stringFromCharCode(codePoint >> 12 & 0x0F | 0xE0);
            symbol += createByte(codePoint, 6);
        } else if ((codePoint & 0xFFE00000) == 0) {
            symbol = stringFromCharCode(codePoint >> 18 & 0x07 | 0xF0);
            symbol += createByte(codePoint, 12);
            symbol += createByte(codePoint, 6);
        }
        symbol += stringFromCharCode(codePoint & 0x3F | 0x80);
        return symbol;
    }
    function utf8encode(string) {
        var codePoints = ucs2decode(string);
        var length = codePoints.length;
        var index = -1;
        var codePoint;
        var byteString = "";
        while(++index < length){
            codePoint = codePoints[index];
            byteString += encodeCodePoint(codePoint);
        }
        return byteString;
    }
    /*--------------------------------------------------------------------------*/ function readContinuationByte() {
        if (byteIndex >= byteCount) throw Error("Invalid byte index");
        var continuationByte = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        if ((continuationByte & 0xC0) == 0x80) return continuationByte & 0x3F;
        // If we end up here, it’s not a continuation byte
        throw Error("Invalid continuation byte");
    }
    function decodeSymbol() {
        var byte1;
        var byte2;
        var byte3;
        var byte4;
        var codePoint;
        if (byteIndex > byteCount) throw Error("Invalid byte index");
        if (byteIndex == byteCount) return false;
        // Read first byte
        byte1 = byteArray[byteIndex] & 0xFF;
        byteIndex++;
        // 1-byte sequence (no continuation bytes)
        if ((byte1 & 0x80) == 0) return byte1;
        // 2-byte sequence
        if ((byte1 & 0xE0) == 0xC0) {
            byte2 = readContinuationByte();
            codePoint = (byte1 & 0x1F) << 6 | byte2;
            if (codePoint >= 0x80) return codePoint;
            else throw Error("Invalid continuation byte");
        }
        // 3-byte sequence (may include unpaired surrogates)
        if ((byte1 & 0xF0) == 0xE0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            codePoint = (byte1 & 0x0F) << 12 | byte2 << 6 | byte3;
            if (codePoint >= 0x0800) {
                checkScalarValue(codePoint);
                return codePoint;
            } else throw Error("Invalid continuation byte");
        }
        // 4-byte sequence
        if ((byte1 & 0xF8) == 0xF0) {
            byte2 = readContinuationByte();
            byte3 = readContinuationByte();
            byte4 = readContinuationByte();
            codePoint = (byte1 & 0x07) << 0x12 | byte2 << 0x0C | byte3 << 0x06 | byte4;
            if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) return codePoint;
        }
        throw Error("Invalid UTF-8 detected");
    }
    var byteArray;
    var byteCount;
    var byteIndex;
    function utf8decode(byteString) {
        byteArray = ucs2decode(byteString);
        byteCount = byteArray.length;
        byteIndex = 0;
        var codePoints = [];
        var tmp;
        while((tmp = decodeSymbol()) !== false)codePoints.push(tmp);
        return ucs2encode(codePoints);
    }
    /*--------------------------------------------------------------------------*/ root.version = "3.0.0";
    root.encode = utf8encode;
    root.decode = utf8decode;
})(module.exports);

});

parcelRegister("kA8g9", function(module, exports) {
// This was ported from https://github.com/emn178/js-sha3, with some minor
// modifications and pruning. It is licensed under MIT:
//
// Copyright 2015-2016 Chen, Yi-Cyuan
//  
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// 
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
const $efbd9398ce8212d2$var$HEX_CHARS = "0123456789abcdef".split("");
const $efbd9398ce8212d2$var$KECCAK_PADDING = [
    1,
    256,
    65536,
    16777216
];
const $efbd9398ce8212d2$var$SHIFT = [
    0,
    8,
    16,
    24
];
const $efbd9398ce8212d2$var$RC = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
const $efbd9398ce8212d2$var$Keccak = (bits)=>({
        blocks: [],
        reset: true,
        block: 0,
        start: 0,
        blockCount: 1600 - (bits << 1) >> 5,
        outputBlocks: bits >> 5,
        s: ((s)=>[].concat(s, s, s, s, s))([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ])
    });
const $efbd9398ce8212d2$var$update = (state, message)=>{
    var length = message.length, blocks = state.blocks, byteCount = state.blockCount << 2, blockCount = state.blockCount, outputBlocks = state.outputBlocks, s = state.s, index = 0, i, code;
    // update
    while(index < length){
        if (state.reset) {
            state.reset = false;
            blocks[0] = state.block;
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        if (typeof message !== "string") for(i = state.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
        else for(i = state.start; index < length && i < byteCount; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $efbd9398ce8212d2$var$SHIFT[i++ & 3];
            }
        }
        state.lastByteIndex = i;
        if (i >= byteCount) {
            state.start = i - byteCount;
            state.block = blocks[blockCount];
            for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
            $efbd9398ce8212d2$var$f(s);
            state.reset = true;
        } else state.start = i;
    }
    // finalize
    i = state.lastByteIndex;
    blocks[i >> 2] |= $efbd9398ce8212d2$var$KECCAK_PADDING[i & 3];
    if (state.lastByteIndex === byteCount) {
        blocks[0] = blocks[blockCount];
        for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
    }
    blocks[blockCount - 1] |= 0x80000000;
    for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
    $efbd9398ce8212d2$var$f(s);
    // toString
    var hex = "", i = 0, j = 0, block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            block = s[i];
            hex += $efbd9398ce8212d2$var$HEX_CHARS[block >> 4 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 12 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 8 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 20 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 16 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 28 & 0x0F] + $efbd9398ce8212d2$var$HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            $efbd9398ce8212d2$var$f(s);
            i = 0;
        }
    }
    return "0x" + hex;
};
const $efbd9398ce8212d2$var$f = (s)=>{
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for(n = 0; n < 48; n += 2){
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= $efbd9398ce8212d2$var$RC[n];
        s[1] ^= $efbd9398ce8212d2$var$RC[n + 1];
    }
};
const $efbd9398ce8212d2$var$keccak = (bits)=>(str)=>{
        var msg;
        if (str.slice(0, 2) === "0x") {
            msg = [];
            for(var i = 2, l = str.length; i < l; i += 2)msg.push(parseInt(str.slice(i, i + 2), 16));
        } else msg = str;
        return $efbd9398ce8212d2$var$update($efbd9398ce8212d2$var$Keccak(bits, bits), msg);
    };
module.exports = {
    keccak256: $efbd9398ce8212d2$var$keccak(256),
    keccak512: $efbd9398ce8212d2$var$keccak(512),
    keccak256s: $efbd9398ce8212d2$var$keccak(256),
    keccak512s: $efbd9398ce8212d2$var$keccak(512)
};

});

parcelRegister("6jIAb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $i9l17 = parcelRequire("i9l17");
/**
 * Returns true if the bloom is a valid bloom
 * @param bloom The bloom
 */ function $49971997be6ed745$var$isBloom(bloom) {
    if (typeof bloom !== "string") return false;
    if (!/^(0x)?[0-9a-f]{512}$/i.test(bloom)) return false;
    if (/^(0x)?[0-9a-f]{512}$/.test(bloom) || /^(0x)?[0-9A-F]{512}$/.test(bloom)) return true;
    return false;
}
module.exports.isBloom = $49971997be6ed745$var$isBloom;
/**
 * Returns true if the value is part of the given bloom
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param value The value
 */ function $49971997be6ed745$var$isInBloom(bloom, value) {
    if (typeof value === "object" && value.constructor === Uint8Array) value = $i9l17.bytesToHex(value);
    const hash = $i9l17.keccak256(value).replace("0x", "");
    for(let i = 0; i < 12; i += 4){
        // calculate bit position in bloom filter that must be active
        const bitpos = (parseInt(hash.substr(i, 2), 16) << 8) + parseInt(hash.substr(i + 2, 2), 16) & 2047;
        // test if bitpos in bloom is active
        const code = $49971997be6ed745$var$codePointToInt(bloom.charCodeAt(bloom.length - 1 - Math.floor(bitpos / 4)));
        const offset = 1 << bitpos % 4;
        if ((code & offset) !== offset) return false;
    }
    return true;
}
module.exports.isInBloom = $49971997be6ed745$var$isInBloom;
/**
 * Code points to int
 * @param codePoint The code point
 */ function $49971997be6ed745$var$codePointToInt(codePoint) {
    if (codePoint >= 48 && codePoint <= 57) /* ['0'..'9'] -> [0..9] */ return codePoint - 48;
    if (codePoint >= 65 && codePoint <= 70) /* ['A'..'F'] -> [10..15] */ return codePoint - 55;
    if (codePoint >= 97 && codePoint <= 102) /* ['a'..'f'] -> [10..15] */ return codePoint - 87;
    throw new Error("invalid bloom");
}
/**
 * Returns true if the ethereum users address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param address the address to test
 */ function $49971997be6ed745$var$isUserEthereumAddressInBloom(bloom, ethereumAddress) {
    if (!$49971997be6ed745$var$isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!$49971997be6ed745$var$isAddress(ethereumAddress)) throw new Error(`Invalid ethereum address given: "${ethereumAddress}"`);
    // you have to pad the ethereum address to 32 bytes
    // else the bloom filter does not work
    // this is only if your matching the USERS
    // ethereum address. Contract address do not need this
    // hence why we have 2 methods
    // (0x is not in the 2nd parameter of padleft so 64 chars is fine)
    const address = $i9l17.padLeft(ethereumAddress, 64);
    return $49971997be6ed745$var$isInBloom(bloom, address);
}
module.exports.isUserEthereumAddressInBloom = $49971997be6ed745$var$isUserEthereumAddressInBloom;
/**
 * Returns true if the contract address is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param contractAddress the contract address to test
 */ function $49971997be6ed745$var$isContractAddressInBloom(bloom, contractAddress) {
    if (!$49971997be6ed745$var$isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!$49971997be6ed745$var$isAddress(contractAddress)) throw new Error(`Invalid contract address given: "${contractAddress}"`);
    return $49971997be6ed745$var$isInBloom(bloom, contractAddress);
}
module.exports.isContractAddressInBloom = $49971997be6ed745$var$isContractAddressInBloom;
/**
 * Returns true if the topic is part of the given bloom.
 * note: false positives are possible.
 * @param bloom encoded bloom
 * @param topic the topic encoded hex
 */ function $49971997be6ed745$var$isTopicInBloom(bloom, topic) {
    if (!$49971997be6ed745$var$isBloom(bloom)) throw new Error("Invalid bloom given");
    if (!$49971997be6ed745$var$isTopic(topic)) throw new Error("Invalid topic");
    return $49971997be6ed745$var$isInBloom(bloom, topic);
}
module.exports.isTopicInBloom = $49971997be6ed745$var$isTopicInBloom;
/**
 * Checks if its a valid topic
 * @param topic encoded hex topic
 */ function $49971997be6ed745$var$isTopic(topic) {
    if (typeof topic !== "string") return false;
    if (!/^(0x)?[0-9a-f]{64}$/i.test(topic)) return false;
    else if (/^(0x)?[0-9a-f]{64}$/.test(topic) || /^(0x)?[0-9A-F]{64}$/.test(topic)) return true;
    return false;
}
module.exports.isTopic = $49971997be6ed745$var$isTopic;
/**
 * Is valid address
 * @param address The address
 */ function $49971997be6ed745$var$isAddress(address) {
    if (typeof address !== "string") return false;
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) return true;
    if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) return true;
    return false;
}
module.exports.isAddress = $49971997be6ed745$var$isAddress;

});
parcelRegister("i9l17", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $e2O8Q = parcelRequire("e2O8Q");
/**
 * Keccak256 hash
 * @param data The data
 */ function $d3695ed010a557a8$var$keccak256(data) {
    return "0x" + $e2O8Q.keccak_256($d3695ed010a557a8$var$toByteArray(data));
}
module.exports.keccak256 = $d3695ed010a557a8$var$keccak256;
/**
 * Adding padding to string on the left
 * @param value The value
 * @param chars The chars
 */ module.exports.padLeft = (value, chars)=>{
    const hasPrefix = /^0x/i.test(value) || typeof value === "number";
    value = value.toString().replace(/^0x/i, "");
    const padding = chars - value.length + 1 >= 0 ? chars - value.length + 1 : 0;
    return (hasPrefix ? "0x" : "") + new Array(padding).join("0") + value;
};
/**
 * Convert bytes to hex
 * @param bytes The bytes
 */ function $d3695ed010a557a8$var$bytesToHex(bytes) {
    const hex = [];
    for(let i = 0; i < bytes.length; i++){
        hex.push((bytes[i] >>> 4).toString(16));
        hex.push((bytes[i] & 0xf).toString(16));
    }
    return `0x${hex.join("").replace(/^0+/, "")}`;
}
module.exports.bytesToHex = $d3695ed010a557a8$var$bytesToHex;
/**
 * To byte array
 * @param value The value
 */ function $d3695ed010a557a8$var$toByteArray(value) {
    if (value == null) throw new Error("cannot convert null value to array");
    if (typeof value === "string") {
        const match = value.match(/^(0x)?[0-9a-fA-F]*$/);
        if (!match) throw new Error("invalid hexidecimal string");
        if (match[1] !== "0x") throw new Error("hex string must have 0x prefix");
        value = value.substring(2);
        if (value.length % 2) value = "0" + value;
        const result = [];
        for(let i = 0; i < value.length; i += 2)result.push(parseInt(value.substr(i, 2), 16));
        return $d3695ed010a557a8$var$addSlice(new Uint8Array(result));
    }
    if ($d3695ed010a557a8$var$isByteArray(value)) return $d3695ed010a557a8$var$addSlice(new Uint8Array(value));
    throw new Error("invalid arrayify value");
}
module.exports.toByteArray = $d3695ed010a557a8$var$toByteArray;
/**
 * Is byte array
 * @param value The value
 */ function $d3695ed010a557a8$var$isByteArray(value) {
    if (!value || // tslint:disable-next-line: radix
    parseInt(String(value.length)) != value.length || typeof value === "string") return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        // tslint:disable-next-line: radix
        if (v < 0 || v >= 256 || parseInt(String(v)) != v) return false;
    }
    return true;
}
/**
 * Add slice to array
 * @param array The array
 */ function $d3695ed010a557a8$var$addSlice(array) {
    if (array.slice !== undefined) return array;
    array.slice = ()=>{
        const args = Array.prototype.slice.call(arguments);
        return $d3695ed010a557a8$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}

});
parcelRegister("e2O8Q", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.8.0
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2018
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var INPUT_ERROR = "input is invalid type";
    var FINALIZE_ERROR = "finalize already called";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA3_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4TNnu === "object" && $4TNnu.versions && $4TNnu.versions.node;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === "function" && define.amd;
    var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var CSHAKE_PADDING = [
        4,
        1024,
        262144,
        67108864
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array",
        "digest"
    ];
    var CSHAKE_BYTEPAD = {
        "128": 168,
        "256": 136
    };
    if (root.JS_SHA3_NO_NODE_JS || !Array.isArray) Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    if (ARRAY_BUFFER && (root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createCshakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits, n, s) {
            return methods["cshake" + bits].update(message, outputBits, n, s)[outputType]();
        };
    };
    var createKmacOutputMethod = function(bits, padding, outputType) {
        return function(key, message, outputBits, s) {
            return methods["kmac" + bits].update(key, message, outputBits, s)[outputType]();
        };
    };
    var createOutputMethods = function(method, createMethod, bits, padding) {
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createMethod(bits, padding, type);
        }
        return method;
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        return createOutputMethods(method, createOutputMethod, bits, padding);
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        return createOutputMethods(method, createShakeOutputMethod, bits, padding);
    };
    var createCshakeMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createCshakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits, n, s) {
            if (!n && !s) return methods["shake" + bits].create(outputBits);
            else return new Keccak(bits, padding, outputBits).bytepad([
                n,
                s
            ], w);
        };
        method.update = function(message, outputBits, n, s) {
            return method.create(outputBits, n, s).update(message);
        };
        return createOutputMethods(method, createCshakeOutputMethod, bits, padding);
    };
    var createKmacMethod = function(bits, padding) {
        var w = CSHAKE_BYTEPAD[bits];
        var method = createKmacOutputMethod(bits, padding, "hex");
        method.create = function(key, outputBits, s) {
            return new Kmac(bits, padding, outputBits).bytepad([
                "KMAC",
                s
            ], w).bytepad([
                key
            ], w);
        };
        method.update = function(key, message, outputBits, s) {
            return method.create(key, outputBits, s).update(message);
        };
        return createOutputMethods(method, createKmacOutputMethod, bits, padding);
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        },
        {
            name: "cshake",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createCshakeMethod
        },
        {
            name: "kmac",
            padding: CSHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createKmacMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
            if (algorithm.name !== "sha3") {
                var newMethodName = algorithm.name + bits[j];
                methodNames.push(newMethodName);
                methods[newMethodName] = methods[methodName];
            }
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.finalized = false;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var notString, type = typeof message;
        if (type !== "string") {
            if (type === "object") {
                if (message === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) message = new Uint8Array(message);
                else if (!Array.isArray(message)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var blocks = this.blocks, byteCount = this.byteCount, length = message.length, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.encode = function(x, right) {
        var o = x & 255, n = 1;
        var bytes = [
            o
        ];
        x = x >> 8;
        o = x & 255;
        while(o > 0){
            bytes.unshift(o);
            x = x >> 8;
            o = x & 255;
            ++n;
        }
        if (right) bytes.push(n);
        else bytes.unshift(n);
        this.update(bytes);
        return bytes.length;
    };
    Keccak.prototype.encodeString = function(str) {
        var notString, type = typeof str;
        if (type !== "string") {
            if (type === "object") {
                if (str === null) throw new Error(INPUT_ERROR);
                else if (ARRAY_BUFFER && str.constructor === ArrayBuffer) str = new Uint8Array(str);
                else if (!Array.isArray(str)) {
                    if (!ARRAY_BUFFER || !ArrayBuffer.isView(str)) throw new Error(INPUT_ERROR);
                }
            } else throw new Error(INPUT_ERROR);
            notString = true;
        }
        var bytes = 0, length = str.length;
        if (notString) bytes = length;
        else for(var i = 0; i < str.length; ++i){
            var code = str.charCodeAt(i);
            if (code < 0x80) bytes += 1;
            else if (code < 0x800) bytes += 2;
            else if (code < 0xd800 || code >= 0xe000) bytes += 3;
            else {
                code = 0x10000 + ((code & 0x3ff) << 10 | str.charCodeAt(++i) & 0x3ff);
                bytes += 4;
            }
        }
        bytes += this.encode(bytes * 8);
        this.update(str);
        return bytes;
    };
    Keccak.prototype.bytepad = function(strs, w) {
        var bytes = this.encode(w);
        for(var i = 0; i < strs.length; ++i)bytes += this.encodeString(strs[i]);
        var paddingBytes = w - bytes % w;
        var zeros = [];
        zeros.length = paddingBytes;
        this.update(zeros);
        return this;
    };
    Keccak.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    function Kmac(bits, padding, outputBits) {
        Keccak.call(this, bits, padding, outputBits);
    }
    Kmac.prototype = new Keccak();
    Kmac.prototype.finalize = function() {
        this.encode(this.outputBits, true);
        return Keccak.prototype.finalize.call(this);
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) module.exports = methods;
    else {
        for(i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
        if (AMD) define(function() {
            return methods;
        });
    }
})();

});




parcelRegister("cV2C1", function(module, exports) {
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file soliditySha3.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $7vYz3 = parcelRequire("7vYz3");

var $as7K2 = parcelRequire("as7K2");
var $967cd5a077be0435$var$_elementaryName = function(name) {
    /*jshint maxcomplexity:false */ if (name.startsWith("int[")) return "int256" + name.slice(3);
    else if (name === "int") return "int256";
    else if (name.startsWith("uint[")) return "uint256" + name.slice(4);
    else if (name === "uint") return "uint256";
    else if (name.startsWith("fixed[")) return "fixed128x128" + name.slice(5);
    else if (name === "fixed") return "fixed128x128";
    else if (name.startsWith("ufixed[")) return "ufixed128x128" + name.slice(6);
    else if (name === "ufixed") return "ufixed128x128";
    return name;
};
// Parse N from type<N>
var $967cd5a077be0435$var$_parseTypeN = function(type) {
    var typesize = /^\D+(\d+).*$/.exec(type);
    return typesize ? parseInt(typesize[1], 10) : null;
};
// Parse N from type[<N>]
var $967cd5a077be0435$var$_parseTypeNArray = function(type) {
    var arraySize = /^\D+\d*\[(\d+)\]$/.exec(type);
    return arraySize ? parseInt(arraySize[1], 10) : null;
};
var $967cd5a077be0435$var$_parseNumber = function(arg) {
    var type = typeof arg;
    if (type === "string") {
        if ($as7K2.isHexStrict(arg)) return new $7vYz3(arg.replace(/0x/i, ""), 16);
        else return new $7vYz3(arg, 10);
    } else if (type === "number") return new $7vYz3(arg);
    else if ($as7K2.isBigNumber(arg)) return new $7vYz3(arg.toString(10));
    else if ($as7K2.isBN(arg)) return arg;
    else throw new Error(arg + " is not a number");
};
var $967cd5a077be0435$var$_solidityPack = function(type, value, arraySize) {
    /*jshint maxcomplexity:false */ var size, num;
    type = $967cd5a077be0435$var$_elementaryName(type);
    if (type === "bytes") {
        if (value.replace(/^0x/i, "").length % 2 !== 0) throw new Error("Invalid bytes characters " + value.length);
        return value;
    } else if (type === "string") return $as7K2.utf8ToHex(value);
    else if (type === "bool") return value ? "01" : "00";
    else if (type.startsWith("address")) {
        if (arraySize) size = 64;
        else size = 40;
        if (!$as7K2.isAddress(value)) throw new Error(value + " is not a valid address, or the checksum is invalid.");
        return $as7K2.leftPad(value.toLowerCase(), size);
    }
    size = $967cd5a077be0435$var$_parseTypeN(type);
    if (type.startsWith("bytes")) {
        if (!size) throw new Error("bytes[] not yet supported in solidity");
        // must be 32 byte slices when in an array
        if (arraySize) size = 32;
        if (size < 1 || size > 32 || size < value.replace(/^0x/i, "").length / 2) throw new Error("Invalid bytes" + size + " for " + value);
        return $as7K2.rightPad(value, size * 2);
    } else if (type.startsWith("uint")) {
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid uint" + size + " size");
        num = $967cd5a077be0435$var$_parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied uint exceeds width: " + size + " vs " + num.bitLength());
        if (num.lt(new $7vYz3(0))) throw new Error("Supplied uint " + num.toString() + " is negative");
        return size ? $as7K2.leftPad(num.toString("hex"), size / 8 * 2) : num;
    } else if (type.startsWith("int")) {
        if (size % 8 || size < 8 || size > 256) throw new Error("Invalid int" + size + " size");
        num = $967cd5a077be0435$var$_parseNumber(value);
        if (num.bitLength() > size) throw new Error("Supplied int exceeds width: " + size + " vs " + num.bitLength());
        if (num.lt(new $7vYz3(0))) return num.toTwos(size).toString("hex");
        else return size ? $as7K2.leftPad(num.toString("hex"), size / 8 * 2) : num;
    } else // FIXME: support all other types
    throw new Error("Unsupported or invalid type: " + type);
};
var $967cd5a077be0435$var$_processSolidityEncodePackedArgs = function(arg) {
    /*jshint maxcomplexity:false */ if (Array.isArray(arg)) throw new Error("Autodetection of array types is not supported.");
    var type, value = "";
    var hexArg, arraySize;
    // if type is given
    if (!!arg && typeof arg === "object" && (arg.hasOwnProperty("v") || arg.hasOwnProperty("t") || arg.hasOwnProperty("value") || arg.hasOwnProperty("type"))) {
        type = arg.hasOwnProperty("t") ? arg.t : arg.type;
        value = arg.hasOwnProperty("v") ? arg.v : arg.value;
    // otherwise try to guess the type
    } else {
        type = $as7K2.toHex(arg, true);
        value = $as7K2.toHex(arg);
        if (!type.startsWith("int") && !type.startsWith("uint")) type = "bytes";
    }
    if ((type.startsWith("int") || type.startsWith("uint")) && typeof value === "string" && !/^(-)?0x/i.test(value)) value = new $7vYz3(value);
    // get the array size
    if (Array.isArray(value)) {
        arraySize = $967cd5a077be0435$var$_parseTypeNArray(type);
        if (arraySize && value.length !== arraySize) throw new Error(type + " is not matching the given array " + JSON.stringify(value));
        else arraySize = value.length;
    }
    if (Array.isArray(value)) {
        hexArg = value.map(function(val) {
            return $967cd5a077be0435$var$_solidityPack(type, val, arraySize).toString("hex").replace("0x", "");
        });
        return hexArg.join("");
    } else {
        hexArg = $967cd5a077be0435$var$_solidityPack(type, value, arraySize);
        return hexArg.toString("hex").replace("0x", "");
    }
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256
 *
 * @method soliditySha3
 * @return {Object} the sha3
 */ var $967cd5a077be0435$var$soliditySha3 = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map($967cd5a077be0435$var$_processSolidityEncodePackedArgs);
    // console.log(args, hexArgs);
    // console.log('0x'+ hexArgs.join(''));
    return $as7K2.sha3("0x" + hexArgs.join(""));
};
/**
 * Hashes solidity values to a sha3 hash using keccak 256 but does return the hash of value `null` instead of `null`
 *
 * @method soliditySha3Raw
 * @return {Object} the sha3
 */ var $967cd5a077be0435$var$soliditySha3Raw = function() {
    return $as7K2.sha3Raw("0x" + Array.prototype.slice.call(arguments).map($967cd5a077be0435$var$_processSolidityEncodePackedArgs).join(""));
};
/**
 * Encode packed args to hex
 *
 * @method encodePacked
 * @return {String} the hex encoded arguments
 */ var $967cd5a077be0435$var$encodePacked = function() {
    /*jshint maxcomplexity:false */ var args = Array.prototype.slice.call(arguments);
    var hexArgs = args.map($967cd5a077be0435$var$_processSolidityEncodePackedArgs);
    return "0x" + hexArgs.join("").toLowerCase();
};
module.exports = {
    soliditySha3: $967cd5a077be0435$var$soliditySha3,
    soliditySha3Raw: $967cd5a077be0435$var$soliditySha3Raw,
    encodePacked: $967cd5a077be0435$var$encodePacked
};

});


parcelRegister("j6ZZu", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file iban.js
 *
 * Details: https://github.com/ethereum/wiki/wiki/ICAP:-Inter-exchange-Client-Address-Protocol
 *
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2015
 */ "use strict";

var $hpg7W = parcelRequire("hpg7W");

var $7vYz3 = parcelRequire("7vYz3");
const $de9ea9ebe613af7a$var$leftPad = function(string, bytes) {
    let result = string;
    while(result.length < bytes * 2)result = "0" + result;
    return result;
};
/**
 * Prepare an IBAN for mod 97 computation by moving the first 4 chars to the end and transforming the letters to
 * numbers (A = 10, B = 11, ..., Z = 35), as specified in ISO13616.
 *
 * @method iso13616Prepare
 * @param {String} iban the IBAN
 * @returns {String} the prepared IBAN
 */ const $de9ea9ebe613af7a$var$iso13616Prepare = function(iban) {
    const A = "A".charCodeAt(0);
    const Z = "Z".charCodeAt(0);
    iban = iban.toUpperCase();
    iban = iban.substr(4) + iban.substr(0, 4);
    return iban.split("").map(function(n) {
        const code = n.charCodeAt(0);
        if (code >= A && code <= Z) // A = 10, B = 11, ... Z = 35
        return code - A + 10;
        else return n;
    }).join("");
};
/**
 * Calculates the MOD 97 10 of the passed IBAN as specified in ISO7064.
 *
 * @method mod9710
 * @param {String} iban
 * @returns {Number}
 */ const $de9ea9ebe613af7a$var$mod9710 = function(iban) {
    let remainder = iban;
    let block;
    while(remainder.length > 2){
        block = remainder.slice(0, 9);
        remainder = parseInt(block, 10) % 97 + remainder.slice(block.length);
    }
    return parseInt(remainder, 10) % 97;
};
/**
 * This prototype should be used to create iban object from iban correct string
 *
 * @param {String} iban
 */ class $de9ea9ebe613af7a$var$Iban {
    constructor(iban){
        this._iban = iban;
    }
    /**
     * This method should be used to create an ethereum address from a direct iban address
     *
     * @method toAddress
     * @param {String} iban address
     * @return {String} the ethereum address
     */ static toAddress(ib) {
        ib = new $de9ea9ebe613af7a$var$Iban(ib);
        if (!ib.isDirect()) throw new Error("IBAN is indirect and can't be converted");
        return ib.toAddress();
    }
    /**
     * This method should be used to create iban address from an ethereum address
     *
     * @method toIban
     * @param {String} address
     * @return {String} the IBAN address
     */ static toIban(address) {
        return $de9ea9ebe613af7a$var$Iban.fromAddress(address).toString();
    }
    /**
     * This method should be used to create iban object from an ethereum address
     *
     * @method fromAddress
     * @param {String} address
     * @return {Iban} the IBAN object
     */ static fromAddress(address) {
        if (!$hpg7W.isAddress(address)) throw new Error("Provided address is not a valid address: " + address);
        address = address.replace("0x", "").replace("0X", "");
        const asBn = new $7vYz3(address, 16);
        const base36 = asBn.toString(36);
        const padded = $de9ea9ebe613af7a$var$leftPad(base36, 15);
        return $de9ea9ebe613af7a$var$Iban.fromBban(padded.toUpperCase());
    }
    /**
     * Convert the passed BBAN to an IBAN for this country specification.
     * Please note that <i>"generation of the IBAN shall be the exclusive responsibility of the bank/branch servicing the account"</i>.
     * This method implements the preferred algorithm described in http://en.wikipedia.org/wiki/International_Bank_Account_Number#Generating_IBAN_check_digits
     *
     * @method fromBban
     * @param {String} bban the BBAN to convert to IBAN
     * @returns {Iban} the IBAN object
     */ static fromBban(bban) {
        const countryCode = "XE";
        const remainder = $de9ea9ebe613af7a$var$mod9710($de9ea9ebe613af7a$var$iso13616Prepare(countryCode + "00" + bban));
        const checkDigit = ("0" + (98 - remainder)).slice(-2);
        return new $de9ea9ebe613af7a$var$Iban(countryCode + checkDigit + bban);
    }
    /**
     * Should be used to create IBAN object for given institution and identifier
     *
     * @method createIndirect
     * @param {Object} options, required options are "institution" and "identifier"
     * @return {Iban} the IBAN object
     */ static createIndirect(options) {
        return $de9ea9ebe613af7a$var$Iban.fromBban("ETH" + options.institution + options.identifier);
    }
    /**
     * This method should be used to check if given string is valid iban object
     *
     * @method isValid
     * @param {String} iban string
     * @return {Boolean} true if it is valid IBAN
     */ static isValid(iban) {
        const i = new $de9ea9ebe613af7a$var$Iban(iban);
        return i.isValid();
    }
    /**
     * Should be called to check if iban is correct
     *
     * @method isValid
     * @returns {Boolean} true if it is, otherwise false
     */ isValid() {
        return /^XE[0-9]{2}(ETH[0-9A-Z]{13}|[0-9A-Z]{30,31})$/.test(this._iban) && $de9ea9ebe613af7a$var$mod9710($de9ea9ebe613af7a$var$iso13616Prepare(this._iban)) === 1;
    }
    /**
     * Should be called to check if iban number is direct
     *
     * @method isDirect
     * @returns {Boolean} true if it is, otherwise false
     */ isDirect() {
        return this._iban.length === 34 || this._iban.length === 35;
    }
    /**
     * Should be called to check if iban number if indirect
     *
     * @method isIndirect
     * @returns {Boolean} true if it is, otherwise false
     */ isIndirect() {
        return this._iban.length === 20;
    }
    /**
     * Should be called to get iban checksum
     * Uses the mod-97-10 checksumming protocol (ISO/IEC 7064:2003)
     *
     * @method checksum
     * @returns {String} checksum
     */ checksum() {
        return this._iban.substr(2, 2);
    }
    /**
     * Should be called to get institution identifier
     * eg. XREG
     *
     * @method institution
     * @returns {String} institution identifier
     */ institution() {
        return this.isIndirect() ? this._iban.substr(7, 4) : "";
    }
    /**
     * Should be called to get client identifier within institution
     * eg. GAVOFYORK
     *
     * @method client
     * @returns {String} client identifier
     */ client() {
        return this.isIndirect() ? this._iban.substr(11) : "";
    }
    /**
     * Should be called to get client direct address
     *
     * @method toAddress
     * @returns {String} ethereum address
     */ toAddress() {
        if (this.isDirect()) {
            const base36 = this._iban.substr(4);
            const asBn = new $7vYz3(base36, 36);
            return $hpg7W.toChecksumAddress(asBn.toString(16, 20));
        }
        return "";
    }
    toString() {
        return this._iban;
    }
}
module.exports = $de9ea9ebe613af7a$var$Iban;

});



parcelRegister("bAl6e", function(module, exports) {
var $86f36c67720196a7$var$_globalThis;

if (typeof globalThis === "object") $86f36c67720196a7$var$_globalThis = globalThis;
else try {
    $86f36c67720196a7$var$_globalThis = (parcelRequire("ctmns"));
} catch (error) {} finally{
    if (!$86f36c67720196a7$var$_globalThis && typeof window !== "undefined") $86f36c67720196a7$var$_globalThis = window;
    if (!$86f36c67720196a7$var$_globalThis) throw new Error("Could not determine global this");
}
var $86f36c67720196a7$var$NativeWebSocket = $86f36c67720196a7$var$_globalThis.WebSocket || $86f36c67720196a7$var$_globalThis.MozWebSocket;

var $kFVfN = parcelRequire("kFVfN");
/**
 * Expose a W3C WebSocket class with just one or two arguments.
 */ function $86f36c67720196a7$var$W3CWebSocket(uri, protocols) {
    var native_instance;
    if (protocols) native_instance = new $86f36c67720196a7$var$NativeWebSocket(uri, protocols);
    else native_instance = new $86f36c67720196a7$var$NativeWebSocket(uri);
    /**
	 * 'native_instance' is an instance of nativeWebSocket (the browser's WebSocket
	 * class). Since it is an Object it will be returned as it is when creating an
	 * instance of W3CWebSocket via 'new W3CWebSocket()'.
	 *
	 * ECMAScript 5: http://bclary.com/2004/11/07/#a-13.2.2
	 */ return native_instance;
}
if ($86f36c67720196a7$var$NativeWebSocket) [
    "CONNECTING",
    "OPEN",
    "CLOSING",
    "CLOSED"
].forEach(function(prop) {
    Object.defineProperty($86f36c67720196a7$var$W3CWebSocket, prop, {
        get: function() {
            return $86f36c67720196a7$var$NativeWebSocket[prop];
        }
    });
});
/**
 * Module exports.
 */ module.exports = {
    "w3cwebsocket": $86f36c67720196a7$var$NativeWebSocket ? $86f36c67720196a7$var$W3CWebSocket : null,
    "version": $kFVfN
};

});
parcelRegister("ctmns", function(module, exports) {
var $91498d1f4c3baf47$var$naiveFallback = function() {
    if (typeof self === "object" && self) return self;
    if (typeof window === "object" && window) return window;
    throw new Error("Unable to resolve global `this`");
};
module.exports = function() {
    if (this) return this;
    // Unexpected strict mode (may happen if e.g. bundled into ESM module)
    // Fallback to standard globalThis if available
    if (typeof globalThis === "object" && globalThis) return globalThis;
    // Thanks @mathiasbynens -> https://mathiasbynens.be/notes/globalthis
    // In all ES5+ engines global object inherits from Object.prototype
    // (if you approached one that doesn't please report)
    try {
        Object.defineProperty(Object.prototype, "__global__", {
            get: function() {
                return this;
            },
            configurable: true
        });
    } catch (error) {
        // Unfortunate case of updates to Object.prototype being restricted
        // via preventExtensions, seal or freeze
        return $91498d1f4c3baf47$var$naiveFallback();
    }
    try {
        // Safari case (window.__global__ works, but __global__ does not)
        if (!__global__) return $91498d1f4c3baf47$var$naiveFallback();
        return __global__;
    } finally{
        delete Object.prototype.__global__;
    }
}();

});

parcelRegister("kFVfN", function(module, exports) {

module.exports = (parcelRequire("8OKYx")).version;

});
parcelRegister("8OKYx", function(module, exports) {
module.exports = JSON.parse('{"name":"websocket","description":"Websocket Client & Server Library implementing the WebSocket protocol as specified in RFC 6455.","keywords":["websocket","websockets","socket","networking","comet","push","RFC-6455","realtime","server","client"],"author":"Brian McKelvey <theturtle32@gmail.com> (https://github.com/theturtle32)","contributors":["I\xf1aki Baz Castillo <ibc@aliax.net> (http://dev.sipdoc.net)"],"version":"1.0.34","repository":{"type":"git","url":"https://github.com/theturtle32/WebSocket-Node.git"},"homepage":"https://github.com/theturtle32/WebSocket-Node","engines":{"node":">=4.0.0"},"dependencies":{"bufferutil":"^4.0.1","debug":"^2.2.0","es5-ext":"^0.10.50","typedarray-to-buffer":"^3.1.5","utf-8-validate":"^5.0.2","yaeti":"^0.0.6"},"devDependencies":{"buffer-equal":"^1.0.0","gulp":"^4.0.2","gulp-jshint":"^2.0.4","jshint-stylish":"^2.2.1","jshint":"^2.0.0","tape":"^4.9.1"},"config":{"verbose":false},"scripts":{"test":"tape test/unit/*.js","gulp":"gulp"},"main":"index","directories":{"lib":"./lib"},"browser":"lib/browser.js","license":"Apache-2.0"}');

});




parcelRegister("9DK0x", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file httpprovider.js
 * @authors:
 *   Marek Kotewicz <marek@parity.io>
 *   Marian Oancea
 *   Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2015
 */ 
var $heyrh = parcelRequire("heyrh");
var $704b71bf0e4735ff$require$errors = $heyrh.errors;

var $ll0CD = parcelRequire("ll0CD");
var $704b71bf0e4735ff$require$XHR2 = $ll0CD.XMLHttpRequest;

var $3JpYu = parcelRequire("3JpYu");

var $hrxEy = parcelRequire("hrxEy");
/**
 * HttpProvider should be used to send rpc calls over http
 */ var $704b71bf0e4735ff$var$HttpProvider = function HttpProvider(host, options) {
    options = options || {};
    this.withCredentials = options.withCredentials || false;
    this.timeout = options.timeout || 0;
    this.headers = options.headers;
    this.agent = options.agent;
    this.connected = false;
    // keepAlive is true unless explicitly set to false
    const keepAlive = options.keepAlive !== false;
    this.host = host || "http://localhost:8545";
    if (!this.agent) {
        if (this.host.substring(0, 5) === "https") this.httpsAgent = new $hrxEy.Agent({
            keepAlive: keepAlive
        });
        else this.httpAgent = new $3JpYu.Agent({
            keepAlive: keepAlive
        });
    }
};
$704b71bf0e4735ff$var$HttpProvider.prototype._prepareRequest = function() {
    var request;
    // the current runtime is a browser
    if (typeof XMLHttpRequest !== "undefined") request = new XMLHttpRequest();
    else {
        request = new $704b71bf0e4735ff$require$XHR2();
        var agents = {
            httpsAgent: this.httpsAgent,
            httpAgent: this.httpAgent,
            baseUrl: this.baseUrl
        };
        if (this.agent) {
            agents.httpsAgent = this.agent.https;
            agents.httpAgent = this.agent.http;
            agents.baseUrl = this.agent.baseUrl;
        }
        request.nodejsSet(agents);
    }
    request.open("POST", this.host, true);
    request.setRequestHeader("Content-Type", "application/json");
    request.timeout = this.timeout;
    request.withCredentials = this.withCredentials;
    if (this.headers) this.headers.forEach(function(header) {
        request.setRequestHeader(header.name, header.value);
    });
    return request;
};
/**
 * Should be used to make async request
 *
 * @method send
 * @param {Object} payload
 * @param {Function} callback triggered on end with (err, result)
 */ $704b71bf0e4735ff$var$HttpProvider.prototype.send = function(payload, callback) {
    var _this = this;
    var request = this._prepareRequest();
    request.onreadystatechange = function() {
        if (request.readyState === 4 && request.timeout !== 1) {
            var result = request.responseText;
            var error = null;
            try {
                result = JSON.parse(result);
            } catch (e) {
                error = $704b71bf0e4735ff$require$errors.InvalidResponse(request.responseText);
            }
            _this.connected = true;
            callback(error, result);
        }
    };
    request.ontimeout = function() {
        _this.connected = false;
        callback($704b71bf0e4735ff$require$errors.ConnectionTimeout(this.timeout));
    };
    try {
        request.send(JSON.stringify(payload));
    } catch (error) {
        this.connected = false;
        callback($704b71bf0e4735ff$require$errors.InvalidConnection(this.host));
    }
};
$704b71bf0e4735ff$var$HttpProvider.prototype.disconnect = function() {
//NO OP
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 * @returns {boolean}
 */ $704b71bf0e4735ff$var$HttpProvider.prototype.supportsSubscriptions = function() {
    return false;
};
module.exports = $704b71bf0e4735ff$var$HttpProvider;

});
parcelRegister("ll0CD", function(module, exports) {
"use strict";
function $f88c0aae61c1eaf3$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$f88c0aae61c1eaf3$var$__export((parcelRequire("aWYzW")));

var $3eo3J = parcelRequire("3eo3J");
module.exports.XMLHttpRequestEventTarget = $3eo3J.XMLHttpRequestEventTarget;

});
parcelRegister("aWYzW", function(module, exports) {

var $4TNnu = parcelRequire("4TNnu");

var $ihoyg = parcelRequire("ihoyg");
var $7f8e4fd8b0dd393d$require$Buffer = $ihoyg.Buffer;
"use strict";
var $7f8e4fd8b0dd393d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $7f8e4fd8b0dd393d$var$__assign = module.exports && module.exports.__assign || Object.assign || function(t) {
    for(var s, i = 1, n = arguments.length; i < n; i++){
        s = arguments[i];
        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3JpYu = parcelRequire("3JpYu");

var $hrxEy = parcelRequire("hrxEy");

var $9GD6K = parcelRequire("9GD6K");

var $hH01d = parcelRequire("hH01d");

var $dqb2k = parcelRequire("dqb2k");

var $70dIz = parcelRequire("70dIz");

var $3eo3J = parcelRequire("3eo3J");

var $hEzNs = parcelRequire("hEzNs");

var $6vZiM = parcelRequire("6vZiM");
var $7f8e4fd8b0dd393d$var$XMLHttpRequest = /** @class */ function(_super) {
    $7f8e4fd8b0dd393d$var$__extends(XMLHttpRequest, _super);
    function XMLHttpRequest(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this) || this;
        _this.UNSENT = XMLHttpRequest.UNSENT;
        _this.OPENED = XMLHttpRequest.OPENED;
        _this.HEADERS_RECEIVED = XMLHttpRequest.HEADERS_RECEIVED;
        _this.LOADING = XMLHttpRequest.LOADING;
        _this.DONE = XMLHttpRequest.DONE;
        _this.onreadystatechange = null;
        _this.readyState = XMLHttpRequest.UNSENT;
        _this.response = null;
        _this.responseText = "";
        _this.responseType = "";
        _this.status = 0; // TODO: UNSENT?
        _this.statusText = "";
        _this.timeout = 0;
        _this.upload = new $hEzNs.XMLHttpRequestUpload();
        _this.responseUrl = "";
        _this.withCredentials = false;
        _this._method = null;
        _this._url = null;
        _this._sync = false;
        _this._headers = {};
        _this._loweredHeaders = {};
        _this._mimeOverride = null; // TODO: is type right?
        _this._request = null;
        _this._response = null;
        _this._responseParts = null;
        _this._responseHeaders = null;
        _this._aborting = null; // TODO: type?
        _this._error = null; // TODO: type?
        _this._loadedBytes = 0;
        _this._totalBytes = 0;
        _this._lengthComputable = false;
        _this._restrictedMethods = {
            CONNECT: true,
            TRACE: true,
            TRACK: true
        };
        _this._restrictedHeaders = {
            "accept-charset": true,
            "accept-encoding": true,
            "access-control-request-headers": true,
            "access-control-request-method": true,
            connection: true,
            "content-length": true,
            cookie: true,
            cookie2: true,
            date: true,
            dnt: true,
            expect: true,
            host: true,
            "keep-alive": true,
            origin: true,
            referer: true,
            te: true,
            trailer: true,
            "transfer-encoding": true,
            upgrade: true,
            "user-agent": true,
            via: true
        };
        _this._privateHeaders = {
            "set-cookie": true,
            "set-cookie2": true
        };
        _this._userAgent = "Mozilla/5.0 (" + $9GD6K.type() + " " + $9GD6K.arch() + ") node.js/" + $4TNnu.versions.node + " v8/" + $4TNnu.versions.v8;
        _this._anonymous = options.anon || false;
        return _this;
    }
    XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
        if (async === void 0) async = true;
        method = method.toUpperCase();
        if (this._restrictedMethods[method]) throw new XMLHttpRequest.SecurityError("HTTP method " + method + " is not allowed in XHR");
        var xhrUrl = this._parseUrl(url, user, password);
        this.readyState === XMLHttpRequest.HEADERS_RECEIVED || (this.readyState, XMLHttpRequest.LOADING);
        this._method = method;
        this._url = xhrUrl;
        this._sync = !async;
        this._headers = {};
        this._loweredHeaders = {};
        this._mimeOverride = null;
        this._setReadyState(XMLHttpRequest.OPENED);
        this._request = null;
        this._response = null;
        this.status = 0;
        this.statusText = "";
        this._responseParts = [];
        this._responseHeaders = null;
        this._loadedBytes = 0;
        this._totalBytes = 0;
        this._lengthComputable = false;
    };
    XMLHttpRequest.prototype.setRequestHeader = function(name, value) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError("XHR readyState must be OPENED");
        var loweredName = name.toLowerCase();
        if (this._restrictedHeaders[loweredName] || /^sec-/.test(loweredName) || /^proxy-/.test(loweredName)) {
            console.warn('Refused to set unsafe header "' + name + '"');
            return;
        }
        value = value.toString();
        if (this._loweredHeaders[loweredName] != null) {
            name = this._loweredHeaders[loweredName];
            this._headers[name] = this._headers[name] + ", " + value;
        } else {
            this._loweredHeaders[loweredName] = name;
            this._headers[name] = value;
        }
    };
    XMLHttpRequest.prototype.send = function(data) {
        if (this.readyState !== XMLHttpRequest.OPENED) throw new XMLHttpRequest.InvalidStateError("XHR readyState must be OPENED");
        if (this._request) throw new XMLHttpRequest.InvalidStateError("send() already called");
        switch(this._url.protocol){
            case "file:":
                return this._sendFile(data);
            case "http:":
            case "https:":
                return this._sendHttp(data);
            default:
                throw new XMLHttpRequest.NetworkError("Unsupported protocol " + this._url.protocol);
        }
    };
    XMLHttpRequest.prototype.abort = function() {
        if (this._request == null) return;
        this._request.abort();
        this._setError();
        this._dispatchProgress("abort");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype.getResponseHeader = function(name) {
        if (this._responseHeaders == null || name == null) return null;
        var loweredName = name.toLowerCase();
        return this._responseHeaders.hasOwnProperty(loweredName) ? this._responseHeaders[name.toLowerCase()] : null;
    };
    XMLHttpRequest.prototype.getAllResponseHeaders = function() {
        var _this = this;
        if (this._responseHeaders == null) return "";
        return Object.keys(this._responseHeaders).map(function(key) {
            return key + ": " + _this._responseHeaders[key];
        }).join("\r\n");
    };
    XMLHttpRequest.prototype.overrideMimeType = function(mimeType) {
        if (this.readyState === XMLHttpRequest.LOADING || this.readyState === XMLHttpRequest.DONE) throw new XMLHttpRequest.InvalidStateError("overrideMimeType() not allowed in LOADING or DONE");
        this._mimeOverride = mimeType.toLowerCase();
    };
    XMLHttpRequest.prototype.nodejsSet = function(options) {
        this.nodejsHttpAgent = options.httpAgent || this.nodejsHttpAgent;
        this.nodejsHttpsAgent = options.httpsAgent || this.nodejsHttpsAgent;
        if (options.hasOwnProperty("baseUrl")) {
            if (options.baseUrl != null) {
                var parsedUrl = $hH01d.parse(options.baseUrl, false, true);
                if (!parsedUrl.protocol) throw new XMLHttpRequest.SyntaxError("baseUrl must be an absolute URL");
            }
            this.nodejsBaseUrl = options.baseUrl;
        }
    };
    XMLHttpRequest.nodejsSet = function(options) {
        XMLHttpRequest.prototype.nodejsSet(options);
    };
    XMLHttpRequest.prototype._setReadyState = function(readyState) {
        this.readyState = readyState;
        this.dispatchEvent(new $dqb2k.ProgressEvent("readystatechange"));
    };
    XMLHttpRequest.prototype._sendFile = function(data) {
        // TODO
        throw new Error("Protocol file: not implemented");
    };
    XMLHttpRequest.prototype._sendHttp = function(data) {
        if (this._sync) throw new Error("Synchronous XHR processing not implemented");
        if (data && (this._method === "GET" || this._method === "HEAD")) {
            console.warn("Discarding entity body for " + this._method + " requests");
            data = null;
        } else data = data || "";
        this.upload._setData(data);
        this._finalizeHeaders();
        this._sendHxxpRequest();
    };
    XMLHttpRequest.prototype._sendHxxpRequest = function() {
        var _this = this;
        if (this.withCredentials) {
            var cookie = XMLHttpRequest.cookieJar.getCookies($6vZiM.CookieAccessInfo(this._url.hostname, this._url.pathname, this._url.protocol === "https:")).toValueString();
            this._headers.cookie = this._headers.cookie2 = cookie;
        }
        var _a = this._url.protocol === "http:" ? [
            $3JpYu,
            this.nodejsHttpAgent
        ] : [
            $hrxEy,
            this.nodejsHttpsAgent
        ], hxxp = _a[0], agent = _a[1];
        var requestMethod = hxxp.request.bind(hxxp);
        var request = requestMethod({
            hostname: this._url.hostname,
            port: +this._url.port,
            path: this._url.path,
            auth: this._url.auth,
            method: this._method,
            headers: this._headers,
            agent: agent
        });
        this._request = request;
        if (this.timeout) request.setTimeout(this.timeout, function() {
            return _this._onHttpTimeout(request);
        });
        request.on("response", function(response) {
            return _this._onHttpResponse(request, response);
        });
        request.on("error", function(error) {
            return _this._onHttpRequestError(request, error);
        });
        this.upload._startUpload(request);
        if (this._request === request) this._dispatchProgress("loadstart");
    };
    XMLHttpRequest.prototype._finalizeHeaders = function() {
        this._headers = $7f8e4fd8b0dd393d$var$__assign({}, this._headers, {
            Connection: "keep-alive",
            Host: this._url.host,
            "User-Agent": this._userAgent
        }, this._anonymous ? {
            Referer: "about:blank"
        } : {});
        this.upload._finalizeHeaders(this._headers, this._loweredHeaders);
    };
    XMLHttpRequest.prototype._onHttpResponse = function(request, response) {
        var _this = this;
        if (this._request !== request) return;
        if (this.withCredentials && (response.headers["set-cookie"] || response.headers["set-cookie2"])) XMLHttpRequest.cookieJar.setCookies(response.headers["set-cookie"] || response.headers["set-cookie2"]);
        if ([
            301,
            302,
            303,
            307,
            308
        ].indexOf(response.statusCode) >= 0) {
            this._url = this._parseUrl(response.headers.location);
            this._method = "GET";
            if (this._loweredHeaders["content-type"]) {
                delete this._headers[this._loweredHeaders["content-type"]];
                delete this._loweredHeaders["content-type"];
            }
            if (this._headers["Content-Type"] != null) delete this._headers["Content-Type"];
            delete this._headers["Content-Length"];
            this.upload._reset();
            this._finalizeHeaders();
            this._sendHxxpRequest();
            return;
        }
        this._response = response;
        this._response.on("data", function(data) {
            return _this._onHttpResponseData(response, data);
        });
        this._response.on("end", function() {
            return _this._onHttpResponseEnd(response);
        });
        this._response.on("close", function() {
            return _this._onHttpResponseClose(response);
        });
        this.responseUrl = this._url.href.split("#")[0];
        this.status = response.statusCode;
        this.statusText = $3JpYu.STATUS_CODES[this.status];
        this._parseResponseHeaders(response);
        var lengthString = this._responseHeaders["content-length"] || "";
        this._totalBytes = +lengthString;
        this._lengthComputable = !!lengthString;
        this._setReadyState(XMLHttpRequest.HEADERS_RECEIVED);
    };
    XMLHttpRequest.prototype._onHttpResponseData = function(response, data) {
        if (this._response !== response) return;
        this._responseParts.push(new $7f8e4fd8b0dd393d$require$Buffer(data));
        this._loadedBytes += data.length;
        if (this.readyState !== XMLHttpRequest.LOADING) this._setReadyState(XMLHttpRequest.LOADING);
        this._dispatchProgress("progress");
    };
    XMLHttpRequest.prototype._onHttpResponseEnd = function(response) {
        if (this._response !== response) return;
        this._parseResponse();
        this._request = null;
        this._response = null;
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("load");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpResponseClose = function(response) {
        if (this._response !== response) return;
        var request = this._request;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("error");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpTimeout = function(request) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("timeout");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._onHttpRequestError = function(request, error) {
        if (this._request !== request) return;
        this._setError();
        request.abort();
        this._setReadyState(XMLHttpRequest.DONE);
        this._dispatchProgress("error");
        this._dispatchProgress("loadend");
    };
    XMLHttpRequest.prototype._dispatchProgress = function(eventType) {
        var event = new XMLHttpRequest.ProgressEvent(eventType);
        event.lengthComputable = this._lengthComputable;
        event.loaded = this._loadedBytes;
        event.total = this._totalBytes;
        this.dispatchEvent(event);
    };
    XMLHttpRequest.prototype._setError = function() {
        this._request = null;
        this._response = null;
        this._responseHeaders = null;
        this._responseParts = null;
    };
    XMLHttpRequest.prototype._parseUrl = function(urlString, user, password) {
        var absoluteUrl = this.nodejsBaseUrl == null ? urlString : $hH01d.resolve(this.nodejsBaseUrl, urlString);
        var xhrUrl = $hH01d.parse(absoluteUrl, false, true);
        xhrUrl.hash = null;
        var _a = (xhrUrl.auth || "").split(":"), xhrUser = _a[0], xhrPassword = _a[1];
        if (xhrUser || xhrPassword || user || password) xhrUrl.auth = (user || xhrUser || "") + ":" + (password || xhrPassword || "");
        return xhrUrl;
    };
    XMLHttpRequest.prototype._parseResponseHeaders = function(response) {
        this._responseHeaders = {};
        for(var name_1 in response.headers){
            var loweredName = name_1.toLowerCase();
            if (this._privateHeaders[loweredName]) continue;
            this._responseHeaders[loweredName] = response.headers[name_1];
        }
        if (this._mimeOverride != null) this._responseHeaders["content-type"] = this._mimeOverride;
    };
    XMLHttpRequest.prototype._parseResponse = function() {
        var buffer = $7f8e4fd8b0dd393d$require$Buffer.concat(this._responseParts);
        this._responseParts = null;
        switch(this.responseType){
            case "json":
                this.responseText = null;
                try {
                    this.response = JSON.parse(buffer.toString("utf-8"));
                } catch (_a) {
                    this.response = null;
                }
                return;
            case "buffer":
                this.responseText = null;
                this.response = buffer;
                return;
            case "arraybuffer":
                this.responseText = null;
                var arrayBuffer = new ArrayBuffer(buffer.length);
                var view = new Uint8Array(arrayBuffer);
                for(var i = 0; i < buffer.length; i++)view[i] = buffer[i];
                this.response = arrayBuffer;
                return;
            case "text":
            default:
                try {
                    this.responseText = buffer.toString(this._parseResponseEncoding());
                } catch (_b) {
                    this.responseText = buffer.toString("binary");
                }
                this.response = this.responseText;
        }
    };
    XMLHttpRequest.prototype._parseResponseEncoding = function() {
        return /;\s*charset=(.*)$/.exec(this._responseHeaders["content-type"] || "")[1] || "utf-8";
    };
    XMLHttpRequest.ProgressEvent = $dqb2k.ProgressEvent;
    XMLHttpRequest.InvalidStateError = $70dIz.InvalidStateError;
    XMLHttpRequest.NetworkError = $70dIz.NetworkError;
    XMLHttpRequest.SecurityError = $70dIz.SecurityError;
    XMLHttpRequest.SyntaxError = $70dIz.SyntaxError;
    XMLHttpRequest.XMLHttpRequestUpload = $hEzNs.XMLHttpRequestUpload;
    XMLHttpRequest.UNSENT = 0;
    XMLHttpRequest.OPENED = 1;
    XMLHttpRequest.HEADERS_RECEIVED = 2;
    XMLHttpRequest.LOADING = 3;
    XMLHttpRequest.DONE = 4;
    XMLHttpRequest.cookieJar = $6vZiM.CookieJar();
    return XMLHttpRequest;
}($3eo3J.XMLHttpRequestEventTarget);
module.exports.XMLHttpRequest = $7f8e4fd8b0dd393d$var$XMLHttpRequest;
$7f8e4fd8b0dd393d$var$XMLHttpRequest.prototype.nodejsHttpAgent = $3JpYu.globalAgent;
$7f8e4fd8b0dd393d$var$XMLHttpRequest.prototype.nodejsHttpsAgent = $hrxEy.globalAgent;
$7f8e4fd8b0dd393d$var$XMLHttpRequest.prototype.nodejsBaseUrl = null;

});
parcelRegister("dqb2k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9c5643b3538350ac$var$ProgressEvent = /** @class */ function() {
    function ProgressEvent(type) {
        this.type = type;
        this.bubbles = false;
        this.cancelable = false;
        this.loaded = 0;
        this.lengthComputable = false;
        this.total = 0;
    }
    return ProgressEvent;
}();
module.exports.ProgressEvent = $9c5643b3538350ac$var$ProgressEvent;

});

parcelRegister("70dIz", function(module, exports) {
"use strict";
var $51932c98aeffb87e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $51932c98aeffb87e$var$SecurityError = /** @class */ function(_super) {
    $51932c98aeffb87e$var$__extends(SecurityError, _super);
    function SecurityError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SecurityError;
}(Error);
module.exports.SecurityError = $51932c98aeffb87e$var$SecurityError;
var $51932c98aeffb87e$var$InvalidStateError = /** @class */ function(_super) {
    $51932c98aeffb87e$var$__extends(InvalidStateError, _super);
    function InvalidStateError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return InvalidStateError;
}(Error);
module.exports.InvalidStateError = $51932c98aeffb87e$var$InvalidStateError;
var $51932c98aeffb87e$var$NetworkError = /** @class */ function(_super) {
    $51932c98aeffb87e$var$__extends(NetworkError, _super);
    function NetworkError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NetworkError;
}(Error);
module.exports.NetworkError = $51932c98aeffb87e$var$NetworkError;
var $51932c98aeffb87e$var$SyntaxError = /** @class */ function(_super) {
    $51932c98aeffb87e$var$__extends(SyntaxError, _super);
    function SyntaxError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return SyntaxError;
}(Error);
module.exports.SyntaxError = $51932c98aeffb87e$var$SyntaxError;

});

parcelRegister("3eo3J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $25a5578efe577008$var$XMLHttpRequestEventTarget = /** @class */ function() {
    function XMLHttpRequestEventTarget() {
        this.listeners = {};
    }
    XMLHttpRequestEventTarget.prototype.addEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        this.listeners[eventType] = this.listeners[eventType] || [];
        this.listeners[eventType].push(listener.handleEvent || listener);
    };
    XMLHttpRequestEventTarget.prototype.removeEventListener = function(eventType, listener) {
        eventType = eventType.toLowerCase();
        if (!this.listeners[eventType]) return;
        var index = this.listeners[eventType].indexOf(listener.handleEvent || listener);
        if (index < 0) return;
        this.listeners[eventType].splice(index, 1);
    };
    XMLHttpRequestEventTarget.prototype.dispatchEvent = function(event) {
        var eventType = event.type.toLowerCase();
        event.target = this; // TODO: set event.currentTarget?
        if (this.listeners[eventType]) for(var _i = 0, _a = this.listeners[eventType]; _i < _a.length; _i++){
            var listener_1 = _a[_i];
            listener_1.call(this, event);
        }
        var listener = this["on" + eventType];
        if (listener) listener.call(this, event);
        return true;
    };
    return XMLHttpRequestEventTarget;
}();
module.exports.XMLHttpRequestEventTarget = $25a5578efe577008$var$XMLHttpRequestEventTarget;

});

parcelRegister("hEzNs", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $cda1f08d2f4ac900$require$Buffer = $ihoyg.Buffer;
"use strict";
var $cda1f08d2f4ac900$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3eo3J = parcelRequire("3eo3J");
var $cda1f08d2f4ac900$var$XMLHttpRequestUpload = /** @class */ function(_super) {
    $cda1f08d2f4ac900$var$__extends(XMLHttpRequestUpload, _super);
    function XMLHttpRequestUpload() {
        var _this = _super.call(this) || this;
        _this._contentType = null;
        _this._body = null;
        _this._reset();
        return _this;
    }
    XMLHttpRequestUpload.prototype._reset = function() {
        this._contentType = null;
        this._body = null;
    };
    XMLHttpRequestUpload.prototype._setData = function(data) {
        if (data == null) return;
        if (typeof data === "string") {
            if (data.length !== 0) this._contentType = "text/plain;charset=UTF-8";
            this._body = new $cda1f08d2f4ac900$require$Buffer(data, "utf-8");
        } else if ($cda1f08d2f4ac900$require$Buffer.isBuffer(data)) this._body = data;
        else if (data instanceof ArrayBuffer) {
            var body = new $cda1f08d2f4ac900$require$Buffer(data.byteLength);
            var view = new Uint8Array(data);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i];
            this._body = body;
        } else if (data.buffer && data.buffer instanceof ArrayBuffer) {
            var body = new $cda1f08d2f4ac900$require$Buffer(data.byteLength);
            var offset = data.byteOffset;
            var view = new Uint8Array(data.buffer);
            for(var i = 0; i < data.byteLength; i++)body[i] = view[i + offset];
            this._body = body;
        } else throw new Error("Unsupported send() data " + data);
    };
    XMLHttpRequestUpload.prototype._finalizeHeaders = function(headers, loweredHeaders) {
        if (this._contentType && !loweredHeaders["content-type"]) headers["Content-Type"] = this._contentType;
        if (this._body) headers["Content-Length"] = this._body.length.toString();
    };
    XMLHttpRequestUpload.prototype._startUpload = function(request) {
        if (this._body) request.write(this._body);
        request.end();
    };
    return XMLHttpRequestUpload;
}($3eo3J.XMLHttpRequestEventTarget);
module.exports.XMLHttpRequestUpload = $cda1f08d2f4ac900$var$XMLHttpRequestUpload;

});

parcelRegister("6vZiM", function(module, exports) {

$parcel$export(module.exports, "CookieAccessInfo", function () { return $4be5309b079bebfc$export$f88fc6dda7ae65f0; }, function (v) { return $4be5309b079bebfc$export$f88fc6dda7ae65f0 = v; });
$parcel$export(module.exports, "CookieJar", function () { return $4be5309b079bebfc$export$991f683f69795c48; }, function (v) { return $4be5309b079bebfc$export$991f683f69795c48 = v; });
var $4be5309b079bebfc$export$f88fc6dda7ae65f0;
var $4be5309b079bebfc$export$bd0cf18531183c14;
var $4be5309b079bebfc$export$991f683f69795c48;
/* jshint node: true */ (function() {
    "use strict";
    function CookieAccessInfo(domain, path, secure, script) {
        if (this instanceof CookieAccessInfo) {
            this.domain = domain || undefined;
            this.path = path || "/";
            this.secure = !!secure;
            this.script = !!script;
            return this;
        }
        return new CookieAccessInfo(domain, path, secure, script);
    }
    CookieAccessInfo.All = Object.freeze(Object.create(null));
    $4be5309b079bebfc$export$f88fc6dda7ae65f0 = CookieAccessInfo;
    function Cookie(cookiestr, request_domain, request_path) {
        if (cookiestr instanceof Cookie) return cookiestr;
        if (this instanceof Cookie) {
            this.name = null;
            this.value = null;
            this.expiration_date = Infinity;
            this.path = String(request_path || "/");
            this.explicit_path = false;
            this.domain = request_domain || null;
            this.explicit_domain = false;
            this.secure = false; //how to define default?
            this.noscript = false; //httponly
            if (cookiestr) this.parse(cookiestr, request_domain, request_path);
            return this;
        }
        return new Cookie(cookiestr, request_domain, request_path);
    }
    $4be5309b079bebfc$export$bd0cf18531183c14 = Cookie;
    Cookie.prototype.toString = function toString() {
        var str = [
            this.name + "=" + this.value
        ];
        if (this.expiration_date !== Infinity) str.push("expires=" + new Date(this.expiration_date).toGMTString());
        if (this.domain) str.push("domain=" + this.domain);
        if (this.path) str.push("path=" + this.path);
        if (this.secure) str.push("secure");
        if (this.noscript) str.push("httponly");
        return str.join("; ");
    };
    Cookie.prototype.toValueString = function toValueString() {
        return this.name + "=" + this.value;
    };
    var cookie_str_splitter = /[:](?=\s*[a-zA-Z0-9_\-]+\s*[=])/g;
    Cookie.prototype.parse = function parse(str, request_domain, request_path) {
        if (this instanceof Cookie) {
            var parts = str.split(";").filter(function(value) {
                return !!value;
            });
            var i;
            var pair = parts[0].match(/([^=]+)=([\s\S]*)/);
            if (!pair) {
                console.warn("Invalid cookie header encountered. Header: '" + str + "'");
                return;
            }
            var key = pair[1];
            var value = pair[2];
            if (typeof key !== "string" || key.length === 0 || typeof value !== "string") {
                console.warn("Unable to extract values from cookie header. Cookie: '" + str + "'");
                return;
            }
            this.name = key;
            this.value = value;
            for(i = 1; i < parts.length; i += 1){
                pair = parts[i].match(/([^=]+)(?:=([\s\S]*))?/);
                key = pair[1].trim().toLowerCase();
                value = pair[2];
                switch(key){
                    case "httponly":
                        this.noscript = true;
                        break;
                    case "expires":
                        this.expiration_date = value ? Number(Date.parse(value)) : Infinity;
                        break;
                    case "path":
                        this.path = value ? value.trim() : "";
                        this.explicit_path = true;
                        break;
                    case "domain":
                        this.domain = value ? value.trim() : "";
                        this.explicit_domain = !!this.domain;
                        break;
                    case "secure":
                        this.secure = true;
                        break;
                }
            }
            if (!this.explicit_path) this.path = request_path || "/";
            if (!this.explicit_domain) this.domain = request_domain;
            return this;
        }
        return new Cookie().parse(str, request_domain, request_path);
    };
    Cookie.prototype.matches = function matches(access_info) {
        if (access_info === CookieAccessInfo.All) return true;
        if (this.noscript && access_info.script || this.secure && !access_info.secure || !this.collidesWith(access_info)) return false;
        return true;
    };
    Cookie.prototype.collidesWith = function collidesWith(access_info) {
        if (this.path && !access_info.path || this.domain && !access_info.domain) return false;
        if (this.path && access_info.path.indexOf(this.path) !== 0) return false;
        if (this.explicit_path && access_info.path.indexOf(this.path) !== 0) return false;
        var access_domain = access_info.domain && access_info.domain.replace(/^[\.]/, "");
        var cookie_domain = this.domain && this.domain.replace(/^[\.]/, "");
        if (cookie_domain === access_domain) return true;
        if (cookie_domain) {
            if (!this.explicit_domain) return false; // we already checked if the domains were exactly the same
            var wildcard = access_domain.indexOf(cookie_domain);
            if (wildcard === -1 || wildcard !== access_domain.length - cookie_domain.length) return false;
            return true;
        }
        return true;
    };
    function CookieJar() {
        var cookies, cookies_list, collidable_cookie;
        if (this instanceof CookieJar) {
            cookies = Object.create(null); //name: [Cookie]
            this.setCookie = function setCookie(cookie, request_domain, request_path) {
                var remove, i;
                cookie = new Cookie(cookie, request_domain, request_path);
                //Delete the cookie if the set is past the current time
                remove = cookie.expiration_date <= Date.now();
                if (cookies[cookie.name] !== undefined) {
                    cookies_list = cookies[cookie.name];
                    for(i = 0; i < cookies_list.length; i += 1){
                        collidable_cookie = cookies_list[i];
                        if (collidable_cookie.collidesWith(cookie)) {
                            if (remove) {
                                cookies_list.splice(i, 1);
                                if (cookies_list.length === 0) delete cookies[cookie.name];
                                return false;
                            }
                            cookies_list[i] = cookie;
                            return cookie;
                        }
                    }
                    if (remove) return false;
                    cookies_list.push(cookie);
                    return cookie;
                }
                if (remove) return false;
                cookies[cookie.name] = [
                    cookie
                ];
                return cookies[cookie.name];
            };
            //returns a cookie
            this.getCookie = function getCookie(cookie_name, access_info) {
                var cookie, i;
                cookies_list = cookies[cookie_name];
                if (!cookies_list) return;
                for(i = 0; i < cookies_list.length; i += 1){
                    cookie = cookies_list[i];
                    if (cookie.expiration_date <= Date.now()) {
                        if (cookies_list.length === 0) delete cookies[cookie.name];
                        continue;
                    }
                    if (cookie.matches(access_info)) return cookie;
                }
            };
            //returns a list of cookies
            this.getCookies = function getCookies(access_info) {
                var matches = [], cookie_name, cookie;
                for(cookie_name in cookies){
                    cookie = this.getCookie(cookie_name, access_info);
                    if (cookie) matches.push(cookie);
                }
                matches.toString = function toString() {
                    return matches.join(":");
                };
                matches.toValueString = function toValueString() {
                    return matches.map(function(c) {
                        return c.toValueString();
                    }).join(";");
                };
                return matches;
            };
            return this;
        }
        return new CookieJar();
    }
    $4be5309b079bebfc$export$991f683f69795c48 = CookieJar;
    //returns list of cookies that were set correctly. Cookies that are expired and removed are not returned.
    CookieJar.prototype.setCookies = function setCookies(cookies, request_domain, request_path) {
        cookies = Array.isArray(cookies) ? cookies : cookies.split(cookie_str_splitter);
        var successful = [], i, cookie;
        cookies = cookies.map(function(item) {
            return new Cookie(item, request_domain, request_path);
        });
        for(i = 0; i < cookies.length; i += 1){
            cookie = cookies[i];
            if (this.setCookie(cookie, request_domain, request_path)) successful.push(cookie);
        }
        return successful;
    };
})();

});




parcelRegister("2g8iy", function(module, exports) {
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file index.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $heyrh = parcelRequire("heyrh");
var $1a53833d9c022627$require$errors = $heyrh.errors;

var $gVLnd = parcelRequire("gVLnd");
var $1a53833d9c022627$var$IpcProvider = function IpcProvider(path, net) {
    var _this = this;
    this.responseCallbacks = {};
    this.notificationCallbacks = [];
    this.path = path;
    this.connected = false;
    this.connection = net.connect({
        path: this.path
    });
    this.addDefaultEvents();
    // LISTEN FOR CONNECTION RESPONSES
    var callback = function(result) {
        /*jshint maxcomplexity: 6 */ var id = null;
        // get the id which matches the returned id
        if (Array.isArray(result)) result.forEach(function(load) {
            if (_this.responseCallbacks[load.id]) id = load.id;
        });
        else id = result.id;
        // notification
        if (!id && result.method.indexOf("_subscription") !== -1) _this.notificationCallbacks.forEach(function(callback) {
            if (typeof callback === "function") callback(result);
        });
        else if (_this.responseCallbacks[id]) {
            _this.responseCallbacks[id](null, result);
            delete _this.responseCallbacks[id];
        }
    };
    // use oboe.js for Sockets
    if (net.constructor.name === "Socket") $gVLnd(this.connection).done(callback);
    else this.connection.on("data", function(data) {
        _this._parseResponse(data.toString()).forEach(callback);
    });
};
/**
Will add the error and end event to timeout existing calls

@method addDefaultEvents
*/ $1a53833d9c022627$var$IpcProvider.prototype.addDefaultEvents = function() {
    var _this = this;
    this.connection.on("connect", function() {
        _this.connected = true;
    });
    this.connection.on("close", function() {
        _this.connected = false;
    });
    this.connection.on("error", function() {
        _this._timeout();
    });
    this.connection.on("end", function() {
        _this._timeout();
    });
    this.connection.on("timeout", function() {
        _this._timeout();
    });
};
/**
 Will parse the response and make an array out of it.

 NOTE, this exists for backwards compatibility reasons.

 @method _parseResponse
 @param {String} data
 */ $1a53833d9c022627$var$IpcProvider.prototype._parseResponse = function(data) {
    var _this = this, returnValues = [];
    // DE-CHUNKER
    var dechunkedData = data.replace(/\}[\n\r]?\{/g, "}|--|{") // }{
    .replace(/\}\][\n\r]?\[\{/g, "}]|--|[{") // }][{
    .replace(/\}[\n\r]?\[\{/g, "}|--|[{") // }[{
    .replace(/\}\][\n\r]?\{/g, "}]|--|{") // }]{
    .split("|--|");
    dechunkedData.forEach(function(data) {
        // prepend the last chunk
        if (_this.lastChunk) data = _this.lastChunk + data;
        var result = null;
        try {
            result = JSON.parse(data);
        } catch (e) {
            _this.lastChunk = data;
            // start timeout to cancel all requests
            clearTimeout(_this.lastChunkTimeout);
            _this.lastChunkTimeout = setTimeout(function() {
                _this._timeout();
                throw $1a53833d9c022627$require$errors.InvalidResponse(data);
            }, 15000);
            return;
        }
        // cancel timeout and set chunk to null
        clearTimeout(_this.lastChunkTimeout);
        _this.lastChunk = null;
        if (result) returnValues.push(result);
    });
    return returnValues;
};
/**
Get the adds a callback to the responseCallbacks object,
which will be called if a response matching the response Id will arrive.

@method _addResponseCallback
*/ $1a53833d9c022627$var$IpcProvider.prototype._addResponseCallback = function(payload, callback) {
    var id = payload.id || payload[0].id;
    var method = payload.method || payload[0].method;
    this.responseCallbacks[id] = callback;
    this.responseCallbacks[id].method = method;
};
/**
Timeout all requests when the end/error event is fired

@method _timeout
*/ $1a53833d9c022627$var$IpcProvider.prototype._timeout = function() {
    for(var key in this.responseCallbacks)if (this.responseCallbacks.hasOwnProperty(key)) {
        this.responseCallbacks[key]($1a53833d9c022627$require$errors.InvalidConnection("on IPC"));
        delete this.responseCallbacks[key];
    }
};
/**
 Try to reconnect

 @method reconnect
 */ $1a53833d9c022627$var$IpcProvider.prototype.reconnect = function() {
    this.connection.connect({
        path: this.path
    });
};
$1a53833d9c022627$var$IpcProvider.prototype.send = function(payload, callback) {
    // try reconnect, when connection is gone
    if (!this.connection.writable) this.connection.connect({
        path: this.path
    });
    this.connection.write(JSON.stringify(payload));
    this._addResponseCallback(payload, callback);
};
/**
Subscribes to provider events.provider

@method on
@param {String} type    'notification', 'connect', 'error', 'end' or 'data'
@param {Function} callback   the callback to call
*/ $1a53833d9c022627$var$IpcProvider.prototype.on = function(type, callback) {
    if (typeof callback !== "function") throw new Error("The second parameter callback must be a function.");
    switch(type){
        case "data":
            this.notificationCallbacks.push(callback);
            break;
        // adds error, end, timeout, connect
        default:
            this.connection.on(type, callback);
            break;
    }
};
/**
 Subscribes to provider events.provider

 @method on
 @param {String} type    'connect', 'error', 'end' or 'data'
 @param {Function} callback   the callback to call
 */ $1a53833d9c022627$var$IpcProvider.prototype.once = function(type, callback) {
    if (typeof callback !== "function") throw new Error("The second parameter callback must be a function.");
    this.connection.once(type, callback);
};
/**
Removes event listener

@method removeListener
@param {String} type    'data', 'connect', 'error', 'end' or 'data'
@param {Function} callback   the callback to call
*/ $1a53833d9c022627$var$IpcProvider.prototype.removeListener = function(type, callback) {
    var _this = this;
    switch(type){
        case "data":
            this.notificationCallbacks.forEach(function(cb, index) {
                if (cb === callback) _this.notificationCallbacks.splice(index, 1);
            });
            break;
        default:
            this.connection.removeListener(type, callback);
            break;
    }
};
/**
Removes all event listeners

@method removeAllListeners
@param {String} type    'data', 'connect', 'error', 'end' or 'data'
*/ $1a53833d9c022627$var$IpcProvider.prototype.removeAllListeners = function(type) {
    switch(type){
        case "data":
            this.notificationCallbacks = [];
            break;
        default:
            this.connection.removeAllListeners(type);
            break;
    }
};
/**
Resets the providers, clears all callbacks

@method reset
*/ $1a53833d9c022627$var$IpcProvider.prototype.reset = function() {
    this._timeout();
    this.notificationCallbacks = [];
    this.connection.removeAllListeners("error");
    this.connection.removeAllListeners("end");
    this.connection.removeAllListeners("timeout");
    this.addDefaultEvents();
};
/**
 * Returns the desired boolean.
 *
 * @method supportsSubscriptions
 * @returns {boolean}
 */ $1a53833d9c022627$var$IpcProvider.prototype.supportsSubscriptions = function() {
    return true;
};
module.exports = $1a53833d9c022627$var$IpcProvider;

});
parcelRegister("gVLnd", function(module, exports) {
/*!
 * v2.1.4-104-gc868b3a
 * 
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(typeof self !== "undefined" ? self : module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return partialComplete;
            });
            /* unused harmony export compose */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return compose2;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return attr;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return lazyUnion;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return apply;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return varArgs;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return flip;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return lazyIntersection;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return noop;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return always;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return functor;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /**
 * Partially complete a function.
 *
 *  var add3 = partialComplete( function add(a,b){return a+b}, 3 );
 *
 *  add3(4) // gives 7
 *
 *  function wrap(left, right, cen){return left + " " + cen + " " + right;}
 *
 *  var pirateGreeting = partialComplete( wrap , "I'm", ", a mighty pirate!" );
 *
 *  pirateGreeting("Guybrush Threepwood");
 *  // gives "I'm Guybrush Threepwood, a mighty pirate!"
 */ var partialComplete = varArgs(function(fn, args) {
                // this isn't the shortest way to write this but it does
                // avoid creating a new array each time to pass to fn.apply,
                // otherwise could just call boundArgs.concat(callArgs)
                var numBoundArgs = args.length;
                return varArgs(function(callArgs) {
                    for(var i = 0; i < callArgs.length; i++)args[numBoundArgs + i] = callArgs[i];
                    args.length = numBoundArgs + callArgs.length;
                    return fn.apply(this, args);
                });
            });
            /**
* Compose zero or more functions:
*
*    compose(f1, f2, f3)(x) = f1(f2(f3(x))))
*
* The last (inner-most) function may take more than one parameter:
*
*    compose(f1, f2, f3)(x,y) = f1(f2(f3(x,y))))
*/ var compose = varArgs(function(fns) {
                var fnsList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["c" /* arrayAsList */ ])(fns);
                function next(params, curFn) {
                    return [
                        apply(params, curFn)
                    ];
                }
                return varArgs(function(startParams) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__lists__["f" /* foldR */ ])(next, startParams, fnsList)[0];
                });
            });
            /**
* A more optimised version of compose that takes exactly two functions
* @param f1
* @param f2
*/ function compose2(f1, f2) {
                return function() {
                    return f1.call(this, f2.apply(this, arguments));
                };
            }
            /**
* Generic form for a function to get a property from an object
*
*    var o = {
*       foo:'bar'
*    }
*
*    var getFoo = attr('foo')
*
*    fetFoo(o) // returns 'bar'
*
* @param {String} key the property name
*/ function attr(key) {
                return function(o) {
                    return o[key];
                };
            }
            /**
* Call a list of functions with the same args until one returns a
* truthy result. Similar to the || operator.
*
* So:
*      lazyUnion([f1,f2,f3 ... fn])( p1, p2 ... pn )
*
* Is equivalent to:
*      apply([p1, p2 ... pn], f1) ||
*      apply([p1, p2 ... pn], f2) ||
*      apply([p1, p2 ... pn], f3) ... apply(fn, [p1, p2 ... pn])
*
* @returns the first return value that is given that is truthy.
*/ var lazyUnion = varArgs(function(fns) {
                return varArgs(function(params) {
                    var maybeValue;
                    for(var i = 0; i < attr("length")(fns); i++){
                        maybeValue = apply(params, fns[i]);
                        if (maybeValue) return maybeValue;
                    }
                });
            });
            /**
* This file declares various pieces of functional programming.
*
* This isn't a general purpose functional library, to keep things small it
* has just the parts useful for Oboe.js.
*/ /**
* Call a single function with the given arguments array.
* Basically, a functional-style version of the OO-style Function#apply for
* when we don't care about the context ('this') of the call.
*
* The order of arguments allows partial completion of the arguments array
*/ function apply(args, fn) {
                return fn.apply(undefined, args);
            }
            /**
* Define variable argument functions but cut out all that tedious messing about
* with the arguments object. Delivers the variable-length part of the arguments
* list as an array.
*
* Eg:
*
* var myFunction = varArgs(
*    function( fixedArgument, otherFixedArgument, variableNumberOfArguments ){
*       console.log( variableNumberOfArguments );
*    }
* )
*
* myFunction('a', 'b', 1, 2, 3); // logs [1,2,3]
*
* var myOtherFunction = varArgs(function( variableNumberOfArguments ){
*    console.log( variableNumberOfArguments );
* })
*
* myFunction(1, 2, 3); // logs [1,2,3]
*
*/ function varArgs(fn) {
                var numberOfFixedArguments = fn.length - 1;
                var slice = Array.prototype.slice;
                if (numberOfFixedArguments === 0) // an optimised case for when there are no fixed args:
                return function() {
                    return fn.call(this, slice.call(arguments));
                };
                else if (numberOfFixedArguments === 1) // an optimised case for when there are is one fixed args:
                return function() {
                    return fn.call(this, arguments[0], slice.call(arguments, 1));
                };
                // general case
                // we know how many arguments fn will always take. Create a
                // fixed-size array to hold that many, to be re-used on
                // every call to the returned function
                var argsHolder = Array(fn.length);
                return function() {
                    for(var i = 0; i < numberOfFixedArguments; i++)argsHolder[i] = arguments[i];
                    argsHolder[numberOfFixedArguments] = slice.call(arguments, numberOfFixedArguments);
                    return fn.apply(this, argsHolder);
                };
            }
            /**
* Swap the order of parameters to a binary function
*
* A bit like this flip: http://zvon.org/other/haskell/Outputprelude/flip_f.html
*/ function flip(fn) {
                return function(a, b) {
                    return fn(b, a);
                };
            }
            /**
* Create a function which is the intersection of two other functions.
*
* Like the && operator, if the first is truthy, the second is never called,
* otherwise the return value from the second is returned.
*/ function lazyIntersection(fn1, fn2) {
                return function(param) {
                    return fn1(param) && fn2(param);
                };
            }
            /**
* A function which does nothing
*/ function noop() {}
            /**
* A function which is always happy
*/ function always() {
                return true;
            }
            /**
* Create a function which always returns the same
* value
*
* var return3 = functor(3);
*
* return3() // gives 3
* return3() // still gives 3
* return3() // will always give 3
*/ function functor(val) {
                return function() {
                    return val;
                };
            }
        /***/ },
        /* 1 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return cons;
            });
            /* unused harmony export emptyList */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return head;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() {
                return tail;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return arrayAsList;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return list;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return listAsArray;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return map;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return foldR;
            });
            /* unused harmony export foldR1 */ /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() {
                return without;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return all;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return applyEach;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return reverseList;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return first;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /**
 * Like cons in Lisp
 */ function cons(x, xs) {
                /* Internally lists are linked 2-element Javascript arrays.

      Ideally the return here would be Object.freeze([x,xs])
      so that bugs related to mutation are found fast.
      However, cons is right on the critical path for
      performance and this slows oboe-mark down by
      ~25%. Under theoretical future JS engines that freeze more
      efficiently (possibly even use immutability to
      run faster) this should be considered for
      restoration.
   */ return [
                    x,
                    xs
                ];
            }
            /**
 * The empty list
 */ var emptyList = null;
            /**
 * Get the head of a list.
 *
 * Ie, head(cons(a,b)) = a
 */ var head = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])(0);
            /**
 * Get the tail of a list.
 *
 * Ie, tail(cons(a,b)) = b
 */ var tail = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])(1);
            /**
 * Converts an array to a list
 *
 *    asList([a,b,c])
 *
 * is equivalent to:
 *
 *    cons(a, cons(b, cons(c, emptyList)))
 **/ function arrayAsList(inputArray) {
                return reverseList(inputArray.reduce(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["e" /* flip */ ])(cons), emptyList));
            }
            /**
 * A varargs version of arrayAsList. Works a bit like list
 * in LISP.
 *
 *    list(a,b,c)
 *
 * is equivalent to:
 *
 *    cons(a, cons(b, cons(c, emptyList)))
 */ var list = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["k" /* varArgs */ ])(arrayAsList);
            /**
 * Convert a list back to a js native array
 */ function listAsArray(list) {
                return foldR(function(arraySoFar, listItem) {
                    arraySoFar.unshift(listItem);
                    return arraySoFar;
                }, [], list);
            }
            /**
 * Map a function over a list
 */ function map(fn, list) {
                return list ? cons(fn(head(list)), map(fn, tail(list))) : emptyList;
            }
            /**
 * foldR implementation. Reduce a list down to a single value.
 *
 * @pram {Function} fn     (rightEval, curVal) -> result
 */ function foldR(fn, startValue, list) {
                return list ? fn(foldR(fn, startValue, tail(list)), head(list)) : startValue;
            }
            /**
 * foldR implementation. Reduce a list down to a single value.
 *
 * @pram {Function} fn     (rightEval, curVal) -> result
 */ function foldR1(fn, list) {
                return tail(list) ? fn(foldR1(fn, tail(list)), head(list)) : head(list);
            }
            /**
 * Return a list like the one given but with the first instance equal
 * to item removed
 */ function without(list, test, removedFn) {
                return withoutInner(list, removedFn || __WEBPACK_IMPORTED_MODULE_0__functional__["i" /* noop */ ]);
                function withoutInner(subList, removedFn) {
                    return subList ? test(head(subList)) ? (removedFn(head(subList)), tail(subList)) : cons(head(subList), withoutInner(tail(subList), removedFn)) : emptyList;
                }
            }
            /**
 * Returns true if the given function holds for every item in
 * the list, false otherwise
 */ function all(fn, list) {
                return !list || fn(head(list)) && all(fn, tail(list));
            }
            /**
 * Call every function in a list of functions with the same arguments
 *
 * This doesn't make any sense if we're doing pure functional because
 * it doesn't return anything. Hence, this is only really useful if the
 * functions being called have side-effects.
 */ function applyEach(fnList, args) {
                if (fnList) {
                    head(fnList).apply(null, args);
                    applyEach(tail(fnList), args);
                }
            }
            /**
 * Reverse the order of a list
 */ function reverseList(list) {
                // js re-implementation of 3rd solution from:
                //    http://www.haskell.org/haskellwiki/99_questions/Solutions/5
                function reverseInner(list, reversedAlready) {
                    if (!list) return reversedAlready;
                    return reverseInner(tail(list), cons(head(list), reversedAlready));
                }
                return reverseInner(list, emptyList);
            }
            function first(test, list) {
                return list && (test(head(list)) ? head(list) : first(test, tail(list)));
            }
        /***/ },
        /* 2 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return isOfType;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return len;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return isString;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return defined;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return hasAllProperties;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /**
 * This file defines some loosely associated syntactic sugar for
 * Javascript programming
 */ /**
 * Returns true if the given candidate is of type T
 */ function isOfType(T, maybeSomething) {
                return maybeSomething && maybeSomething.constructor === T;
            }
            var len = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["c" /* attr */ ])("length");
            var isString = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(isOfType, String);
            /**
 * I don't like saying this:
 *
 *    foo !=== undefined
 *
 * because of the double-negative. I find this:
 *
 *    defined(foo)
 *
 * easier to read.
 */ function defined(value) {
                return value !== undefined;
            }
            /**
 * Returns true if object o has a key named like every property in
 * the properties array. Will give false if any are missing, or if o
 * is not an object.
 */ function hasAllProperties(fieldList, o) {
                return o instanceof Object && Object(__WEBPACK_IMPORTED_MODULE_0__lists__["a" /* all */ ])(function(field) {
                    return field in o;
                }, fieldList);
            }
        /***/ },
        /* 3 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() {
                return NODE_OPENED;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() {
                return NODE_CLOSED;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() {
                return NODE_SWAP;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() {
                return NODE_DROP;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return FAIL_EVENT;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() {
                return ROOT_NODE_FOUND;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() {
                return ROOT_PATH_FOUND;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return HTTP_START;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() {
                return STREAM_DATA;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() {
                return STREAM_END;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ABORTING;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() {
                return SAX_KEY;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() {
                return SAX_VALUE_OPEN;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() {
                return SAX_VALUE_CLOSE;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() {
                return errorReport;
            });
            /**
 * This file declares some constants to use as names for event types.
 */ // the events which are never exported are kept as
            // the smallest possible representation, in numbers:
            var _S = 1;
            // fired whenever a new node starts in the JSON stream:
            var NODE_OPENED = _S++;
            // fired whenever a node closes in the JSON stream:
            var NODE_CLOSED = _S++;
            // called if a .node callback returns a value -
            var NODE_SWAP = _S++;
            var NODE_DROP = _S++;
            var FAIL_EVENT = "fail";
            var ROOT_NODE_FOUND = _S++;
            var ROOT_PATH_FOUND = _S++;
            var HTTP_START = "start";
            var STREAM_DATA = "data";
            var STREAM_END = "end";
            var ABORTING = _S++;
            // SAX events butchered from Clarinet
            var SAX_KEY = _S++;
            var SAX_VALUE_OPEN = _S++;
            var SAX_VALUE_CLOSE = _S++;
            function errorReport(statusCode, body, error) {
                try {
                    var jsonBody = JSON.parse(body);
                } catch (e) {}
                return {
                    statusCode: statusCode,
                    body: body,
                    jsonBody: jsonBody,
                    thrown: error
                };
            }
        /***/ },
        /* 4 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return namedNode;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return keyOf;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() {
                return nodeOf;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /**
 * Get a new key->node mapping
 *
 * @param {String|Number} key
 * @param {Object|Array|String|Number|null} node a value found in the json
 */ function namedNode(key, node) {
                return {
                    key: key,
                    node: node
                };
            }
            /** get the key of a namedNode */ var keyOf = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])("key");
            /** get the node from a namedNode */ var nodeOf = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])("node");
        /***/ },
        /* 5 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return oboe;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaults__ = __webpack_require__(8);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__wire__ = __webpack_require__(9);
            // export public API
            function oboe(arg1) {
                // We use duck-typing to detect if the parameter given is a stream, with the
                // below list of parameters.
                // Unpipe and unshift would normally be present on a stream but this breaks
                // compatibility with Request streams.
                // See https://github.com/jimhigson/oboe.js/issues/65
                var nodeStreamMethodNames = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["h" /* list */ ])("resume", "pause", "pipe");
                var isStream = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(__WEBPACK_IMPORTED_MODULE_2__util__["b" /* hasAllProperties */ ], nodeStreamMethodNames);
                if (arg1) {
                    if (isStream(arg1) || Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* isString */ ])(arg1)) //  simple version for GETs. Signature is:
                    //    oboe( url )
                    //  or, under node:
                    //    oboe( readableStream )
                    return Object(__WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* applyDefaults */ ])(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ], arg1 // url
                    );
                    else // method signature is:
                    //    oboe({method:m, url:u, body:b, headers:{...}})
                    return Object(__WEBPACK_IMPORTED_MODULE_3__defaults__["a" /* applyDefaults */ ])(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ], arg1.url, arg1.method, arg1.body, arg1.headers, arg1.withCredentials, arg1.cached);
                } else // wire up a no-AJAX, no-stream Oboe. Will have to have content
                // fed in externally and using .emit.
                return Object(__WEBPACK_IMPORTED_MODULE_4__wire__["a" /* wire */ ])();
            }
            /* oboe.drop is a special value. If a node callback returns this value the
   parsed node is deleted from the JSON
 */ oboe.drop = function() {
                return oboe.drop;
            };
        /***/ },
        /* 6 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return incrementalContentBuilder;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ROOT_PATH;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lists__ = __webpack_require__(1);
            /**
 * This file provides various listeners which can be used to build up
 * a changing ascent based on the callbacks provided by Clarinet. It listens
 * to the low-level events from Clarinet and emits higher-level ones.
 *
 * The building up is stateless so to track a JSON file
 * ascentManager.js is required to store the ascent state
 * between calls.
 */ /**
 * A special value to use in the path list to represent the path 'to' a root
 * object (which doesn't really have any path). This prevents the need for
 * special-casing detection of the root object and allows it to be treated
 * like any other object. We might think of this as being similar to the
 * 'unnamed root' domain ".", eg if I go to
 * http://en.wikipedia.org./wiki/En/Main_page the dot after 'org' deliminates
 * the unnamed root of the DNS.
 *
 * This is kept as an object to take advantage that in Javascript's OO objects
 * are guaranteed to be distinct, therefore no other object can possibly clash
 * with this one. Strings, numbers etc provide no such guarantee.
 **/ var ROOT_PATH = {};
            /**
 * Create a new set of handlers for clarinet's events, bound to the emit
 * function given.
 */ function incrementalContentBuilder(oboeBus) {
                var emitNodeOpened = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["f" /* NODE_OPENED */ ]).emit;
                var emitNodeClosed = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["d" /* NODE_CLOSED */ ]).emit;
                var emitRootOpened = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["i" /* ROOT_PATH_FOUND */ ]).emit;
                var emitRootClosed = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["h" /* ROOT_NODE_FOUND */ ]).emit;
                function arrayIndicesAreKeys(possiblyInconsistentAscent, newDeepestNode) {
                    /* for values in arrays we aren't pre-warned of the coming paths
         (Clarinet gives no call to onkey like it does for values in objects)
         so if we are in an array we need to create this path ourselves. The
         key will be len(parentNode) because array keys are always sequential
         numbers. */ var parentNode = Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(possiblyInconsistentAscent));
                    return Object(__WEBPACK_IMPORTED_MODULE_2__util__["c" /* isOfType */ ])(Array, parentNode) ? keyFound(possiblyInconsistentAscent, Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* len */ ])(parentNode), newDeepestNode) : possiblyInconsistentAscent;
                }
                function nodeOpened(ascent, newDeepestNode) {
                    if (!ascent) {
                        // we discovered the root node,
                        emitRootOpened(newDeepestNode);
                        return keyFound(ascent, ROOT_PATH, newDeepestNode);
                    }
                    // we discovered a non-root node
                    var arrayConsistentAscent = arrayIndicesAreKeys(ascent, newDeepestNode);
                    var ancestorBranches = Object(__WEBPACK_IMPORTED_MODULE_3__lists__["l" /* tail */ ])(arrayConsistentAscent);
                    var previouslyUnmappedName = Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["a" /* keyOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(arrayConsistentAscent));
                    appendBuiltContent(ancestorBranches, previouslyUnmappedName, newDeepestNode);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lists__["d" /* cons */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["b" /* namedNode */ ])(previouslyUnmappedName, newDeepestNode), ancestorBranches);
                }
                /**
    * Add a new value to the object we are building up to represent the
    * parsed JSON
    */ function appendBuiltContent(ancestorBranches, key, node) {
                    Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(ancestorBranches))[key] = node;
                }
                /**
    * For when we find a new key in the json.
    *
    * @param {String|Number|Object} newDeepestName the key. If we are in an
    *    array will be a number, otherwise a string. May take the special
    *    value ROOT_PATH if the root node has just been found
    *
    * @param {String|Number|Object|Array|Null|undefined} [maybeNewDeepestNode]
    *    usually this won't be known so can be undefined. Can't use null
    *    to represent unknown because null is a valid value in JSON
    **/ function keyFound(ascent, newDeepestName, maybeNewDeepestNode) {
                    if (ascent) // If we have the key but (unless adding to an array) no known value
                    // yet. Put that key in the output but against no defined value:
                    appendBuiltContent(ascent, newDeepestName, maybeNewDeepestNode);
                    var ascentWithNewPath = Object(__WEBPACK_IMPORTED_MODULE_3__lists__["d" /* cons */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["b" /* namedNode */ ])(newDeepestName, maybeNewDeepestNode), ascent);
                    emitNodeOpened(ascentWithNewPath);
                    return ascentWithNewPath;
                }
                /**
    * For when the current node ends.
    */ function nodeClosed(ascent) {
                    emitNodeClosed(ascent);
                    return Object(__WEBPACK_IMPORTED_MODULE_3__lists__["l" /* tail */ ])(ascent) || // If there are no nodes left in the ascent the root node
                    // just closed. Emit a special event for this:
                    emitRootClosed(Object(__WEBPACK_IMPORTED_MODULE_1__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_3__lists__["g" /* head */ ])(ascent)));
                }
                var contentBuilderHandlers = {};
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["l" /* SAX_VALUE_OPEN */ ]] = nodeOpened;
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["k" /* SAX_VALUE_CLOSE */ ]] = nodeClosed;
                contentBuilderHandlers[__WEBPACK_IMPORTED_MODULE_0__events__["j" /* SAX_KEY */ ]] = keyFound;
                return contentBuilderHandlers;
            }
        /***/ },
        /* 7 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            Object.defineProperty(__webpack_exports__, "__esModule", {
                value: true
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__publicApi__ = __webpack_require__(5);
            /* harmony default export */ __webpack_exports__["default"] = __WEBPACK_IMPORTED_MODULE_0__publicApi__["a" /* oboe */ ];
        /***/ },
        /* 8 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return applyDefaults;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(2);
            function applyDefaults(passthrough, url, httpMethodName, body, headers, withCredentials, cached) {
                headers = headers ? JSON.parse(JSON.stringify(headers)) : {};
                if (body) {
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* isString */ ])(body)) {
                        // If the body is not a string, stringify it. This allows objects to
                        // be given which will be sent as JSON.
                        body = JSON.stringify(body);
                        // Default Content-Type to JSON unless given otherwise.
                        headers["Content-Type"] = headers["Content-Type"] || "application/json";
                    }
                    headers["Content-Length"] = headers["Content-Length"] || body.length;
                } else body = null;
                // support cache busting like jQuery.ajax({cache:false})
                function modifiedUrl(baseUrl, cached) {
                    if (cached === false) {
                        if (baseUrl.indexOf("?") === -1) baseUrl += "?";
                        else baseUrl += "&";
                        baseUrl += "_=" + new Date().getTime();
                    }
                    return baseUrl;
                }
                return passthrough(httpMethodName || "GET", modifiedUrl(url, cached), body, headers, withCredentials || false);
            }
        /***/ },
        /* 9 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return wire;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pubSub__ = __webpack_require__(10);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascentManager__ = __webpack_require__(12);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__incrementalContentBuilder__ = __webpack_require__(6);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__patternAdapter__ = __webpack_require__(13);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsonPath__ = __webpack_require__(14);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__instanceApi__ = __webpack_require__(16);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_clarinet__ = __webpack_require__(17);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__ = __webpack_require__(18);
            /**
 * This file sits just behind the API which is used to attain a new
 * Oboe instance. It creates the new components that are required
 * and introduces them to each other.
 */ function wire(httpMethodName, contentSource, body, headers, withCredentials) {
                var oboeBus = Object(__WEBPACK_IMPORTED_MODULE_0__pubSub__["a" /* pubSub */ ])();
                // Wire the input stream in if we are given a content source.
                // This will usually be the case. If not, the instance created
                // will have to be passed content from an external source.
                if (contentSource) Object(__WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__["b" /* streamingHttp */ ])(oboeBus, Object(__WEBPACK_IMPORTED_MODULE_7__streamingHttp_node__["a" /* httpTransport */ ])(), httpMethodName, contentSource, body, headers, withCredentials);
                Object(__WEBPACK_IMPORTED_MODULE_6__libs_clarinet__["a" /* clarinet */ ])(oboeBus);
                Object(__WEBPACK_IMPORTED_MODULE_1__ascentManager__["a" /* ascentManager */ ])(oboeBus, Object(__WEBPACK_IMPORTED_MODULE_2__incrementalContentBuilder__["b" /* incrementalContentBuilder */ ])(oboeBus));
                Object(__WEBPACK_IMPORTED_MODULE_3__patternAdapter__["a" /* patternAdapter */ ])(oboeBus, __WEBPACK_IMPORTED_MODULE_4__jsonPath__["a" /* jsonPathCompiler */ ]);
                return Object(__WEBPACK_IMPORTED_MODULE_5__instanceApi__["a" /* instanceApi */ ])(oboeBus, contentSource);
            }
        /***/ },
        /* 10 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return pubSub;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__singleEventPubSub__ = __webpack_require__(11);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /**
 * pubSub is a curried interface for listening to and emitting
 * events.
 *
 * If we get a bus:
 *
 *    var bus = pubSub();
 *
 * We can listen to event 'foo' like:
 *
 *    bus('foo').on(myCallback)
 *
 * And emit event foo like:
 *
 *    bus('foo').emit()
 *
 * or, with a parameter:
 *
 *    bus('foo').emit('bar')
 *
 * All functions can be cached and don't need to be
 * bound. Ie:
 *
 *    var fooEmitter = bus('foo').emit
 *    fooEmitter('bar');  // emit an event
 *    fooEmitter('baz');  // emit another
 *
 * There's also an uncurried[1] shortcut for .emit and .on:
 *
 *    bus.on('foo', callback)
 *    bus.emit('foo', 'bar')
 *
 * [1]: http://zvon.org/other/haskell/Outputprelude/uncurry_f.html
 */ function pubSub() {
                var singles = {};
                var newListener = newSingle("newListener");
                var removeListener = newSingle("removeListener");
                function newSingle(eventName) {
                    singles[eventName] = Object(__WEBPACK_IMPORTED_MODULE_0__singleEventPubSub__["a" /* singleEventPubSub */ ])(eventName, newListener, removeListener);
                    return singles[eventName];
                }
                /** pubSub instances are functions */ function pubSubInstance(eventName) {
                    return singles[eventName] || newSingle(eventName);
                }
                // add convenience EventEmitter-style uncurried form of 'emit' and 'on'
                [
                    "emit",
                    "on",
                    "un"
                ].forEach(function(methodName) {
                    pubSubInstance[methodName] = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["k" /* varArgs */ ])(function(eventName, parameters) {
                        Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(parameters, pubSubInstance(eventName)[methodName]);
                    });
                });
                return pubSubInstance;
            }
        /***/ },
        /* 11 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return singleEventPubSub;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__functional__ = __webpack_require__(0);
            /**
 * A pub/sub which is responsible for a single event type. A
 * multi-event type event bus is created by pubSub by collecting
 * several of these.
 *
 * @param {String} eventType
 *    the name of the events managed by this singleEventPubSub
 * @param {singleEventPubSub} [newListener]
 *    place to notify of new listeners
 * @param {singleEventPubSub} [removeListener]
 *    place to notify of when listeners are removed
 */ function singleEventPubSub(eventType, newListener, removeListener) {
                /** we are optimised for emitting events over firing them.
   *  As well as the tuple list which stores event ids and
   *  listeners there is a list with just the listeners which
   *  can be iterated more quickly when we are emitting
   */ var listenerTupleList, listenerList;
                function hasId(id) {
                    return function(tuple) {
                        return tuple.id === id;
                    };
                }
                return {
                    /**
     * @param {Function} listener
     * @param {*} listenerId
     *    an id that this listener can later by removed by.
     *    Can be of any type, to be compared to other ids using ==
     */ on: function(listener, listenerId) {
                        var tuple = {
                            listener: listener,
                            id: listenerId || listener // when no id is given use the
                        };
                        if (newListener) newListener.emit(eventType, listener, tuple.id);
                        listenerTupleList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["d" /* cons */ ])(tuple, listenerTupleList);
                        listenerList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["d" /* cons */ ])(listener, listenerList);
                        return this // chaining
                        ;
                    },
                    emit: function() {
                        Object(__WEBPACK_IMPORTED_MODULE_0__lists__["b" /* applyEach */ ])(listenerList, arguments);
                    },
                    un: function(listenerId) {
                        var removed;
                        listenerTupleList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["m" /* without */ ])(listenerTupleList, hasId(listenerId), function(tuple) {
                            removed = tuple;
                        });
                        if (removed) {
                            listenerList = Object(__WEBPACK_IMPORTED_MODULE_0__lists__["m" /* without */ ])(listenerList, function(listener) {
                                return listener === removed.listener;
                            });
                            if (removeListener) removeListener.emit(eventType, removed.listener, removed.id);
                        }
                    },
                    listeners: function() {
                        // differs from Node EventEmitter: returns list, not array
                        return listenerList;
                    },
                    hasListener: function(listenerId) {
                        var test = listenerId ? hasId(listenerId) : __WEBPACK_IMPORTED_MODULE_2__functional__["a" /* always */ ];
                        return Object(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* defined */ ])(Object(__WEBPACK_IMPORTED_MODULE_0__lists__["e" /* first */ ])(test, listenerTupleList));
                    }
                };
            }
        /***/ },
        /* 12 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return ascentManager;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lists__ = __webpack_require__(1);
            /**
 * A bridge used to assign stateless functions to listen to clarinet.
 *
 * As well as the parameter from clarinet, each callback will also be passed
 * the result of the last callback.
 *
 * This may also be used to clear all listeners by assigning zero handlers:
 *
 *    ascentManager( clarinet, {} )
 */ function ascentManager(oboeBus, handlers) {
                "use strict";
                var listenerId = {};
                var ascent;
                function stateAfter(handler) {
                    return function(param) {
                        ascent = handler(ascent, param);
                    };
                }
                for(var eventName in handlers)oboeBus(eventName).on(stateAfter(handlers[eventName]), listenerId);
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["g" /* NODE_SWAP */ ]).on(function(newNode) {
                    var oldHead = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ascent);
                    var key = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["a" /* keyOf */ ])(oldHead);
                    var ancestors = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["l" /* tail */ ])(ascent);
                    var parentNode;
                    if (ancestors) {
                        parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ancestors));
                        parentNode[key] = newNode;
                    }
                });
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["e" /* NODE_DROP */ ]).on(function() {
                    var oldHead = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ascent);
                    var key = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["a" /* keyOf */ ])(oldHead);
                    var ancestors = Object(__WEBPACK_IMPORTED_MODULE_2__lists__["l" /* tail */ ])(ascent);
                    var parentNode;
                    if (ancestors) {
                        parentNode = Object(__WEBPACK_IMPORTED_MODULE_0__ascent__["c" /* nodeOf */ ])(Object(__WEBPACK_IMPORTED_MODULE_2__lists__["g" /* head */ ])(ancestors));
                        delete parentNode[key];
                    }
                });
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* ABORTING */ ]).on(function() {
                    for(var eventName in handlers)oboeBus(eventName).un(listenerId);
                });
            }
        /***/ },
        /* 13 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return patternAdapter;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascent__ = __webpack_require__(4);
            /**
 *  The pattern adaptor listens for newListener and removeListener
 *  events. When patterns are added or removed it compiles the JSONPath
 *  and wires them up.
 *
 *  When nodes and paths are found it emits the fully-qualified match
 *  events with parameters ready to ship to the outside world
 */ function patternAdapter(oboeBus, jsonPathCompiler) {
                var predicateEventMap = {
                    node: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["d" /* NODE_CLOSED */ ]),
                    path: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["f" /* NODE_OPENED */ ])
                };
                function emitMatchingNode(emitMatch, node, ascent) {
                    /*
         We're now calling to the outside world where Lisp-style
         lists will not be familiar. Convert to standard arrays.

         Also, reverse the order because it is more common to
         list paths "root to leaf" than "leaf to root"  */ var descent = Object(__WEBPACK_IMPORTED_MODULE_1__lists__["k" /* reverseList */ ])(ascent);
                    emitMatch(node, // To make a path, strip off the last item which is the special
                    // ROOT_PATH token for the 'path' to the root node
                    Object(__WEBPACK_IMPORTED_MODULE_1__lists__["i" /* listAsArray */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["l" /* tail */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["j" /* map */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["a" /* keyOf */ ], descent))), Object(__WEBPACK_IMPORTED_MODULE_1__lists__["i" /* listAsArray */ ])(Object(__WEBPACK_IMPORTED_MODULE_1__lists__["j" /* map */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ], descent)) // ancestors
                    );
                }
                /*
    * Set up the catching of events such as NODE_CLOSED and NODE_OPENED and, if
    * matching the specified pattern, propagate to pattern-match events such as
    * oboeBus('node:!')
    *
    *
    *
    * @param {Function} predicateEvent
    *          either oboeBus(NODE_CLOSED) or oboeBus(NODE_OPENED).
    * @param {Function} compiledJsonPath
    */ function addUnderlyingListener(fullEventName, predicateEvent, compiledJsonPath) {
                    var emitMatch = oboeBus(fullEventName).emit;
                    predicateEvent.on(function(ascent) {
                        var maybeMatchingMapping = compiledJsonPath(ascent);
                        /* Possible values for maybeMatchingMapping are now:

          false:
          we did not match

          an object/array/string/number/null:
          we matched and have the node that matched.
          Because nulls are valid json values this can be null.

          undefined:
          we matched but don't have the matching node yet.
          ie, we know there is an upcoming node that matches but we
          can't say anything else about it.
          */ if (maybeMatchingMapping !== false) emitMatchingNode(emitMatch, Object(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ])(maybeMatchingMapping), ascent);
                    }, fullEventName);
                    oboeBus("removeListener").on(function(removedEventName) {
                        // if the fully qualified match event listener is later removed, clean up
                        // by removing the underlying listener if it was the last using that pattern:
                        if (removedEventName === fullEventName) {
                            if (!oboeBus(removedEventName).listeners()) predicateEvent.un(fullEventName);
                        }
                    });
                }
                oboeBus("newListener").on(function(fullEventName) {
                    var match = /(node|path):(.*)/.exec(fullEventName);
                    if (match) {
                        var predicateEvent = predicateEventMap[match[1]];
                        if (!predicateEvent.hasListener(fullEventName)) addUnderlyingListener(fullEventName, predicateEvent, jsonPathCompiler(match[2]));
                    }
                });
            }
        /***/ },
        /* 14 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return jsonPathCompiler;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists__ = __webpack_require__(1);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ascent__ = __webpack_require__(4);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__ = __webpack_require__(6);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsonPathSyntax__ = __webpack_require__(15);
            /**
 * The jsonPath evaluator compiler used for Oboe.js.
 *
 * One function is exposed. This function takes a String JSONPath spec and
 * returns a function to test candidate ascents for matches.
 *
 *  String jsonPath -> (List ascent) -> Boolean|Object
 *
 * This file is coded in a pure functional style. That is, no function has
 * side effects, every function evaluates to the same value for the same
 * arguments and no variables are reassigned.
 */ // the call to jsonPathSyntax injects the token syntaxes that are needed
            // inside the compiler
            var jsonPathCompiler = Object(__WEBPACK_IMPORTED_MODULE_5__jsonPathSyntax__["a" /* jsonPathSyntax */ ])(function(pathNodeSyntax, doubleDotSyntax, dotSyntax, bangSyntax, emptySyntax) {
                var CAPTURING_INDEX = 1;
                var NAME_INDEX = 2;
                var FIELD_LIST_INDEX = 3;
                var headKey = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["a" /* keyOf */ ], __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                var headNode = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(__WEBPACK_IMPORTED_MODULE_2__ascent__["c" /* nodeOf */ ], __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                /**
    * Create an evaluator function for a named path node, expressed in the
    * JSONPath like:
    *    foo
    *    ["bar"]
    *    [2]
    */ function nameClause(previousExpr, detection) {
                    var name = detection[NAME_INDEX];
                    var matchesName = !name || name === "*" ? __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ] : function(ascent) {
                        return String(headKey(ascent)) === name;
                    };
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(matchesName, previousExpr);
                }
                /**
    * Create an evaluator function for a a duck-typed node, expressed like:
    *
    *    {spin, taste, colour}
    *    .particle{spin, taste, colour}
    *    *{spin, taste, colour}
    */ function duckTypeClause(previousExpr, detection) {
                    var fieldListStr = detection[FIELD_LIST_INDEX];
                    if (!fieldListStr) return previousExpr;
                     // don't wrap at all, return given expr as-is
                    var hasAllrequiredFields = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["j" /* partialComplete */ ])(__WEBPACK_IMPORTED_MODULE_3__util__["b" /* hasAllProperties */ ], Object(__WEBPACK_IMPORTED_MODULE_1__lists__["c" /* arrayAsList */ ])(fieldListStr.split(/\W+/)));
                    var isMatch = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(hasAllrequiredFields, headNode);
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(isMatch, previousExpr);
                }
                /**
    * Expression for $, returns the evaluator function
    */ function capture(previousExpr, detection) {
                    // extract meaning from the detection
                    var capturing = !!detection[CAPTURING_INDEX];
                    if (!capturing) return previousExpr;
                     // don't wrap at all, return given expr as-is
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(previousExpr, __WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ]);
                }
                /**
    * Create an evaluator function that moves onto the next item on the
    * lists. This function is the place where the logic to move up a
    * level in the ascent exists.
    *
    * Eg, for JSONPath ".foo" we need skip1(nameClause(always, [,'foo']))
    */ function skip1(previousExpr) {
                    if (previousExpr === __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]) /* If there is no previous expression this consume command
            is at the start of the jsonPath.
            Since JSONPath specifies what we'd like to find but not
            necessarily everything leading down to it, when running
            out of JSONPath to check against we default to true */ return __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ];
                    /** return true if the ascent we have contains only the JSON root,
       *  false otherwise
       */ function notAtRoot(ascent) {
                        return headKey(ascent) !== __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__["a" /* ROOT_PATH */ ];
                    }
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["g" /* lazyIntersection */ ])(/* If we're already at the root but there are more
                  expressions to satisfy, can't consume any more. No match.

                  This check is why none of the other exprs have to be able
                  to handle empty lists; skip1 is the only evaluator that
                  moves onto the next token and it refuses to do so once it
                  reaches the last item in the list. */ notAtRoot, /* We are not at the root of the ascent yet.
                  Move to the next level of the ascent by handing only
                  the tail to the previous expression */ Object(__WEBPACK_IMPORTED_MODULE_0__functional__["d" /* compose2 */ ])(previousExpr, __WEBPACK_IMPORTED_MODULE_1__lists__["l" /* tail */ ]));
                }
                /**
    * Create an evaluator function for the .. (double dot) token. Consumes
    * zero or more levels of the ascent, the fewest that are required to find
    * a match when given to previousExpr.
    */ function skipMany(previousExpr) {
                    if (previousExpr === __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]) /* If there is no previous expression this consume command
            is at the start of the jsonPath.
            Since JSONPath specifies what we'd like to find but not
            necessarily everything leading down to it, when running
            out of JSONPath to check against we default to true */ return __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ];
                    // In JSONPath .. is equivalent to !.. so if .. reaches the root
                    // the match has succeeded. Ie, we might write ..foo or !..foo
                    // and both should match identically.
                    var terminalCaseWhenArrivingAtRoot = rootExpr();
                    var terminalCaseWhenPreviousExpressionIsSatisfied = previousExpr;
                    var recursiveCase = skip1(function(ascent) {
                        return cases(ascent);
                    });
                    var cases = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(terminalCaseWhenArrivingAtRoot, terminalCaseWhenPreviousExpressionIsSatisfied, recursiveCase);
                    return cases;
                }
                /**
    * Generate an evaluator for ! - matches only the root element of the json
    * and ignores any previous expressions since nothing may precede !.
    */ function rootExpr() {
                    return function(ascent) {
                        return headKey(ascent) === __WEBPACK_IMPORTED_MODULE_4__incrementalContentBuilder__["a" /* ROOT_PATH */ ];
                    };
                }
                /**
    * Generate a statement wrapper to sit around the outermost
    * clause evaluator.
    *
    * Handles the case where the capturing is implicit because the JSONPath
    * did not contain a '$' by returning the last node.
    */ function statementExpr(lastClause) {
                    return function(ascent) {
                        // kick off the evaluation by passing through to the last clause
                        var exprMatch = lastClause(ascent);
                        return exprMatch === true ? Object(__WEBPACK_IMPORTED_MODULE_1__lists__["g" /* head */ ])(ascent) : exprMatch;
                    };
                }
                /**
    * For when a token has been found in the JSONPath input.
    * Compiles the parser for that token and returns in combination with the
    * parser already generated.
    *
    * @param {Function} exprs  a list of the clause evaluator generators for
    *                          the token that was found
    * @param {Function} parserGeneratedSoFar the parser already found
    * @param {Array} detection the match given by the regex engine when
    *                          the feature was found
    */ function expressionsReader(exprs, parserGeneratedSoFar, detection) {
                    // if exprs is zero-length foldR will pass back the
                    // parserGeneratedSoFar as-is so we don't need to treat
                    // this as a special case
                    return Object(__WEBPACK_IMPORTED_MODULE_1__lists__["f" /* foldR */ ])(function(parserGeneratedSoFar, expr) {
                        return expr(parserGeneratedSoFar, detection);
                    }, parserGeneratedSoFar, exprs);
                }
                /**
    *  If jsonPath matches the given detector function, creates a function which
    *  evaluates against every clause in the clauseEvaluatorGenerators. The
    *  created function is propagated to the onSuccess function, along with
    *  the remaining unparsed JSONPath substring.
    *
    *  The intended use is to create a clauseMatcher by filling in
    *  the first two arguments, thus providing a function that knows
    *  some syntax to match and what kind of generator to create if it
    *  finds it. The parameter list once completed is:
    *
    *    (jsonPath, parserGeneratedSoFar, onSuccess)
    *
    *  onSuccess may be compileJsonPathToFunction, to recursively continue
    *  parsing after finding a match or returnFoundParser to stop here.
    */ function generateClauseReaderIfTokenFound(tokenDetector, clauseEvaluatorGenerators, jsonPath, parserGeneratedSoFar, onSuccess) {
                    var detected = tokenDetector(jsonPath);
                    if (detected) {
                        var compiledParser = expressionsReader(clauseEvaluatorGenerators, parserGeneratedSoFar, detected);
                        var remainingUnparsedJsonPath = jsonPath.substr(Object(__WEBPACK_IMPORTED_MODULE_3__util__["e" /* len */ ])(detected[0]));
                        return onSuccess(remainingUnparsedJsonPath, compiledParser);
                    }
                }
                /**
    * Partially completes generateClauseReaderIfTokenFound above.
    */ function clauseMatcher(tokenDetector, exprs) {
                    return Object(__WEBPACK_IMPORTED_MODULE_0__functional__["j" /* partialComplete */ ])(generateClauseReaderIfTokenFound, tokenDetector, exprs);
                }
                /**
    * clauseForJsonPath is a function which attempts to match against
    * several clause matchers in order until one matches. If non match the
    * jsonPath expression is invalid and an error is thrown.
    *
    * The parameter list is the same as a single clauseMatcher:
    *
    *    (jsonPath, parserGeneratedSoFar, onSuccess)
    */ var clauseForJsonPath = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(clauseMatcher(pathNodeSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(capture, duckTypeClause, nameClause, skip1)), clauseMatcher(doubleDotSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(skipMany)), clauseMatcher(dotSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])()), clauseMatcher(bangSyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(capture, rootExpr)), clauseMatcher(emptySyntax, Object(__WEBPACK_IMPORTED_MODULE_1__lists__["h" /* list */ ])(statementExpr)), function(jsonPath) {
                    throw Error('"' + jsonPath + '" could not be tokenised');
                });
                /**
    * One of two possible values for the onSuccess argument of
    * generateClauseReaderIfTokenFound.
    *
    * When this function is used, generateClauseReaderIfTokenFound simply
    * returns the compiledParser that it made, regardless of if there is
    * any remaining jsonPath to be compiled.
    */ function returnFoundParser(_remainingJsonPath, compiledParser) {
                    return compiledParser;
                }
                /**
    * Recursively compile a JSONPath expression.
    *
    * This function serves as one of two possible values for the onSuccess
    * argument of generateClauseReaderIfTokenFound, meaning continue to
    * recursively compile. Otherwise, returnFoundParser is given and
    * compilation terminates.
    */ function compileJsonPathToFunction(uncompiledJsonPath, parserGeneratedSoFar) {
                    /**
       * On finding a match, if there is remaining text to be compiled
       * we want to either continue parsing using a recursive call to
       * compileJsonPathToFunction. Otherwise, we want to stop and return
       * the parser that we have found so far.
       */ var onFind = uncompiledJsonPath ? compileJsonPathToFunction : returnFoundParser;
                    return clauseForJsonPath(uncompiledJsonPath, parserGeneratedSoFar, onFind);
                }
                /**
    * This is the function that we expose to the rest of the library.
    */ return function(jsonPath) {
                    try {
                        // Kick off the recursive parsing of the jsonPath
                        return compileJsonPathToFunction(jsonPath, __WEBPACK_IMPORTED_MODULE_0__functional__["a" /* always */ ]);
                    } catch (e) {
                        throw Error('Could not compile "' + jsonPath + '" because ' + e.message);
                    }
                };
            });
        /***/ },
        /* 15 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return jsonPathSyntax;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functional__ = __webpack_require__(0);
            var jsonPathSyntax = function() {
                /**
  * Export a regular expression as a simple function by exposing just
  * the Regex#exec. This allows regex tests to be used under the same
  * interface as differently implemented tests, or for a user of the
  * tests to not concern themselves with their implementation as regular
  * expressions.
  *
  * This could also be expressed point-free as:
  *   Function.prototype.bind.bind(RegExp.prototype.exec),
  *
  * But that's far too confusing! (and not even smaller once minified
  * and gzipped)
  */ var regexDescriptor = function regexDescriptor(regex) {
                    return regex.exec.bind(regex);
                };
                /**
  * Join several regular expressions and express as a function.
  * This allows the token patterns to reuse component regular expressions
  * instead of being expressed in full using huge and confusing regular
  * expressions.
  */ var jsonPathClause = Object(__WEBPACK_IMPORTED_MODULE_0__functional__["k" /* varArgs */ ])(function(componentRegexes) {
                    // The regular expressions all start with ^ because we
                    // only want to find matches at the start of the
                    // JSONPath fragment we are inspecting
                    componentRegexes.unshift(/^/);
                    return regexDescriptor(RegExp(componentRegexes.map(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["c" /* attr */ ])("source")).join("")));
                });
                var possiblyCapturing = /(\$?)/;
                var namedNode = /([\w-_]+|\*)/;
                var namePlaceholder = /()/;
                var nodeInArrayNotation = /\["([^"]+)"\]/;
                var numberedNodeInArrayNotation = /\[(\d+|\*)\]/;
                var fieldList = /{([\w ]*?)}/;
                var optionalFieldList = /(?:{([\w ]*?)})?/;
                //   foo or *
                var jsonPathNamedNodeInObjectNotation = jsonPathClause(possiblyCapturing, namedNode, optionalFieldList);
                //   ["foo"]
                var jsonPathNamedNodeInArrayNotation = jsonPathClause(possiblyCapturing, nodeInArrayNotation, optionalFieldList);
                //   [2] or [*]
                var jsonPathNumberedNodeInArrayNotation = jsonPathClause(possiblyCapturing, numberedNodeInArrayNotation, optionalFieldList);
                //   {a b c}
                var jsonPathPureDuckTyping = jsonPathClause(possiblyCapturing, namePlaceholder, fieldList);
                //   ..
                var jsonPathDoubleDot = jsonPathClause(/\.\./);
                //   .
                var jsonPathDot = jsonPathClause(/\./);
                //   !
                var jsonPathBang = jsonPathClause(possiblyCapturing, /!/);
                //   nada!
                var emptyString = jsonPathClause(/$/);
                /* We export only a single function. When called, this function injects
      into another function the descriptors from above.
    */ return function(fn) {
                    return fn(Object(__WEBPACK_IMPORTED_MODULE_0__functional__["h" /* lazyUnion */ ])(jsonPathNamedNodeInObjectNotation, jsonPathNamedNodeInArrayNotation, jsonPathNumberedNodeInArrayNotation, jsonPathPureDuckTyping), jsonPathDoubleDot, jsonPathDot, jsonPathBang, emptyString);
                };
            }();
        /***/ },
        /* 16 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return instanceApi;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__functional__ = __webpack_require__(0);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__publicApi__ = __webpack_require__(5);
            /**
 * The instance API is the thing that is returned when oboe() is called.
 * it allows:
 *
 *    - listeners for various events to be added and removed
 *    - the http response header/headers to be read
 */ function instanceApi(oboeBus, contentSource) {
                var oboeApi;
                var fullyQualifiedNamePattern = /^(node|path):./;
                var rootNodeFinishedEvent = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["h" /* ROOT_NODE_FOUND */ ]);
                var emitNodeDrop = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["e" /* NODE_DROP */ ]).emit;
                var emitNodeSwap = oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["g" /* NODE_SWAP */ ]).emit;
                /**
       * Add any kind of listener that the instance api exposes
       */ var addListener = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["k" /* varArgs */ ])(function(eventId, parameters) {
                    if (oboeApi[eventId]) // for events added as .on(event, callback), if there is a
                    // .event() equivalent with special behaviour , pass through
                    // to that:
                    Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(parameters, oboeApi[eventId]);
                    else {
                        // we have a standard Node.js EventEmitter 2-argument call.
                        // The first parameter is the listener.
                        var event = oboeBus(eventId);
                        var listener = parameters[0];
                        if (fullyQualifiedNamePattern.test(eventId)) // allow fully-qualified node/path listeners
                        // to be added
                        addForgettableCallback(event, wrapCallbackToSwapNodeIfSomethingReturned(listener));
                        else // the event has no special handling, pass through
                        // directly onto the event bus:
                        event.on(listener);
                    }
                    return oboeApi // chaining
                    ;
                });
                /**
       * Remove any kind of listener that the instance api exposes
       */ var removeListener = function(eventId, p2, p3) {
                    if (eventId === "done") rootNodeFinishedEvent.un(p2);
                    else if (eventId === "node" || eventId === "path") // allow removal of node and path
                    oboeBus.un(eventId + ":" + p2, p3);
                    else {
                        // we have a standard Node.js EventEmitter 2-argument call.
                        // The second parameter is the listener. This may be a call
                        // to remove a fully-qualified node/path listener but requires
                        // no special handling
                        var listener = p2;
                        oboeBus(eventId).un(listener);
                    }
                    return oboeApi // chaining
                    ;
                };
                /**
   * Add a callback, wrapped in a try/catch so as to not break the
   * execution of Oboe if an exception is thrown (fail events are
   * fired instead)
   *
   * The callback is used as the listener id so that it can later be
   * removed using .un(callback)
   */ function addProtectedCallback(eventName, callback) {
                    oboeBus(eventName).on(protectedCallback(callback), callback);
                    return oboeApi // chaining
                    ;
                }
                /**
   * Add a callback where, if .forget() is called during the callback's
   * execution, the callback will be de-registered
   */ function addForgettableCallback(event, callback, listenerId) {
                    // listenerId is optional and if not given, the original
                    // callback will be used
                    listenerId = listenerId || callback;
                    var safeCallback = protectedCallback(callback);
                    event.on(function() {
                        var discard = false;
                        oboeApi.forget = function() {
                            discard = true;
                        };
                        Object(__WEBPACK_IMPORTED_MODULE_1__functional__["b" /* apply */ ])(arguments, safeCallback);
                        delete oboeApi.forget;
                        if (discard) event.un(listenerId);
                    }, listenerId);
                    return oboeApi // chaining
                    ;
                }
                /**
   *  wrap a callback so that if it throws, Oboe.js doesn't crash but instead
   *  throw the error in another event loop
   */ function protectedCallback(callback) {
                    return function() {
                        try {
                            return callback.apply(oboeApi, arguments);
                        } catch (e) {
                            setTimeout(function() {
                                throw new Error(e.message);
                            });
                        }
                    };
                }
                /**
   * Return the fully qualified event for when a pattern matches
   * either a node or a path
   *
   * @param type {String} either 'node' or 'path'
   */ function fullyQualifiedPatternMatchEvent(type, pattern) {
                    return oboeBus(type + ":" + pattern);
                }
                function wrapCallbackToSwapNodeIfSomethingReturned(callback) {
                    return function() {
                        var returnValueFromCallback = callback.apply(this, arguments);
                        if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["a" /* defined */ ])(returnValueFromCallback)) {
                            if (returnValueFromCallback === __WEBPACK_IMPORTED_MODULE_3__publicApi__["a" /* oboe */ ].drop) emitNodeDrop();
                            else emitNodeSwap(returnValueFromCallback);
                        }
                    };
                }
                function addSingleNodeOrPathListener(eventId, pattern, callback) {
                    var effectiveCallback;
                    if (eventId === "node") effectiveCallback = wrapCallbackToSwapNodeIfSomethingReturned(callback);
                    else effectiveCallback = callback;
                    addForgettableCallback(fullyQualifiedPatternMatchEvent(eventId, pattern), effectiveCallback, callback);
                }
                /**
   * Add several listeners at a time, from a map
   */ function addMultipleNodeOrPathListeners(eventId, listenerMap) {
                    for(var pattern in listenerMap)addSingleNodeOrPathListener(eventId, pattern, listenerMap[pattern]);
                }
                /**
   * implementation behind .onPath() and .onNode()
   */ function addNodeOrPathListenerApi(eventId, jsonPathOrListenerMap, callback) {
                    if (Object(__WEBPACK_IMPORTED_MODULE_2__util__["d" /* isString */ ])(jsonPathOrListenerMap)) addSingleNodeOrPathListener(eventId, jsonPathOrListenerMap, callback);
                    else addMultipleNodeOrPathListeners(eventId, jsonPathOrListenerMap);
                    return oboeApi // chaining
                    ;
                }
                // some interface methods are only filled in after we receive
                // values and are noops before that:
                oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["i" /* ROOT_PATH_FOUND */ ]).on(function(rootNode) {
                    oboeApi.root = Object(__WEBPACK_IMPORTED_MODULE_1__functional__["f" /* functor */ ])(rootNode);
                });
                /**
   * When content starts make the headers readable through the
   * instance API
   */ oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["c" /* HTTP_START */ ]).on(function(_statusCode, headers) {
                    oboeApi.header = function(name) {
                        return name ? headers[name] : headers;
                    };
                });
                /**
   * Construct and return the public API of the Oboe instance to be
   * returned to the calling application
   */ oboeApi = {
                    on: addListener,
                    addListener: addListener,
                    removeListener: removeListener,
                    emit: oboeBus.emit,
                    node: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addNodeOrPathListenerApi, "node"),
                    path: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addNodeOrPathListenerApi, "path"),
                    done: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addForgettableCallback, rootNodeFinishedEvent),
                    start: Object(__WEBPACK_IMPORTED_MODULE_1__functional__["j" /* partialComplete */ ])(addProtectedCallback, __WEBPACK_IMPORTED_MODULE_0__events__["c" /* HTTP_START */ ]),
                    // fail doesn't use protectedCallback because
                    // could lead to non-terminating loops
                    fail: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["b" /* FAIL_EVENT */ ]).on,
                    // public api calling abort fires the ABORTING event
                    abort: oboeBus(__WEBPACK_IMPORTED_MODULE_0__events__["a" /* ABORTING */ ]).emit,
                    // initially return nothing for header and root
                    header: __WEBPACK_IMPORTED_MODULE_1__functional__["i" /* noop */ ],
                    root: __WEBPACK_IMPORTED_MODULE_1__functional__["i" /* noop */ ],
                    source: contentSource
                };
                return oboeApi;
            }
        /***/ },
        /* 17 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return clarinet;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__events__ = __webpack_require__(3);
            /*
   This is a slightly hacked-up browser only version of clarinet

      *  some features removed to help keep browser Oboe under
         the 5k micro-library limit
      *  plug directly into event bus

   For the original go here:
      https://github.com/dscape/clarinet

   We receive the events:
      STREAM_DATA
      STREAM_END

   We emit the events:
      SAX_KEY
      SAX_VALUE_OPEN
      SAX_VALUE_CLOSE
      FAIL_EVENT
 */ function clarinet(eventBus) {
                "use strict";
                // shortcut some events on the bus
                var emitSaxKey = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["j" /* SAX_KEY */ ]).emit;
                var emitValueOpen = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["l" /* SAX_VALUE_OPEN */ ]).emit;
                var emitValueClose = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["k" /* SAX_VALUE_CLOSE */ ]).emit;
                var emitFail = eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["b" /* FAIL_EVENT */ ]).emit;
                var MAX_BUFFER_LENGTH = 65536;
                var stringTokenPattern = /[\\"\n]/g;
                var _n = 0;
                // states
                var BEGIN = _n++;
                var VALUE = _n++ // general stuff
                ;
                var OPEN_OBJECT = _n++ // {
                ;
                var CLOSE_OBJECT = _n++ // }
                ;
                var OPEN_ARRAY = _n++ // [
                ;
                var CLOSE_ARRAY = _n++ // ]
                ;
                var STRING = _n++ // ""
                ;
                var OPEN_KEY = _n++ // , "a"
                ;
                var CLOSE_KEY = _n++ // :
                ;
                var TRUE = _n++ // r
                ;
                var TRUE2 = _n++ // u
                ;
                var TRUE3 = _n++ // e
                ;
                var FALSE = _n++ // a
                ;
                var FALSE2 = _n++ // l
                ;
                var FALSE3 = _n++ // s
                ;
                var FALSE4 = _n++ // e
                ;
                var NULL = _n++ // u
                ;
                var NULL2 = _n++ // l
                ;
                var NULL3 = _n++ // l
                ;
                var NUMBER_DECIMAL_POINT = _n++ // .
                ;
                var NUMBER_DIGIT = _n // [0-9]
                ;
                // setup initial parser values
                var bufferCheckPosition = MAX_BUFFER_LENGTH;
                var latestError;
                var c;
                var p;
                var textNode;
                var numberNode = "";
                var slashed = false;
                var closed = false;
                var state = BEGIN;
                var stack = [];
                var unicodeS = null;
                var unicodeI = 0;
                var depth = 0;
                var position = 0;
                var column = 0 // mostly for error reporting
                ;
                var line = 1;
                function checkBufferLength() {
                    var maxActual = 0;
                    if (textNode !== undefined && textNode.length > MAX_BUFFER_LENGTH) {
                        emitError("Max buffer length exceeded: textNode");
                        maxActual = Math.max(maxActual, textNode.length);
                    }
                    if (numberNode.length > MAX_BUFFER_LENGTH) {
                        emitError("Max buffer length exceeded: numberNode");
                        maxActual = Math.max(maxActual, numberNode.length);
                    }
                    bufferCheckPosition = MAX_BUFFER_LENGTH - maxActual + position;
                }
                eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["m" /* STREAM_DATA */ ]).on(handleData);
                /* At the end of the http content close the clarinet
    This will provide an error if the total content provided was not
    valid json, ie if not all arrays, objects and Strings closed properly */ eventBus(__WEBPACK_IMPORTED_MODULE_0__events__["n" /* STREAM_END */ ]).on(handleStreamEnd);
                function emitError(errorString) {
                    if (textNode !== undefined) {
                        emitValueOpen(textNode);
                        emitValueClose();
                        textNode = undefined;
                    }
                    latestError = Error(errorString + "\nLn: " + line + "\nCol: " + column + "\nChr: " + c);
                    emitFail(Object(__WEBPACK_IMPORTED_MODULE_0__events__["o" /* errorReport */ ])(undefined, undefined, latestError));
                }
                function handleStreamEnd() {
                    if (state === BEGIN) {
                        // Handle the case where the stream closes without ever receiving
                        // any input. This isn't an error - response bodies can be blank,
                        // particularly for 204 http responses
                        // Because of how Oboe is currently implemented, we parse a
                        // completely empty stream as containing an empty object.
                        // This is because Oboe's done event is only fired when the
                        // root object of the JSON stream closes.
                        // This should be decoupled and attached instead to the input stream
                        // from the http (or whatever) resource ending.
                        // If this decoupling could happen the SAX parser could simply emit
                        // zero events on a completely empty input.
                        emitValueOpen({});
                        emitValueClose();
                        closed = true;
                        return;
                    }
                    if (state !== VALUE || depth !== 0) emitError("Unexpected end");
                    if (textNode !== undefined) {
                        emitValueOpen(textNode);
                        emitValueClose();
                        textNode = undefined;
                    }
                    closed = true;
                }
                function whitespace(c) {
                    return c === "\r" || c === "\n" || c === " " || c === "	";
                }
                function handleData(chunk) {
                    // this used to throw the error but inside Oboe we will have already
                    // gotten the error when it was emitted. The important thing is to
                    // not continue with the parse.
                    if (latestError) return;
                    if (closed) return emitError("Cannot write after close");
                    var i = 0;
                    c = chunk[0];
                    while(c){
                        if (i > 0) p = c;
                        c = chunk[i++];
                        if (!c) break;
                        position++;
                        if (c === "\n") {
                            line++;
                            column = 0;
                        } else column++;
                        switch(state){
                            case BEGIN:
                                if (c === "{") state = OPEN_OBJECT;
                                else if (c === "[") state = OPEN_ARRAY;
                                else if (!whitespace(c)) return emitError("Non-whitespace before {[.");
                                continue;
                            case OPEN_KEY:
                            case OPEN_OBJECT:
                                if (whitespace(c)) continue;
                                if (state === OPEN_KEY) stack.push(CLOSE_KEY);
                                else if (c === "}") {
                                    emitValueOpen({});
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                    continue;
                                } else stack.push(CLOSE_OBJECT);
                                if (c === '"') state = STRING;
                                else return emitError('Malformed object key should start with " ');
                                continue;
                            case CLOSE_KEY:
                            case CLOSE_OBJECT:
                                if (whitespace(c)) continue;
                                if (c === ":") {
                                    if (state === CLOSE_OBJECT) {
                                        stack.push(CLOSE_OBJECT);
                                        if (textNode !== undefined) {
                                            // was previously (in upstream Clarinet) one event
                                            //  - object open came with the text of the first
                                            emitValueOpen({});
                                            emitSaxKey(textNode);
                                            textNode = undefined;
                                        }
                                        depth++;
                                    } else if (textNode !== undefined) {
                                        emitSaxKey(textNode);
                                        textNode = undefined;
                                    }
                                    state = VALUE;
                                } else if (c === "}") {
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    emitValueClose();
                                    depth--;
                                    state = stack.pop() || VALUE;
                                } else if (c === ",") {
                                    if (state === CLOSE_OBJECT) stack.push(CLOSE_OBJECT);
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    state = OPEN_KEY;
                                } else return emitError("Bad object");
                                continue;
                            case OPEN_ARRAY:
                            case VALUE:
                                if (whitespace(c)) continue;
                                if (state === OPEN_ARRAY) {
                                    emitValueOpen([]);
                                    depth++;
                                    state = VALUE;
                                    if (c === "]") {
                                        emitValueClose();
                                        depth--;
                                        state = stack.pop() || VALUE;
                                        continue;
                                    } else stack.push(CLOSE_ARRAY);
                                }
                                if (c === '"') state = STRING;
                                else if (c === "{") state = OPEN_OBJECT;
                                else if (c === "[") state = OPEN_ARRAY;
                                else if (c === "t") state = TRUE;
                                else if (c === "f") state = FALSE;
                                else if (c === "n") state = NULL;
                                else if (c === "-") numberNode += c;
                                else if (c === "0") {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else if ("123456789".indexOf(c) !== -1) {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else return emitError("Bad value");
                                continue;
                            case CLOSE_ARRAY:
                                if (c === ",") {
                                    stack.push(CLOSE_ARRAY);
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    state = VALUE;
                                } else if (c === "]") {
                                    if (textNode !== undefined) {
                                        emitValueOpen(textNode);
                                        emitValueClose();
                                        textNode = undefined;
                                    }
                                    emitValueClose();
                                    depth--;
                                    state = stack.pop() || VALUE;
                                } else if (whitespace(c)) continue;
                                else return emitError("Bad array");
                                continue;
                            case STRING:
                                if (textNode === undefined) textNode = "";
                                // thanks thejh, this is an about 50% performance improvement.
                                var starti = i - 1;
                                // eslint-disable-next-line no-labels
                                STRING_BIGLOOP: while(true){
                                    // zero means "no unicode active". 1-4 mean "parse some more". end after 4.
                                    while(unicodeI > 0){
                                        unicodeS += c;
                                        c = chunk.charAt(i++);
                                        if (unicodeI === 4) {
                                            // TODO this might be slow? well, probably not used too often anyway
                                            textNode += String.fromCharCode(parseInt(unicodeS, 16));
                                            unicodeI = 0;
                                            starti = i - 1;
                                        } else unicodeI++;
                                        // we can just break here: no stuff we skipped that still has to be sliced out or so
                                        // eslint-disable-next-line no-labels
                                        if (!c) break STRING_BIGLOOP;
                                    }
                                    if (c === '"' && !slashed) {
                                        state = stack.pop() || VALUE;
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                    if (c === "\\" && !slashed) {
                                        slashed = true;
                                        textNode += chunk.substring(starti, i - 1);
                                        c = chunk.charAt(i++);
                                        if (!c) break;
                                    }
                                    if (slashed) {
                                        slashed = false;
                                        if (c === "n") textNode += "\n";
                                        else if (c === "r") textNode += "\r";
                                        else if (c === "t") textNode += "	";
                                        else if (c === "f") textNode += "\f";
                                        else if (c === "b") textNode += "\b";
                                        else if (c === "u") {
                                            // \uxxxx. meh!
                                            unicodeI = 1;
                                            unicodeS = "";
                                        } else textNode += c;
                                        c = chunk.charAt(i++);
                                        starti = i - 1;
                                        if (!c) break;
                                        else continue;
                                    }
                                    stringTokenPattern.lastIndex = i;
                                    var reResult = stringTokenPattern.exec(chunk);
                                    if (!reResult) {
                                        i = chunk.length + 1;
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                    i = reResult.index + 1;
                                    c = chunk.charAt(reResult.index);
                                    if (!c) {
                                        textNode += chunk.substring(starti, i - 1);
                                        break;
                                    }
                                }
                                continue;
                            case TRUE:
                                if (!c) continue; // strange buffers
                                if (c === "r") state = TRUE2;
                                else return emitError("Invalid true started with t" + c);
                                continue;
                            case TRUE2:
                                if (!c) continue;
                                if (c === "u") state = TRUE3;
                                else return emitError("Invalid true started with tr" + c);
                                continue;
                            case TRUE3:
                                if (!c) continue;
                                if (c === "e") {
                                    emitValueOpen(true);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError("Invalid true started with tru" + c);
                                continue;
                            case FALSE:
                                if (!c) continue;
                                if (c === "a") state = FALSE2;
                                else return emitError("Invalid false started with f" + c);
                                continue;
                            case FALSE2:
                                if (!c) continue;
                                if (c === "l") state = FALSE3;
                                else return emitError("Invalid false started with fa" + c);
                                continue;
                            case FALSE3:
                                if (!c) continue;
                                if (c === "s") state = FALSE4;
                                else return emitError("Invalid false started with fal" + c);
                                continue;
                            case FALSE4:
                                if (!c) continue;
                                if (c === "e") {
                                    emitValueOpen(false);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError("Invalid false started with fals" + c);
                                continue;
                            case NULL:
                                if (!c) continue;
                                if (c === "u") state = NULL2;
                                else return emitError("Invalid null started with n" + c);
                                continue;
                            case NULL2:
                                if (!c) continue;
                                if (c === "l") state = NULL3;
                                else return emitError("Invalid null started with nu" + c);
                                continue;
                            case NULL3:
                                if (!c) continue;
                                if (c === "l") {
                                    emitValueOpen(null);
                                    emitValueClose();
                                    state = stack.pop() || VALUE;
                                } else return emitError("Invalid null started with nul" + c);
                                continue;
                            case NUMBER_DECIMAL_POINT:
                                if (c === ".") {
                                    numberNode += c;
                                    state = NUMBER_DIGIT;
                                } else return emitError("Leading zero not followed by .");
                                continue;
                            case NUMBER_DIGIT:
                                if ("0123456789".indexOf(c) !== -1) numberNode += c;
                                else if (c === ".") {
                                    if (numberNode.indexOf(".") !== -1) return emitError("Invalid number has two dots");
                                    numberNode += c;
                                } else if (c === "e" || c === "E") {
                                    if (numberNode.indexOf("e") !== -1 || numberNode.indexOf("E") !== -1) return emitError("Invalid number has two exponential");
                                    numberNode += c;
                                } else if (c === "+" || c === "-") {
                                    if (!(p === "e" || p === "E")) return emitError("Invalid symbol in number");
                                    numberNode += c;
                                } else {
                                    if (numberNode) {
                                        emitValueOpen(parseFloat(numberNode));
                                        emitValueClose();
                                        numberNode = "";
                                    }
                                    i-- // go back one
                                    ;
                                    state = stack.pop() || VALUE;
                                }
                                continue;
                            default:
                                return emitError("Unknown state: " + state);
                        }
                    }
                    if (position >= bufferCheckPosition) checkBufferLength();
                }
            }
        /***/ },
        /* 18 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return httpTransport;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return streamingHttp;
            });
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__ = __webpack_require__(19);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__events__ = __webpack_require__(3);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util__ = __webpack_require__(2);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parseResponseHeaders_browser__ = __webpack_require__(20);
            /* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functional__ = __webpack_require__(0);
            function httpTransport() {
                return new XMLHttpRequest();
            }
            /**
 * A wrapper around the browser XmlHttpRequest object that raises an
 * event whenever a new part of the response is available.
 *
 * In older browsers progressive reading is impossible so all the
 * content is given in a single call. For newer ones several events
 * should be raised, allowing progressive interpretation of the response.
 *
 * @param {Function} oboeBus an event bus local to this Oboe instance
 * @param {XMLHttpRequest} xhr the xhr to use as the transport. Under normal
 *          operation, will have been created using httpTransport() above
 *          but for tests a stub can be provided instead.
 * @param {String} method one of 'GET' 'POST' 'PUT' 'PATCH' 'DELETE'
 * @param {String} url the url to make a request to
 * @param {String|Null} data some content to be sent with the request.
 *                      Only valid if method is POST or PUT.
 * @param {Object} [headers] the http request headers to send
 * @param {boolean} withCredentials the XHR withCredentials property will be
 *    set to this value
 */ function streamingHttp(oboeBus, xhr, method, url, data, headers, withCredentials) {
                "use strict";
                var emitStreamData = oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["m" /* STREAM_DATA */ ]).emit;
                var emitFail = oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["b" /* FAIL_EVENT */ ]).emit;
                var numberOfCharsAlreadyGivenToCallback = 0;
                var stillToSendStartEvent = true;
                // When an ABORTING message is put on the event bus abort
                // the ajax request
                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["a" /* ABORTING */ ]).on(function() {
                    // if we keep the onreadystatechange while aborting the XHR gives
                    // a callback like a successful call so first remove this listener
                    // by assigning null:
                    xhr.onreadystatechange = null;
                    xhr.abort();
                });
                /**
    * Handle input from the underlying xhr: either a state change,
    * the progress event or the request being complete.
    */ function handleProgress() {
                    if (String(xhr.status)[0] === "2") {
                        var textSoFar = xhr.responseText;
                        var newText = (" " + textSoFar.substr(numberOfCharsAlreadyGivenToCallback)).substr(1);
                        /* Raise the event for new text.

       On older browsers, the new text is the whole response.
       On newer/better ones, the fragment part that we got since
       last progress. */ if (newText) emitStreamData(newText);
                        numberOfCharsAlreadyGivenToCallback = Object(__WEBPACK_IMPORTED_MODULE_2__util__["e" /* len */ ])(textSoFar);
                    }
                }
                if ("onprogress" in xhr) xhr.onprogress = handleProgress;
                function sendStartIfNotAlready(xhr) {
                    // Internet Explorer is very unreliable as to when xhr.status etc can
                    // be read so has to be protected with try/catch and tried again on
                    // the next readyState if it fails
                    try {
                        stillToSendStartEvent && oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["c" /* HTTP_START */ ]).emit(xhr.status, Object(__WEBPACK_IMPORTED_MODULE_3__parseResponseHeaders_browser__["a" /* parseResponseHeaders */ ])(xhr.getAllResponseHeaders()));
                        stillToSendStartEvent = false;
                    } catch (e) {}
                }
                xhr.onreadystatechange = function() {
                    switch(xhr.readyState){
                        case 2:
                        case 3:
                            return sendStartIfNotAlready(xhr);
                        case 4:
                            sendStartIfNotAlready(xhr) // if xhr.status hasn't been available yet, it must be NOW, huh IE?
                            ;
                            // is this a 2xx http code?
                            var successful = String(xhr.status)[0] === "2";
                            if (successful) {
                                // In Chrome 29 (not 28) no onprogress is emitted when a response
                                // is complete before the onload. We need to always do handleInput
                                // in case we get the load but have not had a final progress event.
                                // This looks like a bug and may change in future but let's take
                                // the safest approach and assume we might not have received a
                                // progress event for each part of the response
                                handleProgress();
                                oboeBus(__WEBPACK_IMPORTED_MODULE_1__events__["n" /* STREAM_END */ ]).emit();
                            } else emitFail(Object(__WEBPACK_IMPORTED_MODULE_1__events__["o" /* errorReport */ ])(xhr.status, xhr.responseText));
                    }
                };
                try {
                    xhr.open(method, url, true);
                    for(var headerName in headers)xhr.setRequestHeader(headerName, headers[headerName]);
                    if (!Object(__WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__["a" /* isCrossOrigin */ ])(window.location, Object(__WEBPACK_IMPORTED_MODULE_0__detectCrossOrigin_browser__["b" /* parseUrlOrigin */ ])(url))) xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                    xhr.withCredentials = withCredentials;
                    xhr.send(data);
                } catch (e) {
                    // To keep a consistent interface with Node, we can't emit an event here.
                    // Node's streaming http adaptor receives the error as an asynchronous
                    // event rather than as an exception. If we emitted now, the Oboe user
                    // has had no chance to add a .fail listener so there is no way
                    // the event could be useful. For both these reasons defer the
                    // firing to the next JS frame.
                    window.setTimeout(Object(__WEBPACK_IMPORTED_MODULE_4__functional__["j" /* partialComplete */ ])(emitFail, Object(__WEBPACK_IMPORTED_MODULE_1__events__["o" /* errorReport */ ])(undefined, undefined, e)), 0);
                }
            }
        /***/ },
        /* 19 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return isCrossOrigin;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() {
                return parseUrlOrigin;
            });
            /**
 * Detect if a given URL is cross-origin in the scope of the
 * current page.
 *
 * Browser only (since cross-origin has no meaning in Node.js)
 *
 * @param {Object} pageLocation - as in window.location
 * @param {Object} ajaxHost - an object like window.location describing the
 *    origin of the url that we want to ajax in
 */ function isCrossOrigin(pageLocation, ajaxHost) {
                /*
    * NB: defaultPort only knows http and https.
    * Returns undefined otherwise.
    */ function defaultPort(protocol) {
                    return ({
                        "http:": 80,
                        "https:": 443
                    })[protocol];
                }
                function portOf(location) {
                    // pageLocation should always have a protocol. ajaxHost if no port or
                    // protocol is specified, should use the port of the containing page
                    return String(location.port || defaultPort(location.protocol || pageLocation.protocol));
                }
                // if ajaxHost doesn't give a domain, port is the same as pageLocation
                // it can't give a protocol but not a domain
                // it can't give a port but not a domain
                return !!(ajaxHost.protocol && ajaxHost.protocol !== pageLocation.protocol || ajaxHost.host && ajaxHost.host !== pageLocation.host || ajaxHost.host && portOf(ajaxHost) !== portOf(pageLocation));
            }
            /* turn any url into an object like window.location */ function parseUrlOrigin(url) {
                // url could be domain-relative
                // url could give a domain
                // cross origin means:
                //    same domain
                //    same port
                //    some protocol
                // so, same everything up to the first (single) slash
                // if such is given
                //
                // can ignore everything after that
                var URL_HOST_PATTERN = /(\w+:)?(?:\/\/)([\w.-]+)?(?::(\d+))?\/?/;
                // if no match, use an empty array so that
                // subexpressions 1,2,3 are all undefined
                // and will ultimately return all empty
                // strings as the parse result:
                var urlHostMatch = URL_HOST_PATTERN.exec(url) || [];
                return {
                    protocol: urlHostMatch[1] || "",
                    host: urlHostMatch[2] || "",
                    port: urlHostMatch[3] || ""
                };
            }
        /***/ },
        /* 20 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() {
                return parseResponseHeaders;
            });
            // based on gist https://gist.github.com/monsur/706839
            /**
 * XmlHttpRequest's getAllResponseHeaders() method returns a string of response
 * headers according to the format described here:
 * http://www.w3.org/TR/XMLHttpRequest/#the-getallresponseheaders-method
 * This method parses that string into a user-friendly key/value pair object.
 */ function parseResponseHeaders(headerStr) {
                var headers = {};
                headerStr && headerStr.split("\r\n").forEach(function(headerPair) {
                    // Can't use split() here because it does the wrong thing
                    // if the header value has the string ": " in it.
                    var index = headerPair.indexOf(": ");
                    headers[headerPair.substring(0, index)] = headerPair.substring(index + 2);
                });
                return headers;
            }
        /***/ }
    ])["default"];
});

});


parcelRegister("cgUd1", function(module, exports) {
"use strict";
/** Highest positive signed 32-bit float value */ const $8ef294a097b4d38a$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $8ef294a097b4d38a$var$base = 36;
const $8ef294a097b4d38a$var$tMin = 1;
const $8ef294a097b4d38a$var$tMax = 26;
const $8ef294a097b4d38a$var$skew = 38;
const $8ef294a097b4d38a$var$damp = 700;
const $8ef294a097b4d38a$var$initialBias = 72;
const $8ef294a097b4d38a$var$initialN = 128; // 0x80
const $8ef294a097b4d38a$var$delimiter = "-"; // '\x2D'
/** Regular expressions */ const $8ef294a097b4d38a$var$regexPunycode = /^xn--/;
const $8ef294a097b4d38a$var$regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
const $8ef294a097b4d38a$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $8ef294a097b4d38a$var$errors = {
    "overflow": "Overflow: input needs wider integers to process",
    "not-basic": "Illegal input >= 0x80 (not a basic code point)",
    "invalid-input": "Invalid input"
};
/** Convenience shortcuts */ const $8ef294a097b4d38a$var$baseMinusTMin = $8ef294a097b4d38a$var$base - $8ef294a097b4d38a$var$tMin;
const $8ef294a097b4d38a$var$floor = Math.floor;
const $8ef294a097b4d38a$var$stringFromCharCode = String.fromCharCode;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function $8ef294a097b4d38a$var$error(type) {
    throw new RangeError($8ef294a097b4d38a$var$errors[type]);
}
/**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function $8ef294a097b4d38a$var$map(array, fn) {
    const result = [];
    let length = array.length;
    while(length--)result[length] = fn(array[length]);
    return result;
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function $8ef294a097b4d38a$var$mapDomain(string, fn) {
    const parts = string.split("@");
    let result = "";
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + "@";
        string = parts[1];
    }
    // Avoid `split(regex)` for IE8 compatibility. See #17.
    string = string.replace($8ef294a097b4d38a$var$regexSeparators, ".");
    const labels = string.split(".");
    const encoded = $8ef294a097b4d38a$var$map(labels, fn).join(".");
    return result + encoded;
}
/**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function $8ef294a097b4d38a$var$ucs2decode(string) {
    const output = [];
    let counter = 0;
    const length = string.length;
    while(counter < length){
        const value = string.charCodeAt(counter++);
        if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
            // It's a high surrogate, and there is a next character.
            const extra = string.charCodeAt(counter++);
            if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
            else {
                // It's an unmatched surrogate; only append this code unit, in case the
                // next code unit is the high surrogate of a surrogate pair.
                output.push(value);
                counter--;
            }
        } else output.push(value);
    }
    return output;
}
/**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ const $8ef294a097b4d38a$var$ucs2encode = (array)=>String.fromCodePoint(...array);
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ const $8ef294a097b4d38a$var$basicToDigit = function(codePoint) {
    if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
    if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
    if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
    return $8ef294a097b4d38a$var$base;
};
/**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ const $8ef294a097b4d38a$var$digitToBasic = function(digit, flag) {
    //  0..25 map to ASCII a..z or A..Z
    // 26..35 map to ASCII 0..9
    return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
};
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ const $8ef294a097b4d38a$var$adapt = function(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? $8ef294a097b4d38a$var$floor(delta / $8ef294a097b4d38a$var$damp) : delta >> 1;
    delta += $8ef294a097b4d38a$var$floor(delta / numPoints);
    for(; delta > $8ef294a097b4d38a$var$baseMinusTMin * $8ef294a097b4d38a$var$tMax >> 1; k += $8ef294a097b4d38a$var$base)delta = $8ef294a097b4d38a$var$floor(delta / $8ef294a097b4d38a$var$baseMinusTMin);
    return $8ef294a097b4d38a$var$floor(k + ($8ef294a097b4d38a$var$baseMinusTMin + 1) * delta / (delta + $8ef294a097b4d38a$var$skew));
};
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ const $8ef294a097b4d38a$var$decode = function(input) {
    // Don't use UCS-2.
    const output = [];
    const inputLength = input.length;
    let i = 0;
    let n = $8ef294a097b4d38a$var$initialN;
    let bias = $8ef294a097b4d38a$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($8ef294a097b4d38a$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $8ef294a097b4d38a$var$error("not-basic");
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $8ef294a097b4d38a$var$base;; k += $8ef294a097b4d38a$var$base){
            if (index >= inputLength) $8ef294a097b4d38a$var$error("invalid-input");
            const digit = $8ef294a097b4d38a$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $8ef294a097b4d38a$var$base || digit > $8ef294a097b4d38a$var$floor(($8ef294a097b4d38a$var$maxInt - i) / w)) $8ef294a097b4d38a$var$error("overflow");
            i += digit * w;
            const t = k <= bias ? $8ef294a097b4d38a$var$tMin : k >= bias + $8ef294a097b4d38a$var$tMax ? $8ef294a097b4d38a$var$tMax : k - bias;
            if (digit < t) break;
            const baseMinusT = $8ef294a097b4d38a$var$base - t;
            if (w > $8ef294a097b4d38a$var$floor($8ef294a097b4d38a$var$maxInt / baseMinusT)) $8ef294a097b4d38a$var$error("overflow");
            w *= baseMinusT;
        }
        const out = output.length + 1;
        bias = $8ef294a097b4d38a$var$adapt(i - oldi, out, oldi == 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if ($8ef294a097b4d38a$var$floor(i / out) > $8ef294a097b4d38a$var$maxInt - n) $8ef294a097b4d38a$var$error("overflow");
        n += $8ef294a097b4d38a$var$floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
};
/**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ const $8ef294a097b4d38a$var$encode = function(input) {
    const output = [];
    // Convert the input in UCS-2 to an array of Unicode code points.
    input = $8ef294a097b4d38a$var$ucs2decode(input);
    // Cache the length.
    let inputLength = input.length;
    // Initialize the state.
    let n = $8ef294a097b4d38a$var$initialN;
    let delta = 0;
    let bias = $8ef294a097b4d38a$var$initialBias;
    // Handle the basic code points.
    for (const currentValue of input)if (currentValue < 0x80) output.push($8ef294a097b4d38a$var$stringFromCharCode(currentValue));
    let basicLength = output.length;
    let handledCPCount = basicLength;
    // `handledCPCount` is the number of code points that have been handled;
    // `basicLength` is the number of basic code points.
    // Finish the basic string with a delimiter unless it's empty.
    if (basicLength) output.push($8ef294a097b4d38a$var$delimiter);
    // Main encoding loop:
    while(handledCPCount < inputLength){
        // All non-basic code points < n have been handled already. Find the next
        // larger one:
        let m = $8ef294a097b4d38a$var$maxInt;
        for (const currentValue of input)if (currentValue >= n && currentValue < m) m = currentValue;
        // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
        // but guard against overflow.
        const handledCPCountPlusOne = handledCPCount + 1;
        if (m - n > $8ef294a097b4d38a$var$floor(($8ef294a097b4d38a$var$maxInt - delta) / handledCPCountPlusOne)) $8ef294a097b4d38a$var$error("overflow");
        delta += (m - n) * handledCPCountPlusOne;
        n = m;
        for (const currentValue of input){
            if (currentValue < n && ++delta > $8ef294a097b4d38a$var$maxInt) $8ef294a097b4d38a$var$error("overflow");
            if (currentValue == n) {
                // Represent delta as a generalized variable-length integer.
                let q = delta;
                for(let k = $8ef294a097b4d38a$var$base;; k += $8ef294a097b4d38a$var$base){
                    const t = k <= bias ? $8ef294a097b4d38a$var$tMin : k >= bias + $8ef294a097b4d38a$var$tMax ? $8ef294a097b4d38a$var$tMax : k - bias;
                    if (q < t) break;
                    const qMinusT = q - t;
                    const baseMinusT = $8ef294a097b4d38a$var$base - t;
                    output.push($8ef294a097b4d38a$var$stringFromCharCode($8ef294a097b4d38a$var$digitToBasic(t + qMinusT % baseMinusT, 0)));
                    q = $8ef294a097b4d38a$var$floor(qMinusT / baseMinusT);
                }
                output.push($8ef294a097b4d38a$var$stringFromCharCode($8ef294a097b4d38a$var$digitToBasic(q, 0)));
                bias = $8ef294a097b4d38a$var$adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                delta = 0;
                ++handledCPCount;
            }
        }
        ++delta;
        ++n;
    }
    return output.join("");
};
/**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ const $8ef294a097b4d38a$var$toUnicode = function(input) {
    return $8ef294a097b4d38a$var$mapDomain(input, function(string) {
        return $8ef294a097b4d38a$var$regexPunycode.test(string) ? $8ef294a097b4d38a$var$decode(string.slice(4).toLowerCase()) : string;
    });
};
/**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ const $8ef294a097b4d38a$var$toASCII = function(input) {
    return $8ef294a097b4d38a$var$mapDomain(input, function(string) {
        return $8ef294a097b4d38a$var$regexNonASCII.test(string) ? "xn--" + $8ef294a097b4d38a$var$encode(string) : string;
    });
};
/*--------------------------------------------------------------------------*/ /** Define the public API */ const $8ef294a097b4d38a$var$punycode = {
    /**
	 * A string representing the current Punycode.js version number.
	 * @memberOf punycode
	 * @type String
	 */ "version": "2.1.0",
    /**
	 * An object of methods to convert from JavaScript's internal character
	 * representation (UCS-2) to Unicode code points, and back.
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode
	 * @type Object
	 */ "ucs2": {
        "decode": $8ef294a097b4d38a$var$ucs2decode,
        "encode": $8ef294a097b4d38a$var$ucs2encode
    },
    "decode": $8ef294a097b4d38a$var$decode,
    "encode": $8ef294a097b4d38a$var$encode,
    "toASCII": $8ef294a097b4d38a$var$toASCII,
    "toUnicode": $8ef294a097b4d38a$var$toUnicode
};
module.exports = $8ef294a097b4d38a$var$punycode;

});

parcelRegister("drBoY", function(module, exports) {
/* This file is generated from the Unicode IDNA table, using
   the build-unicode-tables.py script. Please edit that
   script instead of this file. */ /* istanbul ignore next */ (function(root, factory) {
    if (typeof define === "function" && define.amd) define([], function() {
        return factory();
    });
    else module.exports = factory();
})(module.exports, function() {
    var blocks = [
        new Uint32Array([
            2157250,
            2157314,
            2157378,
            2157442,
            2157506,
            2157570,
            2157634,
            0,
            2157698,
            2157762,
            2157826,
            2157890,
            2157954,
            0,
            2158018,
            0
        ]),
        new Uint32Array([
            2179041,
            6291456,
            2179073,
            6291456,
            2179105,
            6291456,
            2179137,
            6291456,
            2179169,
            6291456,
            2179201,
            6291456,
            2179233,
            6291456,
            2179265,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            0,
            2113729,
            2197345,
            2197377,
            2113825,
            2197409,
            2197441,
            2113921,
            2197473,
            2114017,
            2197505,
            2197537,
            2197569,
            2197601,
            2197633,
            2197665
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            14680064,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064
        ]),
        new Uint32Array([
            2196001,
            2196033,
            2196065,
            2196097,
            2196129,
            2196161,
            2196193,
            2196225,
            2196257,
            2196289,
            2196321,
            2196353,
            2196385,
            2196417,
            2196449,
            2196481
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097281,
            2105921,
            2097729,
            2106081,
            0,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            2105889,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2177025,
            6291456,
            2177057,
            6291456,
            2177089,
            6291456,
            2177121,
            6291456,
            2177153,
            6291456,
            2177185,
            6291456,
            2177217,
            6291456,
            2177249,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2134435,
            2134531,
            2134627,
            2134723,
            2134723,
            2134819,
            2134819,
            2134915,
            2134915,
            2135011,
            2105987,
            2135107,
            2135203,
            2135299,
            2131587,
            2135395
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            2168673,
            2169249,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2147906,
            2147970,
            2148034,
            2148098,
            2148162,
            2148226,
            2148290,
            2148354,
            2147906,
            2147970,
            2148034,
            2148098,
            2148162,
            2148226,
            2148290,
            2148354
        ]),
        new Uint32Array([
            2125219,
            2125315,
            2152834,
            2152898,
            2125411,
            2152962,
            2153026,
            2125506,
            2125507,
            2125603,
            2153090,
            2153154,
            2153218,
            2153282,
            2153346,
            2105348
        ]),
        new Uint32Array([
            2203393,
            6291456,
            2203425,
            6291456,
            2203457,
            6291456,
            2203489,
            6291456,
            6291456,
            6291456,
            6291456,
            2203521,
            6291456,
            2181281,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            2145538,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2139426,
            2160834,
            2160898,
            2160962,
            2134242,
            2161026,
            2161090,
            2161154,
            2161218,
            2161282,
            2161346,
            2161410,
            2138658,
            2161474,
            2161538,
            2134722
        ]),
        new Uint32Array([
            2119939,
            2124930,
            2125026,
            2106658,
            2125218,
            2128962,
            2129058,
            2129154,
            2129250,
            2129346,
            2129442,
            2108866,
            2108770,
            2150466,
            2150530,
            2150594
        ]),
        new Uint32Array([
            2201601,
            6291456,
            2201633,
            6291456,
            2201665,
            6291456,
            2201697,
            6291456,
            2201729,
            6291456,
            2201761,
            6291456,
            2201793,
            6291456,
            2201825,
            6291456
        ]),
        new Uint32Array([
            2193537,
            2193569,
            2193601,
            2193633,
            2193665,
            2193697,
            2193729,
            2193761,
            2193793,
            2193825,
            2193857,
            2193889,
            2193921,
            2193953,
            2193985,
            2194017
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2190561,
            6291456,
            2190593,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2190625,
            6291456,
            2190657,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2215905,
            2215937,
            2215969,
            2216001,
            2216033,
            2216065,
            2216097,
            2216129,
            2216161,
            2216193,
            2216225,
            2216257,
            2105441,
            2216289,
            2216321,
            2216353
        ]),
        new Uint32Array([
            23068672,
            18884130,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2191233,
            2191265,
            2191297,
            2191329,
            2191361,
            2191393,
            2191425,
            2117377,
            2191457,
            2191489,
            2191521,
            2191553,
            2191585,
            2191617,
            2191649,
            2117953
        ]),
        new Uint32Array([
            2132227,
            2132323,
            2132419,
            2132419,
            2132515,
            2132515,
            2132611,
            2132707,
            2132707,
            2132803,
            2132899,
            2132899,
            2132995,
            2132995,
            2133091,
            2133187
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            10609889,
            10610785,
            10609921,
            10610817,
            2222241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2219969,
            2157121,
            2157441,
            2157505,
            2157889,
            2157953,
            2220001,
            2158465,
            2158529,
            10575617,
            2156994,
            2157058,
            2129923,
            2130019,
            2157122,
            2157186
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2185249,
            6291456,
            2185281,
            6291456,
            2185313,
            6291456,
            2185345,
            6291456,
            2185377,
            6291456,
            2185409,
            6291456,
            2185441,
            6291456,
            2185473,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            6291456,
            0
        ]),
        new Uint32Array([
            2183361,
            6291456,
            2183393,
            6291456,
            2183425,
            6291456,
            2183457,
            6291456,
            2183489,
            6291456,
            2183521,
            6291456,
            2183553,
            6291456,
            2183585,
            6291456
        ]),
        new Uint32Array([
            2192161,
            2192193,
            2192225,
            2192257,
            2192289,
            2192321,
            2192353,
            2192385,
            2192417,
            2192449,
            2192481,
            2192513,
            2192545,
            2192577,
            2192609,
            2192641
        ]),
        new Uint32Array([
            2212001,
            2212033,
            2212065,
            2212097,
            2212129,
            2212161,
            2212193,
            2212225,
            2212257,
            2212289,
            2212321,
            2212353,
            2212385,
            2212417,
            2212449,
            2207265
        ]),
        new Uint32Array([
            2249825,
            2249857,
            2249889,
            2249921,
            2249954,
            2250018,
            2250082,
            2250145,
            2250177,
            2250209,
            2250241,
            2250274,
            2250337,
            2250370,
            2250433,
            2250465
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2147905,
            2147969,
            2148033,
            2148097,
            2148161,
            2148225,
            2148289,
            2148353
        ]),
        new Uint32Array([
            10485857,
            6291456,
            2197217,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2180353,
            2180385,
            2144033,
            2180417,
            2180449,
            2180481,
            2180513,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            10610209,
            10610465,
            10610241,
            10610753,
            10609857
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2223842,
            2223906,
            2223970,
            2224034,
            2224098,
            2224162,
            2224226,
            2224290,
            2224354,
            2224418,
            2224482,
            2224546,
            2224610,
            2224674,
            2224738,
            2224802
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            18923650,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            18923714,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2126179,
            2125538,
            2126275,
            2126371,
            2126467,
            2125634,
            2126563,
            2105603,
            2105604,
            2125346,
            2126659,
            2126755,
            2126851,
            2098179,
            2098181,
            2098182
        ]),
        new Uint32Array([
            2227426,
            2227490,
            2227554,
            2227618,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2192353,
            2240642,
            2240642,
            2240705,
            2240737,
            2240737,
            2240769,
            2240802,
            2240866,
            2240929,
            2240961,
            2240993,
            2241025,
            2241057,
            2241089,
            2241121
        ]),
        new Uint32Array([
            6291456,
            2170881,
            2170913,
            2170945,
            6291456,
            2170977,
            6291456,
            2171009,
            2171041,
            6291456,
            6291456,
            6291456,
            2171073,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2132226,
            2132514,
            2163586,
            2132610,
            2160386,
            2133090,
            2133186,
            2160450,
            2160514,
            2160578,
            2133570,
            2106178,
            2160642,
            2133858,
            2160706,
            2160770
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10532162,
            10532226,
            10532290,
            10532354,
            10532418,
            10532482,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2098209,
            2108353,
            2108193,
            2108481,
            2170241,
            2111713,
            2105473,
            2105569,
            2105601,
            2112289,
            2112481,
            2098305,
            2108321,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2209121,
            2209153,
            2209185,
            2209217,
            2209249,
            2209281,
            2209313,
            2209345,
            2209377,
            2209409,
            2209441,
            2209473,
            2207265,
            2209505,
            2209537,
            2209569
        ]),
        new Uint32Array([
            2189025,
            6291456,
            2189057,
            6291456,
            2189089,
            6291456,
            2189121,
            6291456,
            2189153,
            6291456,
            2189185,
            6291456,
            2189217,
            6291456,
            2189249,
            6291456
        ]),
        new Uint32Array([
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2165764,
            2140004
        ]),
        new Uint32Array([
            2215105,
            6291456,
            2215137,
            6291456,
            6291456,
            2215169,
            2215201,
            6291456,
            6291456,
            6291456,
            2215233,
            2215265,
            2215297,
            2215329,
            2215361,
            2215393
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            10505091,
            10505187,
            10505283,
            10505379,
            10505475,
            10505571,
            10505667,
            10505763,
            10505859,
            10505955,
            10506051,
            10506147,
            10506243,
            10506339,
            10506435,
            10506531
        ]),
        new Uint32Array([
            2229730,
            2229794,
            2229858,
            2229922,
            2229986,
            2230050,
            2230114,
            2230178,
            2230242,
            2230306,
            2230370,
            2230434,
            2230498,
            2230562,
            2230626,
            2230690
        ]),
        new Uint32Array([
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            0,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            10502115,
            10502178,
            10502211,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2190305,
            6291456,
            2190337,
            6291456,
            2190369,
            6291456,
            2190401,
            6291456,
            2190433,
            6291456,
            2190465,
            6291456,
            2190497,
            6291456,
            2190529,
            6291456
        ]),
        new Uint32Array([
            2173793,
            2173985,
            2174017,
            6291456,
            2173761,
            2173697,
            6291456,
            2174689,
            6291456,
            2174017,
            2174721,
            6291456,
            6291456,
            2174753,
            2174785,
            2174817
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2099521,
            2099105,
            2120705,
            2098369,
            2120801,
            2103361,
            2097985,
            2098433,
            2121377,
            2121473,
            2099169,
            2099873,
            2098401,
            2099393,
            2152609,
            2100033
        ]),
        new Uint32Array([
            2132898,
            2163842,
            2163906,
            2133282,
            2132034,
            2131938,
            2137410,
            2132802,
            2132706,
            2164866,
            2133282,
            2160578,
            2165186,
            2165186,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10500003,
            10500099,
            10500195,
            10500291,
            10500387,
            10500483,
            10500579,
            10500675,
            10500771,
            10500867,
            10500963,
            10501059,
            10501155,
            10501251,
            10501347,
            10501443
        ]),
        new Uint32Array([
            2163458,
            2130978,
            2131074,
            2131266,
            2131362,
            2163522,
            2160130,
            2132066,
            2131010,
            2131106,
            2106018,
            2131618,
            2131298,
            2132034,
            2131938,
            2137410
        ]),
        new Uint32Array([
            2212961,
            2116993,
            2212993,
            2213025,
            2213057,
            2213089,
            2213121,
            2213153,
            2213185,
            2213217,
            2213249,
            2209633,
            2213281,
            2213313,
            2213345,
            2213377
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2113729,
            2113825,
            2113921,
            2114017,
            2114113,
            2114209,
            2114305,
            2114401,
            2114497,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            2115073,
            2115169
        ]),
        new Uint32Array([
            2238177,
            2238209,
            2238241,
            2238273,
            2238305,
            2238337,
            2238337,
            2217537,
            2238369,
            2238401,
            2238433,
            2238465,
            2215649,
            2238497,
            2238529,
            2238561
        ]),
        new Uint32Array([
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            2145026,
            0,
            6291456,
            2145090,
            0,
            6291456,
            6291456,
            0,
            0,
            23068672,
            0,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2099233,
            2122017,
            2200673,
            2098113,
            2121537,
            2103201,
            2200705,
            2104033,
            2121857,
            2121953,
            2122401,
            2099649,
            2099969,
            2123009,
            2100129,
            2100289
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2187681,
            2187713,
            2187745,
            2187777,
            2187809,
            2187841,
            2187873,
            2187905,
            2187937,
            2187969,
            2188001,
            2188033,
            2188065,
            2188097,
            2188129,
            2188161
        ]),
        new Uint32Array([
            0,
            10554498,
            10554562,
            10554626,
            10554690,
            10554754,
            10554818,
            10554882,
            10554946,
            10555010,
            10555074,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2235170,
            2235234,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2181153,
            6291456,
            2188897,
            6291456,
            6291456,
            2188929,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2111905,
            2100865,
            2188961,
            2188993
        ]),
        new Uint32Array([
            2100833,
            2100897,
            0,
            0,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10575617,
            2187041,
            10502177,
            10489601,
            10489697,
            2112289
        ]),
        new Uint32Array([
            6291456,
            2172833,
            6291456,
            2172865,
            2172897,
            2172929,
            2172961,
            6291456,
            2172993,
            6291456,
            2173025,
            6291456,
            2173057,
            6291456,
            2173089,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2190721
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184993,
            6291456,
            2185025,
            6291456,
            2185057,
            6291456,
            2185089,
            6291456,
            2185121,
            6291456,
            2185153,
            6291456,
            2185185,
            6291456,
            2185217,
            6291456
        ]),
        new Uint32Array([
            2115265,
            2115361,
            2115457,
            2115553,
            2115649,
            2115745,
            2115841,
            2115937,
            2116033,
            2116129,
            2116225,
            2116321,
            2150658,
            2150722,
            2200225,
            6291456
        ]),
        new Uint32Array([
            2168321,
            6291456,
            2168353,
            6291456,
            2168385,
            6291456,
            2168417,
            6291456,
            2168449,
            6291456,
            2168481,
            6291456,
            2168513,
            6291456,
            2168545,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2186625,
            0,
            0,
            6291456,
            6291456,
            2186657,
            2186689,
            2186721,
            2173505,
            0,
            10496067,
            10496163,
            10496259
        ]),
        new Uint32Array([
            2178785,
            6291456,
            2178817,
            6291456,
            2178849,
            6291456,
            2178881,
            6291456,
            2178913,
            6291456,
            2178945,
            6291456,
            2178977,
            6291456,
            2179009,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097152,
            0,
            0,
            0,
            2097152,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            2197857,
            2197889,
            2197921,
            2197953,
            2197985,
            2198017,
            0,
            0,
            2198049,
            2198081,
            2198113,
            2198145,
            2198177,
            2198209
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2098209,
            2167297,
            2111137,
            6291456
        ]),
        new Uint32Array([
            2171393,
            6291456,
            2171425,
            6291456,
            2171457,
            6291456,
            2171489,
            6291456,
            2171521,
            6291456,
            2171553,
            6291456,
            2171585,
            6291456,
            2171617,
            6291456
        ]),
        new Uint32Array([
            2206753,
            2206785,
            2195457,
            2206817,
            2206849,
            2206881,
            2206913,
            2197153,
            2197153,
            2206945,
            2117857,
            2206977,
            2207009,
            2207041,
            2207073,
            2207105
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            2144834,
            2144898,
            0,
            2144962
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            0,
            2105505,
            2098241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2202049,
            6291456,
            2202081,
            6291456,
            2202113,
            6291456,
            2202145,
            6291456,
            2202177,
            6291456,
            2202209,
            6291456,
            2202241,
            6291456
        ]),
        new Uint32Array([
            10501155,
            10501251,
            10501347,
            10501443,
            10501539,
            10501635,
            10501731,
            10501827,
            10501923,
            10502019,
            2141731,
            2105505,
            2098177,
            2155586,
            2166530,
            0
        ]),
        new Uint32Array([
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441
        ]),
        new Uint32Array([
            2146882,
            2146946,
            2147010,
            2147074,
            2147138,
            2147202,
            2147266,
            2147330,
            2146882,
            2146946,
            2147010,
            2147074,
            2147138,
            2147202,
            2147266,
            2147330
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            10502307,
            10502403,
            10502499,
            10502595,
            10502691,
            10502787,
            10502883,
            10502979,
            10503075,
            10503171,
            10503267,
            10503363,
            10503459,
            10503555,
            10503651,
            10503747
        ]),
        new Uint32Array([
            2179937,
            2179969,
            2180001,
            2180033,
            2156545,
            2180065,
            2156577,
            2180097,
            2180129,
            2180161,
            2180193,
            2180225,
            2180257,
            2180289,
            2156737,
            2180321
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0
        ]),
        new Uint32Array([
            2227682,
            2227746,
            2227810,
            2227874,
            2227938,
            2228002,
            2228066,
            2228130,
            2228194,
            2228258,
            2228322,
            2228386,
            2228450,
            2228514,
            2228578,
            2228642
        ]),
        new Uint32Array([
            2105601,
            2169121,
            2108193,
            2170049,
            2181025,
            2181057,
            2112481,
            2108321,
            2108289,
            2181089,
            2170497,
            2100865,
            2181121,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2180641,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2178273,
            6291456,
            2178305,
            6291456,
            2178337,
            6291456,
            2178369,
            6291456,
            2178401,
            6291456,
            2178433,
            6291456,
            2178465,
            6291456,
            2178497,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            2237377,
            2237409,
            2236225,
            2237441,
            2237473,
            2217441,
            2215521,
            2215553,
            2217473,
            2237505,
            2237537,
            2209697,
            2237569,
            2215585,
            2237601,
            2237633
        ]),
        new Uint32Array([
            2221985,
            2165601,
            2165601,
            2165665,
            2165665,
            2222017,
            2222017,
            2165729,
            2165729,
            2158913,
            2158913,
            2158913,
            2158913,
            2097281,
            2097281,
            2105921
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2149634,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2176897,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            2176929,
            6291456,
            2176961,
            6291456,
            2176993,
            6291456
        ]),
        new Uint32Array([
            2172641,
            6291456,
            2172673,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2172705,
            2172737,
            6291456,
            2172769,
            2172801,
            6291456
        ]),
        new Uint32Array([
            2099173,
            2104196,
            2121667,
            2099395,
            2121763,
            2152258,
            2152322,
            2098946,
            2152386,
            2121859,
            2121955,
            2099333,
            2122051,
            2104324,
            2099493,
            2122147
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2145794,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            2145858,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            0
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            0,
            2097377,
            0,
            0,
            2106017,
            0,
            2097505,
            2105889,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2239074,
            2239138,
            2239201,
            2239233,
            2239265,
            2239297,
            2239329,
            2239361,
            0,
            2239393,
            2239425,
            2239425,
            2239458,
            2239521,
            2239553,
            2209569
        ]),
        new Uint32Array([
            14680064,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2108321,
            2108289,
            2113153,
            2098209,
            2180897,
            2180929,
            2180961,
            2111137,
            2098241,
            2108353,
            2170241,
            2170273,
            2180993,
            2105825,
            6291456,
            2105473
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146114,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2105921,
            2105921,
            2105921,
            2222049,
            2222049,
            2130977,
            2130977,
            2130977,
            2130977,
            2160065,
            2160065,
            2160065,
            2160065,
            2097729,
            2097729,
            2097729
        ]),
        new Uint32Array([
            2218145,
            2214785,
            2207937,
            2218177,
            2218209,
            2192993,
            2210113,
            2212769,
            2218241,
            2218273,
            2216129,
            2218305,
            2216161,
            2218337,
            2218369,
            2218401
        ]),
        new Uint32Array([
            0,
            0,
            0,
            2156546,
            2156610,
            2156674,
            2156738,
            2156802,
            0,
            0,
            0,
            0,
            0,
            2156866,
            23068672,
            2156930
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2213409,
            2213441,
            2213473,
            2213505,
            2213537,
            2213569,
            2213601,
            2213633,
            2213665,
            2195681,
            2213697,
            2213729,
            2213761,
            2213793,
            2213825,
            2213857
        ]),
        new Uint32Array([
            2100033,
            2099233,
            2122017,
            2200673,
            2098113,
            2121537,
            2103201,
            2200705,
            2104033,
            2121857,
            2121953,
            2122401,
            2099649,
            2099969,
            2123009,
            2100129
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2201857,
            6291456,
            2201889,
            6291456,
            2201921,
            6291456,
            2201953,
            6291456,
            2201985,
            6291456,
            2202017,
            6291456,
            2176193,
            2176257,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2188193,
            2188225,
            2188257,
            2188289,
            2188321,
            2188353,
            2188385,
            2188417,
            2188449,
            2188481,
            2188513,
            2188545,
            2188577,
            2188609,
            2188641,
            0
        ]),
        new Uint32Array([
            10554529,
            2221089,
            0,
            10502113,
            10562017,
            10537921,
            10538049,
            2221121,
            2221153,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2213889,
            2213921,
            2213953,
            2213985,
            2214017,
            2214049,
            2214081,
            2194177,
            2214113,
            2214145,
            2214177,
            2214209,
            2214241,
            2214273,
            2214305,
            2214337
        ]),
        new Uint32Array([
            2166978,
            2167042,
            2099169,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2180545,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10518915,
            10519011,
            10519107,
            10519203,
            2162242,
            2162306,
            2159554,
            2162370,
            2159362,
            2159618,
            2105922,
            2162434,
            2159746,
            2162498,
            2159810,
            2159874
        ]),
        new Uint32Array([
            2161730,
            2161794,
            2135586,
            2161858,
            2161922,
            2137186,
            2131810,
            2160290,
            2135170,
            2161986,
            2137954,
            2162050,
            2162114,
            2162178,
            10518723,
            10518819
        ]),
        new Uint32Array([
            10506627,
            10506723,
            10506819,
            10506915,
            10507011,
            10507107,
            10507203,
            10507299,
            10507395,
            10507491,
            10507587,
            10507683,
            10507779,
            10507875,
            10507971,
            10508067
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2175873,
            2175905,
            2175937,
            2175969,
            2176001,
            2176033,
            2176065,
            2176097,
            2176129,
            2176161,
            2176193,
            2176225,
            2176257,
            2176289,
            2176321,
            2176353
        ]),
        new Uint32Array([
            2140006,
            2140198,
            2140390,
            2140582,
            2140774,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241
        ]),
        new Uint32Array([
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2145154,
            2145218,
            2145282,
            6291456,
            0,
            2145346,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            10531458,
            10495395,
            2148545,
            2143201,
            2173473,
            2148865,
            2173505,
            0,
            2173537,
            0,
            2173569,
            2149121
        ]),
        new Uint32Array([
            10537282,
            10495683,
            2148738,
            2148802,
            2148866,
            0,
            6291456,
            2148930,
            2186593,
            2173473,
            2148737,
            2148865,
            2148802,
            10495779,
            10495875,
            10495971
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2215425,
            2215457,
            2215489,
            2215521,
            2215553,
            2215585,
            2215617,
            2215649,
            2215681,
            2215713,
            2215745,
            2215777,
            2192033,
            2215809,
            2215841,
            2215873
        ]),
        new Uint32Array([
            2242049,
            2242081,
            2242113,
            2242145,
            2242177,
            2242209,
            2242241,
            2242273,
            2215937,
            2242305,
            2242338,
            2242401,
            2242433,
            2242465,
            2242497,
            2216001
        ]),
        new Uint32Array([
            10554529,
            2221089,
            0,
            0,
            10562017,
            10502113,
            10538049,
            10537921,
            2221185,
            10489601,
            10489697,
            10609889,
            10609921,
            2141729,
            2141793,
            10610273
        ]),
        new Uint32Array([
            2141923,
            2142019,
            2142115,
            2142211,
            2142307,
            2142403,
            2142499,
            2142595,
            2142691,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            2221185,
            2221217,
            10609857,
            10609857,
            10489601,
            10489697,
            10609889,
            10609921,
            2141729,
            2141793,
            2221345,
            2221377,
            2221409,
            2221441,
            2187105
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            18923970,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2183105,
            6291456,
            2183137,
            6291456,
            2183169,
            6291456,
            2183201,
            6291456,
            2183233,
            6291456,
            2183265,
            6291456,
            2183297,
            6291456,
            2183329,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2134434,
            2134818,
            2097666,
            2097186,
            2097474,
            2097698,
            2105986,
            2131586,
            2132450,
            2131874,
            2131778,
            2135970,
            2135778,
            2161602,
            2136162,
            2161666
        ]),
        new Uint32Array([
            2236865,
            2236897,
            2236930,
            2236993,
            2237025,
            2235681,
            2237058,
            2237121,
            2237153,
            2237185,
            2237217,
            2217281,
            2237250,
            2191233,
            2237313,
            2237345
        ]),
        new Uint32Array([
            2190049,
            6291456,
            2190081,
            6291456,
            2190113,
            6291456,
            2190145,
            6291456,
            2190177,
            6291456,
            2190209,
            6291456,
            2190241,
            6291456,
            2190273,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2101922,
            2102050,
            2102178,
            2102306,
            10498755,
            10498851,
            10498947,
            10499043,
            10499139,
            10499235,
            10499331,
            10499427,
            10499523,
            10489604,
            10489732,
            10489860
        ]),
        new Uint32Array([
            2166914,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2181601,
            2170561,
            2181633,
            2181665,
            2170753,
            2181697,
            2172897,
            2170881,
            2181729,
            2170913,
            2172929,
            2113441,
            2181761,
            2181793,
            2171009,
            2173761
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            2106081,
            0,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            0,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2248001,
            2248033,
            2248066,
            2248130,
            2248193,
            2248226,
            2248289,
            2248322,
            2248385,
            2248417,
            2216673,
            2248450,
            2248514,
            2248577,
            2248610,
            2248673
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2169729,
            6291456,
            2169761,
            6291456,
            2169793,
            6291456,
            2169825,
            6291456,
            2169857,
            2169889,
            6291456,
            2169921,
            6291456,
            2143329,
            6291456,
            2098305
        ]),
        new Uint32Array([
            2162178,
            2163202,
            2163266,
            2135170,
            2136226,
            2161986,
            2137954,
            2159426,
            2159490,
            2163330,
            2159554,
            2163394,
            2159682,
            2139522,
            2136450,
            2159746
        ]),
        new Uint32Array([
            2173953,
            2173985,
            0,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2174209,
            2174241,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            4271169,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2174273
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2190785,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2189793,
            6291456,
            2189825,
            6291456,
            2189857,
            6291456,
            2189889,
            6291456,
            2189921,
            6291456,
            2189953,
            6291456,
            2189985,
            6291456,
            2190017,
            6291456
        ]),
        new Uint32Array([
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            0,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            0,
            2098209,
            2111137
        ]),
        new Uint32Array([
            2172129,
            6291456,
            2172161,
            6291456,
            2172193,
            6291456,
            2172225,
            6291456,
            2172257,
            6291456,
            2172289,
            6291456,
            2172321,
            6291456,
            2172353,
            6291456
        ]),
        new Uint32Array([
            2214753,
            6291456,
            2214785,
            6291456,
            6291456,
            2214817,
            2214849,
            2214881,
            2214913,
            2214945,
            2214977,
            2215009,
            2215041,
            2215073,
            2194401,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            10610305,
            10610337,
            10575617,
            2221761,
            10610401,
            10610433,
            10502177,
            0,
            10610465,
            10610497,
            10610529,
            10610561,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2187105,
            2187137,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2199393,
            2199425,
            2199457,
            2199489,
            2199521,
            2199553,
            2199585,
            2199617,
            2199649,
            2199681,
            2199713,
            2199745,
            2199777,
            2199809,
            2199841,
            0
        ]),
        new Uint32Array([
            2217249,
            2217281,
            2217313,
            2217345,
            2217377,
            2217409,
            2217441,
            2217473,
            2215617,
            2217505,
            2217537,
            2217569,
            2214753,
            2217601,
            2217633,
            2217665
        ]),
        new Uint32Array([
            2170273,
            2170305,
            6291456,
            2170337,
            2170369,
            6291456,
            2170401,
            2170433,
            2170465,
            6291456,
            6291456,
            6291456,
            2170497,
            2170529,
            6291456,
            2170561
        ]),
        new Uint32Array([
            2188673,
            6291456,
            2188705,
            2188737,
            2188769,
            6291456,
            6291456,
            2188801,
            6291456,
            2188833,
            6291456,
            2188865,
            6291456,
            2180929,
            2181505,
            2180897
        ]),
        new Uint32Array([
            10489988,
            10490116,
            10490244,
            10490372,
            10490500,
            10490628,
            10490756,
            10490884,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2147393,
            2147457,
            2147521,
            2147585,
            2147649,
            2147713,
            2147777,
            2147841
        ]),
        new Uint32Array([
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2241153,
            2241185,
            2241217,
            2215809,
            2241250,
            2241313,
            2241345,
            2241377,
            2217921,
            2241377,
            2241409,
            2215873,
            2241441,
            2241473,
            2241505,
            2241537
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220417,
            2220417,
            2220449,
            2220449,
            2220481,
            2220481,
            2220513,
            2220513,
            2220545,
            2220545,
            2220577,
            2220577,
            2220609,
            2220609,
            2220641,
            2220641
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2144002,
            0,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2167105,
            2167137,
            2167169,
            2167201,
            2167233,
            2167265,
            2167297,
            2167329,
            2167361,
            2167393,
            2167425,
            2167457,
            2167489,
            2167521,
            2167553,
            2167585
        ]),
        new Uint32Array([
            10575521,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            2234146,
            2234210,
            2234274,
            2234338,
            2234402,
            2234466,
            2234530,
            2234594,
            2234658,
            2234722,
            2234786,
            2234850,
            2234914,
            2234978,
            2235042,
            2235106
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2180577,
            0,
            0,
            0,
            0,
            0,
            2180609,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2242529,
            2242561,
            2242593,
            2242625,
            2242657,
            2242689,
            2242721,
            2242753,
            2207937,
            2218177,
            2242785,
            2242817,
            2242849,
            2242882,
            2242945,
            2242977
        ]),
        new Uint32Array([
            2118049,
            2105345,
            2118241,
            2105441,
            2118433,
            2118529,
            2118625,
            2118721,
            2118817,
            2200257,
            2200289,
            2191809,
            2200321,
            2200353,
            2200385,
            2200417
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2185505,
            6291456,
            2185537,
            6291456,
            2185569,
            6291456,
            2185601,
            6291456,
            2185633,
            6291456,
            2185665,
            6291456,
            2185697,
            6291456,
            2185729,
            6291456
        ]),
        new Uint32Array([
            2231970,
            2232034,
            2232098,
            2232162,
            2232226,
            2232290,
            2232354,
            2232418,
            2232482,
            2232546,
            2232610,
            2232674,
            2232738,
            2232802,
            2232866,
            2232930
        ]),
        new Uint32Array([
            2218625,
            2246402,
            2246466,
            2246530,
            2246594,
            2246657,
            2246689,
            2246689,
            2218657,
            2219681,
            2246721,
            2246753,
            2246785,
            2246818,
            2246881,
            2208481
        ]),
        new Uint32Array([
            2197025,
            2197057,
            2197089,
            2197121,
            2197153,
            2197185,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2219137,
            2216961,
            2219169,
            2219201,
            2219233,
            2219265,
            2219297,
            2217025,
            2215041,
            2219329,
            2217057,
            2219361,
            2217089,
            2219393,
            2197153,
            2219426
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713
        ]),
        new Uint32Array([
            2243522,
            2243585,
            2243617,
            2243649,
            2243681,
            2210113,
            2243713,
            2243746,
            2243810,
            2243874,
            2243937,
            2243970,
            2244033,
            2244065,
            2244097,
            2244129
        ]),
        new Uint32Array([
            2178017,
            6291456,
            2178049,
            6291456,
            2178081,
            6291456,
            2178113,
            6291456,
            2178145,
            6291456,
            2178177,
            6291456,
            2178209,
            6291456,
            2178241,
            6291456
        ]),
        new Uint32Array([
            10553858,
            2165314,
            10518722,
            6291456,
            10518818,
            0,
            10518914,
            2130690,
            10519010,
            2130786,
            10519106,
            2130882,
            10519202,
            2165378,
            10554050,
            2165506
        ]),
        new Uint32Array([
            0,
            0,
            2135491,
            2135587,
            2135683,
            2135779,
            2135875,
            2135971,
            2135971,
            2136067,
            2136163,
            2136259,
            2136355,
            2136355,
            2136451,
            2136547
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2220033,
            2220033,
            2220065,
            2220065,
            2220065,
            2220065,
            2220097,
            2220097,
            2220097,
            2220097,
            2220129,
            2220129,
            2220129,
            2220129,
            2220161,
            2220161
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2100897,
            2100898,
            2100899,
            2150018,
            2100865,
            2100866,
            2100867,
            2100868,
            2150082,
            2108481,
            2109858,
            2109859,
            2105569,
            2105505,
            2098241,
            2105601
        ]),
        new Uint32Array([
            2097217,
            2097505,
            2097505,
            2097505,
            2097505,
            2165570,
            2165570,
            2165634,
            2165634,
            2165698,
            2165698,
            2097858,
            2097858,
            0,
            0,
            2097152
        ]),
        new Uint32Array([
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            10503843,
            10503939,
            10504035,
            10504131,
            10504227,
            10504323,
            10504419,
            10504515,
            10504611,
            10504707,
            10504803,
            10504899,
            10504995,
            10491140,
            10491268,
            0
        ]),
        new Uint32Array([
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            2105953,
            2132705,
            2130977,
            2160065,
            2131297,
            2162049,
            2133089,
            2160577,
            2133857,
            2235297,
            2220769,
            2235329,
            2235361
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2222401,
            2222433,
            2222465,
            10531394,
            2222497,
            2222529,
            2222561,
            0,
            2222593,
            2222625,
            2222657,
            2222689,
            2222721,
            2222753,
            2222785,
            0
        ]),
        new Uint32Array([
            2184481,
            6291456,
            2184513,
            6291456,
            2184545,
            6291456,
            2184577,
            6291456,
            2184609,
            6291456,
            2184641,
            6291456,
            2184673,
            6291456,
            2184705,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2105570,
            2156034,
            2126947,
            2156098,
            2153666,
            2127043,
            2127139,
            2156162,
            0,
            2127235,
            2156226,
            2156290,
            2156354,
            2156418,
            2127331,
            2127427
        ]),
        new Uint32Array([
            2215905,
            2207041,
            2153185,
            2241569,
            2241601,
            2241633,
            2241665,
            2241697,
            2241730,
            2241793,
            2241825,
            2241857,
            2241889,
            2241921,
            2241954,
            2242017
        ]),
        new Uint32Array([
            2203777,
            6291456,
            2203809,
            6291456,
            2203841,
            6291456,
            2203873,
            6291456,
            2203905,
            6291456,
            2173121,
            2180993,
            2181249,
            2203937,
            2181313,
            0
        ]),
        new Uint32Array([
            2168577,
            6291456,
            2168609,
            6291456,
            2168641,
            6291456,
            2168673,
            6291456,
            2168705,
            6291456,
            2168737,
            6291456,
            2168769,
            6291456,
            2168801,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2210113,
            2195521,
            2210145,
            2210177,
            2210209,
            2210241,
            2210273,
            2210305,
            2210337,
            2210369,
            2210401,
            2210433,
            2210465,
            2210497,
            2210529,
            2210561
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            2228706,
            2228770,
            2228834,
            2228898,
            2228962,
            2229026,
            2229090,
            2229154,
            2229218,
            2229282,
            2229346,
            2229410,
            2229474,
            2229538,
            2229602,
            2229666
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            18874368,
            18874368,
            18874368,
            0,
            0
        ]),
        new Uint32Array([
            2133089,
            2133281,
            2133281,
            2133281,
            2133281,
            2160577,
            2160577,
            2160577,
            2160577,
            2097441,
            2097441,
            2097441,
            2097441,
            2133857,
            2133857,
            2133857
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089
        ]),
        new Uint32Array([
            2178529,
            6291456,
            2178561,
            6291456,
            2178593,
            6291456,
            2178625,
            6291456,
            2178657,
            6291456,
            2178689,
            6291456,
            2178721,
            6291456,
            2178753,
            6291456
        ]),
        new Uint32Array([
            2221025,
            2221025,
            2221057,
            2221057,
            2159329,
            2159329,
            2159329,
            2159329,
            2097217,
            2097217,
            2158914,
            2158914,
            2158978,
            2158978,
            2159042,
            2159042
        ]),
        new Uint32Array([
            2208161,
            2208193,
            2208225,
            2208257,
            2194433,
            2208289,
            2208321,
            2208353,
            2208385,
            2208417,
            2208449,
            2208481,
            2208513,
            2208545,
            2208577,
            2208609
        ]),
        new Uint32Array([
            2169217,
            6291456,
            2169249,
            6291456,
            2169281,
            6291456,
            2169313,
            6291456,
            2169345,
            6291456,
            2169377,
            6291456,
            2169409,
            6291456,
            2169441,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2133187,
            2133283,
            2133283,
            2133379,
            2133475,
            2133571,
            2133667,
            2133667,
            2133763,
            2133859,
            2133955,
            2134051,
            2134147,
            2134147,
            2134243,
            2134339
        ]),
        new Uint32Array([
            2197697,
            2114113,
            2114209,
            2197729,
            2197761,
            2114305,
            2197793,
            2114401,
            2114497,
            2197825,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            0
        ]),
        new Uint32Array([
            2193089,
            2193121,
            2193153,
            2193185,
            2117665,
            2117569,
            2193217,
            2193249,
            2193281,
            2193313,
            2193345,
            2193377,
            2193409,
            2193441,
            2193473,
            2193505
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184225,
            6291456,
            2184257,
            6291456,
            2184289,
            6291456,
            2184321,
            6291456,
            2184353,
            6291456,
            2184385,
            6291456,
            2184417,
            6291456,
            2184449,
            6291456
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2100833,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2098657,
            2098049,
            2200737,
            2123489,
            2123681,
            2200769,
            2098625,
            2100321,
            2098145,
            2100449,
            2098017,
            2098753,
            2200801,
            2200833,
            2200865,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            0,
            2098241,
            2108353,
            2108417,
            2105825,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2181153,
            2105505,
            2181185,
            2167617,
            2180993
        ]),
        new Uint32Array([
            2160002,
            2160066,
            2160130,
            2160194,
            2160258,
            2132066,
            2131010,
            2131106,
            2106018,
            2131618,
            2160322,
            2131298,
            2132034,
            2131938,
            2137410,
            2132226
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2183617,
            6291456,
            2183649,
            6291456,
            2183681,
            6291456,
            2183713,
            6291456,
            2183745,
            6291456,
            2183777,
            6291456,
            2183809,
            6291456,
            2183841,
            6291456
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2250977,
            2251009,
            2251041,
            2251073,
            2195009,
            2251106,
            2251169,
            2251201,
            2251233,
            2251265,
            2251297,
            2251330,
            2251394,
            2251457,
            2251489,
            2251521
        ]),
        new Uint32Array([
            2205729,
            2205761,
            2205793,
            2205825,
            2205857,
            2205889,
            2205921,
            2205953,
            2205985,
            2206017,
            2206049,
            2206081,
            2206113,
            2206145,
            2206177,
            2206209
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2143170,
            2168993,
            6291456,
            2169025,
            6291456,
            2169057,
            6291456,
            2169089,
            6291456,
            2143234,
            2169121,
            6291456,
            2169153,
            6291456,
            2169185,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            2190689,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2248706,
            2248769,
            2248801,
            2248833,
            2248865,
            2248897,
            2248929,
            2248962,
            2249026,
            2249090,
            2249154,
            2240705,
            2249217,
            2249249,
            2249281,
            2249313
        ]),
        new Uint32Array([
            10485857,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10495394,
            6291456,
            2098209,
            6291456,
            6291456,
            2097152,
            6291456,
            10531394
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            14680064,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889
        ]),
        new Uint32Array([
            6291456,
            2186977,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10537858,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2209601,
            2209633,
            2209665,
            2209697,
            2209729,
            2209761,
            2209793,
            2209825,
            2209857,
            2209889,
            2209921,
            2209953,
            2209985,
            2210017,
            2210049,
            2210081
        ]),
        new Uint32Array([
            10501539,
            10501635,
            10501731,
            10501827,
            10501923,
            10502019,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2194561,
            2194593,
            2194625,
            2119777,
            2119873,
            2194657,
            2194689,
            2194721,
            2194753,
            2194785,
            2194817,
            2194849,
            2194881,
            2194913,
            2194945,
            2194977
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569
        ]),
        new Uint32Array([
            2222818,
            2222882,
            2222946,
            2223010,
            2223074,
            2223138,
            2223202,
            2223266,
            2223330,
            2223394,
            2223458,
            2223522,
            2223586,
            2223650,
            2223714,
            2223778
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672
        ]),
        new Uint32Array([
            0,
            2179553,
            2179585,
            2179617,
            2179649,
            2144001,
            2179681,
            2179713,
            2179745,
            2179777,
            2179809,
            2156705,
            2179841,
            2156833,
            2179873,
            2179905
        ]),
        new Uint32Array([
            6291456,
            23068672,
            6291456,
            2145602,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2196513,
            2196545,
            2196577,
            2196609,
            2196641,
            2196673,
            2196705,
            2196737,
            2196769,
            2196801,
            2196833,
            2196865,
            2196897,
            2196929,
            2196961,
            2196993
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2177281,
            6291456,
            2177313,
            6291456,
            2177345,
            6291456,
            2177377,
            6291456,
            2177409,
            6291456,
            2177441,
            6291456,
            2177473,
            6291456,
            2177505,
            6291456
        ]),
        new Uint32Array([
            2187137,
            2221473,
            2221505,
            2221537,
            2221569,
            6291456,
            6291456,
            10610209,
            10610241,
            10537986,
            10537986,
            10537986,
            10537986,
            10609857,
            10609857,
            10609857
        ]),
        new Uint32Array([
            2243009,
            2243041,
            2216033,
            2243074,
            2243137,
            2243169,
            2243201,
            2219617,
            2243233,
            2243265,
            2243297,
            2243329,
            2243362,
            2243425,
            2243457,
            2243489
        ]),
        new Uint32Array([
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            10485857,
            2097152,
            4194304,
            4194304,
            0,
            0
        ]),
        new Uint32Array([
            2143042,
            6291456,
            2143106,
            2143106,
            2168833,
            6291456,
            2168865,
            6291456,
            6291456,
            2168897,
            6291456,
            2168929,
            6291456,
            2168961,
            6291456,
            2143170
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2204193,
            2204225,
            2204257,
            2204289,
            2204321,
            2204353,
            2204385,
            2204417,
            2204449,
            2204481,
            2204513,
            2204545,
            2204577,
            2204609,
            2204641,
            2204673
        ]),
        new Uint32Array([
            2202753,
            6291456,
            2202785,
            6291456,
            2202817,
            6291456,
            2202849,
            6291456,
            2202881,
            6291456,
            2202913,
            6291456,
            2202945,
            6291456,
            2202977,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321
        ]),
        new Uint32Array([
            2147394,
            2147458,
            2147522,
            2147586,
            2147650,
            2147714,
            2147778,
            2147842,
            2147394,
            2147458,
            2147522,
            2147586,
            2147650,
            2147714,
            2147778,
            2147842
        ]),
        new Uint32Array([
            2253313,
            2253346,
            2253409,
            2253441,
            2253473,
            2253505,
            2253537,
            2253569,
            2253601,
            2253634,
            2219393,
            2253697,
            2253729,
            2253761,
            2253793,
            2253825
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2162562,
            2162626,
            2131362,
            2162690,
            2159938,
            2160002,
            2162754,
            2162818,
            2160130,
            2162882,
            2160194,
            2160258,
            2160834,
            2160898,
            2161026,
            2161090
        ]),
        new Uint32Array([
            2175361,
            2175393,
            2175425,
            2175457,
            2175489,
            2175521,
            2175553,
            2175585,
            2175617,
            2175649,
            2175681,
            2175713,
            2175745,
            2175777,
            2175809,
            2175841
        ]),
        new Uint32Array([
            2253858,
            2253921,
            2253954,
            2254018,
            2254082,
            2196737,
            2254145,
            2196865,
            2254177,
            2254209,
            2254241,
            2254273,
            2197025,
            2254306,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2202113,
            2204129,
            2188705,
            2204161
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953
        ]),
        new Uint32Array([
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209
        ]),
        new Uint32Array([
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            0,
            2108417,
            0,
            2111713,
            2100897,
            2111905
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2175425,
            2175489,
            2175809,
            2175905,
            2175937,
            2175937,
            2176193,
            2176417,
            2180865,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            2143298,
            2143298,
            2143298,
            2143362,
            2143362,
            2143362,
            2143426,
            2143426,
            2143426,
            2171105,
            6291456,
            2171137
        ]),
        new Uint32Array([
            2120162,
            2120258,
            2151618,
            2151682,
            2151746,
            2151810,
            2151874,
            2151938,
            2152002,
            2120035,
            2120131,
            2120227,
            2152066,
            2120323,
            2152130,
            2120419
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2195361,
            2142433,
            2236065,
            2236097,
            2236129,
            2236161,
            2118241,
            2117473,
            2236193,
            2236225,
            2236257,
            2236289,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2189281,
            6291456,
            2189313,
            6291456,
            2189345,
            6291456,
            2189377,
            6291456,
            2189409,
            6291456,
            2189441,
            6291456,
            2189473,
            6291456,
            2189505,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2145922,
            6291456,
            6291456,
            6291456,
            6291456,
            2145986,
            6291456,
            6291456,
            6291456,
            6291456,
            2146050,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10502113,
            10562017,
            10610401,
            10502177,
            10610433,
            10538049
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            2186401,
            0,
            2186433,
            0,
            2186465,
            0,
            2186497
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            0,
            2198241,
            2198273,
            2198305,
            2198337,
            2198369,
            2198401,
            0,
            0,
            2198433,
            2198465,
            2198497,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            2105921,
            2097729,
            0,
            2097377,
            0,
            0,
            2106017,
            2133281,
            2097505,
            2105889,
            0,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2197889,
            2197921,
            2197953,
            2197985,
            2198017,
            2198049,
            2198081,
            2198113,
            2198145,
            2198177,
            2198209,
            2198241,
            2198273,
            2198305,
            2198337,
            2198369
        ]),
        new Uint32Array([
            2132514,
            2132610,
            2160386,
            2133090,
            2133186,
            2160450,
            2160514,
            2133282,
            2160578,
            2133570,
            2106178,
            2160642,
            2133858,
            2160706,
            2160770,
            2134146
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2184737,
            6291456,
            2184769,
            6291456,
            2184801,
            6291456,
            2184833,
            6291456,
            2184865,
            6291456,
            2184897,
            6291456,
            2184929,
            6291456,
            2184961,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2186753,
            6291456,
            6291456,
            6291456,
            6291456,
            2186785,
            2186817,
            2186849,
            2173569,
            2186881,
            10496355,
            10495395,
            10575521
        ]),
        new Uint32Array([
            0,
            0,
            2097729,
            0,
            0,
            0,
            0,
            2106017,
            0,
            2097505,
            0,
            2097185,
            0,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2189537,
            6291456,
            2189569,
            6291456,
            2189601,
            6291456,
            2189633,
            6291456,
            2189665,
            6291456,
            2189697,
            6291456,
            2189729,
            6291456,
            2189761,
            6291456
        ]),
        new Uint32Array([
            2202497,
            6291456,
            2202529,
            6291456,
            2202561,
            6291456,
            2202593,
            6291456,
            2202625,
            6291456,
            2202657,
            6291456,
            2202689,
            6291456,
            2202721,
            6291456
        ]),
        new Uint32Array([
            2245217,
            2218369,
            2245249,
            2245282,
            2245345,
            2245377,
            2245410,
            2245474,
            2245537,
            2245569,
            2245601,
            2245633,
            2245665,
            2245665,
            2245697,
            2245729
        ]),
        new Uint32Array([
            6291456,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            23068672,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097281,
            2105921,
            2097729,
            2106081,
            2097377,
            2097601,
            2162337,
            2106017,
            2133281,
            2097505,
            0,
            2097185,
            2097697,
            2135777,
            2097633,
            2097441
        ]),
        new Uint32Array([
            2176641,
            6291456,
            2176673,
            6291456,
            2176705,
            6291456,
            2176737,
            6291456,
            2176769,
            6291456,
            2176801,
            6291456,
            2176833,
            6291456,
            2176865,
            6291456
        ]),
        new Uint32Array([
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2174369,
            2174369,
            0,
            0,
            2100833,
            2100737
        ]),
        new Uint32Array([
            2116513,
            2190817,
            2190849,
            2190881,
            2190913,
            2190945,
            2116609,
            2190977,
            2191009,
            2191041,
            2191073,
            2117185,
            2191105,
            2191137,
            2191169,
            2191201
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456
        ]),
        new Uint32Array([
            2167617,
            2167649,
            2167681,
            2167713,
            2167745,
            2167777,
            2167809,
            6291456,
            2167841,
            2167873,
            2167905,
            2167937,
            2167969,
            2168001,
            2168033,
            4240130
        ]),
        new Uint32Array([
            2165122,
            2163970,
            2164034,
            2164098,
            2164162,
            2164226,
            2164290,
            2164354,
            2164418,
            2164482,
            2164546,
            2133122,
            2134562,
            2132162,
            2132834,
            2136866
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2186209,
            2186241,
            2186273,
            2186305,
            2186337,
            2186369,
            0,
            0
        ]),
        new Uint32Array([
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            10537921,
            10610689,
            10610273,
            10610497,
            10610529,
            10610305,
            10610721,
            10489601,
            10489697,
            10610337,
            10575617,
            10554529,
            2221761,
            2197217,
            10496577
        ]),
        new Uint32Array([
            2105473,
            2105569,
            2105601,
            2112289,
            0,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441
        ]),
        new Uint32Array([
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481
        ]),
        new Uint32Array([
            2125346,
            2153410,
            2153474,
            2127394,
            2153538,
            2153602,
            2153666,
            2153730,
            2105507,
            2105476,
            2153794,
            2153858,
            2153922,
            2153986,
            2154050,
            2105794
        ]),
        new Uint32Array([
            2200449,
            2119681,
            2200481,
            2153313,
            2199873,
            2199905,
            2199937,
            2200513,
            2200545,
            2200577,
            2200609,
            2119105,
            2119201,
            2119297,
            2119393,
            2119489
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2175777,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2222273,
            2197217,
            2221473,
            2221505,
            2221089,
            2222305,
            2200865,
            2099681,
            2104481,
            2222337,
            2099905,
            2120737,
            2222369,
            2103713,
            2100225,
            2098785
        ]),
        new Uint32Array([
            2201377,
            6291456,
            2201409,
            6291456,
            2201441,
            6291456,
            2201473,
            6291456,
            2201505,
            6291456,
            2201537,
            6291456,
            2201569,
            6291456,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793
        ]),
        new Uint32Array([
            2200897,
            6291456,
            2200929,
            6291456,
            2200961,
            6291456,
            2200993,
            6291456,
            2201025,
            6291456,
            2180865,
            6291456,
            2201057,
            6291456,
            2201089,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2161154,
            2161410,
            2138658,
            2161474,
            2161538,
            2097666,
            2097186,
            2097474,
            2162946,
            2132450,
            2163010,
            2163074,
            2136162,
            2163138,
            2161666,
            2161730
        ]),
        new Uint32Array([
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            2145410,
            2145474,
            0,
            6291456
        ]),
        new Uint32Array([
            2244161,
            2216065,
            2212769,
            2244193,
            2244225,
            2244257,
            2244290,
            2244353,
            2244385,
            2244417,
            2244449,
            2218273,
            2244481,
            2244514,
            2244577,
            2244609
        ]),
        new Uint32Array([
            2125730,
            2125699,
            2125795,
            2125891,
            2125987,
            2154114,
            2154178,
            2154242,
            2154306,
            2154370,
            2154434,
            2154498,
            2126082,
            2126178,
            2126274,
            2126083
        ]),
        new Uint32Array([
            2237665,
            2237697,
            2237697,
            2237697,
            2237730,
            2237793,
            2237825,
            2237857,
            2237890,
            2237953,
            2237985,
            2238017,
            2238049,
            2238081,
            2238113,
            2238145
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2150146,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2214369,
            2238593,
            2238625,
            2238657,
            2238689,
            2238721,
            2238753,
            2238785,
            2238817,
            2238850,
            2238913,
            2238945,
            2238977,
            2235457,
            2239009,
            2239041
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2252066,
            2252130,
            2252193,
            2252225,
            2252257,
            2252290,
            2252353,
            2252385,
            2252417,
            2252449,
            2252481,
            2252513,
            2252545,
            2252578,
            2252641,
            2252673
        ]),
        new Uint32Array([
            2197697,
            2114113,
            2114209,
            2197729,
            2197761,
            2114305,
            2197793,
            2114401,
            2114497,
            2197825,
            2114593,
            2114689,
            2114785,
            2114881,
            2114977,
            2197857
        ]),
        new Uint32Array([
            2224866,
            2224930,
            2224994,
            2225058,
            2225122,
            2225186,
            2225250,
            2225314,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2219490,
            2219554,
            2219617,
            2219649,
            2219681,
            2219714,
            2219778,
            2219842,
            2219905,
            2219937,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289
        ]),
        new Uint32Array([
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            2220161,
            2220161,
            2220193,
            2220193,
            2220193,
            2220193,
            2220225,
            2220225,
            2220225,
            2220225,
            2220257,
            2220257,
            2220257,
            2220257,
            2220289,
            2220289
        ]),
        new Uint32Array([
            2192673,
            2192705,
            2192737,
            2192769,
            2192801,
            2192833,
            2192865,
            2118049,
            2192897,
            2117473,
            2117761,
            2192929,
            2192961,
            2192993,
            2193025,
            2193057
        ]),
        new Uint32Array([
            2179297,
            6291456,
            2179329,
            6291456,
            2179361,
            6291456,
            2179393,
            6291456,
            2179425,
            6291456,
            2179457,
            6291456,
            2179489,
            6291456,
            2179521,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2235745,
            2235777,
            2193633,
            2235809,
            2235841,
            2235873,
            2235905,
            2235937,
            2235969,
            2116513,
            2116705,
            2236001,
            2200513,
            2199905,
            2200545,
            2236033
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2232993,
            2233025,
            0,
            0,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761
        ]),
        new Uint32Array([
            2170593,
            6291456,
            2170625,
            6291456,
            2170657,
            6291456,
            2170689,
            2170721,
            6291456,
            2170753,
            6291456,
            6291456,
            2170785,
            6291456,
            2170817,
            2170849
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2166786,
            2166850,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            10575617,
            2187041,
            10502177,
            10489601,
            10489697,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2134562,
            2132162,
            2132834,
            2136866,
            2136482,
            2164610,
            2164674,
            2164738,
            2164802,
            2132802,
            2132706,
            2164866,
            2132898,
            2164930,
            2164994,
            2165058
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2098337,
            2101441,
            10531458,
            2153473,
            6291456,
            6291456,
            10531522,
            2100737,
            2108193,
            6291456,
            2106499,
            2106595,
            2106691,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2233122,
            2233186,
            2233250,
            2233314,
            2233378,
            2233442,
            2233506,
            2233570,
            2233634,
            2233698,
            2233762,
            2233826,
            2233890,
            2233954,
            2234018,
            2234082
        ]),
        new Uint32Array([
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2205217,
            2205249,
            2205281,
            2205313,
            2205345,
            2205377,
            2205409,
            2205441,
            2205473,
            2205505,
            2205537,
            2205569,
            2205601,
            2205633,
            2205665,
            2205697
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2173601,
            2173761,
            2174081,
            2173569,
            2174241,
            2174113,
            2173953,
            6291456,
            2174305,
            6291456,
            2174337,
            6291456,
            2174369,
            6291456,
            2174401,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2152450,
            2152514,
            2099653,
            2104452,
            2099813,
            2122243,
            2099973,
            2152578,
            2122339,
            2122435,
            2122531,
            2122627,
            2122723,
            2104580,
            2122819,
            2152642
        ]),
        new Uint32Array([
            2236385,
            2236417,
            2236449,
            2236482,
            2236545,
            2215425,
            2236577,
            2236609,
            2236641,
            2236673,
            2215457,
            2236705,
            2236737,
            2236770,
            2215489,
            2236833
        ]),
        new Uint32Array([
            2163394,
            2159746,
            2163458,
            2131362,
            2163522,
            2160130,
            2163778,
            2132226,
            2163842,
            2132898,
            2163906,
            2161410,
            2138658,
            2097666,
            2136162,
            2163650
        ]),
        new Uint32Array([
            2218721,
            2246913,
            2246946,
            2216385,
            2247010,
            2247074,
            2215009,
            2247137,
            2247169,
            2216481,
            2247201,
            2247233,
            2247266,
            2247330,
            2247330,
            0
        ]),
        new Uint32Array([
            2129730,
            2129762,
            2129858,
            2129731,
            2129827,
            2156482,
            2156482,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2203969,
            2204001,
            2181377,
            2204033,
            2204065,
            6291456,
            2204097,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2169473,
            6291456,
            2169505,
            6291456,
            2169537,
            6291456,
            2169569,
            6291456,
            2169601,
            6291456,
            2169633,
            6291456,
            2169665,
            6291456,
            2169697,
            6291456
        ]),
        new Uint32Array([
            2141542,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220801,
            2220801,
            2220801,
            2220801,
            2220833,
            2220833,
            2220865,
            2220865,
            2220865,
            2220865,
            2220897,
            2220897,
            2220897,
            2220897,
            2139873,
            2139873
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            0
        ]),
        new Uint32Array([
            2214849,
            2218433,
            2218465,
            2218497,
            2218529,
            2218561,
            2214881,
            2218593,
            2218625,
            2218657,
            2218689,
            2218721,
            2218753,
            2216545,
            2218785,
            2218817
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2136482,
            2164610,
            2164674,
            2164738,
            2164802,
            2132802,
            2132706,
            2164866,
            2132898,
            2164930,
            2164994,
            2165058,
            2165122,
            2132802,
            2132706,
            2164866
        ]),
        new Uint32Array([
            2207649,
            2207681,
            2207713,
            2207745,
            2207777,
            2207809,
            2207841,
            2207873,
            2207905,
            2207937,
            2207969,
            2208001,
            2208033,
            2208065,
            2208097,
            2208129
        ]),
        new Uint32Array([
            2123683,
            2105092,
            2152706,
            2123779,
            2105220,
            2152770,
            2100453,
            2098755,
            2123906,
            2124002,
            2124098,
            2124194,
            2124290,
            2124386,
            2124482,
            2124578
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10485857
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            10508163,
            10508259,
            10508355,
            10508451,
            2200129,
            2200161,
            2192737,
            2200193,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2203553,
            6291456,
            2203585,
            6291456,
            6291456,
            6291456,
            2203617,
            6291456,
            2203649,
            6291456,
            2203681,
            6291456,
            2203713,
            6291456,
            2203745,
            6291456
        ]),
        new Uint32Array([
            18884449,
            18884065,
            23068672,
            18884417,
            18884034,
            18921185,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            18874368
        ]),
        new Uint32Array([
            2247393,
            2247426,
            2247489,
            2247521,
            2247553,
            2247586,
            2247649,
            2247681,
            2247713,
            2247745,
            2247777,
            2247810,
            2247873,
            2247905,
            2247937,
            2247969
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            0,
            2132705,
            2130977,
            2160065,
            2131297,
            0,
            2133089,
            2160577,
            2133857,
            2235297,
            0,
            2235329,
            0
        ]),
        new Uint32Array([
            2182593,
            6291456,
            2182625,
            6291456,
            2182657,
            6291456,
            2182689,
            6291456,
            2182721,
            6291456,
            2182753,
            6291456,
            2182785,
            6291456,
            2182817,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2102402,
            2102403,
            6291456,
            2110050
        ]),
        new Uint32Array([
            2149890,
            2108323,
            2149954,
            6291456,
            2113441,
            6291456,
            2149057,
            6291456,
            2113441,
            6291456,
            2105473,
            2167265,
            2111137,
            2105505,
            6291456,
            2108353
        ]),
        new Uint32Array([
            2219105,
            2219137,
            2195233,
            2251554,
            2251617,
            2251649,
            2251681,
            2251713,
            2251746,
            2251810,
            2251873,
            2251905,
            2251937,
            2251970,
            2252033,
            2219169
        ]),
        new Uint32Array([
            2203009,
            6291456,
            2203041,
            6291456,
            2203073,
            6291456,
            2203105,
            6291456,
            2203137,
            6291456,
            2203169,
            6291456,
            2203201,
            6291456,
            2203233,
            6291456
        ]),
        new Uint32Array([
            2128195,
            2128291,
            2128387,
            2128483,
            2128579,
            2128675,
            2128771,
            2128867,
            2128963,
            2129059,
            2129155,
            2129251,
            2129347,
            2129443,
            2129539,
            2129635
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2140964,
            2141156,
            2140966,
            2141158,
            2141350
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2225378,
            2225442,
            2225506,
            2225570,
            2225634,
            2225698,
            2225762,
            2225826,
            2225890,
            2225954,
            2226018,
            2226082,
            2226146,
            2226210,
            2226274,
            2226338
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417
        ]),
        new Uint32Array([
            2108353,
            2108417,
            0,
            2105601,
            2108193,
            2157121,
            2157313,
            2157377,
            2157441,
            2100897,
            6291456,
            2108419,
            2173953,
            2173633,
            2173633,
            2173953
        ]),
        new Uint32Array([
            2111713,
            2173121,
            2111905,
            2098177,
            2173153,
            2173185,
            2173217,
            2113153,
            2113345,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            2190753
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2197249,
            6291456,
            2117377,
            2197281,
            2197313,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100833,
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2173281,
            6291456,
            2173313,
            6291456,
            2173345,
            6291456,
            2173377,
            6291456,
            0,
            0,
            10532546,
            6291456,
            6291456,
            6291456,
            10562017,
            2173441
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2159426,
            2159490,
            2159554,
            2159362,
            2159618,
            2159682,
            2139522,
            2136450,
            2159746,
            2159810,
            2159874,
            2130978,
            2131074,
            2131266,
            2131362,
            2159938
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2203233,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2203265,
            6291456,
            2203297,
            6291456,
            2203329,
            2203361,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2148418,
            2148482,
            2148546,
            0,
            6291456,
            2148610,
            2186529,
            2186561,
            2148417,
            2148545,
            2148482,
            10495778,
            2143969,
            10495778
        ]),
        new Uint32Array([
            2134146,
            2139426,
            2160962,
            2134242,
            2161218,
            2161282,
            2161346,
            2161410,
            2138658,
            2134722,
            2134434,
            2134818,
            2097666,
            2097346,
            2097698,
            2105986
        ]),
        new Uint32Array([
            2198881,
            2198913,
            2198945,
            2198977,
            2199009,
            2199041,
            2199073,
            2199105,
            2199137,
            2199169,
            2199201,
            2199233,
            2199265,
            2199297,
            2199329,
            2199361
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            10610561,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193
        ]),
        new Uint32Array([
            2183873,
            6291456,
            2183905,
            6291456,
            2183937,
            6291456,
            2183969,
            6291456,
            2184001,
            6291456,
            2184033,
            6291456,
            2184065,
            6291456,
            2184097,
            6291456
        ]),
        new Uint32Array([
            2244642,
            2244706,
            2244769,
            2244801,
            2218305,
            2244833,
            2244865,
            2244897,
            2244929,
            2244961,
            2244993,
            2245026,
            2245089,
            2245122,
            2245185,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2116513,
            2116609,
            2116705,
            2116801,
            2199873,
            2199905,
            2199937,
            2199969,
            2190913,
            2200001,
            2200033,
            2200065,
            2200097,
            2191009
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2180673,
            2180705,
            2180737,
            2180769,
            2180801,
            2180833,
            0,
            0
        ]),
        new Uint32Array([
            2098081,
            2099521,
            2099105,
            2120705,
            2098369,
            2120801,
            2103361,
            2097985,
            2098433,
            2121377,
            2121473,
            2099169,
            2099873,
            2098401,
            2099393,
            2152609
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2150402
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2145666,
            2145730,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665
        ]),
        new Uint32Array([
            2187073,
            6291456,
            6291456,
            6291456,
            6291456,
            2098241,
            2098241,
            2108353,
            2100897,
            2111905,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2102404,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2100612,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10485857
        ]),
        new Uint32Array([
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889
        ]),
        new Uint32Array([
            2217697,
            2217729,
            2217761,
            2217793,
            2217825,
            2217857,
            2217889,
            2217921,
            2217953,
            2215873,
            2217985,
            2215905,
            2218017,
            2218049,
            2218081,
            2218113
        ]),
        new Uint32Array([
            2211233,
            2218849,
            2216673,
            2218881,
            2218913,
            2218945,
            2218977,
            2219009,
            2216833,
            2219041,
            2215137,
            2219073,
            2216865,
            2209505,
            2219105,
            2216897
        ]),
        new Uint32Array([
            2240097,
            2240129,
            2240161,
            2240193,
            2240225,
            2240257,
            2240289,
            2240321,
            2240353,
            2240386,
            2240449,
            2240481,
            2240513,
            2240545,
            2207905,
            2240578
        ]),
        new Uint32Array([
            6291456,
            6291456,
            2202273,
            6291456,
            2202305,
            6291456,
            2202337,
            6291456,
            2202369,
            6291456,
            2202401,
            6291456,
            2202433,
            6291456,
            2202465,
            6291456
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            18923394,
            23068672,
            18923458,
            18923522,
            18884099,
            18923586,
            18884195,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2201121,
            6291456,
            2201153,
            6291456,
            2201185,
            6291456,
            2201217,
            6291456,
            2201249,
            6291456,
            2201281,
            6291456,
            2201313,
            6291456,
            2201345,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2211041,
            2211073,
            2211105,
            2211137,
            2211169,
            2211201,
            2211233,
            2211265,
            2211297,
            2211329,
            2211361,
            2211393,
            2211425,
            2211457,
            2211489,
            2211521
        ]),
        new Uint32Array([
            2181825,
            6291456,
            2181857,
            6291456,
            2181889,
            6291456,
            2181921,
            6291456,
            2181953,
            6291456,
            2181985,
            6291456,
            2182017,
            6291456,
            2182049,
            6291456
        ]),
        new Uint32Array([
            2162337,
            2097633,
            2097633,
            2097633,
            2097633,
            2132705,
            2132705,
            2132705,
            2132705,
            2097153,
            2097153,
            2097153,
            2097153,
            2133089,
            2133089,
            2133089
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2148545,
            6291456,
            2173473,
            6291456,
            2148865,
            6291456,
            2173505,
            6291456,
            2173537,
            6291456,
            2173569,
            6291456,
            2149121,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2207137,
            2207169,
            2207201,
            2207233,
            2207265,
            2207297,
            2207329,
            2207361,
            2207393,
            2207425,
            2207457,
            2207489,
            2207521,
            2207553,
            2207585,
            2207617
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2198401,
            2198433,
            2198465,
            2198497,
            0,
            2198529,
            2198561,
            2198593,
            2198625,
            2198657,
            2198689,
            2198721,
            2198753,
            2198785,
            2198817,
            2198849
        ]),
        new Uint32Array([
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0,
            0
        ]),
        new Uint32Array([
            2216385,
            2118721,
            2216417,
            2216449,
            2216481,
            2216513,
            2216545,
            2211233,
            2216577,
            2216609,
            2216641,
            2216673,
            2216705,
            2216737,
            2216737,
            2216769
        ]),
        new Uint32Array([
            2216801,
            2216833,
            2216865,
            2216897,
            2216929,
            2216961,
            2216993,
            2215169,
            2217025,
            2217057,
            2217089,
            2217121,
            2217154,
            2217217,
            0,
            0
        ]),
        new Uint32Array([
            2210593,
            2191809,
            2210625,
            2210657,
            2210689,
            2210721,
            2210753,
            2210785,
            2210817,
            2210849,
            2191297,
            2210881,
            2210913,
            2210945,
            2210977,
            2211009
        ]),
        new Uint32Array([
            0,
            0,
            2105825,
            0,
            0,
            2111905,
            2105473,
            0,
            0,
            2112289,
            2108193,
            2112481,
            2112577,
            0,
            2098305,
            2108321
        ]),
        new Uint32Array([
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            2097153,
            2134241,
            0,
            2132705,
            0,
            0,
            2131297,
            0,
            2133089,
            0,
            2133857,
            0,
            2220769,
            0,
            2235361
        ]),
        new Uint32Array([
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            6291456,
            6291456,
            14680064
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2171873,
            6291456,
            2171905,
            6291456,
            2171937,
            6291456,
            2171969,
            6291456,
            2172001,
            6291456,
            2172033,
            6291456,
            2172065,
            6291456,
            2172097,
            6291456
        ]),
        new Uint32Array([
            2220929,
            2220929,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2133857,
            2134145,
            2134145,
            2134145,
            2134145,
            2134241,
            2134241,
            2134241,
            2134241,
            2105889,
            2105889,
            2105889,
            2105889,
            2097185,
            2097185,
            2097185
        ]),
        new Uint32Array([
            2173697,
            2173761,
            2173793,
            2174113,
            2173985,
            2173953,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            10499619,
            10499715,
            10499811,
            10499907
        ]),
        new Uint32Array([
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            2144322,
            2144386,
            2144450,
            2144514,
            2144578,
            2144642,
            2144706,
            2144770
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137,
            0,
            2098241,
            2108353,
            2108417,
            2105825,
            0,
            0,
            2111905,
            2105473,
            2105569
        ]),
        new Uint32Array([
            2236321,
            2236353,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2152194,
            2121283,
            2103684,
            2103812,
            2097986,
            2098533,
            2097990,
            2098693,
            2098595,
            2098853,
            2099013,
            2103940,
            2121379,
            2121475,
            2121571,
            2104068
        ]),
        new Uint32Array([
            2206241,
            2206273,
            2206305,
            2206337,
            2206369,
            2206401,
            2206433,
            2206465,
            2206497,
            2206529,
            2206561,
            2206593,
            2206625,
            2206657,
            2206689,
            2206721
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            16777216,
            16777216,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            23068672,
            23068672,
            10538818,
            10538882,
            6291456,
            6291456,
            2150338
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2214369,
            2214401,
            2214433,
            2214465,
            2214497,
            2214529,
            2214561,
            2214593,
            2194977,
            2214625,
            2195073,
            2214657,
            2214689,
            2214721,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2097152,
            2097152,
            2097152,
            2097152,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2182081,
            6291456,
            2182113,
            6291456,
            2182145,
            6291456,
            2182177,
            6291456,
            2182209,
            6291456,
            2182241,
            6291456,
            2182273,
            6291456,
            2182305,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146881,
            2146945,
            2147009,
            2147073,
            2147137,
            2147201,
            2147265,
            2147329
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2122915,
            2123011,
            2123107,
            2104708,
            2123203,
            2123299,
            2123395,
            2100133,
            2104836,
            2100290,
            2100293,
            2104962,
            2104964,
            2098052,
            2123491,
            2123587
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2171169,
            6291456,
            2171201,
            6291456,
            2171233,
            6291456,
            2171265,
            6291456,
            2171297,
            6291456,
            2171329,
            6291456,
            6291456,
            2171361,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            2148994,
            2149058,
            2149122,
            0,
            6291456,
            2149186,
            2186945,
            2173537,
            2148993,
            2149121,
            2149058,
            10531458,
            10496066,
            0
        ]),
        new Uint32Array([
            2195009,
            2195041,
            2195073,
            2195105,
            2195137,
            2195169,
            2195201,
            2195233,
            2195265,
            2195297,
            2195329,
            2195361,
            2195393,
            2195425,
            2195457,
            2195489
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2182849,
            6291456,
            2182881,
            6291456,
            2182913,
            6291456,
            2182945,
            6291456,
            2182977,
            6291456,
            2183009,
            6291456,
            2183041,
            6291456,
            2183073,
            6291456
        ]),
        new Uint32Array([
            2211553,
            2210081,
            2211585,
            2211617,
            2211649,
            2211681,
            2211713,
            2211745,
            2211777,
            2211809,
            2209569,
            2211841,
            2211873,
            2211905,
            2211937,
            2211969
        ]),
        new Uint32Array([
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2166594,
            2127298,
            2166658,
            2142978,
            2141827,
            2166722
        ]),
        new Uint32Array([
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233057,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            2185761,
            2185793,
            2185825,
            2185857,
            2185889,
            2185921,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            2148481,
            2173601,
            2173633,
            2173665,
            2173697,
            2173729,
            2148801,
            2173761,
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            2220961,
            2220961,
            2220961,
            2220961,
            2144193,
            2144193,
            2159201,
            2159201,
            2159265,
            2159265,
            2144194,
            2220993,
            2220993
        ]),
        new Uint32Array([
            2192641,
            2235393,
            2235425,
            2152257,
            2116609,
            2235457,
            2235489,
            2200065,
            2235521,
            2235553,
            2235585,
            2212449,
            2235617,
            2235649,
            2235681,
            2235713
        ]),
        new Uint32Array([
            2194049,
            2194081,
            2194113,
            2194145,
            2194177,
            2194209,
            2194241,
            2194273,
            2194305,
            2194337,
            2194369,
            2194401,
            2194433,
            2194465,
            2194497,
            2194529
        ]),
        new Uint32Array([
            2196673,
            2208641,
            2208673,
            2208705,
            2208737,
            2208769,
            2208801,
            2208833,
            2208865,
            2208897,
            2208929,
            2208961,
            2208993,
            2209025,
            2209057,
            2209089
        ]),
        new Uint32Array([
            2191681,
            2191713,
            2191745,
            2191777,
            2153281,
            2191809,
            2191841,
            2191873,
            2191905,
            2191937,
            2191969,
            2192001,
            2192033,
            2192065,
            2192097,
            2192129
        ]),
        new Uint32Array([
            2230946,
            2231010,
            2231074,
            2231138,
            2231202,
            2231266,
            2231330,
            2231394,
            2231458,
            2231522,
            2231586,
            2231650,
            2231714,
            2231778,
            2231842,
            2231906
        ]),
        new Uint32Array([
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064,
            14680064
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2185953,
            2185985,
            2186017,
            2186049,
            2186081,
            2186113,
            2186145,
            2186177
        ]),
        new Uint32Array([
            2139811,
            2139907,
            2097284,
            2105860,
            2105988,
            2106116,
            2106244,
            2097444,
            2097604,
            2097155,
            10485778,
            10486344,
            2106372,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2110051,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2172385,
            6291456,
            2172417,
            6291456,
            2172449,
            6291456,
            2172481,
            6291456,
            2172513,
            6291456,
            2172545,
            6291456,
            2172577,
            6291456,
            2172609,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2249345,
            2249377,
            2249409,
            2249441,
            2249473,
            2249505,
            2249537,
            2249570,
            2210209,
            2249633,
            2249665,
            2249697,
            2249729,
            2249761,
            2249793,
            2216769
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2187169,
            2187201,
            2187233,
            2187265,
            2187297,
            2187329,
            2187361,
            2187393,
            2187425,
            2187457,
            2187489,
            2187521,
            2187553,
            2187585,
            2187617,
            2187649
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            0,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2182337,
            6291456,
            2182369,
            6291456,
            2182401,
            6291456,
            2182433,
            6291456,
            2182465,
            6291456,
            2182497,
            6291456,
            2182529,
            6291456,
            2182561,
            6291456
        ]),
        new Uint32Array([
            2138179,
            2138275,
            2138371,
            2138467,
            2134243,
            2134435,
            2138563,
            2138659,
            2138755,
            2138851,
            2138947,
            2139043,
            2138947,
            2138755,
            2139139,
            2139235
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2250498,
            2250562,
            2250625,
            2250657,
            2208321,
            2250689,
            2250721,
            2250753,
            2250785,
            2250817,
            2250849,
            2218945,
            2250881,
            2250913,
            2250945,
            0
        ]),
        new Uint32Array([
            2170369,
            2105569,
            2098305,
            2108481,
            2173249,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456
        ]),
        new Uint32Array([
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            0,
            2108193,
            0,
            0,
            0,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481
        ]),
        new Uint32Array([
            2100897,
            2100897,
            2105569,
            2105569,
            6291456,
            2112289,
            2149826,
            6291456,
            6291456,
            2112481,
            2112577,
            2098177,
            2098177,
            2098177,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            2169953,
            2169985,
            6291456,
            2170017,
            6291456,
            2170049,
            2170081,
            6291456,
            2170113,
            2170145,
            2170177,
            6291456,
            6291456,
            2170209,
            2170241
        ]),
        new Uint32Array([
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220641,
            2220641,
            2220673,
            2220673,
            2220673,
            2220673,
            2220705,
            2220705,
            2220705,
            2220705,
            2220737,
            2220737,
            2220737,
            2220737,
            2220769,
            2220769
        ]),
        new Uint32Array([
            2127650,
            2127746,
            2127842,
            2127938,
            2128034,
            2128130,
            2128226,
            2128322,
            2128418,
            2127523,
            2127619,
            2127715,
            2127811,
            2127907,
            2128003,
            2128099
        ]),
        new Uint32Array([
            2143969,
            2173793,
            2173825,
            2153473,
            2173857,
            2173889,
            2173921,
            2173953,
            2173985,
            2173761,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177
        ]),
        new Uint32Array([
            0,
            0,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2204705,
            2204737,
            2204769,
            2204801,
            2204833,
            2204865,
            2204897,
            2204929,
            2204961,
            2204993,
            2205025,
            2205057,
            2205089,
            2205121,
            2205153,
            2205185
        ]),
        new Uint32Array([
            2176385,
            6291456,
            2176417,
            6291456,
            2176449,
            6291456,
            2176481,
            6291456,
            2176513,
            6291456,
            2176545,
            6291456,
            2176577,
            6291456,
            2176609,
            6291456
        ]),
        new Uint32Array([
            2195521,
            2195553,
            2195585,
            2195617,
            2195649,
            2195681,
            2117857,
            2195713,
            2195745,
            2195777,
            2195809,
            2195841,
            2195873,
            2195905,
            2195937,
            2195969
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2173921,
            2173953,
            2173985,
            2174017,
            2174017,
            2174049,
            2174081,
            2174113,
            2174145,
            2174177,
            2149057,
            2233089,
            2173697,
            2173761,
            2173793,
            2174113
        ]),
        new Uint32Array([
            2131586,
            2132450,
            2135970,
            2135778,
            2161602,
            2136162,
            2163650,
            2161794,
            2135586,
            2163714,
            2137186,
            2131810,
            2160290,
            2135170,
            2097506,
            2159554
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            2105953,
            2132705,
            2130977,
            2160065,
            2131297,
            2162049,
            2133089,
            2160577,
            2133857,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2116513,
            2116609,
            2116705,
            2116801,
            2116897,
            2116993,
            2117089,
            2117185,
            2117281,
            2117377,
            2117473,
            2117569,
            2117665,
            2117761,
            2117857,
            2117953
        ]),
        new Uint32Array([
            2100737,
            2098337,
            2101441,
            2101569,
            2101697,
            2101825,
            2101953,
            2102081,
            2102209,
            2100802,
            2101154,
            2101282,
            2101410,
            2101538,
            2101666,
            2101794
        ]),
        new Uint32Array([
            2100289,
            2098657,
            2098049,
            2200737,
            2123489,
            2123681,
            2200769,
            2098625,
            2100321,
            2098145,
            2100449,
            2098017,
            2098753,
            2098977,
            2150241,
            2150305
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2109955,
            6291456,
            6291456,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368,
            18874368
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            6291456,
            0,
            6291456,
            0,
            0
        ]),
        new Uint32Array([
            2130979,
            2131075,
            2131075,
            2131171,
            2131267,
            2131363,
            2131459,
            2131555,
            2131651,
            2131651,
            2131747,
            2131843,
            2131939,
            2132035,
            2132131,
            2132227
        ]),
        new Uint32Array([
            0,
            2177793,
            6291456,
            2177825,
            6291456,
            2177857,
            6291456,
            2177889,
            6291456,
            2177921,
            6291456,
            2177953,
            6291456,
            2177985,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2113345,
            0,
            2098209,
            2111137,
            2105505,
            2098241,
            2108353,
            2108417,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289
        ]),
        new Uint32Array([
            2136643,
            2136739,
            2136835,
            2136931,
            2137027,
            2137123,
            2137219,
            2137315,
            2137411,
            2137507,
            2137603,
            2137699,
            2137795,
            2137891,
            2137987,
            2138083
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0
        ]),
        new Uint32Array([
            2174433,
            6291456,
            2174465,
            6291456,
            2174497,
            6291456,
            2174529,
            6291456,
            2174561,
            6291456,
            2174593,
            6291456,
            2174625,
            6291456,
            2174657,
            6291456
        ]),
        new Uint32Array([
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441
        ]),
        new Uint32Array([
            10496547,
            10496643,
            2105505,
            2149698,
            6291456,
            10496739,
            10496835,
            2170273,
            6291456,
            2149762,
            2105825,
            2111713,
            2111713,
            2111713,
            2111713,
            2168673
        ]),
        new Uint32Array([
            6291456,
            2143490,
            2143490,
            2143490,
            2171649,
            6291456,
            2171681,
            2171713,
            2171745,
            6291456,
            2171777,
            6291456,
            2171809,
            6291456,
            2171841,
            6291456
        ]),
        new Uint32Array([
            2159106,
            2159106,
            2159170,
            2159170,
            2159234,
            2159234,
            2159298,
            2159298,
            2159298,
            2159362,
            2159362,
            2159362,
            2106401,
            2106401,
            2106401,
            2106401
        ]),
        new Uint32Array([
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865,
            2113153,
            2108481,
            2113345,
            2113441,
            2098209,
            2111137
        ]),
        new Uint32Array([
            2108417,
            2181217,
            2181249,
            2181281,
            2170433,
            2170401,
            2181313,
            2181345,
            2181377,
            2181409,
            2181441,
            2181473,
            2181505,
            2181537,
            2170529,
            2181569
        ]),
        new Uint32Array([
            2218433,
            2245761,
            2245793,
            2245825,
            2245857,
            2245890,
            2245953,
            2245986,
            2209665,
            2246050,
            2246113,
            2246146,
            2246210,
            2246274,
            2246337,
            2246369
        ]),
        new Uint32Array([
            2230754,
            2230818,
            2230882,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            0,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2184129,
            6291456,
            2184161,
            6291456,
            2184193,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            2146818,
            2183361,
            6291456,
            6291456,
            2142978,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2135170,
            2097506,
            2130691,
            2130787,
            2130883,
            2163970,
            2164034,
            2164098,
            2164162,
            2164226,
            2164290,
            2164354,
            2164418,
            2164482,
            2164546,
            2133122
        ]),
        new Uint32Array([
            2108515,
            2108611,
            2100740,
            2108707,
            2108803,
            2108899,
            2108995,
            2109091,
            2109187,
            2109283,
            2109379,
            2109475,
            2109571,
            2109667,
            2109763,
            2100738
        ]),
        new Uint32Array([
            2102788,
            2102916,
            2103044,
            2120515,
            2103172,
            2120611,
            2120707,
            2098373,
            2103300,
            2120803,
            2120899,
            2120995,
            2103428,
            2103556,
            2121091,
            2121187
        ]),
        new Uint32Array([
            2158082,
            2158146,
            0,
            2158210,
            2158274,
            0,
            2158338,
            2158402,
            2158466,
            2129922,
            2158530,
            2158594,
            2158658,
            2158722,
            2158786,
            2158850
        ]),
        new Uint32Array([
            10499619,
            10499715,
            10499811,
            10499907,
            10500003,
            10500099,
            10500195,
            10500291,
            10500387,
            10500483,
            10500579,
            10500675,
            10500771,
            10500867,
            10500963,
            10501059
        ]),
        new Uint32Array([
            2239585,
            2239618,
            2239681,
            2239713,
            0,
            2191969,
            2239745,
            2239777,
            2192033,
            2239809,
            2239841,
            2239874,
            2239937,
            2239970,
            2240033,
            2240065
        ]),
        new Uint32Array([
            2252705,
            2252738,
            2252801,
            2252833,
            2252865,
            2252897,
            2252930,
            2252994,
            2253057,
            2253089,
            2253121,
            2253154,
            2253217,
            2253250,
            2219361,
            2219361
        ]),
        new Uint32Array([
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            2108193,
            2112481,
            2112577,
            2098177,
            2098305,
            2108321,
            2108289,
            2100865
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            10538050,
            10538114,
            10538178,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2226402,
            2226466,
            2226530,
            2226594,
            2226658,
            2226722,
            2226786,
            2226850,
            2226914,
            2226978,
            2227042,
            2227106,
            2227170,
            2227234,
            2227298,
            2227362
        ]),
        new Uint32Array([
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            2144066,
            2144130,
            2144194,
            2144258,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2124674,
            2124770,
            2123875,
            2123971,
            2124067,
            2124163,
            2124259,
            2124355,
            2124451,
            2124547,
            2124643,
            2124739,
            2124835,
            2124931,
            2125027,
            2125123
        ]),
        new Uint32Array([
            2168065,
            6291456,
            2168097,
            6291456,
            2168129,
            6291456,
            2168161,
            6291456,
            2168193,
            6291456,
            2168225,
            6291456,
            2168257,
            6291456,
            2168289,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            2100610,
            2100611,
            6291456,
            2107842,
            2107843,
            6291456,
            6291456,
            6291456,
            6291456,
            10537922,
            6291456,
            10537986,
            6291456
        ]),
        new Uint32Array([
            2174849,
            2174881,
            2174913,
            2174945,
            2174977,
            2175009,
            2175041,
            2175073,
            2175105,
            2175137,
            2175169,
            2175201,
            2175233,
            2175265,
            2175297,
            2175329
        ]),
        new Uint32Array([
            2154562,
            2154626,
            2154690,
            2154754,
            2141858,
            2154818,
            2154882,
            2127298,
            2154946,
            2127298,
            2155010,
            2155074,
            2155138,
            2155202,
            2155266,
            2155202
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            0
        ]),
        new Uint32Array([
            2200641,
            2150786,
            2150850,
            2150914,
            2150978,
            2151042,
            2106562,
            2151106,
            2150562,
            2151170,
            2151234,
            2151298,
            2151362,
            2151426,
            2151490,
            2151554
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            6291456,
            6291456
        ]),
        new Uint32Array([
            2220289,
            2220289,
            2220321,
            2220321,
            2220321,
            2220321,
            2220353,
            2220353,
            2220353,
            2220353,
            2220385,
            2220385,
            2220385,
            2220385,
            2220417,
            2220417
        ]),
        new Uint32Array([
            2155330,
            2155394,
            0,
            2155458,
            2155522,
            2155586,
            2105732,
            0,
            2155650,
            2155714,
            2155778,
            2125314,
            2155842,
            2155906,
            2126274,
            2155970
        ]),
        new Uint32Array([
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            23068672,
            23068672,
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2097729,
            2106017,
            2106017,
            2106017,
            2106017,
            2131297,
            2131297,
            2131297,
            2131297,
            2106081,
            2106081,
            2162049,
            2162049,
            2105953,
            2105953,
            2162337
        ]),
        new Uint32Array([
            2097185,
            2097697,
            2097697,
            2097697,
            2097697,
            2135777,
            2135777,
            2135777,
            2135777,
            2097377,
            2097377,
            2097377,
            2097377,
            2097601,
            2097601,
            2097217
        ]),
        new Uint32Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            23068672
        ]),
        new Uint32Array([
            2139331,
            2139427,
            2139523,
            2139043,
            2133571,
            2132611,
            2139619,
            2139715,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2174113,
            2174145,
            2100897,
            2098177,
            2108289,
            2100865,
            2173601,
            2173633,
            2173985,
            2174113,
            2174145,
            6291456,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456,
            23068672,
            6291456,
            6291456,
            6291456,
            6291456
        ]),
        new Uint32Array([
            23068672,
            23068672,
            18923778,
            23068672,
            23068672,
            23068672,
            23068672,
            18923842,
            23068672,
            23068672,
            23068672,
            23068672,
            18923906,
            23068672,
            23068672,
            23068672
        ]),
        new Uint32Array([
            2134145,
            2097153,
            2134241,
            0,
            2132705,
            2130977,
            2160065,
            2131297,
            0,
            2133089,
            0,
            2133857,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            6291456,
            6291456,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2177537,
            6291456,
            2177569,
            6291456,
            2177601,
            6291456,
            2177633,
            6291456,
            2177665,
            6291456,
            2177697,
            6291456,
            2177729,
            6291456,
            2177761,
            6291456
        ]),
        new Uint32Array([
            2212481,
            2212513,
            2212545,
            2212577,
            2197121,
            2212609,
            2212641,
            2212673,
            2212705,
            2212737,
            2212769,
            2212801,
            2212833,
            2212865,
            2212897,
            2212929
        ]),
        new Uint32Array([
            6291456,
            6291456,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ]),
        new Uint32Array([
            2098241,
            2108353,
            2170209,
            2105825,
            2111713,
            2100897,
            2111905,
            2105473,
            2105569,
            2105601,
            2112289,
            6291456,
            2108193,
            2172417,
            2112481,
            2098177
        ]),
        new Uint32Array([
            6291456,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            23068672,
            6291456,
            6291456
        ])
    ];
    var blockIdxes = new Uint16Array([
        616,
        616,
        565,
        147,
        161,
        411,
        330,
        2,
        131,
        131,
        328,
        454,
        241,
        408,
        86,
        86,
        696,
        113,
        285,
        350,
        325,
        301,
        473,
        214,
        639,
        232,
        447,
        64,
        369,
        598,
        124,
        672,
        567,
        223,
        621,
        154,
        107,
        86,
        86,
        86,
        86,
        86,
        86,
        505,
        86,
        68,
        634,
        86,
        218,
        218,
        218,
        218,
        486,
        218,
        218,
        513,
        188,
        608,
        216,
        86,
        217,
        463,
        668,
        85,
        700,
        360,
        184,
        86,
        86,
        86,
        647,
        402,
        153,
        10,
        346,
        718,
        662,
        260,
        145,
        298,
        117,
        1,
        443,
        342,
        138,
        54,
        563,
        86,
        240,
        572,
        218,
        70,
        387,
        86,
        118,
        460,
        641,
        602,
        86,
        86,
        306,
        218,
        86,
        692,
        86,
        86,
        86,
        86,
        86,
        162,
        707,
        86,
        458,
        26,
        86,
        218,
        638,
        86,
        86,
        86,
        86,
        86,
        65,
        449,
        86,
        86,
        306,
        183,
        86,
        58,
        391,
        667,
        86,
        157,
        131,
        131,
        131,
        131,
        86,
        433,
        131,
        406,
        31,
        218,
        247,
        86,
        86,
        693,
        218,
        581,
        351,
        86,
        438,
        295,
        69,
        462,
        45,
        126,
        173,
        650,
        14,
        295,
        69,
        97,
        168,
        187,
        641,
        78,
        523,
        390,
        69,
        108,
        287,
        664,
        173,
        219,
        83,
        295,
        69,
        108,
        431,
        426,
        173,
        694,
        412,
        115,
        628,
        52,
        257,
        398,
        641,
        118,
        501,
        121,
        69,
        579,
        151,
        423,
        173,
        620,
        464,
        121,
        69,
        382,
        151,
        476,
        173,
        27,
        53,
        121,
        86,
        594,
        578,
        226,
        173,
        86,
        632,
        130,
        86,
        96,
        228,
        268,
        641,
        622,
        563,
        86,
        86,
        21,
        148,
        650,
        131,
        131,
        321,
        43,
        144,
        343,
        381,
        531,
        131,
        131,
        178,
        20,
        86,
        399,
        156,
        375,
        164,
        541,
        30,
        60,
        715,
        198,
        92,
        118,
        131,
        131,
        86,
        86,
        306,
        407,
        86,
        280,
        457,
        196,
        488,
        358,
        131,
        131,
        244,
        86,
        86,
        143,
        86,
        86,
        86,
        86,
        86,
        667,
        563,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        336,
        363,
        86,
        86,
        336,
        86,
        86,
        380,
        678,
        67,
        86,
        86,
        86,
        678,
        86,
        86,
        86,
        512,
        86,
        307,
        86,
        708,
        86,
        86,
        86,
        86,
        86,
        528,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        563,
        307,
        86,
        86,
        86,
        86,
        86,
        104,
        450,
        337,
        86,
        720,
        86,
        32,
        450,
        397,
        86,
        86,
        86,
        587,
        218,
        558,
        708,
        708,
        293,
        708,
        86,
        86,
        86,
        86,
        86,
        694,
        205,
        86,
        8,
        86,
        86,
        86,
        86,
        549,
        86,
        667,
        697,
        697,
        679,
        86,
        458,
        460,
        86,
        86,
        650,
        86,
        708,
        543,
        86,
        86,
        86,
        245,
        86,
        86,
        86,
        140,
        218,
        127,
        708,
        708,
        458,
        197,
        131,
        131,
        131,
        131,
        500,
        86,
        86,
        483,
        251,
        86,
        306,
        510,
        515,
        86,
        722,
        86,
        86,
        86,
        65,
        201,
        86,
        86,
        483,
        580,
        470,
        86,
        86,
        86,
        368,
        131,
        131,
        131,
        694,
        114,
        110,
        555,
        86,
        86,
        123,
        721,
        163,
        142,
        713,
        418,
        86,
        317,
        675,
        209,
        218,
        218,
        218,
        371,
        545,
        592,
        629,
        490,
        603,
        199,
        46,
        320,
        525,
        680,
        310,
        279,
        388,
        111,
        42,
        252,
        593,
        607,
        235,
        617,
        410,
        377,
        50,
        548,
        135,
        356,
        17,
        520,
        189,
        116,
        392,
        600,
        349,
        332,
        482,
        699,
        690,
        535,
        119,
        106,
        451,
        71,
        152,
        667,
        131,
        218,
        218,
        265,
        671,
        637,
        492,
        504,
        533,
        683,
        269,
        269,
        658,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        491,
        619,
        86,
        86,
        6,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        229,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        86,
        86,
        171,
        131,
        118,
        131,
        656,
        206,
        234,
        571,
        89,
        334,
        670,
        246,
        311,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        534,
        86,
        86,
        86,
        86,
        86,
        86,
        82,
        86,
        86,
        86,
        86,
        86,
        430,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        599,
        86,
        324,
        86,
        470,
        69,
        640,
        264,
        131,
        626,
        101,
        174,
        86,
        86,
        667,
        233,
        105,
        73,
        374,
        394,
        221,
        204,
        84,
        28,
        326,
        86,
        86,
        471,
        86,
        86,
        86,
        109,
        573,
        86,
        171,
        200,
        200,
        200,
        200,
        218,
        218,
        86,
        86,
        86,
        86,
        460,
        131,
        131,
        131,
        86,
        506,
        86,
        86,
        86,
        86,
        86,
        220,
        404,
        34,
        614,
        47,
        442,
        305,
        25,
        612,
        338,
        601,
        648,
        7,
        344,
        255,
        131,
        131,
        51,
        86,
        312,
        507,
        563,
        86,
        86,
        86,
        86,
        588,
        86,
        86,
        86,
        86,
        86,
        530,
        511,
        86,
        458,
        3,
        435,
        384,
        556,
        522,
        230,
        527,
        86,
        118,
        86,
        86,
        717,
        86,
        137,
        273,
        79,
        181,
        484,
        23,
        93,
        112,
        655,
        249,
        417,
        703,
        370,
        87,
        98,
        313,
        684,
        585,
        155,
        465,
        596,
        481,
        695,
        18,
        416,
        428,
        61,
        701,
        706,
        282,
        643,
        495,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        307,
        86,
        86,
        86,
        171,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        650,
        131,
        422,
        542,
        420,
        263,
        24,
        172,
        86,
        86,
        86,
        86,
        86,
        566,
        86,
        86,
        132,
        540,
        395,
        353,
        494,
        519,
        19,
        485,
        284,
        472,
        131,
        131,
        131,
        16,
        714,
        86,
        211,
        708,
        86,
        86,
        86,
        694,
        698,
        86,
        86,
        483,
        704,
        708,
        218,
        272,
        86,
        86,
        120,
        86,
        159,
        478,
        86,
        307,
        247,
        86,
        86,
        663,
        597,
        459,
        627,
        667,
        86,
        86,
        277,
        455,
        39,
        302,
        86,
        250,
        86,
        86,
        86,
        271,
        99,
        452,
        306,
        281,
        329,
        400,
        200,
        86,
        86,
        362,
        549,
        352,
        646,
        461,
        323,
        586,
        86,
        86,
        4,
        708,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        86,
        518,
        86,
        86,
        650,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        125,
        554,
        480,
        300,
        613,
        72,
        333,
        288,
        561,
        544,
        604,
        48,
        719,
        91,
        169,
        176,
        590,
        224,
        76,
        191,
        29,
        559,
        560,
        231,
        537,
        166,
        477,
        538,
        256,
        437,
        131,
        131,
        469,
        167,
        40,
        0,
        685,
        266,
        441,
        705,
        239,
        642,
        475,
        568,
        640,
        610,
        299,
        673,
        517,
        318,
        385,
        22,
        202,
        180,
        179,
        359,
        424,
        215,
        90,
        66,
        521,
        653,
        467,
        682,
        453,
        409,
        479,
        88,
        131,
        661,
        35,
        303,
        15,
        262,
        666,
        630,
        712,
        131,
        131,
        618,
        659,
        175,
        218,
        195,
        347,
        193,
        227,
        261,
        150,
        165,
        709,
        546,
        294,
        569,
        710,
        270,
        413,
        376,
        524,
        55,
        242,
        38,
        419,
        529,
        170,
        657,
        3,
        304,
        122,
        379,
        278,
        131,
        651,
        86,
        67,
        576,
        458,
        458,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        118,
        309,
        86,
        86,
        547,
        86,
        86,
        86,
        86,
        667,
        650,
        664,
        131,
        131,
        86,
        86,
        56,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        307,
        86,
        86,
        86,
        664,
        238,
        650,
        86,
        86,
        717,
        86,
        118,
        86,
        86,
        315,
        86,
        59,
        86,
        86,
        574,
        549,
        131,
        131,
        340,
        57,
        436,
        86,
        86,
        86,
        86,
        86,
        86,
        458,
        708,
        499,
        691,
        62,
        86,
        650,
        86,
        86,
        694,
        86,
        86,
        86,
        319,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        86,
        549,
        694,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        77,
        86,
        86,
        139,
        86,
        502,
        86,
        86,
        86,
        667,
        595,
        131,
        131,
        131,
        86,
        12,
        86,
        13,
        86,
        609,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        625,
        86,
        669,
        86,
        86,
        182,
        129,
        86,
        5,
        694,
        104,
        86,
        86,
        86,
        86,
        131,
        131,
        86,
        86,
        386,
        171,
        86,
        86,
        86,
        345,
        86,
        324,
        86,
        589,
        86,
        213,
        36,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        104,
        131,
        131,
        131,
        141,
        290,
        80,
        677,
        86,
        86,
        86,
        267,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        667,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        515,
        86,
        86,
        33,
        136,
        669,
        86,
        711,
        515,
        86,
        86,
        550,
        640,
        86,
        104,
        708,
        515,
        86,
        159,
        372,
        717,
        86,
        86,
        444,
        515,
        86,
        86,
        663,
        37,
        86,
        563,
        460,
        86,
        390,
        624,
        702,
        131,
        131,
        131,
        131,
        389,
        59,
        708,
        86,
        86,
        341,
        208,
        708,
        635,
        295,
        69,
        108,
        431,
        508,
        100,
        190,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        649,
        516,
        660,
        131,
        131,
        86,
        86,
        86,
        218,
        631,
        708,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        341,
        575,
        238,
        514,
        131,
        131,
        86,
        86,
        86,
        218,
        291,
        708,
        307,
        131,
        86,
        86,
        306,
        367,
        708,
        131,
        131,
        131,
        86,
        378,
        697,
        86,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        615,
        253,
        86,
        86,
        86,
        292,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        104,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        69,
        86,
        341,
        553,
        549,
        86,
        307,
        86,
        86,
        645,
        275,
        455,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        708,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        460,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        667,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        104,
        86,
        667,
        459,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        458,
        225,
        86,
        86,
        86,
        516,
        549,
        11,
        390,
        405,
        86,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        460,
        44,
        218,
        197,
        711,
        515,
        131,
        131,
        131,
        131,
        664,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        307,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        308,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        118,
        307,
        104,
        286,
        591,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        549,
        86,
        86,
        681,
        86,
        86,
        75,
        185,
        314,
        582,
        86,
        358,
        496,
        474,
        86,
        104,
        131,
        86,
        86,
        86,
        86,
        146,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        171,
        86,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        246,
        503,
        689,
        339,
        674,
        81,
        258,
        415,
        439,
        128,
        562,
        366,
        414,
        246,
        503,
        689,
        583,
        222,
        557,
        316,
        636,
        665,
        186,
        355,
        95,
        670,
        246,
        503,
        689,
        339,
        674,
        557,
        258,
        415,
        439,
        186,
        355,
        95,
        670,
        246,
        503,
        689,
        446,
        644,
        536,
        652,
        331,
        532,
        335,
        440,
        274,
        421,
        297,
        570,
        74,
        425,
        364,
        425,
        606,
        552,
        403,
        509,
        134,
        365,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        218,
        218,
        218,
        498,
        218,
        218,
        577,
        627,
        551,
        497,
        572,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        553,
        354,
        236,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        296,
        455,
        131,
        131,
        456,
        243,
        103,
        86,
        41,
        459,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        9,
        276,
        158,
        716,
        393,
        564,
        383,
        489,
        401,
        654,
        210,
        654,
        131,
        131,
        131,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        650,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        667,
        563,
        563,
        563,
        86,
        549,
        102,
        686,
        133,
        246,
        605,
        86,
        448,
        86,
        86,
        207,
        307,
        131,
        131,
        131,
        641,
        86,
        177,
        611,
        445,
        373,
        194,
        584,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        308,
        307,
        171,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        717,
        86,
        86,
        86,
        86,
        86,
        460,
        131,
        131,
        650,
        86,
        86,
        86,
        694,
        708,
        86,
        86,
        694,
        86,
        458,
        131,
        131,
        131,
        131,
        131,
        131,
        667,
        694,
        289,
        650,
        667,
        131,
        131,
        86,
        640,
        131,
        131,
        664,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        171,
        131,
        131,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        460,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        458,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        86,
        640,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        466,
        203,
        149,
        429,
        94,
        432,
        160,
        687,
        539,
        63,
        237,
        283,
        192,
        248,
        348,
        259,
        427,
        526,
        396,
        676,
        254,
        468,
        487,
        212,
        327,
        623,
        49,
        633,
        322,
        493,
        434,
        688,
        357,
        361,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131,
        131
    ]);
    var mappingStr = "\u0635\u0644\u0649 \u0627\u0644\u0644\u0647 \u0639\u0644\u064A\u0647 \u0648\u0633\u0644\u0645\u062C\u0644 \u062C\u0644\u0627\u0644\u0647\u30AD\u30ED\u30E1\u30FC\u30C8\u30EBrad\u2215s2\u30A8\u30B9\u30AF\u30FC\u30C9\u30AD\u30ED\u30B0\u30E9\u30E0\u30AD\u30ED\u30EF\u30C3\u30C8\u30B0\u30E9\u30E0\u30C8\u30F3\u30AF\u30EB\u30BC\u30A4\u30ED\u30B5\u30F3\u30C1\u30FC\u30E0\u30D1\u30FC\u30BB\u30F3\u30C8\u30D4\u30A2\u30B9\u30C8\u30EB\u30D5\u30A1\u30E9\u30C3\u30C9\u30D6\u30C3\u30B7\u30A7\u30EB\u30D8\u30AF\u30BF\u30FC\u30EB\u30DE\u30F3\u30B7\u30E7\u30F3\u30DF\u30EA\u30D0\u30FC\u30EB\u30EC\u30F3\u30C8\u30B2\u30F3\u2032\u2032\u2032\u20321\u204410viii(10)(11)(12)(13)(14)(15)(16)(17)(18)(19)(20)\u222B\u222B\u222B\u222B(\uC624\uC804)(\uC624\uD6C4)\u30A2\u30D1\u30FC\u30C8\u30A2\u30EB\u30D5\u30A1\u30A2\u30F3\u30DA\u30A2\u30A4\u30CB\u30F3\u30B0\u30A8\u30FC\u30AB\u30FC\u30AB\u30E9\u30C3\u30C8\u30AB\u30ED\u30EA\u30FC\u30AD\u30E5\u30EA\u30FC\u30AE\u30EB\u30C0\u30FC\u30AF\u30ED\u30FC\u30CD\u30B5\u30A4\u30AF\u30EB\u30B7\u30EA\u30F3\u30B0\u30D0\u30FC\u30EC\u30EB\u30D5\u30A3\u30FC\u30C8\u30DD\u30A4\u30F3\u30C8\u30DE\u30A4\u30AF\u30ED\u30DF\u30AF\u30ED\u30F3\u30E1\u30AC\u30C8\u30F3\u30EA\u30C3\u30C8\u30EB\u30EB\u30FC\u30D6\u30EB\u682A\u5F0F\u4F1A\u793Ekcalm\u2215s2c\u2215kg\u0627\u0643\u0628\u0631\u0645\u062D\u0645\u062F\u0635\u0644\u0639\u0645\u0631\u0633\u0648\u0644\u0631\u06CC\u0627\u06441\u204441\u204423\u20444 \u0308\u0301\u0FB2\u0F71\u0F80\u0FB3\u0F71\u0F80 \u0308\u0342 \u0313\u0300 \u0313\u0301 \u0313\u0342 \u0314\u0300 \u0314\u0301 \u0314\u0342 \u0308\u0300\u2035\u2035\u2035a/ca/sc/oc/utelfax1\u204471\u204491\u204432\u204431\u204452\u204453\u204454\u204451\u204465\u204461\u204483\u204485\u204487\u20448xii0\u20443\u222E\u222E\u222E(1)(2)(3)(4)(5)(6)(7)(8)(9)(a)(b)(c)(d)(e)(f)(g)(h)(i)(j)(k)(l)(m)(n)(o)(p)(q)(r)(s)(t)(u)(v)(w)(x)(y)(z)::====(\u1100)(\u1102)(\u1103)(\u1105)(\u1106)(\u1107)(\u1109)(\u110B)(\u110C)(\u110E)(\u110F)(\u1110)(\u1111)(\u1112)(\uAC00)(\uB098)(\uB2E4)(\uB77C)(\uB9C8)(\uBC14)(\uC0AC)(\uC544)(\uC790)(\uCC28)(\uCE74)(\uD0C0)(\uD30C)(\uD558)(\uC8FC)(\u4E00)(\u4E8C)(\u4E09)(\u56DB)(\u4E94)(\u516D)(\u4E03)(\u516B)(\u4E5D)(\u5341)(\u6708)(\u706B)(\u6C34)(\u6728)(\u91D1)(\u571F)(\u65E5)(\u682A)(\u6709)(\u793E)(\u540D)(\u7279)(\u8CA1)(\u795D)(\u52B4)(\u4EE3)(\u547C)(\u5B66)(\u76E3)(\u4F01)(\u8CC7)(\u5354)(\u796D)(\u4F11)(\u81EA)(\u81F3)pte10\u670811\u670812\u6708ergltd\u30A2\u30FC\u30EB\u30A4\u30F3\u30C1\u30A6\u30A9\u30F3\u30AA\u30F3\u30B9\u30AA\u30FC\u30E0\u30AB\u30A4\u30EA\u30AC\u30ED\u30F3\u30AC\u30F3\u30DE\u30AE\u30CB\u30FC\u30B1\u30FC\u30B9\u30B3\u30EB\u30CA\u30B3\u30FC\u30DD\u30BB\u30F3\u30C1\u30C0\u30FC\u30B9\u30CE\u30C3\u30C8\u30CF\u30A4\u30C4\u30D1\u30FC\u30C4\u30D4\u30AF\u30EB\u30D5\u30E9\u30F3\u30DA\u30CB\u30D2\u30D8\u30EB\u30C4\u30DA\u30F3\u30B9\u30DA\u30FC\u30B8\u30D9\u30FC\u30BF\u30DC\u30EB\u30C8\u30DD\u30F3\u30C9\u30DB\u30FC\u30EB\u30DB\u30FC\u30F3\u30DE\u30A4\u30EB\u30DE\u30C3\u30CF\u30DE\u30EB\u30AF\u30E4\u30FC\u30C9\u30E4\u30FC\u30EB\u30E6\u30A2\u30F3\u30EB\u30D4\u30FC10\u70B911\u70B912\u70B913\u70B914\u70B915\u70B916\u70B917\u70B918\u70B919\u70B920\u70B921\u70B922\u70B923\u70B924\u70B9hpabardm2dm3khzmhzghzthzmm2cm2km2mm3cm3km3kpampagpalogmilmolppmv\u2215ma\u2215m10\u65E511\u65E512\u65E513\u65E514\u65E515\u65E516\u65E517\u65E518\u65E519\u65E520\u65E521\u65E522\u65E523\u65E524\u65E525\u65E526\u65E527\u65E528\u65E529\u65E530\u65E531\u65E5galffiffl\u05E9\u05BC\u05C1\u05E9\u05BC\u05C2 \u064C\u0651 \u064D\u0651 \u064E\u0651 \u064F\u0651 \u0650\u0651 \u0651\u0670\u0640\u064E\u0651\u0640\u064F\u0651\u0640\u0650\u0651\u062A\u062C\u0645\u062A\u062D\u062C\u062A\u062D\u0645\u062A\u062E\u0645\u062A\u0645\u062C\u062A\u0645\u062D\u062A\u0645\u062E\u062C\u0645\u062D\u062D\u0645\u064A\u062D\u0645\u0649\u0633\u062D\u062C\u0633\u062C\u062D\u0633\u062C\u0649\u0633\u0645\u062D\u0633\u0645\u062C\u0633\u0645\u0645\u0635\u062D\u062D\u0635\u0645\u0645\u0634\u062D\u0645\u0634\u062C\u064A\u0634\u0645\u062E\u0634\u0645\u0645\u0636\u062D\u0649\u0636\u062E\u0645\u0637\u0645\u062D\u0637\u0645\u0645\u0637\u0645\u064A\u0639\u062C\u0645\u0639\u0645\u0645\u0639\u0645\u0649\u063A\u0645\u0645\u063A\u0645\u064A\u063A\u0645\u0649\u0641\u062E\u0645\u0642\u0645\u062D\u0642\u0645\u0645\u0644\u062D\u0645\u0644\u062D\u064A\u0644\u062D\u0649\u0644\u062C\u062C\u0644\u062E\u0645\u0644\u0645\u062D\u0645\u062D\u062C\u0645\u062D\u064A\u0645\u062C\u062D\u0645\u062C\u0645\u0645\u062E\u0645\u0645\u062C\u062E\u0647\u0645\u062C\u0647\u0645\u0645\u0646\u062D\u0645\u0646\u062D\u0649\u0646\u062C\u0645\u0646\u062C\u0649\u0646\u0645\u064A\u0646\u0645\u0649\u064A\u0645\u0645\u0628\u062E\u064A\u062A\u062C\u064A\u062A\u062C\u0649\u062A\u062E\u064A\u062A\u062E\u0649\u062A\u0645\u064A\u062A\u0645\u0649\u062C\u0645\u064A\u062C\u062D\u0649\u062C\u0645\u0649\u0633\u062E\u0649\u0635\u062D\u064A\u0634\u062D\u064A\u0636\u062D\u064A\u0644\u062C\u064A\u0644\u0645\u064A\u064A\u062D\u064A\u064A\u062C\u064A\u064A\u0645\u064A\u0645\u0645\u064A\u0642\u0645\u064A\u0646\u062D\u064A\u0639\u0645\u064A\u0643\u0645\u064A\u0646\u062C\u062D\u0645\u062E\u064A\u0644\u062C\u0645\u0643\u0645\u0645\u062C\u062D\u064A\u062D\u062C\u064A\u0645\u062C\u064A\u0641\u0645\u064A\u0628\u062D\u064A\u0633\u062E\u064A\u0646\u062C\u064A\u0635\u0644\u06D2\u0642\u0644\u06D2\uD834\uDD58\uD834\uDD65\uD834\uDD6E\uD834\uDD58\uD834\uDD65\uD834\uDD6F\uD834\uDD58\uD834\uDD65\uD834\uDD70\uD834\uDD58\uD834\uDD65\uD834\uDD71\uD834\uDD58\uD834\uDD65\uD834\uDD72\uD834\uDDB9\uD834\uDD65\uD834\uDD6E\uD834\uDDBA\uD834\uDD65\uD834\uDD6E\uD834\uDDB9\uD834\uDD65\uD834\uDD6F\uD834\uDDBA\uD834\uDD65\uD834\uDD6F\u3014s\u3015ppv\u3014\u672C\u3015\u3014\u4E09\u3015\u3014\u4E8C\u3015\u3014\u5B89\u3015\u3014\u70B9\u3015\u3014\u6253\u3015\u3014\u76D7\u3015\u3014\u52DD\u3015\u3014\u6557\u3015 \u0304 \u0301 \u0327ssi\u0307ijl\xb7\u02BCnd\u017Eljnjdz \u0306 \u0307 \u030A \u0328 \u0303 \u030B \u03B9\u0565\u0582\u0627\u0674\u0648\u0674\u06C7\u0674\u064A\u0674\u0915\u093C\u0916\u093C\u0917\u093C\u091C\u093C\u0921\u093C\u0922\u093C\u092B\u093C\u092F\u093C\u09A1\u09BC\u09A2\u09BC\u09AF\u09BC\u0A32\u0A3C\u0A38\u0A3C\u0A16\u0A3C\u0A17\u0A3C\u0A1C\u0A3C\u0A2B\u0A3C\u0B21\u0B3C\u0B22\u0B3C\u0E4D\u0E32\u0ECD\u0EB2\u0EAB\u0E99\u0EAB\u0EA1\u0F42\u0FB7\u0F4C\u0FB7\u0F51\u0FB7\u0F56\u0FB7\u0F5B\u0FB7\u0F40\u0FB5\u0F71\u0F72\u0F71\u0F74\u0FB2\u0F80\u0FB3\u0F80\u0F92\u0FB7\u0F9C\u0FB7\u0FA1\u0FB7\u0FA6\u0FB7\u0FAB\u0FB7\u0F90\u0FB5a\u02BE\u1F00\u03B9\u1F01\u03B9\u1F02\u03B9\u1F03\u03B9\u1F04\u03B9\u1F05\u03B9\u1F06\u03B9\u1F07\u03B9\u1F20\u03B9\u1F21\u03B9\u1F22\u03B9\u1F23\u03B9\u1F24\u03B9\u1F25\u03B9\u1F26\u03B9\u1F27\u03B9\u1F60\u03B9\u1F61\u03B9\u1F62\u03B9\u1F63\u03B9\u1F64\u03B9\u1F65\u03B9\u1F66\u03B9\u1F67\u03B9\u1F70\u03B9\u03B1\u03B9\u03AC\u03B9\u1FB6\u03B9 \u0342\u1F74\u03B9\u03B7\u03B9\u03AE\u03B9\u1FC6\u03B9\u1F7C\u03B9\u03C9\u03B9\u03CE\u03B9\u1FF6\u03B9 \u0333!! \u0305???!!?rs\xb0c\xb0fnosmtmivix\u2ADD\u0338 \u3099 \u309A\u3088\u308A\u30B3\u30C8333435\uCC38\uACE0\uC8FC\uC758363738394042444546474849503\u67084\u67085\u67086\u67087\u67088\u67089\u6708hgev\u30AE\u30AC\u30C7\u30B7\u30C9\u30EB\u30CA\u30CE\u30D4\u30B3\u30D3\u30EB\u30DA\u30BD\u30DB\u30F3\u30EA\u30E9\u30EC\u30E0daauovpciu\u5E73\u6210\u662D\u548C\u5927\u6B63\u660E\u6CBBna\u03BCakakbmbgbpfnf\u03BCf\u03BCgmg\u03BClmldlklfmnm\u03BCmpsns\u03BCsmsnv\u03BCvkvpwnw\u03BCwmwkwk\u03C9m\u03C9bqcccddbgyhainkkktlnlxphprsrsvwbst\u0574\u0576\u0574\u0565\u0574\u056B\u057E\u0576\u0574\u056D\u05D9\u05B4\u05F2\u05B7\u05E9\u05C1\u05E9\u05C2\u05D0\u05B7\u05D0\u05B8\u05D0\u05BC\u05D1\u05BC\u05D2\u05BC\u05D3\u05BC\u05D4\u05BC\u05D5\u05BC\u05D6\u05BC\u05D8\u05BC\u05D9\u05BC\u05DA\u05BC\u05DB\u05BC\u05DC\u05BC\u05DE\u05BC\u05E0\u05BC\u05E1\u05BC\u05E3\u05BC\u05E4\u05BC\u05E6\u05BC\u05E7\u05BC\u05E8\u05BC\u05EA\u05BC\u05D5\u05B9\u05D1\u05BF\u05DB\u05BF\u05E4\u05BF\u05D0\u05DC\u0626\u0627\u0626\u06D5\u0626\u0648\u0626\u06C7\u0626\u06C6\u0626\u06C8\u0626\u06D0\u0626\u0649\u0626\u062C\u0626\u062D\u0626\u0645\u0626\u064A\u0628\u062C\u0628\u0645\u0628\u0649\u0628\u064A\u062A\u0649\u062A\u064A\u062B\u062C\u062B\u0645\u062B\u0649\u062B\u064A\u062E\u062D\u0636\u062C\u0636\u0645\u0637\u062D\u0638\u0645\u063A\u062C\u0641\u062C\u0641\u062D\u0641\u0649\u0641\u064A\u0642\u062D\u0642\u0649\u0642\u064A\u0643\u0627\u0643\u062C\u0643\u062D\u0643\u062E\u0643\u0644\u0643\u0649\u0643\u064A\u0646\u062E\u0646\u0649\u0646\u064A\u0647\u062C\u0647\u0649\u0647\u064A\u064A\u0649\u0630\u0670\u0631\u0670\u0649\u0670\u0626\u0631\u0626\u0632\u0626\u0646\u0628\u0632\u0628\u0646\u062A\u0631\u062A\u0632\u062A\u0646\u062B\u0631\u062B\u0632\u062B\u0646\u0645\u0627\u0646\u0631\u0646\u0632\u0646\u0646\u064A\u0631\u064A\u0632\u0626\u062E\u0626\u0647\u0628\u0647\u062A\u0647\u0635\u062E\u0646\u0647\u0647\u0670\u062B\u0647\u0633\u0647\u0634\u0647\u0637\u0649\u0637\u064A\u0639\u0649\u0639\u064A\u063A\u0649\u063A\u064A\u0633\u0649\u0633\u064A\u0634\u0649\u0634\u064A\u0635\u0649\u0635\u064A\u0636\u0649\u0636\u064A\u0634\u062E\u0634\u0631\u0633\u0631\u0635\u0631\u0636\u0631\u0627\u064B \u064B\u0640\u064B\u0640\u0651 \u0652\u0640\u0652\u0644\u0622\u0644\u0623\u0644\u0625\uD834\uDD57\uD834\uDD650,1,2,3,4,5,6,7,8,9,wzhvsdwcmcmddj\u307B\u304B\u30B3\u30B3\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf8\xf9\xfa\xfb\xfc\xfd\xfe\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0135\u0137\u013A\u013C\u013E\u0142\u0144\u0146\u0148\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\xff\u017A\u017C\u0253\u0183\u0185\u0254\u0188\u0256\u0257\u018C\u01DD\u0259\u025B\u0192\u0260\u0263\u0269\u0268\u0199\u026F\u0272\u0275\u01A1\u01A3\u01A5\u0280\u01A8\u0283\u01AD\u0288\u01B0\u028A\u028B\u01B4\u01B6\u0292\u01B9\u01BD\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F5\u0195\u01BF\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u019E\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233\u2C65\u023C\u019A\u2C66\u0242\u0180\u0289\u028C\u0247\u0249\u024B\u024D\u024F\u0266\u0279\u027B\u0281\u0295\u0371\u0373\u02B9\u0377;\u03F3\u03AD\u03AF\u03CC\u03CD\u03B2\u03B3\u03B4\u03B5\u03B6\u03B8\u03BA\u03BB\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03CA\u03CB\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF\u03F8\u03FB\u037B\u037C\u037D\u0450\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\u045D\u045E\u045F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561\u0562\u0563\u0564\u0566\u0567\u0568\u0569\u056A\u056C\u056E\u056F\u0570\u0571\u0572\u0573\u0575\u0577\u0578\u0579\u057A\u057B\u057C\u057D\u057F\u0580\u0581\u0583\u0584\u0585\u0586\u0F0B\u2D27\u2D2D\u10DC\u13F0\u13F1\u13F2\u13F3\u13F4\u13F5\uA64B\u0250\u0251\u1D02\u025C\u1D16\u1D17\u1D1D\u1D25\u0252\u0255\u025F\u0261\u0265\u026A\u1D7B\u029D\u026D\u1D85\u029F\u0271\u0270\u0273\u0274\u0278\u0282\u01AB\u1D1C\u0290\u0291\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF\u1F10\u1F11\u1F12\u1F13\u1F14\u1F15\u1F30\u1F31\u1F32\u1F33\u1F34\u1F35\u1F36\u1F37\u1F40\u1F41\u1F42\u1F43\u1F44\u1F45\u1F51\u1F53\u1F55\u1F57\u1FB0\u1FB1\u1F72\u0390\u1FD0\u1FD1\u1F76\u03B0\u1FE0\u1FE1\u1F7A\u1FE5`\u1F78\u2010+\u2212\u2211\u3008\u3009\u2C30\u2C31\u2C32\u2C33\u2C34\u2C35\u2C36\u2C37\u2C38\u2C39\u2C3A\u2C3B\u2C3C\u2C3D\u2C3E\u2C3F\u2C40\u2C41\u2C42\u2C43\u2C44\u2C45\u2C46\u2C47\u2C48\u2C49\u2C4A\u2C4B\u2C4C\u2C4D\u2C4E\u2C4F\u2C50\u2C51\u2C52\u2C53\u2C54\u2C55\u2C56\u2C57\u2C58\u2C59\u2C5A\u2C5B\u2C5C\u2C5D\u2C5E\u2C61\u026B\u1D7D\u027D\u2C68\u2C6A\u2C6C\u2C73\u2C76\u023F\u0240\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CEC\u2CEE\u2CF3\u2D61\u6BCD\u9F9F\u4E28\u4E36\u4E3F\u4E59\u4E85\u4EA0\u4EBA\u513F\u5165\u5182\u5196\u51AB\u51E0\u51F5\u5200\u529B\u52F9\u5315\u531A\u5338\u535C\u5369\u5382\u53B6\u53C8\u53E3\u56D7\u58EB\u5902\u590A\u5915\u5973\u5B50\u5B80\u5BF8\u5C0F\u5C22\u5C38\u5C6E\u5C71\u5DDB\u5DE5\u5DF1\u5DFE\u5E72\u5E7A\u5E7F\u5EF4\u5EFE\u5F0B\u5F13\u5F50\u5F61\u5F73\u5FC3\u6208\u6236\u624B\u652F\u6534\u6587\u6597\u65A4\u65B9\u65E0\u66F0\u6B20\u6B62\u6B79\u6BB3\u6BCB\u6BD4\u6BDB\u6C0F\u6C14\u722A\u7236\u723B\u723F\u7247\u7259\u725B\u72AC\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7530\u758B\u7592\u7676\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79B8\u79BE\u7A74\u7ACB\u7AF9\u7C73\u7CF8\u7F36\u7F51\u7F8A\u7FBD\u8001\u800C\u8012\u8033\u807F\u8089\u81E3\u81FC\u820C\u821B\u821F\u826E\u8272\u8278\u864D\u866B\u8840\u884C\u8863\u897E\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C78\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FB5\u9091\u9149\u91C6\u91CC\u9577\u9580\u961C\u96B6\u96B9\u96E8\u9751\u975E\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u99AC\u9AA8\u9AD8\u9ADF\u9B25\u9B2F\u9B32\u9B3C\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u9EC3\u9ECD\u9ED1\u9EF9\u9EFD\u9F0E\u9F13\u9F20\u9F3B\u9F4A\u9F52\u9F8D\u9F9C\u9FA0.\u3012\u5344\u5345\u1101\u11AA\u11AC\u11AD\u1104\u11B0\u11B1\u11B2\u11B3\u11B4\u11B5\u111A\u1108\u1121\u110A\u110D\u1161\u1162\u1163\u1164\u1165\u1166\u1167\u1168\u1169\u116A\u116B\u116C\u116D\u116E\u116F\u1170\u1171\u1172\u1173\u1174\u1175\u1114\u1115\u11C7\u11C8\u11CC\u11CE\u11D3\u11D7\u11D9\u111C\u11DD\u11DF\u111D\u111E\u1120\u1122\u1123\u1127\u1129\u112B\u112C\u112D\u112E\u112F\u1132\u1136\u1140\u1147\u114C\u11F1\u11F2\u1157\u1158\u1159\u1184\u1185\u1188\u1191\u1192\u1194\u119E\u11A1\u4E0A\u4E2D\u4E0B\u7532\u4E19\u4E01\u5929\u5730\u554F\u5E7C\u7B8F\uC6B0\u79D8\u7537\u9069\u512A\u5370\u6CE8\u9805\u5199\u5DE6\u53F3\u533B\u5B97\u591C\u30C6\u30CC\u30E2\u30E8\u30F0\u30F1\u30F2\uA641\uA643\uA645\uA647\uA649\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA77A\uA77C\u1D79\uA77F\uA781\uA783\uA785\uA787\uA78C\uA791\uA793\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\u026C\u029E\u0287\uAB53\uA7B5\uA7B7\uAB37\uAB52\u13A0\u13A1\u13A2\u13A3\u13A4\u13A5\u13A6\u13A7\u13A8\u13A9\u13AA\u13AB\u13AC\u13AD\u13AE\u13AF\u13B0\u13B1\u13B2\u13B3\u13B4\u13B5\u13B6\u13B7\u13B8\u13B9\u13BA\u13BB\u13BC\u13BD\u13BE\u13BF\u13C0\u13C1\u13C2\u13C3\u13C4\u13C5\u13C6\u13C7\u13C8\u13C9\u13CA\u13CB\u13CC\u13CD\u13CE\u13CF\u13D0\u13D1\u13D2\u13D3\u13D4\u13D5\u13D6\u13D7\u13D8\u13D9\u13DA\u13DB\u13DC\u13DD\u13DE\u13DF\u13E0\u13E1\u13E2\u13E3\u13E4\u13E5\u13E6\u13E7\u13E8\u13E9\u13EA\u13EB\u13EC\u13ED\u13EE\u13EF\u8C48\u66F4\u8CC8\u6ED1\u4E32\u53E5\u5951\u5587\u5948\u61F6\u7669\u7F85\u863F\u87BA\u88F8\u908F\u6A02\u6D1B\u70D9\u73DE\u843D\u916A\u99F1\u4E82\u5375\u6B04\u721B\u862D\u9E1E\u5D50\u6FEB\u85CD\u8964\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u90CE\u4F86\u51B7\u52DE\u64C4\u6AD3\u7210\u76E7\u8606\u865C\u8DEF\u9732\u9B6F\u9DFA\u788C\u797F\u7DA0\u83C9\u9304\u8AD6\u58DF\u5F04\u7C60\u807E\u7262\u78CA\u8CC2\u96F7\u58D8\u5C62\u6A13\u6DDA\u6F0F\u7D2F\u7E37\u964B\u52D2\u808B\u51DC\u51CC\u7A1C\u7DBE\u83F1\u9675\u8B80\u62CF\u8AFE\u4E39\u5BE7\u6012\u7387\u7570\u5317\u78FB\u4FBF\u5FA9\u4E0D\u6CCC\u6578\u7D22\u53C3\u585E\u7701\u8449\u8AAA\u6BBA\u6C88\u62FE\u82E5\u63A0\u7565\u4EAE\u5169\u51C9\u6881\u7CE7\u826F\u8AD2\u91CF\u52F5\u5442\u5EEC\u65C5\u6FFE\u792A\u95AD\u9A6A\u9E97\u9ECE\u66C6\u6B77\u8F62\u5E74\u6190\u6200\u649A\u6F23\u7149\u7489\u79CA\u7DF4\u806F\u8F26\u84EE\u9023\u934A\u5217\u52A3\u54BD\u70C8\u88C2\u5EC9\u5FF5\u637B\u6BAE\u7C3E\u7375\u4EE4\u56F9\u5DBA\u601C\u73B2\u7469\u7F9A\u8046\u9234\u96F6\u9748\u9818\u4F8B\u79AE\u91B4\u96B8\u60E1\u4E86\u50DA\u5BEE\u5C3F\u6599\u71CE\u7642\u84FC\u907C\u6688\u962E\u5289\u677B\u67F3\u6D41\u6E9C\u7409\u7559\u786B\u7D10\u985E\u622E\u9678\u502B\u5D19\u6DEA\u8F2A\u5F8B\u6144\u6817\u9686\u5229\u540F\u5C65\u6613\u674E\u68A8\u6CE5\u7406\u75E2\u7F79\u88CF\u88E1\u96E2\u533F\u6EBA\u541D\u71D0\u7498\u85FA\u96A3\u9C57\u9E9F\u6797\u6DCB\u81E8\u7B20\u7C92\u72C0\u7099\u8B58\u4EC0\u8336\u523A\u5207\u5EA6\u62D3\u7CD6\u5B85\u6D1E\u66B4\u8F3B\u964D\u5ED3\u5140\u55C0\u585A\u6674\u51DE\u732A\u76CA\u793C\u795E\u7965\u798F\u9756\u7CBE\u8612\u8AF8\u9038\u90FD\u98EF\u98FC\u9928\u9DB4\u90DE\u96B7\u4FAE\u50E7\u514D\u52C9\u52E4\u5351\u559D\u5606\u5668\u5840\u58A8\u5C64\u6094\u6168\u618E\u61F2\u654F\u65E2\u6691\u6885\u6D77\u6E1A\u6F22\u716E\u722B\u7422\u7891\u7949\u7948\u7950\u7956\u798D\u798E\u7A40\u7A81\u7BC0\u7E09\u7E41\u7F72\u8005\u81ED\u8279\u8457\u8910\u8996\u8B01\u8B39\u8CD3\u8D08\u8FB6\u96E3\u97FF\u983B\u6075\uD850\uDEEE\u8218\u4E26\u51B5\u5168\u4F80\u5145\u5180\u52C7\u52FA\u5555\u5599\u55E2\u58B3\u5944\u5954\u5A62\u5B28\u5ED2\u5ED9\u5F69\u5FAD\u60D8\u614E\u6108\u6160\u6234\u63C4\u641C\u6452\u6556\u671B\u6756\u6EDB\u6ECB\u701E\u77A7\u7235\u72AF\u7471\u7506\u753B\u761D\u761F\u76DB\u76F4\u774A\u7740\u78CC\u7AB1\u7C7B\u7D5B\u7F3E\u8352\u83EF\u8779\u8941\u8986\u8ABF\u8ACB\u8AED\u8B8A\u8F38\u9072\u9199\u9276\u967C\u97DB\u980B\u9B12\uD84A\uDC4A\uD84A\uDC44\uD84C\uDFD5\u3B9D\u4018\u4039\uD854\uDE49\uD857\uDCD0\uD85F\uDED3\u9F43\u9F8E\u05E2\u05DD\u0671\u067B\u067E\u0680\u067A\u067F\u0679\u06A4\u06A6\u0684\u0683\u0686\u0687\u068D\u068C\u068E\u0688\u0698\u0691\u06A9\u06AF\u06B3\u06B1\u06BA\u06BB\u06C0\u06C1\u06BE\u06D3\u06AD\u06CB\u06C5\u06C9\u3001\u3016\u3017\u2014\u2013_{}\u3010\u3011\u300A\u300B\u300C\u300D\u300E\u300F[]#&*-<>\\$%@\u0621\u0624\u0629\"'^|~\u2985\u2986\u30FB\u30A5\u30E3\xa2\xa3\xac\xa6\xa5\u20A9\u2502\u2190\u2191\u2192\u2193\u25A0\u25CB\uD801\uDC28\uD801\uDC29\uD801\uDC2A\uD801\uDC2B\uD801\uDC2C\uD801\uDC2D\uD801\uDC2E\uD801\uDC2F\uD801\uDC30\uD801\uDC31\uD801\uDC32\uD801\uDC33\uD801\uDC34\uD801\uDC35\uD801\uDC36\uD801\uDC37\uD801\uDC38\uD801\uDC39\uD801\uDC3A\uD801\uDC3B\uD801\uDC3C\uD801\uDC3D\uD801\uDC3E\uD801\uDC3F\uD801\uDC40\uD801\uDC41\uD801\uDC42\uD801\uDC43\uD801\uDC44\uD801\uDC45\uD801\uDC46\uD801\uDC47\uD801\uDC48\uD801\uDC49\uD801\uDC4A\uD801\uDC4B\uD801\uDC4C\uD801\uDC4D\uD801\uDC4E\uD801\uDC4F\uD801\uDCD8\uD801\uDCD9\uD801\uDCDA\uD801\uDCDB\uD801\uDCDC\uD801\uDCDD\uD801\uDCDE\uD801\uDCDF\uD801\uDCE0\uD801\uDCE1\uD801\uDCE2\uD801\uDCE3\uD801\uDCE4\uD801\uDCE5\uD801\uDCE6\uD801\uDCE7\uD801\uDCE8\uD801\uDCE9\uD801\uDCEA\uD801\uDCEB\uD801\uDCEC\uD801\uDCED\uD801\uDCEE\uD801\uDCEF\uD801\uDCF0\uD801\uDCF1\uD801\uDCF2\uD801\uDCF3\uD801\uDCF4\uD801\uDCF5\uD801\uDCF6\uD801\uDCF7\uD801\uDCF8\uD801\uDCF9\uD801\uDCFA\uD801\uDCFB\uD803\uDCC0\uD803\uDCC1\uD803\uDCC2\uD803\uDCC3\uD803\uDCC4\uD803\uDCC5\uD803\uDCC6\uD803\uDCC7\uD803\uDCC8\uD803\uDCC9\uD803\uDCCA\uD803\uDCCB\uD803\uDCCC\uD803\uDCCD\uD803\uDCCE\uD803\uDCCF\uD803\uDCD0\uD803\uDCD1\uD803\uDCD2\uD803\uDCD3\uD803\uDCD4\uD803\uDCD5\uD803\uDCD6\uD803\uDCD7\uD803\uDCD8\uD803\uDCD9\uD803\uDCDA\uD803\uDCDB\uD803\uDCDC\uD803\uDCDD\uD803\uDCDE\uD803\uDCDF\uD803\uDCE0\uD803\uDCE1\uD803\uDCE2\uD803\uDCE3\uD803\uDCE4\uD803\uDCE5\uD803\uDCE6\uD803\uDCE7\uD803\uDCE8\uD803\uDCE9\uD803\uDCEA\uD803\uDCEB\uD803\uDCEC\uD803\uDCED\uD803\uDCEE\uD803\uDCEF\uD803\uDCF0\uD803\uDCF1\uD803\uDCF2\uD806\uDCC0\uD806\uDCC1\uD806\uDCC2\uD806\uDCC3\uD806\uDCC4\uD806\uDCC5\uD806\uDCC6\uD806\uDCC7\uD806\uDCC8\uD806\uDCC9\uD806\uDCCA\uD806\uDCCB\uD806\uDCCC\uD806\uDCCD\uD806\uDCCE\uD806\uDCCF\uD806\uDCD0\uD806\uDCD1\uD806\uDCD2\uD806\uDCD3\uD806\uDCD4\uD806\uDCD5\uD806\uDCD6\uD806\uDCD7\uD806\uDCD8\uD806\uDCD9\uD806\uDCDA\uD806\uDCDB\uD806\uDCDC\uD806\uDCDD\uD806\uDCDE\uD806\uDCDF\u0131\u0237\u2207\u2202\uD83A\uDD22\uD83A\uDD23\uD83A\uDD24\uD83A\uDD25\uD83A\uDD26\uD83A\uDD27\uD83A\uDD28\uD83A\uDD29\uD83A\uDD2A\uD83A\uDD2B\uD83A\uDD2C\uD83A\uDD2D\uD83A\uDD2E\uD83A\uDD2F\uD83A\uDD30\uD83A\uDD31\uD83A\uDD32\uD83A\uDD33\uD83A\uDD34\uD83A\uDD35\uD83A\uDD36\uD83A\uDD37\uD83A\uDD38\uD83A\uDD39\uD83A\uDD3A\uD83A\uDD3B\uD83A\uDD3C\uD83A\uDD3D\uD83A\uDD3E\uD83A\uDD3F\uD83A\uDD40\uD83A\uDD41\uD83A\uDD42\uD83A\uDD43\u066E\u06A1\u066F\u5B57\u53CC\u591A\u89E3\u4EA4\u6620\u7121\u524D\u5F8C\u518D\u65B0\u521D\u7D42\u8CA9\u58F0\u5439\u6F14\u6295\u6355\u904A\u6307\u7981\u7A7A\u5408\u6E80\u7533\u5272\u55B6\u914D\u5F97\u53EF\u4E3D\u4E38\u4E41\uD840\uDD22\u4F60\u4FBB\u5002\u507A\u5099\u50CF\u349E\uD841\uDE3A\u5154\u5164\u5177\uD841\uDD1C\u34B9\u5167\uD841\uDD4B\u5197\u51A4\u4ECC\u51AC\uD864\uDDDF\u5203\u34DF\u523B\u5246\u5277\u3515\u5305\u5306\u5349\u535A\u5373\u537D\u537F\uD842\uDE2C\u7070\u53CA\u53DF\uD842\uDF63\u53EB\u53F1\u5406\u549E\u5438\u5448\u5468\u54A2\u54F6\u5510\u5553\u5563\u5584\u55AB\u55B3\u55C2\u5716\u5717\u5651\u5674\u58EE\u57CE\u57F4\u580D\u578B\u5832\u5831\u58AC\uD845\uDCE4\u58F2\u58F7\u5906\u5922\u5962\uD845\uDEA8\uD845\uDEEA\u59EC\u5A1B\u5A27\u59D8\u5A66\u36EE\u5B08\u5B3E\uD846\uDDC8\u5BC3\u5BD8\u5BF3\uD846\uDF18\u5BFF\u5C06\u3781\u5C60\u5CC0\u5C8D\uD847\uDDE4\u5D43\uD847\uDDE6\u5D6E\u5D6B\u5D7C\u5DE1\u5DE2\u382F\u5DFD\u5E28\u5E3D\u5E69\u3862\uD848\uDD83\u387C\u5EB0\u5EB3\u5EB6\uD868\uDF92\uD848\uDF31\u8201\u5F22\u38C7\uD84C\uDEB8\uD858\uDDDA\u5F62\u5F6B\u38E3\u5F9A\u5FCD\u5FD7\u5FF9\u6081\u393A\u391C\uD849\uDED4\u60C7\u6148\u614C\u617A\u61B2\u61A4\u61AF\u61DE\u621B\u625D\u62B1\u62D4\u6350\uD84A\uDF0C\u633D\u62FC\u6368\u6383\u63E4\uD84A\uDFF1\u6422\u63C5\u63A9\u3A2E\u6469\u647E\u649D\u6477\u3A6C\u656C\uD84C\uDC0A\u65E3\u66F8\u6649\u3B19\u3B08\u3AE4\u5192\u5195\u6700\u669C\u80AD\u43D9\u6721\u675E\u6753\uD84C\uDFC3\u3B49\u67FA\u6785\u6852\uD84D\uDC6D\u688E\u681F\u6914\u6942\u69A3\u69EA\u6AA8\uD84D\uDEA3\u6ADB\u3C18\u6B21\uD84E\uDCA7\u6B54\u3C4E\u6B72\u6B9F\u6BBB\uD84E\uDE8D\uD847\uDD0B\uD84E\uDEFA\u6C4E\uD84F\uDCBC\u6CBF\u6CCD\u6C67\u6D16\u6D3E\u6D69\u6D78\u6D85\uD84F\uDD1E\u6D34\u6E2F\u6E6E\u3D33\u6EC7\uD84F\uDED1\u6DF9\u6F6E\uD84F\uDF5E\uD84F\uDF8E\u6FC6\u7039\u701B\u3D96\u704A\u707D\u7077\u70AD\uD841\uDD25\u7145\uD850\uDE63\u719C\u7228\u7250\uD851\uDE08\u7280\u7295\uD851\uDF35\uD852\uDC14\u737A\u738B\u3EAC\u73A5\u3EB8\u7447\u745C\u7485\u74CA\u3F1B\u7524\uD853\uDC36\u753E\uD853\uDC92\uD848\uDD9F\u7610\uD853\uDFA1\uD853\uDFB8\uD854\uDC44\u3FFC\u4008\uD854\uDCF3\uD854\uDCF2\uD854\uDD19\uD854\uDD33\u771E\u771F\u778B\u4046\u4096\uD855\uDC1D\u784E\u40E3\uD855\uDE26\uD855\uDE9A\uD855\uDEC5\u79EB\u412F\u7A4A\u7A4F\uD856\uDD7C\uD856\uDEA7\u4202\uD856\uDFAB\u7BC6\u7BC9\u4227\uD857\uDC80\u7CD2\u42A0\u7CE8\u7CE3\u7D00\uD857\uDF86\u7D63\u4301\u7DC7\u7E02\u7E45\u4334\uD858\uDE28\uD858\uDE47\u4359\uD858\uDED9\u7F7A\uD858\uDF3E\u7F95\u7FFA\uD859\uDCDA\uD859\uDD23\u8060\uD859\uDDA8\u8070\uD84C\uDF5F\u43D5\u80B2\u8103\u440B\u813E\u5AB5\uD859\uDFA7\uD859\uDFB5\uD84C\uDF93\uD84C\uDF9C\u8204\u8F9E\u446B\u8291\u828B\u829D\u52B3\u82B1\u82B3\u82BD\u82E6\uD85A\uDF3C\u831D\u8363\u83AD\u8323\u83BD\u83E7\u8353\u83CA\u83CC\u83DC\uD85B\uDC36\uD85B\uDD6B\uD85B\uDCD5\u452B\u84F1\u84F3\u8516\uD85C\uDFCA\u8564\uD85B\uDF2C\u455D\u4561\uD85B\uDFB1\uD85C\uDCD2\u456B\u8650\u8667\u8669\u86A9\u8688\u870E\u86E2\u8728\u876B\u8786\u87E1\u8801\u45F9\u8860\uD85D\uDE67\u88D7\u88DE\u4635\u88FA\u34BB\uD85E\uDCAE\uD85E\uDD66\u46BE\u46C7\u8AA0\uD85F\uDCA8\u8CAB\u8CC1\u8D1B\u8D77\uD85F\uDF2F\uD842\uDC04\u8DCB\u8DBC\u8DF0\uD842\uDCDE\u8ED4\uD861\uDDD2\uD861\uDDED\u9094\u90F1\u9111\uD861\uDF2E\u911B\u9238\u92D7\u92D8\u927C\u93F9\u9415\uD862\uDFFA\u958B\u4995\u95B7\uD863\uDD77\u49E6\u96C3\u5DB2\u9723\uD864\uDD45\uD864\uDE1A\u4A6E\u4A76\u97E0\uD865\uDC0A\u4AB2\uD865\uDC96\u9829\uD865\uDDB6\u98E2\u4B33\u9929\u99A7\u99C2\u99FE\u4BCE\uD866\uDF30\u9C40\u9CFD\u4CCE\u4CED\u9D67\uD868\uDCCE\u4CF8\uD868\uDD05\uD868\uDE0E\uD868\uDE91\u4D56\u9EFE\u9F05\u9F0F\u9F16\uD869\uDE00";
    function mapChar(codePoint) {
        if (codePoint >= 0x30000) {
            // High planes are special cased.
            if (codePoint >= 0xE0100 && codePoint <= 0xE01EF) return 18874368;
            return 0;
        }
        return blocks[blockIdxes[codePoint >> 4]][codePoint & 15];
    }
    return {
        mapStr: mappingStr,
        mapChar: mapChar
    };
});

});

parcelRegister("g2JpA", function(module, exports) {
/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $bae00f13a98ee960$require$Buffer = $ihoyg.Buffer;
"use strict";

var $9q7Fh = parcelRequire("9q7Fh");

var $ektAJ = parcelRequire("ektAJ");

var $1TtMw = parcelRequire("1TtMw");

var $ecpNJ = parcelRequire("ecpNJ");
exports = module.exports;
/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {string|number} multicodecStrOrCode
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.addPrefix = (multicodecStrOrCode, data)=>{
    let prefix;
    if ($bae00f13a98ee960$require$Buffer.isBuffer(multicodecStrOrCode)) prefix = $ecpNJ.varintBufferEncode(multicodecStrOrCode);
    else {
        if ($1TtMw[multicodecStrOrCode]) prefix = $1TtMw[multicodecStrOrCode];
        else throw new Error("multicodec not recognized");
    }
    return $bae00f13a98ee960$require$Buffer.concat([
        prefix,
        data
    ]);
};
/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.rmPrefix = (data)=>{
    $9q7Fh.decode(data);
    return data.slice($9q7Fh.decode.bytes);
};
/**
 * Get the codec of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {string}
 */ exports.getCodec = (prefixedData)=>{
    const code = $9q7Fh.decode(prefixedData);
    const codecName = $ektAJ.get(code);
    if (codecName === undefined) throw new Error(`Code ${code} not found`);
    return codecName;
};
/**
 * Get the name of the codec.
 * @param {number} codec
 * @returns {string}
 */ exports.getName = (codec)=>{
    return $ektAJ.get(codec);
};
/**
 * Get the code of the codec
 * @param {string} name
 * @returns {number}
 */ exports.getNumber = (name)=>{
    const code = $1TtMw[name];
    if (code === undefined) throw new Error("Codec `" + name + "` not found");
    return $ecpNJ.varintBufferDecode(code)[0];
};
/**
 * Get the code of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {number}
 */ exports.getCode = (prefixedData)=>{
    return $9q7Fh.decode(prefixedData);
};
/**
 * Get the code as varint of a codec name.
 * @param {string} codecName
 * @returns {Buffer}
 */ exports.getCodeVarint = (codecName)=>{
    const code = $1TtMw[codecName];
    if (code === undefined) throw new Error("Codec `" + codecName + "` not found");
    return code;
};
/**
 * Get the varint of a code.
 * @param {Number} code
 * @returns {Array.<number>}
 */ exports.getVarint = (code)=>{
    return $9q7Fh.encode(code);
};

var $6POqb = parcelRequire("6POqb");
Object.assign(exports, $6POqb);

// Human friendly names for printing, e.g. in error messages
exports.print = (parcelRequire("250EQ"));

});
parcelRegister("ektAJ", function(module, exports) {
"use strict";

var $2zY2y = parcelRequire("2zY2y");
// map for hexString -> codecName
const $a6e9e334befb63c3$var$nameTable = new Map();
for(const encodingName in $2zY2y){
    const code = $2zY2y[encodingName];
    $a6e9e334befb63c3$var$nameTable.set(code, encodingName);
}
module.exports = Object.freeze($a6e9e334befb63c3$var$nameTable);

});
parcelRegister("2zY2y", function(module, exports) {
module.exports = JSON.parse('{"identity":0,"ip4":4,"tcp":6,"sha1":17,"sha2-256":18,"sha2-512":19,"sha3-512":20,"sha3-384":21,"sha3-256":22,"sha3-224":23,"shake-128":24,"shake-256":25,"keccak-224":26,"keccak-256":27,"keccak-384":28,"keccak-512":29,"dccp":33,"murmur3-128":34,"murmur3-32":35,"ip6":41,"ip6zone":42,"path":47,"multicodec":48,"multihash":49,"multiaddr":50,"multibase":51,"dns":53,"dns4":54,"dns6":55,"dnsaddr":56,"protobuf":80,"cbor":81,"raw":85,"dbl-sha2-256":86,"rlp":96,"bencode":99,"dag-pb":112,"dag-cbor":113,"libp2p-key":114,"git-raw":120,"torrent-info":123,"torrent-file":124,"leofcoin-block":129,"leofcoin-tx":130,"leofcoin-pr":131,"sctp":132,"eth-block":144,"eth-block-list":145,"eth-tx-trie":146,"eth-tx":147,"eth-tx-receipt-trie":148,"eth-tx-receipt":149,"eth-state-trie":150,"eth-account-snapshot":151,"eth-storage-trie":152,"bitcoin-block":176,"bitcoin-tx":177,"zcash-block":192,"zcash-tx":193,"stellar-block":208,"stellar-tx":209,"md4":212,"md5":213,"bmt":214,"decred-block":224,"decred-tx":225,"ipld-ns":226,"ipfs-ns":227,"swarm-ns":228,"ipns-ns":229,"zeronet":230,"ed25519-pub":237,"dash-block":240,"dash-tx":241,"swarm-manifest":250,"swarm-feed":251,"udp":273,"p2p-webrtc-star":275,"p2p-webrtc-direct":276,"p2p-stardust":277,"p2p-circuit":290,"dag-json":297,"udt":301,"utp":302,"unix":400,"p2p":421,"ipfs":421,"https":443,"onion":444,"onion3":445,"garlic64":446,"garlic32":447,"tls":448,"quic":460,"ws":477,"wss":478,"p2p-websocket-star":479,"http":480,"json":512,"messagepack":513,"x11":4352,"blake2b-8":45569,"blake2b-16":45570,"blake2b-24":45571,"blake2b-32":45572,"blake2b-40":45573,"blake2b-48":45574,"blake2b-56":45575,"blake2b-64":45576,"blake2b-72":45577,"blake2b-80":45578,"blake2b-88":45579,"blake2b-96":45580,"blake2b-104":45581,"blake2b-112":45582,"blake2b-120":45583,"blake2b-128":45584,"blake2b-136":45585,"blake2b-144":45586,"blake2b-152":45587,"blake2b-160":45588,"blake2b-168":45589,"blake2b-176":45590,"blake2b-184":45591,"blake2b-192":45592,"blake2b-200":45593,"blake2b-208":45594,"blake2b-216":45595,"blake2b-224":45596,"blake2b-232":45597,"blake2b-240":45598,"blake2b-248":45599,"blake2b-256":45600,"blake2b-264":45601,"blake2b-272":45602,"blake2b-280":45603,"blake2b-288":45604,"blake2b-296":45605,"blake2b-304":45606,"blake2b-312":45607,"blake2b-320":45608,"blake2b-328":45609,"blake2b-336":45610,"blake2b-344":45611,"blake2b-352":45612,"blake2b-360":45613,"blake2b-368":45614,"blake2b-376":45615,"blake2b-384":45616,"blake2b-392":45617,"blake2b-400":45618,"blake2b-408":45619,"blake2b-416":45620,"blake2b-424":45621,"blake2b-432":45622,"blake2b-440":45623,"blake2b-448":45624,"blake2b-456":45625,"blake2b-464":45626,"blake2b-472":45627,"blake2b-480":45628,"blake2b-488":45629,"blake2b-496":45630,"blake2b-504":45631,"blake2b-512":45632,"blake2s-8":45633,"blake2s-16":45634,"blake2s-24":45635,"blake2s-32":45636,"blake2s-40":45637,"blake2s-48":45638,"blake2s-56":45639,"blake2s-64":45640,"blake2s-72":45641,"blake2s-80":45642,"blake2s-88":45643,"blake2s-96":45644,"blake2s-104":45645,"blake2s-112":45646,"blake2s-120":45647,"blake2s-128":45648,"blake2s-136":45649,"blake2s-144":45650,"blake2s-152":45651,"blake2s-160":45652,"blake2s-168":45653,"blake2s-176":45654,"blake2s-184":45655,"blake2s-192":45656,"blake2s-200":45657,"blake2s-208":45658,"blake2s-216":45659,"blake2s-224":45660,"blake2s-232":45661,"blake2s-240":45662,"blake2s-248":45663,"blake2s-256":45664,"skein256-8":45825,"skein256-16":45826,"skein256-24":45827,"skein256-32":45828,"skein256-40":45829,"skein256-48":45830,"skein256-56":45831,"skein256-64":45832,"skein256-72":45833,"skein256-80":45834,"skein256-88":45835,"skein256-96":45836,"skein256-104":45837,"skein256-112":45838,"skein256-120":45839,"skein256-128":45840,"skein256-136":45841,"skein256-144":45842,"skein256-152":45843,"skein256-160":45844,"skein256-168":45845,"skein256-176":45846,"skein256-184":45847,"skein256-192":45848,"skein256-200":45849,"skein256-208":45850,"skein256-216":45851,"skein256-224":45852,"skein256-232":45853,"skein256-240":45854,"skein256-248":45855,"skein256-256":45856,"skein512-8":45857,"skein512-16":45858,"skein512-24":45859,"skein512-32":45860,"skein512-40":45861,"skein512-48":45862,"skein512-56":45863,"skein512-64":45864,"skein512-72":45865,"skein512-80":45866,"skein512-88":45867,"skein512-96":45868,"skein512-104":45869,"skein512-112":45870,"skein512-120":45871,"skein512-128":45872,"skein512-136":45873,"skein512-144":45874,"skein512-152":45875,"skein512-160":45876,"skein512-168":45877,"skein512-176":45878,"skein512-184":45879,"skein512-192":45880,"skein512-200":45881,"skein512-208":45882,"skein512-216":45883,"skein512-224":45884,"skein512-232":45885,"skein512-240":45886,"skein512-248":45887,"skein512-256":45888,"skein512-264":45889,"skein512-272":45890,"skein512-280":45891,"skein512-288":45892,"skein512-296":45893,"skein512-304":45894,"skein512-312":45895,"skein512-320":45896,"skein512-328":45897,"skein512-336":45898,"skein512-344":45899,"skein512-352":45900,"skein512-360":45901,"skein512-368":45902,"skein512-376":45903,"skein512-384":45904,"skein512-392":45905,"skein512-400":45906,"skein512-408":45907,"skein512-416":45908,"skein512-424":45909,"skein512-432":45910,"skein512-440":45911,"skein512-448":45912,"skein512-456":45913,"skein512-464":45914,"skein512-472":45915,"skein512-480":45916,"skein512-488":45917,"skein512-496":45918,"skein512-504":45919,"skein512-512":45920,"skein1024-8":45921,"skein1024-16":45922,"skein1024-24":45923,"skein1024-32":45924,"skein1024-40":45925,"skein1024-48":45926,"skein1024-56":45927,"skein1024-64":45928,"skein1024-72":45929,"skein1024-80":45930,"skein1024-88":45931,"skein1024-96":45932,"skein1024-104":45933,"skein1024-112":45934,"skein1024-120":45935,"skein1024-128":45936,"skein1024-136":45937,"skein1024-144":45938,"skein1024-152":45939,"skein1024-160":45940,"skein1024-168":45941,"skein1024-176":45942,"skein1024-184":45943,"skein1024-192":45944,"skein1024-200":45945,"skein1024-208":45946,"skein1024-216":45947,"skein1024-224":45948,"skein1024-232":45949,"skein1024-240":45950,"skein1024-248":45951,"skein1024-256":45952,"skein1024-264":45953,"skein1024-272":45954,"skein1024-280":45955,"skein1024-288":45956,"skein1024-296":45957,"skein1024-304":45958,"skein1024-312":45959,"skein1024-320":45960,"skein1024-328":45961,"skein1024-336":45962,"skein1024-344":45963,"skein1024-352":45964,"skein1024-360":45965,"skein1024-368":45966,"skein1024-376":45967,"skein1024-384":45968,"skein1024-392":45969,"skein1024-400":45970,"skein1024-408":45971,"skein1024-416":45972,"skein1024-424":45973,"skein1024-432":45974,"skein1024-440":45975,"skein1024-448":45976,"skein1024-456":45977,"skein1024-464":45978,"skein1024-472":45979,"skein1024-480":45980,"skein1024-488":45981,"skein1024-496":45982,"skein1024-504":45983,"skein1024-512":45984,"skein1024-520":45985,"skein1024-528":45986,"skein1024-536":45987,"skein1024-544":45988,"skein1024-552":45989,"skein1024-560":45990,"skein1024-568":45991,"skein1024-576":45992,"skein1024-584":45993,"skein1024-592":45994,"skein1024-600":45995,"skein1024-608":45996,"skein1024-616":45997,"skein1024-624":45998,"skein1024-632":45999,"skein1024-640":46000,"skein1024-648":46001,"skein1024-656":46002,"skein1024-664":46003,"skein1024-672":46004,"skein1024-680":46005,"skein1024-688":46006,"skein1024-696":46007,"skein1024-704":46008,"skein1024-712":46009,"skein1024-720":46010,"skein1024-728":46011,"skein1024-736":46012,"skein1024-744":46013,"skein1024-752":46014,"skein1024-760":46015,"skein1024-768":46016,"skein1024-776":46017,"skein1024-784":46018,"skein1024-792":46019,"skein1024-800":46020,"skein1024-808":46021,"skein1024-816":46022,"skein1024-824":46023,"skein1024-832":46024,"skein1024-840":46025,"skein1024-848":46026,"skein1024-856":46027,"skein1024-864":46028,"skein1024-872":46029,"skein1024-880":46030,"skein1024-888":46031,"skein1024-896":46032,"skein1024-904":46033,"skein1024-912":46034,"skein1024-920":46035,"skein1024-928":46036,"skein1024-936":46037,"skein1024-944":46038,"skein1024-952":46039,"skein1024-960":46040,"skein1024-968":46041,"skein1024-976":46042,"skein1024-984":46043,"skein1024-992":46044,"skein1024-1000":46045,"skein1024-1008":46046,"skein1024-1016":46047,"skein1024-1024":46048,"holochain-adr-v0":8417572,"holochain-adr-v1":8483108,"holochain-key-v0":9728292,"holochain-key-v1":9793828,"holochain-sig-v0":10645796,"holochain-sig-v1":10711332}');

});


parcelRegister("1TtMw", function(module, exports) {
"use strict";

var $2zY2y = parcelRequire("2zY2y");

var $ecpNJ = parcelRequire("ecpNJ");
var $16120781f909ca30$require$varintEncode = $ecpNJ.varintEncode;
// map for codecName -> codeVarintBuffer
const $16120781f909ca30$var$varintTable = {};
for(const encodingName in $2zY2y){
    const code = $2zY2y[encodingName];
    $16120781f909ca30$var$varintTable[encodingName] = $16120781f909ca30$require$varintEncode(code);
}
module.exports = Object.freeze($16120781f909ca30$var$varintTable);

});
parcelRegister("ecpNJ", function(module, exports) {

var $ihoyg = parcelRequire("ihoyg");
var $a5663341a06f39a9$require$Buffer = $ihoyg.Buffer;
"use strict";

var $9q7Fh = parcelRequire("9q7Fh");
module.exports = {
    numberToBuffer: $a5663341a06f39a9$var$numberToBuffer,
    bufferToNumber: $a5663341a06f39a9$var$bufferToNumber,
    varintBufferEncode: $a5663341a06f39a9$var$varintBufferEncode,
    varintBufferDecode: $a5663341a06f39a9$var$varintBufferDecode,
    varintEncode: $a5663341a06f39a9$var$varintEncode
};
function $a5663341a06f39a9$var$bufferToNumber(buf) {
    return parseInt(buf.toString("hex"), 16);
}
function $a5663341a06f39a9$var$numberToBuffer(num) {
    let hexString = num.toString(16);
    if (hexString.length % 2 === 1) hexString = "0" + hexString;
    return $a5663341a06f39a9$require$Buffer.from(hexString, "hex");
}
function $a5663341a06f39a9$var$varintBufferEncode(input) {
    return $a5663341a06f39a9$require$Buffer.from($9q7Fh.encode($a5663341a06f39a9$var$bufferToNumber(input)));
}
function $a5663341a06f39a9$var$varintBufferDecode(input) {
    return $a5663341a06f39a9$var$numberToBuffer($9q7Fh.decode(input));
}
function $a5663341a06f39a9$var$varintEncode(num) {
    return $a5663341a06f39a9$require$Buffer.from($9q7Fh.encode(num));
}

});


parcelRegister("6POqb", function(module, exports) {
"use strict";

var $2zY2y = parcelRequire("2zY2y");
// map for codecConstant -> code
const $4f9e9e185563d9af$var$constants = {};
for (const [name, code] of Object.entries($2zY2y))$4f9e9e185563d9af$var$constants[name.toUpperCase().replace(/-/g, "_")] = code;
module.exports = Object.freeze($4f9e9e185563d9af$var$constants);

});

parcelRegister("250EQ", function(module, exports) {
"use strict";

var $2zY2y = parcelRequire("2zY2y");
// map for code -> print friendly name
const $183c8f044bec28e9$var$tableByCode = {};
for (const [name, code] of Object.entries($2zY2y))if ($183c8f044bec28e9$var$tableByCode[code] === undefined) $183c8f044bec28e9$var$tableByCode[code] = name;
module.exports = Object.freeze($183c8f044bec28e9$var$tableByCode);

});


parcelRegister("8thpe", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 * @module Multibase
 */ "use strict";

var $ihoyg = parcelRequire("ihoyg");
var $62ae889b68340860$require$Buffer = $ihoyg.Buffer;

var $8CrQN = parcelRequire("8CrQN");
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.names = Object.freeze(Object.keys($8CrQN.names));
exports.codes = Object.freeze(Object.keys($8CrQN.codes));
/**
 * Create a new buffer with the multibase varint+code.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be prefixed with multibase.
 * @memberof Multibase
 * @returns {Buffer}
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error("requires an encoded buffer");
    const base = getBase(nameOrCode);
    const codeBuf = $62ae889b68340860$require$Buffer.from(base.code);
    const name = base.name;
    validEncode(name, buf);
    return $62ae889b68340860$require$Buffer.concat([
        codeBuf,
        buf
    ]);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be encoded.
 * @returns {Buffer}
 * @memberof Multibase
 */ function encode(nameOrCode, buf) {
    const base = getBase(nameOrCode);
    const name = base.name;
    return multibase(name, $62ae889b68340860$require$Buffer.from(base.encode(buf)));
}
/**
 * Takes a buffer or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Buffer|string} bufOrString
 * @returns {Buffer}
 * @memberof Multibase
 *
 */ function decode(bufOrString) {
    if ($62ae889b68340860$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    const code = bufOrString.substring(0, 1);
    bufOrString = bufOrString.substring(1, bufOrString.length);
    if (typeof bufOrString === "string") bufOrString = $62ae889b68340860$require$Buffer.from(bufOrString);
    const base = getBase(code);
    return $62ae889b68340860$require$Buffer.from(base.decode(bufOrString.toString()));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Buffer|string} bufOrString
 * @returns {boolean}
 * @memberof Multibase
 */ function isEncoded(bufOrString) {
    if ($62ae889b68340860$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(bufOrString) !== "[object String]") return false;
    const code = bufOrString.substring(0, 1);
    try {
        const base = getBase(code);
        return base.name;
    } catch (err) {
        return false;
    }
}
/**
 * @param {string} name
 * @param {Buffer} buf
 * @private
 * @returns {undefined}
 */ function validEncode(name, buf) {
    const base = getBase(name);
    base.decode(buf.toString());
}
function getBase(nameOrCode) {
    let base;
    if ($8CrQN.names[nameOrCode]) base = $8CrQN.names[nameOrCode];
    else if ($8CrQN.codes[nameOrCode]) base = $8CrQN.codes[nameOrCode];
    else throw new Error("Unsupported encoding");
    if (!base.isImplemented()) throw new Error("Base " + nameOrCode + " is not implemented yet");
    return base;
}

});
parcelRegister("8CrQN", function(module, exports) {
"use strict";

var $c7scJ = parcelRequire("c7scJ");

var $kG2My = parcelRequire("kG2My");

var $94fH1 = parcelRequire("94fH1");

var $b7YgH = parcelRequire("b7YgH");

var $1fbud = parcelRequire("1fbud");
// name, code, implementation, alphabet
const $646779e57f3dc227$var$constants = [
    [
        "base1",
        "1",
        "",
        "1"
    ],
    [
        "base2",
        "0",
        $kG2My,
        "01"
    ],
    [
        "base8",
        "7",
        $kG2My,
        "01234567"
    ],
    [
        "base10",
        "9",
        $kG2My,
        "0123456789"
    ],
    [
        "base16",
        "f",
        $94fH1,
        "0123456789abcdef"
    ],
    [
        "base32",
        "b",
        $b7YgH,
        "abcdefghijklmnopqrstuvwxyz234567"
    ],
    [
        "base32pad",
        "c",
        $b7YgH,
        "abcdefghijklmnopqrstuvwxyz234567="
    ],
    [
        "base32hex",
        "v",
        $b7YgH,
        "0123456789abcdefghijklmnopqrstuv"
    ],
    [
        "base32hexpad",
        "t",
        $b7YgH,
        "0123456789abcdefghijklmnopqrstuv="
    ],
    [
        "base32z",
        "h",
        $b7YgH,
        "ybndrfg8ejkmcpqxot1uwisza345h769"
    ],
    [
        "base58flickr",
        "Z",
        $kG2My,
        "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
    ],
    [
        "base58btc",
        "z",
        $kG2My,
        "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    ],
    [
        "base64",
        "m",
        $1fbud,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ],
    [
        "base64pad",
        "M",
        $1fbud,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    ],
    [
        "base64url",
        "u",
        $1fbud,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
    ],
    [
        "base64urlpad",
        "U",
        $1fbud,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="
    ]
];
const $646779e57f3dc227$var$names = $646779e57f3dc227$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $c7scJ(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, {});
const $646779e57f3dc227$var$codes = $646779e57f3dc227$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $646779e57f3dc227$var$names[tupple[0]];
    return prev;
}, {});
module.exports = {
    names: $646779e57f3dc227$var$names,
    codes: $646779e57f3dc227$var$codes
};

});
parcelRegister("c7scJ", function(module, exports) {
"use strict";
class $8d2c044178f3ea2e$var$Base {
    constructor(name, code, implementation, alphabet){
        this.name = name;
        this.code = code;
        this.alphabet = alphabet;
        if (implementation && alphabet) this.engine = implementation(alphabet);
    }
    encode(stringOrBuffer) {
        return this.engine.encode(stringOrBuffer);
    }
    decode(stringOrBuffer) {
        return this.engine.decode(stringOrBuffer);
    }
    isImplemented() {
        return this.engine;
    }
}
module.exports = $8d2c044178f3ea2e$var$Base;

});

parcelRegister("94fH1", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $69a0a90cc0225485$require$Buffer = $ihoyg.Buffer;
module.exports = function base16(alphabet) {
    return {
        encode (input) {
            if (typeof input === "string") return $69a0a90cc0225485$require$Buffer.from(input).toString("hex");
            return input.toString("hex");
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base16 character");
            }
            return $69a0a90cc0225485$require$Buffer.from(input, "hex");
        }
    };
};

});

parcelRegister("b7YgH", function(module, exports) {
"use strict";
function $819f1930545b3acd$var$decode(input, alphabet) {
    input = input.replace(new RegExp("=", "g"), "");
    const length = input.length;
    let bits = 0;
    let value = 0;
    let index = 0;
    const output = new Uint8Array(length * 5 / 8 | 0);
    for(let i = 0; i < length; i++){
        value = value << 5 | alphabet.indexOf(input[i]);
        bits += 5;
        if (bits >= 8) {
            output[index++] = value >>> bits - 8 & 255;
            bits -= 8;
        }
    }
    return output.buffer;
}
function $819f1930545b3acd$var$encode(buffer, alphabet) {
    const length = buffer.byteLength;
    const view = new Uint8Array(buffer);
    const padding = alphabet.indexOf("=") === alphabet.length - 1;
    if (padding) alphabet = alphabet.substring(0, alphabet.length - 1);
    let bits = 0;
    let value = 0;
    let output = "";
    for(let i = 0; i < length; i++){
        value = value << 8 | view[i];
        bits += 8;
        while(bits >= 5){
            output += alphabet[value >>> bits - 5 & 31];
            bits -= 5;
        }
    }
    if (bits > 0) output += alphabet[value << 5 - bits & 31];
    if (padding) while(output.length % 8 !== 0)output += "=";
    return output;
}
module.exports = function base32(alphabet) {
    return {
        encode (input) {
            if (typeof input === "string") return $819f1930545b3acd$var$encode(Uint8Array.from(input), alphabet);
            return $819f1930545b3acd$var$encode(input, alphabet);
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base32 character");
            }
            return $819f1930545b3acd$var$decode(input, alphabet);
        }
    };
};

});

parcelRegister("1fbud", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $0e801a1a1d57543d$require$Buffer = $ihoyg.Buffer;
module.exports = function base64(alphabet) {
    // The alphabet is only used to know:
    //   1. If padding is enabled (must contain '=')
    //   2. If the output must be url-safe (must contain '-' and '_')
    //   3. If the input of the output function is valid
    // The alphabets from RFC 4648 are always used.
    const padding = alphabet.indexOf("=") > -1;
    const url = alphabet.indexOf("-") > -1 && alphabet.indexOf("_") > -1;
    return {
        encode (input) {
            let output = "";
            if (typeof input === "string") output = $0e801a1a1d57543d$require$Buffer.from(input).toString("base64");
            else output = input.toString("base64");
            if (url) output = output.replace(/\+/g, "-").replace(/\//g, "_");
            const pad = output.indexOf("=");
            if (pad > 0 && !padding) output = output.substring(0, pad);
            return output;
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base64 character");
            }
            return $0e801a1a1d57543d$require$Buffer.from(input, "base64");
        }
    };
};

});



parcelRegister("locRC", function(module, exports) {
/**
 * Implementation of the [multibase](https://github.com/multiformats/multibase) specification.
 * @module Multibase
 */ "use strict";

var $ihoyg = parcelRequire("ihoyg");
var $f925d15aded7bb35$require$Buffer = $ihoyg.Buffer;

var $M4zeA = parcelRequire("M4zeA");
exports = module.exports = multibase;
exports.encode = encode;
exports.decode = decode;
exports.isEncoded = isEncoded;
exports.names = Object.freeze(Object.keys($M4zeA.names));
exports.codes = Object.freeze(Object.keys($M4zeA.codes));
const errNotSupported = new Error("Unsupported encoding");
/**
 * Create a new buffer with the multibase varint+code.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be prefixed with multibase.
 * @memberof Multibase
 * @returns {Buffer}
 */ function multibase(nameOrCode, buf) {
    if (!buf) throw new Error("requires an encoded buffer");
    const base = getBase(nameOrCode);
    const codeBuf = $f925d15aded7bb35$require$Buffer.from(base.code);
    const name = base.name;
    validEncode(name, buf);
    return $f925d15aded7bb35$require$Buffer.concat([
        codeBuf,
        buf
    ]);
}
/**
 * Encode data with the specified base and add the multibase prefix.
 *
 * @param {string|number} nameOrCode - The multibase name or code number.
 * @param {Buffer} buf - The data to be encoded.
 * @returns {Buffer}
 * @memberof Multibase
 */ function encode(nameOrCode, buf) {
    const base = getBase(nameOrCode);
    const name = base.name;
    return multibase(name, $f925d15aded7bb35$require$Buffer.from(base.encode(buf)));
}
/**
 * Takes a buffer or string encoded with multibase header, decodes it and
 * returns the decoded buffer
 *
 * @param {Buffer|string} bufOrString
 * @returns {Buffer}
 * @memberof Multibase
 *
 */ function decode(bufOrString) {
    if ($f925d15aded7bb35$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    const code = bufOrString.substring(0, 1);
    bufOrString = bufOrString.substring(1, bufOrString.length);
    if (typeof bufOrString === "string") bufOrString = $f925d15aded7bb35$require$Buffer.from(bufOrString);
    const base = getBase(code);
    return $f925d15aded7bb35$require$Buffer.from(base.decode(bufOrString.toString()));
}
/**
 * Is the given data multibase encoded?
 *
 * @param {Buffer|string} bufOrString
 * @returns {boolean}
 * @memberof Multibase
 */ function isEncoded(bufOrString) {
    if ($f925d15aded7bb35$require$Buffer.isBuffer(bufOrString)) bufOrString = bufOrString.toString();
    // Ensure bufOrString is a string
    if (Object.prototype.toString.call(bufOrString) !== "[object String]") return false;
    const code = bufOrString.substring(0, 1);
    try {
        const base = getBase(code);
        return base.name;
    } catch (err) {
        return false;
    }
}
/**
 * @param {string} name
 * @param {Buffer} buf
 * @private
 * @returns {undefined}
 */ function validEncode(name, buf) {
    const base = getBase(name);
    base.decode(buf.toString());
}
function getBase(nameOrCode) {
    let base;
    if ($M4zeA.names[nameOrCode]) base = $M4zeA.names[nameOrCode];
    else if ($M4zeA.codes[nameOrCode]) base = $M4zeA.codes[nameOrCode];
    else throw errNotSupported;
    if (!base.isImplemented()) throw new Error("Base " + nameOrCode + " is not implemented yet");
    return base;
}

});
parcelRegister("M4zeA", function(module, exports) {
"use strict";

var $3dmiJ = parcelRequire("3dmiJ");

var $kG2My = parcelRequire("kG2My");

var $3Nyf3 = parcelRequire("3Nyf3");

var $cAhO3 = parcelRequire("cAhO3");

var $kkVW3 = parcelRequire("kkVW3");
// name, code, implementation, alphabet
const $090806c7783fb616$var$constants = [
    [
        "base1",
        "1",
        "",
        "1"
    ],
    [
        "base2",
        "0",
        $kG2My,
        "01"
    ],
    [
        "base8",
        "7",
        $kG2My,
        "01234567"
    ],
    [
        "base10",
        "9",
        $kG2My,
        "0123456789"
    ],
    [
        "base16",
        "f",
        $3Nyf3,
        "0123456789abcdef"
    ],
    [
        "base32",
        "b",
        $cAhO3,
        "abcdefghijklmnopqrstuvwxyz234567"
    ],
    [
        "base32pad",
        "c",
        $cAhO3,
        "abcdefghijklmnopqrstuvwxyz234567="
    ],
    [
        "base32hex",
        "v",
        $cAhO3,
        "0123456789abcdefghijklmnopqrstuv"
    ],
    [
        "base32hexpad",
        "t",
        $cAhO3,
        "0123456789abcdefghijklmnopqrstuv="
    ],
    [
        "base32z",
        "h",
        $cAhO3,
        "ybndrfg8ejkmcpqxot1uwisza345h769"
    ],
    [
        "base58flickr",
        "Z",
        $kG2My,
        "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"
    ],
    [
        "base58btc",
        "z",
        $kG2My,
        "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"
    ],
    [
        "base64",
        "m",
        $kkVW3,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"
    ],
    [
        "base64pad",
        "M",
        $kkVW3,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    ],
    [
        "base64url",
        "u",
        $kkVW3,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
    ],
    [
        "base64urlpad",
        "U",
        $kkVW3,
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="
    ]
];
const $090806c7783fb616$var$names = $090806c7783fb616$var$constants.reduce((prev, tupple)=>{
    prev[tupple[0]] = new $3dmiJ(tupple[0], tupple[1], tupple[2], tupple[3]);
    return prev;
}, {});
const $090806c7783fb616$var$codes = $090806c7783fb616$var$constants.reduce((prev, tupple)=>{
    prev[tupple[1]] = $090806c7783fb616$var$names[tupple[0]];
    return prev;
}, {});
module.exports = {
    names: $090806c7783fb616$var$names,
    codes: $090806c7783fb616$var$codes
};

});
parcelRegister("3dmiJ", function(module, exports) {
"use strict";
class $2573e28af1dfa71a$var$Base {
    constructor(name, code, implementation, alphabet){
        this.name = name;
        this.code = code;
        this.alphabet = alphabet;
        if (implementation && alphabet) this.engine = implementation(alphabet);
    }
    encode(stringOrBuffer) {
        return this.engine.encode(stringOrBuffer);
    }
    decode(stringOrBuffer) {
        return this.engine.decode(stringOrBuffer);
    }
    isImplemented() {
        return this.engine;
    }
}
module.exports = $2573e28af1dfa71a$var$Base;

});

parcelRegister("3Nyf3", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $2c4082690c8a5136$require$Buffer = $ihoyg.Buffer;
module.exports = function base16(alphabet) {
    return {
        encode (input) {
            if (typeof input === "string") return $2c4082690c8a5136$require$Buffer.from(input).toString("hex");
            return input.toString("hex");
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base16 character");
            }
            return $2c4082690c8a5136$require$Buffer.from(input, "hex");
        }
    };
};

});

parcelRegister("cAhO3", function(module, exports) {
"use strict";
function $9296a8cb1834962f$var$decode(input, alphabet) {
    input = input.replace(new RegExp("=", "g"), "");
    const length = input.length;
    let bits = 0;
    let value = 0;
    let index = 0;
    const output = new Uint8Array(length * 5 / 8 | 0);
    for(let i = 0; i < length; i++){
        value = value << 5 | alphabet.indexOf(input[i]);
        bits += 5;
        if (bits >= 8) {
            output[index++] = value >>> bits - 8 & 255;
            bits -= 8;
        }
    }
    return output.buffer;
}
function $9296a8cb1834962f$var$encode(buffer, alphabet) {
    const length = buffer.byteLength;
    const view = new Uint8Array(buffer);
    const padding = alphabet.indexOf("=") === alphabet.length - 1;
    if (padding) alphabet = alphabet.substring(0, alphabet.length - 1);
    let bits = 0;
    let value = 0;
    let output = "";
    for(let i = 0; i < length; i++){
        value = value << 8 | view[i];
        bits += 8;
        while(bits >= 5){
            output += alphabet[value >>> bits - 5 & 31];
            bits -= 5;
        }
    }
    if (bits > 0) output += alphabet[value << 5 - bits & 31];
    if (padding) while(output.length % 8 !== 0)output += "=";
    return output;
}
module.exports = function base32(alphabet) {
    return {
        encode (input) {
            if (typeof input === "string") return $9296a8cb1834962f$var$encode(Uint8Array.from(input), alphabet);
            return $9296a8cb1834962f$var$encode(input, alphabet);
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base32 character");
            }
            return $9296a8cb1834962f$var$decode(input, alphabet);
        }
    };
};

});

parcelRegister("kkVW3", function(module, exports) {
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $ece29da346d14047$require$Buffer = $ihoyg.Buffer;
module.exports = function base64(alphabet) {
    // The alphabet is only used to know:
    //   1. If padding is enabled (must contain '=')
    //   2. If the output must be url-safe (must contain '-' and '_')
    //   3. If the input of the output function is valid
    // The alphabets from RFC 4648 are always used.
    const padding = alphabet.indexOf("=") > -1;
    const url = alphabet.indexOf("-") > -1 && alphabet.indexOf("_") > -1;
    return {
        encode (input) {
            let output = "";
            if (typeof input === "string") output = $ece29da346d14047$require$Buffer.from(input).toString("base64");
            else output = input.toString("base64");
            if (url) output = output.replace(/\+/g, "-").replace(/\//g, "_");
            const pad = output.indexOf("=");
            if (pad > 0 && !padding) output = output.substring(0, pad);
            return output;
        },
        decode (input) {
            for (const char of input){
                if (alphabet.indexOf(char) < 0) throw new Error("invalid base64 character");
            }
            return $ece29da346d14047$require$Buffer.from(input, "base64");
        }
    };
};

});



parcelRegister("j36gA", function(module, exports) {
/**
 * Implementation of the multicodec specification.
 *
 * @module multicodec
 * @example
 * const multicodec = require('multicodec')
 *
 * const prefixedProtobuf = multicodec.addPrefix('protobuf', protobufBuffer)
 * // prefixedProtobuf 0x50...
 *
 */ "use strict";

var $ihoyg = parcelRequire("ihoyg");
var $dde328896a70afac$require$Buffer = $ihoyg.Buffer;

var $9q7Fh = parcelRequire("9q7Fh");

var $7mGOK = parcelRequire("7mGOK");

var $hklOr = parcelRequire("hklOr");

var $6w24l = parcelRequire("6w24l");
exports = module.exports;
/**
 * Prefix a buffer with a multicodec-packed.
 *
 * @param {string|number} multicodecStrOrCode
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.addPrefix = (multicodecStrOrCode, data)=>{
    let prefix;
    if ($dde328896a70afac$require$Buffer.isBuffer(multicodecStrOrCode)) prefix = $6w24l.varintBufferEncode(multicodecStrOrCode);
    else {
        if ($hklOr[multicodecStrOrCode]) prefix = $hklOr[multicodecStrOrCode];
        else throw new Error("multicodec not recognized");
    }
    return $dde328896a70afac$require$Buffer.concat([
        prefix,
        data
    ]);
};
/**
 * Decapsulate the multicodec-packed prefix from the data.
 *
 * @param {Buffer} data
 * @returns {Buffer}
 */ exports.rmPrefix = (data)=>{
    $9q7Fh.decode(data);
    return data.slice($9q7Fh.decode.bytes);
};
/**
 * Get the codec of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {string}
 */ exports.getCodec = (prefixedData)=>{
    const code = $9q7Fh.decode(prefixedData);
    const codecName = $7mGOK.get(code);
    if (codecName === undefined) throw new Error(`Code ${code} not found`);
    return codecName;
};
/**
 * Get the name of the codec.
 * @param {number} codec
 * @returns {string}
 */ exports.getName = (codec)=>{
    return $7mGOK.get(codec);
};
/**
 * Get the code of the codec
 * @param {string} name
 * @returns {number}
 */ exports.getNumber = (name)=>{
    const code = $hklOr[name];
    if (code === undefined) throw new Error("Codec `" + name + "` not found");
    return $6w24l.varintBufferDecode(code)[0];
};
/**
 * Get the code of the prefixed data.
 * @param {Buffer} prefixedData
 * @returns {number}
 */ exports.getCode = (prefixedData)=>{
    return $9q7Fh.decode(prefixedData);
};
/**
 * Get the code as varint of a codec name.
 * @param {string} codecName
 * @returns {Buffer}
 */ exports.getCodeVarint = (codecName)=>{
    const code = $hklOr[codecName];
    if (code === undefined) throw new Error("Codec `" + codecName + "` not found");
    return code;
};
/**
 * Get the varint of a code.
 * @param {Number} code
 * @returns {Array.<number>}
 */ exports.getVarint = (code)=>{
    return $9q7Fh.encode(code);
};

var $cGspu = parcelRequire("cGspu");
Object.assign(exports, $cGspu);

// Human friendly names for printing, e.g. in error messages
exports.print = (parcelRequire("5iUHr"));

});
parcelRegister("7mGOK", function(module, exports) {
"use strict";

var $euDHO = parcelRequire("euDHO");
// map for hexString -> codecName
const $55cbcd23d9feb445$var$nameTable = new Map();
for(const encodingName in $euDHO){
    const code = $euDHO[encodingName];
    $55cbcd23d9feb445$var$nameTable.set(code, encodingName);
}
module.exports = Object.freeze($55cbcd23d9feb445$var$nameTable);

});
parcelRegister("euDHO", function(module, exports) {
module.exports = JSON.parse('{"identity":0,"ip4":4,"tcp":6,"sha1":17,"sha2-256":18,"sha2-512":19,"sha3-512":20,"sha3-384":21,"sha3-256":22,"sha3-224":23,"shake-128":24,"shake-256":25,"keccak-224":26,"keccak-256":27,"keccak-384":28,"keccak-512":29,"blake3":30,"dccp":33,"murmur3-128":34,"murmur3-32":35,"ip6":41,"ip6zone":42,"path":47,"multicodec":48,"multihash":49,"multiaddr":50,"multibase":51,"dns":53,"dns4":54,"dns6":55,"dnsaddr":56,"protobuf":80,"cbor":81,"raw":85,"dbl-sha2-256":86,"rlp":96,"bencode":99,"dag-pb":112,"dag-cbor":113,"libp2p-key":114,"git-raw":120,"torrent-info":123,"torrent-file":124,"leofcoin-block":129,"leofcoin-tx":130,"leofcoin-pr":131,"sctp":132,"dag-jose":133,"dag-cose":134,"eth-block":144,"eth-block-list":145,"eth-tx-trie":146,"eth-tx":147,"eth-tx-receipt-trie":148,"eth-tx-receipt":149,"eth-state-trie":150,"eth-account-snapshot":151,"eth-storage-trie":152,"bitcoin-block":176,"bitcoin-tx":177,"bitcoin-witness-commitment":178,"zcash-block":192,"zcash-tx":193,"stellar-block":208,"stellar-tx":209,"md4":212,"md5":213,"bmt":214,"decred-block":224,"decred-tx":225,"ipld-ns":226,"ipfs-ns":227,"swarm-ns":228,"ipns-ns":229,"zeronet":230,"secp256k1-pub":231,"bls12_381-g1-pub":234,"bls12_381-g2-pub":235,"x25519-pub":236,"ed25519-pub":237,"dash-block":240,"dash-tx":241,"swarm-manifest":250,"swarm-feed":251,"udp":273,"p2p-webrtc-star":275,"p2p-webrtc-direct":276,"p2p-stardust":277,"p2p-circuit":290,"dag-json":297,"udt":301,"utp":302,"unix":400,"p2p":421,"ipfs":421,"https":443,"onion":444,"onion3":445,"garlic64":446,"garlic32":447,"tls":448,"quic":460,"ws":477,"wss":478,"p2p-websocket-star":479,"http":480,"json":512,"messagepack":513,"libp2p-peer-record":769,"sha2-256-trunc254-padded":4114,"ripemd-128":4178,"ripemd-160":4179,"ripemd-256":4180,"ripemd-320":4181,"x11":4352,"sm3-256":21325,"blake2b-8":45569,"blake2b-16":45570,"blake2b-24":45571,"blake2b-32":45572,"blake2b-40":45573,"blake2b-48":45574,"blake2b-56":45575,"blake2b-64":45576,"blake2b-72":45577,"blake2b-80":45578,"blake2b-88":45579,"blake2b-96":45580,"blake2b-104":45581,"blake2b-112":45582,"blake2b-120":45583,"blake2b-128":45584,"blake2b-136":45585,"blake2b-144":45586,"blake2b-152":45587,"blake2b-160":45588,"blake2b-168":45589,"blake2b-176":45590,"blake2b-184":45591,"blake2b-192":45592,"blake2b-200":45593,"blake2b-208":45594,"blake2b-216":45595,"blake2b-224":45596,"blake2b-232":45597,"blake2b-240":45598,"blake2b-248":45599,"blake2b-256":45600,"blake2b-264":45601,"blake2b-272":45602,"blake2b-280":45603,"blake2b-288":45604,"blake2b-296":45605,"blake2b-304":45606,"blake2b-312":45607,"blake2b-320":45608,"blake2b-328":45609,"blake2b-336":45610,"blake2b-344":45611,"blake2b-352":45612,"blake2b-360":45613,"blake2b-368":45614,"blake2b-376":45615,"blake2b-384":45616,"blake2b-392":45617,"blake2b-400":45618,"blake2b-408":45619,"blake2b-416":45620,"blake2b-424":45621,"blake2b-432":45622,"blake2b-440":45623,"blake2b-448":45624,"blake2b-456":45625,"blake2b-464":45626,"blake2b-472":45627,"blake2b-480":45628,"blake2b-488":45629,"blake2b-496":45630,"blake2b-504":45631,"blake2b-512":45632,"blake2s-8":45633,"blake2s-16":45634,"blake2s-24":45635,"blake2s-32":45636,"blake2s-40":45637,"blake2s-48":45638,"blake2s-56":45639,"blake2s-64":45640,"blake2s-72":45641,"blake2s-80":45642,"blake2s-88":45643,"blake2s-96":45644,"blake2s-104":45645,"blake2s-112":45646,"blake2s-120":45647,"blake2s-128":45648,"blake2s-136":45649,"blake2s-144":45650,"blake2s-152":45651,"blake2s-160":45652,"blake2s-168":45653,"blake2s-176":45654,"blake2s-184":45655,"blake2s-192":45656,"blake2s-200":45657,"blake2s-208":45658,"blake2s-216":45659,"blake2s-224":45660,"blake2s-232":45661,"blake2s-240":45662,"blake2s-248":45663,"blake2s-256":45664,"skein256-8":45825,"skein256-16":45826,"skein256-24":45827,"skein256-32":45828,"skein256-40":45829,"skein256-48":45830,"skein256-56":45831,"skein256-64":45832,"skein256-72":45833,"skein256-80":45834,"skein256-88":45835,"skein256-96":45836,"skein256-104":45837,"skein256-112":45838,"skein256-120":45839,"skein256-128":45840,"skein256-136":45841,"skein256-144":45842,"skein256-152":45843,"skein256-160":45844,"skein256-168":45845,"skein256-176":45846,"skein256-184":45847,"skein256-192":45848,"skein256-200":45849,"skein256-208":45850,"skein256-216":45851,"skein256-224":45852,"skein256-232":45853,"skein256-240":45854,"skein256-248":45855,"skein256-256":45856,"skein512-8":45857,"skein512-16":45858,"skein512-24":45859,"skein512-32":45860,"skein512-40":45861,"skein512-48":45862,"skein512-56":45863,"skein512-64":45864,"skein512-72":45865,"skein512-80":45866,"skein512-88":45867,"skein512-96":45868,"skein512-104":45869,"skein512-112":45870,"skein512-120":45871,"skein512-128":45872,"skein512-136":45873,"skein512-144":45874,"skein512-152":45875,"skein512-160":45876,"skein512-168":45877,"skein512-176":45878,"skein512-184":45879,"skein512-192":45880,"skein512-200":45881,"skein512-208":45882,"skein512-216":45883,"skein512-224":45884,"skein512-232":45885,"skein512-240":45886,"skein512-248":45887,"skein512-256":45888,"skein512-264":45889,"skein512-272":45890,"skein512-280":45891,"skein512-288":45892,"skein512-296":45893,"skein512-304":45894,"skein512-312":45895,"skein512-320":45896,"skein512-328":45897,"skein512-336":45898,"skein512-344":45899,"skein512-352":45900,"skein512-360":45901,"skein512-368":45902,"skein512-376":45903,"skein512-384":45904,"skein512-392":45905,"skein512-400":45906,"skein512-408":45907,"skein512-416":45908,"skein512-424":45909,"skein512-432":45910,"skein512-440":45911,"skein512-448":45912,"skein512-456":45913,"skein512-464":45914,"skein512-472":45915,"skein512-480":45916,"skein512-488":45917,"skein512-496":45918,"skein512-504":45919,"skein512-512":45920,"skein1024-8":45921,"skein1024-16":45922,"skein1024-24":45923,"skein1024-32":45924,"skein1024-40":45925,"skein1024-48":45926,"skein1024-56":45927,"skein1024-64":45928,"skein1024-72":45929,"skein1024-80":45930,"skein1024-88":45931,"skein1024-96":45932,"skein1024-104":45933,"skein1024-112":45934,"skein1024-120":45935,"skein1024-128":45936,"skein1024-136":45937,"skein1024-144":45938,"skein1024-152":45939,"skein1024-160":45940,"skein1024-168":45941,"skein1024-176":45942,"skein1024-184":45943,"skein1024-192":45944,"skein1024-200":45945,"skein1024-208":45946,"skein1024-216":45947,"skein1024-224":45948,"skein1024-232":45949,"skein1024-240":45950,"skein1024-248":45951,"skein1024-256":45952,"skein1024-264":45953,"skein1024-272":45954,"skein1024-280":45955,"skein1024-288":45956,"skein1024-296":45957,"skein1024-304":45958,"skein1024-312":45959,"skein1024-320":45960,"skein1024-328":45961,"skein1024-336":45962,"skein1024-344":45963,"skein1024-352":45964,"skein1024-360":45965,"skein1024-368":45966,"skein1024-376":45967,"skein1024-384":45968,"skein1024-392":45969,"skein1024-400":45970,"skein1024-408":45971,"skein1024-416":45972,"skein1024-424":45973,"skein1024-432":45974,"skein1024-440":45975,"skein1024-448":45976,"skein1024-456":45977,"skein1024-464":45978,"skein1024-472":45979,"skein1024-480":45980,"skein1024-488":45981,"skein1024-496":45982,"skein1024-504":45983,"skein1024-512":45984,"skein1024-520":45985,"skein1024-528":45986,"skein1024-536":45987,"skein1024-544":45988,"skein1024-552":45989,"skein1024-560":45990,"skein1024-568":45991,"skein1024-576":45992,"skein1024-584":45993,"skein1024-592":45994,"skein1024-600":45995,"skein1024-608":45996,"skein1024-616":45997,"skein1024-624":45998,"skein1024-632":45999,"skein1024-640":46000,"skein1024-648":46001,"skein1024-656":46002,"skein1024-664":46003,"skein1024-672":46004,"skein1024-680":46005,"skein1024-688":46006,"skein1024-696":46007,"skein1024-704":46008,"skein1024-712":46009,"skein1024-720":46010,"skein1024-728":46011,"skein1024-736":46012,"skein1024-744":46013,"skein1024-752":46014,"skein1024-760":46015,"skein1024-768":46016,"skein1024-776":46017,"skein1024-784":46018,"skein1024-792":46019,"skein1024-800":46020,"skein1024-808":46021,"skein1024-816":46022,"skein1024-824":46023,"skein1024-832":46024,"skein1024-840":46025,"skein1024-848":46026,"skein1024-856":46027,"skein1024-864":46028,"skein1024-872":46029,"skein1024-880":46030,"skein1024-888":46031,"skein1024-896":46032,"skein1024-904":46033,"skein1024-912":46034,"skein1024-920":46035,"skein1024-928":46036,"skein1024-936":46037,"skein1024-944":46038,"skein1024-952":46039,"skein1024-960":46040,"skein1024-968":46041,"skein1024-976":46042,"skein1024-984":46043,"skein1024-992":46044,"skein1024-1000":46045,"skein1024-1008":46046,"skein1024-1016":46047,"skein1024-1024":46048,"poseidon-bls12_381-a2-fc1":46081,"poseidon-bls12_381-a2-fc1-sc":46082,"zeroxcert-imprint-256":52753,"fil-commitment-unsealed":61697,"fil-commitment-sealed":61698,"holochain-adr-v0":8417572,"holochain-adr-v1":8483108,"holochain-key-v0":9728292,"holochain-key-v1":9793828,"holochain-sig-v0":10645796,"holochain-sig-v1":10711332}');

});


parcelRegister("hklOr", function(module, exports) {
"use strict";

var $euDHO = parcelRequire("euDHO");

var $6w24l = parcelRequire("6w24l");
var $c9d5396cbf1d6420$require$varintEncode = $6w24l.varintEncode;
// map for codecName -> codeVarintBuffer
const $c9d5396cbf1d6420$var$varintTable = {};
for(const encodingName in $euDHO){
    const code = $euDHO[encodingName];
    $c9d5396cbf1d6420$var$varintTable[encodingName] = $c9d5396cbf1d6420$require$varintEncode(code);
}
module.exports = Object.freeze($c9d5396cbf1d6420$var$varintTable);

});
parcelRegister("6w24l", function(module, exports) {
"use strict";

var $9q7Fh = parcelRequire("9q7Fh");

var $ihoyg = parcelRequire("ihoyg");
var $4be7561aad455a9c$require$Buffer = $ihoyg.Buffer;
module.exports = {
    numberToBuffer: $4be7561aad455a9c$var$numberToBuffer,
    bufferToNumber: $4be7561aad455a9c$var$bufferToNumber,
    varintBufferEncode: $4be7561aad455a9c$var$varintBufferEncode,
    varintBufferDecode: $4be7561aad455a9c$var$varintBufferDecode,
    varintEncode: $4be7561aad455a9c$var$varintEncode
};
function $4be7561aad455a9c$var$bufferToNumber(buf) {
    return parseInt(buf.toString("hex"), 16);
}
function $4be7561aad455a9c$var$numberToBuffer(num) {
    let hexString = num.toString(16);
    if (hexString.length % 2 === 1) hexString = "0" + hexString;
    return $4be7561aad455a9c$require$Buffer.from(hexString, "hex");
}
function $4be7561aad455a9c$var$varintBufferEncode(input) {
    return $4be7561aad455a9c$require$Buffer.from($9q7Fh.encode($4be7561aad455a9c$var$bufferToNumber(input)));
}
function $4be7561aad455a9c$var$varintBufferDecode(input) {
    return $4be7561aad455a9c$var$numberToBuffer($9q7Fh.decode(input));
}
function $4be7561aad455a9c$var$varintEncode(num) {
    return $4be7561aad455a9c$require$Buffer.from($9q7Fh.encode(num));
}

});


parcelRegister("cGspu", function(module, exports) {
"use strict";

var $euDHO = parcelRequire("euDHO");
// map for codecConstant -> code
const $93bf71ef8b6db0ca$var$constants = {};
for (const [name, code] of Object.entries($euDHO))$93bf71ef8b6db0ca$var$constants[name.toUpperCase().replace(/-/g, "_")] = code;
module.exports = Object.freeze($93bf71ef8b6db0ca$var$constants);

});

parcelRegister("5iUHr", function(module, exports) {
"use strict";

var $euDHO = parcelRequire("euDHO");
// map for code -> print friendly name
const $3dca9d8eadea55b7$var$tableByCode = {};
for (const [name, code] of Object.entries($euDHO))if ($3dca9d8eadea55b7$var$tableByCode[code] === undefined) $3dca9d8eadea55b7$var$tableByCode[code] = name;
module.exports = Object.freeze($3dca9d8eadea55b7$var$tableByCode);

});


var $fa69a9a3405c626c$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ !function(global) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    var inModule = true;
    var runtime = global.regeneratorRuntime;
    if (runtime) {
        if (inModule) // If regeneratorRuntime is defined globally and we're in a module,
        // make the exports object identical to regeneratorRuntime.
        $fa69a9a3405c626c$exports = runtime;
        // Don't bother evaluating the rest of this file if the runtime was
        // already defined globally.
        return;
    }
    // Define the runtime globally (as expected by generated code) as either
    // module.exports (if we're in a module) or a new, empty object.
    runtime = global.regeneratorRuntime = inModule ? $fa69a9a3405c626c$exports : {};
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        generator._invoke = makeInvokeMethod(innerFn, self, context);
        return generator;
    }
    runtime.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    IteratorPrototype[iteratorSymbol] = function() {
        return this;
    };
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            prototype[method] = function(arg) {
                return this._invoke(method, arg);
            };
        });
    }
    runtime.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    runtime.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            if (!(toStringTagSymbol in genFun)) genFun[toStringTagSymbol] = "GeneratorFunction";
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    runtime.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return Promise.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return Promise.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration. If the Promise is rejected, however, the
                    // result for this iteration will be rejected with the same
                    // reason. Note that rejections of yielded Promises are not
                    // thrown back into the generator function, as is the case
                    // when an awaited Promise is rejected. This difference in
                    // behavior between yield and await is important, because it
                    // allows the consumer to decide what to do with the yielded
                    // rejection (swallow it and continue, manually .throw it back
                    // into the generator, abandon iteration, whatever). With
                    // await, by contrast, there is no opportunity to examine the
                    // rejection reason outside the generator function, so the
                    // only option is to throw it from the await expression, and
                    // let the generator function handle the exception.
                    result.value = unwrapped;
                    resolve(result);
                }, reject);
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new Promise(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        this._invoke = enqueue;
    }
    defineIteratorMethods(AsyncIterator.prototype);
    AsyncIterator.prototype[asyncIteratorSymbol] = function() {
        return this;
    };
    runtime.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    runtime.async = function(innerFn, outerFn, self, tryLocsList) {
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
        return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var method = delegate.iterator[context.method];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method always terminates the yield* loop.
            context.delegate = null;
            if (context.method === "throw") {
                if (delegate.iterator.return) {
                    // If the delegate iterator has a return method, give it a
                    // chance to clean up.
                    context.method = "return";
                    context.arg = undefined;
                    maybeInvokeDelegate(delegate, context);
                    if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                    // "return" to "throw", let that override the TypeError below.
                    return ContinueSentinel;
                }
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a 'throw' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    Gp[toStringTagSymbol] = "Generator";
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    Gp[iteratorSymbol] = function() {
        return this;
    };
    Gp.toString = function() {
        return "[object Generator]";
    };
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    runtime.keys = function(object) {
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    runtime.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
}(// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function() {
    return this;
}() || Function("return this")());



var $lFpDy = parcelRequire("lFpDy");
parcelRequire("lFpDy");
var $3a5kd = parcelRequire("3a5kd");
var $7NkOr = parcelRequire("7NkOr");
var $437b837d88ef5c30$exports = {};
// source: messages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $437b837d88ef5c30$var$goog = $2MzPv;
var $437b837d88ef5c30$var$global = (function() {
    return this || window || $437b837d88ef5c30$var$global || self || Function("return this")();
}).call(null);
var $d4cdf7121546d3d6$exports = {};
// source: types.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $d4cdf7121546d3d6$var$goog = $2MzPv;
var $d4cdf7121546d3d6$var$global = (function() {
    return this || window || $d4cdf7121546d3d6$var$global || self || Function("return this")();
}).call(null);
var $8c6cf1e0333499b5$exports = {};
// source: google/protobuf/descriptor.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $8c6cf1e0333499b5$var$goog = $2MzPv;
var $8c6cf1e0333499b5$var$global = Function("return this")();
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.DescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.DescriptorProto.ExtensionRange", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.DescriptorProto.ReservedRange", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.EnumDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.EnumDescriptorProto.EnumReservedRange", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.EnumOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.EnumValueDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.EnumValueOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.ExtensionRangeOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Label", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldDescriptorProto.Type", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldOptions.CType", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FieldOptions.JSType", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FileDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FileDescriptorSet", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FileOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.FileOptions.OptimizeMode", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.GeneratedCodeInfo", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.GeneratedCodeInfo.Annotation", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.MessageOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.MethodDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.MethodOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.MethodOptions.IdempotencyLevel", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.OneofDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.OneofOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.ServiceDescriptorProto", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.ServiceOptions", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.SourceCodeInfo", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.SourceCodeInfo.Location", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.UninterpretedOption", null, $8c6cf1e0333499b5$var$global);
$8c6cf1e0333499b5$var$goog.exportSymbol("proto.google.protobuf.UninterpretedOption.NamePart", null, $8c6cf1e0333499b5$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.FileDescriptorSet = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.FileDescriptorSet.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.FileDescriptorSet, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.FileDescriptorSet.displayName = "proto.google.protobuf.FileDescriptorSet";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.FileDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.FileDescriptorProto.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.FileDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.FileDescriptorProto.displayName = "proto.google.protobuf.FileDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.DescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.DescriptorProto.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.DescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.DescriptorProto.displayName = "proto.google.protobuf.DescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.DescriptorProto.ExtensionRange = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.DescriptorProto.ExtensionRange, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.DescriptorProto.ExtensionRange.displayName = "proto.google.protobuf.DescriptorProto.ExtensionRange";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.DescriptorProto.ReservedRange = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.DescriptorProto.ReservedRange, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.DescriptorProto.ReservedRange.displayName = "proto.google.protobuf.DescriptorProto.ReservedRange";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.ExtensionRangeOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.ExtensionRangeOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.ExtensionRangeOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.ExtensionRangeOptions.displayName = "proto.google.protobuf.ExtensionRangeOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.ExtensionRangeOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.ExtensionRangeOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.FieldDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.FieldDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.FieldDescriptorProto.displayName = "proto.google.protobuf.FieldDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.OneofDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.OneofDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.OneofDescriptorProto.displayName = "proto.google.protobuf.OneofDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.EnumDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.EnumDescriptorProto.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.EnumDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.EnumDescriptorProto.displayName = "proto.google.protobuf.EnumDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.displayName = "proto.google.protobuf.EnumDescriptorProto.EnumReservedRange";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.EnumValueDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.EnumValueDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.EnumValueDescriptorProto.displayName = "proto.google.protobuf.EnumValueDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.ServiceDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.ServiceDescriptorProto.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.ServiceDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.ServiceDescriptorProto.displayName = "proto.google.protobuf.ServiceDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.MethodDescriptorProto = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.MethodDescriptorProto, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.MethodDescriptorProto.displayName = "proto.google.protobuf.MethodDescriptorProto";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.FileOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.FileOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.FileOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.FileOptions.displayName = "proto.google.protobuf.FileOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.FileOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.FileOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.MessageOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.MessageOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.MessageOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.MessageOptions.displayName = "proto.google.protobuf.MessageOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.MessageOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.MessageOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.FieldOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.FieldOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.FieldOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.FieldOptions.displayName = "proto.google.protobuf.FieldOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.FieldOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.FieldOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.OneofOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.OneofOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.OneofOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.OneofOptions.displayName = "proto.google.protobuf.OneofOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.OneofOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.OneofOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.EnumOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.EnumOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.EnumOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.EnumOptions.displayName = "proto.google.protobuf.EnumOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.EnumOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.EnumOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.EnumValueOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.EnumValueOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.EnumValueOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.EnumValueOptions.displayName = "proto.google.protobuf.EnumValueOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.EnumValueOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.EnumValueOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.ServiceOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.ServiceOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.ServiceOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.ServiceOptions.displayName = "proto.google.protobuf.ServiceOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.ServiceOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.ServiceOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.MethodOptions = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, 500, proto.google.protobuf.MethodOptions.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.MethodOptions, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.MethodOptions.displayName = "proto.google.protobuf.MethodOptions";
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldInfo>}
 */ proto.google.protobuf.MethodOptions.extensions = {};
/**
 * The extensions registered with this message class. This is a map of
 * extension field number to fieldInfo object.
 *
 * For example:
 *     { 123: {fieldIndex: 123, fieldName: {my_field_name: 0}, ctor: proto.example.MyMessage} }
 *
 * fieldName contains the JsCompiler renamed field name property so that it
 * works in OPTIMIZED mode.
 *
 * @type {!Object<number, jspb.ExtensionFieldBinaryInfo>}
 */ proto.google.protobuf.MethodOptions.extensionsBinary = {};
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.UninterpretedOption = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.UninterpretedOption.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.UninterpretedOption, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.UninterpretedOption.displayName = "proto.google.protobuf.UninterpretedOption";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.UninterpretedOption.NamePart = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.UninterpretedOption.NamePart, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.UninterpretedOption.NamePart.displayName = "proto.google.protobuf.UninterpretedOption.NamePart";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.SourceCodeInfo = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.SourceCodeInfo.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.SourceCodeInfo, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.SourceCodeInfo.displayName = "proto.google.protobuf.SourceCodeInfo";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.SourceCodeInfo.Location = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.SourceCodeInfo.Location, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.SourceCodeInfo.Location.displayName = "proto.google.protobuf.SourceCodeInfo.Location";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.GeneratedCodeInfo = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.GeneratedCodeInfo.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.GeneratedCodeInfo, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.GeneratedCodeInfo.displayName = "proto.google.protobuf.GeneratedCodeInfo";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_, null);
};
$8c6cf1e0333499b5$var$goog.inherits(proto.google.protobuf.GeneratedCodeInfo.Annotation, $2MzPv.Message);
if ($8c6cf1e0333499b5$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.google.protobuf.GeneratedCodeInfo.Annotation.displayName = "proto.google.protobuf.GeneratedCodeInfo.Annotation";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.FileDescriptorSet.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.FileDescriptorSet.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.FileDescriptorSet.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.FileDescriptorSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileDescriptorSet.toObject = function(includeInstance, msg) {
        var f, obj = {
            fileList: $2MzPv.Message.toObjectList(msg.getFileList(), proto.google.protobuf.FileDescriptorProto.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.FileDescriptorSet}
 */ proto.google.protobuf.FileDescriptorSet.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.FileDescriptorSet;
    return proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.FileDescriptorSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.FileDescriptorSet}
 */ proto.google.protobuf.FileDescriptorSet.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.google.protobuf.FileDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader);
                msg.addFile(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.FileDescriptorSet.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.FileDescriptorSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileDescriptorSet.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFileList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter);
};
/**
 * repeated FileDescriptorProto file = 1;
 * @return {!Array<!proto.google.protobuf.FileDescriptorProto>}
 */ proto.google.protobuf.FileDescriptorSet.prototype.getFileList = function() {
    return /** @type{!Array<!proto.google.protobuf.FileDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.FileDescriptorProto, 1);
};
/**
 * @param {!Array<!proto.google.protobuf.FileDescriptorProto>} value
 * @return {!proto.google.protobuf.FileDescriptorSet} returns this
*/ proto.google.protobuf.FileDescriptorSet.prototype.setFileList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.google.protobuf.FileDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FileDescriptorProto}
 */ proto.google.protobuf.FileDescriptorSet.prototype.addFile = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.FileDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorSet} returns this
 */ proto.google.protobuf.FileDescriptorSet.prototype.clearFileList = function() {
    return this.setFileList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.FileDescriptorProto.repeatedFields_ = [
    3,
    10,
    11,
    4,
    5,
    6,
    7
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.FileDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.FileDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.FileDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            pb_package: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            dependencyList: (f = $2MzPv.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
            publicDependencyList: (f = $2MzPv.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
            weakDependencyList: (f = $2MzPv.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
            messageTypeList: $2MzPv.Message.toObjectList(msg.getMessageTypeList(), proto.google.protobuf.DescriptorProto.toObject, includeInstance),
            enumTypeList: $2MzPv.Message.toObjectList(msg.getEnumTypeList(), proto.google.protobuf.EnumDescriptorProto.toObject, includeInstance),
            serviceList: $2MzPv.Message.toObjectList(msg.getServiceList(), proto.google.protobuf.ServiceDescriptorProto.toObject, includeInstance),
            extensionList: $2MzPv.Message.toObjectList(msg.getExtensionList(), proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
            options: (f = msg.getOptions()) && proto.google.protobuf.FileOptions.toObject(includeInstance, f),
            sourceCodeInfo: (f = msg.getSourceCodeInfo()) && proto.google.protobuf.SourceCodeInfo.toObject(includeInstance, f),
            syntax: (f = $2MzPv.Message.getField(msg, 12)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.FileDescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.FileDescriptorProto;
    return proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.FileDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.FileDescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPackage(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.addDependency(value);
                break;
            case 10:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addPublicDependency(values[i]);
                break;
            case 11:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addWeakDependency(values[i]);
                break;
            case 4:
                var value = new proto.google.protobuf.DescriptorProto;
                reader.readMessage(value, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader);
                msg.addMessageType(value);
                break;
            case 5:
                var value = new proto.google.protobuf.EnumDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader);
                msg.addEnumType(value);
                break;
            case 6:
                var value = new proto.google.protobuf.ServiceDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader);
                msg.addService(value);
                break;
            case 7:
                var value = new proto.google.protobuf.FieldDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
                msg.addExtension$(value);
                break;
            case 8:
                var value = new proto.google.protobuf.FileOptions;
                reader.readMessage(value, proto.google.protobuf.FileOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            case 9:
                var value = new proto.google.protobuf.SourceCodeInfo;
                reader.readMessage(value, proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader);
                msg.setSourceCodeInfo(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setSyntax(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.FileDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.FileDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = message.getDependencyList();
    if (f.length > 0) writer.writeRepeatedString(3, f);
    f = message.getPublicDependencyList();
    if (f.length > 0) writer.writeRepeatedInt32(10, f);
    f = message.getWeakDependencyList();
    if (f.length > 0) writer.writeRepeatedInt32(11, f);
    f = message.getMessageTypeList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.google.protobuf.DescriptorProto.serializeBinaryToWriter);
    f = message.getEnumTypeList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter);
    f = message.getServiceList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter);
    f = message.getExtensionList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter);
    f = message.getOptions();
    if (f != null) writer.writeMessage(8, f, proto.google.protobuf.FileOptions.serializeBinaryToWriter);
    f = message.getSourceCodeInfo();
    if (f != null) writer.writeMessage(9, f, proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeString(12, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string package = 2;
 * @return {string}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getPackage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setPackage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearPackage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileDescriptorProto.prototype.hasPackage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * repeated string dependency = 3;
 * @return {!Array<string>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getDependencyList = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setDependencyList = function(value) {
    return $2MzPv.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.addDependency = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearDependencyList = function() {
    return this.setDependencyList([]);
};
/**
 * repeated int32 public_dependency = 10;
 * @return {!Array<number>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getPublicDependencyList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 10);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setPublicDependencyList = function(value) {
    return $2MzPv.Message.setField(this, 10, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.addPublicDependency = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 10, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearPublicDependencyList = function() {
    return this.setPublicDependencyList([]);
};
/**
 * repeated int32 weak_dependency = 11;
 * @return {!Array<number>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getWeakDependencyList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 11);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setWeakDependencyList = function(value) {
    return $2MzPv.Message.setField(this, 11, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.addWeakDependency = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 11, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearWeakDependencyList = function() {
    return this.setWeakDependencyList([]);
};
/**
 * repeated DescriptorProto message_type = 4;
 * @return {!Array<!proto.google.protobuf.DescriptorProto>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getMessageTypeList = function() {
    return /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 4);
};
/**
 * @param {!Array<!proto.google.protobuf.DescriptorProto>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setMessageTypeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.google.protobuf.DescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.DescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.prototype.addMessageType = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.DescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearMessageTypeList = function() {
    return this.setMessageTypeList([]);
};
/**
 * repeated EnumDescriptorProto enum_type = 5;
 * @return {!Array<!proto.google.protobuf.EnumDescriptorProto>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getEnumTypeList = function() {
    return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 5);
};
/**
 * @param {!Array<!proto.google.protobuf.EnumDescriptorProto>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setEnumTypeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.google.protobuf.EnumDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.EnumDescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.prototype.addEnumType = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.google.protobuf.EnumDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
};
/**
 * repeated ServiceDescriptorProto service = 6;
 * @return {!Array<!proto.google.protobuf.ServiceDescriptorProto>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getServiceList = function() {
    return /** @type{!Array<!proto.google.protobuf.ServiceDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.ServiceDescriptorProto, 6);
};
/**
 * @param {!Array<!proto.google.protobuf.ServiceDescriptorProto>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setServiceList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.google.protobuf.ServiceDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.ServiceDescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.prototype.addService = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.google.protobuf.ServiceDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearServiceList = function() {
    return this.setServiceList([]);
};
/**
 * repeated FieldDescriptorProto extension = 7;
 * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getExtensionList = function() {
    return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 7);
};
/**
 * @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setExtensionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FieldDescriptorProto}
 */ proto.google.protobuf.FileDescriptorProto.prototype.addExtension$ = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
};
/**
 * optional FileOptions options = 8;
 * @return {?proto.google.protobuf.FileOptions}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.FileOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.FileOptions, 8);
};
/**
 * @param {?proto.google.protobuf.FileOptions|undefined} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional SourceCodeInfo source_code_info = 9;
 * @return {?proto.google.protobuf.SourceCodeInfo}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getSourceCodeInfo = function() {
    return /** @type{?proto.google.protobuf.SourceCodeInfo} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.SourceCodeInfo, 9);
};
/**
 * @param {?proto.google.protobuf.SourceCodeInfo|undefined} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
*/ proto.google.protobuf.FileDescriptorProto.prototype.setSourceCodeInfo = function(value) {
    return $2MzPv.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearSourceCodeInfo = function() {
    return this.setSourceCodeInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileDescriptorProto.prototype.hasSourceCodeInfo = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional string syntax = 12;
 * @return {string}
 */ proto.google.protobuf.FileDescriptorProto.prototype.getSyntax = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.setSyntax = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileDescriptorProto} returns this
 */ proto.google.protobuf.FileDescriptorProto.prototype.clearSyntax = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileDescriptorProto.prototype.hasSyntax = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.DescriptorProto.repeatedFields_ = [
    2,
    6,
    3,
    4,
    5,
    8,
    9,
    10
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.DescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.DescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.DescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            fieldList: $2MzPv.Message.toObjectList(msg.getFieldList(), proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
            extensionList: $2MzPv.Message.toObjectList(msg.getExtensionList(), proto.google.protobuf.FieldDescriptorProto.toObject, includeInstance),
            nestedTypeList: $2MzPv.Message.toObjectList(msg.getNestedTypeList(), proto.google.protobuf.DescriptorProto.toObject, includeInstance),
            enumTypeList: $2MzPv.Message.toObjectList(msg.getEnumTypeList(), proto.google.protobuf.EnumDescriptorProto.toObject, includeInstance),
            extensionRangeList: $2MzPv.Message.toObjectList(msg.getExtensionRangeList(), proto.google.protobuf.DescriptorProto.ExtensionRange.toObject, includeInstance),
            oneofDeclList: $2MzPv.Message.toObjectList(msg.getOneofDeclList(), proto.google.protobuf.OneofDescriptorProto.toObject, includeInstance),
            options: (f = msg.getOptions()) && proto.google.protobuf.MessageOptions.toObject(includeInstance, f),
            reservedRangeList: $2MzPv.Message.toObjectList(msg.getReservedRangeList(), proto.google.protobuf.DescriptorProto.ReservedRange.toObject, includeInstance),
            reservedNameList: (f = $2MzPv.Message.getRepeatedField(msg, 10)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.DescriptorProto}
 */ proto.google.protobuf.DescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.DescriptorProto;
    return proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.DescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.DescriptorProto}
 */ proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = new proto.google.protobuf.FieldDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
                msg.addField(value);
                break;
            case 6:
                var value = new proto.google.protobuf.FieldDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader);
                msg.addExtension$(value);
                break;
            case 3:
                var value = new proto.google.protobuf.DescriptorProto;
                reader.readMessage(value, proto.google.protobuf.DescriptorProto.deserializeBinaryFromReader);
                msg.addNestedType(value);
                break;
            case 4:
                var value = new proto.google.protobuf.EnumDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader);
                msg.addEnumType(value);
                break;
            case 5:
                var value = new proto.google.protobuf.DescriptorProto.ExtensionRange;
                reader.readMessage(value, proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader);
                msg.addExtensionRange(value);
                break;
            case 8:
                var value = new proto.google.protobuf.OneofDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader);
                msg.addOneofDecl(value);
                break;
            case 7:
                var value = new proto.google.protobuf.MessageOptions;
                reader.readMessage(value, proto.google.protobuf.MessageOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            case 9:
                var value = new proto.google.protobuf.DescriptorProto.ReservedRange;
                reader.readMessage(value, proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader);
                msg.addReservedRange(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.addReservedName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.DescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.DescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.DescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getFieldList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter);
    f = message.getExtensionList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter);
    f = message.getNestedTypeList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.google.protobuf.DescriptorProto.serializeBinaryToWriter);
    f = message.getEnumTypeList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter);
    f = message.getExtensionRangeList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter);
    f = message.getOneofDeclList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter);
    f = message.getOptions();
    if (f != null) writer.writeMessage(7, f, proto.google.protobuf.MessageOptions.serializeBinaryToWriter);
    f = message.getReservedRangeList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter);
    f = message.getReservedNameList();
    if (f.length > 0) writer.writeRepeatedString(10, f);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.DescriptorProto.ExtensionRange.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.toObject = function(includeInstance, msg) {
        var f, obj = {
            start: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            end: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            options: (f = msg.getOptions()) && proto.google.protobuf.ExtensionRangeOptions.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.DescriptorProto.ExtensionRange;
    return proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEnd(value);
                break;
            case 3:
                var value = new proto.google.protobuf.ExtensionRangeOptions;
                reader.readMessage(value, proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeInt32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeInt32(2, f);
    f = message.getOptions();
    if (f != null) writer.writeMessage(3, f, proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter);
};
/**
 * optional int32 start = 1;
 * @return {number}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getStart = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setStart = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearStart = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasStart = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional int32 end = 2;
 * @return {number}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getEnd = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setEnd = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearEnd = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasEnd = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional ExtensionRangeOptions options = 3;
 * @return {?proto.google.protobuf.ExtensionRangeOptions}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.ExtensionRangeOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.ExtensionRangeOptions, 3);
};
/**
 * @param {?proto.google.protobuf.ExtensionRangeOptions|undefined} value
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
*/ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange} returns this
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.ExtensionRange.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.DescriptorProto.ReservedRange.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.ReservedRange.toObject = function(includeInstance, msg) {
        var f, obj = {
            start: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            end: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.DescriptorProto.ReservedRange;
    return proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEnd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.DescriptorProto.ReservedRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.DescriptorProto.ReservedRange.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeInt32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeInt32(2, f);
};
/**
 * optional int32 start = 1;
 * @return {number}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getStart = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange} returns this
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setStart = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange} returns this
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearStart = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasStart = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional int32 end = 2;
 * @return {number}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.getEnd = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange} returns this
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.setEnd = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange} returns this
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.clearEnd = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.ReservedRange.prototype.hasEnd = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.DescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated FieldDescriptorProto field = 2;
 * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
 */ proto.google.protobuf.DescriptorProto.prototype.getFieldList = function() {
    return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 2);
};
/**
 * @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setFieldList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FieldDescriptorProto}
 */ proto.google.protobuf.DescriptorProto.prototype.addField = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearFieldList = function() {
    return this.setFieldList([]);
};
/**
 * repeated FieldDescriptorProto extension = 6;
 * @return {!Array<!proto.google.protobuf.FieldDescriptorProto>}
 */ proto.google.protobuf.DescriptorProto.prototype.getExtensionList = function() {
    return /** @type{!Array<!proto.google.protobuf.FieldDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.FieldDescriptorProto, 6);
};
/**
 * @param {!Array<!proto.google.protobuf.FieldDescriptorProto>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setExtensionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.google.protobuf.FieldDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.FieldDescriptorProto}
 */ proto.google.protobuf.DescriptorProto.prototype.addExtension$ = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.google.protobuf.FieldDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearExtensionList = function() {
    return this.setExtensionList([]);
};
/**
 * repeated DescriptorProto nested_type = 3;
 * @return {!Array<!proto.google.protobuf.DescriptorProto>}
 */ proto.google.protobuf.DescriptorProto.prototype.getNestedTypeList = function() {
    return /** @type{!Array<!proto.google.protobuf.DescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto, 3);
};
/**
 * @param {!Array<!proto.google.protobuf.DescriptorProto>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setNestedTypeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.google.protobuf.DescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.DescriptorProto}
 */ proto.google.protobuf.DescriptorProto.prototype.addNestedType = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.google.protobuf.DescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearNestedTypeList = function() {
    return this.setNestedTypeList([]);
};
/**
 * repeated EnumDescriptorProto enum_type = 4;
 * @return {!Array<!proto.google.protobuf.EnumDescriptorProto>}
 */ proto.google.protobuf.DescriptorProto.prototype.getEnumTypeList = function() {
    return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto, 4);
};
/**
 * @param {!Array<!proto.google.protobuf.EnumDescriptorProto>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setEnumTypeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.google.protobuf.EnumDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.EnumDescriptorProto}
 */ proto.google.protobuf.DescriptorProto.prototype.addEnumType = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.EnumDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearEnumTypeList = function() {
    return this.setEnumTypeList([]);
};
/**
 * repeated ExtensionRange extension_range = 5;
 * @return {!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>}
 */ proto.google.protobuf.DescriptorProto.prototype.getExtensionRangeList = function() {
    return /** @type{!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ExtensionRange, 5);
};
/**
 * @param {!Array<!proto.google.protobuf.DescriptorProto.ExtensionRange>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setExtensionRangeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.google.protobuf.DescriptorProto.ExtensionRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.DescriptorProto.ExtensionRange}
 */ proto.google.protobuf.DescriptorProto.prototype.addExtensionRange = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.google.protobuf.DescriptorProto.ExtensionRange, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearExtensionRangeList = function() {
    return this.setExtensionRangeList([]);
};
/**
 * repeated OneofDescriptorProto oneof_decl = 8;
 * @return {!Array<!proto.google.protobuf.OneofDescriptorProto>}
 */ proto.google.protobuf.DescriptorProto.prototype.getOneofDeclList = function() {
    return /** @type{!Array<!proto.google.protobuf.OneofDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.OneofDescriptorProto, 8);
};
/**
 * @param {!Array<!proto.google.protobuf.OneofDescriptorProto>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setOneofDeclList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.google.protobuf.OneofDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.OneofDescriptorProto}
 */ proto.google.protobuf.DescriptorProto.prototype.addOneofDecl = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.google.protobuf.OneofDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearOneofDeclList = function() {
    return this.setOneofDeclList([]);
};
/**
 * optional MessageOptions options = 7;
 * @return {?proto.google.protobuf.MessageOptions}
 */ proto.google.protobuf.DescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.MessageOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.MessageOptions, 7);
};
/**
 * @param {?proto.google.protobuf.MessageOptions|undefined} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.DescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * repeated ReservedRange reserved_range = 9;
 * @return {!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>}
 */ proto.google.protobuf.DescriptorProto.prototype.getReservedRangeList = function() {
    return /** @type{!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.DescriptorProto.ReservedRange, 9);
};
/**
 * @param {!Array<!proto.google.protobuf.DescriptorProto.ReservedRange>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
*/ proto.google.protobuf.DescriptorProto.prototype.setReservedRangeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.google.protobuf.DescriptorProto.ReservedRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.DescriptorProto.ReservedRange}
 */ proto.google.protobuf.DescriptorProto.prototype.addReservedRange = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.google.protobuf.DescriptorProto.ReservedRange, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
};
/**
 * repeated string reserved_name = 10;
 * @return {!Array<string>}
 */ proto.google.protobuf.DescriptorProto.prototype.getReservedNameList = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.getRepeatedField(this, 10);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.setReservedNameList = function(value) {
    return $2MzPv.Message.setField(this, 10, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.addReservedName = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 10, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.DescriptorProto} returns this
 */ proto.google.protobuf.DescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.ExtensionRangeOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.ExtensionRangeOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.ExtensionRangeOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.ExtensionRangeOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ExtensionRangeOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.ExtensionRangeOptions.extensions, proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.ExtensionRangeOptions}
 */ proto.google.protobuf.ExtensionRangeOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.ExtensionRangeOptions;
    return proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.ExtensionRangeOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.ExtensionRangeOptions}
 */ proto.google.protobuf.ExtensionRangeOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.ExtensionRangeOptions.extensionsBinary, proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension, proto.google.protobuf.ExtensionRangeOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.ExtensionRangeOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.ExtensionRangeOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ExtensionRangeOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.ExtensionRangeOptions.extensionsBinary, proto.google.protobuf.ExtensionRangeOptions.prototype.getExtension);
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.ExtensionRangeOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.ExtensionRangeOptions} returns this
*/ proto.google.protobuf.ExtensionRangeOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.ExtensionRangeOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.ExtensionRangeOptions} returns this
 */ proto.google.protobuf.ExtensionRangeOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.FieldDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.FieldDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FieldDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            number: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            label: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            type: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            typeName: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            extendee: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            defaultValue: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            oneofIndex: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            jsonName: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f,
            options: (f = msg.getOptions()) && proto.google.protobuf.FieldOptions.toObject(includeInstance, f),
            proto3Optional: (f = $2MzPv.Message.getBooleanField(msg, 17)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.FieldDescriptorProto}
 */ proto.google.protobuf.FieldDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.FieldDescriptorProto;
    return proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.FieldDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.FieldDescriptorProto}
 */ proto.google.protobuf.FieldDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNumber(value);
                break;
            case 4:
                var value = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ reader.readEnum();
                msg.setLabel(value);
                break;
            case 5:
                var value = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ reader.readEnum();
                msg.setType(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTypeName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setExtendee(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDefaultValue(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOneofIndex(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setJsonName(value);
                break;
            case 8:
                var value = new proto.google.protobuf.FieldOptions;
                reader.readMessage(value, proto.google.protobuf.FieldOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            case 17:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setProto3Optional(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.FieldDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FieldDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeInt32(3, f);
    f = /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeEnum(4, f);
    f = /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeEnum(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeInt32(9, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeString(10, f);
    f = message.getOptions();
    if (f != null) writer.writeMessage(8, f, proto.google.protobuf.FieldOptions.serializeBinaryToWriter);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 17);
    if (f != null) writer.writeBool(17, f);
};
/**
 * @enum {number}
 */ proto.google.protobuf.FieldDescriptorProto.Type = {
    TYPE_DOUBLE: 1,
    TYPE_FLOAT: 2,
    TYPE_INT64: 3,
    TYPE_UINT64: 4,
    TYPE_INT32: 5,
    TYPE_FIXED64: 6,
    TYPE_FIXED32: 7,
    TYPE_BOOL: 8,
    TYPE_STRING: 9,
    TYPE_GROUP: 10,
    TYPE_MESSAGE: 11,
    TYPE_BYTES: 12,
    TYPE_UINT32: 13,
    TYPE_ENUM: 14,
    TYPE_SFIXED32: 15,
    TYPE_SFIXED64: 16,
    TYPE_SINT32: 17,
    TYPE_SINT64: 18
};
/**
 * @enum {number}
 */ proto.google.protobuf.FieldDescriptorProto.Label = {
    LABEL_OPTIONAL: 1,
    LABEL_REQUIRED: 2,
    LABEL_REPEATED: 3
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional int32 number = 3;
 * @return {number}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getNumber = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setNumber = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearNumber = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasNumber = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional Label label = 4;
 * @return {!proto.google.protobuf.FieldDescriptorProto.Label}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getLabel = function() {
    return /** @type {!proto.google.protobuf.FieldDescriptorProto.Label} */ $2MzPv.Message.getFieldWithDefault(this, 4, 1);
};
/**
 * @param {!proto.google.protobuf.FieldDescriptorProto.Label} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional Type type = 5;
 * @return {!proto.google.protobuf.FieldDescriptorProto.Type}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getType = function() {
    return /** @type {!proto.google.protobuf.FieldDescriptorProto.Type} */ $2MzPv.Message.getFieldWithDefault(this, 5, 1);
};
/**
 * @param {!proto.google.protobuf.FieldDescriptorProto.Type} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string type_name = 6;
 * @return {string}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getTypeName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setTypeName = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearTypeName = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasTypeName = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string extendee = 2;
 * @return {string}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getExtendee = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setExtendee = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearExtendee = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasExtendee = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string default_value = 7;
 * @return {string}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getDefaultValue = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setDefaultValue = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearDefaultValue = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasDefaultValue = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional int32 oneof_index = 9;
 * @return {number}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getOneofIndex = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setOneofIndex = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearOneofIndex = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasOneofIndex = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional string json_name = 10;
 * @return {string}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getJsonName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setJsonName = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearJsonName = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasJsonName = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional FieldOptions options = 8;
 * @return {?proto.google.protobuf.FieldOptions}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.FieldOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.FieldOptions, 8);
};
/**
 * @param {?proto.google.protobuf.FieldOptions|undefined} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
*/ proto.google.protobuf.FieldDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional bool proto3_optional = 17;
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.getProto3Optional = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 17, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.setProto3Optional = function(value) {
    return $2MzPv.Message.setField(this, 17, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldDescriptorProto} returns this
 */ proto.google.protobuf.FieldDescriptorProto.prototype.clearProto3Optional = function() {
    return $2MzPv.Message.setField(this, 17, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldDescriptorProto.prototype.hasProto3Optional = function() {
    return $2MzPv.Message.getField(this, 17) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.OneofDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.OneofDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.OneofDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            options: (f = msg.getOptions()) && proto.google.protobuf.OneofOptions.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.OneofDescriptorProto}
 */ proto.google.protobuf.OneofDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.OneofDescriptorProto;
    return proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.OneofDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.OneofDescriptorProto}
 */ proto.google.protobuf.OneofDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = new proto.google.protobuf.OneofOptions;
                reader.readMessage(value, proto.google.protobuf.OneofOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.OneofDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.OneofDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getOptions();
    if (f != null) writer.writeMessage(2, f, proto.google.protobuf.OneofOptions.serializeBinaryToWriter);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.OneofDescriptorProto} returns this
 */ proto.google.protobuf.OneofDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.OneofDescriptorProto} returns this
 */ proto.google.protobuf.OneofDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional OneofOptions options = 2;
 * @return {?proto.google.protobuf.OneofOptions}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.OneofOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.OneofOptions, 2);
};
/**
 * @param {?proto.google.protobuf.OneofOptions|undefined} value
 * @return {!proto.google.protobuf.OneofDescriptorProto} returns this
*/ proto.google.protobuf.OneofDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.OneofDescriptorProto} returns this
 */ proto.google.protobuf.OneofDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.OneofDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.EnumDescriptorProto.repeatedFields_ = [
    2,
    4,
    5
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.EnumDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.EnumDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            valueList: $2MzPv.Message.toObjectList(msg.getValueList(), proto.google.protobuf.EnumValueDescriptorProto.toObject, includeInstance),
            options: (f = msg.getOptions()) && proto.google.protobuf.EnumOptions.toObject(includeInstance, f),
            reservedRangeList: $2MzPv.Message.toObjectList(msg.getReservedRangeList(), proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject, includeInstance),
            reservedNameList: (f = $2MzPv.Message.getRepeatedField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.EnumDescriptorProto}
 */ proto.google.protobuf.EnumDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.EnumDescriptorProto;
    return proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.EnumDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.EnumDescriptorProto}
 */ proto.google.protobuf.EnumDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = new proto.google.protobuf.EnumValueDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader);
                msg.addValue(value);
                break;
            case 3:
                var value = new proto.google.protobuf.EnumOptions;
                reader.readMessage(value, proto.google.protobuf.EnumOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            case 4:
                var value = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange;
                reader.readMessage(value, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader);
                msg.addReservedRange(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.addReservedName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.EnumDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getValueList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter);
    f = message.getOptions();
    if (f != null) writer.writeMessage(3, f, proto.google.protobuf.EnumOptions.serializeBinaryToWriter);
    f = message.getReservedRangeList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter);
    f = message.getReservedNameList();
    if (f.length > 0) writer.writeRepeatedString(5, f);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.toObject = function(includeInstance, msg) {
        var f, obj = {
            start: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            end: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.EnumDescriptorProto.EnumReservedRange;
    return proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEnd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeInt32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeInt32(2, f);
};
/**
 * optional int32 start = 1;
 * @return {number}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getStart = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} returns this
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setStart = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} returns this
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearStart = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasStart = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional int32 end = 2;
 * @return {number}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.getEnd = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} returns this
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.setEnd = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange} returns this
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.clearEnd = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumDescriptorProto.EnumReservedRange.prototype.hasEnd = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated EnumValueDescriptorProto value = 2;
 * @return {!Array<!proto.google.protobuf.EnumValueDescriptorProto>}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.getValueList = function() {
    return /** @type{!Array<!proto.google.protobuf.EnumValueDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumValueDescriptorProto, 2);
};
/**
 * @param {!Array<!proto.google.protobuf.EnumValueDescriptorProto>} value
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
*/ proto.google.protobuf.EnumDescriptorProto.prototype.setValueList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.google.protobuf.EnumValueDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.EnumValueDescriptorProto}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.addValue = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.EnumValueDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.clearValueList = function() {
    return this.setValueList([]);
};
/**
 * optional EnumOptions options = 3;
 * @return {?proto.google.protobuf.EnumOptions}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.EnumOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.EnumOptions, 3);
};
/**
 * @param {?proto.google.protobuf.EnumOptions|undefined} value
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
*/ proto.google.protobuf.EnumDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * repeated EnumReservedRange reserved_range = 4;
 * @return {!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.getReservedRangeList = function() {
    return /** @type{!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, 4);
};
/**
 * @param {!Array<!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange>} value
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
*/ proto.google.protobuf.EnumDescriptorProto.prototype.setReservedRangeList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.EnumDescriptorProto.EnumReservedRange}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.addReservedRange = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.google.protobuf.EnumDescriptorProto.EnumReservedRange, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedRangeList = function() {
    return this.setReservedRangeList([]);
};
/**
 * repeated string reserved_name = 5;
 * @return {!Array<string>}
 */ proto.google.protobuf.EnumDescriptorProto.prototype.getReservedNameList = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.getRepeatedField(this, 5);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.setReservedNameList = function(value) {
    return $2MzPv.Message.setField(this, 5, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.addReservedName = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 5, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.EnumDescriptorProto} returns this
 */ proto.google.protobuf.EnumDescriptorProto.prototype.clearReservedNameList = function() {
    return this.setReservedNameList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.EnumValueDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.EnumValueDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumValueDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            number: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            options: (f = msg.getOptions()) && proto.google.protobuf.EnumValueOptions.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.EnumValueDescriptorProto}
 */ proto.google.protobuf.EnumValueDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.EnumValueDescriptorProto;
    return proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.EnumValueDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.EnumValueDescriptorProto}
 */ proto.google.protobuf.EnumValueDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNumber(value);
                break;
            case 3:
                var value = new proto.google.protobuf.EnumValueOptions;
                reader.readMessage(value, proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.EnumValueDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumValueDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeInt32(2, f);
    f = message.getOptions();
    if (f != null) writer.writeMessage(3, f, proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional int32 number = 2;
 * @return {number}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.getNumber = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.setNumber = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.clearNumber = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.hasNumber = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EnumValueOptions options = 3;
 * @return {?proto.google.protobuf.EnumValueOptions}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.EnumValueOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.EnumValueOptions, 3);
};
/**
 * @param {?proto.google.protobuf.EnumValueOptions|undefined} value
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
*/ proto.google.protobuf.EnumValueDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.EnumValueDescriptorProto} returns this
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumValueDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.ServiceDescriptorProto.repeatedFields_ = [
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.ServiceDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.ServiceDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ServiceDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            methodList: $2MzPv.Message.toObjectList(msg.getMethodList(), proto.google.protobuf.MethodDescriptorProto.toObject, includeInstance),
            options: (f = msg.getOptions()) && proto.google.protobuf.ServiceOptions.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.ServiceDescriptorProto}
 */ proto.google.protobuf.ServiceDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.ServiceDescriptorProto;
    return proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.ServiceDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.ServiceDescriptorProto}
 */ proto.google.protobuf.ServiceDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = new proto.google.protobuf.MethodDescriptorProto;
                reader.readMessage(value, proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader);
                msg.addMethod(value);
                break;
            case 3:
                var value = new proto.google.protobuf.ServiceOptions;
                reader.readMessage(value, proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.ServiceDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ServiceDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getMethodList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter);
    f = message.getOptions();
    if (f != null) writer.writeMessage(3, f, proto.google.protobuf.ServiceOptions.serializeBinaryToWriter);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated MethodDescriptorProto method = 2;
 * @return {!Array<!proto.google.protobuf.MethodDescriptorProto>}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.getMethodList = function() {
    return /** @type{!Array<!proto.google.protobuf.MethodDescriptorProto>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.MethodDescriptorProto, 2);
};
/**
 * @param {!Array<!proto.google.protobuf.MethodDescriptorProto>} value
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
*/ proto.google.protobuf.ServiceDescriptorProto.prototype.setMethodList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.google.protobuf.MethodDescriptorProto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.MethodDescriptorProto}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.addMethod = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.MethodDescriptorProto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.clearMethodList = function() {
    return this.setMethodList([]);
};
/**
 * optional ServiceOptions options = 3;
 * @return {?proto.google.protobuf.ServiceOptions}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.ServiceOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.ServiceOptions, 3);
};
/**
 * @param {?proto.google.protobuf.ServiceOptions|undefined} value
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
*/ proto.google.protobuf.ServiceDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.ServiceDescriptorProto} returns this
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.ServiceDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.MethodDescriptorProto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.MethodDescriptorProto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MethodDescriptorProto.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            inputType: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            outputType: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            options: (f = msg.getOptions()) && proto.google.protobuf.MethodOptions.toObject(includeInstance, f),
            clientStreaming: $2MzPv.Message.getBooleanFieldWithDefault(msg, 5, false),
            serverStreaming: $2MzPv.Message.getBooleanFieldWithDefault(msg, 6, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.MethodDescriptorProto}
 */ proto.google.protobuf.MethodDescriptorProto.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.MethodDescriptorProto;
    return proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.MethodDescriptorProto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.MethodDescriptorProto}
 */ proto.google.protobuf.MethodDescriptorProto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setInputType(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setOutputType(value);
                break;
            case 4:
                var value = new proto.google.protobuf.MethodOptions;
                reader.readMessage(value, proto.google.protobuf.MethodOptions.deserializeBinaryFromReader);
                msg.setOptions(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setClientStreaming(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setServerStreaming(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.MethodDescriptorProto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MethodDescriptorProto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = message.getOptions();
    if (f != null) writer.writeMessage(4, f, proto.google.protobuf.MethodOptions.serializeBinaryToWriter);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBool(6, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string input_type = 2;
 * @return {string}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getInputType = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.setInputType = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearInputType = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasInputType = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string output_type = 3;
 * @return {string}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getOutputType = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.setOutputType = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearOutputType = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasOutputType = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional MethodOptions options = 4;
 * @return {?proto.google.protobuf.MethodOptions}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getOptions = function() {
    return /** @type{?proto.google.protobuf.MethodOptions} */ $2MzPv.Message.getWrapperField(this, proto.google.protobuf.MethodOptions, 4);
};
/**
 * @param {?proto.google.protobuf.MethodOptions|undefined} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
*/ proto.google.protobuf.MethodDescriptorProto.prototype.setOptions = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearOptions = function() {
    return this.setOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasOptions = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bool client_streaming = 5;
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getClientStreaming = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.setClientStreaming = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearClientStreaming = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasClientStreaming = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bool server_streaming = 6;
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.getServerStreaming = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.setServerStreaming = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodDescriptorProto} returns this
 */ proto.google.protobuf.MethodDescriptorProto.prototype.clearServerStreaming = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodDescriptorProto.prototype.hasServerStreaming = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.FileOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.FileOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.FileOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.FileOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            javaPackage: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            javaOuterClassname: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            javaMultipleFiles: $2MzPv.Message.getBooleanFieldWithDefault(msg, 10, false),
            javaGenerateEqualsAndHash: (f = $2MzPv.Message.getBooleanField(msg, 20)) == null ? undefined : f,
            javaStringCheckUtf8: $2MzPv.Message.getBooleanFieldWithDefault(msg, 27, false),
            optimizeFor: $2MzPv.Message.getFieldWithDefault(msg, 9, 1),
            goPackage: (f = $2MzPv.Message.getField(msg, 11)) == null ? undefined : f,
            ccGenericServices: $2MzPv.Message.getBooleanFieldWithDefault(msg, 16, false),
            javaGenericServices: $2MzPv.Message.getBooleanFieldWithDefault(msg, 17, false),
            pyGenericServices: $2MzPv.Message.getBooleanFieldWithDefault(msg, 18, false),
            phpGenericServices: $2MzPv.Message.getBooleanFieldWithDefault(msg, 42, false),
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 23, false),
            ccEnableArenas: $2MzPv.Message.getBooleanFieldWithDefault(msg, 31, true),
            objcClassPrefix: (f = $2MzPv.Message.getField(msg, 36)) == null ? undefined : f,
            csharpNamespace: (f = $2MzPv.Message.getField(msg, 37)) == null ? undefined : f,
            swiftPrefix: (f = $2MzPv.Message.getField(msg, 39)) == null ? undefined : f,
            phpClassPrefix: (f = $2MzPv.Message.getField(msg, 40)) == null ? undefined : f,
            phpNamespace: (f = $2MzPv.Message.getField(msg, 41)) == null ? undefined : f,
            phpMetadataNamespace: (f = $2MzPv.Message.getField(msg, 44)) == null ? undefined : f,
            rubyPackage: (f = $2MzPv.Message.getField(msg, 45)) == null ? undefined : f,
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.FileOptions.extensions, proto.google.protobuf.FileOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.FileOptions}
 */ proto.google.protobuf.FileOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.FileOptions;
    return proto.google.protobuf.FileOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.FileOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.FileOptions}
 */ proto.google.protobuf.FileOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setJavaPackage(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setJavaOuterClassname(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setJavaMultipleFiles(value);
                break;
            case 20:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setJavaGenerateEqualsAndHash(value);
                break;
            case 27:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setJavaStringCheckUtf8(value);
                break;
            case 9:
                var value = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ reader.readEnum();
                msg.setOptimizeFor(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setGoPackage(value);
                break;
            case 16:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setCcGenericServices(value);
                break;
            case 17:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setJavaGenericServices(value);
                break;
            case 18:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPyGenericServices(value);
                break;
            case 42:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPhpGenericServices(value);
                break;
            case 23:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 31:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setCcEnableArenas(value);
                break;
            case 36:
                var value = /** @type {string} */ reader.readString();
                msg.setObjcClassPrefix(value);
                break;
            case 37:
                var value = /** @type {string} */ reader.readString();
                msg.setCsharpNamespace(value);
                break;
            case 39:
                var value = /** @type {string} */ reader.readString();
                msg.setSwiftPrefix(value);
                break;
            case 40:
                var value = /** @type {string} */ reader.readString();
                msg.setPhpClassPrefix(value);
                break;
            case 41:
                var value = /** @type {string} */ reader.readString();
                msg.setPhpNamespace(value);
                break;
            case 44:
                var value = /** @type {string} */ reader.readString();
                msg.setPhpMetadataNamespace(value);
                break;
            case 45:
                var value = /** @type {string} */ reader.readString();
                msg.setRubyPackage(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.FileOptions.extensionsBinary, proto.google.protobuf.FileOptions.prototype.getExtension, proto.google.protobuf.FileOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.FileOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.FileOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.FileOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FileOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeString(8, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeBool(10, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 20);
    if (f != null) writer.writeBool(20, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 27);
    if (f != null) writer.writeBool(27, f);
    f = /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeEnum(9, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 11);
    if (f != null) writer.writeString(11, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 16);
    if (f != null) writer.writeBool(16, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 17);
    if (f != null) writer.writeBool(17, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 18);
    if (f != null) writer.writeBool(18, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 42);
    if (f != null) writer.writeBool(42, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 23);
    if (f != null) writer.writeBool(23, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 31);
    if (f != null) writer.writeBool(31, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 36);
    if (f != null) writer.writeString(36, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 37);
    if (f != null) writer.writeString(37, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 39);
    if (f != null) writer.writeString(39, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 40);
    if (f != null) writer.writeString(40, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 41);
    if (f != null) writer.writeString(41, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 44);
    if (f != null) writer.writeString(44, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 45);
    if (f != null) writer.writeString(45, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.FileOptions.extensionsBinary, proto.google.protobuf.FileOptions.prototype.getExtension);
};
/**
 * @enum {number}
 */ proto.google.protobuf.FileOptions.OptimizeMode = {
    SPEED: 1,
    CODE_SIZE: 2,
    LITE_RUNTIME: 3
};
/**
 * optional string java_package = 1;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getJavaPackage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaPackage = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaPackage = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaPackage = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string java_outer_classname = 8;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getJavaOuterClassname = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaOuterClassname = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaOuterClassname = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaOuterClassname = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional bool java_multiple_files = 10;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getJavaMultipleFiles = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaMultipleFiles = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaMultipleFiles = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaMultipleFiles = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional bool java_generate_equals_and_hash = 20;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getJavaGenerateEqualsAndHash = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 20, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaGenerateEqualsAndHash = function(value) {
    return $2MzPv.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaGenerateEqualsAndHash = function() {
    return $2MzPv.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaGenerateEqualsAndHash = function() {
    return $2MzPv.Message.getField(this, 20) != null;
};
/**
 * optional bool java_string_check_utf8 = 27;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getJavaStringCheckUtf8 = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 27, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaStringCheckUtf8 = function(value) {
    return $2MzPv.Message.setField(this, 27, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaStringCheckUtf8 = function() {
    return $2MzPv.Message.setField(this, 27, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaStringCheckUtf8 = function() {
    return $2MzPv.Message.getField(this, 27) != null;
};
/**
 * optional OptimizeMode optimize_for = 9;
 * @return {!proto.google.protobuf.FileOptions.OptimizeMode}
 */ proto.google.protobuf.FileOptions.prototype.getOptimizeFor = function() {
    return /** @type {!proto.google.protobuf.FileOptions.OptimizeMode} */ $2MzPv.Message.getFieldWithDefault(this, 9, 1);
};
/**
 * @param {!proto.google.protobuf.FileOptions.OptimizeMode} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setOptimizeFor = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearOptimizeFor = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasOptimizeFor = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional string go_package = 11;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getGoPackage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setGoPackage = function(value) {
    return $2MzPv.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearGoPackage = function() {
    return $2MzPv.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasGoPackage = function() {
    return $2MzPv.Message.getField(this, 11) != null;
};
/**
 * optional bool cc_generic_services = 16;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getCcGenericServices = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 16, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setCcGenericServices = function(value) {
    return $2MzPv.Message.setField(this, 16, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearCcGenericServices = function() {
    return $2MzPv.Message.setField(this, 16, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasCcGenericServices = function() {
    return $2MzPv.Message.getField(this, 16) != null;
};
/**
 * optional bool java_generic_services = 17;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getJavaGenericServices = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 17, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setJavaGenericServices = function(value) {
    return $2MzPv.Message.setField(this, 17, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearJavaGenericServices = function() {
    return $2MzPv.Message.setField(this, 17, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasJavaGenericServices = function() {
    return $2MzPv.Message.getField(this, 17) != null;
};
/**
 * optional bool py_generic_services = 18;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getPyGenericServices = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 18, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setPyGenericServices = function(value) {
    return $2MzPv.Message.setField(this, 18, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearPyGenericServices = function() {
    return $2MzPv.Message.setField(this, 18, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasPyGenericServices = function() {
    return $2MzPv.Message.getField(this, 18) != null;
};
/**
 * optional bool php_generic_services = 42;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getPhpGenericServices = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 42, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setPhpGenericServices = function(value) {
    return $2MzPv.Message.setField(this, 42, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearPhpGenericServices = function() {
    return $2MzPv.Message.setField(this, 42, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasPhpGenericServices = function() {
    return $2MzPv.Message.getField(this, 42) != null;
};
/**
 * optional bool deprecated = 23;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 23, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 23, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 23, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 23) != null;
};
/**
 * optional bool cc_enable_arenas = 31;
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.getCcEnableArenas = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 31, true);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setCcEnableArenas = function(value) {
    return $2MzPv.Message.setField(this, 31, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearCcEnableArenas = function() {
    return $2MzPv.Message.setField(this, 31, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasCcEnableArenas = function() {
    return $2MzPv.Message.getField(this, 31) != null;
};
/**
 * optional string objc_class_prefix = 36;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getObjcClassPrefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 36, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setObjcClassPrefix = function(value) {
    return $2MzPv.Message.setField(this, 36, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearObjcClassPrefix = function() {
    return $2MzPv.Message.setField(this, 36, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasObjcClassPrefix = function() {
    return $2MzPv.Message.getField(this, 36) != null;
};
/**
 * optional string csharp_namespace = 37;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getCsharpNamespace = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 37, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setCsharpNamespace = function(value) {
    return $2MzPv.Message.setField(this, 37, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearCsharpNamespace = function() {
    return $2MzPv.Message.setField(this, 37, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasCsharpNamespace = function() {
    return $2MzPv.Message.getField(this, 37) != null;
};
/**
 * optional string swift_prefix = 39;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getSwiftPrefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 39, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setSwiftPrefix = function(value) {
    return $2MzPv.Message.setField(this, 39, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearSwiftPrefix = function() {
    return $2MzPv.Message.setField(this, 39, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasSwiftPrefix = function() {
    return $2MzPv.Message.getField(this, 39) != null;
};
/**
 * optional string php_class_prefix = 40;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getPhpClassPrefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 40, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setPhpClassPrefix = function(value) {
    return $2MzPv.Message.setField(this, 40, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearPhpClassPrefix = function() {
    return $2MzPv.Message.setField(this, 40, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasPhpClassPrefix = function() {
    return $2MzPv.Message.getField(this, 40) != null;
};
/**
 * optional string php_namespace = 41;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getPhpNamespace = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 41, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setPhpNamespace = function(value) {
    return $2MzPv.Message.setField(this, 41, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearPhpNamespace = function() {
    return $2MzPv.Message.setField(this, 41, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasPhpNamespace = function() {
    return $2MzPv.Message.getField(this, 41) != null;
};
/**
 * optional string php_metadata_namespace = 44;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getPhpMetadataNamespace = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 44, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setPhpMetadataNamespace = function(value) {
    return $2MzPv.Message.setField(this, 44, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearPhpMetadataNamespace = function() {
    return $2MzPv.Message.setField(this, 44, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasPhpMetadataNamespace = function() {
    return $2MzPv.Message.getField(this, 44) != null;
};
/**
 * optional string ruby_package = 45;
 * @return {string}
 */ proto.google.protobuf.FileOptions.prototype.getRubyPackage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 45, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.setRubyPackage = function(value) {
    return $2MzPv.Message.setField(this, 45, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearRubyPackage = function() {
    return $2MzPv.Message.setField(this, 45, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FileOptions.prototype.hasRubyPackage = function() {
    return $2MzPv.Message.getField(this, 45) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.FileOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.FileOptions} returns this
*/ proto.google.protobuf.FileOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.FileOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FileOptions} returns this
 */ proto.google.protobuf.FileOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.MessageOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.MessageOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.MessageOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.MessageOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MessageOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            messageSetWireFormat: $2MzPv.Message.getBooleanFieldWithDefault(msg, 1, false),
            noStandardDescriptorAccessor: $2MzPv.Message.getBooleanFieldWithDefault(msg, 2, false),
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 3, false),
            mapEntry: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.MessageOptions.extensions, proto.google.protobuf.MessageOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.MessageOptions}
 */ proto.google.protobuf.MessageOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.MessageOptions;
    return proto.google.protobuf.MessageOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.MessageOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.MessageOptions}
 */ proto.google.protobuf.MessageOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setMessageSetWireFormat(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setNoStandardDescriptorAccessor(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setMapEntry(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.MessageOptions.extensionsBinary, proto.google.protobuf.MessageOptions.prototype.getExtension, proto.google.protobuf.MessageOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.MessageOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.MessageOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.MessageOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MessageOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.MessageOptions.extensionsBinary, proto.google.protobuf.MessageOptions.prototype.getExtension);
};
/**
 * optional bool message_set_wire_format = 1;
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.getMessageSetWireFormat = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.setMessageSetWireFormat = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.clearMessageSetWireFormat = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.hasMessageSetWireFormat = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool no_standard_descriptor_accessor = 2;
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.getNoStandardDescriptorAccessor = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.setNoStandardDescriptorAccessor = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.clearNoStandardDescriptorAccessor = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.hasNoStandardDescriptorAccessor = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool deprecated = 3;
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool map_entry = 7;
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.getMapEntry = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.setMapEntry = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.clearMapEntry = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MessageOptions.prototype.hasMapEntry = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.MessageOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.MessageOptions} returns this
*/ proto.google.protobuf.MessageOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.MessageOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.MessageOptions} returns this
 */ proto.google.protobuf.MessageOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.FieldOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.FieldOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.FieldOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.FieldOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FieldOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            ctype: $2MzPv.Message.getFieldWithDefault(msg, 1, 0),
            packed: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            jstype: $2MzPv.Message.getFieldWithDefault(msg, 6, 0),
            lazy: $2MzPv.Message.getBooleanFieldWithDefault(msg, 5, false),
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 3, false),
            weak: $2MzPv.Message.getBooleanFieldWithDefault(msg, 10, false),
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.FieldOptions.extensions, proto.google.protobuf.FieldOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.FieldOptions}
 */ proto.google.protobuf.FieldOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.FieldOptions;
    return proto.google.protobuf.FieldOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.FieldOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.FieldOptions}
 */ proto.google.protobuf.FieldOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.google.protobuf.FieldOptions.CType} */ reader.readEnum();
                msg.setCtype(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPacked(value);
                break;
            case 6:
                var value = /** @type {!proto.google.protobuf.FieldOptions.JSType} */ reader.readEnum();
                msg.setJstype(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLazy(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWeak(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.FieldOptions.extensionsBinary, proto.google.protobuf.FieldOptions.prototype.getExtension, proto.google.protobuf.FieldOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.FieldOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.FieldOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.FieldOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.FieldOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.google.protobuf.FieldOptions.CType} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {!proto.google.protobuf.FieldOptions.JSType} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeEnum(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeBool(10, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.FieldOptions.extensionsBinary, proto.google.protobuf.FieldOptions.prototype.getExtension);
};
/**
 * @enum {number}
 */ proto.google.protobuf.FieldOptions.CType = {
    STRING: 0,
    CORD: 1,
    STRING_PIECE: 2
};
/**
 * @enum {number}
 */ proto.google.protobuf.FieldOptions.JSType = {
    JS_NORMAL: 0,
    JS_STRING: 1,
    JS_NUMBER: 2
};
/**
 * optional CType ctype = 1;
 * @return {!proto.google.protobuf.FieldOptions.CType}
 */ proto.google.protobuf.FieldOptions.prototype.getCtype = function() {
    return /** @type {!proto.google.protobuf.FieldOptions.CType} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.google.protobuf.FieldOptions.CType} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setCtype = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearCtype = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasCtype = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool packed = 2;
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.getPacked = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setPacked = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearPacked = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasPacked = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional JSType jstype = 6;
 * @return {!proto.google.protobuf.FieldOptions.JSType}
 */ proto.google.protobuf.FieldOptions.prototype.getJstype = function() {
    return /** @type {!proto.google.protobuf.FieldOptions.JSType} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.google.protobuf.FieldOptions.JSType} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setJstype = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearJstype = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasJstype = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool lazy = 5;
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.getLazy = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setLazy = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearLazy = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasLazy = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bool deprecated = 3;
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool weak = 10;
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.getWeak = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.setWeak = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearWeak = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.FieldOptions.prototype.hasWeak = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.FieldOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.FieldOptions} returns this
*/ proto.google.protobuf.FieldOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.FieldOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.FieldOptions} returns this
 */ proto.google.protobuf.FieldOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.OneofOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.OneofOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.OneofOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.OneofOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.OneofOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.OneofOptions.extensions, proto.google.protobuf.OneofOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.OneofOptions}
 */ proto.google.protobuf.OneofOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.OneofOptions;
    return proto.google.protobuf.OneofOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.OneofOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.OneofOptions}
 */ proto.google.protobuf.OneofOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.OneofOptions.extensionsBinary, proto.google.protobuf.OneofOptions.prototype.getExtension, proto.google.protobuf.OneofOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.OneofOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.OneofOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.OneofOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.OneofOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.OneofOptions.extensionsBinary, proto.google.protobuf.OneofOptions.prototype.getExtension);
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.OneofOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.OneofOptions} returns this
*/ proto.google.protobuf.OneofOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.OneofOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.OneofOptions} returns this
 */ proto.google.protobuf.OneofOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.EnumOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.EnumOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.EnumOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.EnumOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            allowAlias: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 3, false),
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.EnumOptions.extensions, proto.google.protobuf.EnumOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.EnumOptions}
 */ proto.google.protobuf.EnumOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.EnumOptions;
    return proto.google.protobuf.EnumOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.EnumOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.EnumOptions}
 */ proto.google.protobuf.EnumOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAllowAlias(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.EnumOptions.extensionsBinary, proto.google.protobuf.EnumOptions.prototype.getExtension, proto.google.protobuf.EnumOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.EnumOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.EnumOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.EnumOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.EnumOptions.extensionsBinary, proto.google.protobuf.EnumOptions.prototype.getExtension);
};
/**
 * optional bool allow_alias = 2;
 * @return {boolean}
 */ proto.google.protobuf.EnumOptions.prototype.getAllowAlias = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.EnumOptions} returns this
 */ proto.google.protobuf.EnumOptions.prototype.setAllowAlias = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumOptions} returns this
 */ proto.google.protobuf.EnumOptions.prototype.clearAllowAlias = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumOptions.prototype.hasAllowAlias = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool deprecated = 3;
 * @return {boolean}
 */ proto.google.protobuf.EnumOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.EnumOptions} returns this
 */ proto.google.protobuf.EnumOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumOptions} returns this
 */ proto.google.protobuf.EnumOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.EnumOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.EnumOptions} returns this
*/ proto.google.protobuf.EnumOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.EnumOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.EnumOptions} returns this
 */ proto.google.protobuf.EnumOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.EnumValueOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.EnumValueOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.EnumValueOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.EnumValueOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumValueOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 1, false),
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.EnumValueOptions.extensions, proto.google.protobuf.EnumValueOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.EnumValueOptions}
 */ proto.google.protobuf.EnumValueOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.EnumValueOptions;
    return proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.EnumValueOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.EnumValueOptions}
 */ proto.google.protobuf.EnumValueOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.EnumValueOptions.extensionsBinary, proto.google.protobuf.EnumValueOptions.prototype.getExtension, proto.google.protobuf.EnumValueOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.EnumValueOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.EnumValueOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.EnumValueOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.EnumValueOptions.extensionsBinary, proto.google.protobuf.EnumValueOptions.prototype.getExtension);
};
/**
 * optional bool deprecated = 1;
 * @return {boolean}
 */ proto.google.protobuf.EnumValueOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.EnumValueOptions} returns this
 */ proto.google.protobuf.EnumValueOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.EnumValueOptions} returns this
 */ proto.google.protobuf.EnumValueOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.EnumValueOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.EnumValueOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.EnumValueOptions} returns this
*/ proto.google.protobuf.EnumValueOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.EnumValueOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.EnumValueOptions} returns this
 */ proto.google.protobuf.EnumValueOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.ServiceOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.ServiceOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.ServiceOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.ServiceOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ServiceOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 33, false),
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.ServiceOptions.extensions, proto.google.protobuf.ServiceOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.ServiceOptions}
 */ proto.google.protobuf.ServiceOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.ServiceOptions;
    return proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.ServiceOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.ServiceOptions}
 */ proto.google.protobuf.ServiceOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 33:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.ServiceOptions.extensionsBinary, proto.google.protobuf.ServiceOptions.prototype.getExtension, proto.google.protobuf.ServiceOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.ServiceOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.ServiceOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.ServiceOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.ServiceOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 33);
    if (f != null) writer.writeBool(33, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.ServiceOptions.extensionsBinary, proto.google.protobuf.ServiceOptions.prototype.getExtension);
};
/**
 * optional bool deprecated = 33;
 * @return {boolean}
 */ proto.google.protobuf.ServiceOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 33, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.ServiceOptions} returns this
 */ proto.google.protobuf.ServiceOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 33, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.ServiceOptions} returns this
 */ proto.google.protobuf.ServiceOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 33, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.ServiceOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 33) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.ServiceOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.ServiceOptions} returns this
*/ proto.google.protobuf.ServiceOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.ServiceOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.ServiceOptions} returns this
 */ proto.google.protobuf.ServiceOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.MethodOptions.repeatedFields_ = [
    999
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.MethodOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.MethodOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.MethodOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MethodOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            deprecated: $2MzPv.Message.getBooleanFieldWithDefault(msg, 33, false),
            idempotencyLevel: $2MzPv.Message.getFieldWithDefault(msg, 34, 0),
            uninterpretedOptionList: $2MzPv.Message.toObjectList(msg.getUninterpretedOptionList(), proto.google.protobuf.UninterpretedOption.toObject, includeInstance)
        };
        $2MzPv.Message.toObjectExtension(/** @type {!jspb.Message} */ msg, obj, proto.google.protobuf.MethodOptions.extensions, proto.google.protobuf.MethodOptions.prototype.getExtension, includeInstance);
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.MethodOptions}
 */ proto.google.protobuf.MethodOptions.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.MethodOptions;
    return proto.google.protobuf.MethodOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.MethodOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.MethodOptions}
 */ proto.google.protobuf.MethodOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 33:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeprecated(value);
                break;
            case 34:
                var value = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ reader.readEnum();
                msg.setIdempotencyLevel(value);
                break;
            case 999:
                var value = new proto.google.protobuf.UninterpretedOption;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader);
                msg.addUninterpretedOption(value);
                break;
            default:
                $2MzPv.Message.readBinaryExtension(msg, reader, proto.google.protobuf.MethodOptions.extensionsBinary, proto.google.protobuf.MethodOptions.prototype.getExtension, proto.google.protobuf.MethodOptions.prototype.setExtension);
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.MethodOptions.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.MethodOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.MethodOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.MethodOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 33);
    if (f != null) writer.writeBool(33, f);
    f = /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ $2MzPv.Message.getField(message, 34);
    if (f != null) writer.writeEnum(34, f);
    f = message.getUninterpretedOptionList();
    if (f.length > 0) writer.writeRepeatedMessage(999, f, proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter);
    $2MzPv.Message.serializeBinaryExtensions(message, writer, proto.google.protobuf.MethodOptions.extensionsBinary, proto.google.protobuf.MethodOptions.prototype.getExtension);
};
/**
 * @enum {number}
 */ proto.google.protobuf.MethodOptions.IdempotencyLevel = {
    IDEMPOTENCY_UNKNOWN: 0,
    NO_SIDE_EFFECTS: 1,
    IDEMPOTENT: 2
};
/**
 * optional bool deprecated = 33;
 * @return {boolean}
 */ proto.google.protobuf.MethodOptions.prototype.getDeprecated = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 33, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.MethodOptions} returns this
 */ proto.google.protobuf.MethodOptions.prototype.setDeprecated = function(value) {
    return $2MzPv.Message.setField(this, 33, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodOptions} returns this
 */ proto.google.protobuf.MethodOptions.prototype.clearDeprecated = function() {
    return $2MzPv.Message.setField(this, 33, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodOptions.prototype.hasDeprecated = function() {
    return $2MzPv.Message.getField(this, 33) != null;
};
/**
 * optional IdempotencyLevel idempotency_level = 34;
 * @return {!proto.google.protobuf.MethodOptions.IdempotencyLevel}
 */ proto.google.protobuf.MethodOptions.prototype.getIdempotencyLevel = function() {
    return /** @type {!proto.google.protobuf.MethodOptions.IdempotencyLevel} */ $2MzPv.Message.getFieldWithDefault(this, 34, 0);
};
/**
 * @param {!proto.google.protobuf.MethodOptions.IdempotencyLevel} value
 * @return {!proto.google.protobuf.MethodOptions} returns this
 */ proto.google.protobuf.MethodOptions.prototype.setIdempotencyLevel = function(value) {
    return $2MzPv.Message.setField(this, 34, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.MethodOptions} returns this
 */ proto.google.protobuf.MethodOptions.prototype.clearIdempotencyLevel = function() {
    return $2MzPv.Message.setField(this, 34, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.MethodOptions.prototype.hasIdempotencyLevel = function() {
    return $2MzPv.Message.getField(this, 34) != null;
};
/**
 * repeated UninterpretedOption uninterpreted_option = 999;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption>}
 */ proto.google.protobuf.MethodOptions.prototype.getUninterpretedOptionList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption, 999);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption>} value
 * @return {!proto.google.protobuf.MethodOptions} returns this
*/ proto.google.protobuf.MethodOptions.prototype.setUninterpretedOptionList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 999, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.MethodOptions.prototype.addUninterpretedOption = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 999, opt_value, proto.google.protobuf.UninterpretedOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.MethodOptions} returns this
 */ proto.google.protobuf.MethodOptions.prototype.clearUninterpretedOptionList = function() {
    return this.setUninterpretedOptionList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.UninterpretedOption.repeatedFields_ = [
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.UninterpretedOption.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.UninterpretedOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.UninterpretedOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.UninterpretedOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            nameList: $2MzPv.Message.toObjectList(msg.getNameList(), proto.google.protobuf.UninterpretedOption.NamePart.toObject, includeInstance),
            identifierValue: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            positiveIntValue: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            negativeIntValue: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            doubleValue: (f = $2MzPv.Message.getOptionalFloatingPointField(msg, 6)) == null ? undefined : f,
            stringValue: msg.getStringValue_asB64(),
            aggregateValue: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.UninterpretedOption.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.UninterpretedOption;
    return proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.UninterpretedOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.UninterpretedOption}
 */ proto.google.protobuf.UninterpretedOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = new proto.google.protobuf.UninterpretedOption.NamePart;
                reader.readMessage(value, proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader);
                msg.addName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setIdentifierValue(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint64();
                msg.setPositiveIntValue(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setNegativeIntValue(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readDouble();
                msg.setDoubleValue(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setStringValue(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setAggregateValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.UninterpretedOption.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.UninterpretedOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.UninterpretedOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNameList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint64(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeInt64(5, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeDouble(6, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBytes(7, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeString(8, f);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.UninterpretedOption.NamePart.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.UninterpretedOption.NamePart} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.UninterpretedOption.NamePart.toObject = function(includeInstance, msg) {
        var f, obj = {
            namePart: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            isExtension: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
 */ proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.UninterpretedOption.NamePart;
    return proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.UninterpretedOption.NamePart} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
 */ proto.google.protobuf.UninterpretedOption.NamePart.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setNamePart(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsExtension(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.UninterpretedOption.NamePart} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.UninterpretedOption.NamePart.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * required string name_part = 1;
 * @return {string}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.getNamePart = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart} returns this
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.setNamePart = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart} returns this
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearNamePart = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasNamePart = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required bool is_extension = 2;
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.getIsExtension = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart} returns this
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.setIsExtension = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart} returns this
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.clearIsExtension = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.NamePart.prototype.hasIsExtension = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * repeated NamePart name = 2;
 * @return {!Array<!proto.google.protobuf.UninterpretedOption.NamePart>}
 */ proto.google.protobuf.UninterpretedOption.prototype.getNameList = function() {
    return /** @type{!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.UninterpretedOption.NamePart, 2);
};
/**
 * @param {!Array<!proto.google.protobuf.UninterpretedOption.NamePart>} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
*/ proto.google.protobuf.UninterpretedOption.prototype.setNameList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.google.protobuf.UninterpretedOption.NamePart=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.UninterpretedOption.NamePart}
 */ proto.google.protobuf.UninterpretedOption.prototype.addName = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.google.protobuf.UninterpretedOption.NamePart, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearNameList = function() {
    return this.setNameList([]);
};
/**
 * optional string identifier_value = 3;
 * @return {string}
 */ proto.google.protobuf.UninterpretedOption.prototype.getIdentifierValue = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setIdentifierValue = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearIdentifierValue = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasIdentifierValue = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint64 positive_int_value = 4;
 * @return {number}
 */ proto.google.protobuf.UninterpretedOption.prototype.getPositiveIntValue = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setPositiveIntValue = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearPositiveIntValue = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasPositiveIntValue = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional int64 negative_int_value = 5;
 * @return {number}
 */ proto.google.protobuf.UninterpretedOption.prototype.getNegativeIntValue = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setNegativeIntValue = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearNegativeIntValue = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasNegativeIntValue = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional double double_value = 6;
 * @return {number}
 */ proto.google.protobuf.UninterpretedOption.prototype.getDoubleValue = function() {
    return /** @type {number} */ $2MzPv.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setDoubleValue = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearDoubleValue = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasDoubleValue = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bytes string_value = 7;
 * @return {!(string|Uint8Array)}
 */ proto.google.protobuf.UninterpretedOption.prototype.getStringValue = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes string_value = 7;
 * This is a type-conversion wrapper around `getStringValue()`
 * @return {string}
 */ proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getStringValue());
};
/**
 * optional bytes string_value = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getStringValue()`
 * @return {!Uint8Array}
 */ proto.google.protobuf.UninterpretedOption.prototype.getStringValue_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getStringValue());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setStringValue = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearStringValue = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasStringValue = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional string aggregate_value = 8;
 * @return {string}
 */ proto.google.protobuf.UninterpretedOption.prototype.getAggregateValue = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.setAggregateValue = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.UninterpretedOption} returns this
 */ proto.google.protobuf.UninterpretedOption.prototype.clearAggregateValue = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.UninterpretedOption.prototype.hasAggregateValue = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.SourceCodeInfo.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.SourceCodeInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.SourceCodeInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.SourceCodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.SourceCodeInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            locationList: $2MzPv.Message.toObjectList(msg.getLocationList(), proto.google.protobuf.SourceCodeInfo.Location.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.SourceCodeInfo}
 */ proto.google.protobuf.SourceCodeInfo.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.SourceCodeInfo;
    return proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.SourceCodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.SourceCodeInfo}
 */ proto.google.protobuf.SourceCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.google.protobuf.SourceCodeInfo.Location;
                reader.readMessage(value, proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader);
                msg.addLocation(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.SourceCodeInfo.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.SourceCodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.SourceCodeInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLocationList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.SourceCodeInfo.Location.repeatedFields_ = [
    1,
    2,
    6
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.SourceCodeInfo.Location.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.SourceCodeInfo.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.SourceCodeInfo.Location.toObject = function(includeInstance, msg) {
        var f, obj = {
            pathList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            spanList: (f = $2MzPv.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
            leadingComments: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            trailingComments: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            leadingDetachedCommentsList: (f = $2MzPv.Message.getRepeatedField(msg, 6)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location}
 */ proto.google.protobuf.SourceCodeInfo.Location.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.SourceCodeInfo.Location;
    return proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.SourceCodeInfo.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location}
 */ proto.google.protobuf.SourceCodeInfo.Location.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addPath(values[i]);
                break;
            case 2:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addSpan(values[i]);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLeadingComments(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTrailingComments(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.addLeadingDetachedComments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.SourceCodeInfo.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.SourceCodeInfo.Location.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPathList();
    if (f.length > 0) writer.writePackedInt32(1, f);
    f = message.getSpanList();
    if (f.length > 0) writer.writePackedInt32(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = message.getLeadingDetachedCommentsList();
    if (f.length > 0) writer.writeRepeatedString(6, f);
};
/**
 * repeated int32 path = 1;
 * @return {!Array<number>}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.getPathList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.setPathList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.addPath = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.clearPathList = function() {
    return this.setPathList([]);
};
/**
 * repeated int32 span = 2;
 * @return {!Array<number>}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.getSpanList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.setSpanList = function(value) {
    return $2MzPv.Message.setField(this, 2, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.addSpan = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.clearSpanList = function() {
    return this.setSpanList([]);
};
/**
 * optional string leading_comments = 3;
 * @return {string}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingComments = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingComments = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingComments = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.hasLeadingComments = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string trailing_comments = 4;
 * @return {string}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.getTrailingComments = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.setTrailingComments = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.clearTrailingComments = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.hasTrailingComments = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * repeated string leading_detached_comments = 6;
 * @return {!Array<string>}
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.getLeadingDetachedCommentsList = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.getRepeatedField(this, 6);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.setLeadingDetachedCommentsList = function(value) {
    return $2MzPv.Message.setField(this, 6, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.addLeadingDetachedComments = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.SourceCodeInfo.Location} returns this
 */ proto.google.protobuf.SourceCodeInfo.Location.prototype.clearLeadingDetachedCommentsList = function() {
    return this.setLeadingDetachedCommentsList([]);
};
/**
 * repeated Location location = 1;
 * @return {!Array<!proto.google.protobuf.SourceCodeInfo.Location>}
 */ proto.google.protobuf.SourceCodeInfo.prototype.getLocationList = function() {
    return /** @type{!Array<!proto.google.protobuf.SourceCodeInfo.Location>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.SourceCodeInfo.Location, 1);
};
/**
 * @param {!Array<!proto.google.protobuf.SourceCodeInfo.Location>} value
 * @return {!proto.google.protobuf.SourceCodeInfo} returns this
*/ proto.google.protobuf.SourceCodeInfo.prototype.setLocationList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.google.protobuf.SourceCodeInfo.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.SourceCodeInfo.Location}
 */ proto.google.protobuf.SourceCodeInfo.prototype.addLocation = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.SourceCodeInfo.Location, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.SourceCodeInfo} returns this
 */ proto.google.protobuf.SourceCodeInfo.prototype.clearLocationList = function() {
    return this.setLocationList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.GeneratedCodeInfo.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.GeneratedCodeInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.GeneratedCodeInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.GeneratedCodeInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.GeneratedCodeInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            annotationList: $2MzPv.Message.toObjectList(msg.getAnnotationList(), proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.GeneratedCodeInfo}
 */ proto.google.protobuf.GeneratedCodeInfo.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.GeneratedCodeInfo;
    return proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.GeneratedCodeInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.GeneratedCodeInfo}
 */ proto.google.protobuf.GeneratedCodeInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.google.protobuf.GeneratedCodeInfo.Annotation;
                reader.readMessage(value, proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader);
                msg.addAnnotation(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.GeneratedCodeInfo.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.GeneratedCodeInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.GeneratedCodeInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAnnotationList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.toObject = function(opt_includeInstance) {
        return proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.toObject = function(includeInstance, msg) {
        var f, obj = {
            pathList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            sourceFile: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            begin: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            end: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.google.protobuf.GeneratedCodeInfo.Annotation;
    return proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addPath(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceFile(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBegin(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEnd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPathList();
    if (f.length > 0) writer.writePackedInt32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeInt32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeInt32(4, f);
};
/**
 * repeated int32 path = 1;
 * @return {!Array<number>}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getPathList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setPathList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.addPath = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearPathList = function() {
    return this.setPathList([]);
};
/**
 * optional string source_file = 2;
 * @return {string}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getSourceFile = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setSourceFile = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearSourceFile = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasSourceFile = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional int32 begin = 3;
 * @return {number}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getBegin = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setBegin = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearBegin = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasBegin = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional int32 end = 4;
 * @return {number}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.getEnd = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.setEnd = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.clearEnd = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.google.protobuf.GeneratedCodeInfo.Annotation.prototype.hasEnd = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * repeated Annotation annotation = 1;
 * @return {!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>}
 */ proto.google.protobuf.GeneratedCodeInfo.prototype.getAnnotationList = function() {
    return /** @type{!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.google.protobuf.GeneratedCodeInfo.Annotation, 1);
};
/**
 * @param {!Array<!proto.google.protobuf.GeneratedCodeInfo.Annotation>} value
 * @return {!proto.google.protobuf.GeneratedCodeInfo} returns this
*/ proto.google.protobuf.GeneratedCodeInfo.prototype.setAnnotationList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.google.protobuf.GeneratedCodeInfo.Annotation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.google.protobuf.GeneratedCodeInfo.Annotation}
 */ proto.google.protobuf.GeneratedCodeInfo.prototype.addAnnotation = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.google.protobuf.GeneratedCodeInfo.Annotation, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.google.protobuf.GeneratedCodeInfo} returns this
 */ proto.google.protobuf.GeneratedCodeInfo.prototype.clearAnnotationList = function() {
    return this.setAnnotationList([]);
};
$8c6cf1e0333499b5$var$goog.object.extend($8c6cf1e0333499b5$exports, proto.google.protobuf);


$d4cdf7121546d3d6$var$goog.object.extend(proto, $8c6cf1e0333499b5$exports);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.ButtonRequestType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.CoinType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.FailureType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.HDNodePathType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.HDNodeType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.IdentityType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.InputScriptType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.MultisigRedeemScriptType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.OutputAddressType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.OutputScriptType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.PinMatrixRequestType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.PolicyType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.RawTransactionType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.RequestType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TransactionType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TxInputType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TxOutputBinType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TxOutputType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TxRequestDetailsType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.TxRequestSerializedType", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.wireDebugIn", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.wireDebugOut", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.wireIn", null, $d4cdf7121546d3d6$var$global);
$d4cdf7121546d3d6$var$goog.exportSymbol("proto.wireOut", null, $d4cdf7121546d3d6$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.HDNodeType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.HDNodeType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.HDNodeType.displayName = "proto.HDNodeType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.HDNodePathType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.HDNodePathType.repeatedFields_, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.HDNodePathType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.HDNodePathType.displayName = "proto.HDNodePathType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CoinType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.CoinType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CoinType.displayName = "proto.CoinType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MultisigRedeemScriptType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.MultisigRedeemScriptType.repeatedFields_, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.MultisigRedeemScriptType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MultisigRedeemScriptType.displayName = "proto.MultisigRedeemScriptType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxInputType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.TxInputType.repeatedFields_, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TxInputType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxInputType.displayName = "proto.TxInputType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxOutputType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.TxOutputType.repeatedFields_, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TxOutputType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxOutputType.displayName = "proto.TxOutputType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxOutputBinType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TxOutputBinType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxOutputBinType.displayName = "proto.TxOutputBinType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TransactionType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.TransactionType.repeatedFields_, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TransactionType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TransactionType.displayName = "proto.TransactionType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RawTransactionType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.RawTransactionType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RawTransactionType.displayName = "proto.RawTransactionType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxRequestDetailsType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TxRequestDetailsType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxRequestDetailsType.displayName = "proto.TxRequestDetailsType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxRequestSerializedType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.TxRequestSerializedType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxRequestSerializedType.displayName = "proto.TxRequestSerializedType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.IdentityType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.IdentityType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.IdentityType.displayName = "proto.IdentityType";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PolicyType = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$d4cdf7121546d3d6$var$goog.inherits(proto.PolicyType, $2MzPv.Message);
if ($d4cdf7121546d3d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PolicyType.displayName = "proto.PolicyType";
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.HDNodeType.prototype.toObject = function(opt_includeInstance) {
        return proto.HDNodeType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.HDNodeType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.HDNodeType.toObject = function(includeInstance, msg) {
        var f, obj = {
            depth: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            fingerprint: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            childNum: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            chainCode: msg.getChainCode_asB64(),
            privateKey: msg.getPrivateKey_asB64(),
            publicKey: msg.getPublicKey_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.HDNodeType}
 */ proto.HDNodeType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.HDNodeType;
    return proto.HDNodeType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.HDNodeType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.HDNodeType}
 */ proto.HDNodeType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDepth(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFingerprint(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setChildNum(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setChainCode(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPrivateKey(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.HDNodeType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.HDNodeType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.HDNodeType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.HDNodeType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBytes(5, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBytes(6, f);
};
/**
 * required uint32 depth = 1;
 * @return {number}
 */ proto.HDNodeType.prototype.getDepth = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setDepth = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearDepth = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasDepth = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required uint32 fingerprint = 2;
 * @return {number}
 */ proto.HDNodeType.prototype.getFingerprint = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setFingerprint = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearFingerprint = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasFingerprint = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * required uint32 child_num = 3;
 * @return {number}
 */ proto.HDNodeType.prototype.getChildNum = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setChildNum = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearChildNum = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasChildNum = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * required bytes chain_code = 4;
 * @return {!(string|Uint8Array)}
 */ proto.HDNodeType.prototype.getChainCode = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * required bytes chain_code = 4;
 * This is a type-conversion wrapper around `getChainCode()`
 * @return {string}
 */ proto.HDNodeType.prototype.getChainCode_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getChainCode());
};
/**
 * required bytes chain_code = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChainCode()`
 * @return {!Uint8Array}
 */ proto.HDNodeType.prototype.getChainCode_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getChainCode());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setChainCode = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearChainCode = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasChainCode = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bytes private_key = 5;
 * @return {!(string|Uint8Array)}
 */ proto.HDNodeType.prototype.getPrivateKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes private_key = 5;
 * This is a type-conversion wrapper around `getPrivateKey()`
 * @return {string}
 */ proto.HDNodeType.prototype.getPrivateKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPrivateKey());
};
/**
 * optional bytes private_key = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPrivateKey()`
 * @return {!Uint8Array}
 */ proto.HDNodeType.prototype.getPrivateKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPrivateKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setPrivateKey = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearPrivateKey = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasPrivateKey = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bytes public_key = 6;
 * @return {!(string|Uint8Array)}
 */ proto.HDNodeType.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes public_key = 6;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.HDNodeType.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.HDNodeType.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodeType} returns this
 */ proto.HDNodeType.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodeType.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.HDNodePathType.repeatedFields_ = [
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.HDNodePathType.prototype.toObject = function(opt_includeInstance) {
        return proto.HDNodePathType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.HDNodePathType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.HDNodePathType.toObject = function(includeInstance, msg) {
        var f, obj = {
            node: (f = msg.getNode()) && proto.HDNodeType.toObject(includeInstance, f),
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.HDNodePathType}
 */ proto.HDNodePathType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.HDNodePathType;
    return proto.HDNodePathType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.HDNodePathType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.HDNodePathType}
 */ proto.HDNodePathType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.HDNodeType;
                reader.readMessage(value, proto.HDNodeType.deserializeBinaryFromReader);
                msg.setNode(value);
                break;
            case 2:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.HDNodePathType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.HDNodePathType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.HDNodePathType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.HDNodePathType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNode();
    if (f != null) writer.writeMessage(1, f, proto.HDNodeType.serializeBinaryToWriter);
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(2, f);
};
/**
 * required HDNodeType node = 1;
 * @return {!proto.HDNodeType}
 */ proto.HDNodePathType.prototype.getNode = function() {
    return /** @type{!proto.HDNodeType} */ $2MzPv.Message.getWrapperField(this, proto.HDNodeType, 1, 1);
};
/**
 * @param {!proto.HDNodeType} value
 * @return {!proto.HDNodePathType} returns this
*/ proto.HDNodePathType.prototype.setNode = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.HDNodePathType} returns this
 */ proto.HDNodePathType.prototype.clearNode = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.HDNodePathType.prototype.hasNode = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated uint32 address_n = 2;
 * @return {!Array<number>}
 */ proto.HDNodePathType.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.HDNodePathType} returns this
 */ proto.HDNodePathType.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 2, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.HDNodePathType} returns this
 */ proto.HDNodePathType.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.HDNodePathType} returns this
 */ proto.HDNodePathType.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CoinType.prototype.toObject = function(opt_includeInstance) {
        return proto.CoinType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CoinType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CoinType.toObject = function(includeInstance, msg) {
        var f, obj = {
            coinName: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            coinShortcut: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            addressType: $2MzPv.Message.getFieldWithDefault(msg, 3, 0),
            maxfeeKb: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            addressTypeP2sh: $2MzPv.Message.getFieldWithDefault(msg, 5, 5),
            signedMessageHeader: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            bip44AccountPath: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            forkid: (f = $2MzPv.Message.getField(msg, 12)) == null ? undefined : f,
            decimals: (f = $2MzPv.Message.getField(msg, 13)) == null ? undefined : f,
            contractAddress: msg.getContractAddress_asB64(),
            xpubMagic: $2MzPv.Message.getFieldWithDefault(msg, 16, 76067358),
            segwit: (f = $2MzPv.Message.getBooleanField(msg, 18)) == null ? undefined : f,
            forceBip143: (f = $2MzPv.Message.getBooleanField(msg, 19)) == null ? undefined : f,
            curveName: (f = $2MzPv.Message.getField(msg, 20)) == null ? undefined : f,
            cashaddrPrefix: (f = $2MzPv.Message.getField(msg, 21)) == null ? undefined : f,
            bech32Prefix: (f = $2MzPv.Message.getField(msg, 22)) == null ? undefined : f,
            decred: (f = $2MzPv.Message.getBooleanField(msg, 23)) == null ? undefined : f,
            xpubMagicSegwitP2sh: (f = $2MzPv.Message.getField(msg, 25)) == null ? undefined : f,
            xpubMagicSegwitNative: (f = $2MzPv.Message.getField(msg, 26)) == null ? undefined : f,
            nanoaddrPrefix: (f = $2MzPv.Message.getField(msg, 27)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CoinType}
 */ proto.CoinType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CoinType;
    return proto.CoinType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CoinType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CoinType}
 */ proto.CoinType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinShortcut(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAddressType(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint64();
                msg.setMaxfeeKb(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAddressTypeP2sh(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setSignedMessageHeader(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBip44AccountPath(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readUint32();
                msg.setForkid(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDecimals(value);
                break;
            case 14:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setContractAddress(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readUint32();
                msg.setXpubMagic(value);
                break;
            case 18:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSegwit(value);
                break;
            case 19:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setForceBip143(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setCurveName(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setCashaddrPrefix(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setBech32Prefix(value);
                break;
            case 23:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDecred(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readUint32();
                msg.setXpubMagicSegwitP2sh(value);
                break;
            case 26:
                var value = /** @type {number} */ reader.readUint32();
                msg.setXpubMagicSegwitNative(value);
                break;
            case 27:
                var value = /** @type {string} */ reader.readString();
                msg.setNanoaddrPrefix(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CoinType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CoinType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CoinType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CoinType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint64(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeString(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeUint32(12, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 13);
    if (f != null) writer.writeUint32(13, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 14);
    if (f != null) writer.writeBytes(14, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 16);
    if (f != null) writer.writeUint32(16, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 18);
    if (f != null) writer.writeBool(18, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 19);
    if (f != null) writer.writeBool(19, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 20);
    if (f != null) writer.writeString(20, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 21);
    if (f != null) writer.writeString(21, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 22);
    if (f != null) writer.writeString(22, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 23);
    if (f != null) writer.writeBool(23, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 25);
    if (f != null) writer.writeUint32(25, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 26);
    if (f != null) writer.writeUint32(26, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 27);
    if (f != null) writer.writeString(27, f);
};
/**
 * optional string coin_name = 1;
 * @return {string}
 */ proto.CoinType.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string coin_shortcut = 2;
 * @return {string}
 */ proto.CoinType.prototype.getCoinShortcut = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setCoinShortcut = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearCoinShortcut = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasCoinShortcut = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 address_type = 3;
 * @return {number}
 */ proto.CoinType.prototype.getAddressType = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint64 maxfee_kb = 4;
 * @return {number}
 */ proto.CoinType.prototype.getMaxfeeKb = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setMaxfeeKb = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearMaxfeeKb = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasMaxfeeKb = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 address_type_p2sh = 5;
 * @return {number}
 */ proto.CoinType.prototype.getAddressTypeP2sh = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 5);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setAddressTypeP2sh = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearAddressTypeP2sh = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasAddressTypeP2sh = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string signed_message_header = 8;
 * @return {string}
 */ proto.CoinType.prototype.getSignedMessageHeader = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setSignedMessageHeader = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearSignedMessageHeader = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasSignedMessageHeader = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 bip44_account_path = 9;
 * @return {number}
 */ proto.CoinType.prototype.getBip44AccountPath = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setBip44AccountPath = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearBip44AccountPath = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasBip44AccountPath = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional uint32 forkid = 12;
 * @return {number}
 */ proto.CoinType.prototype.getForkid = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setForkid = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearForkid = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasForkid = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional uint32 decimals = 13;
 * @return {number}
 */ proto.CoinType.prototype.getDecimals = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setDecimals = function(value) {
    return $2MzPv.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearDecimals = function() {
    return $2MzPv.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasDecimals = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
/**
 * optional bytes contract_address = 14;
 * @return {!(string|Uint8Array)}
 */ proto.CoinType.prototype.getContractAddress = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 14, "");
};
/**
 * optional bytes contract_address = 14;
 * This is a type-conversion wrapper around `getContractAddress()`
 * @return {string}
 */ proto.CoinType.prototype.getContractAddress_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getContractAddress());
};
/**
 * optional bytes contract_address = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getContractAddress()`
 * @return {!Uint8Array}
 */ proto.CoinType.prototype.getContractAddress_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getContractAddress());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setContractAddress = function(value) {
    return $2MzPv.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearContractAddress = function() {
    return $2MzPv.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasContractAddress = function() {
    return $2MzPv.Message.getField(this, 14) != null;
};
/**
 * optional uint32 xpub_magic = 16;
 * @return {number}
 */ proto.CoinType.prototype.getXpubMagic = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 16, 76067358);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setXpubMagic = function(value) {
    return $2MzPv.Message.setField(this, 16, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearXpubMagic = function() {
    return $2MzPv.Message.setField(this, 16, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasXpubMagic = function() {
    return $2MzPv.Message.getField(this, 16) != null;
};
/**
 * optional bool segwit = 18;
 * @return {boolean}
 */ proto.CoinType.prototype.getSegwit = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 18, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setSegwit = function(value) {
    return $2MzPv.Message.setField(this, 18, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearSegwit = function() {
    return $2MzPv.Message.setField(this, 18, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasSegwit = function() {
    return $2MzPv.Message.getField(this, 18) != null;
};
/**
 * optional bool force_bip143 = 19;
 * @return {boolean}
 */ proto.CoinType.prototype.getForceBip143 = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 19, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setForceBip143 = function(value) {
    return $2MzPv.Message.setField(this, 19, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearForceBip143 = function() {
    return $2MzPv.Message.setField(this, 19, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasForceBip143 = function() {
    return $2MzPv.Message.getField(this, 19) != null;
};
/**
 * optional string curve_name = 20;
 * @return {string}
 */ proto.CoinType.prototype.getCurveName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setCurveName = function(value) {
    return $2MzPv.Message.setField(this, 20, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearCurveName = function() {
    return $2MzPv.Message.setField(this, 20, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasCurveName = function() {
    return $2MzPv.Message.getField(this, 20) != null;
};
/**
 * optional string cashaddr_prefix = 21;
 * @return {string}
 */ proto.CoinType.prototype.getCashaddrPrefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setCashaddrPrefix = function(value) {
    return $2MzPv.Message.setField(this, 21, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearCashaddrPrefix = function() {
    return $2MzPv.Message.setField(this, 21, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasCashaddrPrefix = function() {
    return $2MzPv.Message.getField(this, 21) != null;
};
/**
 * optional string bech32_prefix = 22;
 * @return {string}
 */ proto.CoinType.prototype.getBech32Prefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setBech32Prefix = function(value) {
    return $2MzPv.Message.setField(this, 22, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearBech32Prefix = function() {
    return $2MzPv.Message.setField(this, 22, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasBech32Prefix = function() {
    return $2MzPv.Message.getField(this, 22) != null;
};
/**
 * optional bool decred = 23;
 * @return {boolean}
 */ proto.CoinType.prototype.getDecred = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 23, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setDecred = function(value) {
    return $2MzPv.Message.setField(this, 23, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearDecred = function() {
    return $2MzPv.Message.setField(this, 23, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasDecred = function() {
    return $2MzPv.Message.getField(this, 23) != null;
};
/**
 * optional uint32 xpub_magic_segwit_p2sh = 25;
 * @return {number}
 */ proto.CoinType.prototype.getXpubMagicSegwitP2sh = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 25, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setXpubMagicSegwitP2sh = function(value) {
    return $2MzPv.Message.setField(this, 25, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearXpubMagicSegwitP2sh = function() {
    return $2MzPv.Message.setField(this, 25, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasXpubMagicSegwitP2sh = function() {
    return $2MzPv.Message.getField(this, 25) != null;
};
/**
 * optional uint32 xpub_magic_segwit_native = 26;
 * @return {number}
 */ proto.CoinType.prototype.getXpubMagicSegwitNative = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 26, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setXpubMagicSegwitNative = function(value) {
    return $2MzPv.Message.setField(this, 26, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearXpubMagicSegwitNative = function() {
    return $2MzPv.Message.setField(this, 26, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasXpubMagicSegwitNative = function() {
    return $2MzPv.Message.getField(this, 26) != null;
};
/**
 * optional string nanoaddr_prefix = 27;
 * @return {string}
 */ proto.CoinType.prototype.getNanoaddrPrefix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 27, "");
};
/**
 * @param {string} value
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.setNanoaddrPrefix = function(value) {
    return $2MzPv.Message.setField(this, 27, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinType} returns this
 */ proto.CoinType.prototype.clearNanoaddrPrefix = function() {
    return $2MzPv.Message.setField(this, 27, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinType.prototype.hasNanoaddrPrefix = function() {
    return $2MzPv.Message.getField(this, 27) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.MultisigRedeemScriptType.repeatedFields_ = [
    1,
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MultisigRedeemScriptType.prototype.toObject = function(opt_includeInstance) {
        return proto.MultisigRedeemScriptType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MultisigRedeemScriptType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MultisigRedeemScriptType.toObject = function(includeInstance, msg) {
        var f, obj = {
            pubkeysList: $2MzPv.Message.toObjectList(msg.getPubkeysList(), proto.HDNodePathType.toObject, includeInstance),
            signaturesList: msg.getSignaturesList_asB64(),
            m: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MultisigRedeemScriptType}
 */ proto.MultisigRedeemScriptType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MultisigRedeemScriptType;
    return proto.MultisigRedeemScriptType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MultisigRedeemScriptType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MultisigRedeemScriptType}
 */ proto.MultisigRedeemScriptType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.HDNodePathType;
                reader.readMessage(value, proto.HDNodePathType.deserializeBinaryFromReader);
                msg.addPubkeys(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.addSignatures(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setM(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MultisigRedeemScriptType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MultisigRedeemScriptType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MultisigRedeemScriptType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MultisigRedeemScriptType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPubkeysList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.HDNodePathType.serializeBinaryToWriter);
    f = message.getSignaturesList_asU8();
    if (f.length > 0) writer.writeRepeatedBytes(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
};
/**
 * repeated HDNodePathType pubkeys = 1;
 * @return {!Array<!proto.HDNodePathType>}
 */ proto.MultisigRedeemScriptType.prototype.getPubkeysList = function() {
    return /** @type{!Array<!proto.HDNodePathType>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.HDNodePathType, 1);
};
/**
 * @param {!Array<!proto.HDNodePathType>} value
 * @return {!proto.MultisigRedeemScriptType} returns this
*/ proto.MultisigRedeemScriptType.prototype.setPubkeysList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.HDNodePathType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.HDNodePathType}
 */ proto.MultisigRedeemScriptType.prototype.addPubkeys = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.HDNodePathType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.clearPubkeysList = function() {
    return this.setPubkeysList([]);
};
/**
 * repeated bytes signatures = 2;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */ proto.MultisigRedeemScriptType.prototype.getSignaturesList = function() {
    return /** @type {!(Array<!Uint8Array>|Array<string>)} */ $2MzPv.Message.getRepeatedField(this, 2);
};
/**
 * repeated bytes signatures = 2;
 * This is a type-conversion wrapper around `getSignaturesList()`
 * @return {!Array<string>}
 */ proto.MultisigRedeemScriptType.prototype.getSignaturesList_asB64 = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.bytesListAsB64(this.getSignaturesList());
};
/**
 * repeated bytes signatures = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignaturesList()`
 * @return {!Array<!Uint8Array>}
 */ proto.MultisigRedeemScriptType.prototype.getSignaturesList_asU8 = function() {
    return /** @type {!Array<!Uint8Array>} */ $2MzPv.Message.bytesListAsU8(this.getSignaturesList());
};
/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.setSignaturesList = function(value) {
    return $2MzPv.Message.setField(this, 2, value || []);
};
/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.addSignatures = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.clearSignaturesList = function() {
    return this.setSignaturesList([]);
};
/**
 * optional uint32 m = 3;
 * @return {number}
 */ proto.MultisigRedeemScriptType.prototype.getM = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.setM = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MultisigRedeemScriptType} returns this
 */ proto.MultisigRedeemScriptType.prototype.clearM = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MultisigRedeemScriptType.prototype.hasM = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.TxInputType.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxInputType.prototype.toObject = function(opt_includeInstance) {
        return proto.TxInputType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxInputType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxInputType.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            prevHash: msg.getPrevHash_asB64(),
            prevIndex: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            scriptSig: msg.getScriptSig_asB64(),
            sequence: $2MzPv.Message.getFieldWithDefault(msg, 5, -1),
            scriptType: $2MzPv.Message.getFieldWithDefault(msg, 6, 0),
            multisig: (f = msg.getMultisig()) && proto.MultisigRedeemScriptType.toObject(includeInstance, f),
            amount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            decredTree: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            decredScriptVersion: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxInputType}
 */ proto.TxInputType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxInputType;
    return proto.TxInputType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxInputType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxInputType}
 */ proto.TxInputType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPrevHash(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPrevIndex(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setScriptSig(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSequence(value);
                break;
            case 6:
                var value = /** @type {!proto.InputScriptType} */ reader.readEnum();
                msg.setScriptType(value);
                break;
            case 7:
                var value = new proto.MultisigRedeemScriptType;
                reader.readMessage(value, proto.MultisigRedeemScriptType.deserializeBinaryFromReader);
                msg.setMultisig(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDecredTree(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDecredScriptVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxInputType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxInputType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxInputType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxInputType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {!proto.InputScriptType} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeEnum(6, f);
    f = message.getMultisig();
    if (f != null) writer.writeMessage(7, f, proto.MultisigRedeemScriptType.serializeBinaryToWriter);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint64(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeUint32(10, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.TxInputType.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required bytes prev_hash = 2;
 * @return {!(string|Uint8Array)}
 */ proto.TxInputType.prototype.getPrevHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes prev_hash = 2;
 * This is a type-conversion wrapper around `getPrevHash()`
 * @return {string}
 */ proto.TxInputType.prototype.getPrevHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPrevHash());
};
/**
 * required bytes prev_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPrevHash()`
 * @return {!Uint8Array}
 */ proto.TxInputType.prototype.getPrevHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPrevHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setPrevHash = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearPrevHash = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasPrevHash = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * required uint32 prev_index = 3;
 * @return {number}
 */ proto.TxInputType.prototype.getPrevIndex = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setPrevIndex = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearPrevIndex = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasPrevIndex = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes script_sig = 4;
 * @return {!(string|Uint8Array)}
 */ proto.TxInputType.prototype.getScriptSig = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes script_sig = 4;
 * This is a type-conversion wrapper around `getScriptSig()`
 * @return {string}
 */ proto.TxInputType.prototype.getScriptSig_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getScriptSig());
};
/**
 * optional bytes script_sig = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getScriptSig()`
 * @return {!Uint8Array}
 */ proto.TxInputType.prototype.getScriptSig_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getScriptSig());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setScriptSig = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearScriptSig = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasScriptSig = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 sequence = 5;
 * @return {number}
 */ proto.TxInputType.prototype.getSequence = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, -1);
};
/**
 * @param {number} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional InputScriptType script_type = 6;
 * @return {!proto.InputScriptType}
 */ proto.TxInputType.prototype.getScriptType = function() {
    return /** @type {!proto.InputScriptType} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.InputScriptType} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setScriptType = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearScriptType = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasScriptType = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional MultisigRedeemScriptType multisig = 7;
 * @return {?proto.MultisigRedeemScriptType}
 */ proto.TxInputType.prototype.getMultisig = function() {
    return /** @type{?proto.MultisigRedeemScriptType} */ $2MzPv.Message.getWrapperField(this, proto.MultisigRedeemScriptType, 7);
};
/**
 * @param {?proto.MultisigRedeemScriptType|undefined} value
 * @return {!proto.TxInputType} returns this
*/ proto.TxInputType.prototype.setMultisig = function(value) {
    return $2MzPv.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearMultisig = function() {
    return this.setMultisig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasMultisig = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint64 amount = 8;
 * @return {number}
 */ proto.TxInputType.prototype.getAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 decred_tree = 9;
 * @return {number}
 */ proto.TxInputType.prototype.getDecredTree = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setDecredTree = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearDecredTree = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasDecredTree = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional uint32 decred_script_version = 10;
 * @return {number}
 */ proto.TxInputType.prototype.getDecredScriptVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.setDecredScriptVersion = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxInputType} returns this
 */ proto.TxInputType.prototype.clearDecredScriptVersion = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxInputType.prototype.hasDecredScriptVersion = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.TxOutputType.repeatedFields_ = [
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxOutputType.prototype.toObject = function(opt_includeInstance) {
        return proto.TxOutputType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxOutputType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxOutputType.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            scriptType: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            multisig: (f = msg.getMultisig()) && proto.MultisigRedeemScriptType.toObject(includeInstance, f),
            opReturnData: msg.getOpReturnData_asB64(),
            addressType: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            decredScriptVersion: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxOutputType}
 */ proto.TxOutputType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxOutputType;
    return proto.TxOutputType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxOutputType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxOutputType}
 */ proto.TxOutputType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 2:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {!proto.OutputScriptType} */ reader.readEnum();
                msg.setScriptType(value);
                break;
            case 5:
                var value = new proto.MultisigRedeemScriptType;
                reader.readMessage(value, proto.MultisigRedeemScriptType.deserializeBinaryFromReader);
                msg.setMultisig(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setOpReturnData(value);
                break;
            case 7:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDecredScriptVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxOutputType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxOutputType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxOutputType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxOutputType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64(3, f);
    f = /** @type {!proto.OutputScriptType} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeEnum(4, f);
    f = message.getMultisig();
    if (f != null) writer.writeMessage(5, f, proto.MultisigRedeemScriptType.serializeBinaryToWriter);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBytes(6, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeEnum(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.TxOutputType.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated uint32 address_n = 2;
 * @return {!Array<number>}
 */ proto.TxOutputType.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 2, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required uint64 amount = 3;
 * @return {number}
 */ proto.TxOutputType.prototype.getAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * required OutputScriptType script_type = 4;
 * @return {!proto.OutputScriptType}
 */ proto.TxOutputType.prototype.getScriptType = function() {
    return /** @type {!proto.OutputScriptType} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.OutputScriptType} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setScriptType = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearScriptType = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasScriptType = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional MultisigRedeemScriptType multisig = 5;
 * @return {?proto.MultisigRedeemScriptType}
 */ proto.TxOutputType.prototype.getMultisig = function() {
    return /** @type{?proto.MultisigRedeemScriptType} */ $2MzPv.Message.getWrapperField(this, proto.MultisigRedeemScriptType, 5);
};
/**
 * @param {?proto.MultisigRedeemScriptType|undefined} value
 * @return {!proto.TxOutputType} returns this
*/ proto.TxOutputType.prototype.setMultisig = function(value) {
    return $2MzPv.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearMultisig = function() {
    return this.setMultisig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasMultisig = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bytes op_return_data = 6;
 * @return {!(string|Uint8Array)}
 */ proto.TxOutputType.prototype.getOpReturnData = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes op_return_data = 6;
 * This is a type-conversion wrapper around `getOpReturnData()`
 * @return {string}
 */ proto.TxOutputType.prototype.getOpReturnData_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getOpReturnData());
};
/**
 * optional bytes op_return_data = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOpReturnData()`
 * @return {!Uint8Array}
 */ proto.TxOutputType.prototype.getOpReturnData_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getOpReturnData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setOpReturnData = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearOpReturnData = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasOpReturnData = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional OutputAddressType address_type = 7;
 * @return {!proto.OutputAddressType}
 */ proto.TxOutputType.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 decred_script_version = 9;
 * @return {number}
 */ proto.TxOutputType.prototype.getDecredScriptVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.setDecredScriptVersion = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputType} returns this
 */ proto.TxOutputType.prototype.clearDecredScriptVersion = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputType.prototype.hasDecredScriptVersion = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxOutputBinType.prototype.toObject = function(opt_includeInstance) {
        return proto.TxOutputBinType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxOutputBinType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxOutputBinType.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            scriptPubkey: msg.getScriptPubkey_asB64(),
            decredScriptVersion: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxOutputBinType}
 */ proto.TxOutputBinType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxOutputBinType;
    return proto.TxOutputBinType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxOutputBinType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxOutputBinType}
 */ proto.TxOutputBinType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setScriptPubkey(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDecredScriptVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxOutputBinType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxOutputBinType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxOutputBinType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxOutputBinType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
};
/**
 * required uint64 amount = 1;
 * @return {number}
 */ proto.TxOutputBinType.prototype.getAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputBinType.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required bytes script_pubkey = 2;
 * @return {!(string|Uint8Array)}
 */ proto.TxOutputBinType.prototype.getScriptPubkey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes script_pubkey = 2;
 * This is a type-conversion wrapper around `getScriptPubkey()`
 * @return {string}
 */ proto.TxOutputBinType.prototype.getScriptPubkey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getScriptPubkey());
};
/**
 * required bytes script_pubkey = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getScriptPubkey()`
 * @return {!Uint8Array}
 */ proto.TxOutputBinType.prototype.getScriptPubkey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getScriptPubkey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.setScriptPubkey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.clearScriptPubkey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputBinType.prototype.hasScriptPubkey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 decred_script_version = 3;
 * @return {number}
 */ proto.TxOutputBinType.prototype.getDecredScriptVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.setDecredScriptVersion = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxOutputBinType} returns this
 */ proto.TxOutputBinType.prototype.clearDecredScriptVersion = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxOutputBinType.prototype.hasDecredScriptVersion = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.TransactionType.repeatedFields_ = [
    2,
    3,
    5
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TransactionType.prototype.toObject = function(opt_includeInstance) {
        return proto.TransactionType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TransactionType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TransactionType.toObject = function(includeInstance, msg) {
        var f, obj = {
            version: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            inputsList: $2MzPv.Message.toObjectList(msg.getInputsList(), proto.TxInputType.toObject, includeInstance),
            binOutputsList: $2MzPv.Message.toObjectList(msg.getBinOutputsList(), proto.TxOutputBinType.toObject, includeInstance),
            outputsList: $2MzPv.Message.toObjectList(msg.getOutputsList(), proto.TxOutputType.toObject, includeInstance),
            lockTime: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            inputsCnt: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            outputsCnt: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            extraData: msg.getExtraData_asB64(),
            extraDataLen: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            expiry: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f,
            overwintered: (f = $2MzPv.Message.getBooleanField(msg, 11)) == null ? undefined : f,
            versionGroupId: (f = $2MzPv.Message.getField(msg, 12)) == null ? undefined : f,
            branchId: (f = $2MzPv.Message.getField(msg, 13)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TransactionType}
 */ proto.TransactionType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TransactionType;
    return proto.TransactionType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TransactionType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TransactionType}
 */ proto.TransactionType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersion(value);
                break;
            case 2:
                var value = new proto.TxInputType;
                reader.readMessage(value, proto.TxInputType.deserializeBinaryFromReader);
                msg.addInputs(value);
                break;
            case 3:
                var value = new proto.TxOutputBinType;
                reader.readMessage(value, proto.TxOutputBinType.deserializeBinaryFromReader);
                msg.addBinOutputs(value);
                break;
            case 5:
                var value = new proto.TxOutputType;
                reader.readMessage(value, proto.TxOutputType.deserializeBinaryFromReader);
                msg.addOutputs(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLockTime(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInputsCnt(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setOutputsCnt(value);
                break;
            case 8:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setExtraData(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExtraDataLen(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExpiry(value);
                break;
            case 11:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOverwintered(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersionGroupId(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBranchId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TransactionType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TransactionType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TransactionType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TransactionType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = message.getInputsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.TxInputType.serializeBinaryToWriter);
    f = message.getBinOutputsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.TxOutputBinType.serializeBinaryToWriter);
    f = message.getOutputsList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.TxOutputType.serializeBinaryToWriter);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeUint32(6, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeUint32(7, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeBytes(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeUint32(10, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 11);
    if (f != null) writer.writeBool(11, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeUint32(12, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 13);
    if (f != null) writer.writeUint32(13, f);
};
/**
 * optional uint32 version = 1;
 * @return {number}
 */ proto.TransactionType.prototype.getVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setVersion = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearVersion = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasVersion = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated TxInputType inputs = 2;
 * @return {!Array<!proto.TxInputType>}
 */ proto.TransactionType.prototype.getInputsList = function() {
    return /** @type{!Array<!proto.TxInputType>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.TxInputType, 2);
};
/**
 * @param {!Array<!proto.TxInputType>} value
 * @return {!proto.TransactionType} returns this
*/ proto.TransactionType.prototype.setInputsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.TxInputType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TxInputType}
 */ proto.TransactionType.prototype.addInputs = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.TxInputType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearInputsList = function() {
    return this.setInputsList([]);
};
/**
 * repeated TxOutputBinType bin_outputs = 3;
 * @return {!Array<!proto.TxOutputBinType>}
 */ proto.TransactionType.prototype.getBinOutputsList = function() {
    return /** @type{!Array<!proto.TxOutputBinType>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.TxOutputBinType, 3);
};
/**
 * @param {!Array<!proto.TxOutputBinType>} value
 * @return {!proto.TransactionType} returns this
*/ proto.TransactionType.prototype.setBinOutputsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.TxOutputBinType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TxOutputBinType}
 */ proto.TransactionType.prototype.addBinOutputs = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.TxOutputBinType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearBinOutputsList = function() {
    return this.setBinOutputsList([]);
};
/**
 * repeated TxOutputType outputs = 5;
 * @return {!Array<!proto.TxOutputType>}
 */ proto.TransactionType.prototype.getOutputsList = function() {
    return /** @type{!Array<!proto.TxOutputType>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.TxOutputType, 5);
};
/**
 * @param {!Array<!proto.TxOutputType>} value
 * @return {!proto.TransactionType} returns this
*/ proto.TransactionType.prototype.setOutputsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.TxOutputType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.TxOutputType}
 */ proto.TransactionType.prototype.addOutputs = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.TxOutputType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearOutputsList = function() {
    return this.setOutputsList([]);
};
/**
 * optional uint32 lock_time = 4;
 * @return {number}
 */ proto.TransactionType.prototype.getLockTime = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setLockTime = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearLockTime = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasLockTime = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 inputs_cnt = 6;
 * @return {number}
 */ proto.TransactionType.prototype.getInputsCnt = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setInputsCnt = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearInputsCnt = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasInputsCnt = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional uint32 outputs_cnt = 7;
 * @return {number}
 */ proto.TransactionType.prototype.getOutputsCnt = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setOutputsCnt = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearOutputsCnt = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasOutputsCnt = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional bytes extra_data = 8;
 * @return {!(string|Uint8Array)}
 */ proto.TransactionType.prototype.getExtraData = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * optional bytes extra_data = 8;
 * This is a type-conversion wrapper around `getExtraData()`
 * @return {string}
 */ proto.TransactionType.prototype.getExtraData_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getExtraData());
};
/**
 * optional bytes extra_data = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getExtraData()`
 * @return {!Uint8Array}
 */ proto.TransactionType.prototype.getExtraData_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getExtraData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setExtraData = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearExtraData = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasExtraData = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 extra_data_len = 9;
 * @return {number}
 */ proto.TransactionType.prototype.getExtraDataLen = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setExtraDataLen = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearExtraDataLen = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasExtraDataLen = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional uint32 expiry = 10;
 * @return {number}
 */ proto.TransactionType.prototype.getExpiry = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setExpiry = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearExpiry = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasExpiry = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional bool overwintered = 11;
 * @return {boolean}
 */ proto.TransactionType.prototype.getOverwintered = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 11, false);
};
/**
 * @param {boolean} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setOverwintered = function(value) {
    return $2MzPv.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearOverwintered = function() {
    return $2MzPv.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasOverwintered = function() {
    return $2MzPv.Message.getField(this, 11) != null;
};
/**
 * optional uint32 version_group_id = 12;
 * @return {number}
 */ proto.TransactionType.prototype.getVersionGroupId = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setVersionGroupId = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearVersionGroupId = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasVersionGroupId = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional uint32 branch_id = 13;
 * @return {number}
 */ proto.TransactionType.prototype.getBranchId = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.setBranchId = function(value) {
    return $2MzPv.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TransactionType} returns this
 */ proto.TransactionType.prototype.clearBranchId = function() {
    return $2MzPv.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TransactionType.prototype.hasBranchId = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RawTransactionType.prototype.toObject = function(opt_includeInstance) {
        return proto.RawTransactionType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RawTransactionType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RawTransactionType.toObject = function(includeInstance, msg) {
        var f, obj = {
            payload: msg.getPayload_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RawTransactionType}
 */ proto.RawTransactionType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RawTransactionType;
    return proto.RawTransactionType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RawTransactionType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RawTransactionType}
 */ proto.RawTransactionType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPayload(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RawTransactionType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RawTransactionType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RawTransactionType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RawTransactionType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * required bytes payload = 1;
 * @return {!(string|Uint8Array)}
 */ proto.RawTransactionType.prototype.getPayload = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * required bytes payload = 1;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */ proto.RawTransactionType.prototype.getPayload_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPayload());
};
/**
 * required bytes payload = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */ proto.RawTransactionType.prototype.getPayload_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPayload());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.RawTransactionType} returns this
 */ proto.RawTransactionType.prototype.setPayload = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RawTransactionType} returns this
 */ proto.RawTransactionType.prototype.clearPayload = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RawTransactionType.prototype.hasPayload = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxRequestDetailsType.prototype.toObject = function(opt_includeInstance) {
        return proto.TxRequestDetailsType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxRequestDetailsType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequestDetailsType.toObject = function(includeInstance, msg) {
        var f, obj = {
            requestIndex: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            txHash: msg.getTxHash_asB64(),
            extraDataLen: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            extraDataOffset: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxRequestDetailsType}
 */ proto.TxRequestDetailsType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxRequestDetailsType;
    return proto.TxRequestDetailsType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxRequestDetailsType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxRequestDetailsType}
 */ proto.TxRequestDetailsType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRequestIndex(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setTxHash(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExtraDataLen(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExtraDataOffset(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxRequestDetailsType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxRequestDetailsType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxRequestDetailsType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequestDetailsType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
};
/**
 * optional uint32 request_index = 1;
 * @return {number}
 */ proto.TxRequestDetailsType.prototype.getRequestIndex = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.setRequestIndex = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.clearRequestIndex = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestDetailsType.prototype.hasRequestIndex = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes tx_hash = 2;
 * @return {!(string|Uint8Array)}
 */ proto.TxRequestDetailsType.prototype.getTxHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes tx_hash = 2;
 * This is a type-conversion wrapper around `getTxHash()`
 * @return {string}
 */ proto.TxRequestDetailsType.prototype.getTxHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getTxHash());
};
/**
 * optional bytes tx_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTxHash()`
 * @return {!Uint8Array}
 */ proto.TxRequestDetailsType.prototype.getTxHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getTxHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.setTxHash = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.clearTxHash = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestDetailsType.prototype.hasTxHash = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 extra_data_len = 3;
 * @return {number}
 */ proto.TxRequestDetailsType.prototype.getExtraDataLen = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.setExtraDataLen = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.clearExtraDataLen = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestDetailsType.prototype.hasExtraDataLen = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 extra_data_offset = 4;
 * @return {number}
 */ proto.TxRequestDetailsType.prototype.getExtraDataOffset = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.setExtraDataOffset = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestDetailsType} returns this
 */ proto.TxRequestDetailsType.prototype.clearExtraDataOffset = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestDetailsType.prototype.hasExtraDataOffset = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxRequestSerializedType.prototype.toObject = function(opt_includeInstance) {
        return proto.TxRequestSerializedType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxRequestSerializedType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequestSerializedType.toObject = function(includeInstance, msg) {
        var f, obj = {
            signatureIndex: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            signature: msg.getSignature_asB64(),
            serializedTx: msg.getSerializedTx_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxRequestSerializedType}
 */ proto.TxRequestSerializedType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxRequestSerializedType;
    return proto.TxRequestSerializedType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxRequestSerializedType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxRequestSerializedType}
 */ proto.TxRequestSerializedType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSignatureIndex(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSerializedTx(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxRequestSerializedType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxRequestSerializedType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxRequestSerializedType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequestSerializedType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * optional uint32 signature_index = 1;
 * @return {number}
 */ proto.TxRequestSerializedType.prototype.getSignatureIndex = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.setSignatureIndex = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.clearSignatureIndex = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestSerializedType.prototype.hasSignatureIndex = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.TxRequestSerializedType.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.TxRequestSerializedType.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.TxRequestSerializedType.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestSerializedType.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes serialized_tx = 3;
 * @return {!(string|Uint8Array)}
 */ proto.TxRequestSerializedType.prototype.getSerializedTx = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes serialized_tx = 3;
 * This is a type-conversion wrapper around `getSerializedTx()`
 * @return {string}
 */ proto.TxRequestSerializedType.prototype.getSerializedTx_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSerializedTx());
};
/**
 * optional bytes serialized_tx = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSerializedTx()`
 * @return {!Uint8Array}
 */ proto.TxRequestSerializedType.prototype.getSerializedTx_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSerializedTx());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.setSerializedTx = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequestSerializedType} returns this
 */ proto.TxRequestSerializedType.prototype.clearSerializedTx = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequestSerializedType.prototype.hasSerializedTx = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.IdentityType.prototype.toObject = function(opt_includeInstance) {
        return proto.IdentityType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.IdentityType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IdentityType.toObject = function(includeInstance, msg) {
        var f, obj = {
            proto: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            user: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            host: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            port: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            path: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            index: $2MzPv.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.IdentityType}
 */ proto.IdentityType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.IdentityType;
    return proto.IdentityType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.IdentityType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.IdentityType}
 */ proto.IdentityType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProto(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUser(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setHost(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPort(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPath(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setIndex(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.IdentityType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.IdentityType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.IdentityType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.IdentityType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeUint32(6, f);
};
/**
 * optional string proto = 1;
 * @return {string}
 */ proto.IdentityType.prototype.getProto = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setProto = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearProto = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasProto = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string user = 2;
 * @return {string}
 */ proto.IdentityType.prototype.getUser = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setUser = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearUser = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasUser = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string host = 3;
 * @return {string}
 */ proto.IdentityType.prototype.getHost = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setHost = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearHost = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasHost = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string port = 4;
 * @return {string}
 */ proto.IdentityType.prototype.getPort = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setPort = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearPort = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasPort = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string path = 5;
 * @return {string}
 */ proto.IdentityType.prototype.getPath = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setPath = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearPath = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasPath = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional uint32 index = 6;
 * @return {number}
 */ proto.IdentityType.prototype.getIndex = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.setIndex = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.IdentityType} returns this
 */ proto.IdentityType.prototype.clearIndex = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.IdentityType.prototype.hasIndex = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PolicyType.prototype.toObject = function(opt_includeInstance) {
        return proto.PolicyType.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PolicyType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PolicyType.toObject = function(includeInstance, msg) {
        var f, obj = {
            policyName: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            enabled: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PolicyType}
 */ proto.PolicyType.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PolicyType;
    return proto.PolicyType.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PolicyType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PolicyType}
 */ proto.PolicyType.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyName(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setEnabled(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PolicyType.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PolicyType.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PolicyType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PolicyType.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * optional string policy_name = 1;
 * @return {string}
 */ proto.PolicyType.prototype.getPolicyName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.PolicyType} returns this
 */ proto.PolicyType.prototype.setPolicyName = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PolicyType} returns this
 */ proto.PolicyType.prototype.clearPolicyName = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PolicyType.prototype.hasPolicyName = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool enabled = 2;
 * @return {boolean}
 */ proto.PolicyType.prototype.getEnabled = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.PolicyType} returns this
 */ proto.PolicyType.prototype.setEnabled = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PolicyType} returns this
 */ proto.PolicyType.prototype.clearEnabled = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PolicyType.prototype.hasEnabled = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * @enum {number}
 */ proto.FailureType = {
    FAILURE_UNEXPECTEDMESSAGE: 1,
    FAILURE_BUTTONEXPECTED: 2,
    FAILURE_SYNTAXERROR: 3,
    FAILURE_ACTIONCANCELLED: 4,
    FAILURE_PINEXPECTED: 5,
    FAILURE_PINCANCELLED: 6,
    FAILURE_PININVALID: 7,
    FAILURE_INVALIDSIGNATURE: 8,
    FAILURE_OTHER: 9,
    FAILURE_NOTENOUGHFUNDS: 10,
    FAILURE_NOTINITIALIZED: 11,
    FAILURE_PINMISMATCH: 12,
    FAILURE_FIRMWAREERROR: 99
};
/**
 * @enum {number}
 */ proto.OutputScriptType = {
    PAYTOADDRESS: 0,
    PAYTOSCRIPTHASH: 1,
    PAYTOMULTISIG: 2,
    PAYTOOPRETURN: 3,
    PAYTOWITNESS: 4,
    PAYTOP2SHWITNESS: 5
};
/**
 * @enum {number}
 */ proto.InputScriptType = {
    SPENDADDRESS: 0,
    SPENDMULTISIG: 1,
    EXTERNAL: 2,
    SPENDWITNESS: 3,
    SPENDP2SHWITNESS: 4
};
/**
 * @enum {number}
 */ proto.RequestType = {
    TXINPUT: 0,
    TXOUTPUT: 1,
    TXMETA: 2,
    TXFINISHED: 3,
    TXEXTRADATA: 4
};
/**
 * @enum {number}
 */ proto.OutputAddressType = {
    SPEND: 0,
    TRANSFER: 1,
    CHANGE: 2
};
/**
 * @enum {number}
 */ proto.ButtonRequestType = {
    BUTTONREQUEST_OTHER: 1,
    BUTTONREQUEST_FEEOVERTHRESHOLD: 2,
    BUTTONREQUEST_CONFIRMOUTPUT: 3,
    BUTTONREQUEST_RESETDEVICE: 4,
    BUTTONREQUEST_CONFIRMWORD: 5,
    BUTTONREQUEST_WIPEDEVICE: 6,
    BUTTONREQUEST_PROTECTCALL: 7,
    BUTTONREQUEST_SIGNTX: 8,
    BUTTONREQUEST_FIRMWARECHECK: 9,
    BUTTONREQUEST_ADDRESS: 10,
    BUTTONREQUEST_FIRMWAREERASE: 11,
    BUTTONREQUEST_CONFIRMTRANSFERTOACCOUNT: 12,
    BUTTONREQUEST_CONFIRMTRANSFERTONODEPATH: 13,
    BUTTONREQUEST_CHANGELABEL: 14,
    BUTTONREQUEST_CHANGELANGUAGE: 15,
    BUTTONREQUEST_ENABLEPASSPHRASE: 16,
    BUTTONREQUEST_DISABLEPASSPHRASE: 17,
    BUTTONREQUEST_ENCRYPTANDSIGNMESSAGE: 18,
    BUTTONREQUEST_ENCRYPTMESSAGE: 19,
    BUTTONREQUEST_IMPORTPRIVATEKEY: 20,
    BUTTONREQUEST_IMPORTRECOVERYSENTENCE: 21,
    BUTTONREQUEST_SIGNIDENTITY: 22,
    BUTTONREQUEST_PING: 23,
    BUTTONREQUEST_REMOVEPIN: 24,
    BUTTONREQUEST_CHANGEPIN: 25,
    BUTTONREQUEST_CREATEPIN: 26,
    BUTTONREQUEST_GETENTROPY: 27,
    BUTTONREQUEST_SIGNMESSAGE: 28,
    BUTTONREQUEST_APPLYPOLICIES: 29,
    BUTTONREQUEST_AUTOLOCKDELAYMS: 31,
    BUTTONREQUEST_U2FCOUNTER: 32,
    BUTTONREQUEST_CONFIRMEOSACTION: 33,
    BUTTONREQUEST_CONFIRMEOSBUDGET: 34,
    BUTTONREQUEST_CONFIRMMEMO: 35,
    BUTTONREQUEST_REMOVEWIPECODE: 36,
    BUTTONREQUEST_CHANGEWIPECODE: 37,
    BUTTONREQUEST_CREATEWIPECODE: 38
};
/**
 * @enum {number}
 */ proto.PinMatrixRequestType = {
    PINMATRIXREQUESTTYPE_CURRENT: 1,
    PINMATRIXREQUESTTYPE_NEWFIRST: 2,
    PINMATRIXREQUESTTYPE_NEWSECOND: 3
};
/**
 * A tuple of {field number, class constructor} for the extension
 * field named `wireIn`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */ proto.wireIn = new $2MzPv.ExtensionFieldInfo(50002, {
    wireIn: 0
}, null, /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ null, 0);
$8c6cf1e0333499b5$exports.EnumValueOptions.extensionsBinary[50002] = new $2MzPv.ExtensionFieldBinaryInfo(proto.wireIn, $2MzPv.BinaryReader.prototype.readBool, $2MzPv.BinaryWriter.prototype.writeBool, undefined, undefined, false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
$8c6cf1e0333499b5$exports.EnumValueOptions.extensions[50002] = proto.wireIn;
/**
 * A tuple of {field number, class constructor} for the extension
 * field named `wireOut`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */ proto.wireOut = new $2MzPv.ExtensionFieldInfo(50003, {
    wireOut: 0
}, null, /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ null, 0);
$8c6cf1e0333499b5$exports.EnumValueOptions.extensionsBinary[50003] = new $2MzPv.ExtensionFieldBinaryInfo(proto.wireOut, $2MzPv.BinaryReader.prototype.readBool, $2MzPv.BinaryWriter.prototype.writeBool, undefined, undefined, false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
$8c6cf1e0333499b5$exports.EnumValueOptions.extensions[50003] = proto.wireOut;
/**
 * A tuple of {field number, class constructor} for the extension
 * field named `wireDebugIn`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */ proto.wireDebugIn = new $2MzPv.ExtensionFieldInfo(50004, {
    wireDebugIn: 0
}, null, /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ null, 0);
$8c6cf1e0333499b5$exports.EnumValueOptions.extensionsBinary[50004] = new $2MzPv.ExtensionFieldBinaryInfo(proto.wireDebugIn, $2MzPv.BinaryReader.prototype.readBool, $2MzPv.BinaryWriter.prototype.writeBool, undefined, undefined, false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
$8c6cf1e0333499b5$exports.EnumValueOptions.extensions[50004] = proto.wireDebugIn;
/**
 * A tuple of {field number, class constructor} for the extension
 * field named `wireDebugOut`.
 * @type {!jspb.ExtensionFieldInfo<boolean>}
 */ proto.wireDebugOut = new $2MzPv.ExtensionFieldInfo(50005, {
    wireDebugOut: 0
}, null, /** @type {?function((boolean|undefined),!jspb.Message=): !Object} */ null, 0);
$8c6cf1e0333499b5$exports.EnumValueOptions.extensionsBinary[50005] = new $2MzPv.ExtensionFieldBinaryInfo(proto.wireDebugOut, $2MzPv.BinaryReader.prototype.readBool, $2MzPv.BinaryWriter.prototype.writeBool, undefined, undefined, false);
// This registers the extension field with the extended class, so that
// toObject() will function correctly.
$8c6cf1e0333499b5$exports.EnumValueOptions.extensions[50005] = proto.wireDebugOut;
$d4cdf7121546d3d6$var$goog.object.extend($d4cdf7121546d3d6$exports, proto);


$437b837d88ef5c30$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Address", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ApplyPolicies", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ApplySettings", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ButtonAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ButtonRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Cancel", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ChangePin", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ChangeWipeCode", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.CharacterAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.CharacterRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.CipherKeyValue", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.CipheredKeyValue", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ClearSession", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.CoinTable", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkDecision", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkFillConfig", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkFlashDump", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkFlashDumpResponse", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkGetState", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkLog", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkState", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DebugLinkStop", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DecryptMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.DecryptedMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.EncryptMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.EncryptedMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Entropy", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.EntropyAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.EntropyRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Failure", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Features", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.FirmwareErase", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.FirmwareUpload", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.FlashHash", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.FlashHashResponse", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.FlashWrite", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.GetAddress", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.GetCoinTable", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.GetEntropy", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.GetFeatures", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.GetPublicKey", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Initialize", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.LoadDevice", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.MessageSignature", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.MessageType", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.PassphraseAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.PassphraseRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.PinMatrixAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.PinMatrixRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Ping", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.PublicKey", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.RawTxAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.RecoveryDevice", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.ResetDevice", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.SignIdentity", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.SignMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.SignTx", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.SignedIdentity", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.SoftReset", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.Success", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.TxAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.TxRequest", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.VerifyMessage", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.WipeDevice", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.WordAck", null, $437b837d88ef5c30$var$global);
$437b837d88ef5c30$var$goog.exportSymbol("proto.WordRequest", null, $437b837d88ef5c30$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Initialize = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Initialize, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Initialize.displayName = "proto.Initialize";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.GetFeatures = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.GetFeatures, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.GetFeatures.displayName = "proto.GetFeatures";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Features = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.Features.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Features, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Features.displayName = "proto.Features";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.GetCoinTable = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.GetCoinTable, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.GetCoinTable.displayName = "proto.GetCoinTable";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CoinTable = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.CoinTable.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.CoinTable, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CoinTable.displayName = "proto.CoinTable";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ClearSession = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ClearSession, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ClearSession.displayName = "proto.ClearSession";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ApplySettings = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ApplySettings, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ApplySettings.displayName = "proto.ApplySettings";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ChangePin = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ChangePin, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ChangePin.displayName = "proto.ChangePin";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Ping = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Ping, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Ping.displayName = "proto.Ping";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Success = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Success, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Success.displayName = "proto.Success";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Failure = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Failure, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Failure.displayName = "proto.Failure";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ButtonRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ButtonRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ButtonRequest.displayName = "proto.ButtonRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ButtonAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ButtonAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ButtonAck.displayName = "proto.ButtonAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PinMatrixRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.PinMatrixRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PinMatrixRequest.displayName = "proto.PinMatrixRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PinMatrixAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.PinMatrixAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PinMatrixAck.displayName = "proto.PinMatrixAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Cancel = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Cancel, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Cancel.displayName = "proto.Cancel";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PassphraseRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.PassphraseRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PassphraseRequest.displayName = "proto.PassphraseRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PassphraseAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.PassphraseAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PassphraseAck.displayName = "proto.PassphraseAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.GetEntropy = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.GetEntropy, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.GetEntropy.displayName = "proto.GetEntropy";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Entropy = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Entropy, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Entropy.displayName = "proto.Entropy";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.GetPublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.GetPublicKey.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.GetPublicKey, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.GetPublicKey.displayName = "proto.GetPublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.PublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.PublicKey, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.PublicKey.displayName = "proto.PublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.GetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.GetAddress.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.GetAddress, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.GetAddress.displayName = "proto.GetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Address = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.Address, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Address.displayName = "proto.Address";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.WipeDevice = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.WipeDevice, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.WipeDevice.displayName = "proto.WipeDevice";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.LoadDevice = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.LoadDevice, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.LoadDevice.displayName = "proto.LoadDevice";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ResetDevice = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ResetDevice, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ResetDevice.displayName = "proto.ResetDevice";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EntropyRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.EntropyRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EntropyRequest.displayName = "proto.EntropyRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EntropyAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.EntropyAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EntropyAck.displayName = "proto.EntropyAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RecoveryDevice = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.RecoveryDevice, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RecoveryDevice.displayName = "proto.RecoveryDevice";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.WordRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.WordRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.WordRequest.displayName = "proto.WordRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.WordAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.WordAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.WordAck.displayName = "proto.WordAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CharacterRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.CharacterRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CharacterRequest.displayName = "proto.CharacterRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CharacterAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.CharacterAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CharacterAck.displayName = "proto.CharacterAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.SignMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.SignMessage.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.SignMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.SignMessage.displayName = "proto.SignMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.VerifyMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.VerifyMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.VerifyMessage.displayName = "proto.VerifyMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MessageSignature = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.MessageSignature, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MessageSignature.displayName = "proto.MessageSignature";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EncryptMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EncryptMessage.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.EncryptMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EncryptMessage.displayName = "proto.EncryptMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EncryptedMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.EncryptedMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EncryptedMessage.displayName = "proto.EncryptedMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DecryptMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.DecryptMessage.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DecryptMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DecryptMessage.displayName = "proto.DecryptMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DecryptedMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DecryptedMessage, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DecryptedMessage.displayName = "proto.DecryptedMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CipherKeyValue = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.CipherKeyValue.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.CipherKeyValue, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CipherKeyValue.displayName = "proto.CipherKeyValue";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CipheredKeyValue = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.CipheredKeyValue, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CipheredKeyValue.displayName = "proto.CipheredKeyValue";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.SignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.SignTx, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.SignTx.displayName = "proto.SignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.TxRequest, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxRequest.displayName = "proto.TxRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.TxAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.TxAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.TxAck.displayName = "proto.TxAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RawTxAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.RawTxAck, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RawTxAck.displayName = "proto.RawTxAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.SignIdentity = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.SignIdentity, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.SignIdentity.displayName = "proto.SignIdentity";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.SignedIdentity = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.SignedIdentity, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.SignedIdentity.displayName = "proto.SignedIdentity";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ApplyPolicies = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.ApplyPolicies.repeatedFields_, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ApplyPolicies, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ApplyPolicies.displayName = "proto.ApplyPolicies";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.FlashHash = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.FlashHash, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.FlashHash.displayName = "proto.FlashHash";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.FlashWrite = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.FlashWrite, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.FlashWrite.displayName = "proto.FlashWrite";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.FlashHashResponse = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.FlashHashResponse, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.FlashHashResponse.displayName = "proto.FlashHashResponse";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkFlashDump = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkFlashDump, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkFlashDump.displayName = "proto.DebugLinkFlashDump";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkFlashDumpResponse = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkFlashDumpResponse, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkFlashDumpResponse.displayName = "proto.DebugLinkFlashDumpResponse";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.SoftReset = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.SoftReset, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.SoftReset.displayName = "proto.SoftReset";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.FirmwareErase = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.FirmwareErase, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.FirmwareErase.displayName = "proto.FirmwareErase";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.FirmwareUpload = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.FirmwareUpload, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.FirmwareUpload.displayName = "proto.FirmwareUpload";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkDecision = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkDecision, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkDecision.displayName = "proto.DebugLinkDecision";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkGetState = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkGetState, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkGetState.displayName = "proto.DebugLinkGetState";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkState = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkState, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkState.displayName = "proto.DebugLinkState";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkStop = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkStop, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkStop.displayName = "proto.DebugLinkStop";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkLog = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkLog, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkLog.displayName = "proto.DebugLinkLog";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.DebugLinkFillConfig = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.DebugLinkFillConfig, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.DebugLinkFillConfig.displayName = "proto.DebugLinkFillConfig";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ChangeWipeCode = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$437b837d88ef5c30$var$goog.inherits(proto.ChangeWipeCode, $2MzPv.Message);
if ($437b837d88ef5c30$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ChangeWipeCode.displayName = "proto.ChangeWipeCode";
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Initialize.prototype.toObject = function(opt_includeInstance) {
        return proto.Initialize.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Initialize} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Initialize.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Initialize}
 */ proto.Initialize.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Initialize;
    return proto.Initialize.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Initialize} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Initialize}
 */ proto.Initialize.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Initialize.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Initialize.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Initialize} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Initialize.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.GetFeatures.prototype.toObject = function(opt_includeInstance) {
        return proto.GetFeatures.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetFeatures} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetFeatures.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetFeatures}
 */ proto.GetFeatures.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.GetFeatures;
    return proto.GetFeatures.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetFeatures} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetFeatures}
 */ proto.GetFeatures.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.GetFeatures.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.GetFeatures.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetFeatures} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetFeatures.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.Features.repeatedFields_ = [
    11,
    18
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Features.prototype.toObject = function(opt_includeInstance) {
        return proto.Features.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Features} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Features.toObject = function(includeInstance, msg) {
        var f, obj = {
            vendor: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            majorVersion: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            minorVersion: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            patchVersion: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            bootloaderMode: (f = $2MzPv.Message.getBooleanField(msg, 5)) == null ? undefined : f,
            deviceId: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            pinProtection: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 8)) == null ? undefined : f,
            language: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            label: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f,
            coinsList: $2MzPv.Message.toObjectList(msg.getCoinsList(), $d4cdf7121546d3d6$exports.CoinType.toObject, includeInstance),
            initialized: (f = $2MzPv.Message.getBooleanField(msg, 12)) == null ? undefined : f,
            revision: msg.getRevision_asB64(),
            bootloaderHash: msg.getBootloaderHash_asB64(),
            imported: (f = $2MzPv.Message.getBooleanField(msg, 15)) == null ? undefined : f,
            pinCached: (f = $2MzPv.Message.getBooleanField(msg, 16)) == null ? undefined : f,
            passphraseCached: (f = $2MzPv.Message.getBooleanField(msg, 17)) == null ? undefined : f,
            policiesList: $2MzPv.Message.toObjectList(msg.getPoliciesList(), $d4cdf7121546d3d6$exports.PolicyType.toObject, includeInstance),
            model: (f = $2MzPv.Message.getField(msg, 21)) == null ? undefined : f,
            firmwareVariant: (f = $2MzPv.Message.getField(msg, 22)) == null ? undefined : f,
            firmwareHash: msg.getFirmwareHash_asB64(),
            noBackup: (f = $2MzPv.Message.getBooleanField(msg, 24)) == null ? undefined : f,
            wipeCodeProtection: (f = $2MzPv.Message.getBooleanField(msg, 25)) == null ? undefined : f,
            autoLockDelayMs: (f = $2MzPv.Message.getField(msg, 26)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Features}
 */ proto.Features.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Features;
    return proto.Features.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Features} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Features}
 */ proto.Features.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVendor(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMajorVersion(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMinorVersion(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setPatchVersion(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setBootloaderMode(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceId(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPinProtection(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 11:
                var value = new $d4cdf7121546d3d6$exports.CoinType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.CoinType.deserializeBinaryFromReader);
                msg.addCoins(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInitialized(value);
                break;
            case 13:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setRevision(value);
                break;
            case 14:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setBootloaderHash(value);
                break;
            case 15:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setImported(value);
                break;
            case 16:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPinCached(value);
                break;
            case 17:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseCached(value);
                break;
            case 18:
                var value = new $d4cdf7121546d3d6$exports.PolicyType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.PolicyType.deserializeBinaryFromReader);
                msg.addPolicies(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setFirmwareVariant(value);
                break;
            case 23:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setFirmwareHash(value);
                break;
            case 24:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setNoBackup(value);
                break;
            case 25:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWipeCodeProtection(value);
                break;
            case 26:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAutoLockDelayMs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Features.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Features.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Features} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Features.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeBool(8, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeString(9, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeString(10, f);
    f = message.getCoinsList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, $d4cdf7121546d3d6$exports.CoinType.serializeBinaryToWriter);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeBool(12, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 13);
    if (f != null) writer.writeBytes(13, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 14);
    if (f != null) writer.writeBytes(14, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 15);
    if (f != null) writer.writeBool(15, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 16);
    if (f != null) writer.writeBool(16, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 17);
    if (f != null) writer.writeBool(17, f);
    f = message.getPoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(18, f, $d4cdf7121546d3d6$exports.PolicyType.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 21);
    if (f != null) writer.writeString(21, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 22);
    if (f != null) writer.writeString(22, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 23);
    if (f != null) writer.writeBytes(23, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 24);
    if (f != null) writer.writeBool(24, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 25);
    if (f != null) writer.writeBool(25, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 26);
    if (f != null) writer.writeUint32(26, f);
};
/**
 * optional string vendor = 1;
 * @return {string}
 */ proto.Features.prototype.getVendor = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setVendor = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearVendor = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasVendor = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 major_version = 2;
 * @return {number}
 */ proto.Features.prototype.getMajorVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setMajorVersion = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearMajorVersion = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasMajorVersion = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 minor_version = 3;
 * @return {number}
 */ proto.Features.prototype.getMinorVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setMinorVersion = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearMinorVersion = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasMinorVersion = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 patch_version = 4;
 * @return {number}
 */ proto.Features.prototype.getPatchVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setPatchVersion = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPatchVersion = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasPatchVersion = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bool bootloader_mode = 5;
 * @return {boolean}
 */ proto.Features.prototype.getBootloaderMode = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setBootloaderMode = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearBootloaderMode = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasBootloaderMode = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string device_id = 6;
 * @return {string}
 */ proto.Features.prototype.getDeviceId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setDeviceId = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearDeviceId = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasDeviceId = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool pin_protection = 7;
 * @return {boolean}
 */ proto.Features.prototype.getPinProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setPinProtection = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPinProtection = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasPinProtection = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional bool passphrase_protection = 8;
 * @return {boolean}
 */ proto.Features.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional string language = 9;
 * @return {string}
 */ proto.Features.prototype.getLanguage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setLanguage = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearLanguage = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasLanguage = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional string label = 10;
 * @return {string}
 */ proto.Features.prototype.getLabel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * repeated CoinType coins = 11;
 * @return {!Array<!proto.CoinType>}
 */ proto.Features.prototype.getCoinsList = function() {
    return /** @type{!Array<!proto.CoinType>} */ $2MzPv.Message.getRepeatedWrapperField(this, $d4cdf7121546d3d6$exports.CoinType, 11);
};
/**
 * @param {!Array<!proto.CoinType>} value
 * @return {!proto.Features} returns this
*/ proto.Features.prototype.setCoinsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.CoinType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CoinType}
 */ proto.Features.prototype.addCoins = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.CoinType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearCoinsList = function() {
    return this.setCoinsList([]);
};
/**
 * optional bool initialized = 12;
 * @return {boolean}
 */ proto.Features.prototype.getInitialized = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setInitialized = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearInitialized = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasInitialized = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional bytes revision = 13;
 * @return {!(string|Uint8Array)}
 */ proto.Features.prototype.getRevision = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 13, "");
};
/**
 * optional bytes revision = 13;
 * This is a type-conversion wrapper around `getRevision()`
 * @return {string}
 */ proto.Features.prototype.getRevision_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getRevision());
};
/**
 * optional bytes revision = 13;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRevision()`
 * @return {!Uint8Array}
 */ proto.Features.prototype.getRevision_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getRevision());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setRevision = function(value) {
    return $2MzPv.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearRevision = function() {
    return $2MzPv.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasRevision = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
/**
 * optional bytes bootloader_hash = 14;
 * @return {!(string|Uint8Array)}
 */ proto.Features.prototype.getBootloaderHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 14, "");
};
/**
 * optional bytes bootloader_hash = 14;
 * This is a type-conversion wrapper around `getBootloaderHash()`
 * @return {string}
 */ proto.Features.prototype.getBootloaderHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getBootloaderHash());
};
/**
 * optional bytes bootloader_hash = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBootloaderHash()`
 * @return {!Uint8Array}
 */ proto.Features.prototype.getBootloaderHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getBootloaderHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setBootloaderHash = function(value) {
    return $2MzPv.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearBootloaderHash = function() {
    return $2MzPv.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasBootloaderHash = function() {
    return $2MzPv.Message.getField(this, 14) != null;
};
/**
 * optional bool imported = 15;
 * @return {boolean}
 */ proto.Features.prototype.getImported = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 15, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setImported = function(value) {
    return $2MzPv.Message.setField(this, 15, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearImported = function() {
    return $2MzPv.Message.setField(this, 15, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasImported = function() {
    return $2MzPv.Message.getField(this, 15) != null;
};
/**
 * optional bool pin_cached = 16;
 * @return {boolean}
 */ proto.Features.prototype.getPinCached = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 16, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setPinCached = function(value) {
    return $2MzPv.Message.setField(this, 16, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPinCached = function() {
    return $2MzPv.Message.setField(this, 16, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasPinCached = function() {
    return $2MzPv.Message.getField(this, 16) != null;
};
/**
 * optional bool passphrase_cached = 17;
 * @return {boolean}
 */ proto.Features.prototype.getPassphraseCached = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 17, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setPassphraseCached = function(value) {
    return $2MzPv.Message.setField(this, 17, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPassphraseCached = function() {
    return $2MzPv.Message.setField(this, 17, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasPassphraseCached = function() {
    return $2MzPv.Message.getField(this, 17) != null;
};
/**
 * repeated PolicyType policies = 18;
 * @return {!Array<!proto.PolicyType>}
 */ proto.Features.prototype.getPoliciesList = function() {
    return /** @type{!Array<!proto.PolicyType>} */ $2MzPv.Message.getRepeatedWrapperField(this, $d4cdf7121546d3d6$exports.PolicyType, 18);
};
/**
 * @param {!Array<!proto.PolicyType>} value
 * @return {!proto.Features} returns this
*/ proto.Features.prototype.setPoliciesList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 18, value);
};
/**
 * @param {!proto.PolicyType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PolicyType}
 */ proto.Features.prototype.addPolicies = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.PolicyType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearPoliciesList = function() {
    return this.setPoliciesList([]);
};
/**
 * optional string model = 21;
 * @return {string}
 */ proto.Features.prototype.getModel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setModel = function(value) {
    return $2MzPv.Message.setField(this, 21, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearModel = function() {
    return $2MzPv.Message.setField(this, 21, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasModel = function() {
    return $2MzPv.Message.getField(this, 21) != null;
};
/**
 * optional string firmware_variant = 22;
 * @return {string}
 */ proto.Features.prototype.getFirmwareVariant = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setFirmwareVariant = function(value) {
    return $2MzPv.Message.setField(this, 22, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearFirmwareVariant = function() {
    return $2MzPv.Message.setField(this, 22, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasFirmwareVariant = function() {
    return $2MzPv.Message.getField(this, 22) != null;
};
/**
 * optional bytes firmware_hash = 23;
 * @return {!(string|Uint8Array)}
 */ proto.Features.prototype.getFirmwareHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 23, "");
};
/**
 * optional bytes firmware_hash = 23;
 * This is a type-conversion wrapper around `getFirmwareHash()`
 * @return {string}
 */ proto.Features.prototype.getFirmwareHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getFirmwareHash());
};
/**
 * optional bytes firmware_hash = 23;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFirmwareHash()`
 * @return {!Uint8Array}
 */ proto.Features.prototype.getFirmwareHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getFirmwareHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setFirmwareHash = function(value) {
    return $2MzPv.Message.setField(this, 23, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearFirmwareHash = function() {
    return $2MzPv.Message.setField(this, 23, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasFirmwareHash = function() {
    return $2MzPv.Message.getField(this, 23) != null;
};
/**
 * optional bool no_backup = 24;
 * @return {boolean}
 */ proto.Features.prototype.getNoBackup = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 24, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setNoBackup = function(value) {
    return $2MzPv.Message.setField(this, 24, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearNoBackup = function() {
    return $2MzPv.Message.setField(this, 24, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasNoBackup = function() {
    return $2MzPv.Message.getField(this, 24) != null;
};
/**
 * optional bool wipe_code_protection = 25;
 * @return {boolean}
 */ proto.Features.prototype.getWipeCodeProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 25, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setWipeCodeProtection = function(value) {
    return $2MzPv.Message.setField(this, 25, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearWipeCodeProtection = function() {
    return $2MzPv.Message.setField(this, 25, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasWipeCodeProtection = function() {
    return $2MzPv.Message.getField(this, 25) != null;
};
/**
 * optional uint32 auto_lock_delay_ms = 26;
 * @return {number}
 */ proto.Features.prototype.getAutoLockDelayMs = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 26, 0);
};
/**
 * @param {number} value
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.setAutoLockDelayMs = function(value) {
    return $2MzPv.Message.setField(this, 26, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Features} returns this
 */ proto.Features.prototype.clearAutoLockDelayMs = function() {
    return $2MzPv.Message.setField(this, 26, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Features.prototype.hasAutoLockDelayMs = function() {
    return $2MzPv.Message.getField(this, 26) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.GetCoinTable.prototype.toObject = function(opt_includeInstance) {
        return proto.GetCoinTable.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetCoinTable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetCoinTable.toObject = function(includeInstance, msg) {
        var f, obj = {
            start: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            end: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetCoinTable}
 */ proto.GetCoinTable.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.GetCoinTable;
    return proto.GetCoinTable.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetCoinTable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetCoinTable}
 */ proto.GetCoinTable.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setStart(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setEnd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.GetCoinTable.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.GetCoinTable.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetCoinTable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetCoinTable.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
};
/**
 * optional uint32 start = 1;
 * @return {number}
 */ proto.GetCoinTable.prototype.getStart = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.GetCoinTable} returns this
 */ proto.GetCoinTable.prototype.setStart = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetCoinTable} returns this
 */ proto.GetCoinTable.prototype.clearStart = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetCoinTable.prototype.hasStart = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 end = 2;
 * @return {number}
 */ proto.GetCoinTable.prototype.getEnd = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.GetCoinTable} returns this
 */ proto.GetCoinTable.prototype.setEnd = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetCoinTable} returns this
 */ proto.GetCoinTable.prototype.clearEnd = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetCoinTable.prototype.hasEnd = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.CoinTable.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CoinTable.prototype.toObject = function(opt_includeInstance) {
        return proto.CoinTable.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CoinTable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CoinTable.toObject = function(includeInstance, msg) {
        var f, obj = {
            tableList: $2MzPv.Message.toObjectList(msg.getTableList(), $d4cdf7121546d3d6$exports.CoinType.toObject, includeInstance),
            numCoins: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            chunkSize: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CoinTable}
 */ proto.CoinTable.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CoinTable;
    return proto.CoinTable.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CoinTable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CoinTable}
 */ proto.CoinTable.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.CoinType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.CoinType.deserializeBinaryFromReader);
                msg.addTable(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setNumCoins(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setChunkSize(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CoinTable.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CoinTable.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CoinTable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CoinTable.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTableList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $d4cdf7121546d3d6$exports.CoinType.serializeBinaryToWriter);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
};
/**
 * repeated CoinType table = 1;
 * @return {!Array<!proto.CoinType>}
 */ proto.CoinTable.prototype.getTableList = function() {
    return /** @type{!Array<!proto.CoinType>} */ $2MzPv.Message.getRepeatedWrapperField(this, $d4cdf7121546d3d6$exports.CoinType, 1);
};
/**
 * @param {!Array<!proto.CoinType>} value
 * @return {!proto.CoinTable} returns this
*/ proto.CoinTable.prototype.setTableList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.CoinType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.CoinType}
 */ proto.CoinTable.prototype.addTable = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.CoinType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.CoinTable} returns this
 */ proto.CoinTable.prototype.clearTableList = function() {
    return this.setTableList([]);
};
/**
 * optional uint32 num_coins = 2;
 * @return {number}
 */ proto.CoinTable.prototype.getNumCoins = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinTable} returns this
 */ proto.CoinTable.prototype.setNumCoins = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinTable} returns this
 */ proto.CoinTable.prototype.clearNumCoins = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinTable.prototype.hasNumCoins = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 chunk_size = 3;
 * @return {number}
 */ proto.CoinTable.prototype.getChunkSize = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.CoinTable} returns this
 */ proto.CoinTable.prototype.setChunkSize = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CoinTable} returns this
 */ proto.CoinTable.prototype.clearChunkSize = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CoinTable.prototype.hasChunkSize = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ClearSession.prototype.toObject = function(opt_includeInstance) {
        return proto.ClearSession.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ClearSession} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ClearSession.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ClearSession}
 */ proto.ClearSession.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ClearSession;
    return proto.ClearSession.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ClearSession} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ClearSession}
 */ proto.ClearSession.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ClearSession.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ClearSession.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ClearSession} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ClearSession.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ApplySettings.prototype.toObject = function(opt_includeInstance) {
        return proto.ApplySettings.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplySettings} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ApplySettings.toObject = function(includeInstance, msg) {
        var f, obj = {
            language: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            label: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            usePassphrase: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            autoLockDelayMs: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            u2fCounter: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplySettings}
 */ proto.ApplySettings.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ApplySettings;
    return proto.ApplySettings.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplySettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplySettings}
 */ proto.ApplySettings.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setUsePassphrase(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAutoLockDelayMs(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setU2fCounter(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ApplySettings.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ApplySettings.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplySettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ApplySettings.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
};
/**
 * optional string language = 1;
 * @return {string}
 */ proto.ApplySettings.prototype.getLanguage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.setLanguage = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.clearLanguage = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ApplySettings.prototype.hasLanguage = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string label = 2;
 * @return {string}
 */ proto.ApplySettings.prototype.getLabel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ApplySettings.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool use_passphrase = 3;
 * @return {boolean}
 */ proto.ApplySettings.prototype.getUsePassphrase = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.setUsePassphrase = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.clearUsePassphrase = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ApplySettings.prototype.hasUsePassphrase = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 auto_lock_delay_ms = 4;
 * @return {number}
 */ proto.ApplySettings.prototype.getAutoLockDelayMs = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.setAutoLockDelayMs = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.clearAutoLockDelayMs = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ApplySettings.prototype.hasAutoLockDelayMs = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 u2f_counter = 5;
 * @return {number}
 */ proto.ApplySettings.prototype.getU2fCounter = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.setU2fCounter = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ApplySettings} returns this
 */ proto.ApplySettings.prototype.clearU2fCounter = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ApplySettings.prototype.hasU2fCounter = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ChangePin.prototype.toObject = function(opt_includeInstance) {
        return proto.ChangePin.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ChangePin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ChangePin.toObject = function(includeInstance, msg) {
        var f, obj = {
            remove: (f = $2MzPv.Message.getBooleanField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ChangePin}
 */ proto.ChangePin.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ChangePin;
    return proto.ChangePin.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ChangePin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ChangePin}
 */ proto.ChangePin.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRemove(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ChangePin.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ChangePin.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ChangePin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ChangePin.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
};
/**
 * optional bool remove = 1;
 * @return {boolean}
 */ proto.ChangePin.prototype.getRemove = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ChangePin} returns this
 */ proto.ChangePin.prototype.setRemove = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ChangePin} returns this
 */ proto.ChangePin.prototype.clearRemove = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ChangePin.prototype.hasRemove = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Ping.prototype.toObject = function(opt_includeInstance) {
        return proto.Ping.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Ping} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Ping.toObject = function(includeInstance, msg) {
        var f, obj = {
            message: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            buttonProtection: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            pinProtection: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 4)) == null ? undefined : f,
            wipeCodeProtection: (f = $2MzPv.Message.getBooleanField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Ping}
 */ proto.Ping.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Ping;
    return proto.Ping.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Ping} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Ping}
 */ proto.Ping.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setButtonProtection(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPinProtection(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWipeCodeProtection(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Ping.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Ping.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Ping} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Ping.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
};
/**
 * optional string message = 1;
 * @return {string}
 */ proto.Ping.prototype.getMessage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ping.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool button_protection = 2;
 * @return {boolean}
 */ proto.Ping.prototype.getButtonProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.setButtonProtection = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.clearButtonProtection = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ping.prototype.hasButtonProtection = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool pin_protection = 3;
 * @return {boolean}
 */ proto.Ping.prototype.getPinProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.setPinProtection = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.clearPinProtection = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ping.prototype.hasPinProtection = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool passphrase_protection = 4;
 * @return {boolean}
 */ proto.Ping.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ping.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bool wipe_code_protection = 5;
 * @return {boolean}
 */ proto.Ping.prototype.getWipeCodeProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.setWipeCodeProtection = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ping} returns this
 */ proto.Ping.prototype.clearWipeCodeProtection = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ping.prototype.hasWipeCodeProtection = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Success.prototype.toObject = function(opt_includeInstance) {
        return proto.Success.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Success} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Success.toObject = function(includeInstance, msg) {
        var f, obj = {
            message: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Success}
 */ proto.Success.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Success;
    return proto.Success.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Success} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Success}
 */ proto.Success.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Success.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Success.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Success} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Success.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string message = 1;
 * @return {string}
 */ proto.Success.prototype.getMessage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.Success} returns this
 */ proto.Success.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Success} returns this
 */ proto.Success.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Success.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Failure.prototype.toObject = function(opt_includeInstance) {
        return proto.Failure.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Failure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Failure.toObject = function(includeInstance, msg) {
        var f, obj = {
            code: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            message: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Failure}
 */ proto.Failure.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Failure;
    return proto.Failure.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Failure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Failure}
 */ proto.Failure.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.FailureType} */ reader.readEnum();
                msg.setCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Failure.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Failure.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Failure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Failure.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.FailureType} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional FailureType code = 1;
 * @return {!proto.FailureType}
 */ proto.Failure.prototype.getCode = function() {
    return /** @type {!proto.FailureType} */ $2MzPv.Message.getFieldWithDefault(this, 1, 1);
};
/**
 * @param {!proto.FailureType} value
 * @return {!proto.Failure} returns this
 */ proto.Failure.prototype.setCode = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Failure} returns this
 */ proto.Failure.prototype.clearCode = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Failure.prototype.hasCode = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string message = 2;
 * @return {string}
 */ proto.Failure.prototype.getMessage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.Failure} returns this
 */ proto.Failure.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Failure} returns this
 */ proto.Failure.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Failure.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ButtonRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.ButtonRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ButtonRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ButtonRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            code: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            data: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ButtonRequest}
 */ proto.ButtonRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ButtonRequest;
    return proto.ButtonRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ButtonRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ButtonRequest}
 */ proto.ButtonRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.ButtonRequestType} */ reader.readEnum();
                msg.setCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ButtonRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ButtonRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ButtonRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ButtonRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.ButtonRequestType} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional ButtonRequestType code = 1;
 * @return {!proto.ButtonRequestType}
 */ proto.ButtonRequest.prototype.getCode = function() {
    return /** @type {!proto.ButtonRequestType} */ $2MzPv.Message.getFieldWithDefault(this, 1, 1);
};
/**
 * @param {!proto.ButtonRequestType} value
 * @return {!proto.ButtonRequest} returns this
 */ proto.ButtonRequest.prototype.setCode = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ButtonRequest} returns this
 */ proto.ButtonRequest.prototype.clearCode = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ButtonRequest.prototype.hasCode = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string data = 2;
 * @return {string}
 */ proto.ButtonRequest.prototype.getData = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.ButtonRequest} returns this
 */ proto.ButtonRequest.prototype.setData = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ButtonRequest} returns this
 */ proto.ButtonRequest.prototype.clearData = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ButtonRequest.prototype.hasData = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ButtonAck.prototype.toObject = function(opt_includeInstance) {
        return proto.ButtonAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ButtonAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ButtonAck.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ButtonAck}
 */ proto.ButtonAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ButtonAck;
    return proto.ButtonAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ButtonAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ButtonAck}
 */ proto.ButtonAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ButtonAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ButtonAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ButtonAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ButtonAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PinMatrixRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.PinMatrixRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PinMatrixRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PinMatrixRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            type: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PinMatrixRequest}
 */ proto.PinMatrixRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PinMatrixRequest;
    return proto.PinMatrixRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PinMatrixRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PinMatrixRequest}
 */ proto.PinMatrixRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.PinMatrixRequestType} */ reader.readEnum();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PinMatrixRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PinMatrixRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PinMatrixRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PinMatrixRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.PinMatrixRequestType} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
};
/**
 * optional PinMatrixRequestType type = 1;
 * @return {!proto.PinMatrixRequestType}
 */ proto.PinMatrixRequest.prototype.getType = function() {
    return /** @type {!proto.PinMatrixRequestType} */ $2MzPv.Message.getFieldWithDefault(this, 1, 1);
};
/**
 * @param {!proto.PinMatrixRequestType} value
 * @return {!proto.PinMatrixRequest} returns this
 */ proto.PinMatrixRequest.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PinMatrixRequest} returns this
 */ proto.PinMatrixRequest.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PinMatrixRequest.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PinMatrixAck.prototype.toObject = function(opt_includeInstance) {
        return proto.PinMatrixAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PinMatrixAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PinMatrixAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            pin: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PinMatrixAck}
 */ proto.PinMatrixAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PinMatrixAck;
    return proto.PinMatrixAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PinMatrixAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PinMatrixAck}
 */ proto.PinMatrixAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PinMatrixAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PinMatrixAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PinMatrixAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PinMatrixAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * required string pin = 1;
 * @return {string}
 */ proto.PinMatrixAck.prototype.getPin = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.PinMatrixAck} returns this
 */ proto.PinMatrixAck.prototype.setPin = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PinMatrixAck} returns this
 */ proto.PinMatrixAck.prototype.clearPin = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PinMatrixAck.prototype.hasPin = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Cancel.prototype.toObject = function(opt_includeInstance) {
        return proto.Cancel.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Cancel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Cancel.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Cancel}
 */ proto.Cancel.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Cancel;
    return proto.Cancel.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Cancel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Cancel}
 */ proto.Cancel.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Cancel.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Cancel.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Cancel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Cancel.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PassphraseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.PassphraseRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PassphraseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PassphraseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PassphraseRequest}
 */ proto.PassphraseRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PassphraseRequest;
    return proto.PassphraseRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PassphraseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PassphraseRequest}
 */ proto.PassphraseRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PassphraseRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PassphraseRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PassphraseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PassphraseRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PassphraseAck.prototype.toObject = function(opt_includeInstance) {
        return proto.PassphraseAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PassphraseAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PassphraseAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            passphrase: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PassphraseAck}
 */ proto.PassphraseAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PassphraseAck;
    return proto.PassphraseAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PassphraseAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PassphraseAck}
 */ proto.PassphraseAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPassphrase(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PassphraseAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PassphraseAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PassphraseAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PassphraseAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * required string passphrase = 1;
 * @return {string}
 */ proto.PassphraseAck.prototype.getPassphrase = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.PassphraseAck} returns this
 */ proto.PassphraseAck.prototype.setPassphrase = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PassphraseAck} returns this
 */ proto.PassphraseAck.prototype.clearPassphrase = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PassphraseAck.prototype.hasPassphrase = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.GetEntropy.prototype.toObject = function(opt_includeInstance) {
        return proto.GetEntropy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetEntropy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetEntropy.toObject = function(includeInstance, msg) {
        var f, obj = {
            size: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetEntropy}
 */ proto.GetEntropy.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.GetEntropy;
    return proto.GetEntropy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetEntropy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetEntropy}
 */ proto.GetEntropy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSize(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.GetEntropy.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.GetEntropy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetEntropy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetEntropy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
};
/**
 * required uint32 size = 1;
 * @return {number}
 */ proto.GetEntropy.prototype.getSize = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.GetEntropy} returns this
 */ proto.GetEntropy.prototype.setSize = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetEntropy} returns this
 */ proto.GetEntropy.prototype.clearSize = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetEntropy.prototype.hasSize = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Entropy.prototype.toObject = function(opt_includeInstance) {
        return proto.Entropy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Entropy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Entropy.toObject = function(includeInstance, msg) {
        var f, obj = {
            entropy: msg.getEntropy_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Entropy}
 */ proto.Entropy.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Entropy;
    return proto.Entropy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Entropy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Entropy}
 */ proto.Entropy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setEntropy(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Entropy.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Entropy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Entropy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Entropy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * required bytes entropy = 1;
 * @return {!(string|Uint8Array)}
 */ proto.Entropy.prototype.getEntropy = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * required bytes entropy = 1;
 * This is a type-conversion wrapper around `getEntropy()`
 * @return {string}
 */ proto.Entropy.prototype.getEntropy_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getEntropy());
};
/**
 * required bytes entropy = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEntropy()`
 * @return {!Uint8Array}
 */ proto.Entropy.prototype.getEntropy_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getEntropy());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Entropy} returns this
 */ proto.Entropy.prototype.setEntropy = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Entropy} returns this
 */ proto.Entropy.prototype.clearEntropy = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Entropy.prototype.hasEntropy = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.GetPublicKey.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.GetPublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.GetPublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetPublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetPublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            ecdsaCurveName: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 4, "Bitcoin"),
            scriptType: $2MzPv.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetPublicKey}
 */ proto.GetPublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.GetPublicKey;
    return proto.GetPublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetPublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetPublicKey}
 */ proto.GetPublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEcdsaCurveName(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 5:
                var value = /** @type {!proto.InputScriptType} */ reader.readEnum();
                msg.setScriptType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.GetPublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.GetPublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetPublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetPublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {!proto.InputScriptType} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeEnum(5, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.GetPublicKey.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string ecdsa_curve_name = 2;
 * @return {string}
 */ proto.GetPublicKey.prototype.getEcdsaCurveName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.setEcdsaCurveName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.clearEcdsaCurveName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetPublicKey.prototype.hasEcdsaCurveName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool show_display = 3;
 * @return {boolean}
 */ proto.GetPublicKey.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetPublicKey.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string coin_name = 4;
 * @return {string}
 */ proto.GetPublicKey.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetPublicKey.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional InputScriptType script_type = 5;
 * @return {!proto.InputScriptType}
 */ proto.GetPublicKey.prototype.getScriptType = function() {
    return /** @type {!proto.InputScriptType} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.InputScriptType} value
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.setScriptType = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetPublicKey} returns this
 */ proto.GetPublicKey.prototype.clearScriptType = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetPublicKey.prototype.hasScriptType = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.PublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.PublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.PublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            node: (f = msg.getNode()) && $d4cdf7121546d3d6$exports.HDNodeType.toObject(includeInstance, f),
            xpub: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.PublicKey}
 */ proto.PublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.PublicKey;
    return proto.PublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.PublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.PublicKey}
 */ proto.PublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.HDNodeType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.HDNodeType.deserializeBinaryFromReader);
                msg.setNode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setXpub(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.PublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.PublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.PublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.PublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNode();
    if (f != null) writer.writeMessage(1, f, $d4cdf7121546d3d6$exports.HDNodeType.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * required HDNodeType node = 1;
 * @return {!proto.HDNodeType}
 */ proto.PublicKey.prototype.getNode = function() {
    return /** @type{!proto.HDNodeType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.HDNodeType, 1, 1);
};
/**
 * @param {!proto.HDNodeType} value
 * @return {!proto.PublicKey} returns this
*/ proto.PublicKey.prototype.setNode = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PublicKey} returns this
 */ proto.PublicKey.prototype.clearNode = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PublicKey.prototype.hasNode = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string xpub = 2;
 * @return {string}
 */ proto.PublicKey.prototype.getXpub = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.PublicKey} returns this
 */ proto.PublicKey.prototype.setXpub = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.PublicKey} returns this
 */ proto.PublicKey.prototype.clearXpub = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.PublicKey.prototype.hasXpub = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.GetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.GetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.GetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.GetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 2, "Bitcoin"),
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            multisig: (f = msg.getMultisig()) && $d4cdf7121546d3d6$exports.MultisigRedeemScriptType.toObject(includeInstance, f),
            scriptType: $2MzPv.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.GetAddress}
 */ proto.GetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.GetAddress;
    return proto.GetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.GetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.GetAddress}
 */ proto.GetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 4:
                var value = new $d4cdf7121546d3d6$exports.MultisigRedeemScriptType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.MultisigRedeemScriptType.deserializeBinaryFromReader);
                msg.setMultisig(value);
                break;
            case 5:
                var value = /** @type {!proto.InputScriptType} */ reader.readEnum();
                msg.setScriptType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.GetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.GetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.GetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.GetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = message.getMultisig();
    if (f != null) writer.writeMessage(4, f, $d4cdf7121546d3d6$exports.MultisigRedeemScriptType.serializeBinaryToWriter);
    f = /** @type {!proto.InputScriptType} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeEnum(5, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.GetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string coin_name = 2;
 * @return {string}
 */ proto.GetAddress.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetAddress.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool show_display = 3;
 * @return {boolean}
 */ proto.GetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional MultisigRedeemScriptType multisig = 4;
 * @return {?proto.MultisigRedeemScriptType}
 */ proto.GetAddress.prototype.getMultisig = function() {
    return /** @type{?proto.MultisigRedeemScriptType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.MultisigRedeemScriptType, 4);
};
/**
 * @param {?proto.MultisigRedeemScriptType|undefined} value
 * @return {!proto.GetAddress} returns this
*/ proto.GetAddress.prototype.setMultisig = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.clearMultisig = function() {
    return this.setMultisig(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetAddress.prototype.hasMultisig = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional InputScriptType script_type = 5;
 * @return {!proto.InputScriptType}
 */ proto.GetAddress.prototype.getScriptType = function() {
    return /** @type {!proto.InputScriptType} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.InputScriptType} value
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.setScriptType = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.GetAddress} returns this
 */ proto.GetAddress.prototype.clearScriptType = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.GetAddress.prototype.hasScriptType = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Address.prototype.toObject = function(opt_includeInstance) {
        return proto.Address.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Address.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Address}
 */ proto.Address.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Address;
    return proto.Address.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Address}
 */ proto.Address.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Address.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Address.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Address.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * required string address = 1;
 * @return {string}
 */ proto.Address.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.Address} returns this
 */ proto.Address.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Address} returns this
 */ proto.Address.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Address.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.WipeDevice.prototype.toObject = function(opt_includeInstance) {
        return proto.WipeDevice.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.WipeDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WipeDevice.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.WipeDevice}
 */ proto.WipeDevice.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.WipeDevice;
    return proto.WipeDevice.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.WipeDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.WipeDevice}
 */ proto.WipeDevice.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.WipeDevice.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.WipeDevice.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.WipeDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WipeDevice.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.LoadDevice.prototype.toObject = function(opt_includeInstance) {
        return proto.LoadDevice.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.LoadDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.LoadDevice.toObject = function(includeInstance, msg) {
        var f, obj = {
            mnemonic: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            node: (f = msg.getNode()) && $d4cdf7121546d3d6$exports.HDNodeType.toObject(includeInstance, f),
            pin: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 4)) == null ? undefined : f,
            language: $2MzPv.Message.getFieldWithDefault(msg, 5, "english"),
            label: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            skipChecksum: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            u2fCounter: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.LoadDevice}
 */ proto.LoadDevice.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.LoadDevice;
    return proto.LoadDevice.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.LoadDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.LoadDevice}
 */ proto.LoadDevice.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMnemonic(value);
                break;
            case 2:
                var value = new $d4cdf7121546d3d6$exports.HDNodeType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.HDNodeType.deserializeBinaryFromReader);
                msg.setNode(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPin(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSkipChecksum(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setU2fCounter(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.LoadDevice.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.LoadDevice.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.LoadDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.LoadDevice.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getNode();
    if (f != null) writer.writeMessage(2, f, $d4cdf7121546d3d6$exports.HDNodeType.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
};
/**
 * optional string mnemonic = 1;
 * @return {string}
 */ proto.LoadDevice.prototype.getMnemonic = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setMnemonic = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearMnemonic = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasMnemonic = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional HDNodeType node = 2;
 * @return {?proto.HDNodeType}
 */ proto.LoadDevice.prototype.getNode = function() {
    return /** @type{?proto.HDNodeType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.HDNodeType, 2);
};
/**
 * @param {?proto.HDNodeType|undefined} value
 * @return {!proto.LoadDevice} returns this
*/ proto.LoadDevice.prototype.setNode = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearNode = function() {
    return this.setNode(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasNode = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string pin = 3;
 * @return {string}
 */ proto.LoadDevice.prototype.getPin = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setPin = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearPin = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasPin = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool passphrase_protection = 4;
 * @return {boolean}
 */ proto.LoadDevice.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string language = 5;
 * @return {string}
 */ proto.LoadDevice.prototype.getLanguage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "english");
};
/**
 * @param {string} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setLanguage = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearLanguage = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasLanguage = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string label = 6;
 * @return {string}
 */ proto.LoadDevice.prototype.getLabel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool skip_checksum = 7;
 * @return {boolean}
 */ proto.LoadDevice.prototype.getSkipChecksum = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setSkipChecksum = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearSkipChecksum = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasSkipChecksum = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 u2f_counter = 8;
 * @return {number}
 */ proto.LoadDevice.prototype.getU2fCounter = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.setU2fCounter = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.LoadDevice} returns this
 */ proto.LoadDevice.prototype.clearU2fCounter = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.LoadDevice.prototype.hasU2fCounter = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ResetDevice.prototype.toObject = function(opt_includeInstance) {
        return proto.ResetDevice.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ResetDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ResetDevice.toObject = function(includeInstance, msg) {
        var f, obj = {
            displayRandom: (f = $2MzPv.Message.getBooleanField(msg, 1)) == null ? undefined : f,
            strength: $2MzPv.Message.getFieldWithDefault(msg, 2, 256),
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            pinProtection: (f = $2MzPv.Message.getBooleanField(msg, 4)) == null ? undefined : f,
            language: $2MzPv.Message.getFieldWithDefault(msg, 5, "english"),
            label: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            noBackup: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            autoLockDelayMs: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            u2fCounter: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ResetDevice}
 */ proto.ResetDevice.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ResetDevice;
    return proto.ResetDevice.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ResetDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ResetDevice}
 */ proto.ResetDevice.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDisplayRandom(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setStrength(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPinProtection(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setNoBackup(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAutoLockDelayMs(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setU2fCounter(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ResetDevice.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ResetDevice.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ResetDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ResetDevice.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
};
/**
 * optional bool display_random = 1;
 * @return {boolean}
 */ proto.ResetDevice.prototype.getDisplayRandom = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setDisplayRandom = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearDisplayRandom = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasDisplayRandom = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 strength = 2;
 * @return {number}
 */ proto.ResetDevice.prototype.getStrength = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 256);
};
/**
 * @param {number} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setStrength = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearStrength = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasStrength = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool passphrase_protection = 3;
 * @return {boolean}
 */ proto.ResetDevice.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool pin_protection = 4;
 * @return {boolean}
 */ proto.ResetDevice.prototype.getPinProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setPinProtection = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearPinProtection = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasPinProtection = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string language = 5;
 * @return {string}
 */ proto.ResetDevice.prototype.getLanguage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "english");
};
/**
 * @param {string} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setLanguage = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearLanguage = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasLanguage = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string label = 6;
 * @return {string}
 */ proto.ResetDevice.prototype.getLabel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool no_backup = 7;
 * @return {boolean}
 */ proto.ResetDevice.prototype.getNoBackup = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setNoBackup = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearNoBackup = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasNoBackup = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 auto_lock_delay_ms = 8;
 * @return {number}
 */ proto.ResetDevice.prototype.getAutoLockDelayMs = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setAutoLockDelayMs = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearAutoLockDelayMs = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasAutoLockDelayMs = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 u2f_counter = 9;
 * @return {number}
 */ proto.ResetDevice.prototype.getU2fCounter = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.setU2fCounter = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ResetDevice} returns this
 */ proto.ResetDevice.prototype.clearU2fCounter = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ResetDevice.prototype.hasU2fCounter = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EntropyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.EntropyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EntropyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EntropyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EntropyRequest}
 */ proto.EntropyRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EntropyRequest;
    return proto.EntropyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EntropyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EntropyRequest}
 */ proto.EntropyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EntropyRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EntropyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EntropyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EntropyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EntropyAck.prototype.toObject = function(opt_includeInstance) {
        return proto.EntropyAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EntropyAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EntropyAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            entropy: msg.getEntropy_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EntropyAck}
 */ proto.EntropyAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EntropyAck;
    return proto.EntropyAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EntropyAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EntropyAck}
 */ proto.EntropyAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setEntropy(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EntropyAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EntropyAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EntropyAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EntropyAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes entropy = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EntropyAck.prototype.getEntropy = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes entropy = 1;
 * This is a type-conversion wrapper around `getEntropy()`
 * @return {string}
 */ proto.EntropyAck.prototype.getEntropy_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getEntropy());
};
/**
 * optional bytes entropy = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEntropy()`
 * @return {!Uint8Array}
 */ proto.EntropyAck.prototype.getEntropy_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getEntropy());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EntropyAck} returns this
 */ proto.EntropyAck.prototype.setEntropy = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EntropyAck} returns this
 */ proto.EntropyAck.prototype.clearEntropy = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EntropyAck.prototype.hasEntropy = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RecoveryDevice.prototype.toObject = function(opt_includeInstance) {
        return proto.RecoveryDevice.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RecoveryDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RecoveryDevice.toObject = function(includeInstance, msg) {
        var f, obj = {
            wordCount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            pinProtection: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            language: $2MzPv.Message.getFieldWithDefault(msg, 4, "english"),
            label: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            enforceWordlist: (f = $2MzPv.Message.getBooleanField(msg, 6)) == null ? undefined : f,
            useCharacterCipher: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            autoLockDelayMs: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            u2fCounter: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            dryRun: (f = $2MzPv.Message.getBooleanField(msg, 10)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RecoveryDevice}
 */ proto.RecoveryDevice.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RecoveryDevice;
    return proto.RecoveryDevice.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RecoveryDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RecoveryDevice}
 */ proto.RecoveryDevice.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWordCount(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPinProtection(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setEnforceWordlist(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setUseCharacterCipher(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAutoLockDelayMs(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readUint32();
                msg.setU2fCounter(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDryRun(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RecoveryDevice.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RecoveryDevice.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RecoveryDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RecoveryDevice.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBool(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeUint32(9, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeBool(10, f);
};
/**
 * optional uint32 word_count = 1;
 * @return {number}
 */ proto.RecoveryDevice.prototype.getWordCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setWordCount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearWordCount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasWordCount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool passphrase_protection = 2;
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool pin_protection = 3;
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.getPinProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setPinProtection = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearPinProtection = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasPinProtection = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string language = 4;
 * @return {string}
 */ proto.RecoveryDevice.prototype.getLanguage = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "english");
};
/**
 * @param {string} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setLanguage = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearLanguage = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasLanguage = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string label = 5;
 * @return {string}
 */ proto.RecoveryDevice.prototype.getLabel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setLabel = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearLabel = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasLabel = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bool enforce_wordlist = 6;
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.getEnforceWordlist = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setEnforceWordlist = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearEnforceWordlist = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasEnforceWordlist = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool use_character_cipher = 7;
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.getUseCharacterCipher = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setUseCharacterCipher = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearUseCharacterCipher = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasUseCharacterCipher = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 auto_lock_delay_ms = 8;
 * @return {number}
 */ proto.RecoveryDevice.prototype.getAutoLockDelayMs = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setAutoLockDelayMs = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearAutoLockDelayMs = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasAutoLockDelayMs = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 u2f_counter = 9;
 * @return {number}
 */ proto.RecoveryDevice.prototype.getU2fCounter = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setU2fCounter = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearU2fCounter = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasU2fCounter = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional bool dry_run = 10;
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.getDryRun = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.setDryRun = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RecoveryDevice} returns this
 */ proto.RecoveryDevice.prototype.clearDryRun = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RecoveryDevice.prototype.hasDryRun = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.WordRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.WordRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.WordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WordRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.WordRequest}
 */ proto.WordRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.WordRequest;
    return proto.WordRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.WordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.WordRequest}
 */ proto.WordRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.WordRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.WordRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.WordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WordRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.WordAck.prototype.toObject = function(opt_includeInstance) {
        return proto.WordAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.WordAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WordAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            word: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.WordAck}
 */ proto.WordAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.WordAck;
    return proto.WordAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.WordAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.WordAck}
 */ proto.WordAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setWord(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.WordAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.WordAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.WordAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.WordAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * required string word = 1;
 * @return {string}
 */ proto.WordAck.prototype.getWord = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.WordAck} returns this
 */ proto.WordAck.prototype.setWord = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.WordAck} returns this
 */ proto.WordAck.prototype.clearWord = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.WordAck.prototype.hasWord = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CharacterRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.CharacterRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CharacterRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CharacterRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            wordPos: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            characterPos: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CharacterRequest}
 */ proto.CharacterRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CharacterRequest;
    return proto.CharacterRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CharacterRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CharacterRequest}
 */ proto.CharacterRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWordPos(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setCharacterPos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CharacterRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CharacterRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CharacterRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CharacterRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
};
/**
 * required uint32 word_pos = 1;
 * @return {number}
 */ proto.CharacterRequest.prototype.getWordPos = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.CharacterRequest} returns this
 */ proto.CharacterRequest.prototype.setWordPos = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CharacterRequest} returns this
 */ proto.CharacterRequest.prototype.clearWordPos = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CharacterRequest.prototype.hasWordPos = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required uint32 character_pos = 2;
 * @return {number}
 */ proto.CharacterRequest.prototype.getCharacterPos = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.CharacterRequest} returns this
 */ proto.CharacterRequest.prototype.setCharacterPos = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CharacterRequest} returns this
 */ proto.CharacterRequest.prototype.clearCharacterPos = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CharacterRequest.prototype.hasCharacterPos = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CharacterAck.prototype.toObject = function(opt_includeInstance) {
        return proto.CharacterAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CharacterAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CharacterAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            character: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            pb_delete: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            done: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CharacterAck}
 */ proto.CharacterAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CharacterAck;
    return proto.CharacterAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CharacterAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CharacterAck}
 */ proto.CharacterAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCharacter(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDelete(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CharacterAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CharacterAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CharacterAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CharacterAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * optional string character = 1;
 * @return {string}
 */ proto.CharacterAck.prototype.getCharacter = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.setCharacter = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.clearCharacter = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CharacterAck.prototype.hasCharacter = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bool delete = 2;
 * @return {boolean}
 */ proto.CharacterAck.prototype.getDelete = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.setDelete = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.clearDelete = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CharacterAck.prototype.hasDelete = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool done = 3;
 * @return {boolean}
 */ proto.CharacterAck.prototype.getDone = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.setDone = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CharacterAck} returns this
 */ proto.CharacterAck.prototype.clearDone = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CharacterAck.prototype.hasDone = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.SignMessage.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.SignMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.SignMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SignMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            message: msg.getMessage_asB64(),
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 3, "Bitcoin"),
            scriptType: $2MzPv.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SignMessage}
 */ proto.SignMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.SignMessage;
    return proto.SignMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SignMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SignMessage}
 */ proto.SignMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 4:
                var value = /** @type {!proto.InputScriptType} */ reader.readEnum();
                msg.setScriptType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.SignMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.SignMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SignMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {!proto.InputScriptType} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeEnum(4, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.SignMessage.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required bytes message = 2;
 * @return {!(string|Uint8Array)}
 */ proto.SignMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes message = 2;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.SignMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * required bytes message = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.SignMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string coin_name = 3;
 * @return {string}
 */ proto.SignMessage.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignMessage.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional InputScriptType script_type = 4;
 * @return {!proto.InputScriptType}
 */ proto.SignMessage.prototype.getScriptType = function() {
    return /** @type {!proto.InputScriptType} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.InputScriptType} value
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.setScriptType = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignMessage} returns this
 */ proto.SignMessage.prototype.clearScriptType = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignMessage.prototype.hasScriptType = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.VerifyMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.VerifyMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.VerifyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.VerifyMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            signature: msg.getSignature_asB64(),
            message: msg.getMessage_asB64(),
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 4, "Bitcoin")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.VerifyMessage}
 */ proto.VerifyMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.VerifyMessage;
    return proto.VerifyMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.VerifyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.VerifyMessage}
 */ proto.VerifyMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.VerifyMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.VerifyMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.VerifyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.VerifyMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.VerifyMessage.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.VerifyMessage.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.VerifyMessage.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.VerifyMessage.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.VerifyMessage.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.VerifyMessage.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes message = 3;
 * @return {!(string|Uint8Array)}
 */ proto.VerifyMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes message = 3;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.VerifyMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.VerifyMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.VerifyMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string coin_name = 4;
 * @return {string}
 */ proto.VerifyMessage.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.VerifyMessage} returns this
 */ proto.VerifyMessage.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.VerifyMessage.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MessageSignature.prototype.toObject = function(opt_includeInstance) {
        return proto.MessageSignature.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MessageSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MessageSignature.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MessageSignature}
 */ proto.MessageSignature.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MessageSignature;
    return proto.MessageSignature.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MessageSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MessageSignature}
 */ proto.MessageSignature.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MessageSignature.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MessageSignature.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MessageSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MessageSignature.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.MessageSignature.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.MessageSignature} returns this
 */ proto.MessageSignature.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MessageSignature} returns this
 */ proto.MessageSignature.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MessageSignature.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.MessageSignature.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.MessageSignature.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.MessageSignature.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.MessageSignature} returns this
 */ proto.MessageSignature.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MessageSignature} returns this
 */ proto.MessageSignature.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MessageSignature.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EncryptMessage.repeatedFields_ = [
    4
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EncryptMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.EncryptMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EncryptMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EncryptMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            pubkey: msg.getPubkey_asB64(),
            message: msg.getMessage_asB64(),
            displayOnly: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f,
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 5, "Bitcoin")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EncryptMessage}
 */ proto.EncryptMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EncryptMessage;
    return proto.EncryptMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EncryptMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EncryptMessage}
 */ proto.EncryptMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPubkey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDisplayOnly(value);
                break;
            case 4:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EncryptMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EncryptMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EncryptMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EncryptMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
};
/**
 * optional bytes pubkey = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EncryptMessage.prototype.getPubkey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes pubkey = 1;
 * This is a type-conversion wrapper around `getPubkey()`
 * @return {string}
 */ proto.EncryptMessage.prototype.getPubkey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPubkey());
};
/**
 * optional bytes pubkey = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPubkey()`
 * @return {!Uint8Array}
 */ proto.EncryptMessage.prototype.getPubkey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPubkey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.setPubkey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.clearPubkey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptMessage.prototype.hasPubkey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes message = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EncryptMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes message = 2;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.EncryptMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.EncryptMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool display_only = 3;
 * @return {boolean}
 */ proto.EncryptMessage.prototype.getDisplayOnly = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.setDisplayOnly = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.clearDisplayOnly = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptMessage.prototype.hasDisplayOnly = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * repeated uint32 address_n = 4;
 * @return {!Array<number>}
 */ proto.EncryptMessage.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 4);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 4, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string coin_name = 5;
 * @return {string}
 */ proto.EncryptMessage.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptMessage} returns this
 */ proto.EncryptMessage.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptMessage.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EncryptedMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.EncryptedMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EncryptedMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EncryptedMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            nonce: msg.getNonce_asB64(),
            message: msg.getMessage_asB64(),
            hmac: msg.getHmac_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EncryptedMessage}
 */ proto.EncryptedMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EncryptedMessage;
    return proto.EncryptedMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EncryptedMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EncryptedMessage}
 */ proto.EncryptedMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setHmac(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EncryptedMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EncryptedMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EncryptedMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EncryptedMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * optional bytes nonce = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EncryptedMessage.prototype.getNonce = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes nonce = 1;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.EncryptedMessage.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.EncryptedMessage.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.setNonce = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.clearNonce = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptedMessage.prototype.hasNonce = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes message = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EncryptedMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes message = 2;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.EncryptedMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.EncryptedMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptedMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes hmac = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EncryptedMessage.prototype.getHmac = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes hmac = 3;
 * This is a type-conversion wrapper around `getHmac()`
 * @return {string}
 */ proto.EncryptedMessage.prototype.getHmac_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getHmac());
};
/**
 * optional bytes hmac = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHmac()`
 * @return {!Uint8Array}
 */ proto.EncryptedMessage.prototype.getHmac_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getHmac());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.setHmac = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EncryptedMessage} returns this
 */ proto.EncryptedMessage.prototype.clearHmac = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EncryptedMessage.prototype.hasHmac = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.DecryptMessage.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DecryptMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.DecryptMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DecryptMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DecryptMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            nonce: msg.getNonce_asB64(),
            message: msg.getMessage_asB64(),
            hmac: msg.getHmac_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DecryptMessage}
 */ proto.DecryptMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DecryptMessage;
    return proto.DecryptMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DecryptMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DecryptMessage}
 */ proto.DecryptMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setHmac(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DecryptMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DecryptMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DecryptMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DecryptMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.DecryptMessage.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bytes nonce = 2;
 * @return {!(string|Uint8Array)}
 */ proto.DecryptMessage.prototype.getNonce = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes nonce = 2;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.DecryptMessage.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.DecryptMessage.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.setNonce = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.clearNonce = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DecryptMessage.prototype.hasNonce = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes message = 3;
 * @return {!(string|Uint8Array)}
 */ proto.DecryptMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes message = 3;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.DecryptMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.DecryptMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DecryptMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes hmac = 4;
 * @return {!(string|Uint8Array)}
 */ proto.DecryptMessage.prototype.getHmac = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes hmac = 4;
 * This is a type-conversion wrapper around `getHmac()`
 * @return {string}
 */ proto.DecryptMessage.prototype.getHmac_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getHmac());
};
/**
 * optional bytes hmac = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHmac()`
 * @return {!Uint8Array}
 */ proto.DecryptMessage.prototype.getHmac_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getHmac());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.setHmac = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DecryptMessage} returns this
 */ proto.DecryptMessage.prototype.clearHmac = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DecryptMessage.prototype.hasHmac = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DecryptedMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.DecryptedMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DecryptedMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DecryptedMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            message: msg.getMessage_asB64(),
            address: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DecryptedMessage}
 */ proto.DecryptedMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DecryptedMessage;
    return proto.DecryptedMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DecryptedMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DecryptedMessage}
 */ proto.DecryptedMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DecryptedMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DecryptedMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DecryptedMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DecryptedMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional bytes message = 1;
 * @return {!(string|Uint8Array)}
 */ proto.DecryptedMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes message = 1;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.DecryptedMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.DecryptedMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DecryptedMessage} returns this
 */ proto.DecryptedMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DecryptedMessage} returns this
 */ proto.DecryptedMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DecryptedMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string address = 2;
 * @return {string}
 */ proto.DecryptedMessage.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.DecryptedMessage} returns this
 */ proto.DecryptedMessage.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DecryptedMessage} returns this
 */ proto.DecryptedMessage.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DecryptedMessage.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.CipherKeyValue.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CipherKeyValue.prototype.toObject = function(opt_includeInstance) {
        return proto.CipherKeyValue.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CipherKeyValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CipherKeyValue.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            key: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            value: msg.getValue_asB64(),
            encrypt: (f = $2MzPv.Message.getBooleanField(msg, 4)) == null ? undefined : f,
            askOnEncrypt: (f = $2MzPv.Message.getBooleanField(msg, 5)) == null ? undefined : f,
            askOnDecrypt: (f = $2MzPv.Message.getBooleanField(msg, 6)) == null ? undefined : f,
            iv: msg.getIv_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CipherKeyValue}
 */ proto.CipherKeyValue.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CipherKeyValue;
    return proto.CipherKeyValue.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CipherKeyValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CipherKeyValue}
 */ proto.CipherKeyValue.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setKey(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setValue(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setEncrypt(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAskOnEncrypt(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAskOnDecrypt(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setIv(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CipherKeyValue.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CipherKeyValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CipherKeyValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CipherKeyValue.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBool(6, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBytes(7, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.CipherKeyValue.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string key = 2;
 * @return {string}
 */ proto.CipherKeyValue.prototype.getKey = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setKey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearKey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasKey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes value = 3;
 * @return {!(string|Uint8Array)}
 */ proto.CipherKeyValue.prototype.getValue = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes value = 3;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */ proto.CipherKeyValue.prototype.getValue_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getValue());
};
/**
 * optional bytes value = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */ proto.CipherKeyValue.prototype.getValue_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getValue());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setValue = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearValue = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasValue = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bool encrypt = 4;
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.getEncrypt = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setEncrypt = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearEncrypt = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasEncrypt = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bool ask_on_encrypt = 5;
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.getAskOnEncrypt = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setAskOnEncrypt = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearAskOnEncrypt = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasAskOnEncrypt = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bool ask_on_decrypt = 6;
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.getAskOnDecrypt = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setAskOnDecrypt = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearAskOnDecrypt = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasAskOnDecrypt = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bytes iv = 7;
 * @return {!(string|Uint8Array)}
 */ proto.CipherKeyValue.prototype.getIv = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes iv = 7;
 * This is a type-conversion wrapper around `getIv()`
 * @return {string}
 */ proto.CipherKeyValue.prototype.getIv_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getIv());
};
/**
 * optional bytes iv = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getIv()`
 * @return {!Uint8Array}
 */ proto.CipherKeyValue.prototype.getIv_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getIv());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.setIv = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipherKeyValue} returns this
 */ proto.CipherKeyValue.prototype.clearIv = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipherKeyValue.prototype.hasIv = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CipheredKeyValue.prototype.toObject = function(opt_includeInstance) {
        return proto.CipheredKeyValue.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CipheredKeyValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CipheredKeyValue.toObject = function(includeInstance, msg) {
        var f, obj = {
            value: msg.getValue_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CipheredKeyValue}
 */ proto.CipheredKeyValue.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CipheredKeyValue;
    return proto.CipheredKeyValue.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CipheredKeyValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CipheredKeyValue}
 */ proto.CipheredKeyValue.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CipheredKeyValue.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CipheredKeyValue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CipheredKeyValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CipheredKeyValue.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes value = 1;
 * @return {!(string|Uint8Array)}
 */ proto.CipheredKeyValue.prototype.getValue = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes value = 1;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */ proto.CipheredKeyValue.prototype.getValue_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getValue());
};
/**
 * optional bytes value = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */ proto.CipheredKeyValue.prototype.getValue_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getValue());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CipheredKeyValue} returns this
 */ proto.CipheredKeyValue.prototype.setValue = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CipheredKeyValue} returns this
 */ proto.CipheredKeyValue.prototype.clearValue = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CipheredKeyValue.prototype.hasValue = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.SignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.SignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            outputsCount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            inputsCount: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 3, "Bitcoin"),
            version: $2MzPv.Message.getFieldWithDefault(msg, 4, 1),
            lockTime: $2MzPv.Message.getFieldWithDefault(msg, 5, 0),
            expiry: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            overwintered: (f = $2MzPv.Message.getBooleanField(msg, 7)) == null ? undefined : f,
            versionGroupId: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            branchId: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SignTx}
 */ proto.SignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.SignTx;
    return proto.SignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SignTx}
 */ proto.SignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setOutputsCount(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setInputsCount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersion(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLockTime(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExpiry(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOverwintered(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setVersionGroupId(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBranchId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.SignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.SignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeUint32(6, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBool(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeUint32(10, f);
};
/**
 * required uint32 outputs_count = 1;
 * @return {number}
 */ proto.SignTx.prototype.getOutputsCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setOutputsCount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearOutputsCount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasOutputsCount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required uint32 inputs_count = 2;
 * @return {number}
 */ proto.SignTx.prototype.getInputsCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setInputsCount = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearInputsCount = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasInputsCount = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string coin_name = 3;
 * @return {string}
 */ proto.SignTx.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "Bitcoin");
};
/**
 * @param {string} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 version = 4;
 * @return {number}
 */ proto.SignTx.prototype.getVersion = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 1);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setVersion = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearVersion = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasVersion = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 lock_time = 5;
 * @return {number}
 */ proto.SignTx.prototype.getLockTime = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setLockTime = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearLockTime = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasLockTime = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional uint32 expiry = 6;
 * @return {number}
 */ proto.SignTx.prototype.getExpiry = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setExpiry = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearExpiry = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasExpiry = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bool overwintered = 7;
 * @return {boolean}
 */ proto.SignTx.prototype.getOverwintered = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setOverwintered = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearOverwintered = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasOverwintered = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 version_group_id = 8;
 * @return {number}
 */ proto.SignTx.prototype.getVersionGroupId = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setVersionGroupId = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearVersionGroupId = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasVersionGroupId = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional uint32 branch_id = 10;
 * @return {number}
 */ proto.SignTx.prototype.getBranchId = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.setBranchId = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignTx} returns this
 */ proto.SignTx.prototype.clearBranchId = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignTx.prototype.hasBranchId = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.TxRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            requestType: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            details: (f = msg.getDetails()) && $d4cdf7121546d3d6$exports.TxRequestDetailsType.toObject(includeInstance, f),
            serialized: (f = msg.getSerialized()) && $d4cdf7121546d3d6$exports.TxRequestSerializedType.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxRequest}
 */ proto.TxRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxRequest;
    return proto.TxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxRequest}
 */ proto.TxRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.RequestType} */ reader.readEnum();
                msg.setRequestType(value);
                break;
            case 2:
                var value = new $d4cdf7121546d3d6$exports.TxRequestDetailsType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.TxRequestDetailsType.deserializeBinaryFromReader);
                msg.setDetails(value);
                break;
            case 3:
                var value = new $d4cdf7121546d3d6$exports.TxRequestSerializedType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.TxRequestSerializedType.deserializeBinaryFromReader);
                msg.setSerialized(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.RequestType} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
    f = message.getDetails();
    if (f != null) writer.writeMessage(2, f, $d4cdf7121546d3d6$exports.TxRequestDetailsType.serializeBinaryToWriter);
    f = message.getSerialized();
    if (f != null) writer.writeMessage(3, f, $d4cdf7121546d3d6$exports.TxRequestSerializedType.serializeBinaryToWriter);
};
/**
 * optional RequestType request_type = 1;
 * @return {!proto.RequestType}
 */ proto.TxRequest.prototype.getRequestType = function() {
    return /** @type {!proto.RequestType} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.RequestType} value
 * @return {!proto.TxRequest} returns this
 */ proto.TxRequest.prototype.setRequestType = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.TxRequest} returns this
 */ proto.TxRequest.prototype.clearRequestType = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequest.prototype.hasRequestType = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional TxRequestDetailsType details = 2;
 * @return {?proto.TxRequestDetailsType}
 */ proto.TxRequest.prototype.getDetails = function() {
    return /** @type{?proto.TxRequestDetailsType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.TxRequestDetailsType, 2);
};
/**
 * @param {?proto.TxRequestDetailsType|undefined} value
 * @return {!proto.TxRequest} returns this
*/ proto.TxRequest.prototype.setDetails = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.TxRequest} returns this
 */ proto.TxRequest.prototype.clearDetails = function() {
    return this.setDetails(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequest.prototype.hasDetails = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional TxRequestSerializedType serialized = 3;
 * @return {?proto.TxRequestSerializedType}
 */ proto.TxRequest.prototype.getSerialized = function() {
    return /** @type{?proto.TxRequestSerializedType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.TxRequestSerializedType, 3);
};
/**
 * @param {?proto.TxRequestSerializedType|undefined} value
 * @return {!proto.TxRequest} returns this
*/ proto.TxRequest.prototype.setSerialized = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.TxRequest} returns this
 */ proto.TxRequest.prototype.clearSerialized = function() {
    return this.setSerialized(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxRequest.prototype.hasSerialized = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.TxAck.prototype.toObject = function(opt_includeInstance) {
        return proto.TxAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.TxAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            tx: (f = msg.getTx()) && $d4cdf7121546d3d6$exports.TransactionType.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.TxAck}
 */ proto.TxAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.TxAck;
    return proto.TxAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.TxAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.TxAck}
 */ proto.TxAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.TransactionType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.TransactionType.deserializeBinaryFromReader);
                msg.setTx(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.TxAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.TxAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.TxAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.TxAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTx();
    if (f != null) writer.writeMessage(1, f, $d4cdf7121546d3d6$exports.TransactionType.serializeBinaryToWriter);
};
/**
 * optional TransactionType tx = 1;
 * @return {?proto.TransactionType}
 */ proto.TxAck.prototype.getTx = function() {
    return /** @type{?proto.TransactionType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.TransactionType, 1);
};
/**
 * @param {?proto.TransactionType|undefined} value
 * @return {!proto.TxAck} returns this
*/ proto.TxAck.prototype.setTx = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.TxAck} returns this
 */ proto.TxAck.prototype.clearTx = function() {
    return this.setTx(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.TxAck.prototype.hasTx = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RawTxAck.prototype.toObject = function(opt_includeInstance) {
        return proto.RawTxAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RawTxAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RawTxAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            tx: (f = msg.getTx()) && $d4cdf7121546d3d6$exports.RawTransactionType.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RawTxAck}
 */ proto.RawTxAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RawTxAck;
    return proto.RawTxAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RawTxAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RawTxAck}
 */ proto.RawTxAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.RawTransactionType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.RawTransactionType.deserializeBinaryFromReader);
                msg.setTx(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RawTxAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RawTxAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RawTxAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RawTxAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTx();
    if (f != null) writer.writeMessage(1, f, $d4cdf7121546d3d6$exports.RawTransactionType.serializeBinaryToWriter);
};
/**
 * optional RawTransactionType tx = 1;
 * @return {?proto.RawTransactionType}
 */ proto.RawTxAck.prototype.getTx = function() {
    return /** @type{?proto.RawTransactionType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.RawTransactionType, 1);
};
/**
 * @param {?proto.RawTransactionType|undefined} value
 * @return {!proto.RawTxAck} returns this
*/ proto.RawTxAck.prototype.setTx = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.RawTxAck} returns this
 */ proto.RawTxAck.prototype.clearTx = function() {
    return this.setTx(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RawTxAck.prototype.hasTx = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.SignIdentity.prototype.toObject = function(opt_includeInstance) {
        return proto.SignIdentity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SignIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignIdentity.toObject = function(includeInstance, msg) {
        var f, obj = {
            identity: (f = msg.getIdentity()) && $d4cdf7121546d3d6$exports.IdentityType.toObject(includeInstance, f),
            challengeHidden: msg.getChallengeHidden_asB64(),
            challengeVisual: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            ecdsaCurveName: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SignIdentity}
 */ proto.SignIdentity.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.SignIdentity;
    return proto.SignIdentity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SignIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SignIdentity}
 */ proto.SignIdentity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.IdentityType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.IdentityType.deserializeBinaryFromReader);
                msg.setIdentity(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setChallengeHidden(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setChallengeVisual(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setEcdsaCurveName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.SignIdentity.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.SignIdentity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SignIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignIdentity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getIdentity();
    if (f != null) writer.writeMessage(1, f, $d4cdf7121546d3d6$exports.IdentityType.serializeBinaryToWriter);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional IdentityType identity = 1;
 * @return {?proto.IdentityType}
 */ proto.SignIdentity.prototype.getIdentity = function() {
    return /** @type{?proto.IdentityType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.IdentityType, 1);
};
/**
 * @param {?proto.IdentityType|undefined} value
 * @return {!proto.SignIdentity} returns this
*/ proto.SignIdentity.prototype.setIdentity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.clearIdentity = function() {
    return this.setIdentity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignIdentity.prototype.hasIdentity = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes challenge_hidden = 2;
 * @return {!(string|Uint8Array)}
 */ proto.SignIdentity.prototype.getChallengeHidden = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes challenge_hidden = 2;
 * This is a type-conversion wrapper around `getChallengeHidden()`
 * @return {string}
 */ proto.SignIdentity.prototype.getChallengeHidden_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getChallengeHidden());
};
/**
 * optional bytes challenge_hidden = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChallengeHidden()`
 * @return {!Uint8Array}
 */ proto.SignIdentity.prototype.getChallengeHidden_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getChallengeHidden());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.setChallengeHidden = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.clearChallengeHidden = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignIdentity.prototype.hasChallengeHidden = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string challenge_visual = 3;
 * @return {string}
 */ proto.SignIdentity.prototype.getChallengeVisual = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.setChallengeVisual = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.clearChallengeVisual = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignIdentity.prototype.hasChallengeVisual = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string ecdsa_curve_name = 4;
 * @return {string}
 */ proto.SignIdentity.prototype.getEcdsaCurveName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.setEcdsaCurveName = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignIdentity} returns this
 */ proto.SignIdentity.prototype.clearEcdsaCurveName = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignIdentity.prototype.hasEcdsaCurveName = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.SignedIdentity.prototype.toObject = function(opt_includeInstance) {
        return proto.SignedIdentity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SignedIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignedIdentity.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            publicKey: msg.getPublicKey_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SignedIdentity}
 */ proto.SignedIdentity.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.SignedIdentity;
    return proto.SignedIdentity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SignedIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SignedIdentity}
 */ proto.SignedIdentity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.SignedIdentity.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.SignedIdentity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SignedIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SignedIdentity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.SignedIdentity.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignedIdentity.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes public_key = 2;
 * @return {!(string|Uint8Array)}
 */ proto.SignedIdentity.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes public_key = 2;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.SignedIdentity.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.SignedIdentity.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignedIdentity.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes signature = 3;
 * @return {!(string|Uint8Array)}
 */ proto.SignedIdentity.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes signature = 3;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.SignedIdentity.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.SignedIdentity.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.SignedIdentity} returns this
 */ proto.SignedIdentity.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.SignedIdentity.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.ApplyPolicies.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ApplyPolicies.prototype.toObject = function(opt_includeInstance) {
        return proto.ApplyPolicies.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ApplyPolicies} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ApplyPolicies.toObject = function(includeInstance, msg) {
        var f, obj = {
            policyList: $2MzPv.Message.toObjectList(msg.getPolicyList(), $d4cdf7121546d3d6$exports.PolicyType.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ApplyPolicies}
 */ proto.ApplyPolicies.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ApplyPolicies;
    return proto.ApplyPolicies.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ApplyPolicies} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ApplyPolicies}
 */ proto.ApplyPolicies.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $d4cdf7121546d3d6$exports.PolicyType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.PolicyType.deserializeBinaryFromReader);
                msg.addPolicy(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ApplyPolicies.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ApplyPolicies.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ApplyPolicies} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ApplyPolicies.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPolicyList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $d4cdf7121546d3d6$exports.PolicyType.serializeBinaryToWriter);
};
/**
 * repeated PolicyType policy = 1;
 * @return {!Array<!proto.PolicyType>}
 */ proto.ApplyPolicies.prototype.getPolicyList = function() {
    return /** @type{!Array<!proto.PolicyType>} */ $2MzPv.Message.getRepeatedWrapperField(this, $d4cdf7121546d3d6$exports.PolicyType, 1);
};
/**
 * @param {!Array<!proto.PolicyType>} value
 * @return {!proto.ApplyPolicies} returns this
*/ proto.ApplyPolicies.prototype.setPolicyList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.PolicyType=} opt_value
 * @param {number=} opt_index
 * @return {!proto.PolicyType}
 */ proto.ApplyPolicies.prototype.addPolicy = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.PolicyType, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ApplyPolicies} returns this
 */ proto.ApplyPolicies.prototype.clearPolicyList = function() {
    return this.setPolicyList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.FlashHash.prototype.toObject = function(opt_includeInstance) {
        return proto.FlashHash.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FlashHash} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashHash.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            length: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            challenge: msg.getChallenge_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FlashHash}
 */ proto.FlashHash.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.FlashHash;
    return proto.FlashHash.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FlashHash} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FlashHash}
 */ proto.FlashHash.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLength(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setChallenge(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.FlashHash.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.FlashHash.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FlashHash} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashHash.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * optional uint32 address = 1;
 * @return {number}
 */ proto.FlashHash.prototype.getAddress = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashHash.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 length = 2;
 * @return {number}
 */ proto.FlashHash.prototype.getLength = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.setLength = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.clearLength = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashHash.prototype.hasLength = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes challenge = 3;
 * @return {!(string|Uint8Array)}
 */ proto.FlashHash.prototype.getChallenge = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes challenge = 3;
 * This is a type-conversion wrapper around `getChallenge()`
 * @return {string}
 */ proto.FlashHash.prototype.getChallenge_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getChallenge());
};
/**
 * optional bytes challenge = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChallenge()`
 * @return {!Uint8Array}
 */ proto.FlashHash.prototype.getChallenge_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getChallenge());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.setChallenge = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashHash} returns this
 */ proto.FlashHash.prototype.clearChallenge = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashHash.prototype.hasChallenge = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.FlashWrite.prototype.toObject = function(opt_includeInstance) {
        return proto.FlashWrite.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FlashWrite} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashWrite.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            data: msg.getData_asB64(),
            erase: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FlashWrite}
 */ proto.FlashWrite.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.FlashWrite;
    return proto.FlashWrite.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FlashWrite} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FlashWrite}
 */ proto.FlashWrite.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setData(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setErase(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.FlashWrite.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.FlashWrite.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FlashWrite} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashWrite.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * optional uint32 address = 1;
 * @return {number}
 */ proto.FlashWrite.prototype.getAddress = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashWrite.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes data = 2;
 * @return {!(string|Uint8Array)}
 */ proto.FlashWrite.prototype.getData = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes data = 2;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */ proto.FlashWrite.prototype.getData_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getData());
};
/**
 * optional bytes data = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */ proto.FlashWrite.prototype.getData_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.setData = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.clearData = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashWrite.prototype.hasData = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool erase = 3;
 * @return {boolean}
 */ proto.FlashWrite.prototype.getErase = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.setErase = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashWrite} returns this
 */ proto.FlashWrite.prototype.clearErase = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashWrite.prototype.hasErase = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.FlashHashResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.FlashHashResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FlashHashResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashHashResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            data: msg.getData_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FlashHashResponse}
 */ proto.FlashHashResponse.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.FlashHashResponse;
    return proto.FlashHashResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FlashHashResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FlashHashResponse}
 */ proto.FlashHashResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.FlashHashResponse.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.FlashHashResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FlashHashResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FlashHashResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */ proto.FlashHashResponse.prototype.getData = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */ proto.FlashHashResponse.prototype.getData_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getData());
};
/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */ proto.FlashHashResponse.prototype.getData_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FlashHashResponse} returns this
 */ proto.FlashHashResponse.prototype.setData = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FlashHashResponse} returns this
 */ proto.FlashHashResponse.prototype.clearData = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FlashHashResponse.prototype.hasData = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkFlashDump.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkFlashDump.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkFlashDump} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFlashDump.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            length: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkFlashDump}
 */ proto.DebugLinkFlashDump.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkFlashDump;
    return proto.DebugLinkFlashDump.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkFlashDump} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkFlashDump}
 */ proto.DebugLinkFlashDump.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLength(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkFlashDump.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkFlashDump.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkFlashDump} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFlashDump.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
};
/**
 * optional uint32 address = 1;
 * @return {number}
 */ proto.DebugLinkFlashDump.prototype.getAddress = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.DebugLinkFlashDump} returns this
 */ proto.DebugLinkFlashDump.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkFlashDump} returns this
 */ proto.DebugLinkFlashDump.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkFlashDump.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 length = 2;
 * @return {number}
 */ proto.DebugLinkFlashDump.prototype.getLength = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.DebugLinkFlashDump} returns this
 */ proto.DebugLinkFlashDump.prototype.setLength = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkFlashDump} returns this
 */ proto.DebugLinkFlashDump.prototype.clearLength = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkFlashDump.prototype.hasLength = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkFlashDumpResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkFlashDumpResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkFlashDumpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFlashDumpResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            data: msg.getData_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkFlashDumpResponse}
 */ proto.DebugLinkFlashDumpResponse.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkFlashDumpResponse;
    return proto.DebugLinkFlashDumpResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkFlashDumpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkFlashDumpResponse}
 */ proto.DebugLinkFlashDumpResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkFlashDumpResponse.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkFlashDumpResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkFlashDumpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFlashDumpResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes data = 1;
 * @return {!(string|Uint8Array)}
 */ proto.DebugLinkFlashDumpResponse.prototype.getData = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes data = 1;
 * This is a type-conversion wrapper around `getData()`
 * @return {string}
 */ proto.DebugLinkFlashDumpResponse.prototype.getData_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getData());
};
/**
 * optional bytes data = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getData()`
 * @return {!Uint8Array}
 */ proto.DebugLinkFlashDumpResponse.prototype.getData_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getData());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DebugLinkFlashDumpResponse} returns this
 */ proto.DebugLinkFlashDumpResponse.prototype.setData = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkFlashDumpResponse} returns this
 */ proto.DebugLinkFlashDumpResponse.prototype.clearData = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkFlashDumpResponse.prototype.hasData = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.SoftReset.prototype.toObject = function(opt_includeInstance) {
        return proto.SoftReset.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.SoftReset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SoftReset.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.SoftReset}
 */ proto.SoftReset.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.SoftReset;
    return proto.SoftReset.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.SoftReset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.SoftReset}
 */ proto.SoftReset.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.SoftReset.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.SoftReset.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.SoftReset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.SoftReset.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.FirmwareErase.prototype.toObject = function(opt_includeInstance) {
        return proto.FirmwareErase.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FirmwareErase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FirmwareErase.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FirmwareErase}
 */ proto.FirmwareErase.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.FirmwareErase;
    return proto.FirmwareErase.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FirmwareErase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FirmwareErase}
 */ proto.FirmwareErase.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.FirmwareErase.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.FirmwareErase.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FirmwareErase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FirmwareErase.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.FirmwareUpload.prototype.toObject = function(opt_includeInstance) {
        return proto.FirmwareUpload.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.FirmwareUpload} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FirmwareUpload.toObject = function(includeInstance, msg) {
        var f, obj = {
            payloadHash: msg.getPayloadHash_asB64(),
            payload: msg.getPayload_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.FirmwareUpload}
 */ proto.FirmwareUpload.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.FirmwareUpload;
    return proto.FirmwareUpload.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.FirmwareUpload} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.FirmwareUpload}
 */ proto.FirmwareUpload.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPayloadHash(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPayload(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.FirmwareUpload.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.FirmwareUpload.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.FirmwareUpload} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.FirmwareUpload.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * required bytes payload_hash = 1;
 * @return {!(string|Uint8Array)}
 */ proto.FirmwareUpload.prototype.getPayloadHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * required bytes payload_hash = 1;
 * This is a type-conversion wrapper around `getPayloadHash()`
 * @return {string}
 */ proto.FirmwareUpload.prototype.getPayloadHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPayloadHash());
};
/**
 * required bytes payload_hash = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayloadHash()`
 * @return {!Uint8Array}
 */ proto.FirmwareUpload.prototype.getPayloadHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPayloadHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FirmwareUpload} returns this
 */ proto.FirmwareUpload.prototype.setPayloadHash = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FirmwareUpload} returns this
 */ proto.FirmwareUpload.prototype.clearPayloadHash = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FirmwareUpload.prototype.hasPayloadHash = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required bytes payload = 2;
 * @return {!(string|Uint8Array)}
 */ proto.FirmwareUpload.prototype.getPayload = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes payload = 2;
 * This is a type-conversion wrapper around `getPayload()`
 * @return {string}
 */ proto.FirmwareUpload.prototype.getPayload_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPayload());
};
/**
 * required bytes payload = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPayload()`
 * @return {!Uint8Array}
 */ proto.FirmwareUpload.prototype.getPayload_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPayload());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.FirmwareUpload} returns this
 */ proto.FirmwareUpload.prototype.setPayload = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.FirmwareUpload} returns this
 */ proto.FirmwareUpload.prototype.clearPayload = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.FirmwareUpload.prototype.hasPayload = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkDecision.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkDecision.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkDecision} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkDecision.toObject = function(includeInstance, msg) {
        var f, obj = {
            yesNo: (f = $2MzPv.Message.getBooleanField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkDecision}
 */ proto.DebugLinkDecision.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkDecision;
    return proto.DebugLinkDecision.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkDecision} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkDecision}
 */ proto.DebugLinkDecision.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setYesNo(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkDecision.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkDecision.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkDecision} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkDecision.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
};
/**
 * required bool yes_no = 1;
 * @return {boolean}
 */ proto.DebugLinkDecision.prototype.getYesNo = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.DebugLinkDecision} returns this
 */ proto.DebugLinkDecision.prototype.setYesNo = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkDecision} returns this
 */ proto.DebugLinkDecision.prototype.clearYesNo = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkDecision.prototype.hasYesNo = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkGetState.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkGetState.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkGetState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkGetState.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkGetState}
 */ proto.DebugLinkGetState.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkGetState;
    return proto.DebugLinkGetState.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkGetState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkGetState}
 */ proto.DebugLinkGetState.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkGetState.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkGetState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkGetState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkGetState.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkState.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkState.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkState.toObject = function(includeInstance, msg) {
        var f, obj = {
            layout: msg.getLayout_asB64(),
            pin: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            matrix: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            mnemonic: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            node: (f = msg.getNode()) && $d4cdf7121546d3d6$exports.HDNodeType.toObject(includeInstance, f),
            passphraseProtection: (f = $2MzPv.Message.getBooleanField(msg, 6)) == null ? undefined : f,
            resetWord: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            resetEntropy: msg.getResetEntropy_asB64(),
            recoveryFakeWord: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f,
            recoveryWordPos: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f,
            recoveryCipher: (f = $2MzPv.Message.getField(msg, 11)) == null ? undefined : f,
            recoveryAutoCompletedWord: (f = $2MzPv.Message.getField(msg, 12)) == null ? undefined : f,
            firmwareHash: msg.getFirmwareHash_asB64(),
            storageHash: msg.getStorageHash_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkState}
 */ proto.DebugLinkState.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkState;
    return proto.DebugLinkState.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkState}
 */ proto.DebugLinkState.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setLayout(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMatrix(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setMnemonic(value);
                break;
            case 5:
                var value = new $d4cdf7121546d3d6$exports.HDNodeType;
                reader.readMessage(value, $d4cdf7121546d3d6$exports.HDNodeType.deserializeBinaryFromReader);
                msg.setNode(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPassphraseProtection(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setResetWord(value);
                break;
            case 8:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setResetEntropy(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setRecoveryFakeWord(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRecoveryWordPos(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setRecoveryCipher(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setRecoveryAutoCompletedWord(value);
                break;
            case 13:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setFirmwareHash(value);
                break;
            case 14:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setStorageHash(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkState.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkState.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = message.getNode();
    if (f != null) writer.writeMessage(5, f, $d4cdf7121546d3d6$exports.HDNodeType.serializeBinaryToWriter);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBool(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeBytes(8, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeString(9, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeUint32(10, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 11);
    if (f != null) writer.writeString(11, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeString(12, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 13);
    if (f != null) writer.writeBytes(13, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 14);
    if (f != null) writer.writeBytes(14, f);
};
/**
 * optional bytes layout = 1;
 * @return {!(string|Uint8Array)}
 */ proto.DebugLinkState.prototype.getLayout = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes layout = 1;
 * This is a type-conversion wrapper around `getLayout()`
 * @return {string}
 */ proto.DebugLinkState.prototype.getLayout_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getLayout());
};
/**
 * optional bytes layout = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLayout()`
 * @return {!Uint8Array}
 */ proto.DebugLinkState.prototype.getLayout_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getLayout());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setLayout = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearLayout = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasLayout = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string pin = 2;
 * @return {string}
 */ proto.DebugLinkState.prototype.getPin = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setPin = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearPin = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasPin = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string matrix = 3;
 * @return {string}
 */ proto.DebugLinkState.prototype.getMatrix = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setMatrix = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearMatrix = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasMatrix = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string mnemonic = 4;
 * @return {string}
 */ proto.DebugLinkState.prototype.getMnemonic = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setMnemonic = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearMnemonic = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasMnemonic = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional HDNodeType node = 5;
 * @return {?proto.HDNodeType}
 */ proto.DebugLinkState.prototype.getNode = function() {
    return /** @type{?proto.HDNodeType} */ $2MzPv.Message.getWrapperField(this, $d4cdf7121546d3d6$exports.HDNodeType, 5);
};
/**
 * @param {?proto.HDNodeType|undefined} value
 * @return {!proto.DebugLinkState} returns this
*/ proto.DebugLinkState.prototype.setNode = function(value) {
    return $2MzPv.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearNode = function() {
    return this.setNode(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasNode = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bool passphrase_protection = 6;
 * @return {boolean}
 */ proto.DebugLinkState.prototype.getPassphraseProtection = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setPassphraseProtection = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearPassphraseProtection = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasPassphraseProtection = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string reset_word = 7;
 * @return {string}
 */ proto.DebugLinkState.prototype.getResetWord = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setResetWord = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearResetWord = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasResetWord = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional bytes reset_entropy = 8;
 * @return {!(string|Uint8Array)}
 */ proto.DebugLinkState.prototype.getResetEntropy = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * optional bytes reset_entropy = 8;
 * This is a type-conversion wrapper around `getResetEntropy()`
 * @return {string}
 */ proto.DebugLinkState.prototype.getResetEntropy_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getResetEntropy());
};
/**
 * optional bytes reset_entropy = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getResetEntropy()`
 * @return {!Uint8Array}
 */ proto.DebugLinkState.prototype.getResetEntropy_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getResetEntropy());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setResetEntropy = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearResetEntropy = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasResetEntropy = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional string recovery_fake_word = 9;
 * @return {string}
 */ proto.DebugLinkState.prototype.getRecoveryFakeWord = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setRecoveryFakeWord = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearRecoveryFakeWord = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasRecoveryFakeWord = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional uint32 recovery_word_pos = 10;
 * @return {number}
 */ proto.DebugLinkState.prototype.getRecoveryWordPos = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setRecoveryWordPos = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearRecoveryWordPos = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasRecoveryWordPos = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional string recovery_cipher = 11;
 * @return {string}
 */ proto.DebugLinkState.prototype.getRecoveryCipher = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setRecoveryCipher = function(value) {
    return $2MzPv.Message.setField(this, 11, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearRecoveryCipher = function() {
    return $2MzPv.Message.setField(this, 11, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasRecoveryCipher = function() {
    return $2MzPv.Message.getField(this, 11) != null;
};
/**
 * optional string recovery_auto_completed_word = 12;
 * @return {string}
 */ proto.DebugLinkState.prototype.getRecoveryAutoCompletedWord = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setRecoveryAutoCompletedWord = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearRecoveryAutoCompletedWord = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasRecoveryAutoCompletedWord = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional bytes firmware_hash = 13;
 * @return {!(string|Uint8Array)}
 */ proto.DebugLinkState.prototype.getFirmwareHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 13, "");
};
/**
 * optional bytes firmware_hash = 13;
 * This is a type-conversion wrapper around `getFirmwareHash()`
 * @return {string}
 */ proto.DebugLinkState.prototype.getFirmwareHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getFirmwareHash());
};
/**
 * optional bytes firmware_hash = 13;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFirmwareHash()`
 * @return {!Uint8Array}
 */ proto.DebugLinkState.prototype.getFirmwareHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getFirmwareHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setFirmwareHash = function(value) {
    return $2MzPv.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearFirmwareHash = function() {
    return $2MzPv.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasFirmwareHash = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
/**
 * optional bytes storage_hash = 14;
 * @return {!(string|Uint8Array)}
 */ proto.DebugLinkState.prototype.getStorageHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 14, "");
};
/**
 * optional bytes storage_hash = 14;
 * This is a type-conversion wrapper around `getStorageHash()`
 * @return {string}
 */ proto.DebugLinkState.prototype.getStorageHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getStorageHash());
};
/**
 * optional bytes storage_hash = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getStorageHash()`
 * @return {!Uint8Array}
 */ proto.DebugLinkState.prototype.getStorageHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getStorageHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.setStorageHash = function(value) {
    return $2MzPv.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkState} returns this
 */ proto.DebugLinkState.prototype.clearStorageHash = function() {
    return $2MzPv.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkState.prototype.hasStorageHash = function() {
    return $2MzPv.Message.getField(this, 14) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkStop.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkStop.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkStop} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkStop.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkStop}
 */ proto.DebugLinkStop.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkStop;
    return proto.DebugLinkStop.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkStop} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkStop}
 */ proto.DebugLinkStop.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkStop.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkStop.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkStop} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkStop.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkLog.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkLog.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkLog} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkLog.toObject = function(includeInstance, msg) {
        var f, obj = {
            level: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            bucket: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            text: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkLog}
 */ proto.DebugLinkLog.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkLog;
    return proto.DebugLinkLog.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkLog} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkLog}
 */ proto.DebugLinkLog.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLevel(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setBucket(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setText(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkLog.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkLog.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkLog} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkLog.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
};
/**
 * optional uint32 level = 1;
 * @return {number}
 */ proto.DebugLinkLog.prototype.getLevel = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.setLevel = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.clearLevel = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkLog.prototype.hasLevel = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string bucket = 2;
 * @return {string}
 */ proto.DebugLinkLog.prototype.getBucket = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.setBucket = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.clearBucket = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkLog.prototype.hasBucket = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string text = 3;
 * @return {string}
 */ proto.DebugLinkLog.prototype.getText = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.setText = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.DebugLinkLog} returns this
 */ proto.DebugLinkLog.prototype.clearText = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.DebugLinkLog.prototype.hasText = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.DebugLinkFillConfig.prototype.toObject = function(opt_includeInstance) {
        return proto.DebugLinkFillConfig.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.DebugLinkFillConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFillConfig.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.DebugLinkFillConfig}
 */ proto.DebugLinkFillConfig.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.DebugLinkFillConfig;
    return proto.DebugLinkFillConfig.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.DebugLinkFillConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.DebugLinkFillConfig}
 */ proto.DebugLinkFillConfig.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.DebugLinkFillConfig.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.DebugLinkFillConfig.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.DebugLinkFillConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.DebugLinkFillConfig.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ChangeWipeCode.prototype.toObject = function(opt_includeInstance) {
        return proto.ChangeWipeCode.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ChangeWipeCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ChangeWipeCode.toObject = function(includeInstance, msg) {
        var f, obj = {
            remove: (f = $2MzPv.Message.getBooleanField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ChangeWipeCode}
 */ proto.ChangeWipeCode.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ChangeWipeCode;
    return proto.ChangeWipeCode.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ChangeWipeCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ChangeWipeCode}
 */ proto.ChangeWipeCode.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRemove(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ChangeWipeCode.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ChangeWipeCode.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ChangeWipeCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ChangeWipeCode.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBool(1, f);
};
/**
 * optional bool remove = 1;
 * @return {boolean}
 */ proto.ChangeWipeCode.prototype.getRemove = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ChangeWipeCode} returns this
 */ proto.ChangeWipeCode.prototype.setRemove = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ChangeWipeCode} returns this
 */ proto.ChangeWipeCode.prototype.clearRemove = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ChangeWipeCode.prototype.hasRemove = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * @enum {number}
 */ proto.MessageType = {
    MESSAGETYPE_INITIALIZE: 0,
    MESSAGETYPE_PING: 1,
    MESSAGETYPE_SUCCESS: 2,
    MESSAGETYPE_FAILURE: 3,
    MESSAGETYPE_CHANGEPIN: 4,
    MESSAGETYPE_WIPEDEVICE: 5,
    MESSAGETYPE_FIRMWAREERASE: 6,
    MESSAGETYPE_FIRMWAREUPLOAD: 7,
    MESSAGETYPE_GETENTROPY: 9,
    MESSAGETYPE_ENTROPY: 10,
    MESSAGETYPE_GETPUBLICKEY: 11,
    MESSAGETYPE_PUBLICKEY: 12,
    MESSAGETYPE_LOADDEVICE: 13,
    MESSAGETYPE_RESETDEVICE: 14,
    MESSAGETYPE_SIGNTX: 15,
    MESSAGETYPE_FEATURES: 17,
    MESSAGETYPE_PINMATRIXREQUEST: 18,
    MESSAGETYPE_PINMATRIXACK: 19,
    MESSAGETYPE_CANCEL: 20,
    MESSAGETYPE_TXREQUEST: 21,
    MESSAGETYPE_TXACK: 22,
    MESSAGETYPE_CIPHERKEYVALUE: 23,
    MESSAGETYPE_CLEARSESSION: 24,
    MESSAGETYPE_APPLYSETTINGS: 25,
    MESSAGETYPE_BUTTONREQUEST: 26,
    MESSAGETYPE_BUTTONACK: 27,
    MESSAGETYPE_GETADDRESS: 29,
    MESSAGETYPE_ADDRESS: 30,
    MESSAGETYPE_ENTROPYREQUEST: 35,
    MESSAGETYPE_ENTROPYACK: 36,
    MESSAGETYPE_SIGNMESSAGE: 38,
    MESSAGETYPE_VERIFYMESSAGE: 39,
    MESSAGETYPE_MESSAGESIGNATURE: 40,
    MESSAGETYPE_PASSPHRASEREQUEST: 41,
    MESSAGETYPE_PASSPHRASEACK: 42,
    MESSAGETYPE_RECOVERYDEVICE: 45,
    MESSAGETYPE_WORDREQUEST: 46,
    MESSAGETYPE_WORDACK: 47,
    MESSAGETYPE_CIPHEREDKEYVALUE: 48,
    MESSAGETYPE_ENCRYPTMESSAGE: 49,
    MESSAGETYPE_ENCRYPTEDMESSAGE: 50,
    MESSAGETYPE_DECRYPTMESSAGE: 51,
    MESSAGETYPE_DECRYPTEDMESSAGE: 52,
    MESSAGETYPE_SIGNIDENTITY: 53,
    MESSAGETYPE_SIGNEDIDENTITY: 54,
    MESSAGETYPE_GETFEATURES: 55,
    MESSAGETYPE_ETHEREUMGETADDRESS: 56,
    MESSAGETYPE_ETHEREUMADDRESS: 57,
    MESSAGETYPE_ETHEREUMSIGNTX: 58,
    MESSAGETYPE_ETHEREUMTXREQUEST: 59,
    MESSAGETYPE_ETHEREUMTXACK: 60,
    MESSAGETYPE_CHARACTERREQUEST: 80,
    MESSAGETYPE_CHARACTERACK: 81,
    MESSAGETYPE_RAWTXACK: 82,
    MESSAGETYPE_APPLYPOLICIES: 83,
    MESSAGETYPE_FLASHHASH: 84,
    MESSAGETYPE_FLASHWRITE: 85,
    MESSAGETYPE_FLASHHASHRESPONSE: 86,
    MESSAGETYPE_DEBUGLINKFLASHDUMP: 87,
    MESSAGETYPE_DEBUGLINKFLASHDUMPRESPONSE: 88,
    MESSAGETYPE_SOFTRESET: 89,
    MESSAGETYPE_DEBUGLINKDECISION: 100,
    MESSAGETYPE_DEBUGLINKGETSTATE: 101,
    MESSAGETYPE_DEBUGLINKSTATE: 102,
    MESSAGETYPE_DEBUGLINKSTOP: 103,
    MESSAGETYPE_DEBUGLINKLOG: 104,
    MESSAGETYPE_DEBUGLINKFILLCONFIG: 105,
    MESSAGETYPE_GETCOINTABLE: 106,
    MESSAGETYPE_COINTABLE: 107,
    MESSAGETYPE_ETHEREUMSIGNMESSAGE: 108,
    MESSAGETYPE_ETHEREUMVERIFYMESSAGE: 109,
    MESSAGETYPE_ETHEREUMMESSAGESIGNATURE: 110,
    MESSAGETYPE_CHANGEWIPECODE: 111,
    MESSAGETYPE_ETHEREUMSIGNTYPEDHASH: 112,
    MESSAGETYPE_ETHEREUMTYPEDDATASIGNATURE: 113,
    MESSAGETYPE_ETHEREUM712TYPESVALUES: 114,
    MESSAGETYPE_RIPPLEGETADDRESS: 400,
    MESSAGETYPE_RIPPLEADDRESS: 401,
    MESSAGETYPE_RIPPLESIGNTX: 402,
    MESSAGETYPE_RIPPLESIGNEDTX: 403,
    MESSAGETYPE_THORCHAINGETADDRESS: 500,
    MESSAGETYPE_THORCHAINADDRESS: 501,
    MESSAGETYPE_THORCHAINSIGNTX: 502,
    MESSAGETYPE_THORCHAINMSGREQUEST: 503,
    MESSAGETYPE_THORCHAINMSGACK: 504,
    MESSAGETYPE_THORCHAINSIGNEDTX: 505,
    MESSAGETYPE_EOSGETPUBLICKEY: 600,
    MESSAGETYPE_EOSPUBLICKEY: 601,
    MESSAGETYPE_EOSSIGNTX: 602,
    MESSAGETYPE_EOSTXACTIONREQUEST: 603,
    MESSAGETYPE_EOSTXACTIONACK: 604,
    MESSAGETYPE_EOSSIGNEDTX: 605,
    MESSAGETYPE_NANOGETADDRESS: 700,
    MESSAGETYPE_NANOADDRESS: 701,
    MESSAGETYPE_NANOSIGNTX: 702,
    MESSAGETYPE_NANOSIGNEDTX: 703,
    MESSAGETYPE_BINANCEGETADDRESS: 800,
    MESSAGETYPE_BINANCEADDRESS: 801,
    MESSAGETYPE_BINANCEGETPUBLICKEY: 802,
    MESSAGETYPE_BINANCEPUBLICKEY: 803,
    MESSAGETYPE_BINANCESIGNTX: 804,
    MESSAGETYPE_BINANCETXREQUEST: 805,
    MESSAGETYPE_BINANCETRANSFERMSG: 806,
    MESSAGETYPE_BINANCEORDERMSG: 807,
    MESSAGETYPE_BINANCECANCELMSG: 808,
    MESSAGETYPE_BINANCESIGNEDTX: 809,
    MESSAGETYPE_COSMOSGETADDRESS: 900,
    MESSAGETYPE_COSMOSADDRESS: 901,
    MESSAGETYPE_COSMOSSIGNTX: 902,
    MESSAGETYPE_COSMOSMSGREQUEST: 903,
    MESSAGETYPE_COSMOSMSGACK: 904,
    MESSAGETYPE_COSMOSSIGNEDTX: 905,
    MESSAGETYPE_COSMOSMSGDELEGATE: 906,
    MESSAGETYPE_COSMOSMSGUNDELEGATE: 907,
    MESSAGETYPE_COSMOSMSGREDELEGATE: 908,
    MESSAGETYPE_COSMOSMSGREWARDS: 909,
    MESSAGETYPE_COSMOSMSGIBCTRANSFER: 910,
    MESSAGETYPE_TENDERMINTGETADDRESS: 1000,
    MESSAGETYPE_TENDERMINTADDRESS: 1001,
    MESSAGETYPE_TENDERMINTSIGNTX: 1002,
    MESSAGETYPE_TENDERMINTMSGREQUEST: 1003,
    MESSAGETYPE_TENDERMINTMSGACK: 1004,
    MESSAGETYPE_TENDERMINTMSGSEND: 1005,
    MESSAGETYPE_TENDERMINTSIGNEDTX: 1006,
    MESSAGETYPE_TENDERMINTMSGDELEGATE: 1007,
    MESSAGETYPE_TENDERMINTMSGUNDELEGATE: 1008,
    MESSAGETYPE_TENDERMINTMSGREDELEGATE: 1009,
    MESSAGETYPE_TENDERMINTMSGREWARDS: 1010,
    MESSAGETYPE_TENDERMINTMSGIBCTRANSFER: 1011,
    MESSAGETYPE_OSMOSISGETADDRESS: 1100,
    MESSAGETYPE_OSMOSISADDRESS: 1101,
    MESSAGETYPE_OSMOSISSIGNTX: 1102,
    MESSAGETYPE_OSMOSISMSGREQUEST: 1103,
    MESSAGETYPE_OSMOSISMSGACK: 1104,
    MESSAGETYPE_OSMOSISMSGSEND: 1105,
    MESSAGETYPE_OSMOSISMSGDELEGATE: 1106,
    MESSAGETYPE_OSMOSISMSGUNDELEGATE: 1107,
    MESSAGETYPE_OSMOSISMSGREDELEGATE: 1108,
    MESSAGETYPE_OSMOSISMSGREWARDS: 1109,
    MESSAGETYPE_OSMOSISMSGLPADD: 1110,
    MESSAGETYPE_OSMOSISMSGLPREMOVE: 1111,
    MESSAGETYPE_OSMOSISMSGLPSTAKE: 1112,
    MESSAGETYPE_OSMOSISMSGLPUNSTAKE: 1113,
    MESSAGETYPE_OSMOSISMSGIBCTRANSFER: 1114,
    MESSAGETYPE_OSMOSISMSGSWAP: 1115,
    MESSAGETYPE_OSMOSISSIGNEDTX: 1116,
    MESSAGETYPE_MAYACHAINGETADDRESS: 1200,
    MESSAGETYPE_MAYACHAINADDRESS: 1201,
    MESSAGETYPE_MAYACHAINSIGNTX: 1202,
    MESSAGETYPE_MAYACHAINMSGREQUEST: 1203,
    MESSAGETYPE_MAYACHAINMSGACK: 1204,
    MESSAGETYPE_MAYACHAINSIGNEDTX: 1205
};
$437b837d88ef5c30$var$goog.object.extend($437b837d88ef5c30$exports, proto);



parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");
var $6iw60 = parcelRequire("6iw60");

var $kEUo3 = parcelRequire("kEUo3");
var $3dec37221774706a$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $iMRgf = parcelRequire("iMRgf");

var $dNfWb = parcelRequire("dNfWb");
var $fc725679f3b36f10$exports = {};

var $aZLZv = parcelRequire("aZLZv");

var $dNfWb = parcelRequire("dNfWb");
var $fc725679f3b36f10$require$MAX_LENGTH = $dNfWb.MAX_LENGTH;
var $fc725679f3b36f10$require$MAX_SAFE_INTEGER = $dNfWb.MAX_SAFE_INTEGER;

var $iMRgf = parcelRequire("iMRgf");
var $fc725679f3b36f10$require$re = $iMRgf.re;
var $fc725679f3b36f10$require$t = $iMRgf.t;
var $0fb0b2e7b430918a$exports = {};
// parse out just the options we care about so we always get a consistent
// obj with keys in a consistent order.
const $0fb0b2e7b430918a$var$opts = [
    "includePrerelease",
    "loose",
    "rtl"
];
const $0fb0b2e7b430918a$var$parseOptions = (options)=>!options ? {} : typeof options !== "object" ? {
        loose: true
    } : $0fb0b2e7b430918a$var$opts.filter((k)=>options[k]).reduce((o, k)=>{
        o[k] = true;
        return o;
    }, {});
$0fb0b2e7b430918a$exports = $0fb0b2e7b430918a$var$parseOptions;


var $c74c8a37da8eb4f1$exports = {};
const $c74c8a37da8eb4f1$var$numeric = /^[0-9]+$/;
const $c74c8a37da8eb4f1$var$compareIdentifiers = (a, b)=>{
    const anum = $c74c8a37da8eb4f1$var$numeric.test(a);
    const bnum = $c74c8a37da8eb4f1$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $c74c8a37da8eb4f1$var$rcompareIdentifiers = (a, b)=>$c74c8a37da8eb4f1$var$compareIdentifiers(b, a);
$c74c8a37da8eb4f1$exports = {
    compareIdentifiers: $c74c8a37da8eb4f1$var$compareIdentifiers,
    rcompareIdentifiers: $c74c8a37da8eb4f1$var$rcompareIdentifiers
};


var $fc725679f3b36f10$require$compareIdentifiers = $c74c8a37da8eb4f1$exports.compareIdentifiers;
class $fc725679f3b36f10$var$SemVer {
    constructor(version, options){
        options = $0fb0b2e7b430918a$exports(options);
        if (version instanceof $fc725679f3b36f10$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid Version: ${version}`);
        if (version.length > $fc725679f3b36f10$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$fc725679f3b36f10$require$MAX_LENGTH} characters`);
        $aZLZv("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $fc725679f3b36f10$require$re[$fc725679f3b36f10$require$t.LOOSE] : $fc725679f3b36f10$require$re[$fc725679f3b36f10$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $fc725679f3b36f10$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $fc725679f3b36f10$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $fc725679f3b36f10$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $fc725679f3b36f10$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $aZLZv("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $fc725679f3b36f10$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $fc725679f3b36f10$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $fc725679f3b36f10$var$SemVer)) other = new $fc725679f3b36f10$var$SemVer(other, this.options);
        return $fc725679f3b36f10$require$compareIdentifiers(this.major, other.major) || $fc725679f3b36f10$require$compareIdentifiers(this.minor, other.minor) || $fc725679f3b36f10$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $fc725679f3b36f10$var$SemVer)) other = new $fc725679f3b36f10$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $aZLZv("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $fc725679f3b36f10$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $fc725679f3b36f10$var$SemVer)) other = new $fc725679f3b36f10$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $aZLZv("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $fc725679f3b36f10$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier);
                this.inc("pre", identifier);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier);
                this.inc("pre", identifier);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                if (this.prerelease.length === 0) this.prerelease = [
                    0
                ];
                else {
                    let i = this.prerelease.length;
                    while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                        this.prerelease[i]++;
                        i = -2;
                    }
                    if (i === -1) // didn't increment anything
                    this.prerelease.push(0);
                }
                if (identifier) {
                    // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                    // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                    if ($fc725679f3b36f10$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                        if (isNaN(this.prerelease[1])) this.prerelease = [
                            identifier,
                            0
                        ];
                    } else this.prerelease = [
                        identifier,
                        0
                    ];
                }
                break;
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.format();
        this.raw = this.version;
        return this;
    }
}
$fc725679f3b36f10$exports = $fc725679f3b36f10$var$SemVer;



var $fdbabf5dca878679$exports = {};

var $dNfWb = parcelRequire("dNfWb");
var $fdbabf5dca878679$require$MAX_LENGTH = $dNfWb.MAX_LENGTH;

var $iMRgf = parcelRequire("iMRgf");
var $fdbabf5dca878679$require$re = $iMRgf.re;
var $fdbabf5dca878679$require$t = $iMRgf.t;


const $fdbabf5dca878679$var$parse = (version, options)=>{
    options = $0fb0b2e7b430918a$exports(options);
    if (version instanceof $fc725679f3b36f10$exports) return version;
    if (typeof version !== "string") return null;
    if (version.length > $fdbabf5dca878679$require$MAX_LENGTH) return null;
    const r = options.loose ? $fdbabf5dca878679$require$re[$fdbabf5dca878679$require$t.LOOSE] : $fdbabf5dca878679$require$re[$fdbabf5dca878679$require$t.FULL];
    if (!r.test(version)) return null;
    try {
        return new $fc725679f3b36f10$exports(version, options);
    } catch (er) {
        return null;
    }
};
$fdbabf5dca878679$exports = $fdbabf5dca878679$var$parse;


var $81cb9e183b0978cf$exports = {};

const $81cb9e183b0978cf$var$valid = (version, options)=>{
    const v = $fdbabf5dca878679$exports(version, options);
    return v ? v.version : null;
};
$81cb9e183b0978cf$exports = $81cb9e183b0978cf$var$valid;


var $718b2c44e375137e$exports = {};

const $718b2c44e375137e$var$clean = (version, options)=>{
    const s = $fdbabf5dca878679$exports(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
$718b2c44e375137e$exports = $718b2c44e375137e$var$clean;


var $0a63b0abcdcfa517$exports = {};

const $0a63b0abcdcfa517$var$inc = (version, release, options, identifier)=>{
    if (typeof options === "string") {
        identifier = options;
        options = undefined;
    }
    try {
        return new $fc725679f3b36f10$exports(version instanceof $fc725679f3b36f10$exports ? version.version : version, options).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
};
$0a63b0abcdcfa517$exports = $0a63b0abcdcfa517$var$inc;


var $d4e392b712c2bf9d$exports = {};

var $91e30d6943c86ab3$exports = {};
var $b5021c9f1e418aae$exports = {};

const $b5021c9f1e418aae$var$compare = (a, b, loose)=>new $fc725679f3b36f10$exports(a, loose).compare(new $fc725679f3b36f10$exports(b, loose));
$b5021c9f1e418aae$exports = $b5021c9f1e418aae$var$compare;


const $91e30d6943c86ab3$var$eq = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) === 0;
$91e30d6943c86ab3$exports = $91e30d6943c86ab3$var$eq;


const $d4e392b712c2bf9d$var$diff = (version1, version2)=>{
    if ($91e30d6943c86ab3$exports(version1, version2)) return null;
    else {
        const v1 = $fdbabf5dca878679$exports(version1);
        const v2 = $fdbabf5dca878679$exports(version2);
        const hasPre = v1.prerelease.length || v2.prerelease.length;
        const prefix = hasPre ? "pre" : "";
        const defaultResult = hasPre ? "prerelease" : "";
        for(const key in v1)if (key === "major" || key === "minor" || key === "patch") {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
};
$d4e392b712c2bf9d$exports = $d4e392b712c2bf9d$var$diff;


var $8ff4f2d38bd7897a$exports = {};

const $8ff4f2d38bd7897a$var$major = (a, loose)=>new $fc725679f3b36f10$exports(a, loose).major;
$8ff4f2d38bd7897a$exports = $8ff4f2d38bd7897a$var$major;


var $5a9777515df53692$exports = {};

const $5a9777515df53692$var$minor = (a, loose)=>new $fc725679f3b36f10$exports(a, loose).minor;
$5a9777515df53692$exports = $5a9777515df53692$var$minor;


var $d2eb0a3e88b768b3$exports = {};

const $d2eb0a3e88b768b3$var$patch = (a, loose)=>new $fc725679f3b36f10$exports(a, loose).patch;
$d2eb0a3e88b768b3$exports = $d2eb0a3e88b768b3$var$patch;


var $9775c5d521bc628f$exports = {};

const $9775c5d521bc628f$var$prerelease = (version, options)=>{
    const parsed = $fdbabf5dca878679$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$9775c5d521bc628f$exports = $9775c5d521bc628f$var$prerelease;



var $7b2295eeb3557434$exports = {};

const $7b2295eeb3557434$var$rcompare = (a, b, loose)=>$b5021c9f1e418aae$exports(b, a, loose);
$7b2295eeb3557434$exports = $7b2295eeb3557434$var$rcompare;


var $34bf107f7b4db1ba$exports = {};

const $34bf107f7b4db1ba$var$compareLoose = (a, b)=>$b5021c9f1e418aae$exports(a, b, true);
$34bf107f7b4db1ba$exports = $34bf107f7b4db1ba$var$compareLoose;


var $088b7be0e2780bc8$exports = {};

const $088b7be0e2780bc8$var$compareBuild = (a, b, loose)=>{
    const versionA = new $fc725679f3b36f10$exports(a, loose);
    const versionB = new $fc725679f3b36f10$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$088b7be0e2780bc8$exports = $088b7be0e2780bc8$var$compareBuild;


var $b5c1703d787f4489$exports = {};

const $b5c1703d787f4489$var$sort = (list, loose)=>list.sort((a, b)=>$088b7be0e2780bc8$exports(a, b, loose));
$b5c1703d787f4489$exports = $b5c1703d787f4489$var$sort;


var $6fe5a4afba9394b0$exports = {};

const $6fe5a4afba9394b0$var$rsort = (list, loose)=>list.sort((a, b)=>$088b7be0e2780bc8$exports(b, a, loose));
$6fe5a4afba9394b0$exports = $6fe5a4afba9394b0$var$rsort;


var $0de3e2003ab63496$exports = {};

const $0de3e2003ab63496$var$gt = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) > 0;
$0de3e2003ab63496$exports = $0de3e2003ab63496$var$gt;


var $8013974d3130e539$exports = {};

const $8013974d3130e539$var$lt = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) < 0;
$8013974d3130e539$exports = $8013974d3130e539$var$lt;



var $03ca4f97b49b6989$exports = {};

const $03ca4f97b49b6989$var$neq = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) !== 0;
$03ca4f97b49b6989$exports = $03ca4f97b49b6989$var$neq;


var $2d369901bf68105f$exports = {};

const $2d369901bf68105f$var$gte = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) >= 0;
$2d369901bf68105f$exports = $2d369901bf68105f$var$gte;


var $977d241ac8d9cbdb$exports = {};

const $977d241ac8d9cbdb$var$lte = (a, b, loose)=>$b5021c9f1e418aae$exports(a, b, loose) <= 0;
$977d241ac8d9cbdb$exports = $977d241ac8d9cbdb$var$lte;


var $30227c94efda3651$exports = {};






const $30227c94efda3651$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $91e30d6943c86ab3$exports(a, b, loose);
        case "!=":
            return $03ca4f97b49b6989$exports(a, b, loose);
        case ">":
            return $0de3e2003ab63496$exports(a, b, loose);
        case ">=":
            return $2d369901bf68105f$exports(a, b, loose);
        case "<":
            return $8013974d3130e539$exports(a, b, loose);
        case "<=":
            return $977d241ac8d9cbdb$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$30227c94efda3651$exports = $30227c94efda3651$var$cmp;


var $adf9e68177350c86$exports = {};



var $iMRgf = parcelRequire("iMRgf");
var $adf9e68177350c86$require$re = $iMRgf.re;
var $adf9e68177350c86$require$t = $iMRgf.t;
const $adf9e68177350c86$var$coerce = (version, options)=>{
    if (version instanceof $fc725679f3b36f10$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match($adf9e68177350c86$require$re[$adf9e68177350c86$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        let next;
        while((next = $adf9e68177350c86$require$re[$adf9e68177350c86$require$t.COERCERTL].exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            $adf9e68177350c86$require$re[$adf9e68177350c86$require$t.COERCERTL].lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        $adf9e68177350c86$require$re[$adf9e68177350c86$require$t.COERCERTL].lastIndex = -1;
    }
    if (match === null) return null;
    return $fdbabf5dca878679$exports(`${match[2]}.${match[3] || "0"}.${match[4] || "0"}`, options);
};
$adf9e68177350c86$exports = $adf9e68177350c86$var$coerce;


var $82ccfc43f47672bb$exports = {};
const $82ccfc43f47672bb$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $82ccfc43f47672bb$var$Comparator {
    static get ANY() {
        return $82ccfc43f47672bb$var$ANY;
    }
    constructor(comp, options){
        options = $0fb0b2e7b430918a$exports(options);
        if (comp instanceof $82ccfc43f47672bb$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        $aZLZv("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $82ccfc43f47672bb$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $aZLZv("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $82ccfc43f47672bb$require$re[$82ccfc43f47672bb$require$t.COMPARATORLOOSE] : $82ccfc43f47672bb$require$re[$82ccfc43f47672bb$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $82ccfc43f47672bb$var$ANY;
        else this.semver = new $fc725679f3b36f10$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $aZLZv("Comparator.test", version, this.options.loose);
        if (this.semver === $82ccfc43f47672bb$var$ANY || version === $82ccfc43f47672bb$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $fc725679f3b36f10$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $30227c94efda3651$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $82ccfc43f47672bb$var$Comparator)) throw new TypeError("a Comparator is required");
        if (!options || typeof options !== "object") options = {
            loose: !!options,
            includePrerelease: false
        };
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $49b09db8a2217572$exports(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $49b09db8a2217572$exports(this.value, options).test(comp.semver);
        }
        const sameDirectionIncreasing = (this.operator === ">=" || this.operator === ">") && (comp.operator === ">=" || comp.operator === ">");
        const sameDirectionDecreasing = (this.operator === "<=" || this.operator === "<") && (comp.operator === "<=" || comp.operator === "<");
        const sameSemVer = this.semver.version === comp.semver.version;
        const differentDirectionsInclusive = (this.operator === ">=" || this.operator === "<=") && (comp.operator === ">=" || comp.operator === "<=");
        const oppositeDirectionsLessThan = $30227c94efda3651$exports(this.semver, "<", comp.semver, options) && (this.operator === ">=" || this.operator === ">") && (comp.operator === "<=" || comp.operator === "<");
        const oppositeDirectionsGreaterThan = $30227c94efda3651$exports(this.semver, ">", comp.semver, options) && (this.operator === "<=" || this.operator === "<") && (comp.operator === ">=" || comp.operator === ">");
        return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
    }
}
$82ccfc43f47672bb$exports = $82ccfc43f47672bb$var$Comparator;


var $iMRgf = parcelRequire("iMRgf");
var $82ccfc43f47672bb$require$re = $iMRgf.re;
var $82ccfc43f47672bb$require$t = $iMRgf.t;


var $aZLZv = parcelRequire("aZLZv");

var $49b09db8a2217572$exports = {};
// hoisted class for cyclic dependency
class $49b09db8a2217572$var$Range {
    constructor(range, options){
        options = $0fb0b2e7b430918a$exports(options);
        if (range instanceof $49b09db8a2217572$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $49b09db8a2217572$var$Range(range.raw, options);
        }
        if (range instanceof $82ccfc43f47672bb$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.format();
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First, split based on boolean or ||
        this.raw = range;
        this.set = range.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${range}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$49b09db8a2217572$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $49b09db8a2217572$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.format();
    }
    format() {
        this.range = this.set.map((comps)=>{
            return comps.join(" ").trim();
        }).join("||").trim();
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        range = range.trim();
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = Object.keys(this.options).join(",");
        const memoKey = `parseRange:${memoOpts}:${range}`;
        const cached = $49b09db8a2217572$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.HYPHENRANGELOOSE] : $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.HYPHENRANGE];
        range = range.replace(hr, $49b09db8a2217572$var$hyphenReplace(this.options.includePrerelease));
        $aZLZv("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($49b09db8a2217572$require$re[$49b09db8a2217572$require$t.COMPARATORTRIM], $49b09db8a2217572$require$comparatorTrimReplace);
        $aZLZv("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($49b09db8a2217572$require$re[$49b09db8a2217572$require$t.TILDETRIM], $49b09db8a2217572$require$tildeTrimReplace);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($49b09db8a2217572$require$re[$49b09db8a2217572$require$t.CARETTRIM], $49b09db8a2217572$require$caretTrimReplace);
        // normalize spaces
        range = range.split(/\s+/).join(" ");
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$49b09db8a2217572$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$49b09db8a2217572$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $aZLZv("loose invalid filter", comp, this.options);
            return !!comp.match($49b09db8a2217572$require$re[$49b09db8a2217572$require$t.COMPARATORLOOSE]);
        });
        $aZLZv("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $82ccfc43f47672bb$exports(comp, this.options));
        for (const comp of comparators){
            if ($49b09db8a2217572$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $49b09db8a2217572$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $49b09db8a2217572$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $49b09db8a2217572$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $49b09db8a2217572$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $fc725679f3b36f10$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($49b09db8a2217572$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$49b09db8a2217572$exports = $49b09db8a2217572$var$Range;
var $8dd5d9d546ed414a$exports = {};
"use strict";
var $da7703ccdec1f8f5$exports = {};
"use strict";
$da7703ccdec1f8f5$exports = $da7703ccdec1f8f5$var$Yallist;
$da7703ccdec1f8f5$var$Yallist.Node = $da7703ccdec1f8f5$var$Node;
$da7703ccdec1f8f5$var$Yallist.create = $da7703ccdec1f8f5$var$Yallist;
function $da7703ccdec1f8f5$var$Yallist(list) {
    var self = this;
    if (!(self instanceof $da7703ccdec1f8f5$var$Yallist)) self = new $da7703ccdec1f8f5$var$Yallist();
    self.tail = null;
    self.head = null;
    self.length = 0;
    if (list && typeof list.forEach === "function") list.forEach(function(item) {
        self.push(item);
    });
    else if (arguments.length > 0) for(var i = 0, l = arguments.length; i < l; i++)self.push(arguments[i]);
    return self;
}
$da7703ccdec1f8f5$var$Yallist.prototype.removeNode = function(node) {
    if (node.list !== this) throw new Error("removing node which does not belong to this list");
    var next = node.next;
    var prev = node.prev;
    if (next) next.prev = prev;
    if (prev) prev.next = next;
    if (node === this.head) this.head = next;
    if (node === this.tail) this.tail = prev;
    node.list.length--;
    node.next = null;
    node.prev = null;
    node.list = null;
    return next;
};
$da7703ccdec1f8f5$var$Yallist.prototype.unshiftNode = function(node) {
    if (node === this.head) return;
    if (node.list) node.list.removeNode(node);
    var head = this.head;
    node.list = this;
    node.next = head;
    if (head) head.prev = node;
    this.head = node;
    if (!this.tail) this.tail = node;
    this.length++;
};
$da7703ccdec1f8f5$var$Yallist.prototype.pushNode = function(node) {
    if (node === this.tail) return;
    if (node.list) node.list.removeNode(node);
    var tail = this.tail;
    node.list = this;
    node.prev = tail;
    if (tail) tail.next = node;
    this.tail = node;
    if (!this.head) this.head = node;
    this.length++;
};
$da7703ccdec1f8f5$var$Yallist.prototype.push = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$da7703ccdec1f8f5$var$push(this, arguments[i]);
    return this.length;
};
$da7703ccdec1f8f5$var$Yallist.prototype.unshift = function() {
    for(var i = 0, l = arguments.length; i < l; i++)$da7703ccdec1f8f5$var$unshift(this, arguments[i]);
    return this.length;
};
$da7703ccdec1f8f5$var$Yallist.prototype.pop = function() {
    if (!this.tail) return undefined;
    var res = this.tail.value;
    this.tail = this.tail.prev;
    if (this.tail) this.tail.next = null;
    else this.head = null;
    this.length--;
    return res;
};
$da7703ccdec1f8f5$var$Yallist.prototype.shift = function() {
    if (!this.head) return undefined;
    var res = this.head.value;
    this.head = this.head.next;
    if (this.head) this.head.prev = null;
    else this.tail = null;
    this.length--;
    return res;
};
$da7703ccdec1f8f5$var$Yallist.prototype.forEach = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.head, i = 0; walker !== null; i++){
        fn.call(thisp, walker.value, i, this);
        walker = walker.next;
    }
};
$da7703ccdec1f8f5$var$Yallist.prototype.forEachReverse = function(fn, thisp) {
    thisp = thisp || this;
    for(var walker = this.tail, i = this.length - 1; walker !== null; i--){
        fn.call(thisp, walker.value, i, this);
        walker = walker.prev;
    }
};
$da7703ccdec1f8f5$var$Yallist.prototype.get = function(n) {
    for(var i = 0, walker = this.head; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.next;
    if (i === n && walker !== null) return walker.value;
};
$da7703ccdec1f8f5$var$Yallist.prototype.getReverse = function(n) {
    for(var i = 0, walker = this.tail; walker !== null && i < n; i++)// abort out of the list early if we hit a cycle
    walker = walker.prev;
    if (i === n && walker !== null) return walker.value;
};
$da7703ccdec1f8f5$var$Yallist.prototype.map = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $da7703ccdec1f8f5$var$Yallist();
    for(var walker = this.head; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.next;
    }
    return res;
};
$da7703ccdec1f8f5$var$Yallist.prototype.mapReverse = function(fn, thisp) {
    thisp = thisp || this;
    var res = new $da7703ccdec1f8f5$var$Yallist();
    for(var walker = this.tail; walker !== null;){
        res.push(fn.call(thisp, walker.value, this));
        walker = walker.prev;
    }
    return res;
};
$da7703ccdec1f8f5$var$Yallist.prototype.reduce = function(fn, initial) {
    var acc;
    var walker = this.head;
    if (arguments.length > 1) acc = initial;
    else if (this.head) {
        walker = this.head.next;
        acc = this.head.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = 0; walker !== null; i++){
        acc = fn(acc, walker.value, i);
        walker = walker.next;
    }
    return acc;
};
$da7703ccdec1f8f5$var$Yallist.prototype.reduceReverse = function(fn, initial) {
    var acc;
    var walker = this.tail;
    if (arguments.length > 1) acc = initial;
    else if (this.tail) {
        walker = this.tail.prev;
        acc = this.tail.value;
    } else throw new TypeError("Reduce of empty list with no initial value");
    for(var i = this.length - 1; walker !== null; i--){
        acc = fn(acc, walker.value, i);
        walker = walker.prev;
    }
    return acc;
};
$da7703ccdec1f8f5$var$Yallist.prototype.toArray = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.head; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.next;
    }
    return arr;
};
$da7703ccdec1f8f5$var$Yallist.prototype.toArrayReverse = function() {
    var arr = new Array(this.length);
    for(var i = 0, walker = this.tail; walker !== null; i++){
        arr[i] = walker.value;
        walker = walker.prev;
    }
    return arr;
};
$da7703ccdec1f8f5$var$Yallist.prototype.slice = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $da7703ccdec1f8f5$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = 0, walker = this.head; walker !== null && i < from; i++)walker = walker.next;
    for(; walker !== null && i < to; i++, walker = walker.next)ret.push(walker.value);
    return ret;
};
$da7703ccdec1f8f5$var$Yallist.prototype.sliceReverse = function(from, to) {
    to = to || this.length;
    if (to < 0) to += this.length;
    from = from || 0;
    if (from < 0) from += this.length;
    var ret = new $da7703ccdec1f8f5$var$Yallist();
    if (to < from || to < 0) return ret;
    if (from < 0) from = 0;
    if (to > this.length) to = this.length;
    for(var i = this.length, walker = this.tail; walker !== null && i > to; i--)walker = walker.prev;
    for(; walker !== null && i > from; i--, walker = walker.prev)ret.push(walker.value);
    return ret;
};
$da7703ccdec1f8f5$var$Yallist.prototype.splice = function(start, deleteCount, ...nodes) {
    if (start > this.length) start = this.length - 1;
    if (start < 0) start = this.length + start;
    for(var i = 0, walker = this.head; walker !== null && i < start; i++)walker = walker.next;
    var ret = [];
    for(var i = 0; walker && i < deleteCount; i++){
        ret.push(walker.value);
        walker = this.removeNode(walker);
    }
    if (walker === null) walker = this.tail;
    if (walker !== this.head && walker !== this.tail) walker = walker.prev;
    for(var i = 0; i < nodes.length; i++)walker = $da7703ccdec1f8f5$var$insert(this, walker, nodes[i]);
    return ret;
};
$da7703ccdec1f8f5$var$Yallist.prototype.reverse = function() {
    var head = this.head;
    var tail = this.tail;
    for(var walker = head; walker !== null; walker = walker.prev){
        var p = walker.prev;
        walker.prev = walker.next;
        walker.next = p;
    }
    this.head = tail;
    this.tail = head;
    return this;
};
function $da7703ccdec1f8f5$var$insert(self, node, value) {
    var inserted = node === self.head ? new $da7703ccdec1f8f5$var$Node(value, null, node, self) : new $da7703ccdec1f8f5$var$Node(value, node, node.next, self);
    if (inserted.next === null) self.tail = inserted;
    if (inserted.prev === null) self.head = inserted;
    self.length++;
    return inserted;
}
function $da7703ccdec1f8f5$var$push(self, item) {
    self.tail = new $da7703ccdec1f8f5$var$Node(item, self.tail, null, self);
    if (!self.head) self.head = self.tail;
    self.length++;
}
function $da7703ccdec1f8f5$var$unshift(self, item) {
    self.head = new $da7703ccdec1f8f5$var$Node(item, null, self.head, self);
    if (!self.tail) self.tail = self.head;
    self.length++;
}
function $da7703ccdec1f8f5$var$Node(value, prev, next, list) {
    if (!(this instanceof $da7703ccdec1f8f5$var$Node)) return new $da7703ccdec1f8f5$var$Node(value, prev, next, list);
    this.list = list;
    this.value = value;
    if (prev) {
        prev.next = this;
        this.prev = prev;
    } else this.prev = null;
    if (next) {
        next.prev = this;
        this.next = next;
    } else this.next = null;
}

try {
    // add if support for Symbol.iterator is present
    (parcelRequire("aTLS7"))($da7703ccdec1f8f5$var$Yallist);
} catch (er) {}


const $8dd5d9d546ed414a$var$MAX = Symbol("max");
const $8dd5d9d546ed414a$var$LENGTH = Symbol("length");
const $8dd5d9d546ed414a$var$LENGTH_CALCULATOR = Symbol("lengthCalculator");
const $8dd5d9d546ed414a$var$ALLOW_STALE = Symbol("allowStale");
const $8dd5d9d546ed414a$var$MAX_AGE = Symbol("maxAge");
const $8dd5d9d546ed414a$var$DISPOSE = Symbol("dispose");
const $8dd5d9d546ed414a$var$NO_DISPOSE_ON_SET = Symbol("noDisposeOnSet");
const $8dd5d9d546ed414a$var$LRU_LIST = Symbol("lruList");
const $8dd5d9d546ed414a$var$CACHE = Symbol("cache");
const $8dd5d9d546ed414a$var$UPDATE_AGE_ON_GET = Symbol("updateAgeOnGet");
const $8dd5d9d546ed414a$var$naiveLength = ()=>1;
// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
class $8dd5d9d546ed414a$var$LRUCache {
    constructor(options){
        if (typeof options === "number") options = {
            max: options
        };
        if (!options) options = {};
        if (options.max && (typeof options.max !== "number" || options.max < 0)) throw new TypeError("max must be a non-negative number");
        // Kind of weird to have a default max of Infinity, but oh well.
        const max = this[$8dd5d9d546ed414a$var$MAX] = options.max || Infinity;
        const lc = options.length || $8dd5d9d546ed414a$var$naiveLength;
        this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR] = typeof lc !== "function" ? $8dd5d9d546ed414a$var$naiveLength : lc;
        this[$8dd5d9d546ed414a$var$ALLOW_STALE] = options.stale || false;
        if (options.maxAge && typeof options.maxAge !== "number") throw new TypeError("maxAge must be a number");
        this[$8dd5d9d546ed414a$var$MAX_AGE] = options.maxAge || 0;
        this[$8dd5d9d546ed414a$var$DISPOSE] = options.dispose;
        this[$8dd5d9d546ed414a$var$NO_DISPOSE_ON_SET] = options.noDisposeOnSet || false;
        this[$8dd5d9d546ed414a$var$UPDATE_AGE_ON_GET] = options.updateAgeOnGet || false;
        this.reset();
    }
    // resize the cache when the max changes.
    set max(mL) {
        if (typeof mL !== "number" || mL < 0) throw new TypeError("max must be a non-negative number");
        this[$8dd5d9d546ed414a$var$MAX] = mL || Infinity;
        $8dd5d9d546ed414a$var$trim(this);
    }
    get max() {
        return this[$8dd5d9d546ed414a$var$MAX];
    }
    set allowStale(allowStale) {
        this[$8dd5d9d546ed414a$var$ALLOW_STALE] = !!allowStale;
    }
    get allowStale() {
        return this[$8dd5d9d546ed414a$var$ALLOW_STALE];
    }
    set maxAge(mA) {
        if (typeof mA !== "number") throw new TypeError("maxAge must be a non-negative number");
        this[$8dd5d9d546ed414a$var$MAX_AGE] = mA;
        $8dd5d9d546ed414a$var$trim(this);
    }
    get maxAge() {
        return this[$8dd5d9d546ed414a$var$MAX_AGE];
    }
    // resize the cache when the lengthCalculator changes.
    set lengthCalculator(lC) {
        if (typeof lC !== "function") lC = $8dd5d9d546ed414a$var$naiveLength;
        if (lC !== this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR]) {
            this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR] = lC;
            this[$8dd5d9d546ed414a$var$LENGTH] = 0;
            this[$8dd5d9d546ed414a$var$LRU_LIST].forEach((hit)=>{
                hit.length = this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR](hit.value, hit.key);
                this[$8dd5d9d546ed414a$var$LENGTH] += hit.length;
            });
        }
        $8dd5d9d546ed414a$var$trim(this);
    }
    get lengthCalculator() {
        return this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR];
    }
    get length() {
        return this[$8dd5d9d546ed414a$var$LENGTH];
    }
    get itemCount() {
        return this[$8dd5d9d546ed414a$var$LRU_LIST].length;
    }
    rforEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$8dd5d9d546ed414a$var$LRU_LIST].tail; walker !== null;){
            const prev = walker.prev;
            $8dd5d9d546ed414a$var$forEachStep(this, fn, walker, thisp);
            walker = prev;
        }
    }
    forEach(fn, thisp) {
        thisp = thisp || this;
        for(let walker = this[$8dd5d9d546ed414a$var$LRU_LIST].head; walker !== null;){
            const next = walker.next;
            $8dd5d9d546ed414a$var$forEachStep(this, fn, walker, thisp);
            walker = next;
        }
    }
    keys() {
        return this[$8dd5d9d546ed414a$var$LRU_LIST].toArray().map((k)=>k.key);
    }
    values() {
        return this[$8dd5d9d546ed414a$var$LRU_LIST].toArray().map((k)=>k.value);
    }
    reset() {
        if (this[$8dd5d9d546ed414a$var$DISPOSE] && this[$8dd5d9d546ed414a$var$LRU_LIST] && this[$8dd5d9d546ed414a$var$LRU_LIST].length) this[$8dd5d9d546ed414a$var$LRU_LIST].forEach((hit)=>this[$8dd5d9d546ed414a$var$DISPOSE](hit.key, hit.value));
        this[$8dd5d9d546ed414a$var$CACHE] = new Map() // hash of items by key
        ;
        this[$8dd5d9d546ed414a$var$LRU_LIST] = new $da7703ccdec1f8f5$exports() // list of items in order of use recency
        ;
        this[$8dd5d9d546ed414a$var$LENGTH] = 0 // length of items in the list
        ;
    }
    dump() {
        return this[$8dd5d9d546ed414a$var$LRU_LIST].map((hit)=>$8dd5d9d546ed414a$var$isStale(this, hit) ? false : {
                k: hit.key,
                v: hit.value,
                e: hit.now + (hit.maxAge || 0)
            }).toArray().filter((h)=>h);
    }
    dumpLru() {
        return this[$8dd5d9d546ed414a$var$LRU_LIST];
    }
    set(key, value, maxAge) {
        maxAge = maxAge || this[$8dd5d9d546ed414a$var$MAX_AGE];
        if (maxAge && typeof maxAge !== "number") throw new TypeError("maxAge must be a number");
        const now = maxAge ? Date.now() : 0;
        const len = this[$8dd5d9d546ed414a$var$LENGTH_CALCULATOR](value, key);
        if (this[$8dd5d9d546ed414a$var$CACHE].has(key)) {
            if (len > this[$8dd5d9d546ed414a$var$MAX]) {
                $8dd5d9d546ed414a$var$del(this, this[$8dd5d9d546ed414a$var$CACHE].get(key));
                return false;
            }
            const node = this[$8dd5d9d546ed414a$var$CACHE].get(key);
            const item = node.value;
            // dispose of the old one before overwriting
            // split out into 2 ifs for better coverage tracking
            if (this[$8dd5d9d546ed414a$var$DISPOSE]) {
                if (!this[$8dd5d9d546ed414a$var$NO_DISPOSE_ON_SET]) this[$8dd5d9d546ed414a$var$DISPOSE](key, item.value);
            }
            item.now = now;
            item.maxAge = maxAge;
            item.value = value;
            this[$8dd5d9d546ed414a$var$LENGTH] += len - item.length;
            item.length = len;
            this.get(key);
            $8dd5d9d546ed414a$var$trim(this);
            return true;
        }
        const hit = new $8dd5d9d546ed414a$var$Entry(key, value, len, now, maxAge);
        // oversized objects fall out of cache automatically.
        if (hit.length > this[$8dd5d9d546ed414a$var$MAX]) {
            if (this[$8dd5d9d546ed414a$var$DISPOSE]) this[$8dd5d9d546ed414a$var$DISPOSE](key, value);
            return false;
        }
        this[$8dd5d9d546ed414a$var$LENGTH] += hit.length;
        this[$8dd5d9d546ed414a$var$LRU_LIST].unshift(hit);
        this[$8dd5d9d546ed414a$var$CACHE].set(key, this[$8dd5d9d546ed414a$var$LRU_LIST].head);
        $8dd5d9d546ed414a$var$trim(this);
        return true;
    }
    has(key) {
        if (!this[$8dd5d9d546ed414a$var$CACHE].has(key)) return false;
        const hit = this[$8dd5d9d546ed414a$var$CACHE].get(key).value;
        return !$8dd5d9d546ed414a$var$isStale(this, hit);
    }
    get(key) {
        return $8dd5d9d546ed414a$var$get(this, key, true);
    }
    peek(key) {
        return $8dd5d9d546ed414a$var$get(this, key, false);
    }
    pop() {
        const node = this[$8dd5d9d546ed414a$var$LRU_LIST].tail;
        if (!node) return null;
        $8dd5d9d546ed414a$var$del(this, node);
        return node.value;
    }
    del(key) {
        $8dd5d9d546ed414a$var$del(this, this[$8dd5d9d546ed414a$var$CACHE].get(key));
    }
    load(arr) {
        // reset the cache
        this.reset();
        const now = Date.now();
        // A previous serialized cache has the most recent items first
        for(let l = arr.length - 1; l >= 0; l--){
            const hit = arr[l];
            const expiresAt = hit.e || 0;
            if (expiresAt === 0) // the item was created without expiration in a non aged cache
            this.set(hit.k, hit.v);
            else {
                const maxAge = expiresAt - now;
                // dont add already expired items
                if (maxAge > 0) this.set(hit.k, hit.v, maxAge);
            }
        }
    }
    prune() {
        this[$8dd5d9d546ed414a$var$CACHE].forEach((value, key)=>$8dd5d9d546ed414a$var$get(this, key, false));
    }
}
const $8dd5d9d546ed414a$var$get = (self, key, doUse)=>{
    const node = self[$8dd5d9d546ed414a$var$CACHE].get(key);
    if (node) {
        const hit = node.value;
        if ($8dd5d9d546ed414a$var$isStale(self, hit)) {
            $8dd5d9d546ed414a$var$del(self, node);
            if (!self[$8dd5d9d546ed414a$var$ALLOW_STALE]) return undefined;
        } else if (doUse) {
            if (self[$8dd5d9d546ed414a$var$UPDATE_AGE_ON_GET]) node.value.now = Date.now();
            self[$8dd5d9d546ed414a$var$LRU_LIST].unshiftNode(node);
        }
        return hit.value;
    }
};
const $8dd5d9d546ed414a$var$isStale = (self, hit)=>{
    if (!hit || !hit.maxAge && !self[$8dd5d9d546ed414a$var$MAX_AGE]) return false;
    const diff = Date.now() - hit.now;
    return hit.maxAge ? diff > hit.maxAge : self[$8dd5d9d546ed414a$var$MAX_AGE] && diff > self[$8dd5d9d546ed414a$var$MAX_AGE];
};
const $8dd5d9d546ed414a$var$trim = (self)=>{
    if (self[$8dd5d9d546ed414a$var$LENGTH] > self[$8dd5d9d546ed414a$var$MAX]) for(let walker = self[$8dd5d9d546ed414a$var$LRU_LIST].tail; self[$8dd5d9d546ed414a$var$LENGTH] > self[$8dd5d9d546ed414a$var$MAX] && walker !== null;){
        // We know that we're about to delete this one, and also
        // what the next least recently used key will be, so just
        // go ahead and set it now.
        const prev = walker.prev;
        $8dd5d9d546ed414a$var$del(self, walker);
        walker = prev;
    }
};
const $8dd5d9d546ed414a$var$del = (self, node)=>{
    if (node) {
        const hit = node.value;
        if (self[$8dd5d9d546ed414a$var$DISPOSE]) self[$8dd5d9d546ed414a$var$DISPOSE](hit.key, hit.value);
        self[$8dd5d9d546ed414a$var$LENGTH] -= hit.length;
        self[$8dd5d9d546ed414a$var$CACHE].delete(hit.key);
        self[$8dd5d9d546ed414a$var$LRU_LIST].removeNode(node);
    }
};
class $8dd5d9d546ed414a$var$Entry {
    constructor(key, value, length, now, maxAge){
        this.key = key;
        this.value = value;
        this.length = length;
        this.now = now;
        this.maxAge = maxAge || 0;
    }
}
const $8dd5d9d546ed414a$var$forEachStep = (self, fn, node, thisp)=>{
    let hit = node.value;
    if ($8dd5d9d546ed414a$var$isStale(self, hit)) {
        $8dd5d9d546ed414a$var$del(self, node);
        if (!self[$8dd5d9d546ed414a$var$ALLOW_STALE]) hit = undefined;
    }
    if (hit) fn.call(thisp, hit.value, hit.key, self);
};
$8dd5d9d546ed414a$exports = $8dd5d9d546ed414a$var$LRUCache;


const $49b09db8a2217572$var$cache = new $8dd5d9d546ed414a$exports({
    max: 1000
});



var $aZLZv = parcelRequire("aZLZv");


var $iMRgf = parcelRequire("iMRgf");
var $49b09db8a2217572$require$re = $iMRgf.re;
var $49b09db8a2217572$require$t = $iMRgf.t;
var $49b09db8a2217572$require$comparatorTrimReplace = $iMRgf.comparatorTrimReplace;
var $49b09db8a2217572$require$tildeTrimReplace = $iMRgf.tildeTrimReplace;
var $49b09db8a2217572$require$caretTrimReplace = $iMRgf.caretTrimReplace;
const $49b09db8a2217572$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $49b09db8a2217572$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $49b09db8a2217572$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $49b09db8a2217572$var$parseComparator = (comp, options)=>{
    $aZLZv("comp", comp, options);
    comp = $49b09db8a2217572$var$replaceCarets(comp, options);
    $aZLZv("caret", comp);
    comp = $49b09db8a2217572$var$replaceTildes(comp, options);
    $aZLZv("tildes", comp);
    comp = $49b09db8a2217572$var$replaceXRanges(comp, options);
    $aZLZv("xrange", comp);
    comp = $49b09db8a2217572$var$replaceStars(comp, options);
    $aZLZv("stars", comp);
    return comp;
};
const $49b09db8a2217572$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $49b09db8a2217572$var$replaceTildes = (comp, options)=>comp.trim().split(/\s+/).map((c)=>{
        return $49b09db8a2217572$var$replaceTilde(c, options);
    }).join(" ");
const $49b09db8a2217572$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.TILDELOOSE] : $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $aZLZv("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($49b09db8a2217572$var$isX(M)) ret = "";
        else if ($49b09db8a2217572$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($49b09db8a2217572$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $aZLZv("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $aZLZv("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $49b09db8a2217572$var$replaceCarets = (comp, options)=>comp.trim().split(/\s+/).map((c)=>{
        return $49b09db8a2217572$var$replaceCaret(c, options);
    }).join(" ");
const $49b09db8a2217572$var$replaceCaret = (comp, options)=>{
    $aZLZv("caret", comp, options);
    const r = options.loose ? $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.CARETLOOSE] : $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $aZLZv("caret", comp, _, M, m, p, pr);
        let ret;
        if ($49b09db8a2217572$var$isX(M)) ret = "";
        else if ($49b09db8a2217572$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($49b09db8a2217572$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $aZLZv("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $aZLZv("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $aZLZv("caret return", ret);
        return ret;
    });
};
const $49b09db8a2217572$var$replaceXRanges = (comp, options)=>{
    $aZLZv("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>{
        return $49b09db8a2217572$var$replaceXRange(c, options);
    }).join(" ");
};
const $49b09db8a2217572$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.XRANGELOOSE] : $49b09db8a2217572$require$re[$49b09db8a2217572$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $aZLZv("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $49b09db8a2217572$var$isX(M);
        const xm = xM || $49b09db8a2217572$var$isX(m);
        const xp = xm || $49b09db8a2217572$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $aZLZv("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $49b09db8a2217572$var$replaceStars = (comp, options)=>{
    $aZLZv("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($49b09db8a2217572$require$re[$49b09db8a2217572$require$t.STAR], "");
};
const $49b09db8a2217572$var$replaceGTE0 = (comp, options)=>{
    $aZLZv("replaceGTE0", comp, options);
    return comp.trim().replace($49b09db8a2217572$require$re[options.includePrerelease ? $49b09db8a2217572$require$t.GTE0PRE : $49b09db8a2217572$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
const $49b09db8a2217572$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb)=>{
        if ($49b09db8a2217572$var$isX(fM)) from = "";
        else if ($49b09db8a2217572$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($49b09db8a2217572$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($49b09db8a2217572$var$isX(tM)) to = "";
        else if ($49b09db8a2217572$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($49b09db8a2217572$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $49b09db8a2217572$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $aZLZv(set[i].semver);
            if (set[i].semver === $82ccfc43f47672bb$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $29ad5fb8ae9e118d$exports = {};

const $29ad5fb8ae9e118d$var$satisfies = (version, range, options)=>{
    try {
        range = new $49b09db8a2217572$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$29ad5fb8ae9e118d$exports = $29ad5fb8ae9e118d$var$satisfies;


var $919a479b39ff3830$exports = {};

// Mostly just for testing and legacy API reasons
const $919a479b39ff3830$var$toComparators = (range, options)=>new $49b09db8a2217572$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
$919a479b39ff3830$exports = $919a479b39ff3830$var$toComparators;


var $680512fd5a86a0f0$exports = {};


const $680512fd5a86a0f0$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $49b09db8a2217572$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $fc725679f3b36f10$exports(max, options);
            }
        }
    });
    return max;
};
$680512fd5a86a0f0$exports = $680512fd5a86a0f0$var$maxSatisfying;


var $d1f64900a30a3e65$exports = {};


const $d1f64900a30a3e65$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $49b09db8a2217572$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $fc725679f3b36f10$exports(min, options);
            }
        }
    });
    return min;
};
$d1f64900a30a3e65$exports = $d1f64900a30a3e65$var$minSatisfying;


var $3db8cc3a58f81ed2$exports = {};



const $3db8cc3a58f81ed2$var$minVersion = (range, loose)=>{
    range = new $49b09db8a2217572$exports(range, loose);
    let minver = new $fc725679f3b36f10$exports("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $fc725679f3b36f10$exports("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $fc725679f3b36f10$exports(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $0de3e2003ab63496$exports(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $0de3e2003ab63496$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$3db8cc3a58f81ed2$exports = $3db8cc3a58f81ed2$var$minVersion;


var $aa78e25523aef779$exports = {};

const $aa78e25523aef779$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $49b09db8a2217572$exports(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
$aa78e25523aef779$exports = $aa78e25523aef779$var$validRange;


var $4cfa6c232bef1911$exports = {};


const { ANY: $4cfa6c232bef1911$var$ANY } = $82ccfc43f47672bb$exports;






const $4cfa6c232bef1911$var$outside = (version, range, hilo, options)=>{
    version = new $fc725679f3b36f10$exports(version, options);
    range = new $49b09db8a2217572$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $0de3e2003ab63496$exports;
            ltefn = $977d241ac8d9cbdb$exports;
            ltfn = $8013974d3130e539$exports;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $8013974d3130e539$exports;
            ltefn = $2d369901bf68105f$exports;
            ltfn = $0de3e2003ab63496$exports;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($29ad5fb8ae9e118d$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $4cfa6c232bef1911$var$ANY) comparator = new $82ccfc43f47672bb$exports(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$4cfa6c232bef1911$exports = $4cfa6c232bef1911$var$outside;


var $e2ea440445709686$exports = {};
// Determine if version is greater than all the versions possible in the range.

const $e2ea440445709686$var$gtr = (version, range, options)=>$4cfa6c232bef1911$exports(version, range, ">", options);
$e2ea440445709686$exports = $e2ea440445709686$var$gtr;


var $653644f99eea24b0$exports = {};

// Determine if version is less than all the versions possible in the range
const $653644f99eea24b0$var$ltr = (version, range, options)=>$4cfa6c232bef1911$exports(version, range, "<", options);
$653644f99eea24b0$exports = $653644f99eea24b0$var$ltr;


var $58ec654386d118ca$exports = {};

const $58ec654386d118ca$var$intersects = (r1, r2, options)=>{
    r1 = new $49b09db8a2217572$exports(r1, options);
    r2 = new $49b09db8a2217572$exports(r2, options);
    return r1.intersects(r2);
};
$58ec654386d118ca$exports = $58ec654386d118ca$var$intersects;


var $00eadb5fdbd1880b$exports = {};
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.


$00eadb5fdbd1880b$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$b5021c9f1e418aae$exports(a, b, options));
    for (const version of v){
        const included = $29ad5fb8ae9e118d$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $ffe804ed364e92ad$exports = {};


const { ANY: $ffe804ed364e92ad$var$ANY } = $82ccfc43f47672bb$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $ffe804ed364e92ad$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $49b09db8a2217572$exports(sub, options);
    dom = new $49b09db8a2217572$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $ffe804ed364e92ad$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $ffe804ed364e92ad$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $ffe804ed364e92ad$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $ffe804ed364e92ad$var$ANY) return true;
        else if (options.includePrerelease) sub = [
            new $82ccfc43f47672bb$exports(">=0.0.0-0")
        ];
        else sub = [
            new $82ccfc43f47672bb$exports(">=0.0.0")
        ];
    }
    if (dom.length === 1 && dom[0].semver === $ffe804ed364e92ad$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = [
            new $82ccfc43f47672bb$exports(">=0.0.0")
        ];
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $ffe804ed364e92ad$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $ffe804ed364e92ad$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $b5021c9f1e418aae$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$29ad5fb8ae9e118d$exports(eq, String(gt), options)) return null;
        if (lt && !$29ad5fb8ae9e118d$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$29ad5fb8ae9e118d$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $ffe804ed364e92ad$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$29ad5fb8ae9e118d$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $ffe804ed364e92ad$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$29ad5fb8ae9e118d$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $ffe804ed364e92ad$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b5021c9f1e418aae$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $ffe804ed364e92ad$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $b5021c9f1e418aae$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
$ffe804ed364e92ad$exports = $ffe804ed364e92ad$var$subset;


$3dec37221774706a$exports = {
    parse: $fdbabf5dca878679$exports,
    valid: $81cb9e183b0978cf$exports,
    clean: $718b2c44e375137e$exports,
    inc: $0a63b0abcdcfa517$exports,
    diff: $d4e392b712c2bf9d$exports,
    major: $8ff4f2d38bd7897a$exports,
    minor: $5a9777515df53692$exports,
    patch: $d2eb0a3e88b768b3$exports,
    prerelease: $9775c5d521bc628f$exports,
    compare: $b5021c9f1e418aae$exports,
    rcompare: $7b2295eeb3557434$exports,
    compareLoose: $34bf107f7b4db1ba$exports,
    compareBuild: $088b7be0e2780bc8$exports,
    sort: $b5c1703d787f4489$exports,
    rsort: $6fe5a4afba9394b0$exports,
    gt: $0de3e2003ab63496$exports,
    lt: $8013974d3130e539$exports,
    eq: $91e30d6943c86ab3$exports,
    neq: $03ca4f97b49b6989$exports,
    gte: $2d369901bf68105f$exports,
    lte: $977d241ac8d9cbdb$exports,
    cmp: $30227c94efda3651$exports,
    coerce: $adf9e68177350c86$exports,
    Comparator: $82ccfc43f47672bb$exports,
    Range: $49b09db8a2217572$exports,
    satisfies: $29ad5fb8ae9e118d$exports,
    toComparators: $919a479b39ff3830$exports,
    maxSatisfying: $680512fd5a86a0f0$exports,
    minSatisfying: $d1f64900a30a3e65$exports,
    minVersion: $3db8cc3a58f81ed2$exports,
    validRange: $aa78e25523aef779$exports,
    outside: $4cfa6c232bef1911$exports,
    gtr: $e2ea440445709686$exports,
    ltr: $653644f99eea24b0$exports,
    intersects: $58ec654386d118ca$exports,
    simplifyRange: $00eadb5fdbd1880b$exports,
    subset: $ffe804ed364e92ad$exports,
    SemVer: $fc725679f3b36f10$exports,
    re: $iMRgf.re,
    src: $iMRgf.src,
    tokens: $iMRgf.t,
    SEMVER_SPEC_VERSION: $dNfWb.SEMVER_SPEC_VERSION,
    compareIdentifiers: $c74c8a37da8eb4f1$exports.compareIdentifiers,
    rcompareIdentifiers: $c74c8a37da8eb4f1$exports.rcompareIdentifiers
};



var $ce54469dbed45e7f$exports = {};
// source: messages-binance.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $ce54469dbed45e7f$var$goog = $2MzPv;
var $ce54469dbed45e7f$var$global = (function() {
    return this || window || $ce54469dbed45e7f$var$global || self || Function("return this")();
}).call(null);

$ce54469dbed45e7f$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceAddress", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceCancelMsg", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceGetAddress", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceGetPublicKey", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceOrderMsg", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceOrderMsg.BinanceOrderSide", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceOrderMsg.BinanceOrderType", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceOrderMsg.BinanceTimeInForce", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinancePublicKey", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceSignTx", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceSignedTx", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceTransferMsg", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceTransferMsg.BinanceCoin", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceTransferMsg.BinanceInputOutput", null, $ce54469dbed45e7f$var$global);
$ce54469dbed45e7f$var$goog.exportSymbol("proto.BinanceTxRequest", null, $ce54469dbed45e7f$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.BinanceGetAddress.repeatedFields_, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceGetAddress, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceGetAddress.displayName = "proto.BinanceGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceAddress, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceAddress.displayName = "proto.BinanceAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceGetPublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.BinanceGetPublicKey.repeatedFields_, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceGetPublicKey, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceGetPublicKey.displayName = "proto.BinanceGetPublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinancePublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinancePublicKey, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinancePublicKey.displayName = "proto.BinancePublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.BinanceSignTx.repeatedFields_, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceSignTx, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceSignTx.displayName = "proto.BinanceSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceTxRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceTxRequest, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceTxRequest.displayName = "proto.BinanceTxRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceTransferMsg = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.BinanceTransferMsg.repeatedFields_, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceTransferMsg, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceTransferMsg.displayName = "proto.BinanceTransferMsg";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceTransferMsg.BinanceInputOutput = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.BinanceTransferMsg.BinanceInputOutput.repeatedFields_, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceTransferMsg.BinanceInputOutput, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceTransferMsg.BinanceInputOutput.displayName = "proto.BinanceTransferMsg.BinanceInputOutput";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceTransferMsg.BinanceCoin = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceTransferMsg.BinanceCoin, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceTransferMsg.BinanceCoin.displayName = "proto.BinanceTransferMsg.BinanceCoin";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceOrderMsg = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceOrderMsg, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceOrderMsg.displayName = "proto.BinanceOrderMsg";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceCancelMsg = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceCancelMsg, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceCancelMsg.displayName = "proto.BinanceCancelMsg";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.BinanceSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ce54469dbed45e7f$var$goog.inherits(proto.BinanceSignedTx, $2MzPv.Message);
if ($ce54469dbed45e7f$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.BinanceSignedTx.displayName = "proto.BinanceSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.BinanceGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceGetAddress}
 */ proto.BinanceGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceGetAddress;
    return proto.BinanceGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceGetAddress}
 */ proto.BinanceGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.BinanceGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.BinanceGetAddress} returns this
 */ proto.BinanceGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.BinanceGetAddress} returns this
 */ proto.BinanceGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceGetAddress} returns this
 */ proto.BinanceGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.BinanceGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.BinanceGetAddress} returns this
 */ proto.BinanceGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceGetAddress} returns this
 */ proto.BinanceGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceAddress}
 */ proto.BinanceAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceAddress;
    return proto.BinanceAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceAddress}
 */ proto.BinanceAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.BinanceAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceAddress} returns this
 */ proto.BinanceAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceAddress} returns this
 */ proto.BinanceAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.BinanceGetPublicKey.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceGetPublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceGetPublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceGetPublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceGetPublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceGetPublicKey}
 */ proto.BinanceGetPublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceGetPublicKey;
    return proto.BinanceGetPublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceGetPublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceGetPublicKey}
 */ proto.BinanceGetPublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceGetPublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceGetPublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceGetPublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceGetPublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.BinanceGetPublicKey.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.BinanceGetPublicKey} returns this
 */ proto.BinanceGetPublicKey.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.BinanceGetPublicKey} returns this
 */ proto.BinanceGetPublicKey.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceGetPublicKey} returns this
 */ proto.BinanceGetPublicKey.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.BinanceGetPublicKey.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.BinanceGetPublicKey} returns this
 */ proto.BinanceGetPublicKey.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceGetPublicKey} returns this
 */ proto.BinanceGetPublicKey.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceGetPublicKey.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinancePublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.BinancePublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinancePublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinancePublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            publicKey: msg.getPublicKey_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinancePublicKey}
 */ proto.BinancePublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinancePublicKey;
    return proto.BinancePublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinancePublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinancePublicKey}
 */ proto.BinancePublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinancePublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinancePublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinancePublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinancePublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes public_key = 1;
 * @return {!(string|Uint8Array)}
 */ proto.BinancePublicKey.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes public_key = 1;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.BinancePublicKey.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.BinancePublicKey.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.BinancePublicKey} returns this
 */ proto.BinancePublicKey.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinancePublicKey} returns this
 */ proto.BinancePublicKey.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinancePublicKey.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.BinanceSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            msgCount: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            accountNumber: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            source: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceSignTx}
 */ proto.BinanceSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceSignTx;
    return proto.BinanceSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceSignTx}
 */ proto.BinanceSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgCount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setAccountNumber(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setChainId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setSequence(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setSource(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeSint64String(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeSint64String(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeSint64String(7, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.BinanceSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint32 msg_count = 2;
 * @return {number}
 */ proto.BinanceSignTx.prototype.getMsgCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setMsgCount = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearMsgCount = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasMsgCount = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional sint64 account_number = 3;
 * @return {string}
 */ proto.BinanceSignTx.prototype.getAccountNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setAccountNumber = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearAccountNumber = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasAccountNumber = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string chain_id = 4;
 * @return {string}
 */ proto.BinanceSignTx.prototype.getChainId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string memo = 5;
 * @return {string}
 */ proto.BinanceSignTx.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional sint64 sequence = 6;
 * @return {string}
 */ proto.BinanceSignTx.prototype.getSequence = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional sint64 source = 7;
 * @return {string}
 */ proto.BinanceSignTx.prototype.getSource = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.setSource = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignTx} returns this
 */ proto.BinanceSignTx.prototype.clearSource = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignTx.prototype.hasSource = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceTxRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceTxRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceTxRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTxRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceTxRequest}
 */ proto.BinanceTxRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceTxRequest;
    return proto.BinanceTxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceTxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceTxRequest}
 */ proto.BinanceTxRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceTxRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceTxRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceTxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTxRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.BinanceTransferMsg.repeatedFields_ = [
    1,
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceTransferMsg.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceTransferMsg.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceTransferMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.toObject = function(includeInstance, msg) {
        var f, obj = {
            inputsList: $2MzPv.Message.toObjectList(msg.getInputsList(), proto.BinanceTransferMsg.BinanceInputOutput.toObject, includeInstance),
            outputsList: $2MzPv.Message.toObjectList(msg.getOutputsList(), proto.BinanceTransferMsg.BinanceInputOutput.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceTransferMsg}
 */ proto.BinanceTransferMsg.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceTransferMsg;
    return proto.BinanceTransferMsg.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceTransferMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceTransferMsg}
 */ proto.BinanceTransferMsg.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.BinanceTransferMsg.BinanceInputOutput;
                reader.readMessage(value, proto.BinanceTransferMsg.BinanceInputOutput.deserializeBinaryFromReader);
                msg.addInputs(value);
                break;
            case 2:
                var value = new proto.BinanceTransferMsg.BinanceInputOutput;
                reader.readMessage(value, proto.BinanceTransferMsg.BinanceInputOutput.deserializeBinaryFromReader);
                msg.addOutputs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceTransferMsg.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceTransferMsg.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceTransferMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInputsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.BinanceTransferMsg.BinanceInputOutput.serializeBinaryToWriter);
    f = message.getOutputsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.BinanceTransferMsg.BinanceInputOutput.serializeBinaryToWriter);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.BinanceTransferMsg.BinanceInputOutput.repeatedFields_ = [
    2
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceTransferMsg.BinanceInputOutput.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceTransferMsg.BinanceInputOutput} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.BinanceInputOutput.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            coinsList: $2MzPv.Message.toObjectList(msg.getCoinsList(), proto.BinanceTransferMsg.BinanceCoin.toObject, includeInstance),
            addressType: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput}
 */ proto.BinanceTransferMsg.BinanceInputOutput.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceTransferMsg.BinanceInputOutput;
    return proto.BinanceTransferMsg.BinanceInputOutput.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceTransferMsg.BinanceInputOutput} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput}
 */ proto.BinanceTransferMsg.BinanceInputOutput.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 2:
                var value = new proto.BinanceTransferMsg.BinanceCoin;
                reader.readMessage(value, proto.BinanceTransferMsg.BinanceCoin.deserializeBinaryFromReader);
                msg.addCoins(value);
                break;
            case 3:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceTransferMsg.BinanceInputOutput.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceTransferMsg.BinanceInputOutput} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.BinanceInputOutput.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = message.getCoinsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.BinanceTransferMsg.BinanceCoin.serializeBinaryToWriter);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeEnum(3, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated BinanceCoin coins = 2;
 * @return {!Array<!proto.BinanceTransferMsg.BinanceCoin>}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.getCoinsList = function() {
    return /** @type{!Array<!proto.BinanceTransferMsg.BinanceCoin>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.BinanceTransferMsg.BinanceCoin, 2);
};
/**
 * @param {!Array<!proto.BinanceTransferMsg.BinanceCoin>} value
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
*/ proto.BinanceTransferMsg.BinanceInputOutput.prototype.setCoinsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.BinanceTransferMsg.BinanceCoin=} opt_value
 * @param {number=} opt_index
 * @return {!proto.BinanceTransferMsg.BinanceCoin}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.addCoins = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.BinanceTransferMsg.BinanceCoin, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.clearCoinsList = function() {
    return this.setCoinsList([]);
};
/**
 * optional OutputAddressType address_type = 3;
 * @return {!proto.OutputAddressType}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput} returns this
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceTransferMsg.BinanceInputOutput.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceTransferMsg.BinanceCoin.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceTransferMsg.BinanceCoin} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.BinanceCoin.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceTransferMsg.BinanceCoin}
 */ proto.BinanceTransferMsg.BinanceCoin.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceTransferMsg.BinanceCoin;
    return proto.BinanceTransferMsg.BinanceCoin.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceTransferMsg.BinanceCoin} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceTransferMsg.BinanceCoin}
 */ proto.BinanceTransferMsg.BinanceCoin.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceTransferMsg.BinanceCoin.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceTransferMsg.BinanceCoin} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceTransferMsg.BinanceCoin.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeSint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional sint64 amount = 1;
 * @return {string}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceTransferMsg.BinanceCoin} returns this
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceTransferMsg.BinanceCoin} returns this
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string denom = 2;
 * @return {string}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceTransferMsg.BinanceCoin} returns this
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceTransferMsg.BinanceCoin} returns this
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceTransferMsg.BinanceCoin.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * repeated BinanceInputOutput inputs = 1;
 * @return {!Array<!proto.BinanceTransferMsg.BinanceInputOutput>}
 */ proto.BinanceTransferMsg.prototype.getInputsList = function() {
    return /** @type{!Array<!proto.BinanceTransferMsg.BinanceInputOutput>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.BinanceTransferMsg.BinanceInputOutput, 1);
};
/**
 * @param {!Array<!proto.BinanceTransferMsg.BinanceInputOutput>} value
 * @return {!proto.BinanceTransferMsg} returns this
*/ proto.BinanceTransferMsg.prototype.setInputsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.BinanceTransferMsg.BinanceInputOutput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput}
 */ proto.BinanceTransferMsg.prototype.addInputs = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.BinanceTransferMsg.BinanceInputOutput, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceTransferMsg} returns this
 */ proto.BinanceTransferMsg.prototype.clearInputsList = function() {
    return this.setInputsList([]);
};
/**
 * repeated BinanceInputOutput outputs = 2;
 * @return {!Array<!proto.BinanceTransferMsg.BinanceInputOutput>}
 */ proto.BinanceTransferMsg.prototype.getOutputsList = function() {
    return /** @type{!Array<!proto.BinanceTransferMsg.BinanceInputOutput>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.BinanceTransferMsg.BinanceInputOutput, 2);
};
/**
 * @param {!Array<!proto.BinanceTransferMsg.BinanceInputOutput>} value
 * @return {!proto.BinanceTransferMsg} returns this
*/ proto.BinanceTransferMsg.prototype.setOutputsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.BinanceTransferMsg.BinanceInputOutput=} opt_value
 * @param {number=} opt_index
 * @return {!proto.BinanceTransferMsg.BinanceInputOutput}
 */ proto.BinanceTransferMsg.prototype.addOutputs = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.BinanceTransferMsg.BinanceInputOutput, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.BinanceTransferMsg} returns this
 */ proto.BinanceTransferMsg.prototype.clearOutputsList = function() {
    return this.setOutputsList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceOrderMsg.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceOrderMsg.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceOrderMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceOrderMsg.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            ordertype: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            price: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            quantity: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            sender: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            side: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            symbol: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            timeinforce: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceOrderMsg}
 */ proto.BinanceOrderMsg.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceOrderMsg;
    return proto.BinanceOrderMsg.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceOrderMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceOrderMsg}
 */ proto.BinanceOrderMsg.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.BinanceOrderMsg.BinanceOrderType} */ reader.readEnum();
                msg.setOrdertype(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setPrice(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setQuantity(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 6:
                var value = /** @type {!proto.BinanceOrderMsg.BinanceOrderSide} */ reader.readEnum();
                msg.setSide(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSymbol(value);
                break;
            case 8:
                var value = /** @type {!proto.BinanceOrderMsg.BinanceTimeInForce} */ reader.readEnum();
                msg.setTimeinforce(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceOrderMsg.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceOrderMsg.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceOrderMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceOrderMsg.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {!proto.BinanceOrderMsg.BinanceOrderType} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeEnum(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeSint64String(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeSint64String(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {!proto.BinanceOrderMsg.BinanceOrderSide} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeEnum(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {!proto.BinanceOrderMsg.BinanceTimeInForce} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeEnum(8, f);
};
/**
 * @enum {number}
 */ proto.BinanceOrderMsg.BinanceOrderType = {
    OT_UNKNOWN: 0,
    MARKET: 1,
    LIMIT: 2,
    OT_RESERVED: 3
};
/**
 * @enum {number}
 */ proto.BinanceOrderMsg.BinanceOrderSide = {
    SIDE_UNKNOWN: 0,
    BUY: 1,
    SELL: 2
};
/**
 * @enum {number}
 */ proto.BinanceOrderMsg.BinanceTimeInForce = {
    TIF_UNKNOWN: 0,
    GTE: 1,
    TIF_RESERVED: 2,
    IOC: 3
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.BinanceOrderMsg.prototype.getId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setId = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearId = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasId = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional BinanceOrderType ordertype = 2;
 * @return {!proto.BinanceOrderMsg.BinanceOrderType}
 */ proto.BinanceOrderMsg.prototype.getOrdertype = function() {
    return /** @type {!proto.BinanceOrderMsg.BinanceOrderType} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.BinanceOrderMsg.BinanceOrderType} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setOrdertype = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearOrdertype = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasOrdertype = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional sint64 price = 3;
 * @return {string}
 */ proto.BinanceOrderMsg.prototype.getPrice = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setPrice = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearPrice = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasPrice = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional sint64 quantity = 4;
 * @return {string}
 */ proto.BinanceOrderMsg.prototype.getQuantity = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "0");
};
/**
 * @param {string} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setQuantity = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearQuantity = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasQuantity = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string sender = 5;
 * @return {string}
 */ proto.BinanceOrderMsg.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional BinanceOrderSide side = 6;
 * @return {!proto.BinanceOrderMsg.BinanceOrderSide}
 */ proto.BinanceOrderMsg.prototype.getSide = function() {
    return /** @type {!proto.BinanceOrderMsg.BinanceOrderSide} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.BinanceOrderMsg.BinanceOrderSide} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setSide = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearSide = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasSide = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string symbol = 7;
 * @return {string}
 */ proto.BinanceOrderMsg.prototype.getSymbol = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setSymbol = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearSymbol = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasSymbol = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional BinanceTimeInForce timeinforce = 8;
 * @return {!proto.BinanceOrderMsg.BinanceTimeInForce}
 */ proto.BinanceOrderMsg.prototype.getTimeinforce = function() {
    return /** @type {!proto.BinanceOrderMsg.BinanceTimeInForce} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {!proto.BinanceOrderMsg.BinanceTimeInForce} value
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.setTimeinforce = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceOrderMsg} returns this
 */ proto.BinanceOrderMsg.prototype.clearTimeinforce = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceOrderMsg.prototype.hasTimeinforce = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceCancelMsg.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceCancelMsg.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceCancelMsg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceCancelMsg.toObject = function(includeInstance, msg) {
        var f, obj = {
            refid: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            sender: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            symbol: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceCancelMsg}
 */ proto.BinanceCancelMsg.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceCancelMsg;
    return proto.BinanceCancelMsg.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceCancelMsg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceCancelMsg}
 */ proto.BinanceCancelMsg.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setRefid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSymbol(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceCancelMsg.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceCancelMsg.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceCancelMsg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceCancelMsg.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
};
/**
 * optional string refid = 1;
 * @return {string}
 */ proto.BinanceCancelMsg.prototype.getRefid = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.setRefid = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.clearRefid = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceCancelMsg.prototype.hasRefid = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string sender = 2;
 * @return {string}
 */ proto.BinanceCancelMsg.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceCancelMsg.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string symbol = 3;
 * @return {string}
 */ proto.BinanceCancelMsg.prototype.getSymbol = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.setSymbol = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceCancelMsg} returns this
 */ proto.BinanceCancelMsg.prototype.clearSymbol = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceCancelMsg.prototype.hasSymbol = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.BinanceSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.BinanceSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.BinanceSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            signature: msg.getSignature_asB64(),
            publicKey: msg.getPublicKey_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.BinanceSignedTx}
 */ proto.BinanceSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.BinanceSignedTx;
    return proto.BinanceSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.BinanceSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.BinanceSignedTx}
 */ proto.BinanceSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.BinanceSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.BinanceSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.BinanceSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.BinanceSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes signature = 1;
 * @return {!(string|Uint8Array)}
 */ proto.BinanceSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes signature = 1;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.BinanceSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.BinanceSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.BinanceSignedTx} returns this
 */ proto.BinanceSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignedTx} returns this
 */ proto.BinanceSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes public_key = 2;
 * @return {!(string|Uint8Array)}
 */ proto.BinanceSignedTx.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes public_key = 2;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.BinanceSignedTx.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.BinanceSignedTx.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.BinanceSignedTx} returns this
 */ proto.BinanceSignedTx.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.BinanceSignedTx} returns this
 */ proto.BinanceSignedTx.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.BinanceSignedTx.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$ce54469dbed45e7f$var$goog.object.extend($ce54469dbed45e7f$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $hqAsy = parcelRequire("hqAsy");

var $kWcCv = parcelRequire("kWcCv");

var $hQ2c4 = parcelRequire("hQ2c4");

var $kWcCv = parcelRequire("kWcCv");

var $bAAqK = parcelRequire("bAAqK");

var $ihoyg = parcelRequire("ihoyg");
var $2530c6d6f9fff4bc$require$Buffer = $ihoyg.Buffer;
function $2530c6d6f9fff4bc$export$f2f3614b968eb2e6(txBytes, chainId) {
    const txDecoded = $hQ2c4.amino.decoder.unMarshalBinaryLengthPrefixed(txBytes, {
        aminoPrefix: "f0625dee",
        msgs: [
            {
                aminoPrefix: "2a2c87fa",
                inputs: [
                    {
                        address: $2530c6d6f9fff4bc$require$Buffer.alloc(0),
                        coins: [
                            {
                                denom: "",
                                amount: 0
                            }
                        ]
                    }
                ],
                outputs: [
                    {
                        address: $2530c6d6f9fff4bc$require$Buffer.alloc(0),
                        coins: [
                            {
                                denom: "",
                                amount: 0
                            }
                        ]
                    }
                ]
            }
        ],
        signatures: [
            {
                pubKey: $2530c6d6f9fff4bc$require$Buffer.alloc(0),
                signature: $2530c6d6f9fff4bc$require$Buffer.alloc(0),
                accountNumber: 0,
                sequence: 0
            }
        ],
        memo: "",
        source: 0,
        data: $2530c6d6f9fff4bc$require$Buffer.alloc(0)
    }).val;
    if (txDecoded.data !== null) throw new Error("bad data length");
    if (txDecoded.msgs.length !== 1) throw new Error("bad msgs length");
    if (txDecoded.signatures.length !== 1) throw new Error("bad signatures length");
    const signBytes = JSON.stringify({
        account_number: String(txDecoded.signatures[0].accountNumber),
        chain_id: chainId,
        data: null,
        memo: txDecoded.memo,
        msgs: [
            {
                inputs: txDecoded.msgs[0].inputs.map((x)=>({
                        address: $hQ2c4.crypto.encodeAddress(x.address, "bnb"),
                        coins: x.coins.map((y)=>({
                                amount: Number(y.amount),
                                denom: y.denom
                            }))
                    })),
                outputs: txDecoded.msgs[0].outputs.map((x)=>({
                        address: $hQ2c4.crypto.encodeAddress(x.address, "bnb"),
                        coins: x.coins.map((y)=>({
                                amount: Number(y.amount),
                                denom: y.denom
                            }))
                    }))
            }
        ],
        sequence: String(txDecoded.signatures[0].sequence),
        source: String(txDecoded.source)
    });
    const signBytesHash = (0, (/*@__PURE__*/$parcel$interopDefault($kWcCv))).SHA256((0, (/*@__PURE__*/$parcel$interopDefault($kWcCv))).enc.Utf8.parse(signBytes)).toString();
    const pubKeyAmino = $2530c6d6f9fff4bc$require$Buffer.from(txDecoded.signatures[0].pubKey);
    if (pubKeyAmino.readUInt32BE(0) !== 0xeb5ae987) throw new Error("bad pubkey aminoPrefix");
    if (pubKeyAmino.readUInt8(4) !== 33) throw new Error("bad pubKey length");
    const pubKey = pubKeyAmino.slice(5);
    const signature = txDecoded.signatures[0].signature;
    return {
        signBytes: signBytes,
        signBytesHash: signBytesHash,
        pubKey: pubKey,
        signature: signature
    };
}
function $2530c6d6f9fff4bc$export$240e37a89601cf1d(txBytes, chainId) {
    const { signBytesHash: signBytesHash, pubKey: pubKey, signature: signature } = $2530c6d6f9fff4bc$export$f2f3614b968eb2e6(txBytes, chainId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bAAqK))).verify($2530c6d6f9fff4bc$require$Buffer.from(signBytesHash, "hex"), pubKey, signature);
}
function $2530c6d6f9fff4bc$export$dac152b62be3d268(unsignedTx, publicKey, signature) {
    const { account_number: account_number, chain_id: chain_id, sequence: sequence, source: source } = unsignedTx;
    const msg = unsignedTx.msgs[0];
    const amountToInt = (x)=>Number(x);
    const msgNormalizer = (x)=>({
            address: $hQ2c4.crypto.decodeAddress(x.address),
            coins: x.coins.map((y)=>({
                    // In particular, these keys are backwards because we can't have nice things.
                    denom: y.denom,
                    amount: amountToInt(y.amount)
                }))
        });
    const baseMsg = {
        inputs: msg.inputs.map(msgNormalizer),
        outputs: msg.outputs.map(msgNormalizer),
        aminoPrefix: "2A2C87FA"
    };
    const tx = new $hQ2c4.Transaction(Object.assign({}, unsignedTx, {
        chainId: chain_id,
        accountNumber: Number(account_number),
        source: Number(source ?? 0),
        sequence: Number(sequence),
        // A bug in the binance SDK makes this field required, even though it shouldn't be.
        baseMsg: {
            getMsg: ()=>baseMsg,
            getBaseMsg: ()=>baseMsg,
            getSignMsg: ()=>baseMsg
        }
    }));
    const ecPubKey = $hQ2c4.crypto.getPublicKey($2530c6d6f9fff4bc$require$Buffer.from(publicKey).toString("hex"));
    tx.addSignature(ecPubKey, signature);
    const serializedTx = $2530c6d6f9fff4bc$require$Buffer.from(tx.serialize(), "hex");
    if (!$2530c6d6f9fff4bc$export$240e37a89601cf1d(serializedTx, chain_id)) throw new Error("serialized tx did not validate");
    return serializedTx;
}



var $ihoyg = parcelRequire("ihoyg");
var $1df2ffc82308ac2c$require$Buffer = $ihoyg.Buffer;
function $1df2ffc82308ac2c$export$90044b61b3ecd340(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Binance"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $1df2ffc82308ac2c$export$baabfb5b222781c7(transport, msg) {
    return transport.lockDuring(async ()=>{
        if (msg.testnet) throw new Error("testnet not supported");
        const partialTx = Object.assign({}, msg.tx);
        if (!partialTx.data) partialTx.data = null;
        if (!partialTx.memo) partialTx.memo = "";
        if (!partialTx.sequence) partialTx.sequence = "0";
        if (!partialTx.source) partialTx.source = "0";
        if (!partialTx.account_number) throw new Error("account_number is required");
        if (!partialTx.chain_id) throw new Error("chain_id is required");
        const tx = partialTx;
        if (tx.data) throw new Error("tx data field not supported");
        const signTx = new $ce54469dbed45e7f$exports.BinanceSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setAccountNumber(tx.account_number);
        signTx.setChainId(tx.chain_id);
        signTx.setSequence(tx.sequence);
        if (tx.memo) signTx.setMemo(tx.memo);
        //verify not a batch tx
        if (msg.tx.msgs.length > 1) throw new Error("Binance batch sending not supported!");
        const message = msg.tx.msgs[0];
        //tell device not a batch tx
        signTx.setMsgCount(1);
        //tell device im about to send a tx to sign
        let resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BINANCESIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        const outputAmount = new (0, (/*@__PURE__*/$parcel$interopDefault($hqAsy)))(message.outputs[0].coins[0].amount);
        const inputAmount = new (0, (/*@__PURE__*/$parcel$interopDefault($hqAsy)))(message.inputs[0].coins[0].amount);
        if (!outputAmount.isInteger()) throw new Error("Output amount must be an integer");
        if (!inputAmount.isInteger()) throw new Error("Input amount must be an integer");
        const coinOut = new $ce54469dbed45e7f$exports.BinanceTransferMsg.BinanceCoin();
        coinOut.setAmount(outputAmount.toString());
        coinOut.setDenom(message.outputs[0].coins[0].denom);
        const outputs = new $ce54469dbed45e7f$exports.BinanceTransferMsg.BinanceInputOutput();
        outputs.setAddress(message.outputs[0].address);
        outputs.setCoinsList([
            coinOut
        ]);
        const coinIn = new $ce54469dbed45e7f$exports.BinanceTransferMsg.BinanceCoin();
        coinIn.setAmount(inputAmount.toString());
        coinIn.setDenom(message.inputs[0].coins[0].denom);
        const inputs = new $ce54469dbed45e7f$exports.BinanceTransferMsg.BinanceInputOutput();
        inputs.setAddress(message.inputs[0].address);
        inputs.setCoinsList([
            coinIn
        ]);
        const send = new $ce54469dbed45e7f$exports.BinanceTransferMsg();
        send.addInputs(inputs);
        send.addOutputs(outputs);
        //sent tx to device
        resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BINANCETRANSFERMSG, send, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BINANCESIGNEDTX) throw new Error(`binance: unexpected response ${resp.message_type}`);
        const signedTx = new $ce54469dbed45e7f$exports.BinanceSignedTx();
        signedTx.setSignature(resp.message.signature);
        signedTx.setPublicKey(resp.message.publicKey);
        const serialized = (0, $2530c6d6f9fff4bc$export$dac152b62be3d268)(tx, $1df2ffc82308ac2c$require$Buffer.from(signedTx.getPublicKey_asU8()), $1df2ffc82308ac2c$require$Buffer.from(signedTx.getSignature_asU8())).toString("hex");
        const out = {
            ...tx,
            signatures: {
                pub_key: signedTx.getPublicKey_asB64(),
                signature: signedTx.getSignature_asB64()
            },
            serialized: serialized,
            txid: (0, (/*@__PURE__*/$parcel$interopDefault($kWcCv))).SHA256((0, (/*@__PURE__*/$parcel$interopDefault($kWcCv))).enc.Hex.parse(serialized)).toString()
        };
        return out;
    });
}
async function $1df2ffc82308ac2c$export$d0c430e0a91cb179(transport, msg) {
    const getAddr = new $ce54469dbed45e7f$exports.BinanceGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BINANCEGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const binanceAddress = response.proto;
    return $7NkOr.mustBeDefined(binanceAddress.getAddress());
}




parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");
var $6iw60 = parcelRequire("6iw60");
var $3a5kd = parcelRequire("3a5kd");

var $1JUZg = parcelRequire("1JUZg");

var $bhJ7Q = parcelRequire("bhJ7Q");
var $ced2e61e6d0d8d17$exports = {};
/**
 * This allows you to work with object hierarchies that have been frozen
 * with Object.freeze().  "get" operations can use the normal JS syntax,
 * but operations that modify the data will have to return partial copies of
 * the structure. The portions of the structure that did not change will
 * === their previous values.
 *
 * Inspired by clojure/mori and Immutable.js
 */ "use strict";
const $ced2e61e6d0d8d17$var$i = $ced2e61e6d0d8d17$exports;
const $ced2e61e6d0d8d17$var$identity = (coll)=>coll;
// we only care about objects or arrays for now
const $ced2e61e6d0d8d17$var$weCareAbout = (val)=>val !== null && (Array.isArray(val) || // This will skip objects created with `new Foo()`
    // and objects created with `Object.create(proto)`
    // The benefit is ignoring DOM elements and event emitters,
    // which are often circular.
    $ced2e61e6d0d8d17$var$isObjectLike(val));
const $ced2e61e6d0d8d17$var$isObjectLike = (val)=>typeof val === "object" && (val.constructor === Object || val.constructor == null) && (Object.getPrototypeOf(val) === Object.prototype || Object.getPrototypeOf(val) === null);
const $ced2e61e6d0d8d17$var$forKeys = (obj, iter)=>{
    let idx, keys;
    if (Array.isArray(obj)) {
        idx = obj.length;
        while(idx--)iter(idx);
        return;
    }
    keys = Object.keys(obj);
    idx = keys.length;
    while(idx--)iter(keys[idx]);
};
const $ced2e61e6d0d8d17$var$cloneObj = (obj)=>{
    const newObj = obj.constructor == null ? Object.create(null) : {};
    const keys = Object.keys(obj);
    let idx = keys.length;
    let key;
    while(idx--){
        key = keys[idx];
        newObj[key] = obj[key];
    }
    return newObj;
};
const $ced2e61e6d0d8d17$var$clone = (coll)=>{
    if (Array.isArray(coll)) return coll.slice();
    else return $ced2e61e6d0d8d17$var$cloneObj(coll);
};
const $ced2e61e6d0d8d17$var$freezeIfNeeded = $ced2e61e6d0d8d17$var$identity;
const $ced2e61e6d0d8d17$var$_freeze = $ced2e61e6d0d8d17$var$identity;
const $ced2e61e6d0d8d17$var$prevNodes = [];
const $ced2e61e6d0d8d17$var$baseFreeze = (coll)=>{
    if ($ced2e61e6d0d8d17$var$prevNodes.some((val)=>val === coll)) throw new Error("object has a reference cycle");
    $ced2e61e6d0d8d17$var$prevNodes.push(coll);
    $ced2e61e6d0d8d17$var$forKeys(coll, (key)=>{
        const prop = coll[key];
        if ($ced2e61e6d0d8d17$var$weCareAbout(prop)) $ced2e61e6d0d8d17$var$baseFreeze(prop);
    });
    $ced2e61e6d0d8d17$var$prevNodes.pop();
    Object.freeze(coll);
    return coll;
};
/**
 * recrursively freeze an object and all its child objects
 * @param  {Object|Array} coll
 * @return {Object|Array}
 */ $ced2e61e6d0d8d17$exports.freeze = $ced2e61e6d0d8d17$var$identity;
/**
 * recursively un-freeze an object, by cloning frozen collections
 * @param  {[type]} coll [description]
 * @return {[type]}      [description]
 */ $ced2e61e6d0d8d17$exports.thaw = function thaw(coll) {
    if (!$ced2e61e6d0d8d17$var$weCareAbout(coll) || !Object.isFrozen(coll)) return coll;
    const newColl = Array.isArray(coll) ? new Array(coll.length) : {};
    $ced2e61e6d0d8d17$var$forKeys(coll, (key)=>{
        newColl[key] = thaw(coll[key]);
    });
    return newColl;
};
/**
 * set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key   Key or index
 * @param  {Object}        value
 * @return {Object|Array}        new object hierarchy with modifications
 */ $ced2e61e6d0d8d17$exports.assoc = function assoc(coll, key, value) {
    if (coll[key] === value) return $ced2e61e6d0d8d17$var$_freeze(coll);
    const newObj = $ced2e61e6d0d8d17$var$clone(coll);
    newObj[key] = $ced2e61e6d0d8d17$var$freezeIfNeeded(value);
    return $ced2e61e6d0d8d17$var$_freeze(newObj);
};
$ced2e61e6d0d8d17$exports.set = $ced2e61e6d0d8d17$exports.assoc;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {String|Number} key  Key or Index
 * @return {Object|Array}       New object or array
 */ $ced2e61e6d0d8d17$exports.dissoc = function dissoc(coll, key) {
    const newObj = $ced2e61e6d0d8d17$var$clone(coll);
    delete newObj[key];
    return $ced2e61e6d0d8d17$var$_freeze(newObj);
};
$ced2e61e6d0d8d17$exports.unset = $ced2e61e6d0d8d17$exports.dissoc;
/**
 * set a value deep in a hierarchical structure
 * @param  {Object|Array} coll
 * @param  {Array}        path    A list of keys to traverse
 * @param  {Object}       value
 * @return {Object|Array}       new object hierarchy with modifications
 */ $ced2e61e6d0d8d17$exports.assocIn = function assocIn(coll, path, value) {
    const key0 = path[0];
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple assoc.
    return $ced2e61e6d0d8d17$var$i.assoc(coll, key0, value);
    else // break the problem down.  Assoc this object with the first key
    // and the result of assocIn with the rest of the keys
    return $ced2e61e6d0d8d17$var$i.assoc(coll, key0, assocIn(coll[key0] || {}, path.slice(1), value));
};
$ced2e61e6d0d8d17$exports.setIn = $ced2e61e6d0d8d17$exports.assocIn;
/**
 * un-set a value on an object or array
 * @param  {Object|Array}  coll
 * @param  {Array} path  A list of keys to traverse
 * @return {Object|Array}       New object or array
 */ $ced2e61e6d0d8d17$exports.dissocIn = function dissocIn(coll, path) {
    const key0 = path[0];
    if (!coll.hasOwnProperty(key0)) return coll;
    if (path.length === 1) // simplest case is a 1-element array.  Just a simple dissoc.
    return $ced2e61e6d0d8d17$var$i.dissoc(coll, key0);
    else // break the problem down.  Assoc this object with the first key
    // and the result of dissocIn with the rest of the keys
    return $ced2e61e6d0d8d17$var$i.assoc(coll, key0, dissocIn(coll[key0], path.slice(1)));
};
$ced2e61e6d0d8d17$exports.unsetIn = $ced2e61e6d0d8d17$exports.dissocIn;
/**
 * get an object from a hierachy based on an array of keys
 * @param  {Object|Array} coll
 * @param  {Array}        path    list of keys
 * @return {Object}       value, or undefined
 */ function $ced2e61e6d0d8d17$var$baseGet(coll, path) {
    return (path || []).reduce((curr, key)=>{
        if (!curr) return;
        return curr[key];
    }, coll);
}
$ced2e61e6d0d8d17$exports.getIn = $ced2e61e6d0d8d17$var$baseGet;
/**
 * Update a value in a hierarchy
 * @param  {Object|Array}   coll
 * @param  {Array}          path     list of keys
 * @param  {Function} callback The existing value with be passed to this.
 *                             Return the new value to set
 * @return {Object|Array}      new object hierarchy with modifications
 */ $ced2e61e6d0d8d17$exports.updateIn = function updateIn(coll, path, callback) {
    const existingVal = $ced2e61e6d0d8d17$var$baseGet(coll, path);
    return $ced2e61e6d0d8d17$var$i.assocIn(coll, path, callback(existingVal));
};
// generate wrappers for the mutative array methods
[
    "push",
    "unshift",
    "pop",
    "shift",
    "reverse",
    "sort"
].forEach((methodName)=>{
    $ced2e61e6d0d8d17$exports[methodName] = function(arr, val) {
        const newArr = [
            ...arr
        ];
        newArr[methodName]($ced2e61e6d0d8d17$var$freezeIfNeeded(val));
        return $ced2e61e6d0d8d17$var$_freeze(newArr);
    };
    $ced2e61e6d0d8d17$exports[methodName].displayName = "icepick." + methodName;
});
// splice is special because it is variadic
$ced2e61e6d0d8d17$exports.splice = function splice(arr, ..._args) {
    const newArr = [
        ...arr
    ];
    const args = _args.map($ced2e61e6d0d8d17$var$freezeIfNeeded);
    newArr.splice.apply(newArr, args);
    return $ced2e61e6d0d8d17$var$_freeze(newArr);
};
// slice is non-mutative
$ced2e61e6d0d8d17$exports.slice = function slice(arr, arg1, arg2) {
    const newArr = arr.slice(arg1, arg2);
    return $ced2e61e6d0d8d17$var$_freeze(newArr);
};
[
    "map",
    "filter"
].forEach((methodName)=>{
    $ced2e61e6d0d8d17$exports[methodName] = function(fn, arr) {
        const newArr = arr[methodName](fn);
        return $ced2e61e6d0d8d17$var$_freeze(newArr);
    };
    $ced2e61e6d0d8d17$exports[methodName].displayName = "icepick." + methodName;
});
$ced2e61e6d0d8d17$exports.extend = $ced2e61e6d0d8d17$exports.assign = function assign(obj, ...objs) {
    const newObj = objs.reduce($ced2e61e6d0d8d17$var$singleAssign, obj);
    return $ced2e61e6d0d8d17$var$_freeze(newObj);
};
function $ced2e61e6d0d8d17$var$singleAssign(obj1, obj2) {
    return Object.keys(obj2).reduce((obj, key)=>{
        return $ced2e61e6d0d8d17$var$i.assoc(obj, key, obj2[key]);
    }, obj1);
}
$ced2e61e6d0d8d17$exports.merge = $ced2e61e6d0d8d17$var$merge;
function $ced2e61e6d0d8d17$var$merge(target, source, resolver) {
    if (target == null || source == null) return target;
    return Object.keys(source).reduce((obj, key)=>{
        const sourceVal = source[key];
        const targetVal = obj[key];
        const resolvedSourceVal = resolver ? resolver(targetVal, sourceVal, key) : sourceVal;
        if ($ced2e61e6d0d8d17$var$weCareAbout(sourceVal) && $ced2e61e6d0d8d17$var$weCareAbout(targetVal)) {
            // if they are both frozen and reference equal, assume they are deep equal
            if (resolvedSourceVal === targetVal && true) return obj;
            if (Array.isArray(sourceVal)) return $ced2e61e6d0d8d17$var$i.assoc(obj, key, resolvedSourceVal);
            // recursively merge pairs of objects
            return $ced2e61e6d0d8d17$var$assocIfDifferent(obj, key, $ced2e61e6d0d8d17$var$merge(targetVal, resolvedSourceVal, resolver));
        }
        // primitive values, stuff with prototypes
        return $ced2e61e6d0d8d17$var$assocIfDifferent(obj, key, resolvedSourceVal);
    }, target);
}
function $ced2e61e6d0d8d17$var$assocIfDifferent(target, key, value) {
    if (target[key] === value) return target;
    return $ced2e61e6d0d8d17$var$i.assoc(target, key, value);
}
const $ced2e61e6d0d8d17$var$chainProto = {
    value: function value() {
        return this.val;
    },
    thru: function thru(fn) {
        this.val = $ced2e61e6d0d8d17$var$freezeIfNeeded(fn(this.val));
        return this;
    }
};
Object.keys($ced2e61e6d0d8d17$exports).forEach((methodName)=>{
    if (methodName.match(/^(map|filter)$/)) {
        $ced2e61e6d0d8d17$var$chainProto[methodName] = function(fn) {
            this.val = $ced2e61e6d0d8d17$exports[methodName](fn, this.val);
            return this;
        };
        return;
    }
    $ced2e61e6d0d8d17$var$chainProto[methodName] = function(...args) {
        this.val = $ced2e61e6d0d8d17$exports[methodName](this.val, ...args);
        return this;
    };
});
$ced2e61e6d0d8d17$exports.chain = function chain(val) {
    const wrapped = Object.create($ced2e61e6d0d8d17$var$chainProto);
    wrapped.val = val;
    return wrapped;
};



parcelRequire("lFpDy");
var $6iw60 = parcelRequire("6iw60");
const $18acccdd0f9aa659$export$3992177e206fbb4d = 63;
function $18acccdd0f9aa659$export$7f2590ea4e77478c(fieldName) {
    return `set${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)}`;
}
function $18acccdd0f9aa659$export$d9791cdfbd60a48f(str) {
    const utf8 = [];
    for(let i = 0; i < str.length; i++){
        let charcode = str.charCodeAt(i);
        if (charcode < 0x80) utf8.push(charcode);
        else if (charcode < 0x800) utf8.push(0xc0 | charcode >> 6, 0x80 | charcode & 0x3f);
        else if (charcode < 0xd800 || charcode >= 0xe000) utf8.push(0xe0 | charcode >> 12, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        else {
            i++;
            charcode = (charcode & 0x3ff) << 10 | str.charCodeAt(i) & 0x3ff;
            utf8.push(0xf0 | charcode >> 18, 0x80 | charcode >> 12 & 0x3f, 0x80 | charcode >> 6 & 0x3f, 0x80 | charcode & 0x3f);
        }
    }
    return new Uint8Array(utf8);
}
function $18acccdd0f9aa659$export$299f78d99cd9b58c(scriptType) {
    switch(scriptType){
        case $6iw60.BTCInputScriptType.CashAddr:
        case $6iw60.BTCInputScriptType.SpendAddress:
            return $d4cdf7121546d3d6$exports.InputScriptType.SPENDADDRESS;
        case $6iw60.BTCInputScriptType.SpendMultisig:
            return $d4cdf7121546d3d6$exports.InputScriptType.SPENDMULTISIG;
        case $6iw60.BTCInputScriptType.SpendP2SHWitness:
            return $d4cdf7121546d3d6$exports.InputScriptType.SPENDP2SHWITNESS;
        case $6iw60.BTCInputScriptType.SpendWitness:
            return $d4cdf7121546d3d6$exports.InputScriptType.SPENDWITNESS;
    }
    throw new Error("unhandled InputSriptType enum: " + scriptType);
}
function $18acccdd0f9aa659$export$ee9477f9f04c6569(scriptType) {
    switch(scriptType){
        case $6iw60.BTCOutputScriptType.PayToAddress:
            return $d4cdf7121546d3d6$exports.OutputScriptType.PAYTOADDRESS;
        case $6iw60.BTCOutputScriptType.PayToMultisig:
            return $d4cdf7121546d3d6$exports.OutputScriptType.PAYTOMULTISIG;
        case $6iw60.BTCOutputScriptType.PayToP2SHWitness:
            return $d4cdf7121546d3d6$exports.OutputScriptType.PAYTOP2SHWITNESS;
        case $6iw60.BTCOutputScriptType.PayToWitness:
            return $d4cdf7121546d3d6$exports.OutputScriptType.PAYTOWITNESS;
    }
    throw new Error("unhandled OutputScriptType enum: " + scriptType);
}



var $ihoyg = parcelRequire("ihoyg");
var $0396a8ef29b63193$require$Buffer = $ihoyg.Buffer;
// FIXME: load this from the device's coin table, or from some static features
// table... instead of, you know, adding another God-forsaken coin table.
// :facepalm:
const $0396a8ef29b63193$var$supportedCoins = [
    "Bitcoin",
    "Testnet",
    "BitcoinCash",
    "BitcoinGold",
    "Litecoin",
    "Dash",
    "DigiByte",
    "Dogecoin"
];
const $0396a8ef29b63193$var$segwitCoins = [
    "Bitcoin",
    "Testnet",
    "BitcoinGold",
    "Litecoin"
];
function $0396a8ef29b63193$var$legacyAccount(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: $6iw60.BTCInputScriptType.SpendAddress,
        addressNList: [
            2147483692,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}
function $0396a8ef29b63193$var$segwitAccount(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: $6iw60.BTCInputScriptType.SpendP2SHWitness,
        addressNList: [
            2147483697,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}
function $0396a8ef29b63193$var$segwitNativeAccount(coin, slip44, accountIdx) {
    return {
        coin: coin,
        scriptType: $6iw60.BTCInputScriptType.SpendWitness,
        addressNList: [
            2147483732,
            0x80000000 + slip44,
            0x80000000 + accountIdx
        ]
    };
}
function $0396a8ef29b63193$var$packVarint(n) {
    if (n < 253) return n.toString(16).padStart(2, "0");
    else if (n < 0xffff) return "FD" + n.toString(16).padStart(4, "0");
    else if (n < 0xffffffff) return "FE" + n.toString(16).padStart(8, "0");
    else return "FF" + n.toString(16).padStart(16, "0");
}
function $0396a8ef29b63193$var$prepareSignTx(coin, inputs, outputs) {
    const unsignedTx = new $d4cdf7121546d3d6$exports.TransactionType();
    unsignedTx.setInputsCnt(inputs.length);
    unsignedTx.setOutputsCnt(outputs.length);
    inputs.forEach((input, i)=>{
        const utxo = new $d4cdf7121546d3d6$exports.TxInputType();
        utxo.setPrevHash($7NkOr.fromHexString(input.txid));
        utxo.setPrevIndex(input.vout);
        if (input.sequence !== undefined) utxo.setSequence(input.sequence);
        utxo.setScriptType((0, $18acccdd0f9aa659$export$299f78d99cd9b58c)(input.scriptType));
        utxo.setAddressNList(input.addressNList);
        utxo.setAmount(Number(input.amount));
        unsignedTx.addInputs(utxo, i);
    });
    outputs.forEach((o, k)=>{
        const output = o;
        const newOutput = new $d4cdf7121546d3d6$exports.TxOutputType();
        newOutput.setAmount(Number(output.amount));
        // map to BCH address format
        if (coin === "BitcoinCash") {
            if (output.address && !output.address.startsWith("bitcoincash:")) output.address = "bitcoincash:" + output.address;
        }
        if (output.isChange || output.addressType === $6iw60.BTCOutputAddressType.Transfer) {
            // BTCSignTxOutputTranfer ||  BTCSignTxOutputChange
            newOutput.setScriptType((0, $18acccdd0f9aa659$export$ee9477f9f04c6569)(output.scriptType));
            newOutput.setAddressNList(output.addressNList);
            newOutput.setAddressType(output.isChange ? $d4cdf7121546d3d6$exports.OutputAddressType.CHANGE : $d4cdf7121546d3d6$exports.OutputAddressType.TRANSFER);
        } else if (output.opReturnData !== undefined && output.opReturnData !== null) {
            // BTCSignTxOutputMemo
            newOutput.setScriptType($d4cdf7121546d3d6$exports.OutputScriptType.PAYTOOPRETURN);
            newOutput.setAddressType($d4cdf7121546d3d6$exports.OutputAddressType.SPEND);
            newOutput.setOpReturnData(output.opReturnData);
        } else {
            // BTCSignTxOutputSpend
            newOutput.setScriptType($d4cdf7121546d3d6$exports.OutputScriptType.PAYTOADDRESS);
            (0, (/*@__PURE__*/$parcel$interopDefault($bhJ7Q)))(output.address !== undefined, "Output must have a valid BTC address.");
            newOutput.setAddress(output.address);
            newOutput.setAddressType($d4cdf7121546d3d6$exports.OutputAddressType.SPEND);
        }
        unsignedTx.addOutputs(newOutput, k);
    });
    const txmap = {}; // Create a map of transactions by txid needed for the KeepKey signing flow.
    txmap["unsigned"] = unsignedTx;
    const forceBip143Coins = [
        "BitcoinGold",
        "BitcoinCash",
        "BitcoinSV"
    ];
    if (forceBip143Coins.includes(coin)) return txmap;
    inputs.forEach((inputTx)=>{
        if (inputTx.txid in txmap) return;
        if (inputTx.scriptType === $6iw60.BTCInputScriptType.SpendP2SHWitness || inputTx.scriptType === $6iw60.BTCInputScriptType.SpendWitness || inputTx.scriptType === $6iw60.BTCInputScriptType.External) return;
        const prevTx = (()=>{
            if (inputTx.tx) return inputTx.tx;
            if (!inputTx.hex) throw new Error("non-segwit inputs must have the associated prev tx");
            const tx = $1JUZg.Transaction.fromHex(inputTx.hex);
            return {
                version: tx.version,
                locktime: tx.locktime,
                vin: tx.ins.map((input)=>({
                        txid: $0396a8ef29b63193$require$Buffer.from(input.hash).reverse().toString("hex"),
                        vout: input.index,
                        scriptSig: {
                            hex: input.script.toString("hex")
                        },
                        sequence: input.sequence
                    })),
                vout: tx.outs.map((output)=>({
                        value: String(output.value),
                        scriptPubKey: {
                            hex: output.script.toString("hex")
                        }
                    }))
            };
        })();
        const tx = new $d4cdf7121546d3d6$exports.TransactionType();
        tx.setVersion(prevTx.version);
        tx.setLockTime(prevTx.locktime);
        tx.setInputsCnt(prevTx.vin.length);
        tx.setOutputsCnt(prevTx.vout.length);
        prevTx.vin.forEach((vin, i)=>{
            const txInput = new $d4cdf7121546d3d6$exports.TxInputType();
            if ("coinbase" in vin) {
                txInput.setPrevHash($7NkOr.fromHexString("\x00".repeat(64)));
                txInput.setPrevIndex(0xffffffff);
                txInput.setScriptSig($7NkOr.fromHexString($7NkOr.mustBeDefined(vin.coinbase)));
                txInput.setSequence(vin.sequence);
            } else {
                txInput.setPrevHash($7NkOr.fromHexString(vin.txid));
                txInput.setPrevIndex(vin.vout);
                txInput.setScriptSig($7NkOr.fromHexString(vin.scriptSig.hex));
                txInput.setSequence(vin.sequence);
            }
            tx.addInputs(txInput, i);
        });
        prevTx.vout.forEach((vout, i)=>{
            const txOutput = new $d4cdf7121546d3d6$exports.TxOutputBinType();
            txOutput.setAmount(Number(vout.value));
            txOutput.setScriptPubkey($7NkOr.fromHexString(vout.scriptPubKey.hex));
            tx.addBinOutputs(txOutput, i);
        });
        if (coin === "Dash") {
            const dip2_type = prevTx.type || 0;
            // DIP2 Special Tx with payload
            if (prevTx.version === 3 && dip2_type !== 0) {
                if (!prevTx.extraPayload) throw new Error("Payload missing in DIP2 transaction");
                tx.setExtraData($7NkOr.fromHexString($0396a8ef29b63193$var$packVarint(prevTx.extraPayload.length * 2) + prevTx.extraPayload));
            }
            // Trezor (and therefore KeepKey) firmware doesn't understand the
            // split of version and type, so let's mimic the old serialization
            // format
            tx.setVersion(prevTx.version | dip2_type << 16);
        }
        txmap[inputTx.txid] = tx;
    });
    return txmap;
}
async function $0396a8ef29b63193$var$ensureCoinSupport(wallet, coin) {
    if (!$0396a8ef29b63193$var$supportedCoins.includes(coin)) throw new Error(`'${coin}' not yet supported in HDWalletKeepKey`);
    if (!wallet.btcSupportsCoin(coin)) throw new Error(`'${coin} is not supported in this firmware version`);
}
function $0396a8ef29b63193$var$validateVoutOrdering(msg) {
    // From THORChain specification:
    /* ignoreTx checks if we can already ignore a tx according to preset rules
    
     we expect array of "vout" for a BTC to have this format
     OP_RETURN is mandatory only on inbound tx
     vout:0 is our vault
     vout:1 is any any change back to themselves
     vout:2 is OP_RETURN (first 80 bytes)
     vout:3 is OP_RETURN (next 80 bytes)
    
     Rules to ignore a tx are:
     - vout:0 doesn't have coins (value)
     - vout:0 doesn't have address
     - count vouts > 4
     - count vouts with coins (value) > 2
  */ // Check that vout:0 contains the vault address
    if (msg.outputs[0].address != msg.vaultAddress) return false;
    // Check that vout:1 is change address
    if (msg.outputs[1].addressType != $6iw60.BTCOutputAddressType.Change) return false;
    // Check and make sure vout:2 has OP_RETURN data
    if (!(msg.outputs[2] && msg.outputs[2]?.opReturnData)) return false;
    return true;
}
async function $0396a8ef29b63193$export$5bc2382b8aee7114(coin) {
    // FIXME: inspect the CoinTable to determine which coins are actually supported by the device.
    return $0396a8ef29b63193$var$supportedCoins.includes(coin);
}
async function $0396a8ef29b63193$export$e19a8971ffa7da73(coin, scriptType) {
    if (!$0396a8ef29b63193$var$supportedCoins.includes(coin)) return false;
    if (!$0396a8ef29b63193$var$segwitCoins.includes(coin) && scriptType === $6iw60.BTCInputScriptType.SpendP2SHWitness) return false;
    if (!$0396a8ef29b63193$var$segwitCoins.includes(coin) && scriptType === $6iw60.BTCInputScriptType.SpendWitness) return false;
    return true;
}
async function $0396a8ef29b63193$export$21cad4f266f414c0(wallet, transport, msg) {
    await $0396a8ef29b63193$var$ensureCoinSupport(wallet, msg.coin);
    const addr = new $437b837d88ef5c30$exports.GetAddress();
    addr.setAddressNList(msg.addressNList);
    addr.setCoinName(msg.coin);
    addr.setShowDisplay(msg.showDisplay || false);
    addr.setScriptType((0, $18acccdd0f9aa659$export$299f78d99cd9b58c)(msg.scriptType || $6iw60.BTCInputScriptType.SpendAddress));
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETADDRESS, addr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    if (response.message_type === $3a5kd.Events.CANCEL) throw response;
    const btcAddress = response.proto;
    return $7NkOr.mustBeDefined(btcAddress.getAddress());
}
async function $0396a8ef29b63193$export$4a108889564ae71c(wallet, transport, msgIn) {
    return transport.lockDuring(async ()=>{
        // Make a copy of the input parameter so as to not mutate the caller's data.
        // Unfreezing a recursively-frozen object is nontrivial, so we leverage an existing package
        const msg = (0, $ced2e61e6d0d8d17$exports.thaw)(msgIn);
        msg.outputs = (0, $ced2e61e6d0d8d17$exports.thaw)(msgIn.outputs);
        await $0396a8ef29b63193$var$ensureCoinSupport(wallet, msg.coin);
        if (msg.opReturnData) {
            if (msg.opReturnData.length > 80) throw new Error("OP_RETURN output character count is too damn high.");
            msg.outputs.push({
                addressType: $6iw60.BTCOutputAddressType.Spend,
                opReturnData: $0396a8ef29b63193$require$Buffer.from(msg.opReturnData).toString("base64"),
                amount: "0",
                isChange: false
            });
        }
        // If this is a THORChain transaction, validate the vout ordering
        if (msg.vaultAddress && !$0396a8ef29b63193$var$validateVoutOrdering(msg)) throw new Error("Improper vout ordering for BTC Thorchain transaction");
        const txmap = $0396a8ef29b63193$var$prepareSignTx(msg.coin, msg.inputs, msg.outputs);
        // Prepare and send initial message
        const tx = new $437b837d88ef5c30$exports.SignTx();
        tx.setInputsCount(msg.inputs.length);
        tx.setOutputsCount(msg.outputs.length);
        tx.setCoinName(msg.coin);
        if (msg.version !== undefined) tx.setVersion(msg.version);
        tx.setLockTime(msg.locktime || 0);
        let responseType;
        let response;
        const { message_enum: message_enum, proto: proto } = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_SIGNTX, tx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        }); // 5 Minute timeout
        responseType = message_enum;
        response = proto;
        // Prepare structure for signatures
        const signatures = new Array(msg.inputs.length).fill(null);
        let serializedTx = "";
        try {
            // Begin callback loop
            // eslint-disable-next-line no-constant-condition
            while(true){
                if (responseType !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_TXREQUEST) throw new Error(`Unexpected message type: ${responseType}`);
                const txRequest = response;
                // If there's some part of signed transaction, add it
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (txRequest.hasSerialized() && txRequest.getSerialized().hasSerializedTx()) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                serializedTx += $7NkOr.toHexString(txRequest.getSerialized().getSerializedTx_asU8());
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (txRequest.hasSerialized() && txRequest.getSerialized().hasSignatureIndex()) {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const sigIdx = txRequest.getSerialized().getSignatureIndex();
                    if (signatures[sigIdx] !== null) throw new Error(`Signature for index ${sigIdx} already filled`);
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    signatures[sigIdx] = $7NkOr.toHexString(txRequest.getSerialized().getSignature_asU8());
                }
                if (txRequest.getRequestType() === $d4cdf7121546d3d6$exports.RequestType.TXFINISHED) break;
                let currentTx;
                let currentMsg;
                let txAck;
                // Device asked for one more information, let's process it.
                if (!txRequest.hasDetails()) throw new Error("expected details");
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const reqDetails = txRequest.getDetails();
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (!reqDetails.hasTxHash()) currentTx = txmap["unsigned"];
                else currentTx = txmap[$7NkOr.toHexString(reqDetails.getTxHash_asU8())];
                if (txRequest.getRequestType() === $d4cdf7121546d3d6$exports.RequestType.TXMETA) {
                    currentMsg = new $d4cdf7121546d3d6$exports.TransactionType();
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (currentTx.hasVersion()) currentMsg.setVersion(currentTx.getVersion());
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (currentTx.hasLockTime()) currentMsg.setLockTime(currentTx.getLockTime());
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (currentTx.hasInputsCnt()) currentMsg.setInputsCnt(currentTx.getInputsCnt());
                    if (reqDetails.hasTxHash()) currentMsg.setOutputsCnt(currentTx.getBinOutputsList().length);
                    else currentMsg.setOutputsCnt(currentTx.getOutputsList().length);
                    if (currentTx.hasExtraData()) currentMsg.setExtraDataLen(currentTx.getExtraData_asU8().length);
                    else currentMsg.setExtraDataLen(0);
                    txAck = new $437b837d88ef5c30$exports.TxAck();
                    txAck.setTx(currentMsg);
                    const message = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_TXACK, txAck, {
                        msgTimeout: $7NkOr.LONG_TIMEOUT,
                        omitLock: true
                    }); // 5 Minute timeout
                    responseType = message.message_enum;
                    response = message.proto;
                    continue;
                }
                if (txRequest.getRequestType() === $d4cdf7121546d3d6$exports.RequestType.TXINPUT) {
                    if (!reqDetails.hasRequestIndex()) throw new Error("expected request index");
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const reqIndex = reqDetails.getRequestIndex();
                    currentMsg = new $d4cdf7121546d3d6$exports.TransactionType();
                    currentMsg.setInputsList([
                        currentTx.getInputsList()[reqIndex]
                    ]);
                    txAck = new $437b837d88ef5c30$exports.TxAck();
                    txAck.setTx(currentMsg);
                    const message = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_TXACK, txAck, {
                        msgTimeout: $7NkOr.LONG_TIMEOUT,
                        omitLock: true
                    }); // 5 Minute timeout
                    responseType = message.message_enum;
                    response = message.proto;
                    continue;
                }
                if (txRequest.getRequestType() === $d4cdf7121546d3d6$exports.RequestType.TXOUTPUT) {
                    if (!reqDetails.hasRequestIndex()) throw new Error("expected request index");
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const reqIndex = reqDetails.getRequestIndex();
                    currentMsg = new $d4cdf7121546d3d6$exports.TransactionType();
                    if (reqDetails.hasTxHash()) currentMsg.setBinOutputsList([
                        currentTx.getBinOutputsList()[reqIndex]
                    ]);
                    else {
                        currentMsg.setOutputsList([
                            currentTx.getOutputsList()[reqIndex]
                        ]);
                        currentMsg.setOutputsCnt(1);
                    }
                    txAck = new $437b837d88ef5c30$exports.TxAck();
                    txAck.setTx(currentMsg);
                    const message = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_TXACK, txAck, {
                        msgTimeout: $7NkOr.LONG_TIMEOUT,
                        omitLock: true
                    }); // 5 Minute timeout
                    responseType = message.message_enum;
                    response = message.proto;
                    continue;
                }
                if (txRequest.getRequestType() === $d4cdf7121546d3d6$exports.RequestType.TXEXTRADATA) {
                    if (!reqDetails.hasExtraDataOffset() || !reqDetails.hasExtraDataLen()) throw new Error("missing extra data offset and length");
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const offset = reqDetails.getExtraDataOffset();
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const length = reqDetails.getExtraDataLen();
                    currentMsg = new $d4cdf7121546d3d6$exports.TransactionType();
                    currentMsg.setExtraData(currentTx.getExtraData_asU8().slice(offset, offset + length));
                    txAck = new $437b837d88ef5c30$exports.TxAck();
                    txAck.setTx(currentMsg);
                    const message = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_TXACK, txAck, {
                        msgTimeout: $7NkOr.LONG_TIMEOUT,
                        omitLock: true
                    }); // 5 Minute timeout
                    responseType = message.message_enum;
                    response = message.proto;
                    continue;
                }
            }
        } catch (error) {
            console.error({
                error: error
            });
            throw new Error("Failed to sign BTC transaction");
        }
        if (signatures.includes(null)) throw new Error("Some signatures are missing!");
        return {
            signatures: signatures,
            serializedTx: serializedTx
        };
    });
}
async function $0396a8ef29b63193$export$b16a1c3994f70e7a() {
    return true;
}
function $0396a8ef29b63193$export$aa714ed70e3e3d8f() {
    return true;
}
async function $0396a8ef29b63193$export$f393afb7041494e8(wallet, transport, msg) {
    await $0396a8ef29b63193$var$ensureCoinSupport(wallet, msg.coin);
    const sign = new $437b837d88ef5c30$exports.SignMessage();
    sign.setAddressNList(msg.addressNList);
    sign.setMessage((0, $18acccdd0f9aa659$export$d9791cdfbd60a48f)(msg.message));
    sign.setCoinName(msg.coin || "Bitcoin");
    sign.setScriptType((0, $18acccdd0f9aa659$export$299f78d99cd9b58c)(msg.scriptType ?? $6iw60.BTCInputScriptType.SpendAddress));
    const event = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_SIGNMESSAGE, sign, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const messageSignature = event.proto;
    const address = messageSignature.getAddress();
    if (!address) throw new Error("btcSignMessage failed");
    return {
        address: address,
        signature: $7NkOr.toHexString(messageSignature.getSignature_asU8())
    };
}
async function $0396a8ef29b63193$export$5d3bd4730f650ae3(wallet, transport, msg) {
    await $0396a8ef29b63193$var$ensureCoinSupport(wallet, msg.coin);
    const verify = new $437b837d88ef5c30$exports.VerifyMessage();
    verify.setAddress(msg.address);
    verify.setSignature($7NkOr.arrayify("0x" + msg.signature));
    verify.setMessage((0, $18acccdd0f9aa659$export$d9791cdfbd60a48f)(msg.message));
    verify.setCoinName(msg.coin);
    let event;
    try {
        event = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_VERIFYMESSAGE, verify);
    } catch (e) {
        if ($7NkOr.isIndexable(e) && e.message_enum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FAILURE) return false;
        throw e;
    }
    const success = event.proto;
    return success.getMessage() === "Message verified";
}
function $0396a8ef29b63193$export$9e274eca87a9a359(msg) {
    const slip44 = $7NkOr.slip44ByCoin(msg.coin);
    if (slip44 === undefined) return [];
    const bip44 = $0396a8ef29b63193$var$legacyAccount(msg.coin, slip44, msg.accountIdx);
    const bip49 = $0396a8ef29b63193$var$segwitAccount(msg.coin, slip44, msg.accountIdx);
    const bip84 = $0396a8ef29b63193$var$segwitNativeAccount(msg.coin, slip44, msg.accountIdx);
    // For BTC Forks
    const btcLegacy = $0396a8ef29b63193$var$legacyAccount(msg.coin, $7NkOr.slip44ByCoin("Bitcoin"), msg.accountIdx);
    const btcSegwit = $0396a8ef29b63193$var$segwitAccount(msg.coin, $7NkOr.slip44ByCoin("Bitcoin"), msg.accountIdx);
    const btcSegwitNative = $0396a8ef29b63193$var$segwitNativeAccount(msg.coin, $7NkOr.slip44ByCoin("Bitcoin"), msg.accountIdx);
    // For BCH Forks
    const bchLegacy = $0396a8ef29b63193$var$legacyAccount(msg.coin, $7NkOr.slip44ByCoin("BitcoinCash"), msg.accountIdx);
    let paths = {
        Bitcoin: [
            bip44,
            bip49,
            bip84
        ],
        Litecoin: [
            bip44,
            bip49,
            bip84
        ],
        Dash: [
            bip44
        ],
        DigiByte: [
            bip44,
            bip49,
            bip84
        ],
        Dogecoin: [
            bip44
        ],
        Testnet: [
            bip44,
            bip49,
            bip84
        ],
        BitcoinCash: [
            bip44,
            btcLegacy
        ],
        BitcoinSV: [
            bip44,
            bchLegacy,
            btcLegacy
        ],
        BitcoinGold: [
            bip44,
            bip49,
            bip84,
            btcLegacy,
            btcSegwit,
            btcSegwitNative
        ]
    }[msg.coin] ?? [];
    if (msg.scriptType !== undefined) paths = paths.filter((path)=>{
        return path.scriptType === msg.scriptType;
    });
    return paths;
}
function $0396a8ef29b63193$export$44f42932656c0961(msg) {
    if (msg.length < 1) return false;
    if (msg.length > 3) return false;
    const account0 = msg[0];
    if (account0.addressNList.length != 3) return false;
    // Make sure Purpose and ScriptType match
    const purpose = account0.addressNList[0];
    const purposeForScriptType = {
        [$6iw60.BTCInputScriptType.SpendAddress]: 2147483692,
        [$6iw60.BTCInputScriptType.SpendP2SHWitness]: 2147483697,
        [$6iw60.BTCInputScriptType.SpendWitness]: 2147483732
    };
    if (purposeForScriptType[account0.scriptType] !== purpose) return false;
    // Coin must be hardened
    const slip44 = account0.addressNList[1];
    if (slip44 < 0x80000000) return false;
    // Account Idx must be hardened
    const idx = account0.addressNList[2];
    if (idx < 0x80000000) return false;
    // Accounts must have the same SLIP44 and Account Idx, but may have differing
    // purpose fields (so long as they're BIP44/BIP49/BIP84)
    if (msg.find((path)=>{
        if (path.addressNList.length != 3) return true;
        if (![
            2147483692,
            2147483697,
            2147483732
        ].includes(path.addressNList[0])) return true;
        if (purposeForScriptType[path.scriptType] !== path.addressNList[0]) return true;
        if (path.addressNList[1] != slip44) return true;
        if (path.addressNList[2] != idx) return true;
    })) return false;
    return true;
}



var $133b05dab394aa62$exports = {};
// source: messages-cosmos.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $133b05dab394aa62$var$goog = $2MzPv;
var $133b05dab394aa62$var$global = (function() {
    return this || window || $133b05dab394aa62$var$global || self || Function("return this")();
}).call(null);

$133b05dab394aa62$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosAddress", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosGetAddress", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgAck", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgDelegate", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgIBCTransfer", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgRedelegate", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgRequest", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgRewards", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgSend", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosMsgUndelegate", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosSignTx", null, $133b05dab394aa62$var$global);
$133b05dab394aa62$var$goog.exportSymbol("proto.CosmosSignedTx", null, $133b05dab394aa62$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.CosmosGetAddress.repeatedFields_, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosGetAddress, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosGetAddress.displayName = "proto.CosmosGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosAddress, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosAddress.displayName = "proto.CosmosAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.CosmosSignTx.repeatedFields_, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosSignTx, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosSignTx.displayName = "proto.CosmosSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgRequest, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgRequest.displayName = "proto.CosmosMsgRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgAck, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgAck.displayName = "proto.CosmosMsgAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgSend = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgSend, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgSend.displayName = "proto.CosmosMsgSend";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgDelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgDelegate, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgDelegate.displayName = "proto.CosmosMsgDelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgUndelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgUndelegate, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgUndelegate.displayName = "proto.CosmosMsgUndelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgRedelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgRedelegate, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgRedelegate.displayName = "proto.CosmosMsgRedelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgRewards = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgRewards, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgRewards.displayName = "proto.CosmosMsgRewards";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosMsgIBCTransfer = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosMsgIBCTransfer, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosMsgIBCTransfer.displayName = "proto.CosmosMsgIBCTransfer";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.CosmosSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$133b05dab394aa62$var$goog.inherits(proto.CosmosSignedTx, $2MzPv.Message);
if ($133b05dab394aa62$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.CosmosSignedTx.displayName = "proto.CosmosSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.CosmosGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosGetAddress}
 */ proto.CosmosGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosGetAddress;
    return proto.CosmosGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosGetAddress}
 */ proto.CosmosGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.CosmosGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.CosmosGetAddress} returns this
 */ proto.CosmosGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.CosmosGetAddress} returns this
 */ proto.CosmosGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.CosmosGetAddress} returns this
 */ proto.CosmosGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.CosmosGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.CosmosGetAddress} returns this
 */ proto.CosmosGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosGetAddress} returns this
 */ proto.CosmosGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosAddress}
 */ proto.CosmosAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosAddress;
    return proto.CosmosAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosAddress}
 */ proto.CosmosAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.CosmosAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosAddress} returns this
 */ proto.CosmosAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosAddress} returns this
 */ proto.CosmosAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.CosmosSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            accountNumber: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            feeAmount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            gas: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            msgCount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosSignTx}
 */ proto.CosmosSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosSignTx;
    return proto.CosmosSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosSignTx}
 */ proto.CosmosSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setChainId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFeeAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGas(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSequence(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgCount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeUint64String(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.CosmosSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint64 account_number = 2;
 * @return {string}
 */ proto.CosmosSignTx.prototype.getAccountNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setAccountNumber = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearAccountNumber = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasAccountNumber = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string chain_id = 3;
 * @return {string}
 */ proto.CosmosSignTx.prototype.getChainId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 fee_amount = 4;
 * @return {number}
 */ proto.CosmosSignTx.prototype.getFeeAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setFeeAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearFeeAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasFeeAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 gas = 5;
 * @return {number}
 */ proto.CosmosSignTx.prototype.getGas = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setGas = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearGas = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasGas = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string memo = 6;
 * @return {string}
 */ proto.CosmosSignTx.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional uint64 sequence = 7;
 * @return {string}
 */ proto.CosmosSignTx.prototype.getSequence = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 msg_count = 8;
 * @return {number}
 */ proto.CosmosSignTx.prototype.getMsgCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.setMsgCount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignTx} returns this
 */ proto.CosmosSignTx.prototype.clearMsgCount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignTx.prototype.hasMsgCount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgRequest}
 */ proto.CosmosMsgRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgRequest;
    return proto.CosmosMsgRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgRequest}
 */ proto.CosmosMsgRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgAck.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            send: (f = msg.getSend()) && proto.CosmosMsgSend.toObject(includeInstance, f),
            delegate: (f = msg.getDelegate()) && proto.CosmosMsgDelegate.toObject(includeInstance, f),
            undelegate: (f = msg.getUndelegate()) && proto.CosmosMsgUndelegate.toObject(includeInstance, f),
            redelegate: (f = msg.getRedelegate()) && proto.CosmosMsgRedelegate.toObject(includeInstance, f),
            rewards: (f = msg.getRewards()) && proto.CosmosMsgRewards.toObject(includeInstance, f),
            ibcTransfer: (f = msg.getIbcTransfer()) && proto.CosmosMsgIBCTransfer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgAck}
 */ proto.CosmosMsgAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgAck;
    return proto.CosmosMsgAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgAck}
 */ proto.CosmosMsgAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.CosmosMsgSend;
                reader.readMessage(value, proto.CosmosMsgSend.deserializeBinaryFromReader);
                msg.setSend(value);
                break;
            case 2:
                var value = new proto.CosmosMsgDelegate;
                reader.readMessage(value, proto.CosmosMsgDelegate.deserializeBinaryFromReader);
                msg.setDelegate(value);
                break;
            case 3:
                var value = new proto.CosmosMsgUndelegate;
                reader.readMessage(value, proto.CosmosMsgUndelegate.deserializeBinaryFromReader);
                msg.setUndelegate(value);
                break;
            case 4:
                var value = new proto.CosmosMsgRedelegate;
                reader.readMessage(value, proto.CosmosMsgRedelegate.deserializeBinaryFromReader);
                msg.setRedelegate(value);
                break;
            case 5:
                var value = new proto.CosmosMsgRewards;
                reader.readMessage(value, proto.CosmosMsgRewards.deserializeBinaryFromReader);
                msg.setRewards(value);
                break;
            case 6:
                var value = new proto.CosmosMsgIBCTransfer;
                reader.readMessage(value, proto.CosmosMsgIBCTransfer.deserializeBinaryFromReader);
                msg.setIbcTransfer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSend();
    if (f != null) writer.writeMessage(1, f, proto.CosmosMsgSend.serializeBinaryToWriter);
    f = message.getDelegate();
    if (f != null) writer.writeMessage(2, f, proto.CosmosMsgDelegate.serializeBinaryToWriter);
    f = message.getUndelegate();
    if (f != null) writer.writeMessage(3, f, proto.CosmosMsgUndelegate.serializeBinaryToWriter);
    f = message.getRedelegate();
    if (f != null) writer.writeMessage(4, f, proto.CosmosMsgRedelegate.serializeBinaryToWriter);
    f = message.getRewards();
    if (f != null) writer.writeMessage(5, f, proto.CosmosMsgRewards.serializeBinaryToWriter);
    f = message.getIbcTransfer();
    if (f != null) writer.writeMessage(6, f, proto.CosmosMsgIBCTransfer.serializeBinaryToWriter);
};
/**
 * optional CosmosMsgSend send = 1;
 * @return {?proto.CosmosMsgSend}
 */ proto.CosmosMsgAck.prototype.getSend = function() {
    return /** @type{?proto.CosmosMsgSend} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgSend, 1);
};
/**
 * @param {?proto.CosmosMsgSend|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setSend = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearSend = function() {
    return this.setSend(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasSend = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional CosmosMsgDelegate delegate = 2;
 * @return {?proto.CosmosMsgDelegate}
 */ proto.CosmosMsgAck.prototype.getDelegate = function() {
    return /** @type{?proto.CosmosMsgDelegate} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgDelegate, 2);
};
/**
 * @param {?proto.CosmosMsgDelegate|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setDelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearDelegate = function() {
    return this.setDelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasDelegate = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional CosmosMsgUndelegate undelegate = 3;
 * @return {?proto.CosmosMsgUndelegate}
 */ proto.CosmosMsgAck.prototype.getUndelegate = function() {
    return /** @type{?proto.CosmosMsgUndelegate} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgUndelegate, 3);
};
/**
 * @param {?proto.CosmosMsgUndelegate|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setUndelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearUndelegate = function() {
    return this.setUndelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasUndelegate = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional CosmosMsgRedelegate redelegate = 4;
 * @return {?proto.CosmosMsgRedelegate}
 */ proto.CosmosMsgAck.prototype.getRedelegate = function() {
    return /** @type{?proto.CosmosMsgRedelegate} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgRedelegate, 4);
};
/**
 * @param {?proto.CosmosMsgRedelegate|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setRedelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearRedelegate = function() {
    return this.setRedelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasRedelegate = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional CosmosMsgRewards rewards = 5;
 * @return {?proto.CosmosMsgRewards}
 */ proto.CosmosMsgAck.prototype.getRewards = function() {
    return /** @type{?proto.CosmosMsgRewards} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgRewards, 5);
};
/**
 * @param {?proto.CosmosMsgRewards|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setRewards = function(value) {
    return $2MzPv.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearRewards = function() {
    return this.setRewards(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasRewards = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional CosmosMsgIBCTransfer ibc_transfer = 6;
 * @return {?proto.CosmosMsgIBCTransfer}
 */ proto.CosmosMsgAck.prototype.getIbcTransfer = function() {
    return /** @type{?proto.CosmosMsgIBCTransfer} */ $2MzPv.Message.getWrapperField(this, proto.CosmosMsgIBCTransfer, 6);
};
/**
 * @param {?proto.CosmosMsgIBCTransfer|undefined} value
 * @return {!proto.CosmosMsgAck} returns this
*/ proto.CosmosMsgAck.prototype.setIbcTransfer = function(value) {
    return $2MzPv.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.CosmosMsgAck} returns this
 */ proto.CosmosMsgAck.prototype.clearIbcTransfer = function() {
    return this.setIbcTransfer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgAck.prototype.hasIbcTransfer = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgSend.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgSend.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgSend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgSend.toObject = function(includeInstance, msg) {
        var f, obj = {
            fromAddress: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            toAddress: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            addressType: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgSend}
 */ proto.CosmosMsgSend.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgSend;
    return proto.CosmosMsgSend.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgSend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgSend}
 */ proto.CosmosMsgSend.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setFromAddress(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setToAddress(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgSend.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgSend.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgSend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgSend.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint64String(8, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeEnum(9, f);
};
/**
 * optional string from_address = 6;
 * @return {string}
 */ proto.CosmosMsgSend.prototype.getFromAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.setFromAddress = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.clearFromAddress = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgSend.prototype.hasFromAddress = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string to_address = 7;
 * @return {string}
 */ proto.CosmosMsgSend.prototype.getToAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.setToAddress = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.clearToAddress = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgSend.prototype.hasToAddress = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint64 amount = 8;
 * @return {string}
 */ proto.CosmosMsgSend.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgSend.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional OutputAddressType address_type = 9;
 * @return {!proto.OutputAddressType}
 */ proto.CosmosMsgSend.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgSend} returns this
 */ proto.CosmosMsgSend.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgSend.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgDelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgDelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgDelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgDelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgDelegate}
 */ proto.CosmosMsgDelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgDelegate;
    return proto.CosmosMsgDelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgDelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgDelegate}
 */ proto.CosmosMsgDelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgDelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgDelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgDelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgDelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.CosmosMsgDelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgDelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.CosmosMsgDelegate.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgDelegate.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 amount = 3;
 * @return {string}
 */ proto.CosmosMsgDelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgDelegate} returns this
 */ proto.CosmosMsgDelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgDelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgUndelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgUndelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgUndelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgUndelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgUndelegate}
 */ proto.CosmosMsgUndelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgUndelegate;
    return proto.CosmosMsgUndelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgUndelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgUndelegate}
 */ proto.CosmosMsgUndelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgUndelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgUndelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgUndelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgUndelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.CosmosMsgUndelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgUndelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.CosmosMsgUndelegate.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgUndelegate.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 amount = 3;
 * @return {string}
 */ proto.CosmosMsgUndelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgUndelegate} returns this
 */ proto.CosmosMsgUndelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgUndelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgRedelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgRedelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgRedelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRedelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorSrcAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            validatorDstAddress: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgRedelegate}
 */ proto.CosmosMsgRedelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgRedelegate;
    return proto.CosmosMsgRedelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgRedelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgRedelegate}
 */ proto.CosmosMsgRedelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorSrcAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorDstAddress(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgRedelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgRedelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgRedelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRedelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint64String(4, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.CosmosMsgRedelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRedelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_src_address = 2;
 * @return {string}
 */ proto.CosmosMsgRedelegate.prototype.getValidatorSrcAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.setValidatorSrcAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.clearValidatorSrcAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRedelegate.prototype.hasValidatorSrcAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string validator_dst_address = 3;
 * @return {string}
 */ proto.CosmosMsgRedelegate.prototype.getValidatorDstAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.setValidatorDstAddress = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.clearValidatorDstAddress = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRedelegate.prototype.hasValidatorDstAddress = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint64 amount = 4;
 * @return {string}
 */ proto.CosmosMsgRedelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRedelegate} returns this
 */ proto.CosmosMsgRedelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRedelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgRewards.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgRewards.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgRewards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRewards.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgRewards}
 */ proto.CosmosMsgRewards.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgRewards;
    return proto.CosmosMsgRewards.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgRewards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgRewards}
 */ proto.CosmosMsgRewards.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgRewards.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgRewards.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgRewards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgRewards.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.CosmosMsgRewards.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRewards.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.CosmosMsgRewards.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRewards.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 amount = 3;
 * @return {string}
 */ proto.CosmosMsgRewards.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgRewards} returns this
 */ proto.CosmosMsgRewards.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgRewards.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosMsgIBCTransfer.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosMsgIBCTransfer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosMsgIBCTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgIBCTransfer.toObject = function(includeInstance, msg) {
        var f, obj = {
            receiver: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            sender: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            sourceChannel: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            sourcePort: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            revisionHeight: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            revisionNumber: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosMsgIBCTransfer}
 */ proto.CosmosMsgIBCTransfer.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosMsgIBCTransfer;
    return proto.CosmosMsgIBCTransfer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosMsgIBCTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosMsgIBCTransfer}
 */ proto.CosmosMsgIBCTransfer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReceiver(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceChannel(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSourcePort(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setRevisionHeight(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setRevisionNumber(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosMsgIBCTransfer.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosMsgIBCTransfer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosMsgIBCTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosMsgIBCTransfer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint64(8, f);
};
/**
 * optional string receiver = 1;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string sender = 2;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string source_channel = 3;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getSourceChannel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setSourceChannel = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearSourceChannel = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasSourceChannel = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string source_port = 4;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getSourcePort = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setSourcePort = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearSourcePort = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasSourcePort = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string revision_height = 5;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getRevisionHeight = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setRevisionHeight = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearRevisionHeight = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasRevisionHeight = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string revision_number = 6;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getRevisionNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setRevisionNumber = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearRevisionNumber = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasRevisionNumber = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string denom = 7;
 * @return {string}
 */ proto.CosmosMsgIBCTransfer.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint64 amount = 8;
 * @return {number}
 */ proto.CosmosMsgIBCTransfer.prototype.getAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosMsgIBCTransfer} returns this
 */ proto.CosmosMsgIBCTransfer.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosMsgIBCTransfer.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.CosmosSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.CosmosSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.CosmosSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            publicKey: msg.getPublicKey_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.CosmosSignedTx}
 */ proto.CosmosSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.CosmosSignedTx;
    return proto.CosmosSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.CosmosSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.CosmosSignedTx}
 */ proto.CosmosSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.CosmosSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.CosmosSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.CosmosSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.CosmosSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes public_key = 1;
 * @return {!(string|Uint8Array)}
 */ proto.CosmosSignedTx.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes public_key = 1;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.CosmosSignedTx.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.CosmosSignedTx.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CosmosSignedTx} returns this
 */ proto.CosmosSignedTx.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignedTx} returns this
 */ proto.CosmosSignedTx.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignedTx.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.CosmosSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.CosmosSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.CosmosSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.CosmosSignedTx} returns this
 */ proto.CosmosSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.CosmosSignedTx} returns this
 */ proto.CosmosSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.CosmosSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$133b05dab394aa62$var$goog.object.extend($133b05dab394aa62$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $1Vf4C = parcelRequire("1Vf4C");

var $gGdnO = parcelRequire("gGdnO");

const $ee3499be6fffa9bb$var$protoTxBuilder = (0, (/*@__PURE__*/$parcel$interopDefault($gGdnO))).from(()=>(parcelRequire("eknzC")));
function $ee3499be6fffa9bb$export$91ffdbe147bbd2b8(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Atom"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $ee3499be6fffa9bb$export$85899f1e7d94790a(transport, msg) {
    const getAddr = new $133b05dab394aa62$exports.CosmosGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_COSMOSGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const cosmosAddress = response.proto;
    return $7NkOr.mustBeDefined(cosmosAddress.getAddress());
}
async function $ee3499be6fffa9bb$export$ed75bd314543b412(transport, msg) {
    const address = await $ee3499be6fffa9bb$export$85899f1e7d94790a(transport, {
        addressNList: msg.addressNList
    });
    const getPublicKeyMsg = new $437b837d88ef5c30$exports.GetPublicKey();
    getPublicKeyMsg.setAddressNList(msg.addressNList);
    getPublicKeyMsg.setEcdsaCurveName("secp256k1");
    const pubkeyMsg = (await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETPUBLICKEY, getPublicKeyMsg, {
        msgTimeout: $7NkOr.DEFAULT_TIMEOUT
    })).proto;
    const pubkey = (0, (/*@__PURE__*/$parcel$interopDefault($1Vf4C))).decode($7NkOr.mustBeDefined(pubkeyMsg.getXpub())).slice(45);
    return transport.lockDuring(async ()=>{
        const signTx = new $133b05dab394aa62$exports.CosmosSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setAccountNumber(msg.account_number);
        signTx.setChainId(msg.chain_id);
        signTx.setFeeAmount(parseInt(msg.tx.fee.amount[0].amount));
        signTx.setGas(parseInt(msg.tx.fee.gas));
        signTx.setSequence(msg.sequence);
        if (msg.tx.memo !== undefined) signTx.setMemo(msg.tx.memo);
        signTx.setMsgCount(1);
        let resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_COSMOSSIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        for (const m of msg.tx.msg){
            if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_COSMOSMSGREQUEST) throw new Error(`cosmos: unexpected response ${resp.message_type}`);
            let ack;
            if (m.type === "cosmos-sdk/MsgSend") {
                if (m.value.amount.length !== 1) throw new Error("cosmos: Multiple amounts per msg not supported");
                const denom = m.value.amount[0].denom;
                if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                const send = new $133b05dab394aa62$exports.CosmosMsgSend();
                send.setFromAddress(m.value.from_address);
                send.setToAddress(m.value.to_address);
                send.setAmount(m.value.amount[0].amount);
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setSend(send);
            } else if (m.type === "cosmos-sdk/MsgDelegate") {
                const denom = m.value.amount.denom;
                if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                const delegate = new $133b05dab394aa62$exports.CosmosMsgDelegate();
                delegate.setDelegatorAddress(m.value.delegator_address);
                delegate.setValidatorAddress(m.value.validator_address);
                delegate.setAmount(m.value.amount.amount);
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setDelegate(delegate);
            } else if (m.type === "cosmos-sdk/MsgUndelegate") {
                const denom = m.value.amount.denom;
                if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                const undelegate = new $133b05dab394aa62$exports.CosmosMsgUndelegate();
                undelegate.setDelegatorAddress(m.value.delegator_address);
                undelegate.setValidatorAddress(m.value.validator_address);
                undelegate.setAmount(m.value.amount.amount);
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setUndelegate(undelegate);
            } else if (m.type === "cosmos-sdk/MsgBeginRedelegate") {
                const denom = m.value.amount.denom;
                if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                const redelegate = new $133b05dab394aa62$exports.CosmosMsgRedelegate();
                redelegate.setDelegatorAddress(m.value.delegator_address);
                redelegate.setValidatorSrcAddress(m.value.validator_src_address);
                redelegate.setValidatorDstAddress(m.value.validator_dst_address);
                redelegate.setAmount(m.value.amount.amount);
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setRedelegate(redelegate);
            } else if (m.type === "cosmos-sdk/MsgWithdrawDelegationReward") {
                const rewards = new $133b05dab394aa62$exports.CosmosMsgRewards();
                rewards.setDelegatorAddress(m.value.delegator_address);
                rewards.setValidatorAddress(m.value.validator_address);
                if (m.value.amount) {
                    const denom = m.value.amount.denom;
                    if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                    rewards.setAmount(m.value.amount.amount);
                }
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setRewards(rewards);
            } else if (m.type === "cosmos-sdk/MsgTransfer") {
                const denom = m.value.token.denom;
                if (denom !== "uatom") throw new Error("cosmos: Unsupported denomination: " + denom);
                const ibcTransfer = new $133b05dab394aa62$exports.CosmosMsgIBCTransfer();
                ibcTransfer.setReceiver(m.value.receiver);
                ibcTransfer.setSender(m.value.sender);
                ibcTransfer.setSourceChannel(m.value.source_channel);
                ibcTransfer.setSourcePort(m.value.source_port);
                ibcTransfer.setRevisionHeight(m.value.timeout_height.revision_height);
                ibcTransfer.setRevisionNumber(m.value.timeout_height.revision_number);
                ibcTransfer.setAmount(m.value.token.amount);
                ibcTransfer.setDenom(m.value.token.denom);
                ack = new $133b05dab394aa62$exports.CosmosMsgAck();
                ack.setIbcTransfer(ibcTransfer);
            } else throw new Error(`cosmos: Message ${m.type} is not yet supported`);
            resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_COSMOSMSGACK, ack, {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_COSMOSSIGNEDTX) throw new Error(`cosmos: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        const offlineSigner = {
            async getAccounts () {
                return [
                    {
                        address: address,
                        algo: "secp256k1",
                        pubkey: pubkey
                    }
                ];
            },
            async signAmino (signerAddress, signDoc) {
                if (signerAddress !== address) throw new Error("expected signerAddress to match address");
                return {
                    signed: signDoc,
                    signature: {
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: signedTx.getPublicKey_asB64()
                        },
                        signature: signedTx.getSignature_asB64()
                    }
                };
            }
        };
        const signerData = {
            sequence: Number(msg.sequence),
            accountNumber: Number(msg.account_number),
            chainId: msg.chain_id
        };
        return (await $ee3499be6fffa9bb$var$protoTxBuilder).sign(address, msg.tx, offlineSigner, signerData);
    });
}



var $e45745d0e423cacd$exports = {};
// source: messages-eos.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $e45745d0e423cacd$var$goog = $2MzPv;
var $e45745d0e423cacd$var$global = (function() {
    return this || window || $e45745d0e423cacd$var$global || self || Function("return this")();
}).call(null);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionBuyRam", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionBuyRamBytes", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionCommon", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionDelegate", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionDeleteAuth", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionLinkAuth", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionNewAccount", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionRefund", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionSellRam", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionTransfer", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionUndelegate", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionUnknown", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionUnlinkAuth", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionUpdateAuth", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosActionVoteProducer", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosAsset", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosAuthorization", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosAuthorizationAccount", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosAuthorizationKey", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosAuthorizationWait", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosGetPublicKey", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosPermissionLevel", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosPublicKey", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosPublicKeyKind", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosSignTx", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosSignedTx", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosTxActionAck", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosTxActionRequest", null, $e45745d0e423cacd$var$global);
$e45745d0e423cacd$var$goog.exportSymbol("proto.EosTxHeader", null, $e45745d0e423cacd$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosGetPublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosGetPublicKey.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosGetPublicKey, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosGetPublicKey.displayName = "proto.EosGetPublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosPublicKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosPublicKey, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosPublicKey.displayName = "proto.EosPublicKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosSignTx.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosSignTx, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosSignTx.displayName = "proto.EosSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosTxHeader = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosTxHeader, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosTxHeader.displayName = "proto.EosTxHeader";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosTxActionRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosTxActionRequest, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosTxActionRequest.displayName = "proto.EosTxActionRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosTxActionAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosTxActionAck, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosTxActionAck.displayName = "proto.EosTxActionAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosAsset = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosAsset, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosAsset.displayName = "proto.EosAsset";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosPermissionLevel = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosPermissionLevel, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosPermissionLevel.displayName = "proto.EosPermissionLevel";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosAuthorizationKey = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosAuthorizationKey.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosAuthorizationKey, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosAuthorizationKey.displayName = "proto.EosAuthorizationKey";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosAuthorizationAccount = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosAuthorizationAccount, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosAuthorizationAccount.displayName = "proto.EosAuthorizationAccount";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosAuthorizationWait = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosAuthorizationWait, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosAuthorizationWait.displayName = "proto.EosAuthorizationWait";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosAuthorization = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosAuthorization.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosAuthorization, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosAuthorization.displayName = "proto.EosAuthorization";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionCommon = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosActionCommon.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionCommon, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionCommon.displayName = "proto.EosActionCommon";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionTransfer = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionTransfer, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionTransfer.displayName = "proto.EosActionTransfer";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionDelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionDelegate, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionDelegate.displayName = "proto.EosActionDelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionUndelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionUndelegate, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionUndelegate.displayName = "proto.EosActionUndelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionRefund = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionRefund, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionRefund.displayName = "proto.EosActionRefund";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionBuyRam = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionBuyRam, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionBuyRam.displayName = "proto.EosActionBuyRam";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionBuyRamBytes = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionBuyRamBytes, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionBuyRamBytes.displayName = "proto.EosActionBuyRamBytes";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionSellRam = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionSellRam, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionSellRam.displayName = "proto.EosActionSellRam";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionVoteProducer = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EosActionVoteProducer.repeatedFields_, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionVoteProducer, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionVoteProducer.displayName = "proto.EosActionVoteProducer";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionUpdateAuth = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionUpdateAuth, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionUpdateAuth.displayName = "proto.EosActionUpdateAuth";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionDeleteAuth = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionDeleteAuth, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionDeleteAuth.displayName = "proto.EosActionDeleteAuth";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionLinkAuth = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionLinkAuth, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionLinkAuth.displayName = "proto.EosActionLinkAuth";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionUnlinkAuth = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionUnlinkAuth, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionUnlinkAuth.displayName = "proto.EosActionUnlinkAuth";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionNewAccount = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionNewAccount, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionNewAccount.displayName = "proto.EosActionNewAccount";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosActionUnknown = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosActionUnknown, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosActionUnknown.displayName = "proto.EosActionUnknown";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EosSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e45745d0e423cacd$var$goog.inherits(proto.EosSignedTx, $2MzPv.Message);
if ($e45745d0e423cacd$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EosSignedTx.displayName = "proto.EosSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosGetPublicKey.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosGetPublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.EosGetPublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosGetPublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosGetPublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            kind: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosGetPublicKey}
 */ proto.EosGetPublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosGetPublicKey;
    return proto.EosGetPublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosGetPublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosGetPublicKey}
 */ proto.EosGetPublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 3:
                var value = /** @type {!proto.EosPublicKeyKind} */ reader.readEnum();
                msg.setKind(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosGetPublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosGetPublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosGetPublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosGetPublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {!proto.EosPublicKeyKind} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeEnum(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EosGetPublicKey.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.EosGetPublicKey.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosGetPublicKey.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosPublicKeyKind kind = 3;
 * @return {!proto.EosPublicKeyKind}
 */ proto.EosGetPublicKey.prototype.getKind = function() {
    return /** @type {!proto.EosPublicKeyKind} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.EosPublicKeyKind} value
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.setKind = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosGetPublicKey} returns this
 */ proto.EosGetPublicKey.prototype.clearKind = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosGetPublicKey.prototype.hasKind = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosPublicKey.prototype.toObject = function(opt_includeInstance) {
        return proto.EosPublicKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosPublicKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosPublicKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            wifPublicKey: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            rawPublicKey: msg.getRawPublicKey_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosPublicKey}
 */ proto.EosPublicKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosPublicKey;
    return proto.EosPublicKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosPublicKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosPublicKey}
 */ proto.EosPublicKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setWifPublicKey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setRawPublicKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosPublicKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosPublicKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosPublicKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosPublicKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional string wif_public_key = 1;
 * @return {string}
 */ proto.EosPublicKey.prototype.getWifPublicKey = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.EosPublicKey} returns this
 */ proto.EosPublicKey.prototype.setWifPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosPublicKey} returns this
 */ proto.EosPublicKey.prototype.clearWifPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosPublicKey.prototype.hasWifPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes raw_public_key = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EosPublicKey.prototype.getRawPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes raw_public_key = 2;
 * This is a type-conversion wrapper around `getRawPublicKey()`
 * @return {string}
 */ proto.EosPublicKey.prototype.getRawPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getRawPublicKey());
};
/**
 * optional bytes raw_public_key = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getRawPublicKey()`
 * @return {!Uint8Array}
 */ proto.EosPublicKey.prototype.getRawPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getRawPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosPublicKey} returns this
 */ proto.EosPublicKey.prototype.setRawPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosPublicKey} returns this
 */ proto.EosPublicKey.prototype.clearRawPublicKey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosPublicKey.prototype.hasRawPublicKey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.EosSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            chainId: msg.getChainId_asB64(),
            header: (f = msg.getHeader()) && proto.EosTxHeader.toObject(includeInstance, f),
            numActions: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosSignTx}
 */ proto.EosSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosSignTx;
    return proto.EosSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosSignTx}
 */ proto.EosSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setChainId(value);
                break;
            case 3:
                var value = new proto.EosTxHeader;
                reader.readMessage(value, proto.EosTxHeader.deserializeBinaryFromReader);
                msg.setHeader(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setNumActions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = message.getHeader();
    if (f != null) writer.writeMessage(3, f, proto.EosTxHeader.serializeBinaryToWriter);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EosSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bytes chain_id = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EosSignTx.prototype.getChainId = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes chain_id = 2;
 * This is a type-conversion wrapper around `getChainId()`
 * @return {string}
 */ proto.EosSignTx.prototype.getChainId_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getChainId());
};
/**
 * optional bytes chain_id = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getChainId()`
 * @return {!Uint8Array}
 */ proto.EosSignTx.prototype.getChainId_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getChainId());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosTxHeader header = 3;
 * @return {?proto.EosTxHeader}
 */ proto.EosSignTx.prototype.getHeader = function() {
    return /** @type{?proto.EosTxHeader} */ $2MzPv.Message.getWrapperField(this, proto.EosTxHeader, 3);
};
/**
 * @param {?proto.EosTxHeader|undefined} value
 * @return {!proto.EosSignTx} returns this
*/ proto.EosSignTx.prototype.setHeader = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.clearHeader = function() {
    return this.setHeader(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignTx.prototype.hasHeader = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 num_actions = 4;
 * @return {number}
 */ proto.EosSignTx.prototype.getNumActions = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.setNumActions = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignTx} returns this
 */ proto.EosSignTx.prototype.clearNumActions = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignTx.prototype.hasNumActions = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosTxHeader.prototype.toObject = function(opt_includeInstance) {
        return proto.EosTxHeader.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosTxHeader} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxHeader.toObject = function(includeInstance, msg) {
        var f, obj = {
            expiration: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            refBlockNum: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            refBlockPrefix: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            maxNetUsageWords: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            maxCpuUsageMs: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            delaySec: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosTxHeader}
 */ proto.EosTxHeader.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosTxHeader;
    return proto.EosTxHeader.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosTxHeader} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosTxHeader}
 */ proto.EosTxHeader.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setExpiration(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRefBlockNum(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setRefBlockPrefix(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMaxNetUsageWords(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMaxCpuUsageMs(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDelaySec(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosTxHeader.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosTxHeader.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosTxHeader} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxHeader.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeUint32(6, f);
};
/**
 * required uint32 expiration = 1;
 * @return {number}
 */ proto.EosTxHeader.prototype.getExpiration = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setExpiration = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearExpiration = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasExpiration = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required uint32 ref_block_num = 2;
 * @return {number}
 */ proto.EosTxHeader.prototype.getRefBlockNum = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setRefBlockNum = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearRefBlockNum = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasRefBlockNum = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * required uint32 ref_block_prefix = 3;
 * @return {number}
 */ proto.EosTxHeader.prototype.getRefBlockPrefix = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setRefBlockPrefix = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearRefBlockPrefix = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasRefBlockPrefix = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * required uint32 max_net_usage_words = 4;
 * @return {number}
 */ proto.EosTxHeader.prototype.getMaxNetUsageWords = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setMaxNetUsageWords = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearMaxNetUsageWords = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasMaxNetUsageWords = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * required uint32 max_cpu_usage_ms = 5;
 * @return {number}
 */ proto.EosTxHeader.prototype.getMaxCpuUsageMs = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setMaxCpuUsageMs = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearMaxCpuUsageMs = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasMaxCpuUsageMs = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * required uint32 delay_sec = 6;
 * @return {number}
 */ proto.EosTxHeader.prototype.getDelaySec = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.setDelaySec = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosTxHeader} returns this
 */ proto.EosTxHeader.prototype.clearDelaySec = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxHeader.prototype.hasDelaySec = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosTxActionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.EosTxActionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosTxActionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxActionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosTxActionRequest}
 */ proto.EosTxActionRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosTxActionRequest;
    return proto.EosTxActionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosTxActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosTxActionRequest}
 */ proto.EosTxActionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosTxActionRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosTxActionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosTxActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxActionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosTxActionAck.prototype.toObject = function(opt_includeInstance) {
        return proto.EosTxActionAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosTxActionAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxActionAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            common: (f = msg.getCommon()) && proto.EosActionCommon.toObject(includeInstance, f),
            transfer: (f = msg.getTransfer()) && proto.EosActionTransfer.toObject(includeInstance, f),
            delegate: (f = msg.getDelegate()) && proto.EosActionDelegate.toObject(includeInstance, f),
            undelegate: (f = msg.getUndelegate()) && proto.EosActionUndelegate.toObject(includeInstance, f),
            refund: (f = msg.getRefund()) && proto.EosActionRefund.toObject(includeInstance, f),
            buyRam: (f = msg.getBuyRam()) && proto.EosActionBuyRam.toObject(includeInstance, f),
            buyRamBytes: (f = msg.getBuyRamBytes()) && proto.EosActionBuyRamBytes.toObject(includeInstance, f),
            sellRam: (f = msg.getSellRam()) && proto.EosActionSellRam.toObject(includeInstance, f),
            voteProducer: (f = msg.getVoteProducer()) && proto.EosActionVoteProducer.toObject(includeInstance, f),
            updateAuth: (f = msg.getUpdateAuth()) && proto.EosActionUpdateAuth.toObject(includeInstance, f),
            deleteAuth: (f = msg.getDeleteAuth()) && proto.EosActionDeleteAuth.toObject(includeInstance, f),
            linkAuth: (f = msg.getLinkAuth()) && proto.EosActionLinkAuth.toObject(includeInstance, f),
            unlinkAuth: (f = msg.getUnlinkAuth()) && proto.EosActionUnlinkAuth.toObject(includeInstance, f),
            newAccount: (f = msg.getNewAccount()) && proto.EosActionNewAccount.toObject(includeInstance, f),
            unknown: (f = msg.getUnknown()) && proto.EosActionUnknown.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosTxActionAck}
 */ proto.EosTxActionAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosTxActionAck;
    return proto.EosTxActionAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosTxActionAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosTxActionAck}
 */ proto.EosTxActionAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.EosActionCommon;
                reader.readMessage(value, proto.EosActionCommon.deserializeBinaryFromReader);
                msg.setCommon(value);
                break;
            case 2:
                var value = new proto.EosActionTransfer;
                reader.readMessage(value, proto.EosActionTransfer.deserializeBinaryFromReader);
                msg.setTransfer(value);
                break;
            case 3:
                var value = new proto.EosActionDelegate;
                reader.readMessage(value, proto.EosActionDelegate.deserializeBinaryFromReader);
                msg.setDelegate(value);
                break;
            case 4:
                var value = new proto.EosActionUndelegate;
                reader.readMessage(value, proto.EosActionUndelegate.deserializeBinaryFromReader);
                msg.setUndelegate(value);
                break;
            case 5:
                var value = new proto.EosActionRefund;
                reader.readMessage(value, proto.EosActionRefund.deserializeBinaryFromReader);
                msg.setRefund(value);
                break;
            case 6:
                var value = new proto.EosActionBuyRam;
                reader.readMessage(value, proto.EosActionBuyRam.deserializeBinaryFromReader);
                msg.setBuyRam(value);
                break;
            case 7:
                var value = new proto.EosActionBuyRamBytes;
                reader.readMessage(value, proto.EosActionBuyRamBytes.deserializeBinaryFromReader);
                msg.setBuyRamBytes(value);
                break;
            case 8:
                var value = new proto.EosActionSellRam;
                reader.readMessage(value, proto.EosActionSellRam.deserializeBinaryFromReader);
                msg.setSellRam(value);
                break;
            case 9:
                var value = new proto.EosActionVoteProducer;
                reader.readMessage(value, proto.EosActionVoteProducer.deserializeBinaryFromReader);
                msg.setVoteProducer(value);
                break;
            case 10:
                var value = new proto.EosActionUpdateAuth;
                reader.readMessage(value, proto.EosActionUpdateAuth.deserializeBinaryFromReader);
                msg.setUpdateAuth(value);
                break;
            case 11:
                var value = new proto.EosActionDeleteAuth;
                reader.readMessage(value, proto.EosActionDeleteAuth.deserializeBinaryFromReader);
                msg.setDeleteAuth(value);
                break;
            case 12:
                var value = new proto.EosActionLinkAuth;
                reader.readMessage(value, proto.EosActionLinkAuth.deserializeBinaryFromReader);
                msg.setLinkAuth(value);
                break;
            case 13:
                var value = new proto.EosActionUnlinkAuth;
                reader.readMessage(value, proto.EosActionUnlinkAuth.deserializeBinaryFromReader);
                msg.setUnlinkAuth(value);
                break;
            case 14:
                var value = new proto.EosActionNewAccount;
                reader.readMessage(value, proto.EosActionNewAccount.deserializeBinaryFromReader);
                msg.setNewAccount(value);
                break;
            case 15:
                var value = new proto.EosActionUnknown;
                reader.readMessage(value, proto.EosActionUnknown.deserializeBinaryFromReader);
                msg.setUnknown(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosTxActionAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosTxActionAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosTxActionAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosTxActionAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommon();
    if (f != null) writer.writeMessage(1, f, proto.EosActionCommon.serializeBinaryToWriter);
    f = message.getTransfer();
    if (f != null) writer.writeMessage(2, f, proto.EosActionTransfer.serializeBinaryToWriter);
    f = message.getDelegate();
    if (f != null) writer.writeMessage(3, f, proto.EosActionDelegate.serializeBinaryToWriter);
    f = message.getUndelegate();
    if (f != null) writer.writeMessage(4, f, proto.EosActionUndelegate.serializeBinaryToWriter);
    f = message.getRefund();
    if (f != null) writer.writeMessage(5, f, proto.EosActionRefund.serializeBinaryToWriter);
    f = message.getBuyRam();
    if (f != null) writer.writeMessage(6, f, proto.EosActionBuyRam.serializeBinaryToWriter);
    f = message.getBuyRamBytes();
    if (f != null) writer.writeMessage(7, f, proto.EosActionBuyRamBytes.serializeBinaryToWriter);
    f = message.getSellRam();
    if (f != null) writer.writeMessage(8, f, proto.EosActionSellRam.serializeBinaryToWriter);
    f = message.getVoteProducer();
    if (f != null) writer.writeMessage(9, f, proto.EosActionVoteProducer.serializeBinaryToWriter);
    f = message.getUpdateAuth();
    if (f != null) writer.writeMessage(10, f, proto.EosActionUpdateAuth.serializeBinaryToWriter);
    f = message.getDeleteAuth();
    if (f != null) writer.writeMessage(11, f, proto.EosActionDeleteAuth.serializeBinaryToWriter);
    f = message.getLinkAuth();
    if (f != null) writer.writeMessage(12, f, proto.EosActionLinkAuth.serializeBinaryToWriter);
    f = message.getUnlinkAuth();
    if (f != null) writer.writeMessage(13, f, proto.EosActionUnlinkAuth.serializeBinaryToWriter);
    f = message.getNewAccount();
    if (f != null) writer.writeMessage(14, f, proto.EosActionNewAccount.serializeBinaryToWriter);
    f = message.getUnknown();
    if (f != null) writer.writeMessage(15, f, proto.EosActionUnknown.serializeBinaryToWriter);
};
/**
 * optional EosActionCommon common = 1;
 * @return {?proto.EosActionCommon}
 */ proto.EosTxActionAck.prototype.getCommon = function() {
    return /** @type{?proto.EosActionCommon} */ $2MzPv.Message.getWrapperField(this, proto.EosActionCommon, 1);
};
/**
 * @param {?proto.EosActionCommon|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setCommon = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearCommon = function() {
    return this.setCommon(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasCommon = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional EosActionTransfer transfer = 2;
 * @return {?proto.EosActionTransfer}
 */ proto.EosTxActionAck.prototype.getTransfer = function() {
    return /** @type{?proto.EosActionTransfer} */ $2MzPv.Message.getWrapperField(this, proto.EosActionTransfer, 2);
};
/**
 * @param {?proto.EosActionTransfer|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setTransfer = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearTransfer = function() {
    return this.setTransfer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasTransfer = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosActionDelegate delegate = 3;
 * @return {?proto.EosActionDelegate}
 */ proto.EosTxActionAck.prototype.getDelegate = function() {
    return /** @type{?proto.EosActionDelegate} */ $2MzPv.Message.getWrapperField(this, proto.EosActionDelegate, 3);
};
/**
 * @param {?proto.EosActionDelegate|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setDelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearDelegate = function() {
    return this.setDelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasDelegate = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional EosActionUndelegate undelegate = 4;
 * @return {?proto.EosActionUndelegate}
 */ proto.EosTxActionAck.prototype.getUndelegate = function() {
    return /** @type{?proto.EosActionUndelegate} */ $2MzPv.Message.getWrapperField(this, proto.EosActionUndelegate, 4);
};
/**
 * @param {?proto.EosActionUndelegate|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setUndelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearUndelegate = function() {
    return this.setUndelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasUndelegate = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional EosActionRefund refund = 5;
 * @return {?proto.EosActionRefund}
 */ proto.EosTxActionAck.prototype.getRefund = function() {
    return /** @type{?proto.EosActionRefund} */ $2MzPv.Message.getWrapperField(this, proto.EosActionRefund, 5);
};
/**
 * @param {?proto.EosActionRefund|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setRefund = function(value) {
    return $2MzPv.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearRefund = function() {
    return this.setRefund(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasRefund = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional EosActionBuyRam buy_ram = 6;
 * @return {?proto.EosActionBuyRam}
 */ proto.EosTxActionAck.prototype.getBuyRam = function() {
    return /** @type{?proto.EosActionBuyRam} */ $2MzPv.Message.getWrapperField(this, proto.EosActionBuyRam, 6);
};
/**
 * @param {?proto.EosActionBuyRam|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setBuyRam = function(value) {
    return $2MzPv.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearBuyRam = function() {
    return this.setBuyRam(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasBuyRam = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional EosActionBuyRamBytes buy_ram_bytes = 7;
 * @return {?proto.EosActionBuyRamBytes}
 */ proto.EosTxActionAck.prototype.getBuyRamBytes = function() {
    return /** @type{?proto.EosActionBuyRamBytes} */ $2MzPv.Message.getWrapperField(this, proto.EosActionBuyRamBytes, 7);
};
/**
 * @param {?proto.EosActionBuyRamBytes|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setBuyRamBytes = function(value) {
    return $2MzPv.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearBuyRamBytes = function() {
    return this.setBuyRamBytes(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasBuyRamBytes = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional EosActionSellRam sell_ram = 8;
 * @return {?proto.EosActionSellRam}
 */ proto.EosTxActionAck.prototype.getSellRam = function() {
    return /** @type{?proto.EosActionSellRam} */ $2MzPv.Message.getWrapperField(this, proto.EosActionSellRam, 8);
};
/**
 * @param {?proto.EosActionSellRam|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setSellRam = function(value) {
    return $2MzPv.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearSellRam = function() {
    return this.setSellRam(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasSellRam = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional EosActionVoteProducer vote_producer = 9;
 * @return {?proto.EosActionVoteProducer}
 */ proto.EosTxActionAck.prototype.getVoteProducer = function() {
    return /** @type{?proto.EosActionVoteProducer} */ $2MzPv.Message.getWrapperField(this, proto.EosActionVoteProducer, 9);
};
/**
 * @param {?proto.EosActionVoteProducer|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setVoteProducer = function(value) {
    return $2MzPv.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearVoteProducer = function() {
    return this.setVoteProducer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasVoteProducer = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional EosActionUpdateAuth update_auth = 10;
 * @return {?proto.EosActionUpdateAuth}
 */ proto.EosTxActionAck.prototype.getUpdateAuth = function() {
    return /** @type{?proto.EosActionUpdateAuth} */ $2MzPv.Message.getWrapperField(this, proto.EosActionUpdateAuth, 10);
};
/**
 * @param {?proto.EosActionUpdateAuth|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setUpdateAuth = function(value) {
    return $2MzPv.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearUpdateAuth = function() {
    return this.setUpdateAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasUpdateAuth = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional EosActionDeleteAuth delete_auth = 11;
 * @return {?proto.EosActionDeleteAuth}
 */ proto.EosTxActionAck.prototype.getDeleteAuth = function() {
    return /** @type{?proto.EosActionDeleteAuth} */ $2MzPv.Message.getWrapperField(this, proto.EosActionDeleteAuth, 11);
};
/**
 * @param {?proto.EosActionDeleteAuth|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setDeleteAuth = function(value) {
    return $2MzPv.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearDeleteAuth = function() {
    return this.setDeleteAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasDeleteAuth = function() {
    return $2MzPv.Message.getField(this, 11) != null;
};
/**
 * optional EosActionLinkAuth link_auth = 12;
 * @return {?proto.EosActionLinkAuth}
 */ proto.EosTxActionAck.prototype.getLinkAuth = function() {
    return /** @type{?proto.EosActionLinkAuth} */ $2MzPv.Message.getWrapperField(this, proto.EosActionLinkAuth, 12);
};
/**
 * @param {?proto.EosActionLinkAuth|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setLinkAuth = function(value) {
    return $2MzPv.Message.setWrapperField(this, 12, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearLinkAuth = function() {
    return this.setLinkAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasLinkAuth = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional EosActionUnlinkAuth unlink_auth = 13;
 * @return {?proto.EosActionUnlinkAuth}
 */ proto.EosTxActionAck.prototype.getUnlinkAuth = function() {
    return /** @type{?proto.EosActionUnlinkAuth} */ $2MzPv.Message.getWrapperField(this, proto.EosActionUnlinkAuth, 13);
};
/**
 * @param {?proto.EosActionUnlinkAuth|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setUnlinkAuth = function(value) {
    return $2MzPv.Message.setWrapperField(this, 13, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearUnlinkAuth = function() {
    return this.setUnlinkAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasUnlinkAuth = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
/**
 * optional EosActionNewAccount new_account = 14;
 * @return {?proto.EosActionNewAccount}
 */ proto.EosTxActionAck.prototype.getNewAccount = function() {
    return /** @type{?proto.EosActionNewAccount} */ $2MzPv.Message.getWrapperField(this, proto.EosActionNewAccount, 14);
};
/**
 * @param {?proto.EosActionNewAccount|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setNewAccount = function(value) {
    return $2MzPv.Message.setWrapperField(this, 14, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearNewAccount = function() {
    return this.setNewAccount(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasNewAccount = function() {
    return $2MzPv.Message.getField(this, 14) != null;
};
/**
 * optional EosActionUnknown unknown = 15;
 * @return {?proto.EosActionUnknown}
 */ proto.EosTxActionAck.prototype.getUnknown = function() {
    return /** @type{?proto.EosActionUnknown} */ $2MzPv.Message.getWrapperField(this, proto.EosActionUnknown, 15);
};
/**
 * @param {?proto.EosActionUnknown|undefined} value
 * @return {!proto.EosTxActionAck} returns this
*/ proto.EosTxActionAck.prototype.setUnknown = function(value) {
    return $2MzPv.Message.setWrapperField(this, 15, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosTxActionAck} returns this
 */ proto.EosTxActionAck.prototype.clearUnknown = function() {
    return this.setUnknown(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosTxActionAck.prototype.hasUnknown = function() {
    return $2MzPv.Message.getField(this, 15) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosAsset.prototype.toObject = function(opt_includeInstance) {
        return proto.EosAsset.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosAsset} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAsset.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            symbol: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosAsset}
 */ proto.EosAsset.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosAsset;
    return proto.EosAsset.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosAsset} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosAsset}
 */ proto.EosAsset.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSymbol(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosAsset.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosAsset.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosAsset} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAsset.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeSint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
};
/**
 * optional sint64 amount = 1;
 * @return {string}
 */ proto.EosAsset.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosAsset} returns this
 */ proto.EosAsset.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAsset} returns this
 */ proto.EosAsset.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAsset.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 symbol = 2;
 * @return {string}
 */ proto.EosAsset.prototype.getSymbol = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosAsset} returns this
 */ proto.EosAsset.prototype.setSymbol = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAsset} returns this
 */ proto.EosAsset.prototype.clearSymbol = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAsset.prototype.hasSymbol = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosPermissionLevel.prototype.toObject = function(opt_includeInstance) {
        return proto.EosPermissionLevel.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosPermissionLevel} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosPermissionLevel.toObject = function(includeInstance, msg) {
        var f, obj = {
            actor: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            permission: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosPermissionLevel}
 */ proto.EosPermissionLevel.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosPermissionLevel;
    return proto.EosPermissionLevel.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosPermissionLevel} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosPermissionLevel}
 */ proto.EosPermissionLevel.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setActor(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPermission(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosPermissionLevel.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosPermissionLevel.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosPermissionLevel} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosPermissionLevel.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
};
/**
 * optional uint64 actor = 1;
 * @return {string}
 */ proto.EosPermissionLevel.prototype.getActor = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosPermissionLevel} returns this
 */ proto.EosPermissionLevel.prototype.setActor = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosPermissionLevel} returns this
 */ proto.EosPermissionLevel.prototype.clearActor = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosPermissionLevel.prototype.hasActor = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 permission = 2;
 * @return {string}
 */ proto.EosPermissionLevel.prototype.getPermission = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosPermissionLevel} returns this
 */ proto.EosPermissionLevel.prototype.setPermission = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosPermissionLevel} returns this
 */ proto.EosPermissionLevel.prototype.clearPermission = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosPermissionLevel.prototype.hasPermission = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosAuthorizationKey.repeatedFields_ = [
    4
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosAuthorizationKey.prototype.toObject = function(opt_includeInstance) {
        return proto.EosAuthorizationKey.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosAuthorizationKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationKey.toObject = function(includeInstance, msg) {
        var f, obj = {
            type: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            key: msg.getKey_asB64(),
            weight: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosAuthorizationKey}
 */ proto.EosAuthorizationKey.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosAuthorizationKey;
    return proto.EosAuthorizationKey.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosAuthorizationKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosAuthorizationKey}
 */ proto.EosAuthorizationKey.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setType(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setKey(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWeight(value);
                break;
            case 4:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosAuthorizationKey.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosAuthorizationKey.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosAuthorizationKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationKey.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(4, f);
};
/**
 * optional uint32 type = 1;
 * @return {number}
 */ proto.EosAuthorizationKey.prototype.getType = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationKey.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes key = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EosAuthorizationKey.prototype.getKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes key = 2;
 * This is a type-conversion wrapper around `getKey()`
 * @return {string}
 */ proto.EosAuthorizationKey.prototype.getKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getKey());
};
/**
 * optional bytes key = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getKey()`
 * @return {!Uint8Array}
 */ proto.EosAuthorizationKey.prototype.getKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.setKey = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.clearKey = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationKey.prototype.hasKey = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 weight = 3;
 * @return {number}
 */ proto.EosAuthorizationKey.prototype.getWeight = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.setWeight = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.clearWeight = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationKey.prototype.hasWeight = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * repeated uint32 address_n = 4;
 * @return {!Array<number>}
 */ proto.EosAuthorizationKey.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 4);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 4, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosAuthorizationKey} returns this
 */ proto.EosAuthorizationKey.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosAuthorizationAccount.prototype.toObject = function(opt_includeInstance) {
        return proto.EosAuthorizationAccount.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosAuthorizationAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationAccount.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = msg.getAccount()) && proto.EosPermissionLevel.toObject(includeInstance, f),
            weight: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosAuthorizationAccount}
 */ proto.EosAuthorizationAccount.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosAuthorizationAccount;
    return proto.EosAuthorizationAccount.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosAuthorizationAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosAuthorizationAccount}
 */ proto.EosAuthorizationAccount.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.EosPermissionLevel;
                reader.readMessage(value, proto.EosPermissionLevel.deserializeBinaryFromReader);
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWeight(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosAuthorizationAccount.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosAuthorizationAccount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosAuthorizationAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationAccount.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccount();
    if (f != null) writer.writeMessage(1, f, proto.EosPermissionLevel.serializeBinaryToWriter);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
};
/**
 * optional EosPermissionLevel account = 1;
 * @return {?proto.EosPermissionLevel}
 */ proto.EosAuthorizationAccount.prototype.getAccount = function() {
    return /** @type{?proto.EosPermissionLevel} */ $2MzPv.Message.getWrapperField(this, proto.EosPermissionLevel, 1);
};
/**
 * @param {?proto.EosPermissionLevel|undefined} value
 * @return {!proto.EosAuthorizationAccount} returns this
*/ proto.EosAuthorizationAccount.prototype.setAccount = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosAuthorizationAccount} returns this
 */ proto.EosAuthorizationAccount.prototype.clearAccount = function() {
    return this.setAccount(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationAccount.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 weight = 2;
 * @return {number}
 */ proto.EosAuthorizationAccount.prototype.getWeight = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorizationAccount} returns this
 */ proto.EosAuthorizationAccount.prototype.setWeight = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationAccount} returns this
 */ proto.EosAuthorizationAccount.prototype.clearWeight = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationAccount.prototype.hasWeight = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosAuthorizationWait.prototype.toObject = function(opt_includeInstance) {
        return proto.EosAuthorizationWait.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosAuthorizationWait} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationWait.toObject = function(includeInstance, msg) {
        var f, obj = {
            waitSec: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            weight: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosAuthorizationWait}
 */ proto.EosAuthorizationWait.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosAuthorizationWait;
    return proto.EosAuthorizationWait.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosAuthorizationWait} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosAuthorizationWait}
 */ proto.EosAuthorizationWait.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWaitSec(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setWeight(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosAuthorizationWait.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosAuthorizationWait.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosAuthorizationWait} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorizationWait.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
};
/**
 * optional uint32 wait_sec = 1;
 * @return {number}
 */ proto.EosAuthorizationWait.prototype.getWaitSec = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorizationWait} returns this
 */ proto.EosAuthorizationWait.prototype.setWaitSec = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationWait} returns this
 */ proto.EosAuthorizationWait.prototype.clearWaitSec = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationWait.prototype.hasWaitSec = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 weight = 2;
 * @return {number}
 */ proto.EosAuthorizationWait.prototype.getWeight = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorizationWait} returns this
 */ proto.EosAuthorizationWait.prototype.setWeight = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorizationWait} returns this
 */ proto.EosAuthorizationWait.prototype.clearWeight = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorizationWait.prototype.hasWeight = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosAuthorization.repeatedFields_ = [
    2,
    3,
    4
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosAuthorization.prototype.toObject = function(opt_includeInstance) {
        return proto.EosAuthorization.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosAuthorization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorization.toObject = function(includeInstance, msg) {
        var f, obj = {
            threshold: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            keysList: $2MzPv.Message.toObjectList(msg.getKeysList(), proto.EosAuthorizationKey.toObject, includeInstance),
            accountsList: $2MzPv.Message.toObjectList(msg.getAccountsList(), proto.EosAuthorizationAccount.toObject, includeInstance),
            waitsList: $2MzPv.Message.toObjectList(msg.getWaitsList(), proto.EosAuthorizationWait.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosAuthorization}
 */ proto.EosAuthorization.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosAuthorization;
    return proto.EosAuthorization.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosAuthorization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosAuthorization}
 */ proto.EosAuthorization.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setThreshold(value);
                break;
            case 2:
                var value = new proto.EosAuthorizationKey;
                reader.readMessage(value, proto.EosAuthorizationKey.deserializeBinaryFromReader);
                msg.addKeys(value);
                break;
            case 3:
                var value = new proto.EosAuthorizationAccount;
                reader.readMessage(value, proto.EosAuthorizationAccount.deserializeBinaryFromReader);
                msg.addAccounts(value);
                break;
            case 4:
                var value = new proto.EosAuthorizationWait;
                reader.readMessage(value, proto.EosAuthorizationWait.deserializeBinaryFromReader);
                msg.addWaits(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosAuthorization.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosAuthorization.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosAuthorization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosAuthorization.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = message.getKeysList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.EosAuthorizationKey.serializeBinaryToWriter);
    f = message.getAccountsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.EosAuthorizationAccount.serializeBinaryToWriter);
    f = message.getWaitsList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.EosAuthorizationWait.serializeBinaryToWriter);
};
/**
 * optional uint32 threshold = 1;
 * @return {number}
 */ proto.EosAuthorization.prototype.getThreshold = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosAuthorization} returns this
 */ proto.EosAuthorization.prototype.setThreshold = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosAuthorization} returns this
 */ proto.EosAuthorization.prototype.clearThreshold = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosAuthorization.prototype.hasThreshold = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * repeated EosAuthorizationKey keys = 2;
 * @return {!Array<!proto.EosAuthorizationKey>}
 */ proto.EosAuthorization.prototype.getKeysList = function() {
    return /** @type{!Array<!proto.EosAuthorizationKey>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.EosAuthorizationKey, 2);
};
/**
 * @param {!Array<!proto.EosAuthorizationKey>} value
 * @return {!proto.EosAuthorization} returns this
*/ proto.EosAuthorization.prototype.setKeysList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.EosAuthorizationKey=} opt_value
 * @param {number=} opt_index
 * @return {!proto.EosAuthorizationKey}
 */ proto.EosAuthorization.prototype.addKeys = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.EosAuthorizationKey, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosAuthorization} returns this
 */ proto.EosAuthorization.prototype.clearKeysList = function() {
    return this.setKeysList([]);
};
/**
 * repeated EosAuthorizationAccount accounts = 3;
 * @return {!Array<!proto.EosAuthorizationAccount>}
 */ proto.EosAuthorization.prototype.getAccountsList = function() {
    return /** @type{!Array<!proto.EosAuthorizationAccount>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.EosAuthorizationAccount, 3);
};
/**
 * @param {!Array<!proto.EosAuthorizationAccount>} value
 * @return {!proto.EosAuthorization} returns this
*/ proto.EosAuthorization.prototype.setAccountsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.EosAuthorizationAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.EosAuthorizationAccount}
 */ proto.EosAuthorization.prototype.addAccounts = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.EosAuthorizationAccount, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosAuthorization} returns this
 */ proto.EosAuthorization.prototype.clearAccountsList = function() {
    return this.setAccountsList([]);
};
/**
 * repeated EosAuthorizationWait waits = 4;
 * @return {!Array<!proto.EosAuthorizationWait>}
 */ proto.EosAuthorization.prototype.getWaitsList = function() {
    return /** @type{!Array<!proto.EosAuthorizationWait>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.EosAuthorizationWait, 4);
};
/**
 * @param {!Array<!proto.EosAuthorizationWait>} value
 * @return {!proto.EosAuthorization} returns this
*/ proto.EosAuthorization.prototype.setWaitsList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.EosAuthorizationWait=} opt_value
 * @param {number=} opt_index
 * @return {!proto.EosAuthorizationWait}
 */ proto.EosAuthorization.prototype.addWaits = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.EosAuthorizationWait, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosAuthorization} returns this
 */ proto.EosAuthorization.prototype.clearWaitsList = function() {
    return this.setWaitsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosActionCommon.repeatedFields_ = [
    3
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionCommon.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionCommon.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionCommon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionCommon.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            name: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            authorizationList: $2MzPv.Message.toObjectList(msg.getAuthorizationList(), proto.EosPermissionLevel.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionCommon}
 */ proto.EosActionCommon.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionCommon;
    return proto.EosActionCommon.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionCommon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionCommon}
 */ proto.EosActionCommon.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setName(value);
                break;
            case 3:
                var value = new proto.EosPermissionLevel;
                reader.readMessage(value, proto.EosPermissionLevel.deserializeBinaryFromReader);
                msg.addAuthorization(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionCommon.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionCommon.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionCommon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionCommon.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getAuthorizationList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.EosPermissionLevel.serializeBinaryToWriter);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionCommon.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionCommon} returns this
 */ proto.EosActionCommon.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionCommon} returns this
 */ proto.EosActionCommon.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionCommon.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 name = 2;
 * @return {string}
 */ proto.EosActionCommon.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionCommon} returns this
 */ proto.EosActionCommon.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionCommon} returns this
 */ proto.EosActionCommon.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionCommon.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * repeated EosPermissionLevel authorization = 3;
 * @return {!Array<!proto.EosPermissionLevel>}
 */ proto.EosActionCommon.prototype.getAuthorizationList = function() {
    return /** @type{!Array<!proto.EosPermissionLevel>} */ $2MzPv.Message.getRepeatedWrapperField(this, proto.EosPermissionLevel, 3);
};
/**
 * @param {!Array<!proto.EosPermissionLevel>} value
 * @return {!proto.EosActionCommon} returns this
*/ proto.EosActionCommon.prototype.setAuthorizationList = function(value) {
    return $2MzPv.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.EosPermissionLevel=} opt_value
 * @param {number=} opt_index
 * @return {!proto.EosPermissionLevel}
 */ proto.EosActionCommon.prototype.addAuthorization = function(opt_value, opt_index) {
    return $2MzPv.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.EosPermissionLevel, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosActionCommon} returns this
 */ proto.EosActionCommon.prototype.clearAuthorizationList = function() {
    return this.setAuthorizationList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionTransfer.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionTransfer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionTransfer.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            quantity: (f = msg.getQuantity()) && proto.EosAsset.toObject(includeInstance, f),
            memo: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionTransfer}
 */ proto.EosActionTransfer.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionTransfer;
    return proto.EosActionTransfer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionTransfer}
 */ proto.EosActionTransfer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setReceiver(value);
                break;
            case 3:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setQuantity(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionTransfer.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionTransfer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionTransfer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getQuantity();
    if (f != null) writer.writeMessage(3, f, proto.EosAsset.serializeBinaryToWriter);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional uint64 sender = 1;
 * @return {string}
 */ proto.EosActionTransfer.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionTransfer.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 receiver = 2;
 * @return {string}
 */ proto.EosActionTransfer.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionTransfer.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosAsset quantity = 3;
 * @return {?proto.EosAsset}
 */ proto.EosActionTransfer.prototype.getQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 3);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionTransfer} returns this
*/ proto.EosActionTransfer.prototype.setQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.clearQuantity = function() {
    return this.setQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionTransfer.prototype.hasQuantity = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string memo = 4;
 * @return {string}
 */ proto.EosActionTransfer.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionTransfer} returns this
 */ proto.EosActionTransfer.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionTransfer.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionDelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionDelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionDelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionDelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            netQuantity: (f = msg.getNetQuantity()) && proto.EosAsset.toObject(includeInstance, f),
            cpuQuantity: (f = msg.getCpuQuantity()) && proto.EosAsset.toObject(includeInstance, f),
            transfer: (f = $2MzPv.Message.getBooleanField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionDelegate}
 */ proto.EosActionDelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionDelegate;
    return proto.EosActionDelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionDelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionDelegate}
 */ proto.EosActionDelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setReceiver(value);
                break;
            case 3:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setNetQuantity(value);
                break;
            case 4:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setCpuQuantity(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTransfer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionDelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionDelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionDelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionDelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getNetQuantity();
    if (f != null) writer.writeMessage(3, f, proto.EosAsset.serializeBinaryToWriter);
    f = message.getCpuQuantity();
    if (f != null) writer.writeMessage(4, f, proto.EosAsset.serializeBinaryToWriter);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
};
/**
 * optional uint64 sender = 1;
 * @return {string}
 */ proto.EosActionDelegate.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 receiver = 2;
 * @return {string}
 */ proto.EosActionDelegate.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosAsset net_quantity = 3;
 * @return {?proto.EosAsset}
 */ proto.EosActionDelegate.prototype.getNetQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 3);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionDelegate} returns this
*/ proto.EosActionDelegate.prototype.setNetQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.clearNetQuantity = function() {
    return this.setNetQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.hasNetQuantity = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional EosAsset cpu_quantity = 4;
 * @return {?proto.EosAsset}
 */ proto.EosActionDelegate.prototype.getCpuQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 4);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionDelegate} returns this
*/ proto.EosActionDelegate.prototype.setCpuQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.clearCpuQuantity = function() {
    return this.setCpuQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.hasCpuQuantity = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bool transfer = 5;
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.getTransfer = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.setTransfer = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionDelegate} returns this
 */ proto.EosActionDelegate.prototype.clearTransfer = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDelegate.prototype.hasTransfer = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionUndelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionUndelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionUndelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUndelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            netQuantity: (f = msg.getNetQuantity()) && proto.EosAsset.toObject(includeInstance, f),
            cpuQuantity: (f = msg.getCpuQuantity()) && proto.EosAsset.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionUndelegate}
 */ proto.EosActionUndelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionUndelegate;
    return proto.EosActionUndelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionUndelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionUndelegate}
 */ proto.EosActionUndelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setReceiver(value);
                break;
            case 3:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setNetQuantity(value);
                break;
            case 4:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setCpuQuantity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionUndelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionUndelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionUndelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUndelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getNetQuantity();
    if (f != null) writer.writeMessage(3, f, proto.EosAsset.serializeBinaryToWriter);
    f = message.getCpuQuantity();
    if (f != null) writer.writeMessage(4, f, proto.EosAsset.serializeBinaryToWriter);
};
/**
 * optional uint64 sender = 1;
 * @return {string}
 */ proto.EosActionUndelegate.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUndelegate.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 receiver = 2;
 * @return {string}
 */ proto.EosActionUndelegate.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUndelegate.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosAsset net_quantity = 3;
 * @return {?proto.EosAsset}
 */ proto.EosActionUndelegate.prototype.getNetQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 3);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionUndelegate} returns this
*/ proto.EosActionUndelegate.prototype.setNetQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.clearNetQuantity = function() {
    return this.setNetQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUndelegate.prototype.hasNetQuantity = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional EosAsset cpu_quantity = 4;
 * @return {?proto.EosAsset}
 */ proto.EosActionUndelegate.prototype.getCpuQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 4);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionUndelegate} returns this
*/ proto.EosActionUndelegate.prototype.setCpuQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionUndelegate} returns this
 */ proto.EosActionUndelegate.prototype.clearCpuQuantity = function() {
    return this.setCpuQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUndelegate.prototype.hasCpuQuantity = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionRefund.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionRefund.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionRefund} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionRefund.toObject = function(includeInstance, msg) {
        var f, obj = {
            owner: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionRefund}
 */ proto.EosActionRefund.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionRefund;
    return proto.EosActionRefund.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionRefund} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionRefund}
 */ proto.EosActionRefund.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setOwner(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionRefund.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionRefund.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionRefund} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionRefund.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
};
/**
 * optional uint64 owner = 1;
 * @return {string}
 */ proto.EosActionRefund.prototype.getOwner = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionRefund} returns this
 */ proto.EosActionRefund.prototype.setOwner = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionRefund} returns this
 */ proto.EosActionRefund.prototype.clearOwner = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionRefund.prototype.hasOwner = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionBuyRam.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionBuyRam.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionBuyRam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionBuyRam.toObject = function(includeInstance, msg) {
        var f, obj = {
            payer: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            quantity: (f = msg.getQuantity()) && proto.EosAsset.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionBuyRam}
 */ proto.EosActionBuyRam.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionBuyRam;
    return proto.EosActionBuyRam.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionBuyRam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionBuyRam}
 */ proto.EosActionBuyRam.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPayer(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setReceiver(value);
                break;
            case 3:
                var value = new proto.EosAsset;
                reader.readMessage(value, proto.EosAsset.deserializeBinaryFromReader);
                msg.setQuantity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionBuyRam.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionBuyRam.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionBuyRam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionBuyRam.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getQuantity();
    if (f != null) writer.writeMessage(3, f, proto.EosAsset.serializeBinaryToWriter);
};
/**
 * optional uint64 payer = 1;
 * @return {string}
 */ proto.EosActionBuyRam.prototype.getPayer = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionBuyRam} returns this
 */ proto.EosActionBuyRam.prototype.setPayer = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionBuyRam} returns this
 */ proto.EosActionBuyRam.prototype.clearPayer = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRam.prototype.hasPayer = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 receiver = 2;
 * @return {string}
 */ proto.EosActionBuyRam.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionBuyRam} returns this
 */ proto.EosActionBuyRam.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionBuyRam} returns this
 */ proto.EosActionBuyRam.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRam.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosAsset quantity = 3;
 * @return {?proto.EosAsset}
 */ proto.EosActionBuyRam.prototype.getQuantity = function() {
    return /** @type{?proto.EosAsset} */ $2MzPv.Message.getWrapperField(this, proto.EosAsset, 3);
};
/**
 * @param {?proto.EosAsset|undefined} value
 * @return {!proto.EosActionBuyRam} returns this
*/ proto.EosActionBuyRam.prototype.setQuantity = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionBuyRam} returns this
 */ proto.EosActionBuyRam.prototype.clearQuantity = function() {
    return this.setQuantity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRam.prototype.hasQuantity = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionBuyRamBytes.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionBuyRamBytes.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionBuyRamBytes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionBuyRamBytes.toObject = function(includeInstance, msg) {
        var f, obj = {
            payer: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            bytes: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionBuyRamBytes}
 */ proto.EosActionBuyRamBytes.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionBuyRamBytes;
    return proto.EosActionBuyRamBytes.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionBuyRamBytes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionBuyRamBytes}
 */ proto.EosActionBuyRamBytes.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPayer(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setReceiver(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBytes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionBuyRamBytes.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionBuyRamBytes.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionBuyRamBytes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionBuyRamBytes.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
};
/**
 * optional uint64 payer = 1;
 * @return {string}
 */ proto.EosActionBuyRamBytes.prototype.getPayer = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.setPayer = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.clearPayer = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRamBytes.prototype.hasPayer = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 receiver = 2;
 * @return {string}
 */ proto.EosActionBuyRamBytes.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRamBytes.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 bytes = 3;
 * @return {number}
 */ proto.EosActionBuyRamBytes.prototype.getBytes = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.setBytes = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionBuyRamBytes} returns this
 */ proto.EosActionBuyRamBytes.prototype.clearBytes = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionBuyRamBytes.prototype.hasBytes = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionSellRam.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionSellRam.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionSellRam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionSellRam.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            bytes: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionSellRam}
 */ proto.EosActionSellRam.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionSellRam;
    return proto.EosActionSellRam.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionSellRam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionSellRam}
 */ proto.EosActionSellRam.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readSint64String();
                msg.setBytes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionSellRam.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionSellRam.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionSellRam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionSellRam.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeSint64String(2, f);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionSellRam.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionSellRam} returns this
 */ proto.EosActionSellRam.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionSellRam} returns this
 */ proto.EosActionSellRam.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionSellRam.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional sint64 bytes = 2;
 * @return {string}
 */ proto.EosActionSellRam.prototype.getBytes = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionSellRam} returns this
 */ proto.EosActionSellRam.prototype.setBytes = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionSellRam} returns this
 */ proto.EosActionSellRam.prototype.clearBytes = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionSellRam.prototype.hasBytes = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EosActionVoteProducer.repeatedFields_ = [
    3
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionVoteProducer.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionVoteProducer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionVoteProducer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionVoteProducer.toObject = function(includeInstance, msg) {
        var f, obj = {
            voter: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            proxy: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            producersList: (f = $2MzPv.Message.getRepeatedField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionVoteProducer}
 */ proto.EosActionVoteProducer.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionVoteProducer;
    return proto.EosActionVoteProducer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionVoteProducer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionVoteProducer}
 */ proto.EosActionVoteProducer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setVoter(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setProxy(value);
                break;
            case 3:
                var values = /** @type {!Array<string>} */ reader.isDelimited() ? reader.readPackedUint64String() : [
                    reader.readUint64String()
                ];
                for(var i = 0; i < values.length; i++)msg.addProducers(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionVoteProducer.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionVoteProducer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionVoteProducer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionVoteProducer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getProducersList();
    if (f.length > 0) writer.writeRepeatedUint64String(3, f);
};
/**
 * optional uint64 voter = 1;
 * @return {string}
 */ proto.EosActionVoteProducer.prototype.getVoter = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.setVoter = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.clearVoter = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionVoteProducer.prototype.hasVoter = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 proxy = 2;
 * @return {string}
 */ proto.EosActionVoteProducer.prototype.getProxy = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.setProxy = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.clearProxy = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionVoteProducer.prototype.hasProxy = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * repeated uint64 producers = 3;
 * @return {!Array<string>}
 */ proto.EosActionVoteProducer.prototype.getProducersList = function() {
    return /** @type {!Array<string>} */ $2MzPv.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.setProducersList = function(value) {
    return $2MzPv.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.addProducers = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EosActionVoteProducer} returns this
 */ proto.EosActionVoteProducer.prototype.clearProducersList = function() {
    return this.setProducersList([]);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionUpdateAuth.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionUpdateAuth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionUpdateAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUpdateAuth.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            permission: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            parent: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            auth: (f = msg.getAuth()) && proto.EosAuthorization.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionUpdateAuth}
 */ proto.EosActionUpdateAuth.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionUpdateAuth;
    return proto.EosActionUpdateAuth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionUpdateAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionUpdateAuth}
 */ proto.EosActionUpdateAuth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPermission(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setParent(value);
                break;
            case 4:
                var value = new proto.EosAuthorization;
                reader.readMessage(value, proto.EosAuthorization.deserializeBinaryFromReader);
                msg.setAuth(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionUpdateAuth.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionUpdateAuth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionUpdateAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUpdateAuth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
    f = message.getAuth();
    if (f != null) writer.writeMessage(4, f, proto.EosAuthorization.serializeBinaryToWriter);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionUpdateAuth.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUpdateAuth.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 permission = 2;
 * @return {string}
 */ proto.EosActionUpdateAuth.prototype.getPermission = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.setPermission = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.clearPermission = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUpdateAuth.prototype.hasPermission = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 parent = 3;
 * @return {string}
 */ proto.EosActionUpdateAuth.prototype.getParent = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.setParent = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.clearParent = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUpdateAuth.prototype.hasParent = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional EosAuthorization auth = 4;
 * @return {?proto.EosAuthorization}
 */ proto.EosActionUpdateAuth.prototype.getAuth = function() {
    return /** @type{?proto.EosAuthorization} */ $2MzPv.Message.getWrapperField(this, proto.EosAuthorization, 4);
};
/**
 * @param {?proto.EosAuthorization|undefined} value
 * @return {!proto.EosActionUpdateAuth} returns this
*/ proto.EosActionUpdateAuth.prototype.setAuth = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionUpdateAuth} returns this
 */ proto.EosActionUpdateAuth.prototype.clearAuth = function() {
    return this.setAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUpdateAuth.prototype.hasAuth = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionDeleteAuth.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionDeleteAuth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionDeleteAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionDeleteAuth.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            permission: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionDeleteAuth}
 */ proto.EosActionDeleteAuth.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionDeleteAuth;
    return proto.EosActionDeleteAuth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionDeleteAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionDeleteAuth}
 */ proto.EosActionDeleteAuth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPermission(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionDeleteAuth.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionDeleteAuth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionDeleteAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionDeleteAuth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionDeleteAuth.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionDeleteAuth} returns this
 */ proto.EosActionDeleteAuth.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionDeleteAuth} returns this
 */ proto.EosActionDeleteAuth.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDeleteAuth.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 permission = 2;
 * @return {string}
 */ proto.EosActionDeleteAuth.prototype.getPermission = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionDeleteAuth} returns this
 */ proto.EosActionDeleteAuth.prototype.setPermission = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionDeleteAuth} returns this
 */ proto.EosActionDeleteAuth.prototype.clearPermission = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionDeleteAuth.prototype.hasPermission = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionLinkAuth.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionLinkAuth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionLinkAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionLinkAuth.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            code: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            type: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            requirement: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionLinkAuth}
 */ proto.EosActionLinkAuth.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionLinkAuth;
    return proto.EosActionLinkAuth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionLinkAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionLinkAuth}
 */ proto.EosActionLinkAuth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setCode(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setRequirement(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionLinkAuth.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionLinkAuth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionLinkAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionLinkAuth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint64String(4, f);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionLinkAuth.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionLinkAuth.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 code = 2;
 * @return {string}
 */ proto.EosActionLinkAuth.prototype.getCode = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.setCode = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.clearCode = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionLinkAuth.prototype.hasCode = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 type = 3;
 * @return {string}
 */ proto.EosActionLinkAuth.prototype.getType = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionLinkAuth.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint64 requirement = 4;
 * @return {string}
 */ proto.EosActionLinkAuth.prototype.getRequirement = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.setRequirement = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionLinkAuth} returns this
 */ proto.EosActionLinkAuth.prototype.clearRequirement = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionLinkAuth.prototype.hasRequirement = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionUnlinkAuth.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionUnlinkAuth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionUnlinkAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUnlinkAuth.toObject = function(includeInstance, msg) {
        var f, obj = {
            account: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            code: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            type: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionUnlinkAuth}
 */ proto.EosActionUnlinkAuth.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionUnlinkAuth;
    return proto.EosActionUnlinkAuth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionUnlinkAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionUnlinkAuth}
 */ proto.EosActionUnlinkAuth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setCode(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionUnlinkAuth.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionUnlinkAuth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionUnlinkAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUnlinkAuth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint64String(3, f);
};
/**
 * optional uint64 account = 1;
 * @return {string}
 */ proto.EosActionUnlinkAuth.prototype.getAccount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.setAccount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.clearAccount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUnlinkAuth.prototype.hasAccount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 code = 2;
 * @return {string}
 */ proto.EosActionUnlinkAuth.prototype.getCode = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.setCode = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.clearCode = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUnlinkAuth.prototype.hasCode = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint64 type = 3;
 * @return {string}
 */ proto.EosActionUnlinkAuth.prototype.getType = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUnlinkAuth} returns this
 */ proto.EosActionUnlinkAuth.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUnlinkAuth.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionNewAccount.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionNewAccount.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionNewAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionNewAccount.toObject = function(includeInstance, msg) {
        var f, obj = {
            creator: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            name: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            owner: (f = msg.getOwner()) && proto.EosAuthorization.toObject(includeInstance, f),
            active: (f = msg.getActive()) && proto.EosAuthorization.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionNewAccount}
 */ proto.EosActionNewAccount.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionNewAccount;
    return proto.EosActionNewAccount.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionNewAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionNewAccount}
 */ proto.EosActionNewAccount.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setCreator(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setName(value);
                break;
            case 3:
                var value = new proto.EosAuthorization;
                reader.readMessage(value, proto.EosAuthorization.deserializeBinaryFromReader);
                msg.setOwner(value);
                break;
            case 4:
                var value = new proto.EosAuthorization;
                reader.readMessage(value, proto.EosAuthorization.deserializeBinaryFromReader);
                msg.setActive(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionNewAccount.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionNewAccount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionNewAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionNewAccount.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64String(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = message.getOwner();
    if (f != null) writer.writeMessage(3, f, proto.EosAuthorization.serializeBinaryToWriter);
    f = message.getActive();
    if (f != null) writer.writeMessage(4, f, proto.EosAuthorization.serializeBinaryToWriter);
};
/**
 * optional uint64 creator = 1;
 * @return {string}
 */ proto.EosActionNewAccount.prototype.getCreator = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.setCreator = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.clearCreator = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionNewAccount.prototype.hasCreator = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 name = 2;
 * @return {string}
 */ proto.EosActionNewAccount.prototype.getName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.setName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.clearName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionNewAccount.prototype.hasName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional EosAuthorization owner = 3;
 * @return {?proto.EosAuthorization}
 */ proto.EosActionNewAccount.prototype.getOwner = function() {
    return /** @type{?proto.EosAuthorization} */ $2MzPv.Message.getWrapperField(this, proto.EosAuthorization, 3);
};
/**
 * @param {?proto.EosAuthorization|undefined} value
 * @return {!proto.EosActionNewAccount} returns this
*/ proto.EosActionNewAccount.prototype.setOwner = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.clearOwner = function() {
    return this.setOwner(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionNewAccount.prototype.hasOwner = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional EosAuthorization active = 4;
 * @return {?proto.EosAuthorization}
 */ proto.EosActionNewAccount.prototype.getActive = function() {
    return /** @type{?proto.EosAuthorization} */ $2MzPv.Message.getWrapperField(this, proto.EosAuthorization, 4);
};
/**
 * @param {?proto.EosAuthorization|undefined} value
 * @return {!proto.EosActionNewAccount} returns this
*/ proto.EosActionNewAccount.prototype.setActive = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.EosActionNewAccount} returns this
 */ proto.EosActionNewAccount.prototype.clearActive = function() {
    return this.setActive(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionNewAccount.prototype.hasActive = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosActionUnknown.prototype.toObject = function(opt_includeInstance) {
        return proto.EosActionUnknown.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosActionUnknown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUnknown.toObject = function(includeInstance, msg) {
        var f, obj = {
            dataSize: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            dataChunk: msg.getDataChunk_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosActionUnknown}
 */ proto.EosActionUnknown.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosActionUnknown;
    return proto.EosActionUnknown.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosActionUnknown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosActionUnknown}
 */ proto.EosActionUnknown.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDataSize(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDataChunk(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosActionUnknown.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosActionUnknown.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosActionUnknown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosActionUnknown.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional uint32 data_size = 1;
 * @return {number}
 */ proto.EosActionUnknown.prototype.getDataSize = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosActionUnknown} returns this
 */ proto.EosActionUnknown.prototype.setDataSize = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUnknown} returns this
 */ proto.EosActionUnknown.prototype.clearDataSize = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUnknown.prototype.hasDataSize = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes data_chunk = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EosActionUnknown.prototype.getDataChunk = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes data_chunk = 2;
 * This is a type-conversion wrapper around `getDataChunk()`
 * @return {string}
 */ proto.EosActionUnknown.prototype.getDataChunk_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getDataChunk());
};
/**
 * optional bytes data_chunk = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDataChunk()`
 * @return {!Uint8Array}
 */ proto.EosActionUnknown.prototype.getDataChunk_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getDataChunk());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosActionUnknown} returns this
 */ proto.EosActionUnknown.prototype.setDataChunk = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosActionUnknown} returns this
 */ proto.EosActionUnknown.prototype.clearDataChunk = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosActionUnknown.prototype.hasDataChunk = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EosSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.EosSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EosSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            signatureV: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            signatureR: msg.getSignatureR_asB64(),
            signatureS: msg.getSignatureS_asB64(),
            hash: msg.getHash_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EosSignedTx}
 */ proto.EosSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EosSignedTx;
    return proto.EosSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EosSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EosSignedTx}
 */ proto.EosSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSignatureV(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignatureR(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignatureS(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setHash(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EosSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EosSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EosSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EosSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
};
/**
 * optional uint32 signature_v = 1;
 * @return {number}
 */ proto.EosSignedTx.prototype.getSignatureV = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.setSignatureV = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.clearSignatureV = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignedTx.prototype.hasSignatureV = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature_r = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EosSignedTx.prototype.getSignatureR = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature_r = 2;
 * This is a type-conversion wrapper around `getSignatureR()`
 * @return {string}
 */ proto.EosSignedTx.prototype.getSignatureR_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignatureR());
};
/**
 * optional bytes signature_r = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignatureR()`
 * @return {!Uint8Array}
 */ proto.EosSignedTx.prototype.getSignatureR_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignatureR());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.setSignatureR = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.clearSignatureR = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignedTx.prototype.hasSignatureR = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes signature_s = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EosSignedTx.prototype.getSignatureS = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes signature_s = 3;
 * This is a type-conversion wrapper around `getSignatureS()`
 * @return {string}
 */ proto.EosSignedTx.prototype.getSignatureS_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignatureS());
};
/**
 * optional bytes signature_s = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignatureS()`
 * @return {!Uint8Array}
 */ proto.EosSignedTx.prototype.getSignatureS_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignatureS());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.setSignatureS = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.clearSignatureS = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignedTx.prototype.hasSignatureS = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes hash = 4;
 * @return {!(string|Uint8Array)}
 */ proto.EosSignedTx.prototype.getHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes hash = 4;
 * This is a type-conversion wrapper around `getHash()`
 * @return {string}
 */ proto.EosSignedTx.prototype.getHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getHash());
};
/**
 * optional bytes hash = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHash()`
 * @return {!Uint8Array}
 */ proto.EosSignedTx.prototype.getHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.setHash = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EosSignedTx} returns this
 */ proto.EosSignedTx.prototype.clearHash = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EosSignedTx.prototype.hasHash = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * @enum {number}
 */ proto.EosPublicKeyKind = {
    EOS: 0,
    EOS_K1: 1,
    EOS_R1: 2
};
$e45745d0e423cacd$var$goog.object.extend($e45745d0e423cacd$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $hZS7n = parcelRequire("hZS7n");

var $3FiLE = parcelRequire("3FiLE");

var $jRkuS = parcelRequire("jRkuS");

var $ihoyg = parcelRequire("ihoyg");
var $3c1604a9db806af4$require$Buffer = $ihoyg.Buffer;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3c1604a9db806af4$var$eosSigFormatter(r, s, v) {
    const recoverId = 0x1f;
    let signature = "SIG_K1_";
    console.debug("formatter logs");
    const keyBuffer = $3c1604a9db806af4$require$Buffer.alloc(65);
    const rbuf = $3c1604a9db806af4$require$Buffer.from(r);
    const sbuf = $3c1604a9db806af4$require$Buffer.from(s);
    keyBuffer.writeUInt8(recoverId, 0);
    rbuf.copy(keyBuffer, 1);
    sbuf.copy(keyBuffer, 33);
    console.debug(keyBuffer);
    const check = [
        keyBuffer
    ];
    const keyType = "K1"; // we only sign using K1 curve
    check.push($3c1604a9db806af4$require$Buffer.from(keyType));
    console.debug(check);
    console.debug("hash");
    console.debug((0, (/*@__PURE__*/$parcel$interopDefault($3FiLE)))("ripemd160").update($7NkOr.compatibleBufferConcat(check)).digest());
    const chksum = (0, (/*@__PURE__*/$parcel$interopDefault($3FiLE)))("ripemd160").update($7NkOr.compatibleBufferConcat(check)).digest().slice(0, 4);
    console.debug(chksum);
    signature = signature.concat($hZS7n.encode($7NkOr.compatibleBufferConcat([
        keyBuffer,
        chksum
    ])));
    console.debug(signature);
    return signature;
}
function $3c1604a9db806af4$var$charToSymbol(c) {
    if (c.charCodeAt(0) >= "a".charCodeAt(0) && c.charCodeAt(0) <= "z".charCodeAt(0)) return c.charCodeAt(0) - "a".charCodeAt(0) + 6;
    if (c.charCodeAt(0) >= "1".charCodeAt(0) && c.charCodeAt(0) <= "5".charCodeAt(0)) return c.charCodeAt(0) - "1".charCodeAt(0) + 1;
    return 0;
}
function $3c1604a9db806af4$var$nameToNumber(name) {
    let value = new (0, (/*@__PURE__*/$parcel$interopDefault($jRkuS)))(0, 0, true);
    let c = new (0, (/*@__PURE__*/$parcel$interopDefault($jRkuS)))(0, 0, true);
    for(let i = 0; i < 13; i++){
        if (i < name.length && i < 13) c = (0, (/*@__PURE__*/$parcel$interopDefault($jRkuS))).fromNumber($3c1604a9db806af4$var$charToSymbol(name[i]), true);
        if (i < 12) {
            c = c.and((0, (/*@__PURE__*/$parcel$interopDefault($jRkuS))).fromString("1f", true, 16));
            c = c.shl(64 - 5 * (i + 1));
        } else // last iteration
        c = c.and((0, (/*@__PURE__*/$parcel$interopDefault($jRkuS))).fromString("0f", true, 16));
        value = value.or(c);
    }
    return value.toString();
}
function $3c1604a9db806af4$var$symbolFromString(p, name) {
    let result = 0;
    for(let i = 0; i < name.length; i++)result |= name.charCodeAt(i) << 8 * (i + 1);
    result |= p;
    return result;
}
function $3c1604a9db806af4$var$assetToNumber(asset) {
    const assetSplit = asset.split(" "); // amount, symbol
    const dot_pos = assetSplit[0].indexOf(".");
    let fract_part = 0;
    let int_part = 0;
    let precision_digit = 0;
    // parse symbol
    if (dot_pos != -1) precision_digit = assetSplit[0].length - dot_pos - 1;
    else precision_digit = 0;
    const sym = $3c1604a9db806af4$var$symbolFromString(precision_digit, assetSplit[1]);
    //parse amount
    if (dot_pos != -1) {
        int_part = parseInt(assetSplit[0].slice(0, dot_pos));
        fract_part = parseInt(assetSplit[0].slice(dot_pos + 1));
        if (int_part < 0) fract_part *= -1;
    } else int_part = parseInt(assetSplit[0]);
    let amount = int_part;
    amount *= Math.pow(10, sym & 0xff);
    amount += fract_part;
    return [
        amount,
        sym
    ];
}
function $3c1604a9db806af4$export$25d2e327a4f7b21a(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Eos"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $3c1604a9db806af4$export$526bf75314a8a0de(transport, msg) {
    const getPubkey = new $e45745d0e423cacd$exports.EosGetPublicKey();
    getPubkey.setAddressNList(msg.addressNList);
    getPubkey.setShowDisplay(msg.showDisplay !== false);
    getPubkey.setKind(msg.kind);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_EOSGETPUBLICKEY, getPubkey, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const eosPubkey = response.proto;
    return $7NkOr.mustBeDefined(eosPubkey.getWifPublicKey());
}
async function $3c1604a9db806af4$export$62ad1ee4b348f12c(transport, msg) {
    return transport.lockDuring(async ()=>{
        let resp;
        // check some params
        if (msg.tx.actions.length > 1) throw new Error(`Too many actions in Eos transaction: Keepkey only supports one!`);
        const signTx = new $e45745d0e423cacd$exports.EosSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setChainId($7NkOr.fromHexString(msg.chain_id));
        const txHeader = new $e45745d0e423cacd$exports.EosTxHeader();
        txHeader.setExpiration((Date.parse(msg.tx.expiration) - Date.parse("01 Jan 1970 00:00:00Z") - new Date().getTimezoneOffset() * 60000) / 1000);
        txHeader.setRefBlockNum(msg.tx.ref_block_num);
        txHeader.setRefBlockPrefix(msg.tx.ref_block_prefix);
        txHeader.setMaxNetUsageWords(msg.tx.max_net_usage_words);
        txHeader.setMaxCpuUsageMs(msg.tx.max_cpu_usage_ms);
        txHeader.setDelaySec(msg.tx.delay_sec);
        signTx.setHeader(txHeader);
        signTx.setNumActions(msg.tx.actions.length);
        console.debug("tx header");
        console.debug(txHeader);
        resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_EOSSIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_EOSTXACTIONREQUEST) throw new Error(`eos: unexpected response ${resp.message_type}`);
        // parse the common block of the action
        const actCommon = new $e45745d0e423cacd$exports.EosActionCommon();
        actCommon.setAccount($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].account).toString());
        actCommon.setName($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].name).toString());
        // interate through authorizations and add them
        for(let n = 0; n < msg.tx.actions[0].authorization.length; n++){
            const actPerm = new $e45745d0e423cacd$exports.EosPermissionLevel();
            actPerm.setActor($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].authorization[n].actor).toString());
            actPerm.setPermission($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].authorization[n].permission).toString());
            actCommon.addAuthorization(actPerm);
        }
        const actAck = new $e45745d0e423cacd$exports.EosTxActionAck();
        actAck.setCommon(actCommon);
        // parse the various action types here.
        switch(msg.tx.actions[0].name){
            case "transfer":
                {
                    // build the transfer action
                    const actType = new $e45745d0e423cacd$exports.EosActionTransfer();
                    actType.setSender($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].data.from).toString());
                    actType.setReceiver($3c1604a9db806af4$var$nameToNumber(msg.tx.actions[0].data.to).toString());
                    const actAsset = new $e45745d0e423cacd$exports.EosAsset();
                    const assetParse = $3c1604a9db806af4$var$assetToNumber(msg.tx.actions[0].data.quantity);
                    actAsset.setAmount(assetParse[0].toString());
                    actAsset.setSymbol(assetParse[1].toString());
                    actType.setQuantity(actAsset);
                    actType.setMemo(msg.tx.actions[0].data.memo);
                    actAck.setTransfer(actType);
                    break;
                }
        }
        console.debug("action data");
        console.debug(actAck);
        resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_EOSTXACTIONACK, actAck, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_EOSSIGNEDTX) throw new Error(`eos: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        // format signature for use in the eos system
        //    const EosFormatSig = eosSigFormatter(signedTx.getSignatureR() as Uint8Array, signedTx.getSignatureS() as Uint8Array, signedTx.getSignatureV())
        const signatureR = signedTx.getSignatureR_asU8();
        const signatureS = signedTx.getSignatureS_asU8();
        const signatureV = signedTx.getSignatureV();
        if (signatureV === undefined) throw new Error("missing signatureV");
        const sig = {
            signatureV: signatureV,
            signatureR: signatureR,
            signatureS: signatureS,
            hash: signedTx.getHash(),
            eosFormSig: $3c1604a9db806af4$var$eosSigFormatter(signatureR, signatureS, signatureV)
        };
        return sig;
    });
}



var $bE5P3 = parcelRequire("bE5P3");
var $d67a384a34381279$exports = {};
"use strict";
var $d67a384a34381279$var$__createBinding = $d67a384a34381279$exports && $d67a384a34381279$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d67a384a34381279$var$__exportStar = $d67a384a34381279$exports && $d67a384a34381279$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !exports1.hasOwnProperty(p)) $d67a384a34381279$var$__createBinding(exports1, m, p);
};
Object.defineProperty($d67a384a34381279$exports, "__esModule", {
    value: true
});
var $9646c67bd73cc859$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $9646c67bd73cc859$require$Buffer = $ihoyg.Buffer;
"use strict";
var $9646c67bd73cc859$var$__extends = $9646c67bd73cc859$exports && $9646c67bd73cc859$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $9646c67bd73cc859$var$__assign = $9646c67bd73cc859$exports && $9646c67bd73cc859$exports.__assign || function() {
    $9646c67bd73cc859$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9646c67bd73cc859$var$__assign.apply(this, arguments);
};
var $9646c67bd73cc859$var$__read = $9646c67bd73cc859$exports && $9646c67bd73cc859$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty($9646c67bd73cc859$exports, "__esModule", {
    value: true
});

var $eqs3F = parcelRequire("eqs3F");

var $6bHyf = parcelRequire("6bHyf");
var $f05db0d54fecd35a$exports = {};
"use strict";
var $f05db0d54fecd35a$var$__values = $f05db0d54fecd35a$exports && $f05db0d54fecd35a$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f05db0d54fecd35a$var$__read = $f05db0d54fecd35a$exports && $f05db0d54fecd35a$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f05db0d54fecd35a$var$__importDefault = $f05db0d54fecd35a$exports && $f05db0d54fecd35a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f05db0d54fecd35a$exports, "__esModule", {
    value: true
});
$f05db0d54fecd35a$exports.BaseTransaction = void 0;

var $f05db0d54fecd35a$var$common_1 = $f05db0d54fecd35a$var$__importDefault((parcelRequire("bE5P3")));

var $eqs3F = parcelRequire("eqs3F");

var $6bHyf = parcelRequire("6bHyf");
/**
 * This base class will likely be subject to further
 * refactoring along the introduction of additional tx types
 * on the Ethereum network.
 *
 * It is therefore not recommended to use directly.
 */ var $f05db0d54fecd35a$var$BaseTransaction = /** @class */ function() {
    function BaseTransaction(txData) {
        /**
         * List of tx type defining EIPs,
         * e.g. 1559 (fee market) and 2930 (access lists)
         * for FeeMarketEIP1559Transaction objects
         */ this.activeCapabilities = [];
        /**
         * The default chain the tx falls back to if no Common
         * is provided and if the chain can't be derived from
         * a passed in chainId (only EIP-2718 typed txs) or
         * EIP-155 signature (legacy txs).
         *
         * @hidden
         */ this.DEFAULT_CHAIN = "mainnet";
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ this.DEFAULT_HARDFORK = "istanbul";
        var nonce = txData.nonce, gasLimit = txData.gasLimit, to = txData.to, value = txData.value, data = txData.data, v = txData.v, r = txData.r, s = txData.s, type = txData.type;
        this._type = new $eqs3F.BN($eqs3F.toBuffer(type)).toNumber();
        var toB = $eqs3F.toBuffer(to === "" ? "0x" : to);
        var vB = $eqs3F.toBuffer(v === "" ? "0x" : v);
        var rB = $eqs3F.toBuffer(r === "" ? "0x" : r);
        var sB = $eqs3F.toBuffer(s === "" ? "0x" : s);
        this.nonce = new $eqs3F.BN($eqs3F.toBuffer(nonce === "" ? "0x" : nonce));
        this.gasLimit = new $eqs3F.BN($eqs3F.toBuffer(gasLimit === "" ? "0x" : gasLimit));
        this.to = toB.length > 0 ? new $eqs3F.Address(toB) : undefined;
        this.value = new $eqs3F.BN($eqs3F.toBuffer(value === "" ? "0x" : value));
        this.data = $eqs3F.toBuffer(data === "" ? "0x" : data);
        this.v = vB.length > 0 ? new $eqs3F.BN(vB) : undefined;
        this.r = rB.length > 0 ? new $eqs3F.BN(rB) : undefined;
        this.s = sB.length > 0 ? new $eqs3F.BN(sB) : undefined;
        this._validateCannotExceedMaxInteger({
            nonce: this.nonce,
            gasLimit: this.gasLimit,
            value: this.value,
            r: this.r,
            s: this.s
        });
    }
    Object.defineProperty(BaseTransaction.prototype, "transactionType", {
        /**
         * Alias for {@link BaseTransaction.type}
         *
         * @deprecated Use `type` instead
         */ get: function() {
            return this.type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BaseTransaction.prototype, "type", {
        /**
         * Returns the transaction type.
         *
         * Note: legacy txs will return tx type `0`.
         */ get: function() {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Checks if a tx type defining capability is active
     * on a tx, for example the EIP-1559 fee market mechanism
     * or the EIP-2930 access list feature.
     *
     * Note that this is different from the tx type itself,
     * so EIP-2930 access lists can very well be active
     * on an EIP-1559 tx for example.
     *
     * This method can be useful for feature checks if the
     * tx type is unknown (e.g. when instantiated with
     * the tx factory).
     *
     * See `Capabilites` in the `types` module for a reference
     * on all supported capabilities.
     */ BaseTransaction.prototype.supports = function(capability) {
        return this.activeCapabilities.includes(capability);
    };
    BaseTransaction.prototype.validate = function(stringError) {
        if (stringError === void 0) stringError = false;
        var errors = [];
        if (this.getBaseFee().gt(this.gasLimit)) errors.push("gasLimit is too low. given " + this.gasLimit + ", need at least " + this.getBaseFee());
        if (this.isSigned() && !this.verifySignature()) errors.push("Invalid Signature");
        return stringError ? errors : errors.length === 0;
    };
    /**
     * The minimum amount of gas the tx must have (DataFee + TxFee + Creation Fee)
     */ BaseTransaction.prototype.getBaseFee = function() {
        var fee = this.getDataFee().addn(this.common.param("gasPrices", "tx"));
        if (this.common.gteHardfork("homestead") && this.toCreationAddress()) fee.iaddn(this.common.param("gasPrices", "txCreation"));
        return fee;
    };
    /**
     * The amount of gas paid for the data in this tx
     */ BaseTransaction.prototype.getDataFee = function() {
        var txDataZero = this.common.param("gasPrices", "txDataZero");
        var txDataNonZero = this.common.param("gasPrices", "txDataNonZero");
        var cost = 0;
        for(var i = 0; i < this.data.length; i++)this.data[i] === 0 ? cost += txDataZero : cost += txDataNonZero;
        return new $eqs3F.BN(cost);
    };
    /**
     * If the tx's `to` is to the creation address
     */ BaseTransaction.prototype.toCreationAddress = function() {
        return this.to === undefined || this.to.buf.length === 0;
    };
    BaseTransaction.prototype.isSigned = function() {
        var _a = this, v = _a.v, r = _a.r, s = _a.s;
        if (this.type === 0) {
            if (!v || !r || !s) return false;
            else return true;
        } else {
            if (v === undefined || !r || !s) return false;
            else return true;
        }
    };
    /**
     * Determines if the signature is valid
     */ BaseTransaction.prototype.verifySignature = function() {
        try {
            // Main signature verification is done in `getSenderPublicKey()`
            var publicKey = this.getSenderPublicKey();
            return $eqs3F.unpadBuffer(publicKey).length !== 0;
        } catch (e) {
            return false;
        }
    };
    /**
     * Returns the sender's address
     */ BaseTransaction.prototype.getSenderAddress = function() {
        return new $eqs3F.Address($eqs3F.publicToAddress(this.getSenderPublicKey()));
    };
    /**
     * Signs a transaction.
     *
     * Note that the signed tx is returned as a new object,
     * use as follows:
     * ```javascript
     * const signedTx = tx.sign(privateKey)
     * ```
     */ BaseTransaction.prototype.sign = function(privateKey) {
        if (privateKey.length !== 32) throw new Error("Private key must be 32 bytes in length.");
        // Hack for the constellation that we have got a legacy tx after spuriousDragon with a non-EIP155 conforming signature
        // and want to recreate a signature (where EIP155 should be applied)
        // Leaving this hack lets the legacy.spec.ts -> sign(), verifySignature() test fail
        // 2021-06-23
        var hackApplied = false;
        if (this.type === 0 && this.common.gteHardfork("spuriousDragon") && !this.supports($6bHyf.Capability.EIP155ReplayProtection)) {
            this.activeCapabilities.push($6bHyf.Capability.EIP155ReplayProtection);
            hackApplied = true;
        }
        var msgHash = this.getMessageToSign(true);
        var _a = $eqs3F.ecsign(msgHash, privateKey), v = _a.v, r = _a.r, s = _a.s;
        var tx = this._processSignature(v, r, s);
        // Hack part 2
        if (hackApplied) {
            var index = this.activeCapabilities.indexOf($6bHyf.Capability.EIP155ReplayProtection);
            if (index > -1) this.activeCapabilities.splice(index, 1);
        }
        return tx;
    };
    /**
     * Does chain ID checks on common and returns a common
     * to be used on instantiation
     * @hidden
     *
     * @param common - {@link Common} instance from tx options
     * @param chainId - Chain ID from tx options (typed txs) or signature (legacy tx)
     */ BaseTransaction.prototype._getCommon = function(common, chainId) {
        var _a;
        // Chain ID provided
        if (chainId) {
            var chainIdBN = new $eqs3F.BN($eqs3F.toBuffer(chainId));
            if (common) {
                if (!common.chainIdBN().eq(chainIdBN)) throw new Error("The chain ID does not match the chain ID of Common");
                // Common provided, chain ID does match
                // -> Return provided Common
                return common.copy();
            } else {
                if ($f05db0d54fecd35a$var$common_1.default.isSupportedChainId(chainIdBN)) // No Common, chain ID supported by Common
                // -> Instantiate Common with chain ID
                return new $f05db0d54fecd35a$var$common_1.default({
                    chain: chainIdBN,
                    hardfork: this.DEFAULT_HARDFORK
                });
                else // No Common, chain ID not supported by Common
                // -> Instantiate custom Common derived from DEFAULT_CHAIN
                return $f05db0d54fecd35a$var$common_1.default.forCustomChain(this.DEFAULT_CHAIN, {
                    name: "custom-chain",
                    networkId: chainIdBN,
                    chainId: chainIdBN
                }, this.DEFAULT_HARDFORK);
            }
        } else // No chain ID provided
        // -> return Common provided or create new default Common
        return (_a = common === null || common === void 0 ? void 0 : common.copy()) !== null && _a !== void 0 ? _a : new $f05db0d54fecd35a$var$common_1.default({
            chain: this.DEFAULT_CHAIN,
            hardfork: this.DEFAULT_HARDFORK
        });
    };
    BaseTransaction.prototype._validateCannotExceedMaxInteger = function(values, bits) {
        var e_1, _a;
        if (bits === void 0) bits = 53;
        try {
            for(var _b = $f05db0d54fecd35a$var$__values(Object.entries(values)), _c = _b.next(); !_c.done; _c = _b.next()){
                var _d = $f05db0d54fecd35a$var$__read(_c.value, 2), key = _d[0], value = _d[1];
                if (bits === 53) {
                    if (value === null || value === void 0 ? void 0 : value.gt($eqs3F.MAX_INTEGER)) throw new Error(key + " cannot exceed MAX_INTEGER, given " + value);
                } else if (bits === 256) {
                    if (value === null || value === void 0 ? void 0 : value.gte($eqs3F.TWO_POW256)) throw new Error(key + " must be less than 2^256, given " + value);
                } else throw new Error("unimplemented bits value");
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
    };
    return BaseTransaction;
}();
$f05db0d54fecd35a$exports.BaseTransaction = $f05db0d54fecd35a$var$BaseTransaction;


var $9646c67bd73cc859$var$TRANSACTION_TYPE = 0;
/**
 * An Ethereum non-typed (legacy) transaction
 */ var $9646c67bd73cc859$var$Transaction = /** @class */ function(_super) {
    $9646c67bd73cc859$var$__extends(Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a;
        var _this = _super.call(this, $9646c67bd73cc859$var$__assign($9646c67bd73cc859$var$__assign({}, txData), {
            type: $9646c67bd73cc859$var$TRANSACTION_TYPE
        })) || this;
        _this.common = _this._validateTxV(_this.v, opts.common);
        _this.gasPrice = new $eqs3F.BN($eqs3F.toBuffer(txData.gasPrice === "" ? "0x" : txData.gasPrice));
        _this._validateCannotExceedMaxInteger({
            gasPrice: _this.gasPrice
        });
        if (_this.common.gteHardfork("spuriousDragon")) {
            if (!_this.isSigned()) _this.activeCapabilities.push($6bHyf.Capability.EIP155ReplayProtection);
            else {
                // EIP155 spec:
                // If block.number >= 2,675,000 and v = CHAIN_ID * 2 + 35 or v = CHAIN_ID * 2 + 36
                // then when computing the hash of a transaction for purposes of signing or recovering
                // instead of hashing only the first six elements (i.e. nonce, gasprice, startgas, to, value, data)
                // hash nine elements, with v replaced by CHAIN_ID, r = 0 and s = 0.
                var v = _this.v;
                var chainIdDoubled = _this.common.chainIdBN().muln(2);
                // v and chain ID meet EIP-155 conditions
                if (v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36))) _this.activeCapabilities.push($6bHyf.Capability.EIP155ReplayProtection);
            }
        }
        var freeze = (_a = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _a !== void 0 ? _a : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { nonce, gasPrice, gasLimit, to, value, data, v, r, s }
     *
     * Notes:
     * - All parameters are optional and have some basic default values
     */ Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     */ Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        var values = $eqs3F.rlp.decode(serialized);
        if (!Array.isArray(values)) throw new Error("Invalid serialized tx input. Must be array");
        return this.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link Transaction.fromSerializedTx})
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link Transaction.fromSerializedTx} constructor
     */ Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     */ Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        // If length is not 6, it has length 9. If v/r/s are empty Buffers, it is still an unsigned transaction
        // This happens if you get the RLP data from `raw()`
        if (values.length !== 6 && values.length !== 9) throw new Error("Invalid transaction. Only expecting 6 values (for unsigned tx) or 9 values (for signed tx).");
        var _a = $9646c67bd73cc859$var$__read(values, 9), nonce = _a[0], gasPrice = _a[1], gasLimit = _a[2], to = _a[3], value = _a[4], data = _a[5], v = _a[6], r = _a[7], s = _a[8];
        return new Transaction({
            nonce: nonce,
            gasPrice: gasPrice,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            v: v,
            r: r,
            s: s
        }, opts);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the legacy transaction, in order.
     *
     * Format: `[nonce, gasPrice, gasLimit, to, value, data, v, r, s]`
     *
     * For an unsigned legacy tx this method returns the the empty Buffer values
     * for the signature parameters `v`, `r` and `s`. For an EIP-155 compliant
     * representation have a look at {@link Transaction.getMessageToSign}.
     */ Transaction.prototype.raw = function() {
        return [
            $eqs3F.bnToUnpaddedBuffer(this.nonce),
            $eqs3F.bnToUnpaddedBuffer(this.gasPrice),
            $eqs3F.bnToUnpaddedBuffer(this.gasLimit),
            this.to !== undefined ? this.to.buf : $9646c67bd73cc859$require$Buffer.from([]),
            $eqs3F.bnToUnpaddedBuffer(this.value),
            this.data,
            this.v !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.v) : $9646c67bd73cc859$require$Buffer.from([]),
            this.r !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.r) : $9646c67bd73cc859$require$Buffer.from([]),
            this.s !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.s) : $9646c67bd73cc859$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the legacy transaction.
     *
     * Format: `rlp([nonce, gasPrice, gasLimit, to, value, data, v, r, s])`
     *
     * For an unsigned legacy tx this method uses the empty Buffer values
     * for the signature parameters `v`, `r` and `s` for encoding. For an
     * EIP-155 compliant representation use {@link Transaction.getMessageToSign}.
     */ Transaction.prototype.serialize = function() {
        return $eqs3F.rlp.encode(this.raw());
    };
    Transaction.prototype._getMessageToSign = function() {
        var values = [
            $eqs3F.bnToUnpaddedBuffer(this.nonce),
            $eqs3F.bnToUnpaddedBuffer(this.gasPrice),
            $eqs3F.bnToUnpaddedBuffer(this.gasLimit),
            this.to !== undefined ? this.to.buf : $9646c67bd73cc859$require$Buffer.from([]),
            $eqs3F.bnToUnpaddedBuffer(this.value),
            this.data
        ];
        if (this.supports($6bHyf.Capability.EIP155ReplayProtection)) {
            values.push($eqs3F.toBuffer(this.common.chainIdBN()));
            values.push($eqs3F.unpadBuffer($eqs3F.toBuffer(0)));
            values.push($eqs3F.unpadBuffer($eqs3F.toBuffer(0)));
        }
        return values;
    };
    Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var message = this._getMessageToSign();
        if (hashMessage) return $eqs3F.rlphash(message);
        else return message;
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     */ Transaction.prototype.getUpfrontCost = function() {
        return this.gasLimit.mul(this.gasPrice).add(this.value);
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ Transaction.prototype.hash = function() {
        return $eqs3F.rlphash(this.raw());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ Transaction.prototype.getMessageToVerifySignature = function() {
        if (!this.isSigned()) throw Error("This transaction is not signed");
        var message = this._getMessageToSign();
        return $eqs3F.rlphash(message);
    };
    /**
     * Returns the public key of the sender
     */ Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork("homestead") && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($6bHyf.N_DIV_2))) throw new Error("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        var _b = this, v = _b.v, r = _b.r, s = _b.s;
        try {
            return $eqs3F.ecrecover(msgHash, v, $eqs3F.bnToUnpaddedBuffer(r), $eqs3F.bnToUnpaddedBuffer(s), this.supports($6bHyf.Capability.EIP155ReplayProtection) ? this.common.chainIdBN() : undefined);
        } catch (e) {
            throw new Error("Invalid Signature");
        }
    };
    /**
     * Process the v, r, s values from the `sign` method of the base transaction.
     */ Transaction.prototype._processSignature = function(v, r, s) {
        var vBN = new $eqs3F.BN(v);
        if (this.supports($6bHyf.Capability.EIP155ReplayProtection)) vBN.iadd(this.common.chainIdBN().muln(2).addn(8));
        var opts = {
            common: this.common
        };
        return Transaction.fromTxData({
            nonce: this.nonce,
            gasPrice: this.gasPrice,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            v: vBN,
            r: new $eqs3F.BN(r),
            s: new $eqs3F.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction.
     */ Transaction.prototype.toJSON = function() {
        return {
            nonce: $eqs3F.bnToHex(this.nonce),
            gasPrice: $eqs3F.bnToHex(this.gasPrice),
            gasLimit: $eqs3F.bnToHex(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: $eqs3F.bnToHex(this.value),
            data: "0x" + this.data.toString("hex"),
            v: this.v !== undefined ? $eqs3F.bnToHex(this.v) : undefined,
            r: this.r !== undefined ? $eqs3F.bnToHex(this.r) : undefined,
            s: this.s !== undefined ? $eqs3F.bnToHex(this.s) : undefined
        };
    };
    /**
     * Validates tx's `v` value
     */ Transaction.prototype._validateTxV = function(v, common) {
        var chainIdBN;
        // No unsigned tx and EIP-155 activated and chain ID included
        if (v !== undefined && !v.eqn(0) && (!common || common.gteHardfork("spuriousDragon")) && !v.eqn(27) && !v.eqn(28)) {
            if (common) {
                var chainIdDoubled = common.chainIdBN().muln(2);
                var isValidEIP155V = v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36));
                if (!isValidEIP155V) throw new Error("Incompatible EIP155-based V " + v.toString() + " and chain id " + common.chainIdBN().toString() + ". See the Common parameter of the Transaction constructor to set the chain id.");
            } else {
                // Derive the original chain ID
                var numSub = void 0;
                if (v.subn(35).isEven()) numSub = 35;
                else numSub = 36;
                // Use derived chain ID to create a proper Common
                chainIdBN = v.subn(numSub).divn(2);
            }
        }
        return this._getCommon(common, chainIdBN);
    };
    /**
     * @deprecated if you have called this internal method please use `tx.supports(Capabilities.EIP155ReplayProtection)` instead
     */ Transaction.prototype._unsignedTxImplementsEIP155 = function() {
        return this.common.gteHardfork("spuriousDragon");
    };
    /**
     * @deprecated if you have called this internal method please use `tx.supports(Capabilities.EIP155ReplayProtection)` instead
     */ Transaction.prototype._signedTxImplementsEIP155 = function() {
        if (!this.isSigned()) throw Error("This transaction is not signed");
        var onEIP155BlockOrLater = this.common.gteHardfork("spuriousDragon");
        // EIP155 spec:
        // If block.number >= 2,675,000 and v = CHAIN_ID * 2 + 35 or v = CHAIN_ID * 2 + 36, then when computing the hash of a transaction for purposes of signing or recovering, instead of hashing only the first six elements (i.e. nonce, gasprice, startgas, to, value, data), hash nine elements, with v replaced by CHAIN_ID, r = 0 and s = 0.
        var v = this.v;
        var chainIdDoubled = this.common.chainIdBN().muln(2);
        var vAndChainIdMeetEIP155Conditions = v.eq(chainIdDoubled.addn(35)) || v.eq(chainIdDoubled.addn(36));
        return vAndChainIdMeetEIP155Conditions && onEIP155BlockOrLater;
    };
    return Transaction;
}($f05db0d54fecd35a$exports.BaseTransaction);
$9646c67bd73cc859$exports.default = $9646c67bd73cc859$var$Transaction;


Object.defineProperty($d67a384a34381279$exports, "Transaction", {
    enumerable: true,
    get: function() {
        return $9646c67bd73cc859$exports.default;
    }
});
var $bfe19d6b462ef508$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $bfe19d6b462ef508$require$Buffer = $ihoyg.Buffer;
"use strict";
var $bfe19d6b462ef508$var$__extends = $bfe19d6b462ef508$exports && $bfe19d6b462ef508$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $bfe19d6b462ef508$var$__assign = $bfe19d6b462ef508$exports && $bfe19d6b462ef508$exports.__assign || function() {
    $bfe19d6b462ef508$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $bfe19d6b462ef508$var$__assign.apply(this, arguments);
};
var $bfe19d6b462ef508$var$__read = $bfe19d6b462ef508$exports && $bfe19d6b462ef508$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty($bfe19d6b462ef508$exports, "__esModule", {
    value: true
});

var $eqs3F = parcelRequire("eqs3F");


var $6bHyf = parcelRequire("6bHyf");
var $fde297469f1d875c$exports = {};
"use strict";
Object.defineProperty($fde297469f1d875c$exports, "__esModule", {
    value: true
});
$fde297469f1d875c$exports.AccessLists = void 0;

var $eqs3F = parcelRequire("eqs3F");

var $6bHyf = parcelRequire("6bHyf");
var $fde297469f1d875c$var$AccessLists = /** @class */ function() {
    function AccessLists() {}
    AccessLists.getAccessListData = function(accessList) {
        var AccessListJSON;
        var bufferAccessList;
        if (accessList && $6bHyf.isAccessList(accessList)) {
            AccessListJSON = accessList;
            var newAccessList = [];
            for(var i = 0; i < accessList.length; i++){
                var item = accessList[i];
                var addressBuffer = $eqs3F.toBuffer(item.address);
                var storageItems = [];
                for(var index = 0; index < item.storageKeys.length; index++)storageItems.push($eqs3F.toBuffer(item.storageKeys[index]));
                newAccessList.push([
                    addressBuffer,
                    storageItems
                ]);
            }
            bufferAccessList = newAccessList;
        } else {
            bufferAccessList = accessList !== null && accessList !== void 0 ? accessList : [];
            // build the JSON
            var json = [];
            for(var i = 0; i < bufferAccessList.length; i++){
                var data = bufferAccessList[i];
                var address = $eqs3F.bufferToHex(data[0]);
                var storageKeys = [];
                for(var item = 0; item < data[1].length; item++)storageKeys.push($eqs3F.bufferToHex(data[1][item]));
                var jsonItem = {
                    address: address,
                    storageKeys: storageKeys
                };
                json.push(jsonItem);
            }
            AccessListJSON = json;
        }
        return {
            AccessListJSON: AccessListJSON,
            accessList: bufferAccessList
        };
    };
    AccessLists.verifyAccessList = function(accessList) {
        for(var key = 0; key < accessList.length; key++){
            var accessListItem = accessList[key];
            var address = accessListItem[0];
            var storageSlots = accessListItem[1];
            if (accessListItem[2] !== undefined) throw new Error("Access list item cannot have 3 elements. It can only have an address, and an array of storage slots.");
            if (address.length != 20) throw new Error("Invalid EIP-2930 transaction: address length should be 20 bytes");
            for(var storageSlot = 0; storageSlot < storageSlots.length; storageSlot++){
                if (storageSlots[storageSlot].length != 32) throw new Error("Invalid EIP-2930 transaction: storage slot length should be 32 bytes");
            }
        }
    };
    AccessLists.getAccessListJSON = function(accessList) {
        var accessListJSON = [];
        for(var index = 0; index < accessList.length; index++){
            var item = accessList[index];
            var JSONItem = {
                address: "0x" + $eqs3F.setLengthLeft(item[0], 20).toString("hex"),
                storageKeys: []
            };
            var storageSlots = item[1];
            for(var slot = 0; slot < storageSlots.length; slot++){
                var storageSlot = storageSlots[slot];
                JSONItem.storageKeys.push("0x" + $eqs3F.setLengthLeft(storageSlot, 32).toString("hex"));
            }
            accessListJSON.push(JSONItem);
        }
        return accessListJSON;
    };
    AccessLists.getDataFeeEIP2930 = function(accessList, common) {
        var accessListStorageKeyCost = common.param("gasPrices", "accessListStorageKeyCost");
        var accessListAddressCost = common.param("gasPrices", "accessListAddressCost");
        var slots = 0;
        for(var index = 0; index < accessList.length; index++){
            var item = accessList[index];
            var storageSlots = item[1];
            slots += storageSlots.length;
        }
        var addresses = accessList.length;
        return addresses * accessListAddressCost + slots * accessListStorageKeyCost;
    };
    return AccessLists;
}();
$fde297469f1d875c$exports.AccessLists = $fde297469f1d875c$var$AccessLists;


var $bfe19d6b462ef508$var$TRANSACTION_TYPE = 1;
var $bfe19d6b462ef508$var$TRANSACTION_TYPE_BUFFER = $bfe19d6b462ef508$require$Buffer.from($bfe19d6b462ef508$var$TRANSACTION_TYPE.toString(16).padStart(2, "0"), "hex");
/**
 * Typed transaction with optional access lists
 *
 * - TransactionType: 1
 * - EIP: [EIP-2930](https://eips.ethereum.org/EIPS/eip-2930)
 */ var $bfe19d6b462ef508$var$AccessListEIP2930Transaction = /** @class */ function(_super) {
    $bfe19d6b462ef508$var$__extends(AccessListEIP2930Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function AccessListEIP2930Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a, _b;
        var _this = _super.call(this, $bfe19d6b462ef508$var$__assign($bfe19d6b462ef508$var$__assign({}, txData), {
            type: $bfe19d6b462ef508$var$TRANSACTION_TYPE
        })) || this;
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ _this.DEFAULT_HARDFORK = "berlin";
        var chainId = txData.chainId, accessList = txData.accessList, gasPrice = txData.gasPrice;
        _this.common = _this._getCommon(opts.common, chainId);
        _this.chainId = _this.common.chainIdBN();
        // EIP-2718 check is done in Common
        if (!_this.common.isActivatedEIP(2930)) throw new Error("EIP-2930 not enabled on Common");
        _this.activeCapabilities = _this.activeCapabilities.concat([
            2718,
            2930
        ]);
        // Populate the access list fields
        var accessListData = $fde297469f1d875c$exports.AccessLists.getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
        _this.accessList = accessListData.accessList;
        _this.AccessListJSON = accessListData.AccessListJSON;
        // Verify the access list format.
        $fde297469f1d875c$exports.AccessLists.verifyAccessList(_this.accessList);
        _this.gasPrice = new $eqs3F.BN($eqs3F.toBuffer(gasPrice === "" ? "0x" : gasPrice));
        _this._validateCannotExceedMaxInteger({
            gasPrice: _this.gasPrice
        });
        if (_this.v && !_this.v.eqn(0) && !_this.v.eqn(1)) throw new Error("The y-parity of the transaction should either be 0 or 1");
        if (_this.common.gteHardfork("homestead") && ((_a = _this.s) === null || _a === void 0 ? void 0 : _a.gt($6bHyf.N_DIV_2))) throw new Error("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        var freeze = (_b = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _b !== void 0 ? _b : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "senderR", {
        /**
         * EIP-2930 alias for `r`
         *
         * @deprecated use `r` instead
         */ get: function() {
            return this.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "senderS", {
        /**
         * EIP-2930 alias for `s`
         *
         * @deprecated use `s` instead
         */ get: function() {
            return this.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AccessListEIP2930Transaction.prototype, "yParity", {
        /**
         * EIP-2930 alias for `v`
         *
         * @deprecated use `v` instead
         */ get: function() {
            return this.v;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */ AccessListEIP2930Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new AccessListEIP2930Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     */ AccessListEIP2930Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        if (!serialized.slice(0, 1).equals($bfe19d6b462ef508$var$TRANSACTION_TYPE_BUFFER)) throw new Error("Invalid serialized tx input: not an EIP-2930 transaction (wrong tx type, expected: " + $bfe19d6b462ef508$var$TRANSACTION_TYPE + ", received: " + serialized.slice(0, 1).toString("hex"));
        var values = $eqs3F.rlp.decode(serialized.slice(1));
        if (!Array.isArray(values)) throw new Error("Invalid serialized tx input: must be array");
        return AccessListEIP2930Transaction.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link AccessListEIP2930Transaction.fromSerializedTx})
     *
     * Note: This means that the Buffer should start with 0x01.
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link AccessListEIP2930Transaction.fromSerializedTx} constructor
     */ AccessListEIP2930Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return AccessListEIP2930Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     */ AccessListEIP2930Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        if (values.length !== 8 && values.length !== 11) throw new Error("Invalid EIP-2930 transaction. Only expecting 8 values (for unsigned tx) or 11 values (for signed tx).");
        var _a = $bfe19d6b462ef508$var$__read(values, 11), chainId = _a[0], nonce = _a[1], gasPrice = _a[2], gasLimit = _a[3], to = _a[4], value = _a[5], data = _a[6], accessList = _a[7], v = _a[8], r = _a[9], s = _a[10];
        var emptyAccessList = [];
        return new AccessListEIP2930Transaction({
            chainId: new $eqs3F.BN(chainId),
            nonce: nonce,
            gasPrice: gasPrice,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            accessList: accessList !== null && accessList !== void 0 ? accessList : emptyAccessList,
            v: v !== undefined ? new $eqs3F.BN(v) : undefined,
            r: r,
            s: s
        }, opts);
    };
    /**
     * The amount of gas paid for the data in this tx
     */ AccessListEIP2930Transaction.prototype.getDataFee = function() {
        var cost = _super.prototype.getDataFee.call(this);
        cost.iaddn($fde297469f1d875c$exports.AccessLists.getDataFeeEIP2930(this.accessList, this.common));
        return cost;
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     */ AccessListEIP2930Transaction.prototype.getUpfrontCost = function() {
        return this.gasLimit.mul(this.gasPrice).add(this.value);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the EIP-2930 transaction, in order.
     *
     * Format: `[chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)]`
     *
     * Use {@link AccessListEIP2930Transaction.serialize} to add to block data for {@link Block.fromValuesArray}.
     */ AccessListEIP2930Transaction.prototype.raw = function() {
        return [
            $eqs3F.bnToUnpaddedBuffer(this.chainId),
            $eqs3F.bnToUnpaddedBuffer(this.nonce),
            $eqs3F.bnToUnpaddedBuffer(this.gasPrice),
            $eqs3F.bnToUnpaddedBuffer(this.gasLimit),
            this.to !== undefined ? this.to.buf : $bfe19d6b462ef508$require$Buffer.from([]),
            $eqs3F.bnToUnpaddedBuffer(this.value),
            this.data,
            this.accessList,
            this.v !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.v) : $bfe19d6b462ef508$require$Buffer.from([]),
            this.r !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.r) : $bfe19d6b462ef508$require$Buffer.from([]),
            this.s !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.s) : $bfe19d6b462ef508$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the EIP-2930 transaction.
     *
     * Format: `0x01 || rlp([chainId, nonce, gasPrice, gasLimit, to, value, data, accessList,
     * signatureYParity (v), signatureR (r), signatureS (s)])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceeding and concatenated to
     * the RLP encoding of the values.
     */ AccessListEIP2930Transaction.prototype.serialize = function() {
        var base = this.raw();
        return $bfe19d6b462ef508$require$Buffer.concat([
            $bfe19d6b462ef508$var$TRANSACTION_TYPE_BUFFER,
            $eqs3F.rlp.encode(base)
        ]);
    };
    /**
     * Returns the serialized unsigned tx (hashed or raw), which can be used
     * to sign the transaction (e.g. for sending to a hardware wallet).
     *
     * Note: in contrast to the legacy tx the raw message format is already
     * serialized and doesn't need to be RLP encoded any more.
     *
     * ```javascript
     * const serializedMessage = tx.getMessageToSign(false) // use this for the HW wallet input
     * ```
     *
     * @param hashMessage - Return hashed message if set to true (default: true)
     */ AccessListEIP2930Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var base = this.raw().slice(0, 8);
        var message = $bfe19d6b462ef508$require$Buffer.concat([
            $bfe19d6b462ef508$var$TRANSACTION_TYPE_BUFFER,
            $eqs3F.rlp.encode(base)
        ]);
        if (hashMessage) return $eqs3F.keccak256(message);
        else return message;
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link AccessListEIP2930Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ AccessListEIP2930Transaction.prototype.hash = function() {
        if (!this.isSigned()) throw new Error("Cannot call hash method if transaction is not signed");
        return $eqs3F.keccak256(this.serialize());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ AccessListEIP2930Transaction.prototype.getMessageToVerifySignature = function() {
        return this.getMessageToSign();
    };
    /**
     * Returns the public key of the sender
     */ AccessListEIP2930Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        if (!this.isSigned()) throw new Error("Cannot call this method if transaction is not signed");
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork("homestead") && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($6bHyf.N_DIV_2))) throw new Error("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        var _b = this, yParity = _b.yParity, r = _b.r, s = _b.s;
        try {
            return $eqs3F.ecrecover(msgHash, yParity.addn(27), $eqs3F.bnToUnpaddedBuffer(r), $eqs3F.bnToUnpaddedBuffer(s));
        } catch (e) {
            throw new Error("Invalid Signature");
        }
    };
    AccessListEIP2930Transaction.prototype._processSignature = function(v, r, s) {
        var opts = {
            common: this.common
        };
        return AccessListEIP2930Transaction.fromTxData({
            chainId: this.chainId,
            nonce: this.nonce,
            gasPrice: this.gasPrice,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            accessList: this.accessList,
            v: new $eqs3F.BN(v - 27),
            r: new $eqs3F.BN(r),
            s: new $eqs3F.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction
     */ AccessListEIP2930Transaction.prototype.toJSON = function() {
        var accessListJSON = $fde297469f1d875c$exports.AccessLists.getAccessListJSON(this.accessList);
        return {
            chainId: $eqs3F.bnToHex(this.chainId),
            nonce: $eqs3F.bnToHex(this.nonce),
            gasPrice: $eqs3F.bnToHex(this.gasPrice),
            gasLimit: $eqs3F.bnToHex(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: $eqs3F.bnToHex(this.value),
            data: "0x" + this.data.toString("hex"),
            accessList: accessListJSON,
            v: this.v !== undefined ? $eqs3F.bnToHex(this.v) : undefined,
            r: this.r !== undefined ? $eqs3F.bnToHex(this.r) : undefined,
            s: this.s !== undefined ? $eqs3F.bnToHex(this.s) : undefined
        };
    };
    return AccessListEIP2930Transaction;
}($f05db0d54fecd35a$exports.BaseTransaction);
$bfe19d6b462ef508$exports.default = $bfe19d6b462ef508$var$AccessListEIP2930Transaction;


Object.defineProperty($d67a384a34381279$exports, "AccessListEIP2930Transaction", {
    enumerable: true,
    get: function() {
        return $bfe19d6b462ef508$exports.default;
    }
});
var $8aa5316bc8bad869$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $8aa5316bc8bad869$require$Buffer = $ihoyg.Buffer;
"use strict";
Object.defineProperty($8aa5316bc8bad869$exports, "__esModule", {
    value: true
});

var $eqs3F = parcelRequire("eqs3F");

var $8aa5316bc8bad869$var$TransactionFactory = /** @class */ function() {
    // It is not possible to instantiate a TransactionFactory object.
    function TransactionFactory() {}
    /**
     * Create a transaction from a `txData` object
     *
     * @param txData - The transaction data. The `type` field will determine which transaction type is returned (if undefined, creates a legacy transaction)
     * @param txOptions - Options to pass on to the constructor of the transaction
     */ TransactionFactory.fromTxData = function(txData, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if (!("type" in txData) || txData.type === undefined) // Assume legacy transaction
        return $d67a384a34381279$exports.Transaction.fromTxData(txData, txOptions);
        else {
            var txType = new $eqs3F.BN($eqs3F.toBuffer(txData.type)).toNumber();
            if (txType === 0) return $d67a384a34381279$exports.Transaction.fromTxData(txData, txOptions);
            else if (txType === 1) return $d67a384a34381279$exports.AccessListEIP2930Transaction.fromTxData(txData, txOptions);
            else if (txType === 2) return $d67a384a34381279$exports.FeeMarketEIP1559Transaction.fromTxData(txData, txOptions);
            else throw new Error("Tx instantiation with type " + txType + " not supported");
        }
    };
    /**
     * This method tries to decode serialized data.
     *
     * @param data - The data Buffer
     * @param txOptions - The transaction options
     */ TransactionFactory.fromSerializedData = function(data, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if (data[0] <= 0x7f) {
            // Determine the type.
            var EIP = void 0;
            switch(data[0]){
                case 1:
                    EIP = 2930;
                    break;
                case 2:
                    EIP = 1559;
                    break;
                default:
                    throw new Error("TypedTransaction with ID " + data[0] + " unknown");
            }
            if (EIP === 1559) return $d67a384a34381279$exports.FeeMarketEIP1559Transaction.fromSerializedTx(data, txOptions);
            else // EIP === 2930
            return $d67a384a34381279$exports.AccessListEIP2930Transaction.fromSerializedTx(data, txOptions);
        } else return $d67a384a34381279$exports.Transaction.fromSerializedTx(data, txOptions);
    };
    /**
     * When decoding a BlockBody, in the transactions field, a field is either:
     * A Buffer (a TypedTransaction - encoded as TransactionType || rlp(TransactionPayload))
     * A Buffer[] (Legacy Transaction)
     * This method returns the right transaction.
     *
     * @param data - A Buffer or Buffer[]
     * @param txOptions - The transaction options
     */ TransactionFactory.fromBlockBodyData = function(data, txOptions) {
        if (txOptions === void 0) txOptions = {};
        if ($8aa5316bc8bad869$require$Buffer.isBuffer(data)) return this.fromSerializedData(data, txOptions);
        else if (Array.isArray(data)) // It is a legacy transaction
        return $d67a384a34381279$exports.Transaction.fromValuesArray(data, txOptions);
        else throw new Error("Cannot decode transaction: unknown type input");
    };
    /**
     * This helper method allows one to retrieve the class which matches the transactionID
     * If transactionID is undefined, returns the legacy transaction class.
     * @deprecated - This method is deprecated and will be removed on the next major release
     * @param transactionID
     * @param common - This option is not used
     */ // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
    TransactionFactory.getTransactionClass = function(transactionID, common) {
        if (transactionID === void 0) transactionID = 0;
        var legacyTxn = transactionID == 0 || transactionID >= 0x80 && transactionID <= 0xff;
        if (legacyTxn) return $d67a384a34381279$exports.Transaction;
        switch(transactionID){
            case 1:
                return $d67a384a34381279$exports.AccessListEIP2930Transaction;
            case 2:
                return $d67a384a34381279$exports.FeeMarketEIP1559Transaction;
            default:
                throw new Error("TypedTransaction with ID " + transactionID + " unknown");
        }
    };
    return TransactionFactory;
}();
$8aa5316bc8bad869$exports.default = $8aa5316bc8bad869$var$TransactionFactory;


Object.defineProperty($d67a384a34381279$exports, "TransactionFactory", {
    enumerable: true,
    get: function() {
        return $8aa5316bc8bad869$exports.default;
    }
});
var $355b48b85dbd80aa$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $355b48b85dbd80aa$require$Buffer = $ihoyg.Buffer;
"use strict";
var $355b48b85dbd80aa$var$__extends = $355b48b85dbd80aa$exports && $355b48b85dbd80aa$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $355b48b85dbd80aa$var$__assign = $355b48b85dbd80aa$exports && $355b48b85dbd80aa$exports.__assign || function() {
    $355b48b85dbd80aa$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $355b48b85dbd80aa$var$__assign.apply(this, arguments);
};
var $355b48b85dbd80aa$var$__read = $355b48b85dbd80aa$exports && $355b48b85dbd80aa$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty($355b48b85dbd80aa$exports, "__esModule", {
    value: true
});

var $eqs3F = parcelRequire("eqs3F");


var $6bHyf = parcelRequire("6bHyf");

var $355b48b85dbd80aa$var$TRANSACTION_TYPE = 2;
var $355b48b85dbd80aa$var$TRANSACTION_TYPE_BUFFER = $355b48b85dbd80aa$require$Buffer.from($355b48b85dbd80aa$var$TRANSACTION_TYPE.toString(16).padStart(2, "0"), "hex");
/**
 * Typed transaction with a new gas fee market mechanism
 *
 * - TransactionType: 2
 * - EIP: [EIP-1559](https://eips.ethereum.org/EIPS/eip-1559)
 */ var $355b48b85dbd80aa$var$FeeMarketEIP1559Transaction = /** @class */ function(_super) {
    $355b48b85dbd80aa$var$__extends(FeeMarketEIP1559Transaction, _super);
    /**
     * This constructor takes the values, validates them, assigns them and freezes the object.
     *
     * It is not recommended to use this constructor directly. Instead use
     * the static factory methods to assist in creating a Transaction object from
     * varying data types.
     */ function FeeMarketEIP1559Transaction(txData, opts) {
        if (opts === void 0) opts = {};
        var _a, _b;
        var _this = _super.call(this, $355b48b85dbd80aa$var$__assign($355b48b85dbd80aa$var$__assign({}, txData), {
            type: $355b48b85dbd80aa$var$TRANSACTION_TYPE
        })) || this;
        /**
         * The default HF if the tx type is active on that HF
         * or the first greater HF where the tx is active.
         *
         * @hidden
         */ _this.DEFAULT_HARDFORK = "london";
        var chainId = txData.chainId, accessList = txData.accessList, maxFeePerGas = txData.maxFeePerGas, maxPriorityFeePerGas = txData.maxPriorityFeePerGas;
        _this.common = _this._getCommon(opts.common, chainId);
        _this.chainId = _this.common.chainIdBN();
        if (!_this.common.isActivatedEIP(1559)) throw new Error("EIP-1559 not enabled on Common");
        _this.activeCapabilities = _this.activeCapabilities.concat([
            1559,
            2718,
            2930
        ]);
        // Populate the access list fields
        var accessListData = $fde297469f1d875c$exports.AccessLists.getAccessListData(accessList !== null && accessList !== void 0 ? accessList : []);
        _this.accessList = accessListData.accessList;
        _this.AccessListJSON = accessListData.AccessListJSON;
        // Verify the access list format.
        $fde297469f1d875c$exports.AccessLists.verifyAccessList(_this.accessList);
        _this.maxFeePerGas = new $eqs3F.BN($eqs3F.toBuffer(maxFeePerGas === "" ? "0x" : maxFeePerGas));
        _this.maxPriorityFeePerGas = new $eqs3F.BN($eqs3F.toBuffer(maxPriorityFeePerGas === "" ? "0x" : maxPriorityFeePerGas));
        _this._validateCannotExceedMaxInteger({
            maxFeePerGas: _this.maxFeePerGas,
            maxPriorityFeePerGas: _this.maxPriorityFeePerGas
        }, 256);
        if (_this.maxFeePerGas.lt(_this.maxPriorityFeePerGas)) throw new Error("maxFeePerGas cannot be less than maxPriorityFeePerGas (The total must be the larger of the two)");
        if (_this.v && !_this.v.eqn(0) && !_this.v.eqn(1)) throw new Error("The y-parity of the transaction should either be 0 or 1");
        if (_this.common.gteHardfork("homestead") && ((_a = _this.s) === null || _a === void 0 ? void 0 : _a.gt($6bHyf.N_DIV_2))) throw new Error("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        var freeze = (_b = opts === null || opts === void 0 ? void 0 : opts.freeze) !== null && _b !== void 0 ? _b : true;
        if (freeze) Object.freeze(_this);
        return _this;
    }
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "senderR", {
        /**
         * EIP-2930 alias for `r`
         *
         * @deprecated use `r` instead
         */ get: function() {
            return this.r;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "senderS", {
        /**
         * EIP-2930 alias for `s`
         *
         * @deprecated use `s` instead
         */ get: function() {
            return this.s;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FeeMarketEIP1559Transaction.prototype, "yParity", {
        /**
         * EIP-2930 alias for `v`
         *
         * @deprecated use `v` instead
         */ get: function() {
            return this.v;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Instantiate a transaction from a data dictionary.
     *
     * Format: { chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, v, r, s }
     *
     * Notes:
     * - `chainId` will be set automatically if not provided
     * - All parameters are optional and have some basic default values
     */ FeeMarketEIP1559Transaction.fromTxData = function(txData, opts) {
        if (opts === void 0) opts = {};
        return new FeeMarketEIP1559Transaction(txData, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     */ FeeMarketEIP1559Transaction.fromSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        if (!serialized.slice(0, 1).equals($355b48b85dbd80aa$var$TRANSACTION_TYPE_BUFFER)) throw new Error("Invalid serialized tx input: not an EIP-1559 transaction (wrong tx type, expected: " + $355b48b85dbd80aa$var$TRANSACTION_TYPE + ", received: " + serialized.slice(0, 1).toString("hex"));
        var values = $eqs3F.rlp.decode(serialized.slice(1));
        if (!Array.isArray(values)) throw new Error("Invalid serialized tx input: must be array");
        return FeeMarketEIP1559Transaction.fromValuesArray(values, opts);
    };
    /**
     * Instantiate a transaction from the serialized tx.
     * (alias of {@link FeeMarketEIP1559Transaction.fromSerializedTx})
     *
     * Note: This means that the Buffer should start with 0x01.
     *
     * @deprecated this constructor alias is deprecated and will be removed
     * in favor of the {@link FeeMarketEIP1559Transaction.fromSerializedTx} constructor
     */ FeeMarketEIP1559Transaction.fromRlpSerializedTx = function(serialized, opts) {
        if (opts === void 0) opts = {};
        return FeeMarketEIP1559Transaction.fromSerializedTx(serialized, opts);
    };
    /**
     * Create a transaction from a values array.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     */ FeeMarketEIP1559Transaction.fromValuesArray = function(values, opts) {
        if (opts === void 0) opts = {};
        if (values.length !== 9 && values.length !== 12) throw new Error("Invalid EIP-1559 transaction. Only expecting 9 values (for unsigned tx) or 12 values (for signed tx).");
        var _a = $355b48b85dbd80aa$var$__read(values, 12), chainId = _a[0], nonce = _a[1], maxPriorityFeePerGas = _a[2], maxFeePerGas = _a[3], gasLimit = _a[4], to = _a[5], value = _a[6], data = _a[7], accessList = _a[8], v = _a[9], r = _a[10], s = _a[11];
        return new FeeMarketEIP1559Transaction({
            chainId: new $eqs3F.BN(chainId),
            nonce: nonce,
            maxPriorityFeePerGas: maxPriorityFeePerGas,
            maxFeePerGas: maxFeePerGas,
            gasLimit: gasLimit,
            to: to,
            value: value,
            data: data,
            accessList: accessList !== null && accessList !== void 0 ? accessList : [],
            v: v !== undefined ? new $eqs3F.BN(v) : undefined,
            r: r,
            s: s
        }, opts);
    };
    /**
     * The amount of gas paid for the data in this tx
     */ FeeMarketEIP1559Transaction.prototype.getDataFee = function() {
        var cost = _super.prototype.getDataFee.call(this);
        cost.iaddn($fde297469f1d875c$exports.AccessLists.getDataFeeEIP2930(this.accessList, this.common));
        return cost;
    };
    /**
     * The up front amount that an account must have for this transaction to be valid
     * @param baseFee The base fee of the block (will be set to 0 if not provided)
     */ FeeMarketEIP1559Transaction.prototype.getUpfrontCost = function(baseFee) {
        if (baseFee === void 0) baseFee = new $eqs3F.BN(0);
        var inclusionFeePerGas = $eqs3F.BN.min(this.maxPriorityFeePerGas, this.maxFeePerGas.sub(baseFee));
        var gasPrice = inclusionFeePerGas.add(baseFee);
        return this.gasLimit.mul(gasPrice).add(this.value);
    };
    /**
     * Returns a Buffer Array of the raw Buffers of the EIP-1559 transaction, in order.
     *
     * Format: `[chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS]`
     *
     * Use {@link FeeMarketEIP1559Transaction.serialize} to add to block data for {@link Block.fromValuesArray}.
     */ FeeMarketEIP1559Transaction.prototype.raw = function() {
        return [
            $eqs3F.bnToUnpaddedBuffer(this.chainId),
            $eqs3F.bnToUnpaddedBuffer(this.nonce),
            $eqs3F.bnToUnpaddedBuffer(this.maxPriorityFeePerGas),
            $eqs3F.bnToUnpaddedBuffer(this.maxFeePerGas),
            $eqs3F.bnToUnpaddedBuffer(this.gasLimit),
            this.to !== undefined ? this.to.buf : $355b48b85dbd80aa$require$Buffer.from([]),
            $eqs3F.bnToUnpaddedBuffer(this.value),
            this.data,
            this.accessList,
            this.v !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.v) : $355b48b85dbd80aa$require$Buffer.from([]),
            this.r !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.r) : $355b48b85dbd80aa$require$Buffer.from([]),
            this.s !== undefined ? $eqs3F.bnToUnpaddedBuffer(this.s) : $355b48b85dbd80aa$require$Buffer.from([])
        ];
    };
    /**
     * Returns the serialized encoding of the EIP-1559 transaction.
     *
     * Format: `0x02 || rlp([chainId, nonce, maxPriorityFeePerGas, maxFeePerGas, gasLimit, to, value, data,
     * accessList, signatureYParity, signatureR, signatureS])`
     *
     * Note that in contrast to the legacy tx serialization format this is not
     * valid RLP any more due to the raw tx type preceeding and concatenated to
     * the RLP encoding of the values.
     */ FeeMarketEIP1559Transaction.prototype.serialize = function() {
        var base = this.raw();
        return $355b48b85dbd80aa$require$Buffer.concat([
            $355b48b85dbd80aa$var$TRANSACTION_TYPE_BUFFER,
            $eqs3F.rlp.encode(base)
        ]);
    };
    FeeMarketEIP1559Transaction.prototype.getMessageToSign = function(hashMessage) {
        if (hashMessage === void 0) hashMessage = true;
        var base = this.raw().slice(0, 9);
        var message = $355b48b85dbd80aa$require$Buffer.concat([
            $355b48b85dbd80aa$var$TRANSACTION_TYPE_BUFFER,
            $eqs3F.rlp.encode(base)
        ]);
        if (hashMessage) return $eqs3F.keccak256(message);
        else return message;
    };
    /**
     * Computes a sha3-256 hash of the serialized tx.
     *
     * This method can only be used for signed txs (it throws otherwise).
     * Use {@link FeeMarketEIP1559Transaction.getMessageToSign} to get a tx hash for the purpose of signing.
     */ FeeMarketEIP1559Transaction.prototype.hash = function() {
        if (!this.isSigned()) throw new Error("Cannot call hash method if transaction is not signed");
        return $eqs3F.keccak256(this.serialize());
    };
    /**
     * Computes a sha3-256 hash which can be used to verify the signature
     */ FeeMarketEIP1559Transaction.prototype.getMessageToVerifySignature = function() {
        return this.getMessageToSign();
    };
    /**
     * Returns the public key of the sender
     */ FeeMarketEIP1559Transaction.prototype.getSenderPublicKey = function() {
        var _a;
        if (!this.isSigned()) throw new Error("Cannot call this method if transaction is not signed");
        var msgHash = this.getMessageToVerifySignature();
        // EIP-2: All transaction signatures whose s-value is greater than secp256k1n/2 are considered invalid.
        // Reasoning: https://ethereum.stackexchange.com/a/55728
        if (this.common.gteHardfork("homestead") && ((_a = this.s) === null || _a === void 0 ? void 0 : _a.gt($6bHyf.N_DIV_2))) throw new Error("Invalid Signature: s-values greater than secp256k1n/2 are considered invalid");
        var _b = this, v = _b.v, r = _b.r, s = _b.s;
        try {
            return $eqs3F.ecrecover(msgHash, v.addn(27), $eqs3F.bnToUnpaddedBuffer(r), $eqs3F.bnToUnpaddedBuffer(s));
        } catch (e) {
            throw new Error("Invalid Signature");
        }
    };
    FeeMarketEIP1559Transaction.prototype._processSignature = function(v, r, s) {
        var opts = {
            common: this.common
        };
        return FeeMarketEIP1559Transaction.fromTxData({
            chainId: this.chainId,
            nonce: this.nonce,
            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
            maxFeePerGas: this.maxFeePerGas,
            gasLimit: this.gasLimit,
            to: this.to,
            value: this.value,
            data: this.data,
            accessList: this.accessList,
            v: new $eqs3F.BN(v - 27),
            r: new $eqs3F.BN(r),
            s: new $eqs3F.BN(s)
        }, opts);
    };
    /**
     * Returns an object with the JSON representation of the transaction
     */ FeeMarketEIP1559Transaction.prototype.toJSON = function() {
        var accessListJSON = $fde297469f1d875c$exports.AccessLists.getAccessListJSON(this.accessList);
        return {
            chainId: $eqs3F.bnToHex(this.chainId),
            nonce: $eqs3F.bnToHex(this.nonce),
            maxPriorityFeePerGas: $eqs3F.bnToHex(this.maxPriorityFeePerGas),
            maxFeePerGas: $eqs3F.bnToHex(this.maxFeePerGas),
            gasLimit: $eqs3F.bnToHex(this.gasLimit),
            to: this.to !== undefined ? this.to.toString() : undefined,
            value: $eqs3F.bnToHex(this.value),
            data: "0x" + this.data.toString("hex"),
            accessList: accessListJSON,
            v: this.v !== undefined ? $eqs3F.bnToHex(this.v) : undefined,
            r: this.r !== undefined ? $eqs3F.bnToHex(this.r) : undefined,
            s: this.s !== undefined ? $eqs3F.bnToHex(this.s) : undefined
        };
    };
    return FeeMarketEIP1559Transaction;
}($f05db0d54fecd35a$exports.BaseTransaction);
$355b48b85dbd80aa$exports.default = $355b48b85dbd80aa$var$FeeMarketEIP1559Transaction;


Object.defineProperty($d67a384a34381279$exports, "FeeMarketEIP1559Transaction", {
    enumerable: true,
    get: function() {
        return $355b48b85dbd80aa$exports.default;
    }
});

$d67a384a34381279$var$__exportStar((parcelRequire("6bHyf")), $d67a384a34381279$exports);



var $09c7e2dd7e871038$exports = {};
// source: messages-ethereum.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $09c7e2dd7e871038$var$goog = $2MzPv;
var $09c7e2dd7e871038$var$global = (function() {
    return this || window || $09c7e2dd7e871038$var$global || self || Function("return this")();
}).call(null);

$09c7e2dd7e871038$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.Ethereum712TypesValues", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumAddress", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumGetAddress", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumMessageSignature", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumSignMessage", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumSignTx", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumSignTypedHash", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumTxAck", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumTxRequest", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumTypedDataSignature", null, $09c7e2dd7e871038$var$global);
$09c7e2dd7e871038$var$goog.exportSymbol("proto.EthereumVerifyMessage", null, $09c7e2dd7e871038$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EthereumGetAddress.repeatedFields_, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumGetAddress, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumGetAddress.displayName = "proto.EthereumGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumAddress, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumAddress.displayName = "proto.EthereumAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EthereumSignTx.repeatedFields_, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumSignTx, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumSignTx.displayName = "proto.EthereumSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumTxRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumTxRequest, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumTxRequest.displayName = "proto.EthereumTxRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumTxAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumTxAck, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumTxAck.displayName = "proto.EthereumTxAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumSignMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EthereumSignMessage.repeatedFields_, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumSignMessage, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumSignMessage.displayName = "proto.EthereumSignMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumVerifyMessage = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumVerifyMessage, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumVerifyMessage.displayName = "proto.EthereumVerifyMessage";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumMessageSignature = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumMessageSignature, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumMessageSignature.displayName = "proto.EthereumMessageSignature";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumSignTypedHash = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.EthereumSignTypedHash.repeatedFields_, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumSignTypedHash, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumSignTypedHash.displayName = "proto.EthereumSignTypedHash";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.EthereumTypedDataSignature = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.EthereumTypedDataSignature, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.EthereumTypedDataSignature.displayName = "proto.EthereumTypedDataSignature";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.Ethereum712TypesValues = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.Ethereum712TypesValues.repeatedFields_, null);
};
$09c7e2dd7e871038$var$goog.inherits(proto.Ethereum712TypesValues, $2MzPv.Message);
if ($09c7e2dd7e871038$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.Ethereum712TypesValues.displayName = "proto.Ethereum712TypesValues";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EthereumGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumGetAddress}
 */ proto.EthereumGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumGetAddress;
    return proto.EthereumGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumGetAddress}
 */ proto.EthereumGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EthereumGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EthereumGetAddress} returns this
 */ proto.EthereumGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EthereumGetAddress} returns this
 */ proto.EthereumGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EthereumGetAddress} returns this
 */ proto.EthereumGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.EthereumGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.EthereumGetAddress} returns this
 */ proto.EthereumGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumGetAddress} returns this
 */ proto.EthereumGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: msg.getAddress_asB64(),
            addressStr: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumAddress}
 */ proto.EthereumAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumAddress;
    return proto.EthereumAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumAddress}
 */ proto.EthereumAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAddressStr(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * required bytes address = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumAddress.prototype.getAddress = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * required bytes address = 1;
 * This is a type-conversion wrapper around `getAddress()`
 * @return {string}
 */ proto.EthereumAddress.prototype.getAddress_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getAddress());
};
/**
 * required bytes address = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAddress()`
 * @return {!Uint8Array}
 */ proto.EthereumAddress.prototype.getAddress_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getAddress());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumAddress} returns this
 */ proto.EthereumAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumAddress} returns this
 */ proto.EthereumAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string address_str = 2;
 * @return {string}
 */ proto.EthereumAddress.prototype.getAddressStr = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.EthereumAddress} returns this
 */ proto.EthereumAddress.prototype.setAddressStr = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumAddress} returns this
 */ proto.EthereumAddress.prototype.clearAddressStr = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumAddress.prototype.hasAddressStr = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EthereumSignTx.repeatedFields_ = [
    1,
    9
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            nonce: msg.getNonce_asB64(),
            gasPrice: msg.getGasPrice_asB64(),
            gasLimit: msg.getGasLimit_asB64(),
            to: msg.getTo_asB64(),
            value: msg.getValue_asB64(),
            dataInitialChunk: msg.getDataInitialChunk_asB64(),
            dataLength: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            toAddressNList: (f = $2MzPv.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
            addressType: (f = $2MzPv.Message.getField(msg, 10)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 12)) == null ? undefined : f,
            maxFeePerGas: msg.getMaxFeePerGas_asB64(),
            maxPriorityFeePerGas: msg.getMaxPriorityFeePerGas_asB64(),
            tokenValue: msg.getTokenValue_asB64(),
            tokenTo: msg.getTokenTo_asB64(),
            tokenShortcut: (f = $2MzPv.Message.getField(msg, 102)) == null ? undefined : f,
            txType: (f = $2MzPv.Message.getField(msg, 103)) == null ? undefined : f,
            type: (f = $2MzPv.Message.getField(msg, 104)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumSignTx}
 */ proto.EthereumSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumSignTx;
    return proto.EthereumSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumSignTx}
 */ proto.EthereumSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setNonce(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setGasPrice(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setGasLimit(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setTo(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setValue(value);
                break;
            case 7:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDataInitialChunk(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDataLength(value);
                break;
            case 9:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addToAddressN(values[i]);
                break;
            case 10:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readUint32();
                msg.setChainId(value);
                break;
            case 13:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMaxFeePerGas(value);
                break;
            case 14:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMaxPriorityFeePerGas(value);
                break;
            case 100:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setTokenValue(value);
                break;
            case 101:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setTokenTo(value);
                break;
            case 102:
                var value = /** @type {string} */ reader.readString();
                msg.setTokenShortcut(value);
                break;
            case 103:
                var value = /** @type {number} */ reader.readUint32();
                msg.setTxType(value);
                break;
            case 104:
                var value = /** @type {number} */ reader.readUint32();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBytes(5, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBytes(6, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeBytes(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = message.getToAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(9, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 10);
    if (f != null) writer.writeEnum(10, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 12);
    if (f != null) writer.writeUint32(12, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 13);
    if (f != null) writer.writeBytes(13, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 14);
    if (f != null) writer.writeBytes(14, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 100);
    if (f != null) writer.writeBytes(100, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 101);
    if (f != null) writer.writeBytes(101, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 102);
    if (f != null) writer.writeString(102, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 103);
    if (f != null) writer.writeUint32(103, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 104);
    if (f != null) writer.writeUint32(104, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EthereumSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bytes nonce = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getNonce = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes nonce = 2;
 * This is a type-conversion wrapper around `getNonce()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getNonce_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getNonce());
};
/**
 * optional bytes nonce = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getNonce()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getNonce_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getNonce());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setNonce = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearNonce = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasNonce = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes gas_price = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getGasPrice = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes gas_price = 3;
 * This is a type-conversion wrapper around `getGasPrice()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getGasPrice_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getGasPrice());
};
/**
 * optional bytes gas_price = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getGasPrice()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getGasPrice_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getGasPrice());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setGasPrice = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearGasPrice = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasGasPrice = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes gas_limit = 4;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getGasLimit = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes gas_limit = 4;
 * This is a type-conversion wrapper around `getGasLimit()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getGasLimit_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getGasLimit());
};
/**
 * optional bytes gas_limit = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getGasLimit()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getGasLimit_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getGasLimit());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setGasLimit = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearGasLimit = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasGasLimit = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bytes to = 5;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getTo = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes to = 5;
 * This is a type-conversion wrapper around `getTo()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getTo_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getTo());
};
/**
 * optional bytes to = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTo()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getTo_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getTo());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setTo = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearTo = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasTo = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bytes value = 6;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getValue = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes value = 6;
 * This is a type-conversion wrapper around `getValue()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getValue_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getValue());
};
/**
 * optional bytes value = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getValue()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getValue_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getValue());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setValue = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearValue = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasValue = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional bytes data_initial_chunk = 7;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getDataInitialChunk = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * optional bytes data_initial_chunk = 7;
 * This is a type-conversion wrapper around `getDataInitialChunk()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getDataInitialChunk_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getDataInitialChunk());
};
/**
 * optional bytes data_initial_chunk = 7;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDataInitialChunk()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getDataInitialChunk_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getDataInitialChunk());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setDataInitialChunk = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearDataInitialChunk = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasDataInitialChunk = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 data_length = 8;
 * @return {number}
 */ proto.EthereumSignTx.prototype.getDataLength = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setDataLength = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearDataLength = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasDataLength = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * repeated uint32 to_address_n = 9;
 * @return {!Array<number>}
 */ proto.EthereumSignTx.prototype.getToAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 9);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setToAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 9, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.addToAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 9, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearToAddressNList = function() {
    return this.setToAddressNList([]);
};
/**
 * optional OutputAddressType address_type = 10;
 * @return {!proto.OutputAddressType}
 */ proto.EthereumSignTx.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 10, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 10, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional uint32 chain_id = 12;
 * @return {number}
 */ proto.EthereumSignTx.prototype.getChainId = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 12, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 12, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 12) != null;
};
/**
 * optional bytes max_fee_per_gas = 13;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getMaxFeePerGas = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 13, "");
};
/**
 * optional bytes max_fee_per_gas = 13;
 * This is a type-conversion wrapper around `getMaxFeePerGas()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getMaxFeePerGas_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMaxFeePerGas());
};
/**
 * optional bytes max_fee_per_gas = 13;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMaxFeePerGas()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getMaxFeePerGas_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMaxFeePerGas());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setMaxFeePerGas = function(value) {
    return $2MzPv.Message.setField(this, 13, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearMaxFeePerGas = function() {
    return $2MzPv.Message.setField(this, 13, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasMaxFeePerGas = function() {
    return $2MzPv.Message.getField(this, 13) != null;
};
/**
 * optional bytes max_priority_fee_per_gas = 14;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getMaxPriorityFeePerGas = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 14, "");
};
/**
 * optional bytes max_priority_fee_per_gas = 14;
 * This is a type-conversion wrapper around `getMaxPriorityFeePerGas()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getMaxPriorityFeePerGas_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMaxPriorityFeePerGas());
};
/**
 * optional bytes max_priority_fee_per_gas = 14;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMaxPriorityFeePerGas()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getMaxPriorityFeePerGas_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMaxPriorityFeePerGas());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setMaxPriorityFeePerGas = function(value) {
    return $2MzPv.Message.setField(this, 14, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearMaxPriorityFeePerGas = function() {
    return $2MzPv.Message.setField(this, 14, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasMaxPriorityFeePerGas = function() {
    return $2MzPv.Message.getField(this, 14) != null;
};
/**
 * optional bytes token_value = 100;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getTokenValue = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 100, "");
};
/**
 * optional bytes token_value = 100;
 * This is a type-conversion wrapper around `getTokenValue()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getTokenValue_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getTokenValue());
};
/**
 * optional bytes token_value = 100;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTokenValue()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getTokenValue_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getTokenValue());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setTokenValue = function(value) {
    return $2MzPv.Message.setField(this, 100, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearTokenValue = function() {
    return $2MzPv.Message.setField(this, 100, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasTokenValue = function() {
    return $2MzPv.Message.getField(this, 100) != null;
};
/**
 * optional bytes token_to = 101;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTx.prototype.getTokenTo = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 101, "");
};
/**
 * optional bytes token_to = 101;
 * This is a type-conversion wrapper around `getTokenTo()`
 * @return {string}
 */ proto.EthereumSignTx.prototype.getTokenTo_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getTokenTo());
};
/**
 * optional bytes token_to = 101;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTokenTo()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTx.prototype.getTokenTo_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getTokenTo());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setTokenTo = function(value) {
    return $2MzPv.Message.setField(this, 101, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearTokenTo = function() {
    return $2MzPv.Message.setField(this, 101, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasTokenTo = function() {
    return $2MzPv.Message.getField(this, 101) != null;
};
/**
 * optional string token_shortcut = 102;
 * @return {string}
 */ proto.EthereumSignTx.prototype.getTokenShortcut = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 102, "");
};
/**
 * @param {string} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setTokenShortcut = function(value) {
    return $2MzPv.Message.setField(this, 102, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearTokenShortcut = function() {
    return $2MzPv.Message.setField(this, 102, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasTokenShortcut = function() {
    return $2MzPv.Message.getField(this, 102) != null;
};
/**
 * optional uint32 tx_type = 103;
 * @return {number}
 */ proto.EthereumSignTx.prototype.getTxType = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 103, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setTxType = function(value) {
    return $2MzPv.Message.setField(this, 103, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearTxType = function() {
    return $2MzPv.Message.setField(this, 103, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasTxType = function() {
    return $2MzPv.Message.getField(this, 103) != null;
};
/**
 * optional uint32 type = 104;
 * @return {number}
 */ proto.EthereumSignTx.prototype.getType = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 104, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.setType = function(value) {
    return $2MzPv.Message.setField(this, 104, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTx} returns this
 */ proto.EthereumSignTx.prototype.clearType = function() {
    return $2MzPv.Message.setField(this, 104, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTx.prototype.hasType = function() {
    return $2MzPv.Message.getField(this, 104) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumTxRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumTxRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumTxRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTxRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dataLength: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            signatureV: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            signatureR: msg.getSignatureR_asB64(),
            signatureS: msg.getSignatureS_asB64(),
            hash: msg.getHash_asB64(),
            signatureDer: msg.getSignatureDer_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumTxRequest}
 */ proto.EthereumTxRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumTxRequest;
    return proto.EthereumTxRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumTxRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumTxRequest}
 */ proto.EthereumTxRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDataLength(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSignatureV(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignatureR(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignatureS(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setHash(value);
                break;
            case 6:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignatureDer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumTxRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumTxRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumTxRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTxRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint32(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBytes(5, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeBytes(6, f);
};
/**
 * optional uint32 data_length = 1;
 * @return {number}
 */ proto.EthereumTxRequest.prototype.getDataLength = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setDataLength = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearDataLength = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasDataLength = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint32 signature_v = 2;
 * @return {number}
 */ proto.EthereumTxRequest.prototype.getSignatureV = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setSignatureV = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearSignatureV = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasSignatureV = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes signature_r = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTxRequest.prototype.getSignatureR = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes signature_r = 3;
 * This is a type-conversion wrapper around `getSignatureR()`
 * @return {string}
 */ proto.EthereumTxRequest.prototype.getSignatureR_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignatureR());
};
/**
 * optional bytes signature_r = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignatureR()`
 * @return {!Uint8Array}
 */ proto.EthereumTxRequest.prototype.getSignatureR_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignatureR());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setSignatureR = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearSignatureR = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasSignatureR = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes signature_s = 4;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTxRequest.prototype.getSignatureS = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes signature_s = 4;
 * This is a type-conversion wrapper around `getSignatureS()`
 * @return {string}
 */ proto.EthereumTxRequest.prototype.getSignatureS_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignatureS());
};
/**
 * optional bytes signature_s = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignatureS()`
 * @return {!Uint8Array}
 */ proto.EthereumTxRequest.prototype.getSignatureS_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignatureS());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setSignatureS = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearSignatureS = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasSignatureS = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bytes hash = 5;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTxRequest.prototype.getHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes hash = 5;
 * This is a type-conversion wrapper around `getHash()`
 * @return {string}
 */ proto.EthereumTxRequest.prototype.getHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getHash());
};
/**
 * optional bytes hash = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHash()`
 * @return {!Uint8Array}
 */ proto.EthereumTxRequest.prototype.getHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setHash = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearHash = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasHash = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional bytes signature_der = 6;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTxRequest.prototype.getSignatureDer = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * optional bytes signature_der = 6;
 * This is a type-conversion wrapper around `getSignatureDer()`
 * @return {string}
 */ proto.EthereumTxRequest.prototype.getSignatureDer_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignatureDer());
};
/**
 * optional bytes signature_der = 6;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignatureDer()`
 * @return {!Uint8Array}
 */ proto.EthereumTxRequest.prototype.getSignatureDer_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignatureDer());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.setSignatureDer = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxRequest} returns this
 */ proto.EthereumTxRequest.prototype.clearSignatureDer = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxRequest.prototype.hasSignatureDer = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumTxAck.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumTxAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumTxAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTxAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            dataChunk: msg.getDataChunk_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumTxAck}
 */ proto.EthereumTxAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumTxAck;
    return proto.EthereumTxAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumTxAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumTxAck}
 */ proto.EthereumTxAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDataChunk(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumTxAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumTxAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumTxAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTxAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
};
/**
 * optional bytes data_chunk = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTxAck.prototype.getDataChunk = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes data_chunk = 1;
 * This is a type-conversion wrapper around `getDataChunk()`
 * @return {string}
 */ proto.EthereumTxAck.prototype.getDataChunk_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getDataChunk());
};
/**
 * optional bytes data_chunk = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDataChunk()`
 * @return {!Uint8Array}
 */ proto.EthereumTxAck.prototype.getDataChunk_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getDataChunk());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTxAck} returns this
 */ proto.EthereumTxAck.prototype.setDataChunk = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTxAck} returns this
 */ proto.EthereumTxAck.prototype.clearDataChunk = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTxAck.prototype.hasDataChunk = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EthereumSignMessage.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumSignMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumSignMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumSignMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            message: msg.getMessage_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumSignMessage}
 */ proto.EthereumSignMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumSignMessage;
    return proto.EthereumSignMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumSignMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumSignMessage}
 */ proto.EthereumSignMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumSignMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumSignMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumSignMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EthereumSignMessage.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EthereumSignMessage} returns this
 */ proto.EthereumSignMessage.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EthereumSignMessage} returns this
 */ proto.EthereumSignMessage.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EthereumSignMessage} returns this
 */ proto.EthereumSignMessage.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required bytes message = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes message = 2;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.EthereumSignMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * required bytes message = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.EthereumSignMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignMessage} returns this
 */ proto.EthereumSignMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignMessage} returns this
 */ proto.EthereumSignMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumVerifyMessage.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumVerifyMessage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumVerifyMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumVerifyMessage.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: msg.getAddress_asB64(),
            signature: msg.getSignature_asB64(),
            message: msg.getMessage_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumVerifyMessage}
 */ proto.EthereumVerifyMessage.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumVerifyMessage;
    return proto.EthereumVerifyMessage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumVerifyMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumVerifyMessage}
 */ proto.EthereumVerifyMessage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumVerifyMessage.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumVerifyMessage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumVerifyMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumVerifyMessage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * optional bytes address = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumVerifyMessage.prototype.getAddress = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes address = 1;
 * This is a type-conversion wrapper around `getAddress()`
 * @return {string}
 */ proto.EthereumVerifyMessage.prototype.getAddress_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getAddress());
};
/**
 * optional bytes address = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAddress()`
 * @return {!Uint8Array}
 */ proto.EthereumVerifyMessage.prototype.getAddress_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getAddress());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumVerifyMessage.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumVerifyMessage.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.EthereumVerifyMessage.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.EthereumVerifyMessage.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumVerifyMessage.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes message = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumVerifyMessage.prototype.getMessage = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes message = 3;
 * This is a type-conversion wrapper around `getMessage()`
 * @return {string}
 */ proto.EthereumVerifyMessage.prototype.getMessage_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessage());
};
/**
 * optional bytes message = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessage()`
 * @return {!Uint8Array}
 */ proto.EthereumVerifyMessage.prototype.getMessage_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.setMessage = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumVerifyMessage} returns this
 */ proto.EthereumVerifyMessage.prototype.clearMessage = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumVerifyMessage.prototype.hasMessage = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumMessageSignature.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumMessageSignature.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumMessageSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumMessageSignature.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: msg.getAddress_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumMessageSignature}
 */ proto.EthereumMessageSignature.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumMessageSignature;
    return proto.EthereumMessageSignature.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumMessageSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumMessageSignature}
 */ proto.EthereumMessageSignature.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumMessageSignature.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumMessageSignature.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumMessageSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumMessageSignature.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes address = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumMessageSignature.prototype.getAddress = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes address = 1;
 * This is a type-conversion wrapper around `getAddress()`
 * @return {string}
 */ proto.EthereumMessageSignature.prototype.getAddress_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getAddress());
};
/**
 * optional bytes address = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getAddress()`
 * @return {!Uint8Array}
 */ proto.EthereumMessageSignature.prototype.getAddress_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getAddress());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumMessageSignature} returns this
 */ proto.EthereumMessageSignature.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumMessageSignature} returns this
 */ proto.EthereumMessageSignature.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumMessageSignature.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumMessageSignature.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.EthereumMessageSignature.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.EthereumMessageSignature.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumMessageSignature} returns this
 */ proto.EthereumMessageSignature.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumMessageSignature} returns this
 */ proto.EthereumMessageSignature.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumMessageSignature.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.EthereumSignTypedHash.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumSignTypedHash.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumSignTypedHash.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumSignTypedHash} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignTypedHash.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            domainSeparatorHash: msg.getDomainSeparatorHash_asB64(),
            messageHash: msg.getMessageHash_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumSignTypedHash}
 */ proto.EthereumSignTypedHash.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumSignTypedHash;
    return proto.EthereumSignTypedHash.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumSignTypedHash} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumSignTypedHash}
 */ proto.EthereumSignTypedHash.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDomainSeparatorHash(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessageHash(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumSignTypedHash.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumSignTypedHash.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumSignTypedHash} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumSignTypedHash.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.EthereumSignTypedHash.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required bytes domain_separator_hash = 2;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTypedHash.prototype.getDomainSeparatorHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * required bytes domain_separator_hash = 2;
 * This is a type-conversion wrapper around `getDomainSeparatorHash()`
 * @return {string}
 */ proto.EthereumSignTypedHash.prototype.getDomainSeparatorHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getDomainSeparatorHash());
};
/**
 * required bytes domain_separator_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDomainSeparatorHash()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTypedHash.prototype.getDomainSeparatorHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getDomainSeparatorHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.setDomainSeparatorHash = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.clearDomainSeparatorHash = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTypedHash.prototype.hasDomainSeparatorHash = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes message_hash = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumSignTypedHash.prototype.getMessageHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes message_hash = 3;
 * This is a type-conversion wrapper around `getMessageHash()`
 * @return {string}
 */ proto.EthereumSignTypedHash.prototype.getMessageHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessageHash());
};
/**
 * optional bytes message_hash = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessageHash()`
 * @return {!Uint8Array}
 */ proto.EthereumSignTypedHash.prototype.getMessageHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessageHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.setMessageHash = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumSignTypedHash} returns this
 */ proto.EthereumSignTypedHash.prototype.clearMessageHash = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumSignTypedHash.prototype.hasMessageHash = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.EthereumTypedDataSignature.prototype.toObject = function(opt_includeInstance) {
        return proto.EthereumTypedDataSignature.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.EthereumTypedDataSignature} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTypedDataSignature.toObject = function(includeInstance, msg) {
        var f, obj = {
            signature: msg.getSignature_asB64(),
            address: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            domainSeparatorHash: msg.getDomainSeparatorHash_asB64(),
            hasMsgHash: (f = $2MzPv.Message.getBooleanField(msg, 4)) == null ? undefined : f,
            messageHash: msg.getMessageHash_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.EthereumTypedDataSignature}
 */ proto.EthereumTypedDataSignature.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.EthereumTypedDataSignature;
    return proto.EthereumTypedDataSignature.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.EthereumTypedDataSignature} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.EthereumTypedDataSignature}
 */ proto.EthereumTypedDataSignature.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDomainSeparatorHash(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHasMsgHash(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setMessageHash(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.EthereumTypedDataSignature.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.EthereumTypedDataSignature.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.EthereumTypedDataSignature} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.EthereumTypedDataSignature.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBytes(3, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBytes(5, f);
};
/**
 * required bytes signature = 1;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTypedDataSignature.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * required bytes signature = 1;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.EthereumTypedDataSignature.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * required bytes signature = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.EthereumTypedDataSignature.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * required string address = 2;
 * @return {string}
 */ proto.EthereumTypedDataSignature.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bytes domain_separator_hash = 3;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTypedDataSignature.prototype.getDomainSeparatorHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes domain_separator_hash = 3;
 * This is a type-conversion wrapper around `getDomainSeparatorHash()`
 * @return {string}
 */ proto.EthereumTypedDataSignature.prototype.getDomainSeparatorHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getDomainSeparatorHash());
};
/**
 * optional bytes domain_separator_hash = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDomainSeparatorHash()`
 * @return {!Uint8Array}
 */ proto.EthereumTypedDataSignature.prototype.getDomainSeparatorHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getDomainSeparatorHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.setDomainSeparatorHash = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.clearDomainSeparatorHash = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.hasDomainSeparatorHash = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * required bool has_msg_hash = 4;
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.getHasMsgHash = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.setHasMsgHash = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.clearHasMsgHash = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.hasHasMsgHash = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bytes message_hash = 5;
 * @return {!(string|Uint8Array)}
 */ proto.EthereumTypedDataSignature.prototype.getMessageHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes message_hash = 5;
 * This is a type-conversion wrapper around `getMessageHash()`
 * @return {string}
 */ proto.EthereumTypedDataSignature.prototype.getMessageHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getMessageHash());
};
/**
 * optional bytes message_hash = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMessageHash()`
 * @return {!Uint8Array}
 */ proto.EthereumTypedDataSignature.prototype.getMessageHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getMessageHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.setMessageHash = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.EthereumTypedDataSignature} returns this
 */ proto.EthereumTypedDataSignature.prototype.clearMessageHash = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.EthereumTypedDataSignature.prototype.hasMessageHash = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.Ethereum712TypesValues.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.Ethereum712TypesValues.prototype.toObject = function(opt_includeInstance) {
        return proto.Ethereum712TypesValues.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Ethereum712TypesValues} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Ethereum712TypesValues.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            eip712types: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            eip712primetype: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            eip712data: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            eip712typevals: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Ethereum712TypesValues}
 */ proto.Ethereum712TypesValues.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.Ethereum712TypesValues;
    return proto.Ethereum712TypesValues.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Ethereum712TypesValues} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Ethereum712TypesValues}
 */ proto.Ethereum712TypesValues.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEip712types(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setEip712primetype(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setEip712data(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setEip712typevals(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.Ethereum712TypesValues.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.Ethereum712TypesValues.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Ethereum712TypesValues} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.Ethereum712TypesValues.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.Ethereum712TypesValues.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * required string eip712types = 2;
 * @return {string}
 */ proto.Ethereum712TypesValues.prototype.getEip712types = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.setEip712types = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.clearEip712types = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ethereum712TypesValues.prototype.hasEip712types = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * required string eip712primetype = 3;
 * @return {string}
 */ proto.Ethereum712TypesValues.prototype.getEip712primetype = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.setEip712primetype = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.clearEip712primetype = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ethereum712TypesValues.prototype.hasEip712primetype = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * required string eip712data = 4;
 * @return {string}
 */ proto.Ethereum712TypesValues.prototype.getEip712data = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.setEip712data = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.clearEip712data = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ethereum712TypesValues.prototype.hasEip712data = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * required uint32 eip712typevals = 5;
 * @return {number}
 */ proto.Ethereum712TypesValues.prototype.getEip712typevals = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.setEip712typevals = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.Ethereum712TypesValues} returns this
 */ proto.Ethereum712TypesValues.prototype.clearEip712typevals = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.Ethereum712TypesValues.prototype.hasEip712typevals = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
$09c7e2dd7e871038$var$goog.object.extend($09c7e2dd7e871038$exports, proto);



parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");
var $egG3m = parcelRequire("egG3m");
var $23486f72422a2370$exports = {};
"use strict";
var $23486f72422a2370$var$__createBinding = $23486f72422a2370$exports && $23486f72422a2370$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $23486f72422a2370$var$__exportStar = $23486f72422a2370$exports && $23486f72422a2370$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $23486f72422a2370$var$__createBinding(exports1, m, p);
};
Object.defineProperty($23486f72422a2370$exports, "__esModule", {
    value: true
});
$23486f72422a2370$exports.normalize = $23486f72422a2370$exports.concatSig = void 0;

$23486f72422a2370$var$__exportStar((parcelRequire("dQo6s")), $23486f72422a2370$exports);

$23486f72422a2370$var$__exportStar((parcelRequire("oHv2a")), $23486f72422a2370$exports);

$23486f72422a2370$var$__exportStar((parcelRequire("4x0IF")), $23486f72422a2370$exports);

var $grbfr = parcelRequire("grbfr");
Object.defineProperty($23486f72422a2370$exports, "concatSig", {
    enumerable: true,
    get: function() {
        return $grbfr.concatSig;
    }
});
Object.defineProperty($23486f72422a2370$exports, "normalize", {
    enumerable: true,
    get: function() {
        return $grbfr.normalize;
    }
});


var $9ff6e88fb54a1c7c$exports = {};
var $aff1350eb1052ea7$exports = {};
"use strict";


$aff1350eb1052ea7$exports = (parcelRequire("dlCNI"))((parcelRequire("7XtP2")));


function $9ff6e88fb54a1c7c$var$encodeInternal(address, parsed, chainId) {
    $9ff6e88fb54a1c7c$var$checkChainId(chainId);
    parsed = parsed === undefined ? $9ff6e88fb54a1c7c$var$getHex(address) : parsed;
    if (parsed === null) throw new TypeError("Bad address");
    var addressHex = parsed[1].toLowerCase();
    var forHash = chainId !== undefined ? chainId.toString(10) + "0x" + addressHex : addressHex;
    var checksum = $aff1350eb1052ea7$exports("keccak256").update(forHash).digest();
    var ret = "0x";
    for(var i = 0; i < 20; ++i){
        var byte = checksum[i];
        var ha = addressHex.charAt(i * 2);
        var hb = addressHex.charAt(i * 2 + 1);
        ret += (byte & 0xf0) >= 0x80 ? ha.toUpperCase() : ha;
        ret += (byte & 0x0f) >= 0x08 ? hb.toUpperCase() : hb;
    }
    return ret;
}
function $9ff6e88fb54a1c7c$var$encode(address, chainId) {
    return $9ff6e88fb54a1c7c$var$encodeInternal(address, undefined, chainId);
}
function $9ff6e88fb54a1c7c$var$verify(address, allowOneCase, chainId) {
    $9ff6e88fb54a1c7c$var$checkChainId(chainId);
    var parsed = $9ff6e88fb54a1c7c$var$getHex(address);
    if (parsed !== null) {
        if (address.indexOf("0x") !== 0) return false;
        if (allowOneCase && $9ff6e88fb54a1c7c$var$isOneCase(parsed[1])) return true;
        return $9ff6e88fb54a1c7c$var$encodeInternal(address, parsed, chainId) === address;
    }
    return false;
}
function $9ff6e88fb54a1c7c$var$checkChainId(n) {
    if (n !== undefined && !$9ff6e88fb54a1c7c$var$isPositiveInteger(n)) throw new TypeError("Bad chainId");
}
function $9ff6e88fb54a1c7c$var$isPositiveInteger(n) {
    return (typeof n === "number" || n instanceof Number) && n > 0 && n + 0 === Math.floor(n);
}
function $9ff6e88fb54a1c7c$var$isOneCase(s) {
    return s === s.toLowerCase() || s === s.toUpperCase();
}
function $9ff6e88fb54a1c7c$var$isString(data) {
    return typeof data === "string" || data instanceof String;
}
function $9ff6e88fb54a1c7c$var$getHex(data) {
    return $9ff6e88fb54a1c7c$var$isString(data) ? data.match(/^(?:0x)?([0-9a-fA-F]{40})$/) : null;
}
$9ff6e88fb54a1c7c$exports = {
    encode: $9ff6e88fb54a1c7c$var$encode,
    verify: $9ff6e88fb54a1c7c$var$verify
};



var $8iu5n = parcelRequire("8iu5n");

async function $498e4f3d99501515$export$c19ce23c9e212ea7(chainId) {
    return true;
}
async function $498e4f3d99501515$export$bf08b0f93c5ac413() {
    return true;
}
function $498e4f3d99501515$export$bb575c1aefbd30f4() {
    return true;
}
function $498e4f3d99501515$export$9085c5f7c6435a2e(msg) {
    const slip44 = $7NkOr.slip44ByCoin(msg.coin);
    if (slip44 === undefined) return [];
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + slip44,
                0x80000000 + msg.accountIdx,
                0,
                0
            ],
            hardenedPath: [
                2147483692,
                0x80000000 + slip44,
                0x80000000 + msg.accountIdx
            ],
            relPath: [
                0,
                0
            ],
            description: "KeepKey"
        }
    ];
}
function $498e4f3d99501515$var$stripLeadingZeroes(buf) {
    const firstZeroIndex = buf.findIndex((x)=>x !== 0);
    return buf.slice(firstZeroIndex !== -1 ? firstZeroIndex : buf.length);
}
async function $498e4f3d99501515$export$b845b4057200770d(transport, msg) {
    return transport.lockDuring(async ()=>{
        const est = new $09c7e2dd7e871038$exports.EthereumSignTx();
        est.setAddressNList(msg.addressNList);
        est.setNonce($498e4f3d99501515$var$stripLeadingZeroes($7NkOr.arrayify(msg.nonce)));
        est.setGasLimit($7NkOr.arrayify(msg.gasLimit));
        if (msg.gasPrice) est.setGasPrice($7NkOr.arrayify(msg.gasPrice));
        if (msg.maxFeePerGas) {
            est.setMaxFeePerGas($7NkOr.arrayify(msg.maxFeePerGas));
            est.setType($egG3m.ETHTransactionType.ETH_TX_TYPE_EIP_1559);
            if (msg.maxPriorityFeePerGas) est.setMaxPriorityFeePerGas($7NkOr.arrayify(msg.maxPriorityFeePerGas));
        }
        if (msg.value.match("^0x0*$") === null) est.setValue($7NkOr.arrayify(msg.value));
        if (msg.toAddressNList) {
            est.setAddressType($d4cdf7121546d3d6$exports.OutputAddressType.SPEND);
            est.setToAddressNList(msg.toAddressNList);
        } else est.setAddressType($d4cdf7121546d3d6$exports.OutputAddressType.SPEND);
        if (msg.to) est.setTo($7NkOr.arrayify(msg.to));
        let dataChunk = null;
        let dataRemaining = undefined;
        if (msg.data) {
            dataRemaining = $7NkOr.arrayify(msg.data);
            est.setDataLength(dataRemaining.length);
            dataChunk = dataRemaining.slice(0, 1024);
            dataRemaining = dataRemaining.slice(dataChunk.length);
            est.setDataInitialChunk(dataChunk);
        }
        if (msg.chainId !== undefined) est.setChainId(msg.chainId);
        let response;
        let nextResponse = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMSIGNTX, est, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        response = nextResponse.proto;
        try {
            const esa = new $09c7e2dd7e871038$exports.EthereumTxAck();
            while(response.hasDataLength()){
                const dataLength = response.getDataLength();
                dataRemaining = $7NkOr.mustBeDefined(dataRemaining);
                dataChunk = dataRemaining.slice(0, dataLength);
                dataRemaining = dataRemaining.slice(dataLength, dataRemaining.length);
                esa.setDataChunk(dataChunk);
                nextResponse = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMTXACK, esa, {
                    msgTimeout: $7NkOr.LONG_TIMEOUT,
                    omitLock: true
                });
                response = nextResponse.proto;
            }
        } catch (error) {
            console.error({
                error: error
            });
            throw new Error("Failed to sign ETH transaction");
        }
        const utxBase = {
            to: msg.to,
            value: msg.value,
            data: msg.data,
            chainId: msg.chainId,
            nonce: msg.nonce,
            gasLimit: msg.gasLimit,
            maxFeePerGas: msg.maxFeePerGas,
            maxPriorityFeePerGas: msg.maxPriorityFeePerGas
        };
        const r = "0x" + $7NkOr.toHexString(response.getSignatureR_asU8());
        const s = "0x" + $7NkOr.toHexString(response.getSignatureS_asU8());
        if (!response.hasSignatureV()) throw new Error("could not get v");
        const v = $7NkOr.mustBeDefined(response.getSignatureV());
        const v2 = "0x" + v.toString(16);
        const common = (0, (/*@__PURE__*/$parcel$interopDefault($bE5P3))).custom({
            chainId: msg.chainId
        });
        const tx = msg.maxFeePerGas ? (0, $d67a384a34381279$exports.FeeMarketEIP1559Transaction).fromTxData({
            ...utxBase,
            maxFeePerGas: msg.maxFeePerGas,
            maxPriorityFeePerGas: msg.maxPriorityFeePerGas,
            r: r,
            s: s,
            v: v2
        }) : (0, $d67a384a34381279$exports.Transaction).fromTxData({
            ...utxBase,
            gasPrice: msg.gasPrice,
            r: r,
            s: s,
            v: v2
        }, {
            common: common
        });
        return {
            r: r,
            s: s,
            v: v,
            serialized: "0x" + $7NkOr.toHexString(tx.serialize())
        };
    });
}
async function $498e4f3d99501515$export$52db94402edc4376(transport, msg) {
    const getAddr = new $09c7e2dd7e871038$exports.EthereumGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const ethAddress = response.proto;
    let address;
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (ethAddress.hasAddressStr()) address = ethAddress.getAddressStr();
    else if (ethAddress.hasAddress()) address = "0x" + $7NkOr.toHexString(ethAddress.getAddress_asU8());
    else throw new Error("Unable to obtain ETH address from device.");
    return address;
}
async function $498e4f3d99501515$export$a578110d5d38f7e6(transport, msg) {
    const { addressNList: addressNList, message: message } = msg;
    if (!(0, $8iu5n.isHexString)(message)) throw new Error("data is not an hex string");
    const m = new $09c7e2dd7e871038$exports.EthereumSignMessage();
    m.setAddressNList(addressNList);
    const messageBytes = (0, $8iu5n.arrayify)(message);
    m.setMessage(messageBytes);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMSIGNMESSAGE, m, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const sig = response.proto;
    return {
        address: $9ff6e88fb54a1c7c$exports.encode("0x" + $7NkOr.toHexString(sig.getAddress_asU8())),
        signature: "0x" + $7NkOr.toHexString(sig.getSignature_asU8())
    };
}
async function $498e4f3d99501515$export$52d7a3c627b1c409(transport, msg) {
    try {
        const version = (0, $23486f72422a2370$exports.SignTypedDataVersion).V4;
        const EIP_712_DOMAIN = "EIP712Domain";
        const { types: types, primaryType: primaryType, domain: domain, message: message } = msg.typedData;
        const domainSeparatorHash = (0, $23486f72422a2370$exports.TypedDataUtils).hashStruct(EIP_712_DOMAIN, domain, types, version);
        const ethereumSignTypedHash = new $09c7e2dd7e871038$exports.EthereumSignTypedHash();
        ethereumSignTypedHash.setAddressNList(msg.addressNList);
        ethereumSignTypedHash.setDomainSeparatorHash(domainSeparatorHash);
        let messageHash = undefined;
        // If "EIP712Domain" is the primaryType, messageHash is not required - look at T1 connect impl ;)
        // todo: the firmware should define messageHash as an optional Uint8Array field for this case
        if (primaryType !== EIP_712_DOMAIN) {
            messageHash = (0, $23486f72422a2370$exports.TypedDataUtils).hashStruct(primaryType, message, types, version);
            ethereumSignTypedHash.setMessageHash(messageHash);
        }
        const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMSIGNTYPEDHASH, ethereumSignTypedHash, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        const result = response.proto;
        const res = {
            address: result.getAddress() || "",
            signature: "0x" + $7NkOr.toHexString(result.getSignature_asU8())
        };
        return res;
    } catch (error) {
        console.error({
            error: error
        });
        throw new Error("Failed to sign typed ETH message");
    }
}
async function $498e4f3d99501515$export$acb9cc41cbb8b7de(transport, msg) {
    const m = new $09c7e2dd7e871038$exports.EthereumVerifyMessage();
    m.setAddress($7NkOr.arrayify(msg.address));
    m.setSignature($7NkOr.arrayify(msg.signature));
    m.setMessage((0, $8iu5n.isBytes)(msg.message) ? (0, $8iu5n.arrayify)(msg.message) : (0, $18acccdd0f9aa659$export$d9791cdfbd60a48f)(msg.message));
    let event;
    try {
        event = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ETHEREUMVERIFYMESSAGE, m, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
    } catch (e) {
        if ($7NkOr.isIndexable(e) && e.message_enum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FAILURE) return false;
        throw e;
    }
    const success = event.proto;
    return success.getMessage() === "Message verified";
}



var $9b53c374edf4eb8c$exports = {};
// source: messages-mayachain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $9b53c374edf4eb8c$var$goog = $2MzPv;
var $9b53c374edf4eb8c$var$global = (function() {
    return this || window || $9b53c374edf4eb8c$var$global || self || Function("return this")();
}).call(null);

$9b53c374edf4eb8c$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainAddress", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainGetAddress", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainMsgAck", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainMsgDeposit", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainMsgRequest", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainMsgSend", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainSignTx", null, $9b53c374edf4eb8c$var$global);
$9b53c374edf4eb8c$var$goog.exportSymbol("proto.MayachainSignedTx", null, $9b53c374edf4eb8c$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.MayachainGetAddress.repeatedFields_, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainGetAddress, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainGetAddress.displayName = "proto.MayachainGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainAddress, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainAddress.displayName = "proto.MayachainAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.MayachainSignTx.repeatedFields_, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainSignTx, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainSignTx.displayName = "proto.MayachainSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainMsgRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainMsgRequest, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainMsgRequest.displayName = "proto.MayachainMsgRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainMsgAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainMsgAck, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainMsgAck.displayName = "proto.MayachainMsgAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainMsgSend = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainMsgSend, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainMsgSend.displayName = "proto.MayachainMsgSend";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainMsgDeposit = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainMsgDeposit, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainMsgDeposit.displayName = "proto.MayachainMsgDeposit";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.MayachainSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9b53c374edf4eb8c$var$goog.inherits(proto.MayachainSignedTx, $2MzPv.Message);
if ($9b53c374edf4eb8c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.MayachainSignedTx.displayName = "proto.MayachainSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.MayachainGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainGetAddress}
 */ proto.MayachainGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainGetAddress;
    return proto.MayachainGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainGetAddress}
 */ proto.MayachainGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.MayachainGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.MayachainGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool testnet = 3;
 * @return {boolean}
 */ proto.MayachainGetAddress.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainGetAddress} returns this
 */ proto.MayachainGetAddress.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainGetAddress.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainAddress}
 */ proto.MayachainAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainAddress;
    return proto.MayachainAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainAddress}
 */ proto.MayachainAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.MayachainAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainAddress} returns this
 */ proto.MayachainAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainAddress} returns this
 */ proto.MayachainAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.MayachainSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            accountNumber: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            feeAmount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            gas: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            msgCount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainSignTx}
 */ proto.MayachainSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainSignTx;
    return proto.MayachainSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainSignTx}
 */ proto.MayachainSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setChainId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFeeAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGas(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSequence(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgCount(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeUint64String(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeBool(9, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.MayachainSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint64 account_number = 2;
 * @return {string}
 */ proto.MayachainSignTx.prototype.getAccountNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setAccountNumber = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearAccountNumber = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasAccountNumber = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string chain_id = 3;
 * @return {string}
 */ proto.MayachainSignTx.prototype.getChainId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 fee_amount = 4;
 * @return {number}
 */ proto.MayachainSignTx.prototype.getFeeAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setFeeAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearFeeAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasFeeAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 gas = 5;
 * @return {number}
 */ proto.MayachainSignTx.prototype.getGas = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setGas = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearGas = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasGas = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string memo = 6;
 * @return {string}
 */ proto.MayachainSignTx.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional uint64 sequence = 7;
 * @return {string}
 */ proto.MayachainSignTx.prototype.getSequence = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "0");
};
/**
 * @param {string} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 msg_count = 8;
 * @return {number}
 */ proto.MayachainSignTx.prototype.getMsgCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setMsgCount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearMsgCount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasMsgCount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional bool testnet = 9;
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignTx} returns this
 */ proto.MayachainSignTx.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignTx.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainMsgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainMsgRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainMsgRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainMsgRequest}
 */ proto.MayachainMsgRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainMsgRequest;
    return proto.MayachainMsgRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainMsgRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainMsgRequest}
 */ proto.MayachainMsgRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainMsgRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainMsgRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainMsgRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainMsgAck.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainMsgAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainMsgAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            send: (f = msg.getSend()) && proto.MayachainMsgSend.toObject(includeInstance, f),
            deposit: (f = msg.getDeposit()) && proto.MayachainMsgDeposit.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainMsgAck}
 */ proto.MayachainMsgAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainMsgAck;
    return proto.MayachainMsgAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainMsgAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainMsgAck}
 */ proto.MayachainMsgAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.MayachainMsgSend;
                reader.readMessage(value, proto.MayachainMsgSend.deserializeBinaryFromReader);
                msg.setSend(value);
                break;
            case 2:
                var value = new proto.MayachainMsgDeposit;
                reader.readMessage(value, proto.MayachainMsgDeposit.deserializeBinaryFromReader);
                msg.setDeposit(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainMsgAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainMsgAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainMsgAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSend();
    if (f != null) writer.writeMessage(1, f, proto.MayachainMsgSend.serializeBinaryToWriter);
    f = message.getDeposit();
    if (f != null) writer.writeMessage(2, f, proto.MayachainMsgDeposit.serializeBinaryToWriter);
};
/**
 * optional MayachainMsgSend send = 1;
 * @return {?proto.MayachainMsgSend}
 */ proto.MayachainMsgAck.prototype.getSend = function() {
    return /** @type{?proto.MayachainMsgSend} */ $2MzPv.Message.getWrapperField(this, proto.MayachainMsgSend, 1);
};
/**
 * @param {?proto.MayachainMsgSend|undefined} value
 * @return {!proto.MayachainMsgAck} returns this
*/ proto.MayachainMsgAck.prototype.setSend = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.MayachainMsgAck} returns this
 */ proto.MayachainMsgAck.prototype.clearSend = function() {
    return this.setSend(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgAck.prototype.hasSend = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional MayachainMsgDeposit deposit = 2;
 * @return {?proto.MayachainMsgDeposit}
 */ proto.MayachainMsgAck.prototype.getDeposit = function() {
    return /** @type{?proto.MayachainMsgDeposit} */ $2MzPv.Message.getWrapperField(this, proto.MayachainMsgDeposit, 2);
};
/**
 * @param {?proto.MayachainMsgDeposit|undefined} value
 * @return {!proto.MayachainMsgAck} returns this
*/ proto.MayachainMsgAck.prototype.setDeposit = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.MayachainMsgAck} returns this
 */ proto.MayachainMsgAck.prototype.clearDeposit = function() {
    return this.setDeposit(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgAck.prototype.hasDeposit = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainMsgSend.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainMsgSend.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainMsgSend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgSend.toObject = function(includeInstance, msg) {
        var f, obj = {
            fromAddress: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            toAddress: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            addressType: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainMsgSend}
 */ proto.MayachainMsgSend.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainMsgSend;
    return proto.MayachainMsgSend.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainMsgSend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainMsgSend}
 */ proto.MayachainMsgSend.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setFromAddress(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setToAddress(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainMsgSend.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainMsgSend.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainMsgSend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgSend.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint64String(8, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeEnum(9, f);
};
/**
 * optional string from_address = 6;
 * @return {string}
 */ proto.MayachainMsgSend.prototype.getFromAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.setFromAddress = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.clearFromAddress = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgSend.prototype.hasFromAddress = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string to_address = 7;
 * @return {string}
 */ proto.MayachainMsgSend.prototype.getToAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.setToAddress = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.clearToAddress = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgSend.prototype.hasToAddress = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint64 amount = 8;
 * @return {string}
 */ proto.MayachainMsgSend.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "0");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgSend.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional OutputAddressType address_type = 9;
 * @return {!proto.OutputAddressType}
 */ proto.MayachainMsgSend.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgSend} returns this
 */ proto.MayachainMsgSend.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgSend.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainMsgDeposit.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainMsgDeposit.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainMsgDeposit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgDeposit.toObject = function(includeInstance, msg) {
        var f, obj = {
            asset: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            signer: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainMsgDeposit}
 */ proto.MayachainMsgDeposit.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainMsgDeposit;
    return proto.MayachainMsgDeposit.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainMsgDeposit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainMsgDeposit}
 */ proto.MayachainMsgDeposit.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAsset(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSigner(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainMsgDeposit.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainMsgDeposit.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainMsgDeposit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainMsgDeposit.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional string asset = 1;
 * @return {string}
 */ proto.MayachainMsgDeposit.prototype.getAsset = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.setAsset = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.clearAsset = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgDeposit.prototype.hasAsset = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 amount = 2;
 * @return {string}
 */ proto.MayachainMsgDeposit.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgDeposit.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string memo = 3;
 * @return {string}
 */ proto.MayachainMsgDeposit.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgDeposit.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string signer = 4;
 * @return {string}
 */ proto.MayachainMsgDeposit.prototype.getSigner = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.setSigner = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainMsgDeposit} returns this
 */ proto.MayachainMsgDeposit.prototype.clearSigner = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainMsgDeposit.prototype.hasSigner = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.MayachainSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.MayachainSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.MayachainSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            publicKey: msg.getPublicKey_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.MayachainSignedTx}
 */ proto.MayachainSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.MayachainSignedTx;
    return proto.MayachainSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.MayachainSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.MayachainSignedTx}
 */ proto.MayachainSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.MayachainSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.MayachainSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.MayachainSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.MayachainSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes public_key = 1;
 * @return {!(string|Uint8Array)}
 */ proto.MayachainSignedTx.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes public_key = 1;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.MayachainSignedTx.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.MayachainSignedTx.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.MayachainSignedTx} returns this
 */ proto.MayachainSignedTx.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignedTx} returns this
 */ proto.MayachainSignedTx.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignedTx.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.MayachainSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.MayachainSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.MayachainSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.MayachainSignedTx} returns this
 */ proto.MayachainSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.MayachainSignedTx} returns this
 */ proto.MayachainSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.MayachainSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$9b53c374edf4eb8c$var$goog.object.extend($9b53c374edf4eb8c$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $1Vf4C = parcelRequire("1Vf4C");

var $gGdnO = parcelRequire("gGdnO");

const $0fbcf8d6af2d9dc2$var$protoTxBuilder = (0, (/*@__PURE__*/$parcel$interopDefault($gGdnO))).from(()=>(parcelRequire("eknzC")));
function $0fbcf8d6af2d9dc2$export$c492b906e65561a0(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Mayachain"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $0fbcf8d6af2d9dc2$export$4396203deabecd(transport, msg) {
    const getAddr = new $9b53c374edf4eb8c$exports.MayachainGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    if (msg.testnet !== undefined) getAddr.setTestnet(msg.testnet);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_MAYACHAINGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const mayachainAddress = response.proto;
    return $7NkOr.mustBeDefined(mayachainAddress.getAddress());
}
async function $0fbcf8d6af2d9dc2$export$316aaf9a46bb31a5(transport, msg) {
    const address = await $0fbcf8d6af2d9dc2$export$4396203deabecd(transport, {
        addressNList: msg.addressNList
    });
    const getPublicKeyMsg = new $437b837d88ef5c30$exports.GetPublicKey();
    getPublicKeyMsg.setAddressNList(msg.addressNList);
    getPublicKeyMsg.setEcdsaCurveName("secp256k1");
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETPUBLICKEY, getPublicKeyMsg, {
        msgTimeout: $7NkOr.DEFAULT_TIMEOUT
    });
    const pubkeyMsg = response.proto;
    const pubkey = (0, (/*@__PURE__*/$parcel$interopDefault($1Vf4C))).decode($7NkOr.mustBeDefined(pubkeyMsg.getXpub())).slice(45);
    return transport.lockDuring(async ()=>{
        const signTx = new $9b53c374edf4eb8c$exports.MayachainSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setAccountNumber(msg.account_number);
        signTx.setChainId(msg.chain_id);
        signTx.setFeeAmount(parseInt(msg.tx.fee.amount[0].amount));
        signTx.setGas(parseInt(msg.tx.fee.gas));
        signTx.setSequence(msg.sequence);
        if (msg.tx.memo !== undefined) signTx.setMemo(msg.tx.memo);
        signTx.setMsgCount(1);
        let resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_MAYACHAINSIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        for (const m of msg.tx.msg){
            if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_MAYACHAINMSGREQUEST) throw new Error(`MAYAChain: unexpected response ${resp.message_type}`);
            let ack;
            if (m.type === "mayachain/MsgSend") {
                if (m.value.amount.length !== 1) throw new Error("MAYAChain: Multiple amounts per MsgSend not supported");
                const denom = m.value.amount[0].denom;
                if (denom !== "cacao") throw new Error("MAYAChain: Unsupported denomination: " + denom);
                const send = new $9b53c374edf4eb8c$exports.MayachainMsgSend();
                send.setFromAddress(m.value.from_address);
                send.setToAddress(m.value.to_address);
                send.setAmount(m.value.amount[0].amount);
                ack = new $9b53c374edf4eb8c$exports.MayachainMsgAck();
                ack.setSend(send);
            } else if (m.type === "mayachain/MsgDeposit") {
                if (m.value.coins.length !== 1) throw new Error("MAYAChain: Multiple amounts per MsgDeposit not supported");
                const coinAsset = m.value.coins[0].asset;
                if (coinAsset !== "MAYA.CACAO") throw new Error("MAYAChain: Unsupported coin asset: " + coinAsset);
                const deposit = new $9b53c374edf4eb8c$exports.MayachainMsgDeposit();
                deposit.setAsset(m.value.coins[0].asset);
                deposit.setAmount(m.value.coins[0].amount);
                deposit.setMemo(m.value.memo);
                deposit.setSigner(m.value.signer);
                ack = new $9b53c374edf4eb8c$exports.MayachainMsgAck();
                ack.setDeposit(deposit);
            } else throw new Error(`MAYAChain: Message ${m.type} is not yet supported`);
            resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_MAYACHAINMSGACK, ack, {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_MAYACHAINSIGNEDTX) throw new Error(`MAYAChain: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        const offlineSigner = {
            async getAccounts () {
                return [
                    {
                        address: address,
                        algo: "secp256k1",
                        pubkey: pubkey
                    }
                ];
            },
            async signAmino (signerAddress, signDoc) {
                if (signerAddress !== address) throw new Error("expected signerAddress to match address");
                return {
                    signed: signDoc,
                    signature: {
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: signedTx.getPublicKey_asB64()
                        },
                        signature: signedTx.getSignature_asB64()
                    }
                };
            }
        };
        const signerData = {
            sequence: Number(msg.sequence),
            accountNumber: Number(msg.account_number),
            chainId: msg.chain_id
        };
        return (await $0fbcf8d6af2d9dc2$var$protoTxBuilder).sign(address, msg.tx, offlineSigner, signerData, "maya");
    });
}



var $fe61df3a654f7174$exports = {};
// source: messages-osmosis.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $fe61df3a654f7174$var$goog = $2MzPv;
var $fe61df3a654f7174$var$global = (function() {
    return this || window || $fe61df3a654f7174$var$global || self || Function("return this")();
}).call(null);

$fe61df3a654f7174$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisAddress", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisGetAddress", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgAck", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgDelegate", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgIBCTransfer", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgLPAdd", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgLPRemove", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgLPStake", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgLPUnstake", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgRedelegate", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgRequest", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgRewards", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgSend", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgSwap", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisMsgUndelegate", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisSignTx", null, $fe61df3a654f7174$var$global);
$fe61df3a654f7174$var$goog.exportSymbol("proto.OsmosisSignedTx", null, $fe61df3a654f7174$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.OsmosisGetAddress.repeatedFields_, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisGetAddress, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisGetAddress.displayName = "proto.OsmosisGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisAddress, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisAddress.displayName = "proto.OsmosisAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.OsmosisSignTx.repeatedFields_, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisSignTx, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisSignTx.displayName = "proto.OsmosisSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgRequest, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgRequest.displayName = "proto.OsmosisMsgRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgAck, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgAck.displayName = "proto.OsmosisMsgAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgSend = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgSend, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgSend.displayName = "proto.OsmosisMsgSend";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgDelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgDelegate, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgDelegate.displayName = "proto.OsmosisMsgDelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgUndelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgUndelegate, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgUndelegate.displayName = "proto.OsmosisMsgUndelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgRedelegate = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgRedelegate, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgRedelegate.displayName = "proto.OsmosisMsgRedelegate";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgLPAdd = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgLPAdd, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgLPAdd.displayName = "proto.OsmosisMsgLPAdd";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgLPRemove = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgLPRemove, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgLPRemove.displayName = "proto.OsmosisMsgLPRemove";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgLPStake = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgLPStake, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgLPStake.displayName = "proto.OsmosisMsgLPStake";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgLPUnstake = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgLPUnstake, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgLPUnstake.displayName = "proto.OsmosisMsgLPUnstake";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgRewards = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgRewards, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgRewards.displayName = "proto.OsmosisMsgRewards";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgIBCTransfer = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgIBCTransfer, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgIBCTransfer.displayName = "proto.OsmosisMsgIBCTransfer";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisMsgSwap = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisMsgSwap, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisMsgSwap.displayName = "proto.OsmosisMsgSwap";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.OsmosisSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe61df3a654f7174$var$goog.inherits(proto.OsmosisSignedTx, $2MzPv.Message);
if ($fe61df3a654f7174$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.OsmosisSignedTx.displayName = "proto.OsmosisSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.OsmosisGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisGetAddress}
 */ proto.OsmosisGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisGetAddress;
    return proto.OsmosisGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisGetAddress}
 */ proto.OsmosisGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.OsmosisGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.OsmosisGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool testnet = 3;
 * @return {boolean}
 */ proto.OsmosisGetAddress.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisGetAddress} returns this
 */ proto.OsmosisGetAddress.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisGetAddress.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisAddress}
 */ proto.OsmosisAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisAddress;
    return proto.OsmosisAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisAddress}
 */ proto.OsmosisAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.OsmosisAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisAddress} returns this
 */ proto.OsmosisAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisAddress} returns this
 */ proto.OsmosisAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.OsmosisSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            accountNumber: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            feeAmount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            gas: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            msgCount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisSignTx}
 */ proto.OsmosisSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisSignTx;
    return proto.OsmosisSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisSignTx}
 */ proto.OsmosisSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setChainId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFeeAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGas(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSequence(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgCount(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeUint64String(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeBool(9, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.OsmosisSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint64 account_number = 2;
 * @return {string}
 */ proto.OsmosisSignTx.prototype.getAccountNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setAccountNumber = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearAccountNumber = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasAccountNumber = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string chain_id = 3;
 * @return {string}
 */ proto.OsmosisSignTx.prototype.getChainId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 fee_amount = 4;
 * @return {number}
 */ proto.OsmosisSignTx.prototype.getFeeAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setFeeAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearFeeAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasFeeAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 gas = 5;
 * @return {number}
 */ proto.OsmosisSignTx.prototype.getGas = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setGas = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearGas = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasGas = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string memo = 6;
 * @return {string}
 */ proto.OsmosisSignTx.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional uint64 sequence = 7;
 * @return {string}
 */ proto.OsmosisSignTx.prototype.getSequence = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 msg_count = 8;
 * @return {number}
 */ proto.OsmosisSignTx.prototype.getMsgCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setMsgCount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearMsgCount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasMsgCount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional bool testnet = 9;
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignTx} returns this
 */ proto.OsmosisSignTx.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignTx.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgRequest}
 */ proto.OsmosisMsgRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgRequest;
    return proto.OsmosisMsgRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgRequest}
 */ proto.OsmosisMsgRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgAck.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            send: (f = msg.getSend()) && proto.OsmosisMsgSend.toObject(includeInstance, f),
            delegate: (f = msg.getDelegate()) && proto.OsmosisMsgDelegate.toObject(includeInstance, f),
            undelegate: (f = msg.getUndelegate()) && proto.OsmosisMsgUndelegate.toObject(includeInstance, f),
            redelegate: (f = msg.getRedelegate()) && proto.OsmosisMsgRedelegate.toObject(includeInstance, f),
            rewards: (f = msg.getRewards()) && proto.OsmosisMsgRewards.toObject(includeInstance, f),
            lpAdd: (f = msg.getLpAdd()) && proto.OsmosisMsgLPAdd.toObject(includeInstance, f),
            lpRemove: (f = msg.getLpRemove()) && proto.OsmosisMsgLPRemove.toObject(includeInstance, f),
            lpStake: (f = msg.getLpStake()) && proto.OsmosisMsgLPStake.toObject(includeInstance, f),
            lpUnstake: (f = msg.getLpUnstake()) && proto.OsmosisMsgLPUnstake.toObject(includeInstance, f),
            ibcTransfer: (f = msg.getIbcTransfer()) && proto.OsmosisMsgIBCTransfer.toObject(includeInstance, f),
            swap: (f = msg.getSwap()) && proto.OsmosisMsgSwap.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgAck}
 */ proto.OsmosisMsgAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgAck;
    return proto.OsmosisMsgAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgAck}
 */ proto.OsmosisMsgAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.OsmosisMsgSend;
                reader.readMessage(value, proto.OsmosisMsgSend.deserializeBinaryFromReader);
                msg.setSend(value);
                break;
            case 2:
                var value = new proto.OsmosisMsgDelegate;
                reader.readMessage(value, proto.OsmosisMsgDelegate.deserializeBinaryFromReader);
                msg.setDelegate(value);
                break;
            case 3:
                var value = new proto.OsmosisMsgUndelegate;
                reader.readMessage(value, proto.OsmosisMsgUndelegate.deserializeBinaryFromReader);
                msg.setUndelegate(value);
                break;
            case 4:
                var value = new proto.OsmosisMsgRedelegate;
                reader.readMessage(value, proto.OsmosisMsgRedelegate.deserializeBinaryFromReader);
                msg.setRedelegate(value);
                break;
            case 5:
                var value = new proto.OsmosisMsgRewards;
                reader.readMessage(value, proto.OsmosisMsgRewards.deserializeBinaryFromReader);
                msg.setRewards(value);
                break;
            case 6:
                var value = new proto.OsmosisMsgLPAdd;
                reader.readMessage(value, proto.OsmosisMsgLPAdd.deserializeBinaryFromReader);
                msg.setLpAdd(value);
                break;
            case 7:
                var value = new proto.OsmosisMsgLPRemove;
                reader.readMessage(value, proto.OsmosisMsgLPRemove.deserializeBinaryFromReader);
                msg.setLpRemove(value);
                break;
            case 8:
                var value = new proto.OsmosisMsgLPStake;
                reader.readMessage(value, proto.OsmosisMsgLPStake.deserializeBinaryFromReader);
                msg.setLpStake(value);
                break;
            case 9:
                var value = new proto.OsmosisMsgLPUnstake;
                reader.readMessage(value, proto.OsmosisMsgLPUnstake.deserializeBinaryFromReader);
                msg.setLpUnstake(value);
                break;
            case 10:
                var value = new proto.OsmosisMsgIBCTransfer;
                reader.readMessage(value, proto.OsmosisMsgIBCTransfer.deserializeBinaryFromReader);
                msg.setIbcTransfer(value);
                break;
            case 11:
                var value = new proto.OsmosisMsgSwap;
                reader.readMessage(value, proto.OsmosisMsgSwap.deserializeBinaryFromReader);
                msg.setSwap(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSend();
    if (f != null) writer.writeMessage(1, f, proto.OsmosisMsgSend.serializeBinaryToWriter);
    f = message.getDelegate();
    if (f != null) writer.writeMessage(2, f, proto.OsmosisMsgDelegate.serializeBinaryToWriter);
    f = message.getUndelegate();
    if (f != null) writer.writeMessage(3, f, proto.OsmosisMsgUndelegate.serializeBinaryToWriter);
    f = message.getRedelegate();
    if (f != null) writer.writeMessage(4, f, proto.OsmosisMsgRedelegate.serializeBinaryToWriter);
    f = message.getRewards();
    if (f != null) writer.writeMessage(5, f, proto.OsmosisMsgRewards.serializeBinaryToWriter);
    f = message.getLpAdd();
    if (f != null) writer.writeMessage(6, f, proto.OsmosisMsgLPAdd.serializeBinaryToWriter);
    f = message.getLpRemove();
    if (f != null) writer.writeMessage(7, f, proto.OsmosisMsgLPRemove.serializeBinaryToWriter);
    f = message.getLpStake();
    if (f != null) writer.writeMessage(8, f, proto.OsmosisMsgLPStake.serializeBinaryToWriter);
    f = message.getLpUnstake();
    if (f != null) writer.writeMessage(9, f, proto.OsmosisMsgLPUnstake.serializeBinaryToWriter);
    f = message.getIbcTransfer();
    if (f != null) writer.writeMessage(10, f, proto.OsmosisMsgIBCTransfer.serializeBinaryToWriter);
    f = message.getSwap();
    if (f != null) writer.writeMessage(11, f, proto.OsmosisMsgSwap.serializeBinaryToWriter);
};
/**
 * optional OsmosisMsgSend send = 1;
 * @return {?proto.OsmosisMsgSend}
 */ proto.OsmosisMsgAck.prototype.getSend = function() {
    return /** @type{?proto.OsmosisMsgSend} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgSend, 1);
};
/**
 * @param {?proto.OsmosisMsgSend|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setSend = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearSend = function() {
    return this.setSend(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasSend = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional OsmosisMsgDelegate delegate = 2;
 * @return {?proto.OsmosisMsgDelegate}
 */ proto.OsmosisMsgAck.prototype.getDelegate = function() {
    return /** @type{?proto.OsmosisMsgDelegate} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgDelegate, 2);
};
/**
 * @param {?proto.OsmosisMsgDelegate|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setDelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearDelegate = function() {
    return this.setDelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasDelegate = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional OsmosisMsgUndelegate undelegate = 3;
 * @return {?proto.OsmosisMsgUndelegate}
 */ proto.OsmosisMsgAck.prototype.getUndelegate = function() {
    return /** @type{?proto.OsmosisMsgUndelegate} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgUndelegate, 3);
};
/**
 * @param {?proto.OsmosisMsgUndelegate|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setUndelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearUndelegate = function() {
    return this.setUndelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasUndelegate = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional OsmosisMsgRedelegate redelegate = 4;
 * @return {?proto.OsmosisMsgRedelegate}
 */ proto.OsmosisMsgAck.prototype.getRedelegate = function() {
    return /** @type{?proto.OsmosisMsgRedelegate} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgRedelegate, 4);
};
/**
 * @param {?proto.OsmosisMsgRedelegate|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setRedelegate = function(value) {
    return $2MzPv.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearRedelegate = function() {
    return this.setRedelegate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasRedelegate = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional OsmosisMsgRewards rewards = 5;
 * @return {?proto.OsmosisMsgRewards}
 */ proto.OsmosisMsgAck.prototype.getRewards = function() {
    return /** @type{?proto.OsmosisMsgRewards} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgRewards, 5);
};
/**
 * @param {?proto.OsmosisMsgRewards|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setRewards = function(value) {
    return $2MzPv.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearRewards = function() {
    return this.setRewards(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasRewards = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional OsmosisMsgLPAdd lp_add = 6;
 * @return {?proto.OsmosisMsgLPAdd}
 */ proto.OsmosisMsgAck.prototype.getLpAdd = function() {
    return /** @type{?proto.OsmosisMsgLPAdd} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgLPAdd, 6);
};
/**
 * @param {?proto.OsmosisMsgLPAdd|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setLpAdd = function(value) {
    return $2MzPv.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearLpAdd = function() {
    return this.setLpAdd(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasLpAdd = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional OsmosisMsgLPRemove lp_remove = 7;
 * @return {?proto.OsmosisMsgLPRemove}
 */ proto.OsmosisMsgAck.prototype.getLpRemove = function() {
    return /** @type{?proto.OsmosisMsgLPRemove} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgLPRemove, 7);
};
/**
 * @param {?proto.OsmosisMsgLPRemove|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setLpRemove = function(value) {
    return $2MzPv.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearLpRemove = function() {
    return this.setLpRemove(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasLpRemove = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional OsmosisMsgLPStake lp_stake = 8;
 * @return {?proto.OsmosisMsgLPStake}
 */ proto.OsmosisMsgAck.prototype.getLpStake = function() {
    return /** @type{?proto.OsmosisMsgLPStake} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgLPStake, 8);
};
/**
 * @param {?proto.OsmosisMsgLPStake|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setLpStake = function(value) {
    return $2MzPv.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearLpStake = function() {
    return this.setLpStake(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasLpStake = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional OsmosisMsgLPUnstake lp_unstake = 9;
 * @return {?proto.OsmosisMsgLPUnstake}
 */ proto.OsmosisMsgAck.prototype.getLpUnstake = function() {
    return /** @type{?proto.OsmosisMsgLPUnstake} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgLPUnstake, 9);
};
/**
 * @param {?proto.OsmosisMsgLPUnstake|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setLpUnstake = function(value) {
    return $2MzPv.Message.setWrapperField(this, 9, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearLpUnstake = function() {
    return this.setLpUnstake(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasLpUnstake = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
/**
 * optional OsmosisMsgIBCTransfer ibc_transfer = 10;
 * @return {?proto.OsmosisMsgIBCTransfer}
 */ proto.OsmosisMsgAck.prototype.getIbcTransfer = function() {
    return /** @type{?proto.OsmosisMsgIBCTransfer} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgIBCTransfer, 10);
};
/**
 * @param {?proto.OsmosisMsgIBCTransfer|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setIbcTransfer = function(value) {
    return $2MzPv.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearIbcTransfer = function() {
    return this.setIbcTransfer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasIbcTransfer = function() {
    return $2MzPv.Message.getField(this, 10) != null;
};
/**
 * optional OsmosisMsgSwap swap = 11;
 * @return {?proto.OsmosisMsgSwap}
 */ proto.OsmosisMsgAck.prototype.getSwap = function() {
    return /** @type{?proto.OsmosisMsgSwap} */ $2MzPv.Message.getWrapperField(this, proto.OsmosisMsgSwap, 11);
};
/**
 * @param {?proto.OsmosisMsgSwap|undefined} value
 * @return {!proto.OsmosisMsgAck} returns this
*/ proto.OsmosisMsgAck.prototype.setSwap = function(value) {
    return $2MzPv.Message.setWrapperField(this, 11, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.OsmosisMsgAck} returns this
 */ proto.OsmosisMsgAck.prototype.clearSwap = function() {
    return this.setSwap(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgAck.prototype.hasSwap = function() {
    return $2MzPv.Message.getField(this, 11) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgSend.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgSend.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgSend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgSend.toObject = function(includeInstance, msg) {
        var f, obj = {
            fromAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            toAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            addressType: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgSend}
 */ proto.OsmosisMsgSend.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgSend;
    return proto.OsmosisMsgSend.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgSend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgSend}
 */ proto.OsmosisMsgSend.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setFromAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setToAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            case 5:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgSend.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgSend.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgSend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgSend.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeEnum(5, f);
};
/**
 * optional string from_address = 1;
 * @return {string}
 */ proto.OsmosisMsgSend.prototype.getFromAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.setFromAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.clearFromAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSend.prototype.hasFromAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string to_address = 2;
 * @return {string}
 */ proto.OsmosisMsgSend.prototype.getToAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.setToAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.clearToAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSend.prototype.hasToAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string denom = 3;
 * @return {string}
 */ proto.OsmosisMsgSend.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSend.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string amount = 4;
 * @return {string}
 */ proto.OsmosisMsgSend.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSend.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional OutputAddressType address_type = 5;
 * @return {!proto.OutputAddressType}
 */ proto.OsmosisMsgSend.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSend} returns this
 */ proto.OsmosisMsgSend.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSend.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgDelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgDelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgDelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgDelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgDelegate}
 */ proto.OsmosisMsgDelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgDelegate;
    return proto.OsmosisMsgDelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgDelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgDelegate}
 */ proto.OsmosisMsgDelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgDelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgDelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgDelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgDelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.OsmosisMsgDelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgDelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.OsmosisMsgDelegate.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgDelegate.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string denom = 3;
 * @return {string}
 */ proto.OsmosisMsgDelegate.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgDelegate.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string amount = 4;
 * @return {string}
 */ proto.OsmosisMsgDelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgDelegate} returns this
 */ proto.OsmosisMsgDelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgDelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgUndelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgUndelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgUndelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgUndelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgUndelegate}
 */ proto.OsmosisMsgUndelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgUndelegate;
    return proto.OsmosisMsgUndelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgUndelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgUndelegate}
 */ proto.OsmosisMsgUndelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgUndelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgUndelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgUndelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgUndelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.OsmosisMsgUndelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgUndelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.OsmosisMsgUndelegate.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgUndelegate.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string denom = 3;
 * @return {string}
 */ proto.OsmosisMsgUndelegate.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgUndelegate.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string amount = 4;
 * @return {string}
 */ proto.OsmosisMsgUndelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgUndelegate} returns this
 */ proto.OsmosisMsgUndelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgUndelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgRedelegate.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgRedelegate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgRedelegate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRedelegate.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorSrcAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            validatorDstAddress: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgRedelegate}
 */ proto.OsmosisMsgRedelegate.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgRedelegate;
    return proto.OsmosisMsgRedelegate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgRedelegate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgRedelegate}
 */ proto.OsmosisMsgRedelegate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorSrcAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorDstAddress(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgRedelegate.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgRedelegate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgRedelegate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRedelegate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.OsmosisMsgRedelegate.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRedelegate.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_src_address = 2;
 * @return {string}
 */ proto.OsmosisMsgRedelegate.prototype.getValidatorSrcAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.setValidatorSrcAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.clearValidatorSrcAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRedelegate.prototype.hasValidatorSrcAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string validator_dst_address = 3;
 * @return {string}
 */ proto.OsmosisMsgRedelegate.prototype.getValidatorDstAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.setValidatorDstAddress = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.clearValidatorDstAddress = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRedelegate.prototype.hasValidatorDstAddress = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string denom = 4;
 * @return {string}
 */ proto.OsmosisMsgRedelegate.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRedelegate.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string amount = 5;
 * @return {string}
 */ proto.OsmosisMsgRedelegate.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRedelegate} returns this
 */ proto.OsmosisMsgRedelegate.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRedelegate.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgLPAdd.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgLPAdd.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgLPAdd} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPAdd.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            poolId: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            shareOutAmount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            denomInMaxA: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            amountInMaxA: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            denomInMaxB: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            amountInMaxB: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgLPAdd}
 */ proto.OsmosisMsgLPAdd.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgLPAdd;
    return proto.OsmosisMsgLPAdd.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgLPAdd} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgLPAdd}
 */ proto.OsmosisMsgLPAdd.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPoolId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setShareOutAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDenomInMaxA(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAmountInMaxA(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setDenomInMaxB(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setAmountInMaxB(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgLPAdd.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgLPAdd.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgLPAdd} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPAdd.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
};
/**
 * optional string sender = 1;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 pool_id = 2;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getPoolId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setPoolId = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearPoolId = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasPoolId = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string share_out_amount = 3;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getShareOutAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setShareOutAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearShareOutAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasShareOutAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string denom_in_max_a = 4;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getDenomInMaxA = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setDenomInMaxA = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearDenomInMaxA = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasDenomInMaxA = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string amount_in_max_a = 5;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getAmountInMaxA = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setAmountInMaxA = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearAmountInMaxA = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasAmountInMaxA = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string denom_in_max_b = 6;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getDenomInMaxB = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setDenomInMaxB = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearDenomInMaxB = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasDenomInMaxB = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string amount_in_max_b = 7;
 * @return {string}
 */ proto.OsmosisMsgLPAdd.prototype.getAmountInMaxB = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.setAmountInMaxB = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPAdd} returns this
 */ proto.OsmosisMsgLPAdd.prototype.clearAmountInMaxB = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPAdd.prototype.hasAmountInMaxB = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgLPRemove.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgLPRemove.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgLPRemove} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPRemove.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            poolId: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            shareInAmount: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            denomOutMinA: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            amountOutMinA: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            denomOutMinB: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            amountOutMinB: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgLPRemove}
 */ proto.OsmosisMsgLPRemove.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgLPRemove;
    return proto.OsmosisMsgLPRemove.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgLPRemove} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgLPRemove}
 */ proto.OsmosisMsgLPRemove.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPoolId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setShareInAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDenomOutMinA(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAmountOutMinA(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setDenomOutMinB(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setAmountOutMinB(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgLPRemove.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgLPRemove.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgLPRemove} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPRemove.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
};
/**
 * optional string sender = 1;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 pool_id = 2;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getPoolId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setPoolId = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearPoolId = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasPoolId = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string share_in_amount = 3;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getShareInAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setShareInAmount = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearShareInAmount = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasShareInAmount = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string denom_out_min_a = 4;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getDenomOutMinA = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setDenomOutMinA = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearDenomOutMinA = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasDenomOutMinA = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string amount_out_min_a = 5;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getAmountOutMinA = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setAmountOutMinA = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearAmountOutMinA = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasAmountOutMinA = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string denom_out_min_b = 6;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getDenomOutMinB = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setDenomOutMinB = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearDenomOutMinB = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasDenomOutMinB = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string amount_out_min_b = 7;
 * @return {string}
 */ proto.OsmosisMsgLPRemove.prototype.getAmountOutMinB = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.setAmountOutMinB = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPRemove} returns this
 */ proto.OsmosisMsgLPRemove.prototype.clearAmountOutMinB = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPRemove.prototype.hasAmountOutMinB = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgLPStake.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgLPStake.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgLPStake} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPStake.toObject = function(includeInstance, msg) {
        var f, obj = {
            owner: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            duration: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgLPStake}
 */ proto.OsmosisMsgLPStake.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgLPStake;
    return proto.OsmosisMsgLPStake.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgLPStake} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgLPStake}
 */ proto.OsmosisMsgLPStake.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOwner(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setDuration(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgLPStake.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgLPStake.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgLPStake} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPStake.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
};
/**
 * optional string owner = 1;
 * @return {string}
 */ proto.OsmosisMsgLPStake.prototype.getOwner = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.setOwner = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.clearOwner = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPStake.prototype.hasOwner = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 duration = 2;
 * @return {string}
 */ proto.OsmosisMsgLPStake.prototype.getDuration = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.setDuration = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.clearDuration = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPStake.prototype.hasDuration = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string denom = 4;
 * @return {string}
 */ proto.OsmosisMsgLPStake.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPStake.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string amount = 5;
 * @return {string}
 */ proto.OsmosisMsgLPStake.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPStake} returns this
 */ proto.OsmosisMsgLPStake.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPStake.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgLPUnstake.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgLPUnstake.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgLPUnstake} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPUnstake.toObject = function(includeInstance, msg) {
        var f, obj = {
            owner: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            id: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgLPUnstake}
 */ proto.OsmosisMsgLPUnstake.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgLPUnstake;
    return proto.OsmosisMsgLPUnstake.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgLPUnstake} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgLPUnstake}
 */ proto.OsmosisMsgLPUnstake.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOwner(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgLPUnstake.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgLPUnstake.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgLPUnstake} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgLPUnstake.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional string owner = 1;
 * @return {string}
 */ proto.OsmosisMsgLPUnstake.prototype.getOwner = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPUnstake} returns this
 */ proto.OsmosisMsgLPUnstake.prototype.setOwner = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPUnstake} returns this
 */ proto.OsmosisMsgLPUnstake.prototype.clearOwner = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPUnstake.prototype.hasOwner = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string id = 2;
 * @return {string}
 */ proto.OsmosisMsgLPUnstake.prototype.getId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgLPUnstake} returns this
 */ proto.OsmosisMsgLPUnstake.prototype.setId = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgLPUnstake} returns this
 */ proto.OsmosisMsgLPUnstake.prototype.clearId = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgLPUnstake.prototype.hasId = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgRewards.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgRewards.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgRewards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRewards.toObject = function(includeInstance, msg) {
        var f, obj = {
            delegatorAddress: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            validatorAddress: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgRewards}
 */ proto.OsmosisMsgRewards.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgRewards;
    return proto.OsmosisMsgRewards.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgRewards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgRewards}
 */ proto.OsmosisMsgRewards.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDelegatorAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValidatorAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgRewards.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgRewards.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgRewards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgRewards.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
};
/**
 * optional string delegator_address = 1;
 * @return {string}
 */ proto.OsmosisMsgRewards.prototype.getDelegatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRewards} returns this
 */ proto.OsmosisMsgRewards.prototype.setDelegatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRewards} returns this
 */ proto.OsmosisMsgRewards.prototype.clearDelegatorAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRewards.prototype.hasDelegatorAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string validator_address = 2;
 * @return {string}
 */ proto.OsmosisMsgRewards.prototype.getValidatorAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgRewards} returns this
 */ proto.OsmosisMsgRewards.prototype.setValidatorAddress = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgRewards} returns this
 */ proto.OsmosisMsgRewards.prototype.clearValidatorAddress = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgRewards.prototype.hasValidatorAddress = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgIBCTransfer.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgIBCTransfer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgIBCTransfer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgIBCTransfer.toObject = function(includeInstance, msg) {
        var f, obj = {
            sourcePort: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            sourceChannel: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            denom: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            sender: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            receiver: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            revisionNumber: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            revisionHeight: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgIBCTransfer}
 */ proto.OsmosisMsgIBCTransfer.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgIBCTransfer;
    return proto.OsmosisMsgIBCTransfer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgIBCTransfer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgIBCTransfer}
 */ proto.OsmosisMsgIBCTransfer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSourcePort(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceChannel(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDenom(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAmount(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setReceiver(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setRevisionNumber(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setRevisionHeight(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgIBCTransfer.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgIBCTransfer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgIBCTransfer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgIBCTransfer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeString(8, f);
};
/**
 * optional string source_port = 1;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getSourcePort = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setSourcePort = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearSourcePort = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasSourcePort = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string source_channel = 2;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getSourceChannel = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setSourceChannel = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearSourceChannel = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasSourceChannel = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string denom = 3;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setDenom = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearDenom = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasDenom = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string amount = 4;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string sender = 5;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string receiver = 6;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getReceiver = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setReceiver = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearReceiver = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasReceiver = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string revision_number = 7;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getRevisionNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setRevisionNumber = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearRevisionNumber = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasRevisionNumber = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional string revision_height = 8;
 * @return {string}
 */ proto.OsmosisMsgIBCTransfer.prototype.getRevisionHeight = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.setRevisionHeight = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgIBCTransfer} returns this
 */ proto.OsmosisMsgIBCTransfer.prototype.clearRevisionHeight = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgIBCTransfer.prototype.hasRevisionHeight = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisMsgSwap.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisMsgSwap.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisMsgSwap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgSwap.toObject = function(includeInstance, msg) {
        var f, obj = {
            sender: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            poolId: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            tokenOutDenom: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            tokenInDenom: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            tokenInAmount: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            tokenOutMinAmount: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisMsgSwap}
 */ proto.OsmosisMsgSwap.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisMsgSwap;
    return proto.OsmosisMsgSwap.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisMsgSwap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisMsgSwap}
 */ proto.OsmosisMsgSwap.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSender(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setPoolId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTokenOutDenom(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTokenInDenom(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTokenInAmount(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTokenOutMinAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisMsgSwap.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisMsgSwap.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisMsgSwap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisMsgSwap.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
};
/**
 * optional string sender = 1;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getSender = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setSender = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearSender = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasSender = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 pool_id = 2;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getPoolId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setPoolId = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearPoolId = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasPoolId = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string token_out_denom = 3;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getTokenOutDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setTokenOutDenom = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearTokenOutDenom = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasTokenOutDenom = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string token_in_denom = 4;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getTokenInDenom = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setTokenInDenom = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearTokenInDenom = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasTokenInDenom = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string token_in_amount = 5;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getTokenInAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setTokenInAmount = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearTokenInAmount = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasTokenInAmount = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string token_out_min_amount = 6;
 * @return {string}
 */ proto.OsmosisMsgSwap.prototype.getTokenOutMinAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.setTokenOutMinAmount = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisMsgSwap} returns this
 */ proto.OsmosisMsgSwap.prototype.clearTokenOutMinAmount = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisMsgSwap.prototype.hasTokenOutMinAmount = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.OsmosisSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.OsmosisSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.OsmosisSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            publicKey: msg.getPublicKey_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.OsmosisSignedTx}
 */ proto.OsmosisSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.OsmosisSignedTx;
    return proto.OsmosisSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.OsmosisSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.OsmosisSignedTx}
 */ proto.OsmosisSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.OsmosisSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.OsmosisSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.OsmosisSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.OsmosisSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes public_key = 1;
 * @return {!(string|Uint8Array)}
 */ proto.OsmosisSignedTx.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes public_key = 1;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.OsmosisSignedTx.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.OsmosisSignedTx.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.OsmosisSignedTx} returns this
 */ proto.OsmosisSignedTx.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignedTx} returns this
 */ proto.OsmosisSignedTx.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignedTx.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.OsmosisSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.OsmosisSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.OsmosisSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.OsmosisSignedTx} returns this
 */ proto.OsmosisSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.OsmosisSignedTx} returns this
 */ proto.OsmosisSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.OsmosisSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$fe61df3a654f7174$var$goog.object.extend($fe61df3a654f7174$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $1Vf4C = parcelRequire("1Vf4C");

var $gGdnO = parcelRequire("gGdnO");

const $a9300787f03269d5$var$protoTxBuilder = (0, (/*@__PURE__*/$parcel$interopDefault($gGdnO))).from(()=>(parcelRequire("eknzC")));
function $a9300787f03269d5$export$63b95deac2d9ec2e(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Osmo"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $a9300787f03269d5$export$e0d19f858238e335(transport, msg) {
    const getAddr = new $fe61df3a654f7174$exports.OsmosisGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_OSMOSISGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const osmosisAddress = response.proto;
    return $7NkOr.mustBeDefined(osmosisAddress.getAddress());
}
async function $a9300787f03269d5$export$a287510f3e061a50(transport, msg) {
    const address = await $a9300787f03269d5$export$e0d19f858238e335(transport, {
        addressNList: msg.addressNList,
        showDisplay: false
    });
    const getPublicKeyMsg = new $437b837d88ef5c30$exports.GetPublicKey();
    getPublicKeyMsg.setAddressNList(msg.addressNList);
    getPublicKeyMsg.setEcdsaCurveName("secp256k1");
    const pubkeyMsg = (await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETPUBLICKEY, getPublicKeyMsg, {
        msgTimeout: $7NkOr.DEFAULT_TIMEOUT
    })).proto;
    const pubkey = $1Vf4C.decode($7NkOr.mustBeDefined(pubkeyMsg.getXpub())).slice(45);
    return transport.lockDuring(async ()=>{
        const signTx = new $fe61df3a654f7174$exports.OsmosisSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setAccountNumber(msg.account_number);
        signTx.setChainId(msg.chain_id);
        signTx.setFeeAmount(parseInt(msg.tx.fee.amount[0].amount));
        signTx.setGas(parseInt(msg.tx.fee.gas));
        signTx.setSequence(msg.sequence);
        if (msg.tx.memo !== undefined) signTx.setMemo(msg.tx.memo);
        signTx.setMsgCount(1);
        let resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_OSMOSISSIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        for (const m of msg.tx.msg){
            if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_OSMOSISMSGREQUEST) throw new Error(`osmosis: unexpected response ${resp.message_type}`);
            let ack;
            switch(m.type){
                case "cosmos-sdk/MsgSend":
                    {
                        // Transfer
                        if (m.value.amount.length !== 1) throw new Error("osmosis: Multiple amounts per msg not supported");
                        const denom = m.value.amount[0].denom;
                        if (denom !== "uosmo") throw new Error("osmosis: Unsupported denomination: " + denom);
                        const send = new $fe61df3a654f7174$exports.OsmosisMsgSend();
                        send.setFromAddress(m.value.from_address);
                        send.setToAddress(m.value.to_address);
                        send.setDenom(m.value.amount[0].denom);
                        send.setAmount(m.value.amount[0].amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setSend(send);
                        break;
                    }
                case "cosmos-sdk/MsgDelegate":
                    {
                        // Delegate
                        const denom = m.value.amount.denom;
                        if (denom !== "uosmo") throw new Error("osmosis: Unsupported denomination: " + denom);
                        const delegate = new $fe61df3a654f7174$exports.OsmosisMsgDelegate();
                        delegate.setDelegatorAddress(m.value.delegator_address);
                        delegate.setValidatorAddress(m.value.validator_address);
                        delegate.setDenom(m.value.amount.denom);
                        delegate.setAmount(m.value.amount.amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setDelegate(delegate);
                        break;
                    }
                case "cosmos-sdk/MsgUndelegate":
                    {
                        // Undelegate
                        const denom = m.value.amount.denom;
                        if (denom !== "uosmo") throw new Error("osmosis: Unsupported denomination: " + denom);
                        const undelegate = new $fe61df3a654f7174$exports.OsmosisMsgUndelegate();
                        undelegate.setDelegatorAddress(m.value.delegator_address);
                        undelegate.setValidatorAddress(m.value.validator_address);
                        undelegate.setDenom(m.value.amount.denom);
                        undelegate.setAmount(m.value.amount.amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setUndelegate(undelegate);
                        break;
                    }
                case "cosmos-sdk/MsgBeginRedelegate":
                    {
                        // Redelegate
                        const denom = m.value.amount.denom;
                        if (denom !== "uosmo") throw new Error("osmosis: Unsupported denomination: " + denom);
                        const redelegate = new $fe61df3a654f7174$exports.OsmosisMsgRedelegate();
                        redelegate.setDelegatorAddress(m.value.delegator_address);
                        redelegate.setValidatorSrcAddress(m.value.validator_src_address);
                        redelegate.setValidatorDstAddress(m.value.validator_dst_address);
                        redelegate.setAmount(m.value.amount.amount);
                        redelegate.setDenom(m.value.amount.denom);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setRedelegate(redelegate);
                        break;
                    }
                case "cosmos-sdk/MsgWithdrawDelegationReward":
                    {
                        // Rewards
                        const rewards = new $fe61df3a654f7174$exports.OsmosisMsgRewards();
                        rewards.setDelegatorAddress(m.value.delegator_address);
                        rewards.setValidatorAddress(m.value.validator_address);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setRewards(rewards);
                        break;
                    }
                case "osmosis/gamm/join-pool":
                    {
                        // LP add
                        const lpAdd = new $fe61df3a654f7174$exports.OsmosisMsgLPAdd();
                        lpAdd.setSender(m.value.sender);
                        lpAdd.setPoolId(m.value.pool_id);
                        lpAdd.setShareOutAmount(m.value.share_out_amount);
                        lpAdd.setDenomInMaxA(m.value.token_in_maxs[0].denom);
                        lpAdd.setAmountInMaxA(m.value.token_in_maxs[0].amount);
                        lpAdd.setDenomInMaxB(m.value.token_in_maxs[1].denom);
                        lpAdd.setAmountInMaxB(m.value.token_in_maxs[1].amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setLpAdd(lpAdd);
                        break;
                    }
                case "osmosis/gamm/exit-pool":
                    {
                        // LP remove
                        const lpRemove = new $fe61df3a654f7174$exports.OsmosisMsgLPRemove();
                        lpRemove.setSender(m.value.sender);
                        lpRemove.setPoolId(m.value.pool_id);
                        lpRemove.setShareInAmount(m.value.share_in_amount);
                        lpRemove.setDenomOutMinA(m.value.token_out_mins[0].denom);
                        lpRemove.setAmountOutMinA(m.value.token_out_mins[0].amount);
                        lpRemove.setDenomOutMinB(m.value.token_out_mins[1].denom);
                        lpRemove.setAmountOutMinB(m.value.token_out_mins[1].amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setLpRemove(lpRemove);
                        break;
                    }
                case "cosmos-sdk/MsgTransfer":
                    {
                        // IBC Transfer
                        const ibcTransfer = new $fe61df3a654f7174$exports.OsmosisMsgIBCTransfer();
                        ibcTransfer.setReceiver(m.value.receiver);
                        ibcTransfer.setSender(m.value.sender);
                        ibcTransfer.setSourceChannel(m.value.source_channel);
                        ibcTransfer.setSourcePort(m.value.source_port);
                        ibcTransfer.setRevisionHeight(m.value.timeout_height.revision_height);
                        ibcTransfer.setRevisionNumber(m.value.timeout_height.revision_number);
                        ibcTransfer.setAmount(m.value.token.amount);
                        ibcTransfer.setDenom(m.value.token.denom);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setIbcTransfer(ibcTransfer);
                        break;
                    }
                case "osmosis/gamm/swap-exact-amount-in":
                    {
                        // Swap
                        const swap = new $fe61df3a654f7174$exports.OsmosisMsgSwap();
                        swap.setSender(m.value.sender);
                        swap.setPoolId(m.value.routes[0].pool_id);
                        swap.setTokenOutDenom(m.value.routes[0].token_out_denom);
                        swap.setTokenInDenom(m.value.token_in.denom);
                        swap.setTokenInAmount(m.value.token_in.amount);
                        swap.setTokenOutMinAmount(m.value.token_out_min_amount);
                        ack = new $fe61df3a654f7174$exports.OsmosisMsgAck();
                        ack.setSwap(swap);
                        break;
                    }
                default:
                    throw new Error(`osmosis: Message ${m.type} is not yet supported`);
            }
            resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_OSMOSISMSGACK, ack, {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_OSMOSISSIGNEDTX) throw new Error(`osmosis: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        const offlineSigner = {
            async getAccounts () {
                return [
                    {
                        address: address,
                        algo: "secp256k1",
                        pubkey: pubkey
                    }
                ];
            },
            async signAmino (signerAddress, signDoc) {
                if (signerAddress !== address) throw new Error("expected signerAddress to match address");
                return {
                    signed: signDoc,
                    signature: {
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: signedTx.getPublicKey_asB64()
                        },
                        signature: signedTx.getSignature_asB64()
                    }
                };
            }
        };
        const signerData = {
            sequence: Number(msg.sequence),
            accountNumber: Number(msg.account_number),
            chainId: msg.chain_id
        };
        return (await $a9300787f03269d5$var$protoTxBuilder).sign(address, (0, $7NkOr.sortTxFields)(msg.tx), offlineSigner, signerData);
    });
}



var $fe559938afeeabdc$exports = {};
// source: messages-ripple.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $fe559938afeeabdc$var$goog = $2MzPv;
var $fe559938afeeabdc$var$global = (function() {
    return this || window || $fe559938afeeabdc$var$global || self || Function("return this")();
}).call(null);
$fe559938afeeabdc$var$goog.exportSymbol("proto.RippleAddress", null, $fe559938afeeabdc$var$global);
$fe559938afeeabdc$var$goog.exportSymbol("proto.RippleGetAddress", null, $fe559938afeeabdc$var$global);
$fe559938afeeabdc$var$goog.exportSymbol("proto.RipplePayment", null, $fe559938afeeabdc$var$global);
$fe559938afeeabdc$var$goog.exportSymbol("proto.RippleSignTx", null, $fe559938afeeabdc$var$global);
$fe559938afeeabdc$var$goog.exportSymbol("proto.RippleSignedTx", null, $fe559938afeeabdc$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RippleGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.RippleGetAddress.repeatedFields_, null);
};
$fe559938afeeabdc$var$goog.inherits(proto.RippleGetAddress, $2MzPv.Message);
if ($fe559938afeeabdc$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RippleGetAddress.displayName = "proto.RippleGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RippleAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe559938afeeabdc$var$goog.inherits(proto.RippleAddress, $2MzPv.Message);
if ($fe559938afeeabdc$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RippleAddress.displayName = "proto.RippleAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RippleSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.RippleSignTx.repeatedFields_, null);
};
$fe559938afeeabdc$var$goog.inherits(proto.RippleSignTx, $2MzPv.Message);
if ($fe559938afeeabdc$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RippleSignTx.displayName = "proto.RippleSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RipplePayment = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe559938afeeabdc$var$goog.inherits(proto.RipplePayment, $2MzPv.Message);
if ($fe559938afeeabdc$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RipplePayment.displayName = "proto.RipplePayment";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.RippleSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$fe559938afeeabdc$var$goog.inherits(proto.RippleSignedTx, $2MzPv.Message);
if ($fe559938afeeabdc$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.RippleSignedTx.displayName = "proto.RippleSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.RippleGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RippleGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.RippleGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RippleGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RippleGetAddress}
 */ proto.RippleGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RippleGetAddress;
    return proto.RippleGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RippleGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RippleGetAddress}
 */ proto.RippleGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RippleGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RippleGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RippleGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.RippleGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.RippleGetAddress} returns this
 */ proto.RippleGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.RippleGetAddress} returns this
 */ proto.RippleGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.RippleGetAddress} returns this
 */ proto.RippleGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.RippleGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.RippleGetAddress} returns this
 */ proto.RippleGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleGetAddress} returns this
 */ proto.RippleGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RippleAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.RippleAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RippleAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RippleAddress}
 */ proto.RippleAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RippleAddress;
    return proto.RippleAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RippleAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RippleAddress}
 */ proto.RippleAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RippleAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RippleAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RippleAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.RippleAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.RippleAddress} returns this
 */ proto.RippleAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleAddress} returns this
 */ proto.RippleAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.RippleSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RippleSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.RippleSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RippleSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            fee: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            flags: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            lastLedgerSequence: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            payment: (f = msg.getPayment()) && proto.RipplePayment.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RippleSignTx}
 */ proto.RippleSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RippleSignTx;
    return proto.RippleSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RippleSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RippleSignTx}
 */ proto.RippleSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint64();
                msg.setFee(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFlags(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setSequence(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLastLedgerSequence(value);
                break;
            case 6:
                var value = new proto.RipplePayment;
                reader.readMessage(value, proto.RipplePayment.deserializeBinaryFromReader);
                msg.setPayment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RippleSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RippleSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RippleSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = message.getPayment();
    if (f != null) writer.writeMessage(6, f, proto.RipplePayment.serializeBinaryToWriter);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.RippleSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint64 fee = 2;
 * @return {number}
 */ proto.RippleSignTx.prototype.getFee = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.setFee = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearFee = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignTx.prototype.hasFee = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 flags = 3;
 * @return {number}
 */ proto.RippleSignTx.prototype.getFlags = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.setFlags = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearFlags = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignTx.prototype.hasFlags = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 sequence = 4;
 * @return {number}
 */ proto.RippleSignTx.prototype.getSequence = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 last_ledger_sequence = 5;
 * @return {number}
 */ proto.RippleSignTx.prototype.getLastLedgerSequence = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.setLastLedgerSequence = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearLastLedgerSequence = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignTx.prototype.hasLastLedgerSequence = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional RipplePayment payment = 6;
 * @return {?proto.RipplePayment}
 */ proto.RippleSignTx.prototype.getPayment = function() {
    return /** @type{?proto.RipplePayment} */ $2MzPv.Message.getWrapperField(this, proto.RipplePayment, 6);
};
/**
 * @param {?proto.RipplePayment|undefined} value
 * @return {!proto.RippleSignTx} returns this
*/ proto.RippleSignTx.prototype.setPayment = function(value) {
    return $2MzPv.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.RippleSignTx} returns this
 */ proto.RippleSignTx.prototype.clearPayment = function() {
    return this.setPayment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignTx.prototype.hasPayment = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RipplePayment.prototype.toObject = function(opt_includeInstance) {
        return proto.RipplePayment.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RipplePayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RipplePayment.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            destination: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            destinationTag: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RipplePayment}
 */ proto.RipplePayment.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RipplePayment;
    return proto.RipplePayment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RipplePayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RipplePayment}
 */ proto.RipplePayment.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint64();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDestination(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDestinationTag(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RipplePayment.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RipplePayment.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RipplePayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RipplePayment.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {number} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeUint64(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeUint32(3, f);
};
/**
 * optional uint64 amount = 1;
 * @return {number}
 */ proto.RipplePayment.prototype.getAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RipplePayment.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional string destination = 2;
 * @return {string}
 */ proto.RipplePayment.prototype.getDestination = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.setDestination = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.clearDestination = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RipplePayment.prototype.hasDestination = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional uint32 destination_tag = 3;
 * @return {number}
 */ proto.RipplePayment.prototype.getDestinationTag = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.setDestinationTag = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RipplePayment} returns this
 */ proto.RipplePayment.prototype.clearDestinationTag = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RipplePayment.prototype.hasDestinationTag = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.RippleSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.RippleSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.RippleSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            signature: msg.getSignature_asB64(),
            serializedTx: msg.getSerializedTx_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.RippleSignedTx}
 */ proto.RippleSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.RippleSignedTx;
    return proto.RippleSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.RippleSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.RippleSignedTx}
 */ proto.RippleSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSerializedTx(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.RippleSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.RippleSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.RippleSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.RippleSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes signature = 1;
 * @return {!(string|Uint8Array)}
 */ proto.RippleSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes signature = 1;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.RippleSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.RippleSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.RippleSignedTx} returns this
 */ proto.RippleSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignedTx} returns this
 */ proto.RippleSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes serialized_tx = 2;
 * @return {!(string|Uint8Array)}
 */ proto.RippleSignedTx.prototype.getSerializedTx = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes serialized_tx = 2;
 * This is a type-conversion wrapper around `getSerializedTx()`
 * @return {string}
 */ proto.RippleSignedTx.prototype.getSerializedTx_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSerializedTx());
};
/**
 * optional bytes serialized_tx = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSerializedTx()`
 * @return {!Uint8Array}
 */ proto.RippleSignedTx.prototype.getSerializedTx_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSerializedTx());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.RippleSignedTx} returns this
 */ proto.RippleSignedTx.prototype.setSerializedTx = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.RippleSignedTx} returns this
 */ proto.RippleSignedTx.prototype.clearSerializedTx = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.RippleSignedTx.prototype.hasSerializedTx = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$fe559938afeeabdc$var$goog.object.extend($fe559938afeeabdc$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $kEUo3 = parcelRequire("kEUo3");
function $cde9fec45a163105$export$8a64695de5385be0(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Ripple"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $cde9fec45a163105$export$39da8e0971833dd7(transport, msg) {
    return transport.lockDuring(async ()=>{
        const signTx = new $fe559938afeeabdc$exports.RippleSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setFee(parseInt(msg.tx.value.fee.amount[0].amount));
        signTx.setSequence(parseInt(msg.sequence));
        signTx.setLastLedgerSequence(parseInt(msg.lastLedgerSequence));
        const payment = new $fe559938afeeabdc$exports.RipplePayment();
        payment.setAmount(parseInt(msg.payment.amount));
        payment.setDestination(msg.payment.destination);
        if (msg.payment.destinationTag !== undefined) payment.setDestinationTag(parseInt(msg.payment.destinationTag));
        signTx.setPayment(payment);
        const resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_RIPPLESIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        for (const m of msg.tx.value.msg){
            if (m.type === "ripple-sdk/MsgSend") {
                if (m.value.amount.length !== 1) throw new Error("ripple: Multiple amounts per msg not supported");
                const denom = m.value.amount[0].denom;
                if (denom !== "drop") throw new Error("ripple: Unsupported denomination: " + denom);
            } else throw new Error(`ripple: Message ${m.type} is not yet supported`);
        }
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_RIPPLESIGNEDTX) throw new Error(`ripple: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        const signed = (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).cloneDeep(msg.tx);
        signed.value.signatures = [
            {
                serializedTx: signedTx.getSerializedTx_asB64(),
                signature: signedTx.getSignature_asB64()
            }
        ];
        return signed;
    });
}
async function $cde9fec45a163105$export$d1679ca16e9d8669(transport, msg) {
    const getAddr = new $fe559938afeeabdc$exports.RippleGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_RIPPLEGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const rippleAddress = response.proto;
    return $7NkOr.mustBeDefined(rippleAddress.getAddress());
}



var $ed39b9d9c224f2ab$exports = {};
// source: messages-thorchain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $ed39b9d9c224f2ab$var$goog = $2MzPv;
var $ed39b9d9c224f2ab$var$global = (function() {
    return this || window || $ed39b9d9c224f2ab$var$global || self || Function("return this")();
}).call(null);

$ed39b9d9c224f2ab$var$goog.object.extend(proto, $d4cdf7121546d3d6$exports);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainAddress", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainGetAddress", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainMsgAck", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainMsgDeposit", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainMsgRequest", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainMsgSend", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainSignTx", null, $ed39b9d9c224f2ab$var$global);
$ed39b9d9c224f2ab$var$goog.exportSymbol("proto.ThorchainSignedTx", null, $ed39b9d9c224f2ab$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.ThorchainGetAddress.repeatedFields_, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainGetAddress, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainGetAddress.displayName = "proto.ThorchainGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainAddress, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainAddress.displayName = "proto.ThorchainAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.ThorchainSignTx.repeatedFields_, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainSignTx, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainSignTx.displayName = "proto.ThorchainSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainMsgRequest = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainMsgRequest, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainMsgRequest.displayName = "proto.ThorchainMsgRequest";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainMsgAck = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainMsgAck, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainMsgAck.displayName = "proto.ThorchainMsgAck";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainMsgSend = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainMsgSend, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainMsgSend.displayName = "proto.ThorchainMsgSend";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainMsgDeposit = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainMsgDeposit, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainMsgDeposit.displayName = "proto.ThorchainMsgDeposit";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.ThorchainSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$ed39b9d9c224f2ab$var$goog.inherits(proto.ThorchainSignedTx, $2MzPv.Message);
if ($ed39b9d9c224f2ab$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.ThorchainSignedTx.displayName = "proto.ThorchainSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.ThorchainGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 2)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainGetAddress}
 */ proto.ThorchainGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainGetAddress;
    return proto.ThorchainGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainGetAddress}
 */ proto.ThorchainGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.ThorchainGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional bool show_display = 2;
 * @return {boolean}
 */ proto.ThorchainGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool testnet = 3;
 * @return {boolean}
 */ proto.ThorchainGetAddress.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainGetAddress} returns this
 */ proto.ThorchainGetAddress.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainGetAddress.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainAddress}
 */ proto.ThorchainAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainAddress;
    return proto.ThorchainAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainAddress}
 */ proto.ThorchainAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.ThorchainAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainAddress} returns this
 */ proto.ThorchainAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainAddress} returns this
 */ proto.ThorchainAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.ThorchainSignTx.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            accountNumber: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            chainId: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            feeAmount: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            gas: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            sequence: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            msgCount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            testnet: (f = $2MzPv.Message.getBooleanField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainSignTx}
 */ proto.ThorchainSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainSignTx;
    return proto.ThorchainSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainSignTx}
 */ proto.ThorchainSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setChainId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readUint32();
                msg.setFeeAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readUint32();
                msg.setGas(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setSequence(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMsgCount(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTestnet(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeUint32(4, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeUint32(5, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeUint64String(7, f);
    f = /** @type {number} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint32(8, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeBool(9, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.ThorchainSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional uint64 account_number = 2;
 * @return {string}
 */ proto.ThorchainSignTx.prototype.getAccountNumber = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setAccountNumber = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearAccountNumber = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasAccountNumber = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string chain_id = 3;
 * @return {string}
 */ proto.ThorchainSignTx.prototype.getChainId = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setChainId = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearChainId = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasChainId = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional uint32 fee_amount = 4;
 * @return {number}
 */ proto.ThorchainSignTx.prototype.getFeeAmount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setFeeAmount = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearFeeAmount = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasFeeAmount = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional uint32 gas = 5;
 * @return {number}
 */ proto.ThorchainSignTx.prototype.getGas = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setGas = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearGas = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasGas = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * optional string memo = 6;
 * @return {string}
 */ proto.ThorchainSignTx.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional uint64 sequence = 7;
 * @return {string}
 */ proto.ThorchainSignTx.prototype.getSequence = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "0");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setSequence = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearSequence = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasSequence = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint32 msg_count = 8;
 * @return {number}
 */ proto.ThorchainSignTx.prototype.getMsgCount = function() {
    return /** @type {number} */ $2MzPv.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setMsgCount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearMsgCount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasMsgCount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional bool testnet = 9;
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.getTestnet = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.setTestnet = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignTx} returns this
 */ proto.ThorchainSignTx.prototype.clearTestnet = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignTx.prototype.hasTestnet = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainMsgRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainMsgRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainMsgRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainMsgRequest}
 */ proto.ThorchainMsgRequest.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainMsgRequest;
    return proto.ThorchainMsgRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainMsgRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainMsgRequest}
 */ proto.ThorchainMsgRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainMsgRequest.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainMsgRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainMsgRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainMsgAck.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainMsgAck.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainMsgAck} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgAck.toObject = function(includeInstance, msg) {
        var f, obj = {
            send: (f = msg.getSend()) && proto.ThorchainMsgSend.toObject(includeInstance, f),
            deposit: (f = msg.getDeposit()) && proto.ThorchainMsgDeposit.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainMsgAck}
 */ proto.ThorchainMsgAck.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainMsgAck;
    return proto.ThorchainMsgAck.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainMsgAck} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainMsgAck}
 */ proto.ThorchainMsgAck.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.ThorchainMsgSend;
                reader.readMessage(value, proto.ThorchainMsgSend.deserializeBinaryFromReader);
                msg.setSend(value);
                break;
            case 2:
                var value = new proto.ThorchainMsgDeposit;
                reader.readMessage(value, proto.ThorchainMsgDeposit.deserializeBinaryFromReader);
                msg.setDeposit(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainMsgAck.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainMsgAck.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainMsgAck} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgAck.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSend();
    if (f != null) writer.writeMessage(1, f, proto.ThorchainMsgSend.serializeBinaryToWriter);
    f = message.getDeposit();
    if (f != null) writer.writeMessage(2, f, proto.ThorchainMsgDeposit.serializeBinaryToWriter);
};
/**
 * optional ThorchainMsgSend send = 1;
 * @return {?proto.ThorchainMsgSend}
 */ proto.ThorchainMsgAck.prototype.getSend = function() {
    return /** @type{?proto.ThorchainMsgSend} */ $2MzPv.Message.getWrapperField(this, proto.ThorchainMsgSend, 1);
};
/**
 * @param {?proto.ThorchainMsgSend|undefined} value
 * @return {!proto.ThorchainMsgAck} returns this
*/ proto.ThorchainMsgAck.prototype.setSend = function(value) {
    return $2MzPv.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.ThorchainMsgAck} returns this
 */ proto.ThorchainMsgAck.prototype.clearSend = function() {
    return this.setSend(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgAck.prototype.hasSend = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional ThorchainMsgDeposit deposit = 2;
 * @return {?proto.ThorchainMsgDeposit}
 */ proto.ThorchainMsgAck.prototype.getDeposit = function() {
    return /** @type{?proto.ThorchainMsgDeposit} */ $2MzPv.Message.getWrapperField(this, proto.ThorchainMsgDeposit, 2);
};
/**
 * @param {?proto.ThorchainMsgDeposit|undefined} value
 * @return {!proto.ThorchainMsgAck} returns this
*/ proto.ThorchainMsgAck.prototype.setDeposit = function(value) {
    return $2MzPv.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.ThorchainMsgAck} returns this
 */ proto.ThorchainMsgAck.prototype.clearDeposit = function() {
    return this.setDeposit(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgAck.prototype.hasDeposit = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainMsgSend.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainMsgSend.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainMsgSend} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgSend.toObject = function(includeInstance, msg) {
        var f, obj = {
            fromAddress: (f = $2MzPv.Message.getField(msg, 6)) == null ? undefined : f,
            toAddress: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 8)) == null ? undefined : f,
            addressType: (f = $2MzPv.Message.getField(msg, 9)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainMsgSend}
 */ proto.ThorchainMsgSend.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainMsgSend;
    return proto.ThorchainMsgSend.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainMsgSend} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainMsgSend}
 */ proto.ThorchainMsgSend.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setFromAddress(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setToAddress(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {!proto.OutputAddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainMsgSend.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainMsgSend.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainMsgSend} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgSend.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeUint64String(8, f);
    f = /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getField(message, 9);
    if (f != null) writer.writeEnum(9, f);
};
/**
 * optional string from_address = 6;
 * @return {string}
 */ proto.ThorchainMsgSend.prototype.getFromAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.setFromAddress = function(value) {
    return $2MzPv.Message.setField(this, 6, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.clearFromAddress = function() {
    return $2MzPv.Message.setField(this, 6, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgSend.prototype.hasFromAddress = function() {
    return $2MzPv.Message.getField(this, 6) != null;
};
/**
 * optional string to_address = 7;
 * @return {string}
 */ proto.ThorchainMsgSend.prototype.getToAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.setToAddress = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.clearToAddress = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgSend.prototype.hasToAddress = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional uint64 amount = 8;
 * @return {string}
 */ proto.ThorchainMsgSend.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 8, "0");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgSend.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
/**
 * optional OutputAddressType address_type = 9;
 * @return {!proto.OutputAddressType}
 */ proto.ThorchainMsgSend.prototype.getAddressType = function() {
    return /** @type {!proto.OutputAddressType} */ $2MzPv.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.OutputAddressType} value
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.setAddressType = function(value) {
    return $2MzPv.Message.setField(this, 9, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgSend} returns this
 */ proto.ThorchainMsgSend.prototype.clearAddressType = function() {
    return $2MzPv.Message.setField(this, 9, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgSend.prototype.hasAddressType = function() {
    return $2MzPv.Message.getField(this, 9) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainMsgDeposit.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainMsgDeposit.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainMsgDeposit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgDeposit.toObject = function(includeInstance, msg) {
        var f, obj = {
            asset: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f,
            amount: (f = $2MzPv.Message.getField(msg, 2)) == null ? undefined : f,
            memo: (f = $2MzPv.Message.getField(msg, 3)) == null ? undefined : f,
            signer: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainMsgDeposit}
 */ proto.ThorchainMsgDeposit.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainMsgDeposit;
    return proto.ThorchainMsgDeposit.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainMsgDeposit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainMsgDeposit}
 */ proto.ThorchainMsgDeposit.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAsset(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readUint64String();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMemo(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSigner(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainMsgDeposit.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainMsgDeposit.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainMsgDeposit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainMsgDeposit.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeUint64String(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
};
/**
 * optional string asset = 1;
 * @return {string}
 */ proto.ThorchainMsgDeposit.prototype.getAsset = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.setAsset = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.clearAsset = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgDeposit.prototype.hasAsset = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional uint64 amount = 2;
 * @return {string}
 */ proto.ThorchainMsgDeposit.prototype.getAmount = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "0");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.setAmount = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.clearAmount = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgDeposit.prototype.hasAmount = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string memo = 3;
 * @return {string}
 */ proto.ThorchainMsgDeposit.prototype.getMemo = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.setMemo = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.clearMemo = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgDeposit.prototype.hasMemo = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional string signer = 4;
 * @return {string}
 */ proto.ThorchainMsgDeposit.prototype.getSigner = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.setSigner = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainMsgDeposit} returns this
 */ proto.ThorchainMsgDeposit.prototype.clearSigner = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainMsgDeposit.prototype.hasSigner = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.ThorchainSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.ThorchainSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.ThorchainSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            publicKey: msg.getPublicKey_asB64(),
            signature: msg.getSignature_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.ThorchainSignedTx}
 */ proto.ThorchainSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.ThorchainSignedTx;
    return proto.ThorchainSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.ThorchainSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.ThorchainSignedTx}
 */ proto.ThorchainSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPublicKey(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.ThorchainSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.ThorchainSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.ThorchainSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.ThorchainSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes public_key = 1;
 * @return {!(string|Uint8Array)}
 */ proto.ThorchainSignedTx.prototype.getPublicKey = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes public_key = 1;
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {string}
 */ proto.ThorchainSignedTx.prototype.getPublicKey_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getPublicKey());
};
/**
 * optional bytes public_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPublicKey()`
 * @return {!Uint8Array}
 */ proto.ThorchainSignedTx.prototype.getPublicKey_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getPublicKey());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ThorchainSignedTx} returns this
 */ proto.ThorchainSignedTx.prototype.setPublicKey = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignedTx} returns this
 */ proto.ThorchainSignedTx.prototype.clearPublicKey = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignedTx.prototype.hasPublicKey = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes signature = 2;
 * @return {!(string|Uint8Array)}
 */ proto.ThorchainSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes signature = 2;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.ThorchainSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.ThorchainSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.ThorchainSignedTx} returns this
 */ proto.ThorchainSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.ThorchainSignedTx} returns this
 */ proto.ThorchainSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.ThorchainSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$ed39b9d9c224f2ab$var$goog.object.extend($ed39b9d9c224f2ab$exports, proto);


parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");

var $1Vf4C = parcelRequire("1Vf4C");

var $gGdnO = parcelRequire("gGdnO");

const $1a4d3c81afb1ceaf$var$protoTxBuilder = (0, (/*@__PURE__*/$parcel$interopDefault($gGdnO))).from(()=>(parcelRequire("eknzC")));
function $1a4d3c81afb1ceaf$export$a633c37084f31eda(msg) {
    return [
        {
            addressNList: [
                2147483692,
                0x80000000 + $7NkOr.slip44ByCoin("Thorchain"),
                0x80000000 + msg.accountIdx,
                0,
                0
            ]
        }
    ];
}
async function $1a4d3c81afb1ceaf$export$ac25b1d0e8050d9b(transport, msg) {
    const getAddr = new $ed39b9d9c224f2ab$exports.ThorchainGetAddress();
    getAddr.setAddressNList(msg.addressNList);
    getAddr.setShowDisplay(msg.showDisplay !== false);
    if (msg.testnet !== undefined) getAddr.setTestnet(msg.testnet);
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_THORCHAINGETADDRESS, getAddr, {
        msgTimeout: $7NkOr.LONG_TIMEOUT
    });
    const thorchainAddress = response.proto;
    return $7NkOr.mustBeDefined(thorchainAddress.getAddress());
}
async function $1a4d3c81afb1ceaf$export$4b62217da920de63(transport, msg) {
    const address = await $1a4d3c81afb1ceaf$export$ac25b1d0e8050d9b(transport, {
        addressNList: msg.addressNList
    });
    const getPublicKeyMsg = new $437b837d88ef5c30$exports.GetPublicKey();
    getPublicKeyMsg.setAddressNList(msg.addressNList);
    getPublicKeyMsg.setEcdsaCurveName("secp256k1");
    const response = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETPUBLICKEY, getPublicKeyMsg, {
        msgTimeout: $7NkOr.DEFAULT_TIMEOUT
    });
    const pubkeyMsg = response.proto;
    const pubkey = (0, (/*@__PURE__*/$parcel$interopDefault($1Vf4C))).decode($7NkOr.mustBeDefined(pubkeyMsg.getXpub())).slice(45);
    return transport.lockDuring(async ()=>{
        const signTx = new $ed39b9d9c224f2ab$exports.ThorchainSignTx();
        signTx.setAddressNList(msg.addressNList);
        signTx.setAccountNumber(msg.account_number);
        signTx.setChainId(msg.chain_id);
        signTx.setFeeAmount(parseInt(msg.tx.fee.amount[0].amount));
        signTx.setGas(parseInt(msg.tx.fee.gas));
        signTx.setSequence(msg.sequence);
        if (msg.tx.memo !== undefined) signTx.setMemo(msg.tx.memo);
        signTx.setMsgCount(1);
        let resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_THORCHAINSIGNTX, signTx, {
            msgTimeout: $7NkOr.LONG_TIMEOUT,
            omitLock: true
        });
        for (const m of msg.tx.msg){
            if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_THORCHAINMSGREQUEST) throw new Error(`THORChain: unexpected response ${resp.message_type}`);
            let ack;
            if (m.type === "thorchain/MsgSend") {
                if (m.value.amount.length !== 1) throw new Error("THORChain: Multiple amounts per MsgSend not supported");
                const denom = m.value.amount[0].denom;
                if (denom !== "rune") throw new Error("THORChain: Unsupported denomination: " + denom);
                const send = new $ed39b9d9c224f2ab$exports.ThorchainMsgSend();
                send.setFromAddress(m.value.from_address);
                send.setToAddress(m.value.to_address);
                send.setAmount(m.value.amount[0].amount);
                ack = new $ed39b9d9c224f2ab$exports.ThorchainMsgAck();
                ack.setSend(send);
            } else if (m.type === "thorchain/MsgDeposit") {
                if (m.value.coins.length !== 1) throw new Error("THORChain: Multiple amounts per MsgDeposit not supported");
                const coinAsset = m.value.coins[0].asset;
                if (coinAsset !== "THOR.RUNE") throw new Error("THORChain: Unsupported coin asset: " + coinAsset);
                const deposit = new $ed39b9d9c224f2ab$exports.ThorchainMsgDeposit();
                deposit.setAsset(m.value.coins[0].asset);
                deposit.setAmount(m.value.coins[0].amount);
                deposit.setMemo(m.value.memo);
                deposit.setSigner(m.value.signer);
                ack = new $ed39b9d9c224f2ab$exports.ThorchainMsgAck();
                ack.setDeposit(deposit);
            } else throw new Error(`THORChain: Message ${m.type} is not yet supported`);
            resp = await transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_THORCHAINMSGACK, ack, {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (resp.message_enum !== $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_THORCHAINSIGNEDTX) throw new Error(`THORChain: unexpected response ${resp.message_type}`);
        const signedTx = resp.proto;
        const offlineSigner = {
            async getAccounts () {
                return [
                    {
                        address: address,
                        algo: "secp256k1",
                        pubkey: pubkey
                    }
                ];
            },
            async signAmino (signerAddress, signDoc) {
                if (signerAddress !== address) throw new Error("expected signerAddress to match address");
                return {
                    signed: signDoc,
                    signature: {
                        pub_key: {
                            type: "tendermint/PubKeySecp256k1",
                            value: signedTx.getPublicKey_asB64()
                        },
                        signature: signedTx.getSignature_asB64()
                    }
                };
            }
        };
        const signerData = {
            sequence: Number(msg.sequence),
            accountNumber: Number(msg.account_number),
            chainId: msg.chain_id
        };
        return (await $1a4d3c81afb1ceaf$var$protoTxBuilder).sign(address, msg.tx, offlineSigner, signerData, "thor");
    });
}







var $1f3e8800324a65d4$exports = {};
// source: messages-nano.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $2MzPv = parcelRequire("2MzPv");
var $1f3e8800324a65d4$var$goog = $2MzPv;
var $1f3e8800324a65d4$var$global = (function() {
    return this || window || $1f3e8800324a65d4$var$global || self || Function("return this")();
}).call(null);
$1f3e8800324a65d4$var$goog.exportSymbol("proto.NanoAddress", null, $1f3e8800324a65d4$var$global);
$1f3e8800324a65d4$var$goog.exportSymbol("proto.NanoGetAddress", null, $1f3e8800324a65d4$var$global);
$1f3e8800324a65d4$var$goog.exportSymbol("proto.NanoSignTx", null, $1f3e8800324a65d4$var$global);
$1f3e8800324a65d4$var$goog.exportSymbol("proto.NanoSignTx.ParentBlock", null, $1f3e8800324a65d4$var$global);
$1f3e8800324a65d4$var$goog.exportSymbol("proto.NanoSignedTx", null, $1f3e8800324a65d4$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.NanoGetAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.NanoGetAddress.repeatedFields_, null);
};
$1f3e8800324a65d4$var$goog.inherits(proto.NanoGetAddress, $2MzPv.Message);
if ($1f3e8800324a65d4$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.NanoGetAddress.displayName = "proto.NanoGetAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.NanoAddress = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1f3e8800324a65d4$var$goog.inherits(proto.NanoAddress, $2MzPv.Message);
if ($1f3e8800324a65d4$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.NanoAddress.displayName = "proto.NanoAddress";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.NanoSignTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, proto.NanoSignTx.repeatedFields_, null);
};
$1f3e8800324a65d4$var$goog.inherits(proto.NanoSignTx, $2MzPv.Message);
if ($1f3e8800324a65d4$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.NanoSignTx.displayName = "proto.NanoSignTx";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.NanoSignTx.ParentBlock = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1f3e8800324a65d4$var$goog.inherits(proto.NanoSignTx.ParentBlock, $2MzPv.Message);
if ($1f3e8800324a65d4$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.NanoSignTx.ParentBlock.displayName = "proto.NanoSignTx.ParentBlock";
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.NanoSignedTx = function(opt_data) {
    $2MzPv.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1f3e8800324a65d4$var$goog.inherits(proto.NanoSignedTx, $2MzPv.Message);
if ($1f3e8800324a65d4$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.NanoSignedTx.displayName = "proto.NanoSignedTx";
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.NanoGetAddress.repeatedFields_ = [
    1
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.NanoGetAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.NanoGetAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.NanoGetAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoGetAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 2, "Nano"),
            showDisplay: (f = $2MzPv.Message.getBooleanField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.NanoGetAddress}
 */ proto.NanoGetAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.NanoGetAddress;
    return proto.NanoGetAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.NanoGetAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.NanoGetAddress}
 */ proto.NanoGetAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setShowDisplay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.NanoGetAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.NanoGetAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.NanoGetAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoGetAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = /** @type {boolean} */ $2MzPv.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.NanoGetAddress.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string coin_name = 2;
 * @return {string}
 */ proto.NanoGetAddress.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "Nano");
};
/**
 * @param {string} value
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoGetAddress.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional bool show_display = 3;
 * @return {boolean}
 */ proto.NanoGetAddress.prototype.getShowDisplay = function() {
    return /** @type {boolean} */ $2MzPv.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.setShowDisplay = function(value) {
    return $2MzPv.Message.setField(this, 3, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoGetAddress} returns this
 */ proto.NanoGetAddress.prototype.clearShowDisplay = function() {
    return $2MzPv.Message.setField(this, 3, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoGetAddress.prototype.hasShowDisplay = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.NanoAddress.prototype.toObject = function(opt_includeInstance) {
        return proto.NanoAddress.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.NanoAddress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoAddress.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = $2MzPv.Message.getField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.NanoAddress}
 */ proto.NanoAddress.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.NanoAddress;
    return proto.NanoAddress.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.NanoAddress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.NanoAddress}
 */ proto.NanoAddress.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.NanoAddress.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.NanoAddress.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.NanoAddress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoAddress.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {string} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeString(1, f);
};
/**
 * optional string address = 1;
 * @return {string}
 */ proto.NanoAddress.prototype.getAddress = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.NanoAddress} returns this
 */ proto.NanoAddress.prototype.setAddress = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoAddress} returns this
 */ proto.NanoAddress.prototype.clearAddress = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoAddress.prototype.hasAddress = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.NanoSignTx.repeatedFields_ = [
    1,
    6
];
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.NanoSignTx.prototype.toObject = function(opt_includeInstance) {
        return proto.NanoSignTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.NanoSignTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressNList: (f = $2MzPv.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            coinName: $2MzPv.Message.getFieldWithDefault(msg, 2, "Nano"),
            parentBlock: (f = msg.getParentBlock()) && proto.NanoSignTx.ParentBlock.toObject(includeInstance, f),
            linkHash: msg.getLinkHash_asB64(),
            linkRecipient: (f = $2MzPv.Message.getField(msg, 5)) == null ? undefined : f,
            linkRecipientNList: (f = $2MzPv.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
            representative: (f = $2MzPv.Message.getField(msg, 7)) == null ? undefined : f,
            balance: msg.getBalance_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.NanoSignTx}
 */ proto.NanoSignTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.NanoSignTx;
    return proto.NanoSignTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.NanoSignTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.NanoSignTx}
 */ proto.NanoSignTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addAddressN(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCoinName(value);
                break;
            case 3:
                var value = new proto.NanoSignTx.ParentBlock;
                reader.readMessage(value, proto.NanoSignTx.ParentBlock.deserializeBinaryFromReader);
                msg.setParentBlock(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setLinkHash(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLinkRecipient(value);
                break;
            case 6:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedUint32() : [
                    reader.readUint32()
                ];
                for(var i = 0; i < values.length; i++)msg.addLinkRecipientN(values[i]);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setRepresentative(value);
                break;
            case 8:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setBalance(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.NanoSignTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.NanoSignTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.NanoSignTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressNList();
    if (f.length > 0) writer.writeRepeatedUint32(1, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeString(2, f);
    f = message.getParentBlock();
    if (f != null) writer.writeMessage(3, f, proto.NanoSignTx.ParentBlock.serializeBinaryToWriter);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeBytes(4, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = message.getLinkRecipientNList();
    if (f.length > 0) writer.writeRepeatedUint32(6, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 7);
    if (f != null) writer.writeString(7, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 8);
    if (f != null) writer.writeBytes(8, f);
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.NanoSignTx.ParentBlock.prototype.toObject = function(opt_includeInstance) {
        return proto.NanoSignTx.ParentBlock.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.NanoSignTx.ParentBlock} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignTx.ParentBlock.toObject = function(includeInstance, msg) {
        var f, obj = {
            parentHash: msg.getParentHash_asB64(),
            link: msg.getLink_asB64(),
            representative: (f = $2MzPv.Message.getField(msg, 4)) == null ? undefined : f,
            balance: msg.getBalance_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.NanoSignTx.ParentBlock}
 */ proto.NanoSignTx.ParentBlock.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.NanoSignTx.ParentBlock;
    return proto.NanoSignTx.ParentBlock.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.NanoSignTx.ParentBlock} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.NanoSignTx.ParentBlock}
 */ proto.NanoSignTx.ParentBlock.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setParentHash(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setLink(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setRepresentative(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setBalance(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.NanoSignTx.ParentBlock.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.NanoSignTx.ParentBlock.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.NanoSignTx.ParentBlock} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignTx.ParentBlock.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
    f = /** @type {string} */ $2MzPv.Message.getField(message, 4);
    if (f != null) writer.writeString(4, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 5);
    if (f != null) writer.writeBytes(5, f);
};
/**
 * optional bytes parent_hash = 1;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignTx.ParentBlock.prototype.getParentHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes parent_hash = 1;
 * This is a type-conversion wrapper around `getParentHash()`
 * @return {string}
 */ proto.NanoSignTx.ParentBlock.prototype.getParentHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getParentHash());
};
/**
 * optional bytes parent_hash = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getParentHash()`
 * @return {!Uint8Array}
 */ proto.NanoSignTx.ParentBlock.prototype.getParentHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getParentHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.setParentHash = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.clearParentHash = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.ParentBlock.prototype.hasParentHash = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes link = 2;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignTx.ParentBlock.prototype.getLink = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes link = 2;
 * This is a type-conversion wrapper around `getLink()`
 * @return {string}
 */ proto.NanoSignTx.ParentBlock.prototype.getLink_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getLink());
};
/**
 * optional bytes link = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLink()`
 * @return {!Uint8Array}
 */ proto.NanoSignTx.ParentBlock.prototype.getLink_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getLink());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.setLink = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.clearLink = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.ParentBlock.prototype.hasLink = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional string representative = 4;
 * @return {string}
 */ proto.NanoSignTx.ParentBlock.prototype.getRepresentative = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.setRepresentative = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.clearRepresentative = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.ParentBlock.prototype.hasRepresentative = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional bytes balance = 5;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignTx.ParentBlock.prototype.getBalance = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes balance = 5;
 * This is a type-conversion wrapper around `getBalance()`
 * @return {string}
 */ proto.NanoSignTx.ParentBlock.prototype.getBalance_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getBalance());
};
/**
 * optional bytes balance = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBalance()`
 * @return {!Uint8Array}
 */ proto.NanoSignTx.ParentBlock.prototype.getBalance_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getBalance());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.setBalance = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx.ParentBlock} returns this
 */ proto.NanoSignTx.ParentBlock.prototype.clearBalance = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.ParentBlock.prototype.hasBalance = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * repeated uint32 address_n = 1;
 * @return {!Array<number>}
 */ proto.NanoSignTx.prototype.getAddressNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setAddressNList = function(value) {
    return $2MzPv.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.addAddressN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearAddressNList = function() {
    return this.setAddressNList([]);
};
/**
 * optional string coin_name = 2;
 * @return {string}
 */ proto.NanoSignTx.prototype.getCoinName = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 2, "Nano");
};
/**
 * @param {string} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setCoinName = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearCoinName = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasCoinName = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
/**
 * optional ParentBlock parent_block = 3;
 * @return {?proto.NanoSignTx.ParentBlock}
 */ proto.NanoSignTx.prototype.getParentBlock = function() {
    return /** @type{?proto.NanoSignTx.ParentBlock} */ $2MzPv.Message.getWrapperField(this, proto.NanoSignTx.ParentBlock, 3);
};
/**
 * @param {?proto.NanoSignTx.ParentBlock|undefined} value
 * @return {!proto.NanoSignTx} returns this
*/ proto.NanoSignTx.prototype.setParentBlock = function(value) {
    return $2MzPv.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearParentBlock = function() {
    return this.setParentBlock(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasParentBlock = function() {
    return $2MzPv.Message.getField(this, 3) != null;
};
/**
 * optional bytes link_hash = 4;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignTx.prototype.getLinkHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 4, "");
};
/**
 * optional bytes link_hash = 4;
 * This is a type-conversion wrapper around `getLinkHash()`
 * @return {string}
 */ proto.NanoSignTx.prototype.getLinkHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getLinkHash());
};
/**
 * optional bytes link_hash = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLinkHash()`
 * @return {!Uint8Array}
 */ proto.NanoSignTx.prototype.getLinkHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getLinkHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setLinkHash = function(value) {
    return $2MzPv.Message.setField(this, 4, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearLinkHash = function() {
    return $2MzPv.Message.setField(this, 4, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasLinkHash = function() {
    return $2MzPv.Message.getField(this, 4) != null;
};
/**
 * optional string link_recipient = 5;
 * @return {string}
 */ proto.NanoSignTx.prototype.getLinkRecipient = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setLinkRecipient = function(value) {
    return $2MzPv.Message.setField(this, 5, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearLinkRecipient = function() {
    return $2MzPv.Message.setField(this, 5, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasLinkRecipient = function() {
    return $2MzPv.Message.getField(this, 5) != null;
};
/**
 * repeated uint32 link_recipient_n = 6;
 * @return {!Array<number>}
 */ proto.NanoSignTx.prototype.getLinkRecipientNList = function() {
    return /** @type {!Array<number>} */ $2MzPv.Message.getRepeatedField(this, 6);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setLinkRecipientNList = function(value) {
    return $2MzPv.Message.setField(this, 6, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.addLinkRecipientN = function(value, opt_index) {
    return $2MzPv.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearLinkRecipientNList = function() {
    return this.setLinkRecipientNList([]);
};
/**
 * optional string representative = 7;
 * @return {string}
 */ proto.NanoSignTx.prototype.getRepresentative = function() {
    return /** @type {string} */ $2MzPv.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setRepresentative = function(value) {
    return $2MzPv.Message.setField(this, 7, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearRepresentative = function() {
    return $2MzPv.Message.setField(this, 7, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasRepresentative = function() {
    return $2MzPv.Message.getField(this, 7) != null;
};
/**
 * optional bytes balance = 8;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignTx.prototype.getBalance = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 8, "");
};
/**
 * optional bytes balance = 8;
 * This is a type-conversion wrapper around `getBalance()`
 * @return {string}
 */ proto.NanoSignTx.prototype.getBalance_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getBalance());
};
/**
 * optional bytes balance = 8;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBalance()`
 * @return {!Uint8Array}
 */ proto.NanoSignTx.prototype.getBalance_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getBalance());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.setBalance = function(value) {
    return $2MzPv.Message.setField(this, 8, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignTx} returns this
 */ proto.NanoSignTx.prototype.clearBalance = function() {
    return $2MzPv.Message.setField(this, 8, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignTx.prototype.hasBalance = function() {
    return $2MzPv.Message.getField(this, 8) != null;
};
if ($2MzPv.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.NanoSignedTx.prototype.toObject = function(opt_includeInstance) {
        return proto.NanoSignedTx.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.NanoSignedTx} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignedTx.toObject = function(includeInstance, msg) {
        var f, obj = {
            signature: msg.getSignature_asB64(),
            blockHash: msg.getBlockHash_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.NanoSignedTx}
 */ proto.NanoSignedTx.deserializeBinary = function(bytes) {
    var reader = new $2MzPv.BinaryReader(bytes);
    var msg = new proto.NanoSignedTx;
    return proto.NanoSignedTx.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.NanoSignedTx} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.NanoSignedTx}
 */ proto.NanoSignedTx.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setSignature(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setBlockHash(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.NanoSignedTx.prototype.serializeBinary = function() {
    var writer = new $2MzPv.BinaryWriter();
    proto.NanoSignedTx.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.NanoSignedTx} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.NanoSignedTx.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 1);
    if (f != null) writer.writeBytes(1, f);
    f = /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getField(message, 2);
    if (f != null) writer.writeBytes(2, f);
};
/**
 * optional bytes signature = 1;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignedTx.prototype.getSignature = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes signature = 1;
 * This is a type-conversion wrapper around `getSignature()`
 * @return {string}
 */ proto.NanoSignedTx.prototype.getSignature_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getSignature());
};
/**
 * optional bytes signature = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSignature()`
 * @return {!Uint8Array}
 */ proto.NanoSignedTx.prototype.getSignature_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getSignature());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignedTx} returns this
 */ proto.NanoSignedTx.prototype.setSignature = function(value) {
    return $2MzPv.Message.setField(this, 1, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignedTx} returns this
 */ proto.NanoSignedTx.prototype.clearSignature = function() {
    return $2MzPv.Message.setField(this, 1, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignedTx.prototype.hasSignature = function() {
    return $2MzPv.Message.getField(this, 1) != null;
};
/**
 * optional bytes block_hash = 2;
 * @return {!(string|Uint8Array)}
 */ proto.NanoSignedTx.prototype.getBlockHash = function() {
    return /** @type {!(string|Uint8Array)} */ $2MzPv.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes block_hash = 2;
 * This is a type-conversion wrapper around `getBlockHash()`
 * @return {string}
 */ proto.NanoSignedTx.prototype.getBlockHash_asB64 = function() {
    return /** @type {string} */ $2MzPv.Message.bytesAsB64(this.getBlockHash());
};
/**
 * optional bytes block_hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getBlockHash()`
 * @return {!Uint8Array}
 */ proto.NanoSignedTx.prototype.getBlockHash_asU8 = function() {
    return /** @type {!Uint8Array} */ $2MzPv.Message.bytesAsU8(this.getBlockHash());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.NanoSignedTx} returns this
 */ proto.NanoSignedTx.prototype.setBlockHash = function(value) {
    return $2MzPv.Message.setField(this, 2, value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.NanoSignedTx} returns this
 */ proto.NanoSignedTx.prototype.clearBlockHash = function() {
    return $2MzPv.Message.setField(this, 2, undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.NanoSignedTx.prototype.hasBlockHash = function() {
    return $2MzPv.Message.getField(this, 2) != null;
};
$1f3e8800324a65d4$var$goog.object.extend($1f3e8800324a65d4$exports, proto);





var $kEUo3 = parcelRequire("kEUo3");
// Conflict between typedef and actual js export
const $941d05c7ef54f088$var$AllMessages = [].concat(Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).omit($437b837d88ef5c30$exports, "MessageType", "MessageTypeMap"))).concat(Object.entries($133b05dab394aa62$exports)).concat(Object.entries($ce54469dbed45e7f$exports)).concat(Object.entries($fe559938afeeabdc$exports)).concat(Object.entries($1f3e8800324a65d4$exports)).concat(Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).omit($e45745d0e423cacd$exports, "EosPublicKeyKind", "EosPublicKeyKindMap"))).concat(Object.entries($ed39b9d9c224f2ab$exports)).concat(Object.entries($9b53c374edf4eb8c$exports));
const $941d05c7ef54f088$var$upperCasedMessageClasses = $941d05c7ef54f088$var$AllMessages.reduce((registry, entry)=>{
    registry[entry[0].toUpperCase()] = entry[1];
    return registry;
}, {});
const $941d05c7ef54f088$export$b26b7eecad5f37af = Object.entries($437b837d88ef5c30$exports.MessageType).reduce((registry, entry)=>{
    registry[entry[1]] = entry[0].split("_")[1];
    return registry;
}, {});
const $941d05c7ef54f088$export$64c0007fb7fca8ef = Object.entries($437b837d88ef5c30$exports.MessageType).reduce((registry, entry)=>{
    registry[entry[1]] = $941d05c7ef54f088$var$upperCasedMessageClasses[entry[0].split("_")[1].toUpperCase()];
    return registry;
}, {});



function $459ec2812757e70b$export$bd6c7a035c72384b(wallet) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($kEUo3))).isObject(wallet) && wallet._isKeepKey;
}
function $459ec2812757e70b$var$describeETHPath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Ethereum",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Ethereum")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] != 0) return unknown;
    if (path[4] != 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Ethereum Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Ethereum",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeUTXOPath(path, coin, scriptType) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: coin,
        scriptType: scriptType,
        isKnown: false
    };
    if (!scriptType) return unknown;
    if (!$0396a8ef29b63193$export$5bc2382b8aee7114(coin)) return unknown;
    if (!$0396a8ef29b63193$export$e19a8971ffa7da73(coin, scriptType)) return unknown;
    if (path.length !== 3 && path.length !== 5) return unknown;
    if ((path[0] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    const purpose = path[0] & 0x7fffffff;
    if (![
        44,
        49,
        84
    ].includes(purpose)) return unknown;
    if (purpose === 44 && scriptType !== $6iw60.BTCInputScriptType.SpendAddress) return unknown;
    if (purpose === 49 && scriptType !== $6iw60.BTCInputScriptType.SpendP2SHWitness) return unknown;
    if (purpose === 84 && scriptType !== $6iw60.BTCInputScriptType.SpendWitness) return unknown;
    const wholeAccount = path.length === 3;
    const script = scriptType ? ({
        [$6iw60.BTCInputScriptType.SpendAddress]: [
            "Legacy"
        ],
        [$6iw60.BTCInputScriptType.SpendP2SHWitness]: [],
        [$6iw60.BTCInputScriptType.SpendWitness]: [
            "Segwit Native"
        ]
    })[scriptType] ?? [] : [];
    let isPrefork = false;
    const slip44 = $7NkOr.slip44ByCoin(coin);
    if (slip44 === undefined) return unknown;
    if (path[1] !== 0x80000000 + slip44) switch(coin){
        case "BitcoinCash":
        case "BitcoinGold":
            if (path[1] === 0x80000000 + $7NkOr.slip44ByCoin("Bitcoin")) {
                isPrefork = true;
                break;
            }
            return unknown;
        case "BitcoinSV":
            if (path[1] === 0x80000000 + $7NkOr.slip44ByCoin("Bitcoin") || path[1] === 0x80000000 + $7NkOr.slip44ByCoin("BitcoinCash")) {
                isPrefork = true;
                break;
            }
            return unknown;
        default:
            return unknown;
    }
    let attributes = isPrefork ? [
        "Prefork"
    ] : [];
    switch(coin){
        case "Bitcoin":
        case "Litecoin":
        case "BitcoinGold":
        case "Testnet":
            attributes = attributes.concat(script);
            break;
        default:
            break;
    }
    const attr = attributes.length ? ` (${attributes.join(", ")})` : "";
    const accountIdx = path[2] & 0x7fffffff;
    if (wholeAccount) return {
        coin: coin,
        verbose: `${coin} Account #${accountIdx}${attr}`,
        accountIdx: accountIdx,
        wholeAccount: true,
        isKnown: true,
        scriptType: scriptType,
        isPrefork: isPrefork
    };
    else {
        const change = path[3] === 1 ? "Change " : "";
        const addressIdx = path[4];
        return {
            coin: coin,
            verbose: `${coin} Account #${accountIdx}, ${change}Address #${addressIdx}${attr}`,
            accountIdx: accountIdx,
            addressIdx: addressIdx,
            wholeAccount: false,
            isKnown: true,
            isChange: path[3] === 1,
            scriptType: scriptType,
            isPrefork: isPrefork
        };
    }
}
function $459ec2812757e70b$var$describeCosmosPath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Atom",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Atom")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Cosmos Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Atom",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeOsmosisPath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Osmo",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Osmo")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Osmosis Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Osmo",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeThorchainPath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Rune",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Rune")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `THORChain Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Rune",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeEosPath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Eos",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Eos")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Eos Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Eos",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeRipplePath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Ripple",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Ripple")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Ripple Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Ripple",
        isKnown: true,
        isPrefork: false
    };
}
function $459ec2812757e70b$var$describeBinancePath(path) {
    const pathStr = $7NkOr.addressNListToBIP32(path);
    const unknown = {
        verbose: pathStr,
        coin: "Binance",
        isKnown: false
    };
    if (path.length != 5) return unknown;
    if (path[0] != 2147483692) return unknown;
    if (path[1] != 0x80000000 + $7NkOr.slip44ByCoin("Binance")) return unknown;
    if ((path[2] & 0x80000000) >>> 0 !== 0x80000000) return unknown;
    if (path[3] !== 0 || path[4] !== 0) return unknown;
    const index = path[2] & 0x7fffffff;
    return {
        verbose: `Binance Account #${index}`,
        accountIdx: index,
        wholeAccount: true,
        coin: "Binance",
        isKnown: true,
        isPrefork: false
    };
}
class $459ec2812757e70b$export$b1870a8e6b6fd706 {
    getVendor() {
        return "KeepKey";
    }
    async btcSupportsCoin(coin) {
        return $0396a8ef29b63193$export$5bc2382b8aee7114(coin);
    }
    async btcSupportsScriptType(coin, scriptType) {
        return $0396a8ef29b63193$export$e19a8971ffa7da73(coin, scriptType);
    }
    async btcSupportsSecureTransfer() {
        return $0396a8ef29b63193$export$b16a1c3994f70e7a();
    }
    btcSupportsNativeShapeShift() {
        return $0396a8ef29b63193$export$aa714ed70e3e3d8f();
    }
    btcGetAccountPaths(msg) {
        return $0396a8ef29b63193$export$9e274eca87a9a359(msg);
    }
    btcIsSameAccount(msg) {
        return $0396a8ef29b63193$export$44f42932656c0961(msg);
    }
    async ethSupportsNetwork(chain_id) {
        return $498e4f3d99501515$export$c19ce23c9e212ea7(chain_id);
    }
    async ethSupportsSecureTransfer() {
        return $498e4f3d99501515$export$bf08b0f93c5ac413();
    }
    ethSupportsNativeShapeShift() {
        return $498e4f3d99501515$export$bb575c1aefbd30f4();
    }
    async ethSupportsEIP1559() {
        return true;
    }
    ethGetAccountPaths(msg) {
        return $498e4f3d99501515$export$9085c5f7c6435a2e(msg);
    }
    cosmosGetAccountPaths(msg) {
        return $ee3499be6fffa9bb$export$91ffdbe147bbd2b8(msg);
    }
    osmosisGetAccountPaths(msg) {
        return $a9300787f03269d5$export$63b95deac2d9ec2e(msg);
    }
    thorchainGetAccountPaths(msg) {
        return $1a4d3c81afb1ceaf$export$a633c37084f31eda(msg);
    }
    mayachainGetAccountPaths(msg) {
        return $0fbcf8d6af2d9dc2$export$c492b906e65561a0(msg);
    }
    rippleGetAccountPaths(msg) {
        return $cde9fec45a163105$export$8a64695de5385be0(msg);
    }
    binanceGetAccountPaths(msg) {
        return $1df2ffc82308ac2c$export$90044b61b3ecd340(msg);
    }
    eosGetAccountPaths(msg) {
        return $3c1604a9db806af4$export$25d2e327a4f7b21a(msg);
    }
    hasOnDevicePinEntry() {
        return false;
    }
    hasOnDevicePassphrase() {
        return false;
    }
    hasOnDeviceDisplay() {
        return true;
    }
    hasOnDeviceRecovery() {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasNativeShapeShift(srcCoin, dstCoin) {
        return true;
    }
    supportsBip44Accounts() {
        return true;
    }
    supportsOfflineSigning() {
        return true;
    }
    supportsBroadcast() {
        return false;
    }
    describePath(msg) {
        switch(msg.coin){
            case "Ethereum":
                return $459ec2812757e70b$var$describeETHPath(msg.path);
            case "Atom":
                return $459ec2812757e70b$var$describeCosmosPath(msg.path);
            case "Osmo":
                return $459ec2812757e70b$var$describeOsmosisPath(msg.path);
            case "Binance":
                return $459ec2812757e70b$var$describeBinancePath(msg.path);
            case "Ripple":
                return $459ec2812757e70b$var$describeRipplePath(msg.path);
            case "Eos":
                return $459ec2812757e70b$var$describeEosPath(msg.path);
            default:
                return $459ec2812757e70b$var$describeUTXOPath(msg.path, msg.coin, msg.scriptType);
        }
    }
    btcNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeUTXOPath(msg.addressNList, msg.coin, msg.scriptType);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        if (addressNList[0] === 2147483692 || addressNList[0] === 2147483697 || addressNList[0] === 2147483732) {
            addressNList[2] += 1;
            return {
                ...msg,
                addressNList: addressNList
            };
        }
        return undefined;
    }
    ethNextAccountPath(msg) {
        const addressNList = msg.hardenedPath.concat(msg.relPath);
        const description = $459ec2812757e70b$var$describeETHPath(addressNList);
        if (!description.isKnown) return undefined;
        if (addressNList[0] === 2147483692) {
            addressNList[2] += 1;
            return {
                ...msg,
                addressNList: addressNList,
                hardenedPath: $7NkOr.hardenedPath(addressNList),
                relPath: $7NkOr.relativePath(addressNList)
            };
        }
        return undefined;
    }
    cosmosNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeCosmosPath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    osmosisNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeOsmosisPath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    thorchainNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeThorchainPath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    mayachainNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeThorchainPath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    rippleNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeRipplePath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    binanceNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeBinancePath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    eosNextAccountPath(msg) {
        const description = $459ec2812757e70b$var$describeEosPath(msg.addressNList);
        if (!description.isKnown) return undefined;
        const addressNList = msg.addressNList;
        addressNList[2] += 1;
        return {
            ...msg,
            addressNList: addressNList
        };
    }
    constructor(){
        this._supportsBTCInfo = true;
        this._supportsETHInfo = true;
        this._supportsCosmosInfo = true;
        this._supportsOsmosisInfo = true;
        this._supportsRippleInfo = true;
        this._supportsBinanceInfo = true;
        this._supportsEosInfo = true;
        this._supportsThorchainInfo = true;
        this._supportsMayachainInfo = true;
    }
}
class $459ec2812757e70b$export$c3ae0991ce69a474 {
    constructor(transport){
        this._supportsETHInfo = true;
        this._supportsBTCInfo = true;
        this._supportsCosmosInfo = true;
        this._supportsOsmosisInfo = true;
        this._supportsRippleInfo = true;
        this._supportsBinanceInfo = true;
        this._supportsEosInfo = true;
        this._supportsFioInfo = false;
        this._isKeepKey = true;
        this._supportsETH = true;
        this._supportsEthSwitchChain = false;
        this._supportsAvalanche = false;
        this._supportsOptimism = true;
        this._supportsBSC = true;
        this._supportsPolygon = true;
        this._supportsGnosis = true;
        this._supportsArbitrum = false;
        this._supportsArbitrumNova = false;
        this._supportsBTC = true;
        this._supportsCosmos = true;
        this._supportsOsmosis = true;
        this._supportsRipple = true;
        this._supportsBinance = true;
        this._supportsEos = true;
        this._supportsFio = false;
        this._supportsThorchainInfo = true;
        this._supportsThorchain = true;
        this._supportsMayachainInfo = false;
        this._supportsMayachain = false;
        this._supportsSecretInfo = false;
        this._supportsSecret = false;
        this._supportsKava = false;
        this._supportsKavaInfo = false;
        this._supportsTerra = false;
        this._supportsTerraInfo = false;
        this.transport = transport;
        this._supportsDebugLink = transport.debugLink;
        this.info = new $459ec2812757e70b$export$b1870a8e6b6fd706();
    }
    static async create(transport) {
        return new $459ec2812757e70b$export$c3ae0991ce69a474(transport);
    }
    async getDeviceID() {
        const featuresId = (await this.getFeatures(/*cached=*/ true)).deviceId;
        // Devices in bootloader mode show up with empty string deviceId's in their features object.
        if (featuresId) return featuresId;
        // Grabbing the one from the transport seems to be a reasonable fallback.
        return await this.transport.getDeviceID();
    }
    getVendor() {
        return "KeepKey";
    }
    async getModel() {
        return $7NkOr.mustBeDefined((await this.getFeatures(/*cached=*/ true)).model);
    }
    async getFirmwareVersion() {
        const features = await this.getFeatures(/*cached=*/ true);
        return `v${features.majorVersion}.${features.minorVersion}.${features.patchVersion}`;
    }
    async getLabel() {
        return (await this.getFeatures(/*cached=*/ true)).label ?? "";
    }
    async isInitialized() {
        return !!(await this.getFeatures()).initialized;
    }
    async isLocked() {
        const features = await this.getFeatures();
        if (features.pinProtection && !features.pinCached) return true;
        if (features.passphraseProtection && !features.passphraseCached) return true;
        return false;
    }
    async getPublicKeys(getPublicKeys) {
        const publicKeys = [];
        for(let i = 0; i < getPublicKeys.length; i++){
            const { coin: coin, addressNList: addressNList, curve: curve, showDisplay: showDisplay, scriptType: scriptType } = getPublicKeys[i];
            const GPK = new $437b837d88ef5c30$exports.GetPublicKey();
            if (coin) GPK.setCoinName(coin);
            GPK.setAddressNList(addressNList);
            GPK.setShowDisplay(showDisplay || false);
            GPK.setEcdsaCurveName(curve || "secp256k1");
            GPK.setScriptType((0, $18acccdd0f9aa659$export$299f78d99cd9b58c)(scriptType || $6iw60.BTCInputScriptType.SpendAddress));
            const event = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETPUBLICKEY, GPK, {
                msgTimeout: showDisplay ? $7NkOr.LONG_TIMEOUT : $7NkOr.DEFAULT_TIMEOUT
            });
            const publicKey = event.proto;
            publicKeys.push({
                xpub: $7NkOr.mustBeDefined(publicKey.getXpub())
            });
        }
        return publicKeys;
    }
    async ping(msg) {
        const ping = new $437b837d88ef5c30$exports.Ping();
        ping.setMessage(msg.msg);
        ping.setButtonProtection(msg.button || false);
        ping.setPinProtection(msg.pin || false);
        ping.setPassphraseProtection(msg.passphrase || false);
        const event = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PING, ping, {
            msgTimeout: msg.button || msg.pin || msg.passphrase ? $7NkOr.LONG_TIMEOUT : $7NkOr.DEFAULT_TIMEOUT
        });
        const message = event.proto;
        return {
            msg: $7NkOr.mustBeDefined(message.getMessage())
        };
    }
    async reset(msg) {
        const resetDevice = new $437b837d88ef5c30$exports.ResetDevice();
        resetDevice.setStrength(msg.entropy || 128);
        resetDevice.setDisplayRandom(false);
        resetDevice.setPassphraseProtection(msg.passphrase || false);
        resetDevice.setPinProtection(msg.pin || false);
        resetDevice.setLabel(msg.label);
        if (msg.autoLockDelayMs) resetDevice.setAutoLockDelayMs(msg.autoLockDelayMs);
        resetDevice.setU2fCounter(msg.u2fCounter || Math.floor(+new Date() / 1000));
        // resetDevice.setWordsPerGape(wordsPerScreen) // Re-enable when patch gets in
        // Send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_RESETDEVICE, resetDevice, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        this.cacheFeatures(undefined);
    }
    async recover(r) {
        const msg = new $437b837d88ef5c30$exports.RecoveryDevice();
        msg.setWordCount({
            128: 12,
            192: 18,
            256: 24
        }[r.entropy]);
        msg.setPassphraseProtection(r.passphrase);
        msg.setPinProtection(r.pin);
        msg.setLabel(r.label);
        msg.setLanguage(r.language || "english");
        msg.setEnforceWordlist(true);
        msg.setUseCharacterCipher(true);
        if (r.autoLockDelayMs) msg.setAutoLockDelayMs(r.autoLockDelayMs);
        msg.setU2fCounter(r.u2fCounter || Math.floor(+new Date() / 1000));
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_RECOVERYDEVICE, msg, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        this.cacheFeatures(undefined);
    }
    async pressYes() {
        return this.press(true);
    }
    async pressNo() {
        return this.press(false);
    }
    async press(isYes) {
        const decision = new $437b837d88ef5c30$exports.DebugLinkDecision();
        decision.setYesNo(isYes);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_DEBUGLINKDECISION, decision, {
            noWait: true,
            debugLink: true
        });
    }
    hasOnDevicePinEntry() {
        return false;
    }
    hasOnDevicePassphrase() {
        return false;
    }
    hasOnDeviceDisplay() {
        return true;
    }
    hasOnDeviceRecovery() {
        return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasNativeShapeShift(srcCoin, dstCoin) {
        return true;
    }
    supportsBip44Accounts() {
        return this.info.supportsBip44Accounts();
    }
    supportsOfflineSigning() {
        return true;
    }
    supportsBroadcast() {
        return false;
    }
    async sendPin(pin) {
        const matrixAck = new $437b837d88ef5c30$exports.PinMatrixAck();
        matrixAck.setPin(pin);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PINMATRIXACK, matrixAck, {
            msgTimeout: $7NkOr.DEFAULT_TIMEOUT,
            omitLock: true,
            noWait: true
        });
    }
    async sendPassphrase(passphrase) {
        const passphraseAck = new $437b837d88ef5c30$exports.PassphraseAck();
        passphraseAck.setPassphrase(passphrase);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PASSPHRASEACK, passphraseAck, {
            msgTimeout: $7NkOr.DEFAULT_TIMEOUT,
            omitLock: true,
            noWait: true
        });
    }
    async sendCharacter(character) {
        await this.sendCharacterProto(character, false, false);
    }
    async sendCharacterDelete() {
        await this.sendCharacterProto("", true, false);
    }
    async sendCharacterDone() {
        await this.sendCharacterProto("", false, true);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async sendWord(word) {
        throw new Error("Not Yet Implemented :(");
    }
    async sendCharacterProto(character, _delete, _done) {
        const characterAck = new $437b837d88ef5c30$exports.CharacterAck();
        if (character !== "") characterAck.setCharacter(character);
        else if (_delete) characterAck.setDelete(_delete);
        else if (_done) characterAck.setDone(_done);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CHARACTERACK, characterAck, {
            msgTimeout: $7NkOr.DEFAULT_TIMEOUT,
            omitLock: true,
            noWait: true
        });
    }
    // ApplyPolicy enables or disables a named policy such as "ShapeShift" on the device
    async applyPolicy(p) {
        const policy = new $d4cdf7121546d3d6$exports.PolicyType();
        policy.setPolicyName(p.policyName);
        policy.setEnabled(p.enabled);
        const applyPolicies = new $437b837d88ef5c30$exports.ApplyPolicies();
        applyPolicies.setPolicyList([
            policy
        ]);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_APPLYPOLICIES, applyPolicies, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        this.cacheFeatures(undefined);
    }
    // ApplySettings changes the label, language, and enabling/disabling the passphrase
    // The default language is english
    async applySettings(s) {
        const applySettings = new $437b837d88ef5c30$exports.ApplySettings();
        if (s.label) applySettings.setLabel(s.label);
        if (s.language) applySettings.setLanguage(s.language);
        if (s.usePassphrase !== undefined) applySettings.setUsePassphrase(s.usePassphrase);
        if (s.autoLockDelayMs) applySettings.setAutoLockDelayMs(s.autoLockDelayMs);
        if (s.u2fCounter) applySettings.setU2fCounter(s.u2fCounter);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_APPLYSETTINGS, applySettings);
        this.cacheFeatures(undefined);
    }
    // Cancel aborts the last device action that required user interaction
    // It can follow a button request, passphrase request, or pin request
    async cancel() {
        await this.transport.cancel();
    }
    // ChangePin requests setting/changing the pin
    async changePin() {
        const changePin = new $437b837d88ef5c30$exports.ChangePin();
        // User may be propmpted for button press up to 2 times
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CHANGEPIN, changePin, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
    }
    // CipherKeyValue encrypts or decrypts a value with a given key, nodepath, and initializationVector
    // This method encrypts if encrypt is true and decrypts if false, the confirm paramater determines wether
    // the user is prompted on the device. See EncryptKeyValue() and DecryptKeyValue() for convenience methods
    // NOTE: If the length of the value in bytes is not divisible by 16 it will be zero padded
    async cipherKeyValue(v) {
        // if(val.length % 16 !== 0) val = val.concat() TODO THIS
        const cipherKeyValue = new $437b837d88ef5c30$exports.CipherKeyValue();
        cipherKeyValue.setAddressNList(v.addressNList);
        cipherKeyValue.setKey(v.key);
        cipherKeyValue.setValue(v.value);
        cipherKeyValue.setEncrypt(!!v.encrypt);
        cipherKeyValue.setAskOnEncrypt(v.askOnEncrypt || false);
        cipherKeyValue.setAskOnDecrypt(v.askOnDecrypt || false);
        cipherKeyValue.setIv(v.iv || "");
        const response = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CIPHERKEYVALUE, cipherKeyValue);
        const ckv = response.message;
        return ckv.getValue();
    }
    // ClearSession clears cached session values such as the pin and passphrase
    async clearSession() {
        const clearSession = new $437b837d88ef5c30$exports.ClearSession();
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CLEARSESSION, clearSession);
        this.cacheFeatures(undefined);
    }
    // DecryptKeyValue is a convenience method around decrypting with CipherKeyValue().
    // For more granular control of the process use CipherKeyValue()
    async decryptKeyValue(v) {
        return this.cipherKeyValue(v);
    }
    // FirmwareErase askes the device to erase its firmware
    async firmwareErase() {
        const firmwareErase = new $437b837d88ef5c30$exports.FirmwareErase();
        // send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FIRMWAREERASE, firmwareErase);
        this.cacheFeatures(undefined);
    }
    async firmwareUpload(firmware) {
        const firmwareUpload = new $437b837d88ef5c30$exports.FirmwareUpload();
        const hash = await this.transport.getFirmwareHash(firmware);
        firmwareUpload.setPayload(firmware);
        firmwareUpload.setPayloadHash(hash);
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FIRMWAREUPLOAD, firmwareUpload);
        this.cacheFeatures(undefined);
    }
    // Initialize assigns a hid connection to this KeepKey and send initialize message to device
    async initialize() {
        const initialize = new $437b837d88ef5c30$exports.Initialize();
        const event = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_INITIALIZE, initialize);
        if (!event.message) throw event;
        const out = event.message;
        this.features = out;
        // v6.1.0 firmware changed usb serial numbers to match STM32 desig_device_id
        // If the deviceId in the features table doesn't match, then we need to
        // add another k-v pair to the keyring so it can be looked up either way.
        const transportDeviceID = await this.transport.getDeviceID();
        if (out.deviceId && transportDeviceID !== out.deviceId) this.transport.keyring.addAlias(transportDeviceID, out.deviceId);
        const fwVersion = `v${out.majorVersion}.${out.minorVersion}.${out.patchVersion}`;
        //Lost Support per proto 44.3
        this._supportsOsmosis = (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(fwVersion, "v7.7.0");
        this._supportsCosmos = (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(fwVersion, "v7.3.0");
        this._supportsRipple = (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(fwVersion, "v6.4.0");
        this._supportsBinance = (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(fwVersion, "v6.4.0");
        this._supportsEos = (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(fwVersion, "v6.4.0");
        // this._supportsThorchain = semver.get(fwVersion, "v7.3.0");
        this.cacheFeatures(out);
        return out;
    }
    // GetFeatures returns the features and other device information such as the version, label, and supported coins
    async getFeatures(cached = false) {
        if (cached && this.featuresCache) return this.featuresCache;
        const features = new $437b837d88ef5c30$exports.GetFeatures();
        const event = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETFEATURES, features);
        this.cacheFeatures(event.message);
        return event.message;
    }
    cacheFeatures(features) {
        this.featuresCache = features;
    }
    // GetEntropy requests sample data from the hardware RNG
    async getEntropy(size) {
        const getEntropy = new $437b837d88ef5c30$exports.GetEntropy();
        getEntropy.setSize(size);
        // send
        const event = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETENTROPY, getEntropy, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        return $7NkOr.mustBeDefined(event.proto).getEntropy_asU8();
    }
    // GetNumCoins returns the number of coins supported by the device regardless of if the hanve funds.
    async getNumCoins() {
        const getCoinTable = new $437b837d88ef5c30$exports.GetCoinTable();
        const response = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETCOINTABLE, getCoinTable);
        return $7NkOr.mustBeDefined($7NkOr.mustBeDefined(response.proto).getNumCoins());
    }
    // GetCoinTable returns an array of Types.CoinTypes, with start and end arguments for paging.
    // You cannot request more than 10 at a time.
    async getCoinTable(start = 0, end = start + 10) {
        const getCoinTable = new $437b837d88ef5c30$exports.GetCoinTable();
        getCoinTable.setStart(start);
        getCoinTable.setEnd(end);
        const response = await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_GETCOINTABLE, getCoinTable);
        const coinTable = response.message;
        return coinTable.tableList;
    }
    // LoadDevice loads a provided seed onto the device and applies the provided settings
    // including setting a pin/device label, enabling/disabling the passphrase, and whether to
    // check the checksum of the provided mnemonic
    async loadDevice(msg) {
        const loadDevice = new $437b837d88ef5c30$exports.LoadDevice();
        loadDevice.setMnemonic(msg.mnemonic);
        loadDevice.setPassphraseProtection(!!msg.passphrase);
        loadDevice.setSkipChecksum(!!msg.skipChecksum);
        if (msg.pin) loadDevice.setPin(msg.pin);
        if (msg.label) loadDevice.setLabel(msg.label);
        // send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_LOADDEVICE, loadDevice, {
            msgTimeout: $7NkOr.LONG_TIMEOUT
        });
        this.cacheFeatures(undefined);
    }
    // RemovePin disables pin protection for the device. If a pin is currently enabled
    // it will prompt the user to enter the current pin
    async removePin() {
        const changePin = new $437b837d88ef5c30$exports.ChangePin();
        changePin.setRemove(true);
        // send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CHANGEPIN, changePin);
        this.cacheFeatures(undefined);
    }
    async send(events) {
        for (const event of events){
            const MessageType = (0, $941d05c7ef54f088$export$64c0007fb7fca8ef)[$7NkOr.mustBeDefined(event.message_enum)];
            const msg = new MessageType();
            Object.entries(event.message).forEach(([key, value])=>{
                const setterMethod = (0, $18acccdd0f9aa659$export$7f2590ea4e77478c)(key);
                if (msg[setterMethod]) // Assume setter methods are always of the format: strength -> setStrength
                // until this exists https://github.com/protocolbuffers/protobuf/issues/1591
                msg[setterMethod](value);
            });
            await this.transport.call($7NkOr.mustBeDefined(event.message_enum), msg);
        }
    }
    // SoftReset power cycles the device. The device only responds to
    // this message while in manufacturer mode
    async softReset() {
        const softReset = new $437b837d88ef5c30$exports.SoftReset();
        // send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_SOFTRESET, softReset);
        this.cacheFeatures(undefined);
    }
    // WipeDevice wipes all sensitive data and settings
    async wipe() {
        const wipeDevice = new $437b837d88ef5c30$exports.WipeDevice();
        // send
        await this.transport.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_WIPEDEVICE, wipeDevice);
        this.cacheFeatures(undefined);
    }
    async btcSupportsCoin(coin) {
        return this.info.btcSupportsCoin(coin);
    }
    async btcSupportsScriptType(coin, scriptType) {
        return this.info.btcSupportsScriptType(coin, scriptType);
    }
    async btcGetAddress(msg) {
        return $0396a8ef29b63193$export$21cad4f266f414c0(this, this.transport, msg);
    }
    async btcSignTx(msg) {
        return $0396a8ef29b63193$export$4a108889564ae71c(this, this.transport, msg);
    }
    async btcSupportsSecureTransfer() {
        return this.info.btcSupportsSecureTransfer();
    }
    btcSupportsNativeShapeShift() {
        return this.info.btcSupportsNativeShapeShift();
    }
    async ethSupportsEIP1559() {
        // EIP1559 support starts in v7.2.1
        return (0, (/*@__PURE__*/$parcel$interopDefault($3dec37221774706a$exports))).gte(await this.getFirmwareVersion(), "v7.2.1");
    }
    async btcSignMessage(msg) {
        return $0396a8ef29b63193$export$f393afb7041494e8(this, this.transport, msg);
    }
    async btcVerifyMessage(msg) {
        return $0396a8ef29b63193$export$5d3bd4730f650ae3(this, this.transport, msg);
    }
    btcGetAccountPaths(msg) {
        return this.info.btcGetAccountPaths(msg);
    }
    btcIsSameAccount(msg) {
        // TODO: mixed-mode segwit was added in v6.0.2
        // https://github.com/keepkey/keepkey-firmware/pull/81
        // if (firmware_version.lt('6.0.2') && msg.length > 1)
        //  return false
        return this.info.btcIsSameAccount(msg);
    }
    async ethSignTx(msg) {
        return $498e4f3d99501515$export$b845b4057200770d(this.transport, msg);
    }
    async ethGetAddress(msg) {
        return $498e4f3d99501515$export$52db94402edc4376(this.transport, msg);
    }
    async ethSignMessage(msg) {
        return $498e4f3d99501515$export$a578110d5d38f7e6(this.transport, msg);
    }
    async ethSignTypedData(msg) {
        return $498e4f3d99501515$export$52d7a3c627b1c409(this.transport, msg);
    }
    async ethVerifyMessage(msg) {
        return $498e4f3d99501515$export$acb9cc41cbb8b7de(this.transport, msg);
    }
    async ethSupportsNetwork(chain_id) {
        return this.info.ethSupportsNetwork(chain_id);
    }
    async ethSupportsSecureTransfer() {
        return this.info.ethSupportsSecureTransfer();
    }
    ethSupportsNativeShapeShift() {
        return this.info.ethSupportsNativeShapeShift();
    }
    ethGetAccountPaths(msg) {
        return this.info.ethGetAccountPaths(msg);
    }
    rippleGetAccountPaths(msg) {
        return this.info.rippleGetAccountPaths(msg);
    }
    rippleGetAddress(msg) {
        return $cde9fec45a163105$export$d1679ca16e9d8669(this.transport, msg);
    }
    rippleSignTx(msg) {
        return $cde9fec45a163105$export$39da8e0971833dd7(this.transport, msg);
    }
    cosmosGetAccountPaths(msg) {
        return this.info.cosmosGetAccountPaths(msg);
    }
    cosmosGetAddress(msg) {
        return $ee3499be6fffa9bb$export$85899f1e7d94790a(this.transport, msg);
    }
    cosmosSignTx(msg) {
        return $ee3499be6fffa9bb$export$ed75bd314543b412(this.transport, msg);
    }
    osmosisGetAccountPaths(msg) {
        return this.info.osmosisGetAccountPaths(msg);
    }
    osmosisGetAddress(msg) {
        return $a9300787f03269d5$export$e0d19f858238e335(this.transport, msg);
    }
    osmosisSignTx(msg) {
        return $a9300787f03269d5$export$a287510f3e061a50(this.transport, msg);
    }
    thorchainGetAccountPaths(msg) {
        return this.info.thorchainGetAccountPaths(msg);
    }
    thorchainGetAddress(msg) {
        return $1a4d3c81afb1ceaf$export$ac25b1d0e8050d9b(this.transport, msg);
    }
    thorchainSignTx(msg) {
        return $1a4d3c81afb1ceaf$export$4b62217da920de63(this.transport, msg);
    }
    mayachainGetAccountPaths(msg) {
        return this.info.mayachainGetAccountPaths(msg);
    }
    mayachainGetAddress(msg) {
        return $0fbcf8d6af2d9dc2$export$4396203deabecd(this.transport, msg);
    }
    mayachainSignTx(msg) {
        return $0fbcf8d6af2d9dc2$export$316aaf9a46bb31a5(this.transport, msg);
    }
    binanceGetAccountPaths(msg) {
        return this.info.binanceGetAccountPaths(msg);
    }
    binanceGetAddress(msg) {
        return $1df2ffc82308ac2c$export$d0c430e0a91cb179(this.transport, msg);
    }
    binanceSignTx(msg) {
        return $1df2ffc82308ac2c$export$baabfb5b222781c7(this.transport, msg);
    }
    eosGetAccountPaths(msg) {
        return this.info.eosGetAccountPaths(msg);
    }
    eosGetPublicKey(msg) {
        return $3c1604a9db806af4$export$526bf75314a8a0de(this.transport, msg);
    }
    eosSignTx(msg) {
        return $3c1604a9db806af4$export$62ad1ee4b348f12c(this.transport, msg);
    }
    describePath(msg) {
        return this.info.describePath(msg);
    }
    disconnect() {
        return this.transport.disconnect();
    }
    btcNextAccountPath(msg) {
        return this.info.btcNextAccountPath(msg);
    }
    ethNextAccountPath(msg) {
        return this.info.ethNextAccountPath(msg);
    }
    eosNextAccountPath(msg) {
        return this.info.eosNextAccountPath(msg);
    }
    cosmosNextAccountPath(msg) {
        return this.info.cosmosNextAccountPath(msg);
    }
    osmosisNextAccountPath(msg) {
        return this.info.osmosisNextAccountPath(msg);
    }
    rippleNextAccountPath(msg) {
        return this.info.rippleNextAccountPath(msg);
    }
    binanceNextAccountPath(msg) {
        return this.info.binanceNextAccountPath(msg);
    }
}
function $459ec2812757e70b$export$a80b3bd66acc52ff() {
    return new $459ec2812757e70b$export$b1870a8e6b6fd706();
}
function $459ec2812757e70b$export$185802fd694ee1f5(transport) {
    return new $459ec2812757e70b$export$c3ae0991ce69a474(transport);
}




parcelRequire("lFpDy");
var $hNfwf = parcelRequire("hNfwf");
var $7NkOr = parcelRequire("7NkOr");
var $3a5kd = parcelRequire("3a5kd");
var $34AFc = parcelRequire("34AFc");

var $aO8Ot = parcelRequire("aO8Ot");

var $2MzPv = parcelRequire("2MzPv");


class $8ca73ec23f6e4ddf$export$86495b081fef8e52 extends $34AFc.Transport {
    constructor(keyring, delegate){
        super(keyring);
        this.debugLink = false;
        this.userActionRequired = false;
        /// One per transport, unlike on Trezor, since the contention is
        /// only per-device, not global.
        this.callInProgress = {
            main: undefined,
            debug: undefined
        };
        this.delegate = delegate;
    }
    static async create(keyring, delegate) {
        return new $8ca73ec23f6e4ddf$export$86495b081fef8e52(keyring, delegate);
    }
    isOpened() {
        return this.delegate.isOpened();
    }
    getDeviceID() {
        return this.delegate.getDeviceID();
    }
    connect() {
        return this.delegate.connect();
    }
    async tryConnectDebugLink() {
        let out = false;
        if (this.delegate.tryConnectDebugLink && await this.delegate.tryConnectDebugLink()) out = true;
        this.debugLink = out;
        return out;
    }
    disconnect() {
        return this.delegate.disconnect();
    }
    async write(buf, debugLink) {
        // break frame into segments
        for(let i = 0; i < buf.length; i += (0, $18acccdd0f9aa659$export$3992177e206fbb4d)){
            const segment = buf.slice(i, i + (0, $18acccdd0f9aa659$export$3992177e206fbb4d));
            const padding = new Uint8Array((0, $18acccdd0f9aa659$export$3992177e206fbb4d) - segment.length);
            const fragments = [];
            fragments.push(new Uint8Array([
                (0, $18acccdd0f9aa659$export$3992177e206fbb4d)
            ]));
            fragments.push(segment);
            fragments.push(padding);
            const fragmentBuffer = new Uint8Array(fragments.map((x)=>x.length).reduce((a, x)=>a + x, 0));
            fragments.reduce((a, x)=>(fragmentBuffer.set(x, a), a + x.length), 0);
            await this.delegate.writeChunk(fragmentBuffer, debugLink);
        }
    }
    async read(debugLink) {
        const first = await this.delegate.readChunk(debugLink);
        // Check that buffer starts with: "?##" [ 0x3f, 0x23, 0x23 ]
        // "?" = USB reportId, "##" = KeepKey magic bytes
        // Message ID is bytes 4-5. Message length starts at byte 6.
        const firstView = new DataView(first.buffer.slice(first.byteOffset, first.byteOffset + first.byteLength));
        const valid = (firstView.getUint32(0) & 0xffffff00) === 0x3f232300;
        const msgLength = firstView.getUint32(5);
        if (!valid) throw new Error("message not valid");
        const buffer = new Uint8Array(9 + msgLength);
        buffer.set(first.slice(0, Math.min(first.length, buffer.length)));
        for(let offset = first.length; offset < buffer.length;){
            // Drop USB "?" reportId in the first byte
            const next = (await this.delegate.readChunk(debugLink)).slice(1);
            buffer.set(next.slice(0, Math.min(next.length, buffer.length - offset)), offset);
            offset += next.length;
        }
        return buffer;
    }
    getVendor() {
        return "KeepKey";
    }
    getEntropy(length) {
        if (typeof window !== "undefined" && window?.crypto) return window.crypto.getRandomValues(new Uint8Array(length));
        return $aO8Ot.randomBytes(length);
    }
    async getFirmwareHash(firmware) {
        if (typeof window !== "undefined" && window?.crypto) return new Uint8Array(await window.crypto.subtle.digest({
            name: "SHA-256"
        }, firmware));
        const hash = $aO8Ot.createHash("sha256");
        hash.update(firmware);
        return hash.digest();
    }
    /**
   * Utility function to cancel all pending calls whenver one of them is cancelled.
   */ async cancellable(inProgress) {
        try {
            await inProgress;
        } catch (e) {
            // Throw away the error, as the other context will handle it,
            // unless it was a cancel, in which case we cancel everything.
            if ($7NkOr.isIndexable(e) && e.type === $hNfwf.HDWalletErrorType.ActionCancelled) {
                this.callInProgress = {
                    main: undefined,
                    debug: undefined
                };
                throw e;
            }
        }
    }
    async lockDuring(action) {
        this.callInProgress.main = (async ()=>{
            await this.cancellable(this.callInProgress.main);
            return action();
        })();
        return this.callInProgress.main;
    }
    async handleCancellableResponse() {
        return this.readResponse(false);
    }
    async readResponse(debugLink) {
        let buf;
        do buf = await this.read(debugLink);
        while (!buf);
        const [msgTypeEnum, msg] = this.fromMessageBuffer(buf);
        const event = $3a5kd.makeEvent({
            message_type: (0, $941d05c7ef54f088$export$b26b7eecad5f37af)[msgTypeEnum],
            message_enum: msgTypeEnum,
            message: msg.toObject(),
            proto: msg,
            from_wallet: true
        });
        this.emit(String(msgTypeEnum), event);
        if (debugLink) return event;
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FAILURE) {
            const failureEvent = $3a5kd.makeEvent({
                message_type: $3a5kd.Events.FAILURE,
                message_enum: msgTypeEnum,
                message: msg.toObject(),
                from_wallet: true
            });
            this.emit($3a5kd.Events.FAILURE, failureEvent);
            return failureEvent;
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BUTTONREQUEST) {
            this.emit($3a5kd.Events.BUTTON_REQUEST, $3a5kd.makeEvent({
                message_type: $3a5kd.Events.BUTTON_REQUEST,
                from_wallet: true
            }));
            this.userActionRequired = true;
            return this.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BUTTONACK, new $437b837d88ef5c30$exports.ButtonAck(), {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ENTROPYREQUEST) {
            const ack = new $437b837d88ef5c30$exports.EntropyAck();
            ack.setEntropy(this.getEntropy(32));
            return this.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_ENTROPYACK, ack, {
                msgTimeout: $7NkOr.LONG_TIMEOUT,
                omitLock: true
            });
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PINMATRIXREQUEST) {
            this.emit($3a5kd.Events.PIN_REQUEST, $3a5kd.makeEvent({
                message_type: $3a5kd.Events.PIN_REQUEST,
                from_wallet: true
            }));
            this.userActionRequired = true;
            return this.handleCancellableResponse();
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PASSPHRASEREQUEST) {
            this.emit($3a5kd.Events.PASSPHRASE_REQUEST, $3a5kd.makeEvent({
                message_type: $3a5kd.Events.PASSPHRASE_REQUEST,
                from_wallet: true
            }));
            this.userActionRequired = true;
            return this.handleCancellableResponse();
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CHARACTERREQUEST) {
            this.emit($3a5kd.Events.CHARACTER_REQUEST, $3a5kd.makeEvent({
                message_type: $3a5kd.Events.CHARACTER_REQUEST,
                from_wallet: true
            }));
            this.userActionRequired = true;
            return this.handleCancellableResponse();
        }
        if (msgTypeEnum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_WORDREQUEST) {
            this.emit($3a5kd.Events.WORD_REQUEST, $3a5kd.makeEvent({
                message_type: $3a5kd.Events.WORD_REQUEST,
                from_wallet: true
            }));
            this.userActionRequired = true;
            return this.handleCancellableResponse();
        }
        return event;
    }
    async call(msgTypeEnum, msg, options) {
        options ??= {};
        options.msgTimeout ??= $7NkOr.DEFAULT_TIMEOUT;
        this.emit(String(msgTypeEnum), $3a5kd.makeEvent({
            message_type: (0, $941d05c7ef54f088$export$b26b7eecad5f37af)[msgTypeEnum],
            message_enum: msgTypeEnum,
            message: msg.toObject(),
            proto: msg,
            from_wallet: false
        }));
        const makePromise = async ()=>{
            if ([
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_BUTTONACK,
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PASSPHRASEACK,
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CHARACTERACK,
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_PINMATRIXACK,
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_WORDACK
            ].includes(msgTypeEnum)) this.userActionRequired = true;
            await this.write(this.toMessageBuffer(msgTypeEnum, msg), !!options?.debugLink);
            if (options?.noWait) return undefined;
            const response = await this.readResponse(!!options?.debugLink);
            this.userActionRequired = false;
            if (response.message_enum === $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FAILURE && response.message.code === $d4cdf7121546d3d6$exports.FailureType.FAILURE_ACTIONCANCELLED) {
                this.callInProgress = {
                    main: undefined,
                    debug: undefined
                };
                throw new $hNfwf.ActionCancelled();
            }
            if (response.message_type === $3a5kd.Events.FAILURE) throw response;
            return response;
        };
        if (options?.omitLock) return makePromise();
        // See the comments in hdwallet-trezor-connect's call for why this weird
        // sequence. We've got a very similar issue here that needs pretty much
        // the same solution.
        const lockKey = options?.debugLink ? "debug" : "main";
        this.callInProgress[lockKey] = (async ()=>{
            await this.cancellable(this.callInProgress[lockKey]);
            try {
                return makePromise();
            } finally{
                this.userActionRequired = false;
            }
        })();
        return await this.callInProgress[lockKey];
    }
    async cancel() {
        if (!this.userActionRequired) return;
        try {
            this.callInProgress = {
                main: undefined,
                debug: undefined
            };
            const cancelMsg = new $437b837d88ef5c30$exports.Cancel();
            await this.call($437b837d88ef5c30$exports.MessageType.MESSAGETYPE_CANCEL, cancelMsg, {
                omitLock: this.userActionRequired,
                noWait: this.userActionRequired
            });
        } catch (e) {
            console.error("Cancel Pending Error", e);
        } finally{
            this.callInProgress = {
                main: undefined,
                debug: undefined
            };
        }
    }
    toMessageBuffer(msgTypeEnum, msg) {
        const messageBuffer = msg.serializeBinary();
        const headerBuffer = new Uint8Array(8);
        const headerView = new DataView(headerBuffer.buffer);
        headerView.setUint8(0, 0x23);
        headerView.setUint8(1, 0x23);
        headerView.setUint16(2, msgTypeEnum);
        headerView.setUint32(4, messageBuffer.byteLength);
        const fragments = [
            headerBuffer,
            messageBuffer
        ];
        const fragmentBuffer = new Uint8Array(fragments.map((x)=>x.length).reduce((a, x)=>a + x, 0));
        fragments.reduce((a, x)=>(fragmentBuffer.set(x, a), a + x.length), 0);
        return fragmentBuffer;
    }
    fromMessageBuffer(buf) {
        const typeID = new DataView(buf.buffer).getUint16(3);
        const MType = (0, $941d05c7ef54f088$export$64c0007fb7fca8ef)[typeID];
        if (!MType) {
            const msg = new $437b837d88ef5c30$exports.Failure();
            msg.setCode($d4cdf7121546d3d6$exports.FailureType.FAILURE_UNEXPECTEDMESSAGE);
            msg.setMessage("Unknown message type received");
            return [
                $437b837d88ef5c30$exports.MessageType.MESSAGETYPE_FAILURE,
                msg
            ];
        }
        const msg = new MType();
        const reader = new $2MzPv.BinaryReader(buf, 9, buf.length - 9);
        return [
            typeID,
            MType.deserializeBinaryFromReader(msg, reader)
        ];
    }
    static failureMessageFactory(e) {
        const msg = new $437b837d88ef5c30$exports.Failure();
        msg.setCode($d4cdf7121546d3d6$exports.FailureType.FAILURE_UNEXPECTEDMESSAGE);
        if (typeof e === "string") msg.setMessage(e);
        else msg.setMessage(String(e));
        return msg.serializeBinary();
    }
}


class $d84495c5fd63ebe9$export$906fdd6a257127ec {
    constructor(keyring, delegate){
        this.keyring = keyring;
        this.delegate = delegate;
        try {
            this.delegate.registerCallbacks?.(this.handleConnect.bind(this), this.handleDisconnect.bind(this));
        } catch (e) {
            console.error(e);
        }
    }
    static fromDelegate(delegate) {
        const fn = (keyring)=>new $d84495c5fd63ebe9$export$906fdd6a257127ec(keyring, delegate);
        const out = fn;
        out.useKeyring = fn;
        return out;
    }
    static async inspectDevice(delegate, device) {
        const props = await Promise.resolve(delegate.inspectDevice?.(device)) ?? ([
            "object",
            "function"
        ].includes(typeof device) ? device : {});
        if (!props.serialNumber && typeof device === "string") props.serialNumber = device;
        return {
            get productName () {
                const out = props["productName"];
                return typeof out === "string" ? out : "KeepKey";
            },
            get serialNumber () {
                const out = props["serialNumber"];
                if (typeof out !== "string") throw new Error("could not get serialNumber from device");
                return out;
            }
        };
    }
    async inspectDevice(device) {
        return $d84495c5fd63ebe9$export$906fdd6a257127ec.inspectDevice(this.delegate, device);
    }
    async handleConnect(device) {
        try {
            await this.initialize([
                device
            ]);
            const { productName: productName, serialNumber: serialNumber } = await this.inspectDevice(device);
            await this.keyring.emit([
                productName,
                serialNumber,
                $3a5kd.Events.CONNECT
            ], serialNumber);
        } catch (e) {
            console.error(e);
        }
    }
    async handleDisconnect(device) {
        const { productName: productName, serialNumber: serialNumber } = await this.inspectDevice(device);
        try {
            await this.keyring.remove(serialNumber);
        } catch  {
        // swallow keyring removal errors
        }
        await this.keyring.emit([
            productName,
            serialNumber,
            $3a5kd.Events.DISCONNECT
        ], serialNumber);
    }
    async initialize(devices, tryDebugLink, autoConnect) {
        devices = devices ?? await this.getDevices();
        for (const device of devices){
            const { serialNumber: serialNumber } = await this.inspectDevice(device);
            if (this.keyring.wallets[serialNumber]) await this.keyring.remove(serialNumber);
            const delegate = await this.getTransportDelegate(device);
            if (delegate === null) continue;
            const transport = await (0, $8ca73ec23f6e4ddf$export$86495b081fef8e52).create(this.keyring, delegate);
            await transport.connect();
            if (tryDebugLink) await transport.tryConnectDebugLink();
            const wallet = await (0, $459ec2812757e70b$export$c3ae0991ce69a474).create(transport);
            if (autoConnect) await wallet.initialize();
            this.keyring.add(wallet, serialNumber);
        }
        return Object.keys(this.keyring.wallets).length;
    }
    async getDevice(serialNumber) {
        if (this.delegate.getDevice) return await this.delegate.getDevice(serialNumber);
        if (!serialNumber) throw new Error("no default device specified");
        const devices = await this.getDevices();
        return (await Promise.all(devices.map(async (x)=>(await this.inspectDevice(x)).serialNumber === serialNumber ? x : null))).filter((x)=>x !== null)[0];
    }
    async getDevices() {
        if (this.delegate.getDevices) return await this.delegate.getDevices();
        let defaultDevice = undefined;
        try {
            defaultDevice = await this.getDevice();
        } catch  {
        // swallow default device fetch errors
        }
        return defaultDevice ? [
            defaultDevice
        ] : [];
    }
    async getTransportDelegate(device) {
        return await this.delegate.getTransportDelegate(device);
    }
    async pairDevice(serialNumber, tryDebugLink) {
        const device = await this.getDevice(serialNumber);
        if (!device) throw new Error(serialNumber ? `could not find device matching serial number '${serialNumber}'` : "could not find default device");
        return this.pairRawDevice(device, tryDebugLink);
    }
    async pairRawDevice(device, tryDebugLink) {
        await this.initialize([
            device
        ], tryDebugLink, true);
        return $7NkOr.mustBeDefined(this.keyring.get((await this.inspectDevice(device)).serialNumber));
    }
}









parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");
var $60813fe03488687f$exports = {};

$60813fe03488687f$exports = (parcelRequire("49Skf"));



var $ihoyg = parcelRequire("ihoyg");
var $34fe416937167198$require$Buffer = $ihoyg.Buffer;
class $34fe416937167198$export$de936d49666cae1 {
    constructor(config){
        this.axiosInstance = null;
        this.config = {
            ...config,
            headers: {
                "content-type": "application/json",
                "Access-Control-Allow-Origin": config.baseURL
            }
        };
    }
    async getDeviceID() {
        return this.config.baseURL;
    }
    async isOpened() {
        return !!this.axiosInstance;
    }
    async connect() {
        this.axiosInstance = (0, (/*@__PURE__*/$parcel$interopDefault($60813fe03488687f$exports))).create(this.config);
    }
    async tryConnectDebugLink() {
        return true;
    }
    async disconnect() {
        this.axiosInstance = null;
    }
    async writeChunk(buf, debugLink) {
        const data = $34fe416937167198$require$Buffer.from(buf).toString("hex");
        await $7NkOr.mustBeDefined(this.axiosInstance).post(debugLink ? "/exchange/debug" : "/exchange/device", {
            data: data
        });
    }
    async readChunk(debugLink) {
        const { data: { data: data } } = await $7NkOr.mustBeDefined(this.axiosInstance).get(debugLink ? "/exchange/debug" : "/exchange/device");
        return $34fe416937167198$require$Buffer.from(data, "hex");
    }
}


const $034d6bd0745942b1$export$51d36903f06f4733 = {
    async getDevice (host) {
        return {
            baseURL: host
        };
    },
    async getTransportDelegate (config) {
        return new (0, $34fe416937167198$export$de936d49666cae1)(config);
    },
    async inspectDevice (config) {
        return {
            serialNumber: config.baseURL
        };
    }
};
const $034d6bd0745942b1$export$906fdd6a257127ec = $d84495c5fd63ebe9$export$906fdd6a257127ec.fromDelegate($034d6bd0745942b1$export$51d36903f06f4733);
const $034d6bd0745942b1$export$99cf9dd423484e6a = $034d6bd0745942b1$export$906fdd6a257127ec;



const $dda3a4503eac84d7$export$5a47fd4787da9a04 = 0x2b24;
const $dda3a4503eac84d7$export$1174cd6f07f33876 = 0x0002;
const $dda3a4503eac84d7$export$1d98ad1cd0e1983e = 0x0001;




parcelRequire("lFpDy");
var $7NkOr = parcelRequire("7NkOr");
var $hNfwf = parcelRequire("hNfwf");

parcelRequire("lFpDy");
var $hNfwf = parcelRequire("hNfwf");
var $7NkOr = parcelRequire("7NkOr");

const $15a671e04abb5e87$export$5a47fd4787da9a04 = 0x2b24;
const $15a671e04abb5e87$export$1174cd6f07f33876 = 0x0002;
const $15a671e04abb5e87$export$1d98ad1cd0e1983e = 0x0001;


class $04072ff71d87f8c2$export$de936d49666cae1 {
    constructor(usbDevice){
        if (usbDevice.vendorId !== (0, $15a671e04abb5e87$export$5a47fd4787da9a04)) throw new $hNfwf.WebUSBCouldNotPair("KeepKey", "bad vendor id");
        if (usbDevice.productId !== (0, $15a671e04abb5e87$export$1174cd6f07f33876)) throw new $hNfwf.FirmwareUpdateRequired("KeepKey", "6.1.0");
        this.usbDevice = usbDevice;
    }
    static async create(device) {
        if (device.vendorId !== (0, $15a671e04abb5e87$export$5a47fd4787da9a04)) return null;
        return new $04072ff71d87f8c2$export$de936d49666cae1(device);
    }
    async getDeviceID() {
        return this.usbDevice.serialNumber;
    }
    async isOpened() {
        return this.usbDevice.opened;
    }
    async connect() {
        await this.usbDevice.open();
        if (this.usbDevice.configuration === null) await this.usbDevice.selectConfiguration(1);
        try {
            await this.usbDevice.claimInterface(0);
        } catch (e) {
            console.error("Could not claim interface 0", this.usbDevice, {
                e: e
            });
            if ($7NkOr.isIndexable(e) && e.code === 18) // "The requested interface implements a protected class"
            throw new $hNfwf.FirmwareUpdateRequired("KeepKey", "6.1.0");
            if ($7NkOr.isIndexable(e) && e.code === 19) // "Unable to claim interface"
            throw new $hNfwf.ConflictingApp("KeepKey");
            throw e;
        }
    }
    async tryConnectDebugLink() {
        // We have to use "guess & check" here because the browser doesn't give us a
        // way to inspect the descriptors :(
        try {
            await this.usbDevice.claimInterface(1);
            return true;
        } catch (e) {
            return false;
        }
    }
    async disconnect() {
        if (!this.usbDevice.opened) return;
        try {
            // If the device is disconnected, this will fail and throw, which is fine.
            await this.usbDevice.close();
        } catch (e) {
            console.warn("Error closing connection with usbDevice");
        }
    }
    async writeChunk(buf, debugLink) {
        await this.usbDevice.transferOut(debugLink ? 2 : 1, buf.buffer.slice(buf.byteOffset, buf.byteOffset + buf.byteLength));
    }
    async readChunk(debugLink) {
        const { status: status, data: data } = await this.usbDevice.transferIn(debugLink ? 2 : 1, $18acccdd0f9aa659$export$3992177e206fbb4d + 1);
        if (status === "stall") await this.usbDevice.clearHalt("out", debugLink ? 2 : 1);
        if (data === undefined) throw new Error("bad read");
        return new Uint8Array($7NkOr.toArrayBuffer(data));
    }
}



// This avoids a prompt ReferenceError if the module is imported outside a browser.
const $a42c9d68bdee87de$var$webUSB = typeof window === "object" && window?.navigator?.usb;
function $a42c9d68bdee87de$var$assertWebUSB(x) {
    if (!x) throw new $hNfwf.WebUSBNotAvailable();
}
const $a42c9d68bdee87de$export$c74d920b0c961ec4 = {
    async getDevices () {
        $a42c9d68bdee87de$var$assertWebUSB($a42c9d68bdee87de$var$webUSB);
        const devices = (await $a42c9d68bdee87de$var$webUSB.getDevices()).filter((d)=>d.serialNumber !== undefined);
        return devices.filter((x)=>x.vendorId === (0, $15a671e04abb5e87$export$5a47fd4787da9a04) && [
                (0, $15a671e04abb5e87$export$1174cd6f07f33876),
                (0, $15a671e04abb5e87$export$1d98ad1cd0e1983e)
            ].includes(x.productId));
    },
    async getDevice (serialNumber) {
        $a42c9d68bdee87de$var$assertWebUSB($a42c9d68bdee87de$var$webUSB);
        try {
            const out = await $a42c9d68bdee87de$var$webUSB.requestDevice({
                filters: [
                    {
                        vendorId: (0, $15a671e04abb5e87$export$5a47fd4787da9a04),
                        productId: (0, $15a671e04abb5e87$export$1174cd6f07f33876),
                        serialNumber: serialNumber
                    },
                    {
                        vendorId: (0, $15a671e04abb5e87$export$5a47fd4787da9a04),
                        productId: (0, $15a671e04abb5e87$export$1d98ad1cd0e1983e),
                        serialNumber: serialNumber
                    }
                ]
            });
            if (out.serialNumber === undefined) throw new Error("expected serial number");
            return out;
        } catch (e) {
            throw new $hNfwf.WebUSBCouldNotPair("KeepKey", String($7NkOr.isIndexable(e) ? e.message : e));
        }
    },
    async getTransportDelegate (device) {
        return new (0, $04072ff71d87f8c2$export$de936d49666cae1)(device);
    },
    registerCallbacks (handleConnect, handleDisconnect) {
        $a42c9d68bdee87de$var$assertWebUSB($a42c9d68bdee87de$var$webUSB);
        async function handleUSBEvent(connecting, e) {
            const device = e.device;
            if (device.vendorId !== (0, $15a671e04abb5e87$export$5a47fd4787da9a04)) return;
            if (device.productId !== (0, $15a671e04abb5e87$export$1174cd6f07f33876)) return;
            return (connecting ? handleConnect : handleDisconnect)(device);
        }
        $a42c9d68bdee87de$var$webUSB.addEventListener("connect", handleUSBEvent.bind(null, true));
        $a42c9d68bdee87de$var$webUSB.addEventListener("disconnect", handleUSBEvent.bind(null, false));
    }
};
const $a42c9d68bdee87de$export$906fdd6a257127ec = $d84495c5fd63ebe9$export$906fdd6a257127ec.fromDelegate($a42c9d68bdee87de$export$c74d920b0c961ec4);
const $a42c9d68bdee87de$export$d9bc819ab1cac3ac = $a42c9d68bdee87de$export$906fdd6a257127ec;






var $06a8c24e42bf2f0f$exports = {};
"use strict";
var $06a8c24e42bf2f0f$var$__createBinding = $06a8c24e42bf2f0f$exports && $06a8c24e42bf2f0f$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $06a8c24e42bf2f0f$var$__setModuleDefault = $06a8c24e42bf2f0f$exports && $06a8c24e42bf2f0f$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $06a8c24e42bf2f0f$var$__exportStar = $06a8c24e42bf2f0f$exports && $06a8c24e42bf2f0f$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $06a8c24e42bf2f0f$var$__createBinding(exports1, m, p);
};
var $06a8c24e42bf2f0f$var$__importStar = $06a8c24e42bf2f0f$exports && $06a8c24e42bf2f0f$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $06a8c24e42bf2f0f$var$__createBinding(result, mod, k);
    }
    $06a8c24e42bf2f0f$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($06a8c24e42bf2f0f$exports, "__esModule", {
    value: true
});
$06a8c24e42bf2f0f$exports.crypto = void 0;

$06a8c24e42bf2f0f$var$__exportStar((parcelRequire("6X6Ju")), $06a8c24e42bf2f0f$exports);

$06a8c24e42bf2f0f$exports.crypto = $06a8c24e42bf2f0f$var$__importStar((parcelRequire("4GN4F")));

$06a8c24e42bf2f0f$var$__exportStar((parcelRequire("e6mku")), $06a8c24e42bf2f0f$exports);



var $768377ac0536d182$exports = {};
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if (typeof $768377ac0536d182$exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    $768377ac0536d182$exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : $768377ac0536d182$exports, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function(callback) {
            return jQuery.each(this, callback);
        },
        map: function(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function() {
            return this.eq(0);
        },
        last: function() {
            return this.eq(-1);
        },
        even: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function(msg) {
            throw new Error(msg);
        },
        noop: function() {},
        isPlainObject: function(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\x00") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\x00-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return node && node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            node = elem.getAttributeNode("id");
                            if (node && node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                node = elem.getAttributeNode("id");
                                if (node && node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function(elem) {
                    return elem === documentElement;
                },
                focus: function(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function(elem) {
            return siblings(elem.firstChild);
        },
        contents: function(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function() {
                    return state;
                },
                always: function() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, nodeName = elem.nodeName, display = defaultDisplayMap[nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function() {
            return showHide(this, true);
        },
        hide: function() {
            return showHide(this);
        },
        toggle: function(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (nodeName === "input" || nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function(html) {
            return html;
        },
        clone: function(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function(selector) {
            return remove(this, selector, true);
        },
        remove: function(selector) {
            return remove(this, selector);
        },
        text: function(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value;
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function(p) {
            return p;
        },
        swing: function(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function(type, clearQueue, gotoEnd) {
            var stopQueue = function(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function(value, stateVal) {
            var classNames, className, i, self, type = typeof value, isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function(key) {
                    var match;
                    if (completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function() {
                    return completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function(name, value) {
                    if (completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function(type) {
                    if (completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function(map) {
                    var code;
                    if (map) {
                        if (completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (completed) return;
                completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});


var $45dd0a73038568f0$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 *   Gav Wood <gav@parity.io>
 *   Jeffrey Wilcke <jeffrey.wilcke@ethereum.org>
 *   Marek Kotewicz <marek@parity.io>
 *   Marian Oancea <marian@ethereum.org>
 * @date 2017
 */ "use strict";
var $34f6b12022aeac1d$exports = {};
$34f6b12022aeac1d$exports = JSON.parse('{"name":"web3","version":"1.5.1","description":"Ethereum JavaScript API","repository":"https://github.com/ethereum/web3.js","license":"LGPL-3.0","engines":{"node":">=8.0.0"},"main":"lib/index.js","bugs":{"url":"https://github.com/ethereum/web3.js/issues"},"keywords":["Ethereum","JavaScript","API"],"author":"ethereum.org","types":"types/index.d.ts","scripts":{"compile":"tsc -b tsconfig.json","dtslint":"dtslint --localTs ../../node_modules/typescript/lib types","postinstall":"echo \\"WARNING: the web3-shh and web3-bzz api will be deprecated in the next version\\""},"authors":[{"name":"Fabian Vogelsteller","email":"fabian@ethereum.org","homepage":"http://frozeman.de"},{"name":"Marek Kotewicz","email":"marek@parity.io","url":"https://github.com/debris"},{"name":"Marian Oancea","url":"https://github.com/cubedro"},{"name":"Gav Wood","email":"g@parity.io","homepage":"http://gavwood.com"},{"name":"Jeffery Wilcke","email":"jeffrey.wilcke@ethereum.org","url":"https://github.com/obscuren"}],"dependencies":{"web3-bzz":"1.5.1","web3-core":"1.5.1","web3-eth":"1.5.1","web3-eth-personal":"1.5.1","web3-net":"1.5.1","web3-shh":"1.5.1","web3-utils":"1.5.1"},"devDependencies":{"@types/node":"^12.12.6","dtslint":"^3.4.1","typescript":"^3.9.5","web3-core-helpers":"1.5.1"},"gitHead":"37a046d53ba193e89f3c53921c8b0ddc6a2e86fe"}');


var $45dd0a73038568f0$require$version = $34f6b12022aeac1d$exports.version;
var $c0d140841aa0e2a6$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ var $2da6253b89d591af$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $4zyeF = parcelRequire("4zyeF");
var $2da6253b89d591af$require$callbackify = $4zyeF.callbackify;

var $heyrh = parcelRequire("heyrh");
var $2da6253b89d591af$require$errors = $heyrh.errors;
var $e538a1c8675eb279$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /** @file jsonrpc.js
 * @authors:
 *   Fabian Vogelsteller <fabian@ethereum.org>
 *   Marek Kotewicz <marek@ethdev.com>
 *   Aaron Kumavis <aaron@kumavis.me>
 * @date 2015
 */ "use strict";
// Initialize Jsonrpc as a simple object with utility functions.
var $e538a1c8675eb279$var$Jsonrpc = {
    messageId: 0
};
/**
 * Should be called to valid json create payload object
 *
 * @method toPayload
 * @param {Function} method of jsonrpc call, required
 * @param {Array} params, an array of method params, optional
 * @returns {Object} valid jsonrpc payload object
 */ $e538a1c8675eb279$var$Jsonrpc.toPayload = function(method, params) {
    if (!method) throw new Error('JSONRPC method should be specified for params: "' + JSON.stringify(params) + '"!');
    // advance message ID
    $e538a1c8675eb279$var$Jsonrpc.messageId++;
    return {
        jsonrpc: "2.0",
        id: $e538a1c8675eb279$var$Jsonrpc.messageId,
        method: method,
        params: params || []
    };
};
/**
 * Should be called to check if jsonrpc response is valid
 *
 * @method isValidResponse
 * @param {Object}
 * @returns {Boolean} true if response is valid, otherwise false
 */ $e538a1c8675eb279$var$Jsonrpc.isValidResponse = function(response) {
    return Array.isArray(response) ? response.every(validateSingleMessage) : validateSingleMessage(response);
    function validateSingleMessage(message) {
        return !!message && !message.error && message.jsonrpc === "2.0" && (typeof message.id === "number" || typeof message.id === "string") && message.result !== undefined; // only undefined is not valid json object
    }
};
/**
 * Should be called to create batch payload object
 *
 * @method toBatchPayload
 * @param {Array} messages, an array of objects with method (required) and params (optional) fields
 * @returns {Array} batch payload
 */ $e538a1c8675eb279$var$Jsonrpc.toBatchPayload = function(messages) {
    return messages.map(function(message) {
        return $e538a1c8675eb279$var$Jsonrpc.toPayload(message.method, message.params);
    });
};
$e538a1c8675eb279$exports = $e538a1c8675eb279$var$Jsonrpc;


var $364cb87526f158eb$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file batch.js
 * @author Marek Kotewicz <marek@ethdev.com>
 * @date 2015
 */ "use strict";


var $heyrh = parcelRequire("heyrh");
var $364cb87526f158eb$require$errors = $heyrh.errors;
var $364cb87526f158eb$var$Batch = function(requestManager) {
    this.requestManager = requestManager;
    this.requests = [];
};
/**
 * Should be called to add create new request to batch request
 *
 * @method add
 * @param {Object} jsonrpc requet object
 */ $364cb87526f158eb$var$Batch.prototype.add = function(request) {
    this.requests.push(request);
};
/**
 * Should be called to execute batch request
 *
 * @method execute
 */ $364cb87526f158eb$var$Batch.prototype.execute = function() {
    var requests = this.requests;
    this.requestManager.sendBatch(requests, function(err, results) {
        results = results || [];
        requests.map(function(request, index) {
            return results[index] || {};
        }).forEach(function(result, index) {
            if (requests[index].callback) {
                if (result && result.error) return requests[index].callback($364cb87526f158eb$require$errors.ErrorResponse(result));
                if (!$e538a1c8675eb279$exports.isValidResponse(result)) return requests[index].callback($364cb87526f158eb$require$errors.InvalidResponse(result));
                try {
                    requests[index].callback(null, requests[index].format ? requests[index].format(result.result) : result.result);
                } catch (err) {
                    requests[index].callback(err);
                }
            }
        });
    });
};
$364cb87526f158eb$exports = $364cb87526f158eb$var$Batch;


var $8024cf11c28d403b$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file givenProvider.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $8024cf11c28d403b$var$givenProvider = null;
// ADD GIVEN PROVIDER
/* jshint ignore:start */ var $8024cf11c28d403b$var$global;
try {
    $8024cf11c28d403b$var$global = Function("return this")();
} catch (e) {
    $8024cf11c28d403b$var$global = window;
}
// EIP-1193: window.ethereum
if (typeof $8024cf11c28d403b$var$global.ethereum !== "undefined") $8024cf11c28d403b$var$givenProvider = $8024cf11c28d403b$var$global.ethereum;
else if (typeof $8024cf11c28d403b$var$global.web3 !== "undefined" && $8024cf11c28d403b$var$global.web3.currentProvider) {
    if ($8024cf11c28d403b$var$global.web3.currentProvider.sendAsync) {
        $8024cf11c28d403b$var$global.web3.currentProvider.send = $8024cf11c28d403b$var$global.web3.currentProvider.sendAsync;
        delete $8024cf11c28d403b$var$global.web3.currentProvider.sendAsync;
    }
    // if connection is 'ipcProviderWrapper', add subscription support
    if (!$8024cf11c28d403b$var$global.web3.currentProvider.on && $8024cf11c28d403b$var$global.web3.currentProvider.connection && $8024cf11c28d403b$var$global.web3.currentProvider.connection.constructor.name === "ipcProviderWrapper") $8024cf11c28d403b$var$global.web3.currentProvider.on = function(type, callback) {
        if (typeof callback !== "function") throw new Error("The second parameter callback must be a function.");
        switch(type){
            case "data":
                this.connection.on("data", function(data) {
                    var result = "";
                    data = data.toString();
                    try {
                        result = JSON.parse(data);
                    } catch (e) {
                        return callback(new Error("Couldn't parse response data" + data));
                    }
                    // notification
                    if (!result.id && result.method.indexOf("_subscription") !== -1) callback(null, result);
                });
                break;
            default:
                this.connection.on(type, callback);
                break;
        }
    };
    $8024cf11c28d403b$var$givenProvider = $8024cf11c28d403b$var$global.web3.currentProvider;
}
/* jshint ignore:end */ $8024cf11c28d403b$exports = $8024cf11c28d403b$var$givenProvider;


/**
 * It's responsible for passing messages to providers
 * It's also responsible for polling the ethereum node for incoming messages
 * Default poll timeout is 1 second
 * Singleton
 *
 * @param {string|Object}provider
 * @param {Net.Socket} net
 *
 * @constructor
 */ var $2da6253b89d591af$var$RequestManager = function RequestManager(provider, net) {
    this.provider = null;
    this.providers = RequestManager.providers;
    this.setProvider(provider, net);
    this.subscriptions = new Map();
};
$2da6253b89d591af$var$RequestManager.givenProvider = $8024cf11c28d403b$exports;



$2da6253b89d591af$var$RequestManager.providers = {
    WebsocketProvider: (parcelRequire("6iS4i")),
    HttpProvider: (parcelRequire("9DK0x")),
    IpcProvider: (parcelRequire("2g8iy"))
};
/**
 * Should be used to set provider of request manager
 *
 * @method setProvider
 *
 * @param {Object} provider
 * @param {net.Socket} net
 *
 * @returns void
 */ $2da6253b89d591af$var$RequestManager.prototype.setProvider = function(provider, net) {
    var _this = this;
    // autodetect provider
    if (provider && typeof provider === "string" && this.providers) {
        // HTTP
        if (/^http(s)?:\/\//i.test(provider)) provider = new this.providers.HttpProvider(provider);
        else if (/^ws(s)?:\/\//i.test(provider)) provider = new this.providers.WebsocketProvider(provider);
        else if (provider && typeof net === "object" && typeof net.connect === "function") provider = new this.providers.IpcProvider(provider, net);
        else if (provider) throw new Error("Can't autodetect provider for \"" + provider + '"');
    }
    // reset the old one before changing, if still connected
    if (this.provider && this.provider.connected) this.clearSubscriptions();
    this.provider = provider || null;
    // listen to incoming notifications
    if (this.provider && this.provider.on) {
        if (typeof provider.request === "function") this.provider.on("message", function(payload) {
            if (payload && payload.type === "eth_subscription" && payload.data) {
                const data = payload.data;
                if (data.subscription && _this.subscriptions.has(data.subscription)) _this.subscriptions.get(data.subscription).callback(null, data.result);
            }
        });
        else this.provider.on("data", function data(result, deprecatedResult) {
            result = result || deprecatedResult; // this is for possible old providers, which may had the error first handler
            // if result is a subscription, call callback for that subscription
            if (result.method && result.params && result.params.subscription && _this.subscriptions.has(result.params.subscription)) _this.subscriptions.get(result.params.subscription).callback(null, result.params.result);
        });
        // resubscribe if the provider has reconnected
        this.provider.on("connect", function connect() {
            _this.subscriptions.forEach(function(subscription) {
                subscription.subscription.resubscribe();
            });
        });
        // notify all subscriptions about the error condition
        this.provider.on("error", function error(error) {
            _this.subscriptions.forEach(function(subscription) {
                subscription.callback(error);
            });
        });
        // notify all subscriptions about bad close conditions
        const disconnect = function disconnect(event) {
            if (!_this._isCleanCloseEvent(event) || _this._isIpcCloseError(event)) {
                _this.subscriptions.forEach(function(subscription) {
                    subscription.callback($2da6253b89d591af$require$errors.ConnectionCloseError(event));
                    _this.subscriptions.delete(subscription.subscription.id);
                });
                if (_this.provider && _this.provider.emit) _this.provider.emit("error", $2da6253b89d591af$require$errors.ConnectionCloseError(event));
            }
            if (_this.provider && _this.provider.emit) _this.provider.emit("end", event);
        };
        // TODO: Remove close once the standard allows it
        this.provider.on("close", disconnect);
        this.provider.on("disconnect", disconnect);
    // TODO add end, timeout??
    }
};
/**
 * Asynchronously send request to provider.
 * Prefers to use the `request` method available on the provider as specified in [EIP-1193](https://eips.ethereum.org/EIPS/eip-1193).
 * If `request` is not available, falls back to `sendAsync` and `send` respectively.
 * @method send
 * @param {Object} data
 * @param {Function} callback
 */ $2da6253b89d591af$var$RequestManager.prototype.send = function(data, callback) {
    callback = callback || function() {};
    if (!this.provider) return callback($2da6253b89d591af$require$errors.InvalidProvider());
    const { method: method, params: params } = data;
    const jsonrpcPayload = $e538a1c8675eb279$exports.toPayload(method, params);
    const jsonrpcResultCallback = this._jsonrpcResultCallback(callback, jsonrpcPayload);
    if (this.provider.request) {
        const callbackRequest = $2da6253b89d591af$require$callbackify(this.provider.request.bind(this.provider));
        const requestArgs = {
            method: method,
            params: params
        };
        callbackRequest(requestArgs, callback);
    } else if (this.provider.sendAsync) this.provider.sendAsync(jsonrpcPayload, jsonrpcResultCallback);
    else if (this.provider.send) this.provider.send(jsonrpcPayload, jsonrpcResultCallback);
    else throw new Error("Provider does not have a request or send method to use.");
};
/**
 * Asynchronously send batch request.
 * Only works if provider supports batch methods through `sendAsync` or `send`.
 * @method sendBatch
 * @param {Array} data - array of payload objects
 * @param {Function} callback
 */ $2da6253b89d591af$var$RequestManager.prototype.sendBatch = function(data, callback) {
    if (!this.provider) return callback($2da6253b89d591af$require$errors.InvalidProvider());
    var payload = $e538a1c8675eb279$exports.toBatchPayload(data);
    this.provider[this.provider.sendAsync ? "sendAsync" : "send"](payload, function(err, results) {
        if (err) return callback(err);
        if (!Array.isArray(results)) return callback($2da6253b89d591af$require$errors.InvalidResponse(results));
        callback(null, results);
    });
};
/**
 * Waits for notifications
 *
 * @method addSubscription
 * @param {Subscription} subscription         the subscription
 * @param {String} type         the subscription namespace (eth, personal, etc)
 * @param {Function} callback   the callback to call for incoming notifications
 */ $2da6253b89d591af$var$RequestManager.prototype.addSubscription = function(subscription, callback) {
    if (this.provider.on) this.subscriptions.set(subscription.id, {
        callback: callback,
        subscription: subscription
    });
    else throw new Error("The provider doesn't support subscriptions: " + this.provider.constructor.name);
};
/**
 * Waits for notifications
 *
 * @method removeSubscription
 * @param {String} id           the subscription id
 * @param {Function} callback   fired once the subscription is removed
 */ $2da6253b89d591af$var$RequestManager.prototype.removeSubscription = function(id, callback) {
    if (this.subscriptions.has(id)) {
        var type = this.subscriptions.get(id).subscription.options.type;
        // remove subscription first to avoid reentry
        this.subscriptions.delete(id);
        // then, try to actually unsubscribe
        this.send({
            method: type + "_unsubscribe",
            params: [
                id
            ]
        }, callback);
        return;
    }
    if (typeof callback === "function") // call the callback if the subscription was already removed
    callback(null);
};
/**
 * Should be called to reset the subscriptions
 *
 * @method reset
 *
 * @returns {boolean}
 */ $2da6253b89d591af$var$RequestManager.prototype.clearSubscriptions = function(keepIsSyncing) {
    try {
        var _this = this;
        // uninstall all subscriptions
        if (this.subscriptions.size > 0) this.subscriptions.forEach(function(value, id) {
            if (!keepIsSyncing || value.name !== "syncing") _this.removeSubscription(id);
        });
        //  reset notification callbacks etc.
        if (this.provider.reset) this.provider.reset();
        return true;
    } catch (e) {
        throw new Error(`Error while clearing subscriptions: ${e}`);
    }
};
/**
 * Evaluates WS close event
 *
 * @method _isCleanClose
 *
 * @param {CloseEvent | boolean} event WS close event or exception flag
 *
 * @returns {boolean}
 */ $2da6253b89d591af$var$RequestManager.prototype._isCleanCloseEvent = function(event) {
    return typeof event === "object" && ([
        1000
    ].includes(event.code) || event.wasClean === true);
};
/**
 * Detects Ipc close error. The node.net module emits ('close', isException)
 *
 * @method _isIpcCloseError
 *
 * @param {CloseEvent | boolean} event WS close event or exception flag
 *
 * @returns {boolean}
 */ $2da6253b89d591af$var$RequestManager.prototype._isIpcCloseError = function(event) {
    return typeof event === "boolean" && event;
};
/**
 * The jsonrpc result callback for RequestManager.send
 *
 * @method _jsonrpcResultCallback
 *
 * @param {Function} callback the callback to use
 * @param {Object} payload the jsonrpc payload
 *
 * @returns {Function} return callback of form (err, result)
 *
 */ $2da6253b89d591af$var$RequestManager.prototype._jsonrpcResultCallback = function(callback, payload) {
    return function(err, result) {
        if (result && result.id && payload.id !== result.id) return callback(new Error(`Wrong response id ${result.id} (expected: ${payload.id}) in ${JSON.stringify(payload)}`));
        if (err) return callback(err);
        if (result && result.error) return callback($2da6253b89d591af$require$errors.ErrorResponse(result));
        if (!$e538a1c8675eb279$exports.isValidResponse(result)) return callback($2da6253b89d591af$require$errors.InvalidResponse(result));
        callback(null, result.result);
    };
};
$2da6253b89d591af$exports = {
    Manager: $2da6253b89d591af$var$RequestManager,
    BatchManager: $364cb87526f158eb$exports
};


var $8babe2aec18c747f$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file extend.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $heyrh = parcelRequire("heyrh");
var $8babe2aec18c747f$require$formatters = $heyrh.formatters;
var $60ff6d2aea0ffa29$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @author Marek Kotewicz <marek@parity.io>
 * @date 2017
 */ "use strict";

var $heyrh = parcelRequire("heyrh");
var $60ff6d2aea0ffa29$require$errors = $heyrh.errors;

var $heyrh = parcelRequire("heyrh");
var $60ff6d2aea0ffa29$require$formatters = $heyrh.formatters;

var $hpg7W = parcelRequire("hpg7W");
var $4f4e7bc1f87a0108$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2016
 */ "use strict";

var $6p5EE = parcelRequire("6p5EE");
/**
 * This function generates a defer promise and adds eventEmitter functionality to it
 *
 * @method eventifiedPromise
 */ var $4f4e7bc1f87a0108$var$PromiEvent = function PromiEvent(justPromise) {
    var resolve, reject, eventEmitter = new Promise(function() {
        resolve = arguments[0];
        reject = arguments[1];
    });
    if (justPromise) return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
    // get eventEmitter
    var emitter = new $6p5EE();
    // add eventEmitter to the promise
    eventEmitter._events = emitter._events;
    eventEmitter.emit = emitter.emit;
    eventEmitter.on = emitter.on;
    eventEmitter.once = emitter.once;
    eventEmitter.off = emitter.off;
    eventEmitter.listeners = emitter.listeners;
    eventEmitter.addListener = emitter.addListener;
    eventEmitter.removeListener = emitter.removeListener;
    eventEmitter.removeAllListeners = emitter.removeAllListeners;
    return {
        resolve: resolve,
        reject: reject,
        eventEmitter: eventEmitter
    };
};
$4f4e7bc1f87a0108$var$PromiEvent.resolve = function(value) {
    var promise = $4f4e7bc1f87a0108$var$PromiEvent(true);
    promise.resolve(value);
    return promise.eventEmitter;
};
$4f4e7bc1f87a0108$exports = $4f4e7bc1f87a0108$var$PromiEvent;


var $51af6b2439bc4ea7$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $fb7aa01bff19666a$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file subscription.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";

var $heyrh = parcelRequire("heyrh");
var $fb7aa01bff19666a$require$errors = $heyrh.errors;

var $6p5EE = parcelRequire("6p5EE");

var $heyrh = parcelRequire("heyrh");
var $fb7aa01bff19666a$require$formatters = $heyrh.formatters;
function $fb7aa01bff19666a$var$identity(value) {
    return value;
}
function $fb7aa01bff19666a$var$Subscription(options) {
    $6p5EE.call(this);
    this.id = null;
    this.callback = $fb7aa01bff19666a$var$identity;
    this.arguments = null;
    this.lastBlock = null; // "from" block tracker for backfilling events on reconnection
    this.options = {
        subscription: options.subscription,
        type: options.type,
        requestManager: options.requestManager
    };
}
// INHERIT
$fb7aa01bff19666a$var$Subscription.prototype = Object.create($6p5EE.prototype);
$fb7aa01bff19666a$var$Subscription.prototype.constructor = $fb7aa01bff19666a$var$Subscription;
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ $fb7aa01bff19666a$var$Subscription.prototype._extractCallback = function(args) {
    if (typeof args[args.length - 1] === "function") return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ $fb7aa01bff19666a$var$Subscription.prototype._validateArgs = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) subscription = {};
    if (!subscription.params) subscription.params = 0;
    if (args.length !== subscription.params) throw $fb7aa01bff19666a$require$errors.InvalidNumberOfParams(args.length, subscription.params, subscription.subscriptionName);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ $fb7aa01bff19666a$var$Subscription.prototype._formatInput = function(args) {
    var subscription = this.options.subscription;
    if (!subscription) return args;
    if (!subscription.inputFormatter) return args;
    var formattedArgs = subscription.inputFormatter.map(function(formatter, index) {
        return formatter ? formatter(args[index]) : args[index];
    });
    return formattedArgs;
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param result {Object}
 * @return {Object}
 */ $fb7aa01bff19666a$var$Subscription.prototype._formatOutput = function(result) {
    var subscription = this.options.subscription;
    return subscription && subscription.outputFormatter && result ? subscription.outputFormatter(result) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ $fb7aa01bff19666a$var$Subscription.prototype._toPayload = function(args) {
    var params = [];
    this.callback = this._extractCallback(args) || $fb7aa01bff19666a$var$identity;
    if (!this.subscriptionMethod) {
        this.subscriptionMethod = args.shift();
        // replace subscription with given name
        if (this.options.subscription.subscriptionName) this.subscriptionMethod = this.options.subscription.subscriptionName;
    }
    if (!this.arguments) {
        this.arguments = this._formatInput(args);
        this._validateArgs(this.arguments);
        args = []; // make empty after validation
    }
    // re-add subscriptionName
    params.push(this.subscriptionMethod);
    params = params.concat(this.arguments);
    if (args.length) throw new Error("Only a callback is allowed as parameter on an already instantiated subscription.");
    return {
        method: this.options.type + "_subscribe",
        params: params
    };
};
/**
 * Unsubscribes and clears callbacks
 *
 * @method unsubscribe
 * @return {Object}
 */ $fb7aa01bff19666a$var$Subscription.prototype.unsubscribe = function(callback) {
    this.options.requestManager.removeSubscription(this.id, callback);
    this.id = null;
    this.lastBlock = null;
    this.removeAllListeners();
};
/**
 * Subscribes and watches for changes
 *
 * @method subscribe
 * @param {String} subscription the subscription
 * @param {Object} options the options object with address topics and fromBlock
 * @return {Object}
 */ $fb7aa01bff19666a$var$Subscription.prototype.subscribe = function() {
    var _this = this;
    var args = Array.prototype.slice.call(arguments);
    var payload = this._toPayload(args);
    if (!payload) return this;
    // throw error, if provider is not set
    if (!this.options.requestManager.provider) {
        setTimeout(function() {
            var err1 = new Error("No provider set.");
            _this.callback(err1, null, _this);
            _this.emit("error", err1);
        }, 0);
        return this;
    }
    // throw error, if provider doesnt support subscriptions
    if (!this.options.requestManager.provider.on) {
        setTimeout(function() {
            var err2 = new Error("The current provider doesn't support subscriptions: " + _this.options.requestManager.provider.constructor.name);
            _this.callback(err2, null, _this);
            _this.emit("error", err2);
        }, 0);
        return this;
    }
    // Re-subscription only: continue fetching from the last block we received.
    // a dropped connection may have resulted in gaps in the logs...
    if (this.lastBlock && !!this.options.params && typeof this.options.params === "object") {
        payload.params[1] = this.options.params;
        payload.params[1].fromBlock = $fb7aa01bff19666a$require$formatters.inputBlockNumberFormatter(this.lastBlock + 1);
    }
    // if id is there unsubscribe first
    if (this.id) this.unsubscribe();
    // store the params in the options object
    this.options.params = payload.params[1];
    // get past logs, if fromBlock is available
    if (payload.params[0] === "logs" && !!payload.params[1] && typeof payload.params[1] === "object" && payload.params[1].hasOwnProperty("fromBlock") && isFinite(payload.params[1].fromBlock)) {
        // send the subscription request
        // copy the params to avoid race-condition with deletion below this block
        var blockParams = Object.assign({}, payload.params[1]);
        this.options.requestManager.send({
            method: "eth_getLogs",
            params: [
                blockParams
            ]
        }, function(err, logs) {
            if (!err) logs.forEach(function(log) {
                var output = _this._formatOutput(log);
                _this.callback(null, output, _this);
                _this.emit("data", output);
            });
            else setTimeout(function() {
                _this.callback(err, null, _this);
                _this.emit("error", err);
            }, 0);
        });
    }
    // create subscription
    // TODO move to separate function? so that past logs can go first?
    if (typeof payload.params[1] === "object") delete payload.params[1].fromBlock;
    this.options.requestManager.send(payload, function(err, result) {
        if (!err && result) {
            _this.id = result;
            _this.method = payload.params[0];
            _this.emit("connected", result);
            // call callback on notifications
            _this.options.requestManager.addSubscription(_this, function(error, result) {
                if (!error) {
                    if (!Array.isArray(result)) result = [
                        result
                    ];
                    result.forEach(function(resultItem) {
                        var output = _this._formatOutput(resultItem);
                        // Track current block (for gaps introduced by dropped connections)
                        _this.lastBlock = !!output && typeof output === "object" ? output.blockNumber : null;
                        if (typeof _this.options.subscription.subscriptionHandler === "function") return _this.options.subscription.subscriptionHandler.call(_this, output);
                        else _this.emit("data", output);
                        // call the callback, last so that unsubscribe there won't affect the emit above
                        _this.callback(null, output, _this);
                    });
                } else {
                    _this.callback(error, false, _this);
                    _this.emit("error", error);
                }
            });
        } else setTimeout(function() {
            _this.callback(err, false, _this);
            _this.emit("error", err);
        }, 0);
    });
    // return an object to cancel the subscription
    return this;
};
/**
 * Resubscribe
 *
 * @method resubscribe
 *
 * @returns {void}
 */ $fb7aa01bff19666a$var$Subscription.prototype.resubscribe = function() {
    this.options.requestManager.removeSubscription(this.id); // unsubscribe
    this.id = null;
    this.subscribe(this.callback);
};
$fb7aa01bff19666a$exports = $fb7aa01bff19666a$var$Subscription;


var $51af6b2439bc4ea7$var$Subscriptions = function Subscriptions(options) {
    this.name = options.name;
    this.type = options.type;
    this.subscriptions = options.subscriptions || {};
    this.requestManager = null;
};
$51af6b2439bc4ea7$var$Subscriptions.prototype.setRequestManager = function(rm) {
    this.requestManager = rm;
};
$51af6b2439bc4ea7$var$Subscriptions.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    var name = this.name.split(".");
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
$51af6b2439bc4ea7$var$Subscriptions.prototype.buildCall = function() {
    var _this = this;
    return function() {
        if (!_this.subscriptions[arguments[0]]) console.warn("Subscription " + JSON.stringify(arguments[0]) + " doesn't exist. Subscribing anyway.");
        var subscription = new $fb7aa01bff19666a$exports({
            subscription: _this.subscriptions[arguments[0]] || {},
            requestManager: _this.requestManager,
            type: _this.type
        });
        return subscription.subscribe.apply(subscription, arguments);
    };
};
$51af6b2439bc4ea7$exports = {
    subscriptions: $51af6b2439bc4ea7$var$Subscriptions,
    subscription: $fb7aa01bff19666a$exports
};


var $60ff6d2aea0ffa29$require$Subscriptions = $51af6b2439bc4ea7$exports.subscriptions;

var $bE5P3 = parcelRequire("bE5P3");
var $60ff6d2aea0ffa29$require$HardForks = $bE5P3.Hardfork;
const $55595c85884ad9e5$export$83d89fbfd8236492 = "logger/5.3.0";


"use strict";
let $457ceee81ca294cf$var$_permanentCensorErrors = false;
let $457ceee81ca294cf$var$_censorErrors = false;
const $457ceee81ca294cf$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $457ceee81ca294cf$var$_logLevel = $457ceee81ca294cf$var$LogLevels["default"];
let $457ceee81ca294cf$var$_globalLogger = null;
function $457ceee81ca294cf$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $457ceee81ca294cf$var$_normalizeError = $457ceee81ca294cf$var$_checkNormalize();
var $457ceee81ca294cf$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($457ceee81ca294cf$export$243e62d78d3b544d || ($457ceee81ca294cf$export$243e62d78d3b544d = {}));
var $457ceee81ca294cf$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficien funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($457ceee81ca294cf$export$d4e71bc0b80dc0fb || ($457ceee81ca294cf$export$d4e71bc0b80dc0fb = {}));
class $457ceee81ca294cf$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($457ceee81ca294cf$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($457ceee81ca294cf$var$_logLevel > $457ceee81ca294cf$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($457ceee81ca294cf$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($457ceee81ca294cf$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($457ceee81ca294cf$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($457ceee81ca294cf$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $457ceee81ca294cf$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            try {
                messageDetails.push(key + "=" + JSON.stringify(params[key]));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $457ceee81ca294cf$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($457ceee81ca294cf$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $457ceee81ca294cf$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $457ceee81ca294cf$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $457ceee81ca294cf$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $457ceee81ca294cf$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $457ceee81ca294cf$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $457ceee81ca294cf$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $457ceee81ca294cf$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $457ceee81ca294cf$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $457ceee81ca294cf$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$457ceee81ca294cf$var$_globalLogger) $457ceee81ca294cf$var$_globalLogger = new $457ceee81ca294cf$export$efa9a398d6368992((0, $55595c85884ad9e5$export$83d89fbfd8236492));
        return $457ceee81ca294cf$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $457ceee81ca294cf$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($457ceee81ca294cf$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $457ceee81ca294cf$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $457ceee81ca294cf$var$_censorErrors = !!censorship;
        $457ceee81ca294cf$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $457ceee81ca294cf$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $457ceee81ca294cf$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $457ceee81ca294cf$var$_logLevel = level;
    }
    static from(version) {
        return new $457ceee81ca294cf$export$efa9a398d6368992(version);
    }
}
$457ceee81ca294cf$export$efa9a398d6368992.errors = $457ceee81ca294cf$export$d4e71bc0b80dc0fb;
$457ceee81ca294cf$export$efa9a398d6368992.levels = $457ceee81ca294cf$export$243e62d78d3b544d;


const $62bacc949e6b24fe$export$83d89fbfd8236492 = "bytes/5.3.0";


"use strict";
const $c50e893d91244e52$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $62bacc949e6b24fe$export$83d89fbfd8236492));
///////////////////////////////
function $c50e893d91244e52$var$isHexable(value) {
    return !!value.toHexString;
}
function $c50e893d91244e52$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $c50e893d91244e52$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $c50e893d91244e52$export$9a14abb1a440cd5e(value) {
    return $c50e893d91244e52$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $c50e893d91244e52$export$c6fabfbfd097fc30(value);
}
function $c50e893d91244e52$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (value.length == null) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (typeof v !== "number" || v < 0 || v >= 256 || v % 1) return false;
    }
    return true;
}
function $c50e893d91244e52$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $c50e893d91244e52$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $c50e893d91244e52$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($c50e893d91244e52$var$isHexable(value)) value = value.toHexString();
    if ($c50e893d91244e52$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $c50e893d91244e52$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $c50e893d91244e52$var$addSlice(new Uint8Array(result));
    }
    if ($c50e893d91244e52$export$c6fabfbfd097fc30(value)) return $c50e893d91244e52$var$addSlice(new Uint8Array(value));
    return $c50e893d91244e52$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $c50e893d91244e52$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$c50e893d91244e52$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $c50e893d91244e52$var$addSlice(result);
}
function $c50e893d91244e52$export$a8f4574d0e56446c(value) {
    let result = $c50e893d91244e52$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $c50e893d91244e52$export$3cdc770bf8b2ed3d(value, length) {
    value = $c50e893d91244e52$export$3131421a7d01b4fb(value);
    if (value.length > length) $c50e893d91244e52$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $c50e893d91244e52$var$addSlice(result);
}
function $c50e893d91244e52$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $c50e893d91244e52$var$HexCharacters = "0123456789abcdef";
function $c50e893d91244e52$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $c50e893d91244e52$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $c50e893d91244e52$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($c50e893d91244e52$var$isHexable(value)) return value.toHexString();
    if ($c50e893d91244e52$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $c50e893d91244e52$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($c50e893d91244e52$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $c50e893d91244e52$var$HexCharacters[(v & 0xf0) >> 4] + $c50e893d91244e52$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $c50e893d91244e52$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $c50e893d91244e52$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $c50e893d91244e52$export$2b0d6b5fbe698c70(data);
    else if (!$c50e893d91244e52$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $c50e893d91244e52$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $c50e893d91244e52$export$2b0d6b5fbe698c70(data);
    else if (!$c50e893d91244e52$export$b02a40aff8e4ad18(data) || data.length % 2) $c50e893d91244e52$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $c50e893d91244e52$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $c50e893d91244e52$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $c50e893d91244e52$export$6916af760a341dd3(value) {
    const trimmed = $c50e893d91244e52$export$967bc0082a978949($c50e893d91244e52$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $c50e893d91244e52$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $c50e893d91244e52$export$2b0d6b5fbe698c70(value);
    if (!$c50e893d91244e52$export$b02a40aff8e4ad18(value)) $c50e893d91244e52$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $c50e893d91244e52$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $c50e893d91244e52$export$2b0d6b5fbe698c70(value);
    else if (!$c50e893d91244e52$export$b02a40aff8e4ad18(value)) $c50e893d91244e52$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $c50e893d91244e52$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $c50e893d91244e52$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($c50e893d91244e52$export$9a14abb1a440cd5e(signature)) {
        const bytes = $c50e893d91244e52$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $c50e893d91244e52$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $c50e893d91244e52$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $c50e893d91244e52$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $c50e893d91244e52$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $c50e893d91244e52$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $c50e893d91244e52$export$3cdc770bf8b2ed3d($c50e893d91244e52$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $c50e893d91244e52$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $c50e893d91244e52$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $c50e893d91244e52$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $c50e893d91244e52$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $c50e893d91244e52$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else {
            if (result.v == null) result.v = 27 + result.recoveryParam;
            else if (result.recoveryParam !== 1 - result.v % 2) $c50e893d91244e52$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$c50e893d91244e52$export$b02a40aff8e4ad18(result.r)) $c50e893d91244e52$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $c50e893d91244e52$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$c50e893d91244e52$export$b02a40aff8e4ad18(result.s)) $c50e893d91244e52$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $c50e893d91244e52$export$e9c46a54370b47e8(result.s, 32);
        const vs = $c50e893d91244e52$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $c50e893d91244e52$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $c50e893d91244e52$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$c50e893d91244e52$export$b02a40aff8e4ad18(result._vs)) $c50e893d91244e52$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $c50e893d91244e52$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $c50e893d91244e52$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $c50e893d91244e52$export$71bb9d78a59bbe25(signature) {
    signature = $c50e893d91244e52$export$7fb170f1e457988f(signature);
    return $c50e893d91244e52$export$2b0d6b5fbe698c70($c50e893d91244e52$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



var $7vYz3 = parcelRequire("7vYz3");


const $c6101e55ac814174$export$83d89fbfd8236492 = "bignumber/5.3.0";


"use strict";
var $f3b152c28cfe30e9$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).BN;
const $f3b152c28cfe30e9$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $c6101e55ac814174$export$83d89fbfd8236492));
const $f3b152c28cfe30e9$var$_constructorGuard = {};
const $f3b152c28cfe30e9$var$MAX_SAFE = 0x1fffffffffffff;
function $f3b152c28cfe30e9$export$a3d0a7fa9b65683b(value) {
    return value != null && ($f3b152c28cfe30e9$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $c50e893d91244e52$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $c50e893d91244e52$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $f3b152c28cfe30e9$var$_warnedToStringRadix = false;
class $f3b152c28cfe30e9$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        $f3b152c28cfe30e9$var$logger.checkNew(new.target, $f3b152c28cfe30e9$export$d97aa349ed20696);
        if (constructorGuard !== $f3b152c28cfe30e9$var$_constructorGuard) $f3b152c28cfe30e9$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $f3b152c28cfe30e9$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).add($f3b152c28cfe30e9$var$toBN(other)));
    }
    sub(other) {
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).sub($f3b152c28cfe30e9$var$toBN(other)));
    }
    div(other) {
        const o = $f3b152c28cfe30e9$export$d97aa349ed20696.from(other);
        if (o.isZero()) $f3b152c28cfe30e9$var$throwFault("division by zero", "div");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).div($f3b152c28cfe30e9$var$toBN(other)));
    }
    mul(other) {
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).mul($f3b152c28cfe30e9$var$toBN(other)));
    }
    mod(other) {
        const value = $f3b152c28cfe30e9$var$toBN(other);
        if (value.isNeg()) $f3b152c28cfe30e9$var$throwFault("cannot modulo negative values", "mod");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $f3b152c28cfe30e9$var$toBN(other);
        if (value.isNeg()) $f3b152c28cfe30e9$var$throwFault("cannot raise to negative values", "pow");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $f3b152c28cfe30e9$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3b152c28cfe30e9$var$throwFault("cannot 'and' negative values", "and");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).and(value));
    }
    or(other) {
        const value = $f3b152c28cfe30e9$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3b152c28cfe30e9$var$throwFault("cannot 'or' negative values", "or");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $f3b152c28cfe30e9$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $f3b152c28cfe30e9$var$throwFault("cannot 'xor' negative values", "xor");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $f3b152c28cfe30e9$var$throwFault("cannot mask negative values", "mask");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $f3b152c28cfe30e9$var$throwFault("cannot shift negative values", "shl");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $f3b152c28cfe30e9$var$throwFault("cannot shift negative values", "shr");
        return $f3b152c28cfe30e9$var$toBigNumber($f3b152c28cfe30e9$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $f3b152c28cfe30e9$var$toBN(this).eq($f3b152c28cfe30e9$var$toBN(other));
    }
    lt(other) {
        return $f3b152c28cfe30e9$var$toBN(this).lt($f3b152c28cfe30e9$var$toBN(other));
    }
    lte(other) {
        return $f3b152c28cfe30e9$var$toBN(this).lte($f3b152c28cfe30e9$var$toBN(other));
    }
    gt(other) {
        return $f3b152c28cfe30e9$var$toBN(this).gt($f3b152c28cfe30e9$var$toBN(other));
    }
    gte(other) {
        return $f3b152c28cfe30e9$var$toBN(this).gte($f3b152c28cfe30e9$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $f3b152c28cfe30e9$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $f3b152c28cfe30e9$var$toBN(this).toNumber();
        } catch (error) {
            $f3b152c28cfe30e9$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $f3b152c28cfe30e9$var$logger.throwError("this platform does not support BigInt", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$f3b152c28cfe30e9$var$_warnedToStringRadix) {
                    $f3b152c28cfe30e9$var$_warnedToStringRadix = true;
                    $f3b152c28cfe30e9$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $f3b152c28cfe30e9$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $f3b152c28cfe30e9$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $f3b152c28cfe30e9$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $f3b152c28cfe30e9$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $f3b152c28cfe30e9$export$d97aa349ed20696($f3b152c28cfe30e9$var$_constructorGuard, $f3b152c28cfe30e9$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $f3b152c28cfe30e9$export$d97aa349ed20696($f3b152c28cfe30e9$var$_constructorGuard, $f3b152c28cfe30e9$var$toHex(new $f3b152c28cfe30e9$var$BN(value)));
            return $f3b152c28cfe30e9$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $f3b152c28cfe30e9$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $f3b152c28cfe30e9$var$MAX_SAFE || value <= -$f3b152c28cfe30e9$var$MAX_SAFE) $f3b152c28cfe30e9$var$throwFault("overflow", "BigNumber.from", value);
            return $f3b152c28cfe30e9$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $f3b152c28cfe30e9$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $c50e893d91244e52$export$c6fabfbfd097fc30)(anyValue)) return $f3b152c28cfe30e9$export$d97aa349ed20696.from((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes piority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $f3b152c28cfe30e9$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $c50e893d91244e52$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $c50e893d91244e52$export$b02a40aff8e4ad18)(hex.substring(1))) return $f3b152c28cfe30e9$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $f3b152c28cfe30e9$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $f3b152c28cfe30e9$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $f3b152c28cfe30e9$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have mulitple negative signs (e.g. "--0x04")
        if (value[0] === "-") $f3b152c28cfe30e9$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $f3b152c28cfe30e9$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $f3b152c28cfe30e9$var$toBigNumber(value) {
    return $f3b152c28cfe30e9$export$d97aa349ed20696.from($f3b152c28cfe30e9$var$toHex(value));
}
function $f3b152c28cfe30e9$var$toBN(value) {
    const hex = $f3b152c28cfe30e9$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $f3b152c28cfe30e9$var$BN("-" + hex.substring(3), 16);
    return new $f3b152c28cfe30e9$var$BN(hex.substring(2), 16);
}
function $f3b152c28cfe30e9$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $f3b152c28cfe30e9$var$logger.throwError(fault, (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $f3b152c28cfe30e9$export$51e4a08295f7770f(value) {
    return new $f3b152c28cfe30e9$var$BN(value, 36).toString(16);
}
function $f3b152c28cfe30e9$export$1293db5d29c264ff(value) {
    return new $f3b152c28cfe30e9$var$BN(value, 16).toString(36);
}


var $8228226827ed2eec$exports = {};

var $4TNnu = parcelRequire("4TNnu");
/**
 * [js-sha3]{@link https://github.com/emn178/js-sha3}
 *
 * @version 0.5.7
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2015-2016
 * @license MIT
 */ /*jslint bitwise: true */ (function() {
    "use strict";
    var root = typeof window === "object" ? window : {};
    var NODE_JS = !root.JS_SHA3_NO_NODE_JS && typeof $4TNnu === "object" && $4TNnu.versions && $4TNnu.versions.node;
    if (NODE_JS) root = $parcel$global;
    var COMMON_JS = !root.JS_SHA3_NO_COMMON_JS && true && $8228226827ed2eec$exports;
    var HEX_CHARS = "0123456789abcdef".split("");
    var SHAKE_PADDING = [
        31,
        7936,
        2031616,
        520093696
    ];
    var KECCAK_PADDING = [
        1,
        256,
        65536,
        16777216
    ];
    var PADDING = [
        6,
        1536,
        393216,
        100663296
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var RC = [
        1,
        0,
        32898,
        0,
        32906,
        2147483648,
        2147516416,
        2147483648,
        32907,
        0,
        2147483649,
        0,
        2147516545,
        2147483648,
        32777,
        2147483648,
        138,
        0,
        136,
        0,
        2147516425,
        0,
        2147483658,
        0,
        2147516555,
        0,
        139,
        2147483648,
        32905,
        2147483648,
        32771,
        2147483648,
        32770,
        2147483648,
        128,
        2147483648,
        32778,
        0,
        2147483658,
        2147483648,
        2147516545,
        2147483648,
        32896,
        2147483648,
        2147483649,
        0,
        2147516424,
        2147483648
    ];
    var BITS = [
        224,
        256,
        384,
        512
    ];
    var SHAKE_BITS = [
        128,
        256
    ];
    var OUTPUT_TYPES = [
        "hex",
        "buffer",
        "arrayBuffer",
        "array"
    ];
    var createOutputMethod = function(bits, padding, outputType) {
        return function(message) {
            return new Keccak(bits, padding, bits).update(message)[outputType]();
        };
    };
    var createShakeOutputMethod = function(bits, padding, outputType) {
        return function(message, outputBits) {
            return new Keccak(bits, padding, outputBits).update(message)[outputType]();
        };
    };
    var createMethod = function(bits, padding) {
        var method = createOutputMethod(bits, padding, "hex");
        method.create = function() {
            return new Keccak(bits, padding, bits);
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(bits, padding, type);
        }
        return method;
    };
    var createShakeMethod = function(bits, padding) {
        var method = createShakeOutputMethod(bits, padding, "hex");
        method.create = function(outputBits) {
            return new Keccak(bits, padding, outputBits);
        };
        method.update = function(message, outputBits) {
            return method.create(outputBits).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createShakeOutputMethod(bits, padding, type);
        }
        return method;
    };
    var algorithms = [
        {
            name: "keccak",
            padding: KECCAK_PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "sha3",
            padding: PADDING,
            bits: BITS,
            createMethod: createMethod
        },
        {
            name: "shake",
            padding: SHAKE_PADDING,
            bits: SHAKE_BITS,
            createMethod: createShakeMethod
        }
    ];
    var methods = {}, methodNames = [];
    for(var i = 0; i < algorithms.length; ++i){
        var algorithm = algorithms[i];
        var bits = algorithm.bits;
        for(var j = 0; j < bits.length; ++j){
            var methodName = algorithm.name + "_" + bits[j];
            methodNames.push(methodName);
            methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding);
        }
    }
    function Keccak(bits, padding, outputBits) {
        this.blocks = [];
        this.s = [];
        this.padding = padding;
        this.outputBits = outputBits;
        this.reset = true;
        this.block = 0;
        this.start = 0;
        this.blockCount = 1600 - (bits << 1) >> 5;
        this.byteCount = this.blockCount << 2;
        this.outputBlocks = outputBits >> 5;
        this.extraBytes = (outputBits & 31) >> 3;
        for(var i = 0; i < 50; ++i)this.s[i] = 0;
    }
    Keccak.prototype.update = function(message) {
        var notString = typeof message !== "string";
        if (notString && message.constructor === ArrayBuffer) message = new Uint8Array(message);
        var length = message.length, blocks = this.blocks, byteCount = this.byteCount, blockCount = this.blockCount, index = 0, s = this.s, i, code;
        while(index < length){
            if (this.reset) {
                this.reset = false;
                blocks[0] = this.block;
                for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
            }
            if (notString) for(i = this.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
            else for(i = this.start; index < length && i < byteCount; ++index){
                code = message.charCodeAt(index);
                if (code < 0x80) blocks[i >> 2] |= code << SHIFT[i++ & 3];
                else if (code < 0x800) {
                    blocks[i >> 2] |= (0xc0 | code >> 6) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else if (code < 0xd800 || code >= 0xe000) {
                    blocks[i >> 2] |= (0xe0 | code >> 12) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                    blocks[i >> 2] |= (0xf0 | code >> 18) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << SHIFT[i++ & 3];
                    blocks[i >> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                }
            }
            this.lastByteIndex = i;
            if (i >= byteCount) {
                this.start = i - byteCount;
                this.block = blocks[blockCount];
                for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
                f(s);
                this.reset = true;
            } else this.start = i;
        }
        return this;
    };
    Keccak.prototype.finalize = function() {
        var blocks = this.blocks, i = this.lastByteIndex, blockCount = this.blockCount, s = this.s;
        blocks[i >> 2] |= this.padding[i & 3];
        if (this.lastByteIndex === this.byteCount) {
            blocks[0] = blocks[blockCount];
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        blocks[blockCount - 1] |= 0x80000000;
        for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
        f(s);
    };
    Keccak.prototype.toString = Keccak.prototype.hex = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var hex = "", block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                block = s[i];
                hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F] + HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F] + HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F] + HEX_CHARS[block >> 28 & 0x0F] + HEX_CHARS[block >> 24 & 0x0F];
            }
            if (j % blockCount === 0) {
                f(s);
                i = 0;
            }
        }
        if (extraBytes) {
            block = s[i];
            if (extraBytes > 0) hex += HEX_CHARS[block >> 4 & 0x0F] + HEX_CHARS[block & 0x0F];
            if (extraBytes > 1) hex += HEX_CHARS[block >> 12 & 0x0F] + HEX_CHARS[block >> 8 & 0x0F];
            if (extraBytes > 2) hex += HEX_CHARS[block >> 20 & 0x0F] + HEX_CHARS[block >> 16 & 0x0F];
        }
        return hex;
    };
    Keccak.prototype.arrayBuffer = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var bytes = this.outputBits >> 3;
        var buffer;
        if (extraBytes) buffer = new ArrayBuffer(outputBlocks + 1 << 2);
        else buffer = new ArrayBuffer(bytes);
        var array = new Uint32Array(buffer);
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j)array[j] = s[i];
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            array[i] = s[i];
            buffer = buffer.slice(0, bytes);
        }
        return buffer;
    };
    Keccak.prototype.buffer = Keccak.prototype.arrayBuffer;
    Keccak.prototype.digest = Keccak.prototype.array = function() {
        this.finalize();
        var blockCount = this.blockCount, s = this.s, outputBlocks = this.outputBlocks, extraBytes = this.extraBytes, i = 0, j = 0;
        var array = [], offset, block;
        while(j < outputBlocks){
            for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
                offset = j << 2;
                block = s[i];
                array[offset] = block & 0xFF;
                array[offset + 1] = block >> 8 & 0xFF;
                array[offset + 2] = block >> 16 & 0xFF;
                array[offset + 3] = block >> 24 & 0xFF;
            }
            if (j % blockCount === 0) f(s);
        }
        if (extraBytes) {
            offset = j << 2;
            block = s[i];
            if (extraBytes > 0) array[offset] = block & 0xFF;
            if (extraBytes > 1) array[offset + 1] = block >> 8 & 0xFF;
            if (extraBytes > 2) array[offset + 2] = block >> 16 & 0xFF;
        }
        return array;
    };
    var f = function(s) {
        var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
        for(n = 0; n < 48; n += 2){
            c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
            c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
            c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
            c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
            c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
            c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
            c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
            c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
            c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
            c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
            h = c8 ^ (c2 << 1 | c3 >>> 31);
            l = c9 ^ (c3 << 1 | c2 >>> 31);
            s[0] ^= h;
            s[1] ^= l;
            s[10] ^= h;
            s[11] ^= l;
            s[20] ^= h;
            s[21] ^= l;
            s[30] ^= h;
            s[31] ^= l;
            s[40] ^= h;
            s[41] ^= l;
            h = c0 ^ (c4 << 1 | c5 >>> 31);
            l = c1 ^ (c5 << 1 | c4 >>> 31);
            s[2] ^= h;
            s[3] ^= l;
            s[12] ^= h;
            s[13] ^= l;
            s[22] ^= h;
            s[23] ^= l;
            s[32] ^= h;
            s[33] ^= l;
            s[42] ^= h;
            s[43] ^= l;
            h = c2 ^ (c6 << 1 | c7 >>> 31);
            l = c3 ^ (c7 << 1 | c6 >>> 31);
            s[4] ^= h;
            s[5] ^= l;
            s[14] ^= h;
            s[15] ^= l;
            s[24] ^= h;
            s[25] ^= l;
            s[34] ^= h;
            s[35] ^= l;
            s[44] ^= h;
            s[45] ^= l;
            h = c4 ^ (c8 << 1 | c9 >>> 31);
            l = c5 ^ (c9 << 1 | c8 >>> 31);
            s[6] ^= h;
            s[7] ^= l;
            s[16] ^= h;
            s[17] ^= l;
            s[26] ^= h;
            s[27] ^= l;
            s[36] ^= h;
            s[37] ^= l;
            s[46] ^= h;
            s[47] ^= l;
            h = c6 ^ (c0 << 1 | c1 >>> 31);
            l = c7 ^ (c1 << 1 | c0 >>> 31);
            s[8] ^= h;
            s[9] ^= l;
            s[18] ^= h;
            s[19] ^= l;
            s[28] ^= h;
            s[29] ^= l;
            s[38] ^= h;
            s[39] ^= l;
            s[48] ^= h;
            s[49] ^= l;
            b0 = s[0];
            b1 = s[1];
            b32 = s[11] << 4 | s[10] >>> 28;
            b33 = s[10] << 4 | s[11] >>> 28;
            b14 = s[20] << 3 | s[21] >>> 29;
            b15 = s[21] << 3 | s[20] >>> 29;
            b46 = s[31] << 9 | s[30] >>> 23;
            b47 = s[30] << 9 | s[31] >>> 23;
            b28 = s[40] << 18 | s[41] >>> 14;
            b29 = s[41] << 18 | s[40] >>> 14;
            b20 = s[2] << 1 | s[3] >>> 31;
            b21 = s[3] << 1 | s[2] >>> 31;
            b2 = s[13] << 12 | s[12] >>> 20;
            b3 = s[12] << 12 | s[13] >>> 20;
            b34 = s[22] << 10 | s[23] >>> 22;
            b35 = s[23] << 10 | s[22] >>> 22;
            b16 = s[33] << 13 | s[32] >>> 19;
            b17 = s[32] << 13 | s[33] >>> 19;
            b48 = s[42] << 2 | s[43] >>> 30;
            b49 = s[43] << 2 | s[42] >>> 30;
            b40 = s[5] << 30 | s[4] >>> 2;
            b41 = s[4] << 30 | s[5] >>> 2;
            b22 = s[14] << 6 | s[15] >>> 26;
            b23 = s[15] << 6 | s[14] >>> 26;
            b4 = s[25] << 11 | s[24] >>> 21;
            b5 = s[24] << 11 | s[25] >>> 21;
            b36 = s[34] << 15 | s[35] >>> 17;
            b37 = s[35] << 15 | s[34] >>> 17;
            b18 = s[45] << 29 | s[44] >>> 3;
            b19 = s[44] << 29 | s[45] >>> 3;
            b10 = s[6] << 28 | s[7] >>> 4;
            b11 = s[7] << 28 | s[6] >>> 4;
            b42 = s[17] << 23 | s[16] >>> 9;
            b43 = s[16] << 23 | s[17] >>> 9;
            b24 = s[26] << 25 | s[27] >>> 7;
            b25 = s[27] << 25 | s[26] >>> 7;
            b6 = s[36] << 21 | s[37] >>> 11;
            b7 = s[37] << 21 | s[36] >>> 11;
            b38 = s[47] << 24 | s[46] >>> 8;
            b39 = s[46] << 24 | s[47] >>> 8;
            b30 = s[8] << 27 | s[9] >>> 5;
            b31 = s[9] << 27 | s[8] >>> 5;
            b12 = s[18] << 20 | s[19] >>> 12;
            b13 = s[19] << 20 | s[18] >>> 12;
            b44 = s[29] << 7 | s[28] >>> 25;
            b45 = s[28] << 7 | s[29] >>> 25;
            b26 = s[38] << 8 | s[39] >>> 24;
            b27 = s[39] << 8 | s[38] >>> 24;
            b8 = s[48] << 14 | s[49] >>> 18;
            b9 = s[49] << 14 | s[48] >>> 18;
            s[0] = b0 ^ ~b2 & b4;
            s[1] = b1 ^ ~b3 & b5;
            s[10] = b10 ^ ~b12 & b14;
            s[11] = b11 ^ ~b13 & b15;
            s[20] = b20 ^ ~b22 & b24;
            s[21] = b21 ^ ~b23 & b25;
            s[30] = b30 ^ ~b32 & b34;
            s[31] = b31 ^ ~b33 & b35;
            s[40] = b40 ^ ~b42 & b44;
            s[41] = b41 ^ ~b43 & b45;
            s[2] = b2 ^ ~b4 & b6;
            s[3] = b3 ^ ~b5 & b7;
            s[12] = b12 ^ ~b14 & b16;
            s[13] = b13 ^ ~b15 & b17;
            s[22] = b22 ^ ~b24 & b26;
            s[23] = b23 ^ ~b25 & b27;
            s[32] = b32 ^ ~b34 & b36;
            s[33] = b33 ^ ~b35 & b37;
            s[42] = b42 ^ ~b44 & b46;
            s[43] = b43 ^ ~b45 & b47;
            s[4] = b4 ^ ~b6 & b8;
            s[5] = b5 ^ ~b7 & b9;
            s[14] = b14 ^ ~b16 & b18;
            s[15] = b15 ^ ~b17 & b19;
            s[24] = b24 ^ ~b26 & b28;
            s[25] = b25 ^ ~b27 & b29;
            s[34] = b34 ^ ~b36 & b38;
            s[35] = b35 ^ ~b37 & b39;
            s[44] = b44 ^ ~b46 & b48;
            s[45] = b45 ^ ~b47 & b49;
            s[6] = b6 ^ ~b8 & b0;
            s[7] = b7 ^ ~b9 & b1;
            s[16] = b16 ^ ~b18 & b10;
            s[17] = b17 ^ ~b19 & b11;
            s[26] = b26 ^ ~b28 & b20;
            s[27] = b27 ^ ~b29 & b21;
            s[36] = b36 ^ ~b38 & b30;
            s[37] = b37 ^ ~b39 & b31;
            s[46] = b46 ^ ~b48 & b40;
            s[47] = b47 ^ ~b49 & b41;
            s[8] = b8 ^ ~b0 & b2;
            s[9] = b9 ^ ~b1 & b3;
            s[18] = b18 ^ ~b10 & b12;
            s[19] = b19 ^ ~b11 & b13;
            s[28] = b28 ^ ~b20 & b22;
            s[29] = b29 ^ ~b21 & b23;
            s[38] = b38 ^ ~b30 & b32;
            s[39] = b39 ^ ~b31 & b33;
            s[48] = b48 ^ ~b40 & b42;
            s[49] = b49 ^ ~b41 & b43;
            s[0] ^= RC[n];
            s[1] ^= RC[n + 1];
        }
    };
    if (COMMON_JS) $8228226827ed2eec$exports = methods;
    else for(var i = 0; i < methodNames.length; ++i)root[methodNames[i]] = methods[methodNames[i]];
})();



"use strict";
function $5eb237d3c60c9d20$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($8228226827ed2eec$exports))).keccak_256((0, $c50e893d91244e52$export$3131421a7d01b4fb)(data));
}




const $a97db66a3649a656$export$83d89fbfd8236492 = "rlp/5.3.0";


"use strict";
const $39194328b8d1ac52$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $a97db66a3649a656$export$83d89fbfd8236492));
function $39194328b8d1ac52$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $39194328b8d1ac52$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $39194328b8d1ac52$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($39194328b8d1ac52$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $39194328b8d1ac52$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $c50e893d91244e52$export$9a14abb1a440cd5e)(object)) $39194328b8d1ac52$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $c50e893d91244e52$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $39194328b8d1ac52$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $39194328b8d1ac52$export$c564cdbbe6da493(object) {
    return (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)($39194328b8d1ac52$var$_encode(object));
}
function $39194328b8d1ac52$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $39194328b8d1ac52$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $39194328b8d1ac52$var$logger.throwError("child data too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $39194328b8d1ac52$var$_decode(data, offset) {
    if (data.length === 0) $39194328b8d1ac52$var$logger.throwError("data too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $39194328b8d1ac52$var$logger.throwError("data short segment too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $39194328b8d1ac52$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $39194328b8d1ac52$var$logger.throwError("data long segment too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $39194328b8d1ac52$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $39194328b8d1ac52$var$logger.throwError("data array too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $39194328b8d1ac52$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $39194328b8d1ac52$var$logger.throwError("data array too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $39194328b8d1ac52$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $39194328b8d1ac52$var$logger.throwError("data array too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $39194328b8d1ac52$var$logger.throwError("data too short", (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $39194328b8d1ac52$export$2f872c0f2117be69(data) {
    const bytes = (0, $c50e893d91244e52$export$3131421a7d01b4fb)(data);
    const decoded = $39194328b8d1ac52$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $39194328b8d1ac52$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $d723a0a2a01459ef$export$83d89fbfd8236492 = "address/5.3.0";


"use strict";
const $0257bd232cd43f8c$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $d723a0a2a01459ef$export$83d89fbfd8236492));
function $0257bd232cd43f8c$var$getChecksumAddress(address) {
    if (!(0, $c50e893d91244e52$export$b02a40aff8e4ad18)(address, 20)) $0257bd232cd43f8c$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $c50e893d91244e52$export$3131421a7d01b4fb)((0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $0257bd232cd43f8c$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $0257bd232cd43f8c$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $0257bd232cd43f8c$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$0257bd232cd43f8c$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$0257bd232cd43f8c$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $0257bd232cd43f8c$var$safeDigits = Math.floor($0257bd232cd43f8c$var$log10($0257bd232cd43f8c$var$MAX_SAFE_INTEGER));
function $0257bd232cd43f8c$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $0257bd232cd43f8c$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $0257bd232cd43f8c$var$safeDigits){
        let block = expanded.substring(0, $0257bd232cd43f8c$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $0257bd232cd43f8c$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $0257bd232cd43f8c$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $0257bd232cd43f8c$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $0257bd232cd43f8c$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $0257bd232cd43f8c$var$ibanChecksum(address)) $0257bd232cd43f8c$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $f3b152c28cfe30e9$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $0257bd232cd43f8c$var$getChecksumAddress("0x" + result);
    } else $0257bd232cd43f8c$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $0257bd232cd43f8c$export$977e255126d763d6(address) {
    try {
        $0257bd232cd43f8c$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $0257bd232cd43f8c$export$962c4ddada9f668f(address) {
    let base36 = (0, $f3b152c28cfe30e9$export$1293db5d29c264ff)($0257bd232cd43f8c$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $0257bd232cd43f8c$var$ibanChecksum("XE00" + base36) + base36;
}
function $0257bd232cd43f8c$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $0257bd232cd43f8c$export$88411125f012957a(transaction.from);
    } catch (error) {
        $0257bd232cd43f8c$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $c50e893d91244e52$export$a8f4574d0e56446c)((0, $c50e893d91244e52$export$3131421a7d01b4fb)((0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $0257bd232cd43f8c$export$88411125f012957a((0, $c50e893d91244e52$export$15da666eba198c18)((0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)((0, $39194328b8d1ac52$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $0257bd232cd43f8c$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $c50e893d91244e52$export$13882f896d3c0683)(salt) !== 32) $0257bd232cd43f8c$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $c50e893d91244e52$export$13882f896d3c0683)(initCodeHash) !== 32) $0257bd232cd43f8c$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $0257bd232cd43f8c$export$88411125f012957a((0, $c50e893d91244e52$export$15da666eba198c18)((0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)((0, $c50e893d91244e52$export$ee1b3e54f0441b22)([
        "0xff",
        $0257bd232cd43f8c$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}





const $2b27eee9c323428e$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(-1);
const $2b27eee9c323428e$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(0);
const $2b27eee9c323428e$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(1);
const $2b27eee9c323428e$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(2);
const $2b27eee9c323428e$export$c8db55bd7405209e = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from("1000000000000000000");
const $2b27eee9c323428e$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $2b27eee9c323428e$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $2b27eee9c323428e$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");




const $a53444aae30d0058$export$83d89fbfd8236492 = "properties/5.3.0";


"use strict";
var $f71b0d1ed409e388$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $f71b0d1ed409e388$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $a53444aae30d0058$export$83d89fbfd8236492));
function $f71b0d1ed409e388$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $f71b0d1ed409e388$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $f71b0d1ed409e388$export$d503dd157d963b60(object) {
    return $f71b0d1ed409e388$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $f71b0d1ed409e388$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $f71b0d1ed409e388$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $f71b0d1ed409e388$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $f71b0d1ed409e388$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $f71b0d1ed409e388$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $f71b0d1ed409e388$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $f71b0d1ed409e388$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            if (!$f71b0d1ed409e388$var$_isFrozen(object[keys[i]])) return false;
        }
        return true;
    }
    return $f71b0d1ed409e388$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $f71b0d1ed409e388$var$_deepCopy(object) {
    if ($f71b0d1ed409e388$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$f71b0d1ed409e388$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $f71b0d1ed409e388$export$104236534534f9be(result, key, $f71b0d1ed409e388$export$6c40052bed430212(value));
        }
        return result;
    }
    return $f71b0d1ed409e388$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $f71b0d1ed409e388$export$6c40052bed430212(object) {
    return $f71b0d1ed409e388$var$_deepCopy(object);
}
class $f71b0d1ed409e388$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $f71b0d1ed409e388$export$6c40052bed430212(info[key]);
    }
}




var $7vYz3 = parcelRequire("7vYz3");

var $leqJp = parcelRequire("leqJp");
var $01ebb678163d6df5$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $01ebb678163d6df5$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function $01ebb678163d6df5$var$createCommonjsModule(fn, basedir, module) {
    return module = {
        path: basedir,
        exports: {},
        require: function(path, base) {
            return $01ebb678163d6df5$var$commonjsRequire(path, base === undefined || base === null ? module.path : base);
        }
    }, fn(module, module.exports), module.exports;
}
function $01ebb678163d6df5$var$getDefaultExportFromNamespaceIfPresent(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") ? n["default"] : n;
}
function $01ebb678163d6df5$var$getDefaultExportFromNamespaceIfNotNamed(n) {
    return n && Object.prototype.hasOwnProperty.call(n, "default") && Object.keys(n).length === 1 ? n["default"] : n;
}
function $01ebb678163d6df5$var$getAugmentedNamespace(n) {
    if (n.__esModule) return n;
    var a = Object.defineProperty({}, "__esModule", {
        value: true
    });
    Object.keys(n).forEach(function(k) {
        var d = Object.getOwnPropertyDescriptor(n, k);
        Object.defineProperty(a, k, d.get ? d : {
            enumerable: true,
            get: function() {
                return n[k];
            }
        });
    });
    return a;
}
function $01ebb678163d6df5$var$commonjsRequire() {
    throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
var $01ebb678163d6df5$var$minimalisticAssert = $01ebb678163d6df5$var$assert;
function $01ebb678163d6df5$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$01ebb678163d6df5$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};
var $01ebb678163d6df5$var$utils_1 = $01ebb678163d6df5$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    function toArray(msg, enc) {
        if (Array.isArray(msg)) return msg.slice();
        if (!msg) return [];
        var res = [];
        if (typeof msg !== "string") {
            for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
            return res;
        }
        if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        } else for(var i = 0; i < msg.length; i++){
            var c = msg.charCodeAt(i);
            var hi = c >> 8;
            var lo = c & 0xff;
            if (hi) res.push(hi, lo);
            else res.push(lo);
        }
        return res;
    }
    utils.toArray = toArray;
    function zero2(word) {
        if (word.length === 1) return "0" + word;
        else return word;
    }
    utils.zero2 = zero2;
    function toHex(msg) {
        var res = "";
        for(var i = 0; i < msg.length; i++)res += zero2(msg[i].toString(16));
        return res;
    }
    utils.toHex = toHex;
    utils.encode = function encode(arr, enc) {
        if (enc === "hex") return toHex(arr);
        else return arr;
    };
});
var $01ebb678163d6df5$var$utils_1$1 = $01ebb678163d6df5$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var utils = exports;
    utils.assert = $01ebb678163d6df5$var$minimalisticAssert;
    utils.toArray = $01ebb678163d6df5$var$utils_1.toArray;
    utils.zero2 = $01ebb678163d6df5$var$utils_1.zero2;
    utils.toHex = $01ebb678163d6df5$var$utils_1.toHex;
    utils.encode = $01ebb678163d6df5$var$utils_1.encode;
    // Represent num in a w-NAF form
    function getNAF(num, w, bits) {
        var naf = new Array(Math.max(num.bitLength(), bits) + 1);
        naf.fill(0);
        var ws = 1 << w + 1;
        var k = num.clone();
        for(var i = 0; i < naf.length; i++){
            var z;
            var mod = k.andln(ws - 1);
            if (k.isOdd()) {
                if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
                else z = mod;
                k.isubn(z);
            } else z = 0;
            naf[i] = z;
            k.iushrn(1);
        }
        return naf;
    }
    utils.getNAF = getNAF;
    // Represent k1, k2 in a Joint Sparse Form
    function getJSF(k1, k2) {
        var jsf = [
            [],
            []
        ];
        k1 = k1.clone();
        k2 = k2.clone();
        var d1 = 0;
        var d2 = 0;
        var m8;
        while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
            // First phase
            var m14 = k1.andln(3) + d1 & 3;
            var m24 = k2.andln(3) + d2 & 3;
            if (m14 === 3) m14 = -1;
            if (m24 === 3) m24 = -1;
            var u1;
            if ((m14 & 1) === 0) u1 = 0;
            else {
                m8 = k1.andln(7) + d1 & 7;
                if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
                else u1 = m14;
            }
            jsf[0].push(u1);
            var u2;
            if ((m24 & 1) === 0) u2 = 0;
            else {
                m8 = k2.andln(7) + d2 & 7;
                if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
                else u2 = m24;
            }
            jsf[1].push(u2);
            // Second phase
            if (2 * d1 === u1 + 1) d1 = 1 - d1;
            if (2 * d2 === u2 + 1) d2 = 1 - d2;
            k1.iushrn(1);
            k2.iushrn(1);
        }
        return jsf;
    }
    utils.getJSF = getJSF;
    function cachedProperty(obj, name, computer) {
        var key = "_" + name;
        obj.prototype[name] = function cachedProperty() {
            return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
        };
    }
    utils.cachedProperty = cachedProperty;
    function parseBytes(bytes) {
        return typeof bytes === "string" ? utils.toArray(bytes, "hex") : bytes;
    }
    utils.parseBytes = parseBytes;
    function intFromLE(bytes) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(bytes, "hex", "le");
    }
    utils.intFromLE = intFromLE;
});
"use strict";
var $01ebb678163d6df5$var$getNAF = $01ebb678163d6df5$var$utils_1$1.getNAF;
var $01ebb678163d6df5$var$getJSF = $01ebb678163d6df5$var$utils_1$1.getJSF;
var $01ebb678163d6df5$var$assert$1 = $01ebb678163d6df5$var$utils_1$1.assert;
function $01ebb678163d6df5$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).red(conf.prime) : (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).mont(this.p);
    // Useful for many curves
    this.zero = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(0).toRed(this.red);
    this.one = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(1).toRed(this.red);
    this.two = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
var $01ebb678163d6df5$var$base = $01ebb678163d6df5$var$BaseCurve;
$01ebb678163d6df5$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$01ebb678163d6df5$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$01ebb678163d6df5$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $01ebb678163d6df5$var$assert$1(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $01ebb678163d6df5$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$01ebb678163d6df5$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $01ebb678163d6df5$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $01ebb678163d6df5$var$assert$1(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$01ebb678163d6df5$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $01ebb678163d6df5$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $01ebb678163d6df5$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $01ebb678163d6df5$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $01ebb678163d6df5$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$01ebb678163d6df5$var$BaseCurve.BasePoint = $01ebb678163d6df5$var$BasePoint;
$01ebb678163d6df5$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$01ebb678163d6df5$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$01ebb678163d6df5$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $01ebb678163d6df5$var$utils_1$1.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $01ebb678163d6df5$var$assert$1(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $01ebb678163d6df5$var$assert$1(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$01ebb678163d6df5$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$01ebb678163d6df5$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$01ebb678163d6df5$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $01ebb678163d6df5$var$utils_1$1.encode(this._encode(compact), enc);
};
$01ebb678163d6df5$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$01ebb678163d6df5$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$01ebb678163d6df5$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$01ebb678163d6df5$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$01ebb678163d6df5$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$01ebb678163d6df5$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};
var $01ebb678163d6df5$var$inherits_browser = $01ebb678163d6df5$var$createCommonjsModule(function(module) {
    if (typeof Object.create === "function") // implementation from standard node.js 'util' module
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else // old school shim for old browsers
    module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
"use strict";
var $01ebb678163d6df5$var$assert$2 = $01ebb678163d6df5$var$utils_1$1.assert;
function $01ebb678163d6df5$var$ShortCurve(conf) {
    $01ebb678163d6df5$var$base.call(this, "short", conf);
    this.a = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.a, 16).toRed(this.red);
    this.b = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$01ebb678163d6df5$var$inherits_browser($01ebb678163d6df5$var$ShortCurve, $01ebb678163d6df5$var$base);
var $01ebb678163d6df5$var$short_1 = $01ebb678163d6df5$var$ShortCurve;
$01ebb678163d6df5$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $01ebb678163d6df5$var$assert$2(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(vec.a, 16),
            b: new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$01ebb678163d6df5$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).mont(num);
    var tinv = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$01ebb678163d6df5$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(1);
    var y1 = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(0);
    var x2 = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(0);
    var y2 = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$01ebb678163d6df5$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$01ebb678163d6df5$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$01ebb678163d6df5$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$01ebb678163d6df5$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $01ebb678163d6df5$var$Point(curve, x, y, isRed) {
    $01ebb678163d6df5$var$base.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$01ebb678163d6df5$var$inherits_browser($01ebb678163d6df5$var$Point, $01ebb678163d6df5$var$base.BasePoint);
$01ebb678163d6df5$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $01ebb678163d6df5$var$Point(this, x, y, isRed);
};
$01ebb678163d6df5$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $01ebb678163d6df5$var$Point.fromJSON(this, obj, red);
};
$01ebb678163d6df5$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$01ebb678163d6df5$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$01ebb678163d6df5$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$01ebb678163d6df5$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$01ebb678163d6df5$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$01ebb678163d6df5$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$01ebb678163d6df5$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$01ebb678163d6df5$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$01ebb678163d6df5$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$01ebb678163d6df5$var$Point.prototype.mul = function mul(k) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$01ebb678163d6df5$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$01ebb678163d6df5$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$01ebb678163d6df5$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$01ebb678163d6df5$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$01ebb678163d6df5$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $01ebb678163d6df5$var$JPoint(curve, x, y, z) {
    $01ebb678163d6df5$var$base.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(0);
    } else {
        this.x = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(x, 16);
        this.y = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(y, 16);
        this.z = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$01ebb678163d6df5$var$inherits_browser($01ebb678163d6df5$var$JPoint, $01ebb678163d6df5$var$base.BasePoint);
$01ebb678163d6df5$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $01ebb678163d6df5$var$JPoint(this, x, y, z);
};
$01ebb678163d6df5$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$01ebb678163d6df5$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$01ebb678163d6df5$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$01ebb678163d6df5$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$01ebb678163d6df5$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$01ebb678163d6df5$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(k, kbase);
    return this.curve._wnafMul(this, k);
};
$01ebb678163d6df5$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$01ebb678163d6df5$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$01ebb678163d6df5$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$01ebb678163d6df5$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
var $01ebb678163d6df5$var$curve_1 = $01ebb678163d6df5$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curve = exports;
    curve.base = $01ebb678163d6df5$var$base;
    curve.short = $01ebb678163d6df5$var$short_1;
    curve.mont = /*RicMoo:ethers:require(./mont)*/ null;
    curve.edwards = /*RicMoo:ethers:require(./edwards)*/ null;
});
var $01ebb678163d6df5$var$curves_1 = $01ebb678163d6df5$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var curves = exports;
    var assert = $01ebb678163d6df5$var$utils_1$1.assert;
    function PresetCurve(options) {
        if (options.type === "short") this.curve = new $01ebb678163d6df5$var$curve_1.short(options);
        else if (options.type === "edwards") this.curve = new $01ebb678163d6df5$var$curve_1.edwards(options);
        else this.curve = new $01ebb678163d6df5$var$curve_1.mont(options);
        this.g = this.curve.g;
        this.n = this.curve.n;
        this.hash = options.hash;
        assert(this.g.validate(), "Invalid curve");
        assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    curves.PresetCurve = PresetCurve;
    function defineCurve(name, options) {
        Object.defineProperty(curves, name, {
            configurable: true,
            enumerable: true,
            get: function() {
                var curve = new PresetCurve(options);
                Object.defineProperty(curves, name, {
                    configurable: true,
                    enumerable: true,
                    value: curve
                });
                return curve;
            }
        });
    }
    defineCurve("p192", {
        type: "short",
        prime: "p192",
        p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
        b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
        n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
            "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
        ]
    });
    defineCurve("p224", {
        type: "short",
        prime: "p224",
        p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
        a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
        b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
        n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
            "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
        ]
    });
    defineCurve("p256", {
        type: "short",
        prime: null,
        p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
        a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
        b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
        n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
            "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
        ]
    });
    defineCurve("p384", {
        type: "short",
        prime: null,
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
        a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
        b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
        n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha384,
        gRed: false,
        g: [
            "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
            "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
        ]
    });
    defineCurve("p521", {
        type: "short",
        prime: null,
        p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
        a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
        b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
        n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha512,
        gRed: false,
        g: [
            "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
            "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
        ]
    });
    defineCurve("curve25519", {
        type: "mont",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "76d06",
        b: "1",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "9"
        ]
    });
    defineCurve("ed25519", {
        type: "edwards",
        prime: "p25519",
        p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
        a: "-1",
        c: "1",
        // -121665 * (121666^(-1)) (mod P)
        d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
        n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        gRed: false,
        g: [
            "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
            // 4/5
            "6666666666666666666666666666666666666666666666666666666666666658"
        ]
    });
    var pre;
    try {
        pre = /*RicMoo:ethers:require(./precomputed/secp256k1)*/ null.crash();
    } catch (e) {
        pre = undefined;
    }
    defineCurve("secp256k1", {
        type: "short",
        prime: "k256",
        p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
        a: "0",
        b: "7",
        n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
        h: "1",
        hash: (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).sha256,
        // Precomputed endomorphism
        beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
        lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
        basis: [
            {
                a: "3086d221a7d46bcde86c90e49284eb15",
                b: "-e4437ed6010e88286f547fa90abfe4c3"
            },
            {
                a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
                b: "3086d221a7d46bcde86c90e49284eb15"
            }
        ],
        gRed: false,
        g: [
            "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
            "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
            pre
        ]
    });
});
"use strict";
function $01ebb678163d6df5$var$HmacDRBG(options) {
    if (!(this instanceof $01ebb678163d6df5$var$HmacDRBG)) return new $01ebb678163d6df5$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $01ebb678163d6df5$var$utils_1.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $01ebb678163d6df5$var$utils_1.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $01ebb678163d6df5$var$utils_1.toArray(options.pers, options.persEnc || "hex");
    $01ebb678163d6df5$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
var $01ebb678163d6df5$var$hmacDrbg = $01ebb678163d6df5$var$HmacDRBG;
$01ebb678163d6df5$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$01ebb678163d6df5$var$HmacDRBG.prototype._hmac = function hmac() {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($leqJp))).hmac(this.hash, this.K);
};
$01ebb678163d6df5$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$01ebb678163d6df5$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $01ebb678163d6df5$var$utils_1.toArray(entropy, entropyEnc);
    add = $01ebb678163d6df5$var$utils_1.toArray(add, addEnc);
    $01ebb678163d6df5$var$minimalisticAssert(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$01ebb678163d6df5$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $01ebb678163d6df5$var$utils_1.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $01ebb678163d6df5$var$utils_1.encode(res, enc);
};
"use strict";
var $01ebb678163d6df5$var$assert$3 = $01ebb678163d6df5$var$utils_1$1.assert;
function $01ebb678163d6df5$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
var $01ebb678163d6df5$var$key = $01ebb678163d6df5$var$KeyPair;
$01ebb678163d6df5$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $01ebb678163d6df5$var$KeyPair) return pub;
    return new $01ebb678163d6df5$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$01ebb678163d6df5$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $01ebb678163d6df5$var$KeyPair) return priv;
    return new $01ebb678163d6df5$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$01ebb678163d6df5$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$01ebb678163d6df5$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$01ebb678163d6df5$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$01ebb678163d6df5$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$01ebb678163d6df5$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $01ebb678163d6df5$var$assert$3(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $01ebb678163d6df5$var$assert$3(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$01ebb678163d6df5$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $01ebb678163d6df5$var$assert$3(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$01ebb678163d6df5$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$01ebb678163d6df5$var$KeyPair.prototype.verify = function verify(msg, signature) {
    return this.ec.verify(msg, signature, this);
};
$01ebb678163d6df5$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};
"use strict";
var $01ebb678163d6df5$var$assert$4 = $01ebb678163d6df5$var$utils_1$1.assert;
function $01ebb678163d6df5$var$Signature(options, enc) {
    if (options instanceof $01ebb678163d6df5$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $01ebb678163d6df5$var$assert$4(options.r && options.s, "Signature without r or s");
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(options.r, 16);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
var $01ebb678163d6df5$var$signature = $01ebb678163d6df5$var$Signature;
function $01ebb678163d6df5$var$Position() {
    this.place = 0;
}
function $01ebb678163d6df5$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $01ebb678163d6df5$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$01ebb678163d6df5$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $01ebb678163d6df5$var$utils_1$1.toArray(data, enc);
    var p = new $01ebb678163d6df5$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $01ebb678163d6df5$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $01ebb678163d6df5$var$getLength(data, p);
    if (rlen === false) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $01ebb678163d6df5$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(r);
    this.s = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(s);
    this.recoveryParam = null;
    return true;
};
function $01ebb678163d6df5$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$01ebb678163d6df5$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $01ebb678163d6df5$var$rmPadding(r);
    s = $01ebb678163d6df5$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $01ebb678163d6df5$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $01ebb678163d6df5$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $01ebb678163d6df5$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $01ebb678163d6df5$var$utils_1$1.encode(res, enc);
};
"use strict";
var $01ebb678163d6df5$var$rand = /*RicMoo:ethers:require(brorand)*/ function() {
    throw new Error("unsupported");
};
var $01ebb678163d6df5$var$assert$5 = $01ebb678163d6df5$var$utils_1$1.assert;
function $01ebb678163d6df5$var$EC(options) {
    if (!(this instanceof $01ebb678163d6df5$var$EC)) return new $01ebb678163d6df5$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $01ebb678163d6df5$var$assert$5(Object.prototype.hasOwnProperty.call($01ebb678163d6df5$var$curves_1, options), "Unknown curve " + options);
        options = $01ebb678163d6df5$var$curves_1[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $01ebb678163d6df5$var$curves_1.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
var $01ebb678163d6df5$var$ec = $01ebb678163d6df5$var$EC;
$01ebb678163d6df5$var$EC.prototype.keyPair = function keyPair(options) {
    return new $01ebb678163d6df5$var$key(this, options);
};
$01ebb678163d6df5$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $01ebb678163d6df5$var$key.fromPrivate(this, priv, enc);
};
$01ebb678163d6df5$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $01ebb678163d6df5$var$key.fromPublic(this, pub, enc);
};
$01ebb678163d6df5$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $01ebb678163d6df5$var$hmacDrbg({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $01ebb678163d6df5$var$rand(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(2));
    for(;;){
        var priv = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$01ebb678163d6df5$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly) {
    var delta = msg.byteLength() * 8 - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$01ebb678163d6df5$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(msg, 16));
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Instantiate Hmac_DRBG
    var drbg = new $01ebb678163d6df5$var$hmacDrbg({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $01ebb678163d6df5$var$signature({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$01ebb678163d6df5$var$EC.prototype.verify = function verify(msg, signature$1, key, enc) {
    msg = this._truncateToN(new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(msg, 16));
    key = this.keyFromPublic(key, enc);
    signature$1 = new $01ebb678163d6df5$var$signature(signature$1, "hex");
    // Perform primitive values validation
    var r = signature$1.r;
    var s = signature$1.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$01ebb678163d6df5$var$EC.prototype.recoverPubKey = function(msg, signature$1, j, enc) {
    $01ebb678163d6df5$var$assert$5((3 & j) === j, "The recovery param is more than two bits");
    signature$1 = new $01ebb678163d6df5$var$signature(signature$1, enc);
    var n = this.n;
    var e = new (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3)))(msg);
    var r = signature$1.r;
    var s = signature$1.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature$1.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$01ebb678163d6df5$var$EC.prototype.getKeyRecoveryParam = function(e, signature$1, Q, enc) {
    signature$1 = new $01ebb678163d6df5$var$signature(signature$1, enc);
    if (signature$1.recoveryParam !== null) return signature$1.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature$1, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};
var $01ebb678163d6df5$var$elliptic_1 = $01ebb678163d6df5$var$createCommonjsModule(function(module, exports) {
    "use strict";
    var elliptic = exports;
    elliptic.version = "6.5.4";
    elliptic.utils = $01ebb678163d6df5$var$utils_1$1;
    elliptic.rand = /*RicMoo:ethers:require(brorand)*/ function() {
        throw new Error("unsupported");
    };
    elliptic.curve = $01ebb678163d6df5$var$curve_1;
    elliptic.curves = $01ebb678163d6df5$var$curves_1;
    // Protocols
    elliptic.ec = $01ebb678163d6df5$var$ec;
    elliptic.eddsa = /*RicMoo:ethers:require(./elliptic/eddsa)*/ null;
});
var $01ebb678163d6df5$export$129fe12d32abc311 = $01ebb678163d6df5$var$elliptic_1.ec;
 //# sourceMappingURL=browser-elliptic.js.map





const $94084f1e4a7663ff$export$83d89fbfd8236492 = "signing-key/5.3.0";


"use strict";
const $92f9ba877c85a1d7$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $94084f1e4a7663ff$export$83d89fbfd8236492));
let $92f9ba877c85a1d7$var$_curve = null;
function $92f9ba877c85a1d7$var$getCurve() {
    if (!$92f9ba877c85a1d7$var$_curve) $92f9ba877c85a1d7$var$_curve = new (0, $01ebb678163d6df5$export$129fe12d32abc311)("secp256k1");
    return $92f9ba877c85a1d7$var$_curve;
}
class $92f9ba877c85a1d7$export$21643ca94aed3e83 {
    constructor(privateKey){
        (0, $f71b0d1ed409e388$export$104236534534f9be)(this, "curve", "secp256k1");
        (0, $f71b0d1ed409e388$export$104236534534f9be)(this, "privateKey", (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(privateKey));
        const keyPair = $92f9ba877c85a1d7$var$getCurve().keyFromPrivate((0, $c50e893d91244e52$export$3131421a7d01b4fb)(this.privateKey));
        (0, $f71b0d1ed409e388$export$104236534534f9be)(this, "publicKey", "0x" + keyPair.getPublic(false, "hex"));
        (0, $f71b0d1ed409e388$export$104236534534f9be)(this, "compressedPublicKey", "0x" + keyPair.getPublic(true, "hex"));
        (0, $f71b0d1ed409e388$export$104236534534f9be)(this, "_isSigningKey", true);
    }
    _addPoint(other) {
        const p0 = $92f9ba877c85a1d7$var$getCurve().keyFromPublic((0, $c50e893d91244e52$export$3131421a7d01b4fb)(this.publicKey));
        const p1 = $92f9ba877c85a1d7$var$getCurve().keyFromPublic((0, $c50e893d91244e52$export$3131421a7d01b4fb)(other));
        return "0x" + p0.pub.add(p1.pub).encodeCompressed("hex");
    }
    signDigest(digest) {
        const keyPair = $92f9ba877c85a1d7$var$getCurve().keyFromPrivate((0, $c50e893d91244e52$export$3131421a7d01b4fb)(this.privateKey));
        const digestBytes = (0, $c50e893d91244e52$export$3131421a7d01b4fb)(digest);
        if (digestBytes.length !== 32) $92f9ba877c85a1d7$var$logger.throwArgumentError("bad digest length", "digest", digest);
        const signature = keyPair.sign(digestBytes, {
            canonical: true
        });
        return (0, $c50e893d91244e52$export$7fb170f1e457988f)({
            recoveryParam: signature.recoveryParam,
            r: (0, $c50e893d91244e52$export$e9c46a54370b47e8)("0x" + signature.r.toString(16), 32),
            s: (0, $c50e893d91244e52$export$e9c46a54370b47e8)("0x" + signature.s.toString(16), 32)
        });
    }
    computeSharedSecret(otherKey) {
        const keyPair = $92f9ba877c85a1d7$var$getCurve().keyFromPrivate((0, $c50e893d91244e52$export$3131421a7d01b4fb)(this.privateKey));
        const otherKeyPair = $92f9ba877c85a1d7$var$getCurve().keyFromPublic((0, $c50e893d91244e52$export$3131421a7d01b4fb)($92f9ba877c85a1d7$export$4a89473d39301224(otherKey)));
        return (0, $c50e893d91244e52$export$e9c46a54370b47e8)("0x" + keyPair.derive(otherKeyPair.getPublic()).toString(16), 32);
    }
    static isSigningKey(value) {
        return !!(value && value._isSigningKey);
    }
}
function $92f9ba877c85a1d7$export$952dd09fbe0232b7(digest, signature) {
    const sig = (0, $c50e893d91244e52$export$7fb170f1e457988f)(signature);
    const rs = {
        r: (0, $c50e893d91244e52$export$3131421a7d01b4fb)(sig.r),
        s: (0, $c50e893d91244e52$export$3131421a7d01b4fb)(sig.s)
    };
    return "0x" + $92f9ba877c85a1d7$var$getCurve().recoverPubKey((0, $c50e893d91244e52$export$3131421a7d01b4fb)(digest), rs, sig.recoveryParam).encode("hex", false);
}
function $92f9ba877c85a1d7$export$4a89473d39301224(key, compressed) {
    const bytes = (0, $c50e893d91244e52$export$3131421a7d01b4fb)(key);
    if (bytes.length === 32) {
        const signingKey = new $92f9ba877c85a1d7$export$21643ca94aed3e83(bytes);
        if (compressed) return "0x" + $92f9ba877c85a1d7$var$getCurve().keyFromPrivate(bytes).getPublic(true, "hex");
        return signingKey.publicKey;
    } else if (bytes.length === 33) {
        if (compressed) return (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $92f9ba877c85a1d7$var$getCurve().keyFromPublic(bytes).getPublic(false, "hex");
    } else if (bytes.length === 65) {
        if (!compressed) return (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(bytes);
        return "0x" + $92f9ba877c85a1d7$var$getCurve().keyFromPublic(bytes).getPublic(true, "hex");
    }
    return $92f9ba877c85a1d7$var$logger.throwArgumentError("invalid public or private key", "key", "[REDACTED]");
}



const $116825dab0b16b07$export$83d89fbfd8236492 = "transactions/5.3.0";


"use strict";
const $f94d2c40884137b2$var$logger = new (0, $457ceee81ca294cf$export$efa9a398d6368992)((0, $116825dab0b16b07$export$83d89fbfd8236492));
///////////////////////////////
function $f94d2c40884137b2$var$handleAddress(value) {
    if (value === "0x") return null;
    return (0, $0257bd232cd43f8c$export$88411125f012957a)(value);
}
function $f94d2c40884137b2$var$handleNumber(value) {
    if (value === "0x") return 0, $2b27eee9c323428e$export$aaef8a3eae948f03;
    return (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(value);
}
// Legacy Transaction Fields
const $f94d2c40884137b2$var$transactionFields = [
    {
        name: "nonce",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasPrice",
        maxLength: 32,
        numeric: true
    },
    {
        name: "gasLimit",
        maxLength: 32,
        numeric: true
    },
    {
        name: "to",
        length: 20
    },
    {
        name: "value",
        maxLength: 32,
        numeric: true
    },
    {
        name: "data"
    }
];
const $f94d2c40884137b2$var$allowedTransactionKeys = {
    chainId: true,
    data: true,
    gasLimit: true,
    gasPrice: true,
    nonce: true,
    to: true,
    value: true
};
function $f94d2c40884137b2$export$e67e2732ba9803f9(key) {
    const publicKey = (0, $92f9ba877c85a1d7$export$4a89473d39301224)(key);
    return (0, $0257bd232cd43f8c$export$88411125f012957a)((0, $c50e893d91244e52$export$15da666eba198c18)((0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)((0, $c50e893d91244e52$export$15da666eba198c18)(publicKey, 1)), 12));
}
function $f94d2c40884137b2$export$23cc18f96d8510e2(digest, signature) {
    return $f94d2c40884137b2$export$e67e2732ba9803f9((0, $92f9ba877c85a1d7$export$952dd09fbe0232b7)((0, $c50e893d91244e52$export$3131421a7d01b4fb)(digest), signature));
}
function $f94d2c40884137b2$var$formatNumber(value, name) {
    const result = (0, $c50e893d91244e52$export$a8f4574d0e56446c)((0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(value).toHexString());
    if (result.length > 32) $f94d2c40884137b2$var$logger.throwArgumentError("invalid length for " + name, "transaction:" + name, value);
    return result;
}
function $f94d2c40884137b2$var$accessSetify(addr, storageKeys) {
    return {
        address: (0, $0257bd232cd43f8c$export$88411125f012957a)(addr),
        storageKeys: (storageKeys || []).map((storageKey, index)=>{
            if ((0, $c50e893d91244e52$export$13882f896d3c0683)(storageKey) !== 32) $f94d2c40884137b2$var$logger.throwArgumentError("invalid access list storageKey", `accessList[${addr}:${index}]`, storageKey);
            return storageKey.toLowerCase();
        })
    };
}
function $f94d2c40884137b2$export$6c8662b1600dce2(value) {
    if (Array.isArray(value)) return value.map((set, index)=>{
        if (Array.isArray(set)) {
            if (set.length > 2) $f94d2c40884137b2$var$logger.throwArgumentError("access list expected to be [ address, storageKeys[] ]", `value[${index}]`, set);
            return $f94d2c40884137b2$var$accessSetify(set[0], set[1]);
        }
        return $f94d2c40884137b2$var$accessSetify(set.address, set.storageKeys);
    });
    const result = Object.keys(value).map((addr)=>{
        const storageKeys = value[addr].reduce((accum, storageKey)=>{
            accum[storageKey] = true;
            return accum;
        }, {});
        return $f94d2c40884137b2$var$accessSetify(addr, Object.keys(storageKeys).sort());
    });
    result.sort((a, b)=>a.address.localeCompare(b.address));
    return result;
}
function $f94d2c40884137b2$var$formatAccessList(value) {
    return $f94d2c40884137b2$export$6c8662b1600dce2(value).map((set)=>[
            set.address,
            set.storageKeys
        ]);
}
function $f94d2c40884137b2$var$_serializeEip2930(transaction, signature) {
    const fields = [
        $f94d2c40884137b2$var$formatNumber(transaction.chainId || 0, "chainId"),
        $f94d2c40884137b2$var$formatNumber(transaction.nonce || 0, "nonce"),
        $f94d2c40884137b2$var$formatNumber(transaction.gasPrice || 0, "gasPrice"),
        $f94d2c40884137b2$var$formatNumber(transaction.gasLimit || 0, "gasLimit"),
        transaction.to != null ? (0, $0257bd232cd43f8c$export$88411125f012957a)(transaction.to) : "0x",
        $f94d2c40884137b2$var$formatNumber(transaction.value || 0, "value"),
        transaction.data || "0x",
        $f94d2c40884137b2$var$formatAccessList(transaction.accessList || [])
    ];
    if (signature) {
        const sig = (0, $c50e893d91244e52$export$7fb170f1e457988f)(signature);
        fields.push($f94d2c40884137b2$var$formatNumber(sig.recoveryParam, "recoveryParam"));
        fields.push((0, $c50e893d91244e52$export$a8f4574d0e56446c)(sig.r));
        fields.push((0, $c50e893d91244e52$export$a8f4574d0e56446c)(sig.s));
    }
    return (0, $c50e893d91244e52$export$6d4b99629b38754a)([
        "0x01",
        $39194328b8d1ac52$export$c564cdbbe6da493(fields)
    ]);
}
// Legacy Transactions and EIP-155
function $f94d2c40884137b2$var$_serialize(transaction, signature) {
    (0, $f71b0d1ed409e388$export$ae5a316ba623b73a)(transaction, $f94d2c40884137b2$var$allowedTransactionKeys);
    const raw = [];
    $f94d2c40884137b2$var$transactionFields.forEach(function(fieldInfo) {
        let value = transaction[fieldInfo.name] || [];
        const options = {};
        if (fieldInfo.numeric) options.hexPad = "left";
        value = (0, $c50e893d91244e52$export$3131421a7d01b4fb)((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(value, options));
        // Fixed-width field
        if (fieldInfo.length && value.length !== fieldInfo.length && value.length > 0) $f94d2c40884137b2$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        // Variable-width (with a maximum)
        if (fieldInfo.maxLength) {
            value = (0, $c50e893d91244e52$export$a8f4574d0e56446c)(value);
            if (value.length > fieldInfo.maxLength) $f94d2c40884137b2$var$logger.throwArgumentError("invalid length for " + fieldInfo.name, "transaction:" + fieldInfo.name, value);
        }
        raw.push((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(value));
    });
    let chainId = 0;
    if (transaction.chainId != null) {
        // A chainId was provided; if non-zero we'll use EIP-155
        chainId = transaction.chainId;
        if (typeof chainId !== "number") $f94d2c40884137b2$var$logger.throwArgumentError("invalid transaction.chainId", "transaction", transaction);
    } else if (signature && !(0, $c50e893d91244e52$export$9a14abb1a440cd5e)(signature) && signature.v > 28) // No chainId provided, but the signature is signing with EIP-155; derive chainId
    chainId = Math.floor((signature.v - 35) / 2);
    // We have an EIP-155 transaction (chainId was specified and non-zero)
    if (chainId !== 0) {
        raw.push((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(chainId)); // @TODO: hexValue?
        raw.push("0x");
        raw.push("0x");
    }
    // Requesting an unsigned transation
    if (!signature) return $39194328b8d1ac52$export$c564cdbbe6da493(raw);
    // The splitSignature will ensure the transaction has a recoveryParam in the
    // case that the signTransaction function only adds a v.
    const sig = (0, $c50e893d91244e52$export$7fb170f1e457988f)(signature);
    // We pushed a chainId and null r, s on for hashing only; remove those
    let v = 27 + sig.recoveryParam;
    if (chainId !== 0) {
        raw.pop();
        raw.pop();
        raw.pop();
        v += chainId * 2 + 8;
        // If an EIP-155 v (directly or indirectly; maybe _vs) was provided, check it!
        if (sig.v > 28 && sig.v !== v) $f94d2c40884137b2$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    } else if (sig.v !== v) $f94d2c40884137b2$var$logger.throwArgumentError("transaction.chainId/signature.v mismatch", "signature", signature);
    raw.push((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(v));
    raw.push((0, $c50e893d91244e52$export$a8f4574d0e56446c)((0, $c50e893d91244e52$export$3131421a7d01b4fb)(sig.r)));
    raw.push((0, $c50e893d91244e52$export$a8f4574d0e56446c)((0, $c50e893d91244e52$export$3131421a7d01b4fb)(sig.s)));
    return $39194328b8d1ac52$export$c564cdbbe6da493(raw);
}
function $f94d2c40884137b2$export$dfdc1655ccc5b9cb(transaction, signature) {
    // Legacy and EIP-155 Transactions
    if (transaction.type == null) {
        if (transaction.accessList != null) $f94d2c40884137b2$var$logger.throwArgumentError("untyped transactions do not support accessList; include type: 1", "transaction", transaction);
        return $f94d2c40884137b2$var$_serialize(transaction, signature);
    }
    // Typed Transactions (EIP-2718)
    switch(transaction.type){
        case 1:
            return $f94d2c40884137b2$var$_serializeEip2930(transaction, signature);
        default:
            break;
    }
    return $f94d2c40884137b2$var$logger.throwError(`unsupported transaction type: ${transaction.type}`, (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "serializeTransaction",
        transactionType: transaction.type
    });
}
function $f94d2c40884137b2$var$_parseEip2930(payload) {
    const transaction = $39194328b8d1ac52$export$2f872c0f2117be69(payload.slice(1));
    if (transaction.length !== 8 && transaction.length !== 11) $f94d2c40884137b2$var$logger.throwArgumentError("invalid component count for transaction type: 1", "payload", (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(payload));
    const tx = {
        type: 1,
        chainId: $f94d2c40884137b2$var$handleNumber(transaction[0]).toNumber(),
        nonce: $f94d2c40884137b2$var$handleNumber(transaction[1]).toNumber(),
        gasPrice: $f94d2c40884137b2$var$handleNumber(transaction[2]),
        gasLimit: $f94d2c40884137b2$var$handleNumber(transaction[3]),
        to: $f94d2c40884137b2$var$handleAddress(transaction[4]),
        value: $f94d2c40884137b2$var$handleNumber(transaction[5]),
        data: transaction[6],
        accessList: $f94d2c40884137b2$export$6c8662b1600dce2(transaction[7])
    };
    // Unsigned EIP-2930 Transaction
    if (transaction.length === 8) return tx;
    try {
        const recid = $f94d2c40884137b2$var$handleNumber(transaction[8]).toNumber();
        if (recid !== 0 && recid !== 1) throw new Error("bad recid");
        tx.v = recid;
    } catch (error) {
        $f94d2c40884137b2$var$logger.throwArgumentError("invalid v for transaction type: 1", "v", transaction[8]);
    }
    tx.r = (0, $c50e893d91244e52$export$e9c46a54370b47e8)(transaction[9], 32);
    tx.s = (0, $c50e893d91244e52$export$e9c46a54370b47e8)(transaction[10], 32);
    try {
        const digest = (0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)($f94d2c40884137b2$var$_serializeEip2930(tx));
        tx.from = $f94d2c40884137b2$export$23cc18f96d8510e2(digest, {
            r: tx.r,
            s: tx.s,
            recoveryParam: tx.v
        });
    } catch (error) {
        console.log(error);
    }
    tx.hash = (0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)(payload);
    return tx;
}
// Legacy Transactions and EIP-155
function $f94d2c40884137b2$var$_parse(rawTransaction) {
    const transaction = $39194328b8d1ac52$export$2f872c0f2117be69(rawTransaction);
    if (transaction.length !== 9 && transaction.length !== 6) $f94d2c40884137b2$var$logger.throwArgumentError("invalid raw transaction", "rawTransaction", rawTransaction);
    const tx = {
        nonce: $f94d2c40884137b2$var$handleNumber(transaction[0]).toNumber(),
        gasPrice: $f94d2c40884137b2$var$handleNumber(transaction[1]),
        gasLimit: $f94d2c40884137b2$var$handleNumber(transaction[2]),
        to: $f94d2c40884137b2$var$handleAddress(transaction[3]),
        value: $f94d2c40884137b2$var$handleNumber(transaction[4]),
        data: transaction[5],
        chainId: 0
    };
    // Legacy unsigned transaction
    if (transaction.length === 6) return tx;
    try {
        tx.v = (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(transaction[6]).toNumber();
    } catch (error) {
        console.log(error);
        return tx;
    }
    tx.r = (0, $c50e893d91244e52$export$e9c46a54370b47e8)(transaction[7], 32);
    tx.s = (0, $c50e893d91244e52$export$e9c46a54370b47e8)(transaction[8], 32);
    if ((0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(tx.r).isZero() && (0, $f3b152c28cfe30e9$export$d97aa349ed20696).from(tx.s).isZero()) {
        // EIP-155 unsigned transaction
        tx.chainId = tx.v;
        tx.v = 0;
    } else {
        // Signed Tranasaction
        tx.chainId = Math.floor((tx.v - 35) / 2);
        if (tx.chainId < 0) tx.chainId = 0;
        let recoveryParam = tx.v - 27;
        const raw = transaction.slice(0, 6);
        if (tx.chainId !== 0) {
            raw.push((0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(tx.chainId));
            raw.push("0x");
            raw.push("0x");
            recoveryParam -= tx.chainId * 2 + 8;
        }
        const digest = (0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)($39194328b8d1ac52$export$c564cdbbe6da493(raw));
        try {
            tx.from = $f94d2c40884137b2$export$23cc18f96d8510e2(digest, {
                r: (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(tx.r),
                s: (0, $c50e893d91244e52$export$2b0d6b5fbe698c70)(tx.s),
                recoveryParam: recoveryParam
            });
        } catch (error) {
            console.log(error);
        }
        tx.hash = (0, $5eb237d3c60c9d20$export$f8151fce47ad1c35)(rawTransaction);
    }
    tx.type = null;
    return tx;
}
function $f94d2c40884137b2$export$98e6a39c04603d36(rawTransaction) {
    const payload = (0, $c50e893d91244e52$export$3131421a7d01b4fb)(rawTransaction);
    // Legacy and EIP-155 Transactions
    if (payload[0] > 0x7f) return $f94d2c40884137b2$var$_parse(payload);
    // Typed Transaction (EIP-2718)
    switch(payload[0]){
        case 1:
            return $f94d2c40884137b2$var$_parseEip2930(payload);
        default:
            break;
    }
    return $f94d2c40884137b2$var$logger.throwError(`unsupported transaction type: ${payload[0]}`, (0, $457ceee81ca294cf$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
        operation: "parseTransaction",
        transactionType: payload[0]
    });
}


var $60ff6d2aea0ffa29$var$Method = function Method(options) {
    if (!options.call || !options.name) throw new Error('When creating a method you need to provide at least the "name" and "call" property.');
    this.name = options.name;
    this.call = options.call;
    this.params = options.params || 0;
    this.inputFormatter = options.inputFormatter;
    this.outputFormatter = options.outputFormatter;
    this.transformPayload = options.transformPayload;
    this.extraFormatters = options.extraFormatters;
    this.abiCoder = options.abiCoder; // Will be used to encode the revert reason string
    this.requestManager = options.requestManager;
    // reference to eth.accounts
    this.accounts = options.accounts;
    this.defaultBlock = options.defaultBlock || "latest";
    this.defaultAccount = options.defaultAccount || null;
    this.transactionBlockTimeout = options.transactionBlockTimeout || 50;
    this.transactionConfirmationBlocks = options.transactionConfirmationBlocks || 24;
    this.transactionPollingTimeout = options.transactionPollingTimeout || 750;
    this.defaultCommon = options.defaultCommon;
    this.defaultChain = options.defaultChain;
    this.defaultHardfork = options.defaultHardfork;
    this.handleRevert = options.handleRevert;
};
$60ff6d2aea0ffa29$var$Method.prototype.setRequestManager = function(requestManager, accounts) {
    this.requestManager = requestManager;
    // reference to eth.accounts
    if (accounts) this.accounts = accounts;
};
$60ff6d2aea0ffa29$var$Method.prototype.createFunction = function(requestManager, accounts) {
    var func = this.buildCall();
    func.call = this.call;
    this.setRequestManager(requestManager || this.requestManager, accounts || this.accounts);
    return func;
};
$60ff6d2aea0ffa29$var$Method.prototype.attachToObject = function(obj) {
    var func = this.buildCall();
    func.call = this.call;
    var name = this.name.split(".");
    if (name.length > 1) {
        obj[name[0]] = obj[name[0]] || {};
        obj[name[0]][name[1]] = func;
    } else obj[name[0]] = func;
};
/**
 * Should be used to determine name of the jsonrpc method based on arguments
 *
 * @method getCall
 * @param {Array} arguments
 * @return {String} name of jsonrpc method
 */ $60ff6d2aea0ffa29$var$Method.prototype.getCall = function(args) {
    return typeof this.call === "function" ? this.call(args) : this.call;
};
/**
 * Should be used to extract callback from array of arguments. Modifies input param
 *
 * @method extractCallback
 * @param {Array} arguments
 * @return {Function|Null} callback, if exists
 */ $60ff6d2aea0ffa29$var$Method.prototype.extractCallback = function(args) {
    if (typeof args[args.length - 1] === "function") return args.pop(); // modify the args array!
};
/**
 * Should be called to check if the number of arguments is correct
 *
 * @method validateArgs
 * @param {Array} arguments
 * @throws {Error} if it is not
 */ $60ff6d2aea0ffa29$var$Method.prototype.validateArgs = function(args) {
    if (args.length !== this.params) throw $60ff6d2aea0ffa29$require$errors.InvalidNumberOfParams(args.length, this.params, this.name);
};
/**
 * Should be called to format input args of method
 *
 * @method formatInput
 * @param {Array}
 * @return {Array}
 */ $60ff6d2aea0ffa29$var$Method.prototype.formatInput = function(args) {
    var _this = this;
    if (!this.inputFormatter) return args;
    return this.inputFormatter.map(function(formatter, index) {
        // bind this for defaultBlock, and defaultAccount
        return formatter ? formatter.call(_this, args[index]) : args[index];
    });
};
/**
 * Should be called to format output(result) of method
 *
 * @method formatOutput
 * @param {Object}
 * @return {Object}
 */ $60ff6d2aea0ffa29$var$Method.prototype.formatOutput = function(result) {
    var _this = this;
    if (Array.isArray(result)) return result.map(function(res) {
        return _this.outputFormatter && res ? _this.outputFormatter(res) : res;
    });
    else return this.outputFormatter && result ? this.outputFormatter(result) : result;
};
/**
 * Should create payload from given input args
 *
 * @method toPayload
 * @param {Array} args
 * @return {Object}
 */ $60ff6d2aea0ffa29$var$Method.prototype.toPayload = function(args) {
    var call = this.getCall(args);
    var callback = this.extractCallback(args);
    var params = this.formatInput(args);
    this.validateArgs(params);
    var payload = {
        method: call,
        params: params,
        callback: callback
    };
    if (this.transformPayload) payload = this.transformPayload(payload);
    return payload;
};
$60ff6d2aea0ffa29$var$Method.prototype._confirmTransaction = function(defer, result, payload) {
    var method = this, promiseResolved = false, canUnsubscribe = true, timeoutCount = 0, confirmationCount = 0, intervalId = null, lastBlock = null, receiptJSON = "", gasProvided = !!payload.params[0] && typeof payload.params[0] === "object" && payload.params[0].gas ? payload.params[0].gas : null, isContractDeployment = !!payload.params[0] && typeof payload.params[0] === "object" && payload.params[0].data && payload.params[0].from && !payload.params[0].to, hasBytecode = isContractDeployment && payload.params[0].data.length > 2;
    // add custom send Methods
    var _ethereumCalls = [
        new $60ff6d2aea0ffa29$var$Method({
            name: "getBlockByNumber",
            call: "eth_getBlockByNumber",
            params: 2,
            inputFormatter: [
                $60ff6d2aea0ffa29$require$formatters.inputBlockNumberFormatter,
                function(val) {
                    return !!val;
                }
            ],
            outputFormatter: $60ff6d2aea0ffa29$require$formatters.outputBlockFormatter
        }),
        new $60ff6d2aea0ffa29$var$Method({
            name: "getTransactionReceipt",
            call: "eth_getTransactionReceipt",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $60ff6d2aea0ffa29$require$formatters.outputTransactionReceiptFormatter
        }),
        new $60ff6d2aea0ffa29$var$Method({
            name: "getCode",
            call: "eth_getCode",
            params: 2,
            inputFormatter: [
                $60ff6d2aea0ffa29$require$formatters.inputAddressFormatter,
                $60ff6d2aea0ffa29$require$formatters.inputDefaultBlockNumberFormatter
            ]
        }),
        new $60ff6d2aea0ffa29$var$Method({
            name: "getTransactionByHash",
            call: "eth_getTransactionByHash",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $60ff6d2aea0ffa29$require$formatters.outputTransactionFormatter
        }),
        new $60ff6d2aea0ffa29$require$Subscriptions({
            name: "subscribe",
            type: "eth",
            subscriptions: {
                "newBlockHeaders": {
                    subscriptionName: "newHeads",
                    params: 0,
                    outputFormatter: $60ff6d2aea0ffa29$require$formatters.outputBlockFormatter
                }
            }
        })
    ];
    // attach methods to this._ethereumCall
    var _ethereumCall = {};
    _ethereumCalls.forEach((mthd)=>{
        mthd.attachToObject(_ethereumCall);
        mthd.requestManager = method.requestManager; // assign rather than call setRequestManager()
    });
    // fire "receipt" and confirmation events and resolve after
    var checkConfirmation = function(existingReceipt, isPolling, err, blockHeader, sub) {
        if (!err) {
            // create fake unsubscribe
            if (!sub) sub = {
                unsubscribe: function() {
                    clearInterval(intervalId);
                }
            };
            // if we have a valid receipt we don't need to send a request
            return (existingReceipt ? $4f4e7bc1f87a0108$exports.resolve(existingReceipt) : _ethereumCall.getTransactionReceipt(result))// catch error from requesting receipt
            .catch(function(err) {
                sub.unsubscribe();
                promiseResolved = true;
                $hpg7W._fireError({
                    message: "Failed to check for transaction receipt:",
                    data: err
                }, defer.eventEmitter, defer.reject);
            })// if CONFIRMATION listener exists check for confirmations, by setting canUnsubscribe = false
            .then(async function(receipt) {
                if (!receipt || !receipt.blockHash) throw new Error("Receipt missing or blockHash null");
                // apply extra formatters
                if (method.extraFormatters && method.extraFormatters.receiptFormatter) receipt = method.extraFormatters.receiptFormatter(receipt);
                // check if confirmation listener exists
                if (defer.eventEmitter.listeners("confirmation").length > 0) {
                    var block;
                    // If there was an immediately retrieved receipt, it's already
                    // been confirmed by the direct call to checkConfirmation needed
                    // for parity instant-seal
                    if (existingReceipt === undefined || confirmationCount !== 0) {
                        // Get latest block to emit with confirmation
                        var latestBlock = await _ethereumCall.getBlockByNumber("latest");
                        var latestBlockHash = latestBlock ? latestBlock.hash : null;
                        if (isPolling) {
                            if (lastBlock) {
                                block = await _ethereumCall.getBlockByNumber(lastBlock.number + 1);
                                if (block) {
                                    lastBlock = block;
                                    defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                                }
                            } else {
                                block = await _ethereumCall.getBlockByNumber(receipt.blockNumber);
                                lastBlock = block;
                                defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                            }
                        } else defer.eventEmitter.emit("confirmation", confirmationCount, receipt, latestBlockHash);
                    }
                    if (isPolling && block || !isPolling) confirmationCount++;
                    canUnsubscribe = false;
                    if (confirmationCount === method.transactionConfirmationBlocks + 1) {
                        sub.unsubscribe();
                        defer.eventEmitter.removeAllListeners();
                    }
                }
                return receipt;
            })// CHECK for CONTRACT DEPLOYMENT
            .then(async function(receipt) {
                if (isContractDeployment && !promiseResolved) {
                    if (!receipt.contractAddress) {
                        if (canUnsubscribe) {
                            sub.unsubscribe();
                            promiseResolved = true;
                        }
                        $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.NoContractAddressFoundError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        return;
                    }
                    var code;
                    try {
                        code = await _ethereumCall.getCode(receipt.contractAddress);
                    } catch (err) {
                    // ignore;
                    }
                    if (!code) return;
                    // If deployment is status.true and there was a real
                    // bytecode string, assume it was successful.
                    var deploymentSuccess = receipt.status === true && hasBytecode;
                    if (deploymentSuccess || code.length > 2) {
                        defer.eventEmitter.emit("receipt", receipt);
                        // if contract, return instance instead of receipt
                        if (method.extraFormatters && method.extraFormatters.contractDeployFormatter) defer.resolve(method.extraFormatters.contractDeployFormatter(receipt));
                        else defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.ContractCodeNotStoredError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
                return receipt;
            })// CHECK for normal tx check for receipt only
            .then(async function(receipt) {
                if (!isContractDeployment && !promiseResolved) {
                    if (!receipt.outOfGas && (!gasProvided || gasProvided !== receipt.gasUsed) && (receipt.status === true || receipt.status === "0x1" || typeof receipt.status === "undefined")) {
                        defer.eventEmitter.emit("receipt", receipt);
                        defer.resolve(receipt);
                        // need to remove listeners, as they aren't removed automatically when succesfull
                        if (canUnsubscribe) defer.eventEmitter.removeAllListeners();
                    } else {
                        receiptJSON = JSON.stringify(receipt, null, 2);
                        if (receipt.status === false || receipt.status === "0x0") try {
                            var revertMessage = null;
                            if (method.handleRevert && (method.call === "eth_sendTransaction" || method.call === "eth_sendRawTransaction")) {
                                var txReplayOptions = payload.params[0];
                                // If send was raw, fetch the transaction and reconstitute the
                                // original params so they can be replayed with `eth_call`
                                if (method.call === "eth_sendRawTransaction") {
                                    var rawTransactionHex = payload.params[0];
                                    var parsedTx = $f94d2c40884137b2$export$98e6a39c04603d36(rawTransactionHex);
                                    txReplayOptions = $60ff6d2aea0ffa29$require$formatters.inputTransactionFormatter({
                                        data: parsedTx.data,
                                        to: parsedTx.to,
                                        from: parsedTx.from,
                                        gas: parsedTx.gasLimit.toHexString(),
                                        gasPrice: parsedTx.gasPrice.toHexString(),
                                        value: parsedTx.value.toHexString()
                                    });
                                }
                                // Get revert reason string with eth_call
                                revertMessage = await method.getRevertReason(txReplayOptions, receipt.blockNumber);
                                if (revertMessage) $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.TransactionRevertInstructionError(revertMessage.reason, revertMessage.signature, receipt), defer.eventEmitter, defer.reject, null, receipt);
                                else throw false; // Throw false and let the try/catch statement handle the error correctly after
                            } else throw false; // Throw false and let the try/catch statement handle the error correctly after
                        } catch (error) {
                            // Throw an normal revert error if no revert reason is given or the detection of it is disabled
                            $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.TransactionRevertedWithoutReasonError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                        }
                        else // Throw OOG if status is not existing and provided gas and used gas are equal
                        $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.TransactionOutOfGasError(receipt), defer.eventEmitter, defer.reject, null, receipt);
                    }
                    if (canUnsubscribe) sub.unsubscribe();
                    promiseResolved = true;
                }
            })// time out the transaction if not mined after 50 blocks
            .catch(function() {
                timeoutCount++;
                // check to see if we are http polling
                if (!!isPolling) // polling timeout is different than transactionBlockTimeout blocks since we are triggering every second
                {
                    if (timeoutCount - 1 >= method.transactionPollingTimeout) {
                        sub.unsubscribe();
                        promiseResolved = true;
                        $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.TransactionError("Transaction was not mined within " + method.transactionPollingTimeout + " seconds, please make sure your transaction was properly sent. Be aware that it might still be mined!"), defer.eventEmitter, defer.reject);
                    }
                } else if (timeoutCount - 1 >= method.transactionBlockTimeout) {
                    sub.unsubscribe();
                    promiseResolved = true;
                    $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.TransactionError("Transaction was not mined within " + method.transactionBlockTimeout + " blocks, please make sure your transaction was properly sent. Be aware that it might still be mined!"), defer.eventEmitter, defer.reject);
                }
            });
        } else {
            sub.unsubscribe();
            promiseResolved = true;
            $hpg7W._fireError({
                message: "Failed to subscribe to new newBlockHeaders to confirm the transaction receipts.",
                data: err
            }, defer.eventEmitter, defer.reject);
        }
    };
    // start watching for confirmation depending on the support features of the provider
    var startWatching = (function(existingReceipt) {
        const startInterval = ()=>{
            intervalId = setInterval(checkConfirmation.bind(null, existingReceipt, true), 1000);
        };
        if (!this.requestManager.provider.on) startInterval();
        else _ethereumCall.subscribe("newBlockHeaders", function(err, blockHeader, sub) {
            if (err || !blockHeader) // fall back to polling
            startInterval();
            else checkConfirmation(existingReceipt, false, err, blockHeader, sub);
        });
    }).bind(this);
    // first check if we already have a confirmed transaction
    _ethereumCall.getTransactionReceipt(result).then(function(receipt) {
        if (receipt && receipt.blockHash) {
            if (defer.eventEmitter.listeners("confirmation").length > 0) // We must keep on watching for new Blocks, if a confirmation listener is present
            startWatching(receipt);
            checkConfirmation(receipt, false);
        } else if (!promiseResolved) startWatching();
    }).catch(function() {
        if (!promiseResolved) startWatching();
    });
};
var $60ff6d2aea0ffa29$var$getWallet = function(from, accounts) {
    var wallet = null;
    // is index given
    if (typeof from === "number") wallet = accounts.wallet[from];
    else if (!!from && typeof from === "object" && from.address && from.privateKey) wallet = from;
    else wallet = accounts.wallet[from.toLowerCase()];
    return wallet;
};
$60ff6d2aea0ffa29$var$Method.prototype.buildCall = function() {
    var method = this, isSendTx = method.call === "eth_sendTransaction" || method.call === "eth_sendRawTransaction", isCall = method.call === "eth_call";
    // actual send function
    var send = function() {
        var defer = $4f4e7bc1f87a0108$exports(!isSendTx), payload = method.toPayload(Array.prototype.slice.call(arguments));
        // CALLBACK function
        var sendTxCallback = function(err, result) {
            if (method.handleRevert && isCall && method.abiCoder) {
                var reasonData;
                // Ganache / Geth <= 1.9.13 return the reason data as a successful eth_call response
                // Geth >= 1.9.15 attaches the reason data to an error object.
                // Geth 1.9.14 is missing revert reason (https://github.com/ethereum/web3.js/issues/3520)
                if (!err && method.isRevertReasonString(result)) reasonData = result.substring(10);
                else if (err && err.data) reasonData = err.data.substring(10);
                if (reasonData) {
                    var reason = method.abiCoder.decodeParameter("string", "0x" + reasonData);
                    var signature = "Error(String)";
                    $hpg7W._fireError($60ff6d2aea0ffa29$require$errors.RevertInstructionError(reason, signature), defer.eventEmitter, defer.reject, payload.callback, {
                        reason: reason,
                        signature: signature
                    });
                    return;
                }
            }
            try {
                result = method.formatOutput(result);
            } catch (e) {
                err = e;
            }
            if (result instanceof Error) err = result;
            if (!err) {
                if (payload.callback) payload.callback(null, result);
            } else {
                if (err.error) err = err.error;
                return $hpg7W._fireError(err, defer.eventEmitter, defer.reject, payload.callback);
            }
            // return PROMISE
            if (!isSendTx) {
                if (!err) defer.resolve(result);
            } else {
                defer.eventEmitter.emit("transactionHash", result);
                method._confirmTransaction(defer, result, payload);
            }
        };
        // SENDS the SIGNED SIGNATURE
        var sendSignedTx = function(sign) {
            var signedPayload = {
                ...payload,
                method: "eth_sendRawTransaction",
                params: [
                    sign.rawTransaction
                ]
            };
            method.requestManager.send(signedPayload, sendTxCallback);
        };
        var sendRequest = function(payload, method) {
            if (method && method.accounts && method.accounts.wallet && method.accounts.wallet.length) {
                var wallet;
                // ETH_SENDTRANSACTION
                if (payload.method === "eth_sendTransaction") {
                    var tx = payload.params[0];
                    wallet = $60ff6d2aea0ffa29$var$getWallet(!!tx && typeof tx === "object" ? tx.from : null, method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var tx = JSON.parse(JSON.stringify(tx));
                        delete tx.from;
                        if (method.defaultChain && !tx.chain) tx.chain = method.defaultChain;
                        if (method.defaultHardfork && !tx.hardfork) tx.hardfork = method.defaultHardfork;
                        if (method.defaultCommon && !tx.common) tx.common = method.defaultCommon;
                        method.accounts.signTransaction(tx, wallet.privateKey).then(sendSignedTx).catch(function(err) {
                            if (typeof defer.eventEmitter.listeners === "function" && defer.eventEmitter.listeners("error").length) {
                                try {
                                    defer.eventEmitter.emit("error", err);
                                } catch (err) {
                                // Ignore userland error prevent it to bubble up within web3.
                                }
                                defer.eventEmitter.removeAllListeners();
                                defer.eventEmitter.catch(function() {});
                            }
                            defer.reject(err);
                        });
                        return;
                    }
                // ETH_SIGN
                } else if (payload.method === "eth_sign") {
                    var data = payload.params[1];
                    wallet = $60ff6d2aea0ffa29$var$getWallet(payload.params[0], method.accounts);
                    // If wallet was found, sign tx, and send using sendRawTransaction
                    if (wallet && wallet.privateKey) {
                        var sign = method.accounts.sign(data, wallet.privateKey);
                        if (payload.callback) payload.callback(null, sign.signature);
                        defer.resolve(sign.signature);
                        return;
                    }
                }
            }
            return method.requestManager.send(payload, sendTxCallback);
        };
        // Send the actual transaction
        if (isSendTx && !!payload.params[0] && typeof payload.params[0] === "object" && typeof payload.params[0].gasPrice === "undefined" && (typeof payload.params[0].maxPriorityFeePerGas === "undefined" || typeof payload.params[0].maxFeePerGas === "undefined")) {
            if (typeof payload.params[0].type === "undefined") payload.params[0].type = $60ff6d2aea0ffa29$var$_handleTxType(payload.params[0]);
            $60ff6d2aea0ffa29$var$_handleTxPricing(method, payload.params[0]).then((txPricing)=>{
                if (txPricing.gasPrice !== undefined) payload.params[0].gasPrice = txPricing.gasPrice;
                else if (txPricing.maxPriorityFeePerGas !== undefined && txPricing.maxFeePerGas !== undefined) {
                    payload.params[0].maxPriorityFeePerGas = txPricing.maxPriorityFeePerGas;
                    payload.params[0].maxFeePerGas = txPricing.maxFeePerGas;
                }
                if (isSendTx) setTimeout(()=>{
                    defer.eventEmitter.emit("sending", payload);
                }, 0);
                sendRequest(payload, method);
            });
        } else {
            if (isSendTx) setTimeout(()=>{
                defer.eventEmitter.emit("sending", payload);
            }, 0);
            sendRequest(payload, method);
        }
        if (isSendTx) setTimeout(()=>{
            defer.eventEmitter.emit("sent", payload);
        }, 0);
        return defer.eventEmitter;
    };
    // necessary to attach things to the method
    send.method = method;
    // necessary for batch requests
    send.request = this.request.bind(this);
    return send;
};
function $60ff6d2aea0ffa29$var$_handleTxType(tx) {
    // Taken from https://github.com/ethers-io/ethers.js/blob/2a7ce0e72a1e0c9469e10392b0329e75e341cf18/packages/abstract-signer/src.ts/index.ts#L215
    const hasEip1559 = tx.maxFeePerGas !== undefined || tx.maxPriorityFeePerGas !== undefined;
    let txType;
    if (tx.type !== undefined) txType = $hpg7W.toHex(tx.type);
    else if (tx.type === undefined && hasEip1559) txType = "0x2";
    else txType = "0x0";
    if (tx.gasPrice !== undefined && (txType === "0x2" || hasEip1559)) throw Error("eip-1559 transactions don't support gasPrice");
    if ((txType === "0x1" || txType === "0x0") && hasEip1559) throw Error("pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas");
    if (hasEip1559 || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $60ff6d2aea0ffa29$require$HardForks.London || tx.hardfork && tx.hardfork.toLowerCase() === $60ff6d2aea0ffa29$require$HardForks.London) txType = "0x2";
    else if (tx.accessList || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $60ff6d2aea0ffa29$require$HardForks.Berlin || tx.hardfork && tx.hardfork.toLowerCase() === $60ff6d2aea0ffa29$require$HardForks.Berlin) txType = "0x1";
    return txType;
}
function $60ff6d2aea0ffa29$var$_handleTxPricing(method, tx) {
    return new Promise((resolve, reject)=>{
        try {
            var getBlockByNumber = new $60ff6d2aea0ffa29$var$Method({
                name: "getBlockByNumber",
                call: "eth_getBlockByNumber",
                params: 2,
                inputFormatter: [
                    function(blockNumber) {
                        return blockNumber ? $hpg7W.toHex(blockNumber) : "latest";
                    },
                    function() {
                        return false;
                    }
                ]
            }).createFunction(method.requestManager);
            var getGasPrice = new $60ff6d2aea0ffa29$var$Method({
                name: "getGasPrice",
                call: "eth_gasPrice",
                params: 0
            }).createFunction(method.requestManager);
            if (tx.type < "0x2" && tx.gasPrice !== undefined) // Legacy transaction, return provided gasPrice
            resolve({
                gasPrice: tx.gasPrice
            });
            else Promise.all([
                getBlockByNumber(),
                getGasPrice()
            ]).then((responses)=>{
                const [block, gasPrice] = responses;
                if (tx.type === "0x2" && block && block.baseFeePerGas) {
                    // The network supports EIP-1559
                    // Taken from https://github.com/ethers-io/ethers.js/blob/ba6854bdd5a912fe873d5da494cb5c62c190adde/packages/abstract-provider/src.ts/index.ts#L230
                    let maxPriorityFeePerGas, maxFeePerGas;
                    if (tx.gasPrice) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        maxPriorityFeePerGas = tx.gasPrice;
                        maxFeePerGas = tx.gasPrice;
                        delete tx.gasPrice;
                    } else {
                        maxPriorityFeePerGas = tx.maxPriorityFeePerGas || "0x3B9ACA00"; // 1 Gwei
                        maxFeePerGas = tx.maxFeePerGas || $hpg7W.toHex($hpg7W.toBN(block.baseFeePerGas).mul($hpg7W.toBN(2)).add($hpg7W.toBN(maxPriorityFeePerGas)));
                    }
                    resolve({
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas
                    });
                } else {
                    if (tx.maxPriorityFeePerGas || tx.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                    resolve({
                        gasPrice: gasPrice
                    });
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/**
 * Returns the revert reason string if existing or otherwise false.
 *
 * @method getRevertReason
 *
 * @param {Object} txOptions
 * @param {Number} blockNumber
 *
 * @returns {Promise<Boolean|String>}
 */ $60ff6d2aea0ffa29$var$Method.prototype.getRevertReason = function(txOptions, blockNumber) {
    var self = this;
    return new Promise(function(resolve, reject) {
        new $60ff6d2aea0ffa29$var$Method({
            name: "call",
            call: "eth_call",
            params: 2,
            abiCoder: self.abiCoder,
            handleRevert: true
        }).createFunction(self.requestManager)(txOptions, $hpg7W.numberToHex(blockNumber)).then(function() {
            resolve(false);
        }).catch(function(error) {
            if (error.reason) resolve({
                reason: error.reason,
                signature: error.signature
            });
            else reject(error);
        });
    });
};
/**
 * Checks if the given hex string is a revert message from the EVM
 *
 * @method isRevertReasonString
 *
 * @param {String} data - Hex string prefixed with 0x
 *
 * @returns {Boolean}
 */ $60ff6d2aea0ffa29$var$Method.prototype.isRevertReasonString = function(data) {
    return typeof data === "string" && (data.length - 2) / 2 % 32 === 4 && data.substring(0, 10) === "0x08c379a0";
};
/**
 * Should be called to create the pure JSONRPC request which can be used in a batch request
 *
 * @method request
 * @return {Object} jsonrpc request
 */ $60ff6d2aea0ffa29$var$Method.prototype.request = function() {
    var payload = this.toPayload(Array.prototype.slice.call(arguments));
    payload.format = this.formatOutput.bind(this);
    return payload;
};
$60ff6d2aea0ffa29$exports = $60ff6d2aea0ffa29$var$Method;



var $hpg7W = parcelRequire("hpg7W");
var $8babe2aec18c747f$var$extend = function(pckg) {
    /* jshint maxcomplexity:5 */ var ex = function(extension) {
        var extendedObject;
        if (extension.property) {
            if (!pckg[extension.property]) pckg[extension.property] = {};
            extendedObject = pckg[extension.property];
        } else extendedObject = pckg;
        if (extension.methods) extension.methods.forEach(function(method) {
            if (!(method instanceof $60ff6d2aea0ffa29$exports)) method = new $60ff6d2aea0ffa29$exports(method);
            method.attachToObject(extendedObject);
            method.setRequestManager(pckg._requestManager);
        });
        return pckg;
    };
    ex.formatters = $8babe2aec18c747f$require$formatters;
    ex.utils = $hpg7W;
    ex.Method = $60ff6d2aea0ffa29$exports;
    return ex;
};
$8babe2aec18c747f$exports = $8babe2aec18c747f$var$extend;


const $c0d140841aa0e2a6$var$packageInit = (pkg, args)=>{
    args = Array.prototype.slice.call(args);
    if (!pkg) throw new Error('You need to instantiate using the "new" keyword.');
    // make property of pkg._provider, which can properly set providers
    Object.defineProperty(pkg, "currentProvider", {
        get: ()=>{
            return pkg._provider;
        },
        set: (value)=>{
            return pkg.setProvider(value);
        },
        enumerable: true,
        configurable: true
    });
    // inherit from parent package or create a new RequestManager
    if (args[0] && args[0]._requestManager) pkg._requestManager = args[0]._requestManager;
    else pkg._requestManager = new $2da6253b89d591af$exports.Manager(args[0], args[1]);
    // add givenProvider
    pkg.givenProvider = $2da6253b89d591af$exports.Manager.givenProvider;
    pkg.providers = $2da6253b89d591af$exports.Manager.providers;
    pkg._provider = pkg._requestManager.provider;
    // add SETPROVIDER function (don't overwrite if already existing)
    if (!pkg.setProvider) pkg.setProvider = (provider, net)=>{
        pkg._requestManager.setProvider(provider, net);
        pkg._provider = pkg._requestManager.provider;
        return true;
    };
    pkg.setRequestManager = (manager)=>{
        pkg._requestManager = manager;
        pkg._provider = manager.provider;
    };
    // attach batch request creation
    pkg.BatchRequest = $2da6253b89d591af$exports.BatchManager.bind(null, pkg._requestManager);
    // attach extend function
    pkg.extend = $8babe2aec18c747f$exports(pkg);
};
const $c0d140841aa0e2a6$var$addProviders = (pkg)=>{
    pkg.givenProvider = $2da6253b89d591af$exports.Manager.givenProvider;
    pkg.providers = $2da6253b89d591af$exports.Manager.providers;
};
$c0d140841aa0e2a6$exports = {
    packageInit: $c0d140841aa0e2a6$var$packageInit,
    addProviders: $c0d140841aa0e2a6$var$addProviders
};


var $214a994bad7e103b$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";


var $heyrh = parcelRequire("heyrh");

var $214a994bad7e103b$require$Subscriptions = $51af6b2439bc4ea7$exports.subscriptions;


var $hpg7W = parcelRequire("hpg7W");
var $db630ee0260f83ef$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";



var $hpg7W = parcelRequire("hpg7W");
var $db630ee0260f83ef$var$Net = function() {
    var _this = this;
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    [
        new $60ff6d2aea0ffa29$exports({
            name: "getId",
            call: "net_version",
            params: 0,
            outputFormatter: parseInt
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "isListening",
            call: "net_listening",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getPeerCount",
            call: "net_peerCount",
            params: 0,
            outputFormatter: $hpg7W.hexToNumber
        })
    ].forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
    });
};
$c0d140841aa0e2a6$exports.addProviders($db630ee0260f83ef$var$Net);
$db630ee0260f83ef$exports = $db630ee0260f83ef$var$Net;


var $6c47817db8eaa99b$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";
var $ec93c44aec9e47ce$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file ENS.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";
var $fc7a4943d74a91eb$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file config.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2017
 */ "use strict";
/**
 * Source: https://docs.ens.domains/ens-deployments
 *
 * @type {{addresses: {main: string, rinkeby: string, goerli: string, ropsten: string}}}
 */ var $fc7a4943d74a91eb$var$config = {
    addresses: {
        main: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        ropsten: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        rinkeby: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e",
        goerli: "0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e"
    },
    // These ids obtained at ensdomains docs:
    // https://docs.ens.domains/contract-developer-guide/writing-a-resolver
    interfaceIds: {
        addr: "0x3b3b57de",
        setAddr: "0x3b3b57de",
        pubkey: "0xc8690233",
        setPubkey: "0xc8690233",
        contenthash: "0xbc1c58d1",
        setContenthash: "0xbc1c58d1",
        content: "0xd8389dc5",
        setContent: "0xd8389dc5"
    }
};
$fc7a4943d74a91eb$exports = $fc7a4943d74a91eb$var$config;



var $heyrh = parcelRequire("heyrh");
var $ec93c44aec9e47ce$require$formatters = $heyrh.formatters;

var $hpg7W = parcelRequire("hpg7W");
var $63c7915f18ef7036$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file Registry.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";
var $64f2080ad381d344$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file contract.js
 *
 * To initialize a contract use:
 *
 *  var Contract = require('web3-eth-contract');
 *  Contract.setProvider('ws://localhost:8546');
 *  var contract = new Contract(abi, address, ...);
 *
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";



var $hpg7W = parcelRequire("hpg7W");

var $64f2080ad381d344$require$Subscription = $51af6b2439bc4ea7$exports.subscription;

var $heyrh = parcelRequire("heyrh");
var $64f2080ad381d344$require$formatters = $heyrh.formatters;

var $heyrh = parcelRequire("heyrh");
var $64f2080ad381d344$require$errors = $heyrh.errors;

var $618c9d1507e674b0$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file index.js
 * @author Marek Kotewicz <marek@parity.io>
 * @author Fabian Vogelsteller <fabian@frozeman.de>
 * @date 2018
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $618c9d1507e674b0$require$Buffer = $ihoyg.Buffer;

var $hpg7W = parcelRequire("hpg7W");

var $7vYz3 = parcelRequire("7vYz3");
const $4c8488be00f82633$export$83d89fbfd8236492 = "logger/5.3.0";


"use strict";
let $7c6d6713f9f653fe$var$_permanentCensorErrors = false;
let $7c6d6713f9f653fe$var$_censorErrors = false;
const $7c6d6713f9f653fe$var$LogLevels = {
    debug: 1,
    "default": 2,
    info: 2,
    warning: 3,
    error: 4,
    off: 5
};
let $7c6d6713f9f653fe$var$_logLevel = $7c6d6713f9f653fe$var$LogLevels["default"];
let $7c6d6713f9f653fe$var$_globalLogger = null;
function $7c6d6713f9f653fe$var$_checkNormalize() {
    try {
        const missing = [];
        // Make sure all forms of normalization are supported
        [
            "NFD",
            "NFC",
            "NFKD",
            "NFKC"
        ].forEach((form)=>{
            try {
                if ("test".normalize(form) !== "test") throw new Error("bad normalize");
            } catch (error) {
                missing.push(form);
            }
        });
        if (missing.length) throw new Error("missing " + missing.join(", "));
        if (String.fromCharCode(0xe9).normalize("NFD") !== String.fromCharCode(0x65, 0x0301)) throw new Error("broken implementation");
    } catch (error) {
        return error.message;
    }
    return null;
}
const $7c6d6713f9f653fe$var$_normalizeError = $7c6d6713f9f653fe$var$_checkNormalize();
var $7c6d6713f9f653fe$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARNING"] = "WARNING";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["OFF"] = "OFF";
})($7c6d6713f9f653fe$export$243e62d78d3b544d || ($7c6d6713f9f653fe$export$243e62d78d3b544d = {}));
var $7c6d6713f9f653fe$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    ///////////////////
    // Generic Errors
    // Unknown Error
    ErrorCode["UNKNOWN_ERROR"] = "UNKNOWN_ERROR";
    // Not Implemented
    ErrorCode["NOT_IMPLEMENTED"] = "NOT_IMPLEMENTED";
    // Unsupported Operation
    //   - operation
    ErrorCode["UNSUPPORTED_OPERATION"] = "UNSUPPORTED_OPERATION";
    // Network Error (i.e. Ethereum Network, such as an invalid chain ID)
    //   - event ("noNetwork" is not re-thrown in provider.ready; otherwise thrown)
    ErrorCode["NETWORK_ERROR"] = "NETWORK_ERROR";
    // Some sort of bad response from the server
    ErrorCode["SERVER_ERROR"] = "SERVER_ERROR";
    // Timeout
    ErrorCode["TIMEOUT"] = "TIMEOUT";
    ///////////////////
    // Operational  Errors
    // Buffer Overrun
    ErrorCode["BUFFER_OVERRUN"] = "BUFFER_OVERRUN";
    // Numeric Fault
    //   - operation: the operation being executed
    //   - fault: the reason this faulted
    ErrorCode["NUMERIC_FAULT"] = "NUMERIC_FAULT";
    ///////////////////
    // Argument Errors
    // Missing new operator to an object
    //  - name: The name of the class
    ErrorCode["MISSING_NEW"] = "MISSING_NEW";
    // Invalid argument (e.g. value is incompatible with type) to a function:
    //   - argument: The argument name that was invalid
    //   - value: The value of the argument
    ErrorCode["INVALID_ARGUMENT"] = "INVALID_ARGUMENT";
    // Missing argument to a function:
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["MISSING_ARGUMENT"] = "MISSING_ARGUMENT";
    // Too many arguments
    //   - count: The number of arguments received
    //   - expectedCount: The number of arguments expected
    ErrorCode["UNEXPECTED_ARGUMENT"] = "UNEXPECTED_ARGUMENT";
    ///////////////////
    // Blockchain Errors
    // Call exception
    //  - transaction: the transaction
    //  - address?: the contract address
    //  - args?: The arguments passed into the function
    //  - method?: The Solidity method signature
    //  - errorSignature?: The EIP848 error signature
    //  - errorArgs?: The EIP848 error parameters
    //  - reason: The reason (only for EIP848 "Error(string)")
    ErrorCode["CALL_EXCEPTION"] = "CALL_EXCEPTION";
    // Insufficien funds (< value + gasLimit * gasPrice)
    //   - transaction: the transaction attempted
    ErrorCode["INSUFFICIENT_FUNDS"] = "INSUFFICIENT_FUNDS";
    // Nonce has already been used
    //   - transaction: the transaction attempted
    ErrorCode["NONCE_EXPIRED"] = "NONCE_EXPIRED";
    // The replacement fee for the transaction is too low
    //   - transaction: the transaction attempted
    ErrorCode["REPLACEMENT_UNDERPRICED"] = "REPLACEMENT_UNDERPRICED";
    // The gas limit could not be estimated
    //   - transaction: the transaction passed to estimateGas
    ErrorCode["UNPREDICTABLE_GAS_LIMIT"] = "UNPREDICTABLE_GAS_LIMIT";
    // The transaction was replaced by one with a higher gas price
    //   - reason: "cancelled", "replaced" or "repriced"
    //   - cancelled: true if reason == "cancelled" or reason == "replaced")
    //   - hash: original transaction hash
    //   - replacement: the full TransactionsResponse for the replacement
    //   - receipt: the receipt of the replacement
    ErrorCode["TRANSACTION_REPLACED"] = "TRANSACTION_REPLACED";
})($7c6d6713f9f653fe$export$d4e71bc0b80dc0fb || ($7c6d6713f9f653fe$export$d4e71bc0b80dc0fb = {}));
class $7c6d6713f9f653fe$export$efa9a398d6368992 {
    constructor(version){
        Object.defineProperty(this, "version", {
            enumerable: true,
            value: version,
            writable: false
        });
    }
    _log(logLevel, args) {
        const level = logLevel.toLowerCase();
        if ($7c6d6713f9f653fe$var$LogLevels[level] == null) this.throwArgumentError("invalid log level name", "logLevel", logLevel);
        if ($7c6d6713f9f653fe$var$_logLevel > $7c6d6713f9f653fe$var$LogLevels[level]) return;
        console.log.apply(console, args);
    }
    debug(...args) {
        this._log($7c6d6713f9f653fe$export$efa9a398d6368992.levels.DEBUG, args);
    }
    info(...args) {
        this._log($7c6d6713f9f653fe$export$efa9a398d6368992.levels.INFO, args);
    }
    warn(...args) {
        this._log($7c6d6713f9f653fe$export$efa9a398d6368992.levels.WARNING, args);
    }
    makeError(message, code, params) {
        // Errors are being censored
        if ($7c6d6713f9f653fe$var$_censorErrors) return this.makeError("censored error", code, {});
        if (!code) code = $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNKNOWN_ERROR;
        if (!params) params = {};
        const messageDetails = [];
        Object.keys(params).forEach((key)=>{
            try {
                messageDetails.push(key + "=" + JSON.stringify(params[key]));
            } catch (error) {
                messageDetails.push(key + "=" + JSON.stringify(params[key].toString()));
            }
        });
        messageDetails.push(`code=${code}`);
        messageDetails.push(`version=${this.version}`);
        const reason = message;
        if (messageDetails.length) message += " (" + messageDetails.join(", ") + ")";
        // @TODO: Any??
        const error = new Error(message);
        error.reason = reason;
        error.code = code;
        Object.keys(params).forEach(function(key) {
            error[key] = params[key];
        });
        return error;
    }
    throwError(message, code, params) {
        throw this.makeError(message, code, params);
    }
    throwArgumentError(message, name, value) {
        return this.throwError(message, $7c6d6713f9f653fe$export$efa9a398d6368992.errors.INVALID_ARGUMENT, {
            argument: name,
            value: value
        });
    }
    assert(condition, message, code, params) {
        if (!!condition) return;
        this.throwError(message, code, params);
    }
    assertArgument(condition, message, name, value) {
        if (!!condition) return;
        this.throwArgumentError(message, name, value);
    }
    checkNormalize(message) {
        if (message == null) message = "platform missing String.prototype.normalize";
        if ($7c6d6713f9f653fe$var$_normalizeError) this.throwError("platform missing String.prototype.normalize", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "String.prototype.normalize",
            form: $7c6d6713f9f653fe$var$_normalizeError
        });
    }
    checkSafeUint53(value, message) {
        if (typeof value !== "number") return;
        if (message == null) message = "value not safe";
        if (value < 0 || value >= 0x1fffffffffffff) this.throwError(message, $7c6d6713f9f653fe$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "out-of-safe-range",
            value: value
        });
        if (value % 1) this.throwError(message, $7c6d6713f9f653fe$export$efa9a398d6368992.errors.NUMERIC_FAULT, {
            operation: "checkSafeInteger",
            fault: "non-integer",
            value: value
        });
    }
    checkArgumentCount(count, expectedCount, message) {
        if (message) message = ": " + message;
        else message = "";
        if (count < expectedCount) this.throwError("missing argument" + message, $7c6d6713f9f653fe$export$efa9a398d6368992.errors.MISSING_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
        if (count > expectedCount) this.throwError("too many arguments" + message, $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNEXPECTED_ARGUMENT, {
            count: count,
            expectedCount: expectedCount
        });
    }
    checkNew(target, kind) {
        if (target === Object || target == null) this.throwError("missing new", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    checkAbstract(target, kind) {
        if (target === kind) this.throwError("cannot instantiate abstract class " + JSON.stringify(kind.name) + " directly; use a sub-class", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            name: target.name,
            operation: "new"
        });
        else if (target === Object || target == null) this.throwError("missing new", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.MISSING_NEW, {
            name: kind.name
        });
    }
    static globalLogger() {
        if (!$7c6d6713f9f653fe$var$_globalLogger) $7c6d6713f9f653fe$var$_globalLogger = new $7c6d6713f9f653fe$export$efa9a398d6368992((0, $4c8488be00f82633$export$83d89fbfd8236492));
        return $7c6d6713f9f653fe$var$_globalLogger;
    }
    static setCensorship(censorship, permanent) {
        if (!censorship && permanent) this.globalLogger().throwError("cannot permanently disable censorship", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
            operation: "setCensorship"
        });
        if ($7c6d6713f9f653fe$var$_permanentCensorErrors) {
            if (!censorship) return;
            this.globalLogger().throwError("error censorship permanent", $7c6d6713f9f653fe$export$efa9a398d6368992.errors.UNSUPPORTED_OPERATION, {
                operation: "setCensorship"
            });
        }
        $7c6d6713f9f653fe$var$_censorErrors = !!censorship;
        $7c6d6713f9f653fe$var$_permanentCensorErrors = !!permanent;
    }
    static setLogLevel(logLevel) {
        const level = $7c6d6713f9f653fe$var$LogLevels[logLevel.toLowerCase()];
        if (level == null) {
            $7c6d6713f9f653fe$export$efa9a398d6368992.globalLogger().warn("invalid log level - " + logLevel);
            return;
        }
        $7c6d6713f9f653fe$var$_logLevel = level;
    }
    static from(version) {
        return new $7c6d6713f9f653fe$export$efa9a398d6368992(version);
    }
}
$7c6d6713f9f653fe$export$efa9a398d6368992.errors = $7c6d6713f9f653fe$export$d4e71bc0b80dc0fb;
$7c6d6713f9f653fe$export$efa9a398d6368992.levels = $7c6d6713f9f653fe$export$243e62d78d3b544d;


const $2b87c6841a7c47f9$export$83d89fbfd8236492 = "bytes/5.3.0";


"use strict";
const $1b014f92cae5f25f$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $2b87c6841a7c47f9$export$83d89fbfd8236492));
///////////////////////////////
function $1b014f92cae5f25f$var$isHexable(value) {
    return !!value.toHexString;
}
function $1b014f92cae5f25f$var$addSlice(array) {
    if (array.slice) return array;
    array.slice = function() {
        const args = Array.prototype.slice.call(arguments);
        return $1b014f92cae5f25f$var$addSlice(new Uint8Array(Array.prototype.slice.apply(array, args)));
    };
    return array;
}
function $1b014f92cae5f25f$export$9a14abb1a440cd5e(value) {
    return $1b014f92cae5f25f$export$b02a40aff8e4ad18(value) && !(value.length % 2) || $1b014f92cae5f25f$export$c6fabfbfd097fc30(value);
}
function $1b014f92cae5f25f$export$c6fabfbfd097fc30(value) {
    if (value == null) return false;
    if (value.constructor === Uint8Array) return true;
    if (typeof value === "string") return false;
    if (value.length == null) return false;
    for(let i = 0; i < value.length; i++){
        const v = value[i];
        if (typeof v !== "number" || v < 0 || v >= 256 || v % 1) return false;
    }
    return true;
}
function $1b014f92cae5f25f$export$3131421a7d01b4fb(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $1b014f92cae5f25f$var$logger.checkSafeUint53(value, "invalid arrayify value");
        const result = [];
        while(value){
            result.unshift(value & 0xff);
            value = parseInt(String(value / 256));
        }
        if (result.length === 0) result.push(0);
        return $1b014f92cae5f25f$var$addSlice(new Uint8Array(result));
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($1b014f92cae5f25f$var$isHexable(value)) value = value.toHexString();
    if ($1b014f92cae5f25f$export$b02a40aff8e4ad18(value)) {
        let hex = value.substring(2);
        if (hex.length % 2) {
            if (options.hexPad === "left") hex = "0x0" + hex.substring(2);
            else if (options.hexPad === "right") hex += "0";
            else $1b014f92cae5f25f$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        const result = [];
        for(let i = 0; i < hex.length; i += 2)result.push(parseInt(hex.substring(i, i + 2), 16));
        return $1b014f92cae5f25f$var$addSlice(new Uint8Array(result));
    }
    if ($1b014f92cae5f25f$export$c6fabfbfd097fc30(value)) return $1b014f92cae5f25f$var$addSlice(new Uint8Array(value));
    return $1b014f92cae5f25f$var$logger.throwArgumentError("invalid arrayify value", "value", value);
}
function $1b014f92cae5f25f$export$ee1b3e54f0441b22(items) {
    const objects = items.map((item)=>$1b014f92cae5f25f$export$3131421a7d01b4fb(item));
    const length = objects.reduce((accum, item)=>accum + item.length, 0);
    const result = new Uint8Array(length);
    objects.reduce((offset, object)=>{
        result.set(object, offset);
        return offset + object.length;
    }, 0);
    return $1b014f92cae5f25f$var$addSlice(result);
}
function $1b014f92cae5f25f$export$a8f4574d0e56446c(value) {
    let result = $1b014f92cae5f25f$export$3131421a7d01b4fb(value);
    if (result.length === 0) return result;
    // Find the first non-zero entry
    let start = 0;
    while(start < result.length && result[start] === 0)start++;
    // If we started with zeros, strip them
    if (start) result = result.slice(start);
    return result;
}
function $1b014f92cae5f25f$export$3cdc770bf8b2ed3d(value, length) {
    value = $1b014f92cae5f25f$export$3131421a7d01b4fb(value);
    if (value.length > length) $1b014f92cae5f25f$var$logger.throwArgumentError("value out of range", "value", arguments[0]);
    const result = new Uint8Array(length);
    result.set(value, length - value.length);
    return $1b014f92cae5f25f$var$addSlice(result);
}
function $1b014f92cae5f25f$export$b02a40aff8e4ad18(value, length) {
    if (typeof value !== "string" || !value.match(/^0x[0-9A-Fa-f]*$/)) return false;
    if (length && value.length !== 2 + 2 * length) return false;
    return true;
}
const $1b014f92cae5f25f$var$HexCharacters = "0123456789abcdef";
function $1b014f92cae5f25f$export$2b0d6b5fbe698c70(value, options) {
    if (!options) options = {};
    if (typeof value === "number") {
        $1b014f92cae5f25f$var$logger.checkSafeUint53(value, "invalid hexlify value");
        let hex = "";
        while(value){
            hex = $1b014f92cae5f25f$var$HexCharacters[value & 0xf] + hex;
            value = Math.floor(value / 16);
        }
        if (hex.length) {
            if (hex.length % 2) hex = "0" + hex;
            return "0x" + hex;
        }
        return "0x00";
    }
    if (typeof value === "bigint") {
        value = value.toString(16);
        if (value.length % 2) return "0x0" + value;
        return "0x" + value;
    }
    if (options.allowMissingPrefix && typeof value === "string" && value.substring(0, 2) !== "0x") value = "0x" + value;
    if ($1b014f92cae5f25f$var$isHexable(value)) return value.toHexString();
    if ($1b014f92cae5f25f$export$b02a40aff8e4ad18(value)) {
        if (value.length % 2) {
            if (options.hexPad === "left") value = "0x0" + value.substring(2);
            else if (options.hexPad === "right") value += "0";
            else $1b014f92cae5f25f$var$logger.throwArgumentError("hex data is odd-length", "value", value);
        }
        return value.toLowerCase();
    }
    if ($1b014f92cae5f25f$export$c6fabfbfd097fc30(value)) {
        let result = "0x";
        for(let i = 0; i < value.length; i++){
            let v = value[i];
            result += $1b014f92cae5f25f$var$HexCharacters[(v & 0xf0) >> 4] + $1b014f92cae5f25f$var$HexCharacters[v & 0x0f];
        }
        return result;
    }
    return $1b014f92cae5f25f$var$logger.throwArgumentError("invalid hexlify value", "value", value);
}
function $1b014f92cae5f25f$export$13882f896d3c0683(data) {
    if (typeof data !== "string") data = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(data);
    else if (!$1b014f92cae5f25f$export$b02a40aff8e4ad18(data) || data.length % 2) return null;
    return (data.length - 2) / 2;
}
function $1b014f92cae5f25f$export$15da666eba198c18(data, offset, endOffset) {
    if (typeof data !== "string") data = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(data);
    else if (!$1b014f92cae5f25f$export$b02a40aff8e4ad18(data) || data.length % 2) $1b014f92cae5f25f$var$logger.throwArgumentError("invalid hexData", "value", data);
    offset = 2 + 2 * offset;
    if (endOffset != null) return "0x" + data.substring(offset, 2 + 2 * endOffset);
    return "0x" + data.substring(offset);
}
function $1b014f92cae5f25f$export$6d4b99629b38754a(items) {
    let result = "0x";
    items.forEach((item)=>{
        result += $1b014f92cae5f25f$export$2b0d6b5fbe698c70(item).substring(2);
    });
    return result;
}
function $1b014f92cae5f25f$export$6916af760a341dd3(value) {
    const trimmed = $1b014f92cae5f25f$export$967bc0082a978949($1b014f92cae5f25f$export$2b0d6b5fbe698c70(value, {
        hexPad: "left"
    }));
    if (trimmed === "0x") return "0x0";
    return trimmed;
}
function $1b014f92cae5f25f$export$967bc0082a978949(value) {
    if (typeof value !== "string") value = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(value);
    if (!$1b014f92cae5f25f$export$b02a40aff8e4ad18(value)) $1b014f92cae5f25f$var$logger.throwArgumentError("invalid hex string", "value", value);
    value = value.substring(2);
    let offset = 0;
    while(offset < value.length && value[offset] === "0")offset++;
    return "0x" + value.substring(offset);
}
function $1b014f92cae5f25f$export$e9c46a54370b47e8(value, length) {
    if (typeof value !== "string") value = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(value);
    else if (!$1b014f92cae5f25f$export$b02a40aff8e4ad18(value)) $1b014f92cae5f25f$var$logger.throwArgumentError("invalid hex string", "value", value);
    if (value.length > 2 * length + 2) $1b014f92cae5f25f$var$logger.throwArgumentError("value out of range", "value", arguments[1]);
    while(value.length < 2 * length + 2)value = "0x0" + value.substring(2);
    return value;
}
function $1b014f92cae5f25f$export$7fb170f1e457988f(signature) {
    const result = {
        r: "0x",
        s: "0x",
        _vs: "0x",
        recoveryParam: 0,
        v: 0
    };
    if ($1b014f92cae5f25f$export$9a14abb1a440cd5e(signature)) {
        const bytes = $1b014f92cae5f25f$export$3131421a7d01b4fb(signature);
        if (bytes.length !== 65) $1b014f92cae5f25f$var$logger.throwArgumentError("invalid signature string; must be 65 bytes", "signature", signature);
        // Get the r, s and v
        result.r = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(bytes.slice(0, 32));
        result.s = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
        result.v = bytes[64];
        // Allow a recid to be used as the v
        if (result.v < 27) {
            if (result.v === 0 || result.v === 1) result.v += 27;
            else $1b014f92cae5f25f$var$logger.throwArgumentError("signature invalid v byte", "signature", signature);
        }
        // Compute recoveryParam from v
        result.recoveryParam = 1 - result.v % 2;
        // Compute _vs from recoveryParam and s
        if (result.recoveryParam) bytes[32] |= 0x80;
        result._vs = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(bytes.slice(32, 64));
    } else {
        result.r = signature.r;
        result.s = signature.s;
        result.v = signature.v;
        result.recoveryParam = signature.recoveryParam;
        result._vs = signature._vs;
        // If the _vs is available, use it to populate missing s, v and recoveryParam
        // and verify non-missing s, v and recoveryParam
        if (result._vs != null) {
            const vs = $1b014f92cae5f25f$export$3cdc770bf8b2ed3d($1b014f92cae5f25f$export$3131421a7d01b4fb(result._vs), 32);
            result._vs = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(vs);
            // Set or check the recid
            const recoveryParam = vs[0] >= 128 ? 1 : 0;
            if (result.recoveryParam == null) result.recoveryParam = recoveryParam;
            else if (result.recoveryParam !== recoveryParam) $1b014f92cae5f25f$var$logger.throwArgumentError("signature recoveryParam mismatch _vs", "signature", signature);
            // Set or check the s
            vs[0] &= 0x7f;
            const s = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(vs);
            if (result.s == null) result.s = s;
            else if (result.s !== s) $1b014f92cae5f25f$var$logger.throwArgumentError("signature v mismatch _vs", "signature", signature);
        }
        // Use recid and v to populate each other
        if (result.recoveryParam == null) {
            if (result.v == null) $1b014f92cae5f25f$var$logger.throwArgumentError("signature missing v and recoveryParam", "signature", signature);
            else if (result.v === 0 || result.v === 1) result.recoveryParam = result.v;
            else result.recoveryParam = 1 - result.v % 2;
        } else {
            if (result.v == null) result.v = 27 + result.recoveryParam;
            else if (result.recoveryParam !== 1 - result.v % 2) $1b014f92cae5f25f$var$logger.throwArgumentError("signature recoveryParam mismatch v", "signature", signature);
        }
        if (result.r == null || !$1b014f92cae5f25f$export$b02a40aff8e4ad18(result.r)) $1b014f92cae5f25f$var$logger.throwArgumentError("signature missing or invalid r", "signature", signature);
        else result.r = $1b014f92cae5f25f$export$e9c46a54370b47e8(result.r, 32);
        if (result.s == null || !$1b014f92cae5f25f$export$b02a40aff8e4ad18(result.s)) $1b014f92cae5f25f$var$logger.throwArgumentError("signature missing or invalid s", "signature", signature);
        else result.s = $1b014f92cae5f25f$export$e9c46a54370b47e8(result.s, 32);
        const vs = $1b014f92cae5f25f$export$3131421a7d01b4fb(result.s);
        if (vs[0] >= 128) $1b014f92cae5f25f$var$logger.throwArgumentError("signature s out of range", "signature", signature);
        if (result.recoveryParam) vs[0] |= 0x80;
        const _vs = $1b014f92cae5f25f$export$2b0d6b5fbe698c70(vs);
        if (result._vs) {
            if (!$1b014f92cae5f25f$export$b02a40aff8e4ad18(result._vs)) $1b014f92cae5f25f$var$logger.throwArgumentError("signature invalid _vs", "signature", signature);
            result._vs = $1b014f92cae5f25f$export$e9c46a54370b47e8(result._vs, 32);
        }
        // Set or check the _vs
        if (result._vs == null) result._vs = _vs;
        else if (result._vs !== _vs) $1b014f92cae5f25f$var$logger.throwArgumentError("signature _vs mismatch v and s", "signature", signature);
    }
    return result;
}
function $1b014f92cae5f25f$export$71bb9d78a59bbe25(signature) {
    signature = $1b014f92cae5f25f$export$7fb170f1e457988f(signature);
    return $1b014f92cae5f25f$export$2b0d6b5fbe698c70($1b014f92cae5f25f$export$ee1b3e54f0441b22([
        signature.r,
        signature.s,
        signature.recoveryParam ? "0x1c" : "0x1b"
    ]));
}



const $632ecb2b55b596d8$export$83d89fbfd8236492 = "bignumber/5.3.0";


"use strict";
var $dca7be31a9d42f28$var$BN = (0, (/*@__PURE__*/$parcel$interopDefault($7vYz3))).BN;
const $dca7be31a9d42f28$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $632ecb2b55b596d8$export$83d89fbfd8236492));
const $dca7be31a9d42f28$var$_constructorGuard = {};
const $dca7be31a9d42f28$var$MAX_SAFE = 0x1fffffffffffff;
function $dca7be31a9d42f28$export$a3d0a7fa9b65683b(value) {
    return value != null && ($dca7be31a9d42f28$export$d97aa349ed20696.isBigNumber(value) || typeof value === "number" && value % 1 === 0 || typeof value === "string" && !!value.match(/^-?[0-9]+$/) || (0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(value) || typeof value === "bigint" || (0, $1b014f92cae5f25f$export$c6fabfbfd097fc30)(value));
}
// Only warn about passing 10 into radix once
let $dca7be31a9d42f28$var$_warnedToStringRadix = false;
class $dca7be31a9d42f28$export$d97aa349ed20696 {
    constructor(constructorGuard, hex){
        $dca7be31a9d42f28$var$logger.checkNew(new.target, $dca7be31a9d42f28$export$d97aa349ed20696);
        if (constructorGuard !== $dca7be31a9d42f28$var$_constructorGuard) $dca7be31a9d42f28$var$logger.throwError("cannot call constructor directly; use BigNumber.from", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new (BigNumber)"
        });
        this._hex = hex;
        this._isBigNumber = true;
        Object.freeze(this);
    }
    fromTwos(value) {
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).fromTwos(value));
    }
    toTwos(value) {
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).toTwos(value));
    }
    abs() {
        if (this._hex[0] === "-") return $dca7be31a9d42f28$export$d97aa349ed20696.from(this._hex.substring(1));
        return this;
    }
    add(other) {
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).add($dca7be31a9d42f28$var$toBN(other)));
    }
    sub(other) {
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).sub($dca7be31a9d42f28$var$toBN(other)));
    }
    div(other) {
        const o = $dca7be31a9d42f28$export$d97aa349ed20696.from(other);
        if (o.isZero()) $dca7be31a9d42f28$var$throwFault("division by zero", "div");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).div($dca7be31a9d42f28$var$toBN(other)));
    }
    mul(other) {
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).mul($dca7be31a9d42f28$var$toBN(other)));
    }
    mod(other) {
        const value = $dca7be31a9d42f28$var$toBN(other);
        if (value.isNeg()) $dca7be31a9d42f28$var$throwFault("cannot modulo negative values", "mod");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).umod(value));
    }
    pow(other) {
        const value = $dca7be31a9d42f28$var$toBN(other);
        if (value.isNeg()) $dca7be31a9d42f28$var$throwFault("cannot raise to negative values", "pow");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).pow(value));
    }
    and(other) {
        const value = $dca7be31a9d42f28$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $dca7be31a9d42f28$var$throwFault("cannot 'and' negative values", "and");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).and(value));
    }
    or(other) {
        const value = $dca7be31a9d42f28$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $dca7be31a9d42f28$var$throwFault("cannot 'or' negative values", "or");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).or(value));
    }
    xor(other) {
        const value = $dca7be31a9d42f28$var$toBN(other);
        if (this.isNegative() || value.isNeg()) $dca7be31a9d42f28$var$throwFault("cannot 'xor' negative values", "xor");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).xor(value));
    }
    mask(value) {
        if (this.isNegative() || value < 0) $dca7be31a9d42f28$var$throwFault("cannot mask negative values", "mask");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).maskn(value));
    }
    shl(value) {
        if (this.isNegative() || value < 0) $dca7be31a9d42f28$var$throwFault("cannot shift negative values", "shl");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).shln(value));
    }
    shr(value) {
        if (this.isNegative() || value < 0) $dca7be31a9d42f28$var$throwFault("cannot shift negative values", "shr");
        return $dca7be31a9d42f28$var$toBigNumber($dca7be31a9d42f28$var$toBN(this).shrn(value));
    }
    eq(other) {
        return $dca7be31a9d42f28$var$toBN(this).eq($dca7be31a9d42f28$var$toBN(other));
    }
    lt(other) {
        return $dca7be31a9d42f28$var$toBN(this).lt($dca7be31a9d42f28$var$toBN(other));
    }
    lte(other) {
        return $dca7be31a9d42f28$var$toBN(this).lte($dca7be31a9d42f28$var$toBN(other));
    }
    gt(other) {
        return $dca7be31a9d42f28$var$toBN(this).gt($dca7be31a9d42f28$var$toBN(other));
    }
    gte(other) {
        return $dca7be31a9d42f28$var$toBN(this).gte($dca7be31a9d42f28$var$toBN(other));
    }
    isNegative() {
        return this._hex[0] === "-";
    }
    isZero() {
        return $dca7be31a9d42f28$var$toBN(this).isZero();
    }
    toNumber() {
        try {
            return $dca7be31a9d42f28$var$toBN(this).toNumber();
        } catch (error) {
            $dca7be31a9d42f28$var$throwFault("overflow", "toNumber", this.toString());
        }
        return null;
    }
    toBigInt() {
        try {
            return BigInt(this.toString());
        } catch (e) {}
        return $dca7be31a9d42f28$var$logger.throwError("this platform does not support BigInt", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            value: this.toString()
        });
    }
    toString() {
        // Lots of people expect this, which we do not support, so check (See: #889)
        if (arguments.length > 0) {
            if (arguments[0] === 10) {
                if (!$dca7be31a9d42f28$var$_warnedToStringRadix) {
                    $dca7be31a9d42f28$var$_warnedToStringRadix = true;
                    $dca7be31a9d42f28$var$logger.warn("BigNumber.toString does not accept any parameters; base-10 is assumed");
                }
            } else if (arguments[0] === 16) $dca7be31a9d42f28$var$logger.throwError("BigNumber.toString does not accept any parameters; use bigNumber.toHexString()", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
            else $dca7be31a9d42f28$var$logger.throwError("BigNumber.toString does not accept parameters", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {});
        }
        return $dca7be31a9d42f28$var$toBN(this).toString(10);
    }
    toHexString() {
        return this._hex;
    }
    toJSON(key) {
        return {
            type: "BigNumber",
            hex: this.toHexString()
        };
    }
    static from(value) {
        if (value instanceof $dca7be31a9d42f28$export$d97aa349ed20696) return value;
        if (typeof value === "string") {
            if (value.match(/^-?0x[0-9a-f]+$/i)) return new $dca7be31a9d42f28$export$d97aa349ed20696($dca7be31a9d42f28$var$_constructorGuard, $dca7be31a9d42f28$var$toHex(value));
            if (value.match(/^-?[0-9]+$/)) return new $dca7be31a9d42f28$export$d97aa349ed20696($dca7be31a9d42f28$var$_constructorGuard, $dca7be31a9d42f28$var$toHex(new $dca7be31a9d42f28$var$BN(value)));
            return $dca7be31a9d42f28$var$logger.throwArgumentError("invalid BigNumber string", "value", value);
        }
        if (typeof value === "number") {
            if (value % 1) $dca7be31a9d42f28$var$throwFault("underflow", "BigNumber.from", value);
            if (value >= $dca7be31a9d42f28$var$MAX_SAFE || value <= -$dca7be31a9d42f28$var$MAX_SAFE) $dca7be31a9d42f28$var$throwFault("overflow", "BigNumber.from", value);
            return $dca7be31a9d42f28$export$d97aa349ed20696.from(String(value));
        }
        const anyValue = value;
        if (typeof anyValue === "bigint") return $dca7be31a9d42f28$export$d97aa349ed20696.from(anyValue.toString());
        if ((0, $1b014f92cae5f25f$export$c6fabfbfd097fc30)(anyValue)) return $dca7be31a9d42f28$export$d97aa349ed20696.from((0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(anyValue));
        if (anyValue) {
            // Hexable interface (takes piority)
            if (anyValue.toHexString) {
                const hex = anyValue.toHexString();
                if (typeof hex === "string") return $dca7be31a9d42f28$export$d97aa349ed20696.from(hex);
            } else {
                // For now, handle legacy JSON-ified values (goes away in v6)
                let hex = anyValue._hex;
                // New-form JSON
                if (hex == null && anyValue.type === "BigNumber") hex = anyValue.hex;
                if (typeof hex === "string") {
                    if ((0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(hex) || hex[0] === "-" && (0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(hex.substring(1))) return $dca7be31a9d42f28$export$d97aa349ed20696.from(hex);
                }
            }
        }
        return $dca7be31a9d42f28$var$logger.throwArgumentError("invalid BigNumber value", "value", value);
    }
    static isBigNumber(value) {
        return !!(value && value._isBigNumber);
    }
}
// Normalize the hex string
function $dca7be31a9d42f28$var$toHex(value) {
    // For BN, call on the hex string
    if (typeof value !== "string") return $dca7be31a9d42f28$var$toHex(value.toString(16));
    // If negative, prepend the negative sign to the normalized positive value
    if (value[0] === "-") {
        // Strip off the negative sign
        value = value.substring(1);
        // Cannot have mulitple negative signs (e.g. "--0x04")
        if (value[0] === "-") $dca7be31a9d42f28$var$logger.throwArgumentError("invalid hex", "value", value);
        // Call toHex on the positive component
        value = $dca7be31a9d42f28$var$toHex(value);
        // Do not allow "-0x00"
        if (value === "0x00") return value;
        // Negate the value
        return "-" + value;
    }
    // Add a "0x" prefix if missing
    if (value.substring(0, 2) !== "0x") value = "0x" + value;
    // Normalize zero
    if (value === "0x") return "0x00";
    // Make the string even length
    if (value.length % 2) value = "0x0" + value.substring(2);
    // Trim to smallest even-length string
    while(value.length > 4 && value.substring(0, 4) === "0x00")value = "0x" + value.substring(4);
    return value;
}
function $dca7be31a9d42f28$var$toBigNumber(value) {
    return $dca7be31a9d42f28$export$d97aa349ed20696.from($dca7be31a9d42f28$var$toHex(value));
}
function $dca7be31a9d42f28$var$toBN(value) {
    const hex = $dca7be31a9d42f28$export$d97aa349ed20696.from(value).toHexString();
    if (hex[0] === "-") return new $dca7be31a9d42f28$var$BN("-" + hex.substring(3), 16);
    return new $dca7be31a9d42f28$var$BN(hex.substring(2), 16);
}
function $dca7be31a9d42f28$var$throwFault(fault, operation, value) {
    const params = {
        fault: fault,
        operation: operation
    };
    if (value != null) params.value = value;
    return $dca7be31a9d42f28$var$logger.throwError(fault, (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.NUMERIC_FAULT, params);
}
function $dca7be31a9d42f28$export$51e4a08295f7770f(value) {
    return new $dca7be31a9d42f28$var$BN(value, 36).toString(16);
}
function $dca7be31a9d42f28$export$1293db5d29c264ff(value) {
    return new $dca7be31a9d42f28$var$BN(value, 16).toString(36);
}



const $8c0ff7b7e19a07f0$export$83d89fbfd8236492 = "properties/5.3.0";


"use strict";
var $7f4e84acce6920b4$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $7f4e84acce6920b4$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $8c0ff7b7e19a07f0$export$83d89fbfd8236492));
function $7f4e84acce6920b4$export$104236534534f9be(object, name, value) {
    Object.defineProperty(object, name, {
        enumerable: true,
        value: value,
        writable: false
    });
}
function $7f4e84acce6920b4$export$f695fbbf3cdaaf47(ctor, key) {
    for(let i = 0; i < 32; i++){
        if (ctor[key]) return ctor[key];
        if (!ctor.prototype || typeof ctor.prototype !== "object") break;
        ctor = Object.getPrototypeOf(ctor.prototype).constructor;
    }
    return null;
}
function $7f4e84acce6920b4$export$d503dd157d963b60(object) {
    return $7f4e84acce6920b4$var$__awaiter(this, void 0, void 0, function*() {
        const promises = Object.keys(object).map((key)=>{
            const value = object[key];
            return Promise.resolve(value).then((v)=>({
                    key: key,
                    value: v
                }));
        });
        const results = yield Promise.all(promises);
        return results.reduce((accum, result)=>{
            accum[result.key] = result.value;
            return accum;
        }, {});
    });
}
function $7f4e84acce6920b4$export$ae5a316ba623b73a(object, properties) {
    if (!object || typeof object !== "object") $7f4e84acce6920b4$var$logger.throwArgumentError("invalid object", "object", object);
    Object.keys(object).forEach((key)=>{
        if (!properties[key]) $7f4e84acce6920b4$var$logger.throwArgumentError("invalid object key - " + key, "transaction:" + key, object);
    });
}
function $7f4e84acce6920b4$export$9c13236873b118a5(object) {
    const result = {};
    for(const key in object)result[key] = object[key];
    return result;
}
const $7f4e84acce6920b4$var$opaque = {
    bigint: true,
    boolean: true,
    "function": true,
    number: true,
    string: true
};
function $7f4e84acce6920b4$var$_isFrozen(object) {
    // Opaque objects are not mutable, so safe to copy by assignment
    if (object === undefined || object === null || $7f4e84acce6920b4$var$opaque[typeof object]) return true;
    if (Array.isArray(object) || typeof object === "object") {
        if (!Object.isFrozen(object)) return false;
        const keys = Object.keys(object);
        for(let i = 0; i < keys.length; i++){
            if (!$7f4e84acce6920b4$var$_isFrozen(object[keys[i]])) return false;
        }
        return true;
    }
    return $7f4e84acce6920b4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
// Returns a new copy of object, such that no properties may be replaced.
// New properties may be added only to objects.
function $7f4e84acce6920b4$var$_deepCopy(object) {
    if ($7f4e84acce6920b4$var$_isFrozen(object)) return object;
    // Arrays are mutable, so we need to create a copy
    if (Array.isArray(object)) return Object.freeze(object.map((item)=>$7f4e84acce6920b4$export$6c40052bed430212(item)));
    if (typeof object === "object") {
        const result = {};
        for(const key in object){
            const value = object[key];
            if (value === undefined) continue;
            $7f4e84acce6920b4$export$104236534534f9be(result, key, $7f4e84acce6920b4$export$6c40052bed430212(value));
        }
        return result;
    }
    return $7f4e84acce6920b4$var$logger.throwArgumentError(`Cannot deepCopy ${typeof object}`, "object", object);
}
function $7f4e84acce6920b4$export$6c40052bed430212(object) {
    return $7f4e84acce6920b4$var$_deepCopy(object);
}
class $7f4e84acce6920b4$export$393edc798c47379d {
    constructor(info){
        for(const key in info)this[key] = $7f4e84acce6920b4$export$6c40052bed430212(info[key]);
    }
}



const $7fb639b615393000$export$83d89fbfd8236492 = "abi/5.0.7";


"use strict";
const $84a16b430e377916$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $7fb639b615393000$export$83d89fbfd8236492));
const $84a16b430e377916$var$_constructorGuard = {};
let $84a16b430e377916$var$ModifiersBytes = {
    calldata: true,
    memory: true,
    storage: true
};
let $84a16b430e377916$var$ModifiersNest = {
    calldata: true,
    memory: true
};
function $84a16b430e377916$var$checkModifier(type, name) {
    if (type === "bytes" || type === "string") {
        if ($84a16b430e377916$var$ModifiersBytes[name]) return true;
    } else if (type === "address") {
        if (name === "payable") return true;
    } else if (type.indexOf("[") >= 0 || type === "tuple") {
        if ($84a16b430e377916$var$ModifiersNest[name]) return true;
    }
    if ($84a16b430e377916$var$ModifiersBytes[name] || name === "payable") $84a16b430e377916$var$logger.throwArgumentError("invalid modifier", "name", name);
    return false;
}
// @TODO: Make sure that children of an indexed tuple are marked with a null indexed
function $84a16b430e377916$var$parseParamType(param, allowIndexed) {
    let originalParam = param;
    function throwError(i) {
        $84a16b430e377916$var$logger.throwArgumentError(`unexpected character at position ${i}`, "param", param);
    }
    param = param.replace(/\s/g, " ");
    function newNode(parent) {
        let node = {
            type: "",
            name: "",
            parent: parent,
            state: {
                allowType: true
            }
        };
        if (allowIndexed) node.indexed = false;
        return node;
    }
    let parent = {
        type: "",
        name: "",
        state: {
            allowType: true
        }
    };
    let node = parent;
    for(let i = 0; i < param.length; i++){
        let c = param[i];
        switch(c){
            case "(":
                if (node.state.allowType && node.type === "") node.type = "tuple";
                else if (!node.state.allowParams) throwError(i);
                node.state.allowType = false;
                node.type = $84a16b430e377916$var$verifyType(node.type);
                node.components = [
                    newNode(node)
                ];
                node = node.components[0];
                break;
            case ")":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($84a16b430e377916$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $84a16b430e377916$var$verifyType(node.type);
                let child = node;
                node = node.parent;
                if (!node) throwError(i);
                delete child.parent;
                node.state.allowParams = false;
                node.state.allowName = true;
                node.state.allowArray = true;
                break;
            case ",":
                delete node.state;
                if (node.name === "indexed") {
                    if (!allowIndexed) throwError(i);
                    node.indexed = true;
                    node.name = "";
                }
                if ($84a16b430e377916$var$checkModifier(node.type, node.name)) node.name = "";
                node.type = $84a16b430e377916$var$verifyType(node.type);
                let sibling = newNode(node.parent);
                //{ type: "", name: "", parent: node.parent, state: { allowType: true } };
                node.parent.components.push(sibling);
                delete node.parent;
                node = sibling;
                break;
            // Hit a space...
            case " ":
                // If reading type, the type is done and may read a param or name
                if (node.state.allowType) {
                    if (node.type !== "") {
                        node.type = $84a16b430e377916$var$verifyType(node.type);
                        delete node.state.allowType;
                        node.state.allowName = true;
                        node.state.allowParams = true;
                    }
                }
                // If reading name, the name is done
                if (node.state.allowName) {
                    if (node.name !== "") {
                        if (node.name === "indexed") {
                            if (!allowIndexed) throwError(i);
                            if (node.indexed) throwError(i);
                            node.indexed = true;
                            node.name = "";
                        } else if ($84a16b430e377916$var$checkModifier(node.type, node.name)) node.name = "";
                        else node.state.allowName = false;
                    }
                }
                break;
            case "[":
                if (!node.state.allowArray) throwError(i);
                node.type += c;
                node.state.allowArray = false;
                node.state.allowName = false;
                node.state.readArray = true;
                break;
            case "]":
                if (!node.state.readArray) throwError(i);
                node.type += c;
                node.state.readArray = false;
                node.state.allowArray = true;
                node.state.allowName = true;
                break;
            default:
                if (node.state.allowType) {
                    node.type += c;
                    node.state.allowParams = true;
                    node.state.allowArray = true;
                } else if (node.state.allowName) {
                    node.name += c;
                    delete node.state.allowArray;
                } else if (node.state.readArray) node.type += c;
                else throwError(i);
        }
    }
    if (node.parent) $84a16b430e377916$var$logger.throwArgumentError("unexpected eof", "param", param);
    delete parent.state;
    if (node.name === "indexed") {
        if (!allowIndexed) throwError(originalParam.length - 7);
        if (node.indexed) throwError(originalParam.length - 7);
        node.indexed = true;
        node.name = "";
    } else if ($84a16b430e377916$var$checkModifier(node.type, node.name)) node.name = "";
    parent.type = $84a16b430e377916$var$verifyType(parent.type);
    return parent;
}
function $84a16b430e377916$var$populate(object, params) {
    for(let key in params)(0, $7f4e84acce6920b4$export$104236534534f9be)(object, key, params[key]);
}
const $84a16b430e377916$export$f010f239efc4d445 = Object.freeze({
    // Bare formatting, as is needed for computing a sighash of an event or function
    sighash: "sighash",
    // Human-Readable with Minimal spacing and without names (compact human-readable)
    minimal: "minimal",
    // Human-Readble with nice spacing, including all names
    full: "full",
    // JSON-format a la Solidity
    json: "json"
});
const $84a16b430e377916$var$paramTypeArray = new RegExp(/^(.*)\[([0-9]*)\]$/);
class $84a16b430e377916$export$426dc07f493a4c47 {
    constructor(constructorGuard, params){
        if (constructorGuard !== $84a16b430e377916$var$_constructorGuard) $84a16b430e377916$var$logger.throwError("use fromString", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new ParamType()"
        });
        $84a16b430e377916$var$populate(this, params);
        let match = this.type.match($84a16b430e377916$var$paramTypeArray);
        if (match) $84a16b430e377916$var$populate(this, {
            arrayLength: parseInt(match[2] || "-1"),
            arrayChildren: $84a16b430e377916$export$426dc07f493a4c47.fromObject({
                type: match[1],
                components: this.components
            }),
            baseType: "array"
        });
        else $84a16b430e377916$var$populate(this, {
            arrayLength: null,
            arrayChildren: null,
            baseType: this.components != null ? "tuple" : this.type
        });
        this._isParamType = true;
        Object.freeze(this);
    }
    // Format the parameter fragment
    //   - sighash: "(uint256,address)"
    //   - minimal: "tuple(uint256,address) indexed"
    //   - full:    "tuple(uint256 foo, addres bar) indexed baz"
    format(format) {
        if (!format) format = $84a16b430e377916$export$f010f239efc4d445.sighash;
        if (!$84a16b430e377916$export$f010f239efc4d445[format]) $84a16b430e377916$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $84a16b430e377916$export$f010f239efc4d445.json) {
            let result = {
                type: this.baseType === "tuple" ? "tuple" : this.type,
                name: this.name || undefined
            };
            if (typeof this.indexed === "boolean") result.indexed = this.indexed;
            if (this.components) result.components = this.components.map((comp)=>JSON.parse(comp.format(format)));
            return JSON.stringify(result);
        }
        let result = "";
        // Array
        if (this.baseType === "array") {
            result += this.arrayChildren.format(format);
            result += "[" + (this.arrayLength < 0 ? "" : String(this.arrayLength)) + "]";
        } else if (this.baseType === "tuple") {
            if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) result += this.type;
            result += "(" + this.components.map((comp)=>comp.format(format)).join(format === $84a16b430e377916$export$f010f239efc4d445.full ? ", " : ",") + ")";
        } else result += this.type;
        if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) {
            if (this.indexed === true) result += " indexed";
            if (format === $84a16b430e377916$export$f010f239efc4d445.full && this.name) result += " " + this.name;
        }
        return result;
    }
    static from(value, allowIndexed) {
        if (typeof value === "string") return $84a16b430e377916$export$426dc07f493a4c47.fromString(value, allowIndexed);
        return $84a16b430e377916$export$426dc07f493a4c47.fromObject(value);
    }
    static fromObject(value) {
        if ($84a16b430e377916$export$426dc07f493a4c47.isParamType(value)) return value;
        return new $84a16b430e377916$export$426dc07f493a4c47($84a16b430e377916$var$_constructorGuard, {
            name: value.name || null,
            type: $84a16b430e377916$var$verifyType(value.type),
            indexed: value.indexed == null ? null : !!value.indexed,
            components: value.components ? value.components.map($84a16b430e377916$export$426dc07f493a4c47.fromObject) : null
        });
    }
    static fromString(value, allowIndexed) {
        function ParamTypify(node) {
            return $84a16b430e377916$export$426dc07f493a4c47.fromObject({
                name: node.name,
                type: node.type,
                indexed: node.indexed,
                components: node.components
            });
        }
        return ParamTypify($84a16b430e377916$var$parseParamType(value, !!allowIndexed));
    }
    static isParamType(value) {
        return !!(value != null && value._isParamType);
    }
}
function $84a16b430e377916$var$parseParams(value, allowIndex) {
    return $84a16b430e377916$var$splitNesting(value).map((param)=>$84a16b430e377916$export$426dc07f493a4c47.fromString(param, allowIndex));
}
class $84a16b430e377916$export$ffb0004e005737fa {
    constructor(constructorGuard, params){
        if (constructorGuard !== $84a16b430e377916$var$_constructorGuard) $84a16b430e377916$var$logger.throwError("use a static from method", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "new Fragment()"
        });
        $84a16b430e377916$var$populate(this, params);
        this._isFragment = true;
        Object.freeze(this);
    }
    static from(value) {
        if ($84a16b430e377916$export$ffb0004e005737fa.isFragment(value)) return value;
        if (typeof value === "string") return $84a16b430e377916$export$ffb0004e005737fa.fromString(value);
        return $84a16b430e377916$export$ffb0004e005737fa.fromObject(value);
    }
    static fromObject(value) {
        if ($84a16b430e377916$export$ffb0004e005737fa.isFragment(value)) return value;
        switch(value.type){
            case "function":
                return $84a16b430e377916$export$8d576c928b93668f.fromObject(value);
            case "event":
                return $84a16b430e377916$export$958548f08bac2833.fromObject(value);
            case "constructor":
                return $84a16b430e377916$export$3ac5c9504f801ea4.fromObject(value);
            case "fallback":
            case "receive":
                // @TODO: Something? Maybe return a FunctionFragment? A custom DefaultFunctionFragment?
                return null;
        }
        return $84a16b430e377916$var$logger.throwArgumentError("invalid fragment object", "value", value);
    }
    static fromString(value) {
        // Make sure the "returns" is surrounded by a space and all whitespace is exactly one space
        value = value.replace(/\s/g, " ");
        value = value.replace(/\(/g, " (").replace(/\)/g, ") ").replace(/\s+/g, " ");
        value = value.trim();
        if (value.split(" ")[0] === "event") return $84a16b430e377916$export$958548f08bac2833.fromString(value.substring(5).trim());
        else if (value.split(" ")[0] === "function") return $84a16b430e377916$export$8d576c928b93668f.fromString(value.substring(8).trim());
        else if (value.split("(")[0].trim() === "constructor") return $84a16b430e377916$export$3ac5c9504f801ea4.fromString(value.trim());
        return $84a16b430e377916$var$logger.throwArgumentError("unsupported fragment", "value", value);
    }
    static isFragment(value) {
        return !!(value && value._isFragment);
    }
}
class $84a16b430e377916$export$958548f08bac2833 extends $84a16b430e377916$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $84a16b430e377916$export$f010f239efc4d445.sighash;
        if (!$84a16b430e377916$export$f010f239efc4d445[format]) $84a16b430e377916$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $84a16b430e377916$export$f010f239efc4d445.json) return JSON.stringify({
            type: "event",
            anonymous: this.anonymous,
            name: this.name,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        let result = "";
        if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) result += "event ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $84a16b430e377916$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) {
            if (this.anonymous) result += "anonymous ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $84a16b430e377916$export$958548f08bac2833.fromString(value);
        return $84a16b430e377916$export$958548f08bac2833.fromObject(value);
    }
    static fromObject(value) {
        if ($84a16b430e377916$export$958548f08bac2833.isEventFragment(value)) return value;
        if (value.type !== "event") $84a16b430e377916$var$logger.throwArgumentError("invalid event object", "value", value);
        const params = {
            name: $84a16b430e377916$var$verifyIdentifier(value.name),
            anonymous: value.anonymous,
            inputs: value.inputs ? value.inputs.map($84a16b430e377916$export$426dc07f493a4c47.fromObject) : [],
            type: "event"
        };
        return new $84a16b430e377916$export$958548f08bac2833($84a16b430e377916$var$_constructorGuard, params);
    }
    static fromString(value) {
        let match = value.match($84a16b430e377916$var$regexParen);
        if (!match) $84a16b430e377916$var$logger.throwArgumentError("invalid event string", "value", value);
        let anonymous = false;
        match[3].split(" ").forEach((modifier)=>{
            switch(modifier.trim()){
                case "anonymous":
                    anonymous = true;
                    break;
                case "":
                    break;
                default:
                    $84a16b430e377916$var$logger.warn("unknown modifier: " + modifier);
            }
        });
        return $84a16b430e377916$export$958548f08bac2833.fromObject({
            name: match[1].trim(),
            anonymous: anonymous,
            inputs: $84a16b430e377916$var$parseParams(match[2], true),
            type: "event"
        });
    }
    static isEventFragment(value) {
        return value && value._isFragment && value.type === "event";
    }
}
function $84a16b430e377916$var$parseGas(value, params) {
    params.gas = null;
    let comps = value.split("@");
    if (comps.length !== 1) {
        if (comps.length > 2) $84a16b430e377916$var$logger.throwArgumentError("invalid human-readable ABI signature", "value", value);
        if (!comps[1].match(/^[0-9]+$/)) $84a16b430e377916$var$logger.throwArgumentError("invalid human-readable ABI signature gas", "value", value);
        params.gas = (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(comps[1]);
        return comps[0];
    }
    return value;
}
function $84a16b430e377916$var$parseModifiers(value, params) {
    params.constant = false;
    params.payable = false;
    params.stateMutability = "nonpayable";
    value.split(" ").forEach((modifier)=>{
        switch(modifier.trim()){
            case "constant":
                params.constant = true;
                break;
            case "payable":
                params.payable = true;
                params.stateMutability = "payable";
                break;
            case "nonpayable":
                params.payable = false;
                params.stateMutability = "nonpayable";
                break;
            case "pure":
                params.constant = true;
                params.stateMutability = "pure";
                break;
            case "view":
                params.constant = true;
                params.stateMutability = "view";
                break;
            case "external":
            case "public":
            case "":
                break;
            default:
                console.log("unknown modifier: " + modifier);
        }
    });
}
function $84a16b430e377916$var$verifyState(value) {
    let result = {
        constant: false,
        payable: true,
        stateMutability: "payable"
    };
    if (value.stateMutability != null) {
        result.stateMutability = value.stateMutability;
        // Set (and check things are consistent) the constant property
        result.constant = result.stateMutability === "view" || result.stateMutability === "pure";
        if (value.constant != null) {
            if (!!value.constant !== result.constant) $84a16b430e377916$var$logger.throwArgumentError("cannot have constant function with mutability " + result.stateMutability, "value", value);
        }
        // Set (and check things are consistent) the payable property
        result.payable = result.stateMutability === "payable";
        if (value.payable != null) {
            if (!!value.payable !== result.payable) $84a16b430e377916$var$logger.throwArgumentError("cannot have payable function with mutability " + result.stateMutability, "value", value);
        }
    } else if (value.payable != null) {
        result.payable = !!value.payable;
        // If payable we can assume non-constant; otherwise we can't assume
        if (value.constant == null && !result.payable && value.type !== "constructor") $84a16b430e377916$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
        result.constant = !!value.constant;
        if (result.constant) result.stateMutability = "view";
        else result.stateMutability = result.payable ? "payable" : "nonpayable";
        if (result.payable && result.constant) $84a16b430e377916$var$logger.throwArgumentError("cannot have constant payable function", "value", value);
    } else if (value.constant != null) {
        result.constant = !!value.constant;
        result.payable = !result.constant;
        result.stateMutability = result.constant ? "view" : "payable";
    } else if (value.type !== "constructor") $84a16b430e377916$var$logger.throwArgumentError("unable to determine stateMutability", "value", value);
    return result;
}
class $84a16b430e377916$export$3ac5c9504f801ea4 extends $84a16b430e377916$export$ffb0004e005737fa {
    format(format) {
        if (!format) format = $84a16b430e377916$export$f010f239efc4d445.sighash;
        if (!$84a16b430e377916$export$f010f239efc4d445[format]) $84a16b430e377916$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $84a16b430e377916$export$f010f239efc4d445.json) return JSON.stringify({
            type: "constructor",
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payble: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format)))
        });
        if (format === $84a16b430e377916$export$f010f239efc4d445.sighash) $84a16b430e377916$var$logger.throwError("cannot format a constructor for sighash", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNSUPPORTED_OPERATION, {
            operation: "format(sighash)"
        });
        let result = "constructor(" + this.inputs.map((input)=>input.format(format)).join(format === $84a16b430e377916$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (this.stateMutability && this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $84a16b430e377916$export$3ac5c9504f801ea4.fromString(value);
        return $84a16b430e377916$export$3ac5c9504f801ea4.fromObject(value);
    }
    static fromObject(value) {
        if ($84a16b430e377916$export$3ac5c9504f801ea4.isConstructorFragment(value)) return value;
        if (value.type !== "constructor") $84a16b430e377916$var$logger.throwArgumentError("invalid constructor object", "value", value);
        let state = $84a16b430e377916$var$verifyState(value);
        if (state.constant) $84a16b430e377916$var$logger.throwArgumentError("constructor cannot be constant", "value", value);
        const params = {
            name: null,
            type: value.type,
            inputs: value.inputs ? value.inputs.map($84a16b430e377916$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $84a16b430e377916$export$3ac5c9504f801ea4($84a16b430e377916$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "constructor"
        };
        value = $84a16b430e377916$var$parseGas(value, params);
        let parens = value.match($84a16b430e377916$var$regexParen);
        if (!parens || parens[1].trim() !== "constructor") $84a16b430e377916$var$logger.throwArgumentError("invalid constructor string", "value", value);
        params.inputs = $84a16b430e377916$var$parseParams(parens[2].trim(), false);
        $84a16b430e377916$var$parseModifiers(parens[3].trim(), params);
        return $84a16b430e377916$export$3ac5c9504f801ea4.fromObject(params);
    }
    static isConstructorFragment(value) {
        return value && value._isFragment && value.type === "constructor";
    }
}
class $84a16b430e377916$export$8d576c928b93668f extends $84a16b430e377916$export$3ac5c9504f801ea4 {
    format(format) {
        if (!format) format = $84a16b430e377916$export$f010f239efc4d445.sighash;
        if (!$84a16b430e377916$export$f010f239efc4d445[format]) $84a16b430e377916$var$logger.throwArgumentError("invalid format type", "format", format);
        if (format === $84a16b430e377916$export$f010f239efc4d445.json) return JSON.stringify({
            type: "function",
            name: this.name,
            constant: this.constant,
            stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : undefined,
            payble: this.payable,
            gas: this.gas ? this.gas.toNumber() : undefined,
            inputs: this.inputs.map((input)=>JSON.parse(input.format(format))),
            ouputs: this.outputs.map((output)=>JSON.parse(output.format(format)))
        });
        let result = "";
        if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) result += "function ";
        result += this.name + "(" + this.inputs.map((input)=>input.format(format)).join(format === $84a16b430e377916$export$f010f239efc4d445.full ? ", " : ",") + ") ";
        if (format !== $84a16b430e377916$export$f010f239efc4d445.sighash) {
            if (this.stateMutability) {
                if (this.stateMutability !== "nonpayable") result += this.stateMutability + " ";
            } else if (this.constant) result += "view ";
            if (this.outputs && this.outputs.length) result += "returns (" + this.outputs.map((output)=>output.format(format)).join(", ") + ") ";
            if (this.gas != null) result += "@" + this.gas.toString() + " ";
        }
        return result.trim();
    }
    static from(value) {
        if (typeof value === "string") return $84a16b430e377916$export$8d576c928b93668f.fromString(value);
        return $84a16b430e377916$export$8d576c928b93668f.fromObject(value);
    }
    static fromObject(value) {
        if ($84a16b430e377916$export$8d576c928b93668f.isFunctionFragment(value)) return value;
        if (value.type !== "function") $84a16b430e377916$var$logger.throwArgumentError("invalid function object", "value", value);
        let state = $84a16b430e377916$var$verifyState(value);
        const params = {
            type: value.type,
            name: $84a16b430e377916$var$verifyIdentifier(value.name),
            constant: state.constant,
            inputs: value.inputs ? value.inputs.map($84a16b430e377916$export$426dc07f493a4c47.fromObject) : [],
            outputs: value.outputs ? value.outputs.map($84a16b430e377916$export$426dc07f493a4c47.fromObject) : [],
            payable: state.payable,
            stateMutability: state.stateMutability,
            gas: value.gas ? (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(value.gas) : null
        };
        return new $84a16b430e377916$export$8d576c928b93668f($84a16b430e377916$var$_constructorGuard, params);
    }
    static fromString(value) {
        let params = {
            type: "function"
        };
        value = $84a16b430e377916$var$parseGas(value, params);
        let comps = value.split(" returns ");
        if (comps.length > 2) $84a16b430e377916$var$logger.throwArgumentError("invalid function string", "value", value);
        let parens = comps[0].match($84a16b430e377916$var$regexParen);
        if (!parens) $84a16b430e377916$var$logger.throwArgumentError("invalid function signature", "value", value);
        params.name = parens[1].trim();
        if (params.name) $84a16b430e377916$var$verifyIdentifier(params.name);
        params.inputs = $84a16b430e377916$var$parseParams(parens[2], false);
        $84a16b430e377916$var$parseModifiers(parens[3].trim(), params);
        // We have outputs
        if (comps.length > 1) {
            let returns = comps[1].match($84a16b430e377916$var$regexParen);
            if (returns[1].trim() != "" || returns[3].trim() != "") $84a16b430e377916$var$logger.throwArgumentError("unexpected tokens", "value", value);
            params.outputs = $84a16b430e377916$var$parseParams(returns[2], false);
        } else params.outputs = [];
        return $84a16b430e377916$export$8d576c928b93668f.fromObject(params);
    }
    static isFunctionFragment(value) {
        return value && value._isFragment && value.type === "function";
    }
}
//export class ErrorFragment extends Fragment {
//}
//export class StructFragment extends Fragment {
//}
function $84a16b430e377916$var$verifyType(type) {
    // These need to be transformed to their full description
    if (type.match(/^uint($|[^1-9])/)) type = "uint256" + type.substring(4);
    else if (type.match(/^int($|[^1-9])/)) type = "int256" + type.substring(3);
    // @TODO: more verification
    return type;
}
const $84a16b430e377916$var$regexIdentifier = new RegExp("^[A-Za-z_][A-Za-z0-9_]*$");
function $84a16b430e377916$var$verifyIdentifier(value) {
    if (!value || !value.match($84a16b430e377916$var$regexIdentifier)) $84a16b430e377916$var$logger.throwArgumentError(`invalid identifier "${value}"`, "value", value);
    return value;
}
const $84a16b430e377916$var$regexParen = new RegExp("^([^)(]*)\\((.*)\\)([^)(]*)$");
function $84a16b430e377916$var$splitNesting(value) {
    value = value.trim();
    let result = [];
    let accum = "";
    let depth = 0;
    for(let offset = 0; offset < value.length; offset++){
        let c = value[offset];
        if (c === "," && depth === 0) {
            result.push(accum);
            accum = "";
        } else {
            accum += c;
            if (c === "(") depth++;
            else if (c === ")") {
                depth--;
                if (depth === -1) $84a16b430e377916$var$logger.throwArgumentError("unbalanced parenthesis", "value", value);
            }
        }
    }
    if (accum) result.push(accum);
    return result;
}











"use strict";
const $96d5e5149aeee47f$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $7fb639b615393000$export$83d89fbfd8236492));
function $96d5e5149aeee47f$export$5546b9ec21157cc2(result) {
    // Find the first error (if any)
    const errors = [];
    const checkErrors = function(path, object) {
        if (!Array.isArray(object)) return;
        for(let key in object){
            const childPath = path.slice();
            childPath.push(key);
            try {
                checkErrors(childPath, object[key]);
            } catch (error) {
                errors.push({
                    path: childPath,
                    error: error
                });
            }
        }
    };
    checkErrors([], result);
    return errors;
}
class $96d5e5149aeee47f$export$2c0c39526f8bad46 {
    constructor(name, type, localName, dynamic){
        // @TODO: defineReadOnly these
        this.name = name;
        this.type = type;
        this.localName = localName;
        this.dynamic = dynamic;
    }
    _throwError(message, value) {
        $96d5e5149aeee47f$var$logger.throwArgumentError(message, this.localName, value);
    }
}
class $96d5e5149aeee47f$export$d7a960146e1a269e {
    constructor(wordSize){
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        this._data = [];
        this._dataLength = 0;
        this._padding = new Uint8Array(wordSize);
    }
    get data() {
        return (0, $1b014f92cae5f25f$export$6d4b99629b38754a)(this._data);
    }
    get length() {
        return this._dataLength;
    }
    _writeData(data) {
        this._data.push(data);
        this._dataLength += data.length;
        return data.length;
    }
    appendWriter(writer) {
        return this._writeData((0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)(writer._data));
    }
    // Arrayish items; padded on the right to wordSize
    writeBytes(value) {
        let bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(value);
        const paddingOffset = bytes.length % this.wordSize;
        if (paddingOffset) bytes = (0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)([
            bytes,
            this._padding.slice(paddingOffset)
        ]);
        return this._writeData(bytes);
    }
    _getValue(value) {
        let bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)((0, $dca7be31a9d42f28$export$d97aa349ed20696).from(value));
        if (bytes.length > this.wordSize) $96d5e5149aeee47f$var$logger.throwError("value out-of-bounds", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
            length: this.wordSize,
            offset: bytes.length
        });
        if (bytes.length % this.wordSize) bytes = (0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)([
            this._padding.slice(bytes.length % this.wordSize),
            bytes
        ]);
        return bytes;
    }
    // BigNumberish items; padded on the left to wordSize
    writeValue(value) {
        return this._writeData(this._getValue(value));
    }
    writeUpdatableValue() {
        const offset = this._data.length;
        this._data.push(this._padding);
        this._dataLength += this.wordSize;
        return (value)=>{
            this._data[offset] = this._getValue(value);
        };
    }
}
class $96d5e5149aeee47f$export$2f7a2f0e90c07dc4 {
    constructor(data, wordSize, coerceFunc, allowLoose){
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "_data", (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data));
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "wordSize", wordSize || 32);
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "_coerceFunc", coerceFunc);
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "allowLoose", allowLoose);
        this._offset = 0;
    }
    get data() {
        return (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(this._data);
    }
    get consumed() {
        return this._offset;
    }
    // The default Coerce function
    static coerce(name, value) {
        let match = name.match("^u?int([0-9]+)$");
        if (match && parseInt(match[1]) <= 48) value = value.toNumber();
        return value;
    }
    coerce(name, value) {
        if (this._coerceFunc) return this._coerceFunc(name, value);
        return $96d5e5149aeee47f$export$2f7a2f0e90c07dc4.coerce(name, value);
    }
    _peekBytes(offset, length, loose) {
        let alignedLength = Math.ceil(length / this.wordSize) * this.wordSize;
        if (this._offset + alignedLength > this._data.length) {
            if (this.allowLoose && loose && this._offset + length <= this._data.length) alignedLength = length;
            else $96d5e5149aeee47f$var$logger.throwError("data out-of-bounds", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {
                length: this._data.length,
                offset: this._offset + alignedLength
            });
        }
        return this._data.slice(this._offset, this._offset + alignedLength);
    }
    subReader(offset) {
        return new $96d5e5149aeee47f$export$2f7a2f0e90c07dc4(this._data.slice(this._offset + offset), this.wordSize, this._coerceFunc, this.allowLoose);
    }
    readBytes(length, loose) {
        let bytes = this._peekBytes(0, length, !!loose);
        this._offset += bytes.length;
        // @TODO: Make sure the length..end bytes are all 0?
        return bytes.slice(0, length);
    }
    readValue() {
        return (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(this.readBytes(this.wordSize));
    }
}






"use strict";
function $d3d3a9436b2bb4b4$export$f8151fce47ad1c35(data) {
    return "0x" + (0, (/*@__PURE__*/$parcel$interopDefault($8228226827ed2eec$exports))).keccak_256((0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data));
}




const $fe197f81b323dbe5$export$83d89fbfd8236492 = "rlp/5.3.0";


"use strict";
const $900761dba37c7101$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $fe197f81b323dbe5$export$83d89fbfd8236492));
function $900761dba37c7101$var$arrayifyInteger(value) {
    const result = [];
    while(value){
        result.unshift(value & 0xff);
        value >>= 8;
    }
    return result;
}
function $900761dba37c7101$var$unarrayifyInteger(data, offset, length) {
    let result = 0;
    for(let i = 0; i < length; i++)result = result * 256 + data[offset + i];
    return result;
}
function $900761dba37c7101$var$_encode(object) {
    if (Array.isArray(object)) {
        let payload = [];
        object.forEach(function(child) {
            payload = payload.concat($900761dba37c7101$var$_encode(child));
        });
        if (payload.length <= 55) {
            payload.unshift(0xc0 + payload.length);
            return payload;
        }
        const length = $900761dba37c7101$var$arrayifyInteger(payload.length);
        length.unshift(0xf7 + length.length);
        return length.concat(payload);
    }
    if (!(0, $1b014f92cae5f25f$export$9a14abb1a440cd5e)(object)) $900761dba37c7101$var$logger.throwArgumentError("RLP object must be BytesLike", "object", object);
    const data = Array.prototype.slice.call((0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(object));
    if (data.length === 1 && data[0] <= 0x7f) return data;
    else if (data.length <= 55) {
        data.unshift(0x80 + data.length);
        return data;
    }
    const length = $900761dba37c7101$var$arrayifyInteger(data.length);
    length.unshift(0xb7 + length.length);
    return length.concat(data);
}
function $900761dba37c7101$export$c564cdbbe6da493(object) {
    return (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)($900761dba37c7101$var$_encode(object));
}
function $900761dba37c7101$var$_decodeChildren(data, offset, childOffset, length) {
    const result = [];
    while(childOffset < offset + 1 + length){
        const decoded = $900761dba37c7101$var$_decode(data, childOffset);
        result.push(decoded.result);
        childOffset += decoded.consumed;
        if (childOffset > offset + 1 + length) $900761dba37c7101$var$logger.throwError("child data too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    }
    return {
        consumed: 1 + length,
        result: result
    };
}
// returns { consumed: number, result: Object }
function $900761dba37c7101$var$_decode(data, offset) {
    if (data.length === 0) $900761dba37c7101$var$logger.throwError("data too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
    // Array with extra length prefix
    if (data[offset] >= 0xf8) {
        const lengthLength = data[offset] - 0xf7;
        if (offset + 1 + lengthLength > data.length) $900761dba37c7101$var$logger.throwError("data short segment too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $900761dba37c7101$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $900761dba37c7101$var$logger.throwError("data long segment too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $900761dba37c7101$var$_decodeChildren(data, offset, offset + 1 + lengthLength, lengthLength + length);
    } else if (data[offset] >= 0xc0) {
        const length = data[offset] - 0xc0;
        if (offset + 1 + length > data.length) $900761dba37c7101$var$logger.throwError("data array too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        return $900761dba37c7101$var$_decodeChildren(data, offset, offset + 1, length);
    } else if (data[offset] >= 0xb8) {
        const lengthLength = data[offset] - 0xb7;
        if (offset + 1 + lengthLength > data.length) $900761dba37c7101$var$logger.throwError("data array too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const length = $900761dba37c7101$var$unarrayifyInteger(data, offset + 1, lengthLength);
        if (offset + 1 + lengthLength + length > data.length) $900761dba37c7101$var$logger.throwError("data array too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(data.slice(offset + 1 + lengthLength, offset + 1 + lengthLength + length));
        return {
            consumed: 1 + lengthLength + length,
            result: result
        };
    } else if (data[offset] >= 0x80) {
        const length = data[offset] - 0x80;
        if (offset + 1 + length > data.length) $900761dba37c7101$var$logger.throwError("data too short", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN, {});
        const result = (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(data.slice(offset + 1, offset + 1 + length));
        return {
            consumed: 1 + length,
            result: result
        };
    }
    return {
        consumed: 1,
        result: (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(data[offset])
    };
}
function $900761dba37c7101$export$2f872c0f2117be69(data) {
    const bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data);
    const decoded = $900761dba37c7101$var$_decode(bytes, 0);
    if (decoded.consumed !== bytes.length) $900761dba37c7101$var$logger.throwArgumentError("invalid rlp data", "data", data);
    return decoded.result;
}



const $ad70656990198c91$export$83d89fbfd8236492 = "address/5.3.0";


"use strict";
const $4159d98cef43574c$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $ad70656990198c91$export$83d89fbfd8236492));
function $4159d98cef43574c$var$getChecksumAddress(address) {
    if (!(0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(address, 20)) $4159d98cef43574c$var$logger.throwArgumentError("invalid address", "address", address);
    address = address.toLowerCase();
    const chars = address.substring(2).split("");
    const expanded = new Uint8Array(40);
    for(let i = 0; i < 40; i++)expanded[i] = chars[i].charCodeAt(0);
    const hashed = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)((0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)(expanded));
    for(let i = 0; i < 40; i += 2){
        if (hashed[i >> 1] >> 4 >= 8) chars[i] = chars[i].toUpperCase();
        if ((hashed[i >> 1] & 0x0f) >= 8) chars[i + 1] = chars[i + 1].toUpperCase();
    }
    return "0x" + chars.join("");
}
// Shims for environments that are missing some required constants and functions
const $4159d98cef43574c$var$MAX_SAFE_INTEGER = 0x1fffffffffffff;
function $4159d98cef43574c$var$log10(x) {
    if (Math.log10) return Math.log10(x);
    return Math.log(x) / Math.LN10;
}
// See: https://en.wikipedia.org/wiki/International_Bank_Account_Number
// Create lookup table
const $4159d98cef43574c$var$ibanLookup = {};
for(let i = 0; i < 10; i++)$4159d98cef43574c$var$ibanLookup[String(i)] = String(i);
for(let i = 0; i < 26; i++)$4159d98cef43574c$var$ibanLookup[String.fromCharCode(65 + i)] = String(10 + i);
// How many decimal digits can we process? (for 64-bit float, this is 15)
const $4159d98cef43574c$var$safeDigits = Math.floor($4159d98cef43574c$var$log10($4159d98cef43574c$var$MAX_SAFE_INTEGER));
function $4159d98cef43574c$var$ibanChecksum(address) {
    address = address.toUpperCase();
    address = address.substring(4) + address.substring(0, 2) + "00";
    let expanded = address.split("").map((c)=>{
        return $4159d98cef43574c$var$ibanLookup[c];
    }).join("");
    // Javascript can handle integers safely up to 15 (decimal) digits
    while(expanded.length >= $4159d98cef43574c$var$safeDigits){
        let block = expanded.substring(0, $4159d98cef43574c$var$safeDigits);
        expanded = parseInt(block, 10) % 97 + expanded.substring(block.length);
    }
    let checksum = String(98 - parseInt(expanded, 10) % 97);
    while(checksum.length < 2)checksum = "0" + checksum;
    return checksum;
}
function $4159d98cef43574c$export$88411125f012957a(address) {
    let result = null;
    if (typeof address !== "string") $4159d98cef43574c$var$logger.throwArgumentError("invalid address", "address", address);
    if (address.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
        // Missing the 0x prefix
        if (address.substring(0, 2) !== "0x") address = "0x" + address;
        result = $4159d98cef43574c$var$getChecksumAddress(address);
        // It is a checksummed address with a bad checksum
        if (address.match(/([A-F].*[a-f])|([a-f].*[A-F])/) && result !== address) $4159d98cef43574c$var$logger.throwArgumentError("bad address checksum", "address", address);
    // Maybe ICAP? (we only support direct mode)
    } else if (address.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
        // It is an ICAP address with a bad checksum
        if (address.substring(2, 4) !== $4159d98cef43574c$var$ibanChecksum(address)) $4159d98cef43574c$var$logger.throwArgumentError("bad icap checksum", "address", address);
        result = (0, $dca7be31a9d42f28$export$51e4a08295f7770f)(address.substring(4));
        while(result.length < 40)result = "0" + result;
        result = $4159d98cef43574c$var$getChecksumAddress("0x" + result);
    } else $4159d98cef43574c$var$logger.throwArgumentError("invalid address", "address", address);
    return result;
}
function $4159d98cef43574c$export$977e255126d763d6(address) {
    try {
        $4159d98cef43574c$export$88411125f012957a(address);
        return true;
    } catch (error) {}
    return false;
}
function $4159d98cef43574c$export$962c4ddada9f668f(address) {
    let base36 = (0, $dca7be31a9d42f28$export$1293db5d29c264ff)($4159d98cef43574c$export$88411125f012957a(address).substring(2)).toUpperCase();
    while(base36.length < 30)base36 = "0" + base36;
    return "XE" + $4159d98cef43574c$var$ibanChecksum("XE00" + base36) + base36;
}
function $4159d98cef43574c$export$b7fbffef12272e40(transaction) {
    let from = null;
    try {
        from = $4159d98cef43574c$export$88411125f012957a(transaction.from);
    } catch (error) {
        $4159d98cef43574c$var$logger.throwArgumentError("missing from address", "transaction", transaction);
    }
    const nonce = (0, $1b014f92cae5f25f$export$a8f4574d0e56446c)((0, $1b014f92cae5f25f$export$3131421a7d01b4fb)((0, $dca7be31a9d42f28$export$d97aa349ed20696).from(transaction.nonce).toHexString()));
    return $4159d98cef43574c$export$88411125f012957a((0, $1b014f92cae5f25f$export$15da666eba198c18)((0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)((0, $900761dba37c7101$export$c564cdbbe6da493)([
        from,
        nonce
    ])), 12));
}
function $4159d98cef43574c$export$e0b22d96621f73a2(from, salt, initCodeHash) {
    if ((0, $1b014f92cae5f25f$export$13882f896d3c0683)(salt) !== 32) $4159d98cef43574c$var$logger.throwArgumentError("salt must be 32 bytes", "salt", salt);
    if ((0, $1b014f92cae5f25f$export$13882f896d3c0683)(initCodeHash) !== 32) $4159d98cef43574c$var$logger.throwArgumentError("initCodeHash must be 32 bytes", "initCodeHash", initCodeHash);
    return $4159d98cef43574c$export$88411125f012957a((0, $1b014f92cae5f25f$export$15da666eba198c18)((0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)((0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)([
        "0xff",
        $4159d98cef43574c$export$88411125f012957a(from),
        salt,
        initCodeHash
    ])), 12));
}




"use strict";
class $fcff3105dcb258e8$export$59dbbded7775bfe7 extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("address", "address", localName, false);
    }
    encode(writer, value) {
        try {
            (0, $4159d98cef43574c$export$88411125f012957a)(value);
        } catch (error) {
            this._throwError(error.message, value);
        }
        return writer.writeValue(value);
    }
    decode(reader) {
        return (0, $4159d98cef43574c$export$88411125f012957a)((0, $1b014f92cae5f25f$export$e9c46a54370b47e8)(reader.readValue().toHexString(), 20));
    }
}






"use strict";
class $5b2137964ffa30e6$export$87c41d1139a03fa2 extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(coder){
        super(coder.name, coder.type, undefined, coder.dynamic);
        this.coder = coder;
    }
    encode(writer, value) {
        return this.coder.encode(writer, value);
    }
    decode(reader) {
        return this.coder.decode(reader);
    }
}


"use strict";
const $162dde4a816a3426$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $7fb639b615393000$export$83d89fbfd8236492));
function $162dde4a816a3426$export$2a703dbb0cb35339(writer, coders, values) {
    let arrayValues = null;
    if (Array.isArray(values)) arrayValues = values;
    else if (values && typeof values === "object") {
        let unique = {};
        arrayValues = coders.map((coder)=>{
            const name = coder.localName;
            if (!name) $162dde4a816a3426$var$logger.throwError("cannot encode object for signature with missing names", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            if (unique[name]) $162dde4a816a3426$var$logger.throwError("cannot encode object for signature with duplicate names", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "values",
                coder: coder,
                value: values
            });
            unique[name] = true;
            return values[name];
        });
    } else $162dde4a816a3426$var$logger.throwArgumentError("invalid tuple value", "tuple", values);
    if (coders.length !== arrayValues.length) $162dde4a816a3426$var$logger.throwArgumentError("types/value length mismatch", "tuple", values);
    let staticWriter = new (0, $96d5e5149aeee47f$export$d7a960146e1a269e)(writer.wordSize);
    let dynamicWriter = new (0, $96d5e5149aeee47f$export$d7a960146e1a269e)(writer.wordSize);
    let updateFuncs = [];
    coders.forEach((coder, index)=>{
        let value = arrayValues[index];
        if (coder.dynamic) {
            // Get current dynamic offset (for the future pointer)
            let dynamicOffset = dynamicWriter.length;
            // Encode the dynamic value into the dynamicWriter
            coder.encode(dynamicWriter, value);
            // Prepare to populate the correct offset once we are done
            let updateFunc = staticWriter.writeUpdatableValue();
            updateFuncs.push((baseOffset)=>{
                updateFunc(baseOffset + dynamicOffset);
            });
        } else coder.encode(staticWriter, value);
    });
    // Backfill all the dynamic offsets, now that we know the static length
    updateFuncs.forEach((func)=>{
        func(staticWriter.length);
    });
    let length = writer.appendWriter(staticWriter);
    length += writer.appendWriter(dynamicWriter);
    return length;
}
function $162dde4a816a3426$export$417857010dc9287f(reader, coders) {
    let values = [];
    // A reader anchored to this base
    let baseReader = reader.subReader(0);
    coders.forEach((coder)=>{
        let value = null;
        if (coder.dynamic) {
            let offset = reader.readValue();
            let offsetReader = baseReader.subReader(offset.toNumber());
            try {
                value = coder.decode(offsetReader);
            } catch (error) {
                // Cannot recover from this
                if (error.code === (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
                value = error;
                value.baseType = coder.name;
                value.name = coder.localName;
                value.type = coder.type;
            }
        } else try {
            value = coder.decode(reader);
        } catch (error) {
            // Cannot recover from this
            if (error.code === (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.BUFFER_OVERRUN) throw error;
            value = error;
            value.baseType = coder.name;
            value.name = coder.localName;
            value.type = coder.type;
        }
        if (value != undefined) values.push(value);
    });
    // We only output named properties for uniquely named coders
    const uniqueNames = coders.reduce((accum, coder)=>{
        const name = coder.localName;
        if (name) {
            if (!accum[name]) accum[name] = 0;
            accum[name]++;
        }
        return accum;
    }, {});
    // Add any named parameters (i.e. tuples)
    coders.forEach((coder, index)=>{
        let name = coder.localName;
        if (!name || uniqueNames[name] !== 1) return;
        if (name === "length") name = "_length";
        if (values[name] != null) return;
        const value = values[index];
        if (value instanceof Error) Object.defineProperty(values, name, {
            get: ()=>{
                throw value;
            }
        });
        else values[name] = value;
    });
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (value instanceof Error) Object.defineProperty(values, i, {
            get: ()=>{
                throw value;
            }
        });
    }
    return Object.freeze(values);
}
class $162dde4a816a3426$export$88bc419d2df11f54 extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(coder, length, localName){
        const type = coder.type + "[" + (length >= 0 ? length : "") + "]";
        const dynamic = length === -1 || coder.dynamic;
        super("array", type, localName, dynamic);
        this.coder = coder;
        this.length = length;
    }
    encode(writer, value) {
        if (!Array.isArray(value)) this._throwError("expected array value", value);
        let count = this.length;
        if (count === -1) {
            count = value.length;
            writer.writeValue(value.length);
        }
        $162dde4a816a3426$var$logger.checkArgumentCount(value.length, count, "coder array" + (this.localName ? " " + this.localName : ""));
        let coders = [];
        for(let i = 0; i < value.length; i++)coders.push(this.coder);
        return $162dde4a816a3426$export$2a703dbb0cb35339(writer, coders, value);
    }
    decode(reader) {
        let count = this.length;
        if (count === -1) count = reader.readValue().toNumber();
        let coders = [];
        for(let i = 0; i < count; i++)coders.push(new (0, $5b2137964ffa30e6$export$87c41d1139a03fa2)(this.coder));
        return reader.coerce(this.name, $162dde4a816a3426$export$417857010dc9287f(reader, coders));
    }
}



"use strict";
class $aaa78a99cc93e97a$export$fe9118d6c093150c extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("bool", "bool", localName, false);
    }
    encode(writer, value) {
        return writer.writeValue(value ? 1 : 0);
    }
    decode(reader) {
        return reader.coerce(this.type, !reader.readValue().isZero());
    }
}




"use strict";
class $eafeedffad8ee5a8$export$db9eadd8df12ad2e extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(type, localName){
        super(type, type, localName, true);
    }
    encode(writer, value) {
        value = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(value);
        let length = writer.writeValue(value.length);
        length += writer.writeBytes(value);
        return length;
    }
    decode(reader) {
        return reader.readBytes(reader.readValue().toNumber(), true);
    }
}
class $eafeedffad8ee5a8$export$e5823e9574df18d2 extends $eafeedffad8ee5a8$export$db9eadd8df12ad2e {
    constructor(localName){
        super("bytes", localName);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(super.decode(reader)));
    }
}




"use strict";
class $fa157b02870c9b74$export$7dec9db68e6bcf5a extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(size, localName){
        let name = "bytes" + String(size);
        super(name, name, localName, false);
        this.size = size;
    }
    encode(writer, value) {
        let data = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(value);
        if (data.length !== this.size) this._throwError("incorrect data length", value);
        return writer.writeBytes(data);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(reader.readBytes(this.size)));
    }
}



"use strict";
class $330bc6d7023508b8$export$70982cadf2d6b4ec extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(localName){
        super("null", "", localName, false);
    }
    encode(writer, value) {
        if (value != null) this._throwError("not null", value);
        return writer.writeBytes([]);
    }
    decode(reader) {
        reader.readBytes(0);
        return reader.coerce(this.name, null);
    }
}




const $73b04d7151bc51b5$export$c83ef0909a6ddeec = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(-1);
const $73b04d7151bc51b5$export$aaef8a3eae948f03 = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(0);
const $73b04d7151bc51b5$export$9aa05a5866350bcf = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(1);
const $73b04d7151bc51b5$export$9276dd97bf62cc8d = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(2);
const $73b04d7151bc51b5$export$c8db55bd7405209e = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from("1000000000000000000");
const $73b04d7151bc51b5$export$1b53890de5aabdd0 = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
const $73b04d7151bc51b5$export$963c9b9317b80aaf = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from("-0x8000000000000000000000000000000000000000000000000000000000000000");
const $73b04d7151bc51b5$export$6f8dbb07ebe6d738 = /*#__PURE__*/ (0, $dca7be31a9d42f28$export$d97aa349ed20696).from("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");



"use strict";
class $0c453c4146e3302e$export$b934dc8cfe13938c extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(size, signed, localName){
        const name = (signed ? "int" : "uint") + size * 8;
        super(name, name, localName, false);
        this.size = size;
        this.signed = signed;
    }
    encode(writer, value) {
        let v = (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(value);
        // Check bounds are safe for encoding
        let maxUintValue = (0, $73b04d7151bc51b5$export$1b53890de5aabdd0).mask(writer.wordSize * 8);
        if (this.signed) {
            let bounds = maxUintValue.mask(this.size * 8 - 1);
            if (v.gt(bounds) || v.lt(bounds.add((0, $73b04d7151bc51b5$export$9aa05a5866350bcf)).mul((0, $73b04d7151bc51b5$export$c83ef0909a6ddeec)))) this._throwError("value out-of-bounds", value);
        } else if (v.lt((0, $73b04d7151bc51b5$export$aaef8a3eae948f03)) || v.gt(maxUintValue.mask(this.size * 8))) this._throwError("value out-of-bounds", value);
        v = v.toTwos(this.size * 8).mask(this.size * 8);
        if (this.signed) v = v.fromTwos(this.size * 8).toTwos(8 * writer.wordSize);
        return writer.writeValue(v);
    }
    decode(reader) {
        let value = reader.readValue().mask(this.size * 8);
        if (this.signed) value = value.fromTwos(this.size * 8);
        return reader.coerce(this.name, value);
    }
}




const $c2d822366bcf2500$export$83d89fbfd8236492 = "strings/5.3.0";


"use strict";
const $f48aa322f4fc7218$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $c2d822366bcf2500$export$83d89fbfd8236492));
var $f48aa322f4fc7218$export$c6986442964129f5;
(function(UnicodeNormalizationForm) {
    UnicodeNormalizationForm["current"] = "";
    UnicodeNormalizationForm["NFC"] = "NFC";
    UnicodeNormalizationForm["NFD"] = "NFD";
    UnicodeNormalizationForm["NFKC"] = "NFKC";
    UnicodeNormalizationForm["NFKD"] = "NFKD";
})($f48aa322f4fc7218$export$c6986442964129f5 || ($f48aa322f4fc7218$export$c6986442964129f5 = {}));
var $f48aa322f4fc7218$export$c285fa6ac15ff6a6;
(function(Utf8ErrorReason) {
    // A continuation byte was present where there was nothing to continue
    // - offset = the index the codepoint began in
    Utf8ErrorReason["UNEXPECTED_CONTINUE"] = "unexpected continuation byte";
    // An invalid (non-continuation) byte to start a UTF-8 codepoint was found
    // - offset = the index the codepoint began in
    Utf8ErrorReason["BAD_PREFIX"] = "bad codepoint prefix";
    // The string is too short to process the expected codepoint
    // - offset = the index the codepoint began in
    Utf8ErrorReason["OVERRUN"] = "string overrun";
    // A missing continuation byte was expected but not found
    // - offset = the index the continuation byte was expected at
    Utf8ErrorReason["MISSING_CONTINUE"] = "missing continuation byte";
    // The computed code point is outside the range for UTF-8
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; outside the UTF-8 range
    Utf8ErrorReason["OUT_OF_RANGE"] = "out of UTF-8 range";
    // UTF-8 strings may not contain UTF-16 surrogate pairs
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; inside the UTF-16 surrogate range
    Utf8ErrorReason["UTF16_SURROGATE"] = "UTF-16 surrogate";
    // The string is an overlong reperesentation
    // - offset       = start of this codepoint
    // - badCodepoint = the computed codepoint; already bounds checked
    Utf8ErrorReason["OVERLONG"] = "overlong representation";
})($f48aa322f4fc7218$export$c285fa6ac15ff6a6 || ($f48aa322f4fc7218$export$c285fa6ac15ff6a6 = {}));
function $f48aa322f4fc7218$var$errorFunc(reason, offset, bytes, output, badCodepoint) {
    return $f48aa322f4fc7218$var$logger.throwArgumentError(`invalid codepoint at offset ${offset}; ${reason}`, "bytes", bytes);
}
function $f48aa322f4fc7218$var$ignoreFunc(reason, offset, bytes, output, badCodepoint) {
    // If there is an invalid prefix (including stray continuation), skip any additional continuation bytes
    if (reason === $f48aa322f4fc7218$export$c285fa6ac15ff6a6.BAD_PREFIX || reason === $f48aa322f4fc7218$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE) {
        let i = 0;
        for(let o = offset + 1; o < bytes.length; o++){
            if (bytes[o] >> 6 !== 0x02) break;
            i++;
        }
        return i;
    }
    // This byte runs us past the end of the string, so just jump to the end
    // (but the first byte was read already read and therefore skipped)
    if (reason === $f48aa322f4fc7218$export$c285fa6ac15ff6a6.OVERRUN) return bytes.length - offset - 1;
    // Nothing to skip
    return 0;
}
function $f48aa322f4fc7218$var$replaceFunc(reason, offset, bytes, output, badCodepoint) {
    // Overlong representations are otherwise "valid" code points; just non-deistingtished
    if (reason === $f48aa322f4fc7218$export$c285fa6ac15ff6a6.OVERLONG) {
        output.push(badCodepoint);
        return 0;
    }
    // Put the replacement character into the output
    output.push(0xfffd);
    // Otherwise, process as if ignoring errors
    return $f48aa322f4fc7218$var$ignoreFunc(reason, offset, bytes, output, badCodepoint);
}
const $f48aa322f4fc7218$export$c6e2180c5bb5bc05 = Object.freeze({
    error: $f48aa322f4fc7218$var$errorFunc,
    ignore: $f48aa322f4fc7218$var$ignoreFunc,
    replace: $f48aa322f4fc7218$var$replaceFunc
});
// http://stackoverflow.com/questions/13356493/decode-utf-8-with-javascript#13691499
function $f48aa322f4fc7218$var$getUtf8CodePoints(bytes, onError) {
    if (onError == null) onError = $f48aa322f4fc7218$export$c6e2180c5bb5bc05.error;
    bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(bytes);
    const result = [];
    let i = 0;
    // Invalid bytes are ignored
    while(i < bytes.length){
        const c = bytes[i++];
        // 0xxx xxxx
        if (c >> 7 === 0) {
            result.push(c);
            continue;
        }
        // Multibyte; how many bytes left for this character?
        let extraLength = null;
        let overlongMask = null;
        // 110x xxxx 10xx xxxx
        if ((c & 0xe0) === 0xc0) {
            extraLength = 1;
            overlongMask = 0x7f;
        // 1110 xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf0) === 0xe0) {
            extraLength = 2;
            overlongMask = 0x7ff;
        // 1111 0xxx 10xx xxxx 10xx xxxx 10xx xxxx
        } else if ((c & 0xf8) === 0xf0) {
            extraLength = 3;
            overlongMask = 0xffff;
        } else {
            if ((c & 0xc0) === 0x80) i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.UNEXPECTED_CONTINUE, i - 1, bytes, result);
            else i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.BAD_PREFIX, i - 1, bytes, result);
            continue;
        }
        // Do we have enough bytes in our data?
        if (i - 1 + extraLength >= bytes.length) {
            i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.OVERRUN, i - 1, bytes, result);
            continue;
        }
        // Remove the length prefix from the char
        let res = c & (1 << 8 - extraLength - 1) - 1;
        for(let j = 0; j < extraLength; j++){
            let nextChar = bytes[i];
            // Invalid continuation byte
            if ((nextChar & 0xc0) != 0x80) {
                i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.MISSING_CONTINUE, i, bytes, result);
                res = null;
                break;
            }
            res = res << 6 | nextChar & 0x3f;
            i++;
        }
        // See above loop for invalid contimuation byte
        if (res === null) continue;
        // Maximum code point
        if (res > 0x10ffff) {
            i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.OUT_OF_RANGE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Reserved for UTF-16 surrogate halves
        if (res >= 0xd800 && res <= 0xdfff) {
            i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.UTF16_SURROGATE, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        // Check for overlong sequences (more bytes than needed)
        if (res <= overlongMask) {
            i += onError($f48aa322f4fc7218$export$c285fa6ac15ff6a6.OVERLONG, i - 1 - extraLength, bytes, result, res);
            continue;
        }
        result.push(res);
    }
    return result;
}
function $f48aa322f4fc7218$export$8feeb310b4b4752f(str, form = $f48aa322f4fc7218$export$c6986442964129f5.current) {
    if (form != $f48aa322f4fc7218$export$c6986442964129f5.current) {
        $f48aa322f4fc7218$var$logger.checkNormalize();
        str = str.normalize(form);
    }
    let result = [];
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 0x80) result.push(c);
        else if (c < 0x800) {
            result.push(c >> 6 | 0xc0);
            result.push(c & 0x3f | 0x80);
        } else if ((c & 0xfc00) == 0xd800) {
            i++;
            const c2 = str.charCodeAt(i);
            if (i >= str.length || (c2 & 0xfc00) !== 0xdc00) throw new Error("invalid utf-8 string");
            // Surrogate Pair
            const pair = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
            result.push(pair >> 18 | 0xf0);
            result.push(pair >> 12 & 0x3f | 0x80);
            result.push(pair >> 6 & 0x3f | 0x80);
            result.push(pair & 0x3f | 0x80);
        } else {
            result.push(c >> 12 | 0xe0);
            result.push(c >> 6 & 0x3f | 0x80);
            result.push(c & 0x3f | 0x80);
        }
    }
    return (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(result);
}
function $f48aa322f4fc7218$var$escapeChar(value) {
    const hex = "0000" + value.toString(16);
    return "\\u" + hex.substring(hex.length - 4);
}
function $f48aa322f4fc7218$export$a7a0ec15960b9055(bytes, onError) {
    return '"' + $f48aa322f4fc7218$var$getUtf8CodePoints(bytes, onError).map((codePoint)=>{
        if (codePoint < 256) {
            switch(codePoint){
                case 8:
                    return "\\b";
                case 9:
                    return "\\t";
                case 10:
                    return "\\n";
                case 13:
                    return "\\r";
                case 34:
                    return '\\"';
                case 92:
                    return "\\\\";
            }
            if (codePoint >= 32 && codePoint < 127) return String.fromCharCode(codePoint);
        }
        if (codePoint <= 0xffff) return $f48aa322f4fc7218$var$escapeChar(codePoint);
        codePoint -= 0x10000;
        return $f48aa322f4fc7218$var$escapeChar((codePoint >> 10 & 0x3ff) + 0xd800) + $f48aa322f4fc7218$var$escapeChar((codePoint & 0x3ff) + 0xdc00);
    }).join("") + '"';
}
function $f48aa322f4fc7218$export$232e1dab03132235(codePoints) {
    return codePoints.map((codePoint)=>{
        if (codePoint <= 0xffff) return String.fromCharCode(codePoint);
        codePoint -= 0x10000;
        return String.fromCharCode((codePoint >> 10 & 0x3ff) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
    }).join("");
}
function $f48aa322f4fc7218$export$7643a1dc2c38d5eb(bytes, onError) {
    return $f48aa322f4fc7218$export$232e1dab03132235($f48aa322f4fc7218$var$getUtf8CodePoints(bytes, onError));
}
function $f48aa322f4fc7218$export$ae470a36a31b28c2(str, form = $f48aa322f4fc7218$export$c6986442964129f5.current) {
    return $f48aa322f4fc7218$var$getUtf8CodePoints($f48aa322f4fc7218$export$8feeb310b4b4752f(str, form));
}



"use strict";
class $badf53e68799dc4a$export$2d1b854518731426 extends (0, $eafeedffad8ee5a8$export$db9eadd8df12ad2e) {
    constructor(localName){
        super("string", localName);
    }
    encode(writer, value) {
        return super.encode(writer, (0, $f48aa322f4fc7218$export$8feeb310b4b4752f)(value));
    }
    decode(reader) {
        return (0, $f48aa322f4fc7218$export$7643a1dc2c38d5eb)(super.decode(reader));
    }
}




"use strict";
class $0c5de501637e07ae$export$e9fceba8f110fea6 extends (0, $96d5e5149aeee47f$export$2c0c39526f8bad46) {
    constructor(coders, localName){
        let dynamic = false;
        const types = [];
        coders.forEach((coder)=>{
            if (coder.dynamic) dynamic = true;
            types.push(coder.type);
        });
        const type = "tuple(" + types.join(",") + ")";
        super("tuple", type, localName, dynamic);
        this.coders = coders;
    }
    encode(writer, value) {
        return (0, $162dde4a816a3426$export$2a703dbb0cb35339)(writer, this.coders, value);
    }
    decode(reader) {
        return reader.coerce(this.name, (0, $162dde4a816a3426$export$417857010dc9287f)(reader, this.coders));
    }
}



"use strict";
const $d08ac34fc069306a$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $7fb639b615393000$export$83d89fbfd8236492));
const $d08ac34fc069306a$var$paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
const $d08ac34fc069306a$var$paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
class $d08ac34fc069306a$export$fe041e1a83d3efc6 {
    constructor(coerceFunc){
        $d08ac34fc069306a$var$logger.checkNew(new.target, $d08ac34fc069306a$export$fe041e1a83d3efc6);
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "coerceFunc", coerceFunc || null);
    }
    _getCoder(param) {
        switch(param.baseType){
            case "address":
                return new (0, $fcff3105dcb258e8$export$59dbbded7775bfe7)(param.name);
            case "bool":
                return new (0, $aaa78a99cc93e97a$export$fe9118d6c093150c)(param.name);
            case "string":
                return new (0, $badf53e68799dc4a$export$2d1b854518731426)(param.name);
            case "bytes":
                return new (0, $eafeedffad8ee5a8$export$e5823e9574df18d2)(param.name);
            case "array":
                return new (0, $162dde4a816a3426$export$88bc419d2df11f54)(this._getCoder(param.arrayChildren), param.arrayLength, param.name);
            case "tuple":
                return new (0, $0c5de501637e07ae$export$e9fceba8f110fea6)((param.components || []).map((component)=>{
                    return this._getCoder(component);
                }), param.name);
            case "":
                return new (0, $330bc6d7023508b8$export$70982cadf2d6b4ec)(param.name);
        }
        // u?int[0-9]*
        let match = param.type.match($d08ac34fc069306a$var$paramTypeNumber);
        if (match) {
            let size = parseInt(match[2] || "256");
            if (size === 0 || size > 256 || size % 8 !== 0) $d08ac34fc069306a$var$logger.throwArgumentError("invalid " + match[1] + " bit length", "param", param);
            return new (0, $0c453c4146e3302e$export$b934dc8cfe13938c)(size / 8, match[1] === "int", param.name);
        }
        // bytes[0-9]+
        match = param.type.match($d08ac34fc069306a$var$paramTypeBytes);
        if (match) {
            let size = parseInt(match[1]);
            if (size === 0 || size > 32) $d08ac34fc069306a$var$logger.throwArgumentError("invalid bytes length", "param", param);
            return new (0, $fa157b02870c9b74$export$7dec9db68e6bcf5a)(size, param.name);
        }
        return $d08ac34fc069306a$var$logger.throwArgumentError("invalid type", "type", param.type);
    }
    _getWordSize() {
        return 32;
    }
    _getReader(data, allowLoose) {
        return new (0, $96d5e5149aeee47f$export$2f7a2f0e90c07dc4)(data, this._getWordSize(), this.coerceFunc, allowLoose);
    }
    _getWriter() {
        return new (0, $96d5e5149aeee47f$export$d7a960146e1a269e)(this._getWordSize());
    }
    encode(types, values) {
        if (types.length !== values.length) $d08ac34fc069306a$var$logger.throwError("types/values length mismatch", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
            count: {
                types: types.length,
                values: values.length
            },
            value: {
                types: types,
                values: values
            }
        });
        const coders = types.map((type)=>this._getCoder((0, $84a16b430e377916$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $0c5de501637e07ae$export$e9fceba8f110fea6)(coders, "_");
        const writer = this._getWriter();
        coder.encode(writer, values);
        return writer.data;
    }
    decode(types, data, loose) {
        const coders = types.map((type)=>this._getCoder((0, $84a16b430e377916$export$426dc07f493a4c47).from(type)));
        const coder = new (0, $0c5de501637e07ae$export$e9fceba8f110fea6)(coders, "_");
        return coder.decode(this._getReader((0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data), loose));
    }
}
const $d08ac34fc069306a$export$51d1cfcdb913adff = new $d08ac34fc069306a$export$fe041e1a83d3efc6();







function $a122f8bd27430410$export$d560c7e4a29451c2(text) {
    return (0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)((0, $f48aa322f4fc7218$export$8feeb310b4b4752f)(text));
}









"use strict";
const $08b6007b55b7733b$var$logger = new (0, $7c6d6713f9f653fe$export$efa9a398d6368992)((0, $7fb639b615393000$export$83d89fbfd8236492));
class $08b6007b55b7733b$export$c2ab6499be98b3c5 extends (0, $7f4e84acce6920b4$export$393edc798c47379d) {
}
class $08b6007b55b7733b$export$7a3223b0fadb690b extends (0, $7f4e84acce6920b4$export$393edc798c47379d) {
}
class $08b6007b55b7733b$export$8ef99100a3c56f8c extends (0, $7f4e84acce6920b4$export$393edc798c47379d) {
    static isIndexed(value) {
        return !!(value && value._isIndexed);
    }
}
function $08b6007b55b7733b$var$wrapAccessError(property, error) {
    const wrap = new Error(`deferred error during ABI decoding triggered accessing ${property}`);
    wrap.error = error;
    return wrap;
}
class $08b6007b55b7733b$export$48cefb51a4e315b2 {
    constructor(fragments){
        $08b6007b55b7733b$var$logger.checkNew(new.target, $08b6007b55b7733b$export$48cefb51a4e315b2);
        let abi = [];
        if (typeof fragments === "string") abi = JSON.parse(fragments);
        else abi = fragments;
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "fragments", abi.map((fragment)=>{
            return (0, $84a16b430e377916$export$ffb0004e005737fa).from(fragment);
        }).filter((fragment)=>fragment != null));
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "_abiCoder", (0, $7f4e84acce6920b4$export$f695fbbf3cdaaf47)(new.target, "getAbiCoder")());
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "functions", {});
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "errors", {});
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "events", {});
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "structs", {});
        // Add all fragments by their signature
        this.fragments.forEach((fragment)=>{
            let bucket = null;
            switch(fragment.type){
                case "constructor":
                    if (this.deploy) {
                        $08b6007b55b7733b$var$logger.warn("duplicate definition - constructor");
                        return;
                    }
                    //checkNames(fragment, "input", fragment.inputs);
                    (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "deploy", fragment);
                    return;
                case "function":
                    //checkNames(fragment, "input", fragment.inputs);
                    //checkNames(fragment, "output", (<FunctionFragment>fragment).outputs);
                    bucket = this.functions;
                    break;
                case "event":
                    //checkNames(fragment, "input", fragment.inputs);
                    bucket = this.events;
                    break;
                default:
                    return;
            }
            let signature = fragment.format();
            if (bucket[signature]) {
                $08b6007b55b7733b$var$logger.warn("duplicate definition - " + signature);
                return;
            }
            bucket[signature] = fragment;
        });
        // If we do not have a constructor add a default
        if (!this.deploy) (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "deploy", (0, $84a16b430e377916$export$3ac5c9504f801ea4).from({
            payable: false,
            type: "constructor"
        }));
        (0, $7f4e84acce6920b4$export$104236534534f9be)(this, "_isInterface", true);
    }
    format(format) {
        if (!format) format = (0, $84a16b430e377916$export$f010f239efc4d445).full;
        if (format === (0, $84a16b430e377916$export$f010f239efc4d445).sighash) $08b6007b55b7733b$var$logger.throwArgumentError("interface does not support formatting sighash", "format", format);
        const abi = this.fragments.map((fragment)=>fragment.format(format));
        // We need to re-bundle the JSON fragments a bit
        if (format === (0, $84a16b430e377916$export$f010f239efc4d445).json) return JSON.stringify(abi.map((j)=>JSON.parse(j)));
        return abi;
    }
    // Sub-classes can override these to handle other blockchains
    static getAbiCoder() {
        return 0, $d08ac34fc069306a$export$51d1cfcdb913adff;
    }
    static getAddress(address) {
        return (0, $4159d98cef43574c$export$88411125f012957a)(address);
    }
    static getSighash(functionFragment) {
        return (0, $1b014f92cae5f25f$export$15da666eba198c18)((0, $a122f8bd27430410$export$d560c7e4a29451c2)(functionFragment.format()), 0, 4);
    }
    static getEventTopic(eventFragment) {
        return (0, $a122f8bd27430410$export$d560c7e4a29451c2)(eventFragment.format());
    }
    // Find a function definition by any means necessary (unless it is ambiguous)
    getFunction(nameOrSignatureOrSighash) {
        if ((0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(nameOrSignatureOrSighash)) {
            for(const name in this.functions){
                if (nameOrSignatureOrSighash === this.getSighash(name)) return this.functions[name];
            }
            $08b6007b55b7733b$var$logger.throwArgumentError("no matching function", "sighash", nameOrSignatureOrSighash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrSighash.indexOf("(") === -1) {
            const name = nameOrSignatureOrSighash.trim();
            const matching = Object.keys(this.functions).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $08b6007b55b7733b$var$logger.throwArgumentError("no matching function", "name", name);
            else if (matching.length > 1) $08b6007b55b7733b$var$logger.throwArgumentError("multiple matching functions", "name", name);
            return this.functions[matching[0]];
        }
        // Normlize the signature and lookup the function
        const result = this.functions[(0, $84a16b430e377916$export$8d576c928b93668f).fromString(nameOrSignatureOrSighash).format()];
        if (!result) $08b6007b55b7733b$var$logger.throwArgumentError("no matching function", "signature", nameOrSignatureOrSighash);
        return result;
    }
    // Find an event definition by any means necessary (unless it is ambiguous)
    getEvent(nameOrSignatureOrTopic) {
        if ((0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(nameOrSignatureOrTopic)) {
            const topichash = nameOrSignatureOrTopic.toLowerCase();
            for(const name in this.events){
                if (topichash === this.getEventTopic(name)) return this.events[name];
            }
            $08b6007b55b7733b$var$logger.throwArgumentError("no matching event", "topichash", topichash);
        }
        // It is a bare name, look up the function (will return null if ambiguous)
        if (nameOrSignatureOrTopic.indexOf("(") === -1) {
            const name = nameOrSignatureOrTopic.trim();
            const matching = Object.keys(this.events).filter((f)=>f.split("(" /* fix:) */ )[0] === name);
            if (matching.length === 0) $08b6007b55b7733b$var$logger.throwArgumentError("no matching event", "name", name);
            else if (matching.length > 1) $08b6007b55b7733b$var$logger.throwArgumentError("multiple matching events", "name", name);
            return this.events[matching[0]];
        }
        // Normlize the signature and lookup the function
        const result = this.events[(0, $84a16b430e377916$export$958548f08bac2833).fromString(nameOrSignatureOrTopic).format()];
        if (!result) $08b6007b55b7733b$var$logger.throwArgumentError("no matching event", "signature", nameOrSignatureOrTopic);
        return result;
    }
    // Get the sighash (the bytes4 selector) used by Solidity to identify a function
    getSighash(functionFragment) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $7f4e84acce6920b4$export$f695fbbf3cdaaf47)(this.constructor, "getSighash")(functionFragment);
    }
    // Get the topic (the bytes32 hash) used by Solidity to identify an event
    getEventTopic(eventFragment) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        return (0, $7f4e84acce6920b4$export$f695fbbf3cdaaf47)(this.constructor, "getEventTopic")(eventFragment);
    }
    _decodeParams(params, data) {
        return this._abiCoder.decode(params, data);
    }
    _encodeParams(params, values) {
        return this._abiCoder.encode(params, values);
    }
    encodeDeploy(values) {
        return this._encodeParams(this.deploy.inputs, values || []);
    }
    // Decode the data for a function call (e.g. tx.data)
    decodeFunctionData(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        const bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data);
        if ((0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) !== this.getSighash(functionFragment)) $08b6007b55b7733b$var$logger.throwArgumentError(`data signature does not match function ${functionFragment.name}.`, "data", (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(bytes));
        return this._decodeParams(functionFragment.inputs, bytes.slice(4));
    }
    // Encode the data for a function call (e.g. tx.data)
    encodeFunctionData(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)((0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)([
            this.getSighash(functionFragment),
            this._encodeParams(functionFragment.inputs, values || [])
        ]));
    }
    // Decode the result from a function call (e.g. from eth_call)
    decodeFunctionResult(functionFragment, data) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        let bytes = (0, $1b014f92cae5f25f$export$3131421a7d01b4fb)(data);
        let reason = null;
        let errorSignature = null;
        switch(bytes.length % this._abiCoder._getWordSize()){
            case 0:
                try {
                    return this._abiCoder.decode(functionFragment.outputs, bytes);
                } catch (error) {}
                break;
            case 4:
                if ((0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(bytes.slice(0, 4)) === "0x08c379a0") {
                    errorSignature = "Error(string)";
                    reason = this._abiCoder.decode([
                        "string"
                    ], bytes.slice(4))[0];
                }
                break;
        }
        return $08b6007b55b7733b$var$logger.throwError("call revert exception", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.CALL_EXCEPTION, {
            method: functionFragment.format(),
            errorSignature: errorSignature,
            errorArgs: [
                reason
            ],
            reason: reason
        });
    }
    // Encode the result for a function call (e.g. for eth_call)
    encodeFunctionResult(functionFragment, values) {
        if (typeof functionFragment === "string") functionFragment = this.getFunction(functionFragment);
        return (0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(this._abiCoder.encode(functionFragment.outputs, values || []));
    }
    // Create the filter for the event with search criteria (e.g. for eth_filterLog)
    encodeFilterTopics(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (values.length > eventFragment.inputs.length) $08b6007b55b7733b$var$logger.throwError("too many arguments for " + eventFragment.format(), (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.UNEXPECTED_ARGUMENT, {
            argument: "values",
            value: values
        });
        let topics = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        const encodeTopic = (param, value)=>{
            if (param.type === "string") return (0, $a122f8bd27430410$export$d560c7e4a29451c2)(value);
            else if (param.type === "bytes") return (0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)((0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(value));
            // Check addresses are valid
            if (param.type === "address") this._abiCoder.encode([
                "address"
            ], [
                value
            ]);
            return (0, $1b014f92cae5f25f$export$e9c46a54370b47e8)((0, $1b014f92cae5f25f$export$2b0d6b5fbe698c70)(value), 32);
        };
        values.forEach((value, index)=>{
            let param = eventFragment.inputs[index];
            if (!param.indexed) {
                if (value != null) $08b6007b55b7733b$var$logger.throwArgumentError("cannot filter non-indexed parameters; must be null", "contract." + param.name, value);
                return;
            }
            if (value == null) topics.push(null);
            else if (param.baseType === "array" || param.baseType === "tuple") $08b6007b55b7733b$var$logger.throwArgumentError("filtering with tuples or arrays not supported", "contract." + param.name, value);
            else if (Array.isArray(value)) topics.push(value.map((value)=>encodeTopic(param, value)));
            else topics.push(encodeTopic(param, value));
        });
        // Trim off trailing nulls
        while(topics.length && topics[topics.length - 1] === null)topics.pop();
        return topics;
    }
    encodeEventLog(eventFragment, values) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        const topics = [];
        const dataTypes = [];
        const dataValues = [];
        if (!eventFragment.anonymous) topics.push(this.getEventTopic(eventFragment));
        if (values.length !== eventFragment.inputs.length) $08b6007b55b7733b$var$logger.throwArgumentError("event arguments/values mismatch", "values", values);
        eventFragment.inputs.forEach((param, index)=>{
            const value = values[index];
            if (param.indexed) {
                if (param.type === "string") topics.push((0, $a122f8bd27430410$export$d560c7e4a29451c2)(value));
                else if (param.type === "bytes") topics.push((0, $d3d3a9436b2bb4b4$export$f8151fce47ad1c35)(value));
                else if (param.baseType === "tuple" || param.baseType === "array") // @TOOD
                throw new Error("not implemented");
                else topics.push(this._abiCoder.encode([
                    param.type
                ], [
                    value
                ]));
            } else {
                dataTypes.push(param);
                dataValues.push(value);
            }
        });
        return {
            data: this._abiCoder.encode(dataTypes, dataValues),
            topics: topics
        };
    }
    // Decode a filter for the event and the search criteria
    decodeEventLog(eventFragment, data, topics) {
        if (typeof eventFragment === "string") eventFragment = this.getEvent(eventFragment);
        if (topics != null && !eventFragment.anonymous) {
            let topicHash = this.getEventTopic(eventFragment);
            if (!(0, $1b014f92cae5f25f$export$b02a40aff8e4ad18)(topics[0], 32) || topics[0].toLowerCase() !== topicHash) $08b6007b55b7733b$var$logger.throwError("fragment/topic mismatch", (0, $7c6d6713f9f653fe$export$efa9a398d6368992).errors.INVALID_ARGUMENT, {
                argument: "topics[0]",
                expected: topicHash,
                value: topics[0]
            });
            topics = topics.slice(1);
        }
        let indexed = [];
        let nonIndexed = [];
        let dynamic = [];
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (param.type === "string" || param.type === "bytes" || param.baseType === "tuple" || param.baseType === "array") {
                    indexed.push((0, $84a16b430e377916$export$426dc07f493a4c47).fromObject({
                        type: "bytes32",
                        name: param.name
                    }));
                    dynamic.push(true);
                } else {
                    indexed.push(param);
                    dynamic.push(false);
                }
            } else {
                nonIndexed.push(param);
                dynamic.push(false);
            }
        });
        let resultIndexed = topics != null ? this._abiCoder.decode(indexed, (0, $1b014f92cae5f25f$export$ee1b3e54f0441b22)(topics)) : null;
        let resultNonIndexed = this._abiCoder.decode(nonIndexed, data, true);
        let result = [];
        let nonIndexedIndex = 0, indexedIndex = 0;
        eventFragment.inputs.forEach((param, index)=>{
            if (param.indexed) {
                if (resultIndexed == null) result[index] = new $08b6007b55b7733b$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: null
                });
                else if (dynamic[index]) result[index] = new $08b6007b55b7733b$export$8ef99100a3c56f8c({
                    _isIndexed: true,
                    hash: resultIndexed[indexedIndex++]
                });
                else try {
                    result[index] = resultIndexed[indexedIndex++];
                } catch (error) {
                    result[index] = error;
                }
            } else try {
                result[index] = resultNonIndexed[nonIndexedIndex++];
            } catch (error) {
                result[index] = error;
            }
            // Add the keyword argument if named and safe
            if (param.name && result[param.name] == null) {
                const value = result[index];
                // Make error named values throw on access
                if (value instanceof Error) Object.defineProperty(result, param.name, {
                    get: ()=>{
                        throw $08b6007b55b7733b$var$wrapAccessError(`property ${JSON.stringify(param.name)}`, value);
                    }
                });
                else result[param.name] = value;
            }
        });
        // Make all error indexed values throw on access
        for(let i = 0; i < result.length; i++){
            const value = result[i];
            if (value instanceof Error) Object.defineProperty(result, i, {
                get: ()=>{
                    throw $08b6007b55b7733b$var$wrapAccessError(`index ${i}`, value);
                }
            });
        }
        return Object.freeze(result);
    }
    // Given a transaction, find the matching function fragment (if any) and
    // determine all its properties and call parameters
    parseTransaction(tx) {
        let fragment = this.getFunction(tx.data.substring(0, 10).toLowerCase());
        if (!fragment) return null;
        return new $08b6007b55b7733b$export$7a3223b0fadb690b({
            args: this._abiCoder.decode(fragment.inputs, "0x" + tx.data.substring(10)),
            functionFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            sighash: this.getSighash(fragment),
            value: (0, $dca7be31a9d42f28$export$d97aa349ed20696).from(tx.value || "0")
        });
    }
    // Given an event log, find the matching event fragment (if any) and
    // determine all its properties and values
    parseLog(log) {
        let fragment = this.getEvent(log.topics[0]);
        if (!fragment || fragment.anonymous) return null;
        // @TODO: If anonymous, and the only method, and the input count matches, should we parse?
        //        Probably not, because just because it is the only event in the ABI does
        //        not mean we have the full ABI; maybe jsut a fragment?
        return new $08b6007b55b7733b$export$c2ab6499be98b3c5({
            eventFragment: fragment,
            name: fragment.name,
            signature: fragment.format(),
            topic: this.getEventTopic(fragment),
            args: this.decodeEventLog(fragment, log.data, log.topics)
        });
    }
    /*
    static from(value: Array<Fragment | string | JsonAbi> | string | Interface) {
        if (Interface.isInterface(value)) {
            return value;
        }
        if (typeof(value) === "string") {
            return new Interface(JSON.parse(value));
        }
        return new Interface(value);
    }
    */ static isInterface(value) {
        return !!(value && value._isInterface);
    }
}


"use strict";


var $618c9d1507e674b0$require$EthersAbiCoder = $d08ac34fc069306a$export$fe041e1a83d3efc6;

var $618c9d1507e674b0$require$ParamType = $84a16b430e377916$export$426dc07f493a4c47;
var $618c9d1507e674b0$var$ethersAbiCoder = new $618c9d1507e674b0$require$EthersAbiCoder(function(type, value) {
    if (type.match(/^u?int/) && !Array.isArray(value) && (!(!!value && typeof value === "object") || value.constructor.name !== "BN")) return value.toString();
    return value;
});
// result method
function $618c9d1507e674b0$var$Result() {}
/**
 * ABICoder prototype should be used to encode/decode solidity params of any type
 */ var $618c9d1507e674b0$var$ABICoder = function() {};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeFunctionSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ $618c9d1507e674b0$var$ABICoder.prototype.encodeFunctionSignature = function(functionName) {
    if (typeof functionName === "function" || typeof functionName === "object" && functionName) functionName = $hpg7W._jsonInterfaceMethodToString(functionName);
    return $hpg7W.sha3(functionName).slice(0, 10);
};
/**
 * Encodes the function name to its ABI representation, which are the first 4 bytes of the sha3 of the function name including  types.
 *
 * @method encodeEventSignature
 * @param {String|Object} functionName
 * @return {String} encoded function name
 */ $618c9d1507e674b0$var$ABICoder.prototype.encodeEventSignature = function(functionName) {
    if (typeof functionName === "function" || typeof functionName === "object" && functionName) functionName = $hpg7W._jsonInterfaceMethodToString(functionName);
    return $hpg7W.sha3(functionName);
};
/**
 * Should be used to encode plain param
 *
 * @method encodeParameter
 *
 * @param {String|Object} type
 * @param {any} param
 *
 * @return {String} encoded plain param
 */ $618c9d1507e674b0$var$ABICoder.prototype.encodeParameter = function(type, param) {
    return this.encodeParameters([
        type
    ], [
        param
    ]);
};
/**
 * Should be used to encode list of params
 *
 * @method encodeParameters
 *
 * @param {Array<String|Object>} types
 * @param {Array<any>} params
 *
 * @return {String} encoded list of params
 */ $618c9d1507e674b0$var$ABICoder.prototype.encodeParameters = function(types, params) {
    var self = this;
    types = self.mapTypes(types);
    params = params.map(function(param, index) {
        let type = types[index];
        if (typeof type === "object" && type.type) // We may get a named type of shape {name, type}
        type = type.type;
        param = self.formatParam(type, param);
        // Format params for tuples
        if (typeof type === "string" && type.includes("tuple")) {
            const coder = $618c9d1507e674b0$var$ethersAbiCoder._getCoder($618c9d1507e674b0$require$ParamType.from(type));
            const modifyParams = (coder, param)=>{
                if (coder.name === "array") return param.map((p)=>modifyParams($618c9d1507e674b0$var$ethersAbiCoder._getCoder($618c9d1507e674b0$require$ParamType.from(coder.type.replace("[]", ""))), p));
                coder.coders.forEach((c, i)=>{
                    if (c.name === "tuple") modifyParams(c, param[i]);
                    else param[i] = self.formatParam(c.name, param[i]);
                });
            };
            modifyParams(coder, param);
        }
        return param;
    });
    return $618c9d1507e674b0$var$ethersAbiCoder.encode(types, params);
};
/**
 * Map types if simplified format is used
 *
 * @method mapTypes
 * @param {Array} types
 * @return {Array}
 */ $618c9d1507e674b0$var$ABICoder.prototype.mapTypes = function(types) {
    var self = this;
    var mappedTypes = [];
    types.forEach(function(type) {
        // Remap `function` type params to bytes24 since Ethers does not
        // recognize former type. Solidity docs say `Function` is a bytes24
        // encoding the contract address followed by the function selector hash.
        if (typeof type === "object" && type.type === "function") type = Object.assign({}, type, {
            type: "bytes24"
        });
        if (self.isSimplifiedStructFormat(type)) {
            var structName = Object.keys(type)[0];
            mappedTypes.push(Object.assign(self.mapStructNameAndType(structName), {
                components: self.mapStructToCoderFormat(type[structName])
            }));
            return;
        }
        mappedTypes.push(type);
    });
    return mappedTypes;
};
/**
 * Check if type is simplified struct format
 *
 * @method isSimplifiedStructFormat
 * @param {string | Object} type
 * @returns {boolean}
 */ $618c9d1507e674b0$var$ABICoder.prototype.isSimplifiedStructFormat = function(type) {
    return typeof type === "object" && typeof type.components === "undefined" && typeof type.name === "undefined";
};
/**
 * Maps the correct tuple type and name when the simplified format in encode/decodeParameter is used
 *
 * @method mapStructNameAndType
 * @param {string} structName
 * @return {{type: string, name: *}}
 */ $618c9d1507e674b0$var$ABICoder.prototype.mapStructNameAndType = function(structName) {
    var type = "tuple";
    if (structName.indexOf("[]") > -1) {
        type = "tuple[]";
        structName = structName.slice(0, -2);
    }
    return {
        type: type,
        name: structName
    };
};
/**
 * Maps the simplified format in to the expected format of the ABICoder
 *
 * @method mapStructToCoderFormat
 * @param {Object} struct
 * @return {Array}
 */ $618c9d1507e674b0$var$ABICoder.prototype.mapStructToCoderFormat = function(struct) {
    var self = this;
    var components = [];
    Object.keys(struct).forEach(function(key) {
        if (typeof struct[key] === "object") {
            components.push(Object.assign(self.mapStructNameAndType(key), {
                components: self.mapStructToCoderFormat(struct[key])
            }));
            return;
        }
        components.push({
            name: key,
            type: struct[key]
        });
    });
    return components;
};
/**
 * Handle some formatting of params for backwards compatability with Ethers V4
 *
 * @method formatParam
 * @param {String} - type
 * @param {any} - param
 * @return {any} - The formatted param
 */ $618c9d1507e674b0$var$ABICoder.prototype.formatParam = function(type, param) {
    const paramTypeBytes = new RegExp(/^bytes([0-9]*)$/);
    const paramTypeBytesArray = new RegExp(/^bytes([0-9]*)\[\]$/);
    const paramTypeNumber = new RegExp(/^(u?int)([0-9]*)$/);
    const paramTypeNumberArray = new RegExp(/^(u?int)([0-9]*)\[\]$/);
    // Format BN to string
    if ($hpg7W.isBN(param) || $hpg7W.isBigNumber(param)) return param.toString(10);
    if (type.match(paramTypeBytesArray) || type.match(paramTypeNumberArray)) return param.map((p)=>this.formatParam(type.replace("[]", ""), p));
    // Format correct width for u?int[0-9]*
    let match = type.match(paramTypeNumber);
    if (match) {
        let size = parseInt(match[2] || "256");
        if (size / 8 < param.length) // pad to correct bit width
        param = $hpg7W.leftPad(param, size);
    }
    // Format correct length for bytes[0-9]+
    match = type.match(paramTypeBytes);
    if (match) {
        if ($618c9d1507e674b0$require$Buffer.isBuffer(param)) param = $hpg7W.toHex(param);
        // format to correct length
        let size = parseInt(match[1]);
        if (size) {
            let maxSize = size * 2;
            if (param.substring(0, 2) === "0x") maxSize += 2;
            if (param.length < maxSize) // pad to correct length
            param = $hpg7W.rightPad(param, size * 2);
        }
        // format odd-length bytes to even-length
        if (param.length % 2 === 1) param = "0x0" + param.substring(2);
    }
    return param;
};
/**
 * Encodes a function call from its json interface and parameters.
 *
 * @method encodeFunctionCall
 * @param {Array} jsonInterface
 * @param {Array} params
 * @return {String} The encoded ABI for this function call
 */ $618c9d1507e674b0$var$ABICoder.prototype.encodeFunctionCall = function(jsonInterface, params) {
    return this.encodeFunctionSignature(jsonInterface) + this.encodeParameters(jsonInterface.inputs, params).replace("0x", "");
};
/**
 * Should be used to decode bytes to plain param
 *
 * @method decodeParameter
 * @param {String} type
 * @param {String} bytes
 * @return {Object} plain param
 */ $618c9d1507e674b0$var$ABICoder.prototype.decodeParameter = function(type, bytes) {
    return this.decodeParameters([
        type
    ], bytes)[0];
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @return {Array} array of plain params
 */ $618c9d1507e674b0$var$ABICoder.prototype.decodeParameters = function(outputs, bytes) {
    return this.decodeParametersWith(outputs, bytes, false);
};
/**
 * Should be used to decode list of params
 *
 * @method decodeParameter
 * @param {Array} outputs
 * @param {String} bytes
 * @param {Boolean} loose
 * @return {Array} array of plain params
 */ $618c9d1507e674b0$var$ABICoder.prototype.decodeParametersWith = function(outputs, bytes, loose) {
    if (outputs.length > 0 && (!bytes || bytes === "0x" || bytes === "0X")) throw new Error("Returned values aren't valid, did it run Out of Gas? You might also see this error if you are not using the correct ABI for the contract you are retrieving data from, requesting data from a block number that does not exist, or querying a node which is not fully synced.");
    var res = $618c9d1507e674b0$var$ethersAbiCoder.decode(this.mapTypes(outputs), "0x" + bytes.replace(/0x/i, ""), loose);
    var returnValue = new $618c9d1507e674b0$var$Result();
    returnValue.__length__ = 0;
    outputs.forEach(function(output, i) {
        var decodedValue = res[returnValue.__length__];
        decodedValue = decodedValue === "0x" ? null : decodedValue;
        returnValue[i] = decodedValue;
        if ((typeof output === "function" || !!output && typeof output === "object") && output.name) returnValue[output.name] = decodedValue;
        returnValue.__length__++;
    });
    return returnValue;
};
/**
 * Decodes events non- and indexed parameters.
 *
 * @method decodeLog
 * @param {Object} inputs
 * @param {String} data
 * @param {Array} topics
 * @return {Array} array of plain params
 */ $618c9d1507e674b0$var$ABICoder.prototype.decodeLog = function(inputs, data, topics) {
    var _this = this;
    topics = Array.isArray(topics) ? topics : [
        topics
    ];
    data = data || "";
    var notIndexedInputs = [];
    var indexedParams = [];
    var topicCount = 0;
    // TODO check for anonymous logs?
    inputs.forEach(function(input, i) {
        if (input.indexed) {
            indexedParams[i] = [
                "bool",
                "int",
                "uint",
                "address",
                "fixed",
                "ufixed"
            ].find(function(staticType) {
                return input.type.indexOf(staticType) !== -1;
            }) ? _this.decodeParameter(input.type, topics[topicCount]) : topics[topicCount];
            topicCount++;
        } else notIndexedInputs[i] = input;
    });
    var nonIndexedData = data;
    var notIndexedParams = nonIndexedData ? this.decodeParametersWith(notIndexedInputs, nonIndexedData, true) : [];
    var returnValue = new $618c9d1507e674b0$var$Result();
    returnValue.__length__ = 0;
    inputs.forEach(function(res, i) {
        returnValue[i] = res.type === "string" ? "" : null;
        if (typeof notIndexedParams[i] !== "undefined") returnValue[i] = notIndexedParams[i];
        if (typeof indexedParams[i] !== "undefined") returnValue[i] = indexedParams[i];
        if (res.name) returnValue[res.name] = returnValue[i];
        returnValue.__length__++;
    });
    return returnValue;
};
var $618c9d1507e674b0$var$coder = new $618c9d1507e674b0$var$ABICoder();
$618c9d1507e674b0$exports = $618c9d1507e674b0$var$coder;


/**
 * Should be called to create new contract instance
 *
 * @method Contract
 * @constructor
 * @param {Array} jsonInterface
 * @param {String} address
 * @param {Object} options
 */ var $64f2080ad381d344$var$Contract = function Contract(jsonInterface, address, options) {
    var _this = this, args = Array.prototype.slice.call(arguments);
    if (!(this instanceof Contract)) throw new Error('Please use the "new" keyword to instantiate a web3.eth.Contract() object!');
    this.setProvider = function() {
        $c0d140841aa0e2a6$exports.packageInit(_this, arguments);
        _this.clearSubscriptions = _this._requestManager.clearSubscriptions;
    };
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, [
        this.constructor
    ]);
    this.clearSubscriptions = this._requestManager.clearSubscriptions;
    if (!jsonInterface || !Array.isArray(jsonInterface)) throw $64f2080ad381d344$require$errors.ContractMissingABIError();
    // create the options object
    this.options = {};
    var lastArg = args[args.length - 1];
    if (!!lastArg && typeof lastArg === "object" && !Array.isArray(lastArg)) {
        options = lastArg;
        this.options = {
            ...this.options,
            ...this._getOrSetDefaultOptions(options)
        };
        if (!!address && typeof address === "object") address = null;
    }
    // set address
    Object.defineProperty(this.options, "address", {
        set: function(value) {
            if (value) _this._address = $hpg7W.toChecksumAddress($64f2080ad381d344$require$formatters.inputAddressFormatter(value));
        },
        get: function() {
            return _this._address;
        },
        enumerable: true
    });
    // add method and event signatures, when the jsonInterface gets set
    Object.defineProperty(this.options, "jsonInterface", {
        set: function(value) {
            _this.methods = {};
            _this.events = {};
            _this._jsonInterface = value.map(function(method) {
                var func, funcName;
                // make constant and payable backwards compatible
                method.constant = method.stateMutability === "view" || method.stateMutability === "pure" || method.constant;
                method.payable = method.stateMutability === "payable" || method.payable;
                if (method.name) funcName = $hpg7W._jsonInterfaceMethodToString(method);
                // function
                if (method.type === "function") {
                    method.signature = $618c9d1507e674b0$exports.encodeFunctionSignature(funcName);
                    func = _this._createTxObject.bind({
                        method: method,
                        parent: _this
                    });
                    // add method only if not one already exists
                    if (!_this.methods[method.name]) _this.methods[method.name] = func;
                    else {
                        var cascadeFunc = _this._createTxObject.bind({
                            method: method,
                            parent: _this,
                            nextMethod: _this.methods[method.name]
                        });
                        _this.methods[method.name] = cascadeFunc;
                    }
                    // definitely add the method based on its signature
                    _this.methods[method.signature] = func;
                    // add method by name
                    _this.methods[funcName] = func;
                // event
                } else if (method.type === "event") {
                    method.signature = $618c9d1507e674b0$exports.encodeEventSignature(funcName);
                    var event = _this._on.bind(_this, method.signature);
                    // add method only if not already exists
                    if (!_this.events[method.name] || _this.events[method.name].name === "bound ") _this.events[method.name] = event;
                    // definitely add the method based on its signature
                    _this.events[method.signature] = event;
                    // add event by name
                    _this.events[funcName] = event;
                }
                return method;
            });
            // add allEvents
            _this.events.allEvents = _this._on.bind(_this, "allevents");
            return _this._jsonInterface;
        },
        get: function() {
            return _this._jsonInterface;
        },
        enumerable: true
    });
    // get default account from the Class
    var defaultAccount = this.constructor.defaultAccount;
    var defaultBlock = this.constructor.defaultBlock || "latest";
    Object.defineProperty(this, "handleRevert", {
        get: function() {
            if (_this.options.handleRevert === false || _this.options.handleRevert === true) return _this.options.handleRevert;
            return this.constructor.handleRevert;
        },
        set: function(val) {
            _this.options.handleRevert = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultCommon", {
        get: function() {
            return _this.options.common || this.constructor.defaultCommon;
        },
        set: function(val) {
            _this.options.common = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultHardfork", {
        get: function() {
            return _this.options.hardfork || this.constructor.defaultHardfork;
        },
        set: function(val) {
            _this.options.hardfork = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultChain", {
        get: function() {
            return _this.options.chain || this.constructor.defaultChain;
        },
        set: function(val) {
            _this.options.chain = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionPollingTimeout", {
        get: function() {
            if (_this.options.transactionPollingTimeout === 0) return _this.options.transactionPollingTimeout;
            return _this.options.transactionPollingTimeout || this.constructor.transactionPollingTimeout;
        },
        set: function(val) {
            _this.options.transactionPollingTimeout = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionConfirmationBlocks", {
        get: function() {
            if (_this.options.transactionConfirmationBlocks === 0) return _this.options.transactionConfirmationBlocks;
            return _this.options.transactionConfirmationBlocks || this.constructor.transactionConfirmationBlocks;
        },
        set: function(val) {
            _this.options.transactionConfirmationBlocks = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionBlockTimeout", {
        get: function() {
            if (_this.options.transactionBlockTimeout === 0) return _this.options.transactionBlockTimeout;
            return _this.options.transactionBlockTimeout || this.constructor.transactionBlockTimeout;
        },
        set: function(val) {
            _this.options.transactionBlockTimeout = val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultAccount", {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $hpg7W.toChecksumAddress($64f2080ad381d344$require$formatters.inputAddressFormatter(val));
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultBlock", {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            return val;
        },
        enumerable: true
    });
    // properties
    this.methods = {};
    this.events = {};
    this._address = null;
    this._jsonInterface = [];
    // set getter/setter properties
    this.options.address = address;
    this.options.jsonInterface = jsonInterface;
};
/**
 * Sets the new provider, creates a new requestManager, registers the "data" listener on the provider and sets the
 * accounts module for the Contract class.
 *
 * @method setProvider
 *
 * @param {string|provider} provider
 * @param {Accounts} accounts
 *
 * @returns void
 */ $64f2080ad381d344$var$Contract.setProvider = function(provider, accounts) {
    // Contract.currentProvider = provider;
    $c0d140841aa0e2a6$exports.packageInit(this, [
        provider
    ]);
    this._ethAccounts = accounts;
};
/**
 * Get the callback and modify the array if necessary
 *
 * @method _getCallback
 * @param {Array} args
 * @return {Function} the callback
 */ $64f2080ad381d344$var$Contract.prototype._getCallback = function getCallback(args) {
    if (args && !!args[args.length - 1] && typeof args[args.length - 1] === "function") return args.pop(); // modify the args array!
};
/**
 * Checks that no listener with name "newListener" or "removeListener" is added.
 *
 * @method _checkListener
 * @param {String} type
 * @param {String} event
 * @return {Object} the contract instance
 */ $64f2080ad381d344$var$Contract.prototype._checkListener = function(type, event) {
    if (event === type) throw $64f2080ad381d344$require$errors.ContractReservedEventError(type);
};
/**
 * Use default values, if options are not available
 *
 * @method _getOrSetDefaultOptions
 * @param {Object} options the options gived by the user
 * @return {Object} the options with gaps filled by defaults
 */ $64f2080ad381d344$var$Contract.prototype._getOrSetDefaultOptions = function getOrSetDefaultOptions(options) {
    var gasPrice = options.gasPrice ? String(options.gasPrice) : null;
    var from = options.from ? $hpg7W.toChecksumAddress($64f2080ad381d344$require$formatters.inputAddressFormatter(options.from)) : null;
    options.data = options.data || this.options.data;
    options.from = from || this.options.from;
    options.gasPrice = gasPrice || this.options.gasPrice;
    options.gas = options.gas || options.gasLimit || this.options.gas;
    // TODO replace with only gasLimit?
    delete options.gasLimit;
    return options;
};
/**
 * Should be used to encode indexed params and options to one final object
 *
 * @method _encodeEventABI
 * @param {Object} event
 * @param {Object} options
 * @return {Object} everything combined together and encoded
 */ $64f2080ad381d344$var$Contract.prototype._encodeEventABI = function(event, options) {
    options = options || {};
    var filter = options.filter || {}, result = {};
    [
        "fromBlock",
        "toBlock"
    ].filter(function(f) {
        return options[f] !== undefined;
    }).forEach(function(f) {
        result[f] = $64f2080ad381d344$require$formatters.inputBlockNumberFormatter(options[f]);
    });
    // use given topics
    if (Array.isArray(options.topics)) result.topics = options.topics;
    else {
        result.topics = [];
        // add event signature
        if (event && !event.anonymous && event.name !== "ALLEVENTS") result.topics.push(event.signature);
        // add event topics (indexed arguments)
        if (event.name !== "ALLEVENTS") {
            var indexedTopics = event.inputs.filter(function(i) {
                return i.indexed === true;
            }).map(function(i) {
                var value = filter[i.name];
                if (!value) return null;
                // TODO: https://github.com/ethereum/web3.js/issues/344
                // TODO: deal properly with components
                if (Array.isArray(value)) return value.map(function(v) {
                    return $618c9d1507e674b0$exports.encodeParameter(i.type, v);
                });
                return $618c9d1507e674b0$exports.encodeParameter(i.type, value);
            });
            result.topics = result.topics.concat(indexedTopics);
        }
        if (!result.topics.length) delete result.topics;
    }
    if (this.options.address) result.address = this.options.address.toLowerCase();
    return result;
};
/**
 * Should be used to decode indexed params and options
 *
 * @method _decodeEventABI
 * @param {Object} data
 * @return {Object} result object with decoded indexed && not indexed params
 */ $64f2080ad381d344$var$Contract.prototype._decodeEventABI = function(data) {
    var event = this;
    data.data = data.data || "";
    data.topics = data.topics || [];
    var result = $64f2080ad381d344$require$formatters.outputLogFormatter(data);
    // if allEvents get the right event
    if (event.name === "ALLEVENTS") event = event.jsonInterface.find(function(intf) {
        return intf.signature === data.topics[0];
    }) || {
        anonymous: true
    };
    // create empty inputs if none are present (e.g. anonymous events on allEvents)
    event.inputs = event.inputs || [];
    // Handle case where an event signature shadows the current ABI with non-identical
    // arg indexing. If # of topics doesn't match, event is anon.
    if (!event.anonymous) {
        let indexedInputs = 0;
        event.inputs.forEach((input)=>input.indexed ? indexedInputs++ : null);
        if (indexedInputs > 0 && data.topics.length !== indexedInputs + 1) event = {
            anonymous: true,
            inputs: []
        };
    }
    var argTopics = event.anonymous ? data.topics : data.topics.slice(1);
    result.returnValues = $618c9d1507e674b0$exports.decodeLog(event.inputs, data.data, argTopics);
    delete result.returnValues.__length__;
    // add name
    result.event = event.name;
    // add signature
    result.signature = event.anonymous || !data.topics[0] ? null : data.topics[0];
    // move the data and topics to "raw"
    result.raw = {
        data: result.data,
        topics: result.topics
    };
    delete result.data;
    delete result.topics;
    return result;
};
/**
 * Encodes an ABI for a method, including signature or the method.
 * Or when constructor encodes only the constructor parameters.
 *
 * @method _encodeMethodABI
 * @param {Mixed} args the arguments to encode
 * @param {String} the encoded ABI
 */ $64f2080ad381d344$var$Contract.prototype._encodeMethodABI = function _encodeMethodABI() {
    var methodSignature = this._method.signature, args = this.arguments || [];
    var signature = false, paramsABI = this._parent.options.jsonInterface.filter(function(json) {
        return methodSignature === "constructor" && json.type === methodSignature || (json.signature === methodSignature || json.signature === methodSignature.replace("0x", "") || json.name === methodSignature) && json.type === "function";
    }).map(function(json) {
        var inputLength = Array.isArray(json.inputs) ? json.inputs.length : 0;
        if (inputLength !== args.length) throw new Error("The number of arguments is not matching the methods required number. You need to pass " + inputLength + " arguments.");
        if (json.type === "function") signature = json.signature;
        return Array.isArray(json.inputs) ? json.inputs : [];
    }).map(function(inputs) {
        return $618c9d1507e674b0$exports.encodeParameters(inputs, args).replace("0x", "");
    })[0] || "";
    // return constructor
    if (methodSignature === "constructor") {
        if (!this._deployData) throw new Error("The contract has no contract data option set. This is necessary to append the constructor parameters.");
        if (!this._deployData.startsWith("0x")) this._deployData = "0x" + this._deployData;
        return this._deployData + paramsABI;
    }
    // return method
    var returnValue = signature ? signature + paramsABI : paramsABI;
    if (!returnValue) throw new Error("Couldn't find a matching contract method named \"" + this._method.name + '".');
    return returnValue;
};
/**
 * Decode method return values
 *
 * @method _decodeMethodReturn
 * @param {Array} outputs
 * @param {String} returnValues
 * @return {Object} decoded output return values
 */ $64f2080ad381d344$var$Contract.prototype._decodeMethodReturn = function(outputs, returnValues) {
    if (!returnValues) return null;
    returnValues = returnValues.length >= 2 ? returnValues.slice(2) : returnValues;
    var result = $618c9d1507e674b0$exports.decodeParameters(outputs, returnValues);
    if (result.__length__ === 1) return result[0];
    delete result.__length__;
    return result;
};
/**
 * Deploys a contract and fire events based on its state: transactionHash, receipt
 *
 * All event listeners will be removed, once the last possible event is fired ("error", or "receipt")
 *
 * @method deploy
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} EventEmitter possible events are "error", "transactionHash" and "receipt"
 */ $64f2080ad381d344$var$Contract.prototype.deploy = function(options, callback) {
    options = options || {};
    options.arguments = options.arguments || [];
    options = this._getOrSetDefaultOptions(options);
    // throw error, if no "data" is specified
    if (!options.data) {
        if (typeof callback === "function") return callback($64f2080ad381d344$require$errors.ContractMissingDeployDataError());
        throw $64f2080ad381d344$require$errors.ContractMissingDeployDataError();
    }
    var constructor = this.options.jsonInterface.find((method)=>{
        return method.type === "constructor";
    }) || {};
    constructor.signature = "constructor";
    return this._createTxObject.apply({
        method: constructor,
        parent: this,
        deployData: options.data,
        _ethAccounts: this.constructor._ethAccounts
    }, options.arguments);
};
/**
 * Gets the event signature and outputFormatters
 *
 * @method _generateEventOptions
 * @param {Object} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the event options object
 */ $64f2080ad381d344$var$Contract.prototype._generateEventOptions = function() {
    var args = Array.prototype.slice.call(arguments);
    // get the callback
    var callback = this._getCallback(args);
    // get the options
    var options = (!!args[args.length - 1] && typeof args[args.length - 1]) === "object" ? args.pop() : {};
    var eventName = typeof args[0] === "string" ? args[0] : "allevents";
    var event = eventName.toLowerCase() === "allevents" ? {
        name: "ALLEVENTS",
        jsonInterface: this.options.jsonInterface
    } : this.options.jsonInterface.find(function(json) {
        return json.type === "event" && (json.name === eventName || json.signature === "0x" + eventName.replace("0x", ""));
    });
    if (!event) throw $64f2080ad381d344$require$errors.ContractEventDoesNotExistError(eventName);
    if (!$hpg7W.isAddress(this.options.address)) throw $64f2080ad381d344$require$errors.ContractNoAddressDefinedError();
    return {
        params: this._encodeEventABI(event, options),
        event: event,
        callback: callback
    };
};
/**
 * Adds event listeners and creates a subscription, and remove it once its fired.
 *
 * @method clone
 * @return {Object} the event subscription
 */ $64f2080ad381d344$var$Contract.prototype.clone = function() {
    return new this.constructor(this.options.jsonInterface, this.options.address, this.options);
};
/**
 * Adds event listeners and creates a subscription, and remove it once its fired.
 *
 * @method once
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the event subscription
 */ $64f2080ad381d344$var$Contract.prototype.once = function(event, options, callback) {
    var args = Array.prototype.slice.call(arguments);
    // get the callback
    callback = this._getCallback(args);
    if (!callback) throw $64f2080ad381d344$require$errors.ContractOnceRequiresCallbackError();
    // don't allow fromBlock
    if (options) delete options.fromBlock;
    // don't return as once shouldn't provide "on"
    this._on(event, options, function(err, res, sub) {
        sub.unsubscribe();
        if (typeof callback === "function") callback(err, res, sub);
    });
    return undefined;
};
/**
 * Adds event listeners and creates a subscription.
 *
 * @method _on
 *
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 *
 * @return {Object} the event subscription
 */ $64f2080ad381d344$var$Contract.prototype._on = function() {
    var subOptions = this._generateEventOptions.apply(this, arguments);
    if (subOptions.params && subOptions.params.toBlock) {
        delete subOptions.params.toBlock;
        console.warn("Invalid option: toBlock. Use getPastEvents for specific range.");
    }
    // prevent the event "newListener" and "removeListener" from being overwritten
    this._checkListener("newListener", subOptions.event.name);
    this._checkListener("removeListener", subOptions.event.name);
    // TODO check if listener already exists? and reuse subscription if options are the same.
    // create new subscription
    var subscription = new $64f2080ad381d344$require$Subscription({
        subscription: {
            params: 1,
            inputFormatter: [
                $64f2080ad381d344$require$formatters.inputLogFormatter
            ],
            outputFormatter: this._decodeEventABI.bind(subOptions.event),
            // DUBLICATE, also in web3-eth
            subscriptionHandler: function(output) {
                if (output.removed) this.emit("changed", output);
                else this.emit("data", output);
                if (typeof this.callback === "function") this.callback(null, output, this);
            }
        },
        type: "eth",
        requestManager: this._requestManager
    });
    subscription.subscribe("logs", subOptions.params, subOptions.callback || function() {});
    return subscription;
};
/**
 * Get past events from contracts
 *
 * @method getPastEvents
 * @param {String} event
 * @param {Object} options
 * @param {Function} callback
 * @return {Object} the promievent
 */ $64f2080ad381d344$var$Contract.prototype.getPastEvents = function() {
    var subOptions = this._generateEventOptions.apply(this, arguments);
    var getPastLogs = new $60ff6d2aea0ffa29$exports({
        name: "getPastLogs",
        call: "eth_getLogs",
        params: 1,
        inputFormatter: [
            $64f2080ad381d344$require$formatters.inputLogFormatter
        ],
        outputFormatter: this._decodeEventABI.bind(subOptions.event)
    });
    getPastLogs.setRequestManager(this._requestManager);
    var call = getPastLogs.buildCall();
    getPastLogs = null;
    return call(subOptions.params, subOptions.callback);
};
/**
 * returns the an object with call, send, estimate functions
 *
 * @method _createTxObject
 * @returns {Object} an object with functions to call the methods
 */ $64f2080ad381d344$var$Contract.prototype._createTxObject = function _createTxObject() {
    var args = Array.prototype.slice.call(arguments);
    var txObject = {};
    if (this.method.type === "function") {
        txObject.call = this.parent._executeMethod.bind(txObject, "call");
        txObject.call.request = this.parent._executeMethod.bind(txObject, "call", true); // to make batch requests
    }
    txObject.send = this.parent._executeMethod.bind(txObject, "send");
    txObject.send.request = this.parent._executeMethod.bind(txObject, "send", true); // to make batch requests
    txObject.encodeABI = this.parent._encodeMethodABI.bind(txObject);
    txObject.estimateGas = this.parent._executeMethod.bind(txObject, "estimate");
    if (args && this.method.inputs && args.length !== this.method.inputs.length) {
        if (this.nextMethod) return this.nextMethod.apply(null, args);
        throw $64f2080ad381d344$require$errors.InvalidNumberOfParams(args.length, this.method.inputs.length, this.method.name);
    }
    txObject.arguments = args || [];
    txObject._method = this.method;
    txObject._parent = this.parent;
    txObject._ethAccounts = this.parent.constructor._ethAccounts || this._ethAccounts;
    if (this.deployData) txObject._deployData = this.deployData;
    return txObject;
};
/**
 * Generates the options for the execute call
 *
 * @method _processExecuteArguments
 * @param {Array} args
 * @param {Promise} defer
 */ $64f2080ad381d344$var$Contract.prototype._processExecuteArguments = function _processExecuteArguments(args, defer) {
    var processedArgs = {};
    processedArgs.type = args.shift();
    // get the callback
    processedArgs.callback = this._parent._getCallback(args);
    // get block number to use for call
    if (processedArgs.type === "call" && args[args.length - 1] !== true && (typeof args[args.length - 1] === "string" || isFinite(args[args.length - 1]))) processedArgs.defaultBlock = args.pop();
    // get the options
    processedArgs.options = (!!args[args.length - 1] && typeof args[args.length - 1]) === "object" ? args.pop() : {};
    // get the generateRequest argument for batch requests
    processedArgs.generateRequest = args[args.length - 1] === true ? args.pop() : false;
    processedArgs.options = this._parent._getOrSetDefaultOptions(processedArgs.options);
    processedArgs.options.data = this.encodeABI();
    // add contract address
    if (!this._deployData && !$hpg7W.isAddress(this._parent.options.address)) throw $64f2080ad381d344$require$errors.ContractNoAddressDefinedError();
    if (!this._deployData) processedArgs.options.to = this._parent.options.address;
    // return error, if no "data" is specified
    if (!processedArgs.options.data) return $hpg7W._fireError(new Error("Couldn't find a matching contract method, or the number of parameters is wrong."), defer.eventEmitter, defer.reject, processedArgs.callback);
    return processedArgs;
};
/**
 * Executes a call, transact or estimateGas on a contract function
 *
 * @method _executeMethod
 * @param {String} type the type this execute function should execute
 * @param {Boolean} makeRequest if true, it simply returns the request parameters, rather than executing it
 */ $64f2080ad381d344$var$Contract.prototype._executeMethod = function _executeMethod() {
    var _this = this, args = this._parent._processExecuteArguments.call(this, Array.prototype.slice.call(arguments), defer), defer = $4f4e7bc1f87a0108$exports(args.type !== "send"), ethAccounts = _this.constructor._ethAccounts || _this._ethAccounts;
    // simple return request for batch requests
    if (args.generateRequest) {
        var payload = {
            params: [
                $64f2080ad381d344$require$formatters.inputCallFormatter.call(this._parent, args.options)
            ],
            callback: args.callback
        };
        if (args.type === "call") {
            payload.params.push($64f2080ad381d344$require$formatters.inputDefaultBlockNumberFormatter.call(this._parent, args.defaultBlock));
            payload.method = "eth_call";
            payload.format = this._parent._decodeMethodReturn.bind(null, this._method.outputs);
        } else payload.method = "eth_sendTransaction";
        return payload;
    }
    switch(args.type){
        case "estimate":
            var estimateGas = new $60ff6d2aea0ffa29$exports({
                name: "estimateGas",
                call: "eth_estimateGas",
                params: 1,
                inputFormatter: [
                    $64f2080ad381d344$require$formatters.inputCallFormatter
                ],
                outputFormatter: $hpg7W.hexToNumber,
                requestManager: _this._parent._requestManager,
                accounts: ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock
            }).createFunction();
            return estimateGas(args.options, args.callback);
        case "call":
            // TODO check errors: missing "from" should give error on deploy and send, call ?
            var call = new $60ff6d2aea0ffa29$exports({
                name: "call",
                call: "eth_call",
                params: 2,
                inputFormatter: [
                    $64f2080ad381d344$require$formatters.inputCallFormatter,
                    $64f2080ad381d344$require$formatters.inputDefaultBlockNumberFormatter
                ],
                // add output formatter for decoding
                outputFormatter: function(result) {
                    return _this._parent._decodeMethodReturn(_this._method.outputs, result);
                },
                requestManager: _this._parent._requestManager,
                accounts: ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock,
                handleRevert: _this._parent.handleRevert,
                abiCoder: $618c9d1507e674b0$exports
            }).createFunction();
            return call(args.options, args.defaultBlock, args.callback);
        case "send":
            // return error, if no "from" is specified
            if (!$hpg7W.isAddress(args.options.from)) return $hpg7W._fireError($64f2080ad381d344$require$errors.ContractNoFromAddressDefinedError(), defer.eventEmitter, defer.reject, args.callback);
            if (typeof this._method.payable === "boolean" && !this._method.payable && args.options.value && args.options.value > 0) return $hpg7W._fireError(new Error("Can not send value to non-payable contract method or constructor"), defer.eventEmitter, defer.reject, args.callback);
            // make sure receipt logs are decoded
            var extraFormatters = {
                receiptFormatter: function(receipt) {
                    if (Array.isArray(receipt.logs)) {
                        // decode logs
                        var events = receipt.logs.map((log)=>{
                            return _this._parent._decodeEventABI.call({
                                name: "ALLEVENTS",
                                jsonInterface: _this._parent.options.jsonInterface
                            }, log);
                        });
                        // make log names keys
                        receipt.events = {};
                        var count = 0;
                        events.forEach(function(ev) {
                            if (ev.event) {
                                // if > 1 of the same event, don't overwrite any existing events
                                if (receipt.events[ev.event]) {
                                    if (Array.isArray(receipt.events[ev.event])) receipt.events[ev.event].push(ev);
                                    else receipt.events[ev.event] = [
                                        receipt.events[ev.event],
                                        ev
                                    ];
                                } else receipt.events[ev.event] = ev;
                            } else {
                                receipt.events[count] = ev;
                                count++;
                            }
                        });
                        delete receipt.logs;
                    }
                    return receipt;
                },
                contractDeployFormatter: function(receipt) {
                    var newContract = _this._parent.clone();
                    newContract.options.address = receipt.contractAddress;
                    return newContract;
                }
            };
            var sendTransaction = new $60ff6d2aea0ffa29$exports({
                name: "sendTransaction",
                call: "eth_sendTransaction",
                params: 1,
                inputFormatter: [
                    $64f2080ad381d344$require$formatters.inputTransactionFormatter
                ],
                requestManager: _this._parent._requestManager,
                accounts: _this.constructor._ethAccounts || _this._ethAccounts,
                defaultAccount: _this._parent.defaultAccount,
                defaultBlock: _this._parent.defaultBlock,
                transactionBlockTimeout: _this._parent.transactionBlockTimeout,
                transactionConfirmationBlocks: _this._parent.transactionConfirmationBlocks,
                transactionPollingTimeout: _this._parent.transactionPollingTimeout,
                defaultCommon: _this._parent.defaultCommon,
                defaultChain: _this._parent.defaultChain,
                defaultHardfork: _this._parent.defaultHardfork,
                handleRevert: _this._parent.handleRevert,
                extraFormatters: extraFormatters,
                abiCoder: $618c9d1507e674b0$exports
            }).createFunction();
            return sendTransaction(args.options, args.callback);
        default:
            throw new Error('Method "' + args.type + '" not implemented.');
    }
};
$64f2080ad381d344$exports = $64f2080ad381d344$var$Contract;


var $f652b9cec197140c$export$d6af199866bfb566;
var $f652b9cec197140c$export$a3295358bff77e;

var $ihoyg = parcelRequire("ihoyg");
var $f652b9cec197140c$require$Buffer = $ihoyg.Buffer;

var $f652b9cec197140c$require$sha3 = $8228226827ed2eec$exports.keccak_256;
var $2285c3ce80247b5d$exports = {};


(function(root, factory) {
    /* istanbul ignore next */ if (typeof define === "function" && define.amd) define([
        "punycode",
        "./idna-map"
    ], function(punycode, idna_map) {
        return factory(punycode, idna_map);
    });
    else $2285c3ce80247b5d$exports = factory((parcelRequire("cgUd1")), (parcelRequire("drBoY")));
})($2285c3ce80247b5d$exports, function(punycode, idna_map) {
    function mapLabel(label, useStd3ASCII, transitional) {
        var mapped = [];
        var chars = punycode.ucs2.decode(label);
        for(var i = 0; i < chars.length; i++){
            var cp = chars[i];
            var ch = punycode.ucs2.encode([
                chars[i]
            ]);
            var composite = idna_map.mapChar(cp);
            var flags = composite >> 23;
            var kind = composite >> 21 & 3;
            var index = composite >> 5 & 0xffff;
            var length = composite & 0x1f;
            var value = idna_map.mapStr.substr(index, length);
            if (kind === 0 || useStd3ASCII && flags & 1) throw new Error("Illegal char " + ch);
            else if (kind === 1) mapped.push(value);
            else if (kind === 2) mapped.push(transitional ? value : ch);
            else if (kind === 3) mapped.push(ch);
        }
        var newLabel = mapped.join("").normalize("NFC");
        return newLabel;
    }
    function process(domain, transitional, useStd3ASCII) {
        /* istanbul ignore if */ if (useStd3ASCII === undefined) useStd3ASCII = false;
        var mappedIDNA = mapLabel(domain, useStd3ASCII, transitional);
        // Step 3. Break
        var labels = mappedIDNA.split(".");
        // Step 4. Convert/Validate
        labels = labels.map(function(label) {
            if (label.startsWith("xn--")) {
                label = punycode.decode(label.substring(4));
                validateLabel(label, useStd3ASCII, false);
            } else validateLabel(label, useStd3ASCII, transitional);
            return label;
        });
        return labels.join(".");
    }
    function validateLabel(label, useStd3ASCII, transitional) {
        // 2. The label must not contain a U+002D HYPHEN-MINUS character in both the
        // third position and fourth positions.
        if (label[2] === "-" && label[3] === "-") throw new Error("Failed to validate " + label);
        // 3. The label must neither begin nor end with a U+002D HYPHEN-MINUS
        // character.
        if (label.startsWith("-") || label.endsWith("-")) throw new Error("Failed to validate " + label);
        // 4. The label must not contain a U+002E ( . ) FULL STOP.
        // this should nerver happen as label is chunked internally by this character
        /* istanbul ignore if */ if (label.includes(".")) throw new Error("Failed to validate " + label);
        if (mapLabel(label, useStd3ASCII, transitional) !== label) throw new Error("Failed to validate " + label);
        // 5. The label must not begin with a combining mark, that is:
        // General_Category=Mark.
        var ch = label.codePointAt(0);
        if (idna_map.mapChar(ch) & 16777216) throw new Error("Label contains illegal character: " + ch);
    }
    function toAscii(domain, options) {
        if (options === undefined) options = {};
        var transitional = "transitional" in options ? options.transitional : true;
        var useStd3ASCII = "useStd3ASCII" in options ? options.useStd3ASCII : false;
        var verifyDnsLength = "verifyDnsLength" in options ? options.verifyDnsLength : false;
        var labels = process(domain, transitional, useStd3ASCII).split(".");
        var asciiLabels = labels.map(punycode.toASCII);
        var asciiString = asciiLabels.join(".");
        var i;
        if (verifyDnsLength) {
            if (asciiString.length < 1 || asciiString.length > 253) throw new Error("DNS name has wrong length: " + asciiString);
            for(i = 0; i < asciiLabels.length; i++){
                var label = asciiLabels[i];
                if (label.length < 1 || label.length > 63) throw new Error("DNS label has wrong length: " + label);
            }
        }
        return asciiString;
    }
    function toUnicode(domain, options) {
        if (options === undefined) options = {};
        var useStd3ASCII = "useStd3ASCII" in options ? options.useStd3ASCII : false;
        return process(domain, false, useStd3ASCII);
    }
    return {
        toUnicode: toUnicode,
        toAscii: toAscii
    };
});


function $f652b9cec197140c$var$namehash(inputName) {
    // Reject empty names:
    var node = "";
    for(var i = 0; i < 32; i++)node += "00";
    name = $f652b9cec197140c$var$normalize(inputName);
    if (name) {
        var labels = name.split(".");
        for(var i = labels.length - 1; i >= 0; i--){
            var labelSha = $f652b9cec197140c$require$sha3(labels[i]);
            node = $f652b9cec197140c$require$sha3(new $f652b9cec197140c$require$Buffer(node + labelSha, "hex"));
        }
    }
    return "0x" + node;
}
function $f652b9cec197140c$var$normalize(name1) {
    return name1 ? $2285c3ce80247b5d$exports.toUnicode(name1, {
        useStd3ASCII: true,
        transitional: false
    }) : name1;
}
$f652b9cec197140c$export$d6af199866bfb566 = $f652b9cec197140c$var$namehash;
$f652b9cec197140c$export$a3295358bff77e = $f652b9cec197140c$var$normalize;




var $heyrh = parcelRequire("heyrh");
var $63c7915f18ef7036$require$formatters = $heyrh.formatters;

var $hpg7W = parcelRequire("hpg7W");
var $591e1c6ce4cb2edc$exports = {};
"use strict";
var $591e1c6ce4cb2edc$var$REGISTRY = [
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "resolver",
        "outputs": [
            {
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "owner",
        "outputs": [
            {
                "name": "",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "label",
                "type": "bytes32"
            },
            {
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "setSubnodeOwner",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setTTL",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "ttl",
        "outputs": [
            {
                "name": "",
                "type": "uint64"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "resolver",
                "type": "address"
            }
        ],
        "name": "setResolver",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "setOwner",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "Transfer",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": true,
                "name": "label",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "owner",
                "type": "address"
            }
        ],
        "name": "NewOwner",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "resolver",
                "type": "address"
            }
        ],
        "name": "NewResolver",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "NewTTL",
        "type": "event"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "resolver",
                "type": "address"
            },
            {
                "internalType": "uint64",
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setRecord",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "setApprovalForAll",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "internalType": "address",
                "name": "operator",
                "type": "address"
            },
            {
                "indexed": false,
                "internalType": "bool",
                "name": "approved",
                "type": "bool"
            }
        ],
        "name": "ApprovalForAll",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "operator",
                "type": "address"
            }
        ],
        "name": "isApprovedForAll",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "recordExists",
        "outputs": [
            {
                "internalType": "bool",
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "internalType": "bytes32",
                "name": "node",
                "type": "bytes32"
            },
            {
                "internalType": "bytes32",
                "name": "label",
                "type": "bytes32"
            },
            {
                "internalType": "address",
                "name": "owner",
                "type": "address"
            },
            {
                "internalType": "address",
                "name": "resolver",
                "type": "address"
            },
            {
                "internalType": "uint64",
                "name": "ttl",
                "type": "uint64"
            }
        ],
        "name": "setSubnodeRecord",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
$591e1c6ce4cb2edc$exports = $591e1c6ce4cb2edc$var$REGISTRY;


var $72fa7e755dc4e81d$exports = {};
"use strict";
var $72fa7e755dc4e81d$var$RESOLVER = [
    {
        "constant": true,
        "inputs": [
            {
                "name": "interfaceID",
                "type": "bytes4"
            }
        ],
        "name": "supportsInterface",
        "outputs": [
            {
                "name": "",
                "type": "bool"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "contentTypes",
                "type": "uint256"
            }
        ],
        "name": "ABI",
        "outputs": [
            {
                "name": "contentType",
                "type": "uint256"
            },
            {
                "name": "data",
                "type": "bytes"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "setMultihash",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "multihash",
        "outputs": [
            {
                "name": "",
                "type": "bytes"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "x",
                "type": "bytes32"
            },
            {
                "name": "y",
                "type": "bytes32"
            }
        ],
        "name": "setPubkey",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "content",
        "outputs": [
            {
                "name": "ret",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "addr",
        "outputs": [
            {
                "name": "ret",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "contentType",
                "type": "uint256"
            },
            {
                "name": "data",
                "type": "bytes"
            }
        ],
        "name": "setABI",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "name",
        "outputs": [
            {
                "name": "ret",
                "type": "string"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "name",
                "type": "string"
            }
        ],
        "name": "setName",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes32"
            }
        ],
        "name": "setContent",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "pubkey",
        "outputs": [
            {
                "name": "x",
                "type": "bytes32"
            },
            {
                "name": "y",
                "type": "bytes32"
            }
        ],
        "payable": false,
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "addr",
                "type": "address"
            }
        ],
        "name": "setAddr",
        "outputs": [],
        "payable": false,
        "type": "function"
    },
    {
        "inputs": [
            {
                "name": "ensAddr",
                "type": "address"
            }
        ],
        "payable": false,
        "type": "constructor"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "a",
                "type": "address"
            }
        ],
        "name": "AddrChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "hash",
                "type": "bytes32"
            }
        ],
        "name": "ContentChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "name",
                "type": "string"
            }
        ],
        "name": "NameChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": true,
                "name": "contentType",
                "type": "uint256"
            }
        ],
        "name": "ABIChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "x",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "y",
                "type": "bytes32"
            }
        ],
        "name": "PubkeyChanged",
        "type": "event"
    },
    {
        "anonymous": false,
        "inputs": [
            {
                "indexed": true,
                "name": "node",
                "type": "bytes32"
            },
            {
                "indexed": false,
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "ContenthashChanged",
        "type": "event"
    },
    {
        "constant": true,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            }
        ],
        "name": "contenthash",
        "outputs": [
            {
                "name": "",
                "type": "bytes"
            }
        ],
        "payable": false,
        "stateMutability": "view",
        "type": "function"
    },
    {
        "constant": false,
        "inputs": [
            {
                "name": "node",
                "type": "bytes32"
            },
            {
                "name": "hash",
                "type": "bytes"
            }
        ],
        "name": "setContenthash",
        "outputs": [],
        "payable": false,
        "stateMutability": "nonpayable",
        "type": "function"
    }
];
$72fa7e755dc4e81d$exports = $72fa7e755dc4e81d$var$RESOLVER;


/**
 * A wrapper around the ENS registry contract.
 *
 * @method Registry
 * @param {Ens} ens
 * @constructor
 */ function $63c7915f18ef7036$var$Registry(ens) {
    var self = this;
    this.ens = ens;
    this.contract = ens.checkNetwork().then(function(address) {
        var contract = new $64f2080ad381d344$exports($591e1c6ce4cb2edc$exports, address);
        contract.setProvider(self.ens.eth.currentProvider);
        return contract;
    });
}
/**
 * Returns the address of the owner of an ENS name.
 *
 * @deprecated Please use the "getOwner" method instead of "owner"
 *
 * @method owner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<string>}
 */ $63c7915f18ef7036$var$Registry.prototype.owner = function(name, callback) {
    console.warn('Deprecated: Please use the "getOwner" method instead of "owner".');
    return this.getOwner(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method getOwner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<string>}
 */ $63c7915f18ef7036$var$Registry.prototype.getOwner = function(name, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.owner($f652b9cec197140c$export$d6af199866bfb566(name)).call();
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setOwner
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setOwner = function(name, address, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.setOwner($f652b9cec197140c$export$d6af199866bfb566(name), $63c7915f18ef7036$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the TTL of the given node by his name
 *
 * @method getTTL
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returnss {Promise<string>}
 */ $63c7915f18ef7036$var$Registry.prototype.getTTL = function(name, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.ttl($f652b9cec197140c$export$d6af199866bfb566(name)).call();
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setTTL
 *
 * @param {string} name
 * @param {number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setTTL = function(name, ttl, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.setTTL($f652b9cec197140c$export$d6af199866bfb566(name), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setSubnodeOwner
 *
 * @param {string} name
 * @param {string} label
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setSubnodeOwner = function(name, label, address, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    if (!$hpg7W.isHexStrict(label)) label = $hpg7W.sha3(label);
    this.contract.then(function(contract) {
        return contract.methods.setSubnodeOwner($f652b9cec197140c$export$d6af199866bfb566(name), label, $63c7915f18ef7036$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets the owner, resolver, and TTL for an ENS record in a single operation.
 *
 * @method setRecord
 *
 * @param {string} name
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setRecord = function(name, owner, resolver, ttl, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.setRecord($f652b9cec197140c$export$d6af199866bfb566(name), $63c7915f18ef7036$require$formatters.inputAddressFormatter(owner), $63c7915f18ef7036$require$formatters.inputAddressFormatter(resolver), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets the owner, resolver and TTL for a subdomain, creating it if necessary.
 *
 * @method setSubnodeRecord
 *
 * @param {string} name
 * @param {string} label
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setSubnodeRecord = function(name, label, owner, resolver, ttl, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    if (!$hpg7W.isHexStrict(label)) label = $hpg7W.sha3(label);
    this.contract.then(function(contract) {
        return contract.methods.setSubnodeRecord($f652b9cec197140c$export$d6af199866bfb566(name), label, $63c7915f18ef7036$require$formatters.inputAddressFormatter(owner), $63c7915f18ef7036$require$formatters.inputAddressFormatter(resolver), ttl).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Sets or clears an approval by the given operator.
 *
 * @method setApprovalForAll
 *
 * @param {string} operator
 * @param {boolean} approved
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setApprovalForAll = function(operator, approved, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.setApprovalForAll($63c7915f18ef7036$require$formatters.inputAddressFormatter(operator), approved).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns true if the operator is approved
 *
 * @method isApprovedForAll
 *
 * @param {string} owner
 * @param {string} operator
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $63c7915f18ef7036$var$Registry.prototype.isApprovedForAll = function(owner, operator, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.isApprovedForAll($63c7915f18ef7036$require$formatters.inputAddressFormatter(owner), $63c7915f18ef7036$require$formatters.inputAddressFormatter(operator)).call();
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns true if the record exists
 *
 * @method recordExists
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $63c7915f18ef7036$var$Registry.prototype.recordExists = function(name, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.recordExists($f652b9cec197140c$export$d6af199866bfb566(name)).call();
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Returns the resolver contract associated with a name.
 *
 * @deprecated Please use the "getResolver" method instead of "resolver"
 *
 * @method resolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $63c7915f18ef7036$var$Registry.prototype.resolver = function(name, callback) {
    console.warn('Deprecated: Please use the "getResolver" method instead of "resolver".');
    return this.getResolver(name, callback);
};
/**
 * Returns the resolver contract associated with a name.
 *
 * @method getResolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $63c7915f18ef7036$var$Registry.prototype.getResolver = function(name, callback) {
    var self = this;
    return this.contract.then(function(contract) {
        return contract.methods.resolver($f652b9cec197140c$export$d6af199866bfb566(name)).call();
    }).then(function(address) {
        var contract = new $64f2080ad381d344$exports($72fa7e755dc4e81d$exports, address);
        contract.setProvider(self.ens.eth.currentProvider);
        if (typeof callback === "function") {
            // It's required to pass the contract to the first argument to be backward compatible and to have the required consistency
            callback(contract, contract);
            return;
        }
        return contract;
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        throw error;
    });
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setResolver
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $63c7915f18ef7036$var$Registry.prototype.setResolver = function(name, address, txConfig, callback) {
    var promiEvent = new $4f4e7bc1f87a0108$exports(true);
    this.contract.then(function(contract) {
        return contract.methods.setResolver($f652b9cec197140c$export$d6af199866bfb566(name), $63c7915f18ef7036$require$formatters.inputAddressFormatter(address)).send(txConfig);
    }).then(function(receipt) {
        if (typeof callback === "function") {
            // It's required to pass the receipt to the first argument to be backward compatible and to have the required consistency
            callback(receipt, receipt);
            return;
        }
        promiEvent.resolve(receipt);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
$63c7915f18ef7036$exports = $63c7915f18ef7036$var$Registry;


var $cbe6383f35211b3b$exports = {};
/*
    This file is part of web3.js.
    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.
    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.
    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file ResolverMethodHandler.js
 *
 * @author Samuel Furter <samuel@ethereum.org>
 * @date 2018
 */ "use strict";



var $heyrh = parcelRequire("heyrh");
var $cbe6383f35211b3b$require$errors = $heyrh.errors;

var $cbe6383f35211b3b$require$interfaceIds = $fc7a4943d74a91eb$exports.interfaceIds;
/**
 * @param {Registry} registry
 * @constructor
 */ function $cbe6383f35211b3b$var$ResolverMethodHandler(registry) {
    this.registry = registry;
}
/**
 * Executes an resolver method and returns an eventifiedPromise
 *
 * @param {string} ensName
 * @param {string} methodName
 * @param {array} methodArguments
 * @param {function} callback
 * @returns {Object}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.method = function(ensName, methodName, methodArguments, outputFormatter, callback) {
    return {
        call: this.call.bind({
            ensName: ensName,
            methodName: methodName,
            methodArguments: methodArguments,
            callback: callback,
            parent: this,
            outputFormatter: outputFormatter
        }),
        send: this.send.bind({
            ensName: ensName,
            methodName: methodName,
            methodArguments: methodArguments,
            callback: callback,
            parent: this
        })
    };
};
/**
 * Executes call
 *
 * @returns {eventifiedPromise}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.call = function(callback) {
    var self = this;
    var promiEvent = new $4f4e7bc1f87a0108$exports();
    var preparedArguments = this.parent.prepareArguments(this.ensName, this.methodArguments);
    var outputFormatter = this.outputFormatter || null;
    this.parent.registry.getResolver(this.ensName).then(async function(resolver) {
        await self.parent.checkInterfaceSupport(resolver, self.methodName);
        self.parent.handleCall(promiEvent, resolver.methods[self.methodName], preparedArguments, outputFormatter, callback);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Executes send
 *
 * @param {Object} sendOptions
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.send = function(sendOptions, callback) {
    var self = this;
    var promiEvent = new $4f4e7bc1f87a0108$exports();
    var preparedArguments = this.parent.prepareArguments(this.ensName, this.methodArguments);
    this.parent.registry.getResolver(this.ensName).then(async function(resolver) {
        await self.parent.checkInterfaceSupport(resolver, self.methodName);
        self.parent.handleSend(promiEvent, resolver.methods[self.methodName], preparedArguments, sendOptions, callback);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent.eventEmitter;
};
/**
 * Handles a call method
 *
 * @param {eventifiedPromise} promiEvent
 * @param {function} method
 * @param {array} preparedArguments
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.handleCall = function(promiEvent, method, preparedArguments, outputFormatter, callback) {
    method.apply(this, preparedArguments).call().then(function(result) {
        if (outputFormatter) result = outputFormatter(result);
        if (typeof callback === "function") {
            // It's required to pass the receipt to the second argument to be backwards compatible and to have the required consistency
            callback(result, result);
            return;
        }
        promiEvent.resolve(result);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent;
};
/**
 * Handles a send method
 *
 * @param {eventifiedPromise} promiEvent
 * @param {function} method
 * @param {array} preparedArguments
 * @param {Object} sendOptions
 * @param {function} callback
 * @returns {eventifiedPromise}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.handleSend = function(promiEvent, method, preparedArguments, sendOptions, callback) {
    method.apply(this, preparedArguments).send(sendOptions).on("sending", function() {
        promiEvent.eventEmitter.emit("sending");
    }).on("sent", function() {
        promiEvent.eventEmitter.emit("sent");
    }).on("transactionHash", function(hash) {
        promiEvent.eventEmitter.emit("transactionHash", hash);
    }).on("confirmation", function(confirmationNumber, receipt) {
        promiEvent.eventEmitter.emit("confirmation", confirmationNumber, receipt);
    }).on("receipt", function(receipt) {
        promiEvent.eventEmitter.emit("receipt", receipt);
        promiEvent.resolve(receipt);
        if (typeof callback === "function") // It's required to pass the receipt to the second argument to be backwards compatible and to have the required consistency
        callback(receipt, receipt);
    }).on("error", function(error) {
        promiEvent.eventEmitter.emit("error", error);
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        promiEvent.reject(error);
    });
    return promiEvent;
};
/**
 * Adds the ENS node to the arguments
 *
 * @param {string} name
 * @param {array} methodArguments
 *
 * @returns {array}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.prepareArguments = function(name, methodArguments) {
    var node = $f652b9cec197140c$export$d6af199866bfb566(name);
    if (methodArguments.length > 0) {
        methodArguments.unshift(node);
        return methodArguments;
    }
    return [
        node
    ];
};
/**
 *
 *
 * @param {Contract} resolver
 * @param {string} methodName
 *
 * @returns {Promise}
 */ $cbe6383f35211b3b$var$ResolverMethodHandler.prototype.checkInterfaceSupport = async function(resolver, methodName) {
    // Skip validation for undocumented interface ids (ex: multihash)
    if (!$cbe6383f35211b3b$require$interfaceIds[methodName]) return;
    var supported = false;
    try {
        supported = await resolver.methods.supportsInterface($cbe6383f35211b3b$require$interfaceIds[methodName]).call();
    } catch (err) {
        console.warn('Could not verify interface of resolver contract at "' + resolver.options.address + '". ');
    }
    if (!supported) throw $cbe6383f35211b3b$require$errors.ResolverMethodMissingError(resolver.options.address, methodName);
};
$cbe6383f35211b3b$exports = $cbe6383f35211b3b$var$ResolverMethodHandler;


var $2e393b7dc35fd78d$exports = {};
/*
Adapted from ensdomains/ui
https://github.com/ensdomains/ui/blob/3e62e440b53466eeec9dd1c63d73924eefbd88c1/src/utils/contents.js#L1-L85

BSD 2-Clause License

Copyright (c) 2019, Ethereum Name Service
All rights reserved.

Redistribution and use in source and binary forms, with or without
modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this
  list of conditions and the following disclaimer.

* Redistributions in binary form must reproduce the above copyright notice,
  this list of conditions and the following disclaimer in the documentation
  and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE
FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL
DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY,
OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var $5062c82da900e7f1$exports = {};
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ 
var $g2JpA = parcelRequire("g2JpA");
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ var $adad6c2a32ffa238$export$83238ff569ad9e94;
var $adad6c2a32ffa238$export$63dc120dff6c5db8;

var $ihoyg = parcelRequire("ihoyg");
var $adad6c2a32ffa238$require$Buffer = $ihoyg.Buffer;
var $1932d7f4dbc3d3a4$exports = {};
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $1932d7f4dbc3d3a4$require$Buffer = $ihoyg.Buffer;
/**
 * Multihash implementation in JavaScript.
 *
 * @module multihash
 */ var $85943b908325c028$export$e4b2ac9215619f8d;
var $85943b908325c028$export$e45cb6485273080e;
var $85943b908325c028$export$6afcb0067345fd27;
/**
 * Convert the given multihash to a hex encoded string.
 *
 * @param {Buffer} hash
 * @returns {string}
 */ var $85943b908325c028$export$f4915efbb94d4d01;
/**
 * Convert the given hex encoded string to a multihash.
 *
 * @param {string} hash
 * @returns {Buffer}
 */ var $85943b908325c028$export$99a70112ceb8327b;
/**
 * Convert the given multihash to a base58 encoded string.
 *
 * @param {Buffer} hash
 * @returns {string}
 */ var $85943b908325c028$export$6f10cd39aba42032;
/**
 * Convert the given base58 encoded string to a multihash.
 *
 * @param {string|Buffer} hash
 * @returns {Buffer}
 */ var $85943b908325c028$export$94293751533bac2;
/**
 * Decode a hash from the given multihash.
 *
 * @param {Buffer} buf
 * @returns {{code: number, name: string, length: number, digest: Buffer}} result
 */ var $85943b908325c028$export$2f872c0f2117be69;
/**
 *  Encode a hash digest along with the specified function code.
 *
 * > **Note:** the length is derived from the length of the digest itself.
 *
 * @param {Buffer} digest
 * @param {string|number} code
 * @param {number} [length]
 * @returns {Buffer}
 */ var $85943b908325c028$export$c564cdbbe6da493;
/**
 * Converts a hash function name into the matching code.
 * If passed a number it will return the number if it's a valid code.
 * @param {string|number} name
 * @returns {number}
 */ var $85943b908325c028$export$5c4b645cb8721bfa;
/**
 * Checks wether a code is part of the app range
 *
 * @param {number} code
 * @returns {boolean}
 */ var $85943b908325c028$export$dd468b29e9e316eb;
/**
 * Checks whether a multihash code is valid.
 *
 * @param {number} code
 * @returns {boolean}
 */ var $85943b908325c028$export$a5c39676d2a86af8;
var $85943b908325c028$export$a22775fa5e2eebd9;
/**
 * Returns a prefix from a valid multihash. Throws an error if it is not valid.
 *
 * @param {Buffer} multihash
 * @returns {undefined}
 * @throws {Error}
 */ var $85943b908325c028$export$82e9f45cca5ba907;
"use strict";

var $ihoyg = parcelRequire("ihoyg");
var $85943b908325c028$require$Buffer = $ihoyg.Buffer;

var $8thpe = parcelRequire("8thpe");

var $9q7Fh = parcelRequire("9q7Fh");
/* eslint quote-props: off */ /* eslint key-spacing: off */ var $77b6810a2f8afdac$export$e4b2ac9215619f8d;
var $77b6810a2f8afdac$export$e45cb6485273080e;
var $77b6810a2f8afdac$export$6afcb0067345fd27;
"use strict";
$77b6810a2f8afdac$export$e4b2ac9215619f8d = Object.freeze({
    "identity": 0x0,
    "sha1": 0x11,
    "sha2-256": 0x12,
    "sha2-512": 0x13,
    "dbl-sha2-256": 0x56,
    "sha3-224": 0x17,
    "sha3-256": 0x16,
    "sha3-384": 0x15,
    "sha3-512": 0x14,
    "shake-128": 0x18,
    "shake-256": 0x19,
    "keccak-224": 0x1A,
    "keccak-256": 0x1B,
    "keccak-384": 0x1C,
    "keccak-512": 0x1D,
    "murmur3-128": 0x22,
    "murmur3-32": 0x23,
    "md4": 0xd4,
    "md5": 0xd5,
    "blake2b-8": 0xb201,
    "blake2b-16": 0xb202,
    "blake2b-24": 0xb203,
    "blake2b-32": 0xb204,
    "blake2b-40": 0xb205,
    "blake2b-48": 0xb206,
    "blake2b-56": 0xb207,
    "blake2b-64": 0xb208,
    "blake2b-72": 0xb209,
    "blake2b-80": 0xb20a,
    "blake2b-88": 0xb20b,
    "blake2b-96": 0xb20c,
    "blake2b-104": 0xb20d,
    "blake2b-112": 0xb20e,
    "blake2b-120": 0xb20f,
    "blake2b-128": 0xb210,
    "blake2b-136": 0xb211,
    "blake2b-144": 0xb212,
    "blake2b-152": 0xb213,
    "blake2b-160": 0xb214,
    "blake2b-168": 0xb215,
    "blake2b-176": 0xb216,
    "blake2b-184": 0xb217,
    "blake2b-192": 0xb218,
    "blake2b-200": 0xb219,
    "blake2b-208": 0xb21a,
    "blake2b-216": 0xb21b,
    "blake2b-224": 0xb21c,
    "blake2b-232": 0xb21d,
    "blake2b-240": 0xb21e,
    "blake2b-248": 0xb21f,
    "blake2b-256": 0xb220,
    "blake2b-264": 0xb221,
    "blake2b-272": 0xb222,
    "blake2b-280": 0xb223,
    "blake2b-288": 0xb224,
    "blake2b-296": 0xb225,
    "blake2b-304": 0xb226,
    "blake2b-312": 0xb227,
    "blake2b-320": 0xb228,
    "blake2b-328": 0xb229,
    "blake2b-336": 0xb22a,
    "blake2b-344": 0xb22b,
    "blake2b-352": 0xb22c,
    "blake2b-360": 0xb22d,
    "blake2b-368": 0xb22e,
    "blake2b-376": 0xb22f,
    "blake2b-384": 0xb230,
    "blake2b-392": 0xb231,
    "blake2b-400": 0xb232,
    "blake2b-408": 0xb233,
    "blake2b-416": 0xb234,
    "blake2b-424": 0xb235,
    "blake2b-432": 0xb236,
    "blake2b-440": 0xb237,
    "blake2b-448": 0xb238,
    "blake2b-456": 0xb239,
    "blake2b-464": 0xb23a,
    "blake2b-472": 0xb23b,
    "blake2b-480": 0xb23c,
    "blake2b-488": 0xb23d,
    "blake2b-496": 0xb23e,
    "blake2b-504": 0xb23f,
    "blake2b-512": 0xb240,
    "blake2s-8": 0xb241,
    "blake2s-16": 0xb242,
    "blake2s-24": 0xb243,
    "blake2s-32": 0xb244,
    "blake2s-40": 0xb245,
    "blake2s-48": 0xb246,
    "blake2s-56": 0xb247,
    "blake2s-64": 0xb248,
    "blake2s-72": 0xb249,
    "blake2s-80": 0xb24a,
    "blake2s-88": 0xb24b,
    "blake2s-96": 0xb24c,
    "blake2s-104": 0xb24d,
    "blake2s-112": 0xb24e,
    "blake2s-120": 0xb24f,
    "blake2s-128": 0xb250,
    "blake2s-136": 0xb251,
    "blake2s-144": 0xb252,
    "blake2s-152": 0xb253,
    "blake2s-160": 0xb254,
    "blake2s-168": 0xb255,
    "blake2s-176": 0xb256,
    "blake2s-184": 0xb257,
    "blake2s-192": 0xb258,
    "blake2s-200": 0xb259,
    "blake2s-208": 0xb25a,
    "blake2s-216": 0xb25b,
    "blake2s-224": 0xb25c,
    "blake2s-232": 0xb25d,
    "blake2s-240": 0xb25e,
    "blake2s-248": 0xb25f,
    "blake2s-256": 0xb260,
    "Skein256-8": 0xb301,
    "Skein256-16": 0xb302,
    "Skein256-24": 0xb303,
    "Skein256-32": 0xb304,
    "Skein256-40": 0xb305,
    "Skein256-48": 0xb306,
    "Skein256-56": 0xb307,
    "Skein256-64": 0xb308,
    "Skein256-72": 0xb309,
    "Skein256-80": 0xb30a,
    "Skein256-88": 0xb30b,
    "Skein256-96": 0xb30c,
    "Skein256-104": 0xb30d,
    "Skein256-112": 0xb30e,
    "Skein256-120": 0xb30f,
    "Skein256-128": 0xb310,
    "Skein256-136": 0xb311,
    "Skein256-144": 0xb312,
    "Skein256-152": 0xb313,
    "Skein256-160": 0xb314,
    "Skein256-168": 0xb315,
    "Skein256-176": 0xb316,
    "Skein256-184": 0xb317,
    "Skein256-192": 0xb318,
    "Skein256-200": 0xb319,
    "Skein256-208": 0xb31a,
    "Skein256-216": 0xb31b,
    "Skein256-224": 0xb31c,
    "Skein256-232": 0xb31d,
    "Skein256-240": 0xb31e,
    "Skein256-248": 0xb31f,
    "Skein256-256": 0xb320,
    "Skein512-8": 0xb321,
    "Skein512-16": 0xb322,
    "Skein512-24": 0xb323,
    "Skein512-32": 0xb324,
    "Skein512-40": 0xb325,
    "Skein512-48": 0xb326,
    "Skein512-56": 0xb327,
    "Skein512-64": 0xb328,
    "Skein512-72": 0xb329,
    "Skein512-80": 0xb32a,
    "Skein512-88": 0xb32b,
    "Skein512-96": 0xb32c,
    "Skein512-104": 0xb32d,
    "Skein512-112": 0xb32e,
    "Skein512-120": 0xb32f,
    "Skein512-128": 0xb330,
    "Skein512-136": 0xb331,
    "Skein512-144": 0xb332,
    "Skein512-152": 0xb333,
    "Skein512-160": 0xb334,
    "Skein512-168": 0xb335,
    "Skein512-176": 0xb336,
    "Skein512-184": 0xb337,
    "Skein512-192": 0xb338,
    "Skein512-200": 0xb339,
    "Skein512-208": 0xb33a,
    "Skein512-216": 0xb33b,
    "Skein512-224": 0xb33c,
    "Skein512-232": 0xb33d,
    "Skein512-240": 0xb33e,
    "Skein512-248": 0xb33f,
    "Skein512-256": 0xb340,
    "Skein512-264": 0xb341,
    "Skein512-272": 0xb342,
    "Skein512-280": 0xb343,
    "Skein512-288": 0xb344,
    "Skein512-296": 0xb345,
    "Skein512-304": 0xb346,
    "Skein512-312": 0xb347,
    "Skein512-320": 0xb348,
    "Skein512-328": 0xb349,
    "Skein512-336": 0xb34a,
    "Skein512-344": 0xb34b,
    "Skein512-352": 0xb34c,
    "Skein512-360": 0xb34d,
    "Skein512-368": 0xb34e,
    "Skein512-376": 0xb34f,
    "Skein512-384": 0xb350,
    "Skein512-392": 0xb351,
    "Skein512-400": 0xb352,
    "Skein512-408": 0xb353,
    "Skein512-416": 0xb354,
    "Skein512-424": 0xb355,
    "Skein512-432": 0xb356,
    "Skein512-440": 0xb357,
    "Skein512-448": 0xb358,
    "Skein512-456": 0xb359,
    "Skein512-464": 0xb35a,
    "Skein512-472": 0xb35b,
    "Skein512-480": 0xb35c,
    "Skein512-488": 0xb35d,
    "Skein512-496": 0xb35e,
    "Skein512-504": 0xb35f,
    "Skein512-512": 0xb360,
    "Skein1024-8": 0xb361,
    "Skein1024-16": 0xb362,
    "Skein1024-24": 0xb363,
    "Skein1024-32": 0xb364,
    "Skein1024-40": 0xb365,
    "Skein1024-48": 0xb366,
    "Skein1024-56": 0xb367,
    "Skein1024-64": 0xb368,
    "Skein1024-72": 0xb369,
    "Skein1024-80": 0xb36a,
    "Skein1024-88": 0xb36b,
    "Skein1024-96": 0xb36c,
    "Skein1024-104": 0xb36d,
    "Skein1024-112": 0xb36e,
    "Skein1024-120": 0xb36f,
    "Skein1024-128": 0xb370,
    "Skein1024-136": 0xb371,
    "Skein1024-144": 0xb372,
    "Skein1024-152": 0xb373,
    "Skein1024-160": 0xb374,
    "Skein1024-168": 0xb375,
    "Skein1024-176": 0xb376,
    "Skein1024-184": 0xb377,
    "Skein1024-192": 0xb378,
    "Skein1024-200": 0xb379,
    "Skein1024-208": 0xb37a,
    "Skein1024-216": 0xb37b,
    "Skein1024-224": 0xb37c,
    "Skein1024-232": 0xb37d,
    "Skein1024-240": 0xb37e,
    "Skein1024-248": 0xb37f,
    "Skein1024-256": 0xb380,
    "Skein1024-264": 0xb381,
    "Skein1024-272": 0xb382,
    "Skein1024-280": 0xb383,
    "Skein1024-288": 0xb384,
    "Skein1024-296": 0xb385,
    "Skein1024-304": 0xb386,
    "Skein1024-312": 0xb387,
    "Skein1024-320": 0xb388,
    "Skein1024-328": 0xb389,
    "Skein1024-336": 0xb38a,
    "Skein1024-344": 0xb38b,
    "Skein1024-352": 0xb38c,
    "Skein1024-360": 0xb38d,
    "Skein1024-368": 0xb38e,
    "Skein1024-376": 0xb38f,
    "Skein1024-384": 0xb390,
    "Skein1024-392": 0xb391,
    "Skein1024-400": 0xb392,
    "Skein1024-408": 0xb393,
    "Skein1024-416": 0xb394,
    "Skein1024-424": 0xb395,
    "Skein1024-432": 0xb396,
    "Skein1024-440": 0xb397,
    "Skein1024-448": 0xb398,
    "Skein1024-456": 0xb399,
    "Skein1024-464": 0xb39a,
    "Skein1024-472": 0xb39b,
    "Skein1024-480": 0xb39c,
    "Skein1024-488": 0xb39d,
    "Skein1024-496": 0xb39e,
    "Skein1024-504": 0xb39f,
    "Skein1024-512": 0xb3a0,
    "Skein1024-520": 0xb3a1,
    "Skein1024-528": 0xb3a2,
    "Skein1024-536": 0xb3a3,
    "Skein1024-544": 0xb3a4,
    "Skein1024-552": 0xb3a5,
    "Skein1024-560": 0xb3a6,
    "Skein1024-568": 0xb3a7,
    "Skein1024-576": 0xb3a8,
    "Skein1024-584": 0xb3a9,
    "Skein1024-592": 0xb3aa,
    "Skein1024-600": 0xb3ab,
    "Skein1024-608": 0xb3ac,
    "Skein1024-616": 0xb3ad,
    "Skein1024-624": 0xb3ae,
    "Skein1024-632": 0xb3af,
    "Skein1024-640": 0xb3b0,
    "Skein1024-648": 0xb3b1,
    "Skein1024-656": 0xb3b2,
    "Skein1024-664": 0xb3b3,
    "Skein1024-672": 0xb3b4,
    "Skein1024-680": 0xb3b5,
    "Skein1024-688": 0xb3b6,
    "Skein1024-696": 0xb3b7,
    "Skein1024-704": 0xb3b8,
    "Skein1024-712": 0xb3b9,
    "Skein1024-720": 0xb3ba,
    "Skein1024-728": 0xb3bb,
    "Skein1024-736": 0xb3bc,
    "Skein1024-744": 0xb3bd,
    "Skein1024-752": 0xb3be,
    "Skein1024-760": 0xb3bf,
    "Skein1024-768": 0xb3c0,
    "Skein1024-776": 0xb3c1,
    "Skein1024-784": 0xb3c2,
    "Skein1024-792": 0xb3c3,
    "Skein1024-800": 0xb3c4,
    "Skein1024-808": 0xb3c5,
    "Skein1024-816": 0xb3c6,
    "Skein1024-824": 0xb3c7,
    "Skein1024-832": 0xb3c8,
    "Skein1024-840": 0xb3c9,
    "Skein1024-848": 0xb3ca,
    "Skein1024-856": 0xb3cb,
    "Skein1024-864": 0xb3cc,
    "Skein1024-872": 0xb3cd,
    "Skein1024-880": 0xb3ce,
    "Skein1024-888": 0xb3cf,
    "Skein1024-896": 0xb3d0,
    "Skein1024-904": 0xb3d1,
    "Skein1024-912": 0xb3d2,
    "Skein1024-920": 0xb3d3,
    "Skein1024-928": 0xb3d4,
    "Skein1024-936": 0xb3d5,
    "Skein1024-944": 0xb3d6,
    "Skein1024-952": 0xb3d7,
    "Skein1024-960": 0xb3d8,
    "Skein1024-968": 0xb3d9,
    "Skein1024-976": 0xb3da,
    "Skein1024-984": 0xb3db,
    "Skein1024-992": 0xb3dc,
    "Skein1024-1000": 0xb3dd,
    "Skein1024-1008": 0xb3de,
    "Skein1024-1016": 0xb3df,
    "Skein1024-1024": 0xb3e0
});
$77b6810a2f8afdac$export$e45cb6485273080e = Object.freeze({
    0x0: "identity",
    // sha family
    0x11: "sha1",
    0x12: "sha2-256",
    0x13: "sha2-512",
    0x56: "dbl-sha2-256",
    0x17: "sha3-224",
    0x16: "sha3-256",
    0x15: "sha3-384",
    0x14: "sha3-512",
    0x18: "shake-128",
    0x19: "shake-256",
    0x1A: "keccak-224",
    0x1B: "keccak-256",
    0x1C: "keccak-384",
    0x1D: "keccak-512",
    0x22: "murmur3-128",
    0x23: "murmur3-32",
    0xd4: "md4",
    0xd5: "md5",
    // blake2
    0xb201: "blake2b-8",
    0xb202: "blake2b-16",
    0xb203: "blake2b-24",
    0xb204: "blake2b-32",
    0xb205: "blake2b-40",
    0xb206: "blake2b-48",
    0xb207: "blake2b-56",
    0xb208: "blake2b-64",
    0xb209: "blake2b-72",
    0xb20a: "blake2b-80",
    0xb20b: "blake2b-88",
    0xb20c: "blake2b-96",
    0xb20d: "blake2b-104",
    0xb20e: "blake2b-112",
    0xb20f: "blake2b-120",
    0xb210: "blake2b-128",
    0xb211: "blake2b-136",
    0xb212: "blake2b-144",
    0xb213: "blake2b-152",
    0xb214: "blake2b-160",
    0xb215: "blake2b-168",
    0xb216: "blake2b-176",
    0xb217: "blake2b-184",
    0xb218: "blake2b-192",
    0xb219: "blake2b-200",
    0xb21a: "blake2b-208",
    0xb21b: "blake2b-216",
    0xb21c: "blake2b-224",
    0xb21d: "blake2b-232",
    0xb21e: "blake2b-240",
    0xb21f: "blake2b-248",
    0xb220: "blake2b-256",
    0xb221: "blake2b-264",
    0xb222: "blake2b-272",
    0xb223: "blake2b-280",
    0xb224: "blake2b-288",
    0xb225: "blake2b-296",
    0xb226: "blake2b-304",
    0xb227: "blake2b-312",
    0xb228: "blake2b-320",
    0xb229: "blake2b-328",
    0xb22a: "blake2b-336",
    0xb22b: "blake2b-344",
    0xb22c: "blake2b-352",
    0xb22d: "blake2b-360",
    0xb22e: "blake2b-368",
    0xb22f: "blake2b-376",
    0xb230: "blake2b-384",
    0xb231: "blake2b-392",
    0xb232: "blake2b-400",
    0xb233: "blake2b-408",
    0xb234: "blake2b-416",
    0xb235: "blake2b-424",
    0xb236: "blake2b-432",
    0xb237: "blake2b-440",
    0xb238: "blake2b-448",
    0xb239: "blake2b-456",
    0xb23a: "blake2b-464",
    0xb23b: "blake2b-472",
    0xb23c: "blake2b-480",
    0xb23d: "blake2b-488",
    0xb23e: "blake2b-496",
    0xb23f: "blake2b-504",
    0xb240: "blake2b-512",
    0xb241: "blake2s-8",
    0xb242: "blake2s-16",
    0xb243: "blake2s-24",
    0xb244: "blake2s-32",
    0xb245: "blake2s-40",
    0xb246: "blake2s-48",
    0xb247: "blake2s-56",
    0xb248: "blake2s-64",
    0xb249: "blake2s-72",
    0xb24a: "blake2s-80",
    0xb24b: "blake2s-88",
    0xb24c: "blake2s-96",
    0xb24d: "blake2s-104",
    0xb24e: "blake2s-112",
    0xb24f: "blake2s-120",
    0xb250: "blake2s-128",
    0xb251: "blake2s-136",
    0xb252: "blake2s-144",
    0xb253: "blake2s-152",
    0xb254: "blake2s-160",
    0xb255: "blake2s-168",
    0xb256: "blake2s-176",
    0xb257: "blake2s-184",
    0xb258: "blake2s-192",
    0xb259: "blake2s-200",
    0xb25a: "blake2s-208",
    0xb25b: "blake2s-216",
    0xb25c: "blake2s-224",
    0xb25d: "blake2s-232",
    0xb25e: "blake2s-240",
    0xb25f: "blake2s-248",
    0xb260: "blake2s-256",
    // skein
    0xb301: "Skein256-8",
    0xb302: "Skein256-16",
    0xb303: "Skein256-24",
    0xb304: "Skein256-32",
    0xb305: "Skein256-40",
    0xb306: "Skein256-48",
    0xb307: "Skein256-56",
    0xb308: "Skein256-64",
    0xb309: "Skein256-72",
    0xb30a: "Skein256-80",
    0xb30b: "Skein256-88",
    0xb30c: "Skein256-96",
    0xb30d: "Skein256-104",
    0xb30e: "Skein256-112",
    0xb30f: "Skein256-120",
    0xb310: "Skein256-128",
    0xb311: "Skein256-136",
    0xb312: "Skein256-144",
    0xb313: "Skein256-152",
    0xb314: "Skein256-160",
    0xb315: "Skein256-168",
    0xb316: "Skein256-176",
    0xb317: "Skein256-184",
    0xb318: "Skein256-192",
    0xb319: "Skein256-200",
    0xb31a: "Skein256-208",
    0xb31b: "Skein256-216",
    0xb31c: "Skein256-224",
    0xb31d: "Skein256-232",
    0xb31e: "Skein256-240",
    0xb31f: "Skein256-248",
    0xb320: "Skein256-256",
    0xb321: "Skein512-8",
    0xb322: "Skein512-16",
    0xb323: "Skein512-24",
    0xb324: "Skein512-32",
    0xb325: "Skein512-40",
    0xb326: "Skein512-48",
    0xb327: "Skein512-56",
    0xb328: "Skein512-64",
    0xb329: "Skein512-72",
    0xb32a: "Skein512-80",
    0xb32b: "Skein512-88",
    0xb32c: "Skein512-96",
    0xb32d: "Skein512-104",
    0xb32e: "Skein512-112",
    0xb32f: "Skein512-120",
    0xb330: "Skein512-128",
    0xb331: "Skein512-136",
    0xb332: "Skein512-144",
    0xb333: "Skein512-152",
    0xb334: "Skein512-160",
    0xb335: "Skein512-168",
    0xb336: "Skein512-176",
    0xb337: "Skein512-184",
    0xb338: "Skein512-192",
    0xb339: "Skein512-200",
    0xb33a: "Skein512-208",
    0xb33b: "Skein512-216",
    0xb33c: "Skein512-224",
    0xb33d: "Skein512-232",
    0xb33e: "Skein512-240",
    0xb33f: "Skein512-248",
    0xb340: "Skein512-256",
    0xb341: "Skein512-264",
    0xb342: "Skein512-272",
    0xb343: "Skein512-280",
    0xb344: "Skein512-288",
    0xb345: "Skein512-296",
    0xb346: "Skein512-304",
    0xb347: "Skein512-312",
    0xb348: "Skein512-320",
    0xb349: "Skein512-328",
    0xb34a: "Skein512-336",
    0xb34b: "Skein512-344",
    0xb34c: "Skein512-352",
    0xb34d: "Skein512-360",
    0xb34e: "Skein512-368",
    0xb34f: "Skein512-376",
    0xb350: "Skein512-384",
    0xb351: "Skein512-392",
    0xb352: "Skein512-400",
    0xb353: "Skein512-408",
    0xb354: "Skein512-416",
    0xb355: "Skein512-424",
    0xb356: "Skein512-432",
    0xb357: "Skein512-440",
    0xb358: "Skein512-448",
    0xb359: "Skein512-456",
    0xb35a: "Skein512-464",
    0xb35b: "Skein512-472",
    0xb35c: "Skein512-480",
    0xb35d: "Skein512-488",
    0xb35e: "Skein512-496",
    0xb35f: "Skein512-504",
    0xb360: "Skein512-512",
    0xb361: "Skein1024-8",
    0xb362: "Skein1024-16",
    0xb363: "Skein1024-24",
    0xb364: "Skein1024-32",
    0xb365: "Skein1024-40",
    0xb366: "Skein1024-48",
    0xb367: "Skein1024-56",
    0xb368: "Skein1024-64",
    0xb369: "Skein1024-72",
    0xb36a: "Skein1024-80",
    0xb36b: "Skein1024-88",
    0xb36c: "Skein1024-96",
    0xb36d: "Skein1024-104",
    0xb36e: "Skein1024-112",
    0xb36f: "Skein1024-120",
    0xb370: "Skein1024-128",
    0xb371: "Skein1024-136",
    0xb372: "Skein1024-144",
    0xb373: "Skein1024-152",
    0xb374: "Skein1024-160",
    0xb375: "Skein1024-168",
    0xb376: "Skein1024-176",
    0xb377: "Skein1024-184",
    0xb378: "Skein1024-192",
    0xb379: "Skein1024-200",
    0xb37a: "Skein1024-208",
    0xb37b: "Skein1024-216",
    0xb37c: "Skein1024-224",
    0xb37d: "Skein1024-232",
    0xb37e: "Skein1024-240",
    0xb37f: "Skein1024-248",
    0xb380: "Skein1024-256",
    0xb381: "Skein1024-264",
    0xb382: "Skein1024-272",
    0xb383: "Skein1024-280",
    0xb384: "Skein1024-288",
    0xb385: "Skein1024-296",
    0xb386: "Skein1024-304",
    0xb387: "Skein1024-312",
    0xb388: "Skein1024-320",
    0xb389: "Skein1024-328",
    0xb38a: "Skein1024-336",
    0xb38b: "Skein1024-344",
    0xb38c: "Skein1024-352",
    0xb38d: "Skein1024-360",
    0xb38e: "Skein1024-368",
    0xb38f: "Skein1024-376",
    0xb390: "Skein1024-384",
    0xb391: "Skein1024-392",
    0xb392: "Skein1024-400",
    0xb393: "Skein1024-408",
    0xb394: "Skein1024-416",
    0xb395: "Skein1024-424",
    0xb396: "Skein1024-432",
    0xb397: "Skein1024-440",
    0xb398: "Skein1024-448",
    0xb399: "Skein1024-456",
    0xb39a: "Skein1024-464",
    0xb39b: "Skein1024-472",
    0xb39c: "Skein1024-480",
    0xb39d: "Skein1024-488",
    0xb39e: "Skein1024-496",
    0xb39f: "Skein1024-504",
    0xb3a0: "Skein1024-512",
    0xb3a1: "Skein1024-520",
    0xb3a2: "Skein1024-528",
    0xb3a3: "Skein1024-536",
    0xb3a4: "Skein1024-544",
    0xb3a5: "Skein1024-552",
    0xb3a6: "Skein1024-560",
    0xb3a7: "Skein1024-568",
    0xb3a8: "Skein1024-576",
    0xb3a9: "Skein1024-584",
    0xb3aa: "Skein1024-592",
    0xb3ab: "Skein1024-600",
    0xb3ac: "Skein1024-608",
    0xb3ad: "Skein1024-616",
    0xb3ae: "Skein1024-624",
    0xb3af: "Skein1024-632",
    0xb3b0: "Skein1024-640",
    0xb3b1: "Skein1024-648",
    0xb3b2: "Skein1024-656",
    0xb3b3: "Skein1024-664",
    0xb3b4: "Skein1024-672",
    0xb3b5: "Skein1024-680",
    0xb3b6: "Skein1024-688",
    0xb3b7: "Skein1024-696",
    0xb3b8: "Skein1024-704",
    0xb3b9: "Skein1024-712",
    0xb3ba: "Skein1024-720",
    0xb3bb: "Skein1024-728",
    0xb3bc: "Skein1024-736",
    0xb3bd: "Skein1024-744",
    0xb3be: "Skein1024-752",
    0xb3bf: "Skein1024-760",
    0xb3c0: "Skein1024-768",
    0xb3c1: "Skein1024-776",
    0xb3c2: "Skein1024-784",
    0xb3c3: "Skein1024-792",
    0xb3c4: "Skein1024-800",
    0xb3c5: "Skein1024-808",
    0xb3c6: "Skein1024-816",
    0xb3c7: "Skein1024-824",
    0xb3c8: "Skein1024-832",
    0xb3c9: "Skein1024-840",
    0xb3ca: "Skein1024-848",
    0xb3cb: "Skein1024-856",
    0xb3cc: "Skein1024-864",
    0xb3cd: "Skein1024-872",
    0xb3ce: "Skein1024-880",
    0xb3cf: "Skein1024-888",
    0xb3d0: "Skein1024-896",
    0xb3d1: "Skein1024-904",
    0xb3d2: "Skein1024-912",
    0xb3d3: "Skein1024-920",
    0xb3d4: "Skein1024-928",
    0xb3d5: "Skein1024-936",
    0xb3d6: "Skein1024-944",
    0xb3d7: "Skein1024-952",
    0xb3d8: "Skein1024-960",
    0xb3d9: "Skein1024-968",
    0xb3da: "Skein1024-976",
    0xb3db: "Skein1024-984",
    0xb3dc: "Skein1024-992",
    0xb3dd: "Skein1024-1000",
    0xb3de: "Skein1024-1008",
    0xb3df: "Skein1024-1016",
    0xb3e0: "Skein1024-1024"
});
$77b6810a2f8afdac$export$6afcb0067345fd27 = Object.freeze({
    0x11: 20,
    0x12: 32,
    0x13: 64,
    0x56: 32,
    0x17: 28,
    0x16: 32,
    0x15: 48,
    0x14: 64,
    0x18: 32,
    0x19: 64,
    0x1A: 28,
    0x1B: 32,
    0x1C: 48,
    0x1D: 64,
    0x22: 32,
    0xb201: 0x01,
    0xb202: 0x02,
    0xb203: 0x03,
    0xb204: 0x04,
    0xb205: 0x05,
    0xb206: 0x06,
    0xb207: 0x07,
    0xb208: 0x08,
    0xb209: 0x09,
    0xb20a: 0x0a,
    0xb20b: 0x0b,
    0xb20c: 0x0c,
    0xb20d: 0x0d,
    0xb20e: 0x0e,
    0xb20f: 0x0f,
    0xb210: 0x10,
    0xb211: 0x11,
    0xb212: 0x12,
    0xb213: 0x13,
    0xb214: 0x14,
    0xb215: 0x15,
    0xb216: 0x16,
    0xb217: 0x17,
    0xb218: 0x18,
    0xb219: 0x19,
    0xb21a: 0x1a,
    0xb21b: 0x1b,
    0xb21c: 0x1c,
    0xb21d: 0x1d,
    0xb21e: 0x1e,
    0xb21f: 0x1f,
    0xb220: 0x20,
    0xb221: 0x21,
    0xb222: 0x22,
    0xb223: 0x23,
    0xb224: 0x24,
    0xb225: 0x25,
    0xb226: 0x26,
    0xb227: 0x27,
    0xb228: 0x28,
    0xb229: 0x29,
    0xb22a: 0x2a,
    0xb22b: 0x2b,
    0xb22c: 0x2c,
    0xb22d: 0x2d,
    0xb22e: 0x2e,
    0xb22f: 0x2f,
    0xb230: 0x30,
    0xb231: 0x31,
    0xb232: 0x32,
    0xb233: 0x33,
    0xb234: 0x34,
    0xb235: 0x35,
    0xb236: 0x36,
    0xb237: 0x37,
    0xb238: 0x38,
    0xb239: 0x39,
    0xb23a: 0x3a,
    0xb23b: 0x3b,
    0xb23c: 0x3c,
    0xb23d: 0x3d,
    0xb23e: 0x3e,
    0xb23f: 0x3f,
    0xb240: 0x40,
    0xb241: 0x01,
    0xb242: 0x02,
    0xb243: 0x03,
    0xb244: 0x04,
    0xb245: 0x05,
    0xb246: 0x06,
    0xb247: 0x07,
    0xb248: 0x08,
    0xb249: 0x09,
    0xb24a: 0x0a,
    0xb24b: 0x0b,
    0xb24c: 0x0c,
    0xb24d: 0x0d,
    0xb24e: 0x0e,
    0xb24f: 0x0f,
    0xb250: 0x10,
    0xb251: 0x11,
    0xb252: 0x12,
    0xb253: 0x13,
    0xb254: 0x14,
    0xb255: 0x15,
    0xb256: 0x16,
    0xb257: 0x17,
    0xb258: 0x18,
    0xb259: 0x19,
    0xb25a: 0x1a,
    0xb25b: 0x1b,
    0xb25c: 0x1c,
    0xb25d: 0x1d,
    0xb25e: 0x1e,
    0xb25f: 0x1f,
    0xb260: 0x20,
    0xb301: 0x01,
    0xb302: 0x02,
    0xb303: 0x03,
    0xb304: 0x04,
    0xb305: 0x05,
    0xb306: 0x06,
    0xb307: 0x07,
    0xb308: 0x08,
    0xb309: 0x09,
    0xb30a: 0x0a,
    0xb30b: 0x0b,
    0xb30c: 0x0c,
    0xb30d: 0x0d,
    0xb30e: 0x0e,
    0xb30f: 0x0f,
    0xb310: 0x10,
    0xb311: 0x11,
    0xb312: 0x12,
    0xb313: 0x13,
    0xb314: 0x14,
    0xb315: 0x15,
    0xb316: 0x16,
    0xb317: 0x17,
    0xb318: 0x18,
    0xb319: 0x19,
    0xb31a: 0x1a,
    0xb31b: 0x1b,
    0xb31c: 0x1c,
    0xb31d: 0x1d,
    0xb31e: 0x1e,
    0xb31f: 0x1f,
    0xb320: 0x20,
    0xb321: 0x01,
    0xb322: 0x02,
    0xb323: 0x03,
    0xb324: 0x04,
    0xb325: 0x05,
    0xb326: 0x06,
    0xb327: 0x07,
    0xb328: 0x08,
    0xb329: 0x09,
    0xb32a: 0x0a,
    0xb32b: 0x0b,
    0xb32c: 0x0c,
    0xb32d: 0x0d,
    0xb32e: 0x0e,
    0xb32f: 0x0f,
    0xb330: 0x10,
    0xb331: 0x11,
    0xb332: 0x12,
    0xb333: 0x13,
    0xb334: 0x14,
    0xb335: 0x15,
    0xb336: 0x16,
    0xb337: 0x17,
    0xb338: 0x18,
    0xb339: 0x19,
    0xb33a: 0x1a,
    0xb33b: 0x1b,
    0xb33c: 0x1c,
    0xb33d: 0x1d,
    0xb33e: 0x1e,
    0xb33f: 0x1f,
    0xb340: 0x20,
    0xb341: 0x21,
    0xb342: 0x22,
    0xb343: 0x23,
    0xb344: 0x24,
    0xb345: 0x25,
    0xb346: 0x26,
    0xb347: 0x27,
    0xb348: 0x28,
    0xb349: 0x29,
    0xb34a: 0x2a,
    0xb34b: 0x2b,
    0xb34c: 0x2c,
    0xb34d: 0x2d,
    0xb34e: 0x2e,
    0xb34f: 0x2f,
    0xb350: 0x30,
    0xb351: 0x31,
    0xb352: 0x32,
    0xb353: 0x33,
    0xb354: 0x34,
    0xb355: 0x35,
    0xb356: 0x36,
    0xb357: 0x37,
    0xb358: 0x38,
    0xb359: 0x39,
    0xb35a: 0x3a,
    0xb35b: 0x3b,
    0xb35c: 0x3c,
    0xb35d: 0x3d,
    0xb35e: 0x3e,
    0xb35f: 0x3f,
    0xb360: 0x40,
    0xb361: 0x01,
    0xb362: 0x02,
    0xb363: 0x03,
    0xb364: 0x04,
    0xb365: 0x05,
    0xb366: 0x06,
    0xb367: 0x07,
    0xb368: 0x08,
    0xb369: 0x09,
    0xb36a: 0x0a,
    0xb36b: 0x0b,
    0xb36c: 0x0c,
    0xb36d: 0x0d,
    0xb36e: 0x0e,
    0xb36f: 0x0f,
    0xb370: 0x10,
    0xb371: 0x11,
    0xb372: 0x12,
    0xb373: 0x13,
    0xb374: 0x14,
    0xb375: 0x15,
    0xb376: 0x16,
    0xb377: 0x17,
    0xb378: 0x18,
    0xb379: 0x19,
    0xb37a: 0x1a,
    0xb37b: 0x1b,
    0xb37c: 0x1c,
    0xb37d: 0x1d,
    0xb37e: 0x1e,
    0xb37f: 0x1f,
    0xb380: 0x20,
    0xb381: 0x21,
    0xb382: 0x22,
    0xb383: 0x23,
    0xb384: 0x24,
    0xb385: 0x25,
    0xb386: 0x26,
    0xb387: 0x27,
    0xb388: 0x28,
    0xb389: 0x29,
    0xb38a: 0x2a,
    0xb38b: 0x2b,
    0xb38c: 0x2c,
    0xb38d: 0x2d,
    0xb38e: 0x2e,
    0xb38f: 0x2f,
    0xb390: 0x30,
    0xb391: 0x31,
    0xb392: 0x32,
    0xb393: 0x33,
    0xb394: 0x34,
    0xb395: 0x35,
    0xb396: 0x36,
    0xb397: 0x37,
    0xb398: 0x38,
    0xb399: 0x39,
    0xb39a: 0x3a,
    0xb39b: 0x3b,
    0xb39c: 0x3c,
    0xb39d: 0x3d,
    0xb39e: 0x3e,
    0xb39f: 0x3f,
    0xb3a0: 0x40,
    0xb3a1: 0x41,
    0xb3a2: 0x42,
    0xb3a3: 0x43,
    0xb3a4: 0x44,
    0xb3a5: 0x45,
    0xb3a6: 0x46,
    0xb3a7: 0x47,
    0xb3a8: 0x48,
    0xb3a9: 0x49,
    0xb3aa: 0x4a,
    0xb3ab: 0x4b,
    0xb3ac: 0x4c,
    0xb3ad: 0x4d,
    0xb3ae: 0x4e,
    0xb3af: 0x4f,
    0xb3b0: 0x50,
    0xb3b1: 0x51,
    0xb3b2: 0x52,
    0xb3b3: 0x53,
    0xb3b4: 0x54,
    0xb3b5: 0x55,
    0xb3b6: 0x56,
    0xb3b7: 0x57,
    0xb3b8: 0x58,
    0xb3b9: 0x59,
    0xb3ba: 0x5a,
    0xb3bb: 0x5b,
    0xb3bc: 0x5c,
    0xb3bd: 0x5d,
    0xb3be: 0x5e,
    0xb3bf: 0x5f,
    0xb3c0: 0x60,
    0xb3c1: 0x61,
    0xb3c2: 0x62,
    0xb3c3: 0x63,
    0xb3c4: 0x64,
    0xb3c5: 0x65,
    0xb3c6: 0x66,
    0xb3c7: 0x67,
    0xb3c8: 0x68,
    0xb3c9: 0x69,
    0xb3ca: 0x6a,
    0xb3cb: 0x6b,
    0xb3cc: 0x6c,
    0xb3cd: 0x6d,
    0xb3ce: 0x6e,
    0xb3cf: 0x6f,
    0xb3d0: 0x70,
    0xb3d1: 0x71,
    0xb3d2: 0x72,
    0xb3d3: 0x73,
    0xb3d4: 0x74,
    0xb3d5: 0x75,
    0xb3d6: 0x76,
    0xb3d7: 0x77,
    0xb3d8: 0x78,
    0xb3d9: 0x79,
    0xb3da: 0x7a,
    0xb3db: 0x7b,
    0xb3dc: 0x7c,
    0xb3dd: 0x7d,
    0xb3de: 0x7e,
    0xb3df: 0x7f,
    0xb3e0: 0x80
});


$85943b908325c028$export$e4b2ac9215619f8d = $77b6810a2f8afdac$export$e4b2ac9215619f8d;
$85943b908325c028$export$e45cb6485273080e = $77b6810a2f8afdac$export$e45cb6485273080e;
$85943b908325c028$export$6afcb0067345fd27 = $77b6810a2f8afdac$export$6afcb0067345fd27;
$85943b908325c028$export$f4915efbb94d4d01 = function toHexString(hash) {
    if (!$85943b908325c028$require$Buffer.isBuffer(hash)) throw new Error("must be passed a buffer");
    return hash.toString("hex");
};
$85943b908325c028$export$99a70112ceb8327b = function fromHexString(hash) {
    return $85943b908325c028$require$Buffer.from(hash, "hex");
};
$85943b908325c028$export$6f10cd39aba42032 = function toB58String(hash) {
    if (!$85943b908325c028$require$Buffer.isBuffer(hash)) throw new Error("must be passed a buffer");
    return $8thpe.encode("base58btc", hash).toString().slice(1);
};
$85943b908325c028$export$94293751533bac2 = function fromB58String(hash) {
    let encoded = hash;
    if ($85943b908325c028$require$Buffer.isBuffer(hash)) encoded = hash.toString();
    return $8thpe.decode("z" + encoded);
};
$85943b908325c028$export$2f872c0f2117be69 = function decode(buf) {
    if (!$85943b908325c028$require$Buffer.isBuffer(buf)) throw new Error("multihash must be a Buffer");
    if (buf.length < 2) throw new Error("multihash too short. must be > 2 bytes.");
    const code = $9q7Fh.decode(buf);
    if (!$85943b908325c028$export$a5c39676d2a86af8(code)) throw new Error(`multihash unknown function code: 0x${code.toString(16)}`);
    buf = buf.slice($9q7Fh.decode.bytes);
    const len = $9q7Fh.decode(buf);
    if (len < 0) throw new Error(`multihash invalid length: ${len}`);
    buf = buf.slice($9q7Fh.decode.bytes);
    if (buf.length !== len) throw new Error(`multihash length inconsistent: 0x${buf.toString("hex")}`);
    return {
        code: code,
        name: $77b6810a2f8afdac$export$e45cb6485273080e[code],
        length: len,
        digest: buf
    };
};
$85943b908325c028$export$c564cdbbe6da493 = function encode(digest, code, length) {
    if (!digest || code === undefined) throw new Error("multihash encode requires at least two args: digest, code");
    // ensure it's a hashfunction code.
    const hashfn = $85943b908325c028$export$5c4b645cb8721bfa(code);
    if (!$85943b908325c028$require$Buffer.isBuffer(digest)) throw new Error("digest should be a Buffer");
    if (length == null) length = digest.length;
    if (length && digest.length !== length) throw new Error("digest length should be equal to specified length.");
    return $85943b908325c028$require$Buffer.concat([
        $85943b908325c028$require$Buffer.from($9q7Fh.encode(hashfn)),
        $85943b908325c028$require$Buffer.from($9q7Fh.encode(length)),
        digest
    ]);
};
$85943b908325c028$export$5c4b645cb8721bfa = function coerceCode(name) {
    let code = name;
    if (typeof name === "string") {
        if ($77b6810a2f8afdac$export$e4b2ac9215619f8d[name] === undefined) throw new Error(`Unrecognized hash function named: ${name}`);
        code = $77b6810a2f8afdac$export$e4b2ac9215619f8d[name];
    }
    if (typeof code !== "number") throw new Error(`Hash function code should be a number. Got: ${code}`);
    if ($77b6810a2f8afdac$export$e45cb6485273080e[code] === undefined && !$85943b908325c028$export$dd468b29e9e316eb(code)) throw new Error(`Unrecognized function code: ${code}`);
    return code;
};
$85943b908325c028$export$dd468b29e9e316eb = function appCode(code) {
    return code > 0 && code < 0x10;
};
$85943b908325c028$export$a5c39676d2a86af8 = function validCode(code) {
    if ($85943b908325c028$export$dd468b29e9e316eb(code)) return true;
    if ($77b6810a2f8afdac$export$e45cb6485273080e[code]) return true;
    return false;
};
/**
 * Check if the given buffer is a valid multihash. Throws an error if it is not valid.
 *
 * @param {Buffer} multihash
 * @returns {undefined}
 * @throws {Error}
 */ function $85943b908325c028$var$validate(multihash) {
    $85943b908325c028$export$2f872c0f2117be69(multihash) // throws if bad.
    ;
}
$85943b908325c028$export$a22775fa5e2eebd9 = $85943b908325c028$var$validate;
$85943b908325c028$export$82e9f45cca5ba907 = function prefix(multihash) {
    $85943b908325c028$var$validate(multihash);
    return multihash.slice(0, 2);
};



var $locRC = parcelRequire("locRC");

var $j36gA = parcelRequire("j36gA");

var $euDHO = parcelRequire("euDHO");
var $30153582f62a0ec7$exports = {};
"use strict";


var $ihoyg = parcelRequire("ihoyg");
var $30153582f62a0ec7$require$Buffer = $ihoyg.Buffer;
var $30153582f62a0ec7$var$CIDUtil = {
    /**
   * Test if the given input is a valid CID object.
   * Returns an error message if it is not.
   * Returns undefined if it is a valid CID.
   *
   * @param {any} other
   * @returns {string}
   */ checkCIDComponents: function(other) {
        if (other == null) return "null values are not valid CIDs";
        if (!(other.version === 0 || other.version === 1)) return "Invalid version, must be a number equal to 1 or 0";
        if (typeof other.codec !== "string") return "codec must be string";
        if (other.version === 0) {
            if (other.codec !== "dag-pb") return "codec must be 'dag-pb' for CIDv0";
            if (other.multibaseName !== "base58btc") return "multibaseName must be 'base58btc' for CIDv0";
        }
        if (!$30153582f62a0ec7$require$Buffer.isBuffer(other.multihash)) return "multihash must be a Buffer";
        try {
            $85943b908325c028$export$a22775fa5e2eebd9(other.multihash);
        } catch (err) {
            let errorMsg = err.message;
            if (!errorMsg) errorMsg = "Multihash validation failed";
            return errorMsg;
        }
    }
};
$30153582f62a0ec7$exports = $30153582f62a0ec7$var$CIDUtil;


var $64e4f9e2df1bae86$exports = {};
"use strict";
function $64e4f9e2df1bae86$var$withIs(Class, { className: className, symbolName: symbolName }) {
    const symbol = Symbol.for(symbolName);
    const ClassIsWrapper = {
        // The code below assigns the class wrapper to an object to trick
        // JavaScript engines to show the name of the extended class when
        // logging an instances.
        // We are assigning an anonymous class (class wrapper) to the object
        // with key `className` to keep the correct name.
        // If this is not supported it falls back to logging `ClassIsWrapper`.
        [className]: class extends Class {
            constructor(...args){
                super(...args);
                Object.defineProperty(this, symbol, {
                    value: true
                });
            }
            get [Symbol.toStringTag]() {
                return className;
            }
        }
    }[className];
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
function $64e4f9e2df1bae86$var$withIsProto(Class, { className: className, symbolName: symbolName, withoutNew: withoutNew }) {
    const symbol = Symbol.for(symbolName);
    /* eslint-disable object-shorthand */ const ClassIsWrapper = {
        [className]: function(...args) {
            if (withoutNew && !(this instanceof ClassIsWrapper)) return new ClassIsWrapper(...args);
            const _this = Class.call(this, ...args) || this;
            if (_this && !_this[symbol]) Object.defineProperty(_this, symbol, {
                value: true
            });
            return _this;
        }
    }[className];
    /* eslint-enable object-shorthand */ ClassIsWrapper.prototype = Object.create(Class.prototype);
    ClassIsWrapper.prototype.constructor = ClassIsWrapper;
    Object.defineProperty(ClassIsWrapper.prototype, Symbol.toStringTag, {
        get () {
            return className;
        }
    });
    ClassIsWrapper[`is${className}`] = (obj)=>!!(obj && obj[symbol]);
    return ClassIsWrapper;
}
$64e4f9e2df1bae86$exports = $64e4f9e2df1bae86$var$withIs;
$64e4f9e2df1bae86$exports.proto = $64e4f9e2df1bae86$var$withIsProto;


/**
 * @typedef {Object} SerializedCID
 * @param {string} codec
 * @param {number} version
 * @param {Buffer} multihash
 */ /**
 * Test if the given input is a CID.
 * @function isCID
 * @memberof CID
 * @static
 * @param {any} other
 * @returns {bool}
 */ /**
 * Class representing a CID `<mbase><version><mcodec><mhash>`
 * , as defined in [ipld/cid](https://github.com/multiformats/cid).
 * @class CID
 */ class $1932d7f4dbc3d3a4$var$CID {
    /**
   * Create a new CID.
   *
   * The algorithm for argument input is roughly:
   * ```
   * if (cid)
   *   -> create a copy
   * else if (str)
   *   if (1st char is on multibase table) -> CID String
   *   else -> bs58 encoded multihash
   * else if (Buffer)
   *   if (1st byte is 0 or 1) -> CID
   *   else -> multihash
   * else if (Number)
   *   -> construct CID by parts
   * ```
   *
   * @param {string|Buffer|CID} version
   * @param {string} [codec]
   * @param {Buffer} [multihash]
   * @param {string} [multibaseName]
   *
   * @example
   * new CID(<version>, <codec>, <multihash>, <multibaseName>)
   * new CID(<cidStr>)
   * new CID(<cid.buffer>)
   * new CID(<multihash>)
   * new CID(<bs58 encoded multihash>)
   * new CID(<cid>)
   */ constructor(version, codec, multihash, multibaseName){
        if ($1932d7f4dbc3d3a4$var$_CID.isCID(version)) {
            // version is an exising CID instance
            const cid = version;
            this.version = cid.version;
            this.codec = cid.codec;
            this.multihash = $1932d7f4dbc3d3a4$require$Buffer.from(cid.multihash);
            // Default guard for when a CID < 0.7 is passed with no multibaseName
            this.multibaseName = cid.multibaseName || (cid.version === 0 ? "base58btc" : "base32");
            return;
        }
        if (typeof version === "string") {
            // e.g. 'base32' or false
            const baseName = $locRC.isEncoded(version);
            if (baseName) {
                // version is a CID String encoded with multibase, so v1
                const cid = $locRC.decode(version);
                this.version = parseInt(cid.slice(0, 1).toString("hex"), 16);
                this.codec = $j36gA.getCodec(cid.slice(1));
                this.multihash = $j36gA.rmPrefix(cid.slice(1));
                this.multibaseName = baseName;
            } else {
                // version is a base58btc string multihash, so v0
                this.version = 0;
                this.codec = "dag-pb";
                this.multihash = $85943b908325c028$export$94293751533bac2(version);
                this.multibaseName = "base58btc";
            }
            $1932d7f4dbc3d3a4$var$CID.validateCID(this);
            Object.defineProperty(this, "string", {
                value: version
            });
            return;
        }
        if ($1932d7f4dbc3d3a4$require$Buffer.isBuffer(version)) {
            const firstByte = version.slice(0, 1);
            const v = parseInt(firstByte.toString("hex"), 16);
            if (v === 1) {
                // version is a CID buffer
                const cid = version;
                this.version = v;
                this.codec = $j36gA.getCodec(cid.slice(1));
                this.multihash = $j36gA.rmPrefix(cid.slice(1));
                this.multibaseName = "base32";
            } else {
                // version is a raw multihash buffer, so v0
                this.version = 0;
                this.codec = "dag-pb";
                this.multihash = version;
                this.multibaseName = "base58btc";
            }
            $1932d7f4dbc3d3a4$var$CID.validateCID(this);
            return;
        }
        // otherwise, assemble the CID from the parameters
        /**
     * @type {number}
     */ this.version = version;
        /**
     * @type {string}
     */ this.codec = codec;
        /**
     * @type {Buffer}
     */ this.multihash = multihash;
        /**
     * @type {string}
     */ this.multibaseName = multibaseName || (version === 0 ? "base58btc" : "base32");
        $1932d7f4dbc3d3a4$var$CID.validateCID(this);
    }
    /**
   * The CID as a `Buffer`
   *
   * @return {Buffer}
   * @readonly
   *
   * @memberOf CID
   */ get buffer() {
        let buffer = this._buffer;
        if (!buffer) {
            if (this.version === 0) buffer = this.multihash;
            else if (this.version === 1) buffer = $1932d7f4dbc3d3a4$require$Buffer.concat([
                $1932d7f4dbc3d3a4$require$Buffer.from("01", "hex"),
                $j36gA.getCodeVarint(this.codec),
                this.multihash
            ]);
            else throw new Error("unsupported version");
            // Cache this buffer so it doesn't have to be recreated
            Object.defineProperty(this, "_buffer", {
                value: buffer
            });
        }
        return buffer;
    }
    /**
   * Get the prefix of the CID.
   *
   * @returns {Buffer}
   * @readonly
   */ get prefix() {
        return $1932d7f4dbc3d3a4$require$Buffer.concat([
            $1932d7f4dbc3d3a4$require$Buffer.from(`0${this.version}`, "hex"),
            $j36gA.getCodeVarint(this.codec),
            $85943b908325c028$export$82e9f45cca5ba907(this.multihash)
        ]);
    }
    /**
   * Convert to a CID of version `0`.
   *
   * @returns {CID}
   */ toV0() {
        if (this.codec !== "dag-pb") throw new Error("Cannot convert a non dag-pb CID to CIDv0");
        const { name: name, length: length } = $85943b908325c028$export$2f872c0f2117be69(this.multihash);
        if (name !== "sha2-256") throw new Error("Cannot convert non sha2-256 multihash CID to CIDv0");
        if (length !== 32) throw new Error("Cannot convert non 32 byte multihash CID to CIDv0");
        return new $1932d7f4dbc3d3a4$var$_CID(0, this.codec, this.multihash);
    }
    /**
   * Convert to a CID of version `1`.
   *
   * @returns {CID}
   */ toV1() {
        return new $1932d7f4dbc3d3a4$var$_CID(1, this.codec, this.multihash);
    }
    /**
   * Encode the CID into a string.
   *
   * @param {string} [base=this.multibaseName] - Base encoding to use.
   * @returns {string}
   */ toBaseEncodedString(base = this.multibaseName) {
        if (this.string && base === this.multibaseName) return this.string;
        let str = null;
        if (this.version === 0) {
            if (base !== "base58btc") throw new Error("not supported with CIDv0, to support different bases, please migrate the instance do CIDv1, you can do that through cid.toV1()");
            str = $85943b908325c028$export$6f10cd39aba42032(this.multihash);
        } else if (this.version === 1) str = $locRC.encode(base, this.buffer).toString();
        else throw new Error("unsupported version");
        if (base === this.multibaseName) // cache the string value
        Object.defineProperty(this, "string", {
            value: str
        });
        return str;
    }
    /**
   * CID(QmdfTbBqBPQ7VNxZEYEj14VmRuZBkqFbiwReogJgS1zR1n)
   *
   * @returns {String}
   */ [Symbol.for("nodejs.util.inspect.custom")]() {
        return "CID(" + this.toString() + ")";
    }
    toString(base) {
        return this.toBaseEncodedString(base);
    }
    /**
   * Serialize to a plain object.
   *
   * @returns {SerializedCID}
   */ toJSON() {
        return {
            codec: this.codec,
            version: this.version,
            hash: this.multihash
        };
    }
    /**
   * Compare equality with another CID.
   *
   * @param {CID} other
   * @returns {bool}
   */ equals(other) {
        return this.codec === other.codec && this.version === other.version && this.multihash.equals(other.multihash);
    }
    /**
   * Test if the given input is a valid CID object.
   * Throws if it is not.
   *
   * @param {any} other
   * @returns {void}
   */ static validateCID(other) {
        const errorMsg = $30153582f62a0ec7$exports.checkCIDComponents(other);
        if (errorMsg) throw new Error(errorMsg);
    }
}
const $1932d7f4dbc3d3a4$var$_CID = $64e4f9e2df1bae86$exports($1932d7f4dbc3d3a4$var$CID, {
    className: "CID",
    symbolName: "@ipld/js-cid/CID"
});
$1932d7f4dbc3d3a4$var$_CID.codecs = $euDHO;
$1932d7f4dbc3d3a4$exports = $1932d7f4dbc3d3a4$var$_CID;



/**
 * Convert an hexadecimal string to a Buffer, the string can start with or without '0x'
 * @param {string} hex an hexadecimal value
 * @return {Buffer} the resulting Buffer
 */ const $adad6c2a32ffa238$var$hexStringToBuffer = (hex)=>{
    let prefix = hex.slice(0, 2);
    let value = hex.slice(2);
    let res = "";
    if (prefix === "0x") res = value;
    else res = hex;
    return $85943b908325c028$export$99a70112ceb8327b(res);
};
/**
* list of known encoding,
* encoding should be a function that takes a `string` input,
* and return a `Buffer` result
*/ const $adad6c2a32ffa238$var$encodes = {
    /**
  * @param {string} value
  * @return {Buffer}
  */ swarm: (value)=>{
        const multihash = $85943b908325c028$export$c564cdbbe6da493($adad6c2a32ffa238$var$hexStringToBuffer(value), "keccak-256");
        return new $1932d7f4dbc3d3a4$exports(1, "swarm-manifest", multihash).buffer;
    },
    /**
  * @param {string} value
  * @return {Buffer}
  */ ipfs: (value)=>{
        const multihash = $85943b908325c028$export$94293751533bac2(value);
        return new $1932d7f4dbc3d3a4$exports(1, "dag-pb", multihash).buffer;
    },
    /**
  * @param {string} value
  * @return {Buffer}
  */ utf8: (value)=>{
        return $adad6c2a32ffa238$require$Buffer.from(value, "utf8");
    }
};
/** 
* list of known decoding,
* decoding should be a function that takes a `Buffer` input,
* and return a `string` result
*/ const $adad6c2a32ffa238$var$decodes = {
    /**
  * @param {Buffer} value 
  */ hexMultiHash: (value)=>{
        const cid = new $1932d7f4dbc3d3a4$exports(value);
        return $85943b908325c028$export$2f872c0f2117be69(cid.multihash).digest.toString("hex");
    },
    /**
  * @param {Buffer} value 
  */ b58MultiHash: (value)=>{
        const cid = new $1932d7f4dbc3d3a4$exports(value);
        return $85943b908325c028$export$6f10cd39aba42032(cid.multihash);
    },
    /**
  * @param {Buffer} value 
  */ utf8: (value)=>{
        return value.toString("utf8");
    }
};
/**
* list of known encoding/decoding for a given codec,
* `encode` should be chosen among the `encodes` functions
* `decode` should be chosen among the `decodes` functions
*/ const $adad6c2a32ffa238$var$profiles = {
    "swarm-ns": {
        encode: $adad6c2a32ffa238$var$encodes.swarm,
        decode: $adad6c2a32ffa238$var$decodes.hexMultiHash
    },
    "ipfs-ns": {
        encode: $adad6c2a32ffa238$var$encodes.ipfs,
        decode: $adad6c2a32ffa238$var$decodes.b58MultiHash
    },
    "ipns-ns": {
        encode: $adad6c2a32ffa238$var$encodes.ipfs,
        decode: $adad6c2a32ffa238$var$decodes.b58MultiHash
    },
    "default": {
        encode: $adad6c2a32ffa238$var$encodes.utf8,
        decode: $adad6c2a32ffa238$var$decodes.utf8
    }
};
$adad6c2a32ffa238$export$83238ff569ad9e94 = $adad6c2a32ffa238$var$hexStringToBuffer;
$adad6c2a32ffa238$export$63dc120dff6c5db8 = $adad6c2a32ffa238$var$profiles;


var $5062c82da900e7f1$require$hexStringToBuffer = $adad6c2a32ffa238$export$83238ff569ad9e94;
var $5062c82da900e7f1$require$profiles = $adad6c2a32ffa238$export$63dc120dff6c5db8;
/*
	ISC License

	Copyright (c) 2019, Pierre-Louis Despaigne

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted, provided that the above
	copyright notice and this permission notice appear in all copies.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
	WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
	MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
	ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
	WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
	ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
	OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/ var $aa0de2254332f421$export$842ca2baf3158eb4;

/**
 * Take any ipfsHash and convert it to a CID v1 encoded in base32.
 * @param {string} ipfsHash a regular ipfs hash either a cid v0 or v1 (v1 will remain unchanged)
 * @return {string} the resulting ipfs hash as a cid v1
 */ const $aa0de2254332f421$var$cidV0ToV1Base32 = (ipfsHash)=>{
    let cid = new $1932d7f4dbc3d3a4$exports(ipfsHash);
    if (cid.version === 0) cid = cid.toV1();
    return cid.toString("base32");
};
$aa0de2254332f421$export$842ca2baf3158eb4 = $aa0de2254332f421$var$cidV0ToV1Base32;


var $5062c82da900e7f1$require$cidV0ToV1Base32 = $aa0de2254332f421$export$842ca2baf3158eb4;
$5062c82da900e7f1$exports = {
    //export some helpers functions
    helpers: {
        cidV0ToV1Base32: $5062c82da900e7f1$require$cidV0ToV1Base32
    },
    /**
	* Decode a Content Hash.
	* @param {string} hash an hex string containing a content hash
	* @return {string} the decoded content
	*/ decode: function(contentHash) {
        const buffer = $5062c82da900e7f1$require$hexStringToBuffer(contentHash);
        const codec = $g2JpA.getCodec(buffer);
        const value = $g2JpA.rmPrefix(buffer);
        let profile = $5062c82da900e7f1$require$profiles[codec];
        if (!profile) profile = $5062c82da900e7f1$require$profiles["default"];
        return profile.decode(value);
    },
    /**
	* Encode an IPFS address into a content hash
	* @param {string} ipfsHash string containing an IPFS address
	* @return {string} the resulting content hash
	*/ fromIpfs: function(ipfsHash) {
        return this.encode("ipfs-ns", ipfsHash);
    },
    /**
	* Encode a Swarm address into a content hash
	* @param {string} swarmHash string containing a Swarm address
	* @return {string} the resulting content hash
	*/ fromSwarm: function(swarmHash) {
        return this.encode("swarm-ns", swarmHash);
    },
    /**
	* General purpose encoding function
  * @param {string} codec 
  * @param {string} value 
  */ encode: function(codec, value) {
        let profile = $5062c82da900e7f1$require$profiles[codec];
        if (!profile) profile = $5062c82da900e7f1$require$profiles["default"];
        const encodedValue = profile.encode(value);
        return $g2JpA.addPrefix(codec, encodedValue).toString("hex");
    },
    /**
	* Extract the codec of a content hash
	* @param {string} hash hex string containing a content hash
	* @return {string} the extracted codec
	*/ getCodec: function(hash) {
        let buffer = $5062c82da900e7f1$require$hexStringToBuffer(hash);
        return $g2JpA.getCodec(buffer);
    }
};


function $2e393b7dc35fd78d$var$decode(encoded) {
    var decoded = null;
    var protocolType = null;
    var error = null;
    if (encoded && encoded.error) return {
        protocolType: null,
        decoded: encoded.error
    };
    if (encoded) try {
        decoded = $5062c82da900e7f1$exports.decode(encoded);
        var codec = $5062c82da900e7f1$exports.getCodec(encoded);
        if (codec === "ipfs-ns") protocolType = "ipfs";
        else if (codec === "swarm-ns") protocolType = "bzz";
        else if (codec === "onion") protocolType = "onion";
        else if (codec === "onion3") protocolType = "onion3";
        else decoded = encoded;
    } catch (e) {
        error = e.message;
    }
    return {
        protocolType: protocolType,
        decoded: decoded,
        error: error
    };
}
function $2e393b7dc35fd78d$var$encode(text) {
    var content, contentType;
    var encoded = false;
    if (!!text) {
        var matched = text.match(/^(ipfs|bzz|onion|onion3):\/\/(.*)/) || text.match(/\/(ipfs)\/(.*)/);
        if (matched) {
            contentType = matched[1];
            content = matched[2];
        }
        try {
            if (contentType === "ipfs") {
                if (content.length >= 4) encoded = "0x" + $5062c82da900e7f1$exports.fromIpfs(content);
            } else if (contentType === "bzz") {
                if (content.length >= 4) encoded = "0x" + $5062c82da900e7f1$exports.fromSwarm(content);
            } else if (contentType === "onion") {
                if (content.length === 16) encoded = "0x" + $5062c82da900e7f1$exports.encode("onion", content);
            } else if (contentType === "onion3") {
                if (content.length === 56) encoded = "0x" + $5062c82da900e7f1$exports.encode("onion3", content);
            } else throw new Error("Could not encode content hash: unsupported content type");
        } catch (err) {
            throw err;
        }
    }
    return encoded;
}
$2e393b7dc35fd78d$exports = {
    decode: $2e393b7dc35fd78d$var$decode,
    encode: $2e393b7dc35fd78d$var$encode
};


/**
 * Constructs a new instance of ENS
 *
 * @param {Eth} eth
 *
 * @constructor
 */ function $ec93c44aec9e47ce$var$ENS(eth) {
    this.eth = eth;
    var registryAddress = null;
    this._detectedAddress = null;
    this._lastSyncCheck = null;
    Object.defineProperty(this, "registry", {
        get: function() {
            return new $63c7915f18ef7036$exports(this);
        },
        enumerable: true
    });
    Object.defineProperty(this, "resolverMethodHandler", {
        get: function() {
            return new $cbe6383f35211b3b$exports(this.registry);
        },
        enumerable: true
    });
    Object.defineProperty(this, "registryAddress", {
        get: function() {
            return registryAddress;
        },
        set: function(value) {
            if (value === null) {
                registryAddress = value;
                return;
            }
            registryAddress = $ec93c44aec9e47ce$require$formatters.inputAddressFormatter(value);
        },
        enumerable: true
    });
}
/**
 * Returns true if the given interfaceId is supported and otherwise false.
 *
 * @method supportsInterface
 *
 * @param {string} name
 * @param {string} interfaceId
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.supportsInterface = function(name, interfaceId, callback) {
    return this.getResolver(name).then(function(resolver) {
        if (!$hpg7W.isHexStrict(interfaceId)) interfaceId = $hpg7W.sha3(interfaceId).slice(0, 10);
        return resolver.methods.supportsInterface(interfaceId).call(callback);
    }).catch(function(error) {
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        throw error;
    });
};
/**
 * Returns the Resolver by the given address
 *
 * @deprecated Please use the "getResolver" method instead of "resolver"
 *
 * @method resolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.resolver = function(name, callback) {
    return this.registry.resolver(name, callback);
};
/**
 * Returns the Resolver by the given address
 *
 * @method getResolver
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<Contract>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getResolver = function(name, callback) {
    return this.registry.getResolver(name, callback);
};
/**
 * Does set the resolver of the given name
 *
 * @method setResolver
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setResolver = function(name, address, txConfig, callback) {
    return this.registry.setResolver(name, address, txConfig, callback);
};
/**
 * Sets the owner, resolver, and TTL for an ENS record in a single operation.
 *
 * @method setRecord
 *
 * @param {string} name
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setRecord = function(name, owner, resolver, ttl, txConfig, callback) {
    return this.registry.setRecord(name, owner, resolver, ttl, txConfig, callback);
};
/**
 * Sets the owner, resolver and TTL for a subdomain, creating it if necessary.
 *
 * @method setSubnodeRecord
 *
 * @param {string} name
 * @param {string} label
 * @param {string} owner
 * @param {string} resolver
 * @param {string | number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setSubnodeRecord = function(name, label, owner, resolver, ttl, txConfig, callback) {
    return this.registry.setSubnodeRecord(name, label, owner, resolver, ttl, txConfig, callback);
};
/**
 * Sets or clears an approval by the given operator.
 *
 * @method setApprovalForAll
 *
 * @param {string} operator
 * @param {boolean} approved
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setApprovalForAll = function(operator, approved, txConfig, callback) {
    return this.registry.setApprovalForAll(operator, approved, txConfig, callback);
};
/**
 * Returns true if the operator is approved
 *
 * @method isApprovedForAll
 *
 * @param {string} owner
 * @param {string} operator
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.isApprovedForAll = function(owner, operator, callback) {
    return this.registry.isApprovedForAll(owner, operator, callback);
};
/**
 * Returns true if the record exists
 *
 * @method recordExists
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {Promise<boolean>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.recordExists = function(name, callback) {
    return this.registry.recordExists(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setSubnodeOwner
 *
 * @param {string} name
 * @param {string} label
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setSubnodeOwner = function(name, label, address, txConfig, callback) {
    return this.registry.setSubnodeOwner(name, label, address, txConfig, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method getTTL
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getTTL = function(name, callback) {
    return this.registry.getTTL(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setTTL
 *
 * @param {string} name
 * @param {number} ttl
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setTTL = function(name, ttl, txConfig, callback) {
    return this.registry.setTTL(name, ttl, txConfig, callback);
};
/**
 * Returns the owner by the given name and current configured or detected Registry
 *
 * @method getOwner
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getOwner = function(name, callback) {
    return this.registry.getOwner(name, callback);
};
/**
 * Returns the address of the owner of an ENS name.
 *
 * @method setOwner
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setOwner = function(name, address, txConfig, callback) {
    return this.registry.setOwner(name, address, txConfig, callback);
};
/**
 * Returns the address record associated with a name.
 *
 * @method getAddress
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getAddress = function(name, callback) {
    return this.resolverMethodHandler.method(name, "addr", []).call(callback);
};
/**
 * Sets a new address
 *
 * @method setAddress
 *
 * @param {string} name
 * @param {string} address
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setAddress = function(name, address, txConfig, callback) {
    return this.resolverMethodHandler.method(name, "setAddr", [
        address
    ]).send(txConfig, callback);
};
/**
 * Returns the public key
 *
 * @method getPubkey
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getPubkey = function(name, callback) {
    return this.resolverMethodHandler.method(name, "pubkey", [], null, callback).call(callback);
};
/**
 * Set the new public key
 *
 * @method setPubkey
 *
 * @param {string} name
 * @param {string} x
 * @param {string} y
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setPubkey = function(name, x, y, txConfig, callback) {
    return this.resolverMethodHandler.method(name, "setPubkey", [
        x,
        y
    ]).send(txConfig, callback);
};
/**
 * Returns the content
 *
 * @method getContent
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getContent = function(name, callback) {
    return this.resolverMethodHandler.method(name, "content", []).call(callback);
};
/**
 * Set the content
 *
 * @method setContent
 *
 * @param {string} name
 * @param {string} hash
 * @param {function} callback
 * @param {TransactionConfig} txConfig
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setContent = function(name, hash, txConfig, callback) {
    return this.resolverMethodHandler.method(name, "setContent", [
        hash
    ]).send(txConfig, callback);
};
/**
 * Returns the contenthash
 *
 * @method getContenthash
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<ContentHash>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getContenthash = function(name, callback) {
    return this.resolverMethodHandler.method(name, "contenthash", [], $2e393b7dc35fd78d$exports.decode).call(callback);
};
/**
 * Set the contenthash
 *
 * @method setContent
 *
 * @param {string} name
 * @param {string} hash
 * @param {function} callback
 * @param {TransactionConfig} txConfig
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setContenthash = function(name, hash, txConfig, callback) {
    var encoded;
    try {
        encoded = $2e393b7dc35fd78d$exports.encode(hash);
    } catch (err) {
        var error = new Error("Could not encode " + hash + ". See docs for supported hash protocols.");
        if (typeof callback === "function") {
            callback(error, null);
            return;
        }
        throw error;
    }
    return this.resolverMethodHandler.method(name, "setContenthash", [
        encoded
    ]).send(txConfig, callback);
};
/**
 * Get the multihash
 *
 * @method getMultihash
 *
 * @param {string} name
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.getMultihash = function(name, callback) {
    return this.resolverMethodHandler.method(name, "multihash", []).call(callback);
};
/**
 * Set the multihash
 *
 * @method setMultihash
 *
 * @param {string} name
 * @param {string} hash
 * @param {TransactionConfig} txConfig
 * @param {function} callback
 *
 * @callback callback callback(error, result)
 * @returns {PromiEvent<TransactionReceipt | TransactionRevertInstructionError>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.setMultihash = function(name, hash, txConfig, callback) {
    return this.resolverMethodHandler.method(name, "multihash", [
        hash
    ]).send(txConfig, callback);
};
/**
 * Checks if the current used network is synced and looks for ENS support there.
 * Throws an error if not.
 *
 * @returns {Promise<string>}
 */ $ec93c44aec9e47ce$var$ENS.prototype.checkNetwork = async function() {
    var now = new Date() / 1000;
    if (!this._lastSyncCheck || now - this._lastSyncCheck > 3600) {
        var block = await this.eth.getBlock("latest");
        var headAge = now - block.timestamp;
        if (headAge > 3600) throw new Error("Network not synced; last block was " + headAge + " seconds ago");
        this._lastSyncCheck = now;
    }
    if (this.registryAddress) return this.registryAddress;
    if (!this._detectedAddress) {
        var networkType = await this.eth.net.getNetworkType();
        var addr = $fc7a4943d74a91eb$exports.addresses[networkType];
        if (typeof addr === "undefined") throw new Error("ENS is not supported on network " + networkType);
        this._detectedAddress = addr;
        return this._detectedAddress;
    }
    return this._detectedAddress;
};
$ec93c44aec9e47ce$exports = $ec93c44aec9e47ce$var$ENS;


$6c47817db8eaa99b$exports = $ec93c44aec9e47ce$exports;


var $a2b78c5f45c1e37f$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";



var $hpg7W = parcelRequire("hpg7W");


var $heyrh = parcelRequire("heyrh");
var $a2b78c5f45c1e37f$require$formatters = $heyrh.formatters;
var $a2b78c5f45c1e37f$var$Personal = function Personal() {
    var _this = this;
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    this.net = new $db630ee0260f83ef$exports(this);
    var defaultAccount = null;
    var defaultBlock = "latest";
    Object.defineProperty(this, "defaultAccount", {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $hpg7W.toChecksumAddress($a2b78c5f45c1e37f$require$formatters.inputAddressFormatter(val));
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultAccount = defaultAccount;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultBlock", {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultBlock = defaultBlock;
            });
            return val;
        },
        enumerable: true
    });
    var methods = [
        new $60ff6d2aea0ffa29$exports({
            name: "getAccounts",
            call: "personal_listAccounts",
            params: 0,
            outputFormatter: $hpg7W.toChecksumAddress
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "newAccount",
            call: "personal_newAccount",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $hpg7W.toChecksumAddress
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "unlockAccount",
            call: "personal_unlockAccount",
            params: 3,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputAddressFormatter,
                null,
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "lockAccount",
            call: "personal_lockAccount",
            params: 1,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputAddressFormatter
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "importRawKey",
            call: "personal_importRawKey",
            params: 2
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "sendTransaction",
            call: "personal_sendTransaction",
            params: 2,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputTransactionFormatter,
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "signTransaction",
            call: "personal_signTransaction",
            params: 2,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputTransactionFormatter,
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "sign",
            call: "personal_sign",
            params: 3,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputSignFormatter,
                $a2b78c5f45c1e37f$require$formatters.inputAddressFormatter,
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "ecRecover",
            call: "personal_ecRecover",
            params: 2,
            inputFormatter: [
                $a2b78c5f45c1e37f$require$formatters.inputSignFormatter,
                null
            ]
        })
    ];
    methods.forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
        method.defaultBlock = _this.defaultBlock;
        method.defaultAccount = _this.defaultAccount;
    });
};
$c0d140841aa0e2a6$exports.addProviders($a2b78c5f45c1e37f$var$Personal);
$a2b78c5f45c1e37f$exports = $a2b78c5f45c1e37f$var$Personal;




var $j6ZZu = parcelRequire("j6ZZu");
var $2bd241c3a96c6a82$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file accounts.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ 
var $ihoyg = parcelRequire("ihoyg");
var $2bd241c3a96c6a82$require$Buffer = $ihoyg.Buffer;
"use strict";


var $910e2b5726b399b4$exports = {};

var $ihoyg = parcelRequire("ihoyg");
var $910e2b5726b399b4$require$Buffer = $ihoyg.Buffer;
var $d05a945c84ae6b55$exports = {};
var $bfaae824d0be58a7$exports = {};
const $bfaae824d0be58a7$var$generate = (num, fn)=>{
    let a = [];
    for(var i = 0; i < num; ++i)a.push(fn(i));
    return a;
};
const $bfaae824d0be58a7$var$replicate = (num, val)=>$bfaae824d0be58a7$var$generate(num, ()=>val);
const $bfaae824d0be58a7$var$concat = (a, b)=>a.concat(b);
const $bfaae824d0be58a7$var$flatten = (a)=>{
    let r = [];
    for(let j = 0, J = a.length; j < J; ++j)for(let i = 0, I = a[j].length; i < I; ++i)r.push(a[j][i]);
    return r;
};
const $bfaae824d0be58a7$var$chunksOf = (n, a)=>{
    let b = [];
    for(let i = 0, l = a.length; i < l; i += n)b.push(a.slice(i, i + n));
    return b;
};
$bfaae824d0be58a7$exports = {
    generate: $bfaae824d0be58a7$var$generate,
    replicate: $bfaae824d0be58a7$var$replicate,
    concat: $bfaae824d0be58a7$var$concat,
    flatten: $bfaae824d0be58a7$var$flatten,
    chunksOf: $bfaae824d0be58a7$var$chunksOf
};


const $d05a945c84ae6b55$var$at = (bytes, index)=>parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);

const $d05a945c84ae6b55$var$random = (bytes)=>{
    let rnd;
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));
    else rnd = (parcelRequire("aO8Ot")).randomBytes(bytes);
    let hex = "0x";
    for(let i = 0; i < bytes; ++i)hex += ("00" + rnd[i].toString(16)).slice(-2);
    return hex;
};
const $d05a945c84ae6b55$var$length = (a)=>(a.length - 2) / 2;
const $d05a945c84ae6b55$var$flatten = (a)=>"0x" + a.reduce((r, s)=>r + s.slice(2), "");
const $d05a945c84ae6b55$var$slice = (i, j, bs)=>"0x" + bs.slice(i * 2 + 2, j * 2 + 2);
const $d05a945c84ae6b55$var$reverse = (hex)=>{
    let rev = "0x";
    for(let i = 0, l = $d05a945c84ae6b55$var$length(hex); i < l; ++i)rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
    return rev;
};
const $d05a945c84ae6b55$var$pad = (l, hex)=>hex.length === l * 2 + 2 ? hex : $d05a945c84ae6b55$var$pad(l, "0x0" + hex.slice(2));
const $d05a945c84ae6b55$var$padRight = (l, hex)=>hex.length === l * 2 + 2 ? hex : $d05a945c84ae6b55$var$padRight(l, hex + "0");
const $d05a945c84ae6b55$var$toArray = (hex)=>{
    let arr = [];
    for(let i = 2, l = hex.length; i < l; i += 2)arr.push(parseInt(hex.slice(i, i + 2), 16));
    return arr;
};
const $d05a945c84ae6b55$var$fromArray = (arr)=>{
    let hex = "0x";
    for(let i = 0, l = arr.length; i < l; ++i){
        let b = arr[i];
        hex += (b < 16 ? "0" : "") + b.toString(16);
    }
    return hex;
};
const $d05a945c84ae6b55$var$toUint8Array = (hex)=>new Uint8Array($d05a945c84ae6b55$var$toArray(hex));
const $d05a945c84ae6b55$var$fromUint8Array = (arr)=>$d05a945c84ae6b55$var$fromArray([].slice.call(arr, 0));
const $d05a945c84ae6b55$var$fromNumber = (num)=>{
    let hex = num.toString(16);
    return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
};
const $d05a945c84ae6b55$var$toNumber = (hex)=>parseInt(hex.slice(2), 16);
const $d05a945c84ae6b55$var$concat = (a, b)=>a.concat(b.slice(2));
const $d05a945c84ae6b55$var$fromNat = (bn)=>bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
const $d05a945c84ae6b55$var$toNat = (bn)=>bn[2] === "0" ? "0x" + bn.slice(3) : bn;
const $d05a945c84ae6b55$var$fromAscii = (ascii)=>{
    let hex = "0x";
    for(let i = 0; i < ascii.length; ++i)hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
    return hex;
};
const $d05a945c84ae6b55$var$toAscii = (hex)=>{
    let ascii = "";
    for(let i = 2; i < hex.length; i += 2)ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
    return ascii;
};
// From https://gist.github.com/pascaldekloe/62546103a1576803dade9269ccf76330
const $d05a945c84ae6b55$var$fromString = (s)=>{
    const makeByte = (uint8)=>{
        const b = uint8.toString(16);
        return b.length < 2 ? "0" + b : b;
    };
    let bytes = "0x";
    for(let ci = 0; ci != s.length; ci++){
        let c = s.charCodeAt(ci);
        if (c < 128) {
            bytes += makeByte(c);
            continue;
        }
        if (c < 2048) bytes += makeByte(c >> 6 | 192);
        else {
            if (c > 0xd7ff && c < 0xdc00) {
                if (++ci == s.length) return null;
                let c2 = s.charCodeAt(ci);
                if (c2 < 0xdc00 || c2 > 0xdfff) return null;
                c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                bytes += makeByte(c >> 18 | 240);
                bytes += makeByte(c >> 12 & 63 | 128);
            } else // c <= 0xffff
            bytes += makeByte(c >> 12 | 224);
            bytes += makeByte(c >> 6 & 63 | 128);
        }
        bytes += makeByte(c & 63 | 128);
    }
    return bytes;
};
const $d05a945c84ae6b55$var$toString = (bytes)=>{
    let s = "";
    let i = 0;
    let l = $d05a945c84ae6b55$var$length(bytes);
    while(i < l){
        let c = $d05a945c84ae6b55$var$at(bytes, i++);
        if (c > 127) {
            if (c > 191 && c < 224) {
                if (i >= l) return null;
                c = (c & 31) << 6 | $d05a945c84ae6b55$var$at(bytes, i) & 63;
            } else if (c > 223 && c < 240) {
                if (i + 1 >= l) return null;
                c = (c & 15) << 12 | ($d05a945c84ae6b55$var$at(bytes, i) & 63) << 6 | $d05a945c84ae6b55$var$at(bytes, ++i) & 63;
            } else if (c > 239 && c < 248) {
                if (i + 2 >= l) return null;
                c = (c & 7) << 18 | ($d05a945c84ae6b55$var$at(bytes, i) & 63) << 12 | ($d05a945c84ae6b55$var$at(bytes, ++i) & 63) << 6 | $d05a945c84ae6b55$var$at(bytes, ++i) & 63;
            } else return null;
            ++i;
        }
        if (c <= 0xffff) s += String.fromCharCode(c);
        else if (c <= 0x10ffff) {
            c -= 0x10000;
            s += String.fromCharCode(c >> 10 | 0xd800);
            s += String.fromCharCode(c & 0x3FF | 0xdc00);
        } else return null;
    }
    return s;
};
$d05a945c84ae6b55$exports = {
    random: $d05a945c84ae6b55$var$random,
    length: $d05a945c84ae6b55$var$length,
    concat: $d05a945c84ae6b55$var$concat,
    flatten: $d05a945c84ae6b55$var$flatten,
    slice: $d05a945c84ae6b55$var$slice,
    reverse: $d05a945c84ae6b55$var$reverse,
    pad: $d05a945c84ae6b55$var$pad,
    padRight: $d05a945c84ae6b55$var$padRight,
    fromAscii: $d05a945c84ae6b55$var$fromAscii,
    toAscii: $d05a945c84ae6b55$var$toAscii,
    fromString: $d05a945c84ae6b55$var$fromString,
    toString: $d05a945c84ae6b55$var$toString,
    fromNumber: $d05a945c84ae6b55$var$fromNumber,
    toNumber: $d05a945c84ae6b55$var$toNumber,
    fromNat: $d05a945c84ae6b55$var$fromNat,
    toNat: $d05a945c84ae6b55$var$toNat,
    fromArray: $d05a945c84ae6b55$var$fromArray,
    toArray: $d05a945c84ae6b55$var$toArray,
    fromUint8Array: $d05a945c84ae6b55$var$fromUint8Array,
    toUint8Array: $d05a945c84ae6b55$var$toUint8Array
};


var $52d2c0697e0742f9$exports = {};

var $7vYz3 = parcelRequire("7vYz3");

const $52d2c0697e0742f9$var$fromBN = (bn)=>"0x" + bn.toString("hex");
const $52d2c0697e0742f9$var$toBN = (str)=>new $7vYz3(str.slice(2), 16);
const $52d2c0697e0742f9$var$fromString = (str)=>{
    const bn = "0x" + (str.slice(0, 2) === "0x" ? new $7vYz3(str.slice(2), 16) : new $7vYz3(str, 10)).toString("hex");
    return bn === "0x0" ? "0x" : bn;
};
const $52d2c0697e0742f9$var$toEther = (wei)=>$52d2c0697e0742f9$var$toNumber($52d2c0697e0742f9$var$div(wei, $52d2c0697e0742f9$var$fromString("10000000000"))) / 100000000;
const $52d2c0697e0742f9$var$fromEther = (eth)=>$52d2c0697e0742f9$var$mul($52d2c0697e0742f9$var$fromNumber(Math.floor(eth * 100000000)), $52d2c0697e0742f9$var$fromString("10000000000"));
const $52d2c0697e0742f9$var$toString = (a)=>$52d2c0697e0742f9$var$toBN(a).toString(10);
const $52d2c0697e0742f9$var$fromNumber = (a)=>typeof a === "string" ? /^0x/.test(a) ? a : "0x" + a : "0x" + new $7vYz3(a).toString("hex");
const $52d2c0697e0742f9$var$toNumber = (a)=>$52d2c0697e0742f9$var$toBN(a).toNumber();
const $52d2c0697e0742f9$var$toUint256 = (a)=>$d05a945c84ae6b55$exports.pad(32, a);
const $52d2c0697e0742f9$var$bin = (method)=>(a, b)=>$52d2c0697e0742f9$var$fromBN($52d2c0697e0742f9$var$toBN(a)[method]($52d2c0697e0742f9$var$toBN(b)));
const $52d2c0697e0742f9$var$add = $52d2c0697e0742f9$var$bin("add");
const $52d2c0697e0742f9$var$mul = $52d2c0697e0742f9$var$bin("mul");
const $52d2c0697e0742f9$var$div = $52d2c0697e0742f9$var$bin("div");
const $52d2c0697e0742f9$var$sub = $52d2c0697e0742f9$var$bin("sub");
$52d2c0697e0742f9$exports = {
    toString: $52d2c0697e0742f9$var$toString,
    fromString: $52d2c0697e0742f9$var$fromString,
    toNumber: $52d2c0697e0742f9$var$toNumber,
    fromNumber: $52d2c0697e0742f9$var$fromNumber,
    toEther: $52d2c0697e0742f9$var$toEther,
    fromEther: $52d2c0697e0742f9$var$fromEther,
    toUint256: $52d2c0697e0742f9$var$toUint256,
    add: $52d2c0697e0742f9$var$add,
    mul: $52d2c0697e0742f9$var$mul,
    div: $52d2c0697e0742f9$var$div,
    sub: $52d2c0697e0742f9$var$sub
};



var $8J1ou = parcelRequire("8J1ou");
var $6c7692706ff8ded4$exports = {};
// The RLP format
// Serialization and deserialization for the BytesTree type, under the following grammar:
// | First byte | Meaning                                                                    |
// | ---------- | -------------------------------------------------------------------------- |
// | 0   to 127 | HEX(leaf)                                                                  |
// | 128 to 183 | HEX(length_of_leaf + 128) + HEX(leaf)                                      |
// | 184 to 191 | HEX(length_of_length_of_leaf + 128 + 55) + HEX(length_of_leaf) + HEX(leaf) |
// | 192 to 247 | HEX(length_of_node + 192) + HEX(node)                                      |
// | 248 to 255 | HEX(length_of_length_of_node + 128 + 55) + HEX(length_of_node) + HEX(node) |
const $6c7692706ff8ded4$var$encode = (tree)=>{
    const padEven = (str)=>str.length % 2 === 0 ? str : "0" + str;
    const uint = (num)=>padEven(num.toString(16));
    const length = (len, add)=>len < 56 ? uint(add + len) : uint(add + uint(len).length / 2 + 55) + uint(len);
    const dataTree = (tree)=>{
        if (typeof tree === "string") {
            const hex = tree.slice(2);
            const pre = hex.length != 2 || hex >= "80" ? length(hex.length / 2, 128) : "";
            return pre + hex;
        } else {
            const hex = tree.map(dataTree).join("");
            const pre = length(hex.length / 2, 192);
            return pre + hex;
        }
    };
    return "0x" + dataTree(tree);
};
const $6c7692706ff8ded4$var$decode = (hex)=>{
    let i = 2;
    const parseTree = ()=>{
        if (i >= hex.length) throw "";
        const head = hex.slice(i, i + 2);
        return head < "80" ? (i += 2, "0x" + head) : head < "c0" ? parseHex() : parseList();
    };
    const parseLength = ()=>{
        const len = parseInt(hex.slice(i, i += 2), 16) % 64;
        return len < 56 ? len : parseInt(hex.slice(i, i += (len - 55) * 2), 16);
    };
    const parseHex = ()=>{
        const len = parseLength();
        return "0x" + hex.slice(i, i += len * 2);
    };
    const parseList = ()=>{
        const lim = parseLength() * 2 + i;
        let list = [];
        while(i < lim)list.push(parseTree());
        return list;
    };
    try {
        return parseTree();
    } catch (e) {
        return [];
    }
};
$6c7692706ff8ded4$exports = {
    encode: $6c7692706ff8ded4$var$encode,
    decode: $6c7692706ff8ded4$var$decode
};


const $910e2b5726b399b4$var$secp256k1 = new $8J1ou.ec("secp256k1"); // eslint-disable-line

var $kA8g9 = parcelRequire("kA8g9");
var $910e2b5726b399b4$require$keccak256 = $kA8g9.keccak256;
var $910e2b5726b399b4$require$keccak256s = $kA8g9.keccak256s;
const $910e2b5726b399b4$var$create = (entropy)=>{
    const innerHex = $910e2b5726b399b4$require$keccak256($d05a945c84ae6b55$exports.concat($d05a945c84ae6b55$exports.random(32), entropy || $d05a945c84ae6b55$exports.random(32)));
    const middleHex = $d05a945c84ae6b55$exports.concat($d05a945c84ae6b55$exports.concat($d05a945c84ae6b55$exports.random(32), innerHex), $d05a945c84ae6b55$exports.random(32));
    const outerHex = $910e2b5726b399b4$require$keccak256(middleHex);
    return $910e2b5726b399b4$var$fromPrivate(outerHex);
};
const $910e2b5726b399b4$var$toChecksum = (address)=>{
    const addressHash = $910e2b5726b399b4$require$keccak256s(address.slice(2));
    let checksumAddress = "0x";
    for(let i = 0; i < 40; i++)checksumAddress += parseInt(addressHash[i + 2], 16) > 7 ? address[i + 2].toUpperCase() : address[i + 2];
    return checksumAddress;
};
const $910e2b5726b399b4$var$fromPrivate = (privateKey)=>{
    const buffer = new $910e2b5726b399b4$require$Buffer(privateKey.slice(2), "hex");
    const ecKey = $910e2b5726b399b4$var$secp256k1.keyFromPrivate(buffer);
    const publicKey = "0x" + ecKey.getPublic(false, "hex").slice(2);
    const publicHash = $910e2b5726b399b4$require$keccak256(publicKey);
    const address = $910e2b5726b399b4$var$toChecksum("0x" + publicHash.slice(-40));
    return {
        address: address,
        privateKey: privateKey
    };
};
const $910e2b5726b399b4$var$encodeSignature = ([v, r, s])=>$d05a945c84ae6b55$exports.flatten([
        r,
        s,
        v
    ]);
const $910e2b5726b399b4$var$decodeSignature = (hex)=>[
        $d05a945c84ae6b55$exports.slice(64, $d05a945c84ae6b55$exports.length(hex), hex),
        $d05a945c84ae6b55$exports.slice(0, 32, hex),
        $d05a945c84ae6b55$exports.slice(32, 64, hex)
    ];
const $910e2b5726b399b4$var$makeSigner = (addToV)=>(hash, privateKey)=>{
        const signature = $910e2b5726b399b4$var$secp256k1.keyFromPrivate(new $910e2b5726b399b4$require$Buffer(privateKey.slice(2), "hex")).sign(new $910e2b5726b399b4$require$Buffer(hash.slice(2), "hex"), {
            canonical: true
        });
        return $910e2b5726b399b4$var$encodeSignature([
            $52d2c0697e0742f9$exports.fromString($d05a945c84ae6b55$exports.fromNumber(addToV + signature.recoveryParam)),
            $d05a945c84ae6b55$exports.pad(32, $d05a945c84ae6b55$exports.fromNat("0x" + signature.r.toString(16))),
            $d05a945c84ae6b55$exports.pad(32, $d05a945c84ae6b55$exports.fromNat("0x" + signature.s.toString(16)))
        ]);
    };
const $910e2b5726b399b4$var$sign = $910e2b5726b399b4$var$makeSigner(27); // v=27|28 instead of 0|1...
const $910e2b5726b399b4$var$recover = (hash, signature)=>{
    const vals = $910e2b5726b399b4$var$decodeSignature(signature);
    const vrs = {
        v: $d05a945c84ae6b55$exports.toNumber(vals[0]),
        r: vals[1].slice(2),
        s: vals[2].slice(2)
    };
    const ecPublicKey = $910e2b5726b399b4$var$secp256k1.recoverPubKey(new $910e2b5726b399b4$require$Buffer(hash.slice(2), "hex"), vrs, vrs.v < 2 ? vrs.v : 1 - vrs.v % 2); // because odd vals mean v=0... sadly that means v=0 means v=1... I hate that
    const publicKey = "0x" + ecPublicKey.encode("hex", false).slice(2);
    const publicHash = $910e2b5726b399b4$require$keccak256(publicKey);
    const address = $910e2b5726b399b4$var$toChecksum("0x" + publicHash.slice(-40));
    return address;
};
$910e2b5726b399b4$exports = {
    create: $910e2b5726b399b4$var$create,
    toChecksum: $910e2b5726b399b4$var$toChecksum,
    fromPrivate: $910e2b5726b399b4$var$fromPrivate,
    sign: $910e2b5726b399b4$var$sign,
    makeSigner: $910e2b5726b399b4$var$makeSigner,
    recover: $910e2b5726b399b4$var$recover,
    encodeSignature: $910e2b5726b399b4$var$encodeSignature,
    decodeSignature: $910e2b5726b399b4$var$decodeSignature
};



var $kA8g9 = parcelRequire("kA8g9");


var $2bd241c3a96c6a82$var$cryp = typeof $parcel$global === "undefined" ? (parcelRequire("aO8Ot")) : (parcelRequire("aO8Ot"));

var $5W1f9 = parcelRequire("5W1f9");
var $ec8eb3914224fc5f$exports = {};
var $7e0d7b4c90bb5a89$exports = {};
var $bad6bb9688ead690$exports = {};
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $bad6bb9688ead690$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($bad6bb9688ead690$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $bad6bb9688ead690$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    $bad6bb9688ead690$exports = function whatwgRNG() {
        $bad6bb9688ead690$var$getRandomValues($bad6bb9688ead690$var$rnds8);
        return $bad6bb9688ead690$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $bad6bb9688ead690$var$rnds = new Array(16);
    $bad6bb9688ead690$exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $bad6bb9688ead690$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $bad6bb9688ead690$var$rnds;
    };
}


var $e46cb7e6d46fe808$exports = {};
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $e46cb7e6d46fe808$var$byteToHex = [];
for(var $e46cb7e6d46fe808$var$i = 0; $e46cb7e6d46fe808$var$i < 256; ++$e46cb7e6d46fe808$var$i)$e46cb7e6d46fe808$var$byteToHex[$e46cb7e6d46fe808$var$i] = ($e46cb7e6d46fe808$var$i + 0x100).toString(16).substr(1);
function $e46cb7e6d46fe808$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $e46cb7e6d46fe808$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
$e46cb7e6d46fe808$exports = $e46cb7e6d46fe808$var$bytesToUuid;


// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $7e0d7b4c90bb5a89$var$_nodeId;
var $7e0d7b4c90bb5a89$var$_clockseq;
// Previous uuid creation time
var $7e0d7b4c90bb5a89$var$_lastMSecs = 0;
var $7e0d7b4c90bb5a89$var$_lastNSecs = 0;
// See https://github.com/broofa/node-uuid for API details
function $7e0d7b4c90bb5a89$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $7e0d7b4c90bb5a89$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $7e0d7b4c90bb5a89$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $bad6bb9688ead690$exports();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $7e0d7b4c90bb5a89$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $7e0d7b4c90bb5a89$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $7e0d7b4c90bb5a89$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $7e0d7b4c90bb5a89$var$_lastMSecs + (nsecs - $7e0d7b4c90bb5a89$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $7e0d7b4c90bb5a89$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $7e0d7b4c90bb5a89$var$_lastMSecs = msecs;
    $7e0d7b4c90bb5a89$var$_lastNSecs = nsecs;
    $7e0d7b4c90bb5a89$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $e46cb7e6d46fe808$exports(b);
}
$7e0d7b4c90bb5a89$exports = $7e0d7b4c90bb5a89$var$v1;


var $2ab0d600d53654ce$exports = {};


function $2ab0d600d53654ce$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $bad6bb9688ead690$exports)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $e46cb7e6d46fe808$exports(rnds);
}
$2ab0d600d53654ce$exports = $2ab0d600d53654ce$var$v4;


var $ec8eb3914224fc5f$var$uuid = $2ab0d600d53654ce$exports;
$ec8eb3914224fc5f$var$uuid.v1 = $7e0d7b4c90bb5a89$exports;
$ec8eb3914224fc5f$var$uuid.v4 = $2ab0d600d53654ce$exports;
$ec8eb3914224fc5f$exports = $ec8eb3914224fc5f$var$uuid;



var $hpg7W = parcelRequire("hpg7W");

var $heyrh = parcelRequire("heyrh");

var $2bd241c3a96c6a82$require$TransactionFactory = $d67a384a34381279$exports.TransactionFactory;

var $bE5P3 = parcelRequire("bE5P3");
var $2bd241c3a96c6a82$require$Common = $bE5P3.default;

var $bE5P3 = parcelRequire("bE5P3");
var $2bd241c3a96c6a82$require$HardForks = $bE5P3.Hardfork;
var $2bd241c3a96c6a82$var$isNot = function(value) {
    return typeof value === "undefined" || value === null;
};
var $2bd241c3a96c6a82$var$Accounts = function Accounts() {
    var _this = this;
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    // remove unecessary core functions
    delete this.BatchRequest;
    delete this.extend;
    var _ethereumCall = [
        new $60ff6d2aea0ffa29$exports({
            name: "getNetworkId",
            call: "net_version",
            params: 0,
            outputFormatter: parseInt
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getChainId",
            call: "eth_chainId",
            params: 0,
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getGasPrice",
            call: "eth_gasPrice",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getTransactionCount",
            call: "eth_getTransactionCount",
            params: 2,
            inputFormatter: [
                function(address) {
                    if ($hpg7W.isAddress(address)) return address;
                    else throw new Error("Address " + address + ' is not a valid address to get the "transactionCount".');
                },
                function() {
                    return "latest";
                }
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBlockByNumber",
            call: "eth_getBlockByNumber",
            params: 2,
            inputFormatter: [
                function(blockNumber) {
                    return blockNumber ? $hpg7W.toHex(blockNumber) : "latest";
                },
                function() {
                    return false;
                }
            ]
        })
    ];
    // attach methods to this._ethereumCall
    this._ethereumCall = {};
    _ethereumCall.forEach((method)=>{
        method.attachToObject(_this._ethereumCall);
        method.setRequestManager(_this._requestManager);
    });
    this.wallet = new $2bd241c3a96c6a82$var$Wallet(this);
};
$2bd241c3a96c6a82$var$Accounts.prototype._addAccountFunctions = function(account) {
    var _this = this;
    // add sign functions
    account.signTransaction = function signTransaction(tx, callback) {
        return _this.signTransaction(tx, account.privateKey, callback);
    };
    account.sign = function sign(data) {
        return _this.sign(data, account.privateKey);
    };
    account.encrypt = function encrypt(password, options) {
        return _this.encrypt(account.privateKey, password, options);
    };
    return account;
};
$2bd241c3a96c6a82$var$Accounts.prototype.create = function create(entropy) {
    return this._addAccountFunctions($910e2b5726b399b4$exports.create(entropy || $hpg7W.randomHex(32)));
};
$2bd241c3a96c6a82$var$Accounts.prototype.privateKeyToAccount = function privateKeyToAccount(privateKey, ignoreLength) {
    if (!privateKey.startsWith("0x")) privateKey = "0x" + privateKey;
    // 64 hex characters + hex-prefix
    if (!ignoreLength && privateKey.length !== 66) throw new Error("Private key must be 32 bytes long");
    return this._addAccountFunctions($910e2b5726b399b4$exports.fromPrivate(privateKey));
};
$2bd241c3a96c6a82$var$Accounts.prototype.signTransaction = function signTransaction(tx, privateKey, callback) {
    var _this = this, error = false, transactionOptions = {}, hasTxSigningOptions = !!(tx && (tx.chain && tx.hardfork || tx.common));
    callback = callback || function() {};
    if (!tx) {
        error = new Error("No transaction object given!");
        callback(error);
        return Promise.reject(error);
    }
    function signed(tx) {
        const error = $2bd241c3a96c6a82$var$_validateTransactionForSigning(tx);
        if (error) {
            callback(error);
            return Promise.reject(error);
        }
        try {
            var transaction = $heyrh.formatters.inputCallFormatter(Object.assign({}, tx));
            transaction.data = transaction.data || "0x";
            transaction.value = transaction.value || "0x";
            transaction.gasLimit = transaction.gasLimit || transaction.gas;
            if (transaction.type === "0x1" && transaction.accessList === undefined) transaction.accessList = [];
            // Because tx has no @ethereumjs/tx signing options we use fetched vals.
            if (!hasTxSigningOptions) {
                transactionOptions.common = $2bd241c3a96c6a82$require$Common.forCustomChain("mainnet", {
                    name: "custom-network",
                    networkId: transaction.networkId,
                    chainId: transaction.chainId
                }, transaction.hardfork || $2bd241c3a96c6a82$require$HardForks.London);
                delete transaction.networkId;
            } else {
                if (transaction.common) {
                    transactionOptions.common = $2bd241c3a96c6a82$require$Common.forCustomChain(transaction.common.baseChain || "mainnet", {
                        name: transaction.common.customChain.name || "custom-network",
                        networkId: transaction.common.customChain.networkId,
                        chainId: transaction.common.customChain.chainId
                    }, transaction.common.hardfork || $2bd241c3a96c6a82$require$HardForks.London);
                    delete transaction.common;
                }
                if (transaction.chain) {
                    transactionOptions.chain = transaction.chain;
                    delete transaction.chain;
                }
                if (transaction.hardfork) {
                    transactionOptions.hardfork = transaction.hardfork;
                    delete transaction.hardfork;
                }
            }
            if (privateKey.startsWith("0x")) privateKey = privateKey.substring(2);
            var ethTx = $2bd241c3a96c6a82$require$TransactionFactory.fromTxData(transaction, transactionOptions);
            var signedTx = ethTx.sign($2bd241c3a96c6a82$require$Buffer.from(privateKey, "hex"));
            var validationErrors = signedTx.validate(true);
            if (validationErrors.length > 0) {
                let errorString = "Signer Error: ";
                for (const validationError of validationErrors)errorString += `${errorString} ${validationError}.`;
                throw new Error(errorString);
            }
            var rlpEncoded = signedTx.serialize().toString("hex");
            var rawTransaction = "0x" + rlpEncoded;
            var transactionHash = $hpg7W.keccak256(rawTransaction);
            var result = {
                messageHash: "0x" + $2bd241c3a96c6a82$require$Buffer.from(signedTx.getMessageToSign(true)).toString("hex"),
                v: "0x" + $2bd241c3a96c6a82$require$Buffer.from(signedTx.v).toString("hex"),
                r: "0x" + $2bd241c3a96c6a82$require$Buffer.from(signedTx.r).toString("hex"),
                s: "0x" + $2bd241c3a96c6a82$require$Buffer.from(signedTx.s).toString("hex"),
                rawTransaction: rawTransaction,
                transactionHash: transactionHash
            };
            callback(null, result);
            return result;
        } catch (e) {
            callback(e);
            return Promise.reject(e);
        }
    }
    tx.type = $2bd241c3a96c6a82$var$_handleTxType(tx);
    // Resolve immediately if nonce, chainId, price and signing options are provided
    if (tx.nonce !== undefined && tx.chainId !== undefined && (tx.gasPrice !== undefined || tx.maxFeePerGas !== undefined && tx.maxPriorityFeePerGas !== undefined) && hasTxSigningOptions) return Promise.resolve(signed(tx));
    // Otherwise, get the missing info from the Ethereum Node
    return Promise.all([
        $2bd241c3a96c6a82$var$isNot(tx.chainId) ? _this._ethereumCall.getChainId() : tx.chainId,
        $2bd241c3a96c6a82$var$isNot(tx.nonce) ? _this._ethereumCall.getTransactionCount(_this.privateKeyToAccount(privateKey).address) : tx.nonce,
        $2bd241c3a96c6a82$var$isNot(hasTxSigningOptions) ? _this._ethereumCall.getNetworkId() : 1,
        $2bd241c3a96c6a82$var$_handleTxPricing(_this, tx)
    ]).then(function(args) {
        if ($2bd241c3a96c6a82$var$isNot(args[0]) || $2bd241c3a96c6a82$var$isNot(args[1]) || $2bd241c3a96c6a82$var$isNot(args[2]) || $2bd241c3a96c6a82$var$isNot(args[3])) throw new Error('One of the values "chainId", "networkId", "gasPrice", or "nonce" couldn\'t be fetched: ' + JSON.stringify(args));
        return signed({
            ...tx,
            chainId: args[0],
            nonce: args[1],
            networkId: args[2],
            ...args[3] // Will either be gasPrice or maxFeePerGas and maxPriorityFeePerGas
        });
    });
};
function $2bd241c3a96c6a82$var$_validateTransactionForSigning(tx) {
    if (tx.common && tx.chain && tx.hardfork) return new Error("Please provide the @ethereumjs/common object or the chain and hardfork property but not all together.");
    if (tx.chain && !tx.hardfork || tx.hardfork && !tx.chain) return new Error('When specifying chain and hardfork, both values must be defined. Received "chain": ' + tx.chain + ', "hardfork": ' + tx.hardfork);
    if (!tx.gas && !tx.gasLimit && !tx.maxPriorityFeePerGas && !tx.maxFeePerGas) return new Error('"gas" is missing');
    if (tx.gas && tx.gasPrice) {
        if (tx.gas < 0 || tx.gasPrice < 0) return new Error("Gas or gasPrice is lower than 0");
    } else {
        if (tx.maxPriorityFeePerGas < 0 || tx.maxFeePerGas < 0) return new Error("maxPriorityFeePerGas or maxFeePerGas is lower than 0");
    }
    if (tx.nonce < 0 || tx.chainId < 0) return new Error("Nonce or chainId is lower than 0");
    return;
}
function $2bd241c3a96c6a82$var$_handleTxType(tx) {
    // Taken from https://github.com/ethers-io/ethers.js/blob/2a7ce0e72a1e0c9469e10392b0329e75e341cf18/packages/abstract-signer/src.ts/index.ts#L215
    const hasEip1559 = tx.maxFeePerGas !== undefined || tx.maxPriorityFeePerGas !== undefined;
    let txType;
    if (tx.type !== undefined) txType = $hpg7W.toHex(tx.type);
    else if (tx.type === undefined && hasEip1559) txType = "0x2";
    else txType = "0x0";
    if (tx.gasPrice !== undefined && (txType === "0x2" || hasEip1559)) throw Error("eip-1559 transactions don't support gasPrice");
    if ((txType === "0x1" || txType === "0x0") && hasEip1559) throw Error("pre-eip-1559 transaction don't support maxFeePerGas/maxPriorityFeePerGas");
    if (hasEip1559 || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $2bd241c3a96c6a82$require$HardForks.London || tx.hardfork && tx.hardfork.toLowerCase() === $2bd241c3a96c6a82$require$HardForks.London) txType = "0x2";
    else if (tx.accessList || tx.common && tx.common.hardfork && tx.common.hardfork.toLowerCase() === $2bd241c3a96c6a82$require$HardForks.Berlin || tx.hardfork && tx.hardfork.toLowerCase() === $2bd241c3a96c6a82$require$HardForks.Berlin) txType = "0x1";
    return txType;
}
function $2bd241c3a96c6a82$var$_handleTxPricing(_this, tx) {
    return new Promise((resolve, reject)=>{
        try {
            if (tx.type < "0x2" && tx.gasPrice !== undefined) // Legacy transaction, return provided gasPrice
            resolve({
                gasPrice: tx.gasPrice
            });
            else Promise.all([
                _this._ethereumCall.getBlockByNumber(),
                _this._ethereumCall.getGasPrice()
            ]).then((responses)=>{
                const [block, gasPrice] = responses;
                if (tx.type === "0x2" && block && block.baseFeePerGas) {
                    // The network supports EIP-1559
                    // Taken from https://github.com/ethers-io/ethers.js/blob/ba6854bdd5a912fe873d5da494cb5c62c190adde/packages/abstract-provider/src.ts/index.ts#L230
                    let maxPriorityFeePerGas, maxFeePerGas;
                    if (tx.gasPrice) {
                        // Using legacy gasPrice property on an eip-1559 network,
                        // so use gasPrice as both fee properties
                        maxPriorityFeePerGas = tx.gasPrice;
                        maxFeePerGas = tx.gasPrice;
                        delete tx.gasPrice;
                    } else {
                        maxPriorityFeePerGas = tx.maxPriorityFeePerGas || "0x3B9ACA00"; // 1 Gwei
                        maxFeePerGas = tx.maxFeePerGas || $hpg7W.toHex($hpg7W.toBN(block.baseFeePerGas).mul($hpg7W.toBN(2)).add($hpg7W.toBN(maxPriorityFeePerGas)));
                    }
                    resolve({
                        maxFeePerGas: maxFeePerGas,
                        maxPriorityFeePerGas: maxPriorityFeePerGas
                    });
                } else {
                    if (tx.maxPriorityFeePerGas || tx.maxFeePerGas) throw Error("Network doesn't support eip-1559");
                    resolve({
                        gasPrice: gasPrice
                    });
                }
            });
        } catch (error) {
            reject(error);
        }
    });
}
/* jshint ignore:start */ $2bd241c3a96c6a82$var$Accounts.prototype.recoverTransaction = function recoverTransaction(rawTx, txOptions = {}) {
    // Rely on EthereumJs/tx to determine the type of transaction
    const data = $2bd241c3a96c6a82$require$Buffer.from(rawTx.slice(2), "hex");
    const tx = $2bd241c3a96c6a82$require$TransactionFactory.fromSerializedData(data);
    //update checksum
    return $hpg7W.toChecksumAddress(tx.getSenderAddress().toString("hex"));
};
/* jshint ignore:end */ $2bd241c3a96c6a82$var$Accounts.prototype.hashMessage = function hashMessage(data) {
    var messageHex = $hpg7W.isHexStrict(data) ? data : $hpg7W.utf8ToHex(data);
    var messageBytes = $hpg7W.hexToBytes(messageHex);
    var messageBuffer = $2bd241c3a96c6a82$require$Buffer.from(messageBytes);
    var preamble = "\x19Ethereum Signed Message:\n" + messageBytes.length;
    var preambleBuffer = $2bd241c3a96c6a82$require$Buffer.from(preamble);
    var ethMessage = $2bd241c3a96c6a82$require$Buffer.concat([
        preambleBuffer,
        messageBuffer
    ]);
    return $kA8g9.keccak256s(ethMessage);
};
$2bd241c3a96c6a82$var$Accounts.prototype.sign = function sign(data, privateKey) {
    if (!privateKey.startsWith("0x")) privateKey = "0x" + privateKey;
    // 64 hex characters + hex-prefix
    if (privateKey.length !== 66) throw new Error("Private key must be 32 bytes long");
    var hash = this.hashMessage(data);
    var signature = $910e2b5726b399b4$exports.sign(hash, privateKey);
    var vrs = $910e2b5726b399b4$exports.decodeSignature(signature);
    return {
        message: data,
        messageHash: hash,
        v: vrs[0],
        r: vrs[1],
        s: vrs[2],
        signature: signature
    };
};
$2bd241c3a96c6a82$var$Accounts.prototype.recover = function recover(message, signature, preFixed) {
    var args = [].slice.apply(arguments);
    if (!!message && typeof message === "object") return this.recover(message.messageHash, $910e2b5726b399b4$exports.encodeSignature([
        message.v,
        message.r,
        message.s
    ]), true);
    if (!preFixed) message = this.hashMessage(message);
    if (args.length >= 4) {
        preFixed = args.slice(-1)[0];
        preFixed = typeof preFixed === "boolean" ? !!preFixed : false;
        return this.recover(message, $910e2b5726b399b4$exports.encodeSignature(args.slice(1, 4)), preFixed); // v, r, s
    }
    return $910e2b5726b399b4$exports.recover(message, signature);
};
// Taken from https://github.com/ethereumjs/ethereumjs-wallet
$2bd241c3a96c6a82$var$Accounts.prototype.decrypt = function(v3Keystore, password, nonStrict) {
    /* jshint maxcomplexity: 10 */ if (!(typeof password === "string")) throw new Error("No password given.");
    var json = !!v3Keystore && typeof v3Keystore === "object" ? v3Keystore : JSON.parse(nonStrict ? v3Keystore.toLowerCase() : v3Keystore);
    if (json.version !== 3) throw new Error("Not a valid V3 wallet");
    var derivedKey;
    var kdfparams;
    if (json.crypto.kdf === "scrypt") {
        kdfparams = json.crypto.kdfparams;
        // FIXME: support progress reporting callback
        derivedKey = $5W1f9.syncScrypt($2bd241c3a96c6a82$require$Buffer.from(password), $2bd241c3a96c6a82$require$Buffer.from(kdfparams.salt, "hex"), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
    } else if (json.crypto.kdf === "pbkdf2") {
        kdfparams = json.crypto.kdfparams;
        if (kdfparams.prf !== "hmac-sha256") throw new Error("Unsupported parameters to PBKDF2");
        derivedKey = $2bd241c3a96c6a82$var$cryp.pbkdf2Sync($2bd241c3a96c6a82$require$Buffer.from(password), $2bd241c3a96c6a82$require$Buffer.from(kdfparams.salt, "hex"), kdfparams.c, kdfparams.dklen, "sha256");
    } else throw new Error("Unsupported key derivation scheme");
    var ciphertext = $2bd241c3a96c6a82$require$Buffer.from(json.crypto.ciphertext, "hex");
    var mac = $hpg7W.sha3($2bd241c3a96c6a82$require$Buffer.from([
        ...derivedKey.slice(16, 32),
        ...ciphertext
    ])).replace("0x", "");
    if (mac !== json.crypto.mac) throw new Error("Key derivation failed - possibly wrong password");
    var decipher = $2bd241c3a96c6a82$var$cryp.createDecipheriv(json.crypto.cipher, derivedKey.slice(0, 16), $2bd241c3a96c6a82$require$Buffer.from(json.crypto.cipherparams.iv, "hex"));
    var seed = "0x" + $2bd241c3a96c6a82$require$Buffer.from([
        ...decipher.update(ciphertext),
        ...decipher.final()
    ]).toString("hex");
    return this.privateKeyToAccount(seed, true);
};
$2bd241c3a96c6a82$var$Accounts.prototype.encrypt = function(privateKey, password, options) {
    /* jshint maxcomplexity: 20 */ var account = this.privateKeyToAccount(privateKey, true);
    options = options || {};
    var salt = options.salt || $2bd241c3a96c6a82$var$cryp.randomBytes(32);
    var iv = options.iv || $2bd241c3a96c6a82$var$cryp.randomBytes(16);
    var derivedKey;
    var kdf = options.kdf || "scrypt";
    var kdfparams = {
        dklen: options.dklen || 32,
        salt: salt.toString("hex")
    };
    if (kdf === "pbkdf2") {
        kdfparams.c = options.c || 262144;
        kdfparams.prf = "hmac-sha256";
        derivedKey = $2bd241c3a96c6a82$var$cryp.pbkdf2Sync($2bd241c3a96c6a82$require$Buffer.from(password), $2bd241c3a96c6a82$require$Buffer.from(kdfparams.salt, "hex"), kdfparams.c, kdfparams.dklen, "sha256");
    } else if (kdf === "scrypt") {
        // FIXME: support progress reporting callback
        kdfparams.n = options.n || 8192; // 2048 4096 8192 16384
        kdfparams.r = options.r || 8;
        kdfparams.p = options.p || 1;
        derivedKey = $5W1f9.syncScrypt($2bd241c3a96c6a82$require$Buffer.from(password), $2bd241c3a96c6a82$require$Buffer.from(kdfparams.salt, "hex"), kdfparams.n, kdfparams.r, kdfparams.p, kdfparams.dklen);
    } else throw new Error("Unsupported kdf");
    var cipher = $2bd241c3a96c6a82$var$cryp.createCipheriv(options.cipher || "aes-128-ctr", derivedKey.slice(0, 16), iv);
    if (!cipher) throw new Error("Unsupported cipher");
    var ciphertext = $2bd241c3a96c6a82$require$Buffer.from([
        ...cipher.update($2bd241c3a96c6a82$require$Buffer.from(account.privateKey.replace("0x", ""), "hex")),
        ...cipher.final()
    ]);
    var mac = $hpg7W.sha3($2bd241c3a96c6a82$require$Buffer.from([
        ...derivedKey.slice(16, 32),
        ...ciphertext
    ])).replace("0x", "");
    return {
        version: 3,
        id: $ec8eb3914224fc5f$exports.v4({
            random: options.uuid || $2bd241c3a96c6a82$var$cryp.randomBytes(16)
        }),
        address: account.address.toLowerCase().replace("0x", ""),
        crypto: {
            ciphertext: ciphertext.toString("hex"),
            cipherparams: {
                iv: iv.toString("hex")
            },
            cipher: options.cipher || "aes-128-ctr",
            kdf: kdf,
            kdfparams: kdfparams,
            mac: mac.toString("hex")
        }
    };
};
// Note: this is trying to follow closely the specs on
// http://web3js.readthedocs.io/en/1.0/web3-eth-accounts.html
function $2bd241c3a96c6a82$var$Wallet(accounts) {
    this._accounts = accounts;
    this.length = 0;
    this.defaultKeyName = "web3js_wallet";
}
$2bd241c3a96c6a82$var$Wallet.prototype._findSafeIndex = function(pointer) {
    pointer = pointer || 0;
    if (this.hasOwnProperty(pointer)) return this._findSafeIndex(pointer + 1);
    else return pointer;
};
$2bd241c3a96c6a82$var$Wallet.prototype._currentIndexes = function() {
    var keys = Object.keys(this);
    var indexes = keys.map(function(key) {
        return parseInt(key);
    }).filter(function(n) {
        return n < 9e20;
    });
    return indexes;
};
$2bd241c3a96c6a82$var$Wallet.prototype.create = function(numberOfAccounts, entropy) {
    for(var i = 0; i < numberOfAccounts; ++i)this.add(this._accounts.create(entropy).privateKey);
    return this;
};
$2bd241c3a96c6a82$var$Wallet.prototype.add = function(account) {
    if (typeof account === "string") account = this._accounts.privateKeyToAccount(account);
    if (!this[account.address]) {
        account = this._accounts.privateKeyToAccount(account.privateKey);
        account.index = this._findSafeIndex();
        this[account.index] = account;
        this[account.address] = account;
        this[account.address.toLowerCase()] = account;
        this.length++;
        return account;
    } else return this[account.address];
};
$2bd241c3a96c6a82$var$Wallet.prototype.remove = function(addressOrIndex) {
    var account = this[addressOrIndex];
    if (account && account.address) {
        // address
        this[account.address].privateKey = null;
        delete this[account.address];
        // address lowercase
        this[account.address.toLowerCase()].privateKey = null;
        delete this[account.address.toLowerCase()];
        // index
        this[account.index].privateKey = null;
        delete this[account.index];
        this.length--;
        return true;
    } else return false;
};
$2bd241c3a96c6a82$var$Wallet.prototype.clear = function() {
    var _this = this;
    var indexes = this._currentIndexes();
    indexes.forEach(function(index) {
        _this.remove(index);
    });
    return this;
};
$2bd241c3a96c6a82$var$Wallet.prototype.encrypt = function(password, options) {
    var _this = this;
    var indexes = this._currentIndexes();
    var accounts = indexes.map(function(index) {
        return _this[index].encrypt(password, options);
    });
    return accounts;
};
$2bd241c3a96c6a82$var$Wallet.prototype.decrypt = function(encryptedWallet, password) {
    var _this = this;
    encryptedWallet.forEach(function(keystore) {
        var account = _this._accounts.decrypt(keystore, password);
        if (account) _this.add(account);
        else throw new Error("Couldn't decrypt accounts. Password wrong?");
    });
    return this;
};
$2bd241c3a96c6a82$var$Wallet.prototype.save = function(password, keyName) {
    localStorage.setItem(keyName || this.defaultKeyName, JSON.stringify(this.encrypt(password)));
    return true;
};
$2bd241c3a96c6a82$var$Wallet.prototype.load = function(password, keyName) {
    var keystore = localStorage.getItem(keyName || this.defaultKeyName);
    if (keystore) try {
        keystore = JSON.parse(keystore);
    } catch (e) {}
    return this.decrypt(keystore || [], password);
};
if (!$2bd241c3a96c6a82$var$storageAvailable("localStorage")) {
    delete $2bd241c3a96c6a82$var$Wallet.prototype.save;
    delete $2bd241c3a96c6a82$var$Wallet.prototype.load;
}
/**
 * Checks whether a storage type is available or not
 * For more info on how this works, please refer to MDN documentation
 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
 *
 * @method storageAvailable
 * @param {String} type the type of storage ('localStorage', 'sessionStorage')
 * @returns {Boolean} a boolean indicating whether the specified storage is available or not
 */ function $2bd241c3a96c6a82$var$storageAvailable(type) {
    var storage;
    try {
        storage = window[type];
        var x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
    } catch (e) {
        return e && // everything except Firefox
        (e.code === 22 || // Firefox
        e.code === 1014 || // test name field too, because code might not be present
        // everything except Firefox
        e.name === "QuotaExceededError" || // Firefox
        e.name === "NS_ERROR_DOM_QUOTA_REACHED") && // acknowledge QuotaExceededError only if there's something already stored
        storage && storage.length !== 0;
    }
}
$2bd241c3a96c6a82$exports = $2bd241c3a96c6a82$var$Accounts;



var $216cdc309709d030$exports = {};
/*
 This file is part of web3.js.

 web3.js is free software: you can redistribute it and/or modify
 it under the terms of the GNU Lesser General Public License as published by
 the Free Software Foundation, either version 3 of the License, or
 (at your option) any later version.

 web3.js is distributed in the hope that it will be useful,
 but WITHOUT ANY WARRANTY; without even the implied warranty of
 MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 GNU Lesser General Public License for more details.

 You should have received a copy of the GNU Lesser General Public License
 along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
 */ /**
 * @file getNetworkType.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $216cdc309709d030$var$getNetworkType = function(callback) {
    var _this = this, id;
    return this.net.getId().then(function(givenId) {
        id = givenId;
        return _this.getBlock(0);
    }).then(function(genesis) {
        var returnValue = "private";
        if (genesis.hash === "0xd4e56740f876aef8c010b86a40d5f56745a118d0906a34e69aec8c0db1cb8fa3" && id === 1) returnValue = "main";
        if (genesis.hash === "0cd786a2425d16f152c658316c423e6ce1181e15c3295826d7c9904cba9ce303" && id === 2) returnValue = "morden";
        if (genesis.hash === "0x41941023680923e0fe4d74a34bdac8141f2540e3ae90623718e47d66d1ca4a2d" && id === 3) returnValue = "ropsten";
        if (genesis.hash === "0x6341fd3daf94b748c72ced5a5b26028f2474f5f00d824504e4fa37a75767e177" && id === 4) returnValue = "rinkeby";
        if (genesis.hash === "0xbf7e331f7f7c1dd2e05159666b3bf8bc7a8a3a9eb1d518969eab529dd9b88c1a" && id === 5) returnValue = "goerli";
        if (genesis.hash === "0xa3c565fc15c7478862d50ccd6561e3c06b24cc509bf388941c25ea985ce32cb9" && id === 42) returnValue = "kovan";
        if (typeof callback === "function") callback(null, returnValue);
        return returnValue;
    }).catch(function(err) {
        if (typeof callback === "function") callback(err);
        else throw err;
    });
};
$216cdc309709d030$exports = $216cdc309709d030$var$getNetworkType;


var $214a994bad7e103b$var$formatter = $heyrh.formatters;
var $214a994bad7e103b$var$blockCall = function(args) {
    return typeof args[0] === "string" && args[0].indexOf("0x") === 0 ? "eth_getBlockByHash" : "eth_getBlockByNumber";
};
var $214a994bad7e103b$var$transactionFromBlockCall = function(args) {
    return typeof args[0] === "string" && args[0].indexOf("0x") === 0 ? "eth_getTransactionByBlockHashAndIndex" : "eth_getTransactionByBlockNumberAndIndex";
};
var $214a994bad7e103b$var$uncleCall = function(args) {
    return typeof args[0] === "string" && args[0].indexOf("0x") === 0 ? "eth_getUncleByBlockHashAndIndex" : "eth_getUncleByBlockNumberAndIndex";
};
var $214a994bad7e103b$var$getBlockTransactionCountCall = function(args) {
    return typeof args[0] === "string" && args[0].indexOf("0x") === 0 ? "eth_getBlockTransactionCountByHash" : "eth_getBlockTransactionCountByNumber";
};
var $214a994bad7e103b$var$uncleCountCall = function(args) {
    return typeof args[0] === "string" && args[0].indexOf("0x") === 0 ? "eth_getUncleCountByBlockHash" : "eth_getUncleCountByBlockNumber";
};
var $214a994bad7e103b$var$Eth = function Eth() {
    var _this = this;
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    // overwrite package setRequestManager
    var setRequestManager = this.setRequestManager;
    this.setRequestManager = function(manager) {
        setRequestManager(manager);
        _this.net.setRequestManager(manager);
        _this.personal.setRequestManager(manager);
        _this.accounts.setRequestManager(manager);
        _this.Contract._requestManager = _this._requestManager;
        _this.Contract.currentProvider = _this._provider;
        return true;
    };
    // overwrite setProvider
    var setProvider = this.setProvider;
    this.setProvider = function() {
        setProvider.apply(_this, arguments);
        _this.setRequestManager(_this._requestManager);
        // Set detectedAddress/lastSyncCheck back to null because the provider could be connected to a different chain now
        _this.ens._detectedAddress = null;
        _this.ens._lastSyncCheck = null;
    };
    var handleRevert = false;
    var defaultAccount = null;
    var defaultBlock = "latest";
    var transactionBlockTimeout = 50;
    var transactionConfirmationBlocks = 24;
    var transactionPollingTimeout = 750;
    var maxListenersWarningThreshold = 100;
    var defaultChain, defaultHardfork, defaultCommon;
    Object.defineProperty(this, "handleRevert", {
        get: function() {
            return handleRevert;
        },
        set: function(val) {
            handleRevert = val;
            // also set on the Contract object
            _this.Contract.handleRevert = handleRevert;
            // update handleRevert
            methods.forEach(function(method) {
                method.handleRevert = handleRevert;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultCommon", {
        get: function() {
            return defaultCommon;
        },
        set: function(val) {
            defaultCommon = val;
            // also set on the Contract object
            _this.Contract.defaultCommon = defaultCommon;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultCommon = defaultCommon;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultHardfork", {
        get: function() {
            return defaultHardfork;
        },
        set: function(val) {
            defaultHardfork = val;
            // also set on the Contract object
            _this.Contract.defaultHardfork = defaultHardfork;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultHardfork = defaultHardfork;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultChain", {
        get: function() {
            return defaultChain;
        },
        set: function(val) {
            defaultChain = val;
            // also set on the Contract object
            _this.Contract.defaultChain = defaultChain;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultChain = defaultChain;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionPollingTimeout", {
        get: function() {
            return transactionPollingTimeout;
        },
        set: function(val) {
            transactionPollingTimeout = val;
            // also set on the Contract object
            _this.Contract.transactionPollingTimeout = transactionPollingTimeout;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionPollingTimeout = transactionPollingTimeout;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionConfirmationBlocks", {
        get: function() {
            return transactionConfirmationBlocks;
        },
        set: function(val) {
            transactionConfirmationBlocks = val;
            // also set on the Contract object
            _this.Contract.transactionConfirmationBlocks = transactionConfirmationBlocks;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionConfirmationBlocks = transactionConfirmationBlocks;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "transactionBlockTimeout", {
        get: function() {
            return transactionBlockTimeout;
        },
        set: function(val) {
            transactionBlockTimeout = val;
            // also set on the Contract object
            _this.Contract.transactionBlockTimeout = transactionBlockTimeout;
            // update defaultBlock
            methods.forEach(function(method) {
                method.transactionBlockTimeout = transactionBlockTimeout;
            });
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultAccount", {
        get: function() {
            return defaultAccount;
        },
        set: function(val) {
            if (val) defaultAccount = $hpg7W.toChecksumAddress($214a994bad7e103b$var$formatter.inputAddressFormatter(val));
            // also set on the Contract object
            _this.Contract.defaultAccount = defaultAccount;
            _this.personal.defaultAccount = defaultAccount;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultAccount = defaultAccount;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "defaultBlock", {
        get: function() {
            return defaultBlock;
        },
        set: function(val) {
            defaultBlock = val;
            // also set on the Contract object
            _this.Contract.defaultBlock = defaultBlock;
            _this.personal.defaultBlock = defaultBlock;
            // update defaultBlock
            methods.forEach(function(method) {
                method.defaultBlock = defaultBlock;
            });
            return val;
        },
        enumerable: true
    });
    Object.defineProperty(this, "maxListenersWarningThreshold", {
        get: function() {
            return maxListenersWarningThreshold;
        },
        set: function(val) {
            if (_this.currentProvider && _this.currentProvider.setMaxListeners) {
                maxListenersWarningThreshold = val;
                _this.currentProvider.setMaxListeners(val);
            }
        },
        enumerable: true
    });
    this.clearSubscriptions = _this._requestManager.clearSubscriptions.bind(_this._requestManager);
    this.removeSubscriptionById = _this._requestManager.removeSubscription.bind(_this._requestManager);
    // add net
    this.net = new $db630ee0260f83ef$exports(this);
    // add chain detection
    this.net.getNetworkType = $216cdc309709d030$exports.bind(this);
    // add accounts
    this.accounts = new $2bd241c3a96c6a82$exports(this);
    // add personal
    this.personal = new $a2b78c5f45c1e37f$exports(this);
    this.personal.defaultAccount = this.defaultAccount;
    // set warnings threshold
    this.maxListenersWarningThreshold = maxListenersWarningThreshold;
    // create a proxy Contract type for this instance, as a Contract's provider
    // is stored as a class member rather than an instance variable. If we do
    // not create this proxy type, changing the provider in one instance of
    // web3-eth would subsequently change the provider for _all_ contract
    // instances!
    var self = this;
    var Contract = function Contract() {
        $64f2080ad381d344$exports.apply(this, arguments);
        // when Eth.setProvider is called, call packageInit
        // on all contract instances instantiated via this Eth
        // instances. This will update the currentProvider for
        // the contract instances
        var _this = this;
        var setProvider = self.setProvider;
        self.setProvider = function() {
            setProvider.apply(self, arguments);
            $c0d140841aa0e2a6$exports.packageInit(_this, [
                self
            ]);
        };
    };
    Contract.setProvider = function() {
        $64f2080ad381d344$exports.setProvider.apply(this, arguments);
    };
    // make our proxy Contract inherit from web3-eth-contract so that it has all
    // the right functionality and so that instanceof and friends work properly
    Contract.prototype = Object.create($64f2080ad381d344$exports.prototype);
    Contract.prototype.constructor = Contract;
    // add contract
    this.Contract = Contract;
    this.Contract.defaultAccount = this.defaultAccount;
    this.Contract.defaultBlock = this.defaultBlock;
    this.Contract.transactionBlockTimeout = this.transactionBlockTimeout;
    this.Contract.transactionConfirmationBlocks = this.transactionConfirmationBlocks;
    this.Contract.transactionPollingTimeout = this.transactionPollingTimeout;
    this.Contract.handleRevert = this.handleRevert;
    this.Contract._requestManager = this._requestManager;
    this.Contract._ethAccounts = this.accounts;
    this.Contract.currentProvider = this._requestManager.provider;
    // add IBAN
    this.Iban = $j6ZZu;
    // add ABI
    this.abi = $618c9d1507e674b0$exports;
    // add ENS
    this.ens = new $6c47817db8eaa99b$exports(this);
    var methods = [
        new $60ff6d2aea0ffa29$exports({
            name: "getNodeInfo",
            call: "web3_clientVersion"
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getProtocolVersion",
            call: "eth_protocolVersion",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getCoinbase",
            call: "eth_coinbase",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "isMining",
            call: "eth_mining",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getHashrate",
            call: "eth_hashrate",
            params: 0,
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "isSyncing",
            call: "eth_syncing",
            params: 0,
            outputFormatter: $214a994bad7e103b$var$formatter.outputSyncingFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getGasPrice",
            call: "eth_gasPrice",
            params: 0,
            outputFormatter: $214a994bad7e103b$var$formatter.outputBigNumberFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getFeeHistory",
            call: "eth_feeHistory",
            params: 3,
            inputFormatter: [
                $hpg7W.toNumber,
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter,
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getAccounts",
            call: "eth_accounts",
            params: 0,
            outputFormatter: $hpg7W.toChecksumAddress
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBlockNumber",
            call: "eth_blockNumber",
            params: 0,
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBalance",
            call: "eth_getBalance",
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputAddressFormatter,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputBigNumberFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getStorageAt",
            call: "eth_getStorageAt",
            params: 3,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputAddressFormatter,
                $hpg7W.numberToHex,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getCode",
            call: "eth_getCode",
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputAddressFormatter,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBlock",
            call: $214a994bad7e103b$var$blockCall,
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter,
                function(val) {
                    return !!val;
                }
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputBlockFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getUncle",
            call: $214a994bad7e103b$var$uncleCall,
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter,
                $hpg7W.numberToHex
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputBlockFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBlockTransactionCount",
            call: $214a994bad7e103b$var$getBlockTransactionCountCall,
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter
            ],
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getBlockUncleCount",
            call: $214a994bad7e103b$var$uncleCountCall,
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter
            ],
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getTransaction",
            call: "eth_getTransactionByHash",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputTransactionFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getTransactionFromBlock",
            call: $214a994bad7e103b$var$transactionFromBlockCall,
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputBlockNumberFormatter,
                $hpg7W.numberToHex
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputTransactionFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getTransactionReceipt",
            call: "eth_getTransactionReceipt",
            params: 1,
            inputFormatter: [
                null
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputTransactionReceiptFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getTransactionCount",
            call: "eth_getTransactionCount",
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputAddressFormatter,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "sendSignedTransaction",
            call: "eth_sendRawTransaction",
            params: 1,
            inputFormatter: [
                null
            ],
            abiCoder: $618c9d1507e674b0$exports
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "signTransaction",
            call: "eth_signTransaction",
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputTransactionFormatter
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "sendTransaction",
            call: "eth_sendTransaction",
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputTransactionFormatter
            ],
            abiCoder: $618c9d1507e674b0$exports
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "sign",
            call: "eth_sign",
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputSignFormatter,
                $214a994bad7e103b$var$formatter.inputAddressFormatter
            ],
            transformPayload: function(payload) {
                payload.params.reverse();
                return payload;
            }
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "call",
            call: "eth_call",
            params: 2,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputCallFormatter,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ],
            abiCoder: $618c9d1507e674b0$exports
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "estimateGas",
            call: "eth_estimateGas",
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputCallFormatter
            ],
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "submitWork",
            call: "eth_submitWork",
            params: 3
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getWork",
            call: "eth_getWork",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getPastLogs",
            call: "eth_getLogs",
            params: 1,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputLogFormatter
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputLogFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getChainId",
            call: "eth_chainId",
            params: 0,
            outputFormatter: $hpg7W.hexToNumber
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "requestAccounts",
            call: "eth_requestAccounts",
            params: 0,
            outputFormatter: $hpg7W.toChecksumAddress
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getProof",
            call: "eth_getProof",
            params: 3,
            inputFormatter: [
                $214a994bad7e103b$var$formatter.inputAddressFormatter,
                $214a994bad7e103b$var$formatter.inputStorageKeysFormatter,
                $214a994bad7e103b$var$formatter.inputDefaultBlockNumberFormatter
            ],
            outputFormatter: $214a994bad7e103b$var$formatter.outputProofFormatter
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getPendingTransactions",
            call: "eth_pendingTransactions",
            params: 0,
            outputFormatter: $214a994bad7e103b$var$formatter.outputTransactionFormatter
        }),
        // subscriptions
        new $214a994bad7e103b$require$Subscriptions({
            name: "subscribe",
            type: "eth",
            subscriptions: {
                "newBlockHeaders": {
                    // TODO rename on RPC side?
                    subscriptionName: "newHeads",
                    params: 0,
                    outputFormatter: $214a994bad7e103b$var$formatter.outputBlockFormatter
                },
                "pendingTransactions": {
                    subscriptionName: "newPendingTransactions",
                    params: 0
                },
                "logs": {
                    params: 1,
                    inputFormatter: [
                        $214a994bad7e103b$var$formatter.inputLogFormatter
                    ],
                    outputFormatter: $214a994bad7e103b$var$formatter.outputLogFormatter,
                    // DUBLICATE, also in web3-eth-contract
                    subscriptionHandler: function(output) {
                        if (output.removed) this.emit("changed", output);
                        else this.emit("data", output);
                        if (typeof this.callback === "function") this.callback(null, output, this);
                    }
                },
                "syncing": {
                    params: 0,
                    outputFormatter: $214a994bad7e103b$var$formatter.outputSyncingFormatter,
                    subscriptionHandler: function(output) {
                        var _this = this;
                        // fire TRUE at start
                        if (this._isSyncing !== true) {
                            this._isSyncing = true;
                            this.emit("changed", _this._isSyncing);
                            if (typeof this.callback === "function") this.callback(null, _this._isSyncing, this);
                            setTimeout(function() {
                                _this.emit("data", output);
                                if (typeof _this.callback === "function") _this.callback(null, output, _this);
                            }, 0);
                        // fire sync status
                        } else {
                            this.emit("data", output);
                            if (typeof _this.callback === "function") this.callback(null, output, this);
                            // wait for some time before fireing the FALSE
                            clearTimeout(this._isSyncingTimeout);
                            this._isSyncingTimeout = setTimeout(function() {
                                if (output.currentBlock > output.highestBlock - 200) {
                                    _this._isSyncing = false;
                                    _this.emit("changed", _this._isSyncing);
                                    if (typeof _this.callback === "function") _this.callback(null, _this._isSyncing, _this);
                                }
                            }, 500);
                        }
                    }
                }
            }
        })
    ];
    methods.forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager, _this.accounts); // second param is the eth.accounts module (necessary for signing transactions locally)
        method.defaultBlock = _this.defaultBlock;
        method.defaultAccount = _this.defaultAccount;
        method.transactionBlockTimeout = _this.transactionBlockTimeout;
        method.transactionConfirmationBlocks = _this.transactionConfirmationBlocks;
        method.transactionPollingTimeout = _this.transactionPollingTimeout;
        method.handleRevert = _this.handleRevert;
    });
};
// Adds the static givenProvider and providers property to the Eth module
$c0d140841aa0e2a6$exports.addProviders($214a994bad7e103b$var$Eth);
$214a994bad7e103b$exports = $214a994bad7e103b$var$Eth;




var $d131bc9f5cf99840$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";


var $d131bc9f5cf99840$require$Subscriptions = $51af6b2439bc4ea7$exports.subscriptions;


var $d131bc9f5cf99840$var$Shh = function Shh() {
    var _this = this;
    // sets _requestmanager
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    // overwrite package setRequestManager
    var setRequestManager = this.setRequestManager;
    this.setRequestManager = function(manager) {
        setRequestManager(manager);
        _this.net.setRequestManager(manager);
        return true;
    };
    // overwrite setProvider
    var setProvider = this.setProvider;
    this.setProvider = function() {
        setProvider.apply(_this, arguments);
        _this.setRequestManager(_this._requestManager);
    };
    this.net = new $db630ee0260f83ef$exports(this);
    [
        new $d131bc9f5cf99840$require$Subscriptions({
            name: "subscribe",
            type: "shh",
            subscriptions: {
                "messages": {
                    params: 1
                }
            }
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getVersion",
            call: "shh_version",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getInfo",
            call: "shh_info",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "setMaxMessageSize",
            call: "shh_setMaxMessageSize",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "setMinPoW",
            call: "shh_setMinPoW",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "markTrustedPeer",
            call: "shh_markTrustedPeer",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "newKeyPair",
            call: "shh_newKeyPair",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "addPrivateKey",
            call: "shh_addPrivateKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "deleteKeyPair",
            call: "shh_deleteKeyPair",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "hasKeyPair",
            call: "shh_hasKeyPair",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getPublicKey",
            call: "shh_getPublicKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getPrivateKey",
            call: "shh_getPrivateKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "newSymKey",
            call: "shh_newSymKey",
            params: 0
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "addSymKey",
            call: "shh_addSymKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "generateSymKeyFromPassword",
            call: "shh_generateSymKeyFromPassword",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "hasSymKey",
            call: "shh_hasSymKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getSymKey",
            call: "shh_getSymKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "deleteSymKey",
            call: "shh_deleteSymKey",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "newMessageFilter",
            call: "shh_newMessageFilter",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "getFilterMessages",
            call: "shh_getFilterMessages",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "deleteMessageFilter",
            call: "shh_deleteMessageFilter",
            params: 1
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "post",
            call: "shh_post",
            params: 1,
            inputFormatter: [
                null
            ]
        }),
        new $60ff6d2aea0ffa29$exports({
            name: "unsubscribe",
            call: "shh_unsubscribe",
            params: 1
        })
    ].forEach(function(method) {
        method.attachToObject(_this);
        method.setRequestManager(_this._requestManager);
    });
};
$d131bc9f5cf99840$var$Shh.prototype.clearSubscriptions = function() {
    this._requestManager.clearSubscriptions();
};
$c0d140841aa0e2a6$exports.addProviders($d131bc9f5cf99840$var$Shh);
$d131bc9f5cf99840$exports = $d131bc9f5cf99840$var$Shh;


var $a580d7cb1d0f0bfa$exports = {};
/*
    This file is part of web3.js.

    web3.js is free software: you can redistribute it and/or modify
    it under the terms of the GNU Lesser General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    web3.js is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU Lesser General Public License for more details.

    You should have received a copy of the GNU Lesser General Public License
    along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/ /**
 * @file index.js
 * @author Fabian Vogelsteller <fabian@ethereum.org>
 * @date 2017
 */ "use strict";
var $7ee3de06250ed7b7$exports = {};
var $7ee3de06250ed7b7$var$unavailable = function unavailable() {
    throw "This swarm.js function isn't available on the browser.";
};
var $7ee3de06250ed7b7$var$fs = {
    readFile: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$files = {
    download: $7ee3de06250ed7b7$var$unavailable,
    safeDownloadArchived: $7ee3de06250ed7b7$var$unavailable,
    directoryTree: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$os = {
    platform: $7ee3de06250ed7b7$var$unavailable,
    arch: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$path = {
    join: $7ee3de06250ed7b7$var$unavailable,
    slice: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$child_process = {
    spawn: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$mimetype = {
    lookup: $7ee3de06250ed7b7$var$unavailable
};
var $7ee3de06250ed7b7$var$defaultArchives = {};
var $7ee3de06250ed7b7$var$downloadUrl = null;
var $d31b01d8489ccd6f$exports = {};
var $d1ffd40e86b7fa1f$export$f9380c9a627682d3;
var $d1ffd40e86b7fa1f$export$98e6a39c04603d36;
var $d1ffd40e86b7fa1f$export$fac44ee5b035f737;
var $d1ffd40e86b7fa1f$export$7a5253c0f62e0150;
"use strict";
var $294d26d8a99a3ff6$exports = {};
"use strict";
$294d26d8a99a3ff6$exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};


var $3512c7c00a4083d8$exports = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $3512c7c00a4083d8$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $3512c7c00a4083d8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $3512c7c00a4083d8$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $3512c7c00a4083d8$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $3512c7c00a4083d8$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
$3512c7c00a4083d8$exports = $3512c7c00a4083d8$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $3512c7c00a4083d8$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($3512c7c00a4083d8$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($3512c7c00a4083d8$var$getOwnPropertySymbols) {
            symbols = $3512c7c00a4083d8$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($3512c7c00a4083d8$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};


var $e1c58bf2e246f16d$exports = {};
"use strict";
var $e1c58bf2e246f16d$var$token = "%[a-f0-9]{2}";
var $e1c58bf2e246f16d$var$singleMatcher = new RegExp($e1c58bf2e246f16d$var$token, "gi");
var $e1c58bf2e246f16d$var$multiMatcher = new RegExp("(" + $e1c58bf2e246f16d$var$token + ")+", "gi");
function $e1c58bf2e246f16d$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return decodeURIComponent(components.join(""));
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $e1c58bf2e246f16d$var$decodeComponents(left), $e1c58bf2e246f16d$var$decodeComponents(right));
}
function $e1c58bf2e246f16d$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($e1c58bf2e246f16d$var$singleMatcher);
        for(var i = 1; i < tokens.length; i++){
            input = $e1c58bf2e246f16d$var$decodeComponents(tokens, i).join("");
            tokens = input.match($e1c58bf2e246f16d$var$singleMatcher);
        }
        return input;
    }
}
function $e1c58bf2e246f16d$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $e1c58bf2e246f16d$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $e1c58bf2e246f16d$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$e1c58bf2e246f16d$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $e1c58bf2e246f16d$var$customDecodeURIComponent(encodedURI);
    }
};


function $d1ffd40e86b7fa1f$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, index) {
                return value === null ? [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    "[",
                    index,
                    "]"
                ].join("") : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    "[",
                    $d1ffd40e86b7fa1f$var$encode(index, opts),
                    "]=",
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join("");
            };
        case "bracket":
            return function(key, value) {
                return value === null ? $d1ffd40e86b7fa1f$var$encode(key, opts) : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    "[]=",
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join("");
            };
        default:
            return function(key, value) {
                return value === null ? $d1ffd40e86b7fa1f$var$encode(key, opts) : [
                    $d1ffd40e86b7fa1f$var$encode(key, opts),
                    "=",
                    $d1ffd40e86b7fa1f$var$encode(value, opts)
                ].join("");
            };
    }
}
function $d1ffd40e86b7fa1f$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $d1ffd40e86b7fa1f$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $294d26d8a99a3ff6$exports(value) : encodeURIComponent(value);
    return value;
}
function $d1ffd40e86b7fa1f$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === "object") return $d1ffd40e86b7fa1f$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $d1ffd40e86b7fa1f$var$extract(str) {
    var queryStart = str.indexOf("?");
    if (queryStart === -1) return "";
    return str.slice(queryStart + 1);
}
function $d1ffd40e86b7fa1f$var$parse(str, opts) {
    opts = $3512c7c00a4083d8$exports({
        arrayFormat: "none"
    }, opts);
    var formatter = $d1ffd40e86b7fa1f$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== "string") return ret;
    str = str.trim().replace(/^[?#&]/, "");
    if (!str) return ret;
    str.split("&").forEach(function(param) {
        var parts = param.replace(/\+/g, " ").split("=");
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join("=") : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $e1c58bf2e246f16d$exports(val);
        formatter($e1c58bf2e246f16d$exports(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === "object" && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $d1ffd40e86b7fa1f$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$d1ffd40e86b7fa1f$export$f9380c9a627682d3 = $d1ffd40e86b7fa1f$var$extract;
$d1ffd40e86b7fa1f$export$98e6a39c04603d36 = $d1ffd40e86b7fa1f$var$parse;
$d1ffd40e86b7fa1f$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: "none"
    };
    opts = $3512c7c00a4083d8$exports(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $d1ffd40e86b7fa1f$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return "";
        if (val === null) return $d1ffd40e86b7fa1f$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join("&");
        }
        return $d1ffd40e86b7fa1f$var$encode(key, opts) + "=" + $d1ffd40e86b7fa1f$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&") : "";
};
$d1ffd40e86b7fa1f$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split("?")[0] || "",
        query: $d1ffd40e86b7fa1f$var$parse($d1ffd40e86b7fa1f$var$extract(str), opts)
    };
};


var $ac5d0e048c03f184$exports = {};
$ac5d0e048c03f184$exports = $ac5d0e048c03f184$var$urlSetQuery;
function $ac5d0e048c03f184$var$urlSetQuery(url, query) {
    if (query) {
        // remove optional leading symbols
        query = query.trim().replace(/^(\?|#|&)/, "");
        // don't append empty query
        query = query ? "?" + query : query;
        var parts = url.split(/[\?\#]/);
        var start = parts[0];
        if (query && /\:\/\/[^\/]*$/.test(start)) // e.g. http://foo.com -> http://foo.com/
        start = start + "/";
        var match = url.match(/(\#.*)$/);
        url = start + query;
        if (match) url = url + match[0];
    }
    return url;
}



var $653663940faa858e$exports = {};
$653663940faa858e$exports = $653663940faa858e$var$ensureHeader;
function $653663940faa858e$var$ensureHeader(headers, key, value) {
    var lower = key.toLowerCase();
    if (!headers[key] && !headers[lower]) headers[key] = value;
}


var $098603d23c5fefac$exports = {};
var $3556d65f1b54db58$exports = {};
"use strict";
var $7080c2dcc0cd3392$exports = {};
var $7080c2dcc0cd3392$var$win;
if (typeof window !== "undefined") $7080c2dcc0cd3392$var$win = window;
else if (typeof $parcel$global !== "undefined") $7080c2dcc0cd3392$var$win = $parcel$global;
else if (typeof self !== "undefined") $7080c2dcc0cd3392$var$win = self;
else $7080c2dcc0cd3392$var$win = {};
$7080c2dcc0cd3392$exports = $7080c2dcc0cd3392$var$win;


var $7df6b000cdff9e77$exports = {};
$7df6b000cdff9e77$exports = $7df6b000cdff9e77$var$isFunction;
var $7df6b000cdff9e77$var$toString = Object.prototype.toString;
function $7df6b000cdff9e77$var$isFunction(fn) {
    if (!fn) return false;
    var string = $7df6b000cdff9e77$var$toString.call(fn);
    return string === "[object Function]" || typeof fn === "function" && string !== "[object RegExp]" || typeof window !== "undefined" && // IE8 and below
    (fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
}


var $d5f3493041fabdbb$exports = {};
var $d5f3493041fabdbb$var$trim = function(string) {
    return string.replace(/^\s+|\s+$/g, "");
}, $d5f3493041fabdbb$var$isArray = function(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
};
$d5f3493041fabdbb$exports = function(headers) {
    if (!headers) return {};
    var result = {};
    var headersArr = $d5f3493041fabdbb$var$trim(headers).split("\n");
    for(var i = 0; i < headersArr.length; i++){
        var row = headersArr[i];
        var index = row.indexOf(":"), key = $d5f3493041fabdbb$var$trim(row.slice(0, index)).toLowerCase(), value = $d5f3493041fabdbb$var$trim(row.slice(index + 1));
        if (typeof result[key] === "undefined") result[key] = value;
        else if ($d5f3493041fabdbb$var$isArray(result[key])) result[key].push(value);
        else result[key] = [
            result[key],
            value
        ];
    }
    return result;
};



var $57907 = parcelRequire("57907");
$3556d65f1b54db58$exports = $3556d65f1b54db58$var$createXHR;
// Allow use of default import syntax in TypeScript
$3556d65f1b54db58$exports.default = $3556d65f1b54db58$var$createXHR;
$3556d65f1b54db58$var$createXHR.XMLHttpRequest = $7080c2dcc0cd3392$exports.XMLHttpRequest || $3556d65f1b54db58$var$noop;
$3556d65f1b54db58$var$createXHR.XDomainRequest = "withCredentials" in new $3556d65f1b54db58$var$createXHR.XMLHttpRequest() ? $3556d65f1b54db58$var$createXHR.XMLHttpRequest : $7080c2dcc0cd3392$exports.XDomainRequest;
$3556d65f1b54db58$var$forEachArray([
    "get",
    "put",
    "post",
    "patch",
    "head",
    "delete"
], function(method) {
    $3556d65f1b54db58$var$createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
        options = $3556d65f1b54db58$var$initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return $3556d65f1b54db58$var$_createXHR(options);
    };
});
function $3556d65f1b54db58$var$forEachArray(array, iterator) {
    for(var i = 0; i < array.length; i++)iterator(array[i]);
}
function $3556d65f1b54db58$var$isEmpty(obj) {
    for(var i in obj){
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}
function $3556d65f1b54db58$var$initParams(uri, options, callback) {
    var params = uri;
    if ($7df6b000cdff9e77$exports(options)) {
        callback = options;
        if (typeof uri === "string") params = {
            uri: uri
        };
    } else params = $57907(options, {
        uri: uri
    });
    params.callback = callback;
    return params;
}
function $3556d65f1b54db58$var$createXHR(uri, options, callback) {
    options = $3556d65f1b54db58$var$initParams(uri, options, callback);
    return $3556d65f1b54db58$var$_createXHR(options);
}
function $3556d65f1b54db58$var$_createXHR(options) {
    if (typeof options.callback === "undefined") throw new Error("callback argument missing");
    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };
    function readystatechange() {
        if (xhr.readyState === 4) setTimeout(loadFunc, 0);
    }
    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;
        if (xhr.response) body = xhr.response;
        else body = xhr.responseText || $3556d65f1b54db58$var$getXml(xhr);
        if (isJson) try {
            body = JSON.parse(body);
        } catch (e) {}
        return body;
    }
    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }
    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) //IE8 CORS GET successful response doesn't have a status field, but body is fine
        status = 200;
        else status = xhr.status === 1223 ? 204 : xhr.status;
        var response = failureResponse;
        var err = null;
        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) response.headers = $d5f3493041fabdbb$exports(xhr.getAllResponseHeaders());
        } else err = new Error("Internal XMLHttpRequest Error");
        return callback(err, response, response.body);
    }
    var xhr = options.xhr || null;
    if (!xhr) {
        if (options.cors || options.useXDR) xhr = new $3556d65f1b54db58$var$createXHR.XDomainRequest();
        else xhr = new $3556d65f1b54db58$var$createXHR.XMLHttpRequest();
    }
    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };
    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json" //Don't override existing accept header declared by user
        );
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json" //Don't override existing accept header declared by user
            );
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }
    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function() {
    // IE must die
    };
    xhr.onabort = function() {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) xhr.withCredentials = !!options.withCredentials;
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) timeoutTimer = setTimeout(function() {
        if (aborted) return;
        aborted = true //IE9 may still call readystatechange
        ;
        xhr.abort("timeout");
        var e = new Error("XMLHttpRequest timeout");
        e.code = "ETIMEDOUT";
        errorFunc(e);
    }, options.timeout);
    if (xhr.setRequestHeader) {
        for(key in headers)if (headers.hasOwnProperty(key)) xhr.setRequestHeader(key, headers[key]);
    } else if (options.headers && !$3556d65f1b54db58$var$isEmpty(options.headers)) throw new Error("Headers cannot be set on an XDomainRequest object");
    if ("responseType" in options) xhr.responseType = options.responseType;
    if ("beforeSend" in options && typeof options.beforeSend === "function") options.beforeSend(xhr);
    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);
    return xhr;
}
function $3556d65f1b54db58$var$getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") return xhr.responseXML;
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) return xhr.responseXML;
    } catch (e) {}
    return null;
}
function $3556d65f1b54db58$var$noop() {}


var $ca6a26692c8b80a5$exports = {};
$ca6a26692c8b80a5$exports = $ca6a26692c8b80a5$var$getResponse;
function $ca6a26692c8b80a5$var$getResponse(opt, resp) {
    if (!resp) return null;
    return {
        statusCode: resp.statusCode,
        headers: resp.headers,
        method: opt.method,
        url: opt.url,
        // the XHR object in browser, http response in Node
        rawRequest: resp.rawRequest ? resp.rawRequest : resp
    };
}


var $098603d23c5fefac$var$noop = function() {};
$098603d23c5fefac$exports = $098603d23c5fefac$var$xhrRequest;
function $098603d23c5fefac$var$xhrRequest(opt, cb) {
    delete opt.uri;
    // for better JSON.parse error handling than xhr module
    var useJson = false;
    if (opt.responseType === "json") {
        opt.responseType = "text";
        useJson = true;
    }
    var req = $3556d65f1b54db58$exports(opt, function xhrRequestResult(err, resp, body) {
        if (useJson && !err) try {
            var text = resp.rawRequest.responseText;
            body = JSON.parse(text);
        } catch (e) {
            err = e;
        }
        resp = $ca6a26692c8b80a5$exports(opt, resp);
        if (err) cb(err, null, resp);
        else cb(err, body, resp);
        cb = $098603d23c5fefac$var$noop;
    });
    // Patch abort() so that it also calls the callback, but with an error
    var onabort = req.onabort;
    req.onabort = function() {
        var ret = onabort.apply(req, Array.prototype.slice.call(arguments));
        cb(new Error("XHR Aborted"));
        cb = $098603d23c5fefac$var$noop;
        return ret;
    };
    return req;
}


var $d31b01d8489ccd6f$var$mimeTypeJson = "application/json";
var $d31b01d8489ccd6f$var$noop = function() {};
$d31b01d8489ccd6f$exports = $d31b01d8489ccd6f$var$xhrRequest;
function $d31b01d8489ccd6f$var$xhrRequest(url, opt, cb) {
    if (!url || typeof url !== "string") throw new TypeError("must specify a URL");
    if (typeof opt === "function") {
        cb = opt;
        opt = {};
    }
    if (cb && typeof cb !== "function") throw new TypeError("expected cb to be undefined or a function");
    cb = cb || $d31b01d8489ccd6f$var$noop;
    opt = opt || {};
    var defaultResponse = opt.json ? "json" : "text";
    opt = $3512c7c00a4083d8$exports({
        responseType: defaultResponse
    }, opt);
    var headers = opt.headers || {};
    var method = (opt.method || "GET").toUpperCase();
    var query = opt.query;
    if (query) {
        if (typeof query !== "string") query = $d1ffd40e86b7fa1f$export$fac44ee5b035f737(query);
        url = $ac5d0e048c03f184$exports(url, query);
    }
    // allow json response
    if (opt.responseType === "json") $653663940faa858e$exports(headers, "Accept", $d31b01d8489ccd6f$var$mimeTypeJson);
    // if body content is json
    if (opt.json && method !== "GET" && method !== "HEAD") {
        $653663940faa858e$exports(headers, "Content-Type", $d31b01d8489ccd6f$var$mimeTypeJson);
        opt.body = JSON.stringify(opt.body);
    }
    opt.method = method;
    opt.url = url;
    opt.headers = headers;
    delete opt.query;
    delete opt.json;
    return $098603d23c5fefac$exports(opt, cb);
}


var $b6117eff6ec09ce0$exports = {};
var $14f351b43011b989$exports = {};
var $14f351b43011b989$var$generate = function generate(num, fn) {
    var a = [];
    for(var i = 0; i < num; ++i)a.push(fn(i));
    return a;
};
var $14f351b43011b989$var$replicate = function replicate(num, val) {
    return $14f351b43011b989$var$generate(num, function() {
        return val;
    });
};
var $14f351b43011b989$var$concat = function concat(a, b) {
    return a.concat(b);
};
var $14f351b43011b989$var$flatten = function flatten(a) {
    var r = [];
    for(var j = 0, J = a.length; j < J; ++j)for(var i = 0, I = a[j].length; i < I; ++i)r.push(a[j][i]);
    return r;
};
var $14f351b43011b989$var$chunksOf = function chunksOf(n, a) {
    var b = [];
    for(var i = 0, l = a.length; i < l; i += n)b.push(a.slice(i, i + n));
    return b;
};
$14f351b43011b989$exports = {
    generate: $14f351b43011b989$var$generate,
    replicate: $14f351b43011b989$var$replicate,
    concat: $14f351b43011b989$var$concat,
    flatten: $14f351b43011b989$var$flatten,
    chunksOf: $14f351b43011b989$var$chunksOf
};


var $b6117eff6ec09ce0$var$at = function at(bytes, index) {
    return parseInt(bytes.slice(index * 2 + 2, index * 2 + 4), 16);
};

var $b6117eff6ec09ce0$var$random = function random(bytes) {
    var rnd = void 0;
    if (typeof window !== "undefined" && window.crypto && window.crypto.getRandomValues) rnd = window.crypto.getRandomValues(new Uint8Array(bytes));
    else rnd = (parcelRequire("aO8Ot")).randomBytes(bytes);
    var hex = "0x";
    for(var i = 0; i < bytes; ++i)hex += ("00" + rnd[i].toString(16)).slice(-2);
    return hex;
};
var $b6117eff6ec09ce0$var$length = function length(a) {
    return (a.length - 2) / 2;
};
var $b6117eff6ec09ce0$var$flatten = function flatten(a) {
    return "0x" + a.reduce(function(r, s) {
        return r + s.slice(2);
    }, "");
};
var $b6117eff6ec09ce0$var$slice = function slice(i, j, bs) {
    return "0x" + bs.slice(i * 2 + 2, j * 2 + 2);
};
var $b6117eff6ec09ce0$var$reverse = function reverse(hex) {
    var rev = "0x";
    for(var i = 0, l = $b6117eff6ec09ce0$var$length(hex); i < l; ++i)rev += hex.slice((l - i) * 2, (l - i + 1) * 2);
    return rev;
};
var $b6117eff6ec09ce0$var$pad = function pad(l, hex) {
    return hex.length === l * 2 + 2 ? hex : pad(l, "0x0" + hex.slice(2));
};
var $b6117eff6ec09ce0$var$padRight = function padRight(l, hex) {
    return hex.length === l * 2 + 2 ? hex : padRight(l, hex + "0");
};
var $b6117eff6ec09ce0$var$toArray = function toArray(hex) {
    var arr = [];
    for(var i = 2, l = hex.length; i < l; i += 2)arr.push(parseInt(hex.slice(i, i + 2), 16));
    return arr;
};
var $b6117eff6ec09ce0$var$fromArray = function fromArray(arr) {
    var hex = "0x";
    for(var i = 0, l = arr.length; i < l; ++i){
        var b = arr[i];
        hex += (b < 16 ? "0" : "") + b.toString(16);
    }
    return hex;
};
var $b6117eff6ec09ce0$var$toUint8Array = function toUint8Array(hex) {
    return new Uint8Array($b6117eff6ec09ce0$var$toArray(hex));
};
var $b6117eff6ec09ce0$var$fromUint8Array = function fromUint8Array(arr) {
    return $b6117eff6ec09ce0$var$fromArray([].slice.call(arr, 0));
};
var $b6117eff6ec09ce0$var$fromNumber = function fromNumber(num) {
    var hex = num.toString(16);
    return hex.length % 2 === 0 ? "0x" + hex : "0x0" + hex;
};
var $b6117eff6ec09ce0$var$toNumber = function toNumber(hex) {
    return parseInt(hex.slice(2), 16);
};
var $b6117eff6ec09ce0$var$concat = function concat(a, b) {
    return a.concat(b.slice(2));
};
var $b6117eff6ec09ce0$var$fromNat = function fromNat(bn) {
    return bn === "0x0" ? "0x" : bn.length % 2 === 0 ? bn : "0x0" + bn.slice(2);
};
var $b6117eff6ec09ce0$var$toNat = function toNat(bn) {
    return bn[2] === "0" ? "0x" + bn.slice(3) : bn;
};
var $b6117eff6ec09ce0$var$fromAscii = function fromAscii(ascii) {
    var hex = "0x";
    for(var i = 0; i < ascii.length; ++i)hex += ("00" + ascii.charCodeAt(i).toString(16)).slice(-2);
    return hex;
};
var $b6117eff6ec09ce0$var$toAscii = function toAscii(hex) {
    var ascii = "";
    for(var i = 2; i < hex.length; i += 2)ascii += String.fromCharCode(parseInt(hex.slice(i, i + 2), 16));
    return ascii;
};
// From https://gist.github.com/pascaldekloe/62546103a1576803dade9269ccf76330
var $b6117eff6ec09ce0$var$fromString = function fromString(s) {
    var makeByte = function makeByte(uint8) {
        var b = uint8.toString(16);
        return b.length < 2 ? "0" + b : b;
    };
    var bytes = "0x";
    for(var ci = 0; ci != s.length; ci++){
        var c = s.charCodeAt(ci);
        if (c < 128) {
            bytes += makeByte(c);
            continue;
        }
        if (c < 2048) bytes += makeByte(c >> 6 | 192);
        else {
            if (c > 0xd7ff && c < 0xdc00) {
                if (++ci == s.length) return null;
                var c2 = s.charCodeAt(ci);
                if (c2 < 0xdc00 || c2 > 0xdfff) return null;
                c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
                bytes += makeByte(c >> 18 | 240);
                bytes += makeByte(c >> 12 & 63 | 128);
            } else // c <= 0xffff
            bytes += makeByte(c >> 12 | 224);
            bytes += makeByte(c >> 6 & 63 | 128);
        }
        bytes += makeByte(c & 63 | 128);
    }
    return bytes;
};
var $b6117eff6ec09ce0$var$toString = function toString(bytes) {
    var s = "";
    var i = 0;
    var l = $b6117eff6ec09ce0$var$length(bytes);
    while(i < l){
        var c = $b6117eff6ec09ce0$var$at(bytes, i++);
        if (c > 127) {
            if (c > 191 && c < 224) {
                if (i >= l) return null;
                c = (c & 31) << 6 | $b6117eff6ec09ce0$var$at(bytes, i) & 63;
            } else if (c > 223 && c < 240) {
                if (i + 1 >= l) return null;
                c = (c & 15) << 12 | ($b6117eff6ec09ce0$var$at(bytes, i) & 63) << 6 | $b6117eff6ec09ce0$var$at(bytes, ++i) & 63;
            } else if (c > 239 && c < 248) {
                if (i + 2 >= l) return null;
                c = (c & 7) << 18 | ($b6117eff6ec09ce0$var$at(bytes, i) & 63) << 12 | ($b6117eff6ec09ce0$var$at(bytes, ++i) & 63) << 6 | $b6117eff6ec09ce0$var$at(bytes, ++i) & 63;
            } else return null;
            ++i;
        }
        if (c <= 0xffff) s += String.fromCharCode(c);
        else if (c <= 0x10ffff) {
            c -= 0x10000;
            s += String.fromCharCode(c >> 10 | 0xd800);
            s += String.fromCharCode(c & 0x3FF | 0xdc00);
        } else return null;
    }
    return s;
};
$b6117eff6ec09ce0$exports = {
    random: $b6117eff6ec09ce0$var$random,
    length: $b6117eff6ec09ce0$var$length,
    concat: $b6117eff6ec09ce0$var$concat,
    flatten: $b6117eff6ec09ce0$var$flatten,
    slice: $b6117eff6ec09ce0$var$slice,
    reverse: $b6117eff6ec09ce0$var$reverse,
    pad: $b6117eff6ec09ce0$var$pad,
    padRight: $b6117eff6ec09ce0$var$padRight,
    fromAscii: $b6117eff6ec09ce0$var$fromAscii,
    toAscii: $b6117eff6ec09ce0$var$toAscii,
    fromString: $b6117eff6ec09ce0$var$fromString,
    toString: $b6117eff6ec09ce0$var$toString,
    fromNumber: $b6117eff6ec09ce0$var$fromNumber,
    toNumber: $b6117eff6ec09ce0$var$toNumber,
    fromNat: $b6117eff6ec09ce0$var$fromNat,
    toNat: $b6117eff6ec09ce0$var$toNat,
    fromArray: $b6117eff6ec09ce0$var$fromArray,
    toArray: $b6117eff6ec09ce0$var$toArray,
    fromUint8Array: $b6117eff6ec09ce0$var$fromUint8Array,
    toUint8Array: $b6117eff6ec09ce0$var$toUint8Array
};


var $b96252fb1d3e38ac$exports = {};
// Thanks https://github.com/axic/swarmhash
var $379dc411a289a3b3$exports = {};
// This was ported from https://github.com/emn178/js-sha3, with some minor
// modifications and pruning. It is licensed under MIT:
//
// Copyright 2015-2016 Chen, Yi-Cyuan
//  
// Permission is hereby granted, free of charge, to any person obtaining
// a copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to
// permit persons to whom the Software is furnished to do so, subject to
// the following conditions:
// 
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
// 
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
// LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
// OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
var $379dc411a289a3b3$var$HEX_CHARS = "0123456789abcdef".split("");
var $379dc411a289a3b3$var$KECCAK_PADDING = [
    1,
    256,
    65536,
    16777216
];
var $379dc411a289a3b3$var$SHIFT = [
    0,
    8,
    16,
    24
];
var $379dc411a289a3b3$var$RC = [
    1,
    0,
    32898,
    0,
    32906,
    2147483648,
    2147516416,
    2147483648,
    32907,
    0,
    2147483649,
    0,
    2147516545,
    2147483648,
    32777,
    2147483648,
    138,
    0,
    136,
    0,
    2147516425,
    0,
    2147483658,
    0,
    2147516555,
    0,
    139,
    2147483648,
    32905,
    2147483648,
    32771,
    2147483648,
    32770,
    2147483648,
    128,
    2147483648,
    32778,
    0,
    2147483658,
    2147483648,
    2147516545,
    2147483648,
    32896,
    2147483648,
    2147483649,
    0,
    2147516424,
    2147483648
];
var $379dc411a289a3b3$var$Keccak = function Keccak(bits) {
    return {
        blocks: [],
        reset: true,
        block: 0,
        start: 0,
        blockCount: 1600 - (bits << 1) >> 5,
        outputBlocks: bits >> 5,
        s: function(s) {
            return [].concat(s, s, s, s, s);
        }([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ])
    };
};
var $379dc411a289a3b3$var$update = function update(state, message) {
    var length = message.length, blocks = state.blocks, byteCount = state.blockCount << 2, blockCount = state.blockCount, outputBlocks = state.outputBlocks, s = state.s, index = 0, i, code;
    // update
    while(index < length){
        if (state.reset) {
            state.reset = false;
            blocks[0] = state.block;
            for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
        }
        if (typeof message !== "string") for(i = state.start; index < length && i < byteCount; ++index)blocks[i >> 2] |= message[index] << $379dc411a289a3b3$var$SHIFT[i++ & 3];
        else for(i = state.start; index < length && i < byteCount; ++index){
            code = message.charCodeAt(index);
            if (code < 0x80) blocks[i >> 2] |= code << $379dc411a289a3b3$var$SHIFT[i++ & 3];
            else if (code < 0x800) {
                blocks[i >> 2] |= (0xc0 | code >> 6) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
                blocks[i >> 2] |= (0xe0 | code >> 12) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
            } else {
                code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                blocks[i >> 2] |= (0xf0 | code >> 18) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 12 & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code >> 6 & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
                blocks[i >> 2] |= (0x80 | code & 0x3f) << $379dc411a289a3b3$var$SHIFT[i++ & 3];
            }
        }
        state.lastByteIndex = i;
        if (i >= byteCount) {
            state.start = i - byteCount;
            state.block = blocks[blockCount];
            for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
            $379dc411a289a3b3$var$f(s);
            state.reset = true;
        } else state.start = i;
    }
    // finalize
    i = state.lastByteIndex;
    blocks[i >> 2] |= $379dc411a289a3b3$var$KECCAK_PADDING[i & 3];
    if (state.lastByteIndex === byteCount) {
        blocks[0] = blocks[blockCount];
        for(i = 1; i < blockCount + 1; ++i)blocks[i] = 0;
    }
    blocks[blockCount - 1] |= 0x80000000;
    for(i = 0; i < blockCount; ++i)s[i] ^= blocks[i];
    $379dc411a289a3b3$var$f(s);
    // toString
    var hex = "", i = 0, j = 0, block;
    while(j < outputBlocks){
        for(i = 0; i < blockCount && j < outputBlocks; ++i, ++j){
            block = s[i];
            hex += $379dc411a289a3b3$var$HEX_CHARS[block >> 4 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 12 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 8 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 20 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 16 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 28 & 0x0F] + $379dc411a289a3b3$var$HEX_CHARS[block >> 24 & 0x0F];
        }
        if (j % blockCount === 0) {
            $379dc411a289a3b3$var$f(s);
            i = 0;
        }
    }
    return "0x" + hex;
};
var $379dc411a289a3b3$var$f = function f(s) {
    var h, l, n, c0, c1, c2, c3, c4, c5, c6, c7, c8, c9, b0, b1, b2, b3, b4, b5, b6, b7, b8, b9, b10, b11, b12, b13, b14, b15, b16, b17, b18, b19, b20, b21, b22, b23, b24, b25, b26, b27, b28, b29, b30, b31, b32, b33, b34, b35, b36, b37, b38, b39, b40, b41, b42, b43, b44, b45, b46, b47, b48, b49;
    for(n = 0; n < 48; n += 2){
        c0 = s[0] ^ s[10] ^ s[20] ^ s[30] ^ s[40];
        c1 = s[1] ^ s[11] ^ s[21] ^ s[31] ^ s[41];
        c2 = s[2] ^ s[12] ^ s[22] ^ s[32] ^ s[42];
        c3 = s[3] ^ s[13] ^ s[23] ^ s[33] ^ s[43];
        c4 = s[4] ^ s[14] ^ s[24] ^ s[34] ^ s[44];
        c5 = s[5] ^ s[15] ^ s[25] ^ s[35] ^ s[45];
        c6 = s[6] ^ s[16] ^ s[26] ^ s[36] ^ s[46];
        c7 = s[7] ^ s[17] ^ s[27] ^ s[37] ^ s[47];
        c8 = s[8] ^ s[18] ^ s[28] ^ s[38] ^ s[48];
        c9 = s[9] ^ s[19] ^ s[29] ^ s[39] ^ s[49];
        h = c8 ^ (c2 << 1 | c3 >>> 31);
        l = c9 ^ (c3 << 1 | c2 >>> 31);
        s[0] ^= h;
        s[1] ^= l;
        s[10] ^= h;
        s[11] ^= l;
        s[20] ^= h;
        s[21] ^= l;
        s[30] ^= h;
        s[31] ^= l;
        s[40] ^= h;
        s[41] ^= l;
        h = c0 ^ (c4 << 1 | c5 >>> 31);
        l = c1 ^ (c5 << 1 | c4 >>> 31);
        s[2] ^= h;
        s[3] ^= l;
        s[12] ^= h;
        s[13] ^= l;
        s[22] ^= h;
        s[23] ^= l;
        s[32] ^= h;
        s[33] ^= l;
        s[42] ^= h;
        s[43] ^= l;
        h = c2 ^ (c6 << 1 | c7 >>> 31);
        l = c3 ^ (c7 << 1 | c6 >>> 31);
        s[4] ^= h;
        s[5] ^= l;
        s[14] ^= h;
        s[15] ^= l;
        s[24] ^= h;
        s[25] ^= l;
        s[34] ^= h;
        s[35] ^= l;
        s[44] ^= h;
        s[45] ^= l;
        h = c4 ^ (c8 << 1 | c9 >>> 31);
        l = c5 ^ (c9 << 1 | c8 >>> 31);
        s[6] ^= h;
        s[7] ^= l;
        s[16] ^= h;
        s[17] ^= l;
        s[26] ^= h;
        s[27] ^= l;
        s[36] ^= h;
        s[37] ^= l;
        s[46] ^= h;
        s[47] ^= l;
        h = c6 ^ (c0 << 1 | c1 >>> 31);
        l = c7 ^ (c1 << 1 | c0 >>> 31);
        s[8] ^= h;
        s[9] ^= l;
        s[18] ^= h;
        s[19] ^= l;
        s[28] ^= h;
        s[29] ^= l;
        s[38] ^= h;
        s[39] ^= l;
        s[48] ^= h;
        s[49] ^= l;
        b0 = s[0];
        b1 = s[1];
        b32 = s[11] << 4 | s[10] >>> 28;
        b33 = s[10] << 4 | s[11] >>> 28;
        b14 = s[20] << 3 | s[21] >>> 29;
        b15 = s[21] << 3 | s[20] >>> 29;
        b46 = s[31] << 9 | s[30] >>> 23;
        b47 = s[30] << 9 | s[31] >>> 23;
        b28 = s[40] << 18 | s[41] >>> 14;
        b29 = s[41] << 18 | s[40] >>> 14;
        b20 = s[2] << 1 | s[3] >>> 31;
        b21 = s[3] << 1 | s[2] >>> 31;
        b2 = s[13] << 12 | s[12] >>> 20;
        b3 = s[12] << 12 | s[13] >>> 20;
        b34 = s[22] << 10 | s[23] >>> 22;
        b35 = s[23] << 10 | s[22] >>> 22;
        b16 = s[33] << 13 | s[32] >>> 19;
        b17 = s[32] << 13 | s[33] >>> 19;
        b48 = s[42] << 2 | s[43] >>> 30;
        b49 = s[43] << 2 | s[42] >>> 30;
        b40 = s[5] << 30 | s[4] >>> 2;
        b41 = s[4] << 30 | s[5] >>> 2;
        b22 = s[14] << 6 | s[15] >>> 26;
        b23 = s[15] << 6 | s[14] >>> 26;
        b4 = s[25] << 11 | s[24] >>> 21;
        b5 = s[24] << 11 | s[25] >>> 21;
        b36 = s[34] << 15 | s[35] >>> 17;
        b37 = s[35] << 15 | s[34] >>> 17;
        b18 = s[45] << 29 | s[44] >>> 3;
        b19 = s[44] << 29 | s[45] >>> 3;
        b10 = s[6] << 28 | s[7] >>> 4;
        b11 = s[7] << 28 | s[6] >>> 4;
        b42 = s[17] << 23 | s[16] >>> 9;
        b43 = s[16] << 23 | s[17] >>> 9;
        b24 = s[26] << 25 | s[27] >>> 7;
        b25 = s[27] << 25 | s[26] >>> 7;
        b6 = s[36] << 21 | s[37] >>> 11;
        b7 = s[37] << 21 | s[36] >>> 11;
        b38 = s[47] << 24 | s[46] >>> 8;
        b39 = s[46] << 24 | s[47] >>> 8;
        b30 = s[8] << 27 | s[9] >>> 5;
        b31 = s[9] << 27 | s[8] >>> 5;
        b12 = s[18] << 20 | s[19] >>> 12;
        b13 = s[19] << 20 | s[18] >>> 12;
        b44 = s[29] << 7 | s[28] >>> 25;
        b45 = s[28] << 7 | s[29] >>> 25;
        b26 = s[38] << 8 | s[39] >>> 24;
        b27 = s[39] << 8 | s[38] >>> 24;
        b8 = s[48] << 14 | s[49] >>> 18;
        b9 = s[49] << 14 | s[48] >>> 18;
        s[0] = b0 ^ ~b2 & b4;
        s[1] = b1 ^ ~b3 & b5;
        s[10] = b10 ^ ~b12 & b14;
        s[11] = b11 ^ ~b13 & b15;
        s[20] = b20 ^ ~b22 & b24;
        s[21] = b21 ^ ~b23 & b25;
        s[30] = b30 ^ ~b32 & b34;
        s[31] = b31 ^ ~b33 & b35;
        s[40] = b40 ^ ~b42 & b44;
        s[41] = b41 ^ ~b43 & b45;
        s[2] = b2 ^ ~b4 & b6;
        s[3] = b3 ^ ~b5 & b7;
        s[12] = b12 ^ ~b14 & b16;
        s[13] = b13 ^ ~b15 & b17;
        s[22] = b22 ^ ~b24 & b26;
        s[23] = b23 ^ ~b25 & b27;
        s[32] = b32 ^ ~b34 & b36;
        s[33] = b33 ^ ~b35 & b37;
        s[42] = b42 ^ ~b44 & b46;
        s[43] = b43 ^ ~b45 & b47;
        s[4] = b4 ^ ~b6 & b8;
        s[5] = b5 ^ ~b7 & b9;
        s[14] = b14 ^ ~b16 & b18;
        s[15] = b15 ^ ~b17 & b19;
        s[24] = b24 ^ ~b26 & b28;
        s[25] = b25 ^ ~b27 & b29;
        s[34] = b34 ^ ~b36 & b38;
        s[35] = b35 ^ ~b37 & b39;
        s[44] = b44 ^ ~b46 & b48;
        s[45] = b45 ^ ~b47 & b49;
        s[6] = b6 ^ ~b8 & b0;
        s[7] = b7 ^ ~b9 & b1;
        s[16] = b16 ^ ~b18 & b10;
        s[17] = b17 ^ ~b19 & b11;
        s[26] = b26 ^ ~b28 & b20;
        s[27] = b27 ^ ~b29 & b21;
        s[36] = b36 ^ ~b38 & b30;
        s[37] = b37 ^ ~b39 & b31;
        s[46] = b46 ^ ~b48 & b40;
        s[47] = b47 ^ ~b49 & b41;
        s[8] = b8 ^ ~b0 & b2;
        s[9] = b9 ^ ~b1 & b3;
        s[18] = b18 ^ ~b10 & b12;
        s[19] = b19 ^ ~b11 & b13;
        s[28] = b28 ^ ~b20 & b22;
        s[29] = b29 ^ ~b21 & b23;
        s[38] = b38 ^ ~b30 & b32;
        s[39] = b39 ^ ~b31 & b33;
        s[48] = b48 ^ ~b40 & b42;
        s[49] = b49 ^ ~b41 & b43;
        s[0] ^= $379dc411a289a3b3$var$RC[n];
        s[1] ^= $379dc411a289a3b3$var$RC[n + 1];
    }
};
var $379dc411a289a3b3$var$keccak = function keccak(bits) {
    return function(str) {
        var msg;
        if (str.slice(0, 2) === "0x") {
            msg = [];
            for(var i = 2, l = str.length; i < l; i += 2)msg.push(parseInt(str.slice(i, i + 2), 16));
        } else msg = str;
        return $379dc411a289a3b3$var$update($379dc411a289a3b3$var$Keccak(bits, bits), msg);
    };
};
$379dc411a289a3b3$exports = {
    keccak256: $379dc411a289a3b3$var$keccak(256),
    keccak512: $379dc411a289a3b3$var$keccak(512),
    keccak256s: $379dc411a289a3b3$var$keccak(256),
    keccak512s: $379dc411a289a3b3$var$keccak(512)
};


var $b96252fb1d3e38ac$require$keccak = $379dc411a289a3b3$exports.keccak256;

var $b96252fb1d3e38ac$var$swarmHashBlock = function swarmHashBlock(length, data) {
    var lengthEncoded = $b6117eff6ec09ce0$exports.reverse($b6117eff6ec09ce0$exports.pad(6, $b6117eff6ec09ce0$exports.fromNumber(length)));
    var bytes = $b6117eff6ec09ce0$exports.flatten([
        lengthEncoded,
        "0x0000",
        data
    ]);
    return $b96252fb1d3e38ac$require$keccak(bytes).slice(2);
}; // (Bytes | Uint8Array | String) -> String
var $b96252fb1d3e38ac$var$swarmHash = function swarmHash(data) {
    if (typeof data === "string" && data.slice(0, 2) !== "0x") data = $b6117eff6ec09ce0$exports.fromString(data);
    else if (typeof data !== "string" && data.length !== undefined) data = $b6117eff6ec09ce0$exports.fromUint8Array(data);
    var length = $b6117eff6ec09ce0$exports.length(data);
    if (length <= 4096) return $b96252fb1d3e38ac$var$swarmHashBlock(length, data);
    var maxSize = 4096;
    while(maxSize * 128 < length)maxSize *= 128;
    var innerNodes = [];
    for(var i = 0; i < length; i += maxSize){
        var size = maxSize < length - i ? maxSize : length - i;
        innerNodes.push(swarmHash($b6117eff6ec09ce0$exports.slice(data, i, i + size)));
    }
    return $b96252fb1d3e38ac$var$swarmHashBlock(length, $b6117eff6ec09ce0$exports.flatten(innerNodes));
};
$b96252fb1d3e38ac$exports = $b96252fb1d3e38ac$var$swarmHash;


var $72b14a3ccbbe0792$exports = {};
var $72b14a3ccbbe0792$var$picker = function picker(type) {
    return function() {
        return new Promise(function(resolve, reject) {
            var fileLoader = function fileLoader(e) {
                var directory = {};
                var totalFiles = e.target.files.length;
                var loadedFiles = 0;
                [].map.call(e.target.files, function(file) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        var data = new Uint8Array(e.target.result);
                        if (type === "directory") {
                            var path = file.webkitRelativePath;
                            directory[path.slice(path.indexOf("/") + 1)] = {
                                type: "text/plain",
                                data: data
                            };
                            if (++loadedFiles === totalFiles) resolve(directory);
                        } else if (type === "file") {
                            var _path = file.webkitRelativePath;
                            resolve({
                                "type": mimetype.lookup(_path),
                                "data": data
                            });
                        } else resolve(data);
                    };
                    reader.readAsArrayBuffer(file);
                });
            };
            var fileInput;
            if (type === "directory") {
                fileInput = document.createElement("input");
                fileInput.addEventListener("change", fileLoader);
                fileInput.type = "file";
                fileInput.webkitdirectory = true;
                fileInput.mozdirectory = true;
                fileInput.msdirectory = true;
                fileInput.odirectory = true;
                fileInput.directory = true;
            } else {
                fileInput = document.createElement("input");
                fileInput.addEventListener("change", fileLoader);
                fileInput.type = "file";
            }
            var mouseEvent = document.createEvent("MouseEvents");
            mouseEvent.initEvent("click", true, false);
            fileInput.dispatchEvent(mouseEvent);
        });
    };
};
$72b14a3ccbbe0792$exports = {
    data: $72b14a3ccbbe0792$var$picker("data"),
    file: $72b14a3ccbbe0792$var$picker("file"),
    directory: $72b14a3ccbbe0792$var$picker("directory")
};


var $e0942d396c44d8b9$exports = {};
// TODO: this is a temporary fix to hide those libraries from the browser. A
// slightly better long-term solution would be to split this file into two,
// separating the functions that are used on Node.js from the functions that
// are used only on the browser.
$e0942d396c44d8b9$exports = function(_ref) {
    var fs = _ref.fs, files = _ref.files, os = _ref.os, path = _ref.path, child_process = _ref.child_process, mimetype = _ref.mimetype, defaultArchives = _ref.defaultArchives, request = _ref.request, downloadUrl = _ref.downloadUrl, bytes = _ref.bytes, hash = _ref.hash, pick = _ref.pick;
    // ∀ a . String -> JSON -> Map String a -o Map String a
    //   Inserts a key/val pair in an object impurely.
    var impureInsert = function impureInsert(key) {
        return function(val) {
            return function(map) {
                return map[key] = val, map;
            };
        };
    }; // String -> JSON -> Map String JSON
    //   Merges an array of keys and an array of vals into an object.
    var toMap = function toMap(keys) {
        return function(vals) {
            var map = {};
            for(var i = 0, l = keys.length; i < l; ++i)map[keys[i]] = vals[i];
            return map;
        };
    }; // ∀ a . Map String a -> Map String a -> Map String a
    //   Merges two maps into one.
    var merge = function merge(a) {
        return function(b) {
            var map = {};
            for(var key in a)map[key] = a[key];
            for(var _key in b)map[_key] = b[_key];
            return map;
        };
    }; // ∀ a . [a] -> [a] -> Bool
    var equals = function equals(a) {
        return function(b) {
            if (a.length !== b.length) return false;
            else for(var i = 0, l = a.length; i < l; ++i){
                if (a[i] !== b[i]) return false;
            }
            return true;
        };
    }; // String -> String -> String
    var rawUrl = function rawUrl(swarmUrl) {
        return function(hash) {
            return "".concat(swarmUrl, "/bzz-raw:/").concat(hash);
        };
    }; // String -> String -> Promise Uint8Array
    //   Gets the raw contents of a Swarm hash address.
    var downloadData = function downloadData(swarmUrl) {
        return function(hash) {
            return new Promise(function(resolve, reject) {
                request(rawUrl(swarmUrl)(hash), {
                    responseType: "arraybuffer"
                }, function(err, arrayBuffer, response) {
                    if (err) return reject(err);
                    if (response.statusCode >= 400) return reject(new Error("Error ".concat(response.statusCode, ".")));
                    return resolve(new Uint8Array(arrayBuffer));
                });
            });
        };
    }; // type Entry = {"type": String, "hash": String}
    // type File = {"type": String, "data": Uint8Array}
    // String -> String -> Promise (Map String Entry)
    //   Solves the manifest of a Swarm address recursively.
    //   Returns a map from full paths to entries.
    var downloadEntries = function downloadEntries(swarmUrl) {
        return function(hash) {
            var search = function search(hash) {
                return function(path) {
                    return function(routes) {
                        // Formats an entry to the Swarm.js type.
                        var format = function format(entry) {
                            return {
                                type: entry.contentType,
                                hash: entry.hash
                            };
                        }; // To download a single entry:
                        //   if type is bzz-manifest, go deeper
                        //   if not, add it to the routing table
                        var downloadEntry = function downloadEntry(entry) {
                            if (entry.path === undefined) return Promise.resolve();
                            else return entry.contentType === "application/bzz-manifest+json" ? search(entry.hash)(path + entry.path)(routes) : Promise.resolve(impureInsert(path + entry.path)(format(entry))(routes));
                        }; // Downloads the initial manifest and then each entry.
                        return downloadData(swarmUrl)(hash).then(function(text) {
                            return JSON.parse(toString(text)).entries;
                        }).then(function(entries) {
                            return Promise.all(entries.map(downloadEntry));
                        }).then(function() {
                            return routes;
                        });
                    };
                };
            };
            return search(hash)("")({});
        };
    }; // String -> String -> Promise (Map String String)
    //   Same as `downloadEntries`, but returns only hashes (no types).
    var downloadRoutes = function downloadRoutes(swarmUrl) {
        return function(hash) {
            return downloadEntries(swarmUrl)(hash).then(function(entries) {
                return toMap(Object.keys(entries))(Object.keys(entries).map(function(route) {
                    return entries[route].hash;
                }));
            });
        };
    }; // String -> String -> Promise (Map String File)
    //   Gets the entire directory tree in a Swarm address.
    //   Returns a promise mapping paths to file contents.
    var downloadDirectory = function downloadDirectory(swarmUrl) {
        return function(hash) {
            return downloadEntries(swarmUrl)(hash).then(function(entries) {
                var paths = Object.keys(entries);
                var hashs = paths.map(function(path) {
                    return entries[path].hash;
                });
                var types = paths.map(function(path) {
                    return entries[path].type;
                });
                var datas = hashs.map(downloadData(swarmUrl));
                var files = function files(datas) {
                    return datas.map(function(data, i) {
                        return {
                            type: types[i],
                            data: data
                        };
                    });
                };
                return Promise.all(datas).then(function(datas) {
                    return toMap(paths)(files(datas));
                });
            });
        };
    }; // String -> String -> String -> Promise String
    //   Gets the raw contents of a Swarm hash address.
    //   Returns a promise with the downloaded file path.
    var downloadDataToDisk = function downloadDataToDisk(swarmUrl) {
        return function(hash) {
            return function(filePath) {
                return files.download(rawUrl(swarmUrl)(hash))(filePath);
            };
        };
    }; // String -> String -> String -> Promise (Map String String)
    //   Gets the entire directory tree in a Swarm address.
    //   Returns a promise mapping paths to file contents.
    var downloadDirectoryToDisk = function downloadDirectoryToDisk(swarmUrl) {
        return function(hash) {
            return function(dirPath) {
                return downloadRoutes(swarmUrl)(hash).then(function(routingTable) {
                    var downloads = [];
                    for(var route in routingTable)if (route.length > 0) {
                        var filePath = path.join(dirPath, route);
                        downloads.push(downloadDataToDisk(swarmUrl)(routingTable[route])(filePath));
                    }
                    return Promise.all(downloads).then(function() {
                        return dirPath;
                    });
                });
            };
        };
    }; // String -> Uint8Array -> Promise String
    //   Uploads raw data to Swarm.
    //   Returns a promise with the uploaded hash.
    var uploadData = function uploadData(swarmUrl) {
        return function(data) {
            return new Promise(function(resolve, reject) {
                var params = {
                    body: typeof data === "string" ? fromString(data) : data,
                    method: "POST"
                };
                request("".concat(swarmUrl, "/bzz-raw:/"), params, function(err, data) {
                    if (err) return reject(err);
                    return resolve(data);
                });
            });
        };
    }; // String -> String -> String -> File -> Promise String
    //   Uploads a file to the Swarm manifest at a given hash, under a specific
    //   route. Returns a promise containing the uploaded hash.
    //   FIXME: for some reasons Swarm-Gateways is sometimes returning
    //   error 404 (bad request), so we retry up to 3 times. Why?
    var uploadToManifest = function uploadToManifest(swarmUrl) {
        return function(hash) {
            return function(route) {
                return function(file) {
                    var attempt = function attempt(n) {
                        var slashRoute = route[0] === "/" ? route : "/" + route;
                        var url = "".concat(swarmUrl, "/bzz:/").concat(hash).concat(slashRoute);
                        var opt = {
                            method: "PUT",
                            headers: {
                                "Content-Type": file.type
                            },
                            body: file.data
                        };
                        return new Promise(function(resolve, reject) {
                            request(url, opt, function(err, data) {
                                if (err) return reject(err);
                                if (data.indexOf("error") !== -1) return reject(data);
                                return resolve(data);
                            });
                        })["catch"](function(e) {
                            return n > 0 && attempt(n - 1);
                        });
                    };
                    return attempt(3);
                };
            };
        };
    }; // String -> {type: String, data: Uint8Array} -> Promise String
    var uploadFile = function uploadFile(swarmUrl) {
        return function(file) {
            return uploadDirectory(swarmUrl)({
                "": file
            });
        };
    }; // String -> String -> Promise String
    var uploadFileFromDisk = function uploadFileFromDisk(swarmUrl) {
        return function(filePath) {
            return fs.readFile(filePath).then(function(data) {
                return uploadFile(swarmUrl)({
                    type: mimetype.lookup(filePath),
                    data: data
                });
            });
        };
    }; // String -> Map String File -> Promise String
    //   Uploads a directory to Swarm. The directory is
    //   represented as a map of routes and files.
    //   A default path is encoded by having a "" route.
    var uploadDirectory = function uploadDirectory(swarmUrl) {
        return function(directory) {
            return uploadData(swarmUrl)("{}").then(function(hash) {
                var uploadRoute = function uploadRoute(route) {
                    return function(hash) {
                        return uploadToManifest(swarmUrl)(hash)(route)(directory[route]);
                    };
                };
                var uploadToHash = function uploadToHash(hash, route) {
                    return hash.then(uploadRoute(route));
                };
                return Object.keys(directory).reduce(uploadToHash, Promise.resolve(hash));
            });
        };
    }; // String -> Promise String
    var uploadDataFromDisk = function uploadDataFromDisk(swarmUrl) {
        return function(filePath) {
            return fs.readFile(filePath).then(uploadData(swarmUrl));
        };
    }; // String -> Nullable String -> String -> Promise String
    var uploadDirectoryFromDisk = function uploadDirectoryFromDisk(swarmUrl) {
        return function(defaultPath) {
            return function(dirPath) {
                return files.directoryTree(dirPath).then(function(fullPaths) {
                    return Promise.all(fullPaths.map(function(path) {
                        return fs.readFile(path);
                    })).then(function(datas) {
                        var paths = fullPaths.map(function(path) {
                            return path.slice(dirPath.length);
                        });
                        var types = fullPaths.map(function(path) {
                            return mimetype.lookup(path) || "text/plain";
                        });
                        return toMap(paths)(datas.map(function(data, i) {
                            return {
                                type: types[i],
                                data: data
                            };
                        }));
                    });
                }).then(function(directory) {
                    return merge(defaultPath ? {
                        "": directory[defaultPath]
                    } : {})(directory);
                }).then(uploadDirectory(swarmUrl));
            };
        };
    }; // String -> UploadInfo -> Promise String
    //   Simplified multi-type upload which calls the correct
    //   one based on the type of the argument given.
    var _upload = function upload(swarmUrl) {
        return function(arg) {
            // Upload raw data from browser
            if (arg.pick === "data") return pick.data().then(uploadData(swarmUrl)); // Upload a file from browser
            else if (arg.pick === "file") return pick.file().then(uploadFile(swarmUrl)); // Upload a directory from browser
            else if (arg.pick === "directory") return pick.directory().then(uploadDirectory(swarmUrl)); // Upload directory/file from disk
            else if (arg.path) switch(arg.kind){
                case "data":
                    return uploadDataFromDisk(swarmUrl)(arg.path);
                case "file":
                    return uploadFileFromDisk(swarmUrl)(arg.path);
                case "directory":
                    return uploadDirectoryFromDisk(swarmUrl)(arg.defaultFile)(arg.path);
            }
            else if (arg.length || typeof arg === "string") return uploadData(swarmUrl)(arg); // Upload directory with JSON
            else if (arg instanceof Object) return uploadDirectory(swarmUrl)(arg);
            return Promise.reject(new Error("Bad arguments"));
        };
    }; // String -> String -> Nullable String -> Promise (String | Uint8Array | Map String Uint8Array)
    //   Simplified multi-type download which calls the correct function based on
    //   the type of the argument given, and on whether the Swwarm address has a
    //   directory or a file.
    var _download = function download(swarmUrl) {
        return function(hash) {
            return function(path) {
                return isDirectory(swarmUrl)(hash).then(function(isDir) {
                    if (isDir) return path ? downloadDirectoryToDisk(swarmUrl)(hash)(path) : downloadDirectory(swarmUrl)(hash);
                    else return path ? downloadDataToDisk(swarmUrl)(hash)(path) : downloadData(swarmUrl)(hash);
                });
            };
        };
    }; // String -> Promise String
    //   Downloads the Swarm binaries into a path. Returns a promise that only
    //   resolves when the exact Swarm file is there, and verified to be correct.
    //   If it was already there to begin with, skips the download.
    var downloadBinary = function downloadBinary(path, archives) {
        var system = os.platform().replace("win32", "windows") + "-" + (os.arch() === "x64" ? "amd64" : "386");
        var archive = (archives || defaultArchives)[system];
        var archiveUrl = downloadUrl + archive.archive + ".tar.gz";
        var archiveMD5 = archive.archiveMD5;
        var binaryMD5 = archive.binaryMD5;
        return files.safeDownloadArchived(archiveUrl)(archiveMD5)(binaryMD5)(path);
    }; // type SwarmSetup = {
    //   account : String,
    //   password : String,
    //   dataDir : String,
    //   binPath : String,
    //   ensApi : String,
    //   onDownloadProgress : Number ~> (),
    //   archives : [{
    //     archive: String,
    //     binaryMD5: String,
    //     archiveMD5: String
    //   }]
    // }
    // SwarmSetup ~> Promise Process
    //   Starts the Swarm process.
    var startProcess = function startProcess(swarmSetup) {
        return new Promise(function(resolve, reject) {
            var spawn = child_process.spawn;
            var hasString = function hasString(str) {
                return function(buffer) {
                    return ("" + buffer).indexOf(str) !== -1;
                };
            };
            var account = swarmSetup.account, password = swarmSetup.password, dataDir = swarmSetup.dataDir, ensApi = swarmSetup.ensApi, privateKey = swarmSetup.privateKey;
            var STARTUP_TIMEOUT_SECS = 3;
            var WAITING_PASSWORD = 0;
            var STARTING = 1;
            var LISTENING = 2;
            var PASSWORD_PROMPT_HOOK = "Passphrase";
            var LISTENING_HOOK = "Swarm http proxy started";
            var state = WAITING_PASSWORD;
            var swarmProcess = spawn(swarmSetup.binPath, [
                "--bzzaccount",
                account || privateKey,
                "--datadir",
                dataDir,
                "--ens-api",
                ensApi
            ]);
            var handleProcessOutput = function handleProcessOutput(data) {
                if (state === WAITING_PASSWORD && hasString(PASSWORD_PROMPT_HOOK)(data)) setTimeout(function() {
                    state = STARTING;
                    swarmProcess.stdin.write(password + "\n");
                }, 500);
                else if (hasString(LISTENING_HOOK)(data)) {
                    state = LISTENING;
                    clearTimeout(timeout);
                    resolve(swarmProcess);
                }
            };
            swarmProcess.stdout.on("data", handleProcessOutput);
            swarmProcess.stderr.on("data", handleProcessOutput); //swarmProcess.on('close', () => setTimeout(restart, 2000));
            var restart = function restart() {
                return startProcess(swarmSetup).then(resolve)["catch"](reject);
            };
            var error = function error() {
                return reject(new Error("Couldn't start swarm process."));
            };
            var timeout = setTimeout(error, 20000);
        });
    }; // Process ~> Promise ()
    //   Stops the Swarm process.
    var stopProcess = function stopProcess(process) {
        return new Promise(function(resolve, reject) {
            process.stderr.removeAllListeners("data");
            process.stdout.removeAllListeners("data");
            process.stdin.removeAllListeners("error");
            process.removeAllListeners("error");
            process.removeAllListeners("exit");
            process.kill("SIGINT");
            var killTimeout = setTimeout(function() {
                return process.kill("SIGKILL");
            }, 8000);
            process.once("close", function() {
                clearTimeout(killTimeout);
                resolve();
            });
        });
    }; // SwarmSetup -> (SwarmAPI -> Promise ()) -> Promise ()
    //   Receives a Swarm configuration object and a callback function. It then
    //   checks if a local Swarm node is running. If no local Swarm is found, it
    //   downloads the Swarm binaries to the dataDir (if not there), checksums,
    //   starts the Swarm process and calls the callback function with an API
    //   object using the local node. That callback must return a promise which
    //   will resolve when it is done using the API, so that this function can
    //   close the Swarm process properly. Returns a promise that resolves when the
    //   user is done with the API and the Swarm process is closed.
    //   TODO: check if Swarm process is already running (improve `isAvailable`)
    var local = function local(swarmSetup) {
        return function(useAPI) {
            return _isAvailable("http://localhost:8500").then(function(isAvailable) {
                return isAvailable ? useAPI(at("http://localhost:8500")).then(function() {}) : downloadBinary(swarmSetup.binPath, swarmSetup.archives).onData(function(data) {
                    return (swarmSetup.onProgress || function() {})(data.length);
                }).then(function() {
                    return startProcess(swarmSetup);
                }).then(function(process) {
                    return useAPI(at("http://localhost:8500")).then(function() {
                        return process;
                    });
                }).then(stopProcess);
            });
        };
    }; // String ~> Promise Bool
    //   Returns true if Swarm is available on `url`.
    //   Perfoms a test upload to determine that.
    //   TODO: improve this?
    var _isAvailable = function isAvailable(swarmUrl) {
        var testFile = "test";
        var testHash = "c9a99c7d326dcc6316f32fe2625b311f6dc49a175e6877681ded93137d3569e7";
        return uploadData(swarmUrl)(testFile).then(function(hash) {
            return hash === testHash;
        })["catch"](function() {
            return false;
        });
    }; // String -> String ~> Promise Bool
    //   Returns a Promise which is true if that Swarm address is a directory.
    //   Determines that by checking that it (i) is a JSON, (ii) has a .entries.
    //   TODO: improve this?
    var isDirectory = function isDirectory(swarmUrl) {
        return function(hash) {
            return downloadData(swarmUrl)(hash).then(function(data) {
                try {
                    return !!JSON.parse(toString(data)).entries;
                } catch (e) {
                    return false;
                }
            });
        };
    }; // Uncurries a function; used to allow the f(x,y,z) style on exports.
    var uncurry = function uncurry(f) {
        return function(a, b, c, d, e) {
            var p; // Hardcoded because efficiency (`arguments` is very slow).
            if (typeof a !== "undefined") p = f(a);
            if (typeof b !== "undefined") p = f(b);
            if (typeof c !== "undefined") p = f(c);
            if (typeof d !== "undefined") p = f(d);
            if (typeof e !== "undefined") p = f(e);
            return p;
        };
    }; // () -> Promise Bool
    //   Not sure how to mock Swarm to test it properly. Ideas?
    var test = function test() {
        return Promise.resolve(true);
    }; // Uint8Array -> String
    var toString = function toString(uint8Array) {
        return bytes.toString(bytes.fromUint8Array(uint8Array));
    }; // String -> Uint8Array
    var fromString = function fromString(string) {
        return bytes.toUint8Array(bytes.fromString(string));
    }; // String -> SwarmAPI
    //   Fixes the `swarmUrl`, returning an API where you don't have to pass it.
    var at = function at(swarmUrl) {
        return {
            download: function download(hash, path) {
                return _download(swarmUrl)(hash)(path);
            },
            downloadData: uncurry(downloadData(swarmUrl)),
            downloadDataToDisk: uncurry(downloadDataToDisk(swarmUrl)),
            downloadDirectory: uncurry(downloadDirectory(swarmUrl)),
            downloadDirectoryToDisk: uncurry(downloadDirectoryToDisk(swarmUrl)),
            downloadEntries: uncurry(downloadEntries(swarmUrl)),
            downloadRoutes: uncurry(downloadRoutes(swarmUrl)),
            isAvailable: function isAvailable() {
                return _isAvailable(swarmUrl);
            },
            upload: function upload(arg) {
                return _upload(swarmUrl)(arg);
            },
            uploadData: uncurry(uploadData(swarmUrl)),
            uploadFile: uncurry(uploadFile(swarmUrl)),
            uploadFileFromDisk: uncurry(uploadFile(swarmUrl)),
            uploadDataFromDisk: uncurry(uploadDataFromDisk(swarmUrl)),
            uploadDirectory: uncurry(uploadDirectory(swarmUrl)),
            uploadDirectoryFromDisk: uncurry(uploadDirectoryFromDisk(swarmUrl)),
            uploadToManifest: uncurry(uploadToManifest(swarmUrl)),
            pick: pick,
            hash: hash,
            fromString: fromString,
            toString: toString
        };
    };
    return {
        at: at,
        local: local,
        download: _download,
        downloadBinary: downloadBinary,
        downloadData: downloadData,
        downloadDataToDisk: downloadDataToDisk,
        downloadDirectory: downloadDirectory,
        downloadDirectoryToDisk: downloadDirectoryToDisk,
        downloadEntries: downloadEntries,
        downloadRoutes: downloadRoutes,
        isAvailable: _isAvailable,
        startProcess: startProcess,
        stopProcess: stopProcess,
        upload: _upload,
        uploadData: uploadData,
        uploadDataFromDisk: uploadDataFromDisk,
        uploadFile: uploadFile,
        uploadFileFromDisk: uploadFileFromDisk,
        uploadDirectory: uploadDirectory,
        uploadDirectoryFromDisk: uploadDirectoryFromDisk,
        uploadToManifest: uploadToManifest,
        pick: pick,
        hash: hash,
        fromString: fromString,
        toString: toString
    };
};


$7ee3de06250ed7b7$exports = $e0942d396c44d8b9$exports({
    fs: $7ee3de06250ed7b7$var$fs,
    files: $7ee3de06250ed7b7$var$files,
    os: $7ee3de06250ed7b7$var$os,
    path: $7ee3de06250ed7b7$var$path,
    child_process: $7ee3de06250ed7b7$var$child_process,
    defaultArchives: $7ee3de06250ed7b7$var$defaultArchives,
    mimetype: $7ee3de06250ed7b7$var$mimetype,
    request: $d31b01d8489ccd6f$exports,
    downloadUrl: $7ee3de06250ed7b7$var$downloadUrl,
    bytes: $b6117eff6ec09ce0$exports,
    hash: $b96252fb1d3e38ac$exports,
    pick: $72b14a3ccbbe0792$exports
});


var $a580d7cb1d0f0bfa$var$Bzz = function Bzz(provider) {
    this.givenProvider = Bzz.givenProvider;
    if (provider && provider._requestManager) provider = provider.currentProvider;
    // only allow file picker when in browser
    if (typeof document !== "undefined") this.pick = $7ee3de06250ed7b7$exports.pick;
    this.setProvider(provider);
};
// set default ethereum provider
/* jshint ignore:start */ $a580d7cb1d0f0bfa$var$Bzz.givenProvider = null;
if (typeof ethereum !== "undefined" && ethereum.bzz) $a580d7cb1d0f0bfa$var$Bzz.givenProvider = ethereum.bzz;
/* jshint ignore:end */ $a580d7cb1d0f0bfa$var$Bzz.prototype.setProvider = function(provider) {
    // is ethereum provider
    if (!!provider && typeof provider === "object" && typeof provider.bzz === "string") provider = provider.bzz;
    // else if(!_.isString(provider)) {
    //      provider = 'http://swarm-gateways.net'; // default to gateway
    // }
    if (typeof provider === "string") this.currentProvider = provider;
    else {
        this.currentProvider = null;
        var noProviderError = new Error("No provider set, please set one using bzz.setProvider().");
        this.download = this.upload = this.isAvailable = function() {
            throw noProviderError;
        };
        return false;
    }
    // add functions
    this.download = $7ee3de06250ed7b7$exports.at(provider).download;
    this.upload = $7ee3de06250ed7b7$exports.at(provider).upload;
    this.isAvailable = $7ee3de06250ed7b7$exports.at(provider).isAvailable;
    return true;
};
$a580d7cb1d0f0bfa$exports = $a580d7cb1d0f0bfa$var$Bzz;



var $hpg7W = parcelRequire("hpg7W");
var $45dd0a73038568f0$var$Web3 = function Web3() {
    var _this = this;
    // sets _requestmanager etc
    $c0d140841aa0e2a6$exports.packageInit(this, arguments);
    this.version = $45dd0a73038568f0$require$version;
    this.utils = $hpg7W;
    this.eth = new $214a994bad7e103b$exports(this);
    this.shh = new $d131bc9f5cf99840$exports(this);
    this.bzz = new $a580d7cb1d0f0bfa$exports(this);
    // overwrite package setProvider
    var setProvider = this.setProvider;
    this.setProvider = function(provider, net) {
        /*jshint unused: false */ setProvider.apply(_this, arguments);
        _this.eth.setRequestManager(_this._requestManager);
        _this.shh.setRequestManager(_this._requestManager);
        _this.bzz.setProvider(provider);
        return true;
    };
};
$45dd0a73038568f0$var$Web3.version = $45dd0a73038568f0$require$version;
$45dd0a73038568f0$var$Web3.utils = $hpg7W;
$45dd0a73038568f0$var$Web3.modules = {
    Eth: $214a994bad7e103b$exports,
    Net: $db630ee0260f83ef$exports,
    Personal: $a2b78c5f45c1e37f$exports,
    Shh: $d131bc9f5cf99840$exports,
    Bzz: $a580d7cb1d0f0bfa$exports
};
$c0d140841aa0e2a6$exports.addProviders($45dd0a73038568f0$var$Web3);
$45dd0a73038568f0$exports = $45dd0a73038568f0$var$Web3;


var $f0cdcd484e868ccf$exports = {};
$f0cdcd484e868ccf$exports = JSON.parse('{"arkeoBondProviderTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"arkeo/BondProvider","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","provider":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","service":"test-service-string","bond":"10000"}}],"sequence":"90"},"arkeoModProviderTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"arkeo/ModProvider","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","provider":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","service":"test-service-string","metadata_uri":"https://www.example.com","metadata_nonce":69,"status":0,"min_contract_duration":420,"max_contract_duration":420,"subscription_rate":[{"amount":"1200","denom":"uarkeo"}],"pay_as_you_go_rate":[{"amount":"1542","denom":"uarkeo"}],"settlement_duration":94}}],"sequence":"90"},"arkeoOpenContractTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"arkeo/OpenContract","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","provider":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","service":"test-service-string","client":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","delegate":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","contract_type":0,"duration":0,"rate":[{"amount":"354","denom":"uarkeo"}],"deposit":"1000","settlement_duration":94,"authorization":0}}],"sequence":"90"},"arkeoCloseContractTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"arkeo/CloseContract","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","contract_id":82}}],"sequence":"90"},"arkeoClaimContractIncomeTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"arkeo/ClaimContractIncome","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","contract_id":28,"spender":"arkeovaloper1q4mlwtw3ncve72na65xacck557wcknc8j0lmke","signature":"qCgcA/DWCU04nmbvPyXNRx6yUGVzIgY8deDoenNmEcVKfakIzdKJmBLGKEEJEsS676aN6c6DzXfOKIS+YGYR8g==","nonce":48}}],"sequence":"90"},"arkeoClaimEthTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"claim/ClaimEth","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","eth_address":"0x95222290dd7278aa3ddd389cc1e1d165cc4bafe5","signature":"qCgcA/DWCU04nmbvPyXNRx6yUGVzIgY8deDoenNmEcVKfakIzdKJmBLGKEEJEsS676aN6c6DzXfOKIS+YGYR8g=="}}],"sequence":"90"},"arkeoClaimArkeoTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"claim/ClaimArkeo","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh"}}],"sequence":"90"},"arkeoTransferClaimTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"claim/TransferClaim","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","to_address":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh"}}],"sequence":"90"},"arkeoAddClaimTx":{"account_number":"97721","chain_id":"arkeo-mainnet-1","fee":{"amount":[{"amount":"2291","denom":"uarkeo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"claim/AddClaim","value":{"creator":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","chain":0,"address":"arkeo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7r7z5sh","amount":21827}}],"sequence":"90"}}');


var $293b5f44ba4827b5$exports = {};
$293b5f44ba4827b5$exports = JSON.parse('{"account_number":"34","chain_id":"Binance-Chain-Nile","data":"null","memo":"test","msgs":[{"inputs":[{"address":"bnb1afwh46v6nn30nkmugw5swdmsyjmlxslgjfugre","coins":[{"amount":1000000000,"denom":"BNB"}]}],"outputs":[{"address":"bnb1ss57e8sa7xnwq030k2ctr775uac9gjzg347gp4","coins":[{"amount":1000000000,"denom":"BNB"}]}]}],"sequence":"31","source":"1"}');


var $88e7e9916f6f95b0$exports = {};
$88e7e9916f6f95b0$exports = JSON.parse('{"txid":"fa80a9949f1094119195064462f54d0e0eabd3139becd4514ae635b8c7fe3a46","hash":"764ef1574ee2b262e4a84eb575d80461977364590ef424011cb09156db078710","version":1,"size":247,"vsize":165,"weight":658,"locktime":0,"vin":[{"txid":"86a6e02943dcd057cfbe349f2c2274478a3a1be908eb788606a6950e727a0d36","vout":0,"n":0,"scriptSig":{"asm":"001495f41f5c0e0ec2c7fe27f0ac4bd59a5632a40b5f","hex":"16001495f41f5c0e0ec2c7fe27f0ac4bd59a5632a40b5f"},"txinwitness":["3045022100f312e8246e6a00d21fd762f12231c5fb7a20094a32940b9a84e28d712a5ced9b02203b9124d7a94aa7eb1e090ceda32e884511d7068b8d47593aa46537900e3e37d401","037e8bf05c6c7223cfba3ea484ecd61ee910ae38609ea89b4a4839beed2186b3fb"],"sequence":4294967295,"addr":"3Bvy87TmQhhSBqfiCBh8w5yPx6usiDM8SY","valueSat":319488,"value":0.00319488}],"vout":[{"value":"0.00009426","n":0,"scriptPubKey":{"asm":"0 ece6935b2a5a5b5ff997c87370b16fa10f164410","hex":"0014ece6935b2a5a5b5ff997c87370b16fa10f164410","reqSigs":1,"addresses":["bc1qannfxke2tfd4l7vhepehpvt05y83v3qsf6nfkk"],"type":"witness_v0_keyhash"},"spentTxId":"7e58757f43015242c0efa29447bea4583336f2358fdff587b52bbe040ad8982a","spentIndex":0,"spentHeight":590093},{"value":"0.00309896","n":1,"scriptPubKey":{"asm":"OP_HASH160 dfe58cc93d35fb99e15436f47d3bbfce82032806 OP_EQUAL","hex":"a914dfe58cc93d35fb99e15436f47d3bbfce8203280687","reqSigs":1,"addresses":["3N6sbjPwa9L911fPxykD3XnGifMdVRMZPV"],"type":"scripthash"},"spentTxId":"50ccbc5916ea5e63e13acc03745bb4a7b00a41c5e30dbb352d6174b4fba17f41","spentIndex":0,"spentHeight":592303}],"blockhash":"00000000000000000017277948d61a631dae6cce1d7fb501301b825599189f51","blockheight":590093,"confirmations":45356,"time":1565797979,"blocktime":1565797979,"valueOut":0.00319322,"valueIn":0.00319488,"fees":0.00000166}');


var $94d076618d45bcea$exports = {};
$94d076618d45bcea$exports = JSON.parse('{"txid":"609410a9eac51cdce2b9c1911c7b8705bc566e164bca07ae25f2dee87b5b6a91","hash":"609410a9eac51cdce2b9c1911c7b8705bc566e164bca07ae25f2dee87b5b6a91","version":1,"size":372,"vsize":372,"weight":1488,"locktime":0,"vin":[{"txid":"034ad57367fb5ed70a28988a33951cac2b5bdf8dca10881e33ae9f8f6d43091b","vout":0,"n":0,"scriptSig":{"asm":"304502210081734b9b58d109997241c85806e6a5c97ba79f4a76ddb98eb227626b21ac1d290220534bee7f3f2a1803b851570b62825a589b5989f69afa44ddee5b591b8f822d3d[ALL] 03fa044f4e622a9dc7a877155efad20816c6994f95bd1dc21c339a820395a32e01","hex":"48304502210081734b9b58d109997241c85806e6a5c97ba79f4a76ddb98eb227626b21ac1d290220534bee7f3f2a1803b851570b62825a589b5989f69afa44ddee5b591b8f822d3d012103fa044f4e622a9dc7a877155efad20816c6994f95bd1dc21c339a820395a32e01"},"sequence":4294967295,"addr":"1LUEqRQv9NJZsfwEM2qqGrW4TVw5QeJd5r","valueSat":98690,"value":0.0009869},{"txid":"a15e513d6277597f2174499b1e99bbaba7ad2f6686cac0a8e2b2f101cf4eb6e4","vout":1,"n":1,"scriptSig":{"asm":"30450221008a2c95c61db777e15ebb7220c9a84565080ed87b97778a0417854fefa87e447202205dafb62309770a98868737d25bc7779caffa4b50993c36c93acf1f07a5d6d69b[ALL] 02000b4b1051a63e82eeede1f1990ab226685f83ba104a0946edc740e17ce2958b","hex":"4830450221008a2c95c61db777e15ebb7220c9a84565080ed87b97778a0417854fefa87e447202205dafb62309770a98868737d25bc7779caffa4b50993c36c93acf1f07a5d6d69b012102000b4b1051a63e82eeede1f1990ab226685f83ba104a0946edc740e17ce2958b"},"sequence":4294967295,"addr":"17xp6Jrjg1kHkSZGgydk7CP21uwTiRyM28","valueSat":1153125,"value":0.01153125}],"vout":[{"value":"0.00100000","n":0,"scriptPubKey":{"asm":"OP_HASH160 63c4b3af0eb54b8b58b07fbde95a4ab3af3b8735 OP_EQUAL","hex":"a91463c4b3af0eb54b8b58b07fbde95a4ab3af3b873587","reqSigs":1,"addresses":["3AnYTd2FGxJLNKL1AzxfW3FJMntp9D2KKX"],"type":"scripthash"},"spentTxId":"e3ae5bb9f7c8736ee2dd5944ef0fdfb4f20c428903784bcf5016c2fc66dc5caf","spentIndex":0,"spentHeight":574335},{"value":"0.01119823","n":1,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 30f7daeb4336f786cb0cf3bb162d83393681ca2d OP_EQUALVERIFY OP_CHECKSIG","hex":"76a91430f7daeb4336f786cb0cf3bb162d83393681ca2d88ac","reqSigs":1,"addresses":["15TvMVB5Bvgcw2KuxVQNCag8CUS8U1LgGy"],"type":"pubkeyhash"},"spentTxId":"158199f1c5de51769e0eef10bdf15e0a1e0fe3e462012a58ab5fde127752704c","spentIndex":0,"spentHeight":574334}],"blockhash":"00000000000000000029574332e9f7f1687b709008c14cda466cdd89c1fb1ba2","blockheight":574324,"confirmations":20093,"time":1556830423,"blocktime":1556830423,"valueOut":0.01219823,"valueIn":0.01251815,"fees":0.00031992}');


var $57de038c542806ea$exports = {};
$57de038c542806ea$exports = JSON.parse('{"txid":"b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea","hash":"b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea","version":1,"size":257,"vsize":257,"weight":1028,"locktime":0,"vin":[{"txid":"a3b6284d252846ce8305d50edd7239831dc291716ec1752918d876d6ea05f681","vout":1,"n":0,"scriptSig":{"asm":"304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce3[ALL] 045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43","hex":"47304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce30141045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43"},"sequence":4294967295,"addr":"1ParaEza5Ew5ioT5c8zR2wSSvArqiSQbpT","valueSat":989000,"value":0.00989}],"vout":[{"value":"0.00978000","n":0,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 f7b9e0239571434f0ccfdba6f772a6d23f2cfb13 OP_EQUALVERIFY OP_CHECKSIG","hex":"76a914f7b9e0239571434f0ccfdba6f772a6d23f2cfb1388ac","reqSigs":1,"addresses":["1ParaEza5Ew5ioT5c8zR2wSSvArqiSQbpT"],"type":"pubkeyhash"},"spentTxId":"171113f0745f570d18199efcb944b8f742fc590c700a41968081c5655338e4fc","spentIndex":0,"spentHeight":355935},{"value":"0.00010000","n":1,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 9c9d21f47382762df3ad81391ee0964b28dd9517 OP_EQUALVERIFY OP_CHECKSIG","hex":"76a9149c9d21f47382762df3ad81391ee0964b28dd951788ac","reqSigs":1,"addresses":["1FH6ehAd5ZFXCM1cLGzHxK1s4dGdq1JusM"],"type":"pubkeyhash"},"spentTxId":"84da2a3cc29a3e0fb8a3a28882c6fb59a426a95952d484ec2422c5a47b6f93d4","spentIndex":2,"spentHeight":370585}],"blockhash":"000000000000000005c60c504e109684bb0886ab95520ad6a5af0d384f587a6a","blockheight":335414,"confirmations":258975,"time":1419279547,"blocktime":1419279547,"valueOut":0.00988,"valueIn":0.00989,"fees":0.00001}');


var $4d7adfa066eb02fa$exports = {};
$4d7adfa066eb02fa$exports = JSON.parse('{"cosmosDelegateTx":{"account_number":"16359","chain_id":"cosmoshub-4","sequence":"18","fee":{"amount":[{"amount":"2800","denom":"uatom"}],"gas":"290000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgDelegate","value":{"delegator_address":"cosmos15cenya0tr7nm3tz2wn3h3zwkht2rxrq7q7h3dj","validator_address":"cosmosvaloper1qwl879nx9t6kef4supyazayf7vjhennyh568ys","amount":{"denom":"uatom","amount":"1000"}}}]},"cosmosIBCTransferTx":{"account_number":"16359","chain_id":"cosmoshub-4","sequence":"27","fee":{"amount":[{"amount":"2800","denom":"uatom"}],"gas":"290000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgTransfer","value":{"receiver":"osmo15cenya0tr7nm3tz2wn3h3zwkht2rxrq7g9ypmq","sender":"cosmos15cenya0tr7nm3tz2wn3h3zwkht2rxrq7q7h3dj","source_channel":"channel-141","source_port":"transfer","timeout_height":{"revision_height":"9339851","revision_number":"1"},"token":{"amount":"100","denom":"uatom"}}}]},"cosmosRedelegateTx":{"account_number":"16359","chain_id":"cosmoshub-4","sequence":"19","fee":{"amount":[{"amount":"2800","denom":"uosmo"}],"gas":"290000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgBeginRedelegate","value":{"delegator_address":"cosmos15cenya0tr7nm3tz2wn3h3zwkht2rxrq7q7h3dj","validator_src_address":"cosmosvaloper1qwl879nx9t6kef4supyazayf7vjhennyh568ys","validator_dst_address":"cosmosvaloper1qs8tnw2t8l6amtzvdemnnsq9dzk0ag0z52uzay","amount":{"denom":"uosmo","amount":"100"}}}]},"cosmosRewardsTx":{"account_number":"16359","chain_id":"cosmoshub-4","sequence":"19","fee":{"amount":[{"amount":"2800","denom":"uatom"}],"gas":"290000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgWithdrawDelegatorReward","value":{"delegator_address":"cosmos15cenya0tr7nm3tz2wn3h3zwkht2rxrq7q7h3dj","validator_address":"cosmosvaloper1qwl879nx9t6kef4supyazayf7vjhennyh568ys","amount":{"denom":"uatom","amount":"100"}}}]},"cosmosTransferTx":{"account_number":"16359","chain_id":"cosmoshub-4","fee":{"amount":[{"amount":"100","denom":"uatom"}],"gas":"100000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgSend","value":{"amount":[{"amount":"1000","denom":"uatom"}],"from_address":"cosmos1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5urlyk7s","to_address":"cosmos1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5urlyk7s"}}],"sequence":"17"},"cosmosUndelegateTx":{"account_number":"16359","chain_id":"cosmoshub-4","sequence":"20","fee":{"amount":[{"denom":"uatom","amount":"0"}],"gas":"250000"},"memo":"","msgs":[{"type":"cosmos-sdk/MsgUndelegate","value":{"delegator_address":"cosmos15cenya0tr7nm3tz2wn3h3zwkht2rxrq7q7h3dj","validator_address":"cosmosvaloper1qwl879nx9t6kef4supyazayf7vjhennyh568ys","amount":{"denom":"uatom","amount":"3000"}}}]}}');


var $bf89b3bc1e224bc1$exports = {};
$bf89b3bc1e224bc1$exports = JSON.parse('{"txid":"94b3bbe89e5106d93d07be311a543958fa0de127d4bf747e9102c43e92cbb55f","version":1,"locktime":0,"vin":[{"txid":"05c6043770f3cc1f34b46b7268ce5b343bd30821d33c002c3a70a94268126b81","vout":0,"sequence":4294967295,"n":0,"scriptSig":{"hex":"483045022100f23368614d166894e5c75e3a99413b72b30ce45d13c00a50e836380819582c8602206bee0e276d684c794becf27f23426d0da457fcfedbb8c4a86bd3657ca357ee1c0121036ac34cb12ac492c0eb0d1a07bd73a5a5f08bc6ba27b710276073704de9912921","asm":"3045022100f23368614d166894e5c75e3a99413b72b30ce45d13c00a50e836380819582c8602206bee0e276d684c794becf27f23426d0da457fcfedbb8c4a86bd3657ca357ee1c[ALL] 036ac34cb12ac492c0eb0d1a07bd73a5a5f08bc6ba27b710276073704de9912921"},"addr":"XexybzTUtH9V9eY4UJN2aCcBT3utan5C8N","valueSat":4956619,"value":0.04956619,"doubleSpentTxID":null}],"vout":[{"value":"0.04954359","n":0,"scriptPubKey":{"hex":"76a914ed52e17e6d182a28148c3719385ced4e30b5c0bb88ac","asm":"OP_DUP OP_HASH160 ed52e17e6d182a28148c3719385ced4e30b5c0bb OP_EQUALVERIFY OP_CHECKSIG","addresses":["XxKhGNv6ECbqVswm9KYcLPQnyWgZ86jJ6Q"],"type":"pubkeyhash"},"spentTxId":"0fc8d7fb0eb59aef1b96a696c1219461f587d45bede55df188b8b376d0ac3814","spentIndex":0,"spentHeight":1063634}],"blockhash":"000000000000000fe5f1ee531d76e3903faa318747ad9452975c588a7bcd1585","blockheight":1063623,"confirmations":226972,"time":1556830673,"blocktime":1556830673,"valueOut":0.04954359,"size":192,"valueIn":0.04956619,"fees":0.0000226,"txlock":false}');


var $5e5417a26c03d073$exports = {};
$5e5417a26c03d073$exports = JSON.parse('{"txid":"4ab8c81585bf61ddcba03f4b2f4958b3800d68b02874f4955e258775cb3e7068","version":1,"locktime":1495981,"vin":[{"txid":"8927d064aaedf6edf92f6597872043c80fdec99c78cbcc4e5f6ef0c7a8c83188","vout":1,"scriptSig":{"asm":"3044022070e25a73ceebaf5b3a35d5e4930ebba77957a2fe485b9dcbaf982a7c63d4baab02206e75dcc4258db29a2803d6a14112d3d81f93ec23f9b2a61bfe8102d764d7c63901 031b49bb2c43daac784377bcca83c41f781007626e6e8b66cda9f57fed11494359","hex":"473044022070e25a73ceebaf5b3a35d5e4930ebba77957a2fe485b9dcbaf982a7c63d4baab02206e75dcc4258db29a2803d6a14112d3d81f93ec23f9b2a61bfe8102d764d7c6390121031b49bb2c43daac784377bcca83c41f781007626e6e8b66cda9f57fed11494359"},"sequence":4294967294,"n":0,"addr":"D7dBxG6NAihBQRjM8jq1zozkfuRZgRf4i5","valueSat":14667689402,"value":146.67689402,"doubleSpentTxID":null,"isConfirmed":true,"confirmations":1394352,"unconfirmedInput":false},{"txid":"e9489e335aaf33981738b8a713b7a5b02e8be6aa0c169c0636b4a98eaca6a852","vout":0,"scriptSig":{"asm":"304402206b3aa1a4656d4859b87512a5fb50c73f0f6e05d45fa027850a3e1eb4f927675402201fb1c52d85380727d28bea7a21d434bed2d57d3a120082c6c69d578b4f3da07c01 033034cf66b3b153a81713b3ddbcdffd92c34c46510353cf01b237fcfbcf1348bd","hex":"47304402206b3aa1a4656d4859b87512a5fb50c73f0f6e05d45fa027850a3e1eb4f927675402201fb1c52d85380727d28bea7a21d434bed2d57d3a120082c6c69d578b4f3da07c0121033034cf66b3b153a81713b3ddbcdffd92c34c46510353cf01b237fcfbcf1348bd"},"sequence":4294967294,"n":1,"addr":"DG3sCu4vG7KhoAZDjJpoCWLALd8VHeQp6g","valueSat":3345000000,"value":33.45,"doubleSpentTxID":null,"isConfirmed":true,"confirmations":1394420,"unconfirmedInput":false},{"txid":"8eed6b2d569ef8a1877db6ccb64d7db1adcb46c5cfd63b917d07d9d98f93f635","vout":0,"scriptSig":{"asm":"3045022100a0e8a73fc2358a206a73a78582fd7ebba2fb08487aca78aaa89cbf7f9805da0102207704f4f27ff6297b11acd74f8e3f28d924c4006ac0d37dd37bbdba1ef8f401ae01 038ac65cabea63b92d3aabd3f17591c23bbec73b87220a3f0325fe2de9e62107e3","hex":"483045022100a0e8a73fc2358a206a73a78582fd7ebba2fb08487aca78aaa89cbf7f9805da0102207704f4f27ff6297b11acd74f8e3f28d924c4006ac0d37dd37bbdba1ef8f401ae0121038ac65cabea63b92d3aabd3f17591c23bbec73b87220a3f0325fe2de9e62107e3"},"sequence":4294967294,"n":2,"addr":"D8boNXiWsXUJTnTTFEjMLfYCPqrdujEeXF","valueSat":2121413063,"value":21.21413063,"doubleSpentTxID":null,"isConfirmed":true,"confirmations":1394663,"unconfirmedInput":false},{"txid":"270a194d3f42f2a2ac8bc022a030e6b1fee1dae73d5d19b4fd57ea604953cd07","vout":1,"scriptSig":{"asm":"304402203c89ade05e93ee9cb9bfa0703be55a76abd40330108a5e5272bcd0c8338c35df022042d8cb34275e87df1b77f19e9dde5da553b98bca67c1c332a53392b32d55ba5801 038291eee31aa046a00938dda548c0c948f57bf5dc6e534abbe0d5078a6ce083a0","hex":"47304402203c89ade05e93ee9cb9bfa0703be55a76abd40330108a5e5272bcd0c8338c35df022042d8cb34275e87df1b77f19e9dde5da553b98bca67c1c332a53392b32d55ba580121038291eee31aa046a00938dda548c0c948f57bf5dc6e534abbe0d5078a6ce083a0"},"sequence":4294967294,"n":3,"addr":"DP5XndqNyNk6jsQLAFwXU7W8FEqEtoYhNn","valueSat":16481789689,"value":164.81789689,"doubleSpentTxID":null,"isConfirmed":true,"confirmations":1394424,"unconfirmedInput":false}],"vout":[{"value":"8.38512056","n":0,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 6ef1cda5c24d47934853aeccce14163e3a18be13 OP_EQUALVERIFY OP_CHECKSIG","hex":"76a9146ef1cda5c24d47934853aeccce14163e3a18be1388ac","reqSigs":1,"type":"pubkeyhash","addresses":["DFFiY9ZGNWC45EMKZgumPUVjSQn7HW4WGM"]},"spentTxId":"7779835caf478e0607c0c8168bf34fe7806da515dfe43011fab2c1051f34bc6b","spentIndex":8,"spentTs":1481107519},{"value":"355.77380098","n":1,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 d3f096cbc84bd6daf7e7fe2700c32548ca2f23f1 OP_EQUALVERIFY OP_CHECKSIG","hex":"76a914d3f096cbc84bd6daf7e7fe2700c32548ca2f23f188ac","reqSigs":1,"type":"pubkeyhash","addresses":["DQTjL9vfXVbMfCGM49KWeYvvvNzRPaoiFp"]},"spentTxId":"13adfcd2de89b083193f2d0fbd8862ccfd85562bf6e2a1dda235eec5bd351b58","spentIndex":1,"spentTs":1481073187}],"blockhash":"ab7206171c028403f00fd054f6fa5118a44d40152a9bf2b9ec2668265e363901","confirmations":1394335,"time":1481065020,"blocktime":1481065020,"valueOut":364.15892154,"size":667,"valueIn":366.15892154,"fees":2}');


var $debc1b6f37124f07$exports = {};
$debc1b6f37124f07$exports = JSON.parse('{"eip712":{"longPrimaryTypeString":{"typedData":{"types":{"EIP712Domain":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"chainId","type":"uint256"},{"name":"verifyingContract","type":"address"},{"name":"salt","type":"bytes32"}],"Person":[{"name":"name","type":"string"},{"name":"wallet","type":"address"},{"name":"married","type":"bool"},{"name":"kids","type":"uint8"},{"name":"karma","type":"int16"},{"name":"secret","type":"bytes"},{"name":"small_secret","type":"bytes16"},{"name":"pets","type":"string[]"},{"name":"two_best_friends","type":"string[2]"}],"ThisIsARidiculouslyLongPrimaryTypeToForceHashesToBePrecalculatedByHDWalletKeepKey":[{"name":"from","type":"Person"},{"name":"to","type":"Person"},{"name":"messages","type":"string[]"}]},"primaryType":"ThisIsARidiculouslyLongPrimaryTypeToForceHashesToBePrecalculatedByHDWalletKeepKey","domain":{"name":"Ether Mail","version":"1","chainId":1,"verifyingContract":"0x1e0Ae8205e9726E6F296ab8869160A6423E2337E","salt":"0xca92da1a6e91d9358328d2f2155af143a7cb74b81a3a4e3e57e2191823dbb56c"},"message":{"from":{"name":"Amy","wallet":"0xc0004B62C5A39a728e4Af5bee0c6B4a4E54b15ad","married":true,"kids":2,"karma":4,"secret":"0x62c5a39a728e4af5bee0c6b462c5a39a728e4af5bee0c6b462c5a39a728e4af5bee0c6b462c5a39a728e4af5bee0c6b4","small_secret":"0x5ccf0e54367104795a47bc0481645d9e","pets":["parrot"],"two_best_friends":["Carl","Denis"]},"to":{"name":"Bob","wallet":"0x54B0Fa66A065748C40dCA2C7Fe125A2028CF9982","married":false,"kids":0,"karma":-4,"secret":"0x7fe125a2028cf97fe125a2028cf97fe125a2028cf97fe125a2028cf97fe125a2028cf97fe125a2028cf97fe125a2028cf9","small_secret":"0xa5e5c47b64775abc476d2962403258de","pets":["dog","cat"],"two_best_friends":["Emil","Franz"]},"messages":["Hello, Bob!","How are you?","Hope you\'re fine"]}}},"EIP712DomainIsPrimaryType":{"typedData":{"types":{"EIP712Domain":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"chainId","type":"uint256"},{"name":"verifyingContract","type":"address"}]},"domain":{"name":"USD Coin","version":"2","verifyingContract":"0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48","chainId":1},"primaryType":"EIP712Domain"}}},"txs":{"ethTxLegacy":{"addressNList":[2147483692,2147483708,2147483648,0,0],"nonce":"0x01","gasPrice":"0x1dcd65000","gasLimit":"0x5622","value":"0x2c68af0bb14000","to":"0x12eC06288EDD7Ae2CC41A843fE089237fC7354F0","chainId":1,"data":""},"ethTx1559":{"addressNList":[2147483692,2147483708,2147483648,0,0],"nonce":"0x0","gasLimit":"0x5ac3","maxFeePerGas":"0x16854be509","maxPriorityFeePerGas":"0x540ae480","value":"0x1550f7dca70000","to":"0xfc0cc6e85dff3d75e3985e0cb83b090cfd498dd1","chainId":1,"data":""}}}');


var $9d06e313e22802b4$exports = {};
$9d06e313e22802b4$exports = JSON.parse('{"openSeaListNFTMessage":{"types":{"EIP712Domain":[{"name":"name","type":"string"},{"name":"version","type":"string"},{"name":"chainId","type":"uint256"},{"name":"verifyingContract","type":"address"}],"OrderComponents":[{"name":"offerer","type":"address"},{"name":"zone","type":"address"},{"name":"offer","type":"OfferItem[]"},{"name":"consideration","type":"ConsiderationItem[]"},{"name":"orderType","type":"uint8"},{"name":"startTime","type":"uint256"},{"name":"endTime","type":"uint256"},{"name":"zoneHash","type":"bytes32"},{"name":"salt","type":"uint256"},{"name":"conduitKey","type":"bytes32"},{"name":"counter","type":"uint256"}],"OfferItem":[{"name":"itemType","type":"uint8"},{"name":"token","type":"address"},{"name":"identifierOrCriteria","type":"uint256"},{"name":"startAmount","type":"uint256"},{"name":"endAmount","type":"uint256"}],"ConsiderationItem":[{"name":"itemType","type":"uint8"},{"name":"token","type":"address"},{"name":"identifierOrCriteria","type":"uint256"},{"name":"startAmount","type":"uint256"},{"name":"endAmount","type":"uint256"},{"name":"recipient","type":"address"}]},"primaryType":"OrderComponents","domain":{"name":"Seaport","version":"1.5","chainId":137,"verifyingContract":"0x00000000000000ADc04C56Bf30aC9d3c0aAF14dC"},"message":{"offerer":"0x8c9Ed98b7C3961D22Cc871356C7b73d194608817","offer":[{"itemType":"2","token":"0xa9a6A3626993D487d2Dbda3173cf58cA1a9D9e9f","identifierOrCriteria":"64560424590441301826453812164224751707642265079650986418901366599236941237984","startAmount":"1","endAmount":"1"}],"consideration":[{"itemType":"1","token":"0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619","identifierOrCriteria":"0","startAmount":"194707500000000000","endAmount":"194707500000000000","recipient":"0x8c9Ed98b7C3961D22Cc871356C7b73d194608817"},{"itemType":"1","token":"0x7ceB23fD6bC0adD59E62ac25578270cFf1b9f619","identifierOrCriteria":"0","startAmount":"4992500000000000","endAmount":"4992500000000000","recipient":"0x0000a26b00c1F0DF003000390027140000fAa719"}],"startTime":"1696393777","endTime":"1699072168","orderType":0,"zone":"0x0000000000000000000000000000000000000000","zoneHash":"0x0000000000000000000000000000000000000000000000000000000000000000","salt":"24446860302761739304752683030156737591518664810215442929815805592127532436551","conduitKey":"0x0000007b02230091a7ed01230072f7006a004d60a8d4e71d599b8104250f0000","totalOriginalConsiderationItems":"2","counter":"0"}}}');


var $75df0a23b2bce7cc$exports = {};
$75df0a23b2bce7cc$exports = JSON.parse('{"txid":"1de79c706f34c81bbefad49a9ff8d12b6ca86b77605a1998505e4f8792a5892d","version":1,"locktime":0,"vin":[{"txid":"eaada9142c8878c333387250af2b1483322d1116f22ff358b9ab48f94e70f596","vout":1,"sequence":4294967295,"n":0,"scriptSig":{"hex":"47304402207c899ba5197a23b1f3cc4b3621abbc682b5142f3ae29af4b951952573f6c82a002203fd7f038aa8403d2c06fd32c237ab4e915939c25aafa7bcb06fb0ddd46afbfd3012103eddbce765b6d7ae1c91b779696e8b8f72ce444070f83beba2f823af76fd4dfeb","asm":"304402207c899ba5197a23b1f3cc4b3621abbc682b5142f3ae29af4b951952573f6c82a002203fd7f038aa8403d2c06fd32c237ab4e915939c25aafa7bcb06fb0ddd46afbfd3[ALL] 03eddbce765b6d7ae1c91b779696e8b8f72ce444070f83beba2f823af76fd4dfeb"},"addr":"LPYcdaKduHxY4i4FueHoT1TVhv3riCtTY2","valueSat":1895182,"value":0.01895182,"doubleSpentTxID":null}],"vout":[{"value":"0.00682128","n":0,"scriptPubKey":{"hex":"76a91491e975a0238fa1dfff703e50f062e2544a3e372088ac","asm":"OP_DUP OP_HASH160 91e975a0238fa1dfff703e50f062e2544a3e3720 OP_EQUALVERIFY OP_CHECKSIG","addresses":["LYXTv5RdsPYKC4qGmb6x6SuKoFMxUdSjLQ"],"type":"pubkeyhash"},"spentTxId":"ea0ed3755c894e3cb54c4db176c3b85b2b1b9cac05800dec51492105a073a1b3","spentIndex":0,"spentHeight":1624988},{"value":"0.01145254","n":1,"scriptPubKey":{"hex":"76a91415757f526dc67b52ae9f74918db532eebc39608688ac","asm":"OP_DUP OP_HASH160 15757f526dc67b52ae9f74918db532eebc396086 OP_EQUALVERIFY OP_CHECKSIG","addresses":["LMBRD6nXaRsez8hGwWZonxNiUez2VjCdoF"],"type":"pubkeyhash"},"spentTxId":"c1dcc4aa79dc3c48b8d3827a71265d2a46389b21b57ec887bce0f3849568bb16","spentIndex":1,"spentHeight":1629040}],"blockhash":"ba512c48df337d34a243827d90050910377d18466033685cc0e9641dc36da072","blockheight":1624988,"confirmations":75764,"time":1556828765,"blocktime":1556828765,"valueOut":0.01827382,"valueIn":0.01895182,"fees":0.000678}');


var $f4390fe5e7829991$exports = {};
$f4390fe5e7829991$exports = JSON.parse('{"mayachainUnsignedTx":{"fee":{"amount":[{"amount":"1","denom":"cacao"}],"gas":"200000"},"memo":"foobar","msg":[{"type":"mayachain/MsgSend","value":{"amount":[{"amount":"1","denom":"cacao"}],"from_address":"maya1ls33ayg26kmltw7jjy55p32ghjna09zp7z4etj","to_address":"maya1ls33ayg26kmltw7jjy55p32ghjna09zp7z4etj"}}],"signatures":null}}');


var $1057eab25da9e65c$exports = {};
$1057eab25da9e65c$exports = JSON.parse('{"osmosisSendTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgSend","value":{"amount":[{"amount":"10000","denom":"uosmo"}],"from_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","to_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz"}}],"sequence":"90"},"osmosisDelegateTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgDelegate","value":{"amount":{"amount":"1000","denom":"uosmo"},"delegator_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","validator_address":"osmovaloper1cyw4vw20el8e7ez8080md0r8psg25n0cq98a9n"}}],"sequence":"90"},"osmosisUndelegateTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgUndelegate","value":{"amount":{"amount":"3000","denom":"uosmo"},"delegator_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","validator_address":"osmovaloper1clpqr4nrk4khgkxj78fcwwh6dl3uw4ep88n0y4"}}],"sequence":"90"},"osmosisRedelegateTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgBeginRedelegate","value":{"amount":{"amount":"100","denom":"uosmo"},"delegator_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","validator_dst_address":"osmovaloper1clpqr4nrk4khgkxj78fcwwh6dl3uw4ep88n0y4","validator_src_address":"osmovaloper1cyw4vw20el8e7ez8080md0r8psg25n0cq98a9n"}}],"sequence":"90"},"osmosisRewardsTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgWithdrawDelegationReward","value":{"delegator_address":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","validator_address":"osmovaloper1q4mlwtw3ncve72na65xacck557wcknc8j0lmke"}}],"sequence":"90"},"osmosisLPAddTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"osmosis/gamm/join-pool","value":{"pool_id":"1","sender":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","share_out_amount":"1006980521903380445","token_in_maxs":[{"amount":"10595","denom":"ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"},{"amount":"143474","denom":"uosmo"}]}}],"sequence":"90"},"osmosisLPRemoveTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"osmosis/gamm/exit-pool","value":{"pool_id":"1","sender":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","share_in_amount":"78719426289889034","token_out_mins":[{"amount":"1532","denom":"ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"},{"amount":"5304","denom":"uosmo"}]}}],"sequence":"90"},"osmosisIBCTransferTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"cosmos-sdk/MsgTransfer","value":{"receiver":"cosmos1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5urlyk7s","sender":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","source_channel":"channel-0","source_port":"transfer","timeout_height":{"revision_height":"14165482","revision_number":"4"},"token":{"amount":"10000","denom":"ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"}}}],"sequence":"90"},"osmosisSwapTx":{"account_number":"97721","chain_id":"osmosis-1","fee":{"amount":[{"amount":"2291","denom":"uosmo"}],"gas":"91633"},"memo":"memo","msg":[{"type":"osmosis/gamm/swap-exact-amount-in","value":{"routes":[{"pool_id":"1","token_out_denom":"ibc/27394FB092D2ECCD56123C74F36E4C1F926001CEADA9CA97EA622B25F41E5EB2"}],"sender":"osmo1zjk9dkhzz2waxmtvtl3hnnl0t3ac0k5utyhxgz","token_in":{"amount":"6500","denom":"uosmo"},"token_out_min_amount":"8204"}}],"sequence":"90"}}');


var $b2776d27efa52407$exports = {};
$b2776d27efa52407$exports = JSON.parse('{"type":"auth/StdTx","value":{"fee":{"amount":[{"amount":"1000","denom":"drop"}],"gas":"28000"},"memo":"KeepKey","msg":[{"type":"ripple-sdk/MsgSend","value":{"amount":[{"amount":"47000","denom":"drop"}],"from_address":"rh5ZnEVySAy7oGd3nebT3wrohGDrsNS83E","to_address":"rEpwmtmvx8gkMhX5NLdU3vutQt7dor4MZm"}}],"signatures":null}}');


var $f9bfd471e51357ee$exports = {};
$f9bfd471e51357ee$exports = JSON.parse('{"thorchainUnsignedTx":{"fee":{"amount":[{"amount":"3000","denom":"rune"}],"gas":"200000"},"memo":"foobar","msg":[{"type":"thorchain/MsgSend","value":{"amount":[{"amount":"10000","denom":"rune"}],"from_address":"tthor1ls33ayg26kmltw7jjy55p32ghjna09zp6z69y8","to_address":"tthor1jvt443rvhq5h8yrna55yjysvhtju0el7ldnwwy"}}],"signatures":null},"thorchainBitcoinBaseTx":{"txid":"b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea","hash":"b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea","version":1,"size":257,"vsize":257,"weight":1028,"locktime":0,"vin":[{"txid":"a3b6284d252846ce8305d50edd7239831dc291716ec1752918d876d6ea05f681","vout":1,"n":0,"scriptSig":{"asm":"304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce3[ALL] 045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43","hex":"47304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce30141045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43"},"sequence":4294967295,"addr":"1ParaEza5Ew5ioT5c8zR2wSSvArqiSQbpT","valueSat":989000,"value":0.00989}],"vout":[{"value":"0.00010000","n":1,"scriptPubKey":{"asm":"OP_DUP OP_HASH160 9c9d21f47382762df3ad81391ee0964b28dd9517 OP_EQUALVERIFY OP_CHECKSIG","hex":"76a9149c9d21f47382762df3ad81391ee0964b28dd951788ac","reqSigs":1,"addresses":["1FH6ehAd5ZFXCM1cLGzHxK1s4dGdq1JusM"],"type":"pubkeyhash"},"spentTxId":"84da2a3cc29a3e0fb8a3a28882c6fb59a426a95952d484ec2422c5a47b6f93d4","spentIndex":2,"spentHeight":370585}],"blockhash":"000000000000000005c60c504e109684bb0886ab95520ad6a5af0d384f587a6a","blockheight":335414,"confirmations":258975,"time":1419279547,"blocktime":1419279547,"valueOut":0.00988,"valueIn":0.00989,"fees":0.00001},"thorchainEthereumBaseTx":{"nonce":"0x0","gasPrice":"0x5FB9ACA00","gasLimit":"0x186A0","value":"0x00","to":"0x41e5560054824ea6b0732e656e3ad64e20e94e45","chainId":1,"data":""},"thorchainBinanceBaseTx":{"account_number":"34","chain_id":"Binance-Chain-Nile","data":"null","memo":"","msgs":[{"inputs":[{"address":"tbnb1hgm0p7khfk85zpz5v0j8wnej3a90w709zzlffd","coins":[{"amount":1000000000,"denom":"BNB"}]}],"outputs":[{"address":"tbnb1ss57e8sa7xnwq030k2ctr775uac9gjzglqhvpy","coins":[{"amount":1000000000,"denom":"BNB"}]}]}],"sequence":"31","source":"1"},"thorchainNativeRuneBaseTx":{"account_number":"34","chain_id":"Binance-Chain-Nile","data":"null","memo":"","msgs":[{"inputs":[{"address":"tbnb1hgm0p7khfk85zpz5v0j8wnej3a90w709zzlffd","coins":[{"amount":1000000000,"denom":"RUNE"}]}],"outputs":[{"address":"tbnb1ss57e8sa7xnwq030k2ctr775uac9gjzglqhvpy","coins":[{"amount":1000000000,"denom":"RUNE"}]}]}],"sequence":"31","source":"1"},"thorchainRouterAbi":[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"address","name":"asset","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"string","name":"memo","type":"string"}],"name":"Deposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldVault","type":"address"},{"indexed":true,"internalType":"address","name":"newVault","type":"address"},{"indexed":false,"internalType":"address","name":"asset","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"string","name":"memo","type":"string"}],"name":"TransferAllowance","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"vault","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"address","name":"asset","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"string","name":"memo","type":"string"}],"name":"TransferOut","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldVault","type":"address"},{"indexed":true,"internalType":"address","name":"newVault","type":"address"},{"components":[{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"indexed":false,"internalType":"struct Router.Coin[]","name":"coins","type":"tuple[]"},{"indexed":false,"internalType":"string","name":"memo","type":"string"}],"name":"VaultTransfer","type":"event"},{"inputs":[],"name":"RUNE","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address[]","name":"recipients","type":"address[]"},{"components":[{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct Router.Coin[]","name":"coins","type":"tuple[]"},{"internalType":"string[]","name":"memos","type":"string[]"}],"name":"batchTransferOut","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address payable","name":"vault","type":"address"},{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"memo","type":"string"}],"name":"deposit","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"router","type":"address"},{"internalType":"address payable","name":"asgard","type":"address"},{"components":[{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"internalType":"struct Router.Coin[]","name":"coins","type":"tuple[]"},{"internalType":"string","name":"memo","type":"string"}],"name":"returnVaultAssets","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"router","type":"address"},{"internalType":"address","name":"newVault","type":"address"},{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"memo","type":"string"}],"name":"transferAllowance","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address payable","name":"to","type":"address"},{"internalType":"address","name":"asset","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"string","name":"memo","type":"string"}],"name":"transferOut","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"vaultAllowance","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"}]}');



var $ihoyg = parcelRequire("ihoyg");
var $d66a7013b33ce142$require$Buffer = $ihoyg.Buffer;
const $d66a7013b33ce142$var$keyring = new $lFpDy.Keyring();
const $d66a7013b33ce142$var$mnemonic = "alcohol woman abuse must during monitor noble actual mixed trade anger aisle";
const $d66a7013b33ce142$var$testPublicWalletXpubs = [
    "xpub661MyMwAqRbcFLgDU7wpcEVubSF7NkswwmXBUkDiGUW6uopeUMys4AqKXNgpfZKRTLnpKQgffd6a2c3J8JxLkF1AQN17Pm9QYHEqEfo1Rsx",
    "xpub68Zyu13qjcQxDzLNfTYnUXtJuX2qJgnxP6osrcAvJGdo6bs9M2Adt2BunbwiYrZS5qpA1QKoMf3uqS2NHpbyZp4KMJxDrL58NTyvHXBeAv6",
    "xpub6APRH5kELakva27TFbzpfhfsY3Jd4dRGo7NocHb63qWecSgK2dUkjWaYevJsCunicpdAkPg9fvHAdpSFMDCMCDMit8kiTM1w9QoGmfyVwDo",
    "xpub6BiVtCpG9fQPxnPmHXG8PhtzQdWC2Su4qWu6XW9tpWFYhxydCLJGrWBJZ5H6qTAHdPQ7pQhtpjiYZVZARo14qHiay2fvrX996oEP42u8wZy",
    "xpub6APRH5kELakyDsZMmBU9HEoeRUzM9F8STp6ztXLPUJQLiXGrbsfACbngkw5vySPfa9vFs2p3kMsRPxhyDTLhKYEf5HLVfDcDuTTazgzvArk",
    "xpub6CNFa58kEQJu2hwMVoofpDEKVVSg6gfwqBqE2zHAianaUnQkrJzJJ42iLDp7Dmg2aP88qCKoFZ4jidk3tECdQuF4567NGHDfe7iBRwHxgke",
    "xpub68Zyu13qjcQxUZiesSWiHJMqkg8G8Guft6MvDhwP72zSYXr9iKnNmDo7LxuSVwtpamrNwGQHkGDWoK8MAp3S9GW5fVxsjBY6AdvZc1hB7kK",
    "xpub6AA5piovovuKytxa5QtBWAbixSjg7fbmu5gqs6QmvARrUMgewJV51roNH4M7GtvZmjBY1m5oAgAjoHivasewSh4S2H7LAikCyuhJxfHdSsK",
    "xpub6CVKsQYXc9awxgV1tWbG4foDvdcnieK2JkbpPEBKB5WwAPKBZ1mstLbKVB4ov7QzxzjaxNK6EfmNY5Jsk2cG26EVcEkycGW4tchT2dyUhrx",
    "xpub68Zyu13qjcQz2DTzkBfLNCfsCTgT39rsUY9JT7MFvG3oEJvS8gUYwRX4RheUTFGZ6EtW4dFYhCdBX32GHJCodkQLAARjNsw4Drj1oDxvo9p",
    "xpub69s3dQnszuX49hTwhNAQEMJyTcRQNZyhtKAqNgQXApquzXdR3fEjXg75ScXzMMMLkUjQnz2Giwt2L7vesiswkAYwzbHezaUXayU8Z81CW56",
    "xpub6DDUPHpUo4pcy43iJeZjbSVWGav1SMMmuWdMHiGtkK8rhKmfbomtkwW6GKs1GGAKehT6QRocrmda3WWxXawpjmwaUHfFRXuKrXSapdckEYF"
].join(" ");
const $d66a7013b33ce142$var$keepkeyAdapter = $a42c9d68bdee87de$export$d9bc819ab1cac3ac.useKeyring($d66a7013b33ce142$var$keyring);
const $d66a7013b33ce142$var$kkbridgeAdapter = $034d6bd0745942b1$export$99cf9dd423484e6a.useKeyring($d66a7013b33ce142$var$keyring);
const $d66a7013b33ce142$var$kkemuAdapter = $034d6bd0745942b1$export$99cf9dd423484e6a.useKeyring($d66a7013b33ce142$var$keyring);
const $d66a7013b33ce142$var$nativeAdapter = $06a8c24e42bf2f0f$exports.NativeAdapter.useKeyring($d66a7013b33ce142$var$keyring);
window["keyring"] = $d66a7013b33ce142$var$keyring;
window.localStorage.debug = "*";
let $d66a7013b33ce142$var$wallet;
window["wallet"] = $d66a7013b33ce142$var$wallet;
const $d66a7013b33ce142$var$$keepkey = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keepkey");
const $d66a7013b33ce142$var$$keepkeybridge = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keepkeybridge");
const $d66a7013b33ce142$var$$kkemu = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#kkemu");
const $d66a7013b33ce142$var$$native = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#native");
const $d66a7013b33ce142$var$$keyring = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keyring");
$d66a7013b33ce142$var$$keepkey.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$wallet = await $d66a7013b33ce142$var$keepkeyAdapter.pairDevice(undefined, /*tryDebugLink=*/ true);
    window["wallet"] = $d66a7013b33ce142$var$wallet;
    (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keyring select").val(await $d66a7013b33ce142$var$wallet.transport.getDeviceID());
});
$d66a7013b33ce142$var$$keepkeybridge.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$wallet = await $d66a7013b33ce142$var$kkbridgeAdapter.pairDevice("http://localhost:1646");
    window["wallet"] = $d66a7013b33ce142$var$wallet;
    (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keyring select").val(await $d66a7013b33ce142$var$wallet.transport.getDeviceID());
});
$d66a7013b33ce142$var$$kkemu.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$wallet = await $d66a7013b33ce142$var$kkemuAdapter.pairDevice("http://localhost:5000");
    window["wallet"] = $d66a7013b33ce142$var$wallet;
    (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keyring select").val(await $d66a7013b33ce142$var$wallet.transport.getDeviceID());
});
$d66a7013b33ce142$var$$native.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$wallet = await $d66a7013b33ce142$var$nativeAdapter.pairDevice("testid");
    window["wallet"] = $d66a7013b33ce142$var$wallet;
    (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#keyring select").val(await $d66a7013b33ce142$var$wallet.getDeviceID());
});
async function $d66a7013b33ce142$var$deviceConnected(deviceId) {
    $d66a7013b33ce142$var$wallet = $d66a7013b33ce142$var$keyring.get(deviceId);
    if (!$d66a7013b33ce142$var$$keyring.find(`option[value="${deviceId}"]`).length) $d66a7013b33ce142$var$$keyring.append((0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("<option></option>").attr("value", deviceId).text(deviceId + " - " + await $d66a7013b33ce142$var$wallet.getVendor()));
}
/**
 * START UP
 * Initialize all adapters on page load
 */ (async ()=>{
    $d66a7013b33ce142$var$keyring.onAny((name, ...values)=>{
        const [[deviceId, event]] = values;
        const { from_wallet: from_wallet = false, message_type: message_type } = event;
        const direction = from_wallet ? "\uD83D\uDD11" : "\uD83D\uDCBB";
        console.debug(`${deviceId} ${direction} ${message_type}`, event);
        const log = document.getElementById("eventLog");
        log.innerHTML += `<div class="eventEntry">Event: ${name}<br />Values: ${JSON.stringify(values)}</div>`;
        log.scrollTop = log.scrollHeight;
    });
    $d66a7013b33ce142$var$keyring.on([
        "*",
        "*",
        $lFpDy.Events.CONNECT
    ], async (deviceId)=>{
        await $d66a7013b33ce142$var$deviceConnected(deviceId);
    });
    $d66a7013b33ce142$var$keyring.on([
        "*",
        "*",
        $lFpDy.Events.DISCONNECT
    ], async (deviceId)=>{
        $d66a7013b33ce142$var$$keyring.find(`option[value="${deviceId}"]`).remove();
    });
    $d66a7013b33ce142$var$keyring.on([
        "*",
        "*",
        $lFpDy.Events.PIN_REQUEST
    ], ()=>window["pinOpen"]());
    $d66a7013b33ce142$var$keyring.on([
        "*",
        "*",
        $lFpDy.Events.PASSPHRASE_REQUEST
    ], ()=>window["passphraseOpen"]());
    $d66a7013b33ce142$var$keyring.on([
        "*",
        "*",
        $06a8c24e42bf2f0f$exports.NativeEvents.MNEMONIC_REQUIRED
    ], ()=>window["mnemonicOpen"]());
    try {
        await $d66a7013b33ce142$var$kkbridgeAdapter.pairDevice("http://localhost:1646");
    } catch (e) {
        console.error("Could not initialize keepkey bridge", e);
    }
    try {
        await $d66a7013b33ce142$var$nativeAdapter.initialize();
    } catch (e) {
        console.error("Could not initialize NativeAdapter", e);
    }
    for (const deviceID of Object.keys($d66a7013b33ce142$var$keyring.wallets))await $d66a7013b33ce142$var$deviceConnected(deviceID);
    $d66a7013b33ce142$var$$keyring.change(async ()=>{
        if ($d66a7013b33ce142$var$wallet) await $d66a7013b33ce142$var$wallet.disconnect();
        const deviceID = $d66a7013b33ce142$var$$keyring.find(":selected").val();
        $d66a7013b33ce142$var$wallet = $d66a7013b33ce142$var$keyring.get(deviceID);
        if ($d66a7013b33ce142$var$wallet) {
            if ($d66a7013b33ce142$var$wallet.transport) {
                await $d66a7013b33ce142$var$wallet.transport.connect();
                if ($459ec2812757e70b$export$bd6c7a035c72384b($d66a7013b33ce142$var$wallet)) {
                    console.info("try connect debuglink");
                    await $d66a7013b33ce142$var$wallet.transport.tryConnectDebugLink();
                }
            }
            // Initializing a native wallet will immediately prompt for the mnemonic
            if (await $d66a7013b33ce142$var$wallet.getModel() !== "Native") await $d66a7013b33ce142$var$wallet.initialize();
        }
        window["wallet"] = $d66a7013b33ce142$var$wallet;
    });
    $d66a7013b33ce142$var$wallet = $d66a7013b33ce142$var$keyring.get();
    window["wallet"] = $d66a7013b33ce142$var$wallet;
    if ($d66a7013b33ce142$var$wallet) {
        const deviceID = await $d66a7013b33ce142$var$wallet.getDeviceID();
        $d66a7013b33ce142$var$$keyring.val(deviceID).change();
    }
})();
window["handlePinDigit"] = function(digit) {
    const input = document.getElementById("#pinInput");
    if (digit === "") input.value = input.value.slice(0, -1);
    else input.value += digit.toString();
};
window["pinOpen"] = function() {
    document.getElementById("#pinModal").className = "modal opened";
};
window["pinEntered"] = function() {
    const input = document.getElementById("#pinInput");
    $d66a7013b33ce142$var$wallet.sendPin(input.value);
    document.getElementById("#pinModal").className = "modal";
};
window["passphraseOpen"] = function() {
    document.getElementById("#passphraseModal").className = "modal opened";
};
window["passphraseEntered"] = function() {
    const input = document.getElementById("#passphraseInput");
    $d66a7013b33ce142$var$wallet.sendPassphrase(input.value);
    document.getElementById("#passphraseModal").className = "modal";
};
window["mnemonicOpen"] = function() {
    document.getElementById("#mnemonicModal").className = "modal opened";
};
window["mnemonicEntered"] = async function() {
    const input = document.getElementById("#mnemonicInput");
    $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: input.value
    });
    document.getElementById("#mnemonicModal").className = "modal";
};
window["useTestWallet"] = async function() {
    $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: await $06a8c24e42bf2f0f$exports.crypto.Isolation.Engines.Dummy.BIP39.Mnemonic.create($d66a7013b33ce142$var$testPublicWalletXpubs)
    });
    document.getElementById("#mnemonicModal").className = "modal";
};
const $d66a7013b33ce142$var$$yes = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#yes");
const $d66a7013b33ce142$var$$no = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#no");
const $d66a7013b33ce142$var$$cancel = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cancel");
$d66a7013b33ce142$var$$yes.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) return;
    if (!$lFpDy.supportsDebugLink($d66a7013b33ce142$var$wallet)) return;
    await $d66a7013b33ce142$var$wallet.pressYes();
});
$d66a7013b33ce142$var$$no.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) return;
    if (!$lFpDy.supportsDebugLink($d66a7013b33ce142$var$wallet)) return;
    await $d66a7013b33ce142$var$wallet.pressNo();
});
$d66a7013b33ce142$var$$cancel.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) return;
    await $d66a7013b33ce142$var$wallet.cancel();
});
const $d66a7013b33ce142$var$$getVendor = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#getVendor");
const $d66a7013b33ce142$var$$getModel = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#getModel");
const $d66a7013b33ce142$var$$getDeviceID = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#getDeviceID");
const $d66a7013b33ce142$var$$getFirmware = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#getFirmware");
const $d66a7013b33ce142$var$$getLabel = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#getLabel");
const $d66a7013b33ce142$var$$getXpubs = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))(".getXpubs");
const $d66a7013b33ce142$var$$xpubResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))(".xpubResults");
const $d66a7013b33ce142$var$$doPing = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#doPing");
const $d66a7013b33ce142$var$$doWipe = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#doWipe");
const $d66a7013b33ce142$var$$doLoadDevice = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#doLoadDevice");
const $d66a7013b33ce142$var$$doDisconnect = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#doDisconnect");
const $d66a7013b33ce142$var$$doClearSession = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#doClearSession");
const $d66a7013b33ce142$var$$manageResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#manageResults");
$d66a7013b33ce142$var$$getVendor.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const vendor = await $d66a7013b33ce142$var$wallet.getVendor();
    $d66a7013b33ce142$var$$manageResults.val(vendor);
});
$d66a7013b33ce142$var$$getModel.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const model = await $d66a7013b33ce142$var$wallet.getModel();
    $d66a7013b33ce142$var$$manageResults.val(model);
});
$d66a7013b33ce142$var$$getDeviceID.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const deviceID = await $d66a7013b33ce142$var$wallet.getDeviceID();
    $d66a7013b33ce142$var$$manageResults.val(deviceID);
});
$d66a7013b33ce142$var$$getFirmware.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const firmware = await $d66a7013b33ce142$var$wallet.getFirmwareVersion();
    $d66a7013b33ce142$var$$manageResults.val(firmware);
});
$d66a7013b33ce142$var$$getLabel.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const label = await $d66a7013b33ce142$var$wallet.getLabel();
    $d66a7013b33ce142$var$$manageResults.val(label);
});
$d66a7013b33ce142$var$$getXpubs.each(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))(this).on("click", async (e)=>{
        const { groups: { coin: coin } } = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))(this).attr("class").match("coin-(?<coin>.+)");
        e.preventDefault();
        if (!$d66a7013b33ce142$var$wallet) {
            $d66a7013b33ce142$var$$manageResults.val("No wallet?");
            return;
        }
        // Get Ethereum path
        const { hardenedPath: hardenedPath } = $d66a7013b33ce142$var$wallet.ethGetAccountPaths({
            coin: "Ethereum",
            accountIdx: 0
        })[0];
        const btcGetPublicKeysInput = [
            {
                coin: "Bitcoin",
                addressNList: [
                    2147483732,
                    2147483648,
                    2147483648
                ],
                curve: "secp256k1",
                scriptType: $lFpDy.BTCInputScriptType.SpendWitness
            },
            {
                coin: "Bitcoin",
                addressNList: [
                    2147483697,
                    2147483648,
                    2147483648
                ],
                curve: "secp256k1",
                scriptType: $lFpDy.BTCInputScriptType.SpendP2SHWitness
            },
            {
                coin: "Bitcoin",
                addressNList: [
                    2147483692,
                    2147483648,
                    2147483648
                ],
                curve: "secp256k1",
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress
            }
        ];
        const bchGetPublicKeysInput = [
            {
                addressNList: [
                    2147483692,
                    2147483793,
                    2147483648
                ],
                curve: "secp256k1",
                showDisplay: true,
                coin: "BitcoinCash",
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress
            }
        ];
        const ltcGetPublicKeysInput = [
            // SegwitNative
            {
                addressNList: [
                    2147483732,
                    2147483650,
                    2147483648
                ],
                curve: "secp256k1",
                showDisplay: true,
                coin: "Litecoin",
                scriptType: $lFpDy.BTCInputScriptType.SpendWitness
            },
            // SegwitP2sh
            {
                addressNList: [
                    2147483697,
                    2147483650,
                    2147483648
                ],
                curve: "secp256k1",
                showDisplay: true,
                coin: "Litecoin",
                scriptType: $lFpDy.BTCInputScriptType.SpendP2SHWitness
            },
            // P2Pksh
            {
                addressNList: [
                    2147483692,
                    2147483650,
                    2147483648
                ],
                curve: "secp256k1",
                showDisplay: true,
                coin: "Litecoin",
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress
            }
        ];
        const dogeGetPublicKeysInput = [
            {
                addressNList: [
                    2147483692,
                    2147483651,
                    2147483648
                ],
                curve: "secp256k1",
                showDisplay: true,
                coin: "Dogecoin",
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress
            }
        ];
        const hardenedPathGetPublicKeysInput = [
            {
                addressNList: hardenedPath,
                curve: "secp256k1",
                showDisplay: true,
                coin: "Ethereum"
            }
        ];
        const getAllPublicKeysInput = [
            ...btcGetPublicKeysInput,
            ...ltcGetPublicKeysInput,
            ...bchGetPublicKeysInput,
            ...dogeGetPublicKeysInput,
            ...hardenedPathGetPublicKeysInput
        ];
        const getPublicKeysInput = coin === "all" ? getAllPublicKeysInput : getAllPublicKeysInput.filter((input)=>input.coin.replace(/\s/g, "") === coin);
        const result = await $d66a7013b33ce142$var$wallet.getPublicKeys(getPublicKeysInput);
        // Populate either the "Manage" or xpub section input with the results
        (coin === "all" ? $d66a7013b33ce142$var$$manageResults : $d66a7013b33ce142$var$$xpubResults).val(JSON.stringify(result));
    });
});
$d66a7013b33ce142$var$$doPing.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    const result = await $d66a7013b33ce142$var$wallet.ping({
        msg: "Hello World",
        button: true
    });
    $d66a7013b33ce142$var$$manageResults.val(result.msg);
});
$d66a7013b33ce142$var$$doWipe.on("click", (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    $d66a7013b33ce142$var$wallet.wipe();
});
$d66a7013b33ce142$var$$doLoadDevice.on("click", (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: /*trezor test seed:*/ "alcohol woman abuse must during monitor noble actual mixed trade anger aisle"
    });
});
$d66a7013b33ce142$var$$doDisconnect.on("click", (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    $d66a7013b33ce142$var$wallet.disconnect().then(()=>$d66a7013b33ce142$var$$manageResults.val("Disconnected"));
});
$d66a7013b33ce142$var$$doClearSession.on("click", (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$manageResults.val("No wallet?");
        return;
    }
    $d66a7013b33ce142$var$wallet.clearSession().then(()=>$d66a7013b33ce142$var$$manageResults.val("Session Cleared"));
});
/*
 * Binance
 */ const $d66a7013b33ce142$var$$binanceAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#binanceAddr");
const $d66a7013b33ce142$var$$binanceTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#binanceTx");
const $d66a7013b33ce142$var$$binanceResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#binanceResults");
$d66a7013b33ce142$var$$binanceAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$binanceResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.binanceGetAccountPaths({
            accountIdx: 0
        })[0];
        let result = await $d66a7013b33ce142$var$wallet.binanceGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        result = await $d66a7013b33ce142$var$wallet.binanceGetAddress({
            addressNList: addressNList,
            showDisplay: true,
            address: result
        });
        $d66a7013b33ce142$var$$binanceResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$binanceResults.val(label + " does not support Binance");
    }
});
$d66a7013b33ce142$var$$binanceTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$binanceResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.binanceSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/714'/0'/0/0`),
            account_number: "24250",
            sequence: 31,
            tx: $293b5f44ba4827b5$exports
        });
        $d66a7013b33ce142$var$$binanceResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$binanceResults.val(label + " does not support Cosmos");
    }
});
/*
 * Ripple
 */ const $d66a7013b33ce142$var$$rippleAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#rippleAddr");
const $d66a7013b33ce142$var$$rippleTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#rippleTx");
const $d66a7013b33ce142$var$$rippleResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#rippleResults");
$d66a7013b33ce142$var$$rippleAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$rippleResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsRipple($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.rippleGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.rippleGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$rippleResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$rippleResults.val(label + " does not support Ripple");
    }
});
$d66a7013b33ce142$var$$rippleTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$rippleResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsRipple($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.rippleSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/144'/0'/0/0`),
            tx: $b2776d27efa52407$exports,
            flags: undefined,
            sequence: "3",
            lastLedgerSequence: "0",
            payment: {
                amount: "47000",
                destination: "rEpwmtmvx8gkMhX5NLdU3vutQt7dor4MZm",
                destinationTag: "1234567890"
            }
        });
        $d66a7013b33ce142$var$$rippleResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$rippleResults.val(label + " does not support Ripple");
    }
});
/*
 * Eos
 */ const $d66a7013b33ce142$var$$eosAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#eosAddr");
const $d66a7013b33ce142$var$$eosTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#eosTx");
const $d66a7013b33ce142$var$$eosResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#eosResults");
$d66a7013b33ce142$var$$eosAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$eosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsEos($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.eosGetAccountPaths({
            accountIdx: 0
        })[0];
        let result = await $d66a7013b33ce142$var$wallet.eosGetPublicKey({
            addressNList: addressNList,
            showDisplay: false
        });
        result = await $d66a7013b33ce142$var$wallet.eosGetPublicKey({
            addressNList: addressNList,
            showDisplay: true,
            kind: 0
        });
        $d66a7013b33ce142$var$$eosResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$eosResults.val(label + " does not support Eos");
    }
});
$d66a7013b33ce142$var$$eosTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$eosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsEos($d66a7013b33ce142$var$wallet)) {
        const unsigned_main = {
            expiration: "2020-04-30T22:00:00.000",
            ref_block_num: 54661,
            ref_block_prefix: 2118672142,
            max_net_usage_words: 0,
            max_cpu_usage_ms: 0,
            delay_sec: 0,
            context_free_actions: [],
            actions: [
                {
                    account: "eosio.token",
                    name: "transfer",
                    authorization: [
                        {
                            actor: "xhackmebrosx",
                            permission: "active"
                        }
                    ],
                    data: {
                        from: "xhackmebrosx",
                        to: "xhighlanderx",
                        quantity: "0.0001 EOS",
                        memo: "testmemo"
                    }
                }
            ]
        };
        const chainid_main = "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906";
        const res = await $d66a7013b33ce142$var$wallet.eosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList("m/44'/194'/0'/0/0"),
            chain_id: chainid_main,
            tx: unsigned_main
        });
        console.info(res);
        console.info("sigV = %d", res.signatureV);
        console.info("sigR = %s", $lFpDy.toHexString(res.signatureR));
        console.info("sigS = %s", $lFpDy.toHexString(res.signatureS));
        console.info("hash = %s", $lFpDy.toHexString(res.hash));
        console.info("EosFormatSig = %s", res.eosFormSig);
        console.info("EosFormReSig = SIG_K1_Jxa7NRL1hj4Q9wqufaSZa7oAXQQnRxSuAeFSwx6EzHnzPVeB5y6qQge16WCYa3Xod1mDWZv3MnEEPFeK3bEf3iN6es1iVy");
        $d66a7013b33ce142$var$$eosResults.val(res.eosFormSig);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$eosResults.val(label + " does not support Eos");
    }
});
/*
 * Fio
 */ const $d66a7013b33ce142$var$$fioAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#fioAddr");
const $d66a7013b33ce142$var$$fioTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#fioTx");
const $d66a7013b33ce142$var$$fioResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#fioResults");
$d66a7013b33ce142$var$$fioAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$fioResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsFio($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.fioGetAccountPaths({
            accountIdx: 0
        })[0];
        let result = await $d66a7013b33ce142$var$wallet.fioGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        result = await $d66a7013b33ce142$var$wallet.fioGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$fioResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$fioResults.val(label + " does not support ");
    }
});
$d66a7013b33ce142$var$$fioTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$fioResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsFio($d66a7013b33ce142$var$wallet)) {
        const unsigned_main = {
            expiration: "2020-04-30T22:00:00.000",
            ref_block_num: 54661,
            ref_block_prefix: 2118672142,
            max_net_usage_words: 0,
            max_cpu_usage_ms: 0,
            delay_sec: 0,
            context_free_actions: [],
            actions: []
        };
        const chainid_main = "aca376f206b8fc25a6ed44dbdc66547c36c6c33e3a119ffbeaef943642f0e906";
        const res = await $d66a7013b33ce142$var$wallet.fioSignTx({
            addressNList: $lFpDy.bip32ToAddressNList("m/44'/194'/0'/0/0"),
            chain_id: chainid_main,
            tx: unsigned_main
        });
        console.info(res);
        console.info("signature = %d", res.signature);
        console.info("serialized = %s", res.serialized);
        $d66a7013b33ce142$var$$fioResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$fioResults.val(label + " does not support Fio");
    }
});
/*
 * Cosmos
 */ const $d66a7013b33ce142$var$$cosmosAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosAddr");
const $d66a7013b33ce142$var$$cosmosTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosTx");
const $d66a7013b33ce142$var$$cosmosDelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosDelegate");
const $d66a7013b33ce142$var$$cosmosUndelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosUndelegate");
const $d66a7013b33ce142$var$$cosmosRedelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosRedelegate");
const $d66a7013b33ce142$var$$cosmosRewards = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosRewards");
const $d66a7013b33ce142$var$$cosmosIBCTransfer = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosIBCTransfer");
const $d66a7013b33ce142$var$$cosmosResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#cosmosResults");
$d66a7013b33ce142$var$$cosmosAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.cosmosGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.cosmosGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        await $d66a7013b33ce142$var$wallet.cosmosGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$cosmosResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosTransferTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "17",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosDelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosDelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "18",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosUndelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosUndelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "20",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosRedelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosRedelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "19",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosRewards.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosRewardsTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "19",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
$d66a7013b33ce142$var$$cosmosIBCTransfer.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$cosmosResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsCosmos($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $4d7adfa066eb02fa$exports.cosmosIBCTransferTx);
        const res = await $d66a7013b33ce142$var$wallet.cosmosSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: "cosmoshub-4",
            account_number: "16359",
            sequence: "27",
            tx: unsigned
        });
        $d66a7013b33ce142$var$$cosmosResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$cosmosResults.val(label + " does not support Cosmos");
    }
});
/*
 * MAYAChain
 */ const $d66a7013b33ce142$var$$mayachainAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#mayachainAddr");
const $d66a7013b33ce142$var$$mayachainTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#mayachainTx");
const $d66a7013b33ce142$var$$mayachainNativeResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#mayachainNativeResults");
$d66a7013b33ce142$var$$mayachainAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$mayachainNativeResults.val("No wallet?");
        return;
    }
    // eslint-disable-next-line no-console
    console.log($lFpDy);
    {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.mayachainGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.mayachainGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        await $d66a7013b33ce142$var$wallet.mayachainGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$mayachainNativeResults.val(result);
    }
});
$d66a7013b33ce142$var$$mayachainTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$mayachainNativeResults.val("No wallet?");
        return;
    }
    {
        // eslint-disable-next-line no-console
        console.log("mayachainUnsignedTx: ", (0, $f4390fe5e7829991$exports.mayachainUnsignedTx));
        const res = await $d66a7013b33ce142$var$wallet.mayachainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "mayachain-mainnet-v1",
            account_number: "6359",
            sequence: "15",
            tx: (0, $f4390fe5e7829991$exports.mayachainUnsignedTx)
        });
        $d66a7013b33ce142$var$$mayachainNativeResults.val(JSON.stringify(res));
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
    }
});
/*
 * THORChain
 */ const $d66a7013b33ce142$var$$thorchainAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainAddr");
const $d66a7013b33ce142$var$$thorchainTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainTx");
const $d66a7013b33ce142$var$$thorchainNativeResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainNativeResults");
const $d66a7013b33ce142$var$$thorchainSignSwap = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainSignSwap");
const $d66a7013b33ce142$var$$thorchainSourceChain = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainSourceChain");
const $d66a7013b33ce142$var$$thorchainDestChain = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainDestChain");
const $d66a7013b33ce142$var$$thorchainDestAddress = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainDestAddress");
const $d66a7013b33ce142$var$$thorchainAmount = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainAmount");
const $d66a7013b33ce142$var$$thorchainSwapResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainSwapResults");
const $d66a7013b33ce142$var$$thorchainSignAddLiquidity = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainSignAddLiquidity");
const $d66a7013b33ce142$var$$thorchainLiquidityAsset = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainLiquidityAsset");
const $d66a7013b33ce142$var$$thorchainLiquidityAmount = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainLiquidityAmount");
const $d66a7013b33ce142$var$$thorchainLiquidityPoolAddress = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainLiquidityPoolAddress");
const $d66a7013b33ce142$var$$thorchainAddLiquidityResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainAddLiquidityResults");
const $d66a7013b33ce142$var$$thorchainArkeoBondProvider = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoBondProvider");
const $d66a7013b33ce142$var$$thorchainArkeoModProvider = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoModProvider");
const $d66a7013b33ce142$var$$thorchainArkeoOpenContract = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoOpenContract");
const $d66a7013b33ce142$var$$thorchainArkeoCloseContract = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoCloseContract");
const $d66a7013b33ce142$var$$thorchainArkeoClaimContractIncome = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoClaimContractIncome");
const $d66a7013b33ce142$var$$thorchainArkeoClaimEth = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoClaimEth");
const $d66a7013b33ce142$var$$thorchainArkeoClaimArkeo = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoClaimArkeo");
const $d66a7013b33ce142$var$$thorchainArkeoTransferClaim = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoTransferClaim");
const $d66a7013b33ce142$var$$thorchainArkeoAddClaim = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoAddClaim");
const $d66a7013b33ce142$var$$thorchainArkeoResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#thorchainArkeoResults");
$d66a7013b33ce142$var$$thorchainAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainNativeResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.thorchainGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.thorchainGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        await $d66a7013b33ce142$var$wallet.thorchainGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$thorchainNativeResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainNativeResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainNativeResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f9bfd471e51357ee$exports.thorchainUnsignedTx)
        });
        $d66a7013b33ce142$var$$thorchainNativeResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainNativeResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainSignSwap.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainSwapResults.val("No wallet?");
        return;
    }
    if (!$d66a7013b33ce142$var$$thorchainDestAddress.val().match(/^[a-z0-9]+$/i) && $d66a7013b33ce142$var$$thorchainDestAddress.val() != "") {
        console.info($d66a7013b33ce142$var$$thorchainDestAddress.val());
        $d66a7013b33ce142$var$$thorchainSwapResults.val("Invalid destination address");
        return;
    }
    if (!$d66a7013b33ce142$var$$thorchainAmount.val().match(/^\d*\.?\d*$/) && $d66a7013b33ce142$var$$thorchainAmount.val() != "") {
        $d66a7013b33ce142$var$$thorchainSwapResults.val("Amount is not a number");
        return;
    }
    const routerContractAddress = "0x0000000000000000000000000000000000000000";
    const vaultAddress = "0x0000000000000000000000000000000000000000";
    let tx = {};
    const memo = `SWAP:${$d66a7013b33ce142$var$$thorchainDestChain.val()}:${$d66a7013b33ce142$var$$thorchainDestAddress.val()}:${$d66a7013b33ce142$var$$thorchainAmount.val()}`;
    switch($d66a7013b33ce142$var$$thorchainSourceChain.val()){
        case "BTC.BTC":
            tx = (0, $f9bfd471e51357ee$exports.thorchainBitcoinBaseTx);
            if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
                const txid = "b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea";
                const hex = "010000000181f605ead676d8182975c16e7191c21d833972dd0ed50583ce4628254d28b6a3010000008a47304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce30141045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43ffffffff0250ec0e00000000001976a914f7b9e0239571434f0ccfdba6f772a6d23f2cfb1388ac10270000000000001976a9149c9d21f47382762df3ad81391ee0964b28dd951788ac00000000";
                const inputs = [
                    {
                        addressNList: [
                            2147483692,
                            2147483648,
                            2147483648,
                            0,
                            0
                        ],
                        scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                        amount: String(10000),
                        vout: 1,
                        txid: txid,
                        tx: $57de038c542806ea$exports,
                        hex: hex
                    }
                ];
                const outputs = [
                    {
                        address: "bc1q6m9u2qsu8mh8y7v8rr2ywavtj8g5arzlyhcej7",
                        addressType: $lFpDy.BTCOutputAddressType.Spend,
                        opReturnData: $d66a7013b33ce142$require$Buffer.from(memo, "utf-8"),
                        amount: String(0),
                        isChange: false
                    }
                ];
                const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
                    coin: "Bitcoin",
                    inputs: inputs,
                    outputs: outputs,
                    version: 1,
                    locktime: 0,
                    opReturnData: memo
                });
                $d66a7013b33ce142$var$$thorchainSwapResults.val(res.serializedTx);
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support BTC");
            }
            break;
        case "ETH.ETH":
            if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
                const web3 = new (0, (/*@__PURE__*/$parcel$interopDefault($45dd0a73038568f0$exports)))();
                console.info((0, $f9bfd471e51357ee$exports.thorchainRouterAbi)[0]);
                const routerContract = new web3.eth.Contract((0, $f9bfd471e51357ee$exports.thorchainRouterAbi), routerContractAddress);
                tx = (0, $f9bfd471e51357ee$exports.thorchainEthereumBaseTx);
                tx["addressNList"] = $lFpDy.bip32ToAddressNList("m/44'/60'/0'/0/0");
                tx["data"] = routerContract.methods.deposit(vaultAddress, "0x0000000000000000000000000000000000000000", 0, memo).encodeABI();
                const res = await $d66a7013b33ce142$var$wallet.ethSignTx(tx);
                $d66a7013b33ce142$var$$thorchainSwapResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support ETH");
            }
            break;
        case "BNB.BNB":
            if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainBinanceBaseTx);
                tx["memo"] = memo;
                console.info(tx);
                const res = await $d66a7013b33ce142$var$wallet.binanceSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/714'/0'/0/0`),
                    chain_id: "Binance-Chain-Nile",
                    account_number: "24250",
                    sequence: 31,
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainSwapResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support Cosmos");
            }
            break;
        case "BNB.RUNE-B1A":
            if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainNativeRuneBaseTx);
                tx["memo"] = memo;
                console.info(tx);
                const res = await $d66a7013b33ce142$var$wallet.binanceSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/714'/0'/0/0`),
                    chain_id: "Binance-Chain-Nile",
                    account_number: "24250",
                    sequence: 31,
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainSwapResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support Cosmos");
            }
            break;
        case "THOR.RUNE":
            if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainUnsignedTx);
                tx["memo"] = memo;
                console.info(tx);
                const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
                    chain_id: "thorchain",
                    account_number: "24250",
                    sequence: "3",
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainSwapResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support Cosmos");
            }
            break;
        case "ETH.USDT-0xdac17f958d2ee523a2206206994597c13d831ec7":
            if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainEthereumBaseTx);
                tx["addressNList"] = $lFpDy.bip32ToAddressNList("m/44'/60'/0'/0/0");
                tx["data"] = "0x";
                const res = await $d66a7013b33ce142$var$wallet.ethSignTx(tx);
                $d66a7013b33ce142$var$$thorchainSwapResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainSwapResults.val(label + " does not support ETH");
            }
            break;
        default:
            console.info("Base coin is Unknown.");
            console.info("val:", $d66a7013b33ce142$var$$thorchainSourceChain.val());
            $d66a7013b33ce142$var$$thorchainSwapResults.val("Invalid source chain");
            return;
    }
// $thorchainSwapResults.val(memo);
//let res = await wallet.thorchainSignTx();
});
$d66a7013b33ce142$var$$thorchainSignAddLiquidity.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val("No wallet?");
        return;
    }
    if (!$d66a7013b33ce142$var$$thorchainDestAddress.val().match(/^[a-z0-9]+$/i) && $d66a7013b33ce142$var$$thorchainDestAddress.val() != "") {
        console.info($d66a7013b33ce142$var$$thorchainDestAddress.val());
        $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val("Invalid destination address");
        return;
    }
    if (!$d66a7013b33ce142$var$$thorchainAmount.val().match(/^\d*\.?\d*$/) && $d66a7013b33ce142$var$$thorchainAmount.val() != "") {
        $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val("Amount is not a number");
        return;
    }
    const routerContractAddress = "0x0000000000000000000000000000000000000000";
    const vaultAddress = "0x0000000000000000000000000000000000000000";
    let tx = {};
    const memo = `ADD:${$d66a7013b33ce142$var$$thorchainLiquidityAsset.val()}:${$d66a7013b33ce142$var$$thorchainLiquidityPoolAddress.val()}}`;
    switch($d66a7013b33ce142$var$$thorchainLiquidityAsset.val()){
        case "BTC.BTC":
            tx = (0, $f9bfd471e51357ee$exports.thorchainBitcoinBaseTx);
            if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
                const txid = "b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea";
                const hex = "010000000181f605ead676d8182975c16e7191c21d833972dd0ed50583ce4628254d28b6a3010000008a47304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce30141045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43ffffffff0250ec0e00000000001976a914f7b9e0239571434f0ccfdba6f772a6d23f2cfb1388ac10270000000000001976a9149c9d21f47382762df3ad81391ee0964b28dd951788ac00000000";
                const inputs = [
                    {
                        addressNList: [
                            2147483692,
                            2147483648,
                            2147483648,
                            0,
                            0
                        ],
                        scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                        amount: String(10000),
                        vout: 1,
                        txid: txid,
                        tx: $57de038c542806ea$exports,
                        hex: hex
                    }
                ];
                const outputs = [
                    {
                        addressType: $lFpDy.BTCOutputAddressType.Spend,
                        opReturnData: $d66a7013b33ce142$require$Buffer.from(memo, "utf-8"),
                        amount: $d66a7013b33ce142$var$$thorchainLiquidityAmount.val(),
                        isChange: false
                    }
                ];
                const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
                    coin: "Bitcoin",
                    inputs: inputs,
                    outputs: outputs,
                    version: 1,
                    locktime: 0
                });
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(res.serializedTx);
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support BTC");
            }
            break;
        case "ETH.ETH":
            if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
                const web3 = new (0, (/*@__PURE__*/$parcel$interopDefault($45dd0a73038568f0$exports)))();
                console.info((0, $f9bfd471e51357ee$exports.thorchainRouterAbi)[0]);
                const routerContract = new web3.eth.Contract((0, $f9bfd471e51357ee$exports.thorchainRouterAbi), routerContractAddress);
                tx = (0, $f9bfd471e51357ee$exports.thorchainEthereumBaseTx);
                tx["value"] = "0x" + $d66a7013b33ce142$var$$thorchainLiquidityAmount.val().toString(16);
                tx["addressNList"] = $lFpDy.bip32ToAddressNList("m/44'/60'/0'/0/0");
                tx["data"] = routerContract.methods.deposit(vaultAddress, "0x0000000000000000000000000000000000000000", 0, memo).encodeABI();
                console.info(tx);
                const res = await $d66a7013b33ce142$var$wallet.ethSignTx(tx);
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support ETH");
            }
            break;
        case "BNB.BNB":
            if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainBinanceBaseTx);
                tx["memo"] = memo;
                tx["msgs"]["outputs"][0] = {
                    address: $d66a7013b33ce142$var$$thorchainLiquidityPoolAddress.val(),
                    coins: [
                        {
                            amount: $d66a7013b33ce142$var$$thorchainLiquidityAmount.val(),
                            denom: "BNB"
                        }
                    ]
                };
                const res = await $d66a7013b33ce142$var$wallet.binanceSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/714'/0'/0/0`),
                    chain_id: "Binance-Chain-Nile",
                    account_number: "24250",
                    sequence: 31,
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support Cosmos");
            }
            break;
        case "BNB.RUNE-B1A":
            if ($lFpDy.supportsBinance($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainNativeRuneBaseTx);
                tx["memo"] = memo;
                tx["msgs"]["outputs"][0] = {
                    address: $d66a7013b33ce142$var$$thorchainLiquidityPoolAddress.val(),
                    coins: [
                        {
                            amount: $d66a7013b33ce142$var$$thorchainLiquidityAmount.val(),
                            denom: "BNB"
                        }
                    ]
                };
                const res = await $d66a7013b33ce142$var$wallet.binanceSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/714'/0'/0/0`),
                    chain_id: "Binance-Chain-Nile",
                    account_number: "24250",
                    sequence: 31,
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support Cosmos");
            }
            break;
        case "THOR.RUNE":
            if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainUnsignedTx);
                tx["memo"] = memo;
                tx["msgs"]["outputs"][0] = {
                    address: $d66a7013b33ce142$var$$thorchainLiquidityPoolAddress.val(),
                    coins: [
                        {
                            amount: $d66a7013b33ce142$var$$thorchainLiquidityAmount.val(),
                            denom: "RUNE"
                        }
                    ]
                };
                console.info(tx);
                const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
                    addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
                    chain_id: "thorchain",
                    account_number: "24250",
                    sequence: "3",
                    tx: tx
                });
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support Cosmos");
            }
            break;
        case "ETH.USDT-0xdac17f958d2ee523a2206206994597c13d831ec7":
            if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
                tx = (0, $f9bfd471e51357ee$exports.thorchainEthereumBaseTx);
                tx["addressNList"] = $lFpDy.bip32ToAddressNList("m/44'/60'/0'/0/0");
                tx["data"] = "0x";
                tx["to"] = $d66a7013b33ce142$var$$thorchainLiquidityPoolAddress.val();
                tx["value"] = $d66a7013b33ce142$var$$thorchainLiquidityAmount.val();
                const res = await $d66a7013b33ce142$var$wallet.ethSignTx(tx);
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(JSON.stringify(res));
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getLabel();
                $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val(label + " does not support ETH");
            }
            break;
        default:
            console.info("Base coin is Unknown.");
            console.info("val:", $d66a7013b33ce142$var$$thorchainSourceChain.val());
            $d66a7013b33ce142$var$$thorchainAddLiquidityResults.val("Invalid source chain");
            return;
    }
});
$d66a7013b33ce142$var$$thorchainArkeoBondProvider.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainNativeResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoBondProviderTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoModProvider.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoModProviderTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoOpenContract.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoOpenContractTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoCloseContract.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoCloseContractTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoClaimContractIncome.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoClaimContractIncomeTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoClaimEth.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoClaimEthTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoClaimArkeo.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoClaimArkeoTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoTransferClaim.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoTransferClaimTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
$d66a7013b33ce142$var$$thorchainArkeoAddClaim.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$thorchainArkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsThorchain($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.thorchainSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/931'/0'/0/0`),
            chain_id: "thorchain",
            account_number: "24250",
            sequence: "3",
            tx: (0, $f0cdcd484e868ccf$exports.arkeoAddClaimTx)
        });
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$thorchainArkeoResults.val(label + " does not support THORChain");
    }
});
/*
 * Osmosis
 */ const $d66a7013b33ce142$var$$osmosisAddress = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisAddress");
const $d66a7013b33ce142$var$$osmosisSend = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisSend");
const $d66a7013b33ce142$var$$osmosisDelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisDelegate");
const $d66a7013b33ce142$var$$osmosisUndelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisUndelegate");
const $d66a7013b33ce142$var$$osmosisRedelegate = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisRedelegate");
const $d66a7013b33ce142$var$$osmosisRewards = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisRewards");
const $d66a7013b33ce142$var$$osmosisLPAdd = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisLPAdd");
const $d66a7013b33ce142$var$$osmosisLPRemove = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisLPRemove");
const $d66a7013b33ce142$var$$osmosisIBCTransfer = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisIBCTransfer");
const $d66a7013b33ce142$var$$osmosisSwap = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisSwap");
const $d66a7013b33ce142$var$$osmosisResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#osmosisResults");
$d66a7013b33ce142$var$$osmosisAddress.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.osmosisGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.osmosisGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        await $d66a7013b33ce142$var$wallet.osmosisGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$osmosisResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisSend.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisSendTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisDelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisDelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisUndelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisUndelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisRedelegate.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisRedelegateTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisRewards.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisRewardsTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisLPAdd.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisLPAddTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisLPRemove.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisLPRemoveTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisIBCTransfer.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisIBCTransferTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisSwap.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisSwapTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
/*
 * Arkeo
 */ const $d66a7013b33ce142$var$$arkeoGetAddress = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoGetAddress");
const $d66a7013b33ce142$var$$arkeoBondProvider = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoBondProvider");
const $d66a7013b33ce142$var$$arkeoModProvider = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoModProvider");
const $d66a7013b33ce142$var$$arkeoOpenContract = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoOpenContract");
const $d66a7013b33ce142$var$$arkeoCloseContract = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoCloseContract");
const $d66a7013b33ce142$var$$arkeoClaimContractIncome = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoClaimContractIncome");
const $d66a7013b33ce142$var$$arkeoClaimETH = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoClaimETH");
const $d66a7013b33ce142$var$$arkeoClaimArkeo = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoClaimArkeo");
const $d66a7013b33ce142$var$$arkeoTransferClaim = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoTransferClaim");
const $d66a7013b33ce142$var$$arkeoAddClaim = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoAddClaim");
const $d66a7013b33ce142$var$$arkeoResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#arkeoResults");
$d66a7013b33ce142$var$$arkeoGetAddress.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const { addressNList: addressNList } = $d66a7013b33ce142$var$wallet.arkeoGetAccountPaths({
            accountIdx: 0
        })[0];
        const result = await $d66a7013b33ce142$var$wallet.arkeoGetAddress({
            addressNList: addressNList,
            showDisplay: false
        });
        await $d66a7013b33ce142$var$wallet.arkeoGetAddress({
            addressNList: addressNList,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$arkeoResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoBondProvider.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoBondProviderTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoModProvider.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoModProviderTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoOpenContract.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoOpenContractTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoCloseContract.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoCloseContractTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoClaimContractIncome.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoClaimContractIncomeTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoClaimETH.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoClaimEthTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoClaimArkeo.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoClaimArkeoTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoTransferClaim.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoTransferClaimTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$arkeoAddClaim.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$arkeoResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsArkeo($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $f0cdcd484e868ccf$exports.arkeoAddClaimTx);
        const res = await $d66a7013b33ce142$var$wallet.arkeoSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$arkeoResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$arkeoResults.val(label + " does not support Arkeo");
    }
});
$d66a7013b33ce142$var$$osmosisRewards.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisRewardsTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisLPAdd.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisLPAddTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisLPRemove.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisLPRemoveTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisIBCTransfer.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisIBCTransferTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
$d66a7013b33ce142$var$$osmosisSwap.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$osmosisResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsOsmosis($d66a7013b33ce142$var$wallet)) {
        const unsigned = (0, $1057eab25da9e65c$exports.osmosisSwapTx);
        const res = await $d66a7013b33ce142$var$wallet.osmosisSignTx({
            addressNList: $lFpDy.bip32ToAddressNList(`m/44'/118'/0'/0/0`),
            chain_id: unsigned.chain_id,
            account_number: unsigned.account_number,
            sequence: unsigned.sequence,
            tx: unsigned
        });
        $d66a7013b33ce142$var$$osmosisResults.val(JSON.stringify(res));
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$osmosisResults.val(label + " does not support Osmosis");
    }
});
let $d66a7013b33ce142$var$ethEIP1559Selected = false;
const $d66a7013b33ce142$var$ethButtons = [
    "ethAddr",
    "ethTx",
    "ethSign",
    "ethSend",
    "ethVerify",
    "ethResults",
    "ethEIP1559",
    "ethSignTypedData",
    "ethSignTypedDataAlternate1",
    "ethSignTypedDataAlternate2"
].reduce((acc, id)=>{
    acc[id] = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))(`#${id}`);
    return acc;
}, {});
const $d66a7013b33ce142$var$performEthOperation = async (e, config)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$ethButtons.ethResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
        const { hardenedPath: hardenedPath, relPath: relPath } = $d66a7013b33ce142$var$wallet.ethGetAccountPaths({
            coin: "Ethereum",
            accountIdx: 0
        })[0];
        const tx = config.useEIP1559 && $d66a7013b33ce142$var$ethEIP1559Selected ? (0, $debc1b6f37124f07$exports.txs).ethTx1559 : (0, $debc1b6f37124f07$exports.txs).ethTxLegacy;
        let typedData;
        switch(config.typedDataValue){
            case "OpenSea":
                typedData = (0, $9d06e313e22802b4$exports.openSeaListNFTMessage);
                break;
            case "longPrimaryTypeString":
                typedData = (0, $debc1b6f37124f07$exports.eip712)["longPrimaryTypeString"]["typedData"];
                break;
            case "EIP712DomainIsPrimaryType":
                typedData = (0, $debc1b6f37124f07$exports.eip712)["EIP712DomainIsPrimaryType"]["typedData"];
                break;
            default:
                typedData = undefined;
        }
        const result = await config.handler({
            hardenedPath: hardenedPath,
            relPath: relPath,
            tx: tx,
            typedData: typedData
        });
        $d66a7013b33ce142$var$ethButtons.ethResults.val(result);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$ethButtons.ethResults.val(`${label} does not support ETH`);
    }
};
$d66a7013b33ce142$var$ethButtons.ethAddr.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: async ({ hardenedPath: hardenedPath, relPath: relPath })=>{
            let result = await $d66a7013b33ce142$var$wallet.ethGetAddress({
                addressNList: hardenedPath.concat(relPath),
                showDisplay: false
            });
            result = await $d66a7013b33ce142$var$wallet.ethGetAddress({
                addressNList: hardenedPath.concat(relPath),
                showDisplay: true,
                address: result
            });
            return result;
        }
    }));
$d66a7013b33ce142$var$ethButtons.ethTx.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: async ({ tx: tx })=>{
            const res = await $d66a7013b33ce142$var$wallet.ethSignTx(tx);
            return JSON.stringify(res);
        },
        useEIP1559: $d66a7013b33ce142$var$ethEIP1559Selected
    }));
$d66a7013b33ce142$var$ethButtons.ethSign.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: async ({ hardenedPath: hardenedPath, relPath: relPath })=>{
            const result = await $d66a7013b33ce142$var$wallet.ethSignMessage({
                addressNList: hardenedPath.concat(relPath),
                message: "0x48656c6c6f20576f726c64"
            });
            return `Address: ${result.address} Signature: ${result.signature}`;
        }
    }));
$d66a7013b33ce142$var$ethButtons.ethSend.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: async ({ tx: tx })=>{
            if ($d66a7013b33ce142$var$wallet?.ethSendTx) {
                const result = await $d66a7013b33ce142$var$wallet.ethSendTx(tx);
                return result.hash;
            } else {
                const label = await $d66a7013b33ce142$var$wallet.getVendor();
                return label + " does not support ethSendTx";
            }
        },
        useEIP1559: $d66a7013b33ce142$var$ethEIP1559Selected
    }));
$d66a7013b33ce142$var$ethButtons.ethVerify.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: async ()=>{
            const signerAddress = "0x2068dD92B6690255553141Dfcf00dF308281f763";
            const result = await $d66a7013b33ce142$var$wallet.ethVerifyMessage({
                address: signerAddress,
                message: "Hello World",
                signature: "0x61f1dda82e9c3800e960894396c9ce8164fd1526fccb136c71b88442405f7d09721725629915d10bc7cecfca2818fe76bc5816ed96a1b0cebee9b03b052980131b"
            });
            return result ? `\u{2705} ${signerAddress} is the signer` : `\u{274C} ${signerAddress} is NOT the signer`;
        }
    }));
$d66a7013b33ce142$var$ethButtons.ethEIP1559.on("click", ()=>{
    $d66a7013b33ce142$var$ethEIP1559Selected = !$d66a7013b33ce142$var$ethEIP1559Selected;
    $d66a7013b33ce142$var$ethButtons.ethEIP1559.attr("class", $d66a7013b33ce142$var$ethEIP1559Selected ? "button" : "button-outline");
});
const $d66a7013b33ce142$var$doesRecoveredMatchAddress = (typedData, fromAddress, signature)=>{
    const recoveredAddress = $23486f72422a2370$exports.recoverTypedSignature({
        data: typedData,
        signature: signature,
        version: $23486f72422a2370$exports.SignTypedDataVersion.V4
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($45dd0a73038568f0$exports))).utils.toChecksumAddress(recoveredAddress) === (0, (/*@__PURE__*/$parcel$interopDefault($45dd0a73038568f0$exports))).utils.toChecksumAddress(fromAddress);
};
const $d66a7013b33ce142$var$ethSignTypedDataHandler = async ({ hardenedPath: hardenedPath, relPath: relPath, typedData: typedData })=>{
    const { address: address, signature: signature } = await $d66a7013b33ce142$var$wallet.ethSignTypedData({
        typedData: typedData,
        addressNList: hardenedPath.concat(relPath)
    });
    const success = $d66a7013b33ce142$var$doesRecoveredMatchAddress(typedData, address, signature);
    return (success ? `\u{2705} "${address}" is the signer` : `\u{274C} "${address}" is NOT the signer`) + `; Signature is: "${signature}"`;
};
$d66a7013b33ce142$var$ethButtons.ethSignTypedData.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: $d66a7013b33ce142$var$ethSignTypedDataHandler,
        typedDataValue: "OpenSea"
    }));
$d66a7013b33ce142$var$ethButtons.ethSignTypedDataAlternate1.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: $d66a7013b33ce142$var$ethSignTypedDataHandler,
        typedDataValue: "longPrimaryTypeString"
    }));
$d66a7013b33ce142$var$ethButtons.ethSignTypedDataAlternate2.on("click", (e)=>$d66a7013b33ce142$var$performEthOperation(e, {
        handler: $d66a7013b33ce142$var$ethSignTypedDataHandler,
        typedDataValue: "EIP712DomainIsPrimaryType"
    }));
/*
      ERC-20
        * segwit: false
        * mutltisig: false
        * Bech32: false

*/ const $d66a7013b33ce142$var$$erc20DynamicContainer = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20DynamicContainer");
const $d66a7013b33ce142$var$$erc20Addr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Addr");
const $d66a7013b33ce142$var$$erc20Allowance = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Allowance");
const $d66a7013b33ce142$var$$erc20Approve = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Approve");
const $d66a7013b33ce142$var$$erc20BalanceOf = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20BalanceOf");
const $d66a7013b33ce142$var$$erc20TotalSupply = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20TotalSupply");
const $d66a7013b33ce142$var$$erc20Transfer = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Transfer");
const $d66a7013b33ce142$var$$erc20TransferFrom = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20TransferFrom");
const $d66a7013b33ce142$var$$erc20Results = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Results");
const $d66a7013b33ce142$var$$erc20Submit = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Submit");
let $d66a7013b33ce142$var$erc20Selected;
function $d66a7013b33ce142$var$erc20SetSetSelected(selectedButton) {
    const erc20ButtonContentMap = [
        {
            button: $d66a7013b33ce142$var$$erc20Addr,
            content: ""
        },
        {
            button: $d66a7013b33ce142$var$$erc20Allowance,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      <input type='text' placeholder='Owner Address' id='erc20OwnerAddress' />      <input type='text' placeholder='Spender Address' id='erc20SpenderAddress' />      "
        },
        {
            button: $d66a7013b33ce142$var$$erc20Approve,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      <input type='text' placeholder='Spender Address' id='erc20SpenderAddress' />      <input type='text' placeholder='Amount' id='erc20Amount' />      "
        },
        {
            button: $d66a7013b33ce142$var$$erc20BalanceOf,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      <input type='text' placeholder='Account Address' id='erc20AccountAddress' />      "
        },
        {
            button: $d66a7013b33ce142$var$$erc20TotalSupply,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      "
        },
        {
            button: $d66a7013b33ce142$var$$erc20Transfer,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      <input type='text' placeholder='Recipient Address' id='erc20RecipientAddress' />      <input type='text' placeholder='Amount' id='erc20Amount' />      "
        },
        {
            button: $d66a7013b33ce142$var$$erc20TransferFrom,
            content: "      <input type='text' placeholder='Contract Address' id='erc20ContractAddress' />      <input type='text' placeholder='Sender Address' id='erc20SenderAddress' />      <input type='text' placeholder='Recipient Address' id='erc20RecipientAddress' />      <input type='text' placeholder='Amount' id='erc20Amount' />      "
        }
    ];
    erc20ButtonContentMap.map((o)=>o.button).forEach((button)=>{
        if (button == selectedButton) {
            button.attr("class", "button");
            $d66a7013b33ce142$var$$erc20DynamicContainer.empty();
            $d66a7013b33ce142$var$$erc20DynamicContainer.append(erc20ButtonContentMap.filter((o)=>o.button == button)[0].content);
            $d66a7013b33ce142$var$erc20Selected = button;
        } else button.attr("class", "button-outline");
    });
}
$d66a7013b33ce142$var$$erc20Addr.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20Addr);
});
$d66a7013b33ce142$var$$erc20TotalSupply.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20TotalSupply);
});
$d66a7013b33ce142$var$$erc20BalanceOf.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20BalanceOf);
});
$d66a7013b33ce142$var$$erc20Allowance.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20Allowance);
});
$d66a7013b33ce142$var$$erc20Transfer.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20Transfer);
});
$d66a7013b33ce142$var$$erc20Approve.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20Approve);
});
$d66a7013b33ce142$var$$erc20TransferFrom.on("click", async (e)=>{
    e.preventDefault();
    $d66a7013b33ce142$var$erc20SetSetSelected($d66a7013b33ce142$var$$erc20TransferFrom);
});
$d66a7013b33ce142$var$$erc20Submit.on("click", async ()=>{
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$erc20Results.val("No wallet?");
        return;
    }
    let result;
    let data;
    if ($lFpDy.supportsETH($d66a7013b33ce142$var$wallet)) {
        const { hardenedPath: hardenedPath, relPath: relPath } = $d66a7013b33ce142$var$wallet.ethGetAccountPaths({
            coin: "Ethereum",
            accountIdx: 0
        })[0];
        switch($d66a7013b33ce142$var$erc20Selected){
            case $d66a7013b33ce142$var$$erc20Addr:
                result = await $d66a7013b33ce142$var$wallet.ethGetAddress({
                    addressNList: hardenedPath.concat(relPath),
                    showDisplay: false
                });
                result = await $d66a7013b33ce142$var$wallet.ethGetAddress({
                    addressNList: hardenedPath.concat(relPath),
                    showDisplay: true,
                    address: result
                });
                break;
            case $d66a7013b33ce142$var$$erc20Allowance:
                data = "0xdd62ed3e" + // ERC-20 contract allowance function identifier
                (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20OwnerAddress").val().replace("0x", "").padStart(64, "0") + (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20SpenderAddress").val().replace("0x", "").padStart(64, "0");
                break;
            case $d66a7013b33ce142$var$$erc20Approve:
                data = "0x095ea7b3" + // ERC-20 contract approve function identifier
                (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20SpenderAddress").val().replace("0x", "").padStart(64, "0") + parseInt((0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Amount").val(), 10).toString(16).padStart(64, "0");
                break;
            case $d66a7013b33ce142$var$$erc20BalanceOf:
                data = "0x70a08231" + // ERC-20 contract balanceOf function identifier
                (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20AccountAddress").val().replace("0x", "").padStart(64, "0");
                break;
            case $d66a7013b33ce142$var$$erc20TotalSupply:
                data = "0x18160ddd"; // ERC-20 contract totalSupply function identifier
                break;
            case $d66a7013b33ce142$var$$erc20Transfer:
                data = "0xa9059cbb" + // ERC-20 contract transfer function identifier
                (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20RecipientAddress").val().replace("0x", "").padStart(64, "0") + parseInt((0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Amount").val(), 10).toString(16).padStart(64, "0");
                break;
            case $d66a7013b33ce142$var$$erc20TransferFrom:
                data = "0x23b872dd" + // ERC-20 contract transferFrom function identifier
                (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20SenderAddress").val().replace("0x", "").padStart(64, "0") + (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20RecipientAddress").val().replace("0x", "").padStart(64, "0") + parseInt((0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20Amount").val(), 10).toString(16).padStart(64, "0");
                break;
            default:
                console.info("oops", $d66a7013b33ce142$var$erc20Selected);
                return;
        }
        if ($d66a7013b33ce142$var$erc20Selected != $d66a7013b33ce142$var$$erc20Addr) result = await $d66a7013b33ce142$var$wallet.ethSignTx({
            addressNList: hardenedPath.concat(relPath),
            nonce: "0x0",
            gasPrice: "0x5FB9ACA00",
            gasLimit: "0x186A0",
            value: "0x00",
            to: (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#erc20ContractAddress").val(),
            chainId: 1,
            data: data
        });
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$erc20Results.val(label + " does not support ETH");
    }
    console.info(result);
    $d66a7013b33ce142$var$$erc20Results.val(JSON.stringify(result, null, 4));
});
/*
      Bitcoin
        * segwit: false
        * mutltisig: true

*/ const $d66a7013b33ce142$var$$btcAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcAddr");
const $d66a7013b33ce142$var$$btcTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcTx");
const $d66a7013b33ce142$var$$btcSign = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcSign");
const $d66a7013b33ce142$var$$btcVerify = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcVerify");
const $d66a7013b33ce142$var$$btcResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcResults");
$d66a7013b33ce142$var$$btcAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        //coin 0 (mainnet bitcoin)
        //path 0
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: [
                2147483692,
                2147483648,
                2147483648,
                0,
                0
            ],
            coin: "Bitcoin",
            scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$btcResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResults.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "b3002cd9c033f4f3c2ee5a374673d7698b13c7f3525c1ae49a00d2e28e8678ea";
        const hex = "010000000181f605ead676d8182975c16e7191c21d833972dd0ed50583ce4628254d28b6a3010000008a47304402207f3220930276204c83b1740bae1da18e5a3fa2acad34944ecdc3b361b419e3520220598381bdf8273126e11460a8c720afdbb679233123d2d4e94561f75e9b280ce30141045da61d81456b6d787d576dce817a2d61d7f8cb4623ee669cbe711b0bcff327a3797e3da53a2b4e3e210535076c087c8fb98aef60e42dfeea8388435fc99dca43ffffffff0250ec0e00000000001976a914f7b9e0239571434f0ccfdba6f772a6d23f2cfb1388ac10270000000000001976a9149c9d21f47382762df3ad81391ee0964b28dd951788ac00000000";
        const inputs = [
            {
                addressNList: [
                    2147483692,
                    2147483648,
                    2147483648,
                    0,
                    0
                ],
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(10000),
                vout: 1,
                txid: txid,
                tx: $57de038c542806ea$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "1MJ2tj2ThBE62zXbBYA5ZaN3fdve5CPAz1",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(9000),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Bitcoin",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$btcResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResults.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcSign.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcSignMessage({
            addressNList: $lFpDy.bip32ToAddressNList("m/44'/0'/0'/0/0"),
            coin: "Bitcoin",
            scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
            message: "Hello World"
        });
        $d66a7013b33ce142$var$$btcResults.val(res.address + " " + res.signature);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResults.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcVerify.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcVerifyMessage({
            address: "1FH6ehAd5ZFXCM1cLGzHxK1s4dGdq1JusM",
            coin: "Bitcoin",
            signature: "20a037c911044cd6c851b6508317d8892067b0b62074b2cf1c0df9abd4aa053a3c243ffdc37f64d7af2c857128eafc81947c380995596615e5dcc313a15f512cdd",
            message: "Hello World"
        });
        $d66a7013b33ce142$var$$btcResults.val(res ? "\u2705" : "\u274C");
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResults.val(label + " does not support BTC");
    }
});
/*
      Litecoin
        * segwit: true
        * mutltisig: true

*/ const $d66a7013b33ce142$var$$ltcAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#ltcAddr");
const $d66a7013b33ce142$var$$ltcTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#ltcTx");
const $d66a7013b33ce142$var$$ltcSign = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#ltcSign");
const $d66a7013b33ce142$var$$ltcResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#ltcResults");
const $d66a7013b33ce142$var$ltcBip44 = {
    scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
    addressNList: [
        2147483692,
        2147483650,
        2147483648,
        0,
        0
    ]
};
$d66a7013b33ce142$var$$ltcAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$ltcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: $d66a7013b33ce142$var$ltcBip44.addressNList,
            coin: "Litecoin",
            scriptType: $d66a7013b33ce142$var$ltcBip44.scriptType,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$ltcResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel(); // should be LYXTv5RdsPYKC4qGmb6x6SuKoFMxUdSjLQ
        $d66a7013b33ce142$var$$ltcResults.val(label + " does not support Litecoin");
    }
});
$d66a7013b33ce142$var$$ltcTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$ltcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "1de79c706f34c81bbefad49a9ff8d12b6ca86b77605a1998505e4f8792a5892d";
        const hex = "010000000196f5704ef948abb958f32ff216112d3283142baf50723833c378882c14a9adea010000006a47304402207c899ba5197a23b1f3cc4b3621abbc682b5142f3ae29af4b951952573f6c82a002203fd7f038aa8403d2c06fd32c237ab4e915939c25aafa7bcb06fb0ddd46afbfd3012103eddbce765b6d7ae1c91b779696e8b8f72ce444070f83beba2f823af76fd4dfebffffffff0290680a00000000001976a91491e975a0238fa1dfff703e50f062e2544a3e372088aca6791100000000001976a91415757f526dc67b52ae9f74918db532eebc39608688ac00000000";
        const inputs = [
            {
                addressNList: $d66a7013b33ce142$var$ltcBip44.addressNList,
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(2160258),
                vout: 0,
                txid: txid,
                segwit: false,
                tx: $75df0a23b2bce7cc$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "LLe4PciAJgMMJSAtQQ5nkC13t6SSMmERJ3",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(261614),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Litecoin",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$ltcResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$ltcResults.val(label + " does not support Litecoin");
    }
});
$d66a7013b33ce142$var$$ltcSign.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$ltcResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcSignMessage({
            addressNList: $d66a7013b33ce142$var$ltcBip44.addressNList,
            coin: "Litecoin",
            scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
            message: "Hello World"
        });
        $d66a7013b33ce142$var$$ltcResults.val(res.address + " " + res.signature);
    // Address: LYXTv5RdsPYKC4qGmb6x6SuKoFMxUdSjLQ
    // Signature: 1f835c7efaf953e059e7074afa954c5a8535be321f48e393e125e2a839d1721b495b935df1162c2b69f3e698167b75ab8bfd2c9c203f6070ff701ebca49653a056
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$ltcResults.val(label + " does not support Litecoin");
    }
});
/*
      Dogecoin
        * segwit: false
        * mutltisig: true

 */ const $d66a7013b33ce142$var$$dogeAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dogeAddr");
const $d66a7013b33ce142$var$$dogeTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dogeTx");
const $d66a7013b33ce142$var$$dogeResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dogeResults");
const $d66a7013b33ce142$var$dogeBip44 = {
    scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
    addressNList: [
        2147483692,
        2147483651,
        2147483648
    ]
};
$d66a7013b33ce142$var$$dogeAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dogeResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: $d66a7013b33ce142$var$dogeBip44.addressNList.concat([
                0,
                0
            ]),
            coin: "Dogecoin",
            scriptType: $d66a7013b33ce142$var$dogeBip44.scriptType,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$dogeResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel(); // should be DQTjL9vfXVbMfCGM49KWeYvvvNzRPaoiFp for alcohol abuse
        $d66a7013b33ce142$var$$dogeResults.val(label + " does not support DOGE");
    }
});
$d66a7013b33ce142$var$$dogeTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dogeResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "4ab8c81585bf61ddcba03f4b2f4958b3800d68b02874f4955e258775cb3e7068";
        const hex = "01000000048831c8a8c7f06e5f4ecccb789cc9de0fc843208797652ff9edf6edaa64d02789010000006a473044022070e25a73ceebaf5b3a35d5e4930ebba77957a2fe485b9dcbaf982a7c63d4baab02206e75dcc4258db29a2803d6a14112d3d81f93ec23f9b2a61bfe8102d764d7c6390121031b49bb2c43daac784377bcca83c41f781007626e6e8b66cda9f57fed11494359feffffff52a8a6ac8ea9b436069c160caae68b2eb0a5b713a7b838179833af5a339e48e9000000006a47304402206b3aa1a4656d4859b87512a5fb50c73f0f6e05d45fa027850a3e1eb4f927675402201fb1c52d85380727d28bea7a21d434bed2d57d3a120082c6c69d578b4f3da07c0121033034cf66b3b153a81713b3ddbcdffd92c34c46510353cf01b237fcfbcf1348bdfeffffff35f6938fd9d9077d913bd6cfc546cbadb17d4db6ccb67d87a1f89e562d6bed8e000000006b483045022100a0e8a73fc2358a206a73a78582fd7ebba2fb08487aca78aaa89cbf7f9805da0102207704f4f27ff6297b11acd74f8e3f28d924c4006ac0d37dd37bbdba1ef8f401ae0121038ac65cabea63b92d3aabd3f17591c23bbec73b87220a3f0325fe2de9e62107e3feffffff07cd534960ea57fdb4195d3de7dae1feb1e630a022c08baca2f2423f4d190a27010000006a47304402203c89ade05e93ee9cb9bfa0703be55a76abd40330108a5e5272bcd0c8338c35df022042d8cb34275e87df1b77f19e9dde5da553b98bca67c1c332a53392b32d55ba580121038291eee31aa046a00938dda548c0c948f57bf5dc6e534abbe0d5078a6ce083a0feffffff02b8adfa31000000001976a9146ef1cda5c24d47934853aeccce14163e3a18be1388ac02bd9348080000001976a914d3f096cbc84bd6daf7e7fe2700c32548ca2f23f188acadd31600";
        const inputs = [
            {
                addressNList: $d66a7013b33ce142$var$dogeBip44.addressNList.concat([
                    0,
                    0
                ]),
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(35577380098),
                vout: 1,
                txid: txid,
                segwit: false,
                tx: $5e5417a26c03d073$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "DMEHVGRsELY5zyYbfgta3pAhedKGeaDeJd",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(35577380098),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Dogecoin",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$dogeResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$dogeResults.val(label + " does not support Litecoin");
    }
});
/*
      Bitcoin Cash
        * segwit: false
        * mutltisig: true

 */ const $d66a7013b33ce142$var$$bchAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#bchAddr");
const $d66a7013b33ce142$var$$bchTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#bchTx");
const $d66a7013b33ce142$var$$bchResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#bchResults");
const $d66a7013b33ce142$var$bchBip44 = {
    scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
    addressNList: [
        2147483692,
        2147483793,
        2147483648
    ]
};
$d66a7013b33ce142$var$$bchAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$bchResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: $d66a7013b33ce142$var$bchBip44.addressNList.concat([
                0,
                0
            ]),
            coin: "BitcoinCash",
            scriptType: $d66a7013b33ce142$var$bchBip44.scriptType,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$bchResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel(); // KK: bitcoincash:qzqxk2q6rhy3j9fnnc00m08g4n5dm827xv2dmtjzzp
        $d66a7013b33ce142$var$$bchResults.val(label + " does not support BCH");
    }
});
$d66a7013b33ce142$var$$bchTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$bchResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "35ec5b47eea3b45efb062c6fabad43987a79b855dc42630b34f8d26d4a646a2e";
        const hex = "0100000002a90f75f5924be1fb8147885f6212fefeed3d192eb23a737265f01c822aa74be9000000006b48304502210092dbd26379c6a707b5974bf9ce242baf151a2cef95a5644f6bd4fa05bcbf433e0220125c3647fe473a7e9bf89cb092e1f5e2b26f10a33a12c23b2cfbf2bb1d72c6324121035942ab1589fb2f85c0b3e0c9a37b8ea3092ac749fcbc20733ed227322b5da9ecffffffffbaa5bc3a01a705c377b3ee88ae21ca70ee9d3694f05c466f420cc2bd1951afe5000000006b483045022100a79147c5cf806a2bb3bb6619113cc4bf9b522aaf529ea1b34a93b99bd33054020220019df030c623c9e782f23e755fa9259ec708427606cce8302d5a125e4147838a4121035942ab1589fb2f85c0b3e0c9a37b8ea3092ac749fcbc20733ed227322b5da9ecffffffff0188c7d200000000001976a914806b281a1dc91915339e1efdbce8ace8dd9d5e3388ac00000000";
        const inputs = [
            {
                addressNList: $d66a7013b33ce142$var$bchBip44.addressNList.concat([
                    0,
                    0
                ]),
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(13813640),
                vout: 0,
                txid: txid,
                segwit: false,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: await $d66a7013b33ce142$var$wallet.btcSupportsScriptType("BitcoinCash", $lFpDy.BTCInputScriptType.CashAddr) ? "bitcoincash:qq5mg2xtp9y5pvvgy7m4k2af5a7s5suulueyywgvnf" : "14oWXZFPhgP9DA3ggPzhHpUUaikDSjAuMC",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(13813640),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "BitcoinCash",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$bchResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$bchResults.val(label + " does not support Litecoin");
    }
});
/*
       Dash
        * segwit: false
        * mutltisig: true

 */ const $d66a7013b33ce142$var$$dashAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dashAddr");
const $d66a7013b33ce142$var$$dashTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dashTx");
const $d66a7013b33ce142$var$$dashResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dashResults");
const $d66a7013b33ce142$var$dashBip44 = {
    scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
    addressNList: [
        2147483692,
        2147483653,
        2147483648
    ]
};
$d66a7013b33ce142$var$$dashAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dashResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: $d66a7013b33ce142$var$dashBip44.addressNList.concat([
                0,
                0
            ]),
            coin: "Dash",
            scriptType: $d66a7013b33ce142$var$dashBip44.scriptType,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$dashResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$dashResults.val(label + " does not support Dash");
    }
});
$d66a7013b33ce142$var$$dashTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dashResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "94b3bbe89e5106d93d07be311a543958fa0de127d4bf747e9102c43e92cbb55f";
        const hex = "0100000001816b126842a9703a2c003cd32108d33b345bce68726bb4341fccf3703704c605000000006b483045022100f23368614d166894e5c75e3a99413b72b30ce45d13c00a50e836380819582c8602206bee0e276d684c794becf27f23426d0da457fcfedbb8c4a86bd3657ca357ee1c0121036ac34cb12ac492c0eb0d1a07bd73a5a5f08bc6ba27b710276073704de9912921ffffffff01f7984b00000000001976a914ed52e17e6d182a28148c3719385ced4e30b5c0bb88ac00000000";
        const inputs = [
            {
                addressNList: $d66a7013b33ce142$var$dashBip44.addressNList.concat([
                    0,
                    0
                ]),
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(4954359),
                vout: 0,
                txid: txid,
                segwit: false,
                tx: $bf89b3bc1e224bc1$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "XexybzTUtH9V9eY4UJN2aCcBT3utan5C8N",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(4000000),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Dash",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$dashResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$dashResults.val(label + " does not support Dash");
    }
});
/*
       DigiByte
        * segwit: true
        * multisig: true

 */ const $d66a7013b33ce142$var$$dgbAddr = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dgbAddr");
const $d66a7013b33ce142$var$$dgbTx = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dgbTx");
const $d66a7013b33ce142$var$$dgbResults = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#dgbResults");
const $d66a7013b33ce142$var$dgbBip44 = {
    scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
    addressNList: [
        2147483692,
        2147483668,
        2147483648
    ]
};
$d66a7013b33ce142$var$$dgbAddr.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dgbResults.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: $d66a7013b33ce142$var$dgbBip44.addressNList.concat([
                0,
                0
            ]),
            coin: "DigiByte",
            scriptType: $d66a7013b33ce142$var$dgbBip44.scriptType,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$dgbResults.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$dgbResults.val(label + " does not support Dash");
    }
});
$d66a7013b33ce142$var$$dgbTx.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$dgbResults.val("No wallet?");
        return;
    }
    // use all mnemonic as there is no valid tx on alcohol abuse to use for Native signing
    await $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: "all all all all all all all all all all all all"
    });
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const inputs = [
            {
                addressNList: $d66a7013b33ce142$var$dgbBip44.addressNList.concat([
                    0,
                    0
                ]),
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(480000000),
                vout: 15,
                txid: "be150359df4123b379f1f12de978bfced92644645da17b97c7613879f4306a90",
                tx: null,
                hex: "01000000010b89406fd53f648dbf5cc7a46443794487684833c4bb7a067c86bdcf88362d4b010000006b4830450221009b38f01ca6b06c9fddb5d17ecaf306b140181074e06d50d38b4f61bc81c34d0202200eb9d37f551f6599a3488a8215cf53a347ced76b1dfb1c171855390a5576cd5a012102ee6d4720bc42ae172a1b1fbd1c0fccf4b9f364054f5ba1681f5e206c3b3a4d65ffffffff14486b9e7e750000001976a914f972645c9db830433fe9672b55452b4310c9501288ac0066a957160000001976a914584df25dff6f9eff9a86f2a49807249417913de288ac00bb4547170000001976a914cf934b123f7d1d0e6ecceff45dd881c6b3a1a7c588ac0020bcbe000000001976a91445ef856d2aa149ad66c4f98b115cd53ac88bcbbe88ac0063fe4e090000001976a91464d0c1a15eedb75f74a05b7282bbfc425e9a41ef88ac008b10e72e0300001976a91423cacb5aa41a375e057a38920396e889dd431e4d88ac6b884a1e0f0000001976a9149a32a47d48569012e3539a4be52c9436af9337a788ac003d7bc1210000001976a9147ba2fcb7d0d1321d8501019c2d9f68848e70bf7a88ac00389c1c0000000017a914d3b07c1aaea886f8ceddedec440623f812e49ddc87599e220afc0000001976a914e05ed2af3b5e20f3481e17fa26ef220a70237d7f88ac5475e2d91c0000001976a9147403f2f35e9c9e1f465a34d03afb7ff85f50770588acc9a9ce043c0000001976a914510fffca0668d410aea742e95a2fefa7952f695e88acf8f71c55890000001976a914916014ab503133671da74cfa18570debc332d63888acdfdeae45000000001976a9149cfc24e08cb9189839b0b5c973dec6cc1e1e662488ac8d10f92b954000001976a91433eed4c1b486b6c51824eab5a5d25dc47e0acc7e88ac00389c1c000000001976a914a4b8f22d44a76f96e035a75e01d55fc4cad081e188ac855ed4696f0000001976a9148d18463cb1e415242e49dfd3154a0edfcf16f25988ac439d5ff7180000001976a9144227b8ea4d92a707402bc96378a19ff5d83c5f9088ac9d2724980e0000001976a914b721f681fdbf9541cc5e2aed31a1fbb16a727fdf88ac893d1cf2e20000001976a91442f1d1103b1e9e10efdb5a0b1b88dfe627467dc288ac00000000"
            },
            {
                addressNList: $d66a7013b33ce142$var$dgbBip44.addressNList.concat([
                    0,
                    0
                ]),
                scriptType: $lFpDy.BTCInputScriptType.SpendAddress,
                amount: String(10000000),
                vout: 0,
                txid: "528ec23eaf123282e9bce297ebb3edfb05e8b4d5875cbc9c271a98d72a202340",
                tx: null,
                hex: "0100000001442377be8a2c1d8769dd417382f8ac1a35f33c86de89e2dcf997522e7ae9e6b7000000006a473044022004f4072085e7a9e1f84cb77653f02f7a5b301b3d3514fe750e86d42f617c429a0220338f779601a38ff18c7adfd1a1ccd8f723de12ff4f9c41b7b72f1c0f6f4738ac012103723d91852ec39078fb9d167fe2c4e86be1325057d707ab69ce625699d86a537fffffffff0280969800000000001976a914a4b8f22d44a76f96e035a75e01d55fc4cad081e188ac66e00c16000000001976a9144afe51fbe5fb6cd4814ce74b31d7535a5f4a63bc88ac00000000"
            }
        ];
        const outputs = [
            {
                address: "SWpe93hQL2pLUDLy7swsDPWQJGCHSsgmun",
                addressType: null,
                scriptType: $lFpDy.BTCOutputScriptType.PayToMultisig,
                amount: String(400000000),
                isChange: false
            },
            {
                address: "DNLcBry65dHehGExGYjBkM8kxDYr7mZ3BT",
                addressType: null,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                relpath: "1/9",
                amount: String(90000000),
                isChange: true,
                index: 9
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "DigiByte",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$dgbResults.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$dgbResults.val(label + " does not support Dash");
    }
    // set mnemonic back to alcohol abuse
    await $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: $d66a7013b33ce142$var$mnemonic
    });
});
/*
      Bitcoin (segwit)
        * segwit: true
        * mutltisig: true
 */ const $d66a7013b33ce142$var$$btcAddrSegWit = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcAddrSegWit");
const $d66a7013b33ce142$var$$btcAddrSegWitNative = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcAddrSegWitNative");
const $d66a7013b33ce142$var$$btcTxSegWit = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcTxSegWit");
const $d66a7013b33ce142$var$$btcTxSegWitNative = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcTxSegWitNative");
const $d66a7013b33ce142$var$$btcResultsSegWit = (0, (/*@__PURE__*/$parcel$interopDefault($768377ac0536d182$exports)))("#btcResultsSegWit");
$d66a7013b33ce142$var$$btcAddrSegWit.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResultsSegWit.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        //coin 0 (mainnet bitcoin)
        //path 0
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: [
                2147483697,
                2147483648,
                2147483648,
                0,
                0
            ],
            coin: "Bitcoin",
            scriptType: $lFpDy.BTCInputScriptType.SpendP2SHWitness,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$btcResultsSegWit.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResultsSegWit.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcAddrSegWitNative.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResultsSegWit.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        //coin 0 (mainnet bitcoin)
        //path 0
        const res = await $d66a7013b33ce142$var$wallet.btcGetAddress({
            addressNList: [
                2147483732,
                2147483648,
                2147483648,
                0,
                0
            ],
            coin: "Bitcoin",
            scriptType: $lFpDy.BTCInputScriptType.SpendWitness,
            showDisplay: true
        });
        $d66a7013b33ce142$var$$btcResultsSegWit.val(res);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResultsSegWit.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcTxSegWit.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResultsSegWit.val("No wallet?");
        return;
    }
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "609410a9eac51cdce2b9c1911c7b8705bc566e164bca07ae25f2dee87b5b6a91";
        const hex = "01000000021b09436d8f9fae331e8810ca8ddf5b2bac1c95338a98280ad75efb6773d54a03000000006b48304502210081734b9b58d109997241c85806e6a5c97ba79f4a76ddb98eb227626b21ac1d290220534bee7f3f2a1803b851570b62825a589b5989f69afa44ddee5b591b8f822d3d012103fa044f4e622a9dc7a877155efad20816c6994f95bd1dc21c339a820395a32e01ffffffffe4b64ecf01f1b2e2a8c0ca86662fada7abbb991e9b4974217f5977623d515ea1010000006b4830450221008a2c95c61db777e15ebb7220c9a84565080ed87b97778a0417854fefa87e447202205dafb62309770a98868737d25bc7779caffa4b50993c36c93acf1f07a5d6d69b012102000b4b1051a63e82eeede1f1990ab226685f83ba104a0946edc740e17ce2958bffffffff02a08601000000000017a91463c4b3af0eb54b8b58b07fbde95a4ab3af3b8735874f161100000000001976a91430f7daeb4336f786cb0cf3bb162d83393681ca2d88ac00000000";
        const inputs = [
            {
                addressNList: [
                    2147483697,
                    2147483648,
                    2147483648,
                    0,
                    0
                ],
                amount: String(100000),
                vout: 0,
                txid: txid,
                scriptType: $lFpDy.BTCInputScriptType.SpendP2SHWitness,
                tx: $94d076618d45bcea$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "3Eq3agTHEhMCC8sZHnJJcCcZFB7BBSJKWr",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(89869),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Bitcoin",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$btcResultsSegWit.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResultsSegWit.val(label + " does not support BTC");
    }
});
$d66a7013b33ce142$var$$btcTxSegWitNative.on("click", async (e)=>{
    e.preventDefault();
    if (!$d66a7013b33ce142$var$wallet) {
        $d66a7013b33ce142$var$$btcResultsSegWit.val("No wallet?");
        return;
    }
    // use all mnemonic as there is no valid tx on alcohol abuse to use for Native signing
    await $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: "all all all all all all all all all all all all"
    });
    if ($lFpDy.supportsBTC($d66a7013b33ce142$var$wallet)) {
        const txid = "fa80a9949f1094119195064462f54d0e0eabd3139becd4514ae635b8c7fe3a46";
        const hex = "01000000000101360d7a720e95a6068678eb08e91b3a8a4774222c9f34becf57d0dc4329e0a686000000001716001495f41f5c0e0ec2c7fe27f0ac4bd59a5632a40b5fffffffff02d224000000000000160014ece6935b2a5a5b5ff997c87370b16fa10f16441088ba04000000000017a914dfe58cc93d35fb99e15436f47d3bbfce820328068702483045022100f312e8246e6a00d21fd762f12231c5fb7a20094a32940b9a84e28d712a5ced9b02203b9124d7a94aa7eb1e090ceda32e884511d7068b8d47593aa46537900e3e37d40121037e8bf05c6c7223cfba3ea484ecd61ee910ae38609ea89b4a4839beed2186b3fb00000000";
        const inputs = [
            {
                addressNList: [
                    2147483732,
                    2147483648,
                    2147483648,
                    0,
                    0
                ],
                amount: String(9426),
                vout: 0,
                txid: txid,
                scriptType: $lFpDy.BTCInputScriptType.SpendWitness,
                tx: $88e7e9916f6f95b0$exports,
                hex: hex
            }
        ];
        const outputs = [
            {
                address: "bc1qc5dgazasye0yrzdavnw6wau5up8td8gdqh7t6m",
                addressType: $lFpDy.BTCOutputAddressType.Spend,
                scriptType: $lFpDy.BTCOutputScriptType.PayToAddress,
                amount: String(1337),
                isChange: false
            }
        ];
        const res = await $d66a7013b33ce142$var$wallet.btcSignTx({
            coin: "Bitcoin",
            inputs: inputs,
            outputs: outputs,
            version: 1,
            locktime: 0
        });
        $d66a7013b33ce142$var$$btcResultsSegWit.val(res.serializedTx);
    } else {
        const label = await $d66a7013b33ce142$var$wallet.getLabel();
        $d66a7013b33ce142$var$$btcResultsSegWit.val(label + " does not support BTC");
    }
    // set mnemonic back to alcohol abuse
    await $d66a7013b33ce142$var$wallet.loadDevice({
        mnemonic: $d66a7013b33ce142$var$mnemonic
    });
});


//# sourceMappingURL=index.7a9577b4.js.map
